module.exports = [
	{
		"stop_id": 132,
		"ID": 553,
		"x": -40.7422883847,
		"y": 44.730223498,
		"h": 2.1208791209
	},
	{
		"stop_id": 8500464,
		"ID": 553,
		"x": -41.9282861267,
		"y": 42.289235982,
		"h": 2.1208791209
	},
	{
		"stop_id": 8500465,
		"ID": 553,
		"x": -40.9062402327,
		"y": 40.830183681,
		"h": 2.1208791209
	},
	{
		"stop_id": 8500476,
		"ID": 553,
		"x": -42.6182586897,
		"y": 42.960167731,
		"h": 2.1208791209
	},
	{
		"stop_id": 8500477,
		"ID": 553,
		"x": -42.6792774077,
		"y": 44.444202467,
		"h": 2.1208791209
	},
	{
		"stop_id": 8500479,
		"ID": 553,
		"x": -40.5712317247,
		"y": 43.402206364,
		"h": 2.1208791209
	},
	{
		"stop_id": 8508008,
		"ID": 553,
		"x": -39.8612541947,
		"y": 43.811215574,
		"h": 2.1208791209
	},
	{
		"stop_id": 8508702,
		"ID": 553,
		"x": -42.3252861987,
		"y": 40.075214191,
		"h": 2.1208791209
	},
	{
		"stop_id": 8508999,
		"ID": 553,
		"x": -41.6042874207,
		"y": 41.794142863,
		"h": 2.1208791209
	},
	{
		"stop_id": 8576908,
		"ID": 553,
		"x": -40.8772785907,
		"y": 45.290239077,
		"h": 2.1208791209
	},
	{
		"stop_id": 8576915,
		"ID": 553,
		"x": -40.4332432637,
		"y": 45.145239889,
		"h": 2.1208791209
	},
	{
		"stop_id": 8576916,
		"ID": 553,
		"x": -39.8952858277,
		"y": 44.563214767,
		"h": 2.1208791209
	},
	{
		"stop_id": 8576917,
		"ID": 553,
		"x": -39.8302436047,
		"y": 43.83021911,
		"h": 2.1208791209
	},
	{
		"stop_id": 8576918,
		"ID": 553,
		"x": -39.4732380967,
		"y": 43.820192933,
		"h": 2.1208791209
	},
	{
		"stop_id": 8576919,
		"ID": 553,
		"x": -39.2402588507,
		"y": 44.3271784,
		"h": 2.1208791209
	},
	{
		"stop_id": 8576951,
		"ID": 553,
		"x": -38.5382606517,
		"y": 42.00014497,
		"h": 2.1208791209
	},
	{
		"stop_id": 8576952,
		"ID": 553,
		"x": -39.0452476407,
		"y": 42.181249624,
		"h": 2.1208791209
	},
	{
		"stop_id": 8576953,
		"ID": 553,
		"x": -39.3942272587,
		"y": 42.076210034,
		"h": 2.1208791209
	},
	{
		"stop_id": 8576954,
		"ID": 553,
		"x": -39.1762275767,
		"y": 41.559208777,
		"h": 2.1208791209
	},
	{
		"stop_id": 8576955,
		"ID": 553,
		"x": -39.6642666187,
		"y": 43.696140331,
		"h": 2.1208791209
	},
	{
		"stop_id": 8576959,
		"ID": 553,
		"x": -40.3652553867,
		"y": 42.85321416,
		"h": 2.1208791209
	},
	{
		"stop_id": 8576960,
		"ID": 553,
		"x": -40.7692338997,
		"y": 42.504155282,
		"h": 2.1208791209
	},
	{
		"stop_id": 8576961,
		"ID": 553,
		"x": -42.7842380517,
		"y": 40.38918795,
		"h": 2.1208791209
	},
	{
		"stop_id": 8576962,
		"ID": 553,
		"x": -41.9282752917,
		"y": 39.770207211,
		"h": 2.1208791209
	},
	{
		"stop_id": 8578119,
		"ID": 553,
		"x": -44.0712976587,
		"y": 43.715178845,
		"h": 2.1208791209
	},
	{
		"stop_id": 8578120,
		"ID": 553,
		"x": -43.5282985617,
		"y": 43.648144195,
		"h": 2.1208791209
	},
	{
		"stop_id": 8578121,
		"ID": 553,
		"x": -42.9402731197,
		"y": 43.045192014,
		"h": 2.1208791209
	},
	{
		"stop_id": 8578122,
		"ID": 553,
		"x": -42.0102408397,
		"y": 44.739215899,
		"h": 2.1208791209
	},
	{
		"stop_id": 8578123,
		"ID": 553,
		"x": -42.0302437167,
		"y": 45.121160928,
		"h": 2.1208791209
	},
	{
		"stop_id": 8578124,
		"ID": 553,
		"x": -41.2432910207,
		"y": 43.127145629,
		"h": 2.1208791209
	},
	{
		"stop_id": 8578125,
		"ID": 553,
		"x": -40.2672553957,
		"y": 43.623210027,
		"h": 2.1208791209
	},
	{
		"stop_id": 8587597,
		"ID": 553,
		"x": -40.2572744177,
		"y": 39.730179144,
		"h": 2.1208791209
	},
	{
		"stop_id": 8589951,
		"ID": 553,
		"x": -41.9632807767,
		"y": 43.068145562,
		"h": 2.1208791209
	},
	{
		"stop_id": 8591886,
		"ID": 553,
		"x": -41.4202830387,
		"y": 39.818216111,
		"h": 2.1208791209
	},
	{
		"stop_id": 8595921,
		"ID": 553,
		"x": -42.8872302747,
		"y": 43.051233927,
		"h": 2.1208791209
	},
	{
		"stop_id": 133,
		"ID": 949,
		"x": 30.2577532003,
		"y": -70.469846459,
		"h": 1.0659340659
	},
	{
		"stop_id": 8505589,
		"ID": 949,
		"x": 26.7677553483,
		"y": -72.759773727,
		"h": 1.0659340659
	},
	{
		"stop_id": 8505596,
		"ID": 949,
		"x": 30.0957768073,
		"y": -70.493818089,
		"h": 1.0659340659
	},
	{
		"stop_id": 134,
		"ID": 892,
		"x": 16.7577343443,
		"y": -27.969833712,
		"h": 1
	},
	{
		"stop_id": 135,
		"ID": 603,
		"x": -33.9422526907,
		"y": -48.569778683,
		"h": 1
	},
	{
		"stop_id": 136,
		"ID": 572,
		"x": -38.3312829717,
		"y": -40.041800623,
		"h": 1.1978021978
	},
	{
		"stop_id": 8507460,
		"ID": 572,
		"x": -33.9392865077,
		"y": -42.556789556,
		"h": 1.1978021978
	},
	{
		"stop_id": 8576644,
		"ID": 572,
		"x": -37.7482952067,
		"y": -38.775751185,
		"h": 1.1978021978
	},
	{
		"stop_id": 8576645,
		"ID": 572,
		"x": -37.6262487387,
		"y": -38.822773702,
		"h": 1.1978021978
	},
	{
		"stop_id": 8588691,
		"ID": 572,
		"x": -35.1752633097,
		"y": -40.946806662,
		"h": 1.1978021978
	},
	{
		"stop_id": 8588692,
		"ID": 572,
		"x": -35.9522587177,
		"y": -40.464786101,
		"h": 1.1978021978
	},
	{
		"stop_id": 8588693,
		"ID": 572,
		"x": -34.3332731407,
		"y": -42.156815169,
		"h": 1.1978021978
	},
	{
		"stop_id": 137,
		"ID": 848,
		"x": 7.2577179743,
		"y": 31.530193449,
		"h": 4.1318681319
	},
	{
		"stop_id": 8502200,
		"ID": 848,
		"x": 8.8817505253,
		"y": 32.630236558,
		"h": 4.1318681319
	},
	{
		"stop_id": 8508459,
		"ID": 848,
		"x": 8.3487747093,
		"y": 28.940157357,
		"h": 4.1318681319
	},
	{
		"stop_id": 8508461,
		"ID": 848,
		"x": 9.1117704423,
		"y": 28.342207746,
		"h": 4.1318681319
	},
	{
		"stop_id": 8508505,
		"ID": 848,
		"x": 6.9527680803,
		"y": 29.315178434,
		"h": 4.1318681319
	},
	{
		"stop_id": 8516350,
		"ID": 848,
		"x": 9.9547663533,
		"y": 33.686236983,
		"h": 4.1318681319
	},
	{
		"stop_id": 8517336,
		"ID": 848,
		"x": 8.5357600773,
		"y": 29.254155728,
		"h": 4.1318681319
	},
	{
		"stop_id": 8530774,
		"ID": 848,
		"x": 5.7187388173,
		"y": 31.790155411,
		"h": 4.1318681319
	},
	{
		"stop_id": 8573054,
		"ID": 848,
		"x": 6.3797249923,
		"y": 29.155146392,
		"h": 4.1318681319
	},
	{
		"stop_id": 8573055,
		"ID": 848,
		"x": 6.6167357343,
		"y": 29.311207216,
		"h": 4.1318681319
	},
	{
		"stop_id": 8573056,
		"ID": 848,
		"x": 7.0507372243,
		"y": 29.679166357,
		"h": 4.1318681319
	},
	{
		"stop_id": 8573058,
		"ID": 848,
		"x": 7.5037369483,
		"y": 30.776158722,
		"h": 4.1318681319
	},
	{
		"stop_id": 8573059,
		"ID": 848,
		"x": 7.8577532523,
		"y": 31.029206601,
		"h": 4.1318681319
	},
	{
		"stop_id": 8573060,
		"ID": 848,
		"x": 8.4257192233,
		"y": 31.149189595,
		"h": 4.1318681319
	},
	{
		"stop_id": 8573061,
		"ID": 848,
		"x": 8.9477409963,
		"y": 31.187201969,
		"h": 4.1318681319
	},
	{
		"stop_id": 8573062,
		"ID": 848,
		"x": 9.4957736043,
		"y": 31.346193464,
		"h": 4.1318681319
	},
	{
		"stop_id": 8573063,
		"ID": 848,
		"x": 10.2327379663,
		"y": 31.455195623,
		"h": 4.1318681319
	},
	{
		"stop_id": 8573064,
		"ID": 848,
		"x": 10.8247582103,
		"y": 31.108174192,
		"h": 4.1318681319
	},
	{
		"stop_id": 8573065,
		"ID": 848,
		"x": 11.6277728813,
		"y": 31.208236011,
		"h": 4.1318681319
	},
	{
		"stop_id": 8577149,
		"ID": 848,
		"x": 6.5097271503,
		"y": 29.532154685,
		"h": 4.1318681319
	},
	{
		"stop_id": 8577150,
		"ID": 848,
		"x": 6.4587667003,
		"y": 30.269156312,
		"h": 4.1318681319
	},
	{
		"stop_id": 8577151,
		"ID": 848,
		"x": 6.8117753113,
		"y": 30.721142225,
		"h": 4.1318681319
	},
	{
		"stop_id": 8577152,
		"ID": 848,
		"x": 7.2457311643,
		"y": 30.988165587,
		"h": 4.1318681319
	},
	{
		"stop_id": 8577153,
		"ID": 848,
		"x": 7.4767627423,
		"y": 31.174213757,
		"h": 4.1318681319
	},
	{
		"stop_id": 8577154,
		"ID": 848,
		"x": 7.6957641663,
		"y": 31.368251182,
		"h": 4.1318681319
	},
	{
		"stop_id": 8577155,
		"ID": 848,
		"x": 7.9477478723,
		"y": 31.586241625,
		"h": 4.1318681319
	},
	{
		"stop_id": 8577156,
		"ID": 848,
		"x": 8.2077147403,
		"y": 31.81522974,
		"h": 4.1318681319
	},
	{
		"stop_id": 8577157,
		"ID": 848,
		"x": 8.4747583533,
		"y": 32.061210004,
		"h": 4.1318681319
	},
	{
		"stop_id": 8577159,
		"ID": 848,
		"x": 8.9317289153,
		"y": 32.458148148,
		"h": 4.1318681319
	},
	{
		"stop_id": 8577161,
		"ID": 848,
		"x": 8.9017530673,
		"y": 32.634247069,
		"h": 4.1318681319
	},
	{
		"stop_id": 8577173,
		"ID": 848,
		"x": 9.6407434703,
		"y": 33.117214991,
		"h": 4.1318681319
	},
	{
		"stop_id": 8577174,
		"ID": 848,
		"x": 10.1477356653,
		"y": 33.599218518,
		"h": 4.1318681319
	},
	{
		"stop_id": 8577183,
		"ID": 848,
		"x": 7.1027124343,
		"y": 29.387234268,
		"h": 4.1318681319
	},
	{
		"stop_id": 8577184,
		"ID": 848,
		"x": 7.7457486723,
		"y": 29.408152411,
		"h": 4.1318681319
	},
	{
		"stop_id": 8577185,
		"ID": 848,
		"x": 8.3747390373,
		"y": 29.268212968,
		"h": 4.1318681319
	},
	{
		"stop_id": 8577186,
		"ID": 848,
		"x": 8.7897346313,
		"y": 28.947209839,
		"h": 4.1318681319
	},
	{
		"stop_id": 8577187,
		"ID": 848,
		"x": 9.0027133473,
		"y": 28.507163996,
		"h": 4.1318681319
	},
	{
		"stop_id": 8581978,
		"ID": 848,
		"x": 6.6677504443,
		"y": 29.438186622,
		"h": 4.1318681319
	},
	{
		"stop_id": 8588203,
		"ID": 848,
		"x": 8.6677607513,
		"y": 29.160164784,
		"h": 4.1318681319
	},
	{
		"stop_id": 8588526,
		"ID": 848,
		"x": 5.9137373923,
		"y": 32.001207719,
		"h": 4.1318681319
	},
	{
		"stop_id": 8588980,
		"ID": 848,
		"x": 6.3387636573,
		"y": 32.493208254,
		"h": 4.1318681319
	},
	{
		"stop_id": 8588981,
		"ID": 848,
		"x": 6.1467369593,
		"y": 32.222248122,
		"h": 4.1318681319
	},
	{
		"stop_id": 8588982,
		"ID": 848,
		"x": 6.3837311413,
		"y": 32.807235998,
		"h": 4.1318681319
	},
	{
		"stop_id": 8589241,
		"ID": 848,
		"x": 6.8987727523,
		"y": 29.360158527,
		"h": 4.1318681319
	},
	{
		"stop_id": 8589650,
		"ID": 848,
		"x": 10.5327296553,
		"y": 31.117176592,
		"h": 4.1318681319
	},
	{
		"stop_id": 8589652,
		"ID": 848,
		"x": 9.9677121783,
		"y": 30.371189829,
		"h": 4.1318681319
	},
	{
		"stop_id": 8589653,
		"ID": 848,
		"x": 10.4377640253,
		"y": 30.589171205,
		"h": 4.1318681319
	},
	{
		"stop_id": 8589655,
		"ID": 848,
		"x": 9.3087563513,
		"y": 33.857161748,
		"h": 4.1318681319
	},
	{
		"stop_id": 8589656,
		"ID": 848,
		"x": 9.5567083813,
		"y": 33.722175423,
		"h": 4.1318681319
	},
	{
		"stop_id": 8589657,
		"ID": 848,
		"x": 9.6327727743,
		"y": 33.48224166,
		"h": 4.1318681319
	},
	{
		"stop_id": 8589659,
		"ID": 848,
		"x": 8.5117726443,
		"y": 31.475155302,
		"h": 4.1318681319
	},
	{
		"stop_id": 8589660,
		"ID": 848,
		"x": 9.0367682443,
		"y": 32.931211849,
		"h": 4.1318681319
	},
	{
		"stop_id": 8589661,
		"ID": 848,
		"x": 9.9327485573,
		"y": 33.004215146,
		"h": 4.1318681319
	},
	{
		"stop_id": 8589662,
		"ID": 848,
		"x": 9.3897686113,
		"y": 32.620209003,
		"h": 4.1318681319
	},
	{
		"stop_id": 8589663,
		"ID": 848,
		"x": 9.6577138343,
		"y": 32.85324593,
		"h": 4.1318681319
	},
	{
		"stop_id": 8589664,
		"ID": 848,
		"x": 8.7567073073,
		"y": 32.310153424,
		"h": 4.1318681319
	},
	{
		"stop_id": 8589665,
		"ID": 848,
		"x": 9.1707192923,
		"y": 32.695165277,
		"h": 4.1318681319
	},
	{
		"stop_id": 8589666,
		"ID": 848,
		"x": 8.3507287873,
		"y": 31.330223998,
		"h": 4.1318681319
	},
	{
		"stop_id": 8589667,
		"ID": 848,
		"x": 10.1317312503,
		"y": 33.099159055,
		"h": 4.1318681319
	},
	{
		"stop_id": 8589668,
		"ID": 848,
		"x": 8.5487367423,
		"y": 31.822240188,
		"h": 4.1318681319
	},
	{
		"stop_id": 8589669,
		"ID": 848,
		"x": 8.5937520333,
		"y": 32.056235796,
		"h": 4.1318681319
	},
	{
		"stop_id": 8589772,
		"ID": 848,
		"x": 8.7157160203,
		"y": 29.285237003,
		"h": 4.1318681319
	},
	{
		"stop_id": 8589776,
		"ID": 848,
		"x": 9.7447357993,
		"y": 29.178176285,
		"h": 4.1318681319
	},
	{
		"stop_id": 8589777,
		"ID": 848,
		"x": 9.9417396613,
		"y": 29.265194755,
		"h": 4.1318681319
	},
	{
		"stop_id": 8589778,
		"ID": 848,
		"x": 6.9477692303,
		"y": 29.660225047,
		"h": 4.1318681319
	},
	{
		"stop_id": 8589779,
		"ID": 848,
		"x": 9.5067483223,
		"y": 29.06022491,
		"h": 4.1318681319
	},
	{
		"stop_id": 8589781,
		"ID": 848,
		"x": 7.5287302873,
		"y": 29.409146787,
		"h": 4.1318681319
	},
	{
		"stop_id": 8589782,
		"ID": 848,
		"x": 6.8317227643,
		"y": 29.778224381,
		"h": 4.1318681319
	},
	{
		"stop_id": 8589786,
		"ID": 848,
		"x": 7.1917626533,
		"y": 30.443220912,
		"h": 4.1318681319
	},
	{
		"stop_id": 8589790,
		"ID": 848,
		"x": 9.1017131723,
		"y": 29.200180719,
		"h": 4.1318681319
	},
	{
		"stop_id": 8589797,
		"ID": 848,
		"x": 9.6887249973,
		"y": 29.890191016,
		"h": 4.1318681319
	},
	{
		"stop_id": 8589803,
		"ID": 848,
		"x": 6.7587069033,
		"y": 29.601189403,
		"h": 4.1318681319
	},
	{
		"stop_id": 8589804,
		"ID": 848,
		"x": 6.8697454313,
		"y": 30.013238838,
		"h": 4.1318681319
	},
	{
		"stop_id": 8589806,
		"ID": 848,
		"x": 7.3897367233,
		"y": 29.836179492,
		"h": 4.1318681319
	},
	{
		"stop_id": 8589808,
		"ID": 848,
		"x": 8.3507044383,
		"y": 29.656179807,
		"h": 4.1318681319
	},
	{
		"stop_id": 8589809,
		"ID": 848,
		"x": 7.7707393013,
		"y": 29.771216059,
		"h": 4.1318681319
	},
	{
		"stop_id": 8589810,
		"ID": 848,
		"x": 6.5957484143,
		"y": 30.528171847,
		"h": 4.1318681319
	},
	{
		"stop_id": 8589814,
		"ID": 848,
		"x": 6.9137597513,
		"y": 30.140142441,
		"h": 4.1318681319
	},
	{
		"stop_id": 8589820,
		"ID": 848,
		"x": 7.3377086803,
		"y": 30.530247608,
		"h": 4.1318681319
	},
	{
		"stop_id": 8589821,
		"ID": 848,
		"x": 9.1747107783,
		"y": 28.880157548,
		"h": 4.1318681319
	},
	{
		"stop_id": 8589822,
		"ID": 848,
		"x": 9.3797452653,
		"y": 28.964248122,
		"h": 4.1318681319
	},
	{
		"stop_id": 8589826,
		"ID": 848,
		"x": 8.0287062353,
		"y": 29.796156195,
		"h": 4.1318681319
	},
	{
		"stop_id": 8589828,
		"ID": 848,
		"x": 6.0717366763,
		"y": 29.962239922,
		"h": 4.1318681319
	},
	{
		"stop_id": 8589830,
		"ID": 848,
		"x": 9.4127248143,
		"y": 29.652170181,
		"h": 4.1318681319
	},
	{
		"stop_id": 8589831,
		"ID": 848,
		"x": 6.3687626123,
		"y": 30.082153573,
		"h": 4.1318681319
	},
	{
		"stop_id": 8589832,
		"ID": 848,
		"x": 9.0687250843,
		"y": 29.484199299,
		"h": 4.1318681319
	},
	{
		"stop_id": 8589833,
		"ID": 848,
		"x": 8.6807519183,
		"y": 29.53121121,
		"h": 4.1318681319
	},
	{
		"stop_id": 8589834,
		"ID": 848,
		"x": 9.2677512573,
		"y": 28.293201245,
		"h": 4.1318681319
	},
	{
		"stop_id": 8589848,
		"ID": 848,
		"x": 6.4127490253,
		"y": 29.774228356,
		"h": 4.1318681319
	},
	{
		"stop_id": 8589849,
		"ID": 848,
		"x": 9.4697180053,
		"y": 29.540205629,
		"h": 4.1318681319
	},
	{
		"stop_id": 8589850,
		"ID": 848,
		"x": 9.0707018163,
		"y": 29.339242914,
		"h": 4.1318681319
	},
	{
		"stop_id": 8589854,
		"ID": 848,
		"x": 7.0907072513,
		"y": 30.275205847,
		"h": 4.1318681319
	},
	{
		"stop_id": 8589855,
		"ID": 848,
		"x": 10.1227563393,
		"y": 28.952227272,
		"h": 4.1318681319
	},
	{
		"stop_id": 8589856,
		"ID": 848,
		"x": 9.7527429773,
		"y": 28.99315416,
		"h": 4.1318681319
	},
	{
		"stop_id": 8589857,
		"ID": 848,
		"x": 10.5747676853,
		"y": 28.879157823,
		"h": 4.1318681319
	},
	{
		"stop_id": 8591688,
		"ID": 848,
		"x": 7.5497385943,
		"y": 29.776166918,
		"h": 4.1318681319
	},
	{
		"stop_id": 138,
		"ID": 1513,
		"x": 134.6577608823,
		"y": 4.530235533,
		"h": 1
	},
	{
		"stop_id": 139,
		"ID": 1070,
		"x": 43.7577242893,
		"y": 47.930225792,
		"h": 2.1538461538
	},
	{
		"stop_id": 8503209,
		"ID": 1070,
		"x": 41.7437255213,
		"y": 46.302201877,
		"h": 2.1538461538
	},
	{
		"stop_id": 8503211,
		"ID": 1070,
		"x": 45.1537027873,
		"y": 45.357208419,
		"h": 2.1538461538
	},
	{
		"stop_id": 8503299,
		"ID": 1070,
		"x": 43.4357668463,
		"y": 47.571141511,
		"h": 2.1538461538
	},
	{
		"stop_id": 8503634,
		"ID": 1070,
		"x": 43.4177161103,
		"y": 46.175236552,
		"h": 2.1538461538
	},
	{
		"stop_id": 8503635,
		"ID": 1070,
		"x": 44.3587108893,
		"y": 45.755206592,
		"h": 2.1538461538
	},
	{
		"stop_id": 8503636,
		"ID": 1070,
		"x": 45.8557584133,
		"y": 45.149250893,
		"h": 2.1538461538
	},
	{
		"stop_id": 8503680,
		"ID": 1070,
		"x": 41.5087527293,
		"y": 46.848155158,
		"h": 2.1538461538
	},
	{
		"stop_id": 8503683,
		"ID": 1070,
		"x": 45.8787290163,
		"y": 45.47323364,
		"h": 2.1538461538
	},
	{
		"stop_id": 8503859,
		"ID": 1070,
		"x": 42.8687136763,
		"y": 46.006171696,
		"h": 2.1538461538
	},
	{
		"stop_id": 8570505,
		"ID": 1070,
		"x": 43.9947548883,
		"y": 46.08220252,
		"h": 2.1538461538
	},
	{
		"stop_id": 8573800,
		"ID": 1070,
		"x": 41.8147508363,
		"y": 46.292184458,
		"h": 2.1538461538
	},
	{
		"stop_id": 8573801,
		"ID": 1070,
		"x": 42.1057753363,
		"y": 45.932228299,
		"h": 2.1538461538
	},
	{
		"stop_id": 8573802,
		"ID": 1070,
		"x": 42.1647453353,
		"y": 45.821156403,
		"h": 2.1538461538
	},
	{
		"stop_id": 8573803,
		"ID": 1070,
		"x": 42.1147479123,
		"y": 45.426231814,
		"h": 2.1538461538
	},
	{
		"stop_id": 8573804,
		"ID": 1070,
		"x": 41.9227561153,
		"y": 45.152191053,
		"h": 2.1538461538
	},
	{
		"stop_id": 8573805,
		"ID": 1070,
		"x": 41.5737576393,
		"y": 45.061170985,
		"h": 2.1538461538
	},
	{
		"stop_id": 8573806,
		"ID": 1070,
		"x": 41.3867282573,
		"y": 44.903206719,
		"h": 2.1538461538
	},
	{
		"stop_id": 8573820,
		"ID": 1070,
		"x": 42.4427084623,
		"y": 46.047202288,
		"h": 2.1538461538
	},
	{
		"stop_id": 8573823,
		"ID": 1070,
		"x": 42.3737306683,
		"y": 46.18923368,
		"h": 2.1538461538
	},
	{
		"stop_id": 8573824,
		"ID": 1070,
		"x": 42.7617022103,
		"y": 46.226155963,
		"h": 2.1538461538
	},
	{
		"stop_id": 8573825,
		"ID": 1070,
		"x": 44.6127263043,
		"y": 45.43719859,
		"h": 2.1538461538
	},
	{
		"stop_id": 8573826,
		"ID": 1070,
		"x": 45.0927223913,
		"y": 45.252166556,
		"h": 2.1538461538
	},
	{
		"stop_id": 8573827,
		"ID": 1070,
		"x": 45.5017750823,
		"y": 45.227147688,
		"h": 2.1538461538
	},
	{
		"stop_id": 8573828,
		"ID": 1070,
		"x": 46.1057197313,
		"y": 45.035163142,
		"h": 2.1538461538
	},
	{
		"stop_id": 8581056,
		"ID": 1070,
		"x": 41.9627706973,
		"y": 46.025183432,
		"h": 2.1538461538
	},
	{
		"stop_id": 8581057,
		"ID": 1070,
		"x": 42.0157007963,
		"y": 45.598218869,
		"h": 2.1538461538
	},
	{
		"stop_id": 8581265,
		"ID": 1070,
		"x": 41.6517302903,
		"y": 46.142181995,
		"h": 2.1538461538
	},
	{
		"stop_id": 8581266,
		"ID": 1070,
		"x": 41.3067110843,
		"y": 46.199241971,
		"h": 2.1538461538
	},
	{
		"stop_id": 8582391,
		"ID": 1070,
		"x": 44.7857276123,
		"y": 45.275226492,
		"h": 2.1538461538
	},
	{
		"stop_id": 8592294,
		"ID": 1070,
		"x": 41.6977449403,
		"y": 46.070246907,
		"h": 2.1538461538
	},
	{
		"stop_id": 8592295,
		"ID": 1070,
		"x": 40.7077241083,
		"y": 45.590206606,
		"h": 2.1538461538
	},
	{
		"stop_id": 8592296,
		"ID": 1070,
		"x": 41.1867680063,
		"y": 45.765220497,
		"h": 2.1538461538
	},
	{
		"stop_id": 8592297,
		"ID": 1070,
		"x": 41.4477144473,
		"y": 45.880182223,
		"h": 2.1538461538
	},
	{
		"stop_id": 8592298,
		"ID": 1070,
		"x": 40.6377091373,
		"y": 45.670194464,
		"h": 2.1538461538
	},
	{
		"stop_id": 8592300,
		"ID": 1070,
		"x": 40.9677273553,
		"y": 45.690231182,
		"h": 2.1538461538
	},
	{
		"stop_id": 140,
		"ID": 958,
		"x": 28.5577171423,
		"y": -20.469788723,
		"h": 1.1648351648
	},
	{
		"stop_id": 8505164,
		"ID": 958,
		"x": 26.9837108083,
		"y": -18.629811108,
		"h": 1.1648351648
	},
	{
		"stop_id": 8505190,
		"ID": 958,
		"x": 30.1367646083,
		"y": -20.680750759,
		"h": 1.1648351648
	},
	{
		"stop_id": 8505191,
		"ID": 958,
		"x": 29.0867108743,
		"y": -18.896829266,
		"h": 1.1648351648
	},
	{
		"stop_id": 8573141,
		"ID": 958,
		"x": 26.9347610983,
		"y": -18.767821699,
		"h": 1.1648351648
	},
	{
		"stop_id": 8573142,
		"ID": 958,
		"x": 26.2187090253,
		"y": -21.915752911,
		"h": 1.1648351648
	},
	{
		"stop_id": 141,
		"ID": 993,
		"x": 32.5576999103,
		"y": -15.069761807,
		"h": 1.032967033
	},
	{
		"stop_id": 8505172,
		"ID": 993,
		"x": 34.5387536803,
		"y": -14.163779316,
		"h": 1.032967033
	},
	{
		"stop_id": 142,
		"ID": 727,
		"x": -9.4422308917,
		"y": -57.369795315,
		"h": 1.2967032967
	},
	{
		"stop_id": 8501748,
		"ID": 727,
		"x": -13.5762836287,
		"y": -57.037777027,
		"h": 1.2967032967
	},
	{
		"stop_id": 8505704,
		"ID": 727,
		"x": -11.6802513577,
		"y": -55.369826071,
		"h": 1.2967032967
	},
	{
		"stop_id": 8505730,
		"ID": 727,
		"x": -14.6712780137,
		"y": -55.465773238,
		"h": 1.2967032967
	},
	{
		"stop_id": 8505738,
		"ID": 727,
		"x": -12.9442802817,
		"y": -55.017770803,
		"h": 1.2967032967
	},
	{
		"stop_id": 8530234,
		"ID": 727,
		"x": -13.3402614557,
		"y": -54.284774574,
		"h": 1.2967032967
	},
	{
		"stop_id": 8571173,
		"ID": 727,
		"x": -12.2042716767,
		"y": -55.308821441,
		"h": 1.2967032967
	},
	{
		"stop_id": 8571174,
		"ID": 727,
		"x": -12.1642306697,
		"y": -55.559858968,
		"h": 1.2967032967
	},
	{
		"stop_id": 8571175,
		"ID": 727,
		"x": -12.8982966187,
		"y": -56.000811763,
		"h": 1.2967032967
	},
	{
		"stop_id": 8571176,
		"ID": 727,
		"x": -13.6163005937,
		"y": -56.641766578,
		"h": 1.2967032967
	},
	{
		"stop_id": 174,
		"ID": 1060,
		"x": 41.7777311053,
		"y": -11.761843972,
		"h": 1.2307692308
	},
	{
		"stop_id": 8505175,
		"ID": 1060,
		"x": 40.9637041933,
		"y": -12.057848943,
		"h": 1.2307692308
	},
	{
		"stop_id": 8505176,
		"ID": 1060,
		"x": 42.0967096893,
		"y": -11.723752591,
		"h": 1.2307692308
	},
	{
		"stop_id": 8505177,
		"ID": 1060,
		"x": 43.3707660153,
		"y": -11.558796213,
		"h": 1.2307692308
	},
	{
		"stop_id": 8505178,
		"ID": 1060,
		"x": 46.2767520403,
		"y": -11.551750896,
		"h": 1.2307692308
	},
	{
		"stop_id": 8587601,
		"ID": 1060,
		"x": 40.5677409713,
		"y": -12.449836323,
		"h": 1.2307692308
	},
	{
		"stop_id": 8587602,
		"ID": 1060,
		"x": 42.3577722973,
		"y": -11.96981202,
		"h": 1.2307692308
	},
	{
		"stop_id": 8587603,
		"ID": 1060,
		"x": 43.4577219313,
		"y": -11.76977251,
		"h": 1.2307692308
	},
	{
		"stop_id": 175,
		"ID": 657,
		"x": -24.5882815247,
		"y": 67.569186149,
		"h": 1.6263736264
	},
	{
		"stop_id": 8500033,
		"ID": 657,
		"x": -28.6632838927,
		"y": 70.241221927,
		"h": 1.6263736264
	},
	{
		"stop_id": 8500034,
		"ID": 657,
		"x": -28.8602355757,
		"y": 68.418204277,
		"h": 1.6263736264
	},
	{
		"stop_id": 8500035,
		"ID": 657,
		"x": -28.2142418307,
		"y": 66.547143744,
		"h": 1.6263736264
	},
	{
		"stop_id": 8500388,
		"ID": 657,
		"x": -26.2012417227,
		"y": 66.592205657,
		"h": 1.6263736264
	},
	{
		"stop_id": 8500778,
		"ID": 657,
		"x": -25.0622907947,
		"y": 70.410181369,
		"h": 1.6263736264
	},
	{
		"stop_id": 8500779,
		"ID": 657,
		"x": -24.6562713427,
		"y": 69.478166628,
		"h": 1.6263736264
	},
	{
		"stop_id": 8500781,
		"ID": 657,
		"x": -26.1422250947,
		"y": 71.205166412,
		"h": 1.6263736264
	},
	{
		"stop_id": 8572308,
		"ID": 657,
		"x": -26.1982795347,
		"y": 71.445232861,
		"h": 1.6263736264
	},
	{
		"stop_id": 8572309,
		"ID": 657,
		"x": -26.0922963797,
		"y": 70.955170321,
		"h": 1.6263736264
	},
	{
		"stop_id": 8572311,
		"ID": 657,
		"x": -24.8042275487,
		"y": 69.793170912,
		"h": 1.6263736264
	},
	{
		"stop_id": 8572312,
		"ID": 657,
		"x": -24.3712295257,
		"y": 69.29918398,
		"h": 1.6263736264
	},
	{
		"stop_id": 8578040,
		"ID": 657,
		"x": -25.8802654027,
		"y": 66.61515426,
		"h": 1.6263736264
	},
	{
		"stop_id": 8578041,
		"ID": 657,
		"x": -27.1032323857,
		"y": 66.478213761,
		"h": 1.6263736264
	},
	{
		"stop_id": 8578296,
		"ID": 657,
		"x": -28.8422869997,
		"y": 70.130212972,
		"h": 1.6263736264
	},
	{
		"stop_id": 8578297,
		"ID": 657,
		"x": -29.0992809707,
		"y": 68.551164444,
		"h": 1.6263736264
	},
	{
		"stop_id": 8578302,
		"ID": 657,
		"x": -27.8332658607,
		"y": 69.228174631,
		"h": 1.6263736264
	},
	{
		"stop_id": 8578303,
		"ID": 657,
		"x": -27.4842707767,
		"y": 69.097196644,
		"h": 1.6263736264
	},
	{
		"stop_id": 8587564,
		"ID": 657,
		"x": -28.2952800087,
		"y": 66.922182842,
		"h": 1.6263736264
	},
	{
		"stop_id": 8592449,
		"ID": 657,
		"x": -28.1972242037,
		"y": 66.584147355,
		"h": 1.6263736264
	},
	{
		"stop_id": 176,
		"ID": 939,
		"x": 22.1097533293,
		"y": 62.531208265,
		"h": 6.8021978022
	},
	{
		"stop_id": 8502572,
		"ID": 939,
		"x": 21.4737409393,
		"y": 64.592190434,
		"h": 6.8021978022
	},
	{
		"stop_id": 8503000,
		"ID": 939,
		"x": 23.4457619003,
		"y": 65.496188231,
		"h": 6.8021978022
	},
	{
		"stop_id": 8503003,
		"ID": 939,
		"x": 24.0887422363,
		"y": 64.219190028,
		"h": 6.8021978022
	},
	{
		"stop_id": 8503004,
		"ID": 939,
		"x": 25.0897475253,
		"y": 62.400195407,
		"h": 6.8021978022
	},
	{
		"stop_id": 8503009,
		"ID": 939,
		"x": 22.9947571573,
		"y": 62.072149662,
		"h": 6.8021978022
	},
	{
		"stop_id": 8503010,
		"ID": 939,
		"x": 22.7587053403,
		"y": 63.921211446,
		"h": 6.8021978022
	},
	{
		"stop_id": 8503011,
		"ID": 939,
		"x": 22.1927338353,
		"y": 64.733182863,
		"h": 6.8021978022
	},
	{
		"stop_id": 8503051,
		"ID": 939,
		"x": 21.8257740853,
		"y": 63.745180558,
		"h": 6.8021978022
	},
	{
		"stop_id": 8503052,
		"ID": 939,
		"x": 21.0307569283,
		"y": 63.973245387,
		"h": 6.8021978022
	},
	{
		"stop_id": 8503059,
		"ID": 939,
		"x": 24.0637699743,
		"y": 64.190149095,
		"h": 6.8021978022
	},
	{
		"stop_id": 8503083,
		"ID": 939,
		"x": 24.9787703963,
		"y": 64.396189209,
		"h": 6.8021978022
	},
	{
		"stop_id": 8503086,
		"ID": 939,
		"x": 22.4317448133,
		"y": 62.585142896,
		"h": 6.8021978022
	},
	{
		"stop_id": 8503087,
		"ID": 939,
		"x": 22.1147105633,
		"y": 63.168184487,
		"h": 6.8021978022
	},
	{
		"stop_id": 8503088,
		"ID": 939,
		"x": 23.3697508603,
		"y": 65.412171555,
		"h": 6.8021978022
	},
	{
		"stop_id": 8503090,
		"ID": 939,
		"x": 22.8377671973,
		"y": 64.905144383,
		"h": 6.8021978022
	},
	{
		"stop_id": 8503091,
		"ID": 939,
		"x": 22.0847524383,
		"y": 63.729180178,
		"h": 6.8021978022
	},
	{
		"stop_id": 8503093,
		"ID": 939,
		"x": 21.9577181653,
		"y": 61.050151185,
		"h": 6.8021978022
	},
	{
		"stop_id": 8503094,
		"ID": 939,
		"x": 21.9577592683,
		"y": 60.630181993,
		"h": 6.8021978022
	},
	{
		"stop_id": 8503100,
		"ID": 939,
		"x": 25.7407317743,
		"y": 60.987170202,
		"h": 6.8021978022
	},
	{
		"stop_id": 8503446,
		"ID": 939,
		"x": 23.5597225513,
		"y": 65.572177434,
		"h": 6.8021978022
	},
	{
		"stop_id": 8503447,
		"ID": 939,
		"x": 23.5907477573,
		"y": 64.703194959,
		"h": 6.8021978022
	},
	{
		"stop_id": 8503449,
		"ID": 939,
		"x": 23.2467440133,
		"y": 63.376175967,
		"h": 6.8021978022
	},
	{
		"stop_id": 8503499,
		"ID": 939,
		"x": 23.7387499503,
		"y": 65.318174178,
		"h": 6.8021978022
	},
	{
		"stop_id": 8503500,
		"ID": 939,
		"x": 23.9167672163,
		"y": 65.356155356,
		"h": 6.8021978022
	},
	{
		"stop_id": 8503651,
		"ID": 939,
		"x": 23.5097668573,
		"y": 64.144202334,
		"h": 6.8021978022
	},
	{
		"stop_id": 8503653,
		"ID": 939,
		"x": 24.4627185863,
		"y": 62.669237842,
		"h": 6.8021978022
	},
	{
		"stop_id": 8503655,
		"ID": 939,
		"x": 25.5727661393,
		"y": 61.135194591,
		"h": 6.8021978022
	},
	{
		"stop_id": 8503681,
		"ID": 939,
		"x": 23.2327696043,
		"y": 61.864210917,
		"h": 6.8021978022
	},
	{
		"stop_id": 8530811,
		"ID": 939,
		"x": 26.1137146593,
		"y": 62.910189282,
		"h": 6.8021978022
	},
	{
		"stop_id": 8530812,
		"ID": 939,
		"x": 25.0147728393,
		"y": 63.685179194,
		"h": 6.8021978022
	},
	{
		"stop_id": 8530813,
		"ID": 939,
		"x": 24.5157332823,
		"y": 64.032213802,
		"h": 6.8021978022
	},
	{
		"stop_id": 8530822,
		"ID": 939,
		"x": 23.6377466373,
		"y": 64.949147765,
		"h": 6.8021978022
	},
	{
		"stop_id": 8573710,
		"ID": 939,
		"x": 22.2477049523,
		"y": 64.729161826,
		"h": 6.8021978022
	},
	{
		"stop_id": 8576182,
		"ID": 939,
		"x": 25.0607243733,
		"y": 62.432248442,
		"h": 6.8021978022
	},
	{
		"stop_id": 8576183,
		"ID": 939,
		"x": 25.5507729063,
		"y": 61.592212769,
		"h": 6.8021978022
	},
	{
		"stop_id": 8576184,
		"ID": 939,
		"x": 25.7447264133,
		"y": 61.035151711,
		"h": 6.8021978022
	},
	{
		"stop_id": 8576193,
		"ID": 939,
		"x": 23.8347370213,
		"y": 64.269197737,
		"h": 6.8021978022
	},
	{
		"stop_id": 8576194,
		"ID": 939,
		"x": 24.2357060453,
		"y": 63.241217026,
		"h": 6.8021978022
	},
	{
		"stop_id": 8576195,
		"ID": 939,
		"x": 24.0287645873,
		"y": 64.085244102,
		"h": 6.8021978022
	},
	{
		"stop_id": 8576196,
		"ID": 939,
		"x": 24.1697184673,
		"y": 63.862183606,
		"h": 6.8021978022
	},
	{
		"stop_id": 8576197,
		"ID": 939,
		"x": 24.3697367913,
		"y": 63.54522802,
		"h": 6.8021978022
	},
	{
		"stop_id": 8576198,
		"ID": 939,
		"x": 24.5357515603,
		"y": 63.267157861,
		"h": 6.8021978022
	},
	{
		"stop_id": 8576199,
		"ID": 939,
		"x": 24.7437326583,
		"y": 62.956221285,
		"h": 6.8021978022
	},
	{
		"stop_id": 8576200,
		"ID": 939,
		"x": 24.9507036223,
		"y": 62.638161203,
		"h": 6.8021978022
	},
	{
		"stop_id": 8576201,
		"ID": 939,
		"x": 25.4577517583,
		"y": 61.938240943,
		"h": 6.8021978022
	},
	{
		"stop_id": 8576202,
		"ID": 939,
		"x": 25.7247429753,
		"y": 61.64019559,
		"h": 6.8021978022
	},
	{
		"stop_id": 8576203,
		"ID": 939,
		"x": 25.9547510933,
		"y": 61.33517835,
		"h": 6.8021978022
	},
	{
		"stop_id": 8587347,
		"ID": 939,
		"x": 23.1857566173,
		"y": 61.55121506,
		"h": 6.8021978022
	},
	{
		"stop_id": 8587348,
		"ID": 939,
		"x": 23.3827335173,
		"y": 65.391226969,
		"h": 6.8021978022
	},
	{
		"stop_id": 8587349,
		"ID": 939,
		"x": 23.5637712583,
		"y": 65.429239914,
		"h": 6.8021978022
	},
	{
		"stop_id": 8588078,
		"ID": 939,
		"x": 23.7307176633,
		"y": 65.352197333,
		"h": 6.8021978022
	},
	{
		"stop_id": 8590672,
		"ID": 939,
		"x": 23.4777151383,
		"y": 60.032201,
		"h": 6.8021978022
	},
	{
		"stop_id": 8590677,
		"ID": 939,
		"x": 23.6427461413,
		"y": 60.37621066,
		"h": 6.8021978022
	},
	{
		"stop_id": 8590683,
		"ID": 939,
		"x": 23.7446998353,
		"y": 60.109228352,
		"h": 6.8021978022
	},
	{
		"stop_id": 8590684,
		"ID": 939,
		"x": 24.0537586893,
		"y": 60.006175662,
		"h": 6.8021978022
	},
	{
		"stop_id": 8590692,
		"ID": 939,
		"x": 23.7517697403,
		"y": 60.36417912,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591034,
		"ID": 939,
		"x": 21.0327551213,
		"y": 62.551240046,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591040,
		"ID": 939,
		"x": 25.0847544883,
		"y": 62.976213485,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591052,
		"ID": 939,
		"x": 22.1377130593,
		"y": 65.495204355,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591058,
		"ID": 939,
		"x": 22.8167453343,
		"y": 63.925244167,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591059,
		"ID": 939,
		"x": 22.7317191053,
		"y": 63.971206087,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591061,
		"ID": 939,
		"x": 21.8837192673,
		"y": 60.479165481,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591064,
		"ID": 939,
		"x": 22.8397670403,
		"y": 64.653209419,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591067,
		"ID": 939,
		"x": 23.4297087983,
		"y": 65.316163608,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591077,
		"ID": 939,
		"x": 22.5647666173,
		"y": 61.848228992,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591079,
		"ID": 939,
		"x": 22.3467250683,
		"y": 65.035200497,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591080,
		"ID": 939,
		"x": 23.0517268633,
		"y": 62.089178947,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591081,
		"ID": 939,
		"x": 22.9447652193,
		"y": 62.026197132,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591082,
		"ID": 939,
		"x": 22.8667203803,
		"y": 62.518245854,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591083,
		"ID": 939,
		"x": 21.3157470383,
		"y": 63.761200811,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591084,
		"ID": 939,
		"x": 21.2697376943,
		"y": 63.656162486,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591087,
		"ID": 939,
		"x": 25.3077242053,
		"y": 65.251196952,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591089,
		"ID": 939,
		"x": 25.8667051903,
		"y": 62.083233754,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591093,
		"ID": 939,
		"x": 23.4277701933,
		"y": 64.38322754,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591094,
		"ID": 939,
		"x": 24.8077504373,
		"y": 63.421141575,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591095,
		"ID": 939,
		"x": 22.9637576993,
		"y": 64.510165487,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591098,
		"ID": 939,
		"x": 22.4957578223,
		"y": 62.922164124,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591100,
		"ID": 939,
		"x": 22.8777743163,
		"y": 63.037222578,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591104,
		"ID": 939,
		"x": 25.8697684013,
		"y": 63.289165381,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591105,
		"ID": 939,
		"x": 23.4747342873,
		"y": 64.234221268,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591106,
		"ID": 939,
		"x": 22.7567126933,
		"y": 61.398234754,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591109,
		"ID": 939,
		"x": 24.4467402723,
		"y": 62.879164899,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591111,
		"ID": 939,
		"x": 22.7417044683,
		"y": 60.63514032,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591115,
		"ID": 939,
		"x": 26.3927617693,
		"y": 63.55515513,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591119,
		"ID": 939,
		"x": 24.8217103623,
		"y": 64.243168213,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591120,
		"ID": 939,
		"x": 25.7937697173,
		"y": 62.246190392,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591123,
		"ID": 939,
		"x": 24.1047736553,
		"y": 65.339242579,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591133,
		"ID": 939,
		"x": 25.7017139253,
		"y": 62.446233132,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591137,
		"ID": 939,
		"x": 25.1907393043,
		"y": 63.811233512,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591142,
		"ID": 939,
		"x": 26.5167661243,
		"y": 62.515189166,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591149,
		"ID": 939,
		"x": 21.0357382023,
		"y": 63.918162009,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591151,
		"ID": 939,
		"x": 20.8197473823,
		"y": 63.6681539,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591154,
		"ID": 939,
		"x": 21.9227047923,
		"y": 60.68918653,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591174,
		"ID": 939,
		"x": 23.7697499873,
		"y": 65.664199565,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591180,
		"ID": 939,
		"x": 25.3497560133,
		"y": 63.549208248,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591182,
		"ID": 939,
		"x": 21.2157238803,
		"y": 63.03619672,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591183,
		"ID": 939,
		"x": 23.6927667333,
		"y": 64.598218693,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591184,
		"ID": 939,
		"x": 22.3287056203,
		"y": 65.27824068,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591192,
		"ID": 939,
		"x": 24.5827491543,
		"y": 65.672155455,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591195,
		"ID": 939,
		"x": 21.2597223153,
		"y": 64.32818204,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591196,
		"ID": 939,
		"x": 25.0667471783,
		"y": 64.984214707,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591198,
		"ID": 939,
		"x": 25.3397160993,
		"y": 64.280159209,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591199,
		"ID": 939,
		"x": 25.1887447263,
		"y": 64.140225453,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591202,
		"ID": 939,
		"x": 24.5327181273,
		"y": 64.543165043,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591204,
		"ID": 939,
		"x": 22.4797228493,
		"y": 63.299216751,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591205,
		"ID": 939,
		"x": 22.4347642363,
		"y": 64.024234472,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591209,
		"ID": 939,
		"x": 21.0217331513,
		"y": 63.360232285,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591212,
		"ID": 939,
		"x": 26.0747042313,
		"y": 62.191206773,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591216,
		"ID": 939,
		"x": 22.5877695073,
		"y": 62.129196608,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591217,
		"ID": 939,
		"x": 22.8117758783,
		"y": 61.444144933,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591218,
		"ID": 939,
		"x": 22.0027584803,
		"y": 65.078147518,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591219,
		"ID": 939,
		"x": 22.6987131053,
		"y": 65.518216135,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591220,
		"ID": 939,
		"x": 24.2347133783,
		"y": 64.900201381,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591221,
		"ID": 939,
		"x": 25.8147263943,
		"y": 63.637183618,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591227,
		"ID": 939,
		"x": 22.2487134473,
		"y": 65.071204404,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591230,
		"ID": 939,
		"x": 24.9617728113,
		"y": 65.342201755,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591231,
		"ID": 939,
		"x": 25.2677378873,
		"y": 64.616153286,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591233,
		"ID": 939,
		"x": 25.4547240653,
		"y": 63.952234509,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591239,
		"ID": 939,
		"x": 24.1337047153,
		"y": 64.645250604,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591241,
		"ID": 939,
		"x": 23.0377587573,
		"y": 62.467148129,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591245,
		"ID": 939,
		"x": 21.7307423213,
		"y": 63.31022437,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591259,
		"ID": 939,
		"x": 21.7677330113,
		"y": 65.158193507,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591262,
		"ID": 939,
		"x": 23.2397706213,
		"y": 65.239223824,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591268,
		"ID": 939,
		"x": 22.0107358883,
		"y": 60.894213147,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591269,
		"ID": 939,
		"x": 22.0637749973,
		"y": 64.061244429,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591277,
		"ID": 939,
		"x": 22.4947451393,
		"y": 65.641141141,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591279,
		"ID": 939,
		"x": 22.7397150873,
		"y": 61.680203002,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591283,
		"ID": 939,
		"x": 22.8207399203,
		"y": 63.54624474,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591286,
		"ID": 939,
		"x": 23.1197539823,
		"y": 60.460168865,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591287,
		"ID": 939,
		"x": 23.9947705073,
		"y": 64.903144141,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591299,
		"ID": 939,
		"x": 23.3517383663,
		"y": 64.515147672,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591303,
		"ID": 939,
		"x": 24.3907478023,
		"y": 65.157158279,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591304,
		"ID": 939,
		"x": 22.9517627853,
		"y": 61.741198627,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591308,
		"ID": 939,
		"x": 21.5417355773,
		"y": 63.75417701,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591309,
		"ID": 939,
		"x": 23.6587389913,
		"y": 64.783209601,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591315,
		"ID": 939,
		"x": 26.7207416903,
		"y": 62.52416495,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591316,
		"ID": 939,
		"x": 23.3227110613,
		"y": 64.926154437,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591317,
		"ID": 939,
		"x": 23.0797738213,
		"y": 63.846186392,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591327,
		"ID": 939,
		"x": 23.6817604583,
		"y": 65.074192237,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591329,
		"ID": 939,
		"x": 21.9827170283,
		"y": 63.217178113,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591340,
		"ID": 939,
		"x": 26.0347188383,
		"y": 63.800147891,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591341,
		"ID": 939,
		"x": 21.8777089353,
		"y": 64.582173049,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591352,
		"ID": 939,
		"x": 23.1207201873,
		"y": 63.457140141,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591357,
		"ID": 939,
		"x": 23.3517439863,
		"y": 61.129230621,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591364,
		"ID": 939,
		"x": 24.7857231193,
		"y": 63.85314556,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591365,
		"ID": 939,
		"x": 22.1227556373,
		"y": 63.231230315,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591366,
		"ID": 939,
		"x": 22.1777149383,
		"y": 63.4641588,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591367,
		"ID": 939,
		"x": 22.9967494143,
		"y": 65.258175503,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591368,
		"ID": 939,
		"x": 23.2477660233,
		"y": 65.68221788,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591369,
		"ID": 939,
		"x": 23.0307065863,
		"y": 64.833225654,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591375,
		"ID": 939,
		"x": 24.3737589563,
		"y": 64.321189277,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591378,
		"ID": 939,
		"x": 23.6097412703,
		"y": 60.702205531,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591381,
		"ID": 939,
		"x": 22.6267671593,
		"y": 64.956247628,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591384,
		"ID": 939,
		"x": 23.0707249363,
		"y": 64.326189707,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591385,
		"ID": 939,
		"x": 21.3337714443,
		"y": 62.675213522,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591387,
		"ID": 939,
		"x": 23.0367045593,
		"y": 62.905230634,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591392,
		"ID": 939,
		"x": 22.5537282733,
		"y": 62.37123362,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591394,
		"ID": 939,
		"x": 25.3267231233,
		"y": 64.722188633,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591397,
		"ID": 939,
		"x": 24.8907602113,
		"y": 65.618170186,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591404,
		"ID": 939,
		"x": 22.8857579803,
		"y": 64.150147645,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591405,
		"ID": 939,
		"x": 21.4977165493,
		"y": 63.085198332,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591410,
		"ID": 939,
		"x": 22.3847714073,
		"y": 61.328247038,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591412,
		"ID": 939,
		"x": 24.5297008923,
		"y": 65.366174743,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591414,
		"ID": 939,
		"x": 22.4377386473,
		"y": 63.646221608,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591415,
		"ID": 939,
		"x": 22.3807622633,
		"y": 63.625194958,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591421,
		"ID": 939,
		"x": 25.5947477893,
		"y": 64.978228968,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591427,
		"ID": 939,
		"x": 22.4467654303,
		"y": 64.83121414,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591429,
		"ID": 939,
		"x": 25.6217449163,
		"y": 63.523208082,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591430,
		"ID": 939,
		"x": 22.9587733293,
		"y": 60.886231794,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591439,
		"ID": 939,
		"x": 22.7497395353,
		"y": 61.068232033,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591440,
		"ID": 939,
		"x": 25.4777527043,
		"y": 62.597233972,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591444,
		"ID": 939,
		"x": 25.2507699413,
		"y": 65.583182251,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591447,
		"ID": 939,
		"x": 21.6257328303,
		"y": 64.729151623,
		"h": 6.8021978022
	},
	{
		"stop_id": 8591824,
		"ID": 939,
		"x": 21.8177096433,
		"y": 63.782207784,
		"h": 6.8021978022
	},
	{
		"stop_id": 8594253,
		"ID": 939,
		"x": 23.3677705543,
		"y": 60.050229083,
		"h": 6.8021978022
	},
	{
		"stop_id": 8594254,
		"ID": 939,
		"x": 23.3617559383,
		"y": 60.31222323,
		"h": 6.8021978022
	},
	{
		"stop_id": 8014423,
		"ID": 528,
		"x": -47.9427079297,
		"y": 92.695681325,
		"h": 1.1318681319
	},
	{
		"stop_id": 8014424,
		"ID": 528,
		"x": -46.7301256617,
		"y": 91.01800274,
		"h": 1.1318681319
	},
	{
		"stop_id": 8014428,
		"ID": 528,
		"x": -46.9712443757,
		"y": 88.919195239,
		"h": 1.1318681319
	},
	{
		"stop_id": 8530641,
		"ID": 528,
		"x": -48.0212351587,
		"y": 89.755182464,
		"h": 1.1318681319
	},
	{
		"stop_id": 8595519,
		"ID": 528,
		"x": -46.9952441847,
		"y": 88.817181942,
		"h": 1.1318681319
	},
	{
		"stop_id": 8014429,
		"ID": 527,
		"x": -44.9873756957,
		"y": 88.552758304,
		"h": 5.4505494505
	},
	{
		"stop_id": 8060978,
		"ID": 527,
		"x": -44.8422682807,
		"y": 88.130153187,
		"h": 5.4505494505
	},
	{
		"stop_id": 8087021,
		"ID": 527,
		"x": -45.0822773257,
		"y": 86.200187007,
		"h": 5.4505494505
	},
	{
		"stop_id": 8500010,
		"ID": 527,
		"x": -48.3802569677,
		"y": 83.73923544,
		"h": 5.4505494505
	},
	{
		"stop_id": 8500073,
		"ID": 527,
		"x": -47.9832588527,
		"y": 84.17319914,
		"h": 5.4505494505
	},
	{
		"stop_id": 8500079,
		"ID": 527,
		"x": -48.4952715797,
		"y": 84.169205379,
		"h": 5.4505494505
	},
	{
		"stop_id": 8500090,
		"ID": 527,
		"x": -47.0502462457,
		"y": 86.048212014,
		"h": 5.4505494505
	},
	{
		"stop_id": 8500147,
		"ID": 527,
		"x": -47.7432824977,
		"y": 83.130174663,
		"h": 5.4505494505
	},
	{
		"stop_id": 8500161,
		"ID": 527,
		"x": -48.0302607557,
		"y": 83.234230064,
		"h": 5.4505494505
	},
	{
		"stop_id": 8500189,
		"ID": 527,
		"x": -48.2732676777,
		"y": 83.380191015,
		"h": 5.4505494505
	},
	{
		"stop_id": 8500236,
		"ID": 527,
		"x": -47.7422778767,
		"y": 83.825215939,
		"h": 5.4505494505
	},
	{
		"stop_id": 8500237,
		"ID": 527,
		"x": -48.1792483747,
		"y": 84.430216295,
		"h": 5.4505494505
	},
	{
		"stop_id": 8500254,
		"ID": 527,
		"x": -48.2242491987,
		"y": 87.062201607,
		"h": 5.4505494505
	},
	{
		"stop_id": 8500872,
		"ID": 527,
		"x": -48.4662333347,
		"y": 85.130154743,
		"h": 5.4505494505
	},
	{
		"stop_id": 8500897,
		"ID": 527,
		"x": -48.4192697397,
		"y": 84.538162944,
		"h": 5.4505494505
	},
	{
		"stop_id": 8500898,
		"ID": 527,
		"x": -48.0802409357,
		"y": 85.337156022,
		"h": 5.4505494505
	},
	{
		"stop_id": 8500899,
		"ID": 527,
		"x": -47.6262793207,
		"y": 85.52519654,
		"h": 5.4505494505
	},
	{
		"stop_id": 8500994,
		"ID": 527,
		"x": -48.3642359577,
		"y": 84.375154126,
		"h": 5.4505494505
	},
	{
		"stop_id": 8530638,
		"ID": 527,
		"x": -47.5232310667,
		"y": 84.601204273,
		"h": 5.4505494505
	},
	{
		"stop_id": 8530735,
		"ID": 527,
		"x": -46.1402685317,
		"y": 84.947230972,
		"h": 5.4505494505
	},
	{
		"stop_id": 8530764,
		"ID": 527,
		"x": -46.5342957617,
		"y": 84.818250939,
		"h": 5.4505494505
	},
	{
		"stop_id": 8578143,
		"ID": 527,
		"x": -48.3242860147,
		"y": 83.837188714,
		"h": 5.4505494505
	},
	{
		"stop_id": 8578144,
		"ID": 527,
		"x": -49.6072608777,
		"y": 85.7742187,
		"h": 5.4505494505
	},
	{
		"stop_id": 8578305,
		"ID": 527,
		"x": -45.0612550587,
		"y": 84.304240166,
		"h": 5.4505494505
	},
	{
		"stop_id": 8578306,
		"ID": 527,
		"x": -46.4852801437,
		"y": 84.642236896,
		"h": 5.4505494505
	},
	{
		"stop_id": 8578307,
		"ID": 527,
		"x": -45.7702659657,
		"y": 84.628200046,
		"h": 5.4505494505
	},
	{
		"stop_id": 8578308,
		"ID": 527,
		"x": -45.4902432497,
		"y": 84.588171074,
		"h": 5.4505494505
	},
	{
		"stop_id": 8578309,
		"ID": 527,
		"x": -45.1172602957,
		"y": 84.610204971,
		"h": 5.4505494505
	},
	{
		"stop_id": 8578340,
		"ID": 527,
		"x": -45.8692537327,
		"y": 84.34221219,
		"h": 5.4505494505
	},
	{
		"stop_id": 8580373,
		"ID": 527,
		"x": -49.0102920627,
		"y": 84.91321782,
		"h": 5.4505494505
	},
	{
		"stop_id": 8588071,
		"ID": 527,
		"x": -47.8822686507,
		"y": 83.509159207,
		"h": 5.4505494505
	},
	{
		"stop_id": 8588485,
		"ID": 527,
		"x": -48.9002327677,
		"y": 85.520176409,
		"h": 5.4505494505
	},
	{
		"stop_id": 8588486,
		"ID": 527,
		"x": -49.0702765247,
		"y": 85.24723276,
		"h": 5.4505494505
	},
	{
		"stop_id": 8588487,
		"ID": 527,
		"x": -48.6262876587,
		"y": 84.350196405,
		"h": 5.4505494505
	},
	{
		"stop_id": 8588488,
		"ID": 527,
		"x": -49.2332339747,
		"y": 85.597188056,
		"h": 5.4505494505
	},
	{
		"stop_id": 8588489,
		"ID": 527,
		"x": -48.7922893927,
		"y": 84.813212023,
		"h": 5.4505494505
	},
	{
		"stop_id": 8588766,
		"ID": 527,
		"x": -48.3202776507,
		"y": 86.097224051,
		"h": 5.4505494505
	},
	{
		"stop_id": 8588767,
		"ID": 527,
		"x": -48.3332686757,
		"y": 86.631242264,
		"h": 5.4505494505
	},
	{
		"stop_id": 8588768,
		"ID": 527,
		"x": -48.3652780477,
		"y": 86.333192856,
		"h": 5.4505494505
	},
	{
		"stop_id": 8588769,
		"ID": 527,
		"x": -48.2602593947,
		"y": 85.841159519,
		"h": 5.4505494505
	},
	{
		"stop_id": 8588770,
		"ID": 527,
		"x": -47.7012605007,
		"y": 83.570232396,
		"h": 5.4505494505
	},
	{
		"stop_id": 8588772,
		"ID": 527,
		"x": -48.8092631467,
		"y": 85.611184725,
		"h": 5.4505494505
	},
	{
		"stop_id": 8588773,
		"ID": 527,
		"x": -48.6602993837,
		"y": 85.312250751,
		"h": 5.4505494505
	},
	{
		"stop_id": 8588774,
		"ID": 527,
		"x": -48.2312514477,
		"y": 85.551234079,
		"h": 5.4505494505
	},
	{
		"stop_id": 8588775,
		"ID": 527,
		"x": -48.5292252327,
		"y": 84.929228119,
		"h": 5.4505494505
	},
	{
		"stop_id": 8588777,
		"ID": 527,
		"x": -49.1002856157,
		"y": 86.076205782,
		"h": 5.4505494505
	},
	{
		"stop_id": 8588778,
		"ID": 527,
		"x": -47.6302448697,
		"y": 83.263163078,
		"h": 5.4505494505
	},
	{
		"stop_id": 8588779,
		"ID": 527,
		"x": -48.2342668987,
		"y": 85.243234266,
		"h": 5.4505494505
	},
	{
		"stop_id": 8588780,
		"ID": 527,
		"x": -48.5632471367,
		"y": 85.050248807,
		"h": 5.4505494505
	},
	{
		"stop_id": 8588781,
		"ID": 527,
		"x": -48.9842558227,
		"y": 85.87215997,
		"h": 5.4505494505
	},
	{
		"stop_id": 8588782,
		"ID": 527,
		"x": -49.2432974057,
		"y": 86.309226698,
		"h": 5.4505494505
	},
	{
		"stop_id": 8588942,
		"ID": 527,
		"x": -46.2632385807,
		"y": 83.914227919,
		"h": 5.4505494505
	},
	{
		"stop_id": 8588943,
		"ID": 527,
		"x": -46.2042361947,
		"y": 83.030190901,
		"h": 5.4505494505
	},
	{
		"stop_id": 8588947,
		"ID": 527,
		"x": -46.5132367187,
		"y": 84.116251198,
		"h": 5.4505494505
	},
	{
		"stop_id": 8588948,
		"ID": 527,
		"x": -46.0362555637,
		"y": 83.743183747,
		"h": 5.4505494505
	},
	{
		"stop_id": 8588949,
		"ID": 527,
		"x": -46.1642784027,
		"y": 83.434229881,
		"h": 5.4505494505
	},
	{
		"stop_id": 8588950,
		"ID": 527,
		"x": -47.4832838427,
		"y": 83.955168605,
		"h": 5.4505494505
	},
	{
		"stop_id": 8588951,
		"ID": 527,
		"x": -47.1842392767,
		"y": 83.722186325,
		"h": 5.4505494505
	},
	{
		"stop_id": 8588952,
		"ID": 527,
		"x": -46.8922651357,
		"y": 83.810205452,
		"h": 5.4505494505
	},
	{
		"stop_id": 8588953,
		"ID": 527,
		"x": -46.7672816627,
		"y": 84.18017982,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589292,
		"ID": 527,
		"x": -45.6332496027,
		"y": 85.40818251,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589298,
		"ID": 527,
		"x": -48.0182547837,
		"y": 86.342207224,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589300,
		"ID": 527,
		"x": -48.1242803857,
		"y": 83.150209382,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589305,
		"ID": 527,
		"x": -47.8372799997,
		"y": 85.439153944,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589306,
		"ID": 527,
		"x": -45.7142452627,
		"y": 86.11515491,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589307,
		"ID": 527,
		"x": -46.3792579367,
		"y": 86.260167121,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589309,
		"ID": 527,
		"x": -48.4162535217,
		"y": 85.798163228,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589312,
		"ID": 527,
		"x": -46.0362522357,
		"y": 84.100210721,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589316,
		"ID": 527,
		"x": -47.3492363917,
		"y": 85.660196345,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589317,
		"ID": 527,
		"x": -47.1112304407,
		"y": 83.976184899,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589319,
		"ID": 527,
		"x": -47.9592491097,
		"y": 85.919248261,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589320,
		"ID": 527,
		"x": -47.5692564547,
		"y": 84.288224322,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589324,
		"ID": 527,
		"x": -46.7222899687,
		"y": 85.974203313,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589325,
		"ID": 527,
		"x": -47.7852711297,
		"y": 86.968224824,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589326,
		"ID": 527,
		"x": -47.0942808677,
		"y": 85.030180383,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589327,
		"ID": 527,
		"x": -48.7942391557,
		"y": 84.319196414,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589329,
		"ID": 527,
		"x": -46.4052276647,
		"y": 85.628219162,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589331,
		"ID": 527,
		"x": -48.3792816947,
		"y": 87.084140788,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589332,
		"ID": 527,
		"x": -46.1752402357,
		"y": 85.79118833,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589333,
		"ID": 527,
		"x": -48.2692845057,
		"y": 84.20221589,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589334,
		"ID": 527,
		"x": -48.1692393897,
		"y": 87.481160731,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589336,
		"ID": 527,
		"x": -48.0412347817,
		"y": 84.524218816,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589337,
		"ID": 527,
		"x": -47.2412887687,
		"y": 86.61020313,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589341,
		"ID": 527,
		"x": -47.5782790767,
		"y": 86.046216687,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589344,
		"ID": 527,
		"x": -47.7812883287,
		"y": 86.149210289,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589345,
		"ID": 527,
		"x": -48.5792658897,
		"y": 84.643155941,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589346,
		"ID": 527,
		"x": -46.3092294937,
		"y": 84.278155649,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589348,
		"ID": 527,
		"x": -49.0022508797,
		"y": 86.335231203,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589350,
		"ID": 527,
		"x": -47.2822650657,
		"y": 85.23314762,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589352,
		"ID": 527,
		"x": -47.7682570447,
		"y": 85.956211743,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589353,
		"ID": 527,
		"x": -46.3732859877,
		"y": 85.246244811,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589355,
		"ID": 527,
		"x": -47.3502770827,
		"y": 85.005178784,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589358,
		"ID": 527,
		"x": -47.3212530277,
		"y": 86.205194024,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589359,
		"ID": 527,
		"x": -46.7532487097,
		"y": 86.469151167,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589362,
		"ID": 527,
		"x": -47.2842548097,
		"y": 84.101240122,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589363,
		"ID": 527,
		"x": -46.0012920487,
		"y": 85.256212303,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589364,
		"ID": 527,
		"x": -47.2592930907,
		"y": 84.330230238,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589368,
		"ID": 527,
		"x": -46.9352295527,
		"y": 86.207237717,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589369,
		"ID": 527,
		"x": -48.9212534027,
		"y": 84.500201429,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589371,
		"ID": 527,
		"x": -46.6602274947,
		"y": 85.130190864,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589372,
		"ID": 527,
		"x": -46.8512822837,
		"y": 84.489212907,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589374,
		"ID": 527,
		"x": -48.0672775767,
		"y": 87.776236229,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589375,
		"ID": 527,
		"x": -46.7952338697,
		"y": 85.399194914,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589376,
		"ID": 527,
		"x": -47.7222354307,
		"y": 85.043218933,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589380,
		"ID": 527,
		"x": -46.7982894497,
		"y": 83.418247547,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589395,
		"ID": 527,
		"x": -46.1442824097,
		"y": 84.531152519,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589396,
		"ID": 527,
		"x": -45.3222558647,
		"y": 83.851172626,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589397,
		"ID": 527,
		"x": -45.5602255707,
		"y": 83.919202373,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589441,
		"ID": 527,
		"x": -44.0332283867,
		"y": 86.371215307,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589445,
		"ID": 527,
		"x": -44.7412875617,
		"y": 86.305224662,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589446,
		"ID": 527,
		"x": -44.6742537247,
		"y": 87.109185596,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589452,
		"ID": 527,
		"x": -44.8612370277,
		"y": 85.887183215,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589454,
		"ID": 527,
		"x": -45.3792734297,
		"y": 86.350233214,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589456,
		"ID": 527,
		"x": -45.3622694457,
		"y": 86.56820616,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589460,
		"ID": 527,
		"x": -45.0612354697,
		"y": 85.421245873,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589466,
		"ID": 527,
		"x": -44.1062278777,
		"y": 86.83123673,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589471,
		"ID": 527,
		"x": -44.0092494367,
		"y": 87.174180726,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589472,
		"ID": 527,
		"x": -44.9692262677,
		"y": 86.914194386,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589473,
		"ID": 527,
		"x": -45.1282752687,
		"y": 86.300144086,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589474,
		"ID": 527,
		"x": -44.8142810877,
		"y": 86.097227062,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589475,
		"ID": 527,
		"x": -44.5202513127,
		"y": 87.259240795,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589477,
		"ID": 527,
		"x": -44.3492256327,
		"y": 86.703177094,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589482,
		"ID": 527,
		"x": -44.1582247177,
		"y": 86.461171364,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589483,
		"ID": 527,
		"x": -44.6362764977,
		"y": 86.555223347,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589486,
		"ID": 527,
		"x": -43.6352483777,
		"y": 86.621237442,
		"h": 5.4505494505
	},
	{
		"stop_id": 8589487,
		"ID": 527,
		"x": -44.2642438197,
		"y": 86.143224716,
		"h": 5.4505494505
	},
	{
		"stop_id": 8592321,
		"ID": 527,
		"x": -47.0642601917,
		"y": 85.880174861,
		"h": 5.4505494505
	},
	{
		"stop_id": 8592325,
		"ID": 527,
		"x": -48.5622860097,
		"y": 87.737145075,
		"h": 5.4505494505
	},
	{
		"stop_id": 8592328,
		"ID": 527,
		"x": -44.8692541957,
		"y": 85.363238742,
		"h": 5.4505494505
	},
	{
		"stop_id": 8592329,
		"ID": 527,
		"x": -43.9472849927,
		"y": 84.644227872,
		"h": 5.4505494505
	},
	{
		"stop_id": 8592330,
		"ID": 527,
		"x": -44.3372659307,
		"y": 84.967206801,
		"h": 5.4505494505
	},
	{
		"stop_id": 8592350,
		"ID": 527,
		"x": -47.5722449237,
		"y": 88.497187228,
		"h": 5.4505494505
	},
	{
		"stop_id": 8594926,
		"ID": 527,
		"x": -47.9852535217,
		"y": 87.308177286,
		"h": 5.4505494505
	},
	{
		"stop_id": 8595517,
		"ID": 527,
		"x": -48.1272554587,
		"y": 88.363202463,
		"h": 5.4505494505
	},
	{
		"stop_id": 8595518,
		"ID": 527,
		"x": -48.0442428067,
		"y": 88.570179447,
		"h": 5.4505494505
	},
	{
		"stop_id": 8595601,
		"ID": 527,
		"x": -44.9992722357,
		"y": 83.776247101,
		"h": 5.4505494505
	},
	{
		"stop_id": 8014439,
		"ID": 561,
		"x": -43.6892549537,
		"y": 87.725207586,
		"h": 2.3186813187
	},
	{
		"stop_id": 8014440,
		"ID": 561,
		"x": -43.1665274767,
		"y": 89.757209841,
		"h": 2.3186813187
	},
	{
		"stop_id": 8014441,
		"ID": 561,
		"x": -42.6901746867,
		"y": 91.163464081,
		"h": 2.3186813187
	},
	{
		"stop_id": 8060979,
		"ID": 561,
		"x": -44.1422272277,
		"y": 88.130175674,
		"h": 2.3186813187
	},
	{
		"stop_id": 8069220,
		"ID": 561,
		"x": -41.9422752067,
		"y": 89.130199917,
		"h": 2.3186813187
	},
	{
		"stop_id": 8069221,
		"ID": 561,
		"x": -41.5422881697,
		"y": 90.130244934,
		"h": 2.3186813187
	},
	{
		"stop_id": 8589385,
		"ID": 561,
		"x": -42.7212700117,
		"y": 86.363163622,
		"h": 2.3186813187
	},
	{
		"stop_id": 8589386,
		"ID": 561,
		"x": -42.2412456697,
		"y": 86.152189805,
		"h": 2.3186813187
	},
	{
		"stop_id": 8589387,
		"ID": 561,
		"x": -42.9682308077,
		"y": 86.336218521,
		"h": 2.3186813187
	},
	{
		"stop_id": 8589388,
		"ID": 561,
		"x": -41.2282273967,
		"y": 86.27224105,
		"h": 2.3186813187
	},
	{
		"stop_id": 8589389,
		"ID": 561,
		"x": -41.6962601957,
		"y": 86.317162715,
		"h": 2.3186813187
	},
	{
		"stop_id": 8589390,
		"ID": 561,
		"x": -42.4382786107,
		"y": 86.342190221,
		"h": 2.3186813187
	},
	{
		"stop_id": 8589391,
		"ID": 561,
		"x": -41.3372772747,
		"y": 86.422229818,
		"h": 2.3186813187
	},
	{
		"stop_id": 8589442,
		"ID": 561,
		"x": -42.8122733397,
		"y": 87.637140068,
		"h": 2.3186813187
	},
	{
		"stop_id": 8589443,
		"ID": 561,
		"x": -43.9022337127,
		"y": 87.501142179,
		"h": 2.3186813187
	},
	{
		"stop_id": 8589444,
		"ID": 561,
		"x": -44.0512962717,
		"y": 87.653187251,
		"h": 2.3186813187
	},
	{
		"stop_id": 8589447,
		"ID": 561,
		"x": -42.5252916677,
		"y": 87.542232497,
		"h": 2.3186813187
	},
	{
		"stop_id": 8589448,
		"ID": 561,
		"x": -43.2412329017,
		"y": 87.499165758,
		"h": 2.3186813187
	},
	{
		"stop_id": 8589449,
		"ID": 561,
		"x": -43.5352919647,
		"y": 87.682151381,
		"h": 2.3186813187
	},
	{
		"stop_id": 8589450,
		"ID": 561,
		"x": -43.8752947437,
		"y": 87.86425018,
		"h": 2.3186813187
	},
	{
		"stop_id": 8589451,
		"ID": 561,
		"x": -43.7802351907,
		"y": 88.126247468,
		"h": 2.3186813187
	},
	{
		"stop_id": 8589453,
		"ID": 561,
		"x": -43.4952862897,
		"y": 87.935218753,
		"h": 2.3186813187
	},
	{
		"stop_id": 8589455,
		"ID": 561,
		"x": -43.4452877287,
		"y": 88.984215918,
		"h": 2.3186813187
	},
	{
		"stop_id": 8589457,
		"ID": 561,
		"x": -42.5382758157,
		"y": 87.635149787,
		"h": 2.3186813187
	},
	{
		"stop_id": 8589458,
		"ID": 561,
		"x": -43.4152480617,
		"y": 88.182170154,
		"h": 2.3186813187
	},
	{
		"stop_id": 8589459,
		"ID": 561,
		"x": -43.0602676297,
		"y": 88.156251128,
		"h": 2.3186813187
	},
	{
		"stop_id": 8589461,
		"ID": 561,
		"x": -42.8412738707,
		"y": 88.098163417,
		"h": 2.3186813187
	},
	{
		"stop_id": 8589462,
		"ID": 561,
		"x": -42.8192425067,
		"y": 88.312156695,
		"h": 2.3186813187
	},
	{
		"stop_id": 8589464,
		"ID": 561,
		"x": -42.4452548167,
		"y": 87.932187582,
		"h": 2.3186813187
	},
	{
		"stop_id": 8589465,
		"ID": 561,
		"x": -42.2472935287,
		"y": 87.970240195,
		"h": 2.3186813187
	},
	{
		"stop_id": 8589467,
		"ID": 561,
		"x": -43.5832658797,
		"y": 88.749225676,
		"h": 2.3186813187
	},
	{
		"stop_id": 8589468,
		"ID": 561,
		"x": -43.7562859077,
		"y": 87.084237918,
		"h": 2.3186813187
	},
	{
		"stop_id": 8589469,
		"ID": 561,
		"x": -43.4792378747,
		"y": 87.597244496,
		"h": 2.3186813187
	},
	{
		"stop_id": 8589470,
		"ID": 561,
		"x": -43.1912716657,
		"y": 87.739142361,
		"h": 2.3186813187
	},
	{
		"stop_id": 8589476,
		"ID": 561,
		"x": -42.5272248047,
		"y": 88.440200223,
		"h": 2.3186813187
	},
	{
		"stop_id": 8589479,
		"ID": 561,
		"x": -43.6012608137,
		"y": 87.817178591,
		"h": 2.3186813187
	},
	{
		"stop_id": 8589480,
		"ID": 561,
		"x": -43.2032675657,
		"y": 88.344206702,
		"h": 2.3186813187
	},
	{
		"stop_id": 8589481,
		"ID": 561,
		"x": -43.1792850417,
		"y": 86.492179964,
		"h": 2.3186813187
	},
	{
		"stop_id": 8589484,
		"ID": 561,
		"x": -43.7482939747,
		"y": 87.914182505,
		"h": 2.3186813187
	},
	{
		"stop_id": 8589485,
		"ID": 561,
		"x": -43.7082532037,
		"y": 88.4071976,
		"h": 2.3186813187
	},
	{
		"stop_id": 8592339,
		"ID": 561,
		"x": -43.7002586827,
		"y": 87.788222633,
		"h": 2.3186813187
	},
	{
		"stop_id": 8014474,
		"ID": 809,
		"x": -1.0382844407,
		"y": 92.244015988,
		"h": 1.0989010989
	},
	{
		"stop_id": 8572533,
		"ID": 809,
		"x": -1.3912691027,
		"y": 91.934167671,
		"h": 1.0989010989
	},
	{
		"stop_id": 8572534,
		"ID": 809,
		"x": -1.8052243527,
		"y": 91.727155102,
		"h": 1.0989010989
	},
	{
		"stop_id": 8572535,
		"ID": 809,
		"x": -2.2262531007,
		"y": 91.695237522,
		"h": 1.0989010989
	},
	{
		"stop_id": 8014481,
		"ID": 884,
		"x": 14.7388093963,
		"y": 96.666977407,
		"h": 1.0989010989
	},
	{
		"stop_id": 8014488,
		"ID": 884,
		"x": 15.2325976293,
		"y": 97.306756204,
		"h": 1.0989010989
	},
	{
		"stop_id": 8578380,
		"ID": 884,
		"x": 15.0697612133,
		"y": 97.364180346,
		"h": 1.0989010989
	},
	{
		"stop_id": 8578381,
		"ID": 884,
		"x": 14.8617708633,
		"y": 97.630208837,
		"h": 1.0989010989
	},
	{
		"stop_id": 8014482,
		"ID": 914,
		"x": 17.2440513113,
		"y": 98.912883011,
		"h": 1.4615384615
	},
	{
		"stop_id": 8014483,
		"ID": 914,
		"x": 19.5965499643,
		"y": 100.023104994,
		"h": 1.4615384615
	},
	{
		"stop_id": 8503490,
		"ID": 914,
		"x": 19.7767365803,
		"y": 101.487210799,
		"h": 1.4615384615
	},
	{
		"stop_id": 8578370,
		"ID": 914,
		"x": 19.8097434033,
		"y": 103.000161851,
		"h": 1.4615384615
	},
	{
		"stop_id": 8578371,
		"ID": 914,
		"x": 20.2147174953,
		"y": 101.794173385,
		"h": 1.4615384615
	},
	{
		"stop_id": 8578385,
		"ID": 914,
		"x": 17.5667298603,
		"y": 97.592232,
		"h": 1.4615384615
	},
	{
		"stop_id": 8578386,
		"ID": 914,
		"x": 17.2927491993,
		"y": 97.853196383,
		"h": 1.4615384615
	},
	{
		"stop_id": 8578387,
		"ID": 914,
		"x": 17.2547117713,
		"y": 98.936152628,
		"h": 1.4615384615
	},
	{
		"stop_id": 8578388,
		"ID": 914,
		"x": 16.7577013423,
		"y": 100.330177476,
		"h": 1.4615384615
	},
	{
		"stop_id": 8578389,
		"ID": 914,
		"x": 16.9657578193,
		"y": 100.906251245,
		"h": 1.4615384615
	},
	{
		"stop_id": 8578391,
		"ID": 914,
		"x": 17.4387001173,
		"y": 100.948237067,
		"h": 1.4615384615
	},
	{
		"stop_id": 8578392,
		"ID": 914,
		"x": 18.3157617923,
		"y": 101.692188934,
		"h": 1.4615384615
	},
	{
		"stop_id": 8595089,
		"ID": 914,
		"x": 19.9437535913,
		"y": 100.06715772,
		"h": 1.4615384615
	},
	{
		"stop_id": 8595654,
		"ID": 914,
		"x": 19.5767167163,
		"y": 100.046190861,
		"h": 1.4615384615
	},
	{
		"stop_id": 8595655,
		"ID": 914,
		"x": 20.0247310213,
		"y": 100.264196253,
		"h": 1.4615384615
	},
	{
		"stop_id": 8014484,
		"ID": 979,
		"x": 25.5354095453,
		"y": 100.745075781,
		"h": 4.8241758242
	},
	{
		"stop_id": 8014485,
		"ID": 979,
		"x": 28.3759563953,
		"y": 99.421045838,
		"h": 4.8241758242
	},
	{
		"stop_id": 8503423,
		"ID": 979,
		"x": 29.3307027883,
		"y": 99.493231769,
		"h": 4.8241758242
	},
	{
		"stop_id": 8503424,
		"ID": 979,
		"x": 29.8917410733,
		"y": 101.186199738,
		"h": 4.8241758242
	},
	{
		"stop_id": 8503425,
		"ID": 979,
		"x": 30.8947711273,
		"y": 100.521181471,
		"h": 4.8241758242
	},
	{
		"stop_id": 8503479,
		"ID": 979,
		"x": 29.2767267293,
		"y": 100.570234919,
		"h": 4.8241758242
	},
	{
		"stop_id": 8503480,
		"ID": 979,
		"x": 28.8057345113,
		"y": 99.406249591,
		"h": 4.8241758242
	},
	{
		"stop_id": 8503481,
		"ID": 979,
		"x": 28.4017493673,
		"y": 99.544203803,
		"h": 4.8241758242
	},
	{
		"stop_id": 8503482,
		"ID": 979,
		"x": 27.5487697463,
		"y": 100.748214766,
		"h": 4.8241758242
	},
	{
		"stop_id": 8503495,
		"ID": 979,
		"x": 29.8937328573,
		"y": 101.139189189,
		"h": 4.8241758242
	},
	{
		"stop_id": 8503958,
		"ID": 979,
		"x": 30.6827549913,
		"y": 100.280160744,
		"h": 4.8241758242
	},
	{
		"stop_id": 8503959,
		"ID": 979,
		"x": 29.6827314453,
		"y": 100.380215393,
		"h": 4.8241758242
	},
	{
		"stop_id": 8503971,
		"ID": 979,
		"x": 30.0827619283,
		"y": 98.180177745,
		"h": 4.8241758242
	},
	{
		"stop_id": 8506039,
		"ID": 979,
		"x": 28.5407090733,
		"y": 98.750157169,
		"h": 4.8241758242
	},
	{
		"stop_id": 8506049,
		"ID": 979,
		"x": 28.5227729883,
		"y": 97.696210249,
		"h": 4.8241758242
	},
	{
		"stop_id": 8506150,
		"ID": 979,
		"x": 30.5187656483,
		"y": 100.863153767,
		"h": 4.8241758242
	},
	{
		"stop_id": 8518243,
		"ID": 979,
		"x": 26.8877575013,
		"y": 100.810183583,
		"h": 4.8241758242
	},
	{
		"stop_id": 8518924,
		"ID": 979,
		"x": 28.7767341263,
		"y": 99.097215379,
		"h": 4.8241758242
	},
	{
		"stop_id": 8530649,
		"ID": 979,
		"x": 28.2677125263,
		"y": 98.910213417,
		"h": 4.8241758242
	},
	{
		"stop_id": 8573441,
		"ID": 979,
		"x": 29.8577015633,
		"y": 100.655221473,
		"h": 4.8241758242
	},
	{
		"stop_id": 8573442,
		"ID": 979,
		"x": 30.2827137243,
		"y": 100.755228054,
		"h": 4.8241758242
	},
	{
		"stop_id": 8573445,
		"ID": 979,
		"x": 30.2077223983,
		"y": 100.405224132,
		"h": 4.8241758242
	},
	{
		"stop_id": 8573447,
		"ID": 979,
		"x": 29.8497101263,
		"y": 98.450197716,
		"h": 4.8241758242
	},
	{
		"stop_id": 8573449,
		"ID": 979,
		"x": 31.1577081403,
		"y": 100.030248028,
		"h": 4.8241758242
	},
	{
		"stop_id": 8573450,
		"ID": 979,
		"x": 31.5047164693,
		"y": 99.743248344,
		"h": 4.8241758242
	},
	{
		"stop_id": 8573453,
		"ID": 979,
		"x": 29.9777283863,
		"y": 97.9351465,
		"h": 4.8241758242
	},
	{
		"stop_id": 8573455,
		"ID": 979,
		"x": 28.5577184643,
		"y": 97.680164092,
		"h": 4.8241758242
	},
	{
		"stop_id": 8573456,
		"ID": 979,
		"x": 29.6587263673,
		"y": 100.893184508,
		"h": 4.8241758242
	},
	{
		"stop_id": 8573457,
		"ID": 979,
		"x": 29.5077449223,
		"y": 101.205167176,
		"h": 4.8241758242
	},
	{
		"stop_id": 8573458,
		"ID": 979,
		"x": 29.4147349783,
		"y": 101.388140629,
		"h": 4.8241758242
	},
	{
		"stop_id": 8573460,
		"ID": 979,
		"x": 29.3637361013,
		"y": 102.347203742,
		"h": 4.8241758242
	},
	{
		"stop_id": 8573461,
		"ID": 979,
		"x": 29.2507455083,
		"y": 102.741173332,
		"h": 4.8241758242
	},
	{
		"stop_id": 8573462,
		"ID": 979,
		"x": 28.9727487803,
		"y": 103.129209225,
		"h": 4.8241758242
	},
	{
		"stop_id": 8573465,
		"ID": 979,
		"x": 30.2697315513,
		"y": 102.287141831,
		"h": 4.8241758242
	},
	{
		"stop_id": 8573736,
		"ID": 979,
		"x": 30.4947755643,
		"y": 100.895147614,
		"h": 4.8241758242
	},
	{
		"stop_id": 8573737,
		"ID": 979,
		"x": 31.3607189893,
		"y": 100.542159986,
		"h": 4.8241758242
	},
	{
		"stop_id": 8573738,
		"ID": 979,
		"x": 31.5737149893,
		"y": 100.267216285,
		"h": 4.8241758242
	},
	{
		"stop_id": 8578373,
		"ID": 979,
		"x": 26.1737172363,
		"y": 100.921162,
		"h": 4.8241758242
	},
	{
		"stop_id": 8578374,
		"ID": 979,
		"x": 26.8407295243,
		"y": 100.863204909,
		"h": 4.8241758242
	},
	{
		"stop_id": 8578375,
		"ID": 979,
		"x": 28.3147295693,
		"y": 99.975162856,
		"h": 4.8241758242
	},
	{
		"stop_id": 8578376,
		"ID": 979,
		"x": 28.8397734443,
		"y": 99.210147936,
		"h": 4.8241758242
	},
	{
		"stop_id": 8578377,
		"ID": 979,
		"x": 29.1367262033,
		"y": 99.976165041,
		"h": 4.8241758242
	},
	{
		"stop_id": 8579928,
		"ID": 979,
		"x": 28.8407428033,
		"y": 102.046168554,
		"h": 4.8241758242
	},
	{
		"stop_id": 8579930,
		"ID": 979,
		"x": 29.1237456663,
		"y": 102.07022773,
		"h": 4.8241758242
	},
	{
		"stop_id": 8580596,
		"ID": 979,
		"x": 30.8267123263,
		"y": 100.445180541,
		"h": 4.8241758242
	},
	{
		"stop_id": 8581073,
		"ID": 979,
		"x": 30.3007717543,
		"y": 100.944223577,
		"h": 4.8241758242
	},
	{
		"stop_id": 8582052,
		"ID": 979,
		"x": 28.6007601513,
		"y": 98.637181981,
		"h": 4.8241758242
	},
	{
		"stop_id": 8582102,
		"ID": 979,
		"x": 29.3147461013,
		"y": 99.416146583,
		"h": 4.8241758242
	},
	{
		"stop_id": 8588884,
		"ID": 979,
		"x": 29.4817564213,
		"y": 101.840214444,
		"h": 4.8241758242
	},
	{
		"stop_id": 8588885,
		"ID": 979,
		"x": 29.7307238123,
		"y": 102.894241953,
		"h": 4.8241758242
	},
	{
		"stop_id": 8588886,
		"ID": 979,
		"x": 29.6637584683,
		"y": 101.867218276,
		"h": 4.8241758242
	},
	{
		"stop_id": 8588887,
		"ID": 979,
		"x": 29.8317299683,
		"y": 101.321182532,
		"h": 4.8241758242
	},
	{
		"stop_id": 8589223,
		"ID": 979,
		"x": 29.8047239723,
		"y": 103.210198169,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592498,
		"ID": 979,
		"x": 28.6247357463,
		"y": 99.442231736,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592499,
		"ID": 979,
		"x": 29.0177493503,
		"y": 99.420227215,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592500,
		"ID": 979,
		"x": 29.1197442283,
		"y": 99.688216438,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592501,
		"ID": 979,
		"x": 27.8247623283,
		"y": 98.975230059,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592502,
		"ID": 979,
		"x": 28.7457469873,
		"y": 99.735187444,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592503,
		"ID": 979,
		"x": 28.9297087763,
		"y": 99.302245539,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592504,
		"ID": 979,
		"x": 27.8267483763,
		"y": 99.09425029,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592505,
		"ID": 979,
		"x": 27.6137412153,
		"y": 98.984218902,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592506,
		"ID": 979,
		"x": 28.7827482913,
		"y": 100.221161581,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592507,
		"ID": 979,
		"x": 28.8547352653,
		"y": 99.094162017,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592508,
		"ID": 979,
		"x": 28.2037550183,
		"y": 99.411244177,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592509,
		"ID": 979,
		"x": 29.1247407483,
		"y": 99.073207137,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592510,
		"ID": 979,
		"x": 28.0627029323,
		"y": 99.23621413,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592511,
		"ID": 979,
		"x": 28.8607491393,
		"y": 100.741226916,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592512,
		"ID": 979,
		"x": 28.7597721283,
		"y": 100.041217051,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592515,
		"ID": 979,
		"x": 29.7127300183,
		"y": 103.19923569,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592517,
		"ID": 979,
		"x": 29.7157176783,
		"y": 102.049165217,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592518,
		"ID": 979,
		"x": 31.3317600163,
		"y": 100.890237829,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592519,
		"ID": 979,
		"x": 29.4717731603,
		"y": 100.601210303,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592524,
		"ID": 979,
		"x": 30.4357612613,
		"y": 102.601176996,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592525,
		"ID": 979,
		"x": 30.4957197163,
		"y": 102.352210296,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592527,
		"ID": 979,
		"x": 29.9817239823,
		"y": 101.400199262,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592528,
		"ID": 979,
		"x": 29.6687677653,
		"y": 101.542233721,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592530,
		"ID": 979,
		"x": 30.7887236743,
		"y": 102.237158994,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592532,
		"ID": 979,
		"x": 30.7077610483,
		"y": 101.326231653,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592533,
		"ID": 979,
		"x": 29.6867383143,
		"y": 102.751226997,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592534,
		"ID": 979,
		"x": 30.1767183503,
		"y": 101.516160628,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592535,
		"ID": 979,
		"x": 30.4147491603,
		"y": 101.527250924,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592536,
		"ID": 979,
		"x": 30.5307053103,
		"y": 102.611194987,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592537,
		"ID": 979,
		"x": 29.9107500343,
		"y": 101.974174578,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592538,
		"ID": 979,
		"x": 29.8477544243,
		"y": 102.123235473,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592540,
		"ID": 979,
		"x": 29.7047595543,
		"y": 102.291209935,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592542,
		"ID": 979,
		"x": 30.2857708753,
		"y": 102.642141719,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592544,
		"ID": 979,
		"x": 31.0107062513,
		"y": 101.27117363,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592545,
		"ID": 979,
		"x": 31.1407483743,
		"y": 101.63516172,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592546,
		"ID": 979,
		"x": 30.6397445903,
		"y": 101.688170523,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592548,
		"ID": 979,
		"x": 29.0847737073,
		"y": 101.648162252,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592552,
		"ID": 979,
		"x": 30.7657289543,
		"y": 101.970239077,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592553,
		"ID": 979,
		"x": 30.1547581993,
		"y": 101.966217862,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592554,
		"ID": 979,
		"x": 30.5887353783,
		"y": 101.201186333,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592556,
		"ID": 979,
		"x": 30.2727124393,
		"y": 102.848233778,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592557,
		"ID": 979,
		"x": 30.0557028113,
		"y": 102.722145811,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592558,
		"ID": 979,
		"x": 30.9147552843,
		"y": 100.886250687,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592560,
		"ID": 979,
		"x": 29.9687080293,
		"y": 102.274207158,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592561,
		"ID": 979,
		"x": 30.5937023023,
		"y": 102.08614547,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592563,
		"ID": 979,
		"x": 30.5287259133,
		"y": 101.37419542,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592567,
		"ID": 979,
		"x": 30.1157588383,
		"y": 102.436144513,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592568,
		"ID": 979,
		"x": 29.5807524603,
		"y": 102.425223763,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592569,
		"ID": 979,
		"x": 29.4897047313,
		"y": 102.113239152,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592570,
		"ID": 979,
		"x": 28.7477282073,
		"y": 101.672224304,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592571,
		"ID": 979,
		"x": 31.6797717863,
		"y": 100.410206704,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592572,
		"ID": 979,
		"x": 28.6057617953,
		"y": 101.878162142,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592573,
		"ID": 979,
		"x": 31.0087387783,
		"y": 100.736232974,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592574,
		"ID": 979,
		"x": 30.7947428833,
		"y": 101.030198107,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592576,
		"ID": 979,
		"x": 30.3877228163,
		"y": 102.096222806,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592577,
		"ID": 979,
		"x": 30.0517158743,
		"y": 101.615230062,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592582,
		"ID": 979,
		"x": 30.8587531363,
		"y": 101.76415499,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592583,
		"ID": 979,
		"x": 28.8897200623,
		"y": 101.071170124,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592587,
		"ID": 979,
		"x": 30.0747314423,
		"y": 102.060190812,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592588,
		"ID": 979,
		"x": 29.0247712413,
		"y": 101.500240985,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592589,
		"ID": 979,
		"x": 31.2567744073,
		"y": 101.399190293,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592590,
		"ID": 979,
		"x": 31.2507190753,
		"y": 101.271207324,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592617,
		"ID": 979,
		"x": 30.9757078303,
		"y": 101.072239274,
		"h": 4.8241758242
	},
	{
		"stop_id": 8595416,
		"ID": 979,
		"x": 25.6277526723,
		"y": 100.740185945,
		"h": 4.8241758242
	},
	{
		"stop_id": 8014487,
		"ID": 1013,
		"x": 32.2159595063,
		"y": 103.30397388,
		"h": 2.5824175824
	},
	{
		"stop_id": 8503957,
		"ID": 1013,
		"x": 36.3177299483,
		"y": 102.260153548,
		"h": 2.5824175824
	},
	{
		"stop_id": 8503970,
		"ID": 1013,
		"x": 31.9677260793,
		"y": 105.830233873,
		"h": 2.5824175824
	},
	{
		"stop_id": 8506151,
		"ID": 1013,
		"x": 34.4427478953,
		"y": 100.939168098,
		"h": 2.5824175824
	},
	{
		"stop_id": 8573466,
		"ID": 1013,
		"x": 30.5737266303,
		"y": 102.845170301,
		"h": 2.5824175824
	},
	{
		"stop_id": 8573467,
		"ID": 1013,
		"x": 31.0307146353,
		"y": 103.255219092,
		"h": 2.5824175824
	},
	{
		"stop_id": 8573478,
		"ID": 1013,
		"x": 31.4177141773,
		"y": 103.320139735,
		"h": 2.5824175824
	},
	{
		"stop_id": 8573479,
		"ID": 1013,
		"x": 32.0657347333,
		"y": 103.846221311,
		"h": 2.5824175824
	},
	{
		"stop_id": 8573482,
		"ID": 1013,
		"x": 32.0377122453,
		"y": 105.585216823,
		"h": 2.5824175824
	},
	{
		"stop_id": 8573741,
		"ID": 1013,
		"x": 33.5827389543,
		"y": 100.430154127,
		"h": 2.5824175824
	},
	{
		"stop_id": 8573742,
		"ID": 1013,
		"x": 34.0277670213,
		"y": 101.020178685,
		"h": 2.5824175824
	},
	{
		"stop_id": 8573743,
		"ID": 1013,
		"x": 34.4627613653,
		"y": 101.110194004,
		"h": 2.5824175824
	},
	{
		"stop_id": 8573744,
		"ID": 1013,
		"x": 34.7077326613,
		"y": 101.045168141,
		"h": 2.5824175824
	},
	{
		"stop_id": 8573745,
		"ID": 1013,
		"x": 35.1677378383,
		"y": 101.320244357,
		"h": 2.5824175824
	},
	{
		"stop_id": 8573746,
		"ID": 1013,
		"x": 36.0227460063,
		"y": 102.125232685,
		"h": 2.5824175824
	},
	{
		"stop_id": 8579931,
		"ID": 1013,
		"x": 31.6377558713,
		"y": 105.490246956,
		"h": 2.5824175824
	},
	{
		"stop_id": 8591863,
		"ID": 1013,
		"x": 32.1057116253,
		"y": 105.905228764,
		"h": 2.5824175824
	},
	{
		"stop_id": 8592493,
		"ID": 1013,
		"x": 32.2477116313,
		"y": 103.750197096,
		"h": 2.5824175824
	},
	{
		"stop_id": 8592494,
		"ID": 1013,
		"x": 31.8787289163,
		"y": 103.740216567,
		"h": 2.5824175824
	},
	{
		"stop_id": 8592495,
		"ID": 1013,
		"x": 32.1357456973,
		"y": 104.053162455,
		"h": 2.5824175824
	},
	{
		"stop_id": 8592496,
		"ID": 1013,
		"x": 32.3337136903,
		"y": 103.937150389,
		"h": 2.5824175824
	},
	{
		"stop_id": 8592513,
		"ID": 1013,
		"x": 31.4247679003,
		"y": 101.987189476,
		"h": 2.5824175824
	},
	{
		"stop_id": 8592516,
		"ID": 1013,
		"x": 31.1897467583,
		"y": 101.860225328,
		"h": 2.5824175824
	},
	{
		"stop_id": 8592521,
		"ID": 1013,
		"x": 31.7307675503,
		"y": 101.144193384,
		"h": 2.5824175824
	},
	{
		"stop_id": 8592522,
		"ID": 1013,
		"x": 31.5297019503,
		"y": 101.10615444,
		"h": 2.5824175824
	},
	{
		"stop_id": 8592523,
		"ID": 1013,
		"x": 31.5797684113,
		"y": 102.791183656,
		"h": 2.5824175824
	},
	{
		"stop_id": 8592526,
		"ID": 1013,
		"x": 30.6547703283,
		"y": 103.843178831,
		"h": 2.5824175824
	},
	{
		"stop_id": 8592529,
		"ID": 1013,
		"x": 31.4857685163,
		"y": 101.291191395,
		"h": 2.5824175824
	},
	{
		"stop_id": 8592531,
		"ID": 1013,
		"x": 31.1957322523,
		"y": 102.498209748,
		"h": 2.5824175824
	},
	{
		"stop_id": 8592539,
		"ID": 1013,
		"x": 30.4587260333,
		"y": 103.238197996,
		"h": 2.5824175824
	},
	{
		"stop_id": 8592541,
		"ID": 1013,
		"x": 31.6157320063,
		"y": 103.593225184,
		"h": 2.5824175824
	},
	{
		"stop_id": 8592543,
		"ID": 1013,
		"x": 31.1817550583,
		"y": 103.505212352,
		"h": 2.5824175824
	},
	{
		"stop_id": 8592547,
		"ID": 1013,
		"x": 31.0047561113,
		"y": 102.865143215,
		"h": 2.5824175824
	},
	{
		"stop_id": 8592549,
		"ID": 1013,
		"x": 31.7667619973,
		"y": 104.218232349,
		"h": 2.5824175824
	},
	{
		"stop_id": 8592551,
		"ID": 1013,
		"x": 31.4407722943,
		"y": 103.779234544,
		"h": 2.5824175824
	},
	{
		"stop_id": 8592555,
		"ID": 1013,
		"x": 32.0507038003,
		"y": 100.477140312,
		"h": 2.5824175824
	},
	{
		"stop_id": 8592559,
		"ID": 1013,
		"x": 31.6677510893,
		"y": 102.930225664,
		"h": 2.5824175824
	},
	{
		"stop_id": 8592562,
		"ID": 1013,
		"x": 31.9067510623,
		"y": 104.379217668,
		"h": 2.5824175824
	},
	{
		"stop_id": 8592564,
		"ID": 1013,
		"x": 31.6797750053,
		"y": 103.219222175,
		"h": 2.5824175824
	},
	{
		"stop_id": 8592565,
		"ID": 1013,
		"x": 31.0317215183,
		"y": 101.958208318,
		"h": 2.5824175824
	},
	{
		"stop_id": 8592575,
		"ID": 1013,
		"x": 30.9207198413,
		"y": 103.609170314,
		"h": 2.5824175824
	},
	{
		"stop_id": 8592578,
		"ID": 1013,
		"x": 31.2087420493,
		"y": 103.026207422,
		"h": 2.5824175824
	},
	{
		"stop_id": 8592579,
		"ID": 1013,
		"x": 30.6047663333,
		"y": 103.434163143,
		"h": 2.5824175824
	},
	{
		"stop_id": 8592580,
		"ID": 1013,
		"x": 31.1847030403,
		"y": 103.319205211,
		"h": 2.5824175824
	},
	{
		"stop_id": 8592581,
		"ID": 1013,
		"x": 30.7687208673,
		"y": 103.001187938,
		"h": 2.5824175824
	},
	{
		"stop_id": 8592584,
		"ID": 1013,
		"x": 31.6157537693,
		"y": 104.022159791,
		"h": 2.5824175824
	},
	{
		"stop_id": 8592585,
		"ID": 1013,
		"x": 31.9327009713,
		"y": 100.364205642,
		"h": 2.5824175824
	},
	{
		"stop_id": 8592586,
		"ID": 1013,
		"x": 31.2597252523,
		"y": 102.233187495,
		"h": 2.5824175824
	},
	{
		"stop_id": 8595427,
		"ID": 1013,
		"x": 32.0327112723,
		"y": 104.395192746,
		"h": 2.5824175824
	},
	{
		"stop_id": 8014583,
		"ID": 1255,
		"x": 66.9320836883,
		"y": 100.872689999,
		"h": 1.1978021978
	},
	{
		"stop_id": 8014584,
		"ID": 1255,
		"x": 70.5355319973,
		"y": 99.254740974,
		"h": 1.1978021978
	},
	{
		"stop_id": 8039347,
		"ID": 1255,
		"x": 68.5528446303,
		"y": 100.14113493,
		"h": 1.1978021978
	},
	{
		"stop_id": 8080251,
		"ID": 1255,
		"x": 69.7298023433,
		"y": 99.613679483,
		"h": 1.1978021978
	},
	{
		"stop_id": 8099982,
		"ID": 1255,
		"x": 68.4917321553,
		"y": 101.264246999,
		"h": 1.1978021978
	},
	{
		"stop_id": 8506132,
		"ID": 1255,
		"x": 67.5287560053,
		"y": 97.579211378,
		"h": 1.1978021978
	},
	{
		"stop_id": 8506163,
		"ID": 1255,
		"x": 67.6457248503,
		"y": 98.143174712,
		"h": 1.1978021978
	},
	{
		"stop_id": 8014586,
		"ID": 1285,
		"x": 70.8619465103,
		"y": 97.556063457,
		"h": 2.2857142857
	},
	{
		"stop_id": 8014587,
		"ID": 1285,
		"x": 71.0263894683,
		"y": 97.683166018,
		"h": 2.2857142857
	},
	{
		"stop_id": 8506119,
		"ID": 1285,
		"x": 72.3307339923,
		"y": 95.84619811,
		"h": 2.2857142857
	},
	{
		"stop_id": 8506126,
		"ID": 1285,
		"x": 74.6577503883,
		"y": 94.824187529,
		"h": 2.2857142857
	},
	{
		"stop_id": 8506127,
		"ID": 1285,
		"x": 73.5937195123,
		"y": 95.610154234,
		"h": 2.2857142857
	},
	{
		"stop_id": 8506128,
		"ID": 1285,
		"x": 71.2347162833,
		"y": 96.498178837,
		"h": 2.2857142857
	},
	{
		"stop_id": 8506165,
		"ID": 1285,
		"x": 71.2777255883,
		"y": 96.879175059,
		"h": 2.2857142857
	},
	{
		"stop_id": 8506772,
		"ID": 1285,
		"x": 74.6467040633,
		"y": 94.771216883,
		"h": 2.2857142857
	},
	{
		"stop_id": 8530720,
		"ID": 1285,
		"x": 73.4947107763,
		"y": 96.056246876,
		"h": 2.2857142857
	},
	{
		"stop_id": 8573406,
		"ID": 1285,
		"x": 71.3907366373,
		"y": 95.809191607,
		"h": 2.2857142857
	},
	{
		"stop_id": 8573407,
		"ID": 1285,
		"x": 71.8257633323,
		"y": 95.682197693,
		"h": 2.2857142857
	},
	{
		"stop_id": 8573408,
		"ID": 1285,
		"x": 72.1807571463,
		"y": 95.508176869,
		"h": 2.2857142857
	},
	{
		"stop_id": 8573409,
		"ID": 1285,
		"x": 72.7217548533,
		"y": 95.474154775,
		"h": 2.2857142857
	},
	{
		"stop_id": 8573410,
		"ID": 1285,
		"x": 73.2027437293,
		"y": 95.488210275,
		"h": 2.2857142857
	},
	{
		"stop_id": 8573411,
		"ID": 1285,
		"x": 73.3497667663,
		"y": 95.252181504,
		"h": 2.2857142857
	},
	{
		"stop_id": 8573412,
		"ID": 1285,
		"x": 74.1967413933,
		"y": 94.934146089,
		"h": 2.2857142857
	},
	{
		"stop_id": 8581694,
		"ID": 1285,
		"x": 71.3077171083,
		"y": 99.064221018,
		"h": 2.2857142857
	},
	{
		"stop_id": 8581695,
		"ID": 1285,
		"x": 70.8397248853,
		"y": 97.694151753,
		"h": 2.2857142857
	},
	{
		"stop_id": 8581696,
		"ID": 1285,
		"x": 70.5767727753,
		"y": 97.125220575,
		"h": 2.2857142857
	},
	{
		"stop_id": 8581697,
		"ID": 1285,
		"x": 70.5917743223,
		"y": 96.919238835,
		"h": 2.2857142857
	},
	{
		"stop_id": 8581705,
		"ID": 1285,
		"x": 72.9577146633,
		"y": 95.250237215,
		"h": 2.2857142857
	},
	{
		"stop_id": 8581707,
		"ID": 1285,
		"x": 71.0237261793,
		"y": 98.551185771,
		"h": 2.2857142857
	},
	{
		"stop_id": 8581708,
		"ID": 1285,
		"x": 70.8657671983,
		"y": 97.93618912,
		"h": 2.2857142857
	},
	{
		"stop_id": 8581717,
		"ID": 1285,
		"x": 72.3077267463,
		"y": 95.588207235,
		"h": 2.2857142857
	},
	{
		"stop_id": 8581718,
		"ID": 1285,
		"x": 74.3787115043,
		"y": 94.67124244,
		"h": 2.2857142857
	},
	{
		"stop_id": 8581757,
		"ID": 1285,
		"x": 75.1797385383,
		"y": 94.639139942,
		"h": 2.2857142857
	},
	{
		"stop_id": 8581846,
		"ID": 1285,
		"x": 70.7927278403,
		"y": 97.492245947,
		"h": 2.2857142857
	},
	{
		"stop_id": 8594891,
		"ID": 1285,
		"x": 71.7567466823,
		"y": 95.430189593,
		"h": 2.2857142857
	},
	{
		"stop_id": 8594892,
		"ID": 1285,
		"x": 71.6277617253,
		"y": 95.450224486,
		"h": 2.2857142857
	},
	{
		"stop_id": 8594893,
		"ID": 1285,
		"x": 71.4707106183,
		"y": 95.495217877,
		"h": 2.2857142857
	},
	{
		"stop_id": 8594894,
		"ID": 1285,
		"x": 71.9037648113,
		"y": 95.232163213,
		"h": 2.2857142857
	},
	{
		"stop_id": 8594900,
		"ID": 1285,
		"x": 71.6557322643,
		"y": 95.298142906,
		"h": 2.2857142857
	},
	{
		"stop_id": 8594905,
		"ID": 1285,
		"x": 71.1037628293,
		"y": 96.469244059,
		"h": 2.2857142857
	},
	{
		"stop_id": 8594906,
		"ID": 1285,
		"x": 71.2487534643,
		"y": 96.448219283,
		"h": 2.2857142857
	},
	{
		"stop_id": 8594907,
		"ID": 1285,
		"x": 71.4647519463,
		"y": 96.215235639,
		"h": 2.2857142857
	},
	{
		"stop_id": 8594908,
		"ID": 1285,
		"x": 71.6467434103,
		"y": 95.981167786,
		"h": 2.2857142857
	},
	{
		"stop_id": 8594910,
		"ID": 1285,
		"x": 72.5137228193,
		"y": 96.082196832,
		"h": 2.2857142857
	},
	{
		"stop_id": 8594911,
		"ID": 1285,
		"x": 70.9847038983,
		"y": 97.032156828,
		"h": 2.2857142857
	},
	{
		"stop_id": 8594913,
		"ID": 1285,
		"x": 71.9007180943,
		"y": 95.826233437,
		"h": 2.2857142857
	},
	{
		"stop_id": 8595084,
		"ID": 1285,
		"x": 72.4077150063,
		"y": 96.013197559,
		"h": 2.2857142857
	},
	{
		"stop_id": 8301113,
		"ID": 1048,
		"x": 40.7563797273,
		"y": -87.9707247345,
		"h": 1.3626373626
	},
	{
		"stop_id": 8505795,
		"ID": 1048,
		"x": 45.1087459253,
		"y": -87.4638001752,
		"h": 1.3626373626
	},
	{
		"stop_id": 8505874,
		"ID": 1048,
		"x": 42.2577099683,
		"y": -84.8698417487,
		"h": 1.3626373626
	},
	{
		"stop_id": 8505949,
		"ID": 1048,
		"x": 41.2777447443,
		"y": -87.0898536372,
		"h": 1.3626373626
	},
	{
		"stop_id": 8575665,
		"ID": 1048,
		"x": 45.4527621193,
		"y": -88.1517535888,
		"h": 1.3626373626
	},
	{
		"stop_id": 8575666,
		"ID": 1048,
		"x": 45.0917412663,
		"y": -88.0187894758,
		"h": 1.3626373626
	},
	{
		"stop_id": 8575667,
		"ID": 1048,
		"x": 44.9447541903,
		"y": -88.2718202304,
		"h": 1.3626373626
	},
	{
		"stop_id": 8575673,
		"ID": 1048,
		"x": 46.4657510093,
		"y": -87.1608290674,
		"h": 1.3626373626
	},
	{
		"stop_id": 8575674,
		"ID": 1048,
		"x": 45.9877551843,
		"y": -87.0138407027,
		"h": 1.3626373626
	},
	{
		"stop_id": 8575675,
		"ID": 1048,
		"x": 46.0286992023,
		"y": -87.8037579127,
		"h": 1.3626373626
	},
	{
		"stop_id": 8575676,
		"ID": 1048,
		"x": 46.2457389703,
		"y": -87.8918147026,
		"h": 1.3626373626
	},
	{
		"stop_id": 8575677,
		"ID": 1048,
		"x": 46.4167763193,
		"y": -87.8658142856,
		"h": 1.3626373626
	},
	{
		"stop_id": 8500016,
		"ID": 495,
		"x": -49.6672720417,
		"y": 86.282140743,
		"h": 1.3956043956
	},
	{
		"stop_id": 8500138,
		"ID": 495,
		"x": -49.6362863287,
		"y": 86.911192616,
		"h": 1.3956043956
	},
	{
		"stop_id": 8500682,
		"ID": 495,
		"x": -52.6922449257,
		"y": 89.530204674,
		"h": 1.3956043956
	},
	{
		"stop_id": 8530637,
		"ID": 495,
		"x": -48.4222424487,
		"y": 88.228203538,
		"h": 1.3956043956
	},
	{
		"stop_id": 8530642,
		"ID": 495,
		"x": -48.3592696777,
		"y": 88.889239156,
		"h": 1.3956043956
	},
	{
		"stop_id": 8578145,
		"ID": 495,
		"x": -49.8692364607,
		"y": 86.100229508,
		"h": 1.3956043956
	},
	{
		"stop_id": 8578146,
		"ID": 495,
		"x": -50.2452842167,
		"y": 86.679247433,
		"h": 1.3956043956
	},
	{
		"stop_id": 8578148,
		"ID": 495,
		"x": -52.3922953017,
		"y": 89.204223155,
		"h": 1.3956043956
	},
	{
		"stop_id": 8588771,
		"ID": 495,
		"x": -49.4032732077,
		"y": 86.568240043,
		"h": 1.3956043956
	},
	{
		"stop_id": 8589302,
		"ID": 495,
		"x": -50.4972256137,
		"y": 86.068197928,
		"h": 1.3956043956
	},
	{
		"stop_id": 8592322,
		"ID": 495,
		"x": -49.6362903797,
		"y": 86.29420181,
		"h": 1.3956043956
	},
	{
		"stop_id": 8594925,
		"ID": 495,
		"x": -51.8092542027,
		"y": 88.690160219,
		"h": 1.3956043956
	},
	{
		"stop_id": 8718213,
		"ID": 495,
		"x": -50.9599827237,
		"y": 88.49054379,
		"h": 1.3956043956
	},
	{
		"stop_id": 8500020,
		"ID": 560,
		"x": -43.9852325317,
		"y": 82.212209056,
		"h": 2.8131868132
	},
	{
		"stop_id": 8500021,
		"ID": 560,
		"x": -40.7492547637,
		"y": 81.007184779,
		"h": 2.8131868132
	},
	{
		"stop_id": 8500300,
		"ID": 560,
		"x": -38.2462982347,
		"y": 82.776181783,
		"h": 2.8131868132
	},
	{
		"stop_id": 8500853,
		"ID": 560,
		"x": -44.1682904147,
		"y": 83.44625051,
		"h": 2.8131868132
	},
	{
		"stop_id": 8500854,
		"ID": 560,
		"x": -39.0892293377,
		"y": 82.350221306,
		"h": 2.8131868132
	},
	{
		"stop_id": 8517131,
		"ID": 560,
		"x": -39.3162576947,
		"y": 81.892227353,
		"h": 2.8131868132
	},
	{
		"stop_id": 8517411,
		"ID": 560,
		"x": -43.3602914057,
		"y": 81.249234778,
		"h": 2.8131868132
	},
	{
		"stop_id": 8517414,
		"ID": 560,
		"x": -40.6732639807,
		"y": 80.844204872,
		"h": 2.8131868132
	},
	{
		"stop_id": 8517415,
		"ID": 560,
		"x": -40.8962780307,
		"y": 80.867174663,
		"h": 2.8131868132
	},
	{
		"stop_id": 8517416,
		"ID": 560,
		"x": -41.6172839897,
		"y": 80.864148091,
		"h": 2.8131868132
	},
	{
		"stop_id": 8517417,
		"ID": 560,
		"x": -42.2492534147,
		"y": 80.806211215,
		"h": 2.8131868132
	},
	{
		"stop_id": 8530639,
		"ID": 560,
		"x": -42.4142524877,
		"y": 82.576174927,
		"h": 2.8131868132
	},
	{
		"stop_id": 8530640,
		"ID": 560,
		"x": -39.1382356647,
		"y": 82.671163302,
		"h": 2.8131868132
	},
	{
		"stop_id": 8530784,
		"ID": 560,
		"x": -44.1072612317,
		"y": 83.970221206,
		"h": 2.8131868132
	},
	{
		"stop_id": 8531252,
		"ID": 560,
		"x": -41.9622760147,
		"y": 82.132203994,
		"h": 2.8131868132
	},
	{
		"stop_id": 8578192,
		"ID": 560,
		"x": -44.0522605097,
		"y": 81.846222389,
		"h": 2.8131868132
	},
	{
		"stop_id": 8578193,
		"ID": 560,
		"x": -43.9942242277,
		"y": 82.167153955,
		"h": 2.8131868132
	},
	{
		"stop_id": 8578311,
		"ID": 560,
		"x": -43.0622619057,
		"y": 82.608228788,
		"h": 2.8131868132
	},
	{
		"stop_id": 8578313,
		"ID": 560,
		"x": -41.7892606767,
		"y": 81.967166145,
		"h": 2.8131868132
	},
	{
		"stop_id": 8578314,
		"ID": 560,
		"x": -40.0752591807,
		"y": 82.098248851,
		"h": 2.8131868132
	},
	{
		"stop_id": 8578349,
		"ID": 560,
		"x": -38.2702942917,
		"y": 82.749187071,
		"h": 2.8131868132
	},
	{
		"stop_id": 8578350,
		"ID": 560,
		"x": -39.2692981507,
		"y": 82.206163139,
		"h": 2.8131868132
	},
	{
		"stop_id": 8578351,
		"ID": 560,
		"x": -40.6652544697,
		"y": 80.953194812,
		"h": 2.8131868132
	},
	{
		"stop_id": 8578352,
		"ID": 560,
		"x": -40.4922295917,
		"y": 80.830224424,
		"h": 2.8131868132
	},
	{
		"stop_id": 8578353,
		"ID": 560,
		"x": -40.3882247327,
		"y": 80.533246757,
		"h": 2.8131868132
	},
	{
		"stop_id": 8578354,
		"ID": 560,
		"x": -39.7422778197,
		"y": 80.805244229,
		"h": 2.8131868132
	},
	{
		"stop_id": 8578355,
		"ID": 560,
		"x": -39.8342313927,
		"y": 81.071229869,
		"h": 2.8131868132
	},
	{
		"stop_id": 8578356,
		"ID": 560,
		"x": -39.3772777137,
		"y": 81.088237716,
		"h": 2.8131868132
	},
	{
		"stop_id": 8588068,
		"ID": 560,
		"x": -42.7092500417,
		"y": 82.048176249,
		"h": 2.8131868132
	},
	{
		"stop_id": 8588069,
		"ID": 560,
		"x": -42.4362875707,
		"y": 82.180168867,
		"h": 2.8131868132
	},
	{
		"stop_id": 8588070,
		"ID": 560,
		"x": -42.2862472257,
		"y": 81.987141208,
		"h": 2.8131868132
	},
	{
		"stop_id": 8588159,
		"ID": 560,
		"x": -43.6542625177,
		"y": 81.925231466,
		"h": 2.8131868132
	},
	{
		"stop_id": 8588163,
		"ID": 560,
		"x": -40.4022705867,
		"y": 81.375227344,
		"h": 2.8131868132
	},
	{
		"stop_id": 8588621,
		"ID": 560,
		"x": -39.9992837997,
		"y": 80.630151066,
		"h": 2.8131868132
	},
	{
		"stop_id": 8588855,
		"ID": 560,
		"x": -41.0082366147,
		"y": 81.522161902,
		"h": 2.8131868132
	},
	{
		"stop_id": 8592327,
		"ID": 560,
		"x": -43.6942243027,
		"y": 84.503141476,
		"h": 2.8131868132
	},
	{
		"stop_id": 8592331,
		"ID": 560,
		"x": -43.3662733797,
		"y": 84.423203959,
		"h": 2.8131868132
	},
	{
		"stop_id": 8592332,
		"ID": 560,
		"x": -42.9812733157,
		"y": 84.349227542,
		"h": 2.8131868132
	},
	{
		"stop_id": 8592353,
		"ID": 560,
		"x": -40.1522645197,
		"y": 83.820195256,
		"h": 2.8131868132
	},
	{
		"stop_id": 8592354,
		"ID": 560,
		"x": -40.6172864797,
		"y": 83.942206733,
		"h": 2.8131868132
	},
	{
		"stop_id": 8592355,
		"ID": 560,
		"x": -41.0342273707,
		"y": 84.196165482,
		"h": 2.8131868132
	},
	{
		"stop_id": 8592356,
		"ID": 560,
		"x": -41.6072774907,
		"y": 84.288227341,
		"h": 2.8131868132
	},
	{
		"stop_id": 8592357,
		"ID": 560,
		"x": -39.6812505087,
		"y": 83.735155435,
		"h": 2.8131868132
	},
	{
		"stop_id": 8594927,
		"ID": 560,
		"x": -42.2932949937,
		"y": 84.176201627,
		"h": 2.8131868132
	},
	{
		"stop_id": 8594928,
		"ID": 560,
		"x": -42.5132901757,
		"y": 84.190234931,
		"h": 2.8131868132
	},
	{
		"stop_id": 8594994,
		"ID": 560,
		"x": -40.7432617557,
		"y": 81.064243413,
		"h": 2.8131868132
	},
	{
		"stop_id": 8595149,
		"ID": 560,
		"x": -41.4492267377,
		"y": 80.661190528,
		"h": 2.8131868132
	},
	{
		"stop_id": 8595150,
		"ID": 560,
		"x": -40.6672373747,
		"y": 80.633189685,
		"h": 2.8131868132
	},
	{
		"stop_id": 8595153,
		"ID": 560,
		"x": -40.8222575237,
		"y": 81.580236921,
		"h": 2.8131868132
	},
	{
		"stop_id": 8595155,
		"ID": 560,
		"x": -39.9052504507,
		"y": 80.44022264,
		"h": 2.8131868132
	},
	{
		"stop_id": 8595156,
		"ID": 560,
		"x": -41.0702581737,
		"y": 80.555186964,
		"h": 2.8131868132
	},
	{
		"stop_id": 8595701,
		"ID": 560,
		"x": -40.6052383097,
		"y": 81.423157706,
		"h": 2.8131868132
	},
	{
		"stop_id": 8595702,
		"ID": 560,
		"x": -41.6142809557,
		"y": 80.670245706,
		"h": 2.8131868132
	},
	{
		"stop_id": 8595703,
		"ID": 560,
		"x": -41.4402557097,
		"y": 80.5122266,
		"h": 2.8131868132
	},
	{
		"stop_id": 8595704,
		"ID": 560,
		"x": -41.1282931907,
		"y": 80.447152332,
		"h": 2.8131868132
	},
	{
		"stop_id": 8595705,
		"ID": 560,
		"x": -40.4682583087,
		"y": 80.430248459,
		"h": 2.8131868132
	},
	{
		"stop_id": 8500022,
		"ID": 593,
		"x": -38.6102647637,
		"y": 78.657247096,
		"h": 2.1538461538
	},
	{
		"stop_id": 8500858,
		"ID": 593,
		"x": -38.2022838717,
		"y": 77.791233437,
		"h": 2.1538461538
	},
	{
		"stop_id": 8500984,
		"ID": 593,
		"x": -35.1422724317,
		"y": 79.955180937,
		"h": 2.1538461538
	},
	{
		"stop_id": 8572235,
		"ID": 593,
		"x": -34.8922887827,
		"y": 77.30517988,
		"h": 2.1538461538
	},
	{
		"stop_id": 8572237,
		"ID": 593,
		"x": -35.0212598757,
		"y": 78.25017673,
		"h": 2.1538461538
	},
	{
		"stop_id": 8572238,
		"ID": 593,
		"x": -35.1602659887,
		"y": 78.718142378,
		"h": 2.1538461538
	},
	{
		"stop_id": 8572239,
		"ID": 593,
		"x": -35.1172391197,
		"y": 79.6051542,
		"h": 2.1538461538
	},
	{
		"stop_id": 8572240,
		"ID": 593,
		"x": -36.4742672737,
		"y": 81.186210812,
		"h": 2.1538461538
	},
	{
		"stop_id": 8572247,
		"ID": 593,
		"x": -33.7752303957,
		"y": 80.824170896,
		"h": 2.1538461538
	},
	{
		"stop_id": 8572248,
		"ID": 593,
		"x": -34.4882696077,
		"y": 81.088161594,
		"h": 2.1538461538
	},
	{
		"stop_id": 8578315,
		"ID": 593,
		"x": -38.6782297517,
		"y": 80.735213267,
		"h": 2.1538461538
	},
	{
		"stop_id": 8578316,
		"ID": 593,
		"x": -38.5212437577,
		"y": 79.84615942,
		"h": 2.1538461538
	},
	{
		"stop_id": 8578317,
		"ID": 593,
		"x": -38.4072805107,
		"y": 78.803184879,
		"h": 2.1538461538
	},
	{
		"stop_id": 8578346,
		"ID": 593,
		"x": -36.8042593927,
		"y": 81.119211434,
		"h": 2.1538461538
	},
	{
		"stop_id": 8578347,
		"ID": 593,
		"x": -38.0212490567,
		"y": 81.976222436,
		"h": 2.1538461538
	},
	{
		"stop_id": 8578348,
		"ID": 593,
		"x": -37.7252377047,
		"y": 82.444196119,
		"h": 2.1538461538
	},
	{
		"stop_id": 8578358,
		"ID": 593,
		"x": -37.0052564267,
		"y": 82.76224775,
		"h": 2.1538461538
	},
	{
		"stop_id": 8579714,
		"ID": 593,
		"x": -35.1672878207,
		"y": 79.230243504,
		"h": 2.1538461538
	},
	{
		"stop_id": 8582802,
		"ID": 593,
		"x": -37.2622309517,
		"y": 82.543225532,
		"h": 2.1538461538
	},
	{
		"stop_id": 8588878,
		"ID": 593,
		"x": -38.9162320017,
		"y": 78.825168904,
		"h": 2.1538461538
	},
	{
		"stop_id": 8589401,
		"ID": 593,
		"x": -38.6042323837,
		"y": 78.698185527,
		"h": 2.1538461538
	},
	{
		"stop_id": 8589402,
		"ID": 593,
		"x": -38.6202697887,
		"y": 78.420160239,
		"h": 2.1538461538
	},
	{
		"stop_id": 8589403,
		"ID": 593,
		"x": -38.8392472947,
		"y": 79.25718055,
		"h": 2.1538461538
	},
	{
		"stop_id": 8589404,
		"ID": 593,
		"x": -37.8142677647,
		"y": 79.216186866,
		"h": 2.1538461538
	},
	{
		"stop_id": 8589405,
		"ID": 593,
		"x": -37.7442487697,
		"y": 79.472177789,
		"h": 2.1538461538
	},
	{
		"stop_id": 8589406,
		"ID": 593,
		"x": -38.0502670097,
		"y": 79.144158341,
		"h": 2.1538461538
	},
	{
		"stop_id": 8589407,
		"ID": 593,
		"x": -38.0872531407,
		"y": 78.730183531,
		"h": 2.1538461538
	},
	{
		"stop_id": 8589408,
		"ID": 593,
		"x": -37.4782304017,
		"y": 79.129156922,
		"h": 2.1538461538
	},
	{
		"stop_id": 8589409,
		"ID": 593,
		"x": -37.7812719217,
		"y": 79.1152396,
		"h": 2.1538461538
	},
	{
		"stop_id": 8589420,
		"ID": 593,
		"x": -37.9932745917,
		"y": 78.005142194,
		"h": 2.1538461538
	},
	{
		"stop_id": 8589425,
		"ID": 593,
		"x": -37.7732954997,
		"y": 77.532185462,
		"h": 2.1538461538
	},
	{
		"stop_id": 8594158,
		"ID": 593,
		"x": -38.8322927687,
		"y": 79.592213109,
		"h": 2.1538461538
	},
	{
		"stop_id": 8594336,
		"ID": 593,
		"x": -37.9962602287,
		"y": 77.422177793,
		"h": 2.1538461538
	},
	{
		"stop_id": 8595152,
		"ID": 593,
		"x": -39.2852271827,
		"y": 80.669153625,
		"h": 2.1538461538
	},
	{
		"stop_id": 8595444,
		"ID": 593,
		"x": -38.4542505337,
		"y": 79.252213168,
		"h": 2.1538461538
	},
	{
		"stop_id": 8595445,
		"ID": 593,
		"x": -38.3232448267,
		"y": 78.316154172,
		"h": 2.1538461538
	},
	{
		"stop_id": 8500023,
		"ID": 592,
		"x": -37.6792737997,
		"y": 76.770237738,
		"h": 2.5824175824
	},
	{
		"stop_id": 8500024,
		"ID": 592,
		"x": -35.5272672637,
		"y": 75.193228613,
		"h": 2.5824175824
	},
	{
		"stop_id": 8500025,
		"ID": 592,
		"x": -33.4612899777,
		"y": 74.876140891,
		"h": 2.5824175824
	},
	{
		"stop_id": 8500080,
		"ID": 592,
		"x": -36.2772832487,
		"y": 73.105142968,
		"h": 2.5824175824
	},
	{
		"stop_id": 8500081,
		"ID": 592,
		"x": -36.6692406757,
		"y": 75.880142419,
		"h": 2.5824175824
	},
	{
		"stop_id": 8500082,
		"ID": 592,
		"x": -36.9012923627,
		"y": 74.008203383,
		"h": 2.5824175824
	},
	{
		"stop_id": 8500083,
		"ID": 592,
		"x": -35.4102245807,
		"y": 72.115194526,
		"h": 2.5824175824
	},
	{
		"stop_id": 8500799,
		"ID": 592,
		"x": -38.6552645667,
		"y": 74.105222354,
		"h": 2.5824175824
	},
	{
		"stop_id": 8500850,
		"ID": 592,
		"x": -37.3212716787,
		"y": 72.92320805,
		"h": 2.5824175824
	},
	{
		"stop_id": 8500855,
		"ID": 592,
		"x": -36.8622595117,
		"y": 74.015247363,
		"h": 2.5824175824
	},
	{
		"stop_id": 8500859,
		"ID": 592,
		"x": -36.7602383477,
		"y": 76.09715859,
		"h": 2.5824175824
	},
	{
		"stop_id": 8572212,
		"ID": 592,
		"x": -37.6562298907,
		"y": 76.755202149,
		"h": 2.5824175824
	},
	{
		"stop_id": 8572214,
		"ID": 592,
		"x": -37.2692752017,
		"y": 76.43621638,
		"h": 2.5824175824
	},
	{
		"stop_id": 8572215,
		"ID": 592,
		"x": -37.5212686467,
		"y": 75.817180789,
		"h": 2.5824175824
	},
	{
		"stop_id": 8572216,
		"ID": 592,
		"x": -37.6922743007,
		"y": 75.280179723,
		"h": 2.5824175824
	},
	{
		"stop_id": 8572217,
		"ID": 592,
		"x": -38.1932578027,
		"y": 74.72618807,
		"h": 2.5824175824
	},
	{
		"stop_id": 8572218,
		"ID": 592,
		"x": -38.8672250917,
		"y": 73.955150288,
		"h": 2.5824175824
	},
	{
		"stop_id": 8572221,
		"ID": 592,
		"x": -37.7042351317,
		"y": 76.429246646,
		"h": 2.5824175824
	},
	{
		"stop_id": 8572222,
		"ID": 592,
		"x": -38.3542971917,
		"y": 75.832240997,
		"h": 2.5824175824
	},
	{
		"stop_id": 8572229,
		"ID": 592,
		"x": -37.2172791647,
		"y": 76.9552109,
		"h": 2.5824175824
	},
	{
		"stop_id": 8572230,
		"ID": 592,
		"x": -36.8422486867,
		"y": 76.955202412,
		"h": 2.5824175824
	},
	{
		"stop_id": 8572231,
		"ID": 592,
		"x": -36.6422939897,
		"y": 76.780191927,
		"h": 2.5824175824
	},
	{
		"stop_id": 8572232,
		"ID": 592,
		"x": -36.3722651937,
		"y": 76.671175482,
		"h": 2.5824175824
	},
	{
		"stop_id": 8572233,
		"ID": 592,
		"x": -36.1672358607,
		"y": 76.780172144,
		"h": 2.5824175824
	},
	{
		"stop_id": 8572234,
		"ID": 592,
		"x": -35.6632909557,
		"y": 76.9051707,
		"h": 2.5824175824
	},
	{
		"stop_id": 8578256,
		"ID": 592,
		"x": -35.3792931187,
		"y": 72.077184929,
		"h": 2.5824175824
	},
	{
		"stop_id": 8578257,
		"ID": 592,
		"x": -35.3242375557,
		"y": 72.995247392,
		"h": 2.5824175824
	},
	{
		"stop_id": 8578258,
		"ID": 592,
		"x": -36.2982688087,
		"y": 73.129187253,
		"h": 2.5824175824
	},
	{
		"stop_id": 8578318,
		"ID": 592,
		"x": -37.7432493487,
		"y": 77.071204906,
		"h": 2.5824175824
	},
	{
		"stop_id": 8578320,
		"ID": 592,
		"x": -37.3862943367,
		"y": 76.586209478,
		"h": 2.5824175824
	},
	{
		"stop_id": 8578321,
		"ID": 592,
		"x": -36.5992274067,
		"y": 76.000163175,
		"h": 2.5824175824
	},
	{
		"stop_id": 8578323,
		"ID": 592,
		"x": -37.1362622317,
		"y": 73.436142028,
		"h": 2.5824175824
	},
	{
		"stop_id": 8578324,
		"ID": 592,
		"x": -37.4062836267,
		"y": 72.406208977,
		"h": 2.5824175824
	},
	{
		"stop_id": 8589400,
		"ID": 592,
		"x": -37.6472553787,
		"y": 72.058186449,
		"h": 2.5824175824
	},
	{
		"stop_id": 8589411,
		"ID": 592,
		"x": -35.5452670777,
		"y": 75.207164596,
		"h": 2.5824175824
	},
	{
		"stop_id": 8589412,
		"ID": 592,
		"x": -35.9102723947,
		"y": 75.386141503,
		"h": 2.5824175824
	},
	{
		"stop_id": 8589413,
		"ID": 592,
		"x": -35.6182572687,
		"y": 74.580221572,
		"h": 2.5824175824
	},
	{
		"stop_id": 8589414,
		"ID": 592,
		"x": -35.6712246237,
		"y": 74.905225846,
		"h": 2.5824175824
	},
	{
		"stop_id": 8589415,
		"ID": 592,
		"x": -35.5572986617,
		"y": 75.532224499,
		"h": 2.5824175824
	},
	{
		"stop_id": 8589416,
		"ID": 592,
		"x": -35.6442548737,
		"y": 75.782151139,
		"h": 2.5824175824
	},
	{
		"stop_id": 8589417,
		"ID": 592,
		"x": -36.1022769007,
		"y": 75.743170652,
		"h": 2.5824175824
	},
	{
		"stop_id": 8589418,
		"ID": 592,
		"x": -34.9722585307,
		"y": 75.666173909,
		"h": 2.5824175824
	},
	{
		"stop_id": 8589419,
		"ID": 592,
		"x": -37.4802316837,
		"y": 77.1142154,
		"h": 2.5824175824
	},
	{
		"stop_id": 8589421,
		"ID": 592,
		"x": -36.6692386107,
		"y": 76.596184105,
		"h": 2.5824175824
	},
	{
		"stop_id": 8589422,
		"ID": 592,
		"x": -36.3482408627,
		"y": 76.504156584,
		"h": 2.5824175824
	},
	{
		"stop_id": 8593500,
		"ID": 592,
		"x": -34.6582300367,
		"y": 75.048185978,
		"h": 2.5824175824
	},
	{
		"stop_id": 8593507,
		"ID": 592,
		"x": -34.9672385727,
		"y": 73.075225154,
		"h": 2.5824175824
	},
	{
		"stop_id": 8594067,
		"ID": 592,
		"x": -35.1042676377,
		"y": 75.197195256,
		"h": 2.5824175824
	},
	{
		"stop_id": 8595733,
		"ID": 592,
		"x": -38.4462334007,
		"y": 74.396164059,
		"h": 2.5824175824
	},
	{
		"stop_id": 8500026,
		"ID": 625,
		"x": -31.5882462397,
		"y": 74.382179694,
		"h": 1.8241758242
	},
	{
		"stop_id": 8500681,
		"ID": 625,
		"x": -28.5572458087,
		"y": 77.773222023,
		"h": 1.8241758242
	},
	{
		"stop_id": 8500960,
		"ID": 625,
		"x": -33.8922486117,
		"y": 77.555181947,
		"h": 1.8241758242
	},
	{
		"stop_id": 8500980,
		"ID": 625,
		"x": -28.6842336237,
		"y": 76.625209824,
		"h": 1.8241758242
	},
	{
		"stop_id": 8572236,
		"ID": 625,
		"x": -33.8172527017,
		"y": 77.380167365,
		"h": 1.8241758242
	},
	{
		"stop_id": 8572279,
		"ID": 625,
		"x": -28.7402376647,
		"y": 76.971154166,
		"h": 1.8241758242
	},
	{
		"stop_id": 8578259,
		"ID": 625,
		"x": -31.5252293727,
		"y": 74.370248881,
		"h": 1.8241758242
	},
	{
		"stop_id": 8578260,
		"ID": 625,
		"x": -31.6782439627,
		"y": 74.662165018,
		"h": 1.8241758242
	},
	{
		"stop_id": 8578261,
		"ID": 625,
		"x": -31.5082627547,
		"y": 74.987192335,
		"h": 1.8241758242
	},
	{
		"stop_id": 8578262,
		"ID": 625,
		"x": -31.5232861527,
		"y": 75.292216924,
		"h": 1.8241758242
	},
	{
		"stop_id": 8578263,
		"ID": 625,
		"x": -31.1842331317,
		"y": 75.709235113,
		"h": 1.8241758242
	},
	{
		"stop_id": 8578264,
		"ID": 625,
		"x": -31.4272623487,
		"y": 75.912207859,
		"h": 1.8241758242
	},
	{
		"stop_id": 8578265,
		"ID": 625,
		"x": -31.6022699497,
		"y": 76.271175097,
		"h": 1.8241758242
	},
	{
		"stop_id": 8578266,
		"ID": 625,
		"x": -31.4472868557,
		"y": 76.806167327,
		"h": 1.8241758242
	},
	{
		"stop_id": 8578267,
		"ID": 625,
		"x": -31.6792641837,
		"y": 77.567141777,
		"h": 1.8241758242
	},
	{
		"stop_id": 8578268,
		"ID": 625,
		"x": -32.1612943297,
		"y": 77.653160612,
		"h": 1.8241758242
	},
	{
		"stop_id": 8578269,
		"ID": 625,
		"x": -32.1262267457,
		"y": 77.502220302,
		"h": 1.8241758242
	},
	{
		"stop_id": 8578270,
		"ID": 625,
		"x": -31.4702795387,
		"y": 77.486190396,
		"h": 1.8241758242
	},
	{
		"stop_id": 8578271,
		"ID": 625,
		"x": -31.0312701657,
		"y": 77.216226391,
		"h": 1.8241758242
	},
	{
		"stop_id": 8578272,
		"ID": 625,
		"x": -30.4652248907,
		"y": 77.739243515,
		"h": 1.8241758242
	},
	{
		"stop_id": 8578273,
		"ID": 625,
		"x": -30.7702297547,
		"y": 78.130236105,
		"h": 1.8241758242
	},
	{
		"stop_id": 8578274,
		"ID": 625,
		"x": -30.6182706787,
		"y": 78.565169808,
		"h": 1.8241758242
	},
	{
		"stop_id": 8593509,
		"ID": 625,
		"x": -31.2632605467,
		"y": 74.569191422,
		"h": 1.8241758242
	},
	{
		"stop_id": 8593510,
		"ID": 625,
		"x": -32.3122535837,
		"y": 74.888240839,
		"h": 1.8241758242
	},
	{
		"stop_id": 8593511,
		"ID": 625,
		"x": -32.3032870847,
		"y": 75.166248688,
		"h": 1.8241758242
	},
	{
		"stop_id": 8593512,
		"ID": 625,
		"x": -31.8092764747,
		"y": 75.028239123,
		"h": 1.8241758242
	},
	{
		"stop_id": 8500027,
		"ID": 658,
		"x": -28.9032757677,
		"y": 74.744225558,
		"h": 1.989010989
	},
	{
		"stop_id": 8500028,
		"ID": 658,
		"x": -25.8782394307,
		"y": 72.523223533,
		"h": 1.989010989
	},
	{
		"stop_id": 8500963,
		"ID": 658,
		"x": -27.1582456177,
		"y": 75.244234131,
		"h": 1.989010989
	},
	{
		"stop_id": 8500964,
		"ID": 658,
		"x": -23.8382573507,
		"y": 74.263187587,
		"h": 1.989010989
	},
	{
		"stop_id": 8500996,
		"ID": 658,
		"x": -28.4532271837,
		"y": 74.729240007,
		"h": 1.989010989
	},
	{
		"stop_id": 8500997,
		"ID": 658,
		"x": -25.5222386337,
		"y": 77.236156846,
		"h": 1.989010989
	},
	{
		"stop_id": 8500998,
		"ID": 658,
		"x": -26.3472722797,
		"y": 73.145206942,
		"h": 1.989010989
	},
	{
		"stop_id": 8572280,
		"ID": 658,
		"x": -28.6692854237,
		"y": 75.097243232,
		"h": 1.989010989
	},
	{
		"stop_id": 8572281,
		"ID": 658,
		"x": -28.6422891857,
		"y": 74.780168818,
		"h": 1.989010989
	},
	{
		"stop_id": 8572282,
		"ID": 658,
		"x": -28.8322699757,
		"y": 74.762163071,
		"h": 1.989010989
	},
	{
		"stop_id": 8572283,
		"ID": 658,
		"x": -28.2422339287,
		"y": 74.794179269,
		"h": 1.989010989
	},
	{
		"stop_id": 8572284,
		"ID": 658,
		"x": -27.7332485007,
		"y": 75.09021848,
		"h": 1.989010989
	},
	{
		"stop_id": 8572285,
		"ID": 658,
		"x": -26.8812335347,
		"y": 75.117232061,
		"h": 1.989010989
	},
	{
		"stop_id": 8572286,
		"ID": 658,
		"x": -26.6822496747,
		"y": 75.16715038,
		"h": 1.989010989
	},
	{
		"stop_id": 8572287,
		"ID": 658,
		"x": -26.1322863997,
		"y": 75.981245583,
		"h": 1.989010989
	},
	{
		"stop_id": 8572290,
		"ID": 658,
		"x": -26.1212595847,
		"y": 76.681233895,
		"h": 1.989010989
	},
	{
		"stop_id": 8572291,
		"ID": 658,
		"x": -25.9472869307,
		"y": 76.943181813,
		"h": 1.989010989
	},
	{
		"stop_id": 8572293,
		"ID": 658,
		"x": -26.5922301907,
		"y": 75.005209115,
		"h": 1.989010989
	},
	{
		"stop_id": 8572294,
		"ID": 658,
		"x": -25.1072985797,
		"y": 75.15224482,
		"h": 1.989010989
	},
	{
		"stop_id": 8572295,
		"ID": 658,
		"x": -24.6172600437,
		"y": 76.73021414,
		"h": 1.989010989
	},
	{
		"stop_id": 8572299,
		"ID": 658,
		"x": -28.1382360717,
		"y": 74.464174788,
		"h": 1.989010989
	},
	{
		"stop_id": 8572300,
		"ID": 658,
		"x": -27.5172402907,
		"y": 74.035225844,
		"h": 1.989010989
	},
	{
		"stop_id": 8572301,
		"ID": 658,
		"x": -26.0102427867,
		"y": 72.763189133,
		"h": 1.989010989
	},
	{
		"stop_id": 8572302,
		"ID": 658,
		"x": -25.8832540967,
		"y": 72.569226023,
		"h": 1.989010989
	},
	{
		"stop_id": 8572303,
		"ID": 658,
		"x": -24.4472751307,
		"y": 72.095167234,
		"h": 1.989010989
	},
	{
		"stop_id": 8572307,
		"ID": 658,
		"x": -27.9422869937,
		"y": 74.130217714,
		"h": 1.989010989
	},
	{
		"stop_id": 8578275,
		"ID": 658,
		"x": -29.6532564567,
		"y": 74.404141211,
		"h": 1.989010989
	},
	{
		"stop_id": 8582142,
		"ID": 658,
		"x": -26.4302719107,
		"y": 75.338233674,
		"h": 1.989010989
	},
	{
		"stop_id": 8583418,
		"ID": 658,
		"x": -25.9502426177,
		"y": 72.809228597,
		"h": 1.989010989
	},
	{
		"stop_id": 8595472,
		"ID": 658,
		"x": -29.4072858987,
		"y": 74.490230681,
		"h": 1.989010989
	},
	{
		"stop_id": 8595473,
		"ID": 658,
		"x": -28.8762822747,
		"y": 74.628175977,
		"h": 1.989010989
	},
	{
		"stop_id": 8500031,
		"ID": 624,
		"x": -29.6442383367,
		"y": 72.925186494,
		"h": 1.6923076923
	},
	{
		"stop_id": 8500032,
		"ID": 624,
		"x": -28.6002508487,
		"y": 71.758234871,
		"h": 1.6923076923
	},
	{
		"stop_id": 8578276,
		"ID": 624,
		"x": -30.9182548247,
		"y": 74.294227498,
		"h": 1.6923076923
	},
	{
		"stop_id": 8578278,
		"ID": 624,
		"x": -31.9652777267,
		"y": 73.792225392,
		"h": 1.6923076923
	},
	{
		"stop_id": 8578279,
		"ID": 624,
		"x": -31.9522682997,
		"y": 73.462174826,
		"h": 1.6923076923
	},
	{
		"stop_id": 8578280,
		"ID": 624,
		"x": -31.9022590587,
		"y": 72.978194561,
		"h": 1.6923076923
	},
	{
		"stop_id": 8578281,
		"ID": 624,
		"x": -31.8512982187,
		"y": 72.56615703,
		"h": 1.6923076923
	},
	{
		"stop_id": 8578282,
		"ID": 624,
		"x": -31.7062894127,
		"y": 71.488229449,
		"h": 1.6923076923
	},
	{
		"stop_id": 8578283,
		"ID": 624,
		"x": -31.5902733137,
		"y": 69.948197105,
		"h": 1.6923076923
	},
	{
		"stop_id": 8578284,
		"ID": 624,
		"x": -31.6732314087,
		"y": 69.444247711,
		"h": 1.6923076923
	},
	{
		"stop_id": 8578285,
		"ID": 624,
		"x": -31.6262424777,
		"y": 68.908226458,
		"h": 1.6923076923
	},
	{
		"stop_id": 8578290,
		"ID": 624,
		"x": -30.5892353997,
		"y": 73.995188868,
		"h": 1.6923076923
	},
	{
		"stop_id": 8578292,
		"ID": 624,
		"x": -30.3132429297,
		"y": 73.675224465,
		"h": 1.6923076923
	},
	{
		"stop_id": 8578294,
		"ID": 624,
		"x": -29.6412925167,
		"y": 72.538162915,
		"h": 1.6923076923
	},
	{
		"stop_id": 8578295,
		"ID": 624,
		"x": -28.8792541367,
		"y": 70.95523838,
		"h": 1.6923076923
	},
	{
		"stop_id": 8578298,
		"ID": 624,
		"x": -29.6502493287,
		"y": 68.773159123,
		"h": 1.6923076923
	},
	{
		"stop_id": 8578299,
		"ID": 624,
		"x": -29.3622499907,
		"y": 70.041246524,
		"h": 1.6923076923
	},
	{
		"stop_id": 8587049,
		"ID": 624,
		"x": -28.6952941197,
		"y": 71.469209309,
		"h": 1.6923076923
	},
	{
		"stop_id": 8588075,
		"ID": 624,
		"x": -29.5532790977,
		"y": 68.983235215,
		"h": 1.6923076923
	},
	{
		"stop_id": 8588419,
		"ID": 624,
		"x": -29.1992642787,
		"y": 70.261229857,
		"h": 1.6923076923
	},
	{
		"stop_id": 8595639,
		"ID": 624,
		"x": -31.2462955017,
		"y": 74.271182157,
		"h": 1.6923076923
	},
	{
		"stop_id": 8595718,
		"ID": 624,
		"x": -30.0942730387,
		"y": 73.197214431,
		"h": 1.6923076923
	},
	{
		"stop_id": 8500037,
		"ID": 656,
		"x": -24.5682548727,
		"y": 63.668181787,
		"h": 3.1098901099
	},
	{
		"stop_id": 8500216,
		"ID": 656,
		"x": -27.2672880167,
		"y": 60.912249825,
		"h": 3.1098901099
	},
	{
		"stop_id": 8500217,
		"ID": 656,
		"x": -25.0532378497,
		"y": 61.720174455,
		"h": 3.1098901099
	},
	{
		"stop_id": 8500218,
		"ID": 656,
		"x": -24.3012298337,
		"y": 62.100193217,
		"h": 3.1098901099
	},
	{
		"stop_id": 8500371,
		"ID": 656,
		"x": -27.2512629557,
		"y": 60.939243672,
		"h": 3.1098901099
	},
	{
		"stop_id": 8500387,
		"ID": 656,
		"x": -28.0792277307,
		"y": 60.766218642,
		"h": 3.1098901099
	},
	{
		"stop_id": 8500598,
		"ID": 656,
		"x": -24.4102943807,
		"y": 61.839151984,
		"h": 3.1098901099
	},
	{
		"stop_id": 8572352,
		"ID": 656,
		"x": -24.3592590057,
		"y": 62.100180581,
		"h": 3.1098901099
	},
	{
		"stop_id": 8577982,
		"ID": 656,
		"x": -24.2852471727,
		"y": 62.789180739,
		"h": 3.1098901099
	},
	{
		"stop_id": 8577983,
		"ID": 656,
		"x": -24.0042819047,
		"y": 63.066156316,
		"h": 3.1098901099
	},
	{
		"stop_id": 8577984,
		"ID": 656,
		"x": -23.7602533297,
		"y": 63.313235472,
		"h": 3.1098901099
	},
	{
		"stop_id": 8578029,
		"ID": 656,
		"x": -27.5832465257,
		"y": 60.993250164,
		"h": 3.1098901099
	},
	{
		"stop_id": 8578030,
		"ID": 656,
		"x": -27.1052430117,
		"y": 61.088250872,
		"h": 3.1098901099
	},
	{
		"stop_id": 8578031,
		"ID": 656,
		"x": -26.7492779197,
		"y": 61.247208053,
		"h": 3.1098901099
	},
	{
		"stop_id": 8578032,
		"ID": 656,
		"x": -26.3522240137,
		"y": 61.339152119,
		"h": 3.1098901099
	},
	{
		"stop_id": 8578033,
		"ID": 656,
		"x": -26.0602349637,
		"y": 61.50023758,
		"h": 3.1098901099
	},
	{
		"stop_id": 8578034,
		"ID": 656,
		"x": -25.7002500127,
		"y": 61.700196398,
		"h": 3.1098901099
	},
	{
		"stop_id": 8578035,
		"ID": 656,
		"x": -25.4342315227,
		"y": 62.008148233,
		"h": 3.1098901099
	},
	{
		"stop_id": 8578037,
		"ID": 656,
		"x": -24.9972987977,
		"y": 61.897171515,
		"h": 3.1098901099
	},
	{
		"stop_id": 8578038,
		"ID": 656,
		"x": -24.7972856027,
		"y": 61.948155597,
		"h": 3.1098901099
	},
	{
		"stop_id": 8578039,
		"ID": 656,
		"x": -24.6852922017,
		"y": 62.061222125,
		"h": 3.1098901099
	},
	{
		"stop_id": 8578042,
		"ID": 656,
		"x": -27.0002591047,
		"y": 64.975239124,
		"h": 3.1098901099
	},
	{
		"stop_id": 8578043,
		"ID": 656,
		"x": -28.2152595657,
		"y": 64.507247729,
		"h": 3.1098901099
	},
	{
		"stop_id": 8578044,
		"ID": 656,
		"x": -27.9812284497,
		"y": 64.456239254,
		"h": 3.1098901099
	},
	{
		"stop_id": 8578045,
		"ID": 656,
		"x": -26.8532533777,
		"y": 64.191206153,
		"h": 3.1098901099
	},
	{
		"stop_id": 8578046,
		"ID": 656,
		"x": -26.1692393537,
		"y": 63.831243483,
		"h": 3.1098901099
	},
	{
		"stop_id": 8578047,
		"ID": 656,
		"x": -25.6992830427,
		"y": 63.547178196,
		"h": 3.1098901099
	},
	{
		"stop_id": 8578048,
		"ID": 656,
		"x": -25.3152902267,
		"y": 63.374167958,
		"h": 3.1098901099
	},
	{
		"stop_id": 8578049,
		"ID": 656,
		"x": -24.9372814897,
		"y": 63.156229337,
		"h": 3.1098901099
	},
	{
		"stop_id": 8578050,
		"ID": 656,
		"x": -24.6172618587,
		"y": 63.397159342,
		"h": 3.1098901099
	},
	{
		"stop_id": 8578051,
		"ID": 656,
		"x": -23.9082489887,
		"y": 63.952202505,
		"h": 3.1098901099
	},
	{
		"stop_id": 8578052,
		"ID": 656,
		"x": -24.2922564597,
		"y": 63.153153691,
		"h": 3.1098901099
	},
	{
		"stop_id": 8578053,
		"ID": 656,
		"x": -24.4142495467,
		"y": 62.732152665,
		"h": 3.1098901099
	},
	{
		"stop_id": 8578054,
		"ID": 656,
		"x": -24.7732980297,
		"y": 62.532231238,
		"h": 3.1098901099
	},
	{
		"stop_id": 8578055,
		"ID": 656,
		"x": -24.6932281787,
		"y": 62.215164022,
		"h": 3.1098901099
	},
	{
		"stop_id": 8578056,
		"ID": 656,
		"x": -24.5112322807,
		"y": 62.155201815,
		"h": 3.1098901099
	},
	{
		"stop_id": 8582524,
		"ID": 656,
		"x": -24.2692940647,
		"y": 61.080167818,
		"h": 3.1098901099
	},
	{
		"stop_id": 8582525,
		"ID": 656,
		"x": -24.3912503947,
		"y": 61.496154275,
		"h": 3.1098901099
	},
	{
		"stop_id": 8587634,
		"ID": 656,
		"x": -27.4112585127,
		"y": 60.385237489,
		"h": 3.1098901099
	},
	{
		"stop_id": 8587635,
		"ID": 656,
		"x": -27.2422366677,
		"y": 60.64321393,
		"h": 3.1098901099
	},
	{
		"stop_id": 8587644,
		"ID": 656,
		"x": -27.5052269257,
		"y": 60.946198236,
		"h": 3.1098901099
	},
	{
		"stop_id": 8588649,
		"ID": 656,
		"x": -25.1772980387,
		"y": 61.899233858,
		"h": 3.1098901099
	},
	{
		"stop_id": 8590290,
		"ID": 656,
		"x": -24.8222941397,
		"y": 62.898180833,
		"h": 3.1098901099
	},
	{
		"stop_id": 8590416,
		"ID": 656,
		"x": -24.1572335537,
		"y": 61.599173778,
		"h": 3.1098901099
	},
	{
		"stop_id": 8590417,
		"ID": 656,
		"x": -24.0332595337,
		"y": 61.767248878,
		"h": 3.1098901099
	},
	{
		"stop_id": 8590422,
		"ID": 656,
		"x": -24.6882380787,
		"y": 61.549206455,
		"h": 3.1098901099
	},
	{
		"stop_id": 8590425,
		"ID": 656,
		"x": -25.1892546117,
		"y": 61.162243425,
		"h": 3.1098901099
	},
	{
		"stop_id": 8590426,
		"ID": 656,
		"x": -24.0422624737,
		"y": 61.216171285,
		"h": 3.1098901099
	},
	{
		"stop_id": 8590429,
		"ID": 656,
		"x": -24.6812477497,
		"y": 61.824203509,
		"h": 3.1098901099
	},
	{
		"stop_id": 8590430,
		"ID": 656,
		"x": -24.1162316837,
		"y": 61.264202734,
		"h": 3.1098901099
	},
	{
		"stop_id": 8590431,
		"ID": 656,
		"x": -23.9242609087,
		"y": 61.473159028,
		"h": 3.1098901099
	},
	{
		"stop_id": 8590432,
		"ID": 656,
		"x": -24.7392534477,
		"y": 61.717236603,
		"h": 3.1098901099
	},
	{
		"stop_id": 8590433,
		"ID": 656,
		"x": -24.7362964087,
		"y": 61.254176755,
		"h": 3.1098901099
	},
	{
		"stop_id": 8594152,
		"ID": 656,
		"x": -24.3642288007,
		"y": 63.61825008,
		"h": 3.1098901099
	},
	{
		"stop_id": 8594292,
		"ID": 656,
		"x": -25.3892835677,
		"y": 60.75615494,
		"h": 3.1098901099
	},
	{
		"stop_id": 8594311,
		"ID": 656,
		"x": -24.6022598147,
		"y": 62.879244091,
		"h": 3.1098901099
	},
	{
		"stop_id": 8595470,
		"ID": 656,
		"x": -24.2552711477,
		"y": 61.705211527,
		"h": 3.1098901099
	},
	{
		"stop_id": 8595471,
		"ID": 656,
		"x": -24.6822986017,
		"y": 61.938160025,
		"h": 3.1098901099
	},
	{
		"stop_id": 8595683,
		"ID": 656,
		"x": -25.0292421207,
		"y": 62.178166834,
		"h": 3.1098901099
	},
	{
		"stop_id": 8595684,
		"ID": 656,
		"x": -25.0422472127,
		"y": 62.45115682,
		"h": 3.1098901099
	},
	{
		"stop_id": 8595685,
		"ID": 656,
		"x": -25.1852363817,
		"y": 62.4061829,
		"h": 3.1098901099
	},
	{
		"stop_id": 8595686,
		"ID": 656,
		"x": -25.0082989247,
		"y": 61.517194635,
		"h": 3.1098901099
	},
	{
		"stop_id": 8595687,
		"ID": 656,
		"x": -25.1032987077,
		"y": 61.571230437,
		"h": 3.1098901099
	},
	{
		"stop_id": 8595688,
		"ID": 656,
		"x": -25.1112915157,
		"y": 62.138217566,
		"h": 3.1098901099
	},
	{
		"stop_id": 8595911,
		"ID": 656,
		"x": -24.8352948487,
		"y": 63.156161192,
		"h": 3.1098901099
	},
	{
		"stop_id": 8500051,
		"ID": 493,
		"x": -48.3972918697,
		"y": 77.674147388,
		"h": 2.4175824176
	},
	{
		"stop_id": 8500063,
		"ID": 493,
		"x": -50.6522425847,
		"y": 80.105155028,
		"h": 2.4175824176
	},
	{
		"stop_id": 8500064,
		"ID": 493,
		"x": -50.8102673137,
		"y": 78.390191323,
		"h": 2.4175824176
	},
	{
		"stop_id": 8500065,
		"ID": 493,
		"x": -51.6492603037,
		"y": 76.659156232,
		"h": 2.4175824176
	},
	{
		"stop_id": 8500066,
		"ID": 493,
		"x": -53.4432777807,
		"y": 77.060154211,
		"h": 2.4175824176
	},
	{
		"stop_id": 8500067,
		"ID": 493,
		"x": -54.3662259427,
		"y": 77.253162366,
		"h": 2.4175824176
	},
	{
		"stop_id": 8500072,
		"ID": 493,
		"x": -50.9542348007,
		"y": 79.191188891,
		"h": 2.4175824176
	},
	{
		"stop_id": 8500711,
		"ID": 493,
		"x": -52.9882457497,
		"y": 79.214222097,
		"h": 2.4175824176
	},
	{
		"stop_id": 8578201,
		"ID": 493,
		"x": -51.0212467727,
		"y": 79.936154573,
		"h": 2.4175824176
	},
	{
		"stop_id": 8578202,
		"ID": 493,
		"x": -51.6312284057,
		"y": 79.636199625,
		"h": 2.4175824176
	},
	{
		"stop_id": 8578203,
		"ID": 493,
		"x": -52.0032316617,
		"y": 79.528187227,
		"h": 2.4175824176
	},
	{
		"stop_id": 8578204,
		"ID": 493,
		"x": -52.5892474787,
		"y": 79.333212103,
		"h": 2.4175824176
	},
	{
		"stop_id": 8578205,
		"ID": 493,
		"x": -53.2322766767,
		"y": 79.15524446,
		"h": 2.4175824176
	},
	{
		"stop_id": 8578206,
		"ID": 493,
		"x": -53.6532309827,
		"y": 79.117219561,
		"h": 2.4175824176
	},
	{
		"stop_id": 8578207,
		"ID": 493,
		"x": -53.6992649297,
		"y": 78.89524408,
		"h": 2.4175824176
	},
	{
		"stop_id": 8578208,
		"ID": 493,
		"x": -53.3762442917,
		"y": 78.797179149,
		"h": 2.4175824176
	},
	{
		"stop_id": 8578209,
		"ID": 493,
		"x": -53.1052698367,
		"y": 78.829162263,
		"h": 2.4175824176
	},
	{
		"stop_id": 8578210,
		"ID": 493,
		"x": -51.5072314787,
		"y": 78.328145785,
		"h": 2.4175824176
	},
	{
		"stop_id": 8578211,
		"ID": 493,
		"x": -51.1772458007,
		"y": 78.359187246,
		"h": 2.4175824176
	},
	{
		"stop_id": 8578213,
		"ID": 493,
		"x": -50.5122362747,
		"y": 78.178168217,
		"h": 2.4175824176
	},
	{
		"stop_id": 8578214,
		"ID": 493,
		"x": -50.1112494237,
		"y": 78.012245951,
		"h": 2.4175824176
	},
	{
		"stop_id": 8578215,
		"ID": 493,
		"x": -49.4072337687,
		"y": 77.802172586,
		"h": 2.4175824176
	},
	{
		"stop_id": 8578216,
		"ID": 493,
		"x": -48.8592453957,
		"y": 77.80314986,
		"h": 2.4175824176
	},
	{
		"stop_id": 8579553,
		"ID": 493,
		"x": -51.7432563957,
		"y": 75.935209301,
		"h": 2.4175824176
	},
	{
		"stop_id": 8581449,
		"ID": 493,
		"x": -51.8582541937,
		"y": 76.08215498,
		"h": 2.4175824176
	},
	{
		"stop_id": 8581450,
		"ID": 493,
		"x": -53.7092859107,
		"y": 75.683176509,
		"h": 2.4175824176
	},
	{
		"stop_id": 8582799,
		"ID": 493,
		"x": -50.4182617617,
		"y": 75.81216207,
		"h": 2.4175824176
	},
	{
		"stop_id": 8582804,
		"ID": 493,
		"x": -51.6092873927,
		"y": 76.308196577,
		"h": 2.4175824176
	},
	{
		"stop_id": 8583299,
		"ID": 493,
		"x": -53.3042990917,
		"y": 75.586200187,
		"h": 2.4175824176
	},
	{
		"stop_id": 8583310,
		"ID": 493,
		"x": -52.3972953907,
		"y": 75.72522799,
		"h": 2.4175824176
	},
	{
		"stop_id": 8588418,
		"ID": 493,
		"x": -52.8202521747,
		"y": 78.768221989,
		"h": 2.4175824176
	},
	{
		"stop_id": 8588713,
		"ID": 493,
		"x": -50.9702775397,
		"y": 79.495150333,
		"h": 2.4175824176
	},
	{
		"stop_id": 8588794,
		"ID": 493,
		"x": -48.3152495567,
		"y": 77.215215948,
		"h": 2.4175824176
	},
	{
		"stop_id": 8588795,
		"ID": 493,
		"x": -50.9962867117,
		"y": 77.917150154,
		"h": 2.4175824176
	},
	{
		"stop_id": 8588796,
		"ID": 493,
		"x": -52.9562788697,
		"y": 77.00520557,
		"h": 2.4175824176
	},
	{
		"stop_id": 8589980,
		"ID": 493,
		"x": -50.0452489087,
		"y": 80.006155717,
		"h": 2.4175824176
	},
	{
		"stop_id": 8589981,
		"ID": 493,
		"x": -50.1952912487,
		"y": 79.99924188,
		"h": 2.4175824176
	},
	{
		"stop_id": 8589983,
		"ID": 493,
		"x": -50.5222909387,
		"y": 79.9022159,
		"h": 2.4175824176
	},
	{
		"stop_id": 8589984,
		"ID": 493,
		"x": -50.5622652557,
		"y": 79.690231498,
		"h": 2.4175824176
	},
	{
		"stop_id": 8589985,
		"ID": 493,
		"x": -50.6862709547,
		"y": 79.597200397,
		"h": 2.4175824176
	},
	{
		"stop_id": 8592455,
		"ID": 493,
		"x": -53.3722643707,
		"y": 77.042217316,
		"h": 2.4175824176
	},
	{
		"stop_id": 8593513,
		"ID": 493,
		"x": -51.0612448487,
		"y": 78.74617355,
		"h": 2.4175824176
	},
	{
		"stop_id": 8595721,
		"ID": 493,
		"x": -54.3172624607,
		"y": 77.361168287,
		"h": 2.4175824176
	},
	{
		"stop_id": 8595722,
		"ID": 493,
		"x": -54.1242287457,
		"y": 77.246157423,
		"h": 2.4175824176
	},
	{
		"stop_id": 8500060,
		"ID": 494,
		"x": -49.4622784487,
		"y": 82.616153115,
		"h": 4.2967032967
	},
	{
		"stop_id": 8500061,
		"ID": 494,
		"x": -49.5902544497,
		"y": 82.07222378,
		"h": 4.2967032967
	},
	{
		"stop_id": 8500062,
		"ID": 494,
		"x": -49.7272822307,
		"y": 81.165144015,
		"h": 4.2967032967
	},
	{
		"stop_id": 8500071,
		"ID": 494,
		"x": -49.2462352397,
		"y": 83.328246663,
		"h": 4.2967032967
	},
	{
		"stop_id": 8500146,
		"ID": 494,
		"x": -48.5372761597,
		"y": 83.531237039,
		"h": 4.2967032967
	},
	{
		"stop_id": 8500160,
		"ID": 494,
		"x": -48.7702842507,
		"y": 83.65722348,
		"h": 4.2967032967
	},
	{
		"stop_id": 8500193,
		"ID": 494,
		"x": -48.6482586437,
		"y": 83.90217611,
		"h": 4.2967032967
	},
	{
		"stop_id": 8578149,
		"ID": 494,
		"x": -50.5202728207,
		"y": 81.808194725,
		"h": 4.2967032967
	},
	{
		"stop_id": 8578150,
		"ID": 494,
		"x": -50.3522979397,
		"y": 82.066190873,
		"h": 4.2967032967
	},
	{
		"stop_id": 8578151,
		"ID": 494,
		"x": -50.0722605907,
		"y": 82.350168767,
		"h": 4.2967032967
	},
	{
		"stop_id": 8578152,
		"ID": 494,
		"x": -49.7222555637,
		"y": 82.696209519,
		"h": 4.2967032967
	},
	{
		"stop_id": 8578153,
		"ID": 494,
		"x": -50.2632477037,
		"y": 82.842202243,
		"h": 4.2967032967
	},
	{
		"stop_id": 8578154,
		"ID": 494,
		"x": -50.9052425737,
		"y": 82.728247001,
		"h": 4.2967032967
	},
	{
		"stop_id": 8578155,
		"ID": 494,
		"x": -50.6512261937,
		"y": 83.236203815,
		"h": 4.2967032967
	},
	{
		"stop_id": 8578156,
		"ID": 494,
		"x": -50.8852762917,
		"y": 83.326246964,
		"h": 4.2967032967
	},
	{
		"stop_id": 8578157,
		"ID": 494,
		"x": -50.8422936077,
		"y": 83.531231255,
		"h": 4.2967032967
	},
	{
		"stop_id": 8578158,
		"ID": 494,
		"x": -51.0652280837,
		"y": 83.649206536,
		"h": 4.2967032967
	},
	{
		"stop_id": 8578159,
		"ID": 494,
		"x": -51.5892695017,
		"y": 83.819140133,
		"h": 4.2967032967
	},
	{
		"stop_id": 8578160,
		"ID": 494,
		"x": -52.1292808167,
		"y": 84.257175567,
		"h": 4.2967032967
	},
	{
		"stop_id": 8578162,
		"ID": 494,
		"x": -52.7092844667,
		"y": 84.146163935,
		"h": 4.2967032967
	},
	{
		"stop_id": 8578163,
		"ID": 494,
		"x": -53.4362417407,
		"y": 83.88517024,
		"h": 4.2967032967
	},
	{
		"stop_id": 8578164,
		"ID": 494,
		"x": -54.2052330487,
		"y": 83.177250404,
		"h": 4.2967032967
	},
	{
		"stop_id": 8578165,
		"ID": 494,
		"x": -54.5272715667,
		"y": 82.957142079,
		"h": 4.2967032967
	},
	{
		"stop_id": 8578168,
		"ID": 494,
		"x": -50.2332466227,
		"y": 85.833226507,
		"h": 4.2967032967
	},
	{
		"stop_id": 8578169,
		"ID": 494,
		"x": -50.3522857257,
		"y": 85.587197994,
		"h": 4.2967032967
	},
	{
		"stop_id": 8578170,
		"ID": 494,
		"x": -50.8082850697,
		"y": 85.549247174,
		"h": 4.2967032967
	},
	{
		"stop_id": 8578171,
		"ID": 494,
		"x": -51.3052938007,
		"y": 85.078192078,
		"h": 4.2967032967
	},
	{
		"stop_id": 8578172,
		"ID": 494,
		"x": -51.5932825127,
		"y": 84.826170419,
		"h": 4.2967032967
	},
	{
		"stop_id": 8578173,
		"ID": 494,
		"x": -51.7842283147,
		"y": 84.65323595,
		"h": 4.2967032967
	},
	{
		"stop_id": 8578174,
		"ID": 494,
		"x": -51.7902354267,
		"y": 84.304206534,
		"h": 4.2967032967
	},
	{
		"stop_id": 8578176,
		"ID": 494,
		"x": -49.5962881487,
		"y": 81.548185209,
		"h": 4.2967032967
	},
	{
		"stop_id": 8578197,
		"ID": 494,
		"x": -50.1722614777,
		"y": 81.089248725,
		"h": 4.2967032967
	},
	{
		"stop_id": 8578198,
		"ID": 494,
		"x": -50.3212365557,
		"y": 80.901215255,
		"h": 4.2967032967
	},
	{
		"stop_id": 8578199,
		"ID": 494,
		"x": -50.6882295217,
		"y": 80.340150038,
		"h": 4.2967032967
	},
	{
		"stop_id": 8581062,
		"ID": 494,
		"x": -49.4122637587,
		"y": 84.641204496,
		"h": 4.2967032967
	},
	{
		"stop_id": 8587001,
		"ID": 494,
		"x": -52.3702453587,
		"y": 84.146239953,
		"h": 4.2967032967
	},
	{
		"stop_id": 8587559,
		"ID": 494,
		"x": -50.8002455207,
		"y": 81.249160487,
		"h": 4.2967032967
	},
	{
		"stop_id": 8588711,
		"ID": 494,
		"x": -50.9402422117,
		"y": 80.428166049,
		"h": 4.2967032967
	},
	{
		"stop_id": 8588714,
		"ID": 494,
		"x": -51.0982844277,
		"y": 80.698231014,
		"h": 4.2967032967
	},
	{
		"stop_id": 8588761,
		"ID": 494,
		"x": -51.8312483247,
		"y": 83.899203095,
		"h": 4.2967032967
	},
	{
		"stop_id": 8588763,
		"ID": 494,
		"x": -52.9212567887,
		"y": 84.078203917,
		"h": 4.2967032967
	},
	{
		"stop_id": 8588783,
		"ID": 494,
		"x": -48.8602868187,
		"y": 83.885216875,
		"h": 4.2967032967
	},
	{
		"stop_id": 8588784,
		"ID": 494,
		"x": -49.3922265397,
		"y": 82.946170001,
		"h": 4.2967032967
	},
	{
		"stop_id": 8588790,
		"ID": 494,
		"x": -50.3222284497,
		"y": 80.576212797,
		"h": 4.2967032967
	},
	{
		"stop_id": 8589283,
		"ID": 494,
		"x": -50.9832844547,
		"y": 84.084184875,
		"h": 4.2967032967
	},
	{
		"stop_id": 8589284,
		"ID": 494,
		"x": -52.2852687237,
		"y": 84.454227021,
		"h": 4.2967032967
	},
	{
		"stop_id": 8589285,
		"ID": 494,
		"x": -51.9932384367,
		"y": 84.471166771,
		"h": 4.2967032967
	},
	{
		"stop_id": 8589286,
		"ID": 494,
		"x": -51.0592669337,
		"y": 84.46522828,
		"h": 4.2967032967
	},
	{
		"stop_id": 8589287,
		"ID": 494,
		"x": -50.5762833227,
		"y": 84.87623948,
		"h": 4.2967032967
	},
	{
		"stop_id": 8589288,
		"ID": 494,
		"x": -50.8122321557,
		"y": 84.669180532,
		"h": 4.2967032967
	},
	{
		"stop_id": 8589289,
		"ID": 494,
		"x": -50.8522336397,
		"y": 84.339223595,
		"h": 4.2967032967
	},
	{
		"stop_id": 8589290,
		"ID": 494,
		"x": -51.4922410267,
		"y": 84.204208566,
		"h": 4.2967032967
	},
	{
		"stop_id": 8589293,
		"ID": 494,
		"x": -49.8102253017,
		"y": 84.830214397,
		"h": 4.2967032967
	},
	{
		"stop_id": 8589294,
		"ID": 494,
		"x": -50.7222842157,
		"y": 85.710156488,
		"h": 4.2967032967
	},
	{
		"stop_id": 8589295,
		"ID": 494,
		"x": -49.8622258707,
		"y": 83.919158426,
		"h": 4.2967032967
	},
	{
		"stop_id": 8589296,
		"ID": 494,
		"x": -49.4612316497,
		"y": 84.84014768,
		"h": 4.2967032967
	},
	{
		"stop_id": 8589297,
		"ID": 494,
		"x": -49.9612942327,
		"y": 85.293177217,
		"h": 4.2967032967
	},
	{
		"stop_id": 8589301,
		"ID": 494,
		"x": -49.4542288427,
		"y": 84.186147284,
		"h": 4.2967032967
	},
	{
		"stop_id": 8589303,
		"ID": 494,
		"x": -49.5592522757,
		"y": 85.337216143,
		"h": 4.2967032967
	},
	{
		"stop_id": 8589304,
		"ID": 494,
		"x": -50.2782345717,
		"y": 85.257194957,
		"h": 4.2967032967
	},
	{
		"stop_id": 8589308,
		"ID": 494,
		"x": -50.1502839947,
		"y": 85.486227127,
		"h": 4.2967032967
	},
	{
		"stop_id": 8589311,
		"ID": 494,
		"x": -50.0342647987,
		"y": 85.688223784,
		"h": 4.2967032967
	},
	{
		"stop_id": 8589313,
		"ID": 494,
		"x": -48.6822824427,
		"y": 83.456246679,
		"h": 4.2967032967
	},
	{
		"stop_id": 8589315,
		"ID": 494,
		"x": -50.1712783047,
		"y": 83.988145821,
		"h": 4.2967032967
	},
	{
		"stop_id": 8589323,
		"ID": 494,
		"x": -49.5242615597,
		"y": 85.165155534,
		"h": 4.2967032967
	},
	{
		"stop_id": 8589328,
		"ID": 494,
		"x": -49.8982960787,
		"y": 83.517152166,
		"h": 4.2967032967
	},
	{
		"stop_id": 8589330,
		"ID": 494,
		"x": -50.6252814137,
		"y": 83.599162361,
		"h": 4.2967032967
	},
	{
		"stop_id": 8589335,
		"ID": 494,
		"x": -48.5942299657,
		"y": 83.151199097,
		"h": 4.2967032967
	},
	{
		"stop_id": 8589338,
		"ID": 494,
		"x": -50.0152451117,
		"y": 83.81416652,
		"h": 4.2967032967
	},
	{
		"stop_id": 8589339,
		"ID": 494,
		"x": -48.5102496317,
		"y": 82.416180789,
		"h": 4.2967032967
	},
	{
		"stop_id": 8589340,
		"ID": 494,
		"x": -48.9692690257,
		"y": 83.375219011,
		"h": 4.2967032967
	},
	{
		"stop_id": 8589347,
		"ID": 494,
		"x": -50.2332724147,
		"y": 83.684168114,
		"h": 4.2967032967
	},
	{
		"stop_id": 8589351,
		"ID": 494,
		"x": -49.3132681507,
		"y": 85.146175186,
		"h": 4.2967032967
	},
	{
		"stop_id": 8589354,
		"ID": 494,
		"x": -50.1882509287,
		"y": 84.291218769,
		"h": 4.2967032967
	},
	{
		"stop_id": 8589356,
		"ID": 494,
		"x": -49.4172828397,
		"y": 83.934146707,
		"h": 4.2967032967
	},
	{
		"stop_id": 8589360,
		"ID": 494,
		"x": -49.3192286807,
		"y": 84.382185842,
		"h": 4.2967032967
	},
	{
		"stop_id": 8589361,
		"ID": 494,
		"x": -49.1422514927,
		"y": 84.544167391,
		"h": 4.2967032967
	},
	{
		"stop_id": 8589365,
		"ID": 494,
		"x": -50.0022913557,
		"y": 84.316204351,
		"h": 4.2967032967
	},
	{
		"stop_id": 8589366,
		"ID": 494,
		"x": -49.7902941937,
		"y": 85.513170722,
		"h": 4.2967032967
	},
	{
		"stop_id": 8589373,
		"ID": 494,
		"x": -50.4992609817,
		"y": 84.230240664,
		"h": 4.2967032967
	},
	{
		"stop_id": 8589377,
		"ID": 494,
		"x": -49.7752561687,
		"y": 84.354162412,
		"h": 4.2967032967
	},
	{
		"stop_id": 8589378,
		"ID": 494,
		"x": -48.4222702027,
		"y": 83.308188677,
		"h": 4.2967032967
	},
	{
		"stop_id": 8589379,
		"ID": 494,
		"x": -48.3102835317,
		"y": 82.624150412,
		"h": 4.2967032967
	},
	{
		"stop_id": 8589381,
		"ID": 494,
		"x": -49.0662268257,
		"y": 84.124232413,
		"h": 4.2967032967
	},
	{
		"stop_id": 8589382,
		"ID": 494,
		"x": -49.4322421237,
		"y": 83.40119427,
		"h": 4.2967032967
	},
	{
		"stop_id": 8589392,
		"ID": 494,
		"x": -49.5462956337,
		"y": 83.092227523,
		"h": 4.2967032967
	},
	{
		"stop_id": 8589393,
		"ID": 494,
		"x": -49.8222365987,
		"y": 82.194250208,
		"h": 4.2967032967
	},
	{
		"stop_id": 8589394,
		"ID": 494,
		"x": -49.9132436907,
		"y": 81.902230845,
		"h": 4.2967032967
	},
	{
		"stop_id": 8589398,
		"ID": 494,
		"x": -49.9852425877,
		"y": 81.4482438,
		"h": 4.2967032967
	},
	{
		"stop_id": 8589975,
		"ID": 494,
		"x": -49.7872835527,
		"y": 80.881181462,
		"h": 4.2967032967
	},
	{
		"stop_id": 8589976,
		"ID": 494,
		"x": -49.6852727397,
		"y": 80.684217671,
		"h": 4.2967032967
	},
	{
		"stop_id": 8589977,
		"ID": 494,
		"x": -49.7662740067,
		"y": 80.524193776,
		"h": 4.2967032967
	},
	{
		"stop_id": 8589978,
		"ID": 494,
		"x": -49.9832711897,
		"y": 80.292230638,
		"h": 4.2967032967
	},
	{
		"stop_id": 8589979,
		"ID": 494,
		"x": -50.2702691287,
		"y": 80.205151995,
		"h": 4.2967032967
	},
	{
		"stop_id": 8589982,
		"ID": 494,
		"x": -50.4422907327,
		"y": 80.191204684,
		"h": 4.2967032967
	},
	{
		"stop_id": 8592442,
		"ID": 494,
		"x": -50.2012924197,
		"y": 84.8192334,
		"h": 4.2967032967
	},
	{
		"stop_id": 8593495,
		"ID": 494,
		"x": -51.8832326887,
		"y": 83.018188954,
		"h": 4.2967032967
	},
	{
		"stop_id": 8593496,
		"ID": 494,
		"x": -51.5002588557,
		"y": 83.253202565,
		"h": 4.2967032967
	},
	{
		"stop_id": 8593505,
		"ID": 494,
		"x": -51.4702337297,
		"y": 80.986234269,
		"h": 4.2967032967
	},
	{
		"stop_id": 8593506,
		"ID": 494,
		"x": -51.8782892347,
		"y": 81.554183873,
		"h": 4.2967032967
	},
	{
		"stop_id": 8594162,
		"ID": 494,
		"x": -50.1592324807,
		"y": 80.341200622,
		"h": 4.2967032967
	},
	{
		"stop_id": 8500068,
		"ID": 462,
		"x": -55.1802886747,
		"y": 77.242147486,
		"h": 1.1318681319
	},
	{
		"stop_id": 8500069,
		"ID": 462,
		"x": -56.2572343117,
		"y": 77.645144478,
		"h": 1.1318681319
	},
	{
		"stop_id": 8578166,
		"ID": 462,
		"x": -54.8562343127,
		"y": 82.704245379,
		"h": 1.1318681319
	},
	{
		"stop_id": 8578167,
		"ID": 462,
		"x": -55.0372687417,
		"y": 82.549215667,
		"h": 1.1318681319
	},
	{
		"stop_id": 8592450,
		"ID": 462,
		"x": -56.1972313737,
		"y": 77.999196677,
		"h": 1.1318681319
	},
	{
		"stop_id": 8500070,
		"ID": 461,
		"x": -58.2022773447,
		"y": 76.345243844,
		"h": 1.4945054945
	},
	{
		"stop_id": 8500679,
		"ID": 461,
		"x": -55.8122745347,
		"y": 75.842204319,
		"h": 1.4945054945
	},
	{
		"stop_id": 8500695,
		"ID": 461,
		"x": -57.8052314917,
		"y": 74.519245059,
		"h": 1.4945054945
	},
	{
		"stop_id": 8500697,
		"ID": 461,
		"x": -54.0072319817,
		"y": 75.638186934,
		"h": 1.4945054945
	},
	{
		"stop_id": 8572159,
		"ID": 461,
		"x": -58.2252672957,
		"y": 72.953198851,
		"h": 1.4945054945
	},
	{
		"stop_id": 8572160,
		"ID": 461,
		"x": -58.7932590147,
		"y": 73.599182206,
		"h": 1.4945054945
	},
	{
		"stop_id": 8572161,
		"ID": 461,
		"x": -57.6512828397,
		"y": 74.780247375,
		"h": 1.4945054945
	},
	{
		"stop_id": 8572162,
		"ID": 461,
		"x": -55.9322672317,
		"y": 75.701143845,
		"h": 1.4945054945
	},
	{
		"stop_id": 8572164,
		"ID": 461,
		"x": -55.2172830267,
		"y": 76.830175123,
		"h": 1.4945054945
	},
	{
		"stop_id": 8572165,
		"ID": 461,
		"x": -54.1912526677,
		"y": 75.892183906,
		"h": 1.4945054945
	},
	{
		"stop_id": 8572166,
		"ID": 461,
		"x": -56.0632616487,
		"y": 75.049181894,
		"h": 1.4945054945
	},
	{
		"stop_id": 8572199,
		"ID": 461,
		"x": -55.3172534717,
		"y": 71.855231534,
		"h": 1.4945054945
	},
	{
		"stop_id": 8583298,
		"ID": 461,
		"x": -54.5422457227,
		"y": 75.483150633,
		"h": 1.4945054945
	},
	{
		"stop_id": 8583300,
		"ID": 461,
		"x": -57.7792678427,
		"y": 74.671243504,
		"h": 1.4945054945
	},
	{
		"stop_id": 8583436,
		"ID": 461,
		"x": -53.9922839707,
		"y": 75.772179967,
		"h": 1.4945054945
	},
	{
		"stop_id": 8595720,
		"ID": 461,
		"x": -58.1842394587,
		"y": 76.552165198,
		"h": 1.4945054945
	},
	{
		"stop_id": 8500076,
		"ID": 526,
		"x": -46.1172891007,
		"y": 79.820174803,
		"h": 3.4725274725
	},
	{
		"stop_id": 8500077,
		"ID": 526,
		"x": -46.1602587387,
		"y": 77.85718223,
		"h": 3.4725274725
	},
	{
		"stop_id": 8500095,
		"ID": 526,
		"x": -46.2212614027,
		"y": 80.654176293,
		"h": 3.4725274725
	},
	{
		"stop_id": 8500096,
		"ID": 526,
		"x": -46.9282805467,
		"y": 82.604177936,
		"h": 3.4725274725
	},
	{
		"stop_id": 8500119,
		"ID": 526,
		"x": -46.2612646437,
		"y": 79.961165229,
		"h": 3.4725274725
	},
	{
		"stop_id": 8500136,
		"ID": 526,
		"x": -46.9182819647,
		"y": 82.681141777,
		"h": 3.4725274725
	},
	{
		"stop_id": 8500234,
		"ID": 526,
		"x": -47.4262499537,
		"y": 79.174209999,
		"h": 3.4725274725
	},
	{
		"stop_id": 8500235,
		"ID": 526,
		"x": -46.7282500477,
		"y": 82.033217322,
		"h": 3.4725274725
	},
	{
		"stop_id": 8500256,
		"ID": 526,
		"x": -44.0292830107,
		"y": 81.416208035,
		"h": 3.4725274725
	},
	{
		"stop_id": 8500692,
		"ID": 526,
		"x": -46.7612763837,
		"y": 77.262213922,
		"h": 3.4725274725
	},
	{
		"stop_id": 8517409,
		"ID": 526,
		"x": -45.5992889037,
		"y": 82.432185708,
		"h": 3.4725274725
	},
	{
		"stop_id": 8517410,
		"ID": 526,
		"x": -45.3572992907,
		"y": 82.159244538,
		"h": 3.4725274725
	},
	{
		"stop_id": 8517412,
		"ID": 526,
		"x": -44.4922764527,
		"y": 81.67417885,
		"h": 3.4725274725
	},
	{
		"stop_id": 8517413,
		"ID": 526,
		"x": -44.7532340437,
		"y": 81.890219236,
		"h": 3.4725274725
	},
	{
		"stop_id": 8530777,
		"ID": 526,
		"x": -46.8272255657,
		"y": 80.938245893,
		"h": 3.4725274725
	},
	{
		"stop_id": 8578178,
		"ID": 526,
		"x": -48.9132852777,
		"y": 81.531155186,
		"h": 3.4725274725
	},
	{
		"stop_id": 8578179,
		"ID": 526,
		"x": -48.9122318117,
		"y": 80.994231861,
		"h": 3.4725274725
	},
	{
		"stop_id": 8578180,
		"ID": 526,
		"x": -47.3542945977,
		"y": 81.33817707,
		"h": 3.4725274725
	},
	{
		"stop_id": 8578181,
		"ID": 526,
		"x": -47.2172527627,
		"y": 81.171238156,
		"h": 3.4725274725
	},
	{
		"stop_id": 8578183,
		"ID": 526,
		"x": -46.5852363237,
		"y": 80.769216039,
		"h": 3.4725274725
	},
	{
		"stop_id": 8578184,
		"ID": 526,
		"x": -46.3692390007,
		"y": 80.609143753,
		"h": 3.4725274725
	},
	{
		"stop_id": 8578186,
		"ID": 526,
		"x": -46.3622671867,
		"y": 81.292185223,
		"h": 3.4725274725
	},
	{
		"stop_id": 8578188,
		"ID": 526,
		"x": -45.3592832147,
		"y": 81.797211413,
		"h": 3.4725274725
	},
	{
		"stop_id": 8578189,
		"ID": 526,
		"x": -44.7592561297,
		"y": 81.412206939,
		"h": 3.4725274725
	},
	{
		"stop_id": 8578190,
		"ID": 526,
		"x": -44.1782886057,
		"y": 81.03021575,
		"h": 3.4725274725
	},
	{
		"stop_id": 8578194,
		"ID": 526,
		"x": -44.4762431987,
		"y": 82.262182735,
		"h": 3.4725274725
	},
	{
		"stop_id": 8578195,
		"ID": 526,
		"x": -44.7142867187,
		"y": 82.330178023,
		"h": 3.4725274725
	},
	{
		"stop_id": 8578196,
		"ID": 526,
		"x": -45.0162814617,
		"y": 82.258149075,
		"h": 3.4725274725
	},
	{
		"stop_id": 8578218,
		"ID": 526,
		"x": -48.0762442227,
		"y": 77.739145609,
		"h": 3.4725274725
	},
	{
		"stop_id": 8578219,
		"ID": 526,
		"x": -47.6922724647,
		"y": 77.651184732,
		"h": 3.4725274725
	},
	{
		"stop_id": 8578220,
		"ID": 526,
		"x": -47.7122830617,
		"y": 77.336153093,
		"h": 3.4725274725
	},
	{
		"stop_id": 8578225,
		"ID": 526,
		"x": -46.3082335057,
		"y": 77.380189147,
		"h": 3.4725274725
	},
	{
		"stop_id": 8578226,
		"ID": 526,
		"x": -46.1942744427,
		"y": 77.606156494,
		"h": 3.4725274725
	},
	{
		"stop_id": 8588063,
		"ID": 526,
		"x": -47.4812825197,
		"y": 82.074199671,
		"h": 3.4725274725
	},
	{
		"stop_id": 8588064,
		"ID": 526,
		"x": -47.5032784617,
		"y": 81.822202389,
		"h": 3.4725274725
	},
	{
		"stop_id": 8588065,
		"ID": 526,
		"x": -47.7432394917,
		"y": 81.506161665,
		"h": 3.4725274725
	},
	{
		"stop_id": 8588066,
		"ID": 526,
		"x": -48.2762766537,
		"y": 81.428167097,
		"h": 3.4725274725
	},
	{
		"stop_id": 8588067,
		"ID": 526,
		"x": -48.8842577527,
		"y": 81.430249667,
		"h": 3.4725274725
	},
	{
		"stop_id": 8588072,
		"ID": 526,
		"x": -46.5122755617,
		"y": 81.658212952,
		"h": 3.4725274725
	},
	{
		"stop_id": 8588073,
		"ID": 526,
		"x": -46.7152326707,
		"y": 81.557250319,
		"h": 3.4725274725
	},
	{
		"stop_id": 8588759,
		"ID": 526,
		"x": -46.1532863757,
		"y": 78.663190826,
		"h": 3.4725274725
	},
	{
		"stop_id": 8588764,
		"ID": 526,
		"x": -46.1262877167,
		"y": 78.192154217,
		"h": 3.4725274725
	},
	{
		"stop_id": 8588765,
		"ID": 526,
		"x": -46.7242463147,
		"y": 77.69714513,
		"h": 3.4725274725
	},
	{
		"stop_id": 8588776,
		"ID": 526,
		"x": -47.0962706717,
		"y": 82.784165061,
		"h": 3.4725274725
	},
	{
		"stop_id": 8588785,
		"ID": 526,
		"x": -46.1402429497,
		"y": 80.205163929,
		"h": 3.4725274725
	},
	{
		"stop_id": 8588786,
		"ID": 526,
		"x": -47.0312722797,
		"y": 80.769245251,
		"h": 3.4725274725
	},
	{
		"stop_id": 8588787,
		"ID": 526,
		"x": -47.3082281287,
		"y": 80.306230291,
		"h": 3.4725274725
	},
	{
		"stop_id": 8588788,
		"ID": 526,
		"x": -46.6932780367,
		"y": 81.299231629,
		"h": 3.4725274725
	},
	{
		"stop_id": 8588789,
		"ID": 526,
		"x": -46.2962594937,
		"y": 81.044163336,
		"h": 3.4725274725
	},
	{
		"stop_id": 8588791,
		"ID": 526,
		"x": -47.6082632957,
		"y": 78.618234612,
		"h": 3.4725274725
	},
	{
		"stop_id": 8588792,
		"ID": 526,
		"x": -47.8782917447,
		"y": 78.235207111,
		"h": 3.4725274725
	},
	{
		"stop_id": 8588793,
		"ID": 526,
		"x": -47.4082660517,
		"y": 79.729182087,
		"h": 3.4725274725
	},
	{
		"stop_id": 8588946,
		"ID": 526,
		"x": -47.2882826567,
		"y": 82.576170789,
		"h": 3.4725274725
	},
	{
		"stop_id": 8589236,
		"ID": 526,
		"x": -46.2842753727,
		"y": 79.345247085,
		"h": 3.4725274725
	},
	{
		"stop_id": 8589291,
		"ID": 526,
		"x": -48.3232951497,
		"y": 82.068185051,
		"h": 3.4725274725
	},
	{
		"stop_id": 8589299,
		"ID": 526,
		"x": -48.0622354697,
		"y": 82.074140758,
		"h": 3.4725274725
	},
	{
		"stop_id": 8589310,
		"ID": 526,
		"x": -47.5002325327,
		"y": 82.865153019,
		"h": 3.4725274725
	},
	{
		"stop_id": 8589321,
		"ID": 526,
		"x": -47.8162929127,
		"y": 82.183148924,
		"h": 3.4725274725
	},
	{
		"stop_id": 8589322,
		"ID": 526,
		"x": -47.4612400457,
		"y": 82.323191122,
		"h": 3.4725274725
	},
	{
		"stop_id": 8589343,
		"ID": 526,
		"x": -47.6192679257,
		"y": 82.717250823,
		"h": 3.4725274725
	},
	{
		"stop_id": 8589367,
		"ID": 526,
		"x": -48.5362943537,
		"y": 82.212212732,
		"h": 3.4725274725
	},
	{
		"stop_id": 8589370,
		"ID": 526,
		"x": -47.8302970757,
		"y": 83.00824826,
		"h": 3.4725274725
	},
	{
		"stop_id": 8589383,
		"ID": 526,
		"x": -47.8552953517,
		"y": 82.821179478,
		"h": 3.4725274725
	},
	{
		"stop_id": 8592452,
		"ID": 526,
		"x": -46.0172719027,
		"y": 79.862211575,
		"h": 3.4725274725
	},
	{
		"stop_id": 8593497,
		"ID": 526,
		"x": -46.8422917507,
		"y": 77.748144647,
		"h": 3.4725274725
	},
	{
		"stop_id": 8593498,
		"ID": 526,
		"x": -46.9182282007,
		"y": 78.191170075,
		"h": 3.4725274725
	},
	{
		"stop_id": 8593499,
		"ID": 526,
		"x": -46.7902936267,
		"y": 79.09517424,
		"h": 3.4725274725
	},
	{
		"stop_id": 8593501,
		"ID": 526,
		"x": -46.5902703867,
		"y": 79.505226946,
		"h": 3.4725274725
	},
	{
		"stop_id": 8593502,
		"ID": 526,
		"x": -46.2452310667,
		"y": 79.966205081,
		"h": 3.4725274725
	},
	{
		"stop_id": 8593504,
		"ID": 526,
		"x": -45.1072738347,
		"y": 82.545234278,
		"h": 3.4725274725
	},
	{
		"stop_id": 8594681,
		"ID": 526,
		"x": -46.0012957807,
		"y": 79.957202489,
		"h": 3.4725274725
	},
	{
		"stop_id": 8594682,
		"ID": 526,
		"x": -45.4212348527,
		"y": 79.789235156,
		"h": 3.4725274725
	},
	{
		"stop_id": 8594683,
		"ID": 526,
		"x": -45.7012649007,
		"y": 79.895194838,
		"h": 3.4725274725
	},
	{
		"stop_id": 8595636,
		"ID": 526,
		"x": -46.4812455087,
		"y": 80.51015803,
		"h": 3.4725274725
	},
	{
		"stop_id": 8595637,
		"ID": 526,
		"x": -47.2072518657,
		"y": 81.571201654,
		"h": 3.4725274725
	},
	{
		"stop_id": 8595638,
		"ID": 526,
		"x": -46.5862285367,
		"y": 80.027148777,
		"h": 3.4725274725
	},
	{
		"stop_id": 8500084,
		"ID": 591,
		"x": -34.6542786077,
		"y": 70.441227616,
		"h": 1.8571428571
	},
	{
		"stop_id": 8500085,
		"ID": 591,
		"x": -36.0992798587,
		"y": 67.87416239,
		"h": 1.8571428571
	},
	{
		"stop_id": 8500086,
		"ID": 591,
		"x": -36.3162698337,
		"y": 66.509189368,
		"h": 1.8571428571
	},
	{
		"stop_id": 8500087,
		"ID": 591,
		"x": -36.3182399777,
		"y": 65.860204186,
		"h": 1.8571428571
	},
	{
		"stop_id": 8500088,
		"ID": 591,
		"x": -36.3242843327,
		"y": 67.06718809,
		"h": 1.8571428571
	},
	{
		"stop_id": 8500092,
		"ID": 591,
		"x": -34.9032280067,
		"y": 69.945185581,
		"h": 1.8571428571
	},
	{
		"stop_id": 8500093,
		"ID": 591,
		"x": -35.2282766567,
		"y": 69.483196043,
		"h": 1.8571428571
	},
	{
		"stop_id": 8500094,
		"ID": 591,
		"x": -35.8502649347,
		"y": 68.513244643,
		"h": 1.8571428571
	},
	{
		"stop_id": 8500857,
		"ID": 591,
		"x": -38.6972308177,
		"y": 67.563188767,
		"h": 1.8571428571
	},
	{
		"stop_id": 8572351,
		"ID": 591,
		"x": -36.2952731737,
		"y": 65.857181691,
		"h": 1.8571428571
	},
	{
		"stop_id": 8578240,
		"ID": 591,
		"x": -36.3062344177,
		"y": 66.568156221,
		"h": 1.8571428571
	},
	{
		"stop_id": 8578241,
		"ID": 591,
		"x": -36.2952682037,
		"y": 67.003149644,
		"h": 1.8571428571
	},
	{
		"stop_id": 8578250,
		"ID": 591,
		"x": -34.6432574757,
		"y": 70.42215044,
		"h": 1.8571428571
	},
	{
		"stop_id": 8578251,
		"ID": 591,
		"x": -34.7282785407,
		"y": 70.061219118,
		"h": 1.8571428571
	},
	{
		"stop_id": 8578253,
		"ID": 591,
		"x": -33.9722848177,
		"y": 67.750151177,
		"h": 1.8571428571
	},
	{
		"stop_id": 8578254,
		"ID": 591,
		"x": -35.5712471247,
		"y": 70.277203725,
		"h": 1.8571428571
	},
	{
		"stop_id": 8578255,
		"ID": 591,
		"x": -35.5232986277,
		"y": 70.527231422,
		"h": 1.8571428571
	},
	{
		"stop_id": 8578333,
		"ID": 591,
		"x": -38.1152786037,
		"y": 69.029238229,
		"h": 1.8571428571
	},
	{
		"stop_id": 8578334,
		"ID": 591,
		"x": -38.1152930207,
		"y": 68.515234249,
		"h": 1.8571428571
	},
	{
		"stop_id": 8578335,
		"ID": 591,
		"x": -38.7222910317,
		"y": 69.119229712,
		"h": 1.8571428571
	},
	{
		"stop_id": 8580336,
		"ID": 591,
		"x": -36.3132932657,
		"y": 66.520208277,
		"h": 1.8571428571
	},
	{
		"stop_id": 8589384,
		"ID": 591,
		"x": -33.6112808737,
		"y": 68.137205145,
		"h": 1.8571428571
	},
	{
		"stop_id": 8589399,
		"ID": 591,
		"x": -37.9072312327,
		"y": 70.573239318,
		"h": 1.8571428571
	},
	{
		"stop_id": 8592304,
		"ID": 591,
		"x": -34.9082918787,
		"y": 69.965177625,
		"h": 1.8571428571
	},
	{
		"stop_id": 8592305,
		"ID": 591,
		"x": -35.2342546907,
		"y": 69.487173991,
		"h": 1.8571428571
	},
	{
		"stop_id": 8592306,
		"ID": 591,
		"x": -35.8582813307,
		"y": 68.517215009,
		"h": 1.8571428571
	},
	{
		"stop_id": 8592307,
		"ID": 591,
		"x": -36.1052551567,
		"y": 67.896153012,
		"h": 1.8571428571
	},
	{
		"stop_id": 8500089,
		"ID": 557,
		"x": -40.0022334187,
		"y": 64.442246436,
		"h": 1.4615384615
	},
	{
		"stop_id": 8500097,
		"ID": 557,
		"x": -40.2882334637,
		"y": 66.281157474,
		"h": 1.4615384615
	},
	{
		"stop_id": 8500753,
		"ID": 557,
		"x": -43.5392586697,
		"y": 67.220242629,
		"h": 1.4615384615
	},
	{
		"stop_id": 8500852,
		"ID": 557,
		"x": -40.6262673927,
		"y": 67.080246214,
		"h": 1.4615384615
	},
	{
		"stop_id": 8572135,
		"ID": 557,
		"x": -43.7432837167,
		"y": 66.957186556,
		"h": 1.4615384615
	},
	{
		"stop_id": 8572136,
		"ID": 557,
		"x": -43.3792655627,
		"y": 67.704217179,
		"h": 1.4615384615
	},
	{
		"stop_id": 8578242,
		"ID": 557,
		"x": -38.5612383227,
		"y": 66.430156677,
		"h": 1.4615384615
	},
	{
		"stop_id": 8578243,
		"ID": 557,
		"x": -38.9852950957,
		"y": 66.376181195,
		"h": 1.4615384615
	},
	{
		"stop_id": 8578244,
		"ID": 557,
		"x": -40.0532942207,
		"y": 66.973157738,
		"h": 1.4615384615
	},
	{
		"stop_id": 8578246,
		"ID": 557,
		"x": -41.8452665377,
		"y": 66.280155741,
		"h": 1.4615384615
	},
	{
		"stop_id": 8578247,
		"ID": 557,
		"x": -42.1232311167,
		"y": 67.489221178,
		"h": 1.4615384615
	},
	{
		"stop_id": 8578248,
		"ID": 557,
		"x": -42.8062928387,
		"y": 67.028159622,
		"h": 1.4615384615
	},
	{
		"stop_id": 8578330,
		"ID": 557,
		"x": -40.7682558247,
		"y": 67.690188276,
		"h": 1.4615384615
	},
	{
		"stop_id": 8578331,
		"ID": 557,
		"x": -40.6722600117,
		"y": 67.250209013,
		"h": 1.4615384615
	},
	{
		"stop_id": 8578336,
		"ID": 557,
		"x": -39.2802431507,
		"y": 67.197247721,
		"h": 1.4615384615
	},
	{
		"stop_id": 8500100,
		"ID": 336,
		"x": -77.6932894717,
		"y": 47.336190963,
		"h": 1.1978021978
	},
	{
		"stop_id": 8504302,
		"ID": 336,
		"x": -74.2642975227,
		"y": 43.979230785,
		"h": 1.1978021978
	},
	{
		"stop_id": 8504303,
		"ID": 336,
		"x": -75.9032729357,
		"y": 43.956244227,
		"h": 1.1978021978
	},
	{
		"stop_id": 8571938,
		"ID": 336,
		"x": -77.7052781537,
		"y": 47.354238152,
		"h": 1.1978021978
	},
	{
		"stop_id": 8571939,
		"ID": 336,
		"x": -77.4822691947,
		"y": 48.041199743,
		"h": 1.1978021978
	},
	{
		"stop_id": 8589210,
		"ID": 336,
		"x": -74.2642975227,
		"y": 43.979230785,
		"h": 1.1978021978
	},
	{
		"stop_id": 8589211,
		"ID": 336,
		"x": -75.7922834517,
		"y": 44.025205164,
		"h": 1.1978021978
	},
	{
		"stop_id": 8500101,
		"ID": 337,
		"x": -75.7362680037,
		"y": 49.041155941,
		"h": 1.4285714286
	},
	{
		"stop_id": 8504397,
		"ID": 337,
		"x": -76.5852736147,
		"y": 53.398160816,
		"h": 1.4285714286
	},
	{
		"stop_id": 8571941,
		"ID": 337,
		"x": -79.0512826097,
		"y": 50.736184846,
		"h": 1.4285714286
	},
	{
		"stop_id": 8571943,
		"ID": 337,
		"x": -78.2292567027,
		"y": 53.149142686,
		"h": 1.4285714286
	},
	{
		"stop_id": 8571944,
		"ID": 337,
		"x": -77.3232956327,
		"y": 53.285240555,
		"h": 1.4285714286
	},
	{
		"stop_id": 8571951,
		"ID": 337,
		"x": -77.2372718637,
		"y": 49.906149849,
		"h": 1.4285714286
	},
	{
		"stop_id": 8571952,
		"ID": 337,
		"x": -76.4072991697,
		"y": 50.045170372,
		"h": 1.4285714286
	},
	{
		"stop_id": 8571953,
		"ID": 337,
		"x": -75.7172504717,
		"y": 49.017201224,
		"h": 1.4285714286
	},
	{
		"stop_id": 8571964,
		"ID": 337,
		"x": -74.5722887077,
		"y": 53.36619069,
		"h": 1.4285714286
	},
	{
		"stop_id": 8581110,
		"ID": 337,
		"x": -76.4482355657,
		"y": 48.79419774,
		"h": 1.4285714286
	},
	{
		"stop_id": 8581111,
		"ID": 337,
		"x": -78.9222803027,
		"y": 49.991202016,
		"h": 1.4285714286
	},
	{
		"stop_id": 8582962,
		"ID": 337,
		"x": -75.6492524427,
		"y": 49.382237849,
		"h": 1.4285714286
	},
	{
		"stop_id": 8583614,
		"ID": 337,
		"x": -77.7262276887,
		"y": 49.979215966,
		"h": 1.4285714286
	},
	{
		"stop_id": 8583786,
		"ID": 337,
		"x": -75.5612987347,
		"y": 53.497169596,
		"h": 1.4285714286
	},
	{
		"stop_id": 8500102,
		"ID": 366,
		"x": -72.0612362307,
		"y": 49.419246963,
		"h": 1.2307692308
	},
	{
		"stop_id": 8500103,
		"ID": 366,
		"x": -69.8022400747,
		"y": 49.474219181,
		"h": 1.2307692308
	},
	{
		"stop_id": 8500135,
		"ID": 366,
		"x": -73.7102613627,
		"y": 49.438149561,
		"h": 1.2307692308
	},
	{
		"stop_id": 8582684,
		"ID": 366,
		"x": -69.8022400747,
		"y": 49.474219181,
		"h": 1.2307692308
	},
	{
		"stop_id": 8583850,
		"ID": 366,
		"x": -71.4552872697,
		"y": 49.216225067,
		"h": 1.2307692308
	},
	{
		"stop_id": 8583854,
		"ID": 366,
		"x": -72.3912832617,
		"y": 49.388148168,
		"h": 1.2307692308
	},
	{
		"stop_id": 8589219,
		"ID": 366,
		"x": -73.7102613627,
		"y": 49.438149561,
		"h": 1.2307692308
	},
	{
		"stop_id": 8589220,
		"ID": 366,
		"x": -72.0612362307,
		"y": 49.419246963,
		"h": 1.2307692308
	},
	{
		"stop_id": 8500104,
		"ID": 397,
		"x": -67.0512441307,
		"y": 49.620251102,
		"h": 1.6263736264
	},
	{
		"stop_id": 8500676,
		"ID": 397,
		"x": -66.9222956707,
		"y": 53.34023197,
		"h": 1.6263736264
	},
	{
		"stop_id": 8500680,
		"ID": 397,
		"x": -64.8992364927,
		"y": 53.939248059,
		"h": 1.6263736264
	},
	{
		"stop_id": 8571959,
		"ID": 397,
		"x": -65.4592422887,
		"y": 53.352187534,
		"h": 1.6263736264
	},
	{
		"stop_id": 8571960,
		"ID": 397,
		"x": -65.9402568917,
		"y": 53.143215548,
		"h": 1.6263736264
	},
	{
		"stop_id": 8571961,
		"ID": 397,
		"x": -66.4092426117,
		"y": 53.16118487,
		"h": 1.6263736264
	},
	{
		"stop_id": 8578062,
		"ID": 397,
		"x": -65.9432894027,
		"y": 53.56714377,
		"h": 1.6263736264
	},
	{
		"stop_id": 8580084,
		"ID": 397,
		"x": -64.5952882647,
		"y": 53.417225155,
		"h": 1.6263736264
	},
	{
		"stop_id": 8580095,
		"ID": 397,
		"x": -64.3462523557,
		"y": 53.34119963,
		"h": 1.6263736264
	},
	{
		"stop_id": 8580097,
		"ID": 397,
		"x": -65.5012930477,
		"y": 52.988229307,
		"h": 1.6263736264
	},
	{
		"stop_id": 8581144,
		"ID": 397,
		"x": -64.9082574317,
		"y": 53.74825053,
		"h": 1.6263736264
	},
	{
		"stop_id": 8581146,
		"ID": 397,
		"x": -64.8022698377,
		"y": 53.817200012,
		"h": 1.6263736264
	},
	{
		"stop_id": 8581147,
		"ID": 397,
		"x": -65.1602995027,
		"y": 54.065227447,
		"h": 1.6263736264
	},
	{
		"stop_id": 8581148,
		"ID": 397,
		"x": -65.4912376487,
		"y": 53.827175198,
		"h": 1.6263736264
	},
	{
		"stop_id": 8581149,
		"ID": 397,
		"x": -65.8012611177,
		"y": 53.718198626,
		"h": 1.6263736264
	},
	{
		"stop_id": 8581151,
		"ID": 397,
		"x": -65.5802917417,
		"y": 53.599235225,
		"h": 1.6263736264
	},
	{
		"stop_id": 8582682,
		"ID": 397,
		"x": -67.0512441307,
		"y": 49.620251102,
		"h": 1.6263736264
	},
	{
		"stop_id": 8583595,
		"ID": 397,
		"x": -64.7812892967,
		"y": 53.755144034,
		"h": 1.6263736264
	},
	{
		"stop_id": 8583687,
		"ID": 397,
		"x": -67.4152848337,
		"y": 53.5051776,
		"h": 1.6263736264
	},
	{
		"stop_id": 8583849,
		"ID": 397,
		"x": -67.7872874977,
		"y": 49.500250459,
		"h": 1.6263736264
	},
	{
		"stop_id": 8500105,
		"ID": 427,
		"x": -64.0992550437,
		"y": 54.073234498,
		"h": 1.4615384615
	},
	{
		"stop_id": 8500266,
		"ID": 427,
		"x": -58.8552802497,
		"y": 54.622195112,
		"h": 1.4615384615
	},
	{
		"stop_id": 8500267,
		"ID": 427,
		"x": -59.9932319607,
		"y": 54.617145002,
		"h": 1.4615384615
	},
	{
		"stop_id": 8500268,
		"ID": 427,
		"x": -60.9772788747,
		"y": 54.410153639,
		"h": 1.4615384615
	},
	{
		"stop_id": 8571957,
		"ID": 427,
		"x": -64.1042425267,
		"y": 54.081243115,
		"h": 1.4615384615
	},
	{
		"stop_id": 8576477,
		"ID": 427,
		"x": -64.6542668277,
		"y": 54.187188755,
		"h": 1.4615384615
	},
	{
		"stop_id": 8576481,
		"ID": 427,
		"x": -63.6202555027,
		"y": 54.080233942,
		"h": 1.4615384615
	},
	{
		"stop_id": 8576482,
		"ID": 427,
		"x": -63.1022771477,
		"y": 53.853217604,
		"h": 1.4615384615
	},
	{
		"stop_id": 8576483,
		"ID": 427,
		"x": -62.7492687097,
		"y": 53.508146853,
		"h": 1.4615384615
	},
	{
		"stop_id": 8576484,
		"ID": 427,
		"x": -62.2092949687,
		"y": 54.267243394,
		"h": 1.4615384615
	},
	{
		"stop_id": 8576485,
		"ID": 427,
		"x": -62.2882505797,
		"y": 54.505200996,
		"h": 1.4615384615
	},
	{
		"stop_id": 8578911,
		"ID": 427,
		"x": -60.9082977947,
		"y": 54.335204127,
		"h": 1.4615384615
	},
	{
		"stop_id": 8580079,
		"ID": 427,
		"x": -64.5912656067,
		"y": 53.979231337,
		"h": 1.4615384615
	},
	{
		"stop_id": 8581909,
		"ID": 427,
		"x": -58.7392904917,
		"y": 54.521150332,
		"h": 1.4615384615
	},
	{
		"stop_id": 8581912,
		"ID": 427,
		"x": -59.6672488247,
		"y": 54.365204292,
		"h": 1.4615384615
	},
	{
		"stop_id": 8500109,
		"ID": 399,
		"x": -66.4332852257,
		"y": 63.118179668,
		"h": 3.3406593407
	},
	{
		"stop_id": 8500650,
		"ID": 399,
		"x": -64.7602840337,
		"y": 63.14018702,
		"h": 3.3406593407
	},
	{
		"stop_id": 8500667,
		"ID": 399,
		"x": -63.4082639737,
		"y": 63.063242146,
		"h": 3.3406593407
	},
	{
		"stop_id": 8500669,
		"ID": 399,
		"x": -66.7702555037,
		"y": 61.377250681,
		"h": 3.3406593407
	},
	{
		"stop_id": 8571965,
		"ID": 399,
		"x": -66.5002702797,
		"y": 63.137157432,
		"h": 3.3406593407
	},
	{
		"stop_id": 8571966,
		"ID": 399,
		"x": -65.9592779427,
		"y": 64.017229228,
		"h": 3.3406593407
	},
	{
		"stop_id": 8571967,
		"ID": 399,
		"x": -65.9652826987,
		"y": 63.271205591,
		"h": 3.3406593407
	},
	{
		"stop_id": 8571968,
		"ID": 399,
		"x": -65.5262265837,
		"y": 63.128220216,
		"h": 3.3406593407
	},
	{
		"stop_id": 8571969,
		"ID": 399,
		"x": -64.4852783117,
		"y": 63.083143204,
		"h": 3.3406593407
	},
	{
		"stop_id": 8571970,
		"ID": 399,
		"x": -64.1392494277,
		"y": 63.034174401,
		"h": 3.3406593407
	},
	{
		"stop_id": 8571982,
		"ID": 399,
		"x": -66.4862785607,
		"y": 63.348164198,
		"h": 3.3406593407
	},
	{
		"stop_id": 8571983,
		"ID": 399,
		"x": -66.5732896217,
		"y": 63.617213727,
		"h": 3.3406593407
	},
	{
		"stop_id": 8571984,
		"ID": 399,
		"x": -66.2042317797,
		"y": 63.808250128,
		"h": 3.3406593407
	},
	{
		"stop_id": 8571990,
		"ID": 399,
		"x": -64.7012647667,
		"y": 60.673246351,
		"h": 3.3406593407
	},
	{
		"stop_id": 8571991,
		"ID": 399,
		"x": -64.6892693967,
		"y": 60.113218319,
		"h": 3.3406593407
	},
	{
		"stop_id": 8571996,
		"ID": 399,
		"x": -66.7312559727,
		"y": 63.158219319,
		"h": 3.3406593407
	},
	{
		"stop_id": 8571997,
		"ID": 399,
		"x": -66.8182990917,
		"y": 62.580179391,
		"h": 3.3406593407
	},
	{
		"stop_id": 8571998,
		"ID": 399,
		"x": -66.7912268897,
		"y": 61.784199129,
		"h": 3.3406593407
	},
	{
		"stop_id": 8571999,
		"ID": 399,
		"x": -66.9182288277,
		"y": 61.117154867,
		"h": 3.3406593407
	},
	{
		"stop_id": 8572001,
		"ID": 399,
		"x": -65.4542348817,
		"y": 65.601171342,
		"h": 3.3406593407
	},
	{
		"stop_id": 8572009,
		"ID": 399,
		"x": -67.0802525027,
		"y": 63.469176345,
		"h": 3.3406593407
	},
	{
		"stop_id": 8572010,
		"ID": 399,
		"x": -67.1492658897,
		"y": 63.193198815,
		"h": 3.3406593407
	},
	{
		"stop_id": 8572011,
		"ID": 399,
		"x": -67.4412811897,
		"y": 63.102183451,
		"h": 3.3406593407
	},
	{
		"stop_id": 8579755,
		"ID": 399,
		"x": -65.6882593427,
		"y": 63.284148204,
		"h": 3.3406593407
	},
	{
		"stop_id": 8579764,
		"ID": 399,
		"x": -66.3592872737,
		"y": 63.823210451,
		"h": 3.3406593407
	},
	{
		"stop_id": 8579768,
		"ID": 399,
		"x": -67.2782964117,
		"y": 63.131212606,
		"h": 3.3406593407
	},
	{
		"stop_id": 8579793,
		"ID": 399,
		"x": -64.9602598797,
		"y": 61.010239116,
		"h": 3.3406593407
	},
	{
		"stop_id": 8580217,
		"ID": 399,
		"x": -66.0722962517,
		"y": 63.507247984,
		"h": 3.3406593407
	},
	{
		"stop_id": 8580223,
		"ID": 399,
		"x": -66.9502659077,
		"y": 63.579196283,
		"h": 3.3406593407
	},
	{
		"stop_id": 8580606,
		"ID": 399,
		"x": -66.5262993167,
		"y": 62.970192663,
		"h": 3.3406593407
	},
	{
		"stop_id": 8581136,
		"ID": 399,
		"x": -67.3462610467,
		"y": 63.849201226,
		"h": 3.3406593407
	},
	{
		"stop_id": 8581137,
		"ID": 399,
		"x": -65.9072466137,
		"y": 64.581200565,
		"h": 3.3406593407
	},
	{
		"stop_id": 8581138,
		"ID": 399,
		"x": -66.3042486077,
		"y": 64.474230206,
		"h": 3.3406593407
	},
	{
		"stop_id": 8581139,
		"ID": 399,
		"x": -66.8702472847,
		"y": 62.605146979,
		"h": 3.3406593407
	},
	{
		"stop_id": 8581140,
		"ID": 399,
		"x": -67.8902868947,
		"y": 63.610223306,
		"h": 3.3406593407
	},
	{
		"stop_id": 8581218,
		"ID": 399,
		"x": -67.1382814157,
		"y": 63.45724161,
		"h": 3.3406593407
	},
	{
		"stop_id": 8581219,
		"ID": 399,
		"x": -65.9842256527,
		"y": 63.642239307,
		"h": 3.3406593407
	},
	{
		"stop_id": 8581220,
		"ID": 399,
		"x": -66.6282474357,
		"y": 63.388243559,
		"h": 3.3406593407
	},
	{
		"stop_id": 8581221,
		"ID": 399,
		"x": -65.8182464797,
		"y": 63.739237569,
		"h": 3.3406593407
	},
	{
		"stop_id": 8581222,
		"ID": 399,
		"x": -66.1242644997,
		"y": 64.202191195,
		"h": 3.3406593407
	},
	{
		"stop_id": 8581223,
		"ID": 399,
		"x": -65.9132634207,
		"y": 64.390196104,
		"h": 3.3406593407
	},
	{
		"stop_id": 8581224,
		"ID": 399,
		"x": -66.1642789467,
		"y": 64.56124178,
		"h": 3.3406593407
	},
	{
		"stop_id": 8581231,
		"ID": 399,
		"x": -67.1022928157,
		"y": 62.399191935,
		"h": 3.3406593407
	},
	{
		"stop_id": 8581234,
		"ID": 399,
		"x": -66.7782716357,
		"y": 62.820172193,
		"h": 3.3406593407
	},
	{
		"stop_id": 8581235,
		"ID": 399,
		"x": -67.4962387347,
		"y": 63.53119504,
		"h": 3.3406593407
	},
	{
		"stop_id": 8581236,
		"ID": 399,
		"x": -67.6762969077,
		"y": 63.661184956,
		"h": 3.3406593407
	},
	{
		"stop_id": 8581316,
		"ID": 399,
		"x": -66.8222707477,
		"y": 63.29519323,
		"h": 3.3406593407
	},
	{
		"stop_id": 8581727,
		"ID": 399,
		"x": -67.1022358927,
		"y": 63.227161211,
		"h": 3.3406593407
	},
	{
		"stop_id": 8581815,
		"ID": 399,
		"x": -67.4282819877,
		"y": 62.991207097,
		"h": 3.3406593407
	},
	{
		"stop_id": 8581827,
		"ID": 399,
		"x": -66.4202825297,
		"y": 64.120246602,
		"h": 3.3406593407
	},
	{
		"stop_id": 8581828,
		"ID": 399,
		"x": -66.7452773597,
		"y": 63.815209251,
		"h": 3.3406593407
	},
	{
		"stop_id": 8581837,
		"ID": 399,
		"x": -68.4852509567,
		"y": 62.217194597,
		"h": 3.3406593407
	},
	{
		"stop_id": 8581838,
		"ID": 399,
		"x": -67.1862726567,
		"y": 62.069200259,
		"h": 3.3406593407
	},
	{
		"stop_id": 8581888,
		"ID": 399,
		"x": -66.9862540187,
		"y": 63.1862131,
		"h": 3.3406593407
	},
	{
		"stop_id": 8581890,
		"ID": 399,
		"x": -67.5092673027,
		"y": 63.732229061,
		"h": 3.3406593407
	},
	{
		"stop_id": 8582393,
		"ID": 399,
		"x": -67.4682894467,
		"y": 61.982176278,
		"h": 3.3406593407
	},
	{
		"stop_id": 8582394,
		"ID": 399,
		"x": -65.7022291247,
		"y": 63.215229766,
		"h": 3.3406593407
	},
	{
		"stop_id": 8582395,
		"ID": 399,
		"x": -67.0162276297,
		"y": 62.225196782,
		"h": 3.3406593407
	},
	{
		"stop_id": 8582402,
		"ID": 399,
		"x": -66.6932725747,
		"y": 61.489229538,
		"h": 3.3406593407
	},
	{
		"stop_id": 8582563,
		"ID": 399,
		"x": -65.3082413957,
		"y": 62.221212206,
		"h": 3.3406593407
	},
	{
		"stop_id": 8582586,
		"ID": 399,
		"x": -66.0912351107,
		"y": 63.039193483,
		"h": 3.3406593407
	},
	{
		"stop_id": 8582587,
		"ID": 399,
		"x": -66.3432949377,
		"y": 63.000225028,
		"h": 3.3406593407
	},
	{
		"stop_id": 8582813,
		"ID": 399,
		"x": -69.3822705447,
		"y": 63.027221307,
		"h": 3.3406593407
	},
	{
		"stop_id": 8582814,
		"ID": 399,
		"x": -67.8362586187,
		"y": 62.857225807,
		"h": 3.3406593407
	},
	{
		"stop_id": 8583087,
		"ID": 399,
		"x": -66.7592424357,
		"y": 63.570181151,
		"h": 3.3406593407
	},
	{
		"stop_id": 8583088,
		"ID": 399,
		"x": -66.7502787387,
		"y": 62.917200203,
		"h": 3.3406593407
	},
	{
		"stop_id": 8583553,
		"ID": 399,
		"x": -67.1752663677,
		"y": 61.930209608,
		"h": 3.3406593407
	},
	{
		"stop_id": 8583554,
		"ID": 399,
		"x": -67.3232809347,
		"y": 62.109178635,
		"h": 3.3406593407
	},
	{
		"stop_id": 8583555,
		"ID": 399,
		"x": -66.7222888007,
		"y": 62.124220347,
		"h": 3.3406593407
	},
	{
		"stop_id": 8583780,
		"ID": 399,
		"x": -68.8512405537,
		"y": 61.436145712,
		"h": 3.3406593407
	},
	{
		"stop_id": 8583784,
		"ID": 399,
		"x": -66.8102313047,
		"y": 60.686197252,
		"h": 3.3406593407
	},
	{
		"stop_id": 8583866,
		"ID": 399,
		"x": -67.6042558157,
		"y": 61.841156541,
		"h": 3.3406593407
	},
	{
		"stop_id": 8500113,
		"ID": 460,
		"x": -54.9122448747,
		"y": 69.491216183,
		"h": 1.7912087912
	},
	{
		"stop_id": 8500686,
		"ID": 460,
		"x": -55.0152725067,
		"y": 71.341234214,
		"h": 1.7912087912
	},
	{
		"stop_id": 8500954,
		"ID": 460,
		"x": -56.9212428327,
		"y": 70.084218624,
		"h": 1.7912087912
	},
	{
		"stop_id": 8500958,
		"ID": 460,
		"x": -53.9982880797,
		"y": 67.563213596,
		"h": 1.7912087912
	},
	{
		"stop_id": 8572113,
		"ID": 460,
		"x": -54.9432301607,
		"y": 69.454167213,
		"h": 1.7912087912
	},
	{
		"stop_id": 8572114,
		"ID": 460,
		"x": -53.2852280527,
		"y": 68.670212623,
		"h": 1.7912087912
	},
	{
		"stop_id": 8572143,
		"ID": 460,
		"x": -55.2422681147,
		"y": 69.730227203,
		"h": 1.7912087912
	},
	{
		"stop_id": 8572144,
		"ID": 460,
		"x": -55.7762308807,
		"y": 69.868164231,
		"h": 1.7912087912
	},
	{
		"stop_id": 8572145,
		"ID": 460,
		"x": -56.6332276987,
		"y": 69.926144966,
		"h": 1.7912087912
	},
	{
		"stop_id": 8572147,
		"ID": 460,
		"x": -57.7822540587,
		"y": 70.324149491,
		"h": 1.7912087912
	},
	{
		"stop_id": 8572158,
		"ID": 460,
		"x": -57.0822399927,
		"y": 70.205225164,
		"h": 1.7912087912
	},
	{
		"stop_id": 8572168,
		"ID": 460,
		"x": -54.6672857957,
		"y": 68.855226217,
		"h": 1.7912087912
	},
	{
		"stop_id": 8572169,
		"ID": 460,
		"x": -54.1172786657,
		"y": 68.071207469,
		"h": 1.7912087912
	},
	{
		"stop_id": 8572170,
		"ID": 460,
		"x": -54.0552802707,
		"y": 67.722150993,
		"h": 1.7912087912
	},
	{
		"stop_id": 8572171,
		"ID": 460,
		"x": -53.9272961467,
		"y": 67.294219268,
		"h": 1.7912087912
	},
	{
		"stop_id": 8572175,
		"ID": 460,
		"x": -57.6012876927,
		"y": 66.123153784,
		"h": 1.7912087912
	},
	{
		"stop_id": 8572176,
		"ID": 460,
		"x": -54.5602682357,
		"y": 69.99016849,
		"h": 1.7912087912
	},
	{
		"stop_id": 8572177,
		"ID": 460,
		"x": -54.3552454627,
		"y": 70.735169958,
		"h": 1.7912087912
	},
	{
		"stop_id": 8572194,
		"ID": 460,
		"x": -56.8862713657,
		"y": 67.440183804,
		"h": 1.7912087912
	},
	{
		"stop_id": 8572198,
		"ID": 460,
		"x": -54.5922272877,
		"y": 71.005250211,
		"h": 1.7912087912
	},
	{
		"stop_id": 8579511,
		"ID": 460,
		"x": -55.1462417037,
		"y": 69.082210816,
		"h": 1.7912087912
	},
	{
		"stop_id": 8580734,
		"ID": 460,
		"x": -54.4022604677,
		"y": 68.460199413,
		"h": 1.7912087912
	},
	{
		"stop_id": 8581848,
		"ID": 460,
		"x": -54.8072258377,
		"y": 70.163184704,
		"h": 1.7912087912
	},
	{
		"stop_id": 8581849,
		"ID": 460,
		"x": -55.0192460527,
		"y": 69.96621895,
		"h": 1.7912087912
	},
	{
		"stop_id": 8583311,
		"ID": 460,
		"x": -56.2972643647,
		"y": 69.871179807,
		"h": 1.7912087912
	},
	{
		"stop_id": 8500114,
		"ID": 492,
		"x": -52.8142279817,
		"y": 71.100215956,
		"h": 1.5604395604
	},
	{
		"stop_id": 8500673,
		"ID": 492,
		"x": -50.6652358177,
		"y": 72.51124789,
		"h": 1.5604395604
	},
	{
		"stop_id": 8500754,
		"ID": 492,
		"x": -51.9202274897,
		"y": 69.531180346,
		"h": 1.5604395604
	},
	{
		"stop_id": 8572178,
		"ID": 492,
		"x": -53.3042253667,
		"y": 71.525170312,
		"h": 1.5604395604
	},
	{
		"stop_id": 8572179,
		"ID": 492,
		"x": -52.7902813407,
		"y": 71.462148362,
		"h": 1.5604395604
	},
	{
		"stop_id": 8572180,
		"ID": 492,
		"x": -52.8172978947,
		"y": 71.080199252,
		"h": 1.5604395604
	},
	{
		"stop_id": 8572181,
		"ID": 492,
		"x": -52.1822526197,
		"y": 70.145244412,
		"h": 1.5604395604
	},
	{
		"stop_id": 8572182,
		"ID": 492,
		"x": -52.0752580717,
		"y": 69.909226355,
		"h": 1.5604395604
	},
	{
		"stop_id": 8572183,
		"ID": 492,
		"x": -51.8382815917,
		"y": 69.136141697,
		"h": 1.5604395604
	},
	{
		"stop_id": 8572200,
		"ID": 492,
		"x": -53.6142326117,
		"y": 71.417218438,
		"h": 1.5604395604
	},
	{
		"stop_id": 8572201,
		"ID": 492,
		"x": -53.6922506137,
		"y": 72.92524536,
		"h": 1.5604395604
	},
	{
		"stop_id": 8572202,
		"ID": 492,
		"x": -52.1782980787,
		"y": 71.729178296,
		"h": 1.5604395604
	},
	{
		"stop_id": 8572203,
		"ID": 492,
		"x": -51.4172579757,
		"y": 72.330142718,
		"h": 1.5604395604
	},
	{
		"stop_id": 8572204,
		"ID": 492,
		"x": -50.4402269297,
		"y": 72.643237465,
		"h": 1.5604395604
	},
	{
		"stop_id": 8582810,
		"ID": 492,
		"x": -49.4292733837,
		"y": 70.248211844,
		"h": 1.5604395604
	},
	{
		"stop_id": 8582811,
		"ID": 492,
		"x": -49.5292277327,
		"y": 69.884245917,
		"h": 1.5604395604
	},
	{
		"stop_id": 8582812,
		"ID": 492,
		"x": -48.9692428577,
		"y": 69.958168891,
		"h": 1.5604395604
	},
	{
		"stop_id": 8583102,
		"ID": 492,
		"x": -49.3532458317,
		"y": 70.524191483,
		"h": 1.5604395604
	},
	{
		"stop_id": 8500115,
		"ID": 525,
		"x": -48.1742419727,
		"y": 71.94118572,
		"h": 2.4175824176
	},
	{
		"stop_id": 8500116,
		"ID": 525,
		"x": -47.3122510987,
		"y": 73.293152366,
		"h": 2.4175824176
	},
	{
		"stop_id": 8500117,
		"ID": 525,
		"x": -47.3452792467,
		"y": 74.883144238,
		"h": 2.4175824176
	},
	{
		"stop_id": 8500118,
		"ID": 525,
		"x": -46.7432906097,
		"y": 77.205214639,
		"h": 2.4175824176
	},
	{
		"stop_id": 8500233,
		"ID": 525,
		"x": -48.2082288737,
		"y": 76.902210914,
		"h": 2.4175824176
	},
	{
		"stop_id": 8500255,
		"ID": 525,
		"x": -47.8102613877,
		"y": 75.08621856,
		"h": 2.4175824176
	},
	{
		"stop_id": 8500691,
		"ID": 525,
		"x": -46.3942684497,
		"y": 76.294150363,
		"h": 2.4175824176
	},
	{
		"stop_id": 8500956,
		"ID": 525,
		"x": -44.5672727847,
		"y": 73.622186077,
		"h": 2.4175824176
	},
	{
		"stop_id": 8572131,
		"ID": 525,
		"x": -48.1112796837,
		"y": 71.721163086,
		"h": 2.4175824176
	},
	{
		"stop_id": 8572132,
		"ID": 525,
		"x": -48.1672541647,
		"y": 71.955208561,
		"h": 2.4175824176
	},
	{
		"stop_id": 8572205,
		"ID": 525,
		"x": -46.6812460427,
		"y": 76.8532237,
		"h": 2.4175824176
	},
	{
		"stop_id": 8572206,
		"ID": 525,
		"x": -46.3042701217,
		"y": 76.094218368,
		"h": 2.4175824176
	},
	{
		"stop_id": 8572207,
		"ID": 525,
		"x": -45.7422833317,
		"y": 75.756176501,
		"h": 2.4175824176
	},
	{
		"stop_id": 8572208,
		"ID": 525,
		"x": -44.4112723747,
		"y": 73.95225109,
		"h": 2.4175824176
	},
	{
		"stop_id": 8572209,
		"ID": 525,
		"x": -45.3392413877,
		"y": 71.910240183,
		"h": 2.4175824176
	},
	{
		"stop_id": 8578221,
		"ID": 525,
		"x": -47.1032456657,
		"y": 77.213221851,
		"h": 2.4175824176
	},
	{
		"stop_id": 8578224,
		"ID": 525,
		"x": -46.5392444157,
		"y": 77.12116293,
		"h": 2.4175824176
	},
	{
		"stop_id": 8578227,
		"ID": 525,
		"x": -47.1132673017,
		"y": 76.893206412,
		"h": 2.4175824176
	},
	{
		"stop_id": 8578228,
		"ID": 525,
		"x": -47.2472925217,
		"y": 76.437171102,
		"h": 2.4175824176
	},
	{
		"stop_id": 8578229,
		"ID": 525,
		"x": -47.3422260487,
		"y": 76.130210077,
		"h": 2.4175824176
	},
	{
		"stop_id": 8578230,
		"ID": 525,
		"x": -47.4962673277,
		"y": 75.493240558,
		"h": 2.4175824176
	},
	{
		"stop_id": 8578232,
		"ID": 525,
		"x": -47.8332291587,
		"y": 74.621194665,
		"h": 2.4175824176
	},
	{
		"stop_id": 8578233,
		"ID": 525,
		"x": -47.9592360307,
		"y": 74.326191223,
		"h": 2.4175824176
	},
	{
		"stop_id": 8578234,
		"ID": 525,
		"x": -48.1222545497,
		"y": 74.057246874,
		"h": 2.4175824176
	},
	{
		"stop_id": 8578235,
		"ID": 525,
		"x": -48.3662614787,
		"y": 73.978167344,
		"h": 2.4175824176
	},
	{
		"stop_id": 8578236,
		"ID": 525,
		"x": -48.8282274847,
		"y": 73.956176943,
		"h": 2.4175824176
	},
	{
		"stop_id": 8579509,
		"ID": 525,
		"x": -47.2572594617,
		"y": 71.597144135,
		"h": 2.4175824176
	},
	{
		"stop_id": 8582727,
		"ID": 525,
		"x": -47.3642618937,
		"y": 74.875210516,
		"h": 2.4175824176
	},
	{
		"stop_id": 8582800,
		"ID": 525,
		"x": -48.0432559547,
		"y": 75.258204571,
		"h": 2.4175824176
	},
	{
		"stop_id": 8582801,
		"ID": 525,
		"x": -48.6842434207,
		"y": 75.438211107,
		"h": 2.4175824176
	},
	{
		"stop_id": 8583063,
		"ID": 525,
		"x": -46.1682741097,
		"y": 75.890167688,
		"h": 2.4175824176
	},
	{
		"stop_id": 8587228,
		"ID": 525,
		"x": -47.8032892937,
		"y": 75.068220486,
		"h": 2.4175824176
	},
	{
		"stop_id": 8588749,
		"ID": 525,
		"x": -46.8942311747,
		"y": 75.87421084,
		"h": 2.4175824176
	},
	{
		"stop_id": 8588750,
		"ID": 525,
		"x": -46.2352828457,
		"y": 76.750150468,
		"h": 2.4175824176
	},
	{
		"stop_id": 8588751,
		"ID": 525,
		"x": -46.8322965127,
		"y": 76.477195553,
		"h": 2.4175824176
	},
	{
		"stop_id": 8588752,
		"ID": 525,
		"x": -45.8782661167,
		"y": 76.302225588,
		"h": 2.4175824176
	},
	{
		"stop_id": 8588753,
		"ID": 525,
		"x": -46.0412641637,
		"y": 76.089148542,
		"h": 2.4175824176
	},
	{
		"stop_id": 8588754,
		"ID": 525,
		"x": -46.6402473127,
		"y": 75.965159482,
		"h": 2.4175824176
	},
	{
		"stop_id": 8588755,
		"ID": 525,
		"x": -46.2112993007,
		"y": 76.412199103,
		"h": 2.4175824176
	},
	{
		"stop_id": 8588758,
		"ID": 525,
		"x": -47.9582770457,
		"y": 76.125176814,
		"h": 2.4175824176
	},
	{
		"stop_id": 8588760,
		"ID": 525,
		"x": -47.8092343127,
		"y": 75.551199127,
		"h": 2.4175824176
	},
	{
		"stop_id": 8589055,
		"ID": 525,
		"x": -46.3402649957,
		"y": 77.114158968,
		"h": 2.4175824176
	},
	{
		"stop_id": 8589234,
		"ID": 525,
		"x": -47.9882388017,
		"y": 76.830148319,
		"h": 2.4175824176
	},
	{
		"stop_id": 8589264,
		"ID": 525,
		"x": -47.7442603557,
		"y": 76.937152054,
		"h": 2.4175824176
	},
	{
		"stop_id": 8500120,
		"ID": 368,
		"x": -68.8632688107,
		"y": 60.989216073,
		"h": 1.4615384615
	},
	{
		"stop_id": 8500121,
		"ID": 368,
		"x": -70.8882967037,
		"y": 60.131162597,
		"h": 1.4615384615
	},
	{
		"stop_id": 8500122,
		"ID": 368,
		"x": -74.2372423237,
		"y": 60.317228571,
		"h": 1.4615384615
	},
	{
		"stop_id": 8500668,
		"ID": 368,
		"x": -70.5042660657,
		"y": 62.693176448,
		"h": 1.4615384615
	},
	{
		"stop_id": 8500671,
		"ID": 368,
		"x": -70.8762331277,
		"y": 62.672188127,
		"h": 1.4615384615
	},
	{
		"stop_id": 8572013,
		"ID": 368,
		"x": -70.7652956407,
		"y": 62.366229823,
		"h": 1.4615384615
	},
	{
		"stop_id": 8572014,
		"ID": 368,
		"x": -71.2042425297,
		"y": 62.685158986,
		"h": 1.4615384615
	},
	{
		"stop_id": 8572021,
		"ID": 368,
		"x": -74.1952589287,
		"y": 60.332246133,
		"h": 1.4615384615
	},
	{
		"stop_id": 8582081,
		"ID": 368,
		"x": -68.9962667927,
		"y": 60.945173869,
		"h": 1.4615384615
	},
	{
		"stop_id": 8582148,
		"ID": 368,
		"x": -69.5092445467,
		"y": 60.717192949,
		"h": 1.4615384615
	},
	{
		"stop_id": 8582149,
		"ID": 368,
		"x": -70.8992318857,
		"y": 60.064141224,
		"h": 1.4615384615
	},
	{
		"stop_id": 8582150,
		"ID": 368,
		"x": -71.4302763147,
		"y": 60.06317014,
		"h": 1.4615384615
	},
	{
		"stop_id": 8582151,
		"ID": 368,
		"x": -71.8912581257,
		"y": 60.061212281,
		"h": 1.4615384615
	},
	{
		"stop_id": 8582152,
		"ID": 368,
		"x": -72.3442851517,
		"y": 60.068167737,
		"h": 1.4615384615
	},
	{
		"stop_id": 8582972,
		"ID": 368,
		"x": -73.7882436067,
		"y": 60.341157462,
		"h": 1.4615384615
	},
	{
		"stop_id": 8500123,
		"ID": 339,
		"x": -77.0752610017,
		"y": 60.160226092,
		"h": 1.4285714286
	},
	{
		"stop_id": 8500652,
		"ID": 339,
		"x": -75.0362472067,
		"y": 64.286210967,
		"h": 1.4285714286
	},
	{
		"stop_id": 8500659,
		"ID": 339,
		"x": -76.6862467247,
		"y": 61.632249701,
		"h": 1.4285714286
	},
	{
		"stop_id": 8500660,
		"ID": 339,
		"x": -75.7262934557,
		"y": 63.640182874,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572023,
		"ID": 339,
		"x": -76.6132416577,
		"y": 61.821160415,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572024,
		"ID": 339,
		"x": -76.4672848247,
		"y": 62.105147536,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572025,
		"ID": 339,
		"x": -75.7692694977,
		"y": 63.336216453,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572026,
		"ID": 339,
		"x": -75.0172534307,
		"y": 60.305188746,
		"h": 1.4285714286
	},
	{
		"stop_id": 8576779,
		"ID": 339,
		"x": -77.0972701057,
		"y": 60.155176447,
		"h": 1.4285714286
	},
	{
		"stop_id": 8581963,
		"ID": 339,
		"x": -74.8912568367,
		"y": 60.513217238,
		"h": 1.4285714286
	},
	{
		"stop_id": 8582084,
		"ID": 339,
		"x": -76.7622638777,
		"y": 61.396207678,
		"h": 1.4285714286
	},
	{
		"stop_id": 8582154,
		"ID": 339,
		"x": -77.1912478777,
		"y": 60.605181842,
		"h": 1.4285714286
	},
	{
		"stop_id": 8582973,
		"ID": 339,
		"x": -74.5222824057,
		"y": 60.48615327,
		"h": 1.4285714286
	},
	{
		"stop_id": 8583656,
		"ID": 339,
		"x": -75.1942257347,
		"y": 64.095167117,
		"h": 1.4285714286
	},
	{
		"stop_id": 8500124,
		"ID": 308,
		"x": -80.3392357017,
		"y": 63.783235985,
		"h": 1.3956043956
	},
	{
		"stop_id": 8500988,
		"ID": 308,
		"x": -81.1272388887,
		"y": 63.508193789,
		"h": 1.3956043956
	},
	{
		"stop_id": 8572034,
		"ID": 308,
		"x": -80.3162591797,
		"y": 63.787158403,
		"h": 1.3956043956
	},
	{
		"stop_id": 8572035,
		"ID": 308,
		"x": -81.5452545167,
		"y": 63.104240859,
		"h": 1.3956043956
	},
	{
		"stop_id": 8572036,
		"ID": 308,
		"x": -82.8182515347,
		"y": 62.815224493,
		"h": 1.3956043956
	},
	{
		"stop_id": 8572088,
		"ID": 308,
		"x": -82.7202855347,
		"y": 67.814190796,
		"h": 1.3956043956
	},
	{
		"stop_id": 8572089,
		"ID": 308,
		"x": -80.8382706097,
		"y": 68.331168802,
		"h": 1.3956043956
	},
	{
		"stop_id": 8572102,
		"ID": 308,
		"x": -80.3172911317,
		"y": 63.621166605,
		"h": 1.3956043956
	},
	{
		"stop_id": 8582085,
		"ID": 308,
		"x": -81.0652731367,
		"y": 63.64016554,
		"h": 1.3956043956
	},
	{
		"stop_id": 8582940,
		"ID": 308,
		"x": -80.7182518157,
		"y": 63.683172587,
		"h": 1.3956043956
	},
	{
		"stop_id": 8583306,
		"ID": 308,
		"x": -80.5282370407,
		"y": 68.023200418,
		"h": 1.3956043956
	},
	{
		"stop_id": 8583307,
		"ID": 308,
		"x": -80.0802545717,
		"y": 67.585242327,
		"h": 1.3956043956
	},
	{
		"stop_id": 8583350,
		"ID": 308,
		"x": -83.1252524057,
		"y": 68.311217871,
		"h": 1.3956043956
	},
	{
		"stop_id": 8500125,
		"ID": 276,
		"x": -83.4762515677,
		"y": 67.967170796,
		"h": 2.2527472527
	},
	{
		"stop_id": 8500126,
		"ID": 276,
		"x": -86.7982600017,
		"y": 69.726175056,
		"h": 2.2527472527
	},
	{
		"stop_id": 8572041,
		"ID": 276,
		"x": -86.8452955717,
		"y": 69.573178302,
		"h": 2.2527472527
	},
	{
		"stop_id": 8572042,
		"ID": 276,
		"x": -87.1482279717,
		"y": 69.275157082,
		"h": 2.2527472527
	},
	{
		"stop_id": 8572044,
		"ID": 276,
		"x": -87.8172433087,
		"y": 69.353240657,
		"h": 2.2527472527
	},
	{
		"stop_id": 8572045,
		"ID": 276,
		"x": -87.9212676077,
		"y": 69.520180138,
		"h": 2.2527472527
	},
	{
		"stop_id": 8572046,
		"ID": 276,
		"x": -88.2952987187,
		"y": 69.622155664,
		"h": 2.2527472527
	},
	{
		"stop_id": 8572054,
		"ID": 276,
		"x": -88.3892803437,
		"y": 69.600151802,
		"h": 2.2527472527
	},
	{
		"stop_id": 8572055,
		"ID": 276,
		"x": -87.8452320627,
		"y": 68.832140042,
		"h": 2.2527472527
	},
	{
		"stop_id": 8572078,
		"ID": 276,
		"x": -87.9352889347,
		"y": 68.670240065,
		"h": 2.2527472527
	},
	{
		"stop_id": 8572082,
		"ID": 276,
		"x": -86.8302943657,
		"y": 67.87621175,
		"h": 2.2527472527
	},
	{
		"stop_id": 8572083,
		"ID": 276,
		"x": -86.7742404497,
		"y": 67.210184282,
		"h": 2.2527472527
	},
	{
		"stop_id": 8572084,
		"ID": 276,
		"x": -86.7952904557,
		"y": 66.043184061,
		"h": 2.2527472527
	},
	{
		"stop_id": 8572085,
		"ID": 276,
		"x": -86.9292501877,
		"y": 69.253241381,
		"h": 2.2527472527
	},
	{
		"stop_id": 8572086,
		"ID": 276,
		"x": -83.8382270137,
		"y": 68.03223533,
		"h": 2.2527472527
	},
	{
		"stop_id": 8581833,
		"ID": 276,
		"x": -83.4732413547,
		"y": 67.946144915,
		"h": 2.2527472527
	},
	{
		"stop_id": 8581962,
		"ID": 276,
		"x": -86.9372609137,
		"y": 69.709246901,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582024,
		"ID": 276,
		"x": -87.0112631577,
		"y": 69.943187828,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582028,
		"ID": 276,
		"x": -87.4392591067,
		"y": 68.480211895,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582030,
		"ID": 276,
		"x": -87.1842354337,
		"y": 68.932208633,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582034,
		"ID": 276,
		"x": -87.4632817067,
		"y": 69.054148178,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582036,
		"ID": 276,
		"x": -87.7142897087,
		"y": 69.357199131,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582037,
		"ID": 276,
		"x": -87.0302666977,
		"y": 68.689223542,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582086,
		"ID": 276,
		"x": -85.8332305007,
		"y": 68.660238356,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582124,
		"ID": 276,
		"x": -87.7842791087,
		"y": 69.493176757,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582125,
		"ID": 276,
		"x": -87.8022747457,
		"y": 68.81914941,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582126,
		"ID": 276,
		"x": -86.9572771997,
		"y": 68.183219795,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582127,
		"ID": 276,
		"x": -86.5742419147,
		"y": 69.173231195,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582128,
		"ID": 276,
		"x": -85.9682682027,
		"y": 69.251226634,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582131,
		"ID": 276,
		"x": -86.5272484777,
		"y": 69.700144289,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582396,
		"ID": 276,
		"x": -87.7132512927,
		"y": 68.350195234,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582397,
		"ID": 276,
		"x": -87.2222960937,
		"y": 69.008213645,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582766,
		"ID": 276,
		"x": -87.3982823047,
		"y": 69.33224965,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582767,
		"ID": 276,
		"x": -87.2592865757,
		"y": 68.763224027,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582986,
		"ID": 276,
		"x": -86.8752754227,
		"y": 67.500171148,
		"h": 2.2527472527
	},
	{
		"stop_id": 8583349,
		"ID": 276,
		"x": -85.4302952967,
		"y": 68.534166317,
		"h": 2.2527472527
	},
	{
		"stop_id": 8583351,
		"ID": 276,
		"x": -86.3112358797,
		"y": 69.475241549,
		"h": 2.2527472527
	},
	{
		"stop_id": 8583437,
		"ID": 276,
		"x": -89.6252707307,
		"y": 68.439173825,
		"h": 2.2527472527
	},
	{
		"stop_id": 8583657,
		"ID": 276,
		"x": -87.0172583017,
		"y": 69.250200803,
		"h": 2.2527472527
	},
	{
		"stop_id": 8500127,
		"ID": 277,
		"x": -88.6432761157,
		"y": 73.621193461,
		"h": 1.4285714286
	},
	{
		"stop_id": 8500143,
		"ID": 277,
		"x": -89.1842280977,
		"y": 75.186151305,
		"h": 1.4285714286
	},
	{
		"stop_id": 8500677,
		"ID": 277,
		"x": -85.0252705167,
		"y": 75.629159751,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572068,
		"ID": 277,
		"x": -85.3932388607,
		"y": 72.836197261,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572069,
		"ID": 277,
		"x": -85.3622765667,
		"y": 73.279249072,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572070,
		"ID": 277,
		"x": -85.0932400467,
		"y": 76.091209967,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572071,
		"ID": 277,
		"x": -85.1882841637,
		"y": 76.32021966,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572072,
		"ID": 277,
		"x": -85.3622327687,
		"y": 76.758160344,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572073,
		"ID": 277,
		"x": -84.9322306247,
		"y": 76.990243703,
		"h": 1.4285714286
	},
	{
		"stop_id": 8581834,
		"ID": 277,
		"x": -88.6722544237,
		"y": 73.663141574,
		"h": 1.4285714286
	},
	{
		"stop_id": 8582088,
		"ID": 277,
		"x": -89.2302644947,
		"y": 73.925191895,
		"h": 1.4285714286
	},
	{
		"stop_id": 8582143,
		"ID": 277,
		"x": -89.2452436687,
		"y": 74.488203936,
		"h": 1.4285714286
	},
	{
		"stop_id": 8583671,
		"ID": 277,
		"x": -85.3962380277,
		"y": 72.528226093,
		"h": 1.4285714286
	},
	{
		"stop_id": 8583779,
		"ID": 277,
		"x": -89.0242879207,
		"y": 73.614178099,
		"h": 1.4285714286
	},
	{
		"stop_id": 8500128,
		"ID": 245,
		"x": -91.5492862757,
		"y": 77.723168165,
		"h": 1.2967032967
	},
	{
		"stop_id": 8500130,
		"ID": 245,
		"x": -92.0762367087,
		"y": 79.213177132,
		"h": 1.2967032967
	},
	{
		"stop_id": 8500144,
		"ID": 245,
		"x": -90.5462487777,
		"y": 76.239157911,
		"h": 1.2967032967
	},
	{
		"stop_id": 8500662,
		"ID": 245,
		"x": -88.3302639447,
		"y": 77.11515764,
		"h": 1.2967032967
	},
	{
		"stop_id": 8580738,
		"ID": 245,
		"x": -90.4882260937,
		"y": 76.380174077,
		"h": 1.2967032967
	},
	{
		"stop_id": 8582074,
		"ID": 245,
		"x": -89.2282284837,
		"y": 75.282214224,
		"h": 1.2967032967
	},
	{
		"stop_id": 8582089,
		"ID": 245,
		"x": -88.3292842037,
		"y": 77.115152888,
		"h": 1.2967032967
	},
	{
		"stop_id": 8582145,
		"ID": 245,
		"x": -91.5292445807,
		"y": 77.834247946,
		"h": 1.2967032967
	},
	{
		"stop_id": 8582146,
		"ID": 245,
		"x": -91.7462845917,
		"y": 78.096158203,
		"h": 1.2967032967
	},
	{
		"stop_id": 8582147,
		"ID": 245,
		"x": -91.9962421617,
		"y": 78.136214154,
		"h": 1.2967032967
	},
	{
		"stop_id": 8500141,
		"ID": 244,
		"x": -88.4812709927,
		"y": 71.83019726,
		"h": 1.1978021978
	},
	{
		"stop_id": 8572047,
		"ID": 244,
		"x": -90.8222686277,
		"y": 70.445240692,
		"h": 1.1978021978
	},
	{
		"stop_id": 8572048,
		"ID": 244,
		"x": -92.1972549977,
		"y": 71.634212643,
		"h": 1.1978021978
	},
	{
		"stop_id": 8572050,
		"ID": 244,
		"x": -92.1512590537,
		"y": 72.468188799,
		"h": 1.1978021978
	},
	{
		"stop_id": 8582087,
		"ID": 244,
		"x": -88.6022517987,
		"y": 71.864143597,
		"h": 1.1978021978
	},
	{
		"stop_id": 8583303,
		"ID": 244,
		"x": -92.0082761557,
		"y": 73.277174982,
		"h": 1.1978021978
	},
	{
		"stop_id": 8583304,
		"ID": 244,
		"x": -92.3512249077,
		"y": 72.002197658,
		"h": 1.1978021978
	},
	{
		"stop_id": 8500159,
		"ID": 425,
		"x": -63.4682990167,
		"y": 44.193212115,
		"h": 3.8351648352
	},
	{
		"stop_id": 8500202,
		"ID": 425,
		"x": -62.8082416957,
		"y": 43.855184086,
		"h": 3.8351648352
	},
	{
		"stop_id": 8500203,
		"ID": 425,
		"x": -60.5202268157,
		"y": 44.541152772,
		"h": 3.8351648352
	},
	{
		"stop_id": 8504363,
		"ID": 425,
		"x": -60.9632403307,
		"y": 42.092243318,
		"h": 3.8351648352
	},
	{
		"stop_id": 8504365,
		"ID": 425,
		"x": -58.9652330757,
		"y": 44.034169062,
		"h": 3.8351648352
	},
	{
		"stop_id": 8577913,
		"ID": 425,
		"x": -63.0422357597,
		"y": 44.330146736,
		"h": 3.8351648352
	},
	{
		"stop_id": 8577914,
		"ID": 425,
		"x": -62.7942265297,
		"y": 43.844170241,
		"h": 3.8351648352
	},
	{
		"stop_id": 8577915,
		"ID": 425,
		"x": -62.7712764257,
		"y": 43.672168444,
		"h": 3.8351648352
	},
	{
		"stop_id": 8577916,
		"ID": 425,
		"x": -62.6302581567,
		"y": 43.461195116,
		"h": 3.8351648352
	},
	{
		"stop_id": 8577917,
		"ID": 425,
		"x": -61.2412867827,
		"y": 42.205153894,
		"h": 3.8351648352
	},
	{
		"stop_id": 8577918,
		"ID": 425,
		"x": -60.8952907547,
		"y": 41.466197833,
		"h": 3.8351648352
	},
	{
		"stop_id": 8577923,
		"ID": 425,
		"x": -58.5392911827,
		"y": 42.330237687,
		"h": 3.8351648352
	},
	{
		"stop_id": 8577927,
		"ID": 425,
		"x": -60.9412314357,
		"y": 41.139239712,
		"h": 3.8351648352
	},
	{
		"stop_id": 8577928,
		"ID": 425,
		"x": -61.1112662307,
		"y": 40.981186733,
		"h": 3.8351648352
	},
	{
		"stop_id": 8577934,
		"ID": 425,
		"x": -62.3202886727,
		"y": 39.828156975,
		"h": 3.8351648352
	},
	{
		"stop_id": 8577935,
		"ID": 425,
		"x": -60.5702537007,
		"y": 41.461247968,
		"h": 3.8351648352
	},
	{
		"stop_id": 8577936,
		"ID": 425,
		"x": -62.2642980747,
		"y": 41.786156996,
		"h": 3.8351648352
	},
	{
		"stop_id": 8577937,
		"ID": 425,
		"x": -62.0692632657,
		"y": 41.316246217,
		"h": 3.8351648352
	},
	{
		"stop_id": 8577938,
		"ID": 425,
		"x": -62.1222971337,
		"y": 41.04822327,
		"h": 3.8351648352
	},
	{
		"stop_id": 8577940,
		"ID": 425,
		"x": -63.1202348987,
		"y": 44.820146491,
		"h": 3.8351648352
	},
	{
		"stop_id": 8577941,
		"ID": 425,
		"x": -63.2122992507,
		"y": 44.573166357,
		"h": 3.8351648352
	},
	{
		"stop_id": 8577942,
		"ID": 425,
		"x": -63.2562674867,
		"y": 44.421214446,
		"h": 3.8351648352
	},
	{
		"stop_id": 8577943,
		"ID": 425,
		"x": -63.4422691307,
		"y": 44.130158494,
		"h": 3.8351648352
	},
	{
		"stop_id": 8577944,
		"ID": 425,
		"x": -63.8322782137,
		"y": 43.781213903,
		"h": 3.8351648352
	},
	{
		"stop_id": 8577945,
		"ID": 425,
		"x": -64.1422602017,
		"y": 43.57820883,
		"h": 3.8351648352
	},
	{
		"stop_id": 8577962,
		"ID": 425,
		"x": -62.6372822457,
		"y": 44.421206555,
		"h": 3.8351648352
	},
	{
		"stop_id": 8577963,
		"ID": 425,
		"x": -62.2022413007,
		"y": 44.725184144,
		"h": 3.8351648352
	},
	{
		"stop_id": 8577964,
		"ID": 425,
		"x": -61.8062899227,
		"y": 44.548146683,
		"h": 3.8351648352
	},
	{
		"stop_id": 8577965,
		"ID": 425,
		"x": -60.4312915147,
		"y": 44.893236829,
		"h": 3.8351648352
	},
	{
		"stop_id": 8577966,
		"ID": 425,
		"x": -59.5802570087,
		"y": 45.048168864,
		"h": 3.8351648352
	},
	{
		"stop_id": 8587325,
		"ID": 425,
		"x": -60.4662952997,
		"y": 41.535165005,
		"h": 3.8351648352
	},
	{
		"stop_id": 8587445,
		"ID": 425,
		"x": -60.5422804657,
		"y": 44.530149496,
		"h": 3.8351648352
	},
	{
		"stop_id": 8588208,
		"ID": 425,
		"x": -60.7852410217,
		"y": 45.290193365,
		"h": 3.8351648352
	},
	{
		"stop_id": 8588209,
		"ID": 425,
		"x": -60.6992758467,
		"y": 45.09117161,
		"h": 3.8351648352
	},
	{
		"stop_id": 8588464,
		"ID": 425,
		"x": -62.0712877037,
		"y": 43.43615061,
		"h": 3.8351648352
	},
	{
		"stop_id": 8588465,
		"ID": 425,
		"x": -61.9162849677,
		"y": 43.04419392,
		"h": 3.8351648352
	},
	{
		"stop_id": 8588645,
		"ID": 425,
		"x": -62.9052302277,
		"y": 43.755177405,
		"h": 3.8351648352
	},
	{
		"stop_id": 8588646,
		"ID": 425,
		"x": -63.3042695237,
		"y": 43.625220628,
		"h": 3.8351648352
	},
	{
		"stop_id": 8589213,
		"ID": 425,
		"x": -62.2342468017,
		"y": 43.78420047,
		"h": 3.8351648352
	},
	{
		"stop_id": 8589214,
		"ID": 425,
		"x": -62.4492509417,
		"y": 43.971184602,
		"h": 3.8351648352
	},
	{
		"stop_id": 8589867,
		"ID": 425,
		"x": -60.6662854647,
		"y": 41.649150349,
		"h": 3.8351648352
	},
	{
		"stop_id": 8593864,
		"ID": 425,
		"x": -61.1452613437,
		"y": 45.153191046,
		"h": 3.8351648352
	},
	{
		"stop_id": 8593902,
		"ID": 425,
		"x": -61.4792379817,
		"y": 45.245226502,
		"h": 3.8351648352
	},
	{
		"stop_id": 8594090,
		"ID": 425,
		"x": -61.4122396367,
		"y": 44.785157593,
		"h": 3.8351648352
	},
	{
		"stop_id": 8594092,
		"ID": 425,
		"x": -60.6292486607,
		"y": 44.701152399,
		"h": 3.8351648352
	},
	{
		"stop_id": 8594095,
		"ID": 425,
		"x": -61.1072925647,
		"y": 44.868236051,
		"h": 3.8351648352
	},
	{
		"stop_id": 8594096,
		"ID": 425,
		"x": -61.5012976697,
		"y": 44.966179874,
		"h": 3.8351648352
	},
	{
		"stop_id": 8594097,
		"ID": 425,
		"x": -60.3622799087,
		"y": 44.721238229,
		"h": 3.8351648352
	},
	{
		"stop_id": 8594099,
		"ID": 425,
		"x": -61.1492890257,
		"y": 45.410232558,
		"h": 3.8351648352
	},
	{
		"stop_id": 8594102,
		"ID": 425,
		"x": -63.0122417057,
		"y": 45.379192171,
		"h": 3.8351648352
	},
	{
		"stop_id": 8594104,
		"ID": 425,
		"x": -62.9262873417,
		"y": 44.884185905,
		"h": 3.8351648352
	},
	{
		"stop_id": 8594105,
		"ID": 425,
		"x": -62.6532278867,
		"y": 44.811221827,
		"h": 3.8351648352
	},
	{
		"stop_id": 8594106,
		"ID": 425,
		"x": -62.2442844977,
		"y": 44.931212427,
		"h": 3.8351648352
	},
	{
		"stop_id": 8594107,
		"ID": 425,
		"x": -63.6652495117,
		"y": 44.439152476,
		"h": 3.8351648352
	},
	{
		"stop_id": 8594108,
		"ID": 425,
		"x": -63.4912545907,
		"y": 44.322191524,
		"h": 3.8351648352
	},
	{
		"stop_id": 8594110,
		"ID": 425,
		"x": -61.9642469657,
		"y": 43.682141393,
		"h": 3.8351648352
	},
	{
		"stop_id": 8594111,
		"ID": 425,
		"x": -63.3422922647,
		"y": 44.646177103,
		"h": 3.8351648352
	},
	{
		"stop_id": 8594112,
		"ID": 425,
		"x": -63.4672440837,
		"y": 43.472232812,
		"h": 3.8351648352
	},
	{
		"stop_id": 8594113,
		"ID": 425,
		"x": -62.3952825727,
		"y": 44.15315536,
		"h": 3.8351648352
	},
	{
		"stop_id": 8594115,
		"ID": 425,
		"x": -61.8752966537,
		"y": 44.830226801,
		"h": 3.8351648352
	},
	{
		"stop_id": 8594116,
		"ID": 425,
		"x": -63.6692577597,
		"y": 44.226141044,
		"h": 3.8351648352
	},
	{
		"stop_id": 8594117,
		"ID": 425,
		"x": -62.7422469317,
		"y": 44.261165797,
		"h": 3.8351648352
	},
	{
		"stop_id": 8594119,
		"ID": 425,
		"x": -62.5862674397,
		"y": 45.375187743,
		"h": 3.8351648352
	},
	{
		"stop_id": 8594121,
		"ID": 425,
		"x": -62.8502592357,
		"y": 44.506144421,
		"h": 3.8351648352
	},
	{
		"stop_id": 8594122,
		"ID": 425,
		"x": -62.6222575777,
		"y": 44.766179841,
		"h": 3.8351648352
	},
	{
		"stop_id": 8594123,
		"ID": 425,
		"x": -63.9622731157,
		"y": 43.760182887,
		"h": 3.8351648352
	},
	{
		"stop_id": 8594124,
		"ID": 425,
		"x": -62.5522847037,
		"y": 45.141144212,
		"h": 3.8351648352
	},
	{
		"stop_id": 8594125,
		"ID": 425,
		"x": -61.7062508777,
		"y": 44.354219755,
		"h": 3.8351648352
	},
	{
		"stop_id": 8594126,
		"ID": 425,
		"x": -62.0242635307,
		"y": 44.281183168,
		"h": 3.8351648352
	},
	{
		"stop_id": 8594127,
		"ID": 425,
		"x": -63.8402354057,
		"y": 43.998235755,
		"h": 3.8351648352
	},
	{
		"stop_id": 8594130,
		"ID": 425,
		"x": -62.5642633297,
		"y": 44.972161537,
		"h": 3.8351648352
	},
	{
		"stop_id": 8594131,
		"ID": 425,
		"x": -62.3902429617,
		"y": 44.401187707,
		"h": 3.8351648352
	},
	{
		"stop_id": 8594132,
		"ID": 425,
		"x": -61.5492719207,
		"y": 43.980170558,
		"h": 3.8351648352
	},
	{
		"stop_id": 8594133,
		"ID": 425,
		"x": -61.9332511767,
		"y": 45.067165962,
		"h": 3.8351648352
	},
	{
		"stop_id": 8594134,
		"ID": 425,
		"x": -63.0022722867,
		"y": 44.24118302,
		"h": 3.8351648352
	},
	{
		"stop_id": 8594135,
		"ID": 425,
		"x": -62.7872513397,
		"y": 45.293241406,
		"h": 3.8351648352
	},
	{
		"stop_id": 8594136,
		"ID": 425,
		"x": -63.0182585697,
		"y": 45.055226687,
		"h": 3.8351648352
	},
	{
		"stop_id": 8594137,
		"ID": 425,
		"x": -63.4852696307,
		"y": 43.96520017,
		"h": 3.8351648352
	},
	{
		"stop_id": 8594138,
		"ID": 425,
		"x": -61.6202673037,
		"y": 43.802200109,
		"h": 3.8351648352
	},
	{
		"stop_id": 8594139,
		"ID": 425,
		"x": -61.7772961347,
		"y": 44.677212275,
		"h": 3.8351648352
	},
	{
		"stop_id": 8594140,
		"ID": 425,
		"x": -63.1812560167,
		"y": 43.37422183,
		"h": 3.8351648352
	},
	{
		"stop_id": 8594143,
		"ID": 425,
		"x": -63.7912656917,
		"y": 43.905146951,
		"h": 3.8351648352
	},
	{
		"stop_id": 8594144,
		"ID": 425,
		"x": -62.1742962727,
		"y": 43.606181637,
		"h": 3.8351648352
	},
	{
		"stop_id": 8594145,
		"ID": 425,
		"x": -63.0952993167,
		"y": 45.223147385,
		"h": 3.8351648352
	},
	{
		"stop_id": 8594146,
		"ID": 425,
		"x": -62.7762367107,
		"y": 44.18725114,
		"h": 3.8351648352
	},
	{
		"stop_id": 8594150,
		"ID": 425,
		"x": -63.0232845327,
		"y": 43.53422438,
		"h": 3.8351648352
	},
	{
		"stop_id": 8594302,
		"ID": 425,
		"x": -63.1082378927,
		"y": 44.731198271,
		"h": 3.8351648352
	},
	{
		"stop_id": 8500162,
		"ID": 272,
		"x": -84.4302311227,
		"y": 47.649189104,
		"h": 1.4945054945
	},
	{
		"stop_id": 8500164,
		"ID": 272,
		"x": -85.9622624577,
		"y": 47.769176817,
		"h": 1.4945054945
	},
	{
		"stop_id": 8500170,
		"ID": 272,
		"x": -84.9682657477,
		"y": 47.693148788,
		"h": 1.4945054945
	},
	{
		"stop_id": 8500171,
		"ID": 272,
		"x": -86.6432913177,
		"y": 47.859172891,
		"h": 1.4945054945
	},
	{
		"stop_id": 8500888,
		"ID": 272,
		"x": -86.3702666257,
		"y": 48.327223484,
		"h": 1.4945054945
	},
	{
		"stop_id": 8500889,
		"ID": 272,
		"x": -85.6002662947,
		"y": 47.707215154,
		"h": 1.4945054945
	},
	{
		"stop_id": 8500890,
		"ID": 272,
		"x": -88.8902475477,
		"y": 46.306190727,
		"h": 1.4945054945
	},
	{
		"stop_id": 8504306,
		"ID": 272,
		"x": -84.8532394137,
		"y": 43.970204011,
		"h": 1.4945054945
	},
	{
		"stop_id": 8571923,
		"ID": 272,
		"x": -85.1232826227,
		"y": 47.699147796,
		"h": 1.4945054945
	},
	{
		"stop_id": 8571925,
		"ID": 272,
		"x": -86.0442454137,
		"y": 47.830243803,
		"h": 1.4945054945
	},
	{
		"stop_id": 8571926,
		"ID": 272,
		"x": -86.6512952457,
		"y": 47.881222595,
		"h": 1.4945054945
	},
	{
		"stop_id": 8571927,
		"ID": 272,
		"x": -87.1352973757,
		"y": 48.104242209,
		"h": 1.4945054945
	},
	{
		"stop_id": 8576766,
		"ID": 272,
		"x": -87.8102333797,
		"y": 46.831184717,
		"h": 1.4945054945
	},
	{
		"stop_id": 8576767,
		"ID": 272,
		"x": -88.3522716437,
		"y": 46.59018602,
		"h": 1.4945054945
	},
	{
		"stop_id": 8592364,
		"ID": 272,
		"x": -84.6542713747,
		"y": 47.776203688,
		"h": 1.4945054945
	},
	{
		"stop_id": 8594281,
		"ID": 272,
		"x": -86.7722712397,
		"y": 47.777154575,
		"h": 1.4945054945
	},
	{
		"stop_id": 8500165,
		"ID": 240,
		"x": -88.7022840097,
		"y": 47.624178767,
		"h": 1.5274725275
	},
	{
		"stop_id": 8500167,
		"ID": 240,
		"x": -92.7882741347,
		"y": 46.653178662,
		"h": 1.5274725275
	},
	{
		"stop_id": 8500172,
		"ID": 240,
		"x": -91.0572910217,
		"y": 47.450157471,
		"h": 1.5274725275
	},
	{
		"stop_id": 8500173,
		"ID": 240,
		"x": -92.5812242497,
		"y": 46.354179989,
		"h": 1.5274725275
	},
	{
		"stop_id": 8500190,
		"ID": 240,
		"x": -94.0702772787,
		"y": 48.799219408,
		"h": 1.5274725275
	},
	{
		"stop_id": 8500700,
		"ID": 240,
		"x": -90.0262838407,
		"y": 49.724188958,
		"h": 1.5274725275
	},
	{
		"stop_id": 8500756,
		"ID": 240,
		"x": -90.8552555377,
		"y": 50.035230058,
		"h": 1.5274725275
	},
	{
		"stop_id": 8500891,
		"ID": 240,
		"x": -89.6572414137,
		"y": 45.915219427,
		"h": 1.5274725275
	},
	{
		"stop_id": 8571930,
		"ID": 240,
		"x": -89.1112261827,
		"y": 49.104203632,
		"h": 1.5274725275
	},
	{
		"stop_id": 8571931,
		"ID": 240,
		"x": -91.4922512207,
		"y": 51.00420597,
		"h": 1.5274725275
	},
	{
		"stop_id": 8571932,
		"ID": 240,
		"x": -92.0172854037,
		"y": 50.980250092,
		"h": 1.5274725275
	},
	{
		"stop_id": 8571933,
		"ID": 240,
		"x": -92.6712802327,
		"y": 51.031213313,
		"h": 1.5274725275
	},
	{
		"stop_id": 8576768,
		"ID": 240,
		"x": -92.0952727507,
		"y": 46.207197351,
		"h": 1.5274725275
	},
	{
		"stop_id": 8576769,
		"ID": 240,
		"x": -92.5542430367,
		"y": 46.356142939,
		"h": 1.5274725275
	},
	{
		"stop_id": 8588189,
		"ID": 240,
		"x": -90.9142474337,
		"y": 46.161176657,
		"h": 1.5274725275
	},
	{
		"stop_id": 8591844,
		"ID": 240,
		"x": -94.1132254337,
		"y": 48.732204854,
		"h": 1.5274725275
	},
	{
		"stop_id": 8595507,
		"ID": 240,
		"x": -94.0282432327,
		"y": 48.826214966,
		"h": 1.5274725275
	},
	{
		"stop_id": 8500169,
		"ID": 208,
		"x": -94.0512353597,
		"y": 50.060219379,
		"h": 1.3296703297
	},
	{
		"stop_id": 8500191,
		"ID": 208,
		"x": -93.3602658057,
		"y": 51.277234555,
		"h": 1.3296703297
	},
	{
		"stop_id": 8500759,
		"ID": 208,
		"x": -96.5552909007,
		"y": 52.043143294,
		"h": 1.3296703297
	},
	{
		"stop_id": 8571934,
		"ID": 208,
		"x": -93.3892825037,
		"y": 51.286182576,
		"h": 1.3296703297
	},
	{
		"stop_id": 8571935,
		"ID": 208,
		"x": -94.1922672517,
		"y": 52.887237753,
		"h": 1.3296703297
	},
	{
		"stop_id": 8571936,
		"ID": 208,
		"x": -95.8812387527,
		"y": 51.035143999,
		"h": 1.3296703297
	},
	{
		"stop_id": 8571937,
		"ID": 208,
		"x": -96.7272561637,
		"y": 51.206247404,
		"h": 1.3296703297
	},
	{
		"stop_id": 8583658,
		"ID": 208,
		"x": -93.5352554547,
		"y": 51.745186991,
		"h": 1.3296703297
	},
	{
		"stop_id": 8583659,
		"ID": 208,
		"x": -93.3382501687,
		"y": 51.435207632,
		"h": 1.3296703297
	},
	{
		"stop_id": 8591845,
		"ID": 208,
		"x": -94.5362816797,
		"y": 50.454179512,
		"h": 1.3296703297
	},
	{
		"stop_id": 8594495,
		"ID": 208,
		"x": -94.0692317427,
		"y": 50.064214938,
		"h": 1.3296703297
	},
	{
		"stop_id": 8500174,
		"ID": 207,
		"x": -96.2312928217,
		"y": 47.8482073,
		"h": 1.0989010989
	},
	{
		"stop_id": 8500175,
		"ID": 207,
		"x": -97.4732339737,
		"y": 45.60816111,
		"h": 1.0989010989
	},
	{
		"stop_id": 8500176,
		"ID": 207,
		"x": -98.8852414917,
		"y": 44.592244013,
		"h": 1.0989010989
	},
	{
		"stop_id": 8591843,
		"ID": 207,
		"x": -96.2122800477,
		"y": 47.836194066,
		"h": 1.0989010989
	},
	{
		"stop_id": 8500177,
		"ID": 179,
		"x": -100.1052236977,
		"y": 42.672247207,
		"h": 1.1318681319
	},
	{
		"stop_id": 8500180,
		"ID": 179,
		"x": -100.8352806027,
		"y": 40.93820528,
		"h": 1.1318681319
	},
	{
		"stop_id": 8500181,
		"ID": 179,
		"x": -100.6892650997,
		"y": 39.988179411,
		"h": 1.1318681319
	},
	{
		"stop_id": 8504394,
		"ID": 179,
		"x": -103.7302955617,
		"y": 41.238237397,
		"h": 1.1318681319
	},
	{
		"stop_id": 8595676,
		"ID": 179,
		"x": -100.2102973037,
		"y": 42.627157432,
		"h": 1.1318681319
	},
	{
		"stop_id": 8500178,
		"ID": 178,
		"x": -101.0142493187,
		"y": 38.875204408,
		"h": 1.0989010989
	},
	{
		"stop_id": 8500179,
		"ID": 178,
		"x": -101.8552839257,
		"y": 36.594186595,
		"h": 1.0989010989
	},
	{
		"stop_id": 8504312,
		"ID": 178,
		"x": -98.6872576587,
		"y": 36.972247694,
		"h": 1.0989010989
	},
	{
		"stop_id": 8591840,
		"ID": 178,
		"x": -101.1122554827,
		"y": 38.973167165,
		"h": 1.0989010989
	},
	{
		"stop_id": 8500184,
		"ID": 155,
		"x": -105.3992344167,
		"y": 34.548242703,
		"h": 4.5934065934
	},
	{
		"stop_id": 8504314,
		"ID": 155,
		"x": -106.2492803377,
		"y": 34.01718075,
		"h": 4.5934065934
	},
	{
		"stop_id": 8504381,
		"ID": 155,
		"x": -105.6652423747,
		"y": 34.134155591,
		"h": 4.5934065934
	},
	{
		"stop_id": 8504382,
		"ID": 155,
		"x": -104.8882866187,
		"y": 32.717142405,
		"h": 4.5934065934
	},
	{
		"stop_id": 8504739,
		"ID": 155,
		"x": -105.4662561647,
		"y": 36.492143168,
		"h": 4.5934065934
	},
	{
		"stop_id": 8504764,
		"ID": 155,
		"x": -106.3802379587,
		"y": 34.02721243,
		"h": 4.5934065934
	},
	{
		"stop_id": 8571883,
		"ID": 155,
		"x": -105.9692806617,
		"y": 34.477160626,
		"h": 4.5934065934
	},
	{
		"stop_id": 8571884,
		"ID": 155,
		"x": -105.8752687447,
		"y": 34.481210633,
		"h": 4.5934065934
	},
	{
		"stop_id": 8571885,
		"ID": 155,
		"x": -105.8592421857,
		"y": 34.981162697,
		"h": 4.5934065934
	},
	{
		"stop_id": 8571886,
		"ID": 155,
		"x": -105.5642900027,
		"y": 35.490186404,
		"h": 4.5934065934
	},
	{
		"stop_id": 8571887,
		"ID": 155,
		"x": -105.5662402517,
		"y": 36.044199961,
		"h": 4.5934065934
	},
	{
		"stop_id": 8571890,
		"ID": 155,
		"x": -107.5162713447,
		"y": 36.616230583,
		"h": 4.5934065934
	},
	{
		"stop_id": 8571891,
		"ID": 155,
		"x": -107.8192593407,
		"y": 36.141164764,
		"h": 4.5934065934
	},
	{
		"stop_id": 8571892,
		"ID": 155,
		"x": -108.0962678537,
		"y": 36.290168135,
		"h": 4.5934065934
	},
	{
		"stop_id": 8579720,
		"ID": 155,
		"x": -107.5422567197,
		"y": 33.13023748,
		"h": 4.5934065934
	},
	{
		"stop_id": 8579721,
		"ID": 155,
		"x": -107.2072577027,
		"y": 32.977241086,
		"h": 4.5934065934
	},
	{
		"stop_id": 8579722,
		"ID": 155,
		"x": -106.6422846557,
		"y": 33.5301993,
		"h": 4.5934065934
	},
	{
		"stop_id": 8583702,
		"ID": 155,
		"x": -107.1592477007,
		"y": 36.718210981,
		"h": 4.5934065934
	},
	{
		"stop_id": 8587358,
		"ID": 155,
		"x": -107.4422989527,
		"y": 32.680166813,
		"h": 4.5934065934
	},
	{
		"stop_id": 8587361,
		"ID": 155,
		"x": -106.7602644487,
		"y": 33.771163509,
		"h": 4.5934065934
	},
	{
		"stop_id": 8587364,
		"ID": 155,
		"x": -108.4252916997,
		"y": 32.458221168,
		"h": 4.5934065934
	},
	{
		"stop_id": 8587721,
		"ID": 155,
		"x": -107.9732296887,
		"y": 32.785177695,
		"h": 4.5934065934
	},
	{
		"stop_id": 8588214,
		"ID": 155,
		"x": -108.1012259377,
		"y": 32.378196663,
		"h": 4.5934065934
	},
	{
		"stop_id": 8589282,
		"ID": 155,
		"x": -106.9702781017,
		"y": 33.607174335,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593624,
		"ID": 155,
		"x": -108.1032794427,
		"y": 32.69518003,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593625,
		"ID": 155,
		"x": -107.8562675847,
		"y": 33.238167269,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593626,
		"ID": 155,
		"x": -107.8362315997,
		"y": 33.143170736,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593627,
		"ID": 155,
		"x": -107.6942534727,
		"y": 33.358152607,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593629,
		"ID": 155,
		"x": -107.5682906257,
		"y": 33.103208435,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593630,
		"ID": 155,
		"x": -107.5662899667,
		"y": 34.031190997,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593631,
		"ID": 155,
		"x": -107.5212678397,
		"y": 33.219233011,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593632,
		"ID": 155,
		"x": -107.4952804777,
		"y": 34.138239919,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593633,
		"ID": 155,
		"x": -107.4942466617,
		"y": 33.85117107,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593634,
		"ID": 155,
		"x": -107.4842378037,
		"y": 33.528231133,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593635,
		"ID": 155,
		"x": -107.2732728517,
		"y": 33.619151067,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593636,
		"ID": 155,
		"x": -107.2402772207,
		"y": 33.957200436,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593637,
		"ID": 155,
		"x": -107.2162929247,
		"y": 32.844234001,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593638,
		"ID": 155,
		"x": -107.1472796217,
		"y": 33.728210471,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593639,
		"ID": 155,
		"x": -107.0642771707,
		"y": 33.101175515,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593640,
		"ID": 155,
		"x": -107.0542583687,
		"y": 32.862175732,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593641,
		"ID": 155,
		"x": -107.0452314667,
		"y": 34.101176145,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593642,
		"ID": 155,
		"x": -106.9982521297,
		"y": 34.357177862,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593643,
		"ID": 155,
		"x": -106.9842389687,
		"y": 33.866217594,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593644,
		"ID": 155,
		"x": -106.9822550947,
		"y": 34.297237128,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593645,
		"ID": 155,
		"x": -106.9432244627,
		"y": 34.585210524,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593646,
		"ID": 155,
		"x": -106.9122651067,
		"y": 34.220190992,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593647,
		"ID": 155,
		"x": -106.8462866187,
		"y": 33.991197842,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593648,
		"ID": 155,
		"x": -106.8362459077,
		"y": 34.300191793,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593649,
		"ID": 155,
		"x": -106.7892375437,
		"y": 33.343248667,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593650,
		"ID": 155,
		"x": -106.7732918737,
		"y": 34.504148781,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593651,
		"ID": 155,
		"x": -106.7062989497,
		"y": 34.038229765,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593652,
		"ID": 155,
		"x": -106.7022337487,
		"y": 32.919197502,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593653,
		"ID": 155,
		"x": -106.7862480537,
		"y": 34.766185833,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593654,
		"ID": 155,
		"x": -106.6532459707,
		"y": 34.219141235,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593655,
		"ID": 155,
		"x": -106.5612666257,
		"y": 33.444176313,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593656,
		"ID": 155,
		"x": -106.5612293407,
		"y": 32.986236794,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593657,
		"ID": 155,
		"x": -106.5292532887,
		"y": 34.964165293,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593658,
		"ID": 155,
		"x": -106.5282396827,
		"y": 34.090190452,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593660,
		"ID": 155,
		"x": -106.4882767247,
		"y": 35.300155309,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593661,
		"ID": 155,
		"x": -106.4652715057,
		"y": 35.156221567,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593663,
		"ID": 155,
		"x": -106.3882352227,
		"y": 34.691227287,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593665,
		"ID": 155,
		"x": -106.2942746517,
		"y": 34.592209459,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593666,
		"ID": 155,
		"x": -106.2742316087,
		"y": 33.390224649,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593667,
		"ID": 155,
		"x": -106.2682755797,
		"y": 34.90719427,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593669,
		"ID": 155,
		"x": -106.2582425367,
		"y": 33.095146258,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593670,
		"ID": 155,
		"x": -106.2502624667,
		"y": 34.231205004,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593671,
		"ID": 155,
		"x": -106.2452936407,
		"y": 35.506150868,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593673,
		"ID": 155,
		"x": -106.1662335707,
		"y": 35.279174755,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593675,
		"ID": 155,
		"x": -106.1052813547,
		"y": 34.394170019,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593676,
		"ID": 155,
		"x": -106.0912518307,
		"y": 35.122162386,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593677,
		"ID": 155,
		"x": -106.0762619457,
		"y": 33.49118341,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593678,
		"ID": 155,
		"x": -106.0312515847,
		"y": 34.38614399,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593679,
		"ID": 155,
		"x": -105.9902770897,
		"y": 35.310155193,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593680,
		"ID": 155,
		"x": -105.9852265697,
		"y": 33.735175585,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593681,
		"ID": 155,
		"x": -105.9572278647,
		"y": 35.558157803,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593682,
		"ID": 155,
		"x": -106.0232749597,
		"y": 34.299141091,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593683,
		"ID": 155,
		"x": -105.8722596457,
		"y": 34.761243378,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593684,
		"ID": 155,
		"x": -105.8242862057,
		"y": 35.671193478,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593685,
		"ID": 155,
		"x": -105.8102626657,
		"y": 34.631240594,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593686,
		"ID": 155,
		"x": -105.7882828557,
		"y": 33.931208455,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593687,
		"ID": 155,
		"x": -105.7852414377,
		"y": 35.215173497,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593688,
		"ID": 155,
		"x": -105.7052967357,
		"y": 34.236192561,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593689,
		"ID": 155,
		"x": -105.6902960977,
		"y": 34.448203041,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593690,
		"ID": 155,
		"x": -105.6012476607,
		"y": 35.825227582,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593691,
		"ID": 155,
		"x": -105.5682390467,
		"y": 34.161201078,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593692,
		"ID": 155,
		"x": -105.5672569557,
		"y": 34.810247281,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593693,
		"ID": 155,
		"x": -105.5652845427,
		"y": 34.613225593,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593694,
		"ID": 155,
		"x": -105.5482958137,
		"y": 35.507184423,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593695,
		"ID": 155,
		"x": -105.4922467427,
		"y": 34.013194406,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593696,
		"ID": 155,
		"x": -105.4332521957,
		"y": 34.922171617,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593697,
		"ID": 155,
		"x": -105.3922430577,
		"y": 34.796225847,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593699,
		"ID": 155,
		"x": -105.3782686177,
		"y": 34.540188047,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593700,
		"ID": 155,
		"x": -105.3642758557,
		"y": 35.601158861,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593701,
		"ID": 155,
		"x": -105.3262528457,
		"y": 35.10623794,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593702,
		"ID": 155,
		"x": -105.3182519537,
		"y": 33.863213406,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593703,
		"ID": 155,
		"x": -105.2752735697,
		"y": 34.924183002,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593704,
		"ID": 155,
		"x": -105.2482509417,
		"y": 34.696173388,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593705,
		"ID": 155,
		"x": -105.1652879777,
		"y": 35.66823069,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593706,
		"ID": 155,
		"x": -105.1532528727,
		"y": 35.058218604,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593707,
		"ID": 155,
		"x": -105.1092470537,
		"y": 35.294245807,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593708,
		"ID": 155,
		"x": -105.0642855727,
		"y": 34.820175424,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593709,
		"ID": 155,
		"x": -105.0392893377,
		"y": 33.598146465,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593710,
		"ID": 155,
		"x": -104.8852634557,
		"y": 34.704188673,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593711,
		"ID": 155,
		"x": -104.8702299607,
		"y": 35.324222227,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593712,
		"ID": 155,
		"x": -104.7772901307,
		"y": 35.559213334,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593713,
		"ID": 155,
		"x": -104.7242433497,
		"y": 33.332152642,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593714,
		"ID": 155,
		"x": -104.6012915217,
		"y": 33.285196021,
		"h": 4.5934065934
	},
	{
		"stop_id": 8593715,
		"ID": 155,
		"x": -104.3762479437,
		"y": 33.375222637,
		"h": 4.5934065934
	},
	{
		"stop_id": 8594498,
		"ID": 155,
		"x": -104.9282807207,
		"y": 33.569173566,
		"h": 4.5934065934
	},
	{
		"stop_id": 8594499,
		"ID": 155,
		"x": -108.0302294347,
		"y": 32.994209315,
		"h": 4.5934065934
	},
	{
		"stop_id": 8500186,
		"ID": 309,
		"x": -83.1552574847,
		"y": 70.069161332,
		"h": 1.1978021978
	},
	{
		"stop_id": 8500187,
		"ID": 309,
		"x": -81.0072862507,
		"y": 73.219232798,
		"h": 1.1978021978
	},
	{
		"stop_id": 8572096,
		"ID": 309,
		"x": -83.1312506787,
		"y": 70.110204382,
		"h": 1.1978021978
	},
	{
		"stop_id": 8572097,
		"ID": 309,
		"x": -79.6972481257,
		"y": 70.412233513,
		"h": 1.1978021978
	},
	{
		"stop_id": 8583343,
		"ID": 309,
		"x": -83.1152996627,
		"y": 70.327173609,
		"h": 1.1978021978
	},
	{
		"stop_id": 8583345,
		"ID": 309,
		"x": -81.9422921657,
		"y": 70.654193326,
		"h": 1.1978021978
	},
	{
		"stop_id": 8583356,
		"ID": 309,
		"x": -83.6792668557,
		"y": 70.151206702,
		"h": 1.1978021978
	},
	{
		"stop_id": 8500188,
		"ID": 310,
		"x": -81.0932909237,
		"y": 75.603146839,
		"h": 1.0989010989
	},
	{
		"stop_id": 8572074,
		"ID": 310,
		"x": -82.5632478317,
		"y": 77.659163915,
		"h": 1.0989010989
	},
	{
		"stop_id": 8572075,
		"ID": 310,
		"x": -82.2762408787,
		"y": 77.571221634,
		"h": 1.0989010989
	},
	{
		"stop_id": 8583564,
		"ID": 310,
		"x": -83.5102644647,
		"y": 77.365150525,
		"h": 1.0989010989
	},
	{
		"stop_id": 8500192,
		"ID": 241,
		"x": -91.8602773227,
		"y": 52.223166565,
		"h": 1.3626373626
	},
	{
		"stop_id": 8500194,
		"ID": 241,
		"x": -88.4802355497,
		"y": 53.747191709,
		"h": 1.3626373626
	},
	{
		"stop_id": 8500769,
		"ID": 241,
		"x": -93.9862981767,
		"y": 53.158212852,
		"h": 1.3626373626
	},
	{
		"stop_id": 8500863,
		"ID": 241,
		"x": -89.0922460337,
		"y": 54.350236033,
		"h": 1.3626373626
	},
	{
		"stop_id": 8500874,
		"ID": 241,
		"x": -90.4042391757,
		"y": 53.250199375,
		"h": 1.3626373626
	},
	{
		"stop_id": 8500876,
		"ID": 241,
		"x": -89.3422779367,
		"y": 55.230141708,
		"h": 1.3626373626
	},
	{
		"stop_id": 8576781,
		"ID": 241,
		"x": -93.0342765897,
		"y": 51.661187604,
		"h": 1.3626373626
	},
	{
		"stop_id": 8576782,
		"ID": 241,
		"x": -92.0922580167,
		"y": 52.180179929,
		"h": 1.3626373626
	},
	{
		"stop_id": 8576783,
		"ID": 241,
		"x": -88.7152383177,
		"y": 54.630220313,
		"h": 1.3626373626
	},
	{
		"stop_id": 8583814,
		"ID": 241,
		"x": -93.0082875947,
		"y": 51.302152367,
		"h": 1.3626373626
	},
	{
		"stop_id": 8588897,
		"ID": 241,
		"x": -89.2922912997,
		"y": 55.030211333,
		"h": 1.3626373626
	},
	{
		"stop_id": 8595677,
		"ID": 241,
		"x": -92.6292439927,
		"y": 51.921197972,
		"h": 1.3626373626
	},
	{
		"stop_id": 8500195,
		"ID": 274,
		"x": -85.3522885317,
		"y": 54.599250969,
		"h": 1.4285714286
	},
	{
		"stop_id": 8500860,
		"ID": 274,
		"x": -87.8152628197,
		"y": 55.396251044,
		"h": 1.4285714286
	},
	{
		"stop_id": 8500865,
		"ID": 274,
		"x": -84.4082513147,
		"y": 56.874214677,
		"h": 1.4285714286
	},
	{
		"stop_id": 8500866,
		"ID": 274,
		"x": -86.6022854457,
		"y": 55.887150773,
		"h": 1.4285714286
	},
	{
		"stop_id": 8500868,
		"ID": 274,
		"x": -84.9422838457,
		"y": 56.33023617,
		"h": 1.4285714286
	},
	{
		"stop_id": 8500869,
		"ID": 274,
		"x": -83.8912338237,
		"y": 57.127239744,
		"h": 1.4285714286
	},
	{
		"stop_id": 8500877,
		"ID": 274,
		"x": -89.2422562807,
		"y": 57.205216801,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572108,
		"ID": 274,
		"x": -86.9202559677,
		"y": 58.78420356,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572109,
		"ID": 274,
		"x": -87.5422965447,
		"y": 59.105186712,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572110,
		"ID": 274,
		"x": -88.4202432067,
		"y": 57.848248447,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572112,
		"ID": 274,
		"x": -88.7102869277,
		"y": 57.0002374,
		"h": 1.4285714286
	},
	{
		"stop_id": 8576784,
		"ID": 274,
		"x": -88.7392922467,
		"y": 57.007161595,
		"h": 1.4285714286
	},
	{
		"stop_id": 8576785,
		"ID": 274,
		"x": -84.4782992257,
		"y": 56.562200765,
		"h": 1.4285714286
	},
	{
		"stop_id": 8588202,
		"ID": 274,
		"x": -85.5522395547,
		"y": 56.367222138,
		"h": 1.4285714286
	},
	{
		"stop_id": 8500196,
		"ID": 306,
		"x": -83.5432605817,
		"y": 55.954207309,
		"h": 1.4615384615
	},
	{
		"stop_id": 8500751,
		"ID": 306,
		"x": -80.3282698407,
		"y": 52.15824645,
		"h": 1.4615384615
	},
	{
		"stop_id": 8500758,
		"ID": 306,
		"x": -83.1152255187,
		"y": 51.439156983,
		"h": 1.4615384615
	},
	{
		"stop_id": 8500861,
		"ID": 306,
		"x": -82.5122817037,
		"y": 53.908213247,
		"h": 1.4615384615
	},
	{
		"stop_id": 8500867,
		"ID": 306,
		"x": -81.2772488997,
		"y": 56.401245403,
		"h": 1.4615384615
	},
	{
		"stop_id": 8500881,
		"ID": 306,
		"x": -82.2882661797,
		"y": 55.609187013,
		"h": 1.4615384615
	},
	{
		"stop_id": 8500882,
		"ID": 306,
		"x": -82.8542984177,
		"y": 53.708193581,
		"h": 1.4615384615
	},
	{
		"stop_id": 8571942,
		"ID": 306,
		"x": -79.7412546057,
		"y": 51.848154529,
		"h": 1.4615384615
	},
	{
		"stop_id": 8571945,
		"ID": 306,
		"x": -79.2542412647,
		"y": 53.258169354,
		"h": 1.4615384615
	},
	{
		"stop_id": 8571946,
		"ID": 306,
		"x": -79.8322371627,
		"y": 54.073161493,
		"h": 1.4615384615
	},
	{
		"stop_id": 8571947,
		"ID": 306,
		"x": -80.9442384907,
		"y": 53.895155573,
		"h": 1.4615384615
	},
	{
		"stop_id": 8571948,
		"ID": 306,
		"x": -81.5892412287,
		"y": 53.899171618,
		"h": 1.4615384615
	},
	{
		"stop_id": 8571949,
		"ID": 306,
		"x": -82.1612370007,
		"y": 53.94122637,
		"h": 1.4615384615
	},
	{
		"stop_id": 8576778,
		"ID": 306,
		"x": -83.9332757097,
		"y": 53.282243015,
		"h": 1.4615384615
	},
	{
		"stop_id": 8583050,
		"ID": 306,
		"x": -79.1642512797,
		"y": 53.586185788,
		"h": 1.4615384615
	},
	{
		"stop_id": 8500199,
		"ID": 307,
		"x": -80.9272338087,
		"y": 57.793183774,
		"h": 1.4285714286
	},
	{
		"stop_id": 8500657,
		"ID": 307,
		"x": -81.6372423577,
		"y": 61.909150553,
		"h": 1.4285714286
	},
	{
		"stop_id": 8500658,
		"ID": 307,
		"x": -84.2002763357,
		"y": 60.146191416,
		"h": 1.4285714286
	},
	{
		"stop_id": 8500864,
		"ID": 307,
		"x": -82.0302891917,
		"y": 57.626245853,
		"h": 1.4285714286
	},
	{
		"stop_id": 8500875,
		"ID": 307,
		"x": -79.7452870647,
		"y": 59.483238018,
		"h": 1.4285714286
	},
	{
		"stop_id": 8500879,
		"ID": 307,
		"x": -79.3542548877,
		"y": 58.027234995,
		"h": 1.4285714286
	},
	{
		"stop_id": 8500880,
		"ID": 307,
		"x": -80.2992545297,
		"y": 57.473210769,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572103,
		"ID": 307,
		"x": -81.5642302287,
		"y": 62.017171528,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572104,
		"ID": 307,
		"x": -82.2462879107,
		"y": 61.781246264,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572105,
		"ID": 307,
		"x": -82.8012542957,
		"y": 61.441169098,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572106,
		"ID": 307,
		"x": -83.1452843997,
		"y": 61.103195142,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572107,
		"ID": 307,
		"x": -84.4342645707,
		"y": 60.02319713,
		"h": 1.4285714286
	},
	{
		"stop_id": 8576786,
		"ID": 307,
		"x": -81.5422869817,
		"y": 57.930172398,
		"h": 1.4285714286
	},
	{
		"stop_id": 8576787,
		"ID": 307,
		"x": -80.4992361647,
		"y": 58.706238159,
		"h": 1.4285714286
	},
	{
		"stop_id": 8500200,
		"ID": 395,
		"x": -67.2052289897,
		"y": 41.932227809,
		"h": 1.8571428571
	},
	{
		"stop_id": 8500221,
		"ID": 395,
		"x": -64.8552807527,
		"y": 38.229237845,
		"h": 1.8571428571
	},
	{
		"stop_id": 8504366,
		"ID": 395,
		"x": -64.6422982547,
		"y": 38.460188895,
		"h": 1.8571428571
	},
	{
		"stop_id": 8504545,
		"ID": 395,
		"x": -66.6262690227,
		"y": 40.612199035,
		"h": 1.8571428571
	},
	{
		"stop_id": 8571478,
		"ID": 395,
		"x": -64.0702397477,
		"y": 38.070180825,
		"h": 1.8571428571
	},
	{
		"stop_id": 8571479,
		"ID": 395,
		"x": -64.9872874027,
		"y": 38.219237476,
		"h": 1.8571428571
	},
	{
		"stop_id": 8576718,
		"ID": 395,
		"x": -65.8642574057,
		"y": 41.041161319,
		"h": 1.8571428571
	},
	{
		"stop_id": 8576719,
		"ID": 395,
		"x": -68.5252649707,
		"y": 39.509194804,
		"h": 1.8571428571
	},
	{
		"stop_id": 8576720,
		"ID": 395,
		"x": -68.7342879497,
		"y": 39.313174025,
		"h": 1.8571428571
	},
	{
		"stop_id": 8577958,
		"ID": 395,
		"x": -64.3782484447,
		"y": 38.350244199,
		"h": 1.8571428571
	},
	{
		"stop_id": 8577961,
		"ID": 395,
		"x": -63.8812434577,
		"y": 38.744209526,
		"h": 1.8571428571
	},
	{
		"stop_id": 8582574,
		"ID": 395,
		"x": -66.3232297767,
		"y": 40.834203451,
		"h": 1.8571428571
	},
	{
		"stop_id": 8587446,
		"ID": 395,
		"x": -65.4362481667,
		"y": 38.359180512,
		"h": 1.8571428571
	},
	{
		"stop_id": 8587627,
		"ID": 395,
		"x": -67.2752884527,
		"y": 41.926202364,
		"h": 1.8571428571
	},
	{
		"stop_id": 8587629,
		"ID": 395,
		"x": -67.4702386317,
		"y": 42.305231653,
		"h": 1.8571428571
	},
	{
		"stop_id": 8587631,
		"ID": 395,
		"x": -67.8902555917,
		"y": 42.279226666,
		"h": 1.8571428571
	},
	{
		"stop_id": 8587632,
		"ID": 395,
		"x": -67.0432524837,
		"y": 42.39118156,
		"h": 1.8571428571
	},
	{
		"stop_id": 8587633,
		"ID": 395,
		"x": -67.5442645517,
		"y": 42.163246299,
		"h": 1.8571428571
	},
	{
		"stop_id": 8588470,
		"ID": 395,
		"x": -64.4042851377,
		"y": 38.424196282,
		"h": 1.8571428571
	},
	{
		"stop_id": 8588471,
		"ID": 395,
		"x": -64.8202918187,
		"y": 38.424208479,
		"h": 1.8571428571
	},
	{
		"stop_id": 8588472,
		"ID": 395,
		"x": -65.1182449407,
		"y": 38.361215361,
		"h": 1.8571428571
	},
	{
		"stop_id": 8594163,
		"ID": 395,
		"x": -66.1662936247,
		"y": 40.740197631,
		"h": 1.8571428571
	},
	{
		"stop_id": 8594164,
		"ID": 395,
		"x": -66.9122687077,
		"y": 40.452225338,
		"h": 1.8571428571
	},
	{
		"stop_id": 8594165,
		"ID": 395,
		"x": -68.8472990557,
		"y": 39.117234054,
		"h": 1.8571428571
	},
	{
		"stop_id": 8594166,
		"ID": 395,
		"x": -69.0172267507,
		"y": 38.860239088,
		"h": 1.8571428571
	},
	{
		"stop_id": 8594167,
		"ID": 395,
		"x": -68.0232681207,
		"y": 39.982186988,
		"h": 1.8571428571
	},
	{
		"stop_id": 8594168,
		"ID": 395,
		"x": -67.5372474257,
		"y": 40.190200469,
		"h": 1.8571428571
	},
	{
		"stop_id": 8500201,
		"ID": 396,
		"x": -65.2062615247,
		"y": 42.818214897,
		"h": 1.9230769231
	},
	{
		"stop_id": 8576407,
		"ID": 396,
		"x": -67.1132778917,
		"y": 43.860240515,
		"h": 1.9230769231
	},
	{
		"stop_id": 8577946,
		"ID": 396,
		"x": -64.6332754317,
		"y": 43.359247902,
		"h": 1.9230769231
	},
	{
		"stop_id": 8577947,
		"ID": 396,
		"x": -65.2412648957,
		"y": 43.079178054,
		"h": 1.9230769231
	},
	{
		"stop_id": 8577949,
		"ID": 396,
		"x": -65.4922885437,
		"y": 42.947230226,
		"h": 1.9230769231
	},
	{
		"stop_id": 8577953,
		"ID": 396,
		"x": -65.0662580727,
		"y": 42.731146396,
		"h": 1.9230769231
	},
	{
		"stop_id": 8577954,
		"ID": 396,
		"x": -65.4112859337,
		"y": 42.604173086,
		"h": 1.9230769231
	},
	{
		"stop_id": 8577972,
		"ID": 396,
		"x": -63.4562616497,
		"y": 44.887168302,
		"h": 1.9230769231
	},
	{
		"stop_id": 8577973,
		"ID": 396,
		"x": -63.6342750827,
		"y": 45.090181798,
		"h": 1.9230769231
	},
	{
		"stop_id": 8577974,
		"ID": 396,
		"x": -64.3422686377,
		"y": 45.1301642,
		"h": 1.9230769231
	},
	{
		"stop_id": 8577975,
		"ID": 396,
		"x": -65.4722898887,
		"y": 45.107146324,
		"h": 1.9230769231
	},
	{
		"stop_id": 8577977,
		"ID": 396,
		"x": -65.0422722017,
		"y": 46.286216938,
		"h": 1.9230769231
	},
	{
		"stop_id": 8577978,
		"ID": 396,
		"x": -65.5052510127,
		"y": 46.341241682,
		"h": 1.9230769231
	},
	{
		"stop_id": 8577979,
		"ID": 396,
		"x": -64.1572854437,
		"y": 46.964218293,
		"h": 1.9230769231
	},
	{
		"stop_id": 8589215,
		"ID": 396,
		"x": -65.0482973437,
		"y": 43.312247972,
		"h": 1.9230769231
	},
	{
		"stop_id": 8589966,
		"ID": 396,
		"x": -67.4922562977,
		"y": 44.180248529,
		"h": 1.9230769231
	},
	{
		"stop_id": 8593829,
		"ID": 396,
		"x": -65.0742835007,
		"y": 43.075243857,
		"h": 1.9230769231
	},
	{
		"stop_id": 8594103,
		"ID": 396,
		"x": -64.1772600267,
		"y": 44.998181179,
		"h": 1.9230769231
	},
	{
		"stop_id": 8594109,
		"ID": 396,
		"x": -63.5982937457,
		"y": 45.188215723,
		"h": 1.9230769231
	},
	{
		"stop_id": 8594114,
		"ID": 396,
		"x": -63.5392389687,
		"y": 45.348160245,
		"h": 1.9230769231
	},
	{
		"stop_id": 8594118,
		"ID": 396,
		"x": -63.8532994947,
		"y": 45.141250922,
		"h": 1.9230769231
	},
	{
		"stop_id": 8594120,
		"ID": 396,
		"x": -63.7352770197,
		"y": 44.874233853,
		"h": 1.9230769231
	},
	{
		"stop_id": 8594128,
		"ID": 396,
		"x": -64.0782418407,
		"y": 43.849208877,
		"h": 1.9230769231
	},
	{
		"stop_id": 8594129,
		"ID": 396,
		"x": -64.2112796947,
		"y": 43.614171125,
		"h": 1.9230769231
	},
	{
		"stop_id": 8594141,
		"ID": 396,
		"x": -63.4822862047,
		"y": 45.071182277,
		"h": 1.9230769231
	},
	{
		"stop_id": 8594142,
		"ID": 396,
		"x": -63.3012920947,
		"y": 45.148225481,
		"h": 1.9230769231
	},
	{
		"stop_id": 8594147,
		"ID": 396,
		"x": -64.0092926257,
		"y": 44.757247556,
		"h": 1.9230769231
	},
	{
		"stop_id": 8594148,
		"ID": 396,
		"x": -64.0552708157,
		"y": 45.19320493,
		"h": 1.9230769231
	},
	{
		"stop_id": 8594149,
		"ID": 396,
		"x": -63.8502826337,
		"y": 44.475189806,
		"h": 1.9230769231
	},
	{
		"stop_id": 8500204,
		"ID": 456,
		"x": -58.3782854377,
		"y": 45.172159314,
		"h": 2.3846153846
	},
	{
		"stop_id": 8500205,
		"ID": 456,
		"x": -54.4972812977,
		"y": 46.095148192,
		"h": 2.3846153846
	},
	{
		"stop_id": 8500230,
		"ID": 456,
		"x": -54.9932458287,
		"y": 44.024182802,
		"h": 2.3846153846
	},
	{
		"stop_id": 8500231,
		"ID": 456,
		"x": -55.5352820417,
		"y": 43.710152419,
		"h": 2.3846153846
	},
	{
		"stop_id": 8500261,
		"ID": 456,
		"x": -54.1082835587,
		"y": 47.100206824,
		"h": 2.3846153846
	},
	{
		"stop_id": 8500262,
		"ID": 456,
		"x": -57.4042385747,
		"y": 47.169188368,
		"h": 2.3846153846
	},
	{
		"stop_id": 8500454,
		"ID": 456,
		"x": -56.0762894477,
		"y": 46.612178981,
		"h": 2.3846153846
	},
	{
		"stop_id": 8500990,
		"ID": 456,
		"x": -53.7522581247,
		"y": 46.252158488,
		"h": 2.3846153846
	},
	{
		"stop_id": 8518963,
		"ID": 456,
		"x": -53.4692859797,
		"y": 46.093241716,
		"h": 2.3846153846
	},
	{
		"stop_id": 8577969,
		"ID": 456,
		"x": -58.5832603097,
		"y": 46.062199545,
		"h": 2.3846153846
	},
	{
		"stop_id": 8577971,
		"ID": 456,
		"x": -58.3632880547,
		"y": 45.197177343,
		"h": 2.3846153846
	},
	{
		"stop_id": 8578073,
		"ID": 456,
		"x": -54.9912241287,
		"y": 46.749237661,
		"h": 2.3846153846
	},
	{
		"stop_id": 8578076,
		"ID": 456,
		"x": -55.2812462917,
		"y": 46.500202035,
		"h": 2.3846153846
	},
	{
		"stop_id": 8578077,
		"ID": 456,
		"x": -54.8172811457,
		"y": 46.45120036,
		"h": 2.3846153846
	},
	{
		"stop_id": 8578078,
		"ID": 456,
		"x": -54.5252764187,
		"y": 46.40319527,
		"h": 2.3846153846
	},
	{
		"stop_id": 8578079,
		"ID": 456,
		"x": -53.6962586457,
		"y": 46.464229107,
		"h": 2.3846153846
	},
	{
		"stop_id": 8578107,
		"ID": 456,
		"x": -54.2012272927,
		"y": 45.785229823,
		"h": 2.3846153846
	},
	{
		"stop_id": 8578108,
		"ID": 456,
		"x": -53.8682951127,
		"y": 45.761197912,
		"h": 2.3846153846
	},
	{
		"stop_id": 8578109,
		"ID": 456,
		"x": -53.8622769767,
		"y": 45.960210416,
		"h": 2.3846153846
	},
	{
		"stop_id": 8588455,
		"ID": 456,
		"x": -54.2442711107,
		"y": 44.551240116,
		"h": 2.3846153846
	},
	{
		"stop_id": 8588559,
		"ID": 456,
		"x": -54.0642240267,
		"y": 46.48521643,
		"h": 2.3846153846
	},
	{
		"stop_id": 8588584,
		"ID": 456,
		"x": -54.4712635177,
		"y": 46.145200528,
		"h": 2.3846153846
	},
	{
		"stop_id": 8588585,
		"ID": 456,
		"x": -55.4222413637,
		"y": 47.050203789,
		"h": 2.3846153846
	},
	{
		"stop_id": 8588586,
		"ID": 456,
		"x": -54.3622511987,
		"y": 46.83014747,
		"h": 2.3846153846
	},
	{
		"stop_id": 8588587,
		"ID": 456,
		"x": -54.5622409207,
		"y": 46.750146956,
		"h": 2.3846153846
	},
	{
		"stop_id": 8588588,
		"ID": 456,
		"x": -55.1622506537,
		"y": 47.020155232,
		"h": 2.3846153846
	},
	{
		"stop_id": 8588589,
		"ID": 456,
		"x": -55.5322922067,
		"y": 46.490238277,
		"h": 2.3846153846
	},
	{
		"stop_id": 8588593,
		"ID": 456,
		"x": -53.3822529507,
		"y": 45.750241262,
		"h": 2.3846153846
	},
	{
		"stop_id": 8589074,
		"ID": 456,
		"x": -59.0452731157,
		"y": 44.844191928,
		"h": 2.3846153846
	},
	{
		"stop_id": 8589875,
		"ID": 456,
		"x": -58.9382718567,
		"y": 44.18715104,
		"h": 2.3846153846
	},
	{
		"stop_id": 8589876,
		"ID": 456,
		"x": -59.0322809367,
		"y": 44.523226641,
		"h": 2.3846153846
	},
	{
		"stop_id": 8589877,
		"ID": 456,
		"x": -58.8482896497,
		"y": 45.097142682,
		"h": 2.3846153846
	},
	{
		"stop_id": 8589878,
		"ID": 456,
		"x": -58.4462588257,
		"y": 45.568156375,
		"h": 2.3846153846
	},
	{
		"stop_id": 8589879,
		"ID": 456,
		"x": -58.6132872057,
		"y": 45.780249638,
		"h": 2.3846153846
	},
	{
		"stop_id": 8589880,
		"ID": 456,
		"x": -58.3702541587,
		"y": 46.560203878,
		"h": 2.3846153846
	},
	{
		"stop_id": 8589881,
		"ID": 456,
		"x": -57.3122885487,
		"y": 47.376236103,
		"h": 2.3846153846
	},
	{
		"stop_id": 8589882,
		"ID": 456,
		"x": -57.2132748707,
		"y": 47.703248583,
		"h": 2.3846153846
	},
	{
		"stop_id": 8591782,
		"ID": 456,
		"x": -55.7922609697,
		"y": 47.150232494,
		"h": 2.3846153846
	},
	{
		"stop_id": 8591783,
		"ID": 456,
		"x": -55.4622863257,
		"y": 46.265154048,
		"h": 2.3846153846
	},
	{
		"stop_id": 8591784,
		"ID": 456,
		"x": -55.6972984397,
		"y": 46.280223471,
		"h": 2.3846153846
	},
	{
		"stop_id": 8595424,
		"ID": 456,
		"x": -53.4582546847,
		"y": 46.049227171,
		"h": 2.3846153846
	},
	{
		"stop_id": 8595915,
		"ID": 456,
		"x": -54.0922469417,
		"y": 46.236153553,
		"h": 2.3846153846
	},
	{
		"stop_id": 8595916,
		"ID": 456,
		"x": -54.0862351377,
		"y": 45.885173629,
		"h": 2.3846153846
	},
	{
		"stop_id": 8500206,
		"ID": 488,
		"x": -52.6722302277,
		"y": 45.853206785,
		"h": 2.5824175824
	},
	{
		"stop_id": 8500207,
		"ID": 488,
		"x": -51.8582370257,
		"y": 45.573166265,
		"h": 2.5824175824
	},
	{
		"stop_id": 8500272,
		"ID": 488,
		"x": -51.6572326807,
		"y": 46.476191006,
		"h": 2.5824175824
	},
	{
		"stop_id": 8500273,
		"ID": 488,
		"x": -51.3222311667,
		"y": 46.900237319,
		"h": 2.5824175824
	},
	{
		"stop_id": 8500274,
		"ID": 488,
		"x": -50.8632546697,
		"y": 47.407201495,
		"h": 2.5824175824
	},
	{
		"stop_id": 8500275,
		"ID": 488,
		"x": -50.0522952407,
		"y": 48.267194322,
		"h": 2.5824175824
	},
	{
		"stop_id": 8500280,
		"ID": 488,
		"x": -51.9192391797,
		"y": 46.219246705,
		"h": 2.5824175824
	},
	{
		"stop_id": 8500283,
		"ID": 488,
		"x": -49.5912799757,
		"y": 48.56224616,
		"h": 2.5824175824
	},
	{
		"stop_id": 8500455,
		"ID": 488,
		"x": -53.9812939757,
		"y": 47.220176135,
		"h": 2.5824175824
	},
	{
		"stop_id": 8500457,
		"ID": 488,
		"x": -52.7902957727,
		"y": 48.491193611,
		"h": 2.5824175824
	},
	{
		"stop_id": 8500467,
		"ID": 488,
		"x": -50.6122697357,
		"y": 45.688224613,
		"h": 2.5824175824
	},
	{
		"stop_id": 8500487,
		"ID": 488,
		"x": -51.8512750277,
		"y": 47.306203656,
		"h": 2.5824175824
	},
	{
		"stop_id": 8500490,
		"ID": 488,
		"x": -53.9632622517,
		"y": 47.531156255,
		"h": 2.5824175824
	},
	{
		"stop_id": 8500494,
		"ID": 488,
		"x": -52.5122551857,
		"y": 46.010156861,
		"h": 2.5824175824
	},
	{
		"stop_id": 8500498,
		"ID": 488,
		"x": -50.9482698527,
		"y": 45.777219218,
		"h": 2.5824175824
	},
	{
		"stop_id": 8500684,
		"ID": 488,
		"x": -49.5172376527,
		"y": 50.655186202,
		"h": 2.5824175824
	},
	{
		"stop_id": 8500750,
		"ID": 488,
		"x": -50.6072389547,
		"y": 51.027203103,
		"h": 2.5824175824
	},
	{
		"stop_id": 8500991,
		"ID": 488,
		"x": -50.5462486017,
		"y": 45.52122677,
		"h": 2.5824175824
	},
	{
		"stop_id": 8504379,
		"ID": 488,
		"x": -52.5102768697,
		"y": 45.500190873,
		"h": 2.5824175824
	},
	{
		"stop_id": 8572373,
		"ID": 488,
		"x": -51.8892755377,
		"y": 45.611148017,
		"h": 2.5824175824
	},
	{
		"stop_id": 8572374,
		"ID": 488,
		"x": -53.0052433157,
		"y": 46.422161101,
		"h": 2.5824175824
	},
	{
		"stop_id": 8572376,
		"ID": 488,
		"x": -51.3862800097,
		"y": 46.820211241,
		"h": 2.5824175824
	},
	{
		"stop_id": 8572377,
		"ID": 488,
		"x": -50.9542776647,
		"y": 47.341250229,
		"h": 2.5824175824
	},
	{
		"stop_id": 8572378,
		"ID": 488,
		"x": -49.6172634577,
		"y": 48.567205107,
		"h": 2.5824175824
	},
	{
		"stop_id": 8572386,
		"ID": 488,
		"x": -51.9742484047,
		"y": 46.167144342,
		"h": 2.5824175824
	},
	{
		"stop_id": 8578059,
		"ID": 488,
		"x": -54.3912681557,
		"y": 48.113218673,
		"h": 2.5824175824
	},
	{
		"stop_id": 8578061,
		"ID": 488,
		"x": -53.4482762667,
		"y": 46.721191555,
		"h": 2.5824175824
	},
	{
		"stop_id": 8578064,
		"ID": 488,
		"x": -52.4312253767,
		"y": 45.79023592,
		"h": 2.5824175824
	},
	{
		"stop_id": 8578065,
		"ID": 488,
		"x": -52.2292418147,
		"y": 45.612157771,
		"h": 2.5824175824
	},
	{
		"stop_id": 8578080,
		"ID": 488,
		"x": -53.3622601107,
		"y": 46.472245619,
		"h": 2.5824175824
	},
	{
		"stop_id": 8578081,
		"ID": 488,
		"x": -50.6772716867,
		"y": 46.035220319,
		"h": 2.5824175824
	},
	{
		"stop_id": 8578099,
		"ID": 488,
		"x": -52.5752943177,
		"y": 48.74115154,
		"h": 2.5824175824
	},
	{
		"stop_id": 8578100,
		"ID": 488,
		"x": -53.0272820087,
		"y": 48.177180758,
		"h": 2.5824175824
	},
	{
		"stop_id": 8578101,
		"ID": 488,
		"x": -52.5122248617,
		"y": 47.242221588,
		"h": 2.5824175824
	},
	{
		"stop_id": 8578102,
		"ID": 488,
		"x": -51.8912851407,
		"y": 46.914140155,
		"h": 2.5824175824
	},
	{
		"stop_id": 8578103,
		"ID": 488,
		"x": -52.2622661417,
		"y": 46.819165269,
		"h": 2.5824175824
	},
	{
		"stop_id": 8578104,
		"ID": 488,
		"x": -52.5882274947,
		"y": 46.695249868,
		"h": 2.5824175824
	},
	{
		"stop_id": 8578105,
		"ID": 488,
		"x": -50.2672541697,
		"y": 46.276219964,
		"h": 2.5824175824
	},
	{
		"stop_id": 8578106,
		"ID": 488,
		"x": -50.6492593047,
		"y": 46.79615886,
		"h": 2.5824175824
	},
	{
		"stop_id": 8578111,
		"ID": 488,
		"x": -53.1122673547,
		"y": 46.267172388,
		"h": 2.5824175824
	},
	{
		"stop_id": 8583103,
		"ID": 488,
		"x": -51.6402661527,
		"y": 46.478215106,
		"h": 2.5824175824
	},
	{
		"stop_id": 8587846,
		"ID": 488,
		"x": -49.3752524557,
		"y": 46.743197748,
		"h": 2.5824175824
	},
	{
		"stop_id": 8588590,
		"ID": 488,
		"x": -52.2192828367,
		"y": 46.310250284,
		"h": 2.5824175824
	},
	{
		"stop_id": 8588591,
		"ID": 488,
		"x": -52.6222931037,
		"y": 45.590221337,
		"h": 2.5824175824
	},
	{
		"stop_id": 8589953,
		"ID": 488,
		"x": -54.1082500607,
		"y": 47.873222587,
		"h": 2.5824175824
	},
	{
		"stop_id": 8589956,
		"ID": 488,
		"x": -52.8382979437,
		"y": 46.243244581,
		"h": 2.5824175824
	},
	{
		"stop_id": 8589958,
		"ID": 488,
		"x": -50.3962489987,
		"y": 46.699157303,
		"h": 2.5824175824
	},
	{
		"stop_id": 8589960,
		"ID": 488,
		"x": -50.5202536967,
		"y": 45.56618221,
		"h": 2.5824175824
	},
	{
		"stop_id": 8591769,
		"ID": 488,
		"x": -50.0572984557,
		"y": 48.270188016,
		"h": 2.5824175824
	},
	{
		"stop_id": 8500208,
		"ID": 520,
		"x": -48.7672406307,
		"y": 47.019224144,
		"h": 1.7912087912
	},
	{
		"stop_id": 8500209,
		"ID": 520,
		"x": -46.0872272487,
		"y": 47.144153278,
		"h": 1.7912087912
	},
	{
		"stop_id": 8500468,
		"ID": 520,
		"x": -49.5912655777,
		"y": 45.295191152,
		"h": 1.7912087912
	},
	{
		"stop_id": 8500478,
		"ID": 520,
		"x": -44.6252364697,
		"y": 43.438143741,
		"h": 1.7912087912
	},
	{
		"stop_id": 8500485,
		"ID": 520,
		"x": -48.5772493787,
		"y": 44.537215839,
		"h": 1.7912087912
	},
	{
		"stop_id": 8500488,
		"ID": 520,
		"x": -45.8642433157,
		"y": 43.17320433,
		"h": 1.7912087912
	},
	{
		"stop_id": 8578067,
		"ID": 520,
		"x": -48.9532682567,
		"y": 45.081180599,
		"h": 1.7912087912
	},
	{
		"stop_id": 8578068,
		"ID": 520,
		"x": -48.5312896407,
		"y": 44.194210681,
		"h": 1.7912087912
	},
	{
		"stop_id": 8578069,
		"ID": 520,
		"x": -48.2882519507,
		"y": 43.682147344,
		"h": 1.7912087912
	},
	{
		"stop_id": 8578070,
		"ID": 520,
		"x": -47.7902654707,
		"y": 43.019176412,
		"h": 1.7912087912
	},
	{
		"stop_id": 8578112,
		"ID": 520,
		"x": -48.5652616437,
		"y": 45.17817232,
		"h": 1.7912087912
	},
	{
		"stop_id": 8578113,
		"ID": 520,
		"x": -47.8992510797,
		"y": 45.154217406,
		"h": 1.7912087912
	},
	{
		"stop_id": 8578114,
		"ID": 520,
		"x": -46.5012327897,
		"y": 44.670197131,
		"h": 1.7912087912
	},
	{
		"stop_id": 8578115,
		"ID": 520,
		"x": -46.5822629527,
		"y": 44.405195028,
		"h": 1.7912087912
	},
	{
		"stop_id": 8578117,
		"ID": 520,
		"x": -45.5642905297,
		"y": 43.00514286,
		"h": 1.7912087912
	},
	{
		"stop_id": 8578118,
		"ID": 520,
		"x": -44.7602797957,
		"y": 44.03315433,
		"h": 1.7912087912
	},
	{
		"stop_id": 8578133,
		"ID": 520,
		"x": -48.9212645287,
		"y": 46.657172586,
		"h": 1.7912087912
	},
	{
		"stop_id": 8578135,
		"ID": 520,
		"x": -48.6572953347,
		"y": 45.775243437,
		"h": 1.7912087912
	},
	{
		"stop_id": 8587847,
		"ID": 520,
		"x": -48.4272610087,
		"y": 46.929248488,
		"h": 1.7912087912
	},
	{
		"stop_id": 8587848,
		"ID": 520,
		"x": -48.5982525197,
		"y": 47.145167156,
		"h": 1.7912087912
	},
	{
		"stop_id": 8589531,
		"ID": 520,
		"x": -47.1352979657,
		"y": 42.597162319,
		"h": 1.7912087912
	},
	{
		"stop_id": 8589532,
		"ID": 520,
		"x": -46.2222841187,
		"y": 43.830214854,
		"h": 1.7912087912
	},
	{
		"stop_id": 8589919,
		"ID": 520,
		"x": -45.9422528357,
		"y": 46.655194928,
		"h": 1.7912087912
	},
	{
		"stop_id": 8589920,
		"ID": 520,
		"x": -48.1722599997,
		"y": 45.154238652,
		"h": 1.7912087912
	},
	{
		"stop_id": 8589957,
		"ID": 520,
		"x": -46.0892698347,
		"y": 44.558168872,
		"h": 1.7912087912
	},
	{
		"stop_id": 8500210,
		"ID": 554,
		"x": -43.2642675087,
		"y": 48.678196122,
		"h": 1.5934065934
	},
	{
		"stop_id": 8500480,
		"ID": 554,
		"x": -41.1632421917,
		"y": 45.607197136,
		"h": 1.5934065934
	},
	{
		"stop_id": 8576898,
		"ID": 554,
		"x": -43.3322425487,
		"y": 49.438244321,
		"h": 1.5934065934
	},
	{
		"stop_id": 8576899,
		"ID": 554,
		"x": -43.3092726447,
		"y": 48.961242323,
		"h": 1.5934065934
	},
	{
		"stop_id": 8576900,
		"ID": 554,
		"x": -43.3012543857,
		"y": 48.662195588,
		"h": 1.5934065934
	},
	{
		"stop_id": 8576901,
		"ID": 554,
		"x": -43.7092465537,
		"y": 47.46714651,
		"h": 1.5934065934
	},
	{
		"stop_id": 8576902,
		"ID": 554,
		"x": -43.4482897757,
		"y": 47.293193549,
		"h": 1.5934065934
	},
	{
		"stop_id": 8576903,
		"ID": 554,
		"x": -43.2012246647,
		"y": 47.190144843,
		"h": 1.5934065934
	},
	{
		"stop_id": 8576904,
		"ID": 554,
		"x": -42.7992904677,
		"y": 46.916219707,
		"h": 1.5934065934
	},
	{
		"stop_id": 8576906,
		"ID": 554,
		"x": -41.4572571277,
		"y": 45.990183763,
		"h": 1.5934065934
	},
	{
		"stop_id": 8576909,
		"ID": 554,
		"x": -41.8382766047,
		"y": 48.390242945,
		"h": 1.5934065934
	},
	{
		"stop_id": 8576910,
		"ID": 554,
		"x": -41.4502817237,
		"y": 48.482142093,
		"h": 1.5934065934
	},
	{
		"stop_id": 8576911,
		"ID": 554,
		"x": -41.2432553027,
		"y": 48.562162099,
		"h": 1.5934065934
	},
	{
		"stop_id": 8576912,
		"ID": 554,
		"x": -40.9392517517,
		"y": 48.098166913,
		"h": 1.5934065934
	},
	{
		"stop_id": 8576913,
		"ID": 554,
		"x": -40.0072880277,
		"y": 46.348239805,
		"h": 1.5934065934
	},
	{
		"stop_id": 8576914,
		"ID": 554,
		"x": -40.0032916257,
		"y": 46.102217172,
		"h": 1.5934065934
	},
	{
		"stop_id": 8587367,
		"ID": 554,
		"x": -41.1742441497,
		"y": 45.539233546,
		"h": 1.5934065934
	},
	{
		"stop_id": 8589945,
		"ID": 554,
		"x": -41.0662846767,
		"y": 48.420183708,
		"h": 1.5934065934
	},
	{
		"stop_id": 8589946,
		"ID": 554,
		"x": -43.4332426477,
		"y": 48.466160011,
		"h": 1.5934065934
	},
	{
		"stop_id": 8500211,
		"ID": 555,
		"x": -40.3562410097,
		"y": 52.961208788,
		"h": 1.7252747253
	},
	{
		"stop_id": 8500212,
		"ID": 555,
		"x": -39.2232744387,
		"y": 54.591228661,
		"h": 1.7252747253
	},
	{
		"stop_id": 8500288,
		"ID": 555,
		"x": -42.9132564167,
		"y": 51.758150909,
		"h": 1.7252747253
	},
	{
		"stop_id": 8500289,
		"ID": 555,
		"x": -41.5972546007,
		"y": 52.205172113,
		"h": 1.7252747253
	},
	{
		"stop_id": 8500292,
		"ID": 555,
		"x": -40.3722978047,
		"y": 56.639206064,
		"h": 1.7252747253
	},
	{
		"stop_id": 8508158,
		"ID": 555,
		"x": -39.9012446467,
		"y": 52.152211058,
		"h": 1.7252747253
	},
	{
		"stop_id": 8508159,
		"ID": 555,
		"x": -40.3302940057,
		"y": 52.453204328,
		"h": 1.7252747253
	},
	{
		"stop_id": 8518690,
		"ID": 555,
		"x": -39.7272287307,
		"y": 53.880186589,
		"h": 1.7252747253
	},
	{
		"stop_id": 8572371,
		"ID": 555,
		"x": -38.8192702287,
		"y": 55.124186174,
		"h": 1.7252747253
	},
	{
		"stop_id": 8572372,
		"ID": 555,
		"x": -39.2112252347,
		"y": 54.629182521,
		"h": 1.7252747253
	},
	{
		"stop_id": 8576969,
		"ID": 555,
		"x": -43.0572315707,
		"y": 53.196179921,
		"h": 1.7252747253
	},
	{
		"stop_id": 8578920,
		"ID": 555,
		"x": -40.4132808627,
		"y": 56.800173098,
		"h": 1.7252747253
	},
	{
		"stop_id": 8580195,
		"ID": 555,
		"x": -39.9052651967,
		"y": 56.242163208,
		"h": 1.7252747253
	},
	{
		"stop_id": 8583571,
		"ID": 555,
		"x": -39.5692905297,
		"y": 55.835150158,
		"h": 1.7252747253
	},
	{
		"stop_id": 8583573,
		"ID": 555,
		"x": -38.9912337867,
		"y": 55.325153417,
		"h": 1.7252747253
	},
	{
		"stop_id": 8583575,
		"ID": 555,
		"x": -39.5032469477,
		"y": 54.452184891,
		"h": 1.7252747253
	},
	{
		"stop_id": 8583578,
		"ID": 555,
		"x": -39.3282995287,
		"y": 54.77320244,
		"h": 1.7252747253
	},
	{
		"stop_id": 8583582,
		"ID": 555,
		"x": -39.5472363757,
		"y": 54.908206201,
		"h": 1.7252747253
	},
	{
		"stop_id": 8583732,
		"ID": 555,
		"x": -39.3072544367,
		"y": 55.540193912,
		"h": 1.7252747253
	},
	{
		"stop_id": 8589917,
		"ID": 555,
		"x": -40.6722884077,
		"y": 53.090156951,
		"h": 1.7252747253
	},
	{
		"stop_id": 8590435,
		"ID": 555,
		"x": -39.1612424917,
		"y": 54.592221081,
		"h": 1.7252747253
	},
	{
		"stop_id": 8591770,
		"ID": 555,
		"x": -42.6172514357,
		"y": 51.552201572,
		"h": 1.7252747253
	},
	{
		"stop_id": 8594860,
		"ID": 555,
		"x": -42.7932274207,
		"y": 53.359246713,
		"h": 1.7252747253
	},
	{
		"stop_id": 8500213,
		"ID": 589,
		"x": -34.5532742747,
		"y": 56.85723416,
		"h": 1.7912087912
	},
	{
		"stop_id": 8500386,
		"ID": 589,
		"x": -34.7622296937,
		"y": 55.868179466,
		"h": 1.7912087912
	},
	{
		"stop_id": 8500685,
		"ID": 589,
		"x": -38.0082490457,
		"y": 55.181237555,
		"h": 1.7912087912
	},
	{
		"stop_id": 8500762,
		"ID": 589,
		"x": -35.9042840177,
		"y": 59.907143718,
		"h": 1.7912087912
	},
	{
		"stop_id": 8508862,
		"ID": 589,
		"x": -36.0372967407,
		"y": 54.24918122,
		"h": 1.7912087912
	},
	{
		"stop_id": 8572343,
		"ID": 589,
		"x": -38.4862578457,
		"y": 58.421199607,
		"h": 1.7912087912
	},
	{
		"stop_id": 8572344,
		"ID": 589,
		"x": -36.8972966727,
		"y": 59.644191849,
		"h": 1.7912087912
	},
	{
		"stop_id": 8578019,
		"ID": 589,
		"x": -35.7412243237,
		"y": 54.543216266,
		"h": 1.7912087912
	},
	{
		"stop_id": 8578020,
		"ID": 589,
		"x": -34.4592524037,
		"y": 55.945173701,
		"h": 1.7912087912
	},
	{
		"stop_id": 8581284,
		"ID": 589,
		"x": -34.9672470347,
		"y": 57.330236941,
		"h": 1.7912087912
	},
	{
		"stop_id": 8581289,
		"ID": 589,
		"x": -33.3902696477,
		"y": 57.238177568,
		"h": 1.7912087912
	},
	{
		"stop_id": 8582192,
		"ID": 589,
		"x": -38.4192745207,
		"y": 54.771164238,
		"h": 1.7912087912
	},
	{
		"stop_id": 8582255,
		"ID": 589,
		"x": -37.9732500147,
		"y": 54.919203043,
		"h": 1.7912087912
	},
	{
		"stop_id": 8583572,
		"ID": 589,
		"x": -37.6102778277,
		"y": 55.242185803,
		"h": 1.7912087912
	},
	{
		"stop_id": 8583574,
		"ID": 589,
		"x": -38.1382591547,
		"y": 55.091153037,
		"h": 1.7912087912
	},
	{
		"stop_id": 8583576,
		"ID": 589,
		"x": -37.9712411087,
		"y": 55.321237353,
		"h": 1.7912087912
	},
	{
		"stop_id": 8583577,
		"ID": 589,
		"x": -38.0862396037,
		"y": 55.472245002,
		"h": 1.7912087912
	},
	{
		"stop_id": 8583579,
		"ID": 589,
		"x": -38.4992326927,
		"y": 55.57515443,
		"h": 1.7912087912
	},
	{
		"stop_id": 8583580,
		"ID": 589,
		"x": -38.6952530207,
		"y": 55.41424741,
		"h": 1.7912087912
	},
	{
		"stop_id": 8583581,
		"ID": 589,
		"x": -38.5622664477,
		"y": 55.072173605,
		"h": 1.7912087912
	},
	{
		"stop_id": 8583812,
		"ID": 589,
		"x": -33.3192581057,
		"y": 57.356233422,
		"h": 1.7912087912
	},
	{
		"stop_id": 8583815,
		"ID": 589,
		"x": -38.4122364297,
		"y": 55.741235226,
		"h": 1.7912087912
	},
	{
		"stop_id": 8583816,
		"ID": 589,
		"x": -38.6132332137,
		"y": 56.728243838,
		"h": 1.7912087912
	},
	{
		"stop_id": 8589884,
		"ID": 589,
		"x": -33.4432512157,
		"y": 57.659207829,
		"h": 1.7912087912
	},
	{
		"stop_id": 8589885,
		"ID": 589,
		"x": -34.5612697857,
		"y": 56.870208444,
		"h": 1.7912087912
	},
	{
		"stop_id": 8500214,
		"ID": 622,
		"x": -32.4982775837,
		"y": 57.935190547,
		"h": 2.1868131868
	},
	{
		"stop_id": 8500215,
		"ID": 622,
		"x": -29.1152760927,
		"y": 59.664195378,
		"h": 2.1868131868
	},
	{
		"stop_id": 8500380,
		"ID": 622,
		"x": -30.2402286207,
		"y": 58.133200229,
		"h": 2.1868131868
	},
	{
		"stop_id": 8500381,
		"ID": 622,
		"x": -29.1792554897,
		"y": 59.479192547,
		"h": 2.1868131868
	},
	{
		"stop_id": 8500382,
		"ID": 622,
		"x": -31.0782241357,
		"y": 57.32314584,
		"h": 2.1868131868
	},
	{
		"stop_id": 8500383,
		"ID": 622,
		"x": -29.0022848327,
		"y": 58.878166826,
		"h": 2.1868131868
	},
	{
		"stop_id": 8577902,
		"ID": 622,
		"x": -31.3782347797,
		"y": 62.111198208,
		"h": 2.1868131868
	},
	{
		"stop_id": 8577903,
		"ID": 622,
		"x": -31.0802659727,
		"y": 61.225170508,
		"h": 2.1868131868
	},
	{
		"stop_id": 8577904,
		"ID": 622,
		"x": -30.1162690557,
		"y": 61.142177808,
		"h": 2.1868131868
	},
	{
		"stop_id": 8577905,
		"ID": 622,
		"x": -29.5402280597,
		"y": 60.851224139,
		"h": 2.1868131868
	},
	{
		"stop_id": 8577906,
		"ID": 622,
		"x": -29.0662459467,
		"y": 60.445169474,
		"h": 2.1868131868
	},
	{
		"stop_id": 8577907,
		"ID": 622,
		"x": -29.1742812247,
		"y": 60.040242817,
		"h": 2.1868131868
	},
	{
		"stop_id": 8577908,
		"ID": 622,
		"x": -29.1312428117,
		"y": 59.68223575,
		"h": 2.1868131868
	},
	{
		"stop_id": 8577910,
		"ID": 622,
		"x": -33.2642354597,
		"y": 60.654232075,
		"h": 2.1868131868
	},
	{
		"stop_id": 8578023,
		"ID": 622,
		"x": -31.3782957667,
		"y": 57.152155062,
		"h": 2.1868131868
	},
	{
		"stop_id": 8578024,
		"ID": 622,
		"x": -30.0252292697,
		"y": 58.472152293,
		"h": 2.1868131868
	},
	{
		"stop_id": 8578025,
		"ID": 622,
		"x": -28.5592818897,
		"y": 59.139195849,
		"h": 2.1868131868
	},
	{
		"stop_id": 8578026,
		"ID": 622,
		"x": -29.3152374247,
		"y": 59.876192596,
		"h": 2.1868131868
	},
	{
		"stop_id": 8578027,
		"ID": 622,
		"x": -28.9952262967,
		"y": 60.041166971,
		"h": 2.1868131868
	},
	{
		"stop_id": 8578028,
		"ID": 622,
		"x": -28.5912429117,
		"y": 60.289207025,
		"h": 2.1868131868
	},
	{
		"stop_id": 8578916,
		"ID": 622,
		"x": -32.4882514587,
		"y": 57.958251028,
		"h": 2.1868131868
	},
	{
		"stop_id": 8581285,
		"ID": 622,
		"x": -33.2922862907,
		"y": 58.43214223,
		"h": 2.1868131868
	},
	{
		"stop_id": 8581286,
		"ID": 622,
		"x": -32.8362761507,
		"y": 58.607187253,
		"h": 2.1868131868
	},
	{
		"stop_id": 8581287,
		"ID": 622,
		"x": -32.5762308327,
		"y": 58.249143209,
		"h": 2.1868131868
	},
	{
		"stop_id": 8581288,
		"ID": 622,
		"x": -33.1432279297,
		"y": 57.865227184,
		"h": 2.1868131868
	},
	{
		"stop_id": 8587636,
		"ID": 622,
		"x": -32.0562849757,
		"y": 58.915184655,
		"h": 2.1868131868
	},
	{
		"stop_id": 8588076,
		"ID": 622,
		"x": -32.1542274197,
		"y": 58.175150227,
		"h": 2.1868131868
	},
	{
		"stop_id": 8588647,
		"ID": 622,
		"x": -31.5702918927,
		"y": 58.092168688,
		"h": 2.1868131868
	},
	{
		"stop_id": 8588648,
		"ID": 622,
		"x": -31.3792292107,
		"y": 57.918189193,
		"h": 2.1868131868
	},
	{
		"stop_id": 8589883,
		"ID": 622,
		"x": -32.3412612387,
		"y": 58.351174511,
		"h": 2.1868131868
	},
	{
		"stop_id": 8589886,
		"ID": 622,
		"x": -31.1992655317,
		"y": 58.294176809,
		"h": 2.1868131868
	},
	{
		"stop_id": 8589887,
		"ID": 622,
		"x": -31.3062673637,
		"y": 57.966234638,
		"h": 2.1868131868
	},
	{
		"stop_id": 8590412,
		"ID": 622,
		"x": -31.0892278067,
		"y": 62.080231408,
		"h": 2.1868131868
	},
	{
		"stop_id": 8594172,
		"ID": 622,
		"x": -30.2792373997,
		"y": 59.001223896,
		"h": 2.1868131868
	},
	{
		"stop_id": 8594780,
		"ID": 622,
		"x": -29.8522515537,
		"y": 59.615190439,
		"h": 2.1868131868
	},
	{
		"stop_id": 8594918,
		"ID": 622,
		"x": -29.5102265337,
		"y": 60.495148702,
		"h": 2.1868131868
	},
	{
		"stop_id": 8595922,
		"ID": 622,
		"x": -32.5982313307,
		"y": 58.795165699,
		"h": 2.1868131868
	},
	{
		"stop_id": 8500220,
		"ID": 394,
		"x": -67.3982901117,
		"y": 36.065201233,
		"h": 1.2637362637
	},
	{
		"stop_id": 8504415,
		"ID": 394,
		"x": -68.8532337167,
		"y": 33.845226828,
		"h": 1.2637362637
	},
	{
		"stop_id": 8504456,
		"ID": 394,
		"x": -68.2692601137,
		"y": 32.441227933,
		"h": 1.2637362637
	},
	{
		"stop_id": 8508873,
		"ID": 394,
		"x": -67.0382411887,
		"y": 34.683179919,
		"h": 1.2637362637
	},
	{
		"stop_id": 8508874,
		"ID": 394,
		"x": -65.7152933327,
		"y": 34.964182763,
		"h": 1.2637362637
	},
	{
		"stop_id": 8571461,
		"ID": 394,
		"x": -67.3292830827,
		"y": 34.433182992,
		"h": 1.2637362637
	},
	{
		"stop_id": 8571462,
		"ID": 394,
		"x": -66.2382866127,
		"y": 34.87224004,
		"h": 1.2637362637
	},
	{
		"stop_id": 8571463,
		"ID": 394,
		"x": -65.3942395877,
		"y": 34.950190825,
		"h": 1.2637362637
	},
	{
		"stop_id": 8589061,
		"ID": 394,
		"x": -67.0122555627,
		"y": 36.180222708,
		"h": 1.2637362637
	},
	{
		"stop_id": 8500252,
		"ID": 457,
		"x": -54.4662382397,
		"y": 50.869250426,
		"h": 1.4285714286
	},
	{
		"stop_id": 8500260,
		"ID": 457,
		"x": -58.3802508767,
		"y": 53.170171026,
		"h": 1.4285714286
	},
	{
		"stop_id": 8500263,
		"ID": 457,
		"x": -56.9872665027,
		"y": 48.540178828,
		"h": 1.4285714286
	},
	{
		"stop_id": 8500264,
		"ID": 457,
		"x": -55.5672799937,
		"y": 49.105216551,
		"h": 1.4285714286
	},
	{
		"stop_id": 8500265,
		"ID": 457,
		"x": -57.7322569697,
		"y": 52.381201167,
		"h": 1.4285714286
	},
	{
		"stop_id": 8500456,
		"ID": 457,
		"x": -55.0242310607,
		"y": 48.465233559,
		"h": 1.4285714286
	},
	{
		"stop_id": 8500701,
		"ID": 457,
		"x": -56.7262879917,
		"y": 52.325247366,
		"h": 1.4285714286
	},
	{
		"stop_id": 8530671,
		"ID": 457,
		"x": -55.6042929647,
		"y": 49.083177908,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572338,
		"ID": 457,
		"x": -54.9392305707,
		"y": 52.98524758,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572339,
		"ID": 457,
		"x": -55.4342787357,
		"y": 52.877141357,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572340,
		"ID": 457,
		"x": -56.1022418567,
		"y": 52.608205682,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572341,
		"ID": 457,
		"x": -57.5042707797,
		"y": 52.071203137,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572342,
		"ID": 457,
		"x": -57.7352920057,
		"y": 52.405214743,
		"h": 1.4285714286
	},
	{
		"stop_id": 8578058,
		"ID": 457,
		"x": -54.9002575267,
		"y": 48.46121828,
		"h": 1.4285714286
	},
	{
		"stop_id": 8500285,
		"ID": 521,
		"x": -47.7752943827,
		"y": 49.469148918,
		"h": 1.6263736264
	},
	{
		"stop_id": 8500286,
		"ID": 521,
		"x": -46.4752766537,
		"y": 50.277159259,
		"h": 1.6263736264
	},
	{
		"stop_id": 8500287,
		"ID": 521,
		"x": -44.0372886037,
		"y": 51.00318221,
		"h": 1.6263736264
	},
	{
		"stop_id": 8500698,
		"ID": 521,
		"x": -48.6912547597,
		"y": 49.717201273,
		"h": 1.6263736264
	},
	{
		"stop_id": 8500760,
		"ID": 521,
		"x": -49.2932256277,
		"y": 51.516205268,
		"h": 1.6263736264
	},
	{
		"stop_id": 8508696,
		"ID": 521,
		"x": -44.3372668097,
		"y": 52.228144791,
		"h": 1.6263736264
	},
	{
		"stop_id": 8572380,
		"ID": 521,
		"x": -49.0002731717,
		"y": 50.238174155,
		"h": 1.6263736264
	},
	{
		"stop_id": 8572381,
		"ID": 521,
		"x": -49.5922639027,
		"y": 51.505239153,
		"h": 1.6263736264
	},
	{
		"stop_id": 8576891,
		"ID": 521,
		"x": -45.7472682667,
		"y": 52.533190208,
		"h": 1.6263736264
	},
	{
		"stop_id": 8576892,
		"ID": 521,
		"x": -44.4242932197,
		"y": 52.578245286,
		"h": 1.6263736264
	},
	{
		"stop_id": 8576893,
		"ID": 521,
		"x": -44.0982492877,
		"y": 52.656250208,
		"h": 1.6263736264
	},
	{
		"stop_id": 8576894,
		"ID": 521,
		"x": -44.9192929497,
		"y": 51.173140115,
		"h": 1.6263736264
	},
	{
		"stop_id": 8576895,
		"ID": 521,
		"x": -44.2412890777,
		"y": 50.884243259,
		"h": 1.6263736264
	},
	{
		"stop_id": 8576896,
		"ID": 521,
		"x": -44.0092748577,
		"y": 51.001143671,
		"h": 1.6263736264
	},
	{
		"stop_id": 8576897,
		"ID": 521,
		"x": -44.0932879107,
		"y": 50.506178353,
		"h": 1.6263736264
	},
	{
		"stop_id": 8583101,
		"ID": 521,
		"x": -49.3102538867,
		"y": 51.081245566,
		"h": 1.6263736264
	},
	{
		"stop_id": 8583892,
		"ID": 521,
		"x": -48.3862868057,
		"y": 50.001165994,
		"h": 1.6263736264
	},
	{
		"stop_id": 8589915,
		"ID": 521,
		"x": -46.4222508907,
		"y": 50.36521937,
		"h": 1.6263736264
	},
	{
		"stop_id": 8589921,
		"ID": 521,
		"x": -47.8522714647,
		"y": 49.455209115,
		"h": 1.6263736264
	},
	{
		"stop_id": 8589947,
		"ID": 521,
		"x": -43.6972677447,
		"y": 51.03721877,
		"h": 1.6263736264
	},
	{
		"stop_id": 8500293,
		"ID": 556,
		"x": -40.8682245737,
		"y": 57.201185922,
		"h": 1.6593406593
	},
	{
		"stop_id": 8500294,
		"ID": 556,
		"x": -40.4392929047,
		"y": 57.685196324,
		"h": 1.6593406593
	},
	{
		"stop_id": 8500597,
		"ID": 556,
		"x": -42.9652438807,
		"y": 61.284251031,
		"h": 1.6593406593
	},
	{
		"stop_id": 8500674,
		"ID": 556,
		"x": -40.3612414267,
		"y": 57.749156512,
		"h": 1.6593406593
	},
	{
		"stop_id": 8500774,
		"ID": 556,
		"x": -39.8282575167,
		"y": 60.84519732,
		"h": 1.6593406593
	},
	{
		"stop_id": 8572314,
		"ID": 556,
		"x": -40.4692398307,
		"y": 57.803173055,
		"h": 1.6593406593
	},
	{
		"stop_id": 8572315,
		"ID": 556,
		"x": -40.2362547477,
		"y": 58.026182395,
		"h": 1.6593406593
	},
	{
		"stop_id": 8572316,
		"ID": 556,
		"x": -40.0202361947,
		"y": 58.367218811,
		"h": 1.6593406593
	},
	{
		"stop_id": 8572317,
		"ID": 556,
		"x": -39.3172800457,
		"y": 58.680230185,
		"h": 1.6593406593
	},
	{
		"stop_id": 8572318,
		"ID": 556,
		"x": -39.2862799257,
		"y": 59.690194544,
		"h": 1.6593406593
	},
	{
		"stop_id": 8572319,
		"ID": 556,
		"x": -39.5552398967,
		"y": 60.497230314,
		"h": 1.6593406593
	},
	{
		"stop_id": 8572320,
		"ID": 556,
		"x": -40.1322435907,
		"y": 60.992169779,
		"h": 1.6593406593
	},
	{
		"stop_id": 8572321,
		"ID": 556,
		"x": -42.3672354297,
		"y": 61.424165953,
		"h": 1.6593406593
	},
	{
		"stop_id": 8572322,
		"ID": 556,
		"x": -43.7072448647,
		"y": 61.567163588,
		"h": 1.6593406593
	},
	{
		"stop_id": 8572323,
		"ID": 556,
		"x": -43.1762287007,
		"y": 62.370238067,
		"h": 1.6593406593
	},
	{
		"stop_id": 8572324,
		"ID": 556,
		"x": -42.9652917277,
		"y": 62.614206218,
		"h": 1.6593406593
	},
	{
		"stop_id": 8572325,
		"ID": 556,
		"x": -40.8412690057,
		"y": 57.190153424,
		"h": 1.6593406593
	},
	{
		"stop_id": 8572326,
		"ID": 556,
		"x": -41.4502578827,
		"y": 57.567153612,
		"h": 1.6593406593
	},
	{
		"stop_id": 8572327,
		"ID": 556,
		"x": -41.9922265307,
		"y": 57.605204191,
		"h": 1.6593406593
	},
	{
		"stop_id": 8572328,
		"ID": 556,
		"x": -42.9442340637,
		"y": 57.587210143,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583679,
		"ID": 556,
		"x": -43.5542954257,
		"y": 59.563202135,
		"h": 1.6593406593
	},
	{
		"stop_id": 8500301,
		"ID": 626,
		"x": -33.1302918497,
		"y": 84.211183826,
		"h": 2.4835164835
	},
	{
		"stop_id": 8500302,
		"ID": 626,
		"x": -29.9972357887,
		"y": 85.409167978,
		"h": 2.4835164835
	},
	{
		"stop_id": 8500783,
		"ID": 626,
		"x": -31.5792642607,
		"y": 81.59118176,
		"h": 2.4835164835
	},
	{
		"stop_id": 8500970,
		"ID": 626,
		"x": -29.3302918017,
		"y": 84.94422606,
		"h": 2.4835164835
	},
	{
		"stop_id": 8530698,
		"ID": 626,
		"x": -33.3012329967,
		"y": 84.512186353,
		"h": 2.4835164835
	},
	{
		"stop_id": 8572244,
		"ID": 626,
		"x": -31.9762527077,
		"y": 81.58219026,
		"h": 2.4835164835
	},
	{
		"stop_id": 8572245,
		"ID": 626,
		"x": -32.7932464707,
		"y": 80.912172504,
		"h": 2.4835164835
	},
	{
		"stop_id": 8572246,
		"ID": 626,
		"x": -33.4662597567,
		"y": 80.923157325,
		"h": 2.4835164835
	},
	{
		"stop_id": 8572249,
		"ID": 626,
		"x": -33.1502321897,
		"y": 84.226215978,
		"h": 2.4835164835
	},
	{
		"stop_id": 8572250,
		"ID": 626,
		"x": -32.9342431987,
		"y": 84.387192473,
		"h": 2.4835164835
	},
	{
		"stop_id": 8572251,
		"ID": 626,
		"x": -32.4192561497,
		"y": 84.264237203,
		"h": 2.4835164835
	},
	{
		"stop_id": 8572252,
		"ID": 626,
		"x": -32.0502722667,
		"y": 84.814229678,
		"h": 2.4835164835
	},
	{
		"stop_id": 8572270,
		"ID": 626,
		"x": -32.6312894017,
		"y": 84.589159109,
		"h": 2.4835164835
	},
	{
		"stop_id": 8572271,
		"ID": 626,
		"x": -32.2022416767,
		"y": 83.909213945,
		"h": 2.4835164835
	},
	{
		"stop_id": 8572272,
		"ID": 626,
		"x": -32.5512926287,
		"y": 83.413140108,
		"h": 2.4835164835
	},
	{
		"stop_id": 8572273,
		"ID": 626,
		"x": -31.8812969907,
		"y": 81.904194621,
		"h": 2.4835164835
	},
	{
		"stop_id": 8572274,
		"ID": 626,
		"x": -31.0262725757,
		"y": 81.561149111,
		"h": 2.4835164835
	},
	{
		"stop_id": 8572275,
		"ID": 626,
		"x": -29.5512754527,
		"y": 81.270169112,
		"h": 2.4835164835
	},
	{
		"stop_id": 8572313,
		"ID": 626,
		"x": -30.0452474217,
		"y": 85.378238192,
		"h": 2.4835164835
	},
	{
		"stop_id": 8577508,
		"ID": 626,
		"x": -33.6802821147,
		"y": 84.234198546,
		"h": 2.4835164835
	},
	{
		"stop_id": 8580388,
		"ID": 626,
		"x": -32.1902994607,
		"y": 84.610209619,
		"h": 2.4835164835
	},
	{
		"stop_id": 8580565,
		"ID": 626,
		"x": -29.1072654237,
		"y": 84.753240272,
		"h": 2.4835164835
	},
	{
		"stop_id": 8581070,
		"ID": 626,
		"x": -34.0012415257,
		"y": 84.196212447,
		"h": 2.4835164835
	},
	{
		"stop_id": 8583445,
		"ID": 626,
		"x": -29.7212510817,
		"y": 85.008164658,
		"h": 2.4835164835
	},
	{
		"stop_id": 8583449,
		"ID": 626,
		"x": -32.9572538407,
		"y": 84.648161829,
		"h": 2.4835164835
	},
	{
		"stop_id": 8589428,
		"ID": 626,
		"x": -32.1702912937,
		"y": 85.259207534,
		"h": 2.4835164835
	},
	{
		"stop_id": 8589429,
		"ID": 626,
		"x": -31.9852500157,
		"y": 85.570182203,
		"h": 2.4835164835
	},
	{
		"stop_id": 8589430,
		"ID": 626,
		"x": -32.4992482067,
		"y": 84.37316788,
		"h": 2.4835164835
	},
	{
		"stop_id": 8589431,
		"ID": 626,
		"x": -32.3702606307,
		"y": 85.177221401,
		"h": 2.4835164835
	},
	{
		"stop_id": 8589433,
		"ID": 626,
		"x": -32.2082361377,
		"y": 84.453237272,
		"h": 2.4835164835
	},
	{
		"stop_id": 8589434,
		"ID": 626,
		"x": -32.4862970807,
		"y": 84.944187409,
		"h": 2.4835164835
	},
	{
		"stop_id": 8589435,
		"ID": 626,
		"x": -31.9292406317,
		"y": 84.974243849,
		"h": 2.4835164835
	},
	{
		"stop_id": 8589436,
		"ID": 626,
		"x": -32.3472770327,
		"y": 84.732234333,
		"h": 2.4835164835
	},
	{
		"stop_id": 8589437,
		"ID": 626,
		"x": -32.2052949477,
		"y": 84.840191711,
		"h": 2.4835164835
	},
	{
		"stop_id": 8589438,
		"ID": 626,
		"x": -32.6512299237,
		"y": 84.752183275,
		"h": 2.4835164835
	},
	{
		"stop_id": 8590255,
		"ID": 626,
		"x": -33.2352957927,
		"y": 84.613219265,
		"h": 2.4835164835
	},
	{
		"stop_id": 8594516,
		"ID": 626,
		"x": -33.6592725537,
		"y": 84.830156749,
		"h": 2.4835164835
	},
	{
		"stop_id": 8594517,
		"ID": 626,
		"x": -33.4172411917,
		"y": 84.769184633,
		"h": 2.4835164835
	},
	{
		"stop_id": 8594523,
		"ID": 626,
		"x": -33.1982589517,
		"y": 85.384153769,
		"h": 2.4835164835
	},
	{
		"stop_id": 8594525,
		"ID": 626,
		"x": -33.3922668587,
		"y": 85.330248915,
		"h": 2.4835164835
	},
	{
		"stop_id": 8594528,
		"ID": 626,
		"x": -33.4342439977,
		"y": 85.05520053,
		"h": 2.4835164835
	},
	{
		"stop_id": 8595310,
		"ID": 626,
		"x": -32.8492714867,
		"y": 85.764221065,
		"h": 2.4835164835
	},
	{
		"stop_id": 8595657,
		"ID": 626,
		"x": -32.8442941347,
		"y": 83.692220909,
		"h": 2.4835164835
	},
	{
		"stop_id": 8595658,
		"ID": 626,
		"x": -32.8062356467,
		"y": 84.113246472,
		"h": 2.4835164835
	},
	{
		"stop_id": 8595659,
		"ID": 626,
		"x": -32.5892417767,
		"y": 84.382205355,
		"h": 2.4835164835
	},
	{
		"stop_id": 8595660,
		"ID": 626,
		"x": -32.6202710127,
		"y": 84.090190116,
		"h": 2.4835164835
	},
	{
		"stop_id": 8500303,
		"ID": 660,
		"x": -24.2862981917,
		"y": 83.858186541,
		"h": 1.5604395604
	},
	{
		"stop_id": 8500690,
		"ID": 660,
		"x": -29.3432398097,
		"y": 85.208236432,
		"h": 1.5604395604
	},
	{
		"stop_id": 8500789,
		"ID": 660,
		"x": -29.5522825427,
		"y": 86.026194675,
		"h": 1.5604395604
	},
	{
		"stop_id": 8500791,
		"ID": 660,
		"x": -27.0962479027,
		"y": 83.313189534,
		"h": 1.5604395604
	},
	{
		"stop_id": 8572256,
		"ID": 660,
		"x": -29.1322367797,
		"y": 86.349250312,
		"h": 1.5604395604
	},
	{
		"stop_id": 8572258,
		"ID": 660,
		"x": -29.5242879667,
		"y": 85.584244094,
		"h": 1.5604395604
	},
	{
		"stop_id": 8572259,
		"ID": 660,
		"x": -28.7502908077,
		"y": 84.471231395,
		"h": 1.5604395604
	},
	{
		"stop_id": 8572260,
		"ID": 660,
		"x": -27.3792258207,
		"y": 83.803205371,
		"h": 1.5604395604
	},
	{
		"stop_id": 8572425,
		"ID": 660,
		"x": -24.9352940457,
		"y": 84.842147518,
		"h": 1.5604395604
	},
	{
		"stop_id": 8572426,
		"ID": 660,
		"x": -24.6892597947,
		"y": 85.023173885,
		"h": 1.5604395604
	},
	{
		"stop_id": 8572427,
		"ID": 660,
		"x": -24.4692545457,
		"y": 84.61919212,
		"h": 1.5604395604
	},
	{
		"stop_id": 8577361,
		"ID": 660,
		"x": -29.4132455677,
		"y": 85.533220113,
		"h": 1.5604395604
	},
	{
		"stop_id": 8580474,
		"ID": 660,
		"x": -28.5172608247,
		"y": 86.840149089,
		"h": 1.5604395604
	},
	{
		"stop_id": 8580475,
		"ID": 660,
		"x": -29.1392274847,
		"y": 86.115157655,
		"h": 1.5604395604
	},
	{
		"stop_id": 8580477,
		"ID": 660,
		"x": -29.1182668967,
		"y": 86.543239405,
		"h": 1.5604395604
	},
	{
		"stop_id": 8582259,
		"ID": 660,
		"x": -28.9272564237,
		"y": 86.623177247,
		"h": 1.5604395604
	},
	{
		"stop_id": 8583446,
		"ID": 660,
		"x": -29.4592635937,
		"y": 85.628163342,
		"h": 1.5604395604
	},
	{
		"stop_id": 8583809,
		"ID": 660,
		"x": -28.4502756947,
		"y": 84.390196663,
		"h": 1.5604395604
	},
	{
		"stop_id": 8500304,
		"ID": 721,
		"x": -18.2402974067,
		"y": 82.27614627,
		"h": 1.5934065934
	},
	{
		"stop_id": 8500305,
		"ID": 721,
		"x": -16.4652408267,
		"y": 79.43216931,
		"h": 1.5934065934
	},
	{
		"stop_id": 8500583,
		"ID": 721,
		"x": -16.4722533947,
		"y": 79.371186019,
		"h": 1.5934065934
	},
	{
		"stop_id": 8500792,
		"ID": 721,
		"x": -17.3602747447,
		"y": 78.223176,
		"h": 1.5934065934
	},
	{
		"stop_id": 8572396,
		"ID": 721,
		"x": -15.4092759997,
		"y": 79.109198132,
		"h": 1.5934065934
	},
	{
		"stop_id": 8572397,
		"ID": 721,
		"x": -15.9912751967,
		"y": 79.533168876,
		"h": 1.5934065934
	},
	{
		"stop_id": 8572398,
		"ID": 721,
		"x": -15.7072389367,
		"y": 79.663144688,
		"h": 1.5934065934
	},
	{
		"stop_id": 8572399,
		"ID": 721,
		"x": -14.7192594967,
		"y": 80.878219534,
		"h": 1.5934065934
	},
	{
		"stop_id": 8572400,
		"ID": 721,
		"x": -14.8002628407,
		"y": 81.705195598,
		"h": 1.5934065934
	},
	{
		"stop_id": 8572411,
		"ID": 721,
		"x": -17.4922343097,
		"y": 77.940145419,
		"h": 1.5934065934
	},
	{
		"stop_id": 8572412,
		"ID": 721,
		"x": -17.0562285857,
		"y": 78.569158863,
		"h": 1.5934065934
	},
	{
		"stop_id": 8572413,
		"ID": 721,
		"x": -16.4752446337,
		"y": 79.028143893,
		"h": 1.5934065934
	},
	{
		"stop_id": 8572414,
		"ID": 721,
		"x": -15.9362636547,
		"y": 79.1852182,
		"h": 1.5934065934
	},
	{
		"stop_id": 8577981,
		"ID": 721,
		"x": -14.9542671167,
		"y": 78.849216441,
		"h": 1.5934065934
	},
	{
		"stop_id": 8581529,
		"ID": 721,
		"x": -16.3932486377,
		"y": 80.783210518,
		"h": 1.5934065934
	},
	{
		"stop_id": 8581549,
		"ID": 721,
		"x": -16.2162557897,
		"y": 80.744148245,
		"h": 1.5934065934
	},
	{
		"stop_id": 8581550,
		"ID": 721,
		"x": -15.9962474957,
		"y": 80.572203301,
		"h": 1.5934065934
	},
	{
		"stop_id": 8581843,
		"ID": 721,
		"x": -18.3402944637,
		"y": 82.200169375,
		"h": 1.5934065934
	},
	{
		"stop_id": 8581951,
		"ID": 721,
		"x": -17.8762741457,
		"y": 81.849183166,
		"h": 1.5934065934
	},
	{
		"stop_id": 8500309,
		"ID": 806,
		"x": -1.6892555187,
		"y": 76.613159678,
		"h": 2.7802197802
	},
	{
		"stop_id": 8500550,
		"ID": 806,
		"x": -1.8392679737,
		"y": 77.23024665,
		"h": 2.7802197802
	},
	{
		"stop_id": 8500552,
		"ID": 806,
		"x": -0.8752492737,
		"y": 79.650179928,
		"h": 2.7802197802
	},
	{
		"stop_id": 8500555,
		"ID": 806,
		"x": 0.1657160883,
		"y": 79.026170102,
		"h": 2.7802197802
	},
	{
		"stop_id": 8500559,
		"ID": 806,
		"x": -2.5612247387,
		"y": 77.049210342,
		"h": 2.7802197802
	},
	{
		"stop_id": 8500562,
		"ID": 806,
		"x": -3.3082978767,
		"y": 77.687168091,
		"h": 2.7802197802
	},
	{
		"stop_id": 8500563,
		"ID": 806,
		"x": -3.2732991167,
		"y": 78.126151895,
		"h": 2.7802197802
	},
	{
		"stop_id": 8500564,
		"ID": 806,
		"x": -1.9832797467,
		"y": 79.782246796,
		"h": 2.7802197802
	},
	{
		"stop_id": 8500576,
		"ID": 806,
		"x": -1.1082620787,
		"y": 76.410182908,
		"h": 2.7802197802
	},
	{
		"stop_id": 8500577,
		"ID": 806,
		"x": -0.3022343037,
		"y": 76.855207907,
		"h": 2.7802197802
	},
	{
		"stop_id": 8500578,
		"ID": 806,
		"x": -0.5522337467,
		"y": 76.672237731,
		"h": 2.7802197802
	},
	{
		"stop_id": 8500683,
		"ID": 806,
		"x": -0.3042458527,
		"y": 75.652208838,
		"h": 2.7802197802
	},
	{
		"stop_id": 8500786,
		"ID": 806,
		"x": -1.6902324797,
		"y": 75.829142,
		"h": 2.7802197802
	},
	{
		"stop_id": 8500787,
		"ID": 806,
		"x": -1.4892751547,
		"y": 75.648207824,
		"h": 2.7802197802
	},
	{
		"stop_id": 8500788,
		"ID": 806,
		"x": -1.5032649697,
		"y": 75.208199249,
		"h": 2.7802197802
	},
	{
		"stop_id": 8500950,
		"ID": 806,
		"x": -3.1452267517,
		"y": 76.830219202,
		"h": 2.7802197802
	},
	{
		"stop_id": 8500953,
		"ID": 806,
		"x": -3.3872969197,
		"y": 77.12723472,
		"h": 2.7802197802
	},
	{
		"stop_id": 8502705,
		"ID": 806,
		"x": -1.3492395117,
		"y": 75.950248395,
		"h": 2.7802197802
	},
	{
		"stop_id": 8502871,
		"ID": 806,
		"x": -1.4562377767,
		"y": 74.475248836,
		"h": 2.7802197802
	},
	{
		"stop_id": 8502873,
		"ID": 806,
		"x": 0.2907261423,
		"y": 76.597226324,
		"h": 2.7802197802
	},
	{
		"stop_id": 8502985,
		"ID": 806,
		"x": 0.9887209483,
		"y": 77.421165159,
		"h": 2.7802197802
	},
	{
		"stop_id": 8503574,
		"ID": 806,
		"x": -0.9692867737,
		"y": 77.695156033,
		"h": 2.7802197802
	},
	{
		"stop_id": 8503886,
		"ID": 806,
		"x": 1.1597084073,
		"y": 77.621178455,
		"h": 2.7802197802
	},
	{
		"stop_id": 8572449,
		"ID": 806,
		"x": -3.0202264517,
		"y": 80.041183152,
		"h": 2.7802197802
	},
	{
		"stop_id": 8572450,
		"ID": 806,
		"x": -3.4172538997,
		"y": 76.814169182,
		"h": 2.7802197802
	},
	{
		"stop_id": 8572464,
		"ID": 806,
		"x": -1.6552822427,
		"y": 76.692216489,
		"h": 2.7802197802
	},
	{
		"stop_id": 8572479,
		"ID": 806,
		"x": -1.8242627457,
		"y": 76.983215218,
		"h": 2.7802197802
	},
	{
		"stop_id": 8572483,
		"ID": 806,
		"x": -1.3572542387,
		"y": 77.419228337,
		"h": 2.7802197802
	},
	{
		"stop_id": 8572484,
		"ID": 806,
		"x": -0.7572969317,
		"y": 78.006156829,
		"h": 2.7802197802
	},
	{
		"stop_id": 8572485,
		"ID": 806,
		"x": -0.4252555327,
		"y": 78.329154116,
		"h": 2.7802197802
	},
	{
		"stop_id": 8572486,
		"ID": 806,
		"x": -0.1652959577,
		"y": 78.57816858,
		"h": 2.7802197802
	},
	{
		"stop_id": 8572487,
		"ID": 806,
		"x": -0.2702884567,
		"y": 79.562164353,
		"h": 2.7802197802
	},
	{
		"stop_id": 8572488,
		"ID": 806,
		"x": -1.6292592447,
		"y": 79.628155854,
		"h": 2.7802197802
	},
	{
		"stop_id": 8572489,
		"ID": 806,
		"x": -3.1032443197,
		"y": 76.783142396,
		"h": 2.7802197802
	},
	{
		"stop_id": 8572504,
		"ID": 806,
		"x": -1.4722403257,
		"y": 74.829233214,
		"h": 2.7802197802
	},
	{
		"stop_id": 8572510,
		"ID": 806,
		"x": -1.1312591537,
		"y": 76.266184843,
		"h": 2.7802197802
	},
	{
		"stop_id": 8572511,
		"ID": 806,
		"x": 0.7637543473,
		"y": 76.580140295,
		"h": 2.7802197802
	},
	{
		"stop_id": 8572512,
		"ID": 806,
		"x": 0.4087393763,
		"y": 76.511250798,
		"h": 2.7802197802
	},
	{
		"stop_id": 8572516,
		"ID": 806,
		"x": -0.6072570197,
		"y": 76.257166227,
		"h": 2.7802197802
	},
	{
		"stop_id": 8572522,
		"ID": 806,
		"x": -0.3452422877,
		"y": 76.987205079,
		"h": 2.7802197802
	},
	{
		"stop_id": 8572523,
		"ID": 806,
		"x": -0.1812525577,
		"y": 76.952160587,
		"h": 2.7802197802
	},
	{
		"stop_id": 8578674,
		"ID": 806,
		"x": 0.7387426343,
		"y": 76.84418715,
		"h": 2.7802197802
	},
	{
		"stop_id": 8578677,
		"ID": 806,
		"x": 0.0447608893,
		"y": 76.47820698,
		"h": 2.7802197802
	},
	{
		"stop_id": 8579862,
		"ID": 806,
		"x": 0.8187353083,
		"y": 77.998176927,
		"h": 2.7802197802
	},
	{
		"stop_id": 8580321,
		"ID": 806,
		"x": -2.3802492477,
		"y": 76.44219097,
		"h": 2.7802197802
	},
	{
		"stop_id": 8580322,
		"ID": 806,
		"x": -2.5592408687,
		"y": 76.212183438,
		"h": 2.7802197802
	},
	{
		"stop_id": 8580323,
		"ID": 806,
		"x": -2.7112980147,
		"y": 75.947193674,
		"h": 2.7802197802
	},
	{
		"stop_id": 8580324,
		"ID": 806,
		"x": -2.1492794067,
		"y": 76.852172468,
		"h": 2.7802197802
	},
	{
		"stop_id": 8580328,
		"ID": 806,
		"x": -0.7562247797,
		"y": 76.568237967,
		"h": 2.7802197802
	},
	{
		"stop_id": 8581106,
		"ID": 806,
		"x": -4.5332786777,
		"y": 76.921178869,
		"h": 2.7802197802
	},
	{
		"stop_id": 8581294,
		"ID": 806,
		"x": 0.0067643803,
		"y": 76.792161525,
		"h": 2.7802197802
	},
	{
		"stop_id": 8581749,
		"ID": 806,
		"x": -1.5662548897,
		"y": 76.699206729,
		"h": 2.7802197802
	},
	{
		"stop_id": 8583727,
		"ID": 806,
		"x": -4.1902529857,
		"y": 76.897147884,
		"h": 2.7802197802
	},
	{
		"stop_id": 8583728,
		"ID": 806,
		"x": -4.1242676267,
		"y": 76.69317671,
		"h": 2.7802197802
	},
	{
		"stop_id": 8590291,
		"ID": 806,
		"x": 1.5367349653,
		"y": 77.624182735,
		"h": 2.7802197802
	},
	{
		"stop_id": 8500313,
		"ID": 594,
		"x": -34.9442460397,
		"y": 83.609220333,
		"h": 2.2197802198
	},
	{
		"stop_id": 8530697,
		"ID": 594,
		"x": -38.1022350037,
		"y": 83.119167915,
		"h": 2.2197802198
	},
	{
		"stop_id": 8578359,
		"ID": 594,
		"x": -34.9882864247,
		"y": 83.807175346,
		"h": 2.2197802198
	},
	{
		"stop_id": 8578360,
		"ID": 594,
		"x": -34.3522576157,
		"y": 84.127204124,
		"h": 2.2197802198
	},
	{
		"stop_id": 8583447,
		"ID": 594,
		"x": -34.6112694007,
		"y": 83.893156785,
		"h": 2.2197802198
	},
	{
		"stop_id": 8583448,
		"ID": 594,
		"x": -34.7352355447,
		"y": 83.924209534,
		"h": 2.2197802198
	},
	{
		"stop_id": 8594515,
		"ID": 594,
		"x": -33.5642911197,
		"y": 85.699192292,
		"h": 2.2197802198
	},
	{
		"stop_id": 8594518,
		"ID": 594,
		"x": -33.9872855137,
		"y": 85.296162247,
		"h": 2.2197802198
	},
	{
		"stop_id": 8594519,
		"ID": 594,
		"x": -33.6992951177,
		"y": 85.082159064,
		"h": 2.2197802198
	},
	{
		"stop_id": 8594520,
		"ID": 594,
		"x": -33.8212280197,
		"y": 85.564188171,
		"h": 2.2197802198
	},
	{
		"stop_id": 8594521,
		"ID": 594,
		"x": -34.0482696397,
		"y": 85.457233781,
		"h": 2.2197802198
	},
	{
		"stop_id": 8594522,
		"ID": 594,
		"x": -33.7462561087,
		"y": 85.201148157,
		"h": 2.2197802198
	},
	{
		"stop_id": 8594526,
		"ID": 594,
		"x": -33.6872555237,
		"y": 86.108163007,
		"h": 2.2197802198
	},
	{
		"stop_id": 8594527,
		"ID": 594,
		"x": -33.6682824277,
		"y": 85.047159633,
		"h": 2.2197802198
	},
	{
		"stop_id": 8594529,
		"ID": 594,
		"x": -33.2972959757,
		"y": 85.55116253,
		"h": 2.2197802198
	},
	{
		"stop_id": 8594531,
		"ID": 594,
		"x": -34.0552845347,
		"y": 85.218144899,
		"h": 2.2197802198
	},
	{
		"stop_id": 8594532,
		"ID": 594,
		"x": -33.6232850127,
		"y": 85.953223496,
		"h": 2.2197802198
	},
	{
		"stop_id": 8594533,
		"ID": 594,
		"x": -33.8902802137,
		"y": 85.022168564,
		"h": 2.2197802198
	},
	{
		"stop_id": 8595273,
		"ID": 594,
		"x": -36.5632814287,
		"y": 86.472242757,
		"h": 2.2197802198
	},
	{
		"stop_id": 8595274,
		"ID": 594,
		"x": -36.5252596267,
		"y": 86.217210435,
		"h": 2.2197802198
	},
	{
		"stop_id": 8595275,
		"ID": 594,
		"x": -36.8702420537,
		"y": 86.694207165,
		"h": 2.2197802198
	},
	{
		"stop_id": 8595276,
		"ID": 594,
		"x": -36.3472402317,
		"y": 85.95617011,
		"h": 2.2197802198
	},
	{
		"stop_id": 8595283,
		"ID": 594,
		"x": -37.1832865607,
		"y": 84.214140842,
		"h": 2.2197802198
	},
	{
		"stop_id": 8595284,
		"ID": 594,
		"x": -37.1832865607,
		"y": 84.214140842,
		"h": 2.2197802198
	},
	{
		"stop_id": 8595285,
		"ID": 594,
		"x": -37.6102587087,
		"y": 84.821180203,
		"h": 2.2197802198
	},
	{
		"stop_id": 8595286,
		"ID": 594,
		"x": -37.3992655527,
		"y": 84.497188293,
		"h": 2.2197802198
	},
	{
		"stop_id": 8595287,
		"ID": 594,
		"x": -37.2962668737,
		"y": 85.145145737,
		"h": 2.2197802198
	},
	{
		"stop_id": 8595304,
		"ID": 594,
		"x": -33.9252279207,
		"y": 85.821249747,
		"h": 2.2197802198
	},
	{
		"stop_id": 8595309,
		"ID": 594,
		"x": -34.2472568877,
		"y": 84.968249373,
		"h": 2.2197802198
	},
	{
		"stop_id": 8595313,
		"ID": 594,
		"x": -34.0942688197,
		"y": 84.575187545,
		"h": 2.2197802198
	},
	{
		"stop_id": 8595314,
		"ID": 594,
		"x": -34.4682864227,
		"y": 84.486183363,
		"h": 2.2197802198
	},
	{
		"stop_id": 8595315,
		"ID": 594,
		"x": -35.4052950977,
		"y": 84.638144036,
		"h": 2.2197802198
	},
	{
		"stop_id": 8595316,
		"ID": 594,
		"x": -35.2902417847,
		"y": 84.373208739,
		"h": 2.2197802198
	},
	{
		"stop_id": 8595317,
		"ID": 594,
		"x": -35.1622389257,
		"y": 84.67217177,
		"h": 2.2197802198
	},
	{
		"stop_id": 8595318,
		"ID": 594,
		"x": -35.0632602527,
		"y": 84.257179425,
		"h": 2.2197802198
	},
	{
		"stop_id": 8595319,
		"ID": 594,
		"x": -35.5372863437,
		"y": 84.538199302,
		"h": 2.2197802198
	},
	{
		"stop_id": 8595320,
		"ID": 594,
		"x": -34.8442446067,
		"y": 84.784245909,
		"h": 2.2197802198
	},
	{
		"stop_id": 8595321,
		"ID": 594,
		"x": -34.8862527677,
		"y": 84.338198955,
		"h": 2.2197802198
	},
	{
		"stop_id": 8500320,
		"ID": 691,
		"x": -21.3302762897,
		"y": 83.207170406,
		"h": 1.6593406593
	},
	{
		"stop_id": 8500584,
		"ID": 691,
		"x": -22.4112709197,
		"y": 82.142162243,
		"h": 1.6593406593
	},
	{
		"stop_id": 8572418,
		"ID": 691,
		"x": -19.0262547157,
		"y": 84.357178481,
		"h": 1.6593406593
	},
	{
		"stop_id": 8572419,
		"ID": 691,
		"x": -20.1542865647,
		"y": 84.38320829,
		"h": 1.6593406593
	},
	{
		"stop_id": 8572420,
		"ID": 691,
		"x": -20.6472346097,
		"y": 84.276186922,
		"h": 1.6593406593
	},
	{
		"stop_id": 8572421,
		"ID": 691,
		"x": -21.1312393987,
		"y": 83.719165026,
		"h": 1.6593406593
	},
	{
		"stop_id": 8572422,
		"ID": 691,
		"x": -20.8292682247,
		"y": 83.180202103,
		"h": 1.6593406593
	},
	{
		"stop_id": 8572429,
		"ID": 691,
		"x": -24.2462485867,
		"y": 83.858204405,
		"h": 1.6593406593
	},
	{
		"stop_id": 8572431,
		"ID": 691,
		"x": -23.9102888527,
		"y": 83.787178326,
		"h": 1.6593406593
	},
	{
		"stop_id": 8572432,
		"ID": 691,
		"x": -23.3292375647,
		"y": 83.649182052,
		"h": 1.6593406593
	},
	{
		"stop_id": 8572433,
		"ID": 691,
		"x": -22.1122292547,
		"y": 81.797144449,
		"h": 1.6593406593
	},
	{
		"stop_id": 8572434,
		"ID": 691,
		"x": -22.7672610317,
		"y": 82.448144934,
		"h": 1.6593406593
	},
	{
		"stop_id": 8572435,
		"ID": 691,
		"x": -21.1872253017,
		"y": 81.093153846,
		"h": 1.6593406593
	},
	{
		"stop_id": 8572748,
		"ID": 691,
		"x": -21.3422725127,
		"y": 83.234222978,
		"h": 1.6593406593
	},
	{
		"stop_id": 8580335,
		"ID": 691,
		"x": -23.3432331337,
		"y": 83.501212689,
		"h": 1.6593406593
	},
	{
		"stop_id": 8581530,
		"ID": 691,
		"x": -20.1572571607,
		"y": 83.050232943,
		"h": 1.6593406593
	},
	{
		"stop_id": 8581950,
		"ID": 691,
		"x": -18.8032512897,
		"y": 82.525180833,
		"h": 1.6593406593
	},
	{
		"stop_id": 8582500,
		"ID": 691,
		"x": -20.2912288997,
		"y": 80.265249565,
		"h": 1.6593406593
	},
	{
		"stop_id": 8582523,
		"ID": 691,
		"x": -23.5742964487,
		"y": 83.712168683,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583810,
		"ID": 691,
		"x": -20.3642668947,
		"y": 82.919202702,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583811,
		"ID": 691,
		"x": -20.8812752677,
		"y": 83.074229124,
		"h": 1.6593406593
	},
	{
		"stop_id": 8500322,
		"ID": 751,
		"x": -12.8802369167,
		"y": 85.288242178,
		"h": 1.6593406593
	},
	{
		"stop_id": 8500585,
		"ID": 751,
		"x": -13.0582463417,
		"y": 80.674164369,
		"h": 1.6593406593
	},
	{
		"stop_id": 8500588,
		"ID": 751,
		"x": -10.7332333057,
		"y": 84.782163423,
		"h": 1.6593406593
	},
	{
		"stop_id": 8500589,
		"ID": 751,
		"x": -10.0572453797,
		"y": 83.12915227,
		"h": 1.6593406593
	},
	{
		"stop_id": 8500983,
		"ID": 751,
		"x": -14.0632972527,
		"y": 83.063149245,
		"h": 1.6593406593
	},
	{
		"stop_id": 8572401,
		"ID": 751,
		"x": -14.0622975867,
		"y": 83.450214466,
		"h": 1.6593406593
	},
	{
		"stop_id": 8572402,
		"ID": 751,
		"x": -13.1742884127,
		"y": 84.771208888,
		"h": 1.6593406593
	},
	{
		"stop_id": 8572403,
		"ID": 751,
		"x": -12.9562266707,
		"y": 85.256172646,
		"h": 1.6593406593
	},
	{
		"stop_id": 8572415,
		"ID": 751,
		"x": -14.1412630787,
		"y": 83.468173807,
		"h": 1.6593406593
	},
	{
		"stop_id": 8572424,
		"ID": 751,
		"x": -12.7572729487,
		"y": 85.56519817,
		"h": 1.6593406593
	},
	{
		"stop_id": 8572436,
		"ID": 751,
		"x": -14.0332669617,
		"y": 82.334188978,
		"h": 1.6593406593
	},
	{
		"stop_id": 8572437,
		"ID": 751,
		"x": -13.1732937227,
		"y": 84.597201078,
		"h": 1.6593406593
	},
	{
		"stop_id": 8572438,
		"ID": 751,
		"x": -10.5242667507,
		"y": 83.940172214,
		"h": 1.6593406593
	},
	{
		"stop_id": 8572439,
		"ID": 751,
		"x": -10.2842722067,
		"y": 82.303205701,
		"h": 1.6593406593
	},
	{
		"stop_id": 8572440,
		"ID": 751,
		"x": -10.1842517447,
		"y": 81.726180479,
		"h": 1.6593406593
	},
	{
		"stop_id": 8580575,
		"ID": 751,
		"x": -10.2602596387,
		"y": 82.538243584,
		"h": 1.6593406593
	},
	{
		"stop_id": 8580733,
		"ID": 751,
		"x": -14.1162554097,
		"y": 82.520237984,
		"h": 1.6593406593
	},
	{
		"stop_id": 8581108,
		"ID": 751,
		"x": -10.1872339347,
		"y": 83.50122171,
		"h": 1.6593406593
	},
	{
		"stop_id": 8581949,
		"ID": 751,
		"x": -14.1332434067,
		"y": 82.809204158,
		"h": 1.6593406593
	},
	{
		"stop_id": 8582053,
		"ID": 751,
		"x": -13.3802342067,
		"y": 84.445242566,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583243,
		"ID": 751,
		"x": -13.3372957257,
		"y": 80.901243529,
		"h": 1.6593406593
	},
	{
		"stop_id": 8500329,
		"ID": 808,
		"x": -0.4512340717,
		"y": 89.911198809,
		"h": 1.5604395604
	},
	{
		"stop_id": 8503411,
		"ID": 808,
		"x": 0.5247602553,
		"y": 90.927188885,
		"h": 1.5604395604
	},
	{
		"stop_id": 8503570,
		"ID": 808,
		"x": -1.2912956137,
		"y": 87.690140049,
		"h": 1.5604395604
	},
	{
		"stop_id": 8503572,
		"ID": 808,
		"x": -2.5202616007,
		"y": 87.314163021,
		"h": 1.5604395604
	},
	{
		"stop_id": 8503685,
		"ID": 808,
		"x": -0.1632623317,
		"y": 87.153220401,
		"h": 1.5604395604
	},
	{
		"stop_id": 8503780,
		"ID": 808,
		"x": 0.2647596323,
		"y": 85.987226017,
		"h": 1.5604395604
	},
	{
		"stop_id": 8516176,
		"ID": 808,
		"x": 1.2087211063,
		"y": 87.899221462,
		"h": 1.5604395604
	},
	{
		"stop_id": 8572528,
		"ID": 808,
		"x": -1.1002647267,
		"y": 87.538251026,
		"h": 1.5604395604
	},
	{
		"stop_id": 8572529,
		"ID": 808,
		"x": -2.0902595157,
		"y": 87.669165047,
		"h": 1.5604395604
	},
	{
		"stop_id": 8572530,
		"ID": 808,
		"x": -0.9552725117,
		"y": 88.414243936,
		"h": 1.5604395604
	},
	{
		"stop_id": 8572531,
		"ID": 808,
		"x": -0.4772709537,
		"y": 89.905155147,
		"h": 1.5604395604
	},
	{
		"stop_id": 8572532,
		"ID": 808,
		"x": -0.8462358087,
		"y": 90.537171014,
		"h": 1.5604395604
	},
	{
		"stop_id": 8572536,
		"ID": 808,
		"x": -2.3032244367,
		"y": 90.140187515,
		"h": 1.5604395604
	},
	{
		"stop_id": 8572537,
		"ID": 808,
		"x": -3.8202450757,
		"y": 89.780247994,
		"h": 1.5604395604
	},
	{
		"stop_id": 8580184,
		"ID": 808,
		"x": -4.3312943477,
		"y": 88.762218445,
		"h": 1.5604395604
	},
	{
		"stop_id": 8580320,
		"ID": 808,
		"x": -1.2422808887,
		"y": 87.899227629,
		"h": 1.5604395604
	},
	{
		"stop_id": 8581109,
		"ID": 808,
		"x": 0.7327147703,
		"y": 86.81117259,
		"h": 1.5604395604
	},
	{
		"stop_id": 8581968,
		"ID": 808,
		"x": -2.9572321537,
		"y": 90.869198576,
		"h": 1.5604395604
	},
	{
		"stop_id": 8500385,
		"ID": 621,
		"x": -32.8312432897,
		"y": 56.543244032,
		"h": 1.7252747253
	},
	{
		"stop_id": 8500986,
		"ID": 621,
		"x": -32.7722744007,
		"y": 52.861219631,
		"h": 1.7252747253
	},
	{
		"stop_id": 8500992,
		"ID": 621,
		"x": -30.0872361007,
		"y": 53.39521217,
		"h": 1.7252747253
	},
	{
		"stop_id": 8502392,
		"ID": 621,
		"x": -29.0092632817,
		"y": 53.646171562,
		"h": 1.7252747253
	},
	{
		"stop_id": 8508102,
		"ID": 621,
		"x": -29.9642899237,
		"y": 52.446237628,
		"h": 1.7252747253
	},
	{
		"stop_id": 8572361,
		"ID": 621,
		"x": -29.0202319137,
		"y": 55.051214549,
		"h": 1.7252747253
	},
	{
		"stop_id": 8572362,
		"ID": 621,
		"x": -29.4222415877,
		"y": 54.164153301,
		"h": 1.7252747253
	},
	{
		"stop_id": 8572363,
		"ID": 621,
		"x": -29.6282808437,
		"y": 53.824228419,
		"h": 1.7252747253
	},
	{
		"stop_id": 8572364,
		"ID": 621,
		"x": -29.7652629097,
		"y": 53.575159522,
		"h": 1.7252747253
	},
	{
		"stop_id": 8572365,
		"ID": 621,
		"x": -30.4862522977,
		"y": 53.290171915,
		"h": 1.7252747253
	},
	{
		"stop_id": 8572366,
		"ID": 621,
		"x": -31.8812455907,
		"y": 52.953158128,
		"h": 1.7252747253
	},
	{
		"stop_id": 8572367,
		"ID": 621,
		"x": -32.4812785467,
		"y": 52.922249565,
		"h": 1.7252747253
	},
	{
		"stop_id": 8572368,
		"ID": 621,
		"x": -33.2162899197,
		"y": 52.918148578,
		"h": 1.7252747253
	},
	{
		"stop_id": 8572369,
		"ID": 621,
		"x": -34.2952427477,
		"y": 53.586184785,
		"h": 1.7252747253
	},
	{
		"stop_id": 8572695,
		"ID": 621,
		"x": -28.7922885007,
		"y": 54.336171102,
		"h": 1.7252747253
	},
	{
		"stop_id": 8572696,
		"ID": 621,
		"x": -29.5642536097,
		"y": 52.807142962,
		"h": 1.7252747253
	},
	{
		"stop_id": 8572697,
		"ID": 621,
		"x": -30.0142694187,
		"y": 52.452213696,
		"h": 1.7252747253
	},
	{
		"stop_id": 8572698,
		"ID": 621,
		"x": -29.7282547267,
		"y": 52.059183805,
		"h": 1.7252747253
	},
	{
		"stop_id": 8578021,
		"ID": 621,
		"x": -33.2262756617,
		"y": 56.311213803,
		"h": 1.7252747253
	},
	{
		"stop_id": 8578022,
		"ID": 621,
		"x": -32.4722339517,
		"y": 56.642163161,
		"h": 1.7252747253
	},
	{
		"stop_id": 8580330,
		"ID": 621,
		"x": -30.1732410167,
		"y": 52.369148157,
		"h": 1.7252747253
	},
	{
		"stop_id": 8580819,
		"ID": 621,
		"x": -29.9712513137,
		"y": 52.476221363,
		"h": 1.7252747253
	},
	{
		"stop_id": 8581290,
		"ID": 621,
		"x": -33.1082885817,
		"y": 56.260153298,
		"h": 1.7252747253
	},
	{
		"stop_id": 8500453,
		"ID": 487,
		"x": -51.8832769747,
		"y": 45.023141838,
		"h": 2.1208791209
	},
	{
		"stop_id": 8500458,
		"ID": 487,
		"x": -51.1012460437,
		"y": 45.362195674,
		"h": 2.1208791209
	},
	{
		"stop_id": 8508066,
		"ID": 487,
		"x": -53.0452525177,
		"y": 40.992151453,
		"h": 2.1208791209
	},
	{
		"stop_id": 8508068,
		"ID": 487,
		"x": -50.8932634607,
		"y": 43.211232904,
		"h": 2.1208791209
	},
	{
		"stop_id": 8508087,
		"ID": 487,
		"x": -50.8432300517,
		"y": 39.785199971,
		"h": 2.1208791209
	},
	{
		"stop_id": 8508088,
		"ID": 487,
		"x": -50.1472705287,
		"y": 41.747191159,
		"h": 2.1208791209
	},
	{
		"stop_id": 8508089,
		"ID": 487,
		"x": -50.0612801667,
		"y": 42.957147919,
		"h": 2.1208791209
	},
	{
		"stop_id": 8571480,
		"ID": 487,
		"x": -53.0712552177,
		"y": 40.987230805,
		"h": 2.1208791209
	},
	{
		"stop_id": 8578083,
		"ID": 487,
		"x": -51.1312581027,
		"y": 44.998159704,
		"h": 2.1208791209
	},
	{
		"stop_id": 8578084,
		"ID": 487,
		"x": -50.8512526257,
		"y": 44.628239177,
		"h": 2.1208791209
	},
	{
		"stop_id": 8578085,
		"ID": 487,
		"x": -50.6482800647,
		"y": 44.305242329,
		"h": 2.1208791209
	},
	{
		"stop_id": 8578086,
		"ID": 487,
		"x": -50.3612298197,
		"y": 43.300205265,
		"h": 2.1208791209
	},
	{
		"stop_id": 8578087,
		"ID": 487,
		"x": -50.2722874167,
		"y": 43.135248427,
		"h": 2.1208791209
	},
	{
		"stop_id": 8578090,
		"ID": 487,
		"x": -52.1892834377,
		"y": 45.348163,
		"h": 2.1208791209
	},
	{
		"stop_id": 8578091,
		"ID": 487,
		"x": -51.5582604447,
		"y": 44.73018143,
		"h": 2.1208791209
	},
	{
		"stop_id": 8578092,
		"ID": 487,
		"x": -51.0842822987,
		"y": 44.057228558,
		"h": 2.1208791209
	},
	{
		"stop_id": 8578093,
		"ID": 487,
		"x": -50.8372670847,
		"y": 43.733177687,
		"h": 2.1208791209
	},
	{
		"stop_id": 8578094,
		"ID": 487,
		"x": -50.9972787647,
		"y": 42.914239606,
		"h": 2.1208791209
	},
	{
		"stop_id": 8578095,
		"ID": 487,
		"x": -52.4312248367,
		"y": 42.119189922,
		"h": 2.1208791209
	},
	{
		"stop_id": 8578096,
		"ID": 487,
		"x": -52.8472492867,
		"y": 41.897235347,
		"h": 2.1208791209
	},
	{
		"stop_id": 8578097,
		"ID": 487,
		"x": -53.2632658497,
		"y": 41.639177887,
		"h": 2.1208791209
	},
	{
		"stop_id": 8588130,
		"ID": 487,
		"x": -49.4902656607,
		"y": 41.624207599,
		"h": 2.1208791209
	},
	{
		"stop_id": 8588131,
		"ID": 487,
		"x": -49.5712376047,
		"y": 41.89122536,
		"h": 2.1208791209
	},
	{
		"stop_id": 8588331,
		"ID": 487,
		"x": -49.8882876747,
		"y": 41.888249301,
		"h": 2.1208791209
	},
	{
		"stop_id": 8588332,
		"ID": 487,
		"x": -50.2202728397,
		"y": 43.744243868,
		"h": 2.1208791209
	},
	{
		"stop_id": 8588334,
		"ID": 487,
		"x": -49.0742644497,
		"y": 42.055185712,
		"h": 2.1208791209
	},
	{
		"stop_id": 8588592,
		"ID": 487,
		"x": -53.1422623657,
		"y": 45.090221187,
		"h": 2.1208791209
	},
	{
		"stop_id": 8589216,
		"ID": 487,
		"x": -50.7222922777,
		"y": 43.33022416,
		"h": 2.1208791209
	},
	{
		"stop_id": 8589239,
		"ID": 487,
		"x": -49.8522672297,
		"y": 42.250186706,
		"h": 2.1208791209
	},
	{
		"stop_id": 8589922,
		"ID": 487,
		"x": -52.9622734067,
		"y": 45.200153098,
		"h": 2.1208791209
	},
	{
		"stop_id": 8589954,
		"ID": 487,
		"x": -52.8422555057,
		"y": 45.27021999,
		"h": 2.1208791209
	},
	{
		"stop_id": 8589955,
		"ID": 487,
		"x": -52.4642430787,
		"y": 45.340151936,
		"h": 2.1208791209
	},
	{
		"stop_id": 8589959,
		"ID": 487,
		"x": -51.1592339587,
		"y": 45.22025072,
		"h": 2.1208791209
	},
	{
		"stop_id": 8591785,
		"ID": 487,
		"x": -50.8922396727,
		"y": 43.185219164,
		"h": 2.1208791209
	},
	{
		"stop_id": 8591787,
		"ID": 487,
		"x": -49.5892713947,
		"y": 40.499162047,
		"h": 2.1208791209
	},
	{
		"stop_id": 8500459,
		"ID": 519,
		"x": -47.6562797437,
		"y": 42.283236562,
		"h": 1.956043956
	},
	{
		"stop_id": 8500460,
		"ID": 519,
		"x": -47.9572579607,
		"y": 41.021232878,
		"h": 1.956043956
	},
	{
		"stop_id": 8500461,
		"ID": 519,
		"x": -47.3432310727,
		"y": 41.902209875,
		"h": 1.956043956
	},
	{
		"stop_id": 8500462,
		"ID": 519,
		"x": -44.7502777637,
		"y": 40.349242551,
		"h": 1.956043956
	},
	{
		"stop_id": 8500463,
		"ID": 519,
		"x": -43.8932926197,
		"y": 40.584145923,
		"h": 1.956043956
	},
	{
		"stop_id": 8500466,
		"ID": 519,
		"x": -44.8592691247,
		"y": 41.391244541,
		"h": 1.956043956
	},
	{
		"stop_id": 8500497,
		"ID": 519,
		"x": -43.6712449717,
		"y": 39.846198145,
		"h": 1.956043956
	},
	{
		"stop_id": 8508890,
		"ID": 519,
		"x": -46.9542729897,
		"y": 37.525157084,
		"h": 1.956043956
	},
	{
		"stop_id": 8508962,
		"ID": 519,
		"x": -46.5182860777,
		"y": 37.405146556,
		"h": 1.956043956
	},
	{
		"stop_id": 8508963,
		"ID": 519,
		"x": -46.6862316347,
		"y": 37.146184514,
		"h": 1.956043956
	},
	{
		"stop_id": 8576493,
		"ID": 519,
		"x": -47.1702575337,
		"y": 37.625201579,
		"h": 1.956043956
	},
	{
		"stop_id": 8576494,
		"ID": 519,
		"x": -45.4662706507,
		"y": 36.905165412,
		"h": 1.956043956
	},
	{
		"stop_id": 8578071,
		"ID": 519,
		"x": -48.0242708687,
		"y": 40.548159398,
		"h": 1.956043956
	},
	{
		"stop_id": 8578127,
		"ID": 519,
		"x": -46.5772910847,
		"y": 41.666153116,
		"h": 1.956043956
	},
	{
		"stop_id": 8581763,
		"ID": 519,
		"x": -47.8582724527,
		"y": 37.30016512,
		"h": 1.956043956
	},
	{
		"stop_id": 8581764,
		"ID": 519,
		"x": -47.6032471627,
		"y": 37.591177306,
		"h": 1.956043956
	},
	{
		"stop_id": 8588129,
		"ID": 519,
		"x": -48.7332974447,
		"y": 40.797180654,
		"h": 1.956043956
	},
	{
		"stop_id": 8588527,
		"ID": 519,
		"x": -45.0722338597,
		"y": 38.728169891,
		"h": 1.956043956
	},
	{
		"stop_id": 8588548,
		"ID": 519,
		"x": -43.8862992527,
		"y": 39.14921904,
		"h": 1.956043956
	},
	{
		"stop_id": 8588716,
		"ID": 519,
		"x": -46.1982790037,
		"y": 37.313142656,
		"h": 1.956043956
	},
	{
		"stop_id": 8593255,
		"ID": 519,
		"x": -43.7772709047,
		"y": 39.080247026,
		"h": 1.956043956
	},
	{
		"stop_id": 8593256,
		"ID": 519,
		"x": -44.1362497417,
		"y": 39.01414965,
		"h": 1.956043956
	},
	{
		"stop_id": 8593257,
		"ID": 519,
		"x": -44.9602960507,
		"y": 38.799153279,
		"h": 1.956043956
	},
	{
		"stop_id": 8593258,
		"ID": 519,
		"x": -45.0532501547,
		"y": 38.905207835,
		"h": 1.956043956
	},
	{
		"stop_id": 8593259,
		"ID": 519,
		"x": -46.2242332877,
		"y": 37.584239964,
		"h": 1.956043956
	},
	{
		"stop_id": 8593260,
		"ID": 519,
		"x": -47.0482675167,
		"y": 37.807230481,
		"h": 1.956043956
	},
	{
		"stop_id": 8593261,
		"ID": 519,
		"x": -46.4782712257,
		"y": 39.033174358,
		"h": 1.956043956
	},
	{
		"stop_id": 8593262,
		"ID": 519,
		"x": -45.9482800497,
		"y": 39.18824047,
		"h": 1.956043956
	},
	{
		"stop_id": 8593266,
		"ID": 519,
		"x": -47.4052733237,
		"y": 37.723213499,
		"h": 1.956043956
	},
	{
		"stop_id": 8594293,
		"ID": 519,
		"x": -46.1412423667,
		"y": 37.455242663,
		"h": 1.956043956
	},
	{
		"stop_id": 8500551,
		"ID": 779,
		"x": -4.4172609967,
		"y": 76.508188302,
		"h": 2.021978022
	},
	{
		"stop_id": 8500553,
		"ID": 779,
		"x": -8.4252551917,
		"y": 72.137248287,
		"h": 2.021978022
	},
	{
		"stop_id": 8500565,
		"ID": 779,
		"x": -6.9892490447,
		"y": 76.566202174,
		"h": 2.021978022
	},
	{
		"stop_id": 8500570,
		"ID": 779,
		"x": -5.5092546037,
		"y": 76.810190758,
		"h": 2.021978022
	},
	{
		"stop_id": 8500571,
		"ID": 779,
		"x": -6.0042969217,
		"y": 71.824155059,
		"h": 2.021978022
	},
	{
		"stop_id": 8500573,
		"ID": 779,
		"x": -5.6312474517,
		"y": 74.629190259,
		"h": 2.021978022
	},
	{
		"stop_id": 8500575,
		"ID": 779,
		"x": -3.8252651087,
		"y": 75.163232894,
		"h": 2.021978022
	},
	{
		"stop_id": 8500580,
		"ID": 779,
		"x": -5.4092246857,
		"y": 76.407153285,
		"h": 2.021978022
	},
	{
		"stop_id": 8500581,
		"ID": 779,
		"x": -7.5142474647,
		"y": 72.138207817,
		"h": 2.021978022
	},
	{
		"stop_id": 8500979,
		"ID": 779,
		"x": -6.7962990817,
		"y": 72.783141227,
		"h": 2.021978022
	},
	{
		"stop_id": 8502116,
		"ID": 779,
		"x": -4.8172466317,
		"y": 73.350222278,
		"h": 2.021978022
	},
	{
		"stop_id": 8502680,
		"ID": 779,
		"x": -4.9782672947,
		"y": 74.092144494,
		"h": 2.021978022
	},
	{
		"stop_id": 8502875,
		"ID": 779,
		"x": -5.0452351067,
		"y": 75.406235437,
		"h": 2.021978022
	},
	{
		"stop_id": 8502951,
		"ID": 779,
		"x": -3.3792396407,
		"y": 74.500210946,
		"h": 2.021978022
	},
	{
		"stop_id": 8503890,
		"ID": 779,
		"x": -7.5952541477,
		"y": 76.246162801,
		"h": 2.021978022
	},
	{
		"stop_id": 8503891,
		"ID": 779,
		"x": -7.4292878627,
		"y": 75.430159283,
		"h": 2.021978022
	},
	{
		"stop_id": 8572461,
		"ID": 779,
		"x": -7.7502772517,
		"y": 76.645194249,
		"h": 2.021978022
	},
	{
		"stop_id": 8572462,
		"ID": 779,
		"x": -7.2782958307,
		"y": 76.342141617,
		"h": 2.021978022
	},
	{
		"stop_id": 8572463,
		"ID": 779,
		"x": -7.0482275017,
		"y": 77.196237094,
		"h": 2.021978022
	},
	{
		"stop_id": 8572470,
		"ID": 779,
		"x": -6.6892723517,
		"y": 71.975199949,
		"h": 2.021978022
	},
	{
		"stop_id": 8572471,
		"ID": 779,
		"x": -6.2612407757,
		"y": 71.657158498,
		"h": 2.021978022
	},
	{
		"stop_id": 8572472,
		"ID": 779,
		"x": -6.3102628827,
		"y": 71.831171164,
		"h": 2.021978022
	},
	{
		"stop_id": 8572473,
		"ID": 779,
		"x": -6.2732460097,
		"y": 72.6942202,
		"h": 2.021978022
	},
	{
		"stop_id": 8572474,
		"ID": 779,
		"x": -6.8372856757,
		"y": 72.761204207,
		"h": 2.021978022
	},
	{
		"stop_id": 8572475,
		"ID": 779,
		"x": -6.5452379517,
		"y": 72.988200406,
		"h": 2.021978022
	},
	{
		"stop_id": 8572476,
		"ID": 779,
		"x": -7.0112453927,
		"y": 72.620221516,
		"h": 2.021978022
	},
	{
		"stop_id": 8572525,
		"ID": 779,
		"x": -3.5252775297,
		"y": 75.117151065,
		"h": 2.021978022
	},
	{
		"stop_id": 8572526,
		"ID": 779,
		"x": -4.8872443457,
		"y": 74.173155114,
		"h": 2.021978022
	},
	{
		"stop_id": 8580932,
		"ID": 779,
		"x": -6.3652631687,
		"y": 73.29614641,
		"h": 2.021978022
	},
	{
		"stop_id": 8581107,
		"ID": 779,
		"x": -4.9772811867,
		"y": 77.06515856,
		"h": 2.021978022
	},
	{
		"stop_id": 8582953,
		"ID": 779,
		"x": -5.9792523717,
		"y": 74.100203168,
		"h": 2.021978022
	},
	{
		"stop_id": 8583662,
		"ID": 779,
		"x": -4.6892309997,
		"y": 73.063208101,
		"h": 2.021978022
	},
	{
		"stop_id": 8500554,
		"ID": 780,
		"x": -5.3112640967,
		"y": 77.746233639,
		"h": 1.3296703297
	},
	{
		"stop_id": 8500558,
		"ID": 780,
		"x": -6.5722262247,
		"y": 80.60316585,
		"h": 1.3296703297
	},
	{
		"stop_id": 8500568,
		"ID": 780,
		"x": -5.4342700607,
		"y": 79.914222606,
		"h": 1.3296703297
	},
	{
		"stop_id": 8500569,
		"ID": 780,
		"x": -7.0102716267,
		"y": 82.151148617,
		"h": 1.3296703297
	},
	{
		"stop_id": 8500579,
		"ID": 780,
		"x": -6.5042859097,
		"y": 77.816213071,
		"h": 1.3296703297
	},
	{
		"stop_id": 8500767,
		"ID": 780,
		"x": -5.6152632497,
		"y": 78.42815856,
		"h": 1.3296703297
	},
	{
		"stop_id": 8500776,
		"ID": 780,
		"x": -5.5122505137,
		"y": 81.927193925,
		"h": 1.3296703297
	},
	{
		"stop_id": 8572448,
		"ID": 780,
		"x": -7.1092562487,
		"y": 82.662195601,
		"h": 1.3296703297
	},
	{
		"stop_id": 8572480,
		"ID": 780,
		"x": -5.2622675767,
		"y": 78.555154939,
		"h": 1.3296703297
	},
	{
		"stop_id": 8572481,
		"ID": 780,
		"x": -5.8602797577,
		"y": 78.300164582,
		"h": 1.3296703297
	},
	{
		"stop_id": 8572482,
		"ID": 780,
		"x": -6.2412552837,
		"y": 78.264238924,
		"h": 1.3296703297
	},
	{
		"stop_id": 8500556,
		"ID": 781,
		"x": -7.4982672637,
		"y": 85.431225052,
		"h": 1.4285714286
	},
	{
		"stop_id": 8500557,
		"ID": 781,
		"x": -7.9532525307,
		"y": 85.793156527,
		"h": 1.4285714286
	},
	{
		"stop_id": 8500560,
		"ID": 781,
		"x": -7.5892629707,
		"y": 84.476162198,
		"h": 1.4285714286
	},
	{
		"stop_id": 8500777,
		"ID": 781,
		"x": -7.3912973917,
		"y": 83.483182227,
		"h": 1.4285714286
	},
	{
		"stop_id": 8500784,
		"ID": 781,
		"x": -5.1982295057,
		"y": 83.912204812,
		"h": 1.4285714286
	},
	{
		"stop_id": 8500785,
		"ID": 781,
		"x": -6.0822417257,
		"y": 85.473159618,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572442,
		"ID": 781,
		"x": -9.0992741357,
		"y": 86.351197294,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572443,
		"ID": 781,
		"x": -6.3922856587,
		"y": 85.568202135,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572444,
		"ID": 781,
		"x": -5.8882443557,
		"y": 85.262211556,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572445,
		"ID": 781,
		"x": -5.3682906757,
		"y": 84.165158713,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572446,
		"ID": 781,
		"x": -7.4532267127,
		"y": 84.781143547,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572447,
		"ID": 781,
		"x": -7.2512933927,
		"y": 83.224233372,
		"h": 1.4285714286
	},
	{
		"stop_id": 8580181,
		"ID": 781,
		"x": -9.2302351847,
		"y": 86.644182583,
		"h": 1.4285714286
	},
	{
		"stop_id": 8580329,
		"ID": 781,
		"x": -6.6182394137,
		"y": 88.272182107,
		"h": 1.4285714286
	},
	{
		"stop_id": 8500561,
		"ID": 807,
		"x": -3.2012352637,
		"y": 80.425175214,
		"h": 1.4615384615
	},
	{
		"stop_id": 8500566,
		"ID": 807,
		"x": -0.0192327307,
		"y": 80.470247601,
		"h": 1.4615384615
	},
	{
		"stop_id": 8500572,
		"ID": 807,
		"x": -1.2352349197,
		"y": 81.32617149,
		"h": 1.4615384615
	},
	{
		"stop_id": 8503569,
		"ID": 807,
		"x": -3.4152777467,
		"y": 84.032228765,
		"h": 1.4615384615
	},
	{
		"stop_id": 8503573,
		"ID": 807,
		"x": -2.7572522317,
		"y": 85.861228156,
		"h": 1.4615384615
	},
	{
		"stop_id": 8503590,
		"ID": 807,
		"x": -0.7212573037,
		"y": 85.178247946,
		"h": 1.4615384615
	},
	{
		"stop_id": 8503592,
		"ID": 807,
		"x": -0.7782293597,
		"y": 82.98215444,
		"h": 1.4615384615
	},
	{
		"stop_id": 8503599,
		"ID": 807,
		"x": -0.1412963487,
		"y": 83.03524478,
		"h": 1.4615384615
	},
	{
		"stop_id": 8572491,
		"ID": 807,
		"x": -1.2972909667,
		"y": 81.851166843,
		"h": 1.4615384615
	},
	{
		"stop_id": 8572492,
		"ID": 807,
		"x": -0.6942726537,
		"y": 84.87317802,
		"h": 1.4615384615
	},
	{
		"stop_id": 8577360,
		"ID": 807,
		"x": -0.7552501857,
		"y": 84.195174321,
		"h": 1.4615384615
	},
	{
		"stop_id": 8580326,
		"ID": 807,
		"x": 1.6587454343,
		"y": 82.681172673,
		"h": 1.4615384615
	},
	{
		"stop_id": 8581570,
		"ID": 807,
		"x": -0.0062297957,
		"y": 80.376198656,
		"h": 1.4615384615
	},
	{
		"stop_id": 8581907,
		"ID": 807,
		"x": 0.9477650943,
		"y": 81.645177017,
		"h": 1.4615384615
	},
	{
		"stop_id": 8582955,
		"ID": 807,
		"x": -0.9622364947,
		"y": 81.117168291,
		"h": 1.4615384615
	},
	{
		"stop_id": 8500567,
		"ID": 749,
		"x": -9.3722507757,
		"y": 71.87116107,
		"h": 1.3626373626
	},
	{
		"stop_id": 8500591,
		"ID": 749,
		"x": -13.3472629577,
		"y": 72.645246466,
		"h": 1.3626373626
	},
	{
		"stop_id": 8500592,
		"ID": 749,
		"x": -13.4502337817,
		"y": 69.963154187,
		"h": 1.3626373626
	},
	{
		"stop_id": 8502682,
		"ID": 749,
		"x": -13.3872728677,
		"y": 70.76019155,
		"h": 1.3626373626
	},
	{
		"stop_id": 8502893,
		"ID": 749,
		"x": -12.8412806147,
		"y": 71.280176472,
		"h": 1.3626373626
	},
	{
		"stop_id": 8572391,
		"ID": 749,
		"x": -13.3982474637,
		"y": 73.406151972,
		"h": 1.3626373626
	},
	{
		"stop_id": 8572477,
		"ID": 749,
		"x": -9.5612515377,
		"y": 71.839202266,
		"h": 1.3626373626
	},
	{
		"stop_id": 8572478,
		"ID": 749,
		"x": -9.9152593597,
		"y": 71.469181335,
		"h": 1.3626373626
	},
	{
		"stop_id": 8578662,
		"ID": 749,
		"x": -11.8562821867,
		"y": 68.843158898,
		"h": 1.3626373626
	},
	{
		"stop_id": 8578663,
		"ID": 749,
		"x": -11.3662472827,
		"y": 69.068178879,
		"h": 1.3626373626
	},
	{
		"stop_id": 8578664,
		"ID": 749,
		"x": -11.0332992207,
		"y": 69.054228303,
		"h": 1.3626373626
	},
	{
		"stop_id": 8578665,
		"ID": 749,
		"x": -10.5592827457,
		"y": 69.121186896,
		"h": 1.3626373626
	},
	{
		"stop_id": 8500574,
		"ID": 778,
		"x": -5.3722491997,
		"y": 70.531239799,
		"h": 2.5164835165
	},
	{
		"stop_id": 8502104,
		"ID": 778,
		"x": -7.8662550897,
		"y": 66.263180829,
		"h": 2.5164835165
	},
	{
		"stop_id": 8502114,
		"ID": 778,
		"x": -7.7852931027,
		"y": 67.932140172,
		"h": 2.5164835165
	},
	{
		"stop_id": 8502115,
		"ID": 778,
		"x": -5.0762475487,
		"y": 69.289210364,
		"h": 2.5164835165
	},
	{
		"stop_id": 8502119,
		"ID": 778,
		"x": -4.4942891027,
		"y": 66.617205237,
		"h": 2.5164835165
	},
	{
		"stop_id": 8502128,
		"ID": 778,
		"x": -4.8182747187,
		"y": 70.777185388,
		"h": 2.5164835165
	},
	{
		"stop_id": 8502557,
		"ID": 778,
		"x": -6.7192436537,
		"y": 69.373235445,
		"h": 2.5164835165
	},
	{
		"stop_id": 8502681,
		"ID": 778,
		"x": -4.6242420507,
		"y": 66.967236544,
		"h": 2.5164835165
	},
	{
		"stop_id": 8502981,
		"ID": 778,
		"x": -4.0992825287,
		"y": 67.803159148,
		"h": 2.5164835165
	},
	{
		"stop_id": 8572465,
		"ID": 778,
		"x": -5.0182271447,
		"y": 69.299197012,
		"h": 2.5164835165
	},
	{
		"stop_id": 8572466,
		"ID": 778,
		"x": -5.9702538377,
		"y": 69.295149591,
		"h": 2.5164835165
	},
	{
		"stop_id": 8572467,
		"ID": 778,
		"x": -7.0612843927,
		"y": 69.383193163,
		"h": 2.5164835165
	},
	{
		"stop_id": 8572468,
		"ID": 778,
		"x": -5.4092294307,
		"y": 69.775152931,
		"h": 2.5164835165
	},
	{
		"stop_id": 8572469,
		"ID": 778,
		"x": -5.9802958437,
		"y": 71.324245864,
		"h": 2.5164835165
	},
	{
		"stop_id": 8577957,
		"ID": 778,
		"x": -5.5552330487,
		"y": 69.616150726,
		"h": 2.5164835165
	},
	{
		"stop_id": 8578688,
		"ID": 778,
		"x": -4.1782567157,
		"y": 69.78423617,
		"h": 2.5164835165
	},
	{
		"stop_id": 8578689,
		"ID": 778,
		"x": -3.8432858387,
		"y": 69.642175393,
		"h": 2.5164835165
	},
	{
		"stop_id": 8578690,
		"ID": 778,
		"x": -3.6472526627,
		"y": 69.406196241,
		"h": 2.5164835165
	},
	{
		"stop_id": 8578691,
		"ID": 778,
		"x": -4.0812594887,
		"y": 68.954236043,
		"h": 2.5164835165
	},
	{
		"stop_id": 8578692,
		"ID": 778,
		"x": -4.1202417957,
		"y": 68.371244058,
		"h": 2.5164835165
	},
	{
		"stop_id": 8578693,
		"ID": 778,
		"x": -3.9152523087,
		"y": 67.508240828,
		"h": 2.5164835165
	},
	{
		"stop_id": 8578694,
		"ID": 778,
		"x": -4.1882927877,
		"y": 67.377141884,
		"h": 2.5164835165
	},
	{
		"stop_id": 8578695,
		"ID": 778,
		"x": -4.2502653627,
		"y": 66.997188972,
		"h": 2.5164835165
	},
	{
		"stop_id": 8578698,
		"ID": 778,
		"x": -4.6332417477,
		"y": 66.051191211,
		"h": 2.5164835165
	},
	{
		"stop_id": 8578700,
		"ID": 778,
		"x": -5.1442703077,
		"y": 65.85021698,
		"h": 2.5164835165
	},
	{
		"stop_id": 8578734,
		"ID": 778,
		"x": -4.5462539157,
		"y": 66.181200187,
		"h": 2.5164835165
	},
	{
		"stop_id": 8578735,
		"ID": 778,
		"x": -4.4882961257,
		"y": 66.371203384,
		"h": 2.5164835165
	},
	{
		"stop_id": 8578736,
		"ID": 778,
		"x": -4.4292835817,
		"y": 66.577228116,
		"h": 2.5164835165
	},
	{
		"stop_id": 8578737,
		"ID": 778,
		"x": -4.8072678337,
		"y": 66.504220634,
		"h": 2.5164835165
	},
	{
		"stop_id": 8578738,
		"ID": 778,
		"x": -5.1762775297,
		"y": 66.464231429,
		"h": 2.5164835165
	},
	{
		"stop_id": 8578739,
		"ID": 778,
		"x": -5.3592351007,
		"y": 66.341244707,
		"h": 2.5164835165
	},
	{
		"stop_id": 8578742,
		"ID": 778,
		"x": -6.8342844777,
		"y": 66.222156439,
		"h": 2.5164835165
	},
	{
		"stop_id": 8578744,
		"ID": 778,
		"x": -6.7492608297,
		"y": 66.070145109,
		"h": 2.5164835165
	},
	{
		"stop_id": 8578745,
		"ID": 778,
		"x": -4.9902504447,
		"y": 66.401235893,
		"h": 2.5164835165
	},
	{
		"stop_id": 8580894,
		"ID": 778,
		"x": -7.1452507877,
		"y": 69.541223441,
		"h": 2.5164835165
	},
	{
		"stop_id": 8580895,
		"ID": 778,
		"x": -6.7332951627,
		"y": 69.518209978,
		"h": 2.5164835165
	},
	{
		"stop_id": 8580896,
		"ID": 778,
		"x": -6.8752655727,
		"y": 69.765224175,
		"h": 2.5164835165
	},
	{
		"stop_id": 8580897,
		"ID": 778,
		"x": -7.3742502397,
		"y": 69.408215546,
		"h": 2.5164835165
	},
	{
		"stop_id": 8580899,
		"ID": 778,
		"x": -7.6362472207,
		"y": 69.353202546,
		"h": 2.5164835165
	},
	{
		"stop_id": 8588570,
		"ID": 778,
		"x": -7.8242980447,
		"y": 67.309150056,
		"h": 2.5164835165
	},
	{
		"stop_id": 8588573,
		"ID": 778,
		"x": -7.6422946717,
		"y": 66.091248871,
		"h": 2.5164835165
	},
	{
		"stop_id": 8588575,
		"ID": 778,
		"x": -7.7882625557,
		"y": 67.909209557,
		"h": 2.5164835165
	},
	{
		"stop_id": 8588576,
		"ID": 778,
		"x": -8.0092721377,
		"y": 65.848205374,
		"h": 2.5164835165
	},
	{
		"stop_id": 8588577,
		"ID": 778,
		"x": -8.0222689797,
		"y": 66.325194026,
		"h": 2.5164835165
	},
	{
		"stop_id": 8588870,
		"ID": 778,
		"x": -4.9422275807,
		"y": 69.250198388,
		"h": 2.5164835165
	},
	{
		"stop_id": 8590242,
		"ID": 778,
		"x": -5.1392803177,
		"y": 66.292231895,
		"h": 2.5164835165
	},
	{
		"stop_id": 8595641,
		"ID": 778,
		"x": -5.1192510267,
		"y": 66.167219637,
		"h": 2.5164835165
	},
	{
		"stop_id": 8500582,
		"ID": 750,
		"x": -10.0192395407,
		"y": 79.396221516,
		"h": 1.5274725275
	},
	{
		"stop_id": 8500595,
		"ID": 750,
		"x": -12.8422879457,
		"y": 78.69723994,
		"h": 1.5274725275
	},
	{
		"stop_id": 8500975,
		"ID": 750,
		"x": -11.1632926027,
		"y": 78.231225096,
		"h": 1.5274725275
	},
	{
		"stop_id": 8500976,
		"ID": 750,
		"x": -10.9822332407,
		"y": 76.084193911,
		"h": 1.5274725275
	},
	{
		"stop_id": 8500978,
		"ID": 750,
		"x": -13.6142243917,
		"y": 75.833157381,
		"h": 1.5274725275
	},
	{
		"stop_id": 8500982,
		"ID": 750,
		"x": -13.7522427387,
		"y": 76.976219665,
		"h": 1.5274725275
	},
	{
		"stop_id": 8572393,
		"ID": 750,
		"x": -13.3572864857,
		"y": 75.320249371,
		"h": 1.5274725275
	},
	{
		"stop_id": 8572394,
		"ID": 750,
		"x": -13.4742529497,
		"y": 76.472141647,
		"h": 1.5274725275
	},
	{
		"stop_id": 8572395,
		"ID": 750,
		"x": -14.1292857027,
		"y": 77.28418705,
		"h": 1.5274725275
	},
	{
		"stop_id": 8572451,
		"ID": 750,
		"x": -12.4662726207,
		"y": 78.600161629,
		"h": 1.5274725275
	},
	{
		"stop_id": 8572452,
		"ID": 750,
		"x": -11.1802615577,
		"y": 78.095211466,
		"h": 1.5274725275
	},
	{
		"stop_id": 8572454,
		"ID": 750,
		"x": -10.6422309217,
		"y": 77.925194704,
		"h": 1.5274725275
	},
	{
		"stop_id": 8572455,
		"ID": 750,
		"x": -9.6072403827,
		"y": 77.418174308,
		"h": 1.5274725275
	},
	{
		"stop_id": 8572457,
		"ID": 750,
		"x": -9.8792615277,
		"y": 77.242196861,
		"h": 1.5274725275
	},
	{
		"stop_id": 8572458,
		"ID": 750,
		"x": -10.0492555267,
		"y": 76.322227669,
		"h": 1.5274725275
	},
	{
		"stop_id": 8572459,
		"ID": 750,
		"x": -10.7732446347,
		"y": 76.263155442,
		"h": 1.5274725275
	},
	{
		"stop_id": 8572460,
		"ID": 750,
		"x": -11.1352890707,
		"y": 76.014219881,
		"h": 1.5274725275
	},
	{
		"stop_id": 8500586,
		"ID": 690,
		"x": -20.0672334457,
		"y": 80.101186155,
		"h": 1.3626373626
	},
	{
		"stop_id": 8500772,
		"ID": 690,
		"x": -22.7052466717,
		"y": 78.18119843,
		"h": 1.3626373626
	},
	{
		"stop_id": 8500793,
		"ID": 690,
		"x": -19.0652462927,
		"y": 76.491232634,
		"h": 1.3626373626
	},
	{
		"stop_id": 8500973,
		"ID": 690,
		"x": -23.1462824647,
		"y": 79.617237925,
		"h": 1.3626373626
	},
	{
		"stop_id": 8572267,
		"ID": 690,
		"x": -22.9052730237,
		"y": 79.228237556,
		"h": 1.3626373626
	},
	{
		"stop_id": 8572268,
		"ID": 690,
		"x": -22.4432378897,
		"y": 78.635159211,
		"h": 1.3626373626
	},
	{
		"stop_id": 8572269,
		"ID": 690,
		"x": -22.5162918897,
		"y": 78.378186937,
		"h": 1.3626373626
	},
	{
		"stop_id": 8572292,
		"ID": 690,
		"x": -24.6552944357,
		"y": 77.094240268,
		"h": 1.3626373626
	},
	{
		"stop_id": 8572408,
		"ID": 690,
		"x": -18.7582444757,
		"y": 76.666248244,
		"h": 1.3626373626
	},
	{
		"stop_id": 8572409,
		"ID": 690,
		"x": -19.2952703247,
		"y": 76.322206842,
		"h": 1.3626373626
	},
	{
		"stop_id": 8572410,
		"ID": 690,
		"x": -19.6522348087,
		"y": 76.062155567,
		"h": 1.3626373626
	},
	{
		"stop_id": 8582502,
		"ID": 690,
		"x": -20.8492722007,
		"y": 79.316223014,
		"h": 1.3626373626
	},
	{
		"stop_id": 8500593,
		"ID": 720,
		"x": -16.1962314777,
		"y": 73.093159943,
		"h": 1.2967032967
	},
	{
		"stop_id": 8500794,
		"ID": 720,
		"x": -17.5552657567,
		"y": 74.274144081,
		"h": 1.2967032967
	},
	{
		"stop_id": 8500795,
		"ID": 720,
		"x": -16.9452812347,
		"y": 73.236246627,
		"h": 1.2967032967
	},
	{
		"stop_id": 8500796,
		"ID": 720,
		"x": -15.1492469557,
		"y": 71.600140477,
		"h": 1.2967032967
	},
	{
		"stop_id": 8500977,
		"ID": 720,
		"x": -13.4932313547,
		"y": 73.729189501,
		"h": 1.2967032967
	},
	{
		"stop_id": 8572392,
		"ID": 720,
		"x": -13.7552931047,
		"y": 74.477225202,
		"h": 1.2967032967
	},
	{
		"stop_id": 8572405,
		"ID": 720,
		"x": -15.2312942547,
		"y": 72.409190582,
		"h": 1.2967032967
	},
	{
		"stop_id": 8572406,
		"ID": 720,
		"x": -17.4282725117,
		"y": 73.808172424,
		"h": 1.2967032967
	},
	{
		"stop_id": 8572407,
		"ID": 720,
		"x": -17.7252468627,
		"y": 74.69122461,
		"h": 1.2967032967
	},
	{
		"stop_id": 8582073,
		"ID": 720,
		"x": -18.2072724647,
		"y": 76.743250674,
		"h": 1.2967032967
	},
	{
		"stop_id": 8500596,
		"ID": 655,
		"x": -28.0792740957,
		"y": 57.385174704,
		"h": 1.9230769231
	},
	{
		"stop_id": 8502000,
		"ID": 655,
		"x": -24.2412772327,
		"y": 58.580172373,
		"h": 1.9230769231
	},
	{
		"stop_id": 8502361,
		"ID": 655,
		"x": -23.8342297157,
		"y": 57.630233154,
		"h": 1.9230769231
	},
	{
		"stop_id": 8502365,
		"ID": 655,
		"x": -25.4582827627,
		"y": 56.905184087,
		"h": 1.9230769231
	},
	{
		"stop_id": 8502378,
		"ID": 655,
		"x": -25.6862603647,
		"y": 56.939228742,
		"h": 1.9230769231
	},
	{
		"stop_id": 8502382,
		"ID": 655,
		"x": -24.5632350687,
		"y": 57.003141815,
		"h": 1.9230769231
	},
	{
		"stop_id": 8502383,
		"ID": 655,
		"x": -23.8192752297,
		"y": 58.208248048,
		"h": 1.9230769231
	},
	{
		"stop_id": 8502713,
		"ID": 655,
		"x": -27.0992979297,
		"y": 56.112224998,
		"h": 1.9230769231
	},
	{
		"stop_id": 8508103,
		"ID": 655,
		"x": -26.4112587297,
		"y": 57.031178385,
		"h": 1.9230769231
	},
	{
		"stop_id": 8572354,
		"ID": 655,
		"x": -24.5402442777,
		"y": 59.567248643,
		"h": 1.9230769231
	},
	{
		"stop_id": 8572355,
		"ID": 655,
		"x": -24.9392931127,
		"y": 58.74214749,
		"h": 1.9230769231
	},
	{
		"stop_id": 8572356,
		"ID": 655,
		"x": -26.3142772277,
		"y": 57.751179754,
		"h": 1.9230769231
	},
	{
		"stop_id": 8572358,
		"ID": 655,
		"x": -28.5152932467,
		"y": 57.25623174,
		"h": 1.9230769231
	},
	{
		"stop_id": 8572359,
		"ID": 655,
		"x": -28.3542684487,
		"y": 56.735194862,
		"h": 1.9230769231
	},
	{
		"stop_id": 8572360,
		"ID": 655,
		"x": -28.5172745737,
		"y": 55.877240802,
		"h": 1.9230769231
	},
	{
		"stop_id": 8572683,
		"ID": 655,
		"x": -24.2702317067,
		"y": 58.567213423,
		"h": 1.9230769231
	},
	{
		"stop_id": 8572687,
		"ID": 655,
		"x": -24.0082897857,
		"y": 57.327213398,
		"h": 1.9230769231
	},
	{
		"stop_id": 8572688,
		"ID": 655,
		"x": -24.8712302697,
		"y": 56.935172985,
		"h": 1.9230769231
	},
	{
		"stop_id": 8572690,
		"ID": 655,
		"x": -26.4782977287,
		"y": 56.997225878,
		"h": 1.9230769231
	},
	{
		"stop_id": 8572691,
		"ID": 655,
		"x": -26.5692407187,
		"y": 56.612140746,
		"h": 1.9230769231
	},
	{
		"stop_id": 8572692,
		"ID": 655,
		"x": -26.5562683627,
		"y": 56.334148551,
		"h": 1.9230769231
	},
	{
		"stop_id": 8572693,
		"ID": 655,
		"x": -26.8252893917,
		"y": 56.156207611,
		"h": 1.9230769231
	},
	{
		"stop_id": 8572694,
		"ID": 655,
		"x": -28.0022463767,
		"y": 55.875188005,
		"h": 1.9230769231
	},
	{
		"stop_id": 8582506,
		"ID": 655,
		"x": -24.8202583857,
		"y": 59.237162602,
		"h": 1.9230769231
	},
	{
		"stop_id": 8590161,
		"ID": 655,
		"x": -24.9052690037,
		"y": 58.548222879,
		"h": 1.9230769231
	},
	{
		"stop_id": 8594490,
		"ID": 655,
		"x": -27.3662283807,
		"y": 56.323232159,
		"h": 1.9230769231
	},
	{
		"stop_id": 8595159,
		"ID": 655,
		"x": -24.5662770527,
		"y": 55.805142369,
		"h": 1.9230769231
	},
	{
		"stop_id": 8595160,
		"ID": 655,
		"x": -24.7712506987,
		"y": 56.369179102,
		"h": 1.9230769231
	},
	{
		"stop_id": 8595512,
		"ID": 655,
		"x": -25.8672565857,
		"y": 57.010239745,
		"h": 1.9230769231
	},
	{
		"stop_id": 8500599,
		"ID": 719,
		"x": -18.3562483727,
		"y": 70.662246369,
		"h": 2.1868131868
	},
	{
		"stop_id": 8500687,
		"ID": 719,
		"x": -14.5462612007,
		"y": 70.077220678,
		"h": 2.1868131868
	},
	{
		"stop_id": 8502683,
		"ID": 719,
		"x": -13.7672606847,
		"y": 68.973235287,
		"h": 2.1868131868
	},
	{
		"stop_id": 8502684,
		"ID": 719,
		"x": -13.8292964367,
		"y": 68.125179176,
		"h": 2.1868131868
	},
	{
		"stop_id": 8502685,
		"ID": 719,
		"x": -14.1112559387,
		"y": 67.648236192,
		"h": 2.1868131868
	},
	{
		"stop_id": 8502686,
		"ID": 719,
		"x": -14.1052448427,
		"y": 69.710237314,
		"h": 2.1868131868
	},
	{
		"stop_id": 8502687,
		"ID": 719,
		"x": -14.7762930837,
		"y": 70.837212918,
		"h": 2.1868131868
	},
	{
		"stop_id": 8572388,
		"ID": 719,
		"x": -14.2422981507,
		"y": 67.10619714,
		"h": 2.1868131868
	},
	{
		"stop_id": 8572389,
		"ID": 719,
		"x": -13.5702265957,
		"y": 68.49221704,
		"h": 2.1868131868
	},
	{
		"stop_id": 8572390,
		"ID": 719,
		"x": -13.7922817297,
		"y": 69.348185363,
		"h": 2.1868131868
	},
	{
		"stop_id": 8578004,
		"ID": 719,
		"x": -18.7172309607,
		"y": 66.99115457,
		"h": 2.1868131868
	},
	{
		"stop_id": 8578005,
		"ID": 719,
		"x": -17.4932720957,
		"y": 67.384229595,
		"h": 2.1868131868
	},
	{
		"stop_id": 8578006,
		"ID": 719,
		"x": -17.1432408337,
		"y": 67.388179772,
		"h": 2.1868131868
	},
	{
		"stop_id": 8578007,
		"ID": 719,
		"x": -16.7162925567,
		"y": 67.206249848,
		"h": 2.1868131868
	},
	{
		"stop_id": 8578008,
		"ID": 719,
		"x": -16.7462320727,
		"y": 66.754174103,
		"h": 2.1868131868
	},
	{
		"stop_id": 8578009,
		"ID": 719,
		"x": -16.8022671237,
		"y": 66.318143155,
		"h": 2.1868131868
	},
	{
		"stop_id": 8578644,
		"ID": 719,
		"x": -14.1122854967,
		"y": 66.850245523,
		"h": 2.1868131868
	},
	{
		"stop_id": 8578645,
		"ID": 719,
		"x": -15.0012752077,
		"y": 66.997239981,
		"h": 2.1868131868
	},
	{
		"stop_id": 8578646,
		"ID": 719,
		"x": -15.7642936067,
		"y": 67.124175498,
		"h": 2.1868131868
	},
	{
		"stop_id": 8578647,
		"ID": 719,
		"x": -16.3112322937,
		"y": 67.099240625,
		"h": 2.1868131868
	},
	{
		"stop_id": 8578649,
		"ID": 719,
		"x": -16.7382602507,
		"y": 67.643161859,
		"h": 2.1868131868
	},
	{
		"stop_id": 8578650,
		"ID": 719,
		"x": -16.8192585157,
		"y": 68.164148101,
		"h": 2.1868131868
	},
	{
		"stop_id": 8578651,
		"ID": 719,
		"x": -17.0332815127,
		"y": 68.388198669,
		"h": 2.1868131868
	},
	{
		"stop_id": 8578652,
		"ID": 719,
		"x": -17.3882516057,
		"y": 68.661170747,
		"h": 2.1868131868
	},
	{
		"stop_id": 8578653,
		"ID": 719,
		"x": -18.1142365077,
		"y": 68.819248824,
		"h": 2.1868131868
	},
	{
		"stop_id": 8578654,
		"ID": 719,
		"x": -18.1312267017,
		"y": 69.562186737,
		"h": 2.1868131868
	},
	{
		"stop_id": 8578655,
		"ID": 719,
		"x": -17.0622704347,
		"y": 70.27515599,
		"h": 2.1868131868
	},
	{
		"stop_id": 8578659,
		"ID": 719,
		"x": -13.4152956027,
		"y": 68.061243999,
		"h": 2.1868131868
	},
	{
		"stop_id": 8588427,
		"ID": 719,
		"x": -14.1062831147,
		"y": 67.257232684,
		"h": 2.1868131868
	},
	{
		"stop_id": 8588428,
		"ID": 719,
		"x": -13.8362779807,
		"y": 67.506150793,
		"h": 2.1868131868
	},
	{
		"stop_id": 8589188,
		"ID": 719,
		"x": -15.4042339647,
		"y": 65.708239381,
		"h": 2.1868131868
	},
	{
		"stop_id": 8590132,
		"ID": 719,
		"x": -14.5142823577,
		"y": 66.617232648,
		"h": 2.1868131868
	},
	{
		"stop_id": 8590137,
		"ID": 719,
		"x": -14.8042400257,
		"y": 65.943243694,
		"h": 2.1868131868
	},
	{
		"stop_id": 8590159,
		"ID": 719,
		"x": -15.0092540487,
		"y": 65.863196484,
		"h": 2.1868131868
	},
	{
		"stop_id": 8594390,
		"ID": 719,
		"x": -13.6572913877,
		"y": 67.691219376,
		"h": 2.1868131868
	},
	{
		"stop_id": 8594391,
		"ID": 719,
		"x": -13.5742382217,
		"y": 67.912237055,
		"h": 2.1868131868
	},
	{
		"stop_id": 8594930,
		"ID": 719,
		"x": -14.1682508657,
		"y": 66.941209922,
		"h": 2.1868131868
	},
	{
		"stop_id": 8500651,
		"ID": 428,
		"x": -61.3832596957,
		"y": 61.664204146,
		"h": 1.2967032967
	},
	{
		"stop_id": 8571971,
		"ID": 428,
		"x": -62.1852347797,
		"y": 61.753213031,
		"h": 1.2967032967
	},
	{
		"stop_id": 8571972,
		"ID": 428,
		"x": -61.8102763707,
		"y": 61.617202257,
		"h": 1.2967032967
	},
	{
		"stop_id": 8571973,
		"ID": 428,
		"x": -60.9042326587,
		"y": 61.860208563,
		"h": 1.2967032967
	},
	{
		"stop_id": 8571974,
		"ID": 428,
		"x": -59.9302889687,
		"y": 61.508197198,
		"h": 1.2967032967
	},
	{
		"stop_id": 8571993,
		"ID": 428,
		"x": -63.4902590457,
		"y": 57.977215015,
		"h": 1.2967032967
	},
	{
		"stop_id": 8571994,
		"ID": 428,
		"x": -62.1292628537,
		"y": 58.431220909,
		"h": 1.2967032967
	},
	{
		"stop_id": 8571995,
		"ID": 428,
		"x": -61.5082466437,
		"y": 58.960213981,
		"h": 1.2967032967
	},
	{
		"stop_id": 8580244,
		"ID": 428,
		"x": -63.3432568747,
		"y": 57.519171456,
		"h": 1.2967032967
	},
	{
		"stop_id": 8581899,
		"ID": 428,
		"x": -59.6302957807,
		"y": 60.750159467,
		"h": 1.2967032967
	},
	{
		"stop_id": 8500653,
		"ID": 275,
		"x": -87.0542548357,
		"y": 61.998202603,
		"h": 1.1318681319
	},
	{
		"stop_id": 8572037,
		"ID": 275,
		"x": -84.0802301307,
		"y": 62.847197299,
		"h": 1.1318681319
	},
	{
		"stop_id": 8572038,
		"ID": 275,
		"x": -85.3202297677,
		"y": 62.596161929,
		"h": 1.1318681319
	},
	{
		"stop_id": 8572039,
		"ID": 275,
		"x": -86.1782925767,
		"y": 61.898156371,
		"h": 1.1318681319
	},
	{
		"stop_id": 8572040,
		"ID": 275,
		"x": -88.7422320977,
		"y": 61.755196136,
		"h": 1.1318681319
	},
	{
		"stop_id": 8500654,
		"ID": 400,
		"x": -67.2172326817,
		"y": 71.142197698,
		"h": 1.4945054945
	},
	{
		"stop_id": 8500664,
		"ID": 400,
		"x": -69.1542843747,
		"y": 68.301239265,
		"h": 1.4945054945
	},
	{
		"stop_id": 8571986,
		"ID": 400,
		"x": -68.9482772777,
		"y": 68.368178565,
		"h": 1.4945054945
	},
	{
		"stop_id": 8571987,
		"ID": 400,
		"x": -68.3552849197,
		"y": 68.45322314,
		"h": 1.4945054945
	},
	{
		"stop_id": 8571988,
		"ID": 400,
		"x": -67.5122355247,
		"y": 70.267229498,
		"h": 1.4945054945
	},
	{
		"stop_id": 8571989,
		"ID": 400,
		"x": -67.0122298417,
		"y": 70.862200355,
		"h": 1.4945054945
	},
	{
		"stop_id": 8572002,
		"ID": 400,
		"x": -64.9942328967,
		"y": 66.256160549,
		"h": 1.4945054945
	},
	{
		"stop_id": 8572003,
		"ID": 400,
		"x": -68.5182639307,
		"y": 67.122157539,
		"h": 1.4945054945
	},
	{
		"stop_id": 8572004,
		"ID": 400,
		"x": -68.7242747427,
		"y": 67.127249997,
		"h": 1.4945054945
	},
	{
		"stop_id": 8572008,
		"ID": 400,
		"x": -66.0012851527,
		"y": 67.395219181,
		"h": 1.4945054945
	},
	{
		"stop_id": 8572153,
		"ID": 400,
		"x": -65.0132781367,
		"y": 71.16614638,
		"h": 1.4945054945
	},
	{
		"stop_id": 8572154,
		"ID": 400,
		"x": -66.4682484947,
		"y": 71.344200462,
		"h": 1.4945054945
	},
	{
		"stop_id": 8572157,
		"ID": 400,
		"x": -68.2502729507,
		"y": 71.124148998,
		"h": 1.4945054945
	},
	{
		"stop_id": 8582155,
		"ID": 400,
		"x": -68.6912973697,
		"y": 68.406250617,
		"h": 1.4945054945
	},
	{
		"stop_id": 8582568,
		"ID": 400,
		"x": -64.9392472837,
		"y": 66.532177839,
		"h": 1.4945054945
	},
	{
		"stop_id": 8582941,
		"ID": 400,
		"x": -67.3382973227,
		"y": 69.119140686,
		"h": 1.4945054945
	},
	{
		"stop_id": 8500655,
		"ID": 459,
		"x": -57.1992744557,
		"y": 65.339249589,
		"h": 1.4945054945
	},
	{
		"stop_id": 8500663,
		"ID": 459,
		"x": -54.8182944967,
		"y": 62.857250944,
		"h": 1.4945054945
	},
	{
		"stop_id": 8500957,
		"ID": 459,
		"x": -54.9442505257,
		"y": 65.34317707,
		"h": 1.4945054945
	},
	{
		"stop_id": 8571975,
		"ID": 459,
		"x": -58.8252614337,
		"y": 61.628216044,
		"h": 1.4945054945
	},
	{
		"stop_id": 8571976,
		"ID": 459,
		"x": -58.3672740387,
		"y": 61.607174587,
		"h": 1.4945054945
	},
	{
		"stop_id": 8571977,
		"ID": 459,
		"x": -57.0432815187,
		"y": 61.4681924,
		"h": 1.4945054945
	},
	{
		"stop_id": 8571978,
		"ID": 459,
		"x": -56.9012513467,
		"y": 61.372196587,
		"h": 1.4945054945
	},
	{
		"stop_id": 8571979,
		"ID": 459,
		"x": -55.5102746157,
		"y": 61.097169581,
		"h": 1.4945054945
	},
	{
		"stop_id": 8571980,
		"ID": 459,
		"x": -55.1222244837,
		"y": 61.093229821,
		"h": 1.4945054945
	},
	{
		"stop_id": 8571981,
		"ID": 459,
		"x": -54.6442307887,
		"y": 62.941226972,
		"h": 1.4945054945
	},
	{
		"stop_id": 8572172,
		"ID": 459,
		"x": -54.7172310107,
		"y": 65.317234766,
		"h": 1.4945054945
	},
	{
		"stop_id": 8572173,
		"ID": 459,
		"x": -54.8922805837,
		"y": 65.230146386,
		"h": 1.4945054945
	},
	{
		"stop_id": 8572174,
		"ID": 459,
		"x": -56.9872352047,
		"y": 65.187244522,
		"h": 1.4945054945
	},
	{
		"stop_id": 8578923,
		"ID": 459,
		"x": -55.7462250147,
		"y": 61.133142476,
		"h": 1.4945054945
	},
	{
		"stop_id": 8581811,
		"ID": 459,
		"x": -57.1902431297,
		"y": 62.1642347,
		"h": 1.4945054945
	},
	{
		"stop_id": 8582815,
		"ID": 459,
		"x": -55.0432552167,
		"y": 61.384140644,
		"h": 1.4945054945
	},
	{
		"stop_id": 8500656,
		"ID": 242,
		"x": -88.9062775887,
		"y": 59.42718116,
		"h": 1
	},
	{
		"stop_id": 8500665,
		"ID": 458,
		"x": -56.9382653737,
		"y": 59.376150527,
		"h": 1.0659340659
	},
	{
		"stop_id": 8571985,
		"ID": 458,
		"x": -58.3892795447,
		"y": 59.236239146,
		"h": 1.0659340659
	},
	{
		"stop_id": 8583660,
		"ID": 458,
		"x": -57.0602992017,
		"y": 59.444249202,
		"h": 1.0659340659
	},
	{
		"stop_id": 8500666,
		"ID": 398,
		"x": -66.7732721667,
		"y": 59.617149405,
		"h": 1.1318681319
	},
	{
		"stop_id": 8571992,
		"ID": 398,
		"x": -64.2642864037,
		"y": 58.732233539,
		"h": 1.1318681319
	},
	{
		"stop_id": 8572000,
		"ID": 398,
		"x": -67.0062302147,
		"y": 59.315244341,
		"h": 1.1318681319
	},
	{
		"stop_id": 8580736,
		"ID": 398,
		"x": -63.8932539977,
		"y": 56.279215767,
		"h": 1.1318681319
	},
	{
		"stop_id": 8582076,
		"ID": 398,
		"x": -66.9502930367,
		"y": 59.499179234,
		"h": 1.1318681319
	},
	{
		"stop_id": 8500688,
		"ID": 429,
		"x": -61.0352244287,
		"y": 66.893223402,
		"h": 1.1648351648
	},
	{
		"stop_id": 8500689,
		"ID": 429,
		"x": -60.2542941017,
		"y": 67.749202912,
		"h": 1.1648351648
	},
	{
		"stop_id": 8572195,
		"ID": 429,
		"x": -59.7512750377,
		"y": 67.211160359,
		"h": 1.1648351648
	},
	{
		"stop_id": 8572196,
		"ID": 429,
		"x": -60.5342257997,
		"y": 67.500187329,
		"h": 1.1648351648
	},
	{
		"stop_id": 8572197,
		"ID": 429,
		"x": -60.4562247677,
		"y": 67.6701752,
		"h": 1.1648351648
	},
	{
		"stop_id": 8580942,
		"ID": 429,
		"x": -60.6172576557,
		"y": 67.055246196,
		"h": 1.1648351648
	},
	{
		"stop_id": 8500693,
		"ID": 558,
		"x": -40.7972980267,
		"y": 74.139245999,
		"h": 1.7582417582
	},
	{
		"stop_id": 8500775,
		"ID": 558,
		"x": -43.4302960317,
		"y": 71.169236245,
		"h": 1.7582417582
	},
	{
		"stop_id": 8500851,
		"ID": 558,
		"x": -39.4762598727,
		"y": 70.813170472,
		"h": 1.7582417582
	},
	{
		"stop_id": 8500971,
		"ID": 558,
		"x": -40.4922587237,
		"y": 72.455213428,
		"h": 1.7582417582
	},
	{
		"stop_id": 8500972,
		"ID": 558,
		"x": -42.2672797817,
		"y": 72.830198593,
		"h": 1.7582417582
	},
	{
		"stop_id": 8572137,
		"ID": 558,
		"x": -43.0912738887,
		"y": 68.88423035,
		"h": 1.7582417582
	},
	{
		"stop_id": 8572138,
		"ID": 558,
		"x": -42.7352631557,
		"y": 70.038216658,
		"h": 1.7582417582
	},
	{
		"stop_id": 8572140,
		"ID": 558,
		"x": -43.0262293857,
		"y": 71.114211268,
		"h": 1.7582417582
	},
	{
		"stop_id": 8572210,
		"ID": 558,
		"x": -42.9962594817,
		"y": 71.455187574,
		"h": 1.7582417582
	},
	{
		"stop_id": 8572211,
		"ID": 558,
		"x": -42.6842466807,
		"y": 71.270174732,
		"h": 1.7582417582
	},
	{
		"stop_id": 8572219,
		"ID": 558,
		"x": -40.1922902807,
		"y": 73.530243711,
		"h": 1.7582417582
	},
	{
		"stop_id": 8572220,
		"ID": 558,
		"x": -42.1292845657,
		"y": 72.787244138,
		"h": 1.7582417582
	},
	{
		"stop_id": 8572228,
		"ID": 558,
		"x": -41.0072982837,
		"y": 74.25921574,
		"h": 1.7582417582
	},
	{
		"stop_id": 8578325,
		"ID": 558,
		"x": -39.1692993787,
		"y": 70.952206545,
		"h": 1.7582417582
	},
	{
		"stop_id": 8578326,
		"ID": 558,
		"x": -39.7412618707,
		"y": 70.734220128,
		"h": 1.7582417582
	},
	{
		"stop_id": 8578327,
		"ID": 558,
		"x": -39.9192665437,
		"y": 70.493242137,
		"h": 1.7582417582
	},
	{
		"stop_id": 8578328,
		"ID": 558,
		"x": -40.3512447757,
		"y": 69.785239034,
		"h": 1.7582417582
	},
	{
		"stop_id": 8578329,
		"ID": 558,
		"x": -40.5032532187,
		"y": 68.654225166,
		"h": 1.7582417582
	},
	{
		"stop_id": 8580563,
		"ID": 558,
		"x": -40.3272635397,
		"y": 72.627198289,
		"h": 1.7582417582
	},
	{
		"stop_id": 8580564,
		"ID": 558,
		"x": -39.6422625237,
		"y": 72.980156944,
		"h": 1.7582417582
	},
	{
		"stop_id": 8580812,
		"ID": 558,
		"x": -39.9222695187,
		"y": 72.680238028,
		"h": 1.7582417582
	},
	{
		"stop_id": 8580933,
		"ID": 558,
		"x": -41.8422877087,
		"y": 72.880163739,
		"h": 1.7582417582
	},
	{
		"stop_id": 8583312,
		"ID": 558,
		"x": -42.8452599617,
		"y": 71.809182509,
		"h": 1.7582417582
	},
	{
		"stop_id": 8583835,
		"ID": 558,
		"x": -42.4142646617,
		"y": 72.827210576,
		"h": 1.7582417582
	},
	{
		"stop_id": 8500699,
		"ID": 489,
		"x": -49.7042522627,
		"y": 52.025143184,
		"h": 1.4285714286
	},
	{
		"stop_id": 8500773,
		"ID": 489,
		"x": -53.0415180307,
		"y": 54.072170378,
		"h": 1.4285714286
	},
	{
		"stop_id": 8508776,
		"ID": 489,
		"x": -52.0852686387,
		"y": 52.238198045,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572332,
		"ID": 489,
		"x": -48.8422685587,
		"y": 55.130216495,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572333,
		"ID": 489,
		"x": -50.0802710667,
		"y": 54.750186868,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572334,
		"ID": 489,
		"x": -50.9372478727,
		"y": 54.347172618,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572335,
		"ID": 489,
		"x": -52.5922363447,
		"y": 54.055234291,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572336,
		"ID": 489,
		"x": -53.3982544047,
		"y": 53.791166649,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572337,
		"ID": 489,
		"x": -53.9712983487,
		"y": 53.37422348,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572382,
		"ID": 489,
		"x": -50.1152539817,
		"y": 51.434220505,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572383,
		"ID": 489,
		"x": -51.2052381767,
		"y": 52.186244773,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572384,
		"ID": 489,
		"x": -51.7582621437,
		"y": 52.023160966,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572385,
		"ID": 489,
		"x": -51.9762960867,
		"y": 52.01220114,
		"h": 1.4285714286
	},
	{
		"stop_id": 8582657,
		"ID": 489,
		"x": -50.3602680497,
		"y": 56.880164618,
		"h": 1.4285714286
	},
	{
		"stop_id": 8500710,
		"ID": 601,
		"x": -29.5812454107,
		"y": -60.29180219,
		"h": 1.2307692308
	},
	{
		"stop_id": 8530199,
		"ID": 601,
		"x": -30.5682373857,
		"y": -64.102760452,
		"h": 1.2307692308
	},
	{
		"stop_id": 8571070,
		"ID": 601,
		"x": -29.7182677447,
		"y": -59.64182377,
		"h": 1.2307692308
	},
	{
		"stop_id": 8571071,
		"ID": 601,
		"x": -29.5952782707,
		"y": -59.377859181,
		"h": 1.2307692308
	},
	{
		"stop_id": 8571123,
		"ID": 601,
		"x": -28.4633002627,
		"y": -61.237834423,
		"h": 1.2307692308
	},
	{
		"stop_id": 8571124,
		"ID": 601,
		"x": -28.3742339647,
		"y": -61.084853119,
		"h": 1.2307692308
	},
	{
		"stop_id": 8571125,
		"ID": 601,
		"x": -28.6252276417,
		"y": -60.946854954,
		"h": 1.2307692308
	},
	{
		"stop_id": 8571126,
		"ID": 601,
		"x": -29.2972447307,
		"y": -60.761840379,
		"h": 1.2307692308
	},
	{
		"stop_id": 8500729,
		"ID": 305,
		"x": -83.9182280097,
		"y": 47.776154196,
		"h": 1.032967033
	},
	{
		"stop_id": 8571940,
		"ID": 305,
		"x": -79.2352849937,
		"y": 49.941194557,
		"h": 1.032967033
	},
	{
		"stop_id": 8500730,
		"ID": 42,
		"x": -147.4822336227,
		"y": -39.583817607,
		"h": 1.4615384615
	},
	{
		"stop_id": 8570061,
		"ID": 42,
		"x": -147.2642571687,
		"y": -39.791778106,
		"h": 1.4615384615
	},
	{
		"stop_id": 8579649,
		"ID": 42,
		"x": -146.8332444497,
		"y": -38.867812391,
		"h": 1.4615384615
	},
	{
		"stop_id": 8581660,
		"ID": 42,
		"x": -146.7002866617,
		"y": -38.357765644,
		"h": 1.4615384615
	},
	{
		"stop_id": 8581672,
		"ID": 42,
		"x": -147.2032665867,
		"y": -39.175855285,
		"h": 1.4615384615
	},
	{
		"stop_id": 8581928,
		"ID": 42,
		"x": -148.6122511397,
		"y": -41.04979131,
		"h": 1.4615384615
	},
	{
		"stop_id": 8581930,
		"ID": 42,
		"x": -149.1822918287,
		"y": -41.18877315,
		"h": 1.4615384615
	},
	{
		"stop_id": 8581935,
		"ID": 42,
		"x": -149.4872627717,
		"y": -40.916854396,
		"h": 1.4615384615
	},
	{
		"stop_id": 8581936,
		"ID": 42,
		"x": -149.2272471077,
		"y": -40.674799474,
		"h": 1.4615384615
	},
	{
		"stop_id": 8583430,
		"ID": 42,
		"x": -148.0602362177,
		"y": -40.533823784,
		"h": 1.4615384615
	},
	{
		"stop_id": 8583459,
		"ID": 42,
		"x": -146.6952483587,
		"y": -38.63678085,
		"h": 1.4615384615
	},
	{
		"stop_id": 8583460,
		"ID": 42,
		"x": -148.0052418317,
		"y": -38.974816127,
		"h": 1.4615384615
	},
	{
		"stop_id": 8583803,
		"ID": 42,
		"x": -148.9712876367,
		"y": -40.94375553,
		"h": 1.4615384615
	},
	{
		"stop_id": 8583804,
		"ID": 42,
		"x": -148.5812615077,
		"y": -40.908831188,
		"h": 1.4615384615
	},
	{
		"stop_id": 8594161,
		"ID": 42,
		"x": -149.4422347987,
		"y": -41.398812279,
		"h": 1.4615384615
	},
	{
		"stop_id": 8500731,
		"ID": 43,
		"x": -146.0472642557,
		"y": -35.871805408,
		"h": 2.0879120879
	},
	{
		"stop_id": 8500736,
		"ID": 43,
		"x": -145.2622823377,
		"y": -34.859857222,
		"h": 2.0879120879
	},
	{
		"stop_id": 8500737,
		"ID": 43,
		"x": -144.4122950907,
		"y": -35.381846169,
		"h": 2.0879120879
	},
	{
		"stop_id": 8500738,
		"ID": 43,
		"x": -147.5002782287,
		"y": -36.788788307,
		"h": 2.0879120879
	},
	{
		"stop_id": 8501033,
		"ID": 43,
		"x": -144.4112351057,
		"y": -36.261820841,
		"h": 2.0879120879
	},
	{
		"stop_id": 8501320,
		"ID": 43,
		"x": -144.3562853327,
		"y": -37.123764466,
		"h": 2.0879120879
	},
	{
		"stop_id": 8501860,
		"ID": 43,
		"x": -145.8132528367,
		"y": -32.875834349,
		"h": 2.0879120879
	},
	{
		"stop_id": 8501873,
		"ID": 43,
		"x": -144.2382448347,
		"y": -33.829827359,
		"h": 2.0879120879
	},
	{
		"stop_id": 8570034,
		"ID": 43,
		"x": -144.3982332777,
		"y": -36.227761514,
		"h": 2.0879120879
	},
	{
		"stop_id": 8570035,
		"ID": 43,
		"x": -144.0992875147,
		"y": -36.54981262,
		"h": 2.0879120879
	},
	{
		"stop_id": 8570036,
		"ID": 43,
		"x": -143.6722999607,
		"y": -36.083841289,
		"h": 2.0879120879
	},
	{
		"stop_id": 8570055,
		"ID": 43,
		"x": -145.5242525917,
		"y": -36.366793765,
		"h": 2.0879120879
	},
	{
		"stop_id": 8570056,
		"ID": 43,
		"x": -146.5062344247,
		"y": -36.124802119,
		"h": 2.0879120879
	},
	{
		"stop_id": 8570059,
		"ID": 43,
		"x": -147.9172545267,
		"y": -37.370819871,
		"h": 2.0879120879
	},
	{
		"stop_id": 8579222,
		"ID": 43,
		"x": -144.8832365547,
		"y": -34.881799136,
		"h": 2.0879120879
	},
	{
		"stop_id": 8579223,
		"ID": 43,
		"x": -144.4652478087,
		"y": -34.903821035,
		"h": 2.0879120879
	},
	{
		"stop_id": 8579224,
		"ID": 43,
		"x": -144.4372501387,
		"y": -35.173817686,
		"h": 2.0879120879
	},
	{
		"stop_id": 8579690,
		"ID": 43,
		"x": -144.3942954637,
		"y": -34.173835994,
		"h": 2.0879120879
	},
	{
		"stop_id": 8579691,
		"ID": 43,
		"x": -145.3532718177,
		"y": -32.823810117,
		"h": 2.0879120879
	},
	{
		"stop_id": 8582688,
		"ID": 43,
		"x": -144.6802650697,
		"y": -36.592780902,
		"h": 2.0879120879
	},
	{
		"stop_id": 8582690,
		"ID": 43,
		"x": -145.4252580837,
		"y": -36.81179828,
		"h": 2.0879120879
	},
	{
		"stop_id": 8582691,
		"ID": 43,
		"x": -145.0402488707,
		"y": -37.131785847,
		"h": 2.0879120879
	},
	{
		"stop_id": 8582692,
		"ID": 43,
		"x": -144.8172823547,
		"y": -37.393760407,
		"h": 2.0879120879
	},
	{
		"stop_id": 8582696,
		"ID": 43,
		"x": -143.8742574627,
		"y": -36.291810567,
		"h": 2.0879120879
	},
	{
		"stop_id": 8582697,
		"ID": 43,
		"x": -148.1562984907,
		"y": -37.521849129,
		"h": 2.0879120879
	},
	{
		"stop_id": 8583111,
		"ID": 43,
		"x": -145.5212481657,
		"y": -36.360833065,
		"h": 2.0879120879
	},
	{
		"stop_id": 8583424,
		"ID": 43,
		"x": -144.0732496717,
		"y": -35.541810161,
		"h": 2.0879120879
	},
	{
		"stop_id": 8583433,
		"ID": 43,
		"x": -147.2092923737,
		"y": -36.586791592,
		"h": 2.0879120879
	},
	{
		"stop_id": 8583464,
		"ID": 43,
		"x": -144.5792264547,
		"y": -36.646792618,
		"h": 2.0879120879
	},
	{
		"stop_id": 8583465,
		"ID": 43,
		"x": -144.7942398167,
		"y": -36.801850083,
		"h": 2.0879120879
	},
	{
		"stop_id": 8583530,
		"ID": 43,
		"x": -145.2522909457,
		"y": -36.199786582,
		"h": 2.0879120879
	},
	{
		"stop_id": 8583682,
		"ID": 43,
		"x": -144.2862653947,
		"y": -36.41677882,
		"h": 2.0879120879
	},
	{
		"stop_id": 8583821,
		"ID": 43,
		"x": -144.2752557547,
		"y": -36.819835889,
		"h": 2.0879120879
	},
	{
		"stop_id": 8583860,
		"ID": 43,
		"x": -147.4612977987,
		"y": -37.092758619,
		"h": 2.0879120879
	},
	{
		"stop_id": 8500732,
		"ID": 35,
		"x": -148.8042353747,
		"y": -37.884851055,
		"h": 2.0549450549
	},
	{
		"stop_id": 8500733,
		"ID": 35,
		"x": -149.3362598547,
		"y": -38.447851386,
		"h": 2.0549450549
	},
	{
		"stop_id": 8501031,
		"ID": 35,
		"x": -149.6492989657,
		"y": -40.939785862,
		"h": 2.0549450549
	},
	{
		"stop_id": 8501058,
		"ID": 35,
		"x": -153.6292879497,
		"y": -37.948827557,
		"h": 2.0549450549
	},
	{
		"stop_id": 8501064,
		"ID": 35,
		"x": -153.1782485197,
		"y": -36.374775774,
		"h": 2.0549450549
	},
	{
		"stop_id": 8501065,
		"ID": 35,
		"x": -153.7172805277,
		"y": -37.062805586,
		"h": 2.0549450549
	},
	{
		"stop_id": 8501066,
		"ID": 35,
		"x": -153.8152462007,
		"y": -39.068828913,
		"h": 2.0549450549
	},
	{
		"stop_id": 8501296,
		"ID": 35,
		"x": -152.2452330677,
		"y": -40.421847838,
		"h": 2.0549450549
	},
	{
		"stop_id": 8501333,
		"ID": 35,
		"x": -150.3922915507,
		"y": -40.619795753,
		"h": 2.0549450549
	},
	{
		"stop_id": 8501850,
		"ID": 35,
		"x": -152.4312767937,
		"y": -36.098820387,
		"h": 2.0549450549
	},
	{
		"stop_id": 8501851,
		"ID": 35,
		"x": -151.2562715227,
		"y": -38.654776483,
		"h": 2.0549450549
	},
	{
		"stop_id": 8501852,
		"ID": 35,
		"x": -150.4692337437,
		"y": -35.672783015,
		"h": 2.0549450549
	},
	{
		"stop_id": 8501857,
		"ID": 35,
		"x": -151.1052340297,
		"y": -39.950847975,
		"h": 2.0549450549
	},
	{
		"stop_id": 8570010,
		"ID": 35,
		"x": -153.1433006067,
		"y": -40.709834468,
		"h": 2.0549450549
	},
	{
		"stop_id": 8570011,
		"ID": 35,
		"x": -151.6182284257,
		"y": -40.041768147,
		"h": 2.0549450549
	},
	{
		"stop_id": 8570013,
		"ID": 35,
		"x": -151.1172506657,
		"y": -38.969854141,
		"h": 2.0549450549
	},
	{
		"stop_id": 8570014,
		"ID": 35,
		"x": -151.9172821007,
		"y": -38.294813801,
		"h": 2.0549450549
	},
	{
		"stop_id": 8570015,
		"ID": 35,
		"x": -152.4052402877,
		"y": -37.960791389,
		"h": 2.0549450549
	},
	{
		"stop_id": 8570025,
		"ID": 35,
		"x": -151.3672543657,
		"y": -38.361801928,
		"h": 2.0549450549
	},
	{
		"stop_id": 8570026,
		"ID": 35,
		"x": -151.4342987677,
		"y": -38.1667754,
		"h": 2.0549450549
	},
	{
		"stop_id": 8570027,
		"ID": 35,
		"x": -151.3162626497,
		"y": -37.717856661,
		"h": 2.0549450549
	},
	{
		"stop_id": 8570028,
		"ID": 35,
		"x": -150.5232715357,
		"y": -36.713815428,
		"h": 2.0549450549
	},
	{
		"stop_id": 8570029,
		"ID": 35,
		"x": -150.2152891457,
		"y": -35.92475563,
		"h": 2.0549450549
	},
	{
		"stop_id": 8570030,
		"ID": 35,
		"x": -149.6592506277,
		"y": -40.936857841,
		"h": 2.0549450549
	},
	{
		"stop_id": 8570031,
		"ID": 35,
		"x": -149.8962351297,
		"y": -40.855823917,
		"h": 2.0549450549
	},
	{
		"stop_id": 8570032,
		"ID": 35,
		"x": -150.1732655177,
		"y": -40.748830843,
		"h": 2.0549450549
	},
	{
		"stop_id": 8570033,
		"ID": 35,
		"x": -150.8432512947,
		"y": -40.164832451,
		"h": 2.0549450549
	},
	{
		"stop_id": 8581113,
		"ID": 35,
		"x": -150.7672594927,
		"y": -37.244784267,
		"h": 2.0549450549
	},
	{
		"stop_id": 8581927,
		"ID": 35,
		"x": -150.1502973527,
		"y": -40.478791762,
		"h": 2.0549450549
	},
	{
		"stop_id": 8581940,
		"ID": 35,
		"x": -149.4652990017,
		"y": -40.345840892,
		"h": 2.0549450549
	},
	{
		"stop_id": 8582137,
		"ID": 35,
		"x": -152.3592317787,
		"y": -35.675784281,
		"h": 2.0549450549
	},
	{
		"stop_id": 8583431,
		"ID": 35,
		"x": -150.3892768527,
		"y": -40.526785418,
		"h": 2.0549450549
	},
	{
		"stop_id": 8583432,
		"ID": 35,
		"x": -149.8682522177,
		"y": -40.054763904,
		"h": 2.0549450549
	},
	{
		"stop_id": 8500734,
		"ID": 50,
		"x": -142.9682275197,
		"y": -34.496802443,
		"h": 1.8901098901
	},
	{
		"stop_id": 8501035,
		"ID": 50,
		"x": -139.5302980777,
		"y": -34.882805161,
		"h": 1.8901098901
	},
	{
		"stop_id": 8501862,
		"ID": 50,
		"x": -142.9602537257,
		"y": -33.792835751,
		"h": 1.8901098901
	},
	{
		"stop_id": 8501865,
		"ID": 50,
		"x": -140.6252465457,
		"y": -32.894819907,
		"h": 1.8901098901
	},
	{
		"stop_id": 8501867,
		"ID": 50,
		"x": -139.5382578997,
		"y": -33.427751604,
		"h": 1.8901098901
	},
	{
		"stop_id": 8501868,
		"ID": 50,
		"x": -139.4672287817,
		"y": -33.84482189,
		"h": 1.8901098901
	},
	{
		"stop_id": 8501870,
		"ID": 50,
		"x": -140.0312746207,
		"y": -32.843856864,
		"h": 1.8901098901
	},
	{
		"stop_id": 8501871,
		"ID": 50,
		"x": -142.0732260107,
		"y": -32.279823741,
		"h": 1.8901098901
	},
	{
		"stop_id": 8504653,
		"ID": 50,
		"x": -139.0872442367,
		"y": -32.016793601,
		"h": 1.8901098901
	},
	{
		"stop_id": 8570043,
		"ID": 50,
		"x": -142.5922572867,
		"y": -34.344790029,
		"h": 1.8901098901
	},
	{
		"stop_id": 8570044,
		"ID": 50,
		"x": -141.9532412717,
		"y": -33.746761101,
		"h": 1.8901098901
	},
	{
		"stop_id": 8570045,
		"ID": 50,
		"x": -141.1152375097,
		"y": -33.272765406,
		"h": 1.8901098901
	},
	{
		"stop_id": 8570046,
		"ID": 50,
		"x": -140.2852263557,
		"y": -32.972759387,
		"h": 1.8901098901
	},
	{
		"stop_id": 8570049,
		"ID": 50,
		"x": -140.1922265227,
		"y": -32.219791194,
		"h": 1.8901098901
	},
	{
		"stop_id": 8570050,
		"ID": 50,
		"x": -139.4172813927,
		"y": -32.219770709,
		"h": 1.8901098901
	},
	{
		"stop_id": 8570051,
		"ID": 50,
		"x": -140.4532845797,
		"y": -31.352793442,
		"h": 1.8901098901
	},
	{
		"stop_id": 8570088,
		"ID": 50,
		"x": -138.6362669237,
		"y": -31.727781046,
		"h": 1.8901098901
	},
	{
		"stop_id": 8570123,
		"ID": 50,
		"x": -143.2892900247,
		"y": -29.989832069,
		"h": 1.8901098901
	},
	{
		"stop_id": 8579079,
		"ID": 50,
		"x": -139.5332475497,
		"y": -34.867757409,
		"h": 1.8901098901
	},
	{
		"stop_id": 8579080,
		"ID": 50,
		"x": -139.4142510547,
		"y": -34.268767265,
		"h": 1.8901098901
	},
	{
		"stop_id": 8579081,
		"ID": 50,
		"x": -139.7992808407,
		"y": -33.117772632,
		"h": 1.8901098901
	},
	{
		"stop_id": 8579082,
		"ID": 50,
		"x": -141.7242729797,
		"y": -32.278810464,
		"h": 1.8901098901
	},
	{
		"stop_id": 8579083,
		"ID": 50,
		"x": -144.1732400317,
		"y": -32.049807665,
		"h": 1.8901098901
	},
	{
		"stop_id": 8581659,
		"ID": 50,
		"x": -141.5842534487,
		"y": -34.429853267,
		"h": 1.8901098901
	},
	{
		"stop_id": 8583458,
		"ID": 50,
		"x": -141.8542982197,
		"y": -32.630797313,
		"h": 1.8901098901
	},
	{
		"stop_id": 8583527,
		"ID": 50,
		"x": -140.9872525827,
		"y": -35.070756923,
		"h": 1.8901098901
	},
	{
		"stop_id": 8583710,
		"ID": 50,
		"x": -140.2102966457,
		"y": -31.160826801,
		"h": 1.8901098901
	},
	{
		"stop_id": 8583896,
		"ID": 50,
		"x": -142.9302962037,
		"y": -33.042812673,
		"h": 1.8901098901
	},
	{
		"stop_id": 8500739,
		"ID": 188,
		"x": -96.8422362877,
		"y": -63.469817938,
		"h": 1.6923076923
	},
	{
		"stop_id": 8500743,
		"ID": 188,
		"x": -97.4422534517,
		"y": -61.569803532,
		"h": 1.6923076923
	},
	{
		"stop_id": 8500745,
		"ID": 188,
		"x": -96.4892923287,
		"y": -63.163820056,
		"h": 1.6923076923
	},
	{
		"stop_id": 8500746,
		"ID": 188,
		"x": -96.6422775787,
		"y": -62.769798393,
		"h": 1.6923076923
	},
	{
		"stop_id": 8501403,
		"ID": 188,
		"x": -93.4332335497,
		"y": -64.151807102,
		"h": 1.6923076923
	},
	{
		"stop_id": 8570650,
		"ID": 188,
		"x": -93.4002496527,
		"y": -64.159772802,
		"h": 1.6923076923
	},
	{
		"stop_id": 8570653,
		"ID": 188,
		"x": -94.6502616227,
		"y": -62.509842974,
		"h": 1.6923076923
	},
	{
		"stop_id": 8570654,
		"ID": 188,
		"x": -94.7422266357,
		"y": -62.869826069,
		"h": 1.6923076923
	},
	{
		"stop_id": 8570655,
		"ID": 188,
		"x": -94.4922489107,
		"y": -62.94975454,
		"h": 1.6923076923
	},
	{
		"stop_id": 8570656,
		"ID": 188,
		"x": -94.7232436597,
		"y": -63.188764086,
		"h": 1.6923076923
	},
	{
		"stop_id": 8570658,
		"ID": 188,
		"x": -94.7712269037,
		"y": -63.479855514,
		"h": 1.6923076923
	},
	{
		"stop_id": 8570659,
		"ID": 188,
		"x": -94.4932922107,
		"y": -64.484858631,
		"h": 1.6923076923
	},
	{
		"stop_id": 8570660,
		"ID": 188,
		"x": -94.6152543607,
		"y": -64.676808534,
		"h": 1.6923076923
	},
	{
		"stop_id": 8570661,
		"ID": 188,
		"x": -94.7382917487,
		"y": -64.453761786,
		"h": 1.6923076923
	},
	{
		"stop_id": 8570662,
		"ID": 188,
		"x": -95.0422972237,
		"y": -64.417752439,
		"h": 1.6923076923
	},
	{
		"stop_id": 8570663,
		"ID": 188,
		"x": -94.8992266627,
		"y": -64.723853036,
		"h": 1.6923076923
	},
	{
		"stop_id": 8579035,
		"ID": 188,
		"x": -96.3422306577,
		"y": -61.36980303,
		"h": 1.6923076923
	},
	{
		"stop_id": 8579038,
		"ID": 188,
		"x": -96.6422590847,
		"y": -61.769846567,
		"h": 1.6923076923
	},
	{
		"stop_id": 8579044,
		"ID": 188,
		"x": -97.6422455657,
		"y": -62.069805842,
		"h": 1.6923076923
	},
	{
		"stop_id": 8579685,
		"ID": 188,
		"x": -93.6932898707,
		"y": -64.521760126,
		"h": 1.6923076923
	},
	{
		"stop_id": 8582388,
		"ID": 188,
		"x": -95.0262891597,
		"y": -63.223796725,
		"h": 1.6923076923
	},
	{
		"stop_id": 8583246,
		"ID": 188,
		"x": -94.8542863757,
		"y": -64.57381616,
		"h": 1.6923076923
	},
	{
		"stop_id": 8500740,
		"ID": 138,
		"x": -104.1422730487,
		"y": -65.069849576,
		"h": 1.1648351648
	},
	{
		"stop_id": 8501890,
		"ID": 138,
		"x": -104.7422377427,
		"y": -61.769817434,
		"h": 1.1648351648
	},
	{
		"stop_id": 8530070,
		"ID": 138,
		"x": -104.5212407867,
		"y": -61.812815206,
		"h": 1.1648351648
	},
	{
		"stop_id": 8530071,
		"ID": 138,
		"x": -104.2922418337,
		"y": -63.113846458,
		"h": 1.1648351648
	},
	{
		"stop_id": 8530079,
		"ID": 138,
		"x": -107.8402263207,
		"y": -66.753766453,
		"h": 1.1648351648
	},
	{
		"stop_id": 8579060,
		"ID": 138,
		"x": -105.0422584197,
		"y": -61.669856719,
		"h": 1.1648351648
	},
	{
		"stop_id": 8500742,
		"ID": 161,
		"x": -99.5422326717,
		"y": -62.869770171,
		"h": 1.2967032967
	},
	{
		"stop_id": 8500748,
		"ID": 161,
		"x": -100.0422247687,
		"y": -61.869832984,
		"h": 1.2967032967
	},
	{
		"stop_id": 8501456,
		"ID": 161,
		"x": -98.9682863247,
		"y": -61.088838825,
		"h": 1.2967032967
	},
	{
		"stop_id": 8501460,
		"ID": 161,
		"x": -99.1722274077,
		"y": -61.526845025,
		"h": 1.2967032967
	},
	{
		"stop_id": 8501464,
		"ID": 161,
		"x": -100.0782751197,
		"y": -62.78583832,
		"h": 1.2967032967
	},
	{
		"stop_id": 8530378,
		"ID": 161,
		"x": -99.3802940707,
		"y": -61.930800161,
		"h": 1.2967032967
	},
	{
		"stop_id": 8530430,
		"ID": 161,
		"x": -99.7322990047,
		"y": -62.397829332,
		"h": 1.2967032967
	},
	{
		"stop_id": 8579053,
		"ID": 161,
		"x": -100.1422562567,
		"y": -62.869787017,
		"h": 1.2967032967
	},
	{
		"stop_id": 8579054,
		"ID": 161,
		"x": -99.8422968187,
		"y": -62.569854633,
		"h": 1.2967032967
	},
	{
		"stop_id": 8593467,
		"ID": 161,
		"x": -101.0172777167,
		"y": -63.809797959,
		"h": 1.2967032967
	},
	{
		"stop_id": 8500752,
		"ID": 491,
		"x": -51.7062855427,
		"y": 68.23517635,
		"h": 1.5274725275
	},
	{
		"stop_id": 8500755,
		"ID": 491,
		"x": -51.9902508867,
		"y": 66.67723816,
		"h": 1.5274725275
	},
	{
		"stop_id": 8500757,
		"ID": 491,
		"x": -51.9422565247,
		"y": 64.380160587,
		"h": 1.5274725275
	},
	{
		"stop_id": 8500967,
		"ID": 491,
		"x": -49.1762589867,
		"y": 67.001208639,
		"h": 1.5274725275
	},
	{
		"stop_id": 8572115,
		"ID": 491,
		"x": -52.0922970397,
		"y": 68.130157247,
		"h": 1.5274725275
	},
	{
		"stop_id": 8572116,
		"ID": 491,
		"x": -51.4202885167,
		"y": 68.065235386,
		"h": 1.5274725275
	},
	{
		"stop_id": 8572117,
		"ID": 491,
		"x": -49.9202253517,
		"y": 67.535171481,
		"h": 1.5274725275
	},
	{
		"stop_id": 8572118,
		"ID": 491,
		"x": -48.8032303187,
		"y": 66.706246332,
		"h": 1.5274725275
	},
	{
		"stop_id": 8572120,
		"ID": 491,
		"x": -48.3362392657,
		"y": 66.016232222,
		"h": 1.5274725275
	},
	{
		"stop_id": 8572184,
		"ID": 491,
		"x": -51.7482336247,
		"y": 68.560220069,
		"h": 1.5274725275
	},
	{
		"stop_id": 8572185,
		"ID": 491,
		"x": -51.9082335197,
		"y": 67.693223602,
		"h": 1.5274725275
	},
	{
		"stop_id": 8572186,
		"ID": 491,
		"x": -51.9282925267,
		"y": 67.216222185,
		"h": 1.5274725275
	},
	{
		"stop_id": 8572187,
		"ID": 491,
		"x": -52.1612279187,
		"y": 66.240181973,
		"h": 1.5274725275
	},
	{
		"stop_id": 8572188,
		"ID": 491,
		"x": -52.2902909317,
		"y": 65.838205871,
		"h": 1.5274725275
	},
	{
		"stop_id": 8572189,
		"ID": 491,
		"x": -52.0172866147,
		"y": 64.755191648,
		"h": 1.5274725275
	},
	{
		"stop_id": 8572190,
		"ID": 491,
		"x": -49.9632675537,
		"y": 63.168188676,
		"h": 1.5274725275
	},
	{
		"stop_id": 8582411,
		"ID": 491,
		"x": -50.8712336707,
		"y": 67.956177201,
		"h": 1.5274725275
	},
	{
		"stop_id": 8500761,
		"ID": 522,
		"x": -48.1422777657,
		"y": 55.730237769,
		"h": 1.3296703297
	},
	{
		"stop_id": 8500797,
		"ID": 522,
		"x": -43.5782791537,
		"y": 57.566221024,
		"h": 1.3296703297
	},
	{
		"stop_id": 8500798,
		"ID": 522,
		"x": -45.2972272427,
		"y": 57.068164256,
		"h": 1.3296703297
	},
	{
		"stop_id": 8500955,
		"ID": 522,
		"x": -46.7522931727,
		"y": 56.742171003,
		"h": 1.3296703297
	},
	{
		"stop_id": 8572329,
		"ID": 522,
		"x": -45.1512324757,
		"y": 56.771224323,
		"h": 1.3296703297
	},
	{
		"stop_id": 8572330,
		"ID": 522,
		"x": -45.8082541577,
		"y": 56.316148743,
		"h": 1.3296703297
	},
	{
		"stop_id": 8572331,
		"ID": 522,
		"x": -46.4322632807,
		"y": 56.105148806,
		"h": 1.3296703297
	},
	{
		"stop_id": 8580849,
		"ID": 522,
		"x": -45.0552368407,
		"y": 56.637154643,
		"h": 1.3296703297
	},
	{
		"stop_id": 8582656,
		"ID": 522,
		"x": -46.3052516167,
		"y": 59.616175294,
		"h": 1.3296703297
	},
	{
		"stop_id": 8583678,
		"ID": 522,
		"x": -45.2992647457,
		"y": 59.717146745,
		"h": 1.3296703297
	},
	{
		"stop_id": 8583680,
		"ID": 522,
		"x": -44.9862661527,
		"y": 59.781175956,
		"h": 1.3296703297
	},
	{
		"stop_id": 8500763,
		"ID": 590,
		"x": -34.8882889007,
		"y": 61.774157795,
		"h": 1.2637362637
	},
	{
		"stop_id": 8500873,
		"ID": 590,
		"x": -35.3622714847,
		"y": 62.838209707,
		"h": 1.2637362637
	},
	{
		"stop_id": 8500989,
		"ID": 590,
		"x": -36.3392977687,
		"y": 64.171251032,
		"h": 1.2637362637
	},
	{
		"stop_id": 8572345,
		"ID": 590,
		"x": -34.8702770037,
		"y": 60.68420486,
		"h": 1.2637362637
	},
	{
		"stop_id": 8572346,
		"ID": 590,
		"x": -34.7692946007,
		"y": 61.508153202,
		"h": 1.2637362637
	},
	{
		"stop_id": 8572347,
		"ID": 590,
		"x": -35.1612367207,
		"y": 62.016177711,
		"h": 1.2637362637
	},
	{
		"stop_id": 8572348,
		"ID": 590,
		"x": -35.8592755547,
		"y": 63.583226212,
		"h": 1.2637362637
	},
	{
		"stop_id": 8572349,
		"ID": 590,
		"x": -36.4782691717,
		"y": 65.288204731,
		"h": 1.2637362637
	},
	{
		"stop_id": 8579178,
		"ID": 590,
		"x": -36.4842970137,
		"y": 64.976201489,
		"h": 1.2637362637
	},
	{
		"stop_id": 8500764,
		"ID": 523,
		"x": -46.0052417707,
		"y": 63.089164686,
		"h": 1.1978021978
	},
	{
		"stop_id": 8500766,
		"ID": 523,
		"x": -46.2632698977,
		"y": 62.842196073,
		"h": 1.1978021978
	},
	{
		"stop_id": 8500768,
		"ID": 523,
		"x": -43.3222489447,
		"y": 62.854141488,
		"h": 1.1978021978
	},
	{
		"stop_id": 8500770,
		"ID": 523,
		"x": -49.2752659407,
		"y": 63.020150229,
		"h": 1.1978021978
	},
	{
		"stop_id": 8572191,
		"ID": 523,
		"x": -48.2532646947,
		"y": 62.925192651,
		"h": 1.1978021978
	},
	{
		"stop_id": 8572192,
		"ID": 523,
		"x": -46.9812315357,
		"y": 62.542202795,
		"h": 1.1978021978
	},
	{
		"stop_id": 8572193,
		"ID": 523,
		"x": -44.8262241597,
		"y": 63.239207042,
		"h": 1.1978021978
	},
	{
		"stop_id": 8500765,
		"ID": 524,
		"x": -46.1922852667,
		"y": 66.505148602,
		"h": 1.5604395604
	},
	{
		"stop_id": 8500969,
		"ID": 524,
		"x": -47.5762439157,
		"y": 66.375188569,
		"h": 1.5604395604
	},
	{
		"stop_id": 8500981,
		"ID": 524,
		"x": -47.7552658487,
		"y": 69.790155469,
		"h": 1.5604395604
	},
	{
		"stop_id": 8572119,
		"ID": 524,
		"x": -48.1922688927,
		"y": 66.455236736,
		"h": 1.5604395604
	},
	{
		"stop_id": 8572121,
		"ID": 524,
		"x": -47.8752365247,
		"y": 66.49121607,
		"h": 1.5604395604
	},
	{
		"stop_id": 8572122,
		"ID": 524,
		"x": -46.6382594727,
		"y": 66.399193364,
		"h": 1.5604395604
	},
	{
		"stop_id": 8572123,
		"ID": 524,
		"x": -46.3202525467,
		"y": 66.904227853,
		"h": 1.5604395604
	},
	{
		"stop_id": 8572125,
		"ID": 524,
		"x": -46.8072629947,
		"y": 67.629175305,
		"h": 1.5604395604
	},
	{
		"stop_id": 8572126,
		"ID": 524,
		"x": -47.1342900057,
		"y": 67.746216653,
		"h": 1.5604395604
	},
	{
		"stop_id": 8572127,
		"ID": 524,
		"x": -47.8252992807,
		"y": 68.28614493,
		"h": 1.5604395604
	},
	{
		"stop_id": 8572128,
		"ID": 524,
		"x": -47.7892914517,
		"y": 69.148223095,
		"h": 1.5604395604
	},
	{
		"stop_id": 8572129,
		"ID": 524,
		"x": -48.7282678557,
		"y": 69.853207338,
		"h": 1.5604395604
	},
	{
		"stop_id": 8572130,
		"ID": 524,
		"x": -47.8952269827,
		"y": 69.707154465,
		"h": 1.5604395604
	},
	{
		"stop_id": 8572133,
		"ID": 524,
		"x": -45.8602451247,
		"y": 66.639222265,
		"h": 1.5604395604
	},
	{
		"stop_id": 8572134,
		"ID": 524,
		"x": -44.4872747587,
		"y": 66.953230119,
		"h": 1.5604395604
	},
	{
		"stop_id": 8572141,
		"ID": 524,
		"x": -44.6502735257,
		"y": 70.850248797,
		"h": 1.5604395604
	},
	{
		"stop_id": 8572142,
		"ID": 524,
		"x": -45.3532664457,
		"y": 70.63025079,
		"h": 1.5604395604
	},
	{
		"stop_id": 8582119,
		"ID": 524,
		"x": -45.3392550737,
		"y": 66.806234525,
		"h": 1.5604395604
	},
	{
		"stop_id": 8500780,
		"ID": 689,
		"x": -22.2462519547,
		"y": 71.057196181,
		"h": 1.3296703297
	},
	{
		"stop_id": 8500782,
		"ID": 689,
		"x": -24.2392440547,
		"y": 71.832231225,
		"h": 1.3296703297
	},
	{
		"stop_id": 8500965,
		"ID": 689,
		"x": -21.9672870107,
		"y": 72.955144122,
		"h": 1.3296703297
	},
	{
		"stop_id": 8500966,
		"ID": 689,
		"x": -19.9422523937,
		"y": 71.880216219,
		"h": 1.3296703297
	},
	{
		"stop_id": 8572296,
		"ID": 689,
		"x": -22.7872680417,
		"y": 73.222157922,
		"h": 1.3296703297
	},
	{
		"stop_id": 8572297,
		"ID": 689,
		"x": -21.6512931387,
		"y": 73.216233144,
		"h": 1.3296703297
	},
	{
		"stop_id": 8572298,
		"ID": 689,
		"x": -21.0662359617,
		"y": 72.759153814,
		"h": 1.3296703297
	},
	{
		"stop_id": 8572304,
		"ID": 689,
		"x": -23.6792364877,
		"y": 71.476147451,
		"h": 1.3296703297
	},
	{
		"stop_id": 8572305,
		"ID": 689,
		"x": -22.7022731417,
		"y": 71.050214567,
		"h": 1.3296703297
	},
	{
		"stop_id": 8572306,
		"ID": 689,
		"x": -22.4192724667,
		"y": 71.049210442,
		"h": 1.3296703297
	},
	{
		"stop_id": 8578657,
		"ID": 689,
		"x": -19.5302486187,
		"y": 69.882196514,
		"h": 1.3296703297
	},
	{
		"stop_id": 8500862,
		"ID": 659,
		"x": -28.3032745287,
		"y": 78.026183092,
		"h": 1.4285714286
	},
	{
		"stop_id": 8500961,
		"ID": 659,
		"x": -27.7732415807,
		"y": 79.229186178,
		"h": 1.4285714286
	},
	{
		"stop_id": 8500962,
		"ID": 659,
		"x": -29.0042926907,
		"y": 81.187146702,
		"h": 1.4285714286
	},
	{
		"stop_id": 8500987,
		"ID": 659,
		"x": -25.1122333217,
		"y": 81.431244077,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572261,
		"ID": 659,
		"x": -26.9282626367,
		"y": 82.984218728,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572262,
		"ID": 659,
		"x": -26.0892672357,
		"y": 82.280208675,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572263,
		"ID": 659,
		"x": -25.3002724077,
		"y": 81.506200056,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572264,
		"ID": 659,
		"x": -24.8822242337,
		"y": 81.264142808,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572265,
		"ID": 659,
		"x": -24.1542915937,
		"y": 80.785247357,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572266,
		"ID": 659,
		"x": -23.4412903357,
		"y": 79.923192216,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572276,
		"ID": 659,
		"x": -28.0732643457,
		"y": 79.472188082,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572277,
		"ID": 659,
		"x": -27.6292837517,
		"y": 78.871160577,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572278,
		"ID": 659,
		"x": -27.8602565227,
		"y": 78.347216703,
		"h": 1.4285714286
	},
	{
		"stop_id": 8580467,
		"ID": 659,
		"x": -24.9752947667,
		"y": 77.272143594,
		"h": 1.4285714286
	},
	{
		"stop_id": 8500878,
		"ID": 338,
		"x": -77.8972538017,
		"y": 59.876183633,
		"h": 1.2307692308
	},
	{
		"stop_id": 8572027,
		"ID": 338,
		"x": -76.0612293147,
		"y": 59.78821303,
		"h": 1.2307692308
	},
	{
		"stop_id": 8572028,
		"ID": 338,
		"x": -76.0692865737,
		"y": 59.362189809,
		"h": 1.2307692308
	},
	{
		"stop_id": 8572029,
		"ID": 338,
		"x": -76.4682920447,
		"y": 57.590197841,
		"h": 1.2307692308
	},
	{
		"stop_id": 8572030,
		"ID": 338,
		"x": -75.9892944667,
		"y": 56.649164205,
		"h": 1.2307692308
	},
	{
		"stop_id": 8572031,
		"ID": 338,
		"x": -73.6622366267,
		"y": 56.537149992,
		"h": 1.2307692308
	},
	{
		"stop_id": 8583073,
		"ID": 338,
		"x": -75.6782974067,
		"y": 56.545141214,
		"h": 1.2307692308
	},
	{
		"stop_id": 8583822,
		"ID": 338,
		"x": -76.1852845967,
		"y": 59.890176966,
		"h": 1.2307692308
	},
	{
		"stop_id": 8500883,
		"ID": 273,
		"x": -84.3222828657,
		"y": 53.030245875,
		"h": 1.2967032967
	},
	{
		"stop_id": 8500884,
		"ID": 273,
		"x": -84.8602835047,
		"y": 51.559154927,
		"h": 1.2967032967
	},
	{
		"stop_id": 8500885,
		"ID": 273,
		"x": -84.3982886637,
		"y": 51.116163808,
		"h": 1.2967032967
	},
	{
		"stop_id": 8500886,
		"ID": 273,
		"x": -85.3662661497,
		"y": 50.357142513,
		"h": 1.2967032967
	},
	{
		"stop_id": 8500887,
		"ID": 273,
		"x": -86.0022623007,
		"y": 49.850174219,
		"h": 1.2967032967
	},
	{
		"stop_id": 8571928,
		"ID": 273,
		"x": -87.5442885927,
		"y": 48.472148317,
		"h": 1.2967032967
	},
	{
		"stop_id": 8571929,
		"ID": 273,
		"x": -88.0782550297,
		"y": 48.998220322,
		"h": 1.2967032967
	},
	{
		"stop_id": 8576775,
		"ID": 273,
		"x": -83.3142631307,
		"y": 51.163221832,
		"h": 1.2967032967
	},
	{
		"stop_id": 8576777,
		"ID": 273,
		"x": -84.7712669077,
		"y": 52.168151956,
		"h": 1.2967032967
	},
	{
		"stop_id": 8594639,
		"ID": 273,
		"x": -84.6502326457,
		"y": 52.567220349,
		"h": 1.2967032967
	},
	{
		"stop_id": 8500892,
		"ID": 239,
		"x": -89.9892632547,
		"y": 44.040219386,
		"h": 1.2967032967
	},
	{
		"stop_id": 8500893,
		"ID": 239,
		"x": -90.2232930517,
		"y": 43.422158042,
		"h": 1.2967032967
	},
	{
		"stop_id": 8500894,
		"ID": 239,
		"x": -90.2132314187,
		"y": 43.197193916,
		"h": 1.2967032967
	},
	{
		"stop_id": 8500895,
		"ID": 239,
		"x": -92.8512519947,
		"y": 40.024212386,
		"h": 1.2967032967
	},
	{
		"stop_id": 8504308,
		"ID": 239,
		"x": -88.8922684217,
		"y": 42.166163018,
		"h": 1.2967032967
	},
	{
		"stop_id": 8504309,
		"ID": 239,
		"x": -91.5112952097,
		"y": 40.76321734,
		"h": 1.2967032967
	},
	{
		"stop_id": 8504310,
		"ID": 239,
		"x": -92.9162922167,
		"y": 39.826235741,
		"h": 1.2967032967
	},
	{
		"stop_id": 8504361,
		"ID": 239,
		"x": -93.4762485737,
		"y": 40.598183611,
		"h": 1.2967032967
	},
	{
		"stop_id": 8576770,
		"ID": 239,
		"x": -92.5222334217,
		"y": 40.344243162,
		"h": 1.2967032967
	},
	{
		"stop_id": 8576772,
		"ID": 239,
		"x": -92.9952359437,
		"y": 39.814225832,
		"h": 1.2967032967
	},
	{
		"stop_id": 8500936,
		"ID": 315,
		"x": -76.4712949827,
		"y": -78.23077011,
		"h": 1.3626373626
	},
	{
		"stop_id": 8500937,
		"ID": 315,
		"x": -77.0542381617,
		"y": -78.601758553,
		"h": 1.3626373626
	},
	{
		"stop_id": 8501788,
		"ID": 315,
		"x": -76.0102729827,
		"y": -77.528788381,
		"h": 1.3626373626
	},
	{
		"stop_id": 8501789,
		"ID": 315,
		"x": -76.7802245707,
		"y": -77.739771358,
		"h": 1.3626373626
	},
	{
		"stop_id": 8530095,
		"ID": 315,
		"x": -75.5952463867,
		"y": -77.869840848,
		"h": 1.3626373626
	},
	{
		"stop_id": 8530104,
		"ID": 315,
		"x": -76.2782357647,
		"y": -76.733773401,
		"h": 1.3626373626
	},
	{
		"stop_id": 8530105,
		"ID": 315,
		"x": -76.7222488437,
		"y": -74.671843207,
		"h": 1.3626373626
	},
	{
		"stop_id": 8570680,
		"ID": 315,
		"x": -77.1082321207,
		"y": -78.306788726,
		"h": 1.3626373626
	},
	{
		"stop_id": 8570681,
		"ID": 315,
		"x": -76.8212502917,
		"y": -77.396816794,
		"h": 1.3626373626
	},
	{
		"stop_id": 8570682,
		"ID": 315,
		"x": -76.3192418597,
		"y": -77.417781484,
		"h": 1.3626373626
	},
	{
		"stop_id": 8582581,
		"ID": 315,
		"x": -77.5122915117,
		"y": -78.567856209,
		"h": 1.3626373626
	},
	{
		"stop_id": 8583863,
		"ID": 315,
		"x": -76.6282582127,
		"y": -77.963754913,
		"h": 1.3626373626
	},
	{
		"stop_id": 8500938,
		"ID": 314,
		"x": -77.4452412227,
		"y": -78.80984136,
		"h": 1.6923076923
	},
	{
		"stop_id": 8500939,
		"ID": 314,
		"x": -76.9952740307,
		"y": -80.218852002,
		"h": 1.6923076923
	},
	{
		"stop_id": 8500940,
		"ID": 314,
		"x": -76.9962412197,
		"y": -81.234805976,
		"h": 1.6923076923
	},
	{
		"stop_id": 8500941,
		"ID": 314,
		"x": -78.2302309667,
		"y": -81.312753066,
		"h": 1.6923076923
	},
	{
		"stop_id": 8500942,
		"ID": 314,
		"x": -78.6122490347,
		"y": -81.523790741,
		"h": 1.6923076923
	},
	{
		"stop_id": 8500943,
		"ID": 314,
		"x": -76.2872330877,
		"y": -80.469847308,
		"h": 1.6923076923
	},
	{
		"stop_id": 8500946,
		"ID": 314,
		"x": -74.1262590687,
		"y": -82.109760591,
		"h": 1.6923076923
	},
	{
		"stop_id": 8501276,
		"ID": 314,
		"x": -74.8412510427,
		"y": -81.926812485,
		"h": 1.6923076923
	},
	{
		"stop_id": 8501295,
		"ID": 314,
		"x": -75.3292256297,
		"y": -81.239782484,
		"h": 1.6923076923
	},
	{
		"stop_id": 8501579,
		"ID": 314,
		"x": -77.0412426007,
		"y": -79.519813032,
		"h": 1.6923076923
	},
	{
		"stop_id": 8501762,
		"ID": 314,
		"x": -76.7352695007,
		"y": -80.866804133,
		"h": 1.6923076923
	},
	{
		"stop_id": 8530676,
		"ID": 314,
		"x": -77.0732252467,
		"y": -79.530838051,
		"h": 1.6923076923
	},
	{
		"stop_id": 8570678,
		"ID": 314,
		"x": -77.0352828537,
		"y": -79.464802406,
		"h": 1.6923076923
	},
	{
		"stop_id": 8570679,
		"ID": 314,
		"x": -76.8862288097,
		"y": -78.682833918,
		"h": 1.6923076923
	},
	{
		"stop_id": 8570683,
		"ID": 314,
		"x": -77.3542723497,
		"y": -79.366831839,
		"h": 1.6923076923
	},
	{
		"stop_id": 8570684,
		"ID": 314,
		"x": -76.3602479267,
		"y": -79.981845669,
		"h": 1.6923076923
	},
	{
		"stop_id": 8570685,
		"ID": 314,
		"x": -75.9822332827,
		"y": -80.618749731,
		"h": 1.6923076923
	},
	{
		"stop_id": 8570686,
		"ID": 314,
		"x": -75.6652321947,
		"y": -80.887840099,
		"h": 1.6923076923
	},
	{
		"stop_id": 8570687,
		"ID": 314,
		"x": -75.1242433987,
		"y": -81.547796408,
		"h": 1.6923076923
	},
	{
		"stop_id": 8570688,
		"ID": 314,
		"x": -73.6762715697,
		"y": -82.17384777,
		"h": 1.6923076923
	},
	{
		"stop_id": 8579496,
		"ID": 314,
		"x": -74.3532776377,
		"y": -81.348832277,
		"h": 1.6923076923
	},
	{
		"stop_id": 8581309,
		"ID": 314,
		"x": -76.8142511357,
		"y": -80.529856126,
		"h": 1.6923076923
	},
	{
		"stop_id": 8500944,
		"ID": 343,
		"x": -70.8602299537,
		"y": -84.2947606723,
		"h": 1.1648351648
	},
	{
		"stop_id": 8501275,
		"ID": 343,
		"x": -73.4872594537,
		"y": -82.6797582197,
		"h": 1.1648351648
	},
	{
		"stop_id": 8501765,
		"ID": 343,
		"x": -69.8962292857,
		"y": -84.6178457762,
		"h": 1.1648351648
	},
	{
		"stop_id": 8570689,
		"ID": 343,
		"x": -73.1762324507,
		"y": -82.7748393838,
		"h": 1.1648351648
	},
	{
		"stop_id": 8570690,
		"ID": 343,
		"x": -70.8242467957,
		"y": -84.5578486492,
		"h": 1.1648351648
	},
	{
		"stop_id": 8580396,
		"ID": 343,
		"x": -72.4222890227,
		"y": -83.6107803931,
		"h": 1.1648351648
	},
	{
		"stop_id": 8500945,
		"ID": 373,
		"x": -68.2812353957,
		"y": -85.9247884084,
		"h": 1.0989010989
	},
	{
		"stop_id": 8500947,
		"ID": 373,
		"x": -68.7242304767,
		"y": -85.5698536601,
		"h": 1.0989010989
	},
	{
		"stop_id": 8500948,
		"ID": 373,
		"x": -67.2082412607,
		"y": -87.5458133244,
		"h": 1.0989010989
	},
	{
		"stop_id": 8504658,
		"ID": 373,
		"x": -67.1802513187,
		"y": -88.0267587049,
		"h": 1.0989010989
	},
	{
		"stop_id": 8500949,
		"ID": 697,
		"x": -14.5992459827,
		"y": -60.807765765,
		"h": 1
	},
	{
		"stop_id": 8500985,
		"ID": 559,
		"x": -40.6392440667,
		"y": 75.284188373,
		"h": 1.3626373626
	},
	{
		"stop_id": 8500993,
		"ID": 559,
		"x": -43.1382467727,
		"y": 75.829153591,
		"h": 1.3626373626
	},
	{
		"stop_id": 8572223,
		"ID": 559,
		"x": -39.3092859187,
		"y": 75.16820561,
		"h": 1.3626373626
	},
	{
		"stop_id": 8572224,
		"ID": 559,
		"x": -39.9042516137,
		"y": 74.487173744,
		"h": 1.3626373626
	},
	{
		"stop_id": 8572225,
		"ID": 559,
		"x": -40.1952254257,
		"y": 75.222147454,
		"h": 1.3626373626
	},
	{
		"stop_id": 8572226,
		"ID": 559,
		"x": -40.6952497297,
		"y": 75.117229339,
		"h": 1.3626373626
	},
	{
		"stop_id": 8572227,
		"ID": 559,
		"x": -40.9122313147,
		"y": 74.929188512,
		"h": 1.3626373626
	},
	{
		"stop_id": 8583313,
		"ID": 559,
		"x": -43.1982581547,
		"y": 75.453177383,
		"h": 1.3626373626
	},
	{
		"stop_id": 8583344,
		"ID": 559,
		"x": -42.7492753127,
		"y": 75.881177646,
		"h": 1.3626373626
	},
	{
		"stop_id": 8588877,
		"ID": 559,
		"x": -38.8152329647,
		"y": 78.494186554,
		"h": 1.3626373626
	},
	{
		"stop_id": 8589423,
		"ID": 559,
		"x": -38.4632560537,
		"y": 77.815196818,
		"h": 1.3626373626
	},
	{
		"stop_id": 8589426,
		"ID": 559,
		"x": -38.4812815607,
		"y": 77.39918183,
		"h": 1.3626373626
	},
	{
		"stop_id": 8501000,
		"ID": 6,
		"x": -165.6712544167,
		"y": -62.772854311,
		"h": 3.1428571429
	},
	{
		"stop_id": 8501003,
		"ID": 6,
		"x": -167.8632311517,
		"y": -63.516771561,
		"h": 3.1428571429
	},
	{
		"stop_id": 8501006,
		"ID": 6,
		"x": -164.8072772887,
		"y": -62.668857859,
		"h": 3.1428571429
	},
	{
		"stop_id": 8587028,
		"ID": 6,
		"x": -167.4362792287,
		"y": -66.222805743,
		"h": 3.1428571429
	},
	{
		"stop_id": 8587381,
		"ID": 6,
		"x": -167.7622906567,
		"y": -62.476790465,
		"h": 3.1428571429
	},
	{
		"stop_id": 8587388,
		"ID": 6,
		"x": -167.4072613337,
		"y": -65.013761539,
		"h": 3.1428571429
	},
	{
		"stop_id": 8587389,
		"ID": 6,
		"x": -167.8702713127,
		"y": -63.504749044,
		"h": 3.1428571429
	},
	{
		"stop_id": 8587415,
		"ID": 6,
		"x": -168.6142958397,
		"y": -62.573798846,
		"h": 3.1428571429
	},
	{
		"stop_id": 8587416,
		"ID": 6,
		"x": -169.2172288377,
		"y": -63.898779328,
		"h": 3.1428571429
	},
	{
		"stop_id": 8587419,
		"ID": 6,
		"x": -168.6602625477,
		"y": -64.195803682,
		"h": 3.1428571429
	},
	{
		"stop_id": 8587901,
		"ID": 6,
		"x": -165.0072435237,
		"y": -65.249810025,
		"h": 3.1428571429
	},
	{
		"stop_id": 8587903,
		"ID": 6,
		"x": -164.1662874707,
		"y": -65.295855741,
		"h": 3.1428571429
	},
	{
		"stop_id": 8587918,
		"ID": 6,
		"x": -166.6222444137,
		"y": -61.336755044,
		"h": 3.1428571429
	},
	{
		"stop_id": 8592619,
		"ID": 6,
		"x": -167.4402435707,
		"y": -65.907753362,
		"h": 3.1428571429
	},
	{
		"stop_id": 8592620,
		"ID": 6,
		"x": -167.3112481137,
		"y": -66.677768449,
		"h": 3.1428571429
	},
	{
		"stop_id": 8592651,
		"ID": 6,
		"x": -164.6172350017,
		"y": -65.384779914,
		"h": 3.1428571429
	},
	{
		"stop_id": 8592654,
		"ID": 6,
		"x": -164.9012783497,
		"y": -65.180830668,
		"h": 3.1428571429
	},
	{
		"stop_id": 8592655,
		"ID": 6,
		"x": -164.3592602397,
		"y": -65.275842855,
		"h": 3.1428571429
	},
	{
		"stop_id": 8593011,
		"ID": 6,
		"x": -165.6832845667,
		"y": -62.776757219,
		"h": 3.1428571429
	},
	{
		"stop_id": 8593013,
		"ID": 6,
		"x": -165.4682447427,
		"y": -61.821797186,
		"h": 3.1428571429
	},
	{
		"stop_id": 8593015,
		"ID": 6,
		"x": -164.3372883147,
		"y": -62.221830217,
		"h": 3.1428571429
	},
	{
		"stop_id": 8593018,
		"ID": 6,
		"x": -166.0472819137,
		"y": -61.568817033,
		"h": 3.1428571429
	},
	{
		"stop_id": 8593022,
		"ID": 6,
		"x": -164.7182455737,
		"y": -61.470750114,
		"h": 3.1428571429
	},
	{
		"stop_id": 8593025,
		"ID": 6,
		"x": -165.8262886387,
		"y": -61.998751498,
		"h": 3.1428571429
	},
	{
		"stop_id": 8593026,
		"ID": 6,
		"x": -165.1472745547,
		"y": -61.844859427,
		"h": 3.1428571429
	},
	{
		"stop_id": 8593091,
		"ID": 6,
		"x": -167.2022729057,
		"y": -65.29080702,
		"h": 3.1428571429
	},
	{
		"stop_id": 8593092,
		"ID": 6,
		"x": -167.7462509417,
		"y": -61.816760913,
		"h": 3.1428571429
	},
	{
		"stop_id": 8593093,
		"ID": 6,
		"x": -165.7502802047,
		"y": -65.114750931,
		"h": 3.1428571429
	},
	{
		"stop_id": 8593094,
		"ID": 6,
		"x": -168.9772739867,
		"y": -63.596809071,
		"h": 3.1428571429
	},
	{
		"stop_id": 8593096,
		"ID": 6,
		"x": -166.1712997587,
		"y": -62.551822739,
		"h": 3.1428571429
	},
	{
		"stop_id": 8593097,
		"ID": 6,
		"x": -169.3162414637,
		"y": -64.408763941,
		"h": 3.1428571429
	},
	{
		"stop_id": 8593098,
		"ID": 6,
		"x": -166.0192837857,
		"y": -63.245830565,
		"h": 3.1428571429
	},
	{
		"stop_id": 8593099,
		"ID": 6,
		"x": -166.3202645267,
		"y": -62.465810906,
		"h": 3.1428571429
	},
	{
		"stop_id": 8593100,
		"ID": 6,
		"x": -165.9452613857,
		"y": -65.26676275,
		"h": 3.1428571429
	},
	{
		"stop_id": 8593101,
		"ID": 6,
		"x": -168.3242386647,
		"y": -63.23277414,
		"h": 3.1428571429
	},
	{
		"stop_id": 8593102,
		"ID": 6,
		"x": -168.1662358367,
		"y": -63.614856231,
		"h": 3.1428571429
	},
	{
		"stop_id": 8593103,
		"ID": 6,
		"x": -168.3962434727,
		"y": -63.060813955,
		"h": 3.1428571429
	},
	{
		"stop_id": 8593104,
		"ID": 6,
		"x": -168.9732771177,
		"y": -64.571849715,
		"h": 3.1428571429
	},
	{
		"stop_id": 8593105,
		"ID": 6,
		"x": -166.4842372347,
		"y": -65.424824998,
		"h": 3.1428571429
	},
	{
		"stop_id": 8593143,
		"ID": 6,
		"x": -165.1462953397,
		"y": -64.408850625,
		"h": 3.1428571429
	},
	{
		"stop_id": 8593146,
		"ID": 6,
		"x": -165.0922706357,
		"y": -64.041778862,
		"h": 3.1428571429
	},
	{
		"stop_id": 8593149,
		"ID": 6,
		"x": -165.3992929307,
		"y": -64.19885841,
		"h": 3.1428571429
	},
	{
		"stop_id": 8593150,
		"ID": 6,
		"x": -163.9362385807,
		"y": -63.200820581,
		"h": 3.1428571429
	},
	{
		"stop_id": 8593151,
		"ID": 6,
		"x": -163.0902804217,
		"y": -64.192852254,
		"h": 3.1428571429
	},
	{
		"stop_id": 8593156,
		"ID": 6,
		"x": -164.6422228307,
		"y": -63.287784673,
		"h": 3.1428571429
	},
	{
		"stop_id": 8593163,
		"ID": 6,
		"x": -164.7292822517,
		"y": -63.096818903,
		"h": 3.1428571429
	},
	{
		"stop_id": 8593166,
		"ID": 6,
		"x": -164.8102760247,
		"y": -64.457838052,
		"h": 3.1428571429
	},
	{
		"stop_id": 8593168,
		"ID": 6,
		"x": -164.9092399017,
		"y": -63.969806374,
		"h": 3.1428571429
	},
	{
		"stop_id": 8593172,
		"ID": 6,
		"x": -165.4592458887,
		"y": -63.261765877,
		"h": 3.1428571429
	},
	{
		"stop_id": 8593173,
		"ID": 6,
		"x": -163.5812916967,
		"y": -65.087791093,
		"h": 3.1428571429
	},
	{
		"stop_id": 8593175,
		"ID": 6,
		"x": -164.1422727727,
		"y": -63.319788141,
		"h": 3.1428571429
	},
	{
		"stop_id": 8593176,
		"ID": 6,
		"x": -164.4382776797,
		"y": -63.463763766,
		"h": 3.1428571429
	},
	{
		"stop_id": 8593177,
		"ID": 6,
		"x": -164.6572973727,
		"y": -63.742813841,
		"h": 3.1428571429
	},
	{
		"stop_id": 8593179,
		"ID": 6,
		"x": -164.3712714547,
		"y": -63.266797533,
		"h": 3.1428571429
	},
	{
		"stop_id": 8593180,
		"ID": 6,
		"x": -164.9072939227,
		"y": -62.890817008,
		"h": 3.1428571429
	},
	{
		"stop_id": 8594933,
		"ID": 6,
		"x": -164.7272900527,
		"y": -62.115782588,
		"h": 3.1428571429
	},
	{
		"stop_id": 8595026,
		"ID": 6,
		"x": -165.6882949447,
		"y": -61.948805222,
		"h": 3.1428571429
	},
	{
		"stop_id": 8595029,
		"ID": 6,
		"x": -164.8122497727,
		"y": -62.741818086,
		"h": 3.1428571429
	},
	{
		"stop_id": 8595031,
		"ID": 6,
		"x": -164.9322660917,
		"y": -61.598779338,
		"h": 3.1428571429
	},
	{
		"stop_id": 8595040,
		"ID": 6,
		"x": -167.7612642587,
		"y": -62.479810751,
		"h": 3.1428571429
	},
	{
		"stop_id": 8595041,
		"ID": 6,
		"x": -166.5362827937,
		"y": -62.641780322,
		"h": 3.1428571429
	},
	{
		"stop_id": 8595052,
		"ID": 6,
		"x": -164.1822549567,
		"y": -62.935853282,
		"h": 3.1428571429
	},
	{
		"stop_id": 8595228,
		"ID": 6,
		"x": -168.0402391157,
		"y": -63.957780068,
		"h": 3.1428571429
	},
	{
		"stop_id": 8595556,
		"ID": 6,
		"x": -167.2532226727,
		"y": -66.432751981,
		"h": 3.1428571429
	},
	{
		"stop_id": 8595672,
		"ID": 6,
		"x": -167.9632374737,
		"y": -65.050755815,
		"h": 3.1428571429
	},
	{
		"stop_id": 8595952,
		"ID": 6,
		"x": -166.7042383767,
		"y": -62.791797914,
		"h": 3.1428571429
	},
	{
		"stop_id": 8501001,
		"ID": 3,
		"x": -170.8302421067,
		"y": -67.416799489,
		"h": 2.1208791209
	},
	{
		"stop_id": 8501002,
		"ID": 3,
		"x": -169.4562485457,
		"y": -66.428768639,
		"h": 2.1208791209
	},
	{
		"stop_id": 8587031,
		"ID": 3,
		"x": -170.7632370467,
		"y": -68.428806148,
		"h": 2.1208791209
	},
	{
		"stop_id": 8587038,
		"ID": 3,
		"x": -169.2952786757,
		"y": -68.076761812,
		"h": 2.1208791209
	},
	{
		"stop_id": 8587055,
		"ID": 3,
		"x": -171.1782639797,
		"y": -65.614770694,
		"h": 2.1208791209
	},
	{
		"stop_id": 8587073,
		"ID": 3,
		"x": -170.8482595867,
		"y": -67.434813998,
		"h": 2.1208791209
	},
	{
		"stop_id": 8587087,
		"ID": 3,
		"x": -169.7562329107,
		"y": -66.342822333,
		"h": 2.1208791209
	},
	{
		"stop_id": 8592627,
		"ID": 3,
		"x": -170.4562733957,
		"y": -68.699827922,
		"h": 2.1208791209
	},
	{
		"stop_id": 8592628,
		"ID": 3,
		"x": -171.9152865417,
		"y": -69.619803772,
		"h": 2.1208791209
	},
	{
		"stop_id": 8592629,
		"ID": 3,
		"x": -170.4142462457,
		"y": -67.981790869,
		"h": 2.1208791209
	},
	{
		"stop_id": 8592630,
		"ID": 3,
		"x": -171.1642949747,
		"y": -68.566751557,
		"h": 2.1208791209
	},
	{
		"stop_id": 8592631,
		"ID": 3,
		"x": -170.9862980677,
		"y": -67.809747996,
		"h": 2.1208791209
	},
	{
		"stop_id": 8592634,
		"ID": 3,
		"x": -169.3832300797,
		"y": -69.153763383,
		"h": 2.1208791209
	},
	{
		"stop_id": 8592638,
		"ID": 3,
		"x": -170.6442829557,
		"y": -69.929752629,
		"h": 2.1208791209
	},
	{
		"stop_id": 8592686,
		"ID": 3,
		"x": -169.1802922027,
		"y": -68.419843676,
		"h": 2.1208791209
	},
	{
		"stop_id": 8592687,
		"ID": 3,
		"x": -169.1212919067,
		"y": -67.856764145,
		"h": 2.1208791209
	},
	{
		"stop_id": 8592690,
		"ID": 3,
		"x": -172.3202578317,
		"y": -69.837766447,
		"h": 2.1208791209
	},
	{
		"stop_id": 8592766,
		"ID": 3,
		"x": -171.6932919567,
		"y": -64.4278147,
		"h": 2.1208791209
	},
	{
		"stop_id": 8592767,
		"ID": 3,
		"x": -170.1842288637,
		"y": -66.780758853,
		"h": 2.1208791209
	},
	{
		"stop_id": 8592768,
		"ID": 3,
		"x": -170.5902851417,
		"y": -67.505812518,
		"h": 2.1208791209
	},
	{
		"stop_id": 8592769,
		"ID": 3,
		"x": -170.2602804927,
		"y": -67.113811474,
		"h": 2.1208791209
	},
	{
		"stop_id": 8592770,
		"ID": 3,
		"x": -171.0072628687,
		"y": -66.018849851,
		"h": 2.1208791209
	},
	{
		"stop_id": 8593088,
		"ID": 3,
		"x": -170.6012516017,
		"y": -64.5317688,
		"h": 2.1208791209
	},
	{
		"stop_id": 8593089,
		"ID": 3,
		"x": -170.9792923737,
		"y": -64.246753931,
		"h": 2.1208791209
	},
	{
		"stop_id": 8593090,
		"ID": 3,
		"x": -169.5672579677,
		"y": -65.903856382,
		"h": 2.1208791209
	},
	{
		"stop_id": 8594947,
		"ID": 3,
		"x": -171.5012380977,
		"y": -67.528855553,
		"h": 2.1208791209
	},
	{
		"stop_id": 8594948,
		"ID": 3,
		"x": -172.0102954927,
		"y": -67.378780868,
		"h": 2.1208791209
	},
	{
		"stop_id": 8594949,
		"ID": 3,
		"x": -171.9352293887,
		"y": -67.62477986,
		"h": 2.1208791209
	},
	{
		"stop_id": 8594950,
		"ID": 3,
		"x": -172.1922860827,
		"y": -67.126791435,
		"h": 2.1208791209
	},
	{
		"stop_id": 8594951,
		"ID": 3,
		"x": -172.7722290967,
		"y": -67.10275152,
		"h": 2.1208791209
	},
	{
		"stop_id": 8594952,
		"ID": 3,
		"x": -172.6502597697,
		"y": -66.865759494,
		"h": 2.1208791209
	},
	{
		"stop_id": 8594953,
		"ID": 3,
		"x": -172.9212681627,
		"y": -67.002789083,
		"h": 2.1208791209
	},
	{
		"stop_id": 8594954,
		"ID": 3,
		"x": -173.2532370357,
		"y": -67.329790361,
		"h": 2.1208791209
	},
	{
		"stop_id": 8594955,
		"ID": 3,
		"x": -172.6442370907,
		"y": -67.316837863,
		"h": 2.1208791209
	},
	{
		"stop_id": 8595953,
		"ID": 3,
		"x": -171.4642389217,
		"y": -68.971825095,
		"h": 2.1208791209
	},
	{
		"stop_id": 8501007,
		"ID": 12,
		"x": -163.5002504767,
		"y": -62.871772926,
		"h": 4.8241758242
	},
	{
		"stop_id": 8501008,
		"ID": 12,
		"x": -159.7732997177,
		"y": -64.102775936,
		"h": 4.8241758242
	},
	{
		"stop_id": 8501011,
		"ID": 12,
		"x": -159.3232991107,
		"y": -59.691784158,
		"h": 4.8241758242
	},
	{
		"stop_id": 8501020,
		"ID": 12,
		"x": -159.3372405197,
		"y": -60.532856108,
		"h": 4.8241758242
	},
	{
		"stop_id": 8501026,
		"ID": 12,
		"x": -162.0822759827,
		"y": -61.581785017,
		"h": 4.8241758242
	},
	{
		"stop_id": 8516283,
		"ID": 12,
		"x": -159.5882495647,
		"y": -62.745763323,
		"h": 4.8241758242
	},
	{
		"stop_id": 8587039,
		"ID": 12,
		"x": -159.8132280757,
		"y": -60.473848119,
		"h": 4.8241758242
	},
	{
		"stop_id": 8587048,
		"ID": 12,
		"x": -160.6382857297,
		"y": -59.062806869,
		"h": 4.8241758242
	},
	{
		"stop_id": 8587057,
		"ID": 12,
		"x": -159.7752407707,
		"y": -64.154776357,
		"h": 4.8241758242
	},
	{
		"stop_id": 8587058,
		"ID": 12,
		"x": -160.0062574067,
		"y": -62.75385294,
		"h": 4.8241758242
	},
	{
		"stop_id": 8587084,
		"ID": 12,
		"x": -159.9512421777,
		"y": -61.390801582,
		"h": 4.8241758242
	},
	{
		"stop_id": 8587904,
		"ID": 12,
		"x": -160.3802623787,
		"y": -61.50975073,
		"h": 4.8241758242
	},
	{
		"stop_id": 8587910,
		"ID": 12,
		"x": -161.9142677697,
		"y": -58.778749346,
		"h": 4.8241758242
	},
	{
		"stop_id": 8587911,
		"ID": 12,
		"x": -162.3492810567,
		"y": -59.031761859,
		"h": 4.8241758242
	},
	{
		"stop_id": 8587914,
		"ID": 12,
		"x": -161.2022233497,
		"y": -61.456759116,
		"h": 4.8241758242
	},
	{
		"stop_id": 8587924,
		"ID": 12,
		"x": -163.2722512517,
		"y": -62.74382101,
		"h": 4.8241758242
	},
	{
		"stop_id": 8588196,
		"ID": 12,
		"x": -160.1422883167,
		"y": -62.278854562,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592645,
		"ID": 12,
		"x": -160.6402772317,
		"y": -59.643804097,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592646,
		"ID": 12,
		"x": -160.3252987147,
		"y": -58.982751126,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592647,
		"ID": 12,
		"x": -160.7782484287,
		"y": -60.048753349,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592648,
		"ID": 12,
		"x": -160.8322299007,
		"y": -58.72980208,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592649,
		"ID": 12,
		"x": -159.8842745237,
		"y": -58.905804025,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592775,
		"ID": 12,
		"x": -162.2282978307,
		"y": -61.761758854,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592785,
		"ID": 12,
		"x": -160.0112349487,
		"y": -63.402843104,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592788,
		"ID": 12,
		"x": -160.3192643297,
		"y": -61.840750619,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592791,
		"ID": 12,
		"x": -161.6422447087,
		"y": -63.379793279,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592795,
		"ID": 12,
		"x": -159.3402446707,
		"y": -63.383806192,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592798,
		"ID": 12,
		"x": -160.4162468277,
		"y": -63.577780745,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592808,
		"ID": 12,
		"x": -161.2152260517,
		"y": -62.644843255,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592809,
		"ID": 12,
		"x": -161.4072494477,
		"y": -63.187849029,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592825,
		"ID": 12,
		"x": -159.5082668217,
		"y": -63.014806741,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592826,
		"ID": 12,
		"x": -161.5652976697,
		"y": -63.718858281,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592832,
		"ID": 12,
		"x": -160.6712292467,
		"y": -63.437776976,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592834,
		"ID": 12,
		"x": -160.1222731767,
		"y": -63.833826765,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592840,
		"ID": 12,
		"x": -160.4242606237,
		"y": -62.506753895,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592843,
		"ID": 12,
		"x": -159.3422543257,
		"y": -62.587832147,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592845,
		"ID": 12,
		"x": -161.7042612787,
		"y": -62.773810704,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592847,
		"ID": 12,
		"x": -160.0232564007,
		"y": -61.894811645,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592850,
		"ID": 12,
		"x": -160.0532843037,
		"y": -64.178853889,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592852,
		"ID": 12,
		"x": -161.1792320787,
		"y": -62.334807733,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592855,
		"ID": 12,
		"x": -161.2652555997,
		"y": -63.036805722,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592859,
		"ID": 12,
		"x": -159.2742583937,
		"y": -62.75583412,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592861,
		"ID": 12,
		"x": -160.7572658837,
		"y": -62.951813476,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592863,
		"ID": 12,
		"x": -159.5332256277,
		"y": -63.778760915,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592867,
		"ID": 12,
		"x": -160.3992687047,
		"y": -63.109769967,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592875,
		"ID": 12,
		"x": -161.6902524307,
		"y": -64.084762094,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592880,
		"ID": 12,
		"x": -160.8262700207,
		"y": -62.661811876,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592888,
		"ID": 12,
		"x": -159.8622620757,
		"y": -63.797780067,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592889,
		"ID": 12,
		"x": -160.4542773067,
		"y": -63.914803434,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592893,
		"ID": 12,
		"x": -161.5482541527,
		"y": -62.807793506,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592895,
		"ID": 12,
		"x": -159.5812463887,
		"y": -62.634809666,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592899,
		"ID": 12,
		"x": -161.5102768227,
		"y": -62.174811962,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592902,
		"ID": 12,
		"x": -159.1852456077,
		"y": -62.978770676,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592903,
		"ID": 12,
		"x": -160.6882479907,
		"y": -63.749799924,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592905,
		"ID": 12,
		"x": -159.8312780957,
		"y": -62.900843147,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592911,
		"ID": 12,
		"x": -160.9342675187,
		"y": -62.525809326,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592913,
		"ID": 12,
		"x": -160.9872326417,
		"y": -63.250822778,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592914,
		"ID": 12,
		"x": -160.2392921807,
		"y": -62.933764451,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592916,
		"ID": 12,
		"x": -159.8522522837,
		"y": -63.379795453,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592917,
		"ID": 12,
		"x": -159.9232775857,
		"y": -62.92477936,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592919,
		"ID": 12,
		"x": -160.0802951097,
		"y": -63.085832803,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592921,
		"ID": 12,
		"x": -160.2252759077,
		"y": -63.269763294,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592922,
		"ID": 12,
		"x": -161.0952520327,
		"y": -63.543753398,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592928,
		"ID": 12,
		"x": -160.9362754217,
		"y": -63.945778862,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592929,
		"ID": 12,
		"x": -162.5172680837,
		"y": -61.925847074,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592935,
		"ID": 12,
		"x": -162.0642469117,
		"y": -61.505819986,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592936,
		"ID": 12,
		"x": -161.9292806317,
		"y": -62.106814565,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592937,
		"ID": 12,
		"x": -161.7752500757,
		"y": -61.214853462,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592938,
		"ID": 12,
		"x": -160.8452227797,
		"y": -60.962762313,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592939,
		"ID": 12,
		"x": -162.1232770227,
		"y": -62.389823084,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592940,
		"ID": 12,
		"x": -160.8662580837,
		"y": -62.030858448,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592941,
		"ID": 12,
		"x": -161.4512529627,
		"y": -59.704807222,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592942,
		"ID": 12,
		"x": -161.2942492357,
		"y": -61.565838399,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592943,
		"ID": 12,
		"x": -161.5672727867,
		"y": -60.959754496,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592944,
		"ID": 12,
		"x": -161.3982778497,
		"y": -61.993804037,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592945,
		"ID": 12,
		"x": -161.1092633967,
		"y": -61.797754625,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592946,
		"ID": 12,
		"x": -160.7052814347,
		"y": -60.36283589,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592947,
		"ID": 12,
		"x": -160.9812881737,
		"y": -61.200857178,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592948,
		"ID": 12,
		"x": -161.9472721597,
		"y": -62.595818924,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592949,
		"ID": 12,
		"x": -161.1962705707,
		"y": -60.789773327,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592950,
		"ID": 12,
		"x": -161.5872416247,
		"y": -61.480857214,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592951,
		"ID": 12,
		"x": -161.1752306707,
		"y": -60.997812565,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592952,
		"ID": 12,
		"x": -161.6562338127,
		"y": -61.783774404,
		"h": 4.8241758242
	},
	{
		"stop_id": 8592953,
		"ID": 12,
		"x": -161.2462535987,
		"y": -60.412808699,
		"h": 4.8241758242
	},
	{
		"stop_id": 8593008,
		"ID": 12,
		"x": -164.5442336327,
		"y": -61.028820058,
		"h": 4.8241758242
	},
	{
		"stop_id": 8593010,
		"ID": 12,
		"x": -164.4792982957,
		"y": -61.755853114,
		"h": 4.8241758242
	},
	{
		"stop_id": 8593012,
		"ID": 12,
		"x": -163.0422713567,
		"y": -62.467800666,
		"h": 4.8241758242
	},
	{
		"stop_id": 8593014,
		"ID": 12,
		"x": -162.9132539197,
		"y": -62.264763274,
		"h": 4.8241758242
	},
	{
		"stop_id": 8593019,
		"ID": 12,
		"x": -164.2902777597,
		"y": -61.22178381,
		"h": 4.8241758242
	},
	{
		"stop_id": 8593021,
		"ID": 12,
		"x": -162.7072690877,
		"y": -62.013781701,
		"h": 4.8241758242
	},
	{
		"stop_id": 8593074,
		"ID": 12,
		"x": -160.0592744307,
		"y": -60.276758364,
		"h": 4.8241758242
	},
	{
		"stop_id": 8593075,
		"ID": 12,
		"x": -160.3252706287,
		"y": -60.282786846,
		"h": 4.8241758242
	},
	{
		"stop_id": 8593076,
		"ID": 12,
		"x": -159.6402610877,
		"y": -60.556760421,
		"h": 4.8241758242
	},
	{
		"stop_id": 8593077,
		"ID": 12,
		"x": -159.8202775397,
		"y": -61.085780151,
		"h": 4.8241758242
	},
	{
		"stop_id": 8593078,
		"ID": 12,
		"x": -160.0162857157,
		"y": -61.646772168,
		"h": 4.8241758242
	},
	{
		"stop_id": 8593139,
		"ID": 12,
		"x": -162.6432683837,
		"y": -62.990822536,
		"h": 4.8241758242
	},
	{
		"stop_id": 8593141,
		"ID": 12,
		"x": -162.2242272917,
		"y": -63.14181042,
		"h": 4.8241758242
	},
	{
		"stop_id": 8593144,
		"ID": 12,
		"x": -162.6492924777,
		"y": -63.82980667,
		"h": 4.8241758242
	},
	{
		"stop_id": 8593152,
		"ID": 12,
		"x": -162.0542810097,
		"y": -63.95775827,
		"h": 4.8241758242
	},
	{
		"stop_id": 8593155,
		"ID": 12,
		"x": -163.5952910127,
		"y": -63.053812991,
		"h": 4.8241758242
	},
	{
		"stop_id": 8593157,
		"ID": 12,
		"x": -162.6412474287,
		"y": -64.091776064,
		"h": 4.8241758242
	},
	{
		"stop_id": 8593158,
		"ID": 12,
		"x": -162.1262881067,
		"y": -62.790803004,
		"h": 4.8241758242
	},
	{
		"stop_id": 8593161,
		"ID": 12,
		"x": -162.8002995957,
		"y": -63.668800539,
		"h": 4.8241758242
	},
	{
		"stop_id": 8593165,
		"ID": 12,
		"x": -161.9352546197,
		"y": -63.007837454,
		"h": 4.8241758242
	},
	{
		"stop_id": 8593169,
		"ID": 12,
		"x": -163.3642451257,
		"y": -63.054776312,
		"h": 4.8241758242
	},
	{
		"stop_id": 8593220,
		"ID": 12,
		"x": -161.6722298697,
		"y": -59.274814681,
		"h": 4.8241758242
	},
	{
		"stop_id": 8593242,
		"ID": 12,
		"x": -161.5882776407,
		"y": -59.537839625,
		"h": 4.8241758242
	},
	{
		"stop_id": 8593243,
		"ID": 12,
		"x": -161.6692792437,
		"y": -59.026819571,
		"h": 4.8241758242
	},
	{
		"stop_id": 8594935,
		"ID": 12,
		"x": -161.8022338197,
		"y": -58.478786783,
		"h": 4.8241758242
	},
	{
		"stop_id": 8594936,
		"ID": 12,
		"x": -162.9222390457,
		"y": -59.06380644,
		"h": 4.8241758242
	},
	{
		"stop_id": 8594945,
		"ID": 12,
		"x": -163.4422814767,
		"y": -60.177835372,
		"h": 4.8241758242
	},
	{
		"stop_id": 8594946,
		"ID": 12,
		"x": -163.9072977657,
		"y": -60.617787326,
		"h": 4.8241758242
	},
	{
		"stop_id": 8594961,
		"ID": 12,
		"x": -164.4092773937,
		"y": -61.107763569,
		"h": 4.8241758242
	},
	{
		"stop_id": 8595017,
		"ID": 12,
		"x": -162.4142499777,
		"y": -58.638855166,
		"h": 4.8241758242
	},
	{
		"stop_id": 8595020,
		"ID": 12,
		"x": -161.7222638977,
		"y": -64.069768627,
		"h": 4.8241758242
	},
	{
		"stop_id": 8595027,
		"ID": 12,
		"x": -162.4192414007,
		"y": -62.45984973,
		"h": 4.8241758242
	},
	{
		"stop_id": 8595028,
		"ID": 12,
		"x": -164.5142910437,
		"y": -61.428816193,
		"h": 4.8241758242
	},
	{
		"stop_id": 8501012,
		"ID": 22,
		"x": -158.2202660477,
		"y": -58.173803197,
		"h": 2.2857142857
	},
	{
		"stop_id": 8501021,
		"ID": 22,
		"x": -158.8002307297,
		"y": -58.94580396,
		"h": 2.2857142857
	},
	{
		"stop_id": 8501022,
		"ID": 22,
		"x": -157.8502465247,
		"y": -56.405839788,
		"h": 2.2857142857
	},
	{
		"stop_id": 8501232,
		"ID": 22,
		"x": -158.6432576837,
		"y": -59.12281781,
		"h": 2.2857142857
	},
	{
		"stop_id": 8501235,
		"ID": 22,
		"x": -154.4322609927,
		"y": -57.889838463,
		"h": 2.2857142857
	},
	{
		"stop_id": 8501322,
		"ID": 22,
		"x": -157.5472541367,
		"y": -56.655795675,
		"h": 2.2857142857
	},
	{
		"stop_id": 8530616,
		"ID": 22,
		"x": -156.0292764147,
		"y": -61.310813593,
		"h": 2.2857142857
	},
	{
		"stop_id": 8587045,
		"ID": 22,
		"x": -154.8902787317,
		"y": -59.319850578,
		"h": 2.2857142857
	},
	{
		"stop_id": 8587053,
		"ID": 22,
		"x": -153.4052560287,
		"y": -58.334781208,
		"h": 2.2857142857
	},
	{
		"stop_id": 8587064,
		"ID": 22,
		"x": -158.6612489757,
		"y": -58.045855011,
		"h": 2.2857142857
	},
	{
		"stop_id": 8587065,
		"ID": 22,
		"x": -158.8552698867,
		"y": -58.920774995,
		"h": 2.2857142857
	},
	{
		"stop_id": 8587071,
		"ID": 22,
		"x": -154.0212410007,
		"y": -60.050802535,
		"h": 2.2857142857
	},
	{
		"stop_id": 8587095,
		"ID": 22,
		"x": -157.8932441417,
		"y": -56.385795671,
		"h": 2.2857142857
	},
	{
		"stop_id": 8587097,
		"ID": 22,
		"x": -155.4732699337,
		"y": -60.926851668,
		"h": 2.2857142857
	},
	{
		"stop_id": 8587433,
		"ID": 22,
		"x": -153.9712390627,
		"y": -59.396850839,
		"h": 2.2857142857
	},
	{
		"stop_id": 8592724,
		"ID": 22,
		"x": -155.0832944067,
		"y": -59.596756105,
		"h": 2.2857142857
	},
	{
		"stop_id": 8592725,
		"ID": 22,
		"x": -155.2022303907,
		"y": -59.938754826,
		"h": 2.2857142857
	},
	{
		"stop_id": 8592726,
		"ID": 22,
		"x": -154.2832390637,
		"y": -58.659751849,
		"h": 2.2857142857
	},
	{
		"stop_id": 8592727,
		"ID": 22,
		"x": -154.6692479597,
		"y": -59.02581326,
		"h": 2.2857142857
	},
	{
		"stop_id": 8592728,
		"ID": 22,
		"x": -154.5312977277,
		"y": -58.864769058,
		"h": 2.2857142857
	},
	{
		"stop_id": 8592729,
		"ID": 22,
		"x": -154.2922555137,
		"y": -60.117832632,
		"h": 2.2857142857
	},
	{
		"stop_id": 8592730,
		"ID": 22,
		"x": -154.5422617927,
		"y": -60.821791137,
		"h": 2.2857142857
	},
	{
		"stop_id": 8592733,
		"ID": 22,
		"x": -155.3472684937,
		"y": -61.10084097,
		"h": 2.2857142857
	},
	{
		"stop_id": 8592734,
		"ID": 22,
		"x": -155.3822375727,
		"y": -60.463786546,
		"h": 2.2857142857
	},
	{
		"stop_id": 8592736,
		"ID": 22,
		"x": -155.0602890267,
		"y": -60.543809197,
		"h": 2.2857142857
	},
	{
		"stop_id": 8592737,
		"ID": 22,
		"x": -154.7872873837,
		"y": -60.273831427,
		"h": 2.2857142857
	},
	{
		"stop_id": 8592760,
		"ID": 22,
		"x": -154.1302389327,
		"y": -58.185854911,
		"h": 2.2857142857
	},
	{
		"stop_id": 8592764,
		"ID": 22,
		"x": -153.7572321627,
		"y": -57.465787601,
		"h": 2.2857142857
	},
	{
		"stop_id": 8592765,
		"ID": 22,
		"x": -153.9582530847,
		"y": -57.921822653,
		"h": 2.2857142857
	},
	{
		"stop_id": 8592930,
		"ID": 22,
		"x": -159.1372679877,
		"y": -58.754818639,
		"h": 2.2857142857
	},
	{
		"stop_id": 8592932,
		"ID": 22,
		"x": -158.4382794897,
		"y": -57.627797066,
		"h": 2.2857142857
	},
	{
		"stop_id": 8592933,
		"ID": 22,
		"x": -158.3812749057,
		"y": -57.347776574,
		"h": 2.2857142857
	},
	{
		"stop_id": 8592934,
		"ID": 22,
		"x": -159.4602965057,
		"y": -58.622748715,
		"h": 2.2857142857
	},
	{
		"stop_id": 8593181,
		"ID": 22,
		"x": -158.0462609107,
		"y": -55.95481903,
		"h": 2.2857142857
	},
	{
		"stop_id": 8593184,
		"ID": 22,
		"x": -158.0442712287,
		"y": -56.452826065,
		"h": 2.2857142857
	},
	{
		"stop_id": 8593186,
		"ID": 22,
		"x": -157.6682632027,
		"y": -56.972809085,
		"h": 2.2857142857
	},
	{
		"stop_id": 8593187,
		"ID": 22,
		"x": -157.9692275937,
		"y": -56.990823751,
		"h": 2.2857142857
	},
	{
		"stop_id": 8593191,
		"ID": 22,
		"x": -157.6572629237,
		"y": -56.693815072,
		"h": 2.2857142857
	},
	{
		"stop_id": 8595023,
		"ID": 22,
		"x": -158.5042917947,
		"y": -58.566856371,
		"h": 2.2857142857
	},
	{
		"stop_id": 8595663,
		"ID": 22,
		"x": -158.3422400737,
		"y": -56.307769521,
		"h": 2.2857142857
	},
	{
		"stop_id": 8501013,
		"ID": 23,
		"x": -158.0732553647,
		"y": -55.548795262,
		"h": 1.7582417582
	},
	{
		"stop_id": 8501014,
		"ID": 23,
		"x": -157.5192381447,
		"y": -54.169826626,
		"h": 1.7582417582
	},
	{
		"stop_id": 8501015,
		"ID": 23,
		"x": -156.6152826267,
		"y": -53.321762294,
		"h": 1.7582417582
	},
	{
		"stop_id": 8501023,
		"ID": 23,
		"x": -156.0812793347,
		"y": -52.246758119,
		"h": 1.7582417582
	},
	{
		"stop_id": 8501316,
		"ID": 23,
		"x": -155.6902319037,
		"y": -52.511814393,
		"h": 1.7582417582
	},
	{
		"stop_id": 8587078,
		"ID": 23,
		"x": -157.2752242017,
		"y": -53.494800971,
		"h": 1.7582417582
	},
	{
		"stop_id": 8587575,
		"ID": 23,
		"x": -157.0422763477,
		"y": -52.169854879,
		"h": 1.7582417582
	},
	{
		"stop_id": 8587576,
		"ID": 23,
		"x": -156.0422575817,
		"y": -51.669805035,
		"h": 1.7582417582
	},
	{
		"stop_id": 8587577,
		"ID": 23,
		"x": -156.0462579277,
		"y": -52.243759478,
		"h": 1.7582417582
	},
	{
		"stop_id": 8587579,
		"ID": 23,
		"x": -157.3772841997,
		"y": -50.298849328,
		"h": 1.7582417582
	},
	{
		"stop_id": 8587581,
		"ID": 23,
		"x": -157.1822469967,
		"y": -51.673847625,
		"h": 1.7582417582
	},
	{
		"stop_id": 8587707,
		"ID": 23,
		"x": -157.6952779647,
		"y": -49.882773441,
		"h": 1.7582417582
	},
	{
		"stop_id": 8588655,
		"ID": 23,
		"x": -157.0592824077,
		"y": -53.128837513,
		"h": 1.7582417582
	},
	{
		"stop_id": 8588666,
		"ID": 23,
		"x": -155.5022665717,
		"y": -50.323794817,
		"h": 1.7582417582
	},
	{
		"stop_id": 8588667,
		"ID": 23,
		"x": -155.7422669587,
		"y": -50.519768583,
		"h": 1.7582417582
	},
	{
		"stop_id": 8588668,
		"ID": 23,
		"x": -155.7472746037,
		"y": -50.790854755,
		"h": 1.7582417582
	},
	{
		"stop_id": 8588669,
		"ID": 23,
		"x": -156.1722468867,
		"y": -51.349756052,
		"h": 1.7582417582
	},
	{
		"stop_id": 8593183,
		"ID": 23,
		"x": -158.5942518207,
		"y": -54.618826701,
		"h": 1.7582417582
	},
	{
		"stop_id": 8593188,
		"ID": 23,
		"x": -158.0102557357,
		"y": -55.10676942,
		"h": 1.7582417582
	},
	{
		"stop_id": 8593189,
		"ID": 23,
		"x": -158.0222493997,
		"y": -55.516827792,
		"h": 1.7582417582
	},
	{
		"stop_id": 8593190,
		"ID": 23,
		"x": -157.8282533927,
		"y": -55.246814181,
		"h": 1.7582417582
	},
	{
		"stop_id": 8595171,
		"ID": 23,
		"x": -156.3932361057,
		"y": -51.215806234,
		"h": 1.7582417582
	},
	{
		"stop_id": 8595172,
		"ID": 23,
		"x": -156.7332773477,
		"y": -50.951856513,
		"h": 1.7582417582
	},
	{
		"stop_id": 8595173,
		"ID": 23,
		"x": -156.3612269337,
		"y": -52.583824486,
		"h": 1.7582417582
	},
	{
		"stop_id": 8501030,
		"ID": 34,
		"x": -152.2592428717,
		"y": -44.854750709,
		"h": 3.0769230769
	},
	{
		"stop_id": 8501053,
		"ID": 34,
		"x": -153.6732908437,
		"y": -43.220786264,
		"h": 3.0769230769
	},
	{
		"stop_id": 8501059,
		"ID": 34,
		"x": -152.7812776367,
		"y": -44.097816426,
		"h": 3.0769230769
	},
	{
		"stop_id": 8501069,
		"ID": 34,
		"x": -154.0912663587,
		"y": -42.891836723,
		"h": 3.0769230769
	},
	{
		"stop_id": 8501227,
		"ID": 34,
		"x": -151.6792343307,
		"y": -45.098769047,
		"h": 3.0769230769
	},
	{
		"stop_id": 8501289,
		"ID": 34,
		"x": -152.3812743207,
		"y": -41.868853412,
		"h": 3.0769230769
	},
	{
		"stop_id": 8501733,
		"ID": 34,
		"x": -152.3172916297,
		"y": -43.094798364,
		"h": 3.0769230769
	},
	{
		"stop_id": 8570000,
		"ID": 34,
		"x": -152.1932794317,
		"y": -44.807845312,
		"h": 3.0769230769
	},
	{
		"stop_id": 8570001,
		"ID": 34,
		"x": -152.6922497637,
		"y": -44.74480264,
		"h": 3.0769230769
	},
	{
		"stop_id": 8570002,
		"ID": 34,
		"x": -153.1102279837,
		"y": -44.395800262,
		"h": 3.0769230769
	},
	{
		"stop_id": 8570008,
		"ID": 34,
		"x": -152.0802423347,
		"y": -44.053789836,
		"h": 3.0769230769
	},
	{
		"stop_id": 8570009,
		"ID": 34,
		"x": -152.8772457357,
		"y": -41.612832178,
		"h": 3.0769230769
	},
	{
		"stop_id": 8579305,
		"ID": 34,
		"x": -152.6422472917,
		"y": -44.969820234,
		"h": 3.0769230769
	},
	{
		"stop_id": 8579306,
		"ID": 34,
		"x": -153.0462800457,
		"y": -45.0158319,
		"h": 3.0769230769
	},
	{
		"stop_id": 8588656,
		"ID": 34,
		"x": -152.3512576417,
		"y": -45.735758336,
		"h": 3.0769230769
	},
	{
		"stop_id": 8588658,
		"ID": 34,
		"x": -152.1312387487,
		"y": -45.563807272,
		"h": 3.0769230769
	},
	{
		"stop_id": 8588659,
		"ID": 34,
		"x": -152.7162658747,
		"y": -46.281805083,
		"h": 3.0769230769
	},
	{
		"stop_id": 8588660,
		"ID": 34,
		"x": -152.8922446417,
		"y": -46.419839758,
		"h": 3.0769230769
	},
	{
		"stop_id": 8588670,
		"ID": 34,
		"x": -151.4022818607,
		"y": -44.544763701,
		"h": 3.0769230769
	},
	{
		"stop_id": 8588671,
		"ID": 34,
		"x": -151.1642579357,
		"y": -44.281775286,
		"h": 3.0769230769
	},
	{
		"stop_id": 8588672,
		"ID": 34,
		"x": -151.8262625467,
		"y": -44.151844576,
		"h": 3.0769230769
	},
	{
		"stop_id": 8588674,
		"ID": 34,
		"x": -151.6672704887,
		"y": -43.744803845,
		"h": 3.0769230769
	},
	{
		"stop_id": 8588675,
		"ID": 34,
		"x": -151.5172944727,
		"y": -43.569761433,
		"h": 3.0769230769
	},
	{
		"stop_id": 8588677,
		"ID": 34,
		"x": -151.1922957607,
		"y": -43.665758076,
		"h": 3.0769230769
	},
	{
		"stop_id": 8588678,
		"ID": 34,
		"x": -151.6422260757,
		"y": -43.49481311,
		"h": 3.0769230769
	},
	{
		"stop_id": 8588679,
		"ID": 34,
		"x": -151.5172668557,
		"y": -43.244788726,
		"h": 3.0769230769
	},
	{
		"stop_id": 8588680,
		"ID": 34,
		"x": -151.0172624237,
		"y": -43.419818796,
		"h": 3.0769230769
	},
	{
		"stop_id": 8588681,
		"ID": 34,
		"x": -150.9672354987,
		"y": -43.219789433,
		"h": 3.0769230769
	},
	{
		"stop_id": 8588683,
		"ID": 34,
		"x": -151.2672883047,
		"y": -42.819778619,
		"h": 3.0769230769
	},
	{
		"stop_id": 8588685,
		"ID": 34,
		"x": -150.5922427757,
		"y": -43.294831075,
		"h": 3.0769230769
	},
	{
		"stop_id": 8588688,
		"ID": 34,
		"x": -149.3522731507,
		"y": -42.034751974,
		"h": 3.0769230769
	},
	{
		"stop_id": 8593873,
		"ID": 34,
		"x": -152.5752276347,
		"y": -43.955795835,
		"h": 3.0769230769
	},
	{
		"stop_id": 8593874,
		"ID": 34,
		"x": -152.2902761047,
		"y": -45.011813605,
		"h": 3.0769230769
	},
	{
		"stop_id": 8593876,
		"ID": 34,
		"x": -153.4932532497,
		"y": -45.160764648,
		"h": 3.0769230769
	},
	{
		"stop_id": 8593878,
		"ID": 34,
		"x": -152.1422860887,
		"y": -43.895855188,
		"h": 3.0769230769
	},
	{
		"stop_id": 8593879,
		"ID": 34,
		"x": -152.6442852317,
		"y": -44.203770709,
		"h": 3.0769230769
	},
	{
		"stop_id": 8593880,
		"ID": 34,
		"x": -152.3932933947,
		"y": -45.441824269,
		"h": 3.0769230769
	},
	{
		"stop_id": 8593881,
		"ID": 34,
		"x": -152.4092346307,
		"y": -44.041845919,
		"h": 3.0769230769
	},
	{
		"stop_id": 8593882,
		"ID": 34,
		"x": -153.6352437377,
		"y": -45.236823744,
		"h": 3.0769230769
	},
	{
		"stop_id": 8593883,
		"ID": 34,
		"x": -151.9262657617,
		"y": -44.548777524,
		"h": 3.0769230769
	},
	{
		"stop_id": 8593884,
		"ID": 34,
		"x": -152.7772583247,
		"y": -44.026835562,
		"h": 3.0769230769
	},
	{
		"stop_id": 8593885,
		"ID": 34,
		"x": -152.8022324527,
		"y": -44.36376483,
		"h": 3.0769230769
	},
	{
		"stop_id": 8593886,
		"ID": 34,
		"x": -152.3152439837,
		"y": -44.027836984,
		"h": 3.0769230769
	},
	{
		"stop_id": 8593887,
		"ID": 34,
		"x": -152.6402278737,
		"y": -43.84083628,
		"h": 3.0769230769
	},
	{
		"stop_id": 8593888,
		"ID": 34,
		"x": -153.4862647177,
		"y": -44.686808325,
		"h": 3.0769230769
	},
	{
		"stop_id": 8593890,
		"ID": 34,
		"x": -151.8652831967,
		"y": -44.756834819,
		"h": 3.0769230769
	},
	{
		"stop_id": 8593891,
		"ID": 34,
		"x": -152.9062577527,
		"y": -44.523810622,
		"h": 3.0769230769
	},
	{
		"stop_id": 8593892,
		"ID": 34,
		"x": -152.0362829907,
		"y": -44.970793058,
		"h": 3.0769230769
	},
	{
		"stop_id": 8593893,
		"ID": 34,
		"x": -153.2502833227,
		"y": -44.913832256,
		"h": 3.0769230769
	},
	{
		"stop_id": 8593895,
		"ID": 34,
		"x": -153.8842952737,
		"y": -45.304759723,
		"h": 3.0769230769
	},
	{
		"stop_id": 8593896,
		"ID": 34,
		"x": -153.0902567787,
		"y": -45.147786639,
		"h": 3.0769230769
	},
	{
		"stop_id": 8593897,
		"ID": 34,
		"x": -152.0392792167,
		"y": -44.387840526,
		"h": 3.0769230769
	},
	{
		"stop_id": 8593898,
		"ID": 34,
		"x": -152.6172297737,
		"y": -43.945809564,
		"h": 3.0769230769
	},
	{
		"stop_id": 8593899,
		"ID": 34,
		"x": -151.9352801097,
		"y": -44.921753129,
		"h": 3.0769230769
	},
	{
		"stop_id": 8593901,
		"ID": 34,
		"x": -153.3912267487,
		"y": -44.848827751,
		"h": 3.0769230769
	},
	{
		"stop_id": 8594847,
		"ID": 34,
		"x": -153.9592707737,
		"y": -44.927804338,
		"h": 3.0769230769
	},
	{
		"stop_id": 8595202,
		"ID": 34,
		"x": -154.0112951527,
		"y": -45.036835218,
		"h": 3.0769230769
	},
	{
		"stop_id": 8595589,
		"ID": 34,
		"x": -150.8482919527,
		"y": -43.919785699,
		"h": 3.0769230769
	},
	{
		"stop_id": 8595596,
		"ID": 34,
		"x": -153.4072986147,
		"y": -44.501812347,
		"h": 3.0769230769
	},
	{
		"stop_id": 8595597,
		"ID": 34,
		"x": -152.6982375357,
		"y": -45.222776777,
		"h": 3.0769230769
	},
	{
		"stop_id": 8595598,
		"ID": 34,
		"x": -153.3352463797,
		"y": -44.112806752,
		"h": 3.0769230769
	},
	{
		"stop_id": 8595599,
		"ID": 34,
		"x": -151.6762379787,
		"y": -44.957841094,
		"h": 3.0769230769
	},
	{
		"stop_id": 8595653,
		"ID": 34,
		"x": -151.0332739157,
		"y": -43.029786785,
		"h": 3.0769230769
	},
	{
		"stop_id": 8595905,
		"ID": 34,
		"x": -153.8802534547,
		"y": -44.730807794,
		"h": 3.0769230769
	},
	{
		"stop_id": 8501036,
		"ID": 57,
		"x": -135.2052682857,
		"y": -34.208761742,
		"h": 1.8901098901
	},
	{
		"stop_id": 8501042,
		"ID": 57,
		"x": -137.4242281977,
		"y": -34.974853114,
		"h": 1.8901098901
	},
	{
		"stop_id": 8501321,
		"ID": 57,
		"x": -134.7492594977,
		"y": -34.60980055,
		"h": 1.8901098901
	},
	{
		"stop_id": 8577520,
		"ID": 57,
		"x": -138.1172383027,
		"y": -33.169836031,
		"h": 1.8901098901
	},
	{
		"stop_id": 8577555,
		"ID": 57,
		"x": -137.9922429527,
		"y": -33.39481382,
		"h": 1.8901098901
	},
	{
		"stop_id": 8577557,
		"ID": 57,
		"x": -137.9922478077,
		"y": -33.719777428,
		"h": 1.8901098901
	},
	{
		"stop_id": 8577558,
		"ID": 57,
		"x": -138.2642783687,
		"y": -34.057760712,
		"h": 1.8901098901
	},
	{
		"stop_id": 8577562,
		"ID": 57,
		"x": -138.4172890337,
		"y": -34.494790333,
		"h": 1.8901098901
	},
	{
		"stop_id": 8577590,
		"ID": 57,
		"x": -138.5222540047,
		"y": -34.979806175,
		"h": 1.8901098901
	},
	{
		"stop_id": 8577591,
		"ID": 57,
		"x": -138.4852394757,
		"y": -35.226765283,
		"h": 1.8901098901
	},
	{
		"stop_id": 8577592,
		"ID": 57,
		"x": -137.9352377787,
		"y": -35.35978925,
		"h": 1.8901098901
	},
	{
		"stop_id": 8577593,
		"ID": 57,
		"x": -137.4392419217,
		"y": -35.292840678,
		"h": 1.8901098901
	},
	{
		"stop_id": 8577604,
		"ID": 57,
		"x": -137.4992936327,
		"y": -34.97677378,
		"h": 1.8901098901
	},
	{
		"stop_id": 8583358,
		"ID": 57,
		"x": -137.7112339907,
		"y": -34.131771586,
		"h": 1.8901098901
	},
	{
		"stop_id": 8589251,
		"ID": 57,
		"x": -134.8492329147,
		"y": -34.355854625,
		"h": 1.8901098901
	},
	{
		"stop_id": 8589252,
		"ID": 57,
		"x": -135.0362387907,
		"y": -34.073802676,
		"h": 1.8901098901
	},
	{
		"stop_id": 8589253,
		"ID": 57,
		"x": -135.2532324237,
		"y": -34.138787133,
		"h": 1.8901098901
	},
	{
		"stop_id": 8589254,
		"ID": 57,
		"x": -135.9372371917,
		"y": -34.652790275,
		"h": 1.8901098901
	},
	{
		"stop_id": 8589255,
		"ID": 57,
		"x": -136.5232942327,
		"y": -34.596754496,
		"h": 1.8901098901
	},
	{
		"stop_id": 8589256,
		"ID": 57,
		"x": -137.1272865077,
		"y": -34.711750665,
		"h": 1.8901098901
	},
	{
		"stop_id": 8589257,
		"ID": 57,
		"x": -136.1462425467,
		"y": -34.78176929,
		"h": 1.8901098901
	},
	{
		"stop_id": 8589258,
		"ID": 57,
		"x": -135.0502912017,
		"y": -34.263845441,
		"h": 1.8901098901
	},
	{
		"stop_id": 8589262,
		"ID": 57,
		"x": -134.7762959977,
		"y": -33.932858785,
		"h": 1.8901098901
	},
	{
		"stop_id": 8589263,
		"ID": 57,
		"x": -134.7572255607,
		"y": -33.696852057,
		"h": 1.8901098901
	},
	{
		"stop_id": 8594453,
		"ID": 57,
		"x": -138.0982477847,
		"y": -35.077841562,
		"h": 1.8901098901
	},
	{
		"stop_id": 8594454,
		"ID": 57,
		"x": -137.9742294997,
		"y": -34.902799208,
		"h": 1.8901098901
	},
	{
		"stop_id": 8595222,
		"ID": 57,
		"x": -136.1162819587,
		"y": -34.726785021,
		"h": 1.8901098901
	},
	{
		"stop_id": 8595646,
		"ID": 57,
		"x": -135.3822513397,
		"y": -33.900809788,
		"h": 1.8901098901
	},
	{
		"stop_id": 8501037,
		"ID": 68,
		"x": -132.2442422597,
		"y": -31.044836546,
		"h": 2.7472527473
	},
	{
		"stop_id": 8501047,
		"ID": 68,
		"x": -131.1542306617,
		"y": -30.268777232,
		"h": 2.7472527473
	},
	{
		"stop_id": 8501048,
		"ID": 68,
		"x": -130.2652733297,
		"y": -29.730857185,
		"h": 2.7472527473
	},
	{
		"stop_id": 8501054,
		"ID": 68,
		"x": -132.9792433387,
		"y": -31.541766427,
		"h": 2.7472527473
	},
	{
		"stop_id": 8501090,
		"ID": 68,
		"x": -133.2972470397,
		"y": -31.213812475,
		"h": 2.7472527473
	},
	{
		"stop_id": 8501228,
		"ID": 68,
		"x": -131.7462459907,
		"y": -31.351768919,
		"h": 2.7472527473
	},
	{
		"stop_id": 8570069,
		"ID": 68,
		"x": -132.3992730267,
		"y": -30.738793828,
		"h": 2.7472527473
	},
	{
		"stop_id": 8570070,
		"ID": 68,
		"x": -132.6602550657,
		"y": -30.291828356,
		"h": 2.7472527473
	},
	{
		"stop_id": 8570071,
		"ID": 68,
		"x": -132.4262459497,
		"y": -29.681762897,
		"h": 2.7472527473
	},
	{
		"stop_id": 8570081,
		"ID": 68,
		"x": -133.1312264897,
		"y": -31.069759435,
		"h": 2.7472527473
	},
	{
		"stop_id": 8570082,
		"ID": 68,
		"x": -133.5222785177,
		"y": -31.355802962,
		"h": 2.7472527473
	},
	{
		"stop_id": 8570083,
		"ID": 68,
		"x": -133.8702249677,
		"y": -31.753749349,
		"h": 2.7472527473
	},
	{
		"stop_id": 8570084,
		"ID": 68,
		"x": -132.2332862737,
		"y": -31.103779459,
		"h": 2.7472527473
	},
	{
		"stop_id": 8570089,
		"ID": 68,
		"x": -131.8022832617,
		"y": -30.839810984,
		"h": 2.7472527473
	},
	{
		"stop_id": 8570090,
		"ID": 68,
		"x": -131.4422691727,
		"y": -30.044779914,
		"h": 2.7472527473
	},
	{
		"stop_id": 8570091,
		"ID": 68,
		"x": -131.2002681507,
		"y": -29.725815434,
		"h": 2.7472527473
	},
	{
		"stop_id": 8579230,
		"ID": 68,
		"x": -129.7552359787,
		"y": -30.379845635,
		"h": 2.7472527473
	},
	{
		"stop_id": 8588871,
		"ID": 68,
		"x": -131.2072281537,
		"y": -30.220787454,
		"h": 2.7472527473
	},
	{
		"stop_id": 8588898,
		"ID": 68,
		"x": -129.7882734377,
		"y": -30.132767799,
		"h": 2.7472527473
	},
	{
		"stop_id": 8589247,
		"ID": 68,
		"x": -132.1072712097,
		"y": -31.283842417,
		"h": 2.7472527473
	},
	{
		"stop_id": 8589248,
		"ID": 68,
		"x": -132.3032740667,
		"y": -31.477812052,
		"h": 2.7472527473
	},
	{
		"stop_id": 8589249,
		"ID": 68,
		"x": -132.9252476607,
		"y": -31.841814553,
		"h": 2.7472527473
	},
	{
		"stop_id": 8589250,
		"ID": 68,
		"x": -133.0462293417,
		"y": -32.225779574,
		"h": 2.7472527473
	},
	{
		"stop_id": 8591836,
		"ID": 68,
		"x": -132.7762302827,
		"y": -30.930780319,
		"h": 2.7472527473
	},
	{
		"stop_id": 8592251,
		"ID": 68,
		"x": -130.7752522807,
		"y": -29.845807289,
		"h": 2.7472527473
	},
	{
		"stop_id": 8592252,
		"ID": 68,
		"x": -131.0322829697,
		"y": -30.061775098,
		"h": 2.7472527473
	},
	{
		"stop_id": 8592253,
		"ID": 68,
		"x": -130.5703005537,
		"y": -29.762845287,
		"h": 2.7472527473
	},
	{
		"stop_id": 8592257,
		"ID": 68,
		"x": -132.2292440857,
		"y": -30.59676587,
		"h": 2.7472527473
	},
	{
		"stop_id": 8592258,
		"ID": 68,
		"x": -131.9802556387,
		"y": -30.397761347,
		"h": 2.7472527473
	},
	{
		"stop_id": 8592259,
		"ID": 68,
		"x": -130.8302508957,
		"y": -30.388794052,
		"h": 2.7472527473
	},
	{
		"stop_id": 8592260,
		"ID": 68,
		"x": -131.5222876547,
		"y": -30.646829086,
		"h": 2.7472527473
	},
	{
		"stop_id": 8592261,
		"ID": 68,
		"x": -131.8482262387,
		"y": -31.297850319,
		"h": 2.7472527473
	},
	{
		"stop_id": 8592262,
		"ID": 68,
		"x": -132.0362277497,
		"y": -31.171856204,
		"h": 2.7472527473
	},
	{
		"stop_id": 8592263,
		"ID": 68,
		"x": -131.6402553407,
		"y": -30.441749466,
		"h": 2.7472527473
	},
	{
		"stop_id": 8592264,
		"ID": 68,
		"x": -132.6562423957,
		"y": -30.8657552,
		"h": 2.7472527473
	},
	{
		"stop_id": 8592266,
		"ID": 68,
		"x": -132.7402947387,
		"y": -31.327773073,
		"h": 2.7472527473
	},
	{
		"stop_id": 8592267,
		"ID": 68,
		"x": -132.6832569937,
		"y": -30.637855069,
		"h": 2.7472527473
	},
	{
		"stop_id": 8592268,
		"ID": 68,
		"x": -131.6882543377,
		"y": -30.309768126,
		"h": 2.7472527473
	},
	{
		"stop_id": 8592269,
		"ID": 68,
		"x": -131.7622430827,
		"y": -29.669857052,
		"h": 2.7472527473
	},
	{
		"stop_id": 8592270,
		"ID": 68,
		"x": -133.3422942117,
		"y": -31.231827109,
		"h": 2.7472527473
	},
	{
		"stop_id": 8592271,
		"ID": 68,
		"x": -132.4662423197,
		"y": -30.900853187,
		"h": 2.7472527473
	},
	{
		"stop_id": 8592272,
		"ID": 68,
		"x": -131.0872538597,
		"y": -30.425771128,
		"h": 2.7472527473
	},
	{
		"stop_id": 8592273,
		"ID": 68,
		"x": -132.9682902287,
		"y": -31.001818287,
		"h": 2.7472527473
	},
	{
		"stop_id": 8592274,
		"ID": 68,
		"x": -131.5052968187,
		"y": -30.335857745,
		"h": 2.7472527473
	},
	{
		"stop_id": 8592276,
		"ID": 68,
		"x": -131.7032741267,
		"y": -30.775849545,
		"h": 2.7472527473
	},
	{
		"stop_id": 8592277,
		"ID": 68,
		"x": -131.7912898557,
		"y": -31.036830861,
		"h": 2.7472527473
	},
	{
		"stop_id": 8592278,
		"ID": 68,
		"x": -131.7762763327,
		"y": -31.109829371,
		"h": 2.7472527473
	},
	{
		"stop_id": 8592279,
		"ID": 68,
		"x": -130.4112477967,
		"y": -30.319805267,
		"h": 2.7472527473
	},
	{
		"stop_id": 8592280,
		"ID": 68,
		"x": -134.0542444797,
		"y": -31.959817318,
		"h": 2.7472527473
	},
	{
		"stop_id": 8592281,
		"ID": 68,
		"x": -133.7102753427,
		"y": -31.593850425,
		"h": 2.7472527473
	},
	{
		"stop_id": 8592282,
		"ID": 68,
		"x": -133.5002629717,
		"y": -32.351856305,
		"h": 2.7472527473
	},
	{
		"stop_id": 8592283,
		"ID": 68,
		"x": -133.7932670877,
		"y": -32.373824647,
		"h": 2.7472527473
	},
	{
		"stop_id": 8592284,
		"ID": 68,
		"x": -133.2352783337,
		"y": -32.090841432,
		"h": 2.7472527473
	},
	{
		"stop_id": 8595218,
		"ID": 68,
		"x": -130.1502248557,
		"y": -29.722756499,
		"h": 2.7472527473
	},
	{
		"stop_id": 8501045,
		"ID": 79,
		"x": -128.6492634767,
		"y": -29.082790017,
		"h": 5.2527472527
	},
	{
		"stop_id": 8501117,
		"ID": 79,
		"x": -127.7582571377,
		"y": -27.040805457,
		"h": 5.2527472527
	},
	{
		"stop_id": 8501118,
		"ID": 79,
		"x": -125.6912860357,
		"y": -28.23683444,
		"h": 5.2527472527
	},
	{
		"stop_id": 8501208,
		"ID": 79,
		"x": -123.4702444877,
		"y": -29.777856148,
		"h": 5.2527472527
	},
	{
		"stop_id": 8501209,
		"ID": 79,
		"x": -123.8372492907,
		"y": -29.681791187,
		"h": 5.2527472527
	},
	{
		"stop_id": 8501210,
		"ID": 79,
		"x": -124.8742774227,
		"y": -29.77580868,
		"h": 5.2527472527
	},
	{
		"stop_id": 8501211,
		"ID": 79,
		"x": -125.2642842137,
		"y": -29.665844065,
		"h": 5.2527472527
	},
	{
		"stop_id": 8501212,
		"ID": 79,
		"x": -125.7092735807,
		"y": -29.574816952,
		"h": 5.2527472527
	},
	{
		"stop_id": 8501213,
		"ID": 79,
		"x": -126.1202661437,
		"y": -29.852779652,
		"h": 5.2527472527
	},
	{
		"stop_id": 8501214,
		"ID": 79,
		"x": -126.6912922057,
		"y": -29.874793916,
		"h": 5.2527472527
	},
	{
		"stop_id": 8501215,
		"ID": 79,
		"x": -126.8072575797,
		"y": -29.6077988,
		"h": 5.2527472527
	},
	{
		"stop_id": 8501216,
		"ID": 79,
		"x": -126.6532651697,
		"y": -29.257766071,
		"h": 5.2527472527
	},
	{
		"stop_id": 8501217,
		"ID": 79,
		"x": -126.3842956997,
		"y": -28.708784508,
		"h": 5.2527472527
	},
	{
		"stop_id": 8501218,
		"ID": 79,
		"x": -126.1012914427,
		"y": -28.155832988,
		"h": 5.2527472527
	},
	{
		"stop_id": 8501245,
		"ID": 79,
		"x": -127.0712487207,
		"y": -31.390831581,
		"h": 5.2527472527
	},
	{
		"stop_id": 8518452,
		"ID": 79,
		"x": -123.8862527797,
		"y": -29.40578449,
		"h": 5.2527472527
	},
	{
		"stop_id": 8530749,
		"ID": 79,
		"x": -125.7572388997,
		"y": -28.185749033,
		"h": 5.2527472527
	},
	{
		"stop_id": 8579231,
		"ID": 79,
		"x": -128.2232365367,
		"y": -30.898774702,
		"h": 5.2527472527
	},
	{
		"stop_id": 8579233,
		"ID": 79,
		"x": -126.6352971007,
		"y": -29.890759279,
		"h": 5.2527472527
	},
	{
		"stop_id": 8579234,
		"ID": 79,
		"x": -126.5162273157,
		"y": -30.079853601,
		"h": 5.2527472527
	},
	{
		"stop_id": 8581914,
		"ID": 79,
		"x": -127.7222315227,
		"y": -27.049773589,
		"h": 5.2527472527
	},
	{
		"stop_id": 8581918,
		"ID": 79,
		"x": -127.7462911297,
		"y": -26.769790625,
		"h": 5.2527472527
	},
	{
		"stop_id": 8588155,
		"ID": 79,
		"x": -127.6732546757,
		"y": -31.165826592,
		"h": 5.2527472527
	},
	{
		"stop_id": 8588156,
		"ID": 79,
		"x": -127.8962722687,
		"y": -31.074808612,
		"h": 5.2527472527
	},
	{
		"stop_id": 8588157,
		"ID": 79,
		"x": -127.2142848377,
		"y": -30.853821323,
		"h": 5.2527472527
	},
	{
		"stop_id": 8588158,
		"ID": 79,
		"x": -127.3232627477,
		"y": -31.214796771,
		"h": 5.2527472527
	},
	{
		"stop_id": 8588838,
		"ID": 79,
		"x": -125.6602801297,
		"y": -28.179809854,
		"h": 5.2527472527
	},
	{
		"stop_id": 8588839,
		"ID": 79,
		"x": -125.6292740047,
		"y": -27.982819257,
		"h": 5.2527472527
	},
	{
		"stop_id": 8588840,
		"ID": 79,
		"x": -125.6432637887,
		"y": -27.516854008,
		"h": 5.2527472527
	},
	{
		"stop_id": 8588841,
		"ID": 79,
		"x": -125.6472910687,
		"y": -27.149830095,
		"h": 5.2527472527
	},
	{
		"stop_id": 8588842,
		"ID": 79,
		"x": -125.6492567757,
		"y": -26.741806142,
		"h": 5.2527472527
	},
	{
		"stop_id": 8588872,
		"ID": 79,
		"x": -128.5582570697,
		"y": -29.450814347,
		"h": 5.2527472527
	},
	{
		"stop_id": 8588873,
		"ID": 79,
		"x": -126.6772778557,
		"y": -29.112752158,
		"h": 5.2527472527
	},
	{
		"stop_id": 8588874,
		"ID": 79,
		"x": -128.6002549687,
		"y": -28.970844961,
		"h": 5.2527472527
	},
	{
		"stop_id": 8588875,
		"ID": 79,
		"x": -128.6182235827,
		"y": -28.476809321,
		"h": 5.2527472527
	},
	{
		"stop_id": 8588983,
		"ID": 79,
		"x": -125.6602589417,
		"y": -28.282755584,
		"h": 5.2527472527
	},
	{
		"stop_id": 8591930,
		"ID": 79,
		"x": -126.8632345787,
		"y": -26.994842743,
		"h": 5.2527472527
	},
	{
		"stop_id": 8591931,
		"ID": 79,
		"x": -126.8042850017,
		"y": -26.791833096,
		"h": 5.2527472527
	},
	{
		"stop_id": 8591933,
		"ID": 79,
		"x": -126.1482668207,
		"y": -28.54675171,
		"h": 5.2527472527
	},
	{
		"stop_id": 8591935,
		"ID": 79,
		"x": -126.5412557817,
		"y": -27.299820776,
		"h": 5.2527472527
	},
	{
		"stop_id": 8591939,
		"ID": 79,
		"x": -126.3272715147,
		"y": -27.495858991,
		"h": 5.2527472527
	},
	{
		"stop_id": 8591944,
		"ID": 79,
		"x": -126.2542319957,
		"y": -30.086761247,
		"h": 5.2527472527
	},
	{
		"stop_id": 8591945,
		"ID": 79,
		"x": -126.1022671067,
		"y": -30.286772527,
		"h": 5.2527472527
	},
	{
		"stop_id": 8591946,
		"ID": 79,
		"x": -127.1222278247,
		"y": -29.228845798,
		"h": 5.2527472527
	},
	{
		"stop_id": 8591947,
		"ID": 79,
		"x": -127.1212706927,
		"y": -29.697782043,
		"h": 5.2527472527
	},
	{
		"stop_id": 8591948,
		"ID": 79,
		"x": -126.6582488417,
		"y": -28.485840509,
		"h": 5.2527472527
	},
	{
		"stop_id": 8591949,
		"ID": 79,
		"x": -127.3842424827,
		"y": -29.642798921,
		"h": 5.2527472527
	},
	{
		"stop_id": 8591950,
		"ID": 79,
		"x": -125.4142880287,
		"y": -30.0717635,
		"h": 5.2527472527
	},
	{
		"stop_id": 8591951,
		"ID": 79,
		"x": -127.0372871487,
		"y": -29.46181464,
		"h": 5.2527472527
	},
	{
		"stop_id": 8591952,
		"ID": 79,
		"x": -127.2472766247,
		"y": -29.711820828,
		"h": 5.2527472527
	},
	{
		"stop_id": 8591953,
		"ID": 79,
		"x": -126.5252518917,
		"y": -28.233847258,
		"h": 5.2527472527
	},
	{
		"stop_id": 8591954,
		"ID": 79,
		"x": -127.2762576027,
		"y": -29.422780201,
		"h": 5.2527472527
	},
	{
		"stop_id": 8591955,
		"ID": 79,
		"x": -126.8522400577,
		"y": -28.420753086,
		"h": 5.2527472527
	},
	{
		"stop_id": 8591956,
		"ID": 79,
		"x": -127.5652784977,
		"y": -29.827750595,
		"h": 5.2527472527
	},
	{
		"stop_id": 8591957,
		"ID": 79,
		"x": -126.9592958827,
		"y": -28.697821024,
		"h": 5.2527472527
	},
	{
		"stop_id": 8591958,
		"ID": 79,
		"x": -126.3312908427,
		"y": -27.913822689,
		"h": 5.2527472527
	},
	{
		"stop_id": 8591959,
		"ID": 79,
		"x": -127.9302571697,
		"y": -30.511778725,
		"h": 5.2527472527
	},
	{
		"stop_id": 8591960,
		"ID": 79,
		"x": -126.8062658287,
		"y": -28.865845106,
		"h": 5.2527472527
	},
	{
		"stop_id": 8591961,
		"ID": 79,
		"x": -127.0672680467,
		"y": -29.055810434,
		"h": 5.2527472527
	},
	{
		"stop_id": 8591995,
		"ID": 79,
		"x": -124.1122579727,
		"y": -30.210808724,
		"h": 5.2527472527
	},
	{
		"stop_id": 8592049,
		"ID": 79,
		"x": -123.8312845227,
		"y": -29.280858062,
		"h": 5.2527472527
	},
	{
		"stop_id": 8592068,
		"ID": 79,
		"x": -123.7502793797,
		"y": -30.47881932,
		"h": 5.2527472527
	},
	{
		"stop_id": 8592103,
		"ID": 79,
		"x": -123.5632886247,
		"y": -29.369757643,
		"h": 5.2527472527
	},
	{
		"stop_id": 8592105,
		"ID": 79,
		"x": -123.6202811427,
		"y": -29.69277304,
		"h": 5.2527472527
	},
	{
		"stop_id": 8592106,
		"ID": 79,
		"x": -123.4602905967,
		"y": -29.960839198,
		"h": 5.2527472527
	},
	{
		"stop_id": 8592114,
		"ID": 79,
		"x": -124.4192609277,
		"y": -29.878777059,
		"h": 5.2527472527
	},
	{
		"stop_id": 8592178,
		"ID": 79,
		"x": -124.1552632987,
		"y": -28.037826654,
		"h": 5.2527472527
	},
	{
		"stop_id": 8592179,
		"ID": 79,
		"x": -124.0322818507,
		"y": -29.040802943,
		"h": 5.2527472527
	},
	{
		"stop_id": 8592180,
		"ID": 79,
		"x": -123.7782417447,
		"y": -28.846852937,
		"h": 5.2527472527
	},
	{
		"stop_id": 8592184,
		"ID": 79,
		"x": -123.8972957767,
		"y": -29.62078408,
		"h": 5.2527472527
	},
	{
		"stop_id": 8592192,
		"ID": 79,
		"x": -123.8882650237,
		"y": -28.264806195,
		"h": 5.2527472527
	},
	{
		"stop_id": 8592200,
		"ID": 79,
		"x": -125.4522985617,
		"y": -28.270803779,
		"h": 5.2527472527
	},
	{
		"stop_id": 8592201,
		"ID": 79,
		"x": -125.3462806707,
		"y": -27.828830104,
		"h": 5.2527472527
	},
	{
		"stop_id": 8592202,
		"ID": 79,
		"x": -125.3472791967,
		"y": -28.088850965,
		"h": 5.2527472527
	},
	{
		"stop_id": 8592203,
		"ID": 79,
		"x": -124.8072985907,
		"y": -27.495839628,
		"h": 5.2527472527
	},
	{
		"stop_id": 8592204,
		"ID": 79,
		"x": -125.2712636397,
		"y": -27.210753241,
		"h": 5.2527472527
	},
	{
		"stop_id": 8592205,
		"ID": 79,
		"x": -124.9392854737,
		"y": -27.959775016,
		"h": 5.2527472527
	},
	{
		"stop_id": 8592206,
		"ID": 79,
		"x": -124.4712585297,
		"y": -28.116808512,
		"h": 5.2527472527
	},
	{
		"stop_id": 8592207,
		"ID": 79,
		"x": -124.2152741877,
		"y": -28.432843872,
		"h": 5.2527472527
	},
	{
		"stop_id": 8592208,
		"ID": 79,
		"x": -124.3682430397,
		"y": -27.939820086,
		"h": 5.2527472527
	},
	{
		"stop_id": 8592209,
		"ID": 79,
		"x": -125.3112358107,
		"y": -28.757833871,
		"h": 5.2527472527
	},
	{
		"stop_id": 8592210,
		"ID": 79,
		"x": -124.8432915827,
		"y": -29.132791988,
		"h": 5.2527472527
	},
	{
		"stop_id": 8592211,
		"ID": 79,
		"x": -124.1832476557,
		"y": -28.765813911,
		"h": 5.2527472527
	},
	{
		"stop_id": 8592212,
		"ID": 79,
		"x": -124.6132750567,
		"y": -27.95485534,
		"h": 5.2527472527
	},
	{
		"stop_id": 8592213,
		"ID": 79,
		"x": -125.0972412177,
		"y": -28.354831976,
		"h": 5.2527472527
	},
	{
		"stop_id": 8592214,
		"ID": 79,
		"x": -125.5332721627,
		"y": -27.790765247,
		"h": 5.2527472527
	},
	{
		"stop_id": 8592215,
		"ID": 79,
		"x": -124.3502269877,
		"y": -29.524770133,
		"h": 5.2527472527
	},
	{
		"stop_id": 8592216,
		"ID": 79,
		"x": -124.0052554747,
		"y": -29.684777131,
		"h": 5.2527472527
	},
	{
		"stop_id": 8592217,
		"ID": 79,
		"x": -124.1612556057,
		"y": -29.018854685,
		"h": 5.2527472527
	},
	{
		"stop_id": 8592218,
		"ID": 79,
		"x": -125.1622759227,
		"y": -28.831830754,
		"h": 5.2527472527
	},
	{
		"stop_id": 8592219,
		"ID": 79,
		"x": -124.6812552047,
		"y": -29.318757482,
		"h": 5.2527472527
	},
	{
		"stop_id": 8592220,
		"ID": 79,
		"x": -125.1212456977,
		"y": -27.881755671,
		"h": 5.2527472527
	},
	{
		"stop_id": 8592221,
		"ID": 79,
		"x": -124.9472772247,
		"y": -28.462853211,
		"h": 5.2527472527
	},
	{
		"stop_id": 8592222,
		"ID": 79,
		"x": -124.5512713287,
		"y": -27.803774758,
		"h": 5.2527472527
	},
	{
		"stop_id": 8592223,
		"ID": 79,
		"x": -124.6782873407,
		"y": -28.73180136,
		"h": 5.2527472527
	},
	{
		"stop_id": 8592226,
		"ID": 79,
		"x": -126.8712420337,
		"y": -30.657774647,
		"h": 5.2527472527
	},
	{
		"stop_id": 8592227,
		"ID": 79,
		"x": -126.3672683797,
		"y": -30.49484546,
		"h": 5.2527472527
	},
	{
		"stop_id": 8592239,
		"ID": 79,
		"x": -128.5262442337,
		"y": -30.21382595,
		"h": 5.2527472527
	},
	{
		"stop_id": 8592240,
		"ID": 79,
		"x": -128.9662719807,
		"y": -30.631786169,
		"h": 5.2527472527
	},
	{
		"stop_id": 8592241,
		"ID": 79,
		"x": -128.5762737077,
		"y": -30.668838999,
		"h": 5.2527472527
	},
	{
		"stop_id": 8592242,
		"ID": 79,
		"x": -128.6492427837,
		"y": -29.756830926,
		"h": 5.2527472527
	},
	{
		"stop_id": 8592243,
		"ID": 79,
		"x": -128.5102407467,
		"y": -28.245806228,
		"h": 5.2527472527
	},
	{
		"stop_id": 8592244,
		"ID": 79,
		"x": -128.1662246477,
		"y": -28.271857502,
		"h": 5.2527472527
	},
	{
		"stop_id": 8592248,
		"ID": 79,
		"x": -127.4632736657,
		"y": -28.804779404,
		"h": 5.2527472527
	},
	{
		"stop_id": 8592255,
		"ID": 79,
		"x": -129.4882611347,
		"y": -29.191842711,
		"h": 5.2527472527
	},
	{
		"stop_id": 8593815,
		"ID": 79,
		"x": -126.1202627667,
		"y": -27.678805177,
		"h": 5.2527472527
	},
	{
		"stop_id": 8593816,
		"ID": 79,
		"x": -125.9912735617,
		"y": -27.132816451,
		"h": 5.2527472527
	},
	{
		"stop_id": 8593817,
		"ID": 79,
		"x": -126.3762703987,
		"y": -26.726780506,
		"h": 5.2527472527
	},
	{
		"stop_id": 8593837,
		"ID": 79,
		"x": -123.6292675947,
		"y": -30.494781668,
		"h": 5.2527472527
	},
	{
		"stop_id": 8593838,
		"ID": 79,
		"x": -123.6852991417,
		"y": -30.574785254,
		"h": 5.2527472527
	},
	{
		"stop_id": 8593844,
		"ID": 79,
		"x": -123.5022730637,
		"y": -29.787855349,
		"h": 5.2527472527
	},
	{
		"stop_id": 8593866,
		"ID": 79,
		"x": -125.6832912167,
		"y": -28.619799387,
		"h": 5.2527472527
	},
	{
		"stop_id": 8593867,
		"ID": 79,
		"x": -126.2062973907,
		"y": -29.256834651,
		"h": 5.2527472527
	},
	{
		"stop_id": 8593868,
		"ID": 79,
		"x": -126.0512742797,
		"y": -28.75382527,
		"h": 5.2527472527
	},
	{
		"stop_id": 8593869,
		"ID": 79,
		"x": -125.8732307057,
		"y": -28.317768881,
		"h": 5.2527472527
	},
	{
		"stop_id": 8594890,
		"ID": 79,
		"x": -127.7202585497,
		"y": -30.238783214,
		"h": 5.2527472527
	},
	{
		"stop_id": 8594986,
		"ID": 79,
		"x": -126.0072820487,
		"y": -29.293829674,
		"h": 5.2527472527
	},
	{
		"stop_id": 8594987,
		"ID": 79,
		"x": -125.6732287117,
		"y": -29.443807035,
		"h": 5.2527472527
	},
	{
		"stop_id": 8594988,
		"ID": 79,
		"x": -128.2762347647,
		"y": -30.787776182,
		"h": 5.2527472527
	},
	{
		"stop_id": 8595148,
		"ID": 79,
		"x": -125.8262769407,
		"y": -26.748754811,
		"h": 5.2527472527
	},
	{
		"stop_id": 8595213,
		"ID": 79,
		"x": -128.5982876837,
		"y": -28.718838732,
		"h": 5.2527472527
	},
	{
		"stop_id": 8595214,
		"ID": 79,
		"x": -127.5502411747,
		"y": -27.278843444,
		"h": 5.2527472527
	},
	{
		"stop_id": 8595215,
		"ID": 79,
		"x": -127.5582461657,
		"y": -27.695761763,
		"h": 5.2527472527
	},
	{
		"stop_id": 8595216,
		"ID": 79,
		"x": -127.7482350057,
		"y": -27.110846585,
		"h": 5.2527472527
	},
	{
		"stop_id": 8595217,
		"ID": 79,
		"x": -127.6602868607,
		"y": -27.452808354,
		"h": 5.2527472527
	},
	{
		"stop_id": 8595223,
		"ID": 79,
		"x": -126.8792678447,
		"y": -30.496818572,
		"h": 5.2527472527
	},
	{
		"stop_id": 8595516,
		"ID": 79,
		"x": -126.0982926857,
		"y": -26.967767012,
		"h": 5.2527472527
	},
	{
		"stop_id": 8595521,
		"ID": 79,
		"x": -124.9172820187,
		"y": -29.594799033,
		"h": 5.2527472527
	},
	{
		"stop_id": 8595534,
		"ID": 79,
		"x": -125.2132884077,
		"y": -28.978800483,
		"h": 5.2527472527
	},
	{
		"stop_id": 8595602,
		"ID": 79,
		"x": -125.4312490477,
		"y": -29.341844304,
		"h": 5.2527472527
	},
	{
		"stop_id": 8501055,
		"ID": 16,
		"x": -160.5262952247,
		"y": -37.299852813,
		"h": 1.0659340659
	},
	{
		"stop_id": 8501061,
		"ID": 16,
		"x": -161.7052472597,
		"y": -36.899757211,
		"h": 1.0659340659
	},
	{
		"stop_id": 8519077,
		"ID": 16,
		"x": -158.9662698247,
		"y": -37.8038475,
		"h": 1.0659340659
	},
	{
		"stop_id": 8501056,
		"ID": 25,
		"x": -154.4802678997,
		"y": -38.808804158,
		"h": 1.2967032967
	},
	{
		"stop_id": 8501067,
		"ID": 25,
		"x": -154.5462449567,
		"y": -39.879752267,
		"h": 1.2967032967
	},
	{
		"stop_id": 8501068,
		"ID": 25,
		"x": -154.4802372627,
		"y": -41.56281568,
		"h": 1.2967032967
	},
	{
		"stop_id": 8501966,
		"ID": 25,
		"x": -157.1922899297,
		"y": -42.994787643,
		"h": 1.2967032967
	},
	{
		"stop_id": 8501967,
		"ID": 25,
		"x": -156.6172403437,
		"y": -42.194787145,
		"h": 1.2967032967
	},
	{
		"stop_id": 8501968,
		"ID": 25,
		"x": -155.7172532617,
		"y": -43.819846295,
		"h": 1.2967032967
	},
	{
		"stop_id": 8570005,
		"ID": 25,
		"x": -154.6302354807,
		"y": -43.39679526,
		"h": 1.2967032967
	},
	{
		"stop_id": 8570006,
		"ID": 25,
		"x": -156.8922560757,
		"y": -43.01975695,
		"h": 1.2967032967
	},
	{
		"stop_id": 8570007,
		"ID": 25,
		"x": -156.7922970357,
		"y": -42.219764115,
		"h": 1.2967032967
	},
	{
		"stop_id": 8580603,
		"ID": 25,
		"x": -157.0672426487,
		"y": -43.119773656,
		"h": 1.2967032967
	},
	{
		"stop_id": 8501057,
		"ID": 26,
		"x": -156.1802374177,
		"y": -37.671797201,
		"h": 1.0659340659
	},
	{
		"stop_id": 8501062,
		"ID": 26,
		"x": -157.9582623197,
		"y": -37.627815617,
		"h": 1.0659340659
	},
	{
		"stop_id": 8501063,
		"ID": 26,
		"x": -154.0002754597,
		"y": -36.576753533,
		"h": 1.0659340659
	},
	{
		"stop_id": 8501060,
		"ID": 9,
		"x": -164.5942524557,
		"y": -35.677817549,
		"h": 1
	},
	{
		"stop_id": 8501071,
		"ID": 41,
		"x": -145.4472848147,
		"y": -46.438800393,
		"h": 1.032967033
	},
	{
		"stop_id": 8501242,
		"ID": 41,
		"x": -147.1932902867,
		"y": -47.044759104,
		"h": 1.032967033
	},
	{
		"stop_id": 8501075,
		"ID": 90,
		"x": -122.0512441537,
		"y": -31.762806869,
		"h": 4.7252747253
	},
	{
		"stop_id": 8501120,
		"ID": 90,
		"x": -121.8672320757,
		"y": -30.528819567,
		"h": 4.7252747253
	},
	{
		"stop_id": 8501121,
		"ID": 90,
		"x": -119.5432631507,
		"y": -31.203857454,
		"h": 4.7252747253
	},
	{
		"stop_id": 8501160,
		"ID": 90,
		"x": -122.0922340887,
		"y": -29.809766968,
		"h": 4.7252747253
	},
	{
		"stop_id": 8501181,
		"ID": 90,
		"x": -121.7662462797,
		"y": -30.083843123,
		"h": 4.7252747253
	},
	{
		"stop_id": 8501207,
		"ID": 90,
		"x": -123.0532906727,
		"y": -29.95580272,
		"h": 4.7252747253
	},
	{
		"stop_id": 8501319,
		"ID": 90,
		"x": -119.4082936907,
		"y": -31.818751102,
		"h": 4.7252747253
	},
	{
		"stop_id": 8504000,
		"ID": 90,
		"x": -119.6522303137,
		"y": -30.785769923,
		"h": 4.7252747253
	},
	{
		"stop_id": 8579237,
		"ID": 90,
		"x": -120.9732469187,
		"y": -30.041837891,
		"h": 4.7252747253
	},
	{
		"stop_id": 8579253,
		"ID": 90,
		"x": -121.8202560817,
		"y": -30.193789767,
		"h": 4.7252747253
	},
	{
		"stop_id": 8579254,
		"ID": 90,
		"x": -121.5272445417,
		"y": -30.244835664,
		"h": 4.7252747253
	},
	{
		"stop_id": 8588431,
		"ID": 90,
		"x": -120.4872580737,
		"y": -29.988850396,
		"h": 4.7252747253
	},
	{
		"stop_id": 8588432,
		"ID": 90,
		"x": -119.8552729317,
		"y": -29.838788577,
		"h": 4.7252747253
	},
	{
		"stop_id": 8588439,
		"ID": 90,
		"x": -119.3992812137,
		"y": -31.722788926,
		"h": 4.7252747253
	},
	{
		"stop_id": 8588440,
		"ID": 90,
		"x": -119.6902717087,
		"y": -31.67575872,
		"h": 4.7252747253
	},
	{
		"stop_id": 8588441,
		"ID": 90,
		"x": -120.0072682777,
		"y": -31.711831937,
		"h": 4.7252747253
	},
	{
		"stop_id": 8588442,
		"ID": 90,
		"x": -119.9502503747,
		"y": -31.452819125,
		"h": 4.7252747253
	},
	{
		"stop_id": 8588443,
		"ID": 90,
		"x": -119.7292884627,
		"y": -31.285826425,
		"h": 4.7252747253
	},
	{
		"stop_id": 8588444,
		"ID": 90,
		"x": -119.4822840957,
		"y": -31.292844798,
		"h": 4.7252747253
	},
	{
		"stop_id": 8588445,
		"ID": 90,
		"x": -119.5922752857,
		"y": -31.269849775,
		"h": 4.7252747253
	},
	{
		"stop_id": 8588446,
		"ID": 90,
		"x": -119.3502356947,
		"y": -31.173757872,
		"h": 4.7252747253
	},
	{
		"stop_id": 8588447,
		"ID": 90,
		"x": -119.2342435287,
		"y": -30.830833351,
		"h": 4.7252747253
	},
	{
		"stop_id": 8589522,
		"ID": 90,
		"x": -121.1902773437,
		"y": -29.667754421,
		"h": 4.7252747253
	},
	{
		"stop_id": 8589523,
		"ID": 90,
		"x": -121.2502354607,
		"y": -30.09781857,
		"h": 4.7252747253
	},
	{
		"stop_id": 8589524,
		"ID": 90,
		"x": -121.4422857657,
		"y": -30.094849113,
		"h": 4.7252747253
	},
	{
		"stop_id": 8590442,
		"ID": 90,
		"x": -121.5862354147,
		"y": -29.854795565,
		"h": 4.7252747253
	},
	{
		"stop_id": 8591818,
		"ID": 90,
		"x": -121.7572672577,
		"y": -30.135852836,
		"h": 4.7252747253
	},
	{
		"stop_id": 8591978,
		"ID": 90,
		"x": -120.4412258117,
		"y": -29.746851295,
		"h": 4.7252747253
	},
	{
		"stop_id": 8591979,
		"ID": 90,
		"x": -121.2842265187,
		"y": -30.726811184,
		"h": 4.7252747253
	},
	{
		"stop_id": 8591981,
		"ID": 90,
		"x": -120.6192356297,
		"y": -30.661767843,
		"h": 4.7252747253
	},
	{
		"stop_id": 8591983,
		"ID": 90,
		"x": -123.1052525157,
		"y": -30.560806942,
		"h": 4.7252747253
	},
	{
		"stop_id": 8591985,
		"ID": 90,
		"x": -122.3352816747,
		"y": -30.990771689,
		"h": 4.7252747253
	},
	{
		"stop_id": 8591986,
		"ID": 90,
		"x": -121.9992357347,
		"y": -31.469853378,
		"h": 4.7252747253
	},
	{
		"stop_id": 8591988,
		"ID": 90,
		"x": -121.8622859407,
		"y": -29.916760952,
		"h": 4.7252747253
	},
	{
		"stop_id": 8591989,
		"ID": 90,
		"x": -122.7752821257,
		"y": -31.098789793,
		"h": 4.7252747253
	},
	{
		"stop_id": 8591990,
		"ID": 90,
		"x": -122.7802814497,
		"y": -30.060839657,
		"h": 4.7252747253
	},
	{
		"stop_id": 8591991,
		"ID": 90,
		"x": -121.2222459867,
		"y": -30.249853812,
		"h": 4.7252747253
	},
	{
		"stop_id": 8591999,
		"ID": 90,
		"x": -120.2962389847,
		"y": -30.687821294,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592001,
		"ID": 90,
		"x": -122.3372974207,
		"y": -29.732845317,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592004,
		"ID": 90,
		"x": -122.3412430777,
		"y": -30.074767775,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592005,
		"ID": 90,
		"x": -122.6322943747,
		"y": -30.739758499,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592009,
		"ID": 90,
		"x": -120.6802840827,
		"y": -30.460818654,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592010,
		"ID": 90,
		"x": -122.1872580477,
		"y": -29.767757917,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592011,
		"ID": 90,
		"x": -121.9972725317,
		"y": -29.74682801,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592012,
		"ID": 90,
		"x": -120.3172372577,
		"y": -30.783772661,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592020,
		"ID": 90,
		"x": -121.5632396557,
		"y": -30.677811325,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592021,
		"ID": 90,
		"x": -123.3242893977,
		"y": -30.009750091,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592022,
		"ID": 90,
		"x": -123.0812470077,
		"y": -29.586751716,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592023,
		"ID": 90,
		"x": -119.6052380777,
		"y": -29.920772162,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592024,
		"ID": 90,
		"x": -122.1242564787,
		"y": -30.994855716,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592026,
		"ID": 90,
		"x": -121.8352347257,
		"y": -31.0567696,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592027,
		"ID": 90,
		"x": -122.1512712437,
		"y": -30.750776304,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592028,
		"ID": 90,
		"x": -121.9532802517,
		"y": -31.056771714,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592029,
		"ID": 90,
		"x": -121.1192676227,
		"y": -31.520815519,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592036,
		"ID": 90,
		"x": -122.7752485397,
		"y": -29.690802217,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592038,
		"ID": 90,
		"x": -120.8862643817,
		"y": -30.58879664,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592039,
		"ID": 90,
		"x": -121.6242506757,
		"y": -31.191795451,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592040,
		"ID": 90,
		"x": -122.1342647607,
		"y": -30.62077114,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592041,
		"ID": 90,
		"x": -122.4982733067,
		"y": -29.782749805,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592042,
		"ID": 90,
		"x": -120.2782484197,
		"y": -29.686795544,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592043,
		"ID": 90,
		"x": -120.5702784737,
		"y": -30.874822806,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592044,
		"ID": 90,
		"x": -123.2812755747,
		"y": -30.506808932,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592045,
		"ID": 90,
		"x": -120.3642996507,
		"y": -30.503813939,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592046,
		"ID": 90,
		"x": -122.6532740957,
		"y": -30.529758229,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592050,
		"ID": 90,
		"x": -121.8222499027,
		"y": -30.438790916,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592051,
		"ID": 90,
		"x": -121.1732565537,
		"y": -30.419779846,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592052,
		"ID": 90,
		"x": -121.8862466317,
		"y": -30.734845892,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592061,
		"ID": 90,
		"x": -122.0022730557,
		"y": -31.288834914,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592062,
		"ID": 90,
		"x": -121.3002998817,
		"y": -30.984786245,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592064,
		"ID": 90,
		"x": -122.7862411837,
		"y": -30.39484773,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592072,
		"ID": 90,
		"x": -121.4292837987,
		"y": -30.517767125,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592074,
		"ID": 90,
		"x": -120.9442266907,
		"y": -30.311834953,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592075,
		"ID": 90,
		"x": -122.9372925327,
		"y": -30.498763013,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592077,
		"ID": 90,
		"x": -121.2652916487,
		"y": -31.163796932,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592079,
		"ID": 90,
		"x": -121.6632805257,
		"y": -30.785840443,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592080,
		"ID": 90,
		"x": -123.4402539777,
		"y": -30.343815822,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592083,
		"ID": 90,
		"x": -120.4822829247,
		"y": -30.536752083,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592084,
		"ID": 90,
		"x": -121.4082317337,
		"y": -31.330756458,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592086,
		"ID": 90,
		"x": -122.0662773417,
		"y": -31.561764332,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592090,
		"ID": 90,
		"x": -122.5672890147,
		"y": -31.297852317,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592093,
		"ID": 90,
		"x": -121.4832954347,
		"y": -29.873752768,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592095,
		"ID": 90,
		"x": -121.2482249937,
		"y": -30.088834274,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592096,
		"ID": 90,
		"x": -122.2202869907,
		"y": -29.807769827,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592097,
		"ID": 90,
		"x": -122.7082529857,
		"y": -30.268818642,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592098,
		"ID": 90,
		"x": -122.0132773567,
		"y": -29.928761,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592108,
		"ID": 90,
		"x": -121.5682740727,
		"y": -30.495772064,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592110,
		"ID": 90,
		"x": -122.8712867147,
		"y": -30.651761821,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592113,
		"ID": 90,
		"x": -121.6972550407,
		"y": -29.800845474,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592121,
		"ID": 90,
		"x": -123.2122604547,
		"y": -30.802810113,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592122,
		"ID": 90,
		"x": -122.4372995437,
		"y": -30.035856851,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592123,
		"ID": 90,
		"x": -120.6942888547,
		"y": -30.78985444,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592125,
		"ID": 90,
		"x": -121.6902717277,
		"y": -29.666844773,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592129,
		"ID": 90,
		"x": -120.2852605007,
		"y": -30.382767257,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592133,
		"ID": 90,
		"x": -122.2582328817,
		"y": -29.995810833,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592134,
		"ID": 90,
		"x": -122.2012382267,
		"y": -30.263770917,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592168,
		"ID": 90,
		"x": -118.6602635427,
		"y": -31.780772732,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592170,
		"ID": 90,
		"x": -120.5362286607,
		"y": -31.681824906,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592172,
		"ID": 90,
		"x": -120.4102809827,
		"y": -31.348806105,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592182,
		"ID": 90,
		"x": -120.0222258337,
		"y": -31.312800387,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592183,
		"ID": 90,
		"x": -119.7582925367,
		"y": -30.431854881,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592185,
		"ID": 90,
		"x": -119.4222952427,
		"y": -30.198851865,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592186,
		"ID": 90,
		"x": -120.9752339767,
		"y": -31.283822471,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592188,
		"ID": 90,
		"x": -119.6802648857,
		"y": -31.041850618,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592189,
		"ID": 90,
		"x": -118.7362503587,
		"y": -31.490761038,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592190,
		"ID": 90,
		"x": -119.9372557907,
		"y": -30.852848219,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592191,
		"ID": 90,
		"x": -119.5852686377,
		"y": -30.211794386,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592193,
		"ID": 90,
		"x": -120.7712634237,
		"y": -31.363828124,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592195,
		"ID": 90,
		"x": -119.0522720137,
		"y": -31.390820885,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592196,
		"ID": 90,
		"x": -119.7582782427,
		"y": -30.737797602,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592197,
		"ID": 90,
		"x": -120.8492674897,
		"y": -31.66775567,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592198,
		"ID": 90,
		"x": -120.2952922477,
		"y": -31.690816194,
		"h": 4.7252747253
	},
	{
		"stop_id": 8592199,
		"ID": 90,
		"x": -119.0832391197,
		"y": -31.619749455,
		"h": 4.7252747253
	},
	{
		"stop_id": 8593850,
		"ID": 90,
		"x": -118.9532506087,
		"y": -31.109756912,
		"h": 4.7252747253
	},
	{
		"stop_id": 8595192,
		"ID": 90,
		"x": -119.1522852257,
		"y": -30.994843002,
		"h": 4.7252747253
	},
	{
		"stop_id": 8501077,
		"ID": 165,
		"x": -100.4102968837,
		"y": -39.854819971,
		"h": 5.1208791209
	},
	{
		"stop_id": 8501201,
		"ID": 165,
		"x": -104.2342355177,
		"y": -37.503780111,
		"h": 5.1208791209
	},
	{
		"stop_id": 8501202,
		"ID": 165,
		"x": -102.8892727727,
		"y": -38.354789723,
		"h": 5.1208791209
	},
	{
		"stop_id": 8501203,
		"ID": 165,
		"x": -101.4592973367,
		"y": -38.936837872,
		"h": 5.1208791209
	},
	{
		"stop_id": 8501230,
		"ID": 165,
		"x": -99.2722821107,
		"y": -40.049835347,
		"h": 5.1208791209
	},
	{
		"stop_id": 8501264,
		"ID": 165,
		"x": -102.9122967987,
		"y": -35.782750256,
		"h": 5.1208791209
	},
	{
		"stop_id": 8501265,
		"ID": 165,
		"x": -102.4862961907,
		"y": -35.952768852,
		"h": 5.1208791209
	},
	{
		"stop_id": 8501266,
		"ID": 165,
		"x": -101.7482443517,
		"y": -36.087815569,
		"h": 5.1208791209
	},
	{
		"stop_id": 8501280,
		"ID": 165,
		"x": -103.2692888297,
		"y": -35.833759111,
		"h": 5.1208791209
	},
	{
		"stop_id": 8501281,
		"ID": 165,
		"x": -101.4282293297,
		"y": -36.384749396,
		"h": 5.1208791209
	},
	{
		"stop_id": 8501282,
		"ID": 165,
		"x": -101.2732753747,
		"y": -36.037755095,
		"h": 5.1208791209
	},
	{
		"stop_id": 8501283,
		"ID": 165,
		"x": -101.3982848967,
		"y": -35.477826508,
		"h": 5.1208791209
	},
	{
		"stop_id": 8501285,
		"ID": 165,
		"x": -100.5272923417,
		"y": -35.914797328,
		"h": 5.1208791209
	},
	{
		"stop_id": 8501286,
		"ID": 165,
		"x": -100.0392703317,
		"y": -35.563797045,
		"h": 5.1208791209
	},
	{
		"stop_id": 8501300,
		"ID": 165,
		"x": -100.3382789867,
		"y": -39.706786394,
		"h": 5.1208791209
	},
	{
		"stop_id": 8501306,
		"ID": 165,
		"x": -100.1732295557,
		"y": -37.712771027,
		"h": 5.1208791209
	},
	{
		"stop_id": 8501308,
		"ID": 165,
		"x": -99.1272910857,
		"y": -39.939841264,
		"h": 5.1208791209
	},
	{
		"stop_id": 8501312,
		"ID": 165,
		"x": -101.4442662607,
		"y": -39.262775142,
		"h": 5.1208791209
	},
	{
		"stop_id": 8501360,
		"ID": 165,
		"x": -99.7922875557,
		"y": -40.019826322,
		"h": 5.1208791209
	},
	{
		"stop_id": 8501370,
		"ID": 165,
		"x": -99.2422478177,
		"y": -40.169760141,
		"h": 5.1208791209
	},
	{
		"stop_id": 8501374,
		"ID": 165,
		"x": -100.9472772767,
		"y": -37.829801072,
		"h": 5.1208791209
	},
	{
		"stop_id": 8501375,
		"ID": 165,
		"x": -100.3572509197,
		"y": -38.589756097,
		"h": 5.1208791209
	},
	{
		"stop_id": 8501376,
		"ID": 165,
		"x": -100.0922596927,
		"y": -38.229800204,
		"h": 5.1208791209
	},
	{
		"stop_id": 8501380,
		"ID": 165,
		"x": -100.1622664957,
		"y": -39.682847897,
		"h": 5.1208791209
	},
	{
		"stop_id": 8501381,
		"ID": 165,
		"x": -100.2942714077,
		"y": -39.346788684,
		"h": 5.1208791209
	},
	{
		"stop_id": 8501382,
		"ID": 165,
		"x": -101.0432430217,
		"y": -38.489813179,
		"h": 5.1208791209
	},
	{
		"stop_id": 8501383,
		"ID": 165,
		"x": -101.0512567117,
		"y": -38.000841975,
		"h": 5.1208791209
	},
	{
		"stop_id": 8501384,
		"ID": 165,
		"x": -99.5073001477,
		"y": -39.359825147,
		"h": 5.1208791209
	},
	{
		"stop_id": 8501385,
		"ID": 165,
		"x": -98.8973000047,
		"y": -38.519843367,
		"h": 5.1208791209
	},
	{
		"stop_id": 8501390,
		"ID": 165,
		"x": -100.6642487297,
		"y": -39.019784042,
		"h": 5.1208791209
	},
	{
		"stop_id": 8530031,
		"ID": 165,
		"x": -99.3162727277,
		"y": -40.158823814,
		"h": 5.1208791209
	},
	{
		"stop_id": 8530261,
		"ID": 165,
		"x": -100.9932935687,
		"y": -35.54476341,
		"h": 5.1208791209
	},
	{
		"stop_id": 8570575,
		"ID": 165,
		"x": -99.0882260317,
		"y": -37.047849633,
		"h": 5.1208791209
	},
	{
		"stop_id": 8570576,
		"ID": 165,
		"x": -99.6482267047,
		"y": -37.44580739,
		"h": 5.1208791209
	},
	{
		"stop_id": 8570577,
		"ID": 165,
		"x": -100.0442587627,
		"y": -38.244796245,
		"h": 5.1208791209
	},
	{
		"stop_id": 8570578,
		"ID": 165,
		"x": -100.4742655317,
		"y": -37.72485759,
		"h": 5.1208791209
	},
	{
		"stop_id": 8570579,
		"ID": 165,
		"x": -100.3512413237,
		"y": -38.598801269,
		"h": 5.1208791209
	},
	{
		"stop_id": 8579196,
		"ID": 165,
		"x": -101.4622808077,
		"y": -39.211846496,
		"h": 5.1208791209
	},
	{
		"stop_id": 8579197,
		"ID": 165,
		"x": -101.6002482207,
		"y": -39.059810747,
		"h": 5.1208791209
	},
	{
		"stop_id": 8579198,
		"ID": 165,
		"x": -101.4102628337,
		"y": -38.902826919,
		"h": 5.1208791209
	},
	{
		"stop_id": 8579199,
		"ID": 165,
		"x": -101.4222744097,
		"y": -38.728765965,
		"h": 5.1208791209
	},
	{
		"stop_id": 8579200,
		"ID": 165,
		"x": -101.4762568567,
		"y": -38.556859558,
		"h": 5.1208791209
	},
	{
		"stop_id": 8579201,
		"ID": 165,
		"x": -101.6462769677,
		"y": -38.540780796,
		"h": 5.1208791209
	},
	{
		"stop_id": 8579202,
		"ID": 165,
		"x": -101.7522796217,
		"y": -38.347831918,
		"h": 5.1208791209
	},
	{
		"stop_id": 8579203,
		"ID": 165,
		"x": -101.8342443557,
		"y": -38.09179486,
		"h": 5.1208791209
	},
	{
		"stop_id": 8579204,
		"ID": 165,
		"x": -101.7422349837,
		"y": -37.789839057,
		"h": 5.1208791209
	},
	{
		"stop_id": 8579205,
		"ID": 165,
		"x": -101.2712955527,
		"y": -37.552764998,
		"h": 5.1208791209
	},
	{
		"stop_id": 8579206,
		"ID": 165,
		"x": -101.0742782647,
		"y": -37.571798198,
		"h": 5.1208791209
	},
	{
		"stop_id": 8579207,
		"ID": 165,
		"x": -100.9632657037,
		"y": -37.830803167,
		"h": 5.1208791209
	},
	{
		"stop_id": 8579208,
		"ID": 165,
		"x": -101.0422406527,
		"y": -37.202829871,
		"h": 5.1208791209
	},
	{
		"stop_id": 8579209,
		"ID": 165,
		"x": -101.3752305137,
		"y": -37.028778926,
		"h": 5.1208791209
	},
	{
		"stop_id": 8579210,
		"ID": 165,
		"x": -101.6852595957,
		"y": -36.86976616,
		"h": 5.1208791209
	},
	{
		"stop_id": 8579211,
		"ID": 165,
		"x": -101.5762780457,
		"y": -36.553807968,
		"h": 5.1208791209
	},
	{
		"stop_id": 8579213,
		"ID": 165,
		"x": -101.4442834127,
		"y": -36.395754849,
		"h": 5.1208791209
	},
	{
		"stop_id": 8583689,
		"ID": 165,
		"x": -100.5432483657,
		"y": -37.858791751,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593905,
		"ID": 165,
		"x": -102.1242974217,
		"y": -36.727838501,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593906,
		"ID": 165,
		"x": -101.8782305947,
		"y": -36.583826826,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593907,
		"ID": 165,
		"x": -101.9952528407,
		"y": -36.740752928,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593908,
		"ID": 165,
		"x": -101.9492327207,
		"y": -37.177855197,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593909,
		"ID": 165,
		"x": -102.3862591347,
		"y": -36.82581508,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593910,
		"ID": 165,
		"x": -102.2502930897,
		"y": -36.924828103,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593911,
		"ID": 165,
		"x": -102.5862366157,
		"y": -36.654750911,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593913,
		"ID": 165,
		"x": -101.7792818127,
		"y": -37.615824687,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593914,
		"ID": 165,
		"x": -102.0182566747,
		"y": -37.914858663,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593915,
		"ID": 165,
		"x": -102.2492668057,
		"y": -38.942756919,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593917,
		"ID": 165,
		"x": -101.9222652257,
		"y": -39.08379668,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593918,
		"ID": 165,
		"x": -101.2512546267,
		"y": -39.179845057,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593919,
		"ID": 165,
		"x": -102.6692589297,
		"y": -38.890748921,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593920,
		"ID": 165,
		"x": -100.1612793507,
		"y": -40.210789904,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593921,
		"ID": 165,
		"x": -100.1482490137,
		"y": -39.529752993,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593922,
		"ID": 165,
		"x": -100.4542750317,
		"y": -39.243766921,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593923,
		"ID": 165,
		"x": -99.9042632917,
		"y": -40.328792794,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593924,
		"ID": 165,
		"x": -100.1792502457,
		"y": -40.322837322,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593925,
		"ID": 165,
		"x": -100.5892690567,
		"y": -39.464853628,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593926,
		"ID": 165,
		"x": -100.3712412197,
		"y": -39.841854948,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593927,
		"ID": 165,
		"x": -99.8782673057,
		"y": -40.199789492,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593928,
		"ID": 165,
		"x": -100.4282784507,
		"y": -39.683833568,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593929,
		"ID": 165,
		"x": -100.3662961557,
		"y": -39.712822623,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593930,
		"ID": 165,
		"x": -99.9532231507,
		"y": -40.040763795,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593931,
		"ID": 165,
		"x": -100.2832626467,
		"y": -40.187846638,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593932,
		"ID": 165,
		"x": -99.8642811357,
		"y": -39.94675405,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593933,
		"ID": 165,
		"x": -99.8472835017,
		"y": -40.048808146,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593934,
		"ID": 165,
		"x": -100.1472417017,
		"y": -39.276853237,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593935,
		"ID": 165,
		"x": -100.3532861257,
		"y": -40.096772607,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593936,
		"ID": 165,
		"x": -99.7862717417,
		"y": -40.16683,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593938,
		"ID": 165,
		"x": -100.2282268367,
		"y": -39.673844357,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593939,
		"ID": 165,
		"x": -100.3532632677,
		"y": -39.421762364,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593940,
		"ID": 165,
		"x": -100.2922651327,
		"y": -40.006804931,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593941,
		"ID": 165,
		"x": -100.1132644637,
		"y": -40.042804473,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593942,
		"ID": 165,
		"x": -100.0052778817,
		"y": -39.905791527,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593943,
		"ID": 165,
		"x": -100.8342474817,
		"y": -39.2458519,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593944,
		"ID": 165,
		"x": -100.3422732357,
		"y": -39.569800801,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593945,
		"ID": 165,
		"x": -100.2702799287,
		"y": -39.344838211,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593946,
		"ID": 165,
		"x": -99.4532674867,
		"y": -40.604814678,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593951,
		"ID": 165,
		"x": -104.3082304247,
		"y": -37.929784883,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593952,
		"ID": 165,
		"x": -103.9632688697,
		"y": -37.620837924,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593953,
		"ID": 165,
		"x": -103.8442912027,
		"y": -37.14379945,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593954,
		"ID": 165,
		"x": -103.4792487277,
		"y": -37.338786681,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593955,
		"ID": 165,
		"x": -103.1312803657,
		"y": -38.348824231,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593957,
		"ID": 165,
		"x": -103.2122580457,
		"y": -37.007774117,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593958,
		"ID": 165,
		"x": -103.2292432647,
		"y": -37.31680992,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593959,
		"ID": 165,
		"x": -103.6492740937,
		"y": -37.570778482,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593960,
		"ID": 165,
		"x": -103.6822375847,
		"y": -37.686819645,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593961,
		"ID": 165,
		"x": -103.1322720477,
		"y": -37.92182036,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593962,
		"ID": 165,
		"x": -102.8752731947,
		"y": -37.977808028,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593963,
		"ID": 165,
		"x": -104.1582246977,
		"y": -38.155787989,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593964,
		"ID": 165,
		"x": -102.8232491077,
		"y": -38.534799459,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593965,
		"ID": 165,
		"x": -103.4982623127,
		"y": -38.040786525,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593966,
		"ID": 165,
		"x": -104.0602746247,
		"y": -37.13676424,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593968,
		"ID": 165,
		"x": -103.6912259917,
		"y": -36.908798849,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593969,
		"ID": 165,
		"x": -103.9393001757,
		"y": -38.070800773,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593970,
		"ID": 165,
		"x": -102.3832616387,
		"y": -37.919840951,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593971,
		"ID": 165,
		"x": -103.8783001247,
		"y": -37.307856572,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593972,
		"ID": 165,
		"x": -103.5252867847,
		"y": -38.248807809,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593973,
		"ID": 165,
		"x": -103.8672520177,
		"y": -37.707809758,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593975,
		"ID": 165,
		"x": -104.1672905377,
		"y": -37.82277211,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593976,
		"ID": 165,
		"x": -103.8992527427,
		"y": -38.204830308,
		"h": 5.1208791209
	},
	{
		"stop_id": 8593977,
		"ID": 165,
		"x": -103.5072294997,
		"y": -36.844774007,
		"h": 5.1208791209
	},
	{
		"stop_id": 8594160,
		"ID": 165,
		"x": -101.7462496457,
		"y": -39.178854215,
		"h": 5.1208791209
	},
	{
		"stop_id": 8595873,
		"ID": 165,
		"x": -100.3072805557,
		"y": -38.82576898,
		"h": 5.1208791209
	},
	{
		"stop_id": 8595874,
		"ID": 165,
		"x": -102.9442702367,
		"y": -35.678800676,
		"h": 5.1208791209
	},
	{
		"stop_id": 8595959,
		"ID": 165,
		"x": -103.3372401707,
		"y": -37.83284866,
		"h": 5.1208791209
	},
	{
		"stop_id": 8595960,
		"ID": 165,
		"x": -103.3462390917,
		"y": -37.632791915,
		"h": 5.1208791209
	},
	{
		"stop_id": 8595969,
		"ID": 165,
		"x": -102.6102978047,
		"y": -35.816816644,
		"h": 5.1208791209
	},
	{
		"stop_id": 8595970,
		"ID": 165,
		"x": -101.5702947507,
		"y": -37.769804461,
		"h": 5.1208791209
	},
	{
		"stop_id": 8595971,
		"ID": 165,
		"x": -101.1402355487,
		"y": -37.911851619,
		"h": 5.1208791209
	},
	{
		"stop_id": 8501078,
		"ID": 120,
		"x": -108.4112681117,
		"y": -44.369784797,
		"h": 1.032967033
	},
	{
		"stop_id": 8501428,
		"ID": 120,
		"x": -108.4122462197,
		"y": -44.528859371,
		"h": 1.032967033
	},
	{
		"stop_id": 8501079,
		"ID": 141,
		"x": -104.9102905997,
		"y": -45.054849231,
		"h": 1.1978021978
	},
	{
		"stop_id": 8501426,
		"ID": 141,
		"x": -104.7752896007,
		"y": -45.240844366,
		"h": 1.1978021978
	},
	{
		"stop_id": 8530739,
		"ID": 141,
		"x": -104.7342235557,
		"y": -45.41779766,
		"h": 1.1978021978
	},
	{
		"stop_id": 8577338,
		"ID": 141,
		"x": -106.8962428987,
		"y": -45.171803907,
		"h": 1.1978021978
	},
	{
		"stop_id": 8579183,
		"ID": 141,
		"x": -104.3462541077,
		"y": -45.209798032,
		"h": 1.1978021978
	},
	{
		"stop_id": 8581767,
		"ID": 141,
		"x": -105.3742313127,
		"y": -45.053796819,
		"h": 1.1978021978
	},
	{
		"stop_id": 8582428,
		"ID": 141,
		"x": -104.3672851767,
		"y": -45.64975699,
		"h": 1.1978021978
	},
	{
		"stop_id": 8501080,
		"ID": 58,
		"x": -134.6292585957,
		"y": -29.195788174,
		"h": 1.6923076923
	},
	{
		"stop_id": 8501081,
		"ID": 58,
		"x": -133.9032279507,
		"y": -30.477844595,
		"h": 1.6923076923
	},
	{
		"stop_id": 8501082,
		"ID": 58,
		"x": -136.9222346377,
		"y": -28.362761214,
		"h": 1.6923076923
	},
	{
		"stop_id": 8501083,
		"ID": 58,
		"x": -137.0362467347,
		"y": -27.724820299,
		"h": 1.6923076923
	},
	{
		"stop_id": 8501091,
		"ID": 58,
		"x": -133.8202802707,
		"y": -29.501760097,
		"h": 1.6923076923
	},
	{
		"stop_id": 8501092,
		"ID": 58,
		"x": -135.8632799717,
		"y": -29.256771427,
		"h": 1.6923076923
	},
	{
		"stop_id": 8501093,
		"ID": 58,
		"x": -137.3452832367,
		"y": -29.996806438,
		"h": 1.6923076923
	},
	{
		"stop_id": 8501277,
		"ID": 58,
		"x": -134.3482780047,
		"y": -31.725823326,
		"h": 1.6923076923
	},
	{
		"stop_id": 8501278,
		"ID": 58,
		"x": -135.2822623847,
		"y": -30.203858882,
		"h": 1.6923076923
	},
	{
		"stop_id": 8504654,
		"ID": 58,
		"x": -135.6882562517,
		"y": -31.759851734,
		"h": 1.6923076923
	},
	{
		"stop_id": 8504655,
		"ID": 58,
		"x": -133.3792667207,
		"y": -29.093835867,
		"h": 1.6923076923
	},
	{
		"stop_id": 8570074,
		"ID": 58,
		"x": -134.5552453757,
		"y": -28.298756646,
		"h": 1.6923076923
	},
	{
		"stop_id": 8570075,
		"ID": 58,
		"x": -135.2922564827,
		"y": -27.812819166,
		"h": 1.6923076923
	},
	{
		"stop_id": 8570076,
		"ID": 58,
		"x": -135.6002957927,
		"y": -27.073852343,
		"h": 1.6923076923
	},
	{
		"stop_id": 8570077,
		"ID": 58,
		"x": -135.8922581357,
		"y": -27.710857132,
		"h": 1.6923076923
	},
	{
		"stop_id": 8570078,
		"ID": 58,
		"x": -136.4232362937,
		"y": -27.641845818,
		"h": 1.6923076923
	},
	{
		"stop_id": 8570079,
		"ID": 58,
		"x": -136.8672654987,
		"y": -27.15877783,
		"h": 1.6923076923
	},
	{
		"stop_id": 8570085,
		"ID": 58,
		"x": -135.5422542867,
		"y": -30.469849703,
		"h": 1.6923076923
	},
	{
		"stop_id": 8570086,
		"ID": 58,
		"x": -137.2562340477,
		"y": -31.095805348,
		"h": 1.6923076923
	},
	{
		"stop_id": 8570087,
		"ID": 58,
		"x": -137.8422728367,
		"y": -31.065762839,
		"h": 1.6923076923
	},
	{
		"stop_id": 8592285,
		"ID": 58,
		"x": -134.0812524937,
		"y": -28.508755346,
		"h": 1.6923076923
	},
	{
		"stop_id": 8595221,
		"ID": 58,
		"x": -135.4542707047,
		"y": -31.777811524,
		"h": 1.6923076923
	},
	{
		"stop_id": 8501084,
		"ID": 59,
		"x": -136.9172831787,
		"y": -25.648826368,
		"h": 1.3956043956
	},
	{
		"stop_id": 8501087,
		"ID": 59,
		"x": -137.0682640517,
		"y": -22.777791871,
		"h": 1.3956043956
	},
	{
		"stop_id": 8501088,
		"ID": 59,
		"x": -138.2452487887,
		"y": -21.886787455,
		"h": 1.3956043956
	},
	{
		"stop_id": 8501094,
		"ID": 59,
		"x": -137.5882485997,
		"y": -26.555804339,
		"h": 1.3956043956
	},
	{
		"stop_id": 8501097,
		"ID": 59,
		"x": -136.8922998017,
		"y": -23.66278535,
		"h": 1.3956043956
	},
	{
		"stop_id": 8570080,
		"ID": 59,
		"x": -137.2602883387,
		"y": -26.407847142,
		"h": 1.3956043956
	},
	{
		"stop_id": 8570103,
		"ID": 59,
		"x": -134.9172877467,
		"y": -24.394797764,
		"h": 1.3956043956
	},
	{
		"stop_id": 8570104,
		"ID": 59,
		"x": -135.1922256427,
		"y": -24.119749973,
		"h": 1.3956043956
	},
	{
		"stop_id": 8570105,
		"ID": 59,
		"x": -135.1672817647,
		"y": -23.769752368,
		"h": 1.3956043956
	},
	{
		"stop_id": 8570106,
		"ID": 59,
		"x": -134.5672596657,
		"y": -22.344777182,
		"h": 1.3956043956
	},
	{
		"stop_id": 8570107,
		"ID": 59,
		"x": -134.3422487327,
		"y": -21.994821253,
		"h": 1.3956043956
	},
	{
		"stop_id": 8595647,
		"ID": 59,
		"x": -137.0672392547,
		"y": -26.264807501,
		"h": 1.3956043956
	},
	{
		"stop_id": 8595648,
		"ID": 59,
		"x": -137.5562244237,
		"y": -26.546769397,
		"h": 1.3956043956
	},
	{
		"stop_id": 8501085,
		"ID": 51,
		"x": -140.1472619007,
		"y": -26.657841868,
		"h": 1.1648351648
	},
	{
		"stop_id": 8501095,
		"ID": 51,
		"x": -141.3532492807,
		"y": -26.352855345,
		"h": 1.1648351648
	},
	{
		"stop_id": 8570115,
		"ID": 51,
		"x": -142.4922486147,
		"y": -24.094848359,
		"h": 1.1648351648
	},
	{
		"stop_id": 8570116,
		"ID": 51,
		"x": -143.0922911967,
		"y": -24.869787442,
		"h": 1.1648351648
	},
	{
		"stop_id": 8570117,
		"ID": 51,
		"x": -143.8922486967,
		"y": -25.369821886,
		"h": 1.1648351648
	},
	{
		"stop_id": 8570122,
		"ID": 51,
		"x": -142.6782369737,
		"y": -29.47776828,
		"h": 1.1648351648
	},
	{
		"stop_id": 8501089,
		"ID": 52,
		"x": -139.1282315937,
		"y": -19.911811482,
		"h": 1.2967032967
	},
	{
		"stop_id": 8501098,
		"ID": 52,
		"x": -139.8622858367,
		"y": -21.472859202,
		"h": 1.2967032967
	},
	{
		"stop_id": 8501734,
		"ID": 52,
		"x": -141.0922516267,
		"y": -20.994822507,
		"h": 1.2967032967
	},
	{
		"stop_id": 8570110,
		"ID": 52,
		"x": -138.8922646077,
		"y": -20.144840048,
		"h": 1.2967032967
	},
	{
		"stop_id": 8570111,
		"ID": 52,
		"x": -139.8672535967,
		"y": -21.494805701,
		"h": 1.2967032967
	},
	{
		"stop_id": 8570112,
		"ID": 52,
		"x": -141.3672486137,
		"y": -21.14484547,
		"h": 1.2967032967
	},
	{
		"stop_id": 8570113,
		"ID": 52,
		"x": -142.0922910337,
		"y": -23.269749064,
		"h": 1.2967032967
	},
	{
		"stop_id": 8570114,
		"ID": 52,
		"x": -142.1672400277,
		"y": -23.619815254,
		"h": 1.2967032967
	},
	{
		"stop_id": 8583297,
		"ID": 52,
		"x": -140.9982660997,
		"y": -21.246797897,
		"h": 1.2967032967
	},
	{
		"stop_id": 8595650,
		"ID": 52,
		"x": -140.9742384737,
		"y": -20.756836367,
		"h": 1.2967032967
	},
	{
		"stop_id": 8501096,
		"ID": 44,
		"x": -144.2552863037,
		"y": -27.959808705,
		"h": 1.3956043956
	},
	{
		"stop_id": 8501863,
		"ID": 44,
		"x": -146.4332848307,
		"y": -32.24778433,
		"h": 1.3956043956
	},
	{
		"stop_id": 8501872,
		"ID": 44,
		"x": -145.6882531237,
		"y": -31.076781949,
		"h": 1.3956043956
	},
	{
		"stop_id": 8570020,
		"ID": 44,
		"x": -148.4542928267,
		"y": -30.85582872,
		"h": 1.3956043956
	},
	{
		"stop_id": 8570021,
		"ID": 44,
		"x": -146.9722318687,
		"y": -31.198817241,
		"h": 1.3956043956
	},
	{
		"stop_id": 8570119,
		"ID": 44,
		"x": -144.2422624397,
		"y": -27.944760687,
		"h": 1.3956043956
	},
	{
		"stop_id": 8570120,
		"ID": 44,
		"x": -144.4682617217,
		"y": -28.476782244,
		"h": 1.3956043956
	},
	{
		"stop_id": 8570121,
		"ID": 44,
		"x": -143.5282738967,
		"y": -28.899757607,
		"h": 1.3956043956
	},
	{
		"stop_id": 8570124,
		"ID": 44,
		"x": -143.6922475037,
		"y": -30.069823341,
		"h": 1.3956043956
	},
	{
		"stop_id": 8570125,
		"ID": 44,
		"x": -144.8082365847,
		"y": -30.55876378,
		"h": 1.3956043956
	},
	{
		"stop_id": 8570127,
		"ID": 44,
		"x": -146.2402708407,
		"y": -31.185823162,
		"h": 1.3956043956
	},
	{
		"stop_id": 8579086,
		"ID": 44,
		"x": -146.5792743177,
		"y": -30.974814165,
		"h": 1.3956043956
	},
	{
		"stop_id": 8579840,
		"ID": 44,
		"x": -147.5172815437,
		"y": -31.169760811,
		"h": 1.3956043956
	},
	{
		"stop_id": 8501099,
		"ID": 60,
		"x": -138.4422882157,
		"y": -19.163852481,
		"h": 1.2637362637
	},
	{
		"stop_id": 8570135,
		"ID": 60,
		"x": -134.8172343707,
		"y": -20.319833779,
		"h": 1.2637362637
	},
	{
		"stop_id": 8570136,
		"ID": 60,
		"x": -135.4672782747,
		"y": -20.119777789,
		"h": 1.2637362637
	},
	{
		"stop_id": 8570137,
		"ID": 60,
		"x": -136.3572862087,
		"y": -18.393825407,
		"h": 1.2637362637
	},
	{
		"stop_id": 8570138,
		"ID": 60,
		"x": -136.7922878417,
		"y": -18.269852125,
		"h": 1.2637362637
	},
	{
		"stop_id": 8570147,
		"ID": 60,
		"x": -135.1672913947,
		"y": -15.719803608,
		"h": 1.2637362637
	},
	{
		"stop_id": 8570157,
		"ID": 60,
		"x": -138.9472305717,
		"y": -16.996838189,
		"h": 1.2637362637
	},
	{
		"stop_id": 8595649,
		"ID": 60,
		"x": -138.4282316047,
		"y": -19.166816243,
		"h": 1.2637362637
	},
	{
		"stop_id": 8595661,
		"ID": 60,
		"x": -138.2462488897,
		"y": -18.829781019,
		"h": 1.2637362637
	},
	{
		"stop_id": 8501100,
		"ID": 47,
		"x": -144.9882941887,
		"y": -13.357778905,
		"h": 1.1978021978
	},
	{
		"stop_id": 8501151,
		"ID": 47,
		"x": -145.5742874267,
		"y": -13.836820866,
		"h": 1.1978021978
	},
	{
		"stop_id": 8501152,
		"ID": 47,
		"x": -146.4312606817,
		"y": -14.473769964,
		"h": 1.1978021978
	},
	{
		"stop_id": 8530621,
		"ID": 47,
		"x": -144.9592962717,
		"y": -13.476817923,
		"h": 1.1978021978
	},
	{
		"stop_id": 8570161,
		"ID": 47,
		"x": -144.9812401647,
		"y": -13.383783645,
		"h": 1.1978021978
	},
	{
		"stop_id": 8579136,
		"ID": 47,
		"x": -144.5032844947,
		"y": -13.76278389,
		"h": 1.1978021978
	},
	{
		"stop_id": 8593532,
		"ID": 47,
		"x": -144.7142939157,
		"y": -14.053750435,
		"h": 1.1978021978
	},
	{
		"stop_id": 8501103,
		"ID": 54,
		"x": -141.4092714367,
		"y": -8.546833856,
		"h": 1.4945054945
	},
	{
		"stop_id": 8501104,
		"ID": 54,
		"x": -139.1122524367,
		"y": -8.034838237,
		"h": 1.4945054945
	},
	{
		"stop_id": 8504569,
		"ID": 54,
		"x": -140.0422907087,
		"y": -6.569798884,
		"h": 1.4945054945
	},
	{
		"stop_id": 8570230,
		"ID": 54,
		"x": -139.1862752767,
		"y": -10.739787371,
		"h": 1.4945054945
	},
	{
		"stop_id": 8570231,
		"ID": 54,
		"x": -139.8112558767,
		"y": -10.984839436,
		"h": 1.4945054945
	},
	{
		"stop_id": 8570232,
		"ID": 54,
		"x": -140.1892261907,
		"y": -11.569791734,
		"h": 1.4945054945
	},
	{
		"stop_id": 8579088,
		"ID": 54,
		"x": -140.7282966327,
		"y": -8.665812504,
		"h": 1.4945054945
	},
	{
		"stop_id": 8579090,
		"ID": 54,
		"x": -140.0612814387,
		"y": -8.099786783,
		"h": 1.4945054945
	},
	{
		"stop_id": 8579091,
		"ID": 54,
		"x": -139.7332276327,
		"y": -7.468800741,
		"h": 1.4945054945
	},
	{
		"stop_id": 8579092,
		"ID": 54,
		"x": -139.7072599567,
		"y": -7.035779247,
		"h": 1.4945054945
	},
	{
		"stop_id": 8579293,
		"ID": 54,
		"x": -141.4022437387,
		"y": -8.569832217,
		"h": 1.4945054945
	},
	{
		"stop_id": 8579909,
		"ID": 54,
		"x": -140.0022811467,
		"y": -6.584788396,
		"h": 1.4945054945
	},
	{
		"stop_id": 8579910,
		"ID": 54,
		"x": -140.5322707347,
		"y": -8.459780368,
		"h": 1.4945054945
	},
	{
		"stop_id": 8579911,
		"ID": 54,
		"x": -140.7222356797,
		"y": -8.409853348,
		"h": 1.4945054945
	},
	{
		"stop_id": 8579912,
		"ID": 54,
		"x": -140.9852816487,
		"y": -8.617750053,
		"h": 1.4945054945
	},
	{
		"stop_id": 8580862,
		"ID": 54,
		"x": -140.0132714737,
		"y": -11.23984413,
		"h": 1.4945054945
	},
	{
		"stop_id": 8501105,
		"ID": 72,
		"x": -133.4412525607,
		"y": -8.355792948,
		"h": 1.5274725275
	},
	{
		"stop_id": 8501106,
		"ID": 72,
		"x": -133.2072272257,
		"y": -10.397846503,
		"h": 1.5274725275
	},
	{
		"stop_id": 8501107,
		"ID": 72,
		"x": -130.0862411037,
		"y": -10.283777682,
		"h": 1.5274725275
	},
	{
		"stop_id": 8507650,
		"ID": 72,
		"x": -130.6352889997,
		"y": -7.925846778,
		"h": 1.5274725275
	},
	{
		"stop_id": 8530262,
		"ID": 72,
		"x": -129.0122534107,
		"y": -7.824774431,
		"h": 1.5274725275
	},
	{
		"stop_id": 8570148,
		"ID": 72,
		"x": -133.2322363637,
		"y": -10.403765563,
		"h": 1.5274725275
	},
	{
		"stop_id": 8570224,
		"ID": 72,
		"x": -133.6652791227,
		"y": -10.671817596,
		"h": 1.5274725275
	},
	{
		"stop_id": 8570233,
		"ID": 72,
		"x": -133.0243004977,
		"y": -10.388858349,
		"h": 1.5274725275
	},
	{
		"stop_id": 8570234,
		"ID": 72,
		"x": -131.6422948397,
		"y": -9.494749051,
		"h": 1.5274725275
	},
	{
		"stop_id": 8570235,
		"ID": 72,
		"x": -130.9122540787,
		"y": -8.294775018,
		"h": 1.5274725275
	},
	{
		"stop_id": 8570236,
		"ID": 72,
		"x": -129.6662317437,
		"y": -7.83384912,
		"h": 1.5274725275
	},
	{
		"stop_id": 8576379,
		"ID": 72,
		"x": -130.0772231277,
		"y": -10.642754972,
		"h": 1.5274725275
	},
	{
		"stop_id": 8577281,
		"ID": 72,
		"x": -130.4002522277,
		"y": -6.649779553,
		"h": 1.5274725275
	},
	{
		"stop_id": 8579106,
		"ID": 72,
		"x": -130.0592811917,
		"y": -10.280758984,
		"h": 1.5274725275
	},
	{
		"stop_id": 8579108,
		"ID": 72,
		"x": -129.2902957767,
		"y": -7.959852571,
		"h": 1.5274725275
	},
	{
		"stop_id": 8583451,
		"ID": 72,
		"x": -131.5572413667,
		"y": -9.640852771,
		"h": 1.5274725275
	},
	{
		"stop_id": 8595056,
		"ID": 72,
		"x": -129.3192676017,
		"y": -8.169858378,
		"h": 1.5274725275
	},
	{
		"stop_id": 8501108,
		"ID": 71,
		"x": -130.2552404207,
		"y": -14.64983196,
		"h": 1.4615384615
	},
	{
		"stop_id": 8501894,
		"ID": 71,
		"x": -131.2612588377,
		"y": -13.704826836,
		"h": 1.4615384615
	},
	{
		"stop_id": 8504651,
		"ID": 71,
		"x": -132.7332785537,
		"y": -14.694769393,
		"h": 1.4615384615
	},
	{
		"stop_id": 8504659,
		"ID": 71,
		"x": -129.5562758947,
		"y": -15.383756939,
		"h": 1.4615384615
	},
	{
		"stop_id": 8570140,
		"ID": 71,
		"x": -128.6612623797,
		"y": -15.615793156,
		"h": 1.4615384615
	},
	{
		"stop_id": 8570141,
		"ID": 71,
		"x": -129.2452538877,
		"y": -15.662859619,
		"h": 1.4615384615
	},
	{
		"stop_id": 8570142,
		"ID": 71,
		"x": -130.2642257297,
		"y": -14.658842542,
		"h": 1.4615384615
	},
	{
		"stop_id": 8570144,
		"ID": 71,
		"x": -130.5472625677,
		"y": -14.649836208,
		"h": 1.4615384615
	},
	{
		"stop_id": 8570145,
		"ID": 71,
		"x": -131.0422342587,
		"y": -14.619844537,
		"h": 1.4615384615
	},
	{
		"stop_id": 8570146,
		"ID": 71,
		"x": -132.0172968287,
		"y": -14.89477573,
		"h": 1.4615384615
	},
	{
		"stop_id": 8570162,
		"ID": 71,
		"x": -130.6872582097,
		"y": -13.853840615,
		"h": 1.4615384615
	},
	{
		"stop_id": 8583402,
		"ID": 71,
		"x": -129.3052680257,
		"y": -17.186801258,
		"h": 1.4615384615
	},
	{
		"stop_id": 8583403,
		"ID": 71,
		"x": -129.6962627857,
		"y": -17.789817927,
		"h": 1.4615384615
	},
	{
		"stop_id": 8595610,
		"ID": 71,
		"x": -133.2532613427,
		"y": -16.436749792,
		"h": 1.4615384615
	},
	{
		"stop_id": 8595611,
		"ID": 71,
		"x": -131.9142848377,
		"y": -17.294826954,
		"h": 1.4615384615
	},
	{
		"stop_id": 8501110,
		"ID": 95,
		"x": -123.2412410617,
		"y": -4.985796445,
		"h": 3.1758241758
	},
	{
		"stop_id": 8504200,
		"ID": 95,
		"x": -120.6422794377,
		"y": -1.069821551,
		"h": 3.1758241758
	},
	{
		"stop_id": 8504774,
		"ID": 95,
		"x": -120.7122453657,
		"y": -1.14581847,
		"h": 3.1758241758
	},
	{
		"stop_id": 8507652,
		"ID": 95,
		"x": -120.8362254957,
		"y": -4.192820472,
		"h": 3.1758241758
	},
	{
		"stop_id": 8507653,
		"ID": 95,
		"x": -121.8142588037,
		"y": -5.141847521,
		"h": 3.1758241758
	},
	{
		"stop_id": 8507659,
		"ID": 95,
		"x": -119.7612986247,
		"y": -2.479847632,
		"h": 3.1758241758
	},
	{
		"stop_id": 8507675,
		"ID": 95,
		"x": -120.7282616807,
		"y": -5.887757385,
		"h": 3.1758241758
	},
	{
		"stop_id": 8507685,
		"ID": 95,
		"x": -121.1372712657,
		"y": -4.772843282,
		"h": 3.1758241758
	},
	{
		"stop_id": 8507953,
		"ID": 95,
		"x": -118.5852877287,
		"y": -3.486754303,
		"h": 3.1758241758
	},
	{
		"stop_id": 8507964,
		"ID": 95,
		"x": -123.0692580987,
		"y": -1.91477304,
		"h": 3.1758241758
	},
	{
		"stop_id": 8507967,
		"ID": 95,
		"x": -119.5782653307,
		"y": -5.022766776,
		"h": 3.1758241758
	},
	{
		"stop_id": 8570239,
		"ID": 95,
		"x": -121.2312278887,
		"y": -1.060793035,
		"h": 3.1758241758
	},
	{
		"stop_id": 8570240,
		"ID": 95,
		"x": -121.6052262477,
		"y": -1.342763772,
		"h": 3.1758241758
	},
	{
		"stop_id": 8570288,
		"ID": 95,
		"x": -120.1082394447,
		"y": -1.7748516,
		"h": 3.1758241758
	},
	{
		"stop_id": 8570289,
		"ID": 95,
		"x": -120.0102570757,
		"y": -2.139821748,
		"h": 3.1758241758
	},
	{
		"stop_id": 8570290,
		"ID": 95,
		"x": -119.9122487717,
		"y": -2.852762925,
		"h": 3.1758241758
	},
	{
		"stop_id": 8570291,
		"ID": 95,
		"x": -122.1732922797,
		"y": -5.676859247,
		"h": 3.1758241758
	},
	{
		"stop_id": 8570302,
		"ID": 95,
		"x": -119.5422997007,
		"y": -3.022788053,
		"h": 3.1758241758
	},
	{
		"stop_id": 8570303,
		"ID": 95,
		"x": -119.6902955917,
		"y": -3.489790805,
		"h": 3.1758241758
	},
	{
		"stop_id": 8570308,
		"ID": 95,
		"x": -118.3942467747,
		"y": -3.661837931,
		"h": 3.1758241758
	},
	{
		"stop_id": 8575840,
		"ID": 95,
		"x": -120.9702861457,
		"y": -1.03979044,
		"h": 3.1758241758
	},
	{
		"stop_id": 8579289,
		"ID": 95,
		"x": -119.5922508237,
		"y": -1.479758106,
		"h": 3.1758241758
	},
	{
		"stop_id": 8579294,
		"ID": 95,
		"x": -120.9632650657,
		"y": -1.211848124,
		"h": 3.1758241758
	},
	{
		"stop_id": 8579295,
		"ID": 95,
		"x": -121.3122303627,
		"y": -1.510769355,
		"h": 3.1758241758
	},
	{
		"stop_id": 8579296,
		"ID": 95,
		"x": -121.3022979917,
		"y": -1.339775151,
		"h": 3.1758241758
	},
	{
		"stop_id": 8579298,
		"ID": 95,
		"x": -122.4592589707,
		"y": -1.446821223,
		"h": 3.1758241758
	},
	{
		"stop_id": 8579299,
		"ID": 95,
		"x": -122.9882414257,
		"y": -1.584776267,
		"h": 3.1758241758
	},
	{
		"stop_id": 8579303,
		"ID": 95,
		"x": -123.3112279247,
		"y": -1.39680289,
		"h": 3.1758241758
	},
	{
		"stop_id": 8579760,
		"ID": 95,
		"x": -120.3182250257,
		"y": -3.428768144,
		"h": 3.1758241758
	},
	{
		"stop_id": 8580576,
		"ID": 95,
		"x": -120.7212955537,
		"y": -4.551748654,
		"h": 3.1758241758
	},
	{
		"stop_id": 8582051,
		"ID": 95,
		"x": -119.8212974757,
		"y": -1.532825839,
		"h": 3.1758241758
	},
	{
		"stop_id": 8594016,
		"ID": 95,
		"x": -121.5062516647,
		"y": -0.958791722,
		"h": 3.1758241758
	},
	{
		"stop_id": 8594017,
		"ID": 95,
		"x": -121.2032991677,
		"y": -1.954805947,
		"h": 3.1758241758
	},
	{
		"stop_id": 8594018,
		"ID": 95,
		"x": -120.1592880277,
		"y": -2.238818981,
		"h": 3.1758241758
	},
	{
		"stop_id": 8594019,
		"ID": 95,
		"x": -121.5612578887,
		"y": -1.684855586,
		"h": 3.1758241758
	},
	{
		"stop_id": 8594021,
		"ID": 95,
		"x": -120.2882978717,
		"y": -1.63484272,
		"h": 3.1758241758
	},
	{
		"stop_id": 8594024,
		"ID": 95,
		"x": -121.0272468087,
		"y": -1.731819329,
		"h": 3.1758241758
	},
	{
		"stop_id": 8594025,
		"ID": 95,
		"x": -119.4832260817,
		"y": -2.71476134,
		"h": 3.1758241758
	},
	{
		"stop_id": 8594026,
		"ID": 95,
		"x": -121.3412544217,
		"y": -2.007750653,
		"h": 3.1758241758
	},
	{
		"stop_id": 8594027,
		"ID": 95,
		"x": -120.3632784987,
		"y": -2.800849112,
		"h": 3.1758241758
	},
	{
		"stop_id": 8594028,
		"ID": 95,
		"x": -120.6332693007,
		"y": -2.547855256,
		"h": 3.1758241758
	},
	{
		"stop_id": 8594029,
		"ID": 95,
		"x": -121.8112663917,
		"y": -1.127842021,
		"h": 3.1758241758
	},
	{
		"stop_id": 8594030,
		"ID": 95,
		"x": -121.0782978257,
		"y": -1.034792469,
		"h": 3.1758241758
	},
	{
		"stop_id": 8594031,
		"ID": 95,
		"x": -120.5712929067,
		"y": -1.37382583,
		"h": 3.1758241758
	},
	{
		"stop_id": 8594039,
		"ID": 95,
		"x": -120.7902651817,
		"y": -2.399839409,
		"h": 3.1758241758
	},
	{
		"stop_id": 8594040,
		"ID": 95,
		"x": -120.2192247787,
		"y": -2.092798317,
		"h": 3.1758241758
	},
	{
		"stop_id": 8594041,
		"ID": 95,
		"x": -119.3432948417,
		"y": -2.087805825,
		"h": 3.1758241758
	},
	{
		"stop_id": 8594043,
		"ID": 95,
		"x": -120.5252772817,
		"y": -1.527824494,
		"h": 3.1758241758
	},
	{
		"stop_id": 8594044,
		"ID": 95,
		"x": -120.4412754737,
		"y": -2.484770185,
		"h": 3.1758241758
	},
	{
		"stop_id": 8594046,
		"ID": 95,
		"x": -120.4682300797,
		"y": -2.167763248,
		"h": 3.1758241758
	},
	{
		"stop_id": 8594049,
		"ID": 95,
		"x": -121.4692463967,
		"y": -2.086809689,
		"h": 3.1758241758
	},
	{
		"stop_id": 8594050,
		"ID": 95,
		"x": -119.5852894297,
		"y": -2.600789012,
		"h": 3.1758241758
	},
	{
		"stop_id": 8594052,
		"ID": 95,
		"x": -119.5622321807,
		"y": -2.143763707,
		"h": 3.1758241758
	},
	{
		"stop_id": 8594054,
		"ID": 95,
		"x": -120.5402315867,
		"y": -1.826840662,
		"h": 3.1758241758
	},
	{
		"stop_id": 8594055,
		"ID": 95,
		"x": -120.0022333187,
		"y": -2.404828887,
		"h": 3.1758241758
	},
	{
		"stop_id": 8594056,
		"ID": 95,
		"x": -120.0492701517,
		"y": -1.463827138,
		"h": 3.1758241758
	},
	{
		"stop_id": 8594061,
		"ID": 95,
		"x": -121.9832339527,
		"y": -0.861794156,
		"h": 3.1758241758
	},
	{
		"stop_id": 8594062,
		"ID": 95,
		"x": -120.4522374887,
		"y": -1.329787966,
		"h": 3.1758241758
	},
	{
		"stop_id": 8594159,
		"ID": 95,
		"x": -121.2062746727,
		"y": -0.839813652,
		"h": 3.1758241758
	},
	{
		"stop_id": 8595065,
		"ID": 95,
		"x": -120.5582735877,
		"y": -2.947842204,
		"h": 3.1758241758
	},
	{
		"stop_id": 8595066,
		"ID": 95,
		"x": -120.6072745237,
		"y": -3.626835779,
		"h": 3.1758241758
	},
	{
		"stop_id": 8595067,
		"ID": 95,
		"x": -121.0452871367,
		"y": -0.749858991,
		"h": 3.1758241758
	},
	{
		"stop_id": 8595068,
		"ID": 95,
		"x": -121.3062985177,
		"y": -1.364859246,
		"h": 3.1758241758
	},
	{
		"stop_id": 8595069,
		"ID": 95,
		"x": -121.1382731177,
		"y": -1.520784599,
		"h": 3.1758241758
	},
	{
		"stop_id": 8595070,
		"ID": 95,
		"x": -120.6982519517,
		"y": -2.050803436,
		"h": 3.1758241758
	},
	{
		"stop_id": 8595161,
		"ID": 95,
		"x": -120.3172788097,
		"y": -3.244785811,
		"h": 3.1758241758
	},
	{
		"stop_id": 8595656,
		"ID": 95,
		"x": -123.3332300267,
		"y": -1.569778336,
		"h": 3.1758241758
	},
	{
		"stop_id": 8501111,
		"ID": 83,
		"x": -125.3272687047,
		"y": -7.047810989,
		"h": 1.8571428571
	},
	{
		"stop_id": 8501112,
		"ID": 83,
		"x": -126.3042403767,
		"y": -8.991800471,
		"h": 1.8571428571
	},
	{
		"stop_id": 8501191,
		"ID": 83,
		"x": -129.1952696977,
		"y": -7.367838849,
		"h": 1.8571428571
	},
	{
		"stop_id": 8501194,
		"ID": 83,
		"x": -128.3302550027,
		"y": -7.758805799,
		"h": 1.8571428571
	},
	{
		"stop_id": 8501267,
		"ID": 83,
		"x": -129.1342533127,
		"y": -7.406790433,
		"h": 1.8571428571
	},
	{
		"stop_id": 8570200,
		"ID": 83,
		"x": -126.3172736827,
		"y": -8.994768461,
		"h": 1.8571428571
	},
	{
		"stop_id": 8570237,
		"ID": 83,
		"x": -129.1072802997,
		"y": -7.559856948,
		"h": 1.8571428571
	},
	{
		"stop_id": 8570246,
		"ID": 83,
		"x": -129.1712843187,
		"y": -5.787767897,
		"h": 1.8571428571
	},
	{
		"stop_id": 8570247,
		"ID": 83,
		"x": -129.0622449387,
		"y": -6.509777795,
		"h": 1.8571428571
	},
	{
		"stop_id": 8570248,
		"ID": 83,
		"x": -129.0172734427,
		"y": -6.857830532,
		"h": 1.8571428571
	},
	{
		"stop_id": 8577202,
		"ID": 83,
		"x": -129.3062481047,
		"y": -6.71384358,
		"h": 1.8571428571
	},
	{
		"stop_id": 8579733,
		"ID": 83,
		"x": -123.7772576547,
		"y": -7.393776766,
		"h": 1.8571428571
	},
	{
		"stop_id": 8579734,
		"ID": 83,
		"x": -123.9432980107,
		"y": -7.620793668,
		"h": 1.8571428571
	},
	{
		"stop_id": 8581116,
		"ID": 83,
		"x": -129.1772362957,
		"y": -7.381833675,
		"h": 1.8571428571
	},
	{
		"stop_id": 8581953,
		"ID": 83,
		"x": -129.5002386207,
		"y": -6.724816046,
		"h": 1.8571428571
	},
	{
		"stop_id": 8595054,
		"ID": 83,
		"x": -129.0322636127,
		"y": -7.069778345,
		"h": 1.8571428571
	},
	{
		"stop_id": 8595055,
		"ID": 83,
		"x": -128.9772338447,
		"y": -7.004821942,
		"h": 1.8571428571
	},
	{
		"stop_id": 8595057,
		"ID": 83,
		"x": -129.1322702617,
		"y": -6.694850677,
		"h": 1.8571428571
	},
	{
		"stop_id": 8595060,
		"ID": 83,
		"x": -128.8672246847,
		"y": -7.004759057,
		"h": 1.8571428571
	},
	{
		"stop_id": 8595061,
		"ID": 83,
		"x": -129.4622390877,
		"y": -6.579842064,
		"h": 1.8571428571
	},
	{
		"stop_id": 8595062,
		"ID": 83,
		"x": -129.1872846427,
		"y": -6.224832859,
		"h": 1.8571428571
	},
	{
		"stop_id": 8595063,
		"ID": 83,
		"x": -128.8372461087,
		"y": -7.374760722,
		"h": 1.8571428571
	},
	{
		"stop_id": 8595249,
		"ID": 83,
		"x": -129.3922502187,
		"y": -6.319840657,
		"h": 1.8571428571
	},
	{
		"stop_id": 8595408,
		"ID": 83,
		"x": -128.4492408047,
		"y": -7.100844961,
		"h": 1.8571428571
	},
	{
		"stop_id": 8595409,
		"ID": 83,
		"x": -128.7832794367,
		"y": -7.746817503,
		"h": 1.8571428571
	},
	{
		"stop_id": 8595410,
		"ID": 83,
		"x": -128.5332539667,
		"y": -7.652751145,
		"h": 1.8571428571
	},
	{
		"stop_id": 8595482,
		"ID": 83,
		"x": -128.3152533947,
		"y": -7.770762119,
		"h": 1.8571428571
	},
	{
		"stop_id": 8501113,
		"ID": 82,
		"x": -127.0072943527,
		"y": -11.474796266,
		"h": 1.1318681319
	},
	{
		"stop_id": 8501114,
		"ID": 82,
		"x": -127.5742968877,
		"y": -14.857757219,
		"h": 1.1318681319
	},
	{
		"stop_id": 8570139,
		"ID": 82,
		"x": -127.5922685917,
		"y": -14.869782922,
		"h": 1.1318681319
	},
	{
		"stop_id": 8570192,
		"ID": 82,
		"x": -123.6212587107,
		"y": -12.165777509,
		"h": 1.1318681319
	},
	{
		"stop_id": 8570194,
		"ID": 82,
		"x": -123.4672268097,
		"y": -11.68981846,
		"h": 1.1318681319
	},
	{
		"stop_id": 8501115,
		"ID": 70,
		"x": -129.8402235327,
		"y": -20.521787313,
		"h": 1.4945054945
	},
	{
		"stop_id": 8501299,
		"ID": 70,
		"x": -128.6672531307,
		"y": -21.269786882,
		"h": 1.4945054945
	},
	{
		"stop_id": 8570094,
		"ID": 70,
		"x": -130.9672661157,
		"y": -22.719761161,
		"h": 1.4945054945
	},
	{
		"stop_id": 8570095,
		"ID": 70,
		"x": -130.9172938467,
		"y": -21.194827992,
		"h": 1.4945054945
	},
	{
		"stop_id": 8570096,
		"ID": 70,
		"x": -131.0672945447,
		"y": -20.069857564,
		"h": 1.4945054945
	},
	{
		"stop_id": 8570108,
		"ID": 70,
		"x": -132.6422388287,
		"y": -21.094854564,
		"h": 1.4945054945
	},
	{
		"stop_id": 8570109,
		"ID": 70,
		"x": -131.0172817247,
		"y": -19.819754749,
		"h": 1.4945054945
	},
	{
		"stop_id": 8570129,
		"ID": 70,
		"x": -129.8472418287,
		"y": -20.538826052,
		"h": 1.4945054945
	},
	{
		"stop_id": 8570130,
		"ID": 70,
		"x": -129.7012644207,
		"y": -20.10383997,
		"h": 1.4945054945
	},
	{
		"stop_id": 8570131,
		"ID": 70,
		"x": -129.5172273357,
		"y": -19.694751976,
		"h": 1.4945054945
	},
	{
		"stop_id": 8570132,
		"ID": 70,
		"x": -129.2732586287,
		"y": -20.95384492,
		"h": 1.4945054945
	},
	{
		"stop_id": 8570133,
		"ID": 70,
		"x": -133.5172846497,
		"y": -19.569854155,
		"h": 1.4945054945
	},
	{
		"stop_id": 8570134,
		"ID": 70,
		"x": -133.7672508807,
		"y": -19.444816764,
		"h": 1.4945054945
	},
	{
		"stop_id": 8581114,
		"ID": 70,
		"x": -129.4412874347,
		"y": -20.708759157,
		"h": 1.4945054945
	},
	{
		"stop_id": 8582737,
		"ID": 70,
		"x": -131.5142482827,
		"y": -20.061859549,
		"h": 1.4945054945
	},
	{
		"stop_id": 8583378,
		"ID": 70,
		"x": -131.0772716077,
		"y": -20.470854336,
		"h": 1.4945054945
	},
	{
		"stop_id": 8501116,
		"ID": 80,
		"x": -129.3362562977,
		"y": -23.836840406,
		"h": 2.1208791209
	},
	{
		"stop_id": 8501168,
		"ID": 80,
		"x": -123.6672461057,
		"y": -24.489761521,
		"h": 2.1208791209
	},
	{
		"stop_id": 8501169,
		"ID": 80,
		"x": -123.5622374967,
		"y": -22.999838607,
		"h": 2.1208791209
	},
	{
		"stop_id": 8501170,
		"ID": 80,
		"x": -123.6022817457,
		"y": -23.629758653,
		"h": 2.1208791209
	},
	{
		"stop_id": 8570063,
		"ID": 80,
		"x": -123.6282288337,
		"y": -23.01381129,
		"h": 2.1208791209
	},
	{
		"stop_id": 8570064,
		"ID": 80,
		"x": -123.7172289677,
		"y": -22.71981346,
		"h": 2.1208791209
	},
	{
		"stop_id": 8570067,
		"ID": 80,
		"x": -126.7932687867,
		"y": -21.117811226,
		"h": 2.1208791209
	},
	{
		"stop_id": 8570068,
		"ID": 80,
		"x": -126.6192656397,
		"y": -21.930758993,
		"h": 2.1208791209
	},
	{
		"stop_id": 8577645,
		"ID": 80,
		"x": -124.2452962817,
		"y": -23.294814281,
		"h": 2.1208791209
	},
	{
		"stop_id": 8581344,
		"ID": 80,
		"x": -125.2472371907,
		"y": -20.927773134,
		"h": 2.1208791209
	},
	{
		"stop_id": 8581916,
		"ID": 80,
		"x": -127.0672716327,
		"y": -26.167769527,
		"h": 2.1208791209
	},
	{
		"stop_id": 8581917,
		"ID": 80,
		"x": -127.7812808327,
		"y": -26.51380818,
		"h": 2.1208791209
	},
	{
		"stop_id": 8581919,
		"ID": 80,
		"x": -127.8492475957,
		"y": -26.264788993,
		"h": 2.1208791209
	},
	{
		"stop_id": 8581920,
		"ID": 80,
		"x": -127.6012914727,
		"y": -26.148752074,
		"h": 2.1208791209
	},
	{
		"stop_id": 8581921,
		"ID": 80,
		"x": -127.3222440927,
		"y": -26.369797073,
		"h": 2.1208791209
	},
	{
		"stop_id": 8581922,
		"ID": 80,
		"x": -127.1722678277,
		"y": -26.386824611,
		"h": 2.1208791209
	},
	{
		"stop_id": 8581924,
		"ID": 80,
		"x": -127.0352695657,
		"y": -26.473852925,
		"h": 2.1208791209
	},
	{
		"stop_id": 8583748,
		"ID": 80,
		"x": -127.1172877387,
		"y": -24.931857675,
		"h": 2.1208791209
	},
	{
		"stop_id": 8588843,
		"ID": 80,
		"x": -125.8202568147,
		"y": -26.382841612,
		"h": 2.1208791209
	},
	{
		"stop_id": 8588845,
		"ID": 80,
		"x": -126.0702371807,
		"y": -26.149847893,
		"h": 2.1208791209
	},
	{
		"stop_id": 8588847,
		"ID": 80,
		"x": -126.9922283127,
		"y": -24.794849633,
		"h": 2.1208791209
	},
	{
		"stop_id": 8588848,
		"ID": 80,
		"x": -126.7002356487,
		"y": -24.765761721,
		"h": 2.1208791209
	},
	{
		"stop_id": 8588849,
		"ID": 80,
		"x": -126.2632547797,
		"y": -23.850776936,
		"h": 2.1208791209
	},
	{
		"stop_id": 8588850,
		"ID": 80,
		"x": -126.6122619817,
		"y": -23.840785019,
		"h": 2.1208791209
	},
	{
		"stop_id": 8588851,
		"ID": 80,
		"x": -126.9012976217,
		"y": -23.924829136,
		"h": 2.1208791209
	},
	{
		"stop_id": 8588852,
		"ID": 80,
		"x": -127.5742238887,
		"y": -23.671793785,
		"h": 2.1208791209
	},
	{
		"stop_id": 8588853,
		"ID": 80,
		"x": -127.7382307177,
		"y": -23.694841125,
		"h": 2.1208791209
	},
	{
		"stop_id": 8591936,
		"ID": 80,
		"x": -126.3952617867,
		"y": -26.357810645,
		"h": 2.1208791209
	},
	{
		"stop_id": 8591937,
		"ID": 80,
		"x": -126.6612840227,
		"y": -25.501825225,
		"h": 2.1208791209
	},
	{
		"stop_id": 8593780,
		"ID": 80,
		"x": -128.9352735827,
		"y": -23.447811017,
		"h": 2.1208791209
	},
	{
		"stop_id": 8593781,
		"ID": 80,
		"x": -128.6802560977,
		"y": -23.756804635,
		"h": 2.1208791209
	},
	{
		"stop_id": 8593782,
		"ID": 80,
		"x": -129.2902795887,
		"y": -23.732759166,
		"h": 2.1208791209
	},
	{
		"stop_id": 8594177,
		"ID": 80,
		"x": -126.9822743327,
		"y": -26.254769383,
		"h": 2.1208791209
	},
	{
		"stop_id": 8594178,
		"ID": 80,
		"x": -126.9332514307,
		"y": -25.992839489,
		"h": 2.1208791209
	},
	{
		"stop_id": 8595147,
		"ID": 80,
		"x": -124.6192695487,
		"y": -23.682777502,
		"h": 2.1208791209
	},
	{
		"stop_id": 8501122,
		"ID": 103,
		"x": -117.1602710467,
		"y": -32.020854909,
		"h": 3.3076923077
	},
	{
		"stop_id": 8501318,
		"ID": 103,
		"x": -117.6662993687,
		"y": -32.299817835,
		"h": 3.3076923077
	},
	{
		"stop_id": 8504003,
		"ID": 103,
		"x": -116.4852351037,
		"y": -31.364801635,
		"h": 3.3076923077
	},
	{
		"stop_id": 8504010,
		"ID": 103,
		"x": -118.0932628867,
		"y": -30.977760058,
		"h": 3.3076923077
	},
	{
		"stop_id": 8504172,
		"ID": 103,
		"x": -116.1422659337,
		"y": -27.9697735,
		"h": 3.3076923077
	},
	{
		"stop_id": 8504173,
		"ID": 103,
		"x": -114.0312485437,
		"y": -28.182773371,
		"h": 3.3076923077
	},
	{
		"stop_id": 8579246,
		"ID": 103,
		"x": -118.8832254607,
		"y": -28.783751379,
		"h": 3.3076923077
	},
	{
		"stop_id": 8579247,
		"ID": 103,
		"x": -118.1082820317,
		"y": -28.360766134,
		"h": 3.3076923077
	},
	{
		"stop_id": 8579248,
		"ID": 103,
		"x": -117.6442724767,
		"y": -28.636846909,
		"h": 3.3076923077
	},
	{
		"stop_id": 8579249,
		"ID": 103,
		"x": -117.2712298087,
		"y": -28.441769171,
		"h": 3.3076923077
	},
	{
		"stop_id": 8579256,
		"ID": 103,
		"x": -118.9532665777,
		"y": -29.989821609,
		"h": 3.3076923077
	},
	{
		"stop_id": 8579257,
		"ID": 103,
		"x": -118.0772443287,
		"y": -30.252749164,
		"h": 3.3076923077
	},
	{
		"stop_id": 8579258,
		"ID": 103,
		"x": -117.6252897717,
		"y": -30.329825553,
		"h": 3.3076923077
	},
	{
		"stop_id": 8579259,
		"ID": 103,
		"x": -117.0383004227,
		"y": -30.46785559,
		"h": 3.3076923077
	},
	{
		"stop_id": 8579260,
		"ID": 103,
		"x": -116.2072256397,
		"y": -30.547761233,
		"h": 3.3076923077
	},
	{
		"stop_id": 8582774,
		"ID": 103,
		"x": -113.4972240377,
		"y": -30.169848567,
		"h": 3.3076923077
	},
	{
		"stop_id": 8582775,
		"ID": 103,
		"x": -113.3222961567,
		"y": -29.984756887,
		"h": 3.3076923077
	},
	{
		"stop_id": 8582776,
		"ID": 103,
		"x": -113.8472851027,
		"y": -30.584816562,
		"h": 3.3076923077
	},
	{
		"stop_id": 8582777,
		"ID": 103,
		"x": -114.2782251807,
		"y": -30.899756219,
		"h": 3.3076923077
	},
	{
		"stop_id": 8582778,
		"ID": 103,
		"x": -115.0742412827,
		"y": -31.480791305,
		"h": 3.3076923077
	},
	{
		"stop_id": 8582779,
		"ID": 103,
		"x": -115.2822645987,
		"y": -31.930779037,
		"h": 3.3076923077
	},
	{
		"stop_id": 8587546,
		"ID": 103,
		"x": -117.8902593237,
		"y": -26.697764221,
		"h": 3.3076923077
	},
	{
		"stop_id": 8587547,
		"ID": 103,
		"x": -117.0532559437,
		"y": -26.759839675,
		"h": 3.3076923077
	},
	{
		"stop_id": 8587550,
		"ID": 103,
		"x": -117.9872780007,
		"y": -27.717817049,
		"h": 3.3076923077
	},
	{
		"stop_id": 8588434,
		"ID": 103,
		"x": -119.3202858557,
		"y": -30.018766712,
		"h": 3.3076923077
	},
	{
		"stop_id": 8588435,
		"ID": 103,
		"x": -118.5022266427,
		"y": -29.419829899,
		"h": 3.3076923077
	},
	{
		"stop_id": 8588436,
		"ID": 103,
		"x": -118.1622234437,
		"y": -29.93975614,
		"h": 3.3076923077
	},
	{
		"stop_id": 8588438,
		"ID": 103,
		"x": -116.3622759207,
		"y": -30.395777485,
		"h": 3.3076923077
	},
	{
		"stop_id": 8588448,
		"ID": 103,
		"x": -119.0472305987,
		"y": -30.60778319,
		"h": 3.3076923077
	},
	{
		"stop_id": 8588449,
		"ID": 103,
		"x": -118.9462737607,
		"y": -30.43279524,
		"h": 3.3076923077
	},
	{
		"stop_id": 8588450,
		"ID": 103,
		"x": -118.9672838727,
		"y": -30.290845351,
		"h": 3.3076923077
	},
	{
		"stop_id": 8588451,
		"ID": 103,
		"x": -116.1082745557,
		"y": -31.125775492,
		"h": 3.3076923077
	},
	{
		"stop_id": 8588452,
		"ID": 103,
		"x": -115.8052890657,
		"y": -31.441776447,
		"h": 3.3076923077
	},
	{
		"stop_id": 8588453,
		"ID": 103,
		"x": -115.6112518187,
		"y": -31.821784563,
		"h": 3.3076923077
	},
	{
		"stop_id": 8588454,
		"ID": 103,
		"x": -115.2922268767,
		"y": -32.169813944,
		"h": 3.3076923077
	},
	{
		"stop_id": 8591970,
		"ID": 103,
		"x": -118.5012632827,
		"y": -27.548833581,
		"h": 3.3076923077
	},
	{
		"stop_id": 8591976,
		"ID": 103,
		"x": -118.1012783487,
		"y": -31.012812157,
		"h": 3.3076923077
	},
	{
		"stop_id": 8592058,
		"ID": 103,
		"x": -117.5612259337,
		"y": -27.453789773,
		"h": 3.3076923077
	},
	{
		"stop_id": 8592101,
		"ID": 103,
		"x": -118.9342394477,
		"y": -28.245848587,
		"h": 3.3076923077
	},
	{
		"stop_id": 8592145,
		"ID": 103,
		"x": -117.8312762347,
		"y": -31.386849192,
		"h": 3.3076923077
	},
	{
		"stop_id": 8592146,
		"ID": 103,
		"x": -116.6182246947,
		"y": -30.980784747,
		"h": 3.3076923077
	},
	{
		"stop_id": 8592147,
		"ID": 103,
		"x": -117.1552340037,
		"y": -30.834825054,
		"h": 3.3076923077
	},
	{
		"stop_id": 8592148,
		"ID": 103,
		"x": -117.3312444867,
		"y": -31.886815064,
		"h": 3.3076923077
	},
	{
		"stop_id": 8592149,
		"ID": 103,
		"x": -117.9542826237,
		"y": -30.92385613,
		"h": 3.3076923077
	},
	{
		"stop_id": 8592150,
		"ID": 103,
		"x": -117.8992340037,
		"y": -31.976841404,
		"h": 3.3076923077
	},
	{
		"stop_id": 8592151,
		"ID": 103,
		"x": -118.0192371967,
		"y": -31.250846499,
		"h": 3.3076923077
	},
	{
		"stop_id": 8592152,
		"ID": 103,
		"x": -117.4792465537,
		"y": -30.78480664,
		"h": 3.3076923077
	},
	{
		"stop_id": 8592153,
		"ID": 103,
		"x": -116.8202435817,
		"y": -31.361851467,
		"h": 3.3076923077
	},
	{
		"stop_id": 8592154,
		"ID": 103,
		"x": -117.4382411557,
		"y": -31.909801718,
		"h": 3.3076923077
	},
	{
		"stop_id": 8592155,
		"ID": 103,
		"x": -116.8972576447,
		"y": -32.365766667,
		"h": 3.3076923077
	},
	{
		"stop_id": 8592156,
		"ID": 103,
		"x": -117.6642813837,
		"y": -32.233801978,
		"h": 3.3076923077
	},
	{
		"stop_id": 8592157,
		"ID": 103,
		"x": -117.5702484747,
		"y": -31.029840925,
		"h": 3.3076923077
	},
	{
		"stop_id": 8592158,
		"ID": 103,
		"x": -117.7052560467,
		"y": -31.658766324,
		"h": 3.3076923077
	},
	{
		"stop_id": 8592159,
		"ID": 103,
		"x": -117.2302424447,
		"y": -30.981853566,
		"h": 3.3076923077
	},
	{
		"stop_id": 8592160,
		"ID": 103,
		"x": -117.2202426357,
		"y": -32.287757843,
		"h": 3.3076923077
	},
	{
		"stop_id": 8592161,
		"ID": 103,
		"x": -116.3412510947,
		"y": -30.656781304,
		"h": 3.3076923077
	},
	{
		"stop_id": 8592162,
		"ID": 103,
		"x": -116.9172497027,
		"y": -31.634853323,
		"h": 3.3076923077
	},
	{
		"stop_id": 8592163,
		"ID": 103,
		"x": -117.5852617447,
		"y": -31.943851985,
		"h": 3.3076923077
	},
	{
		"stop_id": 8592164,
		"ID": 103,
		"x": -117.4892802027,
		"y": -32.028819863,
		"h": 3.3076923077
	},
	{
		"stop_id": 8592167,
		"ID": 103,
		"x": -118.3242351367,
		"y": -31.791839345,
		"h": 3.3076923077
	},
	{
		"stop_id": 8592169,
		"ID": 103,
		"x": -118.5152642867,
		"y": -31.686807919,
		"h": 3.3076923077
	},
	{
		"stop_id": 8592171,
		"ID": 103,
		"x": -119.2432825657,
		"y": -29.751830133,
		"h": 3.3076923077
	},
	{
		"stop_id": 8592177,
		"ID": 103,
		"x": -119.0142977847,
		"y": -29.867821256,
		"h": 3.3076923077
	},
	{
		"stop_id": 8592194,
		"ID": 103,
		"x": -116.6452800517,
		"y": -28.092763955,
		"h": 3.3076923077
	},
	{
		"stop_id": 8592228,
		"ID": 103,
		"x": -114.4972909467,
		"y": -28.031798083,
		"h": 3.3076923077
	},
	{
		"stop_id": 8592233,
		"ID": 103,
		"x": -115.1942439137,
		"y": -27.809844495,
		"h": 3.3076923077
	},
	{
		"stop_id": 8593795,
		"ID": 103,
		"x": -118.4542875217,
		"y": -30.858848463,
		"h": 3.3076923077
	},
	{
		"stop_id": 8593798,
		"ID": 103,
		"x": -118.5282485677,
		"y": -30.071814488,
		"h": 3.3076923077
	},
	{
		"stop_id": 8593806,
		"ID": 103,
		"x": -118.3562247487,
		"y": -30.050816223,
		"h": 3.3076923077
	},
	{
		"stop_id": 8595190,
		"ID": 103,
		"x": -118.2362274167,
		"y": -30.139810504,
		"h": 3.3076923077
	},
	{
		"stop_id": 8595191,
		"ID": 103,
		"x": -118.7302773917,
		"y": -31.116841175,
		"h": 3.3076923077
	},
	{
		"stop_id": 8501123,
		"ID": 102,
		"x": -115.8892748667,
		"y": -32.971806557,
		"h": 1.2967032967
	},
	{
		"stop_id": 8501124,
		"ID": 102,
		"x": -114.3712646637,
		"y": -33.739748724,
		"h": 1.2967032967
	},
	{
		"stop_id": 8501317,
		"ID": 102,
		"x": -114.0292240207,
		"y": -33.862799488,
		"h": 1.2967032967
	},
	{
		"stop_id": 8504011,
		"ID": 102,
		"x": -114.7082387347,
		"y": -32.803849687,
		"h": 1.2967032967
	},
	{
		"stop_id": 8570559,
		"ID": 102,
		"x": -114.3882751617,
		"y": -33.735814344,
		"h": 1.2967032967
	},
	{
		"stop_id": 8582780,
		"ID": 102,
		"x": -114.7322377377,
		"y": -32.808855169,
		"h": 1.2967032967
	},
	{
		"stop_id": 8582781,
		"ID": 102,
		"x": -115.2372955457,
		"y": -33.029777542,
		"h": 1.2967032967
	},
	{
		"stop_id": 8595728,
		"ID": 102,
		"x": -115.2022640757,
		"y": -32.594758752,
		"h": 1.2967032967
	},
	{
		"stop_id": 8595729,
		"ID": 102,
		"x": -114.8522279657,
		"y": -32.866787521,
		"h": 1.2967032967
	},
	{
		"stop_id": 8595732,
		"ID": 102,
		"x": -114.2162826277,
		"y": -33.600858671,
		"h": 1.2967032967
	},
	{
		"stop_id": 8501125,
		"ID": 122,
		"x": -112.9872634027,
		"y": -33.666788008,
		"h": 1.5934065934
	},
	{
		"stop_id": 8501297,
		"ID": 122,
		"x": -113.7082299167,
		"y": -33.20978763,
		"h": 1.5934065934
	},
	{
		"stop_id": 8501757,
		"ID": 122,
		"x": -110.5922507147,
		"y": -34.494836621,
		"h": 1.5934065934
	},
	{
		"stop_id": 8504007,
		"ID": 122,
		"x": -109.8612307917,
		"y": -31.573778462,
		"h": 1.5934065934
	},
	{
		"stop_id": 8504012,
		"ID": 122,
		"x": -111.4072398767,
		"y": -33.178756633,
		"h": 1.5934065934
	},
	{
		"stop_id": 8504013,
		"ID": 122,
		"x": -110.4322435357,
		"y": -34.607801837,
		"h": 1.5934065934
	},
	{
		"stop_id": 8570560,
		"ID": 122,
		"x": -113.0882914167,
		"y": -33.335829411,
		"h": 1.5934065934
	},
	{
		"stop_id": 8570561,
		"ID": 122,
		"x": -112.8432981197,
		"y": -33.397807954,
		"h": 1.5934065934
	},
	{
		"stop_id": 8570562,
		"ID": 122,
		"x": -111.9422655357,
		"y": -34.182775121,
		"h": 1.5934065934
	},
	{
		"stop_id": 8570563,
		"ID": 122,
		"x": -110.7732326627,
		"y": -34.57378967,
		"h": 1.5934065934
	},
	{
		"stop_id": 8570564,
		"ID": 122,
		"x": -110.4172357687,
		"y": -34.594810386,
		"h": 1.5934065934
	},
	{
		"stop_id": 8570565,
		"ID": 122,
		"x": -110.7852454297,
		"y": -34.206828924,
		"h": 1.5934065934
	},
	{
		"stop_id": 8570566,
		"ID": 122,
		"x": -111.1642703977,
		"y": -33.343814577,
		"h": 1.5934065934
	},
	{
		"stop_id": 8570567,
		"ID": 122,
		"x": -111.4272970007,
		"y": -33.189812312,
		"h": 1.5934065934
	},
	{
		"stop_id": 8570568,
		"ID": 122,
		"x": -111.1422888577,
		"y": -32.694773124,
		"h": 1.5934065934
	},
	{
		"stop_id": 8570569,
		"ID": 122,
		"x": -110.0952713347,
		"y": -32.417820214,
		"h": 1.5934065934
	},
	{
		"stop_id": 8579747,
		"ID": 122,
		"x": -110.5422969687,
		"y": -34.744833969,
		"h": 1.5934065934
	},
	{
		"stop_id": 8595730,
		"ID": 122,
		"x": -114.2842553767,
		"y": -33.103757462,
		"h": 1.5934065934
	},
	{
		"stop_id": 8595731,
		"ID": 122,
		"x": -113.8232542107,
		"y": -33.176848111,
		"h": 1.5934065934
	},
	{
		"stop_id": 8501126,
		"ID": 121,
		"x": -109.9742632637,
		"y": -35.373821826,
		"h": 1.032967033
	},
	{
		"stop_id": 8501243,
		"ID": 121,
		"x": -110.0172882697,
		"y": -35.439830213,
		"h": 1.032967033
	},
	{
		"stop_id": 8501127,
		"ID": 143,
		"x": -109.0202681827,
		"y": -35.56080971,
		"h": 4.032967033
	},
	{
		"stop_id": 8501200,
		"ID": 143,
		"x": -105.4632987247,
		"y": -36.654794813,
		"h": 4.032967033
	},
	{
		"stop_id": 8501247,
		"ID": 143,
		"x": -104.9642957067,
		"y": -37.33180419,
		"h": 4.032967033
	},
	{
		"stop_id": 8501248,
		"ID": 143,
		"x": -105.6832306257,
		"y": -37.12680743,
		"h": 4.032967033
	},
	{
		"stop_id": 8501250,
		"ID": 143,
		"x": -106.0302912377,
		"y": -36.023799708,
		"h": 4.032967033
	},
	{
		"stop_id": 8501251,
		"ID": 143,
		"x": -106.0392267117,
		"y": -35.737805347,
		"h": 4.032967033
	},
	{
		"stop_id": 8501252,
		"ID": 143,
		"x": -106.0812641547,
		"y": -35.461783398,
		"h": 4.032967033
	},
	{
		"stop_id": 8501253,
		"ID": 143,
		"x": -106.2462359547,
		"y": -35.083759108,
		"h": 4.032967033
	},
	{
		"stop_id": 8501254,
		"ID": 143,
		"x": -106.3072670507,
		"y": -34.812813381,
		"h": 4.032967033
	},
	{
		"stop_id": 8501255,
		"ID": 143,
		"x": -106.3582788197,
		"y": -34.547836618,
		"h": 4.032967033
	},
	{
		"stop_id": 8501260,
		"ID": 143,
		"x": -104.7502820467,
		"y": -35.724803437,
		"h": 4.032967033
	},
	{
		"stop_id": 8501261,
		"ID": 143,
		"x": -104.5782790867,
		"y": -36.132853732,
		"h": 4.032967033
	},
	{
		"stop_id": 8501262,
		"ID": 143,
		"x": -104.1202661577,
		"y": -36.302782022,
		"h": 4.032967033
	},
	{
		"stop_id": 8501263,
		"ID": 143,
		"x": -103.7802679517,
		"y": -36.059822512,
		"h": 4.032967033
	},
	{
		"stop_id": 8504015,
		"ID": 143,
		"x": -106.0742289917,
		"y": -36.063815475,
		"h": 4.032967033
	},
	{
		"stop_id": 8504040,
		"ID": 143,
		"x": -106.8912632067,
		"y": -35.815783299,
		"h": 4.032967033
	},
	{
		"stop_id": 8504712,
		"ID": 143,
		"x": -105.9342427877,
		"y": -35.079827917,
		"h": 4.032967033
	},
	{
		"stop_id": 8504728,
		"ID": 143,
		"x": -105.3672435847,
		"y": -34.545768909,
		"h": 4.032967033
	},
	{
		"stop_id": 8504954,
		"ID": 143,
		"x": -104.6713004167,
		"y": -34.868841703,
		"h": 4.032967033
	},
	{
		"stop_id": 8504957,
		"ID": 143,
		"x": -104.7522994677,
		"y": -33.245843345,
		"h": 4.032967033
	},
	{
		"stop_id": 8504958,
		"ID": 143,
		"x": -104.7612784327,
		"y": -33.716796911,
		"h": 4.032967033
	},
	{
		"stop_id": 8504959,
		"ID": 143,
		"x": -105.4392495877,
		"y": -35.178771311,
		"h": 4.032967033
	},
	{
		"stop_id": 8504961,
		"ID": 143,
		"x": -104.1602608347,
		"y": -33.991852848,
		"h": 4.032967033
	},
	{
		"stop_id": 8504963,
		"ID": 143,
		"x": -105.0462821467,
		"y": -35.538818725,
		"h": 4.032967033
	},
	{
		"stop_id": 8504964,
		"ID": 143,
		"x": -105.3232835727,
		"y": -35.837769134,
		"h": 4.032967033
	},
	{
		"stop_id": 8504966,
		"ID": 143,
		"x": -105.6002737247,
		"y": -34.842816653,
		"h": 4.032967033
	},
	{
		"stop_id": 8504967,
		"ID": 143,
		"x": -105.6982418697,
		"y": -35.743756515,
		"h": 4.032967033
	},
	{
		"stop_id": 8579149,
		"ID": 143,
		"x": -105.5822775047,
		"y": -36.924806538,
		"h": 4.032967033
	},
	{
		"stop_id": 8579150,
		"ID": 143,
		"x": -106.6522634107,
		"y": -35.82977016,
		"h": 4.032967033
	},
	{
		"stop_id": 8579151,
		"ID": 143,
		"x": -106.8032236677,
		"y": -35.813805007,
		"h": 4.032967033
	},
	{
		"stop_id": 8579152,
		"ID": 143,
		"x": -107.0202901797,
		"y": -35.784754542,
		"h": 4.032967033
	},
	{
		"stop_id": 8579153,
		"ID": 143,
		"x": -107.4922929347,
		"y": -35.7567897,
		"h": 4.032967033
	},
	{
		"stop_id": 8579154,
		"ID": 143,
		"x": -107.8312446287,
		"y": -35.707842031,
		"h": 4.032967033
	},
	{
		"stop_id": 8579155,
		"ID": 143,
		"x": -107.4462640927,
		"y": -35.647765,
		"h": 4.032967033
	},
	{
		"stop_id": 8579157,
		"ID": 143,
		"x": -106.8022661577,
		"y": -35.671850093,
		"h": 4.032967033
	},
	{
		"stop_id": 8579158,
		"ID": 143,
		"x": -106.5422550267,
		"y": -35.669766436,
		"h": 4.032967033
	},
	{
		"stop_id": 8579159,
		"ID": 143,
		"x": -106.2882746107,
		"y": -35.662844616,
		"h": 4.032967033
	},
	{
		"stop_id": 8579160,
		"ID": 143,
		"x": -105.6022720647,
		"y": -35.839760749,
		"h": 4.032967033
	},
	{
		"stop_id": 8579162,
		"ID": 143,
		"x": -105.1622440357,
		"y": -35.719815326,
		"h": 4.032967033
	},
	{
		"stop_id": 8579164,
		"ID": 143,
		"x": -105.0332723477,
		"y": -35.320804264,
		"h": 4.032967033
	},
	{
		"stop_id": 8579165,
		"ID": 143,
		"x": -104.8032297847,
		"y": -35.205806171,
		"h": 4.032967033
	},
	{
		"stop_id": 8579166,
		"ID": 143,
		"x": -104.4292843487,
		"y": -34.885764673,
		"h": 4.032967033
	},
	{
		"stop_id": 8579168,
		"ID": 143,
		"x": -103.8442660397,
		"y": -34.522785323,
		"h": 4.032967033
	},
	{
		"stop_id": 8579169,
		"ID": 143,
		"x": -103.6982720067,
		"y": -34.363772438,
		"h": 4.032967033
	},
	{
		"stop_id": 8579172,
		"ID": 143,
		"x": -104.9862395657,
		"y": -35.11282876,
		"h": 4.032967033
	},
	{
		"stop_id": 8579173,
		"ID": 143,
		"x": -104.7642805017,
		"y": -35.019779739,
		"h": 4.032967033
	},
	{
		"stop_id": 8579174,
		"ID": 143,
		"x": -105.5492277997,
		"y": -36.690826415,
		"h": 4.032967033
	},
	{
		"stop_id": 8579181,
		"ID": 143,
		"x": -105.0382315117,
		"y": -34.429751669,
		"h": 4.032967033
	},
	{
		"stop_id": 8588746,
		"ID": 143,
		"x": -105.7762385537,
		"y": -36.460752651,
		"h": 4.032967033
	},
	{
		"stop_id": 8593912,
		"ID": 143,
		"x": -107.1832448107,
		"y": -35.614827982,
		"h": 4.032967033
	},
	{
		"stop_id": 8593949,
		"ID": 143,
		"x": -104.5142401677,
		"y": -37.30182132,
		"h": 4.032967033
	},
	{
		"stop_id": 8593950,
		"ID": 143,
		"x": -104.4472749037,
		"y": -37.491750323,
		"h": 4.032967033
	},
	{
		"stop_id": 8593956,
		"ID": 143,
		"x": -104.4762483087,
		"y": -37.709758248,
		"h": 4.032967033
	},
	{
		"stop_id": 8593967,
		"ID": 143,
		"x": -104.6422678157,
		"y": -37.439827164,
		"h": 4.032967033
	},
	{
		"stop_id": 8593974,
		"ID": 143,
		"x": -104.3332394997,
		"y": -37.188774041,
		"h": 4.032967033
	},
	{
		"stop_id": 8593979,
		"ID": 143,
		"x": -105.5172928867,
		"y": -36.027838441,
		"h": 4.032967033
	},
	{
		"stop_id": 8593981,
		"ID": 143,
		"x": -104.9682421477,
		"y": -36.967809221,
		"h": 4.032967033
	},
	{
		"stop_id": 8593982,
		"ID": 143,
		"x": -105.9792281007,
		"y": -36.255756709,
		"h": 4.032967033
	},
	{
		"stop_id": 8593983,
		"ID": 143,
		"x": -104.6442467007,
		"y": -36.634842416,
		"h": 4.032967033
	},
	{
		"stop_id": 8593984,
		"ID": 143,
		"x": -105.1552724267,
		"y": -36.30183479,
		"h": 4.032967033
	},
	{
		"stop_id": 8593985,
		"ID": 143,
		"x": -104.9622662917,
		"y": -37.194748838,
		"h": 4.032967033
	},
	{
		"stop_id": 8593987,
		"ID": 143,
		"x": -105.2942397517,
		"y": -37.022822599,
		"h": 4.032967033
	},
	{
		"stop_id": 8593988,
		"ID": 143,
		"x": -105.0862918207,
		"y": -35.802764475,
		"h": 4.032967033
	},
	{
		"stop_id": 8593989,
		"ID": 143,
		"x": -105.2662651427,
		"y": -36.006843706,
		"h": 4.032967033
	},
	{
		"stop_id": 8593990,
		"ID": 143,
		"x": -104.9042632337,
		"y": -35.793795958,
		"h": 4.032967033
	},
	{
		"stop_id": 8593991,
		"ID": 143,
		"x": -104.7762290697,
		"y": -37.240834622,
		"h": 4.032967033
	},
	{
		"stop_id": 8593992,
		"ID": 143,
		"x": -105.9992591907,
		"y": -36.023816197,
		"h": 4.032967033
	},
	{
		"stop_id": 8593993,
		"ID": 143,
		"x": -105.2172308897,
		"y": -37.079767855,
		"h": 4.032967033
	},
	{
		"stop_id": 8593994,
		"ID": 143,
		"x": -104.8042594407,
		"y": -35.660810766,
		"h": 4.032967033
	},
	{
		"stop_id": 8593995,
		"ID": 143,
		"x": -104.8962334897,
		"y": -36.575814812,
		"h": 4.032967033
	},
	{
		"stop_id": 8593996,
		"ID": 143,
		"x": -105.7022233607,
		"y": -36.093795755,
		"h": 4.032967033
	},
	{
		"stop_id": 8593997,
		"ID": 143,
		"x": -105.0222321907,
		"y": -36.52684253,
		"h": 4.032967033
	},
	{
		"stop_id": 8593998,
		"ID": 143,
		"x": -105.6212895437,
		"y": -36.61079155,
		"h": 4.032967033
	},
	{
		"stop_id": 8593999,
		"ID": 143,
		"x": -104.7602645407,
		"y": -35.816776126,
		"h": 4.032967033
	},
	{
		"stop_id": 8594000,
		"ID": 143,
		"x": -104.5522626467,
		"y": -36.733801442,
		"h": 4.032967033
	},
	{
		"stop_id": 8594002,
		"ID": 143,
		"x": -105.4712827257,
		"y": -36.825822368,
		"h": 4.032967033
	},
	{
		"stop_id": 8594003,
		"ID": 143,
		"x": -104.5622434707,
		"y": -36.928827486,
		"h": 4.032967033
	},
	{
		"stop_id": 8594004,
		"ID": 143,
		"x": -105.0842813557,
		"y": -37.15581047,
		"h": 4.032967033
	},
	{
		"stop_id": 8594640,
		"ID": 143,
		"x": -105.7922459937,
		"y": -36.213835958,
		"h": 4.032967033
	},
	{
		"stop_id": 8594641,
		"ID": 143,
		"x": -105.7022390927,
		"y": -36.286784174,
		"h": 4.032967033
	},
	{
		"stop_id": 8595111,
		"ID": 143,
		"x": -103.7102486507,
		"y": -35.444796374,
		"h": 4.032967033
	},
	{
		"stop_id": 8595112,
		"ID": 143,
		"x": -103.6922955177,
		"y": -35.184793917,
		"h": 4.032967033
	},
	{
		"stop_id": 8595113,
		"ID": 143,
		"x": -104.1402432337,
		"y": -35.533794524,
		"h": 4.032967033
	},
	{
		"stop_id": 8595114,
		"ID": 143,
		"x": -103.7352881087,
		"y": -34.804839743,
		"h": 4.032967033
	},
	{
		"stop_id": 8595116,
		"ID": 143,
		"x": -104.3262866647,
		"y": -35.225815333,
		"h": 4.032967033
	},
	{
		"stop_id": 8595117,
		"ID": 143,
		"x": -104.0422416217,
		"y": -35.179779429,
		"h": 4.032967033
	},
	{
		"stop_id": 8595118,
		"ID": 143,
		"x": -104.7122459617,
		"y": -36.18476934,
		"h": 4.032967033
	},
	{
		"stop_id": 8595119,
		"ID": 143,
		"x": -104.9012389427,
		"y": -36.096752592,
		"h": 4.032967033
	},
	{
		"stop_id": 8595120,
		"ID": 143,
		"x": -104.7502431667,
		"y": -36.396816619,
		"h": 4.032967033
	},
	{
		"stop_id": 8595958,
		"ID": 143,
		"x": -104.6512963907,
		"y": -37.290794177,
		"h": 4.032967033
	},
	{
		"stop_id": 8595961,
		"ID": 143,
		"x": -105.0402843607,
		"y": -35.955856721,
		"h": 4.032967033
	},
	{
		"stop_id": 8595962,
		"ID": 143,
		"x": -105.3142602987,
		"y": -36.278842832,
		"h": 4.032967033
	},
	{
		"stop_id": 8595968,
		"ID": 143,
		"x": -103.4662272777,
		"y": -35.590761424,
		"h": 4.032967033
	},
	{
		"stop_id": 8501153,
		"ID": 46,
		"x": -148.1772987347,
		"y": -15.731825696,
		"h": 1.1978021978
	},
	{
		"stop_id": 8530623,
		"ID": 46,
		"x": -149.0272250377,
		"y": -18.250767558,
		"h": 1.1978021978
	},
	{
		"stop_id": 8579137,
		"ID": 46,
		"x": -145.3812902567,
		"y": -15.484789933,
		"h": 1.1978021978
	},
	{
		"stop_id": 8579138,
		"ID": 46,
		"x": -145.8002531127,
		"y": -15.704816342,
		"h": 1.1978021978
	},
	{
		"stop_id": 8579139,
		"ID": 46,
		"x": -146.6912630807,
		"y": -16.551814089,
		"h": 1.1978021978
	},
	{
		"stop_id": 8579140,
		"ID": 46,
		"x": -148.2782877287,
		"y": -17.884750036,
		"h": 1.1978021978
	},
	{
		"stop_id": 8579141,
		"ID": 46,
		"x": -149.1682731137,
		"y": -18.581757509,
		"h": 1.1978021978
	},
	{
		"stop_id": 8501154,
		"ID": 39,
		"x": -149.9572847707,
		"y": -17.359765021,
		"h": 1
	},
	{
		"stop_id": 8501155,
		"ID": 38,
		"x": -150.7522915287,
		"y": -18.18482244,
		"h": 1.5604395604
	},
	{
		"stop_id": 8501156,
		"ID": 38,
		"x": -151.6322414777,
		"y": -19.289760301,
		"h": 1.5604395604
	},
	{
		"stop_id": 8501157,
		"ID": 38,
		"x": -152.2322779757,
		"y": -20.244799097,
		"h": 1.5604395604
	},
	{
		"stop_id": 8501159,
		"ID": 38,
		"x": -153.5772710257,
		"y": -22.445842955,
		"h": 1.5604395604
	},
	{
		"stop_id": 8501776,
		"ID": 38,
		"x": -150.1422978227,
		"y": -19.386770124,
		"h": 1.5604395604
	},
	{
		"stop_id": 8530622,
		"ID": 38,
		"x": -150.6462474117,
		"y": -18.37476721,
		"h": 1.5604395604
	},
	{
		"stop_id": 8530783,
		"ID": 38,
		"x": -152.9662432507,
		"y": -20.948771222,
		"h": 1.5604395604
	},
	{
		"stop_id": 8570024,
		"ID": 38,
		"x": -153.6392480647,
		"y": -22.482786172,
		"h": 1.5604395604
	},
	{
		"stop_id": 8579143,
		"ID": 38,
		"x": -149.8972661157,
		"y": -19.109841738,
		"h": 1.5604395604
	},
	{
		"stop_id": 8579144,
		"ID": 38,
		"x": -151.5842387107,
		"y": -20.683790708,
		"h": 1.5604395604
	},
	{
		"stop_id": 8579145,
		"ID": 38,
		"x": -151.1072607797,
		"y": -20.263810113,
		"h": 1.5604395604
	},
	{
		"stop_id": 8579146,
		"ID": 38,
		"x": -152.2362314297,
		"y": -20.232841996,
		"h": 1.5604395604
	},
	{
		"stop_id": 8593530,
		"ID": 38,
		"x": -149.5422669427,
		"y": -18.86979408,
		"h": 1.5604395604
	},
	{
		"stop_id": 8595462,
		"ID": 38,
		"x": -153.6172611647,
		"y": -22.674803291,
		"h": 1.5604395604
	},
	{
		"stop_id": 8595464,
		"ID": 38,
		"x": -152.7012241387,
		"y": -21.89279067,
		"h": 1.5604395604
	},
	{
		"stop_id": 8595467,
		"ID": 38,
		"x": -152.0162870357,
		"y": -21.177803368,
		"h": 1.5604395604
	},
	{
		"stop_id": 8595468,
		"ID": 38,
		"x": -151.8502276017,
		"y": -19.585823652,
		"h": 1.5604395604
	},
	{
		"stop_id": 8595469,
		"ID": 38,
		"x": -152.2152883427,
		"y": -19.952770804,
		"h": 1.5604395604
	},
	{
		"stop_id": 8501161,
		"ID": 91,
		"x": -123.0722490567,
		"y": -29.009754372,
		"h": 4.6593406593
	},
	{
		"stop_id": 8501162,
		"ID": 91,
		"x": -123.3222577227,
		"y": -28.519848068,
		"h": 4.6593406593
	},
	{
		"stop_id": 8501163,
		"ID": 91,
		"x": -123.5022363357,
		"y": -27.969752383,
		"h": 4.6593406593
	},
	{
		"stop_id": 8501164,
		"ID": 91,
		"x": -123.6822589067,
		"y": -27.419761524,
		"h": 4.6593406593
	},
	{
		"stop_id": 8501165,
		"ID": 91,
		"x": -123.9322830697,
		"y": -26.999755276,
		"h": 4.6593406593
	},
	{
		"stop_id": 8501166,
		"ID": 91,
		"x": -123.8022463837,
		"y": -25.429838753,
		"h": 4.6593406593
	},
	{
		"stop_id": 8501167,
		"ID": 91,
		"x": -123.9822550677,
		"y": -26.049812078,
		"h": 4.6593406593
	},
	{
		"stop_id": 8504176,
		"ID": 91,
		"x": -121.4422657547,
		"y": -29.569787067,
		"h": 4.6593406593
	},
	{
		"stop_id": 8504177,
		"ID": 91,
		"x": -121.5522734347,
		"y": -25.392833051,
		"h": 4.6593406593
	},
	{
		"stop_id": 8579235,
		"ID": 91,
		"x": -121.2922404197,
		"y": -25.780824858,
		"h": 4.6593406593
	},
	{
		"stop_id": 8579238,
		"ID": 91,
		"x": -120.5372854217,
		"y": -28.759791551,
		"h": 4.6593406593
	},
	{
		"stop_id": 8579239,
		"ID": 91,
		"x": -119.3542712387,
		"y": -27.651821256,
		"h": 4.6593406593
	},
	{
		"stop_id": 8579245,
		"ID": 91,
		"x": -119.4742805417,
		"y": -28.704752973,
		"h": 4.6593406593
	},
	{
		"stop_id": 8579255,
		"ID": 91,
		"x": -120.1082581427,
		"y": -29.508853327,
		"h": 4.6593406593
	},
	{
		"stop_id": 8587357,
		"ID": 91,
		"x": -121.4692500547,
		"y": -28.073809921,
		"h": 4.6593406593
	},
	{
		"stop_id": 8587853,
		"ID": 91,
		"x": -121.4372587697,
		"y": -26.445809989,
		"h": 4.6593406593
	},
	{
		"stop_id": 8589525,
		"ID": 91,
		"x": -118.9512642987,
		"y": -27.4748212,
		"h": 4.6593406593
	},
	{
		"stop_id": 8591962,
		"ID": 91,
		"x": -118.6972754047,
		"y": -26.32481007,
		"h": 4.6593406593
	},
	{
		"stop_id": 8591963,
		"ID": 91,
		"x": -118.8112677907,
		"y": -26.592834902,
		"h": 4.6593406593
	},
	{
		"stop_id": 8591964,
		"ID": 91,
		"x": -119.7972250177,
		"y": -27.325790476,
		"h": 4.6593406593
	},
	{
		"stop_id": 8591965,
		"ID": 91,
		"x": -118.4572650587,
		"y": -27.057777211,
		"h": 4.6593406593
	},
	{
		"stop_id": 8591966,
		"ID": 91,
		"x": -118.6252657277,
		"y": -27.130839248,
		"h": 4.6593406593
	},
	{
		"stop_id": 8591967,
		"ID": 91,
		"x": -118.5762674747,
		"y": -26.787801176,
		"h": 4.6593406593
	},
	{
		"stop_id": 8591969,
		"ID": 91,
		"x": -119.0312349357,
		"y": -26.414794555,
		"h": 4.6593406593
	},
	{
		"stop_id": 8591971,
		"ID": 91,
		"x": -119.5892900987,
		"y": -27.480837525,
		"h": 4.6593406593
	},
	{
		"stop_id": 8591977,
		"ID": 91,
		"x": -120.3982971167,
		"y": -27.84381154,
		"h": 4.6593406593
	},
	{
		"stop_id": 8591980,
		"ID": 91,
		"x": -122.6082586857,
		"y": -29.344806974,
		"h": 4.6593406593
	},
	{
		"stop_id": 8591982,
		"ID": 91,
		"x": -121.3362801507,
		"y": -29.485828419,
		"h": 4.6593406593
	},
	{
		"stop_id": 8591984,
		"ID": 91,
		"x": -122.2752473527,
		"y": -29.263791742,
		"h": 4.6593406593
	},
	{
		"stop_id": 8591987,
		"ID": 91,
		"x": -122.4872491587,
		"y": -28.506837598,
		"h": 4.6593406593
	},
	{
		"stop_id": 8591992,
		"ID": 91,
		"x": -122.6602582267,
		"y": -28.968836153,
		"h": 4.6593406593
	},
	{
		"stop_id": 8591993,
		"ID": 91,
		"x": -123.0432501287,
		"y": -28.536802048,
		"h": 4.6593406593
	},
	{
		"stop_id": 8591994,
		"ID": 91,
		"x": -122.4482827207,
		"y": -27.691800617,
		"h": 4.6593406593
	},
	{
		"stop_id": 8591996,
		"ID": 91,
		"x": -122.3672939727,
		"y": -28.090751104,
		"h": 4.6593406593
	},
	{
		"stop_id": 8591997,
		"ID": 91,
		"x": -120.5232609057,
		"y": -28.063779143,
		"h": 4.6593406593
	},
	{
		"stop_id": 8591998,
		"ID": 91,
		"x": -122.5912924247,
		"y": -28.70585894,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592000,
		"ID": 91,
		"x": -122.7492737627,
		"y": -28.011827024,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592002,
		"ID": 91,
		"x": -119.1912986847,
		"y": -28.47676909,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592003,
		"ID": 91,
		"x": -121.9152304347,
		"y": -28.870757023,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592008,
		"ID": 91,
		"x": -120.2232717307,
		"y": -28.867795532,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592016,
		"ID": 91,
		"x": -120.9422614917,
		"y": -28.363800745,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592017,
		"ID": 91,
		"x": -120.9052543167,
		"y": -29.468775564,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592018,
		"ID": 91,
		"x": -120.4492483497,
		"y": -27.594829028,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592019,
		"ID": 91,
		"x": -121.1172841167,
		"y": -27.645849104,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592025,
		"ID": 91,
		"x": -119.5392491297,
		"y": -28.92678222,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592030,
		"ID": 91,
		"x": -123.1252751197,
		"y": -27.948839225,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592031,
		"ID": 91,
		"x": -120.0982286557,
		"y": -29.052818985,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592032,
		"ID": 91,
		"x": -122.8222297037,
		"y": -29.034841268,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592033,
		"ID": 91,
		"x": -121.9242613297,
		"y": -29.105791227,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592034,
		"ID": 91,
		"x": -121.7462447437,
		"y": -29.238813327,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592035,
		"ID": 91,
		"x": -122.3952632997,
		"y": -29.448753768,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592047,
		"ID": 91,
		"x": -121.5192578907,
		"y": -28.445831316,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592048,
		"ID": 91,
		"x": -120.1572837357,
		"y": -28.096820406,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592053,
		"ID": 91,
		"x": -121.6452712307,
		"y": -29.06776118,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592054,
		"ID": 91,
		"x": -120.5252427667,
		"y": -27.948808003,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592055,
		"ID": 91,
		"x": -121.5202854727,
		"y": -27.799803491,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592056,
		"ID": 91,
		"x": -122.6272517617,
		"y": -28.307821712,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592057,
		"ID": 91,
		"x": -122.6122617777,
		"y": -28.656835192,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592059,
		"ID": 91,
		"x": -121.3042908397,
		"y": -29.044806034,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592060,
		"ID": 91,
		"x": -122.0622440937,
		"y": -29.359833626,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592063,
		"ID": 91,
		"x": -121.0792327067,
		"y": -28.178859841,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592065,
		"ID": 91,
		"x": -119.7052346967,
		"y": -29.052752147,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592066,
		"ID": 91,
		"x": -120.6842586007,
		"y": -27.879826981,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592067,
		"ID": 91,
		"x": -121.2032263687,
		"y": -28.795816432,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592071,
		"ID": 91,
		"x": -121.5372704457,
		"y": -29.346801478,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592076,
		"ID": 91,
		"x": -122.0162955667,
		"y": -29.042804292,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592078,
		"ID": 91,
		"x": -123.0332706857,
		"y": -29.089764037,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592081,
		"ID": 91,
		"x": -120.7002825747,
		"y": -27.606849989,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592082,
		"ID": 91,
		"x": -121.5172612267,
		"y": -28.70677117,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592085,
		"ID": 91,
		"x": -121.8172405247,
		"y": -28.943809403,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592087,
		"ID": 91,
		"x": -122.8912297477,
		"y": -28.372756132,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592088,
		"ID": 91,
		"x": -122.2542941407,
		"y": -28.38575457,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592089,
		"ID": 91,
		"x": -121.4522905827,
		"y": -27.826850061,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592091,
		"ID": 91,
		"x": -121.3602576157,
		"y": -29.324828799,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592092,
		"ID": 91,
		"x": -121.2882855527,
		"y": -27.759828804,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592094,
		"ID": 91,
		"x": -122.7992709787,
		"y": -28.528806567,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592099,
		"ID": 91,
		"x": -120.3352413767,
		"y": -28.345830182,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592102,
		"ID": 91,
		"x": -123.1302590667,
		"y": -29.453829392,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592104,
		"ID": 91,
		"x": -122.4402613457,
		"y": -29.1577931,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592107,
		"ID": 91,
		"x": -123.1402920257,
		"y": -28.317770972,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592109,
		"ID": 91,
		"x": -122.7072653517,
		"y": -29.544768494,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592111,
		"ID": 91,
		"x": -121.6532601767,
		"y": -28.77085115,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592112,
		"ID": 91,
		"x": -119.8252782867,
		"y": -29.202856627,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592115,
		"ID": 91,
		"x": -120.9772756797,
		"y": -28.780781052,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592116,
		"ID": 91,
		"x": -122.0802307027,
		"y": -28.630806653,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592118,
		"ID": 91,
		"x": -120.3122459377,
		"y": -28.560844851,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592119,
		"ID": 91,
		"x": -122.7152254117,
		"y": -29.359806697,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592120,
		"ID": 91,
		"x": -122.0842317437,
		"y": -29.548819385,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592124,
		"ID": 91,
		"x": -123.2362595587,
		"y": -28.868836319,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592126,
		"ID": 91,
		"x": -120.3642689107,
		"y": -29.245801632,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592127,
		"ID": 91,
		"x": -119.8312400937,
		"y": -28.494859487,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592128,
		"ID": 91,
		"x": -119.6512582787,
		"y": -27.82585075,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592131,
		"ID": 91,
		"x": -120.3622985887,
		"y": -28.89085194,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592132,
		"ID": 91,
		"x": -121.7712945787,
		"y": -28.699817928,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592135,
		"ID": 91,
		"x": -121.8882443527,
		"y": -29.458799741,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592136,
		"ID": 91,
		"x": -120.3682330727,
		"y": -29.501788823,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592137,
		"ID": 91,
		"x": -120.9112456087,
		"y": -27.939775692,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592138,
		"ID": 91,
		"x": -121.4722678057,
		"y": -29.315785844,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592139,
		"ID": 91,
		"x": -121.4592625317,
		"y": -24.005812034,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592140,
		"ID": 91,
		"x": -121.6452976887,
		"y": -26.881796188,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592141,
		"ID": 91,
		"x": -121.4352567577,
		"y": -25.041844916,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592142,
		"ID": 91,
		"x": -121.4282260447,
		"y": -24.506848159,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592143,
		"ID": 91,
		"x": -121.6212827147,
		"y": -27.245796882,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592173,
		"ID": 91,
		"x": -123.6502448897,
		"y": -28.498802793,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592175,
		"ID": 91,
		"x": -123.5662630837,
		"y": -28.024769543,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592176,
		"ID": 91,
		"x": -123.3292734007,
		"y": -27.899768771,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592181,
		"ID": 91,
		"x": -123.4342323287,
		"y": -28.68275152,
		"h": 4.6593406593
	},
	{
		"stop_id": 8592187,
		"ID": 91,
		"x": -123.2252997277,
		"y": -28.085858325,
		"h": 4.6593406593
	},
	{
		"stop_id": 8593249,
		"ID": 91,
		"x": -121.6232787337,
		"y": -27.409754288,
		"h": 4.6593406593
	},
	{
		"stop_id": 8593845,
		"ID": 91,
		"x": -121.3332708237,
		"y": -26.072785265,
		"h": 4.6593406593
	},
	{
		"stop_id": 8595004,
		"ID": 91,
		"x": -121.6692597497,
		"y": -27.814834011,
		"h": 4.6593406593
	},
	{
		"stop_id": 8595005,
		"ID": 91,
		"x": -122.0192781237,
		"y": -27.672806666,
		"h": 4.6593406593
	},
	{
		"stop_id": 8501171,
		"ID": 92,
		"x": -123.0022823037,
		"y": -21.259808757,
		"h": 1.3956043956
	},
	{
		"stop_id": 8501172,
		"ID": 92,
		"x": -122.4122711907,
		"y": -19.809756885,
		"h": 1.3956043956
	},
	{
		"stop_id": 8504178,
		"ID": 92,
		"x": -121.0372941597,
		"y": -23.095748974,
		"h": 1.3956043956
	},
	{
		"stop_id": 8570164,
		"ID": 92,
		"x": -120.7502840417,
		"y": -22.519802608,
		"h": 1.3956043956
	},
	{
		"stop_id": 8570176,
		"ID": 92,
		"x": -120.4102814517,
		"y": -21.502805171,
		"h": 1.3956043956
	},
	{
		"stop_id": 8570177,
		"ID": 92,
		"x": -120.1612803227,
		"y": -20.898765269,
		"h": 1.3956043956
	},
	{
		"stop_id": 8570178,
		"ID": 92,
		"x": -119.3862378497,
		"y": -19.441835066,
		"h": 1.3956043956
	},
	{
		"stop_id": 8570179,
		"ID": 92,
		"x": -118.9072749777,
		"y": -20.587753888,
		"h": 1.3956043956
	},
	{
		"stop_id": 8573634,
		"ID": 92,
		"x": -120.9072652187,
		"y": -22.904859737,
		"h": 1.3956043956
	},
	{
		"stop_id": 8581185,
		"ID": 92,
		"x": -121.9922766627,
		"y": -22.244793984,
		"h": 1.3956043956
	},
	{
		"stop_id": 8581186,
		"ID": 92,
		"x": -121.7692844927,
		"y": -22.373838827,
		"h": 1.3956043956
	},
	{
		"stop_id": 8587727,
		"ID": 92,
		"x": -123.3922744517,
		"y": -22.1298315,
		"h": 1.3956043956
	},
	{
		"stop_id": 8591940,
		"ID": 92,
		"x": -121.2902614157,
		"y": -23.493822969,
		"h": 1.3956043956
	},
	{
		"stop_id": 8501173,
		"ID": 93,
		"x": -121.4622902367,
		"y": -16.889777274,
		"h": 1.7912087912
	},
	{
		"stop_id": 8501174,
		"ID": 93,
		"x": -120.9722825657,
		"y": -16.789854866,
		"h": 1.7912087912
	},
	{
		"stop_id": 8501175,
		"ID": 93,
		"x": -118.9022330967,
		"y": -15.209764174,
		"h": 1.7912087912
	},
	{
		"stop_id": 8501178,
		"ID": 93,
		"x": -120.7222910647,
		"y": -16.489792272,
		"h": 1.7912087912
	},
	{
		"stop_id": 8507970,
		"ID": 93,
		"x": -120.9422852007,
		"y": -15.0967865,
		"h": 1.7912087912
	},
	{
		"stop_id": 8570180,
		"ID": 93,
		"x": -121.5352536447,
		"y": -16.732828792,
		"h": 1.7912087912
	},
	{
		"stop_id": 8570181,
		"ID": 93,
		"x": -121.9042781027,
		"y": -16.787824324,
		"h": 1.7912087912
	},
	{
		"stop_id": 8570182,
		"ID": 93,
		"x": -123.3732784847,
		"y": -17.356848571,
		"h": 1.7912087912
	},
	{
		"stop_id": 8570189,
		"ID": 93,
		"x": -123.7452605457,
		"y": -14.94377741,
		"h": 1.7912087912
	},
	{
		"stop_id": 8570190,
		"ID": 93,
		"x": -123.6252618877,
		"y": -14.802756341,
		"h": 1.7912087912
	},
	{
		"stop_id": 8570201,
		"ID": 93,
		"x": -122.7172533847,
		"y": -15.419812081,
		"h": 1.7912087912
	},
	{
		"stop_id": 8570202,
		"ID": 93,
		"x": -121.8072301997,
		"y": -16.488775706,
		"h": 1.7912087912
	},
	{
		"stop_id": 8570203,
		"ID": 93,
		"x": -121.0582344897,
		"y": -16.793756878,
		"h": 1.7912087912
	},
	{
		"stop_id": 8570204,
		"ID": 93,
		"x": -120.7282733527,
		"y": -16.761769504,
		"h": 1.7912087912
	},
	{
		"stop_id": 8570205,
		"ID": 93,
		"x": -120.4192805267,
		"y": -16.962790726,
		"h": 1.7912087912
	},
	{
		"stop_id": 8570206,
		"ID": 93,
		"x": -119.3322415387,
		"y": -17.199816514,
		"h": 1.7912087912
	},
	{
		"stop_id": 8570238,
		"ID": 93,
		"x": -121.4592661967,
		"y": -16.863794108,
		"h": 1.7912087912
	},
	{
		"stop_id": 8570298,
		"ID": 93,
		"x": -120.3882467157,
		"y": -12.799818099,
		"h": 1.7912087912
	},
	{
		"stop_id": 8570299,
		"ID": 93,
		"x": -120.6002652187,
		"y": -14.719837579,
		"h": 1.7912087912
	},
	{
		"stop_id": 8570300,
		"ID": 93,
		"x": -120.9252501327,
		"y": -14.942764489,
		"h": 1.7912087912
	},
	{
		"stop_id": 8570301,
		"ID": 93,
		"x": -121.0722349377,
		"y": -16.178831654,
		"h": 1.7912087912
	},
	{
		"stop_id": 8580485,
		"ID": 93,
		"x": -120.2422451117,
		"y": -16.962800958,
		"h": 1.7912087912
	},
	{
		"stop_id": 8583231,
		"ID": 93,
		"x": -118.4552661777,
		"y": -15.19481526,
		"h": 1.7912087912
	},
	{
		"stop_id": 8583301,
		"ID": 93,
		"x": -120.9802363067,
		"y": -14.877834207,
		"h": 1.7912087912
	},
	{
		"stop_id": 8583302,
		"ID": 93,
		"x": -121.9582564577,
		"y": -12.893782233,
		"h": 1.7912087912
	},
	{
		"stop_id": 8501176,
		"ID": 106,
		"x": -117.4022986627,
		"y": -13.059757213,
		"h": 1.5604395604
	},
	{
		"stop_id": 8501177,
		"ID": 106,
		"x": -115.9622760417,
		"y": -11.009763487,
		"h": 1.5604395604
	},
	{
		"stop_id": 8504759,
		"ID": 106,
		"x": -118.2082947907,
		"y": -10.048854999,
		"h": 1.5604395604
	},
	{
		"stop_id": 8507663,
		"ID": 106,
		"x": -115.0812240457,
		"y": -13.960788354,
		"h": 1.5604395604
	},
	{
		"stop_id": 8507959,
		"ID": 106,
		"x": -116.7662573167,
		"y": -10.930790436,
		"h": 1.5604395604
	},
	{
		"stop_id": 8570220,
		"ID": 106,
		"x": -116.5672316527,
		"y": -14.820799879,
		"h": 1.5604395604
	},
	{
		"stop_id": 8570221,
		"ID": 106,
		"x": -115.7422995037,
		"y": -14.294831171,
		"h": 1.5604395604
	},
	{
		"stop_id": 8570222,
		"ID": 106,
		"x": -114.3382412507,
		"y": -12.742830521,
		"h": 1.5604395604
	},
	{
		"stop_id": 8570223,
		"ID": 106,
		"x": -114.7372878547,
		"y": -12.418784679,
		"h": 1.5604395604
	},
	{
		"stop_id": 8570305,
		"ID": 106,
		"x": -117.8222638037,
		"y": -10.409807438,
		"h": 1.5604395604
	},
	{
		"stop_id": 8570306,
		"ID": 106,
		"x": -116.5422435317,
		"y": -11.039755222,
		"h": 1.5604395604
	},
	{
		"stop_id": 8570307,
		"ID": 106,
		"x": -115.9812782297,
		"y": -11.053831439,
		"h": 1.5604395604
	},
	{
		"stop_id": 8570351,
		"ID": 106,
		"x": -113.5732683727,
		"y": -11.819806031,
		"h": 1.5604395604
	},
	{
		"stop_id": 8570395,
		"ID": 106,
		"x": -115.3462295387,
		"y": -11.08077229,
		"h": 1.5604395604
	},
	{
		"stop_id": 8580462,
		"ID": 106,
		"x": -115.6212335127,
		"y": -11.080769807,
		"h": 1.5604395604
	},
	{
		"stop_id": 8580578,
		"ID": 106,
		"x": -115.2462733937,
		"y": -10.769751866,
		"h": 1.5604395604
	},
	{
		"stop_id": 8582403,
		"ID": 106,
		"x": -115.8142818167,
		"y": -11.27384958,
		"h": 1.5604395604
	},
	{
		"stop_id": 8583400,
		"ID": 106,
		"x": -116.2622911117,
		"y": -14.878824503,
		"h": 1.5604395604
	},
	{
		"stop_id": 8501179,
		"ID": 190,
		"x": -94.5642936677,
		"y": -52.639808295,
		"h": 2.2197802198
	},
	{
		"stop_id": 8501400,
		"ID": 190,
		"x": -96.3262282387,
		"y": -52.964760867,
		"h": 2.2197802198
	},
	{
		"stop_id": 8501459,
		"ID": 190,
		"x": -95.4022607997,
		"y": -54.612793385,
		"h": 2.2197802198
	},
	{
		"stop_id": 8501468,
		"ID": 190,
		"x": -95.0262284017,
		"y": -53.026761817,
		"h": 2.2197802198
	},
	{
		"stop_id": 8501470,
		"ID": 190,
		"x": -94.7922797387,
		"y": -53.937807153,
		"h": 2.2197802198
	},
	{
		"stop_id": 8501484,
		"ID": 190,
		"x": -95.4242530667,
		"y": -52.809754573,
		"h": 2.2197802198
	},
	{
		"stop_id": 8501485,
		"ID": 190,
		"x": -94.8902421347,
		"y": -52.809780189,
		"h": 2.2197802198
	},
	{
		"stop_id": 8501554,
		"ID": 190,
		"x": -95.8122925897,
		"y": -52.923836526,
		"h": 2.2197802198
	},
	{
		"stop_id": 8504660,
		"ID": 190,
		"x": -96.3512283667,
		"y": -51.133796202,
		"h": 2.2197802198
	},
	{
		"stop_id": 8504661,
		"ID": 190,
		"x": -96.5482389037,
		"y": -50.055830222,
		"h": 2.2197802198
	},
	{
		"stop_id": 8517484,
		"ID": 190,
		"x": -94.5902550807,
		"y": -53.146802233,
		"h": 2.2197802198
	},
	{
		"stop_id": 8530335,
		"ID": 190,
		"x": -96.1472701157,
		"y": -53.674757847,
		"h": 2.2197802198
	},
	{
		"stop_id": 8570600,
		"ID": 190,
		"x": -96.2552911537,
		"y": -53.041785271,
		"h": 2.2197802198
	},
	{
		"stop_id": 8570601,
		"ID": 190,
		"x": -95.8222927997,
		"y": -52.908769097,
		"h": 2.2197802198
	},
	{
		"stop_id": 8570602,
		"ID": 190,
		"x": -96.4922627907,
		"y": -51.569824774,
		"h": 2.2197802198
	},
	{
		"stop_id": 8570603,
		"ID": 190,
		"x": -96.6792443747,
		"y": -51.331784052,
		"h": 2.2197802198
	},
	{
		"stop_id": 8570604,
		"ID": 190,
		"x": -96.2502732857,
		"y": -50.802797058,
		"h": 2.2197802198
	},
	{
		"stop_id": 8570616,
		"ID": 190,
		"x": -99.2702918577,
		"y": -52.814771842,
		"h": 2.2197802198
	},
	{
		"stop_id": 8579380,
		"ID": 190,
		"x": -99.2172930127,
		"y": -52.719848579,
		"h": 2.2197802198
	},
	{
		"stop_id": 8579381,
		"ID": 190,
		"x": -99.0922970047,
		"y": -53.559758562,
		"h": 2.2197802198
	},
	{
		"stop_id": 8581046,
		"ID": 190,
		"x": -96.6392472907,
		"y": -52.785763201,
		"h": 2.2197802198
	},
	{
		"stop_id": 8581047,
		"ID": 190,
		"x": -97.0452696447,
		"y": -52.951793397,
		"h": 2.2197802198
	},
	{
		"stop_id": 8581048,
		"ID": 190,
		"x": -97.4512436677,
		"y": -53.118797245,
		"h": 2.2197802198
	},
	{
		"stop_id": 8581049,
		"ID": 190,
		"x": -98.0882697897,
		"y": -53.1668045,
		"h": 2.2197802198
	},
	{
		"stop_id": 8581050,
		"ID": 190,
		"x": -98.3362284917,
		"y": -52.709768873,
		"h": 2.2197802198
	},
	{
		"stop_id": 8582438,
		"ID": 190,
		"x": -98.7422852827,
		"y": -54.374778925,
		"h": 2.2197802198
	},
	{
		"stop_id": 8583404,
		"ID": 190,
		"x": -96.8852544407,
		"y": -50.21084099,
		"h": 2.2197802198
	},
	{
		"stop_id": 8583765,
		"ID": 190,
		"x": -96.3752765097,
		"y": -49.820765416,
		"h": 2.2197802198
	},
	{
		"stop_id": 8587746,
		"ID": 190,
		"x": -96.9572918397,
		"y": -51.577753801,
		"h": 2.2197802198
	},
	{
		"stop_id": 8593763,
		"ID": 190,
		"x": -96.2272898807,
		"y": -52.818842252,
		"h": 2.2197802198
	},
	{
		"stop_id": 8593764,
		"ID": 190,
		"x": -96.5822382987,
		"y": -52.56978049,
		"h": 2.2197802198
	},
	{
		"stop_id": 8593765,
		"ID": 190,
		"x": -97.8852906797,
		"y": -53.518825585,
		"h": 2.2197802198
	},
	{
		"stop_id": 8593766,
		"ID": 190,
		"x": -96.6962941647,
		"y": -53.308789171,
		"h": 2.2197802198
	},
	{
		"stop_id": 8593768,
		"ID": 190,
		"x": -96.3352776027,
		"y": -53.50375583,
		"h": 2.2197802198
	},
	{
		"stop_id": 8593769,
		"ID": 190,
		"x": -96.4002492417,
		"y": -53.217772383,
		"h": 2.2197802198
	},
	{
		"stop_id": 8593770,
		"ID": 190,
		"x": -96.7462369327,
		"y": -52.384793907,
		"h": 2.2197802198
	},
	{
		"stop_id": 8593771,
		"ID": 190,
		"x": -97.0322768077,
		"y": -52.457846319,
		"h": 2.2197802198
	},
	{
		"stop_id": 8595963,
		"ID": 190,
		"x": -96.5032310477,
		"y": -51.890808817,
		"h": 2.2197802198
	},
	{
		"stop_id": 8501198,
		"ID": 291,
		"x": -82.5472568977,
		"y": -35.310824118,
		"h": 1.032967033
	},
	{
		"stop_id": 8501388,
		"ID": 291,
		"x": -80.2322377647,
		"y": -35.184775293,
		"h": 1.032967033
	},
	{
		"stop_id": 8501199,
		"ID": 223,
		"x": -93.4052694317,
		"y": -51.372755654,
		"h": 2.2857142857
	},
	{
		"stop_id": 8501330,
		"ID": 223,
		"x": -92.4672380777,
		"y": -49.979779799,
		"h": 2.2857142857
	},
	{
		"stop_id": 8501467,
		"ID": 223,
		"x": -92.1682736407,
		"y": -49.575749455,
		"h": 2.2857142857
	},
	{
		"stop_id": 8501469,
		"ID": 223,
		"x": -90.0122791127,
		"y": -50.077774045,
		"h": 2.2857142857
	},
	{
		"stop_id": 8501471,
		"ID": 223,
		"x": -91.6752605577,
		"y": -51.823840472,
		"h": 2.2857142857
	},
	{
		"stop_id": 8501472,
		"ID": 223,
		"x": -90.5522280537,
		"y": -50.744814318,
		"h": 2.2857142857
	},
	{
		"stop_id": 8501473,
		"ID": 223,
		"x": -89.2502265887,
		"y": -48.723769494,
		"h": 2.2857142857
	},
	{
		"stop_id": 8501474,
		"ID": 223,
		"x": -89.4372645397,
		"y": -48.067856822,
		"h": 2.2857142857
	},
	{
		"stop_id": 8501480,
		"ID": 223,
		"x": -93.4542434697,
		"y": -51.812813875,
		"h": 2.2857142857
	},
	{
		"stop_id": 8501481,
		"ID": 223,
		"x": -93.0482502327,
		"y": -50.491853001,
		"h": 2.2857142857
	},
	{
		"stop_id": 8501482,
		"ID": 223,
		"x": -92.8672295957,
		"y": -49.916784787,
		"h": 2.2857142857
	},
	{
		"stop_id": 8501483,
		"ID": 223,
		"x": -93.0152840617,
		"y": -49.792795785,
		"h": 2.2857142857
	},
	{
		"stop_id": 8501486,
		"ID": 223,
		"x": -93.2802241057,
		"y": -48.236768872,
		"h": 2.2857142857
	},
	{
		"stop_id": 8501725,
		"ID": 223,
		"x": -92.9772508957,
		"y": -50.252791819,
		"h": 2.2857142857
	},
	{
		"stop_id": 8501974,
		"ID": 223,
		"x": -92.8222472667,
		"y": -49.884793654,
		"h": 2.2857142857
	},
	{
		"stop_id": 8501975,
		"ID": 223,
		"x": -89.4502265727,
		"y": -48.058788375,
		"h": 2.2857142857
	},
	{
		"stop_id": 8570615,
		"ID": 223,
		"x": -91.3022556887,
		"y": -52.242792531,
		"h": 2.2857142857
	},
	{
		"stop_id": 8570626,
		"ID": 223,
		"x": -90.1712467597,
		"y": -48.490848365,
		"h": 2.2857142857
	},
	{
		"stop_id": 8570627,
		"ID": 223,
		"x": -90.8592981077,
		"y": -48.957788366,
		"h": 2.2857142857
	},
	{
		"stop_id": 8570628,
		"ID": 223,
		"x": -91.0792318527,
		"y": -49.256797597,
		"h": 2.2857142857
	},
	{
		"stop_id": 8570629,
		"ID": 223,
		"x": -91.4572251477,
		"y": -49.729833707,
		"h": 2.2857142857
	},
	{
		"stop_id": 8570630,
		"ID": 223,
		"x": -92.3982395707,
		"y": -50.132786319,
		"h": 2.2857142857
	},
	{
		"stop_id": 8570631,
		"ID": 223,
		"x": -92.1782349507,
		"y": -49.6957559,
		"h": 2.2857142857
	},
	{
		"stop_id": 8570632,
		"ID": 223,
		"x": -89.2492824917,
		"y": -48.813818963,
		"h": 2.2857142857
	},
	{
		"stop_id": 8570633,
		"ID": 223,
		"x": -89.6512331047,
		"y": -49.479834904,
		"h": 2.2857142857
	},
	{
		"stop_id": 8570634,
		"ID": 223,
		"x": -89.6172940867,
		"y": -50.024830475,
		"h": 2.2857142857
	},
	{
		"stop_id": 8570635,
		"ID": 223,
		"x": -89.3992799167,
		"y": -49.621818054,
		"h": 2.2857142857
	},
	{
		"stop_id": 8570636,
		"ID": 223,
		"x": -88.9102272727,
		"y": -49.371859415,
		"h": 2.2857142857
	},
	{
		"stop_id": 8595098,
		"ID": 223,
		"x": -92.0022640247,
		"y": -50.24475317,
		"h": 2.2857142857
	},
	{
		"stop_id": 8595100,
		"ID": 223,
		"x": -92.8522766377,
		"y": -50.389770677,
		"h": 2.2857142857
	},
	{
		"stop_id": 8595101,
		"ID": 223,
		"x": -92.6072502587,
		"y": -50.284837227,
		"h": 2.2857142857
	},
	{
		"stop_id": 8595102,
		"ID": 223,
		"x": -91.8472630687,
		"y": -48.869782149,
		"h": 2.2857142857
	},
	{
		"stop_id": 8595103,
		"ID": 223,
		"x": -91.5922567367,
		"y": -48.754856132,
		"h": 2.2857142857
	},
	{
		"stop_id": 8595104,
		"ID": 223,
		"x": -91.8472372647,
		"y": -49.12479873,
		"h": 2.2857142857
	},
	{
		"stop_id": 8595105,
		"ID": 223,
		"x": -92.9672969267,
		"y": -50.234837711,
		"h": 2.2857142857
	},
	{
		"stop_id": 8595106,
		"ID": 223,
		"x": -93.3772813137,
		"y": -50.359848182,
		"h": 2.2857142857
	},
	{
		"stop_id": 8595107,
		"ID": 223,
		"x": -93.1872700957,
		"y": -50.194822988,
		"h": 2.2857142857
	},
	{
		"stop_id": 8595108,
		"ID": 223,
		"x": -92.8672242017,
		"y": -49.789832306,
		"h": 2.2857142857
	},
	{
		"stop_id": 8595109,
		"ID": 223,
		"x": -93.1172798567,
		"y": -49.929855968,
		"h": 2.2857142857
	},
	{
		"stop_id": 8595110,
		"ID": 223,
		"x": -92.6372652277,
		"y": -49.859793855,
		"h": 2.2857142857
	},
	{
		"stop_id": 8501221,
		"ID": 162,
		"x": -99.0672715717,
		"y": -57.259801595,
		"h": 1.5604395604
	},
	{
		"stop_id": 8501423,
		"ID": 162,
		"x": -99.9842790617,
		"y": -53.14377261,
		"h": 1.5604395604
	},
	{
		"stop_id": 8504663,
		"ID": 162,
		"x": -101.2382353927,
		"y": -53.57883076,
		"h": 1.5604395604
	},
	{
		"stop_id": 8504664,
		"ID": 162,
		"x": -101.7082451507,
		"y": -53.835821392,
		"h": 1.5604395604
	},
	{
		"stop_id": 8504665,
		"ID": 162,
		"x": -101.9492564217,
		"y": -54.038799142,
		"h": 1.5604395604
	},
	{
		"stop_id": 8504666,
		"ID": 162,
		"x": -102.2062490377,
		"y": -53.784754602,
		"h": 1.5604395604
	},
	{
		"stop_id": 8504667,
		"ID": 162,
		"x": -102.8022506787,
		"y": -53.271822677,
		"h": 1.5604395604
	},
	{
		"stop_id": 8504668,
		"ID": 162,
		"x": -102.8252599587,
		"y": -53.063774109,
		"h": 1.5604395604
	},
	{
		"stop_id": 8570617,
		"ID": 162,
		"x": -100.0032293377,
		"y": -53.120856702,
		"h": 1.5604395604
	},
	{
		"stop_id": 8579369,
		"ID": 162,
		"x": -101.3162518887,
		"y": -53.173753561,
		"h": 1.5604395604
	},
	{
		"stop_id": 8579371,
		"ID": 162,
		"x": -100.6022615867,
		"y": -54.344784903,
		"h": 1.5604395604
	},
	{
		"stop_id": 8579372,
		"ID": 162,
		"x": -100.2872794387,
		"y": -55.819772514,
		"h": 1.5604395604
	},
	{
		"stop_id": 8579373,
		"ID": 162,
		"x": -99.3532250067,
		"y": -56.93976867,
		"h": 1.5604395604
	},
	{
		"stop_id": 8580654,
		"ID": 162,
		"x": -102.6352818857,
		"y": -53.092809608,
		"h": 1.5604395604
	},
	{
		"stop_id": 8580655,
		"ID": 162,
		"x": -102.7602363297,
		"y": -53.558824906,
		"h": 1.5604395604
	},
	{
		"stop_id": 8582426,
		"ID": 162,
		"x": -99.7172777467,
		"y": -56.534828635,
		"h": 1.5604395604
	},
	{
		"stop_id": 8582439,
		"ID": 162,
		"x": -98.4192967227,
		"y": -55.849829108,
		"h": 1.5604395604
	},
	{
		"stop_id": 8583750,
		"ID": 162,
		"x": -98.9452440467,
		"y": -56.582807004,
		"h": 1.5604395604
	},
	{
		"stop_id": 8501229,
		"ID": 189,
		"x": -97.7332602437,
		"y": -59.24980124,
		"h": 2.3846153846
	},
	{
		"stop_id": 8501421,
		"ID": 189,
		"x": -97.0192637447,
		"y": -59.763846626,
		"h": 2.3846153846
	},
	{
		"stop_id": 8501422,
		"ID": 189,
		"x": -97.5072802587,
		"y": -58.033824725,
		"h": 2.3846153846
	},
	{
		"stop_id": 8501452,
		"ID": 189,
		"x": -95.5772643467,
		"y": -57.262759916,
		"h": 2.3846153846
	},
	{
		"stop_id": 8501457,
		"ID": 189,
		"x": -98.1372561947,
		"y": -60.175826852,
		"h": 2.3846153846
	},
	{
		"stop_id": 8501462,
		"ID": 189,
		"x": -97.7182844957,
		"y": -58.144779195,
		"h": 2.3846153846
	},
	{
		"stop_id": 8501463,
		"ID": 189,
		"x": -97.6152551877,
		"y": -59.932778325,
		"h": 2.3846153846
	},
	{
		"stop_id": 8501726,
		"ID": 189,
		"x": -97.2992255567,
		"y": -57.92484559,
		"h": 2.3846153846
	},
	{
		"stop_id": 8530366,
		"ID": 189,
		"x": -96.4992966497,
		"y": -57.487771877,
		"h": 2.3846153846
	},
	{
		"stop_id": 8575520,
		"ID": 189,
		"x": -98.6222291687,
		"y": -60.039765148,
		"h": 2.3846153846
	},
	{
		"stop_id": 8579033,
		"ID": 189,
		"x": -97.6312364377,
		"y": -59.984815579,
		"h": 2.3846153846
	},
	{
		"stop_id": 8579041,
		"ID": 189,
		"x": -97.9642642447,
		"y": -60.879837877,
		"h": 2.3846153846
	},
	{
		"stop_id": 8579049,
		"ID": 189,
		"x": -98.1202319787,
		"y": -60.178825505,
		"h": 2.3846153846
	},
	{
		"stop_id": 8579050,
		"ID": 189,
		"x": -98.3772317277,
		"y": -60.654761817,
		"h": 2.3846153846
	},
	{
		"stop_id": 8579061,
		"ID": 189,
		"x": -97.0572406437,
		"y": -59.769837259,
		"h": 2.3846153846
	},
	{
		"stop_id": 8579374,
		"ID": 189,
		"x": -98.7722328457,
		"y": -57.228812315,
		"h": 2.3846153846
	},
	{
		"stop_id": 8579375,
		"ID": 189,
		"x": -97.7052903097,
		"y": -58.419778228,
		"h": 2.3846153846
	},
	{
		"stop_id": 8579382,
		"ID": 189,
		"x": -97.5662249967,
		"y": -57.094757297,
		"h": 2.3846153846
	},
	{
		"stop_id": 8579383,
		"ID": 189,
		"x": -97.3932941237,
		"y": -57.643783665,
		"h": 2.3846153846
	},
	{
		"stop_id": 8579384,
		"ID": 189,
		"x": -97.3382687167,
		"y": -57.905815068,
		"h": 2.3846153846
	},
	{
		"stop_id": 8579386,
		"ID": 189,
		"x": -97.6372698177,
		"y": -58.121832335,
		"h": 2.3846153846
	},
	{
		"stop_id": 8579387,
		"ID": 189,
		"x": -97.8292403707,
		"y": -57.683846171,
		"h": 2.3846153846
	},
	{
		"stop_id": 8579972,
		"ID": 189,
		"x": -96.9802548727,
		"y": -60.402855865,
		"h": 2.3846153846
	},
	{
		"stop_id": 8579973,
		"ID": 189,
		"x": -97.3212420507,
		"y": -59.949846517,
		"h": 2.3846153846
	},
	{
		"stop_id": 8580410,
		"ID": 189,
		"x": -97.0852543967,
		"y": -59.947754261,
		"h": 2.3846153846
	},
	{
		"stop_id": 8580767,
		"ID": 189,
		"x": -96.7272421887,
		"y": -60.645756505,
		"h": 2.3846153846
	},
	{
		"stop_id": 8582424,
		"ID": 189,
		"x": -97.4672728777,
		"y": -57.294811452,
		"h": 2.3846153846
	},
	{
		"stop_id": 8582425,
		"ID": 189,
		"x": -98.0972891627,
		"y": -57.419792321,
		"h": 2.3846153846
	},
	{
		"stop_id": 8582434,
		"ID": 189,
		"x": -98.3322589507,
		"y": -60.134784957,
		"h": 2.3846153846
	},
	{
		"stop_id": 8582710,
		"ID": 189,
		"x": -97.6862844137,
		"y": -59.283780617,
		"h": 2.3846153846
	},
	{
		"stop_id": 8583381,
		"ID": 189,
		"x": -97.5172654637,
		"y": -60.441761768,
		"h": 2.3846153846
	},
	{
		"stop_id": 8583382,
		"ID": 189,
		"x": -97.0292799027,
		"y": -59.013849017,
		"h": 2.3846153846
	},
	{
		"stop_id": 8583385,
		"ID": 189,
		"x": -97.7512842217,
		"y": -59.503816732,
		"h": 2.3846153846
	},
	{
		"stop_id": 8583386,
		"ID": 189,
		"x": -97.4372447717,
		"y": -59.15082901,
		"h": 2.3846153846
	},
	{
		"stop_id": 8583387,
		"ID": 189,
		"x": -98.7352324347,
		"y": -56.89477068,
		"h": 2.3846153846
	},
	{
		"stop_id": 8583388,
		"ID": 189,
		"x": -98.5642784707,
		"y": -57.134772591,
		"h": 2.3846153846
	},
	{
		"stop_id": 8583389,
		"ID": 189,
		"x": -97.0482301037,
		"y": -58.71180107,
		"h": 2.3846153846
	},
	{
		"stop_id": 8583543,
		"ID": 189,
		"x": -98.4652237517,
		"y": -57.265808895,
		"h": 2.3846153846
	},
	{
		"stop_id": 8583666,
		"ID": 189,
		"x": -97.9972338897,
		"y": -56.54476132,
		"h": 2.3846153846
	},
	{
		"stop_id": 8583718,
		"ID": 189,
		"x": -97.3052650717,
		"y": -59.600768851,
		"h": 2.3846153846
	},
	{
		"stop_id": 8583719,
		"ID": 189,
		"x": -97.6532467087,
		"y": -60.161767256,
		"h": 2.3846153846
	},
	{
		"stop_id": 8583720,
		"ID": 189,
		"x": -97.0772955447,
		"y": -59.39685748,
		"h": 2.3846153846
	},
	{
		"stop_id": 8583721,
		"ID": 189,
		"x": -97.1462885537,
		"y": -60.525780764,
		"h": 2.3846153846
	},
	{
		"stop_id": 8501231,
		"ID": 32,
		"x": -153.5672482107,
		"y": -56.611777912,
		"h": 1.6593406593
	},
	{
		"stop_id": 8501239,
		"ID": 32,
		"x": -151.9712440777,
		"y": -54.061817267,
		"h": 1.6593406593
	},
	{
		"stop_id": 8587029,
		"ID": 32,
		"x": -153.4232789417,
		"y": -56.78778551,
		"h": 1.6593406593
	},
	{
		"stop_id": 8587067,
		"ID": 32,
		"x": -151.7762660317,
		"y": -54.135836546,
		"h": 1.6593406593
	},
	{
		"stop_id": 8592621,
		"ID": 32,
		"x": -152.9482307457,
		"y": -56.097826518,
		"h": 1.6593406593
	},
	{
		"stop_id": 8592622,
		"ID": 32,
		"x": -152.5732720337,
		"y": -55.719816299,
		"h": 1.6593406593
	},
	{
		"stop_id": 8592623,
		"ID": 32,
		"x": -153.1142311517,
		"y": -56.359754932,
		"h": 1.6593406593
	},
	{
		"stop_id": 8592624,
		"ID": 32,
		"x": -152.3042341027,
		"y": -57.753839544,
		"h": 1.6593406593
	},
	{
		"stop_id": 8592625,
		"ID": 32,
		"x": -152.3412263297,
		"y": -55.475786255,
		"h": 1.6593406593
	},
	{
		"stop_id": 8592626,
		"ID": 32,
		"x": -153.6332416367,
		"y": -57.236798759,
		"h": 1.6593406593
	},
	{
		"stop_id": 8592761,
		"ID": 32,
		"x": -152.6852716187,
		"y": -57.372760073,
		"h": 1.6593406593
	},
	{
		"stop_id": 8592957,
		"ID": 32,
		"x": -151.8552917987,
		"y": -54.67384449,
		"h": 1.6593406593
	},
	{
		"stop_id": 8592958,
		"ID": 32,
		"x": -152.0572902207,
		"y": -55.057769384,
		"h": 1.6593406593
	},
	{
		"stop_id": 8593219,
		"ID": 32,
		"x": -151.6142867327,
		"y": -56.849824974,
		"h": 1.6593406593
	},
	{
		"stop_id": 8593241,
		"ID": 32,
		"x": -150.7632480907,
		"y": -57.696770406,
		"h": 1.6593406593
	},
	{
		"stop_id": 8595008,
		"ID": 32,
		"x": -152.8932454707,
		"y": -56.610762804,
		"h": 1.6593406593
	},
	{
		"stop_id": 8595009,
		"ID": 32,
		"x": -152.4272737367,
		"y": -56.18078107,
		"h": 1.6593406593
	},
	{
		"stop_id": 8595010,
		"ID": 32,
		"x": -153.0902863897,
		"y": -57.034756021,
		"h": 1.6593406593
	},
	{
		"stop_id": 8595016,
		"ID": 32,
		"x": -152.1692984207,
		"y": -55.990841318,
		"h": 1.6593406593
	},
	{
		"stop_id": 8595049,
		"ID": 32,
		"x": -150.6952866707,
		"y": -57.32079049,
		"h": 1.6593406593
	},
	{
		"stop_id": 8595050,
		"ID": 32,
		"x": -150.7242508437,
		"y": -56.950799135,
		"h": 1.6593406593
	},
	{
		"stop_id": 8501234,
		"ID": 192,
		"x": -98.9122730987,
		"y": -42.271761322,
		"h": 1.7252747253
	},
	{
		"stop_id": 8501301,
		"ID": 192,
		"x": -99.4022310067,
		"y": -40.768790068,
		"h": 1.7252747253
	},
	{
		"stop_id": 8501302,
		"ID": 192,
		"x": -99.0122583947,
		"y": -41.745843063,
		"h": 1.7252747253
	},
	{
		"stop_id": 8501313,
		"ID": 192,
		"x": -99.4322449567,
		"y": -40.843852572,
		"h": 1.7252747253
	},
	{
		"stop_id": 8501357,
		"ID": 192,
		"x": -97.4552718507,
		"y": -39.892750862,
		"h": 1.7252747253
	},
	{
		"stop_id": 8501361,
		"ID": 192,
		"x": -98.9572926057,
		"y": -40.602843579,
		"h": 1.7252747253
	},
	{
		"stop_id": 8501362,
		"ID": 192,
		"x": -98.8932525447,
		"y": -40.530779501,
		"h": 1.7252747253
	},
	{
		"stop_id": 8501363,
		"ID": 192,
		"x": -98.6222998647,
		"y": -39.699781177,
		"h": 1.7252747253
	},
	{
		"stop_id": 8501364,
		"ID": 192,
		"x": -97.6922988167,
		"y": -40.13482764,
		"h": 1.7252747253
	},
	{
		"stop_id": 8501365,
		"ID": 192,
		"x": -96.8842271987,
		"y": -39.809816491,
		"h": 1.7252747253
	},
	{
		"stop_id": 8501366,
		"ID": 192,
		"x": -96.3202581477,
		"y": -39.522793164,
		"h": 1.7252747253
	},
	{
		"stop_id": 8501367,
		"ID": 192,
		"x": -95.2342922837,
		"y": -39.13176724,
		"h": 1.7252747253
	},
	{
		"stop_id": 8501368,
		"ID": 192,
		"x": -95.3672620847,
		"y": -39.679813085,
		"h": 1.7252747253
	},
	{
		"stop_id": 8501369,
		"ID": 192,
		"x": -95.0692320287,
		"y": -40.206835939,
		"h": 1.7252747253
	},
	{
		"stop_id": 8501371,
		"ID": 192,
		"x": -98.1822555657,
		"y": -40.247775013,
		"h": 1.7252747253
	},
	{
		"stop_id": 8530673,
		"ID": 192,
		"x": -99.3452891687,
		"y": -40.771833231,
		"h": 1.7252747253
	},
	{
		"stop_id": 8592618,
		"ID": 192,
		"x": -99.3382684747,
		"y": -40.557770688,
		"h": 1.7252747253
	},
	{
		"stop_id": 8593947,
		"ID": 192,
		"x": -99.3782978687,
		"y": -40.764834608,
		"h": 1.7252747253
	},
	{
		"stop_id": 8593948,
		"ID": 192,
		"x": -99.1862613707,
		"y": -41.114829483,
		"h": 1.7252747253
	},
	{
		"stop_id": 8594005,
		"ID": 192,
		"x": -99.1792580357,
		"y": -41.324759734,
		"h": 1.7252747253
	},
	{
		"stop_id": 8594006,
		"ID": 192,
		"x": -98.9442757027,
		"y": -42.12080976,
		"h": 1.7252747253
	},
	{
		"stop_id": 8594007,
		"ID": 192,
		"x": -98.9722728547,
		"y": -41.638827264,
		"h": 1.7252747253
	},
	{
		"stop_id": 8594008,
		"ID": 192,
		"x": -98.7512253187,
		"y": -42.609756226,
		"h": 1.7252747253
	},
	{
		"stop_id": 8501236,
		"ID": 21,
		"x": -158.8272495357,
		"y": -64.65079857,
		"h": 5.3186813187
	},
	{
		"stop_id": 8501237,
		"ID": 21,
		"x": -159.2792562397,
		"y": -64.446806745,
		"h": 5.3186813187
	},
	{
		"stop_id": 8501238,
		"ID": 21,
		"x": -159.1162792577,
		"y": -64.280827048,
		"h": 5.3186813187
	},
	{
		"stop_id": 8501311,
		"ID": 21,
		"x": -158.2492923997,
		"y": -64.242761282,
		"h": 5.3186813187
	},
	{
		"stop_id": 8519458,
		"ID": 21,
		"x": -158.0562506867,
		"y": -65.26375798,
		"h": 5.3186813187
	},
	{
		"stop_id": 8530699,
		"ID": 21,
		"x": -159.3422380077,
		"y": -64.769749553,
		"h": 5.3186813187
	},
	{
		"stop_id": 8530700,
		"ID": 21,
		"x": -158.7422611417,
		"y": -64.669757318,
		"h": 5.3186813187
	},
	{
		"stop_id": 8530701,
		"ID": 21,
		"x": -158.9422579807,
		"y": -63.069817722,
		"h": 5.3186813187
	},
	{
		"stop_id": 8530707,
		"ID": 21,
		"x": -159.1422656247,
		"y": -64.269837699,
		"h": 5.3186813187
	},
	{
		"stop_id": 8587042,
		"ID": 21,
		"x": -155.4412310467,
		"y": -63.239777066,
		"h": 5.3186813187
	},
	{
		"stop_id": 8587046,
		"ID": 21,
		"x": -156.6142676877,
		"y": -63.344833891,
		"h": 5.3186813187
	},
	{
		"stop_id": 8587047,
		"ID": 21,
		"x": -156.5462514827,
		"y": -63.916831124,
		"h": 5.3186813187
	},
	{
		"stop_id": 8587056,
		"ID": 21,
		"x": -157.1652446107,
		"y": -66.023752432,
		"h": 5.3186813187
	},
	{
		"stop_id": 8587059,
		"ID": 21,
		"x": -157.4612347137,
		"y": -63.986828825,
		"h": 5.3186813187
	},
	{
		"stop_id": 8587061,
		"ID": 21,
		"x": -158.9892295727,
		"y": -65.042832305,
		"h": 5.3186813187
	},
	{
		"stop_id": 8587069,
		"ID": 21,
		"x": -155.0002273657,
		"y": -61.460761198,
		"h": 5.3186813187
	},
	{
		"stop_id": 8587094,
		"ID": 21,
		"x": -155.0912654797,
		"y": -62.932783072,
		"h": 5.3186813187
	},
	{
		"stop_id": 8587384,
		"ID": 21,
		"x": -156.9242709317,
		"y": -64.606751385,
		"h": 5.3186813187
	},
	{
		"stop_id": 8587385,
		"ID": 21,
		"x": -156.4592307277,
		"y": -63.142857263,
		"h": 5.3186813187
	},
	{
		"stop_id": 8587900,
		"ID": 21,
		"x": -157.3742806157,
		"y": -67.010772918,
		"h": 5.3186813187
	},
	{
		"stop_id": 8588310,
		"ID": 21,
		"x": -155.9682755437,
		"y": -66.359779577,
		"h": 5.3186813187
	},
	{
		"stop_id": 8588813,
		"ID": 21,
		"x": -157.4412555397,
		"y": -63.939789096,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592691,
		"ID": 21,
		"x": -157.6762879957,
		"y": -66.704814455,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592693,
		"ID": 21,
		"x": -155.6152524157,
		"y": -64.611752657,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592694,
		"ID": 21,
		"x": -156.8682249507,
		"y": -65.413816867,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592695,
		"ID": 21,
		"x": -156.0532632187,
		"y": -64.816810275,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592696,
		"ID": 21,
		"x": -155.6872364387,
		"y": -65.100800972,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592697,
		"ID": 21,
		"x": -155.3842859347,
		"y": -64.786849493,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592698,
		"ID": 21,
		"x": -156.3862528477,
		"y": -65.761749438,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592699,
		"ID": 21,
		"x": -156.1812950347,
		"y": -65.627825995,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592700,
		"ID": 21,
		"x": -155.2552542807,
		"y": -64.544850677,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592701,
		"ID": 21,
		"x": -156.7622912677,
		"y": -66.163757737,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592703,
		"ID": 21,
		"x": -156.3442556897,
		"y": -64.843854023,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592704,
		"ID": 21,
		"x": -156.4032684167,
		"y": -66.386752264,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592705,
		"ID": 21,
		"x": -155.8182789257,
		"y": -64.704811107,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592706,
		"ID": 21,
		"x": -156.4622403837,
		"y": -65.482807547,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592707,
		"ID": 21,
		"x": -155.5782476847,
		"y": -65.325777822,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592708,
		"ID": 21,
		"x": -155.7552519537,
		"y": -65.567787003,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592709,
		"ID": 21,
		"x": -155.6272784937,
		"y": -65.973843957,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592711,
		"ID": 21,
		"x": -155.0922882127,
		"y": -64.866841214,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592713,
		"ID": 21,
		"x": -155.9392983717,
		"y": -65.81479349,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592714,
		"ID": 21,
		"x": -154.8392348837,
		"y": -64.728850928,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592715,
		"ID": 21,
		"x": -155.3362725867,
		"y": -65.123815252,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592716,
		"ID": 21,
		"x": -155.9712511047,
		"y": -66.182845465,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592718,
		"ID": 21,
		"x": -153.9212970007,
		"y": -63.066752983,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592731,
		"ID": 21,
		"x": -155.1412907827,
		"y": -61.633754147,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592740,
		"ID": 21,
		"x": -155.9082677357,
		"y": -62.544830868,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592741,
		"ID": 21,
		"x": -155.9942845497,
		"y": -61.627787709,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592742,
		"ID": 21,
		"x": -157.1342325087,
		"y": -63.480789799,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592743,
		"ID": 21,
		"x": -156.6112684707,
		"y": -64.703831396,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592744,
		"ID": 21,
		"x": -156.3692662207,
		"y": -63.824826496,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592745,
		"ID": 21,
		"x": -156.2452714307,
		"y": -62.961830225,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592746,
		"ID": 21,
		"x": -157.2202481167,
		"y": -64.593759203,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592747,
		"ID": 21,
		"x": -155.7522297467,
		"y": -61.37381349,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592748,
		"ID": 21,
		"x": -156.8242868647,
		"y": -64.273817783,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592749,
		"ID": 21,
		"x": -156.8322612327,
		"y": -62.905845335,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592750,
		"ID": 21,
		"x": -155.5642609217,
		"y": -62.135818309,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592751,
		"ID": 21,
		"x": -156.4462663187,
		"y": -62.245845366,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592752,
		"ID": 21,
		"x": -156.7732364677,
		"y": -63.497824535,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592753,
		"ID": 21,
		"x": -156.6242917737,
		"y": -62.525835065,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592773,
		"ID": 21,
		"x": -158.2712320777,
		"y": -65.072808762,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592777,
		"ID": 21,
		"x": -159.4102341817,
		"y": -64.23985436,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592778,
		"ID": 21,
		"x": -157.8452496157,
		"y": -65.267852183,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592790,
		"ID": 21,
		"x": -158.3822260027,
		"y": -65.51182881,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592803,
		"ID": 21,
		"x": -159.0962537787,
		"y": -63.381817738,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592806,
		"ID": 21,
		"x": -158.3472841527,
		"y": -66.370821764,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592810,
		"ID": 21,
		"x": -158.7352668367,
		"y": -65.694843715,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592815,
		"ID": 21,
		"x": -157.6632429907,
		"y": -64.740807168,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592820,
		"ID": 21,
		"x": -158.9962885257,
		"y": -65.425844279,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592823,
		"ID": 21,
		"x": -157.5192303537,
		"y": -65.926760402,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592824,
		"ID": 21,
		"x": -158.9262351087,
		"y": -65.588761318,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592830,
		"ID": 21,
		"x": -159.1462905707,
		"y": -63.744777456,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592833,
		"ID": 21,
		"x": -157.3062385437,
		"y": -65.320823122,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592846,
		"ID": 21,
		"x": -158.3872576077,
		"y": -65.952798964,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592849,
		"ID": 21,
		"x": -158.1692969157,
		"y": -66.104776152,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592854,
		"ID": 21,
		"x": -158.2792631237,
		"y": -64.518778022,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592856,
		"ID": 21,
		"x": -159.0862979147,
		"y": -64.870798547,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592864,
		"ID": 21,
		"x": -159.4252807597,
		"y": -64.440843065,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592865,
		"ID": 21,
		"x": -157.9482718357,
		"y": -64.927858638,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592866,
		"ID": 21,
		"x": -159.3062496647,
		"y": -64.079800143,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592870,
		"ID": 21,
		"x": -158.6482332547,
		"y": -65.41976232,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592871,
		"ID": 21,
		"x": -159.2152427977,
		"y": -63.92475619,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592876,
		"ID": 21,
		"x": -157.8412333557,
		"y": -64.225826364,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592883,
		"ID": 21,
		"x": -158.7842456547,
		"y": -64.970813224,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592894,
		"ID": 21,
		"x": -157.9732733397,
		"y": -65.68281046,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592896,
		"ID": 21,
		"x": -158.2652630067,
		"y": -65.260800624,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592900,
		"ID": 21,
		"x": -158.5962564457,
		"y": -64.837804992,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592907,
		"ID": 21,
		"x": -159.1342683827,
		"y": -65.257807701,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592910,
		"ID": 21,
		"x": -158.7122791357,
		"y": -65.13475971,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592912,
		"ID": 21,
		"x": -158.7862248187,
		"y": -65.416836529,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592918,
		"ID": 21,
		"x": -157.8882616707,
		"y": -66.438770637,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592924,
		"ID": 21,
		"x": -158.5492672787,
		"y": -65.188791064,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592925,
		"ID": 21,
		"x": -158.4362893477,
		"y": -64.64285101,
		"h": 5.3186813187
	},
	{
		"stop_id": 8592927,
		"ID": 21,
		"x": -158.1792546287,
		"y": -65.601857024,
		"h": 5.3186813187
	},
	{
		"stop_id": 8593106,
		"ID": 21,
		"x": -155.4892521937,
		"y": -66.389840972,
		"h": 5.3186813187
	},
	{
		"stop_id": 8593107,
		"ID": 21,
		"x": -154.6392355867,
		"y": -64.581790452,
		"h": 5.3186813187
	},
	{
		"stop_id": 8593108,
		"ID": 21,
		"x": -156.0243008057,
		"y": -66.483853769,
		"h": 5.3186813187
	},
	{
		"stop_id": 8593109,
		"ID": 21,
		"x": -154.0432520537,
		"y": -64.240791131,
		"h": 5.3186813187
	},
	{
		"stop_id": 8593110,
		"ID": 21,
		"x": -155.6412880347,
		"y": -66.803799306,
		"h": 5.3186813187
	},
	{
		"stop_id": 8593111,
		"ID": 21,
		"x": -155.9962569417,
		"y": -66.97782662,
		"h": 5.3186813187
	},
	{
		"stop_id": 8593112,
		"ID": 21,
		"x": -155.2922677937,
		"y": -66.061753048,
		"h": 5.3186813187
	},
	{
		"stop_id": 8593113,
		"ID": 21,
		"x": -154.1872814407,
		"y": -64.319814545,
		"h": 5.3186813187
	},
	{
		"stop_id": 8593114,
		"ID": 21,
		"x": -153.9252827397,
		"y": -64.47677304,
		"h": 5.3186813187
	},
	{
		"stop_id": 8593115,
		"ID": 21,
		"x": -154.4542995597,
		"y": -64.370781937,
		"h": 5.3186813187
	},
	{
		"stop_id": 8593116,
		"ID": 21,
		"x": -154.8992293937,
		"y": -65.769767766,
		"h": 5.3186813187
	},
	{
		"stop_id": 8593117,
		"ID": 21,
		"x": -155.4982890137,
		"y": -66.633848047,
		"h": 5.3186813187
	},
	{
		"stop_id": 8593118,
		"ID": 21,
		"x": -154.8642275687,
		"y": -66.155777039,
		"h": 5.3186813187
	},
	{
		"stop_id": 8593119,
		"ID": 21,
		"x": -153.6102464077,
		"y": -64.867796978,
		"h": 5.3186813187
	},
	{
		"stop_id": 8593120,
		"ID": 21,
		"x": -154.5112500007,
		"y": -65.5518348,
		"h": 5.3186813187
	},
	{
		"stop_id": 8593121,
		"ID": 21,
		"x": -153.8812396947,
		"y": -65.063816779,
		"h": 5.3186813187
	},
	{
		"stop_id": 8593122,
		"ID": 21,
		"x": -154.1573002357,
		"y": -65.261858011,
		"h": 5.3186813187
	},
	{
		"stop_id": 8593124,
		"ID": 21,
		"x": -155.3652909317,
		"y": -66.514766792,
		"h": 5.3186813187
	},
	{
		"stop_id": 8593128,
		"ID": 21,
		"x": -154.7872849657,
		"y": -64.080826114,
		"h": 5.3186813187
	},
	{
		"stop_id": 8593129,
		"ID": 21,
		"x": -154.4732385397,
		"y": -63.372764188,
		"h": 5.3186813187
	},
	{
		"stop_id": 8593130,
		"ID": 21,
		"x": -154.4652885477,
		"y": -63.958802438,
		"h": 5.3186813187
	},
	{
		"stop_id": 8593131,
		"ID": 21,
		"x": -154.6732615097,
		"y": -63.194852488,
		"h": 5.3186813187
	},
	{
		"stop_id": 8593132,
		"ID": 21,
		"x": -155.7912915547,
		"y": -63.60878803,
		"h": 5.3186813187
	},
	{
		"stop_id": 8593133,
		"ID": 21,
		"x": -154.1602676987,
		"y": -63.237797955,
		"h": 5.3186813187
	},
	{
		"stop_id": 8593134,
		"ID": 21,
		"x": -155.2112422537,
		"y": -64.289833436,
		"h": 5.3186813187
	},
	{
		"stop_id": 8593135,
		"ID": 21,
		"x": -154.1492553977,
		"y": -63.782858082,
		"h": 5.3186813187
	},
	{
		"stop_id": 8593136,
		"ID": 21,
		"x": -156.0532309067,
		"y": -63.719802216,
		"h": 5.3186813187
	},
	{
		"stop_id": 8595019,
		"ID": 21,
		"x": -159.1872618697,
		"y": -64.738835237,
		"h": 5.3186813187
	},
	{
		"stop_id": 8595225,
		"ID": 21,
		"x": -153.5222544937,
		"y": -63.564812593,
		"h": 5.3186813187
	},
	{
		"stop_id": 8595229,
		"ID": 21,
		"x": -153.7122653307,
		"y": -63.842810603,
		"h": 5.3186813187
	},
	{
		"stop_id": 8595367,
		"ID": 21,
		"x": -154.3312793207,
		"y": -66.27676124,
		"h": 5.3186813187
	},
	{
		"stop_id": 8595368,
		"ID": 21,
		"x": -154.6612549347,
		"y": -66.215778954,
		"h": 5.3186813187
	},
	{
		"stop_id": 8595751,
		"ID": 21,
		"x": -154.7542332407,
		"y": -66.79178399,
		"h": 5.3186813187
	},
	{
		"stop_id": 8595786,
		"ID": 21,
		"x": -154.8722489987,
		"y": -66.984826167,
		"h": 5.3186813187
	},
	{
		"stop_id": 8595788,
		"ID": 21,
		"x": -154.6212513657,
		"y": -66.495800129,
		"h": 5.3186813187
	},
	{
		"stop_id": 8595789,
		"ID": 21,
		"x": -155.5872896717,
		"y": -67.055809865,
		"h": 5.3186813187
	},
	{
		"stop_id": 8595819,
		"ID": 21,
		"x": -154.3932821937,
		"y": -66.429774247,
		"h": 5.3186813187
	},
	{
		"stop_id": 8595829,
		"ID": 21,
		"x": -154.7582705227,
		"y": -66.237825407,
		"h": 5.3186813187
	},
	{
		"stop_id": 8501256,
		"ID": 61,
		"x": -135.7002502457,
		"y": -9.520817855,
		"h": 1.3626373626
	},
	{
		"stop_id": 8504657,
		"ID": 61,
		"x": -134.5472930617,
		"y": -10.62384778,
		"h": 1.3626373626
	},
	{
		"stop_id": 8570149,
		"ID": 61,
		"x": -134.5612995797,
		"y": -10.740851859,
		"h": 1.3626373626
	},
	{
		"stop_id": 8570150,
		"ID": 61,
		"x": -135.3082251307,
		"y": -10.977842524,
		"h": 1.3626373626
	},
	{
		"stop_id": 8570151,
		"ID": 61,
		"x": -135.6672529847,
		"y": -12.119858249,
		"h": 1.3626373626
	},
	{
		"stop_id": 8570152,
		"ID": 61,
		"x": -136.9802378347,
		"y": -13.412841725,
		"h": 1.3626373626
	},
	{
		"stop_id": 8570153,
		"ID": 61,
		"x": -137.1422495667,
		"y": -13.619762381,
		"h": 1.3626373626
	},
	{
		"stop_id": 8570225,
		"ID": 61,
		"x": -134.3672701847,
		"y": -10.719813861,
		"h": 1.3626373626
	},
	{
		"stop_id": 8570226,
		"ID": 61,
		"x": -134.8182644517,
		"y": -10.454806539,
		"h": 1.3626373626
	},
	{
		"stop_id": 8570227,
		"ID": 61,
		"x": -135.3622368917,
		"y": -9.844836311,
		"h": 1.3626373626
	},
	{
		"stop_id": 8570228,
		"ID": 61,
		"x": -135.6062590047,
		"y": -9.61784263,
		"h": 1.3626373626
	},
	{
		"stop_id": 8570229,
		"ID": 61,
		"x": -137.5282775007,
		"y": -10.31783866,
		"h": 1.3626373626
	},
	{
		"stop_id": 8501258,
		"ID": 466,
		"x": -53.4362700697,
		"y": -78.740750764,
		"h": 1.3296703297
	},
	{
		"stop_id": 8501747,
		"ID": 466,
		"x": -51.6092350937,
		"y": -80.982831037,
		"h": 1.3296703297
	},
	{
		"stop_id": 8501770,
		"ID": 466,
		"x": -54.2942987397,
		"y": -79.22781494,
		"h": 1.3296703297
	},
	{
		"stop_id": 8501784,
		"ID": 466,
		"x": -53.8542306327,
		"y": -77.264763515,
		"h": 1.3296703297
	},
	{
		"stop_id": 8570907,
		"ID": 466,
		"x": -54.3292456387,
		"y": -78.28381924,
		"h": 1.3296703297
	},
	{
		"stop_id": 8570908,
		"ID": 466,
		"x": -54.3112698397,
		"y": -78.756817082,
		"h": 1.3296703297
	},
	{
		"stop_id": 8570917,
		"ID": 466,
		"x": -53.8672509417,
		"y": -77.800820764,
		"h": 1.3296703297
	},
	{
		"stop_id": 8570918,
		"ID": 466,
		"x": -53.7432793877,
		"y": -77.63684141,
		"h": 1.3296703297
	},
	{
		"stop_id": 8570921,
		"ID": 466,
		"x": -53.5752739677,
		"y": -78.585814703,
		"h": 1.3296703297
	},
	{
		"stop_id": 8570922,
		"ID": 466,
		"x": -52.8692931187,
		"y": -79.62080346,
		"h": 1.3296703297
	},
	{
		"stop_id": 8570923,
		"ID": 466,
		"x": -52.3832810127,
		"y": -80.016770583,
		"h": 1.3296703297
	},
	{
		"stop_id": 8501259,
		"ID": 346,
		"x": -71.1032566897,
		"y": -68.220846891,
		"h": 1.989010989
	},
	{
		"stop_id": 8501505,
		"ID": 346,
		"x": -72.6852359537,
		"y": -65.096780037,
		"h": 1.989010989
	},
	{
		"stop_id": 8501510,
		"ID": 346,
		"x": -70.0472251167,
		"y": -64.265801706,
		"h": 1.989010989
	},
	{
		"stop_id": 8501742,
		"ID": 346,
		"x": -69.4252658807,
		"y": -67.244856515,
		"h": 1.989010989
	},
	{
		"stop_id": 8501772,
		"ID": 346,
		"x": -70.6212464257,
		"y": -67.531842241,
		"h": 1.989010989
	},
	{
		"stop_id": 8501858,
		"ID": 346,
		"x": -70.8632651537,
		"y": -67.930818743,
		"h": 1.989010989
	},
	{
		"stop_id": 8530108,
		"ID": 346,
		"x": -71.1272421577,
		"y": -68.286834131,
		"h": 1.989010989
	},
	{
		"stop_id": 8570839,
		"ID": 346,
		"x": -69.5382427917,
		"y": -64.75078,
		"h": 1.989010989
	},
	{
		"stop_id": 8570840,
		"ID": 346,
		"x": -69.2162301677,
		"y": -65.31179424,
		"h": 1.989010989
	},
	{
		"stop_id": 8570841,
		"ID": 346,
		"x": -69.7812708067,
		"y": -65.862814549,
		"h": 1.989010989
	},
	{
		"stop_id": 8570842,
		"ID": 346,
		"x": -71.6622864297,
		"y": -66.605858222,
		"h": 1.989010989
	},
	{
		"stop_id": 8570843,
		"ID": 346,
		"x": -72.0842603257,
		"y": -66.948843594,
		"h": 1.989010989
	},
	{
		"stop_id": 8570844,
		"ID": 346,
		"x": -72.8212956667,
		"y": -67.544804148,
		"h": 1.989010989
	},
	{
		"stop_id": 8570845,
		"ID": 346,
		"x": -72.4042999547,
		"y": -67.405848954,
		"h": 1.989010989
	},
	{
		"stop_id": 8570846,
		"ID": 346,
		"x": -72.3602848827,
		"y": -67.623826693,
		"h": 1.989010989
	},
	{
		"stop_id": 8570847,
		"ID": 346,
		"x": -72.7482907257,
		"y": -67.918813569,
		"h": 1.989010989
	},
	{
		"stop_id": 8570857,
		"ID": 346,
		"x": -68.3592699127,
		"y": -67.23780968,
		"h": 1.989010989
	},
	{
		"stop_id": 8570858,
		"ID": 346,
		"x": -68.6142314297,
		"y": -67.412858006,
		"h": 1.989010989
	},
	{
		"stop_id": 8570860,
		"ID": 346,
		"x": -69.8142859997,
		"y": -67.277789156,
		"h": 1.989010989
	},
	{
		"stop_id": 8570861,
		"ID": 346,
		"x": -69.7532518877,
		"y": -67.855842564,
		"h": 1.989010989
	},
	{
		"stop_id": 8570863,
		"ID": 346,
		"x": -70.0702527617,
		"y": -67.697784168,
		"h": 1.989010989
	},
	{
		"stop_id": 8570864,
		"ID": 346,
		"x": -70.4172328327,
		"y": -67.256849966,
		"h": 1.989010989
	},
	{
		"stop_id": 8570865,
		"ID": 346,
		"x": -70.4532553137,
		"y": -67.801832328,
		"h": 1.989010989
	},
	{
		"stop_id": 8570867,
		"ID": 346,
		"x": -70.8522480107,
		"y": -68.236767796,
		"h": 1.989010989
	},
	{
		"stop_id": 8570868,
		"ID": 346,
		"x": -70.1202279497,
		"y": -68.200835044,
		"h": 1.989010989
	},
	{
		"stop_id": 8570869,
		"ID": 346,
		"x": -69.4562367007,
		"y": -68.44584281,
		"h": 1.989010989
	},
	{
		"stop_id": 8570870,
		"ID": 346,
		"x": -69.5742943667,
		"y": -69.2398204,
		"h": 1.989010989
	},
	{
		"stop_id": 8582614,
		"ID": 346,
		"x": -73.0642517607,
		"y": -68.196815959,
		"h": 1.989010989
	},
	{
		"stop_id": 8582615,
		"ID": 346,
		"x": -69.9742738797,
		"y": -66.742811137,
		"h": 1.989010989
	},
	{
		"stop_id": 8583738,
		"ID": 346,
		"x": -68.6672491497,
		"y": -66.305790268,
		"h": 1.989010989
	},
	{
		"stop_id": 8583751,
		"ID": 346,
		"x": -70.2852623197,
		"y": -67.418829207,
		"h": 1.989010989
	},
	{
		"stop_id": 8501268,
		"ID": 69,
		"x": -133.7172333647,
		"y": -26.019837187,
		"h": 1.6593406593
	},
	{
		"stop_id": 8501269,
		"ID": 69,
		"x": -133.0922947117,
		"y": -24.194798438,
		"h": 1.6593406593
	},
	{
		"stop_id": 8504652,
		"ID": 69,
		"x": -131.7512401277,
		"y": -29.276768372,
		"h": 1.6593406593
	},
	{
		"stop_id": 8504656,
		"ID": 69,
		"x": -130.8922752967,
		"y": -26.094768107,
		"h": 1.6593406593
	},
	{
		"stop_id": 8570072,
		"ID": 69,
		"x": -133.0042544997,
		"y": -29.311762086,
		"h": 1.6593406593
	},
	{
		"stop_id": 8570092,
		"ID": 69,
		"x": -130.6172940867,
		"y": -27.319814669,
		"h": 1.6593406593
	},
	{
		"stop_id": 8570093,
		"ID": 69,
		"x": -130.9172720467,
		"y": -24.819756568,
		"h": 1.6593406593
	},
	{
		"stop_id": 8570097,
		"ID": 69,
		"x": -132.3852972547,
		"y": -29.531840143,
		"h": 1.6593406593
	},
	{
		"stop_id": 8570098,
		"ID": 69,
		"x": -132.2922293837,
		"y": -28.744854807,
		"h": 1.6593406593
	},
	{
		"stop_id": 8570099,
		"ID": 69,
		"x": -132.7172869867,
		"y": -27.594840361,
		"h": 1.6593406593
	},
	{
		"stop_id": 8570100,
		"ID": 69,
		"x": -132.7622732907,
		"y": -27.155824288,
		"h": 1.6593406593
	},
	{
		"stop_id": 8570101,
		"ID": 69,
		"x": -132.9472640817,
		"y": -27.046845883,
		"h": 1.6593406593
	},
	{
		"stop_id": 8570102,
		"ID": 69,
		"x": -133.2922656577,
		"y": -26.71978249,
		"h": 1.6593406593
	},
	{
		"stop_id": 8581054,
		"ID": 69,
		"x": -130.7922676907,
		"y": -26.619801184,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583891,
		"ID": 69,
		"x": -129.7842361357,
		"y": -25.029856698,
		"h": 1.6593406593
	},
	{
		"stop_id": 8592246,
		"ID": 69,
		"x": -131.8752610497,
		"y": -29.380784573,
		"h": 1.6593406593
	},
	{
		"stop_id": 8592249,
		"ID": 69,
		"x": -129.7592357497,
		"y": -29.326768275,
		"h": 1.6593406593
	},
	{
		"stop_id": 8592250,
		"ID": 69,
		"x": -130.1702612367,
		"y": -29.356762168,
		"h": 1.6593406593
	},
	{
		"stop_id": 8592254,
		"ID": 69,
		"x": -130.4802533547,
		"y": -29.140780198,
		"h": 1.6593406593
	},
	{
		"stop_id": 8595219,
		"ID": 69,
		"x": -130.2702553337,
		"y": -29.553811093,
		"h": 1.6593406593
	},
	{
		"stop_id": 8595220,
		"ID": 69,
		"x": -130.1302462987,
		"y": -29.569794005,
		"h": 1.6593406593
	},
	{
		"stop_id": 8501270,
		"ID": 634,
		"x": -27.7712922337,
		"y": -61.702792066,
		"h": 2.2857142857
	},
	{
		"stop_id": 8501335,
		"ID": 634,
		"x": -26.4022894017,
		"y": -62.439790497,
		"h": 2.2857142857
	},
	{
		"stop_id": 8501444,
		"ID": 634,
		"x": -26.6692831657,
		"y": -65.256784181,
		"h": 2.2857142857
	},
	{
		"stop_id": 8501683,
		"ID": 634,
		"x": -26.4062621957,
		"y": -62.418801761,
		"h": 2.2857142857
	},
	{
		"stop_id": 8501684,
		"ID": 634,
		"x": -29.0032729107,
		"y": -64.422749672,
		"h": 2.2857142857
	},
	{
		"stop_id": 8501718,
		"ID": 634,
		"x": -26.7982468677,
		"y": -62.517771584,
		"h": 2.2857142857
	},
	{
		"stop_id": 8501719,
		"ID": 634,
		"x": -23.9892627007,
		"y": -63.161852488,
		"h": 2.2857142857
	},
	{
		"stop_id": 8501720,
		"ID": 634,
		"x": -25.3182708487,
		"y": -62.715761666,
		"h": 2.2857142857
	},
	{
		"stop_id": 8501722,
		"ID": 634,
		"x": -28.5682817597,
		"y": -65.858808275,
		"h": 2.2857142857
	},
	{
		"stop_id": 8501796,
		"ID": 634,
		"x": -24.6952508997,
		"y": -65.910810333,
		"h": 2.2857142857
	},
	{
		"stop_id": 8501984,
		"ID": 634,
		"x": -27.8112968097,
		"y": -61.854857039,
		"h": 2.2857142857
	},
	{
		"stop_id": 8501987,
		"ID": 634,
		"x": -28.6732287117,
		"y": -65.80476374,
		"h": 2.2857142857
	},
	{
		"stop_id": 8501997,
		"ID": 634,
		"x": -26.3882373157,
		"y": -62.41381124,
		"h": 2.2857142857
	},
	{
		"stop_id": 8505710,
		"ID": 634,
		"x": -27.3722520337,
		"y": -62.469838551,
		"h": 2.2857142857
	},
	{
		"stop_id": 8530196,
		"ID": 634,
		"x": -29.0152939677,
		"y": -64.395797022,
		"h": 2.2857142857
	},
	{
		"stop_id": 8530197,
		"ID": 634,
		"x": -29.7172438187,
		"y": -64.193765587,
		"h": 2.2857142857
	},
	{
		"stop_id": 8571108,
		"ID": 634,
		"x": -26.9432931087,
		"y": -62.601822357,
		"h": 2.2857142857
	},
	{
		"stop_id": 8571109,
		"ID": 634,
		"x": -27.2212765537,
		"y": -62.785856515,
		"h": 2.2857142857
	},
	{
		"stop_id": 8571110,
		"ID": 634,
		"x": -27.3832618307,
		"y": -62.849755132,
		"h": 2.2857142857
	},
	{
		"stop_id": 8571111,
		"ID": 634,
		"x": -27.7052597667,
		"y": -62.987756243,
		"h": 2.2857142857
	},
	{
		"stop_id": 8571112,
		"ID": 634,
		"x": -27.3532721957,
		"y": -62.6578318,
		"h": 2.2857142857
	},
	{
		"stop_id": 8571113,
		"ID": 634,
		"x": -27.3682997377,
		"y": -62.299843047,
		"h": 2.2857142857
	},
	{
		"stop_id": 8571114,
		"ID": 634,
		"x": -27.5872997967,
		"y": -62.36081666,
		"h": 2.2857142857
	},
	{
		"stop_id": 8571115,
		"ID": 634,
		"x": -26.8972740817,
		"y": -61.512802904,
		"h": 2.2857142857
	},
	{
		"stop_id": 8571117,
		"ID": 634,
		"x": -28.0732754617,
		"y": -61.822770308,
		"h": 2.2857142857
	},
	{
		"stop_id": 8571118,
		"ID": 634,
		"x": -28.1962373837,
		"y": -61.777833099,
		"h": 2.2857142857
	},
	{
		"stop_id": 8571119,
		"ID": 634,
		"x": -27.9322944007,
		"y": -61.743770494,
		"h": 2.2857142857
	},
	{
		"stop_id": 8571120,
		"ID": 634,
		"x": -27.7862757077,
		"y": -61.596817802,
		"h": 2.2857142857
	},
	{
		"stop_id": 8571122,
		"ID": 634,
		"x": -27.7192751997,
		"y": -61.415817839,
		"h": 2.2857142857
	},
	{
		"stop_id": 8571142,
		"ID": 634,
		"x": -26.1532606957,
		"y": -62.035768095,
		"h": 2.2857142857
	},
	{
		"stop_id": 8571143,
		"ID": 634,
		"x": -26.7982532747,
		"y": -62.899852957,
		"h": 2.2857142857
	},
	{
		"stop_id": 8571144,
		"ID": 634,
		"x": -25.9002285407,
		"y": -63.722767873,
		"h": 2.2857142857
	},
	{
		"stop_id": 8571145,
		"ID": 634,
		"x": -25.7322983327,
		"y": -64.001858379,
		"h": 2.2857142857
	},
	{
		"stop_id": 8571146,
		"ID": 634,
		"x": -25.2702587587,
		"y": -64.646798323,
		"h": 2.2857142857
	},
	{
		"stop_id": 8571147,
		"ID": 634,
		"x": -25.0632384707,
		"y": -65.219797208,
		"h": 2.2857142857
	},
	{
		"stop_id": 8571148,
		"ID": 634,
		"x": -24.4122317097,
		"y": -66.446774021,
		"h": 2.2857142857
	},
	{
		"stop_id": 8579600,
		"ID": 634,
		"x": -27.6482440777,
		"y": -61.894794106,
		"h": 2.2857142857
	},
	{
		"stop_id": 8580958,
		"ID": 634,
		"x": -26.1422821137,
		"y": -63.27877851,
		"h": 2.2857142857
	},
	{
		"stop_id": 8583244,
		"ID": 634,
		"x": -27.2482318257,
		"y": -62.132783488,
		"h": 2.2857142857
	},
	{
		"stop_id": 8583245,
		"ID": 634,
		"x": -27.0952707357,
		"y": -62.287817706,
		"h": 2.2857142857
	},
	{
		"stop_id": 8501271,
		"ID": 284,
		"x": -83.1462720267,
		"y": -71.766803541,
		"h": 1.3956043956
	},
	{
		"stop_id": 8501501,
		"ID": 284,
		"x": -83.8712781377,
		"y": -74.153817544,
		"h": 1.3956043956
	},
	{
		"stop_id": 8501502,
		"ID": 284,
		"x": -80.2332541497,
		"y": -71.657777722,
		"h": 1.3956043956
	},
	{
		"stop_id": 8504650,
		"ID": 284,
		"x": -82.8632992317,
		"y": -71.597808444,
		"h": 1.3956043956
	},
	{
		"stop_id": 8571004,
		"ID": 284,
		"x": -84.3572239837,
		"y": -72.671779474,
		"h": 1.3956043956
	},
	{
		"stop_id": 8571005,
		"ID": 284,
		"x": -84.1382449497,
		"y": -72.447777118,
		"h": 1.3956043956
	},
	{
		"stop_id": 8571006,
		"ID": 284,
		"x": -83.9872776957,
		"y": -72.280856438,
		"h": 1.3956043956
	},
	{
		"stop_id": 8571007,
		"ID": 284,
		"x": -83.5782816287,
		"y": -72.026800596,
		"h": 1.3956043956
	},
	{
		"stop_id": 8571008,
		"ID": 284,
		"x": -81.8362996237,
		"y": -70.978786808,
		"h": 1.3956043956
	},
	{
		"stop_id": 8571009,
		"ID": 284,
		"x": -80.7472882587,
		"y": -70.481757888,
		"h": 1.3956043956
	},
	{
		"stop_id": 8581380,
		"ID": 284,
		"x": -81.5552375767,
		"y": -70.847854119,
		"h": 1.3956043956
	},
	{
		"stop_id": 8583836,
		"ID": 284,
		"x": -80.9142495097,
		"y": -72.207814835,
		"h": 1.3956043956
	},
	{
		"stop_id": 8583837,
		"ID": 284,
		"x": -79.9572745267,
		"y": -71.54376207,
		"h": 1.3956043956
	},
	{
		"stop_id": 8501272,
		"ID": 251,
		"x": -86.7602946227,
		"y": -74.140812423,
		"h": 2.5824175824
	},
	{
		"stop_id": 8501273,
		"ID": 251,
		"x": -85.4682779357,
		"y": -73.608846467,
		"h": 2.5824175824
	},
	{
		"stop_id": 8501274,
		"ID": 251,
		"x": -84.6732581677,
		"y": -73.039780198,
		"h": 2.5824175824
	},
	{
		"stop_id": 8501292,
		"ID": 251,
		"x": -87.4872728817,
		"y": -76.518836048,
		"h": 2.5824175824
	},
	{
		"stop_id": 8501500,
		"ID": 251,
		"x": -87.5422580457,
		"y": -76.469780943,
		"h": 2.5824175824
	},
	{
		"stop_id": 8501572,
		"ID": 251,
		"x": -88.3722613217,
		"y": -77.954776096,
		"h": 2.5824175824
	},
	{
		"stop_id": 8570960,
		"ID": 251,
		"x": -87.7752911907,
		"y": -76.7478467,
		"h": 2.5824175824
	},
	{
		"stop_id": 8570961,
		"ID": 251,
		"x": -88.3192539667,
		"y": -77.441765605,
		"h": 2.5824175824
	},
	{
		"stop_id": 8570977,
		"ID": 251,
		"x": -88.6842755497,
		"y": -76.695762284,
		"h": 2.5824175824
	},
	{
		"stop_id": 8570989,
		"ID": 251,
		"x": -87.4622559297,
		"y": -77.960794171,
		"h": 2.5824175824
	},
	{
		"stop_id": 8570990,
		"ID": 251,
		"x": -87.4652529757,
		"y": -78.192787298,
		"h": 2.5824175824
	},
	{
		"stop_id": 8570991,
		"ID": 251,
		"x": -86.9892422477,
		"y": -78.343804048,
		"h": 2.5824175824
	},
	{
		"stop_id": 8570992,
		"ID": 251,
		"x": -86.8012811417,
		"y": -78.377775905,
		"h": 2.5824175824
	},
	{
		"stop_id": 8570993,
		"ID": 251,
		"x": -86.5092845877,
		"y": -78.359843357,
		"h": 2.5824175824
	},
	{
		"stop_id": 8570994,
		"ID": 251,
		"x": -85.4782383127,
		"y": -77.891857445,
		"h": 2.5824175824
	},
	{
		"stop_id": 8570996,
		"ID": 251,
		"x": -84.0622888957,
		"y": -77.461831856,
		"h": 2.5824175824
	},
	{
		"stop_id": 8570997,
		"ID": 251,
		"x": -87.7002373317,
		"y": -75.918773365,
		"h": 2.5824175824
	},
	{
		"stop_id": 8570998,
		"ID": 251,
		"x": -87.2112351257,
		"y": -74.854808445,
		"h": 2.5824175824
	},
	{
		"stop_id": 8570999,
		"ID": 251,
		"x": -86.4102948687,
		"y": -73.911806191,
		"h": 2.5824175824
	},
	{
		"stop_id": 8571000,
		"ID": 251,
		"x": -86.1462275807,
		"y": -73.83281422,
		"h": 2.5824175824
	},
	{
		"stop_id": 8571001,
		"ID": 251,
		"x": -85.8572580507,
		"y": -73.74880476,
		"h": 2.5824175824
	},
	{
		"stop_id": 8571002,
		"ID": 251,
		"x": -85.0812837157,
		"y": -73.366803581,
		"h": 2.5824175824
	},
	{
		"stop_id": 8571003,
		"ID": 251,
		"x": -84.9272360507,
		"y": -73.269843025,
		"h": 2.5824175824
	},
	{
		"stop_id": 8580544,
		"ID": 251,
		"x": -88.5242834577,
		"y": -77.800754288,
		"h": 2.5824175824
	},
	{
		"stop_id": 8580545,
		"ID": 251,
		"x": -88.4192610157,
		"y": -77.606820879,
		"h": 2.5824175824
	},
	{
		"stop_id": 8580546,
		"ID": 251,
		"x": -88.1872247587,
		"y": -77.175808059,
		"h": 2.5824175824
	},
	{
		"stop_id": 8580547,
		"ID": 251,
		"x": -87.8902629357,
		"y": -76.810789265,
		"h": 2.5824175824
	},
	{
		"stop_id": 8580548,
		"ID": 251,
		"x": -88.0452307857,
		"y": -76.975816776,
		"h": 2.5824175824
	},
	{
		"stop_id": 8580646,
		"ID": 251,
		"x": -85.9592974707,
		"y": -78.048760304,
		"h": 2.5824175824
	},
	{
		"stop_id": 8581463,
		"ID": 251,
		"x": -86.9932294057,
		"y": -74.321858611,
		"h": 2.5824175824
	},
	{
		"stop_id": 8582630,
		"ID": 251,
		"x": -88.3102773777,
		"y": -76.114800334,
		"h": 2.5824175824
	},
	{
		"stop_id": 8582638,
		"ID": 251,
		"x": -88.2632905027,
		"y": -76.365816165,
		"h": 2.5824175824
	},
	{
		"stop_id": 8582639,
		"ID": 251,
		"x": -87.7932344067,
		"y": -76.581790334,
		"h": 2.5824175824
	},
	{
		"stop_id": 8583563,
		"ID": 251,
		"x": -85.9782750037,
		"y": -78.411751155,
		"h": 2.5824175824
	},
	{
		"stop_id": 8583600,
		"ID": 251,
		"x": -86.8712958677,
		"y": -76.570767369,
		"h": 2.5824175824
	},
	{
		"stop_id": 8583601,
		"ID": 251,
		"x": -86.8152898157,
		"y": -76.237849577,
		"h": 2.5824175824
	},
	{
		"stop_id": 8583602,
		"ID": 251,
		"x": -86.2852888327,
		"y": -76.828831297,
		"h": 2.5824175824
	},
	{
		"stop_id": 8583603,
		"ID": 251,
		"x": -87.0372671057,
		"y": -76.679853832,
		"h": 2.5824175824
	},
	{
		"stop_id": 8583604,
		"ID": 251,
		"x": -86.0112867587,
		"y": -76.627814537,
		"h": 2.5824175824
	},
	{
		"stop_id": 8583605,
		"ID": 251,
		"x": -88.4452581997,
		"y": -75.914837639,
		"h": 2.5824175824
	},
	{
		"stop_id": 8583606,
		"ID": 251,
		"x": -87.3052239127,
		"y": -76.869846363,
		"h": 2.5824175824
	},
	{
		"stop_id": 8583608,
		"ID": 251,
		"x": -87.7812958487,
		"y": -76.908789489,
		"h": 2.5824175824
	},
	{
		"stop_id": 8583609,
		"ID": 251,
		"x": -86.6312846977,
		"y": -76.694790785,
		"h": 2.5824175824
	},
	{
		"stop_id": 8583797,
		"ID": 251,
		"x": -88.0202490007,
		"y": -76.84275488,
		"h": 2.5824175824
	},
	{
		"stop_id": 8583799,
		"ID": 251,
		"x": -88.5802772587,
		"y": -75.724765654,
		"h": 2.5824175824
	},
	{
		"stop_id": 8583800,
		"ID": 251,
		"x": -88.4382246707,
		"y": -77.104808936,
		"h": 2.5824175824
	},
	{
		"stop_id": 8583801,
		"ID": 251,
		"x": -88.2222649237,
		"y": -76.799785438,
		"h": 2.5824175824
	},
	{
		"stop_id": 8583802,
		"ID": 251,
		"x": -88.6122965807,
		"y": -77.362778754,
		"h": 2.5824175824
	},
	{
		"stop_id": 8583879,
		"ID": 251,
		"x": -86.0062606237,
		"y": -76.449857378,
		"h": 2.5824175824
	},
	{
		"stop_id": 8501284,
		"ID": 166,
		"x": -101.2532578327,
		"y": -35.285842263,
		"h": 1.6263736264
	},
	{
		"stop_id": 8501287,
		"ID": 166,
		"x": -100.0292360487,
		"y": -34.891854969,
		"h": 1.6263736264
	},
	{
		"stop_id": 8501288,
		"ID": 166,
		"x": -100.3402832187,
		"y": -34.428748763,
		"h": 1.6263736264
	},
	{
		"stop_id": 8504061,
		"ID": 166,
		"x": -102.9002498227,
		"y": -29.905815944,
		"h": 1.6263736264
	},
	{
		"stop_id": 8504062,
		"ID": 166,
		"x": -101.1672621187,
		"y": -29.666779833,
		"h": 1.6263736264
	},
	{
		"stop_id": 8504713,
		"ID": 166,
		"x": -100.3892322217,
		"y": -30.167795,
		"h": 1.6263736264
	},
	{
		"stop_id": 8504716,
		"ID": 166,
		"x": -99.6742370217,
		"y": -29.780836039,
		"h": 1.6263736264
	},
	{
		"stop_id": 8504955,
		"ID": 166,
		"x": -101.9722617247,
		"y": -31.721786864,
		"h": 1.6263736264
	},
	{
		"stop_id": 8504956,
		"ID": 166,
		"x": -102.4472361647,
		"y": -32.121858633,
		"h": 1.6263736264
	},
	{
		"stop_id": 8504962,
		"ID": 166,
		"x": -103.3252524617,
		"y": -33.213785157,
		"h": 1.6263736264
	},
	{
		"stop_id": 8504965,
		"ID": 166,
		"x": -101.2882579557,
		"y": -30.164755499,
		"h": 1.6263736264
	},
	{
		"stop_id": 8577718,
		"ID": 166,
		"x": -101.1662476227,
		"y": -29.708808396,
		"h": 1.6263736264
	},
	{
		"stop_id": 8579170,
		"ID": 166,
		"x": -103.4422646437,
		"y": -34.069820525,
		"h": 1.6263736264
	},
	{
		"stop_id": 8579184,
		"ID": 166,
		"x": -102.7722643597,
		"y": -32.413801838,
		"h": 1.6263736264
	},
	{
		"stop_id": 8579187,
		"ID": 166,
		"x": -101.8212828027,
		"y": -31.502844538,
		"h": 1.6263736264
	},
	{
		"stop_id": 8591806,
		"ID": 166,
		"x": -100.6352571367,
		"y": -30.416808744,
		"h": 1.6263736264
	},
	{
		"stop_id": 8591807,
		"ID": 166,
		"x": -100.6032413567,
		"y": -30.019823161,
		"h": 1.6263736264
	},
	{
		"stop_id": 8591902,
		"ID": 166,
		"x": -102.9892479947,
		"y": -32.739856798,
		"h": 1.6263736264
	},
	{
		"stop_id": 8593761,
		"ID": 166,
		"x": -103.0722837037,
		"y": -29.979838223,
		"h": 1.6263736264
	},
	{
		"stop_id": 8593762,
		"ID": 166,
		"x": -102.6652415127,
		"y": -29.57677432,
		"h": 1.6263736264
	},
	{
		"stop_id": 8501293,
		"ID": 435,
		"x": -54.0662560047,
		"y": -76.370851732,
		"h": 1.3296703297
	},
	{
		"stop_id": 8530129,
		"ID": 435,
		"x": -56.7782458127,
		"y": -74.788855351,
		"h": 1.3296703297
	},
	{
		"stop_id": 8530130,
		"ID": 435,
		"x": -58.4342798697,
		"y": -74.847781805,
		"h": 1.3296703297
	},
	{
		"stop_id": 8570904,
		"ID": 435,
		"x": -55.6592538537,
		"y": -75.43576138,
		"h": 1.3296703297
	},
	{
		"stop_id": 8570905,
		"ID": 435,
		"x": -54.9702319597,
		"y": -76.172854697,
		"h": 1.3296703297
	},
	{
		"stop_id": 8570906,
		"ID": 435,
		"x": -54.5562701837,
		"y": -77.536753762,
		"h": 1.3296703297
	},
	{
		"stop_id": 8570919,
		"ID": 435,
		"x": -53.9102756527,
		"y": -77.043818128,
		"h": 1.3296703297
	},
	{
		"stop_id": 8570920,
		"ID": 435,
		"x": -53.9652514717,
		"y": -76.557850538,
		"h": 1.3296703297
	},
	{
		"stop_id": 8577418,
		"ID": 435,
		"x": -54.8212782367,
		"y": -76.603840542,
		"h": 1.3296703297
	},
	{
		"stop_id": 8581165,
		"ID": 435,
		"x": -55.9402922357,
		"y": -75.160804365,
		"h": 1.3296703297
	},
	{
		"stop_id": 8582967,
		"ID": 435,
		"x": -55.4622682317,
		"y": -75.544793091,
		"h": 1.3296703297
	},
	{
		"stop_id": 8501294,
		"ID": 316,
		"x": -77.5772405657,
		"y": -67.681788059,
		"h": 2.021978022
	},
	{
		"stop_id": 8501503,
		"ID": 316,
		"x": -76.7942982357,
		"y": -69.097754392,
		"h": 2.021978022
	},
	{
		"stop_id": 8501504,
		"ID": 316,
		"x": -74.9942657747,
		"y": -67.286790312,
		"h": 2.021978022
	},
	{
		"stop_id": 8501584,
		"ID": 316,
		"x": -74.7782448387,
		"y": -70.011793089,
		"h": 2.021978022
	},
	{
		"stop_id": 8501736,
		"ID": 316,
		"x": -78.5402714917,
		"y": -68.957830981,
		"h": 2.021978022
	},
	{
		"stop_id": 8501983,
		"ID": 316,
		"x": -79.1562758857,
		"y": -69.158758409,
		"h": 2.021978022
	},
	{
		"stop_id": 8530106,
		"ID": 316,
		"x": -75.6262264037,
		"y": -72.189812218,
		"h": 2.021978022
	},
	{
		"stop_id": 8530107,
		"ID": 316,
		"x": -76.5132337347,
		"y": -69.255843036,
		"h": 2.021978022
	},
	{
		"stop_id": 8570848,
		"ID": 316,
		"x": -73.9032481247,
		"y": -68.663800099,
		"h": 2.021978022
	},
	{
		"stop_id": 8571011,
		"ID": 316,
		"x": -78.7822571907,
		"y": -68.64880765,
		"h": 2.021978022
	},
	{
		"stop_id": 8571012,
		"ID": 316,
		"x": -78.5582642267,
		"y": -68.511775532,
		"h": 2.021978022
	},
	{
		"stop_id": 8571013,
		"ID": 316,
		"x": -77.4402708697,
		"y": -67.630832909,
		"h": 2.021978022
	},
	{
		"stop_id": 8571014,
		"ID": 316,
		"x": -76.7722453977,
		"y": -69.082809277,
		"h": 2.021978022
	},
	{
		"stop_id": 8576585,
		"ID": 316,
		"x": -75.0792360367,
		"y": -67.333820179,
		"h": 2.021978022
	},
	{
		"stop_id": 8579499,
		"ID": 316,
		"x": -75.8532314257,
		"y": -71.143801385,
		"h": 2.021978022
	},
	{
		"stop_id": 8579500,
		"ID": 316,
		"x": -75.6332507937,
		"y": -72.157777787,
		"h": 2.021978022
	},
	{
		"stop_id": 8579501,
		"ID": 316,
		"x": -74.7872622747,
		"y": -70.034781993,
		"h": 2.021978022
	},
	{
		"stop_id": 8579502,
		"ID": 316,
		"x": -74.8482615747,
		"y": -71.104827006,
		"h": 2.021978022
	},
	{
		"stop_id": 8579505,
		"ID": 316,
		"x": -75.9002632277,
		"y": -70.387855702,
		"h": 2.021978022
	},
	{
		"stop_id": 8579506,
		"ID": 316,
		"x": -76.2182393017,
		"y": -70.963837278,
		"h": 2.021978022
	},
	{
		"stop_id": 8579507,
		"ID": 316,
		"x": -76.4182305747,
		"y": -71.934770672,
		"h": 2.021978022
	},
	{
		"stop_id": 8581446,
		"ID": 316,
		"x": -77.3732757087,
		"y": -67.216823968,
		"h": 2.021978022
	},
	{
		"stop_id": 8581447,
		"ID": 316,
		"x": -77.5632545997,
		"y": -67.364783382,
		"h": 2.021978022
	},
	{
		"stop_id": 8587507,
		"ID": 316,
		"x": -75.6642242207,
		"y": -71.304827646,
		"h": 2.021978022
	},
	{
		"stop_id": 8588299,
		"ID": 316,
		"x": -75.9592912307,
		"y": -70.937859336,
		"h": 2.021978022
	},
	{
		"stop_id": 8588300,
		"ID": 316,
		"x": -75.3622921617,
		"y": -71.719823224,
		"h": 2.021978022
	},
	{
		"stop_id": 8588301,
		"ID": 316,
		"x": -75.3092314567,
		"y": -71.966749787,
		"h": 2.021978022
	},
	{
		"stop_id": 8588302,
		"ID": 316,
		"x": -74.8442908377,
		"y": -72.418823099,
		"h": 2.021978022
	},
	{
		"stop_id": 8588303,
		"ID": 316,
		"x": -74.7132373527,
		"y": -70.303766276,
		"h": 2.021978022
	},
	{
		"stop_id": 8588304,
		"ID": 316,
		"x": -74.6222549227,
		"y": -70.621815887,
		"h": 2.021978022
	},
	{
		"stop_id": 8588305,
		"ID": 316,
		"x": -74.4592355667,
		"y": -71.023748699,
		"h": 2.021978022
	},
	{
		"stop_id": 8588549,
		"ID": 316,
		"x": -75.4172265837,
		"y": -72.254835626,
		"h": 2.021978022
	},
	{
		"stop_id": 8501298,
		"ID": 81,
		"x": -128.0372467657,
		"y": -18.917782359,
		"h": 1.3296703297
	},
	{
		"stop_id": 8507655,
		"ID": 81,
		"x": -124.1822430257,
		"y": -18.852820128,
		"h": 1.3296703297
	},
	{
		"stop_id": 8570066,
		"ID": 81,
		"x": -126.7922450347,
		"y": -20.80676081,
		"h": 1.3296703297
	},
	{
		"stop_id": 8570183,
		"ID": 81,
		"x": -123.8532812497,
		"y": -17.271802781,
		"h": 1.3296703297
	},
	{
		"stop_id": 8570184,
		"ID": 81,
		"x": -124.2462699537,
		"y": -17.363752676,
		"h": 1.3296703297
	},
	{
		"stop_id": 8570185,
		"ID": 81,
		"x": -125.6412943137,
		"y": -18.010841881,
		"h": 1.3296703297
	},
	{
		"stop_id": 8570186,
		"ID": 81,
		"x": -125.7282691667,
		"y": -16.880812741,
		"h": 1.3296703297
	},
	{
		"stop_id": 8570187,
		"ID": 81,
		"x": -125.6232971037,
		"y": -16.400810112,
		"h": 1.3296703297
	},
	{
		"stop_id": 8570188,
		"ID": 81,
		"x": -124.5973001497,
		"y": -15.529839137,
		"h": 1.3296703297
	},
	{
		"stop_id": 8583636,
		"ID": 81,
		"x": -125.2702587517,
		"y": -20.439807387,
		"h": 1.3296703297
	},
	{
		"stop_id": 8583673,
		"ID": 81,
		"x": -127.4412784537,
		"y": -18.718756415,
		"h": 1.3296703297
	},
	{
		"stop_id": 8501303,
		"ID": 164,
		"x": -99.0922867617,
		"y": -43.88485026,
		"h": 1.6593406593
	},
	{
		"stop_id": 8501314,
		"ID": 164,
		"x": -99.2682998037,
		"y": -43.855793853,
		"h": 1.6593406593
	},
	{
		"stop_id": 8570581,
		"ID": 164,
		"x": -99.1062291757,
		"y": -43.852854012,
		"h": 1.6593406593
	},
	{
		"stop_id": 8570582,
		"ID": 164,
		"x": -99.5802727157,
		"y": -45.25378124,
		"h": 1.6593406593
	},
	{
		"stop_id": 8570583,
		"ID": 164,
		"x": -99.3722565567,
		"y": -45.545857301,
		"h": 1.6593406593
	},
	{
		"stop_id": 8570584,
		"ID": 164,
		"x": -99.6632628767,
		"y": -45.819852568,
		"h": 1.6593406593
	},
	{
		"stop_id": 8570585,
		"ID": 164,
		"x": -99.6782875447,
		"y": -46.298773971,
		"h": 1.6593406593
	},
	{
		"stop_id": 8570587,
		"ID": 164,
		"x": -101.1912304557,
		"y": -45.687798886,
		"h": 1.6593406593
	},
	{
		"stop_id": 8575508,
		"ID": 164,
		"x": -104.1442299707,
		"y": -44.801858936,
		"h": 1.6593406593
	},
	{
		"stop_id": 8579185,
		"ID": 164,
		"x": -99.4932540427,
		"y": -44.296759183,
		"h": 1.6593406593
	},
	{
		"stop_id": 8593777,
		"ID": 164,
		"x": -98.8472318517,
		"y": -43.06580911,
		"h": 1.6593406593
	},
	{
		"stop_id": 8593778,
		"ID": 164,
		"x": -99.1042718567,
		"y": -43.494796258,
		"h": 1.6593406593
	},
	{
		"stop_id": 8595177,
		"ID": 164,
		"x": -98.9462609287,
		"y": -44.101801654,
		"h": 1.6593406593
	},
	{
		"stop_id": 8595178,
		"ID": 164,
		"x": -98.7832381507,
		"y": -44.142770442,
		"h": 1.6593406593
	},
	{
		"stop_id": 8595179,
		"ID": 164,
		"x": -98.5112745177,
		"y": -44.322840983,
		"h": 1.6593406593
	},
	{
		"stop_id": 8595180,
		"ID": 164,
		"x": -98.6452497257,
		"y": -44.665817451,
		"h": 1.6593406593
	},
	{
		"stop_id": 8595181,
		"ID": 164,
		"x": -98.7262876157,
		"y": -44.980786395,
		"h": 1.6593406593
	},
	{
		"stop_id": 8595184,
		"ID": 164,
		"x": -98.9422389757,
		"y": -45.326782362,
		"h": 1.6593406593
	},
	{
		"stop_id": 8595185,
		"ID": 164,
		"x": -98.9622266447,
		"y": -45.005822817,
		"h": 1.6593406593
	},
	{
		"stop_id": 8595186,
		"ID": 164,
		"x": -98.8742513037,
		"y": -44.607748794,
		"h": 1.6593406593
	},
	{
		"stop_id": 8595187,
		"ID": 164,
		"x": -98.8022849217,
		"y": -44.268821944,
		"h": 1.6593406593
	},
	{
		"stop_id": 8501304,
		"ID": 163,
		"x": -99.1172777017,
		"y": -48.295813272,
		"h": 1.6593406593
	},
	{
		"stop_id": 8501424,
		"ID": 163,
		"x": -101.4022390537,
		"y": -50.658766373,
		"h": 1.6593406593
	},
	{
		"stop_id": 8501425,
		"ID": 163,
		"x": -102.7762241157,
		"y": -47.806768502,
		"h": 1.6593406593
	},
	{
		"stop_id": 8530740,
		"ID": 163,
		"x": -103.0562396917,
		"y": -47.660798898,
		"h": 1.6593406593
	},
	{
		"stop_id": 8570588,
		"ID": 163,
		"x": -101.0712275927,
		"y": -47.640840456,
		"h": 1.6593406593
	},
	{
		"stop_id": 8570589,
		"ID": 163,
		"x": -101.2282580247,
		"y": -48.617814805,
		"h": 1.6593406593
	},
	{
		"stop_id": 8570590,
		"ID": 163,
		"x": -101.6822781177,
		"y": -49.28679154,
		"h": 1.6593406593
	},
	{
		"stop_id": 8570591,
		"ID": 163,
		"x": -102.1582251647,
		"y": -49.359831831,
		"h": 1.6593406593
	},
	{
		"stop_id": 8570593,
		"ID": 163,
		"x": -101.9422560907,
		"y": -50.904803017,
		"h": 1.6593406593
	},
	{
		"stop_id": 8570595,
		"ID": 163,
		"x": -101.4232886237,
		"y": -50.651839575,
		"h": 1.6593406593
	},
	{
		"stop_id": 8570596,
		"ID": 163,
		"x": -103.2432631367,
		"y": -50.70078591,
		"h": 1.6593406593
	},
	{
		"stop_id": 8570599,
		"ID": 163,
		"x": -103.7422424287,
		"y": -50.482831349,
		"h": 1.6593406593
	},
	{
		"stop_id": 8579180,
		"ID": 163,
		"x": -102.2082568917,
		"y": -50.669815356,
		"h": 1.6593406593
	},
	{
		"stop_id": 8579379,
		"ID": 163,
		"x": -99.4422418087,
		"y": -51.509757283,
		"h": 1.6593406593
	},
	{
		"stop_id": 8579954,
		"ID": 163,
		"x": -101.9992719697,
		"y": -50.876833852,
		"h": 1.6593406593
	},
	{
		"stop_id": 8580445,
		"ID": 163,
		"x": -101.0422913197,
		"y": -47.382796302,
		"h": 1.6593406593
	},
	{
		"stop_id": 8581298,
		"ID": 163,
		"x": -102.5232635347,
		"y": -50.941838599,
		"h": 1.6593406593
	},
	{
		"stop_id": 8582056,
		"ID": 163,
		"x": -102.0522926617,
		"y": -50.016800634,
		"h": 1.6593406593
	},
	{
		"stop_id": 8582389,
		"ID": 163,
		"x": -102.8422644407,
		"y": -52.597858604,
		"h": 1.6593406593
	},
	{
		"stop_id": 8582531,
		"ID": 163,
		"x": -103.0252831007,
		"y": -52.588765529,
		"h": 1.6593406593
	},
	{
		"stop_id": 8591823,
		"ID": 163,
		"x": -98.6572633567,
		"y": -48.88276567,
		"h": 1.6593406593
	},
	{
		"stop_id": 8501315,
		"ID": 24,
		"x": -154.3262336347,
		"y": -48.878794888,
		"h": 1.7912087912
	},
	{
		"stop_id": 8501969,
		"ID": 24,
		"x": -155.1922566007,
		"y": -44.219758465,
		"h": 1.7912087912
	},
	{
		"stop_id": 8501970,
		"ID": 24,
		"x": -154.8352594827,
		"y": -44.129789216,
		"h": 1.7912087912
	},
	{
		"stop_id": 8579308,
		"ID": 24,
		"x": -154.4062600057,
		"y": -44.920799267,
		"h": 1.7912087912
	},
	{
		"stop_id": 8579309,
		"ID": 24,
		"x": -154.6422594857,
		"y": -45.200815715,
		"h": 1.7912087912
	},
	{
		"stop_id": 8579310,
		"ID": 24,
		"x": -155.5542982857,
		"y": -45.879808583,
		"h": 1.7912087912
	},
	{
		"stop_id": 8579312,
		"ID": 24,
		"x": -156.7422420177,
		"y": -45.469789328,
		"h": 1.7912087912
	},
	{
		"stop_id": 8579313,
		"ID": 24,
		"x": -157.3712941887,
		"y": -45.583819786,
		"h": 1.7912087912
	},
	{
		"stop_id": 8579314,
		"ID": 24,
		"x": -157.6642694897,
		"y": -46.011778219,
		"h": 1.7912087912
	},
	{
		"stop_id": 8579316,
		"ID": 24,
		"x": -157.7622247487,
		"y": -48.368752363,
		"h": 1.7912087912
	},
	{
		"stop_id": 8579317,
		"ID": 24,
		"x": -158.0132681187,
		"y": -49.303801787,
		"h": 1.7912087912
	},
	{
		"stop_id": 8588661,
		"ID": 24,
		"x": -153.8922253547,
		"y": -47.694753052,
		"h": 1.7912087912
	},
	{
		"stop_id": 8588662,
		"ID": 24,
		"x": -154.4882530577,
		"y": -47.616818515,
		"h": 1.7912087912
	},
	{
		"stop_id": 8588663,
		"ID": 24,
		"x": -154.6652621287,
		"y": -47.702754838,
		"h": 1.7912087912
	},
	{
		"stop_id": 8588664,
		"ID": 24,
		"x": -155.4172719237,
		"y": -48.519818711,
		"h": 1.7912087912
	},
	{
		"stop_id": 8588665,
		"ID": 24,
		"x": -155.1172373797,
		"y": -48.844767216,
		"h": 1.7912087912
	},
	{
		"stop_id": 8588935,
		"ID": 24,
		"x": -157.5092962007,
		"y": -46.401754962,
		"h": 1.7912087912
	},
	{
		"stop_id": 8593870,
		"ID": 24,
		"x": -156.2602867587,
		"y": -45.520775686,
		"h": 1.7912087912
	},
	{
		"stop_id": 8593871,
		"ID": 24,
		"x": -153.4982273507,
		"y": -47.152783165,
		"h": 1.7912087912
	},
	{
		"stop_id": 8593872,
		"ID": 24,
		"x": -158.2132870617,
		"y": -45.249812751,
		"h": 1.7912087912
	},
	{
		"stop_id": 8594263,
		"ID": 24,
		"x": -157.8442346217,
		"y": -48.904750287,
		"h": 1.7912087912
	},
	{
		"stop_id": 8595174,
		"ID": 24,
		"x": -157.9632915227,
		"y": -45.811792385,
		"h": 1.7912087912
	},
	{
		"stop_id": 8595175,
		"ID": 24,
		"x": -154.6182250417,
		"y": -44.60282982,
		"h": 1.7912087912
	},
	{
		"stop_id": 8595239,
		"ID": 24,
		"x": -158.2422772937,
		"y": -49.38978786,
		"h": 1.7912087912
	},
	{
		"stop_id": 8595502,
		"ID": 24,
		"x": -154.8402410037,
		"y": -47.898785133,
		"h": 1.7912087912
	},
	{
		"stop_id": 8501323,
		"ID": 600,
		"x": -28.6792623487,
		"y": -66.1338492,
		"h": 1.8901098901
	},
	{
		"stop_id": 8501324,
		"ID": 600,
		"x": -29.9202771317,
		"y": -67.851827292,
		"h": 1.8901098901
	},
	{
		"stop_id": 8501325,
		"ID": 600,
		"x": -31.3612736507,
		"y": -68.082850557,
		"h": 1.8901098901
	},
	{
		"stop_id": 8501326,
		"ID": 600,
		"x": -31.2302595477,
		"y": -68.504782135,
		"h": 1.8901098901
	},
	{
		"stop_id": 8501585,
		"ID": 600,
		"x": -30.6112383717,
		"y": -67.570818606,
		"h": 1.8901098901
	},
	{
		"stop_id": 8501685,
		"ID": 600,
		"x": -31.6742231627,
		"y": -68.503850042,
		"h": 1.8901098901
	},
	{
		"stop_id": 8501721,
		"ID": 600,
		"x": -30.4122608077,
		"y": -67.890799252,
		"h": 1.8901098901
	},
	{
		"stop_id": 8501723,
		"ID": 600,
		"x": -28.9432267817,
		"y": -66.019803862,
		"h": 1.8901098901
	},
	{
		"stop_id": 8501724,
		"ID": 600,
		"x": -30.8962992267,
		"y": -67.961820696,
		"h": 1.8901098901
	},
	{
		"stop_id": 8501767,
		"ID": 600,
		"x": -28.7712874897,
		"y": -66.373773687,
		"h": 1.8901098901
	},
	{
		"stop_id": 8501956,
		"ID": 600,
		"x": -31.2182561587,
		"y": -68.42979918,
		"h": 1.8901098901
	},
	{
		"stop_id": 8501957,
		"ID": 600,
		"x": -30.5022302497,
		"y": -67.631769643,
		"h": 1.8901098901
	},
	{
		"stop_id": 8501958,
		"ID": 600,
		"x": -30.1742697967,
		"y": -67.718780499,
		"h": 1.8901098901
	},
	{
		"stop_id": 8501959,
		"ID": 600,
		"x": -29.1292405647,
		"y": -66.237854771,
		"h": 1.8901098901
	},
	{
		"stop_id": 8501986,
		"ID": 600,
		"x": -29.9262446267,
		"y": -68.208814109,
		"h": 1.8901098901
	},
	{
		"stop_id": 8501988,
		"ID": 600,
		"x": -29.6832764677,
		"y": -66.890841416,
		"h": 1.8901098901
	},
	{
		"stop_id": 8501989,
		"ID": 600,
		"x": -30.1132612747,
		"y": -67.293824836,
		"h": 1.8901098901
	},
	{
		"stop_id": 8530198,
		"ID": 600,
		"x": -29.8482529987,
		"y": -64.32381109,
		"h": 1.8901098901
	},
	{
		"stop_id": 8530200,
		"ID": 600,
		"x": -28.6432998407,
		"y": -66.357777788,
		"h": 1.8901098901
	},
	{
		"stop_id": 8579915,
		"ID": 600,
		"x": -31.6422566277,
		"y": -68.719810705,
		"h": 1.8901098901
	},
	{
		"stop_id": 8579916,
		"ID": 600,
		"x": -31.8672317907,
		"y": -69.069801183,
		"h": 1.8901098901
	},
	{
		"stop_id": 8579923,
		"ID": 600,
		"x": -29.9652896817,
		"y": -67.081771908,
		"h": 1.8901098901
	},
	{
		"stop_id": 8579924,
		"ID": 600,
		"x": -29.9412291117,
		"y": -67.374801235,
		"h": 1.8901098901
	},
	{
		"stop_id": 8579926,
		"ID": 600,
		"x": -29.6652921937,
		"y": -67.886809193,
		"h": 1.8901098901
	},
	{
		"stop_id": 8579927,
		"ID": 600,
		"x": -29.5842370867,
		"y": -66.872785499,
		"h": 1.8901098901
	},
	{
		"stop_id": 8587014,
		"ID": 600,
		"x": -31.5992903297,
		"y": -68.442805887,
		"h": 1.8901098901
	},
	{
		"stop_id": 8587311,
		"ID": 600,
		"x": -31.7832566927,
		"y": -69.326766543,
		"h": 1.8901098901
	},
	{
		"stop_id": 8595355,
		"ID": 600,
		"x": -31.5042614577,
		"y": -68.435805643,
		"h": 1.8901098901
	},
	{
		"stop_id": 8501327,
		"ID": 378,
		"x": -64.0262828967,
		"y": -57.981835039,
		"h": 2.4175824176
	},
	{
		"stop_id": 8501785,
		"ID": 378,
		"x": -66.6262730097,
		"y": -60.366790539,
		"h": 2.4175824176
	},
	{
		"stop_id": 8501798,
		"ID": 378,
		"x": -67.6542741797,
		"y": -60.551833817,
		"h": 2.4175824176
	},
	{
		"stop_id": 8570738,
		"ID": 378,
		"x": -66.7482536777,
		"y": -61.139804899,
		"h": 2.4175824176
	},
	{
		"stop_id": 8570739,
		"ID": 378,
		"x": -66.7232448807,
		"y": -60.85880776,
		"h": 2.4175824176
	},
	{
		"stop_id": 8570740,
		"ID": 378,
		"x": -65.9652927937,
		"y": -60.145850945,
		"h": 2.4175824176
	},
	{
		"stop_id": 8570741,
		"ID": 378,
		"x": -65.4792803657,
		"y": -59.632753174,
		"h": 2.4175824176
	},
	{
		"stop_id": 8570742,
		"ID": 378,
		"x": -65.2662745407,
		"y": -59.432856358,
		"h": 2.4175824176
	},
	{
		"stop_id": 8570743,
		"ID": 378,
		"x": -66.9492265697,
		"y": -60.543830462,
		"h": 2.4175824176
	},
	{
		"stop_id": 8570744,
		"ID": 378,
		"x": -67.3092877057,
		"y": -60.59285492,
		"h": 2.4175824176
	},
	{
		"stop_id": 8570745,
		"ID": 378,
		"x": -67.0062349027,
		"y": -60.175803849,
		"h": 2.4175824176
	},
	{
		"stop_id": 8570746,
		"ID": 378,
		"x": -66.5292680217,
		"y": -59.831750872,
		"h": 2.4175824176
	},
	{
		"stop_id": 8570747,
		"ID": 378,
		"x": -66.6922732027,
		"y": -59.558763747,
		"h": 2.4175824176
	},
	{
		"stop_id": 8570748,
		"ID": 378,
		"x": -66.2762668727,
		"y": -59.127799644,
		"h": 2.4175824176
	},
	{
		"stop_id": 8570749,
		"ID": 378,
		"x": -66.4912657177,
		"y": -58.818854518,
		"h": 2.4175824176
	},
	{
		"stop_id": 8570750,
		"ID": 378,
		"x": -66.7202766127,
		"y": -58.842825817,
		"h": 2.4175824176
	},
	{
		"stop_id": 8570751,
		"ID": 378,
		"x": -66.1762451437,
		"y": -58.464806508,
		"h": 2.4175824176
	},
	{
		"stop_id": 8570752,
		"ID": 378,
		"x": -66.0682808737,
		"y": -58.142764475,
		"h": 2.4175824176
	},
	{
		"stop_id": 8570753,
		"ID": 378,
		"x": -65.7792501547,
		"y": -57.893830768,
		"h": 2.4175824176
	},
	{
		"stop_id": 8570754,
		"ID": 378,
		"x": -66.0522620047,
		"y": -57.865757302,
		"h": 2.4175824176
	},
	{
		"stop_id": 8570756,
		"ID": 378,
		"x": -68.9382730897,
		"y": -58.398838598,
		"h": 2.4175824176
	},
	{
		"stop_id": 8570757,
		"ID": 378,
		"x": -68.4722774307,
		"y": -56.463811866,
		"h": 2.4175824176
	},
	{
		"stop_id": 8570771,
		"ID": 378,
		"x": -65.5062847867,
		"y": -61.007843675,
		"h": 2.4175824176
	},
	{
		"stop_id": 8570772,
		"ID": 378,
		"x": -65.3752517257,
		"y": -61.094788948,
		"h": 2.4175824176
	},
	{
		"stop_id": 8570773,
		"ID": 378,
		"x": -64.9802388227,
		"y": -60.958748696,
		"h": 2.4175824176
	},
	{
		"stop_id": 8570775,
		"ID": 378,
		"x": -63.9192878177,
		"y": -59.411831234,
		"h": 2.4175824176
	},
	{
		"stop_id": 8570776,
		"ID": 378,
		"x": -64.0392922027,
		"y": -59.022778038,
		"h": 2.4175824176
	},
	{
		"stop_id": 8570777,
		"ID": 378,
		"x": -63.8632970317,
		"y": -58.616815602,
		"h": 2.4175824176
	},
	{
		"stop_id": 8570778,
		"ID": 378,
		"x": -63.7202739897,
		"y": -58.371793521,
		"h": 2.4175824176
	},
	{
		"stop_id": 8570779,
		"ID": 378,
		"x": -64.0162338307,
		"y": -58.157817009,
		"h": 2.4175824176
	},
	{
		"stop_id": 8570780,
		"ID": 378,
		"x": -64.3322283707,
		"y": -57.66078363,
		"h": 2.4175824176
	},
	{
		"stop_id": 8570781,
		"ID": 378,
		"x": -63.8632686217,
		"y": -57.575752209,
		"h": 2.4175824176
	},
	{
		"stop_id": 8570784,
		"ID": 378,
		"x": -64.0862904417,
		"y": -57.077795061,
		"h": 2.4175824176
	},
	{
		"stop_id": 8570786,
		"ID": 378,
		"x": -63.6552520167,
		"y": -59.257824663,
		"h": 2.4175824176
	},
	{
		"stop_id": 8579873,
		"ID": 378,
		"x": -68.3842699607,
		"y": -60.584842458,
		"h": 2.4175824176
	},
	{
		"stop_id": 8579874,
		"ID": 378,
		"x": -65.7402441367,
		"y": -59.582805846,
		"h": 2.4175824176
	},
	{
		"stop_id": 8579875,
		"ID": 378,
		"x": -65.2922313527,
		"y": -59.319777059,
		"h": 2.4175824176
	},
	{
		"stop_id": 8579876,
		"ID": 378,
		"x": -65.0642874467,
		"y": -59.122777335,
		"h": 2.4175824176
	},
	{
		"stop_id": 8579877,
		"ID": 378,
		"x": -64.1832239867,
		"y": -59.207762653,
		"h": 2.4175824176
	},
	{
		"stop_id": 8579879,
		"ID": 378,
		"x": -66.2302491407,
		"y": -59.778834479,
		"h": 2.4175824176
	},
	{
		"stop_id": 8580527,
		"ID": 378,
		"x": -68.2282969377,
		"y": -60.778826726,
		"h": 2.4175824176
	},
	{
		"stop_id": 8581902,
		"ID": 378,
		"x": -66.7212589267,
		"y": -60.610799889,
		"h": 2.4175824176
	},
	{
		"stop_id": 8582583,
		"ID": 378,
		"x": -64.0172893947,
		"y": -60.05485338,
		"h": 2.4175824176
	},
	{
		"stop_id": 8583219,
		"ID": 378,
		"x": -66.0652598617,
		"y": -58.78485895,
		"h": 2.4175824176
	},
	{
		"stop_id": 8501328,
		"ID": 317,
		"x": -73.6812972487,
		"y": -64.75883457,
		"h": 1.6263736264
	},
	{
		"stop_id": 8570704,
		"ID": 317,
		"x": -73.5902830337,
		"y": -64.311824381,
		"h": 1.6263736264
	},
	{
		"stop_id": 8573907,
		"ID": 317,
		"x": -74.0182678877,
		"y": -65.192814703,
		"h": 1.6263736264
	},
	{
		"stop_id": 8573908,
		"ID": 317,
		"x": -75.4872540197,
		"y": -65.699849618,
		"h": 1.6263736264
	},
	{
		"stop_id": 8573909,
		"ID": 317,
		"x": -76.6202512487,
		"y": -65.303810103,
		"h": 1.6263736264
	},
	{
		"stop_id": 8576506,
		"ID": 317,
		"x": -75.4442390097,
		"y": -66.816847046,
		"h": 1.6263736264
	},
	{
		"stop_id": 8576520,
		"ID": 317,
		"x": -75.3202946187,
		"y": -66.981805744,
		"h": 1.6263736264
	},
	{
		"stop_id": 8576586,
		"ID": 317,
		"x": -76.0022616307,
		"y": -66.306782179,
		"h": 1.6263736264
	},
	{
		"stop_id": 8576587,
		"ID": 317,
		"x": -76.1722485777,
		"y": -65.883778857,
		"h": 1.6263736264
	},
	{
		"stop_id": 8576588,
		"ID": 317,
		"x": -77.4402653707,
		"y": -65.078791824,
		"h": 1.6263736264
	},
	{
		"stop_id": 8576653,
		"ID": 317,
		"x": -78.7582320247,
		"y": -65.365810577,
		"h": 1.6263736264
	},
	{
		"stop_id": 8576655,
		"ID": 317,
		"x": -78.9542669537,
		"y": -65.36285451,
		"h": 1.6263736264
	},
	{
		"stop_id": 8576656,
		"ID": 317,
		"x": -77.9042322417,
		"y": -64.862749697,
		"h": 1.6263736264
	},
	{
		"stop_id": 8576657,
		"ID": 317,
		"x": -77.5232461927,
		"y": -64.821753924,
		"h": 1.6263736264
	},
	{
		"stop_id": 8576658,
		"ID": 317,
		"x": -77.6352848737,
		"y": -64.918803775,
		"h": 1.6263736264
	},
	{
		"stop_id": 8579390,
		"ID": 317,
		"x": -76.1772478127,
		"y": -65.848859083,
		"h": 1.6263736264
	},
	{
		"stop_id": 8579391,
		"ID": 317,
		"x": -76.5022241517,
		"y": -65.65875926,
		"h": 1.6263736264
	},
	{
		"stop_id": 8579392,
		"ID": 317,
		"x": -76.4512516367,
		"y": -66.204837381,
		"h": 1.6263736264
	},
	{
		"stop_id": 8579393,
		"ID": 317,
		"x": -76.9362624437,
		"y": -65.28679755,
		"h": 1.6263736264
	},
	{
		"stop_id": 8582221,
		"ID": 317,
		"x": -75.9682803707,
		"y": -65.641767343,
		"h": 1.6263736264
	},
	{
		"stop_id": 8501329,
		"ID": 351,
		"x": -71.5762714997,
		"y": -36.724856088,
		"h": 1.956043956
	},
	{
		"stop_id": 8501399,
		"ID": 351,
		"x": -71.5872997957,
		"y": -35.504792821,
		"h": 1.956043956
	},
	{
		"stop_id": 8530288,
		"ID": 351,
		"x": -71.5552649627,
		"y": -36.745796692,
		"h": 1.956043956
	},
	{
		"stop_id": 8530290,
		"ID": 351,
		"x": -70.9672847947,
		"y": -39.356759259,
		"h": 1.956043956
	},
	{
		"stop_id": 8530291,
		"ID": 351,
		"x": -71.7682544827,
		"y": -36.312827635,
		"h": 1.956043956
	},
	{
		"stop_id": 8530292,
		"ID": 351,
		"x": -73.0132694027,
		"y": -36.785764016,
		"h": 1.956043956
	},
	{
		"stop_id": 8571264,
		"ID": 351,
		"x": -71.6412837107,
		"y": -35.423757232,
		"h": 1.956043956
	},
	{
		"stop_id": 8571266,
		"ID": 351,
		"x": -71.7792780077,
		"y": -37.134763173,
		"h": 1.956043956
	},
	{
		"stop_id": 8571267,
		"ID": 351,
		"x": -72.0062885247,
		"y": -37.622763653,
		"h": 1.956043956
	},
	{
		"stop_id": 8571268,
		"ID": 351,
		"x": -72.0962723407,
		"y": -38.00376513,
		"h": 1.956043956
	},
	{
		"stop_id": 8571269,
		"ID": 351,
		"x": -72.4012917587,
		"y": -38.835757646,
		"h": 1.956043956
	},
	{
		"stop_id": 8571270,
		"ID": 351,
		"x": -72.4892800787,
		"y": -39.77580856,
		"h": 1.956043956
	},
	{
		"stop_id": 8571271,
		"ID": 351,
		"x": -72.6902494087,
		"y": -41.01676225,
		"h": 1.956043956
	},
	{
		"stop_id": 8571282,
		"ID": 351,
		"x": -70.9052897437,
		"y": -36.032806105,
		"h": 1.956043956
	},
	{
		"stop_id": 8571283,
		"ID": 351,
		"x": -70.6072482797,
		"y": -36.483797274,
		"h": 1.956043956
	},
	{
		"stop_id": 8571284,
		"ID": 351,
		"x": -70.0002235507,
		"y": -37.265806255,
		"h": 1.956043956
	},
	{
		"stop_id": 8571285,
		"ID": 351,
		"x": -69.7242351977,
		"y": -37.703820318,
		"h": 1.956043956
	},
	{
		"stop_id": 8571286,
		"ID": 351,
		"x": -69.7002533737,
		"y": -38.527818187,
		"h": 1.956043956
	},
	{
		"stop_id": 8571287,
		"ID": 351,
		"x": -69.4992539827,
		"y": -39.242831638,
		"h": 1.956043956
	},
	{
		"stop_id": 8571288,
		"ID": 351,
		"x": -69.2952276467,
		"y": -39.728842439,
		"h": 1.956043956
	},
	{
		"stop_id": 8571296,
		"ID": 351,
		"x": -70.4302724607,
		"y": -35.926843597,
		"h": 1.956043956
	},
	{
		"stop_id": 8571297,
		"ID": 351,
		"x": -70.2232735407,
		"y": -36.274824317,
		"h": 1.956043956
	},
	{
		"stop_id": 8571298,
		"ID": 351,
		"x": -70.0092736927,
		"y": -36.406815415,
		"h": 1.956043956
	},
	{
		"stop_id": 8571299,
		"ID": 351,
		"x": -69.5082889087,
		"y": -36.070823403,
		"h": 1.956043956
	},
	{
		"stop_id": 8579277,
		"ID": 351,
		"x": -71.4892608787,
		"y": -36.227784216,
		"h": 1.956043956
	},
	{
		"stop_id": 8580057,
		"ID": 351,
		"x": -69.9142290747,
		"y": -36.07481548,
		"h": 1.956043956
	},
	{
		"stop_id": 8580060,
		"ID": 351,
		"x": -70.4092340617,
		"y": -36.102856093,
		"h": 1.956043956
	},
	{
		"stop_id": 8581187,
		"ID": 351,
		"x": -71.6582967387,
		"y": -35.906848752,
		"h": 1.956043956
	},
	{
		"stop_id": 8581189,
		"ID": 351,
		"x": -71.3802334727,
		"y": -35.815795522,
		"h": 1.956043956
	},
	{
		"stop_id": 8581952,
		"ID": 351,
		"x": -71.5312370507,
		"y": -36.090856949,
		"h": 1.956043956
	},
	{
		"stop_id": 8501331,
		"ID": 407,
		"x": -61.4422369467,
		"y": -60.669789351,
		"h": 2.4505494505
	},
	{
		"stop_id": 8501332,
		"ID": 407,
		"x": -60.5312819607,
		"y": -62.920754468,
		"h": 2.4505494505
	},
	{
		"stop_id": 8501342,
		"ID": 407,
		"x": -61.0422905787,
		"y": -60.369857896,
		"h": 2.4505494505
	},
	{
		"stop_id": 8501507,
		"ID": 407,
		"x": -61.2132547337,
		"y": -60.341803013,
		"h": 2.4505494505
	},
	{
		"stop_id": 8570774,
		"ID": 407,
		"x": -63.8392776317,
		"y": -59.896790377,
		"h": 2.4505494505
	},
	{
		"stop_id": 8570829,
		"ID": 407,
		"x": -63.3312959897,
		"y": -60.462840057,
		"h": 2.4505494505
	},
	{
		"stop_id": 8570830,
		"ID": 407,
		"x": -62.7992706427,
		"y": -60.207791836,
		"h": 2.4505494505
	},
	{
		"stop_id": 8570831,
		"ID": 407,
		"x": -62.3562885127,
		"y": -59.627832698,
		"h": 2.4505494505
	},
	{
		"stop_id": 8570832,
		"ID": 407,
		"x": -62.6342772477,
		"y": -59.650825206,
		"h": 2.4505494505
	},
	{
		"stop_id": 8570833,
		"ID": 407,
		"x": -62.6352672317,
		"y": -59.153804353,
		"h": 2.4505494505
	},
	{
		"stop_id": 8570834,
		"ID": 407,
		"x": -62.7492544347,
		"y": -59.059812644,
		"h": 2.4505494505
	},
	{
		"stop_id": 8570891,
		"ID": 407,
		"x": -62.9212436287,
		"y": -63.17484477,
		"h": 2.4505494505
	},
	{
		"stop_id": 8570893,
		"ID": 407,
		"x": -62.7572702517,
		"y": -63.738762252,
		"h": 2.4505494505
	},
	{
		"stop_id": 8570924,
		"ID": 407,
		"x": -63.2812735367,
		"y": -63.093823239,
		"h": 2.4505494505
	},
	{
		"stop_id": 8570926,
		"ID": 407,
		"x": -61.6532659877,
		"y": -63.327801196,
		"h": 2.4505494505
	},
	{
		"stop_id": 8570927,
		"ID": 407,
		"x": -61.3872645877,
		"y": -63.986760643,
		"h": 2.4505494505
	},
	{
		"stop_id": 8570928,
		"ID": 407,
		"x": -60.9672454007,
		"y": -63.925835358,
		"h": 2.4505494505
	},
	{
		"stop_id": 8570937,
		"ID": 407,
		"x": -60.5742654387,
		"y": -64.023843662,
		"h": 2.4505494505
	},
	{
		"stop_id": 8570939,
		"ID": 407,
		"x": -59.5562496127,
		"y": -62.913811177,
		"h": 2.4505494505
	},
	{
		"stop_id": 8579431,
		"ID": 407,
		"x": -60.7422471357,
		"y": -60.069771975,
		"h": 2.4505494505
	},
	{
		"stop_id": 8579512,
		"ID": 407,
		"x": -62.9222439427,
		"y": -63.169841783,
		"h": 2.4505494505
	},
	{
		"stop_id": 8580403,
		"ID": 407,
		"x": -60.6022274857,
		"y": -63.706795304,
		"h": 2.4505494505
	},
	{
		"stop_id": 8580659,
		"ID": 407,
		"x": -62.9822248457,
		"y": -59.003773323,
		"h": 2.4505494505
	},
	{
		"stop_id": 8581781,
		"ID": 407,
		"x": -60.7992615917,
		"y": -63.106801452,
		"h": 2.4505494505
	},
	{
		"stop_id": 8582431,
		"ID": 407,
		"x": -62.4332957617,
		"y": -62.612812185,
		"h": 2.4505494505
	},
	{
		"stop_id": 8582432,
		"ID": 407,
		"x": -62.2482534827,
		"y": -62.328754895,
		"h": 2.4505494505
	},
	{
		"stop_id": 8582433,
		"ID": 407,
		"x": -62.6172475227,
		"y": -62.839836479,
		"h": 2.4505494505
	},
	{
		"stop_id": 8582949,
		"ID": 407,
		"x": -61.2172474887,
		"y": -63.59183534,
		"h": 2.4505494505
	},
	{
		"stop_id": 8583258,
		"ID": 407,
		"x": -62.6222613487,
		"y": -62.521789546,
		"h": 2.4505494505
	},
	{
		"stop_id": 8583273,
		"ID": 407,
		"x": -63.8032922147,
		"y": -62.191825663,
		"h": 2.4505494505
	},
	{
		"stop_id": 8583286,
		"ID": 407,
		"x": -64.0642996877,
		"y": -62.455770899,
		"h": 2.4505494505
	},
	{
		"stop_id": 8583291,
		"ID": 407,
		"x": -62.0292504397,
		"y": -60.368775273,
		"h": 2.4505494505
	},
	{
		"stop_id": 8583292,
		"ID": 407,
		"x": -61.8662278017,
		"y": -60.383844001,
		"h": 2.4505494505
	},
	{
		"stop_id": 8583366,
		"ID": 407,
		"x": -61.3222530157,
		"y": -60.45382894,
		"h": 2.4505494505
	},
	{
		"stop_id": 8583367,
		"ID": 407,
		"x": -61.4612851517,
		"y": -60.145750058,
		"h": 2.4505494505
	},
	{
		"stop_id": 8583369,
		"ID": 407,
		"x": -63.7322252267,
		"y": -62.047803339,
		"h": 2.4505494505
	},
	{
		"stop_id": 8583374,
		"ID": 407,
		"x": -62.6102751177,
		"y": -60.558835867,
		"h": 2.4505494505
	},
	{
		"stop_id": 8583375,
		"ID": 407,
		"x": -61.5472999397,
		"y": -60.245772821,
		"h": 2.4505494505
	},
	{
		"stop_id": 8583502,
		"ID": 407,
		"x": -60.0452284907,
		"y": -62.870779621,
		"h": 2.4505494505
	},
	{
		"stop_id": 8588517,
		"ID": 407,
		"x": -62.5232293437,
		"y": -62.24381219,
		"h": 2.4505494505
	},
	{
		"stop_id": 8588518,
		"ID": 407,
		"x": -63.0702661247,
		"y": -61.869791101,
		"h": 2.4505494505
	},
	{
		"stop_id": 8588519,
		"ID": 407,
		"x": -62.4122327007,
		"y": -61.927820093,
		"h": 2.4505494505
	},
	{
		"stop_id": 8588521,
		"ID": 407,
		"x": -62.7752465057,
		"y": -62.080830647,
		"h": 2.4505494505
	},
	{
		"stop_id": 8588522,
		"ID": 407,
		"x": -62.7822760657,
		"y": -62.399760796,
		"h": 2.4505494505
	},
	{
		"stop_id": 8588524,
		"ID": 407,
		"x": -63.9362362167,
		"y": -62.451749453,
		"h": 2.4505494505
	},
	{
		"stop_id": 8501334,
		"ID": 285,
		"x": -80.6422879067,
		"y": -65.683845957,
		"h": 1.6923076923
	},
	{
		"stop_id": 8530149,
		"ID": 285,
		"x": -81.1962755357,
		"y": -65.514817636,
		"h": 1.6923076923
	},
	{
		"stop_id": 8530150,
		"ID": 285,
		"x": -82.6412845327,
		"y": -65.603773757,
		"h": 1.6923076923
	},
	{
		"stop_id": 8571010,
		"ID": 285,
		"x": -79.4532652187,
		"y": -69.476842953,
		"h": 1.6923076923
	},
	{
		"stop_id": 8573910,
		"ID": 285,
		"x": -80.1732680487,
		"y": -65.856760499,
		"h": 1.6923076923
	},
	{
		"stop_id": 8576595,
		"ID": 285,
		"x": -79.6432481647,
		"y": -65.353838397,
		"h": 1.6923076923
	},
	{
		"stop_id": 8576649,
		"ID": 285,
		"x": -79.0152901767,
		"y": -65.498838295,
		"h": 1.6923076923
	},
	{
		"stop_id": 8576652,
		"ID": 285,
		"x": -79.2592264417,
		"y": -65.24681793,
		"h": 1.6923076923
	},
	{
		"stop_id": 8579394,
		"ID": 285,
		"x": -78.5192706607,
		"y": -67.322751292,
		"h": 1.6923076923
	},
	{
		"stop_id": 8579395,
		"ID": 285,
		"x": -78.7192744937,
		"y": -67.088787189,
		"h": 1.6923076923
	},
	{
		"stop_id": 8579396,
		"ID": 285,
		"x": -79.0572684707,
		"y": -67.01378844,
		"h": 1.6923076923
	},
	{
		"stop_id": 8579397,
		"ID": 285,
		"x": -79.5542693927,
		"y": -67.260855108,
		"h": 1.6923076923
	},
	{
		"stop_id": 8579398,
		"ID": 285,
		"x": -79.8982276577,
		"y": -66.729785574,
		"h": 1.6923076923
	},
	{
		"stop_id": 8579399,
		"ID": 285,
		"x": -80.0582752557,
		"y": -66.549826127,
		"h": 1.6923076923
	},
	{
		"stop_id": 8579400,
		"ID": 285,
		"x": -80.1852332777,
		"y": -66.380757821,
		"h": 1.6923076923
	},
	{
		"stop_id": 8579401,
		"ID": 285,
		"x": -80.1472994597,
		"y": -66.234813781,
		"h": 1.6923076923
	},
	{
		"stop_id": 8579402,
		"ID": 285,
		"x": -80.7972850367,
		"y": -65.552797558,
		"h": 1.6923076923
	},
	{
		"stop_id": 8579403,
		"ID": 285,
		"x": -80.0112753127,
		"y": -65.933789574,
		"h": 1.6923076923
	},
	{
		"stop_id": 8581448,
		"ID": 285,
		"x": -79.7902989577,
		"y": -67.12378522,
		"h": 1.6923076923
	},
	{
		"stop_id": 8582503,
		"ID": 285,
		"x": -79.9802680787,
		"y": -66.952843944,
		"h": 1.6923076923
	},
	{
		"stop_id": 8582504,
		"ID": 285,
		"x": -80.4772875327,
		"y": -65.870841419,
		"h": 1.6923076923
	},
	{
		"stop_id": 8582725,
		"ID": 285,
		"x": -79.7602572597,
		"y": -67.004825889,
		"h": 1.6923076923
	},
	{
		"stop_id": 8501336,
		"ID": 663,
		"x": -20.7202677907,
		"y": -78.093809221,
		"h": 1.5934065934
	},
	{
		"stop_id": 8501337,
		"ID": 663,
		"x": -22.7972483417,
		"y": -80.528826459,
		"h": 1.5934065934
	},
	{
		"stop_id": 8501647,
		"ID": 663,
		"x": -22.0412731907,
		"y": -76.799811939,
		"h": 1.5934065934
	},
	{
		"stop_id": 8501695,
		"ID": 663,
		"x": -24.3792453427,
		"y": -78.773771082,
		"h": 1.5934065934
	},
	{
		"stop_id": 8501696,
		"ID": 663,
		"x": -24.0842995207,
		"y": -77.967855225,
		"h": 1.5934065934
	},
	{
		"stop_id": 8501780,
		"ID": 663,
		"x": -19.6142599227,
		"y": -77.697845937,
		"h": 1.5934065934
	},
	{
		"stop_id": 8501782,
		"ID": 663,
		"x": -21.7842801877,
		"y": -76.085843594,
		"h": 1.5934065934
	},
	{
		"stop_id": 8505736,
		"ID": 663,
		"x": -20.6952313607,
		"y": -75.888840412,
		"h": 1.5934065934
	},
	{
		"stop_id": 8505737,
		"ID": 663,
		"x": -19.5332728767,
		"y": -78.902825897,
		"h": 1.5934065934
	},
	{
		"stop_id": 8530231,
		"ID": 663,
		"x": -19.5852475207,
		"y": -77.90976436,
		"h": 1.5934065934
	},
	{
		"stop_id": 8530232,
		"ID": 663,
		"x": -19.1532820147,
		"y": -78.197822189,
		"h": 1.5934065934
	},
	{
		"stop_id": 8530805,
		"ID": 663,
		"x": -21.8962709637,
		"y": -76.403817329,
		"h": 1.5934065934
	},
	{
		"stop_id": 8530806,
		"ID": 663,
		"x": -22.5162749037,
		"y": -77.096782373,
		"h": 1.5934065934
	},
	{
		"stop_id": 8530807,
		"ID": 663,
		"x": -21.9592708877,
		"y": -75.934856433,
		"h": 1.5934065934
	},
	{
		"stop_id": 8571196,
		"ID": 663,
		"x": -20.0842324417,
		"y": -76.945763377,
		"h": 1.5934065934
	},
	{
		"stop_id": 8571197,
		"ID": 663,
		"x": -19.7052477057,
		"y": -77.258773741,
		"h": 1.5934065934
	},
	{
		"stop_id": 8571198,
		"ID": 663,
		"x": -19.5422840977,
		"y": -78.569823398,
		"h": 1.5934065934
	},
	{
		"stop_id": 8571199,
		"ID": 663,
		"x": -19.5172658517,
		"y": -80.958791437,
		"h": 1.5934065934
	},
	{
		"stop_id": 8581061,
		"ID": 663,
		"x": -19.6572820807,
		"y": -78.116791921,
		"h": 1.5934065934
	},
	{
		"stop_id": 8501339,
		"ID": 504,
		"x": -43.5942385027,
		"y": -47.25877712,
		"h": 1.7582417582
	},
	{
		"stop_id": 8501341,
		"ID": 504,
		"x": -45.5582945517,
		"y": -48.170801165,
		"h": 1.7582417582
	},
	{
		"stop_id": 8501643,
		"ID": 504,
		"x": -45.3732718907,
		"y": -45.639795421,
		"h": 1.7582417582
	},
	{
		"stop_id": 8501644,
		"ID": 504,
		"x": -45.0862593327,
		"y": -46.71485634,
		"h": 1.7582417582
	},
	{
		"stop_id": 8501655,
		"ID": 504,
		"x": -46.3292670227,
		"y": -48.712819,
		"h": 1.7582417582
	},
	{
		"stop_id": 8501656,
		"ID": 504,
		"x": -45.2962584687,
		"y": -46.061818737,
		"h": 1.7582417582
	},
	{
		"stop_id": 8501657,
		"ID": 504,
		"x": -46.0802568227,
		"y": -44.03975856,
		"h": 1.7582417582
	},
	{
		"stop_id": 8530179,
		"ID": 504,
		"x": -45.5602700927,
		"y": -48.148795028,
		"h": 1.7582417582
	},
	{
		"stop_id": 8579538,
		"ID": 504,
		"x": -45.7952733137,
		"y": -47.597848339,
		"h": 1.7582417582
	},
	{
		"stop_id": 8579539,
		"ID": 504,
		"x": -45.4452548577,
		"y": -46.628782223,
		"h": 1.7582417582
	},
	{
		"stop_id": 8579547,
		"ID": 504,
		"x": -45.7022993387,
		"y": -48.699839055,
		"h": 1.7582417582
	},
	{
		"stop_id": 8588297,
		"ID": 504,
		"x": -45.3852288657,
		"y": -49.070834025,
		"h": 1.7582417582
	},
	{
		"stop_id": 8588322,
		"ID": 504,
		"x": -45.6122638807,
		"y": -47.997842569,
		"h": 1.7582417582
	},
	{
		"stop_id": 8594500,
		"ID": 504,
		"x": -45.3112585687,
		"y": -46.062854954,
		"h": 1.7582417582
	},
	{
		"stop_id": 8594501,
		"ID": 504,
		"x": -45.1632477627,
		"y": -46.024815689,
		"h": 1.7582417582
	},
	{
		"stop_id": 8594502,
		"ID": 504,
		"x": -45.2882965097,
		"y": -45.980760146,
		"h": 1.7582417582
	},
	{
		"stop_id": 8594503,
		"ID": 504,
		"x": -45.3922951937,
		"y": -45.695756705,
		"h": 1.7582417582
	},
	{
		"stop_id": 8594504,
		"ID": 504,
		"x": -45.2142952567,
		"y": -45.783820389,
		"h": 1.7582417582
	},
	{
		"stop_id": 8594505,
		"ID": 504,
		"x": -45.0612656557,
		"y": -45.692851814,
		"h": 1.7582417582
	},
	{
		"stop_id": 8594506,
		"ID": 504,
		"x": -44.9082234537,
		"y": -45.891798846,
		"h": 1.7582417582
	},
	{
		"stop_id": 8594507,
		"ID": 504,
		"x": -44.9012830317,
		"y": -46.369793351,
		"h": 1.7582417582
	},
	{
		"stop_id": 8594508,
		"ID": 504,
		"x": -45.0742550957,
		"y": -46.93782521,
		"h": 1.7582417582
	},
	{
		"stop_id": 8594509,
		"ID": 504,
		"x": -45.2142940837,
		"y": -46.554752785,
		"h": 1.7582417582
	},
	{
		"stop_id": 8594512,
		"ID": 504,
		"x": -45.3192967137,
		"y": -46.273754936,
		"h": 1.7582417582
	},
	{
		"stop_id": 8501343,
		"ID": 258,
		"x": -84.6612918427,
		"y": -37.893816739,
		"h": 1.2307692308
	},
	{
		"stop_id": 8501347,
		"ID": 258,
		"x": -85.1642965997,
		"y": -36.908776908,
		"h": 1.2307692308
	},
	{
		"stop_id": 8501348,
		"ID": 258,
		"x": -84.6672713447,
		"y": -36.594814734,
		"h": 1.2307692308
	},
	{
		"stop_id": 8501392,
		"ID": 258,
		"x": -87.0422245317,
		"y": -36.564812255,
		"h": 1.2307692308
	},
	{
		"stop_id": 8501393,
		"ID": 258,
		"x": -85.9922262977,
		"y": -36.424754477,
		"h": 1.2307692308
	},
	{
		"stop_id": 8501394,
		"ID": 258,
		"x": -83.3372895427,
		"y": -35.484858275,
		"h": 1.2307692308
	},
	{
		"stop_id": 8570618,
		"ID": 258,
		"x": -83.2122409037,
		"y": -35.441771357,
		"h": 1.2307692308
	},
	{
		"stop_id": 8570619,
		"ID": 258,
		"x": -83.7752559177,
		"y": -35.878761355,
		"h": 1.2307692308
	},
	{
		"stop_id": 8501344,
		"ID": 257,
		"x": -84.7512671097,
		"y": -40.774758761,
		"h": 1.0659340659
	},
	{
		"stop_id": 8501702,
		"ID": 257,
		"x": -85.4322923167,
		"y": -42.959858759,
		"h": 1.0659340659
	},
	{
		"stop_id": 8501799,
		"ID": 257,
		"x": -85.2612748937,
		"y": -41.52976747,
		"h": 1.0659340659
	},
	{
		"stop_id": 8501345,
		"ID": 290,
		"x": -83.8842533657,
		"y": -39.626846367,
		"h": 1.1978021978
	},
	{
		"stop_id": 8501349,
		"ID": 290,
		"x": -84.1252589167,
		"y": -37.276821265,
		"h": 1.1978021978
	},
	{
		"stop_id": 8501373,
		"ID": 290,
		"x": -82.2422939707,
		"y": -38.46975784,
		"h": 1.1978021978
	},
	{
		"stop_id": 8501395,
		"ID": 290,
		"x": -81.4702480567,
		"y": -35.573836734,
		"h": 1.1978021978
	},
	{
		"stop_id": 8501700,
		"ID": 290,
		"x": -83.0962655927,
		"y": -40.972847143,
		"h": 1.1978021978
	},
	{
		"stop_id": 8501701,
		"ID": 290,
		"x": -83.3892576827,
		"y": -40.121836728,
		"h": 1.1978021978
	},
	{
		"stop_id": 8530674,
		"ID": 290,
		"x": -83.1362876017,
		"y": -35.501764066,
		"h": 1.1978021978
	},
	{
		"stop_id": 8501346,
		"ID": 256,
		"x": -86.1302406027,
		"y": -44.805752313,
		"h": 1.4285714286
	},
	{
		"stop_id": 8501475,
		"ID": 256,
		"x": -86.9572918947,
		"y": -48.733795399,
		"h": 1.4285714286
	},
	{
		"stop_id": 8501476,
		"ID": 256,
		"x": -84.7952300027,
		"y": -49.007760025,
		"h": 1.4285714286
	},
	{
		"stop_id": 8501758,
		"ID": 256,
		"x": -87.0552650907,
		"y": -46.001773807,
		"h": 1.4285714286
	},
	{
		"stop_id": 8501766,
		"ID": 256,
		"x": -88.3173001267,
		"y": -49.219848253,
		"h": 1.4285714286
	},
	{
		"stop_id": 8501792,
		"ID": 256,
		"x": -85.6492774887,
		"y": -44.186758054,
		"h": 1.4285714286
	},
	{
		"stop_id": 8517485,
		"ID": 256,
		"x": -85.7592387037,
		"y": -48.966762277,
		"h": 1.4285714286
	},
	{
		"stop_id": 8570620,
		"ID": 256,
		"x": -86.8482701737,
		"y": -45.73780085,
		"h": 1.4285714286
	},
	{
		"stop_id": 8570621,
		"ID": 256,
		"x": -87.4282268797,
		"y": -46.480752078,
		"h": 1.4285714286
	},
	{
		"stop_id": 8570622,
		"ID": 256,
		"x": -87.9722729627,
		"y": -47.641802261,
		"h": 1.4285714286
	},
	{
		"stop_id": 8570623,
		"ID": 256,
		"x": -88.8722648407,
		"y": -47.810821791,
		"h": 1.4285714286
	},
	{
		"stop_id": 8570624,
		"ID": 256,
		"x": -88.8952341207,
		"y": -48.151769202,
		"h": 1.4285714286
	},
	{
		"stop_id": 8573653,
		"ID": 256,
		"x": -86.5812364187,
		"y": -45.358809668,
		"h": 1.4285714286
	},
	{
		"stop_id": 8593775,
		"ID": 256,
		"x": -84.3032354227,
		"y": -48.84481791,
		"h": 1.4285714286
	},
	{
		"stop_id": 8501350,
		"ID": 193,
		"x": -97.7802754827,
		"y": -37.675804148,
		"h": 1.2637362637
	},
	{
		"stop_id": 8501351,
		"ID": 193,
		"x": -98.1342649747,
		"y": -37.354836833,
		"h": 1.2637362637
	},
	{
		"stop_id": 8501377,
		"ID": 193,
		"x": -97.7972900077,
		"y": -37.729835027,
		"h": 1.2637362637
	},
	{
		"stop_id": 8501386,
		"ID": 193,
		"x": -96.1222886767,
		"y": -37.644822909,
		"h": 1.2637362637
	},
	{
		"stop_id": 8570570,
		"ID": 193,
		"x": -99.0172268307,
		"y": -34.69478344,
		"h": 1.2637362637
	},
	{
		"stop_id": 8570571,
		"ID": 193,
		"x": -98.9582323687,
		"y": -35.480790657,
		"h": 1.2637362637
	},
	{
		"stop_id": 8570572,
		"ID": 193,
		"x": -98.7802323777,
		"y": -36.088813547,
		"h": 1.2637362637
	},
	{
		"stop_id": 8570573,
		"ID": 193,
		"x": -98.6992659777,
		"y": -36.644843364,
		"h": 1.2637362637
	},
	{
		"stop_id": 8570574,
		"ID": 193,
		"x": -98.6952585507,
		"y": -36.97481474,
		"h": 1.2637362637
	},
	{
		"stop_id": 8501354,
		"ID": 319,
		"x": -77.7612507757,
		"y": -51.941817692,
		"h": 1
	},
	{
		"stop_id": 8501355,
		"ID": 320,
		"x": -75.3682980777,
		"y": -47.658858294,
		"h": 1.2637362637
	},
	{
		"stop_id": 8501793,
		"ID": 320,
		"x": -77.6792820727,
		"y": -48.938811546,
		"h": 1.2637362637
	},
	{
		"stop_id": 8530039,
		"ID": 320,
		"x": -77.7022665327,
		"y": -48.902836409,
		"h": 1.2637362637
	},
	{
		"stop_id": 8530297,
		"ID": 320,
		"x": -75.1752761637,
		"y": -49.210783243,
		"h": 1.2637362637
	},
	{
		"stop_id": 8571274,
		"ID": 320,
		"x": -73.6042262977,
		"y": -46.028836066,
		"h": 1.2637362637
	},
	{
		"stop_id": 8571275,
		"ID": 320,
		"x": -74.4812659377,
		"y": -46.643825792,
		"h": 1.2637362637
	},
	{
		"stop_id": 8571276,
		"ID": 320,
		"x": -75.3772498587,
		"y": -47.638825204,
		"h": 1.2637362637
	},
	{
		"stop_id": 8571277,
		"ID": 320,
		"x": -76.1742349267,
		"y": -48.322811527,
		"h": 1.2637362637
	},
	{
		"stop_id": 8582705,
		"ID": 320,
		"x": -74.0642942677,
		"y": -46.218849134,
		"h": 1.2637362637
	},
	{
		"stop_id": 8501358,
		"ID": 322,
		"x": -77.7112847137,
		"y": -37.137813359,
		"h": 1.0989010989
	},
	{
		"stop_id": 8501396,
		"ID": 322,
		"x": -79.1372936947,
		"y": -34.674828553,
		"h": 1.0989010989
	},
	{
		"stop_id": 8501397,
		"ID": 322,
		"x": -77.3772693287,
		"y": -33.954794111,
		"h": 1.0989010989
	},
	{
		"stop_id": 8530032,
		"ID": 322,
		"x": -77.4142352397,
		"y": -34.278844839,
		"h": 1.0989010989
	},
	{
		"stop_id": 8501378,
		"ID": 225,
		"x": -92.8272888547,
		"y": -35.979794046,
		"h": 1.0659340659
	},
	{
		"stop_id": 8501387,
		"ID": 225,
		"x": -93.6172756247,
		"y": -37.519835914,
		"h": 1.0659340659
	},
	{
		"stop_id": 8501391,
		"ID": 225,
		"x": -89.8572432977,
		"y": -36.28978466,
		"h": 1.0659340659
	},
	{
		"stop_id": 8501379,
		"ID": 226,
		"x": -90.7922840567,
		"y": -33.584783276,
		"h": 1.0989010989
	},
	{
		"stop_id": 8504070,
		"ID": 226,
		"x": -90.1492641757,
		"y": -34.206827836,
		"h": 1.0989010989
	},
	{
		"stop_id": 8504071,
		"ID": 226,
		"x": -89.3762291217,
		"y": -31.821829969,
		"h": 1.0989010989
	},
	{
		"stop_id": 8504072,
		"ID": 226,
		"x": -89.1502732237,
		"y": -30.64979801,
		"h": 1.0989010989
	},
	{
		"stop_id": 8501398,
		"ID": 352,
		"x": -73.4372398947,
		"y": -33.969763202,
		"h": 1.7582417582
	},
	{
		"stop_id": 8507270,
		"ID": 352,
		"x": -71.9122975497,
		"y": -33.754839475,
		"h": 1.7582417582
	},
	{
		"stop_id": 8507271,
		"ID": 352,
		"x": -71.0672392137,
		"y": -32.199846942,
		"h": 1.7582417582
	},
	{
		"stop_id": 8507272,
		"ID": 352,
		"x": -69.4822525277,
		"y": -30.749816622,
		"h": 1.7582417582
	},
	{
		"stop_id": 8530283,
		"ID": 352,
		"x": -70.9132316227,
		"y": -32.307856115,
		"h": 1.7582417582
	},
	{
		"stop_id": 8530284,
		"ID": 352,
		"x": -69.3452612447,
		"y": -33.417789921,
		"h": 1.7582417582
	},
	{
		"stop_id": 8530285,
		"ID": 352,
		"x": -73.1952634807,
		"y": -31.459857044,
		"h": 1.7582417582
	},
	{
		"stop_id": 8530679,
		"ID": 352,
		"x": -71.3652332507,
		"y": -32.167815344,
		"h": 1.7582417582
	},
	{
		"stop_id": 8579261,
		"ID": 352,
		"x": -73.4232405047,
		"y": -33.958789802,
		"h": 1.7582417582
	},
	{
		"stop_id": 8579264,
		"ID": 352,
		"x": -72.8902790987,
		"y": -33.425832951,
		"h": 1.7582417582
	},
	{
		"stop_id": 8579265,
		"ID": 352,
		"x": -71.0932624127,
		"y": -32.200798093,
		"h": 1.7582417582
	},
	{
		"stop_id": 8579266,
		"ID": 352,
		"x": -69.5252599837,
		"y": -30.769756145,
		"h": 1.7582417582
	},
	{
		"stop_id": 8579267,
		"ID": 352,
		"x": -73.0772616127,
		"y": -33.958792138,
		"h": 1.7582417582
	},
	{
		"stop_id": 8579268,
		"ID": 352,
		"x": -72.7212888017,
		"y": -34.094751815,
		"h": 1.7582417582
	},
	{
		"stop_id": 8579269,
		"ID": 352,
		"x": -72.4262480797,
		"y": -34.257797171,
		"h": 1.7582417582
	},
	{
		"stop_id": 8579270,
		"ID": 352,
		"x": -72.0182437677,
		"y": -34.723764637,
		"h": 1.7582417582
	},
	{
		"stop_id": 8579271,
		"ID": 352,
		"x": -71.8092444267,
		"y": -34.965752415,
		"h": 1.7582417582
	},
	{
		"stop_id": 8581097,
		"ID": 352,
		"x": -70.2412864617,
		"y": -31.312807703,
		"h": 1.7582417582
	},
	{
		"stop_id": 8581098,
		"ID": 352,
		"x": -70.5532947567,
		"y": -31.667759174,
		"h": 1.7582417582
	},
	{
		"stop_id": 8581356,
		"ID": 352,
		"x": -71.3392590057,
		"y": -32.310824768,
		"h": 1.7582417582
	},
	{
		"stop_id": 8581357,
		"ID": 352,
		"x": -72.3502767107,
		"y": -33.222783475,
		"h": 1.7582417582
	},
	{
		"stop_id": 8581358,
		"ID": 352,
		"x": -73.1372768597,
		"y": -33.362810302,
		"h": 1.7582417582
	},
	{
		"stop_id": 8581359,
		"ID": 352,
		"x": -73.2932772557,
		"y": -33.76776924,
		"h": 1.7582417582
	},
	{
		"stop_id": 8581360,
		"ID": 352,
		"x": -71.7332973337,
		"y": -35.158777281,
		"h": 1.7582417582
	},
	{
		"stop_id": 8501402,
		"ID": 221,
		"x": -93.5172643247,
		"y": -60.249813643,
		"h": 1.989010989
	},
	{
		"stop_id": 8501420,
		"ID": 221,
		"x": -94.6822384827,
		"y": -61.383755483,
		"h": 1.989010989
	},
	{
		"stop_id": 8501487,
		"ID": 221,
		"x": -92.4562372047,
		"y": -60.316802459,
		"h": 1.989010989
	},
	{
		"stop_id": 8501488,
		"ID": 221,
		"x": -91.1832798857,
		"y": -59.425787827,
		"h": 1.989010989
	},
	{
		"stop_id": 8530064,
		"ID": 221,
		"x": -91.9632243067,
		"y": -60.36281101,
		"h": 1.989010989
	},
	{
		"stop_id": 8530066,
		"ID": 221,
		"x": -91.7772887717,
		"y": -60.130795366,
		"h": 1.989010989
	},
	{
		"stop_id": 8530067,
		"ID": 221,
		"x": -91.4352968267,
		"y": -59.88581139,
		"h": 1.989010989
	},
	{
		"stop_id": 8530246,
		"ID": 221,
		"x": -91.2642840487,
		"y": -59.713843036,
		"h": 1.989010989
	},
	{
		"stop_id": 8530523,
		"ID": 221,
		"x": -92.9722904807,
		"y": -60.072749431,
		"h": 1.989010989
	},
	{
		"stop_id": 8570637,
		"ID": 221,
		"x": -93.4922355727,
		"y": -60.269852626,
		"h": 1.989010989
	},
	{
		"stop_id": 8570638,
		"ID": 221,
		"x": -92.6252308867,
		"y": -60.278753881,
		"h": 1.989010989
	},
	{
		"stop_id": 8570639,
		"ID": 221,
		"x": -93.0472857997,
		"y": -59.967838821,
		"h": 1.989010989
	},
	{
		"stop_id": 8570640,
		"ID": 221,
		"x": -93.2642903567,
		"y": -58.996815382,
		"h": 1.989010989
	},
	{
		"stop_id": 8570641,
		"ID": 221,
		"x": -93.0902581197,
		"y": -58.534769444,
		"h": 1.989010989
	},
	{
		"stop_id": 8570643,
		"ID": 221,
		"x": -91.4932331357,
		"y": -58.747824795,
		"h": 1.989010989
	},
	{
		"stop_id": 8570644,
		"ID": 221,
		"x": -91.4462281677,
		"y": -58.576763961,
		"h": 1.989010989
	},
	{
		"stop_id": 8570646,
		"ID": 221,
		"x": -91.1672548887,
		"y": -59.47278376,
		"h": 1.989010989
	},
	{
		"stop_id": 8570647,
		"ID": 221,
		"x": -90.7072373547,
		"y": -58.814832301,
		"h": 1.989010989
	},
	{
		"stop_id": 8570651,
		"ID": 221,
		"x": -93.8102780697,
		"y": -62.3057596,
		"h": 1.989010989
	},
	{
		"stop_id": 8570652,
		"ID": 221,
		"x": -94.6332415127,
		"y": -61.340794908,
		"h": 1.989010989
	},
	{
		"stop_id": 8570664,
		"ID": 221,
		"x": -93.0492840947,
		"y": -64.019758872,
		"h": 1.989010989
	},
	{
		"stop_id": 8570666,
		"ID": 221,
		"x": -92.2802849467,
		"y": -63.756818375,
		"h": 1.989010989
	},
	{
		"stop_id": 8570667,
		"ID": 221,
		"x": -92.4062884327,
		"y": -63.969801087,
		"h": 1.989010989
	},
	{
		"stop_id": 8575219,
		"ID": 221,
		"x": -92.3982744107,
		"y": -60.564796609,
		"h": 1.989010989
	},
	{
		"stop_id": 8579970,
		"ID": 221,
		"x": -91.8382581007,
		"y": -60.675856356,
		"h": 1.989010989
	},
	{
		"stop_id": 8580534,
		"ID": 221,
		"x": -94.2032917787,
		"y": -61.595837535,
		"h": 1.989010989
	},
	{
		"stop_id": 8580669,
		"ID": 221,
		"x": -93.4672632627,
		"y": -59.444798901,
		"h": 1.989010989
	},
	{
		"stop_id": 8580765,
		"ID": 221,
		"x": -93.2742648867,
		"y": -63.498806499,
		"h": 1.989010989
	},
	{
		"stop_id": 8582007,
		"ID": 221,
		"x": -94.2662256907,
		"y": -61.135801288,
		"h": 1.989010989
	},
	{
		"stop_id": 8582114,
		"ID": 221,
		"x": -91.5882710177,
		"y": -62.029749708,
		"h": 1.989010989
	},
	{
		"stop_id": 8582712,
		"ID": 221,
		"x": -92.0592608977,
		"y": -60.366855137,
		"h": 1.989010989
	},
	{
		"stop_id": 8501404,
		"ID": 220,
		"x": -91.6492584297,
		"y": -69.399811442,
		"h": 1.4615384615
	},
	{
		"stop_id": 8570668,
		"ID": 220,
		"x": -92.3922381017,
		"y": -65.195828856,
		"h": 1.4615384615
	},
	{
		"stop_id": 8570669,
		"ID": 220,
		"x": -92.1642823127,
		"y": -65.490761086,
		"h": 1.4615384615
	},
	{
		"stop_id": 8580101,
		"ID": 220,
		"x": -92.4142829077,
		"y": -66.288817151,
		"h": 1.4615384615
	},
	{
		"stop_id": 8580221,
		"ID": 220,
		"x": -92.7742956867,
		"y": -66.466838435,
		"h": 1.4615384615
	},
	{
		"stop_id": 8580222,
		"ID": 220,
		"x": -92.9132851757,
		"y": -65.966824128,
		"h": 1.4615384615
	},
	{
		"stop_id": 8580391,
		"ID": 220,
		"x": -92.7852498257,
		"y": -67.664829096,
		"h": 1.4615384615
	},
	{
		"stop_id": 8580440,
		"ID": 220,
		"x": -93.5702904247,
		"y": -67.638805816,
		"h": 1.4615384615
	},
	{
		"stop_id": 8580444,
		"ID": 220,
		"x": -92.9212629517,
		"y": -66.81476471,
		"h": 1.4615384615
	},
	{
		"stop_id": 8580651,
		"ID": 220,
		"x": -92.5192584867,
		"y": -64.921780399,
		"h": 1.4615384615
	},
	{
		"stop_id": 8581558,
		"ID": 220,
		"x": -93.1132655177,
		"y": -64.286762721,
		"h": 1.4615384615
	},
	{
		"stop_id": 8587607,
		"ID": 220,
		"x": -91.6522349597,
		"y": -68.442755995,
		"h": 1.4615384615
	},
	{
		"stop_id": 8587645,
		"ID": 220,
		"x": -91.6722745957,
		"y": -69.399801006,
		"h": 1.4615384615
	},
	{
		"stop_id": 8587646,
		"ID": 220,
		"x": -91.0902974217,
		"y": -69.353824184,
		"h": 1.4615384615
	},
	{
		"stop_id": 8588175,
		"ID": 220,
		"x": -91.3922388717,
		"y": -69.801810635,
		"h": 1.4615384615
	},
	{
		"stop_id": 8501405,
		"ID": 219,
		"x": -90.6752780227,
		"y": -72.817827488,
		"h": 1.4945054945
	},
	{
		"stop_id": 8501561,
		"ID": 219,
		"x": -90.1722765067,
		"y": -73.755855387,
		"h": 1.4945054945
	},
	{
		"stop_id": 8501562,
		"ID": 219,
		"x": -92.0233002227,
		"y": -74.692847909,
		"h": 1.4945054945
	},
	{
		"stop_id": 8501563,
		"ID": 219,
		"x": -92.7522481867,
		"y": -75.722773819,
		"h": 1.4945054945
	},
	{
		"stop_id": 8530084,
		"ID": 219,
		"x": -90.2072917917,
		"y": -71.502759329,
		"h": 1.4945054945
	},
	{
		"stop_id": 8530085,
		"ID": 219,
		"x": -89.0592295877,
		"y": -71.752784329,
		"h": 1.4945054945
	},
	{
		"stop_id": 8530303,
		"ID": 219,
		"x": -89.5722327247,
		"y": -74.829834188,
		"h": 1.4945054945
	},
	{
		"stop_id": 8582640,
		"ID": 219,
		"x": -89.1722392577,
		"y": -74.301859105,
		"h": 1.4945054945
	},
	{
		"stop_id": 8583593,
		"ID": 219,
		"x": -90.8312945057,
		"y": -72.75577371,
		"h": 1.4945054945
	},
	{
		"stop_id": 8583594,
		"ID": 219,
		"x": -90.5722263647,
		"y": -73.264802769,
		"h": 1.4945054945
	},
	{
		"stop_id": 8587647,
		"ID": 219,
		"x": -90.1952795187,
		"y": -71.51082393,
		"h": 1.4945054945
	},
	{
		"stop_id": 8587648,
		"ID": 219,
		"x": -90.3442372187,
		"y": -71.677823007,
		"h": 1.4945054945
	},
	{
		"stop_id": 8593487,
		"ID": 219,
		"x": -92.2922783967,
		"y": -74.599803681,
		"h": 1.4945054945
	},
	{
		"stop_id": 8593488,
		"ID": 219,
		"x": -92.7322295857,
		"y": -75.709765233,
		"h": 1.4945054945
	},
	{
		"stop_id": 8593489,
		"ID": 219,
		"x": -92.0622544347,
		"y": -75.009801539,
		"h": 1.4945054945
	},
	{
		"stop_id": 8593490,
		"ID": 219,
		"x": -94.2022439587,
		"y": -72.589754899,
		"h": 1.4945054945
	},
	{
		"stop_id": 8501441,
		"ID": 438,
		"x": -54.0962383717,
		"y": -58.534770711,
		"h": 2.2527472527
	},
	{
		"stop_id": 8501547,
		"ID": 438,
		"x": -56.2982977657,
		"y": -57.021773057,
		"h": 2.2527472527
	},
	{
		"stop_id": 8501586,
		"ID": 438,
		"x": -56.9092601707,
		"y": -56.213800393,
		"h": 2.2527472527
	},
	{
		"stop_id": 8501979,
		"ID": 438,
		"x": -58.6112757937,
		"y": -58.2507755,
		"h": 2.2527472527
	},
	{
		"stop_id": 8505683,
		"ID": 438,
		"x": -54.5072689767,
		"y": -58.76180202,
		"h": 2.2527472527
	},
	{
		"stop_id": 8505684,
		"ID": 438,
		"x": -54.0992554917,
		"y": -58.439838267,
		"h": 2.2527472527
	},
	{
		"stop_id": 8505694,
		"ID": 438,
		"x": -55.3712658437,
		"y": -59.249827334,
		"h": 2.2527472527
	},
	{
		"stop_id": 8570823,
		"ID": 438,
		"x": -58.0472490607,
		"y": -58.637839149,
		"h": 2.2527472527
	},
	{
		"stop_id": 8570824,
		"ID": 438,
		"x": -58.3782740577,
		"y": -58.399802863,
		"h": 2.2527472527
	},
	{
		"stop_id": 8570825,
		"ID": 438,
		"x": -58.2882639777,
		"y": -58.247819949,
		"h": 2.2527472527
	},
	{
		"stop_id": 8570826,
		"ID": 438,
		"x": -59.1632307517,
		"y": -58.472844195,
		"h": 2.2527472527
	},
	{
		"stop_id": 8570946,
		"ID": 438,
		"x": -55.0312428167,
		"y": -58.940758506,
		"h": 2.2527472527
	},
	{
		"stop_id": 8579405,
		"ID": 438,
		"x": -55.9422710257,
		"y": -60.669788608,
		"h": 2.2527472527
	},
	{
		"stop_id": 8579406,
		"ID": 438,
		"x": -56.7422681517,
		"y": -60.969819819,
		"h": 2.2527472527
	},
	{
		"stop_id": 8579407,
		"ID": 438,
		"x": -57.7022737357,
		"y": -61.149851886,
		"h": 2.2527472527
	},
	{
		"stop_id": 8579413,
		"ID": 438,
		"x": -54.2422872667,
		"y": -56.869757953,
		"h": 2.2527472527
	},
	{
		"stop_id": 8579414,
		"ID": 438,
		"x": -54.6272410527,
		"y": -57.089754194,
		"h": 2.2527472527
	},
	{
		"stop_id": 8579420,
		"ID": 438,
		"x": -55.3422604017,
		"y": -59.269816402,
		"h": 2.2527472527
	},
	{
		"stop_id": 8579422,
		"ID": 438,
		"x": -56.3922452277,
		"y": -59.309829606,
		"h": 2.2527472527
	},
	{
		"stop_id": 8579428,
		"ID": 438,
		"x": -58.4422465937,
		"y": -60.369777507,
		"h": 2.2527472527
	},
	{
		"stop_id": 8579478,
		"ID": 438,
		"x": -54.5902308367,
		"y": -56.555796189,
		"h": 2.2527472527
	},
	{
		"stop_id": 8579479,
		"ID": 438,
		"x": -55.0322556927,
		"y": -56.817834818,
		"h": 2.2527472527
	},
	{
		"stop_id": 8579480,
		"ID": 438,
		"x": -55.8422519867,
		"y": -57.369782234,
		"h": 2.2527472527
	},
	{
		"stop_id": 8579481,
		"ID": 438,
		"x": -56.5972511327,
		"y": -57.824768352,
		"h": 2.2527472527
	},
	{
		"stop_id": 8579482,
		"ID": 438,
		"x": -56.8222357367,
		"y": -57.395780487,
		"h": 2.2527472527
	},
	{
		"stop_id": 8579483,
		"ID": 438,
		"x": -56.2822588517,
		"y": -56.484835731,
		"h": 2.2527472527
	},
	{
		"stop_id": 8579484,
		"ID": 438,
		"x": -57.5712337157,
		"y": -56.707751659,
		"h": 2.2527472527
	},
	{
		"stop_id": 8579486,
		"ID": 438,
		"x": -56.5122947117,
		"y": -55.92279757,
		"h": 2.2527472527
	},
	{
		"stop_id": 8579488,
		"ID": 438,
		"x": -57.4522437767,
		"y": -55.634853167,
		"h": 2.2527472527
	},
	{
		"stop_id": 8580235,
		"ID": 438,
		"x": -58.2272569087,
		"y": -58.041816354,
		"h": 2.2527472527
	},
	{
		"stop_id": 8580661,
		"ID": 438,
		"x": -58.5652920127,
		"y": -57.190806098,
		"h": 2.2527472527
	},
	{
		"stop_id": 8588515,
		"ID": 438,
		"x": -57.9222522457,
		"y": -58.986752285,
		"h": 2.2527472527
	},
	{
		"stop_id": 8588516,
		"ID": 438,
		"x": -57.7422755187,
		"y": -60.269768235,
		"h": 2.2527472527
	},
	{
		"stop_id": 8588525,
		"ID": 438,
		"x": -53.4422373077,
		"y": -58.239766214,
		"h": 2.2527472527
	},
	{
		"stop_id": 8594611,
		"ID": 438,
		"x": -54.1482486967,
		"y": -56.794858477,
		"h": 2.2527472527
	},
	{
		"stop_id": 8594612,
		"ID": 438,
		"x": -54.5882621437,
		"y": -57.063820015,
		"h": 2.2527472527
	},
	{
		"stop_id": 8594613,
		"ID": 438,
		"x": -54.8823003197,
		"y": -57.267826206,
		"h": 2.2527472527
	},
	{
		"stop_id": 8594614,
		"ID": 438,
		"x": -54.2472699127,
		"y": -57.071749819,
		"h": 2.2527472527
	},
	{
		"stop_id": 8595608,
		"ID": 438,
		"x": -54.1062674877,
		"y": -56.936778079,
		"h": 2.2527472527
	},
	{
		"stop_id": 8501442,
		"ID": 759,
		"x": -9.4112576617,
		"y": -40.610813498,
		"h": 1.7252747253
	},
	{
		"stop_id": 8501443,
		"ID": 759,
		"x": -8.6272541837,
		"y": -42.152809721,
		"h": 1.7252747253
	},
	{
		"stop_id": 8501646,
		"ID": 759,
		"x": -6.0612274017,
		"y": -43.025782727,
		"h": 1.7252747253
	},
	{
		"stop_id": 8501671,
		"ID": 759,
		"x": -4.8682698167,
		"y": -42.259769642,
		"h": 1.7252747253
	},
	{
		"stop_id": 8501672,
		"ID": 759,
		"x": -6.3722605717,
		"y": -43.247766646,
		"h": 1.7252747253
	},
	{
		"stop_id": 8501729,
		"ID": 759,
		"x": -6.5102933337,
		"y": -43.894768482,
		"h": 1.7252747253
	},
	{
		"stop_id": 8501896,
		"ID": 759,
		"x": -5.3582524427,
		"y": -43.751764893,
		"h": 1.7252747253
	},
	{
		"stop_id": 8501898,
		"ID": 759,
		"x": -5.5892775557,
		"y": -40.882775823,
		"h": 1.7252747253
	},
	{
		"stop_id": 8505745,
		"ID": 759,
		"x": -4.6182523117,
		"y": -42.625796826,
		"h": 1.7252747253
	},
	{
		"stop_id": 8505746,
		"ID": 759,
		"x": -4.4272403397,
		"y": -42.482752654,
		"h": 1.7252747253
	},
	{
		"stop_id": 8530250,
		"ID": 759,
		"x": -4.8682293107,
		"y": -42.255767164,
		"h": 1.7252747253
	},
	{
		"stop_id": 8530251,
		"ID": 759,
		"x": -4.2382365847,
		"y": -41.018801055,
		"h": 1.7252747253
	},
	{
		"stop_id": 8530252,
		"ID": 759,
		"x": -4.1942398667,
		"y": -40.486782057,
		"h": 1.7252747253
	},
	{
		"stop_id": 8578897,
		"ID": 759,
		"x": -6.3402691377,
		"y": -43.812780381,
		"h": 1.7252747253
	},
	{
		"stop_id": 8578899,
		"ID": 759,
		"x": -5.7402499637,
		"y": -43.969750968,
		"h": 1.7252747253
	},
	{
		"stop_id": 8579348,
		"ID": 759,
		"x": -6.3462725577,
		"y": -43.255763385,
		"h": 1.7252747253
	},
	{
		"stop_id": 8579349,
		"ID": 759,
		"x": -4.9542865427,
		"y": -42.389841379,
		"h": 1.7252747253
	},
	{
		"stop_id": 8579354,
		"ID": 759,
		"x": -4.6972782517,
		"y": -42.847856913,
		"h": 1.7252747253
	},
	{
		"stop_id": 8579366,
		"ID": 759,
		"x": -6.0422914907,
		"y": -43.269853703,
		"h": 1.7252747253
	},
	{
		"stop_id": 8579367,
		"ID": 759,
		"x": -5.5942669057,
		"y": -41.217774603,
		"h": 1.7252747253
	},
	{
		"stop_id": 8589088,
		"ID": 759,
		"x": -6.1822903687,
		"y": -42.91980183,
		"h": 1.7252747253
	},
	{
		"stop_id": 8589089,
		"ID": 759,
		"x": -6.3322853617,
		"y": -43.419836935,
		"h": 1.7252747253
	},
	{
		"stop_id": 8589090,
		"ID": 759,
		"x": -6.0722626297,
		"y": -42.519837288,
		"h": 1.7252747253
	},
	{
		"stop_id": 8501446,
		"ID": 255,
		"x": -87.7172982877,
		"y": -53.8697541,
		"h": 1.1978021978
	},
	{
		"stop_id": 8501497,
		"ID": 255,
		"x": -88.1782350637,
		"y": -54.331827017,
		"h": 1.1978021978
	},
	{
		"stop_id": 8501498,
		"ID": 255,
		"x": -87.9562481497,
		"y": -53.059792895,
		"h": 1.1978021978
	},
	{
		"stop_id": 8501499,
		"ID": 255,
		"x": -87.8552455927,
		"y": -52.444848017,
		"h": 1.1978021978
	},
	{
		"stop_id": 8501704,
		"ID": 255,
		"x": -83.7672345447,
		"y": -52.151837243,
		"h": 1.1978021978
	},
	{
		"stop_id": 8530041,
		"ID": 255,
		"x": -85.4812304407,
		"y": -55.439831198,
		"h": 1.1978021978
	},
	{
		"stop_id": 8530043,
		"ID": 255,
		"x": -88.6032300167,
		"y": -52.423857067,
		"h": 1.1978021978
	},
	{
		"stop_id": 8501447,
		"ID": 222,
		"x": -88.8342330327,
		"y": -55.571759156,
		"h": 2.0879120879
	},
	{
		"stop_id": 8501458,
		"ID": 222,
		"x": -93.9782634307,
		"y": -56.307786652,
		"h": 2.0879120879
	},
	{
		"stop_id": 8501461,
		"ID": 222,
		"x": -94.0722431097,
		"y": -55.203808238,
		"h": 2.0879120879
	},
	{
		"stop_id": 8501491,
		"ID": 222,
		"x": -89.6332848577,
		"y": -58.079770176,
		"h": 2.0879120879
	},
	{
		"stop_id": 8501494,
		"ID": 222,
		"x": -88.7132868707,
		"y": -55.851814458,
		"h": 2.0879120879
	},
	{
		"stop_id": 8501495,
		"ID": 222,
		"x": -89.2083001157,
		"y": -55.292803521,
		"h": 2.0879120879
	},
	{
		"stop_id": 8501557,
		"ID": 222,
		"x": -91.7432964937,
		"y": -55.93576047,
		"h": 2.0879120879
	},
	{
		"stop_id": 8501558,
		"ID": 222,
		"x": -91.4172357617,
		"y": -56.301776192,
		"h": 2.0879120879
	},
	{
		"stop_id": 8501707,
		"ID": 222,
		"x": -88.2392747487,
		"y": -55.7538024,
		"h": 2.0879120879
	},
	{
		"stop_id": 8501777,
		"ID": 222,
		"x": -92.4882529157,
		"y": -53.662844201,
		"h": 2.0879120879
	},
	{
		"stop_id": 8504687,
		"ID": 222,
		"x": -92.5472979747,
		"y": -56.486828545,
		"h": 2.0879120879
	},
	{
		"stop_id": 8504688,
		"ID": 222,
		"x": -92.1392643197,
		"y": -56.927810642,
		"h": 2.0879120879
	},
	{
		"stop_id": 8504689,
		"ID": 222,
		"x": -91.5422558087,
		"y": -56.669858276,
		"h": 2.0879120879
	},
	{
		"stop_id": 8530042,
		"ID": 222,
		"x": -89.3022771267,
		"y": -54.469821912,
		"h": 2.0879120879
	},
	{
		"stop_id": 8530355,
		"ID": 222,
		"x": -93.7922317337,
		"y": -55.818815922,
		"h": 2.0879120879
	},
	{
		"stop_id": 8570607,
		"ID": 222,
		"x": -94.0342694547,
		"y": -55.192796507,
		"h": 2.0879120879
	},
	{
		"stop_id": 8570608,
		"ID": 222,
		"x": -93.5912693307,
		"y": -55.080798346,
		"h": 2.0879120879
	},
	{
		"stop_id": 8570609,
		"ID": 222,
		"x": -93.5212262427,
		"y": -54.516796599,
		"h": 2.0879120879
	},
	{
		"stop_id": 8570610,
		"ID": 222,
		"x": -93.4122266907,
		"y": -54.106755811,
		"h": 2.0879120879
	},
	{
		"stop_id": 8570611,
		"ID": 222,
		"x": -92.8992951887,
		"y": -53.869812641,
		"h": 2.0879120879
	},
	{
		"stop_id": 8570612,
		"ID": 222,
		"x": -92.6632662747,
		"y": -53.632764914,
		"h": 2.0879120879
	},
	{
		"stop_id": 8570613,
		"ID": 222,
		"x": -92.0802521807,
		"y": -53.873818767,
		"h": 2.0879120879
	},
	{
		"stop_id": 8570642,
		"ID": 222,
		"x": -92.2052493907,
		"y": -58.174859485,
		"h": 2.0879120879
	},
	{
		"stop_id": 8570645,
		"ID": 222,
		"x": -91.4792312887,
		"y": -57.991852734,
		"h": 2.0879120879
	},
	{
		"stop_id": 8579114,
		"ID": 222,
		"x": -89.2422731177,
		"y": -55.369786903,
		"h": 2.0879120879
	},
	{
		"stop_id": 8579126,
		"ID": 222,
		"x": -89.5392676777,
		"y": -54.843841804,
		"h": 2.0879120879
	},
	{
		"stop_id": 8579127,
		"ID": 222,
		"x": -89.9422898687,
		"y": -54.669749571,
		"h": 2.0879120879
	},
	{
		"stop_id": 8579128,
		"ID": 222,
		"x": -90.1702468357,
		"y": -54.740749968,
		"h": 2.0879120879
	},
	{
		"stop_id": 8579129,
		"ID": 222,
		"x": -90.5162607737,
		"y": -55.115847919,
		"h": 2.0879120879
	},
	{
		"stop_id": 8579130,
		"ID": 222,
		"x": -90.7803002347,
		"y": -55.380849293,
		"h": 2.0879120879
	},
	{
		"stop_id": 8579131,
		"ID": 222,
		"x": -91.3232596017,
		"y": -55.707749362,
		"h": 2.0879120879
	},
	{
		"stop_id": 8579132,
		"ID": 222,
		"x": -93.4432419397,
		"y": -55.561757886,
		"h": 2.0879120879
	},
	{
		"stop_id": 8580900,
		"ID": 222,
		"x": -91.5892776117,
		"y": -58.086764856,
		"h": 2.0879120879
	},
	{
		"stop_id": 8593772,
		"ID": 222,
		"x": -89.5532924297,
		"y": -57.804806412,
		"h": 2.0879120879
	},
	{
		"stop_id": 8501448,
		"ID": 160,
		"x": -103.5402467087,
		"y": -68.690781202,
		"h": 1.2307692308
	},
	{
		"stop_id": 8501451,
		"ID": 160,
		"x": -103.5672504267,
		"y": -68.697811431,
		"h": 1.2307692308
	},
	{
		"stop_id": 8501453,
		"ID": 160,
		"x": -102.3522453717,
		"y": -66.555833746,
		"h": 1.2307692308
	},
	{
		"stop_id": 8501454,
		"ID": 160,
		"x": -101.3482287927,
		"y": -64.580812686,
		"h": 1.2307692308
	},
	{
		"stop_id": 8501465,
		"ID": 160,
		"x": -101.8402709617,
		"y": -65.517775551,
		"h": 1.2307692308
	},
	{
		"stop_id": 8501466,
		"ID": 160,
		"x": -103.2762458347,
		"y": -67.96775777,
		"h": 1.2307692308
	},
	{
		"stop_id": 8530463,
		"ID": 160,
		"x": -102.3242818117,
		"y": -66.246760384,
		"h": 1.2307692308
	},
	{
		"stop_id": 8579062,
		"ID": 160,
		"x": -101.8712642797,
		"y": -65.545796227,
		"h": 1.2307692308
	},
	{
		"stop_id": 8501450,
		"ID": 137,
		"x": -105.5242350227,
		"y": -68.647842734,
		"h": 1.0989010989
	},
	{
		"stop_id": 8501891,
		"ID": 137,
		"x": -106.3422651197,
		"y": -67.669751922,
		"h": 1.0989010989
	},
	{
		"stop_id": 8530078,
		"ID": 137,
		"x": -106.4262531607,
		"y": -67.676774426,
		"h": 1.0989010989
	},
	{
		"stop_id": 8530751,
		"ID": 137,
		"x": -105.9422324817,
		"y": -68.369852602,
		"h": 1.0989010989
	},
	{
		"stop_id": 8501477,
		"ID": 288,
		"x": -83.1802722167,
		"y": -48.940786967,
		"h": 1.4285714286
	},
	{
		"stop_id": 8501479,
		"ID": 288,
		"x": -81.5742371507,
		"y": -49.221854497,
		"h": 1.4285714286
	},
	{
		"stop_id": 8501555,
		"ID": 288,
		"x": -79.3902971017,
		"y": -47.871830097,
		"h": 1.4285714286
	},
	{
		"stop_id": 8501705,
		"ID": 288,
		"x": -83.5592320817,
		"y": -51.4158553,
		"h": 1.4285714286
	},
	{
		"stop_id": 8501706,
		"ID": 288,
		"x": -82.4132302207,
		"y": -49.65585546,
		"h": 1.4285714286
	},
	{
		"stop_id": 8501978,
		"ID": 288,
		"x": -81.5492856057,
		"y": -49.218832363,
		"h": 1.4285714286
	},
	{
		"stop_id": 8530038,
		"ID": 288,
		"x": -81.1672317627,
		"y": -49.343821796,
		"h": 1.4285714286
	},
	{
		"stop_id": 8571278,
		"ID": 288,
		"x": -79.4262907797,
		"y": -49.39279311,
		"h": 1.4285714286
	},
	{
		"stop_id": 8571279,
		"ID": 288,
		"x": -79.9822650747,
		"y": -49.424853064,
		"h": 1.4285714286
	},
	{
		"stop_id": 8571280,
		"ID": 288,
		"x": -81.1422772547,
		"y": -49.296776314,
		"h": 1.4285714286
	},
	{
		"stop_id": 8579125,
		"ID": 288,
		"x": -81.5352828067,
		"y": -49.220772933,
		"h": 1.4285714286
	},
	{
		"stop_id": 8593773,
		"ID": 288,
		"x": -82.6022828877,
		"y": -48.739799706,
		"h": 1.4285714286
	},
	{
		"stop_id": 8593774,
		"ID": 288,
		"x": -82.1802470367,
		"y": -48.800751364,
		"h": 1.4285714286
	},
	{
		"stop_id": 8593776,
		"ID": 288,
		"x": -83.5602345347,
		"y": -48.945853522,
		"h": 1.4285714286
	},
	{
		"stop_id": 8501490,
		"ID": 254,
		"x": -89.2532474877,
		"y": -58.477840273,
		"h": 1.3626373626
	},
	{
		"stop_id": 8501492,
		"ID": 254,
		"x": -88.9522898777,
		"y": -57.814751821,
		"h": 1.3626373626
	},
	{
		"stop_id": 8501493,
		"ID": 254,
		"x": -88.1162774797,
		"y": -56.799792432,
		"h": 1.3626373626
	},
	{
		"stop_id": 8501708,
		"ID": 254,
		"x": -86.3422573357,
		"y": -56.869803262,
		"h": 1.3626373626
	},
	{
		"stop_id": 8501727,
		"ID": 254,
		"x": -88.3052403537,
		"y": -56.176812109,
		"h": 1.3626373626
	},
	{
		"stop_id": 8501778,
		"ID": 254,
		"x": -86.3962239677,
		"y": -59.679851426,
		"h": 1.3626373626
	},
	{
		"stop_id": 8504691,
		"ID": 254,
		"x": -88.1702789347,
		"y": -59.327798639,
		"h": 1.3626373626
	},
	{
		"stop_id": 8530040,
		"ID": 254,
		"x": -87.6262733837,
		"y": -56.690801744,
		"h": 1.3626373626
	},
	{
		"stop_id": 8570648,
		"ID": 254,
		"x": -89.0412692257,
		"y": -58.881853152,
		"h": 1.3626373626
	},
	{
		"stop_id": 8570649,
		"ID": 254,
		"x": -86.6242394317,
		"y": -59.817797161,
		"h": 1.3626373626
	},
	{
		"stop_id": 8587098,
		"ID": 254,
		"x": -88.0642625667,
		"y": -56.752791319,
		"h": 1.3626373626
	},
	{
		"stop_id": 8588193,
		"ID": 254,
		"x": -88.3452882087,
		"y": -57.356765943,
		"h": 1.3626373626
	},
	{
		"stop_id": 8501506,
		"ID": 377,
		"x": -65.8722872467,
		"y": -62.999787713,
		"h": 4.2307692308
	},
	{
		"stop_id": 8501740,
		"ID": 377,
		"x": -67.7542738517,
		"y": -66.652804175,
		"h": 4.2307692308
	},
	{
		"stop_id": 8501741,
		"ID": 377,
		"x": -67.2822935247,
		"y": -66.600834771,
		"h": 4.2307692308
	},
	{
		"stop_id": 8501745,
		"ID": 377,
		"x": -65.5732255747,
		"y": -66.30081683,
		"h": 4.2307692308
	},
	{
		"stop_id": 8501775,
		"ID": 377,
		"x": -65.0492583467,
		"y": -65.808841182,
		"h": 4.2307692308
	},
	{
		"stop_id": 8501994,
		"ID": 377,
		"x": -65.9342371977,
		"y": -62.996833573,
		"h": 4.2307692308
	},
	{
		"stop_id": 8530119,
		"ID": 377,
		"x": -67.1422657127,
		"y": -66.54575988,
		"h": 4.2307692308
	},
	{
		"stop_id": 8530121,
		"ID": 377,
		"x": -65.6412599067,
		"y": -66.405801693,
		"h": 4.2307692308
	},
	{
		"stop_id": 8570695,
		"ID": 377,
		"x": -66.8012891597,
		"y": -62.881817666,
		"h": 4.2307692308
	},
	{
		"stop_id": 8570696,
		"ID": 377,
		"x": -67.8832554837,
		"y": -63.171810369,
		"h": 4.2307692308
	},
	{
		"stop_id": 8570697,
		"ID": 377,
		"x": -68.9012311197,
		"y": -63.274838245,
		"h": 4.2307692308
	},
	{
		"stop_id": 8570732,
		"ID": 377,
		"x": -65.8502566277,
		"y": -62.127827785,
		"h": 4.2307692308
	},
	{
		"stop_id": 8570733,
		"ID": 377,
		"x": -66.3952240417,
		"y": -61.959831089,
		"h": 4.2307692308
	},
	{
		"stop_id": 8570734,
		"ID": 377,
		"x": -67.4032338947,
		"y": -62.170841241,
		"h": 4.2307692308
	},
	{
		"stop_id": 8570735,
		"ID": 377,
		"x": -67.4782262617,
		"y": -61.820795746,
		"h": 4.2307692308
	},
	{
		"stop_id": 8570736,
		"ID": 377,
		"x": -67.3222753737,
		"y": -61.592772242,
		"h": 4.2307692308
	},
	{
		"stop_id": 8570737,
		"ID": 377,
		"x": -66.9852859317,
		"y": -61.472797002,
		"h": 4.2307692308
	},
	{
		"stop_id": 8570770,
		"ID": 377,
		"x": -65.7672411207,
		"y": -61.5038289,
		"h": 4.2307692308
	},
	{
		"stop_id": 8570827,
		"ID": 377,
		"x": -65.4952829137,
		"y": -61.756776135,
		"h": 4.2307692308
	},
	{
		"stop_id": 8570835,
		"ID": 377,
		"x": -66.6962273507,
		"y": -63.560828832,
		"h": 4.2307692308
	},
	{
		"stop_id": 8570836,
		"ID": 377,
		"x": -66.9032456927,
		"y": -63.883854448,
		"h": 4.2307692308
	},
	{
		"stop_id": 8570837,
		"ID": 377,
		"x": -68.0642585077,
		"y": -64.227857789,
		"h": 4.2307692308
	},
	{
		"stop_id": 8570838,
		"ID": 377,
		"x": -68.7132663057,
		"y": -64.45281119,
		"h": 4.2307692308
	},
	{
		"stop_id": 8570851,
		"ID": 377,
		"x": -64.5802553497,
		"y": -63.513781122,
		"h": 4.2307692308
	},
	{
		"stop_id": 8570852,
		"ID": 377,
		"x": -65.7862644407,
		"y": -64.069844006,
		"h": 4.2307692308
	},
	{
		"stop_id": 8570853,
		"ID": 377,
		"x": -66.1122971427,
		"y": -64.294838333,
		"h": 4.2307692308
	},
	{
		"stop_id": 8570854,
		"ID": 377,
		"x": -66.8152514467,
		"y": -64.774840433,
		"h": 4.2307692308
	},
	{
		"stop_id": 8570855,
		"ID": 377,
		"x": -67.1422778917,
		"y": -64.992774798,
		"h": 4.2307692308
	},
	{
		"stop_id": 8570856,
		"ID": 377,
		"x": -67.9572839957,
		"y": -65.452828829,
		"h": 4.2307692308
	},
	{
		"stop_id": 8570875,
		"ID": 377,
		"x": -67.4852284097,
		"y": -66.526762071,
		"h": 4.2307692308
	},
	{
		"stop_id": 8570876,
		"ID": 377,
		"x": -66.4222367947,
		"y": -64.806751648,
		"h": 4.2307692308
	},
	{
		"stop_id": 8570877,
		"ID": 377,
		"x": -66.5832494397,
		"y": -65.03179146,
		"h": 4.2307692308
	},
	{
		"stop_id": 8570878,
		"ID": 377,
		"x": -66.0452450847,
		"y": -64.887755685,
		"h": 4.2307692308
	},
	{
		"stop_id": 8570879,
		"ID": 377,
		"x": -65.4312957417,
		"y": -64.710839865,
		"h": 4.2307692308
	},
	{
		"stop_id": 8570880,
		"ID": 377,
		"x": -65.0262268187,
		"y": -64.641844639,
		"h": 4.2307692308
	},
	{
		"stop_id": 8570881,
		"ID": 377,
		"x": -64.9972655757,
		"y": -64.79283312,
		"h": 4.2307692308
	},
	{
		"stop_id": 8570882,
		"ID": 377,
		"x": -64.8342908057,
		"y": -64.904807025,
		"h": 4.2307692308
	},
	{
		"stop_id": 8570883,
		"ID": 377,
		"x": -65.1482900517,
		"y": -65.211792733,
		"h": 4.2307692308
	},
	{
		"stop_id": 8570884,
		"ID": 377,
		"x": -64.5282957557,
		"y": -65.107826541,
		"h": 4.2307692308
	},
	{
		"stop_id": 8570885,
		"ID": 377,
		"x": -64.3082518747,
		"y": -64.99783406,
		"h": 4.2307692308
	},
	{
		"stop_id": 8570886,
		"ID": 377,
		"x": -65.1422949117,
		"y": -65.580756977,
		"h": 4.2307692308
	},
	{
		"stop_id": 8570887,
		"ID": 377,
		"x": -64.6702852997,
		"y": -65.644752135,
		"h": 4.2307692308
	},
	{
		"stop_id": 8570888,
		"ID": 377,
		"x": -65.1472968027,
		"y": -66.075773228,
		"h": 4.2307692308
	},
	{
		"stop_id": 8570889,
		"ID": 377,
		"x": -64.8612514967,
		"y": -62.956829456,
		"h": 4.2307692308
	},
	{
		"stop_id": 8570890,
		"ID": 377,
		"x": -64.0262378427,
		"y": -63.057759702,
		"h": 4.2307692308
	},
	{
		"stop_id": 8570892,
		"ID": 377,
		"x": -63.5682591657,
		"y": -63.535750456,
		"h": 4.2307692308
	},
	{
		"stop_id": 8573943,
		"ID": 377,
		"x": -65.9842789047,
		"y": -61.785855397,
		"h": 4.2307692308
	},
	{
		"stop_id": 8579389,
		"ID": 377,
		"x": -66.6352613447,
		"y": -62.680801454,
		"h": 4.2307692308
	},
	{
		"stop_id": 8579435,
		"ID": 377,
		"x": -65.8422445467,
		"y": -62.969803742,
		"h": 4.2307692308
	},
	{
		"stop_id": 8579508,
		"ID": 377,
		"x": -65.6772780207,
		"y": -62.564771412,
		"h": 4.2307692308
	},
	{
		"stop_id": 8579513,
		"ID": 377,
		"x": -63.5422464397,
		"y": -63.519759322,
		"h": 4.2307692308
	},
	{
		"stop_id": 8579520,
		"ID": 377,
		"x": -63.9322324057,
		"y": -65.529815812,
		"h": 4.2307692308
	},
	{
		"stop_id": 8579670,
		"ID": 377,
		"x": -66.6642474367,
		"y": -63.996857406,
		"h": 4.2307692308
	},
	{
		"stop_id": 8580672,
		"ID": 377,
		"x": -64.6872692957,
		"y": -64.903819056,
		"h": 4.2307692308
	},
	{
		"stop_id": 8580814,
		"ID": 377,
		"x": -66.0962732907,
		"y": -62.286760431,
		"h": 4.2307692308
	},
	{
		"stop_id": 8580818,
		"ID": 377,
		"x": -65.9452547937,
		"y": -62.684780451,
		"h": 4.2307692308
	},
	{
		"stop_id": 8581067,
		"ID": 377,
		"x": -64.9242586407,
		"y": -65.148849312,
		"h": 4.2307692308
	},
	{
		"stop_id": 8581400,
		"ID": 377,
		"x": -67.4342545957,
		"y": -63.981800189,
		"h": 4.2307692308
	},
	{
		"stop_id": 8582387,
		"ID": 377,
		"x": -64.3962639237,
		"y": -65.134833183,
		"h": 4.2307692308
	},
	{
		"stop_id": 8582452,
		"ID": 377,
		"x": -64.5742581597,
		"y": -62.968852481,
		"h": 4.2307692308
	},
	{
		"stop_id": 8582505,
		"ID": 377,
		"x": -68.0822674647,
		"y": -63.249797479,
		"h": 4.2307692308
	},
	{
		"stop_id": 8582580,
		"ID": 377,
		"x": -67.8362565217,
		"y": -66.307857897,
		"h": 4.2307692308
	},
	{
		"stop_id": 8582711,
		"ID": 377,
		"x": -65.5222985087,
		"y": -62.811822001,
		"h": 4.2307692308
	},
	{
		"stop_id": 8582944,
		"ID": 377,
		"x": -66.1692684797,
		"y": -62.231766663,
		"h": 4.2307692308
	},
	{
		"stop_id": 8582969,
		"ID": 377,
		"x": -65.7472745097,
		"y": -61.744855793,
		"h": 4.2307692308
	},
	{
		"stop_id": 8583259,
		"ID": 377,
		"x": -67.5462967417,
		"y": -63.447838029,
		"h": 4.2307692308
	},
	{
		"stop_id": 8583260,
		"ID": 377,
		"x": -66.4862523537,
		"y": -62.237754175,
		"h": 4.2307692308
	},
	{
		"stop_id": 8583261,
		"ID": 377,
		"x": -66.9212930677,
		"y": -62.524833534,
		"h": 4.2307692308
	},
	{
		"stop_id": 8583262,
		"ID": 377,
		"x": -65.8132465137,
		"y": -62.600763646,
		"h": 4.2307692308
	},
	{
		"stop_id": 8583263,
		"ID": 377,
		"x": -65.0772595387,
		"y": -61.644776012,
		"h": 4.2307692308
	},
	{
		"stop_id": 8583264,
		"ID": 377,
		"x": -68.2312234927,
		"y": -63.609765139,
		"h": 4.2307692308
	},
	{
		"stop_id": 8583266,
		"ID": 377,
		"x": -66.8712332187,
		"y": -62.401833072,
		"h": 4.2307692308
	},
	{
		"stop_id": 8583267,
		"ID": 377,
		"x": -66.9152501047,
		"y": -63.018749395,
		"h": 4.2307692308
	},
	{
		"stop_id": 8583268,
		"ID": 377,
		"x": -67.1382244597,
		"y": -63.084844073,
		"h": 4.2307692308
	},
	{
		"stop_id": 8583269,
		"ID": 377,
		"x": -67.9272872537,
		"y": -63.380852945,
		"h": 4.2307692308
	},
	{
		"stop_id": 8583270,
		"ID": 377,
		"x": -65.9342677257,
		"y": -62.951811491,
		"h": 4.2307692308
	},
	{
		"stop_id": 8583271,
		"ID": 377,
		"x": -68.7682854717,
		"y": -63.834758707,
		"h": 4.2307692308
	},
	{
		"stop_id": 8583272,
		"ID": 377,
		"x": -66.3022378497,
		"y": -62.13979959,
		"h": 4.2307692308
	},
	{
		"stop_id": 8583274,
		"ID": 377,
		"x": -67.6322326147,
		"y": -63.199826222,
		"h": 4.2307692308
	},
	{
		"stop_id": 8583275,
		"ID": 377,
		"x": -64.6162599817,
		"y": -62.063819829,
		"h": 4.2307692308
	},
	{
		"stop_id": 8583276,
		"ID": 377,
		"x": -64.1582756867,
		"y": -63.721766156,
		"h": 4.2307692308
	},
	{
		"stop_id": 8583277,
		"ID": 377,
		"x": -66.3122420647,
		"y": -62.679830805,
		"h": 4.2307692308
	},
	{
		"stop_id": 8583278,
		"ID": 377,
		"x": -66.5222253187,
		"y": -62.46382424,
		"h": 4.2307692308
	},
	{
		"stop_id": 8583279,
		"ID": 377,
		"x": -67.1552611487,
		"y": -63.322828549,
		"h": 4.2307692308
	},
	{
		"stop_id": 8583280,
		"ID": 377,
		"x": -66.0662269927,
		"y": -62.615842268,
		"h": 4.2307692308
	},
	{
		"stop_id": 8583281,
		"ID": 377,
		"x": -64.8772601247,
		"y": -62.194776049,
		"h": 4.2307692308
	},
	{
		"stop_id": 8583282,
		"ID": 377,
		"x": -65.3332555657,
		"y": -62.4538266,
		"h": 4.2307692308
	},
	{
		"stop_id": 8583283,
		"ID": 377,
		"x": -65.5312655587,
		"y": -62.670855415,
		"h": 4.2307692308
	},
	{
		"stop_id": 8583284,
		"ID": 377,
		"x": -64.4212531037,
		"y": -62.165803751,
		"h": 4.2307692308
	},
	{
		"stop_id": 8583285,
		"ID": 377,
		"x": -66.6462253607,
		"y": -62.554838244,
		"h": 4.2307692308
	},
	{
		"stop_id": 8583287,
		"ID": 377,
		"x": -64.9582526017,
		"y": -62.628807116,
		"h": 4.2307692308
	},
	{
		"stop_id": 8583289,
		"ID": 377,
		"x": -69.1112892507,
		"y": -63.399797729,
		"h": 4.2307692308
	},
	{
		"stop_id": 8583368,
		"ID": 377,
		"x": -64.1402693337,
		"y": -62.848796489,
		"h": 4.2307692308
	},
	{
		"stop_id": 8583370,
		"ID": 377,
		"x": -68.5122272527,
		"y": -63.759768063,
		"h": 4.2307692308
	},
	{
		"stop_id": 8583373,
		"ID": 377,
		"x": -66.8142713217,
		"y": -62.768858129,
		"h": 4.2307692308
	},
	{
		"stop_id": 8583376,
		"ID": 377,
		"x": -65.5562329337,
		"y": -62.720855662,
		"h": 4.2307692308
	},
	{
		"stop_id": 8583419,
		"ID": 377,
		"x": -66.7002400827,
		"y": -62.631813435,
		"h": 4.2307692308
	},
	{
		"stop_id": 8583808,
		"ID": 377,
		"x": -67.7622874657,
		"y": -67.04576453,
		"h": 4.2307692308
	},
	{
		"stop_id": 8588814,
		"ID": 377,
		"x": -65.7422886357,
		"y": -62.694770177,
		"h": 4.2307692308
	},
	{
		"stop_id": 8501509,
		"ID": 470,
		"x": -52.4842495237,
		"y": -55.820856475,
		"h": 3.2747252747
	},
	{
		"stop_id": 8501588,
		"ID": 470,
		"x": -51.3652301517,
		"y": -53.597782673,
		"h": 3.2747252747
	},
	{
		"stop_id": 8501590,
		"ID": 470,
		"x": -52.7092742047,
		"y": -55.74675036,
		"h": 3.2747252747
	},
	{
		"stop_id": 8501591,
		"ID": 470,
		"x": -52.9502483447,
		"y": -55.32281641,
		"h": 3.2747252747
	},
	{
		"stop_id": 8501592,
		"ID": 470,
		"x": -53.6132253097,
		"y": -54.780808664,
		"h": 3.2747252747
	},
	{
		"stop_id": 8501593,
		"ID": 470,
		"x": -53.9432566137,
		"y": -54.658848815,
		"h": 3.2747252747
	},
	{
		"stop_id": 8501859,
		"ID": 470,
		"x": -51.8652881457,
		"y": -56.963757656,
		"h": 3.2747252747
	},
	{
		"stop_id": 8501996,
		"ID": 470,
		"x": -52.5702989517,
		"y": -55.843858278,
		"h": 3.2747252747
	},
	{
		"stop_id": 8505681,
		"ID": 470,
		"x": -50.1232728357,
		"y": -56.112841935,
		"h": 3.2747252747
	},
	{
		"stop_id": 8505686,
		"ID": 470,
		"x": -52.3582389387,
		"y": -57.426822238,
		"h": 3.2747252747
	},
	{
		"stop_id": 8505691,
		"ID": 470,
		"x": -50.9922641567,
		"y": -58.24875065,
		"h": 3.2747252747
	},
	{
		"stop_id": 8505696,
		"ID": 470,
		"x": -51.2972388017,
		"y": -57.357856638,
		"h": 3.2747252747
	},
	{
		"stop_id": 8570943,
		"ID": 470,
		"x": -52.7872996527,
		"y": -55.845776899,
		"h": 3.2747252747
	},
	{
		"stop_id": 8570944,
		"ID": 470,
		"x": -51.9742383677,
		"y": -56.687762647,
		"h": 3.2747252747
	},
	{
		"stop_id": 8570945,
		"ID": 470,
		"x": -51.8102318227,
		"y": -57.219811309,
		"h": 3.2747252747
	},
	{
		"stop_id": 8570947,
		"ID": 470,
		"x": -51.6952447907,
		"y": -55.282826657,
		"h": 3.2747252747
	},
	{
		"stop_id": 8579409,
		"ID": 470,
		"x": -52.5422952677,
		"y": -55.869837987,
		"h": 3.2747252747
	},
	{
		"stop_id": 8579410,
		"ID": 470,
		"x": -52.4782552677,
		"y": -55.612859021,
		"h": 3.2747252747
	},
	{
		"stop_id": 8579454,
		"ID": 470,
		"x": -52.2352744437,
		"y": -55.063852831,
		"h": 3.2747252747
	},
	{
		"stop_id": 8579455,
		"ID": 470,
		"x": -51.8872488447,
		"y": -54.814848768,
		"h": 3.2747252747
	},
	{
		"stop_id": 8579456,
		"ID": 470,
		"x": -51.9652726057,
		"y": -54.532811244,
		"h": 3.2747252747
	},
	{
		"stop_id": 8579457,
		"ID": 470,
		"x": -51.7422511097,
		"y": -54.164787774,
		"h": 3.2747252747
	},
	{
		"stop_id": 8579458,
		"ID": 470,
		"x": -51.9592311797,
		"y": -54.37683861,
		"h": 3.2747252747
	},
	{
		"stop_id": 8579459,
		"ID": 470,
		"x": -52.9822651747,
		"y": -54.521794832,
		"h": 3.2747252747
	},
	{
		"stop_id": 8579460,
		"ID": 470,
		"x": -52.9512363107,
		"y": -53.880781391,
		"h": 3.2747252747
	},
	{
		"stop_id": 8579461,
		"ID": 470,
		"x": -52.8992897757,
		"y": -53.627822379,
		"h": 3.2747252747
	},
	{
		"stop_id": 8579474,
		"ID": 470,
		"x": -52.8942290987,
		"y": -55.735844122,
		"h": 3.2747252747
	},
	{
		"stop_id": 8579475,
		"ID": 470,
		"x": -53.2852870447,
		"y": -55.825758185,
		"h": 3.2747252747
	},
	{
		"stop_id": 8579476,
		"ID": 470,
		"x": -54.0922866737,
		"y": -56.301788903,
		"h": 3.2747252747
	},
	{
		"stop_id": 8579477,
		"ID": 470,
		"x": -54.1482245957,
		"y": -55.89375247,
		"h": 3.2747252747
	},
	{
		"stop_id": 8579551,
		"ID": 470,
		"x": -50.1122380377,
		"y": -54.709806281,
		"h": 3.2747252747
	},
	{
		"stop_id": 8579552,
		"ID": 470,
		"x": -49.5442446037,
		"y": -53.611789767,
		"h": 3.2747252747
	},
	{
		"stop_id": 8581299,
		"ID": 470,
		"x": -50.5212366007,
		"y": -55.753837723,
		"h": 3.2747252747
	},
	{
		"stop_id": 8582217,
		"ID": 470,
		"x": -52.3162808137,
		"y": -56.181830505,
		"h": 3.2747252747
	},
	{
		"stop_id": 8587111,
		"ID": 470,
		"x": -52.7542668427,
		"y": -54.207829618,
		"h": 3.2747252747
	},
	{
		"stop_id": 8588284,
		"ID": 470,
		"x": -48.4422485957,
		"y": -55.419836577,
		"h": 3.2747252747
	},
	{
		"stop_id": 8588294,
		"ID": 470,
		"x": -52.3262285087,
		"y": -55.542753122,
		"h": 3.2747252747
	},
	{
		"stop_id": 8594604,
		"ID": 470,
		"x": -51.2752741837,
		"y": -55.469793524,
		"h": 3.2747252747
	},
	{
		"stop_id": 8594605,
		"ID": 470,
		"x": -51.9272531917,
		"y": -55.342824292,
		"h": 3.2747252747
	},
	{
		"stop_id": 8594606,
		"ID": 470,
		"x": -53.1552751547,
		"y": -55.978805174,
		"h": 3.2747252747
	},
	{
		"stop_id": 8594607,
		"ID": 470,
		"x": -53.4382270837,
		"y": -56.372851242,
		"h": 3.2747252747
	},
	{
		"stop_id": 8594608,
		"ID": 470,
		"x": -53.5242933707,
		"y": -56.617836615,
		"h": 3.2747252747
	},
	{
		"stop_id": 8594609,
		"ID": 470,
		"x": -53.5903001227,
		"y": -56.736850299,
		"h": 3.2747252747
	},
	{
		"stop_id": 8594610,
		"ID": 470,
		"x": -53.9372523447,
		"y": -56.926837523,
		"h": 3.2747252747
	},
	{
		"stop_id": 8594615,
		"ID": 470,
		"x": -52.4122664117,
		"y": -55.699822545,
		"h": 3.2747252747
	},
	{
		"stop_id": 8594616,
		"ID": 470,
		"x": -51.1782924587,
		"y": -55.282789021,
		"h": 3.2747252747
	},
	{
		"stop_id": 8594617,
		"ID": 470,
		"x": -51.3472765867,
		"y": -55.222772607,
		"h": 3.2747252747
	},
	{
		"stop_id": 8594620,
		"ID": 470,
		"x": -51.8512548317,
		"y": -55.062812108,
		"h": 3.2747252747
	},
	{
		"stop_id": 8594621,
		"ID": 470,
		"x": -52.0842985997,
		"y": -55.151819205,
		"h": 3.2747252747
	},
	{
		"stop_id": 8594622,
		"ID": 470,
		"x": -52.4012671797,
		"y": -55.298836011,
		"h": 3.2747252747
	},
	{
		"stop_id": 8594623,
		"ID": 470,
		"x": -52.6152315627,
		"y": -55.112776644,
		"h": 3.2747252747
	},
	{
		"stop_id": 8594624,
		"ID": 470,
		"x": -52.7792277247,
		"y": -55.220796309,
		"h": 3.2747252747
	},
	{
		"stop_id": 8594625,
		"ID": 470,
		"x": -52.9502953477,
		"y": -55.349829631,
		"h": 3.2747252747
	},
	{
		"stop_id": 8594626,
		"ID": 470,
		"x": -53.1682774767,
		"y": -55.42577177,
		"h": 3.2747252747
	},
	{
		"stop_id": 8594628,
		"ID": 470,
		"x": -53.0372427627,
		"y": -55.883852714,
		"h": 3.2747252747
	},
	{
		"stop_id": 8594629,
		"ID": 470,
		"x": -53.0662620577,
		"y": -56.195814394,
		"h": 3.2747252747
	},
	{
		"stop_id": 8594630,
		"ID": 470,
		"x": -53.0492635377,
		"y": -56.376772939,
		"h": 3.2747252747
	},
	{
		"stop_id": 8594631,
		"ID": 470,
		"x": -52.9242332877,
		"y": -56.538824844,
		"h": 3.2747252747
	},
	{
		"stop_id": 8594632,
		"ID": 470,
		"x": -52.5972545307,
		"y": -56.383819911,
		"h": 3.2747252747
	},
	{
		"stop_id": 8594633,
		"ID": 470,
		"x": -52.1592571747,
		"y": -56.091815729,
		"h": 3.2747252747
	},
	{
		"stop_id": 8594634,
		"ID": 470,
		"x": -52.0082618427,
		"y": -56.234807077,
		"h": 3.2747252747
	},
	{
		"stop_id": 8594635,
		"ID": 470,
		"x": -52.1332953537,
		"y": -56.640829047,
		"h": 3.2747252747
	},
	{
		"stop_id": 8594636,
		"ID": 470,
		"x": -51.9762498667,
		"y": -56.68176228,
		"h": 3.2747252747
	},
	{
		"stop_id": 8594637,
		"ID": 470,
		"x": -51.9232533647,
		"y": -56.839771705,
		"h": 3.2747252747
	},
	{
		"stop_id": 8594638,
		"ID": 470,
		"x": -52.8342511467,
		"y": -55.894854118,
		"h": 3.2747252747
	},
	{
		"stop_id": 8594706,
		"ID": 470,
		"x": -51.4462905327,
		"y": -53.750857065,
		"h": 3.2747252747
	},
	{
		"stop_id": 8594707,
		"ID": 470,
		"x": -53.4492393757,
		"y": -53.687776211,
		"h": 3.2747252747
	},
	{
		"stop_id": 8594714,
		"ID": 470,
		"x": -52.4412444237,
		"y": -55.567792889,
		"h": 3.2747252747
	},
	{
		"stop_id": 8594721,
		"ID": 470,
		"x": -53.0322304937,
		"y": -55.886848672,
		"h": 3.2747252747
	},
	{
		"stop_id": 8595130,
		"ID": 470,
		"x": -51.0312283117,
		"y": -55.799832873,
		"h": 3.2747252747
	},
	{
		"stop_id": 8501515,
		"ID": 537,
		"x": -41.2202384247,
		"y": -51.602785393,
		"h": 1.2307692308
	},
	{
		"stop_id": 8501519,
		"ID": 537,
		"x": -43.0562246487,
		"y": -52.532792596,
		"h": 1.2307692308
	},
	{
		"stop_id": 8501648,
		"ID": 537,
		"x": -40.2892551227,
		"y": -52.55178063,
		"h": 1.2307692308
	},
	{
		"stop_id": 8501649,
		"ID": 537,
		"x": -42.4282846957,
		"y": -52.183750693,
		"h": 1.2307692308
	},
	{
		"stop_id": 8501991,
		"ID": 537,
		"x": -42.5572346327,
		"y": -52.608770231,
		"h": 1.2307692308
	},
	{
		"stop_id": 8501992,
		"ID": 537,
		"x": -41.6202967197,
		"y": -52.347804216,
		"h": 1.2307692308
	},
	{
		"stop_id": 8579541,
		"ID": 537,
		"x": -41.8492560127,
		"y": -52.664750646,
		"h": 1.2307692308
	},
	{
		"stop_id": 8588868,
		"ID": 537,
		"x": -42.0322767587,
		"y": -52.209842387,
		"h": 1.2307692308
	},
	{
		"stop_id": 8501516,
		"ID": 503,
		"x": -46.8682700757,
		"y": -52.968842559,
		"h": 1.6923076923
	},
	{
		"stop_id": 8501517,
		"ID": 503,
		"x": -44.3222442187,
		"y": -52.781819284,
		"h": 1.6923076923
	},
	{
		"stop_id": 8501518,
		"ID": 503,
		"x": -43.7752356327,
		"y": -52.751834558,
		"h": 1.6923076923
	},
	{
		"stop_id": 8501600,
		"ID": 503,
		"x": -48.9292650497,
		"y": -53.888751869,
		"h": 1.6923076923
	},
	{
		"stop_id": 8501601,
		"ID": 503,
		"x": -43.9272813377,
		"y": -53.606762587,
		"h": 1.6923076923
	},
	{
		"stop_id": 8501650,
		"ID": 503,
		"x": -43.9272813377,
		"y": -53.606762587,
		"h": 1.6923076923
	},
	{
		"stop_id": 8501651,
		"ID": 503,
		"x": -44.7422750347,
		"y": -52.769754787,
		"h": 1.6923076923
	},
	{
		"stop_id": 8501652,
		"ID": 503,
		"x": -44.6362748737,
		"y": -50.457805054,
		"h": 1.6923076923
	},
	{
		"stop_id": 8501653,
		"ID": 503,
		"x": -45.6482382587,
		"y": -51.097774657,
		"h": 1.6923076923
	},
	{
		"stop_id": 8501654,
		"ID": 503,
		"x": -45.9602649747,
		"y": -50.037750778,
		"h": 1.6923076923
	},
	{
		"stop_id": 8501735,
		"ID": 503,
		"x": -45.1392841577,
		"y": -51.473755447,
		"h": 1.6923076923
	},
	{
		"stop_id": 8579537,
		"ID": 503,
		"x": -45.0852272387,
		"y": -52.14284134,
		"h": 1.6923076923
	},
	{
		"stop_id": 8579540,
		"ID": 503,
		"x": -44.5312389027,
		"y": -50.802822566,
		"h": 1.6923076923
	},
	{
		"stop_id": 8579548,
		"ID": 503,
		"x": -44.7752771637,
		"y": -50.226814297,
		"h": 1.6923076923
	},
	{
		"stop_id": 8587880,
		"ID": 503,
		"x": -43.6432833307,
		"y": -52.147856739,
		"h": 1.6923076923
	},
	{
		"stop_id": 8588123,
		"ID": 503,
		"x": -44.9002281387,
		"y": -52.997810197,
		"h": 1.6923076923
	},
	{
		"stop_id": 8588148,
		"ID": 503,
		"x": -44.3192860527,
		"y": -51.067750509,
		"h": 1.6923076923
	},
	{
		"stop_id": 8588282,
		"ID": 503,
		"x": -43.8222609047,
		"y": -53.909858766,
		"h": 1.6923076923
	},
	{
		"stop_id": 8588283,
		"ID": 503,
		"x": -47.1702852827,
		"y": -54.902753501,
		"h": 1.6923076923
	},
	{
		"stop_id": 8588295,
		"ID": 503,
		"x": -46.2922298127,
		"y": -52.679786449,
		"h": 1.6923076923
	},
	{
		"stop_id": 8588296,
		"ID": 503,
		"x": -44.8022406607,
		"y": -50.094816184,
		"h": 1.6923076923
	},
	{
		"stop_id": 8589217,
		"ID": 503,
		"x": -48.9562999497,
		"y": -53.934822358,
		"h": 1.6923076923
	},
	{
		"stop_id": 8501520,
		"ID": 570,
		"x": -39.0012763897,
		"y": -52.591753056,
		"h": 1.7582417582
	},
	{
		"stop_id": 8501603,
		"ID": 570,
		"x": -35.9422750307,
		"y": -54.17785171,
		"h": 1.7582417582
	},
	{
		"stop_id": 8501972,
		"ID": 570,
		"x": -36.1672965997,
		"y": -53.270838576,
		"h": 1.7582417582
	},
	{
		"stop_id": 8501973,
		"ID": 570,
		"x": -35.3122745307,
		"y": -52.831790394,
		"h": 1.7582417582
	},
	{
		"stop_id": 8507473,
		"ID": 570,
		"x": -34.6422600827,
		"y": -52.382829619,
		"h": 1.7582417582
	},
	{
		"stop_id": 8530183,
		"ID": 570,
		"x": -36.5842861357,
		"y": -53.181846831,
		"h": 1.7582417582
	},
	{
		"stop_id": 8530184,
		"ID": 570,
		"x": -37.8592557647,
		"y": -51.985772471,
		"h": 1.7582417582
	},
	{
		"stop_id": 8571018,
		"ID": 570,
		"x": -35.8052617757,
		"y": -52.841762892,
		"h": 1.7582417582
	},
	{
		"stop_id": 8571128,
		"ID": 570,
		"x": -35.9562769827,
		"y": -54.18279801,
		"h": 1.7582417582
	},
	{
		"stop_id": 8571129,
		"ID": 570,
		"x": -35.6962457547,
		"y": -53.33379667,
		"h": 1.7582417582
	},
	{
		"stop_id": 8571130,
		"ID": 570,
		"x": -36.1192349447,
		"y": -53.743773958,
		"h": 1.7582417582
	},
	{
		"stop_id": 8571131,
		"ID": 570,
		"x": -35.9402841027,
		"y": -53.625793274,
		"h": 1.7582417582
	},
	{
		"stop_id": 8571132,
		"ID": 570,
		"x": -35.4852874337,
		"y": -53.61576198,
		"h": 1.7582417582
	},
	{
		"stop_id": 8571134,
		"ID": 570,
		"x": -36.1352958587,
		"y": -53.002803825,
		"h": 1.7582417582
	},
	{
		"stop_id": 8579554,
		"ID": 570,
		"x": -36.5822451907,
		"y": -53.191843968,
		"h": 1.7582417582
	},
	{
		"stop_id": 8579555,
		"ID": 570,
		"x": -36.2342317587,
		"y": -53.251755832,
		"h": 1.7582417582
	},
	{
		"stop_id": 8579556,
		"ID": 570,
		"x": -35.9992536267,
		"y": -53.222825478,
		"h": 1.7582417582
	},
	{
		"stop_id": 8579557,
		"ID": 570,
		"x": -35.4452969537,
		"y": -53.195838584,
		"h": 1.7582417582
	},
	{
		"stop_id": 8579559,
		"ID": 570,
		"x": -33.9302711357,
		"y": -53.294845173,
		"h": 1.7582417582
	},
	{
		"stop_id": 8580441,
		"ID": 570,
		"x": -36.0132351897,
		"y": -52.917840677,
		"h": 1.7582417582
	},
	{
		"stop_id": 8580751,
		"ID": 570,
		"x": -36.3942741347,
		"y": -53.217802201,
		"h": 1.7582417582
	},
	{
		"stop_id": 8587834,
		"ID": 570,
		"x": -38.7122780937,
		"y": -53.573796481,
		"h": 1.7582417582
	},
	{
		"stop_id": 8587835,
		"ID": 570,
		"x": -38.4822730027,
		"y": -53.525859554,
		"h": 1.7582417582
	},
	{
		"stop_id": 8587836,
		"ID": 570,
		"x": -35.9882662107,
		"y": -53.215778938,
		"h": 1.7582417582
	},
	{
		"stop_id": 8501521,
		"ID": 536,
		"x": -42.0732718087,
		"y": -53.549841616,
		"h": 1.8571428571
	},
	{
		"stop_id": 8501522,
		"ID": 536,
		"x": -42.9852701367,
		"y": -53.487843006,
		"h": 1.8571428571
	},
	{
		"stop_id": 8501523,
		"ID": 536,
		"x": -43.6972906607,
		"y": -54.469804129,
		"h": 1.8571428571
	},
	{
		"stop_id": 8501524,
		"ID": 536,
		"x": -43.5782287357,
		"y": -55.26176542,
		"h": 1.8571428571
	},
	{
		"stop_id": 8501525,
		"ID": 536,
		"x": -43.0652825387,
		"y": -55.401779882,
		"h": 1.8571428571
	},
	{
		"stop_id": 8501526,
		"ID": 536,
		"x": -42.8132923237,
		"y": -55.242782049,
		"h": 1.8571428571
	},
	{
		"stop_id": 8501527,
		"ID": 536,
		"x": -43.0372718217,
		"y": -54.464798784,
		"h": 1.8571428571
	},
	{
		"stop_id": 8501602,
		"ID": 536,
		"x": -39.6392772157,
		"y": -53.878757578,
		"h": 1.8571428571
	},
	{
		"stop_id": 8501990,
		"ID": 536,
		"x": -42.4142608607,
		"y": -55.205748819,
		"h": 1.8571428571
	},
	{
		"stop_id": 8530180,
		"ID": 536,
		"x": -39.4902318787,
		"y": -55.071848898,
		"h": 1.8571428571
	},
	{
		"stop_id": 8530181,
		"ID": 536,
		"x": -39.6662462887,
		"y": -55.714750577,
		"h": 1.8571428571
	},
	{
		"stop_id": 8530182,
		"ID": 536,
		"x": -39.9482555717,
		"y": -56.809772045,
		"h": 1.8571428571
	},
	{
		"stop_id": 8579535,
		"ID": 536,
		"x": -43.2802980527,
		"y": -53.232858894,
		"h": 1.8571428571
	},
	{
		"stop_id": 8579542,
		"ID": 536,
		"x": -39.6012375597,
		"y": -53.87385116,
		"h": 1.8571428571
	},
	{
		"stop_id": 8579544,
		"ID": 536,
		"x": -39.0552641477,
		"y": -56.339783326,
		"h": 1.8571428571
	},
	{
		"stop_id": 8579546,
		"ID": 536,
		"x": -38.4622251757,
		"y": -55.659840887,
		"h": 1.8571428571
	},
	{
		"stop_id": 8587318,
		"ID": 536,
		"x": -39.4852235817,
		"y": -55.071832164,
		"h": 1.8571428571
	},
	{
		"stop_id": 8587319,
		"ID": 536,
		"x": -39.2422450577,
		"y": -54.694830089,
		"h": 1.8571428571
	},
	{
		"stop_id": 8587454,
		"ID": 536,
		"x": -39.9552907827,
		"y": -56.826803381,
		"h": 1.8571428571
	},
	{
		"stop_id": 8587832,
		"ID": 536,
		"x": -39.5612983437,
		"y": -53.652831842,
		"h": 1.8571428571
	},
	{
		"stop_id": 8588187,
		"ID": 536,
		"x": -43.2112894737,
		"y": -54.190807581,
		"h": 1.8571428571
	},
	{
		"stop_id": 8588188,
		"ID": 536,
		"x": -42.7812679407,
		"y": -54.873844943,
		"h": 1.8571428571
	},
	{
		"stop_id": 8588285,
		"ID": 536,
		"x": -42.8362830107,
		"y": -54.734819125,
		"h": 1.8571428571
	},
	{
		"stop_id": 8588286,
		"ID": 536,
		"x": -43.6272635987,
		"y": -54.844802456,
		"h": 1.8571428571
	},
	{
		"stop_id": 8589515,
		"ID": 536,
		"x": -39.5172877567,
		"y": -54.098793552,
		"h": 1.8571428571
	},
	{
		"stop_id": 8590450,
		"ID": 536,
		"x": -40.2422682977,
		"y": -52.744835701,
		"h": 1.8571428571
	},
	{
		"stop_id": 8594333,
		"ID": 536,
		"x": -39.3112789507,
		"y": -54.694840839,
		"h": 1.8571428571
	},
	{
		"stop_id": 8501528,
		"ID": 248,
		"x": -85.1182795367,
		"y": -92.3728075473,
		"h": 1.1978021978
	},
	{
		"stop_id": 8501884,
		"ID": 248,
		"x": -86.1222960747,
		"y": -95.5697497814,
		"h": 1.1978021978
	},
	{
		"stop_id": 8504673,
		"ID": 248,
		"x": -85.4722584217,
		"y": -93.2097518824,
		"h": 1.1978021978
	},
	{
		"stop_id": 8579447,
		"ID": 248,
		"x": -84.7342322067,
		"y": -91.4768260678,
		"h": 1.1978021978
	},
	{
		"stop_id": 8579448,
		"ID": 248,
		"x": -84.9962565767,
		"y": -91.9277522508,
		"h": 1.1978021978
	},
	{
		"stop_id": 8579449,
		"ID": 248,
		"x": -85.6422328137,
		"y": -93.919843473,
		"h": 1.1978021978
	},
	{
		"stop_id": 8579450,
		"ID": 248,
		"x": -85.9742719257,
		"y": -94.4708158139,
		"h": 1.1978021978
	},
	{
		"stop_id": 8501529,
		"ID": 282,
		"x": -83.3212549727,
		"y": -84.4917820633,
		"h": 1.3956043956
	},
	{
		"stop_id": 8501530,
		"ID": 282,
		"x": -80.8922847987,
		"y": -85.6197757586,
		"h": 1.3956043956
	},
	{
		"stop_id": 8501532,
		"ID": 282,
		"x": -83.6152239577,
		"y": -85.6247654645,
		"h": 1.3956043956
	},
	{
		"stop_id": 8501533,
		"ID": 282,
		"x": -81.6422742497,
		"y": -84.8198116559,
		"h": 1.3956043956
	},
	{
		"stop_id": 8501534,
		"ID": 282,
		"x": -83.4222398427,
		"y": -86.1197768252,
		"h": 1.3956043956
	},
	{
		"stop_id": 8501577,
		"ID": 282,
		"x": -82.1812404977,
		"y": -82.410832594,
		"h": 1.3956043956
	},
	{
		"stop_id": 8501578,
		"ID": 282,
		"x": -82.5732417237,
		"y": -85.1717743126,
		"h": 1.3956043956
	},
	{
		"stop_id": 8504672,
		"ID": 282,
		"x": -80.6382306017,
		"y": -87.1537756467,
		"h": 1.3956043956
	},
	{
		"stop_id": 8579444,
		"ID": 282,
		"x": -83.1972811897,
		"y": -85.0877905425,
		"h": 1.3956043956
	},
	{
		"stop_id": 8579452,
		"ID": 282,
		"x": -82.5622761817,
		"y": -85.1798197656,
		"h": 1.3956043956
	},
	{
		"stop_id": 8587286,
		"ID": 282,
		"x": -81.8872800217,
		"y": -84.3157742598,
		"h": 1.3956043956
	},
	{
		"stop_id": 8593538,
		"ID": 282,
		"x": -82.9912480347,
		"y": -85.6777759277,
		"h": 1.3956043956
	},
	{
		"stop_id": 8593539,
		"ID": 282,
		"x": -82.3702850057,
		"y": -84.8618223282,
		"h": 1.3956043956
	},
	{
		"stop_id": 8501531,
		"ID": 249,
		"x": -84.0072844317,
		"y": -87.859799686,
		"h": 1.1978021978
	},
	{
		"stop_id": 8501882,
		"ID": 249,
		"x": -84.6922328577,
		"y": -84.8798201018,
		"h": 1.1978021978
	},
	{
		"stop_id": 8530087,
		"ID": 249,
		"x": -85.4532920177,
		"y": -84.746790871,
		"h": 1.1978021978
	},
	{
		"stop_id": 8530088,
		"ID": 249,
		"x": -85.7192800537,
		"y": -85.8327689184,
		"h": 1.1978021978
	},
	{
		"stop_id": 8587476,
		"ID": 249,
		"x": -85.4422597997,
		"y": -84.7198238715,
		"h": 1.1978021978
	},
	{
		"stop_id": 8593537,
		"ID": 249,
		"x": -84.3872299477,
		"y": -85.2037905624,
		"h": 1.1978021978
	},
	{
		"stop_id": 8595612,
		"ID": 249,
		"x": -84.4112555137,
		"y": -85.3607731947,
		"h": 1.1978021978
	},
	{
		"stop_id": 8501535,
		"ID": 185,
		"x": -97.5212966197,
		"y": -80.293802671,
		"h": 1.7912087912
	},
	{
		"stop_id": 8501536,
		"ID": 185,
		"x": -95.0632762287,
		"y": -78.682804175,
		"h": 1.7912087912
	},
	{
		"stop_id": 8501537,
		"ID": 185,
		"x": -96.4042840517,
		"y": -79.293815731,
		"h": 1.7912087912
	},
	{
		"stop_id": 8501538,
		"ID": 185,
		"x": -97.2302825437,
		"y": -79.605809524,
		"h": 1.7912087912
	},
	{
		"stop_id": 8501552,
		"ID": 185,
		"x": -97.8373000587,
		"y": -80.736831533,
		"h": 1.7912087912
	},
	{
		"stop_id": 8501553,
		"ID": 185,
		"x": -98.5532370237,
		"y": -80.568755124,
		"h": 1.7912087912
	},
	{
		"stop_id": 8501565,
		"ID": 185,
		"x": -95.5022903907,
		"y": -79.040856494,
		"h": 1.7912087912
	},
	{
		"stop_id": 8501566,
		"ID": 185,
		"x": -96.9372913877,
		"y": -81.481811436,
		"h": 1.7912087912
	},
	{
		"stop_id": 8501568,
		"ID": 185,
		"x": -97.5152439457,
		"y": -82.213838741,
		"h": 1.7912087912
	},
	{
		"stop_id": 8501787,
		"ID": 185,
		"x": -94.0952840867,
		"y": -81.876799062,
		"h": 1.7912087912
	},
	{
		"stop_id": 8501864,
		"ID": 185,
		"x": -93.6052783927,
		"y": -81.776839806,
		"h": 1.7912087912
	},
	{
		"stop_id": 8530686,
		"ID": 185,
		"x": -96.9162467837,
		"y": -81.318855955,
		"h": 1.7912087912
	},
	{
		"stop_id": 8530823,
		"ID": 185,
		"x": -98.6772490677,
		"y": -80.62476628,
		"h": 1.7912087912
	},
	{
		"stop_id": 8530831,
		"ID": 185,
		"x": -97.1822506257,
		"y": -81.09676913,
		"h": 1.7912087912
	},
	{
		"stop_id": 8530832,
		"ID": 185,
		"x": -98.6922380367,
		"y": -80.849787102,
		"h": 1.7912087912
	},
	{
		"stop_id": 8570983,
		"ID": 185,
		"x": -93.9112264657,
		"y": -82.8347801608,
		"h": 1.7912087912
	},
	{
		"stop_id": 8570984,
		"ID": 185,
		"x": -94.9322780817,
		"y": -80.685822953,
		"h": 1.7912087912
	},
	{
		"stop_id": 8570985,
		"ID": 185,
		"x": -95.6082234417,
		"y": -80.246853152,
		"h": 1.7912087912
	},
	{
		"stop_id": 8570986,
		"ID": 185,
		"x": -96.9522963517,
		"y": -81.744855992,
		"h": 1.7912087912
	},
	{
		"stop_id": 8570987,
		"ID": 185,
		"x": -97.5392528007,
		"y": -82.265827208,
		"h": 1.7912087912
	},
	{
		"stop_id": 8579568,
		"ID": 185,
		"x": -95.3612854337,
		"y": -79.083820847,
		"h": 1.7912087912
	},
	{
		"stop_id": 8579569,
		"ID": 185,
		"x": -95.9042504567,
		"y": -78.872827053,
		"h": 1.7912087912
	},
	{
		"stop_id": 8580642,
		"ID": 185,
		"x": -94.3902542227,
		"y": -81.311826923,
		"h": 1.7912087912
	},
	{
		"stop_id": 8580648,
		"ID": 185,
		"x": -96.4462879937,
		"y": -81.347847716,
		"h": 1.7912087912
	},
	{
		"stop_id": 8580649,
		"ID": 185,
		"x": -96.0052519537,
		"y": -80.611789089,
		"h": 1.7912087912
	},
	{
		"stop_id": 8501541,
		"ID": 439,
		"x": -57.3912826177,
		"y": -54.431800265,
		"h": 2.8461538462
	},
	{
		"stop_id": 8501542,
		"ID": 439,
		"x": -57.3612455837,
		"y": -54.003802755,
		"h": 2.8461538462
	},
	{
		"stop_id": 8501543,
		"ID": 439,
		"x": -56.5202722947,
		"y": -53.629796332,
		"h": 2.8461538462
	},
	{
		"stop_id": 8501545,
		"ID": 439,
		"x": -54.8772675307,
		"y": -52.344757419,
		"h": 2.8461538462
	},
	{
		"stop_id": 8501587,
		"ID": 439,
		"x": -57.4742429627,
		"y": -54.259858403,
		"h": 2.8461538462
	},
	{
		"stop_id": 8501589,
		"ID": 439,
		"x": -53.4552439697,
		"y": -53.167751331,
		"h": 2.8461538462
	},
	{
		"stop_id": 8501594,
		"ID": 439,
		"x": -54.3622261327,
		"y": -54.312840606,
		"h": 2.8461538462
	},
	{
		"stop_id": 8501595,
		"ID": 439,
		"x": -55.0872561407,
		"y": -53.708806578,
		"h": 2.8461538462
	},
	{
		"stop_id": 8501596,
		"ID": 439,
		"x": -55.8462361517,
		"y": -53.512794786,
		"h": 2.8461538462
	},
	{
		"stop_id": 8501597,
		"ID": 439,
		"x": -55.9932677527,
		"y": -55.317764899,
		"h": 2.8461538462
	},
	{
		"stop_id": 8501598,
		"ID": 439,
		"x": -56.1202959607,
		"y": -55.112852166,
		"h": 2.8461538462
	},
	{
		"stop_id": 8501599,
		"ID": 439,
		"x": -56.5462530297,
		"y": -55.078848606,
		"h": 2.8461538462
	},
	{
		"stop_id": 8501795,
		"ID": 439,
		"x": -57.6252797127,
		"y": -54.148857387,
		"h": 2.8461538462
	},
	{
		"stop_id": 8530159,
		"ID": 439,
		"x": -57.5322739937,
		"y": -53.986857453,
		"h": 2.8461538462
	},
	{
		"stop_id": 8530161,
		"ID": 439,
		"x": -56.7342770297,
		"y": -51.077773677,
		"h": 2.8461538462
	},
	{
		"stop_id": 8530166,
		"ID": 439,
		"x": -55.7122309077,
		"y": -53.58685564,
		"h": 2.8461538462
	},
	{
		"stop_id": 8530167,
		"ID": 439,
		"x": -55.1262572237,
		"y": -52.655767886,
		"h": 2.8461538462
	},
	{
		"stop_id": 8530169,
		"ID": 439,
		"x": -55.1492579587,
		"y": -50.2258251,
		"h": 2.8461538462
	},
	{
		"stop_id": 8570816,
		"ID": 439,
		"x": -58.6052335017,
		"y": -54.482827731,
		"h": 2.8461538462
	},
	{
		"stop_id": 8570817,
		"ID": 439,
		"x": -58.3292413877,
		"y": -54.240766062,
		"h": 2.8461538462
	},
	{
		"stop_id": 8570818,
		"ID": 439,
		"x": -58.0692717297,
		"y": -54.086850071,
		"h": 2.8461538462
	},
	{
		"stop_id": 8579463,
		"ID": 439,
		"x": -53.5932669167,
		"y": -53.252822065,
		"h": 2.8461538462
	},
	{
		"stop_id": 8579464,
		"ID": 439,
		"x": -54.0752925947,
		"y": -53.765759712,
		"h": 2.8461538462
	},
	{
		"stop_id": 8579465,
		"ID": 439,
		"x": -54.3122814667,
		"y": -53.729845924,
		"h": 2.8461538462
	},
	{
		"stop_id": 8579466,
		"ID": 439,
		"x": -54.6022971537,
		"y": -53.840816859,
		"h": 2.8461538462
	},
	{
		"stop_id": 8579467,
		"ID": 439,
		"x": -55.0422786047,
		"y": -53.494779203,
		"h": 2.8461538462
	},
	{
		"stop_id": 8579468,
		"ID": 439,
		"x": -54.9392272977,
		"y": -53.179768251,
		"h": 2.8461538462
	},
	{
		"stop_id": 8579469,
		"ID": 439,
		"x": -55.4022379757,
		"y": -53.174777343,
		"h": 2.8461538462
	},
	{
		"stop_id": 8579470,
		"ID": 439,
		"x": -55.8282287577,
		"y": -53.48476972,
		"h": 2.8461538462
	},
	{
		"stop_id": 8579471,
		"ID": 439,
		"x": -56.1512452107,
		"y": -53.569785665,
		"h": 2.8461538462
	},
	{
		"stop_id": 8579473,
		"ID": 439,
		"x": -56.9822309287,
		"y": -53.812775257,
		"h": 2.8461538462
	},
	{
		"stop_id": 8579487,
		"ID": 439,
		"x": -56.7232914327,
		"y": -55.444782414,
		"h": 2.8461538462
	},
	{
		"stop_id": 8579489,
		"ID": 439,
		"x": -57.4202924277,
		"y": -55.146825918,
		"h": 2.8461538462
	},
	{
		"stop_id": 8579490,
		"ID": 439,
		"x": -57.3022611897,
		"y": -54.919781377,
		"h": 2.8461538462
	},
	{
		"stop_id": 8579491,
		"ID": 439,
		"x": -57.3522847687,
		"y": -54.669790175,
		"h": 2.8461538462
	},
	{
		"stop_id": 8579493,
		"ID": 439,
		"x": -55.0272603877,
		"y": -52.68982029,
		"h": 2.8461538462
	},
	{
		"stop_id": 8587110,
		"ID": 439,
		"x": -55.0922344867,
		"y": -53.746828864,
		"h": 2.8461538462
	},
	{
		"stop_id": 8594694,
		"ID": 439,
		"x": -56.8932801087,
		"y": -54.932835839,
		"h": 2.8461538462
	},
	{
		"stop_id": 8594695,
		"ID": 439,
		"x": -58.0942239527,
		"y": -53.527806802,
		"h": 2.8461538462
	},
	{
		"stop_id": 8594696,
		"ID": 439,
		"x": -58.1322987897,
		"y": -53.745811588,
		"h": 2.8461538462
	},
	{
		"stop_id": 8594699,
		"ID": 439,
		"x": -57.1192945297,
		"y": -55.044767761,
		"h": 2.8461538462
	},
	{
		"stop_id": 8594700,
		"ID": 439,
		"x": -58.0132430097,
		"y": -53.324797463,
		"h": 2.8461538462
	},
	{
		"stop_id": 8594702,
		"ID": 439,
		"x": -57.7902782167,
		"y": -55.199755908,
		"h": 2.8461538462
	},
	{
		"stop_id": 8594703,
		"ID": 439,
		"x": -57.8072538007,
		"y": -54.122792445,
		"h": 2.8461538462
	},
	{
		"stop_id": 8594704,
		"ID": 439,
		"x": -57.4542876547,
		"y": -54.474844655,
		"h": 2.8461538462
	},
	{
		"stop_id": 8594708,
		"ID": 439,
		"x": -56.8122655447,
		"y": -53.706756755,
		"h": 2.8461538462
	},
	{
		"stop_id": 8594709,
		"ID": 439,
		"x": -54.6962605517,
		"y": -52.274799253,
		"h": 2.8461538462
	},
	{
		"stop_id": 8594710,
		"ID": 439,
		"x": -56.6352809897,
		"y": -54.090857396,
		"h": 2.8461538462
	},
	{
		"stop_id": 8594711,
		"ID": 439,
		"x": -55.2472236307,
		"y": -53.014810196,
		"h": 2.8461538462
	},
	{
		"stop_id": 8594712,
		"ID": 439,
		"x": -56.5832711407,
		"y": -53.505768488,
		"h": 2.8461538462
	},
	{
		"stop_id": 8594713,
		"ID": 439,
		"x": -56.4852818327,
		"y": -54.39381656,
		"h": 2.8461538462
	},
	{
		"stop_id": 8594716,
		"ID": 439,
		"x": -56.3542508077,
		"y": -53.940858896,
		"h": 2.8461538462
	},
	{
		"stop_id": 8594717,
		"ID": 439,
		"x": -56.3932899667,
		"y": -53.264773359,
		"h": 2.8461538462
	},
	{
		"stop_id": 8594718,
		"ID": 439,
		"x": -56.1702235707,
		"y": -53.121800882,
		"h": 2.8461538462
	},
	{
		"stop_id": 8594719,
		"ID": 439,
		"x": -55.8602663157,
		"y": -53.007780078,
		"h": 2.8461538462
	},
	{
		"stop_id": 8594720,
		"ID": 439,
		"x": -55.5722567077,
		"y": -52.689770133,
		"h": 2.8461538462
	},
	{
		"stop_id": 8595698,
		"ID": 439,
		"x": -56.7732275207,
		"y": -54.311810451,
		"h": 2.8461538462
	},
	{
		"stop_id": 8501546,
		"ID": 408,
		"x": -58.8962416537,
		"y": -55.5608413,
		"h": 2.3186813187
	},
	{
		"stop_id": 8501751,
		"ID": 408,
		"x": -62.2352692977,
		"y": -57.545758444,
		"h": 2.3186813187
	},
	{
		"stop_id": 8501965,
		"ID": 408,
		"x": -62.7272430647,
		"y": -55.328782773,
		"h": 2.3186813187
	},
	{
		"stop_id": 8530151,
		"ID": 408,
		"x": -63.1142916407,
		"y": -55.474756846,
		"h": 2.3186813187
	},
	{
		"stop_id": 8570782,
		"ID": 408,
		"x": -63.5002544127,
		"y": -57.160790712,
		"h": 2.3186813187
	},
	{
		"stop_id": 8570787,
		"ID": 408,
		"x": -62.5452909217,
		"y": -58.186820482,
		"h": 2.3186813187
	},
	{
		"stop_id": 8570788,
		"ID": 408,
		"x": -62.4672840417,
		"y": -57.705844739,
		"h": 2.3186813187
	},
	{
		"stop_id": 8570789,
		"ID": 408,
		"x": -61.9612657377,
		"y": -57.405800235,
		"h": 2.3186813187
	},
	{
		"stop_id": 8570790,
		"ID": 408,
		"x": -61.7452917837,
		"y": -56.748780214,
		"h": 2.3186813187
	},
	{
		"stop_id": 8570791,
		"ID": 408,
		"x": -62.0702704197,
		"y": -56.855823226,
		"h": 2.3186813187
	},
	{
		"stop_id": 8570792,
		"ID": 408,
		"x": -61.6822971497,
		"y": -55.742755851,
		"h": 2.3186813187
	},
	{
		"stop_id": 8570793,
		"ID": 408,
		"x": -61.9082361687,
		"y": -55.537798831,
		"h": 2.3186813187
	},
	{
		"stop_id": 8570794,
		"ID": 408,
		"x": -62.5012759517,
		"y": -55.72675333,
		"h": 2.3186813187
	},
	{
		"stop_id": 8570795,
		"ID": 408,
		"x": -62.2552648697,
		"y": -55.456843187,
		"h": 2.3186813187
	},
	{
		"stop_id": 8570796,
		"ID": 408,
		"x": -62.2772976347,
		"y": -55.0877651,
		"h": 2.3186813187
	},
	{
		"stop_id": 8570797,
		"ID": 408,
		"x": -62.9952837817,
		"y": -55.413793787,
		"h": 2.3186813187
	},
	{
		"stop_id": 8570798,
		"ID": 408,
		"x": -61.5522714007,
		"y": -56.64679368,
		"h": 2.3186813187
	},
	{
		"stop_id": 8570800,
		"ID": 408,
		"x": -60.8172637997,
		"y": -54.705810297,
		"h": 2.3186813187
	},
	{
		"stop_id": 8570801,
		"ID": 408,
		"x": -60.4182503137,
		"y": -54.148823953,
		"h": 2.3186813187
	},
	{
		"stop_id": 8570802,
		"ID": 408,
		"x": -60.0952322467,
		"y": -53.142810218,
		"h": 2.3186813187
	},
	{
		"stop_id": 8570803,
		"ID": 408,
		"x": -60.4542541517,
		"y": -53.166785983,
		"h": 2.3186813187
	},
	{
		"stop_id": 8570807,
		"ID": 408,
		"x": -61.2152639277,
		"y": -56.737822426,
		"h": 2.3186813187
	},
	{
		"stop_id": 8570808,
		"ID": 408,
		"x": -59.9882392447,
		"y": -56.002764452,
		"h": 2.3186813187
	},
	{
		"stop_id": 8570809,
		"ID": 408,
		"x": -59.7012578897,
		"y": -55.963753717,
		"h": 2.3186813187
	},
	{
		"stop_id": 8570810,
		"ID": 408,
		"x": -59.4372812227,
		"y": -56.971795921,
		"h": 2.3186813187
	},
	{
		"stop_id": 8570811,
		"ID": 408,
		"x": -59.1342766127,
		"y": -57.229791244,
		"h": 2.3186813187
	},
	{
		"stop_id": 8570812,
		"ID": 408,
		"x": -59.0322810907,
		"y": -56.698855952,
		"h": 2.3186813187
	},
	{
		"stop_id": 8570813,
		"ID": 408,
		"x": -58.6282831017,
		"y": -56.189774005,
		"h": 2.3186813187
	},
	{
		"stop_id": 8570815,
		"ID": 408,
		"x": -58.8182458757,
		"y": -55.114835861,
		"h": 2.3186813187
	},
	{
		"stop_id": 8575519,
		"ID": 408,
		"x": -63.1312771747,
		"y": -55.532775405,
		"h": 2.3186813187
	},
	{
		"stop_id": 8579485,
		"ID": 408,
		"x": -58.9472354507,
		"y": -56.997769798,
		"h": 2.3186813187
	},
	{
		"stop_id": 8580224,
		"ID": 408,
		"x": -61.8052955407,
		"y": -57.084811972,
		"h": 2.3186813187
	},
	{
		"stop_id": 8580231,
		"ID": 408,
		"x": -61.7622464507,
		"y": -57.858759853,
		"h": 2.3186813187
	},
	{
		"stop_id": 8580660,
		"ID": 408,
		"x": -62.5142390507,
		"y": -58.383820139,
		"h": 2.3186813187
	},
	{
		"stop_id": 8580666,
		"ID": 408,
		"x": -61.7992720767,
		"y": -57.48978927,
		"h": 2.3186813187
	},
	{
		"stop_id": 8580671,
		"ID": 408,
		"x": -62.2182751227,
		"y": -58.008769163,
		"h": 2.3186813187
	},
	{
		"stop_id": 8580674,
		"ID": 408,
		"x": -63.8593002487,
		"y": -56.743793763,
		"h": 2.3186813187
	},
	{
		"stop_id": 8582582,
		"ID": 408,
		"x": -59.4962644157,
		"y": -56.249779483,
		"h": 2.3186813187
	},
	{
		"stop_id": 8582963,
		"ID": 408,
		"x": -61.3452552327,
		"y": -56.910760974,
		"h": 2.3186813187
	},
	{
		"stop_id": 8594697,
		"ID": 408,
		"x": -58.7732382817,
		"y": -55.179749839,
		"h": 2.3186813187
	},
	{
		"stop_id": 8594698,
		"ID": 408,
		"x": -58.3882706197,
		"y": -55.25182662,
		"h": 2.3186813187
	},
	{
		"stop_id": 8501556,
		"ID": 186,
		"x": -94.0872315417,
		"y": -75.034769649,
		"h": 1.0989010989
	},
	{
		"stop_id": 8501564,
		"ID": 186,
		"x": -93.8402779207,
		"y": -76.825750434,
		"h": 1.0989010989
	},
	{
		"stop_id": 8530675,
		"ID": 186,
		"x": -93.1692604797,
		"y": -75.828761005,
		"h": 1.0989010989
	},
	{
		"stop_id": 8595435,
		"ID": 186,
		"x": -93.7332654077,
		"y": -76.731748607,
		"h": 1.0989010989
	},
	{
		"stop_id": 8501573,
		"ID": 218,
		"x": -89.1382628737,
		"y": -78.603767852,
		"h": 2.021978022
	},
	{
		"stop_id": 8530334,
		"ID": 218,
		"x": -93.0522687887,
		"y": -76.107771082,
		"h": 2.021978022
	},
	{
		"stop_id": 8570962,
		"ID": 218,
		"x": -88.6882481557,
		"y": -78.026753952,
		"h": 2.021978022
	},
	{
		"stop_id": 8570964,
		"ID": 218,
		"x": -89.6812444277,
		"y": -79.612844168,
		"h": 2.021978022
	},
	{
		"stop_id": 8570965,
		"ID": 218,
		"x": -90.0382532287,
		"y": -79.080795855,
		"h": 2.021978022
	},
	{
		"stop_id": 8570966,
		"ID": 218,
		"x": -90.1552848807,
		"y": -79.216834118,
		"h": 2.021978022
	},
	{
		"stop_id": 8570967,
		"ID": 218,
		"x": -90.6672671737,
		"y": -79.460809604,
		"h": 2.021978022
	},
	{
		"stop_id": 8570968,
		"ID": 218,
		"x": -90.9142741937,
		"y": -79.487778823,
		"h": 2.021978022
	},
	{
		"stop_id": 8570969,
		"ID": 218,
		"x": -91.4422707257,
		"y": -79.750838782,
		"h": 2.021978022
	},
	{
		"stop_id": 8570970,
		"ID": 218,
		"x": -90.7022585937,
		"y": -79.026853023,
		"h": 2.021978022
	},
	{
		"stop_id": 8570971,
		"ID": 218,
		"x": -90.2362931807,
		"y": -77.960784638,
		"h": 2.021978022
	},
	{
		"stop_id": 8570972,
		"ID": 218,
		"x": -90.0092701617,
		"y": -77.493797095,
		"h": 2.021978022
	},
	{
		"stop_id": 8570973,
		"ID": 218,
		"x": -90.2722722617,
		"y": -77.595750238,
		"h": 2.021978022
	},
	{
		"stop_id": 8570974,
		"ID": 218,
		"x": -89.9802546557,
		"y": -76.918760096,
		"h": 2.021978022
	},
	{
		"stop_id": 8570975,
		"ID": 218,
		"x": -89.2522817727,
		"y": -78.508831212,
		"h": 2.021978022
	},
	{
		"stop_id": 8570978,
		"ID": 218,
		"x": -89.3572455547,
		"y": -77.307817297,
		"h": 2.021978022
	},
	{
		"stop_id": 8570979,
		"ID": 218,
		"x": -91.7232961147,
		"y": -80.531761941,
		"h": 2.021978022
	},
	{
		"stop_id": 8570980,
		"ID": 218,
		"x": -92.0562316657,
		"y": -80.788793285,
		"h": 2.021978022
	},
	{
		"stop_id": 8570981,
		"ID": 218,
		"x": -92.1552538987,
		"y": -80.841846939,
		"h": 2.021978022
	},
	{
		"stop_id": 8570982,
		"ID": 218,
		"x": -92.6642547577,
		"y": -81.265764076,
		"h": 2.021978022
	},
	{
		"stop_id": 8570988,
		"ID": 218,
		"x": -92.2712972817,
		"y": -80.922821956,
		"h": 2.021978022
	},
	{
		"stop_id": 8580543,
		"ID": 218,
		"x": -88.9722935627,
		"y": -78.353777546,
		"h": 2.021978022
	},
	{
		"stop_id": 8580643,
		"ID": 218,
		"x": -91.6162232747,
		"y": -80.123783611,
		"h": 2.021978022
	},
	{
		"stop_id": 8580644,
		"ID": 218,
		"x": -90.0592448377,
		"y": -77.434850207,
		"h": 2.021978022
	},
	{
		"stop_id": 8580756,
		"ID": 218,
		"x": -91.3502893937,
		"y": -80.122843884,
		"h": 2.021978022
	},
	{
		"stop_id": 8582551,
		"ID": 218,
		"x": -92.9932770227,
		"y": -81.44383626,
		"h": 2.021978022
	},
	{
		"stop_id": 8583414,
		"ID": 218,
		"x": -90.9812573997,
		"y": -79.739784934,
		"h": 2.021978022
	},
	{
		"stop_id": 8583798,
		"ID": 218,
		"x": -88.8272278517,
		"y": -77.654786998,
		"h": 2.021978022
	},
	{
		"stop_id": 8583864,
		"ID": 218,
		"x": -90.3102879627,
		"y": -79.134789182,
		"h": 2.021978022
	},
	{
		"stop_id": 8583880,
		"ID": 218,
		"x": -88.9672665417,
		"y": -78.097782436,
		"h": 2.021978022
	},
	{
		"stop_id": 8593486,
		"ID": 218,
		"x": -93.1522562647,
		"y": -75.899780131,
		"h": 2.021978022
	},
	{
		"stop_id": 8595436,
		"ID": 218,
		"x": -93.1042666097,
		"y": -76.212760592,
		"h": 2.021978022
	},
	{
		"stop_id": 8501575,
		"ID": 250,
		"x": -87.3132580007,
		"y": -79.497812677,
		"h": 1.0659340659
	},
	{
		"stop_id": 8504670,
		"ID": 250,
		"x": -86.5022312137,
		"y": -83.0798369512,
		"h": 1.0659340659
	},
	{
		"stop_id": 8504671,
		"ID": 250,
		"x": -85.7422273747,
		"y": -84.2697572301,
		"h": 1.0659340659
	},
	{
		"stop_id": 8501576,
		"ID": 283,
		"x": -82.3602863817,
		"y": -79.684782801,
		"h": 1.2637362637
	},
	{
		"stop_id": 8501580,
		"ID": 283,
		"x": -81.0992429097,
		"y": -79.054826529,
		"h": 1.2637362637
	},
	{
		"stop_id": 8570672,
		"ID": 283,
		"x": -82.3312805477,
		"y": -79.665770454,
		"h": 1.2637362637
	},
	{
		"stop_id": 8570674,
		"ID": 283,
		"x": -81.2242359297,
		"y": -79.071836835,
		"h": 1.2637362637
	},
	{
		"stop_id": 8570675,
		"ID": 283,
		"x": -80.5132524417,
		"y": -78.602750831,
		"h": 1.2637362637
	},
	{
		"stop_id": 8570676,
		"ID": 283,
		"x": -80.0212282227,
		"y": -78.098833945,
		"h": 1.2637362637
	},
	{
		"stop_id": 8570677,
		"ID": 283,
		"x": -81.0652625967,
		"y": -77.448803051,
		"h": 1.2637362637
	},
	{
		"stop_id": 8583220,
		"ID": 283,
		"x": -80.8852931387,
		"y": -78.640813846,
		"h": 1.2637362637
	},
	{
		"stop_id": 8587225,
		"ID": 283,
		"x": -83.8222240657,
		"y": -78.449847789,
		"h": 1.2637362637
	},
	{
		"stop_id": 8501581,
		"ID": 380,
		"x": -67.2322875177,
		"y": -44.514780863,
		"h": 1
	},
	{
		"stop_id": 8501582,
		"ID": 862,
		"x": 12.7437040843,
		"y": -35.300809223,
		"h": 1.0989010989
	},
	{
		"stop_id": 8501897,
		"ID": 862,
		"x": 13.0667387183,
		"y": -34.751832631,
		"h": 1.0989010989
	},
	{
		"stop_id": 8575695,
		"ID": 862,
		"x": 15.9037315253,
		"y": -34.956802784,
		"h": 1.0989010989
	},
	{
		"stop_id": 8580392,
		"ID": 862,
		"x": 11.6747475043,
		"y": -34.775826311,
		"h": 1.0989010989
	},
	{
		"stop_id": 8501583,
		"ID": 699,
		"x": -13.8752839337,
		"y": -48.079770353,
		"h": 1.4945054945
	},
	{
		"stop_id": 8501698,
		"ID": 699,
		"x": -13.9972907847,
		"y": -46.105790584,
		"h": 1.4945054945
	},
	{
		"stop_id": 8501754,
		"ID": 699,
		"x": -17.7922311047,
		"y": -48.221841558,
		"h": 1.4945054945
	},
	{
		"stop_id": 8501953,
		"ID": 699,
		"x": -18.5052307887,
		"y": -46.837818898,
		"h": 1.4945054945
	},
	{
		"stop_id": 8530235,
		"ID": 699,
		"x": -17.7472983767,
		"y": -48.252767681,
		"h": 1.4945054945
	},
	{
		"stop_id": 8530236,
		"ID": 699,
		"x": -18.0992425687,
		"y": -47.597756678,
		"h": 1.4945054945
	},
	{
		"stop_id": 8530566,
		"ID": 699,
		"x": -19.0472253247,
		"y": -47.048820706,
		"h": 1.4945054945
	},
	{
		"stop_id": 8530688,
		"ID": 699,
		"x": -14.5492277497,
		"y": -46.336838973,
		"h": 1.4945054945
	},
	{
		"stop_id": 8530690,
		"ID": 699,
		"x": -13.4902906997,
		"y": -47.30677283,
		"h": 1.4945054945
	},
	{
		"stop_id": 8530824,
		"ID": 699,
		"x": -18.2762409167,
		"y": -46.286749896,
		"h": 1.4945054945
	},
	{
		"stop_id": 8571166,
		"ID": 699,
		"x": -17.9202811577,
		"y": -49.348858439,
		"h": 1.4945054945
	},
	{
		"stop_id": 8571167,
		"ID": 699,
		"x": -18.0032979407,
		"y": -48.775806541,
		"h": 1.4945054945
	},
	{
		"stop_id": 8571168,
		"ID": 699,
		"x": -18.0562882207,
		"y": -48.469793882,
		"h": 1.4945054945
	},
	{
		"stop_id": 8580964,
		"ID": 699,
		"x": -17.9172777187,
		"y": -49.504806046,
		"h": 1.4945054945
	},
	{
		"stop_id": 8581335,
		"ID": 699,
		"x": -18.0552728927,
		"y": -48.605856207,
		"h": 1.4945054945
	},
	{
		"stop_id": 8581336,
		"ID": 699,
		"x": -17.9552896907,
		"y": -48.393835923,
		"h": 1.4945054945
	},
	{
		"stop_id": 8501604,
		"ID": 602,
		"x": -31.7872731607,
		"y": -54.186778598,
		"h": 1.9230769231
	},
	{
		"stop_id": 8501645,
		"ID": 602,
		"x": -31.8132268607,
		"y": -54.522843166,
		"h": 1.9230769231
	},
	{
		"stop_id": 8501659,
		"ID": 602,
		"x": -31.8372486337,
		"y": -56.566859452,
		"h": 1.9230769231
	},
	{
		"stop_id": 8530187,
		"ID": 602,
		"x": -31.8402287427,
		"y": -54.531749785,
		"h": 1.9230769231
	},
	{
		"stop_id": 8530188,
		"ID": 602,
		"x": -33.1452509407,
		"y": -55.560796359,
		"h": 1.9230769231
	},
	{
		"stop_id": 8530192,
		"ID": 602,
		"x": -31.7922941567,
		"y": -56.671815647,
		"h": 1.9230769231
	},
	{
		"stop_id": 8530193,
		"ID": 602,
		"x": -32.0512387567,
		"y": -57.704851662,
		"h": 1.9230769231
	},
	{
		"stop_id": 8571054,
		"ID": 602,
		"x": -29.2102542257,
		"y": -57.256760246,
		"h": 1.9230769231
	},
	{
		"stop_id": 8571055,
		"ID": 602,
		"x": -28.8252830037,
		"y": -55.85877604,
		"h": 1.9230769231
	},
	{
		"stop_id": 8571056,
		"ID": 602,
		"x": -30.4022849247,
		"y": -56.162769524,
		"h": 1.9230769231
	},
	{
		"stop_id": 8571057,
		"ID": 602,
		"x": -30.7812239007,
		"y": -56.53277687,
		"h": 1.9230769231
	},
	{
		"stop_id": 8571058,
		"ID": 602,
		"x": -30.7582323027,
		"y": -56.972775181,
		"h": 1.9230769231
	},
	{
		"stop_id": 8571059,
		"ID": 602,
		"x": -30.6662630997,
		"y": -57.393766806,
		"h": 1.9230769231
	},
	{
		"stop_id": 8571060,
		"ID": 602,
		"x": -30.5412313387,
		"y": -57.186840253,
		"h": 1.9230769231
	},
	{
		"stop_id": 8571061,
		"ID": 602,
		"x": -30.3392820727,
		"y": -56.948856229,
		"h": 1.9230769231
	},
	{
		"stop_id": 8571062,
		"ID": 602,
		"x": -30.1812733247,
		"y": -57.059809575,
		"h": 1.9230769231
	},
	{
		"stop_id": 8571063,
		"ID": 602,
		"x": -30.0482493157,
		"y": -57.308839109,
		"h": 1.9230769231
	},
	{
		"stop_id": 8571064,
		"ID": 602,
		"x": -29.8712633227,
		"y": -57.591777314,
		"h": 1.9230769231
	},
	{
		"stop_id": 8571065,
		"ID": 602,
		"x": -29.7302435047,
		"y": -58.14280037,
		"h": 1.9230769231
	},
	{
		"stop_id": 8571074,
		"ID": 602,
		"x": -30.1762869767,
		"y": -53.519797799,
		"h": 1.9230769231
	},
	{
		"stop_id": 8579560,
		"ID": 602,
		"x": -33.3922848937,
		"y": -53.350779172,
		"h": 1.9230769231
	},
	{
		"stop_id": 8579561,
		"ID": 602,
		"x": -33.3672932537,
		"y": -53.570779519,
		"h": 1.9230769231
	},
	{
		"stop_id": 8579562,
		"ID": 602,
		"x": -32.6292644087,
		"y": -53.702809335,
		"h": 1.9230769231
	},
	{
		"stop_id": 8579564,
		"ID": 602,
		"x": -31.8832435667,
		"y": -53.990789921,
		"h": 1.9230769231
	},
	{
		"stop_id": 8579565,
		"ID": 602,
		"x": -32.2992697747,
		"y": -54.428795235,
		"h": 1.9230769231
	},
	{
		"stop_id": 8581315,
		"ID": 602,
		"x": -30.6912393797,
		"y": -57.039821182,
		"h": 1.9230769231
	},
	{
		"stop_id": 8587837,
		"ID": 602,
		"x": -32.9892761987,
		"y": -53.591799159,
		"h": 1.9230769231
	},
	{
		"stop_id": 8588474,
		"ID": 602,
		"x": -31.8742817087,
		"y": -54.481770555,
		"h": 1.9230769231
	},
	{
		"stop_id": 8588545,
		"ID": 602,
		"x": -31.9232742417,
		"y": -53.879807602,
		"h": 1.9230769231
	},
	{
		"stop_id": 8501605,
		"ID": 636,
		"x": -25.6202343517,
		"y": -55.516843175,
		"h": 2.3846153846
	},
	{
		"stop_id": 8501717,
		"ID": 636,
		"x": -25.2772437317,
		"y": -55.408846839,
		"h": 2.3846153846
	},
	{
		"stop_id": 8507471,
		"ID": 636,
		"x": -25.6632411397,
		"y": -54.105820822,
		"h": 2.3846153846
	},
	{
		"stop_id": 8507472,
		"ID": 636,
		"x": -28.4902532087,
		"y": -53.522778162,
		"h": 2.3846153846
	},
	{
		"stop_id": 8571076,
		"ID": 636,
		"x": -25.8442905397,
		"y": -55.150806286,
		"h": 2.3846153846
	},
	{
		"stop_id": 8571077,
		"ID": 636,
		"x": -26.0802495467,
		"y": -54.911780092,
		"h": 2.3846153846
	},
	{
		"stop_id": 8571078,
		"ID": 636,
		"x": -26.4732447247,
		"y": -54.470841531,
		"h": 2.3846153846
	},
	{
		"stop_id": 8571079,
		"ID": 636,
		"x": -26.9032541907,
		"y": -54.012847823,
		"h": 2.3846153846
	},
	{
		"stop_id": 8571080,
		"ID": 636,
		"x": -27.2052634487,
		"y": -53.82382776,
		"h": 2.3846153846
	},
	{
		"stop_id": 8571081,
		"ID": 636,
		"x": -28.0932303947,
		"y": -53.9047962,
		"h": 2.3846153846
	},
	{
		"stop_id": 8571082,
		"ID": 636,
		"x": -28.8152481807,
		"y": -53.840827635,
		"h": 2.3846153846
	},
	{
		"stop_id": 8571083,
		"ID": 636,
		"x": -28.3602621647,
		"y": -53.841820967,
		"h": 2.3846153846
	},
	{
		"stop_id": 8571084,
		"ID": 636,
		"x": -27.8272931107,
		"y": -53.583795547,
		"h": 2.3846153846
	},
	{
		"stop_id": 8571085,
		"ID": 636,
		"x": -28.2422954357,
		"y": -53.653781198,
		"h": 2.3846153846
	},
	{
		"stop_id": 8571086,
		"ID": 636,
		"x": -28.6422908557,
		"y": -53.482763073,
		"h": 2.3846153846
	},
	{
		"stop_id": 8571087,
		"ID": 636,
		"x": -28.3422396577,
		"y": -53.469763803,
		"h": 2.3846153846
	},
	{
		"stop_id": 8571088,
		"ID": 636,
		"x": -28.1192256677,
		"y": -53.411796587,
		"h": 2.3846153846
	},
	{
		"stop_id": 8571089,
		"ID": 636,
		"x": -27.9782765477,
		"y": -53.246754144,
		"h": 2.3846153846
	},
	{
		"stop_id": 8571090,
		"ID": 636,
		"x": -26.4222796097,
		"y": -54.309813894,
		"h": 2.3846153846
	},
	{
		"stop_id": 8571091,
		"ID": 636,
		"x": -26.2422246997,
		"y": -54.282806988,
		"h": 2.3846153846
	},
	{
		"stop_id": 8571092,
		"ID": 636,
		"x": -26.0822414167,
		"y": -54.248791679,
		"h": 2.3846153846
	},
	{
		"stop_id": 8571093,
		"ID": 636,
		"x": -26.4832743937,
		"y": -54.145844719,
		"h": 2.3846153846
	},
	{
		"stop_id": 8571094,
		"ID": 636,
		"x": -26.1652277577,
		"y": -54.107848314,
		"h": 2.3846153846
	},
	{
		"stop_id": 8571095,
		"ID": 636,
		"x": -25.8852640917,
		"y": -54.079830982,
		"h": 2.3846153846
	},
	{
		"stop_id": 8571096,
		"ID": 636,
		"x": -25.6802462547,
		"y": -54.054779752,
		"h": 2.3846153846
	},
	{
		"stop_id": 8571097,
		"ID": 636,
		"x": -25.4842991287,
		"y": -54.128822672,
		"h": 2.3846153846
	},
	{
		"stop_id": 8571098,
		"ID": 636,
		"x": -25.2922765047,
		"y": -54.175756857,
		"h": 2.3846153846
	},
	{
		"stop_id": 8571099,
		"ID": 636,
		"x": -25.3742541037,
		"y": -53.957779807,
		"h": 2.3846153846
	},
	{
		"stop_id": 8571100,
		"ID": 636,
		"x": -25.7982667577,
		"y": -53.684812259,
		"h": 2.3846153846
	},
	{
		"stop_id": 8571101,
		"ID": 636,
		"x": -25.2092303987,
		"y": -53.742843981,
		"h": 2.3846153846
	},
	{
		"stop_id": 8571102,
		"ID": 636,
		"x": -24.8612474037,
		"y": -53.824779407,
		"h": 2.3846153846
	},
	{
		"stop_id": 8571103,
		"ID": 636,
		"x": -24.7112565027,
		"y": -53.704853136,
		"h": 2.3846153846
	},
	{
		"stop_id": 8571104,
		"ID": 636,
		"x": -24.6262521237,
		"y": -53.524825693,
		"h": 2.3846153846
	},
	{
		"stop_id": 8571105,
		"ID": 636,
		"x": -24.8862818727,
		"y": -53.129796282,
		"h": 2.3846153846
	},
	{
		"stop_id": 8571106,
		"ID": 636,
		"x": -24.5772696777,
		"y": -53.098771461,
		"h": 2.3846153846
	},
	{
		"stop_id": 8580423,
		"ID": 636,
		"x": -25.0532522407,
		"y": -54.182840288,
		"h": 2.3846153846
	},
	{
		"stop_id": 8581852,
		"ID": 636,
		"x": -25.6072265807,
		"y": -55.40482469,
		"h": 2.3846153846
	},
	{
		"stop_id": 8582008,
		"ID": 636,
		"x": -26.6862272797,
		"y": -54.380851558,
		"h": 2.3846153846
	},
	{
		"stop_id": 8582009,
		"ID": 636,
		"x": -26.9202665357,
		"y": -54.185804508,
		"h": 2.3846153846
	},
	{
		"stop_id": 8583664,
		"ID": 636,
		"x": -26.4602974137,
		"y": -54.807828334,
		"h": 2.3846153846
	},
	{
		"stop_id": 8594335,
		"ID": 636,
		"x": -26.7572632707,
		"y": -55.200761113,
		"h": 2.3846153846
	},
	{
		"stop_id": 8595484,
		"ID": 636,
		"x": -26.2942481997,
		"y": -55.129852955,
		"h": 2.3846153846
	},
	{
		"stop_id": 8595485,
		"ID": 636,
		"x": -26.1152820617,
		"y": -55.415783309,
		"h": 2.3846153846
	},
	{
		"stop_id": 8501609,
		"ID": 698,
		"x": -17.4232673557,
		"y": -52.641748702,
		"h": 4.6923076923
	},
	{
		"stop_id": 8501677,
		"ID": 698,
		"x": -15.1932391977,
		"y": -50.775785016,
		"h": 4.6923076923
	},
	{
		"stop_id": 8501753,
		"ID": 698,
		"x": -17.4422431947,
		"y": -52.681790704,
		"h": 4.6923076923
	},
	{
		"stop_id": 8505703,
		"ID": 698,
		"x": -17.0962379107,
		"y": -51.405821512,
		"h": 4.6923076923
	},
	{
		"stop_id": 8505706,
		"ID": 698,
		"x": -15.2202663377,
		"y": -52.438837204,
		"h": 4.6923076923
	},
	{
		"stop_id": 8505707,
		"ID": 698,
		"x": -17.9102316587,
		"y": -52.003809116,
		"h": 4.6923076923
	},
	{
		"stop_id": 8505715,
		"ID": 698,
		"x": -17.7332402837,
		"y": -49.954760093,
		"h": 4.6923076923
	},
	{
		"stop_id": 8505716,
		"ID": 698,
		"x": -17.0572666447,
		"y": -53.392784186,
		"h": 4.6923076923
	},
	{
		"stop_id": 8505717,
		"ID": 698,
		"x": -18.3202708287,
		"y": -53.655805047,
		"h": 4.6923076923
	},
	{
		"stop_id": 8505718,
		"ID": 698,
		"x": -17.3052533907,
		"y": -50.876798862,
		"h": 4.6923076923
	},
	{
		"stop_id": 8505720,
		"ID": 698,
		"x": -14.6902598577,
		"y": -52.834784305,
		"h": 4.6923076923
	},
	{
		"stop_id": 8505722,
		"ID": 698,
		"x": -16.5162332917,
		"y": -51.284754622,
		"h": 4.6923076923
	},
	{
		"stop_id": 8505723,
		"ID": 698,
		"x": -17.6772864907,
		"y": -50.870838482,
		"h": 4.6923076923
	},
	{
		"stop_id": 8505727,
		"ID": 698,
		"x": -15.3362892727,
		"y": -53.116815389,
		"h": 4.6923076923
	},
	{
		"stop_id": 8505728,
		"ID": 698,
		"x": -14.5422606887,
		"y": -53.302810087,
		"h": 4.6923076923
	},
	{
		"stop_id": 8505729,
		"ID": 698,
		"x": -15.1332741517,
		"y": -52.871752029,
		"h": 4.6923076923
	},
	{
		"stop_id": 8505732,
		"ID": 698,
		"x": -18.8672577727,
		"y": -52.636782646,
		"h": 4.6923076923
	},
	{
		"stop_id": 8505733,
		"ID": 698,
		"x": -16.5012540027,
		"y": -53.63885199,
		"h": 4.6923076923
	},
	{
		"stop_id": 8505734,
		"ID": 698,
		"x": -14.8682560607,
		"y": -51.725759589,
		"h": 4.6923076923
	},
	{
		"stop_id": 8515296,
		"ID": 698,
		"x": -17.5542642077,
		"y": -52.688798478,
		"h": 4.6923076923
	},
	{
		"stop_id": 8530233,
		"ID": 698,
		"x": -14.5082905057,
		"y": -53.240857747,
		"h": 4.6923076923
	},
	{
		"stop_id": 8571139,
		"ID": 698,
		"x": -17.8422491887,
		"y": -53.32378986,
		"h": 4.6923076923
	},
	{
		"stop_id": 8571159,
		"ID": 698,
		"x": -18.4492288137,
		"y": -52.380814399,
		"h": 4.6923076923
	},
	{
		"stop_id": 8571160,
		"ID": 698,
		"x": -19.3942861817,
		"y": -52.850761361,
		"h": 4.6923076923
	},
	{
		"stop_id": 8571162,
		"ID": 698,
		"x": -17.5512620637,
		"y": -52.48978708,
		"h": 4.6923076923
	},
	{
		"stop_id": 8571163,
		"ID": 698,
		"x": -17.3502330057,
		"y": -51.951774105,
		"h": 4.6923076923
	},
	{
		"stop_id": 8571164,
		"ID": 698,
		"x": -16.8202541887,
		"y": -51.566841093,
		"h": 4.6923076923
	},
	{
		"stop_id": 8571165,
		"ID": 698,
		"x": -17.7762452307,
		"y": -50.24776356,
		"h": 4.6923076923
	},
	{
		"stop_id": 8571170,
		"ID": 698,
		"x": -17.3212648127,
		"y": -52.216817534,
		"h": 4.6923076923
	},
	{
		"stop_id": 8571188,
		"ID": 698,
		"x": -16.2422252367,
		"y": -53.664786864,
		"h": 4.6923076923
	},
	{
		"stop_id": 8571189,
		"ID": 698,
		"x": -15.7222527567,
		"y": -53.85178982,
		"h": 4.6923076923
	},
	{
		"stop_id": 8571190,
		"ID": 698,
		"x": -15.5952698437,
		"y": -53.56983142,
		"h": 4.6923076923
	},
	{
		"stop_id": 8571191,
		"ID": 698,
		"x": -14.9932922737,
		"y": -51.979816114,
		"h": 4.6923076923
	},
	{
		"stop_id": 8571192,
		"ID": 698,
		"x": -14.8662292897,
		"y": -52.652776165,
		"h": 4.6923076923
	},
	{
		"stop_id": 8578410,
		"ID": 698,
		"x": -15.9052339587,
		"y": -51.660773082,
		"h": 4.6923076923
	},
	{
		"stop_id": 8578422,
		"ID": 698,
		"x": -16.0172934797,
		"y": -51.744849246,
		"h": 4.6923076923
	},
	{
		"stop_id": 8578434,
		"ID": 698,
		"x": -16.2422459837,
		"y": -51.819842471,
		"h": 4.6923076923
	},
	{
		"stop_id": 8578488,
		"ID": 698,
		"x": -16.5922467967,
		"y": -51.844805878,
		"h": 4.6923076923
	},
	{
		"stop_id": 8578503,
		"ID": 698,
		"x": -16.7232242827,
		"y": -51.793823575,
		"h": 4.6923076923
	},
	{
		"stop_id": 8578523,
		"ID": 698,
		"x": -16.9942500837,
		"y": -51.84577101,
		"h": 4.6923076923
	},
	{
		"stop_id": 8578539,
		"ID": 698,
		"x": -17.2172773807,
		"y": -51.94483762,
		"h": 4.6923076923
	},
	{
		"stop_id": 8578540,
		"ID": 698,
		"x": -17.4832518537,
		"y": -52.026853997,
		"h": 4.6923076923
	},
	{
		"stop_id": 8578541,
		"ID": 698,
		"x": -17.6032724397,
		"y": -52.088833749,
		"h": 4.6923076923
	},
	{
		"stop_id": 8578544,
		"ID": 698,
		"x": -17.5422629417,
		"y": -52.719841758,
		"h": 4.6923076923
	},
	{
		"stop_id": 8578545,
		"ID": 698,
		"x": -17.2922331047,
		"y": -52.819810781,
		"h": 4.6923076923
	},
	{
		"stop_id": 8578548,
		"ID": 698,
		"x": -17.4162658747,
		"y": -52.926845307,
		"h": 4.6923076923
	},
	{
		"stop_id": 8578550,
		"ID": 698,
		"x": -17.4942410407,
		"y": -53.055789319,
		"h": 4.6923076923
	},
	{
		"stop_id": 8578551,
		"ID": 698,
		"x": -17.6922810737,
		"y": -53.044829634,
		"h": 4.6923076923
	},
	{
		"stop_id": 8578555,
		"ID": 698,
		"x": -17.8722445607,
		"y": -53.085764903,
		"h": 4.6923076923
	},
	{
		"stop_id": 8578556,
		"ID": 698,
		"x": -17.7862240767,
		"y": -52.882843425,
		"h": 4.6923076923
	},
	{
		"stop_id": 8578566,
		"ID": 698,
		"x": -16.8642840397,
		"y": -52.025832326,
		"h": 4.6923076923
	},
	{
		"stop_id": 8578575,
		"ID": 698,
		"x": -16.2812580077,
		"y": -51.888824794,
		"h": 4.6923076923
	},
	{
		"stop_id": 8578576,
		"ID": 698,
		"x": -15.9432664267,
		"y": -51.821797667,
		"h": 4.6923076923
	},
	{
		"stop_id": 8578582,
		"ID": 698,
		"x": -17.9922517797,
		"y": -53.119833549,
		"h": 4.6923076923
	},
	{
		"stop_id": 8578583,
		"ID": 698,
		"x": -18.1992673967,
		"y": -53.23776263,
		"h": 4.6923076923
	},
	{
		"stop_id": 8578602,
		"ID": 698,
		"x": -18.3512518517,
		"y": -53.383767229,
		"h": 4.6923076923
	},
	{
		"stop_id": 8578610,
		"ID": 698,
		"x": -18.4612342267,
		"y": -53.465782368,
		"h": 4.6923076923
	},
	{
		"stop_id": 8578628,
		"ID": 698,
		"x": -18.6662582957,
		"y": -53.607805113,
		"h": 4.6923076923
	},
	{
		"stop_id": 8578640,
		"ID": 698,
		"x": -18.7312453777,
		"y": -53.657826811,
		"h": 4.6923076923
	},
	{
		"stop_id": 8578648,
		"ID": 698,
		"x": -18.6612584707,
		"y": -53.742839958,
		"h": 4.6923076923
	},
	{
		"stop_id": 8578656,
		"ID": 698,
		"x": -18.7842424537,
		"y": -53.851840007,
		"h": 4.6923076923
	},
	{
		"stop_id": 8578675,
		"ID": 698,
		"x": -18.5742330437,
		"y": -53.806836854,
		"h": 4.6923076923
	},
	{
		"stop_id": 8578676,
		"ID": 698,
		"x": -18.3572359057,
		"y": -53.882840286,
		"h": 4.6923076923
	},
	{
		"stop_id": 8578680,
		"ID": 698,
		"x": -18.1032465587,
		"y": -53.780824152,
		"h": 4.6923076923
	},
	{
		"stop_id": 8578684,
		"ID": 698,
		"x": -17.8892405857,
		"y": -53.757780852,
		"h": 4.6923076923
	},
	{
		"stop_id": 8578687,
		"ID": 698,
		"x": -17.6662349287,
		"y": -53.699760664,
		"h": 4.6923076923
	},
	{
		"stop_id": 8578758,
		"ID": 698,
		"x": -17.5392575887,
		"y": -53.724778291,
		"h": 4.6923076923
	},
	{
		"stop_id": 8578759,
		"ID": 698,
		"x": -17.3192454047,
		"y": -53.767817765,
		"h": 4.6923076923
	},
	{
		"stop_id": 8578761,
		"ID": 698,
		"x": -17.1922292267,
		"y": -53.819841648,
		"h": 4.6923076923
	},
	{
		"stop_id": 8578762,
		"ID": 698,
		"x": -17.3862616927,
		"y": -53.944821968,
		"h": 4.6923076923
	},
	{
		"stop_id": 8578763,
		"ID": 698,
		"x": -17.6342602327,
		"y": -54.098853161,
		"h": 4.6923076923
	},
	{
		"stop_id": 8578777,
		"ID": 698,
		"x": -17.8402388847,
		"y": -54.225791763,
		"h": 4.6923076923
	},
	{
		"stop_id": 8578778,
		"ID": 698,
		"x": -17.8422594727,
		"y": -53.644842628,
		"h": 4.6923076923
	},
	{
		"stop_id": 8578810,
		"ID": 698,
		"x": -18.0922603747,
		"y": -53.619777547,
		"h": 4.6923076923
	},
	{
		"stop_id": 8578814,
		"ID": 698,
		"x": -17.1892271867,
		"y": -53.304779579,
		"h": 4.6923076923
	},
	{
		"stop_id": 8578827,
		"ID": 698,
		"x": -16.9232365967,
		"y": -53.478770266,
		"h": 4.6923076923
	},
	{
		"stop_id": 8578871,
		"ID": 698,
		"x": -16.8422372287,
		"y": -53.494760397,
		"h": 4.6923076923
	},
	{
		"stop_id": 8578884,
		"ID": 698,
		"x": -16.9082443257,
		"y": -53.365828657,
		"h": 4.6923076923
	},
	{
		"stop_id": 8578886,
		"ID": 698,
		"x": -16.7172398637,
		"y": -53.219843585,
		"h": 4.6923076923
	},
	{
		"stop_id": 8578887,
		"ID": 698,
		"x": -16.9062759877,
		"y": -53.02375095,
		"h": 4.6923076923
	},
	{
		"stop_id": 8578889,
		"ID": 698,
		"x": -16.7362285807,
		"y": -52.921826136,
		"h": 4.6923076923
	},
	{
		"stop_id": 8578890,
		"ID": 698,
		"x": -16.8062961967,
		"y": -52.838836784,
		"h": 4.6923076923
	},
	{
		"stop_id": 8578891,
		"ID": 698,
		"x": -16.6062725647,
		"y": -52.685780464,
		"h": 4.6923076923
	},
	{
		"stop_id": 8578893,
		"ID": 698,
		"x": -16.3832720437,
		"y": -52.526772038,
		"h": 4.6923076923
	},
	{
		"stop_id": 8578894,
		"ID": 698,
		"x": -15.7742587777,
		"y": -51.710848341,
		"h": 4.6923076923
	},
	{
		"stop_id": 8578901,
		"ID": 698,
		"x": -16.4422268727,
		"y": -51.919772495,
		"h": 4.6923076923
	},
	{
		"stop_id": 8579338,
		"ID": 698,
		"x": -16.5622447677,
		"y": -51.807795135,
		"h": 4.6923076923
	},
	{
		"stop_id": 8579340,
		"ID": 698,
		"x": -17.1372930177,
		"y": -52.136817476,
		"h": 4.6923076923
	},
	{
		"stop_id": 8579341,
		"ID": 698,
		"x": -15.3302251227,
		"y": -50.827818969,
		"h": 4.6923076923
	},
	{
		"stop_id": 8579716,
		"ID": 698,
		"x": -17.3402654077,
		"y": -53.384769393,
		"h": 4.6923076923
	},
	{
		"stop_id": 8579717,
		"ID": 698,
		"x": -17.4672635437,
		"y": -53.344859644,
		"h": 4.6923076923
	},
	{
		"stop_id": 8579718,
		"ID": 698,
		"x": -17.4642933747,
		"y": -53.240785755,
		"h": 4.6923076923
	},
	{
		"stop_id": 8580499,
		"ID": 698,
		"x": -17.6792988437,
		"y": -50.625838618,
		"h": 4.6923076923
	},
	{
		"stop_id": 8581518,
		"ID": 698,
		"x": -15.8602257087,
		"y": -54.064789818,
		"h": 4.6923076923
	},
	{
		"stop_id": 8582002,
		"ID": 698,
		"x": -17.7412249767,
		"y": -53.206807712,
		"h": 4.6923076923
	},
	{
		"stop_id": 8582003,
		"ID": 698,
		"x": -16.7922752497,
		"y": -53.869820097,
		"h": 4.6923076923
	},
	{
		"stop_id": 8582445,
		"ID": 698,
		"x": -15.4652373177,
		"y": -50.907849705,
		"h": 4.6923076923
	},
	{
		"stop_id": 8582446,
		"ID": 698,
		"x": -17.4342283117,
		"y": -53.02379819,
		"h": 4.6923076923
	},
	{
		"stop_id": 8582447,
		"ID": 698,
		"x": -15.7442821177,
		"y": -50.665761625,
		"h": 4.6923076923
	},
	{
		"stop_id": 8582448,
		"ID": 698,
		"x": -15.3042799547,
		"y": -50.795834251,
		"h": 4.6923076923
	},
	{
		"stop_id": 8582873,
		"ID": 698,
		"x": -16.8282653617,
		"y": -53.270769025,
		"h": 4.6923076923
	},
	{
		"stop_id": 8583247,
		"ID": 698,
		"x": -17.5182859457,
		"y": -52.303795476,
		"h": 4.6923076923
	},
	{
		"stop_id": 8583392,
		"ID": 698,
		"x": -17.0552908557,
		"y": -52.766783661,
		"h": 4.6923076923
	},
	{
		"stop_id": 8583393,
		"ID": 698,
		"x": -17.1002649847,
		"y": -52.647817725,
		"h": 4.6923076923
	},
	{
		"stop_id": 8583394,
		"ID": 698,
		"x": -16.9052565467,
		"y": -52.634767109,
		"h": 4.6923076923
	},
	{
		"stop_id": 8587698,
		"ID": 698,
		"x": -16.0592284257,
		"y": -50.566771219,
		"h": 4.6923076923
	},
	{
		"stop_id": 8587699,
		"ID": 698,
		"x": -15.7782277867,
		"y": -50.497811281,
		"h": 4.6923076923
	},
	{
		"stop_id": 8587700,
		"ID": 698,
		"x": -15.2392947947,
		"y": -50.418829816,
		"h": 4.6923076923
	},
	{
		"stop_id": 8587701,
		"ID": 698,
		"x": -15.0802757977,
		"y": -50.244790709,
		"h": 4.6923076923
	},
	{
		"stop_id": 8587702,
		"ID": 698,
		"x": -15.5912322767,
		"y": -50.609840068,
		"h": 4.6923076923
	},
	{
		"stop_id": 8587703,
		"ID": 698,
		"x": -15.3342708017,
		"y": -50.727797377,
		"h": 4.6923076923
	},
	{
		"stop_id": 8587704,
		"ID": 698,
		"x": -15.5492372277,
		"y": -51.25675389,
		"h": 4.6923076923
	},
	{
		"stop_id": 8587706,
		"ID": 698,
		"x": -15.6372807857,
		"y": -51.527757513,
		"h": 4.6923076923
	},
	{
		"stop_id": 8501634,
		"ID": 864,
		"x": 14.2957256643,
		"y": -24.789801611,
		"h": 1.1648351648
	},
	{
		"stop_id": 8505754,
		"ID": 864,
		"x": 13.0577218393,
		"y": -23.744754593,
		"h": 1.1648351648
	},
	{
		"stop_id": 8505759,
		"ID": 864,
		"x": 15.6077616893,
		"y": -23.769829966,
		"h": 1.1648351648
	},
	{
		"stop_id": 8505899,
		"ID": 864,
		"x": 15.1167293253,
		"y": -24.163847938,
		"h": 1.1648351648
	},
	{
		"stop_id": 8530614,
		"ID": 864,
		"x": 16.1327026043,
		"y": -23.765788592,
		"h": 1.1648351648
	},
	{
		"stop_id": 8580044,
		"ID": 864,
		"x": 13.6887348613,
		"y": -24.385785474,
		"h": 1.1648351648
	},
	{
		"stop_id": 8501635,
		"ID": 838,
		"x": 11.0187351173,
		"y": -25.484823295,
		"h": 1.2967032967
	},
	{
		"stop_id": 8501660,
		"ID": 838,
		"x": 10.9877580483,
		"y": -25.406810271,
		"h": 1.2967032967
	},
	{
		"stop_id": 8501661,
		"ID": 838,
		"x": 9.6357592203,
		"y": -28.886810475,
		"h": 1.2967032967
	},
	{
		"stop_id": 8508761,
		"ID": 838,
		"x": 9.3717464073,
		"y": -24.131756067,
		"h": 1.2967032967
	},
	{
		"stop_id": 8508762,
		"ID": 838,
		"x": 9.2287560783,
		"y": -25.448796095,
		"h": 1.2967032967
	},
	{
		"stop_id": 8577049,
		"ID": 838,
		"x": 8.7307212943,
		"y": -24.365767471,
		"h": 1.2967032967
	},
	{
		"stop_id": 8579362,
		"ID": 838,
		"x": 9.5697592013,
		"y": -28.958832406,
		"h": 1.2967032967
	},
	{
		"stop_id": 8580208,
		"ID": 838,
		"x": 10.6117212123,
		"y": -27.356749694,
		"h": 1.2967032967
	},
	{
		"stop_id": 8580209,
		"ID": 838,
		"x": 9.7617300183,
		"y": -25.45778332,
		"h": 1.2967032967
	},
	{
		"stop_id": 8580384,
		"ID": 838,
		"x": 10.0277069083,
		"y": -28.491841986,
		"h": 1.2967032967
	},
	{
		"stop_id": 8501636,
		"ID": 667,
		"x": -22.9372242537,
		"y": -55.194858776,
		"h": 1.7582417582
	},
	{
		"stop_id": 8501999,
		"ID": 667,
		"x": -21.8402543447,
		"y": -54.630806493,
		"h": 1.7582417582
	},
	{
		"stop_id": 8505702,
		"ID": 667,
		"x": -20.8202952577,
		"y": -53.264754007,
		"h": 1.7582417582
	},
	{
		"stop_id": 8505708,
		"ID": 667,
		"x": -19.8432346237,
		"y": -52.937781841,
		"h": 1.7582417582
	},
	{
		"stop_id": 8505709,
		"ID": 667,
		"x": -22.7842492097,
		"y": -54.882769402,
		"h": 1.7582417582
	},
	{
		"stop_id": 8505712,
		"ID": 667,
		"x": -23.5052861257,
		"y": -55.398832047,
		"h": 1.7582417582
	},
	{
		"stop_id": 8505714,
		"ID": 667,
		"x": -20.1022251837,
		"y": -54.144763106,
		"h": 1.7582417582
	},
	{
		"stop_id": 8505719,
		"ID": 667,
		"x": -20.9972422027,
		"y": -53.335814109,
		"h": 1.7582417582
	},
	{
		"stop_id": 8505724,
		"ID": 667,
		"x": -21.0202978097,
		"y": -53.187775513,
		"h": 1.7582417582
	},
	{
		"stop_id": 8507470,
		"ID": 667,
		"x": -23.5522991687,
		"y": -54.675859568,
		"h": 1.7582417582
	},
	{
		"stop_id": 8571135,
		"ID": 667,
		"x": -24.5562315147,
		"y": -55.591793041,
		"h": 1.7582417582
	},
	{
		"stop_id": 8571136,
		"ID": 667,
		"x": -23.8222565607,
		"y": -55.05576962,
		"h": 1.7582417582
	},
	{
		"stop_id": 8571137,
		"ID": 667,
		"x": -22.2022250547,
		"y": -54.742784867,
		"h": 1.7582417582
	},
	{
		"stop_id": 8571140,
		"ID": 667,
		"x": -22.6872465557,
		"y": -55.221792331,
		"h": 1.7582417582
	},
	{
		"stop_id": 8571157,
		"ID": 667,
		"x": -19.5672608487,
		"y": -54.211826111,
		"h": 1.7582417582
	},
	{
		"stop_id": 8571158,
		"ID": 667,
		"x": -20.0542403537,
		"y": -54.236828802,
		"h": 1.7582417582
	},
	{
		"stop_id": 8571161,
		"ID": 667,
		"x": -20.8202975007,
		"y": -53.096779983,
		"h": 1.7582417582
	},
	{
		"stop_id": 8580417,
		"ID": 667,
		"x": -19.4772502687,
		"y": -54.041808297,
		"h": 1.7582417582
	},
	{
		"stop_id": 8580753,
		"ID": 667,
		"x": -23.0242256007,
		"y": -55.282764661,
		"h": 1.7582417582
	},
	{
		"stop_id": 8580960,
		"ID": 667,
		"x": -20.4312278177,
		"y": -54.305767961,
		"h": 1.7582417582
	},
	{
		"stop_id": 8580961,
		"ID": 667,
		"x": -23.8232612687,
		"y": -55.483769177,
		"h": 1.7582417582
	},
	{
		"stop_id": 8580962,
		"ID": 667,
		"x": -19.6582865087,
		"y": -52.938782525,
		"h": 1.7582417582
	},
	{
		"stop_id": 8580963,
		"ID": 667,
		"x": -20.5742485147,
		"y": -53.099749862,
		"h": 1.7582417582
	},
	{
		"stop_id": 8581060,
		"ID": 667,
		"x": -23.9312614087,
		"y": -55.476849716,
		"h": 1.7582417582
	},
	{
		"stop_id": 8501662,
		"ID": 837,
		"x": 8.3767100063,
		"y": -30.843815514,
		"h": 1.2307692308
	},
	{
		"stop_id": 8501663,
		"ID": 837,
		"x": 7.0497091453,
		"y": -31.787854525,
		"h": 1.2307692308
	},
	{
		"stop_id": 8579360,
		"ID": 837,
		"x": 6.7577658733,
		"y": -31.619768078,
		"h": 1.2307692308
	},
	{
		"stop_id": 8579361,
		"ID": 837,
		"x": 8.1877708433,
		"y": -30.811819445,
		"h": 1.2307692308
	},
	{
		"stop_id": 8580045,
		"ID": 837,
		"x": 8.7687108143,
		"y": -32.263823318,
		"h": 1.2307692308
	},
	{
		"stop_id": 8580212,
		"ID": 837,
		"x": 6.9147062933,
		"y": -31.588795248,
		"h": 1.2307692308
	},
	{
		"stop_id": 8580390,
		"ID": 837,
		"x": 7.0797558713,
		"y": -31.700806991,
		"h": 1.2307692308
	},
	{
		"stop_id": 8589087,
		"ID": 837,
		"x": 5.5577487013,
		"y": -32.269799426,
		"h": 1.2307692308
	},
	{
		"stop_id": 8501664,
		"ID": 812,
		"x": 5.0157321253,
		"y": -33.2957617,
		"h": 1.2307692308
	},
	{
		"stop_id": 8501665,
		"ID": 812,
		"x": 3.8277526373,
		"y": -34.007791198,
		"h": 1.2307692308
	},
	{
		"stop_id": 8501666,
		"ID": 812,
		"x": 2.1077197703,
		"y": -35.930827944,
		"h": 1.2307692308
	},
	{
		"stop_id": 8501667,
		"ID": 812,
		"x": 1.3477053673,
		"y": -36.543791645,
		"h": 1.2307692308
	},
	{
		"stop_id": 8579356,
		"ID": 812,
		"x": 1.3167245533,
		"y": -36.245833896,
		"h": 1.2307692308
	},
	{
		"stop_id": 8579357,
		"ID": 812,
		"x": 1.9567599003,
		"y": -35.79385565,
		"h": 1.2307692308
	},
	{
		"stop_id": 8579358,
		"ID": 812,
		"x": 3.5597226533,
		"y": -33.792827642,
		"h": 1.2307692308
	},
	{
		"stop_id": 8579359,
		"ID": 812,
		"x": 4.8617662513,
		"y": -32.885856714,
		"h": 1.2307692308
	},
	{
		"stop_id": 8501668,
		"ID": 786,
		"x": 0.2437447763,
		"y": -37.413780599,
		"h": 1.2307692308
	},
	{
		"stop_id": 8501669,
		"ID": 786,
		"x": -0.8552610487,
		"y": -38.579784834,
		"h": 1.2307692308
	},
	{
		"stop_id": 8501670,
		"ID": 786,
		"x": -1.9792658477,
		"y": -39.627760815,
		"h": 1.2307692308
	},
	{
		"stop_id": 8505748,
		"ID": 786,
		"x": -2.9162651827,
		"y": -41.048852759,
		"h": 1.2307692308
	},
	{
		"stop_id": 8530253,
		"ID": 786,
		"x": -3.7852615577,
		"y": -38.972759736,
		"h": 1.2307692308
	},
	{
		"stop_id": 8530254,
		"ID": 786,
		"x": -4.0922479467,
		"y": -37.660793013,
		"h": 1.2307692308
	},
	{
		"stop_id": 8579350,
		"ID": 786,
		"x": -1.9962321827,
		"y": -39.621808876,
		"h": 1.2307692308
	},
	{
		"stop_id": 8579355,
		"ID": 786,
		"x": 0.5467160473,
		"y": -37.192753411,
		"h": 1.2307692308
	},
	{
		"stop_id": 8501673,
		"ID": 758,
		"x": -7.5482555247,
		"y": -45.050763486,
		"h": 1.2967032967
	},
	{
		"stop_id": 8505742,
		"ID": 758,
		"x": -6.5292829357,
		"y": -45.178831363,
		"h": 1.2967032967
	},
	{
		"stop_id": 8505743,
		"ID": 758,
		"x": -5.1342625677,
		"y": -45.616837073,
		"h": 1.2967032967
	},
	{
		"stop_id": 8505747,
		"ID": 758,
		"x": -6.0942717977,
		"y": -44.352773111,
		"h": 1.2967032967
	},
	{
		"stop_id": 8505749,
		"ID": 758,
		"x": -4.7452972937,
		"y": -46.754797811,
		"h": 1.2967032967
	},
	{
		"stop_id": 8578898,
		"ID": 758,
		"x": -4.9422896407,
		"y": -46.169834757,
		"h": 1.2967032967
	},
	{
		"stop_id": 8579345,
		"ID": 758,
		"x": -8.5022568957,
		"y": -45.765857483,
		"h": 1.2967032967
	},
	{
		"stop_id": 8579346,
		"ID": 758,
		"x": -7.5112603537,
		"y": -44.969845927,
		"h": 1.2967032967
	},
	{
		"stop_id": 8579363,
		"ID": 758,
		"x": -6.8292863637,
		"y": -44.619839801,
		"h": 1.2967032967
	},
	{
		"stop_id": 8579365,
		"ID": 758,
		"x": -5.6412785847,
		"y": -45.435858328,
		"h": 1.2967032967
	},
	{
		"stop_id": 8501674,
		"ID": 729,
		"x": -9.4962674807,
		"y": -46.378856185,
		"h": 1.3626373626
	},
	{
		"stop_id": 8501675,
		"ID": 729,
		"x": -10.6592483187,
		"y": -46.838762328,
		"h": 1.3626373626
	},
	{
		"stop_id": 8501954,
		"ID": 729,
		"x": -12.1022358487,
		"y": -45.188788166,
		"h": 1.3626373626
	},
	{
		"stop_id": 8501955,
		"ID": 729,
		"x": -11.3132603547,
		"y": -46.405813543,
		"h": 1.3626373626
	},
	{
		"stop_id": 8530241,
		"ID": 729,
		"x": -12.8582811137,
		"y": -44.110811669,
		"h": 1.3626373626
	},
	{
		"stop_id": 8530243,
		"ID": 729,
		"x": -10.6382490827,
		"y": -46.818803642,
		"h": 1.3626373626
	},
	{
		"stop_id": 8530244,
		"ID": 729,
		"x": -10.4812914957,
		"y": -43.222771708,
		"h": 1.3626373626
	},
	{
		"stop_id": 8530245,
		"ID": 729,
		"x": -10.6482302937,
		"y": -42.487749382,
		"h": 1.3626373626
	},
	{
		"stop_id": 8530802,
		"ID": 729,
		"x": -11.4022951387,
		"y": -44.587807452,
		"h": 1.3626373626
	},
	{
		"stop_id": 8530803,
		"ID": 729,
		"x": -11.6132452917,
		"y": -44.506782814,
		"h": 1.3626373626
	},
	{
		"stop_id": 8530808,
		"ID": 729,
		"x": -13.4882902977,
		"y": -45.738839049,
		"h": 1.3626373626
	},
	{
		"stop_id": 8579344,
		"ID": 729,
		"x": -9.6952298577,
		"y": -46.408855932,
		"h": 1.3626373626
	},
	{
		"stop_id": 8501676,
		"ID": 728,
		"x": -12.9072661067,
		"y": -48.518797998,
		"h": 1.0989010989
	},
	{
		"stop_id": 8530237,
		"ID": 728,
		"x": -12.9942690207,
		"y": -48.475782431,
		"h": 1.0989010989
	},
	{
		"stop_id": 8578896,
		"ID": 728,
		"x": -12.8272270407,
		"y": -48.348756468,
		"h": 1.0989010989
	},
	{
		"stop_id": 8579342,
		"ID": 728,
		"x": -12.9592848937,
		"y": -48.480847798,
		"h": 1.0989010989
	},
	{
		"stop_id": 8501679,
		"ID": 564,
		"x": -35.7122399647,
		"y": -87.1758373196,
		"h": 1.8241758242
	},
	{
		"stop_id": 8501689,
		"ID": 564,
		"x": -35.7632590497,
		"y": -85.5307501027,
		"h": 1.8241758242
	},
	{
		"stop_id": 8501690,
		"ID": 564,
		"x": -35.7332931237,
		"y": -85.5887729038,
		"h": 1.8241758242
	},
	{
		"stop_id": 8501691,
		"ID": 564,
		"x": -35.2852395257,
		"y": -87.7048549134,
		"h": 1.8241758242
	},
	{
		"stop_id": 8501692,
		"ID": 564,
		"x": -35.2222579247,
		"y": -89.0328416082,
		"h": 1.8241758242
	},
	{
		"stop_id": 8530206,
		"ID": 564,
		"x": -36.1792720387,
		"y": -86.6108156399,
		"h": 1.8241758242
	},
	{
		"stop_id": 8530207,
		"ID": 564,
		"x": -36.9942449197,
		"y": -88.0627686089,
		"h": 1.8241758242
	},
	{
		"stop_id": 8530212,
		"ID": 564,
		"x": -35.4552286477,
		"y": -85.7567567358,
		"h": 1.8241758242
	},
	{
		"stop_id": 8530213,
		"ID": 564,
		"x": -34.0772977647,
		"y": -86.339850916,
		"h": 1.8241758242
	},
	{
		"stop_id": 8530214,
		"ID": 564,
		"x": -34.0422239487,
		"y": -86.3738316188,
		"h": 1.8241758242
	},
	{
		"stop_id": 8594556,
		"ID": 564,
		"x": -35.7492629417,
		"y": -85.5648235559,
		"h": 1.8241758242
	},
	{
		"stop_id": 8594557,
		"ID": 564,
		"x": -35.6862343117,
		"y": -85.9547747896,
		"h": 1.8241758242
	},
	{
		"stop_id": 8594558,
		"ID": 564,
		"x": -35.5562246327,
		"y": -85.8517627912,
		"h": 1.8241758242
	},
	{
		"stop_id": 8594559,
		"ID": 564,
		"x": -35.7872637427,
		"y": -86.1808443157,
		"h": 1.8241758242
	},
	{
		"stop_id": 8594560,
		"ID": 564,
		"x": -35.9992523237,
		"y": -86.793766252,
		"h": 1.8241758242
	},
	{
		"stop_id": 8594561,
		"ID": 564,
		"x": -35.8262422767,
		"y": -86.4908230828,
		"h": 1.8241758242
	},
	{
		"stop_id": 8594562,
		"ID": 564,
		"x": -36.2192428587,
		"y": -86.6497678327,
		"h": 1.8241758242
	},
	{
		"stop_id": 8594563,
		"ID": 564,
		"x": -35.5152392267,
		"y": -85.7587745005,
		"h": 1.8241758242
	},
	{
		"stop_id": 8594564,
		"ID": 564,
		"x": -36.2512566647,
		"y": -86.7838489998,
		"h": 1.8241758242
	},
	{
		"stop_id": 8594565,
		"ID": 564,
		"x": -35.4272460957,
		"y": -85.2008047583,
		"h": 1.8241758242
	},
	{
		"stop_id": 8594566,
		"ID": 564,
		"x": -35.6302860387,
		"y": -85.3958228037,
		"h": 1.8241758242
	},
	{
		"stop_id": 8594567,
		"ID": 564,
		"x": -35.6452286277,
		"y": -85.8857996041,
		"h": 1.8241758242
	},
	{
		"stop_id": 8594568,
		"ID": 564,
		"x": -35.9392972487,
		"y": -86.8938059057,
		"h": 1.8241758242
	},
	{
		"stop_id": 8594569,
		"ID": 564,
		"x": -35.7672512617,
		"y": -86.6607895645,
		"h": 1.8241758242
	},
	{
		"stop_id": 8594570,
		"ID": 564,
		"x": -35.4832718847,
		"y": -85.5407577968,
		"h": 1.8241758242
	},
	{
		"stop_id": 8594571,
		"ID": 564,
		"x": -36.2582783957,
		"y": -86.5497560029,
		"h": 1.8241758242
	},
	{
		"stop_id": 8501686,
		"ID": 599,
		"x": -32.4602611237,
		"y": -73.546858847,
		"h": 1.1978021978
	},
	{
		"stop_id": 8579322,
		"ID": 599,
		"x": -32.2442310387,
		"y": -70.886766641,
		"h": 1.1978021978
	},
	{
		"stop_id": 8579324,
		"ID": 599,
		"x": -32.4452891847,
		"y": -73.524780479,
		"h": 1.1978021978
	},
	{
		"stop_id": 8579917,
		"ID": 599,
		"x": -31.9472672237,
		"y": -70.059776804,
		"h": 1.1978021978
	},
	{
		"stop_id": 8579918,
		"ID": 599,
		"x": -32.1612500597,
		"y": -70.446835769,
		"h": 1.1978021978
	},
	{
		"stop_id": 8579920,
		"ID": 599,
		"x": -32.5392847837,
		"y": -71.554764475,
		"h": 1.1978021978
	},
	{
		"stop_id": 8579921,
		"ID": 599,
		"x": -32.7172455507,
		"y": -74.536840112,
		"h": 1.1978021978
	},
	{
		"stop_id": 8501687,
		"ID": 598,
		"x": -33.2312628167,
		"y": -77.131749218,
		"h": 1
	},
	{
		"stop_id": 8501688,
		"ID": 565,
		"x": -33.7532979547,
		"y": -80.743836292,
		"h": 1
	},
	{
		"stop_id": 8501693,
		"ID": 596,
		"x": -34.4222680107,
		"y": -89.9728343066,
		"h": 1.032967033
	},
	{
		"stop_id": 8501694,
		"ID": 596,
		"x": -33.1173000347,
		"y": -90.0947810563,
		"h": 1.032967033
	},
	{
		"stop_id": 8501711,
		"ID": 287,
		"x": -83.0422813657,
		"y": -56.169782147,
		"h": 1
	},
	{
		"stop_id": 8501712,
		"ID": 638,
		"x": -28.6272796157,
		"y": -40.560790679,
		"h": 1.0989010989
	},
	{
		"stop_id": 8507773,
		"ID": 638,
		"x": -27.1802247017,
		"y": -39.922846994,
		"h": 1.0989010989
	},
	{
		"stop_id": 8571016,
		"ID": 638,
		"x": -27.6932654207,
		"y": -40.05276623,
		"h": 1.0989010989
	},
	{
		"stop_id": 8571017,
		"ID": 638,
		"x": -29.6472610837,
		"y": -41.09577837,
		"h": 1.0989010989
	},
	{
		"stop_id": 8501713,
		"ID": 571,
		"x": -35.2842811027,
		"y": -49.637765369,
		"h": 1.1318681319
	},
	{
		"stop_id": 8507474,
		"ID": 571,
		"x": -35.3962595147,
		"y": -47.368762346,
		"h": 1.1318681319
	},
	{
		"stop_id": 8507754,
		"ID": 571,
		"x": -35.1172825617,
		"y": -44.519781647,
		"h": 1.1318681319
	},
	{
		"stop_id": 8507786,
		"ID": 571,
		"x": -35.3692394777,
		"y": -47.332858107,
		"h": 1.1318681319
	},
	{
		"stop_id": 8582064,
		"ID": 571,
		"x": -35.1722856987,
		"y": -44.574810216,
		"h": 1.1318681319
	},
	{
		"stop_id": 8501714,
		"ID": 469,
		"x": -52.7282413827,
		"y": -59.830765795,
		"h": 1.4285714286
	},
	{
		"stop_id": 8505679,
		"ID": 469,
		"x": -49.2382399467,
		"y": -60.326773552,
		"h": 1.4285714286
	},
	{
		"stop_id": 8505682,
		"ID": 469,
		"x": -52.4592477587,
		"y": -58.626751655,
		"h": 1.4285714286
	},
	{
		"stop_id": 8505687,
		"ID": 469,
		"x": -49.0482799007,
		"y": -61.390853177,
		"h": 1.4285714286
	},
	{
		"stop_id": 8505692,
		"ID": 469,
		"x": -50.0832693657,
		"y": -59.372816279,
		"h": 1.4285714286
	},
	{
		"stop_id": 8530134,
		"ID": 469,
		"x": -52.9842652337,
		"y": -59.748791971,
		"h": 1.4285714286
	},
	{
		"stop_id": 8530136,
		"ID": 469,
		"x": -52.3802752687,
		"y": -60.054799225,
		"h": 1.4285714286
	},
	{
		"stop_id": 8530137,
		"ID": 469,
		"x": -52.7202960327,
		"y": -62.78575796,
		"h": 1.4285714286
	},
	{
		"stop_id": 8557004,
		"ID": 469,
		"x": -50.0482817327,
		"y": -62.850797492,
		"h": 1.4285714286
	},
	{
		"stop_id": 8557005,
		"ID": 469,
		"x": -49.5822539397,
		"y": -63.846749468,
		"h": 1.4285714286
	},
	{
		"stop_id": 8557006,
		"ID": 469,
		"x": -50.2022326077,
		"y": -61.792855098,
		"h": 1.4285714286
	},
	{
		"stop_id": 8557007,
		"ID": 469,
		"x": -51.7112754027,
		"y": -61.133817046,
		"h": 1.4285714286
	},
	{
		"stop_id": 8570942,
		"ID": 469,
		"x": -53.1182393877,
		"y": -59.006798338,
		"h": 1.4285714286
	},
	{
		"stop_id": 8582218,
		"ID": 469,
		"x": -50.6392811297,
		"y": -58.803838389,
		"h": 1.4285714286
	},
	{
		"stop_id": 8501716,
		"ID": 635,
		"x": -25.8972843477,
		"y": -60.119823676,
		"h": 2.5494505495
	},
	{
		"stop_id": 8501963,
		"ID": 635,
		"x": -23.9612481227,
		"y": -59.505837959,
		"h": 2.5494505495
	},
	{
		"stop_id": 8501964,
		"ID": 635,
		"x": -27.0062345127,
		"y": -57.950824596,
		"h": 2.5494505495
	},
	{
		"stop_id": 8505700,
		"ID": 635,
		"x": -26.0932874167,
		"y": -61.277831404,
		"h": 2.5494505495
	},
	{
		"stop_id": 8505721,
		"ID": 635,
		"x": -25.0662399467,
		"y": -55.721799893,
		"h": 2.5494505495
	},
	{
		"stop_id": 8530194,
		"ID": 635,
		"x": -23.8372971767,
		"y": -59.472754798,
		"h": 2.5494505495
	},
	{
		"stop_id": 8571021,
		"ID": 635,
		"x": -25.3972353867,
		"y": -56.180805545,
		"h": 2.5494505495
	},
	{
		"stop_id": 8571022,
		"ID": 635,
		"x": -25.2022749707,
		"y": -56.217826725,
		"h": 2.5494505495
	},
	{
		"stop_id": 8571023,
		"ID": 635,
		"x": -24.6982294757,
		"y": -57.326823556,
		"h": 2.5494505495
	},
	{
		"stop_id": 8571024,
		"ID": 635,
		"x": -24.9852652167,
		"y": -57.826840056,
		"h": 2.5494505495
	},
	{
		"stop_id": 8571025,
		"ID": 635,
		"x": -24.6582804977,
		"y": -57.915778061,
		"h": 2.5494505495
	},
	{
		"stop_id": 8571026,
		"ID": 635,
		"x": -24.5902367667,
		"y": -58.641749734,
		"h": 2.5494505495
	},
	{
		"stop_id": 8571027,
		"ID": 635,
		"x": -24.5142264647,
		"y": -59.395799863,
		"h": 2.5494505495
	},
	{
		"stop_id": 8571028,
		"ID": 635,
		"x": -24.2652451337,
		"y": -59.579773644,
		"h": 2.5494505495
	},
	{
		"stop_id": 8571029,
		"ID": 635,
		"x": -24.0602291697,
		"y": -59.392808915,
		"h": 2.5494505495
	},
	{
		"stop_id": 8571031,
		"ID": 635,
		"x": -25.8772332927,
		"y": -60.395850704,
		"h": 2.5494505495
	},
	{
		"stop_id": 8571041,
		"ID": 635,
		"x": -26.0352487407,
		"y": -55.728829002,
		"h": 2.5494505495
	},
	{
		"stop_id": 8571042,
		"ID": 635,
		"x": -26.1602335717,
		"y": -55.813788112,
		"h": 2.5494505495
	},
	{
		"stop_id": 8571043,
		"ID": 635,
		"x": -26.5212296887,
		"y": -55.624794982,
		"h": 2.5494505495
	},
	{
		"stop_id": 8571044,
		"ID": 635,
		"x": -27.6342679777,
		"y": -55.787767472,
		"h": 2.5494505495
	},
	{
		"stop_id": 8571046,
		"ID": 635,
		"x": -26.3662587207,
		"y": -56.729831195,
		"h": 2.5494505495
	},
	{
		"stop_id": 8571047,
		"ID": 635,
		"x": -26.6712746797,
		"y": -57.471765228,
		"h": 2.5494505495
	},
	{
		"stop_id": 8571048,
		"ID": 635,
		"x": -26.7392660007,
		"y": -57.824757623,
		"h": 2.5494505495
	},
	{
		"stop_id": 8571049,
		"ID": 635,
		"x": -26.8482265927,
		"y": -57.931848302,
		"h": 2.5494505495
	},
	{
		"stop_id": 8571050,
		"ID": 635,
		"x": -27.1982802147,
		"y": -57.316763139,
		"h": 2.5494505495
	},
	{
		"stop_id": 8571051,
		"ID": 635,
		"x": -28.3452716977,
		"y": -57.015775278,
		"h": 2.5494505495
	},
	{
		"stop_id": 8571052,
		"ID": 635,
		"x": -28.1172646157,
		"y": -57.401782853,
		"h": 2.5494505495
	},
	{
		"stop_id": 8571053,
		"ID": 635,
		"x": -28.6012508947,
		"y": -57.224756345,
		"h": 2.5494505495
	},
	{
		"stop_id": 8571066,
		"ID": 635,
		"x": -29.5002269487,
		"y": -58.245819665,
		"h": 2.5494505495
	},
	{
		"stop_id": 8571067,
		"ID": 635,
		"x": -29.4152404617,
		"y": -57.943799594,
		"h": 2.5494505495
	},
	{
		"stop_id": 8571068,
		"ID": 635,
		"x": -28.4152336987,
		"y": -57.899802142,
		"h": 2.5494505495
	},
	{
		"stop_id": 8571069,
		"ID": 635,
		"x": -28.6342901967,
		"y": -58.175846481,
		"h": 2.5494505495
	},
	{
		"stop_id": 8571075,
		"ID": 635,
		"x": -25.6152575547,
		"y": -55.565839762,
		"h": 2.5494505495
	},
	{
		"stop_id": 8571116,
		"ID": 635,
		"x": -27.1142883227,
		"y": -61.29175231,
		"h": 2.5494505495
	},
	{
		"stop_id": 8571121,
		"ID": 635,
		"x": -27.4132871947,
		"y": -61.299802442,
		"h": 2.5494505495
	},
	{
		"stop_id": 8571127,
		"ID": 635,
		"x": -28.1202298117,
		"y": -60.363838593,
		"h": 2.5494505495
	},
	{
		"stop_id": 8571141,
		"ID": 635,
		"x": -25.7682929897,
		"y": -58.767754648,
		"h": 2.5494505495
	},
	{
		"stop_id": 8579336,
		"ID": 635,
		"x": -25.4932721257,
		"y": -57.091807513,
		"h": 2.5494505495
	},
	{
		"stop_id": 8580516,
		"ID": 635,
		"x": -24.4322680367,
		"y": -58.891846349,
		"h": 2.5494505495
	},
	{
		"stop_id": 8580827,
		"ID": 635,
		"x": -27.1112351277,
		"y": -58.951782274,
		"h": 2.5494505495
	},
	{
		"stop_id": 8580828,
		"ID": 635,
		"x": -27.0932827767,
		"y": -58.591838201,
		"h": 2.5494505495
	},
	{
		"stop_id": 8580829,
		"ID": 635,
		"x": -27.0222966457,
		"y": -58.159794016,
		"h": 2.5494505495
	},
	{
		"stop_id": 8581313,
		"ID": 635,
		"x": -27.0982768477,
		"y": -58.394766171,
		"h": 2.5494505495
	},
	{
		"stop_id": 8581626,
		"ID": 635,
		"x": -25.2352276947,
		"y": -57.00785653,
		"h": 2.5494505495
	},
	{
		"stop_id": 8581723,
		"ID": 635,
		"x": -25.3722245237,
		"y": -55.780795838,
		"h": 2.5494505495
	},
	{
		"stop_id": 8581724,
		"ID": 635,
		"x": -27.8082537097,
		"y": -55.747778218,
		"h": 2.5494505495
	},
	{
		"stop_id": 8582444,
		"ID": 635,
		"x": -24.7952345877,
		"y": -58.00183514,
		"h": 2.5494505495
	},
	{
		"stop_id": 8583665,
		"ID": 635,
		"x": -25.5862948077,
		"y": -56.205775987,
		"h": 2.5494505495
	},
	{
		"stop_id": 8501732,
		"ID": 631,
		"x": -23.6412419657,
		"y": -81.787770013,
		"h": 1
	},
	{
		"stop_id": 8501737,
		"ID": 140,
		"x": -105.0722692187,
		"y": -50.532782366,
		"h": 1.2967032967
	},
	{
		"stop_id": 8501971,
		"ID": 140,
		"x": -103.6482688687,
		"y": -53.12075763,
		"h": 1.2967032967
	},
	{
		"stop_id": 8504669,
		"ID": 140,
		"x": -103.2172811817,
		"y": -52.724787632,
		"h": 1.2967032967
	},
	{
		"stop_id": 8530054,
		"ID": 140,
		"x": -105.0072993307,
		"y": -54.155800707,
		"h": 1.2967032967
	},
	{
		"stop_id": 8530056,
		"ID": 140,
		"x": -105.0822381017,
		"y": -54.162797168,
		"h": 1.2967032967
	},
	{
		"stop_id": 8530057,
		"ID": 140,
		"x": -104.4862866337,
		"y": -54.315769386,
		"h": 1.2967032967
	},
	{
		"stop_id": 8570598,
		"ID": 140,
		"x": -104.2252721857,
		"y": -50.91484213,
		"h": 1.2967032967
	},
	{
		"stop_id": 8580652,
		"ID": 140,
		"x": -104.2312924457,
		"y": -53.0767965,
		"h": 1.2967032967
	},
	{
		"stop_id": 8580653,
		"ID": 140,
		"x": -103.8682514047,
		"y": -52.960848131,
		"h": 1.2967032967
	},
	{
		"stop_id": 8580656,
		"ID": 140,
		"x": -104.7912440357,
		"y": -50.606815441,
		"h": 1.2967032967
	},
	{
		"stop_id": 8501738,
		"ID": 467,
		"x": -49.2722563957,
		"y": -72.902802967,
		"h": 1.0659340659
	},
	{
		"stop_id": 8505697,
		"ID": 467,
		"x": -49.5932851877,
		"y": -72.754827424,
		"h": 1.0659340659
	},
	{
		"stop_id": 8582216,
		"ID": 467,
		"x": -49.8422998397,
		"y": -71.069846609,
		"h": 1.0659340659
	},
	{
		"stop_id": 8501739,
		"ID": 349,
		"x": -71.4742528307,
		"y": -51.415784735,
		"h": 1.1648351648
	},
	{
		"stop_id": 8501899,
		"ID": 349,
		"x": -70.7802763067,
		"y": -48.3138101,
		"h": 1.1648351648
	},
	{
		"stop_id": 8530746,
		"ID": 349,
		"x": -70.7902538307,
		"y": -47.922823261,
		"h": 1.1648351648
	},
	{
		"stop_id": 8570767,
		"ID": 349,
		"x": -70.0822677497,
		"y": -52.50076281,
		"h": 1.1648351648
	},
	{
		"stop_id": 8570768,
		"ID": 349,
		"x": -70.4372990407,
		"y": -52.401758836,
		"h": 1.1648351648
	},
	{
		"stop_id": 8570769,
		"ID": 349,
		"x": -71.1182801907,
		"y": -50.085820898,
		"h": 1.1648351648
	},
	{
		"stop_id": 8501744,
		"ID": 345,
		"x": -69.2212392737,
		"y": -73.140761162,
		"h": 1.2307692308
	},
	{
		"stop_id": 8530099,
		"ID": 345,
		"x": -70.1362288047,
		"y": -75.678844948,
		"h": 1.2307692308
	},
	{
		"stop_id": 8530109,
		"ID": 345,
		"x": -71.7472572277,
		"y": -70.309851681,
		"h": 1.2307692308
	},
	{
		"stop_id": 8530113,
		"ID": 345,
		"x": -69.2462821507,
		"y": -73.289795552,
		"h": 1.2307692308
	},
	{
		"stop_id": 8530115,
		"ID": 345,
		"x": -70.1262912427,
		"y": -75.654850147,
		"h": 1.2307692308
	},
	{
		"stop_id": 8530862,
		"ID": 345,
		"x": -70.8822357367,
		"y": -72.715816809,
		"h": 1.2307692308
	},
	{
		"stop_id": 8570871,
		"ID": 345,
		"x": -69.3712524967,
		"y": -70.975784275,
		"h": 1.2307692308
	},
	{
		"stop_id": 8570872,
		"ID": 345,
		"x": -69.2522836437,
		"y": -71.660756845,
		"h": 1.2307692308
	},
	{
		"stop_id": 8501746,
		"ID": 406,
		"x": -60.9622795717,
		"y": -69.223770401,
		"h": 2.2527472527
	},
	{
		"stop_id": 8504677,
		"ID": 406,
		"x": -62.5422875887,
		"y": -68.269758052,
		"h": 2.2527472527
	},
	{
		"stop_id": 8504679,
		"ID": 406,
		"x": -63.7962252527,
		"y": -67.668849348,
		"h": 2.2527472527
	},
	{
		"stop_id": 8530124,
		"ID": 406,
		"x": -63.7662829987,
		"y": -68.262828433,
		"h": 2.2527472527
	},
	{
		"stop_id": 8570894,
		"ID": 406,
		"x": -62.8542680727,
		"y": -64.776776092,
		"h": 2.2527472527
	},
	{
		"stop_id": 8570895,
		"ID": 406,
		"x": -62.7192845747,
		"y": -65.072768448,
		"h": 2.2527472527
	},
	{
		"stop_id": 8570896,
		"ID": 406,
		"x": -61.8702750857,
		"y": -68.126858,
		"h": 2.2527472527
	},
	{
		"stop_id": 8570897,
		"ID": 406,
		"x": -62.1272365887,
		"y": -69.415837907,
		"h": 2.2527472527
	},
	{
		"stop_id": 8570898,
		"ID": 406,
		"x": -61.4782329567,
		"y": -69.127813416,
		"h": 2.2527472527
	},
	{
		"stop_id": 8570899,
		"ID": 406,
		"x": -60.6562475967,
		"y": -69.441824149,
		"h": 2.2527472527
	},
	{
		"stop_id": 8570929,
		"ID": 406,
		"x": -60.7422595987,
		"y": -64.929815621,
		"h": 2.2527472527
	},
	{
		"stop_id": 8570930,
		"ID": 406,
		"x": -59.9622454107,
		"y": -66.708775964,
		"h": 2.2527472527
	},
	{
		"stop_id": 8570931,
		"ID": 406,
		"x": -59.2442888857,
		"y": -66.768797425,
		"h": 2.2527472527
	},
	{
		"stop_id": 8570932,
		"ID": 406,
		"x": -59.9242441687,
		"y": -68.092790891,
		"h": 2.2527472527
	},
	{
		"stop_id": 8570933,
		"ID": 406,
		"x": -59.5802333527,
		"y": -68.751786257,
		"h": 2.2527472527
	},
	{
		"stop_id": 8570934,
		"ID": 406,
		"x": -59.3892426117,
		"y": -69.025804101,
		"h": 2.2527472527
	},
	{
		"stop_id": 8570938,
		"ID": 406,
		"x": -60.2812712577,
		"y": -64.798815474,
		"h": 2.2527472527
	},
	{
		"stop_id": 8574113,
		"ID": 406,
		"x": -59.3192661887,
		"y": -69.149750331,
		"h": 2.2527472527
	},
	{
		"stop_id": 8579516,
		"ID": 406,
		"x": -63.1652390407,
		"y": -64.836856229,
		"h": 2.2527472527
	},
	{
		"stop_id": 8579517,
		"ID": 406,
		"x": -62.7022645727,
		"y": -66.069821586,
		"h": 2.2527472527
	},
	{
		"stop_id": 8579518,
		"ID": 406,
		"x": -62.9422815507,
		"y": -65.839806008,
		"h": 2.2527472527
	},
	{
		"stop_id": 8579519,
		"ID": 406,
		"x": -63.3822415027,
		"y": -65.81976467,
		"h": 2.2527472527
	},
	{
		"stop_id": 8579521,
		"ID": 406,
		"x": -63.7322549607,
		"y": -65.769848819,
		"h": 2.2527472527
	},
	{
		"stop_id": 8579522,
		"ID": 406,
		"x": -63.2522437037,
		"y": -66.31875452,
		"h": 2.2527472527
	},
	{
		"stop_id": 8579528,
		"ID": 406,
		"x": -63.0422949427,
		"y": -69.819818952,
		"h": 2.2527472527
	},
	{
		"stop_id": 8580460,
		"ID": 406,
		"x": -59.7992327597,
		"y": -68.216855826,
		"h": 2.2527472527
	},
	{
		"stop_id": 8580670,
		"ID": 406,
		"x": -60.2852399487,
		"y": -66.64183005,
		"h": 2.2527472527
	},
	{
		"stop_id": 8580673,
		"ID": 406,
		"x": -61.8822379927,
		"y": -68.533831567,
		"h": 2.2527472527
	},
	{
		"stop_id": 8581100,
		"ID": 406,
		"x": -60.5562833877,
		"y": -66.642796952,
		"h": 2.2527472527
	},
	{
		"stop_id": 8581101,
		"ID": 406,
		"x": -59.8982898437,
		"y": -67.840779162,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582945,
		"ID": 406,
		"x": -60.5472705157,
		"y": -64.644818457,
		"h": 2.2527472527
	},
	{
		"stop_id": 8583789,
		"ID": 406,
		"x": -60.5712884537,
		"y": -65.278792299,
		"h": 2.2527472527
	},
	{
		"stop_id": 8594688,
		"ID": 406,
		"x": -63.7512286667,
		"y": -68.26784106,
		"h": 2.2527472527
	},
	{
		"stop_id": 8594689,
		"ID": 406,
		"x": -63.0352293697,
		"y": -68.224815513,
		"h": 2.2527472527
	},
	{
		"stop_id": 8594690,
		"ID": 406,
		"x": -63.1642539057,
		"y": -68.077781265,
		"h": 2.2527472527
	},
	{
		"stop_id": 8594691,
		"ID": 406,
		"x": -63.5032375877,
		"y": -68.203749311,
		"h": 2.2527472527
	},
	{
		"stop_id": 8594692,
		"ID": 406,
		"x": -63.0552981307,
		"y": -67.381834362,
		"h": 2.2527472527
	},
	{
		"stop_id": 8594693,
		"ID": 406,
		"x": -63.4212241897,
		"y": -67.443760336,
		"h": 2.2527472527
	},
	{
		"stop_id": 8595607,
		"ID": 406,
		"x": -63.0382827087,
		"y": -68.438807963,
		"h": 2.2527472527
	},
	{
		"stop_id": 8501750,
		"ID": 433,
		"x": -56.4682909717,
		"y": -85.4337989084,
		"h": 1.0989010989
	},
	{
		"stop_id": 8570915,
		"ID": 433,
		"x": -56.1662990397,
		"y": -84.8687916866,
		"h": 1.0989010989
	},
	{
		"stop_id": 8570916,
		"ID": 433,
		"x": -56.4162495787,
		"y": -85.8727705799,
		"h": 1.0989010989
	},
	{
		"stop_id": 8580442,
		"ID": 433,
		"x": -56.3862262617,
		"y": -85.6837701133,
		"h": 1.0989010989
	},
	{
		"stop_id": 8501752,
		"ID": 500,
		"x": -46.9462589847,
		"y": -68.597789679,
		"h": 1.3296703297
	},
	{
		"stop_id": 8505690,
		"ID": 500,
		"x": -45.7312626577,
		"y": -70.928825008,
		"h": 1.3296703297
	},
	{
		"stop_id": 8505693,
		"ID": 500,
		"x": -45.4352608077,
		"y": -71.637821883,
		"h": 1.3296703297
	},
	{
		"stop_id": 8505698,
		"ID": 500,
		"x": -47.6062302807,
		"y": -67.774845116,
		"h": 1.3296703297
	},
	{
		"stop_id": 8530145,
		"ID": 500,
		"x": -46.9862984877,
		"y": -72.230783248,
		"h": 1.3296703297
	},
	{
		"stop_id": 8530859,
		"ID": 500,
		"x": -47.6482288347,
		"y": -71.550795434,
		"h": 1.3296703297
	},
	{
		"stop_id": 8570951,
		"ID": 500,
		"x": -47.3942932877,
		"y": -67.958843338,
		"h": 1.3296703297
	},
	{
		"stop_id": 8570952,
		"ID": 500,
		"x": -47.2162813367,
		"y": -68.27385762,
		"h": 1.3296703297
	},
	{
		"stop_id": 8570953,
		"ID": 500,
		"x": -46.5542973157,
		"y": -69.726845175,
		"h": 1.3296703297
	},
	{
		"stop_id": 8570954,
		"ID": 500,
		"x": -45.3302519707,
		"y": -72.261773006,
		"h": 1.3296703297
	},
	{
		"stop_id": 8582214,
		"ID": 500,
		"x": -46.5442587637,
		"y": -69.33385125,
		"h": 1.3296703297
	},
	{
		"stop_id": 8501755,
		"ID": 502,
		"x": -47.5292887207,
		"y": -60.257773059,
		"h": 1.1318681319
	},
	{
		"stop_id": 8530146,
		"ID": 502,
		"x": -46.9592610177,
		"y": -60.723830588,
		"h": 1.1318681319
	},
	{
		"stop_id": 8530147,
		"ID": 502,
		"x": -45.6952571347,
		"y": -60.303836209,
		"h": 1.1318681319
	},
	{
		"stop_id": 8570959,
		"ID": 502,
		"x": -46.9662413547,
		"y": -60.741854094,
		"h": 1.1318681319
	},
	{
		"stop_id": 8579179,
		"ID": 502,
		"x": -47.2582271587,
		"y": -60.367832409,
		"h": 1.1318681319
	},
	{
		"stop_id": 8501756,
		"ID": 347,
		"x": -68.9732412387,
		"y": -60.682791105,
		"h": 2.2197802198
	},
	{
		"stop_id": 8501761,
		"ID": 347,
		"x": -71.0242282127,
		"y": -61.827850804,
		"h": 2.2197802198
	},
	{
		"stop_id": 8570698,
		"ID": 347,
		"x": -69.3992349297,
		"y": -63.300848699,
		"h": 2.2197802198
	},
	{
		"stop_id": 8570699,
		"ID": 347,
		"x": -70.2512235097,
		"y": -63.363783328,
		"h": 2.2197802198
	},
	{
		"stop_id": 8570700,
		"ID": 347,
		"x": -71.2472756487,
		"y": -63.180758921,
		"h": 2.2197802198
	},
	{
		"stop_id": 8570701,
		"ID": 347,
		"x": -72.1002431927,
		"y": -63.192850823,
		"h": 2.2197802198
	},
	{
		"stop_id": 8570702,
		"ID": 347,
		"x": -72.5382594637,
		"y": -63.414822226,
		"h": 2.2197802198
	},
	{
		"stop_id": 8570703,
		"ID": 347,
		"x": -73.1462601227,
		"y": -63.864831447,
		"h": 2.2197802198
	},
	{
		"stop_id": 8570707,
		"ID": 347,
		"x": -69.8842696907,
		"y": -63.685794052,
		"h": 2.2197802198
	},
	{
		"stop_id": 8570708,
		"ID": 347,
		"x": -70.1582867717,
		"y": -63.87475154,
		"h": 2.2197802198
	},
	{
		"stop_id": 8570709,
		"ID": 347,
		"x": -69.8872665167,
		"y": -62.627825366,
		"h": 2.2197802198
	},
	{
		"stop_id": 8570710,
		"ID": 347,
		"x": -70.1662807527,
		"y": -63.189845861,
		"h": 2.2197802198
	},
	{
		"stop_id": 8570711,
		"ID": 347,
		"x": -69.5402633857,
		"y": -62.725782671,
		"h": 2.2197802198
	},
	{
		"stop_id": 8570712,
		"ID": 347,
		"x": -69.6322892957,
		"y": -62.296754809,
		"h": 2.2197802198
	},
	{
		"stop_id": 8570713,
		"ID": 347,
		"x": -70.1752256467,
		"y": -62.431791713,
		"h": 2.2197802198
	},
	{
		"stop_id": 8570714,
		"ID": 347,
		"x": -70.0452380487,
		"y": -62.20779501,
		"h": 2.2197802198
	},
	{
		"stop_id": 8570715,
		"ID": 347,
		"x": -69.9492725957,
		"y": -61.435802556,
		"h": 2.2197802198
	},
	{
		"stop_id": 8570716,
		"ID": 347,
		"x": -72.6512842027,
		"y": -62.007778277,
		"h": 2.2197802198
	},
	{
		"stop_id": 8570717,
		"ID": 347,
		"x": -74.0192534917,
		"y": -60.664806605,
		"h": 2.2197802198
	},
	{
		"stop_id": 8570721,
		"ID": 347,
		"x": -70.8312363427,
		"y": -61.621775477,
		"h": 2.2197802198
	},
	{
		"stop_id": 8570722,
		"ID": 347,
		"x": -69.8692272837,
		"y": -59.891848453,
		"h": 2.2197802198
	},
	{
		"stop_id": 8570723,
		"ID": 347,
		"x": -69.9292314007,
		"y": -59.761794422,
		"h": 2.2197802198
	},
	{
		"stop_id": 8580633,
		"ID": 347,
		"x": -69.1392785957,
		"y": -60.628840407,
		"h": 2.2197802198
	},
	{
		"stop_id": 8580662,
		"ID": 347,
		"x": -72.3882474507,
		"y": -62.048801467,
		"h": 2.2197802198
	},
	{
		"stop_id": 8580664,
		"ID": 347,
		"x": -70.0432603677,
		"y": -60.200814894,
		"h": 2.2197802198
	},
	{
		"stop_id": 8580665,
		"ID": 347,
		"x": -72.5342327037,
		"y": -62.065834557,
		"h": 2.2197802198
	},
	{
		"stop_id": 8580667,
		"ID": 347,
		"x": -71.6242506717,
		"y": -61.93085675,
		"h": 2.2197802198
	},
	{
		"stop_id": 8580668,
		"ID": 347,
		"x": -70.1792916807,
		"y": -62.862773877,
		"h": 2.2197802198
	},
	{
		"stop_id": 8580890,
		"ID": 347,
		"x": -71.6722604117,
		"y": -63.189824356,
		"h": 2.2197802198
	},
	{
		"stop_id": 8581192,
		"ID": 347,
		"x": -70.7522524917,
		"y": -63.264838037,
		"h": 2.2197802198
	},
	{
		"stop_id": 8582263,
		"ID": 347,
		"x": -73.5922429577,
		"y": -62.581857494,
		"h": 2.2197802198
	},
	{
		"stop_id": 8582265,
		"ID": 347,
		"x": -70.7142454097,
		"y": -61.253809739,
		"h": 2.2197802198
	},
	{
		"stop_id": 8583265,
		"ID": 347,
		"x": -69.9122987437,
		"y": -64.198776371,
		"h": 2.2197802198
	},
	{
		"stop_id": 8583288,
		"ID": 347,
		"x": -69.3662336567,
		"y": -63.506780488,
		"h": 2.2197802198
	},
	{
		"stop_id": 8583290,
		"ID": 347,
		"x": -69.6562239177,
		"y": -63.570784819,
		"h": 2.2197802198
	},
	{
		"stop_id": 8583372,
		"ID": 347,
		"x": -70.1322478907,
		"y": -63.94383053,
		"h": 2.2197802198
	},
	{
		"stop_id": 8583686,
		"ID": 347,
		"x": -70.6862588347,
		"y": -64.05579146,
		"h": 2.2197802198
	},
	{
		"stop_id": 8583865,
		"ID": 347,
		"x": -68.7672678457,
		"y": -60.542813611,
		"h": 2.2197802198
	},
	{
		"stop_id": 8501759,
		"ID": 191,
		"x": -96.5512251377,
		"y": -49.435832435,
		"h": 1.3296703297
	},
	{
		"stop_id": 8570605,
		"ID": 191,
		"x": -96.3972449097,
		"y": -49.660773349,
		"h": 1.3296703297
	},
	{
		"stop_id": 8570606,
		"ID": 191,
		"x": -96.4962245417,
		"y": -49.076764732,
		"h": 1.3296703297
	},
	{
		"stop_id": 8580398,
		"ID": 191,
		"x": -95.2382844397,
		"y": -48.178854257,
		"h": 1.3296703297
	},
	{
		"stop_id": 8582430,
		"ID": 191,
		"x": -95.4332920957,
		"y": -48.356791753,
		"h": 1.3296703297
	},
	{
		"stop_id": 8591820,
		"ID": 191,
		"x": -98.8632824977,
		"y": -47.951848752,
		"h": 1.3296703297
	},
	{
		"stop_id": 8591821,
		"ID": 191,
		"x": -98.7242380907,
		"y": -48.217773556,
		"h": 1.3296703297
	},
	{
		"stop_id": 8591822,
		"ID": 191,
		"x": -98.7582565407,
		"y": -48.407760798,
		"h": 1.3296703297
	},
	{
		"stop_id": 8591834,
		"ID": 191,
		"x": -98.0172684827,
		"y": -49.726847187,
		"h": 1.3296703297
	},
	{
		"stop_id": 8595182,
		"ID": 191,
		"x": -98.5742293717,
		"y": -45.067812838,
		"h": 1.3296703297
	},
	{
		"stop_id": 8595183,
		"ID": 191,
		"x": -98.4972759907,
		"y": -45.24284163,
		"h": 1.3296703297
	},
	{
		"stop_id": 8501760,
		"ID": 318,
		"x": -76.8952623807,
		"y": -57.022843,
		"h": 1.1648351648
	},
	{
		"stop_id": 8570718,
		"ID": 318,
		"x": -74.7962490367,
		"y": -58.378790926,
		"h": 1.1648351648
	},
	{
		"stop_id": 8570719,
		"ID": 318,
		"x": -75.4372813237,
		"y": -57.669805389,
		"h": 1.1648351648
	},
	{
		"stop_id": 8570720,
		"ID": 318,
		"x": -75.4262301677,
		"y": -56.328842878,
		"h": 1.1648351648
	},
	{
		"stop_id": 8580663,
		"ID": 318,
		"x": -75.7522239997,
		"y": -56.820781356,
		"h": 1.1648351648
	},
	{
		"stop_id": 8583434,
		"ID": 318,
		"x": -74.7242271357,
		"y": -59.331771799,
		"h": 1.1648351648
	},
	{
		"stop_id": 8501763,
		"ID": 289,
		"x": -82.3032585017,
		"y": -41.137846217,
		"h": 1
	},
	{
		"stop_id": 8501768,
		"ID": 468,
		"x": -49.1182801157,
		"y": -68.446777641,
		"h": 1.2637362637
	},
	{
		"stop_id": 8505680,
		"ID": 468,
		"x": -49.5052640007,
		"y": -68.982815044,
		"h": 1.2637362637
	},
	{
		"stop_id": 8530139,
		"ID": 468,
		"x": -49.3302827307,
		"y": -68.700824164,
		"h": 1.2637362637
	},
	{
		"stop_id": 8530140,
		"ID": 468,
		"x": -50.5022810067,
		"y": -68.218807339,
		"h": 1.2637362637
	},
	{
		"stop_id": 8570948,
		"ID": 468,
		"x": -48.7902619047,
		"y": -67.791763111,
		"h": 1.2637362637
	},
	{
		"stop_id": 8570949,
		"ID": 468,
		"x": -49.2972718347,
		"y": -68.721778056,
		"h": 1.2637362637
	},
	{
		"stop_id": 8580768,
		"ID": 468,
		"x": -48.7512683617,
		"y": -67.877846484,
		"h": 1.2637362637
	},
	{
		"stop_id": 8581381,
		"ID": 468,
		"x": -49.1152943517,
		"y": -68.254788858,
		"h": 1.2637362637
	},
	{
		"stop_id": 8582215,
		"ID": 468,
		"x": -48.4822765777,
		"y": -67.614781355,
		"h": 1.2637362637
	},
	{
		"stop_id": 8501769,
		"ID": 350,
		"x": -72.9142282107,
		"y": -45.310816885,
		"h": 1.1648351648
	},
	{
		"stop_id": 8501771,
		"ID": 350,
		"x": -72.6092333427,
		"y": -41.986855107,
		"h": 1.1648351648
	},
	{
		"stop_id": 8530745,
		"ID": 350,
		"x": -71.9192913577,
		"y": -46.462814212,
		"h": 1.1648351648
	},
	{
		"stop_id": 8571272,
		"ID": 350,
		"x": -72.8632939567,
		"y": -43.513828495,
		"h": 1.1648351648
	},
	{
		"stop_id": 8571273,
		"ID": 350,
		"x": -73.2482682247,
		"y": -45.7318357,
		"h": 1.1648351648
	},
	{
		"stop_id": 8577048,
		"ID": 350,
		"x": -72.7912614127,
		"y": -42.783851222,
		"h": 1.1648351648
	},
	{
		"stop_id": 8501773,
		"ID": 665,
		"x": -23.8792247807,
		"y": -67.665822015,
		"h": 1.1318681319
	},
	{
		"stop_id": 8571149,
		"ID": 665,
		"x": -24.2372726927,
		"y": -66.833838113,
		"h": 1.1318681319
	},
	{
		"stop_id": 8571150,
		"ID": 665,
		"x": -24.1472787057,
		"y": -67.105782316,
		"h": 1.1318681319
	},
	{
		"stop_id": 8571151,
		"ID": 665,
		"x": -23.5472811287,
		"y": -68.338749296,
		"h": 1.1318681319
	},
	{
		"stop_id": 8571152,
		"ID": 665,
		"x": -23.3102663807,
		"y": -68.881830085,
		"h": 1.1318681319
	},
	{
		"stop_id": 8501774,
		"ID": 381,
		"x": -68.7302947617,
		"y": -41.026795287,
		"h": 1.2307692308
	},
	{
		"stop_id": 8571289,
		"ID": 381,
		"x": -69.0352520037,
		"y": -40.239834481,
		"h": 1.2307692308
	},
	{
		"stop_id": 8571290,
		"ID": 381,
		"x": -68.6592373507,
		"y": -41.265795924,
		"h": 1.2307692308
	},
	{
		"stop_id": 8571291,
		"ID": 381,
		"x": -68.5462850217,
		"y": -41.719851226,
		"h": 1.2307692308
	},
	{
		"stop_id": 8571292,
		"ID": 381,
		"x": -68.0902638787,
		"y": -42.129816051,
		"h": 1.2307692308
	},
	{
		"stop_id": 8571293,
		"ID": 381,
		"x": -67.8382640607,
		"y": -42.493784368,
		"h": 1.2307692308
	},
	{
		"stop_id": 8571294,
		"ID": 381,
		"x": -67.7422460097,
		"y": -43.368784271,
		"h": 1.2307692308
	},
	{
		"stop_id": 8571295,
		"ID": 381,
		"x": -67.3762265327,
		"y": -43.694755021,
		"h": 1.2307692308
	},
	{
		"stop_id": 8501779,
		"ID": 501,
		"x": -47.8282985707,
		"y": -63.434813678,
		"h": 1.5274725275
	},
	{
		"stop_id": 8501790,
		"ID": 501,
		"x": -48.4182399347,
		"y": -64.350833827,
		"h": 1.5274725275
	},
	{
		"stop_id": 8505685,
		"ID": 501,
		"x": -47.9752606297,
		"y": -65.482773088,
		"h": 1.5274725275
	},
	{
		"stop_id": 8505688,
		"ID": 501,
		"x": -48.6332244697,
		"y": -64.905835827,
		"h": 1.5274725275
	},
	{
		"stop_id": 8505689,
		"ID": 501,
		"x": -47.8402671137,
		"y": -66.903766203,
		"h": 1.5274725275
	},
	{
		"stop_id": 8505695,
		"ID": 501,
		"x": -48.3682273107,
		"y": -66.337829268,
		"h": 1.5274725275
	},
	{
		"stop_id": 8530142,
		"ID": 501,
		"x": -47.0922354027,
		"y": -63.869764618,
		"h": 1.5274725275
	},
	{
		"stop_id": 8530143,
		"ID": 501,
		"x": -46.5452808707,
		"y": -62.812750108,
		"h": 1.5274725275
	},
	{
		"stop_id": 8557003,
		"ID": 501,
		"x": -48.9602388507,
		"y": -64.677755606,
		"h": 1.5274725275
	},
	{
		"stop_id": 8570950,
		"ID": 501,
		"x": -48.1142740067,
		"y": -64.873851602,
		"h": 1.5274725275
	},
	{
		"stop_id": 8570955,
		"ID": 501,
		"x": -47.8492823797,
		"y": -63.712769053,
		"h": 1.5274725275
	},
	{
		"stop_id": 8570956,
		"ID": 501,
		"x": -47.9052761157,
		"y": -63.487767613,
		"h": 1.5274725275
	},
	{
		"stop_id": 8570957,
		"ID": 501,
		"x": -47.6462575177,
		"y": -63.680797816,
		"h": 1.5274725275
	},
	{
		"stop_id": 8570958,
		"ID": 501,
		"x": -48.0162740287,
		"y": -62.383773621,
		"h": 1.5274725275
	},
	{
		"stop_id": 8580394,
		"ID": 501,
		"x": -48.4742291677,
		"y": -63.869812405,
		"h": 1.5274725275
	},
	{
		"stop_id": 8580641,
		"ID": 501,
		"x": -47.7962713157,
		"y": -63.241767195,
		"h": 1.5274725275
	},
	{
		"stop_id": 8580735,
		"ID": 501,
		"x": -48.1332652437,
		"y": -63.656845167,
		"h": 1.5274725275
	},
	{
		"stop_id": 8501781,
		"ID": 664,
		"x": -21.9042353727,
		"y": -71.170842984,
		"h": 1.5934065934
	},
	{
		"stop_id": 8501783,
		"ID": 664,
		"x": -21.2342545587,
		"y": -74.445758722,
		"h": 1.5934065934
	},
	{
		"stop_id": 8505705,
		"ID": 664,
		"x": -21.6502604697,
		"y": -72.92282071,
		"h": 1.5934065934
	},
	{
		"stop_id": 8505726,
		"ID": 664,
		"x": -22.2032964997,
		"y": -70.57283775,
		"h": 1.5934065934
	},
	{
		"stop_id": 8505735,
		"ID": 664,
		"x": -21.2952747737,
		"y": -73.708765745,
		"h": 1.5934065934
	},
	{
		"stop_id": 8530226,
		"ID": 664,
		"x": -22.7782796987,
		"y": -75.40784524,
		"h": 1.5934065934
	},
	{
		"stop_id": 8530227,
		"ID": 664,
		"x": -21.1042591377,
		"y": -73.931779499,
		"h": 1.5934065934
	},
	{
		"stop_id": 8530230,
		"ID": 664,
		"x": -19.1202903397,
		"y": -72.772790222,
		"h": 1.5934065934
	},
	{
		"stop_id": 8557032,
		"ID": 664,
		"x": -21.1222887197,
		"y": -73.940787698,
		"h": 1.5934065934
	},
	{
		"stop_id": 8571153,
		"ID": 664,
		"x": -21.4292768077,
		"y": -73.393783828,
		"h": 1.5934065934
	},
	{
		"stop_id": 8571154,
		"ID": 664,
		"x": -21.2122256997,
		"y": -73.994831183,
		"h": 1.5934065934
	},
	{
		"stop_id": 8571155,
		"ID": 664,
		"x": -21.5892276647,
		"y": -74.493801252,
		"h": 1.5934065934
	},
	{
		"stop_id": 8571156,
		"ID": 664,
		"x": -21.4492756887,
		"y": -75.320791228,
		"h": 1.5934065934
	},
	{
		"stop_id": 8571193,
		"ID": 664,
		"x": -21.0942618297,
		"y": -74.858749184,
		"h": 1.5934065934
	},
	{
		"stop_id": 8571194,
		"ID": 664,
		"x": -20.9802838737,
		"y": -75.153841857,
		"h": 1.5934065934
	},
	{
		"stop_id": 8571195,
		"ID": 664,
		"x": -20.8392578387,
		"y": -75.517794927,
		"h": 1.5934065934
	},
	{
		"stop_id": 8580959,
		"ID": 664,
		"x": -22.1842253687,
		"y": -70.8707612,
		"h": 1.5934065934
	},
	{
		"stop_id": 8581283,
		"ID": 664,
		"x": -21.9802453117,
		"y": -71.706813189,
		"h": 1.5934065934
	},
	{
		"stop_id": 8581334,
		"ID": 664,
		"x": -21.1402805577,
		"y": -74.660828641,
		"h": 1.5934065934
	},
	{
		"stop_id": 8501786,
		"ID": 726,
		"x": -13.7982317577,
		"y": -60.263797006,
		"h": 1.0989010989
	},
	{
		"stop_id": 8501962,
		"ID": 726,
		"x": -14.2092417717,
		"y": -60.700792228,
		"h": 1.0989010989
	},
	{
		"stop_id": 8505731,
		"ID": 726,
		"x": -12.8892819557,
		"y": -59.54579725,
		"h": 1.0989010989
	},
	{
		"stop_id": 8571177,
		"ID": 726,
		"x": -14.0382618837,
		"y": -60.341763907,
		"h": 1.0989010989
	},
	{
		"stop_id": 8501791,
		"ID": 499,
		"x": -45.3422431397,
		"y": -73.039854727,
		"h": 1.0989010989
	},
	{
		"stop_id": 8530144,
		"ID": 499,
		"x": -45.4122630767,
		"y": -72.906842605,
		"h": 1.0989010989
	},
	{
		"stop_id": 8581942,
		"ID": 499,
		"x": -48.9042373887,
		"y": -76.437806666,
		"h": 1.0989010989
	},
	{
		"stop_id": 8583435,
		"ID": 499,
		"x": -45.0082315037,
		"y": -73.74485119,
		"h": 1.0989010989
	},
	{
		"stop_id": 8501797,
		"ID": 755,
		"x": -5.5372241107,
		"y": -66.288806221,
		"h": 1.0659340659
	},
	{
		"stop_id": 8580966,
		"ID": 755,
		"x": -6.5502343007,
		"y": -66.016856619,
		"h": 1.0659340659
	},
	{
		"stop_id": 8582817,
		"ID": 755,
		"x": -5.5932938637,
		"y": -67.089843144,
		"h": 1.0659340659
	},
	{
		"stop_id": 8501853,
		"ID": 36,
		"x": -150.3412560607,
		"y": -32.674799299,
		"h": 1.2637362637
	},
	{
		"stop_id": 8501854,
		"ID": 36,
		"x": -151.2332250997,
		"y": -33.203844981,
		"h": 1.2637362637
	},
	{
		"stop_id": 8501855,
		"ID": 36,
		"x": -150.1342449197,
		"y": -30.488821366,
		"h": 1.2637362637
	},
	{
		"stop_id": 8501856,
		"ID": 36,
		"x": -151.9972994947,
		"y": -34.496851108,
		"h": 1.2637362637
	},
	{
		"stop_id": 8570016,
		"ID": 36,
		"x": -151.7242362847,
		"y": -34.289793868,
		"h": 1.2637362637
	},
	{
		"stop_id": 8570017,
		"ID": 36,
		"x": -150.3742314447,
		"y": -31.133820622,
		"h": 1.2637362637
	},
	{
		"stop_id": 8570018,
		"ID": 36,
		"x": -149.4172735297,
		"y": -30.54480846,
		"h": 1.2637362637
	},
	{
		"stop_id": 8582794,
		"ID": 36,
		"x": -150.6022922337,
		"y": -35.301775785,
		"h": 1.2637362637
	},
	{
		"stop_id": 8583484,
		"ID": 36,
		"x": -150.8632284417,
		"y": -34.418856424,
		"h": 1.2637362637
	},
	{
		"stop_id": 8501877,
		"ID": 311,
		"x": -78.5922918657,
		"y": -99.3197881825,
		"h": 1
	},
	{
		"stop_id": 8501880,
		"ID": 312,
		"x": -77.6322797577,
		"y": -93.5998290227,
		"h": 1
	},
	{
		"stop_id": 8501883,
		"ID": 247,
		"x": -85.6222495467,
		"y": -97.6697849164,
		"h": 1.032967033
	},
	{
		"stop_id": 8579451,
		"ID": 247,
		"x": -86.2422715587,
		"y": -96.4698108795,
		"h": 1.032967033
	},
	{
		"stop_id": 8501885,
		"ID": 279,
		"x": -80.5452910807,
		"y": -102.8358169196,
		"h": 1.0659340659
	},
	{
		"stop_id": 8593535,
		"ID": 279,
		"x": -79.7632712257,
		"y": -102.278818417,
		"h": 1.0659340659
	},
	{
		"stop_id": 8595140,
		"ID": 279,
		"x": -80.8712281197,
		"y": -104.1278224019,
		"h": 1.0659340659
	},
	{
		"stop_id": 8501886,
		"ID": 281,
		"x": -79.4722536437,
		"y": -89.019754784,
		"h": 1.1648351648
	},
	{
		"stop_id": 8501887,
		"ID": 281,
		"x": -84.0222373967,
		"y": -89.4447791537,
		"h": 1.1648351648
	},
	{
		"stop_id": 8504682,
		"ID": 281,
		"x": -80.5682263967,
		"y": -87.47484793,
		"h": 1.1648351648
	},
	{
		"stop_id": 8579445,
		"ID": 281,
		"x": -83.9762288217,
		"y": -88.965827245,
		"h": 1.1648351648
	},
	{
		"stop_id": 8579446,
		"ID": 281,
		"x": -84.0372628347,
		"y": -89.9258563668,
		"h": 1.1648351648
	},
	{
		"stop_id": 8593536,
		"ID": 281,
		"x": -79.0592767347,
		"y": -89.7287836837,
		"h": 1.1648351648
	},
	{
		"stop_id": 8501892,
		"ID": 45,
		"x": -144.2422496467,
		"y": -25.669754399,
		"h": 1
	},
	{
		"stop_id": 8501895,
		"ID": 784,
		"x": -2.4672555697,
		"y": -47.555839987,
		"h": 1.1318681319
	},
	{
		"stop_id": 8505744,
		"ID": 784,
		"x": -3.1042410137,
		"y": -47.87879142,
		"h": 1.1318681319
	},
	{
		"stop_id": 8589092,
		"ID": 784,
		"x": -0.9922332207,
		"y": -46.919787603,
		"h": 1.1318681319
	},
	{
		"stop_id": 8589093,
		"ID": 784,
		"x": -0.1422882597,
		"y": -47.019851656,
		"h": 1.1318681319
	},
	{
		"stop_id": 8589094,
		"ID": 784,
		"x": -1.1852410747,
		"y": -47.069851882,
		"h": 1.1318681319
	},
	{
		"stop_id": 8501960,
		"ID": 662,
		"x": -19.7842892137,
		"y": -82.7998473784,
		"h": 1
	},
	{
		"stop_id": 8501961,
		"ID": 725,
		"x": -12.1492514587,
		"y": -66.358791197,
		"h": 1.1318681319
	},
	{
		"stop_id": 8505713,
		"ID": 725,
		"x": -10.7352815027,
		"y": -67.559823912,
		"h": 1.1318681319
	},
	{
		"stop_id": 8571180,
		"ID": 725,
		"x": -13.0892470427,
		"y": -65.32377997,
		"h": 1.1318681319
	},
	{
		"stop_id": 8571181,
		"ID": 725,
		"x": -9.3132997917,
		"y": -67.409754792,
		"h": 1.1318681319
	},
	{
		"stop_id": 8580965,
		"ID": 725,
		"x": -12.1472385517,
		"y": -66.113758824,
		"h": 1.1318681319
	},
	{
		"stop_id": 8501977,
		"ID": 382,
		"x": -67.8822350937,
		"y": -35.044757982,
		"h": 1.3626373626
	},
	{
		"stop_id": 8571300,
		"ID": 382,
		"x": -69.0162554567,
		"y": -35.824819888,
		"h": 1.3626373626
	},
	{
		"stop_id": 8571301,
		"ID": 382,
		"x": -68.6242330737,
		"y": -35.664781532,
		"h": 1.3626373626
	},
	{
		"stop_id": 8571302,
		"ID": 382,
		"x": -68.2662758137,
		"y": -35.196852076,
		"h": 1.3626373626
	},
	{
		"stop_id": 8571303,
		"ID": 382,
		"x": -66.4982889297,
		"y": -34.962778964,
		"h": 1.3626373626
	},
	{
		"stop_id": 8571304,
		"ID": 382,
		"x": -68.7482488957,
		"y": -35.293859114,
		"h": 1.3626373626
	},
	{
		"stop_id": 8571305,
		"ID": 382,
		"x": -69.2652515707,
		"y": -35.434793392,
		"h": 1.3626373626
	},
	{
		"stop_id": 8580239,
		"ID": 382,
		"x": -67.3062645547,
		"y": -34.919787922,
		"h": 1.3626373626
	},
	{
		"stop_id": 8580344,
		"ID": 382,
		"x": -69.0552483367,
		"y": -35.365757135,
		"h": 1.3626373626
	},
	{
		"stop_id": 8580520,
		"ID": 382,
		"x": -67.6082679017,
		"y": -34.957749395,
		"h": 1.3626373626
	},
	{
		"stop_id": 8580539,
		"ID": 382,
		"x": -66.8682426027,
		"y": -34.863855494,
		"h": 1.3626373626
	},
	{
		"stop_id": 8580540,
		"ID": 382,
		"x": -68.3432709107,
		"y": -35.44074978,
		"h": 1.3626373626
	},
	{
		"stop_id": 8501980,
		"ID": 94,
		"x": -120.3292678727,
		"y": -10.97085,
		"h": 1.2967032967
	},
	{
		"stop_id": 8507971,
		"ID": 94,
		"x": -120.2822335457,
		"y": -11.728854844,
		"h": 1.2967032967
	},
	{
		"stop_id": 8570195,
		"ID": 94,
		"x": -122.3262444917,
		"y": -10.908850486,
		"h": 1.2967032967
	},
	{
		"stop_id": 8570196,
		"ID": 94,
		"x": -122.5042561267,
		"y": -10.383807958,
		"h": 1.2967032967
	},
	{
		"stop_id": 8570197,
		"ID": 94,
		"x": -123.3753001947,
		"y": -9.784843444,
		"h": 1.2967032967
	},
	{
		"stop_id": 8570198,
		"ID": 94,
		"x": -123.8172817697,
		"y": -9.669847143,
		"h": 1.2967032967
	},
	{
		"stop_id": 8570199,
		"ID": 94,
		"x": -123.9602971717,
		"y": -9.790828348,
		"h": 1.2967032967
	},
	{
		"stop_id": 8570293,
		"ID": 94,
		"x": -120.3302293637,
		"y": -11.292795862,
		"h": 1.2967032967
	},
	{
		"stop_id": 8573549,
		"ID": 94,
		"x": -120.4722561007,
		"y": -10.240776816,
		"h": 1.2967032967
	},
	{
		"stop_id": 8583030,
		"ID": 94,
		"x": -120.8252363677,
		"y": -8.410840636,
		"h": 1.2967032967
	},
	{
		"stop_id": 8501981,
		"ID": 96,
		"x": -119.1552285067,
		"y": 3.191182009,
		"h": 2.2857142857
	},
	{
		"stop_id": 8504201,
		"ID": 96,
		"x": -120.5542897377,
		"y": 1.641147001,
		"h": 2.2857142857
	},
	{
		"stop_id": 8504291,
		"ID": 96,
		"x": -122.2382540657,
		"y": 0.348216446,
		"h": 2.2857142857
	},
	{
		"stop_id": 8504292,
		"ID": 96,
		"x": -122.8992850347,
		"y": 0.618201206,
		"h": 2.2857142857
	},
	{
		"stop_id": 8504557,
		"ID": 96,
		"x": -120.4822589837,
		"y": 1.608174133,
		"h": 2.2857142857
	},
	{
		"stop_id": 8504558,
		"ID": 96,
		"x": -120.6852751777,
		"y": -0.477828012,
		"h": 2.2857142857
	},
	{
		"stop_id": 8507677,
		"ID": 96,
		"x": -121.9422988267,
		"y": 3.980198641,
		"h": 2.2857142857
	},
	{
		"stop_id": 8507679,
		"ID": 96,
		"x": -122.2552720037,
		"y": 4.851183735,
		"h": 2.2857142857
	},
	{
		"stop_id": 8507681,
		"ID": 96,
		"x": -122.3622638697,
		"y": 2.205236008,
		"h": 2.2857142857
	},
	{
		"stop_id": 8507950,
		"ID": 96,
		"x": -121.6212571617,
		"y": 3.297144266,
		"h": 2.2857142857
	},
	{
		"stop_id": 8507957,
		"ID": 96,
		"x": -119.7142435247,
		"y": 2.658239111,
		"h": 2.2857142857
	},
	{
		"stop_id": 8507965,
		"ID": 96,
		"x": -121.6162976107,
		"y": 0.753202753,
		"h": 2.2857142857
	},
	{
		"stop_id": 8530263,
		"ID": 96,
		"x": -121.3612622547,
		"y": -0.287796597,
		"h": 2.2857142857
	},
	{
		"stop_id": 8570249,
		"ID": 96,
		"x": -121.3722368987,
		"y": -0.52281634,
		"h": 2.2857142857
	},
	{
		"stop_id": 8570250,
		"ID": 96,
		"x": -121.5962760917,
		"y": -0.056796325,
		"h": 2.2857142857
	},
	{
		"stop_id": 8570252,
		"ID": 96,
		"x": -120.5582637967,
		"y": 1.663199894,
		"h": 2.2857142857
	},
	{
		"stop_id": 8570253,
		"ID": 96,
		"x": -120.2382600867,
		"y": 1.988249374,
		"h": 2.2857142857
	},
	{
		"stop_id": 8570254,
		"ID": 96,
		"x": -120.5852558037,
		"y": 1.906167571,
		"h": 2.2857142857
	},
	{
		"stop_id": 8570255,
		"ID": 96,
		"x": -120.7882421027,
		"y": 1.904235051,
		"h": 2.2857142857
	},
	{
		"stop_id": 8570256,
		"ID": 96,
		"x": -122.0122959697,
		"y": 2.088181758,
		"h": 2.2857142857
	},
	{
		"stop_id": 8570257,
		"ID": 96,
		"x": -122.7832469387,
		"y": 2.289151259,
		"h": 2.2857142857
	},
	{
		"stop_id": 8570274,
		"ID": 96,
		"x": -119.1202786847,
		"y": 3.951153856,
		"h": 2.2857142857
	},
	{
		"stop_id": 8575769,
		"ID": 96,
		"x": -120.0522758757,
		"y": 2.431177053,
		"h": 2.2857142857
	},
	{
		"stop_id": 8579729,
		"ID": 96,
		"x": -124.4152509957,
		"y": 1.982179174,
		"h": 2.2857142857
	},
	{
		"stop_id": 8579855,
		"ID": 96,
		"x": -119.7782619817,
		"y": 2.652211452,
		"h": 2.2857142857
	},
	{
		"stop_id": 8582422,
		"ID": 96,
		"x": -122.0432537037,
		"y": 4.170247339,
		"h": 2.2857142857
	},
	{
		"stop_id": 8583824,
		"ID": 96,
		"x": -123.0692985537,
		"y": 0.879147165,
		"h": 2.2857142857
	},
	{
		"stop_id": 8583825,
		"ID": 96,
		"x": -122.9032912047,
		"y": 0.723192123,
		"h": 2.2857142857
	},
	{
		"stop_id": 8594010,
		"ID": 96,
		"x": -122.2042586787,
		"y": -0.095834856,
		"h": 2.2857142857
	},
	{
		"stop_id": 8594011,
		"ID": 96,
		"x": -122.8132808287,
		"y": -0.087774058,
		"h": 2.2857142857
	},
	{
		"stop_id": 8594012,
		"ID": 96,
		"x": -122.3662401667,
		"y": 0.193244729,
		"h": 2.2857142857
	},
	{
		"stop_id": 8594013,
		"ID": 96,
		"x": -122.0782618837,
		"y": -0.197762321,
		"h": 2.2857142857
	},
	{
		"stop_id": 8594014,
		"ID": 96,
		"x": -122.8542902117,
		"y": 0.049180654,
		"h": 2.2857142857
	},
	{
		"stop_id": 8594022,
		"ID": 96,
		"x": -121.1532580487,
		"y": -0.183765477,
		"h": 2.2857142857
	},
	{
		"stop_id": 8594023,
		"ID": 96,
		"x": -121.0392392157,
		"y": -0.390829484,
		"h": 2.2857142857
	},
	{
		"stop_id": 8594032,
		"ID": 96,
		"x": -121.4552343717,
		"y": -0.351753024,
		"h": 2.2857142857
	},
	{
		"stop_id": 8594037,
		"ID": 96,
		"x": -121.6862718357,
		"y": -0.547809576,
		"h": 2.2857142857
	},
	{
		"stop_id": 8594038,
		"ID": 96,
		"x": -121.0442271167,
		"y": -0.236802532,
		"h": 2.2857142857
	},
	{
		"stop_id": 8594047,
		"ID": 96,
		"x": -121.8402784117,
		"y": -0.47984132,
		"h": 2.2857142857
	},
	{
		"stop_id": 8594053,
		"ID": 96,
		"x": -121.0972702807,
		"y": -0.546767101,
		"h": 2.2857142857
	},
	{
		"stop_id": 8502001,
		"ID": 686,
		"x": -21.5802484567,
		"y": 55.014167808,
		"h": 3.3736263736
	},
	{
		"stop_id": 8502002,
		"ID": 686,
		"x": -20.5082461087,
		"y": 52.199146447,
		"h": 3.3736263736
	},
	{
		"stop_id": 8502120,
		"ID": 686,
		"x": -21.6962926207,
		"y": 56.56118449,
		"h": 3.3736263736
	},
	{
		"stop_id": 8502353,
		"ID": 686,
		"x": -21.5922988837,
		"y": 51.905244686,
		"h": 3.3736263736
	},
	{
		"stop_id": 8502354,
		"ID": 686,
		"x": -21.2702839827,
		"y": 51.865182247,
		"h": 3.3736263736
	},
	{
		"stop_id": 8502355,
		"ID": 686,
		"x": -20.9702369137,
		"y": 52.513203203,
		"h": 3.3736263736
	},
	{
		"stop_id": 8502356,
		"ID": 686,
		"x": -23.2372602267,
		"y": 53.841247313,
		"h": 3.3736263736
	},
	{
		"stop_id": 8502358,
		"ID": 686,
		"x": -21.2752739007,
		"y": 53.969250057,
		"h": 3.3736263736
	},
	{
		"stop_id": 8502359,
		"ID": 686,
		"x": -21.1642538247,
		"y": 53.476213893,
		"h": 3.3736263736
	},
	{
		"stop_id": 8502363,
		"ID": 686,
		"x": -22.0642389417,
		"y": 56.729170163,
		"h": 3.3736263736
	},
	{
		"stop_id": 8502364,
		"ID": 686,
		"x": -22.3212676917,
		"y": 56.424241387,
		"h": 3.3736263736
	},
	{
		"stop_id": 8502369,
		"ID": 686,
		"x": -21.2392901937,
		"y": 55.84222484,
		"h": 3.3736263736
	},
	{
		"stop_id": 8502370,
		"ID": 686,
		"x": -20.4842913997,
		"y": 56.053185857,
		"h": 3.3736263736
	},
	{
		"stop_id": 8502374,
		"ID": 686,
		"x": -20.1442826597,
		"y": 52.848188478,
		"h": 3.3736263736
	},
	{
		"stop_id": 8502375,
		"ID": 686,
		"x": -20.4462526797,
		"y": 54.201150349,
		"h": 3.3736263736
	},
	{
		"stop_id": 8502380,
		"ID": 686,
		"x": -19.4742424557,
		"y": 52.168148066,
		"h": 3.3736263736
	},
	{
		"stop_id": 8502384,
		"ID": 686,
		"x": -20.9162794437,
		"y": 53.950237701,
		"h": 3.3736263736
	},
	{
		"stop_id": 8502385,
		"ID": 686,
		"x": -20.0312757867,
		"y": 56.196174935,
		"h": 3.3736263736
	},
	{
		"stop_id": 8502386,
		"ID": 686,
		"x": -21.1512866857,
		"y": 54.369194874,
		"h": 3.3736263736
	},
	{
		"stop_id": 8502387,
		"ID": 686,
		"x": -22.3332541147,
		"y": 55.649229304,
		"h": 3.3736263736
	},
	{
		"stop_id": 8502393,
		"ID": 686,
		"x": -22.4052895627,
		"y": 53.630168115,
		"h": 3.3736263736
	},
	{
		"stop_id": 8502398,
		"ID": 686,
		"x": -19.9122760337,
		"y": 52.309176322,
		"h": 3.3736263736
	},
	{
		"stop_id": 8502581,
		"ID": 686,
		"x": -21.4832534167,
		"y": 55.388250477,
		"h": 3.3736263736
	},
	{
		"stop_id": 8502891,
		"ID": 686,
		"x": -22.6672642847,
		"y": 53.972188925,
		"h": 3.3736263736
	},
	{
		"stop_id": 8572654,
		"ID": 686,
		"x": -21.0172775697,
		"y": 56.084154131,
		"h": 3.3736263736
	},
	{
		"stop_id": 8572677,
		"ID": 686,
		"x": -21.3572435127,
		"y": 55.765190907,
		"h": 3.3736263736
	},
	{
		"stop_id": 8572678,
		"ID": 686,
		"x": -21.4432293977,
		"y": 55.997228295,
		"h": 3.3736263736
	},
	{
		"stop_id": 8572679,
		"ID": 686,
		"x": -21.4692849037,
		"y": 56.214198526,
		"h": 3.3736263736
	},
	{
		"stop_id": 8572680,
		"ID": 686,
		"x": -21.5362797387,
		"y": 56.764229104,
		"h": 3.3736263736
	},
	{
		"stop_id": 8572684,
		"ID": 686,
		"x": -21.6132652797,
		"y": 55.420213338,
		"h": 3.3736263736
	},
	{
		"stop_id": 8572685,
		"ID": 686,
		"x": -22.0842701677,
		"y": 55.916192786,
		"h": 3.3736263736
	},
	{
		"stop_id": 8572686,
		"ID": 686,
		"x": -22.4752243777,
		"y": 56.757152772,
		"h": 3.3736263736
	},
	{
		"stop_id": 8572700,
		"ID": 686,
		"x": -21.8562277977,
		"y": 54.968151598,
		"h": 3.3736263736
	},
	{
		"stop_id": 8572701,
		"ID": 686,
		"x": -21.8002251277,
		"y": 54.621178107,
		"h": 3.3736263736
	},
	{
		"stop_id": 8572702,
		"ID": 686,
		"x": -22.0172814447,
		"y": 54.395209949,
		"h": 3.3736263736
	},
	{
		"stop_id": 8572703,
		"ID": 686,
		"x": -22.3642371077,
		"y": 54.225245182,
		"h": 3.3736263736
	},
	{
		"stop_id": 8572704,
		"ID": 686,
		"x": -23.7882701217,
		"y": 53.632204119,
		"h": 3.3736263736
	},
	{
		"stop_id": 8572705,
		"ID": 686,
		"x": -24.3692333657,
		"y": 53.707212268,
		"h": 3.3736263736
	},
	{
		"stop_id": 8572716,
		"ID": 686,
		"x": -22.0702464117,
		"y": 54.89719137,
		"h": 3.3736263736
	},
	{
		"stop_id": 8572717,
		"ID": 686,
		"x": -22.3662401577,
		"y": 54.748229347,
		"h": 3.3736263736
	},
	{
		"stop_id": 8572718,
		"ID": 686,
		"x": -22.5712816297,
		"y": 54.812206748,
		"h": 3.3736263736
	},
	{
		"stop_id": 8572719,
		"ID": 686,
		"x": -22.8962791887,
		"y": 54.78716829,
		"h": 3.3736263736
	},
	{
		"stop_id": 8572720,
		"ID": 686,
		"x": -22.8412707427,
		"y": 54.359239414,
		"h": 3.3736263736
	},
	{
		"stop_id": 8572721,
		"ID": 686,
		"x": -22.7362484777,
		"y": 54.151205348,
		"h": 3.3736263736
	},
	{
		"stop_id": 8572722,
		"ID": 686,
		"x": -22.5752356537,
		"y": 53.920175034,
		"h": 3.3736263736
	},
	{
		"stop_id": 8572723,
		"ID": 686,
		"x": -21.6902823317,
		"y": 53.082243973,
		"h": 3.3736263736
	},
	{
		"stop_id": 8572724,
		"ID": 686,
		"x": -21.5932586127,
		"y": 52.774227561,
		"h": 3.3736263736
	},
	{
		"stop_id": 8572725,
		"ID": 686,
		"x": -21.4582766987,
		"y": 52.132247773,
		"h": 3.3736263736
	},
	{
		"stop_id": 8572726,
		"ID": 686,
		"x": -20.9062401287,
		"y": 52.031207241,
		"h": 3.3736263736
	},
	{
		"stop_id": 8572727,
		"ID": 686,
		"x": -20.5162524387,
		"y": 52.185196003,
		"h": 3.3736263736
	},
	{
		"stop_id": 8572728,
		"ID": 686,
		"x": -21.2622362217,
		"y": 54.795189795,
		"h": 3.3736263736
	},
	{
		"stop_id": 8572740,
		"ID": 686,
		"x": -21.1232558217,
		"y": 53.059217485,
		"h": 3.3736263736
	},
	{
		"stop_id": 8572741,
		"ID": 686,
		"x": -20.4522256007,
		"y": 53.96018076,
		"h": 3.3736263736
	},
	{
		"stop_id": 8572742,
		"ID": 686,
		"x": -22.2292636357,
		"y": 55.436193909,
		"h": 3.3736263736
	},
	{
		"stop_id": 8572743,
		"ID": 686,
		"x": -22.5662490117,
		"y": 55.773179808,
		"h": 3.3736263736
	},
	{
		"stop_id": 8572745,
		"ID": 686,
		"x": -21.5032742807,
		"y": 54.91415456,
		"h": 3.3736263736
	},
	{
		"stop_id": 8580333,
		"ID": 686,
		"x": -22.0032344477,
		"y": 55.221154694,
		"h": 3.3736263736
	},
	{
		"stop_id": 8580586,
		"ID": 686,
		"x": -21.2312561847,
		"y": 51.881222586,
		"h": 3.3736263736
	},
	{
		"stop_id": 8589205,
		"ID": 686,
		"x": -21.5802861137,
		"y": 53.712234038,
		"h": 3.3736263736
	},
	{
		"stop_id": 8589206,
		"ID": 686,
		"x": -21.6072796587,
		"y": 53.9922374,
		"h": 3.3736263736
	},
	{
		"stop_id": 8593493,
		"ID": 686,
		"x": -22.5422850267,
		"y": 54.180211508,
		"h": 3.3736263736
	},
	{
		"stop_id": 8594480,
		"ID": 686,
		"x": -21.3402493247,
		"y": 55.090205639,
		"h": 3.3736263736
	},
	{
		"stop_id": 8594481,
		"ID": 686,
		"x": -21.2992583867,
		"y": 55.723205561,
		"h": 3.3736263736
	},
	{
		"stop_id": 8594482,
		"ID": 686,
		"x": -21.2022459797,
		"y": 55.670244454,
		"h": 3.3736263736
	},
	{
		"stop_id": 8594483,
		"ID": 686,
		"x": -21.0342438447,
		"y": 55.54214341,
		"h": 3.3736263736
	},
	{
		"stop_id": 8594484,
		"ID": 686,
		"x": -21.5482763717,
		"y": 55.336243878,
		"h": 3.3736263736
	},
	{
		"stop_id": 8594485,
		"ID": 686,
		"x": -21.4422685587,
		"y": 55.050188919,
		"h": 3.3736263736
	},
	{
		"stop_id": 8594486,
		"ID": 686,
		"x": -21.0912262327,
		"y": 55.185212805,
		"h": 3.3736263736
	},
	{
		"stop_id": 8594487,
		"ID": 686,
		"x": -20.9312318757,
		"y": 55.243180714,
		"h": 3.3736263736
	},
	{
		"stop_id": 8594488,
		"ID": 686,
		"x": -20.6772521767,
		"y": 55.215159612,
		"h": 3.3736263736
	},
	{
		"stop_id": 8594489,
		"ID": 686,
		"x": -20.4582995887,
		"y": 55.11920803,
		"h": 3.3736263736
	},
	{
		"stop_id": 8595157,
		"ID": 686,
		"x": -24.5402588637,
		"y": 54.196171204,
		"h": 3.3736263736
	},
	{
		"stop_id": 8595158,
		"ID": 686,
		"x": -24.3912642567,
		"y": 54.536157585,
		"h": 3.3736263736
	},
	{
		"stop_id": 8502003,
		"ID": 685,
		"x": -19.6042799117,
		"y": 49.848150979,
		"h": 1.5274725275
	},
	{
		"stop_id": 8502004,
		"ID": 685,
		"x": -18.8092557137,
		"y": 47.195142466,
		"h": 1.5274725275
	},
	{
		"stop_id": 8502389,
		"ID": 685,
		"x": -21.5482380347,
		"y": 46.95123481,
		"h": 1.5274725275
	},
	{
		"stop_id": 8502390,
		"ID": 685,
		"x": -20.1482655877,
		"y": 48.660213447,
		"h": 1.5274725275
	},
	{
		"stop_id": 8502394,
		"ID": 685,
		"x": -24.1232618027,
		"y": 48.971180305,
		"h": 1.5274725275
	},
	{
		"stop_id": 8502395,
		"ID": 685,
		"x": -20.3362481957,
		"y": 50.297204989,
		"h": 1.5274725275
	},
	{
		"stop_id": 8502397,
		"ID": 685,
		"x": -21.3642278977,
		"y": 50.35418821,
		"h": 1.5274725275
	},
	{
		"stop_id": 8502399,
		"ID": 685,
		"x": -21.2392691877,
		"y": 47.353249775,
		"h": 1.5274725275
	},
	{
		"stop_id": 8502578,
		"ID": 685,
		"x": -20.8962448097,
		"y": 47.637208587,
		"h": 1.5274725275
	},
	{
		"stop_id": 8502579,
		"ID": 685,
		"x": -21.8012641417,
		"y": 46.145234271,
		"h": 1.5274725275
	},
	{
		"stop_id": 8502898,
		"ID": 685,
		"x": -19.5792453547,
		"y": 49.852211315,
		"h": 1.5274725275
	},
	{
		"stop_id": 8572729,
		"ID": 685,
		"x": -19.4172488367,
		"y": 50.516165597,
		"h": 1.5274725275
	},
	{
		"stop_id": 8572730,
		"ID": 685,
		"x": -19.6882658487,
		"y": 50.435173283,
		"h": 1.5274725275
	},
	{
		"stop_id": 8572731,
		"ID": 685,
		"x": -22.7012549607,
		"y": 49.759235485,
		"h": 1.5274725275
	},
	{
		"stop_id": 8572733,
		"ID": 685,
		"x": -20.0652338807,
		"y": 48.383150376,
		"h": 1.5274725275
	},
	{
		"stop_id": 8579699,
		"ID": 685,
		"x": -20.1812495097,
		"y": 49.133176235,
		"h": 1.5274725275
	},
	{
		"stop_id": 8589208,
		"ID": 685,
		"x": -19.4062937237,
		"y": 50.084192451,
		"h": 1.5274725275
	},
	{
		"stop_id": 8502005,
		"ID": 715,
		"x": -18.9092776237,
		"y": 44.395180141,
		"h": 1.3626373626
	},
	{
		"stop_id": 8502006,
		"ID": 715,
		"x": -15.7522492177,
		"y": 43.47020647,
		"h": 1.3626373626
	},
	{
		"stop_id": 8572760,
		"ID": 715,
		"x": -18.9422903287,
		"y": 44.468220754,
		"h": 1.3626373626
	},
	{
		"stop_id": 8572811,
		"ID": 715,
		"x": -19.6952484117,
		"y": 45.431143431,
		"h": 1.3626373626
	},
	{
		"stop_id": 8572988,
		"ID": 715,
		"x": -14.1252750687,
		"y": 45.926184603,
		"h": 1.3626373626
	},
	{
		"stop_id": 8572990,
		"ID": 715,
		"x": -14.6742982637,
		"y": 45.478170065,
		"h": 1.3626373626
	},
	{
		"stop_id": 8572991,
		"ID": 715,
		"x": -15.8242890677,
		"y": 46.411152997,
		"h": 1.3626373626
	},
	{
		"stop_id": 8572992,
		"ID": 715,
		"x": -17.9542504407,
		"y": 46.632179651,
		"h": 1.3626373626
	},
	{
		"stop_id": 8581976,
		"ID": 715,
		"x": -18.9422320457,
		"y": 46.018171187,
		"h": 1.3626373626
	},
	{
		"stop_id": 8582441,
		"ID": 715,
		"x": -16.5712303627,
		"y": 43.562159096,
		"h": 1.3626373626
	},
	{
		"stop_id": 8582442,
		"ID": 715,
		"x": -15.6482563897,
		"y": 43.634187101,
		"h": 1.3626373626
	},
	{
		"stop_id": 8582443,
		"ID": 715,
		"x": -14.8532734427,
		"y": 43.75019725,
		"h": 1.3626373626
	},
	{
		"stop_id": 8502007,
		"ID": 744,
		"x": -9.7622938297,
		"y": 42.065150314,
		"h": 2.021978022
	},
	{
		"stop_id": 8502010,
		"ID": 744,
		"x": -11.5382860117,
		"y": 43.08313996,
		"h": 2.021978022
	},
	{
		"stop_id": 8502998,
		"ID": 744,
		"x": -9.7052804637,
		"y": 42.002145648,
		"h": 2.021978022
	},
	{
		"stop_id": 8508708,
		"ID": 744,
		"x": -12.1942936597,
		"y": 41.70724255,
		"h": 2.021978022
	},
	{
		"stop_id": 8572961,
		"ID": 744,
		"x": -9.4942593877,
		"y": 42.287209421,
		"h": 2.021978022
	},
	{
		"stop_id": 8572981,
		"ID": 744,
		"x": -11.5262870587,
		"y": 43.389203917,
		"h": 2.021978022
	},
	{
		"stop_id": 8572983,
		"ID": 744,
		"x": -11.5652562857,
		"y": 44.579181023,
		"h": 2.021978022
	},
	{
		"stop_id": 8572984,
		"ID": 744,
		"x": -11.5722335677,
		"y": 44.954246387,
		"h": 2.021978022
	},
	{
		"stop_id": 8572995,
		"ID": 744,
		"x": -8.8772602477,
		"y": 42.799208591,
		"h": 2.021978022
	},
	{
		"stop_id": 8577319,
		"ID": 744,
		"x": -11.0052922577,
		"y": 41.516178837,
		"h": 2.021978022
	},
	{
		"stop_id": 8577320,
		"ID": 744,
		"x": -11.5892353017,
		"y": 41.594144489,
		"h": 2.021978022
	},
	{
		"stop_id": 8577321,
		"ID": 744,
		"x": -13.6342479867,
		"y": 41.379167217,
		"h": 2.021978022
	},
	{
		"stop_id": 8577322,
		"ID": 744,
		"x": -13.7682622397,
		"y": 41.059158459,
		"h": 2.021978022
	},
	{
		"stop_id": 8581081,
		"ID": 744,
		"x": -10.2592949677,
		"y": 42.268237047,
		"h": 2.021978022
	},
	{
		"stop_id": 8581085,
		"ID": 744,
		"x": -8.2052499047,
		"y": 42.417193493,
		"h": 2.021978022
	},
	{
		"stop_id": 8581191,
		"ID": 744,
		"x": -12.4022798587,
		"y": 43.281220515,
		"h": 2.021978022
	},
	{
		"stop_id": 8581323,
		"ID": 744,
		"x": -8.7722407127,
		"y": 42.256214328,
		"h": 2.021978022
	},
	{
		"stop_id": 8581445,
		"ID": 744,
		"x": -9.9762683377,
		"y": 42.176204987,
		"h": 2.021978022
	},
	{
		"stop_id": 8581469,
		"ID": 744,
		"x": -8.5622554127,
		"y": 41.950158876,
		"h": 2.021978022
	},
	{
		"stop_id": 8582560,
		"ID": 744,
		"x": -9.1142243587,
		"y": 42.967182454,
		"h": 2.021978022
	},
	{
		"stop_id": 8582564,
		"ID": 744,
		"x": -9.6582251477,
		"y": 42.68118318,
		"h": 2.021978022
	},
	{
		"stop_id": 8582565,
		"ID": 744,
		"x": -9.0402843307,
		"y": 43.533163065,
		"h": 2.021978022
	},
	{
		"stop_id": 8582753,
		"ID": 744,
		"x": -11.7422422347,
		"y": 43.5961428,
		"h": 2.021978022
	},
	{
		"stop_id": 8582754,
		"ID": 744,
		"x": -11.5162761937,
		"y": 44.174215265,
		"h": 2.021978022
	},
	{
		"stop_id": 8582755,
		"ID": 744,
		"x": -11.7232774427,
		"y": 45.200179089,
		"h": 2.021978022
	},
	{
		"stop_id": 8582782,
		"ID": 744,
		"x": -10.3312362957,
		"y": 41.034213195,
		"h": 2.021978022
	},
	{
		"stop_id": 8583054,
		"ID": 744,
		"x": -8.8622430377,
		"y": 42.470244016,
		"h": 2.021978022
	},
	{
		"stop_id": 8583242,
		"ID": 744,
		"x": -9.0822829457,
		"y": 42.180188702,
		"h": 2.021978022
	},
	{
		"stop_id": 8583379,
		"ID": 744,
		"x": -8.8672803827,
		"y": 42.270188172,
		"h": 2.021978022
	},
	{
		"stop_id": 8583706,
		"ID": 744,
		"x": -9.7362410617,
		"y": 40.958242309,
		"h": 2.021978022
	},
	{
		"stop_id": 8587735,
		"ID": 744,
		"x": -10.2662605467,
		"y": 41.975220632,
		"h": 2.021978022
	},
	{
		"stop_id": 8588511,
		"ID": 744,
		"x": -8.5512794827,
		"y": 41.81116719,
		"h": 2.021978022
	},
	{
		"stop_id": 8502008,
		"ID": 773,
		"x": -6.6442262657,
		"y": 38.53617268,
		"h": 1.6923076923
	},
	{
		"stop_id": 8502011,
		"ID": 773,
		"x": -8.5082694127,
		"y": 40.346188456,
		"h": 1.6923076923
	},
	{
		"stop_id": 8502550,
		"ID": 773,
		"x": -8.2782749637,
		"y": 41.849210003,
		"h": 1.6923076923
	},
	{
		"stop_id": 8502959,
		"ID": 773,
		"x": -4.4212390267,
		"y": 39.878226124,
		"h": 1.6923076923
	},
	{
		"stop_id": 8502994,
		"ID": 773,
		"x": -8.2942519467,
		"y": 42.215187595,
		"h": 1.6923076923
	},
	{
		"stop_id": 8572964,
		"ID": 773,
		"x": -6.7612820997,
		"y": 42.40519003,
		"h": 1.6923076923
	},
	{
		"stop_id": 8573003,
		"ID": 773,
		"x": -4.0042512387,
		"y": 39.515220742,
		"h": 1.6923076923
	},
	{
		"stop_id": 8577325,
		"ID": 773,
		"x": -8.5232302727,
		"y": 41.459190689,
		"h": 1.6923076923
	},
	{
		"stop_id": 8577326,
		"ID": 773,
		"x": -8.4282696837,
		"y": 40.972151657,
		"h": 1.6923076923
	},
	{
		"stop_id": 8577327,
		"ID": 773,
		"x": -8.4242243627,
		"y": 40.485219645,
		"h": 1.6923076923
	},
	{
		"stop_id": 8577328,
		"ID": 773,
		"x": -7.9792945267,
		"y": 39.413186854,
		"h": 1.6923076923
	},
	{
		"stop_id": 8577329,
		"ID": 773,
		"x": -7.2742833547,
		"y": 38.736159264,
		"h": 1.6923076923
	},
	{
		"stop_id": 8577330,
		"ID": 773,
		"x": -6.9082721327,
		"y": 38.233195447,
		"h": 1.6923076923
	},
	{
		"stop_id": 8577331,
		"ID": 773,
		"x": -7.3552461997,
		"y": 38.169210424,
		"h": 1.6923076923
	},
	{
		"stop_id": 8577332,
		"ID": 773,
		"x": -8.1162410077,
		"y": 38.008249144,
		"h": 1.6923076923
	},
	{
		"stop_id": 8580010,
		"ID": 773,
		"x": -3.4842681617,
		"y": 39.103185567,
		"h": 1.6923076923
	},
	{
		"stop_id": 8583507,
		"ID": 773,
		"x": -4.4882708567,
		"y": 40.914248093,
		"h": 1.6923076923
	},
	{
		"stop_id": 8583509,
		"ID": 773,
		"x": -4.6002260337,
		"y": 40.401224853,
		"h": 1.6923076923
	},
	{
		"stop_id": 8583532,
		"ID": 773,
		"x": -4.3802943467,
		"y": 41.494167843,
		"h": 1.6923076923
	},
	{
		"stop_id": 8593756,
		"ID": 773,
		"x": -7.2952470547,
		"y": 38.515172447,
		"h": 1.6923076923
	},
	{
		"stop_id": 8594846,
		"ID": 773,
		"x": -6.6692910067,
		"y": 37.756248644,
		"h": 1.6923076923
	},
	{
		"stop_id": 8595662,
		"ID": 773,
		"x": -8.4102622637,
		"y": 40.748168646,
		"h": 1.6923076923
	},
	{
		"stop_id": 8502009,
		"ID": 799,
		"x": -2.2672527867,
		"y": 36.047242285,
		"h": 1.5274725275
	},
	{
		"stop_id": 8502754,
		"ID": 799,
		"x": -1.5142934437,
		"y": 34.082229607,
		"h": 1.5274725275
	},
	{
		"stop_id": 8502756,
		"ID": 799,
		"x": -2.6062600207,
		"y": 38.094247536,
		"h": 1.5274725275
	},
	{
		"stop_id": 8573004,
		"ID": 799,
		"x": -2.7162769817,
		"y": 38.475207661,
		"h": 1.5274725275
	},
	{
		"stop_id": 8573005,
		"ID": 799,
		"x": -2.5472559417,
		"y": 37.488216101,
		"h": 1.5274725275
	},
	{
		"stop_id": 8573006,
		"ID": 799,
		"x": -2.4432848277,
		"y": 36.855156886,
		"h": 1.5274725275
	},
	{
		"stop_id": 8573008,
		"ID": 799,
		"x": -2.3532649147,
		"y": 36.073207379,
		"h": 1.5274725275
	},
	{
		"stop_id": 8573039,
		"ID": 799,
		"x": -1.7342459657,
		"y": 34.31722994,
		"h": 1.5274725275
	},
	{
		"stop_id": 8573040,
		"ID": 799,
		"x": -1.8262674677,
		"y": 34.607179986,
		"h": 1.5274725275
	},
	{
		"stop_id": 8573041,
		"ID": 799,
		"x": -2.1082241127,
		"y": 34.930201696,
		"h": 1.5274725275
	},
	{
		"stop_id": 8577245,
		"ID": 799,
		"x": 1.5727450873,
		"y": 36.250186241,
		"h": 1.5274725275
	},
	{
		"stop_id": 8581320,
		"ID": 799,
		"x": -2.3662819157,
		"y": 35.486165311,
		"h": 1.5274725275
	},
	{
		"stop_id": 8582111,
		"ID": 799,
		"x": 1.1477407813,
		"y": 38.009149044,
		"h": 1.5274725275
	},
	{
		"stop_id": 8582112,
		"ID": 799,
		"x": 1.2397664353,
		"y": 37.276187499,
		"h": 1.5274725275
	},
	{
		"stop_id": 8583512,
		"ID": 799,
		"x": -1.9592526947,
		"y": 36.155175315,
		"h": 1.5274725275
	},
	{
		"stop_id": 8583513,
		"ID": 799,
		"x": -1.9632688167,
		"y": 36.123227796,
		"h": 1.5274725275
	},
	{
		"stop_id": 8583562,
		"ID": 799,
		"x": -2.3232698247,
		"y": 37.992237643,
		"h": 1.5274725275
	},
	{
		"stop_id": 8502012,
		"ID": 824,
		"x": 3.6217176703,
		"y": 33.311228717,
		"h": 2.9450549451
	},
	{
		"stop_id": 8502020,
		"ID": 824,
		"x": 1.8027463893,
		"y": 32.990202559,
		"h": 2.9450549451
	},
	{
		"stop_id": 8502021,
		"ID": 824,
		"x": 4.3577739623,
		"y": 31.061145862,
		"h": 2.9450549451
	},
	{
		"stop_id": 8502028,
		"ID": 824,
		"x": 3.9117374653,
		"y": 31.914229731,
		"h": 2.9450549451
	},
	{
		"stop_id": 8502098,
		"ID": 824,
		"x": 3.5027202663,
		"y": 33.627161506,
		"h": 2.9450549451
	},
	{
		"stop_id": 8573028,
		"ID": 824,
		"x": 4.3187748853,
		"y": 31.078181892,
		"h": 2.9450549451
	},
	{
		"stop_id": 8573032,
		"ID": 824,
		"x": 2.9667050893,
		"y": 32.339148093,
		"h": 2.9450549451
	},
	{
		"stop_id": 8573033,
		"ID": 824,
		"x": 2.0997205543,
		"y": 32.303184529,
		"h": 2.9450549451
	},
	{
		"stop_id": 8573034,
		"ID": 824,
		"x": 1.5957752463,
		"y": 32.419163086,
		"h": 2.9450549451
	},
	{
		"stop_id": 8577234,
		"ID": 824,
		"x": 3.8277062393,
		"y": 31.803153794,
		"h": 2.9450549451
	},
	{
		"stop_id": 8577235,
		"ID": 824,
		"x": 3.5587025913,
		"y": 32.252237006,
		"h": 2.9450549451
	},
	{
		"stop_id": 8577236,
		"ID": 824,
		"x": 3.6027270503,
		"y": 33.026183533,
		"h": 2.9450549451
	},
	{
		"stop_id": 8577237,
		"ID": 824,
		"x": 3.6537095873,
		"y": 33.373162731,
		"h": 2.9450549451
	},
	{
		"stop_id": 8577238,
		"ID": 824,
		"x": 3.4347559073,
		"y": 34.079166252,
		"h": 2.9450549451
	},
	{
		"stop_id": 8577239,
		"ID": 824,
		"x": 2.9077082863,
		"y": 34.483189364,
		"h": 2.9450549451
	},
	{
		"stop_id": 8577240,
		"ID": 824,
		"x": 2.7557676653,
		"y": 34.27624397,
		"h": 2.9450549451
	},
	{
		"stop_id": 8577241,
		"ID": 824,
		"x": 2.7217042113,
		"y": 33.955243403,
		"h": 2.9450549451
	},
	{
		"stop_id": 8577242,
		"ID": 824,
		"x": 2.1577688323,
		"y": 33.463169087,
		"h": 2.9450549451
	},
	{
		"stop_id": 8577244,
		"ID": 824,
		"x": 2.3247162433,
		"y": 35.41122408,
		"h": 2.9450549451
	},
	{
		"stop_id": 8577269,
		"ID": 824,
		"x": 4.5707396613,
		"y": 31.120141168,
		"h": 2.9450549451
	},
	{
		"stop_id": 8577271,
		"ID": 824,
		"x": 4.7037008883,
		"y": 31.349162174,
		"h": 2.9450549451
	},
	{
		"stop_id": 8577273,
		"ID": 824,
		"x": 4.9397648533,
		"y": 31.455227364,
		"h": 2.9450549451
	},
	{
		"stop_id": 8577276,
		"ID": 824,
		"x": 4.4707319893,
		"y": 32.365167623,
		"h": 2.9450549451
	},
	{
		"stop_id": 8577277,
		"ID": 824,
		"x": 4.6887750313,
		"y": 32.547187723,
		"h": 2.9450549451
	},
	{
		"stop_id": 8577278,
		"ID": 824,
		"x": 4.9347077313,
		"y": 32.705170139,
		"h": 2.9450549451
	},
	{
		"stop_id": 8582118,
		"ID": 824,
		"x": 1.7757521563,
		"y": 33.001153016,
		"h": 2.9450549451
	},
	{
		"stop_id": 8588837,
		"ID": 824,
		"x": 3.2067311693,
		"y": 34.355148261,
		"h": 2.9450549451
	},
	{
		"stop_id": 8589670,
		"ID": 824,
		"x": 4.0267204393,
		"y": 31.311196495,
		"h": 2.9450549451
	},
	{
		"stop_id": 8589671,
		"ID": 824,
		"x": 3.8467677573,
		"y": 31.618242762,
		"h": 2.9450549451
	},
	{
		"stop_id": 8589989,
		"ID": 824,
		"x": 4.4417133783,
		"y": 31.096181157,
		"h": 2.9450549451
	},
	{
		"stop_id": 8589990,
		"ID": 824,
		"x": 5.2827748233,
		"y": 31.602158928,
		"h": 2.9450549451
	},
	{
		"stop_id": 8590366,
		"ID": 824,
		"x": 3.8857646023,
		"y": 31.067207502,
		"h": 2.9450549451
	},
	{
		"stop_id": 8590367,
		"ID": 824,
		"x": 6.6497620653,
		"y": 33.644159951,
		"h": 2.9450549451
	},
	{
		"stop_id": 8590368,
		"ID": 824,
		"x": 5.0287064323,
		"y": 31.665211457,
		"h": 2.9450549451
	},
	{
		"stop_id": 8590369,
		"ID": 824,
		"x": 4.7577509383,
		"y": 32.131230751,
		"h": 2.9450549451
	},
	{
		"stop_id": 8590371,
		"ID": 824,
		"x": 4.2807291243,
		"y": 32.159219595,
		"h": 2.9450549451
	},
	{
		"stop_id": 8590372,
		"ID": 824,
		"x": 3.0357563313,
		"y": 32.193228873,
		"h": 2.9450549451
	},
	{
		"stop_id": 8590373,
		"ID": 824,
		"x": 5.3077395173,
		"y": 31.277229754,
		"h": 2.9450549451
	},
	{
		"stop_id": 8590374,
		"ID": 824,
		"x": 5.0627446533,
		"y": 31.098230095,
		"h": 2.9450549451
	},
	{
		"stop_id": 8590375,
		"ID": 824,
		"x": 2.9087479803,
		"y": 32.564233544,
		"h": 2.9450549451
	},
	{
		"stop_id": 8590376,
		"ID": 824,
		"x": 3.5097328363,
		"y": 31.721167254,
		"h": 2.9450549451
	},
	{
		"stop_id": 8590377,
		"ID": 824,
		"x": 3.2977341923,
		"y": 31.665221782,
		"h": 2.9450549451
	},
	{
		"stop_id": 8590378,
		"ID": 824,
		"x": 3.3117673693,
		"y": 31.875166279,
		"h": 2.9450549451
	},
	{
		"stop_id": 8590379,
		"ID": 824,
		"x": 3.0917384953,
		"y": 31.486160177,
		"h": 2.9450549451
	},
	{
		"stop_id": 8590380,
		"ID": 824,
		"x": 3.0667192473,
		"y": 31.669231688,
		"h": 2.9450549451
	},
	{
		"stop_id": 8590381,
		"ID": 824,
		"x": 2.9387651893,
		"y": 31.551146342,
		"h": 2.9450549451
	},
	{
		"stop_id": 8590383,
		"ID": 824,
		"x": 2.5937130443,
		"y": 31.296151471,
		"h": 2.9450549451
	},
	{
		"stop_id": 8590384,
		"ID": 824,
		"x": 2.3887451153,
		"y": 31.190170261,
		"h": 2.9450549451
	},
	{
		"stop_id": 8590385,
		"ID": 824,
		"x": 2.2757110293,
		"y": 31.417244631,
		"h": 2.9450549451
	},
	{
		"stop_id": 8590386,
		"ID": 824,
		"x": 3.8227495653,
		"y": 32.873207624,
		"h": 2.9450549451
	},
	{
		"stop_id": 8590387,
		"ID": 824,
		"x": 3.9037355223,
		"y": 32.13016676,
		"h": 2.9450549451
	},
	{
		"stop_id": 8590388,
		"ID": 824,
		"x": 3.9597088053,
		"y": 32.336225178,
		"h": 2.9450549451
	},
	{
		"stop_id": 8590389,
		"ID": 824,
		"x": 4.0377014483,
		"y": 32.613230319,
		"h": 2.9450549451
	},
	{
		"stop_id": 8590390,
		"ID": 824,
		"x": 4.2567272233,
		"y": 33.008155098,
		"h": 2.9450549451
	},
	{
		"stop_id": 8590391,
		"ID": 824,
		"x": 4.1727207753,
		"y": 33.187143069,
		"h": 2.9450549451
	},
	{
		"stop_id": 8590392,
		"ID": 824,
		"x": 4.0167093763,
		"y": 33.042160754,
		"h": 2.9450549451
	},
	{
		"stop_id": 8594372,
		"ID": 824,
		"x": 3.9477258633,
		"y": 31.972205311,
		"h": 2.9450549451
	},
	{
		"stop_id": 8594514,
		"ID": 824,
		"x": 1.4297068953,
		"y": 33.919159798,
		"h": 2.9450549451
	},
	{
		"stop_id": 8594642,
		"ID": 824,
		"x": 3.2207721943,
		"y": 32.192178478,
		"h": 2.9450549451
	},
	{
		"stop_id": 8595699,
		"ID": 824,
		"x": 5.5777172823,
		"y": 32.190191249,
		"h": 2.9450549451
	},
	{
		"stop_id": 8502017,
		"ID": 849,
		"x": 7.1317061823,
		"y": 35.238215158,
		"h": 1.3956043956
	},
	{
		"stop_id": 8502022,
		"ID": 849,
		"x": 7.3357061773,
		"y": 37.964235099,
		"h": 1.3956043956
	},
	{
		"stop_id": 8577163,
		"ID": 849,
		"x": 9.3627560643,
		"y": 34.340204067,
		"h": 1.3956043956
	},
	{
		"stop_id": 8577164,
		"ID": 849,
		"x": 9.4337735953,
		"y": 34.710150968,
		"h": 1.3956043956
	},
	{
		"stop_id": 8577168,
		"ID": 849,
		"x": 9.1977601253,
		"y": 36.834211553,
		"h": 1.3956043956
	},
	{
		"stop_id": 8577169,
		"ID": 849,
		"x": 9.4487754583,
		"y": 36.908167946,
		"h": 1.3956043956
	},
	{
		"stop_id": 8577170,
		"ID": 849,
		"x": 9.8527506813,
		"y": 35.20423032,
		"h": 1.3956043956
	},
	{
		"stop_id": 8577171,
		"ID": 849,
		"x": 10.3287657433,
		"y": 35.515227345,
		"h": 1.3956043956
	},
	{
		"stop_id": 8577172,
		"ID": 849,
		"x": 10.5577417353,
		"y": 35.730171821,
		"h": 1.3956043956
	},
	{
		"stop_id": 8582045,
		"ID": 849,
		"x": 7.2397610313,
		"y": 37.853196177,
		"h": 1.3956043956
	},
	{
		"stop_id": 8589224,
		"ID": 849,
		"x": 7.1637718413,
		"y": 35.296167086,
		"h": 1.3956043956
	},
	{
		"stop_id": 8589225,
		"ID": 849,
		"x": 8.9437233053,
		"y": 36.811152323,
		"h": 1.3956043956
	},
	{
		"stop_id": 8589658,
		"ID": 849,
		"x": 8.9457579863,
		"y": 35.147229291,
		"h": 1.3956043956
	},
	{
		"stop_id": 8502019,
		"ID": 801,
		"x": 1.1197626863,
		"y": 48.715242306,
		"h": 1.5934065934
	},
	{
		"stop_id": 8502029,
		"ID": 801,
		"x": -0.2712265137,
		"y": 50.324216843,
		"h": 1.5934065934
	},
	{
		"stop_id": 8502038,
		"ID": 801,
		"x": -2.8582277527,
		"y": 46.249181523,
		"h": 1.5934065934
	},
	{
		"stop_id": 8502169,
		"ID": 801,
		"x": -2.9052659887,
		"y": 49.924200393,
		"h": 1.5934065934
	},
	{
		"stop_id": 8530631,
		"ID": 801,
		"x": -0.2682338827,
		"y": 50.494246383,
		"h": 1.5934065934
	},
	{
		"stop_id": 8572975,
		"ID": 801,
		"x": -3.6002612977,
		"y": 46.609141917,
		"h": 1.5934065934
	},
	{
		"stop_id": 8572976,
		"ID": 801,
		"x": -3.2332791467,
		"y": 46.354230836,
		"h": 1.5934065934
	},
	{
		"stop_id": 8577254,
		"ID": 801,
		"x": -2.0202500917,
		"y": 45.873232796,
		"h": 1.5934065934
	},
	{
		"stop_id": 8577255,
		"ID": 801,
		"x": -2.6362636187,
		"y": 46.102213655,
		"h": 1.5934065934
	},
	{
		"stop_id": 8577267,
		"ID": 801,
		"x": -0.2502876427,
		"y": 45.69521575,
		"h": 1.5934065934
	},
	{
		"stop_id": 8577268,
		"ID": 801,
		"x": -1.3362874697,
		"y": 46.438155998,
		"h": 1.5934065934
	},
	{
		"stop_id": 8580823,
		"ID": 801,
		"x": -1.2302546717,
		"y": 48.997177061,
		"h": 1.5934065934
	},
	{
		"stop_id": 8580824,
		"ID": 801,
		"x": -2.9162977177,
		"y": 49.882178957,
		"h": 1.5934065934
	},
	{
		"stop_id": 8580832,
		"ID": 801,
		"x": -2.2692606997,
		"y": 47.248145705,
		"h": 1.5934065934
	},
	{
		"stop_id": 8581079,
		"ID": 801,
		"x": -2.9132888397,
		"y": 50.47814846,
		"h": 1.5934065934
	},
	{
		"stop_id": 8582548,
		"ID": 801,
		"x": -3.3822676387,
		"y": 49.642145905,
		"h": 1.5934065934
	},
	{
		"stop_id": 8582550,
		"ID": 801,
		"x": -3.6512705367,
		"y": 49.293156195,
		"h": 1.5934065934
	},
	{
		"stop_id": 8587007,
		"ID": 801,
		"x": -2.4942834797,
		"y": 49.572248156,
		"h": 1.5934065934
	},
	{
		"stop_id": 8591707,
		"ID": 801,
		"x": -2.5472636237,
		"y": 49.10521503,
		"h": 1.5934065934
	},
	{
		"stop_id": 8502023,
		"ID": 850,
		"x": 6.8617483593,
		"y": 40.335209335,
		"h": 1.7252747253
	},
	{
		"stop_id": 8502087,
		"ID": 850,
		"x": 6.8957067353,
		"y": 43.316176011,
		"h": 1.7252747253
	},
	{
		"stop_id": 8577104,
		"ID": 850,
		"x": 6.7317672713,
		"y": 43.171249372,
		"h": 1.7252747253
	},
	{
		"stop_id": 8577106,
		"ID": 850,
		"x": 10.8237347703,
		"y": 41.047185259,
		"h": 1.7252747253
	},
	{
		"stop_id": 8577107,
		"ID": 850,
		"x": 9.7487022983,
		"y": 42.676157094,
		"h": 1.7252747253
	},
	{
		"stop_id": 8577108,
		"ID": 850,
		"x": 10.9877263103,
		"y": 43.780249636,
		"h": 1.7252747253
	},
	{
		"stop_id": 8577113,
		"ID": 850,
		"x": 6.6087033033,
		"y": 43.765149775,
		"h": 1.7252747253
	},
	{
		"stop_id": 8577114,
		"ID": 850,
		"x": 6.6687430773,
		"y": 43.323199812,
		"h": 1.7252747253
	},
	{
		"stop_id": 8577115,
		"ID": 850,
		"x": 7.1887352513,
		"y": 42.443231922,
		"h": 1.7252747253
	},
	{
		"stop_id": 8577116,
		"ID": 850,
		"x": 7.6477605393,
		"y": 41.590192127,
		"h": 1.7252747253
	},
	{
		"stop_id": 8577122,
		"ID": 850,
		"x": 10.9127386313,
		"y": 41.905243723,
		"h": 1.7252747253
	},
	{
		"stop_id": 8577132,
		"ID": 850,
		"x": 10.0267120013,
		"y": 45.416203494,
		"h": 1.7252747253
	},
	{
		"stop_id": 8582044,
		"ID": 850,
		"x": 6.8737034013,
		"y": 40.263185776,
		"h": 1.7252747253
	},
	{
		"stop_id": 8587714,
		"ID": 850,
		"x": 10.9477429413,
		"y": 43.630231782,
		"h": 1.7252747253
	},
	{
		"stop_id": 8587715,
		"ID": 850,
		"x": 6.2477728663,
		"y": 42.170219248,
		"h": 1.7252747253
	},
	{
		"stop_id": 8587784,
		"ID": 850,
		"x": 9.9207609473,
		"y": 44.440210045,
		"h": 1.7252747253
	},
	{
		"stop_id": 8587785,
		"ID": 850,
		"x": 9.9287488843,
		"y": 44.101192483,
		"h": 1.7252747253
	},
	{
		"stop_id": 8587786,
		"ID": 850,
		"x": 9.9627379383,
		"y": 43.639176931,
		"h": 1.7252747253
	},
	{
		"stop_id": 8587788,
		"ID": 850,
		"x": 9.6977723463,
		"y": 42.720147045,
		"h": 1.7252747253
	},
	{
		"stop_id": 8589530,
		"ID": 850,
		"x": 10.8227224303,
		"y": 41.305229944,
		"h": 1.7252747253
	},
	{
		"stop_id": 8590237,
		"ID": 850,
		"x": 10.8977727683,
		"y": 41.620213734,
		"h": 1.7252747253
	},
	{
		"stop_id": 8593392,
		"ID": 850,
		"x": 5.8177211613,
		"y": 41.950216062,
		"h": 1.7252747253
	},
	{
		"stop_id": 8593466,
		"ID": 850,
		"x": 9.7827139523,
		"y": 42.92516093,
		"h": 1.7252747253
	},
	{
		"stop_id": 8502024,
		"ID": 825,
		"x": 4.7077043503,
		"y": 41.780211461,
		"h": 1.6593406593
	},
	{
		"stop_id": 8502042,
		"ID": 825,
		"x": 5.4327460423,
		"y": 41.530164938,
		"h": 1.6593406593
	},
	{
		"stop_id": 8577091,
		"ID": 825,
		"x": 4.7247329883,
		"y": 41.748153051,
		"h": 1.6593406593
	},
	{
		"stop_id": 8577092,
		"ID": 825,
		"x": 4.1577089573,
		"y": 41.445181239,
		"h": 1.6593406593
	},
	{
		"stop_id": 8577094,
		"ID": 825,
		"x": 3.7697482683,
		"y": 41.170189038,
		"h": 1.6593406593
	},
	{
		"stop_id": 8577095,
		"ID": 825,
		"x": 3.5377390413,
		"y": 40.760236263,
		"h": 1.6593406593
	},
	{
		"stop_id": 8577096,
		"ID": 825,
		"x": 3.2327414013,
		"y": 40.830159053,
		"h": 1.6593406593
	},
	{
		"stop_id": 8577097,
		"ID": 825,
		"x": 2.8517532563,
		"y": 40.937210742,
		"h": 1.6593406593
	},
	{
		"stop_id": 8577098,
		"ID": 825,
		"x": 2.6427340383,
		"y": 40.63515942,
		"h": 1.6593406593
	},
	{
		"stop_id": 8577099,
		"ID": 825,
		"x": 2.3377176373,
		"y": 40.380144322,
		"h": 1.6593406593
	},
	{
		"stop_id": 8577101,
		"ID": 825,
		"x": 1.8777546993,
		"y": 41.133177993,
		"h": 1.6593406593
	},
	{
		"stop_id": 8577257,
		"ID": 825,
		"x": 1.9597483873,
		"y": 37.303170833,
		"h": 1.6593406593
	},
	{
		"stop_id": 8577258,
		"ID": 825,
		"x": 2.3957475183,
		"y": 37.675156368,
		"h": 1.6593406593
	},
	{
		"stop_id": 8577261,
		"ID": 825,
		"x": 1.9377196253,
		"y": 40.520188437,
		"h": 1.6593406593
	},
	{
		"stop_id": 8582591,
		"ID": 825,
		"x": 5.4357186683,
		"y": 41.577227634,
		"h": 1.6593406593
	},
	{
		"stop_id": 8587716,
		"ID": 825,
		"x": 5.1267241653,
		"y": 42.050156687,
		"h": 1.6593406593
	},
	{
		"stop_id": 8588077,
		"ID": 825,
		"x": 5.4997130123,
		"y": 41.854217167,
		"h": 1.6593406593
	},
	{
		"stop_id": 8589232,
		"ID": 825,
		"x": 4.7367455633,
		"y": 41.626205082,
		"h": 1.6593406593
	},
	{
		"stop_id": 8593391,
		"ID": 825,
		"x": 4.8167699303,
		"y": 41.945165217,
		"h": 1.6593406593
	},
	{
		"stop_id": 8593393,
		"ID": 825,
		"x": 3.9187697073,
		"y": 41.339221241,
		"h": 1.6593406593
	},
	{
		"stop_id": 8593395,
		"ID": 825,
		"x": 1.5877157393,
		"y": 41.742236856,
		"h": 1.6593406593
	},
	{
		"stop_id": 8502025,
		"ID": 826,
		"x": 4.0427160833,
		"y": 43.853158023,
		"h": 1.4615384615
	},
	{
		"stop_id": 8502026,
		"ID": 826,
		"x": 2.8427242703,
		"y": 46.939188537,
		"h": 1.4615384615
	},
	{
		"stop_id": 8502027,
		"ID": 826,
		"x": 1.8607368343,
		"y": 47.942145528,
		"h": 1.4615384615
	},
	{
		"stop_id": 8516353,
		"ID": 826,
		"x": 4.0767353513,
		"y": 43.289160077,
		"h": 1.4615384615
	},
	{
		"stop_id": 8577069,
		"ID": 826,
		"x": 1.8887108813,
		"y": 47.925202057,
		"h": 1.4615384615
	},
	{
		"stop_id": 8577070,
		"ID": 826,
		"x": 2.6777699453,
		"y": 48.190157088,
		"h": 1.4615384615
	},
	{
		"stop_id": 8577073,
		"ID": 826,
		"x": 2.4277203093,
		"y": 48.120159641,
		"h": 1.4615384615
	},
	{
		"stop_id": 8577074,
		"ID": 826,
		"x": 2.7077709853,
		"y": 48.283199223,
		"h": 1.4615384615
	},
	{
		"stop_id": 8577084,
		"ID": 826,
		"x": 5.2227479773,
		"y": 44.990210468,
		"h": 1.4615384615
	},
	{
		"stop_id": 8577090,
		"ID": 826,
		"x": 5.5507031333,
		"y": 45.297220878,
		"h": 1.4615384615
	},
	{
		"stop_id": 8577109,
		"ID": 826,
		"x": 4.6377203033,
		"y": 44.505206346,
		"h": 1.4615384615
	},
	{
		"stop_id": 8577110,
		"ID": 826,
		"x": 5.0607218413,
		"y": 44.84423839,
		"h": 1.4615384615
	},
	{
		"stop_id": 8577351,
		"ID": 826,
		"x": 2.5997725813,
		"y": 48.340214616,
		"h": 1.4615384615
	},
	{
		"stop_id": 8587100,
		"ID": 826,
		"x": 4.0667341703,
		"y": 43.868202891,
		"h": 1.4615384615
	},
	{
		"stop_id": 8588979,
		"ID": 826,
		"x": 3.8687513753,
		"y": 43.237234141,
		"h": 1.4615384615
	},
	{
		"stop_id": 8502030,
		"ID": 777,
		"x": -5.3232944047,
		"y": 61.600249275,
		"h": 1.4285714286
	},
	{
		"stop_id": 8502174,
		"ID": 777,
		"x": -8.7402389607,
		"y": 61.279140259,
		"h": 1.4285714286
	},
	{
		"stop_id": 8502184,
		"ID": 777,
		"x": -9.2862721607,
		"y": 62.721213907,
		"h": 1.4285714286
	},
	{
		"stop_id": 8502675,
		"ID": 777,
		"x": -5.2212344937,
		"y": 62.508241162,
		"h": 1.4285714286
	},
	{
		"stop_id": 8502676,
		"ID": 777,
		"x": -4.6202444597,
		"y": 61.73516014,
		"h": 1.4285714286
	},
	{
		"stop_id": 8502677,
		"ID": 777,
		"x": -4.0012901787,
		"y": 61.930182716,
		"h": 1.4285714286
	},
	{
		"stop_id": 8502872,
		"ID": 777,
		"x": -6.5672735387,
		"y": 64.975139902,
		"h": 1.4285714286
	},
	{
		"stop_id": 8578701,
		"ID": 777,
		"x": -6.1132661837,
		"y": 65.248189762,
		"h": 1.4285714286
	},
	{
		"stop_id": 8578702,
		"ID": 777,
		"x": -6.5272480787,
		"y": 64.706205199,
		"h": 1.4285714286
	},
	{
		"stop_id": 8578703,
		"ID": 777,
		"x": -5.3112744017,
		"y": 61.64917011,
		"h": 1.4285714286
	},
	{
		"stop_id": 8578704,
		"ID": 777,
		"x": -5.1092954797,
		"y": 61.823142521,
		"h": 1.4285714286
	},
	{
		"stop_id": 8590262,
		"ID": 777,
		"x": -6.7882888757,
		"y": 65.646174582,
		"h": 1.4285714286
	},
	{
		"stop_id": 8590264,
		"ID": 777,
		"x": -4.7232569567,
		"y": 63.618142695,
		"h": 1.4285714286
	},
	{
		"stop_id": 8590265,
		"ID": 777,
		"x": -4.7382287997,
		"y": 63.42420583,
		"h": 1.4285714286
	},
	{
		"stop_id": 8502031,
		"ID": 803,
		"x": -4.0092695267,
		"y": 59.666143291,
		"h": 1.4945054945
	},
	{
		"stop_id": 8502032,
		"ID": 803,
		"x": -3.3442466187,
		"y": 58.160195017,
		"h": 1.4945054945
	},
	{
		"stop_id": 8502678,
		"ID": 803,
		"x": -3.3602466657,
		"y": 61.999172789,
		"h": 1.4945054945
	},
	{
		"stop_id": 8502679,
		"ID": 803,
		"x": -1.7022890167,
		"y": 59.365154056,
		"h": 1.4945054945
	},
	{
		"stop_id": 8530627,
		"ID": 803,
		"x": -1.8332264207,
		"y": 58.598250664,
		"h": 1.4945054945
	},
	{
		"stop_id": 8578705,
		"ID": 803,
		"x": -3.1112546737,
		"y": 61.547237969,
		"h": 1.4945054945
	},
	{
		"stop_id": 8578706,
		"ID": 803,
		"x": -2.0192404157,
		"y": 59.789238104,
		"h": 1.4945054945
	},
	{
		"stop_id": 8578707,
		"ID": 803,
		"x": -1.6582775807,
		"y": 59.016239202,
		"h": 1.4945054945
	},
	{
		"stop_id": 8578708,
		"ID": 803,
		"x": -2.4932315607,
		"y": 59.149220066,
		"h": 1.4945054945
	},
	{
		"stop_id": 8578710,
		"ID": 803,
		"x": -3.0092368407,
		"y": 58.646154043,
		"h": 1.4945054945
	},
	{
		"stop_id": 8578711,
		"ID": 803,
		"x": -3.1622383687,
		"y": 58.421211086,
		"h": 1.4945054945
	},
	{
		"stop_id": 8578712,
		"ID": 803,
		"x": -3.3832543787,
		"y": 58.390200091,
		"h": 1.4945054945
	},
	{
		"stop_id": 8578764,
		"ID": 803,
		"x": -1.5162531087,
		"y": 58.742224176,
		"h": 1.4945054945
	},
	{
		"stop_id": 8578765,
		"ID": 803,
		"x": -0.4962818477,
		"y": 57.170148625,
		"h": 1.4945054945
	},
	{
		"stop_id": 8587560,
		"ID": 803,
		"x": 1.3177716903,
		"y": 60.235142766,
		"h": 1.4945054945
	},
	{
		"stop_id": 8589511,
		"ID": 803,
		"x": 1.2507729993,
		"y": 59.767247977,
		"h": 1.4945054945
	},
	{
		"stop_id": 8502033,
		"ID": 802,
		"x": -2.2222300377,
		"y": 55.148179297,
		"h": 1.4615384615
	},
	{
		"stop_id": 8502034,
		"ID": 802,
		"x": -1.9562690057,
		"y": 52.85714295,
		"h": 1.4615384615
	},
	{
		"stop_id": 8502265,
		"ID": 802,
		"x": 0.0917233123,
		"y": 55.976246175,
		"h": 1.4615384615
	},
	{
		"stop_id": 8530625,
		"ID": 802,
		"x": -0.6162857597,
		"y": 56.090233666,
		"h": 1.4615384615
	},
	{
		"stop_id": 8530626,
		"ID": 802,
		"x": -0.2532260567,
		"y": 54.755194309,
		"h": 1.4615384615
	},
	{
		"stop_id": 8530628,
		"ID": 802,
		"x": -1.9322668437,
		"y": 55.491219795,
		"h": 1.4615384615
	},
	{
		"stop_id": 8530629,
		"ID": 802,
		"x": -1.2592709707,
		"y": 53.098228611,
		"h": 1.4615384615
	},
	{
		"stop_id": 8530630,
		"ID": 802,
		"x": 0.1497662323,
		"y": 51.899249141,
		"h": 1.4615384615
	},
	{
		"stop_id": 8530632,
		"ID": 802,
		"x": -2.2552677877,
		"y": 57.005199912,
		"h": 1.4615384615
	},
	{
		"stop_id": 8578766,
		"ID": 802,
		"x": -0.3602491667,
		"y": 56.257231717,
		"h": 1.4615384615
	},
	{
		"stop_id": 8578767,
		"ID": 802,
		"x": -0.1182369987,
		"y": 56.132239136,
		"h": 1.4615384615
	},
	{
		"stop_id": 8578768,
		"ID": 802,
		"x": 0.6807516493,
		"y": 55.998222265,
		"h": 1.4615384615
	},
	{
		"stop_id": 8580822,
		"ID": 802,
		"x": -1.9612387457,
		"y": 52.901234606,
		"h": 1.4615384615
	},
	{
		"stop_id": 8582549,
		"ID": 802,
		"x": -2.4892768357,
		"y": 52.39223749,
		"h": 1.4615384615
	},
	{
		"stop_id": 8589986,
		"ID": 802,
		"x": -0.4002674297,
		"y": 56.87824558,
		"h": 1.4615384615
	},
	{
		"stop_id": 8502086,
		"ID": 745,
		"x": -10.0582743477,
		"y": 46.847206074,
		"h": 1.3626373626
	},
	{
		"stop_id": 8502090,
		"ID": 745,
		"x": -10.4842756667,
		"y": 47.600249152,
		"h": 1.3626373626
	},
	{
		"stop_id": 8502095,
		"ID": 745,
		"x": -13.3712596477,
		"y": 49.552167035,
		"h": 1.3626373626
	},
	{
		"stop_id": 8572668,
		"ID": 745,
		"x": -11.5672748467,
		"y": 49.355154851,
		"h": 1.3626373626
	},
	{
		"stop_id": 8572669,
		"ID": 745,
		"x": -11.3812453717,
		"y": 49.032238008,
		"h": 1.3626373626
	},
	{
		"stop_id": 8572670,
		"ID": 745,
		"x": -11.0482277707,
		"y": 48.620249818,
		"h": 1.3626373626
	},
	{
		"stop_id": 8572673,
		"ID": 745,
		"x": -9.5902331877,
		"y": 46.027172702,
		"h": 1.3626373626
	},
	{
		"stop_id": 8573000,
		"ID": 745,
		"x": -8.6042484117,
		"y": 48.164242822,
		"h": 1.3626373626
	},
	{
		"stop_id": 8573001,
		"ID": 745,
		"x": -8.7642846117,
		"y": 47.996207678,
		"h": 1.3626373626
	},
	{
		"stop_id": 8573002,
		"ID": 745,
		"x": -8.6972827997,
		"y": 48.864220826,
		"h": 1.3626373626
	},
	{
		"stop_id": 8582759,
		"ID": 745,
		"x": -11.9592734737,
		"y": 50.426226425,
		"h": 1.3626373626
	},
	{
		"stop_id": 8582760,
		"ID": 745,
		"x": -11.5122939537,
		"y": 49.345149554,
		"h": 1.3626373626
	},
	{
		"stop_id": 8502088,
		"ID": 746,
		"x": -14.0972741117,
		"y": 54.805222399,
		"h": 1.4945054945
	},
	{
		"stop_id": 8502097,
		"ID": 746,
		"x": -12.3712741127,
		"y": 52.979221975,
		"h": 1.4945054945
	},
	{
		"stop_id": 8502589,
		"ID": 746,
		"x": -12.8022782057,
		"y": 56.840177348,
		"h": 1.4945054945
	},
	{
		"stop_id": 8502590,
		"ID": 746,
		"x": -12.1642949997,
		"y": 56.436211596,
		"h": 1.4945054945
	},
	{
		"stop_id": 8502591,
		"ID": 746,
		"x": -11.5272314747,
		"y": 56.035197504,
		"h": 1.4945054945
	},
	{
		"stop_id": 8502592,
		"ID": 746,
		"x": -10.7072399237,
		"y": 55.477211883,
		"h": 1.4945054945
	},
	{
		"stop_id": 8502593,
		"ID": 746,
		"x": -9.8722753497,
		"y": 54.740237727,
		"h": 1.4945054945
	},
	{
		"stop_id": 8502594,
		"ID": 746,
		"x": -8.9082412387,
		"y": 53.92320906,
		"h": 1.4945054945
	},
	{
		"stop_id": 8502595,
		"ID": 746,
		"x": -9.2922623027,
		"y": 53.114193523,
		"h": 1.4945054945
	},
	{
		"stop_id": 8502748,
		"ID": 746,
		"x": -12.5012993287,
		"y": 53.78014461,
		"h": 1.4945054945
	},
	{
		"stop_id": 8502886,
		"ID": 746,
		"x": -12.3652817097,
		"y": 53.319153853,
		"h": 1.4945054945
	},
	{
		"stop_id": 8572649,
		"ID": 746,
		"x": -11.0012579057,
		"y": 55.733181298,
		"h": 1.4945054945
	},
	{
		"stop_id": 8572650,
		"ID": 746,
		"x": -10.1562735517,
		"y": 55.092200524,
		"h": 1.4945054945
	},
	{
		"stop_id": 8572660,
		"ID": 746,
		"x": -13.8662840387,
		"y": 54.489242347,
		"h": 1.4945054945
	},
	{
		"stop_id": 8572661,
		"ID": 746,
		"x": -12.7442341607,
		"y": 54.235177667,
		"h": 1.4945054945
	},
	{
		"stop_id": 8581347,
		"ID": 746,
		"x": -12.6882290607,
		"y": 52.838170693,
		"h": 1.4945054945
	},
	{
		"stop_id": 8502089,
		"ID": 717,
		"x": -14.3002742687,
		"y": 55.50022453,
		"h": 1.8571428571
	},
	{
		"stop_id": 8502100,
		"ID": 717,
		"x": -18.5492979207,
		"y": 58.7821452,
		"h": 1.8571428571
	},
	{
		"stop_id": 8502122,
		"ID": 717,
		"x": -15.8632669127,
		"y": 59.126155347,
		"h": 1.8571428571
	},
	{
		"stop_id": 8502199,
		"ID": 717,
		"x": -13.5082681007,
		"y": 57.054225428,
		"h": 1.8571428571
	},
	{
		"stop_id": 8502367,
		"ID": 717,
		"x": -18.4672633257,
		"y": 56.714161108,
		"h": 1.8571428571
	},
	{
		"stop_id": 8502368,
		"ID": 717,
		"x": -17.2202894827,
		"y": 56.998245677,
		"h": 1.8571428571
	},
	{
		"stop_id": 8502371,
		"ID": 717,
		"x": -19.2242785507,
		"y": 56.566190832,
		"h": 1.8571428571
	},
	{
		"stop_id": 8502582,
		"ID": 717,
		"x": -18.8442978257,
		"y": 56.542222384,
		"h": 1.8571428571
	},
	{
		"stop_id": 8502583,
		"ID": 717,
		"x": -17.6702911247,
		"y": 56.757221411,
		"h": 1.8571428571
	},
	{
		"stop_id": 8502584,
		"ID": 717,
		"x": -16.5982899177,
		"y": 56.886212199,
		"h": 1.8571428571
	},
	{
		"stop_id": 8502587,
		"ID": 717,
		"x": -15.9952673347,
		"y": 56.068205486,
		"h": 1.8571428571
	},
	{
		"stop_id": 8502765,
		"ID": 717,
		"x": -14.6882800497,
		"y": 58.892242799,
		"h": 1.8571428571
	},
	{
		"stop_id": 8502766,
		"ID": 717,
		"x": -16.8222789157,
		"y": 54.748220397,
		"h": 1.8571428571
	},
	{
		"stop_id": 8502767,
		"ID": 717,
		"x": -14.2782293207,
		"y": 58.706245738,
		"h": 1.8571428571
	},
	{
		"stop_id": 8502768,
		"ID": 717,
		"x": -15.5262280587,
		"y": 56.747224652,
		"h": 1.8571428571
	},
	{
		"stop_id": 8502769,
		"ID": 717,
		"x": -15.4582591727,
		"y": 57.115190401,
		"h": 1.8571428571
	},
	{
		"stop_id": 8502770,
		"ID": 717,
		"x": -15.4192247767,
		"y": 57.397219203,
		"h": 1.8571428571
	},
	{
		"stop_id": 8572648,
		"ID": 717,
		"x": -13.5032624737,
		"y": 57.023244302,
		"h": 1.8571428571
	},
	{
		"stop_id": 8572651,
		"ID": 717,
		"x": -13.3972626707,
		"y": 57.356174905,
		"h": 1.8571428571
	},
	{
		"stop_id": 8572652,
		"ID": 717,
		"x": -15.3702775907,
		"y": 57.12118392,
		"h": 1.8571428571
	},
	{
		"stop_id": 8572653,
		"ID": 717,
		"x": -16.6202269937,
		"y": 55.053210678,
		"h": 1.8571428571
	},
	{
		"stop_id": 8572656,
		"ID": 717,
		"x": -13.8292949947,
		"y": 56.731193848,
		"h": 1.8571428571
	},
	{
		"stop_id": 8572657,
		"ID": 717,
		"x": -14.1022972837,
		"y": 56.699181239,
		"h": 1.8571428571
	},
	{
		"stop_id": 8581948,
		"ID": 717,
		"x": -13.6392773347,
		"y": 57.710188587,
		"h": 1.8571428571
	},
	{
		"stop_id": 8589888,
		"ID": 717,
		"x": -13.4672677997,
		"y": 57.693181427,
		"h": 1.8571428571
	},
	{
		"stop_id": 8594282,
		"ID": 717,
		"x": -16.9352338397,
		"y": 54.423198785,
		"h": 1.8571428571
	},
	{
		"stop_id": 8595230,
		"ID": 717,
		"x": -14.0222342017,
		"y": 58.598251198,
		"h": 1.8571428571
	},
	{
		"stop_id": 8502092,
		"ID": 774,
		"x": -8.9622800327,
		"y": 45.095246362,
		"h": 1.5274725275
	},
	{
		"stop_id": 8502551,
		"ID": 774,
		"x": -7.0912605587,
		"y": 42.795173043,
		"h": 1.5274725275
	},
	{
		"stop_id": 8502552,
		"ID": 774,
		"x": -6.2172560247,
		"y": 43.780247325,
		"h": 1.5274725275
	},
	{
		"stop_id": 8572674,
		"ID": 774,
		"x": -9.0982826177,
		"y": 45.333236664,
		"h": 1.5274725275
	},
	{
		"stop_id": 8572675,
		"ID": 774,
		"x": -8.7832297007,
		"y": 44.796144891,
		"h": 1.5274725275
	},
	{
		"stop_id": 8572676,
		"ID": 774,
		"x": -8.5552902187,
		"y": 44.181160688,
		"h": 1.5274725275
	},
	{
		"stop_id": 8572965,
		"ID": 774,
		"x": -7.3042356867,
		"y": 42.979186253,
		"h": 1.5274725275
	},
	{
		"stop_id": 8572966,
		"ID": 774,
		"x": -7.0102500527,
		"y": 43.380143581,
		"h": 1.5274725275
	},
	{
		"stop_id": 8572967,
		"ID": 774,
		"x": -6.6862945737,
		"y": 43.43316555,
		"h": 1.5274725275
	},
	{
		"stop_id": 8572969,
		"ID": 774,
		"x": -5.2822399547,
		"y": 44.501179652,
		"h": 1.5274725275
	},
	{
		"stop_id": 8572970,
		"ID": 774,
		"x": -5.5782639787,
		"y": 45.017248312,
		"h": 1.5274725275
	},
	{
		"stop_id": 8572971,
		"ID": 774,
		"x": -5.3532778347,
		"y": 45.747205046,
		"h": 1.5274725275
	},
	{
		"stop_id": 8572974,
		"ID": 774,
		"x": -4.7842980017,
		"y": 46.918174508,
		"h": 1.5274725275
	},
	{
		"stop_id": 8579848,
		"ID": 774,
		"x": -5.5782986107,
		"y": 47.550184856,
		"h": 1.5274725275
	},
	{
		"stop_id": 8581086,
		"ID": 774,
		"x": -7.5532527887,
		"y": 42.840245505,
		"h": 1.5274725275
	},
	{
		"stop_id": 8582547,
		"ID": 774,
		"x": -5.1282286487,
		"y": 48.130224111,
		"h": 1.5274725275
	},
	{
		"stop_id": 8594184,
		"ID": 774,
		"x": -6.0572589617,
		"y": 48.054164658,
		"h": 1.5274725275
	},
	{
		"stop_id": 8502096,
		"ID": 716,
		"x": -13.8702627027,
		"y": 52.054213468,
		"h": 1.1978021978
	},
	{
		"stop_id": 8502352,
		"ID": 716,
		"x": -19.5302565557,
		"y": 51.061185954,
		"h": 1.1978021978
	},
	{
		"stop_id": 8502887,
		"ID": 716,
		"x": -13.7902884857,
		"y": 50.971144346,
		"h": 1.1978021978
	},
	{
		"stop_id": 8572666,
		"ID": 716,
		"x": -13.5552313527,
		"y": 50.55214441,
		"h": 1.1978021978
	},
	{
		"stop_id": 8581055,
		"ID": 716,
		"x": -13.8972747557,
		"y": 51.729243374,
		"h": 1.1978021978
	},
	{
		"stop_id": 8594203,
		"ID": 716,
		"x": -17.1342616167,
		"y": 54.113238484,
		"h": 1.1978021978
	},
	{
		"stop_id": 8595883,
		"ID": 716,
		"x": -19.5882944507,
		"y": 51.360203407,
		"h": 1.1978021978
	},
	{
		"stop_id": 8502101,
		"ID": 718,
		"x": -15.3162617427,
		"y": 60.533250842,
		"h": 2.2527472527
	},
	{
		"stop_id": 8502102,
		"ID": 718,
		"x": -13.6752911017,
		"y": 62.679168806,
		"h": 2.2527472527
	},
	{
		"stop_id": 8502111,
		"ID": 718,
		"x": -18.9352495017,
		"y": 62.630208803,
		"h": 2.2527472527
	},
	{
		"stop_id": 8502112,
		"ID": 718,
		"x": -17.3302939367,
		"y": 64.31323397,
		"h": 2.2527472527
	},
	{
		"stop_id": 8502181,
		"ID": 718,
		"x": -13.8842782237,
		"y": 63.188221581,
		"h": 2.2527472527
	},
	{
		"stop_id": 8502182,
		"ID": 718,
		"x": -14.1632873527,
		"y": 63.593230454,
		"h": 2.2527472527
	},
	{
		"stop_id": 8502194,
		"ID": 718,
		"x": -13.8082889847,
		"y": 62.643225539,
		"h": 2.2527472527
	},
	{
		"stop_id": 8502196,
		"ID": 718,
		"x": -13.9832591157,
		"y": 64.032240979,
		"h": 2.2527472527
	},
	{
		"stop_id": 8578011,
		"ID": 718,
		"x": -17.6862933917,
		"y": 64.518169998,
		"h": 2.2527472527
	},
	{
		"stop_id": 8578012,
		"ID": 718,
		"x": -17.9432811267,
		"y": 64.384154843,
		"h": 2.2527472527
	},
	{
		"stop_id": 8578013,
		"ID": 718,
		"x": -18.5012596027,
		"y": 64.280183111,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582642,
		"ID": 718,
		"x": -18.9342328057,
		"y": 62.614205292,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582643,
		"ID": 718,
		"x": -18.6172256237,
		"y": 62.409146822,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582644,
		"ID": 718,
		"x": -18.4632595617,
		"y": 62.281242415,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582645,
		"ID": 718,
		"x": -18.1552969497,
		"y": 61.711240046,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582646,
		"ID": 718,
		"x": -18.3262945037,
		"y": 61.786205172,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582647,
		"ID": 718,
		"x": -18.3282918247,
		"y": 61.45519698,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582648,
		"ID": 718,
		"x": -18.2162482067,
		"y": 61.642212795,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582649,
		"ID": 718,
		"x": -18.1982403587,
		"y": 61.887165746,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582650,
		"ID": 718,
		"x": -18.1752575547,
		"y": 62.155168857,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582651,
		"ID": 718,
		"x": -18.8812628117,
		"y": 62.591221165,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582652,
		"ID": 718,
		"x": -19.2682489757,
		"y": 62.569222955,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582654,
		"ID": 718,
		"x": -19.3262256507,
		"y": 62.817212891,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582655,
		"ID": 718,
		"x": -19.0762636997,
		"y": 62.77822735,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582681,
		"ID": 718,
		"x": -18.1962978797,
		"y": 62.311235068,
		"h": 2.2527472527
	},
	{
		"stop_id": 8583100,
		"ID": 718,
		"x": -18.3632478387,
		"y": 62.144182,
		"h": 2.2527472527
	},
	{
		"stop_id": 8588650,
		"ID": 718,
		"x": -17.3082556977,
		"y": 64.326177834,
		"h": 2.2527472527
	},
	{
		"stop_id": 8588651,
		"ID": 718,
		"x": -17.1922250987,
		"y": 64.503236963,
		"h": 2.2527472527
	},
	{
		"stop_id": 8589178,
		"ID": 718,
		"x": -17.3252386757,
		"y": 62.264140568,
		"h": 2.2527472527
	},
	{
		"stop_id": 8589179,
		"ID": 718,
		"x": -17.5142335997,
		"y": 62.639151018,
		"h": 2.2527472527
	},
	{
		"stop_id": 8589180,
		"ID": 718,
		"x": -17.6942317347,
		"y": 63.027240028,
		"h": 2.2527472527
	},
	{
		"stop_id": 8589181,
		"ID": 718,
		"x": -17.4002406947,
		"y": 63.086146072,
		"h": 2.2527472527
	},
	{
		"stop_id": 8589182,
		"ID": 718,
		"x": -17.2862314257,
		"y": 63.391161474,
		"h": 2.2527472527
	},
	{
		"stop_id": 8589183,
		"ID": 718,
		"x": -17.1412817177,
		"y": 63.930222812,
		"h": 2.2527472527
	},
	{
		"stop_id": 8589184,
		"ID": 718,
		"x": -17.1602511527,
		"y": 64.205157596,
		"h": 2.2527472527
	},
	{
		"stop_id": 8589185,
		"ID": 718,
		"x": -17.1312687977,
		"y": 64.881147316,
		"h": 2.2527472527
	},
	{
		"stop_id": 8589186,
		"ID": 718,
		"x": -16.9112310847,
		"y": 65.054179539,
		"h": 2.2527472527
	},
	{
		"stop_id": 8589187,
		"ID": 718,
		"x": -16.4682263957,
		"y": 64.838249593,
		"h": 2.2527472527
	},
	{
		"stop_id": 8589191,
		"ID": 718,
		"x": -16.5432266217,
		"y": 65.27421554,
		"h": 2.2527472527
	},
	{
		"stop_id": 8502103,
		"ID": 748,
		"x": -11.1282254677,
		"y": 64.384176219,
		"h": 3.2417582418
	},
	{
		"stop_id": 8502113,
		"ID": 748,
		"x": -13.4882631337,
		"y": 66.558214687,
		"h": 3.2417582418
	},
	{
		"stop_id": 8502123,
		"ID": 748,
		"x": -12.1032920277,
		"y": 66.38917165,
		"h": 3.2417582418
	},
	{
		"stop_id": 8502160,
		"ID": 748,
		"x": -9.8722572897,
		"y": 63.286195002,
		"h": 3.2417582418
	},
	{
		"stop_id": 8502189,
		"ID": 748,
		"x": -10.3832600167,
		"y": 63.541205075,
		"h": 3.2417582418
	},
	{
		"stop_id": 8502191,
		"ID": 748,
		"x": -13.5322426617,
		"y": 65.652151856,
		"h": 3.2417582418
	},
	{
		"stop_id": 8502192,
		"ID": 748,
		"x": -13.6262774487,
		"y": 64.790176447,
		"h": 3.2417582418
	},
	{
		"stop_id": 8502996,
		"ID": 748,
		"x": -13.5072738417,
		"y": 66.614215327,
		"h": 3.2417582418
	},
	{
		"stop_id": 8578642,
		"ID": 748,
		"x": -13.8662537877,
		"y": 66.492235312,
		"h": 3.2417582418
	},
	{
		"stop_id": 8578643,
		"ID": 748,
		"x": -13.9212325857,
		"y": 66.640243362,
		"h": 3.2417582418
	},
	{
		"stop_id": 8578660,
		"ID": 748,
		"x": -12.9592793217,
		"y": 68.289200374,
		"h": 3.2417582418
	},
	{
		"stop_id": 8578661,
		"ID": 748,
		"x": -12.4642359207,
		"y": 68.531179491,
		"h": 3.2417582418
	},
	{
		"stop_id": 8588572,
		"ID": 748,
		"x": -8.4722737597,
		"y": 66.104248542,
		"h": 3.2417582418
	},
	{
		"stop_id": 8588574,
		"ID": 748,
		"x": -8.4322367627,
		"y": 65.823181711,
		"h": 3.2417582418
	},
	{
		"stop_id": 8589189,
		"ID": 748,
		"x": -14.5752643427,
		"y": 65.920189071,
		"h": 3.2417582418
	},
	{
		"stop_id": 8589190,
		"ID": 748,
		"x": -14.1692868907,
		"y": 66.29020846,
		"h": 3.2417582418
	},
	{
		"stop_id": 8590133,
		"ID": 748,
		"x": -12.5912305287,
		"y": 66.448202206,
		"h": 3.2417582418
	},
	{
		"stop_id": 8590134,
		"ID": 748,
		"x": -13.2072983207,
		"y": 67.191172309,
		"h": 3.2417582418
	},
	{
		"stop_id": 8590135,
		"ID": 748,
		"x": -13.8192622597,
		"y": 65.221190354,
		"h": 3.2417582418
	},
	{
		"stop_id": 8590136,
		"ID": 748,
		"x": -13.5262585747,
		"y": 66.134188842,
		"h": 3.2417582418
	},
	{
		"stop_id": 8590138,
		"ID": 748,
		"x": -12.6622718327,
		"y": 67.388161874,
		"h": 3.2417582418
	},
	{
		"stop_id": 8590139,
		"ID": 748,
		"x": -13.7422482927,
		"y": 65.418140981,
		"h": 3.2417582418
	},
	{
		"stop_id": 8590140,
		"ID": 748,
		"x": -13.3882673217,
		"y": 65.859191658,
		"h": 3.2417582418
	},
	{
		"stop_id": 8590141,
		"ID": 748,
		"x": -13.8222707537,
		"y": 66.253192605,
		"h": 3.2417582418
	},
	{
		"stop_id": 8590142,
		"ID": 748,
		"x": -13.1242863127,
		"y": 66.552170688,
		"h": 3.2417582418
	},
	{
		"stop_id": 8590143,
		"ID": 748,
		"x": -13.1622671937,
		"y": 65.12024362,
		"h": 3.2417582418
	},
	{
		"stop_id": 8590144,
		"ID": 748,
		"x": -13.5842635107,
		"y": 65.350211195,
		"h": 3.2417582418
	},
	{
		"stop_id": 8590145,
		"ID": 748,
		"x": -13.2812304097,
		"y": 65.681242693,
		"h": 3.2417582418
	},
	{
		"stop_id": 8590146,
		"ID": 748,
		"x": -13.1572614507,
		"y": 66.11717435,
		"h": 3.2417582418
	},
	{
		"stop_id": 8590147,
		"ID": 748,
		"x": -14.2362979747,
		"y": 66.521182669,
		"h": 3.2417582418
	},
	{
		"stop_id": 8590148,
		"ID": 748,
		"x": -14.4312899797,
		"y": 66.131206112,
		"h": 3.2417582418
	},
	{
		"stop_id": 8590149,
		"ID": 748,
		"x": -13.4022980377,
		"y": 65.22921506,
		"h": 3.2417582418
	},
	{
		"stop_id": 8590150,
		"ID": 748,
		"x": -13.0182687407,
		"y": 65.468164577,
		"h": 3.2417582418
	},
	{
		"stop_id": 8590151,
		"ID": 748,
		"x": -12.4282817637,
		"y": 67.497208678,
		"h": 3.2417582418
	},
	{
		"stop_id": 8590152,
		"ID": 748,
		"x": -13.7572516967,
		"y": 66.330192413,
		"h": 3.2417582418
	},
	{
		"stop_id": 8590153,
		"ID": 748,
		"x": -14.1602702287,
		"y": 66.060234407,
		"h": 3.2417582418
	},
	{
		"stop_id": 8590154,
		"ID": 748,
		"x": -12.7692651547,
		"y": 66.123237644,
		"h": 3.2417582418
	},
	{
		"stop_id": 8590155,
		"ID": 748,
		"x": -13.9652536057,
		"y": 65.770207881,
		"h": 3.2417582418
	},
	{
		"stop_id": 8590156,
		"ID": 748,
		"x": -12.9042496007,
		"y": 67.276170458,
		"h": 3.2417582418
	},
	{
		"stop_id": 8590157,
		"ID": 748,
		"x": -14.0102885847,
		"y": 65.529143476,
		"h": 3.2417582418
	},
	{
		"stop_id": 8590158,
		"ID": 748,
		"x": -13.6622273897,
		"y": 65.169150666,
		"h": 3.2417582418
	},
	{
		"stop_id": 8590160,
		"ID": 748,
		"x": -14.0802281827,
		"y": 65.903188927,
		"h": 3.2417582418
	},
	{
		"stop_id": 8590207,
		"ID": 748,
		"x": -11.0872916387,
		"y": 66.584216038,
		"h": 3.2417582418
	},
	{
		"stop_id": 8590208,
		"ID": 748,
		"x": -12.0502852607,
		"y": 66.417171994,
		"h": 3.2417582418
	},
	{
		"stop_id": 8590209,
		"ID": 748,
		"x": -12.3012922487,
		"y": 66.071148382,
		"h": 3.2417582418
	},
	{
		"stop_id": 8590210,
		"ID": 748,
		"x": -11.4882753277,
		"y": 66.387140892,
		"h": 3.2417582418
	},
	{
		"stop_id": 8590211,
		"ID": 748,
		"x": -11.7512748287,
		"y": 66.26714871,
		"h": 3.2417582418
	},
	{
		"stop_id": 8590212,
		"ID": 748,
		"x": -10.7222589277,
		"y": 66.332161763,
		"h": 3.2417582418
	},
	{
		"stop_id": 8590213,
		"ID": 748,
		"x": -10.6822536767,
		"y": 66.069203542,
		"h": 3.2417582418
	},
	{
		"stop_id": 8590214,
		"ID": 748,
		"x": -12.3762336597,
		"y": 66.425232716,
		"h": 3.2417582418
	},
	{
		"stop_id": 8590215,
		"ID": 748,
		"x": -11.2632954527,
		"y": 66.566207341,
		"h": 3.2417582418
	},
	{
		"stop_id": 8590216,
		"ID": 748,
		"x": -10.5882596797,
		"y": 65.898199359,
		"h": 3.2417582418
	},
	{
		"stop_id": 8590257,
		"ID": 748,
		"x": -10.9572892917,
		"y": 67.916187844,
		"h": 3.2417582418
	},
	{
		"stop_id": 8590258,
		"ID": 748,
		"x": -11.6982837567,
		"y": 67.573239405,
		"h": 3.2417582418
	},
	{
		"stop_id": 8590259,
		"ID": 748,
		"x": -11.2832832677,
		"y": 67.764189702,
		"h": 3.2417582418
	},
	{
		"stop_id": 8590260,
		"ID": 748,
		"x": -11.9182641187,
		"y": 67.367210803,
		"h": 3.2417582418
	},
	{
		"stop_id": 8590261,
		"ID": 748,
		"x": -10.7322651087,
		"y": 68.035235303,
		"h": 3.2417582418
	},
	{
		"stop_id": 8590281,
		"ID": 748,
		"x": -11.1572560387,
		"y": 64.378156657,
		"h": 3.2417582418
	},
	{
		"stop_id": 8590282,
		"ID": 748,
		"x": -12.0772978857,
		"y": 65.776189522,
		"h": 3.2417582418
	},
	{
		"stop_id": 8590283,
		"ID": 748,
		"x": -12.2992695287,
		"y": 65.686238797,
		"h": 3.2417582418
	},
	{
		"stop_id": 8590284,
		"ID": 748,
		"x": -12.6072249087,
		"y": 65.848226599,
		"h": 3.2417582418
	},
	{
		"stop_id": 8590285,
		"ID": 748,
		"x": -11.4802674457,
		"y": 65.199183133,
		"h": 3.2417582418
	},
	{
		"stop_id": 8590286,
		"ID": 748,
		"x": -12.5712822577,
		"y": 66.076221245,
		"h": 3.2417582418
	},
	{
		"stop_id": 8590287,
		"ID": 748,
		"x": -11.3272827857,
		"y": 64.98917715,
		"h": 3.2417582418
	},
	{
		"stop_id": 8590289,
		"ID": 748,
		"x": -11.8382561257,
		"y": 65.472243508,
		"h": 3.2417582418
	},
	{
		"stop_id": 8594392,
		"ID": 748,
		"x": -11.3352730237,
		"y": 64.654220367,
		"h": 3.2417582418
	},
	{
		"stop_id": 8594393,
		"ID": 748,
		"x": -11.6802580647,
		"y": 65.284172525,
		"h": 3.2417582418
	},
	{
		"stop_id": 8594929,
		"ID": 748,
		"x": -13.8202330567,
		"y": 66.643248549,
		"h": 3.2417582418
	},
	{
		"stop_id": 8595454,
		"ID": 748,
		"x": -8.3982975697,
		"y": 65.57519609,
		"h": 3.2417582418
	},
	{
		"stop_id": 8502105,
		"ID": 804,
		"x": -1.1592491887,
		"y": 68.454151998,
		"h": 2.2527472527
	},
	{
		"stop_id": 8502211,
		"ID": 804,
		"x": -1.6992976387,
		"y": 66.447226846,
		"h": 2.2527472527
	},
	{
		"stop_id": 8502212,
		"ID": 804,
		"x": 0.3807219413,
		"y": 64.713193413,
		"h": 2.2527472527
	},
	{
		"stop_id": 8502688,
		"ID": 804,
		"x": 0.7177395783,
		"y": 65.572212026,
		"h": 2.2527472527
	},
	{
		"stop_id": 8502689,
		"ID": 804,
		"x": 0.8037620003,
		"y": 65.882193069,
		"h": 2.2527472527
	},
	{
		"stop_id": 8572613,
		"ID": 804,
		"x": 1.4077238023,
		"y": 66.103209255,
		"h": 2.2527472527
	},
	{
		"stop_id": 8572614,
		"ID": 804,
		"x": 0.8477510783,
		"y": 65.664157877,
		"h": 2.2527472527
	},
	{
		"stop_id": 8572615,
		"ID": 804,
		"x": 0.3637732443,
		"y": 64.701235651,
		"h": 2.2527472527
	},
	{
		"stop_id": 8572616,
		"ID": 804,
		"x": 1.1397168053,
		"y": 65.663146824,
		"h": 2.2527472527
	},
	{
		"stop_id": 8578696,
		"ID": 804,
		"x": -3.7822952747,
		"y": 67.179155935,
		"h": 2.2527472527
	},
	{
		"stop_id": 8578697,
		"ID": 804,
		"x": -3.7202678797,
		"y": 66.759230139,
		"h": 2.2527472527
	},
	{
		"stop_id": 8578699,
		"ID": 804,
		"x": -4.6352304007,
		"y": 65.810230058,
		"h": 2.2527472527
	},
	{
		"stop_id": 8578726,
		"ID": 804,
		"x": -2.8672842237,
		"y": 66.466146751,
		"h": 2.2527472527
	},
	{
		"stop_id": 8578728,
		"ID": 804,
		"x": -3.1352830807,
		"y": 66.500161842,
		"h": 2.2527472527
	},
	{
		"stop_id": 8578729,
		"ID": 804,
		"x": -3.5382349627,
		"y": 66.481205557,
		"h": 2.2527472527
	},
	{
		"stop_id": 8578730,
		"ID": 804,
		"x": -3.6732743197,
		"y": 66.237204252,
		"h": 2.2527472527
	},
	{
		"stop_id": 8578732,
		"ID": 804,
		"x": -4.0102451837,
		"y": 66.065243848,
		"h": 2.2527472527
	},
	{
		"stop_id": 8578746,
		"ID": 804,
		"x": -4.1192950217,
		"y": 66.396225066,
		"h": 2.2527472527
	},
	{
		"stop_id": 8578747,
		"ID": 804,
		"x": -3.8842876317,
		"y": 66.241216066,
		"h": 2.2527472527
	},
	{
		"stop_id": 8578750,
		"ID": 804,
		"x": -3.7092487267,
		"y": 65.833142633,
		"h": 2.2527472527
	},
	{
		"stop_id": 8578754,
		"ID": 804,
		"x": -3.4022490737,
		"y": 64.916200492,
		"h": 2.2527472527
	},
	{
		"stop_id": 8578755,
		"ID": 804,
		"x": -2.0272248497,
		"y": 64.166237948,
		"h": 2.2527472527
	},
	{
		"stop_id": 8578757,
		"ID": 804,
		"x": -1.6702992227,
		"y": 64.21119587,
		"h": 2.2527472527
	},
	{
		"stop_id": 8580725,
		"ID": 804,
		"x": 0.4977204883,
		"y": 65.196157988,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582728,
		"ID": 804,
		"x": -0.0432637297,
		"y": 63.861215015,
		"h": 2.2527472527
	},
	{
		"stop_id": 8583074,
		"ID": 804,
		"x": 0.1857090883,
		"y": 64.518197087,
		"h": 2.2527472527
	},
	{
		"stop_id": 8587101,
		"ID": 804,
		"x": -1.1292758867,
		"y": 68.377172366,
		"h": 2.2527472527
	},
	{
		"stop_id": 8587102,
		"ID": 804,
		"x": -1.1952944347,
		"y": 67.717171973,
		"h": 2.2527472527
	},
	{
		"stop_id": 8587112,
		"ID": 804,
		"x": 0.0567006713,
		"y": 64.016216957,
		"h": 2.2527472527
	},
	{
		"stop_id": 8588869,
		"ID": 804,
		"x": -3.1772310427,
		"y": 66.267156904,
		"h": 2.2527472527
	},
	{
		"stop_id": 8589490,
		"ID": 804,
		"x": -2.0302679477,
		"y": 67.046188571,
		"h": 2.2527472527
	},
	{
		"stop_id": 8589543,
		"ID": 804,
		"x": -3.7362795367,
		"y": 65.305192511,
		"h": 2.2527472527
	},
	{
		"stop_id": 8590162,
		"ID": 804,
		"x": -1.6012496377,
		"y": 64.418236098,
		"h": 2.2527472527
	},
	{
		"stop_id": 8590224,
		"ID": 804,
		"x": -0.1542592887,
		"y": 63.85620693,
		"h": 2.2527472527
	},
	{
		"stop_id": 8590225,
		"ID": 804,
		"x": -0.2832972497,
		"y": 63.345229085,
		"h": 2.2527472527
	},
	{
		"stop_id": 8590226,
		"ID": 804,
		"x": -0.0082520227,
		"y": 63.625183301,
		"h": 2.2527472527
	},
	{
		"stop_id": 8590243,
		"ID": 804,
		"x": -3.8712435067,
		"y": 66.219212708,
		"h": 2.2527472527
	},
	{
		"stop_id": 8590253,
		"ID": 804,
		"x": -1.0042565167,
		"y": 68.200175173,
		"h": 2.2527472527
	},
	{
		"stop_id": 8590254,
		"ID": 804,
		"x": -1.7232546937,
		"y": 67.313146893,
		"h": 2.2527472527
	},
	{
		"stop_id": 8502106,
		"ID": 805,
		"x": 0.3687616593,
		"y": 69.256231571,
		"h": 1.956043956
	},
	{
		"stop_id": 8502237,
		"ID": 805,
		"x": -1.1872468657,
		"y": 72.651159197,
		"h": 1.956043956
	},
	{
		"stop_id": 8502247,
		"ID": 805,
		"x": -0.9742876407,
		"y": 71.615201025,
		"h": 1.956043956
	},
	{
		"stop_id": 8502703,
		"ID": 805,
		"x": -2.1332687037,
		"y": 71.681200213,
		"h": 1.956043956
	},
	{
		"stop_id": 8502704,
		"ID": 805,
		"x": -1.9032686247,
		"y": 72.216151613,
		"h": 1.956043956
	},
	{
		"stop_id": 8502952,
		"ID": 805,
		"x": -3.4442684987,
		"y": 72.822181533,
		"h": 1.956043956
	},
	{
		"stop_id": 8502965,
		"ID": 805,
		"x": -1.4222949117,
		"y": 71.779224017,
		"h": 1.956043956
	},
	{
		"stop_id": 8502966,
		"ID": 805,
		"x": 0.8917676413,
		"y": 71.145224049,
		"h": 1.956043956
	},
	{
		"stop_id": 8502967,
		"ID": 805,
		"x": -1.3922274877,
		"y": 72.502142417,
		"h": 1.956043956
	},
	{
		"stop_id": 8502969,
		"ID": 805,
		"x": -3.5812846357,
		"y": 73.22416511,
		"h": 1.956043956
	},
	{
		"stop_id": 8572505,
		"ID": 805,
		"x": -1.2952894777,
		"y": 73.89920166,
		"h": 1.956043956
	},
	{
		"stop_id": 8572506,
		"ID": 805,
		"x": -2.1482800577,
		"y": 72.216209499,
		"h": 1.956043956
	},
	{
		"stop_id": 8572507,
		"ID": 805,
		"x": -2.3712243337,
		"y": 71.955195853,
		"h": 1.956043956
	},
	{
		"stop_id": 8572508,
		"ID": 805,
		"x": -1.0432613167,
		"y": 71.792197999,
		"h": 1.956043956
	},
	{
		"stop_id": 8572517,
		"ID": 805,
		"x": 0.1807085413,
		"y": 74.062177077,
		"h": 1.956043956
	},
	{
		"stop_id": 8572519,
		"ID": 805,
		"x": 1.2797372663,
		"y": 72.220192324,
		"h": 1.956043956
	},
	{
		"stop_id": 8572520,
		"ID": 805,
		"x": 1.0847555473,
		"y": 71.8292427,
		"h": 1.956043956
	},
	{
		"stop_id": 8572521,
		"ID": 805,
		"x": 1.1407577423,
		"y": 71.445211852,
		"h": 1.956043956
	},
	{
		"stop_id": 8577353,
		"ID": 805,
		"x": 0.3577047283,
		"y": 69.230212311,
		"h": 1.956043956
	},
	{
		"stop_id": 8580637,
		"ID": 805,
		"x": 0.4057128793,
		"y": 68.984193321,
		"h": 1.956043956
	},
	{
		"stop_id": 8582072,
		"ID": 805,
		"x": -1.2492490797,
		"y": 73.254197051,
		"h": 1.956043956
	},
	{
		"stop_id": 8583341,
		"ID": 805,
		"x": -1.7602958997,
		"y": 71.366171415,
		"h": 1.956043956
	},
	{
		"stop_id": 8587113,
		"ID": 805,
		"x": -0.9862254047,
		"y": 69.723195793,
		"h": 1.956043956
	},
	{
		"stop_id": 8587230,
		"ID": 805,
		"x": -0.3642775047,
		"y": 68.779176447,
		"h": 1.956043956
	},
	{
		"stop_id": 8587574,
		"ID": 805,
		"x": 0.0367561493,
		"y": 68.942209711,
		"h": 1.956043956
	},
	{
		"stop_id": 8587741,
		"ID": 805,
		"x": 0.1757050843,
		"y": 69.308202412,
		"h": 1.956043956
	},
	{
		"stop_id": 8587750,
		"ID": 805,
		"x": -3.2342668747,
		"y": 69.262240467,
		"h": 1.956043956
	},
	{
		"stop_id": 8587752,
		"ID": 805,
		"x": -3.4782632497,
		"y": 69.357208043,
		"h": 1.956043956
	},
	{
		"stop_id": 8588178,
		"ID": 805,
		"x": -0.7582915527,
		"y": 69.819193526,
		"h": 1.956043956
	},
	{
		"stop_id": 8590206,
		"ID": 805,
		"x": -0.6412926777,
		"y": 69.975246255,
		"h": 1.956043956
	},
	{
		"stop_id": 8502110,
		"ID": 687,
		"x": -21.3712570077,
		"y": 62.378247711,
		"h": 2.0549450549
	},
	{
		"stop_id": 8502121,
		"ID": 687,
		"x": -20.0842542357,
		"y": 58.568230495,
		"h": 2.0549450549
	},
	{
		"stop_id": 8502362,
		"ID": 687,
		"x": -22.7852619667,
		"y": 57.979219093,
		"h": 2.0549450549
	},
	{
		"stop_id": 8502381,
		"ID": 687,
		"x": -22.8302624897,
		"y": 57.263148825,
		"h": 2.0549450549
	},
	{
		"stop_id": 8502712,
		"ID": 687,
		"x": -23.2932648767,
		"y": 57.715246718,
		"h": 2.0549450549
	},
	{
		"stop_id": 8572353,
		"ID": 687,
		"x": -24.3992273317,
		"y": 60.005144871,
		"h": 2.0549450549
	},
	{
		"stop_id": 8572681,
		"ID": 687,
		"x": -22.6082464467,
		"y": 57.639216193,
		"h": 2.0549450549
	},
	{
		"stop_id": 8572682,
		"ID": 687,
		"x": -23.4802252157,
		"y": 57.895218066,
		"h": 2.0549450549
	},
	{
		"stop_id": 8577503,
		"ID": 687,
		"x": -23.1692833407,
		"y": 58.137166814,
		"h": 2.0549450549
	},
	{
		"stop_id": 8582507,
		"ID": 687,
		"x": -24.2782752837,
		"y": 60.420243919,
		"h": 2.0549450549
	},
	{
		"stop_id": 8583099,
		"ID": 687,
		"x": -19.7702557607,
		"y": 62.046146854,
		"h": 2.0549450549
	},
	{
		"stop_id": 8590404,
		"ID": 687,
		"x": -21.4932357947,
		"y": 61.527239848,
		"h": 2.0549450549
	},
	{
		"stop_id": 8590405,
		"ID": 687,
		"x": -21.9652970147,
		"y": 62.132167733,
		"h": 2.0549450549
	},
	{
		"stop_id": 8590406,
		"ID": 687,
		"x": -21.3652565797,
		"y": 62.26821469,
		"h": 2.0549450549
	},
	{
		"stop_id": 8590407,
		"ID": 687,
		"x": -21.0562866387,
		"y": 62.196172354,
		"h": 2.0549450549
	},
	{
		"stop_id": 8590408,
		"ID": 687,
		"x": -21.7362475817,
		"y": 61.431173007,
		"h": 2.0549450549
	},
	{
		"stop_id": 8590409,
		"ID": 687,
		"x": -21.8872515117,
		"y": 61.434210671,
		"h": 2.0549450549
	},
	{
		"stop_id": 8590410,
		"ID": 687,
		"x": -22.3222951137,
		"y": 62.321141852,
		"h": 2.0549450549
	},
	{
		"stop_id": 8590411,
		"ID": 687,
		"x": -21.5492429267,
		"y": 61.940148121,
		"h": 2.0549450549
	},
	{
		"stop_id": 8590414,
		"ID": 687,
		"x": -20.7632684907,
		"y": 62.437245837,
		"h": 2.0549450549
	},
	{
		"stop_id": 8590418,
		"ID": 687,
		"x": -23.9742802787,
		"y": 61.196233987,
		"h": 2.0549450549
	},
	{
		"stop_id": 8590419,
		"ID": 687,
		"x": -23.5632712987,
		"y": 61.534163985,
		"h": 2.0549450549
	},
	{
		"stop_id": 8590420,
		"ID": 687,
		"x": -23.3862636697,
		"y": 61.936172204,
		"h": 2.0549450549
	},
	{
		"stop_id": 8590421,
		"ID": 687,
		"x": -23.7632318307,
		"y": 61.34916299,
		"h": 2.0549450549
	},
	{
		"stop_id": 8590423,
		"ID": 687,
		"x": -23.5762269657,
		"y": 61.862186702,
		"h": 2.0549450549
	},
	{
		"stop_id": 8590424,
		"ID": 687,
		"x": -23.1852848507,
		"y": 62.11018552,
		"h": 2.0549450549
	},
	{
		"stop_id": 8590427,
		"ID": 687,
		"x": -23.0342559547,
		"y": 62.442221938,
		"h": 2.0549450549
	},
	{
		"stop_id": 8590428,
		"ID": 687,
		"x": -23.3992488397,
		"y": 61.712169578,
		"h": 2.0549450549
	},
	{
		"stop_id": 8590434,
		"ID": 687,
		"x": -22.8732804677,
		"y": 62.14324673,
		"h": 2.0549450549
	},
	{
		"stop_id": 8594173,
		"ID": 687,
		"x": -23.2392953797,
		"y": 61.481222847,
		"h": 2.0549450549
	},
	{
		"stop_id": 8594174,
		"ID": 687,
		"x": -23.0212709927,
		"y": 61.491239832,
		"h": 2.0549450549
	},
	{
		"stop_id": 8594176,
		"ID": 687,
		"x": -22.8882549207,
		"y": 61.695195985,
		"h": 2.0549450549
	},
	{
		"stop_id": 8594497,
		"ID": 687,
		"x": -23.1582505217,
		"y": 57.917205205,
		"h": 2.0549450549
	},
	{
		"stop_id": 8502161,
		"ID": 747,
		"x": -8.6562239387,
		"y": 59.710154736,
		"h": 1.2637362637
	},
	{
		"stop_id": 8502177,
		"ID": 747,
		"x": -13.4212259577,
		"y": 57.636169833,
		"h": 1.2637362637
	},
	{
		"stop_id": 8502178,
		"ID": 747,
		"x": -13.1042558977,
		"y": 59.621167147,
		"h": 1.2637362637
	},
	{
		"stop_id": 8502179,
		"ID": 747,
		"x": -13.1272670687,
		"y": 60.135212521,
		"h": 1.2637362637
	},
	{
		"stop_id": 8502180,
		"ID": 747,
		"x": -13.3432338567,
		"y": 61.24914283,
		"h": 1.2637362637
	},
	{
		"stop_id": 8502195,
		"ID": 747,
		"x": -13.2652564207,
		"y": 60.797232783,
		"h": 1.2637362637
	},
	{
		"stop_id": 8502197,
		"ID": 747,
		"x": -13.3082579757,
		"y": 58.613243308,
		"h": 1.2637362637
	},
	{
		"stop_id": 8578724,
		"ID": 747,
		"x": -8.2752237547,
		"y": 59.59514616,
		"h": 1.2637362637
	},
	{
		"stop_id": 8578725,
		"ID": 747,
		"x": -8.6762850677,
		"y": 59.687189226,
		"h": 1.2637362637
	},
	{
		"stop_id": 8502162,
		"ID": 776,
		"x": -8.5882463517,
		"y": 57.567216929,
		"h": 1.4945054945
	},
	{
		"stop_id": 8502163,
		"ID": 776,
		"x": -7.9032682977,
		"y": 56.34424194,
		"h": 1.4945054945
	},
	{
		"stop_id": 8502164,
		"ID": 776,
		"x": -6.3152818177,
		"y": 54.282183121,
		"h": 1.4945054945
	},
	{
		"stop_id": 8502165,
		"ID": 776,
		"x": -5.6952804227,
		"y": 54.512160948,
		"h": 1.4945054945
	},
	{
		"stop_id": 8502183,
		"ID": 776,
		"x": -8.2582807587,
		"y": 56.900185574,
		"h": 1.4945054945
	},
	{
		"stop_id": 8516450,
		"ID": 776,
		"x": -8.7502524327,
		"y": 58.081161538,
		"h": 1.4945054945
	},
	{
		"stop_id": 8578714,
		"ID": 776,
		"x": -4.1422668057,
		"y": 57.732164647,
		"h": 1.4945054945
	},
	{
		"stop_id": 8578715,
		"ID": 776,
		"x": -4.1062546597,
		"y": 57.488229031,
		"h": 1.4945054945
	},
	{
		"stop_id": 8578716,
		"ID": 776,
		"x": -4.3032343517,
		"y": 57.867194078,
		"h": 1.4945054945
	},
	{
		"stop_id": 8578717,
		"ID": 776,
		"x": -4.6642823567,
		"y": 58.435212044,
		"h": 1.4945054945
	},
	{
		"stop_id": 8578718,
		"ID": 776,
		"x": -5.0962887187,
		"y": 58.69517188,
		"h": 1.4945054945
	},
	{
		"stop_id": 8578719,
		"ID": 776,
		"x": -5.3972523507,
		"y": 58.841173902,
		"h": 1.4945054945
	},
	{
		"stop_id": 8578720,
		"ID": 776,
		"x": -5.6642937187,
		"y": 58.875203346,
		"h": 1.4945054945
	},
	{
		"stop_id": 8578721,
		"ID": 776,
		"x": -6.2582891877,
		"y": 58.990233965,
		"h": 1.4945054945
	},
	{
		"stop_id": 8578722,
		"ID": 776,
		"x": -7.1302383497,
		"y": 59.096182351,
		"h": 1.4945054945
	},
	{
		"stop_id": 8578723,
		"ID": 776,
		"x": -8.0282338977,
		"y": 59.488221063,
		"h": 1.4945054945
	},
	{
		"stop_id": 8502166,
		"ID": 775,
		"x": -4.5622624877,
		"y": 53.44320784,
		"h": 1.3626373626
	},
	{
		"stop_id": 8502167,
		"ID": 775,
		"x": -3.5612718147,
		"y": 51.820194138,
		"h": 1.3626373626
	},
	{
		"stop_id": 8502168,
		"ID": 775,
		"x": -3.3672558627,
		"y": 50.941238349,
		"h": 1.3626373626
	},
	{
		"stop_id": 8502176,
		"ID": 775,
		"x": -3.3682609607,
		"y": 51.430212359,
		"h": 1.3626373626
	},
	{
		"stop_id": 8502596,
		"ID": 775,
		"x": -9.0842339187,
		"y": 52.298215443,
		"h": 1.3626373626
	},
	{
		"stop_id": 8502597,
		"ID": 775,
		"x": -8.3242861647,
		"y": 51.566157279,
		"h": 1.3626373626
	},
	{
		"stop_id": 8502598,
		"ID": 775,
		"x": -8.2462976507,
		"y": 50.917194058,
		"h": 1.3626373626
	},
	{
		"stop_id": 8502892,
		"ID": 775,
		"x": -8.7092290717,
		"y": 52.054154334,
		"h": 1.3626373626
	},
	{
		"stop_id": 8580821,
		"ID": 775,
		"x": -3.6202848507,
		"y": 51.817190418,
		"h": 1.3626373626
	},
	{
		"stop_id": 8580825,
		"ID": 775,
		"x": -3.2922580297,
		"y": 50.904148035,
		"h": 1.3626373626
	},
	{
		"stop_id": 8582762,
		"ID": 775,
		"x": -3.4462682977,
		"y": 51.434142501,
		"h": 1.3626373626
	},
	{
		"stop_id": 8594183,
		"ID": 775,
		"x": -6.9182351417,
		"y": 50.33224473,
		"h": 1.3626373626
	},
	{
		"stop_id": 8502185,
		"ID": 853,
		"x": 8.4847425353,
		"y": 61.720216303,
		"h": 2.1538461538
	},
	{
		"stop_id": 8502248,
		"ID": 853,
		"x": 8.6427241163,
		"y": 62.241175322,
		"h": 2.1538461538
	},
	{
		"stop_id": 8502272,
		"ID": 853,
		"x": 8.1667030803,
		"y": 61.677205301,
		"h": 2.1538461538
	},
	{
		"stop_id": 8502273,
		"ID": 853,
		"x": 8.8577689913,
		"y": 62.34017094,
		"h": 2.1538461538
	},
	{
		"stop_id": 8502274,
		"ID": 853,
		"x": 9.4727676353,
		"y": 62.464177038,
		"h": 2.1538461538
	},
	{
		"stop_id": 8502567,
		"ID": 853,
		"x": 9.7597002163,
		"y": 57.539226301,
		"h": 2.1538461538
	},
	{
		"stop_id": 8502568,
		"ID": 853,
		"x": 8.8387439363,
		"y": 60.064147129,
		"h": 2.1538461538
	},
	{
		"stop_id": 8502570,
		"ID": 853,
		"x": 10.8297264813,
		"y": 58.759243893,
		"h": 2.1538461538
	},
	{
		"stop_id": 8502571,
		"ID": 853,
		"x": 10.0837176503,
		"y": 58.204151735,
		"h": 2.1538461538
	},
	{
		"stop_id": 8502708,
		"ID": 853,
		"x": 8.7327456463,
		"y": 57.956249064,
		"h": 2.1538461538
	},
	{
		"stop_id": 8502709,
		"ID": 853,
		"x": 7.2627016703,
		"y": 57.78313966,
		"h": 2.1538461538
	},
	{
		"stop_id": 8502710,
		"ID": 853,
		"x": 6.5267313473,
		"y": 59.56621196,
		"h": 2.1538461538
	},
	{
		"stop_id": 8502711,
		"ID": 853,
		"x": 5.9987636943,
		"y": 60.377232135,
		"h": 2.1538461538
	},
	{
		"stop_id": 8502878,
		"ID": 853,
		"x": 8.6527532283,
		"y": 62.269199339,
		"h": 2.1538461538
	},
	{
		"stop_id": 8517377,
		"ID": 853,
		"x": 9.1357564603,
		"y": 62.601240263,
		"h": 2.1538461538
	},
	{
		"stop_id": 8572570,
		"ID": 853,
		"x": 8.2947471513,
		"y": 62.070167447,
		"h": 2.1538461538
	},
	{
		"stop_id": 8572600,
		"ID": 853,
		"x": 9.2767018293,
		"y": 61.586169331,
		"h": 2.1538461538
	},
	{
		"stop_id": 8572601,
		"ID": 853,
		"x": 9.4807165603,
		"y": 61.265210727,
		"h": 2.1538461538
	},
	{
		"stop_id": 8572607,
		"ID": 853,
		"x": 7.3067346593,
		"y": 62.750172731,
		"h": 2.1538461538
	},
	{
		"stop_id": 8572625,
		"ID": 853,
		"x": 5.6517100583,
		"y": 60.46923977,
		"h": 2.1538461538
	},
	{
		"stop_id": 8572626,
		"ID": 853,
		"x": 8.6217188043,
		"y": 58.253173652,
		"h": 2.1538461538
	},
	{
		"stop_id": 8572643,
		"ID": 853,
		"x": 8.1757695883,
		"y": 61.664188896,
		"h": 2.1538461538
	},
	{
		"stop_id": 8572644,
		"ID": 853,
		"x": 8.3777324013,
		"y": 60.167243613,
		"h": 2.1538461538
	},
	{
		"stop_id": 8572645,
		"ID": 853,
		"x": 8.6247022323,
		"y": 60.297172729,
		"h": 2.1538461538
	},
	{
		"stop_id": 8572647,
		"ID": 853,
		"x": 10.2537733973,
		"y": 58.448211201,
		"h": 2.1538461538
	},
	{
		"stop_id": 8572747,
		"ID": 853,
		"x": 8.8287016843,
		"y": 62.364185074,
		"h": 2.1538461538
	},
	{
		"stop_id": 8576164,
		"ID": 853,
		"x": 9.5667647433,
		"y": 62.212209098,
		"h": 2.1538461538
	},
	{
		"stop_id": 8576480,
		"ID": 853,
		"x": 9.7557122523,
		"y": 61.906205088,
		"h": 2.1538461538
	},
	{
		"stop_id": 8576496,
		"ID": 853,
		"x": 9.6617345113,
		"y": 61.67116339,
		"h": 2.1538461538
	},
	{
		"stop_id": 8576498,
		"ID": 853,
		"x": 9.6557234583,
		"y": 61.442155593,
		"h": 2.1538461538
	},
	{
		"stop_id": 8580302,
		"ID": 853,
		"x": 9.9557246313,
		"y": 57.867193717,
		"h": 2.1538461538
	},
	{
		"stop_id": 8580840,
		"ID": 853,
		"x": 8.4887415013,
		"y": 59.986171132,
		"h": 2.1538461538
	},
	{
		"stop_id": 8580847,
		"ID": 853,
		"x": 9.1147684733,
		"y": 62.606222379,
		"h": 2.1538461538
	},
	{
		"stop_id": 8581308,
		"ID": 853,
		"x": 8.3807698523,
		"y": 61.857228322,
		"h": 2.1538461538
	},
	{
		"stop_id": 8582462,
		"ID": 853,
		"x": 8.9867217633,
		"y": 61.906249252,
		"h": 2.1538461538
	},
	{
		"stop_id": 8582529,
		"ID": 853,
		"x": 9.1217126873,
		"y": 62.431180611,
		"h": 2.1538461538
	},
	{
		"stop_id": 8502186,
		"ID": 880,
		"x": 12.7587105213,
		"y": 67.049238329,
		"h": 3.8021978022
	},
	{
		"stop_id": 8502220,
		"ID": 880,
		"x": 15.4627307873,
		"y": 66.802185999,
		"h": 3.8021978022
	},
	{
		"stop_id": 8502229,
		"ID": 880,
		"x": 15.1457547243,
		"y": 65.69615377,
		"h": 3.8021978022
	},
	{
		"stop_id": 8502270,
		"ID": 880,
		"x": 12.7637212833,
		"y": 67.528199741,
		"h": 3.8021978022
	},
	{
		"stop_id": 8502278,
		"ID": 880,
		"x": 12.5657428023,
		"y": 66.082188472,
		"h": 3.8021978022
	},
	{
		"stop_id": 8503508,
		"ID": 880,
		"x": 13.1967717713,
		"y": 68.430163208,
		"h": 3.8021978022
	},
	{
		"stop_id": 8503509,
		"ID": 880,
		"x": 16.3957159753,
		"y": 67.736216918,
		"h": 3.8021978022
	},
	{
		"stop_id": 8503512,
		"ID": 880,
		"x": 14.3727703163,
		"y": 67.677204629,
		"h": 3.8021978022
	},
	{
		"stop_id": 8517376,
		"ID": 880,
		"x": 12.8957327743,
		"y": 68.005159616,
		"h": 3.8021978022
	},
	{
		"stop_id": 8587020,
		"ID": 880,
		"x": 13.1627284243,
		"y": 68.436193214,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590200,
		"ID": 880,
		"x": 12.2767727103,
		"y": 67.005222052,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590201,
		"ID": 880,
		"x": 12.0547128623,
		"y": 66.787150375,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590202,
		"ID": 880,
		"x": 11.9497026433,
		"y": 66.442188369,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590203,
		"ID": 880,
		"x": 12.3187709913,
		"y": 67.165180515,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590204,
		"ID": 880,
		"x": 12.1377374813,
		"y": 67.020212292,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590205,
		"ID": 880,
		"x": 11.7387099603,
		"y": 66.587189306,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590217,
		"ID": 880,
		"x": 13.1357067793,
		"y": 68.264180977,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590218,
		"ID": 880,
		"x": 12.3077335483,
		"y": 68.66223578,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590219,
		"ID": 880,
		"x": 13.1007197753,
		"y": 68.359152943,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590220,
		"ID": 880,
		"x": 12.4137550953,
		"y": 67.698163445,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590222,
		"ID": 880,
		"x": 12.6837257053,
		"y": 68.433207995,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590223,
		"ID": 880,
		"x": 12.8787411363,
		"y": 68.067218454,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590241,
		"ID": 880,
		"x": 11.3667690463,
		"y": 67.120209665,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590268,
		"ID": 880,
		"x": 11.2647539083,
		"y": 69.344141786,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590512,
		"ID": 880,
		"x": 14.1457732693,
		"y": 67.53015364,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590513,
		"ID": 880,
		"x": 13.3287389683,
		"y": 67.835247291,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590514,
		"ID": 880,
		"x": 13.1567634633,
		"y": 69.031217522,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590515,
		"ID": 880,
		"x": 12.5637301323,
		"y": 69.729237116,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590516,
		"ID": 880,
		"x": 12.3617516203,
		"y": 68.007197744,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590517,
		"ID": 880,
		"x": 13.7127509013,
		"y": 67.600156499,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590518,
		"ID": 880,
		"x": 11.7057420113,
		"y": 68.012147456,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590519,
		"ID": 880,
		"x": 12.7367627963,
		"y": 69.743249821,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590520,
		"ID": 880,
		"x": 12.3397447923,
		"y": 69.939216552,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590521,
		"ID": 880,
		"x": 12.5537658043,
		"y": 67.97317847,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590523,
		"ID": 880,
		"x": 12.7177069793,
		"y": 69.376194833,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590525,
		"ID": 880,
		"x": 13.6657277453,
		"y": 67.794158657,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590526,
		"ID": 880,
		"x": 14.6947489293,
		"y": 67.492215837,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590528,
		"ID": 880,
		"x": 12.2727600513,
		"y": 69.800190163,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590529,
		"ID": 880,
		"x": 13.2107318403,
		"y": 68.130229212,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590531,
		"ID": 880,
		"x": 12.0877252803,
		"y": 68.386144173,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590532,
		"ID": 880,
		"x": 12.1337185153,
		"y": 67.98619121,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590533,
		"ID": 880,
		"x": 12.2057054603,
		"y": 68.256147887,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590535,
		"ID": 880,
		"x": 12.6567298103,
		"y": 68.795251074,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590536,
		"ID": 880,
		"x": 11.9427467113,
		"y": 67.853227623,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590537,
		"ID": 880,
		"x": 11.4627722323,
		"y": 67.858224595,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590602,
		"ID": 880,
		"x": 13.8697723973,
		"y": 69.399186468,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590603,
		"ID": 880,
		"x": 13.7167008453,
		"y": 68.639179657,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590614,
		"ID": 880,
		"x": 13.7937650213,
		"y": 70.001237014,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590615,
		"ID": 880,
		"x": 13.8927662723,
		"y": 69.656214817,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590616,
		"ID": 880,
		"x": 13.1287649283,
		"y": 70.331151618,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590617,
		"ID": 880,
		"x": 14.2437483643,
		"y": 69.810142876,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590618,
		"ID": 880,
		"x": 13.5127371603,
		"y": 70.177218047,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590619,
		"ID": 880,
		"x": 14.3097416913,
		"y": 67.658181,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590737,
		"ID": 880,
		"x": 12.8057601303,
		"y": 70.60416504,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590738,
		"ID": 880,
		"x": 12.6517251983,
		"y": 70.865249274,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590739,
		"ID": 880,
		"x": 12.4047595773,
		"y": 70.834214421,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590790,
		"ID": 880,
		"x": 16.4397622013,
		"y": 68.20923877,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590792,
		"ID": 880,
		"x": 15.6667206223,
		"y": 67.214186604,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590794,
		"ID": 880,
		"x": 15.7687051683,
		"y": 67.417187545,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590796,
		"ID": 880,
		"x": 15.9877534473,
		"y": 67.250193647,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590797,
		"ID": 880,
		"x": 15.3537717003,
		"y": 67.49319444,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590800,
		"ID": 880,
		"x": 15.0857588493,
		"y": 66.990219126,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590801,
		"ID": 880,
		"x": 14.8257532453,
		"y": 67.383227674,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590802,
		"ID": 880,
		"x": 16.4307366293,
		"y": 68.453189774,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590831,
		"ID": 880,
		"x": 16.2827287303,
		"y": 69.492160802,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590832,
		"ID": 880,
		"x": 16.5157013863,
		"y": 68.995234258,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590837,
		"ID": 880,
		"x": 14.9047224323,
		"y": 66.898203889,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590839,
		"ID": 880,
		"x": 14.1907121173,
		"y": 67.093175978,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590840,
		"ID": 880,
		"x": 14.6027396993,
		"y": 67.117234525,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590841,
		"ID": 880,
		"x": 14.3877128703,
		"y": 66.380232741,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590842,
		"ID": 880,
		"x": 14.5377708863,
		"y": 66.379220998,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590843,
		"ID": 880,
		"x": 14.2447507193,
		"y": 66.726140847,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590845,
		"ID": 880,
		"x": 14.7567138483,
		"y": 66.629148026,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590846,
		"ID": 880,
		"x": 14.5897548123,
		"y": 66.822191934,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590847,
		"ID": 880,
		"x": 14.5567438703,
		"y": 65.721207373,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590848,
		"ID": 880,
		"x": 14.4987633923,
		"y": 66.063171583,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590849,
		"ID": 880,
		"x": 14.8117073883,
		"y": 65.835155894,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590910,
		"ID": 880,
		"x": 16.1707678243,
		"y": 69.571228005,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590911,
		"ID": 880,
		"x": 15.7887729273,
		"y": 69.786171315,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590913,
		"ID": 880,
		"x": 15.3637151373,
		"y": 69.989139894,
		"h": 3.8021978022
	},
	{
		"stop_id": 8590914,
		"ID": 880,
		"x": 14.9677538943,
		"y": 69.85014414,
		"h": 3.8021978022
	},
	{
		"stop_id": 8591829,
		"ID": 880,
		"x": 13.8927715353,
		"y": 69.091248201,
		"h": 3.8021978022
	},
	{
		"stop_id": 8591833,
		"ID": 880,
		"x": 16.4907307063,
		"y": 69.293242439,
		"h": 3.8021978022
	},
	{
		"stop_id": 8591893,
		"ID": 880,
		"x": 12.2137194873,
		"y": 67.851175608,
		"h": 3.8021978022
	},
	{
		"stop_id": 8593529,
		"ID": 880,
		"x": 16.4437262683,
		"y": 68.834190784,
		"h": 3.8021978022
	},
	{
		"stop_id": 8595511,
		"ID": 880,
		"x": 13.2607627643,
		"y": 68.738173995,
		"h": 3.8021978022
	},
	{
		"stop_id": 8502187,
		"ID": 879,
		"x": 11.1427618453,
		"y": 63.842196287,
		"h": 1.7582417582
	},
	{
		"stop_id": 8502221,
		"ID": 879,
		"x": 15.7237219923,
		"y": 63.086163402,
		"h": 1.7582417582
	},
	{
		"stop_id": 8502277,
		"ID": 879,
		"x": 11.4497198843,
		"y": 64.375249413,
		"h": 1.7582417582
	},
	{
		"stop_id": 8502560,
		"ID": 879,
		"x": 10.7367277723,
		"y": 62.315172857,
		"h": 1.7582417582
	},
	{
		"stop_id": 8502876,
		"ID": 879,
		"x": 15.8387385473,
		"y": 60.950219317,
		"h": 1.7582417582
	},
	{
		"stop_id": 8502894,
		"ID": 879,
		"x": 11.8867054013,
		"y": 60.785202593,
		"h": 1.7582417582
	},
	{
		"stop_id": 8502950,
		"ID": 879,
		"x": 15.7007163243,
		"y": 62.69714885,
		"h": 1.7582417582
	},
	{
		"stop_id": 8502979,
		"ID": 879,
		"x": 12.6757580493,
		"y": 61.253217257,
		"h": 1.7582417582
	},
	{
		"stop_id": 8503698,
		"ID": 879,
		"x": 16.4387420313,
		"y": 63.348155892,
		"h": 1.7582417582
	},
	{
		"stop_id": 8572595,
		"ID": 879,
		"x": 14.4557026823,
		"y": 61.924233873,
		"h": 1.7582417582
	},
	{
		"stop_id": 8572596,
		"ID": 879,
		"x": 12.9897067013,
		"y": 61.278185124,
		"h": 1.7582417582
	},
	{
		"stop_id": 8572597,
		"ID": 879,
		"x": 12.4587382243,
		"y": 61.231224318,
		"h": 1.7582417582
	},
	{
		"stop_id": 8572598,
		"ID": 879,
		"x": 11.3997259773,
		"y": 61.55321644,
		"h": 1.7582417582
	},
	{
		"stop_id": 8572599,
		"ID": 879,
		"x": 10.3427160263,
		"y": 62.892244345,
		"h": 1.7582417582
	},
	{
		"stop_id": 8573718,
		"ID": 879,
		"x": 15.8197481473,
		"y": 63.03323674,
		"h": 1.7582417582
	},
	{
		"stop_id": 8573719,
		"ID": 879,
		"x": 15.7917529413,
		"y": 62.360178107,
		"h": 1.7582417582
	},
	{
		"stop_id": 8580317,
		"ID": 879,
		"x": 11.1257432673,
		"y": 61.941210287,
		"h": 1.7582417582
	},
	{
		"stop_id": 8581346,
		"ID": 879,
		"x": 11.6187225893,
		"y": 61.052161338,
		"h": 1.7582417582
	},
	{
		"stop_id": 8582752,
		"ID": 879,
		"x": 16.3617387183,
		"y": 62.94321117,
		"h": 1.7582417582
	},
	{
		"stop_id": 8583214,
		"ID": 879,
		"x": 15.0977616553,
		"y": 64.000220006,
		"h": 1.7582417582
	},
	{
		"stop_id": 8583870,
		"ID": 879,
		"x": 15.6837437493,
		"y": 63.057189881,
		"h": 1.7582417582
	},
	{
		"stop_id": 8590834,
		"ID": 879,
		"x": 15.1197285493,
		"y": 65.598199108,
		"h": 1.7582417582
	},
	{
		"stop_id": 8590838,
		"ID": 879,
		"x": 14.7357436053,
		"y": 64.518145138,
		"h": 1.7582417582
	},
	{
		"stop_id": 8590844,
		"ID": 879,
		"x": 14.6217203463,
		"y": 65.442154641,
		"h": 1.7582417582
	},
	{
		"stop_id": 8502188,
		"ID": 854,
		"x": 9.4597652053,
		"y": 62.840177485,
		"h": 1.6593406593
	},
	{
		"stop_id": 8502268,
		"ID": 854,
		"x": 9.8077440803,
		"y": 63.030157225,
		"h": 1.6593406593
	},
	{
		"stop_id": 8502275,
		"ID": 854,
		"x": 9.4657414853,
		"y": 63.519167925,
		"h": 1.6593406593
	},
	{
		"stop_id": 8502276,
		"ID": 854,
		"x": 10.3727250623,
		"y": 63.549172057,
		"h": 1.6593406593
	},
	{
		"stop_id": 8502575,
		"ID": 854,
		"x": 10.1237190313,
		"y": 64.14520994,
		"h": 1.6593406593
	},
	{
		"stop_id": 8502691,
		"ID": 854,
		"x": 7.0147022343,
		"y": 62.965140764,
		"h": 1.6593406593
	},
	{
		"stop_id": 8502750,
		"ID": 854,
		"x": 8.5687606533,
		"y": 66.566142071,
		"h": 1.6593406593
	},
	{
		"stop_id": 8502881,
		"ID": 854,
		"x": 7.4447210413,
		"y": 66.740200756,
		"h": 1.6593406593
	},
	{
		"stop_id": 8502982,
		"ID": 854,
		"x": 8.3917553553,
		"y": 64.353210729,
		"h": 1.6593406593
	},
	{
		"stop_id": 8503879,
		"ID": 854,
		"x": 9.5837684213,
		"y": 64.680141274,
		"h": 1.6593406593
	},
	{
		"stop_id": 8572559,
		"ID": 854,
		"x": 8.2427690833,
		"y": 67.140247284,
		"h": 1.6593406593
	},
	{
		"stop_id": 8572560,
		"ID": 854,
		"x": 10.3707398203,
		"y": 63.506229466,
		"h": 1.6593406593
	},
	{
		"stop_id": 8572561,
		"ID": 854,
		"x": 8.6197664683,
		"y": 66.4582089,
		"h": 1.6593406593
	},
	{
		"stop_id": 8572567,
		"ID": 854,
		"x": 7.5557153393,
		"y": 66.288139811,
		"h": 1.6593406593
	},
	{
		"stop_id": 8572568,
		"ID": 854,
		"x": 8.9997461783,
		"y": 62.888197056,
		"h": 1.6593406593
	},
	{
		"stop_id": 8572569,
		"ID": 854,
		"x": 6.3507119903,
		"y": 64.010213064,
		"h": 1.6593406593
	},
	{
		"stop_id": 8580310,
		"ID": 854,
		"x": 7.4637207333,
		"y": 68.433173356,
		"h": 1.6593406593
	},
	{
		"stop_id": 8580728,
		"ID": 854,
		"x": 10.2507176143,
		"y": 63.939228413,
		"h": 1.6593406593
	},
	{
		"stop_id": 8580729,
		"ID": 854,
		"x": 10.3157266143,
		"y": 63.814240997,
		"h": 1.6593406593
	},
	{
		"stop_id": 8580846,
		"ID": 854,
		"x": 7.7647274233,
		"y": 63.032228963,
		"h": 1.6593406593
	},
	{
		"stop_id": 8587018,
		"ID": 854,
		"x": 11.0237548443,
		"y": 67.114212553,
		"h": 1.6593406593
	},
	{
		"stop_id": 8502201,
		"ID": 874,
		"x": 12.8127254453,
		"y": 36.798216819,
		"h": 1.8241758242
	},
	{
		"stop_id": 8505002,
		"ID": 874,
		"x": 15.8037741053,
		"y": 32.640140802,
		"h": 1.8241758242
	},
	{
		"stop_id": 8505895,
		"ID": 874,
		"x": 13.1917157043,
		"y": 33.103249293,
		"h": 1.8241758242
	},
	{
		"stop_id": 8515997,
		"ID": 874,
		"x": 11.2427498923,
		"y": 34.948235732,
		"h": 1.8241758242
	},
	{
		"stop_id": 8573066,
		"ID": 874,
		"x": 11.8367423313,
		"y": 31.461233322,
		"h": 1.8241758242
	},
	{
		"stop_id": 8573068,
		"ID": 874,
		"x": 12.6077057033,
		"y": 32.169206983,
		"h": 1.8241758242
	},
	{
		"stop_id": 8573069,
		"ID": 874,
		"x": 13.1467486983,
		"y": 32.626173021,
		"h": 1.8241758242
	},
	{
		"stop_id": 8573070,
		"ID": 874,
		"x": 13.3557524183,
		"y": 33.393221024,
		"h": 1.8241758242
	},
	{
		"stop_id": 8573071,
		"ID": 874,
		"x": 13.6087278623,
		"y": 33.766233234,
		"h": 1.8241758242
	},
	{
		"stop_id": 8573072,
		"ID": 874,
		"x": 14.2047473013,
		"y": 34.496175908,
		"h": 1.8241758242
	},
	{
		"stop_id": 8573073,
		"ID": 874,
		"x": 14.7907407963,
		"y": 35.160235395,
		"h": 1.8241758242
	},
	{
		"stop_id": 8577143,
		"ID": 874,
		"x": 12.8377289353,
		"y": 36.820202152,
		"h": 1.8241758242
	},
	{
		"stop_id": 8577176,
		"ID": 874,
		"x": 10.5107695293,
		"y": 33.920244126,
		"h": 1.8241758242
	},
	{
		"stop_id": 8577177,
		"ID": 874,
		"x": 11.4597656163,
		"y": 34.79116817,
		"h": 1.8241758242
	},
	{
		"stop_id": 8577178,
		"ID": 874,
		"x": 12.0497368573,
		"y": 35.519154608,
		"h": 1.8241758242
	},
	{
		"stop_id": 8577179,
		"ID": 874,
		"x": 12.3057739703,
		"y": 35.826218842,
		"h": 1.8241758242
	},
	{
		"stop_id": 8577181,
		"ID": 874,
		"x": 12.6737726773,
		"y": 36.492218333,
		"h": 1.8241758242
	},
	{
		"stop_id": 8577205,
		"ID": 874,
		"x": 15.7857751993,
		"y": 32.592215334,
		"h": 1.8241758242
	},
	{
		"stop_id": 8587582,
		"ID": 874,
		"x": 16.1127568993,
		"y": 32.571241283,
		"h": 1.8241758242
	},
	{
		"stop_id": 8589864,
		"ID": 874,
		"x": 12.4897427843,
		"y": 36.153211275,
		"h": 1.8241758242
	},
	{
		"stop_id": 8591700,
		"ID": 874,
		"x": 15.0127068463,
		"y": 31.474202845,
		"h": 1.8241758242
	},
	{
		"stop_id": 8591703,
		"ID": 874,
		"x": 15.8397359283,
		"y": 33.014170397,
		"h": 1.8241758242
	},
	{
		"stop_id": 8591704,
		"ID": 874,
		"x": 14.2667237623,
		"y": 33.302178514,
		"h": 1.8241758242
	},
	{
		"stop_id": 8591705,
		"ID": 874,
		"x": 11.2337180993,
		"y": 34.916218872,
		"h": 1.8241758242
	},
	{
		"stop_id": 8594722,
		"ID": 874,
		"x": 14.6417541103,
		"y": 33.370222416,
		"h": 1.8241758242
	},
	{
		"stop_id": 8595501,
		"ID": 874,
		"x": 15.8677343683,
		"y": 32.920242711,
		"h": 1.8241758242
	},
	{
		"stop_id": 8502202,
		"ID": 875,
		"x": 15.4927374483,
		"y": 39.103177823,
		"h": 1.9230769231
	},
	{
		"stop_id": 8502219,
		"ID": 875,
		"x": 13.5097216293,
		"y": 41.765202594,
		"h": 1.9230769231
	},
	{
		"stop_id": 8573079,
		"ID": 875,
		"x": 15.6127585803,
		"y": 38.521202711,
		"h": 1.9230769231
	},
	{
		"stop_id": 8573080,
		"ID": 875,
		"x": 15.6857235233,
		"y": 38.840223911,
		"h": 1.9230769231
	},
	{
		"stop_id": 8573081,
		"ID": 875,
		"x": 15.4807504613,
		"y": 39.067225097,
		"h": 1.9230769231
	},
	{
		"stop_id": 8577138,
		"ID": 875,
		"x": 12.7177416773,
		"y": 41.700246909,
		"h": 1.9230769231
	},
	{
		"stop_id": 8577139,
		"ID": 875,
		"x": 12.6267339733,
		"y": 39.95522264,
		"h": 1.9230769231
	},
	{
		"stop_id": 8577140,
		"ID": 875,
		"x": 12.5877363913,
		"y": 39.725154727,
		"h": 1.9230769231
	},
	{
		"stop_id": 8577141,
		"ID": 875,
		"x": 12.8337147543,
		"y": 38.998229713,
		"h": 1.9230769231
	},
	{
		"stop_id": 8577142,
		"ID": 875,
		"x": 12.9177694783,
		"y": 38.190174505,
		"h": 1.9230769231
	},
	{
		"stop_id": 8582046,
		"ID": 875,
		"x": 13.6857044813,
		"y": 38.120211074,
		"h": 1.9230769231
	},
	{
		"stop_id": 8583380,
		"ID": 875,
		"x": 13.1557239513,
		"y": 37.482178313,
		"h": 1.9230769231
	},
	{
		"stop_id": 8587259,
		"ID": 875,
		"x": 16.2077156803,
		"y": 40.650158859,
		"h": 1.9230769231
	},
	{
		"stop_id": 8587435,
		"ID": 875,
		"x": 15.4077450103,
		"y": 39.670143359,
		"h": 1.9230769231
	},
	{
		"stop_id": 8587590,
		"ID": 875,
		"x": 15.8927754523,
		"y": 39.000176405,
		"h": 1.9230769231
	},
	{
		"stop_id": 8587722,
		"ID": 875,
		"x": 14.9277151993,
		"y": 38.190249598,
		"h": 1.9230769231
	},
	{
		"stop_id": 8588626,
		"ID": 875,
		"x": 15.5497593173,
		"y": 39.219196591,
		"h": 1.9230769231
	},
	{
		"stop_id": 8588644,
		"ID": 875,
		"x": 15.2077269913,
		"y": 38.910236301,
		"h": 1.9230769231
	},
	{
		"stop_id": 8588690,
		"ID": 875,
		"x": 15.2777628403,
		"y": 42.170151624,
		"h": 1.9230769231
	},
	{
		"stop_id": 8588708,
		"ID": 875,
		"x": 16.1177555913,
		"y": 40.520148632,
		"h": 1.9230769231
	},
	{
		"stop_id": 8588709,
		"ID": 875,
		"x": 15.8137560503,
		"y": 41.262217944,
		"h": 1.9230769231
	},
	{
		"stop_id": 8589203,
		"ID": 875,
		"x": 15.7827258213,
		"y": 39.500219305,
		"h": 1.9230769231
	},
	{
		"stop_id": 8593426,
		"ID": 875,
		"x": 15.1377340813,
		"y": 42.470142793,
		"h": 1.9230769231
	},
	{
		"stop_id": 8593428,
		"ID": 875,
		"x": 15.7747218533,
		"y": 39.808209075,
		"h": 1.9230769231
	},
	{
		"stop_id": 8593429,
		"ID": 875,
		"x": 15.5377578573,
		"y": 39.910165096,
		"h": 1.9230769231
	},
	{
		"stop_id": 8593430,
		"ID": 875,
		"x": 15.3577495533,
		"y": 39.430244277,
		"h": 1.9230769231
	},
	{
		"stop_id": 8593431,
		"ID": 875,
		"x": 15.2977122223,
		"y": 38.530231766,
		"h": 1.9230769231
	},
	{
		"stop_id": 8593433,
		"ID": 875,
		"x": 15.3377143913,
		"y": 38.715190077,
		"h": 1.9230769231
	},
	{
		"stop_id": 8593434,
		"ID": 875,
		"x": 15.1227490893,
		"y": 38.380154596,
		"h": 1.9230769231
	},
	{
		"stop_id": 8502203,
		"ID": 904,
		"x": 17.4887714703,
		"y": 43.185211649,
		"h": 3.2087912088
	},
	{
		"stop_id": 8502227,
		"ID": 904,
		"x": 19.0517520083,
		"y": 45.022156452,
		"h": 3.2087912088
	},
	{
		"stop_id": 8502230,
		"ID": 904,
		"x": 19.6287098113,
		"y": 43.461214267,
		"h": 3.2087912088
	},
	{
		"stop_id": 8502250,
		"ID": 904,
		"x": 17.9417293303,
		"y": 43.238141341,
		"h": 3.2087912088
	},
	{
		"stop_id": 8502251,
		"ID": 904,
		"x": 21.7347456293,
		"y": 42.336242811,
		"h": 3.2087912088
	},
	{
		"stop_id": 8502280,
		"ID": 904,
		"x": 21.8717109933,
		"y": 42.682242001,
		"h": 3.2087912088
	},
	{
		"stop_id": 8502299,
		"ID": 904,
		"x": 21.1877345373,
		"y": 43.330230784,
		"h": 3.2087912088
	},
	{
		"stop_id": 8502306,
		"ID": 904,
		"x": 16.9267189763,
		"y": 42.167156475,
		"h": 3.2087912088
	},
	{
		"stop_id": 8502780,
		"ID": 904,
		"x": 21.7877120193,
		"y": 42.510196734,
		"h": 3.2087912088
	},
	{
		"stop_id": 8502791,
		"ID": 904,
		"x": 20.8377041723,
		"y": 42.990140806,
		"h": 3.2087912088
	},
	{
		"stop_id": 8502795,
		"ID": 904,
		"x": 18.1177750943,
		"y": 43.590233093,
		"h": 3.2087912088
	},
	{
		"stop_id": 8502850,
		"ID": 904,
		"x": 18.6577583633,
		"y": 43.830149256,
		"h": 3.2087912088
	},
	{
		"stop_id": 8502851,
		"ID": 904,
		"x": 20.2377374773,
		"y": 44.110249992,
		"h": 3.2087912088
	},
	{
		"stop_id": 8502852,
		"ID": 904,
		"x": 20.1177662033,
		"y": 43.290196175,
		"h": 3.2087912088
	},
	{
		"stop_id": 8502862,
		"ID": 904,
		"x": 16.8777640663,
		"y": 42.730234292,
		"h": 3.2087912088
	},
	{
		"stop_id": 8515995,
		"ID": 904,
		"x": 18.5407648843,
		"y": 43.648153658,
		"h": 3.2087912088
	},
	{
		"stop_id": 8515996,
		"ID": 904,
		"x": 16.9337585393,
		"y": 42.662243302,
		"h": 3.2087912088
	},
	{
		"stop_id": 8516187,
		"ID": 904,
		"x": 21.2657610803,
		"y": 42.733221694,
		"h": 3.2087912088
	},
	{
		"stop_id": 8518459,
		"ID": 904,
		"x": 19.1577698963,
		"y": 44.280171215,
		"h": 3.2087912088
	},
	{
		"stop_id": 8577529,
		"ID": 904,
		"x": 21.8177393953,
		"y": 42.460240934,
		"h": 3.2087912088
	},
	{
		"stop_id": 8577575,
		"ID": 904,
		"x": 21.4977294913,
		"y": 42.580168405,
		"h": 3.2087912088
	},
	{
		"stop_id": 8577576,
		"ID": 904,
		"x": 21.2377193763,
		"y": 42.710157898,
		"h": 3.2087912088
	},
	{
		"stop_id": 8577577,
		"ID": 904,
		"x": 20.5677527163,
		"y": 43.140149319,
		"h": 3.2087912088
	},
	{
		"stop_id": 8577579,
		"ID": 904,
		"x": 19.4577287983,
		"y": 43.680195294,
		"h": 3.2087912088
	},
	{
		"stop_id": 8577580,
		"ID": 904,
		"x": 17.7717121383,
		"y": 43.556248972,
		"h": 3.2087912088
	},
	{
		"stop_id": 8577581,
		"ID": 904,
		"x": 17.4277656883,
		"y": 43.160181478,
		"h": 3.2087912088
	},
	{
		"stop_id": 8577582,
		"ID": 904,
		"x": 17.5877457643,
		"y": 43.45022948,
		"h": 3.2087912088
	},
	{
		"stop_id": 8577584,
		"ID": 904,
		"x": 17.2777527563,
		"y": 43.990238181,
		"h": 3.2087912088
	},
	{
		"stop_id": 8577585,
		"ID": 904,
		"x": 17.0377494123,
		"y": 44.250200094,
		"h": 3.2087912088
	},
	{
		"stop_id": 8577586,
		"ID": 904,
		"x": 16.5977121013,
		"y": 44.690167223,
		"h": 3.2087912088
	},
	{
		"stop_id": 8587262,
		"ID": 904,
		"x": 21.2777111233,
		"y": 42.930184153,
		"h": 3.2087912088
	},
	{
		"stop_id": 8587285,
		"ID": 904,
		"x": 17.1477297173,
		"y": 45.270193562,
		"h": 3.2087912088
	},
	{
		"stop_id": 8587377,
		"ID": 904,
		"x": 18.8767047383,
		"y": 45.049192731,
		"h": 3.2087912088
	},
	{
		"stop_id": 8587378,
		"ID": 904,
		"x": 19.4777074293,
		"y": 45.270202228,
		"h": 3.2087912088
	},
	{
		"stop_id": 8587515,
		"ID": 904,
		"x": 18.9377267133,
		"y": 44.710214765,
		"h": 3.2087912088
	},
	{
		"stop_id": 8587516,
		"ID": 904,
		"x": 18.7977468773,
		"y": 44.170223843,
		"h": 3.2087912088
	},
	{
		"stop_id": 8588247,
		"ID": 904,
		"x": 16.2177546293,
		"y": 41.230225754,
		"h": 3.2087912088
	},
	{
		"stop_id": 8588622,
		"ID": 904,
		"x": 21.7777036873,
		"y": 42.770235652,
		"h": 3.2087912088
	},
	{
		"stop_id": 8588694,
		"ID": 904,
		"x": 21.3377653333,
		"y": 43.530185886,
		"h": 3.2087912088
	},
	{
		"stop_id": 8588696,
		"ID": 904,
		"x": 21.0627665723,
		"y": 43.645190597,
		"h": 3.2087912088
	},
	{
		"stop_id": 8588710,
		"ID": 904,
		"x": 16.6777742273,
		"y": 43.390214517,
		"h": 3.2087912088
	},
	{
		"stop_id": 8589237,
		"ID": 904,
		"x": 16.3177326213,
		"y": 43.440191764,
		"h": 3.2087912088
	},
	{
		"stop_id": 8591837,
		"ID": 904,
		"x": 17.3777643453,
		"y": 44.730140747,
		"h": 3.2087912088
	},
	{
		"stop_id": 8593407,
		"ID": 904,
		"x": 20.7327169213,
		"y": 44.255243105,
		"h": 3.2087912088
	},
	{
		"stop_id": 8593411,
		"ID": 904,
		"x": 17.3777248983,
		"y": 43.330202126,
		"h": 3.2087912088
	},
	{
		"stop_id": 8593413,
		"ID": 904,
		"x": 18.3977708083,
		"y": 43.650164871,
		"h": 3.2087912088
	},
	{
		"stop_id": 8593414,
		"ID": 904,
		"x": 17.2577748433,
		"y": 44.930165758,
		"h": 3.2087912088
	},
	{
		"stop_id": 8593415,
		"ID": 904,
		"x": 17.0577692333,
		"y": 43.310162992,
		"h": 3.2087912088
	},
	{
		"stop_id": 8593416,
		"ID": 904,
		"x": 18.7527278743,
		"y": 44.250239345,
		"h": 3.2087912088
	},
	{
		"stop_id": 8593417,
		"ID": 904,
		"x": 17.6877029903,
		"y": 43.930183867,
		"h": 3.2087912088
	},
	{
		"stop_id": 8593420,
		"ID": 904,
		"x": 17.6277400743,
		"y": 44.245170906,
		"h": 3.2087912088
	},
	{
		"stop_id": 8593421,
		"ID": 904,
		"x": 19.0377275453,
		"y": 44.330170208,
		"h": 3.2087912088
	},
	{
		"stop_id": 8593423,
		"ID": 904,
		"x": 16.8967734063,
		"y": 42.196234689,
		"h": 3.2087912088
	},
	{
		"stop_id": 8593424,
		"ID": 904,
		"x": 16.7877482483,
		"y": 41.830144544,
		"h": 3.2087912088
	},
	{
		"stop_id": 8593425,
		"ID": 904,
		"x": 16.5577626423,
		"y": 41.150186594,
		"h": 3.2087912088
	},
	{
		"stop_id": 8593435,
		"ID": 904,
		"x": 19.2827442043,
		"y": 45.245148327,
		"h": 3.2087912088
	},
	{
		"stop_id": 8593436,
		"ID": 904,
		"x": 19.8227083373,
		"y": 44.690190238,
		"h": 3.2087912088
	},
	{
		"stop_id": 8593437,
		"ID": 904,
		"x": 19.6577555643,
		"y": 44.925146062,
		"h": 3.2087912088
	},
	{
		"stop_id": 8593443,
		"ID": 904,
		"x": 21.5977122843,
		"y": 42.870174389,
		"h": 3.2087912088
	},
	{
		"stop_id": 8593457,
		"ID": 904,
		"x": 20.0977677933,
		"y": 43.430244586,
		"h": 3.2087912088
	},
	{
		"stop_id": 8593458,
		"ID": 904,
		"x": 20.2277142373,
		"y": 43.790232239,
		"h": 3.2087912088
	},
	{
		"stop_id": 8593462,
		"ID": 904,
		"x": 20.8977259683,
		"y": 43.260247303,
		"h": 3.2087912088
	},
	{
		"stop_id": 8594340,
		"ID": 904,
		"x": 17.1577381103,
		"y": 42.995243425,
		"h": 3.2087912088
	},
	{
		"stop_id": 8595086,
		"ID": 904,
		"x": 19.0577190613,
		"y": 45.155214327,
		"h": 3.2087912088
	},
	{
		"stop_id": 8595087,
		"ID": 904,
		"x": 19.2277227793,
		"y": 44.760200964,
		"h": 3.2087912088
	},
	{
		"stop_id": 8595088,
		"ID": 904,
		"x": 19.5277604193,
		"y": 44.460209595,
		"h": 3.2087912088
	},
	{
		"stop_id": 8595393,
		"ID": 904,
		"x": 19.8677566613,
		"y": 44.150205232,
		"h": 3.2087912088
	},
	{
		"stop_id": 8595394,
		"ID": 904,
		"x": 19.3177692503,
		"y": 44.195237284,
		"h": 3.2087912088
	},
	{
		"stop_id": 8502204,
		"ID": 936,
		"x": 21.8777243393,
		"y": 42.730245844,
		"h": 3.2417582418
	},
	{
		"stop_id": 8502206,
		"ID": 936,
		"x": 22.4477145543,
		"y": 45.155184954,
		"h": 3.2417582418
	},
	{
		"stop_id": 8502282,
		"ID": 936,
		"x": 24.1377147803,
		"y": 43.095245695,
		"h": 3.2417582418
	},
	{
		"stop_id": 8502296,
		"ID": 936,
		"x": 24.7177003533,
		"y": 43.420225467,
		"h": 3.2417582418
	},
	{
		"stop_id": 8502694,
		"ID": 936,
		"x": 22.9977605743,
		"y": 45.314250513,
		"h": 3.2417582418
	},
	{
		"stop_id": 8502781,
		"ID": 936,
		"x": 21.9677103593,
		"y": 42.670217492,
		"h": 3.2417582418
	},
	{
		"stop_id": 8502787,
		"ID": 936,
		"x": 22.6177051463,
		"y": 45.040234582,
		"h": 3.2417582418
	},
	{
		"stop_id": 8502788,
		"ID": 936,
		"x": 22.2527105593,
		"y": 43.990144239,
		"h": 3.2417582418
	},
	{
		"stop_id": 8502798,
		"ID": 936,
		"x": 22.4977532933,
		"y": 45.170219966,
		"h": 3.2417582418
	},
	{
		"stop_id": 8502799,
		"ID": 936,
		"x": 23.3177337393,
		"y": 45.27023396,
		"h": 3.2417582418
	},
	{
		"stop_id": 8502970,
		"ID": 936,
		"x": 23.5477339183,
		"y": 45.79025099,
		"h": 3.2417582418
	},
	{
		"stop_id": 8502971,
		"ID": 936,
		"x": 24.9077472413,
		"y": 46.950249236,
		"h": 3.2417582418
	},
	{
		"stop_id": 8502995,
		"ID": 936,
		"x": 26.4377730423,
		"y": 46.180238934,
		"h": 3.2417582418
	},
	{
		"stop_id": 8515992,
		"ID": 936,
		"x": 22.0417040293,
		"y": 44.385176459,
		"h": 3.2417582418
	},
	{
		"stop_id": 8515993,
		"ID": 936,
		"x": 21.9956994333,
		"y": 43.789249984,
		"h": 3.2417582418
	},
	{
		"stop_id": 8573187,
		"ID": 936,
		"x": 21.4537521673,
		"y": 46.760191101,
		"h": 3.2417582418
	},
	{
		"stop_id": 8573188,
		"ID": 936,
		"x": 21.9777558993,
		"y": 45.795149499,
		"h": 3.2417582418
	},
	{
		"stop_id": 8573189,
		"ID": 936,
		"x": 22.3077486963,
		"y": 45.555193571,
		"h": 3.2417582418
	},
	{
		"stop_id": 8573190,
		"ID": 936,
		"x": 22.4477699013,
		"y": 45.310180646,
		"h": 3.2417582418
	},
	{
		"stop_id": 8577531,
		"ID": 936,
		"x": 24.3777130953,
		"y": 43.290210473,
		"h": 3.2417582418
	},
	{
		"stop_id": 8577532,
		"ID": 936,
		"x": 24.4577063073,
		"y": 43.000143132,
		"h": 3.2417582418
	},
	{
		"stop_id": 8577540,
		"ID": 936,
		"x": 25.6727154983,
		"y": 43.750192477,
		"h": 3.2417582418
	},
	{
		"stop_id": 8577559,
		"ID": 936,
		"x": 22.0777171313,
		"y": 43.15016506,
		"h": 3.2417582418
	},
	{
		"stop_id": 8577560,
		"ID": 936,
		"x": 22.1577387453,
		"y": 43.560210765,
		"h": 3.2417582418
	},
	{
		"stop_id": 8577561,
		"ID": 936,
		"x": 22.3177075513,
		"y": 44.350174311,
		"h": 3.2417582418
	},
	{
		"stop_id": 8577563,
		"ID": 936,
		"x": 23.5977556183,
		"y": 45.530217073,
		"h": 3.2417582418
	},
	{
		"stop_id": 8577564,
		"ID": 936,
		"x": 25.3777491263,
		"y": 47.170220408,
		"h": 3.2417582418
	},
	{
		"stop_id": 8577569,
		"ID": 936,
		"x": 26.2777509843,
		"y": 45.650221391,
		"h": 3.2417582418
	},
	{
		"stop_id": 8577570,
		"ID": 936,
		"x": 26.0277676063,
		"y": 45.470154154,
		"h": 3.2417582418
	},
	{
		"stop_id": 8581534,
		"ID": 936,
		"x": 22.6717214533,
		"y": 45.140161977,
		"h": 3.2417582418
	},
	{
		"stop_id": 8587257,
		"ID": 936,
		"x": 22.2577152613,
		"y": 43.330208791,
		"h": 3.2417582418
	},
	{
		"stop_id": 8587279,
		"ID": 936,
		"x": 22.3127571753,
		"y": 43.555231424,
		"h": 3.2417582418
	},
	{
		"stop_id": 8587280,
		"ID": 936,
		"x": 22.7177443463,
		"y": 43.690142713,
		"h": 3.2417582418
	},
	{
		"stop_id": 8587323,
		"ID": 936,
		"x": 21.8177426973,
		"y": 45.87022739,
		"h": 3.2417582418
	},
	{
		"stop_id": 8587326,
		"ID": 936,
		"x": 23.0977605683,
		"y": 44.000187128,
		"h": 3.2417582418
	},
	{
		"stop_id": 8587374,
		"ID": 936,
		"x": 22.1477355663,
		"y": 45.090226768,
		"h": 3.2417582418
	},
	{
		"stop_id": 8587514,
		"ID": 936,
		"x": 21.8577027603,
		"y": 42.830150122,
		"h": 3.2417582418
	},
	{
		"stop_id": 8587719,
		"ID": 936,
		"x": 23.4157635453,
		"y": 43.614247339,
		"h": 3.2417582418
	},
	{
		"stop_id": 8587723,
		"ID": 936,
		"x": 23.4877071883,
		"y": 44.670197545,
		"h": 3.2417582418
	},
	{
		"stop_id": 8587724,
		"ID": 936,
		"x": 21.5327118423,
		"y": 43.510164516,
		"h": 3.2417582418
	},
	{
		"stop_id": 8588245,
		"ID": 936,
		"x": 25.3927231963,
		"y": 46.135160502,
		"h": 3.2417582418
	},
	{
		"stop_id": 8588695,
		"ID": 936,
		"x": 21.2877667103,
		"y": 43.700175763,
		"h": 3.2417582418
	},
	{
		"stop_id": 8588700,
		"ID": 936,
		"x": 22.9577731273,
		"y": 42.990218703,
		"h": 3.2417582418
	},
	{
		"stop_id": 8588701,
		"ID": 936,
		"x": 22.4127423013,
		"y": 42.990226728,
		"h": 3.2417582418
	},
	{
		"stop_id": 8588702,
		"ID": 936,
		"x": 23.1477000473,
		"y": 43.370230468,
		"h": 3.2417582418
	},
	{
		"stop_id": 8588718,
		"ID": 936,
		"x": 23.5477490683,
		"y": 45.340164013,
		"h": 3.2417582418
	},
	{
		"stop_id": 8589202,
		"ID": 936,
		"x": 22.9577078433,
		"y": 44.870167265,
		"h": 3.2417582418
	},
	{
		"stop_id": 8589204,
		"ID": 936,
		"x": 22.4697630433,
		"y": 44.958243773,
		"h": 3.2417582418
	},
	{
		"stop_id": 8589488,
		"ID": 936,
		"x": 23.2377475933,
		"y": 44.990148087,
		"h": 3.2417582418
	},
	{
		"stop_id": 8589870,
		"ID": 936,
		"x": 21.6927359583,
		"y": 43.455203452,
		"h": 3.2417582418
	},
	{
		"stop_id": 8591838,
		"ID": 936,
		"x": 22.6777062793,
		"y": 42.810211829,
		"h": 3.2417582418
	},
	{
		"stop_id": 8591898,
		"ID": 936,
		"x": 21.6777445173,
		"y": 43.210165536,
		"h": 3.2417582418
	},
	{
		"stop_id": 8593396,
		"ID": 936,
		"x": 22.0777549683,
		"y": 44.690213292,
		"h": 3.2417582418
	},
	{
		"stop_id": 8593397,
		"ID": 936,
		"x": 25.7527485663,
		"y": 47.335157997,
		"h": 3.2417582418
	},
	{
		"stop_id": 8593398,
		"ID": 936,
		"x": 22.8577404873,
		"y": 45.170206382,
		"h": 3.2417582418
	},
	{
		"stop_id": 8593399,
		"ID": 936,
		"x": 23.0877295503,
		"y": 45.150167566,
		"h": 3.2417582418
	},
	{
		"stop_id": 8593400,
		"ID": 936,
		"x": 22.3577530613,
		"y": 45.490172178,
		"h": 3.2417582418
	},
	{
		"stop_id": 8593401,
		"ID": 936,
		"x": 24.1077221353,
		"y": 43.550245286,
		"h": 3.2417582418
	},
	{
		"stop_id": 8593402,
		"ID": 936,
		"x": 22.2577480243,
		"y": 44.790203557,
		"h": 3.2417582418
	},
	{
		"stop_id": 8593403,
		"ID": 936,
		"x": 21.7627355793,
		"y": 44.620175842,
		"h": 3.2417582418
	},
	{
		"stop_id": 8593404,
		"ID": 936,
		"x": 23.7177268983,
		"y": 43.850190949,
		"h": 3.2417582418
	},
	{
		"stop_id": 8593405,
		"ID": 936,
		"x": 21.0577477523,
		"y": 44.55018084,
		"h": 3.2417582418
	},
	{
		"stop_id": 8593406,
		"ID": 936,
		"x": 21.9177085403,
		"y": 44.390143742,
		"h": 3.2417582418
	},
	{
		"stop_id": 8593408,
		"ID": 936,
		"x": 22.4177215173,
		"y": 44.83021528,
		"h": 3.2417582418
	},
	{
		"stop_id": 8593409,
		"ID": 936,
		"x": 23.1877385383,
		"y": 43.690228658,
		"h": 3.2417582418
	},
	{
		"stop_id": 8593410,
		"ID": 936,
		"x": 23.4177373823,
		"y": 43.950171051,
		"h": 3.2417582418
	},
	{
		"stop_id": 8593427,
		"ID": 936,
		"x": 26.2427503053,
		"y": 45.77524668,
		"h": 3.2417582418
	},
	{
		"stop_id": 8593445,
		"ID": 936,
		"x": 22.1827343653,
		"y": 42.945248291,
		"h": 3.2417582418
	},
	{
		"stop_id": 8593448,
		"ID": 936,
		"x": 22.4727359783,
		"y": 43.800161408,
		"h": 3.2417582418
	},
	{
		"stop_id": 8502205,
		"ID": 934,
		"x": 22.1157620683,
		"y": 34.401166679,
		"h": 1.8571428571
	},
	{
		"stop_id": 8502258,
		"ID": 934,
		"x": 21.7777413443,
		"y": 34.507159834,
		"h": 1.8571428571
	},
	{
		"stop_id": 8502988,
		"ID": 934,
		"x": 22.1087625143,
		"y": 34.391175078,
		"h": 1.8571428571
	},
	{
		"stop_id": 8517112,
		"ID": 934,
		"x": 21.1977417483,
		"y": 35.470224115,
		"h": 1.8571428571
	},
	{
		"stop_id": 8577411,
		"ID": 934,
		"x": 22.9677463053,
		"y": 31.170243509,
		"h": 1.8571428571
	},
	{
		"stop_id": 8577412,
		"ID": 934,
		"x": 23.0177418413,
		"y": 31.410205573,
		"h": 1.8571428571
	},
	{
		"stop_id": 8577413,
		"ID": 934,
		"x": 22.6177738523,
		"y": 32.61023413,
		"h": 1.8571428571
	},
	{
		"stop_id": 8577414,
		"ID": 934,
		"x": 22.5377313633,
		"y": 33.440230965,
		"h": 1.8571428571
	},
	{
		"stop_id": 8577416,
		"ID": 934,
		"x": 22.0727762003,
		"y": 34.120168945,
		"h": 1.8571428571
	},
	{
		"stop_id": 8577417,
		"ID": 934,
		"x": 21.8177245503,
		"y": 34.570192803,
		"h": 1.8571428571
	},
	{
		"stop_id": 8577552,
		"ID": 934,
		"x": 21.1877707653,
		"y": 35.405156873,
		"h": 1.8571428571
	},
	{
		"stop_id": 8577553,
		"ID": 934,
		"x": 21.5927038053,
		"y": 34.875208167,
		"h": 1.8571428571
	},
	{
		"stop_id": 8577554,
		"ID": 934,
		"x": 21.8177413473,
		"y": 34.480244814,
		"h": 1.8571428571
	},
	{
		"stop_id": 8577556,
		"ID": 934,
		"x": 22.4277244573,
		"y": 33.730238239,
		"h": 1.8571428571
	},
	{
		"stop_id": 8595332,
		"ID": 934,
		"x": 22.1377424443,
		"y": 34.470180793,
		"h": 1.8571428571
	},
	{
		"stop_id": 8595333,
		"ID": 934,
		"x": 22.2677108523,
		"y": 34.355224922,
		"h": 1.8571428571
	},
	{
		"stop_id": 8595334,
		"ID": 934,
		"x": 22.4077010103,
		"y": 34.290220715,
		"h": 1.8571428571
	},
	{
		"stop_id": 8595335,
		"ID": 934,
		"x": 22.5577437813,
		"y": 34.300185861,
		"h": 1.8571428571
	},
	{
		"stop_id": 8595336,
		"ID": 934,
		"x": 22.4277272223,
		"y": 34.550224099,
		"h": 1.8571428571
	},
	{
		"stop_id": 8595337,
		"ID": 934,
		"x": 22.2577362163,
		"y": 34.870205774,
		"h": 1.8571428571
	},
	{
		"stop_id": 8595338,
		"ID": 934,
		"x": 22.0277743653,
		"y": 34.8651543,
		"h": 1.8571428571
	},
	{
		"stop_id": 8595339,
		"ID": 934,
		"x": 21.8877470213,
		"y": 35.150201059,
		"h": 1.8571428571
	},
	{
		"stop_id": 8595340,
		"ID": 934,
		"x": 21.8077554063,
		"y": 34.910169688,
		"h": 1.8571428571
	},
	{
		"stop_id": 8595341,
		"ID": 934,
		"x": 21.8827498063,
		"y": 34.800234739,
		"h": 1.8571428571
	},
	{
		"stop_id": 8595342,
		"ID": 934,
		"x": 22.5277059543,
		"y": 34.100194665,
		"h": 1.8571428571
	},
	{
		"stop_id": 8595343,
		"ID": 934,
		"x": 22.0477136563,
		"y": 34.690201183,
		"h": 1.8571428571
	},
	{
		"stop_id": 8595497,
		"ID": 934,
		"x": 21.8777323013,
		"y": 35.000186989,
		"h": 1.8571428571
	},
	{
		"stop_id": 8502207,
		"ID": 970,
		"x": 26.4537320653,
		"y": 50.000145,
		"h": 2.1868131868
	},
	{
		"stop_id": 8502972,
		"ID": 970,
		"x": 26.4877441063,
		"y": 47.640203654,
		"h": 2.1868131868
	},
	{
		"stop_id": 8503752,
		"ID": 970,
		"x": 29.0667115433,
		"y": 47.561209264,
		"h": 2.1868131868
	},
	{
		"stop_id": 8503754,
		"ID": 970,
		"x": 27.3467186473,
		"y": 50.944160697,
		"h": 2.1868131868
	},
	{
		"stop_id": 8503863,
		"ID": 970,
		"x": 29.1277055263,
		"y": 49.237195021,
		"h": 2.1868131868
	},
	{
		"stop_id": 8503867,
		"ID": 970,
		"x": 29.0337122693,
		"y": 48.71019522,
		"h": 2.1868131868
	},
	{
		"stop_id": 8503892,
		"ID": 970,
		"x": 29.3977121923,
		"y": 50.00422668,
		"h": 2.1868131868
	},
	{
		"stop_id": 8503897,
		"ID": 970,
		"x": 29.9407704033,
		"y": 46.379156898,
		"h": 2.1868131868
	},
	{
		"stop_id": 8503899,
		"ID": 970,
		"x": 28.8067544463,
		"y": 50.780169664,
		"h": 2.1868131868
	},
	{
		"stop_id": 8503972,
		"ID": 970,
		"x": 28.5497543653,
		"y": 48.554212872,
		"h": 2.1868131868
	},
	{
		"stop_id": 8503990,
		"ID": 970,
		"x": 30.8057678453,
		"y": 49.350149199,
		"h": 2.1868131868
	},
	{
		"stop_id": 8573557,
		"ID": 970,
		"x": 28.2327311143,
		"y": 50.980233328,
		"h": 2.1868131868
	},
	{
		"stop_id": 8573558,
		"ID": 970,
		"x": 27.7117514193,
		"y": 50.542234755,
		"h": 2.1868131868
	},
	{
		"stop_id": 8573559,
		"ID": 970,
		"x": 27.9387498833,
		"y": 50.276167585,
		"h": 2.1868131868
	},
	{
		"stop_id": 8573560,
		"ID": 970,
		"x": 28.1327129623,
		"y": 49.311236849,
		"h": 2.1868131868
	},
	{
		"stop_id": 8573561,
		"ID": 970,
		"x": 28.2927136003,
		"y": 49.037187629,
		"h": 2.1868131868
	},
	{
		"stop_id": 8573563,
		"ID": 970,
		"x": 28.7127644643,
		"y": 47.663228768,
		"h": 2.1868131868
	},
	{
		"stop_id": 8573564,
		"ID": 970,
		"x": 28.7497133913,
		"y": 47.354227396,
		"h": 2.1868131868
	},
	{
		"stop_id": 8573565,
		"ID": 970,
		"x": 29.6847661523,
		"y": 46.986175184,
		"h": 2.1868131868
	},
	{
		"stop_id": 8573566,
		"ID": 970,
		"x": 29.9947165733,
		"y": 45.817241352,
		"h": 2.1868131868
	},
	{
		"stop_id": 8573572,
		"ID": 970,
		"x": 31.2637443833,
		"y": 49.177240018,
		"h": 2.1868131868
	},
	{
		"stop_id": 8573573,
		"ID": 970,
		"x": 30.9277458543,
		"y": 49.769196497,
		"h": 2.1868131868
	},
	{
		"stop_id": 8573581,
		"ID": 970,
		"x": 30.1327578203,
		"y": 48.630203548,
		"h": 2.1868131868
	},
	{
		"stop_id": 8573582,
		"ID": 970,
		"x": 30.6577065163,
		"y": 48.105231867,
		"h": 2.1868131868
	},
	{
		"stop_id": 8573583,
		"ID": 970,
		"x": 30.8077248813,
		"y": 47.780172076,
		"h": 2.1868131868
	},
	{
		"stop_id": 8573584,
		"ID": 970,
		"x": 31.3577695843,
		"y": 47.480247749,
		"h": 2.1868131868
	},
	{
		"stop_id": 8577566,
		"ID": 970,
		"x": 26.1177122643,
		"y": 47.480183044,
		"h": 2.1868131868
	},
	{
		"stop_id": 8577567,
		"ID": 970,
		"x": 27.1827349243,
		"y": 46.490182628,
		"h": 2.1868131868
	},
	{
		"stop_id": 8577568,
		"ID": 970,
		"x": 26.7977248663,
		"y": 46.210151747,
		"h": 2.1868131868
	},
	{
		"stop_id": 8581674,
		"ID": 970,
		"x": 28.0577736153,
		"y": 49.580208927,
		"h": 2.1868131868
	},
	{
		"stop_id": 8588416,
		"ID": 970,
		"x": 28.9737288483,
		"y": 50.718170671,
		"h": 2.1868131868
	},
	{
		"stop_id": 8588987,
		"ID": 970,
		"x": 28.5677429763,
		"y": 51.160218135,
		"h": 2.1868131868
	},
	{
		"stop_id": 8590662,
		"ID": 970,
		"x": 29.7477543913,
		"y": 49.439194134,
		"h": 2.1868131868
	},
	{
		"stop_id": 8593250,
		"ID": 970,
		"x": 29.4827493823,
		"y": 50.085226685,
		"h": 2.1868131868
	},
	{
		"stop_id": 8595330,
		"ID": 970,
		"x": 26.4577666233,
		"y": 50.035228223,
		"h": 2.1868131868
	},
	{
		"stop_id": 8595405,
		"ID": 970,
		"x": 29.9377370103,
		"y": 49.055227883,
		"h": 2.1868131868
	},
	{
		"stop_id": 8595520,
		"ID": 970,
		"x": 30.9277076153,
		"y": 49.712155115,
		"h": 2.1868131868
	},
	{
		"stop_id": 8502208,
		"ID": 971,
		"x": 27.3867309993,
		"y": 52.273247526,
		"h": 4.1648351648
	},
	{
		"stop_id": 8502209,
		"ID": 971,
		"x": 26.4367525153,
		"y": 54.258143992,
		"h": 4.1648351648
	},
	{
		"stop_id": 8503103,
		"ID": 971,
		"x": 29.0827363313,
		"y": 54.864220122,
		"h": 4.1648351648
	},
	{
		"stop_id": 8503104,
		"ID": 971,
		"x": 31.4917739623,
		"y": 53.565230143,
		"h": 4.1648351648
	},
	{
		"stop_id": 8503111,
		"ID": 971,
		"x": 28.0177417313,
		"y": 56.558170745,
		"h": 4.1648351648
	},
	{
		"stop_id": 8503203,
		"ID": 971,
		"x": 26.4937209143,
		"y": 54.587206166,
		"h": 4.1648351648
	},
	{
		"stop_id": 8503204,
		"ID": 971,
		"x": 27.9197330943,
		"y": 52.585197441,
		"h": 4.1648351648
	},
	{
		"stop_id": 8503660,
		"ID": 971,
		"x": 28.8577297053,
		"y": 55.045212947,
		"h": 4.1648351648
	},
	{
		"stop_id": 8503661,
		"ID": 971,
		"x": 31.1957642723,
		"y": 53.309173222,
		"h": 4.1648351648
	},
	{
		"stop_id": 8503672,
		"ID": 971,
		"x": 27.9707556923,
		"y": 52.682241916,
		"h": 4.1648351648
	},
	{
		"stop_id": 8503673,
		"ID": 971,
		"x": 26.7587681483,
		"y": 54.474200784,
		"h": 4.1648351648
	},
	{
		"stop_id": 8503855,
		"ID": 971,
		"x": 27.9247219943,
		"y": 52.606174918,
		"h": 4.1648351648
	},
	{
		"stop_id": 8503896,
		"ID": 971,
		"x": 27.1527546593,
		"y": 51.600232078,
		"h": 4.1648351648
	},
	{
		"stop_id": 8503898,
		"ID": 971,
		"x": 27.9967386443,
		"y": 51.333218609,
		"h": 4.1648351648
	},
	{
		"stop_id": 8530643,
		"ID": 971,
		"x": 28.5087485993,
		"y": 52.343186666,
		"h": 4.1648351648
	},
	{
		"stop_id": 8530644,
		"ID": 971,
		"x": 31.0547542723,
		"y": 53.35416046,
		"h": 4.1648351648
	},
	{
		"stop_id": 8573552,
		"ID": 971,
		"x": 27.8257128073,
		"y": 52.447157102,
		"h": 4.1648351648
	},
	{
		"stop_id": 8573553,
		"ID": 971,
		"x": 27.3157682343,
		"y": 52.580204145,
		"h": 4.1648351648
	},
	{
		"stop_id": 8573554,
		"ID": 971,
		"x": 27.4207473003,
		"y": 52.266185745,
		"h": 4.1648351648
	},
	{
		"stop_id": 8573555,
		"ID": 971,
		"x": 27.6467346273,
		"y": 52.156203866,
		"h": 4.1648351648
	},
	{
		"stop_id": 8573556,
		"ID": 971,
		"x": 27.9217544253,
		"y": 51.607196159,
		"h": 4.1648351648
	},
	{
		"stop_id": 8576080,
		"ID": 971,
		"x": 31.5367546153,
		"y": 53.524224564,
		"h": 4.1648351648
	},
	{
		"stop_id": 8577867,
		"ID": 971,
		"x": 28.5847184563,
		"y": 51.780246126,
		"h": 4.1648351648
	},
	{
		"stop_id": 8577912,
		"ID": 971,
		"x": 28.0137141343,
		"y": 52.3311808,
		"h": 4.1648351648
	},
	{
		"stop_id": 8579186,
		"ID": 971,
		"x": 26.5477622073,
		"y": 54.560193758,
		"h": 4.1648351648
	},
	{
		"stop_id": 8579188,
		"ID": 971,
		"x": 26.8577113263,
		"y": 53.89022412,
		"h": 4.1648351648
	},
	{
		"stop_id": 8579189,
		"ID": 971,
		"x": 27.1476997113,
		"y": 53.425236446,
		"h": 4.1648351648
	},
	{
		"stop_id": 8579190,
		"ID": 971,
		"x": 27.2427386423,
		"y": 53.013221479,
		"h": 4.1648351648
	},
	{
		"stop_id": 8579192,
		"ID": 971,
		"x": 27.3207105423,
		"y": 52.785200579,
		"h": 4.1648351648
	},
	{
		"stop_id": 8580724,
		"ID": 971,
		"x": 28.1347326923,
		"y": 52.31217771,
		"h": 4.1648351648
	},
	{
		"stop_id": 8587967,
		"ID": 971,
		"x": 28.3957444943,
		"y": 56.384198109,
		"h": 4.1648351648
	},
	{
		"stop_id": 8587972,
		"ID": 971,
		"x": 28.5797415043,
		"y": 56.550163267,
		"h": 4.1648351648
	},
	{
		"stop_id": 8587975,
		"ID": 971,
		"x": 28.7517524163,
		"y": 56.535157509,
		"h": 4.1648351648
	},
	{
		"stop_id": 8587977,
		"ID": 971,
		"x": 28.2577170723,
		"y": 56.775212741,
		"h": 4.1648351648
	},
	{
		"stop_id": 8587981,
		"ID": 971,
		"x": 29.9287709703,
		"y": 54.918192452,
		"h": 4.1648351648
	},
	{
		"stop_id": 8587982,
		"ID": 971,
		"x": 29.3357175283,
		"y": 54.514199543,
		"h": 4.1648351648
	},
	{
		"stop_id": 8587983,
		"ID": 971,
		"x": 29.8657622673,
		"y": 54.285227471,
		"h": 4.1648351648
	},
	{
		"stop_id": 8587984,
		"ID": 971,
		"x": 30.0777525733,
		"y": 54.163229322,
		"h": 4.1648351648
	},
	{
		"stop_id": 8587992,
		"ID": 971,
		"x": 29.2517190433,
		"y": 55.448172327,
		"h": 4.1648351648
	},
	{
		"stop_id": 8587993,
		"ID": 971,
		"x": 29.4257712033,
		"y": 55.662160218,
		"h": 4.1648351648
	},
	{
		"stop_id": 8587994,
		"ID": 971,
		"x": 29.1847747223,
		"y": 56.26020368,
		"h": 4.1648351648
	},
	{
		"stop_id": 8587996,
		"ID": 971,
		"x": 29.7227055133,
		"y": 55.452250681,
		"h": 4.1648351648
	},
	{
		"stop_id": 8587997,
		"ID": 971,
		"x": 29.1037295693,
		"y": 56.378187583,
		"h": 4.1648351648
	},
	{
		"stop_id": 8587998,
		"ID": 971,
		"x": 29.0657418733,
		"y": 55.302171888,
		"h": 4.1648351648
	},
	{
		"stop_id": 8587999,
		"ID": 971,
		"x": 29.4527014313,
		"y": 55.350227063,
		"h": 4.1648351648
	},
	{
		"stop_id": 8588000,
		"ID": 971,
		"x": 28.5497297683,
		"y": 55.786162917,
		"h": 4.1648351648
	},
	{
		"stop_id": 8588001,
		"ID": 971,
		"x": 29.4757392893,
		"y": 55.41317428,
		"h": 4.1648351648
	},
	{
		"stop_id": 8588002,
		"ID": 971,
		"x": 28.7307575063,
		"y": 56.147229676,
		"h": 4.1648351648
	},
	{
		"stop_id": 8588003,
		"ID": 971,
		"x": 29.6867443723,
		"y": 55.087221983,
		"h": 4.1648351648
	},
	{
		"stop_id": 8588005,
		"ID": 971,
		"x": 28.7857706043,
		"y": 55.446207966,
		"h": 4.1648351648
	},
	{
		"stop_id": 8588006,
		"ID": 971,
		"x": 30.0447078573,
		"y": 55.427202366,
		"h": 4.1648351648
	},
	{
		"stop_id": 8588007,
		"ID": 971,
		"x": 29.1067697423,
		"y": 55.61923748,
		"h": 4.1648351648
	},
	{
		"stop_id": 8588008,
		"ID": 971,
		"x": 28.9947594063,
		"y": 56.072224976,
		"h": 4.1648351648
	},
	{
		"stop_id": 8588009,
		"ID": 971,
		"x": 29.2987099523,
		"y": 55.856172689,
		"h": 4.1648351648
	},
	{
		"stop_id": 8588010,
		"ID": 971,
		"x": 28.8427249733,
		"y": 55.731152432,
		"h": 4.1648351648
	},
	{
		"stop_id": 8588011,
		"ID": 971,
		"x": 29.0887126553,
		"y": 54.854191124,
		"h": 4.1648351648
	},
	{
		"stop_id": 8588023,
		"ID": 971,
		"x": 31.5677234673,
		"y": 53.843154356,
		"h": 4.1648351648
	},
	{
		"stop_id": 8588028,
		"ID": 971,
		"x": 31.0597727083,
		"y": 53.590185983,
		"h": 4.1648351648
	},
	{
		"stop_id": 8588029,
		"ID": 971,
		"x": 30.0477535713,
		"y": 54.020227914,
		"h": 4.1648351648
	},
	{
		"stop_id": 8588030,
		"ID": 971,
		"x": 29.5767543963,
		"y": 54.492247257,
		"h": 4.1648351648
	},
	{
		"stop_id": 8588032,
		"ID": 971,
		"x": 29.5367204883,
		"y": 54.92017751,
		"h": 4.1648351648
	},
	{
		"stop_id": 8588984,
		"ID": 971,
		"x": 28.2767090243,
		"y": 51.548177805,
		"h": 4.1648351648
	},
	{
		"stop_id": 8588985,
		"ID": 971,
		"x": 28.0077215003,
		"y": 51.84018636,
		"h": 4.1648351648
	},
	{
		"stop_id": 8588986,
		"ID": 971,
		"x": 28.7927558283,
		"y": 51.333244424,
		"h": 4.1648351648
	},
	{
		"stop_id": 8589108,
		"ID": 971,
		"x": 26.8127119823,
		"y": 53.426236814,
		"h": 4.1648351648
	},
	{
		"stop_id": 8589109,
		"ID": 971,
		"x": 27.0887444413,
		"y": 52.928241929,
		"h": 4.1648351648
	},
	{
		"stop_id": 8589110,
		"ID": 971,
		"x": 26.9677448593,
		"y": 53.206228983,
		"h": 4.1648351648
	},
	{
		"stop_id": 8589111,
		"ID": 971,
		"x": 27.5727197003,
		"y": 52.510146188,
		"h": 4.1648351648
	},
	{
		"stop_id": 8590641,
		"ID": 971,
		"x": 28.8997051033,
		"y": 55.877219579,
		"h": 4.1648351648
	},
	{
		"stop_id": 8590642,
		"ID": 971,
		"x": 30.0217740523,
		"y": 56.518205998,
		"h": 4.1648351648
	},
	{
		"stop_id": 8590643,
		"ID": 971,
		"x": 29.3607100963,
		"y": 55.440245015,
		"h": 4.1648351648
	},
	{
		"stop_id": 8590644,
		"ID": 971,
		"x": 28.6397682993,
		"y": 56.085163239,
		"h": 4.1648351648
	},
	{
		"stop_id": 8590645,
		"ID": 971,
		"x": 29.2237217783,
		"y": 55.640225548,
		"h": 4.1648351648
	},
	{
		"stop_id": 8590646,
		"ID": 971,
		"x": 30.4277124583,
		"y": 56.31720889,
		"h": 4.1648351648
	},
	{
		"stop_id": 8590647,
		"ID": 971,
		"x": 29.0107017713,
		"y": 54.940198377,
		"h": 4.1648351648
	},
	{
		"stop_id": 8590650,
		"ID": 971,
		"x": 26.9907410313,
		"y": 52.611140191,
		"h": 4.1648351648
	},
	{
		"stop_id": 8590651,
		"ID": 971,
		"x": 28.0817572633,
		"y": 52.434148422,
		"h": 4.1648351648
	},
	{
		"stop_id": 8590652,
		"ID": 971,
		"x": 28.8667271643,
		"y": 51.820250241,
		"h": 4.1648351648
	},
	{
		"stop_id": 8590653,
		"ID": 971,
		"x": 29.3667409793,
		"y": 51.826174655,
		"h": 4.1648351648
	},
	{
		"stop_id": 8590654,
		"ID": 971,
		"x": 30.2357096813,
		"y": 51.469232677,
		"h": 4.1648351648
	},
	{
		"stop_id": 8590655,
		"ID": 971,
		"x": 27.1807229213,
		"y": 52.203180946,
		"h": 4.1648351648
	},
	{
		"stop_id": 8590656,
		"ID": 971,
		"x": 29.6367508473,
		"y": 51.702251358,
		"h": 4.1648351648
	},
	{
		"stop_id": 8590657,
		"ID": 971,
		"x": 29.5267230333,
		"y": 51.452196443,
		"h": 4.1648351648
	},
	{
		"stop_id": 8590658,
		"ID": 971,
		"x": 28.7987588783,
		"y": 52.073195994,
		"h": 4.1648351648
	},
	{
		"stop_id": 8590659,
		"ID": 971,
		"x": 28.3457732153,
		"y": 52.348216762,
		"h": 4.1648351648
	},
	{
		"stop_id": 8590660,
		"ID": 971,
		"x": 27.9617064373,
		"y": 52.48518973,
		"h": 4.1648351648
	},
	{
		"stop_id": 8590661,
		"ID": 971,
		"x": 28.5467342903,
		"y": 52.013181519,
		"h": 4.1648351648
	},
	{
		"stop_id": 8590663,
		"ID": 971,
		"x": 28.3377458303,
		"y": 52.042212404,
		"h": 4.1648351648
	},
	{
		"stop_id": 8590665,
		"ID": 971,
		"x": 26.5037416923,
		"y": 52.386225794,
		"h": 4.1648351648
	},
	{
		"stop_id": 8590734,
		"ID": 971,
		"x": 26.4387172023,
		"y": 54.279187542,
		"h": 4.1648351648
	},
	{
		"stop_id": 8590735,
		"ID": 971,
		"x": 26.2047249963,
		"y": 54.557218857,
		"h": 4.1648351648
	},
	{
		"stop_id": 8590736,
		"ID": 971,
		"x": 26.6337457933,
		"y": 53.87717677,
		"h": 4.1648351648
	},
	{
		"stop_id": 8590819,
		"ID": 971,
		"x": 26.0777627633,
		"y": 54.860155701,
		"h": 4.1648351648
	},
	{
		"stop_id": 8590820,
		"ID": 971,
		"x": 25.9357570243,
		"y": 55.210245417,
		"h": 4.1648351648
	},
	{
		"stop_id": 8594182,
		"ID": 971,
		"x": 27.4677605253,
		"y": 52.745217176,
		"h": 4.1648351648
	},
	{
		"stop_id": 8595412,
		"ID": 971,
		"x": 29.0977153343,
		"y": 51.895196614,
		"h": 4.1648351648
	},
	{
		"stop_id": 8595723,
		"ID": 971,
		"x": 29.0287009343,
		"y": 54.971156389,
		"h": 4.1648351648
	},
	{
		"stop_id": 8502213,
		"ID": 829,
		"x": 3.0607617153,
		"y": 61.941159178,
		"h": 3.9340659341
	},
	{
		"stop_id": 8502269,
		"ID": 829,
		"x": 6.3067706613,
		"y": 62.102175146,
		"h": 3.9340659341
	},
	{
		"stop_id": 8502271,
		"ID": 829,
		"x": 4.3077676433,
		"y": 61.780153096,
		"h": 3.9340659341
	},
	{
		"stop_id": 8502701,
		"ID": 829,
		"x": 3.6007661453,
		"y": 62.641157557,
		"h": 3.9340659341
	},
	{
		"stop_id": 8502702,
		"ID": 829,
		"x": 3.6167048253,
		"y": 62.31621505,
		"h": 3.9340659341
	},
	{
		"stop_id": 8502751,
		"ID": 829,
		"x": 5.9407385823,
		"y": 64.461196689,
		"h": 3.9340659341
	},
	{
		"stop_id": 8502755,
		"ID": 829,
		"x": 4.9357036443,
		"y": 65.219238023,
		"h": 3.9340659341
	},
	{
		"stop_id": 8502889,
		"ID": 829,
		"x": 3.0777570163,
		"y": 61.963243091,
		"h": 3.9340659341
	},
	{
		"stop_id": 8502968,
		"ID": 829,
		"x": 5.6437417743,
		"y": 64.789144628,
		"h": 3.9340659341
	},
	{
		"stop_id": 8502999,
		"ID": 829,
		"x": 3.6157455603,
		"y": 63.212155827,
		"h": 3.9340659341
	},
	{
		"stop_id": 8572544,
		"ID": 829,
		"x": 3.1267571053,
		"y": 62.131210619,
		"h": 3.9340659341
	},
	{
		"stop_id": 8572617,
		"ID": 829,
		"x": 1.8407491333,
		"y": 64.457215408,
		"h": 3.9340659341
	},
	{
		"stop_id": 8572618,
		"ID": 829,
		"x": 2.5727599113,
		"y": 63.673206358,
		"h": 3.9340659341
	},
	{
		"stop_id": 8572619,
		"ID": 829,
		"x": 3.0227739323,
		"y": 63.23120028,
		"h": 3.9340659341
	},
	{
		"stop_id": 8572621,
		"ID": 829,
		"x": 3.2547406613,
		"y": 62.062187038,
		"h": 3.9340659341
	},
	{
		"stop_id": 8572622,
		"ID": 829,
		"x": 3.8207452633,
		"y": 61.912230139,
		"h": 3.9340659341
	},
	{
		"stop_id": 8572623,
		"ID": 829,
		"x": 4.2147297473,
		"y": 61.704208639,
		"h": 3.9340659341
	},
	{
		"stop_id": 8572624,
		"ID": 829,
		"x": 5.2567595473,
		"y": 60.553181869,
		"h": 3.9340659341
	},
	{
		"stop_id": 8572627,
		"ID": 829,
		"x": 3.6437736083,
		"y": 61.671171819,
		"h": 3.9340659341
	},
	{
		"stop_id": 8572628,
		"ID": 829,
		"x": 3.5687684643,
		"y": 61.618223799,
		"h": 3.9340659341
	},
	{
		"stop_id": 8572629,
		"ID": 829,
		"x": 3.2827156493,
		"y": 60.759146772,
		"h": 3.9340659341
	},
	{
		"stop_id": 8572630,
		"ID": 829,
		"x": 3.3997309663,
		"y": 60.019218511,
		"h": 3.9340659341
	},
	{
		"stop_id": 8579278,
		"ID": 829,
		"x": 3.5237277563,
		"y": 61.278177004,
		"h": 3.9340659341
	},
	{
		"stop_id": 8580270,
		"ID": 829,
		"x": 3.4687671033,
		"y": 62.088147285,
		"h": 3.9340659341
	},
	{
		"stop_id": 8580275,
		"ID": 829,
		"x": 4.4587216363,
		"y": 62.13224885,
		"h": 3.9340659341
	},
	{
		"stop_id": 8580276,
		"ID": 829,
		"x": 4.7567248313,
		"y": 62.037192399,
		"h": 3.9340659341
	},
	{
		"stop_id": 8580277,
		"ID": 829,
		"x": 4.7507172063,
		"y": 61.83220805,
		"h": 3.9340659341
	},
	{
		"stop_id": 8580278,
		"ID": 829,
		"x": 4.6427712423,
		"y": 61.689159725,
		"h": 3.9340659341
	},
	{
		"stop_id": 8580281,
		"ID": 829,
		"x": 4.3597245783,
		"y": 61.888232876,
		"h": 3.9340659341
	},
	{
		"stop_id": 8580282,
		"ID": 829,
		"x": 4.1577660073,
		"y": 61.955212164,
		"h": 3.9340659341
	},
	{
		"stop_id": 8580283,
		"ID": 829,
		"x": 3.6617749273,
		"y": 62.136239243,
		"h": 3.9340659341
	},
	{
		"stop_id": 8580285,
		"ID": 829,
		"x": 3.4487425323,
		"y": 62.244152403,
		"h": 3.9340659341
	},
	{
		"stop_id": 8580286,
		"ID": 829,
		"x": 3.7647447783,
		"y": 62.604218056,
		"h": 3.9340659341
	},
	{
		"stop_id": 8580287,
		"ID": 829,
		"x": 3.9337408163,
		"y": 62.670185652,
		"h": 3.9340659341
	},
	{
		"stop_id": 8580293,
		"ID": 829,
		"x": 4.0057383723,
		"y": 62.720215402,
		"h": 3.9340659341
	},
	{
		"stop_id": 8580295,
		"ID": 829,
		"x": 4.2077137733,
		"y": 62.705156001,
		"h": 3.9340659341
	},
	{
		"stop_id": 8580303,
		"ID": 829,
		"x": 3.6037481653,
		"y": 62.001193404,
		"h": 3.9340659341
	},
	{
		"stop_id": 8580305,
		"ID": 829,
		"x": 3.4547110123,
		"y": 61.088200539,
		"h": 3.9340659341
	},
	{
		"stop_id": 8580306,
		"ID": 829,
		"x": 3.3207051063,
		"y": 61.444241369,
		"h": 3.9340659341
	},
	{
		"stop_id": 8580307,
		"ID": 829,
		"x": 2.7807267203,
		"y": 63.46614021,
		"h": 3.9340659341
	},
	{
		"stop_id": 8580308,
		"ID": 829,
		"x": 3.4477078803,
		"y": 61.341188158,
		"h": 3.9340659341
	},
	{
		"stop_id": 8580312,
		"ID": 829,
		"x": 4.3077419183,
		"y": 62.489196883,
		"h": 3.9340659341
	},
	{
		"stop_id": 8580313,
		"ID": 829,
		"x": 4.3747557913,
		"y": 62.35015798,
		"h": 3.9340659341
	},
	{
		"stop_id": 8580314,
		"ID": 829,
		"x": 2.3957497493,
		"y": 62.203227833,
		"h": 3.9340659341
	},
	{
		"stop_id": 8580334,
		"ID": 829,
		"x": 2.4967445693,
		"y": 62.055184619,
		"h": 3.9340659341
	},
	{
		"stop_id": 8580341,
		"ID": 829,
		"x": 2.6247088403,
		"y": 62.016167882,
		"h": 3.9340659341
	},
	{
		"stop_id": 8580342,
		"ID": 829,
		"x": 2.0367723813,
		"y": 62.549161721,
		"h": 3.9340659341
	},
	{
		"stop_id": 8580345,
		"ID": 829,
		"x": 4.3167135773,
		"y": 62.232227631,
		"h": 3.9340659341
	},
	{
		"stop_id": 8580346,
		"ID": 829,
		"x": 3.8727340363,
		"y": 62.201208206,
		"h": 3.9340659341
	},
	{
		"stop_id": 8580347,
		"ID": 829,
		"x": 2.9017274453,
		"y": 63.733156395,
		"h": 3.9340659341
	},
	{
		"stop_id": 8580348,
		"ID": 829,
		"x": 2.6987294723,
		"y": 63.856212645,
		"h": 3.9340659341
	},
	{
		"stop_id": 8580349,
		"ID": 829,
		"x": 2.5097217283,
		"y": 64.000214827,
		"h": 3.9340659341
	},
	{
		"stop_id": 8580350,
		"ID": 829,
		"x": 2.5027486233,
		"y": 63.844144993,
		"h": 3.9340659341
	},
	{
		"stop_id": 8580351,
		"ID": 829,
		"x": 2.7157585713,
		"y": 63.351154454,
		"h": 3.9340659341
	},
	{
		"stop_id": 8580352,
		"ID": 829,
		"x": 2.8057387343,
		"y": 63.229240466,
		"h": 3.9340659341
	},
	{
		"stop_id": 8580353,
		"ID": 829,
		"x": 3.1167118253,
		"y": 63.043176146,
		"h": 3.9340659341
	},
	{
		"stop_id": 8580354,
		"ID": 829,
		"x": 3.2107169203,
		"y": 62.835140461,
		"h": 3.9340659341
	},
	{
		"stop_id": 8580355,
		"ID": 829,
		"x": 3.1177670383,
		"y": 62.694169142,
		"h": 3.9340659341
	},
	{
		"stop_id": 8580356,
		"ID": 829,
		"x": 3.0057114673,
		"y": 62.523198922,
		"h": 3.9340659341
	},
	{
		"stop_id": 8580357,
		"ID": 829,
		"x": 3.0887430483,
		"y": 62.374197221,
		"h": 3.9340659341
	},
	{
		"stop_id": 8580360,
		"ID": 829,
		"x": 4.1217260303,
		"y": 61.372201263,
		"h": 3.9340659341
	},
	{
		"stop_id": 8580362,
		"ID": 829,
		"x": 4.1267174243,
		"y": 61.512240038,
		"h": 3.9340659341
	},
	{
		"stop_id": 8580363,
		"ID": 829,
		"x": 3.9367204733,
		"y": 61.37921832,
		"h": 3.9340659341
	},
	{
		"stop_id": 8580364,
		"ID": 829,
		"x": 3.7447122053,
		"y": 61.306222471,
		"h": 3.9340659341
	},
	{
		"stop_id": 8580365,
		"ID": 829,
		"x": 3.5707324963,
		"y": 61.434229638,
		"h": 3.9340659341
	},
	{
		"stop_id": 8580367,
		"ID": 829,
		"x": 3.9217048103,
		"y": 61.757205714,
		"h": 3.9340659341
	},
	{
		"stop_id": 8580369,
		"ID": 829,
		"x": 3.7877481963,
		"y": 61.698174184,
		"h": 3.9340659341
	},
	{
		"stop_id": 8580372,
		"ID": 829,
		"x": 3.5997079103,
		"y": 61.792228932,
		"h": 3.9340659341
	},
	{
		"stop_id": 8580376,
		"ID": 829,
		"x": 3.6377694283,
		"y": 62.360248069,
		"h": 3.9340659341
	},
	{
		"stop_id": 8580377,
		"ID": 829,
		"x": 3.2747048613,
		"y": 62.985145253,
		"h": 3.9340659341
	},
	{
		"stop_id": 8580382,
		"ID": 829,
		"x": 2.4747671403,
		"y": 62.342151007,
		"h": 3.9340659341
	},
	{
		"stop_id": 8580727,
		"ID": 829,
		"x": 2.9907276993,
		"y": 63.168151247,
		"h": 3.9340659341
	},
	{
		"stop_id": 8580843,
		"ID": 829,
		"x": 3.4607385503,
		"y": 61.565147118,
		"h": 3.9340659341
	},
	{
		"stop_id": 8580889,
		"ID": 829,
		"x": 5.0367153063,
		"y": 60.776151761,
		"h": 3.9340659341
	},
	{
		"stop_id": 8580924,
		"ID": 829,
		"x": 3.5487645093,
		"y": 62.940142149,
		"h": 3.9340659341
	},
	{
		"stop_id": 8581014,
		"ID": 829,
		"x": 5.3807225523,
		"y": 64.887208596,
		"h": 3.9340659341
	},
	{
		"stop_id": 8581641,
		"ID": 829,
		"x": 3.2317588673,
		"y": 62.931207703,
		"h": 3.9340659341
	},
	{
		"stop_id": 8581882,
		"ID": 829,
		"x": 1.6977313673,
		"y": 62.455244184,
		"h": 3.9340659341
	},
	{
		"stop_id": 8581883,
		"ID": 829,
		"x": 1.6907617453,
		"y": 62.610167108,
		"h": 3.9340659341
	},
	{
		"stop_id": 8581884,
		"ID": 829,
		"x": 1.4817681713,
		"y": 62.815147798,
		"h": 3.9340659341
	},
	{
		"stop_id": 8582729,
		"ID": 829,
		"x": 2.0617022343,
		"y": 61.788233336,
		"h": 3.9340659341
	},
	{
		"stop_id": 8582730,
		"ID": 829,
		"x": 1.4847012383,
		"y": 61.55020157,
		"h": 3.9340659341
	},
	{
		"stop_id": 8582731,
		"ID": 829,
		"x": 1.1987109463,
		"y": 62.075172257,
		"h": 3.9340659341
	},
	{
		"stop_id": 8582732,
		"ID": 829,
		"x": 0.8357106323,
		"y": 62.318177565,
		"h": 3.9340659341
	},
	{
		"stop_id": 8583401,
		"ID": 829,
		"x": 1.4427386723,
		"y": 62.160185577,
		"h": 3.9340659341
	},
	{
		"stop_id": 8583760,
		"ID": 829,
		"x": 5.3617015483,
		"y": 60.44714799,
		"h": 3.9340659341
	},
	{
		"stop_id": 8587553,
		"ID": 829,
		"x": 1.1707382853,
		"y": 61.473140884,
		"h": 3.9340659341
	},
	{
		"stop_id": 8587554,
		"ID": 829,
		"x": 1.1587498303,
		"y": 61.772221857,
		"h": 3.9340659341
	},
	{
		"stop_id": 8587555,
		"ID": 829,
		"x": 1.3867605753,
		"y": 61.990159163,
		"h": 3.9340659341
	},
	{
		"stop_id": 8587556,
		"ID": 829,
		"x": 1.6447087503,
		"y": 62.183175843,
		"h": 3.9340659341
	},
	{
		"stop_id": 8502214,
		"ID": 828,
		"x": 6.5517241003,
		"y": 57.166184802,
		"h": 1.4285714286
	},
	{
		"stop_id": 8502670,
		"ID": 828,
		"x": 3.2037534183,
		"y": 59.610192239,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572631,
		"ID": 828,
		"x": 3.3197728193,
		"y": 59.804222161,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572632,
		"ID": 828,
		"x": 3.0017678273,
		"y": 59.40925099,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572633,
		"ID": 828,
		"x": 3.3227009513,
		"y": 58.618225214,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572634,
		"ID": 828,
		"x": 3.4207084293,
		"y": 58.453154996,
		"h": 1.4285714286
	},
	{
		"stop_id": 8578769,
		"ID": 828,
		"x": 1.0897327163,
		"y": 55.93324142,
		"h": 1.4285714286
	},
	{
		"stop_id": 8578770,
		"ID": 828,
		"x": 2.7827180113,
		"y": 55.486185202,
		"h": 1.4285714286
	},
	{
		"stop_id": 8578771,
		"ID": 828,
		"x": 1.5947057303,
		"y": 57.633239383,
		"h": 1.4285714286
	},
	{
		"stop_id": 8578772,
		"ID": 828,
		"x": 1.7427119743,
		"y": 58.252186523,
		"h": 1.4285714286
	},
	{
		"stop_id": 8578773,
		"ID": 828,
		"x": 1.3847433933,
		"y": 58.2022353,
		"h": 1.4285714286
	},
	{
		"stop_id": 8587552,
		"ID": 828,
		"x": 1.7797139813,
		"y": 58.067222841,
		"h": 1.4285714286
	},
	{
		"stop_id": 8587767,
		"ID": 828,
		"x": 1.3907545043,
		"y": 57.52317379,
		"h": 1.4285714286
	},
	{
		"stop_id": 8587864,
		"ID": 828,
		"x": 1.1577146353,
		"y": 56.23024729,
		"h": 1.4285714286
	},
	{
		"stop_id": 8502215,
		"ID": 852,
		"x": 8.4427551953,
		"y": 54.017231413,
		"h": 1.7252747253
	},
	{
		"stop_id": 8502558,
		"ID": 852,
		"x": 10.2527691613,
		"y": 53.632237371,
		"h": 1.7252747253
	},
	{
		"stop_id": 8502562,
		"ID": 852,
		"x": 7.6937508493,
		"y": 54.033250527,
		"h": 1.7252747253
	},
	{
		"stop_id": 8502563,
		"ID": 852,
		"x": 8.8817506453,
		"y": 54.387202029,
		"h": 1.7252747253
	},
	{
		"stop_id": 8502564,
		"ID": 852,
		"x": 6.2417589853,
		"y": 53.085203646,
		"h": 1.7252747253
	},
	{
		"stop_id": 8502565,
		"ID": 852,
		"x": 10.1367082713,
		"y": 54.318225999,
		"h": 1.7252747253
	},
	{
		"stop_id": 8502566,
		"ID": 852,
		"x": 9.9407132813,
		"y": 56.015191671,
		"h": 1.7252747253
	},
	{
		"stop_id": 8502577,
		"ID": 852,
		"x": 10.1137535583,
		"y": 55.105158334,
		"h": 1.7252747253
	},
	{
		"stop_id": 8572609,
		"ID": 852,
		"x": 10.7337430883,
		"y": 52.632244208,
		"h": 1.7252747253
	},
	{
		"stop_id": 8572610,
		"ID": 852,
		"x": 8.8047728633,
		"y": 53.937231233,
		"h": 1.7252747253
	},
	{
		"stop_id": 8572635,
		"ID": 852,
		"x": 9.4207695763,
		"y": 52.413228497,
		"h": 1.7252747253
	},
	{
		"stop_id": 8572639,
		"ID": 852,
		"x": 8.2247403443,
		"y": 53.866187392,
		"h": 1.7252747253
	},
	{
		"stop_id": 8572640,
		"ID": 852,
		"x": 8.0837463063,
		"y": 53.596172169,
		"h": 1.7252747253
	},
	{
		"stop_id": 8572641,
		"ID": 852,
		"x": 6.3517475693,
		"y": 53.246200233,
		"h": 1.7252747253
	},
	{
		"stop_id": 8572642,
		"ID": 852,
		"x": 6.5247542393,
		"y": 52.981171463,
		"h": 1.7252747253
	},
	{
		"stop_id": 8572744,
		"ID": 852,
		"x": 8.4347138203,
		"y": 53.999238103,
		"h": 1.7252747253
	},
	{
		"stop_id": 8581563,
		"ID": 852,
		"x": 8.6847060983,
		"y": 53.436175756,
		"h": 1.7252747253
	},
	{
		"stop_id": 8581669,
		"ID": 852,
		"x": 8.5707256313,
		"y": 53.687144905,
		"h": 1.7252747253
	},
	{
		"stop_id": 8581670,
		"ID": 852,
		"x": 7.5587430393,
		"y": 53.40018265,
		"h": 1.7252747253
	},
	{
		"stop_id": 8582054,
		"ID": 852,
		"x": 9.1777454903,
		"y": 54.042171925,
		"h": 1.7252747253
	},
	{
		"stop_id": 8582256,
		"ID": 852,
		"x": 9.1777548143,
		"y": 52.750188198,
		"h": 1.7252747253
	},
	{
		"stop_id": 8583558,
		"ID": 852,
		"x": 7.9177593473,
		"y": 53.466192504,
		"h": 1.7252747253
	},
	{
		"stop_id": 8583685,
		"ID": 852,
		"x": 8.9167757583,
		"y": 53.131202173,
		"h": 1.7252747253
	},
	{
		"stop_id": 8502216,
		"ID": 851,
		"x": 10.4337631293,
		"y": 50.725187663,
		"h": 1.4285714286
	},
	{
		"stop_id": 8502569,
		"ID": 851,
		"x": 7.7317244003,
		"y": 49.102164128,
		"h": 1.4285714286
	},
	{
		"stop_id": 8502573,
		"ID": 851,
		"x": 10.3157066773,
		"y": 49.770155469,
		"h": 1.4285714286
	},
	{
		"stop_id": 8502576,
		"ID": 851,
		"x": 10.4487019743,
		"y": 48.556246675,
		"h": 1.4285714286
	},
	{
		"stop_id": 8502877,
		"ID": 851,
		"x": 8.7307295263,
		"y": 48.804162256,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572636,
		"ID": 851,
		"x": 10.3007076633,
		"y": 50.856151003,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572637,
		"ID": 851,
		"x": 8.9887031153,
		"y": 48.999156329,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572638,
		"ID": 851,
		"x": 8.5787195943,
		"y": 49.088158105,
		"h": 1.4285714286
	},
	{
		"stop_id": 8577133,
		"ID": 851,
		"x": 10.1297687453,
		"y": 46.577178544,
		"h": 1.4285714286
	},
	{
		"stop_id": 8577134,
		"ID": 851,
		"x": 10.3777527643,
		"y": 46.782231764,
		"h": 1.4285714286
	},
	{
		"stop_id": 8577135,
		"ID": 851,
		"x": 10.7217224383,
		"y": 46.647206376,
		"h": 1.4285714286
	},
	{
		"stop_id": 8581658,
		"ID": 851,
		"x": 7.2267744343,
		"y": 50.974143358,
		"h": 1.4285714286
	},
	{
		"stop_id": 8581830,
		"ID": 851,
		"x": 8.0627502573,
		"y": 50.721227686,
		"h": 1.4285714286
	},
	{
		"stop_id": 8581831,
		"ID": 851,
		"x": 7.6167677463,
		"y": 51.012241116,
		"h": 1.4285714286
	},
	{
		"stop_id": 8502217,
		"ID": 876,
		"x": 12.1977524273,
		"y": 48.319209335,
		"h": 1.7582417582
	},
	{
		"stop_id": 8502218,
		"ID": 876,
		"x": 12.9517057893,
		"y": 44.247220314,
		"h": 1.7582417582
	},
	{
		"stop_id": 8502790,
		"ID": 876,
		"x": 13.3577461663,
		"y": 44.000141175,
		"h": 1.7582417582
	},
	{
		"stop_id": 8502794,
		"ID": 876,
		"x": 15.3877624853,
		"y": 43.210228172,
		"h": 1.7582417582
	},
	{
		"stop_id": 8577125,
		"ID": 876,
		"x": 11.9777714553,
		"y": 44.590186151,
		"h": 1.7582417582
	},
	{
		"stop_id": 8577127,
		"ID": 876,
		"x": 12.8277381103,
		"y": 44.530227963,
		"h": 1.7582417582
	},
	{
		"stop_id": 8577128,
		"ID": 876,
		"x": 12.9277344493,
		"y": 44.230249686,
		"h": 1.7582417582
	},
	{
		"stop_id": 8577136,
		"ID": 876,
		"x": 10.9857678173,
		"y": 46.46822095,
		"h": 1.7582417582
	},
	{
		"stop_id": 8577587,
		"ID": 876,
		"x": 15.8477660623,
		"y": 45.125218401,
		"h": 1.7582417582
	},
	{
		"stop_id": 8577588,
		"ID": 876,
		"x": 15.4277265173,
		"y": 45.350159021,
		"h": 1.7582417582
	},
	{
		"stop_id": 8577594,
		"ID": 876,
		"x": 12.6087675393,
		"y": 44.836208787,
		"h": 1.7582417582
	},
	{
		"stop_id": 8587260,
		"ID": 876,
		"x": 15.1917192253,
		"y": 42.855188226,
		"h": 1.7582417582
	},
	{
		"stop_id": 8587283,
		"ID": 876,
		"x": 15.8277658583,
		"y": 46.460193216,
		"h": 1.7582417582
	},
	{
		"stop_id": 8587375,
		"ID": 876,
		"x": 15.4327733143,
		"y": 45.700234882,
		"h": 1.7582417582
	},
	{
		"stop_id": 8587695,
		"ID": 876,
		"x": 12.1127561783,
		"y": 45.330192596,
		"h": 1.7582417582
	},
	{
		"stop_id": 8587783,
		"ID": 876,
		"x": 11.9327540023,
		"y": 45.621214428,
		"h": 1.7582417582
	},
	{
		"stop_id": 8587787,
		"ID": 876,
		"x": 12.5187308043,
		"y": 44.861242514,
		"h": 1.7582417582
	},
	{
		"stop_id": 8588246,
		"ID": 876,
		"x": 16.4177528613,
		"y": 44.870204204,
		"h": 1.7582417582
	},
	{
		"stop_id": 8588879,
		"ID": 876,
		"x": 15.2177475413,
		"y": 43.190182555,
		"h": 1.7582417582
	},
	{
		"stop_id": 8589231,
		"ID": 876,
		"x": 12.2177040233,
		"y": 44.980229151,
		"h": 1.7582417582
	},
	{
		"stop_id": 8590266,
		"ID": 876,
		"x": 12.4497372503,
		"y": 44.676171625,
		"h": 1.7582417582
	},
	{
		"stop_id": 8590267,
		"ID": 876,
		"x": 11.6197479683,
		"y": 44.090219646,
		"h": 1.7582417582
	},
	{
		"stop_id": 8593412,
		"ID": 876,
		"x": 15.6277437883,
		"y": 46.340241903,
		"h": 1.7582417582
	},
	{
		"stop_id": 8593418,
		"ID": 876,
		"x": 15.5577696803,
		"y": 46.050161157,
		"h": 1.7582417582
	},
	{
		"stop_id": 8502222,
		"ID": 907,
		"x": 18.0837674033,
		"y": 59.610170123,
		"h": 2.3516483516
	},
	{
		"stop_id": 8502885,
		"ID": 907,
		"x": 18.0697437193,
		"y": 58.40824627,
		"h": 2.3516483516
	},
	{
		"stop_id": 8503057,
		"ID": 907,
		"x": 19.5167320833,
		"y": 62.572142446,
		"h": 2.3516483516
	},
	{
		"stop_id": 8503551,
		"ID": 907,
		"x": 17.5557746753,
		"y": 62.538246405,
		"h": 2.3516483516
	},
	{
		"stop_id": 8503690,
		"ID": 907,
		"x": 19.7577102163,
		"y": 59.730216191,
		"h": 2.3516483516
	},
	{
		"stop_id": 8503691,
		"ID": 907,
		"x": 19.6327285853,
		"y": 60.505208468,
		"h": 2.3516483516
	},
	{
		"stop_id": 8503692,
		"ID": 907,
		"x": 18.5327275263,
		"y": 60.930235997,
		"h": 2.3516483516
	},
	{
		"stop_id": 8503693,
		"ID": 907,
		"x": 17.9427063143,
		"y": 61.802217224,
		"h": 2.3516483516
	},
	{
		"stop_id": 8503694,
		"ID": 907,
		"x": 20.0077377383,
		"y": 58.030248461,
		"h": 2.3516483516
	},
	{
		"stop_id": 8503696,
		"ID": 907,
		"x": 19.1087206313,
		"y": 61.558199594,
		"h": 2.3516483516
	},
	{
		"stop_id": 8573712,
		"ID": 907,
		"x": 18.2057673553,
		"y": 61.429177883,
		"h": 2.3516483516
	},
	{
		"stop_id": 8573713,
		"ID": 907,
		"x": 18.5327649243,
		"y": 60.280217235,
		"h": 2.3516483516
	},
	{
		"stop_id": 8573724,
		"ID": 907,
		"x": 19.7877709663,
		"y": 58.999208874,
		"h": 2.3516483516
	},
	{
		"stop_id": 8573725,
		"ID": 907,
		"x": 15.9077708803,
		"y": 59.330176591,
		"h": 2.3516483516
	},
	{
		"stop_id": 8573726,
		"ID": 907,
		"x": 18.1077469823,
		"y": 59.655183178,
		"h": 2.3516483516
	},
	{
		"stop_id": 8573728,
		"ID": 907,
		"x": 17.7107306053,
		"y": 58.57522548,
		"h": 2.3516483516
	},
	{
		"stop_id": 8573729,
		"ID": 907,
		"x": 18.4327480273,
		"y": 58.330181786,
		"h": 2.3516483516
	},
	{
		"stop_id": 8573730,
		"ID": 907,
		"x": 18.4077455113,
		"y": 59.430187588,
		"h": 2.3516483516
	},
	{
		"stop_id": 8573731,
		"ID": 907,
		"x": 18.6327759833,
		"y": 62.230154061,
		"h": 2.3516483516
	},
	{
		"stop_id": 8576699,
		"ID": 907,
		"x": 18.8077700463,
		"y": 60.400158093,
		"h": 2.3516483516
	},
	{
		"stop_id": 8576743,
		"ID": 907,
		"x": 18.9777719683,
		"y": 60.030146473,
		"h": 2.3516483516
	},
	{
		"stop_id": 8579434,
		"ID": 907,
		"x": 18.5477691253,
		"y": 60.930212164,
		"h": 2.3516483516
	},
	{
		"stop_id": 8579440,
		"ID": 907,
		"x": 18.8677294423,
		"y": 60.530155818,
		"h": 2.3516483516
	},
	{
		"stop_id": 8579442,
		"ID": 907,
		"x": 18.7977271053,
		"y": 60.930181461,
		"h": 2.3516483516
	},
	{
		"stop_id": 8579443,
		"ID": 907,
		"x": 18.5577333523,
		"y": 61.160174614,
		"h": 2.3516483516
	},
	{
		"stop_id": 8579453,
		"ID": 907,
		"x": 18.5077233263,
		"y": 61.370220749,
		"h": 2.3516483516
	},
	{
		"stop_id": 8579472,
		"ID": 907,
		"x": 18.3677384873,
		"y": 61.480233023,
		"h": 2.3516483516
	},
	{
		"stop_id": 8579495,
		"ID": 907,
		"x": 18.2477313213,
		"y": 61.600184868,
		"h": 2.3516483516
	},
	{
		"stop_id": 8579497,
		"ID": 907,
		"x": 18.1177007143,
		"y": 61.580240865,
		"h": 2.3516483516
	},
	{
		"stop_id": 8579991,
		"ID": 907,
		"x": 18.4977498223,
		"y": 58.120222885,
		"h": 2.3516483516
	},
	{
		"stop_id": 8579994,
		"ID": 907,
		"x": 18.5677549873,
		"y": 60.630150519,
		"h": 2.3516483516
	},
	{
		"stop_id": 8581059,
		"ID": 907,
		"x": 19.3577103253,
		"y": 61.130206388,
		"h": 2.3516483516
	},
	{
		"stop_id": 8581666,
		"ID": 907,
		"x": 17.1577656993,
		"y": 58.82021035,
		"h": 2.3516483516
	},
	{
		"stop_id": 8581967,
		"ID": 907,
		"x": 18.4777623653,
		"y": 59.825168234,
		"h": 2.3516483516
	},
	{
		"stop_id": 8583053,
		"ID": 907,
		"x": 19.7497754913,
		"y": 59.380193594,
		"h": 2.3516483516
	},
	{
		"stop_id": 8583731,
		"ID": 907,
		"x": 17.5097330433,
		"y": 62.592240991,
		"h": 2.3516483516
	},
	{
		"stop_id": 8583755,
		"ID": 907,
		"x": 15.6647697093,
		"y": 60.538159273,
		"h": 2.3516483516
	},
	{
		"stop_id": 8583805,
		"ID": 907,
		"x": 17.6577640843,
		"y": 58.601219765,
		"h": 2.3516483516
	},
	{
		"stop_id": 8591210,
		"ID": 907,
		"x": 21.4457532773,
		"y": 59.915197268,
		"h": 2.3516483516
	},
	{
		"stop_id": 8591270,
		"ID": 907,
		"x": 21.6447128483,
		"y": 60.153204189,
		"h": 2.3516483516
	},
	{
		"stop_id": 8591278,
		"ID": 907,
		"x": 21.5737751303,
		"y": 59.350210968,
		"h": 2.3516483516
	},
	{
		"stop_id": 8591370,
		"ID": 907,
		"x": 21.5967436763,
		"y": 59.715231955,
		"h": 2.3516483516
	},
	{
		"stop_id": 8502223,
		"ID": 878,
		"x": 16.4427388473,
		"y": 56.574194715,
		"h": 1.7582417582
	},
	{
		"stop_id": 8502553,
		"ID": 878,
		"x": 11.4597159383,
		"y": 59.111231935,
		"h": 1.7582417582
	},
	{
		"stop_id": 8502779,
		"ID": 878,
		"x": 13.3327274593,
		"y": 54.630220454,
		"h": 1.7582417582
	},
	{
		"stop_id": 8502879,
		"ID": 878,
		"x": 12.6317137913,
		"y": 56.237188911,
		"h": 1.7582417582
	},
	{
		"stop_id": 8502883,
		"ID": 878,
		"x": 15.4177602613,
		"y": 55.295247124,
		"h": 1.7582417582
	},
	{
		"stop_id": 8502955,
		"ID": 878,
		"x": 12.0917014713,
		"y": 58.143172572,
		"h": 1.7582417582
	},
	{
		"stop_id": 8503598,
		"ID": 878,
		"x": 14.4307308103,
		"y": 58.729228473,
		"h": 1.7582417582
	},
	{
		"stop_id": 8570706,
		"ID": 878,
		"x": 12.8247624333,
		"y": 55.933223585,
		"h": 1.7582417582
	},
	{
		"stop_id": 8572602,
		"ID": 878,
		"x": 12.1097227923,
		"y": 58.141166999,
		"h": 1.7582417582
	},
	{
		"stop_id": 8572603,
		"ID": 878,
		"x": 12.5017170743,
		"y": 56.601190753,
		"h": 1.7582417582
	},
	{
		"stop_id": 8572605,
		"ID": 878,
		"x": 13.1587605873,
		"y": 54.878142469,
		"h": 1.7582417582
	},
	{
		"stop_id": 8572606,
		"ID": 878,
		"x": 13.5577760583,
		"y": 54.205145205,
		"h": 1.7582417582
	},
	{
		"stop_id": 8572646,
		"ID": 878,
		"x": 11.4377135713,
		"y": 58.941183375,
		"h": 1.7582417582
	},
	{
		"stop_id": 8573720,
		"ID": 878,
		"x": 14.7447530763,
		"y": 58.915178998,
		"h": 1.7582417582
	},
	{
		"stop_id": 8573721,
		"ID": 878,
		"x": 12.8577666083,
		"y": 58.157165882,
		"h": 1.7582417582
	},
	{
		"stop_id": 8573722,
		"ID": 878,
		"x": 12.4017498163,
		"y": 58.03619059,
		"h": 1.7582417582
	},
	{
		"stop_id": 8573723,
		"ID": 878,
		"x": 12.2487702863,
		"y": 57.924145153,
		"h": 1.7582417582
	},
	{
		"stop_id": 8582104,
		"ID": 878,
		"x": 14.6827177473,
		"y": 55.414186181,
		"h": 1.7582417582
	},
	{
		"stop_id": 8582722,
		"ID": 878,
		"x": 16.6137433973,
		"y": 56.681243318,
		"h": 1.7582417582
	},
	{
		"stop_id": 8582790,
		"ID": 878,
		"x": 13.3587362643,
		"y": 54.65022081,
		"h": 1.7582417582
	},
	{
		"stop_id": 8583069,
		"ID": 878,
		"x": 13.3867177493,
		"y": 54.215155389,
		"h": 1.7582417582
	},
	{
		"stop_id": 8583071,
		"ID": 878,
		"x": 12.4337536083,
		"y": 56.878222391,
		"h": 1.7582417582
	},
	{
		"stop_id": 8583206,
		"ID": 878,
		"x": 15.6067137533,
		"y": 59.104188848,
		"h": 1.7582417582
	},
	{
		"stop_id": 8583363,
		"ID": 878,
		"x": 13.6827532923,
		"y": 54.92318188,
		"h": 1.7582417582
	},
	{
		"stop_id": 8502224,
		"ID": 906,
		"x": 16.5227475083,
		"y": 54.049243837,
		"h": 1.6593406593
	},
	{
		"stop_id": 8502574,
		"ID": 906,
		"x": 17.4667552113,
		"y": 54.328185009,
		"h": 1.6593406593
	},
	{
		"stop_id": 8502771,
		"ID": 906,
		"x": 19.4677168263,
		"y": 53.172162805,
		"h": 1.6593406593
	},
	{
		"stop_id": 8502953,
		"ID": 906,
		"x": 17.1077355813,
		"y": 54.630184509,
		"h": 1.6593406593
	},
	{
		"stop_id": 8503689,
		"ID": 906,
		"x": 19.4577615703,
		"y": 56.130211876,
		"h": 1.6593406593
	},
	{
		"stop_id": 8503697,
		"ID": 906,
		"x": 19.5577400433,
		"y": 55.005199963,
		"h": 1.6593406593
	},
	{
		"stop_id": 8573178,
		"ID": 906,
		"x": 16.5247718463,
		"y": 54.021250448,
		"h": 1.6593406593
	},
	{
		"stop_id": 8573193,
		"ID": 906,
		"x": 16.0677285113,
		"y": 55.211225605,
		"h": 1.6593406593
	},
	{
		"stop_id": 8573715,
		"ID": 906,
		"x": 19.4597182173,
		"y": 56.981171089,
		"h": 1.6593406593
	},
	{
		"stop_id": 8573716,
		"ID": 906,
		"x": 19.5787566293,
		"y": 56.614167529,
		"h": 1.6593406593
	},
	{
		"stop_id": 8573717,
		"ID": 906,
		"x": 20.6077529973,
		"y": 54.530197641,
		"h": 1.6593406593
	},
	{
		"stop_id": 8573732,
		"ID": 906,
		"x": 18.9327346033,
		"y": 54.65520057,
		"h": 1.6593406593
	},
	{
		"stop_id": 8573733,
		"ID": 906,
		"x": 19.1077337293,
		"y": 53.505162587,
		"h": 1.6593406593
	},
	{
		"stop_id": 8573734,
		"ID": 906,
		"x": 17.9847585063,
		"y": 54.347174574,
		"h": 1.6593406593
	},
	{
		"stop_id": 8580268,
		"ID": 906,
		"x": 17.3327606873,
		"y": 54.630210676,
		"h": 1.6593406593
	},
	{
		"stop_id": 8581015,
		"ID": 906,
		"x": 16.5067374783,
		"y": 54.783213644,
		"h": 1.6593406593
	},
	{
		"stop_id": 8582721,
		"ID": 906,
		"x": 16.6927290623,
		"y": 56.145218286,
		"h": 1.6593406593
	},
	{
		"stop_id": 8582723,
		"ID": 906,
		"x": 17.0027519893,
		"y": 55.107159018,
		"h": 1.6593406593
	},
	{
		"stop_id": 8582763,
		"ID": 906,
		"x": 17.6317005463,
		"y": 54.474210106,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583047,
		"ID": 906,
		"x": 19.9137172943,
		"y": 52.986217164,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583890,
		"ID": 906,
		"x": 16.0187312433,
		"y": 53.673202902,
		"h": 1.6593406593
	},
	{
		"stop_id": 8502225,
		"ID": 905,
		"x": 17.3847491523,
		"y": 50.503147664,
		"h": 1.6923076923
	},
	{
		"stop_id": 8502226,
		"ID": 905,
		"x": 18.1267330043,
		"y": 47.865238524,
		"h": 1.6923076923
	},
	{
		"stop_id": 8502554,
		"ID": 905,
		"x": 20.3827734953,
		"y": 50.380157043,
		"h": 1.6923076923
	},
	{
		"stop_id": 8573171,
		"ID": 905,
		"x": 20.1897101123,
		"y": 51.003211471,
		"h": 1.6923076923
	},
	{
		"stop_id": 8573180,
		"ID": 905,
		"x": 16.7577708333,
		"y": 49.430203435,
		"h": 1.6923076923
	},
	{
		"stop_id": 8573181,
		"ID": 905,
		"x": 17.4077084033,
		"y": 50.455190476,
		"h": 1.6923076923
	},
	{
		"stop_id": 8573185,
		"ID": 905,
		"x": 20.6077100303,
		"y": 48.080163051,
		"h": 1.6923076923
	},
	{
		"stop_id": 8573186,
		"ID": 905,
		"x": 20.8617734933,
		"y": 47.538228868,
		"h": 1.6923076923
	},
	{
		"stop_id": 8579839,
		"ID": 905,
		"x": 20.2877206703,
		"y": 49.010154093,
		"h": 1.6923076923
	},
	{
		"stop_id": 8580297,
		"ID": 905,
		"x": 20.4527030683,
		"y": 48.239180062,
		"h": 1.6923076923
	},
	{
		"stop_id": 8580298,
		"ID": 905,
		"x": 19.4077657873,
		"y": 48.530158574,
		"h": 1.6923076923
	},
	{
		"stop_id": 8580299,
		"ID": 905,
		"x": 18.6847220763,
		"y": 49.569179605,
		"h": 1.6923076923
	},
	{
		"stop_id": 8580300,
		"ID": 905,
		"x": 17.9427221563,
		"y": 50.305165516,
		"h": 1.6923076923
	},
	{
		"stop_id": 8582701,
		"ID": 905,
		"x": 18.3157595713,
		"y": 50.878223274,
		"h": 1.6923076923
	},
	{
		"stop_id": 8583742,
		"ID": 905,
		"x": 17.9697603543,
		"y": 50.53623301,
		"h": 1.6923076923
	},
	{
		"stop_id": 8583743,
		"ID": 905,
		"x": 17.6897294953,
		"y": 50.701247941,
		"h": 1.6923076923
	},
	{
		"stop_id": 8583756,
		"ID": 905,
		"x": 17.8537681713,
		"y": 50.466225452,
		"h": 1.6923076923
	},
	{
		"stop_id": 8583855,
		"ID": 905,
		"x": 19.9767725213,
		"y": 51.017250667,
		"h": 1.6923076923
	},
	{
		"stop_id": 8587284,
		"ID": 905,
		"x": 17.1777330983,
		"y": 45.540207447,
		"h": 1.6923076923
	},
	{
		"stop_id": 8587593,
		"ID": 905,
		"x": 16.9927357093,
		"y": 47.015146812,
		"h": 1.6923076923
	},
	{
		"stop_id": 8593419,
		"ID": 905,
		"x": 17.5377443193,
		"y": 46.690204438,
		"h": 1.6923076923
	},
	{
		"stop_id": 8593422,
		"ID": 905,
		"x": 16.6277270213,
		"y": 46.855230485,
		"h": 1.6923076923
	},
	{
		"stop_id": 8502231,
		"ID": 935,
		"x": 21.5097374753,
		"y": 39.84015493,
		"h": 2.8461538462
	},
	{
		"stop_id": 8502246,
		"ID": 935,
		"x": 21.7477474193,
		"y": 42.040220758,
		"h": 2.8461538462
	},
	{
		"stop_id": 8502252,
		"ID": 935,
		"x": 21.2707182783,
		"y": 39.98521812,
		"h": 2.8461538462
	},
	{
		"stop_id": 8502281,
		"ID": 935,
		"x": 21.8777424483,
		"y": 41.850206557,
		"h": 2.8461538462
	},
	{
		"stop_id": 8502284,
		"ID": 935,
		"x": 24.9377418793,
		"y": 41.750209795,
		"h": 2.8461538462
	},
	{
		"stop_id": 8502285,
		"ID": 935,
		"x": 25.5377124783,
		"y": 40.380172698,
		"h": 2.8461538462
	},
	{
		"stop_id": 8502291,
		"ID": 935,
		"x": 22.3587533153,
		"y": 40.254188235,
		"h": 2.8461538462
	},
	{
		"stop_id": 8502292,
		"ID": 935,
		"x": 23.2527195783,
		"y": 39.465159516,
		"h": 2.8461538462
	},
	{
		"stop_id": 8502297,
		"ID": 935,
		"x": 25.7177160223,
		"y": 39.930224874,
		"h": 2.8461538462
	},
	{
		"stop_id": 8502298,
		"ID": 935,
		"x": 22.8377143713,
		"y": 42.245156962,
		"h": 2.8461538462
	},
	{
		"stop_id": 8502300,
		"ID": 935,
		"x": 22.0087740323,
		"y": 42.137198349,
		"h": 2.8461538462
	},
	{
		"stop_id": 8502784,
		"ID": 935,
		"x": 22.4577123183,
		"y": 42.210207438,
		"h": 2.8461538462
	},
	{
		"stop_id": 8502792,
		"ID": 935,
		"x": 23.0477112943,
		"y": 42.520149344,
		"h": 2.8461538462
	},
	{
		"stop_id": 8502853,
		"ID": 935,
		"x": 26.2977373073,
		"y": 39.130143278,
		"h": 2.8461538462
	},
	{
		"stop_id": 8502863,
		"ID": 935,
		"x": 21.8077057213,
		"y": 41.610195946,
		"h": 2.8461538462
	},
	{
		"stop_id": 8502864,
		"ID": 935,
		"x": 21.7227258973,
		"y": 41.32017041,
		"h": 2.8461538462
	},
	{
		"stop_id": 8515994,
		"ID": 935,
		"x": 21.6747252793,
		"y": 40.832185394,
		"h": 2.8461538462
	},
	{
		"stop_id": 8517527,
		"ID": 935,
		"x": 21.8867064023,
		"y": 41.473186137,
		"h": 2.8461538462
	},
	{
		"stop_id": 8577530,
		"ID": 935,
		"x": 21.9177458223,
		"y": 42.090250625,
		"h": 2.8461538462
	},
	{
		"stop_id": 8577533,
		"ID": 935,
		"x": 24.7777630943,
		"y": 42.330221151,
		"h": 2.8461538462
	},
	{
		"stop_id": 8577534,
		"ID": 935,
		"x": 24.7877497623,
		"y": 41.990241965,
		"h": 2.8461538462
	},
	{
		"stop_id": 8577535,
		"ID": 935,
		"x": 25.1477153983,
		"y": 41.240185548,
		"h": 2.8461538462
	},
	{
		"stop_id": 8577536,
		"ID": 935,
		"x": 25.3777276193,
		"y": 40.62015808,
		"h": 2.8461538462
	},
	{
		"stop_id": 8577547,
		"ID": 935,
		"x": 21.2977662113,
		"y": 39.965239407,
		"h": 2.8461538462
	},
	{
		"stop_id": 8577548,
		"ID": 935,
		"x": 21.2927134433,
		"y": 39.740242226,
		"h": 2.8461538462
	},
	{
		"stop_id": 8577549,
		"ID": 935,
		"x": 21.1577539843,
		"y": 38.820237301,
		"h": 2.8461538462
	},
	{
		"stop_id": 8587263,
		"ID": 935,
		"x": 22.2677137763,
		"y": 41.070150032,
		"h": 2.8461538462
	},
	{
		"stop_id": 8587264,
		"ID": 935,
		"x": 22.3277100723,
		"y": 40.250202093,
		"h": 2.8461538462
	},
	{
		"stop_id": 8587278,
		"ID": 935,
		"x": 22.8777031013,
		"y": 42.090162245,
		"h": 2.8461538462
	},
	{
		"stop_id": 8587376,
		"ID": 935,
		"x": 21.7677691523,
		"y": 39.310214696,
		"h": 2.8461538462
	},
	{
		"stop_id": 8587449,
		"ID": 935,
		"x": 21.2077537273,
		"y": 39.690164439,
		"h": 2.8461538462
	},
	{
		"stop_id": 8587708,
		"ID": 935,
		"x": 21.9277165143,
		"y": 42.380250164,
		"h": 2.8461538462
	},
	{
		"stop_id": 8588729,
		"ID": 935,
		"x": 21.9427575333,
		"y": 41.290164786,
		"h": 2.8461538462
	},
	{
		"stop_id": 8588730,
		"ID": 935,
		"x": 21.8477418193,
		"y": 40.930175091,
		"h": 2.8461538462
	},
	{
		"stop_id": 8588731,
		"ID": 935,
		"x": 22.1577190793,
		"y": 40.510147755,
		"h": 2.8461538462
	},
	{
		"stop_id": 8588732,
		"ID": 935,
		"x": 21.8777010303,
		"y": 40.410235942,
		"h": 2.8461538462
	},
	{
		"stop_id": 8591868,
		"ID": 935,
		"x": 21.8577705303,
		"y": 40.630221806,
		"h": 2.8461538462
	},
	{
		"stop_id": 8593438,
		"ID": 935,
		"x": 21.5777518173,
		"y": 39.370212988,
		"h": 2.8461538462
	},
	{
		"stop_id": 8593439,
		"ID": 935,
		"x": 21.4677249403,
		"y": 39.450209715,
		"h": 2.8461538462
	},
	{
		"stop_id": 8593440,
		"ID": 935,
		"x": 21.3977117753,
		"y": 39.650167061,
		"h": 2.8461538462
	},
	{
		"stop_id": 8593441,
		"ID": 935,
		"x": 21.4477507203,
		"y": 40.030214693,
		"h": 2.8461538462
	},
	{
		"stop_id": 8593442,
		"ID": 935,
		"x": 21.4777571483,
		"y": 39.860176563,
		"h": 2.8461538462
	},
	{
		"stop_id": 8593444,
		"ID": 935,
		"x": 22.2877668593,
		"y": 40.600220666,
		"h": 2.8461538462
	},
	{
		"stop_id": 8593446,
		"ID": 935,
		"x": 22.6177354503,
		"y": 42.35018072,
		"h": 2.8461538462
	},
	{
		"stop_id": 8593447,
		"ID": 935,
		"x": 21.8827572813,
		"y": 41.59521431,
		"h": 2.8461538462
	},
	{
		"stop_id": 8593449,
		"ID": 935,
		"x": 22.2277236683,
		"y": 40.89014469,
		"h": 2.8461538462
	},
	{
		"stop_id": 8593450,
		"ID": 935,
		"x": 22.7227062613,
		"y": 42.375206456,
		"h": 2.8461538462
	},
	{
		"stop_id": 8593451,
		"ID": 935,
		"x": 22.7377532073,
		"y": 42.110235247,
		"h": 2.8461538462
	},
	{
		"stop_id": 8593452,
		"ID": 935,
		"x": 22.1577189753,
		"y": 41.050178148,
		"h": 2.8461538462
	},
	{
		"stop_id": 8593453,
		"ID": 935,
		"x": 22.0227422783,
		"y": 40.425235769,
		"h": 2.8461538462
	},
	{
		"stop_id": 8593454,
		"ID": 935,
		"x": 22.1277496733,
		"y": 41.310163542,
		"h": 2.8461538462
	},
	{
		"stop_id": 8593455,
		"ID": 935,
		"x": 23.0177266363,
		"y": 42.310145341,
		"h": 2.8461538462
	},
	{
		"stop_id": 8593459,
		"ID": 935,
		"x": 22.6377131713,
		"y": 41.975203036,
		"h": 2.8461538462
	},
	{
		"stop_id": 8593460,
		"ID": 935,
		"x": 22.2577558213,
		"y": 42.040223685,
		"h": 2.8461538462
	},
	{
		"stop_id": 8593461,
		"ID": 935,
		"x": 22.0677002563,
		"y": 41.480230662,
		"h": 2.8461538462
	},
	{
		"stop_id": 8593463,
		"ID": 935,
		"x": 22.5877629783,
		"y": 41.99018887,
		"h": 2.8461538462
	},
	{
		"stop_id": 8593464,
		"ID": 935,
		"x": 22.6577634483,
		"y": 42.23020886,
		"h": 2.8461538462
	},
	{
		"stop_id": 8502253,
		"ID": 903,
		"x": 17.6197166153,
		"y": 39.182141609,
		"h": 1.7252747253
	},
	{
		"stop_id": 8502254,
		"ID": 903,
		"x": 18.3487277163,
		"y": 38.258155458,
		"h": 1.7252747253
	},
	{
		"stop_id": 8502257,
		"ID": 903,
		"x": 18.1097085063,
		"y": 34.10819867,
		"h": 1.7252747253
	},
	{
		"stop_id": 8573075,
		"ID": 903,
		"x": 15.8177260243,
		"y": 35.934223324,
		"h": 1.7252747253
	},
	{
		"stop_id": 8573076,
		"ID": 903,
		"x": 16.2377218143,
		"y": 36.604221381,
		"h": 1.7252747253
	},
	{
		"stop_id": 8573077,
		"ID": 903,
		"x": 16.4857497033,
		"y": 37.220235573,
		"h": 1.7252747253
	},
	{
		"stop_id": 8573078,
		"ID": 903,
		"x": 16.5787567223,
		"y": 38.057196179,
		"h": 1.7252747253
	},
	{
		"stop_id": 8577550,
		"ID": 903,
		"x": 20.7227033273,
		"y": 37.750188533,
		"h": 1.7252747253
	},
	{
		"stop_id": 8577551,
		"ID": 903,
		"x": 20.8677040453,
		"y": 36.080153632,
		"h": 1.7252747253
	},
	{
		"stop_id": 8580236,
		"ID": 903,
		"x": 16.2207287783,
		"y": 38.144232857,
		"h": 1.7252747253
	},
	{
		"stop_id": 8587519,
		"ID": 903,
		"x": 17.1127152903,
		"y": 35.815149448,
		"h": 1.7252747253
	},
	{
		"stop_id": 8587572,
		"ID": 903,
		"x": 18.2017024803,
		"y": 38.332167674,
		"h": 1.7252747253
	},
	{
		"stop_id": 8587583,
		"ID": 903,
		"x": 16.9997432473,
		"y": 35.169162055,
		"h": 1.7252747253
	},
	{
		"stop_id": 8587584,
		"ID": 903,
		"x": 17.9627112473,
		"y": 36.43024052,
		"h": 1.7252747253
	},
	{
		"stop_id": 8587585,
		"ID": 903,
		"x": 17.8977666533,
		"y": 37.860221387,
		"h": 1.7252747253
	},
	{
		"stop_id": 8587587,
		"ID": 903,
		"x": 17.4387351793,
		"y": 38.911170658,
		"h": 1.7252747253
	},
	{
		"stop_id": 8587588,
		"ID": 903,
		"x": 17.2177288713,
		"y": 39.000147541,
		"h": 1.7252747253
	},
	{
		"stop_id": 8587589,
		"ID": 903,
		"x": 16.7177064323,
		"y": 39.030172361,
		"h": 1.7252747253
	},
	{
		"stop_id": 8587771,
		"ID": 903,
		"x": 17.9727078253,
		"y": 34.2501701,
		"h": 1.7252747253
	},
	{
		"stop_id": 8587881,
		"ID": 903,
		"x": 18.1097549813,
		"y": 34.424182711,
		"h": 1.7252747253
	},
	{
		"stop_id": 8588880,
		"ID": 903,
		"x": 17.8827258833,
		"y": 37.320226073,
		"h": 1.7252747253
	},
	{
		"stop_id": 8591755,
		"ID": 903,
		"x": 16.9097615113,
		"y": 35.460193473,
		"h": 1.7252747253
	},
	{
		"stop_id": 8595453,
		"ID": 903,
		"x": 17.0997727123,
		"y": 35.359241158,
		"h": 1.7252747253
	},
	{
		"stop_id": 8502283,
		"ID": 969,
		"x": 25.5277575813,
		"y": 42.720184151,
		"h": 1.5274725275
	},
	{
		"stop_id": 8502288,
		"ID": 969,
		"x": 26.0377355063,
		"y": 43.770234011,
		"h": 1.5274725275
	},
	{
		"stop_id": 8502293,
		"ID": 969,
		"x": 25.6137127863,
		"y": 43.10223385,
		"h": 1.5274725275
	},
	{
		"stop_id": 8502759,
		"ID": 969,
		"x": 30.5727510153,
		"y": 42.155199312,
		"h": 1.5274725275
	},
	{
		"stop_id": 8502761,
		"ID": 969,
		"x": 27.6007437573,
		"y": 43.308203146,
		"h": 1.5274725275
	},
	{
		"stop_id": 8502777,
		"ID": 969,
		"x": 30.9737602013,
		"y": 42.516215555,
		"h": 1.5274725275
	},
	{
		"stop_id": 8502793,
		"ID": 969,
		"x": 27.3977747353,
		"y": 43.33024328,
		"h": 1.5274725275
	},
	{
		"stop_id": 8573148,
		"ID": 969,
		"x": 28.5097574893,
		"y": 43.378216541,
		"h": 1.5274725275
	},
	{
		"stop_id": 8573149,
		"ID": 969,
		"x": 29.5917296103,
		"y": 42.63217231,
		"h": 1.5274725275
	},
	{
		"stop_id": 8573150,
		"ID": 969,
		"x": 30.1657153213,
		"y": 42.320152615,
		"h": 1.5274725275
	},
	{
		"stop_id": 8577541,
		"ID": 969,
		"x": 26.2577160083,
		"y": 43.650214852,
		"h": 1.5274725275
	},
	{
		"stop_id": 8577542,
		"ID": 969,
		"x": 26.6377129733,
		"y": 43.610245925,
		"h": 1.5274725275
	},
	{
		"stop_id": 8577543,
		"ID": 969,
		"x": 27.8777109093,
		"y": 43.085230804,
		"h": 1.5274725275
	},
	{
		"stop_id": 8577544,
		"ID": 969,
		"x": 28.3427230633,
		"y": 42.76020253,
		"h": 1.5274725275
	},
	{
		"stop_id": 8577545,
		"ID": 969,
		"x": 28.6027514763,
		"y": 42.655205659,
		"h": 1.5274725275
	},
	{
		"stop_id": 8581324,
		"ID": 969,
		"x": 27.9577278433,
		"y": 43.70517227,
		"h": 1.5274725275
	},
	{
		"stop_id": 8581325,
		"ID": 969,
		"x": 29.1477311543,
		"y": 42.895152455,
		"h": 1.5274725275
	},
	{
		"stop_id": 8502286,
		"ID": 968,
		"x": 26.9777441513,
		"y": 38.80022521,
		"h": 1.6263736264
	},
	{
		"stop_id": 8502287,
		"ID": 968,
		"x": 29.2177216073,
		"y": 38.440234588,
		"h": 1.6263736264
	},
	{
		"stop_id": 8502294,
		"ID": 968,
		"x": 27.8977397583,
		"y": 38.800246396,
		"h": 1.6263736264
	},
	{
		"stop_id": 8502295,
		"ID": 968,
		"x": 28.3777694023,
		"y": 38.800217718,
		"h": 1.6263736264
	},
	{
		"stop_id": 8502747,
		"ID": 968,
		"x": 30.5977417653,
		"y": 38.005149704,
		"h": 1.6263736264
	},
	{
		"stop_id": 8530633,
		"ID": 968,
		"x": 31.4947435633,
		"y": 36.479214449,
		"h": 1.6263736264
	},
	{
		"stop_id": 8530636,
		"ID": 968,
		"x": 30.0197598633,
		"y": 36.258216485,
		"h": 1.6263736264
	},
	{
		"stop_id": 8530742,
		"ID": 968,
		"x": 27.5477059813,
		"y": 38.855143775,
		"h": 1.6263736264
	},
	{
		"stop_id": 8530743,
		"ID": 968,
		"x": 28.9807172313,
		"y": 38.377212117,
		"h": 1.6263736264
	},
	{
		"stop_id": 8530857,
		"ID": 968,
		"x": 30.6447730023,
		"y": 37.956162772,
		"h": 1.6263736264
	},
	{
		"stop_id": 8577537,
		"ID": 968,
		"x": 26.4577221193,
		"y": 38.890182314,
		"h": 1.6263736264
	},
	{
		"stop_id": 8577538,
		"ID": 968,
		"x": 27.3127137923,
		"y": 38.810229498,
		"h": 1.6263736264
	},
	{
		"stop_id": 8577539,
		"ID": 968,
		"x": 28.9577566583,
		"y": 38.650168217,
		"h": 1.6263736264
	},
	{
		"stop_id": 8577571,
		"ID": 968,
		"x": 29.4277549623,
		"y": 38.495190556,
		"h": 1.6263736264
	},
	{
		"stop_id": 8577572,
		"ID": 968,
		"x": 29.5277015803,
		"y": 38.610210999,
		"h": 1.6263736264
	},
	{
		"stop_id": 8577596,
		"ID": 968,
		"x": 30.0777505663,
		"y": 38.260239509,
		"h": 1.6263736264
	},
	{
		"stop_id": 8577597,
		"ID": 968,
		"x": 31.1077271283,
		"y": 37.235153434,
		"h": 1.6263736264
	},
	{
		"stop_id": 8577598,
		"ID": 968,
		"x": 31.4977606483,
		"y": 36.510170804,
		"h": 1.6263736264
	},
	{
		"stop_id": 8595726,
		"ID": 968,
		"x": 27.7277657763,
		"y": 39.220145702,
		"h": 1.6263736264
	},
	{
		"stop_id": 8595727,
		"ID": 968,
		"x": 26.5677279903,
		"y": 38.100239002,
		"h": 1.6263736264
	},
	{
		"stop_id": 8502350,
		"ID": 654,
		"x": -24.7642722727,
		"y": 53.602143634,
		"h": 1.2307692308
	},
	{
		"stop_id": 8502351,
		"ID": 654,
		"x": -25.1762324787,
		"y": 52.982236702,
		"h": 1.2307692308
	},
	{
		"stop_id": 8502366,
		"ID": 654,
		"x": -25.2202799887,
		"y": 51.94022034,
		"h": 1.2307692308
	},
	{
		"stop_id": 8502388,
		"ID": 654,
		"x": -28.9632966417,
		"y": 51.767243335,
		"h": 1.2307692308
	},
	{
		"stop_id": 8572699,
		"ID": 654,
		"x": -29.4092695247,
		"y": 51.813204426,
		"h": 1.2307692308
	},
	{
		"stop_id": 8572706,
		"ID": 654,
		"x": -25.0652672067,
		"y": 53.302193599,
		"h": 1.2307692308
	},
	{
		"stop_id": 8572707,
		"ID": 654,
		"x": -25.3972419687,
		"y": 52.255170022,
		"h": 1.2307692308
	},
	{
		"stop_id": 8572710,
		"ID": 654,
		"x": -24.8512730937,
		"y": 48.412191844,
		"h": 1.2307692308
	},
	{
		"stop_id": 8502555,
		"ID": 877,
		"x": 12.6907385243,
		"y": 52.6192077,
		"h": 1.4285714286
	},
	{
		"stop_id": 8502556,
		"ID": 877,
		"x": 11.6237724603,
		"y": 52.133193011,
		"h": 1.4285714286
	},
	{
		"stop_id": 8502778,
		"ID": 877,
		"x": 14.5557299353,
		"y": 52.466236051,
		"h": 1.4285714286
	},
	{
		"stop_id": 8502882,
		"ID": 877,
		"x": 15.0577700863,
		"y": 49.455148205,
		"h": 1.4285714286
	},
	{
		"stop_id": 8502884,
		"ID": 877,
		"x": 15.3697282463,
		"y": 52.752219341,
		"h": 1.4285714286
	},
	{
		"stop_id": 8502890,
		"ID": 877,
		"x": 11.1887217573,
		"y": 52.1552226,
		"h": 1.4285714286
	},
	{
		"stop_id": 8502960,
		"ID": 877,
		"x": 13.7607120203,
		"y": 52.573201571,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572604,
		"ID": 877,
		"x": 14.7557408663,
		"y": 53.326218133,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572608,
		"ID": 877,
		"x": 12.0417386963,
		"y": 52.360157792,
		"h": 1.4285714286
	},
	{
		"stop_id": 8573179,
		"ID": 877,
		"x": 15.4197043903,
		"y": 49.525204043,
		"h": 1.4285714286
	},
	{
		"stop_id": 8573194,
		"ID": 877,
		"x": 13.3747694773,
		"y": 53.231223567,
		"h": 1.4285714286
	},
	{
		"stop_id": 8573195,
		"ID": 877,
		"x": 15.4917622793,
		"y": 53.216192909,
		"h": 1.4285714286
	},
	{
		"stop_id": 8583481,
		"ID": 877,
		"x": 14.1427722943,
		"y": 52.459194349,
		"h": 1.4285714286
	},
	{
		"stop_id": 8583482,
		"ID": 877,
		"x": 14.9927756553,
		"y": 52.610147543,
		"h": 1.4285714286
	},
	{
		"stop_id": 8502559,
		"ID": 908,
		"x": 17.6667032563,
		"y": 64.32019621,
		"h": 4.7582417582
	},
	{
		"stop_id": 8503001,
		"ID": 908,
		"x": 19.5557581643,
		"y": 66.922159228,
		"h": 4.7582417582
	},
	{
		"stop_id": 8503053,
		"ID": 908,
		"x": 20.6607136693,
		"y": 63.99123101,
		"h": 4.7582417582
	},
	{
		"stop_id": 8503054,
		"ID": 908,
		"x": 20.0677725113,
		"y": 63.984218281,
		"h": 4.7582417582
	},
	{
		"stop_id": 8503055,
		"ID": 908,
		"x": 17.8597208383,
		"y": 64.048188739,
		"h": 4.7582417582
	},
	{
		"stop_id": 8503056,
		"ID": 908,
		"x": 18.7287273493,
		"y": 63.436179227,
		"h": 4.7582417582
	},
	{
		"stop_id": 8503578,
		"ID": 908,
		"x": 17.1347410083,
		"y": 63.400171629,
		"h": 4.7582417582
	},
	{
		"stop_id": 8503579,
		"ID": 908,
		"x": 16.7217694973,
		"y": 63.324224385,
		"h": 4.7582417582
	},
	{
		"stop_id": 8503580,
		"ID": 908,
		"x": 16.4877628213,
		"y": 64.283234364,
		"h": 4.7582417582
	},
	{
		"stop_id": 8503610,
		"ID": 908,
		"x": 20.0767203373,
		"y": 64.335149158,
		"h": 4.7582417582
	},
	{
		"stop_id": 8503699,
		"ID": 908,
		"x": 16.9587403693,
		"y": 64.559171302,
		"h": 4.7582417582
	},
	{
		"stop_id": 8503709,
		"ID": 908,
		"x": 17.5557077543,
		"y": 64.32219458,
		"h": 4.7582417582
	},
	{
		"stop_id": 8573711,
		"ID": 908,
		"x": 19.3047148453,
		"y": 64.333142268,
		"h": 4.7582417582
	},
	{
		"stop_id": 8573714,
		"ID": 908,
		"x": 17.8037293213,
		"y": 63.356180381,
		"h": 4.7582417582
	},
	{
		"stop_id": 8574610,
		"ID": 908,
		"x": 16.4577166933,
		"y": 65.157144189,
		"h": 4.7582417582
	},
	{
		"stop_id": 8574615,
		"ID": 908,
		"x": 16.5377173073,
		"y": 64.880195149,
		"h": 4.7582417582
	},
	{
		"stop_id": 8574658,
		"ID": 908,
		"x": 16.7497617083,
		"y": 64.732152724,
		"h": 4.7582417582
	},
	{
		"stop_id": 8574684,
		"ID": 908,
		"x": 17.3067220913,
		"y": 64.421248692,
		"h": 4.7582417582
	},
	{
		"stop_id": 8574739,
		"ID": 908,
		"x": 17.5867003123,
		"y": 63.94421498,
		"h": 4.7582417582
	},
	{
		"stop_id": 8574780,
		"ID": 908,
		"x": 18.1367275443,
		"y": 63.221223197,
		"h": 4.7582417582
	},
	{
		"stop_id": 8574898,
		"ID": 908,
		"x": 17.8157141073,
		"y": 63.618192254,
		"h": 4.7582417582
	},
	{
		"stop_id": 8575014,
		"ID": 908,
		"x": 17.7877068273,
		"y": 64.090166208,
		"h": 4.7582417582
	},
	{
		"stop_id": 8576240,
		"ID": 908,
		"x": 20.3277233873,
		"y": 68.10318205,
		"h": 4.7582417582
	},
	{
		"stop_id": 8580912,
		"ID": 908,
		"x": 20.5637246833,
		"y": 64.425232923,
		"h": 4.7582417582
	},
	{
		"stop_id": 8583613,
		"ID": 908,
		"x": 17.3847196683,
		"y": 63.698186099,
		"h": 4.7582417582
	},
	{
		"stop_id": 8590318,
		"ID": 908,
		"x": 18.8187681943,
		"y": 66.873200838,
		"h": 4.7582417582
	},
	{
		"stop_id": 8590725,
		"ID": 908,
		"x": 18.4137597843,
		"y": 68.468238697,
		"h": 4.7582417582
	},
	{
		"stop_id": 8590786,
		"ID": 908,
		"x": 16.4947597423,
		"y": 67.766178308,
		"h": 4.7582417582
	},
	{
		"stop_id": 8590788,
		"ID": 908,
		"x": 16.4627404543,
		"y": 67.438194487,
		"h": 4.7582417582
	},
	{
		"stop_id": 8590791,
		"ID": 908,
		"x": 17.4077366493,
		"y": 67.57518363,
		"h": 4.7582417582
	},
	{
		"stop_id": 8590793,
		"ID": 908,
		"x": 17.5847317783,
		"y": 67.949207524,
		"h": 4.7582417582
	},
	{
		"stop_id": 8590795,
		"ID": 908,
		"x": 17.9537546183,
		"y": 67.350150173,
		"h": 4.7582417582
	},
	{
		"stop_id": 8590799,
		"ID": 908,
		"x": 16.8847690623,
		"y": 67.92421097,
		"h": 4.7582417582
	},
	{
		"stop_id": 8590803,
		"ID": 908,
		"x": 16.9217402943,
		"y": 67.669169575,
		"h": 4.7582417582
	},
	{
		"stop_id": 8590804,
		"ID": 908,
		"x": 16.4177684313,
		"y": 67.524234742,
		"h": 4.7582417582
	},
	{
		"stop_id": 8590805,
		"ID": 908,
		"x": 16.3877672533,
		"y": 67.632150169,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591033,
		"ID": 908,
		"x": 20.4887618233,
		"y": 67.00421648,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591035,
		"ID": 908,
		"x": 20.0057185803,
		"y": 65.631249459,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591036,
		"ID": 908,
		"x": 19.2677210503,
		"y": 65.017145975,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591037,
		"ID": 908,
		"x": 19.2987368003,
		"y": 65.121190471,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591038,
		"ID": 908,
		"x": 21.1957160293,
		"y": 65.469142299,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591044,
		"ID": 908,
		"x": 18.0817038523,
		"y": 66.875148227,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591051,
		"ID": 908,
		"x": 19.1147234253,
		"y": 66.632175732,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591056,
		"ID": 908,
		"x": 19.5137323713,
		"y": 66.880233221,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591057,
		"ID": 908,
		"x": 19.6277392953,
		"y": 66.988170819,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591068,
		"ID": 908,
		"x": 19.2517611623,
		"y": 67.460162068,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591070,
		"ID": 908,
		"x": 19.6507029633,
		"y": 66.621209371,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591074,
		"ID": 908,
		"x": 21.0447487833,
		"y": 67.196241427,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591075,
		"ID": 908,
		"x": 21.4617009073,
		"y": 64.958182099,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591097,
		"ID": 908,
		"x": 19.4157624663,
		"y": 66.764172715,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591116,
		"ID": 908,
		"x": 18.1337480453,
		"y": 66.615197574,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591126,
		"ID": 908,
		"x": 19.5397185633,
		"y": 65.169219845,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591130,
		"ID": 908,
		"x": 18.1977347363,
		"y": 67.336231426,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591134,
		"ID": 908,
		"x": 19.7977740993,
		"y": 65.796243768,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591136,
		"ID": 908,
		"x": 18.9637109773,
		"y": 68.495202265,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591138,
		"ID": 908,
		"x": 20.3557215833,
		"y": 66.015247642,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591141,
		"ID": 908,
		"x": 18.4807311733,
		"y": 65.951170128,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591145,
		"ID": 908,
		"x": 21.2367098053,
		"y": 65.216183369,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591146,
		"ID": 908,
		"x": 20.4857172873,
		"y": 63.290241553,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591150,
		"ID": 908,
		"x": 20.6177539103,
		"y": 63.560224574,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591163,
		"ID": 908,
		"x": 19.5087079313,
		"y": 64.743162138,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591165,
		"ID": 908,
		"x": 19.6487019373,
		"y": 66.421147238,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591167,
		"ID": 908,
		"x": 19.5707126363,
		"y": 67.33922076,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591170,
		"ID": 908,
		"x": 20.8797222803,
		"y": 64.774218832,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591176,
		"ID": 908,
		"x": 20.1927242703,
		"y": 67.472228447,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591177,
		"ID": 908,
		"x": 21.5017480303,
		"y": 65.932222524,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591178,
		"ID": 908,
		"x": 20.7267068873,
		"y": 67.236167616,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591186,
		"ID": 908,
		"x": 21.0927276563,
		"y": 66.203164742,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591190,
		"ID": 908,
		"x": 20.9037336393,
		"y": 64.486224056,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591197,
		"ID": 908,
		"x": 19.6367127723,
		"y": 68.020160338,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591203,
		"ID": 908,
		"x": 20.3727435213,
		"y": 65.309183516,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591208,
		"ID": 908,
		"x": 20.6717253003,
		"y": 64.950190108,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591214,
		"ID": 908,
		"x": 19.7917185023,
		"y": 64.452183473,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591215,
		"ID": 908,
		"x": 18.4837125463,
		"y": 67.681250649,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591222,
		"ID": 908,
		"x": 20.0167617383,
		"y": 66.247181692,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591223,
		"ID": 908,
		"x": 20.2407712073,
		"y": 68.208196742,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591236,
		"ID": 908,
		"x": 21.0057385123,
		"y": 65.421183977,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591243,
		"ID": 908,
		"x": 20.4977597853,
		"y": 64.962175942,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591252,
		"ID": 908,
		"x": 20.6877084423,
		"y": 65.798249131,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591253,
		"ID": 908,
		"x": 20.3367372673,
		"y": 66.520250213,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591254,
		"ID": 908,
		"x": 20.1317482233,
		"y": 66.361146349,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591258,
		"ID": 908,
		"x": 19.3477689453,
		"y": 66.512192058,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591260,
		"ID": 908,
		"x": 18.3047210593,
		"y": 66.677157531,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591265,
		"ID": 908,
		"x": 19.9087371793,
		"y": 66.699171775,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591274,
		"ID": 908,
		"x": 18.4927678663,
		"y": 67.064140739,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591284,
		"ID": 908,
		"x": 18.4267192313,
		"y": 66.845220714,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591310,
		"ID": 908,
		"x": 18.4437298963,
		"y": 66.317170906,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591311,
		"ID": 908,
		"x": 19.2017287253,
		"y": 66.013214747,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591331,
		"ID": 908,
		"x": 20.0777346763,
		"y": 65.028222824,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591333,
		"ID": 908,
		"x": 18.2647362143,
		"y": 66.485158005,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591334,
		"ID": 908,
		"x": 20.6527144333,
		"y": 66.390208545,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591344,
		"ID": 908,
		"x": 19.9817353053,
		"y": 64.792204109,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591345,
		"ID": 908,
		"x": 18.7227724413,
		"y": 66.145175988,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591351,
		"ID": 908,
		"x": 20.6347495883,
		"y": 63.967194979,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591361,
		"ID": 908,
		"x": 19.2087615273,
		"y": 66.953217681,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591363,
		"ID": 908,
		"x": 19.9947231393,
		"y": 65.494223779,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591371,
		"ID": 908,
		"x": 19.8787367903,
		"y": 68.442161897,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591372,
		"ID": 908,
		"x": 19.5277496883,
		"y": 66.504145237,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591374,
		"ID": 908,
		"x": 20.7677506043,
		"y": 66.966192782,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591390,
		"ID": 908,
		"x": 21.1517023203,
		"y": 64.549202413,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591398,
		"ID": 908,
		"x": 21.1917241233,
		"y": 66.784164683,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591401,
		"ID": 908,
		"x": 20.1847289983,
		"y": 64.14023974,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591402,
		"ID": 908,
		"x": 19.9537091343,
		"y": 67.650141303,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591408,
		"ID": 908,
		"x": 19.1537068943,
		"y": 65.621178727,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591413,
		"ID": 908,
		"x": 19.1847550683,
		"y": 67.236216481,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591423,
		"ID": 908,
		"x": 19.7417665523,
		"y": 68.180241555,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591428,
		"ID": 908,
		"x": 19.0237194673,
		"y": 67.621245959,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591431,
		"ID": 908,
		"x": 20.0667308163,
		"y": 68.328161607,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591434,
		"ID": 908,
		"x": 19.9677385983,
		"y": 67.881166689,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591435,
		"ID": 908,
		"x": 19.3437286993,
		"y": 68.285217015,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591436,
		"ID": 908,
		"x": 19.3257459833,
		"y": 68.241166901,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591441,
		"ID": 908,
		"x": 20.2577098023,
		"y": 63.30016959,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591446,
		"ID": 908,
		"x": 20.1337016113,
		"y": 68.12024362,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591448,
		"ID": 908,
		"x": 21.4527436883,
		"y": 65.30320098,
		"h": 4.7582417582
	},
	{
		"stop_id": 8591896,
		"ID": 908,
		"x": 19.8297007513,
		"y": 67.012228987,
		"h": 4.7582417582
	},
	{
		"stop_id": 8502561,
		"ID": 830,
		"x": 2.1687318153,
		"y": 69.529172166,
		"h": 2.3516483516
	},
	{
		"stop_id": 8502700,
		"ID": 830,
		"x": 4.4307574033,
		"y": 69.212227993,
		"h": 2.3516483516
	},
	{
		"stop_id": 8502706,
		"ID": 830,
		"x": 2.3587729873,
		"y": 70.068207827,
		"h": 2.3516483516
	},
	{
		"stop_id": 8502707,
		"ID": 830,
		"x": 3.4347242493,
		"y": 70.832233247,
		"h": 2.3516483516
	},
	{
		"stop_id": 8502752,
		"ID": 830,
		"x": 1.8777470503,
		"y": 66.202142828,
		"h": 2.3516483516
	},
	{
		"stop_id": 8502753,
		"ID": 830,
		"x": 4.6277740753,
		"y": 66.437184878,
		"h": 2.3516483516
	},
	{
		"stop_id": 8502757,
		"ID": 830,
		"x": 3.6947012343,
		"y": 68.06616272,
		"h": 2.3516483516
	},
	{
		"stop_id": 8502772,
		"ID": 830,
		"x": 5.5747602973,
		"y": 70.420251299,
		"h": 2.3516483516
	},
	{
		"stop_id": 8502880,
		"ID": 830,
		"x": 6.4697286493,
		"y": 68.555185776,
		"h": 2.3516483516
	},
	{
		"stop_id": 8502888,
		"ID": 830,
		"x": 3.1407569143,
		"y": 69.695188685,
		"h": 2.3516483516
	},
	{
		"stop_id": 8502897,
		"ID": 830,
		"x": 6.0377259173,
		"y": 67.713224097,
		"h": 2.3516483516
	},
	{
		"stop_id": 8502899,
		"ID": 830,
		"x": 1.9987382233,
		"y": 69.069185988,
		"h": 2.3516483516
	},
	{
		"stop_id": 8502962,
		"ID": 830,
		"x": 3.3797655783,
		"y": 69.107202098,
		"h": 2.3516483516
	},
	{
		"stop_id": 8502984,
		"ID": 830,
		"x": 5.4877664463,
		"y": 66.786160842,
		"h": 2.3516483516
	},
	{
		"stop_id": 8503881,
		"ID": 830,
		"x": 3.1807395483,
		"y": 70.911142679,
		"h": 2.3516483516
	},
	{
		"stop_id": 8516219,
		"ID": 830,
		"x": 3.4617336263,
		"y": 70.797162959,
		"h": 2.3516483516
	},
	{
		"stop_id": 8572539,
		"ID": 830,
		"x": 3.5247003973,
		"y": 69.755205899,
		"h": 2.3516483516
	},
	{
		"stop_id": 8572540,
		"ID": 830,
		"x": 5.5527086473,
		"y": 68.039204392,
		"h": 2.3516483516
	},
	{
		"stop_id": 8572541,
		"ID": 830,
		"x": 5.8357194903,
		"y": 67.698197918,
		"h": 2.3516483516
	},
	{
		"stop_id": 8572542,
		"ID": 830,
		"x": 5.6497088743,
		"y": 67.369244432,
		"h": 2.3516483516
	},
	{
		"stop_id": 8572543,
		"ID": 830,
		"x": 4.7867549463,
		"y": 66.538205777,
		"h": 2.3516483516
	},
	{
		"stop_id": 8572546,
		"ID": 830,
		"x": 3.2747029513,
		"y": 70.008166374,
		"h": 2.3516483516
	},
	{
		"stop_id": 8572547,
		"ID": 830,
		"x": 2.1767012273,
		"y": 69.012224296,
		"h": 2.3516483516
	},
	{
		"stop_id": 8572548,
		"ID": 830,
		"x": 3.1527740283,
		"y": 69.409224975,
		"h": 2.3516483516
	},
	{
		"stop_id": 8572549,
		"ID": 830,
		"x": 3.8267529233,
		"y": 68.479201683,
		"h": 2.3516483516
	},
	{
		"stop_id": 8572555,
		"ID": 830,
		"x": 4.6027041593,
		"y": 71.322150243,
		"h": 2.3516483516
	},
	{
		"stop_id": 8572556,
		"ID": 830,
		"x": 5.0097006703,
		"y": 70.629199508,
		"h": 2.3516483516
	},
	{
		"stop_id": 8572558,
		"ID": 830,
		"x": 5.9477254613,
		"y": 70.069234008,
		"h": 2.3516483516
	},
	{
		"stop_id": 8572562,
		"ID": 830,
		"x": 5.6647735333,
		"y": 70.011174225,
		"h": 2.3516483516
	},
	{
		"stop_id": 8572563,
		"ID": 830,
		"x": 6.1947135253,
		"y": 69.412174561,
		"h": 2.3516483516
	},
	{
		"stop_id": 8572564,
		"ID": 830,
		"x": 6.4007108393,
		"y": 68.821159951,
		"h": 2.3516483516
	},
	{
		"stop_id": 8572565,
		"ID": 830,
		"x": 6.1387601083,
		"y": 68.064149995,
		"h": 2.3516483516
	},
	{
		"stop_id": 8572611,
		"ID": 830,
		"x": 1.6727449913,
		"y": 66.259167207,
		"h": 2.3516483516
	},
	{
		"stop_id": 8572612,
		"ID": 830,
		"x": 1.7857613823,
		"y": 66.41422431,
		"h": 2.3516483516
	},
	{
		"stop_id": 8579963,
		"ID": 830,
		"x": 4.4387405823,
		"y": 71.400205613,
		"h": 2.3516483516
	},
	{
		"stop_id": 8580634,
		"ID": 830,
		"x": 0.7157445013,
		"y": 68.97923246,
		"h": 2.3516483516
	},
	{
		"stop_id": 8581623,
		"ID": 830,
		"x": 2.0947468613,
		"y": 66.233200799,
		"h": 2.3516483516
	},
	{
		"stop_id": 8581624,
		"ID": 830,
		"x": 2.1367662923,
		"y": 66.396197048,
		"h": 2.3516483516
	},
	{
		"stop_id": 8582461,
		"ID": 830,
		"x": 5.3037731203,
		"y": 70.435170321,
		"h": 2.3516483516
	},
	{
		"stop_id": 8582713,
		"ID": 830,
		"x": 4.3767300803,
		"y": 67.565146505,
		"h": 2.3516483516
	},
	{
		"stop_id": 8582879,
		"ID": 830,
		"x": 2.9257556363,
		"y": 69.195224876,
		"h": 2.3516483516
	},
	{
		"stop_id": 8583561,
		"ID": 830,
		"x": 5.4227056533,
		"y": 70.825200118,
		"h": 2.3516483516
	},
	{
		"stop_id": 8502690,
		"ID": 831,
		"x": 4.9147100153,
		"y": 75.317207586,
		"h": 3.4725274725
	},
	{
		"stop_id": 8502774,
		"ID": 831,
		"x": 4.5797049413,
		"y": 71.682158206,
		"h": 3.4725274725
	},
	{
		"stop_id": 8502775,
		"ID": 831,
		"x": 1.1097383223,
		"y": 74.440142224,
		"h": 3.4725274725
	},
	{
		"stop_id": 8502874,
		"ID": 831,
		"x": 0.5857248873,
		"y": 74.086194462,
		"h": 3.4725274725
	},
	{
		"stop_id": 8502983,
		"ID": 831,
		"x": 4.4467536293,
		"y": 74.925165065,
		"h": 3.4725274725
	},
	{
		"stop_id": 8503504,
		"ID": 831,
		"x": 5.7677199563,
		"y": 76.19822681,
		"h": 3.4725274725
	},
	{
		"stop_id": 8503505,
		"ID": 831,
		"x": 6.4137515743,
		"y": 74.339163838,
		"h": 3.4725274725
	},
	{
		"stop_id": 8572387,
		"ID": 831,
		"x": 5.6227453643,
		"y": 75.646221057,
		"h": 3.4725274725
	},
	{
		"stop_id": 8572513,
		"ID": 831,
		"x": 0.7587257563,
		"y": 74.786239212,
		"h": 3.4725274725
	},
	{
		"stop_id": 8572514,
		"ID": 831,
		"x": 1.5567726193,
		"y": 74.314217141,
		"h": 3.4725274725
	},
	{
		"stop_id": 8572515,
		"ID": 831,
		"x": 2.0057461073,
		"y": 74.192237629,
		"h": 3.4725274725
	},
	{
		"stop_id": 8572518,
		"ID": 831,
		"x": 0.9277707813,
		"y": 73.926240185,
		"h": 3.4725274725
	},
	{
		"stop_id": 8572551,
		"ID": 831,
		"x": 4.5807138863,
		"y": 73.172239701,
		"h": 3.4725274725
	},
	{
		"stop_id": 8572552,
		"ID": 831,
		"x": 4.8397755083,
		"y": 72.524147279,
		"h": 3.4725274725
	},
	{
		"stop_id": 8572553,
		"ID": 831,
		"x": 4.6367323203,
		"y": 72.092182644,
		"h": 3.4725274725
	},
	{
		"stop_id": 8572554,
		"ID": 831,
		"x": 5.1307169123,
		"y": 71.815149861,
		"h": 3.4725274725
	},
	{
		"stop_id": 8572580,
		"ID": 831,
		"x": 5.7867452983,
		"y": 75.651148498,
		"h": 3.4725274725
	},
	{
		"stop_id": 8572582,
		"ID": 831,
		"x": 6.0437081233,
		"y": 75.825236287,
		"h": 3.4725274725
	},
	{
		"stop_id": 8578668,
		"ID": 831,
		"x": 5.4237550583,
		"y": 76.470185408,
		"h": 3.4725274725
	},
	{
		"stop_id": 8578669,
		"ID": 831,
		"x": 4.6827552863,
		"y": 76.954207268,
		"h": 3.4725274725
	},
	{
		"stop_id": 8578670,
		"ID": 831,
		"x": 4.1887437863,
		"y": 76.947179838,
		"h": 3.4725274725
	},
	{
		"stop_id": 8578671,
		"ID": 831,
		"x": 3.9517307573,
		"y": 76.901146925,
		"h": 3.4725274725
	},
	{
		"stop_id": 8578672,
		"ID": 831,
		"x": 3.5987493993,
		"y": 76.81618655,
		"h": 3.4725274725
	},
	{
		"stop_id": 8578681,
		"ID": 831,
		"x": 3.6777418363,
		"y": 73.742247121,
		"h": 3.4725274725
	},
	{
		"stop_id": 8578682,
		"ID": 831,
		"x": 2.5337486203,
		"y": 71.828183064,
		"h": 3.4725274725
	},
	{
		"stop_id": 8578683,
		"ID": 831,
		"x": 3.5727074773,
		"y": 74.149194669,
		"h": 3.4725274725
	},
	{
		"stop_id": 8578914,
		"ID": 831,
		"x": 5.6947083783,
		"y": 76.147159807,
		"h": 3.4725274725
	},
	{
		"stop_id": 8579815,
		"ID": 831,
		"x": 4.6947627263,
		"y": 72.513227041,
		"h": 3.4725274725
	},
	{
		"stop_id": 8580311,
		"ID": 831,
		"x": 4.3297617943,
		"y": 73.940185051,
		"h": 3.4725274725
	},
	{
		"stop_id": 8580315,
		"ID": 831,
		"x": 4.6347278003,
		"y": 71.749248293,
		"h": 3.4725274725
	},
	{
		"stop_id": 8580638,
		"ID": 831,
		"x": 5.6717172413,
		"y": 75.915180562,
		"h": 3.4725274725
	},
	{
		"stop_id": 8580730,
		"ID": 831,
		"x": 2.4027398703,
		"y": 74.038167787,
		"h": 3.4725274725
	},
	{
		"stop_id": 8581719,
		"ID": 831,
		"x": 2.9597628913,
		"y": 71.892166121,
		"h": 3.4725274725
	},
	{
		"stop_id": 8581730,
		"ID": 831,
		"x": 3.0977384633,
		"y": 71.999148732,
		"h": 3.4725274725
	},
	{
		"stop_id": 8587346,
		"ID": 831,
		"x": 6.5117242733,
		"y": 74.122212379,
		"h": 3.4725274725
	},
	{
		"stop_id": 8590164,
		"ID": 831,
		"x": 4.1957308233,
		"y": 74.919222955,
		"h": 3.4725274725
	},
	{
		"stop_id": 8590165,
		"ID": 831,
		"x": 3.6357601723,
		"y": 75.507185394,
		"h": 3.4725274725
	},
	{
		"stop_id": 8590166,
		"ID": 831,
		"x": 4.1177393953,
		"y": 73.97125102,
		"h": 3.4725274725
	},
	{
		"stop_id": 8590167,
		"ID": 831,
		"x": 5.1777467193,
		"y": 75.910184521,
		"h": 3.4725274725
	},
	{
		"stop_id": 8590168,
		"ID": 831,
		"x": 4.8657359063,
		"y": 75.887199345,
		"h": 3.4725274725
	},
	{
		"stop_id": 8590169,
		"ID": 831,
		"x": 5.6667632893,
		"y": 74.774182793,
		"h": 3.4725274725
	},
	{
		"stop_id": 8590170,
		"ID": 831,
		"x": 4.2687396543,
		"y": 75.858249614,
		"h": 3.4725274725
	},
	{
		"stop_id": 8590171,
		"ID": 831,
		"x": 4.4857637043,
		"y": 75.881172069,
		"h": 3.4725274725
	},
	{
		"stop_id": 8590173,
		"ID": 831,
		"x": 5.5737374613,
		"y": 76.13815076,
		"h": 3.4725274725
	},
	{
		"stop_id": 8590175,
		"ID": 831,
		"x": 4.2847333203,
		"y": 74.777192694,
		"h": 3.4725274725
	},
	{
		"stop_id": 8590176,
		"ID": 831,
		"x": 4.6597738603,
		"y": 77.071153964,
		"h": 3.4725274725
	},
	{
		"stop_id": 8590177,
		"ID": 831,
		"x": 5.6527036453,
		"y": 75.050228423,
		"h": 3.4725274725
	},
	{
		"stop_id": 8590179,
		"ID": 831,
		"x": 5.7197628593,
		"y": 74.434187914,
		"h": 3.4725274725
	},
	{
		"stop_id": 8590180,
		"ID": 831,
		"x": 5.4337695383,
		"y": 75.862184426,
		"h": 3.4725274725
	},
	{
		"stop_id": 8590181,
		"ID": 831,
		"x": 3.9667511333,
		"y": 76.045239777,
		"h": 3.4725274725
	},
	{
		"stop_id": 8590182,
		"ID": 831,
		"x": 3.7547528953,
		"y": 76.060195549,
		"h": 3.4725274725
	},
	{
		"stop_id": 8590183,
		"ID": 831,
		"x": 4.5917694523,
		"y": 75.270211574,
		"h": 3.4725274725
	},
	{
		"stop_id": 8590184,
		"ID": 831,
		"x": 5.5427081413,
		"y": 75.452196494,
		"h": 3.4725274725
	},
	{
		"stop_id": 8590185,
		"ID": 831,
		"x": 4.1647707453,
		"y": 73.303165316,
		"h": 3.4725274725
	},
	{
		"stop_id": 8590186,
		"ID": 831,
		"x": 4.9097749103,
		"y": 77.031183095,
		"h": 3.4725274725
	},
	{
		"stop_id": 8590187,
		"ID": 831,
		"x": 5.2897461143,
		"y": 76.667189421,
		"h": 3.4725274725
	},
	{
		"stop_id": 8590188,
		"ID": 831,
		"x": 4.0157688823,
		"y": 73.433208872,
		"h": 3.4725274725
	},
	{
		"stop_id": 8590189,
		"ID": 831,
		"x": 5.5457420233,
		"y": 75.956153381,
		"h": 3.4725274725
	},
	{
		"stop_id": 8590190,
		"ID": 831,
		"x": 5.8047723763,
		"y": 76.215204891,
		"h": 3.4725274725
	},
	{
		"stop_id": 8590191,
		"ID": 831,
		"x": 5.1307140303,
		"y": 75.359156195,
		"h": 3.4725274725
	},
	{
		"stop_id": 8590192,
		"ID": 831,
		"x": 5.7387054843,
		"y": 75.918145428,
		"h": 3.4725274725
	},
	{
		"stop_id": 8590193,
		"ID": 831,
		"x": 6.1037374963,
		"y": 74.929249472,
		"h": 3.4725274725
	},
	{
		"stop_id": 8590194,
		"ID": 831,
		"x": 4.3677061033,
		"y": 75.011148944,
		"h": 3.4725274725
	},
	{
		"stop_id": 8590195,
		"ID": 831,
		"x": 5.4007027223,
		"y": 75.962226923,
		"h": 3.4725274725
	},
	{
		"stop_id": 8590197,
		"ID": 831,
		"x": 5.7037112943,
		"y": 76.403224537,
		"h": 3.4725274725
	},
	{
		"stop_id": 8590199,
		"ID": 831,
		"x": 4.6987072423,
		"y": 75.157181078,
		"h": 3.4725274725
	},
	{
		"stop_id": 8590238,
		"ID": 831,
		"x": 3.8167226553,
		"y": 72.563222216,
		"h": 3.4725274725
	},
	{
		"stop_id": 8590246,
		"ID": 831,
		"x": 6.0387139243,
		"y": 73.75122618,
		"h": 3.4725274725
	},
	{
		"stop_id": 8590250,
		"ID": 831,
		"x": 5.9567354943,
		"y": 74.213207038,
		"h": 3.4725274725
	},
	{
		"stop_id": 8590251,
		"ID": 831,
		"x": 5.1437520043,
		"y": 77.126146059,
		"h": 3.4725274725
	},
	{
		"stop_id": 8590304,
		"ID": 831,
		"x": 6.3567559083,
		"y": 74.277148997,
		"h": 3.4725274725
	},
	{
		"stop_id": 8590308,
		"ID": 831,
		"x": 6.2407558883,
		"y": 74.698161803,
		"h": 3.4725274725
	},
	{
		"stop_id": 8590394,
		"ID": 831,
		"x": 4.0967462253,
		"y": 73.708168164,
		"h": 3.4725274725
	},
	{
		"stop_id": 8591708,
		"ID": 831,
		"x": 5.7317485093,
		"y": 75.695238961,
		"h": 3.4725274725
	},
	{
		"stop_id": 8591709,
		"ID": 831,
		"x": 5.3707746243,
		"y": 76.729236644,
		"h": 3.4725274725
	},
	{
		"stop_id": 8594972,
		"ID": 831,
		"x": 6.8577573963,
		"y": 74.440213947,
		"h": 3.4725274725
	},
	{
		"stop_id": 8502692,
		"ID": 1001,
		"x": 31.4677416933,
		"y": 35.100189125,
		"h": 1.5274725275
	},
	{
		"stop_id": 8503282,
		"ID": 1001,
		"x": 34.0767248803,
		"y": 35.368207268,
		"h": 1.5274725275
	},
	{
		"stop_id": 8503290,
		"ID": 1001,
		"x": 33.6787718663,
		"y": 33.97421762,
		"h": 1.5274725275
	},
	{
		"stop_id": 8503714,
		"ID": 1001,
		"x": 30.9977229413,
		"y": 33.710178347,
		"h": 1.5274725275
	},
	{
		"stop_id": 8530412,
		"ID": 1001,
		"x": 32.2607748853,
		"y": 31.078191106,
		"h": 1.5274725275
	},
	{
		"stop_id": 8530634,
		"ID": 1001,
		"x": 31.5437727303,
		"y": 35.370204695,
		"h": 1.5274725275
	},
	{
		"stop_id": 8530635,
		"ID": 1001,
		"x": 31.4517225663,
		"y": 35.105169616,
		"h": 1.5274725275
	},
	{
		"stop_id": 8577599,
		"ID": 1001,
		"x": 31.6477695133,
		"y": 35.880148187,
		"h": 1.5274725275
	},
	{
		"stop_id": 8577600,
		"ID": 1001,
		"x": 31.5577388483,
		"y": 35.38520669,
		"h": 1.5274725275
	},
	{
		"stop_id": 8577601,
		"ID": 1001,
		"x": 31.1477147883,
		"y": 34.500223772,
		"h": 1.5274725275
	},
	{
		"stop_id": 8577602,
		"ID": 1001,
		"x": 30.7777386133,
		"y": 33.310228942,
		"h": 1.5274725275
	},
	{
		"stop_id": 8577605,
		"ID": 1001,
		"x": 31.0637563983,
		"y": 32.571188202,
		"h": 1.5274725275
	},
	{
		"stop_id": 8587534,
		"ID": 1001,
		"x": 33.6867467833,
		"y": 33.940208121,
		"h": 1.5274725275
	},
	{
		"stop_id": 8587535,
		"ID": 1001,
		"x": 34.0807193543,
		"y": 35.341140331,
		"h": 1.5274725275
	},
	{
		"stop_id": 8588109,
		"ID": 1001,
		"x": 34.1707381183,
		"y": 35.188230277,
		"h": 1.5274725275
	},
	{
		"stop_id": 8588110,
		"ID": 1001,
		"x": 34.0877134453,
		"y": 34.950202572,
		"h": 1.5274725275
	},
	{
		"stop_id": 8588236,
		"ID": 1001,
		"x": 34.3597367103,
		"y": 35.863234461,
		"h": 1.5274725275
	},
	{
		"stop_id": 8502749,
		"ID": 800,
		"x": 0.2187266933,
		"y": 39.73125083,
		"h": 1.4615384615
	},
	{
		"stop_id": 8577102,
		"ID": 800,
		"x": 1.4517573333,
		"y": 41.927177755,
		"h": 1.4615384615
	},
	{
		"stop_id": 8577249,
		"ID": 800,
		"x": -0.4712924077,
		"y": 41.066184021,
		"h": 1.4615384615
	},
	{
		"stop_id": 8577250,
		"ID": 800,
		"x": -1.3382702927,
		"y": 42.819168242,
		"h": 1.4615384615
	},
	{
		"stop_id": 8577251,
		"ID": 800,
		"x": -1.3352918257,
		"y": 43.172198466,
		"h": 1.4615384615
	},
	{
		"stop_id": 8577252,
		"ID": 800,
		"x": -1.3782447667,
		"y": 43.57114094,
		"h": 1.4615384615
	},
	{
		"stop_id": 8577253,
		"ID": 800,
		"x": -1.6022294807,
		"y": 44.478191296,
		"h": 1.4615384615
	},
	{
		"stop_id": 8577263,
		"ID": 800,
		"x": 1.0767390383,
		"y": 43.233165652,
		"h": 1.4615384615
	},
	{
		"stop_id": 8577264,
		"ID": 800,
		"x": 0.7067454693,
		"y": 44.172218189,
		"h": 1.4615384615
	},
	{
		"stop_id": 8577265,
		"ID": 800,
		"x": 0.3087351613,
		"y": 44.850178179,
		"h": 1.4615384615
	},
	{
		"stop_id": 8577266,
		"ID": 800,
		"x": 0.2577630403,
		"y": 45.170202121,
		"h": 1.4615384615
	},
	{
		"stop_id": 8583508,
		"ID": 800,
		"x": -3.8022632157,
		"y": 41.057184768,
		"h": 1.4615384615
	},
	{
		"stop_id": 8583550,
		"ID": 800,
		"x": -4.5012450077,
		"y": 42.271197006,
		"h": 1.4615384615
	},
	{
		"stop_id": 8589987,
		"ID": 800,
		"x": 0.1357215263,
		"y": 39.990245233,
		"h": 1.4615384615
	},
	{
		"stop_id": 8589988,
		"ID": 800,
		"x": 0.0007314793,
		"y": 40.049149089,
		"h": 1.4615384615
	},
	{
		"stop_id": 8502758,
		"ID": 937,
		"x": 23.1077349703,
		"y": 50.655143819,
		"h": 1.5604395604
	},
	{
		"stop_id": 8502762,
		"ID": 937,
		"x": 22.1297448343,
		"y": 54.133141553,
		"h": 1.5604395604
	},
	{
		"stop_id": 8502763,
		"ID": 937,
		"x": 21.8887018183,
		"y": 52.665238307,
		"h": 1.5604395604
	},
	{
		"stop_id": 8502764,
		"ID": 937,
		"x": 22.2577216733,
		"y": 52.230236029,
		"h": 1.5604395604
	},
	{
		"stop_id": 8502961,
		"ID": 937,
		"x": 23.6137510113,
		"y": 50.002205727,
		"h": 1.5604395604
	},
	{
		"stop_id": 8502963,
		"ID": 937,
		"x": 22.8577746833,
		"y": 51.13021948,
		"h": 1.5604395604
	},
	{
		"stop_id": 8502986,
		"ID": 937,
		"x": 24.3637508923,
		"y": 48.733215561,
		"h": 1.5604395604
	},
	{
		"stop_id": 8502991,
		"ID": 937,
		"x": 22.6257339483,
		"y": 48.753235093,
		"h": 1.5604395604
	},
	{
		"stop_id": 8503098,
		"ID": 937,
		"x": 24.9267248163,
		"y": 53.297193691,
		"h": 1.5604395604
	},
	{
		"stop_id": 8503695,
		"ID": 937,
		"x": 21.5307287903,
		"y": 53.165237655,
		"h": 1.5604395604
	},
	{
		"stop_id": 8573158,
		"ID": 937,
		"x": 21.9137681933,
		"y": 53.974168491,
		"h": 1.5604395604
	},
	{
		"stop_id": 8573159,
		"ID": 937,
		"x": 22.6657214683,
		"y": 54.101195664,
		"h": 1.5604395604
	},
	{
		"stop_id": 8573169,
		"ID": 937,
		"x": 22.5577492523,
		"y": 50.555212404,
		"h": 1.5604395604
	},
	{
		"stop_id": 8573170,
		"ID": 937,
		"x": 21.1077508423,
		"y": 50.405211691,
		"h": 1.5604395604
	},
	{
		"stop_id": 8573176,
		"ID": 937,
		"x": 21.3857052133,
		"y": 52.285195876,
		"h": 1.5604395604
	},
	{
		"stop_id": 8573182,
		"ID": 937,
		"x": 23.2867122353,
		"y": 50.239239314,
		"h": 1.5604395604
	},
	{
		"stop_id": 8573184,
		"ID": 937,
		"x": 23.0577480753,
		"y": 48.580225827,
		"h": 1.5604395604
	},
	{
		"stop_id": 8590807,
		"ID": 937,
		"x": 24.9127360103,
		"y": 53.312227262,
		"h": 1.5604395604
	},
	{
		"stop_id": 8502760,
		"ID": 1003,
		"x": 33.7077301443,
		"y": 43.280160316,
		"h": 2.7472527473
	},
	{
		"stop_id": 8502954,
		"ID": 1003,
		"x": 32.8077163813,
		"y": 46.120219433,
		"h": 2.7472527473
	},
	{
		"stop_id": 8503286,
		"ID": 1003,
		"x": 34.7837262983,
		"y": 44.914204844,
		"h": 2.7472527473
	},
	{
		"stop_id": 8503287,
		"ID": 1003,
		"x": 35.2627329863,
		"y": 46.826205647,
		"h": 2.7472527473
	},
	{
		"stop_id": 8503293,
		"ID": 1003,
		"x": 34.8707616063,
		"y": 45.665236297,
		"h": 2.7472527473
	},
	{
		"stop_id": 8503294,
		"ID": 1003,
		"x": 36.7477395283,
		"y": 45.525170696,
		"h": 2.7472527473
	},
	{
		"stop_id": 8503758,
		"ID": 1003,
		"x": 31.6447368713,
		"y": 45.184244509,
		"h": 2.7472527473
	},
	{
		"stop_id": 8503797,
		"ID": 1003,
		"x": 33.4857014163,
		"y": 47.985140191,
		"h": 2.7472527473
	},
	{
		"stop_id": 8503864,
		"ID": 1003,
		"x": 32.4227443163,
		"y": 45.779222722,
		"h": 2.7472527473
	},
	{
		"stop_id": 8503865,
		"ID": 1003,
		"x": 32.4827251263,
		"y": 43.77818075,
		"h": 2.7472527473
	},
	{
		"stop_id": 8503868,
		"ID": 1003,
		"x": 31.8587342373,
		"y": 47.173168079,
		"h": 2.7472527473
	},
	{
		"stop_id": 8503869,
		"ID": 1003,
		"x": 32.7627649803,
		"y": 48.039223093,
		"h": 2.7472527473
	},
	{
		"stop_id": 8573567,
		"ID": 1003,
		"x": 31.0477539943,
		"y": 45.079142088,
		"h": 2.7472527473
	},
	{
		"stop_id": 8573568,
		"ID": 1003,
		"x": 32.0237659243,
		"y": 45.503192939,
		"h": 2.7472527473
	},
	{
		"stop_id": 8573569,
		"ID": 1003,
		"x": 33.0217715533,
		"y": 46.636143381,
		"h": 2.7472527473
	},
	{
		"stop_id": 8573570,
		"ID": 1003,
		"x": 33.1257640053,
		"y": 47.337155717,
		"h": 2.7472527473
	},
	{
		"stop_id": 8573579,
		"ID": 1003,
		"x": 31.7187361473,
		"y": 44.72416785,
		"h": 2.7472527473
	},
	{
		"stop_id": 8573580,
		"ID": 1003,
		"x": 32.2167478283,
		"y": 44.070159599,
		"h": 2.7472527473
	},
	{
		"stop_id": 8576108,
		"ID": 1003,
		"x": 36.2607294303,
		"y": 46.440173332,
		"h": 2.7472527473
	},
	{
		"stop_id": 8576109,
		"ID": 1003,
		"x": 35.8557005693,
		"y": 46.464223174,
		"h": 2.7472527473
	},
	{
		"stop_id": 8576110,
		"ID": 1003,
		"x": 35.9787418203,
		"y": 46.404158575,
		"h": 2.7472527473
	},
	{
		"stop_id": 8576112,
		"ID": 1003,
		"x": 35.6717611933,
		"y": 46.518197654,
		"h": 2.7472527473
	},
	{
		"stop_id": 8576113,
		"ID": 1003,
		"x": 35.3537665283,
		"y": 46.464177685,
		"h": 2.7472527473
	},
	{
		"stop_id": 8576114,
		"ID": 1003,
		"x": 35.2367037953,
		"y": 46.563156316,
		"h": 2.7472527473
	},
	{
		"stop_id": 8576116,
		"ID": 1003,
		"x": 34.8367724283,
		"y": 46.539211207,
		"h": 2.7472527473
	},
	{
		"stop_id": 8576117,
		"ID": 1003,
		"x": 34.7517419003,
		"y": 46.249207383,
		"h": 2.7472527473
	},
	{
		"stop_id": 8576118,
		"ID": 1003,
		"x": 34.8377442053,
		"y": 45.773233062,
		"h": 2.7472527473
	},
	{
		"stop_id": 8576119,
		"ID": 1003,
		"x": 34.4307593623,
		"y": 45.526155684,
		"h": 2.7472527473
	},
	{
		"stop_id": 8576120,
		"ID": 1003,
		"x": 34.2187116213,
		"y": 45.214247089,
		"h": 2.7472527473
	},
	{
		"stop_id": 8576122,
		"ID": 1003,
		"x": 34.0047238863,
		"y": 45.067211232,
		"h": 2.7472527473
	},
	{
		"stop_id": 8576123,
		"ID": 1003,
		"x": 34.1417083993,
		"y": 44.734245131,
		"h": 2.7472527473
	},
	{
		"stop_id": 8576124,
		"ID": 1003,
		"x": 34.3567140393,
		"y": 44.98515359,
		"h": 2.7472527473
	},
	{
		"stop_id": 8576126,
		"ID": 1003,
		"x": 34.7437503333,
		"y": 44.959157537,
		"h": 2.7472527473
	},
	{
		"stop_id": 8577509,
		"ID": 1003,
		"x": 36.4127752153,
		"y": 46.119175372,
		"h": 2.7472527473
	},
	{
		"stop_id": 8577510,
		"ID": 1003,
		"x": 36.3327380973,
		"y": 46.087192481,
		"h": 2.7472527473
	},
	{
		"stop_id": 8577511,
		"ID": 1003,
		"x": 36.4307718983,
		"y": 46.009164759,
		"h": 2.7472527473
	},
	{
		"stop_id": 8577512,
		"ID": 1003,
		"x": 36.6127744483,
		"y": 45.91715466,
		"h": 2.7472527473
	},
	{
		"stop_id": 8577519,
		"ID": 1003,
		"x": 35.9017529343,
		"y": 44.840240921,
		"h": 2.7472527473
	},
	{
		"stop_id": 8579182,
		"ID": 1003,
		"x": 32.9577564103,
		"y": 43.130214991,
		"h": 2.7472527473
	},
	{
		"stop_id": 8581281,
		"ID": 1003,
		"x": 36.1857375983,
		"y": 44.771207536,
		"h": 2.7472527473
	},
	{
		"stop_id": 8581417,
		"ID": 1003,
		"x": 34.0987368993,
		"y": 47.897163223,
		"h": 2.7472527473
	},
	{
		"stop_id": 8587696,
		"ID": 1003,
		"x": 36.2977389963,
		"y": 45.087241196,
		"h": 2.7472527473
	},
	{
		"stop_id": 8588508,
		"ID": 1003,
		"x": 33.2877139433,
		"y": 43.09122462,
		"h": 2.7472527473
	},
	{
		"stop_id": 8588798,
		"ID": 1003,
		"x": 34.8407142373,
		"y": 48.010221235,
		"h": 2.7472527473
	},
	{
		"stop_id": 8588836,
		"ID": 1003,
		"x": 36.1177707483,
		"y": 44.920219046,
		"h": 2.7472527473
	},
	{
		"stop_id": 8590853,
		"ID": 1003,
		"x": 33.6747232593,
		"y": 48.172240803,
		"h": 2.7472527473
	},
	{
		"stop_id": 8590854,
		"ID": 1003,
		"x": 34.4187251903,
		"y": 48.256146306,
		"h": 2.7472527473
	},
	{
		"stop_id": 8590857,
		"ID": 1003,
		"x": 33.9597614953,
		"y": 47.885185515,
		"h": 2.7472527473
	},
	{
		"stop_id": 8590858,
		"ID": 1003,
		"x": 33.8827263633,
		"y": 48.245231081,
		"h": 2.7472527473
	},
	{
		"stop_id": 8590864,
		"ID": 1003,
		"x": 34.2747666053,
		"y": 48.368171521,
		"h": 2.7472527473
	},
	{
		"stop_id": 8590867,
		"ID": 1003,
		"x": 34.6397053573,
		"y": 48.198163186,
		"h": 2.7472527473
	},
	{
		"stop_id": 8590870,
		"ID": 1003,
		"x": 34.7747099923,
		"y": 48.259240367,
		"h": 2.7472527473
	},
	{
		"stop_id": 8590876,
		"ID": 1003,
		"x": 33.8297394983,
		"y": 48.026239658,
		"h": 2.7472527473
	},
	{
		"stop_id": 8593251,
		"ID": 1003,
		"x": 33.7977143793,
		"y": 48.150158241,
		"h": 2.7472527473
	},
	{
		"stop_id": 8502773,
		"ID": 855,
		"x": 6.5267025843,
		"y": 69.791147583,
		"h": 2.6153846154
	},
	{
		"stop_id": 8502896,
		"ID": 855,
		"x": 6.0917568493,
		"y": 70.445212095,
		"h": 2.6153846154
	},
	{
		"stop_id": 8502956,
		"ID": 855,
		"x": 7.3107349473,
		"y": 68.591220169,
		"h": 2.6153846154
	},
	{
		"stop_id": 8503506,
		"ID": 855,
		"x": 9.3287540713,
		"y": 71.447225725,
		"h": 2.6153846154
	},
	{
		"stop_id": 8503511,
		"ID": 855,
		"x": 7.5747260693,
		"y": 73.354195988,
		"h": 2.6153846154
	},
	{
		"stop_id": 8503529,
		"ID": 855,
		"x": 9.5727537773,
		"y": 72.832193236,
		"h": 2.6153846154
	},
	{
		"stop_id": 8572557,
		"ID": 855,
		"x": 5.5657446353,
		"y": 70.998231993,
		"h": 2.6153846154
	},
	{
		"stop_id": 8578679,
		"ID": 855,
		"x": 10.5707037563,
		"y": 72.869204275,
		"h": 2.6153846154
	},
	{
		"stop_id": 8579692,
		"ID": 855,
		"x": 6.2027225733,
		"y": 69.906171623,
		"h": 2.6153846154
	},
	{
		"stop_id": 8580318,
		"ID": 855,
		"x": 6.2727341903,
		"y": 70.138227965,
		"h": 2.6153846154
	},
	{
		"stop_id": 8583560,
		"ID": 855,
		"x": 6.6857477973,
		"y": 69.411212281,
		"h": 2.6153846154
	},
	{
		"stop_id": 8590239,
		"ID": 855,
		"x": 9.2787328363,
		"y": 71.447198341,
		"h": 2.6153846154
	},
	{
		"stop_id": 8590240,
		"ID": 855,
		"x": 8.9027567933,
		"y": 71.514212285,
		"h": 2.6153846154
	},
	{
		"stop_id": 8590244,
		"ID": 855,
		"x": 7.0467014993,
		"y": 73.487203991,
		"h": 2.6153846154
	},
	{
		"stop_id": 8590245,
		"ID": 855,
		"x": 7.8117410553,
		"y": 72.551200316,
		"h": 2.6153846154
	},
	{
		"stop_id": 8590247,
		"ID": 855,
		"x": 6.8597679543,
		"y": 73.685242869,
		"h": 2.6153846154
	},
	{
		"stop_id": 8590248,
		"ID": 855,
		"x": 7.2557655013,
		"y": 73.254173648,
		"h": 2.6153846154
	},
	{
		"stop_id": 8590249,
		"ID": 855,
		"x": 7.5647752423,
		"y": 72.876180301,
		"h": 2.6153846154
	},
	{
		"stop_id": 8590269,
		"ID": 855,
		"x": 9.7377510313,
		"y": 71.023144926,
		"h": 2.6153846154
	},
	{
		"stop_id": 8590270,
		"ID": 855,
		"x": 10.6987341893,
		"y": 69.753238437,
		"h": 2.6153846154
	},
	{
		"stop_id": 8590271,
		"ID": 855,
		"x": 10.3227150753,
		"y": 69.896217641,
		"h": 2.6153846154
	},
	{
		"stop_id": 8590272,
		"ID": 855,
		"x": 10.5117390553,
		"y": 71.11922988,
		"h": 2.6153846154
	},
	{
		"stop_id": 8590273,
		"ID": 855,
		"x": 10.1917311113,
		"y": 70.686241596,
		"h": 2.6153846154
	},
	{
		"stop_id": 8590274,
		"ID": 855,
		"x": 10.4387612363,
		"y": 71.3051667,
		"h": 2.6153846154
	},
	{
		"stop_id": 8590275,
		"ID": 855,
		"x": 10.9517226593,
		"y": 69.992201379,
		"h": 2.6153846154
	},
	{
		"stop_id": 8590276,
		"ID": 855,
		"x": 10.1067759023,
		"y": 70.762183433,
		"h": 2.6153846154
	},
	{
		"stop_id": 8590277,
		"ID": 855,
		"x": 10.0147119553,
		"y": 70.327228793,
		"h": 2.6153846154
	},
	{
		"stop_id": 8590278,
		"ID": 855,
		"x": 9.8667121243,
		"y": 70.579226152,
		"h": 2.6153846154
	},
	{
		"stop_id": 8590279,
		"ID": 855,
		"x": 10.4457192983,
		"y": 70.024210044,
		"h": 2.6153846154
	},
	{
		"stop_id": 8590296,
		"ID": 855,
		"x": 7.7587271253,
		"y": 74.322217485,
		"h": 2.6153846154
	},
	{
		"stop_id": 8590297,
		"ID": 855,
		"x": 7.8057089063,
		"y": 74.051222097,
		"h": 2.6153846154
	},
	{
		"stop_id": 8590299,
		"ID": 855,
		"x": 8.3637651363,
		"y": 74.307244772,
		"h": 2.6153846154
	},
	{
		"stop_id": 8590310,
		"ID": 855,
		"x": 8.0817079703,
		"y": 73.822209351,
		"h": 2.6153846154
	},
	{
		"stop_id": 8590311,
		"ID": 855,
		"x": 7.4497124573,
		"y": 74.294238572,
		"h": 2.6153846154
	},
	{
		"stop_id": 8590313,
		"ID": 855,
		"x": 9.7427081913,
		"y": 72.87621653,
		"h": 2.6153846154
	},
	{
		"stop_id": 8590314,
		"ID": 855,
		"x": 10.3277235893,
		"y": 72.737228612,
		"h": 2.6153846154
	},
	{
		"stop_id": 8590315,
		"ID": 855,
		"x": 8.9827424583,
		"y": 73.644243971,
		"h": 2.6153846154
	},
	{
		"stop_id": 8590316,
		"ID": 855,
		"x": 9.9677495233,
		"y": 72.431202751,
		"h": 2.6153846154
	},
	{
		"stop_id": 8590317,
		"ID": 855,
		"x": 10.0987126263,
		"y": 72.392161305,
		"h": 2.6153846154
	},
	{
		"stop_id": 8590396,
		"ID": 855,
		"x": 9.6127107703,
		"y": 70.992213199,
		"h": 2.6153846154
	},
	{
		"stop_id": 8590397,
		"ID": 855,
		"x": 10.4947170983,
		"y": 70.245172531,
		"h": 2.6153846154
	},
	{
		"stop_id": 8591891,
		"ID": 855,
		"x": 10.4337569113,
		"y": 69.849164165,
		"h": 2.6153846154
	},
	{
		"stop_id": 8594304,
		"ID": 855,
		"x": 9.8927541623,
		"y": 71.547233442,
		"h": 2.6153846154
	},
	{
		"stop_id": 8594305,
		"ID": 855,
		"x": 9.5877533303,
		"y": 72.820248955,
		"h": 2.6153846154
	},
	{
		"stop_id": 8594306,
		"ID": 855,
		"x": 10.3107259603,
		"y": 72.873238028,
		"h": 2.6153846154
	},
	{
		"stop_id": 8594307,
		"ID": 855,
		"x": 10.0907612543,
		"y": 72.030248449,
		"h": 2.6153846154
	},
	{
		"stop_id": 8594308,
		"ID": 855,
		"x": 9.5197436893,
		"y": 71.670172542,
		"h": 2.6153846154
	},
	{
		"stop_id": 8594309,
		"ID": 855,
		"x": 10.0277506703,
		"y": 72.71022369,
		"h": 2.6153846154
	},
	{
		"stop_id": 8594310,
		"ID": 855,
		"x": 9.9647209573,
		"y": 71.740219888,
		"h": 2.6153846154
	},
	{
		"stop_id": 8595708,
		"ID": 855,
		"x": 10.0097355993,
		"y": 70.064202478,
		"h": 2.6153846154
	},
	{
		"stop_id": 8502776,
		"ID": 938,
		"x": 24.4177278823,
		"y": 55.119145676,
		"h": 4.3626373626
	},
	{
		"stop_id": 8502992,
		"ID": 938,
		"x": 22.6597096543,
		"y": 55.210230006,
		"h": 4.3626373626
	},
	{
		"stop_id": 8503081,
		"ID": 938,
		"x": 21.0737643253,
		"y": 57.898235138,
		"h": 4.3626373626
	},
	{
		"stop_id": 8503082,
		"ID": 938,
		"x": 22.0247538713,
		"y": 58.248171777,
		"h": 4.3626373626
	},
	{
		"stop_id": 8503089,
		"ID": 938,
		"x": 23.2297678813,
		"y": 56.419247612,
		"h": 4.3626373626
	},
	{
		"stop_id": 8503095,
		"ID": 938,
		"x": 22.1197233223,
		"y": 58.96121332,
		"h": 4.3626373626
	},
	{
		"stop_id": 8503096,
		"ID": 938,
		"x": 22.3367481403,
		"y": 58.156188674,
		"h": 4.3626373626
	},
	{
		"stop_id": 8503097,
		"ID": 938,
		"x": 23.8777374703,
		"y": 55.350239778,
		"h": 4.3626373626
	},
	{
		"stop_id": 8503099,
		"ID": 938,
		"x": 22.4327145953,
		"y": 57.140234762,
		"h": 4.3626373626
	},
	{
		"stop_id": 8503200,
		"ID": 938,
		"x": 24.1197710443,
		"y": 59.529207163,
		"h": 4.3626373626
	},
	{
		"stop_id": 8503201,
		"ID": 938,
		"x": 24.6877419873,
		"y": 57.614209166,
		"h": 4.3626373626
	},
	{
		"stop_id": 8503202,
		"ID": 938,
		"x": 25.4317354813,
		"y": 56.384171643,
		"h": 4.3626373626
	},
	{
		"stop_id": 8503674,
		"ID": 938,
		"x": 25.6797137643,
		"y": 56.467237385,
		"h": 4.3626373626
	},
	{
		"stop_id": 8503675,
		"ID": 938,
		"x": 24.9277096173,
		"y": 57.911173466,
		"h": 4.3626373626
	},
	{
		"stop_id": 8503677,
		"ID": 938,
		"x": 24.4087522383,
		"y": 59.325149248,
		"h": 4.3626373626
	},
	{
		"stop_id": 8503791,
		"ID": 938,
		"x": 24.8827685773,
		"y": 55.60521077,
		"h": 4.3626373626
	},
	{
		"stop_id": 8503862,
		"ID": 938,
		"x": 23.0827668593,
		"y": 55.380234342,
		"h": 4.3626373626
	},
	{
		"stop_id": 8503887,
		"ID": 938,
		"x": 22.7257728043,
		"y": 55.013229423,
		"h": 4.3626373626
	},
	{
		"stop_id": 8573160,
		"ID": 938,
		"x": 23.6577702673,
		"y": 55.530164219,
		"h": 4.3626373626
	},
	{
		"stop_id": 8573161,
		"ID": 938,
		"x": 23.8577440133,
		"y": 55.330166291,
		"h": 4.3626373626
	},
	{
		"stop_id": 8573162,
		"ID": 938,
		"x": 24.0327098293,
		"y": 54.930235593,
		"h": 4.3626373626
	},
	{
		"stop_id": 8573163,
		"ID": 938,
		"x": 24.7187619573,
		"y": 55.232165583,
		"h": 4.3626373626
	},
	{
		"stop_id": 8573164,
		"ID": 938,
		"x": 24.9077679283,
		"y": 55.90522605,
		"h": 4.3626373626
	},
	{
		"stop_id": 8573165,
		"ID": 938,
		"x": 25.2477350083,
		"y": 55.467211895,
		"h": 4.3626373626
	},
	{
		"stop_id": 8573166,
		"ID": 938,
		"x": 25.5077348693,
		"y": 55.880233725,
		"h": 4.3626373626
	},
	{
		"stop_id": 8573167,
		"ID": 938,
		"x": 25.3827158943,
		"y": 56.305189897,
		"h": 4.3626373626
	},
	{
		"stop_id": 8573168,
		"ID": 938,
		"x": 25.4327196283,
		"y": 56.405200861,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590463,
		"ID": 938,
		"x": 23.0217757053,
		"y": 58.315145546,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590464,
		"ID": 938,
		"x": 22.3587155173,
		"y": 58.115240876,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590465,
		"ID": 938,
		"x": 22.4617462393,
		"y": 57.867155661,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590466,
		"ID": 938,
		"x": 21.8217629943,
		"y": 58.613196245,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590467,
		"ID": 938,
		"x": 22.1987642413,
		"y": 56.922179977,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590468,
		"ID": 938,
		"x": 23.0447271513,
		"y": 59.022195754,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590469,
		"ID": 938,
		"x": 21.9557433623,
		"y": 58.405222965,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590470,
		"ID": 938,
		"x": 22.7587721423,
		"y": 57.559166108,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590471,
		"ID": 938,
		"x": 21.6777612113,
		"y": 59.078219147,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590472,
		"ID": 938,
		"x": 22.6817024683,
		"y": 59.252198506,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590473,
		"ID": 938,
		"x": 23.2097593443,
		"y": 58.483223064,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590474,
		"ID": 938,
		"x": 22.6127072783,
		"y": 58.231174832,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590475,
		"ID": 938,
		"x": 22.2157475663,
		"y": 57.171147245,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590476,
		"ID": 938,
		"x": 23.0997523443,
		"y": 58.88820031,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590477,
		"ID": 938,
		"x": 22.8367215533,
		"y": 59.625177061,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590478,
		"ID": 938,
		"x": 22.4047419403,
		"y": 58.259202761,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590479,
		"ID": 938,
		"x": 21.7367063703,
		"y": 58.904236599,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590480,
		"ID": 938,
		"x": 22.8977262843,
		"y": 57.921246394,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590481,
		"ID": 938,
		"x": 22.9527354913,
		"y": 57.577210441,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590482,
		"ID": 938,
		"x": 23.1147298283,
		"y": 57.783171735,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590484,
		"ID": 938,
		"x": 22.7647337253,
		"y": 58.653143729,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590485,
		"ID": 938,
		"x": 22.6707319223,
		"y": 57.810234168,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590486,
		"ID": 938,
		"x": 22.2187079433,
		"y": 57.444160545,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590670,
		"ID": 938,
		"x": 23.5787572283,
		"y": 59.017219108,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590671,
		"ID": 938,
		"x": 23.9587169413,
		"y": 58.898144995,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590673,
		"ID": 938,
		"x": 24.1257392953,
		"y": 59.524176736,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590674,
		"ID": 938,
		"x": 24.3207402043,
		"y": 59.272197267,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590675,
		"ID": 938,
		"x": 23.7317020983,
		"y": 59.362172168,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590676,
		"ID": 938,
		"x": 23.4447312423,
		"y": 58.853221396,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590678,
		"ID": 938,
		"x": 23.6397507783,
		"y": 58.782239539,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590679,
		"ID": 938,
		"x": 23.1697633353,
		"y": 59.213189387,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590680,
		"ID": 938,
		"x": 23.9227285633,
		"y": 59.541213082,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590681,
		"ID": 938,
		"x": 24.3647294923,
		"y": 58.937244965,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590682,
		"ID": 938,
		"x": 23.5627620213,
		"y": 59.736180056,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590685,
		"ID": 938,
		"x": 23.8477617383,
		"y": 59.823249722,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590686,
		"ID": 938,
		"x": 23.7417393553,
		"y": 59.562235583,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590687,
		"ID": 938,
		"x": 24.5307596003,
		"y": 58.789159257,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590688,
		"ID": 938,
		"x": 24.2437572493,
		"y": 58.7391671,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590689,
		"ID": 938,
		"x": 24.1087734083,
		"y": 59.232170423,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590690,
		"ID": 938,
		"x": 23.9147054903,
		"y": 59.220201445,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590691,
		"ID": 938,
		"x": 23.5437430953,
		"y": 59.486177077,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590706,
		"ID": 938,
		"x": 23.1087551193,
		"y": 55.296203768,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590707,
		"ID": 938,
		"x": 23.3577397613,
		"y": 55.064183629,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590708,
		"ID": 938,
		"x": 23.1557277713,
		"y": 54.923149961,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590709,
		"ID": 938,
		"x": 23.4097476443,
		"y": 54.700208682,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590771,
		"ID": 938,
		"x": 24.5687327933,
		"y": 57.729156404,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590772,
		"ID": 938,
		"x": 24.1967737253,
		"y": 57.597236127,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590773,
		"ID": 938,
		"x": 24.4977512633,
		"y": 57.977216367,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590775,
		"ID": 938,
		"x": 23.8717342313,
		"y": 57.317227085,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590776,
		"ID": 938,
		"x": 24.3837041463,
		"y": 57.492250584,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590777,
		"ID": 938,
		"x": 23.6927553833,
		"y": 57.626153274,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590779,
		"ID": 938,
		"x": 23.9607751083,
		"y": 57.101215581,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590780,
		"ID": 938,
		"x": 24.3367348463,
		"y": 56.857240741,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590781,
		"ID": 938,
		"x": 24.3477187743,
		"y": 58.190242982,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590782,
		"ID": 938,
		"x": 24.0067457283,
		"y": 57.713191682,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590783,
		"ID": 938,
		"x": 24.5747055353,
		"y": 58.341237724,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590784,
		"ID": 938,
		"x": 24.5227377913,
		"y": 57.453193916,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590811,
		"ID": 938,
		"x": 25.0457129913,
		"y": 56.448249541,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590812,
		"ID": 938,
		"x": 25.8317719633,
		"y": 55.23320737,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590813,
		"ID": 938,
		"x": 25.2027192733,
		"y": 56.392230721,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590814,
		"ID": 938,
		"x": 25.8487291393,
		"y": 55.458168432,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590815,
		"ID": 938,
		"x": 25.4897249903,
		"y": 55.148228836,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590817,
		"ID": 938,
		"x": 25.5687660373,
		"y": 55.334163196,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590818,
		"ID": 938,
		"x": 25.6787661023,
		"y": 55.939177773,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590822,
		"ID": 938,
		"x": 25.1597419273,
		"y": 56.63623578,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590823,
		"ID": 938,
		"x": 25.7147223843,
		"y": 55.72220601,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590824,
		"ID": 938,
		"x": 25.2757480173,
		"y": 56.469219865,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590825,
		"ID": 938,
		"x": 25.9727567853,
		"y": 55.388240111,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590826,
		"ID": 938,
		"x": 25.0267751633,
		"y": 56.111181984,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590828,
		"ID": 938,
		"x": 24.6557299293,
		"y": 56.520190677,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590829,
		"ID": 938,
		"x": 25.5357220103,
		"y": 55.854172362,
		"h": 4.3626373626
	},
	{
		"stop_id": 8590830,
		"ID": 938,
		"x": 25.8777048223,
		"y": 55.715214836,
		"h": 4.3626373626
	},
	{
		"stop_id": 8591388,
		"ID": 938,
		"x": 22.7257289433,
		"y": 59.805208135,
		"h": 4.3626373626
	},
	{
		"stop_id": 8594252,
		"ID": 938,
		"x": 23.4697503923,
		"y": 59.716194307,
		"h": 4.3626373626
	},
	{
		"stop_id": 8595406,
		"ID": 938,
		"x": 24.7957685053,
		"y": 56.120229198,
		"h": 4.3626373626
	},
	{
		"stop_id": 8595717,
		"ID": 938,
		"x": 22.7807692243,
		"y": 58.234177203,
		"h": 4.3626373626
	},
	{
		"stop_id": 8502865,
		"ID": 1002,
		"x": 31.2077728513,
		"y": 39.230167376,
		"h": 1.2307692308
	},
	{
		"stop_id": 8502866,
		"ID": 1002,
		"x": 31.5777079103,
		"y": 39.590188884,
		"h": 1.2307692308
	},
	{
		"stop_id": 8502867,
		"ID": 1002,
		"x": 33.1827245693,
		"y": 39.385207011,
		"h": 1.2307692308
	},
	{
		"stop_id": 8503292,
		"ID": 1002,
		"x": 35.6597148683,
		"y": 38.268141763,
		"h": 1.2307692308
	},
	{
		"stop_id": 8577573,
		"ID": 1002,
		"x": 30.8677471533,
		"y": 39.130248841,
		"h": 1.2307692308
	},
	{
		"stop_id": 8577574,
		"ID": 1002,
		"x": 32.3377206013,
		"y": 39.480148271,
		"h": 1.2307692308
	},
	{
		"stop_id": 8587855,
		"ID": 1002,
		"x": 34.9217246583,
		"y": 36.864165264,
		"h": 1.2307692308
	},
	{
		"stop_id": 8587856,
		"ID": 1002,
		"x": 35.7967607213,
		"y": 38.329158918,
		"h": 1.2307692308
	},
	{
		"stop_id": 8502895,
		"ID": 856,
		"x": 7.2817237053,
		"y": 79.195166352,
		"h": 2.4505494505
	},
	{
		"stop_id": 8503585,
		"ID": 856,
		"x": 8.1727555483,
		"y": 78.194247723,
		"h": 2.4505494505
	},
	{
		"stop_id": 8503586,
		"ID": 856,
		"x": 8.6097145843,
		"y": 78.975192944,
		"h": 2.4505494505
	},
	{
		"stop_id": 8503588,
		"ID": 856,
		"x": 7.8467749053,
		"y": 77.433174429,
		"h": 2.4505494505
	},
	{
		"stop_id": 8503799,
		"ID": 856,
		"x": 6.4177253353,
		"y": 76.310203554,
		"h": 2.4505494505
	},
	{
		"stop_id": 8503875,
		"ID": 856,
		"x": 5.5077069253,
		"y": 76.930225042,
		"h": 2.4505494505
	},
	{
		"stop_id": 8572550,
		"ID": 856,
		"x": 5.8097282573,
		"y": 76.31221968,
		"h": 2.4505494505
	},
	{
		"stop_id": 8572572,
		"ID": 856,
		"x": 6.0727036123,
		"y": 76.878219169,
		"h": 2.4505494505
	},
	{
		"stop_id": 8572581,
		"ID": 856,
		"x": 6.2457152893,
		"y": 75.619222437,
		"h": 2.4505494505
	},
	{
		"stop_id": 8572583,
		"ID": 856,
		"x": 8.3117088263,
		"y": 78.516194309,
		"h": 2.4505494505
	},
	{
		"stop_id": 8572584,
		"ID": 856,
		"x": 7.0637621253,
		"y": 79.760233364,
		"h": 2.4505494505
	},
	{
		"stop_id": 8572585,
		"ID": 856,
		"x": 8.6537203643,
		"y": 79.470182104,
		"h": 2.4505494505
	},
	{
		"stop_id": 8578678,
		"ID": 856,
		"x": 7.1477077783,
		"y": 75.080171278,
		"h": 2.4505494505
	},
	{
		"stop_id": 8580639,
		"ID": 856,
		"x": 8.0397460283,
		"y": 77.819222508,
		"h": 2.4505494505
	},
	{
		"stop_id": 8590172,
		"ID": 856,
		"x": 6.0777040963,
		"y": 76.476201938,
		"h": 2.4505494505
	},
	{
		"stop_id": 8590174,
		"ID": 856,
		"x": 5.9287352343,
		"y": 76.389150469,
		"h": 2.4505494505
	},
	{
		"stop_id": 8590178,
		"ID": 856,
		"x": 5.7287668353,
		"y": 76.707168771,
		"h": 2.4505494505
	},
	{
		"stop_id": 8590196,
		"ID": 856,
		"x": 6.1547289093,
		"y": 76.721238603,
		"h": 2.4505494505
	},
	{
		"stop_id": 8590227,
		"ID": 856,
		"x": 7.2917595633,
		"y": 77.106177109,
		"h": 2.4505494505
	},
	{
		"stop_id": 8590228,
		"ID": 856,
		"x": 7.1587209403,
		"y": 76.853152256,
		"h": 2.4505494505
	},
	{
		"stop_id": 8590229,
		"ID": 856,
		"x": 6.9537221973,
		"y": 76.69016356,
		"h": 2.4505494505
	},
	{
		"stop_id": 8590230,
		"ID": 856,
		"x": 6.7547514763,
		"y": 76.714165103,
		"h": 2.4505494505
	},
	{
		"stop_id": 8590231,
		"ID": 856,
		"x": 6.3127569223,
		"y": 76.394204177,
		"h": 2.4505494505
	},
	{
		"stop_id": 8590232,
		"ID": 856,
		"x": 6.4937239293,
		"y": 76.511200837,
		"h": 2.4505494505
	},
	{
		"stop_id": 8590233,
		"ID": 856,
		"x": 7.0157392363,
		"y": 76.97918647,
		"h": 2.4505494505
	},
	{
		"stop_id": 8590234,
		"ID": 856,
		"x": 6.8027583553,
		"y": 76.869151893,
		"h": 2.4505494505
	},
	{
		"stop_id": 8590235,
		"ID": 856,
		"x": 6.2267740353,
		"y": 76.486201821,
		"h": 2.4505494505
	},
	{
		"stop_id": 8590236,
		"ID": 856,
		"x": 6.9497278793,
		"y": 76.857241505,
		"h": 2.4505494505
	},
	{
		"stop_id": 8590292,
		"ID": 856,
		"x": 6.7917392733,
		"y": 74.584243506,
		"h": 2.4505494505
	},
	{
		"stop_id": 8590293,
		"ID": 856,
		"x": 7.3097362593,
		"y": 74.648243711,
		"h": 2.4505494505
	},
	{
		"stop_id": 8590294,
		"ID": 856,
		"x": 8.0617529773,
		"y": 75.287163241,
		"h": 2.4505494505
	},
	{
		"stop_id": 8590295,
		"ID": 856,
		"x": 8.0147538043,
		"y": 74.53218353,
		"h": 2.4505494505
	},
	{
		"stop_id": 8590298,
		"ID": 856,
		"x": 7.5077078863,
		"y": 74.506162613,
		"h": 2.4505494505
	},
	{
		"stop_id": 8590300,
		"ID": 856,
		"x": 6.5497518923,
		"y": 75.453163851,
		"h": 2.4505494505
	},
	{
		"stop_id": 8590301,
		"ID": 856,
		"x": 7.8457736653,
		"y": 75.264232751,
		"h": 2.4505494505
	},
	{
		"stop_id": 8590302,
		"ID": 856,
		"x": 7.1017295603,
		"y": 74.865161645,
		"h": 2.4505494505
	},
	{
		"stop_id": 8590303,
		"ID": 856,
		"x": 7.4177345793,
		"y": 74.899206457,
		"h": 2.4505494505
	},
	{
		"stop_id": 8590305,
		"ID": 856,
		"x": 7.6167559223,
		"y": 75.267180786,
		"h": 2.4505494505
	},
	{
		"stop_id": 8590306,
		"ID": 856,
		"x": 7.6957387613,
		"y": 74.701221162,
		"h": 2.4505494505
	},
	{
		"stop_id": 8590307,
		"ID": 856,
		"x": 7.4297027853,
		"y": 75.233142064,
		"h": 2.4505494505
	},
	{
		"stop_id": 8590309,
		"ID": 856,
		"x": 6.9277625873,
		"y": 75.214233271,
		"h": 2.4505494505
	},
	{
		"stop_id": 8590312,
		"ID": 856,
		"x": 6.7807120413,
		"y": 75.310205136,
		"h": 2.4505494505
	},
	{
		"stop_id": 8590395,
		"ID": 856,
		"x": 5.8937203113,
		"y": 76.895244488,
		"h": 2.4505494505
	},
	{
		"stop_id": 8591710,
		"ID": 856,
		"x": 8.0587615433,
		"y": 74.561152841,
		"h": 2.4505494505
	},
	{
		"stop_id": 8595203,
		"ID": 856,
		"x": 5.6287452043,
		"y": 76.911213116,
		"h": 2.4505494505
	},
	{
		"stop_id": 8503006,
		"ID": 940,
		"x": 23.6897608113,
		"y": 69.208154343,
		"h": 6.6373626374
	},
	{
		"stop_id": 8503007,
		"ID": 940,
		"x": 23.7177676113,
		"y": 70.011151071,
		"h": 6.6373626374
	},
	{
		"stop_id": 8503015,
		"ID": 940,
		"x": 22.6047732893,
		"y": 67.136216445,
		"h": 6.6373626374
	},
	{
		"stop_id": 8503020,
		"ID": 940,
		"x": 21.6917431713,
		"y": 66.252175168,
		"h": 6.6373626374
	},
	{
		"stop_id": 8503310,
		"ID": 940,
		"x": 24.7697593033,
		"y": 71.369199165,
		"h": 6.6373626374
	},
	{
		"stop_id": 8503340,
		"ID": 940,
		"x": 24.9927116023,
		"y": 71.275201564,
		"h": 6.6373626374
	},
	{
		"stop_id": 8530473,
		"ID": 940,
		"x": 24.4297314853,
		"y": 66.52817203,
		"h": 6.6373626374
	},
	{
		"stop_id": 8580449,
		"ID": 940,
		"x": 23.7407518103,
		"y": 69.205203549,
		"h": 6.6373626374
	},
	{
		"stop_id": 8580522,
		"ID": 940,
		"x": 22.0827078123,
		"y": 66.880243141,
		"h": 6.6373626374
	},
	{
		"stop_id": 8590620,
		"ID": 940,
		"x": 24.8097723673,
		"y": 71.341193337,
		"h": 6.6373626374
	},
	{
		"stop_id": 8590621,
		"ID": 940,
		"x": 24.6627383883,
		"y": 71.064220288,
		"h": 6.6373626374
	},
	{
		"stop_id": 8590622,
		"ID": 940,
		"x": 25.1267384533,
		"y": 71.121225579,
		"h": 6.6373626374
	},
	{
		"stop_id": 8590625,
		"ID": 940,
		"x": 25.2917296473,
		"y": 71.076223994,
		"h": 6.6373626374
	},
	{
		"stop_id": 8590626,
		"ID": 940,
		"x": 24.9047494193,
		"y": 70.746210277,
		"h": 6.6373626374
	},
	{
		"stop_id": 8590627,
		"ID": 940,
		"x": 24.8177596383,
		"y": 70.618204665,
		"h": 6.6373626374
	},
	{
		"stop_id": 8590629,
		"ID": 940,
		"x": 24.9427504743,
		"y": 71.339202352,
		"h": 6.6373626374
	},
	{
		"stop_id": 8590633,
		"ID": 940,
		"x": 24.9587430963,
		"y": 70.469216971,
		"h": 6.6373626374
	},
	{
		"stop_id": 8590634,
		"ID": 940,
		"x": 25.0667205993,
		"y": 70.649230993,
		"h": 6.6373626374
	},
	{
		"stop_id": 8590742,
		"ID": 940,
		"x": 24.9847438763,
		"y": 71.236169132,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591039,
		"ID": 940,
		"x": 20.9287050113,
		"y": 67.639210113,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591041,
		"ID": 940,
		"x": 22.1777165973,
		"y": 69.095198492,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591043,
		"ID": 940,
		"x": 20.9177322563,
		"y": 67.846213638,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591045,
		"ID": 940,
		"x": 21.0987684483,
		"y": 67.769178411,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591047,
		"ID": 940,
		"x": 25.8047403143,
		"y": 69.16616437,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591048,
		"ID": 940,
		"x": 24.0047129153,
		"y": 70.656240869,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591049,
		"ID": 940,
		"x": 25.4927412713,
		"y": 69.808152891,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591050,
		"ID": 940,
		"x": 25.8037245653,
		"y": 69.440245322,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591053,
		"ID": 940,
		"x": 23.2207600873,
		"y": 68.57520856,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591060,
		"ID": 940,
		"x": 21.6867041793,
		"y": 66.223195751,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591062,
		"ID": 940,
		"x": 23.5217033023,
		"y": 69.318206504,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591063,
		"ID": 940,
		"x": 23.8177032643,
		"y": 69.411220243,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591066,
		"ID": 940,
		"x": 22.6167436763,
		"y": 67.182194557,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591071,
		"ID": 940,
		"x": 23.4557210073,
		"y": 66.15314664,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591073,
		"ID": 940,
		"x": 23.9887024713,
		"y": 68.335161564,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591076,
		"ID": 940,
		"x": 22.8867359193,
		"y": 68.401190591,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591078,
		"ID": 940,
		"x": 24.5747310053,
		"y": 65.848171911,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591085,
		"ID": 940,
		"x": 23.8177436733,
		"y": 70.975174818,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591086,
		"ID": 940,
		"x": 22.6757145923,
		"y": 68.750179127,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591088,
		"ID": 940,
		"x": 23.0637527583,
		"y": 69.368160645,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591091,
		"ID": 940,
		"x": 25.4567139873,
		"y": 68.241233271,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591092,
		"ID": 940,
		"x": 23.2167481543,
		"y": 69.508182994,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591101,
		"ID": 940,
		"x": 22.8927385833,
		"y": 67.7382256,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591103,
		"ID": 940,
		"x": 23.2827296313,
		"y": 70.395216872,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591108,
		"ID": 940,
		"x": 22.7137053833,
		"y": 69.399191884,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591110,
		"ID": 940,
		"x": 22.3877127353,
		"y": 66.628163146,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591112,
		"ID": 940,
		"x": 24.0497534293,
		"y": 68.75822962,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591113,
		"ID": 940,
		"x": 25.4307165163,
		"y": 69.151210247,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591118,
		"ID": 940,
		"x": 21.3297090363,
		"y": 69.639164361,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591121,
		"ID": 940,
		"x": 21.2927024703,
		"y": 67.478166897,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591122,
		"ID": 940,
		"x": 20.9467434073,
		"y": 68.853242683,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591124,
		"ID": 940,
		"x": 24.3857305133,
		"y": 70.767166933,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591127,
		"ID": 940,
		"x": 23.7707136753,
		"y": 69.794178515,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591128,
		"ID": 940,
		"x": 25.0097123503,
		"y": 69.966232742,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591131,
		"ID": 940,
		"x": 21.3027709323,
		"y": 67.178194258,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591135,
		"ID": 940,
		"x": 21.6847220973,
		"y": 67.032209166,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591140,
		"ID": 940,
		"x": 24.3837431123,
		"y": 68.596172909,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591144,
		"ID": 940,
		"x": 23.1947317133,
		"y": 70.293241217,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591148,
		"ID": 940,
		"x": 25.5847045353,
		"y": 68.39118702,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591152,
		"ID": 940,
		"x": 25.0977128013,
		"y": 68.417215724,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591156,
		"ID": 940,
		"x": 24.3627444843,
		"y": 66.523217727,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591159,
		"ID": 940,
		"x": 26.5467338093,
		"y": 68.145151651,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591160,
		"ID": 940,
		"x": 21.8157176783,
		"y": 69.467149453,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591161,
		"ID": 940,
		"x": 21.7677086133,
		"y": 69.418230254,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591164,
		"ID": 940,
		"x": 24.1857575973,
		"y": 66.399173203,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591168,
		"ID": 940,
		"x": 23.4147007293,
		"y": 67.445195838,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591169,
		"ID": 940,
		"x": 21.9157690463,
		"y": 65.712192285,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591171,
		"ID": 940,
		"x": 24.2597338603,
		"y": 66.433246116,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591172,
		"ID": 940,
		"x": 24.5467225143,
		"y": 69.540197022,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591173,
		"ID": 940,
		"x": 24.0607328843,
		"y": 65.740249891,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591175,
		"ID": 940,
		"x": 24.5777080363,
		"y": 69.129217911,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591181,
		"ID": 940,
		"x": 26.1317143823,
		"y": 68.485157863,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591185,
		"ID": 940,
		"x": 25.2677736703,
		"y": 68.897235194,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591187,
		"ID": 940,
		"x": 23.6247536273,
		"y": 70.469186048,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591188,
		"ID": 940,
		"x": 25.8537457973,
		"y": 68.794147241,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591189,
		"ID": 940,
		"x": 25.2847608653,
		"y": 65.909245113,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591191,
		"ID": 940,
		"x": 23.2647107983,
		"y": 70.130209843,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591193,
		"ID": 940,
		"x": 23.6397384053,
		"y": 67.925158623,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591201,
		"ID": 940,
		"x": 20.7277208423,
		"y": 68.434176817,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591206,
		"ID": 940,
		"x": 22.0777351163,
		"y": 69.781217874,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591207,
		"ID": 940,
		"x": 23.6397265143,
		"y": 71.39920892,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591213,
		"ID": 940,
		"x": 21.0427186553,
		"y": 68.048176058,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591224,
		"ID": 940,
		"x": 23.4187166213,
		"y": 71.260219705,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591225,
		"ID": 940,
		"x": 25.0617599383,
		"y": 69.636173014,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591226,
		"ID": 940,
		"x": 21.1387217793,
		"y": 67.59114746,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591229,
		"ID": 940,
		"x": 23.8927553583,
		"y": 66.693251065,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591234,
		"ID": 940,
		"x": 23.1207412953,
		"y": 71.185210146,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591235,
		"ID": 940,
		"x": 22.4847565203,
		"y": 68.531141459,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591237,
		"ID": 940,
		"x": 23.3497157803,
		"y": 66.582199921,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591238,
		"ID": 940,
		"x": 25.0097324343,
		"y": 66.187180892,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591240,
		"ID": 940,
		"x": 22.8037756003,
		"y": 67.431202668,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591242,
		"ID": 940,
		"x": 24.1157268703,
		"y": 67.089250542,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591244,
		"ID": 940,
		"x": 23.7687389373,
		"y": 67.209219455,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591246,
		"ID": 940,
		"x": 23.1287376493,
		"y": 67.361240126,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591247,
		"ID": 940,
		"x": 21.9047403133,
		"y": 67.482234465,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591248,
		"ID": 940,
		"x": 23.6727488753,
		"y": 71.117238734,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591249,
		"ID": 940,
		"x": 21.1057237353,
		"y": 69.184210485,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591250,
		"ID": 940,
		"x": 21.0727136473,
		"y": 69.479201725,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591251,
		"ID": 940,
		"x": 22.8637511653,
		"y": 66.866174898,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591255,
		"ID": 940,
		"x": 23.8267441223,
		"y": 66.892245748,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591256,
		"ID": 940,
		"x": 24.2277477033,
		"y": 69.562240721,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591257,
		"ID": 940,
		"x": 22.7887446253,
		"y": 66.201194271,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591264,
		"ID": 940,
		"x": 26.5117383943,
		"y": 68.635233715,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591266,
		"ID": 940,
		"x": 22.3577283493,
		"y": 68.780232583,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591267,
		"ID": 940,
		"x": 22.7757223983,
		"y": 69.715180291,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591272,
		"ID": 940,
		"x": 23.4757289883,
		"y": 69.485241401,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591273,
		"ID": 940,
		"x": 24.1867358133,
		"y": 69.122218382,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591276,
		"ID": 940,
		"x": 23.5467368613,
		"y": 67.645198238,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591280,
		"ID": 940,
		"x": 22.3537498483,
		"y": 69.45923927,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591282,
		"ID": 940,
		"x": 23.0427381053,
		"y": 65.929200874,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591285,
		"ID": 940,
		"x": 22.2487090373,
		"y": 69.223164501,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591289,
		"ID": 940,
		"x": 23.2357721503,
		"y": 69.777206429,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591290,
		"ID": 940,
		"x": 22.7177713233,
		"y": 68.310214244,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591291,
		"ID": 940,
		"x": 23.1257385483,
		"y": 66.620204431,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591292,
		"ID": 940,
		"x": 22.9137578583,
		"y": 67.054233387,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591293,
		"ID": 940,
		"x": 22.8387049533,
		"y": 69.07924898,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591294,
		"ID": 940,
		"x": 24.4417114783,
		"y": 69.892191291,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591296,
		"ID": 940,
		"x": 22.9737186943,
		"y": 66.583165315,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591297,
		"ID": 940,
		"x": 25.3457044173,
		"y": 69.809151589,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591298,
		"ID": 940,
		"x": 23.6027353573,
		"y": 66.278192754,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591302,
		"ID": 940,
		"x": 21.7147134263,
		"y": 67.860233333,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591306,
		"ID": 940,
		"x": 22.5687414803,
		"y": 66.436198456,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591307,
		"ID": 940,
		"x": 23.0307618383,
		"y": 68.137225821,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591312,
		"ID": 940,
		"x": 21.5127695833,
		"y": 67.5512332,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591314,
		"ID": 940,
		"x": 23.3287269113,
		"y": 68.902187206,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591318,
		"ID": 940,
		"x": 24.7467302293,
		"y": 69.551164615,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591319,
		"ID": 940,
		"x": 24.8347670413,
		"y": 69.12621199,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591322,
		"ID": 940,
		"x": 22.6147518243,
		"y": 65.902221186,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591323,
		"ID": 940,
		"x": 22.3087361193,
		"y": 67.276215419,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591324,
		"ID": 940,
		"x": 23.4527268543,
		"y": 66.662148169,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591325,
		"ID": 940,
		"x": 26.1837626293,
		"y": 68.290209945,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591326,
		"ID": 940,
		"x": 23.1177525153,
		"y": 66.948224668,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591330,
		"ID": 940,
		"x": 25.1057344633,
		"y": 69.14821292,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591332,
		"ID": 940,
		"x": 24.0277332923,
		"y": 68.607249819,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591335,
		"ID": 940,
		"x": 23.3127328513,
		"y": 66.990206351,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591336,
		"ID": 940,
		"x": 24.2357527603,
		"y": 66.793173773,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591339,
		"ID": 940,
		"x": 23.7357760143,
		"y": 66.569168893,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591342,
		"ID": 940,
		"x": 23.0807595903,
		"y": 70.823156321,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591343,
		"ID": 940,
		"x": 25.1897149243,
		"y": 68.608232277,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591346,
		"ID": 940,
		"x": 21.4757138043,
		"y": 69.240199934,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591347,
		"ID": 940,
		"x": 26.3717747143,
		"y": 68.947211492,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591349,
		"ID": 940,
		"x": 25.7677455973,
		"y": 68.466214673,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591350,
		"ID": 940,
		"x": 21.9027722893,
		"y": 70.554160268,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591353,
		"ID": 940,
		"x": 20.7267541933,
		"y": 67.855180236,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591354,
		"ID": 940,
		"x": 24.1007763143,
		"y": 70.363156377,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591355,
		"ID": 940,
		"x": 23.9977631363,
		"y": 70.139197697,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591362,
		"ID": 940,
		"x": 24.0507608273,
		"y": 66.365238646,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591373,
		"ID": 940,
		"x": 23.7027580173,
		"y": 66.018184881,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591376,
		"ID": 940,
		"x": 24.3477595353,
		"y": 65.940239253,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591377,
		"ID": 940,
		"x": 24.6417068253,
		"y": 66.411209356,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591379,
		"ID": 940,
		"x": 23.6407409163,
		"y": 65.697186234,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591380,
		"ID": 940,
		"x": 23.0177242323,
		"y": 70.150214501,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591382,
		"ID": 940,
		"x": 23.8517355843,
		"y": 69.04820595,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591383,
		"ID": 940,
		"x": 22.9127631593,
		"y": 69.738218538,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591386,
		"ID": 940,
		"x": 23.9617102133,
		"y": 67.232180259,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591391,
		"ID": 940,
		"x": 21.5767037323,
		"y": 66.650222695,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591393,
		"ID": 940,
		"x": 24.2847445243,
		"y": 68.146209787,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591403,
		"ID": 940,
		"x": 25.5677234723,
		"y": 68.616222781,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591406,
		"ID": 940,
		"x": 23.7677324923,
		"y": 67.500199495,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591411,
		"ID": 940,
		"x": 24.1077230553,
		"y": 66.10218222,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591416,
		"ID": 940,
		"x": 21.4017420003,
		"y": 67.780215002,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591417,
		"ID": 940,
		"x": 21.7737552593,
		"y": 67.399148215,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591418,
		"ID": 940,
		"x": 22.2117490003,
		"y": 70.568214217,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591419,
		"ID": 940,
		"x": 22.0177707503,
		"y": 67.810146251,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591420,
		"ID": 940,
		"x": 24.7247212643,
		"y": 68.411217285,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591425,
		"ID": 940,
		"x": 22.5337124773,
		"y": 67.664176634,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591433,
		"ID": 940,
		"x": 24.0437178863,
		"y": 66.062247853,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591437,
		"ID": 940,
		"x": 22.1687280193,
		"y": 67.081246192,
		"h": 6.6373626374
	},
	{
		"stop_id": 8591830,
		"ID": 940,
		"x": 24.6607749033,
		"y": 70.159175402,
		"h": 6.6373626374
	},
	{
		"stop_id": 8594185,
		"ID": 940,
		"x": 24.8147083633,
		"y": 70.224196932,
		"h": 6.6373626374
	},
	{
		"stop_id": 8594239,
		"ID": 940,
		"x": 21.8647009003,
		"y": 66.519194257,
		"h": 6.6373626374
	},
	{
		"stop_id": 8594255,
		"ID": 940,
		"x": 23.9707236663,
		"y": 67.043166963,
		"h": 6.6373626374
	},
	{
		"stop_id": 8595899,
		"ID": 940,
		"x": 21.8387130233,
		"y": 69.540187084,
		"h": 6.6373626374
	},
	{
		"stop_id": 8503008,
		"ID": 909,
		"x": 20.9927251053,
		"y": 70.214214258,
		"h": 3.010989011
	},
	{
		"stop_id": 8503526,
		"ID": 909,
		"x": 18.2157012593,
		"y": 71.917180335,
		"h": 3.010989011
	},
	{
		"stop_id": 8576241,
		"ID": 909,
		"x": 19.1447414123,
		"y": 69.231151664,
		"h": 3.010989011
	},
	{
		"stop_id": 8576242,
		"ID": 909,
		"x": 19.0817433543,
		"y": 69.796175587,
		"h": 3.010989011
	},
	{
		"stop_id": 8576243,
		"ID": 909,
		"x": 18.2237063313,
		"y": 70.719173819,
		"h": 3.010989011
	},
	{
		"stop_id": 8576244,
		"ID": 909,
		"x": 18.0147460943,
		"y": 71.082141253,
		"h": 3.010989011
	},
	{
		"stop_id": 8576245,
		"ID": 909,
		"x": 17.7737598633,
		"y": 71.294140565,
		"h": 3.010989011
	},
	{
		"stop_id": 8576246,
		"ID": 909,
		"x": 18.1477209043,
		"y": 71.407240332,
		"h": 3.010989011
	},
	{
		"stop_id": 8576248,
		"ID": 909,
		"x": 18.6027739573,
		"y": 72.193159268,
		"h": 3.010989011
	},
	{
		"stop_id": 8576249,
		"ID": 909,
		"x": 18.8617069983,
		"y": 72.555193371,
		"h": 3.010989011
	},
	{
		"stop_id": 8576250,
		"ID": 909,
		"x": 18.6527118653,
		"y": 72.740228573,
		"h": 3.010989011
	},
	{
		"stop_id": 8576251,
		"ID": 909,
		"x": 18.6307214133,
		"y": 73.136233877,
		"h": 3.010989011
	},
	{
		"stop_id": 8576252,
		"ID": 909,
		"x": 18.1237198523,
		"y": 73.300224803,
		"h": 3.010989011
	},
	{
		"stop_id": 8576253,
		"ID": 909,
		"x": 17.7767737933,
		"y": 73.201155047,
		"h": 3.010989011
	},
	{
		"stop_id": 8576255,
		"ID": 909,
		"x": 17.4497079383,
		"y": 73.624199309,
		"h": 3.010989011
	},
	{
		"stop_id": 8576256,
		"ID": 909,
		"x": 17.1997365353,
		"y": 73.765162866,
		"h": 3.010989011
	},
	{
		"stop_id": 8576262,
		"ID": 909,
		"x": 20.8367556103,
		"y": 70.024171854,
		"h": 3.010989011
	},
	{
		"stop_id": 8576263,
		"ID": 909,
		"x": 20.4447068213,
		"y": 70.257249271,
		"h": 3.010989011
	},
	{
		"stop_id": 8576264,
		"ID": 909,
		"x": 18.3177701433,
		"y": 70.939242139,
		"h": 3.010989011
	},
	{
		"stop_id": 8576265,
		"ID": 909,
		"x": 17.9387072013,
		"y": 71.5751763,
		"h": 3.010989011
	},
	{
		"stop_id": 8576269,
		"ID": 909,
		"x": 17.6597336593,
		"y": 72.109143776,
		"h": 3.010989011
	},
	{
		"stop_id": 8576270,
		"ID": 909,
		"x": 17.3957580663,
		"y": 72.011183223,
		"h": 3.010989011
	},
	{
		"stop_id": 8576271,
		"ID": 909,
		"x": 16.1487516883,
		"y": 72.136169077,
		"h": 3.010989011
	},
	{
		"stop_id": 8576272,
		"ID": 909,
		"x": 15.7397691703,
		"y": 72.238241377,
		"h": 3.010989011
	},
	{
		"stop_id": 8576275,
		"ID": 909,
		"x": 17.3847213023,
		"y": 71.312187689,
		"h": 3.010989011
	},
	{
		"stop_id": 8576278,
		"ID": 909,
		"x": 17.7987119153,
		"y": 72.79324879,
		"h": 3.010989011
	},
	{
		"stop_id": 8576279,
		"ID": 909,
		"x": 17.7437757633,
		"y": 72.472179414,
		"h": 3.010989011
	},
	{
		"stop_id": 8576280,
		"ID": 909,
		"x": 18.0987253373,
		"y": 72.069199691,
		"h": 3.010989011
	},
	{
		"stop_id": 8576281,
		"ID": 909,
		"x": 17.7407740373,
		"y": 73.698166763,
		"h": 3.010989011
	},
	{
		"stop_id": 8590461,
		"ID": 909,
		"x": 18.0497619973,
		"y": 72.953215726,
		"h": 3.010989011
	},
	{
		"stop_id": 8590462,
		"ID": 909,
		"x": 17.8147514213,
		"y": 73.693242539,
		"h": 3.010989011
	},
	{
		"stop_id": 8590726,
		"ID": 909,
		"x": 17.9477686043,
		"y": 68.664145274,
		"h": 3.010989011
	},
	{
		"stop_id": 8590727,
		"ID": 909,
		"x": 17.2487187453,
		"y": 69.005162673,
		"h": 3.010989011
	},
	{
		"stop_id": 8590728,
		"ID": 909,
		"x": 17.5417666043,
		"y": 68.858202116,
		"h": 3.010989011
	},
	{
		"stop_id": 8590754,
		"ID": 909,
		"x": 17.8607236553,
		"y": 71.682233778,
		"h": 3.010989011
	},
	{
		"stop_id": 8590755,
		"ID": 909,
		"x": 17.0397366783,
		"y": 72.221158281,
		"h": 3.010989011
	},
	{
		"stop_id": 8590756,
		"ID": 909,
		"x": 17.6407132283,
		"y": 71.85014722,
		"h": 3.010989011
	},
	{
		"stop_id": 8590757,
		"ID": 909,
		"x": 17.4707600503,
		"y": 72.970207574,
		"h": 3.010989011
	},
	{
		"stop_id": 8590758,
		"ID": 909,
		"x": 17.4497701683,
		"y": 72.798250227,
		"h": 3.010989011
	},
	{
		"stop_id": 8590759,
		"ID": 909,
		"x": 17.4277066233,
		"y": 72.257226648,
		"h": 3.010989011
	},
	{
		"stop_id": 8590760,
		"ID": 909,
		"x": 18.0777278233,
		"y": 71.210174252,
		"h": 3.010989011
	},
	{
		"stop_id": 8590833,
		"ID": 909,
		"x": 16.8247148613,
		"y": 69.194141821,
		"h": 3.010989011
	},
	{
		"stop_id": 8590878,
		"ID": 909,
		"x": 18.2927546693,
		"y": 71.978240317,
		"h": 3.010989011
	},
	{
		"stop_id": 8590908,
		"ID": 909,
		"x": 18.9247221273,
		"y": 72.990244441,
		"h": 3.010989011
	},
	{
		"stop_id": 8591046,
		"ID": 909,
		"x": 20.3847072383,
		"y": 70.670189678,
		"h": 3.010989011
	},
	{
		"stop_id": 8591054,
		"ID": 909,
		"x": 20.9057704043,
		"y": 70.243162817,
		"h": 3.010989011
	},
	{
		"stop_id": 8591090,
		"ID": 909,
		"x": 20.6417402643,
		"y": 70.569151425,
		"h": 3.010989011
	},
	{
		"stop_id": 8591143,
		"ID": 909,
		"x": 19.9217724323,
		"y": 68.868165944,
		"h": 3.010989011
	},
	{
		"stop_id": 8591153,
		"ID": 909,
		"x": 21.1027288963,
		"y": 70.332246595,
		"h": 3.010989011
	},
	{
		"stop_id": 8591155,
		"ID": 909,
		"x": 18.8797092463,
		"y": 69.466247812,
		"h": 3.010989011
	},
	{
		"stop_id": 8591158,
		"ID": 909,
		"x": 19.3017674363,
		"y": 69.05922801,
		"h": 3.010989011
	},
	{
		"stop_id": 8591200,
		"ID": 909,
		"x": 20.0867331293,
		"y": 70.523169158,
		"h": 3.010989011
	},
	{
		"stop_id": 8591275,
		"ID": 909,
		"x": 20.0367016583,
		"y": 68.579164909,
		"h": 3.010989011
	},
	{
		"stop_id": 8591281,
		"ID": 909,
		"x": 20.1887079273,
		"y": 70.728141067,
		"h": 3.010989011
	},
	{
		"stop_id": 8591320,
		"ID": 909,
		"x": 18.8217750683,
		"y": 68.963219466,
		"h": 3.010989011
	},
	{
		"stop_id": 8591328,
		"ID": 909,
		"x": 18.6457221623,
		"y": 69.353175876,
		"h": 3.010989011
	},
	{
		"stop_id": 8591338,
		"ID": 909,
		"x": 20.8767241473,
		"y": 69.688243244,
		"h": 3.010989011
	},
	{
		"stop_id": 8591348,
		"ID": 909,
		"x": 20.1407305423,
		"y": 68.959180406,
		"h": 3.010989011
	},
	{
		"stop_id": 8591358,
		"ID": 909,
		"x": 19.6097363593,
		"y": 68.698187839,
		"h": 3.010989011
	},
	{
		"stop_id": 8591407,
		"ID": 909,
		"x": 21.2347730533,
		"y": 70.626158091,
		"h": 3.010989011
	},
	{
		"stop_id": 8594732,
		"ID": 909,
		"x": 16.5327490053,
		"y": 69.330143449,
		"h": 3.010989011
	},
	{
		"stop_id": 8595714,
		"ID": 909,
		"x": 17.0357332063,
		"y": 73.239197307,
		"h": 3.010989011
	},
	{
		"stop_id": 8503016,
		"ID": 941,
		"x": 25.0067271853,
		"y": 73.547243113,
		"h": 2.5494505495
	},
	{
		"stop_id": 8503309,
		"ID": 941,
		"x": 25.6467490903,
		"y": 72.656199861,
		"h": 2.5494505495
	},
	{
		"stop_id": 8503311,
		"ID": 941,
		"x": 22.7657746243,
		"y": 73.925217768,
		"h": 2.5494505495
	},
	{
		"stop_id": 8503312,
		"ID": 941,
		"x": 21.0717105583,
		"y": 75.696201301,
		"h": 2.5494505495
	},
	{
		"stop_id": 8503857,
		"ID": 941,
		"x": 24.8327320253,
		"y": 77.180219091,
		"h": 2.5494505495
	},
	{
		"stop_id": 8503989,
		"ID": 941,
		"x": 25.0577083223,
		"y": 76.830166922,
		"h": 2.5494505495
	},
	{
		"stop_id": 8573205,
		"ID": 941,
		"x": 25.1077598813,
		"y": 73.555140337,
		"h": 2.5494505495
	},
	{
		"stop_id": 8573210,
		"ID": 941,
		"x": 24.4107031573,
		"y": 76.686154368,
		"h": 2.5494505495
	},
	{
		"stop_id": 8573211,
		"ID": 941,
		"x": 26.3447428133,
		"y": 73.918161075,
		"h": 2.5494505495
	},
	{
		"stop_id": 8573213,
		"ID": 941,
		"x": 25.6417714833,
		"y": 72.933228659,
		"h": 2.5494505495
	},
	{
		"stop_id": 8573214,
		"ID": 941,
		"x": 25.7247717633,
		"y": 72.430152634,
		"h": 2.5494505495
	},
	{
		"stop_id": 8573233,
		"ID": 941,
		"x": 26.3527704333,
		"y": 74.37718671,
		"h": 2.5494505495
	},
	{
		"stop_id": 8573234,
		"ID": 941,
		"x": 26.4457501113,
		"y": 74.595151915,
		"h": 2.5494505495
	},
	{
		"stop_id": 8573237,
		"ID": 941,
		"x": 21.0797104643,
		"y": 75.723219992,
		"h": 2.5494505495
	},
	{
		"stop_id": 8573238,
		"ID": 941,
		"x": 21.5037637533,
		"y": 76.188157443,
		"h": 2.5494505495
	},
	{
		"stop_id": 8573239,
		"ID": 941,
		"x": 21.8307515043,
		"y": 76.389141641,
		"h": 2.5494505495
	},
	{
		"stop_id": 8573240,
		"ID": 941,
		"x": 22.3637442053,
		"y": 74.841215856,
		"h": 2.5494505495
	},
	{
		"stop_id": 8573241,
		"ID": 941,
		"x": 22.7577352353,
		"y": 73.912206974,
		"h": 2.5494505495
	},
	{
		"stop_id": 8573242,
		"ID": 941,
		"x": 23.3397084973,
		"y": 73.464224736,
		"h": 2.5494505495
	},
	{
		"stop_id": 8573244,
		"ID": 941,
		"x": 25.0527073363,
		"y": 72.175187975,
		"h": 2.5494505495
	},
	{
		"stop_id": 8579843,
		"ID": 941,
		"x": 26.0977146903,
		"y": 74.850181413,
		"h": 2.5494505495
	},
	{
		"stop_id": 8579967,
		"ID": 941,
		"x": 26.3207245713,
		"y": 75.320226506,
		"h": 2.5494505495
	},
	{
		"stop_id": 8580301,
		"ID": 941,
		"x": 25.2497692313,
		"y": 73.803144449,
		"h": 2.5494505495
	},
	{
		"stop_id": 8580443,
		"ID": 941,
		"x": 25.5217369893,
		"y": 71.997229827,
		"h": 2.5494505495
	},
	{
		"stop_id": 8582662,
		"ID": 941,
		"x": 22.0187269843,
		"y": 76.812170658,
		"h": 2.5494505495
	},
	{
		"stop_id": 8583761,
		"ID": 941,
		"x": 22.3017324143,
		"y": 77.077179361,
		"h": 2.5494505495
	},
	{
		"stop_id": 8583775,
		"ID": 941,
		"x": 24.3097562323,
		"y": 76.750213936,
		"h": 2.5494505495
	},
	{
		"stop_id": 8587654,
		"ID": 941,
		"x": 25.4277220863,
		"y": 71.788162667,
		"h": 2.5494505495
	},
	{
		"stop_id": 8587799,
		"ID": 941,
		"x": 25.4897412113,
		"y": 72.579212945,
		"h": 2.5494505495
	},
	{
		"stop_id": 8588553,
		"ID": 941,
		"x": 25.7327077313,
		"y": 73.792198315,
		"h": 2.5494505495
	},
	{
		"stop_id": 8588739,
		"ID": 941,
		"x": 26.0337362783,
		"y": 72.974146056,
		"h": 2.5494505495
	},
	{
		"stop_id": 8590631,
		"ID": 941,
		"x": 25.2877179573,
		"y": 71.660165186,
		"h": 2.5494505495
	},
	{
		"stop_id": 8590696,
		"ID": 941,
		"x": 26.1417533383,
		"y": 73.655233738,
		"h": 2.5494505495
	},
	{
		"stop_id": 8590699,
		"ID": 941,
		"x": 26.4297320543,
		"y": 73.608158906,
		"h": 2.5494505495
	},
	{
		"stop_id": 8590762,
		"ID": 941,
		"x": 24.6657081223,
		"y": 71.84018393,
		"h": 2.5494505495
	},
	{
		"stop_id": 8590765,
		"ID": 941,
		"x": 22.9407549063,
		"y": 72.22414593,
		"h": 2.5494505495
	},
	{
		"stop_id": 8590766,
		"ID": 941,
		"x": 22.5837514943,
		"y": 73.689171711,
		"h": 2.5494505495
	},
	{
		"stop_id": 8590767,
		"ID": 941,
		"x": 22.5517025523,
		"y": 73.477232042,
		"h": 2.5494505495
	},
	{
		"stop_id": 8590768,
		"ID": 941,
		"x": 22.3577604533,
		"y": 74.756179169,
		"h": 2.5494505495
	},
	{
		"stop_id": 8591031,
		"ID": 941,
		"x": 25.7877610713,
		"y": 74.455169306,
		"h": 2.5494505495
	},
	{
		"stop_id": 8591032,
		"ID": 941,
		"x": 24.0837696353,
		"y": 72.837232634,
		"h": 2.5494505495
	},
	{
		"stop_id": 8593523,
		"ID": 941,
		"x": 24.0087635543,
		"y": 73.004187386,
		"h": 2.5494505495
	},
	{
		"stop_id": 8594236,
		"ID": 941,
		"x": 22.6217493953,
		"y": 72.991170622,
		"h": 2.5494505495
	},
	{
		"stop_id": 8595709,
		"ID": 941,
		"x": 22.4457056513,
		"y": 73.734177279,
		"h": 2.5494505495
	},
	{
		"stop_id": 8595710,
		"ID": 941,
		"x": 23.0467172933,
		"y": 73.321235179,
		"h": 2.5494505495
	},
	{
		"stop_id": 8595711,
		"ID": 941,
		"x": 22.2337105793,
		"y": 73.112211936,
		"h": 2.5494505495
	},
	{
		"stop_id": 8595712,
		"ID": 941,
		"x": 23.0797013533,
		"y": 73.729228722,
		"h": 2.5494505495
	},
	{
		"stop_id": 8595713,
		"ID": 941,
		"x": 22.3507357283,
		"y": 73.338226328,
		"h": 2.5494505495
	},
	{
		"stop_id": 8503060,
		"ID": 1038,
		"x": 36.4077280593,
		"y": 55.650186055,
		"h": 2.0879120879
	},
	{
		"stop_id": 8503163,
		"ID": 1038,
		"x": 36.8147378183,
		"y": 54.973173828,
		"h": 2.0879120879
	},
	{
		"stop_id": 8503165,
		"ID": 1038,
		"x": 37.0917038403,
		"y": 54.503221833,
		"h": 2.0879120879
	},
	{
		"stop_id": 8503167,
		"ID": 1038,
		"x": 38.9087283743,
		"y": 53.905227426,
		"h": 2.0879120879
	},
	{
		"stop_id": 8503169,
		"ID": 1038,
		"x": 37.5877555013,
		"y": 53.219152388,
		"h": 2.0879120879
	},
	{
		"stop_id": 8503170,
		"ID": 1038,
		"x": 37.0137191303,
		"y": 56.594176935,
		"h": 2.0879120879
	},
	{
		"stop_id": 8503172,
		"ID": 1038,
		"x": 37.2477180023,
		"y": 52.327154785,
		"h": 2.0879120879
	},
	{
		"stop_id": 8503174,
		"ID": 1038,
		"x": 36.6727075853,
		"y": 55.248182371,
		"h": 2.0879120879
	},
	{
		"stop_id": 8503183,
		"ID": 1038,
		"x": 40.2327487133,
		"y": 54.999182992,
		"h": 2.0879120879
	},
	{
		"stop_id": 8503184,
		"ID": 1038,
		"x": 37.2957227743,
		"y": 53.688167866,
		"h": 2.0879120879
	},
	{
		"stop_id": 8503185,
		"ID": 1038,
		"x": 38.4097036643,
		"y": 53.295174458,
		"h": 2.0879120879
	},
	{
		"stop_id": 8503186,
		"ID": 1038,
		"x": 37.1507743113,
		"y": 51.36019428,
		"h": 2.0879120879
	},
	{
		"stop_id": 8503198,
		"ID": 1038,
		"x": 36.4377097673,
		"y": 55.644222614,
		"h": 2.0879120879
	},
	{
		"stop_id": 8503264,
		"ID": 1038,
		"x": 40.6997385593,
		"y": 55.256144188,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575962,
		"ID": 1038,
		"x": 37.2047474243,
		"y": 54.096207644,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575963,
		"ID": 1038,
		"x": 37.5807587073,
		"y": 53.535161055,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575972,
		"ID": 1038,
		"x": 37.3097048773,
		"y": 51.971237502,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575973,
		"ID": 1038,
		"x": 37.4297687943,
		"y": 51.629169421,
		"h": 2.0879120879
	},
	{
		"stop_id": 8576021,
		"ID": 1038,
		"x": 40.4137199283,
		"y": 55.301237249,
		"h": 2.0879120879
	},
	{
		"stop_id": 8576022,
		"ID": 1038,
		"x": 40.1747169233,
		"y": 54.612248699,
		"h": 2.0879120879
	},
	{
		"stop_id": 8576023,
		"ID": 1038,
		"x": 39.4007161373,
		"y": 54.305161162,
		"h": 2.0879120879
	},
	{
		"stop_id": 8576024,
		"ID": 1038,
		"x": 38.6647590453,
		"y": 53.602177544,
		"h": 2.0879120879
	},
	{
		"stop_id": 8576025,
		"ID": 1038,
		"x": 37.0877459703,
		"y": 53.660198346,
		"h": 2.0879120879
	},
	{
		"stop_id": 8576035,
		"ID": 1038,
		"x": 41.2427100453,
		"y": 55.056199728,
		"h": 2.0879120879
	},
	{
		"stop_id": 8576036,
		"ID": 1038,
		"x": 40.8177712813,
		"y": 54.698164675,
		"h": 2.0879120879
	},
	{
		"stop_id": 8576037,
		"ID": 1038,
		"x": 39.9797643433,
		"y": 54.433171539,
		"h": 2.0879120879
	},
	{
		"stop_id": 8576054,
		"ID": 1038,
		"x": 37.5457565183,
		"y": 51.384219753,
		"h": 2.0879120879
	},
	{
		"stop_id": 8587497,
		"ID": 1038,
		"x": 36.6667657983,
		"y": 55.991194947,
		"h": 2.0879120879
	},
	{
		"stop_id": 8587685,
		"ID": 1038,
		"x": 37.2417207513,
		"y": 51.32220521,
		"h": 2.0879120879
	},
	{
		"stop_id": 8587942,
		"ID": 1038,
		"x": 36.5487725033,
		"y": 52.719188249,
		"h": 2.0879120879
	},
	{
		"stop_id": 8588531,
		"ID": 1038,
		"x": 36.7827331153,
		"y": 53.530250057,
		"h": 2.0879120879
	},
	{
		"stop_id": 8590445,
		"ID": 1038,
		"x": 40.2067187553,
		"y": 51.438190284,
		"h": 2.0879120879
	},
	{
		"stop_id": 8590446,
		"ID": 1038,
		"x": 39.8997561963,
		"y": 51.394225628,
		"h": 2.0879120879
	},
	{
		"stop_id": 8590447,
		"ID": 1038,
		"x": 38.7527599713,
		"y": 51.262231497,
		"h": 2.0879120879
	},
	{
		"stop_id": 8503061,
		"ID": 1005,
		"x": 35.2357456833,
		"y": 56.541212422,
		"h": 1.3956043956
	},
	{
		"stop_id": 8503062,
		"ID": 1005,
		"x": 34.8647246163,
		"y": 57.142181098,
		"h": 1.3956043956
	},
	{
		"stop_id": 8503063,
		"ID": 1005,
		"x": 34.4587417893,
		"y": 57.606182636,
		"h": 1.3956043956
	},
	{
		"stop_id": 8503064,
		"ID": 1005,
		"x": 32.5547290293,
		"y": 59.451203392,
		"h": 1.3956043956
	},
	{
		"stop_id": 8503070,
		"ID": 1005,
		"x": 35.8047387953,
		"y": 56.143154789,
		"h": 1.3956043956
	},
	{
		"stop_id": 8503072,
		"ID": 1005,
		"x": 33.5127517463,
		"y": 58.437199832,
		"h": 1.3956043956
	},
	{
		"stop_id": 8588017,
		"ID": 1005,
		"x": 32.9087161103,
		"y": 54.627155344,
		"h": 1.3956043956
	},
	{
		"stop_id": 8588019,
		"ID": 1005,
		"x": 33.1917084743,
		"y": 54.85518752,
		"h": 1.3956043956
	},
	{
		"stop_id": 8588020,
		"ID": 1005,
		"x": 32.9377648053,
		"y": 54.390212774,
		"h": 1.3956043956
	},
	{
		"stop_id": 8588031,
		"ID": 1005,
		"x": 33.4077054333,
		"y": 55.050158363,
		"h": 1.3956043956
	},
	{
		"stop_id": 8588033,
		"ID": 1005,
		"x": 34.1877608413,
		"y": 55.383243425,
		"h": 1.3956043956
	},
	{
		"stop_id": 8590488,
		"ID": 1005,
		"x": 32.3057223163,
		"y": 59.901226993,
		"h": 1.3956043956
	},
	{
		"stop_id": 8590785,
		"ID": 1005,
		"x": 32.6707253683,
		"y": 59.358161208,
		"h": 1.3956043956
	},
	{
		"stop_id": 8503065,
		"ID": 972,
		"x": 31.6747003093,
		"y": 59.742244993,
		"h": 3.2747252747
	},
	{
		"stop_id": 8503066,
		"ID": 972,
		"x": 29.8377175253,
		"y": 60.420181408,
		"h": 3.2747252747
	},
	{
		"stop_id": 8503067,
		"ID": 972,
		"x": 28.2717664073,
		"y": 61.994246175,
		"h": 3.2747252747
	},
	{
		"stop_id": 8503068,
		"ID": 972,
		"x": 30.3927209713,
		"y": 60.038190665,
		"h": 3.2747252747
	},
	{
		"stop_id": 8503074,
		"ID": 972,
		"x": 30.9087336483,
		"y": 59.783194014,
		"h": 3.2747252747
	},
	{
		"stop_id": 8503075,
		"ID": 972,
		"x": 29.3167737563,
		"y": 60.980199429,
		"h": 3.2747252747
	},
	{
		"stop_id": 8503077,
		"ID": 972,
		"x": 27.7707127473,
		"y": 62.127155153,
		"h": 3.2747252747
	},
	{
		"stop_id": 8503078,
		"ID": 972,
		"x": 27.4887284633,
		"y": 61.918181754,
		"h": 3.2747252747
	},
	{
		"stop_id": 8503101,
		"ID": 972,
		"x": 26.5937110333,
		"y": 58.978162232,
		"h": 3.2747252747
	},
	{
		"stop_id": 8503102,
		"ID": 972,
		"x": 27.4387096803,
		"y": 57.504216728,
		"h": 3.2747252747
	},
	{
		"stop_id": 8503141,
		"ID": 972,
		"x": 26.2287216563,
		"y": 59.829151333,
		"h": 3.2747252747
	},
	{
		"stop_id": 8503657,
		"ID": 972,
		"x": 26.3897438783,
		"y": 58.960186238,
		"h": 3.2747252747
	},
	{
		"stop_id": 8503659,
		"ID": 972,
		"x": 27.2767019963,
		"y": 57.195171722,
		"h": 3.2747252747
	},
	{
		"stop_id": 8503682,
		"ID": 972,
		"x": 26.8607645823,
		"y": 57.813205429,
		"h": 3.2747252747
	},
	{
		"stop_id": 8576185,
		"ID": 972,
		"x": 26.2077625833,
		"y": 61.374199587,
		"h": 3.2747252747
	},
	{
		"stop_id": 8576186,
		"ID": 972,
		"x": 26.6287594883,
		"y": 61.280243447,
		"h": 3.2747252747
	},
	{
		"stop_id": 8576187,
		"ID": 972,
		"x": 26.7547660013,
		"y": 61.668141617,
		"h": 3.2747252747
	},
	{
		"stop_id": 8576188,
		"ID": 972,
		"x": 26.9497227163,
		"y": 61.846228955,
		"h": 3.2747252747
	},
	{
		"stop_id": 8576189,
		"ID": 972,
		"x": 27.1457035763,
		"y": 61.938163342,
		"h": 3.2747252747
	},
	{
		"stop_id": 8576204,
		"ID": 972,
		"x": 26.1477672413,
		"y": 60.898204511,
		"h": 3.2747252747
	},
	{
		"stop_id": 8576205,
		"ID": 972,
		"x": 26.3337378043,
		"y": 60.740227812,
		"h": 3.2747252747
	},
	{
		"stop_id": 8576206,
		"ID": 972,
		"x": 26.5007645753,
		"y": 60.3781656,
		"h": 3.2747252747
	},
	{
		"stop_id": 8576207,
		"ID": 972,
		"x": 26.5657670873,
		"y": 60.098239243,
		"h": 3.2747252747
	},
	{
		"stop_id": 8576208,
		"ID": 972,
		"x": 26.7097558643,
		"y": 59.773208492,
		"h": 3.2747252747
	},
	{
		"stop_id": 8576209,
		"ID": 972,
		"x": 26.7357603943,
		"y": 59.405207674,
		"h": 3.2747252747
	},
	{
		"stop_id": 8576210,
		"ID": 972,
		"x": 27.0597119193,
		"y": 59.231142359,
		"h": 3.2747252747
	},
	{
		"stop_id": 8576211,
		"ID": 972,
		"x": 27.2877641983,
		"y": 59.266173753,
		"h": 3.2747252747
	},
	{
		"stop_id": 8576214,
		"ID": 972,
		"x": 28.2197546073,
		"y": 59.962199421,
		"h": 3.2747252747
	},
	{
		"stop_id": 8576215,
		"ID": 972,
		"x": 28.5027305873,
		"y": 60.104170963,
		"h": 3.2747252747
	},
	{
		"stop_id": 8576216,
		"ID": 972,
		"x": 26.8877517853,
		"y": 59.010247096,
		"h": 3.2747252747
	},
	{
		"stop_id": 8576217,
		"ID": 972,
		"x": 26.9707409713,
		"y": 58.733145821,
		"h": 3.2747252747
	},
	{
		"stop_id": 8576218,
		"ID": 972,
		"x": 27.2887472573,
		"y": 58.462157497,
		"h": 3.2747252747
	},
	{
		"stop_id": 8576219,
		"ID": 972,
		"x": 27.4797635403,
		"y": 58.400249018,
		"h": 3.2747252747
	},
	{
		"stop_id": 8576220,
		"ID": 972,
		"x": 27.5507684863,
		"y": 58.616227807,
		"h": 3.2747252747
	},
	{
		"stop_id": 8576221,
		"ID": 972,
		"x": 27.7097246223,
		"y": 58.482247302,
		"h": 3.2747252747
	},
	{
		"stop_id": 8576222,
		"ID": 972,
		"x": 27.8557515223,
		"y": 58.625171111,
		"h": 3.2747252747
	},
	{
		"stop_id": 8576223,
		"ID": 972,
		"x": 26.6127700233,
		"y": 58.988224551,
		"h": 3.2747252747
	},
	{
		"stop_id": 8576224,
		"ID": 972,
		"x": 29.1537155073,
		"y": 60.497175519,
		"h": 3.2747252747
	},
	{
		"stop_id": 8576225,
		"ID": 972,
		"x": 29.4057348773,
		"y": 60.905146329,
		"h": 3.2747252747
	},
	{
		"stop_id": 8576226,
		"ID": 972,
		"x": 29.7687472983,
		"y": 60.562245837,
		"h": 3.2747252747
	},
	{
		"stop_id": 8587964,
		"ID": 972,
		"x": 27.6827488833,
		"y": 57.675151294,
		"h": 3.2747252747
	},
	{
		"stop_id": 8587965,
		"ID": 972,
		"x": 27.4187756093,
		"y": 57.507148431,
		"h": 3.2747252747
	},
	{
		"stop_id": 8587966,
		"ID": 972,
		"x": 27.4297198833,
		"y": 57.282145824,
		"h": 3.2747252747
	},
	{
		"stop_id": 8587968,
		"ID": 972,
		"x": 28.7607705773,
		"y": 57.756181141,
		"h": 3.2747252747
	},
	{
		"stop_id": 8587969,
		"ID": 972,
		"x": 28.2617264103,
		"y": 57.540161658,
		"h": 3.2747252747
	},
	{
		"stop_id": 8587970,
		"ID": 972,
		"x": 28.6727029643,
		"y": 57.667248636,
		"h": 3.2747252747
	},
	{
		"stop_id": 8587971,
		"ID": 972,
		"x": 27.6007344243,
		"y": 57.410196251,
		"h": 3.2747252747
	},
	{
		"stop_id": 8587973,
		"ID": 972,
		"x": 27.8267009253,
		"y": 57.509151889,
		"h": 3.2747252747
	},
	{
		"stop_id": 8587974,
		"ID": 972,
		"x": 27.5807008093,
		"y": 57.173174028,
		"h": 3.2747252747
	},
	{
		"stop_id": 8587976,
		"ID": 972,
		"x": 27.8757673923,
		"y": 57.715247831,
		"h": 3.2747252747
	},
	{
		"stop_id": 8587978,
		"ID": 972,
		"x": 28.0867293173,
		"y": 57.677225876,
		"h": 3.2747252747
	},
	{
		"stop_id": 8587979,
		"ID": 972,
		"x": 27.9277473323,
		"y": 57.130145335,
		"h": 3.2747252747
	},
	{
		"stop_id": 8587980,
		"ID": 972,
		"x": 29.0997569263,
		"y": 57.684191112,
		"h": 3.2747252747
	},
	{
		"stop_id": 8588205,
		"ID": 972,
		"x": 28.4837587283,
		"y": 57.577150224,
		"h": 3.2747252747
	},
	{
		"stop_id": 8590668,
		"ID": 972,
		"x": 27.9027616443,
		"y": 59.824186573,
		"h": 3.2747252747
	},
	{
		"stop_id": 8590669,
		"ID": 972,
		"x": 27.5957098793,
		"y": 59.739153763,
		"h": 3.2747252747
	},
	{
		"stop_id": 8590701,
		"ID": 972,
		"x": 27.1287604863,
		"y": 58.135243241,
		"h": 3.2747252747
	},
	{
		"stop_id": 8590702,
		"ID": 972,
		"x": 26.9417555933,
		"y": 58.362230472,
		"h": 3.2747252747
	},
	{
		"stop_id": 8590703,
		"ID": 972,
		"x": 27.2517597603,
		"y": 58.246236046,
		"h": 3.2747252747
	},
	{
		"stop_id": 8590704,
		"ID": 972,
		"x": 26.8467272113,
		"y": 58.697198429,
		"h": 3.2747252747
	},
	{
		"stop_id": 8590705,
		"ID": 972,
		"x": 26.6907589783,
		"y": 58.882171258,
		"h": 3.2747252747
	},
	{
		"stop_id": 8590879,
		"ID": 972,
		"x": 27.5097200543,
		"y": 61.909150407,
		"h": 3.2747252747
	},
	{
		"stop_id": 8591023,
		"ID": 972,
		"x": 27.8737596763,
		"y": 62.073191635,
		"h": 3.2747252747
	},
	{
		"stop_id": 8591024,
		"ID": 972,
		"x": 27.7897690283,
		"y": 62.423210733,
		"h": 3.2747252747
	},
	{
		"stop_id": 8591025,
		"ID": 972,
		"x": 29.3747044863,
		"y": 61.848156775,
		"h": 3.2747252747
	},
	{
		"stop_id": 8591026,
		"ID": 972,
		"x": 28.5407217233,
		"y": 62.26922346,
		"h": 3.2747252747
	},
	{
		"stop_id": 8591027,
		"ID": 972,
		"x": 29.1877668093,
		"y": 62.183156194,
		"h": 3.2747252747
	},
	{
		"stop_id": 8591028,
		"ID": 972,
		"x": 28.2147439143,
		"y": 62.012191633,
		"h": 3.2747252747
	},
	{
		"stop_id": 8591029,
		"ID": 972,
		"x": 28.1547575313,
		"y": 62.500219518,
		"h": 3.2747252747
	},
	{
		"stop_id": 8591903,
		"ID": 972,
		"x": 27.7117473813,
		"y": 62.241147739,
		"h": 3.2747252747
	},
	{
		"stop_id": 8503084,
		"ID": 973,
		"x": 26.0467225473,
		"y": 64.980195884,
		"h": 3.8681318681
	},
	{
		"stop_id": 8503128,
		"ID": 973,
		"x": 29.6927624353,
		"y": 68.022249079,
		"h": 3.8681318681
	},
	{
		"stop_id": 8503147,
		"ID": 973,
		"x": 27.6387153833,
		"y": 67.673237658,
		"h": 3.8681318681
	},
	{
		"stop_id": 8587653,
		"ID": 973,
		"x": 29.7107022683,
		"y": 67.984157507,
		"h": 3.8681318681
	},
	{
		"stop_id": 8590504,
		"ID": 973,
		"x": 30.5287599553,
		"y": 63.699208686,
		"h": 3.8681318681
	},
	{
		"stop_id": 8590505,
		"ID": 973,
		"x": 29.8937231343,
		"y": 63.450169577,
		"h": 3.8681318681
	},
	{
		"stop_id": 8590510,
		"ID": 973,
		"x": 27.6207674263,
		"y": 68.470241638,
		"h": 3.8681318681
	},
	{
		"stop_id": 8590547,
		"ID": 973,
		"x": 29.4857116173,
		"y": 66.666212154,
		"h": 3.8681318681
	},
	{
		"stop_id": 8590548,
		"ID": 973,
		"x": 29.7557284403,
		"y": 68.097145337,
		"h": 3.8681318681
	},
	{
		"stop_id": 8590549,
		"ID": 973,
		"x": 30.5447208323,
		"y": 67.450174145,
		"h": 3.8681318681
	},
	{
		"stop_id": 8590550,
		"ID": 973,
		"x": 29.8647429033,
		"y": 67.688148144,
		"h": 3.8681318681
	},
	{
		"stop_id": 8590551,
		"ID": 973,
		"x": 30.2867347013,
		"y": 67.429234427,
		"h": 3.8681318681
	},
	{
		"stop_id": 8590552,
		"ID": 973,
		"x": 28.3767115513,
		"y": 67.518156485,
		"h": 3.8681318681
	},
	{
		"stop_id": 8590554,
		"ID": 973,
		"x": 29.1757231913,
		"y": 67.672204686,
		"h": 3.8681318681
	},
	{
		"stop_id": 8590555,
		"ID": 973,
		"x": 30.1017294223,
		"y": 67.45022126,
		"h": 3.8681318681
	},
	{
		"stop_id": 8590557,
		"ID": 973,
		"x": 28.7867270413,
		"y": 68.20823285,
		"h": 3.8681318681
	},
	{
		"stop_id": 8590558,
		"ID": 973,
		"x": 29.9907256313,
		"y": 68.283173338,
		"h": 3.8681318681
	},
	{
		"stop_id": 8590561,
		"ID": 973,
		"x": 28.5007268453,
		"y": 68.235210634,
		"h": 3.8681318681
	},
	{
		"stop_id": 8590562,
		"ID": 973,
		"x": 30.1917506043,
		"y": 67.60314701,
		"h": 3.8681318681
	},
	{
		"stop_id": 8590563,
		"ID": 973,
		"x": 29.2357575473,
		"y": 67.038181059,
		"h": 3.8681318681
	},
	{
		"stop_id": 8590566,
		"ID": 973,
		"x": 27.8707244753,
		"y": 67.551236912,
		"h": 3.8681318681
	},
	{
		"stop_id": 8590567,
		"ID": 973,
		"x": 29.0507323603,
		"y": 67.090223988,
		"h": 3.8681318681
	},
	{
		"stop_id": 8590568,
		"ID": 973,
		"x": 29.2507655983,
		"y": 68.180160722,
		"h": 3.8681318681
	},
	{
		"stop_id": 8590569,
		"ID": 973,
		"x": 27.6907147673,
		"y": 66.815247263,
		"h": 3.8681318681
	},
	{
		"stop_id": 8590570,
		"ID": 973,
		"x": 29.3177611103,
		"y": 66.822249157,
		"h": 3.8681318681
	},
	{
		"stop_id": 8590571,
		"ID": 973,
		"x": 29.5697161673,
		"y": 66.694164854,
		"h": 3.8681318681
	},
	{
		"stop_id": 8590573,
		"ID": 973,
		"x": 30.1267500703,
		"y": 66.821234398,
		"h": 3.8681318681
	},
	{
		"stop_id": 8590575,
		"ID": 973,
		"x": 29.4607213893,
		"y": 67.844172743,
		"h": 3.8681318681
	},
	{
		"stop_id": 8590576,
		"ID": 973,
		"x": 28.9587413833,
		"y": 67.636148715,
		"h": 3.8681318681
	},
	{
		"stop_id": 8590577,
		"ID": 973,
		"x": 29.1577079843,
		"y": 67.997180903,
		"h": 3.8681318681
	},
	{
		"stop_id": 8590578,
		"ID": 973,
		"x": 28.2407336193,
		"y": 68.529234948,
		"h": 3.8681318681
	},
	{
		"stop_id": 8590579,
		"ID": 973,
		"x": 28.0237714503,
		"y": 68.305181828,
		"h": 3.8681318681
	},
	{
		"stop_id": 8590580,
		"ID": 973,
		"x": 29.2087404983,
		"y": 67.580185879,
		"h": 3.8681318681
	},
	{
		"stop_id": 8590581,
		"ID": 973,
		"x": 30.5727401183,
		"y": 67.088214679,
		"h": 3.8681318681
	},
	{
		"stop_id": 8590582,
		"ID": 973,
		"x": 28.4747563313,
		"y": 68.012210691,
		"h": 3.8681318681
	},
	{
		"stop_id": 8590583,
		"ID": 973,
		"x": 28.2487056743,
		"y": 67.718183895,
		"h": 3.8681318681
	},
	{
		"stop_id": 8590586,
		"ID": 973,
		"x": 29.6797161833,
		"y": 67.626195851,
		"h": 3.8681318681
	},
	{
		"stop_id": 8590587,
		"ID": 973,
		"x": 30.4567354153,
		"y": 67.253240526,
		"h": 3.8681318681
	},
	{
		"stop_id": 8590588,
		"ID": 973,
		"x": 28.2097481313,
		"y": 67.484206789,
		"h": 3.8681318681
	},
	{
		"stop_id": 8590589,
		"ID": 973,
		"x": 29.4427440693,
		"y": 67.664210118,
		"h": 3.8681318681
	},
	{
		"stop_id": 8590590,
		"ID": 973,
		"x": 30.3927529433,
		"y": 66.972165,
		"h": 3.8681318681
	},
	{
		"stop_id": 8590591,
		"ID": 973,
		"x": 29.3077434493,
		"y": 67.860218036,
		"h": 3.8681318681
	},
	{
		"stop_id": 8590592,
		"ID": 973,
		"x": 28.7417181563,
		"y": 67.365144656,
		"h": 3.8681318681
	},
	{
		"stop_id": 8590593,
		"ID": 973,
		"x": 29.2547476023,
		"y": 67.332244186,
		"h": 3.8681318681
	},
	{
		"stop_id": 8590594,
		"ID": 973,
		"x": 29.4067536473,
		"y": 68.485181233,
		"h": 3.8681318681
	},
	{
		"stop_id": 8590604,
		"ID": 973,
		"x": 30.5067457773,
		"y": 65.194220465,
		"h": 3.8681318681
	},
	{
		"stop_id": 8590605,
		"ID": 973,
		"x": 30.5947279833,
		"y": 64.868203176,
		"h": 3.8681318681
	},
	{
		"stop_id": 8590606,
		"ID": 973,
		"x": 31.0057125193,
		"y": 64.899167984,
		"h": 3.8681318681
	},
	{
		"stop_id": 8590607,
		"ID": 973,
		"x": 31.3147049463,
		"y": 65.383159244,
		"h": 3.8681318681
	},
	{
		"stop_id": 8590610,
		"ID": 973,
		"x": 30.4307240633,
		"y": 64.536235075,
		"h": 3.8681318681
	},
	{
		"stop_id": 8590611,
		"ID": 973,
		"x": 31.1587271383,
		"y": 64.812223587,
		"h": 3.8681318681
	},
	{
		"stop_id": 8590612,
		"ID": 973,
		"x": 30.7067401553,
		"y": 64.943189275,
		"h": 3.8681318681
	},
	{
		"stop_id": 8590635,
		"ID": 973,
		"x": 27.9547349963,
		"y": 66.303206423,
		"h": 3.8681318681
	},
	{
		"stop_id": 8590751,
		"ID": 973,
		"x": 29.5027501163,
		"y": 64.015141287,
		"h": 3.8681318681
	},
	{
		"stop_id": 8590752,
		"ID": 973,
		"x": 30.1347042963,
		"y": 64.524177023,
		"h": 3.8681318681
	},
	{
		"stop_id": 8590753,
		"ID": 973,
		"x": 29.8507708813,
		"y": 64.352196321,
		"h": 3.8681318681
	},
	{
		"stop_id": 8591065,
		"ID": 973,
		"x": 27.6387630313,
		"y": 67.680243643,
		"h": 3.8681318681
	},
	{
		"stop_id": 8591072,
		"ID": 973,
		"x": 27.2407240763,
		"y": 63.363164382,
		"h": 3.8681318681
	},
	{
		"stop_id": 8591102,
		"ID": 973,
		"x": 27.1367590833,
		"y": 63.631172784,
		"h": 3.8681318681
	},
	{
		"stop_id": 8591107,
		"ID": 973,
		"x": 26.9817645703,
		"y": 63.339243978,
		"h": 3.8681318681
	},
	{
		"stop_id": 8591114,
		"ID": 973,
		"x": 26.1217221773,
		"y": 65.606191274,
		"h": 3.8681318681
	},
	{
		"stop_id": 8591132,
		"ID": 973,
		"x": 25.5447204513,
		"y": 65.793225572,
		"h": 3.8681318681
	},
	{
		"stop_id": 8591147,
		"ID": 973,
		"x": 28.2027257623,
		"y": 63.693149715,
		"h": 3.8681318681
	},
	{
		"stop_id": 8591162,
		"ID": 973,
		"x": 27.9377481003,
		"y": 63.648193509,
		"h": 3.8681318681
	},
	{
		"stop_id": 8591194,
		"ID": 973,
		"x": 27.2537661023,
		"y": 68.339188835,
		"h": 3.8681318681
	},
	{
		"stop_id": 8591211,
		"ID": 973,
		"x": 26.2097665683,
		"y": 66.253171467,
		"h": 3.8681318681
	},
	{
		"stop_id": 8591228,
		"ID": 973,
		"x": 28.0877584243,
		"y": 63.003155746,
		"h": 3.8681318681
	},
	{
		"stop_id": 8591261,
		"ID": 973,
		"x": 27.5787311273,
		"y": 63.519246194,
		"h": 3.8681318681
	},
	{
		"stop_id": 8591271,
		"ID": 973,
		"x": 27.2427285453,
		"y": 67.826195466,
		"h": 3.8681318681
	},
	{
		"stop_id": 8591300,
		"ID": 973,
		"x": 27.2837445143,
		"y": 63.186219819,
		"h": 3.8681318681
	},
	{
		"stop_id": 8591305,
		"ID": 973,
		"x": 26.9137674053,
		"y": 67.997172591,
		"h": 3.8681318681
	},
	{
		"stop_id": 8591360,
		"ID": 973,
		"x": 27.4677269953,
		"y": 63.063163898,
		"h": 3.8681318681
	},
	{
		"stop_id": 8591389,
		"ID": 973,
		"x": 25.5457226613,
		"y": 65.566182325,
		"h": 3.8681318681
	},
	{
		"stop_id": 8591396,
		"ID": 973,
		"x": 26.9867313413,
		"y": 66.13817744,
		"h": 3.8681318681
	},
	{
		"stop_id": 8591399,
		"ID": 973,
		"x": 27.8957050833,
		"y": 62.894234656,
		"h": 3.8681318681
	},
	{
		"stop_id": 8591400,
		"ID": 973,
		"x": 28.0827750403,
		"y": 62.865201832,
		"h": 3.8681318681
	},
	{
		"stop_id": 8591424,
		"ID": 973,
		"x": 26.6677581783,
		"y": 63.380247497,
		"h": 3.8681318681
	},
	{
		"stop_id": 8591432,
		"ID": 973,
		"x": 27.7587347173,
		"y": 63.005183932,
		"h": 3.8681318681
	},
	{
		"stop_id": 8591438,
		"ID": 973,
		"x": 26.8787687623,
		"y": 63.433141945,
		"h": 3.8681318681
	},
	{
		"stop_id": 8591442,
		"ID": 973,
		"x": 25.8087708713,
		"y": 65.907225327,
		"h": 3.8681318681
	},
	{
		"stop_id": 8591443,
		"ID": 973,
		"x": 26.3037175933,
		"y": 65.795192459,
		"h": 3.8681318681
	},
	{
		"stop_id": 8591445,
		"ID": 973,
		"x": 27.8367079903,
		"y": 63.210153265,
		"h": 3.8681318681
	},
	{
		"stop_id": 8591826,
		"ID": 973,
		"x": 30.1097632623,
		"y": 63.249176639,
		"h": 3.8681318681
	},
	{
		"stop_id": 8591831,
		"ID": 973,
		"x": 27.8107373653,
		"y": 65.985173037,
		"h": 3.8681318681
	},
	{
		"stop_id": 8591832,
		"ID": 973,
		"x": 29.3127310533,
		"y": 63.860169303,
		"h": 3.8681318681
	},
	{
		"stop_id": 8594249,
		"ID": 973,
		"x": 30.2567353193,
		"y": 63.731210111,
		"h": 3.8681318681
	},
	{
		"stop_id": 8594250,
		"ID": 973,
		"x": 30.2667547213,
		"y": 63.320165362,
		"h": 3.8681318681
	},
	{
		"stop_id": 8594261,
		"ID": 973,
		"x": 28.0547055293,
		"y": 68.128172708,
		"h": 3.8681318681
	},
	{
		"stop_id": 8503105,
		"ID": 1004,
		"x": 34.1197209583,
		"y": 52.407206438,
		"h": 4.0659340659
	},
	{
		"stop_id": 8503106,
		"ID": 1004,
		"x": 35.1557473533,
		"y": 51.800216289,
		"h": 4.0659340659
	},
	{
		"stop_id": 8503160,
		"ID": 1004,
		"x": 36.3657149973,
		"y": 51.888168838,
		"h": 4.0659340659
	},
	{
		"stop_id": 8503187,
		"ID": 1004,
		"x": 36.0077056033,
		"y": 52.221190122,
		"h": 4.0659340659
	},
	{
		"stop_id": 8503205,
		"ID": 1004,
		"x": 31.4867729653,
		"y": 51.008193797,
		"h": 4.0659340659
	},
	{
		"stop_id": 8503206,
		"ID": 1004,
		"x": 33.9007194203,
		"y": 49.098239985,
		"h": 4.0659340659
	},
	{
		"stop_id": 8503363,
		"ID": 1004,
		"x": 34.3987200623,
		"y": 52.996161643,
		"h": 4.0659340659
	},
	{
		"stop_id": 8503663,
		"ID": 1004,
		"x": 33.8827394503,
		"y": 52.357209405,
		"h": 4.0659340659
	},
	{
		"stop_id": 8503664,
		"ID": 1004,
		"x": 34.9117129923,
		"y": 51.726159448,
		"h": 4.0659340659
	},
	{
		"stop_id": 8503670,
		"ID": 1004,
		"x": 33.9107660723,
		"y": 49.191243102,
		"h": 4.0659340659
	},
	{
		"stop_id": 8503671,
		"ID": 1004,
		"x": 31.8647327383,
		"y": 51.431200697,
		"h": 4.0659340659
	},
	{
		"stop_id": 8503795,
		"ID": 1004,
		"x": 32.2237236343,
		"y": 49.628223318,
		"h": 4.0659340659
	},
	{
		"stop_id": 8503798,
		"ID": 1004,
		"x": 33.8827351473,
		"y": 49.105184005,
		"h": 4.0659340659
	},
	{
		"stop_id": 8503866,
		"ID": 1004,
		"x": 31.6817085473,
		"y": 49.908175822,
		"h": 4.0659340659
	},
	{
		"stop_id": 8573571,
		"ID": 1004,
		"x": 31.7937409433,
		"y": 48.746178279,
		"h": 4.0659340659
	},
	{
		"stop_id": 8573574,
		"ID": 1004,
		"x": 32.6217190863,
		"y": 49.325175128,
		"h": 4.0659340659
	},
	{
		"stop_id": 8573575,
		"ID": 1004,
		"x": 33.0627173403,
		"y": 49.273227063,
		"h": 4.0659340659
	},
	{
		"stop_id": 8573576,
		"ID": 1004,
		"x": 33.5177674483,
		"y": 49.137249227,
		"h": 4.0659340659
	},
	{
		"stop_id": 8573577,
		"ID": 1004,
		"x": 33.5437647553,
		"y": 48.914163031,
		"h": 4.0659340659
	},
	{
		"stop_id": 8573578,
		"ID": 1004,
		"x": 33.7387336873,
		"y": 48.514159236,
		"h": 4.0659340659
	},
	{
		"stop_id": 8576027,
		"ID": 1004,
		"x": 35.9257075253,
		"y": 51.827247087,
		"h": 4.0659340659
	},
	{
		"stop_id": 8576028,
		"ID": 1004,
		"x": 35.5737738343,
		"y": 51.76421284,
		"h": 4.0659340659
	},
	{
		"stop_id": 8576029,
		"ID": 1004,
		"x": 35.2187538533,
		"y": 51.761194145,
		"h": 4.0659340659
	},
	{
		"stop_id": 8576082,
		"ID": 1004,
		"x": 31.9817561103,
		"y": 53.290240948,
		"h": 4.0659340659
	},
	{
		"stop_id": 8576083,
		"ID": 1004,
		"x": 32.2907310173,
		"y": 53.025159261,
		"h": 4.0659340659
	},
	{
		"stop_id": 8576084,
		"ID": 1004,
		"x": 32.9017380843,
		"y": 52.950155188,
		"h": 4.0659340659
	},
	{
		"stop_id": 8576085,
		"ID": 1004,
		"x": 33.3497664263,
		"y": 53.18121484,
		"h": 4.0659340659
	},
	{
		"stop_id": 8576086,
		"ID": 1004,
		"x": 33.7607139613,
		"y": 53.227145473,
		"h": 4.0659340659
	},
	{
		"stop_id": 8576087,
		"ID": 1004,
		"x": 34.7427376153,
		"y": 52.80114573,
		"h": 4.0659340659
	},
	{
		"stop_id": 8576088,
		"ID": 1004,
		"x": 35.3217763283,
		"y": 52.495156555,
		"h": 4.0659340659
	},
	{
		"stop_id": 8576089,
		"ID": 1004,
		"x": 35.6957265763,
		"y": 52.396188996,
		"h": 4.0659340659
	},
	{
		"stop_id": 8580292,
		"ID": 1004,
		"x": 33.5757258893,
		"y": 49.136157795,
		"h": 4.0659340659
	},
	{
		"stop_id": 8581572,
		"ID": 1004,
		"x": 33.0577461423,
		"y": 48.830164209,
		"h": 4.0659340659
	},
	{
		"stop_id": 8581573,
		"ID": 1004,
		"x": 32.8017460463,
		"y": 49.116157592,
		"h": 4.0659340659
	},
	{
		"stop_id": 8587682,
		"ID": 1004,
		"x": 35.1097454653,
		"y": 51.950147131,
		"h": 4.0659340659
	},
	{
		"stop_id": 8587683,
		"ID": 1004,
		"x": 35.5067453283,
		"y": 51.558209682,
		"h": 4.0659340659
	},
	{
		"stop_id": 8587684,
		"ID": 1004,
		"x": 35.8917285773,
		"y": 51.38915698,
		"h": 4.0659340659
	},
	{
		"stop_id": 8587689,
		"ID": 1004,
		"x": 36.2707626823,
		"y": 51.135192849,
		"h": 4.0659340659
	},
	{
		"stop_id": 8587951,
		"ID": 1004,
		"x": 34.1237043613,
		"y": 52.428173552,
		"h": 4.0659340659
	},
	{
		"stop_id": 8588013,
		"ID": 1004,
		"x": 32.9457695173,
		"y": 53.538159407,
		"h": 4.0659340659
	},
	{
		"stop_id": 8588014,
		"ID": 1004,
		"x": 31.7857640863,
		"y": 53.705186816,
		"h": 4.0659340659
	},
	{
		"stop_id": 8588015,
		"ID": 1004,
		"x": 32.3827353123,
		"y": 53.198155232,
		"h": 4.0659340659
	},
	{
		"stop_id": 8588016,
		"ID": 1004,
		"x": 33.2177249273,
		"y": 53.870206405,
		"h": 4.0659340659
	},
	{
		"stop_id": 8588021,
		"ID": 1004,
		"x": 32.6367440563,
		"y": 53.232234845,
		"h": 4.0659340659
	},
	{
		"stop_id": 8588022,
		"ID": 1004,
		"x": 33.4767295743,
		"y": 53.767189244,
		"h": 4.0659340659
	},
	{
		"stop_id": 8588024,
		"ID": 1004,
		"x": 32.4797608993,
		"y": 53.749172811,
		"h": 4.0659340659
	},
	{
		"stop_id": 8588025,
		"ID": 1004,
		"x": 32.7477496163,
		"y": 54.050225103,
		"h": 4.0659340659
	},
	{
		"stop_id": 8588026,
		"ID": 1004,
		"x": 33.0607470973,
		"y": 53.876201112,
		"h": 4.0659340659
	},
	{
		"stop_id": 8588027,
		"ID": 1004,
		"x": 32.1507210843,
		"y": 53.684249464,
		"h": 4.0659340659
	},
	{
		"stop_id": 8588034,
		"ID": 1004,
		"x": 32.8107506973,
		"y": 53.97014774,
		"h": 4.0659340659
	},
	{
		"stop_id": 8588044,
		"ID": 1004,
		"x": 34.5577006203,
		"y": 53.890227458,
		"h": 4.0659340659
	},
	{
		"stop_id": 8588045,
		"ID": 1004,
		"x": 34.5327467553,
		"y": 53.250250578,
		"h": 4.0659340659
	},
	{
		"stop_id": 8588046,
		"ID": 1004,
		"x": 34.1757016143,
		"y": 52.773247228,
		"h": 4.0659340659
	},
	{
		"stop_id": 8588048,
		"ID": 1004,
		"x": 34.1577021963,
		"y": 53.490154152,
		"h": 4.0659340659
	},
	{
		"stop_id": 8588049,
		"ID": 1004,
		"x": 34.3617607103,
		"y": 53.685192351,
		"h": 4.0659340659
	},
	{
		"stop_id": 8588429,
		"ID": 1004,
		"x": 34.6737437673,
		"y": 53.817239051,
		"h": 4.0659340659
	},
	{
		"stop_id": 8588430,
		"ID": 1004,
		"x": 34.0007060433,
		"y": 53.156208391,
		"h": 4.0659340659
	},
	{
		"stop_id": 8588734,
		"ID": 1004,
		"x": 35.0107192043,
		"y": 52.586144152,
		"h": 4.0659340659
	},
	{
		"stop_id": 8590489,
		"ID": 1004,
		"x": 30.8017718033,
		"y": 51.043189503,
		"h": 4.0659340659
	},
	{
		"stop_id": 8590490,
		"ID": 1004,
		"x": 31.5497466403,
		"y": 50.295203536,
		"h": 4.0659340659
	},
	{
		"stop_id": 8590491,
		"ID": 1004,
		"x": 31.9617528473,
		"y": 50.904205566,
		"h": 4.0659340659
	},
	{
		"stop_id": 8590492,
		"ID": 1004,
		"x": 31.8327661213,
		"y": 50.833165839,
		"h": 4.0659340659
	},
	{
		"stop_id": 8590493,
		"ID": 1004,
		"x": 31.5327091953,
		"y": 50.975208591,
		"h": 4.0659340659
	},
	{
		"stop_id": 8590494,
		"ID": 1004,
		"x": 32.3367239103,
		"y": 50.512164015,
		"h": 4.0659340659
	},
	{
		"stop_id": 8590495,
		"ID": 1004,
		"x": 32.5557307033,
		"y": 50.194220087,
		"h": 4.0659340659
	},
	{
		"stop_id": 8590496,
		"ID": 1004,
		"x": 31.1057010493,
		"y": 50.275164456,
		"h": 4.0659340659
	},
	{
		"stop_id": 8590497,
		"ID": 1004,
		"x": 30.8367570813,
		"y": 51.132230928,
		"h": 4.0659340659
	},
	{
		"stop_id": 8590498,
		"ID": 1004,
		"x": 31.6357178743,
		"y": 50.45119204,
		"h": 4.0659340659
	},
	{
		"stop_id": 8590499,
		"ID": 1004,
		"x": 30.7257066393,
		"y": 51.240172769,
		"h": 4.0659340659
	},
	{
		"stop_id": 8590500,
		"ID": 1004,
		"x": 32.0497482433,
		"y": 50.423217297,
		"h": 4.0659340659
	},
	{
		"stop_id": 8590501,
		"ID": 1004,
		"x": 32.6567248033,
		"y": 50.293193639,
		"h": 4.0659340659
	},
	{
		"stop_id": 8590502,
		"ID": 1004,
		"x": 30.6137362753,
		"y": 51.125164796,
		"h": 4.0659340659
	},
	{
		"stop_id": 8590718,
		"ID": 1004,
		"x": 32.3887724933,
		"y": 53.365148131,
		"h": 4.0659340659
	},
	{
		"stop_id": 8590855,
		"ID": 1004,
		"x": 32.8397280753,
		"y": 49.449210587,
		"h": 4.0659340659
	},
	{
		"stop_id": 8590856,
		"ID": 1004,
		"x": 33.7467097553,
		"y": 49.148185793,
		"h": 4.0659340659
	},
	{
		"stop_id": 8590859,
		"ID": 1004,
		"x": 32.9597243633,
		"y": 49.117174811,
		"h": 4.0659340659
	},
	{
		"stop_id": 8590860,
		"ID": 1004,
		"x": 34.4857579613,
		"y": 48.48114814,
		"h": 4.0659340659
	},
	{
		"stop_id": 8590861,
		"ID": 1004,
		"x": 33.3347202673,
		"y": 49.165178857,
		"h": 4.0659340659
	},
	{
		"stop_id": 8590862,
		"ID": 1004,
		"x": 33.0357483073,
		"y": 49.545224199,
		"h": 4.0659340659
	},
	{
		"stop_id": 8590863,
		"ID": 1004,
		"x": 34.4137459333,
		"y": 48.42218717,
		"h": 4.0659340659
	},
	{
		"stop_id": 8590866,
		"ID": 1004,
		"x": 33.1747116293,
		"y": 49.289209931,
		"h": 4.0659340659
	},
	{
		"stop_id": 8590868,
		"ID": 1004,
		"x": 33.8927539633,
		"y": 48.647233886,
		"h": 4.0659340659
	},
	{
		"stop_id": 8590869,
		"ID": 1004,
		"x": 33.6427155433,
		"y": 49.100183623,
		"h": 4.0659340659
	},
	{
		"stop_id": 8590871,
		"ID": 1004,
		"x": 32.9047322603,
		"y": 49.671160722,
		"h": 4.0659340659
	},
	{
		"stop_id": 8590872,
		"ID": 1004,
		"x": 32.9917187563,
		"y": 49.867213717,
		"h": 4.0659340659
	},
	{
		"stop_id": 8590873,
		"ID": 1004,
		"x": 32.7557602063,
		"y": 49.608240298,
		"h": 4.0659340659
	},
	{
		"stop_id": 8590874,
		"ID": 1004,
		"x": 33.4537511373,
		"y": 48.433183371,
		"h": 4.0659340659
	},
	{
		"stop_id": 8590875,
		"ID": 1004,
		"x": 32.6787168993,
		"y": 49.254232078,
		"h": 4.0659340659
	},
	{
		"stop_id": 8590877,
		"ID": 1004,
		"x": 33.6977585963,
		"y": 49.318205595,
		"h": 4.0659340659
	},
	{
		"stop_id": 8594283,
		"ID": 1004,
		"x": 35.4297686913,
		"y": 51.774245727,
		"h": 4.0659340659
	},
	{
		"stop_id": 8594643,
		"ID": 1004,
		"x": 35.0027731083,
		"y": 53.506248309,
		"h": 4.0659340659
	},
	{
		"stop_id": 8594644,
		"ID": 1004,
		"x": 34.7297298433,
		"y": 53.33321795,
		"h": 4.0659340659
	},
	{
		"stop_id": 8594645,
		"ID": 1004,
		"x": 34.8007153573,
		"y": 53.576192151,
		"h": 4.0659340659
	},
	{
		"stop_id": 8595510,
		"ID": 1004,
		"x": 34.2127339903,
		"y": 48.655175748,
		"h": 4.0659340659
	},
	{
		"stop_id": 8503107,
		"ID": 1037,
		"x": 37.3967611603,
		"y": 50.40217198,
		"h": 3.1098901099
	},
	{
		"stop_id": 8503108,
		"ID": 1037,
		"x": 39.7507219983,
		"y": 49.922193721,
		"h": 3.1098901099
	},
	{
		"stop_id": 8503207,
		"ID": 1037,
		"x": 36.3817459303,
		"y": 46.81017264,
		"h": 3.1098901099
	},
	{
		"stop_id": 8503208,
		"ID": 1037,
		"x": 37.8877582923,
		"y": 46.013234071,
		"h": 3.1098901099
	},
	{
		"stop_id": 8503210,
		"ID": 1037,
		"x": 40.0757473553,
		"y": 46.753197649,
		"h": 3.1098901099
	},
	{
		"stop_id": 8503289,
		"ID": 1037,
		"x": 40.3227503193,
		"y": 46.412209109,
		"h": 3.1098901099
	},
	{
		"stop_id": 8503295,
		"ID": 1037,
		"x": 38.4357696723,
		"y": 45.644207443,
		"h": 3.1098901099
	},
	{
		"stop_id": 8503359,
		"ID": 1037,
		"x": 38.5147072823,
		"y": 49.715150911,
		"h": 3.1098901099
	},
	{
		"stop_id": 8503361,
		"ID": 1037,
		"x": 39.3847735453,
		"y": 50.222190991,
		"h": 3.1098901099
	},
	{
		"stop_id": 8503665,
		"ID": 1037,
		"x": 37.1587068833,
		"y": 50.19624687,
		"h": 3.1098901099
	},
	{
		"stop_id": 8503666,
		"ID": 1037,
		"x": 40.1787704783,
		"y": 49.66518267,
		"h": 3.1098901099
	},
	{
		"stop_id": 8503669,
		"ID": 1037,
		"x": 36.3677057413,
		"y": 46.891226554,
		"h": 3.1098901099
	},
	{
		"stop_id": 8575974,
		"ID": 1037,
		"x": 37.8297284183,
		"y": 51.100221028,
		"h": 3.1098901099
	},
	{
		"stop_id": 8575975,
		"ID": 1037,
		"x": 40.0967106153,
		"y": 49.834151263,
		"h": 3.1098901099
	},
	{
		"stop_id": 8576056,
		"ID": 1037,
		"x": 40.2107324683,
		"y": 50.376246654,
		"h": 3.1098901099
	},
	{
		"stop_id": 8576057,
		"ID": 1037,
		"x": 39.7567478833,
		"y": 49.933191591,
		"h": 3.1098901099
	},
	{
		"stop_id": 8576058,
		"ID": 1037,
		"x": 39.9377552093,
		"y": 50.244231833,
		"h": 3.1098901099
	},
	{
		"stop_id": 8576059,
		"ID": 1037,
		"x": 39.6337709483,
		"y": 50.240250506,
		"h": 3.1098901099
	},
	{
		"stop_id": 8576060,
		"ID": 1037,
		"x": 39.0737014083,
		"y": 50.289172532,
		"h": 3.1098901099
	},
	{
		"stop_id": 8576061,
		"ID": 1037,
		"x": 38.7347150563,
		"y": 50.277205102,
		"h": 3.1098901099
	},
	{
		"stop_id": 8576062,
		"ID": 1037,
		"x": 38.4077620003,
		"y": 50.293142914,
		"h": 3.1098901099
	},
	{
		"stop_id": 8576063,
		"ID": 1037,
		"x": 38.2197295363,
		"y": 50.440149515,
		"h": 3.1098901099
	},
	{
		"stop_id": 8576064,
		"ID": 1037,
		"x": 38.0567579743,
		"y": 50.482163622,
		"h": 3.1098901099
	},
	{
		"stop_id": 8576065,
		"ID": 1037,
		"x": 37.7997080513,
		"y": 50.595245489,
		"h": 3.1098901099
	},
	{
		"stop_id": 8576066,
		"ID": 1037,
		"x": 37.7127676513,
		"y": 50.448155818,
		"h": 3.1098901099
	},
	{
		"stop_id": 8576067,
		"ID": 1037,
		"x": 37.4947073953,
		"y": 50.511186709,
		"h": 3.1098901099
	},
	{
		"stop_id": 8576101,
		"ID": 1037,
		"x": 37.4187661603,
		"y": 50.390189477,
		"h": 3.1098901099
	},
	{
		"stop_id": 8576106,
		"ID": 1037,
		"x": 36.3737648573,
		"y": 46.774239927,
		"h": 3.1098901099
	},
	{
		"stop_id": 8576107,
		"ID": 1037,
		"x": 36.6467011313,
		"y": 46.325220984,
		"h": 3.1098901099
	},
	{
		"stop_id": 8577513,
		"ID": 1037,
		"x": 36.8237525213,
		"y": 45.763242337,
		"h": 3.1098901099
	},
	{
		"stop_id": 8577514,
		"ID": 1037,
		"x": 36.9397528103,
		"y": 45.527178321,
		"h": 3.1098901099
	},
	{
		"stop_id": 8577521,
		"ID": 1037,
		"x": 36.7117099123,
		"y": 46.078207483,
		"h": 3.1098901099
	},
	{
		"stop_id": 8577522,
		"ID": 1037,
		"x": 37.3107050343,
		"y": 45.798191762,
		"h": 3.1098901099
	},
	{
		"stop_id": 8577523,
		"ID": 1037,
		"x": 37.6197743883,
		"y": 45.644241701,
		"h": 3.1098901099
	},
	{
		"stop_id": 8581264,
		"ID": 1037,
		"x": 37.4827358893,
		"y": 45.506234164,
		"h": 3.1098901099
	},
	{
		"stop_id": 8581267,
		"ID": 1037,
		"x": 40.6777631183,
		"y": 46.390175657,
		"h": 3.1098901099
	},
	{
		"stop_id": 8581268,
		"ID": 1037,
		"x": 40.3457627103,
		"y": 46.553143981,
		"h": 3.1098901099
	},
	{
		"stop_id": 8581269,
		"ID": 1037,
		"x": 40.0947123223,
		"y": 46.684243208,
		"h": 3.1098901099
	},
	{
		"stop_id": 8581270,
		"ID": 1037,
		"x": 39.9007339033,
		"y": 46.598149728,
		"h": 3.1098901099
	},
	{
		"stop_id": 8581271,
		"ID": 1037,
		"x": 39.8627176903,
		"y": 46.384245456,
		"h": 3.1098901099
	},
	{
		"stop_id": 8581272,
		"ID": 1037,
		"x": 39.8057658063,
		"y": 46.097193464,
		"h": 3.1098901099
	},
	{
		"stop_id": 8581273,
		"ID": 1037,
		"x": 40.2977011583,
		"y": 46.410230774,
		"h": 3.1098901099
	},
	{
		"stop_id": 8581274,
		"ID": 1037,
		"x": 40.1577213843,
		"y": 46.330152962,
		"h": 3.1098901099
	},
	{
		"stop_id": 8581275,
		"ID": 1037,
		"x": 39.0187428513,
		"y": 45.76616761,
		"h": 3.1098901099
	},
	{
		"stop_id": 8581276,
		"ID": 1037,
		"x": 38.7367742113,
		"y": 45.6271701,
		"h": 3.1098901099
	},
	{
		"stop_id": 8581277,
		"ID": 1037,
		"x": 38.4357599943,
		"y": 45.640204379,
		"h": 3.1098901099
	},
	{
		"stop_id": 8581278,
		"ID": 1037,
		"x": 38.1187569613,
		"y": 45.607179694,
		"h": 3.1098901099
	},
	{
		"stop_id": 8587686,
		"ID": 1037,
		"x": 37.2397483963,
		"y": 51.095228326,
		"h": 3.1098901099
	},
	{
		"stop_id": 8587687,
		"ID": 1037,
		"x": 37.2377519183,
		"y": 50.902164979,
		"h": 3.1098901099
	},
	{
		"stop_id": 8587688,
		"ID": 1037,
		"x": 37.4577650303,
		"y": 50.899200968,
		"h": 3.1098901099
	},
	{
		"stop_id": 8587948,
		"ID": 1037,
		"x": 37.7447639073,
		"y": 50.93014609,
		"h": 3.1098901099
	},
	{
		"stop_id": 8587949,
		"ID": 1037,
		"x": 37.8557039903,
		"y": 50.708247751,
		"h": 3.1098901099
	},
	{
		"stop_id": 8588139,
		"ID": 1037,
		"x": 36.8137759773,
		"y": 50.447151391,
		"h": 3.1098901099
	},
	{
		"stop_id": 8588308,
		"ID": 1037,
		"x": 36.5207605523,
		"y": 46.236228488,
		"h": 3.1098901099
	},
	{
		"stop_id": 8588338,
		"ID": 1037,
		"x": 36.8567583363,
		"y": 45.616227701,
		"h": 3.1098901099
	},
	{
		"stop_id": 8588339,
		"ID": 1037,
		"x": 36.8906996493,
		"y": 45.9572472,
		"h": 3.1098901099
	},
	{
		"stop_id": 8588533,
		"ID": 1037,
		"x": 39.2577207093,
		"y": 49.78019197,
		"h": 3.1098901099
	},
	{
		"stop_id": 8592286,
		"ID": 1037,
		"x": 38.2577604213,
		"y": 46.250156619,
		"h": 3.1098901099
	},
	{
		"stop_id": 8592287,
		"ID": 1037,
		"x": 37.8977605313,
		"y": 46.050202808,
		"h": 3.1098901099
	},
	{
		"stop_id": 8592289,
		"ID": 1037,
		"x": 38.3577016573,
		"y": 46.370224539,
		"h": 3.1098901099
	},
	{
		"stop_id": 8592290,
		"ID": 1037,
		"x": 39.9377072183,
		"y": 46.300217947,
		"h": 3.1098901099
	},
	{
		"stop_id": 8592291,
		"ID": 1037,
		"x": 39.2177382203,
		"y": 46.550156977,
		"h": 3.1098901099
	},
	{
		"stop_id": 8592292,
		"ID": 1037,
		"x": 39.6677642243,
		"y": 46.650178563,
		"h": 3.1098901099
	},
	{
		"stop_id": 8592293,
		"ID": 1037,
		"x": 39.8677280253,
		"y": 46.700227164,
		"h": 3.1098901099
	},
	{
		"stop_id": 8594068,
		"ID": 1037,
		"x": 38.6977023593,
		"y": 46.380182014,
		"h": 3.1098901099
	},
	{
		"stop_id": 8503109,
		"ID": 1071,
		"x": 42.0817160003,
		"y": 50.333190933,
		"h": 2.9120879121
	},
	{
		"stop_id": 8503110,
		"ID": 1071,
		"x": 44.6267340953,
		"y": 48.786166361,
		"h": 2.9120879121
	},
	{
		"stop_id": 8503112,
		"ID": 1071,
		"x": 44.4157141053,
		"y": 50.284147506,
		"h": 2.9120879121
	},
	{
		"stop_id": 8503122,
		"ID": 1071,
		"x": 44.9887759233,
		"y": 53.902186501,
		"h": 2.9120879121
	},
	{
		"stop_id": 8503159,
		"ID": 1071,
		"x": 45.2617717153,
		"y": 53.444210936,
		"h": 2.9120879121
	},
	{
		"stop_id": 8503161,
		"ID": 1071,
		"x": 45.5627328323,
		"y": 52.803159098,
		"h": 2.9120879121
	},
	{
		"stop_id": 8503164,
		"ID": 1071,
		"x": 40.5767390573,
		"y": 50.810179068,
		"h": 2.9120879121
	},
	{
		"stop_id": 8503175,
		"ID": 1071,
		"x": 41.4617217203,
		"y": 51.893212908,
		"h": 2.9120879121
	},
	{
		"stop_id": 8503176,
		"ID": 1071,
		"x": 42.9547030763,
		"y": 52.081188818,
		"h": 2.9120879121
	},
	{
		"stop_id": 8503177,
		"ID": 1071,
		"x": 41.8157057673,
		"y": 51.939174923,
		"h": 2.9120879121
	},
	{
		"stop_id": 8503195,
		"ID": 1071,
		"x": 44.7107063773,
		"y": 53.627192268,
		"h": 2.9120879121
	},
	{
		"stop_id": 8503196,
		"ID": 1071,
		"x": 43.3967545623,
		"y": 52.360166231,
		"h": 2.9120879121
	},
	{
		"stop_id": 8503197,
		"ID": 1071,
		"x": 41.0267190913,
		"y": 51.776177993,
		"h": 2.9120879121
	},
	{
		"stop_id": 8503353,
		"ID": 1071,
		"x": 45.6627002373,
		"y": 50.514190965,
		"h": 2.9120879121
	},
	{
		"stop_id": 8503354,
		"ID": 1071,
		"x": 45.0687730473,
		"y": 50.415169625,
		"h": 2.9120879121
	},
	{
		"stop_id": 8503356,
		"ID": 1071,
		"x": 40.7637519293,
		"y": 51.630171576,
		"h": 2.9120879121
	},
	{
		"stop_id": 8503358,
		"ID": 1071,
		"x": 46.4647596283,
		"y": 51.639212976,
		"h": 2.9120879121
	},
	{
		"stop_id": 8503667,
		"ID": 1071,
		"x": 44.3847042693,
		"y": 48.873210431,
		"h": 2.9120879121
	},
	{
		"stop_id": 8575967,
		"ID": 1071,
		"x": 41.2567368583,
		"y": 51.437162479,
		"h": 2.9120879121
	},
	{
		"stop_id": 8575968,
		"ID": 1071,
		"x": 41.6397761993,
		"y": 51.468151653,
		"h": 2.9120879121
	},
	{
		"stop_id": 8575969,
		"ID": 1071,
		"x": 41.9067701773,
		"y": 51.055180709,
		"h": 2.9120879121
	},
	{
		"stop_id": 8575970,
		"ID": 1071,
		"x": 42.3047637193,
		"y": 50.424194897,
		"h": 2.9120879121
	},
	{
		"stop_id": 8575971,
		"ID": 1071,
		"x": 42.0477172073,
		"y": 50.324157468,
		"h": 2.9120879121
	},
	{
		"stop_id": 8576052,
		"ID": 1071,
		"x": 44.4047552373,
		"y": 53.132222227,
		"h": 2.9120879121
	},
	{
		"stop_id": 8576053,
		"ID": 1071,
		"x": 43.8817019853,
		"y": 52.508159461,
		"h": 2.9120879121
	},
	{
		"stop_id": 8576055,
		"ID": 1071,
		"x": 40.9167059713,
		"y": 51.428164945,
		"h": 2.9120879121
	},
	{
		"stop_id": 8576077,
		"ID": 1071,
		"x": 44.6487034833,
		"y": 50.303248885,
		"h": 2.9120879121
	},
	{
		"stop_id": 8576078,
		"ID": 1071,
		"x": 44.8017027063,
		"y": 50.06520258,
		"h": 2.9120879121
	},
	{
		"stop_id": 8576079,
		"ID": 1071,
		"x": 44.9507555873,
		"y": 49.235200364,
		"h": 2.9120879121
	},
	{
		"stop_id": 8576090,
		"ID": 1071,
		"x": 44.6617049623,
		"y": 48.796232306,
		"h": 2.9120879121
	},
	{
		"stop_id": 8576102,
		"ID": 1071,
		"x": 44.9807285883,
		"y": 53.882140437,
		"h": 2.9120879121
	},
	{
		"stop_id": 8578524,
		"ID": 1071,
		"x": 44.8277179873,
		"y": 49.000191747,
		"h": 2.9120879121
	},
	{
		"stop_id": 8578525,
		"ID": 1071,
		"x": 45.3077756233,
		"y": 49.130196458,
		"h": 2.9120879121
	},
	{
		"stop_id": 8578526,
		"ID": 1071,
		"x": 45.6827581513,
		"y": 49.230242506,
		"h": 2.9120879121
	},
	{
		"stop_id": 8587941,
		"ID": 1071,
		"x": 41.7787074703,
		"y": 51.539243079,
		"h": 2.9120879121
	},
	{
		"stop_id": 8587943,
		"ID": 1071,
		"x": 45.2177648633,
		"y": 49.230237673,
		"h": 2.9120879121
	},
	{
		"stop_id": 8588012,
		"ID": 1071,
		"x": 44.8957715143,
		"y": 49.884165566,
		"h": 2.9120879121
	},
	{
		"stop_id": 8589104,
		"ID": 1071,
		"x": 44.9637042643,
		"y": 49.695219241,
		"h": 2.9120879121
	},
	{
		"stop_id": 8589512,
		"ID": 1071,
		"x": 45.1187149503,
		"y": 49.469225462,
		"h": 2.9120879121
	},
	{
		"stop_id": 8590444,
		"ID": 1071,
		"x": 40.5797230963,
		"y": 51.62416893,
		"h": 2.9120879121
	},
	{
		"stop_id": 8590448,
		"ID": 1071,
		"x": 43.0267480093,
		"y": 52.415241773,
		"h": 2.9120879121
	},
	{
		"stop_id": 8590449,
		"ID": 1071,
		"x": 43.3987391073,
		"y": 52.420246073,
		"h": 2.9120879121
	},
	{
		"stop_id": 8591723,
		"ID": 1071,
		"x": 45.4097573213,
		"y": 49.843203758,
		"h": 2.9120879121
	},
	{
		"stop_id": 8591732,
		"ID": 1071,
		"x": 45.3327258763,
		"y": 50.430174223,
		"h": 2.9120879121
	},
	{
		"stop_id": 8591734,
		"ID": 1071,
		"x": 45.1077607243,
		"y": 50.480239705,
		"h": 2.9120879121
	},
	{
		"stop_id": 8591735,
		"ID": 1071,
		"x": 44.8267735073,
		"y": 50.538222721,
		"h": 2.9120879121
	},
	{
		"stop_id": 8591739,
		"ID": 1071,
		"x": 44.8677566983,
		"y": 50.692171254,
		"h": 2.9120879121
	},
	{
		"stop_id": 8591740,
		"ID": 1071,
		"x": 44.6687100353,
		"y": 51.013247457,
		"h": 2.9120879121
	},
	{
		"stop_id": 8591741,
		"ID": 1071,
		"x": 46.1227076403,
		"y": 50.342235316,
		"h": 2.9120879121
	},
	{
		"stop_id": 8591745,
		"ID": 1071,
		"x": 44.0527092413,
		"y": 51.109197405,
		"h": 2.9120879121
	},
	{
		"stop_id": 8591746,
		"ID": 1071,
		"x": 44.6977068073,
		"y": 48.700236965,
		"h": 2.9120879121
	},
	{
		"stop_id": 8591747,
		"ID": 1071,
		"x": 45.5577585333,
		"y": 49.650233196,
		"h": 2.9120879121
	},
	{
		"stop_id": 8591748,
		"ID": 1071,
		"x": 45.8577377053,
		"y": 49.630205571,
		"h": 2.9120879121
	},
	{
		"stop_id": 8591749,
		"ID": 1071,
		"x": 45.4247607223,
		"y": 49.004169617,
		"h": 2.9120879121
	},
	{
		"stop_id": 8591750,
		"ID": 1071,
		"x": 45.3377620393,
		"y": 49.670244643,
		"h": 2.9120879121
	},
	{
		"stop_id": 8591751,
		"ID": 1071,
		"x": 45.0377143223,
		"y": 48.715230077,
		"h": 2.9120879121
	},
	{
		"stop_id": 8591753,
		"ID": 1071,
		"x": 45.4017068713,
		"y": 49.335233601,
		"h": 2.9120879121
	},
	{
		"stop_id": 8591754,
		"ID": 1071,
		"x": 45.2877050363,
		"y": 48.680169834,
		"h": 2.9120879121
	},
	{
		"stop_id": 8595329,
		"ID": 1071,
		"x": 41.4507715233,
		"y": 51.096208199,
		"h": 2.9120879121
	},
	{
		"stop_id": 8503113,
		"ID": 1105,
		"x": 46.5717522513,
		"y": 48.685215799,
		"h": 2.2857142857
	},
	{
		"stop_id": 8503120,
		"ID": 1105,
		"x": 45.9677748283,
		"y": 49.486163316,
		"h": 2.2857142857
	},
	{
		"stop_id": 8503717,
		"ID": 1105,
		"x": 50.1457111793,
		"y": 46.487179284,
		"h": 2.2857142857
	},
	{
		"stop_id": 8578527,
		"ID": 1105,
		"x": 46.0977682093,
		"y": 49.370166157,
		"h": 2.2857142857
	},
	{
		"stop_id": 8578529,
		"ID": 1105,
		"x": 46.5577179873,
		"y": 49.355249658,
		"h": 2.2857142857
	},
	{
		"stop_id": 8578530,
		"ID": 1105,
		"x": 46.8277685343,
		"y": 49.400229391,
		"h": 2.2857142857
	},
	{
		"stop_id": 8578531,
		"ID": 1105,
		"x": 46.9777405583,
		"y": 49.400141702,
		"h": 2.2857142857
	},
	{
		"stop_id": 8578532,
		"ID": 1105,
		"x": 47.2877158493,
		"y": 49.440188818,
		"h": 2.2857142857
	},
	{
		"stop_id": 8578533,
		"ID": 1105,
		"x": 47.7177001343,
		"y": 49.390240526,
		"h": 2.2857142857
	},
	{
		"stop_id": 8578534,
		"ID": 1105,
		"x": 48.3427556703,
		"y": 49.010170241,
		"h": 2.2857142857
	},
	{
		"stop_id": 8578535,
		"ID": 1105,
		"x": 49.0877068463,
		"y": 49.690168397,
		"h": 2.2857142857
	},
	{
		"stop_id": 8578536,
		"ID": 1105,
		"x": 49.8277038573,
		"y": 49.570224435,
		"h": 2.2857142857
	},
	{
		"stop_id": 8578537,
		"ID": 1105,
		"x": 50.1327172423,
		"y": 49.570187066,
		"h": 2.2857142857
	},
	{
		"stop_id": 8578560,
		"ID": 1105,
		"x": 50.1077473163,
		"y": 50.830140599,
		"h": 2.2857142857
	},
	{
		"stop_id": 8578561,
		"ID": 1105,
		"x": 49.7577181233,
		"y": 51.090215768,
		"h": 2.2857142857
	},
	{
		"stop_id": 8578562,
		"ID": 1105,
		"x": 49.5777661203,
		"y": 51.240241089,
		"h": 2.2857142857
	},
	{
		"stop_id": 8583793,
		"ID": 1105,
		"x": 49.9377241623,
		"y": 46.284186089,
		"h": 2.2857142857
	},
	{
		"stop_id": 8588035,
		"ID": 1105,
		"x": 45.9027490233,
		"y": 48.517165073,
		"h": 2.2857142857
	},
	{
		"stop_id": 8591722,
		"ID": 1105,
		"x": 46.1447491493,
		"y": 49.543244751,
		"h": 2.2857142857
	},
	{
		"stop_id": 8591724,
		"ID": 1105,
		"x": 46.2677151973,
		"y": 49.804189314,
		"h": 2.2857142857
	},
	{
		"stop_id": 8591725,
		"ID": 1105,
		"x": 45.9917419613,
		"y": 49.382177571,
		"h": 2.2857142857
	},
	{
		"stop_id": 8591726,
		"ID": 1105,
		"x": 46.8577192563,
		"y": 49.280230892,
		"h": 2.2857142857
	},
	{
		"stop_id": 8591727,
		"ID": 1105,
		"x": 46.6407150063,
		"y": 48.823220282,
		"h": 2.2857142857
	},
	{
		"stop_id": 8591728,
		"ID": 1105,
		"x": 46.5617109383,
		"y": 48.535145083,
		"h": 2.2857142857
	},
	{
		"stop_id": 8591729,
		"ID": 1105,
		"x": 46.2257160643,
		"y": 49.870157178,
		"h": 2.2857142857
	},
	{
		"stop_id": 8591730,
		"ID": 1105,
		"x": 47.2917635733,
		"y": 49.518209872,
		"h": 2.2857142857
	},
	{
		"stop_id": 8591731,
		"ID": 1105,
		"x": 47.4677717273,
		"y": 49.565194761,
		"h": 2.2857142857
	},
	{
		"stop_id": 8591733,
		"ID": 1105,
		"x": 46.7677406173,
		"y": 49.060229368,
		"h": 2.2857142857
	},
	{
		"stop_id": 8591736,
		"ID": 1105,
		"x": 46.1577203083,
		"y": 49.440175583,
		"h": 2.2857142857
	},
	{
		"stop_id": 8591737,
		"ID": 1105,
		"x": 46.2177577633,
		"y": 49.590247774,
		"h": 2.2857142857
	},
	{
		"stop_id": 8591738,
		"ID": 1105,
		"x": 46.6077086773,
		"y": 49.905227388,
		"h": 2.2857142857
	},
	{
		"stop_id": 8591742,
		"ID": 1105,
		"x": 46.0327355133,
		"y": 49.615194091,
		"h": 2.2857142857
	},
	{
		"stop_id": 8591743,
		"ID": 1105,
		"x": 46.2887571703,
		"y": 48.489236903,
		"h": 2.2857142857
	},
	{
		"stop_id": 8591744,
		"ID": 1105,
		"x": 46.7197741993,
		"y": 49.974174496,
		"h": 2.2857142857
	},
	{
		"stop_id": 8591752,
		"ID": 1105,
		"x": 45.5567688183,
		"y": 48.599201012,
		"h": 2.2857142857
	},
	{
		"stop_id": 8591858,
		"ID": 1105,
		"x": 47.6777071553,
		"y": 49.654163147,
		"h": 2.2857142857
	},
	{
		"stop_id": 8591869,
		"ID": 1105,
		"x": 46.4197713703,
		"y": 49.852161331,
		"h": 2.2857142857
	},
	{
		"stop_id": 8594202,
		"ID": 1105,
		"x": 46.2587480673,
		"y": 49.135189743,
		"h": 2.2857142857
	},
	{
		"stop_id": 8595486,
		"ID": 1105,
		"x": 48.4877474283,
		"y": 49.130232679,
		"h": 2.2857142857
	},
	{
		"stop_id": 8595487,
		"ID": 1105,
		"x": 48.2477360603,
		"y": 48.820187876,
		"h": 2.2857142857
	},
	{
		"stop_id": 8503115,
		"ID": 1142,
		"x": 54.2157465503,
		"y": 48.992154742,
		"h": 2.4505494505
	},
	{
		"stop_id": 8503367,
		"ID": 1142,
		"x": 53.2467374513,
		"y": 53.553231113,
		"h": 2.4505494505
	},
	{
		"stop_id": 8503369,
		"ID": 1142,
		"x": 54.1577723173,
		"y": 50.830148354,
		"h": 2.4505494505
	},
	{
		"stop_id": 8503383,
		"ID": 1142,
		"x": 53.8177718393,
		"y": 50.7302311,
		"h": 2.4505494505
	},
	{
		"stop_id": 8503386,
		"ID": 1142,
		"x": 54.6077351193,
		"y": 53.280165473,
		"h": 2.4505494505
	},
	{
		"stop_id": 8503647,
		"ID": 1142,
		"x": 53.9857232943,
		"y": 48.92314105,
		"h": 2.4505494505
	},
	{
		"stop_id": 8503686,
		"ID": 1142,
		"x": 55.2777535363,
		"y": 52.036223815,
		"h": 2.4505494505
	},
	{
		"stop_id": 8503991,
		"ID": 1142,
		"x": 54.2797488233,
		"y": 51.608209596,
		"h": 2.4505494505
	},
	{
		"stop_id": 8503995,
		"ID": 1142,
		"x": 55.7177335173,
		"y": 53.254167557,
		"h": 2.4505494505
	},
	{
		"stop_id": 8503999,
		"ID": 1142,
		"x": 55.3697534043,
		"y": 53.332144004,
		"h": 2.4505494505
	},
	{
		"stop_id": 8506487,
		"ID": 1142,
		"x": 56.3327064213,
		"y": 51.360199747,
		"h": 2.4505494505
	},
	{
		"stop_id": 8506498,
		"ID": 1142,
		"x": 52.8787175993,
		"y": 50.052169212,
		"h": 2.4505494505
	},
	{
		"stop_id": 8506862,
		"ID": 1142,
		"x": 53.0677705923,
		"y": 53.455197406,
		"h": 2.4505494505
	},
	{
		"stop_id": 8506968,
		"ID": 1142,
		"x": 52.5077030523,
		"y": 50.680196121,
		"h": 2.4505494505
	},
	{
		"stop_id": 8573587,
		"ID": 1142,
		"x": 52.7867004873,
		"y": 53.456201291,
		"h": 2.4505494505
	},
	{
		"stop_id": 8573588,
		"ID": 1142,
		"x": 54.2577301493,
		"y": 53.555212633,
		"h": 2.4505494505
	},
	{
		"stop_id": 8573592,
		"ID": 1142,
		"x": 56.0077282703,
		"y": 52.33018638,
		"h": 2.4505494505
	},
	{
		"stop_id": 8573593,
		"ID": 1142,
		"x": 54.7267741703,
		"y": 51.762146576,
		"h": 2.4505494505
	},
	{
		"stop_id": 8573594,
		"ID": 1142,
		"x": 53.1377083413,
		"y": 51.002156319,
		"h": 2.4505494505
	},
	{
		"stop_id": 8573595,
		"ID": 1142,
		"x": 52.5747413233,
		"y": 50.68324265,
		"h": 2.4505494505
	},
	{
		"stop_id": 8573596,
		"ID": 1142,
		"x": 52.8847188953,
		"y": 50.74615716,
		"h": 2.4505494505
	},
	{
		"stop_id": 8573597,
		"ID": 1142,
		"x": 53.4077400053,
		"y": 50.720181374,
		"h": 2.4505494505
	},
	{
		"stop_id": 8573598,
		"ID": 1142,
		"x": 54.4047191113,
		"y": 50.964213219,
		"h": 2.4505494505
	},
	{
		"stop_id": 8573855,
		"ID": 1142,
		"x": 55.6117684503,
		"y": 49.554183936,
		"h": 2.4505494505
	},
	{
		"stop_id": 8573856,
		"ID": 1142,
		"x": 55.0487046193,
		"y": 49.200230033,
		"h": 2.4505494505
	},
	{
		"stop_id": 8573857,
		"ID": 1142,
		"x": 54.6547401893,
		"y": 49.121241503,
		"h": 2.4505494505
	},
	{
		"stop_id": 8573858,
		"ID": 1142,
		"x": 54.2177734503,
		"y": 49.060246725,
		"h": 2.4505494505
	},
	{
		"stop_id": 8573859,
		"ID": 1142,
		"x": 52.7167529353,
		"y": 50.350223871,
		"h": 2.4505494505
	},
	{
		"stop_id": 8573860,
		"ID": 1142,
		"x": 52.3757458643,
		"y": 50.365238312,
		"h": 2.4505494505
	},
	{
		"stop_id": 8578538,
		"ID": 1142,
		"x": 52.1877380263,
		"y": 50.130179228,
		"h": 2.4505494505
	},
	{
		"stop_id": 8578546,
		"ID": 1142,
		"x": 55.5577710873,
		"y": 51.040195909,
		"h": 2.4505494505
	},
	{
		"stop_id": 8578547,
		"ID": 1142,
		"x": 56.0277436053,
		"y": 51.210243875,
		"h": 2.4505494505
	},
	{
		"stop_id": 8578557,
		"ID": 1142,
		"x": 52.1377384323,
		"y": 50.770179843,
		"h": 2.4505494505
	},
	{
		"stop_id": 8578558,
		"ID": 1142,
		"x": 51.4077342643,
		"y": 50.810181693,
		"h": 2.4505494505
	},
	{
		"stop_id": 8578559,
		"ID": 1142,
		"x": 50.8577296143,
		"y": 50.680154741,
		"h": 2.4505494505
	},
	{
		"stop_id": 8579933,
		"ID": 1142,
		"x": 55.6727400143,
		"y": 49.636209585,
		"h": 2.4505494505
	},
	{
		"stop_id": 8580885,
		"ID": 1142,
		"x": 52.2827235573,
		"y": 53.625143136,
		"h": 2.4505494505
	},
	{
		"stop_id": 8581903,
		"ID": 1142,
		"x": 52.7217695743,
		"y": 50.885180199,
		"h": 2.4505494505
	},
	{
		"stop_id": 8583055,
		"ID": 1142,
		"x": 53.3897461863,
		"y": 49.076223555,
		"h": 2.4505494505
	},
	{
		"stop_id": 8588335,
		"ID": 1142,
		"x": 54.8777689383,
		"y": 50.380190921,
		"h": 2.4505494505
	},
	{
		"stop_id": 8589221,
		"ID": 1142,
		"x": 56.4927492953,
		"y": 51.590176818,
		"h": 2.4505494505
	},
	{
		"stop_id": 8589513,
		"ID": 1142,
		"x": 53.1187018963,
		"y": 53.360200985,
		"h": 2.4505494505
	},
	{
		"stop_id": 8594374,
		"ID": 1142,
		"x": 56.3217114573,
		"y": 51.384226291,
		"h": 2.4505494505
	},
	{
		"stop_id": 8594375,
		"ID": 1142,
		"x": 56.5407298513,
		"y": 51.715214738,
		"h": 2.4505494505
	},
	{
		"stop_id": 8594491,
		"ID": 1142,
		"x": 51.9957186173,
		"y": 53.801209791,
		"h": 2.4505494505
	},
	{
		"stop_id": 8503116,
		"ID": 1177,
		"x": 57.0427473553,
		"y": 48.949199631,
		"h": 2.2197802198
	},
	{
		"stop_id": 8503117,
		"ID": 1177,
		"x": 60.2177343723,
		"y": 48.312235373,
		"h": 2.2197802198
	},
	{
		"stop_id": 8503118,
		"ID": 1177,
		"x": 59.2037714573,
		"y": 46.788212974,
		"h": 2.2197802198
	},
	{
		"stop_id": 8503577,
		"ID": 1177,
		"x": 58.7037378873,
		"y": 49.370169646,
		"h": 2.2197802198
	},
	{
		"stop_id": 8503769,
		"ID": 1177,
		"x": 60.2577045643,
		"y": 49.780216532,
		"h": 2.2197802198
	},
	{
		"stop_id": 8503770,
		"ID": 1177,
		"x": 60.5107641083,
		"y": 50.749220303,
		"h": 2.2197802198
	},
	{
		"stop_id": 8503790,
		"ID": 1177,
		"x": 58.1207121643,
		"y": 48.789232996,
		"h": 2.2197802198
	},
	{
		"stop_id": 8503996,
		"ID": 1177,
		"x": 60.3517528063,
		"y": 47.840230506,
		"h": 2.2197802198
	},
	{
		"stop_id": 8503998,
		"ID": 1177,
		"x": 59.0277180913,
		"y": 48.305230323,
		"h": 2.2197802198
	},
	{
		"stop_id": 8506494,
		"ID": 1177,
		"x": 59.4057336683,
		"y": 49.478172015,
		"h": 2.2197802198
	},
	{
		"stop_id": 8506738,
		"ID": 1177,
		"x": 56.2577473773,
		"y": 48.05524115,
		"h": 2.2197802198
	},
	{
		"stop_id": 8573842,
		"ID": 1177,
		"x": 57.5687240203,
		"y": 49.416146053,
		"h": 2.2197802198
	},
	{
		"stop_id": 8573843,
		"ID": 1177,
		"x": 57.6357535073,
		"y": 49.746175145,
		"h": 2.2197802198
	},
	{
		"stop_id": 8573844,
		"ID": 1177,
		"x": 58.5817298663,
		"y": 50.422244945,
		"h": 2.2197802198
	},
	{
		"stop_id": 8573845,
		"ID": 1177,
		"x": 58.9387573793,
		"y": 50.46717631,
		"h": 2.2197802198
	},
	{
		"stop_id": 8573846,
		"ID": 1177,
		"x": 59.6827364123,
		"y": 50.40524983,
		"h": 2.2197802198
	},
	{
		"stop_id": 8573847,
		"ID": 1177,
		"x": 60.6727367293,
		"y": 49.674190248,
		"h": 2.2197802198
	},
	{
		"stop_id": 8573848,
		"ID": 1177,
		"x": 58.2207293233,
		"y": 50.943151893,
		"h": 2.2197802198
	},
	{
		"stop_id": 8573851,
		"ID": 1177,
		"x": 57.1977167913,
		"y": 49.054217427,
		"h": 2.2197802198
	},
	{
		"stop_id": 8573852,
		"ID": 1177,
		"x": 56.7627339903,
		"y": 49.302206835,
		"h": 2.2197802198
	},
	{
		"stop_id": 8573853,
		"ID": 1177,
		"x": 56.3477051753,
		"y": 49.337227041,
		"h": 2.2197802198
	},
	{
		"stop_id": 8573854,
		"ID": 1177,
		"x": 55.9987426323,
		"y": 49.496215061,
		"h": 2.2197802198
	},
	{
		"stop_id": 8573861,
		"ID": 1177,
		"x": 58.4437486233,
		"y": 48.537223187,
		"h": 2.2197802198
	},
	{
		"stop_id": 8573862,
		"ID": 1177,
		"x": 59.8457368573,
		"y": 48.139159953,
		"h": 2.2197802198
	},
	{
		"stop_id": 8573863,
		"ID": 1177,
		"x": 60.8827686483,
		"y": 47.305217409,
		"h": 2.2197802198
	},
	{
		"stop_id": 8573877,
		"ID": 1177,
		"x": 60.2397486133,
		"y": 47.308212498,
		"h": 2.2197802198
	},
	{
		"stop_id": 8573878,
		"ID": 1177,
		"x": 59.1827584343,
		"y": 46.630223368,
		"h": 2.2197802198
	},
	{
		"stop_id": 8573879,
		"ID": 1177,
		"x": 58.8327082453,
		"y": 46.068235668,
		"h": 2.2197802198
	},
	{
		"stop_id": 8574440,
		"ID": 1177,
		"x": 57.5577076683,
		"y": 49.08021829,
		"h": 2.2197802198
	},
	{
		"stop_id": 8574441,
		"ID": 1177,
		"x": 58.0647063033,
		"y": 49.134174263,
		"h": 2.2197802198
	},
	{
		"stop_id": 8574442,
		"ID": 1177,
		"x": 60.0607241893,
		"y": 50.109173999,
		"h": 2.2197802198
	},
	{
		"stop_id": 8574443,
		"ID": 1177,
		"x": 60.3367381653,
		"y": 50.50917563,
		"h": 2.2197802198
	},
	{
		"stop_id": 8574444,
		"ID": 1177,
		"x": 60.4087386573,
		"y": 50.993242407,
		"h": 2.2197802198
	},
	{
		"stop_id": 8574473,
		"ID": 1177,
		"x": 57.0117084833,
		"y": 48.97516609,
		"h": 2.2197802198
	},
	{
		"stop_id": 8580537,
		"ID": 1177,
		"x": 60.5757406943,
		"y": 47.65616681,
		"h": 2.2197802198
	},
	{
		"stop_id": 8581016,
		"ID": 1177,
		"x": 58.7577624243,
		"y": 45.980228403,
		"h": 2.2197802198
	},
	{
		"stop_id": 8583215,
		"ID": 1177,
		"x": 57.9657513843,
		"y": 48.902141557,
		"h": 2.2197802198
	},
	{
		"stop_id": 8583511,
		"ID": 1177,
		"x": 59.1037451423,
		"y": 46.674234422,
		"h": 2.2197802198
	},
	{
		"stop_id": 8503119,
		"ID": 1212,
		"x": 61.9867523413,
		"y": 41.640206226,
		"h": 1.7912087912
	},
	{
		"stop_id": 8503225,
		"ID": 1212,
		"x": 63.2547633053,
		"y": 39.275178837,
		"h": 1.7912087912
	},
	{
		"stop_id": 8503226,
		"ID": 1212,
		"x": 63.4637444203,
		"y": 37.746184355,
		"h": 1.7912087912
	},
	{
		"stop_id": 8530515,
		"ID": 1212,
		"x": 62.2687117513,
		"y": 38.020245319,
		"h": 1.7912087912
	},
	{
		"stop_id": 8530658,
		"ID": 1212,
		"x": 66.2347381583,
		"y": 39.17517003,
		"h": 1.7912087912
	},
	{
		"stop_id": 8573868,
		"ID": 1212,
		"x": 62.3557596573,
		"y": 42.124146043,
		"h": 1.7912087912
	},
	{
		"stop_id": 8573869,
		"ID": 1212,
		"x": 62.0177003883,
		"y": 41.714230896,
		"h": 1.7912087912
	},
	{
		"stop_id": 8573870,
		"ID": 1212,
		"x": 62.1327568623,
		"y": 41.855141118,
		"h": 1.7912087912
	},
	{
		"stop_id": 8573871,
		"ID": 1212,
		"x": 62.3077349123,
		"y": 41.330200507,
		"h": 1.7912087912
	},
	{
		"stop_id": 8573872,
		"ID": 1212,
		"x": 62.4567525003,
		"y": 40.449229304,
		"h": 1.7912087912
	},
	{
		"stop_id": 8573873,
		"ID": 1212,
		"x": 62.5077320363,
		"y": 40.630196217,
		"h": 1.7912087912
	},
	{
		"stop_id": 8573874,
		"ID": 1212,
		"x": 63.2417071993,
		"y": 39.38922128,
		"h": 1.7912087912
	},
	{
		"stop_id": 8573884,
		"ID": 1212,
		"x": 63.2977319593,
		"y": 36.840153913,
		"h": 1.7912087912
	},
	{
		"stop_id": 8577666,
		"ID": 1212,
		"x": 60.5777585293,
		"y": 40.22022739,
		"h": 1.7912087912
	},
	{
		"stop_id": 8577809,
		"ID": 1212,
		"x": 62.7977433163,
		"y": 37.690180233,
		"h": 1.7912087912
	},
	{
		"stop_id": 8577863,
		"ID": 1212,
		"x": 63.2577690123,
		"y": 37.22018186,
		"h": 1.7912087912
	},
	{
		"stop_id": 8578489,
		"ID": 1212,
		"x": 65.4827251343,
		"y": 38.945237854,
		"h": 1.7912087912
	},
	{
		"stop_id": 8578490,
		"ID": 1212,
		"x": 65.8977194733,
		"y": 38.637177498,
		"h": 1.7912087912
	},
	{
		"stop_id": 8578491,
		"ID": 1212,
		"x": 66.0077503243,
		"y": 39.115213792,
		"h": 1.7912087912
	},
	{
		"stop_id": 8578492,
		"ID": 1212,
		"x": 66.1527417473,
		"y": 39.220249802,
		"h": 1.7912087912
	},
	{
		"stop_id": 8578493,
		"ID": 1212,
		"x": 66.4427703093,
		"y": 39.345154592,
		"h": 1.7912087912
	},
	{
		"stop_id": 8579550,
		"ID": 1212,
		"x": 63.3827306763,
		"y": 38.980146277,
		"h": 1.7912087912
	},
	{
		"stop_id": 8587509,
		"ID": 1212,
		"x": 62.9637082673,
		"y": 38.376245847,
		"h": 1.7912087912
	},
	{
		"stop_id": 8587510,
		"ID": 1212,
		"x": 62.7647434023,
		"y": 38.128177872,
		"h": 1.7912087912
	},
	{
		"stop_id": 8595640,
		"ID": 1212,
		"x": 63.1857477033,
		"y": 39.32123453,
		"h": 1.7912087912
	},
	{
		"stop_id": 8503121,
		"ID": 1106,
		"x": 47.3827174503,
		"y": 52.793240176,
		"h": 2.4175824176
	},
	{
		"stop_id": 8503139,
		"ID": 1106,
		"x": 47.2637673733,
		"y": 53.668214258,
		"h": 2.4175824176
	},
	{
		"stop_id": 8503158,
		"ID": 1106,
		"x": 47.1977414053,
		"y": 56.395245827,
		"h": 2.4175824176
	},
	{
		"stop_id": 8503171,
		"ID": 1106,
		"x": 47.2597496063,
		"y": 53.450196258,
		"h": 2.4175824176
	},
	{
		"stop_id": 8503173,
		"ID": 1106,
		"x": 47.2487437783,
		"y": 53.922250527,
		"h": 2.4175824176
	},
	{
		"stop_id": 8503190,
		"ID": 1106,
		"x": 47.5247403053,
		"y": 55.74519393,
		"h": 2.4175824176
	},
	{
		"stop_id": 8503191,
		"ID": 1106,
		"x": 47.8227018113,
		"y": 54.868235791,
		"h": 2.4175824176
	},
	{
		"stop_id": 8503192,
		"ID": 1106,
		"x": 46.5587182573,
		"y": 54.738158327,
		"h": 2.4175824176
	},
	{
		"stop_id": 8503355,
		"ID": 1106,
		"x": 46.7647187453,
		"y": 52.248157625,
		"h": 2.4175824176
	},
	{
		"stop_id": 8503396,
		"ID": 1106,
		"x": 46.5487672733,
		"y": 52.711200882,
		"h": 2.4175824176
	},
	{
		"stop_id": 8503398,
		"ID": 1106,
		"x": 47.8647696833,
		"y": 56.867218876,
		"h": 2.4175824176
	},
	{
		"stop_id": 8576041,
		"ID": 1106,
		"x": 47.1887436003,
		"y": 52.820211407,
		"h": 2.4175824176
	},
	{
		"stop_id": 8576044,
		"ID": 1106,
		"x": 46.9467165453,
		"y": 56.854198223,
		"h": 2.4175824176
	},
	{
		"stop_id": 8576045,
		"ID": 1106,
		"x": 47.3957167973,
		"y": 55.985162353,
		"h": 2.4175824176
	},
	{
		"stop_id": 8576050,
		"ID": 1106,
		"x": 47.0437248583,
		"y": 52.621228529,
		"h": 2.4175824176
	},
	{
		"stop_id": 8576069,
		"ID": 1106,
		"x": 45.8417645143,
		"y": 54.607159392,
		"h": 2.4175824176
	},
	{
		"stop_id": 8576070,
		"ID": 1106,
		"x": 46.3677249143,
		"y": 54.657236663,
		"h": 2.4175824176
	},
	{
		"stop_id": 8576071,
		"ID": 1106,
		"x": 48.1727215033,
		"y": 54.779182183,
		"h": 2.4175824176
	},
	{
		"stop_id": 8576072,
		"ID": 1106,
		"x": 47.4697255623,
		"y": 54.250154182,
		"h": 2.4175824176
	},
	{
		"stop_id": 8576073,
		"ID": 1106,
		"x": 48.6167040883,
		"y": 54.72121987,
		"h": 2.4175824176
	},
	{
		"stop_id": 8576074,
		"ID": 1106,
		"x": 48.9147701703,
		"y": 54.441224824,
		"h": 2.4175824176
	},
	{
		"stop_id": 8576076,
		"ID": 1106,
		"x": 46.5987312983,
		"y": 51.912150376,
		"h": 2.4175824176
	},
	{
		"stop_id": 8576103,
		"ID": 1106,
		"x": 47.4377564093,
		"y": 52.755203479,
		"h": 2.4175824176
	},
	{
		"stop_id": 8577340,
		"ID": 1106,
		"x": 50.9577358523,
		"y": 54.470190228,
		"h": 2.4175824176
	},
	{
		"stop_id": 8577341,
		"ID": 1106,
		"x": 50.7077761753,
		"y": 54.685150084,
		"h": 2.4175824176
	},
	{
		"stop_id": 8577343,
		"ID": 1106,
		"x": 51.0577489443,
		"y": 54.9301935,
		"h": 2.4175824176
	},
	{
		"stop_id": 8577344,
		"ID": 1106,
		"x": 51.1277123453,
		"y": 54.705211296,
		"h": 2.4175824176
	},
	{
		"stop_id": 8578563,
		"ID": 1106,
		"x": 48.3777586973,
		"y": 52.034233563,
		"h": 2.4175824176
	},
	{
		"stop_id": 8578564,
		"ID": 1106,
		"x": 47.7327269853,
		"y": 52.255147025,
		"h": 2.4175824176
	},
	{
		"stop_id": 8578565,
		"ID": 1106,
		"x": 47.1827609843,
		"y": 52.61016474,
		"h": 2.4175824176
	},
	{
		"stop_id": 8581103,
		"ID": 1106,
		"x": 51.4377096923,
		"y": 54.530201378,
		"h": 2.4175824176
	},
	{
		"stop_id": 8587945,
		"ID": 1106,
		"x": 47.9437060503,
		"y": 52.765247874,
		"h": 2.4175824176
	},
	{
		"stop_id": 8587946,
		"ID": 1106,
		"x": 48.1737277303,
		"y": 52.950230289,
		"h": 2.4175824176
	},
	{
		"stop_id": 8587947,
		"ID": 1106,
		"x": 48.3407160263,
		"y": 53.316214779,
		"h": 2.4175824176
	},
	{
		"stop_id": 8588036,
		"ID": 1106,
		"x": 47.0427574733,
		"y": 52.498227941,
		"h": 2.4175824176
	},
	{
		"stop_id": 8588037,
		"ID": 1106,
		"x": 47.5197134103,
		"y": 51.738235247,
		"h": 2.4175824176
	},
	{
		"stop_id": 8588038,
		"ID": 1106,
		"x": 47.5827332283,
		"y": 52.01325052,
		"h": 2.4175824176
	},
	{
		"stop_id": 8588039,
		"ID": 1106,
		"x": 47.3997115193,
		"y": 51.847154025,
		"h": 2.4175824176
	},
	{
		"stop_id": 8588040,
		"ID": 1106,
		"x": 47.5487619693,
		"y": 52.280175233,
		"h": 2.4175824176
	},
	{
		"stop_id": 8588041,
		"ID": 1106,
		"x": 48.4847276683,
		"y": 53.567141477,
		"h": 2.4175824176
	},
	{
		"stop_id": 8588042,
		"ID": 1106,
		"x": 47.6907188863,
		"y": 51.928247612,
		"h": 2.4175824176
	},
	{
		"stop_id": 8588043,
		"ID": 1106,
		"x": 47.7537493863,
		"y": 51.767152711,
		"h": 2.4175824176
	},
	{
		"stop_id": 8588883,
		"ID": 1106,
		"x": 51.6517017553,
		"y": 54.334167562,
		"h": 2.4175824176
	},
	{
		"stop_id": 8594538,
		"ID": 1106,
		"x": 46.2617349223,
		"y": 52.786241884,
		"h": 2.4175824176
	},
	{
		"stop_id": 8503123,
		"ID": 1072,
		"x": 42.5957381103,
		"y": 59.108235838,
		"h": 2.4175824176
	},
	{
		"stop_id": 8503130,
		"ID": 1072,
		"x": 46.2167135663,
		"y": 57.172151219,
		"h": 2.4175824176
	},
	{
		"stop_id": 8503179,
		"ID": 1072,
		"x": 42.9757523633,
		"y": 59.573158849,
		"h": 2.4175824176
	},
	{
		"stop_id": 8503180,
		"ID": 1072,
		"x": 41.8427311503,
		"y": 58.323143071,
		"h": 2.4175824176
	},
	{
		"stop_id": 8503181,
		"ID": 1072,
		"x": 40.4167094873,
		"y": 57.24420279,
		"h": 2.4175824176
	},
	{
		"stop_id": 8503182,
		"ID": 1072,
		"x": 41.6287336373,
		"y": 56.626189467,
		"h": 2.4175824176
	},
	{
		"stop_id": 8575995,
		"ID": 1072,
		"x": 42.9467683923,
		"y": 59.391183398,
		"h": 2.4175824176
	},
	{
		"stop_id": 8575996,
		"ID": 1072,
		"x": 43.3087512633,
		"y": 59.590166571,
		"h": 2.4175824176
	},
	{
		"stop_id": 8575997,
		"ID": 1072,
		"x": 43.7247467493,
		"y": 59.890192101,
		"h": 2.4175824176
	},
	{
		"stop_id": 8576008,
		"ID": 1072,
		"x": 44.2127643633,
		"y": 58.127242707,
		"h": 2.4175824176
	},
	{
		"stop_id": 8576009,
		"ID": 1072,
		"x": 44.7247734303,
		"y": 57.741153914,
		"h": 2.4175824176
	},
	{
		"stop_id": 8576010,
		"ID": 1072,
		"x": 45.0337522303,
		"y": 57.642188744,
		"h": 2.4175824176
	},
	{
		"stop_id": 8576011,
		"ID": 1072,
		"x": 45.3657025403,
		"y": 57.609141631,
		"h": 2.4175824176
	},
	{
		"stop_id": 8576012,
		"ID": 1072,
		"x": 45.7237674073,
		"y": 57.575242857,
		"h": 2.4175824176
	},
	{
		"stop_id": 8576013,
		"ID": 1072,
		"x": 46.4587506083,
		"y": 57.452248634,
		"h": 2.4175824176
	},
	{
		"stop_id": 8576014,
		"ID": 1072,
		"x": 42.6767429463,
		"y": 58.634156777,
		"h": 2.4175824176
	},
	{
		"stop_id": 8576015,
		"ID": 1072,
		"x": 42.1207352573,
		"y": 58.389179622,
		"h": 2.4175824176
	},
	{
		"stop_id": 8576018,
		"ID": 1072,
		"x": 40.7857062863,
		"y": 57.055183867,
		"h": 2.4175824176
	},
	{
		"stop_id": 8576020,
		"ID": 1072,
		"x": 41.4047665073,
		"y": 56.225176663,
		"h": 2.4175824176
	},
	{
		"stop_id": 8576033,
		"ID": 1072,
		"x": 41.7147535183,
		"y": 57.97924683,
		"h": 2.4175824176
	},
	{
		"stop_id": 8576034,
		"ID": 1072,
		"x": 41.8777327863,
		"y": 56.787234748,
		"h": 2.4175824176
	},
	{
		"stop_id": 8576046,
		"ID": 1072,
		"x": 46.5227573963,
		"y": 57.240229042,
		"h": 2.4175824176
	},
	{
		"stop_id": 8576068,
		"ID": 1072,
		"x": 44.9517127153,
		"y": 54.347206782,
		"h": 2.4175824176
	},
	{
		"stop_id": 8576091,
		"ID": 1072,
		"x": 42.7567618103,
		"y": 59.386228658,
		"h": 2.4175824176
	},
	{
		"stop_id": 8576092,
		"ID": 1072,
		"x": 43.0507641993,
		"y": 59.830211868,
		"h": 2.4175824176
	},
	{
		"stop_id": 8576104,
		"ID": 1072,
		"x": 46.2767430313,
		"y": 57.106171564,
		"h": 2.4175824176
	},
	{
		"stop_id": 8576105,
		"ID": 1072,
		"x": 42.5457560033,
		"y": 59.165195972,
		"h": 2.4175824176
	},
	{
		"stop_id": 8587937,
		"ID": 1072,
		"x": 40.8807161313,
		"y": 57.42518574,
		"h": 2.4175824176
	},
	{
		"stop_id": 8587939,
		"ID": 1072,
		"x": 44.5037745513,
		"y": 57.861251069,
		"h": 2.4175824176
	},
	{
		"stop_id": 8587956,
		"ID": 1072,
		"x": 42.1067269783,
		"y": 59.830158681,
		"h": 2.4175824176
	},
	{
		"stop_id": 8587957,
		"ID": 1072,
		"x": 43.1387420563,
		"y": 58.694192028,
		"h": 2.4175824176
	},
	{
		"stop_id": 8587963,
		"ID": 1072,
		"x": 44.3767126493,
		"y": 54.584170674,
		"h": 2.4175824176
	},
	{
		"stop_id": 8587985,
		"ID": 1072,
		"x": 42.4857538703,
		"y": 57.706152202,
		"h": 2.4175824176
	},
	{
		"stop_id": 8587986,
		"ID": 1072,
		"x": 42.9527743743,
		"y": 56.89914865,
		"h": 2.4175824176
	},
	{
		"stop_id": 8587987,
		"ID": 1072,
		"x": 42.5787268823,
		"y": 57.1261984,
		"h": 2.4175824176
	},
	{
		"stop_id": 8587988,
		"ID": 1072,
		"x": 43.5797537563,
		"y": 56.42821958,
		"h": 2.4175824176
	},
	{
		"stop_id": 8587989,
		"ID": 1072,
		"x": 43.3387084613,
		"y": 55.36221578,
		"h": 2.4175824176
	},
	{
		"stop_id": 8587990,
		"ID": 1072,
		"x": 42.3827489443,
		"y": 57.433170447,
		"h": 2.4175824176
	},
	{
		"stop_id": 8587991,
		"ID": 1072,
		"x": 43.2387134743,
		"y": 55.565191583,
		"h": 2.4175824176
	},
	{
		"stop_id": 8590443,
		"ID": 1072,
		"x": 44.6987086113,
		"y": 57.894146976,
		"h": 2.4175824176
	},
	{
		"stop_id": 8590915,
		"ID": 1072,
		"x": 45.0157494953,
		"y": 59.646204669,
		"h": 2.4175824176
	},
	{
		"stop_id": 8594257,
		"ID": 1072,
		"x": 45.2067331593,
		"y": 54.425210924,
		"h": 2.4175824176
	},
	{
		"stop_id": 8594541,
		"ID": 1072,
		"x": 42.3407627053,
		"y": 59.916245939,
		"h": 2.4175824176
	},
	{
		"stop_id": 8594731,
		"ID": 1072,
		"x": 42.5617396093,
		"y": 59.02325097,
		"h": 2.4175824176
	},
	{
		"stop_id": 8503124,
		"ID": 1039,
		"x": 40.5467602553,
		"y": 61.066210035,
		"h": 2.2527472527
	},
	{
		"stop_id": 8503125,
		"ID": 1039,
		"x": 36.9747360653,
		"y": 62.609201169,
		"h": 2.2527472527
	},
	{
		"stop_id": 8503168,
		"ID": 1039,
		"x": 36.3687215163,
		"y": 59.929207172,
		"h": 2.2527472527
	},
	{
		"stop_id": 8503188,
		"ID": 1039,
		"x": 37.2547709833,
		"y": 58.29416418,
		"h": 2.2527472527
	},
	{
		"stop_id": 8503189,
		"ID": 1039,
		"x": 36.4517432893,
		"y": 60.581156441,
		"h": 2.2527472527
	},
	{
		"stop_id": 8503253,
		"ID": 1039,
		"x": 38.0747325513,
		"y": 62.51316296,
		"h": 2.2527472527
	},
	{
		"stop_id": 8503263,
		"ID": 1039,
		"x": 39.0117269443,
		"y": 60.17722968,
		"h": 2.2527472527
	},
	{
		"stop_id": 8503267,
		"ID": 1039,
		"x": 39.9677485833,
		"y": 59.316223045,
		"h": 2.2527472527
	},
	{
		"stop_id": 8503364,
		"ID": 1039,
		"x": 37.2047646373,
		"y": 58.73023164,
		"h": 2.2527472527
	},
	{
		"stop_id": 8503392,
		"ID": 1039,
		"x": 40.1217752573,
		"y": 57.88316472,
		"h": 2.2527472527
	},
	{
		"stop_id": 8530696,
		"ID": 1039,
		"x": 35.6007002173,
		"y": 59.875223542,
		"h": 2.2527472527
	},
	{
		"stop_id": 8575957,
		"ID": 1039,
		"x": 36.7907671003,
		"y": 61.822160092,
		"h": 2.2527472527
	},
	{
		"stop_id": 8575958,
		"ID": 1039,
		"x": 36.6677186723,
		"y": 61.390164114,
		"h": 2.2527472527
	},
	{
		"stop_id": 8575960,
		"ID": 1039,
		"x": 37.2637641123,
		"y": 57.966175255,
		"h": 2.2527472527
	},
	{
		"stop_id": 8575961,
		"ID": 1039,
		"x": 37.1687042383,
		"y": 57.146229047,
		"h": 2.2527472527
	},
	{
		"stop_id": 8575976,
		"ID": 1039,
		"x": 37.5637395553,
		"y": 62.19418213,
		"h": 2.2527472527
	},
	{
		"stop_id": 8575977,
		"ID": 1039,
		"x": 37.9127111953,
		"y": 62.054142151,
		"h": 2.2527472527
	},
	{
		"stop_id": 8575978,
		"ID": 1039,
		"x": 38.1007261203,
		"y": 61.982184729,
		"h": 2.2527472527
	},
	{
		"stop_id": 8575979,
		"ID": 1039,
		"x": 38.2257144473,
		"y": 61.727163146,
		"h": 2.2527472527
	},
	{
		"stop_id": 8575980,
		"ID": 1039,
		"x": 38.6657146443,
		"y": 60.832204217,
		"h": 2.2527472527
	},
	{
		"stop_id": 8575981,
		"ID": 1039,
		"x": 39.8437123683,
		"y": 59.588237305,
		"h": 2.2527472527
	},
	{
		"stop_id": 8575982,
		"ID": 1039,
		"x": 40.0867301163,
		"y": 58.325244991,
		"h": 2.2527472527
	},
	{
		"stop_id": 8576016,
		"ID": 1039,
		"x": 40.5977027923,
		"y": 57.853166338,
		"h": 2.2527472527
	},
	{
		"stop_id": 8576017,
		"ID": 1039,
		"x": 40.0507030513,
		"y": 57.549160392,
		"h": 2.2527472527
	},
	{
		"stop_id": 8576030,
		"ID": 1039,
		"x": 39.7357118753,
		"y": 57.732235577,
		"h": 2.2527472527
	},
	{
		"stop_id": 8576095,
		"ID": 1039,
		"x": 36.7527009203,
		"y": 62.359172394,
		"h": 2.2527472527
	},
	{
		"stop_id": 8576788,
		"ID": 1039,
		"x": 36.8657404803,
		"y": 61.887207717,
		"h": 2.2527472527
	},
	{
		"stop_id": 8580879,
		"ID": 1039,
		"x": 36.9747680293,
		"y": 62.343220751,
		"h": 2.2527472527
	},
	{
		"stop_id": 8581539,
		"ID": 1039,
		"x": 36.7087446903,
		"y": 62.139178754,
		"h": 2.2527472527
	},
	{
		"stop_id": 8581542,
		"ID": 1039,
		"x": 37.0907581793,
		"y": 61.798141338,
		"h": 2.2527472527
	},
	{
		"stop_id": 8581543,
		"ID": 1039,
		"x": 37.5187042563,
		"y": 61.590204612,
		"h": 2.2527472527
	},
	{
		"stop_id": 8581546,
		"ID": 1039,
		"x": 37.8137113713,
		"y": 61.484189012,
		"h": 2.2527472527
	},
	{
		"stop_id": 8581547,
		"ID": 1039,
		"x": 38.2427566673,
		"y": 61.487149859,
		"h": 2.2527472527
	},
	{
		"stop_id": 8581548,
		"ID": 1039,
		"x": 36.8497744153,
		"y": 62.468168625,
		"h": 2.2527472527
	},
	{
		"stop_id": 8587952,
		"ID": 1039,
		"x": 36.9227464503,
		"y": 62.252192316,
		"h": 2.2527472527
	},
	{
		"stop_id": 8588050,
		"ID": 1039,
		"x": 37.7757604393,
		"y": 62.803241048,
		"h": 2.2527472527
	},
	{
		"stop_id": 8588056,
		"ID": 1039,
		"x": 37.8917510923,
		"y": 62.418187041,
		"h": 2.2527472527
	},
	{
		"stop_id": 8588058,
		"ID": 1039,
		"x": 37.6077600543,
		"y": 62.790249525,
		"h": 2.2527472527
	},
	{
		"stop_id": 8588532,
		"ID": 1039,
		"x": 37.2077223553,
		"y": 57.605210633,
		"h": 2.2527472527
	},
	{
		"stop_id": 8503126,
		"ID": 1006,
		"x": 34.5017235533,
		"y": 64.681196601,
		"h": 2.5164835165
	},
	{
		"stop_id": 8503254,
		"ID": 1006,
		"x": 35.7377638063,
		"y": 61.94121154,
		"h": 2.5164835165
	},
	{
		"stop_id": 8503633,
		"ID": 1006,
		"x": 34.8767059263,
		"y": 61.799198685,
		"h": 2.5164835165
	},
	{
		"stop_id": 8503785,
		"ID": 1006,
		"x": 35.3727418443,
		"y": 62.067221875,
		"h": 2.5164835165
	},
	{
		"stop_id": 8530645,
		"ID": 1006,
		"x": 33.9957627773,
		"y": 61.440167214,
		"h": 2.5164835165
	},
	{
		"stop_id": 8530646,
		"ID": 1006,
		"x": 34.8287138233,
		"y": 61.780196948,
		"h": 2.5164835165
	},
	{
		"stop_id": 8530647,
		"ID": 1006,
		"x": 31.9637508463,
		"y": 64.241185866,
		"h": 2.5164835165
	},
	{
		"stop_id": 8530648,
		"ID": 1006,
		"x": 33.6437689383,
		"y": 64.131206285,
		"h": 2.5164835165
	},
	{
		"stop_id": 8573504,
		"ID": 1006,
		"x": 36.8337086483,
		"y": 62.698193857,
		"h": 2.5164835165
	},
	{
		"stop_id": 8576097,
		"ID": 1006,
		"x": 36.1617737433,
		"y": 62.010213767,
		"h": 2.5164835165
	},
	{
		"stop_id": 8576099,
		"ID": 1006,
		"x": 35.1927564173,
		"y": 62.329204475,
		"h": 2.5164835165
	},
	{
		"stop_id": 8580872,
		"ID": 1006,
		"x": 36.5177306873,
		"y": 62.895208682,
		"h": 2.5164835165
	},
	{
		"stop_id": 8580874,
		"ID": 1006,
		"x": 36.0077252903,
		"y": 62.746174565,
		"h": 2.5164835165
	},
	{
		"stop_id": 8580877,
		"ID": 1006,
		"x": 35.7607501453,
		"y": 62.569169818,
		"h": 2.5164835165
	},
	{
		"stop_id": 8581538,
		"ID": 1006,
		"x": 35.3077052113,
		"y": 62.112213709,
		"h": 2.5164835165
	},
	{
		"stop_id": 8581540,
		"ID": 1006,
		"x": 35.5347341333,
		"y": 62.681176359,
		"h": 2.5164835165
	},
	{
		"stop_id": 8581541,
		"ID": 1006,
		"x": 35.2587619943,
		"y": 62.577227117,
		"h": 2.5164835165
	},
	{
		"stop_id": 8581544,
		"ID": 1006,
		"x": 36.2937247923,
		"y": 62.281221076,
		"h": 2.5164835165
	},
	{
		"stop_id": 8581545,
		"ID": 1006,
		"x": 36.5027458233,
		"y": 62.566158846,
		"h": 2.5164835165
	},
	{
		"stop_id": 8587010,
		"ID": 1006,
		"x": 35.6837172523,
		"y": 62.181190886,
		"h": 2.5164835165
	},
	{
		"stop_id": 8587680,
		"ID": 1006,
		"x": 36.2527201493,
		"y": 63.133207091,
		"h": 2.5164835165
	},
	{
		"stop_id": 8587859,
		"ID": 1006,
		"x": 36.4267047813,
		"y": 63.452157956,
		"h": 2.5164835165
	},
	{
		"stop_id": 8587860,
		"ID": 1006,
		"x": 36.5157418443,
		"y": 63.278246921,
		"h": 2.5164835165
	},
	{
		"stop_id": 8588051,
		"ID": 1006,
		"x": 36.7417525023,
		"y": 62.948221946,
		"h": 2.5164835165
	},
	{
		"stop_id": 8588052,
		"ID": 1006,
		"x": 36.5137474843,
		"y": 63.480146796,
		"h": 2.5164835165
	},
	{
		"stop_id": 8588055,
		"ID": 1006,
		"x": 36.7457015653,
		"y": 63.049141121,
		"h": 2.5164835165
	},
	{
		"stop_id": 8590487,
		"ID": 1006,
		"x": 32.1767327963,
		"y": 60.331214818,
		"h": 2.5164835165
	},
	{
		"stop_id": 8590596,
		"ID": 1006,
		"x": 30.5987530813,
		"y": 62.998193413,
		"h": 2.5164835165
	},
	{
		"stop_id": 8590597,
		"ID": 1006,
		"x": 31.9767040543,
		"y": 61.455181143,
		"h": 2.5164835165
	},
	{
		"stop_id": 8590608,
		"ID": 1006,
		"x": 32.0407736883,
		"y": 63.570204305,
		"h": 2.5164835165
	},
	{
		"stop_id": 8590609,
		"ID": 1006,
		"x": 31.3867646823,
		"y": 64.538183078,
		"h": 2.5164835165
	},
	{
		"stop_id": 8590636,
		"ID": 1006,
		"x": 34.4147260413,
		"y": 64.142181618,
		"h": 2.5164835165
	},
	{
		"stop_id": 8590637,
		"ID": 1006,
		"x": 34.8287287593,
		"y": 64.133206185,
		"h": 2.5164835165
	},
	{
		"stop_id": 8590638,
		"ID": 1006,
		"x": 33.8847688953,
		"y": 64.222186111,
		"h": 2.5164835165
	},
	{
		"stop_id": 8590639,
		"ID": 1006,
		"x": 34.0057664563,
		"y": 64.329178854,
		"h": 2.5164835165
	},
	{
		"stop_id": 8590640,
		"ID": 1006,
		"x": 34.1257088333,
		"y": 64.178183308,
		"h": 2.5164835165
	},
	{
		"stop_id": 8590712,
		"ID": 1006,
		"x": 32.5997578223,
		"y": 62.710231743,
		"h": 2.5164835165
	},
	{
		"stop_id": 8590713,
		"ID": 1006,
		"x": 33.3197509403,
		"y": 61.454203505,
		"h": 2.5164835165
	},
	{
		"stop_id": 8590714,
		"ID": 1006,
		"x": 33.6207708733,
		"y": 61.163157943,
		"h": 2.5164835165
	},
	{
		"stop_id": 8590715,
		"ID": 1006,
		"x": 32.6077547433,
		"y": 61.760197789,
		"h": 2.5164835165
	},
	{
		"stop_id": 8590716,
		"ID": 1006,
		"x": 33.9687052773,
		"y": 61.416166203,
		"h": 2.5164835165
	},
	{
		"stop_id": 8590720,
		"ID": 1006,
		"x": 34.0707750043,
		"y": 65.195200318,
		"h": 2.5164835165
	},
	{
		"stop_id": 8590721,
		"ID": 1006,
		"x": 34.2137320093,
		"y": 64.673176381,
		"h": 2.5164835165
	},
	{
		"stop_id": 8590852,
		"ID": 1006,
		"x": 33.5677592483,
		"y": 65.657171771,
		"h": 2.5164835165
	},
	{
		"stop_id": 8591825,
		"ID": 1006,
		"x": 30.9067369083,
		"y": 63.710203606,
		"h": 2.5164835165
	},
	{
		"stop_id": 8591828,
		"ID": 1006,
		"x": 31.1037093963,
		"y": 62.630184681,
		"h": 2.5164835165
	},
	{
		"stop_id": 8591857,
		"ID": 1006,
		"x": 36.2747503433,
		"y": 63.47115523,
		"h": 2.5164835165
	},
	{
		"stop_id": 8503127,
		"ID": 1007,
		"x": 32.3807318973,
		"y": 66.318225193,
		"h": 2.4175824176
	},
	{
		"stop_id": 8503150,
		"ID": 1007,
		"x": 34.9807565903,
		"y": 66.938227873,
		"h": 2.4175824176
	},
	{
		"stop_id": 8503151,
		"ID": 1007,
		"x": 34.0977592853,
		"y": 66.87724897,
		"h": 2.4175824176
	},
	{
		"stop_id": 8503154,
		"ID": 1007,
		"x": 33.0567162083,
		"y": 66.053231553,
		"h": 2.4175824176
	},
	{
		"stop_id": 8503155,
		"ID": 1007,
		"x": 34.2617330473,
		"y": 65.828153001,
		"h": 2.4175824176
	},
	{
		"stop_id": 8503156,
		"ID": 1007,
		"x": 33.7007379353,
		"y": 66.784239685,
		"h": 2.4175824176
	},
	{
		"stop_id": 8503305,
		"ID": 1007,
		"x": 34.4217574573,
		"y": 70.95721517,
		"h": 2.4175824176
	},
	{
		"stop_id": 8503350,
		"ID": 1007,
		"x": 34.2247610113,
		"y": 69.00523613,
		"h": 2.4175824176
	},
	{
		"stop_id": 8503351,
		"ID": 1007,
		"x": 35.1057054633,
		"y": 69.490202966,
		"h": 2.4175824176
	},
	{
		"stop_id": 8503370,
		"ID": 1007,
		"x": 35.5117029013,
		"y": 70.753146734,
		"h": 2.4175824176
	},
	{
		"stop_id": 8503372,
		"ID": 1007,
		"x": 34.9817756903,
		"y": 71.112153187,
		"h": 2.4175824176
	},
	{
		"stop_id": 8503378,
		"ID": 1007,
		"x": 33.3017705243,
		"y": 71.45023634,
		"h": 2.4175824176
	},
	{
		"stop_id": 8575918,
		"ID": 1007,
		"x": 34.3847657213,
		"y": 70.882235439,
		"h": 2.4175824176
	},
	{
		"stop_id": 8575919,
		"ID": 1007,
		"x": 34.3967272133,
		"y": 71.207234914,
		"h": 2.4175824176
	},
	{
		"stop_id": 8575920,
		"ID": 1007,
		"x": 35.1657406183,
		"y": 71.329156556,
		"h": 2.4175824176
	},
	{
		"stop_id": 8575921,
		"ID": 1007,
		"x": 35.3887115963,
		"y": 70.996249818,
		"h": 2.4175824176
	},
	{
		"stop_id": 8575925,
		"ID": 1007,
		"x": 36.3507692313,
		"y": 69.295221525,
		"h": 2.4175824176
	},
	{
		"stop_id": 8576127,
		"ID": 1007,
		"x": 32.4487651513,
		"y": 66.275249927,
		"h": 2.4175824176
	},
	{
		"stop_id": 8576128,
		"ID": 1007,
		"x": 33.8667499163,
		"y": 65.898179809,
		"h": 2.4175824176
	},
	{
		"stop_id": 8576129,
		"ID": 1007,
		"x": 34.5167577733,
		"y": 66.917149159,
		"h": 2.4175824176
	},
	{
		"stop_id": 8576130,
		"ID": 1007,
		"x": 34.2547434253,
		"y": 67.325191739,
		"h": 2.4175824176
	},
	{
		"stop_id": 8576131,
		"ID": 1007,
		"x": 34.1437174053,
		"y": 67.503235996,
		"h": 2.4175824176
	},
	{
		"stop_id": 8576132,
		"ID": 1007,
		"x": 33.9287736663,
		"y": 67.325142885,
		"h": 2.4175824176
	},
	{
		"stop_id": 8576133,
		"ID": 1007,
		"x": 33.9607736043,
		"y": 68.643220555,
		"h": 2.4175824176
	},
	{
		"stop_id": 8576135,
		"ID": 1007,
		"x": 34.8187196173,
		"y": 70.426234426,
		"h": 2.4175824176
	},
	{
		"stop_id": 8576139,
		"ID": 1007,
		"x": 33.1137067973,
		"y": 66.4261865,
		"h": 2.4175824176
	},
	{
		"stop_id": 8576140,
		"ID": 1007,
		"x": 34.6437156963,
		"y": 66.930179196,
		"h": 2.4175824176
	},
	{
		"stop_id": 8587858,
		"ID": 1007,
		"x": 35.2147679613,
		"y": 66.863247134,
		"h": 2.4175824176
	},
	{
		"stop_id": 8588096,
		"ID": 1007,
		"x": 33.4677431683,
		"y": 65.970171055,
		"h": 2.4175824176
	},
	{
		"stop_id": 8588097,
		"ID": 1007,
		"x": 33.9377268443,
		"y": 66.520221731,
		"h": 2.4175824176
	},
	{
		"stop_id": 8589106,
		"ID": 1007,
		"x": 33.4107731133,
		"y": 66.423177643,
		"h": 2.4175824176
	},
	{
		"stop_id": 8589128,
		"ID": 1007,
		"x": 33.7877643413,
		"y": 66.782166003,
		"h": 2.4175824176
	},
	{
		"stop_id": 8590559,
		"ID": 1007,
		"x": 31.5207475213,
		"y": 67.271206206,
		"h": 2.4175824176
	},
	{
		"stop_id": 8590565,
		"ID": 1007,
		"x": 31.8617516613,
		"y": 67.412240301,
		"h": 2.4175824176
	},
	{
		"stop_id": 8590574,
		"ID": 1007,
		"x": 31.3877656253,
		"y": 67.473203329,
		"h": 2.4175824176
	},
	{
		"stop_id": 8590584,
		"ID": 1007,
		"x": 30.9717025053,
		"y": 67.465148797,
		"h": 2.4175824176
	},
	{
		"stop_id": 8590806,
		"ID": 1007,
		"x": 31.8847049853,
		"y": 65.879204849,
		"h": 2.4175824176
	},
	{
		"stop_id": 8590851,
		"ID": 1007,
		"x": 33.5977649943,
		"y": 66.902152387,
		"h": 2.4175824176
	},
	{
		"stop_id": 8590901,
		"ID": 1007,
		"x": 31.3717035033,
		"y": 69.199166283,
		"h": 2.4175824176
	},
	{
		"stop_id": 8590902,
		"ID": 1007,
		"x": 31.1337229643,
		"y": 69.183166456,
		"h": 2.4175824176
	},
	{
		"stop_id": 8590903,
		"ID": 1007,
		"x": 31.3847670813,
		"y": 68.924156092,
		"h": 2.4175824176
	},
	{
		"stop_id": 8590904,
		"ID": 1007,
		"x": 31.0577509943,
		"y": 69.072250195,
		"h": 2.4175824176
	},
	{
		"stop_id": 8590905,
		"ID": 1007,
		"x": 30.9137282203,
		"y": 69.417198638,
		"h": 2.4175824176
	},
	{
		"stop_id": 8590906,
		"ID": 1007,
		"x": 30.7497392653,
		"y": 68.926204842,
		"h": 2.4175824176
	},
	{
		"stop_id": 8503129,
		"ID": 974,
		"x": 27.2947580253,
		"y": 69.392142896,
		"h": 4.5274725275
	},
	{
		"stop_id": 8503306,
		"ID": 974,
		"x": 29.3457108163,
		"y": 70.254168963,
		"h": 4.5274725275
	},
	{
		"stop_id": 8503307,
		"ID": 974,
		"x": 29.8387418873,
		"y": 72.304181059,
		"h": 4.5274725275
	},
	{
		"stop_id": 8503308,
		"ID": 974,
		"x": 26.6237608413,
		"y": 73.37324942,
		"h": 4.5274725275
	},
	{
		"stop_id": 8503700,
		"ID": 974,
		"x": 29.8337309213,
		"y": 72.321229563,
		"h": 4.5274725275
	},
	{
		"stop_id": 8576152,
		"ID": 974,
		"x": 26.6587048833,
		"y": 73.852238578,
		"h": 4.5274725275
	},
	{
		"stop_id": 8576153,
		"ID": 974,
		"x": 27.2427527103,
		"y": 73.669203611,
		"h": 4.5274725275
	},
	{
		"stop_id": 8576154,
		"ID": 974,
		"x": 27.6747474813,
		"y": 73.442167649,
		"h": 4.5274725275
	},
	{
		"stop_id": 8576155,
		"ID": 974,
		"x": 28.0927328813,
		"y": 73.292236792,
		"h": 4.5274725275
	},
	{
		"stop_id": 8576158,
		"ID": 974,
		"x": 29.3967379113,
		"y": 73.024180208,
		"h": 4.5274725275
	},
	{
		"stop_id": 8576159,
		"ID": 974,
		"x": 30.0247466413,
		"y": 72.79415427,
		"h": 4.5274725275
	},
	{
		"stop_id": 8576160,
		"ID": 974,
		"x": 29.9757059803,
		"y": 72.864243257,
		"h": 4.5274725275
	},
	{
		"stop_id": 8576161,
		"ID": 974,
		"x": 30.0467224673,
		"y": 72.862206808,
		"h": 4.5274725275
	},
	{
		"stop_id": 8576163,
		"ID": 974,
		"x": 30.5817091953,
		"y": 72.99622368,
		"h": 4.5274725275
	},
	{
		"stop_id": 8580432,
		"ID": 974,
		"x": 26.2267580973,
		"y": 72.845179328,
		"h": 4.5274725275
	},
	{
		"stop_id": 8580433,
		"ID": 974,
		"x": 27.5767725033,
		"y": 73.646212857,
		"h": 4.5274725275
	},
	{
		"stop_id": 8580434,
		"ID": 974,
		"x": 26.8707018943,
		"y": 73.781169749,
		"h": 4.5274725275
	},
	{
		"stop_id": 8580435,
		"ID": 974,
		"x": 27.2347111373,
		"y": 73.54921528,
		"h": 4.5274725275
	},
	{
		"stop_id": 8580437,
		"ID": 974,
		"x": 27.1647645193,
		"y": 73.710201248,
		"h": 4.5274725275
	},
	{
		"stop_id": 8580438,
		"ID": 974,
		"x": 27.3297119593,
		"y": 73.941246954,
		"h": 4.5274725275
	},
	{
		"stop_id": 8580536,
		"ID": 974,
		"x": 25.8927011803,
		"y": 71.387227849,
		"h": 4.5274725275
	},
	{
		"stop_id": 8587420,
		"ID": 974,
		"x": 26.6307211613,
		"y": 73.41315937,
		"h": 4.5274725275
	},
	{
		"stop_id": 8587651,
		"ID": 974,
		"x": 27.5747417573,
		"y": 69.0061913,
		"h": 4.5274725275
	},
	{
		"stop_id": 8587652,
		"ID": 974,
		"x": 27.2377349223,
		"y": 68.603152939,
		"h": 4.5274725275
	},
	{
		"stop_id": 8587655,
		"ID": 974,
		"x": 27.3417667313,
		"y": 69.393167626,
		"h": 4.5274725275
	},
	{
		"stop_id": 8588313,
		"ID": 974,
		"x": 30.9327756383,
		"y": 71.47018262,
		"h": 4.5274725275
	},
	{
		"stop_id": 8588314,
		"ID": 974,
		"x": 29.3327605293,
		"y": 70.272210296,
		"h": 4.5274725275
	},
	{
		"stop_id": 8588315,
		"ID": 974,
		"x": 28.3587553863,
		"y": 73.263165905,
		"h": 4.5274725275
	},
	{
		"stop_id": 8588316,
		"ID": 974,
		"x": 30.0727235403,
		"y": 72.630199059,
		"h": 4.5274725275
	},
	{
		"stop_id": 8588317,
		"ID": 974,
		"x": 30.5577695713,
		"y": 72.355250161,
		"h": 4.5274725275
	},
	{
		"stop_id": 8588318,
		"ID": 974,
		"x": 30.5127039993,
		"y": 70.897214422,
		"h": 4.5274725275
	},
	{
		"stop_id": 8588319,
		"ID": 974,
		"x": 30.2027154523,
		"y": 70.673216548,
		"h": 4.5274725275
	},
	{
		"stop_id": 8588736,
		"ID": 974,
		"x": 26.8677673613,
		"y": 74.069237649,
		"h": 4.5274725275
	},
	{
		"stop_id": 8588737,
		"ID": 974,
		"x": 27.1987286383,
		"y": 74.078205806,
		"h": 4.5274725275
	},
	{
		"stop_id": 8588738,
		"ID": 974,
		"x": 27.0747457423,
		"y": 74.170235488,
		"h": 4.5274725275
	},
	{
		"stop_id": 8588740,
		"ID": 974,
		"x": 26.2497056203,
		"y": 72.95315071,
		"h": 4.5274725275
	},
	{
		"stop_id": 8588742,
		"ID": 974,
		"x": 26.9587085313,
		"y": 69.893152091,
		"h": 4.5274725275
	},
	{
		"stop_id": 8588743,
		"ID": 974,
		"x": 27.0457015113,
		"y": 70.142170241,
		"h": 4.5274725275
	},
	{
		"stop_id": 8588744,
		"ID": 974,
		"x": 26.8067271283,
		"y": 69.845227265,
		"h": 4.5274725275
	},
	{
		"stop_id": 8588745,
		"ID": 974,
		"x": 26.5327496563,
		"y": 70.058171038,
		"h": 4.5274725275
	},
	{
		"stop_id": 8590503,
		"ID": 974,
		"x": 29.7097604723,
		"y": 72.97619607,
		"h": 4.5274725275
	},
	{
		"stop_id": 8590507,
		"ID": 974,
		"x": 30.1287657623,
		"y": 70.434244,
		"h": 4.5274725275
	},
	{
		"stop_id": 8590508,
		"ID": 974,
		"x": 30.2617740353,
		"y": 70.114239453,
		"h": 4.5274725275
	},
	{
		"stop_id": 8590538,
		"ID": 974,
		"x": 29.5237414373,
		"y": 69.353159314,
		"h": 4.5274725275
	},
	{
		"stop_id": 8590539,
		"ID": 974,
		"x": 29.4597053983,
		"y": 70.452146883,
		"h": 4.5274725275
	},
	{
		"stop_id": 8590540,
		"ID": 974,
		"x": 29.7587317473,
		"y": 69.901234139,
		"h": 4.5274725275
	},
	{
		"stop_id": 8590541,
		"ID": 974,
		"x": 29.1737456963,
		"y": 69.850165768,
		"h": 4.5274725275
	},
	{
		"stop_id": 8590542,
		"ID": 974,
		"x": 29.3797602363,
		"y": 69.511223972,
		"h": 4.5274725275
	},
	{
		"stop_id": 8590543,
		"ID": 974,
		"x": 29.2797441063,
		"y": 70.942149295,
		"h": 4.5274725275
	},
	{
		"stop_id": 8590544,
		"ID": 974,
		"x": 29.0037529343,
		"y": 69.353238191,
		"h": 4.5274725275
	},
	{
		"stop_id": 8590545,
		"ID": 974,
		"x": 29.5587221343,
		"y": 69.596205375,
		"h": 4.5274725275
	},
	{
		"stop_id": 8590553,
		"ID": 974,
		"x": 29.8187254893,
		"y": 68.624164875,
		"h": 4.5274725275
	},
	{
		"stop_id": 8590556,
		"ID": 974,
		"x": 30.2557194323,
		"y": 68.675156915,
		"h": 4.5274725275
	},
	{
		"stop_id": 8590623,
		"ID": 974,
		"x": 25.5897726543,
		"y": 71.077176754,
		"h": 4.5274725275
	},
	{
		"stop_id": 8590628,
		"ID": 974,
		"x": 25.5957281693,
		"y": 70.957171487,
		"h": 4.5274725275
	},
	{
		"stop_id": 8590632,
		"ID": 974,
		"x": 26.1427288453,
		"y": 70.48916503,
		"h": 4.5274725275
	},
	{
		"stop_id": 8590693,
		"ID": 974,
		"x": 26.6507609673,
		"y": 73.301143414,
		"h": 4.5274725275
	},
	{
		"stop_id": 8590694,
		"ID": 974,
		"x": 27.5097635883,
		"y": 72.937234731,
		"h": 4.5274725275
	},
	{
		"stop_id": 8590697,
		"ID": 974,
		"x": 26.4407139513,
		"y": 73.087140985,
		"h": 4.5274725275
	},
	{
		"stop_id": 8590698,
		"ID": 974,
		"x": 26.9207103303,
		"y": 73.070243558,
		"h": 4.5274725275
	},
	{
		"stop_id": 8590700,
		"ID": 974,
		"x": 27.0887584133,
		"y": 72.886230345,
		"h": 4.5274725275
	},
	{
		"stop_id": 8590740,
		"ID": 974,
		"x": 26.1897624223,
		"y": 70.706233955,
		"h": 4.5274725275
	},
	{
		"stop_id": 8590741,
		"ID": 974,
		"x": 26.0147583863,
		"y": 70.743170763,
		"h": 4.5274725275
	},
	{
		"stop_id": 8590743,
		"ID": 974,
		"x": 25.7337717113,
		"y": 71.79123993,
		"h": 4.5274725275
	},
	{
		"stop_id": 8590744,
		"ID": 974,
		"x": 26.2087471503,
		"y": 71.545147351,
		"h": 4.5274725275
	},
	{
		"stop_id": 8590745,
		"ID": 974,
		"x": 26.5267576713,
		"y": 70.578145091,
		"h": 4.5274725275
	},
	{
		"stop_id": 8590746,
		"ID": 974,
		"x": 26.4797656983,
		"y": 70.737248604,
		"h": 4.5274725275
	},
	{
		"stop_id": 8590747,
		"ID": 974,
		"x": 26.3047623783,
		"y": 70.940191916,
		"h": 4.5274725275
	},
	{
		"stop_id": 8590748,
		"ID": 974,
		"x": 25.9437583503,
		"y": 71.076174108,
		"h": 4.5274725275
	},
	{
		"stop_id": 8590750,
		"ID": 974,
		"x": 26.3397504683,
		"y": 71.113165073,
		"h": 4.5274725275
	},
	{
		"stop_id": 8590880,
		"ID": 974,
		"x": 27.5537297833,
		"y": 70.04222382,
		"h": 4.5274725275
	},
	{
		"stop_id": 8590881,
		"ID": 974,
		"x": 26.8327529993,
		"y": 69.562170705,
		"h": 4.5274725275
	},
	{
		"stop_id": 8590882,
		"ID": 974,
		"x": 28.2427514503,
		"y": 69.450186423,
		"h": 4.5274725275
	},
	{
		"stop_id": 8590883,
		"ID": 974,
		"x": 27.9197146023,
		"y": 70.38722331,
		"h": 4.5274725275
	},
	{
		"stop_id": 8590884,
		"ID": 974,
		"x": 27.7007579033,
		"y": 69.28514978,
		"h": 4.5274725275
	},
	{
		"stop_id": 8590885,
		"ID": 974,
		"x": 28.5187311523,
		"y": 69.276158028,
		"h": 4.5274725275
	},
	{
		"stop_id": 8590886,
		"ID": 974,
		"x": 27.2217082183,
		"y": 69.797155435,
		"h": 4.5274725275
	},
	{
		"stop_id": 8590887,
		"ID": 974,
		"x": 27.7987252263,
		"y": 69.94420817,
		"h": 4.5274725275
	},
	{
		"stop_id": 8590888,
		"ID": 974,
		"x": 27.4027284473,
		"y": 69.964163974,
		"h": 4.5274725275
	},
	{
		"stop_id": 8590889,
		"ID": 974,
		"x": 26.3197006653,
		"y": 69.798209273,
		"h": 4.5274725275
	},
	{
		"stop_id": 8590890,
		"ID": 974,
		"x": 28.2857274573,
		"y": 69.118238963,
		"h": 4.5274725275
	},
	{
		"stop_id": 8590892,
		"ID": 974,
		"x": 27.7797098443,
		"y": 70.199232532,
		"h": 4.5274725275
	},
	{
		"stop_id": 8590894,
		"ID": 974,
		"x": 28.0297147503,
		"y": 69.213180442,
		"h": 4.5274725275
	},
	{
		"stop_id": 8590895,
		"ID": 974,
		"x": 27.7437599913,
		"y": 69.35817322,
		"h": 4.5274725275
	},
	{
		"stop_id": 8590896,
		"ID": 974,
		"x": 27.8397737093,
		"y": 70.618217276,
		"h": 4.5274725275
	},
	{
		"stop_id": 8590897,
		"ID": 974,
		"x": 28.3297414433,
		"y": 69.214188058,
		"h": 4.5274725275
	},
	{
		"stop_id": 8590898,
		"ID": 974,
		"x": 28.4207397123,
		"y": 69.637196393,
		"h": 4.5274725275
	},
	{
		"stop_id": 8590899,
		"ID": 974,
		"x": 27.2427651873,
		"y": 69.535154587,
		"h": 4.5274725275
	},
	{
		"stop_id": 8590900,
		"ID": 974,
		"x": 28.2707469673,
		"y": 69.613170622,
		"h": 4.5274725275
	},
	{
		"stop_id": 8591263,
		"ID": 974,
		"x": 26.8487543863,
		"y": 68.736224247,
		"h": 4.5274725275
	},
	{
		"stop_id": 8594186,
		"ID": 974,
		"x": 27.6657680533,
		"y": 69.702172471,
		"h": 4.5274725275
	},
	{
		"stop_id": 8594187,
		"ID": 974,
		"x": 27.4217449463,
		"y": 69.677225697,
		"h": 4.5274725275
	},
	{
		"stop_id": 8594188,
		"ID": 974,
		"x": 27.8687105693,
		"y": 69.713177874,
		"h": 4.5274725275
	},
	{
		"stop_id": 8594189,
		"ID": 974,
		"x": 27.9517601643,
		"y": 69.436195764,
		"h": 4.5274725275
	},
	{
		"stop_id": 8594190,
		"ID": 974,
		"x": 27.6737304323,
		"y": 69.500247642,
		"h": 4.5274725275
	},
	{
		"stop_id": 8594198,
		"ID": 974,
		"x": 27.7647097233,
		"y": 69.018224618,
		"h": 4.5274725275
	},
	{
		"stop_id": 8594338,
		"ID": 974,
		"x": 30.4727089193,
		"y": 69.852246182,
		"h": 4.5274725275
	},
	{
		"stop_id": 8594553,
		"ID": 974,
		"x": 25.7267120093,
		"y": 71.585203493,
		"h": 4.5274725275
	},
	{
		"stop_id": 8595073,
		"ID": 974,
		"x": 28.8447571833,
		"y": 70.228193609,
		"h": 4.5274725275
	},
	{
		"stop_id": 8595074,
		"ID": 974,
		"x": 28.5027226093,
		"y": 70.836221139,
		"h": 4.5274725275
	},
	{
		"stop_id": 8595075,
		"ID": 974,
		"x": 29.0257616963,
		"y": 69.919221976,
		"h": 4.5274725275
	},
	{
		"stop_id": 8595076,
		"ID": 974,
		"x": 29.1527632173,
		"y": 71.403152164,
		"h": 4.5274725275
	},
	{
		"stop_id": 8595077,
		"ID": 974,
		"x": 28.7807699023,
		"y": 70.732178362,
		"h": 4.5274725275
	},
	{
		"stop_id": 8595078,
		"ID": 974,
		"x": 29.3407210003,
		"y": 71.433221011,
		"h": 4.5274725275
	},
	{
		"stop_id": 8595080,
		"ID": 974,
		"x": 28.9557338833,
		"y": 70.558217509,
		"h": 4.5274725275
	},
	{
		"stop_id": 8595081,
		"ID": 974,
		"x": 29.2647202413,
		"y": 70.566190761,
		"h": 4.5274725275
	},
	{
		"stop_id": 8595128,
		"ID": 974,
		"x": 29.1307709863,
		"y": 71.154186492,
		"h": 4.5274725275
	},
	{
		"stop_id": 8595129,
		"ID": 974,
		"x": 29.3527084243,
		"y": 71.183209073,
		"h": 4.5274725275
	},
	{
		"stop_id": 8503134,
		"ID": 1108,
		"x": 48.9887061313,
		"y": 64.871161848,
		"h": 1.5274725275
	},
	{
		"stop_id": 8503559,
		"ID": 1108,
		"x": 45.4827403073,
		"y": 66.005149548,
		"h": 1.5274725275
	},
	{
		"stop_id": 8503560,
		"ID": 1108,
		"x": 47.3527490963,
		"y": 66.760240763,
		"h": 1.5274725275
	},
	{
		"stop_id": 8506009,
		"ID": 1108,
		"x": 47.1247658523,
		"y": 67.659184467,
		"h": 1.5274725275
	},
	{
		"stop_id": 8573278,
		"ID": 1108,
		"x": 49.0327469503,
		"y": 64.830158745,
		"h": 1.5274725275
	},
	{
		"stop_id": 8573279,
		"ID": 1108,
		"x": 49.6577723533,
		"y": 64.980222288,
		"h": 1.5274725275
	},
	{
		"stop_id": 8573280,
		"ID": 1108,
		"x": 50.2737743443,
		"y": 65.83019692,
		"h": 1.5274725275
	},
	{
		"stop_id": 8573281,
		"ID": 1108,
		"x": 50.5577388843,
		"y": 66.230242676,
		"h": 1.5274725275
	},
	{
		"stop_id": 8573282,
		"ID": 1108,
		"x": 51.3577381123,
		"y": 66.110193641,
		"h": 1.5274725275
	},
	{
		"stop_id": 8573545,
		"ID": 1108,
		"x": 46.3577332193,
		"y": 66.580204189,
		"h": 1.5274725275
	},
	{
		"stop_id": 8573546,
		"ID": 1108,
		"x": 47.1277503673,
		"y": 67.255245697,
		"h": 1.5274725275
	},
	{
		"stop_id": 8573547,
		"ID": 1108,
		"x": 47.6077535633,
		"y": 66.070186251,
		"h": 1.5274725275
	},
	{
		"stop_id": 8573548,
		"ID": 1108,
		"x": 48.0577302413,
		"y": 65.005161048,
		"h": 1.5274725275
	},
	{
		"stop_id": 8575991,
		"ID": 1108,
		"x": 47.8717120733,
		"y": 63.592207198,
		"h": 1.5274725275
	},
	{
		"stop_id": 8575992,
		"ID": 1108,
		"x": 48.5117525023,
		"y": 64.273177736,
		"h": 1.5274725275
	},
	{
		"stop_id": 8575993,
		"ID": 1108,
		"x": 48.8787714083,
		"y": 64.641184307,
		"h": 1.5274725275
	},
	{
		"stop_id": 8587931,
		"ID": 1108,
		"x": 49.4777363233,
		"y": 64.53821375,
		"h": 1.5274725275
	},
	{
		"stop_id": 8503135,
		"ID": 1144,
		"x": 53.1097006573,
		"y": 63.282193421,
		"h": 1.2637362637
	},
	{
		"stop_id": 8503136,
		"ID": 1144,
		"x": 52.4667268413,
		"y": 60.984248374,
		"h": 1.2637362637
	},
	{
		"stop_id": 8580901,
		"ID": 1144,
		"x": 55.7237145133,
		"y": 64.337150276,
		"h": 1.2637362637
	},
	{
		"stop_id": 8587932,
		"ID": 1144,
		"x": 52.1717698943,
		"y": 63.905150304,
		"h": 1.2637362637
	},
	{
		"stop_id": 8587933,
		"ID": 1144,
		"x": 52.4097077913,
		"y": 61.01719693,
		"h": 1.2637362637
	},
	{
		"stop_id": 8587935,
		"ID": 1144,
		"x": 52.9207511613,
		"y": 62.206172661,
		"h": 1.2637362637
	},
	{
		"stop_id": 8587940,
		"ID": 1144,
		"x": 52.6337097293,
		"y": 61.555202307,
		"h": 1.2637362637
	},
	{
		"stop_id": 8587950,
		"ID": 1144,
		"x": 53.1287617763,
		"y": 63.285225242,
		"h": 1.2637362637
	},
	{
		"stop_id": 8589281,
		"ID": 1144,
		"x": 52.1177306123,
		"y": 60.393184128,
		"h": 1.2637362637
	},
	{
		"stop_id": 8503137,
		"ID": 1143,
		"x": 51.9197718863,
		"y": 58.796178562,
		"h": 1.5274725275
	},
	{
		"stop_id": 8503138,
		"ID": 1143,
		"x": 51.8917729503,
		"y": 54.233150412,
		"h": 1.5274725275
	},
	{
		"stop_id": 8503390,
		"ID": 1143,
		"x": 52.5077648153,
		"y": 54.805209279,
		"h": 1.5274725275
	},
	{
		"stop_id": 8503751,
		"ID": 1143,
		"x": 54.0607377593,
		"y": 54.690224243,
		"h": 1.5274725275
	},
	{
		"stop_id": 8573586,
		"ID": 1143,
		"x": 51.9017225223,
		"y": 54.219215333,
		"h": 1.5274725275
	},
	{
		"stop_id": 8573599,
		"ID": 1143,
		"x": 51.9457508543,
		"y": 54.578214177,
		"h": 1.5274725275
	},
	{
		"stop_id": 8573600,
		"ID": 1143,
		"x": 53.2577615793,
		"y": 54.930195499,
		"h": 1.5274725275
	},
	{
		"stop_id": 8577309,
		"ID": 1143,
		"x": 51.5177471403,
		"y": 55.230250418,
		"h": 1.5274725275
	},
	{
		"stop_id": 8577316,
		"ID": 1143,
		"x": 51.8777666123,
		"y": 55.380234721,
		"h": 1.5274725275
	},
	{
		"stop_id": 8577339,
		"ID": 1143,
		"x": 51.3477303213,
		"y": 55.880246589,
		"h": 1.5274725275
	},
	{
		"stop_id": 8580234,
		"ID": 1143,
		"x": 53.4867362163,
		"y": 54.804233975,
		"h": 1.5274725275
	},
	{
		"stop_id": 8580541,
		"ID": 1143,
		"x": 52.1677663673,
		"y": 54.740187015,
		"h": 1.5274725275
	},
	{
		"stop_id": 8587936,
		"ID": 1143,
		"x": 51.9257096063,
		"y": 58.814193522,
		"h": 1.5274725275
	},
	{
		"stop_id": 8587953,
		"ID": 1143,
		"x": 51.8807517263,
		"y": 54.996210339,
		"h": 1.5274725275
	},
	{
		"stop_id": 8587954,
		"ID": 1143,
		"x": 52.0377085333,
		"y": 56.530151987,
		"h": 1.5274725275
	},
	{
		"stop_id": 8587955,
		"ID": 1143,
		"x": 51.7167231713,
		"y": 58.357235021,
		"h": 1.5274725275
	},
	{
		"stop_id": 8594402,
		"ID": 1143,
		"x": 52.8437187033,
		"y": 55.382246227,
		"h": 1.5274725275
	},
	{
		"stop_id": 8503152,
		"ID": 1040,
		"x": 36.3547703553,
		"y": 63.797145017,
		"h": 2.0549450549
	},
	{
		"stop_id": 8503157,
		"ID": 1040,
		"x": 36.5957490893,
		"y": 66.44320301,
		"h": 2.0549450549
	},
	{
		"stop_id": 8503302,
		"ID": 1040,
		"x": 39.2957703223,
		"y": 66.512190892,
		"h": 2.0549450549
	},
	{
		"stop_id": 8503563,
		"ID": 1040,
		"x": 41.4327236073,
		"y": 66.530178038,
		"h": 2.0549450549
	},
	{
		"stop_id": 8503565,
		"ID": 1040,
		"x": 37.7297644673,
		"y": 63.523148938,
		"h": 2.0549450549
	},
	{
		"stop_id": 8503566,
		"ID": 1040,
		"x": 39.9577332723,
		"y": 63.705209785,
		"h": 2.0549450549
	},
	{
		"stop_id": 8503567,
		"ID": 1040,
		"x": 37.3317155563,
		"y": 63.002221636,
		"h": 2.0549450549
	},
	{
		"stop_id": 8503872,
		"ID": 1040,
		"x": 37.5757176923,
		"y": 63.278209153,
		"h": 2.0549450549
	},
	{
		"stop_id": 8503873,
		"ID": 1040,
		"x": 39.0367489683,
		"y": 63.951212662,
		"h": 2.0549450549
	},
	{
		"stop_id": 8503988,
		"ID": 1040,
		"x": 38.1077069243,
		"y": 65.34422259,
		"h": 2.0549450549
	},
	{
		"stop_id": 8573501,
		"ID": 1040,
		"x": 40.9977630853,
		"y": 64.35517855,
		"h": 2.0549450549
	},
	{
		"stop_id": 8573502,
		"ID": 1040,
		"x": 40.5827112443,
		"y": 64.055242593,
		"h": 2.0549450549
	},
	{
		"stop_id": 8573503,
		"ID": 1040,
		"x": 38.3177637403,
		"y": 64.080159112,
		"h": 2.0549450549
	},
	{
		"stop_id": 8573505,
		"ID": 1040,
		"x": 38.7887191123,
		"y": 64.232193159,
		"h": 2.0549450549
	},
	{
		"stop_id": 8573506,
		"ID": 1040,
		"x": 38.8557431573,
		"y": 65.91116574,
		"h": 2.0549450549
	},
	{
		"stop_id": 8573507,
		"ID": 1040,
		"x": 39.2977342313,
		"y": 66.530237804,
		"h": 2.0549450549
	},
	{
		"stop_id": 8573508,
		"ID": 1040,
		"x": 40.0237350073,
		"y": 66.538194748,
		"h": 2.0549450549
	},
	{
		"stop_id": 8573509,
		"ID": 1040,
		"x": 39.4377316623,
		"y": 66.910208857,
		"h": 2.0549450549
	},
	{
		"stop_id": 8573510,
		"ID": 1040,
		"x": 39.5377197173,
		"y": 67.590193566,
		"h": 2.0549450549
	},
	{
		"stop_id": 8573511,
		"ID": 1040,
		"x": 40.8517094383,
		"y": 67.243185235,
		"h": 2.0549450549
	},
	{
		"stop_id": 8573528,
		"ID": 1040,
		"x": 41.7127529673,
		"y": 65.93516178,
		"h": 2.0549450549
	},
	{
		"stop_id": 8579869,
		"ID": 1040,
		"x": 38.2177217063,
		"y": 67.630151654,
		"h": 2.0549450549
	},
	{
		"stop_id": 8581564,
		"ID": 1040,
		"x": 38.6587496363,
		"y": 67.244154828,
		"h": 2.0549450549
	},
	{
		"stop_id": 8582658,
		"ID": 1040,
		"x": 40.8807105163,
		"y": 64.837234304,
		"h": 2.0549450549
	},
	{
		"stop_id": 8582659,
		"ID": 1040,
		"x": 41.4177179303,
		"y": 65.060211918,
		"h": 2.0549450549
	},
	{
		"stop_id": 8583225,
		"ID": 1040,
		"x": 38.8757751703,
		"y": 64.040158217,
		"h": 2.0549450549
	},
	{
		"stop_id": 8583767,
		"ID": 1040,
		"x": 39.0817576093,
		"y": 67.077172285,
		"h": 2.0549450549
	},
	{
		"stop_id": 8588053,
		"ID": 1040,
		"x": 36.5627490403,
		"y": 63.882250198,
		"h": 2.0549450549
	},
	{
		"stop_id": 8588054,
		"ID": 1040,
		"x": 36.6477093473,
		"y": 63.680142069,
		"h": 2.0549450549
	},
	{
		"stop_id": 8588057,
		"ID": 1040,
		"x": 37.7737111343,
		"y": 63.341175853,
		"h": 2.0549450549
	},
	{
		"stop_id": 8588059,
		"ID": 1040,
		"x": 37.8707638233,
		"y": 63.027197652,
		"h": 2.0549450549
	},
	{
		"stop_id": 8588095,
		"ID": 1040,
		"x": 36.7777194303,
		"y": 66.130142726,
		"h": 2.0549450549
	},
	{
		"stop_id": 8588098,
		"ID": 1040,
		"x": 36.9177472683,
		"y": 66.500154912,
		"h": 2.0549450549
	},
	{
		"stop_id": 8503194,
		"ID": 1073,
		"x": 44.1307389133,
		"y": 60.763185463,
		"h": 2.3516483516
	},
	{
		"stop_id": 8503251,
		"ID": 1073,
		"x": 43.1457131513,
		"y": 60.088167984,
		"h": 2.3516483516
	},
	{
		"stop_id": 8503252,
		"ID": 1073,
		"x": 44.9027574883,
		"y": 60.376224993,
		"h": 2.3516483516
	},
	{
		"stop_id": 8503300,
		"ID": 1073,
		"x": 43.5087238963,
		"y": 60.681155134,
		"h": 2.3516483516
	},
	{
		"stop_id": 8503301,
		"ID": 1073,
		"x": 41.9357465433,
		"y": 64.551228264,
		"h": 2.3516483516
	},
	{
		"stop_id": 8503552,
		"ID": 1073,
		"x": 42.7577052613,
		"y": 65.35022892,
		"h": 2.3516483516
	},
	{
		"stop_id": 8503556,
		"ID": 1073,
		"x": 42.3327304583,
		"y": 65.280176149,
		"h": 2.3516483516
	},
	{
		"stop_id": 8503562,
		"ID": 1073,
		"x": 41.6827511703,
		"y": 65.15514693,
		"h": 2.3516483516
	},
	{
		"stop_id": 8503852,
		"ID": 1073,
		"x": 44.7827091613,
		"y": 64.73019899,
		"h": 2.3516483516
	},
	{
		"stop_id": 8573499,
		"ID": 1073,
		"x": 41.9167428433,
		"y": 64.549234241,
		"h": 2.3516483516
	},
	{
		"stop_id": 8573540,
		"ID": 1073,
		"x": 43.0187043203,
		"y": 64.186163444,
		"h": 2.3516483516
	},
	{
		"stop_id": 8573541,
		"ID": 1073,
		"x": 43.9577204183,
		"y": 63.855247388,
		"h": 2.3516483516
	},
	{
		"stop_id": 8573542,
		"ID": 1073,
		"x": 44.8237176243,
		"y": 63.913164444,
		"h": 2.3516483516
	},
	{
		"stop_id": 8573543,
		"ID": 1073,
		"x": 45.3977186903,
		"y": 64.1901983,
		"h": 2.3516483516
	},
	{
		"stop_id": 8573544,
		"ID": 1073,
		"x": 45.1077077703,
		"y": 64.55524207,
		"h": 2.3516483516
	},
	{
		"stop_id": 8573550,
		"ID": 1073,
		"x": 42.0027645163,
		"y": 64.973152993,
		"h": 2.3516483516
	},
	{
		"stop_id": 8575998,
		"ID": 1073,
		"x": 43.9117037533,
		"y": 60.15521578,
		"h": 2.3516483516
	},
	{
		"stop_id": 8575999,
		"ID": 1073,
		"x": 43.5387528023,
		"y": 60.107231942,
		"h": 2.3516483516
	},
	{
		"stop_id": 8576001,
		"ID": 1073,
		"x": 42.3647208373,
		"y": 60.303179212,
		"h": 2.3516483516
	},
	{
		"stop_id": 8576093,
		"ID": 1073,
		"x": 43.4167273723,
		"y": 60.320163704,
		"h": 2.3516483516
	},
	{
		"stop_id": 8576094,
		"ID": 1073,
		"x": 43.7317007143,
		"y": 60.605202124,
		"h": 2.3516483516
	},
	{
		"stop_id": 8581585,
		"ID": 1073,
		"x": 41.6877185283,
		"y": 64.675189088,
		"h": 2.3516483516
	},
	{
		"stop_id": 8581779,
		"ID": 1073,
		"x": 41.7377037243,
		"y": 65.100155087,
		"h": 2.3516483516
	},
	{
		"stop_id": 8582724,
		"ID": 1073,
		"x": 44.7437326173,
		"y": 64.734181936,
		"h": 2.3516483516
	},
	{
		"stop_id": 8583486,
		"ID": 1073,
		"x": 43.6777297353,
		"y": 61.974217314,
		"h": 2.3516483516
	},
	{
		"stop_id": 8583487,
		"ID": 1073,
		"x": 42.4587545913,
		"y": 63.960199506,
		"h": 2.3516483516
	},
	{
		"stop_id": 8583770,
		"ID": 1073,
		"x": 42.7637266443,
		"y": 64.111247719,
		"h": 2.3516483516
	},
	{
		"stop_id": 8583771,
		"ID": 1073,
		"x": 42.8967160993,
		"y": 64.337169611,
		"h": 2.3516483516
	},
	{
		"stop_id": 8587422,
		"ID": 1073,
		"x": 42.0427479873,
		"y": 60.14819529,
		"h": 2.3516483516
	},
	{
		"stop_id": 8587958,
		"ID": 1073,
		"x": 44.3877749083,
		"y": 60.741228741,
		"h": 2.3516483516
	},
	{
		"stop_id": 8593524,
		"ID": 1073,
		"x": 44.1577515993,
		"y": 65.680190675,
		"h": 2.3516483516
	},
	{
		"stop_id": 8594539,
		"ID": 1073,
		"x": 43.3627180483,
		"y": 60.813163547,
		"h": 2.3516483516
	},
	{
		"stop_id": 8594540,
		"ID": 1073,
		"x": 42.9597145913,
		"y": 60.691191451,
		"h": 2.3516483516
	},
	{
		"stop_id": 8594542,
		"ID": 1073,
		"x": 42.6527189443,
		"y": 60.126226669,
		"h": 2.3516483516
	},
	{
		"stop_id": 8594543,
		"ID": 1073,
		"x": 42.8897690583,
		"y": 60.513176634,
		"h": 2.3516483516
	},
	{
		"stop_id": 8595261,
		"ID": 1073,
		"x": 44.4207101573,
		"y": 61.788180618,
		"h": 2.3516483516
	},
	{
		"stop_id": 8595262,
		"ID": 1073,
		"x": 44.5537009693,
		"y": 62.370195578,
		"h": 2.3516483516
	},
	{
		"stop_id": 8595263,
		"ID": 1073,
		"x": 44.1667135243,
		"y": 60.427220223,
		"h": 2.3516483516
	},
	{
		"stop_id": 8595264,
		"ID": 1073,
		"x": 44.1507176613,
		"y": 61.081227693,
		"h": 2.3516483516
	},
	{
		"stop_id": 8595265,
		"ID": 1073,
		"x": 44.3507130993,
		"y": 61.388194799,
		"h": 2.3516483516
	},
	{
		"stop_id": 8595266,
		"ID": 1073,
		"x": 42.9577162053,
		"y": 60.073233528,
		"h": 2.3516483516
	},
	{
		"stop_id": 8595331,
		"ID": 1073,
		"x": 42.0477615913,
		"y": 60.358221197,
		"h": 2.3516483516
	},
	{
		"stop_id": 8503219,
		"ID": 1107,
		"x": 47.5397325303,
		"y": 62.759196686,
		"h": 1.4615384615
	},
	{
		"stop_id": 8503365,
		"ID": 1107,
		"x": 48.6287707093,
		"y": 58.269213017,
		"h": 1.4615384615
	},
	{
		"stop_id": 8503366,
		"ID": 1107,
		"x": 48.2877565773,
		"y": 57.110200441,
		"h": 1.4615384615
	},
	{
		"stop_id": 8503622,
		"ID": 1107,
		"x": 46.2357426193,
		"y": 61.507213418,
		"h": 1.4615384615
	},
	{
		"stop_id": 8575983,
		"ID": 1107,
		"x": 45.6007287953,
		"y": 60.005172373,
		"h": 1.4615384615
	},
	{
		"stop_id": 8575984,
		"ID": 1107,
		"x": 46.7237744063,
		"y": 60.701204258,
		"h": 1.4615384615
	},
	{
		"stop_id": 8575985,
		"ID": 1107,
		"x": 47.3467638813,
		"y": 60.790151108,
		"h": 1.4615384615
	},
	{
		"stop_id": 8575986,
		"ID": 1107,
		"x": 47.3987037183,
		"y": 61.13714045,
		"h": 1.4615384615
	},
	{
		"stop_id": 8575987,
		"ID": 1107,
		"x": 47.0147098713,
		"y": 61.350165205,
		"h": 1.4615384615
	},
	{
		"stop_id": 8575988,
		"ID": 1107,
		"x": 46.4737722623,
		"y": 61.452204186,
		"h": 1.4615384615
	},
	{
		"stop_id": 8576047,
		"ID": 1107,
		"x": 46.9517068643,
		"y": 57.258157702,
		"h": 1.4615384615
	},
	{
		"stop_id": 8576048,
		"ID": 1107,
		"x": 48.5167466313,
		"y": 57.930236165,
		"h": 1.4615384615
	},
	{
		"stop_id": 8587410,
		"ID": 1107,
		"x": 47.3557169603,
		"y": 58.812201687,
		"h": 1.4615384615
	},
	{
		"stop_id": 8587681,
		"ID": 1107,
		"x": 47.4607734683,
		"y": 61.241232703,
		"h": 1.4615384615
	},
	{
		"stop_id": 8590649,
		"ID": 1107,
		"x": 46.5677098903,
		"y": 57.796244093,
		"h": 1.4615384615
	},
	{
		"stop_id": 8503220,
		"ID": 1104,
		"x": 47.4197486993,
		"y": 44.964188092,
		"h": 1.7582417582
	},
	{
		"stop_id": 8503394,
		"ID": 1104,
		"x": 50.8997520753,
		"y": 43.407149133,
		"h": 1.7582417582
	},
	{
		"stop_id": 8503637,
		"ID": 1104,
		"x": 46.8807344773,
		"y": 45.053237417,
		"h": 1.7582417582
	},
	{
		"stop_id": 8503638,
		"ID": 1104,
		"x": 49.1137184423,
		"y": 44.161223568,
		"h": 1.7582417582
	},
	{
		"stop_id": 8503639,
		"ID": 1104,
		"x": 50.3137706703,
		"y": 43.577189835,
		"h": 1.7582417582
	},
	{
		"stop_id": 8503640,
		"ID": 1104,
		"x": 51.0857466783,
		"y": 43.427180706,
		"h": 1.7582417582
	},
	{
		"stop_id": 8503648,
		"ID": 1104,
		"x": 47.2257194903,
		"y": 45.359214849,
		"h": 1.7582417582
	},
	{
		"stop_id": 8503715,
		"ID": 1104,
		"x": 49.6477266543,
		"y": 45.220150236,
		"h": 1.7582417582
	},
	{
		"stop_id": 8503749,
		"ID": 1104,
		"x": 50.9867212013,
		"y": 42.967211619,
		"h": 1.7582417582
	},
	{
		"stop_id": 8573795,
		"ID": 1104,
		"x": 50.7817165743,
		"y": 43.304211319,
		"h": 1.7582417582
	},
	{
		"stop_id": 8573796,
		"ID": 1104,
		"x": 50.8297184503,
		"y": 41.060189252,
		"h": 1.7582417582
	},
	{
		"stop_id": 8573829,
		"ID": 1104,
		"x": 47.2997682863,
		"y": 45.216217219,
		"h": 1.7582417582
	},
	{
		"stop_id": 8573832,
		"ID": 1104,
		"x": 47.8347572183,
		"y": 44.817233782,
		"h": 1.7582417582
	},
	{
		"stop_id": 8573833,
		"ID": 1104,
		"x": 48.4907463573,
		"y": 44.463197734,
		"h": 1.7582417582
	},
	{
		"stop_id": 8573834,
		"ID": 1104,
		"x": 50.6767182863,
		"y": 43.393218447,
		"h": 1.7582417582
	},
	{
		"stop_id": 8573835,
		"ID": 1104,
		"x": 51.4027247533,
		"y": 43.465232179,
		"h": 1.7582417582
	},
	{
		"stop_id": 8574431,
		"ID": 1104,
		"x": 49.0427497113,
		"y": 45.276210908,
		"h": 1.7582417582
	},
	{
		"stop_id": 8574432,
		"ID": 1104,
		"x": 50.2957725753,
		"y": 45.172175682,
		"h": 1.7582417582
	},
	{
		"stop_id": 8574478,
		"ID": 1104,
		"x": 47.3927144273,
		"y": 44.971150892,
		"h": 1.7582417582
	},
	{
		"stop_id": 8574480,
		"ID": 1104,
		"x": 47.9997566823,
		"y": 44.701243382,
		"h": 1.7582417582
	},
	{
		"stop_id": 8581710,
		"ID": 1104,
		"x": 48.1257489583,
		"y": 45.369250758,
		"h": 1.7582417582
	},
	{
		"stop_id": 8581711,
		"ID": 1104,
		"x": 47.8007357053,
		"y": 45.44920462,
		"h": 1.7582417582
	},
	{
		"stop_id": 8581712,
		"ID": 1104,
		"x": 47.5187733573,
		"y": 45.227169804,
		"h": 1.7582417582
	},
	{
		"stop_id": 8582618,
		"ID": 1104,
		"x": 49.4457691233,
		"y": 44.000185885,
		"h": 1.7582417582
	},
	{
		"stop_id": 8503221,
		"ID": 1141,
		"x": 51.0727070603,
		"y": 44.208196735,
		"h": 1.8241758242
	},
	{
		"stop_id": 8503222,
		"ID": 1141,
		"x": 53.9707113103,
		"y": 43.564156063,
		"h": 1.8241758242
	},
	{
		"stop_id": 8503641,
		"ID": 1141,
		"x": 53.1597078903,
		"y": 43.306184098,
		"h": 1.8241758242
	},
	{
		"stop_id": 8503642,
		"ID": 1141,
		"x": 54.0207515563,
		"y": 43.453249635,
		"h": 1.8241758242
	},
	{
		"stop_id": 8503643,
		"ID": 1141,
		"x": 55.0557182303,
		"y": 43.363166127,
		"h": 1.8241758242
	},
	{
		"stop_id": 8503748,
		"ID": 1141,
		"x": 54.4047462913,
		"y": 46.582238746,
		"h": 1.8241758242
	},
	{
		"stop_id": 8506484,
		"ID": 1141,
		"x": 52.3167220833,
		"y": 45.240171796,
		"h": 1.8241758242
	},
	{
		"stop_id": 8506489,
		"ID": 1141,
		"x": 54.1187362933,
		"y": 46.539167957,
		"h": 1.8241758242
	},
	{
		"stop_id": 8573794,
		"ID": 1141,
		"x": 51.0597028473,
		"y": 44.198169181,
		"h": 1.8241758242
	},
	{
		"stop_id": 8573821,
		"ID": 1141,
		"x": 53.5547339873,
		"y": 45.284208642,
		"h": 1.8241758242
	},
	{
		"stop_id": 8573822,
		"ID": 1141,
		"x": 53.9157220563,
		"y": 46.071145689,
		"h": 1.8241758242
	},
	{
		"stop_id": 8573836,
		"ID": 1141,
		"x": 51.8167472523,
		"y": 43.487217927,
		"h": 1.8241758242
	},
	{
		"stop_id": 8573837,
		"ID": 1141,
		"x": 52.4917006153,
		"y": 43.483239171,
		"h": 1.8241758242
	},
	{
		"stop_id": 8573838,
		"ID": 1141,
		"x": 52.8677339793,
		"y": 43.46922101,
		"h": 1.8241758242
	},
	{
		"stop_id": 8573839,
		"ID": 1141,
		"x": 53.6257337663,
		"y": 43.341181265,
		"h": 1.8241758242
	},
	{
		"stop_id": 8573840,
		"ID": 1141,
		"x": 54.6517377293,
		"y": 43.469246391,
		"h": 1.8241758242
	},
	{
		"stop_id": 8573841,
		"ID": 1141,
		"x": 55.5927142063,
		"y": 43.202202604,
		"h": 1.8241758242
	},
	{
		"stop_id": 8574433,
		"ID": 1141,
		"x": 50.6947147113,
		"y": 45.167230616,
		"h": 1.8241758242
	},
	{
		"stop_id": 8574434,
		"ID": 1141,
		"x": 51.1377158203,
		"y": 45.157240529,
		"h": 1.8241758242
	},
	{
		"stop_id": 8574435,
		"ID": 1141,
		"x": 54.6847203073,
		"y": 46.655230472,
		"h": 1.8241758242
	},
	{
		"stop_id": 8574436,
		"ID": 1141,
		"x": 55.2077112273,
		"y": 47.030162205,
		"h": 1.8241758242
	},
	{
		"stop_id": 8579749,
		"ID": 1141,
		"x": 54.3547621573,
		"y": 45.072223302,
		"h": 1.8241758242
	},
	{
		"stop_id": 8579769,
		"ID": 1141,
		"x": 54.1687383703,
		"y": 46.081215453,
		"h": 1.8241758242
	},
	{
		"stop_id": 8579770,
		"ID": 1141,
		"x": 54.1087367973,
		"y": 46.341156654,
		"h": 1.8241758242
	},
	{
		"stop_id": 8579801,
		"ID": 1141,
		"x": 54.2947014073,
		"y": 44.528208115,
		"h": 1.8241758242
	},
	{
		"stop_id": 8581892,
		"ID": 1141,
		"x": 50.7727584173,
		"y": 44.981205075,
		"h": 1.8241758242
	},
	{
		"stop_id": 8503223,
		"ID": 1176,
		"x": 57.2787739883,
		"y": 43.218240319,
		"h": 1.5274725275
	},
	{
		"stop_id": 8503224,
		"ID": 1176,
		"x": 60.9327013203,
		"y": 41.011140787,
		"h": 1.5274725275
	},
	{
		"stop_id": 8573880,
		"ID": 1176,
		"x": 58.4487646103,
		"y": 45.427201713,
		"h": 1.5274725275
	},
	{
		"stop_id": 8573881,
		"ID": 1176,
		"x": 58.2327054333,
		"y": 44.955209672,
		"h": 1.5274725275
	},
	{
		"stop_id": 8573882,
		"ID": 1176,
		"x": 58.1427679283,
		"y": 44.475162249,
		"h": 1.5274725275
	},
	{
		"stop_id": 8574481,
		"ID": 1176,
		"x": 56.6577144213,
		"y": 42.98020981,
		"h": 1.5274725275
	},
	{
		"stop_id": 8574482,
		"ID": 1176,
		"x": 56.8467171673,
		"y": 42.835241475,
		"h": 1.5274725275
	},
	{
		"stop_id": 8574483,
		"ID": 1176,
		"x": 57.1327075153,
		"y": 42.683177248,
		"h": 1.5274725275
	},
	{
		"stop_id": 8574484,
		"ID": 1176,
		"x": 57.4307169823,
		"y": 42.984159185,
		"h": 1.5274725275
	},
	{
		"stop_id": 8574485,
		"ID": 1176,
		"x": 57.3087418023,
		"y": 43.198147381,
		"h": 1.5274725275
	},
	{
		"stop_id": 8577680,
		"ID": 1176,
		"x": 60.2577203053,
		"y": 40.91019632,
		"h": 1.5274725275
	},
	{
		"stop_id": 8577685,
		"ID": 1176,
		"x": 60.0777511033,
		"y": 41.07014094,
		"h": 1.5274725275
	},
	{
		"stop_id": 8577687,
		"ID": 1176,
		"x": 58.4577005853,
		"y": 42.090214966,
		"h": 1.5274725275
	},
	{
		"stop_id": 8587511,
		"ID": 1176,
		"x": 60.3377337943,
		"y": 40.550195036,
		"h": 1.5274725275
	},
	{
		"stop_id": 8587512,
		"ID": 1176,
		"x": 60.9087186083,
		"y": 41.0192166,
		"h": 1.5274725275
	},
	{
		"stop_id": 8588818,
		"ID": 1176,
		"x": 60.7877616103,
		"y": 40.950156908,
		"h": 1.5274725275
	},
	{
		"stop_id": 8594389,
		"ID": 1176,
		"x": 58.8237102753,
		"y": 41.85820241,
		"h": 1.5274725275
	},
	{
		"stop_id": 8503227,
		"ID": 1211,
		"x": 64.0927075483,
		"y": 35.130173933,
		"h": 1.8571428571
	},
	{
		"stop_id": 8503228,
		"ID": 1211,
		"x": 63.3727611193,
		"y": 31.31318535,
		"h": 1.8571428571
	},
	{
		"stop_id": 8503612,
		"ID": 1211,
		"x": 64.6377689133,
		"y": 35.740226108,
		"h": 1.8571428571
	},
	{
		"stop_id": 8503973,
		"ID": 1211,
		"x": 64.3327236643,
		"y": 34.755206286,
		"h": 1.8571428571
	},
	{
		"stop_id": 8573885,
		"ID": 1211,
		"x": 63.6177500323,
		"y": 36.090184386,
		"h": 1.8571428571
	},
	{
		"stop_id": 8573886,
		"ID": 1211,
		"x": 63.5367271233,
		"y": 35.251185383,
		"h": 1.8571428571
	},
	{
		"stop_id": 8573887,
		"ID": 1211,
		"x": 64.0827487393,
		"y": 35.105169668,
		"h": 1.8571428571
	},
	{
		"stop_id": 8573888,
		"ID": 1211,
		"x": 64.5577545203,
		"y": 34.630242114,
		"h": 1.8571428571
	},
	{
		"stop_id": 8573889,
		"ID": 1211,
		"x": 64.7327463363,
		"y": 35.980175705,
		"h": 1.8571428571
	},
	{
		"stop_id": 8573890,
		"ID": 1211,
		"x": 65.2827568953,
		"y": 36.680243161,
		"h": 1.8571428571
	},
	{
		"stop_id": 8577734,
		"ID": 1211,
		"x": 63.5577593713,
		"y": 35.460228142,
		"h": 1.8571428571
	},
	{
		"stop_id": 8579532,
		"ID": 1211,
		"x": 63.7577497263,
		"y": 35.83021444,
		"h": 1.8571428571
	},
	{
		"stop_id": 8579534,
		"ID": 1211,
		"x": 63.4577137003,
		"y": 36.530217404,
		"h": 1.8571428571
	},
	{
		"stop_id": 8579947,
		"ID": 1211,
		"x": 63.4137087193,
		"y": 34.631158593,
		"h": 1.8571428571
	},
	{
		"stop_id": 8579949,
		"ID": 1211,
		"x": 63.5767009523,
		"y": 34.945218217,
		"h": 1.8571428571
	},
	{
		"stop_id": 8579950,
		"ID": 1211,
		"x": 63.6637600213,
		"y": 35.207224822,
		"h": 1.8571428571
	},
	{
		"stop_id": 8579951,
		"ID": 1211,
		"x": 64.1967272723,
		"y": 34.751151123,
		"h": 1.8571428571
	},
	{
		"stop_id": 8579952,
		"ID": 1211,
		"x": 64.0947732733,
		"y": 34.377184182,
		"h": 1.8571428571
	},
	{
		"stop_id": 8579953,
		"ID": 1211,
		"x": 64.2977672243,
		"y": 34.140220382,
		"h": 1.8571428571
	},
	{
		"stop_id": 8580502,
		"ID": 1211,
		"x": 62.9937583623,
		"y": 31.081193744,
		"h": 1.8571428571
	},
	{
		"stop_id": 8580503,
		"ID": 1211,
		"x": 63.2277600893,
		"y": 31.642225044,
		"h": 1.8571428571
	},
	{
		"stop_id": 8580907,
		"ID": 1211,
		"x": 63.0947014963,
		"y": 31.293213341,
		"h": 1.8571428571
	},
	{
		"stop_id": 8582765,
		"ID": 1211,
		"x": 63.2987325443,
		"y": 34.407165076,
		"h": 1.8571428571
	},
	{
		"stop_id": 8583669,
		"ID": 1211,
		"x": 63.3617272783,
		"y": 31.402248513,
		"h": 1.8571428571
	},
	{
		"stop_id": 8588333,
		"ID": 1211,
		"x": 65.7677566783,
		"y": 32.09016501,
		"h": 1.8571428571
	},
	{
		"stop_id": 8589197,
		"ID": 1211,
		"x": 64.5567125383,
		"y": 35.142176818,
		"h": 1.8571428571
	},
	{
		"stop_id": 8595715,
		"ID": 1211,
		"x": 64.4477027353,
		"y": 34.212176584,
		"h": 1.8571428571
	},
	{
		"stop_id": 8503230,
		"ID": 1210,
		"x": 64.3507271123,
		"y": 28.597247843,
		"h": 1.8571428571
	},
	{
		"stop_id": 8503231,
		"ID": 1210,
		"x": 64.7947564753,
		"y": 27.832244367,
		"h": 1.8571428571
	},
	{
		"stop_id": 8503232,
		"ID": 1210,
		"x": 65.1527741763,
		"y": 25.30122664,
		"h": 1.8571428571
	},
	{
		"stop_id": 8573902,
		"ID": 1210,
		"x": 64.3447743483,
		"y": 28.558205082,
		"h": 1.8571428571
	},
	{
		"stop_id": 8573904,
		"ID": 1210,
		"x": 62.8657291713,
		"y": 29.607205666,
		"h": 1.8571428571
	},
	{
		"stop_id": 8573905,
		"ID": 1210,
		"x": 61.7957123633,
		"y": 29.427169741,
		"h": 1.8571428571
	},
	{
		"stop_id": 8580032,
		"ID": 1210,
		"x": 65.2577625233,
		"y": 27.665242109,
		"h": 1.8571428571
	},
	{
		"stop_id": 8580252,
		"ID": 1210,
		"x": 64.8597586073,
		"y": 27.883196282,
		"h": 1.8571428571
	},
	{
		"stop_id": 8580266,
		"ID": 1210,
		"x": 64.1407216203,
		"y": 28.742216985,
		"h": 1.8571428571
	},
	{
		"stop_id": 8580271,
		"ID": 1210,
		"x": 63.2877207433,
		"y": 29.326234599,
		"h": 1.8571428571
	},
	{
		"stop_id": 8580273,
		"ID": 1210,
		"x": 63.4887532953,
		"y": 29.45515003,
		"h": 1.8571428571
	},
	{
		"stop_id": 8580288,
		"ID": 1210,
		"x": 64.0337317293,
		"y": 28.61222957,
		"h": 1.8571428571
	},
	{
		"stop_id": 8580486,
		"ID": 1210,
		"x": 64.7507621723,
		"y": 28.133224677,
		"h": 1.8571428571
	},
	{
		"stop_id": 8580487,
		"ID": 1210,
		"x": 65.0867028893,
		"y": 27.781194732,
		"h": 1.8571428571
	},
	{
		"stop_id": 8580493,
		"ID": 1210,
		"x": 63.6577051303,
		"y": 29.492226918,
		"h": 1.8571428571
	},
	{
		"stop_id": 8580494,
		"ID": 1210,
		"x": 63.9317320673,
		"y": 29.106160608,
		"h": 1.8571428571
	},
	{
		"stop_id": 8580501,
		"ID": 1210,
		"x": 62.8937013103,
		"y": 30.604212793,
		"h": 1.8571428571
	},
	{
		"stop_id": 8580903,
		"ID": 1210,
		"x": 63.7007463373,
		"y": 28.511141473,
		"h": 1.8571428571
	},
	{
		"stop_id": 8580904,
		"ID": 1210,
		"x": 63.8517362203,
		"y": 28.42219931,
		"h": 1.8571428571
	},
	{
		"stop_id": 8580906,
		"ID": 1210,
		"x": 62.8397205683,
		"y": 29.981180139,
		"h": 1.8571428571
	},
	{
		"stop_id": 8582609,
		"ID": 1210,
		"x": 63.4527668743,
		"y": 28.552158094,
		"h": 1.8571428571
	},
	{
		"stop_id": 8583654,
		"ID": 1210,
		"x": 61.2077274473,
		"y": 29.630150551,
		"h": 1.8571428571
	},
	{
		"stop_id": 8583667,
		"ID": 1210,
		"x": 63.2947370633,
		"y": 30.893251169,
		"h": 1.8571428571
	},
	{
		"stop_id": 8583668,
		"ID": 1210,
		"x": 63.3197651523,
		"y": 30.336227479,
		"h": 1.8571428571
	},
	{
		"stop_id": 8589546,
		"ID": 1210,
		"x": 64.3207603573,
		"y": 25.689172054,
		"h": 1.8571428571
	},
	{
		"stop_id": 8595528,
		"ID": 1210,
		"x": 65.0957103553,
		"y": 25.440250566,
		"h": 1.8571428571
	},
	{
		"stop_id": 8595716,
		"ID": 1210,
		"x": 64.7657005703,
		"y": 27.880230462,
		"h": 1.8571428571
	},
	{
		"stop_id": 8503233,
		"ID": 1209,
		"x": 64.8987436813,
		"y": 23.819228743,
		"h": 1.7252747253
	},
	{
		"stop_id": 8503234,
		"ID": 1209,
		"x": 63.5407164753,
		"y": 22.573200709,
		"h": 1.7252747253
	},
	{
		"stop_id": 8503235,
		"ID": 1209,
		"x": 62.6257278183,
		"y": 21.425185056,
		"h": 1.7252747253
	},
	{
		"stop_id": 8503236,
		"ID": 1209,
		"x": 62.0477286053,
		"y": 20.226141472,
		"h": 1.7252747253
	},
	{
		"stop_id": 8503244,
		"ID": 1209,
		"x": 63.7797194273,
		"y": 22.34919232,
		"h": 1.7252747253
	},
	{
		"stop_id": 8503245,
		"ID": 1209,
		"x": 61.9577541873,
		"y": 19.830234735,
		"h": 1.7252747253
	},
	{
		"stop_id": 8503256,
		"ID": 1209,
		"x": 65.4957629153,
		"y": 24.100159211,
		"h": 1.7252747253
	},
	{
		"stop_id": 8503278,
		"ID": 1209,
		"x": 64.0617677763,
		"y": 24.789219217,
		"h": 1.7252747253
	},
	{
		"stop_id": 8503279,
		"ID": 1209,
		"x": 64.0227749003,
		"y": 23.761184293,
		"h": 1.7252747253
	},
	{
		"stop_id": 8503322,
		"ID": 1209,
		"x": 63.3577461893,
		"y": 22.730211475,
		"h": 1.7252747253
	},
	{
		"stop_id": 8503324,
		"ID": 1209,
		"x": 61.8577581673,
		"y": 20.430201733,
		"h": 1.7252747253
	},
	{
		"stop_id": 8503618,
		"ID": 1209,
		"x": 65.3507188173,
		"y": 23.743178772,
		"h": 1.7252747253
	},
	{
		"stop_id": 8577526,
		"ID": 1209,
		"x": 64.8577377733,
		"y": 23.830158953,
		"h": 1.7252747253
	},
	{
		"stop_id": 8577527,
		"ID": 1209,
		"x": 64.2367190083,
		"y": 23.592161184,
		"h": 1.7252747253
	},
	{
		"stop_id": 8577528,
		"ID": 1209,
		"x": 64.0987162953,
		"y": 24.669227555,
		"h": 1.7252747253
	},
	{
		"stop_id": 8588554,
		"ID": 1209,
		"x": 64.7377729013,
		"y": 23.505186735,
		"h": 1.7252747253
	},
	{
		"stop_id": 8588555,
		"ID": 1209,
		"x": 64.0467040793,
		"y": 23.264191894,
		"h": 1.7252747253
	},
	{
		"stop_id": 8588556,
		"ID": 1209,
		"x": 63.4637115753,
		"y": 22.197216395,
		"h": 1.7252747253
	},
	{
		"stop_id": 8588557,
		"ID": 1209,
		"x": 63.1507759113,
		"y": 21.836163249,
		"h": 1.7252747253
	},
	{
		"stop_id": 8588558,
		"ID": 1209,
		"x": 62.4157394223,
		"y": 21.44423428,
		"h": 1.7252747253
	},
	{
		"stop_id": 8589544,
		"ID": 1209,
		"x": 64.3417444993,
		"y": 23.422213693,
		"h": 1.7252747253
	},
	{
		"stop_id": 8589547,
		"ID": 1209,
		"x": 64.3297428983,
		"y": 24.939230593,
		"h": 1.7252747253
	},
	{
		"stop_id": 8595527,
		"ID": 1209,
		"x": 61.8967525283,
		"y": 20.470247723,
		"h": 1.7252747253
	},
	{
		"stop_id": 8503237,
		"ID": 1172,
		"x": 60.9757462013,
		"y": 18.104144008,
		"h": 1.2967032967
	},
	{
		"stop_id": 8503238,
		"ID": 1172,
		"x": 60.1387439453,
		"y": 16.7942205,
		"h": 1.2967032967
	},
	{
		"stop_id": 8503261,
		"ID": 1172,
		"x": 59.0307128693,
		"y": 17.234200674,
		"h": 1.2967032967
	},
	{
		"stop_id": 8503268,
		"ID": 1172,
		"x": 58.6717436513,
		"y": 18.361235836,
		"h": 1.2967032967
	},
	{
		"stop_id": 8503269,
		"ID": 1172,
		"x": 57.9277177743,
		"y": 19.135215703,
		"h": 1.2967032967
	},
	{
		"stop_id": 8503326,
		"ID": 1172,
		"x": 60.2577701103,
		"y": 17.030226762,
		"h": 1.2967032967
	},
	{
		"stop_id": 8503611,
		"ID": 1172,
		"x": 58.1367192043,
		"y": 17.194140005,
		"h": 1.2967032967
	},
	{
		"stop_id": 8503645,
		"ID": 1172,
		"x": 58.4527316113,
		"y": 17.2542023,
		"h": 1.2967032967
	},
	{
		"stop_id": 8530524,
		"ID": 1172,
		"x": 58.7347492663,
		"y": 17.081214993,
		"h": 1.2967032967
	},
	{
		"stop_id": 8595526,
		"ID": 1172,
		"x": 61.7707458573,
		"y": 19.731243433,
		"h": 1.2967032967
	},
	{
		"stop_id": 8503239,
		"ID": 1171,
		"x": 58.9977592813,
		"y": 15.773145502,
		"h": 1.3296703297
	},
	{
		"stop_id": 8503240,
		"ID": 1171,
		"x": 59.3497736583,
		"y": 16.094159601,
		"h": 1.3296703297
	},
	{
		"stop_id": 8503260,
		"ID": 1171,
		"x": 59.3367320873,
		"y": 16.110244902,
		"h": 1.3296703297
	},
	{
		"stop_id": 8503327,
		"ID": 1171,
		"x": 59.2577361453,
		"y": 16.030168962,
		"h": 1.3296703297
	},
	{
		"stop_id": 8505699,
		"ID": 1171,
		"x": 57.6117229703,
		"y": 13.876183854,
		"h": 1.3296703297
	},
	{
		"stop_id": 8505740,
		"ID": 1171,
		"x": 56.1827557653,
		"y": 13.828168206,
		"h": 1.3296703297
	},
	{
		"stop_id": 8505741,
		"ID": 1171,
		"x": 57.4877487243,
		"y": 14.606168182,
		"h": 1.3296703297
	},
	{
		"stop_id": 8573129,
		"ID": 1171,
		"x": 57.2597116153,
		"y": 14.131248246,
		"h": 1.3296703297
	},
	{
		"stop_id": 8573130,
		"ID": 1171,
		"x": 59.1717491143,
		"y": 15.306151952,
		"h": 1.3296703297
	},
	{
		"stop_id": 8573131,
		"ID": 1171,
		"x": 59.0207065663,
		"y": 15.749250548,
		"h": 1.3296703297
	},
	{
		"stop_id": 8579872,
		"ID": 1171,
		"x": 58.8827105103,
		"y": 15.068237149,
		"h": 1.3296703297
	},
	{
		"stop_id": 8503246,
		"ID": 1208,
		"x": 61.2577293553,
		"y": 18.130199313,
		"h": 1.0659340659
	},
	{
		"stop_id": 8503325,
		"ID": 1208,
		"x": 61.6577452033,
		"y": 18.830164912,
		"h": 1.0659340659
	},
	{
		"stop_id": 8595522,
		"ID": 1208,
		"x": 61.4597703453,
		"y": 18.583184967,
		"h": 1.0659340659
	},
	{
		"stop_id": 8503250,
		"ID": 1066,
		"x": 43.0357522633,
		"y": 25.002225576,
		"h": 1.3956043956
	},
	{
		"stop_id": 8530407,
		"ID": 1066,
		"x": 42.9547739503,
		"y": 24.979149197,
		"h": 1.3956043956
	},
	{
		"stop_id": 8530408,
		"ID": 1066,
		"x": 43.6317374983,
		"y": 23.753202191,
		"h": 1.3956043956
	},
	{
		"stop_id": 8530409,
		"ID": 1066,
		"x": 42.6707545183,
		"y": 24.875197632,
		"h": 1.3956043956
	},
	{
		"stop_id": 8530410,
		"ID": 1066,
		"x": 41.6187654863,
		"y": 23.860208548,
		"h": 1.3956043956
	},
	{
		"stop_id": 8577464,
		"ID": 1066,
		"x": 41.4327664063,
		"y": 20.652185136,
		"h": 1.3956043956
	},
	{
		"stop_id": 8577466,
		"ID": 1066,
		"x": 42.7447380523,
		"y": 20.694244695,
		"h": 1.3956043956
	},
	{
		"stop_id": 8577467,
		"ID": 1066,
		"x": 43.5297299823,
		"y": 20.235225034,
		"h": 1.3956043956
	},
	{
		"stop_id": 8587533,
		"ID": 1066,
		"x": 41.7437451423,
		"y": 20.683147906,
		"h": 1.3956043956
	},
	{
		"stop_id": 8587797,
		"ID": 1066,
		"x": 44.8907178573,
		"y": 19.518187826,
		"h": 1.3956043956
	},
	{
		"stop_id": 8587960,
		"ID": 1066,
		"x": 42.5197301183,
		"y": 21.176164306,
		"h": 1.3956043956
	},
	{
		"stop_id": 8588194,
		"ID": 1066,
		"x": 44.5017071193,
		"y": 19.794245489,
		"h": 1.3956043956
	},
	{
		"stop_id": 8592407,
		"ID": 1066,
		"x": 42.0047437263,
		"y": 20.833245996,
		"h": 1.3956043956
	},
	{
		"stop_id": 8503255,
		"ID": 1272,
		"x": 72.0527073983,
		"y": 20.216144153,
		"h": 1.1978021978
	},
	{
		"stop_id": 8503270,
		"ID": 1272,
		"x": 70.6857751803,
		"y": 22.288202526,
		"h": 1.1978021978
	},
	{
		"stop_id": 8503271,
		"ID": 1272,
		"x": 70.5577635263,
		"y": 22.630230622,
		"h": 1.1978021978
	},
	{
		"stop_id": 8503273,
		"ID": 1272,
		"x": 71.1657008443,
		"y": 21.530221947,
		"h": 1.1978021978
	},
	{
		"stop_id": 8530519,
		"ID": 1272,
		"x": 72.1386993363,
		"y": 19.890231445,
		"h": 1.1978021978
	},
	{
		"stop_id": 8530520,
		"ID": 1272,
		"x": 72.7487005593,
		"y": 20.211201872,
		"h": 1.1978021978
	},
	{
		"stop_id": 8589548,
		"ID": 1272,
		"x": 71.4197220913,
		"y": 21.265143195,
		"h": 1.1978021978
	},
	{
		"stop_id": 8503258,
		"ID": 1271,
		"x": 72.0207469983,
		"y": 17.707149635,
		"h": 1.3296703297
	},
	{
		"stop_id": 8503266,
		"ID": 1271,
		"x": 72.2827417443,
		"y": 16.611190349,
		"h": 1.3296703297
	},
	{
		"stop_id": 8503274,
		"ID": 1271,
		"x": 72.1717116933,
		"y": 19.440164129,
		"h": 1.3296703297
	},
	{
		"stop_id": 8503276,
		"ID": 1271,
		"x": 71.5537198153,
		"y": 14.644169426,
		"h": 1.3296703297
	},
	{
		"stop_id": 8503277,
		"ID": 1271,
		"x": 72.3527069803,
		"y": 15.686240302,
		"h": 1.3296703297
	},
	{
		"stop_id": 8503615,
		"ID": 1271,
		"x": 72.0057069933,
		"y": 14.994159186,
		"h": 1.3296703297
	},
	{
		"stop_id": 8503616,
		"ID": 1271,
		"x": 72.2717598523,
		"y": 15.312162483,
		"h": 1.3296703297
	},
	{
		"stop_id": 8530521,
		"ID": 1271,
		"x": 71.5917194513,
		"y": 14.704161286,
		"h": 1.3296703297
	},
	{
		"stop_id": 8530522,
		"ID": 1271,
		"x": 70.9977454603,
		"y": 15.603170088,
		"h": 1.3296703297
	},
	{
		"stop_id": 8588281,
		"ID": 1271,
		"x": 71.7957607353,
		"y": 14.812174132,
		"h": 1.3296703297
	},
	{
		"stop_id": 8589545,
		"ID": 1271,
		"x": 72.1267658843,
		"y": 19.286162853,
		"h": 1.3296703297
	},
	{
		"stop_id": 8503259,
		"ID": 1242,
		"x": 67.5987532843,
		"y": 24.119214521,
		"h": 1.032967033
	},
	{
		"stop_id": 8503272,
		"ID": 1242,
		"x": 70.0577732733,
		"y": 22.541161466,
		"h": 1.032967033
	},
	{
		"stop_id": 8503265,
		"ID": 1000,
		"x": 33.5677289783,
		"y": 30.037232894,
		"h": 2.5164835165
	},
	{
		"stop_id": 8503750,
		"ID": 1000,
		"x": 36.3577523623,
		"y": 28.305233766,
		"h": 2.5164835165
	},
	{
		"stop_id": 8505095,
		"ID": 1000,
		"x": 32.4507700623,
		"y": 25.937217691,
		"h": 2.5164835165
	},
	{
		"stop_id": 8530402,
		"ID": 1000,
		"x": 36.3487633213,
		"y": 28.311204179,
		"h": 2.5164835165
	},
	{
		"stop_id": 8530403,
		"ID": 1000,
		"x": 36.0147384103,
		"y": 26.84216662,
		"h": 2.5164835165
	},
	{
		"stop_id": 8530413,
		"ID": 1000,
		"x": 32.7597501153,
		"y": 30.598250522,
		"h": 2.5164835165
	},
	{
		"stop_id": 8577421,
		"ID": 1000,
		"x": 31.9707037483,
		"y": 26.074246906,
		"h": 2.5164835165
	},
	{
		"stop_id": 8577422,
		"ID": 1000,
		"x": 31.5447418923,
		"y": 26.145208751,
		"h": 2.5164835165
	},
	{
		"stop_id": 8577423,
		"ID": 1000,
		"x": 31.3537207313,
		"y": 26.331192024,
		"h": 2.5164835165
	},
	{
		"stop_id": 8577430,
		"ID": 1000,
		"x": 32.2207717033,
		"y": 25.315143201,
		"h": 2.5164835165
	},
	{
		"stop_id": 8577431,
		"ID": 1000,
		"x": 32.4657764903,
		"y": 25.650146447,
		"h": 2.5164835165
	},
	{
		"stop_id": 8577432,
		"ID": 1000,
		"x": 32.4847102053,
		"y": 25.768184528,
		"h": 2.5164835165
	},
	{
		"stop_id": 8577448,
		"ID": 1000,
		"x": 32.9467240703,
		"y": 25.699183621,
		"h": 2.5164835165
	},
	{
		"stop_id": 8577449,
		"ID": 1000,
		"x": 32.9507672703,
		"y": 25.385147304,
		"h": 2.5164835165
	},
	{
		"stop_id": 8577471,
		"ID": 1000,
		"x": 32.4347171633,
		"y": 26.041150395,
		"h": 2.5164835165
	},
	{
		"stop_id": 8577472,
		"ID": 1000,
		"x": 31.9717578963,
		"y": 26.495211073,
		"h": 2.5164835165
	},
	{
		"stop_id": 8577473,
		"ID": 1000,
		"x": 31.8967008103,
		"y": 27.075223945,
		"h": 2.5164835165
	},
	{
		"stop_id": 8577474,
		"ID": 1000,
		"x": 31.8777567963,
		"y": 27.457188918,
		"h": 2.5164835165
	},
	{
		"stop_id": 8577475,
		"ID": 1000,
		"x": 31.5967746523,
		"y": 27.955215117,
		"h": 2.5164835165
	},
	{
		"stop_id": 8577476,
		"ID": 1000,
		"x": 30.9517219813,
		"y": 28.657179003,
		"h": 2.5164835165
	},
	{
		"stop_id": 8577477,
		"ID": 1000,
		"x": 30.7637601663,
		"y": 28.763173474,
		"h": 2.5164835165
	},
	{
		"stop_id": 8577486,
		"ID": 1000,
		"x": 33.0357283033,
		"y": 26.024228644,
		"h": 2.5164835165
	},
	{
		"stop_id": 8577487,
		"ID": 1000,
		"x": 33.6127045903,
		"y": 25.352218289,
		"h": 2.5164835165
	},
	{
		"stop_id": 8587531,
		"ID": 1000,
		"x": 31.2047410593,
		"y": 27.176150423,
		"h": 2.5164835165
	},
	{
		"stop_id": 8587740,
		"ID": 1000,
		"x": 32.6617280493,
		"y": 26.774151769,
		"h": 2.5164835165
	},
	{
		"stop_id": 8587768,
		"ID": 1000,
		"x": 33.3027669403,
		"y": 25.780221727,
		"h": 2.5164835165
	},
	{
		"stop_id": 8588112,
		"ID": 1000,
		"x": 33.4107674193,
		"y": 25.603231931,
		"h": 2.5164835165
	},
	{
		"stop_id": 8588119,
		"ID": 1000,
		"x": 30.7747725453,
		"y": 27.647149745,
		"h": 2.5164835165
	},
	{
		"stop_id": 8588120,
		"ID": 1000,
		"x": 31.7237428643,
		"y": 26.575236278,
		"h": 2.5164835165
	},
	{
		"stop_id": 8588121,
		"ID": 1000,
		"x": 31.9557342363,
		"y": 26.385224673,
		"h": 2.5164835165
	},
	{
		"stop_id": 8588238,
		"ID": 1000,
		"x": 32.8367428263,
		"y": 25.838236593,
		"h": 2.5164835165
	},
	{
		"stop_id": 8592403,
		"ID": 1000,
		"x": 32.2857653963,
		"y": 25.27723063,
		"h": 2.5164835165
	},
	{
		"stop_id": 8592408,
		"ID": 1000,
		"x": 33.0037164723,
		"y": 26.29324489,
		"h": 2.5164835165
	},
	{
		"stop_id": 8592409,
		"ID": 1000,
		"x": 32.6547314273,
		"y": 26.033213532,
		"h": 2.5164835165
	},
	{
		"stop_id": 8592412,
		"ID": 1000,
		"x": 32.9907514353,
		"y": 25.875207595,
		"h": 2.5164835165
	},
	{
		"stop_id": 8592413,
		"ID": 1000,
		"x": 32.5367175063,
		"y": 26.294229241,
		"h": 2.5164835165
	},
	{
		"stop_id": 8592414,
		"ID": 1000,
		"x": 32.5127669223,
		"y": 26.299195649,
		"h": 2.5164835165
	},
	{
		"stop_id": 8592415,
		"ID": 1000,
		"x": 32.9627728443,
		"y": 26.457163222,
		"h": 2.5164835165
	},
	{
		"stop_id": 8592416,
		"ID": 1000,
		"x": 32.3957144763,
		"y": 26.656182142,
		"h": 2.5164835165
	},
	{
		"stop_id": 8592417,
		"ID": 1000,
		"x": 33.0507563453,
		"y": 26.18723825,
		"h": 2.5164835165
	},
	{
		"stop_id": 8592418,
		"ID": 1000,
		"x": 32.4767662103,
		"y": 26.803199209,
		"h": 2.5164835165
	},
	{
		"stop_id": 8592419,
		"ID": 1000,
		"x": 32.5667404273,
		"y": 26.103232275,
		"h": 2.5164835165
	},
	{
		"stop_id": 8592420,
		"ID": 1000,
		"x": 32.8857289953,
		"y": 26.630194237,
		"h": 2.5164835165
	},
	{
		"stop_id": 8594730,
		"ID": 1000,
		"x": 33.0867667893,
		"y": 25.368249345,
		"h": 2.5164835165
	},
	{
		"stop_id": 8594996,
		"ID": 1000,
		"x": 32.3377588363,
		"y": 25.505184572,
		"h": 2.5164835165
	},
	{
		"stop_id": 8594997,
		"ID": 1000,
		"x": 32.5077662933,
		"y": 26.873169677,
		"h": 2.5164835165
	},
	{
		"stop_id": 8595634,
		"ID": 1000,
		"x": 33.0927544733,
		"y": 25.941170742,
		"h": 2.5164835165
	},
	{
		"stop_id": 8503275,
		"ID": 1241,
		"x": 65.9577272313,
		"y": 20.630217079,
		"h": 1.0659340659
	},
	{
		"stop_id": 8530517,
		"ID": 1241,
		"x": 65.9897309843,
		"y": 20.632225461,
		"h": 1.0659340659
	},
	{
		"stop_id": 8530518,
		"ID": 1241,
		"x": 66.3927654163,
		"y": 19.606162896,
		"h": 1.0659340659
	},
	{
		"stop_id": 8503280,
		"ID": 967,
		"x": 27.3787361783,
		"y": 29.308144234,
		"h": 1.8571428571
	},
	{
		"stop_id": 8503281,
		"ID": 967,
		"x": 30.5207356933,
		"y": 32.429180056,
		"h": 1.8571428571
	},
	{
		"stop_id": 8505005,
		"ID": 967,
		"x": 29.0707581113,
		"y": 28.828218736,
		"h": 1.8571428571
	},
	{
		"stop_id": 8530411,
		"ID": 967,
		"x": 31.0657449803,
		"y": 32.276240846,
		"h": 1.8571428571
	},
	{
		"stop_id": 8577478,
		"ID": 967,
		"x": 30.4667014313,
		"y": 29.52518486,
		"h": 1.8571428571
	},
	{
		"stop_id": 8577479,
		"ID": 967,
		"x": 30.1297486363,
		"y": 29.889231749,
		"h": 1.8571428571
	},
	{
		"stop_id": 8577480,
		"ID": 967,
		"x": 30.1167724413,
		"y": 30.397154744,
		"h": 1.8571428571
	},
	{
		"stop_id": 8577481,
		"ID": 967,
		"x": 30.2657011673,
		"y": 30.849148525,
		"h": 1.8571428571
	},
	{
		"stop_id": 8577482,
		"ID": 967,
		"x": 30.6017254753,
		"y": 31.721150424,
		"h": 1.8571428571
	},
	{
		"stop_id": 8577483,
		"ID": 967,
		"x": 31.0237136003,
		"y": 32.268150953,
		"h": 1.8571428571
	},
	{
		"stop_id": 8577485,
		"ID": 967,
		"x": 30.5817709513,
		"y": 32.461237144,
		"h": 1.8571428571
	},
	{
		"stop_id": 8577603,
		"ID": 967,
		"x": 30.6177197723,
		"y": 32.810240301,
		"h": 1.8571428571
	},
	{
		"stop_id": 8577606,
		"ID": 967,
		"x": 31.0977370533,
		"y": 32.290182044,
		"h": 1.8571428571
	},
	{
		"stop_id": 8587532,
		"ID": 967,
		"x": 29.0727098513,
		"y": 28.845147949,
		"h": 1.8571428571
	},
	{
		"stop_id": 8587959,
		"ID": 967,
		"x": 29.5667003093,
		"y": 29.022195913,
		"h": 1.8571428571
	},
	{
		"stop_id": 8588115,
		"ID": 967,
		"x": 29.3377079983,
		"y": 29.008207441,
		"h": 1.8571428571
	},
	{
		"stop_id": 8588116,
		"ID": 967,
		"x": 30.1567658503,
		"y": 28.707181082,
		"h": 1.8571428571
	},
	{
		"stop_id": 8588117,
		"ID": 967,
		"x": 29.7207407203,
		"y": 28.936224255,
		"h": 1.8571428571
	},
	{
		"stop_id": 8588118,
		"ID": 967,
		"x": 30.3017111113,
		"y": 28.384151034,
		"h": 1.8571428571
	},
	{
		"stop_id": 8591758,
		"ID": 967,
		"x": 26.1577296503,
		"y": 29.550153341,
		"h": 1.8571428571
	},
	{
		"stop_id": 8591760,
		"ID": 967,
		"x": 29.7377441813,
		"y": 31.210224404,
		"h": 1.8571428571
	},
	{
		"stop_id": 8591761,
		"ID": 967,
		"x": 30.2777082313,
		"y": 31.930169041,
		"h": 1.8571428571
	},
	{
		"stop_id": 8591762,
		"ID": 967,
		"x": 27.4777099423,
		"y": 29.690177072,
		"h": 1.8571428571
	},
	{
		"stop_id": 8591763,
		"ID": 967,
		"x": 27.7777181673,
		"y": 29.870246267,
		"h": 1.8571428571
	},
	{
		"stop_id": 8591764,
		"ID": 967,
		"x": 26.9577466093,
		"y": 29.470229462,
		"h": 1.8571428571
	},
	{
		"stop_id": 8591765,
		"ID": 967,
		"x": 27.2687615033,
		"y": 29.38214378,
		"h": 1.8571428571
	},
	{
		"stop_id": 8595515,
		"ID": 967,
		"x": 30.6807524663,
		"y": 32.550242099,
		"h": 1.8571428571
	},
	{
		"stop_id": 8503283,
		"ID": 1035,
		"x": 39.3327552403,
		"y": 37.987236726,
		"h": 2.2527472527
	},
	{
		"stop_id": 8503721,
		"ID": 1035,
		"x": 38.7877352613,
		"y": 36.594210455,
		"h": 2.2527472527
	},
	{
		"stop_id": 8503722,
		"ID": 1035,
		"x": 38.4837251073,
		"y": 35.698226017,
		"h": 2.2527472527
	},
	{
		"stop_id": 8503723,
		"ID": 1035,
		"x": 38.1207259313,
		"y": 34.856218074,
		"h": 2.2527472527
	},
	{
		"stop_id": 8503726,
		"ID": 1035,
		"x": 39.2117751563,
		"y": 39.476175077,
		"h": 2.2527472527
	},
	{
		"stop_id": 8503735,
		"ID": 1035,
		"x": 41.1077558853,
		"y": 38.056184288,
		"h": 2.2527472527
	},
	{
		"stop_id": 8503736,
		"ID": 1035,
		"x": 41.2827133863,
		"y": 37.89714619,
		"h": 2.2527472527
	},
	{
		"stop_id": 8503738,
		"ID": 1035,
		"x": 41.7437594293,
		"y": 36.644196978,
		"h": 2.2527472527
	},
	{
		"stop_id": 8503747,
		"ID": 1035,
		"x": 40.0127080073,
		"y": 39.045229052,
		"h": 2.2527472527
	},
	{
		"stop_id": 8557000,
		"ID": 1035,
		"x": 39.4567178823,
		"y": 38.713150041,
		"h": 2.2527472527
	},
	{
		"stop_id": 8557001,
		"ID": 1035,
		"x": 38.8817226343,
		"y": 37.674196657,
		"h": 2.2527472527
	},
	{
		"stop_id": 8557002,
		"ID": 1035,
		"x": 39.0887197993,
		"y": 36.775212407,
		"h": 2.2527472527
	},
	{
		"stop_id": 8573756,
		"ID": 1035,
		"x": 39.3327495703,
		"y": 37.919188258,
		"h": 2.2527472527
	},
	{
		"stop_id": 8573757,
		"ID": 1035,
		"x": 39.1927338343,
		"y": 37.207244783,
		"h": 2.2527472527
	},
	{
		"stop_id": 8573758,
		"ID": 1035,
		"x": 38.2877366093,
		"y": 35.291156992,
		"h": 2.2527472527
	},
	{
		"stop_id": 8573759,
		"ID": 1035,
		"x": 38.0097412413,
		"y": 34.175142116,
		"h": 2.2527472527
	},
	{
		"stop_id": 8573765,
		"ID": 1035,
		"x": 39.3407128533,
		"y": 38.521193459,
		"h": 2.2527472527
	},
	{
		"stop_id": 8573766,
		"ID": 1035,
		"x": 38.9877266943,
		"y": 39.134212704,
		"h": 2.2527472527
	},
	{
		"stop_id": 8573771,
		"ID": 1035,
		"x": 39.7447710973,
		"y": 37.77617577,
		"h": 2.2527472527
	},
	{
		"stop_id": 8573772,
		"ID": 1035,
		"x": 40.4277433843,
		"y": 38.210153349,
		"h": 2.2527472527
	},
	{
		"stop_id": 8573773,
		"ID": 1035,
		"x": 41.6617713923,
		"y": 37.028186676,
		"h": 2.2527472527
	},
	{
		"stop_id": 8573789,
		"ID": 1035,
		"x": 39.8737065943,
		"y": 37.930218,
		"h": 2.2527472527
	},
	{
		"stop_id": 8573790,
		"ID": 1035,
		"x": 39.9697229133,
		"y": 38.812231587,
		"h": 2.2527472527
	},
	{
		"stop_id": 8580524,
		"ID": 1035,
		"x": 39.2947033173,
		"y": 38.2811463,
		"h": 2.2527472527
	},
	{
		"stop_id": 8580858,
		"ID": 1035,
		"x": 40.9597521863,
		"y": 38.273168987,
		"h": 2.2527472527
	},
	{
		"stop_id": 8581977,
		"ID": 1035,
		"x": 39.1257349273,
		"y": 38.828172988,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582622,
		"ID": 1035,
		"x": 39.1617279953,
		"y": 37.27822472,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582623,
		"ID": 1035,
		"x": 38.9247410543,
		"y": 37.464204591,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582624,
		"ID": 1035,
		"x": 38.7777215013,
		"y": 37.300210829,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582625,
		"ID": 1035,
		"x": 38.7277555973,
		"y": 36.930234114,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582626,
		"ID": 1035,
		"x": 38.9877160793,
		"y": 36.87016054,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582627,
		"ID": 1035,
		"x": 38.9077193243,
		"y": 38.230243957,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582629,
		"ID": 1035,
		"x": 39.1647660533,
		"y": 38.61622567,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582632,
		"ID": 1035,
		"x": 39.7007402043,
		"y": 38.154154107,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582633,
		"ID": 1035,
		"x": 39.7617147473,
		"y": 38.433149011,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582634,
		"ID": 1035,
		"x": 39.9757002153,
		"y": 38.496217088,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582636,
		"ID": 1035,
		"x": 39.9877697233,
		"y": 39.030245131,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582637,
		"ID": 1035,
		"x": 38.6747172513,
		"y": 37.907160443,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582943,
		"ID": 1035,
		"x": 38.9957512523,
		"y": 38.106169979,
		"h": 2.2527472527
	},
	{
		"stop_id": 8503284,
		"ID": 1036,
		"x": 37.6307120523,
		"y": 41.049232485,
		"h": 2.021978022
	},
	{
		"stop_id": 8503285,
		"ID": 1036,
		"x": 36.5837545113,
		"y": 43.259220767,
		"h": 2.021978022
	},
	{
		"stop_id": 8503288,
		"ID": 1036,
		"x": 37.7337652833,
		"y": 45.394149664,
		"h": 2.021978022
	},
	{
		"stop_id": 8503727,
		"ID": 1036,
		"x": 38.5397182263,
		"y": 39.855204872,
		"h": 2.021978022
	},
	{
		"stop_id": 8503728,
		"ID": 1036,
		"x": 36.9527260103,
		"y": 40.046248421,
		"h": 2.021978022
	},
	{
		"stop_id": 8503761,
		"ID": 1036,
		"x": 39.4327648463,
		"y": 44.507251096,
		"h": 2.021978022
	},
	{
		"stop_id": 8573767,
		"ID": 1036,
		"x": 38.1617412203,
		"y": 40.21723642,
		"h": 2.021978022
	},
	{
		"stop_id": 8573768,
		"ID": 1036,
		"x": 37.4017639693,
		"y": 40.002192339,
		"h": 2.021978022
	},
	{
		"stop_id": 8573769,
		"ID": 1036,
		"x": 37.1687143043,
		"y": 40.436147502,
		"h": 2.021978022
	},
	{
		"stop_id": 8573770,
		"ID": 1036,
		"x": 37.6647572223,
		"y": 41.133182584,
		"h": 2.021978022
	},
	{
		"stop_id": 8573807,
		"ID": 1036,
		"x": 40.6717462693,
		"y": 44.579194152,
		"h": 2.021978022
	},
	{
		"stop_id": 8573808,
		"ID": 1036,
		"x": 40.4597046173,
		"y": 44.603192605,
		"h": 2.021978022
	},
	{
		"stop_id": 8573809,
		"ID": 1036,
		"x": 39.0707633263,
		"y": 44.218241435,
		"h": 2.021978022
	},
	{
		"stop_id": 8573810,
		"ID": 1036,
		"x": 38.7497467223,
		"y": 44.162212243,
		"h": 2.021978022
	},
	{
		"stop_id": 8573811,
		"ID": 1036,
		"x": 37.9457029603,
		"y": 43.962147648,
		"h": 2.021978022
	},
	{
		"stop_id": 8573812,
		"ID": 1036,
		"x": 37.0227599293,
		"y": 44.096164631,
		"h": 2.021978022
	},
	{
		"stop_id": 8573813,
		"ID": 1036,
		"x": 36.6377264443,
		"y": 44.111149035,
		"h": 2.021978022
	},
	{
		"stop_id": 8573814,
		"ID": 1036,
		"x": 36.6327758553,
		"y": 43.930161342,
		"h": 2.021978022
	},
	{
		"stop_id": 8573815,
		"ID": 1036,
		"x": 36.3987567083,
		"y": 43.869221272,
		"h": 2.021978022
	},
	{
		"stop_id": 8573816,
		"ID": 1036,
		"x": 36.3137184493,
		"y": 43.605214753,
		"h": 2.021978022
	},
	{
		"stop_id": 8573818,
		"ID": 1036,
		"x": 36.7817195643,
		"y": 43.067179634,
		"h": 2.021978022
	},
	{
		"stop_id": 8573819,
		"ID": 1036,
		"x": 36.6257671253,
		"y": 43.249227074,
		"h": 2.021978022
	},
	{
		"stop_id": 8577515,
		"ID": 1036,
		"x": 37.3157247893,
		"y": 45.472149244,
		"h": 2.021978022
	},
	{
		"stop_id": 8577516,
		"ID": 1036,
		"x": 37.1317488293,
		"y": 45.130237492,
		"h": 2.021978022
	},
	{
		"stop_id": 8577517,
		"ID": 1036,
		"x": 37.0057133603,
		"y": 44.920146523,
		"h": 2.021978022
	},
	{
		"stop_id": 8577518,
		"ID": 1036,
		"x": 36.7207736363,
		"y": 44.800211677,
		"h": 2.021978022
	},
	{
		"stop_id": 8577524,
		"ID": 1036,
		"x": 37.4187086533,
		"y": 44.944227006,
		"h": 2.021978022
	},
	{
		"stop_id": 8577525,
		"ID": 1036,
		"x": 37.4337493713,
		"y": 44.775239703,
		"h": 2.021978022
	},
	{
		"stop_id": 8581279,
		"ID": 1036,
		"x": 37.6947495403,
		"y": 45.39317652,
		"h": 2.021978022
	},
	{
		"stop_id": 8581280,
		"ID": 1036,
		"x": 37.2537615473,
		"y": 45.103205878,
		"h": 2.021978022
	},
	{
		"stop_id": 8583204,
		"ID": 1036,
		"x": 39.6947311093,
		"y": 44.53019535,
		"h": 2.021978022
	},
	{
		"stop_id": 8588336,
		"ID": 1036,
		"x": 37.3877394313,
		"y": 45.253166434,
		"h": 2.021978022
	},
	{
		"stop_id": 8503303,
		"ID": 1041,
		"x": 37.1717149843,
		"y": 69.112225373,
		"h": 1.8571428571
	},
	{
		"stop_id": 8503371,
		"ID": 1041,
		"x": 36.7597080383,
		"y": 69.941150759,
		"h": 1.8571428571
	},
	{
		"stop_id": 8503373,
		"ID": 1041,
		"x": 40.2167388553,
		"y": 71.691190906,
		"h": 1.8571428571
	},
	{
		"stop_id": 8503376,
		"ID": 1041,
		"x": 36.6887380953,
		"y": 72.050210975,
		"h": 1.8571428571
	},
	{
		"stop_id": 8503382,
		"ID": 1041,
		"x": 37.5017622613,
		"y": 69.019225993,
		"h": 1.8571428571
	},
	{
		"stop_id": 8503561,
		"ID": 1041,
		"x": 40.1017359213,
		"y": 69.217173314,
		"h": 1.8571428571
	},
	{
		"stop_id": 8573532,
		"ID": 1041,
		"x": 40.2177210723,
		"y": 68.620212129,
		"h": 1.8571428571
	},
	{
		"stop_id": 8573533,
		"ID": 1041,
		"x": 40.2017500093,
		"y": 69.973236478,
		"h": 1.8571428571
	},
	{
		"stop_id": 8573534,
		"ID": 1041,
		"x": 40.4677370723,
		"y": 71.230174707,
		"h": 1.8571428571
	},
	{
		"stop_id": 8573535,
		"ID": 1041,
		"x": 40.1977349273,
		"y": 72.030141195,
		"h": 1.8571428571
	},
	{
		"stop_id": 8573536,
		"ID": 1041,
		"x": 40.2827112813,
		"y": 72.810200697,
		"h": 1.8571428571
	},
	{
		"stop_id": 8573537,
		"ID": 1041,
		"x": 40.7607640783,
		"y": 73.353175549,
		"h": 1.8571428571
	},
	{
		"stop_id": 8575923,
		"ID": 1041,
		"x": 36.7607390323,
		"y": 69.748238536,
		"h": 1.8571428571
	},
	{
		"stop_id": 8575924,
		"ID": 1041,
		"x": 36.4907504643,
		"y": 69.437159653,
		"h": 1.8571428571
	},
	{
		"stop_id": 8575926,
		"ID": 1041,
		"x": 36.9117071373,
		"y": 68.730235821,
		"h": 1.8571428571
	},
	{
		"stop_id": 8575927,
		"ID": 1041,
		"x": 37.1617387373,
		"y": 69.122181135,
		"h": 1.8571428571
	},
	{
		"stop_id": 8575929,
		"ID": 1041,
		"x": 38.8127709813,
		"y": 69.577212827,
		"h": 1.8571428571
	},
	{
		"stop_id": 8575930,
		"ID": 1041,
		"x": 38.7717646403,
		"y": 70.957177674,
		"h": 1.8571428571
	},
	{
		"stop_id": 8575931,
		"ID": 1041,
		"x": 39.2817541723,
		"y": 70.984146321,
		"h": 1.8571428571
	},
	{
		"stop_id": 8575934,
		"ID": 1041,
		"x": 40.6717715713,
		"y": 71.511187734,
		"h": 1.8571428571
	},
	{
		"stop_id": 8575935,
		"ID": 1041,
		"x": 41.5137415573,
		"y": 71.04314542,
		"h": 1.8571428571
	},
	{
		"stop_id": 8575936,
		"ID": 1041,
		"x": 40.5617565813,
		"y": 70.638182592,
		"h": 1.8571428571
	},
	{
		"stop_id": 8575947,
		"ID": 1041,
		"x": 37.4017705433,
		"y": 72.889194865,
		"h": 1.8571428571
	},
	{
		"stop_id": 8575948,
		"ID": 1041,
		"x": 38.1877541523,
		"y": 73.592145136,
		"h": 1.8571428571
	},
	{
		"stop_id": 8587857,
		"ID": 1041,
		"x": 38.6407121273,
		"y": 74.209147817,
		"h": 1.8571428571
	},
	{
		"stop_id": 8594339,
		"ID": 1041,
		"x": 37.3037302443,
		"y": 68.993181502,
		"h": 1.8571428571
	},
	{
		"stop_id": 8595082,
		"ID": 1041,
		"x": 35.8287092763,
		"y": 71.591243656,
		"h": 1.8571428571
	},
	{
		"stop_id": 8503304,
		"ID": 1008,
		"x": 35.7997245363,
		"y": 73.984222133,
		"h": 2.4175824176
	},
	{
		"stop_id": 8503374,
		"ID": 1008,
		"x": 35.4877435023,
		"y": 73.128185471,
		"h": 2.4175824176
	},
	{
		"stop_id": 8503377,
		"ID": 1008,
		"x": 33.2497715873,
		"y": 72.680158266,
		"h": 2.4175824176
	},
	{
		"stop_id": 8503380,
		"ID": 1008,
		"x": 34.8497596003,
		"y": 74.366161267,
		"h": 2.4175824176
	},
	{
		"stop_id": 8503381,
		"ID": 1008,
		"x": 35.7087266003,
		"y": 72.850190102,
		"h": 2.4175824176
	},
	{
		"stop_id": 8506960,
		"ID": 1008,
		"x": 33.5727374413,
		"y": 76.084145562,
		"h": 2.4175824176
	},
	{
		"stop_id": 8506961,
		"ID": 1008,
		"x": 35.5547311693,
		"y": 76.709223808,
		"h": 2.4175824176
	},
	{
		"stop_id": 8575909,
		"ID": 1008,
		"x": 34.1547420773,
		"y": 71.934185115,
		"h": 2.4175824176
	},
	{
		"stop_id": 8575937,
		"ID": 1008,
		"x": 33.7777406833,
		"y": 71.565154585,
		"h": 2.4175824176
	},
	{
		"stop_id": 8575938,
		"ID": 1008,
		"x": 33.3767165573,
		"y": 71.823149361,
		"h": 2.4175824176
	},
	{
		"stop_id": 8575939,
		"ID": 1008,
		"x": 33.7057337233,
		"y": 72.546230093,
		"h": 2.4175824176
	},
	{
		"stop_id": 8575940,
		"ID": 1008,
		"x": 34.3727113513,
		"y": 72.219201253,
		"h": 2.4175824176
	},
	{
		"stop_id": 8575941,
		"ID": 1008,
		"x": 34.0527588483,
		"y": 73.427185806,
		"h": 2.4175824176
	},
	{
		"stop_id": 8575942,
		"ID": 1008,
		"x": 35.1307482403,
		"y": 74.104227253,
		"h": 2.4175824176
	},
	{
		"stop_id": 8575943,
		"ID": 1008,
		"x": 35.2637141853,
		"y": 72.958230796,
		"h": 2.4175824176
	},
	{
		"stop_id": 8575944,
		"ID": 1008,
		"x": 35.7977263393,
		"y": 74.005206545,
		"h": 2.4175824176
	},
	{
		"stop_id": 8575946,
		"ID": 1008,
		"x": 34.7727262553,
		"y": 71.912218832,
		"h": 2.4175824176
	},
	{
		"stop_id": 8576167,
		"ID": 1008,
		"x": 30.4477065663,
		"y": 74.057229318,
		"h": 2.4175824176
	},
	{
		"stop_id": 8576168,
		"ID": 1008,
		"x": 30.7537442523,
		"y": 74.448204069,
		"h": 2.4175824176
	},
	{
		"stop_id": 8576169,
		"ID": 1008,
		"x": 30.8327543993,
		"y": 75.159191128,
		"h": 2.4175824176
	},
	{
		"stop_id": 8576170,
		"ID": 1008,
		"x": 31.7047283433,
		"y": 73.688220519,
		"h": 2.4175824176
	},
	{
		"stop_id": 8576171,
		"ID": 1008,
		"x": 32.3427469893,
		"y": 74.818217375,
		"h": 2.4175824176
	},
	{
		"stop_id": 8576172,
		"ID": 1008,
		"x": 32.4447325673,
		"y": 74.942235496,
		"h": 2.4175824176
	},
	{
		"stop_id": 8576173,
		"ID": 1008,
		"x": 32.4317352773,
		"y": 74.905226204,
		"h": 2.4175824176
	},
	{
		"stop_id": 8576174,
		"ID": 1008,
		"x": 33.1307044453,
		"y": 75.958204728,
		"h": 2.4175824176
	},
	{
		"stop_id": 8576176,
		"ID": 1008,
		"x": 34.0267596063,
		"y": 76.028165001,
		"h": 2.4175824176
	},
	{
		"stop_id": 8588279,
		"ID": 1008,
		"x": 33.0017435463,
		"y": 71.557170259,
		"h": 2.4175824176
	},
	{
		"stop_id": 8588311,
		"ID": 1008,
		"x": 34.3637351293,
		"y": 71.640160436,
		"h": 2.4175824176
	},
	{
		"stop_id": 8588312,
		"ID": 1008,
		"x": 34.5887044963,
		"y": 71.751159064,
		"h": 2.4175824176
	},
	{
		"stop_id": 8588469,
		"ID": 1008,
		"x": 31.8927701323,
		"y": 72.962226903,
		"h": 2.4175824176
	},
	{
		"stop_id": 8588502,
		"ID": 1008,
		"x": 34.2947651923,
		"y": 74.403238794,
		"h": 2.4175824176
	},
	{
		"stop_id": 8588735,
		"ID": 1008,
		"x": 35.4277349463,
		"y": 72.802185631,
		"h": 2.4175824176
	},
	{
		"stop_id": 8590506,
		"ID": 1008,
		"x": 33.3767075573,
		"y": 76.012223568,
		"h": 2.4175824176
	},
	{
		"stop_id": 8590710,
		"ID": 1008,
		"x": 33.2037241683,
		"y": 72.60515451,
		"h": 2.4175824176
	},
	{
		"stop_id": 8590924,
		"ID": 1008,
		"x": 35.2737700413,
		"y": 77.12114764,
		"h": 2.4175824176
	},
	{
		"stop_id": 8590940,
		"ID": 1008,
		"x": 35.0467011333,
		"y": 77.211245205,
		"h": 2.4175824176
	},
	{
		"stop_id": 8590943,
		"ID": 1008,
		"x": 35.2837195243,
		"y": 76.741225234,
		"h": 2.4175824176
	},
	{
		"stop_id": 8591002,
		"ID": 1008,
		"x": 35.4337058563,
		"y": 76.467193704,
		"h": 2.4175824176
	},
	{
		"stop_id": 8591019,
		"ID": 1008,
		"x": 35.1407731523,
		"y": 76.953212637,
		"h": 2.4175824176
	},
	{
		"stop_id": 8591835,
		"ID": 1008,
		"x": 34.3297378303,
		"y": 75.827145819,
		"h": 2.4175824176
	},
	{
		"stop_id": 8595267,
		"ID": 1008,
		"x": 31.4857047133,
		"y": 73.237156733,
		"h": 2.4175824176
	},
	{
		"stop_id": 8595538,
		"ID": 1008,
		"x": 33.3947670303,
		"y": 71.889151357,
		"h": 2.4175824176
	},
	{
		"stop_id": 8595706,
		"ID": 1008,
		"x": 34.6517057153,
		"y": 71.822218409,
		"h": 2.4175824176
	},
	{
		"stop_id": 8595707,
		"ID": 1008,
		"x": 31.5797111193,
		"y": 73.182229451,
		"h": 2.4175824176
	},
	{
		"stop_id": 8503313,
		"ID": 910,
		"x": 20.4947688913,
		"y": 77.608146965,
		"h": 2.1538461538
	},
	{
		"stop_id": 8503314,
		"ID": 910,
		"x": 19.4077551003,
		"y": 76.577167621,
		"h": 2.1538461538
	},
	{
		"stop_id": 8503315,
		"ID": 910,
		"x": 17.1957146173,
		"y": 77.002213006,
		"h": 2.1538461538
	},
	{
		"stop_id": 8503316,
		"ID": 910,
		"x": 16.2367228503,
		"y": 77.831230121,
		"h": 2.1538461538
	},
	{
		"stop_id": 8503860,
		"ID": 910,
		"x": 18.2697318083,
		"y": 79.086194575,
		"h": 2.1538461538
	},
	{
		"stop_id": 8503871,
		"ID": 910,
		"x": 20.1197657673,
		"y": 79.412238863,
		"h": 2.1538461538
	},
	{
		"stop_id": 8503885,
		"ID": 910,
		"x": 19.7867271133,
		"y": 77.019251009,
		"h": 2.1538461538
	},
	{
		"stop_id": 8557033,
		"ID": 910,
		"x": 19.5357174073,
		"y": 74.459163475,
		"h": 2.1538461538
	},
	{
		"stop_id": 8557034,
		"ID": 910,
		"x": 18.1267276263,
		"y": 75.146206218,
		"h": 2.1538461538
	},
	{
		"stop_id": 8573236,
		"ID": 910,
		"x": 20.5977752173,
		"y": 76.700182777,
		"h": 2.1538461538
	},
	{
		"stop_id": 8573261,
		"ID": 910,
		"x": 19.8577407543,
		"y": 78.480212974,
		"h": 2.1538461538
	},
	{
		"stop_id": 8573262,
		"ID": 910,
		"x": 20.1107553703,
		"y": 78.238213876,
		"h": 2.1538461538
	},
	{
		"stop_id": 8573263,
		"ID": 910,
		"x": 20.4827121803,
		"y": 77.980157776,
		"h": 2.1538461538
	},
	{
		"stop_id": 8573264,
		"ID": 910,
		"x": 19.1327676853,
		"y": 76.830245039,
		"h": 2.1538461538
	},
	{
		"stop_id": 8573265,
		"ID": 910,
		"x": 18.0827494263,
		"y": 77.13024036,
		"h": 2.1538461538
	},
	{
		"stop_id": 8573273,
		"ID": 910,
		"x": 16.8197519623,
		"y": 78.822164367,
		"h": 2.1538461538
	},
	{
		"stop_id": 8573274,
		"ID": 910,
		"x": 16.3577545193,
		"y": 78.230199016,
		"h": 2.1538461538
	},
	{
		"stop_id": 8573275,
		"ID": 910,
		"x": 16.3327198893,
		"y": 77.78020244,
		"h": 2.1538461538
	},
	{
		"stop_id": 8573276,
		"ID": 910,
		"x": 16.7327096473,
		"y": 77.080160536,
		"h": 2.1538461538
	},
	{
		"stop_id": 8573277,
		"ID": 910,
		"x": 17.1577363723,
		"y": 77.059207071,
		"h": 2.1538461538
	},
	{
		"stop_id": 8576282,
		"ID": 910,
		"x": 16.8617503323,
		"y": 76.283227009,
		"h": 2.1538461538
	},
	{
		"stop_id": 8576283,
		"ID": 910,
		"x": 16.7637502953,
		"y": 76.883190477,
		"h": 2.1538461538
	},
	{
		"stop_id": 8576285,
		"ID": 910,
		"x": 16.6887494363,
		"y": 76.947158787,
		"h": 2.1538461538
	},
	{
		"stop_id": 8576286,
		"ID": 910,
		"x": 16.5217328683,
		"y": 76.910198781,
		"h": 2.1538461538
	},
	{
		"stop_id": 8576287,
		"ID": 910,
		"x": 16.0827058823,
		"y": 76.970159237,
		"h": 2.1538461538
	},
	{
		"stop_id": 8576289,
		"ID": 910,
		"x": 15.4497393753,
		"y": 77.030240933,
		"h": 2.1538461538
	},
	{
		"stop_id": 8582720,
		"ID": 910,
		"x": 20.4647481523,
		"y": 77.943219252,
		"h": 2.1538461538
	},
	{
		"stop_id": 8582751,
		"ID": 910,
		"x": 18.2697651193,
		"y": 79.015140583,
		"h": 2.1538461538
	},
	{
		"stop_id": 8583769,
		"ID": 910,
		"x": 20.1317301333,
		"y": 77.589221603,
		"h": 2.1538461538
	},
	{
		"stop_id": 8590723,
		"ID": 910,
		"x": 19.3967528243,
		"y": 76.571238222,
		"h": 2.1538461538
	},
	{
		"stop_id": 8590729,
		"ID": 910,
		"x": 20.3187554683,
		"y": 75.142216554,
		"h": 2.1538461538
	},
	{
		"stop_id": 8590730,
		"ID": 910,
		"x": 20.5127004753,
		"y": 75.525244431,
		"h": 2.1538461538
	},
	{
		"stop_id": 8590731,
		"ID": 910,
		"x": 20.1997402923,
		"y": 75.730165892,
		"h": 2.1538461538
	},
	{
		"stop_id": 8590732,
		"ID": 910,
		"x": 20.3317383763,
		"y": 75.453183753,
		"h": 2.1538461538
	},
	{
		"stop_id": 8590733,
		"ID": 910,
		"x": 20.2607344343,
		"y": 75.875211272,
		"h": 2.1538461538
	},
	{
		"stop_id": 8594552,
		"ID": 910,
		"x": 17.5357756683,
		"y": 76.850194577,
		"h": 2.1538461538
	},
	{
		"stop_id": 8503317,
		"ID": 882,
		"x": 13.5847112043,
		"y": 78.686199481,
		"h": 1.5934065934
	},
	{
		"stop_id": 8503318,
		"ID": 882,
		"x": 11.2577124173,
		"y": 79.540241641,
		"h": 1.5934065934
	},
	{
		"stop_id": 8503319,
		"ID": 882,
		"x": 10.3887638713,
		"y": 80.118201795,
		"h": 1.5934065934
	},
	{
		"stop_id": 8572586,
		"ID": 882,
		"x": 10.4087005653,
		"y": 80.133227248,
		"h": 1.5934065934
	},
	{
		"stop_id": 8573268,
		"ID": 882,
		"x": 15.6077627643,
		"y": 81.5801578,
		"h": 1.5934065934
	},
	{
		"stop_id": 8573269,
		"ID": 882,
		"x": 15.5077249643,
		"y": 81.930153163,
		"h": 1.5934065934
	},
	{
		"stop_id": 8573270,
		"ID": 882,
		"x": 15.8327093913,
		"y": 81.830220212,
		"h": 1.5934065934
	},
	{
		"stop_id": 8573272,
		"ID": 882,
		"x": 16.7287712503,
		"y": 79.890247929,
		"h": 1.5934065934
	},
	{
		"stop_id": 8575017,
		"ID": 882,
		"x": 12.0877609973,
		"y": 78.680168131,
		"h": 1.5934065934
	},
	{
		"stop_id": 8575027,
		"ID": 882,
		"x": 12.5177160503,
		"y": 79.200239047,
		"h": 1.5934065934
	},
	{
		"stop_id": 8575115,
		"ID": 882,
		"x": 12.9207300203,
		"y": 78.994241216,
		"h": 1.5934065934
	},
	{
		"stop_id": 8580446,
		"ID": 882,
		"x": 13.4077434583,
		"y": 78.920185842,
		"h": 1.5934065934
	},
	{
		"stop_id": 8580453,
		"ID": 882,
		"x": 13.9077581963,
		"y": 78.880246943,
		"h": 1.5934065934
	},
	{
		"stop_id": 8581673,
		"ID": 882,
		"x": 11.1077611563,
		"y": 79.730142669,
		"h": 1.5934065934
	},
	{
		"stop_id": 8582400,
		"ID": 882,
		"x": 13.1347385023,
		"y": 79.079159443,
		"h": 1.5934065934
	},
	{
		"stop_id": 8582401,
		"ID": 882,
		"x": 13.5737354523,
		"y": 78.933250066,
		"h": 1.5934065934
	},
	{
		"stop_id": 8583692,
		"ID": 882,
		"x": 15.5237425783,
		"y": 77.908177848,
		"h": 1.5934065934
	},
	{
		"stop_id": 8587321,
		"ID": 882,
		"x": 13.5837344073,
		"y": 78.704200967,
		"h": 1.5934065934
	},
	{
		"stop_id": 8587322,
		"ID": 882,
		"x": 12.5177677793,
		"y": 78.610239641,
		"h": 1.5934065934
	},
	{
		"stop_id": 8503368,
		"ID": 1213,
		"x": 62.3097167933,
		"y": 45.205205201,
		"h": 1.2637362637
	},
	{
		"stop_id": 8503384,
		"ID": 1213,
		"x": 61.3237015303,
		"y": 47.08622415,
		"h": 1.2637362637
	},
	{
		"stop_id": 8506485,
		"ID": 1213,
		"x": 62.2197370743,
		"y": 44.296191289,
		"h": 1.2637362637
	},
	{
		"stop_id": 8506496,
		"ID": 1213,
		"x": 62.7347212903,
		"y": 43.403169178,
		"h": 1.2637362637
	},
	{
		"stop_id": 8506497,
		"ID": 1213,
		"x": 62.7077168453,
		"y": 42.980166174,
		"h": 1.2637362637
	},
	{
		"stop_id": 8573864,
		"ID": 1213,
		"x": 61.6307425353,
		"y": 46.764224654,
		"h": 1.2637362637
	},
	{
		"stop_id": 8573865,
		"ID": 1213,
		"x": 62.1247253533,
		"y": 45.628194873,
		"h": 1.2637362637
	},
	{
		"stop_id": 8573866,
		"ID": 1213,
		"x": 62.3037590023,
		"y": 44.886161829,
		"h": 1.2637362637
	},
	{
		"stop_id": 8573867,
		"ID": 1213,
		"x": 62.4657645093,
		"y": 43.960193955,
		"h": 1.2637362637
	},
	{
		"stop_id": 8503375,
		"ID": 1042,
		"x": 38.7267458833,
		"y": 74.514156185,
		"h": 3.7362637363
	},
	{
		"stop_id": 8506000,
		"ID": 1042,
		"x": 37.0877720743,
		"y": 79.287193414,
		"h": 3.7362637363
	},
	{
		"stop_id": 8506001,
		"ID": 1042,
		"x": 39.1427415503,
		"y": 79.145180714,
		"h": 3.7362637363
	},
	{
		"stop_id": 8506002,
		"ID": 1042,
		"x": 40.3507753013,
		"y": 77.90714769,
		"h": 3.7362637363
	},
	{
		"stop_id": 8506003,
		"ID": 1042,
		"x": 39.9057515973,
		"y": 75.424173244,
		"h": 3.7362637363
	},
	{
		"stop_id": 8506044,
		"ID": 1042,
		"x": 36.0137326713,
		"y": 78.099195087,
		"h": 3.7362637363
	},
	{
		"stop_id": 8506899,
		"ID": 1042,
		"x": 37.1287171833,
		"y": 79.290199517,
		"h": 3.7362637363
	},
	{
		"stop_id": 8516218,
		"ID": 1042,
		"x": 40.5137235743,
		"y": 79.481198741,
		"h": 3.7362637363
	},
	{
		"stop_id": 8573656,
		"ID": 1042,
		"x": 37.7797303223,
		"y": 79.322143814,
		"h": 3.7362637363
	},
	{
		"stop_id": 8573657,
		"ID": 1042,
		"x": 38.4117306463,
		"y": 78.597226771,
		"h": 3.7362637363
	},
	{
		"stop_id": 8573658,
		"ID": 1042,
		"x": 38.9127313693,
		"y": 78.238155493,
		"h": 3.7362637363
	},
	{
		"stop_id": 8573659,
		"ID": 1042,
		"x": 39.9567030643,
		"y": 77.420208428,
		"h": 3.7362637363
	},
	{
		"stop_id": 8573660,
		"ID": 1042,
		"x": 40.3337736973,
		"y": 76.894144067,
		"h": 3.7362637363
	},
	{
		"stop_id": 8573661,
		"ID": 1042,
		"x": 40.5987518703,
		"y": 76.335175285,
		"h": 3.7362637363
	},
	{
		"stop_id": 8573662,
		"ID": 1042,
		"x": 41.1827075423,
		"y": 76.330211068,
		"h": 3.7362637363
	},
	{
		"stop_id": 8573671,
		"ID": 1042,
		"x": 36.8867053683,
		"y": 79.675221437,
		"h": 3.7362637363
	},
	{
		"stop_id": 8573691,
		"ID": 1042,
		"x": 37.4427368693,
		"y": 79.858146208,
		"h": 3.7362637363
	},
	{
		"stop_id": 8576177,
		"ID": 1042,
		"x": 35.5737437543,
		"y": 77.419210739,
		"h": 3.7362637363
	},
	{
		"stop_id": 8576180,
		"ID": 1042,
		"x": 36.3697358453,
		"y": 78.807206308,
		"h": 3.7362637363
	},
	{
		"stop_id": 8576181,
		"ID": 1042,
		"x": 36.7687160963,
		"y": 79.065243951,
		"h": 3.7362637363
	},
	{
		"stop_id": 8576746,
		"ID": 1042,
		"x": 39.5487195313,
		"y": 77.780197834,
		"h": 3.7362637363
	},
	{
		"stop_id": 8580264,
		"ID": 1042,
		"x": 40.1807305163,
		"y": 80.118200385,
		"h": 3.7362637363
	},
	{
		"stop_id": 8580265,
		"ID": 1042,
		"x": 39.8427032693,
		"y": 80.034208286,
		"h": 3.7362637363
	},
	{
		"stop_id": 8580430,
		"ID": 1042,
		"x": 37.5097168233,
		"y": 79.011223459,
		"h": 3.7362637363
	},
	{
		"stop_id": 8580455,
		"ID": 1042,
		"x": 38.5717035753,
		"y": 78.48123275,
		"h": 3.7362637363
	},
	{
		"stop_id": 8580456,
		"ID": 1042,
		"x": 39.3017740953,
		"y": 77.956202762,
		"h": 3.7362637363
	},
	{
		"stop_id": 8580458,
		"ID": 1042,
		"x": 37.7667154403,
		"y": 79.04214555,
		"h": 3.7362637363
	},
	{
		"stop_id": 8580459,
		"ID": 1042,
		"x": 39.7807300983,
		"y": 77.601171624,
		"h": 3.7362637363
	},
	{
		"stop_id": 8580461,
		"ID": 1042,
		"x": 38.0967516223,
		"y": 78.776155413,
		"h": 3.7362637363
	},
	{
		"stop_id": 8580472,
		"ID": 1042,
		"x": 37.3517146633,
		"y": 79.257161695,
		"h": 3.7362637363
	},
	{
		"stop_id": 8580495,
		"ID": 1042,
		"x": 39.8577030413,
		"y": 75.680238574,
		"h": 3.7362637363
	},
	{
		"stop_id": 8580521,
		"ID": 1042,
		"x": 37.6077220993,
		"y": 79.320198071,
		"h": 3.7362637363
	},
	{
		"stop_id": 8587017,
		"ID": 1042,
		"x": 39.7577294873,
		"y": 80.100165926,
		"h": 3.7362637363
	},
	{
		"stop_id": 8588552,
		"ID": 1042,
		"x": 37.1737662323,
		"y": 79.369223885,
		"h": 3.7362637363
	},
	{
		"stop_id": 8590919,
		"ID": 1042,
		"x": 40.5847569913,
		"y": 79.527218713,
		"h": 3.7362637363
	},
	{
		"stop_id": 8590922,
		"ID": 1042,
		"x": 38.6607334143,
		"y": 79.512221578,
		"h": 3.7362637363
	},
	{
		"stop_id": 8590923,
		"ID": 1042,
		"x": 37.5467560413,
		"y": 79.691164259,
		"h": 3.7362637363
	},
	{
		"stop_id": 8590925,
		"ID": 1042,
		"x": 37.2647271283,
		"y": 78.170185299,
		"h": 3.7362637363
	},
	{
		"stop_id": 8590926,
		"ID": 1042,
		"x": 38.6647504803,
		"y": 79.325246539,
		"h": 3.7362637363
	},
	{
		"stop_id": 8590927,
		"ID": 1042,
		"x": 37.3057508033,
		"y": 76.823213568,
		"h": 3.7362637363
	},
	{
		"stop_id": 8590928,
		"ID": 1042,
		"x": 37.0517159793,
		"y": 77.236164098,
		"h": 3.7362637363
	},
	{
		"stop_id": 8590929,
		"ID": 1042,
		"x": 36.5897068723,
		"y": 79.016175515,
		"h": 3.7362637363
	},
	{
		"stop_id": 8590930,
		"ID": 1042,
		"x": 37.2207652423,
		"y": 80.064227192,
		"h": 3.7362637363
	},
	{
		"stop_id": 8590935,
		"ID": 1042,
		"x": 38.8877241093,
		"y": 78.874146487,
		"h": 3.7362637363
	},
	{
		"stop_id": 8590937,
		"ID": 1042,
		"x": 39.7817468053,
		"y": 78.36914934,
		"h": 3.7362637363
	},
	{
		"stop_id": 8590945,
		"ID": 1042,
		"x": 36.1177279163,
		"y": 78.565144212,
		"h": 3.7362637363
	},
	{
		"stop_id": 8590947,
		"ID": 1042,
		"x": 40.7627718163,
		"y": 77.1671925,
		"h": 3.7362637363
	},
	{
		"stop_id": 8590948,
		"ID": 1042,
		"x": 39.6617630373,
		"y": 78.642244634,
		"h": 3.7362637363
	},
	{
		"stop_id": 8590949,
		"ID": 1042,
		"x": 38.6577695193,
		"y": 79.079151471,
		"h": 3.7362637363
	},
	{
		"stop_id": 8590951,
		"ID": 1042,
		"x": 39.0767426703,
		"y": 78.125244786,
		"h": 3.7362637363
	},
	{
		"stop_id": 8590953,
		"ID": 1042,
		"x": 37.5997491383,
		"y": 80.042211606,
		"h": 3.7362637363
	},
	{
		"stop_id": 8590955,
		"ID": 1042,
		"x": 38.9037557133,
		"y": 79.846209531,
		"h": 3.7362637363
	},
	{
		"stop_id": 8590961,
		"ID": 1042,
		"x": 39.4137672813,
		"y": 79.808149909,
		"h": 3.7362637363
	},
	{
		"stop_id": 8590964,
		"ID": 1042,
		"x": 39.9687381343,
		"y": 79.42816622,
		"h": 3.7362637363
	},
	{
		"stop_id": 8590965,
		"ID": 1042,
		"x": 36.7697294973,
		"y": 78.172203419,
		"h": 3.7362637363
	},
	{
		"stop_id": 8590966,
		"ID": 1042,
		"x": 36.9527288313,
		"y": 78.209221123,
		"h": 3.7362637363
	},
	{
		"stop_id": 8590967,
		"ID": 1042,
		"x": 38.2327080143,
		"y": 79.808248045,
		"h": 3.7362637363
	},
	{
		"stop_id": 8590972,
		"ID": 1042,
		"x": 37.8637690033,
		"y": 79.969169279,
		"h": 3.7362637363
	},
	{
		"stop_id": 8590976,
		"ID": 1042,
		"x": 37.4787555063,
		"y": 78.167251279,
		"h": 3.7362637363
	},
	{
		"stop_id": 8590979,
		"ID": 1042,
		"x": 40.7807709243,
		"y": 76.831223868,
		"h": 3.7362637363
	},
	{
		"stop_id": 8590981,
		"ID": 1042,
		"x": 40.0337561953,
		"y": 79.094210365,
		"h": 3.7362637363
	},
	{
		"stop_id": 8590982,
		"ID": 1042,
		"x": 38.1247679983,
		"y": 79.337187425,
		"h": 3.7362637363
	},
	{
		"stop_id": 8590984,
		"ID": 1042,
		"x": 38.2387628413,
		"y": 79.070189766,
		"h": 3.7362637363
	},
	{
		"stop_id": 8590985,
		"ID": 1042,
		"x": 40.2297459473,
		"y": 77.745191442,
		"h": 3.7362637363
	},
	{
		"stop_id": 8590989,
		"ID": 1042,
		"x": 35.9607102853,
		"y": 77.752168653,
		"h": 3.7362637363
	},
	{
		"stop_id": 8590990,
		"ID": 1042,
		"x": 39.1837422053,
		"y": 78.888211448,
		"h": 3.7362637363
	},
	{
		"stop_id": 8590991,
		"ID": 1042,
		"x": 39.1257501853,
		"y": 78.692192912,
		"h": 3.7362637363
	},
	{
		"stop_id": 8590996,
		"ID": 1042,
		"x": 35.8227460673,
		"y": 77.539212008,
		"h": 3.7362637363
	},
	{
		"stop_id": 8590997,
		"ID": 1042,
		"x": 40.3247255243,
		"y": 77.923164645,
		"h": 3.7362637363
	},
	{
		"stop_id": 8590998,
		"ID": 1042,
		"x": 39.7447595983,
		"y": 77.884242177,
		"h": 3.7362637363
	},
	{
		"stop_id": 8591000,
		"ID": 1042,
		"x": 38.9007298743,
		"y": 79.481193247,
		"h": 3.7362637363
	},
	{
		"stop_id": 8591003,
		"ID": 1042,
		"x": 40.7017031653,
		"y": 77.47818764,
		"h": 3.7362637363
	},
	{
		"stop_id": 8591004,
		"ID": 1042,
		"x": 36.5977510113,
		"y": 78.157166396,
		"h": 3.7362637363
	},
	{
		"stop_id": 8591005,
		"ID": 1042,
		"x": 39.4447444343,
		"y": 78.550193813,
		"h": 3.7362637363
	},
	{
		"stop_id": 8591006,
		"ID": 1042,
		"x": 40.1297113003,
		"y": 79.570220745,
		"h": 3.7362637363
	},
	{
		"stop_id": 8591007,
		"ID": 1042,
		"x": 38.3697609923,
		"y": 79.38217115,
		"h": 3.7362637363
	},
	{
		"stop_id": 8591008,
		"ID": 1042,
		"x": 39.2417145203,
		"y": 79.679162483,
		"h": 3.7362637363
	},
	{
		"stop_id": 8591011,
		"ID": 1042,
		"x": 36.3877075793,
		"y": 78.295195101,
		"h": 3.7362637363
	},
	{
		"stop_id": 8591012,
		"ID": 1042,
		"x": 37.6587275013,
		"y": 78.104159926,
		"h": 3.7362637363
	},
	{
		"stop_id": 8591014,
		"ID": 1042,
		"x": 37.8937556163,
		"y": 78.281177193,
		"h": 3.7362637363
	},
	{
		"stop_id": 8591016,
		"ID": 1042,
		"x": 36.8707273403,
		"y": 78.707173943,
		"h": 3.7362637363
	},
	{
		"stop_id": 8591017,
		"ID": 1042,
		"x": 40.0997038073,
		"y": 77.603213211,
		"h": 3.7362637363
	},
	{
		"stop_id": 8591018,
		"ID": 1042,
		"x": 37.8207691863,
		"y": 78.680186499,
		"h": 3.7362637363
	},
	{
		"stop_id": 8594298,
		"ID": 1042,
		"x": 37.0797013513,
		"y": 79.062211743,
		"h": 3.7362637363
	},
	{
		"stop_id": 8503385,
		"ID": 1178,
		"x": 60.9077446543,
		"y": 53.030222361,
		"h": 1.7912087912
	},
	{
		"stop_id": 8503387,
		"ID": 1178,
		"x": 57.1497099273,
		"y": 56.044188391,
		"h": 1.7912087912
	},
	{
		"stop_id": 8503391,
		"ID": 1178,
		"x": 56.5327727333,
		"y": 54.815200314,
		"h": 1.7912087912
	},
	{
		"stop_id": 8503763,
		"ID": 1178,
		"x": 58.0717304283,
		"y": 55.671217519,
		"h": 1.7912087912
	},
	{
		"stop_id": 8503980,
		"ID": 1178,
		"x": 58.0577631243,
		"y": 52.130201478,
		"h": 1.7912087912
	},
	{
		"stop_id": 8503982,
		"ID": 1178,
		"x": 59.6277395783,
		"y": 51.890226773,
		"h": 1.7912087912
	},
	{
		"stop_id": 8506460,
		"ID": 1178,
		"x": 57.0177320443,
		"y": 51.77016655,
		"h": 1.7912087912
	},
	{
		"stop_id": 8506486,
		"ID": 1178,
		"x": 58.9667506173,
		"y": 52.06723964,
		"h": 1.7912087912
	},
	{
		"stop_id": 8506490,
		"ID": 1178,
		"x": 58.5077503363,
		"y": 51.395216736,
		"h": 1.7912087912
	},
	{
		"stop_id": 8530477,
		"ID": 1178,
		"x": 58.1517237223,
		"y": 55.758208702,
		"h": 1.7912087912
	},
	{
		"stop_id": 8530478,
		"ID": 1178,
		"x": 59.1867029273,
		"y": 55.116211726,
		"h": 1.7912087912
	},
	{
		"stop_id": 8573589,
		"ID": 1178,
		"x": 55.9957321363,
		"y": 54.079234469,
		"h": 1.7912087912
	},
	{
		"stop_id": 8573590,
		"ID": 1178,
		"x": 57.0047701253,
		"y": 55.754214494,
		"h": 1.7912087912
	},
	{
		"stop_id": 8573591,
		"ID": 1178,
		"x": 55.9557698323,
		"y": 53.011160246,
		"h": 1.7912087912
	},
	{
		"stop_id": 8573850,
		"ID": 1178,
		"x": 58.6387367103,
		"y": 52.106171913,
		"h": 1.7912087912
	},
	{
		"stop_id": 8578504,
		"ID": 1178,
		"x": 57.4677457273,
		"y": 55.97017489,
		"h": 1.7912087912
	},
	{
		"stop_id": 8582140,
		"ID": 1178,
		"x": 56.8347616793,
		"y": 55.214218036,
		"h": 1.7912087912
	},
	{
		"stop_id": 8588492,
		"ID": 1178,
		"x": 58.9687076753,
		"y": 52.079177213,
		"h": 1.7912087912
	},
	{
		"stop_id": 8594376,
		"ID": 1178,
		"x": 56.9997593833,
		"y": 52.684208789,
		"h": 1.7912087912
	},
	{
		"stop_id": 8594377,
		"ID": 1178,
		"x": 57.4417620403,
		"y": 52.878175607,
		"h": 1.7912087912
	},
	{
		"stop_id": 8594378,
		"ID": 1178,
		"x": 57.5977253683,
		"y": 52.793185542,
		"h": 1.7912087912
	},
	{
		"stop_id": 8594379,
		"ID": 1178,
		"x": 58.6747743373,
		"y": 53.370239555,
		"h": 1.7912087912
	},
	{
		"stop_id": 8594380,
		"ID": 1178,
		"x": 59.1397735423,
		"y": 54.085214646,
		"h": 1.7912087912
	},
	{
		"stop_id": 8594381,
		"ID": 1178,
		"x": 59.5387658273,
		"y": 54.200194756,
		"h": 1.7912087912
	},
	{
		"stop_id": 8594382,
		"ID": 1178,
		"x": 60.4877699373,
		"y": 54.475216722,
		"h": 1.7912087912
	},
	{
		"stop_id": 8503400,
		"ID": 942,
		"x": 22.9167329333,
		"y": 81.697218387,
		"h": 2.5494505495
	},
	{
		"stop_id": 8503702,
		"ID": 942,
		"x": 23.0327586793,
		"y": 81.555174147,
		"h": 2.5494505495
	},
	{
		"stop_id": 8503771,
		"ID": 942,
		"x": 22.1567709823,
		"y": 80.483141271,
		"h": 2.5494505495
	},
	{
		"stop_id": 8503772,
		"ID": 942,
		"x": 23.4827613133,
		"y": 80.430163097,
		"h": 2.5494505495
	},
	{
		"stop_id": 8503781,
		"ID": 942,
		"x": 23.6827705923,
		"y": 79.630244313,
		"h": 2.5494505495
	},
	{
		"stop_id": 8503782,
		"ID": 942,
		"x": 20.9827158003,
		"y": 79.905220837,
		"h": 2.5494505495
	},
	{
		"stop_id": 8503788,
		"ID": 942,
		"x": 24.1827366463,
		"y": 78.205205411,
		"h": 2.5494505495
	},
	{
		"stop_id": 8503850,
		"ID": 942,
		"x": 23.3577024883,
		"y": 80.805142773,
		"h": 2.5494505495
	},
	{
		"stop_id": 8503853,
		"ID": 942,
		"x": 21.3327188553,
		"y": 81.60521918,
		"h": 2.5494505495
	},
	{
		"stop_id": 8503856,
		"ID": 942,
		"x": 23.7587434033,
		"y": 80.951238689,
		"h": 2.5494505495
	},
	{
		"stop_id": 8573206,
		"ID": 942,
		"x": 23.6157634883,
		"y": 79.140251262,
		"h": 2.5494505495
	},
	{
		"stop_id": 8573207,
		"ID": 942,
		"x": 23.6327501973,
		"y": 78.70515215,
		"h": 2.5494505495
	},
	{
		"stop_id": 8573208,
		"ID": 942,
		"x": 23.9157257213,
		"y": 78.103234214,
		"h": 2.5494505495
	},
	{
		"stop_id": 8573209,
		"ID": 942,
		"x": 24.4327718653,
		"y": 78.080215289,
		"h": 2.5494505495
	},
	{
		"stop_id": 8573254,
		"ID": 942,
		"x": 22.1077651453,
		"y": 81.530169453,
		"h": 2.5494505495
	},
	{
		"stop_id": 8573255,
		"ID": 942,
		"x": 22.3687339233,
		"y": 81.483194589,
		"h": 2.5494505495
	},
	{
		"stop_id": 8573256,
		"ID": 942,
		"x": 22.7077444063,
		"y": 81.355144022,
		"h": 2.5494505495
	},
	{
		"stop_id": 8573257,
		"ID": 942,
		"x": 23.1827197893,
		"y": 81.330209501,
		"h": 2.5494505495
	},
	{
		"stop_id": 8573259,
		"ID": 942,
		"x": 22.5517023973,
		"y": 80.763174441,
		"h": 2.5494505495
	},
	{
		"stop_id": 8573260,
		"ID": 942,
		"x": 21.3657034783,
		"y": 80.074145962,
		"h": 2.5494505495
	},
	{
		"stop_id": 8580583,
		"ID": 942,
		"x": 23.1537452443,
		"y": 81.108184809,
		"h": 2.5494505495
	},
	{
		"stop_id": 8580614,
		"ID": 942,
		"x": 22.9577569193,
		"y": 80.730145313,
		"h": 2.5494505495
	},
	{
		"stop_id": 8580615,
		"ID": 942,
		"x": 22.7077446543,
		"y": 80.680171544,
		"h": 2.5494505495
	},
	{
		"stop_id": 8580616,
		"ID": 942,
		"x": 22.7077462943,
		"y": 80.480237656,
		"h": 2.5494505495
	},
	{
		"stop_id": 8580617,
		"ID": 942,
		"x": 23.0077500573,
		"y": 80.280159559,
		"h": 2.5494505495
	},
	{
		"stop_id": 8580618,
		"ID": 942,
		"x": 23.3337567433,
		"y": 79.893204678,
		"h": 2.5494505495
	},
	{
		"stop_id": 8580619,
		"ID": 942,
		"x": 23.1577666613,
		"y": 79.430152848,
		"h": 2.5494505495
	},
	{
		"stop_id": 8580620,
		"ID": 942,
		"x": 23.0237237783,
		"y": 79.3652256,
		"h": 2.5494505495
	},
	{
		"stop_id": 8580621,
		"ID": 942,
		"x": 23.2577660303,
		"y": 81.130216467,
		"h": 2.5494505495
	},
	{
		"stop_id": 8580622,
		"ID": 942,
		"x": 23.0577235523,
		"y": 81.730216596,
		"h": 2.5494505495
	},
	{
		"stop_id": 8580623,
		"ID": 942,
		"x": 23.1267675973,
		"y": 81.995169698,
		"h": 2.5494505495
	},
	{
		"stop_id": 8580624,
		"ID": 942,
		"x": 23.3577242233,
		"y": 82.180222985,
		"h": 2.5494505495
	},
	{
		"stop_id": 8580625,
		"ID": 942,
		"x": 23.5077743723,
		"y": 82.280190049,
		"h": 2.5494505495
	},
	{
		"stop_id": 8580626,
		"ID": 942,
		"x": 23.5077609503,
		"y": 81.880208182,
		"h": 2.5494505495
	},
	{
		"stop_id": 8580628,
		"ID": 942,
		"x": 24.0077121703,
		"y": 82.030163305,
		"h": 2.5494505495
	},
	{
		"stop_id": 8580629,
		"ID": 942,
		"x": 24.1077715793,
		"y": 81.730233662,
		"h": 2.5494505495
	},
	{
		"stop_id": 8580630,
		"ID": 942,
		"x": 24.1077478813,
		"y": 81.53018689,
		"h": 2.5494505495
	},
	{
		"stop_id": 8580631,
		"ID": 942,
		"x": 23.6987633643,
		"y": 81.283208355,
		"h": 2.5494505495
	},
	{
		"stop_id": 8580632,
		"ID": 942,
		"x": 23.5307756173,
		"y": 80.717174633,
		"h": 2.5494505495
	},
	{
		"stop_id": 8580635,
		"ID": 942,
		"x": 23.6577291563,
		"y": 81.730203178,
		"h": 2.5494505495
	},
	{
		"stop_id": 8580636,
		"ID": 942,
		"x": 23.0077551683,
		"y": 81.630216474,
		"h": 2.5494505495
	},
	{
		"stop_id": 8581780,
		"ID": 942,
		"x": 23.1577276463,
		"y": 80.910196646,
		"h": 2.5494505495
	},
	{
		"stop_id": 8581965,
		"ID": 942,
		"x": 22.6147020293,
		"y": 81.0751841,
		"h": 2.5494505495
	},
	{
		"stop_id": 8582005,
		"ID": 942,
		"x": 23.1557294733,
		"y": 80.091195073,
		"h": 2.5494505495
	},
	{
		"stop_id": 8582739,
		"ID": 942,
		"x": 23.5677647593,
		"y": 80.145247981,
		"h": 2.5494505495
	},
	{
		"stop_id": 8583774,
		"ID": 942,
		"x": 23.7947674243,
		"y": 78.204159277,
		"h": 2.5494505495
	},
	{
		"stop_id": 8583794,
		"ID": 942,
		"x": 23.2667307323,
		"y": 81.307147704,
		"h": 2.5494505495
	},
	{
		"stop_id": 8583831,
		"ID": 942,
		"x": 20.6927461013,
		"y": 79.964205704,
		"h": 2.5494505495
	},
	{
		"stop_id": 8503401,
		"ID": 943,
		"x": 21.9637525193,
		"y": 84.421230676,
		"h": 1.7912087912
	},
	{
		"stop_id": 8503402,
		"ID": 943,
		"x": 21.3627677213,
		"y": 87.061162772,
		"h": 1.7912087912
	},
	{
		"stop_id": 8503874,
		"ID": 943,
		"x": 25.1077569573,
		"y": 84.780143924,
		"h": 1.7912087912
	},
	{
		"stop_id": 8506951,
		"ID": 943,
		"x": 25.5447480543,
		"y": 87.835229328,
		"h": 1.7912087912
	},
	{
		"stop_id": 8530650,
		"ID": 943,
		"x": 22.0087704083,
		"y": 87.368200099,
		"h": 1.7912087912
	},
	{
		"stop_id": 8573215,
		"ID": 943,
		"x": 25.3577580423,
		"y": 84.530204634,
		"h": 1.7912087912
	},
	{
		"stop_id": 8573216,
		"ID": 943,
		"x": 25.2827592243,
		"y": 84.280147725,
		"h": 1.7912087912
	},
	{
		"stop_id": 8573217,
		"ID": 943,
		"x": 25.5427120103,
		"y": 83.932170004,
		"h": 1.7912087912
	},
	{
		"stop_id": 8573706,
		"ID": 943,
		"x": 25.4477758303,
		"y": 88.105160335,
		"h": 1.7912087912
	},
	{
		"stop_id": 8573708,
		"ID": 943,
		"x": 24.8077649523,
		"y": 88.080167631,
		"h": 1.7912087912
	},
	{
		"stop_id": 8575954,
		"ID": 943,
		"x": 21.0547652583,
		"y": 85.284196824,
		"h": 1.7912087912
	},
	{
		"stop_id": 8575955,
		"ID": 943,
		"x": 21.9577276143,
		"y": 84.530233695,
		"h": 1.7912087912
	},
	{
		"stop_id": 8576750,
		"ID": 943,
		"x": 25.6077298323,
		"y": 83.700145377,
		"h": 1.7912087912
	},
	{
		"stop_id": 8579937,
		"ID": 943,
		"x": 21.9527225653,
		"y": 87.030154229,
		"h": 1.7912087912
	},
	{
		"stop_id": 8579939,
		"ID": 943,
		"x": 22.2077313683,
		"y": 87.075166011,
		"h": 1.7912087912
	},
	{
		"stop_id": 8579941,
		"ID": 943,
		"x": 23.3777279643,
		"y": 86.350149662,
		"h": 1.7912087912
	},
	{
		"stop_id": 8579942,
		"ID": 943,
		"x": 22.1977501003,
		"y": 87.420192949,
		"h": 1.7912087912
	},
	{
		"stop_id": 8579944,
		"ID": 943,
		"x": 22.4377342333,
		"y": 87.570202026,
		"h": 1.7912087912
	},
	{
		"stop_id": 8579945,
		"ID": 943,
		"x": 21.5877242753,
		"y": 87.840211901,
		"h": 1.7912087912
	},
	{
		"stop_id": 8580289,
		"ID": 943,
		"x": 24.8077517023,
		"y": 87.130176989,
		"h": 1.7912087912
	},
	{
		"stop_id": 8580290,
		"ID": 943,
		"x": 25.1577679793,
		"y": 87.380175921,
		"h": 1.7912087912
	},
	{
		"stop_id": 8581796,
		"ID": 943,
		"x": 22.5277169723,
		"y": 87.020235348,
		"h": 1.7912087912
	},
	{
		"stop_id": 8583817,
		"ID": 943,
		"x": 22.0557744843,
		"y": 87.67420715,
		"h": 1.7912087912
	},
	{
		"stop_id": 8583818,
		"ID": 943,
		"x": 21.8827746473,
		"y": 87.479213719,
		"h": 1.7912087912
	},
	{
		"stop_id": 8587333,
		"ID": 943,
		"x": 21.7977694363,
		"y": 87.510175872,
		"h": 1.7912087912
	},
	{
		"stop_id": 8503403,
		"ID": 912,
		"x": 21.0697218623,
		"y": 88.04615755,
		"h": 1.3296703297
	},
	{
		"stop_id": 8503405,
		"ID": 912,
		"x": 17.7057726903,
		"y": 86.797222945,
		"h": 1.3296703297
	},
	{
		"stop_id": 8574587,
		"ID": 912,
		"x": 18.4577260103,
		"y": 86.154173606,
		"h": 1.3296703297
	},
	{
		"stop_id": 8575121,
		"ID": 912,
		"x": 20.4327145983,
		"y": 90.85017893,
		"h": 1.3296703297
	},
	{
		"stop_id": 8575950,
		"ID": 912,
		"x": 17.7447084683,
		"y": 86.812189646,
		"h": 1.3296703297
	},
	{
		"stop_id": 8576290,
		"ID": 912,
		"x": 21.0777042433,
		"y": 88.040150821,
		"h": 1.3296703297
	},
	{
		"stop_id": 8576291,
		"ID": 912,
		"x": 20.6577081623,
		"y": 90.680211564,
		"h": 1.3296703297
	},
	{
		"stop_id": 8576292,
		"ID": 912,
		"x": 20.0747113213,
		"y": 90.847215515,
		"h": 1.3296703297
	},
	{
		"stop_id": 8576295,
		"ID": 912,
		"x": 18.1027018953,
		"y": 89.008194564,
		"h": 1.3296703297
	},
	{
		"stop_id": 8576296,
		"ID": 912,
		"x": 17.7877226123,
		"y": 88.980140758,
		"h": 1.3296703297
	},
	{
		"stop_id": 8581966,
		"ID": 912,
		"x": 19.5407481123,
		"y": 89.533186523,
		"h": 1.3296703297
	},
	{
		"stop_id": 8503404,
		"ID": 944,
		"x": 23.3367286933,
		"y": 90.582215105,
		"h": 1.2967032967
	},
	{
		"stop_id": 8503420,
		"ID": 944,
		"x": 25.0597291733,
		"y": 93.047181757,
		"h": 1.2967032967
	},
	{
		"stop_id": 8503576,
		"ID": 944,
		"x": 23.1377505873,
		"y": 91.330140462,
		"h": 1.2967032967
	},
	{
		"stop_id": 8573388,
		"ID": 944,
		"x": 25.0377053333,
		"y": 89.080164423,
		"h": 1.2967032967
	},
	{
		"stop_id": 8573707,
		"ID": 944,
		"x": 25.1827372983,
		"y": 88.84016365,
		"h": 1.2967032967
	},
	{
		"stop_id": 8573709,
		"ID": 944,
		"x": 23.3977461713,
		"y": 90.655244534,
		"h": 1.2967032967
	},
	{
		"stop_id": 8582103,
		"ID": 944,
		"x": 23.7587747823,
		"y": 91.763245355,
		"h": 1.2967032967
	},
	{
		"stop_id": 8583589,
		"ID": 944,
		"x": 23.4617215843,
		"y": 91.574230032,
		"h": 1.2967032967
	},
	{
		"stop_id": 8583590,
		"ID": 944,
		"x": 24.0647375443,
		"y": 91.927159647,
		"h": 1.2967032967
	},
	{
		"stop_id": 8583772,
		"ID": 944,
		"x": 22.6837649513,
		"y": 91.261173508,
		"h": 1.2967032967
	},
	{
		"stop_id": 8503408,
		"ID": 858,
		"x": 7.1137098353,
		"y": 86.615203993,
		"h": 1.1318681319
	},
	{
		"stop_id": 8503414,
		"ID": 858,
		"x": 9.0257608973,
		"y": 86.472143928,
		"h": 1.1318681319
	},
	{
		"stop_id": 8572593,
		"ID": 858,
		"x": 9.5907422853,
		"y": 86.347204105,
		"h": 1.1318681319
	},
	{
		"stop_id": 8578783,
		"ID": 858,
		"x": 6.7067038153,
		"y": 86.625177087,
		"h": 1.1318681319
	},
	{
		"stop_id": 8583559,
		"ID": 858,
		"x": 6.3437340033,
		"y": 87.145172668,
		"h": 1.1318681319
	},
	{
		"stop_id": 8503409,
		"ID": 833,
		"x": 4.7177281533,
		"y": 88.628239842,
		"h": 1.956043956
	},
	{
		"stop_id": 8503501,
		"ID": 833,
		"x": 1.7827121573,
		"y": 87.14615244,
		"h": 1.956043956
	},
	{
		"stop_id": 8503575,
		"ID": 833,
		"x": 2.4567129193,
		"y": 86.307237193,
		"h": 1.956043956
	},
	{
		"stop_id": 8503583,
		"ID": 833,
		"x": 4.3137293113,
		"y": 83.968187919,
		"h": 1.956043956
	},
	{
		"stop_id": 8503584,
		"ID": 833,
		"x": 4.0747355413,
		"y": 85.588161288,
		"h": 1.956043956
	},
	{
		"stop_id": 8503591,
		"ID": 833,
		"x": 1.2067633803,
		"y": 86.740210497,
		"h": 1.956043956
	},
	{
		"stop_id": 8503594,
		"ID": 833,
		"x": 3.3557195713,
		"y": 87.258156126,
		"h": 1.956043956
	},
	{
		"stop_id": 8572493,
		"ID": 833,
		"x": 0.7897047293,
		"y": 86.456154252,
		"h": 1.956043956
	},
	{
		"stop_id": 8572494,
		"ID": 833,
		"x": 1.7417173363,
		"y": 87.188202193,
		"h": 1.956043956
	},
	{
		"stop_id": 8572500,
		"ID": 833,
		"x": 4.4237116073,
		"y": 85.175181408,
		"h": 1.956043956
	},
	{
		"stop_id": 8572501,
		"ID": 833,
		"x": 4.4647022493,
		"y": 88.258200354,
		"h": 1.956043956
	},
	{
		"stop_id": 8572502,
		"ID": 833,
		"x": 4.3217505683,
		"y": 88.68219668,
		"h": 1.956043956
	},
	{
		"stop_id": 8572503,
		"ID": 833,
		"x": 4.6987296053,
		"y": 88.618247129,
		"h": 1.956043956
	},
	{
		"stop_id": 8572589,
		"ID": 833,
		"x": 1.8187057813,
		"y": 86.667163856,
		"h": 1.956043956
	},
	{
		"stop_id": 8576763,
		"ID": 833,
		"x": 3.7797144083,
		"y": 87.783210648,
		"h": 1.956043956
	},
	{
		"stop_id": 8578779,
		"ID": 833,
		"x": 4.4287323513,
		"y": 88.508223892,
		"h": 1.956043956
	},
	{
		"stop_id": 8578780,
		"ID": 833,
		"x": 4.7217404633,
		"y": 88.419233955,
		"h": 1.956043956
	},
	{
		"stop_id": 8578781,
		"ID": 833,
		"x": 5.5607209123,
		"y": 88.084189249,
		"h": 1.956043956
	},
	{
		"stop_id": 8578787,
		"ID": 833,
		"x": 6.3707070583,
		"y": 84.950241652,
		"h": 1.956043956
	},
	{
		"stop_id": 8578788,
		"ID": 833,
		"x": 6.1827067103,
		"y": 84.947139833,
		"h": 1.956043956
	},
	{
		"stop_id": 8582508,
		"ID": 833,
		"x": 5.3317240743,
		"y": 87.71415633,
		"h": 1.956043956
	},
	{
		"stop_id": 8582509,
		"ID": 833,
		"x": 5.1357110643,
		"y": 88.003222942,
		"h": 1.956043956
	},
	{
		"stop_id": 8582513,
		"ID": 833,
		"x": 4.5077507733,
		"y": 88.692224147,
		"h": 1.956043956
	},
	{
		"stop_id": 8582516,
		"ID": 833,
		"x": 4.5677155953,
		"y": 88.553214055,
		"h": 1.956043956
	},
	{
		"stop_id": 8582517,
		"ID": 833,
		"x": 4.1277472213,
		"y": 88.772165439,
		"h": 1.956043956
	},
	{
		"stop_id": 8582519,
		"ID": 833,
		"x": 4.9767045363,
		"y": 88.267237655,
		"h": 1.956043956
	},
	{
		"stop_id": 8582520,
		"ID": 833,
		"x": 4.2127354163,
		"y": 88.697249419,
		"h": 1.956043956
	},
	{
		"stop_id": 8582521,
		"ID": 833,
		"x": 4.2327355193,
		"y": 88.580153711,
		"h": 1.956043956
	},
	{
		"stop_id": 8583442,
		"ID": 833,
		"x": 4.2947632333,
		"y": 88.493203287,
		"h": 1.956043956
	},
	{
		"stop_id": 8583655,
		"ID": 833,
		"x": 5.5677203083,
		"y": 88.077150084,
		"h": 1.956043956
	},
	{
		"stop_id": 8503410,
		"ID": 834,
		"x": 3.3297725753,
		"y": 89.996201623,
		"h": 1.2637362637
	},
	{
		"stop_id": 8582510,
		"ID": 834,
		"x": 3.7007594793,
		"y": 89.326213331,
		"h": 1.2637362637
	},
	{
		"stop_id": 8582511,
		"ID": 834,
		"x": 3.8997272213,
		"y": 89.150217873,
		"h": 1.2637362637
	},
	{
		"stop_id": 8582512,
		"ID": 834,
		"x": 4.0587191333,
		"y": 89.013160563,
		"h": 1.2637362637
	},
	{
		"stop_id": 8582515,
		"ID": 834,
		"x": 4.2037351013,
		"y": 89.021179012,
		"h": 1.2637362637
	},
	{
		"stop_id": 8582518,
		"ID": 834,
		"x": 4.4287603563,
		"y": 89.156167379,
		"h": 1.2637362637
	},
	{
		"stop_id": 8582526,
		"ID": 834,
		"x": 3.6287252073,
		"y": 89.618220714,
		"h": 1.2637362637
	},
	{
		"stop_id": 8582528,
		"ID": 834,
		"x": 3.3917110903,
		"y": 89.957166501,
		"h": 1.2637362637
	},
	{
		"stop_id": 8583441,
		"ID": 834,
		"x": 4.6557387363,
		"y": 88.980168191,
		"h": 1.2637362637
	},
	{
		"stop_id": 8503413,
		"ID": 883,
		"x": 14.0437464323,
		"y": 86.306201244,
		"h": 1.2637362637
	},
	{
		"stop_id": 8503415,
		"ID": 883,
		"x": 10.6217565223,
		"y": 86.146233783,
		"h": 1.2637362637
	},
	{
		"stop_id": 8503687,
		"ID": 883,
		"x": 13.9827740213,
		"y": 86.313223562,
		"h": 1.2637362637
	},
	{
		"stop_id": 8572590,
		"ID": 883,
		"x": 14.5077550173,
		"y": 85.980202676,
		"h": 1.2637362637
	},
	{
		"stop_id": 8572591,
		"ID": 883,
		"x": 13.3227120443,
		"y": 86.006231799,
		"h": 1.2637362637
	},
	{
		"stop_id": 8572592,
		"ID": 883,
		"x": 10.9147078913,
		"y": 86.16819017,
		"h": 1.2637362637
	},
	{
		"stop_id": 8573247,
		"ID": 883,
		"x": 15.4137141603,
		"y": 85.234182441,
		"h": 1.2637362637
	},
	{
		"stop_id": 8580842,
		"ID": 883,
		"x": 10.6987669383,
		"y": 86.176174263,
		"h": 1.2637362637
	},
	{
		"stop_id": 8583712,
		"ID": 883,
		"x": 15.7517646003,
		"y": 84.928140635,
		"h": 1.2637362637
	},
	{
		"stop_id": 8503421,
		"ID": 945,
		"x": 25.4997107413,
		"y": 96.241184345,
		"h": 1.0659340659
	},
	{
		"stop_id": 8578395,
		"ID": 945,
		"x": 24.1857096923,
		"y": 100.092149222,
		"h": 1.0659340659
	},
	{
		"stop_id": 8595423,
		"ID": 945,
		"x": 24.2377508973,
		"y": 99.765167847,
		"h": 1.0659340659
	},
	{
		"stop_id": 8503426,
		"ID": 1012,
		"x": 32.1367645773,
		"y": 99.571248144,
		"h": 1.5604395604
	},
	{
		"stop_id": 8503427,
		"ID": 1012,
		"x": 34.0357201563,
		"y": 99.162233929,
		"h": 1.5604395604
	},
	{
		"stop_id": 8503952,
		"ID": 1012,
		"x": 31.5097058743,
		"y": 96.166244928,
		"h": 1.5604395604
	},
	{
		"stop_id": 8503967,
		"ID": 1012,
		"x": 31.8977743063,
		"y": 100.080193166,
		"h": 1.5604395604
	},
	{
		"stop_id": 8573435,
		"ID": 1012,
		"x": 33.1057551183,
		"y": 94.773178036,
		"h": 1.5604395604
	},
	{
		"stop_id": 8573488,
		"ID": 1012,
		"x": 35.2067065953,
		"y": 97.182248238,
		"h": 1.5604395604
	},
	{
		"stop_id": 8573489,
		"ID": 1012,
		"x": 34.8327219053,
		"y": 97.912207038,
		"h": 1.5604395604
	},
	{
		"stop_id": 8573490,
		"ID": 1012,
		"x": 34.4297205243,
		"y": 98.527181915,
		"h": 1.5604395604
	},
	{
		"stop_id": 8573491,
		"ID": 1012,
		"x": 34.0407457233,
		"y": 99.153194866,
		"h": 1.5604395604
	},
	{
		"stop_id": 8573739,
		"ID": 1012,
		"x": 32.2327061983,
		"y": 99.905145485,
		"h": 1.5604395604
	},
	{
		"stop_id": 8573740,
		"ID": 1012,
		"x": 32.6327233933,
		"y": 99.905177414,
		"h": 1.5604395604
	},
	{
		"stop_id": 8579838,
		"ID": 1012,
		"x": 35.2227170963,
		"y": 97.4241606,
		"h": 1.5604395604
	},
	{
		"stop_id": 8580969,
		"ID": 1012,
		"x": 35.8257578313,
		"y": 96.469182364,
		"h": 1.5604395604
	},
	{
		"stop_id": 8580970,
		"ID": 1012,
		"x": 34.5567705113,
		"y": 96.614218647,
		"h": 1.5604395604
	},
	{
		"stop_id": 8581418,
		"ID": 1012,
		"x": 34.6547397993,
		"y": 96.849211152,
		"h": 1.5604395604
	},
	{
		"stop_id": 8581850,
		"ID": 1012,
		"x": 35.1927454563,
		"y": 97.102176221,
		"h": 1.5604395604
	},
	{
		"stop_id": 8582607,
		"ID": 1012,
		"x": 33.2557063403,
		"y": 96.068204587,
		"h": 1.5604395604
	},
	{
		"stop_id": 8583421,
		"ID": 1012,
		"x": 35.0077093513,
		"y": 97.195170462,
		"h": 1.5604395604
	},
	{
		"stop_id": 8503428,
		"ID": 1046,
		"x": 38.8887173393,
		"y": 99.905187361,
		"h": 1.3956043956
	},
	{
		"stop_id": 8503429,
		"ID": 1046,
		"x": 40.2857481643,
		"y": 97.833218036,
		"h": 1.3956043956
	},
	{
		"stop_id": 8506148,
		"ID": 1046,
		"x": 37.3637331963,
		"y": 100.112165561,
		"h": 1.3956043956
	},
	{
		"stop_id": 8506152,
		"ID": 1046,
		"x": 38.6227723573,
		"y": 100.451229207,
		"h": 1.3956043956
	},
	{
		"stop_id": 8506975,
		"ID": 1046,
		"x": 38.6547089093,
		"y": 98.107242586,
		"h": 1.3956043956
	},
	{
		"stop_id": 8573332,
		"ID": 1046,
		"x": 40.1497235153,
		"y": 97.783201553,
		"h": 1.3956043956
	},
	{
		"stop_id": 8573333,
		"ID": 1046,
		"x": 38.7827086553,
		"y": 98.480153099,
		"h": 1.3956043956
	},
	{
		"stop_id": 8573334,
		"ID": 1046,
		"x": 38.9197074693,
		"y": 99.902147657,
		"h": 1.3956043956
	},
	{
		"stop_id": 8573747,
		"ID": 1046,
		"x": 36.6477030953,
		"y": 102.155225817,
		"h": 1.3956043956
	},
	{
		"stop_id": 8573748,
		"ID": 1046,
		"x": 36.2677522773,
		"y": 100.910141479,
		"h": 1.3956043956
	},
	{
		"stop_id": 8582826,
		"ID": 1046,
		"x": 38.7547570823,
		"y": 99.343227108,
		"h": 1.3956043956
	},
	{
		"stop_id": 8589950,
		"ID": 1046,
		"x": 36.5877443493,
		"y": 102.631225094,
		"h": 1.3956043956
	},
	{
		"stop_id": 8594288,
		"ID": 1046,
		"x": 39.9537311943,
		"y": 103.168140258,
		"h": 1.3956043956
	},
	{
		"stop_id": 8503470,
		"ID": 1079,
		"x": 44.8297651753,
		"y": 99.185148005,
		"h": 1.1978021978
	},
	{
		"stop_id": 8506025,
		"ID": 1079,
		"x": 43.9147218073,
		"y": 97.286175793,
		"h": 1.1978021978
	},
	{
		"stop_id": 8506153,
		"ID": 1079,
		"x": 46.7757032523,
		"y": 97.200186037,
		"h": 1.1978021978
	},
	{
		"stop_id": 8573330,
		"ID": 1079,
		"x": 41.8337276063,
		"y": 94.855156057,
		"h": 1.1978021978
	},
	{
		"stop_id": 8573331,
		"ID": 1079,
		"x": 41.3327545633,
		"y": 96.408141558,
		"h": 1.1978021978
	},
	{
		"stop_id": 8578398,
		"ID": 1079,
		"x": 46.8157583943,
		"y": 97.374177625,
		"h": 1.1978021978
	},
	{
		"stop_id": 8578399,
		"ID": 1079,
		"x": 46.2837433903,
		"y": 97.667186801,
		"h": 1.1978021978
	},
	{
		"stop_id": 8503471,
		"ID": 1080,
		"x": 43.6327435813,
		"y": 102.400171377,
		"h": 1.3956043956
	},
	{
		"stop_id": 8503472,
		"ID": 1080,
		"x": 45.1577576653,
		"y": 105.130190505,
		"h": 1.3956043956
	},
	{
		"stop_id": 8503474,
		"ID": 1080,
		"x": 43.3577294853,
		"y": 102.420149317,
		"h": 1.3956043956
	},
	{
		"stop_id": 8503954,
		"ID": 1080,
		"x": 41.0777060753,
		"y": 103.4551924,
		"h": 1.3956043956
	},
	{
		"stop_id": 8573754,
		"ID": 1080,
		"x": 43.2677122933,
		"y": 102.395219051,
		"h": 1.3956043956
	},
	{
		"stop_id": 8573755,
		"ID": 1080,
		"x": 41.2727520103,
		"y": 103.565188694,
		"h": 1.3956043956
	},
	{
		"stop_id": 8578400,
		"ID": 1080,
		"x": 43.8527324603,
		"y": 102.585203411,
		"h": 1.3956043956
	},
	{
		"stop_id": 8578401,
		"ID": 1080,
		"x": 44.1447379133,
		"y": 102.895183063,
		"h": 1.3956043956
	},
	{
		"stop_id": 8578402,
		"ID": 1080,
		"x": 44.1737117203,
		"y": 103.133245122,
		"h": 1.3956043956
	},
	{
		"stop_id": 8578404,
		"ID": 1080,
		"x": 45.3767244733,
		"y": 105.578176388,
		"h": 1.3956043956
	},
	{
		"stop_id": 8594361,
		"ID": 1080,
		"x": 44.0077124283,
		"y": 102.480167531,
		"h": 1.3956043956
	},
	{
		"stop_id": 8594383,
		"ID": 1080,
		"x": 44.9597368393,
		"y": 104.671242924,
		"h": 1.3956043956
	},
	{
		"stop_id": 8595590,
		"ID": 1080,
		"x": 43.0327208923,
		"y": 102.410240729,
		"h": 1.3956043956
	},
	{
		"stop_id": 8503483,
		"ID": 946,
		"x": 25.5527356593,
		"y": 100.969185118,
		"h": 1.3296703297
	},
	{
		"stop_id": 8503484,
		"ID": 946,
		"x": 23.8177133883,
		"y": 101.420164934,
		"h": 1.3296703297
	},
	{
		"stop_id": 8503485,
		"ID": 946,
		"x": 21.5027590203,
		"y": 102.810208681,
		"h": 1.3296703297
	},
	{
		"stop_id": 8578372,
		"ID": 946,
		"x": 21.2237065973,
		"y": 102.860188598,
		"h": 1.3296703297
	},
	{
		"stop_id": 8588546,
		"ID": 946,
		"x": 25.2277627363,
		"y": 101.076250211,
		"h": 1.3296703297
	},
	{
		"stop_id": 8595417,
		"ID": 946,
		"x": 25.4677684373,
		"y": 101.170239762,
		"h": 1.3296703297
	},
	{
		"stop_id": 8595418,
		"ID": 946,
		"x": 25.3677343193,
		"y": 101.505193063,
		"h": 1.3296703297
	},
	{
		"stop_id": 8595419,
		"ID": 946,
		"x": 25.4897361513,
		"y": 101.364168213,
		"h": 1.3296703297
	},
	{
		"stop_id": 8595420,
		"ID": 946,
		"x": 25.2027023493,
		"y": 100.695229542,
		"h": 1.3296703297
	},
	{
		"stop_id": 8595421,
		"ID": 946,
		"x": 25.4197300363,
		"y": 101.673199531,
		"h": 1.3296703297
	},
	{
		"stop_id": 8595422,
		"ID": 946,
		"x": 25.4937110083,
		"y": 101.551164059,
		"h": 1.3296703297
	},
	{
		"stop_id": 8503486,
		"ID": 915,
		"x": 20.2227611623,
		"y": 103.65019536,
		"h": 1.3296703297
	},
	{
		"stop_id": 8503487,
		"ID": 915,
		"x": 19.1817624033,
		"y": 104.823162012,
		"h": 1.3296703297
	},
	{
		"stop_id": 8503488,
		"ID": 915,
		"x": 18.3947071273,
		"y": 106.465190181,
		"h": 1.3296703297
	},
	{
		"stop_id": 8503492,
		"ID": 915,
		"x": 19.4027346833,
		"y": 107.370210362,
		"h": 1.3296703297
	},
	{
		"stop_id": 8503493,
		"ID": 915,
		"x": 20.2397636213,
		"y": 108.338251124,
		"h": 1.3296703297
	},
	{
		"stop_id": 8578363,
		"ID": 915,
		"x": 19.0067316833,
		"y": 106.89715891,
		"h": 1.3296703297
	},
	{
		"stop_id": 8578364,
		"ID": 915,
		"x": 18.8337005743,
		"y": 106.791200684,
		"h": 1.3296703297
	},
	{
		"stop_id": 8578367,
		"ID": 915,
		"x": 18.3927554873,
		"y": 106.0811673,
		"h": 1.3296703297
	},
	{
		"stop_id": 8578369,
		"ID": 915,
		"x": 19.9157150263,
		"y": 104.170147521,
		"h": 1.3296703297
	},
	{
		"stop_id": 8594312,
		"ID": 915,
		"x": 18.5777116073,
		"y": 106.640216172,
		"h": 1.3296703297
	},
	{
		"stop_id": 8594337,
		"ID": 915,
		"x": 18.7577561863,
		"y": 106.710229161,
		"h": 1.3296703297
	},
	{
		"stop_id": 8503491,
		"ID": 947,
		"x": 22.4787698193,
		"y": 108.681172078,
		"h": 1.032967033
	},
	{
		"stop_id": 8578362,
		"ID": 947,
		"x": 22.2157528043,
		"y": 108.541159541,
		"h": 1.032967033
	},
	{
		"stop_id": 8503502,
		"ID": 832,
		"x": 0.6297305653,
		"y": 80.758156813,
		"h": 1.8901098901
	},
	{
		"stop_id": 8503503,
		"ID": 832,
		"x": 1.6607600273,
		"y": 77.859194884,
		"h": 1.8901098901
	},
	{
		"stop_id": 8503582,
		"ID": 832,
		"x": 4.3887454473,
		"y": 82.987152111,
		"h": 1.8901098901
	},
	{
		"stop_id": 8503587,
		"ID": 832,
		"x": 1.9197280623,
		"y": 82.307164912,
		"h": 1.8901098901
	},
	{
		"stop_id": 8503593,
		"ID": 832,
		"x": 1.1157618203,
		"y": 81.487230476,
		"h": 1.8901098901
	},
	{
		"stop_id": 8503767,
		"ID": 832,
		"x": 4.1617379583,
		"y": 77.535207657,
		"h": 1.8901098901
	},
	{
		"stop_id": 8503776,
		"ID": 832,
		"x": 1.6237363363,
		"y": 78.74723778,
		"h": 1.8901098901
	},
	{
		"stop_id": 8503777,
		"ID": 832,
		"x": 2.2257293623,
		"y": 78.57416123,
		"h": 1.8901098901
	},
	{
		"stop_id": 8503778,
		"ID": 832,
		"x": 2.1317205463,
		"y": 77.555210561,
		"h": 1.8901098901
	},
	{
		"stop_id": 8503779,
		"ID": 832,
		"x": 3.3567076663,
		"y": 78.053173068,
		"h": 1.8901098901
	},
	{
		"stop_id": 8503877,
		"ID": 832,
		"x": 1.6767740663,
		"y": 77.870146795,
		"h": 1.8901098901
	},
	{
		"stop_id": 8572495,
		"ID": 832,
		"x": 0.6527441743,
		"y": 80.791193813,
		"h": 1.8901098901
	},
	{
		"stop_id": 8572496,
		"ID": 832,
		"x": 1.4167235713,
		"y": 82.048194615,
		"h": 1.8901098901
	},
	{
		"stop_id": 8572497,
		"ID": 832,
		"x": 1.7047480593,
		"y": 82.544215122,
		"h": 1.8901098901
	},
	{
		"stop_id": 8572498,
		"ID": 832,
		"x": 2.1917438183,
		"y": 82.10518998,
		"h": 1.8901098901
	},
	{
		"stop_id": 8572524,
		"ID": 832,
		"x": 0.6877592123,
		"y": 80.770202545,
		"h": 1.8901098901
	},
	{
		"stop_id": 8572574,
		"ID": 832,
		"x": 4.9637511443,
		"y": 77.299191604,
		"h": 1.8901098901
	},
	{
		"stop_id": 8572575,
		"ID": 832,
		"x": 3.7137730783,
		"y": 77.84917408,
		"h": 1.8901098901
	},
	{
		"stop_id": 8572576,
		"ID": 832,
		"x": 3.1527436213,
		"y": 78.432169049,
		"h": 1.8901098901
	},
	{
		"stop_id": 8572577,
		"ID": 832,
		"x": 2.8077098853,
		"y": 78.330215544,
		"h": 1.8901098901
	},
	{
		"stop_id": 8572578,
		"ID": 832,
		"x": 1.8987714113,
		"y": 78.653249306,
		"h": 1.8901098901
	},
	{
		"stop_id": 8572579,
		"ID": 832,
		"x": 2.4247536533,
		"y": 78.078218534,
		"h": 1.8901098901
	},
	{
		"stop_id": 8572588,
		"ID": 832,
		"x": 4.8667655513,
		"y": 82.482198356,
		"h": 1.8901098901
	},
	{
		"stop_id": 8578673,
		"ID": 832,
		"x": 2.5967458173,
		"y": 77.261208305,
		"h": 1.8901098901
	},
	{
		"stop_id": 8580164,
		"ID": 832,
		"x": 1.5787033633,
		"y": 82.38323168,
		"h": 1.8901098901
	},
	{
		"stop_id": 8583661,
		"ID": 832,
		"x": 2.5387154783,
		"y": 82.153202275,
		"h": 1.8901098901
	},
	{
		"stop_id": 8583893,
		"ID": 832,
		"x": 4.1057257603,
		"y": 82.838200338,
		"h": 1.8901098901
	},
	{
		"stop_id": 8590252,
		"ID": 832,
		"x": 4.5437326253,
		"y": 77.359214854,
		"h": 1.8901098901
	},
	{
		"stop_id": 8503525,
		"ID": 881,
		"x": 12.9117120593,
		"y": 73.990171378,
		"h": 1.6263736264
	},
	{
		"stop_id": 8503527,
		"ID": 881,
		"x": 15.4397378853,
		"y": 73.753215934,
		"h": 1.6263736264
	},
	{
		"stop_id": 8503528,
		"ID": 881,
		"x": 11.8127379213,
		"y": 73.879153696,
		"h": 1.6263736264
	},
	{
		"stop_id": 8576235,
		"ID": 881,
		"x": 11.8207132433,
		"y": 73.868242023,
		"h": 1.6263736264
	},
	{
		"stop_id": 8576236,
		"ID": 881,
		"x": 12.0037305953,
		"y": 74.498143388,
		"h": 1.6263736264
	},
	{
		"stop_id": 8576237,
		"ID": 881,
		"x": 11.9957077303,
		"y": 74.774250305,
		"h": 1.6263736264
	},
	{
		"stop_id": 8576238,
		"ID": 881,
		"x": 12.9027521603,
		"y": 75.598142805,
		"h": 1.6263736264
	},
	{
		"stop_id": 8576239,
		"ID": 881,
		"x": 13.2817404493,
		"y": 75.435239375,
		"h": 1.6263736264
	},
	{
		"stop_id": 8576257,
		"ID": 881,
		"x": 16.0267431383,
		"y": 74.18223913,
		"h": 1.6263736264
	},
	{
		"stop_id": 8576258,
		"ID": 881,
		"x": 15.7847110473,
		"y": 74.32025024,
		"h": 1.6263736264
	},
	{
		"stop_id": 8576259,
		"ID": 881,
		"x": 15.5867603413,
		"y": 74.118244891,
		"h": 1.6263736264
	},
	{
		"stop_id": 8576260,
		"ID": 881,
		"x": 15.5027249413,
		"y": 73.758241843,
		"h": 1.6263736264
	},
	{
		"stop_id": 8576273,
		"ID": 881,
		"x": 13.2827557913,
		"y": 72.890145079,
		"h": 1.6263736264
	},
	{
		"stop_id": 8576274,
		"ID": 881,
		"x": 11.7427583713,
		"y": 72.89814309,
		"h": 1.6263736264
	},
	{
		"stop_id": 8576276,
		"ID": 881,
		"x": 15.6937697703,
		"y": 72.793177535,
		"h": 1.6263736264
	},
	{
		"stop_id": 8576277,
		"ID": 881,
		"x": 15.6387321423,
		"y": 73.460194215,
		"h": 1.6263736264
	},
	{
		"stop_id": 8576288,
		"ID": 881,
		"x": 15.4907417483,
		"y": 76.817156956,
		"h": 1.6263736264
	},
	{
		"stop_id": 8588094,
		"ID": 881,
		"x": 12.4577463783,
		"y": 73.010230777,
		"h": 1.6263736264
	},
	{
		"stop_id": 8595143,
		"ID": 881,
		"x": 11.7477272433,
		"y": 74.366172065,
		"h": 1.6263736264
	},
	{
		"stop_id": 8595356,
		"ID": 881,
		"x": 15.6017428913,
		"y": 73.966211122,
		"h": 1.6263736264
	},
	{
		"stop_id": 8503553,
		"ID": 1074,
		"x": 43.2757493883,
		"y": 65.936225282,
		"h": 1.3956043956
	},
	{
		"stop_id": 8503554,
		"ID": 1074,
		"x": 43.1077194143,
		"y": 66.200183542,
		"h": 1.3956043956
	},
	{
		"stop_id": 8503555,
		"ID": 1074,
		"x": 45.0187732103,
		"y": 67.648245685,
		"h": 1.3956043956
	},
	{
		"stop_id": 8503564,
		"ID": 1074,
		"x": 42.5177534733,
		"y": 69.455230495,
		"h": 1.3956043956
	},
	{
		"stop_id": 8503792,
		"ID": 1074,
		"x": 41.2457656293,
		"y": 67.622184739,
		"h": 1.3956043956
	},
	{
		"stop_id": 8573513,
		"ID": 1074,
		"x": 43.2517007893,
		"y": 69.906192614,
		"h": 1.3956043956
	},
	{
		"stop_id": 8573514,
		"ID": 1074,
		"x": 43.6827111493,
		"y": 70.380192866,
		"h": 1.3956043956
	},
	{
		"stop_id": 8573515,
		"ID": 1074,
		"x": 44.1827251793,
		"y": 71.330154653,
		"h": 1.3956043956
	},
	{
		"stop_id": 8573529,
		"ID": 1074,
		"x": 41.1407709843,
		"y": 67.243208817,
		"h": 1.3956043956
	},
	{
		"stop_id": 8573530,
		"ID": 1074,
		"x": 41.0017408743,
		"y": 67.772150561,
		"h": 1.3956043956
	},
	{
		"stop_id": 8573531,
		"ID": 1074,
		"x": 40.7777353533,
		"y": 68.180225225,
		"h": 1.3956043956
	},
	{
		"stop_id": 8581691,
		"ID": 1074,
		"x": 45.0077438313,
		"y": 68.980231412,
		"h": 1.3956043956
	},
	{
		"stop_id": 8583869,
		"ID": 1074,
		"x": 41.2987600893,
		"y": 67.605185557,
		"h": 1.3956043956
	},
	{
		"stop_id": 8503581,
		"ID": 857,
		"x": 6.9787653613,
		"y": 81.710177659,
		"h": 1.4615384615
	},
	{
		"stop_id": 8503589,
		"ID": 857,
		"x": 10.0347140363,
		"y": 80.230210891,
		"h": 1.4615384615
	},
	{
		"stop_id": 8503596,
		"ID": 857,
		"x": 9.9457425533,
		"y": 81.016198941,
		"h": 1.4615384615
	},
	{
		"stop_id": 8503880,
		"ID": 857,
		"x": 5.8487239483,
		"y": 82.362250153,
		"h": 1.4615384615
	},
	{
		"stop_id": 8503882,
		"ID": 857,
		"x": 10.6157659913,
		"y": 84.924220731,
		"h": 1.4615384615
	},
	{
		"stop_id": 8503883,
		"ID": 857,
		"x": 11.1257311843,
		"y": 83.96023854,
		"h": 1.4615384615
	},
	{
		"stop_id": 8503884,
		"ID": 857,
		"x": 9.8227747453,
		"y": 85.17024688,
		"h": 1.4615384615
	},
	{
		"stop_id": 8572587,
		"ID": 857,
		"x": 7.3167104473,
		"y": 81.172150837,
		"h": 1.4615384615
	},
	{
		"stop_id": 8572594,
		"ID": 857,
		"x": 10.6237482423,
		"y": 82.433188774,
		"h": 1.4615384615
	},
	{
		"stop_id": 8578784,
		"ID": 857,
		"x": 7.6177165283,
		"y": 84.830227376,
		"h": 1.4615384615
	},
	{
		"stop_id": 8578785,
		"ID": 857,
		"x": 7.4547630013,
		"y": 84.83515444,
		"h": 1.4615384615
	},
	{
		"stop_id": 8578786,
		"ID": 857,
		"x": 6.5807445823,
		"y": 84.995184044,
		"h": 1.4615384615
	},
	{
		"stop_id": 8578903,
		"ID": 857,
		"x": 6.5137653653,
		"y": 81.999167708,
		"h": 1.4615384615
	},
	{
		"stop_id": 8581072,
		"ID": 857,
		"x": 10.9527657863,
		"y": 83.673170255,
		"h": 1.4615384615
	},
	{
		"stop_id": 8581639,
		"ID": 857,
		"x": 9.4937115873,
		"y": 81.370158006,
		"h": 1.4615384615
	},
	{
		"stop_id": 8503597,
		"ID": 911,
		"x": 17.0327341723,
		"y": 83.905174433,
		"h": 1.4615384615
	},
	{
		"stop_id": 8503783,
		"ID": 911,
		"x": 18.3077754033,
		"y": 80.405154101,
		"h": 1.4615384615
	},
	{
		"stop_id": 8503786,
		"ID": 911,
		"x": 17.6827648013,
		"y": 82.080233187,
		"h": 1.4615384615
	},
	{
		"stop_id": 8503854,
		"ID": 911,
		"x": 18.0327230713,
		"y": 83.255182572,
		"h": 1.4615384615
	},
	{
		"stop_id": 8573235,
		"ID": 911,
		"x": 18.0827701993,
		"y": 80.180238764,
		"h": 1.4615384615
	},
	{
		"stop_id": 8573251,
		"ID": 911,
		"x": 17.8827706893,
		"y": 82.730248233,
		"h": 1.4615384615
	},
	{
		"stop_id": 8573252,
		"ID": 911,
		"x": 17.6387405933,
		"y": 82.434153408,
		"h": 1.4615384615
	},
	{
		"stop_id": 8573253,
		"ID": 911,
		"x": 20.4317584083,
		"y": 81.608161388,
		"h": 1.4615384615
	},
	{
		"stop_id": 8573267,
		"ID": 911,
		"x": 16.6147371343,
		"y": 81.800242015,
		"h": 1.4615384615
	},
	{
		"stop_id": 8573271,
		"ID": 911,
		"x": 16.3827699163,
		"y": 81.080142056,
		"h": 1.4615384615
	},
	{
		"stop_id": 8574203,
		"ID": 911,
		"x": 19.0347235433,
		"y": 85.734171759,
		"h": 1.4615384615
	},
	{
		"stop_id": 8575949,
		"ID": 911,
		"x": 20.0887605483,
		"y": 85.652250333,
		"h": 1.4615384615
	},
	{
		"stop_id": 8575952,
		"ID": 911,
		"x": 20.3377073183,
		"y": 85.500164481,
		"h": 1.4615384615
	},
	{
		"stop_id": 8575953,
		"ID": 911,
		"x": 20.6427589143,
		"y": 85.170155486,
		"h": 1.4615384615
	},
	{
		"stop_id": 8583115,
		"ID": 911,
		"x": 20.4807220913,
		"y": 85.284155249,
		"h": 1.4615384615
	},
	{
		"stop_id": 8503613,
		"ID": 1240,
		"x": 70.2877484663,
		"y": 14.018248987,
		"h": 1.1648351648
	},
	{
		"stop_id": 8503614,
		"ID": 1240,
		"x": 70.6257046653,
		"y": 14.169166985,
		"h": 1.1648351648
	},
	{
		"stop_id": 8503619,
		"ID": 1240,
		"x": 70.9337725063,
		"y": 14.299213021,
		"h": 1.1648351648
	},
	{
		"stop_id": 8595523,
		"ID": 1240,
		"x": 69.2737118863,
		"y": 13.046213424,
		"h": 1.1648351648
	},
	{
		"stop_id": 8595524,
		"ID": 1240,
		"x": 68.1327653043,
		"y": 13.045155296,
		"h": 1.1648351648
	},
	{
		"stop_id": 8595525,
		"ID": 1240,
		"x": 67.8176991353,
		"y": 13.080231876,
		"h": 1.1648351648
	},
	{
		"stop_id": 8503623,
		"ID": 1103,
		"x": 51.4557650813,
		"y": 36.891172653,
		"h": 1.1648351648
	},
	{
		"stop_id": 8503624,
		"ID": 1103,
		"x": 50.2657362923,
		"y": 38.341155874,
		"h": 1.1648351648
	},
	{
		"stop_id": 8503625,
		"ID": 1103,
		"x": 50.2057629363,
		"y": 38.868218414,
		"h": 1.1648351648
	},
	{
		"stop_id": 8503760,
		"ID": 1103,
		"x": 51.0107100293,
		"y": 37.582173997,
		"h": 1.1648351648
	},
	{
		"stop_id": 8573797,
		"ID": 1103,
		"x": 50.5357031373,
		"y": 38.097188801,
		"h": 1.1648351648
	},
	{
		"stop_id": 8573798,
		"ID": 1103,
		"x": 51.2297696003,
		"y": 37.263235559,
		"h": 1.1648351648
	},
	{
		"stop_id": 8503626,
		"ID": 1140,
		"x": 50.8177291723,
		"y": 40.105250206,
		"h": 1.032967033
	},
	{
		"stop_id": 8503628,
		"ID": 1140,
		"x": 50.9387361513,
		"y": 39.338146153,
		"h": 1.032967033
	},
	{
		"stop_id": 8503627,
		"ID": 1145,
		"x": 53.1027217863,
		"y": 66.433193755,
		"h": 1.2307692308
	},
	{
		"stop_id": 8506850,
		"ID": 1145,
		"x": 55.7327405503,
		"y": 70.416171468,
		"h": 1.2307692308
	},
	{
		"stop_id": 8573283,
		"ID": 1145,
		"x": 51.7327544683,
		"y": 66.720176539,
		"h": 1.2307692308
	},
	{
		"stop_id": 8573647,
		"ID": 1145,
		"x": 51.4577009133,
		"y": 70.105240706,
		"h": 1.2307692308
	},
	{
		"stop_id": 8578595,
		"ID": 1145,
		"x": 55.6117316343,
		"y": 69.735241384,
		"h": 1.2307692308
	},
	{
		"stop_id": 8578609,
		"ID": 1145,
		"x": 55.7497553793,
		"y": 70.217224479,
		"h": 1.2307692308
	},
	{
		"stop_id": 8581687,
		"ID": 1145,
		"x": 51.0577722973,
		"y": 67.23016135,
		"h": 1.2307692308
	},
	{
		"stop_id": 8581688,
		"ID": 1145,
		"x": 51.4677658203,
		"y": 66.960173654,
		"h": 1.2307692308
	},
	{
		"stop_id": 8503629,
		"ID": 1244,
		"x": 71.3077219693,
		"y": 37.280211773,
		"h": 1.3956043956
	},
	{
		"stop_id": 8509461,
		"ID": 1244,
		"x": 66.9597325533,
		"y": 39.595220372,
		"h": 1.3956043956
	},
	{
		"stop_id": 8509771,
		"ID": 1244,
		"x": 68.4827442023,
		"y": 37.655147715,
		"h": 1.3956043956
	},
	{
		"stop_id": 8509852,
		"ID": 1244,
		"x": 70.0827320763,
		"y": 37.355227928,
		"h": 1.3956043956
	},
	{
		"stop_id": 8530659,
		"ID": 1244,
		"x": 69.7807330053,
		"y": 39.219161541,
		"h": 1.3956043956
	},
	{
		"stop_id": 8573891,
		"ID": 1244,
		"x": 67.6827163453,
		"y": 37.705242468,
		"h": 1.3956043956
	},
	{
		"stop_id": 8573892,
		"ID": 1244,
		"x": 67.9827583883,
		"y": 37.705223977,
		"h": 1.3956043956
	},
	{
		"stop_id": 8573893,
		"ID": 1244,
		"x": 68.7327339473,
		"y": 37.530211588,
		"h": 1.3956043956
	},
	{
		"stop_id": 8573894,
		"ID": 1244,
		"x": 69.3577367783,
		"y": 37.705198368,
		"h": 1.3956043956
	},
	{
		"stop_id": 8573895,
		"ID": 1244,
		"x": 70.7077350213,
		"y": 37.280154129,
		"h": 1.3956043956
	},
	{
		"stop_id": 8573896,
		"ID": 1244,
		"x": 71.0827273203,
		"y": 37.280155279,
		"h": 1.3956043956
	},
	{
		"stop_id": 8573897,
		"ID": 1244,
		"x": 71.7077191713,
		"y": 36.880143718,
		"h": 1.3956043956
	},
	{
		"stop_id": 8578494,
		"ID": 1244,
		"x": 66.7877678443,
		"y": 39.400185568,
		"h": 1.3956043956
	},
	{
		"stop_id": 8503684,
		"ID": 1067,
		"x": 42.0067563093,
		"y": 27.882156629,
		"h": 1.4945054945
	},
	{
		"stop_id": 8503745,
		"ID": 1067,
		"x": 43.7577389103,
		"y": 29.105245411,
		"h": 1.4945054945
	},
	{
		"stop_id": 8503746,
		"ID": 1067,
		"x": 42.8617253233,
		"y": 29.841173722,
		"h": 1.4945054945
	},
	{
		"stop_id": 8503753,
		"ID": 1067,
		"x": 44.3867092063,
		"y": 26.019239476,
		"h": 1.4945054945
	},
	{
		"stop_id": 8503757,
		"ID": 1067,
		"x": 42.3007359393,
		"y": 28.200177233,
		"h": 1.4945054945
	},
	{
		"stop_id": 8503759,
		"ID": 1067,
		"x": 43.6687287113,
		"y": 30.20114248,
		"h": 1.4945054945
	},
	{
		"stop_id": 8503870,
		"ID": 1067,
		"x": 41.5737232713,
		"y": 27.47817317,
		"h": 1.4945054945
	},
	{
		"stop_id": 8530404,
		"ID": 1067,
		"x": 41.6017049853,
		"y": 27.491212975,
		"h": 1.4945054945
	},
	{
		"stop_id": 8530406,
		"ID": 1067,
		"x": 44.4357317343,
		"y": 26.016203925,
		"h": 1.4945054945
	},
	{
		"stop_id": 8573777,
		"ID": 1067,
		"x": 44.0327161473,
		"y": 30.955221432,
		"h": 1.4945054945
	},
	{
		"stop_id": 8573778,
		"ID": 1067,
		"x": 43.9357169823,
		"y": 30.696239482,
		"h": 1.4945054945
	},
	{
		"stop_id": 8573779,
		"ID": 1067,
		"x": 42.1407342183,
		"y": 29.045145446,
		"h": 1.4945054945
	},
	{
		"stop_id": 8573785,
		"ID": 1067,
		"x": 43.8327559263,
		"y": 30.080236423,
		"h": 1.4945054945
	},
	{
		"stop_id": 8573787,
		"ID": 1067,
		"x": 43.8727511983,
		"y": 28.159241744,
		"h": 1.4945054945
	},
	{
		"stop_id": 8573788,
		"ID": 1067,
		"x": 44.0977514223,
		"y": 27.670142326,
		"h": 1.4945054945
	},
	{
		"stop_id": 8577502,
		"ID": 1067,
		"x": 41.6757055443,
		"y": 27.355153268,
		"h": 1.4945054945
	},
	{
		"stop_id": 8503688,
		"ID": 1111,
		"x": 50.1137302753,
		"y": 83.811186473,
		"h": 2.4835164835
	},
	{
		"stop_id": 8506171,
		"ID": 1111,
		"x": 50.1537219033,
		"y": 85.506180371,
		"h": 2.4835164835
	},
	{
		"stop_id": 8506172,
		"ID": 1111,
		"x": 51.4727178003,
		"y": 83.706174178,
		"h": 2.4835164835
	},
	{
		"stop_id": 8506179,
		"ID": 1111,
		"x": 50.4527171483,
		"y": 84.148232974,
		"h": 2.4835164835
	},
	{
		"stop_id": 8506732,
		"ID": 1111,
		"x": 50.1677285363,
		"y": 85.530239615,
		"h": 2.4835164835
	},
	{
		"stop_id": 8506743,
		"ID": 1111,
		"x": 48.5197229793,
		"y": 85.258249203,
		"h": 2.4835164835
	},
	{
		"stop_id": 8506744,
		"ID": 1111,
		"x": 47.7897165843,
		"y": 85.235234584,
		"h": 2.4835164835
	},
	{
		"stop_id": 8506859,
		"ID": 1111,
		"x": 49.9227408213,
		"y": 80.598209635,
		"h": 2.4835164835
	},
	{
		"stop_id": 8506865,
		"ID": 1111,
		"x": 49.5107492973,
		"y": 81.804172237,
		"h": 2.4835164835
	},
	{
		"stop_id": 8506866,
		"ID": 1111,
		"x": 50.5637206763,
		"y": 82.4781909,
		"h": 2.4835164835
	},
	{
		"stop_id": 8506872,
		"ID": 1111,
		"x": 49.9537363323,
		"y": 85.686177101,
		"h": 2.4835164835
	},
	{
		"stop_id": 8573303,
		"ID": 1111,
		"x": 49.9277530013,
		"y": 85.561141427,
		"h": 2.4835164835
	},
	{
		"stop_id": 8573305,
		"ID": 1111,
		"x": 49.0617026143,
		"y": 85.287227866,
		"h": 2.4835164835
	},
	{
		"stop_id": 8573359,
		"ID": 1111,
		"x": 50.4417343423,
		"y": 85.358192124,
		"h": 2.4835164835
	},
	{
		"stop_id": 8573360,
		"ID": 1111,
		"x": 50.1667707683,
		"y": 85.177247604,
		"h": 2.4835164835
	},
	{
		"stop_id": 8573361,
		"ID": 1111,
		"x": 50.6277533063,
		"y": 82.796216133,
		"h": 2.4835164835
	},
	{
		"stop_id": 8573364,
		"ID": 1111,
		"x": 50.5877388473,
		"y": 85.12315562,
		"h": 2.4835164835
	},
	{
		"stop_id": 8578082,
		"ID": 1111,
		"x": 49.2847543873,
		"y": 84.803140999,
		"h": 2.4835164835
	},
	{
		"stop_id": 8578089,
		"ID": 1111,
		"x": 49.6237624783,
		"y": 85.134247561,
		"h": 2.4835164835
	},
	{
		"stop_id": 8578809,
		"ID": 1111,
		"x": 50.1387368353,
		"y": 85.850201773,
		"h": 2.4835164835
	},
	{
		"stop_id": 8578813,
		"ID": 1111,
		"x": 49.6877633933,
		"y": 85.414231281,
		"h": 2.4835164835
	},
	{
		"stop_id": 8578815,
		"ID": 1111,
		"x": 48.7367188953,
		"y": 83.81019937,
		"h": 2.4835164835
	},
	{
		"stop_id": 8578816,
		"ID": 1111,
		"x": 48.4707017003,
		"y": 83.804207265,
		"h": 2.4835164835
	},
	{
		"stop_id": 8578817,
		"ID": 1111,
		"x": 47.3597138613,
		"y": 84.046180982,
		"h": 2.4835164835
	},
	{
		"stop_id": 8578818,
		"ID": 1111,
		"x": 46.8887425203,
		"y": 83.777213537,
		"h": 2.4835164835
	},
	{
		"stop_id": 8578819,
		"ID": 1111,
		"x": 46.6677546023,
		"y": 83.813150957,
		"h": 2.4835164835
	},
	{
		"stop_id": 8579932,
		"ID": 1111,
		"x": 49.3837055443,
		"y": 85.018153698,
		"h": 2.4835164835
	},
	{
		"stop_id": 8581410,
		"ID": 1111,
		"x": 47.9707488263,
		"y": 84.502232226,
		"h": 2.4835164835
	},
	{
		"stop_id": 8581523,
		"ID": 1111,
		"x": 48.5247161633,
		"y": 83.581226633,
		"h": 2.4835164835
	},
	{
		"stop_id": 8581524,
		"ID": 1111,
		"x": 47.2977435403,
		"y": 85.346176735,
		"h": 2.4835164835
	},
	{
		"stop_id": 8582010,
		"ID": 1111,
		"x": 46.3767458693,
		"y": 84.037222218,
		"h": 2.4835164835
	},
	{
		"stop_id": 8582455,
		"ID": 1111,
		"x": 47.4327650993,
		"y": 85.149231807,
		"h": 2.4835164835
	},
	{
		"stop_id": 8582494,
		"ID": 1111,
		"x": 49.3977738093,
		"y": 85.324234783,
		"h": 2.4835164835
	},
	{
		"stop_id": 8583317,
		"ID": 1111,
		"x": 49.1267665583,
		"y": 85.772180668,
		"h": 2.4835164835
	},
	{
		"stop_id": 8583326,
		"ID": 1111,
		"x": 48.8777178453,
		"y": 85.274165381,
		"h": 2.4835164835
	},
	{
		"stop_id": 8583333,
		"ID": 1111,
		"x": 50.7487202733,
		"y": 84.91320231,
		"h": 2.4835164835
	},
	{
		"stop_id": 8583339,
		"ID": 1111,
		"x": 48.6557679973,
		"y": 85.463142786,
		"h": 2.4835164835
	},
	{
		"stop_id": 8583413,
		"ID": 1111,
		"x": 49.8157173283,
		"y": 85.724205314,
		"h": 2.4835164835
	},
	{
		"stop_id": 8594735,
		"ID": 1111,
		"x": 49.4347517383,
		"y": 85.759184912,
		"h": 2.4835164835
	},
	{
		"stop_id": 8594738,
		"ID": 1111,
		"x": 49.5067288043,
		"y": 85.608161526,
		"h": 2.4835164835
	},
	{
		"stop_id": 8594747,
		"ID": 1111,
		"x": 48.6847488143,
		"y": 85.787177778,
		"h": 2.4835164835
	},
	{
		"stop_id": 8594753,
		"ID": 1111,
		"x": 50.0567701643,
		"y": 85.651171237,
		"h": 2.4835164835
	},
	{
		"stop_id": 8594755,
		"ID": 1111,
		"x": 48.3667230883,
		"y": 85.292144338,
		"h": 2.4835164835
	},
	{
		"stop_id": 8594762,
		"ID": 1111,
		"x": 48.8167328373,
		"y": 85.26614896,
		"h": 2.4835164835
	},
	{
		"stop_id": 8594764,
		"ID": 1111,
		"x": 48.4857034213,
		"y": 85.430219454,
		"h": 2.4835164835
	},
	{
		"stop_id": 8594767,
		"ID": 1111,
		"x": 48.8677232483,
		"y": 85.760181194,
		"h": 2.4835164835
	},
	{
		"stop_id": 8503705,
		"ID": 1010,
		"x": 35.9327382453,
		"y": 84.355214482,
		"h": 1.4615384615
	},
	{
		"stop_id": 8506045,
		"ID": 1010,
		"x": 34.8237578793,
		"y": 84.266183902,
		"h": 1.4615384615
	},
	{
		"stop_id": 8506046,
		"ID": 1010,
		"x": 34.0557048693,
		"y": 86.346216784,
		"h": 1.4615384615
	},
	{
		"stop_id": 8506952,
		"ID": 1010,
		"x": 33.0377397363,
		"y": 87.720171291,
		"h": 1.4615384615
	},
	{
		"stop_id": 8506989,
		"ID": 1010,
		"x": 31.3577295603,
		"y": 87.205156411,
		"h": 1.4615384615
	},
	{
		"stop_id": 8573679,
		"ID": 1010,
		"x": 34.1827071533,
		"y": 83.310179137,
		"h": 1.4615384615
	},
	{
		"stop_id": 8573680,
		"ID": 1010,
		"x": 33.7827550113,
		"y": 83.905214282,
		"h": 1.4615384615
	},
	{
		"stop_id": 8573681,
		"ID": 1010,
		"x": 32.7627683943,
		"y": 84.97815397,
		"h": 1.4615384615
	},
	{
		"stop_id": 8573682,
		"ID": 1010,
		"x": 30.9827705843,
		"y": 84.930190304,
		"h": 1.4615384615
	},
	{
		"stop_id": 8573700,
		"ID": 1010,
		"x": 36.2097229963,
		"y": 86.700208612,
		"h": 1.4615384615
	},
	{
		"stop_id": 8573701,
		"ID": 1010,
		"x": 34.0077133623,
		"y": 86.330219704,
		"h": 1.4615384615
	},
	{
		"stop_id": 8581527,
		"ID": 1010,
		"x": 31.8577061773,
		"y": 85.105161713,
		"h": 1.4615384615
	},
	{
		"stop_id": 8581770,
		"ID": 1010,
		"x": 32.7877240643,
		"y": 87.377188099,
		"h": 1.4615384615
	},
	{
		"stop_id": 8583830,
		"ID": 1010,
		"x": 32.9257504873,
		"y": 87.659140707,
		"h": 1.4615384615
	},
	{
		"stop_id": 8587717,
		"ID": 1010,
		"x": 34.5877653443,
		"y": 88.399173968,
		"h": 1.4615384615
	},
	{
		"stop_id": 8503724,
		"ID": 1034,
		"x": 37.6837215203,
		"y": 33.337219787,
		"h": 1.2637362637
	},
	{
		"stop_id": 8503725,
		"ID": 1034,
		"x": 37.0417222813,
		"y": 30.609206835,
		"h": 1.2637362637
	},
	{
		"stop_id": 8503861,
		"ID": 1034,
		"x": 37.2507033073,
		"y": 31.526235587,
		"h": 1.2637362637
	},
	{
		"stop_id": 8573760,
		"ID": 1034,
		"x": 37.7477233493,
		"y": 32.888175547,
		"h": 1.2637362637
	},
	{
		"stop_id": 8573761,
		"ID": 1034,
		"x": 37.7637017123,
		"y": 32.436233555,
		"h": 1.2637362637
	},
	{
		"stop_id": 8573762,
		"ID": 1034,
		"x": 37.5247305023,
		"y": 31.902181821,
		"h": 1.2637362637
	},
	{
		"stop_id": 8573763,
		"ID": 1034,
		"x": 36.8147036783,
		"y": 29.788184286,
		"h": 1.2637362637
	},
	{
		"stop_id": 8573764,
		"ID": 1034,
		"x": 36.5827362043,
		"y": 28.780186891,
		"h": 1.2637362637
	},
	{
		"stop_id": 8580431,
		"ID": 1034,
		"x": 37.1437249653,
		"y": 30.915185296,
		"h": 1.2637362637
	},
	{
		"stop_id": 8503730,
		"ID": 1069,
		"x": 40.8027542703,
		"y": 40.343225046,
		"h": 1.5604395604
	},
	{
		"stop_id": 8503731,
		"ID": 1069,
		"x": 42.2287562543,
		"y": 40.857180984,
		"h": 1.5604395604
	},
	{
		"stop_id": 8503732,
		"ID": 1069,
		"x": 42.6907201603,
		"y": 40.630168267,
		"h": 1.5604395604
	},
	{
		"stop_id": 8503733,
		"ID": 1069,
		"x": 42.0597622923,
		"y": 41.708240014,
		"h": 1.5604395604
	},
	{
		"stop_id": 8503734,
		"ID": 1069,
		"x": 42.9017528163,
		"y": 39.244241969,
		"h": 1.5604395604
	},
	{
		"stop_id": 8503737,
		"ID": 1069,
		"x": 43.0537157213,
		"y": 38.190212099,
		"h": 1.5604395604
	},
	{
		"stop_id": 8573780,
		"ID": 1069,
		"x": 43.1557603653,
		"y": 37.897206986,
		"h": 1.5604395604
	},
	{
		"stop_id": 8573781,
		"ID": 1069,
		"x": 43.3447037093,
		"y": 37.394222008,
		"h": 1.5604395604
	},
	{
		"stop_id": 8573782,
		"ID": 1069,
		"x": 43.3577038443,
		"y": 36.880187727,
		"h": 1.5604395604
	},
	{
		"stop_id": 8573791,
		"ID": 1069,
		"x": 40.5077190163,
		"y": 39.539228376,
		"h": 1.5604395604
	},
	{
		"stop_id": 8573792,
		"ID": 1069,
		"x": 42.4027070543,
		"y": 41.434248625,
		"h": 1.5604395604
	},
	{
		"stop_id": 8573793,
		"ID": 1069,
		"x": 42.9077420993,
		"y": 39.605162097,
		"h": 1.5604395604
	},
	{
		"stop_id": 8577050,
		"ID": 1069,
		"x": 41.5657132933,
		"y": 37.664229988,
		"h": 1.5604395604
	},
	{
		"stop_id": 8581746,
		"ID": 1069,
		"x": 42.8867511353,
		"y": 38.530245072,
		"h": 1.5604395604
	},
	{
		"stop_id": 8583223,
		"ID": 1069,
		"x": 41.4557219443,
		"y": 40.432239967,
		"h": 1.5604395604
	},
	{
		"stop_id": 8583224,
		"ID": 1069,
		"x": 42.7177733933,
		"y": 40.050212965,
		"h": 1.5604395604
	},
	{
		"stop_id": 8583528,
		"ID": 1069,
		"x": 43.1447257073,
		"y": 37.991195315,
		"h": 1.5604395604
	},
	{
		"stop_id": 8583529,
		"ID": 1069,
		"x": 43.2517277313,
		"y": 38.197193257,
		"h": 1.5604395604
	},
	{
		"stop_id": 8503739,
		"ID": 1068,
		"x": 43.1627393923,
		"y": 34.713151828,
		"h": 1.3626373626
	},
	{
		"stop_id": 8503740,
		"ID": 1068,
		"x": 43.9767438363,
		"y": 34.832236513,
		"h": 1.3626373626
	},
	{
		"stop_id": 8503741,
		"ID": 1068,
		"x": 45.0527087623,
		"y": 33.792199373,
		"h": 1.3626373626
	},
	{
		"stop_id": 8503744,
		"ID": 1068,
		"x": 44.6157471663,
		"y": 32.539191732,
		"h": 1.3626373626
	},
	{
		"stop_id": 8503775,
		"ID": 1068,
		"x": 44.8337742253,
		"y": 34.393230643,
		"h": 1.3626373626
	},
	{
		"stop_id": 8573774,
		"ID": 1068,
		"x": 41.9227165033,
		"y": 36.26319775,
		"h": 1.3626373626
	},
	{
		"stop_id": 8573775,
		"ID": 1068,
		"x": 44.4857732823,
		"y": 34.597170252,
		"h": 1.3626373626
	},
	{
		"stop_id": 8573776,
		"ID": 1068,
		"x": 44.2207146153,
		"y": 31.541245827,
		"h": 1.3626373626
	},
	{
		"stop_id": 8573783,
		"ID": 1068,
		"x": 43.5077251553,
		"y": 35.792225452,
		"h": 1.3626373626
	},
	{
		"stop_id": 8580525,
		"ID": 1068,
		"x": 43.3367017153,
		"y": 36.300184902,
		"h": 1.3626373626
	},
	{
		"stop_id": 8583202,
		"ID": 1068,
		"x": 45.5517186363,
		"y": 33.156202393,
		"h": 1.3626373626
	},
	{
		"stop_id": 8583632,
		"ID": 1068,
		"x": 43.6297547133,
		"y": 35.029237989,
		"h": 1.3626373626
	},
	{
		"stop_id": 8503742,
		"ID": 1102,
		"x": 46.4297046043,
		"y": 32.077219715,
		"h": 1.0659340659
	},
	{
		"stop_id": 8503743,
		"ID": 1102,
		"x": 47.4187152923,
		"y": 30.913184743,
		"h": 1.0659340659
	},
	{
		"stop_id": 8573784,
		"ID": 1102,
		"x": 46.8397462923,
		"y": 31.759195219,
		"h": 1.0659340659
	},
	{
		"stop_id": 8503755,
		"ID": 1139,
		"x": 52.6787158923,
		"y": 35.666209603,
		"h": 1.032967033
	},
	{
		"stop_id": 8573799,
		"ID": 1139,
		"x": 51.5887488383,
		"y": 35.79917771,
		"h": 1.032967033
	},
	{
		"stop_id": 8503756,
		"ID": 1138,
		"x": 54.3817523333,
		"y": 26.614201901,
		"h": 1.1318681319
	},
	{
		"stop_id": 8503762,
		"ID": 1138,
		"x": 52.2357500843,
		"y": 26.470222307,
		"h": 1.1318681319
	},
	{
		"stop_id": 8503774,
		"ID": 1138,
		"x": 54.8577254443,
		"y": 26.880185186,
		"h": 1.1318681319
	},
	{
		"stop_id": 8573906,
		"ID": 1138,
		"x": 53.2187458993,
		"y": 27.013143557,
		"h": 1.1318681319
	},
	{
		"stop_id": 8583653,
		"ID": 1138,
		"x": 54.0567733523,
		"y": 26.85717397,
		"h": 1.1318681319
	},
	{
		"stop_id": 8503765,
		"ID": 1173,
		"x": 59.2907672703,
		"y": 28.057180662,
		"h": 1
	},
	{
		"stop_id": 8503768,
		"ID": 1214,
		"x": 62.1787558883,
		"y": 48.698209172,
		"h": 1.2967032967
	},
	{
		"stop_id": 8503974,
		"ID": 1214,
		"x": 60.8207361143,
		"y": 51.965148425,
		"h": 1.2967032967
	},
	{
		"stop_id": 8503978,
		"ID": 1214,
		"x": 61.7727025593,
		"y": 53.283166606,
		"h": 1.2967032967
	},
	{
		"stop_id": 8503979,
		"ID": 1214,
		"x": 61.4757155653,
		"y": 52.442193359,
		"h": 1.2967032967
	},
	{
		"stop_id": 8503981,
		"ID": 1214,
		"x": 60.8297439243,
		"y": 50.65616286,
		"h": 1.2967032967
	},
	{
		"stop_id": 8503994,
		"ID": 1214,
		"x": 61.6937710713,
		"y": 49.312222937,
		"h": 1.2967032967
	},
	{
		"stop_id": 8574439,
		"ID": 1214,
		"x": 61.0247062763,
		"y": 50.394242979,
		"h": 1.2967032967
	},
	{
		"stop_id": 8574445,
		"ID": 1214,
		"x": 60.4487527843,
		"y": 51.392150765,
		"h": 1.2967032967
	},
	{
		"stop_id": 8574479,
		"ID": 1214,
		"x": 61.3987651713,
		"y": 49.86720707,
		"h": 1.2967032967
	},
	{
		"stop_id": 8578552,
		"ID": 1214,
		"x": 61.9077559753,
		"y": 53.630213753,
		"h": 1.2967032967
	},
	{
		"stop_id": 8503950,
		"ID": 1014,
		"x": 31.7977671603,
		"y": 110.815189994,
		"h": 1.5604395604
	},
	{
		"stop_id": 8503953,
		"ID": 1014,
		"x": 33.0977242333,
		"y": 109.502247801,
		"h": 1.5604395604
	},
	{
		"stop_id": 8503955,
		"ID": 1014,
		"x": 31.3377189193,
		"y": 107.74516844,
		"h": 1.5604395604
	},
	{
		"stop_id": 8503963,
		"ID": 1014,
		"x": 33.0727209153,
		"y": 110.630213927,
		"h": 1.5604395604
	},
	{
		"stop_id": 8503964,
		"ID": 1014,
		"x": 32.6777345713,
		"y": 107.565221317,
		"h": 1.5604395604
	},
	{
		"stop_id": 8503966,
		"ID": 1014,
		"x": 31.9727644113,
		"y": 110.105158069,
		"h": 1.5604395604
	},
	{
		"stop_id": 8573483,
		"ID": 1014,
		"x": 32.0977296863,
		"y": 106.205149788,
		"h": 1.5604395604
	},
	{
		"stop_id": 8573484,
		"ID": 1014,
		"x": 32.4827712863,
		"y": 107.530243974,
		"h": 1.5604395604
	},
	{
		"stop_id": 8573486,
		"ID": 1014,
		"x": 31.5827610693,
		"y": 108.655227153,
		"h": 1.5604395604
	},
	{
		"stop_id": 8573487,
		"ID": 1014,
		"x": 31.7577510753,
		"y": 109.615145048,
		"h": 1.5604395604
	},
	{
		"stop_id": 8573492,
		"ID": 1014,
		"x": 35.1827017433,
		"y": 106.535141615,
		"h": 1.5604395604
	},
	{
		"stop_id": 8573493,
		"ID": 1014,
		"x": 35.3027378013,
		"y": 106.970248776,
		"h": 1.5604395604
	},
	{
		"stop_id": 8573494,
		"ID": 1014,
		"x": 34.3897015553,
		"y": 107.440229071,
		"h": 1.5604395604
	},
	{
		"stop_id": 8573495,
		"ID": 1014,
		"x": 32.7277008093,
		"y": 110.22018671,
		"h": 1.5604395604
	},
	{
		"stop_id": 8594364,
		"ID": 1014,
		"x": 34.9527209853,
		"y": 107.290232318,
		"h": 1.5604395604
	},
	{
		"stop_id": 8595529,
		"ID": 1014,
		"x": 36.2917188123,
		"y": 108.138246151,
		"h": 1.5604395604
	},
	{
		"stop_id": 8595530,
		"ID": 1014,
		"x": 36.0637670783,
		"y": 107.824246269,
		"h": 1.5604395604
	},
	{
		"stop_id": 8595531,
		"ID": 1014,
		"x": 35.5737188343,
		"y": 106.952168063,
		"h": 1.5604395604
	},
	{
		"stop_id": 8503951,
		"ID": 981,
		"x": 28.1167100783,
		"y": 111.597231491,
		"h": 1.0659340659
	},
	{
		"stop_id": 8573476,
		"ID": 981,
		"x": 28.6827696263,
		"y": 110.230143742,
		"h": 1.0659340659
	},
	{
		"stop_id": 8573477,
		"ID": 981,
		"x": 28.3327221773,
		"y": 111.580223251,
		"h": 1.0659340659
	},
	{
		"stop_id": 8503962,
		"ID": 980,
		"x": 26.3277545763,
		"y": 105.050209065,
		"h": 1.3296703297
	},
	{
		"stop_id": 8503965,
		"ID": 980,
		"x": 28.0827283723,
		"y": 107.950232177,
		"h": 1.3296703297
	},
	{
		"stop_id": 8503968,
		"ID": 980,
		"x": 28.4577567013,
		"y": 103.68018161,
		"h": 1.3296703297
	},
	{
		"stop_id": 8503969,
		"ID": 980,
		"x": 28.8067458623,
		"y": 103.388160744,
		"h": 1.3296703297
	},
	{
		"stop_id": 8573463,
		"ID": 980,
		"x": 26.6077069703,
		"y": 104.797196051,
		"h": 1.3296703297
	},
	{
		"stop_id": 8573464,
		"ID": 980,
		"x": 25.8977526783,
		"y": 105.135238389,
		"h": 1.3296703297
	},
	{
		"stop_id": 8573471,
		"ID": 980,
		"x": 29.1827134813,
		"y": 104.765142454,
		"h": 1.3296703297
	},
	{
		"stop_id": 8573473,
		"ID": 980,
		"x": 28.1077597163,
		"y": 107.705165496,
		"h": 1.3296703297
	},
	{
		"stop_id": 8573474,
		"ID": 980,
		"x": 28.0157501023,
		"y": 108.147186486,
		"h": 1.3296703297
	},
	{
		"stop_id": 8588888,
		"ID": 980,
		"x": 29.6727067163,
		"y": 104.075174424,
		"h": 1.3296703297
	},
	{
		"stop_id": 8589948,
		"ID": 980,
		"x": 27.9827437163,
		"y": 108.530146836,
		"h": 1.3296703297
	},
	{
		"stop_id": 8503975,
		"ID": 1215,
		"x": 62.6377159013,
		"y": 54.400170745,
		"h": 1.7582417582
	},
	{
		"stop_id": 8503976,
		"ID": 1215,
		"x": 64.5377075983,
		"y": 55.870171685,
		"h": 1.7582417582
	},
	{
		"stop_id": 8503977,
		"ID": 1215,
		"x": 63.6277204393,
		"y": 55.160165909,
		"h": 1.7582417582
	},
	{
		"stop_id": 8503983,
		"ID": 1215,
		"x": 65.8077186013,
		"y": 57.580207927,
		"h": 1.7582417582
	},
	{
		"stop_id": 8506200,
		"ID": 1215,
		"x": 64.8777280873,
		"y": 57.471189764,
		"h": 1.7582417582
	},
	{
		"stop_id": 8506201,
		"ID": 1215,
		"x": 64.5817636403,
		"y": 59.713199819,
		"h": 1.7582417582
	},
	{
		"stop_id": 8506616,
		"ID": 1215,
		"x": 62.7967581823,
		"y": 59.523250876,
		"h": 1.7582417582
	},
	{
		"stop_id": 8574002,
		"ID": 1215,
		"x": 64.5937153503,
		"y": 59.720233896,
		"h": 1.7582417582
	},
	{
		"stop_id": 8574005,
		"ID": 1215,
		"x": 62.3577111093,
		"y": 59.405215067,
		"h": 1.7582417582
	},
	{
		"stop_id": 8574006,
		"ID": 1215,
		"x": 62.0687300903,
		"y": 59.399161032,
		"h": 1.7582417582
	},
	{
		"stop_id": 8574008,
		"ID": 1215,
		"x": 64.9027348673,
		"y": 57.469157447,
		"h": 1.7582417582
	},
	{
		"stop_id": 8574010,
		"ID": 1215,
		"x": 64.9337223763,
		"y": 57.841230986,
		"h": 1.7582417582
	},
	{
		"stop_id": 8574011,
		"ID": 1215,
		"x": 65.0307178993,
		"y": 57.966151322,
		"h": 1.7582417582
	},
	{
		"stop_id": 8574012,
		"ID": 1215,
		"x": 65.2797146853,
		"y": 57.852182961,
		"h": 1.7582417582
	},
	{
		"stop_id": 8574013,
		"ID": 1215,
		"x": 66.4147413373,
		"y": 57.394140989,
		"h": 1.7582417582
	},
	{
		"stop_id": 8578553,
		"ID": 1215,
		"x": 64.7977439793,
		"y": 57.000228645,
		"h": 1.7582417582
	},
	{
		"stop_id": 8578554,
		"ID": 1215,
		"x": 64.8277651673,
		"y": 57.41520551,
		"h": 1.7582417582
	},
	{
		"stop_id": 8578578,
		"ID": 1215,
		"x": 64.9137089343,
		"y": 59.851167906,
		"h": 1.7582417582
	},
	{
		"stop_id": 8578579,
		"ID": 1215,
		"x": 64.7987252383,
		"y": 59.421169258,
		"h": 1.7582417582
	},
	{
		"stop_id": 8578580,
		"ID": 1215,
		"x": 64.6797725813,
		"y": 59.082166988,
		"h": 1.7582417582
	},
	{
		"stop_id": 8578581,
		"ID": 1215,
		"x": 64.8467022373,
		"y": 58.415219023,
		"h": 1.7582417582
	},
	{
		"stop_id": 8578584,
		"ID": 1215,
		"x": 65.4687076683,
		"y": 57.044154417,
		"h": 1.7582417582
	},
	{
		"stop_id": 8578585,
		"ID": 1215,
		"x": 65.7217150783,
		"y": 56.646161423,
		"h": 1.7582417582
	},
	{
		"stop_id": 8578586,
		"ID": 1215,
		"x": 66.0017165113,
		"y": 56.029233692,
		"h": 1.7582417582
	},
	{
		"stop_id": 8503984,
		"ID": 1248,
		"x": 70.0277643493,
		"y": 57.412249091,
		"h": 1.4945054945
	},
	{
		"stop_id": 8503986,
		"ID": 1248,
		"x": 68.5577101433,
		"y": 57.380161681,
		"h": 1.4945054945
	},
	{
		"stop_id": 8503987,
		"ID": 1248,
		"x": 66.9127542013,
		"y": 57.539199702,
		"h": 1.4945054945
	},
	{
		"stop_id": 8506294,
		"ID": 1248,
		"x": 68.0697306543,
		"y": 61.746144099,
		"h": 1.4945054945
	},
	{
		"stop_id": 8506695,
		"ID": 1248,
		"x": 70.4197110233,
		"y": 60.662183613,
		"h": 1.4945054945
	},
	{
		"stop_id": 8506704,
		"ID": 1248,
		"x": 68.5937267003,
		"y": 60.906176946,
		"h": 1.4945054945
	},
	{
		"stop_id": 8506705,
		"ID": 1248,
		"x": 69.7567150273,
		"y": 60.560145363,
		"h": 1.4945054945
	},
	{
		"stop_id": 8506770,
		"ID": 1248,
		"x": 71.4077486913,
		"y": 59.755151008,
		"h": 1.4945054945
	},
	{
		"stop_id": 8574014,
		"ID": 1248,
		"x": 68.0077754583,
		"y": 57.518198319,
		"h": 1.4945054945
	},
	{
		"stop_id": 8574015,
		"ID": 1248,
		"x": 69.2357722473,
		"y": 57.095165529,
		"h": 1.4945054945
	},
	{
		"stop_id": 8574016,
		"ID": 1248,
		"x": 70.4577708423,
		"y": 57.419224857,
		"h": 1.4945054945
	},
	{
		"stop_id": 8574179,
		"ID": 1248,
		"x": 68.1277345623,
		"y": 61.836249259,
		"h": 1.4945054945
	},
	{
		"stop_id": 8574180,
		"ID": 1248,
		"x": 68.2877145613,
		"y": 61.26821073,
		"h": 1.4945054945
	},
	{
		"stop_id": 8574181,
		"ID": 1248,
		"x": 69.3107213703,
		"y": 60.638163154,
		"h": 1.4945054945
	},
	{
		"stop_id": 8574182,
		"ID": 1248,
		"x": 71.1077390503,
		"y": 60.249179219,
		"h": 1.4945054945
	},
	{
		"stop_id": 8574196,
		"ID": 1248,
		"x": 71.7037379713,
		"y": 59.598229679,
		"h": 1.4945054945
	},
	{
		"stop_id": 8504014,
		"ID": 144,
		"x": -105.8232736787,
		"y": -27.785788861,
		"h": 1.6263736264
	},
	{
		"stop_id": 8504060,
		"ID": 144,
		"x": -104.6592402737,
		"y": -29.68280968,
		"h": 1.6263736264
	},
	{
		"stop_id": 8504690,
		"ID": 144,
		"x": -106.2672733307,
		"y": -28.619800348,
		"h": 1.6263736264
	},
	{
		"stop_id": 8504960,
		"ID": 144,
		"x": -105.0262568577,
		"y": -31.465755337,
		"h": 1.6263736264
	},
	{
		"stop_id": 8570440,
		"ID": 144,
		"x": -105.8422590577,
		"y": -27.840782887,
		"h": 1.6263736264
	},
	{
		"stop_id": 8570441,
		"ID": 144,
		"x": -104.7922944377,
		"y": -27.494791412,
		"h": 1.6263736264
	},
	{
		"stop_id": 8570442,
		"ID": 144,
		"x": -104.1512764347,
		"y": -27.752809432,
		"h": 1.6263736264
	},
	{
		"stop_id": 8577713,
		"ID": 144,
		"x": -106.2662415477,
		"y": -28.872828738,
		"h": 1.6263736264
	},
	{
		"stop_id": 8577714,
		"ID": 144,
		"x": -106.3562680747,
		"y": -29.2427677,
		"h": 1.6263736264
	},
	{
		"stop_id": 8577715,
		"ID": 144,
		"x": -106.4852439537,
		"y": -29.794830468,
		"h": 1.6263736264
	},
	{
		"stop_id": 8577717,
		"ID": 144,
		"x": -106.2722854557,
		"y": -30.296854892,
		"h": 1.6263736264
	},
	{
		"stop_id": 8578927,
		"ID": 144,
		"x": -106.3262505447,
		"y": -27.865840158,
		"h": 1.6263736264
	},
	{
		"stop_id": 8579191,
		"ID": 144,
		"x": -104.8872935627,
		"y": -31.848776371,
		"h": 1.6263736264
	},
	{
		"stop_id": 8579193,
		"ID": 144,
		"x": -104.9922382257,
		"y": -31.157852321,
		"h": 1.6263736264
	},
	{
		"stop_id": 8579194,
		"ID": 144,
		"x": -105.0202400347,
		"y": -30.117770004,
		"h": 1.6263736264
	},
	{
		"stop_id": 8579195,
		"ID": 144,
		"x": -104.6832368557,
		"y": -29.669845774,
		"h": 1.6263736264
	},
	{
		"stop_id": 8582199,
		"ID": 144,
		"x": -107.8362647897,
		"y": -28.115849979,
		"h": 1.6263736264
	},
	{
		"stop_id": 8582202,
		"ID": 144,
		"x": -106.8922609337,
		"y": -26.954838645,
		"h": 1.6263736264
	},
	{
		"stop_id": 8593758,
		"ID": 144,
		"x": -103.9772315737,
		"y": -29.856847809,
		"h": 1.6263736264
	},
	{
		"stop_id": 8593759,
		"ID": 144,
		"x": -103.5202665147,
		"y": -29.643751118,
		"h": 1.6263736264
	},
	{
		"stop_id": 8504016,
		"ID": 145,
		"x": -106.5422323497,
		"y": -26.169833575,
		"h": 1.8571428571
	},
	{
		"stop_id": 8504017,
		"ID": 145,
		"x": -107.5162971437,
		"y": -24.684832271,
		"h": 1.8571428571
	},
	{
		"stop_id": 8504020,
		"ID": 145,
		"x": -105.8572780917,
		"y": -24.474804548,
		"h": 1.8571428571
	},
	{
		"stop_id": 8504775,
		"ID": 145,
		"x": -106.6192544707,
		"y": -24.651774043,
		"h": 1.8571428571
	},
	{
		"stop_id": 8504789,
		"ID": 145,
		"x": -106.4242534957,
		"y": -26.421771929,
		"h": 1.8571428571
	},
	{
		"stop_id": 8504978,
		"ID": 145,
		"x": -106.9372848637,
		"y": -21.223821001,
		"h": 1.8571428571
	},
	{
		"stop_id": 8570437,
		"ID": 145,
		"x": -108.0062827567,
		"y": -24.0938263,
		"h": 1.8571428571
	},
	{
		"stop_id": 8570438,
		"ID": 145,
		"x": -107.5172967437,
		"y": -24.694829551,
		"h": 1.8571428571
	},
	{
		"stop_id": 8570439,
		"ID": 145,
		"x": -106.3052566147,
		"y": -25.080774411,
		"h": 1.8571428571
	},
	{
		"stop_id": 8570449,
		"ID": 145,
		"x": -105.7182937107,
		"y": -24.185830901,
		"h": 1.8571428571
	},
	{
		"stop_id": 8570450,
		"ID": 145,
		"x": -104.6302373057,
		"y": -24.041767514,
		"h": 1.8571428571
	},
	{
		"stop_id": 8570451,
		"ID": 145,
		"x": -103.7892342347,
		"y": -24.180846938,
		"h": 1.8571428571
	},
	{
		"stop_id": 8570452,
		"ID": 145,
		"x": -103.4582397347,
		"y": -24.047752895,
		"h": 1.8571428571
	},
	{
		"stop_id": 8570458,
		"ID": 145,
		"x": -108.2392749457,
		"y": -24.494825911,
		"h": 1.8571428571
	},
	{
		"stop_id": 8570459,
		"ID": 145,
		"x": -108.2652660077,
		"y": -25.19676174,
		"h": 1.8571428571
	},
	{
		"stop_id": 8577661,
		"ID": 145,
		"x": -107.1002887627,
		"y": -22.692751693,
		"h": 1.8571428571
	},
	{
		"stop_id": 8577677,
		"ID": 145,
		"x": -104.2882584967,
		"y": -22.162781776,
		"h": 1.8571428571
	},
	{
		"stop_id": 8577678,
		"ID": 145,
		"x": -104.5502958767,
		"y": -22.606840196,
		"h": 1.8571428571
	},
	{
		"stop_id": 8577679,
		"ID": 145,
		"x": -105.4782858287,
		"y": -24.117850858,
		"h": 1.8571428571
	},
	{
		"stop_id": 8577681,
		"ID": 145,
		"x": -105.8922446627,
		"y": -24.475758602,
		"h": 1.8571428571
	},
	{
		"stop_id": 8579737,
		"ID": 145,
		"x": -106.1222910637,
		"y": -26.347850607,
		"h": 1.8571428571
	},
	{
		"stop_id": 8579741,
		"ID": 145,
		"x": -103.9072480647,
		"y": -24.799856694,
		"h": 1.8571428571
	},
	{
		"stop_id": 8579800,
		"ID": 145,
		"x": -106.8522460977,
		"y": -24.563793457,
		"h": 1.8571428571
	},
	{
		"stop_id": 8580757,
		"ID": 145,
		"x": -107.1972693237,
		"y": -24.634780325,
		"h": 1.8571428571
	},
	{
		"stop_id": 8582200,
		"ID": 145,
		"x": -107.6312700097,
		"y": -26.593803786,
		"h": 1.8571428571
	},
	{
		"stop_id": 8583253,
		"ID": 145,
		"x": -104.3162252817,
		"y": -24.978816178,
		"h": 1.8571428571
	},
	{
		"stop_id": 8587962,
		"ID": 145,
		"x": -107.1092928357,
		"y": -21.891816305,
		"h": 1.8571428571
	},
	{
		"stop_id": 8504018,
		"ID": 146,
		"x": -107.8202892837,
		"y": -20.247853861,
		"h": 1.6263736264
	},
	{
		"stop_id": 8504021,
		"ID": 146,
		"x": -104.8252459147,
		"y": -19.044809731,
		"h": 1.6263736264
	},
	{
		"stop_id": 8504279,
		"ID": 146,
		"x": -106.6322970407,
		"y": -16.42179741,
		"h": 1.6263736264
	},
	{
		"stop_id": 8504692,
		"ID": 146,
		"x": -106.9102837287,
		"y": -19.242770397,
		"h": 1.6263736264
	},
	{
		"stop_id": 8504970,
		"ID": 146,
		"x": -105.9162263337,
		"y": -17.606755704,
		"h": 1.6263736264
	},
	{
		"stop_id": 8504977,
		"ID": 146,
		"x": -104.6902823367,
		"y": -17.144827044,
		"h": 1.6263736264
	},
	{
		"stop_id": 8504996,
		"ID": 146,
		"x": -104.3882585437,
		"y": -20.236812075,
		"h": 1.6263736264
	},
	{
		"stop_id": 8577656,
		"ID": 146,
		"x": -106.2072242887,
		"y": -17.646751491,
		"h": 1.6263736264
	},
	{
		"stop_id": 8577657,
		"ID": 146,
		"x": -106.5882362007,
		"y": -18.562825242,
		"h": 1.6263736264
	},
	{
		"stop_id": 8577658,
		"ID": 146,
		"x": -106.7202675607,
		"y": -18.903749788,
		"h": 1.6263736264
	},
	{
		"stop_id": 8577659,
		"ID": 146,
		"x": -107.2622596247,
		"y": -19.175846337,
		"h": 1.6263736264
	},
	{
		"stop_id": 8577660,
		"ID": 146,
		"x": -107.2522959527,
		"y": -19.561795057,
		"h": 1.6263736264
	},
	{
		"stop_id": 8577695,
		"ID": 146,
		"x": -104.7352894527,
		"y": -20.285800764,
		"h": 1.6263736264
	},
	{
		"stop_id": 8577696,
		"ID": 146,
		"x": -104.7763001907,
		"y": -19.054849316,
		"h": 1.6263736264
	},
	{
		"stop_id": 8577697,
		"ID": 146,
		"x": -104.8352601427,
		"y": -18.685768688,
		"h": 1.6263736264
	},
	{
		"stop_id": 8577698,
		"ID": 146,
		"x": -105.5112808567,
		"y": -18.157815834,
		"h": 1.6263736264
	},
	{
		"stop_id": 8577700,
		"ID": 146,
		"x": -107.2482642777,
		"y": -16.559799737,
		"h": 1.6263736264
	},
	{
		"stop_id": 8577701,
		"ID": 146,
		"x": -107.5492992057,
		"y": -16.461799944,
		"h": 1.6263736264
	},
	{
		"stop_id": 8577702,
		"ID": 146,
		"x": -107.6762734097,
		"y": -17.547804776,
		"h": 1.6263736264
	},
	{
		"stop_id": 8595957,
		"ID": 146,
		"x": -105.3442301177,
		"y": -17.651822679,
		"h": 1.6263736264
	},
	{
		"stop_id": 8504019,
		"ID": 125,
		"x": -109.2972840167,
		"y": -15.485757648,
		"h": 1.5934065934
	},
	{
		"stop_id": 8504162,
		"ID": 125,
		"x": -109.8882919207,
		"y": -16.532845781,
		"h": 1.5934065934
	},
	{
		"stop_id": 8504903,
		"ID": 125,
		"x": -108.5302874517,
		"y": -15.716837109,
		"h": 1.5934065934
	},
	{
		"stop_id": 8507661,
		"ID": 125,
		"x": -113.4372729527,
		"y": -13.786754818,
		"h": 1.5934065934
	},
	{
		"stop_id": 8570341,
		"ID": 125,
		"x": -109.3232394217,
		"y": -13.765849244,
		"h": 1.5934065934
	},
	{
		"stop_id": 8570342,
		"ID": 125,
		"x": -109.5632760117,
		"y": -14.267793393,
		"h": 1.5934065934
	},
	{
		"stop_id": 8570343,
		"ID": 125,
		"x": -110.4562814707,
		"y": -15.586787404,
		"h": 1.5934065934
	},
	{
		"stop_id": 8570344,
		"ID": 125,
		"x": -111.4872442107,
		"y": -16.272790495,
		"h": 1.5934065934
	},
	{
		"stop_id": 8570345,
		"ID": 125,
		"x": -111.8242373057,
		"y": -16.665750096,
		"h": 1.5934065934
	},
	{
		"stop_id": 8570346,
		"ID": 125,
		"x": -113.1422792147,
		"y": -16.994780551,
		"h": 1.5934065934
	},
	{
		"stop_id": 8570347,
		"ID": 125,
		"x": -114.0582353277,
		"y": -16.091848109,
		"h": 1.5934065934
	},
	{
		"stop_id": 8570348,
		"ID": 125,
		"x": -113.0422419947,
		"y": -15.225832009,
		"h": 1.5934065934
	},
	{
		"stop_id": 8570349,
		"ID": 125,
		"x": -113.4512991487,
		"y": -15.035857574,
		"h": 1.5934065934
	},
	{
		"stop_id": 8570350,
		"ID": 125,
		"x": -113.3172550277,
		"y": -13.219856251,
		"h": 1.5934065934
	},
	{
		"stop_id": 8577652,
		"ID": 125,
		"x": -108.9792322917,
		"y": -14.481843938,
		"h": 1.5934065934
	},
	{
		"stop_id": 8579243,
		"ID": 125,
		"x": -109.4802529317,
		"y": -15.634766377,
		"h": 1.5934065934
	},
	{
		"stop_id": 8583396,
		"ID": 125,
		"x": -114.0112778387,
		"y": -16.215784346,
		"h": 1.5934065934
	},
	{
		"stop_id": 8588154,
		"ID": 125,
		"x": -110.2662828517,
		"y": -16.522778939,
		"h": 1.5934065934
	},
	{
		"stop_id": 8592165,
		"ID": 125,
		"x": -108.9782696497,
		"y": -14.457839067,
		"h": 1.5934065934
	},
	{
		"stop_id": 8504022,
		"ID": 169,
		"x": -102.0902537727,
		"y": -14.861782759,
		"h": 1.4615384615
	},
	{
		"stop_id": 8504094,
		"ID": 169,
		"x": -101.1632532437,
		"y": -15.768845301,
		"h": 1.4615384615
	},
	{
		"stop_id": 8504265,
		"ID": 169,
		"x": -99.9742683177,
		"y": -14.81678125,
		"h": 1.4615384615
	},
	{
		"stop_id": 8504266,
		"ID": 169,
		"x": -100.4522512957,
		"y": -14.690821145,
		"h": 1.4615384615
	},
	{
		"stop_id": 8504697,
		"ID": 169,
		"x": -102.9602682507,
		"y": -17.223808933,
		"h": 1.4615384615
	},
	{
		"stop_id": 8504879,
		"ID": 169,
		"x": -101.3022586267,
		"y": -12.953856059,
		"h": 1.4615384615
	},
	{
		"stop_id": 8504899,
		"ID": 169,
		"x": -102.7572656717,
		"y": -14.950857441,
		"h": 1.4615384615
	},
	{
		"stop_id": 8504936,
		"ID": 169,
		"x": -102.2522298407,
		"y": -14.356816163,
		"h": 1.4615384615
	},
	{
		"stop_id": 8504976,
		"ID": 169,
		"x": -103.1152739077,
		"y": -15.333811652,
		"h": 1.4615384615
	},
	{
		"stop_id": 8577688,
		"ID": 169,
		"x": -100.3052842317,
		"y": -12.598836336,
		"h": 1.4615384615
	},
	{
		"stop_id": 8577689,
		"ID": 169,
		"x": -100.3912240237,
		"y": -13.536855332,
		"h": 1.4615384615
	},
	{
		"stop_id": 8577691,
		"ID": 169,
		"x": -101.4102504757,
		"y": -15.091780023,
		"h": 1.4615384615
	},
	{
		"stop_id": 8577693,
		"ID": 169,
		"x": -102.3942772377,
		"y": -16.0768182,
		"h": 1.4615384615
	},
	{
		"stop_id": 8577694,
		"ID": 169,
		"x": -102.8032279587,
		"y": -16.766811093,
		"h": 1.4615384615
	},
	{
		"stop_id": 8594248,
		"ID": 169,
		"x": -98.6112313177,
		"y": -15.60685347,
		"h": 1.4615384615
	},
	{
		"stop_id": 8504023,
		"ID": 170,
		"x": -100.0392801747,
		"y": -11.06883062,
		"h": 1.7582417582
	},
	{
		"stop_id": 8504091,
		"ID": 170,
		"x": -98.6112718067,
		"y": -9.990815716,
		"h": 1.7582417582
	},
	{
		"stop_id": 8504093,
		"ID": 170,
		"x": -101.0212908377,
		"y": -11.411767744,
		"h": 1.7582417582
	},
	{
		"stop_id": 8504098,
		"ID": 170,
		"x": -99.1742514037,
		"y": -10.341763193,
		"h": 1.7582417582
	},
	{
		"stop_id": 8504155,
		"ID": 170,
		"x": -101.0122575147,
		"y": -8.116762253,
		"h": 1.7582417582
	},
	{
		"stop_id": 8504263,
		"ID": 170,
		"x": -103.3152373787,
		"y": -10.477805615,
		"h": 1.7582417582
	},
	{
		"stop_id": 8504699,
		"ID": 170,
		"x": -101.7512311507,
		"y": -11.313752672,
		"h": 1.7582417582
	},
	{
		"stop_id": 8504772,
		"ID": 170,
		"x": -99.4672578097,
		"y": -10.744815631,
		"h": 1.7582417582
	},
	{
		"stop_id": 8504935,
		"ID": 170,
		"x": -99.7592422927,
		"y": -11.572749807,
		"h": 1.7582417582
	},
	{
		"stop_id": 8570463,
		"ID": 170,
		"x": -99.7922570187,
		"y": -11.144749509,
		"h": 1.7582417582
	},
	{
		"stop_id": 8570465,
		"ID": 170,
		"x": -100.0292477227,
		"y": -11.089797988,
		"h": 1.7582417582
	},
	{
		"stop_id": 8570467,
		"ID": 170,
		"x": -100.7742566547,
		"y": -11.028819641,
		"h": 1.7582417582
	},
	{
		"stop_id": 8570470,
		"ID": 170,
		"x": -102.1922674527,
		"y": -10.444852442,
		"h": 1.7582417582
	},
	{
		"stop_id": 8570471,
		"ID": 170,
		"x": -102.2762890727,
		"y": -10.256823864,
		"h": 1.7582417582
	},
	{
		"stop_id": 8570473,
		"ID": 170,
		"x": -102.2172697837,
		"y": -9.41980103,
		"h": 1.7582417582
	},
	{
		"stop_id": 8570474,
		"ID": 170,
		"x": -101.0672858347,
		"y": -7.294837275,
		"h": 1.7582417582
	},
	{
		"stop_id": 8570484,
		"ID": 170,
		"x": -99.4532865637,
		"y": -8.973757084,
		"h": 1.7582417582
	},
	{
		"stop_id": 8570485,
		"ID": 170,
		"x": -99.6572480337,
		"y": -7.888830039,
		"h": 1.7582417582
	},
	{
		"stop_id": 8577669,
		"ID": 170,
		"x": -99.4062435167,
		"y": -11.625792153,
		"h": 1.7582417582
	},
	{
		"stop_id": 8577686,
		"ID": 170,
		"x": -99.5862346097,
		"y": -10.784824005,
		"h": 1.7582417582
	},
	{
		"stop_id": 8580466,
		"ID": 170,
		"x": -99.9922252627,
		"y": -11.419775323,
		"h": 1.7582417582
	},
	{
		"stop_id": 8580468,
		"ID": 170,
		"x": -100.0332793367,
		"y": -11.779798934,
		"h": 1.7582417582
	},
	{
		"stop_id": 8580471,
		"ID": 170,
		"x": -100.1172278057,
		"y": -11.919751397,
		"h": 1.7582417582
	},
	{
		"stop_id": 8588867,
		"ID": 170,
		"x": -100.6552823687,
		"y": -11.035859422,
		"h": 1.7582417582
	},
	{
		"stop_id": 8504024,
		"ID": 198,
		"x": -96.2862865257,
		"y": -8.08279465,
		"h": 1.6593406593
	},
	{
		"stop_id": 8504092,
		"ID": 198,
		"x": -97.2502759187,
		"y": -9.298801052,
		"h": 1.6593406593
	},
	{
		"stop_id": 8504600,
		"ID": 198,
		"x": -95.6242393197,
		"y": -8.778830214,
		"h": 1.6593406593
	},
	{
		"stop_id": 8504602,
		"ID": 198,
		"x": -96.0542480807,
		"y": -6.294826483,
		"h": 1.6593406593
	},
	{
		"stop_id": 8504894,
		"ID": 198,
		"x": -93.9682705567,
		"y": -7.520762427,
		"h": 1.6593406593
	},
	{
		"stop_id": 8504980,
		"ID": 198,
		"x": -98.0852355907,
		"y": -4.46685961,
		"h": 1.6593406593
	},
	{
		"stop_id": 8504981,
		"ID": 198,
		"x": -98.4292994937,
		"y": -4.997813944,
		"h": 1.6593406593
	},
	{
		"stop_id": 8504998,
		"ID": 198,
		"x": -99.2172969867,
		"y": -6.41085769,
		"h": 1.6593406593
	},
	{
		"stop_id": 8570477,
		"ID": 198,
		"x": -98.9922869527,
		"y": -5.969771645,
		"h": 1.6593406593
	},
	{
		"stop_id": 8570486,
		"ID": 198,
		"x": -97.4272701707,
		"y": -3.870837107,
		"h": 1.6593406593
	},
	{
		"stop_id": 8570493,
		"ID": 198,
		"x": -96.2572745847,
		"y": -8.026831344,
		"h": 1.6593406593
	},
	{
		"stop_id": 8570494,
		"ID": 198,
		"x": -96.3982897937,
		"y": -7.358842013,
		"h": 1.6593406593
	},
	{
		"stop_id": 8570495,
		"ID": 198,
		"x": -96.3172470897,
		"y": -8.294827495,
		"h": 1.6593406593
	},
	{
		"stop_id": 8575838,
		"ID": 198,
		"x": -96.0692524257,
		"y": -6.084847499,
		"h": 1.6593406593
	},
	{
		"stop_id": 8577703,
		"ID": 198,
		"x": -96.9172298837,
		"y": -8.901782025,
		"h": 1.6593406593
	},
	{
		"stop_id": 8577706,
		"ID": 198,
		"x": -94.7862647127,
		"y": -7.992829825,
		"h": 1.6593406593
	},
	{
		"stop_id": 8582244,
		"ID": 198,
		"x": -97.2022657787,
		"y": -8.494792246,
		"h": 1.6593406593
	},
	{
		"stop_id": 8582245,
		"ID": 198,
		"x": -97.3352345547,
		"y": -9.006782141,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583423,
		"ID": 198,
		"x": -99.3772441577,
		"y": -6.106751097,
		"h": 1.6593406593
	},
	{
		"stop_id": 8588819,
		"ID": 198,
		"x": -95.5672287897,
		"y": -8.132834629,
		"h": 1.6593406593
	},
	{
		"stop_id": 8591686,
		"ID": 198,
		"x": -96.5982303987,
		"y": -8.034856847,
		"h": 1.6593406593
	},
	{
		"stop_id": 8504025,
		"ID": 231,
		"x": -93.2262299577,
		"y": -4.918825483,
		"h": 1.5934065934
	},
	{
		"stop_id": 8504026,
		"ID": 231,
		"x": -90.5992862097,
		"y": -4.709847486,
		"h": 1.5934065934
	},
	{
		"stop_id": 8504548,
		"ID": 231,
		"x": -92.9782886467,
		"y": -3.946810863,
		"h": 1.5934065934
	},
	{
		"stop_id": 8504641,
		"ID": 231,
		"x": -90.2532990537,
		"y": -2.016772565,
		"h": 1.5934065934
	},
	{
		"stop_id": 8504771,
		"ID": 231,
		"x": -92.2422425317,
		"y": -0.969849901,
		"h": 1.5934065934
	},
	{
		"stop_id": 8504791,
		"ID": 231,
		"x": -91.5652282987,
		"y": -6.367759861,
		"h": 1.5934065934
	},
	{
		"stop_id": 8504796,
		"ID": 231,
		"x": -93.5772294847,
		"y": -2.009767714,
		"h": 1.5934065934
	},
	{
		"stop_id": 8504947,
		"ID": 231,
		"x": -91.6612731767,
		"y": -2.284782505,
		"h": 1.5934065934
	},
	{
		"stop_id": 8570487,
		"ID": 231,
		"x": -93.8462308777,
		"y": -2.130858562,
		"h": 1.5934065934
	},
	{
		"stop_id": 8570488,
		"ID": 231,
		"x": -92.5642279427,
		"y": -1.421772731,
		"h": 1.5934065934
	},
	{
		"stop_id": 8570489,
		"ID": 231,
		"x": -91.6422994567,
		"y": -0.805773661,
		"h": 1.5934065934
	},
	{
		"stop_id": 8570499,
		"ID": 231,
		"x": -90.6132700487,
		"y": -4.72478309,
		"h": 1.5934065934
	},
	{
		"stop_id": 8570500,
		"ID": 231,
		"x": -91.3982668977,
		"y": -6.014795522,
		"h": 1.5934065934
	},
	{
		"stop_id": 8577794,
		"ID": 231,
		"x": -90.8222281877,
		"y": -1.95881091,
		"h": 1.5934065934
	},
	{
		"stop_id": 8577795,
		"ID": 231,
		"x": -91.3672854197,
		"y": -2.168839837,
		"h": 1.5934065934
	},
	{
		"stop_id": 8577796,
		"ID": 231,
		"x": -92.4702514737,
		"y": -3.477811802,
		"h": 1.5934065934
	},
	{
		"stop_id": 8588832,
		"ID": 231,
		"x": -91.6202296707,
		"y": -2.69477197,
		"h": 1.5934065934
	},
	{
		"stop_id": 8588833,
		"ID": 231,
		"x": -92.7462804317,
		"y": -3.6878491,
		"h": 1.5934065934
	},
	{
		"stop_id": 8595694,
		"ID": 231,
		"x": -93.2222360847,
		"y": -4.96976337,
		"h": 1.5934065934
	},
	{
		"stop_id": 8504027,
		"ID": 264,
		"x": -88.2812733057,
		"y": -3.071842597,
		"h": 2.3516483516
	},
	{
		"stop_id": 8504028,
		"ID": 264,
		"x": -88.5062955747,
		"y": -1.227801516,
		"h": 2.3516483516
	},
	{
		"stop_id": 8504029,
		"ID": 264,
		"x": -85.8792819127,
		"y": -0.538845691,
		"h": 2.3516483516
	},
	{
		"stop_id": 8504030,
		"ID": 264,
		"x": -84.3472621647,
		"y": -0.445749554,
		"h": 2.3516483516
	},
	{
		"stop_id": 8504605,
		"ID": 264,
		"x": -85.8052477647,
		"y": 1.377165738,
		"h": 2.3516483516
	},
	{
		"stop_id": 8504607,
		"ID": 264,
		"x": -84.7322876577,
		"y": 1.750218255,
		"h": 2.3516483516
	},
	{
		"stop_id": 8504611,
		"ID": 264,
		"x": -87.2022849077,
		"y": 1.459247408,
		"h": 2.3516483516
	},
	{
		"stop_id": 8504624,
		"ID": 264,
		"x": -83.5082284517,
		"y": -0.837795969,
		"h": 2.3516483516
	},
	{
		"stop_id": 8504857,
		"ID": 264,
		"x": -84.4472850867,
		"y": -2.622801093,
		"h": 2.3516483516
	},
	{
		"stop_id": 8504944,
		"ID": 264,
		"x": -84.4802664927,
		"y": -1.549774396,
		"h": 2.3516483516
	},
	{
		"stop_id": 8504974,
		"ID": 264,
		"x": -87.7492544737,
		"y": -0.586840709,
		"h": 2.3516483516
	},
	{
		"stop_id": 8570491,
		"ID": 264,
		"x": -89.5842803007,
		"y": -0.846760053,
		"h": 2.3516483516
	},
	{
		"stop_id": 8570492,
		"ID": 264,
		"x": -88.6052674057,
		"y": -1.259785436,
		"h": 2.3516483516
	},
	{
		"stop_id": 8577789,
		"ID": 264,
		"x": -84.6732413287,
		"y": 0.226174901,
		"h": 2.3516483516
	},
	{
		"stop_id": 8577790,
		"ID": 264,
		"x": -87.2172612347,
		"y": -0.816764519,
		"h": 2.3516483516
	},
	{
		"stop_id": 8577791,
		"ID": 264,
		"x": -87.4542642167,
		"y": -0.713838292,
		"h": 2.3516483516
	},
	{
		"stop_id": 8577793,
		"ID": 264,
		"x": -89.0782611347,
		"y": -1.162764597,
		"h": 2.3516483516
	},
	{
		"stop_id": 8577797,
		"ID": 264,
		"x": -87.8092339167,
		"y": -0.042830043,
		"h": 2.3516483516
	},
	{
		"stop_id": 8577798,
		"ID": 264,
		"x": -88.4762521407,
		"y": -0.062780552,
		"h": 2.3516483516
	},
	{
		"stop_id": 8577806,
		"ID": 264,
		"x": -84.8972977047,
		"y": 2.042175294,
		"h": 2.3516483516
	},
	{
		"stop_id": 8577807,
		"ID": 264,
		"x": -85.3782904487,
		"y": 1.562192034,
		"h": 2.3516483516
	},
	{
		"stop_id": 8577808,
		"ID": 264,
		"x": -86.6172940147,
		"y": 1.59221139,
		"h": 2.3516483516
	},
	{
		"stop_id": 8587452,
		"ID": 264,
		"x": -87.5712746427,
		"y": 1.540220228,
		"h": 2.3516483516
	},
	{
		"stop_id": 8588340,
		"ID": 264,
		"x": -84.3042445097,
		"y": -0.011811689,
		"h": 2.3516483516
	},
	{
		"stop_id": 8588341,
		"ID": 264,
		"x": -84.2102988177,
		"y": -0.468768719,
		"h": 2.3516483516
	},
	{
		"stop_id": 8588342,
		"ID": 264,
		"x": -86.0442530247,
		"y": -0.89475163,
		"h": 2.3516483516
	},
	{
		"stop_id": 8588343,
		"ID": 264,
		"x": -85.5572255287,
		"y": -0.683766292,
		"h": 2.3516483516
	},
	{
		"stop_id": 8588345,
		"ID": 264,
		"x": -86.6172948697,
		"y": -0.917768634,
		"h": 2.3516483516
	},
	{
		"stop_id": 8588346,
		"ID": 264,
		"x": -87.7622369177,
		"y": -0.684831083,
		"h": 2.3516483516
	},
	{
		"stop_id": 8588347,
		"ID": 264,
		"x": -88.0002953727,
		"y": -1.017772846,
		"h": 2.3516483516
	},
	{
		"stop_id": 8588603,
		"ID": 264,
		"x": -85.3872996727,
		"y": -2.650854676,
		"h": 2.3516483516
	},
	{
		"stop_id": 8588825,
		"ID": 264,
		"x": -85.6722855017,
		"y": -3.336758342,
		"h": 2.3516483516
	},
	{
		"stop_id": 8588863,
		"ID": 264,
		"x": -85.1322402227,
		"y": 1.930222307,
		"h": 2.3516483516
	},
	{
		"stop_id": 8589130,
		"ID": 264,
		"x": -84.6862950247,
		"y": 0.06214385,
		"h": 2.3516483516
	},
	{
		"stop_id": 8589131,
		"ID": 264,
		"x": -84.0392499657,
		"y": 0.453235506,
		"h": 2.3516483516
	},
	{
		"stop_id": 8589134,
		"ID": 264,
		"x": -84.2812756297,
		"y": 0.115160063,
		"h": 2.3516483516
	},
	{
		"stop_id": 8589145,
		"ID": 264,
		"x": -85.9622278317,
		"y": 1.385190525,
		"h": 2.3516483516
	},
	{
		"stop_id": 8589165,
		"ID": 264,
		"x": -83.3122280387,
		"y": -0.319859084,
		"h": 2.3516483516
	},
	{
		"stop_id": 8589170,
		"ID": 264,
		"x": -84.4372954987,
		"y": -0.226819444,
		"h": 2.3516483516
	},
	{
		"stop_id": 8589173,
		"ID": 264,
		"x": -85.0552292087,
		"y": 0.058249792,
		"h": 2.3516483516
	},
	{
		"stop_id": 8589273,
		"ID": 264,
		"x": -83.8612538407,
		"y": -0.122786329,
		"h": 2.3516483516
	},
	{
		"stop_id": 8595090,
		"ID": 264,
		"x": -87.5492703977,
		"y": -0.618791595,
		"h": 2.3516483516
	},
	{
		"stop_id": 8504063,
		"ID": 195,
		"x": -98.9702523087,
		"y": -24.433847687,
		"h": 1.0659340659
	},
	{
		"stop_id": 8504064,
		"ID": 195,
		"x": -99.1172889567,
		"y": -22.856852253,
		"h": 1.0659340659
	},
	{
		"stop_id": 8570457,
		"ID": 195,
		"x": -99.1172867797,
		"y": -22.844846092,
		"h": 1.0659340659
	},
	{
		"stop_id": 8504065,
		"ID": 196,
		"x": -94.1082817477,
		"y": -19.364850485,
		"h": 1.4285714286
	},
	{
		"stop_id": 8504882,
		"ID": 196,
		"x": -98.0682887707,
		"y": -18.340763945,
		"h": 1.4285714286
	},
	{
		"stop_id": 8504883,
		"ID": 196,
		"x": -97.8102270687,
		"y": -17.055855519,
		"h": 1.4285714286
	},
	{
		"stop_id": 8504934,
		"ID": 196,
		"x": -98.7932426237,
		"y": -18.739848188,
		"h": 1.4285714286
	},
	{
		"stop_id": 8577673,
		"ID": 196,
		"x": -97.9232266567,
		"y": -16.64481321,
		"h": 1.4285714286
	},
	{
		"stop_id": 8587307,
		"ID": 196,
		"x": -98.3572879827,
		"y": -16.10175149,
		"h": 1.4285714286
	},
	{
		"stop_id": 8594242,
		"ID": 196,
		"x": -95.6752665857,
		"y": -15.818840916,
		"h": 1.4285714286
	},
	{
		"stop_id": 8594243,
		"ID": 196,
		"x": -96.4962801737,
		"y": -16.065767217,
		"h": 1.4285714286
	},
	{
		"stop_id": 8594246,
		"ID": 196,
		"x": -94.1752642767,
		"y": -19.197825173,
		"h": 1.4285714286
	},
	{
		"stop_id": 8594247,
		"ID": 196,
		"x": -94.0742762157,
		"y": -18.83077203,
		"h": 1.4285714286
	},
	{
		"stop_id": 8594388,
		"ID": 196,
		"x": -94.0222568217,
		"y": -17.2087942,
		"h": 1.4285714286
	},
	{
		"stop_id": 8594991,
		"ID": 196,
		"x": -94.3732606827,
		"y": -18.388826023,
		"h": 1.4285714286
	},
	{
		"stop_id": 8594992,
		"ID": 196,
		"x": -96.2022967627,
		"y": -18.983843055,
		"h": 1.4285714286
	},
	{
		"stop_id": 8594993,
		"ID": 196,
		"x": -95.2822980347,
		"y": -17.608771967,
		"h": 1.4285714286
	},
	{
		"stop_id": 8504066,
		"ID": 228,
		"x": -91.7962291477,
		"y": -19.516846298,
		"h": 1.8571428571
	},
	{
		"stop_id": 8504067,
		"ID": 228,
		"x": -88.4252945747,
		"y": -20.581796845,
		"h": 1.8571428571
	},
	{
		"stop_id": 8504078,
		"ID": 228,
		"x": -88.7812572367,
		"y": -22.119749469,
		"h": 1.8571428571
	},
	{
		"stop_id": 8504079,
		"ID": 228,
		"x": -88.6412911077,
		"y": -20.904811711,
		"h": 1.8571428571
	},
	{
		"stop_id": 8504086,
		"ID": 228,
		"x": -89.1252309347,
		"y": -19.504750077,
		"h": 1.8571428571
	},
	{
		"stop_id": 8577725,
		"ID": 228,
		"x": -89.2032771487,
		"y": -19.54983427,
		"h": 1.8571428571
	},
	{
		"stop_id": 8577730,
		"ID": 228,
		"x": -88.7582899347,
		"y": -20.035806748,
		"h": 1.8571428571
	},
	{
		"stop_id": 8577731,
		"ID": 228,
		"x": -88.3082547427,
		"y": -20.570794617,
		"h": 1.8571428571
	},
	{
		"stop_id": 8587237,
		"ID": 228,
		"x": -89.5262906787,
		"y": -19.409833525,
		"h": 1.8571428571
	},
	{
		"stop_id": 8593276,
		"ID": 228,
		"x": -89.2672586027,
		"y": -19.802758799,
		"h": 1.8571428571
	},
	{
		"stop_id": 8593277,
		"ID": 228,
		"x": -89.5852304227,
		"y": -19.893785876,
		"h": 1.8571428571
	},
	{
		"stop_id": 8593280,
		"ID": 228,
		"x": -89.1002867577,
		"y": -19.572795697,
		"h": 1.8571428571
	},
	{
		"stop_id": 8593281,
		"ID": 228,
		"x": -88.9852303347,
		"y": -19.634834043,
		"h": 1.8571428571
	},
	{
		"stop_id": 8593282,
		"ID": 228,
		"x": -88.9362523257,
		"y": -19.785815979,
		"h": 1.8571428571
	},
	{
		"stop_id": 8593284,
		"ID": 228,
		"x": -90.1842241187,
		"y": -20.03484551,
		"h": 1.8571428571
	},
	{
		"stop_id": 8593288,
		"ID": 228,
		"x": -88.6022362497,
		"y": -20.256783117,
		"h": 1.8571428571
	},
	{
		"stop_id": 8593291,
		"ID": 228,
		"x": -91.8152825437,
		"y": -19.54175708,
		"h": 1.8571428571
	},
	{
		"stop_id": 8593292,
		"ID": 228,
		"x": -91.0002923827,
		"y": -19.767843618,
		"h": 1.8571428571
	},
	{
		"stop_id": 8593293,
		"ID": 228,
		"x": -91.4552848477,
		"y": -19.516770667,
		"h": 1.8571428571
	},
	{
		"stop_id": 8594241,
		"ID": 228,
		"x": -88.7942587607,
		"y": -22.082778925,
		"h": 1.8571428571
	},
	{
		"stop_id": 8594245,
		"ID": 228,
		"x": -88.6502273227,
		"y": -20.93078176,
		"h": 1.8571428571
	},
	{
		"stop_id": 8595121,
		"ID": 228,
		"x": -90.8312522647,
		"y": -18.915844888,
		"h": 1.8571428571
	},
	{
		"stop_id": 8595122,
		"ID": 228,
		"x": -89.1512870127,
		"y": -19.288846126,
		"h": 1.8571428571
	},
	{
		"stop_id": 8595123,
		"ID": 228,
		"x": -89.8462946967,
		"y": -18.856842893,
		"h": 1.8571428571
	},
	{
		"stop_id": 8595124,
		"ID": 228,
		"x": -90.2672552057,
		"y": -19.115845386,
		"h": 1.8571428571
	},
	{
		"stop_id": 8595125,
		"ID": 228,
		"x": -90.3892443957,
		"y": -18.661769769,
		"h": 1.8571428571
	},
	{
		"stop_id": 8595126,
		"ID": 228,
		"x": -89.6002266157,
		"y": -19.044835948,
		"h": 1.8571428571
	},
	{
		"stop_id": 8504068,
		"ID": 260,
		"x": -87.9102567587,
		"y": -21.027797878,
		"h": 1.7252747253
	},
	{
		"stop_id": 8504069,
		"ID": 260,
		"x": -86.3572501147,
		"y": -21.209764137,
		"h": 1.7252747253
	},
	{
		"stop_id": 8504075,
		"ID": 260,
		"x": -86.8382890067,
		"y": -25.383819185,
		"h": 1.7252747253
	},
	{
		"stop_id": 8504076,
		"ID": 260,
		"x": -86.7342449627,
		"y": -24.498844115,
		"h": 1.7252747253
	},
	{
		"stop_id": 8504077,
		"ID": 260,
		"x": -87.7482658167,
		"y": -23.466786643,
		"h": 1.7252747253
	},
	{
		"stop_id": 8504088,
		"ID": 260,
		"x": -85.7842303197,
		"y": -21.091777405,
		"h": 1.7252747253
	},
	{
		"stop_id": 8504089,
		"ID": 260,
		"x": -84.9722873737,
		"y": -20.942842315,
		"h": 1.7252747253
	},
	{
		"stop_id": 8504541,
		"ID": 260,
		"x": -87.2122741547,
		"y": -23.503840072,
		"h": 1.7252747253
	},
	{
		"stop_id": 8504708,
		"ID": 260,
		"x": -88.1562516657,
		"y": -23.834830636,
		"h": 1.7252747253
	},
	{
		"stop_id": 8504884,
		"ID": 260,
		"x": -86.8962544357,
		"y": -22.608829163,
		"h": 1.7252747253
	},
	{
		"stop_id": 8504919,
		"ID": 260,
		"x": -87.2662935647,
		"y": -22.214832279,
		"h": 1.7252747253
	},
	{
		"stop_id": 8504937,
		"ID": 260,
		"x": -85.6852817337,
		"y": -25.970766612,
		"h": 1.7252747253
	},
	{
		"stop_id": 8577726,
		"ID": 260,
		"x": -86.2692920597,
		"y": -21.296753433,
		"h": 1.7252747253
	},
	{
		"stop_id": 8577727,
		"ID": 260,
		"x": -85.7832734387,
		"y": -21.100786099,
		"h": 1.7252747253
	},
	{
		"stop_id": 8577728,
		"ID": 260,
		"x": -85.1832991857,
		"y": -21.305799461,
		"h": 1.7252747253
	},
	{
		"stop_id": 8577733,
		"ID": 260,
		"x": -85.8132500417,
		"y": -25.544776209,
		"h": 1.7252747253
	},
	{
		"stop_id": 8577737,
		"ID": 260,
		"x": -87.7732645997,
		"y": -23.452773901,
		"h": 1.7252747253
	},
	{
		"stop_id": 8577738,
		"ID": 260,
		"x": -88.6432550557,
		"y": -24.029824147,
		"h": 1.7252747253
	},
	{
		"stop_id": 8587253,
		"ID": 260,
		"x": -86.4622888697,
		"y": -24.645802372,
		"h": 1.7252747253
	},
	{
		"stop_id": 8588862,
		"ID": 260,
		"x": -86.7172311267,
		"y": -21.979765072,
		"h": 1.7252747253
	},
	{
		"stop_id": 8593286,
		"ID": 260,
		"x": -87.6762984577,
		"y": -21.330823422,
		"h": 1.7252747253
	},
	{
		"stop_id": 8594240,
		"ID": 260,
		"x": -86.8812516537,
		"y": -22.849796138,
		"h": 1.7252747253
	},
	{
		"stop_id": 8594990,
		"ID": 260,
		"x": -86.9492884257,
		"y": -25.327844208,
		"h": 1.7252747253
	},
	{
		"stop_id": 8504073,
		"ID": 259,
		"x": -88.6732361737,
		"y": -29.500761984,
		"h": 1.1318681319
	},
	{
		"stop_id": 8504074,
		"ID": 259,
		"x": -87.7922780957,
		"y": -27.780859262,
		"h": 1.1318681319
	},
	{
		"stop_id": 8504922,
		"ID": 259,
		"x": -86.9012356767,
		"y": -28.329788353,
		"h": 1.1318681319
	},
	{
		"stop_id": 8577735,
		"ID": 259,
		"x": -86.6902322807,
		"y": -27.994794201,
		"h": 1.1318681319
	},
	{
		"stop_id": 8577736,
		"ID": 259,
		"x": -87.8202247037,
		"y": -27.802850707,
		"h": 1.1318681319
	},
	{
		"stop_id": 8504095,
		"ID": 230,
		"x": -92.7822261677,
		"y": -9.947799319,
		"h": 1.5604395604
	},
	{
		"stop_id": 8504096,
		"ID": 230,
		"x": -93.0092857267,
		"y": -9.644829212,
		"h": 1.5604395604
	},
	{
		"stop_id": 8504097,
		"ID": 230,
		"x": -91.3882278437,
		"y": -9.794808264,
		"h": 1.5604395604
	},
	{
		"stop_id": 8504262,
		"ID": 230,
		"x": -90.7652620347,
		"y": -8.615794006,
		"h": 1.5604395604
	},
	{
		"stop_id": 8504792,
		"ID": 230,
		"x": -91.4422272967,
		"y": -8.194805737,
		"h": 1.5604395604
	},
	{
		"stop_id": 8504866,
		"ID": 230,
		"x": -93.6372690717,
		"y": -8.53484082,
		"h": 1.5604395604
	},
	{
		"stop_id": 8504878,
		"ID": 230,
		"x": -88.9082639667,
		"y": -9.381751198,
		"h": 1.5604395604
	},
	{
		"stop_id": 8570501,
		"ID": 230,
		"x": -91.2922301967,
		"y": -6.819774176,
		"h": 1.5604395604
	},
	{
		"stop_id": 8570502,
		"ID": 230,
		"x": -91.3072812877,
		"y": -7.672804139,
		"h": 1.5604395604
	},
	{
		"stop_id": 8570503,
		"ID": 230,
		"x": -91.3172773177,
		"y": -7.987803582,
		"h": 1.5604395604
	},
	{
		"stop_id": 8570504,
		"ID": 230,
		"x": -91.9302277827,
		"y": -8.888782438,
		"h": 1.5604395604
	},
	{
		"stop_id": 8577707,
		"ID": 230,
		"x": -93.5112428287,
		"y": -8.896852441,
		"h": 1.5604395604
	},
	{
		"stop_id": 8577709,
		"ID": 230,
		"x": -92.0252811447,
		"y": -9.839762656,
		"h": 1.5604395604
	},
	{
		"stop_id": 8577710,
		"ID": 230,
		"x": -91.8562668117,
		"y": -9.753849667,
		"h": 1.5604395604
	},
	{
		"stop_id": 8577711,
		"ID": 230,
		"x": -90.7222525617,
		"y": -9.75983009,
		"h": 1.5604395604
	},
	{
		"stop_id": 8577712,
		"ID": 230,
		"x": -89.4492724857,
		"y": -9.809754676,
		"h": 1.5604395604
	},
	{
		"stop_id": 8581898,
		"ID": 230,
		"x": -91.6532316217,
		"y": -9.152847005,
		"h": 1.5604395604
	},
	{
		"stop_id": 8595690,
		"ID": 230,
		"x": -89.6182714147,
		"y": -7.358759121,
		"h": 1.5604395604
	},
	{
		"stop_id": 8504099,
		"ID": 263,
		"x": -87.5662272597,
		"y": -7.263829969,
		"h": 1.6593406593
	},
	{
		"stop_id": 8504546,
		"ID": 263,
		"x": -85.3222399377,
		"y": -8.116843531,
		"h": 1.6593406593
	},
	{
		"stop_id": 8504609,
		"ID": 263,
		"x": -86.3892807607,
		"y": -4.838827053,
		"h": 1.6593406593
	},
	{
		"stop_id": 8504855,
		"ID": 263,
		"x": -88.2542429507,
		"y": -7.991854266,
		"h": 1.6593406593
	},
	{
		"stop_id": 8504870,
		"ID": 263,
		"x": -85.9372950187,
		"y": -3.668774689,
		"h": 1.6593406593
	},
	{
		"stop_id": 8504906,
		"ID": 263,
		"x": -86.0142325737,
		"y": -5.82477435,
		"h": 1.6593406593
	},
	{
		"stop_id": 8504909,
		"ID": 263,
		"x": -86.5192397407,
		"y": -5.755831557,
		"h": 1.6593406593
	},
	{
		"stop_id": 8504941,
		"ID": 263,
		"x": -83.7892807887,
		"y": -5.382800337,
		"h": 1.6593406593
	},
	{
		"stop_id": 8577766,
		"ID": 263,
		"x": -83.9382898317,
		"y": -6.003851986,
		"h": 1.6593406593
	},
	{
		"stop_id": 8577767,
		"ID": 263,
		"x": -83.3822981917,
		"y": -6.121804206,
		"h": 1.6593406593
	},
	{
		"stop_id": 8577774,
		"ID": 263,
		"x": -86.1592467597,
		"y": -3.897805323,
		"h": 1.6593406593
	},
	{
		"stop_id": 8577775,
		"ID": 263,
		"x": -86.6742345217,
		"y": -3.977770598,
		"h": 1.6593406593
	},
	{
		"stop_id": 8577776,
		"ID": 263,
		"x": -88.0892562397,
		"y": -9.329771795,
		"h": 1.6593406593
	},
	{
		"stop_id": 8577780,
		"ID": 263,
		"x": -85.4342770127,
		"y": -6.63082138,
		"h": 1.6593406593
	},
	{
		"stop_id": 8577781,
		"ID": 263,
		"x": -86.0302715847,
		"y": -8.272853344,
		"h": 1.6593406593
	},
	{
		"stop_id": 8580714,
		"ID": 263,
		"x": -87.9702767057,
		"y": -8.067795745,
		"h": 1.6593406593
	},
	{
		"stop_id": 8588824,
		"ID": 263,
		"x": -86.8252647027,
		"y": -7.920791889,
		"h": 1.6593406593
	},
	{
		"stop_id": 8594544,
		"ID": 263,
		"x": -86.2342749467,
		"y": -3.829771293,
		"h": 1.6593406593
	},
	{
		"stop_id": 8595691,
		"ID": 263,
		"x": -88.8522597147,
		"y": -6.219835617,
		"h": 1.6593406593
	},
	{
		"stop_id": 8595692,
		"ID": 263,
		"x": -87.0522954897,
		"y": -5.739856609,
		"h": 1.6593406593
	},
	{
		"stop_id": 8595693,
		"ID": 263,
		"x": -87.0922433267,
		"y": -4.549835796,
		"h": 1.6593406593
	},
	{
		"stop_id": 8504100,
		"ID": 297,
		"x": -81.6972399567,
		"y": 1.03824538,
		"h": 4.9230769231
	},
	{
		"stop_id": 8504181,
		"ID": 297,
		"x": -83.6522963667,
		"y": 2.540208318,
		"h": 4.9230769231
	},
	{
		"stop_id": 8504281,
		"ID": 297,
		"x": -82.7622458127,
		"y": -0.416832998,
		"h": 4.9230769231
	},
	{
		"stop_id": 8504282,
		"ID": 297,
		"x": -79.9062666727,
		"y": 0.738213585,
		"h": 4.9230769231
	},
	{
		"stop_id": 8504622,
		"ID": 297,
		"x": -80.0992275947,
		"y": 1.886243649,
		"h": 4.9230769231
	},
	{
		"stop_id": 8504623,
		"ID": 297,
		"x": -83.0782948647,
		"y": -0.557790523,
		"h": 4.9230769231
	},
	{
		"stop_id": 8504625,
		"ID": 297,
		"x": -82.6442351047,
		"y": 2.239208557,
		"h": 4.9230769231
	},
	{
		"stop_id": 8504627,
		"ID": 297,
		"x": -79.1362555897,
		"y": 1.809217413,
		"h": 4.9230769231
	},
	{
		"stop_id": 8504633,
		"ID": 297,
		"x": -82.2862827037,
		"y": -0.081808408,
		"h": 4.9230769231
	},
	{
		"stop_id": 8504634,
		"ID": 297,
		"x": -82.5462647647,
		"y": -0.343846112,
		"h": 4.9230769231
	},
	{
		"stop_id": 8504881,
		"ID": 297,
		"x": -81.7492595027,
		"y": 1.070231398,
		"h": 4.9230769231
	},
	{
		"stop_id": 8519133,
		"ID": 297,
		"x": -81.3562241737,
		"y": 2.308218203,
		"h": 4.9230769231
	},
	{
		"stop_id": 8530013,
		"ID": 297,
		"x": -81.1582402567,
		"y": 1.078196576,
		"h": 4.9230769231
	},
	{
		"stop_id": 8530016,
		"ID": 297,
		"x": -81.2492916827,
		"y": 1.125215154,
		"h": 4.9230769231
	},
	{
		"stop_id": 8577741,
		"ID": 297,
		"x": -81.2172990757,
		"y": 0.067216533,
		"h": 4.9230769231
	},
	{
		"stop_id": 8577771,
		"ID": 297,
		"x": -82.0132447687,
		"y": 0.534153716,
		"h": 4.9230769231
	},
	{
		"stop_id": 8577772,
		"ID": 297,
		"x": -82.1472458117,
		"y": 0.183250409,
		"h": 4.9230769231
	},
	{
		"stop_id": 8577784,
		"ID": 297,
		"x": -82.0092416967,
		"y": 0.911223955,
		"h": 4.9230769231
	},
	{
		"stop_id": 8577785,
		"ID": 297,
		"x": -82.8072459017,
		"y": 0.682245931,
		"h": 4.9230769231
	},
	{
		"stop_id": 8577786,
		"ID": 297,
		"x": -83.2082606487,
		"y": 0.54718281,
		"h": 4.9230769231
	},
	{
		"stop_id": 8577803,
		"ID": 297,
		"x": -82.9822399607,
		"y": 1.970152297,
		"h": 4.9230769231
	},
	{
		"stop_id": 8577804,
		"ID": 297,
		"x": -83.4482554937,
		"y": 2.052250142,
		"h": 4.9230769231
	},
	{
		"stop_id": 8577805,
		"ID": 297,
		"x": -84.2142771187,
		"y": 1.912157065,
		"h": 4.9230769231
	},
	{
		"stop_id": 8577810,
		"ID": 297,
		"x": -81.3422762737,
		"y": 1.20714919,
		"h": 4.9230769231
	},
	{
		"stop_id": 8577811,
		"ID": 297,
		"x": -81.5442430647,
		"y": 1.46123819,
		"h": 4.9230769231
	},
	{
		"stop_id": 8577812,
		"ID": 297,
		"x": -81.9042303697,
		"y": 1.725146216,
		"h": 4.9230769231
	},
	{
		"stop_id": 8577813,
		"ID": 297,
		"x": -82.7052293657,
		"y": 2.513141741,
		"h": 4.9230769231
	},
	{
		"stop_id": 8577814,
		"ID": 297,
		"x": -82.7022708777,
		"y": 3.103217024,
		"h": 4.9230769231
	},
	{
		"stop_id": 8577815,
		"ID": 297,
		"x": -82.1342318547,
		"y": 3.039247061,
		"h": 4.9230769231
	},
	{
		"stop_id": 8577818,
		"ID": 297,
		"x": -82.4302870657,
		"y": 3.42823584,
		"h": 4.9230769231
	},
	{
		"stop_id": 8577819,
		"ID": 297,
		"x": -82.5312693647,
		"y": 2.881223046,
		"h": 4.9230769231
	},
	{
		"stop_id": 8577820,
		"ID": 297,
		"x": -82.0572591697,
		"y": 1.727161948,
		"h": 4.9230769231
	},
	{
		"stop_id": 8577821,
		"ID": 297,
		"x": -83.2392303387,
		"y": 2.259198524,
		"h": 4.9230769231
	},
	{
		"stop_id": 8577837,
		"ID": 297,
		"x": -80.7262386927,
		"y": 1.322233317,
		"h": 4.9230769231
	},
	{
		"stop_id": 8587103,
		"ID": 297,
		"x": -79.7122703787,
		"y": 1.860144424,
		"h": 4.9230769231
	},
	{
		"stop_id": 8587238,
		"ID": 297,
		"x": -82.7622799727,
		"y": 1.988198185,
		"h": 4.9230769231
	},
	{
		"stop_id": 8587255,
		"ID": 297,
		"x": -80.9002394647,
		"y": 1.354197705,
		"h": 4.9230769231
	},
	{
		"stop_id": 8587356,
		"ID": 297,
		"x": -80.3822900487,
		"y": 1.497235856,
		"h": 4.9230769231
	},
	{
		"stop_id": 8587451,
		"ID": 297,
		"x": -83.7742288257,
		"y": 2.034210893,
		"h": 4.9230769231
	},
	{
		"stop_id": 8587794,
		"ID": 297,
		"x": -79.6432599037,
		"y": 0.537226256,
		"h": 4.9230769231
	},
	{
		"stop_id": 8588344,
		"ID": 297,
		"x": -83.7372542147,
		"y": 0.524162308,
		"h": 4.9230769231
	},
	{
		"stop_id": 8588348,
		"ID": 297,
		"x": -82.9022461707,
		"y": 2.856193753,
		"h": 4.9230769231
	},
	{
		"stop_id": 8588349,
		"ID": 297,
		"x": -83.2222570927,
		"y": 2.732157065,
		"h": 4.9230769231
	},
	{
		"stop_id": 8588350,
		"ID": 297,
		"x": -83.5112986877,
		"y": 2.66515502,
		"h": 4.9230769231
	},
	{
		"stop_id": 8588351,
		"ID": 297,
		"x": -81.6942616357,
		"y": 1.391196067,
		"h": 4.9230769231
	},
	{
		"stop_id": 8588352,
		"ID": 297,
		"x": -81.6452696807,
		"y": 1.138217602,
		"h": 4.9230769231
	},
	{
		"stop_id": 8588856,
		"ID": 297,
		"x": -82.6252512977,
		"y": 1.995230459,
		"h": 4.9230769231
	},
	{
		"stop_id": 8588857,
		"ID": 297,
		"x": -83.1202535867,
		"y": 1.965244268,
		"h": 4.9230769231
	},
	{
		"stop_id": 8588858,
		"ID": 297,
		"x": -81.5432946627,
		"y": 0.530194481,
		"h": 4.9230769231
	},
	{
		"stop_id": 8588859,
		"ID": 297,
		"x": -82.0852632797,
		"y": 0.282180656,
		"h": 4.9230769231
	},
	{
		"stop_id": 8588860,
		"ID": 297,
		"x": -82.2262660807,
		"y": 0.831218066,
		"h": 4.9230769231
	},
	{
		"stop_id": 8589129,
		"ID": 297,
		"x": -82.8032726737,
		"y": -0.284828283,
		"h": 4.9230769231
	},
	{
		"stop_id": 8589135,
		"ID": 297,
		"x": -83.0552448947,
		"y": 0.10424155,
		"h": 4.9230769231
	},
	{
		"stop_id": 8589138,
		"ID": 297,
		"x": -80.2122931507,
		"y": 1.700200302,
		"h": 4.9230769231
	},
	{
		"stop_id": 8589139,
		"ID": 297,
		"x": -81.2332489807,
		"y": 2.717209804,
		"h": 4.9230769231
	},
	{
		"stop_id": 8589140,
		"ID": 297,
		"x": -82.3832244227,
		"y": 0.065190437,
		"h": 4.9230769231
	},
	{
		"stop_id": 8589141,
		"ID": 297,
		"x": -79.8262695037,
		"y": 1.348149621,
		"h": 4.9230769231
	},
	{
		"stop_id": 8589142,
		"ID": 297,
		"x": -81.1622570657,
		"y": 1.830158242,
		"h": 4.9230769231
	},
	{
		"stop_id": 8589143,
		"ID": 297,
		"x": -82.2682397617,
		"y": 0.248183961,
		"h": 4.9230769231
	},
	{
		"stop_id": 8589144,
		"ID": 297,
		"x": -80.2112507927,
		"y": 1.470188116,
		"h": 4.9230769231
	},
	{
		"stop_id": 8589146,
		"ID": 297,
		"x": -83.1512667597,
		"y": -0.31782457,
		"h": 4.9230769231
	},
	{
		"stop_id": 8589147,
		"ID": 297,
		"x": -79.9932600057,
		"y": 2.164250043,
		"h": 4.9230769231
	},
	{
		"stop_id": 8589148,
		"ID": 297,
		"x": -81.1132581007,
		"y": -0.066782009,
		"h": 4.9230769231
	},
	{
		"stop_id": 8589149,
		"ID": 297,
		"x": -81.0022609597,
		"y": -0.199802979,
		"h": 4.9230769231
	},
	{
		"stop_id": 8589150,
		"ID": 297,
		"x": -79.8462754727,
		"y": 1.527199016,
		"h": 4.9230769231
	},
	{
		"stop_id": 8589151,
		"ID": 297,
		"x": -79.7152519657,
		"y": 1.699181744,
		"h": 4.9230769231
	},
	{
		"stop_id": 8589152,
		"ID": 297,
		"x": -80.0532562897,
		"y": 1.400167305,
		"h": 4.9230769231
	},
	{
		"stop_id": 8589153,
		"ID": 297,
		"x": -81.9112339557,
		"y": 0.744216629,
		"h": 4.9230769231
	},
	{
		"stop_id": 8589154,
		"ID": 297,
		"x": -81.3722484037,
		"y": 0.267213254,
		"h": 4.9230769231
	},
	{
		"stop_id": 8589155,
		"ID": 297,
		"x": -81.6092555537,
		"y": 0.738210647,
		"h": 4.9230769231
	},
	{
		"stop_id": 8589157,
		"ID": 297,
		"x": -82.3952683447,
		"y": 0.251221776,
		"h": 4.9230769231
	},
	{
		"stop_id": 8589158,
		"ID": 297,
		"x": -79.9422241597,
		"y": 2.450226065,
		"h": 4.9230769231
	},
	{
		"stop_id": 8589159,
		"ID": 297,
		"x": -82.4842675877,
		"y": 0.717247201,
		"h": 4.9230769231
	},
	{
		"stop_id": 8589160,
		"ID": 297,
		"x": -82.5162619297,
		"y": 0.115166899,
		"h": 4.9230769231
	},
	{
		"stop_id": 8589161,
		"ID": 297,
		"x": -81.3592540537,
		"y": 1.114162248,
		"h": 4.9230769231
	},
	{
		"stop_id": 8589162,
		"ID": 297,
		"x": -80.4202789117,
		"y": 1.900243923,
		"h": 4.9230769231
	},
	{
		"stop_id": 8589163,
		"ID": 297,
		"x": -81.3732566747,
		"y": 2.641231617,
		"h": 4.9230769231
	},
	{
		"stop_id": 8589164,
		"ID": 297,
		"x": -81.3272711707,
		"y": 2.379150425,
		"h": 4.9230769231
	},
	{
		"stop_id": 8589168,
		"ID": 297,
		"x": -83.3922716787,
		"y": -0.15278899,
		"h": 4.9230769231
	},
	{
		"stop_id": 8589169,
		"ID": 297,
		"x": -82.5992702927,
		"y": -0.128753838,
		"h": 4.9230769231
	},
	{
		"stop_id": 8589172,
		"ID": 297,
		"x": -83.4232851187,
		"y": -0.021820121,
		"h": 4.9230769231
	},
	{
		"stop_id": 8589175,
		"ID": 297,
		"x": -82.0922311787,
		"y": 3.780144357,
		"h": 4.9230769231
	},
	{
		"stop_id": 8589176,
		"ID": 297,
		"x": -81.6022710487,
		"y": 3.372226381,
		"h": 4.9230769231
	},
	{
		"stop_id": 8589177,
		"ID": 297,
		"x": -81.4922646257,
		"y": 2.988178947,
		"h": 4.9230769231
	},
	{
		"stop_id": 8589269,
		"ID": 297,
		"x": -80.7232841997,
		"y": 1.359242191,
		"h": 4.9230769231
	},
	{
		"stop_id": 8589270,
		"ID": 297,
		"x": -79.9972805657,
		"y": 2.014185512,
		"h": 4.9230769231
	},
	{
		"stop_id": 8589271,
		"ID": 297,
		"x": -79.6082456117,
		"y": 1.33118862,
		"h": 4.9230769231
	},
	{
		"stop_id": 8589272,
		"ID": 297,
		"x": -82.6972359257,
		"y": 0.028148067,
		"h": 4.9230769231
	},
	{
		"stop_id": 8591687,
		"ID": 297,
		"x": -82.9372635527,
		"y": -0.046852149,
		"h": 4.9230769231
	},
	{
		"stop_id": 8591766,
		"ID": 297,
		"x": -80.1642245977,
		"y": 1.940160533,
		"h": 4.9230769231
	},
	{
		"stop_id": 8591767,
		"ID": 297,
		"x": -80.0402824587,
		"y": 1.915168983,
		"h": 4.9230769231
	},
	{
		"stop_id": 8592365,
		"ID": 297,
		"x": -80.4992252857,
		"y": 1.432163188,
		"h": 4.9230769231
	},
	{
		"stop_id": 8592366,
		"ID": 297,
		"x": -82.1892464347,
		"y": 2.128199628,
		"h": 4.9230769231
	},
	{
		"stop_id": 8592367,
		"ID": 297,
		"x": -81.7282657117,
		"y": 2.023206413,
		"h": 4.9230769231
	},
	{
		"stop_id": 8592368,
		"ID": 297,
		"x": -81.7962916457,
		"y": -0.026832342,
		"h": 4.9230769231
	},
	{
		"stop_id": 8592369,
		"ID": 297,
		"x": -82.3462407567,
		"y": 1.685227569,
		"h": 4.9230769231
	},
	{
		"stop_id": 8592370,
		"ID": 297,
		"x": -82.5082811917,
		"y": 1.726198187,
		"h": 4.9230769231
	},
	{
		"stop_id": 8592371,
		"ID": 297,
		"x": -81.8972712717,
		"y": 2.16023635,
		"h": 4.9230769231
	},
	{
		"stop_id": 8592372,
		"ID": 297,
		"x": -80.8022683467,
		"y": 0.997220936,
		"h": 4.9230769231
	},
	{
		"stop_id": 8592373,
		"ID": 297,
		"x": -81.4242321937,
		"y": -0.087782547,
		"h": 4.9230769231
	},
	{
		"stop_id": 8592374,
		"ID": 297,
		"x": -81.6542315227,
		"y": 1.00518122,
		"h": 4.9230769231
	},
	{
		"stop_id": 8592375,
		"ID": 297,
		"x": -82.5282766807,
		"y": 1.287156511,
		"h": 4.9230769231
	},
	{
		"stop_id": 8592376,
		"ID": 297,
		"x": -81.8942331427,
		"y": 1.930216102,
		"h": 4.9230769231
	},
	{
		"stop_id": 8592377,
		"ID": 297,
		"x": -82.7942588707,
		"y": 0.882188849,
		"h": 4.9230769231
	},
	{
		"stop_id": 8592378,
		"ID": 297,
		"x": -82.7142675197,
		"y": 1.117225235,
		"h": 4.9230769231
	},
	{
		"stop_id": 8592379,
		"ID": 297,
		"x": -82.5802558767,
		"y": 1.886223392,
		"h": 4.9230769231
	},
	{
		"stop_id": 8592380,
		"ID": 297,
		"x": -80.4932485827,
		"y": 0.912205265,
		"h": 4.9230769231
	},
	{
		"stop_id": 8592381,
		"ID": 297,
		"x": -81.6742857707,
		"y": -0.047848317,
		"h": 4.9230769231
	},
	{
		"stop_id": 8592382,
		"ID": 297,
		"x": -81.7082615697,
		"y": 1.652161399,
		"h": 4.9230769231
	},
	{
		"stop_id": 8592383,
		"ID": 297,
		"x": -80.9652368287,
		"y": 1.150211221,
		"h": 4.9230769231
	},
	{
		"stop_id": 8592384,
		"ID": 297,
		"x": -80.2962692977,
		"y": 1.186221545,
		"h": 4.9230769231
	},
	{
		"stop_id": 8592385,
		"ID": 297,
		"x": -81.1422993437,
		"y": 1.053237514,
		"h": 4.9230769231
	},
	{
		"stop_id": 8592386,
		"ID": 297,
		"x": -80.3962281467,
		"y": 1.065170419,
		"h": 4.9230769231
	},
	{
		"stop_id": 8592387,
		"ID": 297,
		"x": -80.5942346867,
		"y": 0.980148172,
		"h": 4.9230769231
	},
	{
		"stop_id": 8592388,
		"ID": 297,
		"x": -80.4272310897,
		"y": 1.348202814,
		"h": 4.9230769231
	},
	{
		"stop_id": 8592389,
		"ID": 297,
		"x": -81.8592607477,
		"y": -0.165782673,
		"h": 4.9230769231
	},
	{
		"stop_id": 8592393,
		"ID": 297,
		"x": -82.5932517977,
		"y": -0.251840865,
		"h": 4.9230769231
	},
	{
		"stop_id": 8594781,
		"ID": 297,
		"x": -83.5452307367,
		"y": 2.366244835,
		"h": 4.9230769231
	},
	{
		"stop_id": 8594782,
		"ID": 297,
		"x": -83.8652285557,
		"y": 2.274147994,
		"h": 4.9230769231
	},
	{
		"stop_id": 8594783,
		"ID": 297,
		"x": -84.4572728087,
		"y": 2.102146535,
		"h": 4.9230769231
	},
	{
		"stop_id": 8504101,
		"ID": 329,
		"x": -78.7242385527,
		"y": 6.339148834,
		"h": 1.5604395604
	},
	{
		"stop_id": 8504535,
		"ID": 329,
		"x": -77.9152731647,
		"y": 4.56025042,
		"h": 1.5604395604
	},
	{
		"stop_id": 8504592,
		"ID": 329,
		"x": -73.8402405387,
		"y": 5.962167988,
		"h": 1.5604395604
	},
	{
		"stop_id": 8504594,
		"ID": 329,
		"x": -76.1092977557,
		"y": 5.178228667,
		"h": 1.5604395604
	},
	{
		"stop_id": 8504636,
		"ID": 329,
		"x": -75.5412307547,
		"y": 2.78722692,
		"h": 1.5604395604
	},
	{
		"stop_id": 8504637,
		"ID": 329,
		"x": -77.1332760387,
		"y": 4.435185385,
		"h": 1.5604395604
	},
	{
		"stop_id": 8504643,
		"ID": 329,
		"x": -77.7472933277,
		"y": 3.748205398,
		"h": 1.5604395604
	},
	{
		"stop_id": 8504769,
		"ID": 329,
		"x": -78.7292375757,
		"y": 6.278243859,
		"h": 1.5604395604
	},
	{
		"stop_id": 8504877,
		"ID": 329,
		"x": -76.7292709697,
		"y": 2.334147995,
		"h": 1.5604395604
	},
	{
		"stop_id": 8504888,
		"ID": 329,
		"x": -75.4302988337,
		"y": 5.817180363,
		"h": 1.5604395604
	},
	{
		"stop_id": 8504890,
		"ID": 329,
		"x": -74.2422326827,
		"y": 6.949205993,
		"h": 1.5604395604
	},
	{
		"stop_id": 8570535,
		"ID": 329,
		"x": -77.8192274127,
		"y": 7.52418038,
		"h": 1.5604395604
	},
	{
		"stop_id": 8577853,
		"ID": 329,
		"x": -76.9952462897,
		"y": 2.781144234,
		"h": 1.5604395604
	},
	{
		"stop_id": 8577861,
		"ID": 329,
		"x": -75.7022543727,
		"y": 5.405242932,
		"h": 1.5604395604
	},
	{
		"stop_id": 8577866,
		"ID": 329,
		"x": -78.6352454217,
		"y": 5.758227644,
		"h": 1.5604395604
	},
	{
		"stop_id": 8582486,
		"ID": 329,
		"x": -77.9062259037,
		"y": 7.101222314,
		"h": 1.5604395604
	},
	{
		"stop_id": 8588816,
		"ID": 329,
		"x": -77.1332302427,
		"y": 2.281174073,
		"h": 1.5604395604
	},
	{
		"stop_id": 8595193,
		"ID": 329,
		"x": -78.6942584397,
		"y": 5.382217736,
		"h": 1.5604395604
	},
	{
		"stop_id": 8504102,
		"ID": 359,
		"x": -73.8272499057,
		"y": 7.647242359,
		"h": 1.5604395604
	},
	{
		"stop_id": 8504113,
		"ID": 359,
		"x": -71.7872833157,
		"y": 8.635169407,
		"h": 1.5604395604
	},
	{
		"stop_id": 8504591,
		"ID": 359,
		"x": -72.5282300127,
		"y": 5.841141284,
		"h": 1.5604395604
	},
	{
		"stop_id": 8504595,
		"ID": 359,
		"x": -72.1232669287,
		"y": 5.193168908,
		"h": 1.5604395604
	},
	{
		"stop_id": 8504598,
		"ID": 359,
		"x": -69.6832638567,
		"y": 9.722181263,
		"h": 1.5604395604
	},
	{
		"stop_id": 8504599,
		"ID": 359,
		"x": -69.7712961377,
		"y": 8.779166765,
		"h": 1.5604395604
	},
	{
		"stop_id": 8504773,
		"ID": 359,
		"x": -69.4522733607,
		"y": 7.784225713,
		"h": 1.5604395604
	},
	{
		"stop_id": 8504889,
		"ID": 359,
		"x": -73.4902968037,
		"y": 6.360224262,
		"h": 1.5604395604
	},
	{
		"stop_id": 8570558,
		"ID": 359,
		"x": -69.0782500857,
		"y": 7.022227031,
		"h": 1.5604395604
	},
	{
		"stop_id": 8577862,
		"ID": 359,
		"x": -73.8282845057,
		"y": 7.661140994,
		"h": 1.5604395604
	},
	{
		"stop_id": 8581307,
		"ID": 359,
		"x": -69.4452856197,
		"y": 7.814230006,
		"h": 1.5604395604
	},
	{
		"stop_id": 8581331,
		"ID": 359,
		"x": -69.0342419407,
		"y": 8.146190722,
		"h": 1.5604395604
	},
	{
		"stop_id": 8583455,
		"ID": 359,
		"x": -72.1832780217,
		"y": 8.957154233,
		"h": 1.5604395604
	},
	{
		"stop_id": 8583456,
		"ID": 359,
		"x": -73.3262264547,
		"y": 7.904212402,
		"h": 1.5604395604
	},
	{
		"stop_id": 8583457,
		"ID": 359,
		"x": -72.5562993607,
		"y": 8.565184642,
		"h": 1.5604395604
	},
	{
		"stop_id": 8583787,
		"ID": 359,
		"x": -72.4852329607,
		"y": 8.74823932,
		"h": 1.5604395604
	},
	{
		"stop_id": 8588602,
		"ID": 359,
		"x": -74.0792407767,
		"y": 7.402159873,
		"h": 1.5604395604
	},
	{
		"stop_id": 8591781,
		"ID": 359,
		"x": -71.5762801317,
		"y": 8.699223716,
		"h": 1.5604395604
	},
	{
		"stop_id": 8504103,
		"ID": 390,
		"x": -68.8172635097,
		"y": 10.478191986,
		"h": 1.6923076923
	},
	{
		"stop_id": 8504104,
		"ID": 390,
		"x": -65.9602968087,
		"y": 12.26822628,
		"h": 1.6923076923
	},
	{
		"stop_id": 8504115,
		"ID": 390,
		"x": -66.3552793357,
		"y": 11.039227804,
		"h": 1.6923076923
	},
	{
		"stop_id": 8504117,
		"ID": 390,
		"x": -65.5652940227,
		"y": 13.373187003,
		"h": 1.6923076923
	},
	{
		"stop_id": 8504191,
		"ID": 390,
		"x": -69.5062888637,
		"y": 10.637147551,
		"h": 1.6923076923
	},
	{
		"stop_id": 8504982,
		"ID": 390,
		"x": -68.1872326837,
		"y": 8.580152044,
		"h": 1.6923076923
	},
	{
		"stop_id": 8507086,
		"ID": 390,
		"x": -63.5932761427,
		"y": 10.246248377,
		"h": 1.6923076923
	},
	{
		"stop_id": 8507087,
		"ID": 390,
		"x": -65.1272480697,
		"y": 9.144205999,
		"h": 1.6923076923
	},
	{
		"stop_id": 8570556,
		"ID": 390,
		"x": -68.7762400367,
		"y": 10.491247356,
		"h": 1.6923076923
	},
	{
		"stop_id": 8570557,
		"ID": 390,
		"x": -69.4532692687,
		"y": 10.622163757,
		"h": 1.6923076923
	},
	{
		"stop_id": 8580925,
		"ID": 390,
		"x": -63.5812494787,
		"y": 10.222227862,
		"h": 1.6923076923
	},
	{
		"stop_id": 8583213,
		"ID": 390,
		"x": -63.4612869267,
		"y": 10.215146863,
		"h": 1.6923076923
	},
	{
		"stop_id": 8583454,
		"ID": 390,
		"x": -68.5502771727,
		"y": 10.687233036,
		"h": 1.6923076923
	},
	{
		"stop_id": 8588079,
		"ID": 390,
		"x": -66.3652524267,
		"y": 11.048243722,
		"h": 1.6923076923
	},
	{
		"stop_id": 8588080,
		"ID": 390,
		"x": -68.0562702837,
		"y": 11.067164577,
		"h": 1.6923076923
	},
	{
		"stop_id": 8588081,
		"ID": 390,
		"x": -68.5612468047,
		"y": 11.100245122,
		"h": 1.6923076923
	},
	{
		"stop_id": 8588082,
		"ID": 390,
		"x": -68.9152758317,
		"y": 11.06921022,
		"h": 1.6923076923
	},
	{
		"stop_id": 8588468,
		"ID": 390,
		"x": -66.8362424077,
		"y": 11.152177962,
		"h": 1.6923076923
	},
	{
		"stop_id": 8589078,
		"ID": 390,
		"x": -65.1152860797,
		"y": 9.137191414,
		"h": 1.6923076923
	},
	{
		"stop_id": 8593310,
		"ID": 390,
		"x": -63.8812974087,
		"y": 9.929166467,
		"h": 1.6923076923
	},
	{
		"stop_id": 8594655,
		"ID": 390,
		"x": -65.4372977967,
		"y": 13.470224722,
		"h": 1.6923076923
	},
	{
		"stop_id": 8594656,
		"ID": 390,
		"x": -65.8282920737,
		"y": 12.455187779,
		"h": 1.6923076923
	},
	{
		"stop_id": 8504105,
		"ID": 391,
		"x": -64.4782489757,
		"y": 14.588192601,
		"h": 2.2527472527
	},
	{
		"stop_id": 8504488,
		"ID": 391,
		"x": -67.7052612617,
		"y": 16.331148136,
		"h": 2.2527472527
	},
	{
		"stop_id": 8504489,
		"ID": 391,
		"x": -63.4642356557,
		"y": 16.84722454,
		"h": 2.2527472527
	},
	{
		"stop_id": 8507980,
		"ID": 391,
		"x": -67.3532414297,
		"y": 17.769234569,
		"h": 2.2527472527
	},
	{
		"stop_id": 8507982,
		"ID": 391,
		"x": -66.5212428217,
		"y": 15.702225041,
		"h": 2.2527472527
	},
	{
		"stop_id": 8516154,
		"ID": 391,
		"x": -64.6112896907,
		"y": 16.630169383,
		"h": 2.2527472527
	},
	{
		"stop_id": 8571355,
		"ID": 391,
		"x": -64.7822625677,
		"y": 19.152224693,
		"h": 2.2527472527
	},
	{
		"stop_id": 8571435,
		"ID": 391,
		"x": -64.0182576847,
		"y": 17.162215532,
		"h": 2.2527472527
	},
	{
		"stop_id": 8571436,
		"ID": 391,
		"x": -63.4132450427,
		"y": 16.210184699,
		"h": 2.2527472527
	},
	{
		"stop_id": 8571438,
		"ID": 391,
		"x": -64.8272682397,
		"y": 15.948209293,
		"h": 2.2527472527
	},
	{
		"stop_id": 8571439,
		"ID": 391,
		"x": -66.0822318097,
		"y": 15.718190616,
		"h": 2.2527472527
	},
	{
		"stop_id": 8571440,
		"ID": 391,
		"x": -67.1702644347,
		"y": 15.875208322,
		"h": 2.2527472527
	},
	{
		"stop_id": 8571442,
		"ID": 391,
		"x": -67.5152323377,
		"y": 17.245163522,
		"h": 2.2527472527
	},
	{
		"stop_id": 8571443,
		"ID": 391,
		"x": -66.3842474537,
		"y": 17.534162259,
		"h": 2.2527472527
	},
	{
		"stop_id": 8571444,
		"ID": 391,
		"x": -67.7812539477,
		"y": 17.840172132,
		"h": 2.2527472527
	},
	{
		"stop_id": 8579523,
		"ID": 391,
		"x": -63.4212278227,
		"y": 16.835190924,
		"h": 2.2527472527
	},
	{
		"stop_id": 8579900,
		"ID": 391,
		"x": -63.2202850977,
		"y": 16.367150843,
		"h": 2.2527472527
	},
	{
		"stop_id": 8579901,
		"ID": 391,
		"x": -63.7482389797,
		"y": 16.141144898,
		"h": 2.2527472527
	},
	{
		"stop_id": 8580427,
		"ID": 391,
		"x": -67.6832673987,
		"y": 16.323225455,
		"h": 2.2527472527
	},
	{
		"stop_id": 8581119,
		"ID": 391,
		"x": -65.0092713037,
		"y": 17.036173965,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582225,
		"ID": 391,
		"x": -63.3922432227,
		"y": 16.555245088,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582262,
		"ID": 391,
		"x": -64.5882462757,
		"y": 16.691183043,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582555,
		"ID": 391,
		"x": -63.9452247447,
		"y": 15.283157744,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582556,
		"ID": 391,
		"x": -64.4482721407,
		"y": 15.025179142,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582557,
		"ID": 391,
		"x": -64.4932445157,
		"y": 14.787199568,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582871,
		"ID": 391,
		"x": -64.3392250157,
		"y": 14.721153136,
		"h": 2.2527472527
	},
	{
		"stop_id": 8589227,
		"ID": 391,
		"x": -64.4302412487,
		"y": 14.620171184,
		"h": 2.2527472527
	},
	{
		"stop_id": 8590044,
		"ID": 391,
		"x": -64.1422819417,
		"y": 15.930203067,
		"h": 2.2527472527
	},
	{
		"stop_id": 8590045,
		"ID": 391,
		"x": -64.3922798537,
		"y": 17.068226953,
		"h": 2.2527472527
	},
	{
		"stop_id": 8590046,
		"ID": 391,
		"x": -63.5732635427,
		"y": 17.189144761,
		"h": 2.2527472527
	},
	{
		"stop_id": 8590077,
		"ID": 391,
		"x": -64.5782587047,
		"y": 16.893171948,
		"h": 2.2527472527
	},
	{
		"stop_id": 8590082,
		"ID": 391,
		"x": -64.1922286687,
		"y": 14.830209262,
		"h": 2.2527472527
	},
	{
		"stop_id": 8590105,
		"ID": 391,
		"x": -64.9782533467,
		"y": 14.075231857,
		"h": 2.2527472527
	},
	{
		"stop_id": 8590106,
		"ID": 391,
		"x": -64.6422405797,
		"y": 14.205234141,
		"h": 2.2527472527
	},
	{
		"stop_id": 8590108,
		"ID": 391,
		"x": -63.6672674577,
		"y": 16.530187191,
		"h": 2.2527472527
	},
	{
		"stop_id": 8590109,
		"ID": 391,
		"x": -63.8922822177,
		"y": 16.705213529,
		"h": 2.2527472527
	},
	{
		"stop_id": 8590403,
		"ID": 391,
		"x": -64.5112402827,
		"y": 14.384221782,
		"h": 2.2527472527
	},
	{
		"stop_id": 8591756,
		"ID": 391,
		"x": -63.9032833667,
		"y": 16.974143193,
		"h": 2.2527472527
	},
	{
		"stop_id": 8591757,
		"ID": 391,
		"x": -63.4872241667,
		"y": 16.972195048,
		"h": 2.2527472527
	},
	{
		"stop_id": 8504106,
		"ID": 420,
		"x": -63.0472449017,
		"y": 15.919144295,
		"h": 3.5054945055
	},
	{
		"stop_id": 8507078,
		"ID": 420,
		"x": -59.1902564497,
		"y": 14.937240558,
		"h": 3.5054945055
	},
	{
		"stop_id": 8507079,
		"ID": 420,
		"x": -60.3982507207,
		"y": 15.728243062,
		"h": 3.5054945055
	},
	{
		"stop_id": 8507082,
		"ID": 420,
		"x": -62.1152601977,
		"y": 16.581155155,
		"h": 3.5054945055
	},
	{
		"stop_id": 8507083,
		"ID": 420,
		"x": -61.5302588267,
		"y": 14.517176218,
		"h": 3.5054945055
	},
	{
		"stop_id": 8507084,
		"ID": 420,
		"x": -62.5952955347,
		"y": 12.865170163,
		"h": 3.5054945055
	},
	{
		"stop_id": 8507085,
		"ID": 420,
		"x": -62.6332786517,
		"y": 11.856210738,
		"h": 3.5054945055
	},
	{
		"stop_id": 8507091,
		"ID": 420,
		"x": -61.2222496057,
		"y": 15.124189265,
		"h": 3.5054945055
	},
	{
		"stop_id": 8507097,
		"ID": 420,
		"x": -59.1792820847,
		"y": 14.844191894,
		"h": 3.5054945055
	},
	{
		"stop_id": 8507099,
		"ID": 420,
		"x": -59.6572537887,
		"y": 13.931241795,
		"h": 3.5054945055
	},
	{
		"stop_id": 8571393,
		"ID": 420,
		"x": -60.3242458797,
		"y": 16.325220136,
		"h": 3.5054945055
	},
	{
		"stop_id": 8571412,
		"ID": 420,
		"x": -60.9582466627,
		"y": 15.348245946,
		"h": 3.5054945055
	},
	{
		"stop_id": 8571413,
		"ID": 420,
		"x": -61.4422568517,
		"y": 14.630209614,
		"h": 3.5054945055
	},
	{
		"stop_id": 8571414,
		"ID": 420,
		"x": -61.5242881997,
		"y": 14.368206229,
		"h": 3.5054945055
	},
	{
		"stop_id": 8571415,
		"ID": 420,
		"x": -61.6302757957,
		"y": 14.008159784,
		"h": 3.5054945055
	},
	{
		"stop_id": 8571417,
		"ID": 420,
		"x": -61.4142790797,
		"y": 12.895169081,
		"h": 3.5054945055
	},
	{
		"stop_id": 8571418,
		"ID": 420,
		"x": -61.1092391447,
		"y": 10.997196313,
		"h": 3.5054945055
	},
	{
		"stop_id": 8579515,
		"ID": 420,
		"x": -60.2372479737,
		"y": 15.20616932,
		"h": 3.5054945055
	},
	{
		"stop_id": 8579898,
		"ID": 420,
		"x": -62.6302424357,
		"y": 16.442202734,
		"h": 3.5054945055
	},
	{
		"stop_id": 8579899,
		"ID": 420,
		"x": -62.9082951557,
		"y": 16.452241284,
		"h": 3.5054945055
	},
	{
		"stop_id": 8580927,
		"ID": 420,
		"x": -61.5192962937,
		"y": 14.501164296,
		"h": 3.5054945055
	},
	{
		"stop_id": 8580939,
		"ID": 420,
		"x": -62.2032832627,
		"y": 16.560180617,
		"h": 3.5054945055
	},
	{
		"stop_id": 8582195,
		"ID": 420,
		"x": -62.6422688247,
		"y": 12.930227804,
		"h": 3.5054945055
	},
	{
		"stop_id": 8582552,
		"ID": 420,
		"x": -62.7402431127,
		"y": 16.184231395,
		"h": 3.5054945055
	},
	{
		"stop_id": 8582553,
		"ID": 420,
		"x": -63.1362818277,
		"y": 15.748215106,
		"h": 3.5054945055
	},
	{
		"stop_id": 8582554,
		"ID": 420,
		"x": -63.4062374727,
		"y": 15.484236932,
		"h": 3.5054945055
	},
	{
		"stop_id": 8588562,
		"ID": 420,
		"x": -58.9972903337,
		"y": 15.094231695,
		"h": 3.5054945055
	},
	{
		"stop_id": 8589077,
		"ID": 420,
		"x": -62.6212360547,
		"y": 11.863208476,
		"h": 3.5054945055
	},
	{
		"stop_id": 8589226,
		"ID": 420,
		"x": -63.0482894197,
		"y": 15.957165202,
		"h": 3.5054945055
	},
	{
		"stop_id": 8589266,
		"ID": 420,
		"x": -61.4562476107,
		"y": 15.216192583,
		"h": 3.5054945055
	},
	{
		"stop_id": 8589267,
		"ID": 420,
		"x": -61.2122465287,
		"y": 14.048169625,
		"h": 3.5054945055
	},
	{
		"stop_id": 8589268,
		"ID": 420,
		"x": -60.0992949147,
		"y": 14.669205132,
		"h": 3.5054945055
	},
	{
		"stop_id": 8589992,
		"ID": 420,
		"x": -59.9502519547,
		"y": 16.195232483,
		"h": 3.5054945055
	},
	{
		"stop_id": 8589993,
		"ID": 420,
		"x": -59.9172966377,
		"y": 15.85616097,
		"h": 3.5054945055
	},
	{
		"stop_id": 8589994,
		"ID": 420,
		"x": -60.1392249857,
		"y": 15.363244563,
		"h": 3.5054945055
	},
	{
		"stop_id": 8589995,
		"ID": 420,
		"x": -60.0642437917,
		"y": 14.926228453,
		"h": 3.5054945055
	},
	{
		"stop_id": 8589996,
		"ID": 420,
		"x": -59.9672296137,
		"y": 14.705216268,
		"h": 3.5054945055
	},
	{
		"stop_id": 8589997,
		"ID": 420,
		"x": -60.2922257097,
		"y": 14.530148116,
		"h": 3.5054945055
	},
	{
		"stop_id": 8589998,
		"ID": 420,
		"x": -60.5922748867,
		"y": 14.250149102,
		"h": 3.5054945055
	},
	{
		"stop_id": 8589999,
		"ID": 420,
		"x": -60.7672560617,
		"y": 14.105212752,
		"h": 3.5054945055
	},
	{
		"stop_id": 8590000,
		"ID": 420,
		"x": -59.7382902427,
		"y": 14.723218843,
		"h": 3.5054945055
	},
	{
		"stop_id": 8590001,
		"ID": 420,
		"x": -59.5702810727,
		"y": 14.777248046,
		"h": 3.5054945055
	},
	{
		"stop_id": 8590002,
		"ID": 420,
		"x": -59.3672340877,
		"y": 14.680203222,
		"h": 3.5054945055
	},
	{
		"stop_id": 8590011,
		"ID": 420,
		"x": -60.7332607337,
		"y": 16.379196708,
		"h": 3.5054945055
	},
	{
		"stop_id": 8590012,
		"ID": 420,
		"x": -60.8732349697,
		"y": 16.230143562,
		"h": 3.5054945055
	},
	{
		"stop_id": 8590013,
		"ID": 420,
		"x": -61.0152409437,
		"y": 16.219167992,
		"h": 3.5054945055
	},
	{
		"stop_id": 8590014,
		"ID": 420,
		"x": -61.2672527527,
		"y": 16.280151569,
		"h": 3.5054945055
	},
	{
		"stop_id": 8590016,
		"ID": 420,
		"x": -60.2312407007,
		"y": 15.92121697,
		"h": 3.5054945055
	},
	{
		"stop_id": 8590022,
		"ID": 420,
		"x": -59.6422555837,
		"y": 15.530204139,
		"h": 3.5054945055
	},
	{
		"stop_id": 8590023,
		"ID": 420,
		"x": -59.2462561087,
		"y": 15.271192064,
		"h": 3.5054945055
	},
	{
		"stop_id": 8590053,
		"ID": 420,
		"x": -60.5262800617,
		"y": 16.084227966,
		"h": 3.5054945055
	},
	{
		"stop_id": 8590054,
		"ID": 420,
		"x": -60.7672528577,
		"y": 15.780216091,
		"h": 3.5054945055
	},
	{
		"stop_id": 8590055,
		"ID": 420,
		"x": -61.3852917237,
		"y": 15.41216518,
		"h": 3.5054945055
	},
	{
		"stop_id": 8590056,
		"ID": 420,
		"x": -61.4282855857,
		"y": 15.003181874,
		"h": 3.5054945055
	},
	{
		"stop_id": 8590057,
		"ID": 420,
		"x": -61.3922825897,
		"y": 13.880240713,
		"h": 3.5054945055
	},
	{
		"stop_id": 8590058,
		"ID": 420,
		"x": -61.4172430437,
		"y": 13.180209867,
		"h": 3.5054945055
	},
	{
		"stop_id": 8590059,
		"ID": 420,
		"x": -61.1122657537,
		"y": 15.188195813,
		"h": 3.5054945055
	},
	{
		"stop_id": 8590073,
		"ID": 420,
		"x": -61.4152869827,
		"y": 15.962245296,
		"h": 3.5054945055
	},
	{
		"stop_id": 8590076,
		"ID": 420,
		"x": -59.5742637617,
		"y": 16.174215433,
		"h": 3.5054945055
	},
	{
		"stop_id": 8590081,
		"ID": 420,
		"x": -63.8272983427,
		"y": 15.123211434,
		"h": 3.5054945055
	},
	{
		"stop_id": 8590083,
		"ID": 420,
		"x": -63.7382934817,
		"y": 15.316141938,
		"h": 3.5054945055
	},
	{
		"stop_id": 8590084,
		"ID": 420,
		"x": -63.4232287557,
		"y": 15.711146497,
		"h": 3.5054945055
	},
	{
		"stop_id": 8590094,
		"ID": 420,
		"x": -63.8762329197,
		"y": 14.738151607,
		"h": 3.5054945055
	},
	{
		"stop_id": 8590095,
		"ID": 420,
		"x": -63.1212404117,
		"y": 14.105219895,
		"h": 3.5054945055
	},
	{
		"stop_id": 8590096,
		"ID": 420,
		"x": -62.4652623377,
		"y": 13.976141731,
		"h": 3.5054945055
	},
	{
		"stop_id": 8590097,
		"ID": 420,
		"x": -62.0922255307,
		"y": 14.05524311,
		"h": 3.5054945055
	},
	{
		"stop_id": 8590098,
		"ID": 420,
		"x": -61.7622841997,
		"y": 14.207199224,
		"h": 3.5054945055
	},
	{
		"stop_id": 8590099,
		"ID": 420,
		"x": -60.5112569417,
		"y": 15.166180312,
		"h": 3.5054945055
	},
	{
		"stop_id": 8590100,
		"ID": 420,
		"x": -59.9622552747,
		"y": 15.193142589,
		"h": 3.5054945055
	},
	{
		"stop_id": 8590101,
		"ID": 420,
		"x": -59.3722804057,
		"y": 15.075191099,
		"h": 3.5054945055
	},
	{
		"stop_id": 8590115,
		"ID": 420,
		"x": -59.5642911757,
		"y": 16.28816541,
		"h": 3.5054945055
	},
	{
		"stop_id": 8590118,
		"ID": 420,
		"x": -61.5932603817,
		"y": 14.708186714,
		"h": 3.5054945055
	},
	{
		"stop_id": 8590119,
		"ID": 420,
		"x": -61.5212590107,
		"y": 15.540162949,
		"h": 3.5054945055
	},
	{
		"stop_id": 8590121,
		"ID": 420,
		"x": -61.0062249457,
		"y": 13.977193399,
		"h": 3.5054945055
	},
	{
		"stop_id": 8593295,
		"ID": 420,
		"x": -64.1222980197,
		"y": 14.75022524,
		"h": 3.5054945055
	},
	{
		"stop_id": 8594651,
		"ID": 420,
		"x": -59.5482956747,
		"y": 15.994230834,
		"h": 3.5054945055
	},
	{
		"stop_id": 8595142,
		"ID": 420,
		"x": -60.1452895447,
		"y": 15.710207946,
		"h": 3.5054945055
	},
	{
		"stop_id": 8504108,
		"ID": 421,
		"x": -62.2182369897,
		"y": 16.666243755,
		"h": 4.0989010989
	},
	{
		"stop_id": 8504495,
		"ID": 421,
		"x": -62.5942304577,
		"y": 16.90521068,
		"h": 4.0989010989
	},
	{
		"stop_id": 8504717,
		"ID": 421,
		"x": -61.3292652927,
		"y": 20.537237001,
		"h": 4.0989010989
	},
	{
		"stop_id": 8507000,
		"ID": 421,
		"x": -59.7052981747,
		"y": 17.179197197,
		"h": 4.0989010989
	},
	{
		"stop_id": 8507785,
		"ID": 421,
		"x": -59.7502902637,
		"y": 17.198207825,
		"h": 4.0989010989
	},
	{
		"stop_id": 8507975,
		"ID": 421,
		"x": -64.3202654657,
		"y": 19.308153311,
		"h": 4.0989010989
	},
	{
		"stop_id": 8507984,
		"ID": 421,
		"x": -62.4642390507,
		"y": 21.850150764,
		"h": 4.0989010989
	},
	{
		"stop_id": 8507992,
		"ID": 421,
		"x": -60.7802984037,
		"y": 17.286246617,
		"h": 4.0989010989
	},
	{
		"stop_id": 8507993,
		"ID": 421,
		"x": -63.0572798247,
		"y": 17.021184187,
		"h": 4.0989010989
	},
	{
		"stop_id": 8508051,
		"ID": 421,
		"x": -59.3152661087,
		"y": 19.366161616,
		"h": 4.0989010989
	},
	{
		"stop_id": 8508052,
		"ID": 421,
		"x": -58.8622990557,
		"y": 19.838238393,
		"h": 4.0989010989
	},
	{
		"stop_id": 8571342,
		"ID": 421,
		"x": -60.5682311457,
		"y": 17.121233589,
		"h": 4.0989010989
	},
	{
		"stop_id": 8571343,
		"ID": 421,
		"x": -61.9592253327,
		"y": 17.256232769,
		"h": 4.0989010989
	},
	{
		"stop_id": 8571344,
		"ID": 421,
		"x": -63.1832354237,
		"y": 17.22114195,
		"h": 4.0989010989
	},
	{
		"stop_id": 8571345,
		"ID": 421,
		"x": -63.7942814037,
		"y": 18.599162266,
		"h": 4.0989010989
	},
	{
		"stop_id": 8571354,
		"ID": 421,
		"x": -64.4662685597,
		"y": 19.259242429,
		"h": 4.0989010989
	},
	{
		"stop_id": 8571356,
		"ID": 421,
		"x": -64.3222657977,
		"y": 19.085145641,
		"h": 4.0989010989
	},
	{
		"stop_id": 8571357,
		"ID": 421,
		"x": -59.9742508837,
		"y": 17.408216556,
		"h": 4.0989010989
	},
	{
		"stop_id": 8571358,
		"ID": 421,
		"x": -60.2072500447,
		"y": 17.667149715,
		"h": 4.0989010989
	},
	{
		"stop_id": 8571359,
		"ID": 421,
		"x": -60.6902738337,
		"y": 17.974155396,
		"h": 4.0989010989
	},
	{
		"stop_id": 8571360,
		"ID": 421,
		"x": -61.3422389857,
		"y": 19.855204989,
		"h": 4.0989010989
	},
	{
		"stop_id": 8571361,
		"ID": 421,
		"x": -61.8502748617,
		"y": 19.994221868,
		"h": 4.0989010989
	},
	{
		"stop_id": 8571362,
		"ID": 421,
		"x": -62.6212838387,
		"y": 20.545184804,
		"h": 4.0989010989
	},
	{
		"stop_id": 8571371,
		"ID": 421,
		"x": -61.0722583757,
		"y": 20.159188695,
		"h": 4.0989010989
	},
	{
		"stop_id": 8571372,
		"ID": 421,
		"x": -62.0052943727,
		"y": 21.504209929,
		"h": 4.0989010989
	},
	{
		"stop_id": 8571373,
		"ID": 421,
		"x": -62.3852391957,
		"y": 22.271232313,
		"h": 4.0989010989
	},
	{
		"stop_id": 8571384,
		"ID": 421,
		"x": -61.7652862677,
		"y": 22.138243331,
		"h": 4.0989010989
	},
	{
		"stop_id": 8576646,
		"ID": 421,
		"x": -59.6222406027,
		"y": 17.099154376,
		"h": 4.0989010989
	},
	{
		"stop_id": 8576988,
		"ID": 421,
		"x": -58.4622696847,
		"y": 19.103242518,
		"h": 4.0989010989
	},
	{
		"stop_id": 8576989,
		"ID": 421,
		"x": -58.5102285397,
		"y": 18.778168934,
		"h": 4.0989010989
	},
	{
		"stop_id": 8579748,
		"ID": 421,
		"x": -59.9152572297,
		"y": 17.306159099,
		"h": 4.0989010989
	},
	{
		"stop_id": 8579896,
		"ID": 421,
		"x": -59.8072422107,
		"y": 16.872145247,
		"h": 4.0989010989
	},
	{
		"stop_id": 8579897,
		"ID": 421,
		"x": -60.0912962007,
		"y": 16.852147825,
		"h": 4.0989010989
	},
	{
		"stop_id": 8580237,
		"ID": 421,
		"x": -64.4092311167,
		"y": 19.305221694,
		"h": 4.0989010989
	},
	{
		"stop_id": 8580404,
		"ID": 421,
		"x": -63.1332638947,
		"y": 19.373159525,
		"h": 4.0989010989
	},
	{
		"stop_id": 8580405,
		"ID": 421,
		"x": -63.5792701387,
		"y": 19.292169003,
		"h": 4.0989010989
	},
	{
		"stop_id": 8581351,
		"ID": 421,
		"x": -59.8612902307,
		"y": 17.074143849,
		"h": 4.0989010989
	},
	{
		"stop_id": 8581428,
		"ID": 421,
		"x": -62.5892528237,
		"y": 22.252207172,
		"h": 4.0989010989
	},
	{
		"stop_id": 8582210,
		"ID": 421,
		"x": -62.7362721517,
		"y": 17.244241443,
		"h": 4.0989010989
	},
	{
		"stop_id": 8583046,
		"ID": 421,
		"x": -61.3482961427,
		"y": 17.528175705,
		"h": 4.0989010989
	},
	{
		"stop_id": 8583205,
		"ID": 421,
		"x": -63.3022636367,
		"y": 17.53215783,
		"h": 4.0989010989
	},
	{
		"stop_id": 8583222,
		"ID": 421,
		"x": -60.6202656397,
		"y": 18.318217713,
		"h": 4.0989010989
	},
	{
		"stop_id": 8588550,
		"ID": 421,
		"x": -59.5352974117,
		"y": 20.363246979,
		"h": 4.0989010989
	},
	{
		"stop_id": 8588551,
		"ID": 421,
		"x": -59.8502520017,
		"y": 19.569152264,
		"h": 4.0989010989
	},
	{
		"stop_id": 8588990,
		"ID": 421,
		"x": -59.5342430227,
		"y": 17.492144257,
		"h": 4.0989010989
	},
	{
		"stop_id": 8588991,
		"ID": 421,
		"x": -58.7092414317,
		"y": 18.706205949,
		"h": 4.0989010989
	},
	{
		"stop_id": 8588994,
		"ID": 421,
		"x": -59.1502981447,
		"y": 17.843242702,
		"h": 4.0989010989
	},
	{
		"stop_id": 8588996,
		"ID": 421,
		"x": -59.1072431377,
		"y": 18.154191483,
		"h": 4.0989010989
	},
	{
		"stop_id": 8589008,
		"ID": 421,
		"x": -58.9592407277,
		"y": 18.529186766,
		"h": 4.0989010989
	},
	{
		"stop_id": 8589019,
		"ID": 421,
		"x": -59.4802432987,
		"y": 21.433161806,
		"h": 4.0989010989
	},
	{
		"stop_id": 8589020,
		"ID": 421,
		"x": -59.7952264237,
		"y": 19.865199656,
		"h": 4.0989010989
	},
	{
		"stop_id": 8589021,
		"ID": 421,
		"x": -59.6202909067,
		"y": 20.672190729,
		"h": 4.0989010989
	},
	{
		"stop_id": 8589022,
		"ID": 421,
		"x": -59.7962858597,
		"y": 20.143238881,
		"h": 4.0989010989
	},
	{
		"stop_id": 8589023,
		"ID": 421,
		"x": -60.1422969357,
		"y": 19.845206231,
		"h": 4.0989010989
	},
	{
		"stop_id": 8589024,
		"ID": 421,
		"x": -59.6442585807,
		"y": 20.909207911,
		"h": 4.0989010989
	},
	{
		"stop_id": 8589991,
		"ID": 421,
		"x": -59.9412480917,
		"y": 16.616235036,
		"h": 4.0989010989
	},
	{
		"stop_id": 8590004,
		"ID": 421,
		"x": -59.4862568357,
		"y": 19.07822083,
		"h": 4.0989010989
	},
	{
		"stop_id": 8590005,
		"ID": 421,
		"x": -61.7952375627,
		"y": 16.636173261,
		"h": 4.0989010989
	},
	{
		"stop_id": 8590008,
		"ID": 421,
		"x": -59.0472995087,
		"y": 19.2322224,
		"h": 4.0989010989
	},
	{
		"stop_id": 8590009,
		"ID": 421,
		"x": -60.5922570437,
		"y": 16.830192426,
		"h": 4.0989010989
	},
	{
		"stop_id": 8590010,
		"ID": 421,
		"x": -60.6122248867,
		"y": 16.698235996,
		"h": 4.0989010989
	},
	{
		"stop_id": 8590015,
		"ID": 421,
		"x": -60.2072634057,
		"y": 16.673172412,
		"h": 4.0989010989
	},
	{
		"stop_id": 8590017,
		"ID": 421,
		"x": -59.2222245047,
		"y": 18.755171821,
		"h": 4.0989010989
	},
	{
		"stop_id": 8590018,
		"ID": 421,
		"x": -59.0632430167,
		"y": 18.857240841,
		"h": 4.0989010989
	},
	{
		"stop_id": 8590024,
		"ID": 421,
		"x": -59.0092564187,
		"y": 19.308156339,
		"h": 4.0989010989
	},
	{
		"stop_id": 8590025,
		"ID": 421,
		"x": -60.9672316057,
		"y": 17.455152684,
		"h": 4.0989010989
	},
	{
		"stop_id": 8590026,
		"ID": 421,
		"x": -59.1212499177,
		"y": 18.996198999,
		"h": 4.0989010989
	},
	{
		"stop_id": 8590027,
		"ID": 421,
		"x": -59.7052949047,
		"y": 17.730159471,
		"h": 4.0989010989
	},
	{
		"stop_id": 8590028,
		"ID": 421,
		"x": -59.8082807297,
		"y": 18.05122234,
		"h": 4.0989010989
	},
	{
		"stop_id": 8590029,
		"ID": 421,
		"x": -59.9242758647,
		"y": 18.2572258,
		"h": 4.0989010989
	},
	{
		"stop_id": 8590030,
		"ID": 421,
		"x": -60.0712391527,
		"y": 18.489247585,
		"h": 4.0989010989
	},
	{
		"stop_id": 8590031,
		"ID": 421,
		"x": -58.8362935717,
		"y": 19.430243862,
		"h": 4.0989010989
	},
	{
		"stop_id": 8590038,
		"ID": 421,
		"x": -60.4182394287,
		"y": 17.854161748,
		"h": 4.0989010989
	},
	{
		"stop_id": 8590039,
		"ID": 421,
		"x": -59.1842542167,
		"y": 18.855228688,
		"h": 4.0989010989
	},
	{
		"stop_id": 8590041,
		"ID": 421,
		"x": -61.0622621457,
		"y": 16.692209623,
		"h": 4.0989010989
	},
	{
		"stop_id": 8590042,
		"ID": 421,
		"x": -61.5422290897,
		"y": 16.662213636,
		"h": 4.0989010989
	},
	{
		"stop_id": 8590043,
		"ID": 421,
		"x": -62.7592306607,
		"y": 16.718193576,
		"h": 4.0989010989
	},
	{
		"stop_id": 8590047,
		"ID": 421,
		"x": -63.3672712037,
		"y": 17.168224676,
		"h": 4.0989010989
	},
	{
		"stop_id": 8590064,
		"ID": 421,
		"x": -59.6962326977,
		"y": 18.561161747,
		"h": 4.0989010989
	},
	{
		"stop_id": 8590065,
		"ID": 421,
		"x": -59.3672421697,
		"y": 19.344146877,
		"h": 4.0989010989
	},
	{
		"stop_id": 8590066,
		"ID": 421,
		"x": -59.5172507867,
		"y": 19.830181366,
		"h": 4.0989010989
	},
	{
		"stop_id": 8590067,
		"ID": 421,
		"x": -59.8422447017,
		"y": 20.155246526,
		"h": 4.0989010989
	},
	{
		"stop_id": 8590068,
		"ID": 421,
		"x": -60.0922814507,
		"y": 20.141140244,
		"h": 4.0989010989
	},
	{
		"stop_id": 8590069,
		"ID": 421,
		"x": -60.6172417387,
		"y": 20.105181033,
		"h": 4.0989010989
	},
	{
		"stop_id": 8590074,
		"ID": 421,
		"x": -59.5132257407,
		"y": 20.135235268,
		"h": 4.0989010989
	},
	{
		"stop_id": 8590075,
		"ID": 421,
		"x": -60.2422383637,
		"y": 18.755182483,
		"h": 4.0989010989
	},
	{
		"stop_id": 8590078,
		"ID": 421,
		"x": -58.8042633357,
		"y": 18.961217689,
		"h": 4.0989010989
	},
	{
		"stop_id": 8590080,
		"ID": 421,
		"x": -58.9042642577,
		"y": 18.938191618,
		"h": 4.0989010989
	},
	{
		"stop_id": 8590085,
		"ID": 421,
		"x": -58.7532471337,
		"y": 18.799249144,
		"h": 4.0989010989
	},
	{
		"stop_id": 8590086,
		"ID": 421,
		"x": -58.8152442877,
		"y": 19.112186377,
		"h": 4.0989010989
	},
	{
		"stop_id": 8593304,
		"ID": 421,
		"x": -60.0932778047,
		"y": 17.895151883,
		"h": 4.0989010989
	},
	{
		"stop_id": 8593306,
		"ID": 421,
		"x": -60.9792797977,
		"y": 20.137155657,
		"h": 4.0989010989
	},
	{
		"stop_id": 8594200,
		"ID": 421,
		"x": -60.7442667467,
		"y": 16.992193509,
		"h": 4.0989010989
	},
	{
		"stop_id": 8594201,
		"ID": 421,
		"x": -61.0862722847,
		"y": 16.897213942,
		"h": 4.0989010989
	},
	{
		"stop_id": 8595137,
		"ID": 421,
		"x": -62.4172384477,
		"y": 17.200173628,
		"h": 4.0989010989
	},
	{
		"stop_id": 8504120,
		"ID": 147,
		"x": -108.4232910707,
		"y": -13.835818534,
		"h": 1.8571428571
	},
	{
		"stop_id": 8504121,
		"ID": 147,
		"x": -105.3562776297,
		"y": -9.444839339,
		"h": 1.8571428571
	},
	{
		"stop_id": 8504694,
		"ID": 147,
		"x": -103.6922896347,
		"y": -11.224778955,
		"h": 1.8571428571
	},
	{
		"stop_id": 8504695,
		"ID": 147,
		"x": -104.8602305407,
		"y": -12.443852656,
		"h": 1.8571428571
	},
	{
		"stop_id": 8504696,
		"ID": 147,
		"x": -104.5482461907,
		"y": -13.439830484,
		"h": 1.8571428571
	},
	{
		"stop_id": 8504698,
		"ID": 147,
		"x": -106.0962677747,
		"y": -13.085758441,
		"h": 1.8571428571
	},
	{
		"stop_id": 8570338,
		"ID": 147,
		"x": -108.5192621207,
		"y": -13.544772304,
		"h": 1.8571428571
	},
	{
		"stop_id": 8570339,
		"ID": 147,
		"x": -108.4072908677,
		"y": -13.288768409,
		"h": 1.8571428571
	},
	{
		"stop_id": 8570340,
		"ID": 147,
		"x": -108.6482491627,
		"y": -13.399755102,
		"h": 1.8571428571
	},
	{
		"stop_id": 8570356,
		"ID": 147,
		"x": -108.0962953787,
		"y": -12.652835889,
		"h": 1.8571428571
	},
	{
		"stop_id": 8570357,
		"ID": 147,
		"x": -108.0262791557,
		"y": -12.063753257,
		"h": 1.8571428571
	},
	{
		"stop_id": 8570358,
		"ID": 147,
		"x": -107.8822257207,
		"y": -11.969751079,
		"h": 1.8571428571
	},
	{
		"stop_id": 8570359,
		"ID": 147,
		"x": -107.7382334107,
		"y": -11.777803906,
		"h": 1.8571428571
	},
	{
		"stop_id": 8570360,
		"ID": 147,
		"x": -107.9872904927,
		"y": -11.307775265,
		"h": 1.8571428571
	},
	{
		"stop_id": 8570361,
		"ID": 147,
		"x": -107.9612557187,
		"y": -10.259758512,
		"h": 1.8571428571
	},
	{
		"stop_id": 8570362,
		"ID": 147,
		"x": -107.9672723297,
		"y": -9.819808168,
		"h": 1.8571428571
	},
	{
		"stop_id": 8570393,
		"ID": 147,
		"x": -108.4482854317,
		"y": -13.850845706,
		"h": 1.8571428571
	},
	{
		"stop_id": 8577647,
		"ID": 147,
		"x": -104.5952602907,
		"y": -12.983793742,
		"h": 1.8571428571
	},
	{
		"stop_id": 8577648,
		"ID": 147,
		"x": -106.3792413557,
		"y": -13.970809504,
		"h": 1.8571428571
	},
	{
		"stop_id": 8577649,
		"ID": 147,
		"x": -106.9462479007,
		"y": -14.658846475,
		"h": 1.8571428571
	},
	{
		"stop_id": 8577650,
		"ID": 147,
		"x": -107.9502767247,
		"y": -15.007819308,
		"h": 1.8571428571
	},
	{
		"stop_id": 8577653,
		"ID": 147,
		"x": -108.7072479407,
		"y": -13.998814644,
		"h": 1.8571428571
	},
	{
		"stop_id": 8577655,
		"ID": 147,
		"x": -108.4352843037,
		"y": -13.484756507,
		"h": 1.8571428571
	},
	{
		"stop_id": 8581513,
		"ID": 147,
		"x": -108.7932935607,
		"y": -13.32875423,
		"h": 1.8571428571
	},
	{
		"stop_id": 8583110,
		"ID": 147,
		"x": -105.3732625717,
		"y": -9.425810944,
		"h": 1.8571428571
	},
	{
		"stop_id": 8591864,
		"ID": 147,
		"x": -105.6332326977,
		"y": -9.430827257,
		"h": 1.8571428571
	},
	{
		"stop_id": 8591865,
		"ID": 147,
		"x": -104.8392674157,
		"y": -10.361796985,
		"h": 1.8571428571
	},
	{
		"stop_id": 8504122,
		"ID": 171,
		"x": -101.3292434107,
		"y": -3.796832954,
		"h": 1.4615384615
	},
	{
		"stop_id": 8504142,
		"ID": 171,
		"x": -99.6362822477,
		"y": -1.460786236,
		"h": 1.4615384615
	},
	{
		"stop_id": 8504150,
		"ID": 171,
		"x": -102.3422577807,
		"y": -1.119828162,
		"h": 1.4615384615
	},
	{
		"stop_id": 8504754,
		"ID": 171,
		"x": -99.9782417437,
		"y": -4.952796359,
		"h": 1.4615384615
	},
	{
		"stop_id": 8570373,
		"ID": 171,
		"x": -101.3422449447,
		"y": -3.809749441,
		"h": 1.4615384615
	},
	{
		"stop_id": 8570374,
		"ID": 171,
		"x": -101.7172856857,
		"y": -3.394797447,
		"h": 1.4615384615
	},
	{
		"stop_id": 8570375,
		"ID": 171,
		"x": -103.2892265447,
		"y": -5.150833408,
		"h": 1.4615384615
	},
	{
		"stop_id": 8570376,
		"ID": 171,
		"x": -103.2052447177,
		"y": -4.677858197,
		"h": 1.4615384615
	},
	{
		"stop_id": 8570384,
		"ID": 171,
		"x": -104.2792575527,
		"y": -3.595825762,
		"h": 1.4615384615
	},
	{
		"stop_id": 8570475,
		"ID": 171,
		"x": -100.4262608967,
		"y": -5.446806495,
		"h": 1.4615384615
	},
	{
		"stop_id": 8570476,
		"ID": 171,
		"x": -99.4772491347,
		"y": -5.42183705,
		"h": 1.4615384615
	},
	{
		"stop_id": 8570478,
		"ID": 171,
		"x": -98.3892588587,
		"y": -3.945849938,
		"h": 1.4615384615
	},
	{
		"stop_id": 8570479,
		"ID": 171,
		"x": -98.6492517647,
		"y": -3.522829381,
		"h": 1.4615384615
	},
	{
		"stop_id": 8570480,
		"ID": 171,
		"x": -99.1202356207,
		"y": -3.348766114,
		"h": 1.4615384615
	},
	{
		"stop_id": 8570481,
		"ID": 171,
		"x": -98.9242252777,
		"y": -2.663800849,
		"h": 1.4615384615
	},
	{
		"stop_id": 8504123,
		"ID": 200,
		"x": -96.2352662167,
		"y": 4.665200277,
		"h": 1.3626373626
	},
	{
		"stop_id": 8504124,
		"ID": 200,
		"x": -94.3102971487,
		"y": 6.78221723,
		"h": 1.3626373626
	},
	{
		"stop_id": 8504134,
		"ID": 200,
		"x": -97.8032295977,
		"y": 2.939169303,
		"h": 1.3626373626
	},
	{
		"stop_id": 8504135,
		"ID": 200,
		"x": -96.4762977217,
		"y": 3.954185081,
		"h": 1.3626373626
	},
	{
		"stop_id": 8504136,
		"ID": 200,
		"x": -94.9342375367,
		"y": 2.806176532,
		"h": 1.3626373626
	},
	{
		"stop_id": 8504780,
		"ID": 200,
		"x": -97.7812253847,
		"y": 2.979161737,
		"h": 1.3626373626
	},
	{
		"stop_id": 8504999,
		"ID": 200,
		"x": -97.2722992197,
		"y": 2.917243425,
		"h": 1.3626373626
	},
	{
		"stop_id": 8570406,
		"ID": 200,
		"x": -98.2812364237,
		"y": 3.120219493,
		"h": 1.3626373626
	},
	{
		"stop_id": 8581635,
		"ID": 200,
		"x": -95.0252875447,
		"y": 2.805157482,
		"h": 1.3626373626
	},
	{
		"stop_id": 8582048,
		"ID": 200,
		"x": -97.8922772687,
		"y": 2.63023819,
		"h": 1.3626373626
	},
	{
		"stop_id": 8583200,
		"ID": 200,
		"x": -94.8402801377,
		"y": 3.016180243,
		"h": 1.3626373626
	},
	{
		"stop_id": 8583707,
		"ID": 200,
		"x": -98.6872473297,
		"y": 3.817227128,
		"h": 1.3626373626
	},
	{
		"stop_id": 8504125,
		"ID": 233,
		"x": -92.3172464657,
		"y": 8.339178046,
		"h": 1.6593406593
	},
	{
		"stop_id": 8504126,
		"ID": 233,
		"x": -90.0562660787,
		"y": 10.1162182,
		"h": 1.6593406593
	},
	{
		"stop_id": 8504886,
		"ID": 233,
		"x": -88.7342742987,
		"y": 9.084203055,
		"h": 1.6593406593
	},
	{
		"stop_id": 8570514,
		"ID": 233,
		"x": -90.0532428287,
		"y": 10.096192053,
		"h": 1.6593406593
	},
	{
		"stop_id": 8570515,
		"ID": 233,
		"x": -91.6472847647,
		"y": 10.30617378,
		"h": 1.6593406593
	},
	{
		"stop_id": 8577822,
		"ID": 233,
		"x": -88.7312301417,
		"y": 7.295231615,
		"h": 1.6593406593
	},
	{
		"stop_id": 8577823,
		"ID": 233,
		"x": -88.6902923347,
		"y": 7.591190824,
		"h": 1.6593406593
	},
	{
		"stop_id": 8577825,
		"ID": 233,
		"x": -89.9542617737,
		"y": 9.398203339,
		"h": 1.6593406593
	},
	{
		"stop_id": 8577828,
		"ID": 233,
		"x": -92.2942861167,
		"y": 8.341164938,
		"h": 1.6593406593
	},
	{
		"stop_id": 8579799,
		"ID": 233,
		"x": -90.3392287137,
		"y": 9.531236932,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583514,
		"ID": 233,
		"x": -90.2092873187,
		"y": 9.242194268,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583516,
		"ID": 233,
		"x": -90.7772431127,
		"y": 9.296150805,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583517,
		"ID": 233,
		"x": -89.9432603027,
		"y": 9.17725115,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583518,
		"ID": 233,
		"x": -90.2102664037,
		"y": 9.483217724,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583519,
		"ID": 233,
		"x": -89.6582887297,
		"y": 10.258174167,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583521,
		"ID": 233,
		"x": -90.3252754517,
		"y": 6.677191292,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583723,
		"ID": 233,
		"x": -90.6242669687,
		"y": 9.23321202,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583726,
		"ID": 233,
		"x": -90.3552887397,
		"y": 6.8772298,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583894,
		"ID": 233,
		"x": -90.0912358777,
		"y": 9.595226762,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583895,
		"ID": 233,
		"x": -89.8122436017,
		"y": 9.776244548,
		"h": 1.6593406593
	},
	{
		"stop_id": 8588723,
		"ID": 233,
		"x": -91.8662687137,
		"y": 8.083151271,
		"h": 1.6593406593
	},
	{
		"stop_id": 8504127,
		"ID": 266,
		"x": -87.4772715477,
		"y": 12.731186232,
		"h": 1.2967032967
	},
	{
		"stop_id": 8504186,
		"ID": 266,
		"x": -84.4032890047,
		"y": 13.111211899,
		"h": 1.2967032967
	},
	{
		"stop_id": 8504646,
		"ID": 266,
		"x": -87.6572958007,
		"y": 10.032240288,
		"h": 1.2967032967
	},
	{
		"stop_id": 8530821,
		"ID": 266,
		"x": -87.3662385817,
		"y": 13.082193633,
		"h": 1.2967032967
	},
	{
		"stop_id": 8577824,
		"ID": 266,
		"x": -88.2792488977,
		"y": 9.829186023,
		"h": 1.2967032967
	},
	{
		"stop_id": 8583520,
		"ID": 266,
		"x": -89.1672960417,
		"y": 11.259159729,
		"h": 1.2967032967
	},
	{
		"stop_id": 8595679,
		"ID": 266,
		"x": -84.4372877817,
		"y": 13.161157382,
		"h": 1.2967032967
	},
	{
		"stop_id": 8595680,
		"ID": 266,
		"x": -84.7142989497,
		"y": 12.66715702,
		"h": 1.2967032967
	},
	{
		"stop_id": 8595681,
		"ID": 266,
		"x": -84.7592270977,
		"y": 10.85815227,
		"h": 1.2967032967
	},
	{
		"stop_id": 8595682,
		"ID": 266,
		"x": -84.4122636747,
		"y": 8.937236273,
		"h": 1.2967032967
	},
	{
		"stop_id": 8504128,
		"ID": 267,
		"x": -84.3622892797,
		"y": 14.625192549,
		"h": 1.6263736264
	},
	{
		"stop_id": 8504536,
		"ID": 267,
		"x": -85.5742714357,
		"y": 17.819173102,
		"h": 1.6263736264
	},
	{
		"stop_id": 8504537,
		"ID": 267,
		"x": -84.5442386767,
		"y": 18.664144161,
		"h": 1.6263736264
	},
	{
		"stop_id": 8504572,
		"ID": 267,
		"x": -84.4302489787,
		"y": 18.93315089,
		"h": 1.6263736264
	},
	{
		"stop_id": 8504573,
		"ID": 267,
		"x": -85.7232621527,
		"y": 17.553231548,
		"h": 1.6263736264
	},
	{
		"stop_id": 8504574,
		"ID": 267,
		"x": -86.7352871987,
		"y": 17.031225112,
		"h": 1.6263736264
	},
	{
		"stop_id": 8504577,
		"ID": 267,
		"x": -84.2652251777,
		"y": 15.206217655,
		"h": 1.6263736264
	},
	{
		"stop_id": 8504892,
		"ID": 267,
		"x": -88.4692779017,
		"y": 16.733172045,
		"h": 1.6263736264
	},
	{
		"stop_id": 8504984,
		"ID": 267,
		"x": -87.7842715497,
		"y": 17.413169035,
		"h": 1.6263736264
	},
	{
		"stop_id": 8504985,
		"ID": 267,
		"x": -86.6702474447,
		"y": 17.238154848,
		"h": 1.6263736264
	},
	{
		"stop_id": 8570511,
		"ID": 267,
		"x": -88.7612361327,
		"y": 16.129145654,
		"h": 1.6263736264
	},
	{
		"stop_id": 8570533,
		"ID": 267,
		"x": -85.0252746107,
		"y": 18.12420561,
		"h": 1.6263736264
	},
	{
		"stop_id": 8577891,
		"ID": 267,
		"x": -84.3942569637,
		"y": 14.630216361,
		"h": 1.6263736264
	},
	{
		"stop_id": 8577892,
		"ID": 267,
		"x": -83.6782261967,
		"y": 15.772247401,
		"h": 1.6263736264
	},
	{
		"stop_id": 8583452,
		"ID": 267,
		"x": -85.0112335027,
		"y": 13.863164581,
		"h": 1.6263736264
	},
	{
		"stop_id": 8583453,
		"ID": 267,
		"x": -84.6292642337,
		"y": 14.747145653,
		"h": 1.6263736264
	},
	{
		"stop_id": 8587003,
		"ID": 267,
		"x": -84.8012568237,
		"y": 14.145207852,
		"h": 1.6263736264
	},
	{
		"stop_id": 8593301,
		"ID": 267,
		"x": -83.8362846787,
		"y": 15.609240866,
		"h": 1.6263736264
	},
	{
		"stop_id": 8595879,
		"ID": 267,
		"x": -84.5102368187,
		"y": 14.872161663,
		"h": 1.6263736264
	},
	{
		"stop_id": 8595880,
		"ID": 267,
		"x": -84.2382311287,
		"y": 15.122172187,
		"h": 1.6263736264
	},
	{
		"stop_id": 8504129,
		"ID": 300,
		"x": -81.4712748157,
		"y": 17.446247508,
		"h": 1.3296703297
	},
	{
		"stop_id": 8504188,
		"ID": 300,
		"x": -84.0422618537,
		"y": 18.930219468,
		"h": 1.3296703297
	},
	{
		"stop_id": 8504400,
		"ID": 300,
		"x": -78.4482996677,
		"y": 20.126211037,
		"h": 1.3296703297
	},
	{
		"stop_id": 8504484,
		"ID": 300,
		"x": -82.2732641887,
		"y": 22.168147662,
		"h": 1.3296703297
	},
	{
		"stop_id": 8504782,
		"ID": 300,
		"x": -78.4362546097,
		"y": 20.109163852,
		"h": 1.3296703297
	},
	{
		"stop_id": 8570531,
		"ID": 300,
		"x": -84.0422250737,
		"y": 18.939224245,
		"h": 1.3296703297
	},
	{
		"stop_id": 8570548,
		"ID": 300,
		"x": -79.0052998857,
		"y": 18.058196881,
		"h": 1.3296703297
	},
	{
		"stop_id": 8570549,
		"ID": 300,
		"x": -78.8612304747,
		"y": 19.163221592,
		"h": 1.3296703297
	},
	{
		"stop_id": 8570550,
		"ID": 300,
		"x": -78.4422408397,
		"y": 19.730198203,
		"h": 1.3296703297
	},
	{
		"stop_id": 8571246,
		"ID": 300,
		"x": -82.1422753687,
		"y": 22.330186707,
		"h": 1.3296703297
	},
	{
		"stop_id": 8595461,
		"ID": 300,
		"x": -81.2432759317,
		"y": 17.151148202,
		"h": 1.3296703297
	},
	{
		"stop_id": 8504130,
		"ID": 128,
		"x": -112.5642578837,
		"y": 0.964192438,
		"h": 1.2637362637
	},
	{
		"stop_id": 8504131,
		"ID": 128,
		"x": -109.5182900727,
		"y": 2.725140824,
		"h": 1.2637362637
	},
	{
		"stop_id": 8507651,
		"ID": 128,
		"x": -110.0342340187,
		"y": 0.699233959,
		"h": 1.2637362637
	},
	{
		"stop_id": 8570385,
		"ID": 128,
		"x": -112.4282490817,
		"y": 0.354211419,
		"h": 1.2637362637
	},
	{
		"stop_id": 8570386,
		"ID": 128,
		"x": -111.9892782007,
		"y": 0.367145384,
		"h": 1.2637362637
	},
	{
		"stop_id": 8579739,
		"ID": 128,
		"x": -112.8202984127,
		"y": 0.776244462,
		"h": 1.2637362637
	},
	{
		"stop_id": 8582675,
		"ID": 128,
		"x": -112.8082279527,
		"y": 0.433169989,
		"h": 1.2637362637
	},
	{
		"stop_id": 8583791,
		"ID": 128,
		"x": -112.5402574757,
		"y": 0.95019498,
		"h": 1.2637362637
	},
	{
		"stop_id": 8591808,
		"ID": 128,
		"x": -109.4552522367,
		"y": 2.578202069,
		"h": 1.2637362637
	},
	{
		"stop_id": 8504132,
		"ID": 150,
		"x": -105.1782896627,
		"y": 5.75423156,
		"h": 1.3956043956
	},
	{
		"stop_id": 8504564,
		"ID": 150,
		"x": -105.5232662387,
		"y": 6.61422675,
		"h": 1.3956043956
	},
	{
		"stop_id": 8504720,
		"ID": 150,
		"x": -106.4042964077,
		"y": 2.809178299,
		"h": 1.3956043956
	},
	{
		"stop_id": 8504722,
		"ID": 150,
		"x": -105.0792706977,
		"y": 4.469220079,
		"h": 1.3956043956
	},
	{
		"stop_id": 8504725,
		"ID": 150,
		"x": -105.4482395177,
		"y": 3.332187376,
		"h": 1.3956043956
	},
	{
		"stop_id": 8577608,
		"ID": 150,
		"x": -106.9342931507,
		"y": 4.850236255,
		"h": 1.3956043956
	},
	{
		"stop_id": 8577610,
		"ID": 150,
		"x": -107.6362814527,
		"y": 3.84715895,
		"h": 1.3956043956
	},
	{
		"stop_id": 8577611,
		"ID": 150,
		"x": -107.8922266837,
		"y": 3.655221175,
		"h": 1.3956043956
	},
	{
		"stop_id": 8577612,
		"ID": 150,
		"x": -105.0542854587,
		"y": 5.831220824,
		"h": 1.3956043956
	},
	{
		"stop_id": 8577623,
		"ID": 150,
		"x": -104.4422784347,
		"y": 6.130218303,
		"h": 1.3956043956
	},
	{
		"stop_id": 8587453,
		"ID": 150,
		"x": -106.5832934297,
		"y": 4.955198699,
		"h": 1.3956043956
	},
	{
		"stop_id": 8588831,
		"ID": 150,
		"x": -104.9592987367,
		"y": 4.776145491,
		"h": 1.3956043956
	},
	{
		"stop_id": 8588861,
		"ID": 150,
		"x": -103.9412820387,
		"y": 4.928166439,
		"h": 1.3956043956
	},
	{
		"stop_id": 8504133,
		"ID": 172,
		"x": -101.6762978117,
		"y": 2.563224403,
		"h": 1.4615384615
	},
	{
		"stop_id": 8504151,
		"ID": 172,
		"x": -99.6072321047,
		"y": 0.638141727,
		"h": 1.4615384615
	},
	{
		"stop_id": 8504721,
		"ID": 172,
		"x": -103.6292836747,
		"y": 3.772236673,
		"h": 1.4615384615
	},
	{
		"stop_id": 8504723,
		"ID": 172,
		"x": -103.0722691207,
		"y": 2.593198495,
		"h": 1.4615384615
	},
	{
		"stop_id": 8504902,
		"ID": 172,
		"x": -102.8902297797,
		"y": 1.72919166,
		"h": 1.4615384615
	},
	{
		"stop_id": 8570399,
		"ID": 172,
		"x": -98.5422554537,
		"y": 2.880224308,
		"h": 1.4615384615
	},
	{
		"stop_id": 8570400,
		"ID": 172,
		"x": -98.7122655067,
		"y": 2.614187785,
		"h": 1.4615384615
	},
	{
		"stop_id": 8570401,
		"ID": 172,
		"x": -99.2302717107,
		"y": 1.15424937,
		"h": 1.4615384615
	},
	{
		"stop_id": 8570402,
		"ID": 172,
		"x": -99.8472768947,
		"y": 0.305235719,
		"h": 1.4615384615
	},
	{
		"stop_id": 8570403,
		"ID": 172,
		"x": -100.2282323607,
		"y": 0.308249603,
		"h": 1.4615384615
	},
	{
		"stop_id": 8577621,
		"ID": 172,
		"x": -103.2132291777,
		"y": 2.352202596,
		"h": 1.4615384615
	},
	{
		"stop_id": 8577622,
		"ID": 172,
		"x": -101.6572330847,
		"y": 2.550194734,
		"h": 1.4615384615
	},
	{
		"stop_id": 8577625,
		"ID": 172,
		"x": -102.6972706357,
		"y": 4.901189076,
		"h": 1.4615384615
	},
	{
		"stop_id": 8577626,
		"ID": 172,
		"x": -102.0422995577,
		"y": 4.646154848,
		"h": 1.4615384615
	},
	{
		"stop_id": 8588820,
		"ID": 172,
		"x": -103.0292318217,
		"y": 1.465165005,
		"h": 1.4615384615
	},
	{
		"stop_id": 8504137,
		"ID": 232,
		"x": -92.3232548157,
		"y": 3.88616144,
		"h": 1.4945054945
	},
	{
		"stop_id": 8504617,
		"ID": 232,
		"x": -89.9972467287,
		"y": 2.391243439,
		"h": 1.4945054945
	},
	{
		"stop_id": 8504632,
		"ID": 232,
		"x": -89.6292486247,
		"y": 0.482162411,
		"h": 1.4945054945
	},
	{
		"stop_id": 8504639,
		"ID": 232,
		"x": -91.1052474317,
		"y": 1.158195976,
		"h": 1.4945054945
	},
	{
		"stop_id": 8570490,
		"ID": 232,
		"x": -90.3672864827,
		"y": -0.69783139,
		"h": 1.4945054945
	},
	{
		"stop_id": 8577799,
		"ID": 232,
		"x": -91.0532700857,
		"y": 0.88022111,
		"h": 1.4945054945
	},
	{
		"stop_id": 8577800,
		"ID": 232,
		"x": -90.1802750037,
		"y": 2.089236076,
		"h": 1.4945054945
	},
	{
		"stop_id": 8577801,
		"ID": 232,
		"x": -89.4022440307,
		"y": 2.440173581,
		"h": 1.4945054945
	},
	{
		"stop_id": 8577802,
		"ID": 232,
		"x": -88.8242730547,
		"y": 2.927143586,
		"h": 1.4945054945
	},
	{
		"stop_id": 8581636,
		"ID": 232,
		"x": -93.5862727457,
		"y": 2.660198936,
		"h": 1.4945054945
	},
	{
		"stop_id": 8581638,
		"ID": 232,
		"x": -94.0502292637,
		"y": 1.606173937,
		"h": 1.4945054945
	},
	{
		"stop_id": 8581804,
		"ID": 232,
		"x": -93.9032916187,
		"y": 2.140171258,
		"h": 1.4945054945
	},
	{
		"stop_id": 8588826,
		"ID": 232,
		"x": -88.9142942147,
		"y": 2.433210873,
		"h": 1.4945054945
	},
	{
		"stop_id": 8588828,
		"ID": 232,
		"x": -90.6432967667,
		"y": 0.842177597,
		"h": 1.4945054945
	},
	{
		"stop_id": 8595176,
		"ID": 232,
		"x": -89.1222525217,
		"y": 3.31914276,
		"h": 1.4945054945
	},
	{
		"stop_id": 8595878,
		"ID": 232,
		"x": -90.0432735407,
		"y": 2.435166653,
		"h": 1.4945054945
	},
	{
		"stop_id": 8504138,
		"ID": 265,
		"x": -88.1682905847,
		"y": 4.256242487,
		"h": 1.5274725275
	},
	{
		"stop_id": 8504139,
		"ID": 265,
		"x": -85.1102892997,
		"y": 2.569241884,
		"h": 1.5274725275
	},
	{
		"stop_id": 8504182,
		"ID": 265,
		"x": -84.9082647627,
		"y": 3.115228961,
		"h": 1.5274725275
	},
	{
		"stop_id": 8504531,
		"ID": 265,
		"x": -85.3292290877,
		"y": 3.195171787,
		"h": 1.5274725275
	},
	{
		"stop_id": 8504604,
		"ID": 265,
		"x": -86.0842655267,
		"y": 3.619234799,
		"h": 1.5274725275
	},
	{
		"stop_id": 8504610,
		"ID": 265,
		"x": -87.1392921487,
		"y": 4.887209197,
		"h": 1.5274725275
	},
	{
		"stop_id": 8504616,
		"ID": 265,
		"x": -85.3592792907,
		"y": 7.017208164,
		"h": 1.5274725275
	},
	{
		"stop_id": 8504648,
		"ID": 265,
		"x": -86.6262967037,
		"y": 7.873238881,
		"h": 1.5274725275
	},
	{
		"stop_id": 8504864,
		"ID": 265,
		"x": -88.1242706697,
		"y": 6.45219806,
		"h": 1.5274725275
	},
	{
		"stop_id": 8504900,
		"ID": 265,
		"x": -88.4102371117,
		"y": 6.920147494,
		"h": 1.5274725275
	},
	{
		"stop_id": 8577835,
		"ID": 265,
		"x": -87.9262385107,
		"y": 7.074146029,
		"h": 1.5274725275
	},
	{
		"stop_id": 8577836,
		"ID": 265,
		"x": -85.7252912407,
		"y": 7.358194473,
		"h": 1.5274725275
	},
	{
		"stop_id": 8588604,
		"ID": 265,
		"x": -86.2252892187,
		"y": 7.910242539,
		"h": 1.5274725275
	},
	{
		"stop_id": 8588605,
		"ID": 265,
		"x": -86.7892808587,
		"y": 7.545245401,
		"h": 1.5274725275
	},
	{
		"stop_id": 8589156,
		"ID": 265,
		"x": -85.1662632557,
		"y": 2.597161333,
		"h": 1.5274725275
	},
	{
		"stop_id": 8589174,
		"ID": 265,
		"x": -88.1482682117,
		"y": 4.263150835,
		"h": 1.5274725275
	},
	{
		"stop_id": 8594496,
		"ID": 265,
		"x": -86.8602467747,
		"y": 4.330195919,
		"h": 1.5274725275
	},
	{
		"stop_id": 8504140,
		"ID": 299,
		"x": -82.9952807187,
		"y": 16.018230347,
		"h": 1.6593406593
	},
	{
		"stop_id": 8504185,
		"ID": 299,
		"x": -81.7572546897,
		"y": 11.812150388,
		"h": 1.6593406593
	},
	{
		"stop_id": 8504778,
		"ID": 299,
		"x": -79.8672691657,
		"y": 11.05517283,
		"h": 1.6593406593
	},
	{
		"stop_id": 8570543,
		"ID": 299,
		"x": -78.3892850807,
		"y": 14.0711949,
		"h": 1.6593406593
	},
	{
		"stop_id": 8577893,
		"ID": 299,
		"x": -83.8342790097,
		"y": 15.145203716,
		"h": 1.6593406593
	},
	{
		"stop_id": 8577895,
		"ID": 299,
		"x": -83.8782423697,
		"y": 13.975194048,
		"h": 1.6593406593
	},
	{
		"stop_id": 8577896,
		"ID": 299,
		"x": -83.6362769507,
		"y": 13.265169482,
		"h": 1.6593406593
	},
	{
		"stop_id": 8577897,
		"ID": 299,
		"x": -81.7392424597,
		"y": 13.181150729,
		"h": 1.6593406593
	},
	{
		"stop_id": 8577898,
		"ID": 299,
		"x": -81.0372884897,
		"y": 12.420191876,
		"h": 1.6593406593
	},
	{
		"stop_id": 8577899,
		"ID": 299,
		"x": -80.8192561727,
		"y": 12.21919772,
		"h": 1.6593406593
	},
	{
		"stop_id": 8577901,
		"ID": 299,
		"x": -80.0102828187,
		"y": 10.974170131,
		"h": 1.6593406593
	},
	{
		"stop_id": 8587351,
		"ID": 299,
		"x": -81.4292250907,
		"y": 15.532168513,
		"h": 1.6593406593
	},
	{
		"stop_id": 8587393,
		"ID": 299,
		"x": -79.9642999067,
		"y": 14.996167646,
		"h": 1.6593406593
	},
	{
		"stop_id": 8587450,
		"ID": 299,
		"x": -81.4422454987,
		"y": 12.712143101,
		"h": 1.6593406593
	},
	{
		"stop_id": 8588722,
		"ID": 299,
		"x": -81.5822959087,
		"y": 11.980151855,
		"h": 1.6593406593
	},
	{
		"stop_id": 8588829,
		"ID": 299,
		"x": -83.2862588047,
		"y": 15.164244679,
		"h": 1.6593406593
	},
	{
		"stop_id": 8588938,
		"ID": 299,
		"x": -83.0632387837,
		"y": 16.067189314,
		"h": 1.6593406593
	},
	{
		"stop_id": 8589137,
		"ID": 299,
		"x": -81.8442386737,
		"y": 13.258247468,
		"h": 1.6593406593
	},
	{
		"stop_id": 8593298,
		"ID": 299,
		"x": -82.3302898437,
		"y": 15.9822066,
		"h": 1.6593406593
	},
	{
		"stop_id": 8593300,
		"ID": 299,
		"x": -82.3452618547,
		"y": 16.611159806,
		"h": 1.6593406593
	},
	{
		"stop_id": 8595697,
		"ID": 299,
		"x": -83.9532542087,
		"y": 14.335248302,
		"h": 1.6593406593
	},
	{
		"stop_id": 8504141,
		"ID": 148,
		"x": -103.1962986187,
		"y": -6.433859103,
		"h": 1.3626373626
	},
	{
		"stop_id": 8504153,
		"ID": 148,
		"x": -107.7602657857,
		"y": -4.93484813,
		"h": 1.3626373626
	},
	{
		"stop_id": 8570363,
		"ID": 148,
		"x": -108.2522321197,
		"y": -8.932809826,
		"h": 1.3626373626
	},
	{
		"stop_id": 8570377,
		"ID": 148,
		"x": -104.0622692547,
		"y": -5.129813726,
		"h": 1.3626373626
	},
	{
		"stop_id": 8570378,
		"ID": 148,
		"x": -103.9922319017,
		"y": -5.444833623,
		"h": 1.3626373626
	},
	{
		"stop_id": 8570379,
		"ID": 148,
		"x": -104.8672696337,
		"y": -6.529768888,
		"h": 1.3626373626
	},
	{
		"stop_id": 8570380,
		"ID": 148,
		"x": -105.4162376147,
		"y": -7.51179679,
		"h": 1.3626373626
	},
	{
		"stop_id": 8570383,
		"ID": 148,
		"x": -105.9592556677,
		"y": -4.850759527,
		"h": 1.3626373626
	},
	{
		"stop_id": 8577619,
		"ID": 148,
		"x": -107.8232978067,
		"y": -4.676758384,
		"h": 1.3626373626
	},
	{
		"stop_id": 8583314,
		"ID": 148,
		"x": -106.9002537057,
		"y": -7.452816134,
		"h": 1.3626373626
	},
	{
		"stop_id": 8583483,
		"ID": 148,
		"x": -109.0872631427,
		"y": -7.208838459,
		"h": 1.3626373626
	},
	{
		"stop_id": 8583752,
		"ID": 148,
		"x": -106.4712409067,
		"y": -7.023838979,
		"h": 1.3626373626
	},
	{
		"stop_id": 8504144,
		"ID": 108,
		"x": -119.0252524907,
		"y": -1.056832371,
		"h": 1.3296703297
	},
	{
		"stop_id": 8504458,
		"ID": 108,
		"x": -118.5932630677,
		"y": -1.261767335,
		"h": 1.3296703297
	},
	{
		"stop_id": 8507683,
		"ID": 108,
		"x": -115.6812897057,
		"y": -1.25280785,
		"h": 1.3296703297
	},
	{
		"stop_id": 8507687,
		"ID": 108,
		"x": -114.6552646787,
		"y": -1.179828438,
		"h": 1.3296703297
	},
	{
		"stop_id": 8507969,
		"ID": 108,
		"x": -116.4022627997,
		"y": -1.223785064,
		"h": 1.3296703297
	},
	{
		"stop_id": 8570318,
		"ID": 108,
		"x": -119.2932444817,
		"y": -1.456839675,
		"h": 1.3296703297
	},
	{
		"stop_id": 8570321,
		"ID": 108,
		"x": -117.0322749737,
		"y": -2.414781364,
		"h": 1.3296703297
	},
	{
		"stop_id": 8582674,
		"ID": 108,
		"x": -113.8282731237,
		"y": -0.421832257,
		"h": 1.3296703297
	},
	{
		"stop_id": 8594020,
		"ID": 108,
		"x": -118.8082881137,
		"y": -1.752812114,
		"h": 1.3296703297
	},
	{
		"stop_id": 8594035,
		"ID": 108,
		"x": -118.8132420537,
		"y": -1.921857726,
		"h": 1.3296703297
	},
	{
		"stop_id": 8594051,
		"ID": 108,
		"x": -118.9242840087,
		"y": -1.49585555,
		"h": 1.3296703297
	},
	{
		"stop_id": 8504152,
		"ID": 149,
		"x": -107.2032795157,
		"y": -3.520750352,
		"h": 1.3956043956
	},
	{
		"stop_id": 8504159,
		"ID": 149,
		"x": -104.0782588847,
		"y": -1.896850654,
		"h": 1.3956043956
	},
	{
		"stop_id": 8504718,
		"ID": 149,
		"x": -104.5832373757,
		"y": 0.549234515,
		"h": 1.3956043956
	},
	{
		"stop_id": 8504724,
		"ID": 149,
		"x": -107.9772388117,
		"y": -0.269796306,
		"h": 1.3956043956
	},
	{
		"stop_id": 8504726,
		"ID": 149,
		"x": -107.5182884427,
		"y": 1.178197767,
		"h": 1.3956043956
	},
	{
		"stop_id": 8504901,
		"ID": 149,
		"x": -105.9952618807,
		"y": -1.17883499,
		"h": 1.3956043956
	},
	{
		"stop_id": 8570404,
		"ID": 149,
		"x": -104.8042758187,
		"y": -2.400807663,
		"h": 1.3956043956
	},
	{
		"stop_id": 8570405,
		"ID": 149,
		"x": -106.9162926917,
		"y": -3.128808171,
		"h": 1.3956043956
	},
	{
		"stop_id": 8577613,
		"ID": 149,
		"x": -108.4502505897,
		"y": -2.057824943,
		"h": 1.3956043956
	},
	{
		"stop_id": 8577614,
		"ID": 149,
		"x": -108.5542626867,
		"y": -2.345800335,
		"h": 1.3956043956
	},
	{
		"stop_id": 8577620,
		"ID": 149,
		"x": -107.1152415407,
		"y": -3.420838492,
		"h": 1.3956043956
	},
	{
		"stop_id": 8580464,
		"ID": 149,
		"x": -106.2922799107,
		"y": -3.094788455,
		"h": 1.3956043956
	},
	{
		"stop_id": 8582049,
		"ID": 149,
		"x": -108.4722751287,
		"y": -2.379820508,
		"h": 1.3956043956
	},
	{
		"stop_id": 8504154,
		"ID": 199,
		"x": -97.8102313347,
		"y": 0.40319072,
		"h": 1.2967032967
	},
	{
		"stop_id": 8504158,
		"ID": 199,
		"x": -97.9172649777,
		"y": -0.169765491,
		"h": 1.2967032967
	},
	{
		"stop_id": 8504794,
		"ID": 199,
		"x": -95.7362477517,
		"y": -2.530768082,
		"h": 1.2967032967
	},
	{
		"stop_id": 8504795,
		"ID": 199,
		"x": -97.0802846877,
		"y": -2.908838159,
		"h": 1.2967032967
	},
	{
		"stop_id": 8570482,
		"ID": 199,
		"x": -98.5172271317,
		"y": -1.648803063,
		"h": 1.2967032967
	},
	{
		"stop_id": 8579744,
		"ID": 199,
		"x": -94.4292450567,
		"y": -0.542777036,
		"h": 1.2967032967
	},
	{
		"stop_id": 8581631,
		"ID": 199,
		"x": -94.2912737637,
		"y": 1.396229128,
		"h": 1.2967032967
	},
	{
		"stop_id": 8581632,
		"ID": 199,
		"x": -95.6322350917,
		"y": 0.021179665,
		"h": 1.2967032967
	},
	{
		"stop_id": 8581633,
		"ID": 199,
		"x": -94.8972514237,
		"y": -0.868770874,
		"h": 1.2967032967
	},
	{
		"stop_id": 8583429,
		"ID": 199,
		"x": -97.8842792507,
		"y": 2.054211834,
		"h": 1.2967032967
	},
	{
		"stop_id": 8504156,
		"ID": 173,
		"x": -99.6392391997,
		"y": 7.133193534,
		"h": 1.6263736264
	},
	{
		"stop_id": 8504719,
		"ID": 173,
		"x": -102.1572498897,
		"y": 7.816143423,
		"h": 1.6263736264
	},
	{
		"stop_id": 8504986,
		"ID": 173,
		"x": -98.6082880127,
		"y": 8.746159965,
		"h": 1.6263736264
	},
	{
		"stop_id": 8557020,
		"ID": 173,
		"x": -98.8032934847,
		"y": 9.156211971,
		"h": 1.6263736264
	},
	{
		"stop_id": 8570410,
		"ID": 173,
		"x": -99.5952544117,
		"y": 7.530226904,
		"h": 1.6263736264
	},
	{
		"stop_id": 8570415,
		"ID": 173,
		"x": -100.3492897207,
		"y": 10.574195108,
		"h": 1.6263736264
	},
	{
		"stop_id": 8577628,
		"ID": 173,
		"x": -100.3102335667,
		"y": 5.644238437,
		"h": 1.6263736264
	},
	{
		"stop_id": 8577629,
		"ID": 173,
		"x": -100.1372257317,
		"y": 6.693191071,
		"h": 1.6263736264
	},
	{
		"stop_id": 8577632,
		"ID": 173,
		"x": -103.3062300577,
		"y": 6.906249628,
		"h": 1.6263736264
	},
	{
		"stop_id": 8577633,
		"ID": 173,
		"x": -102.2212975597,
		"y": 7.313212341,
		"h": 1.6263736264
	},
	{
		"stop_id": 8577634,
		"ID": 173,
		"x": -101.8482655387,
		"y": 6.758156213,
		"h": 1.6263736264
	},
	{
		"stop_id": 8577635,
		"ID": 173,
		"x": -102.1132266697,
		"y": 8.335226378,
		"h": 1.6263736264
	},
	{
		"stop_id": 8577636,
		"ID": 173,
		"x": -102.1202588987,
		"y": 8.762177142,
		"h": 1.6263736264
	},
	{
		"stop_id": 8577637,
		"ID": 173,
		"x": -101.7452677457,
		"y": 9.201212488,
		"h": 1.6263736264
	},
	{
		"stop_id": 8577638,
		"ID": 173,
		"x": -100.4112269387,
		"y": 8.733163396,
		"h": 1.6263736264
	},
	{
		"stop_id": 8577639,
		"ID": 173,
		"x": -99.8302803217,
		"y": 8.108226289,
		"h": 1.6263736264
	},
	{
		"stop_id": 8583428,
		"ID": 173,
		"x": -99.2682271967,
		"y": 6.362196469,
		"h": 1.6263736264
	},
	{
		"stop_id": 8583485,
		"ID": 173,
		"x": -100.0132334787,
		"y": 10.56524642,
		"h": 1.6263736264
	},
	{
		"stop_id": 8583724,
		"ID": 173,
		"x": -98.9182810867,
		"y": 8.560196093,
		"h": 1.6263736264
	},
	{
		"stop_id": 8595537,
		"ID": 173,
		"x": -99.3682452527,
		"y": 7.13917005,
		"h": 1.6263736264
	},
	{
		"stop_id": 8504163,
		"ID": 124,
		"x": -110.0012672097,
		"y": -18.638796693,
		"h": 1.6923076923
	},
	{
		"stop_id": 8504164,
		"ID": 124,
		"x": -110.2152809627,
		"y": -19.7237977,
		"h": 1.6923076923
	},
	{
		"stop_id": 8504165,
		"ID": 124,
		"x": -110.4832818937,
		"y": -20.678821418,
		"h": 1.6923076923
	},
	{
		"stop_id": 8504166,
		"ID": 124,
		"x": -110.8592672997,
		"y": -21.436810254,
		"h": 1.6923076923
	},
	{
		"stop_id": 8504758,
		"ID": 124,
		"x": -110.9542674557,
		"y": -21.811754657,
		"h": 1.6923076923
	},
	{
		"stop_id": 8570417,
		"ID": 124,
		"x": -113.2232956307,
		"y": -23.430829576,
		"h": 1.6923076923
	},
	{
		"stop_id": 8570421,
		"ID": 124,
		"x": -109.9622668937,
		"y": -23.276798775,
		"h": 1.6923076923
	},
	{
		"stop_id": 8570422,
		"ID": 124,
		"x": -109.9752837377,
		"y": -22.78076147,
		"h": 1.6923076923
	},
	{
		"stop_id": 8570423,
		"ID": 124,
		"x": -109.9022282037,
		"y": -22.485772194,
		"h": 1.6923076923
	},
	{
		"stop_id": 8570425,
		"ID": 124,
		"x": -111.4082353677,
		"y": -21.53582905,
		"h": 1.6923076923
	},
	{
		"stop_id": 8570429,
		"ID": 124,
		"x": -112.8922513797,
		"y": -22.394773561,
		"h": 1.6923076923
	},
	{
		"stop_id": 8570430,
		"ID": 124,
		"x": -113.0822429847,
		"y": -21.127857844,
		"h": 1.6923076923
	},
	{
		"stop_id": 8570431,
		"ID": 124,
		"x": -113.0932716717,
		"y": -20.644835498,
		"h": 1.6923076923
	},
	{
		"stop_id": 8570432,
		"ID": 124,
		"x": -112.9922494787,
		"y": -20.044856951,
		"h": 1.6923076923
	},
	{
		"stop_id": 8570433,
		"ID": 124,
		"x": -112.3832492347,
		"y": -19.683815366,
		"h": 1.6923076923
	},
	{
		"stop_id": 8588153,
		"ID": 124,
		"x": -111.0992662227,
		"y": -18.475855357,
		"h": 1.6923076923
	},
	{
		"stop_id": 8591904,
		"ID": 124,
		"x": -111.6792270027,
		"y": -21.468788039,
		"h": 1.6923076923
	},
	{
		"stop_id": 8591905,
		"ID": 124,
		"x": -112.0772343437,
		"y": -21.275783865,
		"h": 1.6923076923
	},
	{
		"stop_id": 8591934,
		"ID": 124,
		"x": -109.9622502947,
		"y": -18.241801674,
		"h": 1.6923076923
	},
	{
		"stop_id": 8592224,
		"ID": 124,
		"x": -112.8872900277,
		"y": -22.353795676,
		"h": 1.6923076923
	},
	{
		"stop_id": 8592225,
		"ID": 124,
		"x": -112.4452538877,
		"y": -21.823855276,
		"h": 1.6923076923
	},
	{
		"stop_id": 8595474,
		"ID": 124,
		"x": -110.9112492677,
		"y": -22.248797419,
		"h": 1.6923076923
	},
	{
		"stop_id": 8504169,
		"ID": 123,
		"x": -112.3432702307,
		"y": -24.37877307,
		"h": 1.6593406593
	},
	{
		"stop_id": 8504997,
		"ID": 123,
		"x": -110.8462557557,
		"y": -25.146771522,
		"h": 1.6593406593
	},
	{
		"stop_id": 8557026,
		"ID": 123,
		"x": -109.9442930807,
		"y": -24.087821141,
		"h": 1.6593406593
	},
	{
		"stop_id": 8570419,
		"ID": 123,
		"x": -111.8672511707,
		"y": -25.269839874,
		"h": 1.6593406593
	},
	{
		"stop_id": 8570420,
		"ID": 123,
		"x": -110.1202844907,
		"y": -24.404847605,
		"h": 1.6593406593
	},
	{
		"stop_id": 8570460,
		"ID": 123,
		"x": -108.9672901807,
		"y": -25.49476038,
		"h": 1.6593406593
	},
	{
		"stop_id": 8570461,
		"ID": 123,
		"x": -109.6222604417,
		"y": -25.547828693,
		"h": 1.6593406593
	},
	{
		"stop_id": 8570462,
		"ID": 123,
		"x": -110.0322315637,
		"y": -24.884838551,
		"h": 1.6593406593
	},
	{
		"stop_id": 8579250,
		"ID": 123,
		"x": -112.5062318757,
		"y": -26.198752417,
		"h": 1.6593406593
	},
	{
		"stop_id": 8579251,
		"ID": 123,
		"x": -111.0672553837,
		"y": -27.88577557,
		"h": 1.6593406593
	},
	{
		"stop_id": 8581429,
		"ID": 123,
		"x": -110.3402550017,
		"y": -24.57075228,
		"h": 1.6593406593
	},
	{
		"stop_id": 8582772,
		"ID": 123,
		"x": -111.9422836147,
		"y": -28.600836896,
		"h": 1.6593406593
	},
	{
		"stop_id": 8582773,
		"ID": 123,
		"x": -112.5002623057,
		"y": -29.168819697,
		"h": 1.6593406593
	},
	{
		"stop_id": 8587545,
		"ID": 123,
		"x": -110.1422396207,
		"y": -25.969820931,
		"h": 1.6593406593
	},
	{
		"stop_id": 8591973,
		"ID": 123,
		"x": -110.4532486697,
		"y": -26.647782378,
		"h": 1.6593406593
	},
	{
		"stop_id": 8591975,
		"ID": 123,
		"x": -111.3672332237,
		"y": -27.774813833,
		"h": 1.6593406593
	},
	{
		"stop_id": 8592229,
		"ID": 123,
		"x": -112.7972290037,
		"y": -26.897781868,
		"h": 1.6593406593
	},
	{
		"stop_id": 8592230,
		"ID": 123,
		"x": -113.4222949037,
		"y": -27.650850975,
		"h": 1.6593406593
	},
	{
		"stop_id": 8592231,
		"ID": 123,
		"x": -112.6962487307,
		"y": -26.683781699,
		"h": 1.6593406593
	},
	{
		"stop_id": 8592232,
		"ID": 123,
		"x": -113.7032284217,
		"y": -27.850773992,
		"h": 1.6593406593
	},
	{
		"stop_id": 8592234,
		"ID": 123,
		"x": -112.9102972177,
		"y": -27.176818975,
		"h": 1.6593406593
	},
	{
		"stop_id": 8504171,
		"ID": 104,
		"x": -117.6002999147,
		"y": -26.087791347,
		"h": 1.5604395604
	},
	{
		"stop_id": 8570167,
		"ID": 104,
		"x": -118.1612746937,
		"y": -21.322791901,
		"h": 1.5604395604
	},
	{
		"stop_id": 8570168,
		"ID": 104,
		"x": -117.9172851017,
		"y": -21.17975068,
		"h": 1.5604395604
	},
	{
		"stop_id": 8570169,
		"ID": 104,
		"x": -117.6822665697,
		"y": -21.194809603,
		"h": 1.5604395604
	},
	{
		"stop_id": 8579240,
		"ID": 104,
		"x": -113.6102770867,
		"y": -24.066820037,
		"h": 1.5604395604
	},
	{
		"stop_id": 8587548,
		"ID": 104,
		"x": -116.7782862667,
		"y": -26.354794786,
		"h": 1.5604395604
	},
	{
		"stop_id": 8587549,
		"ID": 104,
		"x": -117.8422600677,
		"y": -25.969837275,
		"h": 1.5604395604
	},
	{
		"stop_id": 8587929,
		"ID": 104,
		"x": -116.9462388747,
		"y": -25.227815683,
		"h": 1.5604395604
	},
	{
		"stop_id": 8591968,
		"ID": 104,
		"x": -117.5982997397,
		"y": -26.341835973,
		"h": 1.5604395604
	},
	{
		"stop_id": 8592006,
		"ID": 104,
		"x": -116.4122751867,
		"y": -24.928827926,
		"h": 1.5604395604
	},
	{
		"stop_id": 8592015,
		"ID": 104,
		"x": -116.6332708497,
		"y": -25.942837948,
		"h": 1.5604395604
	},
	{
		"stop_id": 8592037,
		"ID": 104,
		"x": -117.7172416577,
		"y": -25.562826212,
		"h": 1.5604395604
	},
	{
		"stop_id": 8592070,
		"ID": 104,
		"x": -117.2252377567,
		"y": -25.264838787,
		"h": 1.5604395604
	},
	{
		"stop_id": 8592073,
		"ID": 104,
		"x": -116.9092420627,
		"y": -26.560771636,
		"h": 1.5604395604
	},
	{
		"stop_id": 8592100,
		"ID": 104,
		"x": -116.6642613187,
		"y": -25.75777854,
		"h": 1.5604395604
	},
	{
		"stop_id": 8592117,
		"ID": 104,
		"x": -115.7182943277,
		"y": -24.57381228,
		"h": 1.5604395604
	},
	{
		"stop_id": 8592130,
		"ID": 104,
		"x": -117.3732566067,
		"y": -25.483760335,
		"h": 1.5604395604
	},
	{
		"stop_id": 8592144,
		"ID": 104,
		"x": -114.4672388417,
		"y": -24.104758627,
		"h": 1.5604395604
	},
	{
		"stop_id": 8504180,
		"ID": 331,
		"x": -75.8882275297,
		"y": 14.027192532,
		"h": 1.8571428571
	},
	{
		"stop_id": 8504189,
		"ID": 331,
		"x": -75.2322555107,
		"y": 14.844218692,
		"h": 1.8571428571
	},
	{
		"stop_id": 8504485,
		"ID": 331,
		"x": -76.4712435727,
		"y": 17.784158364,
		"h": 1.8571428571
	},
	{
		"stop_id": 8504486,
		"ID": 331,
		"x": -75.2922287547,
		"y": 16.460243265,
		"h": 1.8571428571
	},
	{
		"stop_id": 8504539,
		"ID": 331,
		"x": -77.8132948577,
		"y": 15.323201427,
		"h": 1.8571428571
	},
	{
		"stop_id": 8504983,
		"ID": 331,
		"x": -78.9542366147,
		"y": 17.795222424,
		"h": 1.8571428571
	},
	{
		"stop_id": 8570544,
		"ID": 331,
		"x": -78.0642987687,
		"y": 15.619239471,
		"h": 1.8571428571
	},
	{
		"stop_id": 8570545,
		"ID": 331,
		"x": -78.7012708347,
		"y": 15.984209378,
		"h": 1.8571428571
	},
	{
		"stop_id": 8570546,
		"ID": 331,
		"x": -78.1622699827,
		"y": 16.26922561,
		"h": 1.8571428571
	},
	{
		"stop_id": 8570547,
		"ID": 331,
		"x": -78.3832631937,
		"y": 17.692238865,
		"h": 1.8571428571
	},
	{
		"stop_id": 8571449,
		"ID": 331,
		"x": -73.4542913837,
		"y": 16.272173153,
		"h": 1.8571428571
	},
	{
		"stop_id": 8571450,
		"ID": 331,
		"x": -74.0942398557,
		"y": 16.437217526,
		"h": 1.8571428571
	},
	{
		"stop_id": 8571451,
		"ID": 331,
		"x": -74.1012697807,
		"y": 16.83622702,
		"h": 1.8571428571
	},
	{
		"stop_id": 8571452,
		"ID": 331,
		"x": -74.5422589447,
		"y": 16.736143886,
		"h": 1.8571428571
	},
	{
		"stop_id": 8571453,
		"ID": 331,
		"x": -75.3132618857,
		"y": 16.540230276,
		"h": 1.8571428571
	},
	{
		"stop_id": 8571455,
		"ID": 331,
		"x": -73.5222293537,
		"y": 17.182153305,
		"h": 1.8571428571
	},
	{
		"stop_id": 8581353,
		"ID": 331,
		"x": -78.3002570437,
		"y": 16.507227318,
		"h": 1.8571428571
	},
	{
		"stop_id": 8583440,
		"ID": 331,
		"x": -76.7462312727,
		"y": 19.022165117,
		"h": 1.8571428571
	},
	{
		"stop_id": 8587394,
		"ID": 331,
		"x": -78.1612831877,
		"y": 15.678237342,
		"h": 1.8571428571
	},
	{
		"stop_id": 8587395,
		"ID": 331,
		"x": -76.8362936557,
		"y": 16.233248111,
		"h": 1.8571428571
	},
	{
		"stop_id": 8587800,
		"ID": 331,
		"x": -76.8182363717,
		"y": 18.966230018,
		"h": 1.8571428571
	},
	{
		"stop_id": 8588088,
		"ID": 331,
		"x": -75.6632934537,
		"y": 14.313183693,
		"h": 1.8571428571
	},
	{
		"stop_id": 8588089,
		"ID": 331,
		"x": -74.7542947117,
		"y": 16.646182767,
		"h": 1.8571428571
	},
	{
		"stop_id": 8591855,
		"ID": 331,
		"x": -75.1112945397,
		"y": 19.413146987,
		"h": 1.8571428571
	},
	{
		"stop_id": 8593296,
		"ID": 331,
		"x": -79.4582665967,
		"y": 16.800221282,
		"h": 1.8571428571
	},
	{
		"stop_id": 8594856,
		"ID": 331,
		"x": -76.3012671757,
		"y": 16.307218666,
		"h": 1.8571428571
	},
	{
		"stop_id": 8594857,
		"ID": 331,
		"x": -75.7882412977,
		"y": 16.613199205,
		"h": 1.8571428571
	},
	{
		"stop_id": 8504183,
		"ID": 298,
		"x": -82.7162268327,
		"y": 5.44216605,
		"h": 1.2967032967
	},
	{
		"stop_id": 8504184,
		"ID": 298,
		"x": -83.8452384637,
		"y": 8.217201008,
		"h": 1.2967032967
	},
	{
		"stop_id": 8570536,
		"ID": 298,
		"x": -78.5682293217,
		"y": 8.740141803,
		"h": 1.2967032967
	},
	{
		"stop_id": 8587104,
		"ID": 298,
		"x": -82.1232335967,
		"y": 9.237140851,
		"h": 1.2967032967
	},
	{
		"stop_id": 8587105,
		"ID": 298,
		"x": -81.6112707877,
		"y": 8.944196023,
		"h": 1.2967032967
	},
	{
		"stop_id": 8587107,
		"ID": 298,
		"x": -82.7232471127,
		"y": 8.843214497,
		"h": 1.2967032967
	},
	{
		"stop_id": 8587108,
		"ID": 298,
		"x": -82.6672635367,
		"y": 9.662212276,
		"h": 1.2967032967
	},
	{
		"stop_id": 8587109,
		"ID": 298,
		"x": -82.0452780767,
		"y": 10.532204671,
		"h": 1.2967032967
	},
	{
		"stop_id": 8587226,
		"ID": 298,
		"x": -83.2632256737,
		"y": 8.632208287,
		"h": 1.2967032967
	},
	{
		"stop_id": 8587227,
		"ID": 298,
		"x": -83.8312981797,
		"y": 8.195244125,
		"h": 1.2967032967
	},
	{
		"stop_id": 8504192,
		"ID": 360,
		"x": -70.3182575097,
		"y": 11.109232466,
		"h": 1.2637362637
	},
	{
		"stop_id": 8504487,
		"ID": 360,
		"x": -70.5382854897,
		"y": 15.578227911,
		"h": 1.2637362637
	},
	{
		"stop_id": 8575471,
		"ID": 360,
		"x": -71.8532773927,
		"y": 15.85924911,
		"h": 1.2637362637
	},
	{
		"stop_id": 8575837,
		"ID": 360,
		"x": -71.3532618467,
		"y": 15.373212085,
		"h": 1.2637362637
	},
	{
		"stop_id": 8575990,
		"ID": 360,
		"x": -70.5422653117,
		"y": 15.567229266,
		"h": 1.2637362637
	},
	{
		"stop_id": 8588083,
		"ID": 360,
		"x": -69.6302919067,
		"y": 11.137172484,
		"h": 1.2637362637
	},
	{
		"stop_id": 8588084,
		"ID": 360,
		"x": -70.1372408707,
		"y": 11.080230774,
		"h": 1.2637362637
	},
	{
		"stop_id": 8588086,
		"ID": 360,
		"x": -70.3312947557,
		"y": 11.063231387,
		"h": 1.2637362637
	},
	{
		"stop_id": 8588125,
		"ID": 360,
		"x": -70.9062602677,
		"y": 11.195243146,
		"h": 1.2637362637
	},
	{
		"stop_id": 8504194,
		"ID": 330,
		"x": -75.0282989507,
		"y": 12.060204972,
		"h": 1.6593406593
	},
	{
		"stop_id": 8504197,
		"ID": 330,
		"x": -76.4672587007,
		"y": 12.894186805,
		"h": 1.6593406593
	},
	{
		"stop_id": 8504198,
		"ID": 330,
		"x": -75.8072762027,
		"y": 13.062235647,
		"h": 1.6593406593
	},
	{
		"stop_id": 8504199,
		"ID": 330,
		"x": -74.7602733557,
		"y": 12.833155812,
		"h": 1.6593406593
	},
	{
		"stop_id": 8504538,
		"ID": 330,
		"x": -79.1212680567,
		"y": 10.212250823,
		"h": 1.6593406593
	},
	{
		"stop_id": 8504767,
		"ID": 330,
		"x": -75.8042426687,
		"y": 10.941210285,
		"h": 1.6593406593
	},
	{
		"stop_id": 8504783,
		"ID": 330,
		"x": -78.3722616667,
		"y": 12.74520964,
		"h": 1.6593406593
	},
	{
		"stop_id": 8570537,
		"ID": 330,
		"x": -78.4932763747,
		"y": 9.615146317,
		"h": 1.6593406593
	},
	{
		"stop_id": 8570538,
		"ID": 330,
		"x": -78.6422329757,
		"y": 10.26018144,
		"h": 1.6593406593
	},
	{
		"stop_id": 8570540,
		"ID": 330,
		"x": -79.4132337007,
		"y": 11.351147049,
		"h": 1.6593406593
	},
	{
		"stop_id": 8570541,
		"ID": 330,
		"x": -78.7212639867,
		"y": 12.007140143,
		"h": 1.6593406593
	},
	{
		"stop_id": 8570542,
		"ID": 330,
		"x": -78.5002754157,
		"y": 12.376192311,
		"h": 1.6593406593
	},
	{
		"stop_id": 8570551,
		"ID": 330,
		"x": -77.0922878967,
		"y": 8.211158544,
		"h": 1.6593406593
	},
	{
		"stop_id": 8570552,
		"ID": 330,
		"x": -76.3022397897,
		"y": 9.035232847,
		"h": 1.6593406593
	},
	{
		"stop_id": 8570553,
		"ID": 330,
		"x": -76.3732444677,
		"y": 9.733244109,
		"h": 1.6593406593
	},
	{
		"stop_id": 8570554,
		"ID": 330,
		"x": -75.1962922457,
		"y": 11.480219718,
		"h": 1.6593406593
	},
	{
		"stop_id": 8570555,
		"ID": 330,
		"x": -74.9932484107,
		"y": 12.090242092,
		"h": 1.6593406593
	},
	{
		"stop_id": 8580591,
		"ID": 330,
		"x": -79.5192955677,
		"y": 10.736170853,
		"h": 1.6593406593
	},
	{
		"stop_id": 8581035,
		"ID": 330,
		"x": -76.1682265697,
		"y": 10.524204797,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583735,
		"ID": 330,
		"x": -75.0102999717,
		"y": 12.304177398,
		"h": 1.6593406593
	},
	{
		"stop_id": 8588087,
		"ID": 330,
		"x": -74.8312500057,
		"y": 13.02421504,
		"h": 1.6593406593
	},
	{
		"stop_id": 8504203,
		"ID": 109,
		"x": -114.3092636837,
		"y": 6.539196953,
		"h": 1.3626373626
	},
	{
		"stop_id": 8504556,
		"ID": 109,
		"x": -114.5302574997,
		"y": 6.294192627,
		"h": 1.3626373626
	},
	{
		"stop_id": 8504989,
		"ID": 109,
		"x": -119.1782290137,
		"y": 4.446232609,
		"h": 1.3626373626
	},
	{
		"stop_id": 8507658,
		"ID": 109,
		"x": -118.2512722487,
		"y": 5.225195378,
		"h": 1.3626373626
	},
	{
		"stop_id": 8507664,
		"ID": 109,
		"x": -115.3922303607,
		"y": 6.180205255,
		"h": 1.3626373626
	},
	{
		"stop_id": 8507678,
		"ID": 109,
		"x": -118.8762532987,
		"y": 4.668141254,
		"h": 1.3626373626
	},
	{
		"stop_id": 8507695,
		"ID": 109,
		"x": -116.9382759867,
		"y": 5.216147534,
		"h": 1.3626373626
	},
	{
		"stop_id": 8570275,
		"ID": 109,
		"x": -118.5522256587,
		"y": 5.032150737,
		"h": 1.3626373626
	},
	{
		"stop_id": 8570280,
		"ID": 109,
		"x": -114.6112262487,
		"y": 6.995219044,
		"h": 1.3626373626
	},
	{
		"stop_id": 8570281,
		"ID": 109,
		"x": -114.5462690147,
		"y": 7.242206424,
		"h": 1.3626373626
	},
	{
		"stop_id": 8582968,
		"ID": 109,
		"x": -118.1912865597,
		"y": 5.048174843,
		"h": 1.3626373626
	},
	{
		"stop_id": 8583309,
		"ID": 109,
		"x": -114.5692513147,
		"y": 6.641189939,
		"h": 1.3626373626
	},
	{
		"stop_id": 8504204,
		"ID": 129,
		"x": -111.6582619567,
		"y": 9.4912274,
		"h": 1.5274725275
	},
	{
		"stop_id": 8504243,
		"ID": 129,
		"x": -111.3782679717,
		"y": 9.534157171,
		"h": 1.5274725275
	},
	{
		"stop_id": 8504555,
		"ID": 129,
		"x": -110.3192491927,
		"y": 10.838158817,
		"h": 1.5274725275
	},
	{
		"stop_id": 8507656,
		"ID": 129,
		"x": -113.8512811277,
		"y": 9.035215419,
		"h": 1.5274725275
	},
	{
		"stop_id": 8570282,
		"ID": 129,
		"x": -113.8342339397,
		"y": 7.82015342,
		"h": 1.5274725275
	},
	{
		"stop_id": 8570283,
		"ID": 129,
		"x": -113.6852643717,
		"y": 8.753221116,
		"h": 1.5274725275
	},
	{
		"stop_id": 8570327,
		"ID": 129,
		"x": -111.1822987117,
		"y": 10.610182119,
		"h": 1.5274725275
	},
	{
		"stop_id": 8570328,
		"ID": 129,
		"x": -111.6812301417,
		"y": 9.506213333,
		"h": 1.5274725275
	},
	{
		"stop_id": 8570329,
		"ID": 129,
		"x": -113.0452326087,
		"y": 9.322239967,
		"h": 1.5274725275
	},
	{
		"stop_id": 8570330,
		"ID": 129,
		"x": -112.3972735337,
		"y": 10.691152765,
		"h": 1.5274725275
	},
	{
		"stop_id": 8573440,
		"ID": 129,
		"x": -112.1162775277,
		"y": 8.604172483,
		"h": 1.5274725275
	},
	{
		"stop_id": 8575841,
		"ID": 129,
		"x": -111.6712775407,
		"y": 9.581168931,
		"h": 1.5274725275
	},
	{
		"stop_id": 8581065,
		"ID": 129,
		"x": -112.6252497947,
		"y": 10.51818102,
		"h": 1.5274725275
	},
	{
		"stop_id": 8581068,
		"ID": 129,
		"x": -112.0922808987,
		"y": 9.384178438,
		"h": 1.5274725275
	},
	{
		"stop_id": 8581625,
		"ID": 129,
		"x": -112.3122714307,
		"y": 8.010227493,
		"h": 1.5274725275
	},
	{
		"stop_id": 8582050,
		"ID": 129,
		"x": -111.8192264417,
		"y": 9.41714286,
		"h": 1.5274725275
	},
	{
		"stop_id": 8582593,
		"ID": 129,
		"x": -110.9572246067,
		"y": 10.610247171,
		"h": 1.5274725275
	},
	{
		"stop_id": 8504205,
		"ID": 130,
		"x": -109.8512538647,
		"y": 11.858230432,
		"h": 1.6263736264
	},
	{
		"stop_id": 8504554,
		"ID": 130,
		"x": -109.3652415257,
		"y": 11.95822634,
		"h": 1.6263736264
	},
	{
		"stop_id": 8570322,
		"ID": 130,
		"x": -109.8342267967,
		"y": 11.853195789,
		"h": 1.6263736264
	},
	{
		"stop_id": 8570324,
		"ID": 130,
		"x": -110.4252892617,
		"y": 11.203152393,
		"h": 1.6263736264
	},
	{
		"stop_id": 8570325,
		"ID": 130,
		"x": -110.7392926927,
		"y": 11.121224865,
		"h": 1.6263736264
	},
	{
		"stop_id": 8570326,
		"ID": 130,
		"x": -110.8472596957,
		"y": 11.2932451,
		"h": 1.6263736264
	},
	{
		"stop_id": 8570331,
		"ID": 130,
		"x": -112.6572742737,
		"y": 10.869218803,
		"h": 1.6263736264
	},
	{
		"stop_id": 8570332,
		"ID": 130,
		"x": -112.4852691967,
		"y": 11.721179066,
		"h": 1.6263736264
	},
	{
		"stop_id": 8570333,
		"ID": 130,
		"x": -112.6072955427,
		"y": 11.68423753,
		"h": 1.6263736264
	},
	{
		"stop_id": 8578066,
		"ID": 130,
		"x": -111.4132656427,
		"y": 12.411193825,
		"h": 1.6263736264
	},
	{
		"stop_id": 8579645,
		"ID": 130,
		"x": -110.3292529197,
		"y": 11.357202301,
		"h": 1.6263736264
	},
	{
		"stop_id": 8579646,
		"ID": 130,
		"x": -109.9282677397,
		"y": 12.133143465,
		"h": 1.6263736264
	},
	{
		"stop_id": 8579647,
		"ID": 130,
		"x": -110.1592883597,
		"y": 11.77422144,
		"h": 1.6263736264
	},
	{
		"stop_id": 8579648,
		"ID": 130,
		"x": -110.2552374097,
		"y": 11.440177801,
		"h": 1.6263736264
	},
	{
		"stop_id": 8579650,
		"ID": 130,
		"x": -109.7122444477,
		"y": 11.960233595,
		"h": 1.6263736264
	},
	{
		"stop_id": 8579651,
		"ID": 130,
		"x": -109.4632822707,
		"y": 12.117242854,
		"h": 1.6263736264
	},
	{
		"stop_id": 8579652,
		"ID": 130,
		"x": -108.6422558207,
		"y": 12.970161614,
		"h": 1.6263736264
	},
	{
		"stop_id": 8579805,
		"ID": 130,
		"x": -110.1602789357,
		"y": 11.774229811,
		"h": 1.6263736264
	},
	{
		"stop_id": 8581066,
		"ID": 130,
		"x": -110.5022571387,
		"y": 11.320205611,
		"h": 1.6263736264
	},
	{
		"stop_id": 8582594,
		"ID": 130,
		"x": -111.0352667057,
		"y": 10.859168443,
		"h": 1.6263736264
	},
	{
		"stop_id": 8504206,
		"ID": 152,
		"x": -107.4882426987,
		"y": 15.243208003,
		"h": 2.3516483516
	},
	{
		"stop_id": 8504208,
		"ID": 152,
		"x": -105.6832457897,
		"y": 18.537227935,
		"h": 2.3516483516
	},
	{
		"stop_id": 8504234,
		"ID": 152,
		"x": -107.4112497177,
		"y": 19.402177119,
		"h": 2.3516483516
	},
	{
		"stop_id": 8504511,
		"ID": 152,
		"x": -105.3942713407,
		"y": 17.4391637,
		"h": 2.3516483516
	},
	{
		"stop_id": 8504559,
		"ID": 152,
		"x": -106.7162904137,
		"y": 14.490210323,
		"h": 2.3516483516
	},
	{
		"stop_id": 8530713,
		"ID": 152,
		"x": -105.0952619167,
		"y": 17.645220528,
		"h": 2.3516483516
	},
	{
		"stop_id": 8530793,
		"ID": 152,
		"x": -104.2512450867,
		"y": 16.237177727,
		"h": 2.3516483516
	},
	{
		"stop_id": 8571792,
		"ID": 152,
		"x": -105.3112978317,
		"y": 19.478241023,
		"h": 2.3516483516
	},
	{
		"stop_id": 8571795,
		"ID": 152,
		"x": -107.3502621357,
		"y": 19.453163296,
		"h": 2.3516483516
	},
	{
		"stop_id": 8579640,
		"ID": 152,
		"x": -104.3352378337,
		"y": 17.966224447,
		"h": 2.3516483516
	},
	{
		"stop_id": 8579641,
		"ID": 152,
		"x": -104.3292824107,
		"y": 17.592190859,
		"h": 2.3516483516
	},
	{
		"stop_id": 8579642,
		"ID": 152,
		"x": -104.4042934807,
		"y": 17.223210733,
		"h": 2.3516483516
	},
	{
		"stop_id": 8579643,
		"ID": 152,
		"x": -104.8172367337,
		"y": 16.720145477,
		"h": 2.3516483516
	},
	{
		"stop_id": 8579644,
		"ID": 152,
		"x": -104.9922831537,
		"y": 16.830199973,
		"h": 2.3516483516
	},
	{
		"stop_id": 8579653,
		"ID": 152,
		"x": -107.8032320547,
		"y": 14.223161664,
		"h": 2.3516483516
	},
	{
		"stop_id": 8579654,
		"ID": 152,
		"x": -107.5422315957,
		"y": 14.845193405,
		"h": 2.3516483516
	},
	{
		"stop_id": 8579655,
		"ID": 152,
		"x": -107.2352647667,
		"y": 15.269203135,
		"h": 2.3516483516
	},
	{
		"stop_id": 8579656,
		"ID": 152,
		"x": -107.0582825237,
		"y": 15.594202368,
		"h": 2.3516483516
	},
	{
		"stop_id": 8579657,
		"ID": 152,
		"x": -106.2192841247,
		"y": 16.601174236,
		"h": 2.3516483516
	},
	{
		"stop_id": 8579658,
		"ID": 152,
		"x": -105.3472898967,
		"y": 16.495159855,
		"h": 2.3516483516
	},
	{
		"stop_id": 8579659,
		"ID": 152,
		"x": -105.8512601127,
		"y": 17.058242359,
		"h": 2.3516483516
	},
	{
		"stop_id": 8579662,
		"ID": 152,
		"x": -105.3832930387,
		"y": 17.441191912,
		"h": 2.3516483516
	},
	{
		"stop_id": 8579663,
		"ID": 152,
		"x": -106.0322871097,
		"y": 17.502229631,
		"h": 2.3516483516
	},
	{
		"stop_id": 8579664,
		"ID": 152,
		"x": -106.3322670557,
		"y": 17.771163025,
		"h": 2.3516483516
	},
	{
		"stop_id": 8579665,
		"ID": 152,
		"x": -106.5982917547,
		"y": 17.979143569,
		"h": 2.3516483516
	},
	{
		"stop_id": 8579666,
		"ID": 152,
		"x": -106.7932352167,
		"y": 17.662165395,
		"h": 2.3516483516
	},
	{
		"stop_id": 8579667,
		"ID": 152,
		"x": -106.8522470987,
		"y": 17.410154963,
		"h": 2.3516483516
	},
	{
		"stop_id": 8579668,
		"ID": 152,
		"x": -106.8072466817,
		"y": 16.977220762,
		"h": 2.3516483516
	},
	{
		"stop_id": 8588242,
		"ID": 152,
		"x": -106.0342645267,
		"y": 17.12025091,
		"h": 2.3516483516
	},
	{
		"stop_id": 8593543,
		"ID": 152,
		"x": -104.3222812607,
		"y": 17.205142346,
		"h": 2.3516483516
	},
	{
		"stop_id": 8593544,
		"ID": 152,
		"x": -104.1422273007,
		"y": 16.980227647,
		"h": 2.3516483516
	},
	{
		"stop_id": 8593545,
		"ID": 152,
		"x": -103.9422850347,
		"y": 16.930158403,
		"h": 2.3516483516
	},
	{
		"stop_id": 8594231,
		"ID": 152,
		"x": -104.6622400447,
		"y": 17.949225288,
		"h": 2.3516483516
	},
	{
		"stop_id": 8594864,
		"ID": 152,
		"x": -105.5662569557,
		"y": 17.933207191,
		"h": 2.3516483516
	},
	{
		"stop_id": 8594865,
		"ID": 152,
		"x": -105.9182644087,
		"y": 18.030200329,
		"h": 2.3516483516
	},
	{
		"stop_id": 8594866,
		"ID": 152,
		"x": -105.2592707997,
		"y": 18.259151347,
		"h": 2.3516483516
	},
	{
		"stop_id": 8594867,
		"ID": 152,
		"x": -105.7232710647,
		"y": 18.509187264,
		"h": 2.3516483516
	},
	{
		"stop_id": 8594868,
		"ID": 152,
		"x": -105.7432605387,
		"y": 18.286214916,
		"h": 2.3516483516
	},
	{
		"stop_id": 8594869,
		"ID": 152,
		"x": -105.7462781997,
		"y": 17.767166113,
		"h": 2.3516483516
	},
	{
		"stop_id": 8595245,
		"ID": 152,
		"x": -104.3352702637,
		"y": 17.982233738,
		"h": 2.3516483516
	},
	{
		"stop_id": 8595246,
		"ID": 152,
		"x": -104.7072756377,
		"y": 17.963239378,
		"h": 2.3516483516
	},
	{
		"stop_id": 8595495,
		"ID": 152,
		"x": -106.6252537407,
		"y": 16.903189656,
		"h": 2.3516483516
	},
	{
		"stop_id": 8504209,
		"ID": 175,
		"x": -104.6242867697,
		"y": 19.4402288,
		"h": 2.7472527473
	},
	{
		"stop_id": 8504219,
		"ID": 175,
		"x": -102.4202240597,
		"y": 20.75722893,
		"h": 2.7472527473
	},
	{
		"stop_id": 8504220,
		"ID": 175,
		"x": -100.4652397147,
		"y": 21.224143769,
		"h": 2.7472527473
	},
	{
		"stop_id": 8504231,
		"ID": 175,
		"x": -100.7842517527,
		"y": 21.400210417,
		"h": 2.7472527473
	},
	{
		"stop_id": 8504232,
		"ID": 175,
		"x": -101.9532674737,
		"y": 21.166245679,
		"h": 2.7472527473
	},
	{
		"stop_id": 8504260,
		"ID": 175,
		"x": -100.1862282537,
		"y": 21.83214281,
		"h": 2.7472527473
	},
	{
		"stop_id": 8504325,
		"ID": 175,
		"x": -103.3662652277,
		"y": 19.234216054,
		"h": 2.7472527473
	},
	{
		"stop_id": 8504509,
		"ID": 175,
		"x": -100.3522885457,
		"y": 20.885181086,
		"h": 2.7472527473
	},
	{
		"stop_id": 8504510,
		"ID": 175,
		"x": -102.3322284057,
		"y": 20.156147528,
		"h": 2.7472527473
	},
	{
		"stop_id": 8504552,
		"ID": 175,
		"x": -102.1272792267,
		"y": 20.106213549,
		"h": 2.7472527473
	},
	{
		"stop_id": 8504741,
		"ID": 175,
		"x": -103.2472944987,
		"y": 21.382232381,
		"h": 2.7472527473
	},
	{
		"stop_id": 8504742,
		"ID": 175,
		"x": -102.2312693807,
		"y": 21.305189542,
		"h": 2.7472527473
	},
	{
		"stop_id": 8504746,
		"ID": 175,
		"x": -101.5942258567,
		"y": 21.568163011,
		"h": 2.7472527473
	},
	{
		"stop_id": 8530709,
		"ID": 175,
		"x": -99.7862547897,
		"y": 21.286242912,
		"h": 2.7472527473
	},
	{
		"stop_id": 8530710,
		"ID": 175,
		"x": -100.9452990597,
		"y": 20.797202875,
		"h": 2.7472527473
	},
	{
		"stop_id": 8530711,
		"ID": 175,
		"x": -103.0532281227,
		"y": 19.476181099,
		"h": 2.7472527473
	},
	{
		"stop_id": 8530712,
		"ID": 175,
		"x": -103.4822469987,
		"y": 18.67519429,
		"h": 2.7472527473
	},
	{
		"stop_id": 8571789,
		"ID": 175,
		"x": -103.9642667367,
		"y": 19.302216985,
		"h": 2.7472527473
	},
	{
		"stop_id": 8571845,
		"ID": 175,
		"x": -102.4932801227,
		"y": 21.370211905,
		"h": 2.7472527473
	},
	{
		"stop_id": 8571846,
		"ID": 175,
		"x": -100.8172556357,
		"y": 21.766200903,
		"h": 2.7472527473
	},
	{
		"stop_id": 8580772,
		"ID": 175,
		"x": -103.0282918257,
		"y": 21.336166609,
		"h": 2.7472527473
	},
	{
		"stop_id": 8583699,
		"ID": 175,
		"x": -103.2692611347,
		"y": 21.64520929,
		"h": 2.7472527473
	},
	{
		"stop_id": 8593540,
		"ID": 175,
		"x": -102.6072251317,
		"y": 21.130227533,
		"h": 2.7472527473
	},
	{
		"stop_id": 8593541,
		"ID": 175,
		"x": -102.4412837727,
		"y": 21.205189698,
		"h": 2.7472527473
	},
	{
		"stop_id": 8593542,
		"ID": 175,
		"x": -102.9372472627,
		"y": 21.060237818,
		"h": 2.7472527473
	},
	{
		"stop_id": 8593547,
		"ID": 175,
		"x": -100.9572828107,
		"y": 21.440205417,
		"h": 2.7472527473
	},
	{
		"stop_id": 8593558,
		"ID": 175,
		"x": -100.7822491747,
		"y": 20.940158391,
		"h": 2.7472527473
	},
	{
		"stop_id": 8593559,
		"ID": 175,
		"x": -100.6622529647,
		"y": 21.495202776,
		"h": 2.7472527473
	},
	{
		"stop_id": 8593560,
		"ID": 175,
		"x": -100.5372629807,
		"y": 21.050204774,
		"h": 2.7472527473
	},
	{
		"stop_id": 8593561,
		"ID": 175,
		"x": -100.5272631527,
		"y": 21.810233366,
		"h": 2.7472527473
	},
	{
		"stop_id": 8593562,
		"ID": 175,
		"x": -100.2322397937,
		"y": 21.185200274,
		"h": 2.7472527473
	},
	{
		"stop_id": 8593563,
		"ID": 175,
		"x": -99.9872756917,
		"y": 21.745190544,
		"h": 2.7472527473
	},
	{
		"stop_id": 8593564,
		"ID": 175,
		"x": -99.9872423097,
		"y": 21.93018398,
		"h": 2.7472527473
	},
	{
		"stop_id": 8593565,
		"ID": 175,
		"x": -99.9722952687,
		"y": 21.305173721,
		"h": 2.7472527473
	},
	{
		"stop_id": 8593567,
		"ID": 175,
		"x": -99.7722806547,
		"y": 21.735180677,
		"h": 2.7472527473
	},
	{
		"stop_id": 8593569,
		"ID": 175,
		"x": -99.4622799667,
		"y": 21.860176226,
		"h": 2.7472527473
	},
	{
		"stop_id": 8593571,
		"ID": 175,
		"x": -99.4472687447,
		"y": 21.59014565,
		"h": 2.7472527473
	},
	{
		"stop_id": 8593574,
		"ID": 175,
		"x": -99.3472617197,
		"y": 21.665188988,
		"h": 2.7472527473
	},
	{
		"stop_id": 8593613,
		"ID": 175,
		"x": -101.2272583367,
		"y": 21.695223957,
		"h": 2.7472527473
	},
	{
		"stop_id": 8593614,
		"ID": 175,
		"x": -101.9772475867,
		"y": 21.400215116,
		"h": 2.7472527473
	},
	{
		"stop_id": 8594596,
		"ID": 175,
		"x": -103.0742980647,
		"y": 20.994195394,
		"h": 2.7472527473
	},
	{
		"stop_id": 8594601,
		"ID": 175,
		"x": -99.6782580867,
		"y": 21.496192181,
		"h": 2.7472527473
	},
	{
		"stop_id": 8594603,
		"ID": 175,
		"x": -99.7732614017,
		"y": 22.019236984,
		"h": 2.7472527473
	},
	{
		"stop_id": 8594861,
		"ID": 175,
		"x": -102.3622693757,
		"y": 20.743250623,
		"h": 2.7472527473
	},
	{
		"stop_id": 8594862,
		"ID": 175,
		"x": -102.7782253917,
		"y": 20.345236753,
		"h": 2.7472527473
	},
	{
		"stop_id": 8594870,
		"ID": 175,
		"x": -104.4692903987,
		"y": 19.497207125,
		"h": 2.7472527473
	},
	{
		"stop_id": 8594871,
		"ID": 175,
		"x": -104.1252358177,
		"y": 19.138209367,
		"h": 2.7472527473
	},
	{
		"stop_id": 8594872,
		"ID": 175,
		"x": -103.4702549767,
		"y": 19.334145771,
		"h": 2.7472527473
	},
	{
		"stop_id": 8594873,
		"ID": 175,
		"x": -104.1952826157,
		"y": 19.471142397,
		"h": 2.7472527473
	},
	{
		"stop_id": 8594874,
		"ID": 175,
		"x": -101.8492565967,
		"y": 21.167176884,
		"h": 2.7472527473
	},
	{
		"stop_id": 8594875,
		"ID": 175,
		"x": -100.3442421097,
		"y": 21.574182705,
		"h": 2.7472527473
	},
	{
		"stop_id": 8594877,
		"ID": 175,
		"x": -101.3472499257,
		"y": 21.311176203,
		"h": 2.7472527473
	},
	{
		"stop_id": 8594878,
		"ID": 175,
		"x": -101.7832563357,
		"y": 21.377163294,
		"h": 2.7472527473
	},
	{
		"stop_id": 8595247,
		"ID": 175,
		"x": -103.0612876407,
		"y": 19.498140993,
		"h": 2.7472527473
	},
	{
		"stop_id": 8504215,
		"ID": 111,
		"x": -117.7642439507,
		"y": 16.748171457,
		"h": 1.0659340659
	},
	{
		"stop_id": 8504216,
		"ID": 111,
		"x": -114.3072465147,
		"y": 18.106220917,
		"h": 1.0659340659
	},
	{
		"stop_id": 8595200,
		"ID": 111,
		"x": -117.6912303617,
		"y": 16.622166149,
		"h": 1.0659340659
	},
	{
		"stop_id": 8504217,
		"ID": 131,
		"x": -110.2542310197,
		"y": 18.625142483,
		"h": 1.1648351648
	},
	{
		"stop_id": 8504738,
		"ID": 131,
		"x": -111.0412627827,
		"y": 21.19823631,
		"h": 1.1648351648
	},
	{
		"stop_id": 8504747,
		"ID": 131,
		"x": -111.9132522037,
		"y": 22.31923537,
		"h": 1.1648351648
	},
	{
		"stop_id": 8595194,
		"ID": 131,
		"x": -112.8222963797,
		"y": 20.055168033,
		"h": 1.1648351648
	},
	{
		"stop_id": 8595195,
		"ID": 131,
		"x": -113.4392860817,
		"y": 19.29714263,
		"h": 1.1648351648
	},
	{
		"stop_id": 8595196,
		"ID": 131,
		"x": -112.3722303287,
		"y": 20.953142963,
		"h": 1.1648351648
	},
	{
		"stop_id": 8504218,
		"ID": 153,
		"x": -105.4742677427,
		"y": 19.5932213,
		"h": 1.5274725275
	},
	{
		"stop_id": 8504396,
		"ID": 153,
		"x": -108.9162278537,
		"y": 21.745194534,
		"h": 1.5274725275
	},
	{
		"stop_id": 8504743,
		"ID": 153,
		"x": -107.2422807697,
		"y": 21.379182975,
		"h": 1.5274725275
	},
	{
		"stop_id": 8504745,
		"ID": 153,
		"x": -104.8232415857,
		"y": 22.202194635,
		"h": 1.5274725275
	},
	{
		"stop_id": 8571791,
		"ID": 153,
		"x": -104.8052827467,
		"y": 19.518194324,
		"h": 1.5274725275
	},
	{
		"stop_id": 8571793,
		"ID": 153,
		"x": -105.7502367997,
		"y": 19.689177548,
		"h": 1.5274725275
	},
	{
		"stop_id": 8571794,
		"ID": 153,
		"x": -106.9332426697,
		"y": 19.679198528,
		"h": 1.5274725275
	},
	{
		"stop_id": 8571796,
		"ID": 153,
		"x": -107.1922670427,
		"y": 20.1411858,
		"h": 1.5274725275
	},
	{
		"stop_id": 8571797,
		"ID": 153,
		"x": -107.5782365397,
		"y": 20.642224952,
		"h": 1.5274725275
	},
	{
		"stop_id": 8571798,
		"ID": 153,
		"x": -107.6492460657,
		"y": 20.725176268,
		"h": 1.5274725275
	},
	{
		"stop_id": 8571799,
		"ID": 153,
		"x": -107.4282971337,
		"y": 21.075160669,
		"h": 1.5274725275
	},
	{
		"stop_id": 8571843,
		"ID": 153,
		"x": -108.4152916367,
		"y": 22.198232051,
		"h": 1.5274725275
	},
	{
		"stop_id": 8571844,
		"ID": 153,
		"x": -107.2212455247,
		"y": 21.460172976,
		"h": 1.5274725275
	},
	{
		"stop_id": 8579789,
		"ID": 153,
		"x": -105.3422957017,
		"y": 21.880182536,
		"h": 1.5274725275
	},
	{
		"stop_id": 8579790,
		"ID": 153,
		"x": -105.5422422857,
		"y": 21.58021101,
		"h": 1.5274725275
	},
	{
		"stop_id": 8583820,
		"ID": 153,
		"x": -104.9532875667,
		"y": 22.577172825,
		"h": 1.5274725275
	},
	{
		"stop_id": 8594863,
		"ID": 153,
		"x": -105.5092978567,
		"y": 19.600160796,
		"h": 1.5274725275
	},
	{
		"stop_id": 8504221,
		"ID": 203,
		"x": -97.9952320987,
		"y": 22.62722945,
		"h": 3.6373626374
	},
	{
		"stop_id": 8504222,
		"ID": 203,
		"x": -94.4542531817,
		"y": 24.58919696,
		"h": 3.6373626374
	},
	{
		"stop_id": 8504261,
		"ID": 203,
		"x": -98.5082554087,
		"y": 21.906250193,
		"h": 3.6373626374
	},
	{
		"stop_id": 8504268,
		"ID": 203,
		"x": -96.0682639487,
		"y": 23.947241936,
		"h": 3.6373626374
	},
	{
		"stop_id": 8504398,
		"ID": 203,
		"x": -98.5722740627,
		"y": 21.818173002,
		"h": 3.6373626374
	},
	{
		"stop_id": 8504480,
		"ID": 203,
		"x": -94.2602864967,
		"y": 24.313246418,
		"h": 3.6373626374
	},
	{
		"stop_id": 8504550,
		"ID": 203,
		"x": -98.1802360797,
		"y": 21.988170573,
		"h": 3.6373626374
	},
	{
		"stop_id": 8504560,
		"ID": 203,
		"x": -94.4002611327,
		"y": 24.09415829,
		"h": 3.6373626374
	},
	{
		"stop_id": 8504808,
		"ID": 203,
		"x": -95.3302306957,
		"y": 23.580243809,
		"h": 3.6373626374
	},
	{
		"stop_id": 8530006,
		"ID": 203,
		"x": -98.6332291107,
		"y": 22.269158916,
		"h": 3.6373626374
	},
	{
		"stop_id": 8530007,
		"ID": 203,
		"x": -98.6422616467,
		"y": 22.400180913,
		"h": 3.6373626374
	},
	{
		"stop_id": 8530008,
		"ID": 203,
		"x": -98.6422490357,
		"y": 22.53014327,
		"h": 3.6373626374
	},
	{
		"stop_id": 8530023,
		"ID": 203,
		"x": -98.6392301207,
		"y": 22.666200582,
		"h": 3.6373626374
	},
	{
		"stop_id": 8530708,
		"ID": 203,
		"x": -98.9382803477,
		"y": 21.85014386,
		"h": 3.6373626374
	},
	{
		"stop_id": 8530791,
		"ID": 203,
		"x": -97.9792674167,
		"y": 22.602223898,
		"h": 3.6373626374
	},
	{
		"stop_id": 8530792,
		"ID": 203,
		"x": -97.8462568097,
		"y": 22.325214853,
		"h": 3.6373626374
	},
	{
		"stop_id": 8571848,
		"ID": 203,
		"x": -98.6482922437,
		"y": 22.257250558,
		"h": 3.6373626374
	},
	{
		"stop_id": 8571849,
		"ID": 203,
		"x": -98.0142277067,
		"y": 22.571208703,
		"h": 3.6373626374
	},
	{
		"stop_id": 8579623,
		"ID": 203,
		"x": -98.3382743957,
		"y": 21.982189193,
		"h": 3.6373626374
	},
	{
		"stop_id": 8579624,
		"ID": 203,
		"x": -98.4332638447,
		"y": 22.208155392,
		"h": 3.6373626374
	},
	{
		"stop_id": 8579625,
		"ID": 203,
		"x": -98.1292679167,
		"y": 22.62520186,
		"h": 3.6373626374
	},
	{
		"stop_id": 8579627,
		"ID": 203,
		"x": -97.8652756937,
		"y": 22.776147007,
		"h": 3.6373626374
	},
	{
		"stop_id": 8579628,
		"ID": 203,
		"x": -98.6672647037,
		"y": 22.671164336,
		"h": 3.6373626374
	},
	{
		"stop_id": 8579629,
		"ID": 203,
		"x": -98.8662538657,
		"y": 22.843232398,
		"h": 3.6373626374
	},
	{
		"stop_id": 8579630,
		"ID": 203,
		"x": -98.8502456997,
		"y": 23.080150479,
		"h": 3.6373626374
	},
	{
		"stop_id": 8588620,
		"ID": 203,
		"x": -96.8422371167,
		"y": 22.950228383,
		"h": 3.6373626374
	},
	{
		"stop_id": 8593548,
		"ID": 203,
		"x": -95.4622305107,
		"y": 24.230179359,
		"h": 3.6373626374
	},
	{
		"stop_id": 8593549,
		"ID": 203,
		"x": -95.1422522497,
		"y": 24.395250207,
		"h": 3.6373626374
	},
	{
		"stop_id": 8593550,
		"ID": 203,
		"x": -95.2972738887,
		"y": 24.030189901,
		"h": 3.6373626374
	},
	{
		"stop_id": 8593551,
		"ID": 203,
		"x": -95.0872731777,
		"y": 24.165237909,
		"h": 3.6373626374
	},
	{
		"stop_id": 8593552,
		"ID": 203,
		"x": -94.8072260337,
		"y": 24.420170247,
		"h": 3.6373626374
	},
	{
		"stop_id": 8593553,
		"ID": 203,
		"x": -94.7922490867,
		"y": 24.355156401,
		"h": 3.6373626374
	},
	{
		"stop_id": 8593568,
		"ID": 203,
		"x": -99.5922760977,
		"y": 22.180225704,
		"h": 3.6373626374
	},
	{
		"stop_id": 8593570,
		"ID": 203,
		"x": -99.4522732427,
		"y": 22.060222727,
		"h": 3.6373626374
	},
	{
		"stop_id": 8593573,
		"ID": 203,
		"x": -99.4022933747,
		"y": 22.300247877,
		"h": 3.6373626374
	},
	{
		"stop_id": 8593575,
		"ID": 203,
		"x": -99.3472701257,
		"y": 22.99016183,
		"h": 3.6373626374
	},
	{
		"stop_id": 8593576,
		"ID": 203,
		"x": -99.2372577727,
		"y": 22.135168893,
		"h": 3.6373626374
	},
	{
		"stop_id": 8593577,
		"ID": 203,
		"x": -99.2022459127,
		"y": 23.01021053,
		"h": 3.6373626374
	},
	{
		"stop_id": 8593578,
		"ID": 203,
		"x": -99.1972884727,
		"y": 22.33523949,
		"h": 3.6373626374
	},
	{
		"stop_id": 8593579,
		"ID": 203,
		"x": -99.1472315587,
		"y": 22.060196868,
		"h": 3.6373626374
	},
	{
		"stop_id": 8593580,
		"ID": 203,
		"x": -99.0522239907,
		"y": 21.875242266,
		"h": 3.6373626374
	},
	{
		"stop_id": 8593581,
		"ID": 203,
		"x": -98.9672903527,
		"y": 22.250227776,
		"h": 3.6373626374
	},
	{
		"stop_id": 8593582,
		"ID": 203,
		"x": -98.8862535307,
		"y": 22.381213217,
		"h": 3.6373626374
	},
	{
		"stop_id": 8593583,
		"ID": 203,
		"x": -98.8522813337,
		"y": 22.145189826,
		"h": 3.6373626374
	},
	{
		"stop_id": 8593584,
		"ID": 203,
		"x": -98.7422790567,
		"y": 22.355142851,
		"h": 3.6373626374
	},
	{
		"stop_id": 8593585,
		"ID": 203,
		"x": -98.7372699007,
		"y": 21.970225707,
		"h": 3.6373626374
	},
	{
		"stop_id": 8593586,
		"ID": 203,
		"x": -98.5172291337,
		"y": 22.070179,
		"h": 3.6373626374
	},
	{
		"stop_id": 8593587,
		"ID": 203,
		"x": -98.5302894077,
		"y": 22.704178235,
		"h": 3.6373626374
	},
	{
		"stop_id": 8593588,
		"ID": 203,
		"x": -98.4472499867,
		"y": 22.385235281,
		"h": 3.6373626374
	},
	{
		"stop_id": 8593589,
		"ID": 203,
		"x": -98.3472947257,
		"y": 21.940223951,
		"h": 3.6373626374
	},
	{
		"stop_id": 8593590,
		"ID": 203,
		"x": -98.3072818927,
		"y": 22.750200456,
		"h": 3.6373626374
	},
	{
		"stop_id": 8593591,
		"ID": 203,
		"x": -98.2172837097,
		"y": 22.435217933,
		"h": 3.6373626374
	},
	{
		"stop_id": 8593592,
		"ID": 203,
		"x": -98.1972347147,
		"y": 22.065212694,
		"h": 3.6373626374
	},
	{
		"stop_id": 8593593,
		"ID": 203,
		"x": -98.0722492827,
		"y": 22.845181291,
		"h": 3.6373626374
	},
	{
		"stop_id": 8593594,
		"ID": 203,
		"x": -98.0672279877,
		"y": 22.160206149,
		"h": 3.6373626374
	},
	{
		"stop_id": 8593595,
		"ID": 203,
		"x": -97.8922869637,
		"y": 22.905170759,
		"h": 3.6373626374
	},
	{
		"stop_id": 8593596,
		"ID": 203,
		"x": -97.8322363287,
		"y": 22.305224988,
		"h": 3.6373626374
	},
	{
		"stop_id": 8593597,
		"ID": 203,
		"x": -97.6172413767,
		"y": 23.015143963,
		"h": 3.6373626374
	},
	{
		"stop_id": 8593598,
		"ID": 203,
		"x": -97.5172761367,
		"y": 22.935241578,
		"h": 3.6373626374
	},
	{
		"stop_id": 8593599,
		"ID": 203,
		"x": -97.4722754157,
		"y": 22.535174638,
		"h": 3.6373626374
	},
	{
		"stop_id": 8593600,
		"ID": 203,
		"x": -97.4522827027,
		"y": 22.485242032,
		"h": 3.6373626374
	},
	{
		"stop_id": 8593601,
		"ID": 203,
		"x": -97.3272430897,
		"y": 22.652212538,
		"h": 3.6373626374
	},
	{
		"stop_id": 8593602,
		"ID": 203,
		"x": -97.2122935827,
		"y": 23.090180107,
		"h": 3.6373626374
	},
	{
		"stop_id": 8593603,
		"ID": 203,
		"x": -97.0272430137,
		"y": 22.690237048,
		"h": 3.6373626374
	},
	{
		"stop_id": 8593604,
		"ID": 203,
		"x": -96.8322565237,
		"y": 23.27023594,
		"h": 3.6373626374
	},
	{
		"stop_id": 8593605,
		"ID": 203,
		"x": -96.6922886957,
		"y": 22.760188757,
		"h": 3.6373626374
	},
	{
		"stop_id": 8593606,
		"ID": 203,
		"x": -96.5122719877,
		"y": 22.880142159,
		"h": 3.6373626374
	},
	{
		"stop_id": 8593607,
		"ID": 203,
		"x": -96.4792848667,
		"y": 23.480166384,
		"h": 3.6373626374
	},
	{
		"stop_id": 8593608,
		"ID": 203,
		"x": -96.4472531897,
		"y": 22.730211991,
		"h": 3.6373626374
	},
	{
		"stop_id": 8593609,
		"ID": 203,
		"x": -96.3222779177,
		"y": 23.325223265,
		"h": 3.6373626374
	},
	{
		"stop_id": 8593610,
		"ID": 203,
		"x": -96.2572929187,
		"y": 23.715155894,
		"h": 3.6373626374
	},
	{
		"stop_id": 8593611,
		"ID": 203,
		"x": -95.8672837087,
		"y": 23.620167458,
		"h": 3.6373626374
	},
	{
		"stop_id": 8593612,
		"ID": 203,
		"x": -95.7722805137,
		"y": 24.100196482,
		"h": 3.6373626374
	},
	{
		"stop_id": 8593615,
		"ID": 203,
		"x": -94.4472499417,
		"y": 24.460194325,
		"h": 3.6373626374
	},
	{
		"stop_id": 8594597,
		"ID": 203,
		"x": -95.3082524627,
		"y": 24.356217609,
		"h": 3.6373626374
	},
	{
		"stop_id": 8594598,
		"ID": 203,
		"x": -96.0912416247,
		"y": 23.472224721,
		"h": 3.6373626374
	},
	{
		"stop_id": 8594599,
		"ID": 203,
		"x": -95.6702671547,
		"y": 23.779176237,
		"h": 3.6373626374
	},
	{
		"stop_id": 8594600,
		"ID": 203,
		"x": -97.7032996537,
		"y": 22.389226976,
		"h": 3.6373626374
	},
	{
		"stop_id": 8594602,
		"ID": 203,
		"x": -97.1972889737,
		"y": 22.6101478,
		"h": 3.6373626374
	},
	{
		"stop_id": 8594876,
		"ID": 203,
		"x": -96.6182703397,
		"y": 22.639217237,
		"h": 3.6373626374
	},
	{
		"stop_id": 8595248,
		"ID": 203,
		"x": -96.0662514117,
		"y": 23.903204743,
		"h": 3.6373626374
	},
	{
		"stop_id": 8504223,
		"ID": 236,
		"x": -91.3032772857,
		"y": 27.239150221,
		"h": 1.956043956
	},
	{
		"stop_id": 8504481,
		"ID": 236,
		"x": -92.2922610927,
		"y": 23.969187365,
		"h": 1.956043956
	},
	{
		"stop_id": 8504490,
		"ID": 236,
		"x": -90.7722972527,
		"y": 23.980186094,
		"h": 1.956043956
	},
	{
		"stop_id": 8504566,
		"ID": 236,
		"x": -91.3482377827,
		"y": 23.483160216,
		"h": 1.956043956
	},
	{
		"stop_id": 8504567,
		"ID": 236,
		"x": -90.5762684467,
		"y": 25.136149872,
		"h": 1.956043956
	},
	{
		"stop_id": 8504700,
		"ID": 236,
		"x": -89.9352733567,
		"y": 25.538199932,
		"h": 1.956043956
	},
	{
		"stop_id": 8504701,
		"ID": 236,
		"x": -89.0772993167,
		"y": 26.23919091,
		"h": 1.956043956
	},
	{
		"stop_id": 8571527,
		"ID": 236,
		"x": -89.3542463847,
		"y": 25.975192177,
		"h": 1.956043956
	},
	{
		"stop_id": 8571910,
		"ID": 236,
		"x": -94.0712324397,
		"y": 24.316154749,
		"h": 1.956043956
	},
	{
		"stop_id": 8571911,
		"ID": 236,
		"x": -94.3482922547,
		"y": 24.596250624,
		"h": 1.956043956
	},
	{
		"stop_id": 8571912,
		"ID": 236,
		"x": -93.7792948157,
		"y": 25.289250275,
		"h": 1.956043956
	},
	{
		"stop_id": 8571913,
		"ID": 236,
		"x": -93.5722524127,
		"y": 26.682192789,
		"h": 1.956043956
	},
	{
		"stop_id": 8571914,
		"ID": 236,
		"x": -93.3352573167,
		"y": 27.542228015,
		"h": 1.956043956
	},
	{
		"stop_id": 8578906,
		"ID": 236,
		"x": -88.5822753067,
		"y": 24.580171931,
		"h": 1.956043956
	},
	{
		"stop_id": 8582487,
		"ID": 236,
		"x": -92.3372802257,
		"y": 23.955203646,
		"h": 1.956043956
	},
	{
		"stop_id": 8582488,
		"ID": 236,
		"x": -91.6192753197,
		"y": 25.414247217,
		"h": 1.956043956
	},
	{
		"stop_id": 8582489,
		"ID": 236,
		"x": -91.4782685797,
		"y": 25.76624768,
		"h": 1.956043956
	},
	{
		"stop_id": 8582490,
		"ID": 236,
		"x": -90.7712875837,
		"y": 25.354175308,
		"h": 1.956043956
	},
	{
		"stop_id": 8582491,
		"ID": 236,
		"x": -91.3432945507,
		"y": 27.303176772,
		"h": 1.956043956
	},
	{
		"stop_id": 8582592,
		"ID": 236,
		"x": -91.4352361527,
		"y": 24.283182948,
		"h": 1.956043956
	},
	{
		"stop_id": 8582670,
		"ID": 236,
		"x": -90.7952558577,
		"y": 27.89718303,
		"h": 1.956043956
	},
	{
		"stop_id": 8582671,
		"ID": 236,
		"x": -91.6922862387,
		"y": 23.654204091,
		"h": 1.956043956
	},
	{
		"stop_id": 8582672,
		"ID": 236,
		"x": -92.9072972117,
		"y": 23.95824301,
		"h": 1.956043956
	},
	{
		"stop_id": 8582792,
		"ID": 236,
		"x": -89.4252556847,
		"y": 24.877150922,
		"h": 1.956043956
	},
	{
		"stop_id": 8593554,
		"ID": 236,
		"x": -93.4422757207,
		"y": 24.02517436,
		"h": 1.956043956
	},
	{
		"stop_id": 8593555,
		"ID": 236,
		"x": -93.0172596937,
		"y": 23.985205217,
		"h": 1.956043956
	},
	{
		"stop_id": 8593556,
		"ID": 236,
		"x": -92.7522482437,
		"y": 24.135147347,
		"h": 1.956043956
	},
	{
		"stop_id": 8593557,
		"ID": 236,
		"x": -92.5972991507,
		"y": 23.965194405,
		"h": 1.956043956
	},
	{
		"stop_id": 8593616,
		"ID": 236,
		"x": -94.1572620757,
		"y": 24.39024891,
		"h": 1.956043956
	},
	{
		"stop_id": 8593617,
		"ID": 236,
		"x": -93.7722949767,
		"y": 24.24017312,
		"h": 1.956043956
	},
	{
		"stop_id": 8504224,
		"ID": 237,
		"x": -90.0672844847,
		"y": 28.720227457,
		"h": 1.2967032967
	},
	{
		"stop_id": 8571908,
		"ID": 237,
		"x": -88.8482709057,
		"y": 31.078146042,
		"h": 1.2967032967
	},
	{
		"stop_id": 8571915,
		"ID": 237,
		"x": -92.9912462027,
		"y": 28.20122641,
		"h": 1.2967032967
	},
	{
		"stop_id": 8571916,
		"ID": 237,
		"x": -92.1502938907,
		"y": 29.253185243,
		"h": 1.2967032967
	},
	{
		"stop_id": 8571917,
		"ID": 237,
		"x": -91.7992330617,
		"y": 30.205160436,
		"h": 1.2967032967
	},
	{
		"stop_id": 8571918,
		"ID": 237,
		"x": -91.4402968197,
		"y": 30.917199846,
		"h": 1.2967032967
	},
	{
		"stop_id": 8571919,
		"ID": 237,
		"x": -90.8912687807,
		"y": 32.137221175,
		"h": 1.2967032967
	},
	{
		"stop_id": 8571920,
		"ID": 237,
		"x": -90.6642958067,
		"y": 32.718148524,
		"h": 1.2967032967
	},
	{
		"stop_id": 8582492,
		"ID": 237,
		"x": -90.1202901937,
		"y": 28.741176591,
		"h": 1.2967032967
	},
	{
		"stop_id": 8583490,
		"ID": 237,
		"x": -92.4122424167,
		"y": 28.939216866,
		"h": 1.2967032967
	},
	{
		"stop_id": 8504225,
		"ID": 269,
		"x": -88.0282570247,
		"y": 29.231245518,
		"h": 1.989010989
	},
	{
		"stop_id": 8504226,
		"ID": 269,
		"x": -85.8302975177,
		"y": 29.910244408,
		"h": 1.989010989
	},
	{
		"stop_id": 8504377,
		"ID": 269,
		"x": -85.9562845737,
		"y": 29.748151241,
		"h": 1.989010989
	},
	{
		"stop_id": 8504378,
		"ID": 269,
		"x": -85.6692883177,
		"y": 28.403242209,
		"h": 1.989010989
	},
	{
		"stop_id": 8504565,
		"ID": 269,
		"x": -87.2792906917,
		"y": 28.621160871,
		"h": 1.989010989
	},
	{
		"stop_id": 8504702,
		"ID": 269,
		"x": -86.4062262467,
		"y": 26.402152366,
		"h": 1.989010989
	},
	{
		"stop_id": 8504703,
		"ID": 269,
		"x": -87.5182973027,
		"y": 25.426249886,
		"h": 1.989010989
	},
	{
		"stop_id": 8504760,
		"ID": 269,
		"x": -85.6722857377,
		"y": 27.664171757,
		"h": 1.989010989
	},
	{
		"stop_id": 8504991,
		"ID": 269,
		"x": -87.2212513337,
		"y": 25.758167457,
		"h": 1.989010989
	},
	{
		"stop_id": 8504992,
		"ID": 269,
		"x": -84.6752531967,
		"y": 26.512148338,
		"h": 1.989010989
	},
	{
		"stop_id": 8571243,
		"ID": 269,
		"x": -84.8082449167,
		"y": 26.879246804,
		"h": 1.989010989
	},
	{
		"stop_id": 8571523,
		"ID": 269,
		"x": -84.8742994467,
		"y": 26.231162238,
		"h": 1.989010989
	},
	{
		"stop_id": 8571524,
		"ID": 269,
		"x": -85.7382962327,
		"y": 27.341167039,
		"h": 1.989010989
	},
	{
		"stop_id": 8571525,
		"ID": 269,
		"x": -86.0162979537,
		"y": 27.876246154,
		"h": 1.989010989
	},
	{
		"stop_id": 8571526,
		"ID": 269,
		"x": -87.5402464807,
		"y": 27.365220803,
		"h": 1.989010989
	},
	{
		"stop_id": 8571896,
		"ID": 269,
		"x": -85.8352691017,
		"y": 29.937170408,
		"h": 1.989010989
	},
	{
		"stop_id": 8571897,
		"ID": 269,
		"x": -86.1652581407,
		"y": 30.265148116,
		"h": 1.989010989
	},
	{
		"stop_id": 8571898,
		"ID": 269,
		"x": -85.9252694697,
		"y": 30.769150378,
		"h": 1.989010989
	},
	{
		"stop_id": 8571906,
		"ID": 269,
		"x": -88.0022349827,
		"y": 29.223228317,
		"h": 1.989010989
	},
	{
		"stop_id": 8571907,
		"ID": 269,
		"x": -87.9792632027,
		"y": 29.916179865,
		"h": 1.989010989
	},
	{
		"stop_id": 8576659,
		"ID": 269,
		"x": -87.6902625257,
		"y": 27.658200503,
		"h": 1.989010989
	},
	{
		"stop_id": 8576660,
		"ID": 269,
		"x": -88.4212403857,
		"y": 28.737181071,
		"h": 1.989010989
	},
	{
		"stop_id": 8580366,
		"ID": 269,
		"x": -85.4782968617,
		"y": 27.341146964,
		"h": 1.989010989
	},
	{
		"stop_id": 8580368,
		"ID": 269,
		"x": -87.3202259337,
		"y": 25.923162596,
		"h": 1.989010989
	},
	{
		"stop_id": 8582212,
		"ID": 269,
		"x": -86.8872406967,
		"y": 29.645160616,
		"h": 1.989010989
	},
	{
		"stop_id": 8582213,
		"ID": 269,
		"x": -86.5142667207,
		"y": 29.80322535,
		"h": 1.989010989
	},
	{
		"stop_id": 8582667,
		"ID": 269,
		"x": -86.7162582767,
		"y": 29.722203729,
		"h": 1.989010989
	},
	{
		"stop_id": 8582668,
		"ID": 269,
		"x": -88.4872302087,
		"y": 29.185198621,
		"h": 1.989010989
	},
	{
		"stop_id": 8582669,
		"ID": 269,
		"x": -87.9972734797,
		"y": 29.100246005,
		"h": 1.989010989
	},
	{
		"stop_id": 8583496,
		"ID": 269,
		"x": -86.5992446277,
		"y": 30.415178907,
		"h": 1.989010989
	},
	{
		"stop_id": 8583497,
		"ID": 269,
		"x": -85.7442786097,
		"y": 30.297198302,
		"h": 1.989010989
	},
	{
		"stop_id": 8504227,
		"ID": 302,
		"x": -82.7882818017,
		"y": 32.2252035,
		"h": 1.4285714286
	},
	{
		"stop_id": 8504228,
		"ID": 302,
		"x": -81.1632758607,
		"y": 33.319186768,
		"h": 1.4285714286
	},
	{
		"stop_id": 8504356,
		"ID": 302,
		"x": -82.8222963607,
		"y": 32.24623648,
		"h": 1.4285714286
	},
	{
		"stop_id": 8504357,
		"ID": 302,
		"x": -83.0202431077,
		"y": 32.62022247,
		"h": 1.4285714286
	},
	{
		"stop_id": 8504358,
		"ID": 302,
		"x": -82.9522320967,
		"y": 32.400164014,
		"h": 1.4285714286
	},
	{
		"stop_id": 8504359,
		"ID": 302,
		"x": -83.1142999457,
		"y": 33.224159313,
		"h": 1.4285714286
	},
	{
		"stop_id": 8504374,
		"ID": 302,
		"x": -81.1222508237,
		"y": 33.284241129,
		"h": 1.4285714286
	},
	{
		"stop_id": 8504375,
		"ID": 302,
		"x": -82.7632487197,
		"y": 32.179191291,
		"h": 1.4285714286
	},
	{
		"stop_id": 8504376,
		"ID": 302,
		"x": -82.7592475717,
		"y": 30.508226256,
		"h": 1.4285714286
	},
	{
		"stop_id": 8504460,
		"ID": 302,
		"x": -81.5932800657,
		"y": 28.19018225,
		"h": 1.4285714286
	},
	{
		"stop_id": 8571900,
		"ID": 302,
		"x": -83.1272238977,
		"y": 33.239218815,
		"h": 1.4285714286
	},
	{
		"stop_id": 8583495,
		"ID": 302,
		"x": -83.6242259287,
		"y": 32.901225783,
		"h": 1.4285714286
	},
	{
		"stop_id": 8589964,
		"ID": 302,
		"x": -82.7922870477,
		"y": 32.230221905,
		"h": 1.4285714286
	},
	{
		"stop_id": 8589968,
		"ID": 302,
		"x": -81.1822494717,
		"y": 33.300244451,
		"h": 1.4285714286
	},
	{
		"stop_id": 8504229,
		"ID": 334,
		"x": -78.0572831357,
		"y": 35.681249443,
		"h": 2.1868131868
	},
	{
		"stop_id": 8504369,
		"ID": 334,
		"x": -74.5622498067,
		"y": 36.428242523,
		"h": 2.1868131868
	},
	{
		"stop_id": 8504372,
		"ID": 334,
		"x": -78.3512646287,
		"y": 35.40122616,
		"h": 2.1868131868
	},
	{
		"stop_id": 8504462,
		"ID": 334,
		"x": -76.7802962967,
		"y": 33.647169114,
		"h": 2.1868131868
	},
	{
		"stop_id": 8504469,
		"ID": 334,
		"x": -74.7922829167,
		"y": 36.208140596,
		"h": 2.1868131868
	},
	{
		"stop_id": 8504470,
		"ID": 334,
		"x": -75.6582480277,
		"y": 35.382152197,
		"h": 2.1868131868
	},
	{
		"stop_id": 8504471,
		"ID": 334,
		"x": -75.1602813887,
		"y": 35.937153609,
		"h": 2.1868131868
	},
	{
		"stop_id": 8504472,
		"ID": 334,
		"x": -76.3832297107,
		"y": 34.217144092,
		"h": 2.1868131868
	},
	{
		"stop_id": 8504474,
		"ID": 334,
		"x": -76.9342658157,
		"y": 32.415246781,
		"h": 2.1868131868
	},
	{
		"stop_id": 8504475,
		"ID": 334,
		"x": -77.7722449537,
		"y": 31.231174977,
		"h": 2.1868131868
	},
	{
		"stop_id": 8571202,
		"ID": 334,
		"x": -74.7622347477,
		"y": 36.805184936,
		"h": 2.1868131868
	},
	{
		"stop_id": 8571204,
		"ID": 334,
		"x": -74.6762553307,
		"y": 36.357154695,
		"h": 2.1868131868
	},
	{
		"stop_id": 8571206,
		"ID": 334,
		"x": -74.6022395057,
		"y": 35.975193988,
		"h": 2.1868131868
	},
	{
		"stop_id": 8571207,
		"ID": 334,
		"x": -74.3352489897,
		"y": 34.932156026,
		"h": 2.1868131868
	},
	{
		"stop_id": 8571208,
		"ID": 334,
		"x": -74.3662271437,
		"y": 34.467189423,
		"h": 2.1868131868
	},
	{
		"stop_id": 8571209,
		"ID": 334,
		"x": -74.4272838297,
		"y": 34.028201532,
		"h": 2.1868131868
	},
	{
		"stop_id": 8571210,
		"ID": 334,
		"x": -74.4102745267,
		"y": 33.20224562,
		"h": 2.1868131868
	},
	{
		"stop_id": 8571211,
		"ID": 334,
		"x": -74.5622328367,
		"y": 32.552144012,
		"h": 2.1868131868
	},
	{
		"stop_id": 8571212,
		"ID": 334,
		"x": -74.5582869217,
		"y": 31.97414053,
		"h": 2.1868131868
	},
	{
		"stop_id": 8571221,
		"ID": 334,
		"x": -74.2482786847,
		"y": 34.895143551,
		"h": 2.1868131868
	},
	{
		"stop_id": 8571222,
		"ID": 334,
		"x": -73.9532530607,
		"y": 34.637170286,
		"h": 2.1868131868
	},
	{
		"stop_id": 8571223,
		"ID": 334,
		"x": -73.6882840867,
		"y": 34.402184492,
		"h": 2.1868131868
	},
	{
		"stop_id": 8571226,
		"ID": 334,
		"x": -73.4452441177,
		"y": 33.375144652,
		"h": 2.1868131868
	},
	{
		"stop_id": 8571228,
		"ID": 334,
		"x": -73.9492754067,
		"y": 32.561203769,
		"h": 2.1868131868
	},
	{
		"stop_id": 8582071,
		"ID": 334,
		"x": -73.5092261827,
		"y": 34.135169237,
		"h": 2.1868131868
	},
	{
		"stop_id": 8582683,
		"ID": 334,
		"x": -77.7722449537,
		"y": 31.231174977,
		"h": 2.1868131868
	},
	{
		"stop_id": 8582685,
		"ID": 334,
		"x": -76.9332752607,
		"y": 32.390229726,
		"h": 2.1868131868
	},
	{
		"stop_id": 8582686,
		"ID": 334,
		"x": -77.0502670077,
		"y": 33.647173083,
		"h": 2.1868131868
	},
	{
		"stop_id": 8582704,
		"ID": 334,
		"x": -76.3832297107,
		"y": 34.217144092,
		"h": 2.1868131868
	},
	{
		"stop_id": 8583212,
		"ID": 334,
		"x": -74.3042833377,
		"y": 32.615207066,
		"h": 2.1868131868
	},
	{
		"stop_id": 8583217,
		"ID": 334,
		"x": -75.3352944477,
		"y": 35.645222068,
		"h": 2.1868131868
	},
	{
		"stop_id": 8589967,
		"ID": 334,
		"x": -78.4222763217,
		"y": 35.41023234,
		"h": 2.1868131868
	},
	{
		"stop_id": 8592486,
		"ID": 334,
		"x": -74.3612496517,
		"y": 35.868199776,
		"h": 2.1868131868
	},
	{
		"stop_id": 8592490,
		"ID": 334,
		"x": -77.5582849567,
		"y": 36.134211561,
		"h": 2.1868131868
	},
	{
		"stop_id": 8594089,
		"ID": 334,
		"x": -74.6802788307,
		"y": 36.627208773,
		"h": 2.1868131868
	},
	{
		"stop_id": 8594343,
		"ID": 334,
		"x": -74.4492460467,
		"y": 36.158250461,
		"h": 2.1868131868
	},
	{
		"stop_id": 8595965,
		"ID": 334,
		"x": -73.9982383647,
		"y": 35.468197267,
		"h": 2.1868131868
	},
	{
		"stop_id": 8504236,
		"ID": 176,
		"x": -104.2542586627,
		"y": 24.712246409,
		"h": 1.5934065934
	},
	{
		"stop_id": 8504257,
		"ID": 176,
		"x": -100.6092736937,
		"y": 27.755197011,
		"h": 1.5934065934
	},
	{
		"stop_id": 8504258,
		"ID": 176,
		"x": -101.5302614747,
		"y": 25.920200792,
		"h": 1.5934065934
	},
	{
		"stop_id": 8504259,
		"ID": 176,
		"x": -100.4732954617,
		"y": 25.082172471,
		"h": 1.5934065934
	},
	{
		"stop_id": 8579602,
		"ID": 176,
		"x": -100.2122818637,
		"y": 24.74620036,
		"h": 1.5934065934
	},
	{
		"stop_id": 8579603,
		"ID": 176,
		"x": -99.9842425807,
		"y": 25.725214929,
		"h": 1.5934065934
	},
	{
		"stop_id": 8579604,
		"ID": 176,
		"x": -100.2422638747,
		"y": 26.63015103,
		"h": 1.5934065934
	},
	{
		"stop_id": 8579605,
		"ID": 176,
		"x": -101.3892667277,
		"y": 26.416164847,
		"h": 1.5934065934
	},
	{
		"stop_id": 8579606,
		"ID": 176,
		"x": -100.5182275707,
		"y": 27.999157837,
		"h": 1.5934065934
	},
	{
		"stop_id": 8579607,
		"ID": 176,
		"x": -100.6102845717,
		"y": 28.006237873,
		"h": 1.5934065934
	},
	{
		"stop_id": 8579619,
		"ID": 176,
		"x": -103.6162408467,
		"y": 24.23623774,
		"h": 1.5934065934
	},
	{
		"stop_id": 8579631,
		"ID": 176,
		"x": -99.6542887687,
		"y": 23.017226836,
		"h": 1.5934065934
	},
	{
		"stop_id": 8579632,
		"ID": 176,
		"x": -100.3172527087,
		"y": 23.580249349,
		"h": 1.5934065934
	},
	{
		"stop_id": 8579633,
		"ID": 176,
		"x": -99.0672296577,
		"y": 25.73920551,
		"h": 1.5934065934
	},
	{
		"stop_id": 8583819,
		"ID": 176,
		"x": -103.7162390787,
		"y": 23.783159447,
		"h": 1.5934065934
	},
	{
		"stop_id": 8587440,
		"ID": 176,
		"x": -101.9152478337,
		"y": 25.135242065,
		"h": 1.5934065934
	},
	{
		"stop_id": 8587862,
		"ID": 176,
		"x": -99.6442627357,
		"y": 27.731189954,
		"h": 1.5934065934
	},
	{
		"stop_id": 8593566,
		"ID": 176,
		"x": -99.8022385277,
		"y": 23.105159037,
		"h": 1.5934065934
	},
	{
		"stop_id": 8593572,
		"ID": 176,
		"x": -99.4422883987,
		"y": 23.135210174,
		"h": 1.5934065934
	},
	{
		"stop_id": 8504237,
		"ID": 177,
		"x": -102.5972660477,
		"y": 28.267144033,
		"h": 1.4945054945
	},
	{
		"stop_id": 8504250,
		"ID": 177,
		"x": -102.5722363217,
		"y": 28.292200616,
		"h": 1.4945054945
	},
	{
		"stop_id": 8504251,
		"ID": 177,
		"x": -101.4212312457,
		"y": 29.252140521,
		"h": 1.4945054945
	},
	{
		"stop_id": 8504252,
		"ID": 177,
		"x": -100.5022711587,
		"y": 29.606201715,
		"h": 1.4945054945
	},
	{
		"stop_id": 8504253,
		"ID": 177,
		"x": -98.8792850117,
		"y": 30.141168671,
		"h": 1.4945054945
	},
	{
		"stop_id": 8579608,
		"ID": 177,
		"x": -101.3522929567,
		"y": 29.223196738,
		"h": 1.4945054945
	},
	{
		"stop_id": 8579609,
		"ID": 177,
		"x": -100.9212996017,
		"y": 29.459224146,
		"h": 1.4945054945
	},
	{
		"stop_id": 8579610,
		"ID": 177,
		"x": -100.2242693507,
		"y": 29.697245268,
		"h": 1.4945054945
	},
	{
		"stop_id": 8579611,
		"ID": 177,
		"x": -99.3332627427,
		"y": 29.936165096,
		"h": 1.4945054945
	},
	{
		"stop_id": 8579616,
		"ID": 177,
		"x": -102.4902428317,
		"y": 28.535196671,
		"h": 1.4945054945
	},
	{
		"stop_id": 8579617,
		"ID": 177,
		"x": -102.0262239417,
		"y": 28.978249937,
		"h": 1.4945054945
	},
	{
		"stop_id": 8579618,
		"ID": 177,
		"x": -101.6372811727,
		"y": 29.149153567,
		"h": 1.4945054945
	},
	{
		"stop_id": 8587436,
		"ID": 177,
		"x": -102.9562431327,
		"y": 31.122184645,
		"h": 1.4945054945
	},
	{
		"stop_id": 8588595,
		"ID": 177,
		"x": -98.6142881247,
		"y": 30.191237796,
		"h": 1.4945054945
	},
	{
		"stop_id": 8588817,
		"ID": 177,
		"x": -101.1322620357,
		"y": 29.38620116,
		"h": 1.4945054945
	},
	{
		"stop_id": 8589889,
		"ID": 177,
		"x": -100.0522660807,
		"y": 29.585234522,
		"h": 1.4945054945
	},
	{
		"stop_id": 8504255,
		"ID": 204,
		"x": -96.3432445187,
		"y": 30.924141419,
		"h": 1.3626373626
	},
	{
		"stop_id": 8504269,
		"ID": 204,
		"x": -96.3162750067,
		"y": 25.934221859,
		"h": 1.3626373626
	},
	{
		"stop_id": 8579613,
		"ID": 204,
		"x": -96.5092482007,
		"y": 30.881140565,
		"h": 1.3626373626
	},
	{
		"stop_id": 8579614,
		"ID": 204,
		"x": -95.9722426937,
		"y": 31.016144953,
		"h": 1.3626373626
	},
	{
		"stop_id": 8579634,
		"ID": 204,
		"x": -98.6342318867,
		"y": 26.525143881,
		"h": 1.3626373626
	},
	{
		"stop_id": 8579635,
		"ID": 204,
		"x": -98.0382351077,
		"y": 27.277154512,
		"h": 1.3626373626
	},
	{
		"stop_id": 8579636,
		"ID": 204,
		"x": -96.5192366347,
		"y": 28.259246567,
		"h": 1.3626373626
	},
	{
		"stop_id": 8579637,
		"ID": 204,
		"x": -96.4402242627,
		"y": 28.68722667,
		"h": 1.3626373626
	},
	{
		"stop_id": 8579638,
		"ID": 204,
		"x": -96.6452939487,
		"y": 28.922185922,
		"h": 1.3626373626
	},
	{
		"stop_id": 8579639,
		"ID": 204,
		"x": -97.4422332647,
		"y": 29.755219158,
		"h": 1.3626373626
	},
	{
		"stop_id": 8587478,
		"ID": 204,
		"x": -98.2412913867,
		"y": 30.332226909,
		"h": 1.3626373626
	},
	{
		"stop_id": 8587854,
		"ID": 204,
		"x": -99.1112943027,
		"y": 27.202224669,
		"h": 1.3626373626
	},
	{
		"stop_id": 8504256,
		"ID": 205,
		"x": -95.1722248857,
		"y": 31.280143672,
		"h": 1.032967033
	},
	{
		"stop_id": 8579615,
		"ID": 205,
		"x": -95.4692996767,
		"y": 31.124164361,
		"h": 1.032967033
	},
	{
		"stop_id": 8504267,
		"ID": 262,
		"x": -87.6822827427,
		"y": -14.963790434,
		"h": 1.4945054945
	},
	{
		"stop_id": 8504853,
		"ID": 262,
		"x": -85.4762475047,
		"y": -14.950782273,
		"h": 1.4945054945
	},
	{
		"stop_id": 8504904,
		"ID": 262,
		"x": -85.9542848027,
		"y": -11.938841688,
		"h": 1.4945054945
	},
	{
		"stop_id": 8504905,
		"ID": 262,
		"x": -86.9032651707,
		"y": -9.978828871,
		"h": 1.4945054945
	},
	{
		"stop_id": 8504907,
		"ID": 262,
		"x": -86.7222452867,
		"y": -10.809851429,
		"h": 1.4945054945
	},
	{
		"stop_id": 8504908,
		"ID": 262,
		"x": -87.2132430377,
		"y": -12.963830107,
		"h": 1.4945054945
	},
	{
		"stop_id": 8504923,
		"ID": 262,
		"x": -87.5142970047,
		"y": -14.044770328,
		"h": 1.4945054945
	},
	{
		"stop_id": 8504924,
		"ID": 262,
		"x": -88.7932717087,
		"y": -13.843821267,
		"h": 1.4945054945
	},
	{
		"stop_id": 8504927,
		"ID": 262,
		"x": -84.8722509877,
		"y": -13.707828142,
		"h": 1.4945054945
	},
	{
		"stop_id": 8504930,
		"ID": 262,
		"x": -84.3812441267,
		"y": -12.80985767,
		"h": 1.4945054945
	},
	{
		"stop_id": 8577748,
		"ID": 262,
		"x": -85.0972306077,
		"y": -14.501838248,
		"h": 1.4945054945
	},
	{
		"stop_id": 8577750,
		"ID": 262,
		"x": -84.7912487917,
		"y": -10.355793151,
		"h": 1.4945054945
	},
	{
		"stop_id": 8588599,
		"ID": 262,
		"x": -87.8872810017,
		"y": -13.926857435,
		"h": 1.4945054945
	},
	{
		"stop_id": 8588600,
		"ID": 262,
		"x": -88.4952805517,
		"y": -13.796791138,
		"h": 1.4945054945
	},
	{
		"stop_id": 8588827,
		"ID": 262,
		"x": -84.3072283547,
		"y": -11.182777912,
		"h": 1.4945054945
	},
	{
		"stop_id": 8588864,
		"ID": 262,
		"x": -85.2042653967,
		"y": -14.888802597,
		"h": 1.4945054945
	},
	{
		"stop_id": 8504270,
		"ID": 74,
		"x": -129.2922290807,
		"y": 3.975176092,
		"h": 1.7252747253
	},
	{
		"stop_id": 8504290,
		"ID": 74,
		"x": -129.7552243957,
		"y": 3.731214377,
		"h": 1.7252747253
	},
	{
		"stop_id": 8504295,
		"ID": 74,
		"x": -129.5532920817,
		"y": -0.189763791,
		"h": 1.7252747253
	},
	{
		"stop_id": 8504297,
		"ID": 74,
		"x": -128.9552888407,
		"y": 1.065238768,
		"h": 1.7252747253
	},
	{
		"stop_id": 8504298,
		"ID": 74,
		"x": -131.3462802267,
		"y": 3.250216364,
		"h": 1.7252747253
	},
	{
		"stop_id": 8571782,
		"ID": 74,
		"x": -132.0732835897,
		"y": 5.009225862,
		"h": 1.7252747253
	},
	{
		"stop_id": 8571783,
		"ID": 74,
		"x": -132.9382990607,
		"y": 4.54414451,
		"h": 1.7252747253
	},
	{
		"stop_id": 8571784,
		"ID": 74,
		"x": -132.9172754587,
		"y": 4.030249486,
		"h": 1.7252747253
	},
	{
		"stop_id": 8571786,
		"ID": 74,
		"x": -131.7402353377,
		"y": 4.390173632,
		"h": 1.7252747253
	},
	{
		"stop_id": 8571787,
		"ID": 74,
		"x": -131.2642356927,
		"y": 3.550188684,
		"h": 1.7252747253
	},
	{
		"stop_id": 8571788,
		"ID": 74,
		"x": -131.3052697397,
		"y": 3.246167535,
		"h": 1.7252747253
	},
	{
		"stop_id": 8579071,
		"ID": 74,
		"x": -132.2152644647,
		"y": 4.179232331,
		"h": 1.7252747253
	},
	{
		"stop_id": 8579075,
		"ID": 74,
		"x": -133.7102969917,
		"y": 3.24520758,
		"h": 1.7252747253
	},
	{
		"stop_id": 8579077,
		"ID": 74,
		"x": -134.1372277727,
		"y": 3.073178873,
		"h": 1.7252747253
	},
	{
		"stop_id": 8579109,
		"ID": 74,
		"x": -129.7072236487,
		"y": -0.090797292,
		"h": 1.7252747253
	},
	{
		"stop_id": 8579110,
		"ID": 74,
		"x": -129.5812683277,
		"y": -0.211783428,
		"h": 1.7252747253
	},
	{
		"stop_id": 8579282,
		"ID": 74,
		"x": -131.1052748637,
		"y": 3.454233193,
		"h": 1.7252747253
	},
	{
		"stop_id": 8579284,
		"ID": 74,
		"x": -131.2802934457,
		"y": 3.745162105,
		"h": 1.7252747253
	},
	{
		"stop_id": 8579286,
		"ID": 74,
		"x": -130.8492265907,
		"y": 3.641181771,
		"h": 1.7252747253
	},
	{
		"stop_id": 8579719,
		"ID": 74,
		"x": -131.6092276927,
		"y": 3.920209405,
		"h": 1.7252747253
	},
	{
		"stop_id": 8593783,
		"ID": 74,
		"x": -133.9792464427,
		"y": 3.128248457,
		"h": 1.7252747253
	},
	{
		"stop_id": 8593784,
		"ID": 74,
		"x": -133.8322824007,
		"y": 3.212142406,
		"h": 1.7252747253
	},
	{
		"stop_id": 8593786,
		"ID": 74,
		"x": -131.5692849857,
		"y": 3.6372295,
		"h": 1.7252747253
	},
	{
		"stop_id": 8504271,
		"ID": 85,
		"x": -128.8972670227,
		"y": 4.09321953,
		"h": 1.3956043956
	},
	{
		"stop_id": 8504272,
		"ID": 85,
		"x": -127.1982699187,
		"y": 4.455242679,
		"h": 1.3956043956
	},
	{
		"stop_id": 8504273,
		"ID": 85,
		"x": -126.3862691087,
		"y": 5.20123565,
		"h": 1.3956043956
	},
	{
		"stop_id": 8504274,
		"ID": 85,
		"x": -126.6252393027,
		"y": 5.887192482,
		"h": 1.3956043956
	},
	{
		"stop_id": 8504275,
		"ID": 85,
		"x": -125.3342346097,
		"y": 6.255210257,
		"h": 1.3956043956
	},
	{
		"stop_id": 8504299,
		"ID": 85,
		"x": -128.3802252087,
		"y": 4.265139814,
		"h": 1.3956043956
	},
	{
		"stop_id": 8507694,
		"ID": 85,
		"x": -124.0322707937,
		"y": 4.155185855,
		"h": 1.3956043956
	},
	{
		"stop_id": 8570260,
		"ID": 85,
		"x": -126.3812691417,
		"y": 3.07016737,
		"h": 1.3956043956
	},
	{
		"stop_id": 8570261,
		"ID": 85,
		"x": -126.1432514457,
		"y": 3.185141658,
		"h": 1.3956043956
	},
	{
		"stop_id": 8570262,
		"ID": 85,
		"x": -125.4352389577,
		"y": 3.631245534,
		"h": 1.3956043956
	},
	{
		"stop_id": 8579287,
		"ID": 85,
		"x": -128.7142458397,
		"y": 4.136241737,
		"h": 1.3956043956
	},
	{
		"stop_id": 8583823,
		"ID": 85,
		"x": -123.4172695257,
		"y": 5.092142541,
		"h": 1.3956043956
	},
	{
		"stop_id": 8587261,
		"ID": 85,
		"x": -127.5262366837,
		"y": 4.204250478,
		"h": 1.3956043956
	},
	{
		"stop_id": 8504277,
		"ID": 97,
		"x": -123.3392939817,
		"y": 7.299140498,
		"h": 1.5274725275
	},
	{
		"stop_id": 8507662,
		"ID": 97,
		"x": -120.8422539817,
		"y": 9.350153606,
		"h": 1.5274725275
	},
	{
		"stop_id": 8507680,
		"ID": 97,
		"x": -119.6972463287,
		"y": 6.837222083,
		"h": 1.5274725275
	},
	{
		"stop_id": 8507684,
		"ID": 97,
		"x": -121.4752258637,
		"y": 6.616199034,
		"h": 1.5274725275
	},
	{
		"stop_id": 8507958,
		"ID": 97,
		"x": -120.4722597397,
		"y": 6.600246212,
		"h": 1.5274725275
	},
	{
		"stop_id": 8507968,
		"ID": 97,
		"x": -121.6302747217,
		"y": 6.124187101,
		"h": 1.5274725275
	},
	{
		"stop_id": 8570265,
		"ID": 97,
		"x": -121.4542264147,
		"y": 6.205190834,
		"h": 1.5274725275
	},
	{
		"stop_id": 8570266,
		"ID": 97,
		"x": -121.0802560907,
		"y": 6.233245772,
		"h": 1.5274725275
	},
	{
		"stop_id": 8570267,
		"ID": 97,
		"x": -121.7422336007,
		"y": 6.280214847,
		"h": 1.5274725275
	},
	{
		"stop_id": 8570268,
		"ID": 97,
		"x": -121.9522662657,
		"y": 6.371227564,
		"h": 1.5274725275
	},
	{
		"stop_id": 8570269,
		"ID": 97,
		"x": -122.6732826297,
		"y": 7.11820696,
		"h": 1.5274725275
	},
	{
		"stop_id": 8570271,
		"ID": 97,
		"x": -120.5622966407,
		"y": 9.950197858,
		"h": 1.5274725275
	},
	{
		"stop_id": 8580463,
		"ID": 97,
		"x": -123.1682678647,
		"y": 5.342194613,
		"h": 1.5274725275
	},
	{
		"stop_id": 8580481,
		"ID": 97,
		"x": -121.7552264147,
		"y": 6.520154068,
		"h": 1.5274725275
	},
	{
		"stop_id": 8581510,
		"ID": 97,
		"x": -122.4412796867,
		"y": 7.169241963,
		"h": 1.5274725275
	},
	{
		"stop_id": 8581511,
		"ID": 97,
		"x": -120.8262501797,
		"y": 6.405186963,
		"h": 1.5274725275
	},
	{
		"stop_id": 8583885,
		"ID": 97,
		"x": -121.6312567457,
		"y": 5.882169621,
		"h": 1.5274725275
	},
	{
		"stop_id": 8504283,
		"ID": 327,
		"x": -76.5102897827,
		"y": -5.858800939,
		"h": 1.3956043956
	},
	{
		"stop_id": 8504854,
		"ID": 327,
		"x": -75.5602587517,
		"y": -4.702804189,
		"h": 1.3956043956
	},
	{
		"stop_id": 8504869,
		"ID": 327,
		"x": -74.0142647917,
		"y": -6.547754756,
		"h": 1.3956043956
	},
	{
		"stop_id": 8504942,
		"ID": 327,
		"x": -78.9362325907,
		"y": -5.533773402,
		"h": 1.3956043956
	},
	{
		"stop_id": 8504946,
		"ID": 327,
		"x": -77.9702447097,
		"y": -5.919775353,
		"h": 1.3956043956
	},
	{
		"stop_id": 8504949,
		"ID": 327,
		"x": -74.8982845957,
		"y": -5.466801539,
		"h": 1.3956043956
	},
	{
		"stop_id": 8577875,
		"ID": 327,
		"x": -76.5082434247,
		"y": -3.961836596,
		"h": 1.3956043956
	},
	{
		"stop_id": 8577876,
		"ID": 327,
		"x": -74.3912246067,
		"y": -6.172761272,
		"h": 1.3956043956
	},
	{
		"stop_id": 8577884,
		"ID": 327,
		"x": -77.1542743517,
		"y": -4.693806073,
		"h": 1.3956043956
	},
	{
		"stop_id": 8577885,
		"ID": 327,
		"x": -77.6272631317,
		"y": -4.954763485,
		"h": 1.3956043956
	},
	{
		"stop_id": 8577886,
		"ID": 327,
		"x": -77.1902567627,
		"y": -5.318798533,
		"h": 1.3956043956
	},
	{
		"stop_id": 8577887,
		"ID": 327,
		"x": -76.7842785967,
		"y": -5.594779065,
		"h": 1.3956043956
	},
	{
		"stop_id": 8577889,
		"ID": 327,
		"x": -78.2472687957,
		"y": -5.372754616,
		"h": 1.3956043956
	},
	{
		"stop_id": 8504284,
		"ID": 98,
		"x": -119.4642555747,
		"y": 15.510225442,
		"h": 1.6263736264
	},
	{
		"stop_id": 8504285,
		"ID": 98,
		"x": -120.8992543587,
		"y": 14.661153013,
		"h": 1.6263736264
	},
	{
		"stop_id": 8504286,
		"ID": 98,
		"x": -122.8422394817,
		"y": 13.403197739,
		"h": 1.6263736264
	},
	{
		"stop_id": 8504734,
		"ID": 98,
		"x": -123.6472832907,
		"y": 13.895162109,
		"h": 1.6263736264
	},
	{
		"stop_id": 8507666,
		"ID": 98,
		"x": -119.4422674027,
		"y": 13.575213046,
		"h": 1.6263736264
	},
	{
		"stop_id": 8570272,
		"ID": 98,
		"x": -120.3612322037,
		"y": 11.418223851,
		"h": 1.6263736264
	},
	{
		"stop_id": 8570273,
		"ID": 98,
		"x": -120.9212520407,
		"y": 14.603233525,
		"h": 1.6263736264
	},
	{
		"stop_id": 8571858,
		"ID": 98,
		"x": -123.9712787597,
		"y": 14.199152026,
		"h": 1.6263736264
	},
	{
		"stop_id": 8571859,
		"ID": 98,
		"x": -122.9892363877,
		"y": 15.045162236,
		"h": 1.6263736264
	},
	{
		"stop_id": 8571861,
		"ID": 98,
		"x": -123.0782436177,
		"y": 15.392199516,
		"h": 1.6263736264
	},
	{
		"stop_id": 8571862,
		"ID": 98,
		"x": -123.1972989867,
		"y": 16.09921482,
		"h": 1.6263736264
	},
	{
		"stop_id": 8579726,
		"ID": 98,
		"x": -121.7362562587,
		"y": 14.568179092,
		"h": 1.6263736264
	},
	{
		"stop_id": 8580383,
		"ID": 98,
		"x": -122.1792626447,
		"y": 15.194164756,
		"h": 1.6263736264
	},
	{
		"stop_id": 8580385,
		"ID": 98,
		"x": -122.5802622197,
		"y": 14.319193223,
		"h": 1.6263736264
	},
	{
		"stop_id": 8580386,
		"ID": 98,
		"x": -121.2252466027,
		"y": 14.906201563,
		"h": 1.6263736264
	},
	{
		"stop_id": 8580773,
		"ID": 98,
		"x": -121.1822676107,
		"y": 15.226168467,
		"h": 1.6263736264
	},
	{
		"stop_id": 8587726,
		"ID": 98,
		"x": -120.5382871477,
		"y": 15.199223545,
		"h": 1.6263736264
	},
	{
		"stop_id": 8595197,
		"ID": 98,
		"x": -120.0742791697,
		"y": 15.53315356,
		"h": 1.6263736264
	},
	{
		"stop_id": 8595198,
		"ID": 98,
		"x": -120.9562304157,
		"y": 14.646172856,
		"h": 1.6263736264
	},
	{
		"stop_id": 8595199,
		"ID": 98,
		"x": -122.9042811157,
		"y": 13.235199919,
		"h": 1.6263736264
	},
	{
		"stop_id": 8504287,
		"ID": 86,
		"x": -125.0412244967,
		"y": 12.649180787,
		"h": 1.4285714286
	},
	{
		"stop_id": 8504288,
		"ID": 86,
		"x": -127.1732326677,
		"y": 10.852150296,
		"h": 1.4285714286
	},
	{
		"stop_id": 8504542,
		"ID": 86,
		"x": -129.0592400587,
		"y": 10.489193242,
		"h": 1.4285714286
	},
	{
		"stop_id": 8530004,
		"ID": 86,
		"x": -127.5802816897,
		"y": 9.467165436,
		"h": 1.4285714286
	},
	{
		"stop_id": 8530005,
		"ID": 86,
		"x": -127.3682480857,
		"y": 10.599206048,
		"h": 1.4285714286
	},
	{
		"stop_id": 8571776,
		"ID": 86,
		"x": -127.2452997277,
		"y": 10.835176618,
		"h": 1.4285714286
	},
	{
		"stop_id": 8571855,
		"ID": 86,
		"x": -125.3942989467,
		"y": 12.526202672,
		"h": 1.4285714286
	},
	{
		"stop_id": 8579592,
		"ID": 86,
		"x": -125.0382975877,
		"y": 12.617241086,
		"h": 1.4285714286
	},
	{
		"stop_id": 8579593,
		"ID": 86,
		"x": -125.9232888087,
		"y": 13.094156089,
		"h": 1.4285714286
	},
	{
		"stop_id": 8579594,
		"ID": 86,
		"x": -126.3232347597,
		"y": 13.256143457,
		"h": 1.4285714286
	},
	{
		"stop_id": 8579595,
		"ID": 86,
		"x": -126.9012450707,
		"y": 13.198250246,
		"h": 1.4285714286
	},
	{
		"stop_id": 8579596,
		"ID": 86,
		"x": -126.0682777137,
		"y": 13.519238808,
		"h": 1.4285714286
	},
	{
		"stop_id": 8579597,
		"ID": 86,
		"x": -126.3892642647,
		"y": 13.647222991,
		"h": 1.4285714286
	},
	{
		"stop_id": 8588797,
		"ID": 86,
		"x": -125.1092654097,
		"y": 12.364202081,
		"h": 1.4285714286
	},
	{
		"stop_id": 8504293,
		"ID": 84,
		"x": -125.3082874527,
		"y": 0.476149451,
		"h": 1.5934065934
	},
	{
		"stop_id": 8504294,
		"ID": 84,
		"x": -127.2992353087,
		"y": 1.442191799,
		"h": 1.5934065934
	},
	{
		"stop_id": 8507686,
		"ID": 84,
		"x": -126.4032772417,
		"y": -2.62374854,
		"h": 1.5934065934
	},
	{
		"stop_id": 8507697,
		"ID": 84,
		"x": -124.8062673147,
		"y": 2.013215774,
		"h": 1.5934065934
	},
	{
		"stop_id": 8507962,
		"ID": 84,
		"x": -125.4942848177,
		"y": -2.990789847,
		"h": 1.5934065934
	},
	{
		"stop_id": 8507973,
		"ID": 84,
		"x": -127.6232316577,
		"y": 1.87822322,
		"h": 1.5934065934
	},
	{
		"stop_id": 8570241,
		"ID": 84,
		"x": -124.6052348827,
		"y": -2.712776335,
		"h": 1.5934065934
	},
	{
		"stop_id": 8570242,
		"ID": 84,
		"x": -127.0952406987,
		"y": -2.556852798,
		"h": 1.5934065934
	},
	{
		"stop_id": 8570243,
		"ID": 84,
		"x": -128.3842821057,
		"y": -2.931758076,
		"h": 1.5934065934
	},
	{
		"stop_id": 8570258,
		"ID": 84,
		"x": -124.6172852957,
		"y": 1.878196535,
		"h": 1.5934065934
	},
	{
		"stop_id": 8570334,
		"ID": 84,
		"x": -125.0152854597,
		"y": 0.193227892,
		"h": 1.5934065934
	},
	{
		"stop_id": 8570335,
		"ID": 84,
		"x": -125.0672845107,
		"y": -0.519834487,
		"h": 1.5934065934
	},
	{
		"stop_id": 8570336,
		"ID": 84,
		"x": -125.6672842887,
		"y": -0.769841269,
		"h": 1.5934065934
	},
	{
		"stop_id": 8579301,
		"ID": 84,
		"x": -123.9422562357,
		"y": -1.469774278,
		"h": 1.5934065934
	},
	{
		"stop_id": 8579302,
		"ID": 84,
		"x": -123.7412783837,
		"y": -1.473818255,
		"h": 1.5934065934
	},
	{
		"stop_id": 8579740,
		"ID": 84,
		"x": -125.8922886617,
		"y": -0.94479154,
		"h": 1.5934065934
	},
	{
		"stop_id": 8582423,
		"ID": 84,
		"x": -124.9932294967,
		"y": -2.69176944,
		"h": 1.5934065934
	},
	{
		"stop_id": 8583764,
		"ID": 84,
		"x": -127.2812359687,
		"y": 1.454217711,
		"h": 1.5934065934
	},
	{
		"stop_id": 8595204,
		"ID": 84,
		"x": -126.1922690467,
		"y": -0.944801156,
		"h": 1.5934065934
	},
	{
		"stop_id": 8504296,
		"ID": 73,
		"x": -131.5182864477,
		"y": -1.817797967,
		"h": 1.2637362637
	},
	{
		"stop_id": 8507956,
		"ID": 73,
		"x": -129.0772823397,
		"y": -3.387811836,
		"h": 1.2637362637
	},
	{
		"stop_id": 8570244,
		"ID": 73,
		"x": -129.4382481507,
		"y": -4.237776502,
		"h": 1.2637362637
	},
	{
		"stop_id": 8570245,
		"ID": 73,
		"x": -129.1132803147,
		"y": -4.469794847,
		"h": 1.2637362637
	},
	{
		"stop_id": 8579100,
		"ID": 73,
		"x": -133.0192337897,
		"y": -6.437857849,
		"h": 1.2637362637
	},
	{
		"stop_id": 8579102,
		"ID": 73,
		"x": -131.4832440647,
		"y": -4.418839409,
		"h": 1.2637362637
	},
	{
		"stop_id": 8579103,
		"ID": 73,
		"x": -130.7072313237,
		"y": -6.441808658,
		"h": 1.2637362637
	},
	{
		"stop_id": 8579115,
		"ID": 73,
		"x": -130.7992988967,
		"y": -6.30285938,
		"h": 1.2637362637
	},
	{
		"stop_id": 8579905,
		"ID": 73,
		"x": -132.3022576997,
		"y": -4.058761618,
		"h": 1.2637362637
	},
	{
		"stop_id": 8504300,
		"ID": 335,
		"x": -74.5912557207,
		"y": 37.661246634,
		"h": 3.6043956044
	},
	{
		"stop_id": 8504350,
		"ID": 335,
		"x": -74.4042585237,
		"y": 38.756190913,
		"h": 3.6043956044
	},
	{
		"stop_id": 8504351,
		"ID": 335,
		"x": -74.6382864397,
		"y": 39.141220237,
		"h": 3.6043956044
	},
	{
		"stop_id": 8504352,
		"ID": 335,
		"x": -74.8702515047,
		"y": 39.520250401,
		"h": 3.6043956044
	},
	{
		"stop_id": 8504353,
		"ID": 335,
		"x": -75.1412920087,
		"y": 38.044205409,
		"h": 3.6043956044
	},
	{
		"stop_id": 8504354,
		"ID": 335,
		"x": -75.7292278757,
		"y": 38.15916268,
		"h": 3.6043956044
	},
	{
		"stop_id": 8504355,
		"ID": 335,
		"x": -76.7472577667,
		"y": 38.358223268,
		"h": 3.6043956044
	},
	{
		"stop_id": 8504371,
		"ID": 335,
		"x": -75.1702374167,
		"y": 37.475174652,
		"h": 3.6043956044
	},
	{
		"stop_id": 8571200,
		"ID": 335,
		"x": -74.6482314207,
		"y": 37.752219986,
		"h": 3.6043956044
	},
	{
		"stop_id": 8571201,
		"ID": 335,
		"x": -74.8102833117,
		"y": 37.633228084,
		"h": 3.6043956044
	},
	{
		"stop_id": 8576391,
		"ID": 335,
		"x": -74.5602930287,
		"y": 37.725205962,
		"h": 3.6043956044
	},
	{
		"stop_id": 8576392,
		"ID": 335,
		"x": -74.3002950327,
		"y": 38.09521904,
		"h": 3.6043956044
	},
	{
		"stop_id": 8576393,
		"ID": 335,
		"x": -74.4612899197,
		"y": 38.486176218,
		"h": 3.6043956044
	},
	{
		"stop_id": 8576394,
		"ID": 335,
		"x": -73.9902690987,
		"y": 38.998209174,
		"h": 3.6043956044
	},
	{
		"stop_id": 8576395,
		"ID": 335,
		"x": -73.3282515177,
		"y": 39.719181673,
		"h": 3.6043956044
	},
	{
		"stop_id": 8576397,
		"ID": 335,
		"x": -76.3692282837,
		"y": 40.877170484,
		"h": 3.6043956044
	},
	{
		"stop_id": 8576398,
		"ID": 335,
		"x": -76.7712701287,
		"y": 40.770250293,
		"h": 3.6043956044
	},
	{
		"stop_id": 8576399,
		"ID": 335,
		"x": -76.6362748307,
		"y": 40.591203648,
		"h": 3.6043956044
	},
	{
		"stop_id": 8576400,
		"ID": 335,
		"x": -79.4802909447,
		"y": 39.942171254,
		"h": 3.6043956044
	},
	{
		"stop_id": 8576408,
		"ID": 335,
		"x": -74.4442783257,
		"y": 38.280237161,
		"h": 3.6043956044
	},
	{
		"stop_id": 8576410,
		"ID": 335,
		"x": -74.1612604927,
		"y": 37.868192313,
		"h": 3.6043956044
	},
	{
		"stop_id": 8576725,
		"ID": 335,
		"x": -74.2272831517,
		"y": 38.325172788,
		"h": 3.6043956044
	},
	{
		"stop_id": 8579946,
		"ID": 335,
		"x": -74.8412340637,
		"y": 37.456204872,
		"h": 3.6043956044
	},
	{
		"stop_id": 8587613,
		"ID": 335,
		"x": -74.2602451267,
		"y": 38.773179219,
		"h": 3.6043956044
	},
	{
		"stop_id": 8587614,
		"ID": 335,
		"x": -74.1002363157,
		"y": 38.755223089,
		"h": 3.6043956044
	},
	{
		"stop_id": 8587615,
		"ID": 335,
		"x": -73.7352622987,
		"y": 39.124229446,
		"h": 3.6043956044
	},
	{
		"stop_id": 8587616,
		"ID": 335,
		"x": -73.4892473847,
		"y": 39.302200524,
		"h": 3.6043956044
	},
	{
		"stop_id": 8587619,
		"ID": 335,
		"x": -74.5012397687,
		"y": 37.858246346,
		"h": 3.6043956044
	},
	{
		"stop_id": 8587620,
		"ID": 335,
		"x": -74.2982974277,
		"y": 38.537247282,
		"h": 3.6043956044
	},
	{
		"stop_id": 8587841,
		"ID": 335,
		"x": -74.1682654337,
		"y": 38.480229422,
		"h": 3.6043956044
	},
	{
		"stop_id": 8588149,
		"ID": 335,
		"x": -75.1472532327,
		"y": 37.998194339,
		"h": 3.6043956044
	},
	{
		"stop_id": 8589962,
		"ID": 335,
		"x": -76.1722628887,
		"y": 37.530233694,
		"h": 3.6043956044
	},
	{
		"stop_id": 8589965,
		"ID": 335,
		"x": -74.9682725857,
		"y": 41.100199302,
		"h": 3.6043956044
	},
	{
		"stop_id": 8592456,
		"ID": 335,
		"x": -76.3922303637,
		"y": 37.442241343,
		"h": 3.6043956044
	},
	{
		"stop_id": 8592459,
		"ID": 335,
		"x": -75.7082742447,
		"y": 37.799231596,
		"h": 3.6043956044
	},
	{
		"stop_id": 8592464,
		"ID": 335,
		"x": -76.5702976737,
		"y": 37.17614642,
		"h": 3.6043956044
	},
	{
		"stop_id": 8592469,
		"ID": 335,
		"x": -74.7272332977,
		"y": 38.192228864,
		"h": 3.6043956044
	},
	{
		"stop_id": 8592471,
		"ID": 335,
		"x": -74.0522507897,
		"y": 38.272161016,
		"h": 3.6043956044
	},
	{
		"stop_id": 8592475,
		"ID": 335,
		"x": -73.5622644357,
		"y": 39.572193769,
		"h": 3.6043956044
	},
	{
		"stop_id": 8592476,
		"ID": 335,
		"x": -76.5772431667,
		"y": 37.2952348,
		"h": 3.6043956044
	},
	{
		"stop_id": 8592477,
		"ID": 335,
		"x": -74.2382591327,
		"y": 38.923212193,
		"h": 3.6043956044
	},
	{
		"stop_id": 8592484,
		"ID": 335,
		"x": -76.6022404957,
		"y": 41.092177074,
		"h": 3.6043956044
	},
	{
		"stop_id": 8593316,
		"ID": 335,
		"x": -74.9812526107,
		"y": 38.326176635,
		"h": 3.6043956044
	},
	{
		"stop_id": 8593317,
		"ID": 335,
		"x": -74.6242592327,
		"y": 38.053222272,
		"h": 3.6043956044
	},
	{
		"stop_id": 8593322,
		"ID": 335,
		"x": -73.9562758317,
		"y": 38.624244406,
		"h": 3.6043956044
	},
	{
		"stop_id": 8593325,
		"ID": 335,
		"x": -74.4042597237,
		"y": 39.031239054,
		"h": 3.6043956044
	},
	{
		"stop_id": 8593329,
		"ID": 335,
		"x": -74.7752838987,
		"y": 38.449165797,
		"h": 3.6043956044
	},
	{
		"stop_id": 8593331,
		"ID": 335,
		"x": -74.4232926127,
		"y": 38.697203943,
		"h": 3.6043956044
	},
	{
		"stop_id": 8593334,
		"ID": 335,
		"x": -74.7852278247,
		"y": 38.715233854,
		"h": 3.6043956044
	},
	{
		"stop_id": 8593336,
		"ID": 335,
		"x": -74.7272612607,
		"y": 37.162190586,
		"h": 3.6043956044
	},
	{
		"stop_id": 8593339,
		"ID": 335,
		"x": -74.5812841367,
		"y": 39.066144717,
		"h": 3.6043956044
	},
	{
		"stop_id": 8593340,
		"ID": 335,
		"x": -75.0342898977,
		"y": 38.351216698,
		"h": 3.6043956044
	},
	{
		"stop_id": 8593341,
		"ID": 335,
		"x": -74.3452404087,
		"y": 38.91124593,
		"h": 3.6043956044
	},
	{
		"stop_id": 8593344,
		"ID": 335,
		"x": -74.1602785617,
		"y": 38.956151964,
		"h": 3.6043956044
	},
	{
		"stop_id": 8593346,
		"ID": 335,
		"x": -74.1622479037,
		"y": 39.175172517,
		"h": 3.6043956044
	},
	{
		"stop_id": 8593351,
		"ID": 335,
		"x": -73.1462518547,
		"y": 39.810152765,
		"h": 3.6043956044
	},
	{
		"stop_id": 8593359,
		"ID": 335,
		"x": -75.9792263757,
		"y": 37.649214683,
		"h": 3.6043956044
	},
	{
		"stop_id": 8593362,
		"ID": 335,
		"x": -73.7362592067,
		"y": 39.376155564,
		"h": 3.6043956044
	},
	{
		"stop_id": 8593363,
		"ID": 335,
		"x": -76.8112575997,
		"y": 37.156157292,
		"h": 3.6043956044
	},
	{
		"stop_id": 8593365,
		"ID": 335,
		"x": -75.0892430017,
		"y": 37.432161702,
		"h": 3.6043956044
	},
	{
		"stop_id": 8593367,
		"ID": 335,
		"x": -76.7272273247,
		"y": 37.010165091,
		"h": 3.6043956044
	},
	{
		"stop_id": 8593373,
		"ID": 335,
		"x": -74.9592704987,
		"y": 37.611151786,
		"h": 3.6043956044
	},
	{
		"stop_id": 8593374,
		"ID": 335,
		"x": -74.4662360207,
		"y": 39.24218176,
		"h": 3.6043956044
	},
	{
		"stop_id": 8593376,
		"ID": 335,
		"x": -73.6632401367,
		"y": 38.819216406,
		"h": 3.6043956044
	},
	{
		"stop_id": 8593377,
		"ID": 335,
		"x": -73.9802570657,
		"y": 39.124146915,
		"h": 3.6043956044
	},
	{
		"stop_id": 8593379,
		"ID": 335,
		"x": -74.6772366157,
		"y": 38.885170006,
		"h": 3.6043956044
	},
	{
		"stop_id": 8593380,
		"ID": 335,
		"x": -74.8192722987,
		"y": 38.542220324,
		"h": 3.6043956044
	},
	{
		"stop_id": 8593387,
		"ID": 335,
		"x": -79.1252626467,
		"y": 40.088195994,
		"h": 3.6043956044
	},
	{
		"stop_id": 8593389,
		"ID": 335,
		"x": -74.7882665407,
		"y": 37.012147783,
		"h": 3.6043956044
	},
	{
		"stop_id": 8594271,
		"ID": 335,
		"x": -74.9632511557,
		"y": 39.78019526,
		"h": 3.6043956044
	},
	{
		"stop_id": 8594272,
		"ID": 335,
		"x": -74.9092580007,
		"y": 39.541140088,
		"h": 3.6043956044
	},
	{
		"stop_id": 8594273,
		"ID": 335,
		"x": -75.1182811287,
		"y": 39.455184796,
		"h": 3.6043956044
	},
	{
		"stop_id": 8594274,
		"ID": 335,
		"x": -75.4192571877,
		"y": 39.533241428,
		"h": 3.6043956044
	},
	{
		"stop_id": 8594275,
		"ID": 335,
		"x": -76.2312608357,
		"y": 38.82114409,
		"h": 3.6043956044
	},
	{
		"stop_id": 8594276,
		"ID": 335,
		"x": -76.4942469967,
		"y": 38.606201727,
		"h": 3.6043956044
	},
	{
		"stop_id": 8594277,
		"ID": 335,
		"x": -76.7762948347,
		"y": 38.364199015,
		"h": 3.6043956044
	},
	{
		"stop_id": 8594278,
		"ID": 335,
		"x": -76.7692919167,
		"y": 38.55717954,
		"h": 3.6043956044
	},
	{
		"stop_id": 8594279,
		"ID": 335,
		"x": -77.2192491087,
		"y": 38.155145562,
		"h": 3.6043956044
	},
	{
		"stop_id": 8594280,
		"ID": 335,
		"x": -77.6222491427,
		"y": 38.425170688,
		"h": 3.6043956044
	},
	{
		"stop_id": 8595238,
		"ID": 335,
		"x": -73.8752570647,
		"y": 39.261196939,
		"h": 3.6043956044
	},
	{
		"stop_id": 8504301,
		"ID": 365,
		"x": -73.4732364547,
		"y": 41.722238613,
		"h": 2.0549450549
	},
	{
		"stop_id": 8518771,
		"ID": 365,
		"x": -70.6652313007,
		"y": 40.487220849,
		"h": 2.0549450549
	},
	{
		"stop_id": 8576402,
		"ID": 365,
		"x": -73.6622608257,
		"y": 41.684213638,
		"h": 2.0549450549
	},
	{
		"stop_id": 8576403,
		"ID": 365,
		"x": -72.5432905907,
		"y": 42.238232609,
		"h": 2.0549450549
	},
	{
		"stop_id": 8576404,
		"ID": 365,
		"x": -71.2102639627,
		"y": 43.831208825,
		"h": 2.0549450549
	},
	{
		"stop_id": 8576405,
		"ID": 365,
		"x": -70.8202971517,
		"y": 43.968211959,
		"h": 2.0549450549
	},
	{
		"stop_id": 8576406,
		"ID": 365,
		"x": -70.2272866027,
		"y": 43.696191559,
		"h": 2.0549450549
	},
	{
		"stop_id": 8587276,
		"ID": 365,
		"x": -72.7292314457,
		"y": 39.935184222,
		"h": 2.0549450549
	},
	{
		"stop_id": 8587618,
		"ID": 365,
		"x": -71.3642658677,
		"y": 40.750151327,
		"h": 2.0549450549
	},
	{
		"stop_id": 8587622,
		"ID": 365,
		"x": -72.8792889387,
		"y": 39.743181849,
		"h": 2.0549450549
	},
	{
		"stop_id": 8587623,
		"ID": 365,
		"x": -72.4602897507,
		"y": 40.189191893,
		"h": 2.0549450549
	},
	{
		"stop_id": 8587624,
		"ID": 365,
		"x": -72.2552899547,
		"y": 40.411217038,
		"h": 2.0549450549
	},
	{
		"stop_id": 8587625,
		"ID": 365,
		"x": -71.8992474457,
		"y": 40.635160221,
		"h": 2.0549450549
	},
	{
		"stop_id": 8587626,
		"ID": 365,
		"x": -71.0352515007,
		"y": 40.786201238,
		"h": 2.0549450549
	},
	{
		"stop_id": 8587628,
		"ID": 365,
		"x": -68.2932670657,
		"y": 42.220207372,
		"h": 2.0549450549
	},
	{
		"stop_id": 8587630,
		"ID": 365,
		"x": -69.0432859707,
		"y": 41.912162347,
		"h": 2.0549450549
	},
	{
		"stop_id": 8587782,
		"ID": 365,
		"x": -73.2222393307,
		"y": 41.675189436,
		"h": 2.0549450549
	},
	{
		"stop_id": 8587898,
		"ID": 365,
		"x": -70.7932870077,
		"y": 40.865234274,
		"h": 2.0549450549
	},
	{
		"stop_id": 8588061,
		"ID": 365,
		"x": -73.3712727477,
		"y": 41.685203416,
		"h": 2.0549450549
	},
	{
		"stop_id": 8588494,
		"ID": 365,
		"x": -72.1372355027,
		"y": 42.427144761,
		"h": 2.0549450549
	},
	{
		"stop_id": 8589963,
		"ID": 365,
		"x": -74.0072455797,
		"y": 41.39419909,
		"h": 2.0549450549
	},
	{
		"stop_id": 8589969,
		"ID": 365,
		"x": -69.3072300387,
		"y": 44.040164596,
		"h": 2.0549450549
	},
	{
		"stop_id": 8592462,
		"ID": 365,
		"x": -72.9352577387,
		"y": 39.982222908,
		"h": 2.0549450549
	},
	{
		"stop_id": 8592463,
		"ID": 365,
		"x": -70.4872272347,
		"y": 40.668221909,
		"h": 2.0549450549
	},
	{
		"stop_id": 8592466,
		"ID": 365,
		"x": -71.0242323817,
		"y": 40.203174707,
		"h": 2.0549450549
	},
	{
		"stop_id": 8592491,
		"ID": 365,
		"x": -69.8572447967,
		"y": 43.93424153,
		"h": 2.0549450549
	},
	{
		"stop_id": 8592492,
		"ID": 365,
		"x": -70.2312589857,
		"y": 43.849177466,
		"h": 2.0549450549
	},
	{
		"stop_id": 8593324,
		"ID": 365,
		"x": -72.0382428927,
		"y": 40.016199018,
		"h": 2.0549450549
	},
	{
		"stop_id": 8593348,
		"ID": 365,
		"x": -71.6842416887,
		"y": 39.710184981,
		"h": 2.0549450549
	},
	{
		"stop_id": 8593352,
		"ID": 365,
		"x": -73.0452684007,
		"y": 39.996143973,
		"h": 2.0549450549
	},
	{
		"stop_id": 8593354,
		"ID": 365,
		"x": -71.2972552217,
		"y": 40.002140943,
		"h": 2.0549450549
	},
	{
		"stop_id": 8593355,
		"ID": 365,
		"x": -70.6722503367,
		"y": 40.505244299,
		"h": 2.0549450549
	},
	{
		"stop_id": 8595606,
		"ID": 365,
		"x": -71.6512949227,
		"y": 40.290232916,
		"h": 2.0549450549
	},
	{
		"stop_id": 8504304,
		"ID": 304,
		"x": -80.1932543087,
		"y": 44.598219859,
		"h": 1.0659340659
	},
	{
		"stop_id": 8504305,
		"ID": 304,
		"x": -82.0202706667,
		"y": 44.410140636,
		"h": 1.0659340659
	},
	{
		"stop_id": 8583089,
		"ID": 304,
		"x": -79.4042305457,
		"y": 44.689157787,
		"h": 1.0659340659
	},
	{
		"stop_id": 8504307,
		"ID": 271,
		"x": -87.7782620317,
		"y": 42.459189931,
		"h": 1
	},
	{
		"stop_id": 8504311,
		"ID": 206,
		"x": -95.3402368257,
		"y": 38.687152865,
		"h": 1.1978021978
	},
	{
		"stop_id": 8504360,
		"ID": 206,
		"x": -93.5112327037,
		"y": 39.954221624,
		"h": 1.1978021978
	},
	{
		"stop_id": 8576771,
		"ID": 206,
		"x": -93.5292604337,
		"y": 39.665152499,
		"h": 1.1978021978
	},
	{
		"stop_id": 8587542,
		"ID": 206,
		"x": -94.1072585997,
		"y": 39.445228159,
		"h": 1.1978021978
	},
	{
		"stop_id": 8587543,
		"ID": 206,
		"x": -94.2652328197,
		"y": 39.474161768,
		"h": 1.1978021978
	},
	{
		"stop_id": 8587544,
		"ID": 206,
		"x": -93.3312438567,
		"y": 39.917178539,
		"h": 1.1978021978
	},
	{
		"stop_id": 8592362,
		"ID": 206,
		"x": -94.4072904187,
		"y": 39.267199867,
		"h": 1.1978021978
	},
	{
		"stop_id": 8504315,
		"ID": 133,
		"x": -109.3692268457,
		"y": 31.702237114,
		"h": 2.9450549451
	},
	{
		"stop_id": 8504316,
		"ID": 133,
		"x": -112.3522667527,
		"y": 29.533237187,
		"h": 2.9450549451
	},
	{
		"stop_id": 8504391,
		"ID": 133,
		"x": -113.8972274957,
		"y": 29.630151859,
		"h": 2.9450549451
	},
	{
		"stop_id": 8530260,
		"ID": 133,
		"x": -112.9102289767,
		"y": 29.314175705,
		"h": 2.9450549451
	},
	{
		"stop_id": 8571800,
		"ID": 133,
		"x": -112.4592299717,
		"y": 29.466143628,
		"h": 2.9450549451
	},
	{
		"stop_id": 8571801,
		"ID": 133,
		"x": -112.6282718387,
		"y": 29.262188322,
		"h": 2.9450549451
	},
	{
		"stop_id": 8571826,
		"ID": 133,
		"x": -112.3812645957,
		"y": 29.098234413,
		"h": 2.9450549451
	},
	{
		"stop_id": 8571827,
		"ID": 133,
		"x": -111.9582982227,
		"y": 28.601213512,
		"h": 2.9450549451
	},
	{
		"stop_id": 8571828,
		"ID": 133,
		"x": -112.4952298327,
		"y": 28.28520423,
		"h": 2.9450549451
	},
	{
		"stop_id": 8579002,
		"ID": 133,
		"x": -109.7282782257,
		"y": 31.58917567,
		"h": 2.9450549451
	},
	{
		"stop_id": 8579725,
		"ID": 133,
		"x": -110.9002892167,
		"y": 30.422219455,
		"h": 2.9450549451
	},
	{
		"stop_id": 8580339,
		"ID": 133,
		"x": -112.4012801257,
		"y": 29.309203775,
		"h": 2.9450549451
	},
	{
		"stop_id": 8583766,
		"ID": 133,
		"x": -113.4572928187,
		"y": 28.876159378,
		"h": 2.9450549451
	},
	{
		"stop_id": 8587366,
		"ID": 133,
		"x": -111.6262327677,
		"y": 29.959228524,
		"h": 2.9450549451
	},
	{
		"stop_id": 8587368,
		"ID": 133,
		"x": -111.1332724617,
		"y": 30.150175998,
		"h": 2.9450549451
	},
	{
		"stop_id": 8587370,
		"ID": 133,
		"x": -112.1702575957,
		"y": 29.469148495,
		"h": 2.9450549451
	},
	{
		"stop_id": 8587371,
		"ID": 133,
		"x": -112.1852732237,
		"y": 29.498186972,
		"h": 2.9450549451
	},
	{
		"stop_id": 8587373,
		"ID": 133,
		"x": -112.6052567067,
		"y": 29.227185232,
		"h": 2.9450549451
	},
	{
		"stop_id": 8587720,
		"ID": 133,
		"x": -111.1202665557,
		"y": 30.354185229,
		"h": 2.9450549451
	},
	{
		"stop_id": 8591897,
		"ID": 133,
		"x": -108.6782708607,
		"y": 31.966226011,
		"h": 2.9450549451
	},
	{
		"stop_id": 8593716,
		"ID": 133,
		"x": -113.1332843707,
		"y": 29.469153766,
		"h": 2.9450549451
	},
	{
		"stop_id": 8593717,
		"ID": 133,
		"x": -113.0412561157,
		"y": 28.606147733,
		"h": 2.9450549451
	},
	{
		"stop_id": 8593718,
		"ID": 133,
		"x": -113.0062793577,
		"y": 28.846199868,
		"h": 2.9450549451
	},
	{
		"stop_id": 8593719,
		"ID": 133,
		"x": -112.9312760947,
		"y": 28.719231363,
		"h": 2.9450549451
	},
	{
		"stop_id": 8593720,
		"ID": 133,
		"x": -112.9282449847,
		"y": 29.551144755,
		"h": 2.9450549451
	},
	{
		"stop_id": 8593721,
		"ID": 133,
		"x": -112.9052940867,
		"y": 29.322247552,
		"h": 2.9450549451
	},
	{
		"stop_id": 8593722,
		"ID": 133,
		"x": -112.8822762957,
		"y": 29.194187851,
		"h": 2.9450549451
	},
	{
		"stop_id": 8593723,
		"ID": 133,
		"x": -112.8692872337,
		"y": 28.615171407,
		"h": 2.9450549451
	},
	{
		"stop_id": 8593724,
		"ID": 133,
		"x": -112.8052401747,
		"y": 28.980150805,
		"h": 2.9450549451
	},
	{
		"stop_id": 8593725,
		"ID": 133,
		"x": -112.7592472757,
		"y": 28.846216764,
		"h": 2.9450549451
	},
	{
		"stop_id": 8593726,
		"ID": 133,
		"x": -112.7102933847,
		"y": 29.599229819,
		"h": 2.9450549451
	},
	{
		"stop_id": 8593727,
		"ID": 133,
		"x": -112.6972317717,
		"y": 29.402218277,
		"h": 2.9450549451
	},
	{
		"stop_id": 8593728,
		"ID": 133,
		"x": -112.5792271297,
		"y": 29.001152798,
		"h": 2.9450549451
	},
	{
		"stop_id": 8593729,
		"ID": 133,
		"x": -112.5142269257,
		"y": 29.707219243,
		"h": 2.9450549451
	},
	{
		"stop_id": 8593730,
		"ID": 133,
		"x": -112.4272512957,
		"y": 29.139221239,
		"h": 2.9450549451
	},
	{
		"stop_id": 8593731,
		"ID": 133,
		"x": -112.3802436677,
		"y": 29.368163939,
		"h": 2.9450549451
	},
	{
		"stop_id": 8593732,
		"ID": 133,
		"x": -112.3792994427,
		"y": 29.406178242,
		"h": 2.9450549451
	},
	{
		"stop_id": 8593733,
		"ID": 133,
		"x": -112.3202577907,
		"y": 29.888166027,
		"h": 2.9450549451
	},
	{
		"stop_id": 8593734,
		"ID": 133,
		"x": -112.2832853717,
		"y": 28.956173081,
		"h": 2.9450549451
	},
	{
		"stop_id": 8593735,
		"ID": 133,
		"x": -112.1862753537,
		"y": 29.953244916,
		"h": 2.9450549451
	},
	{
		"stop_id": 8593736,
		"ID": 133,
		"x": -112.0552556417,
		"y": 28.930149167,
		"h": 2.9450549451
	},
	{
		"stop_id": 8593737,
		"ID": 133,
		"x": -112.0462888217,
		"y": 28.809220703,
		"h": 2.9450549451
	},
	{
		"stop_id": 8593738,
		"ID": 133,
		"x": -111.9692737957,
		"y": 29.705188747,
		"h": 2.9450549451
	},
	{
		"stop_id": 8593739,
		"ID": 133,
		"x": -111.9622757937,
		"y": 29.654208075,
		"h": 2.9450549451
	},
	{
		"stop_id": 8593741,
		"ID": 133,
		"x": -111.8802932197,
		"y": 28.701144666,
		"h": 2.9450549451
	},
	{
		"stop_id": 8593742,
		"ID": 133,
		"x": -111.8652440357,
		"y": 29.109144216,
		"h": 2.9450549451
	},
	{
		"stop_id": 8593743,
		"ID": 133,
		"x": -111.7532564657,
		"y": 28.98620263,
		"h": 2.9450549451
	},
	{
		"stop_id": 8593744,
		"ID": 133,
		"x": -111.7132864847,
		"y": 29.682156374,
		"h": 2.9450549451
	},
	{
		"stop_id": 8593745,
		"ID": 133,
		"x": -111.7062628207,
		"y": 28.529187496,
		"h": 2.9450549451
	},
	{
		"stop_id": 8593746,
		"ID": 133,
		"x": -111.6382757567,
		"y": 29.99824567,
		"h": 2.9450549451
	},
	{
		"stop_id": 8593747,
		"ID": 133,
		"x": -111.6132643997,
		"y": 29.486167138,
		"h": 2.9450549451
	},
	{
		"stop_id": 8593748,
		"ID": 133,
		"x": -111.5922458227,
		"y": 28.768224003,
		"h": 2.9450549451
	},
	{
		"stop_id": 8593749,
		"ID": 133,
		"x": -111.4932663947,
		"y": 30.118165488,
		"h": 2.9450549451
	},
	{
		"stop_id": 8593750,
		"ID": 133,
		"x": -111.4402397627,
		"y": 28.964240429,
		"h": 2.9450549451
	},
	{
		"stop_id": 8593751,
		"ID": 133,
		"x": -111.3832730847,
		"y": 30.003141469,
		"h": 2.9450549451
	},
	{
		"stop_id": 8593752,
		"ID": 133,
		"x": -111.2822372607,
		"y": 30.274204851,
		"h": 2.9450549451
	},
	{
		"stop_id": 8593754,
		"ID": 133,
		"x": -110.9022681537,
		"y": 30.139179041,
		"h": 2.9450549451
	},
	{
		"stop_id": 8594587,
		"ID": 133,
		"x": -111.5142576397,
		"y": 29.513210063,
		"h": 2.9450549451
	},
	{
		"stop_id": 8594588,
		"ID": 133,
		"x": -111.5052613927,
		"y": 29.342141188,
		"h": 2.9450549451
	},
	{
		"stop_id": 8594589,
		"ID": 133,
		"x": -111.4022904707,
		"y": 29.344247795,
		"h": 2.9450549451
	},
	{
		"stop_id": 8504317,
		"ID": 113,
		"x": -113.8862244717,
		"y": 28.660249814,
		"h": 1.6593406593
	},
	{
		"stop_id": 8504392,
		"ID": 113,
		"x": -115.2882784687,
		"y": 30.599220659,
		"h": 1.6593406593
	},
	{
		"stop_id": 8530624,
		"ID": 113,
		"x": -116.0302691997,
		"y": 30.747170506,
		"h": 1.6593406593
	},
	{
		"stop_id": 8571802,
		"ID": 113,
		"x": -113.8992653407,
		"y": 28.680158099,
		"h": 1.6593406593
	},
	{
		"stop_id": 8571803,
		"ID": 113,
		"x": -114.3782520147,
		"y": 28.081177356,
		"h": 1.6593406593
	},
	{
		"stop_id": 8571804,
		"ID": 113,
		"x": -114.9742983937,
		"y": 27.753147884,
		"h": 1.6593406593
	},
	{
		"stop_id": 8571805,
		"ID": 113,
		"x": -115.5642675307,
		"y": 27.537187543,
		"h": 1.6593406593
	},
	{
		"stop_id": 8571806,
		"ID": 113,
		"x": -115.6962564797,
		"y": 27.241249667,
		"h": 1.6593406593
	},
	{
		"stop_id": 8571807,
		"ID": 113,
		"x": -115.7302498097,
		"y": 26.617196974,
		"h": 1.6593406593
	},
	{
		"stop_id": 8571808,
		"ID": 113,
		"x": -116.0682551337,
		"y": 26.412150943,
		"h": 1.6593406593
	},
	{
		"stop_id": 8571809,
		"ID": 113,
		"x": -116.8462322457,
		"y": 26.031221176,
		"h": 1.6593406593
	},
	{
		"stop_id": 8571810,
		"ID": 113,
		"x": -117.4492950707,
		"y": 25.642245792,
		"h": 1.6593406593
	},
	{
		"stop_id": 8571825,
		"ID": 113,
		"x": -114.9142482347,
		"y": 25.66323697,
		"h": 1.6593406593
	},
	{
		"stop_id": 8579724,
		"ID": 113,
		"x": -114.0372919347,
		"y": 28.535217776,
		"h": 1.6593406593
	},
	{
		"stop_id": 8582532,
		"ID": 113,
		"x": -115.3072314817,
		"y": 30.595172927,
		"h": 1.6593406593
	},
	{
		"stop_id": 8582533,
		"ID": 113,
		"x": -115.2422799847,
		"y": 30.815143876,
		"h": 1.6593406593
	},
	{
		"stop_id": 8582534,
		"ID": 113,
		"x": -115.4662333307,
		"y": 30.732186672,
		"h": 1.6593406593
	},
	{
		"stop_id": 8582535,
		"ID": 113,
		"x": -115.5562754047,
		"y": 30.454196173,
		"h": 1.6593406593
	},
	{
		"stop_id": 8582536,
		"ID": 113,
		"x": -115.6732497947,
		"y": 30.399150046,
		"h": 1.6593406593
	},
	{
		"stop_id": 8582537,
		"ID": 113,
		"x": -115.8682721437,
		"y": 30.478144789,
		"h": 1.6593406593
	},
	{
		"stop_id": 8582538,
		"ID": 113,
		"x": -116.1902741827,
		"y": 30.440167262,
		"h": 1.6593406593
	},
	{
		"stop_id": 8504318,
		"ID": 65,
		"x": -134.4612246407,
		"y": 12.295195466,
		"h": 1.0659340659
	},
	{
		"stop_id": 8504597,
		"ID": 65,
		"x": -134.0292264657,
		"y": 12.442228136,
		"h": 1.0659340659
	},
	{
		"stop_id": 8587503,
		"ID": 65,
		"x": -135.0782768377,
		"y": 11.888145286,
		"h": 1.0659340659
	},
	{
		"stop_id": 8504364,
		"ID": 364,
		"x": -73.5562493437,
		"y": 36.040143896,
		"h": 4.5274725275
	},
	{
		"stop_id": 8504368,
		"ID": 364,
		"x": -71.6792580117,
		"y": 36.468195481,
		"h": 4.5274725275
	},
	{
		"stop_id": 8504416,
		"ID": 364,
		"x": -71.9152359527,
		"y": 36.625210675,
		"h": 4.5274725275
	},
	{
		"stop_id": 8504419,
		"ID": 364,
		"x": -72.3452661947,
		"y": 38.970239149,
		"h": 4.5274725275
	},
	{
		"stop_id": 8504441,
		"ID": 364,
		"x": -70.1322563577,
		"y": 35.15419171,
		"h": 4.5274725275
	},
	{
		"stop_id": 8504461,
		"ID": 364,
		"x": -74.6492768027,
		"y": 36.674157646,
		"h": 4.5274725275
	},
	{
		"stop_id": 8576409,
		"ID": 364,
		"x": -74.1542865937,
		"y": 37.74121323,
		"h": 4.5274725275
	},
	{
		"stop_id": 8576411,
		"ID": 364,
		"x": -73.9252255077,
		"y": 37.590239834,
		"h": 4.5274725275
	},
	{
		"stop_id": 8576412,
		"ID": 364,
		"x": -73.7012273277,
		"y": 37.282196867,
		"h": 4.5274725275
	},
	{
		"stop_id": 8576413,
		"ID": 364,
		"x": -73.4922673567,
		"y": 37.121170874,
		"h": 4.5274725275
	},
	{
		"stop_id": 8576414,
		"ID": 364,
		"x": -73.3072693777,
		"y": 37.061154081,
		"h": 4.5274725275
	},
	{
		"stop_id": 8576416,
		"ID": 364,
		"x": -72.5592553877,
		"y": 36.724182689,
		"h": 4.5274725275
	},
	{
		"stop_id": 8576417,
		"ID": 364,
		"x": -72.2612667897,
		"y": 36.799143454,
		"h": 4.5274725275
	},
	{
		"stop_id": 8576418,
		"ID": 364,
		"x": -71.9592651677,
		"y": 36.800179541,
		"h": 4.5274725275
	},
	{
		"stop_id": 8576419,
		"ID": 364,
		"x": -71.8602260107,
		"y": 36.660228954,
		"h": 4.5274725275
	},
	{
		"stop_id": 8576420,
		"ID": 364,
		"x": -71.5292668407,
		"y": 36.605195497,
		"h": 4.5274725275
	},
	{
		"stop_id": 8576421,
		"ID": 364,
		"x": -71.1012412787,
		"y": 36.35621552,
		"h": 4.5274725275
	},
	{
		"stop_id": 8576422,
		"ID": 364,
		"x": -70.9012536817,
		"y": 36.09123878,
		"h": 4.5274725275
	},
	{
		"stop_id": 8576423,
		"ID": 364,
		"x": -70.6152844427,
		"y": 35.897150736,
		"h": 4.5274725275
	},
	{
		"stop_id": 8576424,
		"ID": 364,
		"x": -70.2842273977,
		"y": 35.73923886,
		"h": 4.5274725275
	},
	{
		"stop_id": 8576425,
		"ID": 364,
		"x": -70.1002706227,
		"y": 35.302219956,
		"h": 4.5274725275
	},
	{
		"stop_id": 8576426,
		"ID": 364,
		"x": -69.8302913007,
		"y": 35.263175301,
		"h": 4.5274725275
	},
	{
		"stop_id": 8576427,
		"ID": 364,
		"x": -69.4762961637,
		"y": 35.265249578,
		"h": 4.5274725275
	},
	{
		"stop_id": 8576428,
		"ID": 364,
		"x": -69.0932448877,
		"y": 35.307210457,
		"h": 4.5274725275
	},
	{
		"stop_id": 8576429,
		"ID": 364,
		"x": -70.2642777967,
		"y": 34.966206966,
		"h": 4.5274725275
	},
	{
		"stop_id": 8576430,
		"ID": 364,
		"x": -70.4802259947,
		"y": 34.587157168,
		"h": 4.5274725275
	},
	{
		"stop_id": 8576431,
		"ID": 364,
		"x": -70.6382532287,
		"y": 34.264151422,
		"h": 4.5274725275
	},
	{
		"stop_id": 8576432,
		"ID": 364,
		"x": -70.8602424307,
		"y": 34.009197411,
		"h": 4.5274725275
	},
	{
		"stop_id": 8576447,
		"ID": 364,
		"x": -71.7252995217,
		"y": 36.665179226,
		"h": 4.5274725275
	},
	{
		"stop_id": 8576721,
		"ID": 364,
		"x": -69.3492416457,
		"y": 38.343249574,
		"h": 4.5274725275
	},
	{
		"stop_id": 8576722,
		"ID": 364,
		"x": -70.1722847707,
		"y": 38.533199168,
		"h": 4.5274725275
	},
	{
		"stop_id": 8576723,
		"ID": 364,
		"x": -72.1292502417,
		"y": 38.857161975,
		"h": 4.5274725275
	},
	{
		"stop_id": 8576724,
		"ID": 364,
		"x": -73.3052599797,
		"y": 38.897208221,
		"h": 4.5274725275
	},
	{
		"stop_id": 8587315,
		"ID": 364,
		"x": -73.7972308067,
		"y": 35.834148481,
		"h": 4.5274725275
	},
	{
		"stop_id": 8587608,
		"ID": 364,
		"x": -68.8732432817,
		"y": 37.546147038,
		"h": 4.5274725275
	},
	{
		"stop_id": 8587610,
		"ID": 364,
		"x": -69.7592591687,
		"y": 37.316228817,
		"h": 4.5274725275
	},
	{
		"stop_id": 8587611,
		"ID": 364,
		"x": -70.1052968447,
		"y": 37.023212866,
		"h": 4.5274725275
	},
	{
		"stop_id": 8587612,
		"ID": 364,
		"x": -70.3282823407,
		"y": 36.862182302,
		"h": 4.5274725275
	},
	{
		"stop_id": 8587621,
		"ID": 364,
		"x": -73.1062318317,
		"y": 39.598161476,
		"h": 4.5274725275
	},
	{
		"stop_id": 8587638,
		"ID": 364,
		"x": -70.8802783857,
		"y": 36.550239743,
		"h": 4.5274725275
	},
	{
		"stop_id": 8587639,
		"ID": 364,
		"x": -71.2052643987,
		"y": 36.442243228,
		"h": 4.5274725275
	},
	{
		"stop_id": 8587899,
		"ID": 364,
		"x": -72.2882358877,
		"y": 39.144218585,
		"h": 4.5274725275
	},
	{
		"stop_id": 8592457,
		"ID": 364,
		"x": -73.7232440327,
		"y": 37.758189577,
		"h": 4.5274725275
	},
	{
		"stop_id": 8592458,
		"ID": 364,
		"x": -71.8642915057,
		"y": 38.748216796,
		"h": 4.5274725275
	},
	{
		"stop_id": 8592460,
		"ID": 364,
		"x": -72.6642494357,
		"y": 39.02718237,
		"h": 4.5274725275
	},
	{
		"stop_id": 8592461,
		"ID": 364,
		"x": -71.3152307237,
		"y": 39.149237588,
		"h": 4.5274725275
	},
	{
		"stop_id": 8592467,
		"ID": 364,
		"x": -71.5482720857,
		"y": 38.753247136,
		"h": 4.5274725275
	},
	{
		"stop_id": 8592468,
		"ID": 364,
		"x": -72.5082597377,
		"y": 39.151248882,
		"h": 4.5274725275
	},
	{
		"stop_id": 8592470,
		"ID": 364,
		"x": -74.2362885707,
		"y": 36.165173986,
		"h": 4.5274725275
	},
	{
		"stop_id": 8592473,
		"ID": 364,
		"x": -71.8922517497,
		"y": 39.390201043,
		"h": 4.5274725275
	},
	{
		"stop_id": 8592474,
		"ID": 364,
		"x": -73.1232736157,
		"y": 38.334246421,
		"h": 4.5274725275
	},
	{
		"stop_id": 8592478,
		"ID": 364,
		"x": -72.8132568257,
		"y": 36.676155001,
		"h": 4.5274725275
	},
	{
		"stop_id": 8592479,
		"ID": 364,
		"x": -72.8802421777,
		"y": 36.137216565,
		"h": 4.5274725275
	},
	{
		"stop_id": 8592480,
		"ID": 364,
		"x": -72.2222956107,
		"y": 36.173146791,
		"h": 4.5274725275
	},
	{
		"stop_id": 8592481,
		"ID": 364,
		"x": -73.3662912037,
		"y": 36.373228027,
		"h": 4.5274725275
	},
	{
		"stop_id": 8592482,
		"ID": 364,
		"x": -71.9132484747,
		"y": 36.374173833,
		"h": 4.5274725275
	},
	{
		"stop_id": 8592483,
		"ID": 364,
		"x": -74.2672921817,
		"y": 37.014181835,
		"h": 4.5274725275
	},
	{
		"stop_id": 8592485,
		"ID": 364,
		"x": -74.0882590797,
		"y": 35.872201323,
		"h": 4.5274725275
	},
	{
		"stop_id": 8592488,
		"ID": 364,
		"x": -73.6112276147,
		"y": 35.928208291,
		"h": 4.5274725275
	},
	{
		"stop_id": 8593252,
		"ID": 364,
		"x": -69.7022377387,
		"y": 38.330160001,
		"h": 4.5274725275
	},
	{
		"stop_id": 8593253,
		"ID": 364,
		"x": -69.2912292187,
		"y": 38.19017845,
		"h": 4.5274725275
	},
	{
		"stop_id": 8593254,
		"ID": 364,
		"x": -69.1342554857,
		"y": 37.819157714,
		"h": 4.5274725275
	},
	{
		"stop_id": 8593315,
		"ID": 364,
		"x": -73.7752985297,
		"y": 36.794202521,
		"h": 4.5274725275
	},
	{
		"stop_id": 8593318,
		"ID": 364,
		"x": -71.8822414517,
		"y": 39.020188589,
		"h": 4.5274725275
	},
	{
		"stop_id": 8593319,
		"ID": 364,
		"x": -73.3132410397,
		"y": 37.17023047,
		"h": 4.5274725275
	},
	{
		"stop_id": 8593320,
		"ID": 364,
		"x": -72.8812468637,
		"y": 38.486236385,
		"h": 4.5274725275
	},
	{
		"stop_id": 8593321,
		"ID": 364,
		"x": -73.4622760987,
		"y": 38.046189556,
		"h": 4.5274725275
	},
	{
		"stop_id": 8593323,
		"ID": 364,
		"x": -72.0942877277,
		"y": 39.181165153,
		"h": 4.5274725275
	},
	{
		"stop_id": 8593326,
		"ID": 364,
		"x": -73.3322291247,
		"y": 36.699225659,
		"h": 4.5274725275
	},
	{
		"stop_id": 8593327,
		"ID": 364,
		"x": -73.1282630137,
		"y": 38.107237814,
		"h": 4.5274725275
	},
	{
		"stop_id": 8593328,
		"ID": 364,
		"x": -72.8752273017,
		"y": 38.908244711,
		"h": 4.5274725275
	},
	{
		"stop_id": 8593330,
		"ID": 364,
		"x": -73.6582358027,
		"y": 37.657200458,
		"h": 4.5274725275
	},
	{
		"stop_id": 8593332,
		"ID": 364,
		"x": -71.7452768157,
		"y": 39.532205405,
		"h": 4.5274725275
	},
	{
		"stop_id": 8593333,
		"ID": 364,
		"x": -71.8202490417,
		"y": 39.365150174,
		"h": 4.5274725275
	},
	{
		"stop_id": 8593335,
		"ID": 364,
		"x": -72.8442894247,
		"y": 39.246149476,
		"h": 4.5274725275
	},
	{
		"stop_id": 8593337,
		"ID": 364,
		"x": -74.3372454127,
		"y": 37.293180987,
		"h": 4.5274725275
	},
	{
		"stop_id": 8593338,
		"ID": 364,
		"x": -73.6442369237,
		"y": 36.737193984,
		"h": 4.5274725275
	},
	{
		"stop_id": 8593342,
		"ID": 364,
		"x": -73.3732512257,
		"y": 37.634190878,
		"h": 4.5274725275
	},
	{
		"stop_id": 8593343,
		"ID": 364,
		"x": -72.1142849927,
		"y": 39.375208167,
		"h": 4.5274725275
	},
	{
		"stop_id": 8593345,
		"ID": 364,
		"x": -73.1182917997,
		"y": 37.652175215,
		"h": 4.5274725275
	},
	{
		"stop_id": 8593347,
		"ID": 364,
		"x": -73.5842731187,
		"y": 36.972188499,
		"h": 4.5274725275
	},
	{
		"stop_id": 8593349,
		"ID": 364,
		"x": -71.9592380007,
		"y": 39.530197897,
		"h": 4.5274725275
	},
	{
		"stop_id": 8593350,
		"ID": 364,
		"x": -74.1292504497,
		"y": 37.148144162,
		"h": 4.5274725275
	},
	{
		"stop_id": 8593353,
		"ID": 364,
		"x": -73.1772689307,
		"y": 37.807175843,
		"h": 4.5274725275
	},
	{
		"stop_id": 8593356,
		"ID": 364,
		"x": -72.8202713007,
		"y": 37.416151196,
		"h": 4.5274725275
	},
	{
		"stop_id": 8593357,
		"ID": 364,
		"x": -72.6352794627,
		"y": 39.303167823,
		"h": 4.5274725275
	},
	{
		"stop_id": 8593358,
		"ID": 364,
		"x": -72.3682693877,
		"y": 38.783180044,
		"h": 4.5274725275
	},
	{
		"stop_id": 8593364,
		"ID": 364,
		"x": -71.6202577467,
		"y": 39.508161276,
		"h": 4.5274725275
	},
	{
		"stop_id": 8593366,
		"ID": 364,
		"x": -73.6012311557,
		"y": 38.608171083,
		"h": 4.5274725275
	},
	{
		"stop_id": 8593368,
		"ID": 364,
		"x": -72.6752854747,
		"y": 39.530164437,
		"h": 4.5274725275
	},
	{
		"stop_id": 8593369,
		"ID": 364,
		"x": -73.5042961527,
		"y": 38.930242319,
		"h": 4.5274725275
	},
	{
		"stop_id": 8593370,
		"ID": 364,
		"x": -71.5822759707,
		"y": 39.159216453,
		"h": 4.5274725275
	},
	{
		"stop_id": 8593372,
		"ID": 364,
		"x": -72.8862550307,
		"y": 38.144161178,
		"h": 4.5274725275
	},
	{
		"stop_id": 8593375,
		"ID": 364,
		"x": -73.7672497487,
		"y": 38.493162265,
		"h": 4.5274725275
	},
	{
		"stop_id": 8593378,
		"ID": 364,
		"x": -72.6252511017,
		"y": 38.649212131,
		"h": 4.5274725275
	},
	{
		"stop_id": 8593382,
		"ID": 364,
		"x": -71.3062518167,
		"y": 39.280184665,
		"h": 4.5274725275
	},
	{
		"stop_id": 8593383,
		"ID": 364,
		"x": -73.0042425627,
		"y": 37.96521007,
		"h": 4.5274725275
	},
	{
		"stop_id": 8593384,
		"ID": 364,
		"x": -73.3432807827,
		"y": 37.998220632,
		"h": 4.5274725275
	},
	{
		"stop_id": 8593385,
		"ID": 364,
		"x": -73.0042320727,
		"y": 39.120210623,
		"h": 4.5274725275
	},
	{
		"stop_id": 8593386,
		"ID": 364,
		"x": -73.9202962127,
		"y": 37.019232758,
		"h": 4.5274725275
	},
	{
		"stop_id": 8593388,
		"ID": 364,
		"x": -73.9792543827,
		"y": 36.89219007,
		"h": 4.5274725275
	},
	{
		"stop_id": 8594169,
		"ID": 364,
		"x": -70.5432577577,
		"y": 38.557212652,
		"h": 4.5274725275
	},
	{
		"stop_id": 8594170,
		"ID": 364,
		"x": -70.9702876387,
		"y": 38.580243781,
		"h": 4.5274725275
	},
	{
		"stop_id": 8594344,
		"ID": 364,
		"x": -73.8672634397,
		"y": 36.063224046,
		"h": 4.5274725275
	},
	{
		"stop_id": 8595071,
		"ID": 364,
		"x": -72.9722716467,
		"y": 37.233161509,
		"h": 4.5274725275
	},
	{
		"stop_id": 8595689,
		"ID": 364,
		"x": -73.0322259767,
		"y": 37.328239372,
		"h": 4.5274725275
	},
	{
		"stop_id": 8595964,
		"ID": 364,
		"x": -73.7252601857,
		"y": 35.4271898,
		"h": 4.5274725275
	},
	{
		"stop_id": 8595966,
		"ID": 364,
		"x": -73.8142669607,
		"y": 35.659199927,
		"h": 4.5274725275
	},
	{
		"stop_id": 8504373,
		"ID": 303,
		"x": -79.5622359137,
		"y": 34.258160474,
		"h": 1.1318681319
	},
	{
		"stop_id": 8504752,
		"ID": 303,
		"x": -82.7642497227,
		"y": 35.971147996,
		"h": 1.1318681319
	},
	{
		"stop_id": 8571903,
		"ID": 303,
		"x": -82.8342758507,
		"y": 35.37218567,
		"h": 1.1318681319
	},
	{
		"stop_id": 8571904,
		"ID": 303,
		"x": -83.7872720367,
		"y": 35.630229705,
		"h": 1.1318681319
	},
	{
		"stop_id": 8576401,
		"ID": 303,
		"x": -79.9812969587,
		"y": 39.673148045,
		"h": 1.1318681319
	},
	{
		"stop_id": 8504383,
		"ID": 154,
		"x": -105.6002536987,
		"y": 30.768215412,
		"h": 1.0659340659
	},
	{
		"stop_id": 8504384,
		"ID": 154,
		"x": -106.8592621367,
		"y": 28.711175001,
		"h": 1.0659340659
	},
	{
		"stop_id": 8504385,
		"ID": 154,
		"x": -108.1052714257,
		"y": 27.527140525,
		"h": 1.0659340659
	},
	{
		"stop_id": 8504386,
		"ID": 132,
		"x": -109.8002287997,
		"y": 25.617141365,
		"h": 1.3626373626
	},
	{
		"stop_id": 8504387,
		"ID": 132,
		"x": -111.7052608137,
		"y": 24.221195195,
		"h": 1.3626373626
	},
	{
		"stop_id": 8504388,
		"ID": 132,
		"x": -113.1912691677,
		"y": 23.068221921,
		"h": 1.3626373626
	},
	{
		"stop_id": 8530011,
		"ID": 132,
		"x": -109.0882871967,
		"y": 26.271248732,
		"h": 1.3626373626
	},
	{
		"stop_id": 8530012,
		"ID": 132,
		"x": -110.9442867147,
		"y": 24.609165902,
		"h": 1.3626373626
	},
	{
		"stop_id": 8530225,
		"ID": 132,
		"x": -112.4472272577,
		"y": 23.672169538,
		"h": 1.3626373626
	},
	{
		"stop_id": 8571829,
		"ID": 132,
		"x": -112.4992793807,
		"y": 27.854206484,
		"h": 1.3626373626
	},
	{
		"stop_id": 8571830,
		"ID": 132,
		"x": -112.6432239747,
		"y": 27.033219418,
		"h": 1.3626373626
	},
	{
		"stop_id": 8571831,
		"ID": 132,
		"x": -112.9792554377,
		"y": 26.405175956,
		"h": 1.3626373626
	},
	{
		"stop_id": 8571832,
		"ID": 132,
		"x": -113.3502852567,
		"y": 25.824160886,
		"h": 1.3626373626
	},
	{
		"stop_id": 8571833,
		"ID": 132,
		"x": -113.6852247597,
		"y": 25.483205871,
		"h": 1.3626373626
	},
	{
		"stop_id": 8571838,
		"ID": 132,
		"x": -113.2892438867,
		"y": 22.974157611,
		"h": 1.3626373626
	},
	{
		"stop_id": 8504393,
		"ID": 114,
		"x": -115.1382660827,
		"y": 32.505196239,
		"h": 1
	},
	{
		"stop_id": 8504395,
		"ID": 134,
		"x": -110.4652787577,
		"y": 34.920191941,
		"h": 1.032967033
	},
	{
		"stop_id": 8571893,
		"ID": 134,
		"x": -109.5802484287,
		"y": 35.501169619,
		"h": 1.032967033
	},
	{
		"stop_id": 8504399,
		"ID": 76,
		"x": -129.9422373307,
		"y": 13.980146482,
		"h": 1.2967032967
	},
	{
		"stop_id": 8504596,
		"ID": 76,
		"x": -132.8172407287,
		"y": 12.766246709,
		"h": 1.2967032967
	},
	{
		"stop_id": 8504736,
		"ID": 76,
		"x": -131.7342606287,
		"y": 12.911178122,
		"h": 1.2967032967
	},
	{
		"stop_id": 8504737,
		"ID": 76,
		"x": -128.5842933817,
		"y": 13.243225251,
		"h": 1.2967032967
	},
	{
		"stop_id": 8571871,
		"ID": 76,
		"x": -129.3092287267,
		"y": 14.152172295,
		"h": 1.2967032967
	},
	{
		"stop_id": 8571872,
		"ID": 76,
		"x": -129.2402578307,
		"y": 14.913158309,
		"h": 1.2967032967
	},
	{
		"stop_id": 8579598,
		"ID": 76,
		"x": -129.4132270247,
		"y": 13.159235548,
		"h": 1.2967032967
	},
	{
		"stop_id": 8579599,
		"ID": 76,
		"x": -130.3872503567,
		"y": 13.867217366,
		"h": 1.2967032967
	},
	{
		"stop_id": 8579601,
		"ID": 76,
		"x": -133.2332864097,
		"y": 12.561228974,
		"h": 1.2967032967
	},
	{
		"stop_id": 8593621,
		"ID": 76,
		"x": -132.5062355957,
		"y": 12.801247499,
		"h": 1.2967032967
	},
	{
		"stop_id": 8504401,
		"ID": 332,
		"x": -77.4332613417,
		"y": 22.797233023,
		"h": 1.3296703297
	},
	{
		"stop_id": 8516444,
		"ID": 332,
		"x": -77.9502922187,
		"y": 21.759224786,
		"h": 1.3296703297
	},
	{
		"stop_id": 8583438,
		"ID": 332,
		"x": -75.0832580567,
		"y": 19.808178047,
		"h": 1.3296703297
	},
	{
		"stop_id": 8587801,
		"ID": 332,
		"x": -74.8692929077,
		"y": 19.622195011,
		"h": 1.3296703297
	},
	{
		"stop_id": 8587802,
		"ID": 332,
		"x": -74.9682300347,
		"y": 21.191191056,
		"h": 1.3296703297
	},
	{
		"stop_id": 8587804,
		"ID": 332,
		"x": -76.7932393817,
		"y": 20.012171594,
		"h": 1.3296703297
	},
	{
		"stop_id": 8587805,
		"ID": 332,
		"x": -77.0232797467,
		"y": 20.0351818,
		"h": 1.3296703297
	},
	{
		"stop_id": 8587806,
		"ID": 332,
		"x": -77.3942313087,
		"y": 19.857174751,
		"h": 1.3296703297
	},
	{
		"stop_id": 8587807,
		"ID": 332,
		"x": -77.6962465727,
		"y": 19.885205535,
		"h": 1.3296703297
	},
	{
		"stop_id": 8587808,
		"ID": 332,
		"x": -77.9442687717,
		"y": 20.050160729,
		"h": 1.3296703297
	},
	{
		"stop_id": 8588091,
		"ID": 332,
		"x": -74.9382244077,
		"y": 19.895185954,
		"h": 1.3296703297
	},
	{
		"stop_id": 8504402,
		"ID": 333,
		"x": -75.2082296557,
		"y": 25.725192938,
		"h": 1.5274725275
	},
	{
		"stop_id": 8504463,
		"ID": 333,
		"x": -77.9802808137,
		"y": 30.290168508,
		"h": 1.5274725275
	},
	{
		"stop_id": 8504464,
		"ID": 333,
		"x": -78.7892302017,
		"y": 29.360185525,
		"h": 1.5274725275
	},
	{
		"stop_id": 8504465,
		"ID": 333,
		"x": -79.6122965477,
		"y": 28.238141566,
		"h": 1.5274725275
	},
	{
		"stop_id": 8571214,
		"ID": 333,
		"x": -74.4852436467,
		"y": 30.565164167,
		"h": 1.5274725275
	},
	{
		"stop_id": 8571230,
		"ID": 333,
		"x": -75.1992904547,
		"y": 28.979203432,
		"h": 1.5274725275
	},
	{
		"stop_id": 8571231,
		"ID": 333,
		"x": -75.4492643557,
		"y": 29.351179457,
		"h": 1.5274725275
	},
	{
		"stop_id": 8571232,
		"ID": 333,
		"x": -75.9012658737,
		"y": 29.619210339,
		"h": 1.5274725275
	},
	{
		"stop_id": 8571233,
		"ID": 333,
		"x": -76.1802899807,
		"y": 29.598187235,
		"h": 1.5274725275
	},
	{
		"stop_id": 8571234,
		"ID": 333,
		"x": -76.7512988177,
		"y": 30.231152325,
		"h": 1.5274725275
	},
	{
		"stop_id": 8571235,
		"ID": 333,
		"x": -77.6302713667,
		"y": 30.256195267,
		"h": 1.5274725275
	},
	{
		"stop_id": 8571236,
		"ID": 333,
		"x": -77.9422526637,
		"y": 30.330185438,
		"h": 1.5274725275
	},
	{
		"stop_id": 8575504,
		"ID": 333,
		"x": -76.2692731717,
		"y": 30.599219493,
		"h": 1.5274725275
	},
	{
		"stop_id": 8576651,
		"ID": 333,
		"x": -79.6122965477,
		"y": 28.238141566,
		"h": 1.5274725275
	},
	{
		"stop_id": 8580935,
		"ID": 333,
		"x": -75.2502689357,
		"y": 25.696175443,
		"h": 1.5274725275
	},
	{
		"stop_id": 8581022,
		"ID": 333,
		"x": -75.1872769337,
		"y": 25.305239311,
		"h": 1.5274725275
	},
	{
		"stop_id": 8582687,
		"ID": 333,
		"x": -78.9292577877,
		"y": 29.217222689,
		"h": 1.5274725275
	},
	{
		"stop_id": 8504403,
		"ID": 362,
		"x": -73.2292922787,
		"y": 27.34815369,
		"h": 1.9230769231
	},
	{
		"stop_id": 8504404,
		"ID": 362,
		"x": -71.8972377627,
		"y": 27.832208648,
		"h": 1.9230769231
	},
	{
		"stop_id": 8504710,
		"ID": 362,
		"x": -72.0482826007,
		"y": 25.944251019,
		"h": 1.9230769231
	},
	{
		"stop_id": 8504711,
		"ID": 362,
		"x": -71.9742401837,
		"y": 25.024145352,
		"h": 1.9230769231
	},
	{
		"stop_id": 8504756,
		"ID": 362,
		"x": -69.2602762167,
		"y": 26.595141831,
		"h": 1.9230769231
	},
	{
		"stop_id": 8504777,
		"ID": 362,
		"x": -72.3692739307,
		"y": 25.38817426,
		"h": 1.9230769231
	},
	{
		"stop_id": 8507974,
		"ID": 362,
		"x": -72.3712655687,
		"y": 23.061231956,
		"h": 1.9230769231
	},
	{
		"stop_id": 8507995,
		"ID": 362,
		"x": -72.9932268487,
		"y": 23.407222716,
		"h": 1.9230769231
	},
	{
		"stop_id": 8571220,
		"ID": 362,
		"x": -71.9462639817,
		"y": 27.827195507,
		"h": 1.9230769231
	},
	{
		"stop_id": 8571229,
		"ID": 362,
		"x": -72.3472368867,
		"y": 27.670169596,
		"h": 1.9230769231
	},
	{
		"stop_id": 8571253,
		"ID": 362,
		"x": -71.8182561947,
		"y": 28.142219709,
		"h": 1.9230769231
	},
	{
		"stop_id": 8571258,
		"ID": 362,
		"x": -69.6652275647,
		"y": 26.973238494,
		"h": 1.9230769231
	},
	{
		"stop_id": 8571259,
		"ID": 362,
		"x": -70.0292898937,
		"y": 27.366188945,
		"h": 1.9230769231
	},
	{
		"stop_id": 8571260,
		"ID": 362,
		"x": -71.4382640427,
		"y": 27.741234325,
		"h": 1.9230769231
	},
	{
		"stop_id": 8571261,
		"ID": 362,
		"x": -69.7122581247,
		"y": 26.667148019,
		"h": 1.9230769231
	},
	{
		"stop_id": 8571262,
		"ID": 362,
		"x": -70.7012308907,
		"y": 25.913145338,
		"h": 1.9230769231
	},
	{
		"stop_id": 8571351,
		"ID": 362,
		"x": -70.0262652067,
		"y": 22.41223456,
		"h": 1.9230769231
	},
	{
		"stop_id": 8571352,
		"ID": 362,
		"x": -70.4912758137,
		"y": 22.516227722,
		"h": 1.9230769231
	},
	{
		"stop_id": 8571353,
		"ID": 362,
		"x": -71.9102313317,
		"y": 23.020245809,
		"h": 1.9230769231
	},
	{
		"stop_id": 8571370,
		"ID": 362,
		"x": -69.8752652127,
		"y": 22.510250139,
		"h": 1.9230769231
	},
	{
		"stop_id": 8571382,
		"ID": 362,
		"x": -68.8102533077,
		"y": 25.288158025,
		"h": 1.9230769231
	},
	{
		"stop_id": 8571383,
		"ID": 362,
		"x": -68.9802351897,
		"y": 25.977245408,
		"h": 1.9230769231
	},
	{
		"stop_id": 8577644,
		"ID": 362,
		"x": -72.8232814427,
		"y": 27.942241245,
		"h": 1.9230769231
	},
	{
		"stop_id": 8578074,
		"ID": 362,
		"x": -68.4262356877,
		"y": 25.554172834,
		"h": 1.9230769231
	},
	{
		"stop_id": 8580406,
		"ID": 362,
		"x": -72.1782256467,
		"y": 27.415226425,
		"h": 1.9230769231
	},
	{
		"stop_id": 8580425,
		"ID": 362,
		"x": -72.5532452537,
		"y": 28.064163866,
		"h": 1.9230769231
	},
	{
		"stop_id": 8580569,
		"ID": 362,
		"x": -72.5482727557,
		"y": 27.798227295,
		"h": 1.9230769231
	},
	{
		"stop_id": 8580776,
		"ID": 362,
		"x": -69.2152453817,
		"y": 26.853212405,
		"h": 1.9230769231
	},
	{
		"stop_id": 8581021,
		"ID": 362,
		"x": -73.2692803167,
		"y": 27.376149224,
		"h": 1.9230769231
	},
	{
		"stop_id": 8504410,
		"ID": 452,
		"x": -57.8962420157,
		"y": 23.071203,
		"h": 3.2747252747
	},
	{
		"stop_id": 8507069,
		"ID": 452,
		"x": -56.2802705557,
		"y": 19.902180692,
		"h": 3.2747252747
	},
	{
		"stop_id": 8507096,
		"ID": 452,
		"x": -56.8102240597,
		"y": 19.968161181,
		"h": 3.2747252747
	},
	{
		"stop_id": 8508001,
		"ID": 452,
		"x": -55.1582922447,
		"y": 24.975243529,
		"h": 3.2747252747
	},
	{
		"stop_id": 8508053,
		"ID": 452,
		"x": -58.3052465827,
		"y": 21.015199106,
		"h": 3.2747252747
	},
	{
		"stop_id": 8508054,
		"ID": 452,
		"x": -58.2972954937,
		"y": 20.516152718,
		"h": 3.2747252747
	},
	{
		"stop_id": 8508055,
		"ID": 452,
		"x": -58.3382445787,
		"y": 21.944140595,
		"h": 3.2747252747
	},
	{
		"stop_id": 8508056,
		"ID": 452,
		"x": -56.2282318017,
		"y": 24.664248335,
		"h": 3.2747252747
	},
	{
		"stop_id": 8508057,
		"ID": 452,
		"x": -55.2432691537,
		"y": 25.147163211,
		"h": 3.2747252747
	},
	{
		"stop_id": 8508070,
		"ID": 452,
		"x": -57.9932866977,
		"y": 22.529212708,
		"h": 3.2747252747
	},
	{
		"stop_id": 8508071,
		"ID": 452,
		"x": -55.5612259047,
		"y": 24.940155299,
		"h": 3.2747252747
	},
	{
		"stop_id": 8508072,
		"ID": 452,
		"x": -55.2472593527,
		"y": 25.094242277,
		"h": 3.2747252747
	},
	{
		"stop_id": 8508076,
		"ID": 452,
		"x": -56.7262689367,
		"y": 20.999204774,
		"h": 3.2747252747
	},
	{
		"stop_id": 8508078,
		"ID": 452,
		"x": -55.1762631107,
		"y": 21.177155993,
		"h": 3.2747252747
	},
	{
		"stop_id": 8571389,
		"ID": 452,
		"x": -58.8542289867,
		"y": 23.147147692,
		"h": 3.2747252747
	},
	{
		"stop_id": 8571390,
		"ID": 452,
		"x": -58.5262703507,
		"y": 23.054150779,
		"h": 3.2747252747
	},
	{
		"stop_id": 8571391,
		"ID": 452,
		"x": -58.2482668017,
		"y": 22.948152702,
		"h": 3.2747252747
	},
	{
		"stop_id": 8571392,
		"ID": 452,
		"x": -57.9362289807,
		"y": 23.011158477,
		"h": 3.2747252747
	},
	{
		"stop_id": 8576457,
		"ID": 452,
		"x": -53.8412446207,
		"y": 21.958179577,
		"h": 3.2747252747
	},
	{
		"stop_id": 8576458,
		"ID": 452,
		"x": -54.4732261887,
		"y": 21.354156209,
		"h": 3.2747252747
	},
	{
		"stop_id": 8576459,
		"ID": 452,
		"x": -54.8512788537,
		"y": 20.639228861,
		"h": 3.2747252747
	},
	{
		"stop_id": 8576460,
		"ID": 452,
		"x": -55.2752814617,
		"y": 20.096163108,
		"h": 3.2747252747
	},
	{
		"stop_id": 8576977,
		"ID": 452,
		"x": -58.4022539937,
		"y": 24.61714206,
		"h": 3.2747252747
	},
	{
		"stop_id": 8576978,
		"ID": 452,
		"x": -58.0722427107,
		"y": 23.966198001,
		"h": 3.2747252747
	},
	{
		"stop_id": 8576980,
		"ID": 452,
		"x": -58.2752729637,
		"y": 22.325140093,
		"h": 3.2747252747
	},
	{
		"stop_id": 8576981,
		"ID": 452,
		"x": -58.3542257857,
		"y": 21.975153918,
		"h": 3.2747252747
	},
	{
		"stop_id": 8576982,
		"ID": 452,
		"x": -58.3272346767,
		"y": 21.019196287,
		"h": 3.2747252747
	},
	{
		"stop_id": 8576983,
		"ID": 452,
		"x": -58.2382505987,
		"y": 20.509162803,
		"h": 3.2747252747
	},
	{
		"stop_id": 8576984,
		"ID": 452,
		"x": -57.7122828237,
		"y": 20.337219048,
		"h": 3.2747252747
	},
	{
		"stop_id": 8576985,
		"ID": 452,
		"x": -57.3662629947,
		"y": 19.633184137,
		"h": 3.2747252747
	},
	{
		"stop_id": 8576992,
		"ID": 452,
		"x": -56.6042369757,
		"y": 20.557248881,
		"h": 3.2747252747
	},
	{
		"stop_id": 8576993,
		"ID": 452,
		"x": -56.8562776777,
		"y": 20.00415876,
		"h": 3.2747252747
	},
	{
		"stop_id": 8576994,
		"ID": 452,
		"x": -57.1992670527,
		"y": 19.727190584,
		"h": 3.2747252747
	},
	{
		"stop_id": 8576998,
		"ID": 452,
		"x": -55.3122922027,
		"y": 19.51215362,
		"h": 3.2747252747
	},
	{
		"stop_id": 8577027,
		"ID": 452,
		"x": -54.8492893987,
		"y": 24.953250968,
		"h": 3.2747252747
	},
	{
		"stop_id": 8587292,
		"ID": 452,
		"x": -56.0892650957,
		"y": 20.52218327,
		"h": 3.2747252747
	},
	{
		"stop_id": 8589010,
		"ID": 452,
		"x": -55.1652603677,
		"y": 20.308248796,
		"h": 3.2747252747
	},
	{
		"stop_id": 8589011,
		"ID": 452,
		"x": -54.9482724547,
		"y": 20.428148092,
		"h": 3.2747252747
	},
	{
		"stop_id": 8589012,
		"ID": 452,
		"x": -55.7172660947,
		"y": 19.93020876,
		"h": 3.2747252747
	},
	{
		"stop_id": 8589013,
		"ID": 452,
		"x": -55.3982278787,
		"y": 20.283175064,
		"h": 3.2747252747
	},
	{
		"stop_id": 8589015,
		"ID": 452,
		"x": -55.6032999267,
		"y": 20.410211717,
		"h": 3.2747252747
	},
	{
		"stop_id": 8589016,
		"ID": 452,
		"x": -55.7482792887,
		"y": 20.574203526,
		"h": 3.2747252747
	},
	{
		"stop_id": 8589017,
		"ID": 452,
		"x": -55.2112994537,
		"y": 20.722216266,
		"h": 3.2747252747
	},
	{
		"stop_id": 8589018,
		"ID": 452,
		"x": -54.6712770867,
		"y": 20.930201342,
		"h": 3.2747252747
	},
	{
		"stop_id": 8589029,
		"ID": 452,
		"x": -54.8052853057,
		"y": 21.152211086,
		"h": 3.2747252747
	},
	{
		"stop_id": 8589030,
		"ID": 452,
		"x": -56.3102776857,
		"y": 19.948188602,
		"h": 3.2747252747
	},
	{
		"stop_id": 8589031,
		"ID": 452,
		"x": -55.8172630027,
		"y": 20.180167477,
		"h": 3.2747252747
	},
	{
		"stop_id": 8589032,
		"ID": 452,
		"x": -55.9362967117,
		"y": 20.467247242,
		"h": 3.2747252747
	},
	{
		"stop_id": 8589033,
		"ID": 452,
		"x": -55.8802731007,
		"y": 20.550216377,
		"h": 3.2747252747
	},
	{
		"stop_id": 8589034,
		"ID": 452,
		"x": -56.2842240507,
		"y": 20.030247696,
		"h": 3.2747252747
	},
	{
		"stop_id": 8589035,
		"ID": 452,
		"x": -56.3012953687,
		"y": 20.616221892,
		"h": 3.2747252747
	},
	{
		"stop_id": 8589036,
		"ID": 452,
		"x": -56.5742630567,
		"y": 20.85820522,
		"h": 3.2747252747
	},
	{
		"stop_id": 8589038,
		"ID": 452,
		"x": -58.9722754417,
		"y": 21.950147173,
		"h": 3.2747252747
	},
	{
		"stop_id": 8589039,
		"ID": 452,
		"x": -59.2052548187,
		"y": 21.720221706,
		"h": 3.2747252747
	},
	{
		"stop_id": 8589042,
		"ID": 452,
		"x": -55.0172489587,
		"y": 25.257173503,
		"h": 3.2747252747
	},
	{
		"stop_id": 8589044,
		"ID": 452,
		"x": -58.9242802047,
		"y": 21.981169849,
		"h": 3.2747252747
	},
	{
		"stop_id": 8589046,
		"ID": 452,
		"x": -58.5382688487,
		"y": 22.157215233,
		"h": 3.2747252747
	},
	{
		"stop_id": 8589047,
		"ID": 452,
		"x": -59.1412919817,
		"y": 22.726219058,
		"h": 3.2747252747
	},
	{
		"stop_id": 8589048,
		"ID": 452,
		"x": -59.4502454777,
		"y": 22.839150156,
		"h": 3.2747252747
	},
	{
		"stop_id": 8589049,
		"ID": 452,
		"x": -58.1742477217,
		"y": 22.577190749,
		"h": 3.2747252747
	},
	{
		"stop_id": 8589050,
		"ID": 452,
		"x": -58.6882805567,
		"y": 22.6811407,
		"h": 3.2747252747
	},
	{
		"stop_id": 8589051,
		"ID": 452,
		"x": -58.7542942587,
		"y": 22.645221738,
		"h": 3.2747252747
	},
	{
		"stop_id": 8589052,
		"ID": 452,
		"x": -56.3942326327,
		"y": 24.699174025,
		"h": 3.2747252747
	},
	{
		"stop_id": 8589053,
		"ID": 452,
		"x": -58.3922525767,
		"y": 21.231185907,
		"h": 3.2747252747
	},
	{
		"stop_id": 8589054,
		"ID": 452,
		"x": -58.5112576757,
		"y": 21.725207688,
		"h": 3.2747252747
	},
	{
		"stop_id": 8589542,
		"ID": 452,
		"x": -58.2962487127,
		"y": 20.596196306,
		"h": 3.2747252747
	},
	{
		"stop_id": 8595514,
		"ID": 452,
		"x": -57.1032451387,
		"y": 19.932230794,
		"h": 3.2747252747
	},
	{
		"stop_id": 8595600,
		"ID": 452,
		"x": -57.7862275817,
		"y": 22.221217852,
		"h": 3.2747252747
	},
	{
		"stop_id": 8595604,
		"ID": 452,
		"x": -58.0792259537,
		"y": 22.493169542,
		"h": 3.2747252747
	},
	{
		"stop_id": 8595605,
		"ID": 452,
		"x": -57.5372920737,
		"y": 21.865219049,
		"h": 3.2747252747
	},
	{
		"stop_id": 8504411,
		"ID": 422,
		"x": -58.7302888197,
		"y": 25.244203402,
		"h": 1.7252747253
	},
	{
		"stop_id": 8507710,
		"ID": 422,
		"x": -60.6842777657,
		"y": 23.241229562,
		"h": 1.7252747253
	},
	{
		"stop_id": 8507777,
		"ID": 422,
		"x": -61.5072741827,
		"y": 22.867222147,
		"h": 1.7252747253
	},
	{
		"stop_id": 8508073,
		"ID": 422,
		"x": -59.8502364297,
		"y": 25.112170701,
		"h": 1.7252747253
	},
	{
		"stop_id": 8508074,
		"ID": 422,
		"x": -58.8772482137,
		"y": 25.24818425,
		"h": 1.7252747253
	},
	{
		"stop_id": 8508077,
		"ID": 422,
		"x": -59.3162583247,
		"y": 23.265166858,
		"h": 1.7252747253
	},
	{
		"stop_id": 8508654,
		"ID": 422,
		"x": -59.8042554377,
		"y": 27.77419363,
		"h": 1.7252747253
	},
	{
		"stop_id": 8571375,
		"ID": 422,
		"x": -63.0692533347,
		"y": 22.460241313,
		"h": 1.7252747253
	},
	{
		"stop_id": 8571385,
		"ID": 422,
		"x": -61.9172831847,
		"y": 22.698159198,
		"h": 1.7252747253
	},
	{
		"stop_id": 8571386,
		"ID": 422,
		"x": -61.1582931437,
		"y": 23.000197422,
		"h": 1.7252747253
	},
	{
		"stop_id": 8571387,
		"ID": 422,
		"x": -59.5782557297,
		"y": 23.252149976,
		"h": 1.7252747253
	},
	{
		"stop_id": 8571470,
		"ID": 422,
		"x": -58.9352717867,
		"y": 25.374246113,
		"h": 1.7252747253
	},
	{
		"stop_id": 8571471,
		"ID": 422,
		"x": -60.4502684317,
		"y": 26.70820914,
		"h": 1.7252747253
	},
	{
		"stop_id": 8571472,
		"ID": 422,
		"x": -60.3422775457,
		"y": 27.240156623,
		"h": 1.7252747253
	},
	{
		"stop_id": 8576972,
		"ID": 422,
		"x": -59.6662488257,
		"y": 25.359192606,
		"h": 1.7252747253
	},
	{
		"stop_id": 8576973,
		"ID": 422,
		"x": -59.8612521367,
		"y": 25.37220283,
		"h": 1.7252747253
	},
	{
		"stop_id": 8576974,
		"ID": 422,
		"x": -59.5752426437,
		"y": 25.079150584,
		"h": 1.7252747253
	},
	{
		"stop_id": 8576975,
		"ID": 422,
		"x": -59.2092444707,
		"y": 25.113186311,
		"h": 1.7252747253
	},
	{
		"stop_id": 8576976,
		"ID": 422,
		"x": -58.6672988357,
		"y": 25.005193471,
		"h": 1.7252747253
	},
	{
		"stop_id": 8579863,
		"ID": 422,
		"x": -59.6392635957,
		"y": 26.060245183,
		"h": 1.7252747253
	},
	{
		"stop_id": 8581025,
		"ID": 422,
		"x": -59.3242406447,
		"y": 25.835242299,
		"h": 1.7252747253
	},
	{
		"stop_id": 8581033,
		"ID": 422,
		"x": -60.3842271377,
		"y": 27.264174788,
		"h": 1.7252747253
	},
	{
		"stop_id": 8594065,
		"ID": 422,
		"x": -62.4882317037,
		"y": 27.253236574,
		"h": 1.7252747253
	},
	{
		"stop_id": 8504412,
		"ID": 393,
		"x": -63.7422876367,
		"y": 27.522221334,
		"h": 1.6923076923
	},
	{
		"stop_id": 8504413,
		"ID": 393,
		"x": -67.3122757407,
		"y": 29.407221785,
		"h": 1.6923076923
	},
	{
		"stop_id": 8504454,
		"ID": 393,
		"x": -68.2502403077,
		"y": 29.145241113,
		"h": 1.6923076923
	},
	{
		"stop_id": 8504455,
		"ID": 393,
		"x": -64.9432590267,
		"y": 30.79921037,
		"h": 1.6923076923
	},
	{
		"stop_id": 8504457,
		"ID": 393,
		"x": -67.9342251187,
		"y": 30.315225956,
		"h": 1.6923076923
	},
	{
		"stop_id": 8504757,
		"ID": 393,
		"x": -68.7462290537,
		"y": 28.239249,
		"h": 1.6923076923
	},
	{
		"stop_id": 8507994,
		"ID": 393,
		"x": -68.0132481187,
		"y": 25.795158039,
		"h": 1.6923076923
	},
	{
		"stop_id": 8508871,
		"ID": 393,
		"x": -67.1232263767,
		"y": 30.886142822,
		"h": 1.6923076923
	},
	{
		"stop_id": 8508872,
		"ID": 393,
		"x": -65.6352401157,
		"y": 30.242217905,
		"h": 1.6923076923
	},
	{
		"stop_id": 8571257,
		"ID": 393,
		"x": -68.8442845627,
		"y": 27.627170172,
		"h": 1.6923076923
	},
	{
		"stop_id": 8571381,
		"ID": 393,
		"x": -67.3162852757,
		"y": 25.808230848,
		"h": 1.6923076923
	},
	{
		"stop_id": 8571464,
		"ID": 393,
		"x": -67.2532872427,
		"y": 30.507205714,
		"h": 1.6923076923
	},
	{
		"stop_id": 8571465,
		"ID": 393,
		"x": -66.5262337047,
		"y": 30.15223727,
		"h": 1.6923076923
	},
	{
		"stop_id": 8571466,
		"ID": 393,
		"x": -66.1012983497,
		"y": 30.076165412,
		"h": 1.6923076923
	},
	{
		"stop_id": 8580402,
		"ID": 393,
		"x": -68.5972739827,
		"y": 28.606228244,
		"h": 1.6923076923
	},
	{
		"stop_id": 8581024,
		"ID": 393,
		"x": -66.9422981667,
		"y": 30.330163385,
		"h": 1.6923076923
	},
	{
		"stop_id": 8581354,
		"ID": 393,
		"x": -65.3662351127,
		"y": 30.582144852,
		"h": 1.6923076923
	},
	{
		"stop_id": 8588320,
		"ID": 393,
		"x": -67.3172604267,
		"y": 29.430241023,
		"h": 1.6923076923
	},
	{
		"stop_id": 8588321,
		"ID": 393,
		"x": -63.7462826327,
		"y": 27.570250668,
		"h": 1.6923076923
	},
	{
		"stop_id": 8594063,
		"ID": 393,
		"x": -65.3922592567,
		"y": 28.003176815,
		"h": 1.6923076923
	},
	{
		"stop_id": 8594064,
		"ID": 393,
		"x": -64.5182446737,
		"y": 27.772162636,
		"h": 1.6923076923
	},
	{
		"stop_id": 8594066,
		"ID": 393,
		"x": -66.9732978267,
		"y": 28.775222324,
		"h": 1.6923076923
	},
	{
		"stop_id": 8504414,
		"ID": 363,
		"x": -69.7932833707,
		"y": 31.361236916,
		"h": 2.3516483516
	},
	{
		"stop_id": 8504704,
		"ID": 363,
		"x": -71.5422685667,
		"y": 28.558228749,
		"h": 2.3516483516
	},
	{
		"stop_id": 8504706,
		"ID": 363,
		"x": -70.0342590907,
		"y": 30.668150866,
		"h": 2.3516483516
	},
	{
		"stop_id": 8504776,
		"ID": 363,
		"x": -69.4872428937,
		"y": 31.618202611,
		"h": 2.3516483516
	},
	{
		"stop_id": 8518749,
		"ID": 363,
		"x": -70.5282916537,
		"y": 30.998215996,
		"h": 2.3516483516
	},
	{
		"stop_id": 8571213,
		"ID": 363,
		"x": -74.5072875447,
		"y": 30.772224393,
		"h": 2.3516483516
	},
	{
		"stop_id": 8571215,
		"ID": 363,
		"x": -73.7642315537,
		"y": 29.83122529,
		"h": 2.3516483516
	},
	{
		"stop_id": 8571216,
		"ID": 363,
		"x": -73.1092652097,
		"y": 29.211142857,
		"h": 2.3516483516
	},
	{
		"stop_id": 8571217,
		"ID": 363,
		"x": -72.6972491187,
		"y": 29.592219011,
		"h": 2.3516483516
	},
	{
		"stop_id": 8571218,
		"ID": 363,
		"x": -72.4052752857,
		"y": 28.427159289,
		"h": 2.3516483516
	},
	{
		"stop_id": 8571225,
		"ID": 363,
		"x": -73.0312512407,
		"y": 33.7742058,
		"h": 2.3516483516
	},
	{
		"stop_id": 8571227,
		"ID": 363,
		"x": -73.7172517687,
		"y": 32.774217108,
		"h": 2.3516483516
	},
	{
		"stop_id": 8571255,
		"ID": 363,
		"x": -69.6362259617,
		"y": 30.814220425,
		"h": 2.3516483516
	},
	{
		"stop_id": 8571256,
		"ID": 363,
		"x": -69.5302916907,
		"y": 30.70820692,
		"h": 2.3516483516
	},
	{
		"stop_id": 8576433,
		"ID": 363,
		"x": -71.0402724587,
		"y": 33.712147631,
		"h": 2.3516483516
	},
	{
		"stop_id": 8576434,
		"ID": 363,
		"x": -70.9392590177,
		"y": 33.333185282,
		"h": 2.3516483516
	},
	{
		"stop_id": 8576435,
		"ID": 363,
		"x": -70.4002455907,
		"y": 31.877145143,
		"h": 2.3516483516
	},
	{
		"stop_id": 8576436,
		"ID": 363,
		"x": -70.0432522307,
		"y": 31.697189256,
		"h": 2.3516483516
	},
	{
		"stop_id": 8576437,
		"ID": 363,
		"x": -69.8132776617,
		"y": 31.394178335,
		"h": 2.3516483516
	},
	{
		"stop_id": 8580977,
		"ID": 363,
		"x": -68.7002515397,
		"y": 30.397161265,
		"h": 2.3516483516
	},
	{
		"stop_id": 8581076,
		"ID": 363,
		"x": -69.2692530587,
		"y": 30.504221845,
		"h": 2.3516483516
	},
	{
		"stop_id": 8581782,
		"ID": 363,
		"x": -69.7772286797,
		"y": 31.110179675,
		"h": 2.3516483516
	},
	{
		"stop_id": 8581783,
		"ID": 363,
		"x": -68.9312672667,
		"y": 32.04521941,
		"h": 2.3516483516
	},
	{
		"stop_id": 8582619,
		"ID": 363,
		"x": -69.6702581927,
		"y": 31.309222126,
		"h": 2.3516483516
	},
	{
		"stop_id": 8582620,
		"ID": 363,
		"x": -70.0512724157,
		"y": 30.930216456,
		"h": 2.3516483516
	},
	{
		"stop_id": 8583033,
		"ID": 363,
		"x": -70.3002278197,
		"y": 30.687185671,
		"h": 2.3516483516
	},
	{
		"stop_id": 8583034,
		"ID": 363,
		"x": -70.2132844327,
		"y": 30.414211435,
		"h": 2.3516483516
	},
	{
		"stop_id": 8583036,
		"ID": 363,
		"x": -69.5002724837,
		"y": 31.546183579,
		"h": 2.3516483516
	},
	{
		"stop_id": 8583037,
		"ID": 363,
		"x": -69.2892972627,
		"y": 31.403203238,
		"h": 2.3516483516
	},
	{
		"stop_id": 8583038,
		"ID": 363,
		"x": -69.0572763297,
		"y": 31.403166447,
		"h": 2.3516483516
	},
	{
		"stop_id": 8583039,
		"ID": 363,
		"x": -68.7932417807,
		"y": 31.280242749,
		"h": 2.3516483516
	},
	{
		"stop_id": 8583040,
		"ID": 363,
		"x": -68.7812287017,
		"y": 31.090228758,
		"h": 2.3516483516
	},
	{
		"stop_id": 8583041,
		"ID": 363,
		"x": -69.1492449677,
		"y": 31.024210287,
		"h": 2.3516483516
	},
	{
		"stop_id": 8583042,
		"ID": 363,
		"x": -69.4262393257,
		"y": 30.981188822,
		"h": 2.3516483516
	},
	{
		"stop_id": 8583045,
		"ID": 363,
		"x": -70.4962888237,
		"y": 30.553241312,
		"h": 2.3516483516
	},
	{
		"stop_id": 8595201,
		"ID": 363,
		"x": -70.5082489217,
		"y": 31.911248764,
		"h": 2.3516483516
	},
	{
		"stop_id": 8595544,
		"ID": 363,
		"x": -70.3622781287,
		"y": 31.875186884,
		"h": 2.3516483516
	},
	{
		"stop_id": 8595545,
		"ID": 363,
		"x": -69.8972549197,
		"y": 32.600223732,
		"h": 2.3516483516
	},
	{
		"stop_id": 8595546,
		"ID": 363,
		"x": -69.6672908477,
		"y": 32.89522219,
		"h": 2.3516483516
	},
	{
		"stop_id": 8595547,
		"ID": 363,
		"x": -69.9522704137,
		"y": 32.225217935,
		"h": 2.3516483516
	},
	{
		"stop_id": 8595548,
		"ID": 363,
		"x": -69.7422430187,
		"y": 32.485228012,
		"h": 2.3516483516
	},
	{
		"stop_id": 8595549,
		"ID": 363,
		"x": -70.0922259627,
		"y": 32.050140223,
		"h": 2.3516483516
	},
	{
		"stop_id": 8504453,
		"ID": 423,
		"x": -64.1882925947,
		"y": 31.058179551,
		"h": 1.3626373626
	},
	{
		"stop_id": 8508753,
		"ID": 423,
		"x": -61.0782523747,
		"y": 28.921217515,
		"h": 1.3626373626
	},
	{
		"stop_id": 8508773,
		"ID": 423,
		"x": -59.3842580397,
		"y": 32.980219983,
		"h": 1.3626373626
	},
	{
		"stop_id": 8508777,
		"ID": 423,
		"x": -61.8042465077,
		"y": 29.739222275,
		"h": 1.3626373626
	},
	{
		"stop_id": 8508782,
		"ID": 423,
		"x": -60.8402394047,
		"y": 32.630242019,
		"h": 1.3626373626
	},
	{
		"stop_id": 8508796,
		"ID": 423,
		"x": -62.7082574947,
		"y": 32.160192961,
		"h": 1.3626373626
	},
	{
		"stop_id": 8571467,
		"ID": 423,
		"x": -63.8622287387,
		"y": 31.491184059,
		"h": 1.3626373626
	},
	{
		"stop_id": 8571468,
		"ID": 423,
		"x": -61.6222514277,
		"y": 32.669246775,
		"h": 1.3626373626
	},
	{
		"stop_id": 8571473,
		"ID": 423,
		"x": -62.1252510857,
		"y": 30.574145613,
		"h": 1.3626373626
	},
	{
		"stop_id": 8571520,
		"ID": 423,
		"x": -59.8752641797,
		"y": 33.499176276,
		"h": 1.3626373626
	},
	{
		"stop_id": 8581627,
		"ID": 423,
		"x": -59.1372553077,
		"y": 32.867173203,
		"h": 1.3626373626
	},
	{
		"stop_id": 8581744,
		"ID": 423,
		"x": -62.3932885787,
		"y": 32.277217576,
		"h": 1.3626373626
	},
	{
		"stop_id": 8504466,
		"ID": 301,
		"x": -79.3722876477,
		"y": 26.364185412,
		"h": 1.1318681319
	},
	{
		"stop_id": 8504467,
		"ID": 301,
		"x": -81.8162521677,
		"y": 25.199223374,
		"h": 1.1318681319
	},
	{
		"stop_id": 8571240,
		"ID": 301,
		"x": -81.2592880487,
		"y": 27.985181547,
		"h": 1.1318681319
	},
	{
		"stop_id": 8576654,
		"ID": 301,
		"x": -81.8872990217,
		"y": 27.962142778,
		"h": 1.1318681319
	},
	{
		"stop_id": 8583216,
		"ID": 301,
		"x": -81.8892808187,
		"y": 25.249189469,
		"h": 1.1318681319
	},
	{
		"stop_id": 8504468,
		"ID": 268,
		"x": -84.9772349057,
		"y": 23.542209205,
		"h": 1.2637362637
	},
	{
		"stop_id": 8504482,
		"ID": 268,
		"x": -88.8052574677,
		"y": 23.980143325,
		"h": 1.2637362637
	},
	{
		"stop_id": 8504483,
		"ID": 268,
		"x": -85.5312797357,
		"y": 22.905231508,
		"h": 1.2637362637
	},
	{
		"stop_id": 8504499,
		"ID": 268,
		"x": -86.0212555737,
		"y": 20.21622199,
		"h": 1.2637362637
	},
	{
		"stop_id": 8571245,
		"ID": 268,
		"x": -85.1872523367,
		"y": 23.567228841,
		"h": 1.2637362637
	},
	{
		"stop_id": 8571521,
		"ID": 268,
		"x": -85.5512939007,
		"y": 22.920215497,
		"h": 1.2637362637
	},
	{
		"stop_id": 8571522,
		"ID": 268,
		"x": -86.6042510377,
		"y": 24.145224689,
		"h": 1.2637362637
	},
	{
		"stop_id": 8581895,
		"ID": 268,
		"x": -85.5872316727,
		"y": 23.611199781,
		"h": 1.2637362637
	},
	{
		"stop_id": 8582793,
		"ID": 268,
		"x": -87.8632366507,
		"y": 24.62019674,
		"h": 1.2637362637
	},
	{
		"stop_id": 8504530,
		"ID": 261,
		"x": -85.0092514517,
		"y": -18.336817953,
		"h": 1.8571428571
	},
	{
		"stop_id": 8504540,
		"ID": 261,
		"x": -84.7822752997,
		"y": -20.520760321,
		"h": 1.8571428571
	},
	{
		"stop_id": 8504872,
		"ID": 261,
		"x": -88.4782578687,
		"y": -17.04274885,
		"h": 1.8571428571
	},
	{
		"stop_id": 8504910,
		"ID": 261,
		"x": -84.7392575987,
		"y": -19.483751206,
		"h": 1.8571428571
	},
	{
		"stop_id": 8504911,
		"ID": 261,
		"x": -85.1072745307,
		"y": -16.546832267,
		"h": 1.8571428571
	},
	{
		"stop_id": 8504912,
		"ID": 261,
		"x": -88.9992854987,
		"y": -18.983768647,
		"h": 1.8571428571
	},
	{
		"stop_id": 8504913,
		"ID": 261,
		"x": -88.0942310167,
		"y": -19.039813798,
		"h": 1.8571428571
	},
	{
		"stop_id": 8504914,
		"ID": 261,
		"x": -87.4992559557,
		"y": -18.989796121,
		"h": 1.8571428571
	},
	{
		"stop_id": 8504915,
		"ID": 261,
		"x": -87.2532988017,
		"y": -18.968808653,
		"h": 1.8571428571
	},
	{
		"stop_id": 8504925,
		"ID": 261,
		"x": -87.4422325927,
		"y": -16.481788546,
		"h": 1.8571428571
	},
	{
		"stop_id": 8504926,
		"ID": 261,
		"x": -86.5792755997,
		"y": -15.958785261,
		"h": 1.8571428571
	},
	{
		"stop_id": 8577739,
		"ID": 261,
		"x": -86.7582614227,
		"y": -18.657792674,
		"h": 1.8571428571
	},
	{
		"stop_id": 8577749,
		"ID": 261,
		"x": -85.9252518557,
		"y": -15.374828637,
		"h": 1.8571428571
	},
	{
		"stop_id": 8577751,
		"ID": 261,
		"x": -85.0272799077,
		"y": -17.310779165,
		"h": 1.8571428571
	},
	{
		"stop_id": 8577778,
		"ID": 261,
		"x": -87.9442710867,
		"y": -15.903818665,
		"h": 1.8571428571
	},
	{
		"stop_id": 8577779,
		"ID": 261,
		"x": -88.7792316897,
		"y": -16.913787637,
		"h": 1.8571428571
	},
	{
		"stop_id": 8588535,
		"ID": 261,
		"x": -88.6852402777,
		"y": -17.474749823,
		"h": 1.8571428571
	},
	{
		"stop_id": 8588830,
		"ID": 261,
		"x": -86.9292781207,
		"y": -18.808762161,
		"h": 1.8571428571
	},
	{
		"stop_id": 8593275,
		"ID": 261,
		"x": -88.8012793987,
		"y": -18.743832525,
		"h": 1.8571428571
	},
	{
		"stop_id": 8593278,
		"ID": 261,
		"x": -88.6952961947,
		"y": -18.176835578,
		"h": 1.8571428571
	},
	{
		"stop_id": 8593279,
		"ID": 261,
		"x": -88.7232756137,
		"y": -19.068819513,
		"h": 1.8571428571
	},
	{
		"stop_id": 8593283,
		"ID": 261,
		"x": -88.6792736207,
		"y": -19.203767212,
		"h": 1.8571428571
	},
	{
		"stop_id": 8593285,
		"ID": 261,
		"x": -88.9882524347,
		"y": -19.296759018,
		"h": 1.8571428571
	},
	{
		"stop_id": 8593287,
		"ID": 261,
		"x": -88.0892648297,
		"y": -20.871764117,
		"h": 1.8571428571
	},
	{
		"stop_id": 8593289,
		"ID": 261,
		"x": -86.6312368217,
		"y": -18.460820021,
		"h": 1.8571428571
	},
	{
		"stop_id": 8593290,
		"ID": 261,
		"x": -88.5522337017,
		"y": -16.933782614,
		"h": 1.8571428571
	},
	{
		"stop_id": 8593485,
		"ID": 261,
		"x": -88.2972690667,
		"y": -19.053856893,
		"h": 1.8571428571
	},
	{
		"stop_id": 8504533,
		"ID": 296,
		"x": -82.1602405997,
		"y": -4.477779183,
		"h": 1.5604395604
	},
	{
		"stop_id": 8504608,
		"ID": 296,
		"x": -82.9162651497,
		"y": -4.748811988,
		"h": 1.5604395604
	},
	{
		"stop_id": 8504615,
		"ID": 296,
		"x": -82.8842600257,
		"y": -6.013809019,
		"h": 1.5604395604
	},
	{
		"stop_id": 8504630,
		"ID": 296,
		"x": -80.1492636567,
		"y": -2.366789989,
		"h": 1.5604395604
	},
	{
		"stop_id": 8504631,
		"ID": 296,
		"x": -81.8592868387,
		"y": -0.89382711,
		"h": 1.5604395604
	},
	{
		"stop_id": 8504635,
		"ID": 296,
		"x": -81.5362575697,
		"y": -3.836758127,
		"h": 1.5604395604
	},
	{
		"stop_id": 8504862,
		"ID": 296,
		"x": -80.9882864567,
		"y": -1.914852071,
		"h": 1.5604395604
	},
	{
		"stop_id": 8504865,
		"ID": 296,
		"x": -80.1742833137,
		"y": -5.347793362,
		"h": 1.5604395604
	},
	{
		"stop_id": 8504932,
		"ID": 296,
		"x": -80.6582882527,
		"y": -3.465817406,
		"h": 1.5604395604
	},
	{
		"stop_id": 8504975,
		"ID": 296,
		"x": -81.7532771957,
		"y": -1.46784968,
		"h": 1.5604395604
	},
	{
		"stop_id": 8577742,
		"ID": 296,
		"x": -81.9152371357,
		"y": -1.257808286,
		"h": 1.5604395604
	},
	{
		"stop_id": 8577743,
		"ID": 296,
		"x": -80.8992269497,
		"y": -2.472789876,
		"h": 1.5604395604
	},
	{
		"stop_id": 8577744,
		"ID": 296,
		"x": -80.3472578007,
		"y": -4.872844346,
		"h": 1.5604395604
	},
	{
		"stop_id": 8577745,
		"ID": 296,
		"x": -80.0972484717,
		"y": -5.92879858,
		"h": 1.5604395604
	},
	{
		"stop_id": 8577765,
		"ID": 296,
		"x": -81.0772688967,
		"y": -3.369841398,
		"h": 1.5604395604
	},
	{
		"stop_id": 8577890,
		"ID": 296,
		"x": -79.6332451397,
		"y": -5.025787865,
		"h": 1.5604395604
	},
	{
		"stop_id": 8587241,
		"ID": 296,
		"x": -79.8492909357,
		"y": -4.783829164,
		"h": 1.5604395604
	},
	{
		"stop_id": 8587793,
		"ID": 296,
		"x": -81.8362921077,
		"y": -4.130807375,
		"h": 1.5604395604
	},
	{
		"stop_id": 8504543,
		"ID": 75,
		"x": -133.3172877187,
		"y": 6.799248652,
		"h": 1.3296703297
	},
	{
		"stop_id": 8504751,
		"ID": 75,
		"x": -132.0882769467,
		"y": 8.482247375,
		"h": 1.3296703297
	},
	{
		"stop_id": 8504761,
		"ID": 75,
		"x": -130.6042505977,
		"y": 9.628143819,
		"h": 1.3296703297
	},
	{
		"stop_id": 8571777,
		"ID": 75,
		"x": -131.1562914467,
		"y": 9.289182356,
		"h": 1.3296703297
	},
	{
		"stop_id": 8571778,
		"ID": 75,
		"x": -132.4732608537,
		"y": 8.151167959,
		"h": 1.3296703297
	},
	{
		"stop_id": 8571779,
		"ID": 75,
		"x": -132.7692446677,
		"y": 7.855156718,
		"h": 1.3296703297
	},
	{
		"stop_id": 8571780,
		"ID": 75,
		"x": -133.5852497887,
		"y": 6.150166053,
		"h": 1.3296703297
	},
	{
		"stop_id": 8571781,
		"ID": 75,
		"x": -132.7552548097,
		"y": 5.836228386,
		"h": 1.3296703297
	},
	{
		"stop_id": 8580774,
		"ID": 75,
		"x": -131.8222422127,
		"y": 8.70916739,
		"h": 1.3296703297
	},
	{
		"stop_id": 8583729,
		"ID": 75,
		"x": -132.5642630417,
		"y": 8.061222622,
		"h": 1.3296703297
	},
	{
		"stop_id": 8583730,
		"ID": 75,
		"x": -131.4852475007,
		"y": 8.980161704,
		"h": 1.3296703297
	},
	{
		"stop_id": 8504547,
		"ID": 202,
		"x": -96.4962669847,
		"y": 13.844232878,
		"h": 1.0989010989
	},
	{
		"stop_id": 8504562,
		"ID": 202,
		"x": -96.7462857837,
		"y": 14.811200538,
		"h": 1.0989010989
	},
	{
		"stop_id": 8570526,
		"ID": 202,
		"x": -94.6172843177,
		"y": 14.805142077,
		"h": 1.0989010989
	},
	{
		"stop_id": 8570527,
		"ID": 202,
		"x": -93.3092857597,
		"y": 16.358154015,
		"h": 1.0989010989
	},
	{
		"stop_id": 8504561,
		"ID": 235,
		"x": -92.0502710877,
		"y": 18.422222214,
		"h": 1.2637362637
	},
	{
		"stop_id": 8504571,
		"ID": 235,
		"x": -88.9612854657,
		"y": 20.204140924,
		"h": 1.2637362637
	},
	{
		"stop_id": 8570528,
		"ID": 235,
		"x": -90.9032239167,
		"y": 17.154191347,
		"h": 1.2637362637
	},
	{
		"stop_id": 8570529,
		"ID": 235,
		"x": -91.3102447357,
		"y": 17.667171807,
		"h": 1.2637362637
	},
	{
		"stop_id": 8570530,
		"ID": 235,
		"x": -91.6362416837,
		"y": 17.960180663,
		"h": 1.2637362637
	},
	{
		"stop_id": 8579746,
		"ID": 235,
		"x": -90.9922423337,
		"y": 18.499176173,
		"h": 1.2637362637
	},
	{
		"stop_id": 8581750,
		"ID": 235,
		"x": -88.9872529847,
		"y": 20.076197675,
		"h": 1.2637362637
	},
	{
		"stop_id": 8583709,
		"ID": 235,
		"x": -90.8302975047,
		"y": 16.890220926,
		"h": 1.2637362637
	},
	{
		"stop_id": 8583829,
		"ID": 235,
		"x": -91.5772919607,
		"y": 17.553196597,
		"h": 1.2637362637
	},
	{
		"stop_id": 8504563,
		"ID": 174,
		"x": -101.0402504497,
		"y": 11.865203278,
		"h": 1.032967033
	},
	{
		"stop_id": 8570416,
		"ID": 174,
		"x": -100.5162404617,
		"y": 10.881168793,
		"h": 1.032967033
	},
	{
		"stop_id": 8504575,
		"ID": 234,
		"x": -90.2922940747,
		"y": 14.551158874,
		"h": 1.3956043956
	},
	{
		"stop_id": 8570517,
		"ID": 234,
		"x": -93.8902338647,
		"y": 12.493224304,
		"h": 1.3956043956
	},
	{
		"stop_id": 8570519,
		"ID": 234,
		"x": -92.2152831097,
		"y": 13.84215929,
		"h": 1.3956043956
	},
	{
		"stop_id": 8570521,
		"ID": 234,
		"x": -91.4332585747,
		"y": 13.789144424,
		"h": 1.3956043956
	},
	{
		"stop_id": 8570522,
		"ID": 234,
		"x": -90.5422907927,
		"y": 14.561228703,
		"h": 1.3956043956
	},
	{
		"stop_id": 8570523,
		"ID": 234,
		"x": -90.1632874507,
		"y": 15.368167073,
		"h": 1.3956043956
	},
	{
		"stop_id": 8570524,
		"ID": 234,
		"x": -91.3672622077,
		"y": 14.555211858,
		"h": 1.3956043956
	},
	{
		"stop_id": 8570525,
		"ID": 234,
		"x": -92.3182453887,
		"y": 14.766226013,
		"h": 1.3956043956
	},
	{
		"stop_id": 8579745,
		"ID": 234,
		"x": -91.5202880287,
		"y": 14.096219566,
		"h": 1.3956043956
	},
	{
		"stop_id": 8580758,
		"ID": 234,
		"x": -91.0212259407,
		"y": 13.427215827,
		"h": 1.3956043956
	},
	{
		"stop_id": 8580759,
		"ID": 234,
		"x": -89.7762498027,
		"y": 12.063185648,
		"h": 1.3956043956
	},
	{
		"stop_id": 8583515,
		"ID": 234,
		"x": -89.4462665737,
		"y": 11.936241798,
		"h": 1.3956043956
	},
	{
		"stop_id": 8583725,
		"ID": 234,
		"x": -89.7422850497,
		"y": 15.206166711,
		"h": 1.3956043956
	},
	{
		"stop_id": 8504578,
		"ID": 238,
		"x": -92.7842464427,
		"y": 37.020176114,
		"h": 1.2637362637
	},
	{
		"stop_id": 8504951,
		"ID": 238,
		"x": -89.5602877977,
		"y": 37.074145096,
		"h": 1.2637362637
	},
	{
		"stop_id": 8504952,
		"ID": 238,
		"x": -93.2362527197,
		"y": 37.612167363,
		"h": 1.2637362637
	},
	{
		"stop_id": 8504953,
		"ID": 238,
		"x": -92.4422561587,
		"y": 37.145245702,
		"h": 1.2637362637
	},
	{
		"stop_id": 8576761,
		"ID": 238,
		"x": -91.3272463167,
		"y": 37.630162253,
		"h": 1.2637362637
	},
	{
		"stop_id": 8576762,
		"ID": 238,
		"x": -90.9122377967,
		"y": 37.355141264,
		"h": 1.2637362637
	},
	{
		"stop_id": 8576773,
		"ID": 238,
		"x": -92.7982797427,
		"y": 39.554193904,
		"h": 1.2637362637
	},
	{
		"stop_id": 8583498,
		"ID": 238,
		"x": -90.6372451127,
		"y": 35.275156006,
		"h": 1.2637362637
	},
	{
		"stop_id": 8583754,
		"ID": 238,
		"x": -90.5872648167,
		"y": 36.217223131,
		"h": 1.2637362637
	},
	{
		"stop_id": 8504593,
		"ID": 358,
		"x": -71.7392693307,
		"y": 4.622195855,
		"h": 1.3956043956
	},
	{
		"stop_id": 8504621,
		"ID": 358,
		"x": -74.0662393147,
		"y": 2.664211963,
		"h": 1.3956043956
	},
	{
		"stop_id": 8504850,
		"ID": 358,
		"x": -73.3842570567,
		"y": 0.114181203,
		"h": 1.3956043956
	},
	{
		"stop_id": 8504858,
		"ID": 358,
		"x": -70.1572753567,
		"y": 3.477175513,
		"h": 1.3956043956
	},
	{
		"stop_id": 8504874,
		"ID": 358,
		"x": -73.3222726927,
		"y": 3.121150577,
		"h": 1.3956043956
	},
	{
		"stop_id": 8504940,
		"ID": 358,
		"x": -72.5942649497,
		"y": 3.378223423,
		"h": 1.3956043956
	},
	{
		"stop_id": 8577840,
		"ID": 358,
		"x": -72.8082552167,
		"y": -0.285760561,
		"h": 1.3956043956
	},
	{
		"stop_id": 8577854,
		"ID": 358,
		"x": -71.6562402017,
		"y": 4.140222774,
		"h": 1.3956043956
	},
	{
		"stop_id": 8577855,
		"ID": 358,
		"x": -70.8542391227,
		"y": 3.966246608,
		"h": 1.3956043956
	},
	{
		"stop_id": 8577856,
		"ID": 358,
		"x": -70.3752916807,
		"y": 3.639201055,
		"h": 1.3956043956
	},
	{
		"stop_id": 8577857,
		"ID": 358,
		"x": -69.9182401597,
		"y": 3.061212616,
		"h": 1.3956043956
	},
	{
		"stop_id": 8577858,
		"ID": 358,
		"x": -68.9222987287,
		"y": 3.473248192,
		"h": 1.3956043956
	},
	{
		"stop_id": 8588823,
		"ID": 358,
		"x": -68.2472816457,
		"y": 2.270176147,
		"h": 1.3956043956
	},
	{
		"stop_id": 8504601,
		"ID": 197,
		"x": -95.1002424977,
		"y": -10.694833907,
		"h": 1.4615384615
	},
	{
		"stop_id": 8504851,
		"ID": 197,
		"x": -97.6962275297,
		"y": -14.423771244,
		"h": 1.4615384615
	},
	{
		"stop_id": 8504895,
		"ID": 197,
		"x": -94.9862601507,
		"y": -12.887753399,
		"h": 1.4615384615
	},
	{
		"stop_id": 8504896,
		"ID": 197,
		"x": -96.1172658177,
		"y": -13.79979758,
		"h": 1.4615384615
	},
	{
		"stop_id": 8504897,
		"ID": 197,
		"x": -97.2152824167,
		"y": -14.032817868,
		"h": 1.4615384615
	},
	{
		"stop_id": 8504898,
		"ID": 197,
		"x": -96.2402920997,
		"y": -12.790748711,
		"h": 1.4615384615
	},
	{
		"stop_id": 8504968,
		"ID": 197,
		"x": -96.8162417447,
		"y": -13.548827254,
		"h": 1.4615384615
	},
	{
		"stop_id": 8504969,
		"ID": 197,
		"x": -93.8862440617,
		"y": -12.908802815,
		"h": 1.4615384615
	},
	{
		"stop_id": 8570497,
		"ID": 197,
		"x": -95.1592997277,
		"y": -9.959769555,
		"h": 1.4615384615
	},
	{
		"stop_id": 8570498,
		"ID": 197,
		"x": -95.2232248417,
		"y": -10.241759876,
		"h": 1.4615384615
	},
	{
		"stop_id": 8577670,
		"ID": 197,
		"x": -98.9572635117,
		"y": -12.968782643,
		"h": 1.4615384615
	},
	{
		"stop_id": 8577682,
		"ID": 197,
		"x": -97.9102466847,
		"y": -14.247764909,
		"h": 1.4615384615
	},
	{
		"stop_id": 8577683,
		"ID": 197,
		"x": -96.3312774617,
		"y": -13.042768764,
		"h": 1.4615384615
	},
	{
		"stop_id": 8577684,
		"ID": 197,
		"x": -94.5182950267,
		"y": -12.940849516,
		"h": 1.4615384615
	},
	{
		"stop_id": 8582575,
		"ID": 197,
		"x": -94.9922615437,
		"y": -10.944822574,
		"h": 1.4615384615
	},
	{
		"stop_id": 8504603,
		"ID": 357,
		"x": -71.8872533527,
		"y": -3.971821377,
		"h": 1.7912087912
	},
	{
		"stop_id": 8504626,
		"ID": 357,
		"x": -71.8562318487,
		"y": -1.717842297,
		"h": 1.7912087912
	},
	{
		"stop_id": 8504638,
		"ID": 357,
		"x": -73.6352491007,
		"y": -2.881778538,
		"h": 1.7912087912
	},
	{
		"stop_id": 8504868,
		"ID": 357,
		"x": -71.3962805717,
		"y": -5.868768386,
		"h": 1.7912087912
	},
	{
		"stop_id": 8504943,
		"ID": 357,
		"x": -71.0202483017,
		"y": -4.441765794,
		"h": 1.7912087912
	},
	{
		"stop_id": 8504948,
		"ID": 357,
		"x": -72.7392872557,
		"y": -3.214859118,
		"h": 1.7912087912
	},
	{
		"stop_id": 8571670,
		"ID": 357,
		"x": -69.2042729487,
		"y": -2.20078597,
		"h": 1.7912087912
	},
	{
		"stop_id": 8571686,
		"ID": 357,
		"x": -69.5672929847,
		"y": -2.571831499,
		"h": 1.7912087912
	},
	{
		"stop_id": 8571687,
		"ID": 357,
		"x": -69.7952553927,
		"y": -3.589859496,
		"h": 1.7912087912
	},
	{
		"stop_id": 8571688,
		"ID": 357,
		"x": -68.6262847627,
		"y": -4.263841838,
		"h": 1.7912087912
	},
	{
		"stop_id": 8571689,
		"ID": 357,
		"x": -69.4782640137,
		"y": -4.643812708,
		"h": 1.7912087912
	},
	{
		"stop_id": 8571690,
		"ID": 357,
		"x": -69.3922602977,
		"y": -5.039821002,
		"h": 1.7912087912
	},
	{
		"stop_id": 8577841,
		"ID": 357,
		"x": -72.1342452757,
		"y": -1.252809405,
		"h": 1.7912087912
	},
	{
		"stop_id": 8577842,
		"ID": 357,
		"x": -71.4332990087,
		"y": -2.926751239,
		"h": 1.7912087912
	},
	{
		"stop_id": 8577843,
		"ID": 357,
		"x": -71.3982647487,
		"y": -4.032829411,
		"h": 1.7912087912
	},
	{
		"stop_id": 8577844,
		"ID": 357,
		"x": -71.3372330317,
		"y": -5.529822338,
		"h": 1.7912087912
	},
	{
		"stop_id": 8577870,
		"ID": 357,
		"x": -74.1812671637,
		"y": -2.887817487,
		"h": 1.7912087912
	},
	{
		"stop_id": 8577871,
		"ID": 357,
		"x": -72.0422670577,
		"y": -3.601758797,
		"h": 1.7912087912
	},
	{
		"stop_id": 8577877,
		"ID": 357,
		"x": -72.8592328167,
		"y": -6.205788606,
		"h": 1.7912087912
	},
	{
		"stop_id": 8577878,
		"ID": 357,
		"x": -72.2842775647,
		"y": -6.065843656,
		"h": 1.7912087912
	},
	{
		"stop_id": 8580043,
		"ID": 357,
		"x": -69.3752765997,
		"y": -5.404811881,
		"h": 1.7912087912
	},
	{
		"stop_id": 8581662,
		"ID": 357,
		"x": -70.9072693637,
		"y": -4.454763089,
		"h": 1.7912087912
	},
	{
		"stop_id": 8581664,
		"ID": 357,
		"x": -70.1982584137,
		"y": -3.776815974,
		"h": 1.7912087912
	},
	{
		"stop_id": 8582569,
		"ID": 357,
		"x": -68.7942841667,
		"y": -2.451774952,
		"h": 1.7912087912
	},
	{
		"stop_id": 8582703,
		"ID": 357,
		"x": -69.2492775947,
		"y": -3.119850584,
		"h": 1.7912087912
	},
	{
		"stop_id": 8504606,
		"ID": 328,
		"x": -77.7502681037,
		"y": 0.136226421,
		"h": 1.4615384615
	},
	{
		"stop_id": 8504619,
		"ID": 328,
		"x": -76.5992831267,
		"y": -0.412754709,
		"h": 1.4615384615
	},
	{
		"stop_id": 8504620,
		"ID": 328,
		"x": -75.6952682797,
		"y": 0.94923977,
		"h": 1.4615384615
	},
	{
		"stop_id": 8504628,
		"ID": 328,
		"x": -78.1442810677,
		"y": 1.971158554,
		"h": 1.4615384615
	},
	{
		"stop_id": 8504629,
		"ID": 328,
		"x": -78.7022998947,
		"y": 0.166191767,
		"h": 1.4615384615
	},
	{
		"stop_id": 8504644,
		"ID": 328,
		"x": -78.1402270657,
		"y": -2.628788474,
		"h": 1.4615384615
	},
	{
		"stop_id": 8504645,
		"ID": 328,
		"x": -75.8372730537,
		"y": -1.686849863,
		"h": 1.4615384615
	},
	{
		"stop_id": 8504856,
		"ID": 328,
		"x": -77.2962313917,
		"y": -3.547802865,
		"h": 1.4615384615
	},
	{
		"stop_id": 8504871,
		"ID": 328,
		"x": -75.0112703277,
		"y": -3.035825779,
		"h": 1.4615384615
	},
	{
		"stop_id": 8504945,
		"ID": 328,
		"x": -74.3392577837,
		"y": 0.312213101,
		"h": 1.4615384615
	},
	{
		"stop_id": 8577839,
		"ID": 328,
		"x": -76.6192258317,
		"y": 1.550206297,
		"h": 1.4615384615
	},
	{
		"stop_id": 8577864,
		"ID": 328,
		"x": -76.9852594007,
		"y": 1.828175669,
		"h": 1.4615384615
	},
	{
		"stop_id": 8577868,
		"ID": 328,
		"x": -76.6832443307,
		"y": -0.187845088,
		"h": 1.4615384615
	},
	{
		"stop_id": 8577869,
		"ID": 328,
		"x": -75.5602703657,
		"y": -2.633855436,
		"h": 1.4615384615
	},
	{
		"stop_id": 8577874,
		"ID": 328,
		"x": -77.8112399147,
		"y": -3.155842359,
		"h": 1.4615384615
	},
	{
		"stop_id": 8504612,
		"ID": 355,
		"x": -70.8962380247,
		"y": -13.217768513,
		"h": 1.2307692308
	},
	{
		"stop_id": 8530014,
		"ID": 355,
		"x": -71.2452246107,
		"y": -13.887774885,
		"h": 1.2307692308
	},
	{
		"stop_id": 8530017,
		"ID": 355,
		"x": -70.8392553307,
		"y": -15.038786732,
		"h": 1.2307692308
	},
	{
		"stop_id": 8577849,
		"ID": 355,
		"x": -71.2652333607,
		"y": -13.747777221,
		"h": 1.2307692308
	},
	{
		"stop_id": 8577850,
		"ID": 355,
		"x": -71.4652943817,
		"y": -13.722819369,
		"h": 1.2307692308
	},
	{
		"stop_id": 8577851,
		"ID": 355,
		"x": -72.2822970617,
		"y": -14.249755873,
		"h": 1.2307692308
	},
	{
		"stop_id": 8588821,
		"ID": 355,
		"x": -72.3432835757,
		"y": -14.390809229,
		"h": 1.2307692308
	},
	{
		"stop_id": 8588822,
		"ID": 355,
		"x": -70.7542344267,
		"y": -12.354821594,
		"h": 1.2307692308
	},
	{
		"stop_id": 8504640,
		"ID": 356,
		"x": -70.8242309357,
		"y": -7.171854786,
		"h": 1.2307692308
	},
	{
		"stop_id": 8504642,
		"ID": 356,
		"x": -70.2902725407,
		"y": -10.869802957,
		"h": 1.2307692308
	},
	{
		"stop_id": 8504647,
		"ID": 356,
		"x": -69.5732255957,
		"y": -8.844786427,
		"h": 1.2307692308
	},
	{
		"stop_id": 8577845,
		"ID": 356,
		"x": -70.8922853557,
		"y": -6.571756744,
		"h": 1.2307692308
	},
	{
		"stop_id": 8577846,
		"ID": 356,
		"x": -70.5332458247,
		"y": -7.8588481,
		"h": 1.2307692308
	},
	{
		"stop_id": 8577847,
		"ID": 356,
		"x": -69.8032346217,
		"y": -9.802774522,
		"h": 1.2307692308
	},
	{
		"stop_id": 8577848,
		"ID": 356,
		"x": -70.6062250807,
		"y": -11.825827381,
		"h": 1.2307692308
	},
	{
		"stop_id": 8577879,
		"ID": 356,
		"x": -68.9062747247,
		"y": -8.808832419,
		"h": 1.2307692308
	},
	{
		"stop_id": 8504649,
		"ID": 156,
		"x": -104.7852687967,
		"y": 40.249210309,
		"h": 1.1978021978
	},
	{
		"stop_id": 8504744,
		"ID": 156,
		"x": -106.5922639207,
		"y": 36.830226703,
		"h": 1.1978021978
	},
	{
		"stop_id": 8504994,
		"ID": 156,
		"x": -105.0532375767,
		"y": 39.659223609,
		"h": 1.1978021978
	},
	{
		"stop_id": 8571889,
		"ID": 156,
		"x": -105.8642544727,
		"y": 36.838204104,
		"h": 1.1978021978
	},
	{
		"stop_id": 8571894,
		"ID": 156,
		"x": -106.3172623237,
		"y": 38.233245543,
		"h": 1.1978021978
	},
	{
		"stop_id": 8571895,
		"ID": 156,
		"x": -104.8992575247,
		"y": 39.481165405,
		"h": 1.1978021978
	},
	{
		"stop_id": 8583248,
		"ID": 156,
		"x": -106.0832463697,
		"y": 36.975212273,
		"h": 1.1978021978
	},
	{
		"stop_id": 8504676,
		"ID": 404,
		"x": -62.4422367707,
		"y": -78.969768817,
		"h": 1.1318681319
	},
	{
		"stop_id": 8504678,
		"ID": 404,
		"x": -62.9622679597,
		"y": -75.779810306,
		"h": 1.1318681319
	},
	{
		"stop_id": 8530127,
		"ID": 404,
		"x": -62.4712906367,
		"y": -78.9008322,
		"h": 1.1318681319
	},
	{
		"stop_id": 8530128,
		"ID": 404,
		"x": -62.9352436567,
		"y": -79.293796404,
		"h": 1.1318681319
	},
	{
		"stop_id": 8579533,
		"ID": 404,
		"x": -62.6922262657,
		"y": -77.369852313,
		"h": 1.1318681319
	},
	{
		"stop_id": 8504685,
		"ID": 405,
		"x": -63.3622485377,
		"y": -71.009774728,
		"h": 1.0989010989
	},
	{
		"stop_id": 8570900,
		"ID": 405,
		"x": -59.6122649557,
		"y": -70.496757036,
		"h": 1.0989010989
	},
	{
		"stop_id": 8579530,
		"ID": 405,
		"x": -63.5622544467,
		"y": -74.129858843,
		"h": 1.0989010989
	},
	{
		"stop_id": 8579531,
		"ID": 405,
		"x": -63.2122760167,
		"y": -75.069761521,
		"h": 1.0989010989
	},
	{
		"stop_id": 8504686,
		"ID": 376,
		"x": -64.8422426407,
		"y": -68.069799213,
		"h": 1.2307692308
	},
	{
		"stop_id": 8530116,
		"ID": 376,
		"x": -67.8562527597,
		"y": -72.708766379,
		"h": 1.2307692308
	},
	{
		"stop_id": 8530120,
		"ID": 376,
		"x": -65.2962508967,
		"y": -68.29183712,
		"h": 1.2307692308
	},
	{
		"stop_id": 8530125,
		"ID": 376,
		"x": -65.1672851857,
		"y": -69.727773848,
		"h": 1.2307692308
	},
	{
		"stop_id": 8570859,
		"ID": 376,
		"x": -68.5142681517,
		"y": -68.061768832,
		"h": 1.2307692308
	},
	{
		"stop_id": 8570862,
		"ID": 376,
		"x": -68.9722966397,
		"y": -68.701842664,
		"h": 1.2307692308
	},
	{
		"stop_id": 8570873,
		"ID": 376,
		"x": -68.4722668947,
		"y": -68.011805403,
		"h": 1.2307692308
	},
	{
		"stop_id": 8570874,
		"ID": 376,
		"x": -67.6192382117,
		"y": -67.581773294,
		"h": 1.2307692308
	},
	{
		"stop_id": 8504715,
		"ID": 194,
		"x": -96.5012239407,
		"y": -30.516796774,
		"h": 1.2307692308
	},
	{
		"stop_id": 8504867,
		"ID": 194,
		"x": -97.3092305867,
		"y": -30.149834103,
		"h": 1.2307692308
	},
	{
		"stop_id": 8577719,
		"ID": 194,
		"x": -99.0822865417,
		"y": -29.785855093,
		"h": 1.2307692308
	},
	{
		"stop_id": 8577720,
		"ID": 194,
		"x": -98.0102358077,
		"y": -29.960757754,
		"h": 1.2307692308
	},
	{
		"stop_id": 8577721,
		"ID": 194,
		"x": -97.5942842907,
		"y": -30.085789987,
		"h": 1.2307692308
	},
	{
		"stop_id": 8577722,
		"ID": 194,
		"x": -97.1892681287,
		"y": -30.465854919,
		"h": 1.2307692308
	},
	{
		"stop_id": 8577723,
		"ID": 194,
		"x": -96.9562431927,
		"y": -30.842827799,
		"h": 1.2307692308
	},
	{
		"stop_id": 8577724,
		"ID": 194,
		"x": -97.1812354917,
		"y": -31.183825554,
		"h": 1.2307692308
	},
	{
		"stop_id": 8504727,
		"ID": 127,
		"x": -111.2822630757,
		"y": -6.269838062,
		"h": 1.3956043956
	},
	{
		"stop_id": 8504987,
		"ID": 127,
		"x": -110.1992527177,
		"y": -1.738822004,
		"h": 1.3956043956
	},
	{
		"stop_id": 8504988,
		"ID": 127,
		"x": -110.8932260647,
		"y": -2.437755271,
		"h": 1.3956043956
	},
	{
		"stop_id": 8507672,
		"ID": 127,
		"x": -111.8692700497,
		"y": -4.97082668,
		"h": 1.3956043956
	},
	{
		"stop_id": 8507689,
		"ID": 127,
		"x": -112.3742729117,
		"y": -3.628785398,
		"h": 1.3956043956
	},
	{
		"stop_id": 8570313,
		"ID": 127,
		"x": -111.7392611847,
		"y": -4.730826628,
		"h": 1.3956043956
	},
	{
		"stop_id": 8570387,
		"ID": 127,
		"x": -111.2012570087,
		"y": -0.845797642,
		"h": 1.3956043956
	},
	{
		"stop_id": 8570389,
		"ID": 127,
		"x": -109.4782820067,
		"y": -3.577748997,
		"h": 1.3956043956
	},
	{
		"stop_id": 8570390,
		"ID": 127,
		"x": -110.0132988397,
		"y": -3.867769426,
		"h": 1.3956043956
	},
	{
		"stop_id": 8570391,
		"ID": 127,
		"x": -110.1542297497,
		"y": -2.993774915,
		"h": 1.3956043956
	},
	{
		"stop_id": 8570392,
		"ID": 127,
		"x": -111.2872500827,
		"y": -2.405800748,
		"h": 1.3956043956
	},
	{
		"stop_id": 8577616,
		"ID": 127,
		"x": -111.2022491617,
		"y": -6.075754301,
		"h": 1.3956043956
	},
	{
		"stop_id": 8588183,
		"ID": 127,
		"x": -110.2942972407,
		"y": -4.842821178,
		"h": 1.3956043956
	},
	{
		"stop_id": 8504729,
		"ID": 385,
		"x": -64.7532486117,
		"y": -20.030837497,
		"h": 1.1648351648
	},
	{
		"stop_id": 8504730,
		"ID": 385,
		"x": -65.3822792997,
		"y": -20.87480127,
		"h": 1.1648351648
	},
	{
		"stop_id": 8504732,
		"ID": 385,
		"x": -64.4602559617,
		"y": -19.091835269,
		"h": 1.1648351648
	},
	{
		"stop_id": 8507292,
		"ID": 385,
		"x": -63.4482929957,
		"y": -18.554846207,
		"h": 1.1648351648
	},
	{
		"stop_id": 8577764,
		"ID": 385,
		"x": -63.4662790747,
		"y": -18.536825931,
		"h": 1.1648351648
	},
	{
		"stop_id": 8594923,
		"ID": 385,
		"x": -64.6712566677,
		"y": -20.275805336,
		"h": 1.1648351648
	},
	{
		"stop_id": 8504731,
		"ID": 384,
		"x": -65.8312822747,
		"y": -21.213858771,
		"h": 1.4285714286
	},
	{
		"stop_id": 8504861,
		"ID": 384,
		"x": -67.4892867227,
		"y": -22.544810684,
		"h": 1.4285714286
	},
	{
		"stop_id": 8507281,
		"ID": 384,
		"x": -63.9972344177,
		"y": -23.845757762,
		"h": 1.4285714286
	},
	{
		"stop_id": 8507291,
		"ID": 384,
		"x": -64.6662838067,
		"y": -21.20482455,
		"h": 1.4285714286
	},
	{
		"stop_id": 8577762,
		"ID": 384,
		"x": -66.6982901457,
		"y": -22.447850724,
		"h": 1.4285714286
	},
	{
		"stop_id": 8577763,
		"ID": 384,
		"x": -66.1902839447,
		"y": -21.887813207,
		"h": 1.4285714286
	},
	{
		"stop_id": 8588866,
		"ID": 384,
		"x": -66.3842600077,
		"y": -22.464773582,
		"h": 1.4285714286
	},
	{
		"stop_id": 8589085,
		"ID": 384,
		"x": -64.6872957287,
		"y": -21.226817918,
		"h": 1.4285714286
	},
	{
		"stop_id": 8594784,
		"ID": 384,
		"x": -64.6292473347,
		"y": -22.375766968,
		"h": 1.4285714286
	},
	{
		"stop_id": 8594785,
		"ID": 384,
		"x": -63.6092824857,
		"y": -23.824791882,
		"h": 1.4285714286
	},
	{
		"stop_id": 8594786,
		"ID": 384,
		"x": -64.4202668187,
		"y": -25.187765873,
		"h": 1.4285714286
	},
	{
		"stop_id": 8594787,
		"ID": 384,
		"x": -64.0002587277,
		"y": -24.851806522,
		"h": 1.4285714286
	},
	{
		"stop_id": 8594788,
		"ID": 384,
		"x": -64.5762922117,
		"y": -25.75480842,
		"h": 1.4285714286
	},
	{
		"stop_id": 8595618,
		"ID": 384,
		"x": -64.7102413877,
		"y": -26.571765901,
		"h": 1.4285714286
	},
	{
		"stop_id": 8504740,
		"ID": 112,
		"x": -115.6482775447,
		"y": 24.588221802,
		"h": 1.4615384615
	},
	{
		"stop_id": 8504765,
		"ID": 112,
		"x": -113.5982869117,
		"y": 22.965159848,
		"h": 1.4615384615
	},
	{
		"stop_id": 8571818,
		"ID": 112,
		"x": -119.5042960707,
		"y": 22.533206975,
		"h": 1.4615384615
	},
	{
		"stop_id": 8571819,
		"ID": 112,
		"x": -118.7442394087,
		"y": 22.93820774,
		"h": 1.4615384615
	},
	{
		"stop_id": 8571820,
		"ID": 112,
		"x": -117.5572636177,
		"y": 23.613196147,
		"h": 1.4615384615
	},
	{
		"stop_id": 8571821,
		"ID": 112,
		"x": -116.8272470947,
		"y": 23.983154467,
		"h": 1.4615384615
	},
	{
		"stop_id": 8571822,
		"ID": 112,
		"x": -116.4372614477,
		"y": 24.223239586,
		"h": 1.4615384615
	},
	{
		"stop_id": 8571823,
		"ID": 112,
		"x": -115.1882616137,
		"y": 24.813166672,
		"h": 1.4615384615
	},
	{
		"stop_id": 8571824,
		"ID": 112,
		"x": -114.7542496827,
		"y": 25.124215604,
		"h": 1.4615384615
	},
	{
		"stop_id": 8571834,
		"ID": 112,
		"x": -114.8682305537,
		"y": 23.259168574,
		"h": 1.4615384615
	},
	{
		"stop_id": 8571835,
		"ID": 112,
		"x": -114.2202307697,
		"y": 22.983157602,
		"h": 1.4615384615
	},
	{
		"stop_id": 8571836,
		"ID": 112,
		"x": -114.1262863197,
		"y": 22.684235155,
		"h": 1.4615384615
	},
	{
		"stop_id": 8571837,
		"ID": 112,
		"x": -113.9302330587,
		"y": 22.788176687,
		"h": 1.4615384615
	},
	{
		"stop_id": 8583700,
		"ID": 112,
		"x": -117.1422421517,
		"y": 23.849212469,
		"h": 1.4615384615
	},
	{
		"stop_id": 8583701,
		"ID": 112,
		"x": -118.2162885517,
		"y": 23.29421529,
		"h": 1.4615384615
	},
	{
		"stop_id": 8504748,
		"ID": 227,
		"x": -91.9672584667,
		"y": -27.371801235,
		"h": 1.0989010989
	},
	{
		"stop_id": 8504749,
		"ID": 227,
		"x": -91.5602399537,
		"y": -26.43683384,
		"h": 1.0989010989
	},
	{
		"stop_id": 8504880,
		"ID": 227,
		"x": -90.4512665997,
		"y": -25.823857301,
		"h": 1.0989010989
	},
	{
		"stop_id": 8530024,
		"ID": 227,
		"x": -90.4342287247,
		"y": -25.955788786,
		"h": 1.0989010989
	},
	{
		"stop_id": 8504750,
		"ID": 99,
		"x": -122.9892631557,
		"y": 21.09119446,
		"h": 1.3296703297
	},
	{
		"stop_id": 8571815,
		"ID": 99,
		"x": -121.5282734507,
		"y": 22.297148944,
		"h": 1.3296703297
	},
	{
		"stop_id": 8571816,
		"ID": 99,
		"x": -121.6052308877,
		"y": 21.208185973,
		"h": 1.3296703297
	},
	{
		"stop_id": 8571817,
		"ID": 99,
		"x": -120.4162992767,
		"y": 21.934176005,
		"h": 1.3296703297
	},
	{
		"stop_id": 8571865,
		"ID": 99,
		"x": -123.3342468497,
		"y": 17.824249901,
		"h": 1.3296703297
	},
	{
		"stop_id": 8571866,
		"ID": 99,
		"x": -122.9702813347,
		"y": 18.4261824,
		"h": 1.3296703297
	},
	{
		"stop_id": 8571867,
		"ID": 99,
		"x": -123.2972406527,
		"y": 19.902203323,
		"h": 1.3296703297
	},
	{
		"stop_id": 8571882,
		"ID": 99,
		"x": -123.8982644187,
		"y": 20.556142013,
		"h": 1.3296703297
	},
	{
		"stop_id": 8583696,
		"ID": 99,
		"x": -119.9942558767,
		"y": 22.217174251,
		"h": 1.3296703297
	},
	{
		"stop_id": 8583697,
		"ID": 99,
		"x": -122.8882495747,
		"y": 21.526161769,
		"h": 1.3296703297
	},
	{
		"stop_id": 8583698,
		"ID": 99,
		"x": -123.0512669587,
		"y": 19.129237285,
		"h": 1.3296703297
	},
	{
		"stop_id": 8504753,
		"ID": 270,
		"x": -88.1342883207,
		"y": 31.892158274,
		"h": 1.2967032967
	},
	{
		"stop_id": 8504762,
		"ID": 270,
		"x": -84.2092843127,
		"y": 35.511218765,
		"h": 1.2967032967
	},
	{
		"stop_id": 8504763,
		"ID": 270,
		"x": -87.0282802067,
		"y": 35.37120166,
		"h": 1.2967032967
	},
	{
		"stop_id": 8571899,
		"ID": 270,
		"x": -84.2212363097,
		"y": 32.576248569,
		"h": 1.2967032967
	},
	{
		"stop_id": 8571902,
		"ID": 270,
		"x": -83.1252593387,
		"y": 33.988195725,
		"h": 1.2967032967
	},
	{
		"stop_id": 8571905,
		"ID": 270,
		"x": -86.7222333517,
		"y": 35.543236205,
		"h": 1.2967032967
	},
	{
		"stop_id": 8571921,
		"ID": 270,
		"x": -89.4852698557,
		"y": 33.782188634,
		"h": 1.2967032967
	},
	{
		"stop_id": 8571922,
		"ID": 270,
		"x": -88.4142663067,
		"y": 32.998249118,
		"h": 1.2967032967
	},
	{
		"stop_id": 8581575,
		"ID": 270,
		"x": -88.1132504397,
		"y": 34.403169838,
		"h": 1.2967032967
	},
	{
		"stop_id": 8581997,
		"ID": 270,
		"x": -88.1202397797,
		"y": 32.14623686,
		"h": 1.2967032967
	},
	{
		"stop_id": 8504766,
		"ID": 389,
		"x": -68.9092270077,
		"y": 6.402195344,
		"h": 1.6923076923
	},
	{
		"stop_id": 8507088,
		"ID": 389,
		"x": -66.7222930337,
		"y": 5.289193804,
		"h": 1.6923076923
	},
	{
		"stop_id": 8507089,
		"ID": 389,
		"x": -67.0532545457,
		"y": 2.772177149,
		"h": 1.6923076923
	},
	{
		"stop_id": 8507095,
		"ID": 389,
		"x": -65.5582397347,
		"y": 7.619149447,
		"h": 1.6923076923
	},
	{
		"stop_id": 8507741,
		"ID": 389,
		"x": -67.5442313797,
		"y": 5.802152577,
		"h": 1.6923076923
	},
	{
		"stop_id": 8507743,
		"ID": 389,
		"x": -65.4722827387,
		"y": 2.924181192,
		"h": 1.6923076923
	},
	{
		"stop_id": 8571661,
		"ID": 389,
		"x": -68.5682676897,
		"y": 5.767236372,
		"h": 1.6923076923
	},
	{
		"stop_id": 8571662,
		"ID": 389,
		"x": -66.7002888697,
		"y": 5.319183502,
		"h": 1.6923076923
	},
	{
		"stop_id": 8571663,
		"ID": 389,
		"x": -67.0742470957,
		"y": 4.308220613,
		"h": 1.6923076923
	},
	{
		"stop_id": 8571664,
		"ID": 389,
		"x": -66.7192858707,
		"y": 3.957165543,
		"h": 1.6923076923
	},
	{
		"stop_id": 8571665,
		"ID": 389,
		"x": -67.2912808647,
		"y": 2.288225457,
		"h": 1.6923076923
	},
	{
		"stop_id": 8571673,
		"ID": 389,
		"x": -66.8512290007,
		"y": 2.602176884,
		"h": 1.6923076923
	},
	{
		"stop_id": 8571691,
		"ID": 389,
		"x": -66.7092823797,
		"y": 2.732186567,
		"h": 1.6923076923
	},
	{
		"stop_id": 8571692,
		"ID": 389,
		"x": -64.9242663957,
		"y": 2.346154444,
		"h": 1.6923076923
	},
	{
		"stop_id": 8577859,
		"ID": 389,
		"x": -67.4912986807,
		"y": 2.533165488,
		"h": 1.6923076923
	},
	{
		"stop_id": 8577860,
		"ID": 389,
		"x": -67.0322869547,
		"y": 2.757143556,
		"h": 1.6923076923
	},
	{
		"stop_id": 8579525,
		"ID": 389,
		"x": -67.0242850437,
		"y": 4.610204597,
		"h": 1.6923076923
	},
	{
		"stop_id": 8579850,
		"ID": 389,
		"x": -66.8922762987,
		"y": 5.770202347,
		"h": 1.6923076923
	},
	{
		"stop_id": 8580763,
		"ID": 389,
		"x": -66.9732816237,
		"y": 3.707229488,
		"h": 1.6923076923
	},
	{
		"stop_id": 8581121,
		"ID": 389,
		"x": -65.9482846637,
		"y": 2.222187903,
		"h": 1.6923076923
	},
	{
		"stop_id": 8589079,
		"ID": 389,
		"x": -65.5502254947,
		"y": 7.627145743,
		"h": 1.6923076923
	},
	{
		"stop_id": 8593309,
		"ID": 389,
		"x": -65.4872716157,
		"y": 7.04822624,
		"h": 1.6923076923
	},
	{
		"stop_id": 8504786,
		"ID": 168,
		"x": -100.2362693467,
		"y": -20.426817703,
		"h": 1.4285714286
	},
	{
		"stop_id": 8504787,
		"ID": 168,
		"x": -99.0782555107,
		"y": -21.474841288,
		"h": 1.4285714286
	},
	{
		"stop_id": 8504788,
		"ID": 168,
		"x": -99.5422953667,
		"y": -22.016838036,
		"h": 1.4285714286
	},
	{
		"stop_id": 8504798,
		"ID": 168,
		"x": -101.6422712207,
		"y": -22.994825441,
		"h": 1.4285714286
	},
	{
		"stop_id": 8504891,
		"ID": 168,
		"x": -103.5532788267,
		"y": -21.379785009,
		"h": 1.4285714286
	},
	{
		"stop_id": 8504893,
		"ID": 168,
		"x": -102.3012334717,
		"y": -20.160829773,
		"h": 1.4285714286
	},
	{
		"stop_id": 8504971,
		"ID": 168,
		"x": -100.2032712707,
		"y": -19.158828608,
		"h": 1.4285714286
	},
	{
		"stop_id": 8570453,
		"ID": 168,
		"x": -102.4572366167,
		"y": -23.327808616,
		"h": 1.4285714286
	},
	{
		"stop_id": 8570454,
		"ID": 168,
		"x": -101.0102466717,
		"y": -22.35876496,
		"h": 1.4285714286
	},
	{
		"stop_id": 8570455,
		"ID": 168,
		"x": -99.5662878067,
		"y": -21.094758909,
		"h": 1.4285714286
	},
	{
		"stop_id": 8570456,
		"ID": 168,
		"x": -99.3692355257,
		"y": -22.662760564,
		"h": 1.4285714286
	},
	{
		"stop_id": 8577674,
		"ID": 168,
		"x": -101.0582401847,
		"y": -19.614791937,
		"h": 1.4285714286
	},
	{
		"stop_id": 8577676,
		"ID": 168,
		"x": -103.2192956787,
		"y": -21.150761782,
		"h": 1.4285714286
	},
	{
		"stop_id": 8588865,
		"ID": 168,
		"x": -102.0132384987,
		"y": -20.081824978,
		"h": 1.4285714286
	},
	{
		"stop_id": 8504790,
		"ID": 167,
		"x": -103.9282932967,
		"y": -27.471752835,
		"h": 1.1648351648
	},
	{
		"stop_id": 8570443,
		"ID": 167,
		"x": -103.1172979187,
		"y": -27.04477681,
		"h": 1.1648351648
	},
	{
		"stop_id": 8570444,
		"ID": 167,
		"x": -101.4872322307,
		"y": -25.409819265,
		"h": 1.1648351648
	},
	{
		"stop_id": 8570445,
		"ID": 167,
		"x": -101.2112933837,
		"y": -25.334803959,
		"h": 1.1648351648
	},
	{
		"stop_id": 8580690,
		"ID": 167,
		"x": -103.2622693997,
		"y": -27.395798368,
		"h": 1.1648351648
	},
	{
		"stop_id": 8593760,
		"ID": 167,
		"x": -102.1752785127,
		"y": -29.450856474,
		"h": 1.1648351648
	},
	{
		"stop_id": 8504797,
		"ID": 294,
		"x": -81.1792446127,
		"y": -17.781806834,
		"h": 1.1648351648
	},
	{
		"stop_id": 8570507,
		"ID": 294,
		"x": -80.6432646087,
		"y": -16.985857678,
		"h": 1.1648351648
	},
	{
		"stop_id": 8570508,
		"ID": 294,
		"x": -80.5672931767,
		"y": -16.694753853,
		"h": 1.1648351648
	},
	{
		"stop_id": 8570509,
		"ID": 294,
		"x": -80.1422726957,
		"y": -16.844848746,
		"h": 1.1648351648
	},
	{
		"stop_id": 8570510,
		"ID": 294,
		"x": -78.9172939157,
		"y": -16.094856056,
		"h": 1.1648351648
	},
	{
		"stop_id": 8582578,
		"ID": 294,
		"x": -81.3482789857,
		"y": -17.93883366,
		"h": 1.1648351648
	},
	{
		"stop_id": 8504852,
		"ID": 293,
		"x": -80.6582840287,
		"y": -19.508849623,
		"h": 1.3626373626
	},
	{
		"stop_id": 8504916,
		"ID": 293,
		"x": -81.9562253647,
		"y": -19.236816748,
		"h": 1.3626373626
	},
	{
		"stop_id": 8504917,
		"ID": 293,
		"x": -83.3632879787,
		"y": -19.978805775,
		"h": 1.3626373626
	},
	{
		"stop_id": 8504920,
		"ID": 293,
		"x": -78.3212768957,
		"y": -20.765853136,
		"h": 1.3626373626
	},
	{
		"stop_id": 8530021,
		"ID": 293,
		"x": -80.3982274207,
		"y": -19.484851497,
		"h": 1.3626373626
	},
	{
		"stop_id": 8577752,
		"ID": 293,
		"x": -83.8822377547,
		"y": -20.309792422,
		"h": 1.3626373626
	},
	{
		"stop_id": 8577753,
		"ID": 293,
		"x": -82.7382698267,
		"y": -19.618834726,
		"h": 1.3626373626
	},
	{
		"stop_id": 8577754,
		"ID": 293,
		"x": -81.1192669477,
		"y": -19.298782977,
		"h": 1.3626373626
	},
	{
		"stop_id": 8577755,
		"ID": 293,
		"x": -80.3432686807,
		"y": -19.918813755,
		"h": 1.3626373626
	},
	{
		"stop_id": 8577756,
		"ID": 293,
		"x": -80.1342767547,
		"y": -20.160761362,
		"h": 1.3626373626
	},
	{
		"stop_id": 8577757,
		"ID": 293,
		"x": -79.4182632987,
		"y": -20.424844718,
		"h": 1.3626373626
	},
	{
		"stop_id": 8583867,
		"ID": 293,
		"x": -80.5232967817,
		"y": -19.546783088,
		"h": 1.3626373626
	},
	{
		"stop_id": 8504859,
		"ID": 324,
		"x": -75.1102745367,
		"y": -21.613826919,
		"h": 1.0659340659
	},
	{
		"stop_id": 8577758,
		"ID": 324,
		"x": -77.8022679177,
		"y": -21.340839303,
		"h": 1.0659340659
	},
	{
		"stop_id": 8577759,
		"ID": 324,
		"x": -76.6272905167,
		"y": -21.750806624,
		"h": 1.0659340659
	},
	{
		"stop_id": 8504860,
		"ID": 354,
		"x": -72.2092958427,
		"y": -20.375853562,
		"h": 1.1318681319
	},
	{
		"stop_id": 8504921,
		"ID": 354,
		"x": -73.9992341657,
		"y": -21.105770429,
		"h": 1.1318681319
	},
	{
		"stop_id": 8504938,
		"ID": 354,
		"x": -71.3492795377,
		"y": -20.44984552,
		"h": 1.1318681319
	},
	{
		"stop_id": 8577760,
		"ID": 354,
		"x": -70.0342444377,
		"y": -20.56275785,
		"h": 1.1318681319
	},
	{
		"stop_id": 8577761,
		"ID": 354,
		"x": -68.8972314247,
		"y": -22.137835457,
		"h": 1.1318681319
	},
	{
		"stop_id": 8504863,
		"ID": 229,
		"x": -88.3752739107,
		"y": -15.24977404,
		"h": 1.1318681319
	},
	{
		"stop_id": 8577777,
		"ID": 229,
		"x": -90.4922276307,
		"y": -13.706823553,
		"h": 1.1318681319
	},
	{
		"stop_id": 8588597,
		"ID": 229,
		"x": -89.6362727177,
		"y": -13.671806371,
		"h": 1.1318681319
	},
	{
		"stop_id": 8588598,
		"ID": 229,
		"x": -91.4402672457,
		"y": -13.31078852,
		"h": 1.1318681319
	},
	{
		"stop_id": 8588601,
		"ID": 229,
		"x": -89.2352289127,
		"y": -13.784852868,
		"h": 1.1318681319
	},
	{
		"stop_id": 8504873,
		"ID": 295,
		"x": -82.7122260827,
		"y": -10.7677928,
		"h": 1.4615384615
	},
	{
		"stop_id": 8504928,
		"ID": 295,
		"x": -81.2022622777,
		"y": -8.37184813,
		"h": 1.4615384615
	},
	{
		"stop_id": 8504929,
		"ID": 295,
		"x": -80.6782705367,
		"y": -6.768776361,
		"h": 1.4615384615
	},
	{
		"stop_id": 8504931,
		"ID": 295,
		"x": -83.3942781287,
		"y": -11.584772888,
		"h": 1.4615384615
	},
	{
		"stop_id": 8504933,
		"ID": 295,
		"x": -82.8092362547,
		"y": -7.366793254,
		"h": 1.4615384615
	},
	{
		"stop_id": 8504939,
		"ID": 295,
		"x": -81.7182552557,
		"y": -9.720772632,
		"h": 1.4615384615
	},
	{
		"stop_id": 8577746,
		"ID": 295,
		"x": -82.2522961777,
		"y": -10.438818524,
		"h": 1.4615384615
	},
	{
		"stop_id": 8577747,
		"ID": 295,
		"x": -83.0452875757,
		"y": -11.287769188,
		"h": 1.4615384615
	},
	{
		"stop_id": 8577768,
		"ID": 295,
		"x": -82.8932560827,
		"y": -6.520812329,
		"h": 1.4615384615
	},
	{
		"stop_id": 8577769,
		"ID": 295,
		"x": -83.1392436607,
		"y": -7.093815186,
		"h": 1.4615384615
	},
	{
		"stop_id": 8577770,
		"ID": 295,
		"x": -81.7482561157,
		"y": -7.671838538,
		"h": 1.4615384615
	},
	{
		"stop_id": 8588596,
		"ID": 295,
		"x": -82.3222740987,
		"y": -7.604774455,
		"h": 1.4615384615
	},
	{
		"stop_id": 8595877,
		"ID": 295,
		"x": -82.9222270477,
		"y": -11.035785743,
		"h": 1.4615384615
	},
	{
		"stop_id": 8595972,
		"ID": 295,
		"x": -81.8222272237,
		"y": -11.699840791,
		"h": 1.4615384615
	},
	{
		"stop_id": 8595973,
		"ID": 295,
		"x": -81.4512501667,
		"y": -11.921755904,
		"h": 1.4615384615
	},
	{
		"stop_id": 8504875,
		"ID": 387,
		"x": -66.3852241737,
		"y": -9.094773445,
		"h": 1.0989010989
	},
	{
		"stop_id": 8577880,
		"ID": 387,
		"x": -67.2632360287,
		"y": -8.709754236,
		"h": 1.0989010989
	},
	{
		"stop_id": 8577881,
		"ID": 387,
		"x": -65.2432568747,
		"y": -9.042805934,
		"h": 1.0989010989
	},
	{
		"stop_id": 8589274,
		"ID": 387,
		"x": -63.2722841677,
		"y": -6.169751564,
		"h": 1.0989010989
	},
	{
		"stop_id": 8504887,
		"ID": 201,
		"x": -94.7072580987,
		"y": 10.735222495,
		"h": 1.3956043956
	},
	{
		"stop_id": 8504973,
		"ID": 201,
		"x": -95.6502289107,
		"y": 9.448234714,
		"h": 1.3956043956
	},
	{
		"stop_id": 8570412,
		"ID": 201,
		"x": -96.5612820577,
		"y": 9.247232252,
		"h": 1.3956043956
	},
	{
		"stop_id": 8570413,
		"ID": 201,
		"x": -96.7832927287,
		"y": 9.78423143,
		"h": 1.3956043956
	},
	{
		"stop_id": 8577641,
		"ID": 201,
		"x": -97.2422645547,
		"y": 8.630247815,
		"h": 1.3956043956
	},
	{
		"stop_id": 8577643,
		"ID": 201,
		"x": -95.2872451397,
		"y": 9.853170268,
		"h": 1.3956043956
	},
	{
		"stop_id": 8577829,
		"ID": 201,
		"x": -94.5442580247,
		"y": 10.444222475,
		"h": 1.3956043956
	},
	{
		"stop_id": 8577830,
		"ID": 201,
		"x": -94.9992979967,
		"y": 10.982186623,
		"h": 1.3956043956
	},
	{
		"stop_id": 8577831,
		"ID": 201,
		"x": -95.2232707907,
		"y": 13.186162298,
		"h": 1.3956043956
	},
	{
		"stop_id": 8577832,
		"ID": 201,
		"x": -95.5702805487,
		"y": 13.44015385,
		"h": 1.3956043956
	},
	{
		"stop_id": 8577833,
		"ID": 201,
		"x": -96.7092495617,
		"y": 13.009201556,
		"h": 1.3956043956
	},
	{
		"stop_id": 8577834,
		"ID": 201,
		"x": -97.8562977967,
		"y": 11.352177971,
		"h": 1.3956043956
	},
	{
		"stop_id": 8595536,
		"ID": 201,
		"x": -98.4612520387,
		"y": 12.369186932,
		"h": 1.3956043956
	},
	{
		"stop_id": 8504993,
		"ID": 361,
		"x": -73.4272319767,
		"y": 17.573144477,
		"h": 1.4615384615
	},
	{
		"stop_id": 8507776,
		"ID": 361,
		"x": -71.3032409137,
		"y": 22.316201823,
		"h": 1.4615384615
	},
	{
		"stop_id": 8507977,
		"ID": 361,
		"x": -69.6292834397,
		"y": 21.963202602,
		"h": 1.4615384615
	},
	{
		"stop_id": 8571348,
		"ID": 361,
		"x": -68.9292462917,
		"y": 20.823232766,
		"h": 1.4615384615
	},
	{
		"stop_id": 8571349,
		"ID": 361,
		"x": -69.3672490307,
		"y": 21.295184959,
		"h": 1.4615384615
	},
	{
		"stop_id": 8571445,
		"ID": 361,
		"x": -69.1812944737,
		"y": 17.729178317,
		"h": 1.4615384615
	},
	{
		"stop_id": 8571447,
		"ID": 361,
		"x": -70.3472943767,
		"y": 17.455224131,
		"h": 1.4615384615
	},
	{
		"stop_id": 8571448,
		"ID": 361,
		"x": -72.4372339117,
		"y": 16.896247953,
		"h": 1.4615384615
	},
	{
		"stop_id": 8571456,
		"ID": 361,
		"x": -73.2272892867,
		"y": 17.825156487,
		"h": 1.4615384615
	},
	{
		"stop_id": 8571457,
		"ID": 361,
		"x": -72.3932915297,
		"y": 18.295241602,
		"h": 1.4615384615
	},
	{
		"stop_id": 8571458,
		"ID": 361,
		"x": -72.0502322277,
		"y": 18.739204773,
		"h": 1.4615384615
	},
	{
		"stop_id": 8571459,
		"ID": 361,
		"x": -71.9222646737,
		"y": 19.123148498,
		"h": 1.4615384615
	},
	{
		"stop_id": 8571460,
		"ID": 361,
		"x": -70.9412531627,
		"y": 18.490207001,
		"h": 1.4615384615
	},
	{
		"stop_id": 8581023,
		"ID": 361,
		"x": -70.4642568077,
		"y": 18.026186382,
		"h": 1.4615384615
	},
	{
		"stop_id": 8583315,
		"ID": 361,
		"x": -73.3722859217,
		"y": 17.997247026,
		"h": 1.4615384615
	},
	{
		"stop_id": 8505000,
		"ID": 823,
		"x": 6.4807082473,
		"y": 28.813166286,
		"h": 5.3186813187
	},
	{
		"stop_id": 8508219,
		"ID": 823,
		"x": 2.4447366623,
		"y": 29.091246495,
		"h": 5.3186813187
	},
	{
		"stop_id": 8508321,
		"ID": 823,
		"x": 5.9777286533,
		"y": 27.130238376,
		"h": 5.3186813187
	},
	{
		"stop_id": 8508450,
		"ID": 823,
		"x": 6.4857618253,
		"y": 28.878151353,
		"h": 5.3186813187
	},
	{
		"stop_id": 8508453,
		"ID": 823,
		"x": 4.0507549553,
		"y": 26.591227795,
		"h": 5.3186813187
	},
	{
		"stop_id": 8508492,
		"ID": 823,
		"x": 6.4787152713,
		"y": 28.924212686,
		"h": 5.3186813187
	},
	{
		"stop_id": 8530358,
		"ID": 823,
		"x": 5.3337093103,
		"y": 28.918168016,
		"h": 5.3186813187
	},
	{
		"stop_id": 8530359,
		"ID": 823,
		"x": 3.9557621063,
		"y": 27.350231207,
		"h": 5.3186813187
	},
	{
		"stop_id": 8530361,
		"ID": 823,
		"x": 3.6267105313,
		"y": 28.081174546,
		"h": 5.3186813187
	},
	{
		"stop_id": 8573022,
		"ID": 823,
		"x": 6.0117217913,
		"y": 28.542146635,
		"h": 5.3186813187
	},
	{
		"stop_id": 8573023,
		"ID": 823,
		"x": 5.9877247553,
		"y": 28.699201189,
		"h": 5.3186813187
	},
	{
		"stop_id": 8573024,
		"ID": 823,
		"x": 5.7047624083,
		"y": 29.001165974,
		"h": 5.3186813187
	},
	{
		"stop_id": 8573027,
		"ID": 823,
		"x": 4.3557416273,
		"y": 30.501223118,
		"h": 5.3186813187
	},
	{
		"stop_id": 8573043,
		"ID": 823,
		"x": 5.8027750123,
		"y": 27.69521663,
		"h": 5.3186813187
	},
	{
		"stop_id": 8573044,
		"ID": 823,
		"x": 3.1517621393,
		"y": 27.01016562,
		"h": 5.3186813187
	},
	{
		"stop_id": 8573045,
		"ID": 823,
		"x": 2.3367536443,
		"y": 26.996181559,
		"h": 5.3186813187
	},
	{
		"stop_id": 8573046,
		"ID": 823,
		"x": 2.0757578543,
		"y": 26.641147086,
		"h": 5.3186813187
	},
	{
		"stop_id": 8573047,
		"ID": 823,
		"x": 1.8067219313,
		"y": 26.318172165,
		"h": 5.3186813187
	},
	{
		"stop_id": 8573048,
		"ID": 823,
		"x": 1.4937558213,
		"y": 26.065245832,
		"h": 5.3186813187
	},
	{
		"stop_id": 8580573,
		"ID": 823,
		"x": 3.9677227253,
		"y": 27.013153459,
		"h": 5.3186813187
	},
	{
		"stop_id": 8581812,
		"ID": 823,
		"x": 4.9087270953,
		"y": 27.12822995,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589697,
		"ID": 823,
		"x": 3.4877688253,
		"y": 26.9712471,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589698,
		"ID": 823,
		"x": 3.9287608073,
		"y": 26.433162649,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589699,
		"ID": 823,
		"x": 4.5177589023,
		"y": 27.76017207,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589700,
		"ID": 823,
		"x": 5.2107645523,
		"y": 27.822155856,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589701,
		"ID": 823,
		"x": 4.8217559353,
		"y": 27.621145458,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589703,
		"ID": 823,
		"x": 3.4407004663,
		"y": 27.396229518,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589704,
		"ID": 823,
		"x": 3.1957266713,
		"y": 27.108244151,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589705,
		"ID": 823,
		"x": 4.4787617113,
		"y": 26.631174454,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589706,
		"ID": 823,
		"x": 3.9947286313,
		"y": 27.701194585,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589707,
		"ID": 823,
		"x": 4.2387402523,
		"y": 27.754170939,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589709,
		"ID": 823,
		"x": 4.1687686263,
		"y": 27.113141271,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589710,
		"ID": 823,
		"x": 5.4487475773,
		"y": 25.949160783,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589711,
		"ID": 823,
		"x": 4.4857028513,
		"y": 26.883180501,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589712,
		"ID": 823,
		"x": 5.5797497173,
		"y": 27.53823093,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589713,
		"ID": 823,
		"x": 4.7187683663,
		"y": 26.010160721,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589714,
		"ID": 823,
		"x": 4.5367018383,
		"y": 26.432232406,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589715,
		"ID": 823,
		"x": 4.3747240233,
		"y": 26.996167465,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589716,
		"ID": 823,
		"x": 4.5127431703,
		"y": 26.772181604,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589717,
		"ID": 823,
		"x": 3.6357044003,
		"y": 26.66218351,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589718,
		"ID": 823,
		"x": 4.0157274963,
		"y": 26.68924657,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589719,
		"ID": 823,
		"x": 3.7477363253,
		"y": 26.535185629,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589720,
		"ID": 823,
		"x": 4.3437248683,
		"y": 26.839183345,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589723,
		"ID": 823,
		"x": 5.1417089183,
		"y": 27.330214712,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589724,
		"ID": 823,
		"x": 5.1107728703,
		"y": 26.505152259,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589725,
		"ID": 823,
		"x": 4.1677598763,
		"y": 26.97315627,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589726,
		"ID": 823,
		"x": 5.4667444643,
		"y": 26.570180803,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589727,
		"ID": 823,
		"x": 4.6357327423,
		"y": 27.526189214,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589728,
		"ID": 823,
		"x": 3.8657248503,
		"y": 27.511146946,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589729,
		"ID": 823,
		"x": 4.4417308963,
		"y": 27.508200058,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589730,
		"ID": 823,
		"x": 4.2487054643,
		"y": 27.406176405,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589731,
		"ID": 823,
		"x": 5.6827640353,
		"y": 26.080245074,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589732,
		"ID": 823,
		"x": 4.0067420943,
		"y": 26.598206331,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589734,
		"ID": 823,
		"x": 4.5997300003,
		"y": 26.248243777,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589736,
		"ID": 823,
		"x": 4.7257313643,
		"y": 27.040197038,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589737,
		"ID": 823,
		"x": 3.6927486683,
		"y": 26.995214163,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589738,
		"ID": 823,
		"x": 3.3357344083,
		"y": 26.8642403,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589739,
		"ID": 823,
		"x": 4.8847367843,
		"y": 25.813168397,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589740,
		"ID": 823,
		"x": 4.9267206183,
		"y": 26.583203256,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589741,
		"ID": 823,
		"x": 3.6967646253,
		"y": 26.939222771,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589742,
		"ID": 823,
		"x": 5.6527698213,
		"y": 26.278148394,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589743,
		"ID": 823,
		"x": 3.4687238943,
		"y": 26.688206701,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589744,
		"ID": 823,
		"x": 5.2647398323,
		"y": 27.758148714,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589745,
		"ID": 823,
		"x": 5.3497413393,
		"y": 25.665240878,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589746,
		"ID": 823,
		"x": 3.7347587373,
		"y": 27.626156193,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589747,
		"ID": 823,
		"x": 3.2737342393,
		"y": 27.32219725,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589748,
		"ID": 823,
		"x": 4.6547145983,
		"y": 26.718234088,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589749,
		"ID": 823,
		"x": 2.4757492933,
		"y": 29.090235806,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589750,
		"ID": 823,
		"x": 2.5597684473,
		"y": 28.852189361,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589751,
		"ID": 823,
		"x": 3.0797548113,
		"y": 28.874209601,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589752,
		"ID": 823,
		"x": 3.4467100693,
		"y": 29.906160397,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589753,
		"ID": 823,
		"x": 3.7067690823,
		"y": 30.192207018,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589755,
		"ID": 823,
		"x": 3.3847486153,
		"y": 29.42921218,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589756,
		"ID": 823,
		"x": 4.2227379623,
		"y": 30.365156254,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589757,
		"ID": 823,
		"x": 3.2427212653,
		"y": 28.776200826,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589758,
		"ID": 823,
		"x": 2.6997343203,
		"y": 28.642190785,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589759,
		"ID": 823,
		"x": 4.3447463193,
		"y": 29.057217142,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589760,
		"ID": 823,
		"x": 3.7427551013,
		"y": 28.924145369,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589761,
		"ID": 823,
		"x": 3.5307556453,
		"y": 28.866191692,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589762,
		"ID": 823,
		"x": 3.0847166283,
		"y": 29.182227878,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589763,
		"ID": 823,
		"x": 3.9787407453,
		"y": 28.984141742,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589764,
		"ID": 823,
		"x": 2.4317553393,
		"y": 29.39618628,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589765,
		"ID": 823,
		"x": 2.8697416353,
		"y": 28.684219847,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589766,
		"ID": 823,
		"x": 5.9387655493,
		"y": 27.148153833,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589767,
		"ID": 823,
		"x": 5.4217388863,
		"y": 26.96014993,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589768,
		"ID": 823,
		"x": 5.4837568513,
		"y": 28.476201123,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589770,
		"ID": 823,
		"x": 6.0627081113,
		"y": 29.479175209,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589771,
		"ID": 823,
		"x": 6.0457621503,
		"y": 27.564142851,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589773,
		"ID": 823,
		"x": 5.6667106413,
		"y": 29.221217638,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589774,
		"ID": 823,
		"x": 6.6097607393,
		"y": 28.00521293,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589775,
		"ID": 823,
		"x": 6.3107537583,
		"y": 28.405142335,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589784,
		"ID": 823,
		"x": 5.9197037643,
		"y": 29.590223895,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589785,
		"ID": 823,
		"x": 5.1367691643,
		"y": 29.761209105,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589788,
		"ID": 823,
		"x": 5.6827277023,
		"y": 29.548150348,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589789,
		"ID": 823,
		"x": 5.1487118043,
		"y": 28.398167406,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589791,
		"ID": 823,
		"x": 5.7707375983,
		"y": 29.77414439,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589792,
		"ID": 823,
		"x": 4.8427689793,
		"y": 29.330198727,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589793,
		"ID": 823,
		"x": 5.4177743623,
		"y": 29.069178273,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589794,
		"ID": 823,
		"x": 5.3417310023,
		"y": 28.552141623,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589796,
		"ID": 823,
		"x": 5.8687145693,
		"y": 28.755148202,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589798,
		"ID": 823,
		"x": 6.3467186493,
		"y": 27.292189528,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589799,
		"ID": 823,
		"x": 5.8327452723,
		"y": 29.932145378,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589800,
		"ID": 823,
		"x": 4.6027078963,
		"y": 29.192187114,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589801,
		"ID": 823,
		"x": 6.1957213903,
		"y": 28.65724773,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589802,
		"ID": 823,
		"x": 5.5117311103,
		"y": 29.628216095,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589807,
		"ID": 823,
		"x": 5.0467625733,
		"y": 29.227235713,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589812,
		"ID": 823,
		"x": 6.2367734793,
		"y": 27.467191739,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589813,
		"ID": 823,
		"x": 6.0357373263,
		"y": 28.342177122,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589815,
		"ID": 823,
		"x": 5.6567412143,
		"y": 29.361194632,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589816,
		"ID": 823,
		"x": 4.8237038293,
		"y": 28.115246761,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589817,
		"ID": 823,
		"x": 4.9247297713,
		"y": 28.197168522,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589818,
		"ID": 823,
		"x": 4.8487462803,
		"y": 28.329204405,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589819,
		"ID": 823,
		"x": 4.9527099193,
		"y": 28.406155461,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589823,
		"ID": 823,
		"x": 5.9777353823,
		"y": 28.040241364,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589824,
		"ID": 823,
		"x": 4.8547164783,
		"y": 29.665200824,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589835,
		"ID": 823,
		"x": 5.5157765553,
		"y": 28.175144031,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589836,
		"ID": 823,
		"x": 5.1377434163,
		"y": 29.469150912,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589837,
		"ID": 823,
		"x": 6.3407420953,
		"y": 27.708156626,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589838,
		"ID": 823,
		"x": 5.6717441623,
		"y": 27.889231498,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589839,
		"ID": 823,
		"x": 5.3927241163,
		"y": 27.842151087,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589840,
		"ID": 823,
		"x": 5.3837393833,
		"y": 28.275207608,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589843,
		"ID": 823,
		"x": 5.2967477703,
		"y": 28.454146581,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589844,
		"ID": 823,
		"x": 5.5427025933,
		"y": 29.929185036,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589847,
		"ID": 823,
		"x": 6.7627449883,
		"y": 28.060171782,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589851,
		"ID": 823,
		"x": 5.7117031563,
		"y": 28.694164234,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589852,
		"ID": 823,
		"x": 6.0147739133,
		"y": 26.700160697,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589860,
		"ID": 823,
		"x": 2.6477097713,
		"y": 27.106156756,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589861,
		"ID": 823,
		"x": 4.6487292283,
		"y": 29.708223012,
		"h": 5.3186813187
	},
	{
		"stop_id": 8589862,
		"ID": 823,
		"x": 4.4837559163,
		"y": 30.324157418,
		"h": 5.3186813187
	},
	{
		"stop_id": 8590364,
		"ID": 823,
		"x": 3.0477258583,
		"y": 30.12619433,
		"h": 5.3186813187
	},
	{
		"stop_id": 8590365,
		"ID": 823,
		"x": 3.3237520283,
		"y": 30.584164624,
		"h": 5.3186813187
	},
	{
		"stop_id": 8595906,
		"ID": 823,
		"x": 4.3717573163,
		"y": 30.912204207,
		"h": 5.3186813187
	},
	{
		"stop_id": 8505001,
		"ID": 873,
		"x": 12.0177390823,
		"y": 28.87422257,
		"h": 2.0549450549
	},
	{
		"stop_id": 8505011,
		"ID": 873,
		"x": 13.9687622243,
		"y": 30.845142734,
		"h": 2.0549450549
	},
	{
		"stop_id": 8505018,
		"ID": 873,
		"x": 11.3467548773,
		"y": 28.299164365,
		"h": 2.0549450549
	},
	{
		"stop_id": 8505669,
		"ID": 873,
		"x": 15.6667408473,
		"y": 29.610246641,
		"h": 2.0549450549
	},
	{
		"stop_id": 8505670,
		"ID": 873,
		"x": 15.8657211533,
		"y": 26.866246579,
		"h": 2.0549450549
	},
	{
		"stop_id": 8508462,
		"ID": 873,
		"x": 13.5997357783,
		"y": 26.308178648,
		"h": 2.0549450549
	},
	{
		"stop_id": 8508463,
		"ID": 873,
		"x": 15.8567007293,
		"y": 26.840226993,
		"h": 2.0549450549
	},
	{
		"stop_id": 8508484,
		"ID": 873,
		"x": 11.7477170343,
		"y": 28.255149012,
		"h": 2.0549450549
	},
	{
		"stop_id": 8508486,
		"ID": 873,
		"x": 13.8487661133,
		"y": 30.42417167,
		"h": 2.0549450549
	},
	{
		"stop_id": 8508487,
		"ID": 873,
		"x": 15.3367343963,
		"y": 29.58718099,
		"h": 2.0549450549
	},
	{
		"stop_id": 8577191,
		"ID": 873,
		"x": 10.5257208913,
		"y": 28.14023005,
		"h": 2.0549450549
	},
	{
		"stop_id": 8577192,
		"ID": 873,
		"x": 10.8597465243,
		"y": 28.268141136,
		"h": 2.0549450549
	},
	{
		"stop_id": 8577193,
		"ID": 873,
		"x": 11.2007065823,
		"y": 28.374139869,
		"h": 2.0549450549
	},
	{
		"stop_id": 8577194,
		"ID": 873,
		"x": 11.4367101633,
		"y": 28.505143284,
		"h": 2.0549450549
	},
	{
		"stop_id": 8577195,
		"ID": 873,
		"x": 11.7867506813,
		"y": 28.815189872,
		"h": 2.0549450549
	},
	{
		"stop_id": 8577196,
		"ID": 873,
		"x": 12.0277207303,
		"y": 29.017210167,
		"h": 2.0549450549
	},
	{
		"stop_id": 8577197,
		"ID": 873,
		"x": 12.6447714113,
		"y": 29.460165231,
		"h": 2.0549450549
	},
	{
		"stop_id": 8577198,
		"ID": 873,
		"x": 12.1017225533,
		"y": 29.26414478,
		"h": 2.0549450549
	},
	{
		"stop_id": 8577199,
		"ID": 873,
		"x": 12.0387501913,
		"y": 29.641179483,
		"h": 2.0549450549
	},
	{
		"stop_id": 8577200,
		"ID": 873,
		"x": 12.2127593603,
		"y": 30.194179538,
		"h": 2.0549450549
	},
	{
		"stop_id": 8577211,
		"ID": 873,
		"x": 15.2767502473,
		"y": 28.587236192,
		"h": 2.0549450549
	},
	{
		"stop_id": 8577212,
		"ID": 873,
		"x": 15.0737602273,
		"y": 27.297205444,
		"h": 2.0549450549
	},
	{
		"stop_id": 8577213,
		"ID": 873,
		"x": 15.2907556273,
		"y": 27.087241464,
		"h": 2.0549450549
	},
	{
		"stop_id": 8587642,
		"ID": 873,
		"x": 13.8307556243,
		"y": 30.529238382,
		"h": 2.0549450549
	},
	{
		"stop_id": 8589059,
		"ID": 873,
		"x": 15.5067477763,
		"y": 27.012246704,
		"h": 2.0549450549
	},
	{
		"stop_id": 8589858,
		"ID": 873,
		"x": 10.9527135853,
		"y": 28.779227776,
		"h": 2.0549450549
	},
	{
		"stop_id": 8589859,
		"ID": 873,
		"x": 11.1647403093,
		"y": 28.497233796,
		"h": 2.0549450549
	},
	{
		"stop_id": 8591701,
		"ID": 873,
		"x": 13.5387048933,
		"y": 30.234234324,
		"h": 2.0549450549
	},
	{
		"stop_id": 8591706,
		"ID": 873,
		"x": 16.0377100243,
		"y": 26.947145535,
		"h": 2.0549450549
	},
	{
		"stop_id": 8592430,
		"ID": 873,
		"x": 15.8487570783,
		"y": 26.933185118,
		"h": 2.0549450549
	},
	{
		"stop_id": 8592431,
		"ID": 873,
		"x": 15.7797714903,
		"y": 26.948210213,
		"h": 2.0549450549
	},
	{
		"stop_id": 8592432,
		"ID": 873,
		"x": 16.0117475413,
		"y": 27.016192954,
		"h": 2.0549450549
	},
	{
		"stop_id": 8595627,
		"ID": 873,
		"x": 16.1837356253,
		"y": 26.995142809,
		"h": 2.0549450549
	},
	{
		"stop_id": 8505003,
		"ID": 902,
		"x": 18.0067670093,
		"y": 33.560165785,
		"h": 1.6923076923
	},
	{
		"stop_id": 8505067,
		"ID": 902,
		"x": 19.1237171063,
		"y": 28.642211028,
		"h": 1.6923076923
	},
	{
		"stop_id": 8505068,
		"ID": 902,
		"x": 18.9417208463,
		"y": 29.355155125,
		"h": 1.6923076923
	},
	{
		"stop_id": 8505069,
		"ID": 902,
		"x": 19.7747633383,
		"y": 29.532203117,
		"h": 1.6923076923
	},
	{
		"stop_id": 8505074,
		"ID": 902,
		"x": 18.3827381483,
		"y": 28.272226261,
		"h": 1.6923076923
	},
	{
		"stop_id": 8505075,
		"ID": 902,
		"x": 18.2097047793,
		"y": 28.724141373,
		"h": 1.6923076923
	},
	{
		"stop_id": 8505088,
		"ID": 902,
		"x": 18.2877170553,
		"y": 31.095240517,
		"h": 1.6923076923
	},
	{
		"stop_id": 8505665,
		"ID": 902,
		"x": 16.2797582213,
		"y": 31.82121925,
		"h": 1.6923076923
	},
	{
		"stop_id": 8505672,
		"ID": 902,
		"x": 17.1577740113,
		"y": 33.500226935,
		"h": 1.6923076923
	},
	{
		"stop_id": 8508488,
		"ID": 902,
		"x": 16.2017058503,
		"y": 32.236157985,
		"h": 1.6923076923
	},
	{
		"stop_id": 8530387,
		"ID": 902,
		"x": 16.2997600933,
		"y": 31.813246913,
		"h": 1.6923076923
	},
	{
		"stop_id": 8530687,
		"ID": 902,
		"x": 18.2507177643,
		"y": 28.197229063,
		"h": 1.6923076923
	},
	{
		"stop_id": 8577206,
		"ID": 902,
		"x": 16.3847351883,
		"y": 32.421166269,
		"h": 1.6923076923
	},
	{
		"stop_id": 8577208,
		"ID": 902,
		"x": 16.1847052993,
		"y": 31.448213493,
		"h": 1.6923076923
	},
	{
		"stop_id": 8577209,
		"ID": 902,
		"x": 16.1397418153,
		"y": 31.21515857,
		"h": 1.6923076923
	},
	{
		"stop_id": 8577210,
		"ID": 902,
		"x": 15.8347257173,
		"y": 30.564202947,
		"h": 1.6923076923
	},
	{
		"stop_id": 8587557,
		"ID": 902,
		"x": 16.6327707033,
		"y": 32.943229946,
		"h": 1.6923076923
	},
	{
		"stop_id": 8587769,
		"ID": 902,
		"x": 17.6977228103,
		"y": 33.735145979,
		"h": 1.6923076923
	},
	{
		"stop_id": 8587770,
		"ID": 902,
		"x": 16.5277184203,
		"y": 32.69016659,
		"h": 1.6923076923
	},
	{
		"stop_id": 8588276,
		"ID": 902,
		"x": 17.3677687253,
		"y": 33.855169233,
		"h": 1.6923076923
	},
	{
		"stop_id": 8592405,
		"ID": 902,
		"x": 16.4067035133,
		"y": 32.152162615,
		"h": 1.6923076923
	},
	{
		"stop_id": 8595481,
		"ID": 902,
		"x": 16.0797318223,
		"y": 31.000146616,
		"h": 1.6923076923
	},
	{
		"stop_id": 8505004,
		"ID": 933,
		"x": 24.6657648313,
		"y": 28.930227788,
		"h": 1.8241758242
	},
	{
		"stop_id": 8505060,
		"ID": 933,
		"x": 22.5777547133,
		"y": 30.630161184,
		"h": 1.8241758242
	},
	{
		"stop_id": 8505062,
		"ID": 933,
		"x": 24.5047052913,
		"y": 28.308211027,
		"h": 1.8241758242
	},
	{
		"stop_id": 8505063,
		"ID": 933,
		"x": 24.4867352243,
		"y": 28.730233357,
		"h": 1.8241758242
	},
	{
		"stop_id": 8505064,
		"ID": 933,
		"x": 23.2587102093,
		"y": 27.916160343,
		"h": 1.8241758242
	},
	{
		"stop_id": 8505065,
		"ID": 933,
		"x": 21.2997110583,
		"y": 27.687196946,
		"h": 1.8241758242
	},
	{
		"stop_id": 8505078,
		"ID": 933,
		"x": 22.6267333813,
		"y": 26.50015349,
		"h": 1.8241758242
	},
	{
		"stop_id": 8530683,
		"ID": 933,
		"x": 23.1577296983,
		"y": 27.930210194,
		"h": 1.8241758242
	},
	{
		"stop_id": 8530798,
		"ID": 933,
		"x": 22.8117741653,
		"y": 26.253217053,
		"h": 1.8241758242
	},
	{
		"stop_id": 8577398,
		"ID": 933,
		"x": 24.6167181373,
		"y": 28.959219752,
		"h": 1.8241758242
	},
	{
		"stop_id": 8577399,
		"ID": 933,
		"x": 24.7577309493,
		"y": 29.090190039,
		"h": 1.8241758242
	},
	{
		"stop_id": 8577400,
		"ID": 933,
		"x": 24.9627358183,
		"y": 29.220182478,
		"h": 1.8241758242
	},
	{
		"stop_id": 8577401,
		"ID": 933,
		"x": 24.8477407003,
		"y": 29.350191749,
		"h": 1.8241758242
	},
	{
		"stop_id": 8577402,
		"ID": 933,
		"x": 24.1577259223,
		"y": 29.590160552,
		"h": 1.8241758242
	},
	{
		"stop_id": 8577403,
		"ID": 933,
		"x": 23.8577147483,
		"y": 29.51022974,
		"h": 1.8241758242
	},
	{
		"stop_id": 8577404,
		"ID": 933,
		"x": 23.5577444183,
		"y": 29.530157776,
		"h": 1.8241758242
	},
	{
		"stop_id": 8577406,
		"ID": 933,
		"x": 23.2177118163,
		"y": 30.010177624,
		"h": 1.8241758242
	},
	{
		"stop_id": 8577408,
		"ID": 933,
		"x": 22.6727582183,
		"y": 30.325162676,
		"h": 1.8241758242
	},
	{
		"stop_id": 8577409,
		"ID": 933,
		"x": 22.6057605213,
		"y": 30.588187,
		"h": 1.8241758242
	},
	{
		"stop_id": 8577410,
		"ID": 933,
		"x": 22.8377570773,
		"y": 30.99021317,
		"h": 1.8241758242
	},
	{
		"stop_id": 8588906,
		"ID": 933,
		"x": 22.7577745803,
		"y": 30.830223771,
		"h": 1.8241758242
	},
	{
		"stop_id": 8589871,
		"ID": 933,
		"x": 26.2857602353,
		"y": 27.533225964,
		"h": 1.8241758242
	},
	{
		"stop_id": 8589872,
		"ID": 933,
		"x": 25.5137221583,
		"y": 27.87714921,
		"h": 1.8241758242
	},
	{
		"stop_id": 8589873,
		"ID": 933,
		"x": 24.7727308603,
		"y": 28.214162063,
		"h": 1.8241758242
	},
	{
		"stop_id": 8589874,
		"ID": 933,
		"x": 24.4777045883,
		"y": 28.444140947,
		"h": 1.8241758242
	},
	{
		"stop_id": 8591759,
		"ID": 933,
		"x": 25.1077565373,
		"y": 29.330204444,
		"h": 1.8241758242
	},
	{
		"stop_id": 8505006,
		"ID": 966,
		"x": 30.9837417693,
		"y": 26.492219393,
		"h": 1.8901098901
	},
	{
		"stop_id": 8505007,
		"ID": 966,
		"x": 29.3497656863,
		"y": 23.441148979,
		"h": 1.8901098901
	},
	{
		"stop_id": 8505087,
		"ID": 966,
		"x": 27.1537470833,
		"y": 27.330223989,
		"h": 1.8901098901
	},
	{
		"stop_id": 8505094,
		"ID": 966,
		"x": 30.9827377073,
		"y": 26.538234783,
		"h": 1.8901098901
	},
	{
		"stop_id": 8505097,
		"ID": 966,
		"x": 29.7817196553,
		"y": 23.747143863,
		"h": 1.8901098901
	},
	{
		"stop_id": 8505098,
		"ID": 966,
		"x": 29.3457145223,
		"y": 23.483227277,
		"h": 1.8901098901
	},
	{
		"stop_id": 8505099,
		"ID": 966,
		"x": 29.0177473293,
		"y": 22.893178892,
		"h": 1.8901098901
	},
	{
		"stop_id": 8508470,
		"ID": 966,
		"x": 28.9957548843,
		"y": 22.786226497,
		"h": 1.8901098901
	},
	{
		"stop_id": 8577424,
		"ID": 966,
		"x": 30.4327030163,
		"y": 26.793179676,
		"h": 1.8901098901
	},
	{
		"stop_id": 8577425,
		"ID": 966,
		"x": 28.8447680763,
		"y": 26.667203693,
		"h": 1.8901098901
	},
	{
		"stop_id": 8577426,
		"ID": 966,
		"x": 28.1857465003,
		"y": 26.979219651,
		"h": 1.8901098901
	},
	{
		"stop_id": 8577427,
		"ID": 966,
		"x": 27.8767736713,
		"y": 26.960218497,
		"h": 1.8901098901
	},
	{
		"stop_id": 8577428,
		"ID": 966,
		"x": 27.4507688453,
		"y": 27.063158225,
		"h": 1.8901098901
	},
	{
		"stop_id": 8577429,
		"ID": 966,
		"x": 31.9057734033,
		"y": 25.287169062,
		"h": 1.8901098901
	},
	{
		"stop_id": 8577433,
		"ID": 966,
		"x": 31.2427605873,
		"y": 24.653161484,
		"h": 1.8901098901
	},
	{
		"stop_id": 8577434,
		"ID": 966,
		"x": 30.5537515573,
		"y": 24.290238581,
		"h": 1.8901098901
	},
	{
		"stop_id": 8577435,
		"ID": 966,
		"x": 29.9527604033,
		"y": 23.875239514,
		"h": 1.8901098901
	},
	{
		"stop_id": 8577436,
		"ID": 966,
		"x": 29.1387577863,
		"y": 23.155150326,
		"h": 1.8901098901
	},
	{
		"stop_id": 8577438,
		"ID": 966,
		"x": 28.7367709843,
		"y": 23.070236388,
		"h": 1.8901098901
	},
	{
		"stop_id": 8577439,
		"ID": 966,
		"x": 28.5687542443,
		"y": 23.197165764,
		"h": 1.8901098901
	},
	{
		"stop_id": 8577440,
		"ID": 966,
		"x": 28.4427200933,
		"y": 23.294144473,
		"h": 1.8901098901
	},
	{
		"stop_id": 8577441,
		"ID": 966,
		"x": 28.1457244593,
		"y": 23.523249089,
		"h": 1.8901098901
	},
	{
		"stop_id": 8577442,
		"ID": 966,
		"x": 28.0007206703,
		"y": 23.592161695,
		"h": 1.8901098901
	},
	{
		"stop_id": 8577443,
		"ID": 966,
		"x": 27.7177685213,
		"y": 23.628145306,
		"h": 1.8901098901
	},
	{
		"stop_id": 8577444,
		"ID": 966,
		"x": 26.9337290243,
		"y": 23.569230441,
		"h": 1.8901098901
	},
	{
		"stop_id": 8588733,
		"ID": 966,
		"x": 30.6377730493,
		"y": 27.162194189,
		"h": 1.8901098901
	},
	{
		"stop_id": 8592404,
		"ID": 966,
		"x": 31.4657093193,
		"y": 24.899171214,
		"h": 1.8901098901
	},
	{
		"stop_id": 8592421,
		"ID": 966,
		"x": 31.3607145283,
		"y": 26.127162771,
		"h": 1.8901098901
	},
	{
		"stop_id": 8505066,
		"ID": 901,
		"x": 19.9377169323,
		"y": 28.130140679,
		"h": 2.0879120879
	},
	{
		"stop_id": 8505071,
		"ID": 901,
		"x": 19.6577006323,
		"y": 26.31024229,
		"h": 2.0879120879
	},
	{
		"stop_id": 8505072,
		"ID": 901,
		"x": 19.3937519813,
		"y": 26.733229501,
		"h": 2.0879120879
	},
	{
		"stop_id": 8505073,
		"ID": 901,
		"x": 19.0947685863,
		"y": 27.440169159,
		"h": 2.0879120879
	},
	{
		"stop_id": 8505079,
		"ID": 901,
		"x": 19.6177606133,
		"y": 25.529212705,
		"h": 2.0879120879
	},
	{
		"stop_id": 8505666,
		"ID": 901,
		"x": 20.0937524643,
		"y": 22.709210207,
		"h": 2.0879120879
	},
	{
		"stop_id": 8508464,
		"ID": 901,
		"x": 19.6257599133,
		"y": 24.436178878,
		"h": 2.0879120879
	},
	{
		"stop_id": 8530388,
		"ID": 901,
		"x": 16.4237163863,
		"y": 27.144183729,
		"h": 2.0879120879
	},
	{
		"stop_id": 8577215,
		"ID": 901,
		"x": 16.3717565033,
		"y": 26.772174251,
		"h": 2.0879120879
	},
	{
		"stop_id": 8577216,
		"ID": 901,
		"x": 16.7747085163,
		"y": 26.697167719,
		"h": 2.0879120879
	},
	{
		"stop_id": 8577217,
		"ID": 901,
		"x": 17.5177292793,
		"y": 26.028203645,
		"h": 2.0879120879
	},
	{
		"stop_id": 8577219,
		"ID": 901,
		"x": 18.6257730433,
		"y": 25.687208506,
		"h": 2.0879120879
	},
	{
		"stop_id": 8577220,
		"ID": 901,
		"x": 19.4797579003,
		"y": 25.002155287,
		"h": 2.0879120879
	},
	{
		"stop_id": 8577221,
		"ID": 901,
		"x": 19.7067248293,
		"y": 24.461160425,
		"h": 2.0879120879
	},
	{
		"stop_id": 8577222,
		"ID": 901,
		"x": 19.8027372833,
		"y": 24.093204864,
		"h": 2.0879120879
	},
	{
		"stop_id": 8577223,
		"ID": 901,
		"x": 19.4977026553,
		"y": 23.387145954,
		"h": 2.0879120879
	},
	{
		"stop_id": 8588807,
		"ID": 901,
		"x": 16.4657104833,
		"y": 27.058220885,
		"h": 2.0879120879
	},
	{
		"stop_id": 8592423,
		"ID": 901,
		"x": 17.4777608313,
		"y": 26.684213708,
		"h": 2.0879120879
	},
	{
		"stop_id": 8592424,
		"ID": 901,
		"x": 17.2287598943,
		"y": 26.775166311,
		"h": 2.0879120879
	},
	{
		"stop_id": 8592425,
		"ID": 901,
		"x": 17.6087471983,
		"y": 26.332241861,
		"h": 2.0879120879
	},
	{
		"stop_id": 8592426,
		"ID": 901,
		"x": 17.6107042723,
		"y": 26.187175189,
		"h": 2.0879120879
	},
	{
		"stop_id": 8592427,
		"ID": 901,
		"x": 18.0087560413,
		"y": 26.119192363,
		"h": 2.0879120879
	},
	{
		"stop_id": 8592428,
		"ID": 901,
		"x": 17.6977164673,
		"y": 26.149168152,
		"h": 2.0879120879
	},
	{
		"stop_id": 8592429,
		"ID": 901,
		"x": 17.4237262083,
		"y": 26.483165078,
		"h": 2.0879120879
	},
	{
		"stop_id": 8592433,
		"ID": 901,
		"x": 16.9147758033,
		"y": 27.185163319,
		"h": 2.0879120879
	},
	{
		"stop_id": 8594998,
		"ID": 901,
		"x": 17.5517548833,
		"y": 26.283250294,
		"h": 2.0879120879
	},
	{
		"stop_id": 8595541,
		"ID": 901,
		"x": 17.5507634523,
		"y": 26.471245629,
		"h": 2.0879120879
	},
	{
		"stop_id": 8595542,
		"ID": 901,
		"x": 16.6697236403,
		"y": 27.326221473,
		"h": 2.0879120879
	},
	{
		"stop_id": 8595628,
		"ID": 901,
		"x": 16.3257109443,
		"y": 26.967155079,
		"h": 2.0879120879
	},
	{
		"stop_id": 8595629,
		"ID": 901,
		"x": 17.5367755593,
		"y": 26.072144705,
		"h": 2.0879120879
	},
	{
		"stop_id": 8595630,
		"ID": 901,
		"x": 17.6247200063,
		"y": 26.138214663,
		"h": 2.0879120879
	},
	{
		"stop_id": 8595631,
		"ID": 901,
		"x": 17.7077297943,
		"y": 26.262147531,
		"h": 2.0879120879
	},
	{
		"stop_id": 8595632,
		"ID": 901,
		"x": 17.7057361053,
		"y": 26.597223303,
		"h": 2.0879120879
	},
	{
		"stop_id": 8595633,
		"ID": 901,
		"x": 16.6327006533,
		"y": 27.178209268,
		"h": 2.0879120879
	},
	{
		"stop_id": 8505081,
		"ID": 1065,
		"x": 46.2217550353,
		"y": 17.414185562,
		"h": 1.1318681319
	},
	{
		"stop_id": 8577470,
		"ID": 1065,
		"x": 45.9457403533,
		"y": 17.976242891,
		"h": 1.1318681319
	},
	{
		"stop_id": 8587690,
		"ID": 1065,
		"x": 46.5737695643,
		"y": 16.962234713,
		"h": 1.1318681319
	},
	{
		"stop_id": 8587796,
		"ID": 1065,
		"x": 45.4937673853,
		"y": 19.021212257,
		"h": 1.1318681319
	},
	{
		"stop_id": 8587961,
		"ID": 1065,
		"x": 45.8267180183,
		"y": 18.317152985,
		"h": 1.1318681319
	},
	{
		"stop_id": 8505082,
		"ID": 932,
		"x": 26.2737564783,
		"y": 23.24514366,
		"h": 1.2637362637
	},
	{
		"stop_id": 8505671,
		"ID": 932,
		"x": 23.0057707653,
		"y": 22.427220984,
		"h": 1.2637362637
	},
	{
		"stop_id": 8508468,
		"ID": 932,
		"x": 22.9717243193,
		"y": 22.397174619,
		"h": 1.2637362637
	},
	{
		"stop_id": 8530722,
		"ID": 932,
		"x": 21.2077016843,
		"y": 22.528200458,
		"h": 1.2637362637
	},
	{
		"stop_id": 8530797,
		"ID": 932,
		"x": 24.0517420893,
		"y": 24.89817348,
		"h": 1.2637362637
	},
	{
		"stop_id": 8577224,
		"ID": 932,
		"x": 21.3037412033,
		"y": 22.576200081,
		"h": 1.2637362637
	},
	{
		"stop_id": 8577225,
		"ID": 932,
		"x": 22.7647056683,
		"y": 22.618230374,
		"h": 1.2637362637
	},
	{
		"stop_id": 8577445,
		"ID": 932,
		"x": 24.7177576893,
		"y": 22.291208562,
		"h": 1.2637362637
	},
	{
		"stop_id": 8591890,
		"ID": 932,
		"x": 22.2607014573,
		"y": 22.774166459,
		"h": 1.2637362637
	},
	{
		"stop_id": 8505083,
		"ID": 1032,
		"x": 38.0717090693,
		"y": 21.854241395,
		"h": 1.3956043956
	},
	{
		"stop_id": 8505093,
		"ID": 1032,
		"x": 40.6167208753,
		"y": 20.853223833,
		"h": 1.3956043956
	},
	{
		"stop_id": 8530400,
		"ID": 1032,
		"x": 38.0617323663,
		"y": 21.901220907,
		"h": 1.3956043956
	},
	{
		"stop_id": 8530401,
		"ID": 1032,
		"x": 38.0107251153,
		"y": 22.214153163,
		"h": 1.3956043956
	},
	{
		"stop_id": 8530819,
		"ID": 1032,
		"x": 38.1877030433,
		"y": 22.325238828,
		"h": 1.3956043956
	},
	{
		"stop_id": 8577458,
		"ID": 1032,
		"x": 37.1527644953,
		"y": 22.178147911,
		"h": 1.3956043956
	},
	{
		"stop_id": 8577459,
		"ID": 1032,
		"x": 38.3367632653,
		"y": 21.602195145,
		"h": 1.3956043956
	},
	{
		"stop_id": 8577460,
		"ID": 1032,
		"x": 38.6347132603,
		"y": 21.313232659,
		"h": 1.3956043956
	},
	{
		"stop_id": 8577461,
		"ID": 1032,
		"x": 39.0627518443,
		"y": 21.079250051,
		"h": 1.3956043956
	},
	{
		"stop_id": 8577462,
		"ID": 1032,
		"x": 40.1717680323,
		"y": 20.997196456,
		"h": 1.3956043956
	},
	{
		"stop_id": 8577463,
		"ID": 1032,
		"x": 40.9097143223,
		"y": 20.70916616,
		"h": 1.3956043956
	},
	{
		"stop_id": 8588114,
		"ID": 1032,
		"x": 39.8087526953,
		"y": 20.993244108,
		"h": 1.3956043956
	},
	{
		"stop_id": 8588293,
		"ID": 1032,
		"x": 39.4597748633,
		"y": 20.987212192,
		"h": 1.3956043956
	},
	{
		"stop_id": 8505084,
		"ID": 999,
		"x": 31.9967220473,
		"y": 25.015162612,
		"h": 2.1538461538
	},
	{
		"stop_id": 8505089,
		"ID": 999,
		"x": 31.5197634643,
		"y": 22.478171347,
		"h": 2.1538461538
	},
	{
		"stop_id": 8505090,
		"ID": 999,
		"x": 33.7977018923,
		"y": 22.704232025,
		"h": 2.1538461538
	},
	{
		"stop_id": 8505091,
		"ID": 999,
		"x": 33.5317400543,
		"y": 21.808142896,
		"h": 2.1538461538
	},
	{
		"stop_id": 8505092,
		"ID": 999,
		"x": 33.8287285143,
		"y": 25.227183313,
		"h": 2.1538461538
	},
	{
		"stop_id": 8505096,
		"ID": 999,
		"x": 31.7277111913,
		"y": 24.774207814,
		"h": 2.1538461538
	},
	{
		"stop_id": 8530391,
		"ID": 999,
		"x": 33.3797638663,
		"y": 21.43919339,
		"h": 2.1538461538
	},
	{
		"stop_id": 8530393,
		"ID": 999,
		"x": 33.4947308973,
		"y": 21.615214739,
		"h": 2.1538461538
	},
	{
		"stop_id": 8530840,
		"ID": 999,
		"x": 34.0507728393,
		"y": 20.663176388,
		"h": 2.1538461538
	},
	{
		"stop_id": 8577450,
		"ID": 999,
		"x": 32.9587706603,
		"y": 25.051159317,
		"h": 2.1538461538
	},
	{
		"stop_id": 8577451,
		"ID": 999,
		"x": 32.9907122033,
		"y": 24.542204237,
		"h": 2.1538461538
	},
	{
		"stop_id": 8577452,
		"ID": 999,
		"x": 32.7077480163,
		"y": 23.676238891,
		"h": 2.1538461538
	},
	{
		"stop_id": 8577453,
		"ID": 999,
		"x": 33.8107694393,
		"y": 22.710218484,
		"h": 2.1538461538
	},
	{
		"stop_id": 8577454,
		"ID": 999,
		"x": 34.6947190203,
		"y": 22.753159907,
		"h": 2.1538461538
	},
	{
		"stop_id": 8577455,
		"ID": 999,
		"x": 35.4727403533,
		"y": 22.740171722,
		"h": 2.1538461538
	},
	{
		"stop_id": 8577456,
		"ID": 999,
		"x": 36.0127648733,
		"y": 22.582144343,
		"h": 2.1538461538
	},
	{
		"stop_id": 8577457,
		"ID": 999,
		"x": 36.5647001123,
		"y": 22.409236332,
		"h": 2.1538461538
	},
	{
		"stop_id": 8577488,
		"ID": 999,
		"x": 34.3527621603,
		"y": 25.029176197,
		"h": 2.1538461538
	},
	{
		"stop_id": 8577489,
		"ID": 999,
		"x": 34.3507488693,
		"y": 24.279196462,
		"h": 2.1538461538
	},
	{
		"stop_id": 8577490,
		"ID": 999,
		"x": 35.1327085533,
		"y": 24.704190628,
		"h": 2.1538461538
	},
	{
		"stop_id": 8577506,
		"ID": 999,
		"x": 30.8967320173,
		"y": 22.364163903,
		"h": 2.1538461538
	},
	{
		"stop_id": 8577507,
		"ID": 999,
		"x": 31.5117145333,
		"y": 22.477158801,
		"h": 2.1538461538
	},
	{
		"stop_id": 8587739,
		"ID": 999,
		"x": 32.1047312143,
		"y": 23.215182561,
		"h": 2.1538461538
	},
	{
		"stop_id": 8588237,
		"ID": 999,
		"x": 34.0547386813,
		"y": 25.072181713,
		"h": 2.1538461538
	},
	{
		"stop_id": 8592394,
		"ID": 999,
		"x": 31.9277029363,
		"y": 23.612170005,
		"h": 2.1538461538
	},
	{
		"stop_id": 8592395,
		"ID": 999,
		"x": 32.5897203413,
		"y": 25.026201048,
		"h": 2.1538461538
	},
	{
		"stop_id": 8592396,
		"ID": 999,
		"x": 31.9687461483,
		"y": 23.817158496,
		"h": 2.1538461538
	},
	{
		"stop_id": 8592397,
		"ID": 999,
		"x": 32.0097410933,
		"y": 24.010249854,
		"h": 2.1538461538
	},
	{
		"stop_id": 8592398,
		"ID": 999,
		"x": 32.0357133713,
		"y": 24.517208243,
		"h": 2.1538461538
	},
	{
		"stop_id": 8592399,
		"ID": 999,
		"x": 31.7217362323,
		"y": 24.881187409,
		"h": 2.1538461538
	},
	{
		"stop_id": 8592400,
		"ID": 999,
		"x": 31.9197104713,
		"y": 24.751248452,
		"h": 2.1538461538
	},
	{
		"stop_id": 8592401,
		"ID": 999,
		"x": 32.5007117933,
		"y": 25.097205772,
		"h": 2.1538461538
	},
	{
		"stop_id": 8592402,
		"ID": 999,
		"x": 32.1417621183,
		"y": 24.199183423,
		"h": 2.1538461538
	},
	{
		"stop_id": 8592410,
		"ID": 999,
		"x": 32.9637525883,
		"y": 25.117169704,
		"h": 2.1538461538
	},
	{
		"stop_id": 8595231,
		"ID": 999,
		"x": 31.9747477623,
		"y": 23.377181017,
		"h": 2.1538461538
	},
	{
		"stop_id": 8595499,
		"ID": 999,
		"x": 33.8427243503,
		"y": 25.251196605,
		"h": 2.1538461538
	},
	{
		"stop_id": 8505085,
		"ID": 965,
		"x": 30.1357369963,
		"y": 21.558245926,
		"h": 1.5934065934
	},
	{
		"stop_id": 8505111,
		"ID": 965,
		"x": 30.2457255133,
		"y": 17.904184558,
		"h": 1.5934065934
	},
	{
		"stop_id": 8508469,
		"ID": 965,
		"x": 27.5117029923,
		"y": 22.104249692,
		"h": 1.5934065934
	},
	{
		"stop_id": 8508471,
		"ID": 965,
		"x": 28.1187314523,
		"y": 20.240159624,
		"h": 1.5934065934
	},
	{
		"stop_id": 8508472,
		"ID": 965,
		"x": 30.1047260753,
		"y": 17.777203158,
		"h": 1.5934065934
	},
	{
		"stop_id": 8508498,
		"ID": 965,
		"x": 27.5157653003,
		"y": 22.07617969,
		"h": 1.5934065934
	},
	{
		"stop_id": 8508499,
		"ID": 965,
		"x": 27.6247104483,
		"y": 21.151171809,
		"h": 1.5934065934
	},
	{
		"stop_id": 8508736,
		"ID": 965,
		"x": 27.4577221363,
		"y": 19.882244423,
		"h": 1.5934065934
	},
	{
		"stop_id": 8530392,
		"ID": 965,
		"x": 31.4807109453,
		"y": 20.184175864,
		"h": 1.5934065934
	},
	{
		"stop_id": 8572954,
		"ID": 965,
		"x": 26.5697432653,
		"y": 19.392147101,
		"h": 1.5934065934
	},
	{
		"stop_id": 8572955,
		"ID": 965,
		"x": 26.9227089153,
		"y": 19.517225239,
		"h": 1.5934065934
	},
	{
		"stop_id": 8572956,
		"ID": 965,
		"x": 27.0827178113,
		"y": 19.626173842,
		"h": 1.5934065934
	},
	{
		"stop_id": 8572957,
		"ID": 965,
		"x": 27.5907537503,
		"y": 20.195167422,
		"h": 1.5934065934
	},
	{
		"stop_id": 8572958,
		"ID": 965,
		"x": 27.5357675363,
		"y": 20.791194025,
		"h": 1.5934065934
	},
	{
		"stop_id": 8572959,
		"ID": 965,
		"x": 27.6287724633,
		"y": 21.097196224,
		"h": 1.5934065934
	},
	{
		"stop_id": 8573132,
		"ID": 965,
		"x": 30.2537634943,
		"y": 17.89118603,
		"h": 1.5934065934
	},
	{
		"stop_id": 8573133,
		"ID": 965,
		"x": 30.8087272473,
		"y": 18.313176153,
		"h": 1.5934065934
	},
	{
		"stop_id": 8577505,
		"ID": 965,
		"x": 29.9227536853,
		"y": 21.447194566,
		"h": 1.5934065934
	},
	{
		"stop_id": 8588113,
		"ID": 965,
		"x": 30.4107158923,
		"y": 21.846245413,
		"h": 1.5934065934
	},
	{
		"stop_id": 8505112,
		"ID": 964,
		"x": 30.5967745933,
		"y": 12.625180528,
		"h": 1.6923076923
	},
	{
		"stop_id": 8505780,
		"ID": 964,
		"x": 25.8037197103,
		"y": 13.535182537,
		"h": 1.6923076923
	},
	{
		"stop_id": 8505918,
		"ID": 964,
		"x": 28.3657332963,
		"y": 14.347225317,
		"h": 1.6923076923
	},
	{
		"stop_id": 8508473,
		"ID": 964,
		"x": 29.6497300883,
		"y": 16.204141835,
		"h": 1.6923076923
	},
	{
		"stop_id": 8508474,
		"ID": 964,
		"x": 27.2147558013,
		"y": 16.29617802,
		"h": 1.6923076923
	},
	{
		"stop_id": 8508475,
		"ID": 964,
		"x": 28.3927106883,
		"y": 14.615238641,
		"h": 1.6923076923
	},
	{
		"stop_id": 8508476,
		"ID": 964,
		"x": 30.5657535703,
		"y": 12.807162331,
		"h": 1.6923076923
	},
	{
		"stop_id": 8530833,
		"ID": 964,
		"x": 28.6727298343,
		"y": 11.298145288,
		"h": 1.6923076923
	},
	{
		"stop_id": 8573092,
		"ID": 964,
		"x": 29.1917352203,
		"y": 10.856222345,
		"h": 1.6923076923
	},
	{
		"stop_id": 8573093,
		"ID": 964,
		"x": 28.7107010053,
		"y": 11.194195999,
		"h": 1.6923076923
	},
	{
		"stop_id": 8573094,
		"ID": 964,
		"x": 28.2727052223,
		"y": 11.90518863,
		"h": 1.6923076923
	},
	{
		"stop_id": 8573098,
		"ID": 964,
		"x": 28.0597514783,
		"y": 14.22520292,
		"h": 1.6923076923
	},
	{
		"stop_id": 8573099,
		"ID": 964,
		"x": 26.7547561783,
		"y": 13.734208351,
		"h": 1.6923076923
	},
	{
		"stop_id": 8573100,
		"ID": 964,
		"x": 26.1827222343,
		"y": 13.602213012,
		"h": 1.6923076923
	},
	{
		"stop_id": 8573113,
		"ID": 964,
		"x": 30.5867296333,
		"y": 12.624250468,
		"h": 1.6923076923
	},
	{
		"stop_id": 8577369,
		"ID": 964,
		"x": 30.6257033093,
		"y": 14.144150132,
		"h": 1.6923076923
	},
	{
		"stop_id": 8577370,
		"ID": 964,
		"x": 30.4807359803,
		"y": 13.598165548,
		"h": 1.6923076923
	},
	{
		"stop_id": 8577371,
		"ID": 964,
		"x": 30.6497011103,
		"y": 12.703141214,
		"h": 1.6923076923
	},
	{
		"stop_id": 8577372,
		"ID": 964,
		"x": 30.6737090303,
		"y": 12.224196549,
		"h": 1.6923076923
	},
	{
		"stop_id": 8581321,
		"ID": 964,
		"x": 25.4587528093,
		"y": 13.640213938,
		"h": 1.6923076923
	},
	{
		"stop_id": 8591900,
		"ID": 964,
		"x": 30.6407283883,
		"y": 13.256250008,
		"h": 1.6923076923
	},
	{
		"stop_id": 8591901,
		"ID": 964,
		"x": 30.5077252163,
		"y": 13.950243758,
		"h": 1.6923076923
	},
	{
		"stop_id": 8505113,
		"ID": 997,
		"x": 31.1947231153,
		"y": 9.745170777,
		"h": 2.2527472527
	},
	{
		"stop_id": 8505657,
		"ID": 997,
		"x": 32.0077053603,
		"y": 10.380208514,
		"h": 2.2527472527
	},
	{
		"stop_id": 8505658,
		"ID": 997,
		"x": 35.0227460093,
		"y": 9.920228787,
		"h": 2.2527472527
	},
	{
		"stop_id": 8505659,
		"ID": 997,
		"x": 34.6877285243,
		"y": 9.950174934,
		"h": 2.2527472527
	},
	{
		"stop_id": 8505660,
		"ID": 997,
		"x": 36.2247525233,
		"y": 10.201232992,
		"h": 2.2527472527
	},
	{
		"stop_id": 8505890,
		"ID": 997,
		"x": 33.6267375863,
		"y": 9.74717466,
		"h": 2.2527472527
	},
	{
		"stop_id": 8505892,
		"ID": 997,
		"x": 32.1327238243,
		"y": 10.430158678,
		"h": 2.2527472527
	},
	{
		"stop_id": 8505893,
		"ID": 997,
		"x": 32.9577365563,
		"y": 8.530214854,
		"h": 2.2527472527
	},
	{
		"stop_id": 8530418,
		"ID": 997,
		"x": 30.8607137293,
		"y": 11.712141581,
		"h": 2.2527472527
	},
	{
		"stop_id": 8530420,
		"ID": 997,
		"x": 32.1467662133,
		"y": 12.631236992,
		"h": 2.2527472527
	},
	{
		"stop_id": 8530421,
		"ID": 997,
		"x": 35.0407408313,
		"y": 9.968211588,
		"h": 2.2527472527
	},
	{
		"stop_id": 8530424,
		"ID": 997,
		"x": 33.0487491003,
		"y": 8.621238985,
		"h": 2.2527472527
	},
	{
		"stop_id": 8530425,
		"ID": 997,
		"x": 34.1697074293,
		"y": 8.525213902,
		"h": 2.2527472527
	},
	{
		"stop_id": 8530853,
		"ID": 997,
		"x": 34.9287715173,
		"y": 10.053161118,
		"h": 2.2527472527
	},
	{
		"stop_id": 8530855,
		"ID": 997,
		"x": 35.4257106433,
		"y": 12.825185627,
		"h": 2.2527472527
	},
	{
		"stop_id": 8573087,
		"ID": 997,
		"x": 31.7367500203,
		"y": 10.192162016,
		"h": 2.2527472527
	},
	{
		"stop_id": 8573088,
		"ID": 997,
		"x": 31.2077619273,
		"y": 9.780169063,
		"h": 2.2527472527
	},
	{
		"stop_id": 8573089,
		"ID": 997,
		"x": 30.8477519913,
		"y": 10.55020111,
		"h": 2.2527472527
	},
	{
		"stop_id": 8573114,
		"ID": 997,
		"x": 30.8317727703,
		"y": 11.625203196,
		"h": 2.2527472527
	},
	{
		"stop_id": 8573116,
		"ID": 997,
		"x": 32.6107547283,
		"y": 9.711165399,
		"h": 2.2527472527
	},
	{
		"stop_id": 8573117,
		"ID": 997,
		"x": 33.3047661243,
		"y": 9.693236644,
		"h": 2.2527472527
	},
	{
		"stop_id": 8573118,
		"ID": 997,
		"x": 34.1947175943,
		"y": 9.875145389,
		"h": 2.2527472527
	},
	{
		"stop_id": 8577373,
		"ID": 997,
		"x": 30.9847059613,
		"y": 11.346230272,
		"h": 2.2527472527
	},
	{
		"stop_id": 8577374,
		"ID": 997,
		"x": 31.4417000433,
		"y": 10.863200471,
		"h": 2.2527472527
	},
	{
		"stop_id": 8577375,
		"ID": 997,
		"x": 31.6147276073,
		"y": 10.674162736,
		"h": 2.2527472527
	},
	{
		"stop_id": 8577376,
		"ID": 997,
		"x": 31.9167313553,
		"y": 10.541139986,
		"h": 2.2527472527
	},
	{
		"stop_id": 8577377,
		"ID": 997,
		"x": 32.3467376413,
		"y": 9.938243078,
		"h": 2.2527472527
	},
	{
		"stop_id": 8577378,
		"ID": 997,
		"x": 32.8087371753,
		"y": 8.978196952,
		"h": 2.2527472527
	},
	{
		"stop_id": 8577379,
		"ID": 997,
		"x": 32.5077481453,
		"y": 8.48023128,
		"h": 2.2527472527
	},
	{
		"stop_id": 8577382,
		"ID": 997,
		"x": 32.0617005453,
		"y": 8.148161707,
		"h": 2.2527472527
	},
	{
		"stop_id": 8577395,
		"ID": 997,
		"x": 32.9807211943,
		"y": 9.625163717,
		"h": 2.2527472527
	},
	{
		"stop_id": 8587401,
		"ID": 997,
		"x": 32.1347747363,
		"y": 10.093195899,
		"h": 2.2527472527
	},
	{
		"stop_id": 8587599,
		"ID": 997,
		"x": 33.9577572153,
		"y": 9.880211782,
		"h": 2.2527472527
	},
	{
		"stop_id": 8587775,
		"ID": 997,
		"x": 31.1277536603,
		"y": 10.339200215,
		"h": 2.2527472527
	},
	{
		"stop_id": 8587927,
		"ID": 997,
		"x": 32.4827043523,
		"y": 8.205224768,
		"h": 2.2527472527
	},
	{
		"stop_id": 8588567,
		"ID": 997,
		"x": 31.4657458543,
		"y": 9.971217399,
		"h": 2.2527472527
	},
	{
		"stop_id": 8588569,
		"ID": 997,
		"x": 32.6467371863,
		"y": 9.420200388,
		"h": 2.2527472527
	},
	{
		"stop_id": 8588583,
		"ID": 997,
		"x": 31.5577172893,
		"y": 9.180224616,
		"h": 2.2527472527
	},
	{
		"stop_id": 8588652,
		"ID": 997,
		"x": 31.6057016033,
		"y": 9.518172967,
		"h": 2.2527472527
	},
	{
		"stop_id": 8505114,
		"ID": 996,
		"x": 32.7287098303,
		"y": 3.609198642,
		"h": 1.3296703297
	},
	{
		"stop_id": 8577380,
		"ID": 996,
		"x": 32.3807501843,
		"y": 7.729239291,
		"h": 1.3296703297
	},
	{
		"stop_id": 8577381,
		"ID": 996,
		"x": 31.8826995493,
		"y": 7.855232302,
		"h": 1.3296703297
	},
	{
		"stop_id": 8577383,
		"ID": 996,
		"x": 32.3467150843,
		"y": 7.433193097,
		"h": 1.3296703297
	},
	{
		"stop_id": 8577384,
		"ID": 996,
		"x": 32.2587673763,
		"y": 5.394207958,
		"h": 1.3296703297
	},
	{
		"stop_id": 8577385,
		"ID": 996,
		"x": 32.5827426403,
		"y": 4.270144903,
		"h": 1.3296703297
	},
	{
		"stop_id": 8577386,
		"ID": 996,
		"x": 32.7457730883,
		"y": 3.616244289,
		"h": 1.3296703297
	},
	{
		"stop_id": 8577387,
		"ID": 996,
		"x": 33.7747246993,
		"y": 2.282145729,
		"h": 1.3296703297
	},
	{
		"stop_id": 8587505,
		"ID": 996,
		"x": 32.4777063673,
		"y": 4.480215987,
		"h": 1.3296703297
	},
	{
		"stop_id": 8587506,
		"ID": 996,
		"x": 32.7077106433,
		"y": 4.010240395,
		"h": 1.3296703297
	},
	{
		"stop_id": 8588198,
		"ID": 996,
		"x": 32.9447001873,
		"y": 3.30823403,
		"h": 1.3296703297
	},
	{
		"stop_id": 8505119,
		"ID": 959,
		"x": 28.2767321703,
		"y": -13.637787972,
		"h": 1.7912087912
	},
	{
		"stop_id": 8505165,
		"ID": 959,
		"x": 28.6667099843,
		"y": -16.847782809,
		"h": 1.7912087912
	},
	{
		"stop_id": 8505170,
		"ID": 959,
		"x": 30.1637205083,
		"y": -16.209858819,
		"h": 1.7912087912
	},
	{
		"stop_id": 8505192,
		"ID": 959,
		"x": 28.5597485443,
		"y": -17.333759332,
		"h": 1.7912087912
	},
	{
		"stop_id": 8573106,
		"ID": 959,
		"x": 28.2447050823,
		"y": -13.619801739,
		"h": 1.7912087912
	},
	{
		"stop_id": 8573107,
		"ID": 959,
		"x": 28.1247123183,
		"y": -13.364847874,
		"h": 1.7912087912
	},
	{
		"stop_id": 8573108,
		"ID": 959,
		"x": 26.9447698343,
		"y": -13.650827679,
		"h": 1.7912087912
	},
	{
		"stop_id": 8573140,
		"ID": 959,
		"x": 28.7577333693,
		"y": -16.819759849,
		"h": 1.7912087912
	},
	{
		"stop_id": 8591899,
		"ID": 959,
		"x": 28.3077044613,
		"y": -13.3698385,
		"h": 1.7912087912
	},
	{
		"stop_id": 8594469,
		"ID": 959,
		"x": 28.5957378143,
		"y": -17.369807924,
		"h": 1.7912087912
	},
	{
		"stop_id": 8594471,
		"ID": 959,
		"x": 28.4627417923,
		"y": -17.074804955,
		"h": 1.7912087912
	},
	{
		"stop_id": 8594472,
		"ID": 959,
		"x": 28.7877502163,
		"y": -17.219781746,
		"h": 1.7912087912
	},
	{
		"stop_id": 8594473,
		"ID": 959,
		"x": 28.8927430303,
		"y": -17.255812015,
		"h": 1.7912087912
	},
	{
		"stop_id": 8594474,
		"ID": 959,
		"x": 28.8047033653,
		"y": -16.852754774,
		"h": 1.7912087912
	},
	{
		"stop_id": 8594475,
		"ID": 959,
		"x": 28.8907441203,
		"y": -17.052829941,
		"h": 1.7912087912
	},
	{
		"stop_id": 8594476,
		"ID": 959,
		"x": 29.1817546343,
		"y": -16.850854548,
		"h": 1.7912087912
	},
	{
		"stop_id": 8594477,
		"ID": 959,
		"x": 28.9207648393,
		"y": -17.104751965,
		"h": 1.7912087912
	},
	{
		"stop_id": 8595235,
		"ID": 959,
		"x": 29.1587246293,
		"y": -17.017851781,
		"h": 1.7912087912
	},
	{
		"stop_id": 8595236,
		"ID": 959,
		"x": 29.1547221963,
		"y": -16.995786508,
		"h": 1.7912087912
	},
	{
		"stop_id": 8595940,
		"ID": 959,
		"x": 28.3827518573,
		"y": -17.249750231,
		"h": 1.7912087912
	},
	{
		"stop_id": 8595941,
		"ID": 959,
		"x": 28.5237464633,
		"y": -17.197761529,
		"h": 1.7912087912
	},
	{
		"stop_id": 8595942,
		"ID": 959,
		"x": 28.5887739353,
		"y": -17.385808789,
		"h": 1.7912087912
	},
	{
		"stop_id": 8595943,
		"ID": 959,
		"x": 29.0047413803,
		"y": -17.169774377,
		"h": 1.7912087912
	},
	{
		"stop_id": 8595944,
		"ID": 959,
		"x": 29.2917465293,
		"y": -17.017771971,
		"h": 1.7912087912
	},
	{
		"stop_id": 8595945,
		"ID": 959,
		"x": 29.2847526823,
		"y": -17.005757165,
		"h": 1.7912087912
	},
	{
		"stop_id": 8505121,
		"ID": 995,
		"x": 32.7777652313,
		"y": -3.034792139,
		"h": 1.5274725275
	},
	{
		"stop_id": 8505664,
		"ID": 995,
		"x": 34.2077755573,
		"y": 0.555154595,
		"h": 1.5274725275
	},
	{
		"stop_id": 8505667,
		"ID": 995,
		"x": 34.3837009313,
		"y": -1.99181109,
		"h": 1.5274725275
	},
	{
		"stop_id": 8505778,
		"ID": 995,
		"x": 35.8427288483,
		"y": -2.063777157,
		"h": 1.5274725275
	},
	{
		"stop_id": 8530434,
		"ID": 995,
		"x": 32.7687474083,
		"y": -3.019810736,
		"h": 1.5274725275
	},
	{
		"stop_id": 8530435,
		"ID": 995,
		"x": 32.1977168863,
		"y": -2.084783801,
		"h": 1.5274725275
	},
	{
		"stop_id": 8530692,
		"ID": 995,
		"x": 33.9047231143,
		"y": -1.429844375,
		"h": 1.5274725275
	},
	{
		"stop_id": 8530693,
		"ID": 995,
		"x": 32.8737394183,
		"y": -1.09275694,
		"h": 1.5274725275
	},
	{
		"stop_id": 8573086,
		"ID": 995,
		"x": 34.9777376643,
		"y": -2.006799985,
		"h": 1.5274725275
	},
	{
		"stop_id": 8577388,
		"ID": 995,
		"x": 33.8247037443,
		"y": 1.482195243,
		"h": 1.5274725275
	},
	{
		"stop_id": 8577389,
		"ID": 995,
		"x": 34.0157099243,
		"y": 1.249143394,
		"h": 1.5274725275
	},
	{
		"stop_id": 8577390,
		"ID": 995,
		"x": 34.3007132003,
		"y": -0.54475261,
		"h": 1.5274725275
	},
	{
		"stop_id": 8577391,
		"ID": 995,
		"x": 34.1827391203,
		"y": -1.403812631,
		"h": 1.5274725275
	},
	{
		"stop_id": 8587425,
		"ID": 995,
		"x": 33.4677754653,
		"y": -2.729805176,
		"h": 1.5274725275
	},
	{
		"stop_id": 8587426,
		"ID": 995,
		"x": 32.3077574283,
		"y": -3.51977207,
		"h": 1.5274725275
	},
	{
		"stop_id": 8588653,
		"ID": 995,
		"x": 34.4077250623,
		"y": -0.919755175,
		"h": 1.5274725275
	},
	{
		"stop_id": 8588654,
		"ID": 995,
		"x": 34.3077760943,
		"y": -1.719830383,
		"h": 1.5274725275
	},
	{
		"stop_id": 8505122,
		"ID": 994,
		"x": 30.7187347333,
		"y": -6.803760414,
		"h": 1.1978021978
	},
	{
		"stop_id": 8587427,
		"ID": 994,
		"x": 32.2577539893,
		"y": -4.239766957,
		"h": 1.1978021978
	},
	{
		"stop_id": 8587428,
		"ID": 994,
		"x": 31.4077385283,
		"y": -5.994833602,
		"h": 1.1978021978
	},
	{
		"stop_id": 8587650,
		"ID": 994,
		"x": 31.1847358873,
		"y": -5.544826727,
		"h": 1.1978021978
	},
	{
		"stop_id": 8588505,
		"ID": 994,
		"x": 31.0327164493,
		"y": -5.969836415,
		"h": 1.1978021978
	},
	{
		"stop_id": 8588506,
		"ID": 994,
		"x": 30.6717327893,
		"y": -6.520849427,
		"h": 1.1978021978
	},
	{
		"stop_id": 8595357,
		"ID": 994,
		"x": 30.9007429543,
		"y": -5.901789291,
		"h": 1.1978021978
	},
	{
		"stop_id": 8505163,
		"ID": 924,
		"x": 21.8477690553,
		"y": -21.197749834,
		"h": 1.032967033
	},
	{
		"stop_id": 8530612,
		"ID": 924,
		"x": 21.6847469553,
		"y": -21.529819324,
		"h": 1.032967033
	},
	{
		"stop_id": 8505173,
		"ID": 1026,
		"x": 37.4977253063,
		"y": -14.503834422,
		"h": 1.1318681319
	},
	{
		"stop_id": 8505174,
		"ID": 1026,
		"x": 40.0587201953,
		"y": -12.995773992,
		"h": 1.1318681319
	},
	{
		"stop_id": 8530752,
		"ID": 1026,
		"x": 40.1137257223,
		"y": -13.081803569,
		"h": 1.1318681319
	},
	{
		"stop_id": 8530753,
		"ID": 1026,
		"x": 38.1677092783,
		"y": -13.371796455,
		"h": 1.1318681319
	},
	{
		"stop_id": 8587600,
		"ID": 1026,
		"x": 40.1577440553,
		"y": -13.169794409,
		"h": 1.1318681319
	},
	{
		"stop_id": 8505179,
		"ID": 1095,
		"x": 46.6697168803,
		"y": -10.539802806,
		"h": 1.7252747253
	},
	{
		"stop_id": 8505180,
		"ID": 1095,
		"x": 47.8787573893,
		"y": -9.831786803,
		"h": 1.7252747253
	},
	{
		"stop_id": 8509179,
		"ID": 1095,
		"x": 48.5697142333,
		"y": -8.95177716,
		"h": 1.7252747253
	},
	{
		"stop_id": 8509742,
		"ID": 1095,
		"x": 48.4747101883,
		"y": -10.838853572,
		"h": 1.7252747253
	},
	{
		"stop_id": 8530573,
		"ID": 1095,
		"x": 47.5147399873,
		"y": -9.418805636,
		"h": 1.7252747253
	},
	{
		"stop_id": 8530574,
		"ID": 1095,
		"x": 45.5767577543,
		"y": -9.058768744,
		"h": 1.7252747253
	},
	{
		"stop_id": 8574888,
		"ID": 1095,
		"x": 48.5677250313,
		"y": -8.934801768,
		"h": 1.7252747253
	},
	{
		"stop_id": 8574890,
		"ID": 1095,
		"x": 49.4947290493,
		"y": -8.916770514,
		"h": 1.7252747253
	},
	{
		"stop_id": 8574895,
		"ID": 1095,
		"x": 50.8107419083,
		"y": -8.358859645,
		"h": 1.7252747253
	},
	{
		"stop_id": 8574896,
		"ID": 1095,
		"x": 48.5397666723,
		"y": -10.021805701,
		"h": 1.7252747253
	},
	{
		"stop_id": 8575103,
		"ID": 1095,
		"x": 49.1517274643,
		"y": -8.615801687,
		"h": 1.7252747253
	},
	{
		"stop_id": 8575104,
		"ID": 1095,
		"x": 48.7997212953,
		"y": -8.719801775,
		"h": 1.7252747253
	},
	{
		"stop_id": 8575105,
		"ID": 1095,
		"x": 48.5527454243,
		"y": -8.994778542,
		"h": 1.7252747253
	},
	{
		"stop_id": 8575106,
		"ID": 1095,
		"x": 48.1607132073,
		"y": -9.090790477,
		"h": 1.7252747253
	},
	{
		"stop_id": 8575107,
		"ID": 1095,
		"x": 47.9737356393,
		"y": -9.352766352,
		"h": 1.7252747253
	},
	{
		"stop_id": 8575108,
		"ID": 1095,
		"x": 47.7227302133,
		"y": -9.807787912,
		"h": 1.7252747253
	},
	{
		"stop_id": 8575110,
		"ID": 1095,
		"x": 47.5327155203,
		"y": -9.465848898,
		"h": 1.7252747253
	},
	{
		"stop_id": 8575111,
		"ID": 1095,
		"x": 47.2116993983,
		"y": -9.591770583,
		"h": 1.7252747253
	},
	{
		"stop_id": 8582764,
		"ID": 1095,
		"x": 49.2687264413,
		"y": -8.555749157,
		"h": 1.7252747253
	},
	{
		"stop_id": 8582934,
		"ID": 1095,
		"x": 47.3427226493,
		"y": -9.616784884,
		"h": 1.7252747253
	},
	{
		"stop_id": 8583426,
		"ID": 1095,
		"x": 48.5837559173,
		"y": -9.233822328,
		"h": 1.7252747253
	},
	{
		"stop_id": 8587605,
		"ID": 1095,
		"x": 47.0577744423,
		"y": -10.269846587,
		"h": 1.7252747253
	},
	{
		"stop_id": 8587606,
		"ID": 1095,
		"x": 47.7577091623,
		"y": -9.56978206,
		"h": 1.7252747253
	},
	{
		"stop_id": 8505201,
		"ID": 957,
		"x": 30.0217673043,
		"y": -28.986801315,
		"h": 1.3296703297
	},
	{
		"stop_id": 8505769,
		"ID": 957,
		"x": 26.7657379283,
		"y": -25.936858849,
		"h": 1.3296703297
	},
	{
		"stop_id": 8573143,
		"ID": 957,
		"x": 26.9307118363,
		"y": -28.056854926,
		"h": 1.3296703297
	},
	{
		"stop_id": 8573144,
		"ID": 957,
		"x": 27.4017063123,
		"y": -28.146778308,
		"h": 1.3296703297
	},
	{
		"stop_id": 8573145,
		"ID": 957,
		"x": 28.3957603673,
		"y": -28.221802026,
		"h": 1.3296703297
	},
	{
		"stop_id": 8575689,
		"ID": 957,
		"x": 29.9907581873,
		"y": -28.970809318,
		"h": 1.3296703297
	},
	{
		"stop_id": 8575690,
		"ID": 957,
		"x": 29.4257729863,
		"y": -29.292836762,
		"h": 1.3296703297
	},
	{
		"stop_id": 8575691,
		"ID": 957,
		"x": 28.5427304673,
		"y": -29.42280992,
		"h": 1.3296703297
	},
	{
		"stop_id": 8575696,
		"ID": 957,
		"x": 29.7527094073,
		"y": -29.325785797,
		"h": 1.3296703297
	},
	{
		"stop_id": 8580395,
		"ID": 957,
		"x": 28.6487556683,
		"y": -28.772756329,
		"h": 1.3296703297
	},
	{
		"stop_id": 8581249,
		"ID": 957,
		"x": 30.3617466803,
		"y": -28.871767154,
		"h": 1.3296703297
	},
	{
		"stop_id": 8505202,
		"ID": 1023,
		"x": 36.3077412013,
		"y": -30.769828122,
		"h": 1.5934065934
	},
	{
		"stop_id": 8505221,
		"ID": 1023,
		"x": 40.1787256753,
		"y": -33.157808918,
		"h": 1.5934065934
	},
	{
		"stop_id": 8505992,
		"ID": 1023,
		"x": 37.9167032373,
		"y": -30.716819114,
		"h": 1.5934065934
	},
	{
		"stop_id": 8575701,
		"ID": 1023,
		"x": 36.2777414373,
		"y": -30.765859421,
		"h": 1.5934065934
	},
	{
		"stop_id": 8575702,
		"ID": 1023,
		"x": 36.6977278173,
		"y": -30.906793773,
		"h": 1.5934065934
	},
	{
		"stop_id": 8575703,
		"ID": 1023,
		"x": 37.3467347883,
		"y": -31.062800179,
		"h": 1.5934065934
	},
	{
		"stop_id": 8575704,
		"ID": 1023,
		"x": 37.4977564733,
		"y": -30.59385273,
		"h": 1.5934065934
	},
	{
		"stop_id": 8575705,
		"ID": 1023,
		"x": 38.2187174103,
		"y": -30.860783111,
		"h": 1.5934065934
	},
	{
		"stop_id": 8575706,
		"ID": 1023,
		"x": 38.0077760753,
		"y": -30.269843076,
		"h": 1.5934065934
	},
	{
		"stop_id": 8575710,
		"ID": 1023,
		"x": 38.4357053133,
		"y": -30.647785669,
		"h": 1.5934065934
	},
	{
		"stop_id": 8575711,
		"ID": 1023,
		"x": 39.7567661693,
		"y": -31.48085516,
		"h": 1.5934065934
	},
	{
		"stop_id": 8575712,
		"ID": 1023,
		"x": 39.9247653883,
		"y": -31.194788981,
		"h": 1.5934065934
	},
	{
		"stop_id": 8579527,
		"ID": 1023,
		"x": 39.9267309893,
		"y": -32.904823525,
		"h": 1.5934065934
	},
	{
		"stop_id": 8579870,
		"ID": 1023,
		"x": 40.7077248153,
		"y": -33.128775405,
		"h": 1.5934065934
	},
	{
		"stop_id": 8580141,
		"ID": 1023,
		"x": 40.3997375773,
		"y": -33.208839417,
		"h": 1.5934065934
	},
	{
		"stop_id": 8580142,
		"ID": 1023,
		"x": 39.7667166133,
		"y": -32.612841152,
		"h": 1.5934065934
	},
	{
		"stop_id": 8581844,
		"ID": 1023,
		"x": 39.1517307193,
		"y": -31.704843835,
		"h": 1.5934065934
	},
	{
		"stop_id": 8583568,
		"ID": 1023,
		"x": 41.5967656433,
		"y": -32.88785267,
		"h": 1.5934065934
	},
	{
		"stop_id": 8587460,
		"ID": 1023,
		"x": 39.0187305303,
		"y": -31.941839123,
		"h": 1.5934065934
	},
	{
		"stop_id": 8505204,
		"ID": 1056,
		"x": 44.0767667473,
		"y": -33.702826733,
		"h": 1.989010989
	},
	{
		"stop_id": 8505767,
		"ID": 1056,
		"x": 43.3557281313,
		"y": -32.556810397,
		"h": 1.989010989
	},
	{
		"stop_id": 8505973,
		"ID": 1056,
		"x": 44.9347277893,
		"y": -34.282802389,
		"h": 1.989010989
	},
	{
		"stop_id": 8575715,
		"ID": 1056,
		"x": 44.1127101223,
		"y": -33.711768781,
		"h": 1.989010989
	},
	{
		"stop_id": 8575716,
		"ID": 1056,
		"x": 44.0077612233,
		"y": -33.303761562,
		"h": 1.989010989
	},
	{
		"stop_id": 8575717,
		"ID": 1056,
		"x": 43.8687175283,
		"y": -33.046768091,
		"h": 1.989010989
	},
	{
		"stop_id": 8575722,
		"ID": 1056,
		"x": 45.0947206743,
		"y": -34.154829374,
		"h": 1.989010989
	},
	{
		"stop_id": 8575723,
		"ID": 1056,
		"x": 45.8427526493,
		"y": -34.242829959,
		"h": 1.989010989
	},
	{
		"stop_id": 8575724,
		"ID": 1056,
		"x": 45.2687216223,
		"y": -33.755768302,
		"h": 1.989010989
	},
	{
		"stop_id": 8575725,
		"ID": 1056,
		"x": 45.1747227133,
		"y": -33.288773853,
		"h": 1.989010989
	},
	{
		"stop_id": 8575732,
		"ID": 1056,
		"x": 46.4387501053,
		"y": -35.360856163,
		"h": 1.989010989
	},
	{
		"stop_id": 8580122,
		"ID": 1056,
		"x": 44.0627766753,
		"y": -33.835818768,
		"h": 1.989010989
	},
	{
		"stop_id": 8580123,
		"ID": 1056,
		"x": 43.7377648083,
		"y": -33.599812987,
		"h": 1.989010989
	},
	{
		"stop_id": 8580124,
		"ID": 1056,
		"x": 45.2527241003,
		"y": -34.234797099,
		"h": 1.989010989
	},
	{
		"stop_id": 8580128,
		"ID": 1056,
		"x": 43.9897175293,
		"y": -33.098830924,
		"h": 1.989010989
	},
	{
		"stop_id": 8580129,
		"ID": 1056,
		"x": 44.2387094393,
		"y": -33.331799551,
		"h": 1.989010989
	},
	{
		"stop_id": 8580130,
		"ID": 1056,
		"x": 43.9597264483,
		"y": -33.448791368,
		"h": 1.989010989
	},
	{
		"stop_id": 8580131,
		"ID": 1056,
		"x": 44.3487103943,
		"y": -34.066812503,
		"h": 1.989010989
	},
	{
		"stop_id": 8580132,
		"ID": 1056,
		"x": 44.7387423233,
		"y": -34.204819405,
		"h": 1.989010989
	},
	{
		"stop_id": 8580133,
		"ID": 1056,
		"x": 45.6717331763,
		"y": -34.04280622,
		"h": 1.989010989
	},
	{
		"stop_id": 8580134,
		"ID": 1056,
		"x": 45.6097123553,
		"y": -34.132836913,
		"h": 1.989010989
	},
	{
		"stop_id": 8580135,
		"ID": 1056,
		"x": 42.8367042893,
		"y": -34.453753856,
		"h": 1.989010989
	},
	{
		"stop_id": 8580136,
		"ID": 1056,
		"x": 42.8907020133,
		"y": -34.701769129,
		"h": 1.989010989
	},
	{
		"stop_id": 8580137,
		"ID": 1056,
		"x": 42.7127056293,
		"y": -34.361804519,
		"h": 1.989010989
	},
	{
		"stop_id": 8580138,
		"ID": 1056,
		"x": 42.7517350743,
		"y": -34.014811014,
		"h": 1.989010989
	},
	{
		"stop_id": 8580139,
		"ID": 1056,
		"x": 41.4877557493,
		"y": -33.748780647,
		"h": 1.989010989
	},
	{
		"stop_id": 8580140,
		"ID": 1056,
		"x": 41.1847224423,
		"y": -33.763760423,
		"h": 1.989010989
	},
	{
		"stop_id": 8580771,
		"ID": 1056,
		"x": 44.5217552493,
		"y": -34.004782461,
		"h": 1.989010989
	},
	{
		"stop_id": 8580808,
		"ID": 1056,
		"x": 43.5217143933,
		"y": -33.531808474,
		"h": 1.989010989
	},
	{
		"stop_id": 8581302,
		"ID": 1056,
		"x": 44.8377667923,
		"y": -34.3917769,
		"h": 1.989010989
	},
	{
		"stop_id": 8581713,
		"ID": 1056,
		"x": 45.3017695033,
		"y": -34.624858223,
		"h": 1.989010989
	},
	{
		"stop_id": 8505205,
		"ID": 1090,
		"x": 47.9257499623,
		"y": -38.324841374,
		"h": 1.3626373626
	},
	{
		"stop_id": 8505974,
		"ID": 1090,
		"x": 48.3147446003,
		"y": -40.267806401,
		"h": 1.3626373626
	},
	{
		"stop_id": 8575733,
		"ID": 1090,
		"x": 47.9347740723,
		"y": -38.300775897,
		"h": 1.3626373626
	},
	{
		"stop_id": 8575734,
		"ID": 1090,
		"x": 48.1327282553,
		"y": -38.869828367,
		"h": 1.3626373626
	},
	{
		"stop_id": 8575735,
		"ID": 1090,
		"x": 48.3827680023,
		"y": -40.819833011,
		"h": 1.3626373626
	},
	{
		"stop_id": 8575736,
		"ID": 1090,
		"x": 48.9087396393,
		"y": -38.657764842,
		"h": 1.3626373626
	},
	{
		"stop_id": 8575737,
		"ID": 1090,
		"x": 48.3387093443,
		"y": -37.740857007,
		"h": 1.3626373626
	},
	{
		"stop_id": 8575738,
		"ID": 1090,
		"x": 47.9667019903,
		"y": -37.192824823,
		"h": 1.3626373626
	},
	{
		"stop_id": 8575739,
		"ID": 1090,
		"x": 49.6837055733,
		"y": -39.360769399,
		"h": 1.3626373626
	},
	{
		"stop_id": 8581248,
		"ID": 1090,
		"x": 47.0357638863,
		"y": -36.571757439,
		"h": 1.3626373626
	},
	{
		"stop_id": 8583567,
		"ID": 1090,
		"x": 48.3697114653,
		"y": -39.439842967,
		"h": 1.3626373626
	},
	{
		"stop_id": 8587473,
		"ID": 1090,
		"x": 49.4197076193,
		"y": -40.417792919,
		"h": 1.3626373626
	},
	{
		"stop_id": 8505207,
		"ID": 1125,
		"x": 53.1857736313,
		"y": -44.970823453,
		"h": 1.2307692308
	},
	{
		"stop_id": 8579104,
		"ID": 1125,
		"x": 55.2857394713,
		"y": -46.231804502,
		"h": 1.2307692308
	},
	{
		"stop_id": 8580589,
		"ID": 1125,
		"x": 56.0567402333,
		"y": -46.662804235,
		"h": 1.2307692308
	},
	{
		"stop_id": 8580590,
		"ID": 1125,
		"x": 53.2397298323,
		"y": -45.016844535,
		"h": 1.2307692308
	},
	{
		"stop_id": 8582964,
		"ID": 1125,
		"x": 54.0037664433,
		"y": -45.837822392,
		"h": 1.2307692308
	},
	{
		"stop_id": 8582965,
		"ID": 1125,
		"x": 54.1037336543,
		"y": -46.053859594,
		"h": 1.2307692308
	},
	{
		"stop_id": 8583876,
		"ID": 1125,
		"x": 53.8947561533,
		"y": -45.406811679,
		"h": 1.2307692308
	},
	{
		"stop_id": 8587472,
		"ID": 1125,
		"x": 53.6437036083,
		"y": -45.2947898,
		"h": 1.2307692308
	},
	{
		"stop_id": 8505209,
		"ID": 1160,
		"x": 58.4477743193,
		"y": -48.013849751,
		"h": 1.6923076923
	},
	{
		"stop_id": 8575206,
		"ID": 1160,
		"x": 58.5937739723,
		"y": -52.602760162,
		"h": 1.6923076923
	},
	{
		"stop_id": 8575207,
		"ID": 1160,
		"x": 58.5337113333,
		"y": -52.222789734,
		"h": 1.6923076923
	},
	{
		"stop_id": 8575208,
		"ID": 1160,
		"x": 58.3827302033,
		"y": -51.912754376,
		"h": 1.6923076923
	},
	{
		"stop_id": 8575209,
		"ID": 1160,
		"x": 58.1937353863,
		"y": -51.331830081,
		"h": 1.6923076923
	},
	{
		"stop_id": 8575211,
		"ID": 1160,
		"x": 58.0757310833,
		"y": -50.743845833,
		"h": 1.6923076923
	},
	{
		"stop_id": 8575212,
		"ID": 1160,
		"x": 58.0057088813,
		"y": -50.39975617,
		"h": 1.6923076923
	},
	{
		"stop_id": 8575213,
		"ID": 1160,
		"x": 57.8947715323,
		"y": -50.093821414,
		"h": 1.6923076923
	},
	{
		"stop_id": 8575214,
		"ID": 1160,
		"x": 57.6167403383,
		"y": -49.328823151,
		"h": 1.6923076923
	},
	{
		"stop_id": 8575215,
		"ID": 1160,
		"x": 57.5326988053,
		"y": -48.946753334,
		"h": 1.6923076923
	},
	{
		"stop_id": 8575216,
		"ID": 1160,
		"x": 57.2287704673,
		"y": -48.27085712,
		"h": 1.6923076923
	},
	{
		"stop_id": 8575217,
		"ID": 1160,
		"x": 57.6667532023,
		"y": -47.742784409,
		"h": 1.6923076923
	},
	{
		"stop_id": 8575218,
		"ID": 1160,
		"x": 58.1337213323,
		"y": -47.701774757,
		"h": 1.6923076923
	},
	{
		"stop_id": 8575220,
		"ID": 1160,
		"x": 58.2907257753,
		"y": -47.356809844,
		"h": 1.6923076923
	},
	{
		"stop_id": 8575221,
		"ID": 1160,
		"x": 58.4377354433,
		"y": -48.039841459,
		"h": 1.6923076923
	},
	{
		"stop_id": 8581714,
		"ID": 1160,
		"x": 58.0317629563,
		"y": -47.147834283,
		"h": 1.6923076923
	},
	{
		"stop_id": 8581715,
		"ID": 1160,
		"x": 57.5177040663,
		"y": -47.171850816,
		"h": 1.6923076923
	},
	{
		"stop_id": 8581721,
		"ID": 1160,
		"x": 58.5327290273,
		"y": -48.510856383,
		"h": 1.6923076923
	},
	{
		"stop_id": 8582679,
		"ID": 1160,
		"x": 58.1677180843,
		"y": -46.982848615,
		"h": 1.6923076923
	},
	{
		"stop_id": 8587464,
		"ID": 1160,
		"x": 58.6317366593,
		"y": -49.087751925,
		"h": 1.6923076923
	},
	{
		"stop_id": 8587465,
		"ID": 1160,
		"x": 59.3877625723,
		"y": -52.559805708,
		"h": 1.6923076923
	},
	{
		"stop_id": 8587470,
		"ID": 1160,
		"x": 57.0247066393,
		"y": -47.114806511,
		"h": 1.6923076923
	},
	{
		"stop_id": 8505212,
		"ID": 1194,
		"x": 63.9097380123,
		"y": -61.994787964,
		"h": 3.6373626374
	},
	{
		"stop_id": 8505213,
		"ID": 1194,
		"x": 63.0597019363,
		"y": -65.327839891,
		"h": 3.6373626374
	},
	{
		"stop_id": 8505950,
		"ID": 1194,
		"x": 63.0417732643,
		"y": -65.311858832,
		"h": 3.6373626374
	},
	{
		"stop_id": 8505951,
		"ID": 1194,
		"x": 63.8037379513,
		"y": -63.368795471,
		"h": 3.6373626374
	},
	{
		"stop_id": 8505952,
		"ID": 1194,
		"x": 64.4927537473,
		"y": -61.952825616,
		"h": 3.6373626374
	},
	{
		"stop_id": 8505977,
		"ID": 1194,
		"x": 65.3557568153,
		"y": -61.575794687,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575122,
		"ID": 1194,
		"x": 62.5407274793,
		"y": -65.949766743,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575123,
		"ID": 1194,
		"x": 62.2117530103,
		"y": -66.696801916,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575124,
		"ID": 1194,
		"x": 62.1067422683,
		"y": -66.962764678,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575152,
		"ID": 1194,
		"x": 62.4287146623,
		"y": -65.522842029,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575153,
		"ID": 1194,
		"x": 62.1957070903,
		"y": -65.69676706,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575154,
		"ID": 1194,
		"x": 62.0897274903,
		"y": -65.909823819,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575155,
		"ID": 1194,
		"x": 61.8207212003,
		"y": -65.995841448,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575156,
		"ID": 1194,
		"x": 61.5077752393,
		"y": -65.877808055,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575178,
		"ID": 1194,
		"x": 62.7577507743,
		"y": -65.069773692,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575179,
		"ID": 1194,
		"x": 62.4827356953,
		"y": -64.901767443,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575180,
		"ID": 1194,
		"x": 62.2757261773,
		"y": -64.858799422,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575181,
		"ID": 1194,
		"x": 61.9537392053,
		"y": -64.453774278,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575182,
		"ID": 1194,
		"x": 62.2207029913,
		"y": -64.181773226,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575183,
		"ID": 1194,
		"x": 63.0057746273,
		"y": -63.612855203,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575184,
		"ID": 1194,
		"x": 63.2157014063,
		"y": -63.447816275,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575185,
		"ID": 1194,
		"x": 63.3177759053,
		"y": -63.289855919,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575186,
		"ID": 1194,
		"x": 63.2787382883,
		"y": -63.009788055,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575187,
		"ID": 1194,
		"x": 63.3537752923,
		"y": -62.801785812,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575188,
		"ID": 1194,
		"x": 63.2277613133,
		"y": -62.521818369,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575222,
		"ID": 1194,
		"x": 63.0327188403,
		"y": -64.994822485,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575223,
		"ID": 1194,
		"x": 63.3447427643,
		"y": -64.623789247,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575224,
		"ID": 1194,
		"x": 63.9437697433,
		"y": -62.077817351,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575225,
		"ID": 1194,
		"x": 64.2966998563,
		"y": -61.743810253,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575226,
		"ID": 1194,
		"x": 64.6567120433,
		"y": -62.097782966,
		"h": 3.6373626374
	},
	{
		"stop_id": 8579671,
		"ID": 1194,
		"x": 61.7297436963,
		"y": -65.929842641,
		"h": 3.6373626374
	},
	{
		"stop_id": 8579672,
		"ID": 1194,
		"x": 62.0137075383,
		"y": -65.769810725,
		"h": 3.6373626374
	},
	{
		"stop_id": 8579936,
		"ID": 1194,
		"x": 62.9567538453,
		"y": -65.383853318,
		"h": 3.6373626374
	},
	{
		"stop_id": 8580519,
		"ID": 1194,
		"x": 64.4877249663,
		"y": -62.598823647,
		"h": 3.6373626374
	},
	{
		"stop_id": 8581240,
		"ID": 1194,
		"x": 63.2977426293,
		"y": -65.908858471,
		"h": 3.6373626374
	},
	{
		"stop_id": 8581241,
		"ID": 1194,
		"x": 62.8787502233,
		"y": -66.53078309,
		"h": 3.6373626374
	},
	{
		"stop_id": 8581242,
		"ID": 1194,
		"x": 62.8257568243,
		"y": -64.134750768,
		"h": 3.6373626374
	},
	{
		"stop_id": 8581243,
		"ID": 1194,
		"x": 61.8377697273,
		"y": -66.852757315,
		"h": 3.6373626374
	},
	{
		"stop_id": 8581251,
		"ID": 1194,
		"x": 63.8727255293,
		"y": -63.522828367,
		"h": 3.6373626374
	},
	{
		"stop_id": 8581252,
		"ID": 1194,
		"x": 64.1607170383,
		"y": -63.352825628,
		"h": 3.6373626374
	},
	{
		"stop_id": 8581258,
		"ID": 1194,
		"x": 62.5427358903,
		"y": -65.429810853,
		"h": 3.6373626374
	},
	{
		"stop_id": 8581259,
		"ID": 1194,
		"x": 61.9177374523,
		"y": -66.277755588,
		"h": 3.6373626374
	},
	{
		"stop_id": 8581551,
		"ID": 1194,
		"x": 62.7347243483,
		"y": -65.465846823,
		"h": 3.6373626374
	},
	{
		"stop_id": 8581574,
		"ID": 1194,
		"x": 61.9277318573,
		"y": -65.53381935,
		"h": 3.6373626374
	},
	{
		"stop_id": 8581766,
		"ID": 1194,
		"x": 62.9357747233,
		"y": -61.884854969,
		"h": 3.6373626374
	},
	{
		"stop_id": 8582702,
		"ID": 1194,
		"x": 62.6977495403,
		"y": -65.374753276,
		"h": 3.6373626374
	},
	{
		"stop_id": 8582979,
		"ID": 1194,
		"x": 64.6827028583,
		"y": -62.494859442,
		"h": 3.6373626374
	},
	{
		"stop_id": 8582980,
		"ID": 1194,
		"x": 64.0247712173,
		"y": -63.170811746,
		"h": 3.6373626374
	},
	{
		"stop_id": 8582981,
		"ID": 1194,
		"x": 64.1937009523,
		"y": -62.965770086,
		"h": 3.6373626374
	},
	{
		"stop_id": 8582982,
		"ID": 1194,
		"x": 64.3267345633,
		"y": -62.218859191,
		"h": 3.6373626374
	},
	{
		"stop_id": 8582983,
		"ID": 1194,
		"x": 64.1247174773,
		"y": -61.797812803,
		"h": 3.6373626374
	},
	{
		"stop_id": 8582994,
		"ID": 1194,
		"x": 62.2417028143,
		"y": -65.116773871,
		"h": 3.6373626374
	},
	{
		"stop_id": 8582995,
		"ID": 1194,
		"x": 62.6757697583,
		"y": -64.371836618,
		"h": 3.6373626374
	},
	{
		"stop_id": 8582996,
		"ID": 1194,
		"x": 62.1867279483,
		"y": -65.438769538,
		"h": 3.6373626374
	},
	{
		"stop_id": 8582997,
		"ID": 1194,
		"x": 61.8257164013,
		"y": -65.740787546,
		"h": 3.6373626374
	},
	{
		"stop_id": 8582998,
		"ID": 1194,
		"x": 62.9827655883,
		"y": -65.794833691,
		"h": 3.6373626374
	},
	{
		"stop_id": 8582999,
		"ID": 1194,
		"x": 62.3337057153,
		"y": -66.386798787,
		"h": 3.6373626374
	},
	{
		"stop_id": 8583000,
		"ID": 1194,
		"x": 63.1797738853,
		"y": -64.601790193,
		"h": 3.6373626374
	},
	{
		"stop_id": 8583002,
		"ID": 1194,
		"x": 63.7007105763,
		"y": -63.948854846,
		"h": 3.6373626374
	},
	{
		"stop_id": 8583003,
		"ID": 1194,
		"x": 62.6947232293,
		"y": -66.095758178,
		"h": 3.6373626374
	},
	{
		"stop_id": 8583004,
		"ID": 1194,
		"x": 63.2097350293,
		"y": -64.799763993,
		"h": 3.6373626374
	},
	{
		"stop_id": 8583005,
		"ID": 1194,
		"x": 61.8187504353,
		"y": -66.497782795,
		"h": 3.6373626374
	},
	{
		"stop_id": 8583006,
		"ID": 1194,
		"x": 63.5197365513,
		"y": -64.341813122,
		"h": 3.6373626374
	},
	{
		"stop_id": 8583007,
		"ID": 1194,
		"x": 62.9337516113,
		"y": -64.648809698,
		"h": 3.6373626374
	},
	{
		"stop_id": 8583009,
		"ID": 1194,
		"x": 62.3917507373,
		"y": -65.171788982,
		"h": 3.6373626374
	},
	{
		"stop_id": 8583010,
		"ID": 1194,
		"x": 63.4517362523,
		"y": -63.932801245,
		"h": 3.6373626374
	},
	{
		"stop_id": 8583013,
		"ID": 1194,
		"x": 62.9167055593,
		"y": -65.533768119,
		"h": 3.6373626374
	},
	{
		"stop_id": 8583014,
		"ID": 1194,
		"x": 62.3387612853,
		"y": -65.886795635,
		"h": 3.6373626374
	},
	{
		"stop_id": 8583015,
		"ID": 1194,
		"x": 62.4257366353,
		"y": -64.613829178,
		"h": 3.6373626374
	},
	{
		"stop_id": 8583018,
		"ID": 1194,
		"x": 62.9937041613,
		"y": -64.334822222,
		"h": 3.6373626374
	},
	{
		"stop_id": 8583021,
		"ID": 1194,
		"x": 62.4797440053,
		"y": -64.814767642,
		"h": 3.6373626374
	},
	{
		"stop_id": 8583022,
		"ID": 1194,
		"x": 63.1017462363,
		"y": -65.603845723,
		"h": 3.6373626374
	},
	{
		"stop_id": 8583023,
		"ID": 1194,
		"x": 62.9617592463,
		"y": -65.89377217,
		"h": 3.6373626374
	},
	{
		"stop_id": 8583024,
		"ID": 1194,
		"x": 63.0947508783,
		"y": -65.47979037,
		"h": 3.6373626374
	},
	{
		"stop_id": 8583025,
		"ID": 1194,
		"x": 63.2147149083,
		"y": -65.48980848,
		"h": 3.6373626374
	},
	{
		"stop_id": 8583026,
		"ID": 1194,
		"x": 62.6127343703,
		"y": -66.375830406,
		"h": 3.6373626374
	},
	{
		"stop_id": 8583027,
		"ID": 1194,
		"x": 62.5587644233,
		"y": -66.54081188,
		"h": 3.6373626374
	},
	{
		"stop_id": 8583028,
		"ID": 1194,
		"x": 62.6437160953,
		"y": -66.647837625,
		"h": 3.6373626374
	},
	{
		"stop_id": 8583029,
		"ID": 1194,
		"x": 62.8077619753,
		"y": -66.491858768,
		"h": 3.6373626374
	},
	{
		"stop_id": 8583691,
		"ID": 1194,
		"x": 64.3497423603,
		"y": -62.73875005,
		"h": 3.6373626374
	},
	{
		"stop_id": 8583703,
		"ID": 1194,
		"x": 63.0197070293,
		"y": -66.146773942,
		"h": 3.6373626374
	},
	{
		"stop_id": 8505214,
		"ID": 1157,
		"x": 61.1067066483,
		"y": -67.770788866,
		"h": 2.0549450549
	},
	{
		"stop_id": 8505415,
		"ID": 1157,
		"x": 58.8457534483,
		"y": -69.302822964,
		"h": 2.0549450549
	},
	{
		"stop_id": 8505948,
		"ID": 1157,
		"x": 60.4907721753,
		"y": -66.210857114,
		"h": 2.0549450549
	},
	{
		"stop_id": 8570418,
		"ID": 1157,
		"x": 60.7007419453,
		"y": -68.999825,
		"h": 2.0549450549
	},
	{
		"stop_id": 8575157,
		"ID": 1157,
		"x": 60.8557624323,
		"y": -65.983781618,
		"h": 2.0549450549
	},
	{
		"stop_id": 8575158,
		"ID": 1157,
		"x": 60.1027414593,
		"y": -66.480839621,
		"h": 2.0549450549
	},
	{
		"stop_id": 8575159,
		"ID": 1157,
		"x": 60.1237719073,
		"y": -66.69279097,
		"h": 2.0549450549
	},
	{
		"stop_id": 8575160,
		"ID": 1157,
		"x": 60.2597536793,
		"y": -66.921812255,
		"h": 2.0549450549
	},
	{
		"stop_id": 8575161,
		"ID": 1157,
		"x": 60.4017541093,
		"y": -67.15782731,
		"h": 2.0549450549
	},
	{
		"stop_id": 8575162,
		"ID": 1157,
		"x": 60.5007425803,
		"y": -67.323755787,
		"h": 2.0549450549
	},
	{
		"stop_id": 8575163,
		"ID": 1157,
		"x": 59.7157589213,
		"y": -66.660825598,
		"h": 2.0549450549
	},
	{
		"stop_id": 8575164,
		"ID": 1157,
		"x": 58.6447026663,
		"y": -67.309840459,
		"h": 2.0549450549
	},
	{
		"stop_id": 8575165,
		"ID": 1157,
		"x": 57.6806989423,
		"y": -67.539749532,
		"h": 2.0549450549
	},
	{
		"stop_id": 8575166,
		"ID": 1157,
		"x": 57.1087656293,
		"y": -67.700800491,
		"h": 2.0549450549
	},
	{
		"stop_id": 8575167,
		"ID": 1157,
		"x": 56.4137614473,
		"y": -67.821796308,
		"h": 2.0549450549
	},
	{
		"stop_id": 8575168,
		"ID": 1157,
		"x": 56.0907524153,
		"y": -67.842769552,
		"h": 2.0549450549
	},
	{
		"stop_id": 8580789,
		"ID": 1157,
		"x": 57.9507640323,
		"y": -69.907784727,
		"h": 2.0549450549
	},
	{
		"stop_id": 8581105,
		"ID": 1157,
		"x": 59.0217159523,
		"y": -69.773811031,
		"h": 2.0549450549
	},
	{
		"stop_id": 8581244,
		"ID": 1157,
		"x": 60.6977575683,
		"y": -67.827856772,
		"h": 2.0549450549
	},
	{
		"stop_id": 8581586,
		"ID": 1157,
		"x": 58.8497552693,
		"y": -69.471748723,
		"h": 2.0549450549
	},
	{
		"stop_id": 8581587,
		"ID": 1157,
		"x": 58.3967630923,
		"y": -69.709754307,
		"h": 2.0549450549
	},
	{
		"stop_id": 8581588,
		"ID": 1157,
		"x": 58.2477041443,
		"y": -69.879772438,
		"h": 2.0549450549
	},
	{
		"stop_id": 8581595,
		"ID": 1157,
		"x": 59.2077448843,
		"y": -69.917818242,
		"h": 2.0549450549
	},
	{
		"stop_id": 8582974,
		"ID": 1157,
		"x": 59.6517766523,
		"y": -69.719844458,
		"h": 2.0549450549
	},
	{
		"stop_id": 8582975,
		"ID": 1157,
		"x": 60.3537561813,
		"y": -69.345835019,
		"h": 2.0549450549
	},
	{
		"stop_id": 8582976,
		"ID": 1157,
		"x": 59.9427286823,
		"y": -69.549769382,
		"h": 2.0549450549
	},
	{
		"stop_id": 8582977,
		"ID": 1157,
		"x": 60.6607596463,
		"y": -69.20776212,
		"h": 2.0549450549
	},
	{
		"stop_id": 8582978,
		"ID": 1157,
		"x": 60.4297261943,
		"y": -68.571798289,
		"h": 2.0549450549
	},
	{
		"stop_id": 8582990,
		"ID": 1157,
		"x": 61.1387631443,
		"y": -67.770816325,
		"h": 2.0549450549
	},
	{
		"stop_id": 8583239,
		"ID": 1157,
		"x": 59.3827045053,
		"y": -69.867793647,
		"h": 2.0549450549
	},
	{
		"stop_id": 8583674,
		"ID": 1157,
		"x": 61.1277399963,
		"y": -65.817803969,
		"h": 2.0549450549
	},
	{
		"stop_id": 8583675,
		"ID": 1157,
		"x": 60.7297631603,
		"y": -67.708805613,
		"h": 2.0549450549
	},
	{
		"stop_id": 8583676,
		"ID": 1157,
		"x": 61.2997459373,
		"y": -68.041790326,
		"h": 2.0549450549
	},
	{
		"stop_id": 8505216,
		"ID": 1120,
		"x": 55.1657401623,
		"y": -73.427788735,
		"h": 1.6923076923
	},
	{
		"stop_id": 8505217,
		"ID": 1120,
		"x": 55.4837107733,
		"y": -76.723758156,
		"h": 1.6923076923
	},
	{
		"stop_id": 8505898,
		"ID": 1120,
		"x": 55.1327320173,
		"y": -73.419852936,
		"h": 1.6923076923
	},
	{
		"stop_id": 8530459,
		"ID": 1120,
		"x": 54.7187745823,
		"y": -73.090789606,
		"h": 1.6923076923
	},
	{
		"stop_id": 8530460,
		"ID": 1120,
		"x": 52.7177675873,
		"y": -74.27978201,
		"h": 1.6923076923
	},
	{
		"stop_id": 8570128,
		"ID": 1120,
		"x": 56.1197633303,
		"y": -74.891855783,
		"h": 1.6923076923
	},
	{
		"stop_id": 8575743,
		"ID": 1120,
		"x": 54.9017603963,
		"y": -73.233763663,
		"h": 1.6923076923
	},
	{
		"stop_id": 8575745,
		"ID": 1120,
		"x": 55.2657491183,
		"y": -73.894763419,
		"h": 1.6923076923
	},
	{
		"stop_id": 8575746,
		"ID": 1120,
		"x": 55.5017592203,
		"y": -74.266758036,
		"h": 1.6923076923
	},
	{
		"stop_id": 8575747,
		"ID": 1120,
		"x": 55.6747311463,
		"y": -74.595803354,
		"h": 1.6923076923
	},
	{
		"stop_id": 8575748,
		"ID": 1120,
		"x": 55.9807625653,
		"y": -74.569846127,
		"h": 1.6923076923
	},
	{
		"stop_id": 8575749,
		"ID": 1120,
		"x": 56.1727140443,
		"y": -74.627777108,
		"h": 1.6923076923
	},
	{
		"stop_id": 8575755,
		"ID": 1120,
		"x": 55.9047167293,
		"y": -75.423761651,
		"h": 1.6923076923
	},
	{
		"stop_id": 8575756,
		"ID": 1120,
		"x": 55.9467683413,
		"y": -75.730834435,
		"h": 1.6923076923
	},
	{
		"stop_id": 8575757,
		"ID": 1120,
		"x": 55.4607597873,
		"y": -76.659817267,
		"h": 1.6923076923
	},
	{
		"stop_id": 8575758,
		"ID": 1120,
		"x": 55.1587217073,
		"y": -76.538793808,
		"h": 1.6923076923
	},
	{
		"stop_id": 8575759,
		"ID": 1120,
		"x": 55.0077224673,
		"y": -76.419792307,
		"h": 1.6923076923
	},
	{
		"stop_id": 8575762,
		"ID": 1120,
		"x": 54.8117207413,
		"y": -78.308767174,
		"h": 1.6923076923
	},
	{
		"stop_id": 8575763,
		"ID": 1120,
		"x": 54.4327681223,
		"y": -78.256758845,
		"h": 1.6923076923
	},
	{
		"stop_id": 8582117,
		"ID": 1120,
		"x": 54.6797547283,
		"y": -77.477806825,
		"h": 1.6923076923
	},
	{
		"stop_id": 8583461,
		"ID": 1120,
		"x": 55.0207349823,
		"y": -74.258758564,
		"h": 1.6923076923
	},
	{
		"stop_id": 8583462,
		"ID": 1120,
		"x": 54.9437261973,
		"y": -74.156812751,
		"h": 1.6923076923
	},
	{
		"stop_id": 8505218,
		"ID": 1119,
		"x": 55.6977268623,
		"y": -80.899854486,
		"h": 2.4835164835
	},
	{
		"stop_id": 8505219,
		"ID": 1119,
		"x": 55.8727589823,
		"y": -82.7828065952,
		"h": 2.4835164835
	},
	{
		"stop_id": 8505887,
		"ID": 1119,
		"x": 54.2197656413,
		"y": -84.4138047295,
		"h": 2.4835164835
	},
	{
		"stop_id": 8505889,
		"ID": 1119,
		"x": 53.9607683963,
		"y": -84.1077818806,
		"h": 2.4835164835
	},
	{
		"stop_id": 8505910,
		"ID": 1119,
		"x": 54.8197256593,
		"y": -81.590833597,
		"h": 2.4835164835
	},
	{
		"stop_id": 8505968,
		"ID": 1119,
		"x": 55.7207735483,
		"y": -79.95477496,
		"h": 2.4835164835
	},
	{
		"stop_id": 8575318,
		"ID": 1119,
		"x": 55.9817394613,
		"y": -82.9308328532,
		"h": 2.4835164835
	},
	{
		"stop_id": 8575319,
		"ID": 1119,
		"x": 55.8737499213,
		"y": -82.7128512052,
		"h": 2.4835164835
	},
	{
		"stop_id": 8575320,
		"ID": 1119,
		"x": 55.8667049133,
		"y": -82.277800157,
		"h": 2.4835164835
	},
	{
		"stop_id": 8575321,
		"ID": 1119,
		"x": 55.6577153143,
		"y": -82.329808638,
		"h": 2.4835164835
	},
	{
		"stop_id": 8575322,
		"ID": 1119,
		"x": 55.2227235513,
		"y": -82.402771355,
		"h": 2.4835164835
	},
	{
		"stop_id": 8575323,
		"ID": 1119,
		"x": 54.9767130653,
		"y": -81.954784348,
		"h": 2.4835164835
	},
	{
		"stop_id": 8575324,
		"ID": 1119,
		"x": 55.1697138273,
		"y": -81.06675712,
		"h": 2.4835164835
	},
	{
		"stop_id": 8575325,
		"ID": 1119,
		"x": 55.1677668933,
		"y": -81.049782449,
		"h": 2.4835164835
	},
	{
		"stop_id": 8575326,
		"ID": 1119,
		"x": 55.2777331613,
		"y": -80.749831262,
		"h": 2.4835164835
	},
	{
		"stop_id": 8575327,
		"ID": 1119,
		"x": 55.3307020843,
		"y": -80.444843546,
		"h": 2.4835164835
	},
	{
		"stop_id": 8575328,
		"ID": 1119,
		"x": 55.5437630263,
		"y": -80.194855921,
		"h": 2.4835164835
	},
	{
		"stop_id": 8575329,
		"ID": 1119,
		"x": 55.2267508443,
		"y": -79.827838808,
		"h": 2.4835164835
	},
	{
		"stop_id": 8575330,
		"ID": 1119,
		"x": 54.9807458843,
		"y": -80.103788502,
		"h": 2.4835164835
	},
	{
		"stop_id": 8575331,
		"ID": 1119,
		"x": 54.8207260033,
		"y": -80.552779169,
		"h": 2.4835164835
	},
	{
		"stop_id": 8575332,
		"ID": 1119,
		"x": 55.1707396653,
		"y": -82.6548147231,
		"h": 2.4835164835
	},
	{
		"stop_id": 8575333,
		"ID": 1119,
		"x": 55.2597557643,
		"y": -83.2747739544,
		"h": 2.4835164835
	},
	{
		"stop_id": 8575334,
		"ID": 1119,
		"x": 54.9467423813,
		"y": -83.2537866207,
		"h": 2.4835164835
	},
	{
		"stop_id": 8575336,
		"ID": 1119,
		"x": 54.8237058273,
		"y": -82.954793673,
		"h": 2.4835164835
	},
	{
		"stop_id": 8575337,
		"ID": 1119,
		"x": 54.7067114623,
		"y": -82.560842626,
		"h": 2.4835164835
	},
	{
		"stop_id": 8575361,
		"ID": 1119,
		"x": 54.3337136733,
		"y": -82.6708203816,
		"h": 2.4835164835
	},
	{
		"stop_id": 8575362,
		"ID": 1119,
		"x": 53.7787121083,
		"y": -82.120844133,
		"h": 2.4835164835
	},
	{
		"stop_id": 8575363,
		"ID": 1119,
		"x": 53.4827612263,
		"y": -82.068776161,
		"h": 2.4835164835
	},
	{
		"stop_id": 8575364,
		"ID": 1119,
		"x": 53.1857339853,
		"y": -81.912755106,
		"h": 2.4835164835
	},
	{
		"stop_id": 8575365,
		"ID": 1119,
		"x": 53.3627604993,
		"y": -81.877771754,
		"h": 2.4835164835
	},
	{
		"stop_id": 8575366,
		"ID": 1119,
		"x": 52.8147007083,
		"y": -81.96078389,
		"h": 2.4835164835
	},
	{
		"stop_id": 8575367,
		"ID": 1119,
		"x": 52.5927206143,
		"y": -81.821799244,
		"h": 2.4835164835
	},
	{
		"stop_id": 8575368,
		"ID": 1119,
		"x": 52.2077605183,
		"y": -81.924751886,
		"h": 2.4835164835
	},
	{
		"stop_id": 8575369,
		"ID": 1119,
		"x": 52.0637644223,
		"y": -82.126760932,
		"h": 2.4835164835
	},
	{
		"stop_id": 8575370,
		"ID": 1119,
		"x": 51.8867018173,
		"y": -82.404758183,
		"h": 2.4835164835
	},
	{
		"stop_id": 8575371,
		"ID": 1119,
		"x": 51.5647538883,
		"y": -82.8348408245,
		"h": 2.4835164835
	},
	{
		"stop_id": 8575385,
		"ID": 1119,
		"x": 54.0907488363,
		"y": -84.2908059052,
		"h": 2.4835164835
	},
	{
		"stop_id": 8575407,
		"ID": 1119,
		"x": 51.7417492763,
		"y": -83.6778265344,
		"h": 2.4835164835
	},
	{
		"stop_id": 8575408,
		"ID": 1119,
		"x": 55.9587421473,
		"y": -80.107794548,
		"h": 2.4835164835
	},
	{
		"stop_id": 8575409,
		"ID": 1119,
		"x": 55.7127009253,
		"y": -80.909798865,
		"h": 2.4835164835
	},
	{
		"stop_id": 8577231,
		"ID": 1119,
		"x": 54.7677005403,
		"y": -82.6457510332,
		"h": 2.4835164835
	},
	{
		"stop_id": 8577314,
		"ID": 1119,
		"x": 55.5017725233,
		"y": -82.34577942,
		"h": 2.4835164835
	},
	{
		"stop_id": 8580700,
		"ID": 1119,
		"x": 55.0907485393,
		"y": -83.7478470269,
		"h": 2.4835164835
	},
	{
		"stop_id": 8580712,
		"ID": 1119,
		"x": 55.0637704933,
		"y": -83.4678331962,
		"h": 2.4835164835
	},
	{
		"stop_id": 8580971,
		"ID": 1119,
		"x": 54.9887053773,
		"y": -83.0238384135,
		"h": 2.4835164835
	},
	{
		"stop_id": 8582418,
		"ID": 1119,
		"x": 54.5027139353,
		"y": -82.7968415108,
		"h": 2.4835164835
	},
	{
		"stop_id": 8505222,
		"ID": 1089,
		"x": 50.8297513063,
		"y": -42.559850786,
		"h": 1.0659340659
	},
	{
		"stop_id": 8581318,
		"ID": 1089,
		"x": 49.9877684763,
		"y": -41.216786886,
		"h": 1.0659340659
	},
	{
		"stop_id": 8587461,
		"ID": 1089,
		"x": 51.1677299833,
		"y": -42.848839117,
		"h": 1.0659340659
	},
	{
		"stop_id": 8505224,
		"ID": 1195,
		"x": 62.2017263583,
		"y": -58.95977716,
		"h": 1.2307692308
	},
	{
		"stop_id": 8575190,
		"ID": 1195,
		"x": 62.4837292903,
		"y": -61.281802096,
		"h": 1.2307692308
	},
	{
		"stop_id": 8575191,
		"ID": 1195,
		"x": 62.1277245033,
		"y": -60.646762826,
		"h": 1.2307692308
	},
	{
		"stop_id": 8575192,
		"ID": 1195,
		"x": 61.2327490813,
		"y": -58.69481836,
		"h": 1.2307692308
	},
	{
		"stop_id": 8575194,
		"ID": 1195,
		"x": 60.7557581593,
		"y": -57.922805921,
		"h": 1.2307692308
	},
	{
		"stop_id": 8575195,
		"ID": 1195,
		"x": 60.7017453813,
		"y": -57.692835101,
		"h": 1.2307692308
	},
	{
		"stop_id": 8587467,
		"ID": 1195,
		"x": 62.5927167343,
		"y": -59.585763424,
		"h": 1.2307692308
	},
	{
		"stop_id": 8587468,
		"ID": 1195,
		"x": 62.0507033463,
		"y": -58.170830683,
		"h": 1.2307692308
	},
	{
		"stop_id": 8505251,
		"ID": 1092,
		"x": 47.2577417753,
		"y": -27.569796802,
		"h": 1.0659340659
	},
	{
		"stop_id": 8578847,
		"ID": 1092,
		"x": 48.4577345783,
		"y": -28.569781714,
		"h": 1.0659340659
	},
	{
		"stop_id": 8578848,
		"ID": 1092,
		"x": 46.0787513483,
		"y": -26.663826154,
		"h": 1.0659340659
	},
	{
		"stop_id": 8505252,
		"ID": 1161,
		"x": 58.9577440383,
		"y": -42.269850606,
		"h": 1.3296703297
	},
	{
		"stop_id": 8505253,
		"ID": 1161,
		"x": 58.5417590663,
		"y": -41.225754992,
		"h": 1.3296703297
	},
	{
		"stop_id": 8505263,
		"ID": 1161,
		"x": 58.2577538563,
		"y": -44.969842998,
		"h": 1.3296703297
	},
	{
		"stop_id": 8505265,
		"ID": 1161,
		"x": 59.1577154603,
		"y": -43.369771852,
		"h": 1.3296703297
	},
	{
		"stop_id": 8505267,
		"ID": 1161,
		"x": 57.8577741803,
		"y": -46.269854748,
		"h": 1.3296703297
	},
	{
		"stop_id": 8505276,
		"ID": 1161,
		"x": 58.1337601763,
		"y": -41.806796833,
		"h": 1.3296703297
	},
	{
		"stop_id": 8578828,
		"ID": 1161,
		"x": 58.8157153133,
		"y": -41.727830466,
		"h": 1.3296703297
	},
	{
		"stop_id": 8578852,
		"ID": 1161,
		"x": 58.2437241353,
		"y": -44.468778919,
		"h": 1.3296703297
	},
	{
		"stop_id": 8578853,
		"ID": 1161,
		"x": 58.1577758223,
		"y": -42.169795039,
		"h": 1.3296703297
	},
	{
		"stop_id": 8582678,
		"ID": 1161,
		"x": 57.8457355993,
		"y": -45.983785328,
		"h": 1.3296703297
	},
	{
		"stop_id": 8582680,
		"ID": 1161,
		"x": 58.0926986243,
		"y": -46.483753702,
		"h": 1.3296703297
	},
	{
		"stop_id": 8505254,
		"ID": 1162,
		"x": 58.0777177473,
		"y": -39.615856421,
		"h": 1.2967032967
	},
	{
		"stop_id": 8505255,
		"ID": 1162,
		"x": 56.4717124443,
		"y": -38.17181447,
		"h": 1.2967032967
	},
	{
		"stop_id": 8505256,
		"ID": 1162,
		"x": 55.9577720503,
		"y": -37.769758697,
		"h": 1.2967032967
	},
	{
		"stop_id": 8505266,
		"ID": 1162,
		"x": 57.5567418303,
		"y": -39.132793221,
		"h": 1.2967032967
	},
	{
		"stop_id": 8505275,
		"ID": 1162,
		"x": 58.1077337873,
		"y": -40.494752637,
		"h": 1.2967032967
	},
	{
		"stop_id": 8578829,
		"ID": 1162,
		"x": 56.8387275373,
		"y": -38.572779354,
		"h": 1.2967032967
	},
	{
		"stop_id": 8588132,
		"ID": 1162,
		"x": 57.1507646343,
		"y": -38.831803974,
		"h": 1.2967032967
	},
	{
		"stop_id": 8588133,
		"ID": 1162,
		"x": 55.7207388873,
		"y": -37.48877978,
		"h": 1.2967032967
	},
	{
		"stop_id": 8591475,
		"ID": 1162,
		"x": 55.8187581743,
		"y": -37.726839467,
		"h": 1.2967032967
	},
	{
		"stop_id": 8591477,
		"ID": 1162,
		"x": 58.5287718003,
		"y": -40.304830927,
		"h": 1.2967032967
	},
	{
		"stop_id": 8505257,
		"ID": 1127,
		"x": 55.4827089813,
		"y": -36.599849413,
		"h": 1.7252747253
	},
	{
		"stop_id": 8505270,
		"ID": 1127,
		"x": 55.1577255963,
		"y": -33.569805679,
		"h": 1.7252747253
	},
	{
		"stop_id": 8505271,
		"ID": 1127,
		"x": 54.3407410933,
		"y": -36.485818814,
		"h": 1.7252747253
	},
	{
		"stop_id": 8505274,
		"ID": 1127,
		"x": 55.7577672843,
		"y": -34.66985167,
		"h": 1.7252747253
	},
	{
		"stop_id": 8578830,
		"ID": 1127,
		"x": 55.6317547653,
		"y": -37.043852001,
		"h": 1.7252747253
	},
	{
		"stop_id": 8578831,
		"ID": 1127,
		"x": 55.9577241133,
		"y": -34.169793363,
		"h": 1.7252747253
	},
	{
		"stop_id": 8578854,
		"ID": 1127,
		"x": 55.2576996803,
		"y": -37.56979158,
		"h": 1.7252747253
	},
	{
		"stop_id": 8578855,
		"ID": 1127,
		"x": 55.1577112493,
		"y": -37.569808351,
		"h": 1.7252747253
	},
	{
		"stop_id": 8578856,
		"ID": 1127,
		"x": 55.2397463893,
		"y": -38.038779934,
		"h": 1.7252747253
	},
	{
		"stop_id": 8578857,
		"ID": 1127,
		"x": 54.5887249163,
		"y": -37.369821294,
		"h": 1.7252747253
	},
	{
		"stop_id": 8578858,
		"ID": 1127,
		"x": 54.5577007473,
		"y": -37.269787268,
		"h": 1.7252747253
	},
	{
		"stop_id": 8578859,
		"ID": 1127,
		"x": 54.3807352393,
		"y": -36.771807652,
		"h": 1.7252747253
	},
	{
		"stop_id": 8578860,
		"ID": 1127,
		"x": 55.3027128543,
		"y": -36.517786762,
		"h": 1.7252747253
	},
	{
		"stop_id": 8578861,
		"ID": 1127,
		"x": 54.9897432223,
		"y": -36.14283283,
		"h": 1.7252747253
	},
	{
		"stop_id": 8578862,
		"ID": 1127,
		"x": 54.8107591403,
		"y": -35.716840863,
		"h": 1.7252747253
	},
	{
		"stop_id": 8578863,
		"ID": 1127,
		"x": 54.9197422903,
		"y": -35.94080749,
		"h": 1.7252747253
	},
	{
		"stop_id": 8578864,
		"ID": 1127,
		"x": 54.7197519183,
		"y": -35.346767206,
		"h": 1.7252747253
	},
	{
		"stop_id": 8578865,
		"ID": 1127,
		"x": 54.5947152153,
		"y": -34.761750269,
		"h": 1.7252747253
	},
	{
		"stop_id": 8578866,
		"ID": 1127,
		"x": 54.4577156843,
		"y": -34.269797435,
		"h": 1.7252747253
	},
	{
		"stop_id": 8578867,
		"ID": 1127,
		"x": 54.8987020673,
		"y": -33.692819927,
		"h": 1.7252747253
	},
	{
		"stop_id": 8588134,
		"ID": 1127,
		"x": 55.5107415623,
		"y": -36.980790398,
		"h": 1.7252747253
	},
	{
		"stop_id": 8594264,
		"ID": 1127,
		"x": 55.2577430673,
		"y": -36.194762293,
		"h": 1.7252747253
	},
	{
		"stop_id": 8594969,
		"ID": 1127,
		"x": 54.9077065433,
		"y": -37.73979015,
		"h": 1.7252747253
	},
	{
		"stop_id": 8505259,
		"ID": 990,
		"x": 35.0927102543,
		"y": -29.400793334,
		"h": 1.4615384615
	},
	{
		"stop_id": 8505260,
		"ID": 990,
		"x": 34.9127418853,
		"y": -28.931781464,
		"h": 1.4615384615
	},
	{
		"stop_id": 8505273,
		"ID": 990,
		"x": 35.1537755533,
		"y": -30.01776497,
		"h": 1.4615384615
	},
	{
		"stop_id": 8505864,
		"ID": 990,
		"x": 30.7787488153,
		"y": -30.001749731,
		"h": 1.4615384615
	},
	{
		"stop_id": 8505972,
		"ID": 990,
		"x": 35.1277132563,
		"y": -30.019843396,
		"h": 1.4615384615
	},
	{
		"stop_id": 8505995,
		"ID": 990,
		"x": 35.1027579693,
		"y": -30.486855466,
		"h": 1.4615384615
	},
	{
		"stop_id": 8575697,
		"ID": 990,
		"x": 30.8417594723,
		"y": -29.445801594,
		"h": 1.4615384615
	},
	{
		"stop_id": 8575707,
		"ID": 990,
		"x": 36.7847532803,
		"y": -29.74679636,
		"h": 1.4615384615
	},
	{
		"stop_id": 8575708,
		"ID": 990,
		"x": 36.0077619263,
		"y": -29.51983499,
		"h": 1.4615384615
	},
	{
		"stop_id": 8575709,
		"ID": 990,
		"x": 35.6147489153,
		"y": -29.257797386,
		"h": 1.4615384615
	},
	{
		"stop_id": 8581317,
		"ID": 990,
		"x": 34.7007657233,
		"y": -30.426800474,
		"h": 1.4615384615
	},
	{
		"stop_id": 8581686,
		"ID": 990,
		"x": 34.8977666583,
		"y": -30.053814323,
		"h": 1.4615384615
	},
	{
		"stop_id": 8581742,
		"ID": 990,
		"x": 34.5607149643,
		"y": -29.972828219,
		"h": 1.4615384615
	},
	{
		"stop_id": 8581743,
		"ID": 990,
		"x": 34.9667345563,
		"y": -29.973792619,
		"h": 1.4615384615
	},
	{
		"stop_id": 8587462,
		"ID": 990,
		"x": 31.6347208113,
		"y": -29.308853527,
		"h": 1.4615384615
	},
	{
		"stop_id": 8505262,
		"ID": 1128,
		"x": 55.1577539513,
		"y": -28.369770392,
		"h": 1.5274725275
	},
	{
		"stop_id": 8578835,
		"ID": 1128,
		"x": 55.8937074993,
		"y": -30.728824875,
		"h": 1.5274725275
	},
	{
		"stop_id": 8578836,
		"ID": 1128,
		"x": 55.4087402323,
		"y": -28.484831521,
		"h": 1.5274725275
	},
	{
		"stop_id": 8578837,
		"ID": 1128,
		"x": 54.2577125993,
		"y": -28.540767138,
		"h": 1.5274725275
	},
	{
		"stop_id": 8578838,
		"ID": 1128,
		"x": 54.8577650213,
		"y": -29.569844941,
		"h": 1.5274725275
	},
	{
		"stop_id": 8578839,
		"ID": 1128,
		"x": 54.3697330733,
		"y": -29.219765577,
		"h": 1.5274725275
	},
	{
		"stop_id": 8578840,
		"ID": 1128,
		"x": 53.2397256833,
		"y": -29.094763147,
		"h": 1.5274725275
	},
	{
		"stop_id": 8578841,
		"ID": 1128,
		"x": 52.7827251513,
		"y": -28.89485264,
		"h": 1.5274725275
	},
	{
		"stop_id": 8578842,
		"ID": 1128,
		"x": 52.3577644563,
		"y": -28.744789126,
		"h": 1.5274725275
	},
	{
		"stop_id": 8578843,
		"ID": 1128,
		"x": 52.4077173573,
		"y": -29.069851946,
		"h": 1.5274725275
	},
	{
		"stop_id": 8578844,
		"ID": 1128,
		"x": 51.5077320903,
		"y": -29.194847301,
		"h": 1.5274725275
	},
	{
		"stop_id": 8578845,
		"ID": 1128,
		"x": 51.0687413953,
		"y": -29.636785676,
		"h": 1.5274725275
	},
	{
		"stop_id": 8578849,
		"ID": 1128,
		"x": 54.0197249873,
		"y": -28.539822284,
		"h": 1.5274725275
	},
	{
		"stop_id": 8591478,
		"ID": 1128,
		"x": 54.6607506723,
		"y": -28.54079113,
		"h": 1.5274725275
	},
	{
		"stop_id": 8591479,
		"ID": 1128,
		"x": 50.4387523823,
		"y": -29.753752153,
		"h": 1.5274725275
	},
	{
		"stop_id": 8594266,
		"ID": 1128,
		"x": 55.5077207573,
		"y": -28.319827366,
		"h": 1.5274725275
	},
	{
		"stop_id": 8595910,
		"ID": 1128,
		"x": 56.0457767753,
		"y": -30.975847885,
		"h": 1.5274725275
	},
	{
		"stop_id": 8505268,
		"ID": 1163,
		"x": 56.2787442223,
		"y": -31.288798782,
		"h": 1.1978021978
	},
	{
		"stop_id": 8505277,
		"ID": 1163,
		"x": 56.4647583293,
		"y": -33.054846363,
		"h": 1.1978021978
	},
	{
		"stop_id": 8578832,
		"ID": 1163,
		"x": 56.2577067783,
		"y": -33.668802892,
		"h": 1.1978021978
	},
	{
		"stop_id": 8578833,
		"ID": 1163,
		"x": 56.4517451043,
		"y": -32.491829826,
		"h": 1.1978021978
	},
	{
		"stop_id": 8578834,
		"ID": 1163,
		"x": 56.6907484113,
		"y": -32.42183639,
		"h": 1.1978021978
	},
	{
		"stop_id": 8591476,
		"ID": 1163,
		"x": 56.5197135073,
		"y": -32.221781711,
		"h": 1.1978021978
	},
	{
		"stop_id": 8594534,
		"ID": 1163,
		"x": 56.3527175713,
		"y": -31.497847829,
		"h": 1.1978021978
	},
	{
		"stop_id": 8505269,
		"ID": 1058,
		"x": 44.7577176663,
		"y": -24.739778705,
		"h": 1.032967033
	},
	{
		"stop_id": 8509740,
		"ID": 1058,
		"x": 44.8727181663,
		"y": -22.300770228,
		"h": 1.032967033
	},
	{
		"stop_id": 8505272,
		"ID": 1129,
		"x": 55.3007011883,
		"y": -25.42784358,
		"h": 1.0659340659
	},
	{
		"stop_id": 8578850,
		"ID": 1129,
		"x": 55.2577661413,
		"y": -25.769782721,
		"h": 1.0659340659
	},
	{
		"stop_id": 8578851,
		"ID": 1129,
		"x": 55.6577754923,
		"y": -24.969811079,
		"h": 1.0659340659
	},
	{
		"stop_id": 8505300,
		"ID": 1154,
		"x": 57.0877457773,
		"y": -86.5638291299,
		"h": 6.5714285714
	},
	{
		"stop_id": 8505371,
		"ID": 1154,
		"x": 58.8917011973,
		"y": -86.4268018936,
		"h": 6.5714285714
	},
	{
		"stop_id": 8505375,
		"ID": 1154,
		"x": 59.0557337123,
		"y": -86.3637773789,
		"h": 6.5714285714
	},
	{
		"stop_id": 8505376,
		"ID": 1154,
		"x": 59.2687052573,
		"y": -86.1848211323,
		"h": 6.5714285714
	},
	{
		"stop_id": 8505377,
		"ID": 1154,
		"x": 59.6787109533,
		"y": -85.9048084687,
		"h": 6.5714285714
	},
	{
		"stop_id": 8505378,
		"ID": 1154,
		"x": 60.0097207663,
		"y": -85.9108568212,
		"h": 6.5714285714
	},
	{
		"stop_id": 8505379,
		"ID": 1154,
		"x": 60.1287277453,
		"y": -86.0957514316,
		"h": 6.5714285714
	},
	{
		"stop_id": 8505380,
		"ID": 1154,
		"x": 57.1237680173,
		"y": -86.6118365375,
		"h": 6.5714285714
	},
	{
		"stop_id": 8505386,
		"ID": 1154,
		"x": 58.2577635743,
		"y": -83.0698216638,
		"h": 6.5714285714
	},
	{
		"stop_id": 8505391,
		"ID": 1154,
		"x": 57.1457634273,
		"y": -86.6757910736,
		"h": 6.5714285714
	},
	{
		"stop_id": 8505550,
		"ID": 1154,
		"x": 57.4557383543,
		"y": -86.8388252008,
		"h": 6.5714285714
	},
	{
		"stop_id": 8505554,
		"ID": 1154,
		"x": 57.5507187583,
		"y": -86.7898487649,
		"h": 6.5714285714
	},
	{
		"stop_id": 8505561,
		"ID": 1154,
		"x": 58.9717117273,
		"y": -85.374843877,
		"h": 6.5714285714
	},
	{
		"stop_id": 8505563,
		"ID": 1154,
		"x": 59.1677145963,
		"y": -84.9718444984,
		"h": 6.5714285714
	},
	{
		"stop_id": 8505565,
		"ID": 1154,
		"x": 59.4577104463,
		"y": -83.5698585412,
		"h": 6.5714285714
	},
	{
		"stop_id": 8505566,
		"ID": 1154,
		"x": 59.6077256613,
		"y": -83.0697896118,
		"h": 6.5714285714
	},
	{
		"stop_id": 8505567,
		"ID": 1154,
		"x": 59.8577066613,
		"y": -81.969778295,
		"h": 6.5714285714
	},
	{
		"stop_id": 8505797,
		"ID": 1154,
		"x": 57.6287639253,
		"y": -83.0587740597,
		"h": 6.5714285714
	},
	{
		"stop_id": 8505894,
		"ID": 1154,
		"x": 55.8527749513,
		"y": -85.2767768561,
		"h": 6.5714285714
	},
	{
		"stop_id": 8505913,
		"ID": 1154,
		"x": 57.5947551063,
		"y": -86.3297928597,
		"h": 6.5714285714
	},
	{
		"stop_id": 8530461,
		"ID": 1154,
		"x": 57.2367315413,
		"y": -86.6437972707,
		"h": 6.5714285714
	},
	{
		"stop_id": 8530462,
		"ID": 1154,
		"x": 57.1497608093,
		"y": -86.6217881543,
		"h": 6.5714285714
	},
	{
		"stop_id": 8575245,
		"ID": 1154,
		"x": 57.3847199123,
		"y": -86.8687699015,
		"h": 6.5714285714
	},
	{
		"stop_id": 8575273,
		"ID": 1154,
		"x": 56.9787730353,
		"y": -86.533790382,
		"h": 6.5714285714
	},
	{
		"stop_id": 8575286,
		"ID": 1154,
		"x": 56.9287065613,
		"y": -86.5088453093,
		"h": 6.5714285714
	},
	{
		"stop_id": 8575310,
		"ID": 1154,
		"x": 57.0707330913,
		"y": -86.1907882658,
		"h": 6.5714285714
	},
	{
		"stop_id": 8575311,
		"ID": 1154,
		"x": 56.8337079263,
		"y": -85.6847681203,
		"h": 6.5714285714
	},
	{
		"stop_id": 8575312,
		"ID": 1154,
		"x": 56.6557430083,
		"y": -85.5827750096,
		"h": 6.5714285714
	},
	{
		"stop_id": 8575313,
		"ID": 1154,
		"x": 56.5177741683,
		"y": -85.1497851709,
		"h": 6.5714285714
	},
	{
		"stop_id": 8575314,
		"ID": 1154,
		"x": 56.3077671563,
		"y": -84.5007986424,
		"h": 6.5714285714
	},
	{
		"stop_id": 8575315,
		"ID": 1154,
		"x": 56.2837201333,
		"y": -84.1948263278,
		"h": 6.5714285714
	},
	{
		"stop_id": 8575316,
		"ID": 1154,
		"x": 56.2137134553,
		"y": -83.7328468093,
		"h": 6.5714285714
	},
	{
		"stop_id": 8575317,
		"ID": 1154,
		"x": 56.0577318953,
		"y": -83.2288105128,
		"h": 6.5714285714
	},
	{
		"stop_id": 8575338,
		"ID": 1154,
		"x": 56.6977733993,
		"y": -85.0798473552,
		"h": 6.5714285714
	},
	{
		"stop_id": 8575339,
		"ID": 1154,
		"x": 57.1347560723,
		"y": -84.7467874579,
		"h": 6.5714285714
	},
	{
		"stop_id": 8575340,
		"ID": 1154,
		"x": 57.3897101773,
		"y": -84.4838098717,
		"h": 6.5714285714
	},
	{
		"stop_id": 8575341,
		"ID": 1154,
		"x": 57.5567171173,
		"y": -84.1918326688,
		"h": 6.5714285714
	},
	{
		"stop_id": 8575342,
		"ID": 1154,
		"x": 57.7747259103,
		"y": -83.7947923434,
		"h": 6.5714285714
	},
	{
		"stop_id": 8575343,
		"ID": 1154,
		"x": 57.3877710053,
		"y": -83.503840807,
		"h": 6.5714285714
	},
	{
		"stop_id": 8575345,
		"ID": 1154,
		"x": 56.4367760253,
		"y": -83.8028565781,
		"h": 6.5714285714
	},
	{
		"stop_id": 8575346,
		"ID": 1154,
		"x": 56.7497509833,
		"y": -83.4727504012,
		"h": 6.5714285714
	},
	{
		"stop_id": 8575347,
		"ID": 1154,
		"x": 56.9187180253,
		"y": -83.0167522809,
		"h": 6.5714285714
	},
	{
		"stop_id": 8575348,
		"ID": 1154,
		"x": 56.9697264463,
		"y": -82.6208350533,
		"h": 6.5714285714
	},
	{
		"stop_id": 8575349,
		"ID": 1154,
		"x": 57.0127385533,
		"y": -82.010813486,
		"h": 6.5714285714
	},
	{
		"stop_id": 8575376,
		"ID": 1154,
		"x": 58.7867487743,
		"y": -86.5238050838,
		"h": 6.5714285714
	},
	{
		"stop_id": 8575377,
		"ID": 1154,
		"x": 59.3927406353,
		"y": -86.9748301146,
		"h": 6.5714285714
	},
	{
		"stop_id": 8575378,
		"ID": 1154,
		"x": 60.2177242813,
		"y": -86.7537886287,
		"h": 6.5714285714
	},
	{
		"stop_id": 8575381,
		"ID": 1154,
		"x": 56.2767119733,
		"y": -86.0097577264,
		"h": 6.5714285714
	},
	{
		"stop_id": 8577312,
		"ID": 1154,
		"x": 57.2457508793,
		"y": -81.675768328,
		"h": 6.5714285714
	},
	{
		"stop_id": 8578994,
		"ID": 1154,
		"x": 58.7577041273,
		"y": -81.669793447,
		"h": 6.5714285714
	},
	{
		"stop_id": 8578995,
		"ID": 1154,
		"x": 58.3607316223,
		"y": -83.4747670222,
		"h": 6.5714285714
	},
	{
		"stop_id": 8578996,
		"ID": 1154,
		"x": 58.2127159473,
		"y": -83.7007976678,
		"h": 6.5714285714
	},
	{
		"stop_id": 8578997,
		"ID": 1154,
		"x": 58.0287142743,
		"y": -84.6317855977,
		"h": 6.5714285714
	},
	{
		"stop_id": 8578998,
		"ID": 1154,
		"x": 57.8577289793,
		"y": -84.1697781467,
		"h": 6.5714285714
	},
	{
		"stop_id": 8578999,
		"ID": 1154,
		"x": 57.4987154463,
		"y": -85.2918195934,
		"h": 6.5714285714
	},
	{
		"stop_id": 8579000,
		"ID": 1154,
		"x": 57.2947185313,
		"y": -85.7927620222,
		"h": 6.5714285714
	},
	{
		"stop_id": 8579001,
		"ID": 1154,
		"x": 57.7627626523,
		"y": -85.7828373445,
		"h": 6.5714285714
	},
	{
		"stop_id": 8579004,
		"ID": 1154,
		"x": 58.5897536613,
		"y": -82.6098260857,
		"h": 6.5714285714
	},
	{
		"stop_id": 8579005,
		"ID": 1154,
		"x": 58.1097287503,
		"y": -83.5818249289,
		"h": 6.5714285714
	},
	{
		"stop_id": 8579006,
		"ID": 1154,
		"x": 57.7937594493,
		"y": -85.2387518807,
		"h": 6.5714285714
	},
	{
		"stop_id": 8579007,
		"ID": 1154,
		"x": 56.6107617163,
		"y": -85.3658207004,
		"h": 6.5714285714
	},
	{
		"stop_id": 8579009,
		"ID": 1154,
		"x": 57.3567122033,
		"y": -86.4447949756,
		"h": 6.5714285714
	},
	{
		"stop_id": 8579012,
		"ID": 1154,
		"x": 59.2577025913,
		"y": -84.369777051,
		"h": 6.5714285714
	},
	{
		"stop_id": 8579013,
		"ID": 1154,
		"x": 58.4237165903,
		"y": -85.8608573581,
		"h": 6.5714285714
	},
	{
		"stop_id": 8579017,
		"ID": 1154,
		"x": 59.7377652533,
		"y": -82.6498317464,
		"h": 6.5714285714
	},
	{
		"stop_id": 8579018,
		"ID": 1154,
		"x": 58.0797002193,
		"y": -85.9107912638,
		"h": 6.5714285714
	},
	{
		"stop_id": 8579019,
		"ID": 1154,
		"x": 57.7327341393,
		"y": -86.0448205953,
		"h": 6.5714285714
	},
	{
		"stop_id": 8579022,
		"ID": 1154,
		"x": 57.3177640463,
		"y": -87.1418031165,
		"h": 6.5714285714
	},
	{
		"stop_id": 8579955,
		"ID": 1154,
		"x": 56.1037118043,
		"y": -85.3718424971,
		"h": 6.5714285714
	},
	{
		"stop_id": 8580037,
		"ID": 1154,
		"x": 56.2107496523,
		"y": -85.1557649156,
		"h": 6.5714285714
	},
	{
		"stop_id": 8580038,
		"ID": 1154,
		"x": 57.7727145123,
		"y": -83.5667855254,
		"h": 6.5714285714
	},
	{
		"stop_id": 8581597,
		"ID": 1154,
		"x": 56.6777184233,
		"y": -86.3697832647,
		"h": 6.5714285714
	},
	{
		"stop_id": 8587432,
		"ID": 1154,
		"x": 57.5707496163,
		"y": -86.7437638504,
		"h": 6.5714285714
	},
	{
		"stop_id": 8587842,
		"ID": 1154,
		"x": 58.8667556053,
		"y": -86.5698322777,
		"h": 6.5714285714
	},
	{
		"stop_id": 8588107,
		"ID": 1154,
		"x": 57.9227362973,
		"y": -84.8867917085,
		"h": 6.5714285714
	},
	{
		"stop_id": 8588108,
		"ID": 1154,
		"x": 57.5257435763,
		"y": -86.2907641511,
		"h": 6.5714285714
	},
	{
		"stop_id": 8588250,
		"ID": 1154,
		"x": 57.5577646213,
		"y": -86.5447660094,
		"h": 6.5714285714
	},
	{
		"stop_id": 8588290,
		"ID": 1154,
		"x": 57.0877231313,
		"y": -86.0267934438,
		"h": 6.5714285714
	},
	{
		"stop_id": 8588291,
		"ID": 1154,
		"x": 57.8327359153,
		"y": -85.9198011175,
		"h": 6.5714285714
	},
	{
		"stop_id": 8588899,
		"ID": 1154,
		"x": 58.0657382803,
		"y": -84.5998238203,
		"h": 6.5714285714
	},
	{
		"stop_id": 8588900,
		"ID": 1154,
		"x": 59.5977666993,
		"y": -82.7797842477,
		"h": 6.5714285714
	},
	{
		"stop_id": 8588901,
		"ID": 1154,
		"x": 59.3477290883,
		"y": -82.9888347408,
		"h": 6.5714285714
	},
	{
		"stop_id": 8588902,
		"ID": 1154,
		"x": 59.0277000013,
		"y": -83.6547812763,
		"h": 6.5714285714
	},
	{
		"stop_id": 8588903,
		"ID": 1154,
		"x": 58.6137156823,
		"y": -84.0738142309,
		"h": 6.5714285714
	},
	{
		"stop_id": 8588970,
		"ID": 1154,
		"x": 59.6647740553,
		"y": -86.9578153701,
		"h": 6.5714285714
	},
	{
		"stop_id": 8588971,
		"ID": 1154,
		"x": 58.8667327753,
		"y": -86.5488181434,
		"h": 6.5714285714
	},
	{
		"stop_id": 8588972,
		"ID": 1154,
		"x": 58.6327707223,
		"y": -86.4947848923,
		"h": 6.5714285714
	},
	{
		"stop_id": 8588973,
		"ID": 1154,
		"x": 57.6687676993,
		"y": -86.2867787422,
		"h": 6.5714285714
	},
	{
		"stop_id": 8588975,
		"ID": 1154,
		"x": 60.0137418083,
		"y": -86.8577712363,
		"h": 6.5714285714
	},
	{
		"stop_id": 8588976,
		"ID": 1154,
		"x": 59.4927286053,
		"y": -86.9368437148,
		"h": 6.5714285714
	},
	{
		"stop_id": 8588977,
		"ID": 1154,
		"x": 58.1407503323,
		"y": -86.5097995448,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591577,
		"ID": 1154,
		"x": 59.1087724253,
		"y": -85.4908015807,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591578,
		"ID": 1154,
		"x": 59.1727721103,
		"y": -85.5428082472,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591579,
		"ID": 1154,
		"x": 59.2717752223,
		"y": -86.3138506857,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591580,
		"ID": 1154,
		"x": 59.2277292673,
		"y": -85.6868328907,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591581,
		"ID": 1154,
		"x": 58.9867527233,
		"y": -85.6608595052,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591582,
		"ID": 1154,
		"x": 59.6777627843,
		"y": -86.0418113182,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591583,
		"ID": 1154,
		"x": 59.4547436733,
		"y": -86.169832679,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591584,
		"ID": 1154,
		"x": 59.3867561023,
		"y": -86.1638277867,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591585,
		"ID": 1154,
		"x": 59.6487419703,
		"y": -86.0198104566,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591586,
		"ID": 1154,
		"x": 59.6417357763,
		"y": -86.1087877366,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591587,
		"ID": 1154,
		"x": 60.8887599353,
		"y": -85.9468359448,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591588,
		"ID": 1154,
		"x": 60.4077242713,
		"y": -86.2918252793,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591590,
		"ID": 1154,
		"x": 58.3787102843,
		"y": -86.4668179448,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591591,
		"ID": 1154,
		"x": 58.6127615843,
		"y": -86.3148275344,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591592,
		"ID": 1154,
		"x": 59.3297296283,
		"y": -87.0057525846,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591593,
		"ID": 1154,
		"x": 59.5817244793,
		"y": -86.8047836469,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591594,
		"ID": 1154,
		"x": 59.1847373673,
		"y": -86.7398498854,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591595,
		"ID": 1154,
		"x": 59.1427642373,
		"y": -86.8677596296,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591596,
		"ID": 1154,
		"x": 59.3837648473,
		"y": -86.8648183213,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591597,
		"ID": 1154,
		"x": 58.9827607893,
		"y": -86.7728201297,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591598,
		"ID": 1154,
		"x": 59.7947068153,
		"y": -84.6617751551,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591599,
		"ID": 1154,
		"x": 57.2917712013,
		"y": -86.1987648905,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591600,
		"ID": 1154,
		"x": 57.1537488403,
		"y": -86.7928292476,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591601,
		"ID": 1154,
		"x": 58.1347343713,
		"y": -85.5968408646,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591603,
		"ID": 1154,
		"x": 57.5187570653,
		"y": -86.5028228783,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591609,
		"ID": 1154,
		"x": 57.7837198513,
		"y": -86.5418448364,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591610,
		"ID": 1154,
		"x": 58.3087230123,
		"y": -84.3848497262,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591611,
		"ID": 1154,
		"x": 57.7397170193,
		"y": -84.963829433,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591612,
		"ID": 1154,
		"x": 57.4657596833,
		"y": -86.5228586151,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591613,
		"ID": 1154,
		"x": 56.7157654043,
		"y": -86.4387686364,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591615,
		"ID": 1154,
		"x": 57.7167712903,
		"y": -85.5117615112,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591616,
		"ID": 1154,
		"x": 58.0947396493,
		"y": -84.4418193362,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591619,
		"ID": 1154,
		"x": 58.2507517933,
		"y": -85.0767863781,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591621,
		"ID": 1154,
		"x": 57.3937008893,
		"y": -86.1088510146,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591622,
		"ID": 1154,
		"x": 58.6017154523,
		"y": -86.0977811183,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591623,
		"ID": 1154,
		"x": 57.3667364433,
		"y": -85.4978387743,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591624,
		"ID": 1154,
		"x": 57.6757762493,
		"y": -85.9238375383,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591625,
		"ID": 1154,
		"x": 57.0867477203,
		"y": -85.7907610044,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591626,
		"ID": 1154,
		"x": 57.0487729123,
		"y": -86.023761983,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591642,
		"ID": 1154,
		"x": 58.5047075623,
		"y": -84.8357958558,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591643,
		"ID": 1154,
		"x": 58.6657124483,
		"y": -84.5758150242,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591644,
		"ID": 1154,
		"x": 58.5647182013,
		"y": -84.4808271972,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591645,
		"ID": 1154,
		"x": 58.4297653253,
		"y": -85.2717768639,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591646,
		"ID": 1154,
		"x": 58.7367318433,
		"y": -84.9327890877,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591647,
		"ID": 1154,
		"x": 59.3746989733,
		"y": -86.7027721031,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591648,
		"ID": 1154,
		"x": 59.7197147453,
		"y": -86.7648239152,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591649,
		"ID": 1154,
		"x": 59.9747026203,
		"y": -86.7798189902,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591650,
		"ID": 1154,
		"x": 59.4577362223,
		"y": -86.5948473916,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591651,
		"ID": 1154,
		"x": 56.3107514953,
		"y": -84.9448232041,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591652,
		"ID": 1154,
		"x": 58.5447250783,
		"y": -85.8328179383,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591653,
		"ID": 1154,
		"x": 58.5577514503,
		"y": -85.7498403618,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591654,
		"ID": 1154,
		"x": 58.4997444673,
		"y": -85.5478291595,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591656,
		"ID": 1154,
		"x": 58.8627147743,
		"y": -85.4898289948,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591717,
		"ID": 1154,
		"x": 60.1577089613,
		"y": -81.929837259,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591793,
		"ID": 1154,
		"x": 59.2297063203,
		"y": -85.8748135935,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591794,
		"ID": 1154,
		"x": 59.6117141373,
		"y": -86.3158546334,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591796,
		"ID": 1154,
		"x": 59.9557015893,
		"y": -84.9387994329,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591797,
		"ID": 1154,
		"x": 57.4977087783,
		"y": -85.2918390227,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591798,
		"ID": 1154,
		"x": 57.6917232613,
		"y": -85.7428491734,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591799,
		"ID": 1154,
		"x": 57.8067701633,
		"y": -85.522807225,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591803,
		"ID": 1154,
		"x": 59.5087563743,
		"y": -86.7388359951,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591804,
		"ID": 1154,
		"x": 59.1677145963,
		"y": -84.9718444984,
		"h": 6.5714285714
	},
	{
		"stop_id": 8591805,
		"ID": 1154,
		"x": 57.0537479513,
		"y": -86.4558524834,
		"h": 6.5714285714
	},
	{
		"stop_id": 8594208,
		"ID": 1154,
		"x": 59.2397281443,
		"y": -86.1808299855,
		"h": 6.5714285714
	},
	{
		"stop_id": 8594209,
		"ID": 1154,
		"x": 59.0487199023,
		"y": -86.1437617122,
		"h": 6.5714285714
	},
	{
		"stop_id": 8594210,
		"ID": 1154,
		"x": 58.9807150583,
		"y": -85.9148202046,
		"h": 6.5714285714
	},
	{
		"stop_id": 8594211,
		"ID": 1154,
		"x": 59.0267721443,
		"y": -85.7027734855,
		"h": 6.5714285714
	},
	{
		"stop_id": 8594218,
		"ID": 1154,
		"x": 59.2887265233,
		"y": -86.9418443024,
		"h": 6.5714285714
	},
	{
		"stop_id": 8594223,
		"ID": 1154,
		"x": 56.7507617123,
		"y": -86.5708556025,
		"h": 6.5714285714
	},
	{
		"stop_id": 8594225,
		"ID": 1154,
		"x": 57.7737132973,
		"y": -86.2448332629,
		"h": 6.5714285714
	},
	{
		"stop_id": 8594227,
		"ID": 1154,
		"x": 59.2397083903,
		"y": -86.5477519813,
		"h": 6.5714285714
	},
	{
		"stop_id": 8594228,
		"ID": 1154,
		"x": 59.1017374443,
		"y": -86.3667692492,
		"h": 6.5714285714
	},
	{
		"stop_id": 8594259,
		"ID": 1154,
		"x": 58.2977053993,
		"y": -83.1327559151,
		"h": 6.5714285714
	},
	{
		"stop_id": 8594285,
		"ID": 1154,
		"x": 56.7937061913,
		"y": -83.3218043043,
		"h": 6.5714285714
	},
	{
		"stop_id": 8595132,
		"ID": 1154,
		"x": 58.4877706593,
		"y": -84.339782662,
		"h": 6.5714285714
	},
	{
		"stop_id": 8595133,
		"ID": 1154,
		"x": 57.8897170973,
		"y": -85.8737781611,
		"h": 6.5714285714
	},
	{
		"stop_id": 8595134,
		"ID": 1154,
		"x": 58.2087028393,
		"y": -85.3327792436,
		"h": 6.5714285714
	},
	{
		"stop_id": 8595135,
		"ID": 1154,
		"x": 57.6117675083,
		"y": -85.8427954247,
		"h": 6.5714285714
	},
	{
		"stop_id": 8595496,
		"ID": 1154,
		"x": 57.6417423433,
		"y": -85.1168276589,
		"h": 6.5714285714
	},
	{
		"stop_id": 8505301,
		"ID": 1153,
		"x": 57.0767200393,
		"y": -88.4047538694,
		"h": 3.010989011
	},
	{
		"stop_id": 8505302,
		"ID": 1153,
		"x": 57.3087239323,
		"y": -92.0948482702,
		"h": 3.010989011
	},
	{
		"stop_id": 8505368,
		"ID": 1153,
		"x": 57.0027695563,
		"y": -88.2508455239,
		"h": 3.010989011
	},
	{
		"stop_id": 8505370,
		"ID": 1153,
		"x": 57.0947619333,
		"y": -89.7587868425,
		"h": 3.010989011
	},
	{
		"stop_id": 8505535,
		"ID": 1153,
		"x": 57.8077486223,
		"y": -92.4107823884,
		"h": 3.010989011
	},
	{
		"stop_id": 8505543,
		"ID": 1153,
		"x": 59.6967611163,
		"y": -88.7747880935,
		"h": 3.010989011
	},
	{
		"stop_id": 8505544,
		"ID": 1153,
		"x": 60.7257346213,
		"y": -88.2127664973,
		"h": 3.010989011
	},
	{
		"stop_id": 8505552,
		"ID": 1153,
		"x": 58.9887111183,
		"y": -90.5928078847,
		"h": 3.010989011
	},
	{
		"stop_id": 8505553,
		"ID": 1153,
		"x": 57.1047707113,
		"y": -87.9247728214,
		"h": 3.010989011
	},
	{
		"stop_id": 8505622,
		"ID": 1153,
		"x": 60.5107139013,
		"y": -92.1307746053,
		"h": 3.010989011
	},
	{
		"stop_id": 8505651,
		"ID": 1153,
		"x": 56.8717499083,
		"y": -92.6827564088,
		"h": 3.010989011
	},
	{
		"stop_id": 8505655,
		"ID": 1153,
		"x": 60.0597077913,
		"y": -88.4977892943,
		"h": 3.010989011
	},
	{
		"stop_id": 8505757,
		"ID": 1153,
		"x": 56.3517531503,
		"y": -91.9248404599,
		"h": 3.010989011
	},
	{
		"stop_id": 8505967,
		"ID": 1153,
		"x": 60.3537735203,
		"y": -91.723809667,
		"h": 3.010989011
	},
	{
		"stop_id": 8575248,
		"ID": 1153,
		"x": 56.9777039553,
		"y": -92.5498552874,
		"h": 3.010989011
	},
	{
		"stop_id": 8575271,
		"ID": 1153,
		"x": 55.7407356173,
		"y": -89.7607553551,
		"h": 3.010989011
	},
	{
		"stop_id": 8575301,
		"ID": 1153,
		"x": 57.0167024543,
		"y": -88.5888111459,
		"h": 3.010989011
	},
	{
		"stop_id": 8575302,
		"ID": 1153,
		"x": 56.8607403873,
		"y": -88.789830767,
		"h": 3.010989011
	},
	{
		"stop_id": 8575303,
		"ID": 1153,
		"x": 56.7917558323,
		"y": -88.9878449966,
		"h": 3.010989011
	},
	{
		"stop_id": 8575304,
		"ID": 1153,
		"x": 56.7477270543,
		"y": -89.1778194021,
		"h": 3.010989011
	},
	{
		"stop_id": 8575305,
		"ID": 1153,
		"x": 56.3947220603,
		"y": -89.9118532582,
		"h": 3.010989011
	},
	{
		"stop_id": 8575306,
		"ID": 1153,
		"x": 56.4797167213,
		"y": -90.2377881184,
		"h": 3.010989011
	},
	{
		"stop_id": 8575307,
		"ID": 1153,
		"x": 56.5827178473,
		"y": -90.9897832022,
		"h": 3.010989011
	},
	{
		"stop_id": 8575308,
		"ID": 1153,
		"x": 56.7067284993,
		"y": -91.2868386079,
		"h": 3.010989011
	},
	{
		"stop_id": 8575309,
		"ID": 1153,
		"x": 56.5237510543,
		"y": -91.6528129543,
		"h": 3.010989011
	},
	{
		"stop_id": 8575541,
		"ID": 1153,
		"x": 56.5207125383,
		"y": -88.6117730897,
		"h": 3.010989011
	},
	{
		"stop_id": 8575914,
		"ID": 1153,
		"x": 60.3397710603,
		"y": -92.6288342954,
		"h": 3.010989011
	},
	{
		"stop_id": 8575915,
		"ID": 1153,
		"x": 60.4307286683,
		"y": -92.3648528856,
		"h": 3.010989011
	},
	{
		"stop_id": 8575916,
		"ID": 1153,
		"x": 60.7667402653,
		"y": -91.8188232331,
		"h": 3.010989011
	},
	{
		"stop_id": 8575917,
		"ID": 1153,
		"x": 60.6577422773,
		"y": -91.5347807399,
		"h": 3.010989011
	},
	{
		"stop_id": 8579029,
		"ID": 1153,
		"x": 58.5577775473,
		"y": -92.469845521,
		"h": 3.010989011
	},
	{
		"stop_id": 8579031,
		"ID": 1153,
		"x": 59.1437697973,
		"y": -90.3228134723,
		"h": 3.010989011
	},
	{
		"stop_id": 8579032,
		"ID": 1153,
		"x": 59.0027178103,
		"y": -90.5398308676,
		"h": 3.010989011
	},
	{
		"stop_id": 8580035,
		"ID": 1153,
		"x": 57.0977348403,
		"y": -87.9498141623,
		"h": 3.010989011
	},
	{
		"stop_id": 8580039,
		"ID": 1153,
		"x": 55.6957365553,
		"y": -90.2038027966,
		"h": 3.010989011
	},
	{
		"stop_id": 8580696,
		"ID": 1153,
		"x": 57.2867140083,
		"y": -92.1278500563,
		"h": 3.010989011
	},
	{
		"stop_id": 8581644,
		"ID": 1153,
		"x": 57.1427357783,
		"y": -88.2708375011,
		"h": 3.010989011
	},
	{
		"stop_id": 8581646,
		"ID": 1153,
		"x": 55.5737573133,
		"y": -90.5087702051,
		"h": 3.010989011
	},
	{
		"stop_id": 8581654,
		"ID": 1153,
		"x": 57.1137471353,
		"y": -88.0167748936,
		"h": 3.010989011
	},
	{
		"stop_id": 8581655,
		"ID": 1153,
		"x": 57.6937134953,
		"y": -88.4117649385,
		"h": 3.010989011
	},
	{
		"stop_id": 8588248,
		"ID": 1153,
		"x": 59.1757422183,
		"y": -91.2638462557,
		"h": 3.010989011
	},
	{
		"stop_id": 8591573,
		"ID": 1153,
		"x": 58.8627408353,
		"y": -91.392823469,
		"h": 3.010989011
	},
	{
		"stop_id": 8591574,
		"ID": 1153,
		"x": 59.1207482193,
		"y": -90.5847795996,
		"h": 3.010989011
	},
	{
		"stop_id": 8591575,
		"ID": 1153,
		"x": 59.0927581773,
		"y": -90.8148204123,
		"h": 3.010989011
	},
	{
		"stop_id": 8591602,
		"ID": 1153,
		"x": 56.9077249363,
		"y": -87.7447650796,
		"h": 3.010989011
	},
	{
		"stop_id": 8591605,
		"ID": 1153,
		"x": 56.8577267203,
		"y": -87.5057816564,
		"h": 3.010989011
	},
	{
		"stop_id": 8591606,
		"ID": 1153,
		"x": 57.0927616443,
		"y": -87.6468119431,
		"h": 3.010989011
	},
	{
		"stop_id": 8591614,
		"ID": 1153,
		"x": 56.7937331383,
		"y": -87.9268538014,
		"h": 3.010989011
	},
	{
		"stop_id": 8591618,
		"ID": 1153,
		"x": 56.9327327413,
		"y": -87.3197704363,
		"h": 3.010989011
	},
	{
		"stop_id": 8591629,
		"ID": 1153,
		"x": 56.3757424153,
		"y": -88.6627999613,
		"h": 3.010989011
	},
	{
		"stop_id": 8591630,
		"ID": 1153,
		"x": 56.7077439443,
		"y": -88.2198138142,
		"h": 3.010989011
	},
	{
		"stop_id": 8591631,
		"ID": 1153,
		"x": 56.6767042873,
		"y": -88.4848127861,
		"h": 3.010989011
	},
	{
		"stop_id": 8591632,
		"ID": 1153,
		"x": 57.1737126133,
		"y": -88.1648355853,
		"h": 3.010989011
	},
	{
		"stop_id": 8591633,
		"ID": 1153,
		"x": 56.9907674733,
		"y": -88.0698400163,
		"h": 3.010989011
	},
	{
		"stop_id": 8591634,
		"ID": 1153,
		"x": 56.8797363493,
		"y": -88.1317907248,
		"h": 3.010989011
	},
	{
		"stop_id": 8591635,
		"ID": 1153,
		"x": 56.9137046873,
		"y": -88.0078315909,
		"h": 3.010989011
	},
	{
		"stop_id": 8591637,
		"ID": 1153,
		"x": 56.0437486083,
		"y": -88.8768319856,
		"h": 3.010989011
	},
	{
		"stop_id": 8591638,
		"ID": 1153,
		"x": 56.4917199813,
		"y": -89.0897674581,
		"h": 3.010989011
	},
	{
		"stop_id": 8591639,
		"ID": 1153,
		"x": 56.3217660153,
		"y": -89.0467610716,
		"h": 3.010989011
	},
	{
		"stop_id": 8591640,
		"ID": 1153,
		"x": 56.1277333823,
		"y": -89.1148406724,
		"h": 3.010989011
	},
	{
		"stop_id": 8591802,
		"ID": 1153,
		"x": 57.0557748143,
		"y": -88.411827701,
		"h": 3.010989011
	},
	{
		"stop_id": 8594220,
		"ID": 1153,
		"x": 57.0246993033,
		"y": -87.6617962531,
		"h": 3.010989011
	},
	{
		"stop_id": 8505303,
		"ID": 1152,
		"x": 59.3427089493,
		"y": -94.6438413044,
		"h": 2.0879120879
	},
	{
		"stop_id": 8505304,
		"ID": 1152,
		"x": 59.7917497353,
		"y": -97.9258052782,
		"h": 2.0879120879
	},
	{
		"stop_id": 8505367,
		"ID": 1152,
		"x": 59.8577191223,
		"y": -97.8698039503,
		"h": 2.0879120879
	},
	{
		"stop_id": 8505536,
		"ID": 1152,
		"x": 56.3017197533,
		"y": -95.5917804454,
		"h": 2.0879120879
	},
	{
		"stop_id": 8505556,
		"ID": 1152,
		"x": 56.5597630223,
		"y": -94.9767626528,
		"h": 2.0879120879
	},
	{
		"stop_id": 8505617,
		"ID": 1152,
		"x": 60.3597124843,
		"y": -94.526779996,
		"h": 2.0879120879
	},
	{
		"stop_id": 8505618,
		"ID": 1152,
		"x": 60.0967437243,
		"y": -94.2098497623,
		"h": 2.0879120879
	},
	{
		"stop_id": 8505619,
		"ID": 1152,
		"x": 60.2417173173,
		"y": -93.4417855129,
		"h": 2.0879120879
	},
	{
		"stop_id": 8505673,
		"ID": 1152,
		"x": 59.9377480263,
		"y": -97.5537857665,
		"h": 2.0879120879
	},
	{
		"stop_id": 8505770,
		"ID": 1152,
		"x": 55.8867271223,
		"y": -96.9797505712,
		"h": 2.0879120879
	},
	{
		"stop_id": 8505897,
		"ID": 1152,
		"x": 60.2157480643,
		"y": -95.535776041,
		"h": 2.0879120879
	},
	{
		"stop_id": 8530469,
		"ID": 1152,
		"x": 56.4577683813,
		"y": -96.4697488173,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575698,
		"ID": 1152,
		"x": 59.9907334493,
		"y": -97.5088236377,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575700,
		"ID": 1152,
		"x": 59.3387545203,
		"y": -94.6598187852,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575911,
		"ID": 1152,
		"x": 59.7637492863,
		"y": -94.7497765535,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575912,
		"ID": 1152,
		"x": 60.1467565613,
		"y": -94.877780982,
		"h": 2.0879120879
	},
	{
		"stop_id": 8577229,
		"ID": 1152,
		"x": 59.9587339053,
		"y": -95.3418082963,
		"h": 2.0879120879
	},
	{
		"stop_id": 8578874,
		"ID": 1152,
		"x": 60.2877060673,
		"y": -95.7298285855,
		"h": 2.0879120879
	},
	{
		"stop_id": 8578875,
		"ID": 1152,
		"x": 59.7907252713,
		"y": -97.8617800076,
		"h": 2.0879120879
	},
	{
		"stop_id": 8578876,
		"ID": 1152,
		"x": 59.1957620013,
		"y": -97.5857872471,
		"h": 2.0879120879
	},
	{
		"stop_id": 8578879,
		"ID": 1152,
		"x": 56.3377655873,
		"y": -95.5817530554,
		"h": 2.0879120879
	},
	{
		"stop_id": 8587130,
		"ID": 1152,
		"x": 60.2487648223,
		"y": -96.1988169922,
		"h": 2.0879120879
	},
	{
		"stop_id": 8587131,
		"ID": 1152,
		"x": 60.2157082993,
		"y": -95.8998121664,
		"h": 2.0879120879
	},
	{
		"stop_id": 8587132,
		"ID": 1152,
		"x": 59.4097359323,
		"y": -97.8577974944,
		"h": 2.0879120879
	},
	{
		"stop_id": 8587134,
		"ID": 1152,
		"x": 59.1827454873,
		"y": -98.3578093486,
		"h": 2.0879120879
	},
	{
		"stop_id": 8587867,
		"ID": 1152,
		"x": 56.5357660193,
		"y": -95.3287991086,
		"h": 2.0879120879
	},
	{
		"stop_id": 8591483,
		"ID": 1152,
		"x": 55.6107629783,
		"y": -96.4448346694,
		"h": 2.0879120879
	},
	{
		"stop_id": 8591484,
		"ID": 1152,
		"x": 57.4757110933,
		"y": -94.3617675177,
		"h": 2.0879120879
	},
	{
		"stop_id": 8591485,
		"ID": 1152,
		"x": 55.9607546023,
		"y": -95.872797581,
		"h": 2.0879120879
	},
	{
		"stop_id": 8591486,
		"ID": 1152,
		"x": 59.7057559863,
		"y": -97.7368028019,
		"h": 2.0879120879
	},
	{
		"stop_id": 8591500,
		"ID": 1152,
		"x": 59.1377271403,
		"y": -97.789842166,
		"h": 2.0879120879
	},
	{
		"stop_id": 8591501,
		"ID": 1152,
		"x": 59.1487301983,
		"y": -96.8987760834,
		"h": 2.0879120879
	},
	{
		"stop_id": 8591502,
		"ID": 1152,
		"x": 59.1867421953,
		"y": -97.1837906056,
		"h": 2.0879120879
	},
	{
		"stop_id": 8593491,
		"ID": 1152,
		"x": 58.1007287643,
		"y": -94.7837735715,
		"h": 2.0879120879
	},
	{
		"stop_id": 8505305,
		"ID": 1151,
		"x": 59.8427704303,
		"y": -101.6748034542,
		"h": 3.6373626374
	},
	{
		"stop_id": 8505372,
		"ID": 1151,
		"x": 60.6027321143,
		"y": -99.7407960539,
		"h": 3.6373626374
	},
	{
		"stop_id": 8505969,
		"ID": 1151,
		"x": 56.7117736723,
		"y": -103.9448101216,
		"h": 3.6373626374
	},
	{
		"stop_id": 8505994,
		"ID": 1151,
		"x": 57.6017564713,
		"y": -102.5198480759,
		"h": 3.6373626374
	},
	{
		"stop_id": 8517519,
		"ID": 1151,
		"x": 57.1927265093,
		"y": -103.8827832969,
		"h": 3.6373626374
	},
	{
		"stop_id": 8518475,
		"ID": 1151,
		"x": 60.1677555213,
		"y": -100.7198476338,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575573,
		"ID": 1151,
		"x": 59.7997180083,
		"y": -101.7608205039,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575574,
		"ID": 1151,
		"x": 60.1307337793,
		"y": -101.7627650092,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575575,
		"ID": 1151,
		"x": 60.5267728963,
		"y": -101.5448069689,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575576,
		"ID": 1151,
		"x": 60.7247757003,
		"y": -101.6318477221,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575577,
		"ID": 1151,
		"x": 60.9857142583,
		"y": -101.9467993568,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575578,
		"ID": 1151,
		"x": 61.2397425893,
		"y": -102.2527600615,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575590,
		"ID": 1151,
		"x": 58.5877517503,
		"y": -103.6648243647,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575591,
		"ID": 1151,
		"x": 58.7367679593,
		"y": -104.0797817553,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575592,
		"ID": 1151,
		"x": 58.7417282543,
		"y": -104.4028047159,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575594,
		"ID": 1151,
		"x": 58.8397462963,
		"y": -104.6118263408,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575595,
		"ID": 1151,
		"x": 59.1657075333,
		"y": -104.6018048728,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575596,
		"ID": 1151,
		"x": 59.4227706263,
		"y": -104.5338490862,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575607,
		"ID": 1151,
		"x": 59.0987062693,
		"y": -102.9758390479,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575608,
		"ID": 1151,
		"x": 58.4847669583,
		"y": -103.2707640843,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575609,
		"ID": 1151,
		"x": 58.1387392933,
		"y": -102.6938329595,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575610,
		"ID": 1151,
		"x": 57.9177453953,
		"y": -102.449818483,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575611,
		"ID": 1151,
		"x": 57.3347749923,
		"y": -102.7027776865,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575612,
		"ID": 1151,
		"x": 57.0577374023,
		"y": -102.9698363433,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575613,
		"ID": 1151,
		"x": 56.7607495743,
		"y": -102.897801814,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575614,
		"ID": 1151,
		"x": 56.8377434863,
		"y": -103.559797338,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575615,
		"ID": 1151,
		"x": 57.0767090893,
		"y": -103.6837553435,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575621,
		"ID": 1151,
		"x": 61.3337258243,
		"y": -101.7128392208,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575623,
		"ID": 1151,
		"x": 60.9757332703,
		"y": -101.2708456506,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575624,
		"ID": 1151,
		"x": 60.8807212793,
		"y": -101.116838813,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575625,
		"ID": 1151,
		"x": 60.8397015333,
		"y": -100.9358543345,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575626,
		"ID": 1151,
		"x": 60.8197498113,
		"y": -100.8068234045,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575627,
		"ID": 1151,
		"x": 60.8747636083,
		"y": -100.7297907511,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575630,
		"ID": 1151,
		"x": 59.1376999293,
		"y": -101.6898295699,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575631,
		"ID": 1151,
		"x": 58.9577188023,
		"y": -101.5698076975,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575632,
		"ID": 1151,
		"x": 58.5447122923,
		"y": -101.5448196208,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575633,
		"ID": 1151,
		"x": 58.3247497083,
		"y": -101.3808574393,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575634,
		"ID": 1151,
		"x": 57.8617025923,
		"y": -101.3337769704,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575635,
		"ID": 1151,
		"x": 57.5047478773,
		"y": -101.2538203662,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575636,
		"ID": 1151,
		"x": 57.1147657293,
		"y": -101.0428285825,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575637,
		"ID": 1151,
		"x": 57.2977478693,
		"y": -100.9297930499,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575638,
		"ID": 1151,
		"x": 57.5377733843,
		"y": -100.6497588422,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575641,
		"ID": 1151,
		"x": 58.1937023113,
		"y": -101.3237988041,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575642,
		"ID": 1151,
		"x": 57.6927299583,
		"y": -99.861774683,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575643,
		"ID": 1151,
		"x": 58.0857469353,
		"y": -100.3687673239,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575645,
		"ID": 1151,
		"x": 57.6467685093,
		"y": -99.6688578325,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575646,
		"ID": 1151,
		"x": 57.6857697963,
		"y": -99.3197494033,
		"h": 3.6373626374
	},
	{
		"stop_id": 8575647,
		"ID": 1151,
		"x": 57.2927624033,
		"y": -98.8767783004,
		"h": 3.6373626374
	},
	{
		"stop_id": 8578868,
		"ID": 1151,
		"x": 60.2237658863,
		"y": -101.9508468303,
		"h": 3.6373626374
	},
	{
		"stop_id": 8578870,
		"ID": 1151,
		"x": 60.1217346963,
		"y": -102.1777942245,
		"h": 3.6373626374
	},
	{
		"stop_id": 8579965,
		"ID": 1151,
		"x": 59.8237148293,
		"y": -101.7407799414,
		"h": 3.6373626374
	},
	{
		"stop_id": 8580059,
		"ID": 1151,
		"x": 60.1277063363,
		"y": -101.3997874814,
		"h": 3.6373626374
	},
	{
		"stop_id": 8580061,
		"ID": 1151,
		"x": 60.3177135723,
		"y": -101.8067828288,
		"h": 3.6373626374
	},
	{
		"stop_id": 8580073,
		"ID": 1151,
		"x": 61.0557621743,
		"y": -103.1798531141,
		"h": 3.6373626374
	},
	{
		"stop_id": 8580074,
		"ID": 1151,
		"x": 60.9047546553,
		"y": -103.1107937995,
		"h": 3.6373626374
	},
	{
		"stop_id": 8580076,
		"ID": 1151,
		"x": 60.1707095303,
		"y": -102.7517972719,
		"h": 3.6373626374
	},
	{
		"stop_id": 8580080,
		"ID": 1151,
		"x": 57.3157113733,
		"y": -101.2057536367,
		"h": 3.6373626374
	},
	{
		"stop_id": 8580107,
		"ID": 1151,
		"x": 59.8697060423,
		"y": -102.3028344547,
		"h": 3.6373626374
	},
	{
		"stop_id": 8580114,
		"ID": 1151,
		"x": 60.0437317343,
		"y": -102.3707989718,
		"h": 3.6373626374
	},
	{
		"stop_id": 8580484,
		"ID": 1151,
		"x": 60.6647208523,
		"y": -103.053831863,
		"h": 3.6373626374
	},
	{
		"stop_id": 8582966,
		"ID": 1151,
		"x": 56.9577112113,
		"y": -103.1867941197,
		"h": 3.6373626374
	},
	{
		"stop_id": 8583238,
		"ID": 1151,
		"x": 56.6507573533,
		"y": -101.0978580791,
		"h": 3.6373626374
	},
	{
		"stop_id": 8583240,
		"ID": 1151,
		"x": 58.8507388433,
		"y": -103.0448282481,
		"h": 3.6373626374
	},
	{
		"stop_id": 8583409,
		"ID": 1151,
		"x": 59.1567284983,
		"y": -104.1257507277,
		"h": 3.6373626374
	},
	{
		"stop_id": 8583790,
		"ID": 1151,
		"x": 57.2447558513,
		"y": -103.8447582739,
		"h": 3.6373626374
	},
	{
		"stop_id": 8583832,
		"ID": 1151,
		"x": 57.8777371223,
		"y": -100.8047604161,
		"h": 3.6373626374
	},
	{
		"stop_id": 8583834,
		"ID": 1151,
		"x": 56.8097633903,
		"y": -101.1518571699,
		"h": 3.6373626374
	},
	{
		"stop_id": 8587129,
		"ID": 1151,
		"x": 59.6077510063,
		"y": -102.3697947703,
		"h": 3.6373626374
	},
	{
		"stop_id": 8587133,
		"ID": 1151,
		"x": 59.9297658613,
		"y": -99.6277484311,
		"h": 3.6373626374
	},
	{
		"stop_id": 8591490,
		"ID": 1151,
		"x": 60.3767153833,
		"y": -101.4428044388,
		"h": 3.6373626374
	},
	{
		"stop_id": 8591491,
		"ID": 1151,
		"x": 60.4847607113,
		"y": -100.9118499439,
		"h": 3.6373626374
	},
	{
		"stop_id": 8591492,
		"ID": 1151,
		"x": 60.3067419053,
		"y": -100.489835934,
		"h": 3.6373626374
	},
	{
		"stop_id": 8591493,
		"ID": 1151,
		"x": 60.3447571333,
		"y": -101.0668322106,
		"h": 3.6373626374
	},
	{
		"stop_id": 8591494,
		"ID": 1151,
		"x": 60.4457288713,
		"y": -100.7168138609,
		"h": 3.6373626374
	},
	{
		"stop_id": 8591495,
		"ID": 1151,
		"x": 60.5327601933,
		"y": -101.2698254221,
		"h": 3.6373626374
	},
	{
		"stop_id": 8591496,
		"ID": 1151,
		"x": 60.2167673453,
		"y": -100.4718171975,
		"h": 3.6373626374
	},
	{
		"stop_id": 8591497,
		"ID": 1151,
		"x": 60.1257261253,
		"y": -100.1668358211,
		"h": 3.6373626374
	},
	{
		"stop_id": 8591504,
		"ID": 1151,
		"x": 59.2457215373,
		"y": -98.8948485771,
		"h": 3.6373626374
	},
	{
		"stop_id": 8594455,
		"ID": 1151,
		"x": 60.1357077143,
		"y": -100.7488321654,
		"h": 3.6373626374
	},
	{
		"stop_id": 8594456,
		"ID": 1151,
		"x": 59.8187278023,
		"y": -102.0367556933,
		"h": 3.6373626374
	},
	{
		"stop_id": 8594461,
		"ID": 1151,
		"x": 60.0317446823,
		"y": -100.9397903635,
		"h": 3.6373626374
	},
	{
		"stop_id": 8505306,
		"ID": 1187,
		"x": 61.9447185103,
		"y": -104.119853233,
		"h": 3.967032967
	},
	{
		"stop_id": 8505307,
		"ID": 1187,
		"x": 64.0287333073,
		"y": -105.6988375957,
		"h": 3.967032967
	},
	{
		"stop_id": 8575579,
		"ID": 1187,
		"x": 61.7507067523,
		"y": -102.2938488083,
		"h": 3.967032967
	},
	{
		"stop_id": 8575580,
		"ID": 1187,
		"x": 62.2137080723,
		"y": -102.4338149575,
		"h": 3.967032967
	},
	{
		"stop_id": 8575581,
		"ID": 1187,
		"x": 62.4697173883,
		"y": -102.2767962394,
		"h": 3.967032967
	},
	{
		"stop_id": 8575582,
		"ID": 1187,
		"x": 62.5117204093,
		"y": -102.1517524419,
		"h": 3.967032967
	},
	{
		"stop_id": 8575600,
		"ID": 1187,
		"x": 60.6697199063,
		"y": -104.6317566219,
		"h": 3.967032967
	},
	{
		"stop_id": 8575601,
		"ID": 1187,
		"x": 60.8717738523,
		"y": -104.6828001217,
		"h": 3.967032967
	},
	{
		"stop_id": 8575602,
		"ID": 1187,
		"x": 61.3647140313,
		"y": -104.8588237382,
		"h": 3.967032967
	},
	{
		"stop_id": 8575603,
		"ID": 1187,
		"x": 62.0347325553,
		"y": -105.1167783669,
		"h": 3.967032967
	},
	{
		"stop_id": 8575604,
		"ID": 1187,
		"x": 62.5897172653,
		"y": -105.3058079415,
		"h": 3.967032967
	},
	{
		"stop_id": 8575605,
		"ID": 1187,
		"x": 62.9007501493,
		"y": -105.3978500648,
		"h": 3.967032967
	},
	{
		"stop_id": 8575628,
		"ID": 1187,
		"x": 62.1447224513,
		"y": -103.8627833247,
		"h": 3.967032967
	},
	{
		"stop_id": 8575649,
		"ID": 1187,
		"x": 63.6817020963,
		"y": -102.4548384266,
		"h": 3.967032967
	},
	{
		"stop_id": 8575650,
		"ID": 1187,
		"x": 64.0697070213,
		"y": -102.9038524216,
		"h": 3.967032967
	},
	{
		"stop_id": 8575651,
		"ID": 1187,
		"x": 64.4797291903,
		"y": -102.8828289625,
		"h": 3.967032967
	},
	{
		"stop_id": 8575768,
		"ID": 1187,
		"x": 64.1647066403,
		"y": -105.3828450586,
		"h": 3.967032967
	},
	{
		"stop_id": 8575770,
		"ID": 1187,
		"x": 63.2677482733,
		"y": -105.046758058,
		"h": 3.967032967
	},
	{
		"stop_id": 8575771,
		"ID": 1187,
		"x": 63.3827658413,
		"y": -104.6848396222,
		"h": 3.967032967
	},
	{
		"stop_id": 8575776,
		"ID": 1187,
		"x": 62.8127024033,
		"y": -103.8568330437,
		"h": 3.967032967
	},
	{
		"stop_id": 8575779,
		"ID": 1187,
		"x": 62.8237508993,
		"y": -103.5138064204,
		"h": 3.967032967
	},
	{
		"stop_id": 8575780,
		"ID": 1187,
		"x": 62.7837101833,
		"y": -103.3077951717,
		"h": 3.967032967
	},
	{
		"stop_id": 8575781,
		"ID": 1187,
		"x": 62.9967289883,
		"y": -102.9748241399,
		"h": 3.967032967
	},
	{
		"stop_id": 8575782,
		"ID": 1187,
		"x": 63.2037186243,
		"y": -102.8677976143,
		"h": 3.967032967
	},
	{
		"stop_id": 8575783,
		"ID": 1187,
		"x": 63.0307314443,
		"y": -102.7537568549,
		"h": 3.967032967
	},
	{
		"stop_id": 8575784,
		"ID": 1187,
		"x": 63.0566990773,
		"y": -102.7007509138,
		"h": 3.967032967
	},
	{
		"stop_id": 8575785,
		"ID": 1187,
		"x": 63.1777610603,
		"y": -102.5747751002,
		"h": 3.967032967
	},
	{
		"stop_id": 8575786,
		"ID": 1187,
		"x": 63.3637406663,
		"y": -102.6667554445,
		"h": 3.967032967
	},
	{
		"stop_id": 8575787,
		"ID": 1187,
		"x": 63.2877675313,
		"y": -102.4247802989,
		"h": 3.967032967
	},
	{
		"stop_id": 8575788,
		"ID": 1187,
		"x": 63.4577131973,
		"y": -102.5307581292,
		"h": 3.967032967
	},
	{
		"stop_id": 8575789,
		"ID": 1187,
		"x": 63.5027345893,
		"y": -102.459796481,
		"h": 3.967032967
	},
	{
		"stop_id": 8575790,
		"ID": 1187,
		"x": 63.7207693213,
		"y": -102.216763079,
		"h": 3.967032967
	},
	{
		"stop_id": 8575809,
		"ID": 1187,
		"x": 63.9907145783,
		"y": -105.1088438522,
		"h": 3.967032967
	},
	{
		"stop_id": 8575812,
		"ID": 1187,
		"x": 63.8477125303,
		"y": -104.4538206559,
		"h": 3.967032967
	},
	{
		"stop_id": 8575813,
		"ID": 1187,
		"x": 64.4627444093,
		"y": -104.5308245588,
		"h": 3.967032967
	},
	{
		"stop_id": 8575814,
		"ID": 1187,
		"x": 64.0857307463,
		"y": -104.5028052712,
		"h": 3.967032967
	},
	{
		"stop_id": 8575817,
		"ID": 1187,
		"x": 64.0097769183,
		"y": -104.2718451548,
		"h": 3.967032967
	},
	{
		"stop_id": 8575820,
		"ID": 1187,
		"x": 64.0587013233,
		"y": -103.799840606,
		"h": 3.967032967
	},
	{
		"stop_id": 8575822,
		"ID": 1187,
		"x": 64.2057257283,
		"y": -103.9797626645,
		"h": 3.967032967
	},
	{
		"stop_id": 8575824,
		"ID": 1187,
		"x": 64.1597328683,
		"y": -105.9678192824,
		"h": 3.967032967
	},
	{
		"stop_id": 8575825,
		"ID": 1187,
		"x": 63.9327640633,
		"y": -106.0448156492,
		"h": 3.967032967
	},
	{
		"stop_id": 8575826,
		"ID": 1187,
		"x": 63.7647155233,
		"y": -106.0337683947,
		"h": 3.967032967
	},
	{
		"stop_id": 8575827,
		"ID": 1187,
		"x": 63.3827668913,
		"y": -106.2198491028,
		"h": 3.967032967
	},
	{
		"stop_id": 8575828,
		"ID": 1187,
		"x": 62.9627734973,
		"y": -106.339844931,
		"h": 3.967032967
	},
	{
		"stop_id": 8575829,
		"ID": 1187,
		"x": 62.7077002253,
		"y": -106.4548326336,
		"h": 3.967032967
	},
	{
		"stop_id": 8580021,
		"ID": 1187,
		"x": 63.5117136983,
		"y": -105.2198472371,
		"h": 3.967032967
	},
	{
		"stop_id": 8580022,
		"ID": 1187,
		"x": 64.0077399333,
		"y": -105.5798431271,
		"h": 3.967032967
	},
	{
		"stop_id": 8580025,
		"ID": 1187,
		"x": 63.6777036703,
		"y": -105.0498103589,
		"h": 3.967032967
	},
	{
		"stop_id": 8580068,
		"ID": 1187,
		"x": 62.6397420173,
		"y": -104.2247965018,
		"h": 3.967032967
	},
	{
		"stop_id": 8580069,
		"ID": 1187,
		"x": 62.6397111553,
		"y": -104.2077847721,
		"h": 3.967032967
	},
	{
		"stop_id": 8580070,
		"ID": 1187,
		"x": 62.0507178293,
		"y": -104.1318566096,
		"h": 3.967032967
	},
	{
		"stop_id": 8580071,
		"ID": 1187,
		"x": 62.0357474533,
		"y": -103.6628162604,
		"h": 3.967032967
	},
	{
		"stop_id": 8580072,
		"ID": 1187,
		"x": 61.4387666393,
		"y": -103.4048585079,
		"h": 3.967032967
	},
	{
		"stop_id": 8580078,
		"ID": 1187,
		"x": 61.7827664933,
		"y": -103.5427773748,
		"h": 3.967032967
	},
	{
		"stop_id": 8580081,
		"ID": 1187,
		"x": 64.0137557443,
		"y": -104.9077847838,
		"h": 3.967032967
	},
	{
		"stop_id": 8580518,
		"ID": 1187,
		"x": 63.8797226043,
		"y": -105.8288439104,
		"h": 3.967032967
	},
	{
		"stop_id": 8581465,
		"ID": 1187,
		"x": 61.4327645343,
		"y": -105.9948495117,
		"h": 3.967032967
	},
	{
		"stop_id": 8581471,
		"ID": 1187,
		"x": 61.6177395883,
		"y": -106.3098445798,
		"h": 3.967032967
	},
	{
		"stop_id": 8581596,
		"ID": 1187,
		"x": 63.4537709993,
		"y": -102.9658206033,
		"h": 3.967032967
	},
	{
		"stop_id": 8583833,
		"ID": 1187,
		"x": 61.8547618833,
		"y": -104.9117766274,
		"h": 3.967032967
	},
	{
		"stop_id": 8587122,
		"ID": 1187,
		"x": 64.0827511623,
		"y": -105.6948492905,
		"h": 3.967032967
	},
	{
		"stop_id": 8587123,
		"ID": 1187,
		"x": 64.1987751973,
		"y": -105.647791369,
		"h": 3.967032967
	},
	{
		"stop_id": 8587124,
		"ID": 1187,
		"x": 63.7497026913,
		"y": -105.3658059387,
		"h": 3.967032967
	},
	{
		"stop_id": 8587125,
		"ID": 1187,
		"x": 63.4437414363,
		"y": -105.5137685827,
		"h": 3.967032967
	},
	{
		"stop_id": 8587265,
		"ID": 1187,
		"x": 61.8787134713,
		"y": -104.1727640131,
		"h": 3.967032967
	},
	{
		"stop_id": 8589491,
		"ID": 1187,
		"x": 61.9797749503,
		"y": -103.9297937526,
		"h": 3.967032967
	},
	{
		"stop_id": 8589492,
		"ID": 1187,
		"x": 61.6517236183,
		"y": -104.2387796396,
		"h": 3.967032967
	},
	{
		"stop_id": 8589493,
		"ID": 1187,
		"x": 61.9917328483,
		"y": -104.5477801173,
		"h": 3.967032967
	},
	{
		"stop_id": 8589494,
		"ID": 1187,
		"x": 62.0907711063,
		"y": -104.3317567268,
		"h": 3.967032967
	},
	{
		"stop_id": 8589495,
		"ID": 1187,
		"x": 63.3907504913,
		"y": -105.7377800893,
		"h": 3.967032967
	},
	{
		"stop_id": 8589496,
		"ID": 1187,
		"x": 62.9637090353,
		"y": -105.4867595107,
		"h": 3.967032967
	},
	{
		"stop_id": 8589498,
		"ID": 1187,
		"x": 64.1617281513,
		"y": -105.2057758919,
		"h": 3.967032967
	},
	{
		"stop_id": 8589499,
		"ID": 1187,
		"x": 63.2837527173,
		"y": -103.714798533,
		"h": 3.967032967
	},
	{
		"stop_id": 8589500,
		"ID": 1187,
		"x": 63.7137430983,
		"y": -103.9977574526,
		"h": 3.967032967
	},
	{
		"stop_id": 8589501,
		"ID": 1187,
		"x": 62.6676998663,
		"y": -103.8178288173,
		"h": 3.967032967
	},
	{
		"stop_id": 8589502,
		"ID": 1187,
		"x": 63.2037753853,
		"y": -104.3837874494,
		"h": 3.967032967
	},
	{
		"stop_id": 8589503,
		"ID": 1187,
		"x": 62.5957491543,
		"y": -103.9998494422,
		"h": 3.967032967
	},
	{
		"stop_id": 8589505,
		"ID": 1187,
		"x": 63.8987758993,
		"y": -104.235848507,
		"h": 3.967032967
	},
	{
		"stop_id": 8589506,
		"ID": 1187,
		"x": 63.7197734163,
		"y": -104.5638260974,
		"h": 3.967032967
	},
	{
		"stop_id": 8589509,
		"ID": 1187,
		"x": 63.6867739833,
		"y": -104.7647519382,
		"h": 3.967032967
	},
	{
		"stop_id": 8589510,
		"ID": 1187,
		"x": 63.5266999483,
		"y": -104.742751672,
		"h": 3.967032967
	},
	{
		"stop_id": 8591480,
		"ID": 1187,
		"x": 62.5587001303,
		"y": -104.5697841219,
		"h": 3.967032967
	},
	{
		"stop_id": 8591481,
		"ID": 1187,
		"x": 62.8807337813,
		"y": -104.7237619294,
		"h": 3.967032967
	},
	{
		"stop_id": 8591482,
		"ID": 1187,
		"x": 63.0247616493,
		"y": -104.8328322217,
		"h": 3.967032967
	},
	{
		"stop_id": 8591488,
		"ID": 1187,
		"x": 63.6607501573,
		"y": -105.4407724501,
		"h": 3.967032967
	},
	{
		"stop_id": 8591489,
		"ID": 1187,
		"x": 63.2697353743,
		"y": -105.618801947,
		"h": 3.967032967
	},
	{
		"stop_id": 8591498,
		"ID": 1187,
		"x": 62.4827519323,
		"y": -106.3358132345,
		"h": 3.967032967
	},
	{
		"stop_id": 8591499,
		"ID": 1187,
		"x": 62.0497216863,
		"y": -106.1858106598,
		"h": 3.967032967
	},
	{
		"stop_id": 8591505,
		"ID": 1187,
		"x": 61.4857590603,
		"y": -106.1698120938,
		"h": 3.967032967
	},
	{
		"stop_id": 8594180,
		"ID": 1187,
		"x": 63.9157561483,
		"y": -105.2487999981,
		"h": 3.967032967
	},
	{
		"stop_id": 8595642,
		"ID": 1187,
		"x": 63.1737290493,
		"y": -104.2657517464,
		"h": 3.967032967
	},
	{
		"stop_id": 8505366,
		"ID": 1050,
		"x": 44.8287527703,
		"y": -67.855753699,
		"h": 3.8021978022
	},
	{
		"stop_id": 8505400,
		"ID": 1050,
		"x": 45.4947040873,
		"y": -68.216792986,
		"h": 3.8021978022
	},
	{
		"stop_id": 8505453,
		"ID": 1050,
		"x": 42.5077085043,
		"y": -69.094801515,
		"h": 3.8021978022
	},
	{
		"stop_id": 8505454,
		"ID": 1050,
		"x": 40.9747148173,
		"y": -69.418776725,
		"h": 3.8021978022
	},
	{
		"stop_id": 8505455,
		"ID": 1050,
		"x": 40.9827682023,
		"y": -70.544795828,
		"h": 3.8021978022
	},
	{
		"stop_id": 8505467,
		"ID": 1050,
		"x": 43.1027304103,
		"y": -68.30479157,
		"h": 3.8021978022
	},
	{
		"stop_id": 8505470,
		"ID": 1050,
		"x": 45.4677414313,
		"y": -68.189799273,
		"h": 3.8021978022
	},
	{
		"stop_id": 8505471,
		"ID": 1050,
		"x": 44.3187189553,
		"y": -68.62680048,
		"h": 3.8021978022
	},
	{
		"stop_id": 8505472,
		"ID": 1050,
		"x": 43.6697276073,
		"y": -68.569758506,
		"h": 3.8021978022
	},
	{
		"stop_id": 8505850,
		"ID": 1050,
		"x": 43.0827050433,
		"y": -70.019774982,
		"h": 3.8021978022
	},
	{
		"stop_id": 8505853,
		"ID": 1050,
		"x": 41.3967454593,
		"y": -70.63084882,
		"h": 3.8021978022
	},
	{
		"stop_id": 8505858,
		"ID": 1050,
		"x": 44.5677081813,
		"y": -68.098851087,
		"h": 3.8021978022
	},
	{
		"stop_id": 8505859,
		"ID": 1050,
		"x": 45.1207347893,
		"y": -67.629787202,
		"h": 3.8021978022
	},
	{
		"stop_id": 8530450,
		"ID": 1050,
		"x": 44.7637260983,
		"y": -67.833750008,
		"h": 3.8021978022
	},
	{
		"stop_id": 8530670,
		"ID": 1050,
		"x": 45.3607377693,
		"y": -68.339751537,
		"h": 3.8021978022
	},
	{
		"stop_id": 8575472,
		"ID": 1050,
		"x": 45.2557495433,
		"y": -68.552818444,
		"h": 3.8021978022
	},
	{
		"stop_id": 8575473,
		"ID": 1050,
		"x": 44.5777314823,
		"y": -68.716850841,
		"h": 3.8021978022
	},
	{
		"stop_id": 8575474,
		"ID": 1050,
		"x": 43.7307163513,
		"y": -68.594844894,
		"h": 3.8021978022
	},
	{
		"stop_id": 8576451,
		"ID": 1050,
		"x": 43.0017162383,
		"y": -69.043750789,
		"h": 3.8021978022
	},
	{
		"stop_id": 8576461,
		"ID": 1050,
		"x": 42.1327169953,
		"y": -68.519750972,
		"h": 3.8021978022
	},
	{
		"stop_id": 8578881,
		"ID": 1050,
		"x": 45.4957174463,
		"y": -68.18175294,
		"h": 3.8021978022
	},
	{
		"stop_id": 8578883,
		"ID": 1050,
		"x": 44.9827598813,
		"y": -68.744774398,
		"h": 3.8021978022
	},
	{
		"stop_id": 8578885,
		"ID": 1050,
		"x": 44.3207101683,
		"y": -68.652782868,
		"h": 3.8021978022
	},
	{
		"stop_id": 8578910,
		"ID": 1050,
		"x": 43.4007124523,
		"y": -69.619786411,
		"h": 3.8021978022
	},
	{
		"stop_id": 8578924,
		"ID": 1050,
		"x": 43.3717129603,
		"y": -68.950854644,
		"h": 3.8021978022
	},
	{
		"stop_id": 8578931,
		"ID": 1050,
		"x": 40.8797212173,
		"y": -70.611770891,
		"h": 3.8021978022
	},
	{
		"stop_id": 8578974,
		"ID": 1050,
		"x": 44.7037725743,
		"y": -68.468855567,
		"h": 3.8021978022
	},
	{
		"stop_id": 8578976,
		"ID": 1050,
		"x": 44.7997528603,
		"y": -68.296757845,
		"h": 3.8021978022
	},
	{
		"stop_id": 8578977,
		"ID": 1050,
		"x": 44.4827719743,
		"y": -68.369818261,
		"h": 3.8021978022
	},
	{
		"stop_id": 8578978,
		"ID": 1050,
		"x": 44.6597525133,
		"y": -68.240801564,
		"h": 3.8021978022
	},
	{
		"stop_id": 8578979,
		"ID": 1050,
		"x": 44.2767305273,
		"y": -68.268848453,
		"h": 3.8021978022
	},
	{
		"stop_id": 8578981,
		"ID": 1050,
		"x": 44.7947001243,
		"y": -67.851782977,
		"h": 3.8021978022
	},
	{
		"stop_id": 8578983,
		"ID": 1050,
		"x": 45.2277263153,
		"y": -67.559779353,
		"h": 3.8021978022
	},
	{
		"stop_id": 8578984,
		"ID": 1050,
		"x": 45.3837689373,
		"y": -67.414759889,
		"h": 3.8021978022
	},
	{
		"stop_id": 8578991,
		"ID": 1050,
		"x": 45.3427650433,
		"y": -67.668855797,
		"h": 3.8021978022
	},
	{
		"stop_id": 8578992,
		"ID": 1050,
		"x": 45.1097025573,
		"y": -67.710807641,
		"h": 3.8021978022
	},
	{
		"stop_id": 8580990,
		"ID": 1050,
		"x": 45.3847338123,
		"y": -68.462858746,
		"h": 3.8021978022
	},
	{
		"stop_id": 8580991,
		"ID": 1050,
		"x": 45.2277297573,
		"y": -68.678828806,
		"h": 3.8021978022
	},
	{
		"stop_id": 8580992,
		"ID": 1050,
		"x": 44.8087337143,
		"y": -68.982819167,
		"h": 3.8021978022
	},
	{
		"stop_id": 8580993,
		"ID": 1050,
		"x": 44.8047423413,
		"y": -69.288750243,
		"h": 3.8021978022
	},
	{
		"stop_id": 8580994,
		"ID": 1050,
		"x": 44.5916990393,
		"y": -69.119756652,
		"h": 3.8021978022
	},
	{
		"stop_id": 8580995,
		"ID": 1050,
		"x": 45.8427384973,
		"y": -68.153811616,
		"h": 3.8021978022
	},
	{
		"stop_id": 8587016,
		"ID": 1050,
		"x": 45.5087689213,
		"y": -67.634842611,
		"h": 3.8021978022
	},
	{
		"stop_id": 8587501,
		"ID": 1050,
		"x": 45.4547711463,
		"y": -69.355771702,
		"h": 3.8021978022
	},
	{
		"stop_id": 8587502,
		"ID": 1050,
		"x": 45.2037088863,
		"y": -69.084837982,
		"h": 3.8021978022
	},
	{
		"stop_id": 8587766,
		"ID": 1050,
		"x": 40.9747157413,
		"y": -69.669823483,
		"h": 3.8021978022
	},
	{
		"stop_id": 8587845,
		"ID": 1050,
		"x": 45.6577046093,
		"y": -68.044850764,
		"h": 3.8021978022
	},
	{
		"stop_id": 8591508,
		"ID": 1050,
		"x": 44.0017229803,
		"y": -70.342771422,
		"h": 3.8021978022
	},
	{
		"stop_id": 8591509,
		"ID": 1050,
		"x": 43.0897625783,
		"y": -69.761824865,
		"h": 3.8021978022
	},
	{
		"stop_id": 8591510,
		"ID": 1050,
		"x": 43.1867003913,
		"y": -70.028794093,
		"h": 3.8021978022
	},
	{
		"stop_id": 8591511,
		"ID": 1050,
		"x": 43.8067148413,
		"y": -70.768820467,
		"h": 3.8021978022
	},
	{
		"stop_id": 8591512,
		"ID": 1050,
		"x": 43.2357084633,
		"y": -69.802818437,
		"h": 3.8021978022
	},
	{
		"stop_id": 8591513,
		"ID": 1050,
		"x": 42.8357096413,
		"y": -69.956807335,
		"h": 3.8021978022
	},
	{
		"stop_id": 8591514,
		"ID": 1050,
		"x": 42.6817162073,
		"y": -69.928837196,
		"h": 3.8021978022
	},
	{
		"stop_id": 8591515,
		"ID": 1050,
		"x": 42.4447292423,
		"y": -70.119845489,
		"h": 3.8021978022
	},
	{
		"stop_id": 8591516,
		"ID": 1050,
		"x": 44.3877199733,
		"y": -70.304797817,
		"h": 3.8021978022
	},
	{
		"stop_id": 8591517,
		"ID": 1050,
		"x": 43.9457427453,
		"y": -70.832819137,
		"h": 3.8021978022
	},
	{
		"stop_id": 8591518,
		"ID": 1050,
		"x": 43.3557331823,
		"y": -69.096774651,
		"h": 3.8021978022
	},
	{
		"stop_id": 8591519,
		"ID": 1050,
		"x": 43.6997239833,
		"y": -70.702826561,
		"h": 3.8021978022
	},
	{
		"stop_id": 8591520,
		"ID": 1050,
		"x": 42.5117080083,
		"y": -69.917810655,
		"h": 3.8021978022
	},
	{
		"stop_id": 8591521,
		"ID": 1050,
		"x": 43.7277317783,
		"y": -69.894834167,
		"h": 3.8021978022
	},
	{
		"stop_id": 8591522,
		"ID": 1050,
		"x": 43.5447602943,
		"y": -70.274750961,
		"h": 3.8021978022
	},
	{
		"stop_id": 8591523,
		"ID": 1050,
		"x": 42.9917160153,
		"y": -69.852766815,
		"h": 3.8021978022
	},
	{
		"stop_id": 8591524,
		"ID": 1050,
		"x": 44.6917510773,
		"y": -70.563846176,
		"h": 3.8021978022
	},
	{
		"stop_id": 8591525,
		"ID": 1050,
		"x": 44.6017312373,
		"y": -70.433757041,
		"h": 3.8021978022
	},
	{
		"stop_id": 8591526,
		"ID": 1050,
		"x": 43.7037465823,
		"y": -70.494847691,
		"h": 3.8021978022
	},
	{
		"stop_id": 8591527,
		"ID": 1050,
		"x": 43.3117518953,
		"y": -70.053797099,
		"h": 3.8021978022
	},
	{
		"stop_id": 8591528,
		"ID": 1050,
		"x": 43.5047164283,
		"y": -69.647811895,
		"h": 3.8021978022
	},
	{
		"stop_id": 8591529,
		"ID": 1050,
		"x": 43.7227400643,
		"y": -70.294840716,
		"h": 3.8021978022
	},
	{
		"stop_id": 8591530,
		"ID": 1050,
		"x": 43.7097430233,
		"y": -69.655766705,
		"h": 3.8021978022
	},
	{
		"stop_id": 8591531,
		"ID": 1050,
		"x": 43.9847273993,
		"y": -70.595779057,
		"h": 3.8021978022
	},
	{
		"stop_id": 8591544,
		"ID": 1050,
		"x": 44.9907220943,
		"y": -68.217855444,
		"h": 3.8021978022
	},
	{
		"stop_id": 8591545,
		"ID": 1050,
		"x": 45.6337527313,
		"y": -69.376788197,
		"h": 3.8021978022
	},
	{
		"stop_id": 8591546,
		"ID": 1050,
		"x": 44.9867621593,
		"y": -68.904807624,
		"h": 3.8021978022
	},
	{
		"stop_id": 8591547,
		"ID": 1050,
		"x": 45.3097725373,
		"y": -69.467802039,
		"h": 3.8021978022
	},
	{
		"stop_id": 8591548,
		"ID": 1050,
		"x": 44.9227235013,
		"y": -68.30575275,
		"h": 3.8021978022
	},
	{
		"stop_id": 8591549,
		"ID": 1050,
		"x": 42.7827644273,
		"y": -69.069807225,
		"h": 3.8021978022
	},
	{
		"stop_id": 8591550,
		"ID": 1050,
		"x": 42.1687691763,
		"y": -69.202798796,
		"h": 3.8021978022
	},
	{
		"stop_id": 8591551,
		"ID": 1050,
		"x": 41.7837152543,
		"y": -68.237761402,
		"h": 3.8021978022
	},
	{
		"stop_id": 8591553,
		"ID": 1050,
		"x": 42.2447418303,
		"y": -69.002839336,
		"h": 3.8021978022
	},
	{
		"stop_id": 8591554,
		"ID": 1050,
		"x": 42.4327716583,
		"y": -68.81977979,
		"h": 3.8021978022
	},
	{
		"stop_id": 8591561,
		"ID": 1050,
		"x": 45.5967318623,
		"y": -67.9098241,
		"h": 3.8021978022
	},
	{
		"stop_id": 8591564,
		"ID": 1050,
		"x": 45.0327099243,
		"y": -67.724814625,
		"h": 3.8021978022
	},
	{
		"stop_id": 8591568,
		"ID": 1050,
		"x": 43.9327181473,
		"y": -68.644758787,
		"h": 3.8021978022
	},
	{
		"stop_id": 8591569,
		"ID": 1050,
		"x": 44.1327093413,
		"y": -68.644779777,
		"h": 3.8021978022
	},
	{
		"stop_id": 8594370,
		"ID": 1050,
		"x": 45.4187580283,
		"y": -68.215776991,
		"h": 3.8021978022
	},
	{
		"stop_id": 8505373,
		"ID": 1188,
		"x": 61.4997423293,
		"y": -96.9728119415,
		"h": 1.7912087912
	},
	{
		"stop_id": 8575583,
		"ID": 1188,
		"x": 63.3107182903,
		"y": -100.9578093235,
		"h": 1.7912087912
	},
	{
		"stop_id": 8575585,
		"ID": 1188,
		"x": 63.6107659003,
		"y": -100.2187635425,
		"h": 1.7912087912
	},
	{
		"stop_id": 8575586,
		"ID": 1188,
		"x": 63.6857758533,
		"y": -99.8697697187,
		"h": 1.7912087912
	},
	{
		"stop_id": 8575587,
		"ID": 1188,
		"x": 64.1627187883,
		"y": -99.2398550842,
		"h": 1.7912087912
	},
	{
		"stop_id": 8575791,
		"ID": 1188,
		"x": 64.0297229313,
		"y": -101.7047915137,
		"h": 1.7912087912
	},
	{
		"stop_id": 8575792,
		"ID": 1188,
		"x": 63.9957758073,
		"y": -101.4867667612,
		"h": 1.7912087912
	},
	{
		"stop_id": 8575793,
		"ID": 1188,
		"x": 63.9817432273,
		"y": -101.2777886889,
		"h": 1.7912087912
	},
	{
		"stop_id": 8575794,
		"ID": 1188,
		"x": 63.7897497753,
		"y": -101.1558170573,
		"h": 1.7912087912
	},
	{
		"stop_id": 8575795,
		"ID": 1188,
		"x": 64.2067686043,
		"y": -100.2327903333,
		"h": 1.7912087912
	},
	{
		"stop_id": 8575796,
		"ID": 1188,
		"x": 64.7797145673,
		"y": -99.407842137,
		"h": 1.7912087912
	},
	{
		"stop_id": 8575797,
		"ID": 1188,
		"x": 64.9337009823,
		"y": -98.763780351,
		"h": 1.7912087912
	},
	{
		"stop_id": 8575798,
		"ID": 1188,
		"x": 64.9577259233,
		"y": -98.3447620438,
		"h": 1.7912087912
	},
	{
		"stop_id": 8575799,
		"ID": 1188,
		"x": 64.7207038373,
		"y": -97.8928374297,
		"h": 1.7912087912
	},
	{
		"stop_id": 8575800,
		"ID": 1188,
		"x": 64.7177741673,
		"y": -97.6698468213,
		"h": 1.7912087912
	},
	{
		"stop_id": 8575801,
		"ID": 1188,
		"x": 64.6037742553,
		"y": -97.0028035844,
		"h": 1.7912087912
	},
	{
		"stop_id": 8575802,
		"ID": 1188,
		"x": 64.5577093743,
		"y": -96.7197615184,
		"h": 1.7912087912
	},
	{
		"stop_id": 8575803,
		"ID": 1188,
		"x": 64.5887219513,
		"y": -96.4598294594,
		"h": 1.7912087912
	},
	{
		"stop_id": 8575807,
		"ID": 1188,
		"x": 64.0517090213,
		"y": -95.9817586889,
		"h": 1.7912087912
	},
	{
		"stop_id": 8575808,
		"ID": 1188,
		"x": 63.9257698393,
		"y": -96.5208170949,
		"h": 1.7912087912
	},
	{
		"stop_id": 8577345,
		"ID": 1188,
		"x": 64.4576987653,
		"y": -98.9697639564,
		"h": 1.7912087912
	},
	{
		"stop_id": 8577352,
		"ID": 1188,
		"x": 64.9837009463,
		"y": -98.1158418249,
		"h": 1.7912087912
	},
	{
		"stop_id": 8577354,
		"ID": 1188,
		"x": 63.0967443173,
		"y": -101.0617568879,
		"h": 1.7912087912
	},
	{
		"stop_id": 8580066,
		"ID": 1188,
		"x": 64.0367249403,
		"y": -96.2828357619,
		"h": 1.7912087912
	},
	{
		"stop_id": 8580067,
		"ID": 1188,
		"x": 64.2497323533,
		"y": -100.5388051383,
		"h": 1.7912087912
	},
	{
		"stop_id": 8505374,
		"ID": 1189,
		"x": 62.8477459803,
		"y": -95.0567876318,
		"h": 1.1318681319
	},
	{
		"stop_id": 8575804,
		"ID": 1189,
		"x": 64.6567496313,
		"y": -95.8848024729,
		"h": 1.1318681319
	},
	{
		"stop_id": 8575805,
		"ID": 1189,
		"x": 64.6277440133,
		"y": -95.7907715327,
		"h": 1.1318681319
	},
	{
		"stop_id": 8575806,
		"ID": 1189,
		"x": 64.4307368963,
		"y": -95.7577684879,
		"h": 1.1318681319
	},
	{
		"stop_id": 8575913,
		"ID": 1189,
		"x": 60.3527150863,
		"y": -93.0447609059,
		"h": 1.1318681319
	},
	{
		"stop_id": 8505389,
		"ID": 1155,
		"x": 58.4777581623,
		"y": -79.809857538,
		"h": 2.5494505495
	},
	{
		"stop_id": 8505568,
		"ID": 1155,
		"x": 59.8577753643,
		"y": -81.269847622,
		"h": 2.5494505495
	},
	{
		"stop_id": 8575350,
		"ID": 1155,
		"x": 57.2107613853,
		"y": -81.430829972,
		"h": 2.5494505495
	},
	{
		"stop_id": 8575351,
		"ID": 1155,
		"x": 56.8047425083,
		"y": -81.137766372,
		"h": 2.5494505495
	},
	{
		"stop_id": 8575352,
		"ID": 1155,
		"x": 56.6897339193,
		"y": -80.650750763,
		"h": 2.5494505495
	},
	{
		"stop_id": 8575353,
		"ID": 1155,
		"x": 57.2397569083,
		"y": -80.42080315,
		"h": 2.5494505495
	},
	{
		"stop_id": 8575354,
		"ID": 1155,
		"x": 57.2227575383,
		"y": -80.779820399,
		"h": 2.5494505495
	},
	{
		"stop_id": 8575355,
		"ID": 1155,
		"x": 57.2497318523,
		"y": -81.275751245,
		"h": 2.5494505495
	},
	{
		"stop_id": 8575356,
		"ID": 1155,
		"x": 57.7337618343,
		"y": -80.749827241,
		"h": 2.5494505495
	},
	{
		"stop_id": 8575357,
		"ID": 1155,
		"x": 57.7627076133,
		"y": -80.341765506,
		"h": 2.5494505495
	},
	{
		"stop_id": 8575358,
		"ID": 1155,
		"x": 57.7067258363,
		"y": -79.880754851,
		"h": 2.5494505495
	},
	{
		"stop_id": 8575359,
		"ID": 1155,
		"x": 58.5047188853,
		"y": -79.727831867,
		"h": 2.5494505495
	},
	{
		"stop_id": 8575411,
		"ID": 1155,
		"x": 58.4927619633,
		"y": -79.308776868,
		"h": 2.5494505495
	},
	{
		"stop_id": 8575412,
		"ID": 1155,
		"x": 58.4917208593,
		"y": -78.774763914,
		"h": 2.5494505495
	},
	{
		"stop_id": 8575413,
		"ID": 1155,
		"x": 58.5387220013,
		"y": -78.5778245,
		"h": 2.5494505495
	},
	{
		"stop_id": 8575414,
		"ID": 1155,
		"x": 58.7327032303,
		"y": -78.09782418,
		"h": 2.5494505495
	},
	{
		"stop_id": 8575415,
		"ID": 1155,
		"x": 58.8177721013,
		"y": -77.988755371,
		"h": 2.5494505495
	},
	{
		"stop_id": 8575416,
		"ID": 1155,
		"x": 58.8717664713,
		"y": -77.746756766,
		"h": 2.5494505495
	},
	{
		"stop_id": 8575422,
		"ID": 1155,
		"x": 58.6557353763,
		"y": -79.613811228,
		"h": 2.5494505495
	},
	{
		"stop_id": 8575423,
		"ID": 1155,
		"x": 58.8257696783,
		"y": -79.419804887,
		"h": 2.5494505495
	},
	{
		"stop_id": 8575424,
		"ID": 1155,
		"x": 59.3077334463,
		"y": -79.540792414,
		"h": 2.5494505495
	},
	{
		"stop_id": 8575425,
		"ID": 1155,
		"x": 59.2817098713,
		"y": -79.318816185,
		"h": 2.5494505495
	},
	{
		"stop_id": 8575426,
		"ID": 1155,
		"x": 59.5797267313,
		"y": -79.042777316,
		"h": 2.5494505495
	},
	{
		"stop_id": 8575427,
		"ID": 1155,
		"x": 59.9147431113,
		"y": -78.917765351,
		"h": 2.5494505495
	},
	{
		"stop_id": 8575428,
		"ID": 1155,
		"x": 60.2777521193,
		"y": -78.729804527,
		"h": 2.5494505495
	},
	{
		"stop_id": 8575429,
		"ID": 1155,
		"x": 60.5497258713,
		"y": -78.595774252,
		"h": 2.5494505495
	},
	{
		"stop_id": 8575430,
		"ID": 1155,
		"x": 60.9707756653,
		"y": -78.382825996,
		"h": 2.5494505495
	},
	{
		"stop_id": 8575431,
		"ID": 1155,
		"x": 60.7897237363,
		"y": -78.410775514,
		"h": 2.5494505495
	},
	{
		"stop_id": 8575432,
		"ID": 1155,
		"x": 61.1447270683,
		"y": -78.122851311,
		"h": 2.5494505495
	},
	{
		"stop_id": 8575433,
		"ID": 1155,
		"x": 61.2157681853,
		"y": -77.622755858,
		"h": 2.5494505495
	},
	{
		"stop_id": 8575449,
		"ID": 1155,
		"x": 58.8767568313,
		"y": -79.743809884,
		"h": 2.5494505495
	},
	{
		"stop_id": 8575450,
		"ID": 1155,
		"x": 59.3227453303,
		"y": -79.749753303,
		"h": 2.5494505495
	},
	{
		"stop_id": 8575451,
		"ID": 1155,
		"x": 59.6347099183,
		"y": -79.461763628,
		"h": 2.5494505495
	},
	{
		"stop_id": 8575452,
		"ID": 1155,
		"x": 60.0377216593,
		"y": -79.20075864,
		"h": 2.5494505495
	},
	{
		"stop_id": 8575453,
		"ID": 1155,
		"x": 61.5587007563,
		"y": -78.475840339,
		"h": 2.5494505495
	},
	{
		"stop_id": 8575469,
		"ID": 1155,
		"x": 60.6007243193,
		"y": -80.488854429,
		"h": 2.5494505495
	},
	{
		"stop_id": 8575470,
		"ID": 1155,
		"x": 60.2387679713,
		"y": -80.652795501,
		"h": 2.5494505495
	},
	{
		"stop_id": 8575764,
		"ID": 1155,
		"x": 55.9557533313,
		"y": -79.256829296,
		"h": 2.5494505495
	},
	{
		"stop_id": 8575906,
		"ID": 1155,
		"x": 55.9777376733,
		"y": -79.646786227,
		"h": 2.5494505495
	},
	{
		"stop_id": 8578993,
		"ID": 1155,
		"x": 58.9577052733,
		"y": -80.269812712,
		"h": 2.5494505495
	},
	{
		"stop_id": 8579003,
		"ID": 1155,
		"x": 58.9857635373,
		"y": -81.201795566,
		"h": 2.5494505495
	},
	{
		"stop_id": 8579015,
		"ID": 1155,
		"x": 60.3077586073,
		"y": -80.794752993,
		"h": 2.5494505495
	},
	{
		"stop_id": 8579016,
		"ID": 1155,
		"x": 60.0317239063,
		"y": -81.163791299,
		"h": 2.5494505495
	},
	{
		"stop_id": 8579977,
		"ID": 1155,
		"x": 56.8427069133,
		"y": -80.522840351,
		"h": 2.5494505495
	},
	{
		"stop_id": 8580697,
		"ID": 1155,
		"x": 58.4197536773,
		"y": -79.529794064,
		"h": 2.5494505495
	},
	{
		"stop_id": 8581756,
		"ID": 1155,
		"x": 58.6727577263,
		"y": -78.205845539,
		"h": 2.5494505495
	},
	{
		"stop_id": 8591506,
		"ID": 1155,
		"x": 60.3587702933,
		"y": -80.524779545,
		"h": 2.5494505495
	},
	{
		"stop_id": 8591507,
		"ID": 1155,
		"x": 60.2007043833,
		"y": -80.845792149,
		"h": 2.5494505495
	},
	{
		"stop_id": 8505390,
		"ID": 1118,
		"x": 53.8047727773,
		"y": -86.2908426248,
		"h": 3.9010989011
	},
	{
		"stop_id": 8505392,
		"ID": 1118,
		"x": 52.7727686153,
		"y": -89.1018184765,
		"h": 3.9010989011
	},
	{
		"stop_id": 8505393,
		"ID": 1118,
		"x": 55.3767299003,
		"y": -87.9577530485,
		"h": 3.9010989011
	},
	{
		"stop_id": 8505394,
		"ID": 1118,
		"x": 54.1317210403,
		"y": -85.8857860007,
		"h": 3.9010989011
	},
	{
		"stop_id": 8505395,
		"ID": 1118,
		"x": 53.5477727403,
		"y": -87.6948107458,
		"h": 3.9010989011
	},
	{
		"stop_id": 8505396,
		"ID": 1118,
		"x": 52.2757657703,
		"y": -89.3077978022,
		"h": 3.9010989011
	},
	{
		"stop_id": 8505397,
		"ID": 1118,
		"x": 51.6767589783,
		"y": -89.7527664112,
		"h": 3.9010989011
	},
	{
		"stop_id": 8505399,
		"ID": 1118,
		"x": 56.1657462453,
		"y": -87.1497668014,
		"h": 3.9010989011
	},
	{
		"stop_id": 8505662,
		"ID": 1118,
		"x": 53.9897567583,
		"y": -84.5887871633,
		"h": 3.9010989011
	},
	{
		"stop_id": 8505755,
		"ID": 1118,
		"x": 52.6517728163,
		"y": -84.8667524602,
		"h": 3.9010989011
	},
	{
		"stop_id": 8505756,
		"ID": 1118,
		"x": 53.0757152303,
		"y": -84.8677880524,
		"h": 3.9010989011
	},
	{
		"stop_id": 8505764,
		"ID": 1118,
		"x": 51.9207749353,
		"y": -88.709810376,
		"h": 3.9010989011
	},
	{
		"stop_id": 8505788,
		"ID": 1118,
		"x": 52.7177237893,
		"y": -87.0197619451,
		"h": 3.9010989011
	},
	{
		"stop_id": 8505789,
		"ID": 1118,
		"x": 50.4487045173,
		"y": -87.0637791681,
		"h": 3.9010989011
	},
	{
		"stop_id": 8505790,
		"ID": 1118,
		"x": 52.0457600083,
		"y": -86.6818146054,
		"h": 3.9010989011
	},
	{
		"stop_id": 8505796,
		"ID": 1118,
		"x": 52.5507280953,
		"y": -87.7988186853,
		"h": 3.9010989011
	},
	{
		"stop_id": 8505881,
		"ID": 1118,
		"x": 53.2977200013,
		"y": -84.6478482702,
		"h": 3.9010989011
	},
	{
		"stop_id": 8505885,
		"ID": 1118,
		"x": 54.1897489593,
		"y": -84.9937604452,
		"h": 3.9010989011
	},
	{
		"stop_id": 8505888,
		"ID": 1118,
		"x": 52.3277183523,
		"y": -84.7757859581,
		"h": 3.9010989011
	},
	{
		"stop_id": 8530789,
		"ID": 1118,
		"x": 54.5277720043,
		"y": -85.8497743882,
		"h": 3.9010989011
	},
	{
		"stop_id": 8530790,
		"ID": 1118,
		"x": 56.0577569233,
		"y": -87.5497653241,
		"h": 3.9010989011
	},
	{
		"stop_id": 8575272,
		"ID": 1118,
		"x": 56.0327431303,
		"y": -88.8117745649,
		"h": 3.9010989011
	},
	{
		"stop_id": 8575274,
		"ID": 1118,
		"x": 56.5387619543,
		"y": -87.2868501045,
		"h": 3.9010989011
	},
	{
		"stop_id": 8575275,
		"ID": 1118,
		"x": 56.3117638133,
		"y": -87.5368028666,
		"h": 3.9010989011
	},
	{
		"stop_id": 8575276,
		"ID": 1118,
		"x": 56.1177029223,
		"y": -87.9097593954,
		"h": 3.9010989011
	},
	{
		"stop_id": 8575277,
		"ID": 1118,
		"x": 55.9017644053,
		"y": -88.2217503037,
		"h": 3.9010989011
	},
	{
		"stop_id": 8575278,
		"ID": 1118,
		"x": 55.5377187373,
		"y": -88.4698319022,
		"h": 3.9010989011
	},
	{
		"stop_id": 8575279,
		"ID": 1118,
		"x": 55.3227187853,
		"y": -88.6047735733,
		"h": 3.9010989011
	},
	{
		"stop_id": 8575280,
		"ID": 1118,
		"x": 55.0667249203,
		"y": -88.7488210103,
		"h": 3.9010989011
	},
	{
		"stop_id": 8575281,
		"ID": 1118,
		"x": 54.9597067363,
		"y": -88.9757731756,
		"h": 3.9010989011
	},
	{
		"stop_id": 8575282,
		"ID": 1118,
		"x": 54.8777085303,
		"y": -89.2228212278,
		"h": 3.9010989011
	},
	{
		"stop_id": 8575283,
		"ID": 1118,
		"x": 54.8147513393,
		"y": -89.5798069584,
		"h": 3.9010989011
	},
	{
		"stop_id": 8575284,
		"ID": 1118,
		"x": 54.7727687083,
		"y": -89.8778013035,
		"h": 3.9010989011
	},
	{
		"stop_id": 8575288,
		"ID": 1118,
		"x": 56.1777564633,
		"y": -86.8898040136,
		"h": 3.9010989011
	},
	{
		"stop_id": 8575289,
		"ID": 1118,
		"x": 56.0907305803,
		"y": -86.9258205694,
		"h": 3.9010989011
	},
	{
		"stop_id": 8575290,
		"ID": 1118,
		"x": 55.9147346153,
		"y": -87.0057811896,
		"h": 3.9010989011
	},
	{
		"stop_id": 8575291,
		"ID": 1118,
		"x": 55.4977297763,
		"y": -87.3298094092,
		"h": 3.9010989011
	},
	{
		"stop_id": 8575292,
		"ID": 1118,
		"x": 55.3107468443,
		"y": -87.3748254257,
		"h": 3.9010989011
	},
	{
		"stop_id": 8575293,
		"ID": 1118,
		"x": 54.6107681653,
		"y": -87.5678276081,
		"h": 3.9010989011
	},
	{
		"stop_id": 8575294,
		"ID": 1118,
		"x": 54.3787618793,
		"y": -88.6287978088,
		"h": 3.9010989011
	},
	{
		"stop_id": 8575295,
		"ID": 1118,
		"x": 54.0897745293,
		"y": -89.3257993943,
		"h": 3.9010989011
	},
	{
		"stop_id": 8575296,
		"ID": 1118,
		"x": 53.7137238223,
		"y": -89.9057756227,
		"h": 3.9010989011
	},
	{
		"stop_id": 8575382,
		"ID": 1118,
		"x": 54.0627219243,
		"y": -85.597771661,
		"h": 3.9010989011
	},
	{
		"stop_id": 8575383,
		"ID": 1118,
		"x": 54.0897387473,
		"y": -85.2908355157,
		"h": 3.9010989011
	},
	{
		"stop_id": 8575384,
		"ID": 1118,
		"x": 54.1257067163,
		"y": -84.6558426886,
		"h": 3.9010989011
	},
	{
		"stop_id": 8575386,
		"ID": 1118,
		"x": 53.3277290773,
		"y": -84.7037722709,
		"h": 3.9010989011
	},
	{
		"stop_id": 8575387,
		"ID": 1118,
		"x": 52.6977424113,
		"y": -85.11985044,
		"h": 3.9010989011
	},
	{
		"stop_id": 8575388,
		"ID": 1118,
		"x": 52.5977308733,
		"y": -85.0857878154,
		"h": 3.9010989011
	},
	{
		"stop_id": 8575391,
		"ID": 1118,
		"x": 51.3877419853,
		"y": -85.5307723856,
		"h": 3.9010989011
	},
	{
		"stop_id": 8575392,
		"ID": 1118,
		"x": 51.6697630143,
		"y": -85.5967655254,
		"h": 3.9010989011
	},
	{
		"stop_id": 8575393,
		"ID": 1118,
		"x": 51.9577746413,
		"y": -85.5247651668,
		"h": 3.9010989011
	},
	{
		"stop_id": 8575394,
		"ID": 1118,
		"x": 53.5717123193,
		"y": -87.648777919,
		"h": 3.9010989011
	},
	{
		"stop_id": 8575395,
		"ID": 1118,
		"x": 53.2747604733,
		"y": -87.4488353399,
		"h": 3.9010989011
	},
	{
		"stop_id": 8575396,
		"ID": 1118,
		"x": 52.8317595503,
		"y": -88.1647591601,
		"h": 3.9010989011
	},
	{
		"stop_id": 8575397,
		"ID": 1118,
		"x": 52.3697266123,
		"y": -88.6068150479,
		"h": 3.9010989011
	},
	{
		"stop_id": 8575398,
		"ID": 1118,
		"x": 52.2437048793,
		"y": -88.5437608606,
		"h": 3.9010989011
	},
	{
		"stop_id": 8575399,
		"ID": 1118,
		"x": 52.5447582903,
		"y": -87.9748255885,
		"h": 3.9010989011
	},
	{
		"stop_id": 8575400,
		"ID": 1118,
		"x": 52.6567654923,
		"y": -87.4817566051,
		"h": 3.9010989011
	},
	{
		"stop_id": 8575401,
		"ID": 1118,
		"x": 52.4097398903,
		"y": -87.7428271562,
		"h": 3.9010989011
	},
	{
		"stop_id": 8575402,
		"ID": 1118,
		"x": 52.1067296783,
		"y": -87.8938430781,
		"h": 3.9010989011
	},
	{
		"stop_id": 8575403,
		"ID": 1118,
		"x": 52.2447313213,
		"y": -89.2978069446,
		"h": 3.9010989011
	},
	{
		"stop_id": 8575404,
		"ID": 1118,
		"x": 51.8177179123,
		"y": -89.2897593499,
		"h": 3.9010989011
	},
	{
		"stop_id": 8575629,
		"ID": 1118,
		"x": 51.5796998553,
		"y": -89.1768217873,
		"h": 3.9010989011
	},
	{
		"stop_id": 8575842,
		"ID": 1118,
		"x": 51.0557358623,
		"y": -88.6247955728,
		"h": 3.9010989011
	},
	{
		"stop_id": 8575843,
		"ID": 1118,
		"x": 50.8127591723,
		"y": -88.0538341477,
		"h": 3.9010989011
	},
	{
		"stop_id": 8577308,
		"ID": 1118,
		"x": 54.6077441383,
		"y": -85.7727738424,
		"h": 3.9010989011
	},
	{
		"stop_id": 8580113,
		"ID": 1118,
		"x": 56.2777010343,
		"y": -86.6498442687,
		"h": 3.9010989011
	},
	{
		"stop_id": 8580699,
		"ID": 1118,
		"x": 54.7577345533,
		"y": -84.7047801849,
		"h": 3.9010989011
	},
	{
		"stop_id": 8580701,
		"ID": 1118,
		"x": 54.8237614593,
		"y": -85.3308504772,
		"h": 3.9010989011
	},
	{
		"stop_id": 8580702,
		"ID": 1118,
		"x": 54.5307539843,
		"y": -85.5717516403,
		"h": 3.9010989011
	},
	{
		"stop_id": 8580746,
		"ID": 1118,
		"x": 54.4277729233,
		"y": -85.4878518827,
		"h": 3.9010989011
	},
	{
		"stop_id": 8580974,
		"ID": 1118,
		"x": 54.7607669863,
		"y": -84.4547754757,
		"h": 3.9010989011
	},
	{
		"stop_id": 8580976,
		"ID": 1118,
		"x": 54.7947305003,
		"y": -84.9908330751,
		"h": 3.9010989011
	},
	{
		"stop_id": 8581647,
		"ID": 1118,
		"x": 55.3067027693,
		"y": -87.9757572447,
		"h": 3.9010989011
	},
	{
		"stop_id": 8583592,
		"ID": 1118,
		"x": 54.5227288953,
		"y": -88.0908389752,
		"h": 3.9010989011
	},
	{
		"stop_id": 8591627,
		"ID": 1118,
		"x": 55.8607573393,
		"y": -88.5757728357,
		"h": 3.9010989011
	},
	{
		"stop_id": 8591628,
		"ID": 1118,
		"x": 55.7017198613,
		"y": -89.122835681,
		"h": 3.9010989011
	},
	{
		"stop_id": 8591795,
		"ID": 1118,
		"x": 55.6867705123,
		"y": -86.4388364651,
		"h": 3.9010989011
	},
	{
		"stop_id": 8591800,
		"ID": 1118,
		"x": 55.5497426853,
		"y": -89.0097518552,
		"h": 3.9010989011
	},
	{
		"stop_id": 8591801,
		"ID": 1118,
		"x": 56.0817740283,
		"y": -88.492844155,
		"h": 3.9010989011
	},
	{
		"stop_id": 8594212,
		"ID": 1118,
		"x": 55.5067099473,
		"y": -86.9698374982,
		"h": 3.9010989011
	},
	{
		"stop_id": 8594213,
		"ID": 1118,
		"x": 55.7967413533,
		"y": -86.081836772,
		"h": 3.9010989011
	},
	{
		"stop_id": 8594214,
		"ID": 1118,
		"x": 55.8117156643,
		"y": -85.7937996944,
		"h": 3.9010989011
	},
	{
		"stop_id": 8594215,
		"ID": 1118,
		"x": 55.7957464003,
		"y": -85.9317530738,
		"h": 3.9010989011
	},
	{
		"stop_id": 8594216,
		"ID": 1118,
		"x": 56.0267061163,
		"y": -85.826843007,
		"h": 3.9010989011
	},
	{
		"stop_id": 8594217,
		"ID": 1118,
		"x": 55.6987479203,
		"y": -87.1467600004,
		"h": 3.9010989011
	},
	{
		"stop_id": 8594221,
		"ID": 1118,
		"x": 56.3947345583,
		"y": -86.5787833407,
		"h": 3.9010989011
	},
	{
		"stop_id": 8594222,
		"ID": 1118,
		"x": 56.5257312463,
		"y": -86.6787927599,
		"h": 3.9010989011
	},
	{
		"stop_id": 8595974,
		"ID": 1118,
		"x": 55.4507337663,
		"y": -89.7077731425,
		"h": 3.9010989011
	},
	{
		"stop_id": 8505398,
		"ID": 1081,
		"x": 50.4677390073,
		"y": -90.6358283569,
		"h": 2.0879120879
	},
	{
		"stop_id": 8505537,
		"ID": 1081,
		"x": 50.3497354983,
		"y": -91.1537572848,
		"h": 2.0879120879
	},
	{
		"stop_id": 8505677,
		"ID": 1081,
		"x": 50.4217468093,
		"y": -90.9258562322,
		"h": 2.0879120879
	},
	{
		"stop_id": 8505781,
		"ID": 1081,
		"x": 51.1147302103,
		"y": -88.8507613095,
		"h": 2.0879120879
	},
	{
		"stop_id": 8505791,
		"ID": 1081,
		"x": 48.3627266513,
		"y": -88.7647962867,
		"h": 2.0879120879
	},
	{
		"stop_id": 8505793,
		"ID": 1081,
		"x": 47.3177005663,
		"y": -88.5297922648,
		"h": 2.0879120879
	},
	{
		"stop_id": 8505794,
		"ID": 1081,
		"x": 46.4737616283,
		"y": -88.4128458435,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575657,
		"ID": 1081,
		"x": 50.4777060303,
		"y": -90.6467662603,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575658,
		"ID": 1081,
		"x": 50.3377203563,
		"y": -90.9098107284,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575659,
		"ID": 1081,
		"x": 49.6687040443,
		"y": -90.3118110624,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575660,
		"ID": 1081,
		"x": 49.4827675103,
		"y": -89.9778177403,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575661,
		"ID": 1081,
		"x": 49.1537420163,
		"y": -89.3877671754,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575662,
		"ID": 1081,
		"x": 48.7227259153,
		"y": -89.0247821169,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575663,
		"ID": 1081,
		"x": 47.7977655583,
		"y": -88.6098201993,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575664,
		"ID": 1081,
		"x": 47.1047246663,
		"y": -88.3797718434,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575668,
		"ID": 1081,
		"x": 47.4197662473,
		"y": -88.2878348348,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575669,
		"ID": 1081,
		"x": 47.5097194253,
		"y": -88.0757756586,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575670,
		"ID": 1081,
		"x": 47.5577216403,
		"y": -87.9108198868,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575671,
		"ID": 1081,
		"x": 47.2007293113,
		"y": -87.3967691873,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575672,
		"ID": 1081,
		"x": 47.0017200743,
		"y": -87.3778089587,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575678,
		"ID": 1081,
		"x": 46.6977687703,
		"y": -87.7908532583,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575680,
		"ID": 1081,
		"x": 50.2957529733,
		"y": -90.6558437448,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575681,
		"ID": 1081,
		"x": 50.0557215503,
		"y": -90.449819916,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575682,
		"ID": 1081,
		"x": 49.8047564493,
		"y": -89.9587930216,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575683,
		"ID": 1081,
		"x": 49.7047706633,
		"y": -89.7357768598,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575684,
		"ID": 1081,
		"x": 49.6537674453,
		"y": -89.4947553697,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575685,
		"ID": 1081,
		"x": 49.1797412073,
		"y": -88.9137634056,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575686,
		"ID": 1081,
		"x": 48.9577734933,
		"y": -88.6197608593,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575687,
		"ID": 1081,
		"x": 48.6957350363,
		"y": -88.3808352098,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575854,
		"ID": 1081,
		"x": 48.9597283863,
		"y": -87.6328472883,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575856,
		"ID": 1081,
		"x": 48.7977429283,
		"y": -87.856778358,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575857,
		"ID": 1081,
		"x": 48.7667625603,
		"y": -88.1398526419,
		"h": 2.0879120879
	},
	{
		"stop_id": 8582416,
		"ID": 1081,
		"x": 47.1757445723,
		"y": -87.7207555166,
		"h": 2.0879120879
	},
	{
		"stop_id": 8582417,
		"ID": 1081,
		"x": 47.0647315543,
		"y": -87.5638250999,
		"h": 2.0879120879
	},
	{
		"stop_id": 8505401,
		"ID": 1085,
		"x": 49.2577156053,
		"y": -67.589777125,
		"h": 3.043956044
	},
	{
		"stop_id": 8505402,
		"ID": 1085,
		"x": 50.4547576073,
		"y": -67.392780867,
		"h": 3.043956044
	},
	{
		"stop_id": 8505458,
		"ID": 1085,
		"x": 48.4097460203,
		"y": -66.369842517,
		"h": 3.043956044
	},
	{
		"stop_id": 8505459,
		"ID": 1085,
		"x": 47.1177623443,
		"y": -66.691859204,
		"h": 3.043956044
	},
	{
		"stop_id": 8505604,
		"ID": 1085,
		"x": 47.1107021083,
		"y": -67.499838084,
		"h": 3.043956044
	},
	{
		"stop_id": 8505610,
		"ID": 1085,
		"x": 46.3417435993,
		"y": -67.793756665,
		"h": 3.043956044
	},
	{
		"stop_id": 8505623,
		"ID": 1085,
		"x": 49.3487611953,
		"y": -66.782835679,
		"h": 3.043956044
	},
	{
		"stop_id": 8505624,
		"ID": 1085,
		"x": 48.9797627603,
		"y": -66.153835579,
		"h": 3.043956044
	},
	{
		"stop_id": 8505625,
		"ID": 1085,
		"x": 49.2607468753,
		"y": -65.625777502,
		"h": 3.043956044
	},
	{
		"stop_id": 8505642,
		"ID": 1085,
		"x": 49.1197098513,
		"y": -67.203783902,
		"h": 3.043956044
	},
	{
		"stop_id": 8505643,
		"ID": 1085,
		"x": 49.1937722573,
		"y": -67.014774571,
		"h": 3.043956044
	},
	{
		"stop_id": 8505644,
		"ID": 1085,
		"x": 48.7407472733,
		"y": -67.061819966,
		"h": 3.043956044
	},
	{
		"stop_id": 8505645,
		"ID": 1085,
		"x": 48.8947485673,
		"y": -66.872827494,
		"h": 3.043956044
	},
	{
		"stop_id": 8505646,
		"ID": 1085,
		"x": 48.6327339683,
		"y": -66.644815007,
		"h": 3.043956044
	},
	{
		"stop_id": 8505648,
		"ID": 1085,
		"x": 49.3007494123,
		"y": -67.29881354,
		"h": 3.043956044
	},
	{
		"stop_id": 8505649,
		"ID": 1085,
		"x": 49.8897597663,
		"y": -67.104838962,
		"h": 3.043956044
	},
	{
		"stop_id": 8505900,
		"ID": 1085,
		"x": 50.5307592493,
		"y": -67.214837573,
		"h": 3.043956044
	},
	{
		"stop_id": 8505902,
		"ID": 1085,
		"x": 51.7597015783,
		"y": -67.258826346,
		"h": 3.043956044
	},
	{
		"stop_id": 8557022,
		"ID": 1085,
		"x": 50.9187045903,
		"y": -67.164844984,
		"h": 3.043956044
	},
	{
		"stop_id": 8575176,
		"ID": 1085,
		"x": 49.2987557583,
		"y": -67.153754929,
		"h": 3.043956044
	},
	{
		"stop_id": 8575177,
		"ID": 1085,
		"x": 49.3647752813,
		"y": -67.581845721,
		"h": 3.043956044
	},
	{
		"stop_id": 8575505,
		"ID": 1085,
		"x": 48.6027397653,
		"y": -66.871832001,
		"h": 3.043956044
	},
	{
		"stop_id": 8575506,
		"ID": 1085,
		"x": 48.4217099723,
		"y": -66.732753204,
		"h": 3.043956044
	},
	{
		"stop_id": 8575509,
		"ID": 1085,
		"x": 49.8417644133,
		"y": -64.252846716,
		"h": 3.043956044
	},
	{
		"stop_id": 8578938,
		"ID": 1085,
		"x": 45.9067379023,
		"y": -68.067752396,
		"h": 3.043956044
	},
	{
		"stop_id": 8578941,
		"ID": 1085,
		"x": 47.6077064823,
		"y": -67.469814244,
		"h": 3.043956044
	},
	{
		"stop_id": 8578942,
		"ID": 1085,
		"x": 48.5567037353,
		"y": -67.432796735,
		"h": 3.043956044
	},
	{
		"stop_id": 8578948,
		"ID": 1085,
		"x": 50.5427448273,
		"y": -67.236856134,
		"h": 3.043956044
	},
	{
		"stop_id": 8578949,
		"ID": 1085,
		"x": 51.1107149143,
		"y": -67.53279996,
		"h": 3.043956044
	},
	{
		"stop_id": 8578957,
		"ID": 1085,
		"x": 45.7877567193,
		"y": -67.808769922,
		"h": 3.043956044
	},
	{
		"stop_id": 8578958,
		"ID": 1085,
		"x": 46.0957018773,
		"y": -67.733797042,
		"h": 3.043956044
	},
	{
		"stop_id": 8578959,
		"ID": 1085,
		"x": 46.2107433523,
		"y": -67.479846248,
		"h": 3.043956044
	},
	{
		"stop_id": 8578960,
		"ID": 1085,
		"x": 46.3627226973,
		"y": -67.346768733,
		"h": 3.043956044
	},
	{
		"stop_id": 8578961,
		"ID": 1085,
		"x": 46.5767579133,
		"y": -67.176797519,
		"h": 3.043956044
	},
	{
		"stop_id": 8578962,
		"ID": 1085,
		"x": 46.9007619933,
		"y": -67.011776607,
		"h": 3.043956044
	},
	{
		"stop_id": 8578964,
		"ID": 1085,
		"x": 46.8587770273,
		"y": -66.815833471,
		"h": 3.043956044
	},
	{
		"stop_id": 8578966,
		"ID": 1085,
		"x": 47.7397641363,
		"y": -66.746784064,
		"h": 3.043956044
	},
	{
		"stop_id": 8578969,
		"ID": 1085,
		"x": 48.8497299533,
		"y": -65.434811378,
		"h": 3.043956044
	},
	{
		"stop_id": 8578985,
		"ID": 1085,
		"x": 45.4767020183,
		"y": -67.362780679,
		"h": 3.043956044
	},
	{
		"stop_id": 8578987,
		"ID": 1085,
		"x": 46.4757520623,
		"y": -67.040814416,
		"h": 3.043956044
	},
	{
		"stop_id": 8578988,
		"ID": 1085,
		"x": 46.1317154353,
		"y": -67.067851525,
		"h": 3.043956044
	},
	{
		"stop_id": 8578989,
		"ID": 1085,
		"x": 45.7307380363,
		"y": -67.665781775,
		"h": 3.043956044
	},
	{
		"stop_id": 8578990,
		"ID": 1085,
		"x": 45.7847667243,
		"y": -67.561774674,
		"h": 3.043956044
	},
	{
		"stop_id": 8580031,
		"ID": 1085,
		"x": 48.2547631153,
		"y": -66.633777522,
		"h": 3.043956044
	},
	{
		"stop_id": 8580981,
		"ID": 1085,
		"x": 51.4507515383,
		"y": -67.606842324,
		"h": 3.043956044
	},
	{
		"stop_id": 8580982,
		"ID": 1085,
		"x": 50.3097698333,
		"y": -67.208850424,
		"h": 3.043956044
	},
	{
		"stop_id": 8580983,
		"ID": 1085,
		"x": 50.0777277823,
		"y": -67.193827376,
		"h": 3.043956044
	},
	{
		"stop_id": 8580984,
		"ID": 1085,
		"x": 49.0157136973,
		"y": -67.351858391,
		"h": 3.043956044
	},
	{
		"stop_id": 8580986,
		"ID": 1085,
		"x": 47.2417398653,
		"y": -67.66885789,
		"h": 3.043956044
	},
	{
		"stop_id": 8580987,
		"ID": 1085,
		"x": 46.6827608873,
		"y": -67.917858668,
		"h": 3.043956044
	},
	{
		"stop_id": 8580988,
		"ID": 1085,
		"x": 46.2017376583,
		"y": -68.099846526,
		"h": 3.043956044
	},
	{
		"stop_id": 8581771,
		"ID": 1085,
		"x": 49.7417202753,
		"y": -68.331760491,
		"h": 3.043956044
	},
	{
		"stop_id": 8581778,
		"ID": 1085,
		"x": 49.7187086623,
		"y": -67.844858135,
		"h": 3.043956044
	},
	{
		"stop_id": 8581894,
		"ID": 1085,
		"x": 51.1857087293,
		"y": -67.262806083,
		"h": 3.043956044
	},
	{
		"stop_id": 8587591,
		"ID": 1085,
		"x": 47.9577231173,
		"y": -64.369821875,
		"h": 3.043956044
	},
	{
		"stop_id": 8588815,
		"ID": 1085,
		"x": 47.6577397443,
		"y": -67.294814724,
		"h": 3.043956044
	},
	{
		"stop_id": 8591555,
		"ID": 1085,
		"x": 46.5307259193,
		"y": -67.616776795,
		"h": 3.043956044
	},
	{
		"stop_id": 8591557,
		"ID": 1085,
		"x": 46.0137254133,
		"y": -67.11282929,
		"h": 3.043956044
	},
	{
		"stop_id": 8591558,
		"ID": 1085,
		"x": 47.2837248343,
		"y": -67.474769165,
		"h": 3.043956044
	},
	{
		"stop_id": 8591559,
		"ID": 1085,
		"x": 46.7827108873,
		"y": -67.544751496,
		"h": 3.043956044
	},
	{
		"stop_id": 8591560,
		"ID": 1085,
		"x": 45.9357360423,
		"y": -67.666767312,
		"h": 3.043956044
	},
	{
		"stop_id": 8591562,
		"ID": 1085,
		"x": 45.8307032603,
		"y": -67.755765841,
		"h": 3.043956044
	},
	{
		"stop_id": 8591563,
		"ID": 1085,
		"x": 46.0807199233,
		"y": -67.932853141,
		"h": 3.043956044
	},
	{
		"stop_id": 8505404,
		"ID": 1121,
		"x": 56.3727372913,
		"y": -70.219753243,
		"h": 2.0879120879
	},
	{
		"stop_id": 8505405,
		"ID": 1121,
		"x": 52.1757594223,
		"y": -70.445818841,
		"h": 2.0879120879
	},
	{
		"stop_id": 8505412,
		"ID": 1121,
		"x": 51.9717160023,
		"y": -67.757806749,
		"h": 2.0879120879
	},
	{
		"stop_id": 8505609,
		"ID": 1121,
		"x": 50.9957091553,
		"y": -70.702763484,
		"h": 2.0879120879
	},
	{
		"stop_id": 8505613,
		"ID": 1121,
		"x": 52.7607395423,
		"y": -70.338812,
		"h": 2.0879120879
	},
	{
		"stop_id": 8505903,
		"ID": 1121,
		"x": 53.0457357693,
		"y": -67.401791832,
		"h": 2.0879120879
	},
	{
		"stop_id": 8505905,
		"ID": 1121,
		"x": 54.1307398963,
		"y": -67.233836458,
		"h": 2.0879120879
	},
	{
		"stop_id": 8505906,
		"ID": 1121,
		"x": 54.0067322763,
		"y": -67.140769851,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575169,
		"ID": 1121,
		"x": 55.5787231193,
		"y": -67.830858205,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575170,
		"ID": 1121,
		"x": 55.1407481653,
		"y": -67.707759431,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575171,
		"ID": 1121,
		"x": 54.5757100983,
		"y": -67.738796743,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575173,
		"ID": 1121,
		"x": 52.8677254043,
		"y": -67.838835653,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575521,
		"ID": 1121,
		"x": 52.5506998283,
		"y": -70.504815232,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575522,
		"ID": 1121,
		"x": 52.1927680393,
		"y": -70.47974957,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575523,
		"ID": 1121,
		"x": 51.9367412723,
		"y": -70.503819389,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575524,
		"ID": 1121,
		"x": 51.4317121533,
		"y": -70.631850378,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575543,
		"ID": 1121,
		"x": 52.4477360133,
		"y": -67.319836351,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575544,
		"ID": 1121,
		"x": 52.7467237733,
		"y": -67.399791891,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575545,
		"ID": 1121,
		"x": 53.2977519253,
		"y": -67.40176347,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575546,
		"ID": 1121,
		"x": 53.8727294973,
		"y": -67.329853581,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575547,
		"ID": 1121,
		"x": 54.0667079553,
		"y": -67.282849593,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575548,
		"ID": 1121,
		"x": 53.8897295643,
		"y": -67.169761733,
		"h": 2.0879120879
	},
	{
		"stop_id": 8577043,
		"ID": 1121,
		"x": 54.0947105073,
		"y": -70.261753466,
		"h": 2.0879120879
	},
	{
		"stop_id": 8578951,
		"ID": 1121,
		"x": 52.0557400753,
		"y": -67.702776793,
		"h": 2.0879120879
	},
	{
		"stop_id": 8578953,
		"ID": 1121,
		"x": 54.0237207573,
		"y": -67.843807836,
		"h": 2.0879120879
	},
	{
		"stop_id": 8579765,
		"ID": 1121,
		"x": 52.0307225683,
		"y": -67.309756732,
		"h": 2.0879120879
	},
	{
		"stop_id": 8579808,
		"ID": 1121,
		"x": 53.2137384493,
		"y": -70.377749767,
		"h": 2.0879120879
	},
	{
		"stop_id": 8580028,
		"ID": 1121,
		"x": 53.5687486463,
		"y": -67.404816301,
		"h": 2.0879120879
	},
	{
		"stop_id": 8580721,
		"ID": 1121,
		"x": 55.7697705233,
		"y": -71.025811718,
		"h": 2.0879120879
	},
	{
		"stop_id": 8580787,
		"ID": 1121,
		"x": 55.1327386583,
		"y": -70.483770653,
		"h": 2.0879120879
	},
	{
		"stop_id": 8580788,
		"ID": 1121,
		"x": 56.3707255133,
		"y": -70.243807985,
		"h": 2.0879120879
	},
	{
		"stop_id": 8580979,
		"ID": 1121,
		"x": 53.6277010723,
		"y": -67.954857164,
		"h": 2.0879120879
	},
	{
		"stop_id": 8580980,
		"ID": 1121,
		"x": 51.6357027263,
		"y": -67.638800916,
		"h": 2.0879120879
	},
	{
		"stop_id": 8581300,
		"ID": 1121,
		"x": 56.4587119843,
		"y": -70.431804883,
		"h": 2.0879120879
	},
	{
		"stop_id": 8505406,
		"ID": 1084,
		"x": 49.3187665713,
		"y": -71.162787789,
		"h": 2.0879120879
	},
	{
		"stop_id": 8505407,
		"ID": 1084,
		"x": 46.0067099553,
		"y": -72.350764282,
		"h": 2.0879120879
	},
	{
		"stop_id": 8505600,
		"ID": 1084,
		"x": 49.0197310213,
		"y": -75.02179123,
		"h": 2.0879120879
	},
	{
		"stop_id": 8505601,
		"ID": 1084,
		"x": 48.2117440363,
		"y": -72.973772464,
		"h": 2.0879120879
	},
	{
		"stop_id": 8505602,
		"ID": 1084,
		"x": 49.2917382503,
		"y": -73.991790808,
		"h": 2.0879120879
	},
	{
		"stop_id": 8505606,
		"ID": 1084,
		"x": 48.7227313273,
		"y": -71.859820143,
		"h": 2.0879120879
	},
	{
		"stop_id": 8505607,
		"ID": 1084,
		"x": 48.4707411253,
		"y": -75.674809986,
		"h": 2.0879120879
	},
	{
		"stop_id": 8505608,
		"ID": 1084,
		"x": 49.8037171163,
		"y": -70.795807326,
		"h": 2.0879120879
	},
	{
		"stop_id": 8505611,
		"ID": 1084,
		"x": 48.5287053603,
		"y": -72.632790418,
		"h": 2.0879120879
	},
	{
		"stop_id": 8505614,
		"ID": 1084,
		"x": 48.3077523523,
		"y": -71.919821435,
		"h": 2.0879120879
	},
	{
		"stop_id": 8505615,
		"ID": 1084,
		"x": 46.2737115553,
		"y": -72.683763022,
		"h": 2.0879120879
	},
	{
		"stop_id": 8505616,
		"ID": 1084,
		"x": 48.8087610163,
		"y": -71.307810035,
		"h": 2.0879120879
	},
	{
		"stop_id": 8505909,
		"ID": 1084,
		"x": 47.3887541483,
		"y": -72.272796047,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575525,
		"ID": 1084,
		"x": 50.2857553883,
		"y": -70.773844011,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575526,
		"ID": 1084,
		"x": 49.6787269653,
		"y": -70.883788082,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575527,
		"ID": 1084,
		"x": 49.3147290373,
		"y": -71.148851289,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575528,
		"ID": 1084,
		"x": 48.5387696643,
		"y": -71.417819173,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575529,
		"ID": 1084,
		"x": 47.8337384353,
		"y": -71.719783737,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575530,
		"ID": 1084,
		"x": 46.6207177263,
		"y": -72.036826208,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575532,
		"ID": 1084,
		"x": 45.8547356333,
		"y": -72.611802135,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575533,
		"ID": 1084,
		"x": 46.1607316763,
		"y": -72.406780016,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575534,
		"ID": 1084,
		"x": 46.4177389683,
		"y": -72.459766264,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575535,
		"ID": 1084,
		"x": 46.4737161283,
		"y": -72.548843896,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575536,
		"ID": 1084,
		"x": 47.0327214493,
		"y": -72.429841958,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575537,
		"ID": 1084,
		"x": 47.7917341083,
		"y": -72.109781824,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575538,
		"ID": 1084,
		"x": 48.5717071873,
		"y": -72.192847085,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575539,
		"ID": 1084,
		"x": 48.4657682643,
		"y": -72.813809166,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575540,
		"ID": 1084,
		"x": 48.9577473013,
		"y": -75.709796755,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575549,
		"ID": 1084,
		"x": 48.5057030993,
		"y": -71.647781403,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575550,
		"ID": 1084,
		"x": 46.1207467643,
		"y": -72.896793987,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575551,
		"ID": 1084,
		"x": 45.7407454793,
		"y": -73.110773334,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575552,
		"ID": 1084,
		"x": 45.5107544033,
		"y": -73.283768099,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575557,
		"ID": 1084,
		"x": 45.8517265013,
		"y": -72.527800409,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575558,
		"ID": 1084,
		"x": 45.4937038473,
		"y": -72.804755693,
		"h": 2.0879120879
	},
	{
		"stop_id": 8505408,
		"ID": 1049,
		"x": 43.6827553703,
		"y": -74.410815096,
		"h": 1.6923076923
	},
	{
		"stop_id": 8505410,
		"ID": 1049,
		"x": 44.3247446593,
		"y": -73.838805688,
		"h": 1.6923076923
	},
	{
		"stop_id": 8505862,
		"ID": 1049,
		"x": 40.4577277353,
		"y": -75.769783268,
		"h": 1.6923076923
	},
	{
		"stop_id": 8575553,
		"ID": 1049,
		"x": 45.0837160503,
		"y": -73.435814913,
		"h": 1.6923076923
	},
	{
		"stop_id": 8575554,
		"ID": 1049,
		"x": 44.7677295673,
		"y": -73.662856416,
		"h": 1.6923076923
	},
	{
		"stop_id": 8575555,
		"ID": 1049,
		"x": 44.5467612183,
		"y": -73.796855649,
		"h": 1.6923076923
	},
	{
		"stop_id": 8575556,
		"ID": 1049,
		"x": 44.3907193453,
		"y": -73.745836404,
		"h": 1.6923076923
	},
	{
		"stop_id": 8575559,
		"ID": 1049,
		"x": 44.7127077123,
		"y": -73.457783491,
		"h": 1.6923076923
	},
	{
		"stop_id": 8575560,
		"ID": 1049,
		"x": 44.0857263313,
		"y": -74.016792238,
		"h": 1.6923076923
	},
	{
		"stop_id": 8575561,
		"ID": 1049,
		"x": 43.4637595123,
		"y": -74.522837528,
		"h": 1.6923076923
	},
	{
		"stop_id": 8575562,
		"ID": 1049,
		"x": 43.1797111543,
		"y": -74.952825138,
		"h": 1.6923076923
	},
	{
		"stop_id": 8575563,
		"ID": 1049,
		"x": 42.7317474073,
		"y": -75.473849017,
		"h": 1.6923076923
	},
	{
		"stop_id": 8575564,
		"ID": 1049,
		"x": 42.2137677403,
		"y": -75.873827125,
		"h": 1.6923076923
	},
	{
		"stop_id": 8575565,
		"ID": 1049,
		"x": 43.7067431743,
		"y": -74.402845543,
		"h": 1.6923076923
	},
	{
		"stop_id": 8575566,
		"ID": 1049,
		"x": 43.4467301713,
		"y": -74.680783557,
		"h": 1.6923076923
	},
	{
		"stop_id": 8575567,
		"ID": 1049,
		"x": 43.4187496333,
		"y": -74.967775918,
		"h": 1.6923076923
	},
	{
		"stop_id": 8575568,
		"ID": 1049,
		"x": 43.3917402203,
		"y": -75.193823832,
		"h": 1.6923076923
	},
	{
		"stop_id": 8575569,
		"ID": 1049,
		"x": 42.8907323953,
		"y": -75.381770496,
		"h": 1.6923076923
	},
	{
		"stop_id": 8575570,
		"ID": 1049,
		"x": 42.8497707933,
		"y": -75.547791123,
		"h": 1.6923076923
	},
	{
		"stop_id": 8575571,
		"ID": 1049,
		"x": 42.6847317713,
		"y": -75.780838277,
		"h": 1.6923076923
	},
	{
		"stop_id": 8575572,
		"ID": 1049,
		"x": 42.5747279023,
		"y": -75.957806437,
		"h": 1.6923076923
	},
	{
		"stop_id": 8581163,
		"ID": 1049,
		"x": 44.3057256993,
		"y": -73.82979276,
		"h": 1.6923076923
	},
	{
		"stop_id": 8505451,
		"ID": 1016,
		"x": 39.2577276043,
		"y": -72.469851023,
		"h": 2.021978022
	},
	{
		"stop_id": 8505456,
		"ID": 1016,
		"x": 40.2577163093,
		"y": -70.790838638,
		"h": 2.021978022
	},
	{
		"stop_id": 8505852,
		"ID": 1016,
		"x": 38.4677623403,
		"y": -74.381774442,
		"h": 2.021978022
	},
	{
		"stop_id": 8505855,
		"ID": 1016,
		"x": 39.8067559873,
		"y": -71.444778801,
		"h": 2.021978022
	},
	{
		"stop_id": 8578917,
		"ID": 1016,
		"x": 38.9327120793,
		"y": -73.419851724,
		"h": 2.021978022
	},
	{
		"stop_id": 8578918,
		"ID": 1016,
		"x": 38.8827009233,
		"y": -73.61978996,
		"h": 2.021978022
	},
	{
		"stop_id": 8578919,
		"ID": 1016,
		"x": 38.6327604803,
		"y": -74.019764286,
		"h": 2.021978022
	},
	{
		"stop_id": 8578921,
		"ID": 1016,
		"x": 38.2277517433,
		"y": -74.959792947,
		"h": 2.021978022
	},
	{
		"stop_id": 8578922,
		"ID": 1016,
		"x": 37.9327259563,
		"y": -74.544845247,
		"h": 2.021978022
	},
	{
		"stop_id": 8578933,
		"ID": 1016,
		"x": 39.8077171903,
		"y": -71.319795802,
		"h": 2.021978022
	},
	{
		"stop_id": 8578934,
		"ID": 1016,
		"x": 39.7827270553,
		"y": -71.36979282,
		"h": 2.021978022
	},
	{
		"stop_id": 8578936,
		"ID": 1016,
		"x": 39.9077366023,
		"y": -71.419771524,
		"h": 2.021978022
	},
	{
		"stop_id": 8587114,
		"ID": 1016,
		"x": 37.9077600113,
		"y": -75.044781113,
		"h": 2.021978022
	},
	{
		"stop_id": 8587115,
		"ID": 1016,
		"x": 37.7577485263,
		"y": -75.169826561,
		"h": 2.021978022
	},
	{
		"stop_id": 8587116,
		"ID": 1016,
		"x": 38.2827701373,
		"y": -73.694781229,
		"h": 2.021978022
	},
	{
		"stop_id": 8587117,
		"ID": 1016,
		"x": 38.2077037083,
		"y": -73.469853227,
		"h": 2.021978022
	},
	{
		"stop_id": 8587119,
		"ID": 1016,
		"x": 39.7577050553,
		"y": -71.869850109,
		"h": 2.021978022
	},
	{
		"stop_id": 8589868,
		"ID": 1016,
		"x": 37.7977000453,
		"y": -75.629804889,
		"h": 2.021978022
	},
	{
		"stop_id": 8591532,
		"ID": 1016,
		"x": 39.4327052073,
		"y": -72.076857866,
		"h": 2.021978022
	},
	{
		"stop_id": 8591533,
		"ID": 1016,
		"x": 38.0217452373,
		"y": -74.584769981,
		"h": 2.021978022
	},
	{
		"stop_id": 8591534,
		"ID": 1016,
		"x": 38.2846996223,
		"y": -74.416756331,
		"h": 2.021978022
	},
	{
		"stop_id": 8591535,
		"ID": 1016,
		"x": 38.1857238663,
		"y": -74.310843858,
		"h": 2.021978022
	},
	{
		"stop_id": 8591536,
		"ID": 1016,
		"x": 37.6717707683,
		"y": -75.343760113,
		"h": 2.021978022
	},
	{
		"stop_id": 8591537,
		"ID": 1016,
		"x": 38.4347715403,
		"y": -73.733792401,
		"h": 2.021978022
	},
	{
		"stop_id": 8591538,
		"ID": 1016,
		"x": 39.6307176403,
		"y": -71.911847088,
		"h": 2.021978022
	},
	{
		"stop_id": 8591539,
		"ID": 1016,
		"x": 38.6457233353,
		"y": -73.741824803,
		"h": 2.021978022
	},
	{
		"stop_id": 8591540,
		"ID": 1016,
		"x": 38.2087647033,
		"y": -74.425765939,
		"h": 2.021978022
	},
	{
		"stop_id": 8591541,
		"ID": 1016,
		"x": 37.6557639073,
		"y": -75.160791842,
		"h": 2.021978022
	},
	{
		"stop_id": 8591565,
		"ID": 1016,
		"x": 40.6607686733,
		"y": -70.916813909,
		"h": 2.021978022
	},
	{
		"stop_id": 8591566,
		"ID": 1016,
		"x": 40.2757576173,
		"y": -71.120859409,
		"h": 2.021978022
	},
	{
		"stop_id": 8591567,
		"ID": 1016,
		"x": 39.7447565263,
		"y": -71.584772713,
		"h": 2.021978022
	},
	{
		"stop_id": 8594191,
		"ID": 1016,
		"x": 39.5777551363,
		"y": -71.839780508,
		"h": 2.021978022
	},
	{
		"stop_id": 8505473,
		"ID": 1051,
		"x": 41.7597244183,
		"y": -66.810819657,
		"h": 1.1648351648
	},
	{
		"stop_id": 8505474,
		"ID": 1051,
		"x": 40.9247577313,
		"y": -64.643831958,
		"h": 1.1648351648
	},
	{
		"stop_id": 8530451,
		"ID": 1051,
		"x": 43.9627488923,
		"y": -66.207806078,
		"h": 1.1648351648
	},
	{
		"stop_id": 8575475,
		"ID": 1051,
		"x": 41.8317058543,
		"y": -66.783818894,
		"h": 1.1648351648
	},
	{
		"stop_id": 8578888,
		"ID": 1051,
		"x": 41.0077579333,
		"y": -65.09484608,
		"h": 1.1648351648
	},
	{
		"stop_id": 8587745,
		"ID": 1051,
		"x": 41.0827253513,
		"y": -64.019813924,
		"h": 1.1648351648
	},
	{
		"stop_id": 8505475,
		"ID": 1018,
		"x": 40.7947029863,
		"y": -62.367789535,
		"h": 1.1318681319
	},
	{
		"stop_id": 8505477,
		"ID": 1018,
		"x": 38.6327173123,
		"y": -60.844795497,
		"h": 1.1318681319
	},
	{
		"stop_id": 8505478,
		"ID": 1018,
		"x": 38.0937545723,
		"y": -60.26083448,
		"h": 1.1318681319
	},
	{
		"stop_id": 8505487,
		"ID": 1018,
		"x": 39.5637490763,
		"y": -61.491776683,
		"h": 1.1318681319
	},
	{
		"stop_id": 8578895,
		"ID": 1018,
		"x": 37.6077264733,
		"y": -60.069773796,
		"h": 1.1318681319
	},
	{
		"stop_id": 8505479,
		"ID": 985,
		"x": 36.7547751153,
		"y": -58.483789585,
		"h": 1.0989010989
	},
	{
		"stop_id": 8505481,
		"ID": 985,
		"x": 36.1787626283,
		"y": -57.590843983,
		"h": 1.0989010989
	},
	{
		"stop_id": 8505482,
		"ID": 985,
		"x": 34.4927082233,
		"y": -55.686844728,
		"h": 1.0989010989
	},
	{
		"stop_id": 8505857,
		"ID": 985,
		"x": 35.9517041293,
		"y": -57.191750427,
		"h": 1.0989010989
	},
	{
		"stop_id": 8505483,
		"ID": 986,
		"x": 31.9137459613,
		"y": -54.554787139,
		"h": 1.032967033
	},
	{
		"stop_id": 8578900,
		"ID": 986,
		"x": 32.3827030443,
		"y": -54.794807149,
		"h": 1.032967033
	},
	{
		"stop_id": 8505484,
		"ID": 953,
		"x": 29.8997539033,
		"y": -52.383788846,
		"h": 1.2967032967
	},
	{
		"stop_id": 8505485,
		"ID": 953,
		"x": 30.0587726623,
		"y": -51.493788181,
		"h": 1.2967032967
	},
	{
		"stop_id": 8505486,
		"ID": 953,
		"x": 30.2567347923,
		"y": -49.907788321,
		"h": 1.2967032967
	},
	{
		"stop_id": 8505856,
		"ID": 953,
		"x": 30.2077190923,
		"y": -49.294819521,
		"h": 1.2967032967
	},
	{
		"stop_id": 8575873,
		"ID": 953,
		"x": 28.2787707553,
		"y": -47.903843963,
		"h": 1.2967032967
	},
	{
		"stop_id": 8575874,
		"ID": 953,
		"x": 27.9827414023,
		"y": -47.544826158,
		"h": 1.2967032967
	},
	{
		"stop_id": 8575875,
		"ID": 953,
		"x": 26.9827401543,
		"y": -46.944799089,
		"h": 1.2967032967
	},
	{
		"stop_id": 8575887,
		"ID": 953,
		"x": 29.8607548563,
		"y": -52.392816709,
		"h": 1.2967032967
	},
	{
		"stop_id": 8578904,
		"ID": 953,
		"x": 29.8827234893,
		"y": -52.019824723,
		"h": 1.2967032967
	},
	{
		"stop_id": 8591542,
		"ID": 953,
		"x": 30.5077099743,
		"y": -49.24476166,
		"h": 1.2967032967
	},
	{
		"stop_id": 8505491,
		"ID": 1017,
		"x": 40.9347003693,
		"y": -66.783786289,
		"h": 1.4945054945
	},
	{
		"stop_id": 8505492,
		"ID": 1017,
		"x": 39.9407494753,
		"y": -66.959770618,
		"h": 1.4945054945
	},
	{
		"stop_id": 8505493,
		"ID": 1017,
		"x": 39.3017142113,
		"y": -67.062756015,
		"h": 1.4945054945
	},
	{
		"stop_id": 8505494,
		"ID": 1017,
		"x": 37.8337663903,
		"y": -67.762778296,
		"h": 1.4945054945
	},
	{
		"stop_id": 8505595,
		"ID": 1017,
		"x": 36.7397396993,
		"y": -67.857793693,
		"h": 1.4945054945
	},
	{
		"stop_id": 8530455,
		"ID": 1017,
		"x": 37.7197628603,
		"y": -67.603847306,
		"h": 1.4945054945
	},
	{
		"stop_id": 8573601,
		"ID": 1017,
		"x": 37.5987586993,
		"y": -67.234785566,
		"h": 1.4945054945
	},
	{
		"stop_id": 8575479,
		"ID": 1017,
		"x": 37.3917033723,
		"y": -66.636848896,
		"h": 1.4945054945
	},
	{
		"stop_id": 8575480,
		"ID": 1017,
		"x": 37.3467559553,
		"y": -66.207748498,
		"h": 1.4945054945
	},
	{
		"stop_id": 8576365,
		"ID": 1017,
		"x": 38.8927358343,
		"y": -67.024846457,
		"h": 1.4945054945
	},
	{
		"stop_id": 8576372,
		"ID": 1017,
		"x": 37.8417535563,
		"y": -67.601772178,
		"h": 1.4945054945
	},
	{
		"stop_id": 8576380,
		"ID": 1017,
		"x": 38.7257445883,
		"y": -67.66885114,
		"h": 1.4945054945
	},
	{
		"stop_id": 8576448,
		"ID": 1017,
		"x": 39.9117560813,
		"y": -67.830791789,
		"h": 1.4945054945
	},
	{
		"stop_id": 8576465,
		"ID": 1017,
		"x": 40.3537437653,
		"y": -67.908780339,
		"h": 1.4945054945
	},
	{
		"stop_id": 8576971,
		"ID": 1017,
		"x": 38.0887670403,
		"y": -67.708856827,
		"h": 1.4945054945
	},
	{
		"stop_id": 8579093,
		"ID": 1017,
		"x": 36.7647551433,
		"y": -65.38576082,
		"h": 1.4945054945
	},
	{
		"stop_id": 8505495,
		"ID": 983,
		"x": 35.7547221553,
		"y": -68.779847349,
		"h": 1.1978021978
	},
	{
		"stop_id": 8505496,
		"ID": 983,
		"x": 33.7577335493,
		"y": -69.210792736,
		"h": 1.1978021978
	},
	{
		"stop_id": 8505497,
		"ID": 983,
		"x": 32.3537523783,
		"y": -69.679787754,
		"h": 1.1978021978
	},
	{
		"stop_id": 8505498,
		"ID": 983,
		"x": 31.7067265583,
		"y": -69.985765583,
		"h": 1.1978021978
	},
	{
		"stop_id": 8505499,
		"ID": 983,
		"x": 30.8247651603,
		"y": -70.40581098,
		"h": 1.1978021978
	},
	{
		"stop_id": 8505598,
		"ID": 983,
		"x": 34.1927101313,
		"y": -70.156758567,
		"h": 1.1978021978
	},
	{
		"stop_id": 8530804,
		"ID": 983,
		"x": 33.7207158383,
		"y": -69.214810373,
		"h": 1.1978021978
	},
	{
		"stop_id": 8505538,
		"ID": 1190,
		"x": 62.7087414253,
		"y": -85.3938371461,
		"h": 1.2637362637
	},
	{
		"stop_id": 8505541,
		"ID": 1190,
		"x": 60.6867207583,
		"y": -86.666789649,
		"h": 1.2637362637
	},
	{
		"stop_id": 8505545,
		"ID": 1190,
		"x": 62.5327611543,
		"y": -87.2508006548,
		"h": 1.2637362637
	},
	{
		"stop_id": 8505551,
		"ID": 1190,
		"x": 61.5087518813,
		"y": -86.4727598551,
		"h": 1.2637362637
	},
	{
		"stop_id": 8505652,
		"ID": 1190,
		"x": 63.6977292643,
		"y": -84.6857772853,
		"h": 1.2637362637
	},
	{
		"stop_id": 8505656,
		"ID": 1190,
		"x": 62.8497599283,
		"y": -87.1267745086,
		"h": 1.2637362637
	},
	{
		"stop_id": 8575379,
		"ID": 1190,
		"x": 61.3717551333,
		"y": -86.4217880511,
		"h": 1.2637362637
	},
	{
		"stop_id": 8575380,
		"ID": 1190,
		"x": 62.6547145003,
		"y": -85.4038211676,
		"h": 1.2637362637
	},
	{
		"stop_id": 8589075,
		"ID": 1190,
		"x": 61.4407009613,
		"y": -86.467779809,
		"h": 1.2637362637
	},
	{
		"stop_id": 8505549,
		"ID": 893,
		"x": 16.4067450303,
		"y": -22.479814321,
		"h": 1.1318681319
	},
	{
		"stop_id": 8505760,
		"ID": 893,
		"x": 20.0327247133,
		"y": -22.21979639,
		"h": 1.1318681319
	},
	{
		"stop_id": 8508982,
		"ID": 893,
		"x": 18.6487019583,
		"y": -21.898801221,
		"h": 1.1318681319
	},
	{
		"stop_id": 8530613,
		"ID": 893,
		"x": 18.8887716383,
		"y": -22.469776379,
		"h": 1.1318681319
	},
	{
		"stop_id": 8573147,
		"ID": 893,
		"x": 21.7217193843,
		"y": -21.243818292,
		"h": 1.1318681319
	},
	{
		"stop_id": 8505557,
		"ID": 1117,
		"x": 54.9587199063,
		"y": -95.8068209136,
		"h": 2.3846153846
	},
	{
		"stop_id": 8505674,
		"ID": 1117,
		"x": 52.2857566083,
		"y": -90.619835062,
		"h": 2.3846153846
	},
	{
		"stop_id": 8505675,
		"ID": 1117,
		"x": 53.9007084083,
		"y": -92.9968415063,
		"h": 2.3846153846
	},
	{
		"stop_id": 8505750,
		"ID": 1117,
		"x": 54.5007717673,
		"y": -90.8488017772,
		"h": 2.3846153846
	},
	{
		"stop_id": 8505758,
		"ID": 1117,
		"x": 54.2217543403,
		"y": -92.608794666,
		"h": 2.3846153846
	},
	{
		"stop_id": 8505863,
		"ID": 1117,
		"x": 54.8747132523,
		"y": -95.820856929,
		"h": 2.3846153846
	},
	{
		"stop_id": 8530468,
		"ID": 1117,
		"x": 55.5577635713,
		"y": -95.2698017984,
		"h": 2.3846153846
	},
	{
		"stop_id": 8575249,
		"ID": 1117,
		"x": 56.7147288133,
		"y": -92.9438329755,
		"h": 2.3846153846
	},
	{
		"stop_id": 8575250,
		"ID": 1117,
		"x": 56.4517301873,
		"y": -93.7647619112,
		"h": 2.3846153846
	},
	{
		"stop_id": 8575251,
		"ID": 1117,
		"x": 56.2897370413,
		"y": -94.0198065614,
		"h": 2.3846153846
	},
	{
		"stop_id": 8575252,
		"ID": 1117,
		"x": 55.9187139033,
		"y": -94.6288447458,
		"h": 2.3846153846
	},
	{
		"stop_id": 8575253,
		"ID": 1117,
		"x": 55.3617467263,
		"y": -95.3137633045,
		"h": 2.3846153846
	},
	{
		"stop_id": 8575254,
		"ID": 1117,
		"x": 54.3927655953,
		"y": -95.6187704422,
		"h": 2.3846153846
	},
	{
		"stop_id": 8575255,
		"ID": 1117,
		"x": 54.1647659593,
		"y": -95.3148307793,
		"h": 2.3846153846
	},
	{
		"stop_id": 8575256,
		"ID": 1117,
		"x": 53.8857102563,
		"y": -95.1258040357,
		"h": 2.3846153846
	},
	{
		"stop_id": 8575257,
		"ID": 1117,
		"x": 53.4777176003,
		"y": -94.6987786414,
		"h": 2.3846153846
	},
	{
		"stop_id": 8575258,
		"ID": 1117,
		"x": 53.5297722803,
		"y": -94.3027611663,
		"h": 2.3846153846
	},
	{
		"stop_id": 8575259,
		"ID": 1117,
		"x": 53.6517709183,
		"y": -93.8807562907,
		"h": 2.3846153846
	},
	{
		"stop_id": 8575260,
		"ID": 1117,
		"x": 53.9717285653,
		"y": -92.9498161264,
		"h": 2.3846153846
	},
	{
		"stop_id": 8575261,
		"ID": 1117,
		"x": 54.2157009743,
		"y": -92.4968312925,
		"h": 2.3846153846
	},
	{
		"stop_id": 8575262,
		"ID": 1117,
		"x": 54.4727636943,
		"y": -92.3257838594,
		"h": 2.3846153846
	},
	{
		"stop_id": 8575263,
		"ID": 1117,
		"x": 54.8397111553,
		"y": -92.352793352,
		"h": 2.3846153846
	},
	{
		"stop_id": 8575264,
		"ID": 1117,
		"x": 55.0917638233,
		"y": -92.1147676356,
		"h": 2.3846153846
	},
	{
		"stop_id": 8575265,
		"ID": 1117,
		"x": 55.3187469853,
		"y": -91.7577900894,
		"h": 2.3846153846
	},
	{
		"stop_id": 8575266,
		"ID": 1117,
		"x": 55.4807045923,
		"y": -90.7738265159,
		"h": 2.3846153846
	},
	{
		"stop_id": 8575267,
		"ID": 1117,
		"x": 54.7357594533,
		"y": -91.8568537335,
		"h": 2.3846153846
	},
	{
		"stop_id": 8575269,
		"ID": 1117,
		"x": 55.2467176813,
		"y": -90.9588248485,
		"h": 2.3846153846
	},
	{
		"stop_id": 8575285,
		"ID": 1117,
		"x": 54.7127016153,
		"y": -90.2737582385,
		"h": 2.3846153846
	},
	{
		"stop_id": 8575297,
		"ID": 1117,
		"x": 53.4517633793,
		"y": -90.7377775511,
		"h": 2.3846153846
	},
	{
		"stop_id": 8575298,
		"ID": 1117,
		"x": 53.5407093983,
		"y": -91.1298336954,
		"h": 2.3846153846
	},
	{
		"stop_id": 8575299,
		"ID": 1117,
		"x": 53.6877199073,
		"y": -91.6868082526,
		"h": 2.3846153846
	},
	{
		"stop_id": 8575300,
		"ID": 1117,
		"x": 53.9957445053,
		"y": -92.3138208012,
		"h": 2.3846153846
	},
	{
		"stop_id": 8577045,
		"ID": 1117,
		"x": 55.3287456803,
		"y": -91.4338226791,
		"h": 2.3846153846
	},
	{
		"stop_id": 8577046,
		"ID": 1117,
		"x": 55.1007003663,
		"y": -91.6558391391,
		"h": 2.3846153846
	},
	{
		"stop_id": 8577047,
		"ID": 1117,
		"x": 54.8417573513,
		"y": -91.6588339046,
		"h": 2.3846153846
	},
	{
		"stop_id": 8580104,
		"ID": 1117,
		"x": 55.5267727063,
		"y": -94.8667763547,
		"h": 2.3846153846
	},
	{
		"stop_id": 8580115,
		"ID": 1117,
		"x": 55.3567061913,
		"y": -95.149856328,
		"h": 2.3846153846
	},
	{
		"stop_id": 8580238,
		"ID": 1117,
		"x": 55.3737193533,
		"y": -94.9418352632,
		"h": 2.3846153846
	},
	{
		"stop_id": 8580748,
		"ID": 1117,
		"x": 53.7897370323,
		"y": -93.5048159302,
		"h": 2.3846153846
	},
	{
		"stop_id": 8583478,
		"ID": 1117,
		"x": 54.6897755523,
		"y": -90.5838462228,
		"h": 2.3846153846
	},
	{
		"stop_id": 8583479,
		"ID": 1117,
		"x": 54.3357272753,
		"y": -91.3047660806,
		"h": 2.3846153846
	},
	{
		"stop_id": 8583480,
		"ID": 1117,
		"x": 54.6377734933,
		"y": -90.8157606615,
		"h": 2.3846153846
	},
	{
		"stop_id": 8587027,
		"ID": 1117,
		"x": 55.1547408473,
		"y": -95.0348137928,
		"h": 2.3846153846
	},
	{
		"stop_id": 8505558,
		"ID": 1116,
		"x": 53.7197086363,
		"y": -97.9208234233,
		"h": 1.2307692308
	},
	{
		"stop_id": 8575648,
		"ID": 1116,
		"x": 55.7847010273,
		"y": -97.4027586828,
		"h": 1.2307692308
	},
	{
		"stop_id": 8575765,
		"ID": 1116,
		"x": 56.3277343183,
		"y": -98.0547779715,
		"h": 1.2307692308
	},
	{
		"stop_id": 8575767,
		"ID": 1116,
		"x": 55.8257209783,
		"y": -97.1758226358,
		"h": 1.2307692308
	},
	{
		"stop_id": 8578880,
		"ID": 1116,
		"x": 54.9736992433,
		"y": -96.8237978059,
		"h": 1.2307692308
	},
	{
		"stop_id": 8591713,
		"ID": 1116,
		"x": 53.7127727333,
		"y": -97.9318491114,
		"h": 1.2307692308
	},
	{
		"stop_id": 8591714,
		"ID": 1116,
		"x": 54.3277088003,
		"y": -97.4097809987,
		"h": 1.2307692308
	},
	{
		"stop_id": 8591715,
		"ID": 1116,
		"x": 54.1477505413,
		"y": -97.8597929309,
		"h": 1.2307692308
	},
	{
		"stop_id": 8505612,
		"ID": 1083,
		"x": 48.9177104573,
		"y": -75.883849907,
		"h": 1.0659340659
	},
	{
		"stop_id": 8505871,
		"ID": 1083,
		"x": 47.5937769723,
		"y": -76.695825642,
		"h": 1.0659340659
	},
	{
		"stop_id": 8575542,
		"ID": 1083,
		"x": 48.0667732093,
		"y": -76.338765896,
		"h": 1.0659340659
	},
	{
		"stop_id": 8505626,
		"ID": 1086,
		"x": 49.9416990613,
		"y": -63.326767816,
		"h": 1.3956043956
	},
	{
		"stop_id": 8505627,
		"ID": 1086,
		"x": 49.6077582023,
		"y": -62.396756465,
		"h": 1.3956043956
	},
	{
		"stop_id": 8505628,
		"ID": 1086,
		"x": 48.8537002653,
		"y": -61.508749684,
		"h": 1.3956043956
	},
	{
		"stop_id": 8505629,
		"ID": 1086,
		"x": 48.7067386013,
		"y": -60.644824384,
		"h": 1.3956043956
	},
	{
		"stop_id": 8505630,
		"ID": 1086,
		"x": 48.5927076753,
		"y": -59.291768773,
		"h": 1.3956043956
	},
	{
		"stop_id": 8505870,
		"ID": 1086,
		"x": 49.0256989763,
		"y": -63.90577313,
		"h": 1.3956043956
	},
	{
		"stop_id": 8505872,
		"ID": 1086,
		"x": 48.1857001303,
		"y": -58.552785106,
		"h": 1.3956043956
	},
	{
		"stop_id": 8573439,
		"ID": 1086,
		"x": 49.8937009373,
		"y": -63.646845366,
		"h": 1.3956043956
	},
	{
		"stop_id": 8575510,
		"ID": 1086,
		"x": 49.7827260993,
		"y": -62.602839893,
		"h": 1.3956043956
	},
	{
		"stop_id": 8575511,
		"ID": 1086,
		"x": 48.6927683973,
		"y": -61.001750044,
		"h": 1.3956043956
	},
	{
		"stop_id": 8578971,
		"ID": 1086,
		"x": 48.7417549193,
		"y": -64.135791845,
		"h": 1.3956043956
	},
	{
		"stop_id": 8578972,
		"ID": 1086,
		"x": 48.6657182103,
		"y": -64.096794444,
		"h": 1.3956043956
	},
	{
		"stop_id": 8579105,
		"ID": 1086,
		"x": 49.2827501233,
		"y": -62.012811365,
		"h": 1.3956043956
	},
	{
		"stop_id": 8505631,
		"ID": 1087,
		"x": 47.4267447183,
		"y": -58.172805293,
		"h": 1.032967033
	},
	{
		"stop_id": 8583776,
		"ID": 1087,
		"x": 47.7037200243,
		"y": -58.24983262,
		"h": 1.032967033
	},
	{
		"stop_id": 8505632,
		"ID": 1052,
		"x": 45.9807115693,
		"y": -56.942787452,
		"h": 1.0659340659
	},
	{
		"stop_id": 8505633,
		"ID": 1052,
		"x": 45.0837278003,
		"y": -55.7717606,
		"h": 1.0659340659
	},
	{
		"stop_id": 8575512,
		"ID": 1052,
		"x": 45.4817692203,
		"y": -56.120850307,
		"h": 1.0659340659
	},
	{
		"stop_id": 8505634,
		"ID": 1053,
		"x": 44.8077201253,
		"y": -55.095774551,
		"h": 1.2967032967
	},
	{
		"stop_id": 8505635,
		"ID": 1053,
		"x": 44.4757651223,
		"y": -54.362816344,
		"h": 1.2967032967
	},
	{
		"stop_id": 8505636,
		"ID": 1053,
		"x": 44.7147379073,
		"y": -53.586757118,
		"h": 1.2967032967
	},
	{
		"stop_id": 8505637,
		"ID": 1053,
		"x": 45.2647606803,
		"y": -52.429829349,
		"h": 1.2967032967
	},
	{
		"stop_id": 8505638,
		"ID": 1053,
		"x": 45.1977311323,
		"y": -51.688855608,
		"h": 1.2967032967
	},
	{
		"stop_id": 8505639,
		"ID": 1053,
		"x": 45.3197004513,
		"y": -50.680762995,
		"h": 1.2967032967
	},
	{
		"stop_id": 8575513,
		"ID": 1053,
		"x": 44.5827014653,
		"y": -54.655825154,
		"h": 1.2967032967
	},
	{
		"stop_id": 8575514,
		"ID": 1053,
		"x": 45.0227689053,
		"y": -52.784808233,
		"h": 1.2967032967
	},
	{
		"stop_id": 8575515,
		"ID": 1053,
		"x": 45.3267451813,
		"y": -51.931769187,
		"h": 1.2967032967
	},
	{
		"stop_id": 8583241,
		"ID": 1053,
		"x": 45.4947312433,
		"y": -50.245774773,
		"h": 1.2967032967
	},
	{
		"stop_id": 8505640,
		"ID": 1088,
		"x": 45.4537036823,
		"y": -49.804764049,
		"h": 1.032967033
	},
	{
		"stop_id": 8575516,
		"ID": 1088,
		"x": 45.4917660583,
		"y": -50.035803939,
		"h": 1.032967033
	},
	{
		"stop_id": 8505641,
		"ID": 1054,
		"x": 45.1077360433,
		"y": -49.344817358,
		"h": 1.1318681319
	},
	{
		"stop_id": 8505771,
		"ID": 1054,
		"x": 44.1057752273,
		"y": -48.505810295,
		"h": 1.1318681319
	},
	{
		"stop_id": 8575517,
		"ID": 1054,
		"x": 45.2527250683,
		"y": -49.614804927,
		"h": 1.1318681319
	},
	{
		"stop_id": 8575518,
		"ID": 1054,
		"x": 44.3667254243,
		"y": -48.690770183,
		"h": 1.1318681319
	},
	{
		"stop_id": 8579903,
		"ID": 1054,
		"x": 44.9047675643,
		"y": -49.091841656,
		"h": 1.1318681319
	},
	{
		"stop_id": 8505661,
		"ID": 1030,
		"x": 37.3217268323,
		"y": 9.906175969,
		"h": 1.2967032967
	},
	{
		"stop_id": 8505772,
		"ID": 1030,
		"x": 38.6077410183,
		"y": 9.505241177,
		"h": 1.2967032967
	},
	{
		"stop_id": 8505775,
		"ID": 1030,
		"x": 40.8557456063,
		"y": 9.420214668,
		"h": 1.2967032967
	},
	{
		"stop_id": 8573119,
		"ID": 1030,
		"x": 36.9297016683,
		"y": 10.094175882,
		"h": 1.2967032967
	},
	{
		"stop_id": 8573120,
		"ID": 1030,
		"x": 37.6937244403,
		"y": 9.718208662,
		"h": 1.2967032967
	},
	{
		"stop_id": 8573121,
		"ID": 1030,
		"x": 38.4517168983,
		"y": 9.381153217,
		"h": 1.2967032967
	},
	{
		"stop_id": 8573122,
		"ID": 1030,
		"x": 39.0117539243,
		"y": 9.428176389,
		"h": 1.2967032967
	},
	{
		"stop_id": 8573123,
		"ID": 1030,
		"x": 40.0387306533,
		"y": 9.091208911,
		"h": 1.2967032967
	},
	{
		"stop_id": 8573124,
		"ID": 1030,
		"x": 41.0437630813,
		"y": 8.64719757,
		"h": 1.2967032967
	},
	{
		"stop_id": 8581319,
		"ID": 1030,
		"x": 39.4987172573,
		"y": 9.343174995,
		"h": 1.2967032967
	},
	{
		"stop_id": 8505663,
		"ID": 797,
		"x": -0.3862392617,
		"y": 25.783202434,
		"h": 1.6263736264
	},
	{
		"stop_id": 8508218,
		"ID": 797,
		"x": -3.2492776357,
		"y": 27.424185521,
		"h": 1.6263736264
	},
	{
		"stop_id": 8508672,
		"ID": 797,
		"x": -3.5332710137,
		"y": 26.960227902,
		"h": 1.6263736264
	},
	{
		"stop_id": 8508673,
		"ID": 797,
		"x": -3.8542647157,
		"y": 26.684161121,
		"h": 1.6263736264
	},
	{
		"stop_id": 8508675,
		"ID": 797,
		"x": -4.3112918837,
		"y": 25.844179483,
		"h": 1.6263736264
	},
	{
		"stop_id": 8508676,
		"ID": 797,
		"x": -4.2712542177,
		"y": 25.528141645,
		"h": 1.6263736264
	},
	{
		"stop_id": 8508677,
		"ID": 797,
		"x": -4.1492549837,
		"y": 25.286243867,
		"h": 1.6263736264
	},
	{
		"stop_id": 8508678,
		"ID": 797,
		"x": -3.9032363907,
		"y": 25.069188244,
		"h": 1.6263736264
	},
	{
		"stop_id": 8508680,
		"ID": 797,
		"x": -1.2392885157,
		"y": 25.049234129,
		"h": 1.6263736264
	},
	{
		"stop_id": 8508754,
		"ID": 797,
		"x": -1.0882712337,
		"y": 24.251239707,
		"h": 1.6263736264
	},
	{
		"stop_id": 8508787,
		"ID": 797,
		"x": -3.8912993497,
		"y": 24.679180044,
		"h": 1.6263736264
	},
	{
		"stop_id": 8572829,
		"ID": 797,
		"x": -3.2542480927,
		"y": 27.387227509,
		"h": 1.6263736264
	},
	{
		"stop_id": 8573049,
		"ID": 797,
		"x": 0.8687158213,
		"y": 25.239149139,
		"h": 1.6263736264
	},
	{
		"stop_id": 8573050,
		"ID": 797,
		"x": 0.8467611073,
		"y": 25.634163658,
		"h": 1.6263736264
	},
	{
		"stop_id": 8573051,
		"ID": 797,
		"x": 0.6177331513,
		"y": 25.53923152,
		"h": 1.6263736264
	},
	{
		"stop_id": 8573053,
		"ID": 797,
		"x": -0.3602725637,
		"y": 23.914232358,
		"h": 1.6263736264
	},
	{
		"stop_id": 8581158,
		"ID": 797,
		"x": -3.5922552997,
		"y": 24.84319223,
		"h": 1.6263736264
	},
	{
		"stop_id": 8581159,
		"ID": 797,
		"x": -2.6332930907,
		"y": 24.902209026,
		"h": 1.6263736264
	},
	{
		"stop_id": 8583711,
		"ID": 797,
		"x": -1.8022430537,
		"y": 25.392172416,
		"h": 1.6263736264
	},
	{
		"stop_id": 8594401,
		"ID": 797,
		"x": -3.0962769157,
		"y": 27.864231992,
		"h": 1.6263736264
	},
	{
		"stop_id": 8505668,
		"ID": 963,
		"x": 31.0227354733,
		"y": 8.146206881,
		"h": 1.3296703297
	},
	{
		"stop_id": 8530414,
		"ID": 963,
		"x": 31.0107002993,
		"y": 8.140242847,
		"h": 1.3296703297
	},
	{
		"stop_id": 8530415,
		"ID": 963,
		"x": 29.3767287523,
		"y": 6.101186568,
		"h": 1.3296703297
	},
	{
		"stop_id": 8577393,
		"ID": 963,
		"x": 31.4577536073,
		"y": 8.705174931,
		"h": 1.3296703297
	},
	{
		"stop_id": 8577394,
		"ID": 963,
		"x": 31.2327096133,
		"y": 8.355193952,
		"h": 1.3296703297
	},
	{
		"stop_id": 8582061,
		"ID": 963,
		"x": 29.5507482253,
		"y": 10.469211356,
		"h": 1.3296703297
	},
	{
		"stop_id": 8587291,
		"ID": 963,
		"x": 30.3067666773,
		"y": 10.695239694,
		"h": 1.3296703297
	},
	{
		"stop_id": 8588124,
		"ID": 963,
		"x": 30.0077236943,
		"y": 10.390219322,
		"h": 1.3296703297
	},
	{
		"stop_id": 8593514,
		"ID": 963,
		"x": 30.9077655563,
		"y": 8.330248682,
		"h": 1.3296703297
	},
	{
		"stop_id": 8593515,
		"ID": 963,
		"x": 30.9157191363,
		"y": 8.706164112,
		"h": 1.3296703297
	},
	{
		"stop_id": 8595392,
		"ID": 963,
		"x": 29.8367290183,
		"y": 10.314164406,
		"h": 1.3296703297
	},
	{
		"stop_id": 8505678,
		"ID": 1191,
		"x": 65.3107103283,
		"y": -84.3217673407,
		"h": 1.1978021978
	},
	{
		"stop_id": 8575467,
		"ID": 1191,
		"x": 61.9067682413,
		"y": -79.101757666,
		"h": 1.1978021978
	},
	{
		"stop_id": 8575468,
		"ID": 1191,
		"x": 61.7507683103,
		"y": -79.55475214,
		"h": 1.1978021978
	},
	{
		"stop_id": 8579010,
		"ID": 1191,
		"x": 60.6577311343,
		"y": -81.169753248,
		"h": 1.1978021978
	},
	{
		"stop_id": 8591716,
		"ID": 1191,
		"x": 60.4177452343,
		"y": -81.509852399,
		"h": 1.1978021978
	},
	{
		"stop_id": 8591718,
		"ID": 1191,
		"x": 60.4977131963,
		"y": -81.329811716,
		"h": 1.1978021978
	},
	{
		"stop_id": 8594974,
		"ID": 1191,
		"x": 61.1937323083,
		"y": -80.671758929,
		"h": 1.1978021978
	},
	{
		"stop_id": 8505701,
		"ID": 696,
		"x": -15.3892842427,
		"y": -62.543828123,
		"h": 1.0989010989
	},
	{
		"stop_id": 8505711,
		"ID": 696,
		"x": -14.8652718537,
		"y": -63.169849537,
		"h": 1.0989010989
	},
	{
		"stop_id": 8571178,
		"ID": 696,
		"x": -14.8362647747,
		"y": -61.649850189,
		"h": 1.0989010989
	},
	{
		"stop_id": 8571179,
		"ID": 696,
		"x": -13.3422870977,
		"y": -64.32275776,
		"h": 1.0989010989
	},
	{
		"stop_id": 8505739,
		"ID": 1135,
		"x": 54.9517736273,
		"y": 13.596157015,
		"h": 1.0989010989
	},
	{
		"stop_id": 8505776,
		"ID": 1135,
		"x": 51.6697052093,
		"y": 11.656200784,
		"h": 1.0989010989
	},
	{
		"stop_id": 8505996,
		"ID": 1135,
		"x": 53.2737104513,
		"y": 12.488206502,
		"h": 1.0989010989
	},
	{
		"stop_id": 8505997,
		"ID": 1135,
		"x": 53.7517483863,
		"y": 12.921230377,
		"h": 1.0989010989
	},
	{
		"stop_id": 8505751,
		"ID": 1082,
		"x": 47.0607428453,
		"y": -86.0277727532,
		"h": 1.956043956
	},
	{
		"stop_id": 8505765,
		"ID": 1082,
		"x": 50.1617090923,
		"y": -86.1988407202,
		"h": 1.956043956
	},
	{
		"stop_id": 8505777,
		"ID": 1082,
		"x": 49.0987516153,
		"y": -87.0058326576,
		"h": 1.956043956
	},
	{
		"stop_id": 8505785,
		"ID": 1082,
		"x": 49.0997026453,
		"y": -86.2198492256,
		"h": 1.956043956
	},
	{
		"stop_id": 8505786,
		"ID": 1082,
		"x": 48.2887438153,
		"y": -85.8508473056,
		"h": 1.956043956
	},
	{
		"stop_id": 8505787,
		"ID": 1082,
		"x": 51.0037638443,
		"y": -83.6667571292,
		"h": 1.956043956
	},
	{
		"stop_id": 8505792,
		"ID": 1082,
		"x": 50.0737216023,
		"y": -84.6488430403,
		"h": 1.956043956
	},
	{
		"stop_id": 8505886,
		"ID": 1082,
		"x": 51.1507025193,
		"y": -85.2848254784,
		"h": 1.956043956
	},
	{
		"stop_id": 8530464,
		"ID": 1082,
		"x": 50.0307146533,
		"y": -84.6648527907,
		"h": 1.956043956
	},
	{
		"stop_id": 8530465,
		"ID": 1082,
		"x": 48.3417337723,
		"y": -82.8087870329,
		"h": 1.956043956
	},
	{
		"stop_id": 8575372,
		"ID": 1082,
		"x": 51.1347619003,
		"y": -83.5038152723,
		"h": 1.956043956
	},
	{
		"stop_id": 8575373,
		"ID": 1082,
		"x": 50.9437209203,
		"y": -83.7588013059,
		"h": 1.956043956
	},
	{
		"stop_id": 8575375,
		"ID": 1082,
		"x": 50.0797290233,
		"y": -84.0087533401,
		"h": 1.956043956
	},
	{
		"stop_id": 8575389,
		"ID": 1082,
		"x": 51.4257146843,
		"y": -84.8797532232,
		"h": 1.956043956
	},
	{
		"stop_id": 8575405,
		"ID": 1082,
		"x": 50.2707646983,
		"y": -86.6338252361,
		"h": 1.956043956
	},
	{
		"stop_id": 8575406,
		"ID": 1082,
		"x": 50.0257504893,
		"y": -85.5817748322,
		"h": 1.956043956
	},
	{
		"stop_id": 8575844,
		"ID": 1082,
		"x": 50.3317211463,
		"y": -87.1588504501,
		"h": 1.956043956
	},
	{
		"stop_id": 8575845,
		"ID": 1082,
		"x": 50.2437217323,
		"y": -86.7877505802,
		"h": 1.956043956
	},
	{
		"stop_id": 8575846,
		"ID": 1082,
		"x": 49.6827722553,
		"y": -86.3407965363,
		"h": 1.956043956
	},
	{
		"stop_id": 8575847,
		"ID": 1082,
		"x": 48.5917668063,
		"y": -85.8447842356,
		"h": 1.956043956
	},
	{
		"stop_id": 8575848,
		"ID": 1082,
		"x": 47.7717030013,
		"y": -86.0728264217,
		"h": 1.956043956
	},
	{
		"stop_id": 8575850,
		"ID": 1082,
		"x": 50.6107260613,
		"y": -83.5588351124,
		"h": 1.956043956
	},
	{
		"stop_id": 8575853,
		"ID": 1082,
		"x": 49.4497513863,
		"y": -87.0447876718,
		"h": 1.956043956
	},
	{
		"stop_id": 8575855,
		"ID": 1082,
		"x": 48.3717616493,
		"y": -87.268754474,
		"h": 1.956043956
	},
	{
		"stop_id": 8580041,
		"ID": 1082,
		"x": 51.6277630803,
		"y": -84.1808086726,
		"h": 1.956043956
	},
	{
		"stop_id": 8581411,
		"ID": 1082,
		"x": 50.1767691233,
		"y": -84.4068193084,
		"h": 1.956043956
	},
	{
		"stop_id": 8582392,
		"ID": 1082,
		"x": 49.3337251543,
		"y": -86.6458270722,
		"h": 1.956043956
	},
	{
		"stop_id": 8582408,
		"ID": 1082,
		"x": 47.6907237193,
		"y": -86.4658505818,
		"h": 1.956043956
	},
	{
		"stop_id": 8582409,
		"ID": 1082,
		"x": 47.8697556143,
		"y": -86.8238097516,
		"h": 1.956043956
	},
	{
		"stop_id": 8583889,
		"ID": 1082,
		"x": 50.0317750833,
		"y": -84.6378156577,
		"h": 1.956043956
	},
	{
		"stop_id": 8505752,
		"ID": 1098,
		"x": 46.8697153273,
		"y": 9.618234621,
		"h": 1.0989010989
	},
	{
		"stop_id": 8505880,
		"ID": 1098,
		"x": 49.7787095433,
		"y": 9.262183587,
		"h": 1.0989010989
	},
	{
		"stop_id": 8505975,
		"ID": 1098,
		"x": 48.2317080313,
		"y": 9.178239415,
		"h": 1.0989010989
	},
	{
		"stop_id": 8573128,
		"ID": 1098,
		"x": 49.4267428893,
		"y": 9.674148371,
		"h": 1.0989010989
	},
	{
		"stop_id": 8505762,
		"ID": 927,
		"x": 25.2377668143,
		"y": -6.899820007,
		"h": 1.0989010989
	},
	{
		"stop_id": 8508723,
		"ID": 927,
		"x": 23.5047234493,
		"y": -5.987782484,
		"h": 1.0989010989
	},
	{
		"stop_id": 8580197,
		"ID": 927,
		"x": 21.9287483953,
		"y": -5.098795077,
		"h": 1.0989010989
	},
	{
		"stop_id": 8580375,
		"ID": 927,
		"x": 25.7507008613,
		"y": -7.292773231,
		"h": 1.0989010989
	},
	{
		"stop_id": 8505763,
		"ID": 921,
		"x": 24.1367510043,
		"y": -42.10683704,
		"h": 1.1318681319
	},
	{
		"stop_id": 8530457,
		"ID": 921,
		"x": 24.1557220373,
		"y": -42.132810741,
		"h": 1.1318681319
	},
	{
		"stop_id": 8530458,
		"ID": 921,
		"x": 22.7687703103,
		"y": -38.464803673,
		"h": 1.1318681319
	},
	{
		"stop_id": 8575880,
		"ID": 921,
		"x": 24.7827130013,
		"y": -43.819825663,
		"h": 1.1318681319
	},
	{
		"stop_id": 8575881,
		"ID": 921,
		"x": 23.8797685553,
		"y": -42.307852513,
		"h": 1.1318681319
	},
	{
		"stop_id": 8505768,
		"ID": 1230,
		"x": 70.0597048463,
		"y": -45.457817324,
		"h": 1.0659340659
	},
	{
		"stop_id": 8505981,
		"ID": 1230,
		"x": 70.1487416243,
		"y": -46.415810089,
		"h": 1.0659340659
	},
	{
		"stop_id": 8580090,
		"ID": 1230,
		"x": 70.1077394433,
		"y": -45.994835239,
		"h": 1.0659340659
	},
	{
		"stop_id": 8505774,
		"ID": 1064,
		"x": 41.6947163193,
		"y": 8.566250677,
		"h": 1.2307692308
	},
	{
		"stop_id": 8573125,
		"ID": 1064,
		"x": 42.5577297973,
		"y": 8.675232688,
		"h": 1.2307692308
	},
	{
		"stop_id": 8573126,
		"ID": 1064,
		"x": 42.5837513953,
		"y": 9.414171674,
		"h": 1.2307692308
	},
	{
		"stop_id": 8573127,
		"ID": 1064,
		"x": 46.2167129553,
		"y": 9.816216758,
		"h": 1.2307692308
	},
	{
		"stop_id": 8583352,
		"ID": 1064,
		"x": 42.9517638423,
		"y": 8.764150597,
		"h": 1.2307692308
	},
	{
		"stop_id": 8583353,
		"ID": 1064,
		"x": 42.0167285663,
		"y": 8.909167071,
		"h": 1.2307692308
	},
	{
		"stop_id": 8583354,
		"ID": 1064,
		"x": 41.3457549503,
		"y": 9.468169557,
		"h": 1.2307692308
	},
	{
		"stop_id": 8583355,
		"ID": 1064,
		"x": 41.9957447873,
		"y": 9.228245468,
		"h": 1.2307692308
	},
	{
		"stop_id": 8505779,
		"ID": 894,
		"x": 21.4447483193,
		"y": -15.600811005,
		"h": 1
	},
	{
		"stop_id": 8505783,
		"ID": 919,
		"x": 21.4777165513,
		"y": -52.595790417,
		"h": 1.3296703297
	},
	{
		"stop_id": 8575893,
		"ID": 919,
		"x": 25.7327656633,
		"y": -54.394750658,
		"h": 1.3296703297
	},
	{
		"stop_id": 8575894,
		"ID": 919,
		"x": 25.3947762243,
		"y": -54.163826804,
		"h": 1.3296703297
	},
	{
		"stop_id": 8575895,
		"ID": 919,
		"x": 25.6417751563,
		"y": -53.78478991,
		"h": 1.3296703297
	},
	{
		"stop_id": 8575896,
		"ID": 919,
		"x": 25.5607724033,
		"y": -53.493762675,
		"h": 1.3296703297
	},
	{
		"stop_id": 8575897,
		"ID": 919,
		"x": 25.1887143973,
		"y": -52.769798392,
		"h": 1.3296703297
	},
	{
		"stop_id": 8575898,
		"ID": 919,
		"x": 22.7857746393,
		"y": -52.338820296,
		"h": 1.3296703297
	},
	{
		"stop_id": 8575899,
		"ID": 919,
		"x": 25.0377659863,
		"y": -54.36584829,
		"h": 1.3296703297
	},
	{
		"stop_id": 8575900,
		"ID": 919,
		"x": 24.4357323983,
		"y": -55.124809808,
		"h": 1.3296703297
	},
	{
		"stop_id": 8575902,
		"ID": 919,
		"x": 23.3317372163,
		"y": -55.5437585,
		"h": 1.3296703297
	},
	{
		"stop_id": 8581751,
		"ID": 919,
		"x": 25.5267526303,
		"y": -53.195845956,
		"h": 1.3296703297
	},
	{
		"stop_id": 8505784,
		"ID": 988,
		"x": 34.3467740803,
		"y": -38.246764073,
		"h": 1.3626373626
	},
	{
		"stop_id": 8573562,
		"ID": 988,
		"x": 31.7307168103,
		"y": -41.813807646,
		"h": 1.3626373626
	},
	{
		"stop_id": 8575652,
		"ID": 988,
		"x": 33.2127085683,
		"y": -42.351824839,
		"h": 1.3626373626
	},
	{
		"stop_id": 8575653,
		"ID": 988,
		"x": 33.4657547173,
		"y": -41.183772656,
		"h": 1.3626373626
	},
	{
		"stop_id": 8575654,
		"ID": 988,
		"x": 33.8217570683,
		"y": -40.444816838,
		"h": 1.3626373626
	},
	{
		"stop_id": 8575655,
		"ID": 988,
		"x": 34.0817347503,
		"y": -39.725788996,
		"h": 1.3626373626
	},
	{
		"stop_id": 8575656,
		"ID": 988,
		"x": 34.3187746033,
		"y": -39.417800464,
		"h": 1.3626373626
	},
	{
		"stop_id": 8575870,
		"ID": 988,
		"x": 33.8287246903,
		"y": -43.650760034,
		"h": 1.3626373626
	},
	{
		"stop_id": 8575871,
		"ID": 988,
		"x": 33.7067215373,
		"y": -43.322784579,
		"h": 1.3626373626
	},
	{
		"stop_id": 8575882,
		"ID": 988,
		"x": 32.2487676003,
		"y": -41.852846957,
		"h": 1.3626373626
	},
	{
		"stop_id": 8575883,
		"ID": 988,
		"x": 31.3057218033,
		"y": -41.93274894,
		"h": 1.3626373626
	},
	{
		"stop_id": 8575884,
		"ID": 988,
		"x": 30.8077414923,
		"y": -41.944802568,
		"h": 1.3626373626
	},
	{
		"stop_id": 8505798,
		"ID": 891,
		"x": 21.7177560983,
		"y": -32.164778772,
		"h": 1.0659340659
	},
	{
		"stop_id": 8505869,
		"ID": 891,
		"x": 19.7687123023,
		"y": -33.750829114,
		"h": 1.0659340659
	},
	{
		"stop_id": 8575694,
		"ID": 891,
		"x": 20.6137253033,
		"y": -33.237773787,
		"h": 1.0659340659
	},
	{
		"stop_id": 8505799,
		"ID": 1156,
		"x": 59.7857265163,
		"y": -72.774855407,
		"h": 1.4285714286
	},
	{
		"stop_id": 8505966,
		"ID": 1156,
		"x": 58.5757511293,
		"y": -74.34075666,
		"h": 1.4285714286
	},
	{
		"stop_id": 8573329,
		"ID": 1156,
		"x": 57.0597006643,
		"y": -70.384782265,
		"h": 1.4285714286
	},
	{
		"stop_id": 8575750,
		"ID": 1156,
		"x": 56.8397095613,
		"y": -74.814792706,
		"h": 1.4285714286
	},
	{
		"stop_id": 8575751,
		"ID": 1156,
		"x": 57.7437064433,
		"y": -74.275768649,
		"h": 1.4285714286
	},
	{
		"stop_id": 8575752,
		"ID": 1156,
		"x": 58.0937342693,
		"y": -74.266752768,
		"h": 1.4285714286
	},
	{
		"stop_id": 8575753,
		"ID": 1156,
		"x": 59.5017409093,
		"y": -73.059750829,
		"h": 1.4285714286
	},
	{
		"stop_id": 8580723,
		"ID": 1156,
		"x": 56.5677480963,
		"y": -71.321759807,
		"h": 1.4285714286
	},
	{
		"stop_id": 8580731,
		"ID": 1156,
		"x": 56.2267442733,
		"y": -71.207768649,
		"h": 1.4285714286
	},
	{
		"stop_id": 8580978,
		"ID": 1156,
		"x": 57.9907621303,
		"y": -74.315785058,
		"h": 1.4285714286
	},
	{
		"stop_id": 8581983,
		"ID": 1156,
		"x": 60.2077439113,
		"y": -72.442852565,
		"h": 1.4285714286
	},
	{
		"stop_id": 8581984,
		"ID": 1156,
		"x": 59.9617720713,
		"y": -72.685767309,
		"h": 1.4285714286
	},
	{
		"stop_id": 8583475,
		"ID": 1156,
		"x": 56.8877038173,
		"y": -70.429789916,
		"h": 1.4285714286
	},
	{
		"stop_id": 8583741,
		"ID": 1156,
		"x": 57.1687689403,
		"y": -70.598825292,
		"h": 1.4285714286
	},
	{
		"stop_id": 8505865,
		"ID": 923,
		"x": 26.3947714503,
		"y": -30.043829385,
		"h": 1.0989010989
	},
	{
		"stop_id": 8505866,
		"ID": 923,
		"x": 24.6277437383,
		"y": -30.749803904,
		"h": 1.0989010989
	},
	{
		"stop_id": 8505867,
		"ID": 923,
		"x": 23.6377315713,
		"y": -31.01985399,
		"h": 1.0989010989
	},
	{
		"stop_id": 8505868,
		"ID": 923,
		"x": 22.5777117943,
		"y": -31.503821169,
		"h": 1.0989010989
	},
	{
		"stop_id": 8505875,
		"ID": 1228,
		"x": 69.8947719633,
		"y": -58.109839007,
		"h": 1.1648351648
	},
	{
		"stop_id": 8505876,
		"ID": 1228,
		"x": 69.1297276453,
		"y": -57.119807698,
		"h": 1.1648351648
	},
	{
		"stop_id": 8505879,
		"ID": 1228,
		"x": 69.4077249843,
		"y": -53.497855067,
		"h": 1.1648351648
	},
	{
		"stop_id": 8580096,
		"ID": 1228,
		"x": 69.3397198483,
		"y": -53.261805675,
		"h": 1.1648351648
	},
	{
		"stop_id": 8580098,
		"ID": 1228,
		"x": 69.3417464273,
		"y": -53.594777297,
		"h": 1.1648351648
	},
	{
		"stop_id": 8580100,
		"ID": 1228,
		"x": 69.1347145523,
		"y": -56.369834317,
		"h": 1.1648351648
	},
	{
		"stop_id": 8505896,
		"ID": 1028,
		"x": 37.4497168343,
		"y": -2.310771045,
		"h": 1.1318681319
	},
	{
		"stop_id": 8505915,
		"ID": 1028,
		"x": 36.4617488503,
		"y": -2.139815349,
		"h": 1.1318681319
	},
	{
		"stop_id": 8505916,
		"ID": 1028,
		"x": 37.0107024113,
		"y": -2.218811535,
		"h": 1.1318681319
	},
	{
		"stop_id": 8530426,
		"ID": 1028,
		"x": 37.4857359323,
		"y": -2.298846187,
		"h": 1.1318681319
	},
	{
		"stop_id": 8530427,
		"ID": 1028,
		"x": 38.2217452383,
		"y": -1.349813173,
		"h": 1.1318681319
	},
	{
		"stop_id": 8505907,
		"ID": 1122,
		"x": 53.6727096433,
		"y": -67.066758317,
		"h": 1.032967033
	},
	{
		"stop_id": 8505908,
		"ID": 1122,
		"x": 53.4147539313,
		"y": -67.045788386,
		"h": 1.032967033
	},
	{
		"stop_id": 8505914,
		"ID": 984,
		"x": 35.2597524593,
		"y": -65.10781882,
		"h": 1.3956043956
	},
	{
		"stop_id": 8573614,
		"ID": 984,
		"x": 32.7787177913,
		"y": -65.461759682,
		"h": 1.3956043956
	},
	{
		"stop_id": 8575481,
		"ID": 984,
		"x": 36.3427109043,
		"y": -65.172781671,
		"h": 1.3956043956
	},
	{
		"stop_id": 8575482,
		"ID": 984,
		"x": 35.6447294743,
		"y": -64.984806073,
		"h": 1.3956043956
	},
	{
		"stop_id": 8575483,
		"ID": 984,
		"x": 34.7507207073,
		"y": -64.974808708,
		"h": 1.3956043956
	},
	{
		"stop_id": 8575484,
		"ID": 984,
		"x": 34.3527308873,
		"y": -65.135767358,
		"h": 1.3956043956
	},
	{
		"stop_id": 8575485,
		"ID": 984,
		"x": 33.4987462893,
		"y": -65.40980235,
		"h": 1.3956043956
	},
	{
		"stop_id": 8575486,
		"ID": 984,
		"x": 33.0437455273,
		"y": -65.506845634,
		"h": 1.3956043956
	},
	{
		"stop_id": 8575487,
		"ID": 984,
		"x": 32.5877463673,
		"y": -65.341822248,
		"h": 1.3956043956
	},
	{
		"stop_id": 8575488,
		"ID": 984,
		"x": 31.6077301013,
		"y": -65.169794722,
		"h": 1.3956043956
	},
	{
		"stop_id": 8575489,
		"ID": 984,
		"x": 30.8877127723,
		"y": -64.354784247,
		"h": 1.3956043956
	},
	{
		"stop_id": 8575490,
		"ID": 984,
		"x": 31.0017101353,
		"y": -65.224822926,
		"h": 1.3956043956
	},
	{
		"stop_id": 8575498,
		"ID": 984,
		"x": 31.0497731483,
		"y": -63.230793685,
		"h": 1.3956043956
	},
	{
		"stop_id": 8505953,
		"ID": 1227,
		"x": 65.7777607133,
		"y": -61.362800906,
		"h": 1.2967032967
	},
	{
		"stop_id": 8505954,
		"ID": 1227,
		"x": 69.0227613483,
		"y": -60.437780139,
		"h": 1.2967032967
	},
	{
		"stop_id": 8505955,
		"ID": 1227,
		"x": 70.5247654133,
		"y": -60.464777397,
		"h": 1.2967032967
	},
	{
		"stop_id": 8575227,
		"ID": 1227,
		"x": 66.3507664433,
		"y": -61.36578616,
		"h": 1.2967032967
	},
	{
		"stop_id": 8575228,
		"ID": 1227,
		"x": 67.7387572613,
		"y": -60.60184803,
		"h": 1.2967032967
	},
	{
		"stop_id": 8575229,
		"ID": 1227,
		"x": 69.5477468853,
		"y": -60.507752262,
		"h": 1.2967032967
	},
	{
		"stop_id": 8575230,
		"ID": 1227,
		"x": 70.4507563823,
		"y": -60.560771618,
		"h": 1.2967032967
	},
	{
		"stop_id": 8575231,
		"ID": 1227,
		"x": 70.7187052973,
		"y": -60.384765947,
		"h": 1.2967032967
	},
	{
		"stop_id": 8580806,
		"ID": 1227,
		"x": 70.1547051063,
		"y": -60.373774804,
		"h": 1.2967032967
	},
	{
		"stop_id": 8581069,
		"ID": 1227,
		"x": 68.4517091573,
		"y": -60.50883857,
		"h": 1.2967032967
	},
	{
		"stop_id": 8505957,
		"ID": 1258,
		"x": 73.3267578883,
		"y": -57.53381708,
		"h": 1.5604395604
	},
	{
		"stop_id": 8505958,
		"ID": 1258,
		"x": 73.7167727253,
		"y": -56.479793638,
		"h": 1.5604395604
	},
	{
		"stop_id": 8505982,
		"ID": 1258,
		"x": 71.3477035113,
		"y": -58.307793926,
		"h": 1.5604395604
	},
	{
		"stop_id": 8505984,
		"ID": 1258,
		"x": 71.8207381773,
		"y": -57.60980318,
		"h": 1.5604395604
	},
	{
		"stop_id": 8505985,
		"ID": 1258,
		"x": 72.7827545733,
		"y": -57.005817488,
		"h": 1.5604395604
	},
	{
		"stop_id": 8575232,
		"ID": 1258,
		"x": 71.3807031913,
		"y": -59.929802711,
		"h": 1.5604395604
	},
	{
		"stop_id": 8575233,
		"ID": 1258,
		"x": 71.7657609243,
		"y": -59.422750553,
		"h": 1.5604395604
	},
	{
		"stop_id": 8575234,
		"ID": 1258,
		"x": 72.4737343823,
		"y": -58.986789686,
		"h": 1.5604395604
	},
	{
		"stop_id": 8575235,
		"ID": 1258,
		"x": 73.0077095013,
		"y": -58.151828872,
		"h": 1.5604395604
	},
	{
		"stop_id": 8575236,
		"ID": 1258,
		"x": 73.9537604433,
		"y": -55.665856937,
		"h": 1.5604395604
	},
	{
		"stop_id": 8580085,
		"ID": 1258,
		"x": 71.6977088983,
		"y": -57.725782642,
		"h": 1.5604395604
	},
	{
		"stop_id": 8580086,
		"ID": 1258,
		"x": 71.2867479683,
		"y": -58.046815062,
		"h": 1.5604395604
	},
	{
		"stop_id": 8580087,
		"ID": 1258,
		"x": 71.5777052093,
		"y": -58.016819996,
		"h": 1.5604395604
	},
	{
		"stop_id": 8580103,
		"ID": 1258,
		"x": 71.5907186003,
		"y": -59.514839645,
		"h": 1.5604395604
	},
	{
		"stop_id": 8580807,
		"ID": 1258,
		"x": 73.6457550583,
		"y": -56.741772695,
		"h": 1.5604395604
	},
	{
		"stop_id": 8580929,
		"ID": 1258,
		"x": 72.0317126633,
		"y": -59.268855395,
		"h": 1.5604395604
	},
	{
		"stop_id": 8582004,
		"ID": 1258,
		"x": 71.5927767923,
		"y": -57.705824356,
		"h": 1.5604395604
	},
	{
		"stop_id": 8582878,
		"ID": 1258,
		"x": 72.6657324553,
		"y": -57.070759849,
		"h": 1.5604395604
	},
	{
		"stop_id": 8505959,
		"ID": 1259,
		"x": 73.9217005993,
		"y": -55.188773364,
		"h": 1.1318681319
	},
	{
		"stop_id": 8505960,
		"ID": 1259,
		"x": 74.4177538663,
		"y": -54.180833075,
		"h": 1.1318681319
	},
	{
		"stop_id": 8505961,
		"ID": 1259,
		"x": 75.6207480153,
		"y": -51.953835627,
		"h": 1.1318681319
	},
	{
		"stop_id": 8580805,
		"ID": 1259,
		"x": 75.5547105553,
		"y": -52.142785939,
		"h": 1.1318681319
	},
	{
		"stop_id": 8583405,
		"ID": 1259,
		"x": 75.7627169803,
		"y": -51.584828446,
		"h": 1.1318681319
	},
	{
		"stop_id": 8505962,
		"ID": 1288,
		"x": 76.2357479993,
		"y": -50.197851714,
		"h": 1.0989010989
	},
	{
		"stop_id": 8505998,
		"ID": 1288,
		"x": 76.7337749873,
		"y": -49.105819787,
		"h": 1.0989010989
	},
	{
		"stop_id": 8575237,
		"ID": 1288,
		"x": 76.1467726263,
		"y": -50.628836911,
		"h": 1.0989010989
	},
	{
		"stop_id": 8575238,
		"ID": 1288,
		"x": 77.0137092823,
		"y": -48.003787024,
		"h": 1.0989010989
	},
	{
		"stop_id": 8505963,
		"ID": 1289,
		"x": 77.5257615363,
		"y": -45.850800353,
		"h": 1.1648351648
	},
	{
		"stop_id": 8505964,
		"ID": 1289,
		"x": 78.3227226213,
		"y": -43.384797517,
		"h": 1.1648351648
	},
	{
		"stop_id": 8575239,
		"ID": 1289,
		"x": 78.2337370723,
		"y": -44.183760167,
		"h": 1.1648351648
	},
	{
		"stop_id": 8575240,
		"ID": 1289,
		"x": 78.2507141043,
		"y": -43.159831884,
		"h": 1.1648351648
	},
	{
		"stop_id": 8575241,
		"ID": 1289,
		"x": 78.0957441953,
		"y": -42.687798706,
		"h": 1.1648351648
	},
	{
		"stop_id": 8575242,
		"ID": 1289,
		"x": 78.0687514413,
		"y": -42.381853984,
		"h": 1.1648351648
	},
	{
		"stop_id": 8505978,
		"ID": 1229,
		"x": 69.6447748083,
		"y": -51.205819943,
		"h": 1.0989010989
	},
	{
		"stop_id": 8505979,
		"ID": 1229,
		"x": 69.6677238343,
		"y": -50.083750786,
		"h": 1.0989010989
	},
	{
		"stop_id": 8505980,
		"ID": 1229,
		"x": 69.8867502693,
		"y": -47.890824869,
		"h": 1.0989010989
	},
	{
		"stop_id": 8580093,
		"ID": 1229,
		"x": 69.6007457913,
		"y": -49.545801103,
		"h": 1.0989010989
	},
	{
		"stop_id": 8505991,
		"ID": 1290,
		"x": 77.5957578283,
		"y": -39.904794572,
		"h": 1
	},
	{
		"stop_id": 8506004,
		"ID": 1075,
		"x": 40.9487138513,
		"y": 74.680218419,
		"h": 1.6263736264
	},
	{
		"stop_id": 8506005,
		"ID": 1075,
		"x": 42.6567206013,
		"y": 73.228222872,
		"h": 1.6263736264
	},
	{
		"stop_id": 8506006,
		"ID": 1075,
		"x": 44.3837696033,
		"y": 72.873160667,
		"h": 1.6263736264
	},
	{
		"stop_id": 8506692,
		"ID": 1075,
		"x": 44.9787513733,
		"y": 75.968192655,
		"h": 1.6263736264
	},
	{
		"stop_id": 8573517,
		"ID": 1075,
		"x": 45.7477078403,
		"y": 72.830153185,
		"h": 1.6263736264
	},
	{
		"stop_id": 8573538,
		"ID": 1075,
		"x": 40.9577269003,
		"y": 74.660244427,
		"h": 1.6263736264
	},
	{
		"stop_id": 8573663,
		"ID": 1075,
		"x": 41.7317611073,
		"y": 75.859214352,
		"h": 1.6263736264
	},
	{
		"stop_id": 8573664,
		"ID": 1075,
		"x": 41.3077625043,
		"y": 75.555157713,
		"h": 1.6263736264
	},
	{
		"stop_id": 8573665,
		"ID": 1075,
		"x": 41.9147330253,
		"y": 76.282143888,
		"h": 1.6263736264
	},
	{
		"stop_id": 8573666,
		"ID": 1075,
		"x": 42.4857641033,
		"y": 76.419202582,
		"h": 1.6263736264
	},
	{
		"stop_id": 8573667,
		"ID": 1075,
		"x": 44.3707182393,
		"y": 77.072155446,
		"h": 1.6263736264
	},
	{
		"stop_id": 8573668,
		"ID": 1075,
		"x": 44.9677600913,
		"y": 76.461183349,
		"h": 1.6263736264
	},
	{
		"stop_id": 8573670,
		"ID": 1075,
		"x": 46.2827130603,
		"y": 74.680229566,
		"h": 1.6263736264
	},
	{
		"stop_id": 8573672,
		"ID": 1075,
		"x": 46.4327109293,
		"y": 74.105221074,
		"h": 1.6263736264
	},
	{
		"stop_id": 8575932,
		"ID": 1075,
		"x": 41.2127478653,
		"y": 72.713237155,
		"h": 1.6263736264
	},
	{
		"stop_id": 8575933,
		"ID": 1075,
		"x": 41.9937669563,
		"y": 71.491173903,
		"h": 1.6263736264
	},
	{
		"stop_id": 8579712,
		"ID": 1075,
		"x": 44.0417112813,
		"y": 77.137207955,
		"h": 1.6263736264
	},
	{
		"stop_id": 8580523,
		"ID": 1075,
		"x": 44.6577475133,
		"y": 73.580228157,
		"h": 1.6263736264
	},
	{
		"stop_id": 8580530,
		"ID": 1075,
		"x": 44.3577455613,
		"y": 73.130245955,
		"h": 1.6263736264
	},
	{
		"stop_id": 8580793,
		"ID": 1075,
		"x": 42.7577719793,
		"y": 73.230194937,
		"h": 1.6263736264
	},
	{
		"stop_id": 8506007,
		"ID": 1109,
		"x": 46.2537552773,
		"y": 72.444206126,
		"h": 1.6923076923
	},
	{
		"stop_id": 8506008,
		"ID": 1109,
		"x": 46.6447173933,
		"y": 70.270218444,
		"h": 1.6923076923
	},
	{
		"stop_id": 8573518,
		"ID": 1109,
		"x": 46.2327187113,
		"y": 72.755195526,
		"h": 1.6923076923
	},
	{
		"stop_id": 8573519,
		"ID": 1109,
		"x": 46.2677418843,
		"y": 72.45524328,
		"h": 1.6923076923
	},
	{
		"stop_id": 8573520,
		"ID": 1109,
		"x": 46.6157454783,
		"y": 72.23919448,
		"h": 1.6923076923
	},
	{
		"stop_id": 8573521,
		"ID": 1109,
		"x": 47.2477067363,
		"y": 72.140162197,
		"h": 1.6923076923
	},
	{
		"stop_id": 8573522,
		"ID": 1109,
		"x": 48.8817582843,
		"y": 72.138237286,
		"h": 1.6923076923
	},
	{
		"stop_id": 8573523,
		"ID": 1109,
		"x": 49.9827308243,
		"y": 72.80019234,
		"h": 1.6923076923
	},
	{
		"stop_id": 8573524,
		"ID": 1109,
		"x": 50.1177717553,
		"y": 74.336199049,
		"h": 1.6923076923
	},
	{
		"stop_id": 8573636,
		"ID": 1109,
		"x": 46.6387367013,
		"y": 70.271222982,
		"h": 1.6923076923
	},
	{
		"stop_id": 8573637,
		"ID": 1109,
		"x": 47.5327489433,
		"y": 69.580224275,
		"h": 1.6923076923
	},
	{
		"stop_id": 8573638,
		"ID": 1109,
		"x": 48.2327646123,
		"y": 69.28024996,
		"h": 1.6923076923
	},
	{
		"stop_id": 8573639,
		"ID": 1109,
		"x": 48.6077011023,
		"y": 69.405195918,
		"h": 1.6923076923
	},
	{
		"stop_id": 8573640,
		"ID": 1109,
		"x": 49.0047177323,
		"y": 69.449171533,
		"h": 1.6923076923
	},
	{
		"stop_id": 8573644,
		"ID": 1109,
		"x": 49.4667074343,
		"y": 69.723226389,
		"h": 1.6923076923
	},
	{
		"stop_id": 8573645,
		"ID": 1109,
		"x": 49.8827112653,
		"y": 69.955210412,
		"h": 1.6923076923
	},
	{
		"stop_id": 8573646,
		"ID": 1109,
		"x": 50.8577488123,
		"y": 70.030170923,
		"h": 1.6923076923
	},
	{
		"stop_id": 8573648,
		"ID": 1109,
		"x": 51.4577179463,
		"y": 70.980188666,
		"h": 1.6923076923
	},
	{
		"stop_id": 8580795,
		"ID": 1109,
		"x": 46.3847457853,
		"y": 70.899178768,
		"h": 1.6923076923
	},
	{
		"stop_id": 8582699,
		"ID": 1109,
		"x": 46.3237585673,
		"y": 70.036162543,
		"h": 1.6923076923
	},
	{
		"stop_id": 8582700,
		"ID": 1109,
		"x": 46.3867222003,
		"y": 70.452183686,
		"h": 1.6923076923
	},
	{
		"stop_id": 8583773,
		"ID": 1109,
		"x": 46.4207088253,
		"y": 71.85615969,
		"h": 1.6923076923
	},
	{
		"stop_id": 8506010,
		"ID": 1182,
		"x": 58.0147519363,
		"y": 75.403144272,
		"h": 2.2197802198
	},
	{
		"stop_id": 8506170,
		"ID": 1182,
		"x": 57.3127267743,
		"y": 77.569206947,
		"h": 2.2197802198
	},
	{
		"stop_id": 8506178,
		"ID": 1182,
		"x": 57.8837535093,
		"y": 77.052191643,
		"h": 2.2197802198
	},
	{
		"stop_id": 8506181,
		"ID": 1182,
		"x": 60.5627689213,
		"y": 76.950180739,
		"h": 2.2197802198
	},
	{
		"stop_id": 8506182,
		"ID": 1182,
		"x": 59.4637326443,
		"y": 79.505184931,
		"h": 2.2197802198
	},
	{
		"stop_id": 8506188,
		"ID": 1182,
		"x": 60.2667680253,
		"y": 77.592178969,
		"h": 2.2197802198
	},
	{
		"stop_id": 8506690,
		"ID": 1182,
		"x": 57.3777537343,
		"y": 75.096241877,
		"h": 2.2197802198
	},
	{
		"stop_id": 8506740,
		"ID": 1182,
		"x": 60.6597529243,
		"y": 77.271213118,
		"h": 2.2197802198
	},
	{
		"stop_id": 8573617,
		"ID": 1182,
		"x": 61.1157476843,
		"y": 76.138178952,
		"h": 2.2197802198
	},
	{
		"stop_id": 8573618,
		"ID": 1182,
		"x": 60.8777422353,
		"y": 76.575151592,
		"h": 2.2197802198
	},
	{
		"stop_id": 8573619,
		"ID": 1182,
		"x": 60.6937740673,
		"y": 76.974199847,
		"h": 2.2197802198
	},
	{
		"stop_id": 8578596,
		"ID": 1182,
		"x": 61.0077163723,
		"y": 75.734175361,
		"h": 2.2197802198
	},
	{
		"stop_id": 8578597,
		"ID": 1182,
		"x": 60.8277107693,
		"y": 75.778211174,
		"h": 2.2197802198
	},
	{
		"stop_id": 8578598,
		"ID": 1182,
		"x": 60.4727707463,
		"y": 75.695141333,
		"h": 2.2197802198
	},
	{
		"stop_id": 8578599,
		"ID": 1182,
		"x": 59.5387518863,
		"y": 75.580145321,
		"h": 2.2197802198
	},
	{
		"stop_id": 8578600,
		"ID": 1182,
		"x": 58.3757015403,
		"y": 75.633201775,
		"h": 2.2197802198
	},
	{
		"stop_id": 8578601,
		"ID": 1182,
		"x": 57.9937172883,
		"y": 75.414179848,
		"h": 2.2197802198
	},
	{
		"stop_id": 8578603,
		"ID": 1182,
		"x": 57.0997404383,
		"y": 74.841195185,
		"h": 2.2197802198
	},
	{
		"stop_id": 8578617,
		"ID": 1182,
		"x": 57.5767336683,
		"y": 75.441146308,
		"h": 2.2197802198
	},
	{
		"stop_id": 8578618,
		"ID": 1182,
		"x": 57.1737486213,
		"y": 75.626221589,
		"h": 2.2197802198
	},
	{
		"stop_id": 8578619,
		"ID": 1182,
		"x": 56.7037678913,
		"y": 75.634186271,
		"h": 2.2197802198
	},
	{
		"stop_id": 8578792,
		"ID": 1182,
		"x": 59.2117006803,
		"y": 74.510190857,
		"h": 2.2197802198
	},
	{
		"stop_id": 8578794,
		"ID": 1182,
		"x": 59.5987248783,
		"y": 74.996179541,
		"h": 2.2197802198
	},
	{
		"stop_id": 8578795,
		"ID": 1182,
		"x": 60.3137113063,
		"y": 75.194142454,
		"h": 2.2197802198
	},
	{
		"stop_id": 8578796,
		"ID": 1182,
		"x": 60.5777157593,
		"y": 75.31116035,
		"h": 2.2197802198
	},
	{
		"stop_id": 8587744,
		"ID": 1182,
		"x": 60.5487377713,
		"y": 77.810207483,
		"h": 2.2197802198
	},
	{
		"stop_id": 8587755,
		"ID": 1182,
		"x": 60.5547516813,
		"y": 77.407197218,
		"h": 2.2197802198
	},
	{
		"stop_id": 8587756,
		"ID": 1182,
		"x": 60.4257630743,
		"y": 77.911242142,
		"h": 2.2197802198
	},
	{
		"stop_id": 8588625,
		"ID": 1182,
		"x": 57.4117639753,
		"y": 75.614250651,
		"h": 2.2197802198
	},
	{
		"stop_id": 8589923,
		"ID": 1182,
		"x": 60.6777724353,
		"y": 76.675167149,
		"h": 2.2197802198
	},
	{
		"stop_id": 8589924,
		"ID": 1182,
		"x": 60.2737135613,
		"y": 75.931197041,
		"h": 2.2197802198
	},
	{
		"stop_id": 8589925,
		"ID": 1182,
		"x": 60.4597272433,
		"y": 76.229232566,
		"h": 2.2197802198
	},
	{
		"stop_id": 8589926,
		"ID": 1182,
		"x": 60.5827400803,
		"y": 76.491183958,
		"h": 2.2197802198
	},
	{
		"stop_id": 8589927,
		"ID": 1182,
		"x": 60.7807761173,
		"y": 75.66115286,
		"h": 2.2197802198
	},
	{
		"stop_id": 8589928,
		"ID": 1182,
		"x": 60.5307273623,
		"y": 75.808195329,
		"h": 2.2197802198
	},
	{
		"stop_id": 8591660,
		"ID": 1182,
		"x": 61.5077196063,
		"y": 76.550225011,
		"h": 2.2197802198
	},
	{
		"stop_id": 8591791,
		"ID": 1182,
		"x": 61.0077509973,
		"y": 76.338150152,
		"h": 2.2197802198
	},
	{
		"stop_id": 8594157,
		"ID": 1182,
		"x": 61.3157189743,
		"y": 76.507145527,
		"h": 2.2197802198
	},
	{
		"stop_id": 8506011,
		"ID": 1146,
		"x": 54.8537235133,
		"y": 75.285226407,
		"h": 1.7252747253
	},
	{
		"stop_id": 8506012,
		"ID": 1146,
		"x": 51.6987565333,
		"y": 76.631240629,
		"h": 1.7252747253
	},
	{
		"stop_id": 8506852,
		"ID": 1146,
		"x": 55.3557657583,
		"y": 71.776204632,
		"h": 1.7252747253
	},
	{
		"stop_id": 8573525,
		"ID": 1146,
		"x": 50.3827404313,
		"y": 74.555193941,
		"h": 1.7252747253
	},
	{
		"stop_id": 8573526,
		"ID": 1146,
		"x": 51.1827708683,
		"y": 74.470169211,
		"h": 1.7252747253
	},
	{
		"stop_id": 8573527,
		"ID": 1146,
		"x": 52.1577599073,
		"y": 73.730227362,
		"h": 1.7252747253
	},
	{
		"stop_id": 8578620,
		"ID": 1146,
		"x": 55.8817736943,
		"y": 75.70724642,
		"h": 1.7252747253
	},
	{
		"stop_id": 8578621,
		"ID": 1146,
		"x": 55.4827180823,
		"y": 75.524196714,
		"h": 1.7252747253
	},
	{
		"stop_id": 8578623,
		"ID": 1146,
		"x": 53.3577077503,
		"y": 75.7301658,
		"h": 1.7252747253
	},
	{
		"stop_id": 8578624,
		"ID": 1146,
		"x": 53.2327278943,
		"y": 75.601225006,
		"h": 1.7252747253
	},
	{
		"stop_id": 8578625,
		"ID": 1146,
		"x": 53.2537007373,
		"y": 74.282173518,
		"h": 1.7252747253
	},
	{
		"stop_id": 8578626,
		"ID": 1146,
		"x": 52.9897712133,
		"y": 74.116224236,
		"h": 1.7252747253
	},
	{
		"stop_id": 8578627,
		"ID": 1146,
		"x": 52.5347126293,
		"y": 73.853244568,
		"h": 1.7252747253
	},
	{
		"stop_id": 8578629,
		"ID": 1146,
		"x": 54.7117738813,
		"y": 74.787166428,
		"h": 1.7252747253
	},
	{
		"stop_id": 8578630,
		"ID": 1146,
		"x": 54.6147183863,
		"y": 74.521175457,
		"h": 1.7252747253
	},
	{
		"stop_id": 8578631,
		"ID": 1146,
		"x": 53.7257565923,
		"y": 72.727220929,
		"h": 1.7252747253
	},
	{
		"stop_id": 8578632,
		"ID": 1146,
		"x": 54.8437173413,
		"y": 71.903161384,
		"h": 1.7252747253
	},
	{
		"stop_id": 8587256,
		"ID": 1146,
		"x": 53.4417272373,
		"y": 74.480154936,
		"h": 1.7252747253
	},
	{
		"stop_id": 8587412,
		"ID": 1146,
		"x": 54.4137641503,
		"y": 75.159173726,
		"h": 1.7252747253
	},
	{
		"stop_id": 8588978,
		"ID": 1146,
		"x": 54.8557331093,
		"y": 75.228216621,
		"h": 1.7252747253
	},
	{
		"stop_id": 8595459,
		"ID": 1146,
		"x": 55.1917131333,
		"y": 71.741211651,
		"h": 1.7252747253
	},
	{
		"stop_id": 8595875,
		"ID": 1146,
		"x": 53.6127184683,
		"y": 72.850159772,
		"h": 1.7252747253
	},
	{
		"stop_id": 8595876,
		"ID": 1146,
		"x": 52.4587647203,
		"y": 73.741154962,
		"h": 1.7252747253
	},
	{
		"stop_id": 8506013,
		"ID": 1110,
		"x": 50.6347398463,
		"y": 78.166156755,
		"h": 1.4945054945
	},
	{
		"stop_id": 8506014,
		"ID": 1110,
		"x": 47.6077122663,
		"y": 79.268167594,
		"h": 1.4945054945
	},
	{
		"stop_id": 8506853,
		"ID": 1110,
		"x": 50.0847073213,
		"y": 78.803240036,
		"h": 1.4945054945
	},
	{
		"stop_id": 8573362,
		"ID": 1110,
		"x": 50.3367679763,
		"y": 78.490214099,
		"h": 1.4945054945
	},
	{
		"stop_id": 8573363,
		"ID": 1110,
		"x": 50.5927598573,
		"y": 78.198178747,
		"h": 1.4945054945
	},
	{
		"stop_id": 8573669,
		"ID": 1110,
		"x": 46.4087339553,
		"y": 75.336141304,
		"h": 1.4945054945
	},
	{
		"stop_id": 8576933,
		"ID": 1110,
		"x": 50.3297128563,
		"y": 77.04719333,
		"h": 1.4945054945
	},
	{
		"stop_id": 8576957,
		"ID": 1110,
		"x": 50.8047341233,
		"y": 77.274240102,
		"h": 1.4945054945
	},
	{
		"stop_id": 8576958,
		"ID": 1110,
		"x": 50.7407629643,
		"y": 77.837189471,
		"h": 1.4945054945
	},
	{
		"stop_id": 8581611,
		"ID": 1110,
		"x": 47.8577132933,
		"y": 78.480156183,
		"h": 1.4945054945
	},
	{
		"stop_id": 8581612,
		"ID": 1110,
		"x": 48.0187368283,
		"y": 78.280140606,
		"h": 1.4945054945
	},
	{
		"stop_id": 8581613,
		"ID": 1110,
		"x": 47.6077069623,
		"y": 79.260160743,
		"h": 1.4945054945
	},
	{
		"stop_id": 8582612,
		"ID": 1110,
		"x": 47.0037202113,
		"y": 76.47323047,
		"h": 1.4945054945
	},
	{
		"stop_id": 8582613,
		"ID": 1110,
		"x": 47.7907429223,
		"y": 78.82623012,
		"h": 1.4945054945
	},
	{
		"stop_id": 8582673,
		"ID": 1110,
		"x": 47.5687692043,
		"y": 76.821183871,
		"h": 1.4945054945
	},
	{
		"stop_id": 8583361,
		"ID": 1110,
		"x": 47.7897441983,
		"y": 77.472184625,
		"h": 1.4945054945
	},
	{
		"stop_id": 8506015,
		"ID": 1076,
		"x": 42.4547678643,
		"y": 79.193174932,
		"h": 1.6923076923
	},
	{
		"stop_id": 8506035,
		"ID": 1076,
		"x": 43.7107157593,
		"y": 79.375156402,
		"h": 1.6923076923
	},
	{
		"stop_id": 8576228,
		"ID": 1076,
		"x": 41.6427644833,
		"y": 81.731198325,
		"h": 1.6923076923
	},
	{
		"stop_id": 8576229,
		"ID": 1076,
		"x": 41.9487416313,
		"y": 82.204180789,
		"h": 1.6923076923
	},
	{
		"stop_id": 8576230,
		"ID": 1076,
		"x": 42.0577525673,
		"y": 81.687180045,
		"h": 1.6923076923
	},
	{
		"stop_id": 8576231,
		"ID": 1076,
		"x": 42.3817227993,
		"y": 81.784180564,
		"h": 1.6923076923
	},
	{
		"stop_id": 8576232,
		"ID": 1076,
		"x": 41.9027450103,
		"y": 81.826185179,
		"h": 1.6923076923
	},
	{
		"stop_id": 8580256,
		"ID": 1076,
		"x": 42.7507707193,
		"y": 79.272250286,
		"h": 1.6923076923
	},
	{
		"stop_id": 8580257,
		"ID": 1076,
		"x": 42.9077473553,
		"y": 79.580227753,
		"h": 1.6923076923
	},
	{
		"stop_id": 8580258,
		"ID": 1076,
		"x": 42.9577702603,
		"y": 79.880234305,
		"h": 1.6923076923
	},
	{
		"stop_id": 8580259,
		"ID": 1076,
		"x": 42.1447084083,
		"y": 79.566246715,
		"h": 1.6923076923
	},
	{
		"stop_id": 8580260,
		"ID": 1076,
		"x": 41.6197288733,
		"y": 79.758164429,
		"h": 1.6923076923
	},
	{
		"stop_id": 8580261,
		"ID": 1076,
		"x": 41.3677089053,
		"y": 79.910199265,
		"h": 1.6923076923
	},
	{
		"stop_id": 8580262,
		"ID": 1076,
		"x": 40.7407489433,
		"y": 80.00114629,
		"h": 1.6923076923
	},
	{
		"stop_id": 8580263,
		"ID": 1076,
		"x": 40.3767355803,
		"y": 80.161216957,
		"h": 1.6923076923
	},
	{
		"stop_id": 8580291,
		"ID": 1076,
		"x": 43.7677580973,
		"y": 77.929175811,
		"h": 1.6923076923
	},
	{
		"stop_id": 8580796,
		"ID": 1076,
		"x": 42.6257746273,
		"y": 81.815204189,
		"h": 1.6923076923
	},
	{
		"stop_id": 8581755,
		"ID": 1076,
		"x": 41.0277450283,
		"y": 79.900167396,
		"h": 1.6923076923
	},
	{
		"stop_id": 8582789,
		"ID": 1076,
		"x": 43.5087607133,
		"y": 78.736208301,
		"h": 1.6923076923
	},
	{
		"stop_id": 8587004,
		"ID": 1076,
		"x": 43.8307424073,
		"y": 82.312160647,
		"h": 1.6923076923
	},
	{
		"stop_id": 8590960,
		"ID": 1076,
		"x": 41.1527231493,
		"y": 79.734160634,
		"h": 1.6923076923
	},
	{
		"stop_id": 8591001,
		"ID": 1076,
		"x": 40.6697146473,
		"y": 79.809226063,
		"h": 1.6923076923
	},
	{
		"stop_id": 8506016,
		"ID": 1043,
		"x": 39.8287072823,
		"y": 80.17620072,
		"h": 2.3186813187
	},
	{
		"stop_id": 8506017,
		"ID": 1043,
		"x": 40.9737045573,
		"y": 82.155229261,
		"h": 2.3186813187
	},
	{
		"stop_id": 8506020,
		"ID": 1043,
		"x": 38.1577374093,
		"y": 83.245170151,
		"h": 2.3186813187
	},
	{
		"stop_id": 8506021,
		"ID": 1043,
		"x": 39.1857077563,
		"y": 85.217151331,
		"h": 2.3186813187
	},
	{
		"stop_id": 8506036,
		"ID": 1043,
		"x": 39.1677157743,
		"y": 82.582208528,
		"h": 2.3186813187
	},
	{
		"stop_id": 8506038,
		"ID": 1043,
		"x": 39.8497310103,
		"y": 81.155140466,
		"h": 2.3186813187
	},
	{
		"stop_id": 8506691,
		"ID": 1043,
		"x": 36.1797176303,
		"y": 82.304194417,
		"h": 2.3186813187
	},
	{
		"stop_id": 8573692,
		"ID": 1043,
		"x": 37.0227549183,
		"y": 80.271153474,
		"h": 2.3186813187
	},
	{
		"stop_id": 8573693,
		"ID": 1043,
		"x": 36.9017152743,
		"y": 80.780145842,
		"h": 2.3186813187
	},
	{
		"stop_id": 8573694,
		"ID": 1043,
		"x": 36.7227651313,
		"y": 81.229147167,
		"h": 2.3186813187
	},
	{
		"stop_id": 8573695,
		"ID": 1043,
		"x": 35.9627221893,
		"y": 83.127242968,
		"h": 2.3186813187
	},
	{
		"stop_id": 8573697,
		"ID": 1043,
		"x": 36.2627502853,
		"y": 84.66515527,
		"h": 2.3186813187
	},
	{
		"stop_id": 8573698,
		"ID": 1043,
		"x": 37.4077471243,
		"y": 85.630223866,
		"h": 2.3186813187
	},
	{
		"stop_id": 8574236,
		"ID": 1043,
		"x": 37.4577132143,
		"y": 83.330245302,
		"h": 2.3186813187
	},
	{
		"stop_id": 8576227,
		"ID": 1043,
		"x": 40.9177056683,
		"y": 82.188192043,
		"h": 2.3186813187
	},
	{
		"stop_id": 8576233,
		"ID": 1043,
		"x": 41.3987744703,
		"y": 82.290153011,
		"h": 2.3186813187
	},
	{
		"stop_id": 8576234,
		"ID": 1043,
		"x": 41.2787433403,
		"y": 82.090156403,
		"h": 2.3186813187
	},
	{
		"stop_id": 8576297,
		"ID": 1043,
		"x": 38.1577602893,
		"y": 83.230158087,
		"h": 2.3186813187
	},
	{
		"stop_id": 8576298,
		"ID": 1043,
		"x": 39.1477386833,
		"y": 85.250210255,
		"h": 2.3186813187
	},
	{
		"stop_id": 8580454,
		"ID": 1043,
		"x": 36.6967714763,
		"y": 80.823169003,
		"h": 2.3186813187
	},
	{
		"stop_id": 8580798,
		"ID": 1043,
		"x": 39.7977290403,
		"y": 80.445234371,
		"h": 2.3186813187
	},
	{
		"stop_id": 8581701,
		"ID": 1043,
		"x": 36.8537580923,
		"y": 81.331146618,
		"h": 2.3186813187
	},
	{
		"stop_id": 8582180,
		"ID": 1043,
		"x": 37.3937509203,
		"y": 82.773178211,
		"h": 2.3186813187
	},
	{
		"stop_id": 8582398,
		"ID": 1043,
		"x": 36.8947283093,
		"y": 80.530160733,
		"h": 2.3186813187
	},
	{
		"stop_id": 8582961,
		"ID": 1043,
		"x": 38.1717430223,
		"y": 84.644231715,
		"h": 2.3186813187
	},
	{
		"stop_id": 8583415,
		"ID": 1043,
		"x": 38.2977713183,
		"y": 84.277237264,
		"h": 2.3186813187
	},
	{
		"stop_id": 8583591,
		"ID": 1043,
		"x": 37.6307468083,
		"y": 83.683162879,
		"h": 2.3186813187
	},
	{
		"stop_id": 8587551,
		"ID": 1043,
		"x": 40.3327006173,
		"y": 85.440205798,
		"h": 2.3186813187
	},
	{
		"stop_id": 8590950,
		"ID": 1043,
		"x": 39.6157641463,
		"y": 80.840167172,
		"h": 2.3186813187
	},
	{
		"stop_id": 8590963,
		"ID": 1043,
		"x": 39.3797164843,
		"y": 80.405181282,
		"h": 2.3186813187
	},
	{
		"stop_id": 8590977,
		"ID": 1043,
		"x": 39.1187213863,
		"y": 80.144154104,
		"h": 2.3186813187
	},
	{
		"stop_id": 8590980,
		"ID": 1043,
		"x": 39.6277402103,
		"y": 81.651149865,
		"h": 2.3186813187
	},
	{
		"stop_id": 8590983,
		"ID": 1043,
		"x": 40.0197199253,
		"y": 80.903241667,
		"h": 2.3186813187
	},
	{
		"stop_id": 8590987,
		"ID": 1043,
		"x": 39.1327517053,
		"y": 82.385238176,
		"h": 2.3186813187
	},
	{
		"stop_id": 8590988,
		"ID": 1043,
		"x": 39.6807014433,
		"y": 80.482185375,
		"h": 2.3186813187
	},
	{
		"stop_id": 8591010,
		"ID": 1043,
		"x": 40.0217405153,
		"y": 80.770165773,
		"h": 2.3186813187
	},
	{
		"stop_id": 8591020,
		"ID": 1043,
		"x": 39.5827360603,
		"y": 81.151202557,
		"h": 2.3186813187
	},
	{
		"stop_id": 8591021,
		"ID": 1043,
		"x": 39.6037736823,
		"y": 81.356169787,
		"h": 2.3186813187
	},
	{
		"stop_id": 8593247,
		"ID": 1043,
		"x": 36.7687245933,
		"y": 81.021171268,
		"h": 2.3186813187
	},
	{
		"stop_id": 8594199,
		"ID": 1043,
		"x": 37.7597605033,
		"y": 83.344230726,
		"h": 2.3186813187
	},
	{
		"stop_id": 8594297,
		"ID": 1043,
		"x": 37.4597616673,
		"y": 83.169145751,
		"h": 2.3186813187
	},
	{
		"stop_id": 8506018,
		"ID": 1077,
		"x": 41.9447460663,
		"y": 83.263221765,
		"h": 1.5934065934
	},
	{
		"stop_id": 8506019,
		"ID": 1077,
		"x": 46.2127280143,
		"y": 84.726202942,
		"h": 1.5934065934
	},
	{
		"stop_id": 8506748,
		"ID": 1077,
		"x": 42.3577441603,
		"y": 85.079205773,
		"h": 1.5934065934
	},
	{
		"stop_id": 8506749,
		"ID": 1077,
		"x": 41.8877188733,
		"y": 83.58818079,
		"h": 1.5934065934
	},
	{
		"stop_id": 8506867,
		"ID": 1077,
		"x": 46.0477681823,
		"y": 87.091171784,
		"h": 1.5934065934
	},
	{
		"stop_id": 8573310,
		"ID": 1077,
		"x": 41.8167522403,
		"y": 83.90522777,
		"h": 1.5934065934
	},
	{
		"stop_id": 8573311,
		"ID": 1077,
		"x": 41.9577406223,
		"y": 83.23019534,
		"h": 1.5934065934
	},
	{
		"stop_id": 8573319,
		"ID": 1077,
		"x": 45.3037008333,
		"y": 87.875238772,
		"h": 1.5934065934
	},
	{
		"stop_id": 8574474,
		"ID": 1077,
		"x": 40.6577203333,
		"y": 86.310231192,
		"h": 1.5934065934
	},
	{
		"stop_id": 8576302,
		"ID": 1077,
		"x": 41.2477413203,
		"y": 87.49017743,
		"h": 1.5934065934
	},
	{
		"stop_id": 8580761,
		"ID": 1077,
		"x": 44.6077152523,
		"y": 86.380172774,
		"h": 1.5934065934
	},
	{
		"stop_id": 8581974,
		"ID": 1077,
		"x": 46.2097553203,
		"y": 84.707244515,
		"h": 1.5934065934
	},
	{
		"stop_id": 8582001,
		"ID": 1077,
		"x": 42.4777515123,
		"y": 83.330247998,
		"h": 1.5934065934
	},
	{
		"stop_id": 8582021,
		"ID": 1077,
		"x": 42.7517238633,
		"y": 86.995211518,
		"h": 1.5934065934
	},
	{
		"stop_id": 8582196,
		"ID": 1077,
		"x": 45.9297739953,
		"y": 84.394186392,
		"h": 1.5934065934
	},
	{
		"stop_id": 8582457,
		"ID": 1077,
		"x": 45.1987508693,
		"y": 88.356234033,
		"h": 1.5934065934
	},
	{
		"stop_id": 8582872,
		"ID": 1077,
		"x": 42.2477102133,
		"y": 84.955200932,
		"h": 1.5934065934
	},
	{
		"stop_id": 8583690,
		"ID": 1077,
		"x": 44.9937635033,
		"y": 88.302215627,
		"h": 1.5934065934
	},
	{
		"stop_id": 8587005,
		"ID": 1077,
		"x": 44.6167582173,
		"y": 83.832157678,
		"h": 1.5934065934
	},
	{
		"stop_id": 8506022,
		"ID": 1044,
		"x": 39.5067619713,
		"y": 87.032173833,
		"h": 1.3626373626
	},
	{
		"stop_id": 8506590,
		"ID": 1044,
		"x": 40.7597076713,
		"y": 90.596178395,
		"h": 1.3626373626
	},
	{
		"stop_id": 8506953,
		"ID": 1044,
		"x": 40.2517165643,
		"y": 91.057172418,
		"h": 1.3626373626
	},
	{
		"stop_id": 8573200,
		"ID": 1044,
		"x": 37.5077073063,
		"y": 91.630159744,
		"h": 1.3626373626
	},
	{
		"stop_id": 8573201,
		"ID": 1044,
		"x": 40.3077334453,
		"y": 91.080141178,
		"h": 1.3626373626
	},
	{
		"stop_id": 8576301,
		"ID": 1044,
		"x": 39.5077737143,
		"y": 87.030189152,
		"h": 1.3626373626
	},
	{
		"stop_id": 8576303,
		"ID": 1044,
		"x": 39.2037232923,
		"y": 88.10321934,
		"h": 1.3626373626
	},
	{
		"stop_id": 8576304,
		"ID": 1044,
		"x": 37.6877652383,
		"y": 88.950181196,
		"h": 1.3626373626
	},
	{
		"stop_id": 8580296,
		"ID": 1044,
		"x": 38.3497444823,
		"y": 91.561142573,
		"h": 1.3626373626
	},
	{
		"stop_id": 8581536,
		"ID": 1044,
		"x": 36.4327327353,
		"y": 87.277205914,
		"h": 1.3626373626
	},
	{
		"stop_id": 8581537,
		"ID": 1044,
		"x": 37.6817077643,
		"y": 86.34922436,
		"h": 1.3626373626
	},
	{
		"stop_id": 8587718,
		"ID": 1044,
		"x": 36.4877344553,
		"y": 88.030177585,
		"h": 1.3626373626
	},
	{
		"stop_id": 8506023,
		"ID": 1045,
		"x": 36.9017548993,
		"y": 91.992184901,
		"h": 1.1648351648
	},
	{
		"stop_id": 8506024,
		"ID": 1045,
		"x": 41.7217294093,
		"y": 94.327210312,
		"h": 1.1648351648
	},
	{
		"stop_id": 8506629,
		"ID": 1045,
		"x": 40.4077032293,
		"y": 94.280165671,
		"h": 1.1648351648
	},
	{
		"stop_id": 8573199,
		"ID": 1045,
		"x": 36.9077419493,
		"y": 91.980161532,
		"h": 1.1648351648
	},
	{
		"stop_id": 8573203,
		"ID": 1045,
		"x": 41.7377629373,
		"y": 94.365185979,
		"h": 1.1648351648
	},
	{
		"stop_id": 8573438,
		"ID": 1045,
		"x": 37.1077659113,
		"y": 93.605167361,
		"h": 1.1648351648
	},
	{
		"stop_id": 8506041,
		"ID": 976,
		"x": 26.7527044013,
		"y": 81.379159135,
		"h": 1.6263736264
	},
	{
		"stop_id": 8506890,
		"ID": 976,
		"x": 26.1297266403,
		"y": 81.92017623,
		"h": 1.6263736264
	},
	{
		"stop_id": 8506891,
		"ID": 976,
		"x": 26.9577370593,
		"y": 80.830170548,
		"h": 1.6263736264
	},
	{
		"stop_id": 8506892,
		"ID": 976,
		"x": 27.2647395063,
		"y": 80.230203715,
		"h": 1.6263736264
	},
	{
		"stop_id": 8506894,
		"ID": 976,
		"x": 26.2827566013,
		"y": 82.480178684,
		"h": 1.6263736264
	},
	{
		"stop_id": 8573218,
		"ID": 976,
		"x": 26.3077078203,
		"y": 82.980162126,
		"h": 1.6263736264
	},
	{
		"stop_id": 8573219,
		"ID": 976,
		"x": 26.2077058703,
		"y": 82.405249937,
		"h": 1.6263736264
	},
	{
		"stop_id": 8573220,
		"ID": 976,
		"x": 25.8097606223,
		"y": 82.498219531,
		"h": 1.6263736264
	},
	{
		"stop_id": 8573221,
		"ID": 976,
		"x": 26.6307338063,
		"y": 81.612228094,
		"h": 1.6263736264
	},
	{
		"stop_id": 8573222,
		"ID": 976,
		"x": 27.2577259113,
		"y": 81.080218285,
		"h": 1.6263736264
	},
	{
		"stop_id": 8573223,
		"ID": 976,
		"x": 26.7577313903,
		"y": 81.370225572,
		"h": 1.6263736264
	},
	{
		"stop_id": 8573224,
		"ID": 976,
		"x": 27.0907055153,
		"y": 80.481178206,
		"h": 1.6263736264
	},
	{
		"stop_id": 8573683,
		"ID": 976,
		"x": 30.1577554923,
		"y": 84.880210022,
		"h": 1.6263736264
	},
	{
		"stop_id": 8573684,
		"ID": 976,
		"x": 29.3077453213,
		"y": 84.405179844,
		"h": 1.6263736264
	},
	{
		"stop_id": 8573685,
		"ID": 976,
		"x": 29.0907530063,
		"y": 84.691146215,
		"h": 1.6263736264
	},
	{
		"stop_id": 8573686,
		"ID": 976,
		"x": 28.7327686183,
		"y": 85.455173504,
		"h": 1.6263736264
	},
	{
		"stop_id": 8573687,
		"ID": 976,
		"x": 28.1577497633,
		"y": 85.505189309,
		"h": 1.6263736264
	},
	{
		"stop_id": 8576148,
		"ID": 976,
		"x": 30.5327235583,
		"y": 81.264225609,
		"h": 1.6263736264
	},
	{
		"stop_id": 8576149,
		"ID": 976,
		"x": 29.4467298093,
		"y": 81.916159139,
		"h": 1.6263736264
	},
	{
		"stop_id": 8583052,
		"ID": 976,
		"x": 27.2647294163,
		"y": 80.63519074,
		"h": 1.6263736264
	},
	{
		"stop_id": 8506042,
		"ID": 1009,
		"x": 31.2457346373,
		"y": 80.940225251,
		"h": 2.2527472527
	},
	{
		"stop_id": 8506043,
		"ID": 1009,
		"x": 33.8457391143,
		"y": 79.913188031,
		"h": 2.2527472527
	},
	{
		"stop_id": 8506896,
		"ID": 1009,
		"x": 32.8827276423,
		"y": 82.205214981,
		"h": 2.2527472527
	},
	{
		"stop_id": 8573673,
		"ID": 1009,
		"x": 36.1487488903,
		"y": 80.044179523,
		"h": 2.2527472527
	},
	{
		"stop_id": 8573674,
		"ID": 1009,
		"x": 34.8297469563,
		"y": 80.391225338,
		"h": 2.2527472527
	},
	{
		"stop_id": 8573675,
		"ID": 1009,
		"x": 34.1687055153,
		"y": 80.727187116,
		"h": 2.2527472527
	},
	{
		"stop_id": 8573676,
		"ID": 1009,
		"x": 32.9577559893,
		"y": 81.705207581,
		"h": 2.2527472527
	},
	{
		"stop_id": 8573677,
		"ID": 1009,
		"x": 32.1827059113,
		"y": 81.930179616,
		"h": 2.2527472527
	},
	{
		"stop_id": 8573678,
		"ID": 1009,
		"x": 32.0577283123,
		"y": 81.330198188,
		"h": 2.2527472527
	},
	{
		"stop_id": 8576147,
		"ID": 1009,
		"x": 31.2207623513,
		"y": 80.9621921,
		"h": 2.2527472527
	},
	{
		"stop_id": 8576178,
		"ID": 1009,
		"x": 35.5617625083,
		"y": 77.994146858,
		"h": 2.2527472527
	},
	{
		"stop_id": 8576179,
		"ID": 1009,
		"x": 35.7657369793,
		"y": 78.24519358,
		"h": 2.2527472527
	},
	{
		"stop_id": 8582123,
		"ID": 1009,
		"x": 32.6847477193,
		"y": 82.227246038,
		"h": 2.2527472527
	},
	{
		"stop_id": 8590917,
		"ID": 1009,
		"x": 34.4727604833,
		"y": 80.028234546,
		"h": 2.2527472527
	},
	{
		"stop_id": 8590918,
		"ID": 1009,
		"x": 34.4217660543,
		"y": 80.552179918,
		"h": 2.2527472527
	},
	{
		"stop_id": 8590921,
		"ID": 1009,
		"x": 33.8467464903,
		"y": 79.935221742,
		"h": 2.2527472527
	},
	{
		"stop_id": 8590933,
		"ID": 1009,
		"x": 35.1947089463,
		"y": 77.458149104,
		"h": 2.2527472527
	},
	{
		"stop_id": 8590938,
		"ID": 1009,
		"x": 34.7847461933,
		"y": 79.33720891,
		"h": 2.2527472527
	},
	{
		"stop_id": 8590939,
		"ID": 1009,
		"x": 35.9257491553,
		"y": 80.140202254,
		"h": 2.2527472527
	},
	{
		"stop_id": 8590942,
		"ID": 1009,
		"x": 34.2097398303,
		"y": 80.52022676,
		"h": 2.2527472527
	},
	{
		"stop_id": 8590946,
		"ID": 1009,
		"x": 35.1927532603,
		"y": 78.955211539,
		"h": 2.2527472527
	},
	{
		"stop_id": 8590952,
		"ID": 1009,
		"x": 35.6707604443,
		"y": 78.722157306,
		"h": 2.2527472527
	},
	{
		"stop_id": 8590954,
		"ID": 1009,
		"x": 33.5557273623,
		"y": 81.168176143,
		"h": 2.2527472527
	},
	{
		"stop_id": 8590956,
		"ID": 1009,
		"x": 33.9067234963,
		"y": 80.439244697,
		"h": 2.2527472527
	},
	{
		"stop_id": 8590957,
		"ID": 1009,
		"x": 34.9427262173,
		"y": 77.47623758,
		"h": 2.2527472527
	},
	{
		"stop_id": 8590959,
		"ID": 1009,
		"x": 36.5507751603,
		"y": 79.856224154,
		"h": 2.2527472527
	},
	{
		"stop_id": 8590969,
		"ID": 1009,
		"x": 34.2067525353,
		"y": 79.869208555,
		"h": 2.2527472527
	},
	{
		"stop_id": 8590970,
		"ID": 1009,
		"x": 34.4987506443,
		"y": 79.603194009,
		"h": 2.2527472527
	},
	{
		"stop_id": 8590973,
		"ID": 1009,
		"x": 35.4227554303,
		"y": 78.852156841,
		"h": 2.2527472527
	},
	{
		"stop_id": 8590974,
		"ID": 1009,
		"x": 35.2157206053,
		"y": 77.309144448,
		"h": 2.2527472527
	},
	{
		"stop_id": 8590975,
		"ID": 1009,
		"x": 33.7647472013,
		"y": 80.284206592,
		"h": 2.2527472527
	},
	{
		"stop_id": 8590978,
		"ID": 1009,
		"x": 35.5207098013,
		"y": 80.307245256,
		"h": 2.2527472527
	},
	{
		"stop_id": 8590986,
		"ID": 1009,
		"x": 35.8277020023,
		"y": 78.622165096,
		"h": 2.2527472527
	},
	{
		"stop_id": 8590992,
		"ID": 1009,
		"x": 35.1147720963,
		"y": 80.433156825,
		"h": 2.2527472527
	},
	{
		"stop_id": 8590993,
		"ID": 1009,
		"x": 34.9217114413,
		"y": 79.146244821,
		"h": 2.2527472527
	},
	{
		"stop_id": 8590994,
		"ID": 1009,
		"x": 35.9567598443,
		"y": 78.485140455,
		"h": 2.2527472527
	},
	{
		"stop_id": 8590995,
		"ID": 1009,
		"x": 33.8497022943,
		"y": 80.110187474,
		"h": 2.2527472527
	},
	{
		"stop_id": 8591013,
		"ID": 1009,
		"x": 34.4887412113,
		"y": 80.278246933,
		"h": 2.2527472527
	},
	{
		"stop_id": 8591015,
		"ID": 1009,
		"x": 33.9857697783,
		"y": 80.88018696,
		"h": 2.2527472527
	},
	{
		"stop_id": 8506047,
		"ID": 1011,
		"x": 33.4717381443,
		"y": 89.61814191,
		"h": 1.2967032967
	},
	{
		"stop_id": 8506048,
		"ID": 1011,
		"x": 31.7617114503,
		"y": 93.741195252,
		"h": 1.2967032967
	},
	{
		"stop_id": 8506875,
		"ID": 1011,
		"x": 31.7677421053,
		"y": 93.798225957,
		"h": 1.2967032967
	},
	{
		"stop_id": 8506879,
		"ID": 1011,
		"x": 31.3327449373,
		"y": 93.330212513,
		"h": 1.2967032967
	},
	{
		"stop_id": 8573196,
		"ID": 1011,
		"x": 33.4577072093,
		"y": 89.630152746,
		"h": 1.2967032967
	},
	{
		"stop_id": 8573197,
		"ID": 1011,
		"x": 33.9577448453,
		"y": 90.230235704,
		"h": 1.2967032967
	},
	{
		"stop_id": 8573198,
		"ID": 1011,
		"x": 34.1277630563,
		"y": 90.493157205,
		"h": 1.2967032967
	},
	{
		"stop_id": 8573436,
		"ID": 1011,
		"x": 33.9327508433,
		"y": 94.53015213,
		"h": 1.2967032967
	},
	{
		"stop_id": 8573437,
		"ID": 1011,
		"x": 34.6077544773,
		"y": 94.555149985,
		"h": 1.2967032967
	},
	{
		"stop_id": 8580722,
		"ID": 1011,
		"x": 33.2957345723,
		"y": 92.983201891,
		"h": 1.2967032967
	},
	{
		"stop_id": 8506052,
		"ID": 1279,
		"x": 71.4327119313,
		"y": 64.605161846,
		"h": 1.4945054945
	},
	{
		"stop_id": 8506053,
		"ID": 1279,
		"x": 72.3957079413,
		"y": 63.346208914,
		"h": 1.4945054945
	},
	{
		"stop_id": 8506054,
		"ID": 1279,
		"x": 72.1627013883,
		"y": 64.731243413,
		"h": 1.4945054945
	},
	{
		"stop_id": 8506479,
		"ID": 1279,
		"x": 72.5807177803,
		"y": 61.650176448,
		"h": 1.4945054945
	},
	{
		"stop_id": 8506607,
		"ID": 1279,
		"x": 76.0067304573,
		"y": 61.54715009,
		"h": 1.4945054945
	},
	{
		"stop_id": 8506698,
		"ID": 1279,
		"x": 76.1827338283,
		"y": 62.915177079,
		"h": 1.4945054945
	},
	{
		"stop_id": 8506773,
		"ID": 1279,
		"x": 75.4147265563,
		"y": 60.978241797,
		"h": 1.4945054945
	},
	{
		"stop_id": 8574185,
		"ID": 1279,
		"x": 73.4537484003,
		"y": 59.920193998,
		"h": 1.4945054945
	},
	{
		"stop_id": 8574186,
		"ID": 1279,
		"x": 74.1217667933,
		"y": 60.464146322,
		"h": 1.4945054945
	},
	{
		"stop_id": 8574187,
		"ID": 1279,
		"x": 74.8957391833,
		"y": 60.815188006,
		"h": 1.4945054945
	},
	{
		"stop_id": 8574188,
		"ID": 1279,
		"x": 75.8397263833,
		"y": 61.322242809,
		"h": 1.4945054945
	},
	{
		"stop_id": 8574204,
		"ID": 1279,
		"x": 71.5147012453,
		"y": 64.42415001,
		"h": 1.4945054945
	},
	{
		"stop_id": 8574205,
		"ID": 1279,
		"x": 72.6337359453,
		"y": 62.265232126,
		"h": 1.4945054945
	},
	{
		"stop_id": 8580930,
		"ID": 1279,
		"x": 72.6627590443,
		"y": 65.485166967,
		"h": 1.4945054945
	},
	{
		"stop_id": 8581722,
		"ID": 1279,
		"x": 75.8417190403,
		"y": 62.623223411,
		"h": 1.4945054945
	},
	{
		"stop_id": 8581735,
		"ID": 1279,
		"x": 72.1137026243,
		"y": 60.982195476,
		"h": 1.4945054945
	},
	{
		"stop_id": 8506055,
		"ID": 1217,
		"x": 64.1437065803,
		"y": 69.18824037,
		"h": 1.9230769231
	},
	{
		"stop_id": 8506204,
		"ID": 1217,
		"x": 63.4887575553,
		"y": 66.822211784,
		"h": 1.9230769231
	},
	{
		"stop_id": 8506205,
		"ID": 1217,
		"x": 63.3047044853,
		"y": 69.743238826,
		"h": 1.9230769231
	},
	{
		"stop_id": 8506474,
		"ID": 1217,
		"x": 64.1627123473,
		"y": 68.10314281,
		"h": 1.9230769231
	},
	{
		"stop_id": 8506478,
		"ID": 1217,
		"x": 64.9017275073,
		"y": 69.643199589,
		"h": 1.9230769231
	},
	{
		"stop_id": 8506633,
		"ID": 1217,
		"x": 65.0167415363,
		"y": 66.584189715,
		"h": 1.9230769231
	},
	{
		"stop_id": 8506675,
		"ID": 1217,
		"x": 64.5877255243,
		"y": 71.38723547,
		"h": 1.9230769231
	},
	{
		"stop_id": 8506685,
		"ID": 1217,
		"x": 61.1167273603,
		"y": 69.870202115,
		"h": 1.9230769231
	},
	{
		"stop_id": 8506729,
		"ID": 1217,
		"x": 64.6427017043,
		"y": 71.109146322,
		"h": 1.9230769231
	},
	{
		"stop_id": 8573969,
		"ID": 1217,
		"x": 63.8297642513,
		"y": 67.159155803,
		"h": 1.9230769231
	},
	{
		"stop_id": 8573972,
		"ID": 1217,
		"x": 64.3057063373,
		"y": 68.544182329,
		"h": 1.9230769231
	},
	{
		"stop_id": 8573973,
		"ID": 1217,
		"x": 65.3927269083,
		"y": 69.465171307,
		"h": 1.9230769231
	},
	{
		"stop_id": 8574001,
		"ID": 1217,
		"x": 64.6867510833,
		"y": 66.339154238,
		"h": 1.9230769231
	},
	{
		"stop_id": 8578515,
		"ID": 1217,
		"x": 60.7277463283,
		"y": 69.005206314,
		"h": 1.9230769231
	},
	{
		"stop_id": 8578516,
		"ID": 1217,
		"x": 60.8677319863,
		"y": 69.39016115,
		"h": 1.9230769231
	},
	{
		"stop_id": 8578517,
		"ID": 1217,
		"x": 61.3377137703,
		"y": 70.149176158,
		"h": 1.9230769231
	},
	{
		"stop_id": 8578518,
		"ID": 1217,
		"x": 61.5977261713,
		"y": 70.471217633,
		"h": 1.9230769231
	},
	{
		"stop_id": 8578519,
		"ID": 1217,
		"x": 61.5717546833,
		"y": 70.777171868,
		"h": 1.9230769231
	},
	{
		"stop_id": 8580479,
		"ID": 1217,
		"x": 63.2827644723,
		"y": 69.709198202,
		"h": 1.9230769231
	},
	{
		"stop_id": 8580480,
		"ID": 1217,
		"x": 63.2597022913,
		"y": 70.045232676,
		"h": 1.9230769231
	},
	{
		"stop_id": 8580582,
		"ID": 1217,
		"x": 64.5277627643,
		"y": 66.061247083,
		"h": 1.9230769231
	},
	{
		"stop_id": 8580611,
		"ID": 1217,
		"x": 64.8287373613,
		"y": 66.656187068,
		"h": 1.9230769231
	},
	{
		"stop_id": 8581127,
		"ID": 1217,
		"x": 64.4957228213,
		"y": 71.247182565,
		"h": 1.9230769231
	},
	{
		"stop_id": 8582463,
		"ID": 1217,
		"x": 61.0527067463,
		"y": 69.615233281,
		"h": 1.9230769231
	},
	{
		"stop_id": 8582464,
		"ID": 1217,
		"x": 63.0807433303,
		"y": 70.335215741,
		"h": 1.9230769231
	},
	{
		"stop_id": 8587340,
		"ID": 1217,
		"x": 63.4577418543,
		"y": 66.730154794,
		"h": 1.9230769231
	},
	{
		"stop_id": 8587778,
		"ID": 1217,
		"x": 62.8777111983,
		"y": 70.560204984,
		"h": 1.9230769231
	},
	{
		"stop_id": 8587779,
		"ID": 1217,
		"x": 62.1127008393,
		"y": 70.227243594,
		"h": 1.9230769231
	},
	{
		"stop_id": 8587780,
		"ID": 1217,
		"x": 61.6157397193,
		"y": 69.920223079,
		"h": 1.9230769231
	},
	{
		"stop_id": 8506056,
		"ID": 1358,
		"x": 86.3867381113,
		"y": 76.072201213,
		"h": 1.989010989
	},
	{
		"stop_id": 8506263,
		"ID": 1358,
		"x": 87.8367239323,
		"y": 75.648206788,
		"h": 1.989010989
	},
	{
		"stop_id": 8506304,
		"ID": 1358,
		"x": 89.1807144683,
		"y": 77.527164805,
		"h": 1.989010989
	},
	{
		"stop_id": 8506393,
		"ID": 1358,
		"x": 87.2667388213,
		"y": 76.153182918,
		"h": 1.989010989
	},
	{
		"stop_id": 8506394,
		"ID": 1358,
		"x": 87.4657241513,
		"y": 78.687171347,
		"h": 1.989010989
	},
	{
		"stop_id": 8506650,
		"ID": 1358,
		"x": 88.1827393653,
		"y": 78.830196883,
		"h": 1.989010989
	},
	{
		"stop_id": 8506703,
		"ID": 1358,
		"x": 88.0267081643,
		"y": 74.544201645,
		"h": 1.989010989
	},
	{
		"stop_id": 8506708,
		"ID": 1358,
		"x": 87.9967105823,
		"y": 78.334169737,
		"h": 1.989010989
	},
	{
		"stop_id": 8573965,
		"ID": 1358,
		"x": 87.2577136743,
		"y": 76.155182937,
		"h": 1.989010989
	},
	{
		"stop_id": 8573966,
		"ID": 1358,
		"x": 87.2177227343,
		"y": 75.840215762,
		"h": 1.989010989
	},
	{
		"stop_id": 8573967,
		"ID": 1358,
		"x": 86.7607664713,
		"y": 75.932199822,
		"h": 1.989010989
	},
	{
		"stop_id": 8574240,
		"ID": 1358,
		"x": 88.0657081593,
		"y": 75.317152015,
		"h": 1.989010989
	},
	{
		"stop_id": 8574242,
		"ID": 1358,
		"x": 87.6927159463,
		"y": 76.311155377,
		"h": 1.989010989
	},
	{
		"stop_id": 8574243,
		"ID": 1358,
		"x": 87.7887684113,
		"y": 76.929154716,
		"h": 1.989010989
	},
	{
		"stop_id": 8574253,
		"ID": 1358,
		"x": 87.7337338293,
		"y": 75.758191877,
		"h": 1.989010989
	},
	{
		"stop_id": 8574254,
		"ID": 1358,
		"x": 86.2617508713,
		"y": 76.216145634,
		"h": 1.989010989
	},
	{
		"stop_id": 8574255,
		"ID": 1358,
		"x": 86.8047744083,
		"y": 76.454242642,
		"h": 1.989010989
	},
	{
		"stop_id": 8574256,
		"ID": 1358,
		"x": 86.9647721503,
		"y": 76.246225677,
		"h": 1.989010989
	},
	{
		"stop_id": 8579846,
		"ID": 1358,
		"x": 85.5807529383,
		"y": 77.4132158,
		"h": 1.989010989
	},
	{
		"stop_id": 8580686,
		"ID": 1358,
		"x": 90.4177031243,
		"y": 75.769237599,
		"h": 1.989010989
	},
	{
		"stop_id": 8580687,
		"ID": 1358,
		"x": 89.6697556223,
		"y": 74.75920568,
		"h": 1.989010989
	},
	{
		"stop_id": 8581393,
		"ID": 1358,
		"x": 90.7357026513,
		"y": 76.15224825,
		"h": 1.989010989
	},
	{
		"stop_id": 8581394,
		"ID": 1358,
		"x": 89.9857468563,
		"y": 76.828231171,
		"h": 1.989010989
	},
	{
		"stop_id": 8581395,
		"ID": 1358,
		"x": 89.7067529783,
		"y": 76.677140962,
		"h": 1.989010989
	},
	{
		"stop_id": 8581396,
		"ID": 1358,
		"x": 89.6497116483,
		"y": 76.47216497,
		"h": 1.989010989
	},
	{
		"stop_id": 8581397,
		"ID": 1358,
		"x": 89.6557380193,
		"y": 76.329175884,
		"h": 1.989010989
	},
	{
		"stop_id": 8581398,
		"ID": 1358,
		"x": 89.7447186463,
		"y": 75.54520481,
		"h": 1.989010989
	},
	{
		"stop_id": 8589580,
		"ID": 1358,
		"x": 88.5537538803,
		"y": 74.391230381,
		"h": 1.989010989
	},
	{
		"stop_id": 8589610,
		"ID": 1358,
		"x": 89.5097741293,
		"y": 74.393144419,
		"h": 1.989010989
	},
	{
		"stop_id": 8594353,
		"ID": 1358,
		"x": 87.8866998423,
		"y": 74.504225392,
		"h": 1.989010989
	},
	{
		"stop_id": 8594354,
		"ID": 1358,
		"x": 87.8657365373,
		"y": 74.824236805,
		"h": 1.989010989
	},
	{
		"stop_id": 8506057,
		"ID": 1218,
		"x": 61.9077257233,
		"y": 74.380194445,
		"h": 3.2087912088
	},
	{
		"stop_id": 8506206,
		"ID": 1218,
		"x": 61.0687556923,
		"y": 75.511225614,
		"h": 3.2087912088
	},
	{
		"stop_id": 8506672,
		"ID": 1218,
		"x": 61.7977106483,
		"y": 76.081204762,
		"h": 3.2087912088
	},
	{
		"stop_id": 8506673,
		"ID": 1218,
		"x": 62.2627660833,
		"y": 75.942205938,
		"h": 3.2087912088
	},
	{
		"stop_id": 8506676,
		"ID": 1218,
		"x": 61.7717078073,
		"y": 73.929229346,
		"h": 3.2087912088
	},
	{
		"stop_id": 8506677,
		"ID": 1218,
		"x": 61.6257210343,
		"y": 75.029196727,
		"h": 3.2087912088
	},
	{
		"stop_id": 8506783,
		"ID": 1218,
		"x": 64.2777531583,
		"y": 76.073200044,
		"h": 3.2087912088
	},
	{
		"stop_id": 8506997,
		"ID": 1218,
		"x": 63.5357350853,
		"y": 73.390221868,
		"h": 3.2087912088
	},
	{
		"stop_id": 8573602,
		"ID": 1218,
		"x": 61.0917162123,
		"y": 75.550172825,
		"h": 3.2087912088
	},
	{
		"stop_id": 8573603,
		"ID": 1218,
		"x": 61.5267465603,
		"y": 75.898152611,
		"h": 3.2087912088
	},
	{
		"stop_id": 8573604,
		"ID": 1218,
		"x": 62.0327749673,
		"y": 76.205145597,
		"h": 3.2087912088
	},
	{
		"stop_id": 8573605,
		"ID": 1218,
		"x": 62.8667654473,
		"y": 77.010187327,
		"h": 3.2087912088
	},
	{
		"stop_id": 8573616,
		"ID": 1218,
		"x": 61.2227321753,
		"y": 75.763146578,
		"h": 3.2087912088
	},
	{
		"stop_id": 8573911,
		"ID": 1218,
		"x": 62.5097550743,
		"y": 75.861230862,
		"h": 3.2087912088
	},
	{
		"stop_id": 8573912,
		"ID": 1218,
		"x": 62.7547353523,
		"y": 75.84116703,
		"h": 3.2087912088
	},
	{
		"stop_id": 8573914,
		"ID": 1218,
		"x": 64.9577392793,
		"y": 76.005204633,
		"h": 3.2087912088
	},
	{
		"stop_id": 8573915,
		"ID": 1218,
		"x": 65.7417751363,
		"y": 75.81115727,
		"h": 3.2087912088
	},
	{
		"stop_id": 8573925,
		"ID": 1218,
		"x": 61.5157436103,
		"y": 75.504248152,
		"h": 3.2087912088
	},
	{
		"stop_id": 8573926,
		"ID": 1218,
		"x": 61.6907214653,
		"y": 74.688231165,
		"h": 3.2087912088
	},
	{
		"stop_id": 8573927,
		"ID": 1218,
		"x": 62.8737527563,
		"y": 73.719209559,
		"h": 3.2087912088
	},
	{
		"stop_id": 8578521,
		"ID": 1218,
		"x": 61.7827372613,
		"y": 73.179246167,
		"h": 3.2087912088
	},
	{
		"stop_id": 8578522,
		"ID": 1218,
		"x": 61.7777256933,
		"y": 74.220162559,
		"h": 3.2087912088
	},
	{
		"stop_id": 8578821,
		"ID": 1218,
		"x": 60.5827259103,
		"y": 74.160147981,
		"h": 3.2087912088
	},
	{
		"stop_id": 8578822,
		"ID": 1218,
		"x": 60.8327179423,
		"y": 74.330159677,
		"h": 3.2087912088
	},
	{
		"stop_id": 8578823,
		"ID": 1218,
		"x": 60.8677688863,
		"y": 74.505248432,
		"h": 3.2087912088
	},
	{
		"stop_id": 8578824,
		"ID": 1218,
		"x": 60.8577486153,
		"y": 74.830216637,
		"h": 3.2087912088
	},
	{
		"stop_id": 8578825,
		"ID": 1218,
		"x": 60.8877237443,
		"y": 75.080156717,
		"h": 3.2087912088
	},
	{
		"stop_id": 8578826,
		"ID": 1218,
		"x": 61.1187404323,
		"y": 75.390251196,
		"h": 3.2087912088
	},
	{
		"stop_id": 8579273,
		"ID": 1218,
		"x": 64.2327047133,
		"y": 71.798153718,
		"h": 3.2087912088
	},
	{
		"stop_id": 8579275,
		"ID": 1218,
		"x": 63.7627239753,
		"y": 73.113153115,
		"h": 3.2087912088
	},
	{
		"stop_id": 8582741,
		"ID": 1218,
		"x": 65.5137145753,
		"y": 71.924216288,
		"h": 3.2087912088
	},
	{
		"stop_id": 8583505,
		"ID": 1218,
		"x": 65.9377656873,
		"y": 75.95021761,
		"h": 3.2087912088
	},
	{
		"stop_id": 8583838,
		"ID": 1218,
		"x": 64.8487264573,
		"y": 76.211203451,
		"h": 3.2087912088
	},
	{
		"stop_id": 8587757,
		"ID": 1218,
		"x": 62.3557617703,
		"y": 76.471145704,
		"h": 3.2087912088
	},
	{
		"stop_id": 8587758,
		"ID": 1218,
		"x": 62.2977268303,
		"y": 76.740186295,
		"h": 3.2087912088
	},
	{
		"stop_id": 8587865,
		"ID": 1218,
		"x": 62.5187693793,
		"y": 76.80024623,
		"h": 3.2087912088
	},
	{
		"stop_id": 8588106,
		"ID": 1218,
		"x": 60.4927151823,
		"y": 74.365164357,
		"h": 3.2087912088
	},
	{
		"stop_id": 8588425,
		"ID": 1218,
		"x": 61.8827123293,
		"y": 73.630247515,
		"h": 3.2087912088
	},
	{
		"stop_id": 8588721,
		"ID": 1218,
		"x": 60.5907715053,
		"y": 74.291203288,
		"h": 3.2087912088
	},
	{
		"stop_id": 8591657,
		"ID": 1218,
		"x": 61.7647633873,
		"y": 76.48821991,
		"h": 3.2087912088
	},
	{
		"stop_id": 8591658,
		"ID": 1218,
		"x": 62.0337450353,
		"y": 76.97818083,
		"h": 3.2087912088
	},
	{
		"stop_id": 8591659,
		"ID": 1218,
		"x": 62.3927343693,
		"y": 76.185211777,
		"h": 3.2087912088
	},
	{
		"stop_id": 8591661,
		"ID": 1218,
		"x": 62.1937063573,
		"y": 75.173217586,
		"h": 3.2087912088
	},
	{
		"stop_id": 8591663,
		"ID": 1218,
		"x": 61.7377202223,
		"y": 75.62423823,
		"h": 3.2087912088
	},
	{
		"stop_id": 8591664,
		"ID": 1218,
		"x": 61.4077300823,
		"y": 76.230229261,
		"h": 3.2087912088
	},
	{
		"stop_id": 8591666,
		"ID": 1218,
		"x": 62.1577392063,
		"y": 76.080163472,
		"h": 3.2087912088
	},
	{
		"stop_id": 8591668,
		"ID": 1218,
		"x": 61.9327275093,
		"y": 76.805172475,
		"h": 3.2087912088
	},
	{
		"stop_id": 8591669,
		"ID": 1218,
		"x": 61.3797638903,
		"y": 75.69218449,
		"h": 3.2087912088
	},
	{
		"stop_id": 8591670,
		"ID": 1218,
		"x": 62.7357278523,
		"y": 76.289169255,
		"h": 3.2087912088
	},
	{
		"stop_id": 8591671,
		"ID": 1218,
		"x": 62.6597608263,
		"y": 75.693182851,
		"h": 3.2087912088
	},
	{
		"stop_id": 8591672,
		"ID": 1218,
		"x": 62.3917136913,
		"y": 75.632147751,
		"h": 3.2087912088
	},
	{
		"stop_id": 8591673,
		"ID": 1218,
		"x": 63.0417418273,
		"y": 75.820206383,
		"h": 3.2087912088
	},
	{
		"stop_id": 8591674,
		"ID": 1218,
		"x": 62.5957546013,
		"y": 76.359225067,
		"h": 3.2087912088
	},
	{
		"stop_id": 8591676,
		"ID": 1218,
		"x": 62.5327652593,
		"y": 76.105143522,
		"h": 3.2087912088
	},
	{
		"stop_id": 8591677,
		"ID": 1218,
		"x": 61.6827120723,
		"y": 76.305152527,
		"h": 3.2087912088
	},
	{
		"stop_id": 8591678,
		"ID": 1218,
		"x": 61.9257243643,
		"y": 76.680140406,
		"h": 3.2087912088
	},
	{
		"stop_id": 8591679,
		"ID": 1218,
		"x": 61.9227620693,
		"y": 77.183190281,
		"h": 3.2087912088
	},
	{
		"stop_id": 8591680,
		"ID": 1218,
		"x": 61.7377712513,
		"y": 76.910148836,
		"h": 3.2087912088
	},
	{
		"stop_id": 8591681,
		"ID": 1218,
		"x": 61.7827121243,
		"y": 76.730246191,
		"h": 3.2087912088
	},
	{
		"stop_id": 8591682,
		"ID": 1218,
		"x": 61.9527179493,
		"y": 75.599188098,
		"h": 3.2087912088
	},
	{
		"stop_id": 8591683,
		"ID": 1218,
		"x": 62.1577383933,
		"y": 75.330170238,
		"h": 3.2087912088
	},
	{
		"stop_id": 8591792,
		"ID": 1218,
		"x": 62.1337084003,
		"y": 76.880152086,
		"h": 3.2087912088
	},
	{
		"stop_id": 8594156,
		"ID": 1218,
		"x": 61.8127073973,
		"y": 75.355208133,
		"h": 3.2087912088
	},
	{
		"stop_id": 8594384,
		"ID": 1218,
		"x": 61.6017590553,
		"y": 76.656245758,
		"h": 3.2087912088
	},
	{
		"stop_id": 8594468,
		"ID": 1218,
		"x": 60.8297055383,
		"y": 74.178188203,
		"h": 3.2087912088
	},
	{
		"stop_id": 8595388,
		"ID": 1218,
		"x": 66.0767144633,
		"y": 73.984195081,
		"h": 3.2087912088
	},
	{
		"stop_id": 8595389,
		"ID": 1218,
		"x": 66.6317008863,
		"y": 74.45821488,
		"h": 3.2087912088
	},
	{
		"stop_id": 8595390,
		"ID": 1218,
		"x": 64.7877662003,
		"y": 74.038214762,
		"h": 3.2087912088
	},
	{
		"stop_id": 8506100,
		"ID": 1112,
		"x": 49.9817080553,
		"y": 85.943142752,
		"h": 2.3516483516
	},
	{
		"stop_id": 8506760,
		"ID": 1112,
		"x": 47.8517375543,
		"y": 91.435226892,
		"h": 2.3516483516
	},
	{
		"stop_id": 8506869,
		"ID": 1112,
		"x": 47.7047670933,
		"y": 88.623188666,
		"h": 2.3516483516
	},
	{
		"stop_id": 8506900,
		"ID": 1112,
		"x": 49.0227730823,
		"y": 87.27324054,
		"h": 2.3516483516
	},
	{
		"stop_id": 8506901,
		"ID": 1112,
		"x": 49.5787744093,
		"y": 86.230146917,
		"h": 2.3516483516
	},
	{
		"stop_id": 8506948,
		"ID": 1112,
		"x": 48.3627585473,
		"y": 88.603177698,
		"h": 2.3516483516
	},
	{
		"stop_id": 8506955,
		"ID": 1112,
		"x": 48.1087003423,
		"y": 86.591222542,
		"h": 2.3516483516
	},
	{
		"stop_id": 8506966,
		"ID": 1112,
		"x": 49.4837436253,
		"y": 90.131149908,
		"h": 2.3516483516
	},
	{
		"stop_id": 8506967,
		"ID": 1112,
		"x": 49.2017066833,
		"y": 89.415196342,
		"h": 2.3516483516
	},
	{
		"stop_id": 8573300,
		"ID": 1112,
		"x": 48.1377650893,
		"y": 88.752194481,
		"h": 2.3516483516
	},
	{
		"stop_id": 8573312,
		"ID": 1112,
		"x": 50.1317177263,
		"y": 86.211164276,
		"h": 2.3516483516
	},
	{
		"stop_id": 8573313,
		"ID": 1112,
		"x": 49.2027515313,
		"y": 86.309159617,
		"h": 2.3516483516
	},
	{
		"stop_id": 8573314,
		"ID": 1112,
		"x": 48.8847394403,
		"y": 86.394156404,
		"h": 2.3516483516
	},
	{
		"stop_id": 8573315,
		"ID": 1112,
		"x": 47.8457108773,
		"y": 86.65314828,
		"h": 2.3516483516
	},
	{
		"stop_id": 8573316,
		"ID": 1112,
		"x": 47.1127337423,
		"y": 86.841231838,
		"h": 2.3516483516
	},
	{
		"stop_id": 8573317,
		"ID": 1112,
		"x": 46.6177745033,
		"y": 86.963184103,
		"h": 2.3516483516
	},
	{
		"stop_id": 8573318,
		"ID": 1112,
		"x": 46.3877222113,
		"y": 87.020207508,
		"h": 2.3516483516
	},
	{
		"stop_id": 8573321,
		"ID": 1112,
		"x": 49.5857079363,
		"y": 86.579246591,
		"h": 2.3516483516
	},
	{
		"stop_id": 8573322,
		"ID": 1112,
		"x": 49.3087688003,
		"y": 86.788199957,
		"h": 2.3516483516
	},
	{
		"stop_id": 8573323,
		"ID": 1112,
		"x": 48.7257323103,
		"y": 88.599162158,
		"h": 2.3516483516
	},
	{
		"stop_id": 8573324,
		"ID": 1112,
		"x": 48.3477300763,
		"y": 88.836218096,
		"h": 2.3516483516
	},
	{
		"stop_id": 8573325,
		"ID": 1112,
		"x": 48.8317005423,
		"y": 89.121234607,
		"h": 2.3516483516
	},
	{
		"stop_id": 8573326,
		"ID": 1112,
		"x": 48.8497668823,
		"y": 90.502229339,
		"h": 2.3516483516
	},
	{
		"stop_id": 8573375,
		"ID": 1112,
		"x": 49.9987529383,
		"y": 85.925221419,
		"h": 2.3516483516
	},
	{
		"stop_id": 8580240,
		"ID": 1112,
		"x": 49.0417582293,
		"y": 88.207185692,
		"h": 2.3516483516
	},
	{
		"stop_id": 8581946,
		"ID": 1112,
		"x": 48.0247204393,
		"y": 91.587183255,
		"h": 2.3516483516
	},
	{
		"stop_id": 8582453,
		"ID": 1112,
		"x": 47.1847263933,
		"y": 85.962217986,
		"h": 2.3516483516
	},
	{
		"stop_id": 8582454,
		"ID": 1112,
		"x": 45.5877028603,
		"y": 89.207229674,
		"h": 2.3516483516
	},
	{
		"stop_id": 8583227,
		"ID": 1112,
		"x": 46.0017617993,
		"y": 88.915152279,
		"h": 2.3516483516
	},
	{
		"stop_id": 8583319,
		"ID": 1112,
		"x": 50.1607410133,
		"y": 86.609163274,
		"h": 2.3516483516
	},
	{
		"stop_id": 8583324,
		"ID": 1112,
		"x": 50.6157455713,
		"y": 86.754216096,
		"h": 2.3516483516
	},
	{
		"stop_id": 8583325,
		"ID": 1112,
		"x": 48.7027178353,
		"y": 86.071198653,
		"h": 2.3516483516
	},
	{
		"stop_id": 8583327,
		"ID": 1112,
		"x": 48.9097312153,
		"y": 86.083234232,
		"h": 2.3516483516
	},
	{
		"stop_id": 8583328,
		"ID": 1112,
		"x": 49.7157472693,
		"y": 86.207218258,
		"h": 2.3516483516
	},
	{
		"stop_id": 8583329,
		"ID": 1112,
		"x": 50.4157049933,
		"y": 86.176199055,
		"h": 2.3516483516
	},
	{
		"stop_id": 8583330,
		"ID": 1112,
		"x": 50.3857646303,
		"y": 86.635153822,
		"h": 2.3516483516
	},
	{
		"stop_id": 8583335,
		"ID": 1112,
		"x": 49.2447171383,
		"y": 86.262225967,
		"h": 2.3516483516
	},
	{
		"stop_id": 8594739,
		"ID": 1112,
		"x": 49.1297556663,
		"y": 86.112198199,
		"h": 2.3516483516
	},
	{
		"stop_id": 8594742,
		"ID": 1112,
		"x": 49.9837710043,
		"y": 86.241219081,
		"h": 2.3516483516
	},
	{
		"stop_id": 8594756,
		"ID": 1112,
		"x": 50.2977530643,
		"y": 85.990171992,
		"h": 2.3516483516
	},
	{
		"stop_id": 8594757,
		"ID": 1112,
		"x": 48.6657263603,
		"y": 86.376229524,
		"h": 2.3516483516
	},
	{
		"stop_id": 8594769,
		"ID": 1112,
		"x": 50.0877143953,
		"y": 86.456227098,
		"h": 2.3516483516
	},
	{
		"stop_id": 8506101,
		"ID": 1148,
		"x": 53.4497091923,
		"y": 88.115151007,
		"h": 2.7472527473
	},
	{
		"stop_id": 8506628,
		"ID": 1148,
		"x": 50.5267726973,
		"y": 86.29515263,
		"h": 2.7472527473
	},
	{
		"stop_id": 8506706,
		"ID": 1148,
		"x": 53.4317566583,
		"y": 88.435203385,
		"h": 2.7472527473
	},
	{
		"stop_id": 8506855,
		"ID": 1148,
		"x": 52.6527368803,
		"y": 84.239181394,
		"h": 2.7472527473
	},
	{
		"stop_id": 8506856,
		"ID": 1148,
		"x": 51.7907601363,
		"y": 84.343166305,
		"h": 2.7472527473
	},
	{
		"stop_id": 8506870,
		"ID": 1148,
		"x": 51.0307420893,
		"y": 84.886235814,
		"h": 2.7472527473
	},
	{
		"stop_id": 8506949,
		"ID": 1148,
		"x": 55.6917146003,
		"y": 84.816150689,
		"h": 2.7472527473
	},
	{
		"stop_id": 8506957,
		"ID": 1148,
		"x": 52.5207589723,
		"y": 87.852189397,
		"h": 2.7472527473
	},
	{
		"stop_id": 8506964,
		"ID": 1148,
		"x": 55.3047346003,
		"y": 84.729194654,
		"h": 2.7472527473
	},
	{
		"stop_id": 8573284,
		"ID": 1148,
		"x": 51.8127713873,
		"y": 87.294172472,
		"h": 2.7472527473
	},
	{
		"stop_id": 8573285,
		"ID": 1148,
		"x": 53.0597127293,
		"y": 88.117247867,
		"h": 2.7472527473
	},
	{
		"stop_id": 8573301,
		"ID": 1148,
		"x": 50.8767614843,
		"y": 86.554143911,
		"h": 2.7472527473
	},
	{
		"stop_id": 8573302,
		"ID": 1148,
		"x": 51.4567315903,
		"y": 87.08916829,
		"h": 2.7472527473
	},
	{
		"stop_id": 8573342,
		"ID": 1148,
		"x": 53.6227398343,
		"y": 87.667181442,
		"h": 2.7472527473
	},
	{
		"stop_id": 8573343,
		"ID": 1148,
		"x": 53.5957531113,
		"y": 87.975160023,
		"h": 2.7472527473
	},
	{
		"stop_id": 8573366,
		"ID": 1148,
		"x": 54.7017482703,
		"y": 84.687228463,
		"h": 2.7472527473
	},
	{
		"stop_id": 8580967,
		"ID": 1148,
		"x": 52.8867393863,
		"y": 84.604177934,
		"h": 2.7472527473
	},
	{
		"stop_id": 8581297,
		"ID": 1148,
		"x": 53.2567336243,
		"y": 84.707219663,
		"h": 2.7472527473
	},
	{
		"stop_id": 8581614,
		"ID": 1148,
		"x": 54.9717619553,
		"y": 84.656213447,
		"h": 2.7472527473
	},
	{
		"stop_id": 8581615,
		"ID": 1148,
		"x": 54.1947232843,
		"y": 83.109155963,
		"h": 2.7472527473
	},
	{
		"stop_id": 8581616,
		"ID": 1148,
		"x": 54.2347217163,
		"y": 83.456231486,
		"h": 2.7472527473
	},
	{
		"stop_id": 8583318,
		"ID": 1148,
		"x": 50.8067241583,
		"y": 85.772148126,
		"h": 2.7472527473
	},
	{
		"stop_id": 8583320,
		"ID": 1148,
		"x": 50.8787093483,
		"y": 85.53017256,
		"h": 2.7472527473
	},
	{
		"stop_id": 8583321,
		"ID": 1148,
		"x": 51.2197603733,
		"y": 86.106182388,
		"h": 2.7472527473
	},
	{
		"stop_id": 8583322,
		"ID": 1148,
		"x": 51.6117023443,
		"y": 84.742249743,
		"h": 2.7472527473
	},
	{
		"stop_id": 8583323,
		"ID": 1148,
		"x": 50.9537605073,
		"y": 85.177158417,
		"h": 2.7472527473
	},
	{
		"stop_id": 8583331,
		"ID": 1148,
		"x": 51.5577088083,
		"y": 86.8271723,
		"h": 2.7472527473
	},
	{
		"stop_id": 8583332,
		"ID": 1148,
		"x": 51.0947716943,
		"y": 86.320246507,
		"h": 2.7472527473
	},
	{
		"stop_id": 8583337,
		"ID": 1148,
		"x": 51.2297103993,
		"y": 84.555235214,
		"h": 2.7472527473
	},
	{
		"stop_id": 8583338,
		"ID": 1148,
		"x": 51.4277039043,
		"y": 86.728193111,
		"h": 2.7472527473
	},
	{
		"stop_id": 8583340,
		"ID": 1148,
		"x": 51.2167152853,
		"y": 87.169170426,
		"h": 2.7472527473
	},
	{
		"stop_id": 8594733,
		"ID": 1148,
		"x": 50.4837620483,
		"y": 85.8491823,
		"h": 2.7472527473
	},
	{
		"stop_id": 8594734,
		"ID": 1148,
		"x": 50.5617129543,
		"y": 86.262220408,
		"h": 2.7472527473
	},
	{
		"stop_id": 8594737,
		"ID": 1148,
		"x": 50.8477524533,
		"y": 86.897235398,
		"h": 2.7472527473
	},
	{
		"stop_id": 8594740,
		"ID": 1148,
		"x": 51.5487072403,
		"y": 85.256179228,
		"h": 2.7472527473
	},
	{
		"stop_id": 8594743,
		"ID": 1148,
		"x": 50.4457230703,
		"y": 85.830234085,
		"h": 2.7472527473
	},
	{
		"stop_id": 8594744,
		"ID": 1148,
		"x": 50.9827093983,
		"y": 85.749200767,
		"h": 2.7472527473
	},
	{
		"stop_id": 8594745,
		"ID": 1148,
		"x": 51.1147345143,
		"y": 86.203184994,
		"h": 2.7472527473
	},
	{
		"stop_id": 8594746,
		"ID": 1148,
		"x": 50.8307229453,
		"y": 86.239228268,
		"h": 2.7472527473
	},
	{
		"stop_id": 8594748,
		"ID": 1148,
		"x": 51.8807289283,
		"y": 84.989207335,
		"h": 2.7472527473
	},
	{
		"stop_id": 8594749,
		"ID": 1148,
		"x": 51.2557505803,
		"y": 86.626203811,
		"h": 2.7472527473
	},
	{
		"stop_id": 8594750,
		"ID": 1148,
		"x": 51.3117531183,
		"y": 87.466217963,
		"h": 2.7472527473
	},
	{
		"stop_id": 8594751,
		"ID": 1148,
		"x": 51.0547610473,
		"y": 87.052250216,
		"h": 2.7472527473
	},
	{
		"stop_id": 8594752,
		"ID": 1148,
		"x": 51.4837347323,
		"y": 86.191220099,
		"h": 2.7472527473
	},
	{
		"stop_id": 8594754,
		"ID": 1148,
		"x": 51.3877406143,
		"y": 84.648174442,
		"h": 2.7472527473
	},
	{
		"stop_id": 8594760,
		"ID": 1148,
		"x": 51.3737007003,
		"y": 85.378215101,
		"h": 2.7472527473
	},
	{
		"stop_id": 8594761,
		"ID": 1148,
		"x": 50.3617434093,
		"y": 85.90517862,
		"h": 2.7472527473
	},
	{
		"stop_id": 8594763,
		"ID": 1148,
		"x": 50.6527051693,
		"y": 85.510150964,
		"h": 2.7472527473
	},
	{
		"stop_id": 8594765,
		"ID": 1148,
		"x": 50.8257556533,
		"y": 85.427202686,
		"h": 2.7472527473
	},
	{
		"stop_id": 8594766,
		"ID": 1148,
		"x": 51.0217116743,
		"y": 86.507151569,
		"h": 2.7472527473
	},
	{
		"stop_id": 8594768,
		"ID": 1148,
		"x": 51.0757634023,
		"y": 85.496168169,
		"h": 2.7472527473
	},
	{
		"stop_id": 8594770,
		"ID": 1148,
		"x": 50.7457483513,
		"y": 86.331163698,
		"h": 2.7472527473
	},
	{
		"stop_id": 8595450,
		"ID": 1148,
		"x": 51.6337393243,
		"y": 87.668235881,
		"h": 2.7472527473
	},
	{
		"stop_id": 8595451,
		"ID": 1148,
		"x": 50.8747044813,
		"y": 86.25417569,
		"h": 2.7472527473
	},
	{
		"stop_id": 8506102,
		"ID": 1184,
		"x": 55.7987688673,
		"y": 88.743197746,
		"h": 1.4945054945
	},
	{
		"stop_id": 8506103,
		"ID": 1184,
		"x": 58.8667478193,
		"y": 89.452214616,
		"h": 1.4945054945
	},
	{
		"stop_id": 8506595,
		"ID": 1184,
		"x": 57.0867708643,
		"y": 90.577200089,
		"h": 1.4945054945
	},
	{
		"stop_id": 8506688,
		"ID": 1184,
		"x": 57.7867304963,
		"y": 90.920182832,
		"h": 1.4945054945
	},
	{
		"stop_id": 8506864,
		"ID": 1184,
		"x": 60.4077094743,
		"y": 86.550158625,
		"h": 1.4945054945
	},
	{
		"stop_id": 8506971,
		"ID": 1184,
		"x": 59.9787082833,
		"y": 86.205248625,
		"h": 1.4945054945
	},
	{
		"stop_id": 8506979,
		"ID": 1184,
		"x": 60.0097121033,
		"y": 90.637147972,
		"h": 1.4945054945
	},
	{
		"stop_id": 8573345,
		"ID": 1184,
		"x": 58.4347575133,
		"y": 91.287232884,
		"h": 1.4945054945
	},
	{
		"stop_id": 8573346,
		"ID": 1184,
		"x": 58.8997667803,
		"y": 89.460218522,
		"h": 1.4945054945
	},
	{
		"stop_id": 8573348,
		"ID": 1184,
		"x": 60.2127445383,
		"y": 91.051206924,
		"h": 1.4945054945
	},
	{
		"stop_id": 8573356,
		"ID": 1184,
		"x": 57.6767697093,
		"y": 91.184236439,
		"h": 1.4945054945
	},
	{
		"stop_id": 8573369,
		"ID": 1184,
		"x": 59.8397596353,
		"y": 85.996245721,
		"h": 1.4945054945
	},
	{
		"stop_id": 8579925,
		"ID": 1184,
		"x": 57.3457246843,
		"y": 91.477151734,
		"h": 1.4945054945
	},
	{
		"stop_id": 8582011,
		"ID": 1184,
		"x": 57.9737695793,
		"y": 90.635203978,
		"h": 1.4945054945
	},
	{
		"stop_id": 8582160,
		"ID": 1184,
		"x": 57.3987230013,
		"y": 90.71717525,
		"h": 1.4945054945
	},
	{
		"stop_id": 8583226,
		"ID": 1184,
		"x": 58.0387310713,
		"y": 91.115161003,
		"h": 1.4945054945
	},
	{
		"stop_id": 8506104,
		"ID": 1221,
		"x": 62.3897200773,
		"y": 88.929206057,
		"h": 1.5274725275
	},
	{
		"stop_id": 8506560,
		"ID": 1221,
		"x": 64.0757244303,
		"y": 89.498174818,
		"h": 1.5274725275
	},
	{
		"stop_id": 8506561,
		"ID": 1221,
		"x": 64.3987348933,
		"y": 88.947220731,
		"h": 1.5274725275
	},
	{
		"stop_id": 8506562,
		"ID": 1221,
		"x": 64.9587199913,
		"y": 90.300171593,
		"h": 1.5274725275
	},
	{
		"stop_id": 8506564,
		"ID": 1221,
		"x": 62.4077414163,
		"y": 92.734228678,
		"h": 1.5274725275
	},
	{
		"stop_id": 8506565,
		"ID": 1221,
		"x": 62.6287054483,
		"y": 89.912174245,
		"h": 1.5274725275
	},
	{
		"stop_id": 8506566,
		"ID": 1221,
		"x": 63.5187297003,
		"y": 93.17618626,
		"h": 1.5274725275
	},
	{
		"stop_id": 8506567,
		"ID": 1221,
		"x": 62.4707343333,
		"y": 91.719250279,
		"h": 1.5274725275
	},
	{
		"stop_id": 8506594,
		"ID": 1221,
		"x": 60.4737045103,
		"y": 91.891181202,
		"h": 1.5274725275
	},
	{
		"stop_id": 8506885,
		"ID": 1221,
		"x": 61.8357669573,
		"y": 92.363183598,
		"h": 1.5274725275
	},
	{
		"stop_id": 8573384,
		"ID": 1221,
		"x": 61.7707424353,
		"y": 90.865228519,
		"h": 1.5274725275
	},
	{
		"stop_id": 8573385,
		"ID": 1221,
		"x": 62.4887705383,
		"y": 89.567178566,
		"h": 1.5274725275
	},
	{
		"stop_id": 8573386,
		"ID": 1221,
		"x": 62.3077542083,
		"y": 88.981226321,
		"h": 1.5274725275
	},
	{
		"stop_id": 8573398,
		"ID": 1221,
		"x": 65.9897057753,
		"y": 90.754240512,
		"h": 1.5274725275
	},
	{
		"stop_id": 8573399,
		"ID": 1221,
		"x": 64.4217669983,
		"y": 90.173181703,
		"h": 1.5274725275
	},
	{
		"stop_id": 8581810,
		"ID": 1221,
		"x": 64.7717084773,
		"y": 93.064159991,
		"h": 1.5274725275
	},
	{
		"stop_id": 8581971,
		"ID": 1221,
		"x": 61.8357289333,
		"y": 92.591173477,
		"h": 1.5274725275
	},
	{
		"stop_id": 8506105,
		"ID": 1220,
		"x": 65.7507553243,
		"y": 87.154233897,
		"h": 1.9230769231
	},
	{
		"stop_id": 8506184,
		"ID": 1220,
		"x": 63.0337602483,
		"y": 83.416173773,
		"h": 1.9230769231
	},
	{
		"stop_id": 8506185,
		"ID": 1220,
		"x": 62.4537125373,
		"y": 85.510169135,
		"h": 1.9230769231
	},
	{
		"stop_id": 8506190,
		"ID": 1220,
		"x": 64.1037006653,
		"y": 85.99118261,
		"h": 1.9230769231
	},
	{
		"stop_id": 8506551,
		"ID": 1220,
		"x": 61.9787093273,
		"y": 87.401204915,
		"h": 1.9230769231
	},
	{
		"stop_id": 8506553,
		"ID": 1220,
		"x": 65.4657113183,
		"y": 85.269219776,
		"h": 1.9230769231
	},
	{
		"stop_id": 8506741,
		"ID": 1220,
		"x": 64.1577521923,
		"y": 83.576215343,
		"h": 1.9230769231
	},
	{
		"stop_id": 8506742,
		"ID": 1220,
		"x": 64.2077263783,
		"y": 84.055144588,
		"h": 1.9230769231
	},
	{
		"stop_id": 8506854,
		"ID": 1220,
		"x": 61.3157674563,
		"y": 86.469176047,
		"h": 1.9230769231
	},
	{
		"stop_id": 8573286,
		"ID": 1220,
		"x": 65.7227535903,
		"y": 87.193230941,
		"h": 1.9230769231
	},
	{
		"stop_id": 8573370,
		"ID": 1220,
		"x": 60.8947153533,
		"y": 85.833208262,
		"h": 1.9230769231
	},
	{
		"stop_id": 8573371,
		"ID": 1220,
		"x": 62.0687103273,
		"y": 87.482245473,
		"h": 1.9230769231
	},
	{
		"stop_id": 8573372,
		"ID": 1220,
		"x": 63.5707747273,
		"y": 88.098200155,
		"h": 1.9230769231
	},
	{
		"stop_id": 8573373,
		"ID": 1220,
		"x": 65.1267244773,
		"y": 87.693177909,
		"h": 1.9230769231
	},
	{
		"stop_id": 8573400,
		"ID": 1220,
		"x": 65.7247277793,
		"y": 87.610216225,
		"h": 1.9230769231
	},
	{
		"stop_id": 8573612,
		"ID": 1220,
		"x": 65.6977248023,
		"y": 86.281186687,
		"h": 1.9230769231
	},
	{
		"stop_id": 8573613,
		"ID": 1220,
		"x": 65.2437229403,
		"y": 87.02314144,
		"h": 1.9230769231
	},
	{
		"stop_id": 8580250,
		"ID": 1220,
		"x": 66.0687586403,
		"y": 87.183246735,
		"h": 1.9230769231
	},
	{
		"stop_id": 8580601,
		"ID": 1220,
		"x": 61.8287241393,
		"y": 87.232183845,
		"h": 1.9230769231
	},
	{
		"stop_id": 8581619,
		"ID": 1220,
		"x": 64.7777356403,
		"y": 88.677170018,
		"h": 1.9230769231
	},
	{
		"stop_id": 8582159,
		"ID": 1220,
		"x": 64.3447445363,
		"y": 86.11023811,
		"h": 1.9230769231
	},
	{
		"stop_id": 8582599,
		"ID": 1220,
		"x": 63.7817243173,
		"y": 85.983213467,
		"h": 1.9230769231
	},
	{
		"stop_id": 8582600,
		"ID": 1220,
		"x": 64.0087697363,
		"y": 86.156234347,
		"h": 1.9230769231
	},
	{
		"stop_id": 8582604,
		"ID": 1220,
		"x": 64.3157266273,
		"y": 85.155195448,
		"h": 1.9230769231
	},
	{
		"stop_id": 8582806,
		"ID": 1220,
		"x": 65.5037422183,
		"y": 88.004226769,
		"h": 1.9230769231
	},
	{
		"stop_id": 8582807,
		"ID": 1220,
		"x": 64.2777644863,
		"y": 83.352194401,
		"h": 1.9230769231
	},
	{
		"stop_id": 8582808,
		"ID": 1220,
		"x": 62.9507590173,
		"y": 88.701179245,
		"h": 1.9230769231
	},
	{
		"stop_id": 8583488,
		"ID": 1220,
		"x": 61.3607038903,
		"y": 86.704200153,
		"h": 1.9230769231
	},
	{
		"stop_id": 8594772,
		"ID": 1220,
		"x": 64.0807424093,
		"y": 86.138169988,
		"h": 1.9230769231
	},
	{
		"stop_id": 8506106,
		"ID": 1252,
		"x": 69.0657439303,
		"y": 85.321194929,
		"h": 1.4615384615
	},
	{
		"stop_id": 8506555,
		"ID": 1252,
		"x": 70.1597148193,
		"y": 82.853166517,
		"h": 1.4615384615
	},
	{
		"stop_id": 8506574,
		"ID": 1252,
		"x": 69.1057726503,
		"y": 82.623222899,
		"h": 1.4615384615
	},
	{
		"stop_id": 8506575,
		"ID": 1252,
		"x": 68.4547681473,
		"y": 81.658180898,
		"h": 1.4615384615
	},
	{
		"stop_id": 8506658,
		"ID": 1252,
		"x": 66.9127528353,
		"y": 80.793160757,
		"h": 1.4615384615
	},
	{
		"stop_id": 8506662,
		"ID": 1252,
		"x": 67.1387180973,
		"y": 83.228238007,
		"h": 1.4615384615
	},
	{
		"stop_id": 8573290,
		"ID": 1252,
		"x": 69.0577155723,
		"y": 85.230157051,
		"h": 1.4615384615
	},
	{
		"stop_id": 8573293,
		"ID": 1252,
		"x": 69.5837718093,
		"y": 82.405234994,
		"h": 1.4615384615
	},
	{
		"stop_id": 8573294,
		"ID": 1252,
		"x": 68.7917650893,
		"y": 81.932193775,
		"h": 1.4615384615
	},
	{
		"stop_id": 8573608,
		"ID": 1252,
		"x": 66.8617481683,
		"y": 81.218234556,
		"h": 1.4615384615
	},
	{
		"stop_id": 8573609,
		"ID": 1252,
		"x": 66.9827163763,
		"y": 83.555193009,
		"h": 1.4615384615
	},
	{
		"stop_id": 8573610,
		"ID": 1252,
		"x": 66.5827107353,
		"y": 84.530196876,
		"h": 1.4615384615
	},
	{
		"stop_id": 8581618,
		"ID": 1252,
		"x": 68.3017102493,
		"y": 81.83024524,
		"h": 1.4615384615
	},
	{
		"stop_id": 8581621,
		"ID": 1252,
		"x": 70.1637013173,
		"y": 82.610250268,
		"h": 1.4615384615
	},
	{
		"stop_id": 8582601,
		"ID": 1252,
		"x": 66.6737545383,
		"y": 81.690199663,
		"h": 1.4615384615
	},
	{
		"stop_id": 8506107,
		"ID": 1283,
		"x": 74.8047006673,
		"y": 85.71122178,
		"h": 1.4615384615
	},
	{
		"stop_id": 8506217,
		"ID": 1283,
		"x": 71.6367335043,
		"y": 84.232210535,
		"h": 1.4615384615
	},
	{
		"stop_id": 8506610,
		"ID": 1283,
		"x": 74.5347106503,
		"y": 88.622213414,
		"h": 1.4615384615
	},
	{
		"stop_id": 8506612,
		"ID": 1283,
		"x": 71.7927220623,
		"y": 86.553207509,
		"h": 1.4615384615
	},
	{
		"stop_id": 8506613,
		"ID": 1283,
		"x": 73.5057709033,
		"y": 88.75014493,
		"h": 1.4615384615
	},
	{
		"stop_id": 8573422,
		"ID": 1283,
		"x": 73.2467753923,
		"y": 88.595158386,
		"h": 1.4615384615
	},
	{
		"stop_id": 8573425,
		"ID": 1283,
		"x": 71.6077662013,
		"y": 84.180184456,
		"h": 1.4615384615
	},
	{
		"stop_id": 8581620,
		"ID": 1283,
		"x": 70.9397161393,
		"y": 86.539154591,
		"h": 1.4615384615
	},
	{
		"stop_id": 8582166,
		"ID": 1283,
		"x": 75.7907031023,
		"y": 87.143246011,
		"h": 1.4615384615
	},
	{
		"stop_id": 8582176,
		"ID": 1283,
		"x": 73.9137692163,
		"y": 88.047242071,
		"h": 1.4615384615
	},
	{
		"stop_id": 8582177,
		"ID": 1283,
		"x": 73.9367561393,
		"y": 87.421160361,
		"h": 1.4615384615
	},
	{
		"stop_id": 8582178,
		"ID": 1283,
		"x": 73.6057487133,
		"y": 87.34616301,
		"h": 1.4615384615
	},
	{
		"stop_id": 8582179,
		"ID": 1283,
		"x": 72.5377459903,
		"y": 85.96717211,
		"h": 1.4615384615
	},
	{
		"stop_id": 8582456,
		"ID": 1283,
		"x": 76.3697228703,
		"y": 86.422193652,
		"h": 1.4615384615
	},
	{
		"stop_id": 8587166,
		"ID": 1283,
		"x": 74.7947261953,
		"y": 85.815205406,
		"h": 1.4615384615
	},
	{
		"stop_id": 8506108,
		"ID": 1312,
		"x": 78.1667109333,
		"y": 85.98521621,
		"h": 1.4945054945
	},
	{
		"stop_id": 8581678,
		"ID": 1312,
		"x": 79.2017485723,
		"y": 91.620238555,
		"h": 1.4945054945
	},
	{
		"stop_id": 8582161,
		"ID": 1312,
		"x": 81.7817648343,
		"y": 88.592164621,
		"h": 1.4945054945
	},
	{
		"stop_id": 8582162,
		"ID": 1312,
		"x": 80.2377094463,
		"y": 87.240146487,
		"h": 1.4945054945
	},
	{
		"stop_id": 8582165,
		"ID": 1312,
		"x": 76.6977566973,
		"y": 86.428209811,
		"h": 1.4945054945
	},
	{
		"stop_id": 8582167,
		"ID": 1312,
		"x": 78.9667039253,
		"y": 86.616223895,
		"h": 1.4945054945
	},
	{
		"stop_id": 8582168,
		"ID": 1312,
		"x": 78.1297323173,
		"y": 86.64321556,
		"h": 1.4945054945
	},
	{
		"stop_id": 8582169,
		"ID": 1312,
		"x": 77.8787665833,
		"y": 86.619230082,
		"h": 1.4945054945
	},
	{
		"stop_id": 8582170,
		"ID": 1312,
		"x": 77.1237244993,
		"y": 88.804151718,
		"h": 1.4945054945
	},
	{
		"stop_id": 8582171,
		"ID": 1312,
		"x": 76.6527179003,
		"y": 89.389160179,
		"h": 1.4945054945
	},
	{
		"stop_id": 8582191,
		"ID": 1312,
		"x": 76.8977220713,
		"y": 89.100207988,
		"h": 1.4945054945
	},
	{
		"stop_id": 8583839,
		"ID": 1312,
		"x": 78.0897671443,
		"y": 86.0172298,
		"h": 1.4945054945
	},
	{
		"stop_id": 8587144,
		"ID": 1312,
		"x": 79.8567752173,
		"y": 86.36916706,
		"h": 1.4945054945
	},
	{
		"stop_id": 8587190,
		"ID": 1312,
		"x": 77.8397210913,
		"y": 86.563155089,
		"h": 1.4945054945
	},
	{
		"stop_id": 8587215,
		"ID": 1312,
		"x": 79.5787109093,
		"y": 87.53419076,
		"h": 1.4945054945
	},
	{
		"stop_id": 8587216,
		"ID": 1312,
		"x": 79.7237708223,
		"y": 86.852166137,
		"h": 1.4945054945
	},
	{
		"stop_id": 8506109,
		"ID": 1337,
		"x": 80.5287318383,
		"y": 85.732233974,
		"h": 2.1538461538
	},
	{
		"stop_id": 8506397,
		"ID": 1337,
		"x": 84.1637282963,
		"y": 83.716194549,
		"h": 2.1538461538
	},
	{
		"stop_id": 8506398,
		"ID": 1337,
		"x": 86.1007096983,
		"y": 84.571186077,
		"h": 2.1538461538
	},
	{
		"stop_id": 8582472,
		"ID": 1337,
		"x": 86.1667161263,
		"y": 85.03016307,
		"h": 2.1538461538
	},
	{
		"stop_id": 8587135,
		"ID": 1337,
		"x": 82.4827084063,
		"y": 84.460241183,
		"h": 2.1538461538
	},
	{
		"stop_id": 8587137,
		"ID": 1337,
		"x": 85.7457542083,
		"y": 86.343210899,
		"h": 2.1538461538
	},
	{
		"stop_id": 8587138,
		"ID": 1337,
		"x": 80.5277021503,
		"y": 85.712189884,
		"h": 2.1538461538
	},
	{
		"stop_id": 8587141,
		"ID": 1337,
		"x": 80.8887059153,
		"y": 84.987170493,
		"h": 2.1538461538
	},
	{
		"stop_id": 8587147,
		"ID": 1337,
		"x": 80.8077615273,
		"y": 85.559249914,
		"h": 2.1538461538
	},
	{
		"stop_id": 8587160,
		"ID": 1337,
		"x": 86.1857513143,
		"y": 85.704197324,
		"h": 2.1538461538
	},
	{
		"stop_id": 8587162,
		"ID": 1337,
		"x": 86.2277725843,
		"y": 85.381244661,
		"h": 2.1538461538
	},
	{
		"stop_id": 8587172,
		"ID": 1337,
		"x": 80.8807086523,
		"y": 86.685203229,
		"h": 2.1538461538
	},
	{
		"stop_id": 8587173,
		"ID": 1337,
		"x": 81.6107586973,
		"y": 87.433141758,
		"h": 2.1538461538
	},
	{
		"stop_id": 8587174,
		"ID": 1337,
		"x": 81.7027392673,
		"y": 87.964203259,
		"h": 2.1538461538
	},
	{
		"stop_id": 8587175,
		"ID": 1337,
		"x": 82.2767031153,
		"y": 86.386187056,
		"h": 2.1538461538
	},
	{
		"stop_id": 8587176,
		"ID": 1337,
		"x": 81.3707361683,
		"y": 85.857181854,
		"h": 2.1538461538
	},
	{
		"stop_id": 8587177,
		"ID": 1337,
		"x": 81.6877717033,
		"y": 86.066189588,
		"h": 2.1538461538
	},
	{
		"stop_id": 8587178,
		"ID": 1337,
		"x": 81.2837198503,
		"y": 87.088206861,
		"h": 2.1538461538
	},
	{
		"stop_id": 8587186,
		"ID": 1337,
		"x": 85.3377269643,
		"y": 83.570190901,
		"h": 2.1538461538
	},
	{
		"stop_id": 8587198,
		"ID": 1337,
		"x": 84.2307121783,
		"y": 87.047247854,
		"h": 2.1538461538
	},
	{
		"stop_id": 8587199,
		"ID": 1337,
		"x": 85.5017673763,
		"y": 86.880191518,
		"h": 2.1538461538
	},
	{
		"stop_id": 8587200,
		"ID": 1337,
		"x": 85.3287558643,
		"y": 88.295141917,
		"h": 2.1538461538
	},
	{
		"stop_id": 8587201,
		"ID": 1337,
		"x": 84.9277587063,
		"y": 87.388173049,
		"h": 2.1538461538
	},
	{
		"stop_id": 8587202,
		"ID": 1337,
		"x": 85.2457563053,
		"y": 87.565146851,
		"h": 2.1538461538
	},
	{
		"stop_id": 8587203,
		"ID": 1337,
		"x": 83.0517709223,
		"y": 86.472175009,
		"h": 2.1538461538
	},
	{
		"stop_id": 8587204,
		"ID": 1337,
		"x": 85.6527689643,
		"y": 87.15918612,
		"h": 2.1538461538
	},
	{
		"stop_id": 8587205,
		"ID": 1337,
		"x": 83.7127440563,
		"y": 86.794173456,
		"h": 2.1538461538
	},
	{
		"stop_id": 8587206,
		"ID": 1337,
		"x": 85.2857422513,
		"y": 88.030151944,
		"h": 2.1538461538
	},
	{
		"stop_id": 8587207,
		"ID": 1337,
		"x": 85.9397448893,
		"y": 86.250230651,
		"h": 2.1538461538
	},
	{
		"stop_id": 8587208,
		"ID": 1337,
		"x": 85.9477399033,
		"y": 86.04221901,
		"h": 2.1538461538
	},
	{
		"stop_id": 8587217,
		"ID": 1337,
		"x": 83.6637689323,
		"y": 83.990203702,
		"h": 2.1538461538
	},
	{
		"stop_id": 8587218,
		"ID": 1337,
		"x": 84.7797183933,
		"y": 83.840234356,
		"h": 2.1538461538
	},
	{
		"stop_id": 8587219,
		"ID": 1337,
		"x": 84.0577523363,
		"y": 83.957187052,
		"h": 2.1538461538
	},
	{
		"stop_id": 8589066,
		"ID": 1337,
		"x": 86.1507718353,
		"y": 84.578206391,
		"h": 2.1538461538
	},
	{
		"stop_id": 8594858,
		"ID": 1337,
		"x": 85.6667599333,
		"y": 86.478179565,
		"h": 2.1538461538
	},
	{
		"stop_id": 8595456,
		"ID": 1337,
		"x": 80.8777604283,
		"y": 85.105247911,
		"h": 2.1538461538
	},
	{
		"stop_id": 8506110,
		"ID": 1359,
		"x": 91.0287000763,
		"y": 81.786235835,
		"h": 2.0549450549
	},
	{
		"stop_id": 8506255,
		"ID": 1359,
		"x": 89.7457384413,
		"y": 81.4402044,
		"h": 2.0549450549
	},
	{
		"stop_id": 8506256,
		"ID": 1359,
		"x": 88.6907331633,
		"y": 81.035224709,
		"h": 2.0549450549
	},
	{
		"stop_id": 8506308,
		"ID": 1359,
		"x": 90.5087328083,
		"y": 81.544201498,
		"h": 2.0549450549
	},
	{
		"stop_id": 8506309,
		"ID": 1359,
		"x": 86.6257711443,
		"y": 85.162202299,
		"h": 2.0549450549
	},
	{
		"stop_id": 8506694,
		"ID": 1359,
		"x": 87.9197174243,
		"y": 80.570238914,
		"h": 2.0549450549
	},
	{
		"stop_id": 8516270,
		"ID": 1359,
		"x": 89.7967215363,
		"y": 82.742248106,
		"h": 2.0549450549
	},
	{
		"stop_id": 8557031,
		"ID": 1359,
		"x": 89.6777674623,
		"y": 80.239172346,
		"h": 2.0549450549
	},
	{
		"stop_id": 8574244,
		"ID": 1359,
		"x": 87.6707222633,
		"y": 80.240144653,
		"h": 2.0549450549
	},
	{
		"stop_id": 8574245,
		"ID": 1359,
		"x": 88.2787118313,
		"y": 80.804223298,
		"h": 2.0549450549
	},
	{
		"stop_id": 8574246,
		"ID": 1359,
		"x": 89.2257360813,
		"y": 81.259234324,
		"h": 2.0549450549
	},
	{
		"stop_id": 8574247,
		"ID": 1359,
		"x": 89.8267375633,
		"y": 82.122160387,
		"h": 2.0549450549
	},
	{
		"stop_id": 8574248,
		"ID": 1359,
		"x": 89.8687317013,
		"y": 82.469239064,
		"h": 2.0549450549
	},
	{
		"stop_id": 8574249,
		"ID": 1359,
		"x": 90.3397315843,
		"y": 82.243169983,
		"h": 2.0549450549
	},
	{
		"stop_id": 8574251,
		"ID": 1359,
		"x": 90.5137127583,
		"y": 81.606168251,
		"h": 2.0549450549
	},
	{
		"stop_id": 8580870,
		"ID": 1359,
		"x": 90.0447319393,
		"y": 81.016233141,
		"h": 2.0549450549
	},
	{
		"stop_id": 8580919,
		"ID": 1359,
		"x": 90.1517407613,
		"y": 81.542250889,
		"h": 2.0549450549
	},
	{
		"stop_id": 8587136,
		"ID": 1359,
		"x": 88.2077311903,
		"y": 83.520162724,
		"h": 2.0549450549
	},
	{
		"stop_id": 8587152,
		"ID": 1359,
		"x": 89.0877470833,
		"y": 82.641145818,
		"h": 2.0549450549
	},
	{
		"stop_id": 8587153,
		"ID": 1359,
		"x": 89.4607042543,
		"y": 82.542224098,
		"h": 2.0549450549
	},
	{
		"stop_id": 8587154,
		"ID": 1359,
		"x": 89.9007316343,
		"y": 81.643217378,
		"h": 2.0549450549
	},
	{
		"stop_id": 8587158,
		"ID": 1359,
		"x": 86.5857316143,
		"y": 85.161209788,
		"h": 2.0549450549
	},
	{
		"stop_id": 8587159,
		"ID": 1359,
		"x": 86.9707723283,
		"y": 84.525228842,
		"h": 2.0549450549
	},
	{
		"stop_id": 8587161,
		"ID": 1359,
		"x": 86.3677393403,
		"y": 84.880201523,
		"h": 2.0549450549
	},
	{
		"stop_id": 8587163,
		"ID": 1359,
		"x": 87.8507472243,
		"y": 84.014179325,
		"h": 2.0549450549
	},
	{
		"stop_id": 8587167,
		"ID": 1359,
		"x": 88.8917739713,
		"y": 82.797150398,
		"h": 2.0549450549
	},
	{
		"stop_id": 8587168,
		"ID": 1359,
		"x": 88.6057054273,
		"y": 83.124182782,
		"h": 2.0549450549
	},
	{
		"stop_id": 8587169,
		"ID": 1359,
		"x": 88.2177006663,
		"y": 83.567237303,
		"h": 2.0549450549
	},
	{
		"stop_id": 8587185,
		"ID": 1359,
		"x": 85.7277343383,
		"y": 83.535185111,
		"h": 2.0549450549
	},
	{
		"stop_id": 8587187,
		"ID": 1359,
		"x": 86.2107355793,
		"y": 83.26115113,
		"h": 2.0549450549
	},
	{
		"stop_id": 8587193,
		"ID": 1359,
		"x": 87.1307535093,
		"y": 83.074194512,
		"h": 2.0549450549
	},
	{
		"stop_id": 8587220,
		"ID": 1359,
		"x": 88.6877283213,
		"y": 82.666226103,
		"h": 2.0549450549
	},
	{
		"stop_id": 8587221,
		"ID": 1359,
		"x": 88.2907320913,
		"y": 82.736231833,
		"h": 2.0549450549
	},
	{
		"stop_id": 8506111,
		"ID": 1383,
		"x": 92.7787655393,
		"y": 80.05124382,
		"h": 2.3516483516
	},
	{
		"stop_id": 8506113,
		"ID": 1383,
		"x": 95.0567480363,
		"y": 78.138249092,
		"h": 2.3516483516
	},
	{
		"stop_id": 8506264,
		"ID": 1383,
		"x": 91.1767254773,
		"y": 80.655203647,
		"h": 2.3516483516
	},
	{
		"stop_id": 8506305,
		"ID": 1383,
		"x": 93.1487513403,
		"y": 77.520239359,
		"h": 2.3516483516
	},
	{
		"stop_id": 8506306,
		"ID": 1383,
		"x": 95.0877246893,
		"y": 78.104247252,
		"h": 2.3516483516
	},
	{
		"stop_id": 8506307,
		"ID": 1383,
		"x": 92.8207169723,
		"y": 79.667159234,
		"h": 2.3516483516
	},
	{
		"stop_id": 8506322,
		"ID": 1383,
		"x": 94.8567247033,
		"y": 77.748179182,
		"h": 2.3516483516
	},
	{
		"stop_id": 8506877,
		"ID": 1383,
		"x": 93.0447525623,
		"y": 77.570159003,
		"h": 2.3516483516
	},
	{
		"stop_id": 8516271,
		"ID": 1383,
		"x": 91.1977011353,
		"y": 80.480229339,
		"h": 2.3516483516
	},
	{
		"stop_id": 8574265,
		"ID": 1383,
		"x": 92.7487072123,
		"y": 77.245196374,
		"h": 2.3516483516
	},
	{
		"stop_id": 8574266,
		"ID": 1383,
		"x": 93.3047018473,
		"y": 77.785204219,
		"h": 2.3516483516
	},
	{
		"stop_id": 8574267,
		"ID": 1383,
		"x": 93.5867575133,
		"y": 78.025192798,
		"h": 2.3516483516
	},
	{
		"stop_id": 8574268,
		"ID": 1383,
		"x": 93.7777365323,
		"y": 78.049168989,
		"h": 2.3516483516
	},
	{
		"stop_id": 8574269,
		"ID": 1383,
		"x": 93.9347096473,
		"y": 78.070153941,
		"h": 2.3516483516
	},
	{
		"stop_id": 8574270,
		"ID": 1383,
		"x": 94.2007566283,
		"y": 78.072182918,
		"h": 2.3516483516
	},
	{
		"stop_id": 8574271,
		"ID": 1383,
		"x": 94.4657546793,
		"y": 78.068190417,
		"h": 2.3516483516
	},
	{
		"stop_id": 8574272,
		"ID": 1383,
		"x": 95.0237607263,
		"y": 77.981226657,
		"h": 2.3516483516
	},
	{
		"stop_id": 8574276,
		"ID": 1383,
		"x": 92.4507478263,
		"y": 79.491229127,
		"h": 2.3516483516
	},
	{
		"stop_id": 8574277,
		"ID": 1383,
		"x": 92.7757647173,
		"y": 79.703147549,
		"h": 2.3516483516
	},
	{
		"stop_id": 8574278,
		"ID": 1383,
		"x": 92.5057271123,
		"y": 80.046204593,
		"h": 2.3516483516
	},
	{
		"stop_id": 8574279,
		"ID": 1383,
		"x": 91.9987312893,
		"y": 80.152172416,
		"h": 2.3516483516
	},
	{
		"stop_id": 8574280,
		"ID": 1383,
		"x": 95.0797442143,
		"y": 77.617210535,
		"h": 2.3516483516
	},
	{
		"stop_id": 8574283,
		"ID": 1383,
		"x": 94.6857390143,
		"y": 77.452192351,
		"h": 2.3516483516
	},
	{
		"stop_id": 8580213,
		"ID": 1383,
		"x": 93.0197579963,
		"y": 77.76115026,
		"h": 2.3516483516
	},
	{
		"stop_id": 8580682,
		"ID": 1383,
		"x": 94.7147516623,
		"y": 78.131193364,
		"h": 2.3516483516
	},
	{
		"stop_id": 8580684,
		"ID": 1383,
		"x": 93.4157077773,
		"y": 78.070141492,
		"h": 2.3516483516
	},
	{
		"stop_id": 8580685,
		"ID": 1383,
		"x": 92.7917684243,
		"y": 77.923209519,
		"h": 2.3516483516
	},
	{
		"stop_id": 8580718,
		"ID": 1383,
		"x": 93.2337501573,
		"y": 77.473166499,
		"h": 2.3516483516
	},
	{
		"stop_id": 8580865,
		"ID": 1383,
		"x": 91.9187158723,
		"y": 77.477210253,
		"h": 2.3516483516
	},
	{
		"stop_id": 8580866,
		"ID": 1383,
		"x": 92.1707635143,
		"y": 78.761186255,
		"h": 2.3516483516
	},
	{
		"stop_id": 8580867,
		"ID": 1383,
		"x": 92.0267271633,
		"y": 78.915199946,
		"h": 2.3516483516
	},
	{
		"stop_id": 8580868,
		"ID": 1383,
		"x": 90.7567238873,
		"y": 79.553172641,
		"h": 2.3516483516
	},
	{
		"stop_id": 8580869,
		"ID": 1383,
		"x": 91.0577227173,
		"y": 80.33017441,
		"h": 2.3516483516
	},
	{
		"stop_id": 8581481,
		"ID": 1383,
		"x": 94.9407383193,
		"y": 77.78819314,
		"h": 2.3516483516
	},
	{
		"stop_id": 8583788,
		"ID": 1383,
		"x": 91.5697143643,
		"y": 80.575163961,
		"h": 2.3516483516
	},
	{
		"stop_id": 8591809,
		"ID": 1383,
		"x": 95.5257414393,
		"y": 77.843237244,
		"h": 2.3516483516
	},
	{
		"stop_id": 8591811,
		"ID": 1383,
		"x": 93.8557292443,
		"y": 78.373187394,
		"h": 2.3516483516
	},
	{
		"stop_id": 8591816,
		"ID": 1383,
		"x": 94.8007252593,
		"y": 78.093177457,
		"h": 2.3516483516
	},
	{
		"stop_id": 8594859,
		"ID": 1383,
		"x": 91.0187705333,
		"y": 80.740149594,
		"h": 2.3516483516
	},
	{
		"stop_id": 8595413,
		"ID": 1383,
		"x": 95.2657272523,
		"y": 77.990236262,
		"h": 2.3516483516
	},
	{
		"stop_id": 8595441,
		"ID": 1383,
		"x": 93.1197526373,
		"y": 78.02922478,
		"h": 2.3516483516
	},
	{
		"stop_id": 8595442,
		"ID": 1383,
		"x": 95.3587554253,
		"y": 77.646213202,
		"h": 2.3516483516
	},
	{
		"stop_id": 8506112,
		"ID": 1360,
		"x": 86.3387543143,
		"y": 87.554173681,
		"h": 1.1978021978
	},
	{
		"stop_id": 8506121,
		"ID": 1360,
		"x": 86.2927335083,
		"y": 87.54914188,
		"h": 1.1978021978
	},
	{
		"stop_id": 8506346,
		"ID": 1360,
		"x": 86.4257173063,
		"y": 87.45622581,
		"h": 1.1978021978
	},
	{
		"stop_id": 8587194,
		"ID": 1360,
		"x": 86.0547161933,
		"y": 87.975248524,
		"h": 1.1978021978
	},
	{
		"stop_id": 8587195,
		"ID": 1360,
		"x": 86.2677098473,
		"y": 87.46521639,
		"h": 1.1978021978
	},
	{
		"stop_id": 8587196,
		"ID": 1360,
		"x": 85.7327567463,
		"y": 88.15315696,
		"h": 1.1978021978
	},
	{
		"stop_id": 8587197,
		"ID": 1360,
		"x": 86.1127150333,
		"y": 87.340150359,
		"h": 1.1978021978
	},
	{
		"stop_id": 8506118,
		"ID": 1222,
		"x": 65.7027143323,
		"y": 97.905179296,
		"h": 1.5274725275
	},
	{
		"stop_id": 8506133,
		"ID": 1222,
		"x": 63.9517191133,
		"y": 98.657248141,
		"h": 1.5274725275
	},
	{
		"stop_id": 8506134,
		"ID": 1222,
		"x": 61.4747617973,
		"y": 99.012145629,
		"h": 1.5274725275
	},
	{
		"stop_id": 8506162,
		"ID": 1222,
		"x": 63.9237243353,
		"y": 99.239222016,
		"h": 1.5274725275
	},
	{
		"stop_id": 8506568,
		"ID": 1222,
		"x": 64.7537023433,
		"y": 94.739147397,
		"h": 1.5274725275
	},
	{
		"stop_id": 8506707,
		"ID": 1222,
		"x": 61.6727691623,
		"y": 95.070144137,
		"h": 1.5274725275
	},
	{
		"stop_id": 8506985,
		"ID": 1222,
		"x": 62.6307403403,
		"y": 97.732243908,
		"h": 1.5274725275
	},
	{
		"stop_id": 8506986,
		"ID": 1222,
		"x": 62.5877619783,
		"y": 95.466197371,
		"h": 1.5274725275
	},
	{
		"stop_id": 8573352,
		"ID": 1222,
		"x": 62.4157062293,
		"y": 97.27924261,
		"h": 1.5274725275
	},
	{
		"stop_id": 8573353,
		"ID": 1222,
		"x": 63.2677048173,
		"y": 98.327177162,
		"h": 1.5274725275
	},
	{
		"stop_id": 8573354,
		"ID": 1222,
		"x": 63.5587059233,
		"y": 98.433245682,
		"h": 1.5274725275
	},
	{
		"stop_id": 8573355,
		"ID": 1222,
		"x": 63.9477661703,
		"y": 98.645153569,
		"h": 1.5274725275
	},
	{
		"stop_id": 8573380,
		"ID": 1222,
		"x": 65.7577702603,
		"y": 97.680244451,
		"h": 1.5274725275
	},
	{
		"stop_id": 8581945,
		"ID": 1222,
		"x": 61.9447212693,
		"y": 98.498223679,
		"h": 1.5274725275
	},
	{
		"stop_id": 8581947,
		"ID": 1222,
		"x": 62.0207326623,
		"y": 98.804196558,
		"h": 1.5274725275
	},
	{
		"stop_id": 8581969,
		"ID": 1222,
		"x": 62.8447470123,
		"y": 98.536236089,
		"h": 1.5274725275
	},
	{
		"stop_id": 8581970,
		"ID": 1222,
		"x": 63.5617354673,
		"y": 98.579227131,
		"h": 1.5274725275
	},
	{
		"stop_id": 8506122,
		"ID": 1338,
		"x": 83.2527466973,
		"y": 89.754203959,
		"h": 1.0659340659
	},
	{
		"stop_id": 8506123,
		"ID": 1338,
		"x": 81.5517443203,
		"y": 90.76716095,
		"h": 1.0659340659
	},
	{
		"stop_id": 8530835,
		"ID": 1338,
		"x": 83.6777398103,
		"y": 89.810233463,
		"h": 1.0659340659
	},
	{
		"stop_id": 8506124,
		"ID": 1313,
		"x": 79.6237691663,
		"y": 92.195204594,
		"h": 1.5604395604
	},
	{
		"stop_id": 8506125,
		"ID": 1313,
		"x": 77.6117196653,
		"y": 93.551167283,
		"h": 1.5604395604
	},
	{
		"stop_id": 8506143,
		"ID": 1313,
		"x": 75.3457638273,
		"y": 94.687208584,
		"h": 1.5604395604
	},
	{
		"stop_id": 8530834,
		"ID": 1313,
		"x": 77.8467303333,
		"y": 93.75317646,
		"h": 1.5604395604
	},
	{
		"stop_id": 8573413,
		"ID": 1313,
		"x": 75.3697346003,
		"y": 94.576203021,
		"h": 1.5604395604
	},
	{
		"stop_id": 8573426,
		"ID": 1313,
		"x": 76.0947346953,
		"y": 94.177230862,
		"h": 1.5604395604
	},
	{
		"stop_id": 8573427,
		"ID": 1313,
		"x": 76.3667414853,
		"y": 94.077177176,
		"h": 1.5604395604
	},
	{
		"stop_id": 8573428,
		"ID": 1313,
		"x": 77.5797426763,
		"y": 93.21620097,
		"h": 1.5604395604
	},
	{
		"stop_id": 8573429,
		"ID": 1313,
		"x": 77.2517615473,
		"y": 92.884249209,
		"h": 1.5604395604
	},
	{
		"stop_id": 8573430,
		"ID": 1313,
		"x": 77.0777357113,
		"y": 92.505170303,
		"h": 1.5604395604
	},
	{
		"stop_id": 8573431,
		"ID": 1313,
		"x": 77.0207574073,
		"y": 92.027154934,
		"h": 1.5604395604
	},
	{
		"stop_id": 8573432,
		"ID": 1313,
		"x": 77.2697001333,
		"y": 92.222231923,
		"h": 1.5604395604
	},
	{
		"stop_id": 8581675,
		"ID": 1313,
		"x": 76.8487536313,
		"y": 92.481176528,
		"h": 1.5604395604
	},
	{
		"stop_id": 8581676,
		"ID": 1313,
		"x": 77.4297460913,
		"y": 92.536148911,
		"h": 1.5604395604
	},
	{
		"stop_id": 8581677,
		"ID": 1313,
		"x": 77.4807453253,
		"y": 93.043170859,
		"h": 1.5604395604
	},
	{
		"stop_id": 8581706,
		"ID": 1313,
		"x": 77.6237725993,
		"y": 93.521195761,
		"h": 1.5604395604
	},
	{
		"stop_id": 8588122,
		"ID": 1313,
		"x": 76.1677735003,
		"y": 94.355200421,
		"h": 1.5604395604
	},
	{
		"stop_id": 8595982,
		"ID": 1313,
		"x": 79.8977466693,
		"y": 92.660144845,
		"h": 1.5604395604
	},
	{
		"stop_id": 8506131,
		"ID": 1254,
		"x": 70.2577653713,
		"y": 96.853247261,
		"h": 2.9120879121
	},
	{
		"stop_id": 8506195,
		"ID": 1254,
		"x": 70.2977178173,
		"y": 92.223186343,
		"h": 2.9120879121
	},
	{
		"stop_id": 8506197,
		"ID": 1254,
		"x": 69.8417631393,
		"y": 95.683173391,
		"h": 2.9120879121
	},
	{
		"stop_id": 8506198,
		"ID": 1254,
		"x": 68.0377608353,
		"y": 96.934146173,
		"h": 2.9120879121
	},
	{
		"stop_id": 8506554,
		"ID": 1254,
		"x": 69.2567684983,
		"y": 92.030160404,
		"h": 2.9120879121
	},
	{
		"stop_id": 8506557,
		"ID": 1254,
		"x": 67.8647123473,
		"y": 92.457199745,
		"h": 2.9120879121
	},
	{
		"stop_id": 8506559,
		"ID": 1254,
		"x": 67.7427688243,
		"y": 93.297145509,
		"h": 2.9120879121
	},
	{
		"stop_id": 8573376,
		"ID": 1254,
		"x": 70.3047707163,
		"y": 96.83115073,
		"h": 2.9120879121
	},
	{
		"stop_id": 8573377,
		"ID": 1254,
		"x": 69.6617419253,
		"y": 96.395248887,
		"h": 2.9120879121
	},
	{
		"stop_id": 8573378,
		"ID": 1254,
		"x": 67.7577013283,
		"y": 97.034182504,
		"h": 2.9120879121
	},
	{
		"stop_id": 8573379,
		"ID": 1254,
		"x": 67.1517737433,
		"y": 97.29014074,
		"h": 2.9120879121
	},
	{
		"stop_id": 8573390,
		"ID": 1254,
		"x": 70.3287256593,
		"y": 95.766193325,
		"h": 2.9120879121
	},
	{
		"stop_id": 8573391,
		"ID": 1254,
		"x": 70.0897473323,
		"y": 95.556168742,
		"h": 2.9120879121
	},
	{
		"stop_id": 8573392,
		"ID": 1254,
		"x": 69.3597616473,
		"y": 95.11916896,
		"h": 2.9120879121
	},
	{
		"stop_id": 8573394,
		"ID": 1254,
		"x": 68.2017060573,
		"y": 93.649192792,
		"h": 2.9120879121
	},
	{
		"stop_id": 8573395,
		"ID": 1254,
		"x": 67.6637126563,
		"y": 92.999153205,
		"h": 2.9120879121
	},
	{
		"stop_id": 8573401,
		"ID": 1254,
		"x": 69.8487167153,
		"y": 96.317166396,
		"h": 2.9120879121
	},
	{
		"stop_id": 8573402,
		"ID": 1254,
		"x": 70.3687258593,
		"y": 96.276240315,
		"h": 2.9120879121
	},
	{
		"stop_id": 8573403,
		"ID": 1254,
		"x": 70.6067223353,
		"y": 96.318202463,
		"h": 2.9120879121
	},
	{
		"stop_id": 8573404,
		"ID": 1254,
		"x": 70.7697605843,
		"y": 96.283217722,
		"h": 2.9120879121
	},
	{
		"stop_id": 8573405,
		"ID": 1254,
		"x": 71.0297440323,
		"y": 96.025167338,
		"h": 2.9120879121
	},
	{
		"stop_id": 8580245,
		"ID": 1254,
		"x": 70.4917214103,
		"y": 95.97521583,
		"h": 2.9120879121
	},
	{
		"stop_id": 8580246,
		"ID": 1254,
		"x": 70.7177279633,
		"y": 96.077198405,
		"h": 2.9120879121
	},
	{
		"stop_id": 8581680,
		"ID": 1254,
		"x": 71.2047276413,
		"y": 95.737211492,
		"h": 2.9120879121
	},
	{
		"stop_id": 8581681,
		"ID": 1254,
		"x": 71.2867397753,
		"y": 95.385243624,
		"h": 2.9120879121
	},
	{
		"stop_id": 8581682,
		"ID": 1254,
		"x": 71.3497325883,
		"y": 95.020175033,
		"h": 2.9120879121
	},
	{
		"stop_id": 8581690,
		"ID": 1254,
		"x": 70.0307227563,
		"y": 96.277239909,
		"h": 2.9120879121
	},
	{
		"stop_id": 8581692,
		"ID": 1254,
		"x": 68.4317171683,
		"y": 96.853171082,
		"h": 2.9120879121
	},
	{
		"stop_id": 8581693,
		"ID": 1254,
		"x": 67.3457510653,
		"y": 97.149180775,
		"h": 2.9120879121
	},
	{
		"stop_id": 8581698,
		"ID": 1254,
		"x": 70.6867021293,
		"y": 96.511159387,
		"h": 2.9120879121
	},
	{
		"stop_id": 8581809,
		"ID": 1254,
		"x": 69.8147486003,
		"y": 95.722173579,
		"h": 2.9120879121
	},
	{
		"stop_id": 8581885,
		"ID": 1254,
		"x": 70.5457201923,
		"y": 96.56520768,
		"h": 2.9120879121
	},
	{
		"stop_id": 8581886,
		"ID": 1254,
		"x": 70.1407545543,
		"y": 96.560160412,
		"h": 2.9120879121
	},
	{
		"stop_id": 8581996,
		"ID": 1254,
		"x": 69.9577188783,
		"y": 96.64721791,
		"h": 2.9120879121
	},
	{
		"stop_id": 8582495,
		"ID": 1254,
		"x": 67.3407460023,
		"y": 96.949212404,
		"h": 2.9120879121
	},
	{
		"stop_id": 8582498,
		"ID": 1254,
		"x": 68.0497435373,
		"y": 96.967215698,
		"h": 2.9120879121
	},
	{
		"stop_id": 8594582,
		"ID": 1254,
		"x": 69.1587126803,
		"y": 96.200156039,
		"h": 2.9120879121
	},
	{
		"stop_id": 8594583,
		"ID": 1254,
		"x": 69.5367680433,
		"y": 96.237243383,
		"h": 2.9120879121
	},
	{
		"stop_id": 8594584,
		"ID": 1254,
		"x": 69.3677499073,
		"y": 96.041239612,
		"h": 2.9120879121
	},
	{
		"stop_id": 8594585,
		"ID": 1254,
		"x": 69.1777507653,
		"y": 96.405216152,
		"h": 2.9120879121
	},
	{
		"stop_id": 8594586,
		"ID": 1254,
		"x": 67.2727310753,
		"y": 96.64623171,
		"h": 2.9120879121
	},
	{
		"stop_id": 8594895,
		"ID": 1254,
		"x": 71.1207457823,
		"y": 95.799186359,
		"h": 2.9120879121
	},
	{
		"stop_id": 8594896,
		"ID": 1254,
		"x": 70.8557665433,
		"y": 95.902192737,
		"h": 2.9120879121
	},
	{
		"stop_id": 8594897,
		"ID": 1254,
		"x": 70.7537438353,
		"y": 95.574169967,
		"h": 2.9120879121
	},
	{
		"stop_id": 8594898,
		"ID": 1254,
		"x": 70.9337249463,
		"y": 95.342149484,
		"h": 2.9120879121
	},
	{
		"stop_id": 8594899,
		"ID": 1254,
		"x": 71.3567166243,
		"y": 95.392249509,
		"h": 2.9120879121
	},
	{
		"stop_id": 8594901,
		"ID": 1254,
		"x": 69.5947732703,
		"y": 95.796196482,
		"h": 2.9120879121
	},
	{
		"stop_id": 8594902,
		"ID": 1254,
		"x": 69.6767689183,
		"y": 95.988181727,
		"h": 2.9120879121
	},
	{
		"stop_id": 8594903,
		"ID": 1254,
		"x": 69.9077760273,
		"y": 95.894162698,
		"h": 2.9120879121
	},
	{
		"stop_id": 8594904,
		"ID": 1254,
		"x": 70.1697216253,
		"y": 95.788155474,
		"h": 2.9120879121
	},
	{
		"stop_id": 8594909,
		"ID": 1254,
		"x": 70.0177404463,
		"y": 95.33414613,
		"h": 2.9120879121
	},
	{
		"stop_id": 8594912,
		"ID": 1254,
		"x": 70.3597193063,
		"y": 95.775218922,
		"h": 2.9120879121
	},
	{
		"stop_id": 8594914,
		"ID": 1254,
		"x": 70.0677687423,
		"y": 95.629200678,
		"h": 2.9120879121
	},
	{
		"stop_id": 8594915,
		"ID": 1254,
		"x": 70.2987096913,
		"y": 97.109178446,
		"h": 2.9120879121
	},
	{
		"stop_id": 8594916,
		"ID": 1254,
		"x": 70.2117624663,
		"y": 97.150191101,
		"h": 2.9120879121
	},
	{
		"stop_id": 8594917,
		"ID": 1254,
		"x": 70.4207606873,
		"y": 97.071166828,
		"h": 2.9120879121
	},
	{
		"stop_id": 8595085,
		"ID": 1254,
		"x": 70.8577525773,
		"y": 95.480157515,
		"h": 2.9120879121
	},
	{
		"stop_id": 8595614,
		"ID": 1254,
		"x": 68.1937423423,
		"y": 96.942202037,
		"h": 2.9120879121
	},
	{
		"stop_id": 8595616,
		"ID": 1254,
		"x": 71.1127137983,
		"y": 95.372146083,
		"h": 2.9120879121
	},
	{
		"stop_id": 8506135,
		"ID": 1186,
		"x": 59.1647540933,
		"y": 98.916237622,
		"h": 1.1648351648
	},
	{
		"stop_id": 8506158,
		"ID": 1186,
		"x": 56.1677653303,
		"y": 99.549153071,
		"h": 1.1648351648
	},
	{
		"stop_id": 8506159,
		"ID": 1186,
		"x": 58.8347177673,
		"y": 99.146142018,
		"h": 1.1648351648
	},
	{
		"stop_id": 8506160,
		"ID": 1186,
		"x": 61.0797218433,
		"y": 99.173190916,
		"h": 1.1648351648
	},
	{
		"stop_id": 8506161,
		"ID": 1186,
		"x": 61.5367434963,
		"y": 100.784231227,
		"h": 1.1648351648
	},
	{
		"stop_id": 8594967,
		"ID": 1186,
		"x": 59.1497542653,
		"y": 99.034158003,
		"h": 1.1648351648
	},
	{
		"stop_id": 8506136,
		"ID": 1150,
		"x": 56.1057345713,
		"y": 97.887155008,
		"h": 1.3626373626
	},
	{
		"stop_id": 8506155,
		"ID": 1150,
		"x": 51.3127747953,
		"y": 95.99121234,
		"h": 1.3626373626
	},
	{
		"stop_id": 8506156,
		"ID": 1150,
		"x": 52.2977165283,
		"y": 97.184152567,
		"h": 1.3626373626
	},
	{
		"stop_id": 8506157,
		"ID": 1150,
		"x": 56.1287475343,
		"y": 98.348149037,
		"h": 1.3626373626
	},
	{
		"stop_id": 8506189,
		"ID": 1150,
		"x": 55.1857365253,
		"y": 98.698242909,
		"h": 1.3626373626
	},
	{
		"stop_id": 8506591,
		"ID": 1150,
		"x": 56.3347235633,
		"y": 97.605172348,
		"h": 1.3626373626
	},
	{
		"stop_id": 8506626,
		"ID": 1150,
		"x": 56.4577203973,
		"y": 97.380162311,
		"h": 1.3626373626
	},
	{
		"stop_id": 8506863,
		"ID": 1150,
		"x": 55.8807132003,
		"y": 96.486213285,
		"h": 1.3626373626
	},
	{
		"stop_id": 8573340,
		"ID": 1150,
		"x": 56.3037089623,
		"y": 97.917186662,
		"h": 1.3626373626
	},
	{
		"stop_id": 8573341,
		"ID": 1150,
		"x": 56.1037457363,
		"y": 97.904243003,
		"h": 1.3626373626
	},
	{
		"stop_id": 8579758,
		"ID": 1150,
		"x": 56.2167216163,
		"y": 97.317249143,
		"h": 1.3626373626
	},
	{
		"stop_id": 8581758,
		"ID": 1150,
		"x": 55.9517696673,
		"y": 97.850209055,
		"h": 1.3626373626
	},
	{
		"stop_id": 8506137,
		"ID": 1113,
		"x": 51.1147439693,
		"y": 95.52817739,
		"h": 1.4615384615
	},
	{
		"stop_id": 8506138,
		"ID": 1113,
		"x": 48.2987108463,
		"y": 95.615234622,
		"h": 1.4615384615
	},
	{
		"stop_id": 8506139,
		"ID": 1113,
		"x": 46.6597082623,
		"y": 96.775154016,
		"h": 1.4615384615
	},
	{
		"stop_id": 8506154,
		"ID": 1113,
		"x": 49.6337441703,
		"y": 96.389202985,
		"h": 1.4615384615
	},
	{
		"stop_id": 8506632,
		"ID": 1113,
		"x": 47.5377604903,
		"y": 96.099227506,
		"h": 1.4615384615
	},
	{
		"stop_id": 8506719,
		"ID": 1113,
		"x": 48.4907628123,
		"y": 93.562245687,
		"h": 1.4615384615
	},
	{
		"stop_id": 8506720,
		"ID": 1113,
		"x": 49.3067351623,
		"y": 91.958166847,
		"h": 1.4615384615
	},
	{
		"stop_id": 8506902,
		"ID": 1113,
		"x": 48.1757685513,
		"y": 95.635224596,
		"h": 1.4615384615
	},
	{
		"stop_id": 8573266,
		"ID": 1113,
		"x": 48.9057150993,
		"y": 92.332216447,
		"h": 1.4615384615
	},
	{
		"stop_id": 8573327,
		"ID": 1113,
		"x": 46.7097410023,
		"y": 96.738245798,
		"h": 1.4615384615
	},
	{
		"stop_id": 8578397,
		"ID": 1113,
		"x": 47.0237716633,
		"y": 97.11014576,
		"h": 1.4615384615
	},
	{
		"stop_id": 8583737,
		"ID": 1113,
		"x": 47.2027451613,
		"y": 96.439228002,
		"h": 1.4615384615
	},
	{
		"stop_id": 8592238,
		"ID": 1113,
		"x": 47.1287050863,
		"y": 97.153196162,
		"h": 1.4615384615
	},
	{
		"stop_id": 8594965,
		"ID": 1113,
		"x": 51.0867468613,
		"y": 95.618177629,
		"h": 1.4615384615
	},
	{
		"stop_id": 8594966,
		"ID": 1113,
		"x": 48.1127323103,
		"y": 95.901200221,
		"h": 1.4615384615
	},
	{
		"stop_id": 8506168,
		"ID": 1183,
		"x": 59.7417364013,
		"y": 80.70619045,
		"h": 1.4615384615
	},
	{
		"stop_id": 8506183,
		"ID": 1183,
		"x": 60.3857053363,
		"y": 82.046208204,
		"h": 1.4615384615
	},
	{
		"stop_id": 8506679,
		"ID": 1183,
		"x": 60.1007715053,
		"y": 82.67120705,
		"h": 1.4615384615
	},
	{
		"stop_id": 8506886,
		"ID": 1183,
		"x": 56.8007380333,
		"y": 85.171232305,
		"h": 1.4615384615
	},
	{
		"stop_id": 8506959,
		"ID": 1183,
		"x": 58.6897634033,
		"y": 85.241182934,
		"h": 1.4615384615
	},
	{
		"stop_id": 8573367,
		"ID": 1183,
		"x": 58.4867036363,
		"y": 85.08319745,
		"h": 1.4615384615
	},
	{
		"stop_id": 8573368,
		"ID": 1183,
		"x": 58.9007069383,
		"y": 85.392216602,
		"h": 1.4615384615
	},
	{
		"stop_id": 8573622,
		"ID": 1183,
		"x": 60.3577245623,
		"y": 82.055203393,
		"h": 1.4615384615
	},
	{
		"stop_id": 8573623,
		"ID": 1183,
		"x": 57.3587416903,
		"y": 81.569175663,
		"h": 1.4615384615
	},
	{
		"stop_id": 8573624,
		"ID": 1183,
		"x": 56.7877391333,
		"y": 82.097249817,
		"h": 1.4615384615
	},
	{
		"stop_id": 8573625,
		"ID": 1183,
		"x": 56.7097725583,
		"y": 82.334144914,
		"h": 1.4615384615
	},
	{
		"stop_id": 8573626,
		"ID": 1183,
		"x": 56.0317696593,
		"y": 82.160232572,
		"h": 1.4615384615
	},
	{
		"stop_id": 8580249,
		"ID": 1183,
		"x": 57.7277118953,
		"y": 81.601188824,
		"h": 1.4615384615
	},
	{
		"stop_id": 8589970,
		"ID": 1183,
		"x": 60.3077501993,
		"y": 81.530164288,
		"h": 1.4615384615
	},
	{
		"stop_id": 8589971,
		"ID": 1183,
		"x": 60.1577444733,
		"y": 80.680142131,
		"h": 1.4615384615
	},
	{
		"stop_id": 8506169,
		"ID": 1147,
		"x": 54.0397513733,
		"y": 79.794173387,
		"h": 1.2637362637
	},
	{
		"stop_id": 8506173,
		"ID": 1147,
		"x": 51.9777157453,
		"y": 82.540238511,
		"h": 1.2637362637
	},
	{
		"stop_id": 8506174,
		"ID": 1147,
		"x": 52.8027171263,
		"y": 81.80524641,
		"h": 1.2637362637
	},
	{
		"stop_id": 8506175,
		"ID": 1147,
		"x": 53.6777490353,
		"y": 80.535195747,
		"h": 1.2637362637
	},
	{
		"stop_id": 8506176,
		"ID": 1147,
		"x": 54.3867746913,
		"y": 79.158197228,
		"h": 1.2637362637
	},
	{
		"stop_id": 8506177,
		"ID": 1147,
		"x": 56.0477724113,
		"y": 78.732216033,
		"h": 1.2637362637
	},
	{
		"stop_id": 8573627,
		"ID": 1147,
		"x": 54.6827383153,
		"y": 82.197226423,
		"h": 1.2637362637
	},
	{
		"stop_id": 8573628,
		"ID": 1147,
		"x": 54.3157752403,
		"y": 82.281209618,
		"h": 1.2637362637
	},
	{
		"stop_id": 8581617,
		"ID": 1147,
		"x": 54.2547522403,
		"y": 82.621219065,
		"h": 1.2637362637
	},
	{
		"stop_id": 8506193,
		"ID": 1253,
		"x": 70.5077603193,
		"y": 87.92014607,
		"h": 1.3956043956
	},
	{
		"stop_id": 8506194,
		"ID": 1253,
		"x": 70.8397174123,
		"y": 89.047215036,
		"h": 1.3956043956
	},
	{
		"stop_id": 8506556,
		"ID": 1253,
		"x": 68.2347247603,
		"y": 90.942210226,
		"h": 1.3956043956
	},
	{
		"stop_id": 8506569,
		"ID": 1253,
		"x": 67.8217205153,
		"y": 86.627206459,
		"h": 1.3956043956
	},
	{
		"stop_id": 8506571,
		"ID": 1253,
		"x": 69.4857304213,
		"y": 87.07923815,
		"h": 1.3956043956
	},
	{
		"stop_id": 8506573,
		"ID": 1253,
		"x": 66.8297242943,
		"y": 86.97719797,
		"h": 1.3956043956
	},
	{
		"stop_id": 8573287,
		"ID": 1253,
		"x": 66.9557295863,
		"y": 87.163183557,
		"h": 1.3956043956
	},
	{
		"stop_id": 8573396,
		"ID": 1253,
		"x": 67.2297315263,
		"y": 90.771238134,
		"h": 1.3956043956
	},
	{
		"stop_id": 8573397,
		"ID": 1253,
		"x": 66.4037145693,
		"y": 90.759187297,
		"h": 1.3956043956
	},
	{
		"stop_id": 8581851,
		"ID": 1253,
		"x": 66.7017134343,
		"y": 87.211230623,
		"h": 1.3956043956
	},
	{
		"stop_id": 8582006,
		"ID": 1253,
		"x": 66.4957470363,
		"y": 87.258202977,
		"h": 1.3956043956
	},
	{
		"stop_id": 8582226,
		"ID": 1253,
		"x": 67.0767468463,
		"y": 86.761182705,
		"h": 1.3956043956
	},
	{
		"stop_id": 8589972,
		"ID": 1253,
		"x": 67.1847037093,
		"y": 86.813216224,
		"h": 1.3956043956
	},
	{
		"stop_id": 8506196,
		"ID": 1284,
		"x": 71.9167025113,
		"y": 93.892142182,
		"h": 1.5604395604
	},
	{
		"stop_id": 8506611,
		"ID": 1284,
		"x": 76.2387520443,
		"y": 90.490245813,
		"h": 1.5604395604
	},
	{
		"stop_id": 8506614,
		"ID": 1284,
		"x": 75.4077285493,
		"y": 92.144229797,
		"h": 1.5604395604
	},
	{
		"stop_id": 8573415,
		"ID": 1284,
		"x": 74.6437319493,
		"y": 94.476191053,
		"h": 1.5604395604
	},
	{
		"stop_id": 8573417,
		"ID": 1284,
		"x": 75.0077605293,
		"y": 92.703189978,
		"h": 1.5604395604
	},
	{
		"stop_id": 8573418,
		"ID": 1284,
		"x": 75.6827260853,
		"y": 91.796190511,
		"h": 1.5604395604
	},
	{
		"stop_id": 8573419,
		"ID": 1284,
		"x": 76.0757334983,
		"y": 90.790231995,
		"h": 1.5604395604
	},
	{
		"stop_id": 8578137,
		"ID": 1284,
		"x": 73.2867441963,
		"y": 91.504204259,
		"h": 1.5604395604
	},
	{
		"stop_id": 8581683,
		"ID": 1284,
		"x": 71.9337692133,
		"y": 93.892189695,
		"h": 1.5604395604
	},
	{
		"stop_id": 8581684,
		"ID": 1284,
		"x": 72.1857558373,
		"y": 93.679165591,
		"h": 1.5604395604
	},
	{
		"stop_id": 8581699,
		"ID": 1284,
		"x": 75.0077095063,
		"y": 94.291198002,
		"h": 1.5604395604
	},
	{
		"stop_id": 8581700,
		"ID": 1284,
		"x": 75.5507265613,
		"y": 93.818155436,
		"h": 1.5604395604
	},
	{
		"stop_id": 8581702,
		"ID": 1284,
		"x": 72.2567105703,
		"y": 93.136223118,
		"h": 1.5604395604
	},
	{
		"stop_id": 8581703,
		"ID": 1284,
		"x": 72.7057497893,
		"y": 93.359167502,
		"h": 1.5604395604
	},
	{
		"stop_id": 8581704,
		"ID": 1284,
		"x": 73.1337067893,
		"y": 92.891219268,
		"h": 1.5604395604
	},
	{
		"stop_id": 8582173,
		"ID": 1284,
		"x": 73.3847368843,
		"y": 91.878221552,
		"h": 1.5604395604
	},
	{
		"stop_id": 8582174,
		"ID": 1284,
		"x": 73.7827080493,
		"y": 89.681187432,
		"h": 1.5604395604
	},
	{
		"stop_id": 8582175,
		"ID": 1284,
		"x": 72.8957145813,
		"y": 89.110203728,
		"h": 1.5604395604
	},
	{
		"stop_id": 8506202,
		"ID": 1216,
		"x": 64.1557554453,
		"y": 62.468173216,
		"h": 1.8901098901
	},
	{
		"stop_id": 8506203,
		"ID": 1216,
		"x": 63.8817509623,
		"y": 64.135206393,
		"h": 1.8901098901
	},
	{
		"stop_id": 8506617,
		"ID": 1216,
		"x": 63.2637311193,
		"y": 59.971174681,
		"h": 1.8901098901
	},
	{
		"stop_id": 8506618,
		"ID": 1216,
		"x": 64.2577301503,
		"y": 60.80522987,
		"h": 1.8901098901
	},
	{
		"stop_id": 8506620,
		"ID": 1216,
		"x": 64.8567335853,
		"y": 61.281180521,
		"h": 1.8901098901
	},
	{
		"stop_id": 8506621,
		"ID": 1216,
		"x": 64.6737577113,
		"y": 60.875219597,
		"h": 1.8901098901
	},
	{
		"stop_id": 8506622,
		"ID": 1216,
		"x": 64.5897298093,
		"y": 61.702158365,
		"h": 1.8901098901
	},
	{
		"stop_id": 8506623,
		"ID": 1216,
		"x": 64.4047139323,
		"y": 62.62417726,
		"h": 1.8901098901
	},
	{
		"stop_id": 8506624,
		"ID": 1216,
		"x": 65.2287043053,
		"y": 62.596233044,
		"h": 1.8901098901
	},
	{
		"stop_id": 8506625,
		"ID": 1216,
		"x": 65.7837069093,
		"y": 63.146199255,
		"h": 1.8901098901
	},
	{
		"stop_id": 8573979,
		"ID": 1216,
		"x": 63.8697538683,
		"y": 64.098146978,
		"h": 1.8901098901
	},
	{
		"stop_id": 8573980,
		"ID": 1216,
		"x": 63.4797020693,
		"y": 64.341236721,
		"h": 1.8901098901
	},
	{
		"stop_id": 8573981,
		"ID": 1216,
		"x": 62.7427126963,
		"y": 64.413141355,
		"h": 1.8901098901
	},
	{
		"stop_id": 8573982,
		"ID": 1216,
		"x": 62.1587681153,
		"y": 64.517197353,
		"h": 1.8901098901
	},
	{
		"stop_id": 8573983,
		"ID": 1216,
		"x": 61.5667353373,
		"y": 64.353140703,
		"h": 1.8901098901
	},
	{
		"stop_id": 8573984,
		"ID": 1216,
		"x": 61.2637640933,
		"y": 64.400212906,
		"h": 1.8901098901
	},
	{
		"stop_id": 8573994,
		"ID": 1216,
		"x": 61.5437294203,
		"y": 62.176171749,
		"h": 1.8901098901
	},
	{
		"stop_id": 8573995,
		"ID": 1216,
		"x": 60.9777276283,
		"y": 61.653190145,
		"h": 1.8901098901
	},
	{
		"stop_id": 8573997,
		"ID": 1216,
		"x": 60.9927148053,
		"y": 63.626148073,
		"h": 1.8901098901
	},
	{
		"stop_id": 8573998,
		"ID": 1216,
		"x": 61.2587031873,
		"y": 62.753168422,
		"h": 1.8901098901
	},
	{
		"stop_id": 8573999,
		"ID": 1216,
		"x": 63.9997466073,
		"y": 65.269191074,
		"h": 1.8901098901
	},
	{
		"stop_id": 8574000,
		"ID": 1216,
		"x": 64.1947552393,
		"y": 65.6042176,
		"h": 1.8901098901
	},
	{
		"stop_id": 8574003,
		"ID": 1216,
		"x": 64.5257478763,
		"y": 59.925205252,
		"h": 1.8901098901
	},
	{
		"stop_id": 8574004,
		"ID": 1216,
		"x": 63.6927125773,
		"y": 60.646204597,
		"h": 1.8901098901
	},
	{
		"stop_id": 8574007,
		"ID": 1216,
		"x": 64.7647154273,
		"y": 60.522162254,
		"h": 1.8901098901
	},
	{
		"stop_id": 8578577,
		"ID": 1216,
		"x": 64.9077360443,
		"y": 60.207231938,
		"h": 1.8901098901
	},
	{
		"stop_id": 8579686,
		"ID": 1216,
		"x": 64.1557405923,
		"y": 62.494194979,
		"h": 1.8901098901
	},
	{
		"stop_id": 8580489,
		"ID": 1216,
		"x": 63.7697550343,
		"y": 64.440243849,
		"h": 1.8901098901
	},
	{
		"stop_id": 8506208,
		"ID": 1250,
		"x": 67.9147231793,
		"y": 72.767229629,
		"h": 2.3846153846
	},
	{
		"stop_id": 8506471,
		"ID": 1250,
		"x": 71.1217678313,
		"y": 70.651215206,
		"h": 2.3846153846
	},
	{
		"stop_id": 8506472,
		"ID": 1250,
		"x": 70.7187237013,
		"y": 70.656219007,
		"h": 2.3846153846
	},
	{
		"stop_id": 8506473,
		"ID": 1250,
		"x": 69.7697272943,
		"y": 69.532173524,
		"h": 2.3846153846
	},
	{
		"stop_id": 8506475,
		"ID": 1250,
		"x": 67.1007387323,
		"y": 69.540221323,
		"h": 2.3846153846
	},
	{
		"stop_id": 8506476,
		"ID": 1250,
		"x": 68.1327738003,
		"y": 69.187204137,
		"h": 2.3846153846
	},
	{
		"stop_id": 8506477,
		"ID": 1250,
		"x": 70.5907285153,
		"y": 70.360248114,
		"h": 2.3846153846
	},
	{
		"stop_id": 8506576,
		"ID": 1250,
		"x": 67.4057042823,
		"y": 72.033182409,
		"h": 2.3846153846
	},
	{
		"stop_id": 8506577,
		"ID": 1250,
		"x": 69.5907584073,
		"y": 73.80219301,
		"h": 2.3846153846
	},
	{
		"stop_id": 8506578,
		"ID": 1250,
		"x": 67.8647316083,
		"y": 74.182193801,
		"h": 2.3846153846
	},
	{
		"stop_id": 8506589,
		"ID": 1250,
		"x": 67.0837341553,
		"y": 72.144155296,
		"h": 2.3846153846
	},
	{
		"stop_id": 8506723,
		"ID": 1250,
		"x": 68.6167429013,
		"y": 71.004166466,
		"h": 2.3846153846
	},
	{
		"stop_id": 8506725,
		"ID": 1250,
		"x": 68.6057169453,
		"y": 72.977241912,
		"h": 2.3846153846
	},
	{
		"stop_id": 8506728,
		"ID": 1250,
		"x": 68.3477119353,
		"y": 73.874235967,
		"h": 2.3846153846
	},
	{
		"stop_id": 8506735,
		"ID": 1250,
		"x": 68.4137658643,
		"y": 73.294145844,
		"h": 2.3846153846
	},
	{
		"stop_id": 8506874,
		"ID": 1250,
		"x": 69.0587270653,
		"y": 73.837182658,
		"h": 2.3846153846
	},
	{
		"stop_id": 8573929,
		"ID": 1250,
		"x": 67.8927661373,
		"y": 72.697249556,
		"h": 2.3846153846
	},
	{
		"stop_id": 8573930,
		"ID": 1250,
		"x": 68.0467669583,
		"y": 72.837251044,
		"h": 2.3846153846
	},
	{
		"stop_id": 8573931,
		"ID": 1250,
		"x": 68.7127027523,
		"y": 73.714221899,
		"h": 2.3846153846
	},
	{
		"stop_id": 8573932,
		"ID": 1250,
		"x": 69.9327236643,
		"y": 74.264200513,
		"h": 2.3846153846
	},
	{
		"stop_id": 8573937,
		"ID": 1250,
		"x": 67.5457359183,
		"y": 72.294199818,
		"h": 2.3846153846
	},
	{
		"stop_id": 8573938,
		"ID": 1250,
		"x": 67.7867657083,
		"y": 71.814180689,
		"h": 2.3846153846
	},
	{
		"stop_id": 8573939,
		"ID": 1250,
		"x": 67.7647063193,
		"y": 71.689150335,
		"h": 2.3846153846
	},
	{
		"stop_id": 8573940,
		"ID": 1250,
		"x": 67.7987587703,
		"y": 71.268176769,
		"h": 2.3846153846
	},
	{
		"stop_id": 8573941,
		"ID": 1250,
		"x": 68.4137062453,
		"y": 70.997208708,
		"h": 2.3846153846
	},
	{
		"stop_id": 8573942,
		"ID": 1250,
		"x": 66.1217495643,
		"y": 72.225149618,
		"h": 2.3846153846
	},
	{
		"stop_id": 8573974,
		"ID": 1250,
		"x": 67.2607396583,
		"y": 69.289205836,
		"h": 2.3846153846
	},
	{
		"stop_id": 8573975,
		"ID": 1250,
		"x": 68.5747365903,
		"y": 69.404172167,
		"h": 2.3846153846
	},
	{
		"stop_id": 8580553,
		"ID": 1250,
		"x": 71.3207019643,
		"y": 70.854239706,
		"h": 2.3846153846
	},
	{
		"stop_id": 8580554,
		"ID": 1250,
		"x": 71.0277487443,
		"y": 70.76924487,
		"h": 2.3846153846
	},
	{
		"stop_id": 8580555,
		"ID": 1250,
		"x": 71.2877246953,
		"y": 70.465161092,
		"h": 2.3846153846
	},
	{
		"stop_id": 8581593,
		"ID": 1250,
		"x": 68.4607678843,
		"y": 72.723208454,
		"h": 2.3846153846
	},
	{
		"stop_id": 8583056,
		"ID": 1250,
		"x": 67.5987443863,
		"y": 73.225167955,
		"h": 2.3846153846
	},
	{
		"stop_id": 8583057,
		"ID": 1250,
		"x": 67.7897265793,
		"y": 73.063244734,
		"h": 2.3846153846
	},
	{
		"stop_id": 8583058,
		"ID": 1250,
		"x": 68.8797674443,
		"y": 73.251211164,
		"h": 2.3846153846
	},
	{
		"stop_id": 8583059,
		"ID": 1250,
		"x": 68.8027761323,
		"y": 73.697161378,
		"h": 2.3846153846
	},
	{
		"stop_id": 8583060,
		"ID": 1250,
		"x": 68.7677250773,
		"y": 73.890240473,
		"h": 2.3846153846
	},
	{
		"stop_id": 8583061,
		"ID": 1250,
		"x": 68.7667253983,
		"y": 74.07516261,
		"h": 2.3846153846
	},
	{
		"stop_id": 8583062,
		"ID": 1250,
		"x": 68.8277547773,
		"y": 74.200155451,
		"h": 2.3846153846
	},
	{
		"stop_id": 8583072,
		"ID": 1250,
		"x": 67.1567482223,
		"y": 73.391160557,
		"h": 2.3846153846
	},
	{
		"stop_id": 8583397,
		"ID": 1250,
		"x": 67.3737064963,
		"y": 73.315190835,
		"h": 2.3846153846
	},
	{
		"stop_id": 8583510,
		"ID": 1250,
		"x": 69.6437147373,
		"y": 70.748169024,
		"h": 2.3846153846
	},
	{
		"stop_id": 8583616,
		"ID": 1250,
		"x": 71.5117532093,
		"y": 70.915191129,
		"h": 2.3846153846
	},
	{
		"stop_id": 8506209,
		"ID": 1280,
		"x": 72.4017652913,
		"y": 70.502161066,
		"h": 1.6593406593
	},
	{
		"stop_id": 8506292,
		"ID": 1280,
		"x": 73.3017457963,
		"y": 65.772170458,
		"h": 1.6593406593
	},
	{
		"stop_id": 8506480,
		"ID": 1280,
		"x": 73.8047479163,
		"y": 66.797173073,
		"h": 1.6593406593
	},
	{
		"stop_id": 8506481,
		"ID": 1280,
		"x": 73.4037229363,
		"y": 67.073176785,
		"h": 1.6593406593
	},
	{
		"stop_id": 8506482,
		"ID": 1280,
		"x": 71.0637534163,
		"y": 68.972210812,
		"h": 1.6593406593
	},
	{
		"stop_id": 8506483,
		"ID": 1280,
		"x": 72.0107575323,
		"y": 68.113200786,
		"h": 1.6593406593
	},
	{
		"stop_id": 8506731,
		"ID": 1280,
		"x": 72.7657169903,
		"y": 67.839231408,
		"h": 1.6593406593
	},
	{
		"stop_id": 8573976,
		"ID": 1280,
		"x": 71.4547622943,
		"y": 70.561166265,
		"h": 1.6593406593
	},
	{
		"stop_id": 8573977,
		"ID": 1280,
		"x": 71.9307071773,
		"y": 70.642243004,
		"h": 1.6593406593
	},
	{
		"stop_id": 8573978,
		"ID": 1280,
		"x": 72.4187175453,
		"y": 70.473179775,
		"h": 1.6593406593
	},
	{
		"stop_id": 8574200,
		"ID": 1280,
		"x": 73.0927719163,
		"y": 65.796172851,
		"h": 1.6593406593
	},
	{
		"stop_id": 8574201,
		"ID": 1280,
		"x": 73.3147176363,
		"y": 65.810162062,
		"h": 1.6593406593
	},
	{
		"stop_id": 8580556,
		"ID": 1280,
		"x": 71.4217750633,
		"y": 70.23414249,
		"h": 1.6593406593
	},
	{
		"stop_id": 8580557,
		"ID": 1280,
		"x": 71.5537531293,
		"y": 70.46115844,
		"h": 1.6593406593
	},
	{
		"stop_id": 8580558,
		"ID": 1280,
		"x": 72.2457747733,
		"y": 70.27014151,
		"h": 1.6593406593
	},
	{
		"stop_id": 8580559,
		"ID": 1280,
		"x": 72.5827343233,
		"y": 70.261205508,
		"h": 1.6593406593
	},
	{
		"stop_id": 8582184,
		"ID": 1280,
		"x": 72.0277305023,
		"y": 70.59024239,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583615,
		"ID": 1280,
		"x": 73.2657252233,
		"y": 69.927198025,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583617,
		"ID": 1280,
		"x": 73.0427624763,
		"y": 70.083226483,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583618,
		"ID": 1280,
		"x": 72.2417740273,
		"y": 70.341227452,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583619,
		"ID": 1280,
		"x": 71.7827306833,
		"y": 70.735150492,
		"h": 1.6593406593
	},
	{
		"stop_id": 8506210,
		"ID": 1309,
		"x": 77.1837295713,
		"y": 70.237178475,
		"h": 2.5164835165
	},
	{
		"stop_id": 8506211,
		"ID": 1309,
		"x": 77.0286991503,
		"y": 73.589246049,
		"h": 2.5164835165
	},
	{
		"stop_id": 8506254,
		"ID": 1309,
		"x": 78.5097436543,
		"y": 71.970244737,
		"h": 2.5164835165
	},
	{
		"stop_id": 8506468,
		"ID": 1309,
		"x": 78.4547335073,
		"y": 70.638171323,
		"h": 2.5164835165
	},
	{
		"stop_id": 8506721,
		"ID": 1309,
		"x": 76.4247274683,
		"y": 70.693214177,
		"h": 2.5164835165
	},
	{
		"stop_id": 8506789,
		"ID": 1309,
		"x": 78.4447397993,
		"y": 73.299186397,
		"h": 2.5164835165
	},
	{
		"stop_id": 8573945,
		"ID": 1309,
		"x": 77.2167101133,
		"y": 70.257181395,
		"h": 2.5164835165
	},
	{
		"stop_id": 8573946,
		"ID": 1309,
		"x": 76.9957123693,
		"y": 70.438242849,
		"h": 2.5164835165
	},
	{
		"stop_id": 8573953,
		"ID": 1309,
		"x": 77.0577220153,
		"y": 70.760192458,
		"h": 2.5164835165
	},
	{
		"stop_id": 8573954,
		"ID": 1309,
		"x": 77.4327103013,
		"y": 70.810243122,
		"h": 2.5164835165
	},
	{
		"stop_id": 8573955,
		"ID": 1309,
		"x": 78.6227353453,
		"y": 72.870165035,
		"h": 2.5164835165
	},
	{
		"stop_id": 8573956,
		"ID": 1309,
		"x": 78.0357707773,
		"y": 73.3771737,
		"h": 2.5164835165
	},
	{
		"stop_id": 8573957,
		"ID": 1309,
		"x": 77.3447602943,
		"y": 73.729240633,
		"h": 2.5164835165
	},
	{
		"stop_id": 8573958,
		"ID": 1309,
		"x": 77.0537551543,
		"y": 73.654218481,
		"h": 2.5164835165
	},
	{
		"stop_id": 8577362,
		"ID": 1309,
		"x": 77.7327269643,
		"y": 70.815202438,
		"h": 2.5164835165
	},
	{
		"stop_id": 8578304,
		"ID": 1309,
		"x": 79.5117059843,
		"y": 70.979239203,
		"h": 2.5164835165
	},
	{
		"stop_id": 8578506,
		"ID": 1309,
		"x": 77.8677585993,
		"y": 68.81516479,
		"h": 2.5164835165
	},
	{
		"stop_id": 8578508,
		"ID": 1309,
		"x": 76.2777274553,
		"y": 71.535165142,
		"h": 2.5164835165
	},
	{
		"stop_id": 8580938,
		"ID": 1309,
		"x": 78.1667690803,
		"y": 70.760240172,
		"h": 2.5164835165
	},
	{
		"stop_id": 8581737,
		"ID": 1309,
		"x": 78.8387368243,
		"y": 73.45820919,
		"h": 2.5164835165
	},
	{
		"stop_id": 8582019,
		"ID": 1309,
		"x": 77.1477521063,
		"y": 73.110219552,
		"h": 2.5164835165
	},
	{
		"stop_id": 8582020,
		"ID": 1309,
		"x": 76.2657490693,
		"y": 71.928251418,
		"h": 2.5164835165
	},
	{
		"stop_id": 8582022,
		"ID": 1309,
		"x": 76.3257372803,
		"y": 71.121221052,
		"h": 2.5164835165
	},
	{
		"stop_id": 8582023,
		"ID": 1309,
		"x": 76.5457225783,
		"y": 70.818222312,
		"h": 2.5164835165
	},
	{
		"stop_id": 8582243,
		"ID": 1309,
		"x": 79.3377476603,
		"y": 69.911162,
		"h": 2.5164835165
	},
	{
		"stop_id": 8587329,
		"ID": 1309,
		"x": 77.2787389753,
		"y": 73.62517133,
		"h": 2.5164835165
	},
	{
		"stop_id": 8588495,
		"ID": 1309,
		"x": 76.8627022723,
		"y": 70.57218621,
		"h": 2.5164835165
	},
	{
		"stop_id": 8588496,
		"ID": 1309,
		"x": 77.9427559203,
		"y": 70.710205532,
		"h": 2.5164835165
	},
	{
		"stop_id": 8588498,
		"ID": 1309,
		"x": 79.2947241003,
		"y": 70.203200432,
		"h": 2.5164835165
	},
	{
		"stop_id": 8588499,
		"ID": 1309,
		"x": 80.2777228403,
		"y": 69.840235482,
		"h": 2.5164835165
	},
	{
		"stop_id": 8588724,
		"ID": 1309,
		"x": 78.7507560163,
		"y": 70.7561935,
		"h": 2.5164835165
	},
	{
		"stop_id": 8588961,
		"ID": 1309,
		"x": 81.8147646753,
		"y": 71.298236475,
		"h": 2.5164835165
	},
	{
		"stop_id": 8589533,
		"ID": 1309,
		"x": 79.6627088463,
		"y": 69.952170355,
		"h": 2.5164835165
	},
	{
		"stop_id": 8589534,
		"ID": 1309,
		"x": 79.9687271423,
		"y": 69.855177379,
		"h": 2.5164835165
	},
	{
		"stop_id": 8589535,
		"ID": 1309,
		"x": 79.0317331273,
		"y": 70.002181833,
		"h": 2.5164835165
	},
	{
		"stop_id": 8589537,
		"ID": 1309,
		"x": 78.5267321143,
		"y": 70.154181896,
		"h": 2.5164835165
	},
	{
		"stop_id": 8589890,
		"ID": 1309,
		"x": 80.7147510023,
		"y": 69.740153043,
		"h": 2.5164835165
	},
	{
		"stop_id": 8590319,
		"ID": 1309,
		"x": 76.8057544373,
		"y": 69.886244449,
		"h": 2.5164835165
	},
	{
		"stop_id": 8590320,
		"ID": 1309,
		"x": 76.9467443923,
		"y": 70.012166417,
		"h": 2.5164835165
	},
	{
		"stop_id": 8590321,
		"ID": 1309,
		"x": 77.1447418283,
		"y": 69.814222791,
		"h": 2.5164835165
	},
	{
		"stop_id": 8590322,
		"ID": 1309,
		"x": 77.3957629383,
		"y": 69.355162056,
		"h": 2.5164835165
	},
	{
		"stop_id": 8590323,
		"ID": 1309,
		"x": 77.9947036843,
		"y": 68.649184024,
		"h": 2.5164835165
	},
	{
		"stop_id": 8590327,
		"ID": 1309,
		"x": 75.8737238113,
		"y": 70.88219216,
		"h": 2.5164835165
	},
	{
		"stop_id": 8590332,
		"ID": 1309,
		"x": 77.6807113463,
		"y": 70.96824781,
		"h": 2.5164835165
	},
	{
		"stop_id": 8590333,
		"ID": 1309,
		"x": 77.9627325803,
		"y": 71.081234641,
		"h": 2.5164835165
	},
	{
		"stop_id": 8590334,
		"ID": 1309,
		"x": 78.4417729493,
		"y": 70.831158558,
		"h": 2.5164835165
	},
	{
		"stop_id": 8591867,
		"ID": 1309,
		"x": 78.2567210833,
		"y": 71.085190873,
		"h": 2.5164835165
	},
	{
		"stop_id": 8506212,
		"ID": 1310,
		"x": 76.9067123473,
		"y": 77.463156009,
		"h": 1.7252747253
	},
	{
		"stop_id": 8506469,
		"ID": 1310,
		"x": 80.6427039583,
		"y": 78.651189571,
		"h": 1.7252747253
	},
	{
		"stop_id": 8506499,
		"ID": 1310,
		"x": 78.2117286553,
		"y": 75.418178424,
		"h": 1.7252747253
	},
	{
		"stop_id": 8506587,
		"ID": 1310,
		"x": 75.3717609023,
		"y": 77.06520424,
		"h": 1.7252747253
	},
	{
		"stop_id": 8506699,
		"ID": 1310,
		"x": 78.0327465563,
		"y": 75.055225473,
		"h": 1.7252747253
	},
	{
		"stop_id": 8506798,
		"ID": 1310,
		"x": 79.3767413183,
		"y": 76.542172044,
		"h": 1.7252747253
	},
	{
		"stop_id": 8573959,
		"ID": 1310,
		"x": 79.0907361493,
		"y": 76.309235957,
		"h": 1.7252747253
	},
	{
		"stop_id": 8573960,
		"ID": 1310,
		"x": 79.6597041953,
		"y": 77.51719968,
		"h": 1.7252747253
	},
	{
		"stop_id": 8574234,
		"ID": 1310,
		"x": 80.1917465803,
		"y": 75.031177568,
		"h": 1.7252747253
	},
	{
		"stop_id": 8574235,
		"ID": 1310,
		"x": 79.2007367823,
		"y": 75.784210676,
		"h": 1.7252747253
	},
	{
		"stop_id": 8578800,
		"ID": 1310,
		"x": 76.7077139833,
		"y": 79.730144008,
		"h": 1.7252747253
	},
	{
		"stop_id": 8578801,
		"ID": 1310,
		"x": 76.9687393723,
		"y": 79.788226069,
		"h": 1.7252747253
	},
	{
		"stop_id": 8578803,
		"ID": 1310,
		"x": 78.0337278683,
		"y": 79.824192653,
		"h": 1.7252747253
	},
	{
		"stop_id": 8578804,
		"ID": 1310,
		"x": 79.2347580513,
		"y": 79.392210206,
		"h": 1.7252747253
	},
	{
		"stop_id": 8578805,
		"ID": 1310,
		"x": 79.6967723543,
		"y": 78.883151866,
		"h": 1.7252747253
	},
	{
		"stop_id": 8578806,
		"ID": 1310,
		"x": 79.7947306723,
		"y": 78.674150894,
		"h": 1.7252747253
	},
	{
		"stop_id": 8578807,
		"ID": 1310,
		"x": 80.0697141113,
		"y": 78.605243753,
		"h": 1.7252747253
	},
	{
		"stop_id": 8578808,
		"ID": 1310,
		"x": 80.5127043613,
		"y": 78.773223097,
		"h": 1.7252747253
	},
	{
		"stop_id": 8579845,
		"ID": 1310,
		"x": 80.9237050673,
		"y": 77.170225396,
		"h": 1.7252747253
	},
	{
		"stop_id": 8579978,
		"ID": 1310,
		"x": 80.0327600713,
		"y": 76.855148371,
		"h": 1.7252747253
	},
	{
		"stop_id": 8579981,
		"ID": 1310,
		"x": 81.5727554573,
		"y": 77.494221481,
		"h": 1.7252747253
	},
	{
		"stop_id": 8579982,
		"ID": 1310,
		"x": 79.6917081813,
		"y": 76.745221042,
		"h": 1.7252747253
	},
	{
		"stop_id": 8587336,
		"ID": 1310,
		"x": 76.8577149323,
		"y": 77.730164464,
		"h": 1.7252747253
	},
	{
		"stop_id": 8506213,
		"ID": 1282,
		"x": 76.1057744293,
		"y": 79.144181371,
		"h": 1.5274725275
	},
	{
		"stop_id": 8506214,
		"ID": 1282,
		"x": 76.6387639223,
		"y": 80.611165801,
		"h": 1.5274725275
	},
	{
		"stop_id": 8506215,
		"ID": 1282,
		"x": 75.5237443603,
		"y": 80.05114191,
		"h": 1.5274725275
	},
	{
		"stop_id": 8506216,
		"ID": 1282,
		"x": 73.0177342213,
		"y": 82.697175042,
		"h": 1.5274725275
	},
	{
		"stop_id": 8506572,
		"ID": 1282,
		"x": 70.8557212723,
		"y": 81.140239443,
		"h": 1.5274725275
	},
	{
		"stop_id": 8506588,
		"ID": 1282,
		"x": 76.1437140523,
		"y": 79.179196819,
		"h": 1.5274725275
	},
	{
		"stop_id": 8506764,
		"ID": 1282,
		"x": 72.0387101163,
		"y": 77.287247116,
		"h": 1.5274725275
	},
	{
		"stop_id": 8573922,
		"ID": 1282,
		"x": 72.2017251073,
		"y": 77.760204382,
		"h": 1.5274725275
	},
	{
		"stop_id": 8573935,
		"ID": 1282,
		"x": 75.4497084783,
		"y": 78.266217645,
		"h": 1.5274725275
	},
	{
		"stop_id": 8578798,
		"ID": 1282,
		"x": 76.2827307583,
		"y": 79.35522431,
		"h": 1.5274725275
	},
	{
		"stop_id": 8578799,
		"ID": 1282,
		"x": 76.5477418843,
		"y": 79.653160983,
		"h": 1.5274725275
	},
	{
		"stop_id": 8580424,
		"ID": 1282,
		"x": 75.6617330163,
		"y": 78.890206974,
		"h": 1.5274725275
	},
	{
		"stop_id": 8587155,
		"ID": 1282,
		"x": 75.8877454553,
		"y": 79.937147699,
		"h": 1.5274725275
	},
	{
		"stop_id": 8587156,
		"ID": 1282,
		"x": 75.9727372803,
		"y": 79.810199657,
		"h": 1.5274725275
	},
	{
		"stop_id": 8587211,
		"ID": 1282,
		"x": 76.6387446843,
		"y": 80.589144478,
		"h": 1.5274725275
	},
	{
		"stop_id": 8587212,
		"ID": 1282,
		"x": 76.0907124983,
		"y": 79.996194313,
		"h": 1.5274725275
	},
	{
		"stop_id": 8587214,
		"ID": 1282,
		"x": 76.4657758213,
		"y": 80.266185925,
		"h": 1.5274725275
	},
	{
		"stop_id": 8506252,
		"ID": 1281,
		"x": 75.0867451123,
		"y": 71.544165934,
		"h": 1.4945054945
	},
	{
		"stop_id": 8506253,
		"ID": 1281,
		"x": 73.9157645903,
		"y": 72.302206327,
		"h": 1.4945054945
	},
	{
		"stop_id": 8506583,
		"ID": 1281,
		"x": 71.3177544703,
		"y": 74.884150817,
		"h": 1.4945054945
	},
	{
		"stop_id": 8506585,
		"ID": 1281,
		"x": 73.6987133453,
		"y": 76.830246643,
		"h": 1.4945054945
	},
	{
		"stop_id": 8506586,
		"ID": 1281,
		"x": 74.7807610903,
		"y": 76.673153564,
		"h": 1.4945054945
	},
	{
		"stop_id": 8506687,
		"ID": 1281,
		"x": 73.3717291913,
		"y": 76.285157422,
		"h": 1.4945054945
	},
	{
		"stop_id": 8506726,
		"ID": 1281,
		"x": 72.5087106343,
		"y": 75.674249401,
		"h": 1.4945054945
	},
	{
		"stop_id": 8506727,
		"ID": 1281,
		"x": 71.9247101633,
		"y": 74.350243657,
		"h": 1.4945054945
	},
	{
		"stop_id": 8506876,
		"ID": 1281,
		"x": 72.9927377273,
		"y": 73.053241751,
		"h": 1.4945054945
	},
	{
		"stop_id": 8573921,
		"ID": 1281,
		"x": 71.8007523283,
		"y": 77.009141579,
		"h": 1.4945054945
	},
	{
		"stop_id": 8573933,
		"ID": 1281,
		"x": 70.3867570673,
		"y": 74.464232371,
		"h": 1.4945054945
	},
	{
		"stop_id": 8573934,
		"ID": 1281,
		"x": 73.1367158673,
		"y": 76.088250619,
		"h": 1.4945054945
	},
	{
		"stop_id": 8573951,
		"ID": 1281,
		"x": 72.2147746203,
		"y": 73.697217944,
		"h": 1.4945054945
	},
	{
		"stop_id": 8590328,
		"ID": 1281,
		"x": 73.3237178643,
		"y": 72.934228025,
		"h": 1.4945054945
	},
	{
		"stop_id": 8590329,
		"ID": 1281,
		"x": 72.5807447063,
		"y": 73.229181323,
		"h": 1.4945054945
	},
	{
		"stop_id": 8590330,
		"ID": 1281,
		"x": 70.8307234873,
		"y": 74.285178391,
		"h": 1.4945054945
	},
	{
		"stop_id": 8506257,
		"ID": 1379,
		"x": 90.7847404673,
		"y": 56.645161487,
		"h": 1.3296703297
	},
	{
		"stop_id": 8506261,
		"ID": 1379,
		"x": 92.8867182923,
		"y": 57.794236769,
		"h": 1.3296703297
	},
	{
		"stop_id": 8506262,
		"ID": 1379,
		"x": 95.0527205533,
		"y": 56.433237776,
		"h": 1.3296703297
	},
	{
		"stop_id": 8506277,
		"ID": 1379,
		"x": 91.2767242513,
		"y": 58.145173395,
		"h": 1.3296703297
	},
	{
		"stop_id": 8506289,
		"ID": 1379,
		"x": 90.8037234383,
		"y": 56.544214977,
		"h": 1.3296703297
	},
	{
		"stop_id": 8578411,
		"ID": 1379,
		"x": 91.9187568163,
		"y": 58.384210519,
		"h": 1.3296703297
	},
	{
		"stop_id": 8578412,
		"ID": 1379,
		"x": 92.1997400103,
		"y": 58.112249518,
		"h": 1.3296703297
	},
	{
		"stop_id": 8579829,
		"ID": 1379,
		"x": 92.9377443413,
		"y": 59.080213916,
		"h": 1.3296703297
	},
	{
		"stop_id": 8582881,
		"ID": 1379,
		"x": 91.2677571463,
		"y": 58.200219336,
		"h": 1.3296703297
	},
	{
		"stop_id": 8582882,
		"ID": 1379,
		"x": 90.8017741703,
		"y": 56.591209507,
		"h": 1.3296703297
	},
	{
		"stop_id": 8587015,
		"ID": 1379,
		"x": 92.8797479643,
		"y": 57.815188539,
		"h": 1.3296703297
	},
	{
		"stop_id": 8506259,
		"ID": 1354,
		"x": 89.5017416373,
		"y": 56.393209613,
		"h": 1
	},
	{
		"stop_id": 8506260,
		"ID": 1355,
		"x": 91.2387157973,
		"y": 59.305189163,
		"h": 1.8241758242
	},
	{
		"stop_id": 8506271,
		"ID": 1355,
		"x": 86.4347333413,
		"y": 61.552240467,
		"h": 1.8241758242
	},
	{
		"stop_id": 8506275,
		"ID": 1355,
		"x": 90.8237252333,
		"y": 60.417141844,
		"h": 1.8241758242
	},
	{
		"stop_id": 8506286,
		"ID": 1355,
		"x": 89.1717697463,
		"y": 61.235227664,
		"h": 1.8241758242
	},
	{
		"stop_id": 8506288,
		"ID": 1355,
		"x": 91.2727168973,
		"y": 59.351208719,
		"h": 1.8241758242
	},
	{
		"stop_id": 8506380,
		"ID": 1355,
		"x": 90.2217309893,
		"y": 61.598236757,
		"h": 1.8241758242
	},
	{
		"stop_id": 8574054,
		"ID": 1355,
		"x": 88.9197718483,
		"y": 62.069249029,
		"h": 1.8241758242
	},
	{
		"stop_id": 8574055,
		"ID": 1355,
		"x": 88.4497103813,
		"y": 62.672167387,
		"h": 1.8241758242
	},
	{
		"stop_id": 8578413,
		"ID": 1355,
		"x": 91.2747049533,
		"y": 58.87214041,
		"h": 1.8241758242
	},
	{
		"stop_id": 8578419,
		"ID": 1355,
		"x": 90.4857067133,
		"y": 61.475242612,
		"h": 1.8241758242
	},
	{
		"stop_id": 8578421,
		"ID": 1355,
		"x": 89.0577059593,
		"y": 61.860176594,
		"h": 1.8241758242
	},
	{
		"stop_id": 8578423,
		"ID": 1355,
		"x": 89.2417699723,
		"y": 61.287144837,
		"h": 1.8241758242
	},
	{
		"stop_id": 8578425,
		"ID": 1355,
		"x": 90.6067088303,
		"y": 61.82019011,
		"h": 1.8241758242
	},
	{
		"stop_id": 8578426,
		"ID": 1355,
		"x": 90.3867268023,
		"y": 62.308193498,
		"h": 1.8241758242
	},
	{
		"stop_id": 8579824,
		"ID": 1355,
		"x": 88.0577137843,
		"y": 57.555168216,
		"h": 1.8241758242
	},
	{
		"stop_id": 8579825,
		"ID": 1355,
		"x": 87.5517022553,
		"y": 60.536249089,
		"h": 1.8241758242
	},
	{
		"stop_id": 8579830,
		"ID": 1355,
		"x": 89.5827396713,
		"y": 60.055223323,
		"h": 1.8241758242
	},
	{
		"stop_id": 8579831,
		"ID": 1355,
		"x": 90.8077391263,
		"y": 60.430193056,
		"h": 1.8241758242
	},
	{
		"stop_id": 8579832,
		"ID": 1355,
		"x": 90.4627467603,
		"y": 59.907179778,
		"h": 1.8241758242
	},
	{
		"stop_id": 8579852,
		"ID": 1355,
		"x": 89.6577447923,
		"y": 62.630206479,
		"h": 1.8241758242
	},
	{
		"stop_id": 8581180,
		"ID": 1355,
		"x": 89.5087477823,
		"y": 61.684228785,
		"h": 1.8241758242
	},
	{
		"stop_id": 8581181,
		"ID": 1355,
		"x": 89.3227661603,
		"y": 61.53318866,
		"h": 1.8241758242
	},
	{
		"stop_id": 8581182,
		"ID": 1355,
		"x": 89.3807756723,
		"y": 61.881196762,
		"h": 1.8241758242
	},
	{
		"stop_id": 8581183,
		"ID": 1355,
		"x": 90.0787190673,
		"y": 61.707171302,
		"h": 1.8241758242
	},
	{
		"stop_id": 8582797,
		"ID": 1355,
		"x": 86.4127186583,
		"y": 61.620205813,
		"h": 1.8241758242
	},
	{
		"stop_id": 8583201,
		"ID": 1355,
		"x": 89.7277119163,
		"y": 61.825207478,
		"h": 1.8241758242
	},
	{
		"stop_id": 8506265,
		"ID": 1332,
		"x": 83.1567286673,
		"y": 56.998237513,
		"h": 1
	},
	{
		"stop_id": 8506266,
		"ID": 1333,
		"x": 83.1117640233,
		"y": 60.155246893,
		"h": 1.2637362637
	},
	{
		"stop_id": 8506284,
		"ID": 1333,
		"x": 83.1097670993,
		"y": 60.172214317,
		"h": 1.2637362637
	},
	{
		"stop_id": 8506285,
		"ID": 1333,
		"x": 84.5547653043,
		"y": 61.131166564,
		"h": 1.2637362637
	},
	{
		"stop_id": 8506603,
		"ID": 1333,
		"x": 83.3067111383,
		"y": 65.683147736,
		"h": 1.2637362637
	},
	{
		"stop_id": 8506713,
		"ID": 1333,
		"x": 82.8057410343,
		"y": 64.950181132,
		"h": 1.2637362637
	},
	{
		"stop_id": 8506759,
		"ID": 1333,
		"x": 82.1577022563,
		"y": 65.130248863,
		"h": 1.2637362637
	},
	{
		"stop_id": 8579833,
		"ID": 1333,
		"x": 85.5787222333,
		"y": 63.906179987,
		"h": 1.2637362637
	},
	{
		"stop_id": 8582796,
		"ID": 1333,
		"x": 83.1477048033,
		"y": 60.239188814,
		"h": 1.2637362637
	},
	{
		"stop_id": 8582798,
		"ID": 1333,
		"x": 84.5117728853,
		"y": 61.16715437,
		"h": 1.2637362637
	},
	{
		"stop_id": 8506267,
		"ID": 1306,
		"x": 77.4827083273,
		"y": 51.78015909,
		"h": 1.2307692308
	},
	{
		"stop_id": 8506791,
		"ID": 1306,
		"x": 79.5327664463,
		"y": 55.555178882,
		"h": 1.2307692308
	},
	{
		"stop_id": 8506792,
		"ID": 1306,
		"x": 80.3467166013,
		"y": 54.866154111,
		"h": 1.2307692308
	},
	{
		"stop_id": 8506793,
		"ID": 1306,
		"x": 81.0187621213,
		"y": 53.775183098,
		"h": 1.2307692308
	},
	{
		"stop_id": 8506795,
		"ID": 1306,
		"x": 81.3897232223,
		"y": 53.883191263,
		"h": 1.2307692308
	},
	{
		"stop_id": 8574045,
		"ID": 1306,
		"x": 78.8227163753,
		"y": 51.443179782,
		"h": 1.2307692308
	},
	{
		"stop_id": 8574046,
		"ID": 1306,
		"x": 79.9307310173,
		"y": 52.150181961,
		"h": 1.2307692308
	},
	{
		"stop_id": 8574051,
		"ID": 1306,
		"x": 79.5247048023,
		"y": 56.295202214,
		"h": 1.2307692308
	},
	{
		"stop_id": 8506268,
		"ID": 1331,
		"x": 82.4757064203,
		"y": 53.077147655,
		"h": 1.0989010989
	},
	{
		"stop_id": 8506269,
		"ID": 1331,
		"x": 84.3557070553,
		"y": 52.335222525,
		"h": 1.0989010989
	},
	{
		"stop_id": 8506787,
		"ID": 1331,
		"x": 82.5427383943,
		"y": 53.05717914,
		"h": 1.0989010989
	},
	{
		"stop_id": 8506794,
		"ID": 1331,
		"x": 81.8217151363,
		"y": 52.974215963,
		"h": 1.0989010989
	},
	{
		"stop_id": 8506270,
		"ID": 1357,
		"x": 86.4507235993,
		"y": 72.078141495,
		"h": 4.6263736264
	},
	{
		"stop_id": 8506302,
		"ID": 1357,
		"x": 85.9687668543,
		"y": 71.709244756,
		"h": 4.6263736264
	},
	{
		"stop_id": 8506303,
		"ID": 1357,
		"x": 87.7137475333,
		"y": 73.016247912,
		"h": 4.6263736264
	},
	{
		"stop_id": 8506358,
		"ID": 1357,
		"x": 86.7067082083,
		"y": 71.890173639,
		"h": 4.6263736264
	},
	{
		"stop_id": 8506359,
		"ID": 1357,
		"x": 87.2957018893,
		"y": 71.934141776,
		"h": 4.6263736264
	},
	{
		"stop_id": 8506361,
		"ID": 1357,
		"x": 88.4787509983,
		"y": 72.012149198,
		"h": 4.6263736264
	},
	{
		"stop_id": 8506362,
		"ID": 1357,
		"x": 89.4077171713,
		"y": 71.710175796,
		"h": 4.6263736264
	},
	{
		"stop_id": 8506363,
		"ID": 1357,
		"x": 90.0447681993,
		"y": 71.47524467,
		"h": 4.6263736264
	},
	{
		"stop_id": 8506364,
		"ID": 1357,
		"x": 90.9797631423,
		"y": 71.044207147,
		"h": 4.6263736264
	},
	{
		"stop_id": 8506365,
		"ID": 1357,
		"x": 91.0867475043,
		"y": 70.694143787,
		"h": 4.6263736264
	},
	{
		"stop_id": 8506370,
		"ID": 1357,
		"x": 86.0217678273,
		"y": 71.736241356,
		"h": 4.6263736264
	},
	{
		"stop_id": 8506459,
		"ID": 1357,
		"x": 87.6697268223,
		"y": 73.762208781,
		"h": 4.6263736264
	},
	{
		"stop_id": 8506653,
		"ID": 1357,
		"x": 87.0537599653,
		"y": 72.991159992,
		"h": 4.6263736264
	},
	{
		"stop_id": 8506654,
		"ID": 1357,
		"x": 88.6547061093,
		"y": 73.287238613,
		"h": 4.6263736264
	},
	{
		"stop_id": 8518100,
		"ID": 1357,
		"x": 87.7377287233,
		"y": 72.06014221,
		"h": 4.6263736264
	},
	{
		"stop_id": 8574069,
		"ID": 1357,
		"x": 88.6077660173,
		"y": 68.788157592,
		"h": 4.6263736264
	},
	{
		"stop_id": 8574070,
		"ID": 1357,
		"x": 89.2047446103,
		"y": 69.03114377,
		"h": 4.6263736264
	},
	{
		"stop_id": 8574071,
		"ID": 1357,
		"x": 89.8427683353,
		"y": 69.381219876,
		"h": 4.6263736264
	},
	{
		"stop_id": 8574095,
		"ID": 1357,
		"x": 86.0017758323,
		"y": 71.610184222,
		"h": 4.6263736264
	},
	{
		"stop_id": 8574223,
		"ID": 1357,
		"x": 85.7607198133,
		"y": 71.443209286,
		"h": 4.6263736264
	},
	{
		"stop_id": 8574239,
		"ID": 1357,
		"x": 86.6437424893,
		"y": 72.449154813,
		"h": 4.6263736264
	},
	{
		"stop_id": 8574257,
		"ID": 1357,
		"x": 86.1217146433,
		"y": 71.561200756,
		"h": 4.6263736264
	},
	{
		"stop_id": 8574458,
		"ID": 1357,
		"x": 90.4747555183,
		"y": 73.766154773,
		"h": 4.6263736264
	},
	{
		"stop_id": 8574460,
		"ID": 1357,
		"x": 90.0107182853,
		"y": 73.95024789,
		"h": 4.6263736264
	},
	{
		"stop_id": 8574462,
		"ID": 1357,
		"x": 89.2827218473,
		"y": 73.316149391,
		"h": 4.6263736264
	},
	{
		"stop_id": 8574465,
		"ID": 1357,
		"x": 87.8667200813,
		"y": 72.674171881,
		"h": 4.6263736264
	},
	{
		"stop_id": 8574466,
		"ID": 1357,
		"x": 91.0577082533,
		"y": 72.097221346,
		"h": 4.6263736264
	},
	{
		"stop_id": 8574467,
		"ID": 1357,
		"x": 87.3417392613,
		"y": 72.429206945,
		"h": 4.6263736264
	},
	{
		"stop_id": 8574468,
		"ID": 1357,
		"x": 90.0487211103,
		"y": 72.911190899,
		"h": 4.6263736264
	},
	{
		"stop_id": 8574469,
		"ID": 1357,
		"x": 86.7817619653,
		"y": 72.093225181,
		"h": 4.6263736264
	},
	{
		"stop_id": 8574470,
		"ID": 1357,
		"x": 89.1907168233,
		"y": 72.954148227,
		"h": 4.6263736264
	},
	{
		"stop_id": 8574471,
		"ID": 1357,
		"x": 86.4677097583,
		"y": 72.093241966,
		"h": 4.6263736264
	},
	{
		"stop_id": 8574472,
		"ID": 1357,
		"x": 88.6677046663,
		"y": 72.835235661,
		"h": 4.6263736264
	},
	{
		"stop_id": 8580688,
		"ID": 1357,
		"x": 89.2607107553,
		"y": 74.02818033,
		"h": 4.6263736264
	},
	{
		"stop_id": 8580689,
		"ID": 1357,
		"x": 88.6497323313,
		"y": 73.365189879,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589553,
		"ID": 1357,
		"x": 89.1117250583,
		"y": 73.26224036,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589554,
		"ID": 1357,
		"x": 88.0547479753,
		"y": 70.814174786,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589555,
		"ID": 1357,
		"x": 87.6447562993,
		"y": 73.150215772,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589556,
		"ID": 1357,
		"x": 85.9007170783,
		"y": 71.766181185,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589557,
		"ID": 1357,
		"x": 87.8517667513,
		"y": 73.113224695,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589559,
		"ID": 1357,
		"x": 86.3327626503,
		"y": 71.353202287,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589560,
		"ID": 1357,
		"x": 86.2557187013,
		"y": 72.077219393,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589561,
		"ID": 1357,
		"x": 88.8397626853,
		"y": 73.277202597,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589563,
		"ID": 1357,
		"x": 88.9267530413,
		"y": 73.61115609,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589565,
		"ID": 1357,
		"x": 86.2117453743,
		"y": 71.776180122,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589567,
		"ID": 1357,
		"x": 88.3847077003,
		"y": 72.645188105,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589568,
		"ID": 1357,
		"x": 86.5067687733,
		"y": 72.580230276,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589570,
		"ID": 1357,
		"x": 87.2637102663,
		"y": 70.873215747,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589571,
		"ID": 1357,
		"x": 87.8037586453,
		"y": 72.351179236,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589574,
		"ID": 1357,
		"x": 89.2127152103,
		"y": 73.384232241,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589575,
		"ID": 1357,
		"x": 86.2207509643,
		"y": 72.650241409,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589576,
		"ID": 1357,
		"x": 85.7027156113,
		"y": 71.125147552,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589577,
		"ID": 1357,
		"x": 87.0987444533,
		"y": 73.544143411,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589579,
		"ID": 1357,
		"x": 88.4297397333,
		"y": 73.128228341,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589581,
		"ID": 1357,
		"x": 88.1227125973,
		"y": 72.547212609,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589583,
		"ID": 1357,
		"x": 89.0017477013,
		"y": 72.912246892,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589584,
		"ID": 1357,
		"x": 88.2757052583,
		"y": 73.38818441,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589585,
		"ID": 1357,
		"x": 87.7987298513,
		"y": 73.887209957,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589586,
		"ID": 1357,
		"x": 87.3077325383,
		"y": 73.284189048,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589588,
		"ID": 1357,
		"x": 88.4697328873,
		"y": 74.131206022,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589589,
		"ID": 1357,
		"x": 87.5327401563,
		"y": 73.715198798,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589591,
		"ID": 1357,
		"x": 86.9027430093,
		"y": 71.015183212,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589592,
		"ID": 1357,
		"x": 88.9897124673,
		"y": 74.066181631,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589594,
		"ID": 1357,
		"x": 88.1557425143,
		"y": 72.862231769,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589597,
		"ID": 1357,
		"x": 88.5257336503,
		"y": 73.43815485,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589598,
		"ID": 1357,
		"x": 85.7567035013,
		"y": 71.020150865,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589601,
		"ID": 1357,
		"x": 86.7187766903,
		"y": 71.31714386,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589602,
		"ID": 1357,
		"x": 85.5487330443,
		"y": 71.807242664,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589603,
		"ID": 1357,
		"x": 86.6007013523,
		"y": 73.05723256,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589604,
		"ID": 1357,
		"x": 85.9737569003,
		"y": 71.252152259,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589605,
		"ID": 1357,
		"x": 86.8547726553,
		"y": 72.686158665,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589606,
		"ID": 1357,
		"x": 88.4107724533,
		"y": 73.804189412,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589607,
		"ID": 1357,
		"x": 87.5397114273,
		"y": 73.341231757,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589608,
		"ID": 1357,
		"x": 86.8397499983,
		"y": 71.184230807,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589609,
		"ID": 1357,
		"x": 86.2587078493,
		"y": 71.913246806,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589611,
		"ID": 1357,
		"x": 85.5337279693,
		"y": 71.502249768,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589613,
		"ID": 1357,
		"x": 86.4697181243,
		"y": 73.273205343,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589615,
		"ID": 1357,
		"x": 85.6467723663,
		"y": 70.861189025,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589617,
		"ID": 1357,
		"x": 88.4157485073,
		"y": 73.521149399,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589618,
		"ID": 1357,
		"x": 89.6047196573,
		"y": 73.253200079,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589620,
		"ID": 1357,
		"x": 86.2297267163,
		"y": 72.01718779,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589624,
		"ID": 1357,
		"x": 86.5197572783,
		"y": 73.587188592,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589625,
		"ID": 1357,
		"x": 87.0837644373,
		"y": 72.23817714,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589626,
		"ID": 1357,
		"x": 86.6847123713,
		"y": 73.547226817,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589627,
		"ID": 1357,
		"x": 86.8267196303,
		"y": 73.538175856,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589628,
		"ID": 1357,
		"x": 85.4257146283,
		"y": 71.302188427,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589629,
		"ID": 1357,
		"x": 87.5857754123,
		"y": 72.573189569,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589630,
		"ID": 1357,
		"x": 87.7537376103,
		"y": 70.830243692,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589631,
		"ID": 1357,
		"x": 88.8037255833,
		"y": 74.123234966,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589633,
		"ID": 1357,
		"x": 87.5477251783,
		"y": 73.598235833,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589634,
		"ID": 1357,
		"x": 88.0447594933,
		"y": 73.160194663,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589635,
		"ID": 1357,
		"x": 86.1677108193,
		"y": 72.319171815,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589637,
		"ID": 1357,
		"x": 86.5567722213,
		"y": 72.798230821,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589639,
		"ID": 1357,
		"x": 89.3547510553,
		"y": 72.994203799,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589643,
		"ID": 1357,
		"x": 86.4047428643,
		"y": 73.096208534,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589645,
		"ID": 1357,
		"x": 89.6717599723,
		"y": 73.452197002,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589647,
		"ID": 1357,
		"x": 85.9367390053,
		"y": 71.986166697,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589649,
		"ID": 1357,
		"x": 89.1847334723,
		"y": 73.926169038,
		"h": 4.6263736264
	},
	{
		"stop_id": 8589913,
		"ID": 1357,
		"x": 86.5577148123,
		"y": 71.603216016,
		"h": 4.6263736264
	},
	{
		"stop_id": 8594234,
		"ID": 1357,
		"x": 91.6527687703,
		"y": 71.106207214,
		"h": 4.6263736264
	},
	{
		"stop_id": 8594345,
		"ID": 1357,
		"x": 86.2757488203,
		"y": 71.565221985,
		"h": 4.6263736264
	},
	{
		"stop_id": 8594346,
		"ID": 1357,
		"x": 86.5137631313,
		"y": 71.613251353,
		"h": 4.6263736264
	},
	{
		"stop_id": 8594347,
		"ID": 1357,
		"x": 86.8467341883,
		"y": 71.932233519,
		"h": 4.6263736264
	},
	{
		"stop_id": 8594348,
		"ID": 1357,
		"x": 87.0457100223,
		"y": 72.409176502,
		"h": 4.6263736264
	},
	{
		"stop_id": 8594349,
		"ID": 1357,
		"x": 87.4057067563,
		"y": 72.758224979,
		"h": 4.6263736264
	},
	{
		"stop_id": 8594350,
		"ID": 1357,
		"x": 87.7027640263,
		"y": 72.83924743,
		"h": 4.6263736264
	},
	{
		"stop_id": 8594351,
		"ID": 1357,
		"x": 87.7367569413,
		"y": 72.983233348,
		"h": 4.6263736264
	},
	{
		"stop_id": 8594352,
		"ID": 1357,
		"x": 87.8047080403,
		"y": 74.095227845,
		"h": 4.6263736264
	},
	{
		"stop_id": 8595613,
		"ID": 1357,
		"x": 86.6807678743,
		"y": 71.767191895,
		"h": 4.6263736264
	},
	{
		"stop_id": 8595871,
		"ID": 1357,
		"x": 89.5677521873,
		"y": 73.734182783,
		"h": 4.6263736264
	},
	{
		"stop_id": 8595872,
		"ID": 1357,
		"x": 89.6487271933,
		"y": 73.883148899,
		"h": 4.6263736264
	},
	{
		"stop_id": 8506276,
		"ID": 1356,
		"x": 90.8127616563,
		"y": 65.520169502,
		"h": 1.6593406593
	},
	{
		"stop_id": 8506375,
		"ID": 1356,
		"x": 87.5827062503,
		"y": 68.089140395,
		"h": 1.6593406593
	},
	{
		"stop_id": 8506376,
		"ID": 1356,
		"x": 88.7327014833,
		"y": 66.642231929,
		"h": 1.6593406593
	},
	{
		"stop_id": 8506377,
		"ID": 1356,
		"x": 89.9757295043,
		"y": 66.230210402,
		"h": 1.6593406593
	},
	{
		"stop_id": 8506470,
		"ID": 1356,
		"x": 86.8247021113,
		"y": 68.163194926,
		"h": 1.6593406593
	},
	{
		"stop_id": 8574056,
		"ID": 1356,
		"x": 88.2687574313,
		"y": 63.467176576,
		"h": 1.6593406593
	},
	{
		"stop_id": 8574057,
		"ID": 1356,
		"x": 87.5707347203,
		"y": 63.810233097,
		"h": 1.6593406593
	},
	{
		"stop_id": 8574058,
		"ID": 1356,
		"x": 86.6587646873,
		"y": 64.205244726,
		"h": 1.6593406593
	},
	{
		"stop_id": 8574059,
		"ID": 1356,
		"x": 86.0977120463,
		"y": 64.720237263,
		"h": 1.6593406593
	},
	{
		"stop_id": 8574060,
		"ID": 1356,
		"x": 86.0097145163,
		"y": 65.087195771,
		"h": 1.6593406593
	},
	{
		"stop_id": 8574061,
		"ID": 1356,
		"x": 86.0077613793,
		"y": 65.280217865,
		"h": 1.6593406593
	},
	{
		"stop_id": 8574062,
		"ID": 1356,
		"x": 85.9447685473,
		"y": 65.6202114,
		"h": 1.6593406593
	},
	{
		"stop_id": 8574063,
		"ID": 1356,
		"x": 85.8127683343,
		"y": 66.192173835,
		"h": 1.6593406593
	},
	{
		"stop_id": 8574064,
		"ID": 1356,
		"x": 86.3557416323,
		"y": 66.869168487,
		"h": 1.6593406593
	},
	{
		"stop_id": 8574065,
		"ID": 1356,
		"x": 87.3757403353,
		"y": 67.494210768,
		"h": 1.6593406593
	},
	{
		"stop_id": 8574066,
		"ID": 1356,
		"x": 87.5727072593,
		"y": 68.081217631,
		"h": 1.6593406593
	},
	{
		"stop_id": 8574067,
		"ID": 1356,
		"x": 87.5567724813,
		"y": 68.172241724,
		"h": 1.6593406593
	},
	{
		"stop_id": 8574068,
		"ID": 1356,
		"x": 88.3087103243,
		"y": 68.468149884,
		"h": 1.6593406593
	},
	{
		"stop_id": 8579823,
		"ID": 1356,
		"x": 87.4247283633,
		"y": 62.875174416,
		"h": 1.6593406593
	},
	{
		"stop_id": 8579828,
		"ID": 1356,
		"x": 88.1327204353,
		"y": 64.505208043,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583762,
		"ID": 1356,
		"x": 86.8287228653,
		"y": 68.144165157,
		"h": 1.6593406593
	},
	{
		"stop_id": 8506278,
		"ID": 1407,
		"x": 96.8577467993,
		"y": 78.031197991,
		"h": 2.8791208791
	},
	{
		"stop_id": 8506311,
		"ID": 1407,
		"x": 96.0107254793,
		"y": 78.062206411,
		"h": 2.8791208791
	},
	{
		"stop_id": 8506312,
		"ID": 1407,
		"x": 98.3677184313,
		"y": 78.43321226,
		"h": 2.8791208791
	},
	{
		"stop_id": 8506352,
		"ID": 1407,
		"x": 98.1727546743,
		"y": 77.430195259,
		"h": 2.8791208791
	},
	{
		"stop_id": 8506353,
		"ID": 1407,
		"x": 98.7207734133,
		"y": 76.823219935,
		"h": 2.8791208791
	},
	{
		"stop_id": 8506354,
		"ID": 1407,
		"x": 97.9957732463,
		"y": 76.047168882,
		"h": 2.8791208791
	},
	{
		"stop_id": 8506355,
		"ID": 1407,
		"x": 98.4887140853,
		"y": 74.6151949,
		"h": 2.8791208791
	},
	{
		"stop_id": 8506400,
		"ID": 1407,
		"x": 97.2707161353,
		"y": 77.805243645,
		"h": 2.8791208791
	},
	{
		"stop_id": 8506634,
		"ID": 1407,
		"x": 98.8567626723,
		"y": 78.11619564,
		"h": 2.8791208791
	},
	{
		"stop_id": 8506693,
		"ID": 1407,
		"x": 95.8677276553,
		"y": 77.324248051,
		"h": 2.8791208791
	},
	{
		"stop_id": 8506762,
		"ID": 1407,
		"x": 100.9717315263,
		"y": 76.173243235,
		"h": 2.8791208791
	},
	{
		"stop_id": 8506777,
		"ID": 1407,
		"x": 100.7347595783,
		"y": 76.847178767,
		"h": 2.8791208791
	},
	{
		"stop_id": 8506782,
		"ID": 1407,
		"x": 99.4527633983,
		"y": 75.419196813,
		"h": 2.8791208791
	},
	{
		"stop_id": 8506796,
		"ID": 1407,
		"x": 98.3577730143,
		"y": 74.430174844,
		"h": 2.8791208791
	},
	{
		"stop_id": 8530830,
		"ID": 1407,
		"x": 98.0327049363,
		"y": 78.580198522,
		"h": 2.8791208791
	},
	{
		"stop_id": 8574076,
		"ID": 1407,
		"x": 97.9687115963,
		"y": 74.680164022,
		"h": 2.8791208791
	},
	{
		"stop_id": 8574077,
		"ID": 1407,
		"x": 98.4577242483,
		"y": 74.555194424,
		"h": 2.8791208791
	},
	{
		"stop_id": 8574083,
		"ID": 1407,
		"x": 98.9647663523,
		"y": 74.760196453,
		"h": 2.8791208791
	},
	{
		"stop_id": 8574084,
		"ID": 1407,
		"x": 99.1537592913,
		"y": 75.159230156,
		"h": 2.8791208791
	},
	{
		"stop_id": 8574085,
		"ID": 1407,
		"x": 99.5577571893,
		"y": 75.697195986,
		"h": 2.8791208791
	},
	{
		"stop_id": 8574086,
		"ID": 1407,
		"x": 99.9077395383,
		"y": 75.710193801,
		"h": 2.8791208791
	},
	{
		"stop_id": 8574087,
		"ID": 1407,
		"x": 100.0577440903,
		"y": 75.505141215,
		"h": 2.8791208791
	},
	{
		"stop_id": 8574088,
		"ID": 1407,
		"x": 100.5167335233,
		"y": 75.989160535,
		"h": 2.8791208791
	},
	{
		"stop_id": 8574114,
		"ID": 1407,
		"x": 100.5697642553,
		"y": 75.655251468,
		"h": 2.8791208791
	},
	{
		"stop_id": 8574281,
		"ID": 1407,
		"x": 95.5097175803,
		"y": 77.543178364,
		"h": 2.8791208791
	},
	{
		"stop_id": 8574282,
		"ID": 1407,
		"x": 95.7937745883,
		"y": 77.495144376,
		"h": 2.8791208791
	},
	{
		"stop_id": 8574288,
		"ID": 1407,
		"x": 95.6987209193,
		"y": 77.284210097,
		"h": 2.8791208791
	},
	{
		"stop_id": 8574295,
		"ID": 1407,
		"x": 101.6617349253,
		"y": 76.935144947,
		"h": 2.8791208791
	},
	{
		"stop_id": 8574296,
		"ID": 1407,
		"x": 101.1487698203,
		"y": 76.855205415,
		"h": 2.8791208791
	},
	{
		"stop_id": 8574298,
		"ID": 1407,
		"x": 100.1837490353,
		"y": 77.236221977,
		"h": 2.8791208791
	},
	{
		"stop_id": 8574299,
		"ID": 1407,
		"x": 99.5067629903,
		"y": 77.520148093,
		"h": 2.8791208791
	},
	{
		"stop_id": 8574300,
		"ID": 1407,
		"x": 98.5557006383,
		"y": 78.171190392,
		"h": 2.8791208791
	},
	{
		"stop_id": 8574301,
		"ID": 1407,
		"x": 98.1517067263,
		"y": 78.105216943,
		"h": 2.8791208791
	},
	{
		"stop_id": 8574302,
		"ID": 1407,
		"x": 97.7007652253,
		"y": 77.981184501,
		"h": 2.8791208791
	},
	{
		"stop_id": 8574303,
		"ID": 1407,
		"x": 97.0707610613,
		"y": 77.730197782,
		"h": 2.8791208791
	},
	{
		"stop_id": 8574304,
		"ID": 1407,
		"x": 96.4677234273,
		"y": 77.524148466,
		"h": 2.8791208791
	},
	{
		"stop_id": 8574446,
		"ID": 1407,
		"x": 96.9157616303,
		"y": 74.665193346,
		"h": 2.8791208791
	},
	{
		"stop_id": 8574447,
		"ID": 1407,
		"x": 96.6837419403,
		"y": 75.333179951,
		"h": 2.8791208791
	},
	{
		"stop_id": 8574475,
		"ID": 1407,
		"x": 99.7527560983,
		"y": 75.219177397,
		"h": 2.8791208791
	},
	{
		"stop_id": 8574476,
		"ID": 1407,
		"x": 99.9087368403,
		"y": 74.790163129,
		"h": 2.8791208791
	},
	{
		"stop_id": 8577228,
		"ID": 1407,
		"x": 96.0077643923,
		"y": 78.08014677,
		"h": 2.8791208791
	},
	{
		"stop_id": 8580917,
		"ID": 1407,
		"x": 97.4427340613,
		"y": 78.006239022,
		"h": 2.8791208791
	},
	{
		"stop_id": 8580918,
		"ID": 1407,
		"x": 97.3067184323,
		"y": 77.87215655,
		"h": 2.8791208791
	},
	{
		"stop_id": 8581126,
		"ID": 1407,
		"x": 97.2087013503,
		"y": 78.0221541,
		"h": 2.8791208791
	},
	{
		"stop_id": 8581484,
		"ID": 1407,
		"x": 96.9257445403,
		"y": 78.100179764,
		"h": 2.8791208791
	},
	{
		"stop_id": 8581486,
		"ID": 1407,
		"x": 97.7827710913,
		"y": 78.305144655,
		"h": 2.8791208791
	},
	{
		"stop_id": 8581487,
		"ID": 1407,
		"x": 98.1247643193,
		"y": 78.408143455,
		"h": 2.8791208791
	},
	{
		"stop_id": 8581488,
		"ID": 1407,
		"x": 98.8517251173,
		"y": 78.759169905,
		"h": 2.8791208791
	},
	{
		"stop_id": 8581489,
		"ID": 1407,
		"x": 99.4447106073,
		"y": 79.328241758,
		"h": 2.8791208791
	},
	{
		"stop_id": 8581490,
		"ID": 1407,
		"x": 99.5657146813,
		"y": 79.535158781,
		"h": 2.8791208791
	},
	{
		"stop_id": 8581491,
		"ID": 1407,
		"x": 100.2347688333,
		"y": 79.586156405,
		"h": 2.8791208791
	},
	{
		"stop_id": 8581492,
		"ID": 1407,
		"x": 100.9207493733,
		"y": 78.65922266,
		"h": 2.8791208791
	},
	{
		"stop_id": 8581508,
		"ID": 1407,
		"x": 99.1917249993,
		"y": 78.971180195,
		"h": 2.8791208791
	},
	{
		"stop_id": 8581509,
		"ID": 1407,
		"x": 99.8097223843,
		"y": 79.522165867,
		"h": 2.8791208791
	},
	{
		"stop_id": 8581531,
		"ID": 1407,
		"x": 98.4077145703,
		"y": 78.505244437,
		"h": 2.8791208791
	},
	{
		"stop_id": 8581622,
		"ID": 1407,
		"x": 96.4577073533,
		"y": 77.980238708,
		"h": 2.8791208791
	},
	{
		"stop_id": 8591810,
		"ID": 1407,
		"x": 96.0407249633,
		"y": 77.968233626,
		"h": 2.8791208791
	},
	{
		"stop_id": 8595443,
		"ID": 1407,
		"x": 95.7227043143,
		"y": 77.780233573,
		"h": 2.8791208791
	},
	{
		"stop_id": 8506280,
		"ID": 1308,
		"x": 79.2697461413,
		"y": 66.24619395,
		"h": 3.043956044
	},
	{
		"stop_id": 8506281,
		"ID": 1308,
		"x": 79.8437016483,
		"y": 64.253191121,
		"h": 3.043956044
	},
	{
		"stop_id": 8506290,
		"ID": 1308,
		"x": 79.0337355693,
		"y": 67.871153493,
		"h": 3.043956044
	},
	{
		"stop_id": 8506291,
		"ID": 1308,
		"x": 76.5327746313,
		"y": 67.300159204,
		"h": 3.043956044
	},
	{
		"stop_id": 8506601,
		"ID": 1308,
		"x": 78.0777201853,
		"y": 62.910231524,
		"h": 3.043956044
	},
	{
		"stop_id": 8506608,
		"ID": 1308,
		"x": 78.3747185993,
		"y": 63.266238467,
		"h": 3.043956044
	},
	{
		"stop_id": 8506696,
		"ID": 1308,
		"x": 78.0877619853,
		"y": 66.214234152,
		"h": 3.043956044
	},
	{
		"stop_id": 8506697,
		"ID": 1308,
		"x": 77.7827123993,
		"y": 65.355148024,
		"h": 3.043956044
	},
	{
		"stop_id": 8506709,
		"ID": 1308,
		"x": 80.2387708253,
		"y": 64.775202192,
		"h": 3.043956044
	},
	{
		"stop_id": 8506710,
		"ID": 1308,
		"x": 77.7077493683,
		"y": 65.655237442,
		"h": 3.043956044
	},
	{
		"stop_id": 8506712,
		"ID": 1308,
		"x": 79.7107137593,
		"y": 65.164226832,
		"h": 3.043956044
	},
	{
		"stop_id": 8506774,
		"ID": 1308,
		"x": 77.0527639783,
		"y": 63.565205278,
		"h": 3.043956044
	},
	{
		"stop_id": 8574189,
		"ID": 1308,
		"x": 77.6317026873,
		"y": 62.844159445,
		"h": 3.043956044
	},
	{
		"stop_id": 8574190,
		"ID": 1308,
		"x": 78.8997136103,
		"y": 63.699211866,
		"h": 3.043956044
	},
	{
		"stop_id": 8574194,
		"ID": 1308,
		"x": 79.4127044673,
		"y": 66.11320383,
		"h": 3.043956044
	},
	{
		"stop_id": 8574195,
		"ID": 1308,
		"x": 79.2387228343,
		"y": 66.657176092,
		"h": 3.043956044
	},
	{
		"stop_id": 8574206,
		"ID": 1308,
		"x": 78.7827503753,
		"y": 67.268173779,
		"h": 3.043956044
	},
	{
		"stop_id": 8574207,
		"ID": 1308,
		"x": 78.3727365053,
		"y": 66.874246061,
		"h": 3.043956044
	},
	{
		"stop_id": 8574208,
		"ID": 1308,
		"x": 78.3407362043,
		"y": 66.672205053,
		"h": 3.043956044
	},
	{
		"stop_id": 8574209,
		"ID": 1308,
		"x": 77.5397634963,
		"y": 64.150206814,
		"h": 3.043956044
	},
	{
		"stop_id": 8574211,
		"ID": 1308,
		"x": 76.9917022263,
		"y": 63.329140835,
		"h": 3.043956044
	},
	{
		"stop_id": 8578507,
		"ID": 1308,
		"x": 79.0287673163,
		"y": 67.838229147,
		"h": 3.043956044
	},
	{
		"stop_id": 8581401,
		"ID": 1308,
		"x": 80.2877552893,
		"y": 68.027237091,
		"h": 3.043956044
	},
	{
		"stop_id": 8581402,
		"ID": 1308,
		"x": 79.7717367343,
		"y": 67.654168426,
		"h": 3.043956044
	},
	{
		"stop_id": 8581667,
		"ID": 1308,
		"x": 79.5637094173,
		"y": 64.131163166,
		"h": 3.043956044
	},
	{
		"stop_id": 8581741,
		"ID": 1308,
		"x": 79.8987528493,
		"y": 64.399175784,
		"h": 3.043956044
	},
	{
		"stop_id": 8587121,
		"ID": 1308,
		"x": 76.8097414213,
		"y": 63.875216993,
		"h": 3.043956044
	},
	{
		"stop_id": 8588062,
		"ID": 1308,
		"x": 78.2587619733,
		"y": 66.423180263,
		"h": 3.043956044
	},
	{
		"stop_id": 8588239,
		"ID": 1308,
		"x": 79.2577434033,
		"y": 67.430219862,
		"h": 3.043956044
	},
	{
		"stop_id": 8588243,
		"ID": 1308,
		"x": 77.6977392163,
		"y": 64.950144358,
		"h": 3.043956044
	},
	{
		"stop_id": 8588244,
		"ID": 1308,
		"x": 77.0287752853,
		"y": 63.789186711,
		"h": 3.043956044
	},
	{
		"stop_id": 8589112,
		"ID": 1308,
		"x": 78.7777695733,
		"y": 67.510167978,
		"h": 3.043956044
	},
	{
		"stop_id": 8589113,
		"ID": 1308,
		"x": 78.6477512823,
		"y": 67.770146899,
		"h": 3.043956044
	},
	{
		"stop_id": 8590324,
		"ID": 1308,
		"x": 78.2207229723,
		"y": 68.370185633,
		"h": 3.043956044
	},
	{
		"stop_id": 8590325,
		"ID": 1308,
		"x": 78.6307441893,
		"y": 68.097160865,
		"h": 3.043956044
	},
	{
		"stop_id": 8590326,
		"ID": 1308,
		"x": 79.0897238833,
		"y": 67.551170852,
		"h": 3.043956044
	},
	{
		"stop_id": 8590336,
		"ID": 1308,
		"x": 79.6387632173,
		"y": 68.243249269,
		"h": 3.043956044
	},
	{
		"stop_id": 8590337,
		"ID": 1308,
		"x": 80.1627244823,
		"y": 68.50517047,
		"h": 3.043956044
	},
	{
		"stop_id": 8590338,
		"ID": 1308,
		"x": 79.9077155353,
		"y": 68.290179497,
		"h": 3.043956044
	},
	{
		"stop_id": 8590339,
		"ID": 1308,
		"x": 79.5677522283,
		"y": 68.000244637,
		"h": 3.043956044
	},
	{
		"stop_id": 8590340,
		"ID": 1308,
		"x": 79.3777087593,
		"y": 67.72819709,
		"h": 3.043956044
	},
	{
		"stop_id": 8590341,
		"ID": 1308,
		"x": 79.5247741293,
		"y": 67.464185805,
		"h": 3.043956044
	},
	{
		"stop_id": 8590342,
		"ID": 1308,
		"x": 80.0227571483,
		"y": 67.857158383,
		"h": 3.043956044
	},
	{
		"stop_id": 8590346,
		"ID": 1308,
		"x": 79.1107490713,
		"y": 67.247162205,
		"h": 3.043956044
	},
	{
		"stop_id": 8590347,
		"ID": 1308,
		"x": 79.0977453523,
		"y": 66.964153754,
		"h": 3.043956044
	},
	{
		"stop_id": 8590348,
		"ID": 1308,
		"x": 79.2967233823,
		"y": 66.265177276,
		"h": 3.043956044
	},
	{
		"stop_id": 8590349,
		"ID": 1308,
		"x": 79.4707550383,
		"y": 65.742227326,
		"h": 3.043956044
	},
	{
		"stop_id": 8590350,
		"ID": 1308,
		"x": 78.3687093833,
		"y": 67.348140823,
		"h": 3.043956044
	},
	{
		"stop_id": 8590351,
		"ID": 1308,
		"x": 78.1247745793,
		"y": 67.590238874,
		"h": 3.043956044
	},
	{
		"stop_id": 8590352,
		"ID": 1308,
		"x": 77.7567762293,
		"y": 67.741161727,
		"h": 3.043956044
	},
	{
		"stop_id": 8590353,
		"ID": 1308,
		"x": 77.3797401953,
		"y": 68.208186452,
		"h": 3.043956044
	},
	{
		"stop_id": 8590354,
		"ID": 1308,
		"x": 77.1247333053,
		"y": 68.145234465,
		"h": 3.043956044
	},
	{
		"stop_id": 8590355,
		"ID": 1308,
		"x": 76.4887676003,
		"y": 67.220186206,
		"h": 3.043956044
	},
	{
		"stop_id": 8590356,
		"ID": 1308,
		"x": 79.1697660723,
		"y": 67.278240155,
		"h": 3.043956044
	},
	{
		"stop_id": 8590357,
		"ID": 1308,
		"x": 79.4487762233,
		"y": 67.214170982,
		"h": 3.043956044
	},
	{
		"stop_id": 8590358,
		"ID": 1308,
		"x": 79.6207116703,
		"y": 67.213209982,
		"h": 3.043956044
	},
	{
		"stop_id": 8590359,
		"ID": 1308,
		"x": 79.8687544423,
		"y": 67.287226115,
		"h": 3.043956044
	},
	{
		"stop_id": 8590360,
		"ID": 1308,
		"x": 80.1067187273,
		"y": 67.327205856,
		"h": 3.043956044
	},
	{
		"stop_id": 8590361,
		"ID": 1308,
		"x": 80.2537049213,
		"y": 67.295201642,
		"h": 3.043956044
	},
	{
		"stop_id": 8590362,
		"ID": 1308,
		"x": 80.4817233333,
		"y": 67.101190225,
		"h": 3.043956044
	},
	{
		"stop_id": 8590363,
		"ID": 1308,
		"x": 80.7167204633,
		"y": 66.98620337,
		"h": 3.043956044
	},
	{
		"stop_id": 8595414,
		"ID": 1308,
		"x": 79.0277434283,
		"y": 68.030159284,
		"h": 3.043956044
	},
	{
		"stop_id": 8595415,
		"ID": 1308,
		"x": 79.5777536973,
		"y": 67.392142379,
		"h": 3.043956044
	},
	{
		"stop_id": 8506282,
		"ID": 1307,
		"x": 80.3817610653,
		"y": 61.24814723,
		"h": 1.2967032967
	},
	{
		"stop_id": 8506283,
		"ID": 1307,
		"x": 79.9147309763,
		"y": 59.909151411,
		"h": 1.2967032967
	},
	{
		"stop_id": 8506602,
		"ID": 1307,
		"x": 76.8427489773,
		"y": 62.200142287,
		"h": 1.2967032967
	},
	{
		"stop_id": 8506790,
		"ID": 1307,
		"x": 79.1127658833,
		"y": 58.505188898,
		"h": 1.2967032967
	},
	{
		"stop_id": 8574047,
		"ID": 1307,
		"x": 79.8397569543,
		"y": 59.8171938,
		"h": 1.2967032967
	},
	{
		"stop_id": 8574048,
		"ID": 1307,
		"x": 79.6727367673,
		"y": 59.767223128,
		"h": 1.2967032967
	},
	{
		"stop_id": 8574049,
		"ID": 1307,
		"x": 79.2077248423,
		"y": 58.930235182,
		"h": 1.2967032967
	},
	{
		"stop_id": 8574050,
		"ID": 1307,
		"x": 79.0297731633,
		"y": 57.930179893,
		"h": 1.2967032967
	},
	{
		"stop_id": 8576284,
		"ID": 1307,
		"x": 79.3087081363,
		"y": 59.304156901,
		"h": 1.2967032967
	},
	{
		"stop_id": 8581129,
		"ID": 1307,
		"x": 78.9097006523,
		"y": 57.403238894,
		"h": 1.2967032967
	},
	{
		"stop_id": 8506287,
		"ID": 1334,
		"x": 82.0287438623,
		"y": 68.802237806,
		"h": 3.6043956044
	},
	{
		"stop_id": 8506300,
		"ID": 1334,
		"x": 80.8117242683,
		"y": 69.443176271,
		"h": 3.6043956044
	},
	{
		"stop_id": 8506301,
		"ID": 1334,
		"x": 82.9767167773,
		"y": 69.859206641,
		"h": 3.6043956044
	},
	{
		"stop_id": 8506371,
		"ID": 1334,
		"x": 85.7777432383,
		"y": 70.28719079,
		"h": 3.6043956044
	},
	{
		"stop_id": 8506372,
		"ID": 1334,
		"x": 85.2267666693,
		"y": 69.140150557,
		"h": 3.6043956044
	},
	{
		"stop_id": 8506373,
		"ID": 1334,
		"x": 85.8967558703,
		"y": 68.257186261,
		"h": 3.6043956044
	},
	{
		"stop_id": 8506374,
		"ID": 1334,
		"x": 86.4117706113,
		"y": 67.987163836,
		"h": 3.6043956044
	},
	{
		"stop_id": 8506392,
		"ID": 1334,
		"x": 83.6157180653,
		"y": 69.945158643,
		"h": 3.6043956044
	},
	{
		"stop_id": 8506600,
		"ID": 1334,
		"x": 84.8827702903,
		"y": 68.174166073,
		"h": 3.6043956044
	},
	{
		"stop_id": 8506604,
		"ID": 1334,
		"x": 84.7667416303,
		"y": 68.735198312,
		"h": 3.6043956044
	},
	{
		"stop_id": 8506605,
		"ID": 1334,
		"x": 84.0977368403,
		"y": 67.672145519,
		"h": 3.6043956044
	},
	{
		"stop_id": 8506606,
		"ID": 1334,
		"x": 84.2397281533,
		"y": 66.852157605,
		"h": 3.6043956044
	},
	{
		"stop_id": 8506775,
		"ID": 1334,
		"x": 84.1237264813,
		"y": 66.03924803,
		"h": 3.6043956044
	},
	{
		"stop_id": 8574213,
		"ID": 1334,
		"x": 84.0047653993,
		"y": 65.770222734,
		"h": 3.6043956044
	},
	{
		"stop_id": 8574214,
		"ID": 1334,
		"x": 84.6127349963,
		"y": 67.813242999,
		"h": 3.6043956044
	},
	{
		"stop_id": 8574215,
		"ID": 1334,
		"x": 86.4497690733,
		"y": 67.953179856,
		"h": 3.6043956044
	},
	{
		"stop_id": 8574258,
		"ID": 1334,
		"x": 85.7597557673,
		"y": 70.343246858,
		"h": 3.6043956044
	},
	{
		"stop_id": 8574259,
		"ID": 1334,
		"x": 85.1827694093,
		"y": 69.105152326,
		"h": 3.6043956044
	},
	{
		"stop_id": 8577630,
		"ID": 1334,
		"x": 85.9627143723,
		"y": 68.216213106,
		"h": 3.6043956044
	},
	{
		"stop_id": 8580242,
		"ID": 1334,
		"x": 85.5307391013,
		"y": 70.732219496,
		"h": 3.6043956044
	},
	{
		"stop_id": 8581774,
		"ID": 1334,
		"x": 81.8457168313,
		"y": 70.976229322,
		"h": 3.6043956044
	},
	{
		"stop_id": 8581777,
		"ID": 1334,
		"x": 81.6477339693,
		"y": 70.830141349,
		"h": 3.6043956044
	},
	{
		"stop_id": 8582227,
		"ID": 1334,
		"x": 81.1277686833,
		"y": 69.850171946,
		"h": 3.6043956044
	},
	{
		"stop_id": 8587343,
		"ID": 1334,
		"x": 82.8677494383,
		"y": 69.935209848,
		"h": 3.6043956044
	},
	{
		"stop_id": 8588500,
		"ID": 1334,
		"x": 81.9127679213,
		"y": 69.868238066,
		"h": 3.6043956044
	},
	{
		"stop_id": 8588501,
		"ID": 1334,
		"x": 83.4477741193,
		"y": 70.405197905,
		"h": 3.6043956044
	},
	{
		"stop_id": 8588889,
		"ID": 1334,
		"x": 81.9407529763,
		"y": 71.427147608,
		"h": 3.6043956044
	},
	{
		"stop_id": 8589550,
		"ID": 1334,
		"x": 83.1137541623,
		"y": 69.424211374,
		"h": 3.6043956044
	},
	{
		"stop_id": 8589551,
		"ID": 1334,
		"x": 84.5787441523,
		"y": 70.5081828,
		"h": 3.6043956044
	},
	{
		"stop_id": 8589552,
		"ID": 1334,
		"x": 81.7437012173,
		"y": 70.15024,
		"h": 3.6043956044
	},
	{
		"stop_id": 8589558,
		"ID": 1334,
		"x": 80.8777472633,
		"y": 69.305169931,
		"h": 3.6043956044
	},
	{
		"stop_id": 8589562,
		"ID": 1334,
		"x": 83.5077180953,
		"y": 69.416159442,
		"h": 3.6043956044
	},
	{
		"stop_id": 8589566,
		"ID": 1334,
		"x": 83.1427634573,
		"y": 70.221216062,
		"h": 3.6043956044
	},
	{
		"stop_id": 8589572,
		"ID": 1334,
		"x": 85.0197334273,
		"y": 70.692228056,
		"h": 3.6043956044
	},
	{
		"stop_id": 8589573,
		"ID": 1334,
		"x": 83.4187713893,
		"y": 70.21220386,
		"h": 3.6043956044
	},
	{
		"stop_id": 8589578,
		"ID": 1334,
		"x": 83.4577393963,
		"y": 69.940222554,
		"h": 3.6043956044
	},
	{
		"stop_id": 8589582,
		"ID": 1334,
		"x": 83.5667413003,
		"y": 69.785156348,
		"h": 3.6043956044
	},
	{
		"stop_id": 8589590,
		"ID": 1334,
		"x": 80.8827077543,
		"y": 69.538171101,
		"h": 3.6043956044
	},
	{
		"stop_id": 8589593,
		"ID": 1334,
		"x": 81.9497442393,
		"y": 69.667156297,
		"h": 3.6043956044
	},
	{
		"stop_id": 8589595,
		"ID": 1334,
		"x": 84.8527749113,
		"y": 71.281155158,
		"h": 3.6043956044
	},
	{
		"stop_id": 8589596,
		"ID": 1334,
		"x": 83.8797004443,
		"y": 70.765215792,
		"h": 3.6043956044
	},
	{
		"stop_id": 8589599,
		"ID": 1334,
		"x": 83.5157488173,
		"y": 70.123241863,
		"h": 3.6043956044
	},
	{
		"stop_id": 8589600,
		"ID": 1334,
		"x": 81.4487343893,
		"y": 69.555203137,
		"h": 3.6043956044
	},
	{
		"stop_id": 8589614,
		"ID": 1334,
		"x": 85.2617384553,
		"y": 70.80714488,
		"h": 3.6043956044
	},
	{
		"stop_id": 8589616,
		"ID": 1334,
		"x": 84.8467209183,
		"y": 70.642177548,
		"h": 3.6043956044
	},
	{
		"stop_id": 8589619,
		"ID": 1334,
		"x": 81.6447747423,
		"y": 69.560215774,
		"h": 3.6043956044
	},
	{
		"stop_id": 8589621,
		"ID": 1334,
		"x": 83.6827133073,
		"y": 69.517154403,
		"h": 3.6043956044
	},
	{
		"stop_id": 8589622,
		"ID": 1334,
		"x": 84.2667358553,
		"y": 70.880165052,
		"h": 3.6043956044
	},
	{
		"stop_id": 8589632,
		"ID": 1334,
		"x": 82.6457057273,
		"y": 69.847231347,
		"h": 3.6043956044
	},
	{
		"stop_id": 8589638,
		"ID": 1334,
		"x": 82.2447689063,
		"y": 69.782215423,
		"h": 3.6043956044
	},
	{
		"stop_id": 8589640,
		"ID": 1334,
		"x": 85.0477430703,
		"y": 71.019223671,
		"h": 3.6043956044
	},
	{
		"stop_id": 8589641,
		"ID": 1334,
		"x": 84.3867365003,
		"y": 70.630179668,
		"h": 3.6043956044
	},
	{
		"stop_id": 8589642,
		"ID": 1334,
		"x": 84.5387107753,
		"y": 71.057173199,
		"h": 3.6043956044
	},
	{
		"stop_id": 8589644,
		"ID": 1334,
		"x": 81.1567116153,
		"y": 69.649228341,
		"h": 3.6043956044
	},
	{
		"stop_id": 8589646,
		"ID": 1334,
		"x": 80.8137012433,
		"y": 69.083221868,
		"h": 3.6043956044
	},
	{
		"stop_id": 8589648,
		"ID": 1334,
		"x": 83.2037095313,
		"y": 69.301154073,
		"h": 3.6043956044
	},
	{
		"stop_id": 8589895,
		"ID": 1334,
		"x": 85.0907336223,
		"y": 71.440231252,
		"h": 3.6043956044
	},
	{
		"stop_id": 8589896,
		"ID": 1334,
		"x": 81.0047345293,
		"y": 69.547187937,
		"h": 3.6043956044
	},
	{
		"stop_id": 8589897,
		"ID": 1334,
		"x": 84.1607360063,
		"y": 70.275238566,
		"h": 3.6043956044
	},
	{
		"stop_id": 8589898,
		"ID": 1334,
		"x": 83.8837225753,
		"y": 70.089229781,
		"h": 3.6043956044
	},
	{
		"stop_id": 8589899,
		"ID": 1334,
		"x": 83.3597116583,
		"y": 69.835199659,
		"h": 3.6043956044
	},
	{
		"stop_id": 8589900,
		"ID": 1334,
		"x": 83.0917293093,
		"y": 69.786242863,
		"h": 3.6043956044
	},
	{
		"stop_id": 8589901,
		"ID": 1334,
		"x": 82.8547252163,
		"y": 69.642176668,
		"h": 3.6043956044
	},
	{
		"stop_id": 8589902,
		"ID": 1334,
		"x": 82.7287003073,
		"y": 69.498232234,
		"h": 3.6043956044
	},
	{
		"stop_id": 8589903,
		"ID": 1334,
		"x": 85.5307349533,
		"y": 70.523242521,
		"h": 3.6043956044
	},
	{
		"stop_id": 8589904,
		"ID": 1334,
		"x": 85.4367683773,
		"y": 70.399154298,
		"h": 3.6043956044
	},
	{
		"stop_id": 8589905,
		"ID": 1334,
		"x": 85.4457690733,
		"y": 69.952171998,
		"h": 3.6043956044
	},
	{
		"stop_id": 8589906,
		"ID": 1334,
		"x": 85.4927220563,
		"y": 70.100241311,
		"h": 3.6043956044
	},
	{
		"stop_id": 8589907,
		"ID": 1334,
		"x": 85.2307164443,
		"y": 69.956243299,
		"h": 3.6043956044
	},
	{
		"stop_id": 8590343,
		"ID": 1334,
		"x": 80.7047532193,
		"y": 68.13720586,
		"h": 3.6043956044
	},
	{
		"stop_id": 8590344,
		"ID": 1334,
		"x": 81.3097371573,
		"y": 67.656238297,
		"h": 3.6043956044
	},
	{
		"stop_id": 8590345,
		"ID": 1334,
		"x": 81.1427080523,
		"y": 67.883142664,
		"h": 3.6043956044
	},
	{
		"stop_id": 8594267,
		"ID": 1334,
		"x": 83.8587679583,
		"y": 69.767209851,
		"h": 3.6043956044
	},
	{
		"stop_id": 8594268,
		"ID": 1334,
		"x": 83.9787384903,
		"y": 70.019245554,
		"h": 3.6043956044
	},
	{
		"stop_id": 8594355,
		"ID": 1334,
		"x": 82.7307507733,
		"y": 69.874189948,
		"h": 3.6043956044
	},
	{
		"stop_id": 8594356,
		"ID": 1334,
		"x": 83.7717556833,
		"y": 70.332190447,
		"h": 3.6043956044
	},
	{
		"stop_id": 8594387,
		"ID": 1334,
		"x": 83.1107315773,
		"y": 70.078197874,
		"h": 3.6043956044
	},
	{
		"stop_id": 8594989,
		"ID": 1334,
		"x": 83.6177276493,
		"y": 69.915179001,
		"h": 3.6043956044
	},
	{
		"stop_id": 8595437,
		"ID": 1334,
		"x": 80.7977626393,
		"y": 69.43016634,
		"h": 3.6043956044
	},
	{
		"stop_id": 8595967,
		"ID": 1334,
		"x": 80.6227565323,
		"y": 68.27016418,
		"h": 3.6043956044
	},
	{
		"stop_id": 8506293,
		"ID": 1249,
		"x": 68.9677123143,
		"y": 64.705235079,
		"h": 1.0989010989
	},
	{
		"stop_id": 8506766,
		"ID": 1249,
		"x": 66.8277102783,
		"y": 63.568192222,
		"h": 1.0989010989
	},
	{
		"stop_id": 8574858,
		"ID": 1249,
		"x": 67.5327204583,
		"y": 63.160149249,
		"h": 1.0989010989
	},
	{
		"stop_id": 8579821,
		"ID": 1249,
		"x": 68.0827465233,
		"y": 62.930222716,
		"h": 1.0989010989
	},
	{
		"stop_id": 8506297,
		"ID": 1247,
		"x": 67.5727447963,
		"y": 53.545175765,
		"h": 1.2967032967
	},
	{
		"stop_id": 8578587,
		"ID": 1247,
		"x": 66.2047719803,
		"y": 55.389222957,
		"h": 1.2967032967
	},
	{
		"stop_id": 8578588,
		"ID": 1247,
		"x": 66.8637400763,
		"y": 54.496152074,
		"h": 1.2967032967
	},
	{
		"stop_id": 8578589,
		"ID": 1247,
		"x": 67.1167058573,
		"y": 54.180173494,
		"h": 1.2967032967
	},
	{
		"stop_id": 8578590,
		"ID": 1247,
		"x": 67.3987300933,
		"y": 53.901191494,
		"h": 1.2967032967
	},
	{
		"stop_id": 8578591,
		"ID": 1247,
		"x": 67.5767066813,
		"y": 53.632222401,
		"h": 1.2967032967
	},
	{
		"stop_id": 8578592,
		"ID": 1247,
		"x": 67.8477119763,
		"y": 53.329227089,
		"h": 1.2967032967
	},
	{
		"stop_id": 8578593,
		"ID": 1247,
		"x": 68.0177363863,
		"y": 53.178198782,
		"h": 1.2967032967
	},
	{
		"stop_id": 8578594,
		"ID": 1247,
		"x": 68.2167473393,
		"y": 53.372199698,
		"h": 1.2967032967
	},
	{
		"stop_id": 8591906,
		"ID": 1247,
		"x": 68.6527641033,
		"y": 53.104159076,
		"h": 1.2967032967
	},
	{
		"stop_id": 8506298,
		"ID": 1277,
		"x": 71.1627722113,
		"y": 51.97719775,
		"h": 1.3626373626
	},
	{
		"stop_id": 8506299,
		"ID": 1277,
		"x": 73.4777624793,
		"y": 49.560141511,
		"h": 1.3626373626
	},
	{
		"stop_id": 8506754,
		"ID": 1277,
		"x": 74.3677092803,
		"y": 51.13416095,
		"h": 1.3626373626
	},
	{
		"stop_id": 8506769,
		"ID": 1277,
		"x": 76.3447154403,
		"y": 51.464162187,
		"h": 1.3626373626
	},
	{
		"stop_id": 8530603,
		"ID": 1277,
		"x": 71.2467380793,
		"y": 51.442151186,
		"h": 1.3626373626
	},
	{
		"stop_id": 8574018,
		"ID": 1277,
		"x": 73.4827678133,
		"y": 49.580159549,
		"h": 1.3626373626
	},
	{
		"stop_id": 8574019,
		"ID": 1277,
		"x": 73.8897260983,
		"y": 49.12524018,
		"h": 1.3626373626
	},
	{
		"stop_id": 8574042,
		"ID": 1277,
		"x": 73.2016993483,
		"y": 49.899249183,
		"h": 1.3626373626
	},
	{
		"stop_id": 8574043,
		"ID": 1277,
		"x": 73.6377059973,
		"y": 50.51020212,
		"h": 1.3626373626
	},
	{
		"stop_id": 8574044,
		"ID": 1277,
		"x": 74.9897375203,
		"y": 51.210183239,
		"h": 1.3626373626
	},
	{
		"stop_id": 8587338,
		"ID": 1277,
		"x": 71.4767204953,
		"y": 51.761161072,
		"h": 1.3626373626
	},
	{
		"stop_id": 8591907,
		"ID": 1277,
		"x": 70.8877459203,
		"y": 52.10814531,
		"h": 1.3626373626
	},
	{
		"stop_id": 8506313,
		"ID": 1427,
		"x": 102.5077588003,
		"y": 77.001236465,
		"h": 2.5164835165
	},
	{
		"stop_id": 8506314,
		"ID": 1427,
		"x": 106.1187371733,
		"y": 75.58016059,
		"h": 2.5164835165
	},
	{
		"stop_id": 8506316,
		"ID": 1427,
		"x": 106.3977353863,
		"y": 73.686205228,
		"h": 2.5164835165
	},
	{
		"stop_id": 8506350,
		"ID": 1427,
		"x": 103.3347513733,
		"y": 75.339226142,
		"h": 2.5164835165
	},
	{
		"stop_id": 8506351,
		"ID": 1427,
		"x": 102.8667604193,
		"y": 76.368204754,
		"h": 2.5164835165
	},
	{
		"stop_id": 8506442,
		"ID": 1427,
		"x": 102.4927534213,
		"y": 77.185239843,
		"h": 2.5164835165
	},
	{
		"stop_id": 8506443,
		"ID": 1427,
		"x": 106.2327222983,
		"y": 73.830173843,
		"h": 2.5164835165
	},
	{
		"stop_id": 8506458,
		"ID": 1427,
		"x": 103.9647099933,
		"y": 72.419234514,
		"h": 2.5164835165
	},
	{
		"stop_id": 8506752,
		"ID": 1427,
		"x": 104.3157471573,
		"y": 72.442193818,
		"h": 2.5164835165
	},
	{
		"stop_id": 8574089,
		"ID": 1427,
		"x": 101.9327134353,
		"y": 76.155173102,
		"h": 2.5164835165
	},
	{
		"stop_id": 8574090,
		"ID": 1427,
		"x": 101.8327533433,
		"y": 76.263222669,
		"h": 2.5164835165
	},
	{
		"stop_id": 8574091,
		"ID": 1427,
		"x": 101.8077351013,
		"y": 76.414141283,
		"h": 2.5164835165
	},
	{
		"stop_id": 8574092,
		"ID": 1427,
		"x": 102.2386995083,
		"y": 76.611236714,
		"h": 2.5164835165
	},
	{
		"stop_id": 8574093,
		"ID": 1427,
		"x": 102.4227586463,
		"y": 77.133155832,
		"h": 2.5164835165
	},
	{
		"stop_id": 8574097,
		"ID": 1427,
		"x": 102.0807304713,
		"y": 74.103198677,
		"h": 2.5164835165
	},
	{
		"stop_id": 8574098,
		"ID": 1427,
		"x": 102.6807507433,
		"y": 74.61015422,
		"h": 2.5164835165
	},
	{
		"stop_id": 8574099,
		"ID": 1427,
		"x": 102.9847036843,
		"y": 74.790243628,
		"h": 2.5164835165
	},
	{
		"stop_id": 8574100,
		"ID": 1427,
		"x": 103.3237448563,
		"y": 75.284198808,
		"h": 2.5164835165
	},
	{
		"stop_id": 8574101,
		"ID": 1427,
		"x": 103.7407560653,
		"y": 74.983163173,
		"h": 2.5164835165
	},
	{
		"stop_id": 8574102,
		"ID": 1427,
		"x": 104.0097529833,
		"y": 74.470172083,
		"h": 2.5164835165
	},
	{
		"stop_id": 8574103,
		"ID": 1427,
		"x": 104.3677175813,
		"y": 74.209143515,
		"h": 2.5164835165
	},
	{
		"stop_id": 8574104,
		"ID": 1427,
		"x": 104.6567732263,
		"y": 74.202154914,
		"h": 2.5164835165
	},
	{
		"stop_id": 8574105,
		"ID": 1427,
		"x": 105.0687714613,
		"y": 74.319175793,
		"h": 2.5164835165
	},
	{
		"stop_id": 8574106,
		"ID": 1427,
		"x": 104.9327669543,
		"y": 74.759186739,
		"h": 2.5164835165
	},
	{
		"stop_id": 8574107,
		"ID": 1427,
		"x": 105.2157196603,
		"y": 74.932245748,
		"h": 2.5164835165
	},
	{
		"stop_id": 8574108,
		"ID": 1427,
		"x": 105.4567382173,
		"y": 74.950207341,
		"h": 2.5164835165
	},
	{
		"stop_id": 8574109,
		"ID": 1427,
		"x": 105.2327489903,
		"y": 75.20623088,
		"h": 2.5164835165
	},
	{
		"stop_id": 8574110,
		"ID": 1427,
		"x": 105.8847746533,
		"y": 75.214223217,
		"h": 2.5164835165
	},
	{
		"stop_id": 8574111,
		"ID": 1427,
		"x": 106.0467274593,
		"y": 75.584147628,
		"h": 2.5164835165
	},
	{
		"stop_id": 8574115,
		"ID": 1427,
		"x": 101.0497430823,
		"y": 75.712217631,
		"h": 2.5164835165
	},
	{
		"stop_id": 8574116,
		"ID": 1427,
		"x": 101.3827156793,
		"y": 75.455227536,
		"h": 2.5164835165
	},
	{
		"stop_id": 8574117,
		"ID": 1427,
		"x": 101.8627095543,
		"y": 75.39613924,
		"h": 2.5164835165
	},
	{
		"stop_id": 8574118,
		"ID": 1427,
		"x": 102.6787340853,
		"y": 75.329180349,
		"h": 2.5164835165
	},
	{
		"stop_id": 8574119,
		"ID": 1427,
		"x": 104.4817680633,
		"y": 73.985182545,
		"h": 2.5164835165
	},
	{
		"stop_id": 8574122,
		"ID": 1427,
		"x": 103.7297562423,
		"y": 72.716164253,
		"h": 2.5164835165
	},
	{
		"stop_id": 8574130,
		"ID": 1427,
		"x": 102.3537211943,
		"y": 72.082244503,
		"h": 2.5164835165
	},
	{
		"stop_id": 8574131,
		"ID": 1427,
		"x": 103.0047544253,
		"y": 72.311222602,
		"h": 2.5164835165
	},
	{
		"stop_id": 8574133,
		"ID": 1427,
		"x": 104.7577309443,
		"y": 72.09620381,
		"h": 2.5164835165
	},
	{
		"stop_id": 8574134,
		"ID": 1427,
		"x": 104.9287208743,
		"y": 71.846250325,
		"h": 2.5164835165
	},
	{
		"stop_id": 8574294,
		"ID": 1427,
		"x": 102.1056996293,
		"y": 77.003229529,
		"h": 2.5164835165
	},
	{
		"stop_id": 8578428,
		"ID": 1427,
		"x": 105.9327009723,
		"y": 73.430240325,
		"h": 2.5164835165
	},
	{
		"stop_id": 8578429,
		"ID": 1427,
		"x": 105.9217282833,
		"y": 73.043193565,
		"h": 2.5164835165
	},
	{
		"stop_id": 8581840,
		"ID": 1427,
		"x": 102.6377229443,
		"y": 75.751161673,
		"h": 2.5164835165
	},
	{
		"stop_id": 8589538,
		"ID": 1427,
		"x": 105.7377682013,
		"y": 75.466155939,
		"h": 2.5164835165
	},
	{
		"stop_id": 8589539,
		"ID": 1427,
		"x": 105.0567568193,
		"y": 75.779154622,
		"h": 2.5164835165
	},
	{
		"stop_id": 8589540,
		"ID": 1427,
		"x": 102.9477022843,
		"y": 76.420150053,
		"h": 2.5164835165
	},
	{
		"stop_id": 8589541,
		"ID": 1427,
		"x": 103.4527649493,
		"y": 76.265225252,
		"h": 2.5164835165
	},
	{
		"stop_id": 8506317,
		"ID": 1426,
		"x": 105.4217364133,
		"y": 70.797217141,
		"h": 1.8241758242
	},
	{
		"stop_id": 8506318,
		"ID": 1426,
		"x": 102.4207300853,
		"y": 68.740207461,
		"h": 1.8241758242
	},
	{
		"stop_id": 8506453,
		"ID": 1426,
		"x": 101.0577215703,
		"y": 68.630178775,
		"h": 1.8241758242
	},
	{
		"stop_id": 8506454,
		"ID": 1426,
		"x": 102.1267406663,
		"y": 69.313199146,
		"h": 1.8241758242
	},
	{
		"stop_id": 8506455,
		"ID": 1426,
		"x": 103.4597587133,
		"y": 70.072208675,
		"h": 1.8241758242
	},
	{
		"stop_id": 8506456,
		"ID": 1426,
		"x": 103.8297463343,
		"y": 70.346249447,
		"h": 1.8241758242
	},
	{
		"stop_id": 8506462,
		"ID": 1426,
		"x": 106.0627186283,
		"y": 69.966144354,
		"h": 1.8241758242
	},
	{
		"stop_id": 8574135,
		"ID": 1426,
		"x": 105.1687526163,
		"y": 71.411141573,
		"h": 1.8241758242
	},
	{
		"stop_id": 8574136,
		"ID": 1426,
		"x": 105.2657330703,
		"y": 71.033226587,
		"h": 1.8241758242
	},
	{
		"stop_id": 8574137,
		"ID": 1426,
		"x": 105.4607738813,
		"y": 70.851250702,
		"h": 1.8241758242
	},
	{
		"stop_id": 8574139,
		"ID": 1426,
		"x": 101.8857636923,
		"y": 70.875217833,
		"h": 1.8241758242
	},
	{
		"stop_id": 8574140,
		"ID": 1426,
		"x": 101.5887553693,
		"y": 70.509192362,
		"h": 1.8241758242
	},
	{
		"stop_id": 8574141,
		"ID": 1426,
		"x": 101.3197188573,
		"y": 70.182205501,
		"h": 1.8241758242
	},
	{
		"stop_id": 8578440,
		"ID": 1426,
		"x": 105.6077070593,
		"y": 70.505211868,
		"h": 1.8241758242
	},
	{
		"stop_id": 8578442,
		"ID": 1426,
		"x": 106.2827540913,
		"y": 69.630178023,
		"h": 1.8241758242
	},
	{
		"stop_id": 8578443,
		"ID": 1426,
		"x": 106.4577297533,
		"y": 69.38015613,
		"h": 1.8241758242
	},
	{
		"stop_id": 8578453,
		"ID": 1426,
		"x": 105.2077023223,
		"y": 70.780236366,
		"h": 1.8241758242
	},
	{
		"stop_id": 8578454,
		"ID": 1426,
		"x": 104.8527347693,
		"y": 70.694163392,
		"h": 1.8241758242
	},
	{
		"stop_id": 8578455,
		"ID": 1426,
		"x": 104.4077458513,
		"y": 70.630195534,
		"h": 1.8241758242
	},
	{
		"stop_id": 8578456,
		"ID": 1426,
		"x": 104.0467613223,
		"y": 70.406195575,
		"h": 1.8241758242
	},
	{
		"stop_id": 8578457,
		"ID": 1426,
		"x": 102.9577016623,
		"y": 69.78021251,
		"h": 1.8241758242
	},
	{
		"stop_id": 8578458,
		"ID": 1426,
		"x": 102.5377269873,
		"y": 69.638216875,
		"h": 1.8241758242
	},
	{
		"stop_id": 8578459,
		"ID": 1426,
		"x": 101.8577457593,
		"y": 69.155140715,
		"h": 1.8241758242
	},
	{
		"stop_id": 8578460,
		"ID": 1426,
		"x": 101.3327175623,
		"y": 68.855208349,
		"h": 1.8241758242
	},
	{
		"stop_id": 8578461,
		"ID": 1426,
		"x": 100.8577083963,
		"y": 68.455244782,
		"h": 1.8241758242
	},
	{
		"stop_id": 8588223,
		"ID": 1426,
		"x": 103.7747546403,
		"y": 65.779163082,
		"h": 1.8241758242
	},
	{
		"stop_id": 8506319,
		"ID": 1405,
		"x": 100.1937031833,
		"y": 66.632231147,
		"h": 2.3186813187
	},
	{
		"stop_id": 8506379,
		"ID": 1405,
		"x": 98.7367578013,
		"y": 66.874235157,
		"h": 2.3186813187
	},
	{
		"stop_id": 8506387,
		"ID": 1405,
		"x": 96.3747328013,
		"y": 65.581174763,
		"h": 2.3186813187
	},
	{
		"stop_id": 8506388,
		"ID": 1405,
		"x": 96.9767081173,
		"y": 65.560145303,
		"h": 2.3186813187
	},
	{
		"stop_id": 8506389,
		"ID": 1405,
		"x": 97.6107697203,
		"y": 65.930193149,
		"h": 2.3186813187
	},
	{
		"stop_id": 8506444,
		"ID": 1405,
		"x": 98.4027272523,
		"y": 63.056196758,
		"h": 2.3186813187
	},
	{
		"stop_id": 8506446,
		"ID": 1405,
		"x": 98.4327508413,
		"y": 64.780145686,
		"h": 2.3186813187
	},
	{
		"stop_id": 8506448,
		"ID": 1405,
		"x": 97.3577409793,
		"y": 63.056207214,
		"h": 2.3186813187
	},
	{
		"stop_id": 8506450,
		"ID": 1405,
		"x": 100.1837701003,
		"y": 66.611164252,
		"h": 2.3186813187
	},
	{
		"stop_id": 8506452,
		"ID": 1405,
		"x": 99.9087046423,
		"y": 67.983240122,
		"h": 2.3186813187
	},
	{
		"stop_id": 8574144,
		"ID": 1405,
		"x": 99.2777100573,
		"y": 67.88918286,
		"h": 2.3186813187
	},
	{
		"stop_id": 8574145,
		"ID": 1405,
		"x": 99.0557603013,
		"y": 67.380166766,
		"h": 2.3186813187
	},
	{
		"stop_id": 8574147,
		"ID": 1405,
		"x": 99.0737410103,
		"y": 67.025182136,
		"h": 2.3186813187
	},
	{
		"stop_id": 8578462,
		"ID": 1405,
		"x": 99.5077122633,
		"y": 67.55524496,
		"h": 2.3186813187
	},
	{
		"stop_id": 8578463,
		"ID": 1405,
		"x": 99.3077474833,
		"y": 67.305180886,
		"h": 2.3186813187
	},
	{
		"stop_id": 8578464,
		"ID": 1405,
		"x": 98.7977673773,
		"y": 66.929143514,
		"h": 2.3186813187
	},
	{
		"stop_id": 8578466,
		"ID": 1405,
		"x": 99.7077164643,
		"y": 66.880166432,
		"h": 2.3186813187
	},
	{
		"stop_id": 8578467,
		"ID": 1405,
		"x": 98.7307205083,
		"y": 67.732153453,
		"h": 2.3186813187
	},
	{
		"stop_id": 8578468,
		"ID": 1405,
		"x": 98.8857761953,
		"y": 68.029154179,
		"h": 2.3186813187
	},
	{
		"stop_id": 8578469,
		"ID": 1405,
		"x": 98.5077126183,
		"y": 68.230249155,
		"h": 2.3186813187
	},
	{
		"stop_id": 8578470,
		"ID": 1405,
		"x": 97.6877520323,
		"y": 68.329177641,
		"h": 2.3186813187
	},
	{
		"stop_id": 8578471,
		"ID": 1405,
		"x": 97.5607081883,
		"y": 67.985239299,
		"h": 2.3186813187
	},
	{
		"stop_id": 8578472,
		"ID": 1405,
		"x": 97.2077244073,
		"y": 67.880221629,
		"h": 2.3186813187
	},
	{
		"stop_id": 8578473,
		"ID": 1405,
		"x": 96.6197107023,
		"y": 67.773240778,
		"h": 2.3186813187
	},
	{
		"stop_id": 8578480,
		"ID": 1405,
		"x": 99.4827340793,
		"y": 66.832182386,
		"h": 2.3186813187
	},
	{
		"stop_id": 8578481,
		"ID": 1405,
		"x": 99.6737168633,
		"y": 66.619212764,
		"h": 2.3186813187
	},
	{
		"stop_id": 8578482,
		"ID": 1405,
		"x": 98.7577652613,
		"y": 65.880250329,
		"h": 2.3186813187
	},
	{
		"stop_id": 8578483,
		"ID": 1405,
		"x": 98.5077146273,
		"y": 65.380185367,
		"h": 2.3186813187
	},
	{
		"stop_id": 8578486,
		"ID": 1405,
		"x": 98.0997741733,
		"y": 63.202160381,
		"h": 2.3186813187
	},
	{
		"stop_id": 8578487,
		"ID": 1405,
		"x": 97.7887225693,
		"y": 63.437233964,
		"h": 2.3186813187
	},
	{
		"stop_id": 8582404,
		"ID": 1405,
		"x": 99.5797632223,
		"y": 68.235197838,
		"h": 2.3186813187
	},
	{
		"stop_id": 8587486,
		"ID": 1405,
		"x": 99.6777554663,
		"y": 66.730210349,
		"h": 2.3186813187
	},
	{
		"stop_id": 8588128,
		"ID": 1405,
		"x": 100.2517332863,
		"y": 65.082243703,
		"h": 2.3186813187
	},
	{
		"stop_id": 8588215,
		"ID": 1405,
		"x": 98.7077547793,
		"y": 68.305224503,
		"h": 2.3186813187
	},
	{
		"stop_id": 8588217,
		"ID": 1405,
		"x": 99.4017355163,
		"y": 67.001176627,
		"h": 2.3186813187
	},
	{
		"stop_id": 8588221,
		"ID": 1405,
		"x": 98.0577747673,
		"y": 64.39021484,
		"h": 2.3186813187
	},
	{
		"stop_id": 8594590,
		"ID": 1405,
		"x": 96.7757213023,
		"y": 67.992242465,
		"h": 2.3186813187
	},
	{
		"stop_id": 8594591,
		"ID": 1405,
		"x": 98.7817632453,
		"y": 67.126245742,
		"h": 2.3186813187
	},
	{
		"stop_id": 8594592,
		"ID": 1405,
		"x": 99.9447034223,
		"y": 66.774216876,
		"h": 2.3186813187
	},
	{
		"stop_id": 8594593,
		"ID": 1405,
		"x": 99.3437681363,
		"y": 67.05823341,
		"h": 2.3186813187
	},
	{
		"stop_id": 8595949,
		"ID": 1405,
		"x": 100.6857342663,
		"y": 66.553223798,
		"h": 2.3186813187
	},
	{
		"stop_id": 8506366,
		"ID": 1381,
		"x": 91.5447261703,
		"y": 70.445244768,
		"h": 1.8241758242
	},
	{
		"stop_id": 8506367,
		"ID": 1381,
		"x": 92.1787380173,
		"y": 70.011154672,
		"h": 1.8241758242
	},
	{
		"stop_id": 8506368,
		"ID": 1381,
		"x": 92.5077509663,
		"y": 69.851221068,
		"h": 1.8241758242
	},
	{
		"stop_id": 8506369,
		"ID": 1381,
		"x": 92.9237296643,
		"y": 70.123191613,
		"h": 1.8241758242
	},
	{
		"stop_id": 8506449,
		"ID": 1381,
		"x": 96.6327625693,
		"y": 68.929177661,
		"h": 1.8241758242
	},
	{
		"stop_id": 8506716,
		"ID": 1381,
		"x": 94.6547009313,
		"y": 70.31623769,
		"h": 1.8241758242
	},
	{
		"stop_id": 8506778,
		"ID": 1381,
		"x": 95.1477750043,
		"y": 71.180188558,
		"h": 1.8241758242
	},
	{
		"stop_id": 8574072,
		"ID": 1381,
		"x": 90.8827015923,
		"y": 69.545167105,
		"h": 1.8241758242
	},
	{
		"stop_id": 8574073,
		"ID": 1381,
		"x": 91.3167746773,
		"y": 69.863193755,
		"h": 1.8241758242
	},
	{
		"stop_id": 8574074,
		"ID": 1381,
		"x": 91.5797238293,
		"y": 70.281200476,
		"h": 1.8241758242
	},
	{
		"stop_id": 8574075,
		"ID": 1381,
		"x": 91.5327700753,
		"y": 70.455171394,
		"h": 1.8241758242
	},
	{
		"stop_id": 8574155,
		"ID": 1381,
		"x": 94.8957706533,
		"y": 70.958161913,
		"h": 1.8241758242
	},
	{
		"stop_id": 8574156,
		"ID": 1381,
		"x": 95.1697275463,
		"y": 70.898148688,
		"h": 1.8241758242
	},
	{
		"stop_id": 8574157,
		"ID": 1381,
		"x": 94.0677202733,
		"y": 70.314190224,
		"h": 1.8241758242
	},
	{
		"stop_id": 8574158,
		"ID": 1381,
		"x": 93.1777733583,
		"y": 70.390227969,
		"h": 1.8241758242
	},
	{
		"stop_id": 8574159,
		"ID": 1381,
		"x": 93.1477478323,
		"y": 70.205159873,
		"h": 1.8241758242
	},
	{
		"stop_id": 8574160,
		"ID": 1381,
		"x": 92.9297508573,
		"y": 70.112224881,
		"h": 1.8241758242
	},
	{
		"stop_id": 8578474,
		"ID": 1381,
		"x": 96.4777452913,
		"y": 68.135189545,
		"h": 1.8241758242
	},
	{
		"stop_id": 8578475,
		"ID": 1381,
		"x": 96.5777242733,
		"y": 68.382181936,
		"h": 1.8241758242
	},
	{
		"stop_id": 8578478,
		"ID": 1381,
		"x": 94.2317462133,
		"y": 69.468171074,
		"h": 1.8241758242
	},
	{
		"stop_id": 8581207,
		"ID": 1381,
		"x": 94.7187678483,
		"y": 70.543243695,
		"h": 1.8241758242
	},
	{
		"stop_id": 8582239,
		"ID": 1381,
		"x": 93.6447318503,
		"y": 69.770243797,
		"h": 1.8241758242
	},
	{
		"stop_id": 8582240,
		"ID": 1381,
		"x": 94.9147545213,
		"y": 69.324149308,
		"h": 1.8241758242
	},
	{
		"stop_id": 8582241,
		"ID": 1381,
		"x": 96.6207050953,
		"y": 68.928191857,
		"h": 1.8241758242
	},
	{
		"stop_id": 8588218,
		"ID": 1381,
		"x": 96.4277313383,
		"y": 68.270227653,
		"h": 1.8241758242
	},
	{
		"stop_id": 8594233,
		"ID": 1381,
		"x": 91.7947654403,
		"y": 70.540172345,
		"h": 1.8241758242
	},
	{
		"stop_id": 8506378,
		"ID": 1380,
		"x": 92.2787344153,
		"y": 64.943239147,
		"h": 1.4285714286
	},
	{
		"stop_id": 8506381,
		"ID": 1380,
		"x": 90.9077586783,
		"y": 63.525227966,
		"h": 1.4285714286
	},
	{
		"stop_id": 8506382,
		"ID": 1380,
		"x": 91.7787525633,
		"y": 64.846238183,
		"h": 1.4285714286
	},
	{
		"stop_id": 8506383,
		"ID": 1380,
		"x": 93.2977456343,
		"y": 65.106163595,
		"h": 1.4285714286
	},
	{
		"stop_id": 8506384,
		"ID": 1380,
		"x": 94.2467720313,
		"y": 65.061244381,
		"h": 1.4285714286
	},
	{
		"stop_id": 8506385,
		"ID": 1380,
		"x": 94.9997162983,
		"y": 64.990220002,
		"h": 1.4285714286
	},
	{
		"stop_id": 8506386,
		"ID": 1380,
		"x": 95.6017123373,
		"y": 65.019210234,
		"h": 1.4285714286
	},
	{
		"stop_id": 8578414,
		"ID": 1380,
		"x": 93.5327482053,
		"y": 61.70216905,
		"h": 1.4285714286
	},
	{
		"stop_id": 8578415,
		"ID": 1380,
		"x": 93.2087054283,
		"y": 61.947152944,
		"h": 1.4285714286
	},
	{
		"stop_id": 8578416,
		"ID": 1380,
		"x": 92.6207465823,
		"y": 62.048232407,
		"h": 1.4285714286
	},
	{
		"stop_id": 8578417,
		"ID": 1380,
		"x": 91.8537576443,
		"y": 61.739178693,
		"h": 1.4285714286
	},
	{
		"stop_id": 8578418,
		"ID": 1380,
		"x": 91.3467537183,
		"y": 61.601225873,
		"h": 1.4285714286
	},
	{
		"stop_id": 8578424,
		"ID": 1380,
		"x": 91.4047077173,
		"y": 61.908216343,
		"h": 1.4285714286
	},
	{
		"stop_id": 8579826,
		"ID": 1380,
		"x": 90.9257216403,
		"y": 63.541143873,
		"h": 1.4285714286
	},
	{
		"stop_id": 8506395,
		"ID": 1336,
		"x": 84.9067047403,
		"y": 80.656199565,
		"h": 1.4615384615
	},
	{
		"stop_id": 8506396,
		"ID": 1336,
		"x": 83.2407347333,
		"y": 82.146144153,
		"h": 1.4615384615
	},
	{
		"stop_id": 8574216,
		"ID": 1336,
		"x": 84.8897487743,
		"y": 80.659232308,
		"h": 1.4615384615
	},
	{
		"stop_id": 8574219,
		"ID": 1336,
		"x": 84.4687347873,
		"y": 79.397162361,
		"h": 1.4615384615
	},
	{
		"stop_id": 8574220,
		"ID": 1336,
		"x": 84.1617597813,
		"y": 79.559177988,
		"h": 1.4615384615
	},
	{
		"stop_id": 8579771,
		"ID": 1336,
		"x": 82.4167609393,
		"y": 77.669161339,
		"h": 1.4615384615
	},
	{
		"stop_id": 8579844,
		"ID": 1336,
		"x": 83.4087064093,
		"y": 79.059198663,
		"h": 1.4615384615
	},
	{
		"stop_id": 8579847,
		"ID": 1336,
		"x": 85.1387576013,
		"y": 77.993164125,
		"h": 1.4615384615
	},
	{
		"stop_id": 8579904,
		"ID": 1336,
		"x": 84.5997378713,
		"y": 79.854248329,
		"h": 1.4615384615
	},
	{
		"stop_id": 8579979,
		"ID": 1336,
		"x": 83.8477671193,
		"y": 79.539194996,
		"h": 1.4615384615
	},
	{
		"stop_id": 8579980,
		"ID": 1336,
		"x": 83.8437208213,
		"y": 78.902144025,
		"h": 1.4615384615
	},
	{
		"stop_id": 8587180,
		"ID": 1336,
		"x": 83.2377309443,
		"y": 82.130166981,
		"h": 1.4615384615
	},
	{
		"stop_id": 8587181,
		"ID": 1336,
		"x": 82.8507429773,
		"y": 82.218241197,
		"h": 1.4615384615
	},
	{
		"stop_id": 8587182,
		"ID": 1336,
		"x": 82.2827111343,
		"y": 82.554230985,
		"h": 1.4615384615
	},
	{
		"stop_id": 8587183,
		"ID": 1336,
		"x": 82.5507424893,
		"y": 82.283188461,
		"h": 1.4615384615
	},
	{
		"stop_id": 8506445,
		"ID": 1446,
		"x": 107.1277448823,
		"y": 75.205230355,
		"h": 1.0659340659
	},
	{
		"stop_id": 8574112,
		"ID": 1446,
		"x": 106.6977625043,
		"y": 75.280205405,
		"h": 1.0659340659
	},
	{
		"stop_id": 8578427,
		"ID": 1446,
		"x": 106.9327173763,
		"y": 74.755147948,
		"h": 1.0659340659
	},
	{
		"stop_id": 8506467,
		"ID": 1408,
		"x": 100.1047583723,
		"y": 80.468230141,
		"h": 1
	},
	{
		"stop_id": 8506580,
		"ID": 1251,
		"x": 70.0387465023,
		"y": 74.486168704,
		"h": 1.6593406593
	},
	{
		"stop_id": 8506581,
		"ID": 1251,
		"x": 66.8257205703,
		"y": 74.835140601,
		"h": 1.6593406593
	},
	{
		"stop_id": 8506661,
		"ID": 1251,
		"x": 69.3007747623,
		"y": 77.147224876,
		"h": 1.6593406593
	},
	{
		"stop_id": 8506669,
		"ID": 1251,
		"x": 67.8667346793,
		"y": 76.529235683,
		"h": 1.6593406593
	},
	{
		"stop_id": 8506680,
		"ID": 1251,
		"x": 66.9827193933,
		"y": 78.830207256,
		"h": 1.6593406593
	},
	{
		"stop_id": 8506724,
		"ID": 1251,
		"x": 67.0407146223,
		"y": 75.418151883,
		"h": 1.6593406593
	},
	{
		"stop_id": 8506730,
		"ID": 1251,
		"x": 66.3487339493,
		"y": 76.55316537,
		"h": 1.6593406593
	},
	{
		"stop_id": 8506784,
		"ID": 1251,
		"x": 70.1467005653,
		"y": 78.135190802,
		"h": 1.6593406593
	},
	{
		"stop_id": 8506785,
		"ID": 1251,
		"x": 66.1607616263,
		"y": 76.878232887,
		"h": 1.6593406593
	},
	{
		"stop_id": 8573607,
		"ID": 1251,
		"x": 66.6077162343,
		"y": 79.380240231,
		"h": 1.6593406593
	},
	{
		"stop_id": 8573916,
		"ID": 1251,
		"x": 65.9917764733,
		"y": 76.453148075,
		"h": 1.6593406593
	},
	{
		"stop_id": 8573917,
		"ID": 1251,
		"x": 66.3827517213,
		"y": 77.005185031,
		"h": 1.6593406593
	},
	{
		"stop_id": 8573918,
		"ID": 1251,
		"x": 68.8327267553,
		"y": 77.232225242,
		"h": 1.6593406593
	},
	{
		"stop_id": 8573919,
		"ID": 1251,
		"x": 70.1147385743,
		"y": 77.524152479,
		"h": 1.6593406593
	},
	{
		"stop_id": 8573920,
		"ID": 1251,
		"x": 70.9637579193,
		"y": 77.095230153,
		"h": 1.6593406593
	},
	{
		"stop_id": 8573944,
		"ID": 1251,
		"x": 66.9827329923,
		"y": 74.530227096,
		"h": 1.6593406593
	},
	{
		"stop_id": 8581128,
		"ID": 1251,
		"x": 69.9417247573,
		"y": 77.774142106,
		"h": 1.6593406593
	},
	{
		"stop_id": 8581424,
		"ID": 1251,
		"x": 69.8207276073,
		"y": 75.998207322,
		"h": 1.6593406593
	},
	{
		"stop_id": 8581425,
		"ID": 1251,
		"x": 69.6887265503,
		"y": 75.565148785,
		"h": 1.6593406593
	},
	{
		"stop_id": 8581427,
		"ID": 1251,
		"x": 69.6667018323,
		"y": 74.686205332,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583596,
		"ID": 1251,
		"x": 68.2397226003,
		"y": 75.406165449,
		"h": 1.6593406593
	},
	{
		"stop_id": 8506592,
		"ID": 1149,
		"x": 54.2447340753,
		"y": 93.507195087,
		"h": 1.4945054945
	},
	{
		"stop_id": 8506627,
		"ID": 1149,
		"x": 54.0477167673,
		"y": 90.258228457,
		"h": 1.4945054945
	},
	{
		"stop_id": 8506758,
		"ID": 1149,
		"x": 50.8897501843,
		"y": 91.175144396,
		"h": 1.4945054945
	},
	{
		"stop_id": 8506857,
		"ID": 1149,
		"x": 53.7577726163,
		"y": 92.542154906,
		"h": 1.4945054945
	},
	{
		"stop_id": 8506871,
		"ID": 1149,
		"x": 54.3677325203,
		"y": 90.246171075,
		"h": 1.4945054945
	},
	{
		"stop_id": 8506881,
		"ID": 1149,
		"x": 55.2507621353,
		"y": 94.20924446,
		"h": 1.4945054945
	},
	{
		"stop_id": 8506882,
		"ID": 1149,
		"x": 53.0847649153,
		"y": 93.175158594,
		"h": 1.4945054945
	},
	{
		"stop_id": 8506969,
		"ID": 1149,
		"x": 55.1327605533,
		"y": 90.355214604,
		"h": 1.4945054945
	},
	{
		"stop_id": 8506978,
		"ID": 1149,
		"x": 56.0677633633,
		"y": 92.75121772,
		"h": 1.4945054945
	},
	{
		"stop_id": 8573336,
		"ID": 1149,
		"x": 53.8277418473,
		"y": 90.759222168,
		"h": 1.4945054945
	},
	{
		"stop_id": 8573344,
		"ID": 1149,
		"x": 54.1387269323,
		"y": 90.169236244,
		"h": 1.4945054945
	},
	{
		"stop_id": 8573357,
		"ID": 1149,
		"x": 56.4327076713,
		"y": 92.055197155,
		"h": 1.4945054945
	},
	{
		"stop_id": 8573358,
		"ID": 1149,
		"x": 55.9447275923,
		"y": 93.185202213,
		"h": 1.4945054945
	},
	{
		"stop_id": 8581972,
		"ID": 1149,
		"x": 54.2247344773,
		"y": 92.69417976,
		"h": 1.4945054945
	},
	{
		"stop_id": 8581973,
		"ID": 1149,
		"x": 53.7237711453,
		"y": 89.704163686,
		"h": 1.4945054945
	},
	{
		"stop_id": 8583557,
		"ID": 1149,
		"x": 55.3827133613,
		"y": 94.262199319,
		"h": 1.4945054945
	},
	{
		"stop_id": 8506593,
		"ID": 1185,
		"x": 60.5007130563,
		"y": 92.890214801,
		"h": 1.2967032967
	},
	{
		"stop_id": 8506597,
		"ID": 1185,
		"x": 56.8987706553,
		"y": 94.585160024,
		"h": 1.2967032967
	},
	{
		"stop_id": 8506718,
		"ID": 1185,
		"x": 55.9697197823,
		"y": 95.738154289,
		"h": 1.2967032967
	},
	{
		"stop_id": 8506977,
		"ID": 1185,
		"x": 57.9817586613,
		"y": 94.593231293,
		"h": 1.2967032967
	},
	{
		"stop_id": 8506984,
		"ID": 1185,
		"x": 60.7867650843,
		"y": 94.504224273,
		"h": 1.2967032967
	},
	{
		"stop_id": 8573337,
		"ID": 1185,
		"x": 55.5637419503,
		"y": 94.546217347,
		"h": 1.2967032967
	},
	{
		"stop_id": 8573338,
		"ID": 1185,
		"x": 55.6317276573,
		"y": 94.725155445,
		"h": 1.2967032967
	},
	{
		"stop_id": 8573349,
		"ID": 1185,
		"x": 60.6927075953,
		"y": 93.246238977,
		"h": 1.2967032967
	},
	{
		"stop_id": 8573350,
		"ID": 1185,
		"x": 60.4887402353,
		"y": 93.514218906,
		"h": 1.2967032967
	},
	{
		"stop_id": 8580251,
		"ID": 1185,
		"x": 60.9017175413,
		"y": 94.757144122,
		"h": 1.2967032967
	},
	{
		"stop_id": 8506599,
		"ID": 1382,
		"x": 96.0447160713,
		"y": 74.31819204,
		"h": 2.0549450549
	},
	{
		"stop_id": 8506683,
		"ID": 1382,
		"x": 91.7877141193,
		"y": 75.073237184,
		"h": 2.0549450549
	},
	{
		"stop_id": 8506753,
		"ID": 1382,
		"x": 93.6687336673,
		"y": 74.056223308,
		"h": 2.0549450549
	},
	{
		"stop_id": 8506756,
		"ID": 1382,
		"x": 96.3437343343,
		"y": 74.704235286,
		"h": 2.0549450549
	},
	{
		"stop_id": 8506767,
		"ID": 1382,
		"x": 94.4497034313,
		"y": 72.411200736,
		"h": 2.0549450549
	},
	{
		"stop_id": 8574260,
		"ID": 1382,
		"x": 91.1847046313,
		"y": 74.645187198,
		"h": 2.0549450549
	},
	{
		"stop_id": 8574261,
		"ID": 1382,
		"x": 91.5627489783,
		"y": 74.852152861,
		"h": 2.0549450549
	},
	{
		"stop_id": 8574262,
		"ID": 1382,
		"x": 92.0027465723,
		"y": 75.316208877,
		"h": 2.0549450549
	},
	{
		"stop_id": 8574263,
		"ID": 1382,
		"x": 92.4357459413,
		"y": 75.891230784,
		"h": 2.0549450549
	},
	{
		"stop_id": 8574264,
		"ID": 1382,
		"x": 92.4937135123,
		"y": 76.827212452,
		"h": 2.0549450549
	},
	{
		"stop_id": 8574284,
		"ID": 1382,
		"x": 94.6857495783,
		"y": 77.212171935,
		"h": 2.0549450549
	},
	{
		"stop_id": 8574285,
		"ID": 1382,
		"x": 94.6847405843,
		"y": 77.011164537,
		"h": 2.0549450549
	},
	{
		"stop_id": 8574286,
		"ID": 1382,
		"x": 94.9487129453,
		"y": 77.0251839,
		"h": 2.0549450549
	},
	{
		"stop_id": 8574287,
		"ID": 1382,
		"x": 95.1647361923,
		"y": 77.093236754,
		"h": 2.0549450549
	},
	{
		"stop_id": 8574448,
		"ID": 1382,
		"x": 95.4697489343,
		"y": 74.103208436,
		"h": 2.0549450549
	},
	{
		"stop_id": 8574449,
		"ID": 1382,
		"x": 94.7457687873,
		"y": 73.961243021,
		"h": 2.0549450549
	},
	{
		"stop_id": 8574450,
		"ID": 1382,
		"x": 95.2757634553,
		"y": 72.438235894,
		"h": 2.0549450549
	},
	{
		"stop_id": 8574451,
		"ID": 1382,
		"x": 93.0157070053,
		"y": 73.935219136,
		"h": 2.0549450549
	},
	{
		"stop_id": 8574452,
		"ID": 1382,
		"x": 94.7527482963,
		"y": 72.191212179,
		"h": 2.0549450549
	},
	{
		"stop_id": 8574453,
		"ID": 1382,
		"x": 92.5237202233,
		"y": 73.748250199,
		"h": 2.0549450549
	},
	{
		"stop_id": 8574454,
		"ID": 1382,
		"x": 91.5677698153,
		"y": 73.408187006,
		"h": 2.0549450549
	},
	{
		"stop_id": 8574455,
		"ID": 1382,
		"x": 94.2517705723,
		"y": 72.479229749,
		"h": 2.0549450549
	},
	{
		"stop_id": 8574457,
		"ID": 1382,
		"x": 93.1697555893,
		"y": 72.237177164,
		"h": 2.0549450549
	},
	{
		"stop_id": 8574459,
		"ID": 1382,
		"x": 93.2067238973,
		"y": 72.623180705,
		"h": 2.0549450549
	},
	{
		"stop_id": 8574461,
		"ID": 1382,
		"x": 92.8437625233,
		"y": 72.044245763,
		"h": 2.0549450549
	},
	{
		"stop_id": 8574463,
		"ID": 1382,
		"x": 92.6557239833,
		"y": 71.910161098,
		"h": 2.0549450549
	},
	{
		"stop_id": 8574464,
		"ID": 1382,
		"x": 91.5917413993,
		"y": 72.338190231,
		"h": 2.0549450549
	},
	{
		"stop_id": 8580210,
		"ID": 1382,
		"x": 91.1247735843,
		"y": 73.448145516,
		"h": 2.0549450549
	},
	{
		"stop_id": 8580692,
		"ID": 1382,
		"x": 93.9187432183,
		"y": 77.225219473,
		"h": 2.0549450549
	},
	{
		"stop_id": 8580693,
		"ID": 1382,
		"x": 94.4447250923,
		"y": 77.021249884,
		"h": 2.0549450549
	},
	{
		"stop_id": 8580997,
		"ID": 1382,
		"x": 93.7927654393,
		"y": 72.312146836,
		"h": 2.0549450549
	},
	{
		"stop_id": 8588566,
		"ID": 1382,
		"x": 92.0577344073,
		"y": 72.320208947,
		"h": 2.0549450549
	},
	{
		"stop_id": 8594235,
		"ID": 1382,
		"x": 92.3257265503,
		"y": 71.801238967,
		"h": 2.0549450549
	},
	{
		"stop_id": 8506651,
		"ID": 1335,
		"x": 83.6777692153,
		"y": 74.006181806,
		"h": 1.9230769231
	},
	{
		"stop_id": 8506733,
		"ID": 1335,
		"x": 83.9197284173,
		"y": 76.748237165,
		"h": 1.9230769231
	},
	{
		"stop_id": 8506734,
		"ID": 1335,
		"x": 85.5987642733,
		"y": 75.680197506,
		"h": 1.9230769231
	},
	{
		"stop_id": 8506799,
		"ID": 1335,
		"x": 83.3447233593,
		"y": 76.96217962,
		"h": 1.9230769231
	},
	{
		"stop_id": 8573963,
		"ID": 1335,
		"x": 83.2317552983,
		"y": 77.171206152,
		"h": 1.9230769231
	},
	{
		"stop_id": 8573964,
		"ID": 1335,
		"x": 84.5267228323,
		"y": 76.013181663,
		"h": 1.9230769231
	},
	{
		"stop_id": 8574224,
		"ID": 1335,
		"x": 84.9717502553,
		"y": 71.512169531,
		"h": 1.9230769231
	},
	{
		"stop_id": 8574225,
		"ID": 1335,
		"x": 84.3287630933,
		"y": 71.591237369,
		"h": 1.9230769231
	},
	{
		"stop_id": 8574226,
		"ID": 1335,
		"x": 83.7177192423,
		"y": 71.745219235,
		"h": 1.9230769231
	},
	{
		"stop_id": 8574227,
		"ID": 1335,
		"x": 84.3447564443,
		"y": 72.797219619,
		"h": 1.9230769231
	},
	{
		"stop_id": 8574228,
		"ID": 1335,
		"x": 84.3717153493,
		"y": 73.168229941,
		"h": 1.9230769231
	},
	{
		"stop_id": 8574229,
		"ID": 1335,
		"x": 84.2497017133,
		"y": 73.60823792,
		"h": 1.9230769231
	},
	{
		"stop_id": 8574231,
		"ID": 1335,
		"x": 82.4867139153,
		"y": 75.011185519,
		"h": 1.9230769231
	},
	{
		"stop_id": 8574232,
		"ID": 1335,
		"x": 81.1387547353,
		"y": 74.150249128,
		"h": 1.9230769231
	},
	{
		"stop_id": 8574233,
		"ID": 1335,
		"x": 80.5417129853,
		"y": 74.559236631,
		"h": 1.9230769231
	},
	{
		"stop_id": 8574237,
		"ID": 1335,
		"x": 84.5977292813,
		"y": 74.185153409,
		"h": 1.9230769231
	},
	{
		"stop_id": 8580797,
		"ID": 1335,
		"x": 84.0317242653,
		"y": 73.825148558,
		"h": 1.9230769231
	},
	{
		"stop_id": 8581773,
		"ID": 1335,
		"x": 83.8127093643,
		"y": 71.955164453,
		"h": 1.9230769231
	},
	{
		"stop_id": 8581776,
		"ID": 1335,
		"x": 82.0397083013,
		"y": 71.575210272,
		"h": 1.9230769231
	},
	{
		"stop_id": 8588962,
		"ID": 1335,
		"x": 82.3237152543,
		"y": 71.689233804,
		"h": 1.9230769231
	},
	{
		"stop_id": 8588963,
		"ID": 1335,
		"x": 82.6357383663,
		"y": 71.73321182,
		"h": 1.9230769231
	},
	{
		"stop_id": 8588964,
		"ID": 1335,
		"x": 82.7857173923,
		"y": 71.620156511,
		"h": 1.9230769231
	},
	{
		"stop_id": 8588965,
		"ID": 1335,
		"x": 82.4357579763,
		"y": 71.496184584,
		"h": 1.9230769231
	},
	{
		"stop_id": 8588966,
		"ID": 1335,
		"x": 82.1597195803,
		"y": 71.490226322,
		"h": 1.9230769231
	},
	{
		"stop_id": 8589569,
		"ID": 1335,
		"x": 85.0907304753,
		"y": 71.693250262,
		"h": 1.9230769231
	},
	{
		"stop_id": 8589587,
		"ID": 1335,
		"x": 85.5777743873,
		"y": 72.235142424,
		"h": 1.9230769231
	},
	{
		"stop_id": 8589612,
		"ID": 1335,
		"x": 85.3127209393,
		"y": 71.70224666,
		"h": 1.9230769231
	},
	{
		"stop_id": 8589623,
		"ID": 1335,
		"x": 85.2477699923,
		"y": 71.984147898,
		"h": 1.9230769231
	},
	{
		"stop_id": 8589908,
		"ID": 1335,
		"x": 83.0657655833,
		"y": 71.641143877,
		"h": 1.9230769231
	},
	{
		"stop_id": 8506655,
		"ID": 1219,
		"x": 63.2307350073,
		"y": 80.078144019,
		"h": 1.4285714286
	},
	{
		"stop_id": 8506659,
		"ID": 1219,
		"x": 62.4227551773,
		"y": 79.169144428,
		"h": 1.4285714286
	},
	{
		"stop_id": 8506664,
		"ID": 1219,
		"x": 64.6827644403,
		"y": 77.93024704,
		"h": 1.4285714286
	},
	{
		"stop_id": 8506665,
		"ID": 1219,
		"x": 63.8477102133,
		"y": 77.731234871,
		"h": 1.4285714286
	},
	{
		"stop_id": 8506668,
		"ID": 1219,
		"x": 64.4557561253,
		"y": 82.230243295,
		"h": 1.4285714286
	},
	{
		"stop_id": 8506670,
		"ID": 1219,
		"x": 65.4107488493,
		"y": 78.651248825,
		"h": 1.4285714286
	},
	{
		"stop_id": 8506737,
		"ID": 1219,
		"x": 61.5657253533,
		"y": 78.467218271,
		"h": 1.4285714286
	},
	{
		"stop_id": 8582603,
		"ID": 1219,
		"x": 64.8487280993,
		"y": 82.332159247,
		"h": 1.4285714286
	},
	{
		"stop_id": 8582606,
		"ID": 1219,
		"x": 65.8347087653,
		"y": 81.898177767,
		"h": 1.4285714286
	},
	{
		"stop_id": 8582608,
		"ID": 1219,
		"x": 65.0527766013,
		"y": 82.105144744,
		"h": 1.4285714286
	},
	{
		"stop_id": 8582809,
		"ID": 1219,
		"x": 65.4427621143,
		"y": 82.074249402,
		"h": 1.4285714286
	},
	{
		"stop_id": 8588624,
		"ID": 1219,
		"x": 66.2747124983,
		"y": 79.388144032,
		"h": 1.4285714286
	},
	{
		"stop_id": 8589071,
		"ID": 1219,
		"x": 63.4407122773,
		"y": 80.149243875,
		"h": 1.4285714286
	},
	{
		"stop_id": 8595252,
		"ID": 1219,
		"x": 66.0497510683,
		"y": 79.419161796,
		"h": 1.4285714286
	},
	{
		"stop_id": 8506666,
		"ID": 846,
		"x": 7.4367551433,
		"y": 16.807219428,
		"h": 2.1538461538
	},
	{
		"stop_id": 8508318,
		"ID": 846,
		"x": 6.5637208083,
		"y": 21.30317176,
		"h": 2.1538461538
	},
	{
		"stop_id": 8508360,
		"ID": 846,
		"x": 10.6427366793,
		"y": 18.654218541,
		"h": 2.1538461538
	},
	{
		"stop_id": 8508390,
		"ID": 846,
		"x": 8.5627098813,
		"y": 20.620164667,
		"h": 2.1538461538
	},
	{
		"stop_id": 8508391,
		"ID": 846,
		"x": 10.8997443323,
		"y": 18.652249308,
		"h": 2.1538461538
	},
	{
		"stop_id": 8508481,
		"ID": 846,
		"x": 6.7457494723,
		"y": 21.512209786,
		"h": 2.1538461538
	},
	{
		"stop_id": 8508483,
		"ID": 846,
		"x": 8.5457377663,
		"y": 21.106154391,
		"h": 2.1538461538
	},
	{
		"stop_id": 8508709,
		"ID": 846,
		"x": 9.5497593913,
		"y": 21.012212306,
		"h": 2.1538461538
	},
	{
		"stop_id": 8508730,
		"ID": 846,
		"x": 8.5247099873,
		"y": 18.425181593,
		"h": 2.1538461538
	},
	{
		"stop_id": 8508731,
		"ID": 846,
		"x": 10.5347058443,
		"y": 21.29422178,
		"h": 2.1538461538
	},
	{
		"stop_id": 8508732,
		"ID": 846,
		"x": 8.7987329763,
		"y": 19.654170918,
		"h": 2.1538461538
	},
	{
		"stop_id": 8508734,
		"ID": 846,
		"x": 9.4987038203,
		"y": 18.73423812,
		"h": 2.1538461538
	},
	{
		"stop_id": 8508896,
		"ID": 846,
		"x": 10.8677051893,
		"y": 18.690227138,
		"h": 2.1538461538
	},
	{
		"stop_id": 8508975,
		"ID": 846,
		"x": 10.1547285013,
		"y": 18.914205047,
		"h": 2.1538461538
	},
	{
		"stop_id": 8572902,
		"ID": 846,
		"x": 7.9457373193,
		"y": 17.54317869,
		"h": 2.1538461538
	},
	{
		"stop_id": 8572903,
		"ID": 846,
		"x": 8.8547646863,
		"y": 18.486219166,
		"h": 2.1538461538
	},
	{
		"stop_id": 8572923,
		"ID": 846,
		"x": 10.1327236783,
		"y": 19.305184989,
		"h": 2.1538461538
	},
	{
		"stop_id": 8572925,
		"ID": 846,
		"x": 9.2547685703,
		"y": 19.832193075,
		"h": 2.1538461538
	},
	{
		"stop_id": 8572926,
		"ID": 846,
		"x": 8.7437059873,
		"y": 20.0392176,
		"h": 2.1538461538
	},
	{
		"stop_id": 8572927,
		"ID": 846,
		"x": 8.9957295323,
		"y": 20.544195251,
		"h": 2.1538461538
	},
	{
		"stop_id": 8572928,
		"ID": 846,
		"x": 8.5837563793,
		"y": 20.656204919,
		"h": 2.1538461538
	},
	{
		"stop_id": 8572929,
		"ID": 846,
		"x": 8.9827734873,
		"y": 20.830219893,
		"h": 2.1538461538
	},
	{
		"stop_id": 8572930,
		"ID": 846,
		"x": 9.1037360313,
		"y": 21.017170484,
		"h": 2.1538461538
	},
	{
		"stop_id": 8572931,
		"ID": 846,
		"x": 9.8627341233,
		"y": 21.063214549,
		"h": 2.1538461538
	},
	{
		"stop_id": 8572938,
		"ID": 846,
		"x": 11.5057361103,
		"y": 19.042235148,
		"h": 2.1538461538
	},
	{
		"stop_id": 8579966,
		"ID": 846,
		"x": 8.2077700693,
		"y": 17.980191545,
		"h": 2.1538461538
	},
	{
		"stop_id": 8580597,
		"ID": 846,
		"x": 8.7247750633,
		"y": 20.887181472,
		"h": 2.1538461538
	},
	{
		"stop_id": 8581333,
		"ID": 846,
		"x": 10.4427679683,
		"y": 19.075233784,
		"h": 2.1538461538
	},
	{
		"stop_id": 8581519,
		"ID": 846,
		"x": 11.2607192283,
		"y": 18.472194755,
		"h": 2.1538461538
	},
	{
		"stop_id": 8582769,
		"ID": 846,
		"x": 9.8807325053,
		"y": 19.741175446,
		"h": 2.1538461538
	},
	{
		"stop_id": 8583492,
		"ID": 846,
		"x": 10.2327447203,
		"y": 19.720162933,
		"h": 2.1538461538
	},
	{
		"stop_id": 8583493,
		"ID": 846,
		"x": 10.6397095663,
		"y": 19.699151413,
		"h": 2.1538461538
	},
	{
		"stop_id": 8583494,
		"ID": 846,
		"x": 10.4907727453,
		"y": 19.446245389,
		"h": 2.1538461538
	},
	{
		"stop_id": 8591817,
		"ID": 846,
		"x": 6.5637208083,
		"y": 21.30317176,
		"h": 2.1538461538
	},
	{
		"stop_id": 8595489,
		"ID": 846,
		"x": 6.6847697843,
		"y": 21.529208431,
		"h": 2.1538461538
	},
	{
		"stop_id": 8595490,
		"ID": 846,
		"x": 6.8747290313,
		"y": 22.015173045,
		"h": 2.1538461538
	},
	{
		"stop_id": 8506678,
		"ID": 1181,
		"x": 56.7057152683,
		"y": 73.90318276,
		"h": 1.4285714286
	},
	{
		"stop_id": 8506851,
		"ID": 1181,
		"x": 55.6987541923,
		"y": 71.841156818,
		"h": 1.4285714286
	},
	{
		"stop_id": 8578514,
		"ID": 1181,
		"x": 60.2277624413,
		"y": 68.820238328,
		"h": 1.4285714286
	},
	{
		"stop_id": 8578520,
		"ID": 1181,
		"x": 61.5377043813,
		"y": 71.956160711,
		"h": 1.4285714286
	},
	{
		"stop_id": 8578604,
		"ID": 1181,
		"x": 56.4307395053,
		"y": 73.2662371,
		"h": 1.4285714286
	},
	{
		"stop_id": 8578605,
		"ID": 1181,
		"x": 55.9947174143,
		"y": 72.350142178,
		"h": 1.4285714286
	},
	{
		"stop_id": 8578607,
		"ID": 1181,
		"x": 55.3937570253,
		"y": 71.367153036,
		"h": 1.4285714286
	},
	{
		"stop_id": 8578608,
		"ID": 1181,
		"x": 55.4527557253,
		"y": 71.139218854,
		"h": 1.4285714286
	},
	{
		"stop_id": 8578789,
		"ID": 1181,
		"x": 58.7147428253,
		"y": 73.050189834,
		"h": 1.4285714286
	},
	{
		"stop_id": 8578790,
		"ID": 1181,
		"x": 58.7837327913,
		"y": 73.312240287,
		"h": 1.4285714286
	},
	{
		"stop_id": 8578791,
		"ID": 1181,
		"x": 59.0887579303,
		"y": 74.153190794,
		"h": 1.4285714286
	},
	{
		"stop_id": 8587772,
		"ID": 1181,
		"x": 59.2627415943,
		"y": 70.93625073,
		"h": 1.4285714286
	},
	{
		"stop_id": 8587781,
		"ID": 1181,
		"x": 59.9537687053,
		"y": 70.627241568,
		"h": 1.4285714286
	},
	{
		"stop_id": 8595946,
		"ID": 1181,
		"x": 57.0727484503,
		"y": 74.26016331,
		"h": 1.4285714286
	},
	{
		"stop_id": 8506686,
		"ID": 1180,
		"x": 58.3227443393,
		"y": 68.247159741,
		"h": 1.2967032967
	},
	{
		"stop_id": 8573985,
		"ID": 1180,
		"x": 61.1007387603,
		"y": 65.332231181,
		"h": 1.2967032967
	},
	{
		"stop_id": 8573986,
		"ID": 1180,
		"x": 60.2177491193,
		"y": 65.683152714,
		"h": 1.2967032967
	},
	{
		"stop_id": 8573987,
		"ID": 1180,
		"x": 59.4507087013,
		"y": 65.416236466,
		"h": 1.2967032967
	},
	{
		"stop_id": 8573988,
		"ID": 1180,
		"x": 58.8887551833,
		"y": 65.249159797,
		"h": 1.2967032967
	},
	{
		"stop_id": 8573989,
		"ID": 1180,
		"x": 57.5417170683,
		"y": 65.305187094,
		"h": 1.2967032967
	},
	{
		"stop_id": 8573990,
		"ID": 1180,
		"x": 57.0667029233,
		"y": 65.289241522,
		"h": 1.2967032967
	},
	{
		"stop_id": 8578511,
		"ID": 1180,
		"x": 58.6177167163,
		"y": 68.230140102,
		"h": 1.2967032967
	},
	{
		"stop_id": 8578512,
		"ID": 1180,
		"x": 59.1977028923,
		"y": 68.380212084,
		"h": 1.2967032967
	},
	{
		"stop_id": 8578513,
		"ID": 1180,
		"x": 59.5827124433,
		"y": 68.320233991,
		"h": 1.2967032967
	},
	{
		"stop_id": 8506689,
		"ID": 1078,
		"x": 45.4677232863,
		"y": 90.345194119,
		"h": 1.3626373626
	},
	{
		"stop_id": 8506858,
		"ID": 1078,
		"x": 43.4717730113,
		"y": 89.042173536,
		"h": 1.3626373626
	},
	{
		"stop_id": 8506887,
		"ID": 1078,
		"x": 41.4457146903,
		"y": 89.966240947,
		"h": 1.3626373626
	},
	{
		"stop_id": 8506888,
		"ID": 1078,
		"x": 44.6047073643,
		"y": 93.296243298,
		"h": 1.3626373626
	},
	{
		"stop_id": 8506954,
		"ID": 1078,
		"x": 42.1867420003,
		"y": 94.25616208,
		"h": 1.3626373626
	},
	{
		"stop_id": 8506963,
		"ID": 1078,
		"x": 46.6927661233,
		"y": 91.987149564,
		"h": 1.3626373626
	},
	{
		"stop_id": 8573202,
		"ID": 1078,
		"x": 41.0537089423,
		"y": 92.929209265,
		"h": 1.3626373626
	},
	{
		"stop_id": 8573328,
		"ID": 1078,
		"x": 42.5507266303,
		"y": 94.060177342,
		"h": 1.3626373626
	},
	{
		"stop_id": 8580247,
		"ID": 1078,
		"x": 45.0157376503,
		"y": 92.813210085,
		"h": 1.3626373626
	},
	{
		"stop_id": 8581406,
		"ID": 1078,
		"x": 43.9437603473,
		"y": 91.561185248,
		"h": 1.3626373626
	},
	{
		"stop_id": 8581409,
		"ID": 1078,
		"x": 43.9837101513,
		"y": 90.157219794,
		"h": 1.3626373626
	},
	{
		"stop_id": 8582718,
		"ID": 1078,
		"x": 42.9677690063,
		"y": 89.82016971,
		"h": 1.3626373626
	},
	{
		"stop_id": 8506750,
		"ID": 1305,
		"x": 80.0927569683,
		"y": 45.994176776,
		"h": 1
	},
	{
		"stop_id": 8506751,
		"ID": 1278,
		"x": 73.0787376693,
		"y": 58.370216397,
		"h": 1.2307692308
	},
	{
		"stop_id": 8506757,
		"ID": 1278,
		"x": 71.6127668513,
		"y": 57.675219573,
		"h": 1.2307692308
	},
	{
		"stop_id": 8574017,
		"ID": 1278,
		"x": 71.1797465413,
		"y": 57.51418295,
		"h": 1.2307692308
	},
	{
		"stop_id": 8574184,
		"ID": 1278,
		"x": 72.8897405253,
		"y": 59.88720041,
		"h": 1.2307692308
	},
	{
		"stop_id": 8574197,
		"ID": 1278,
		"x": 72.7747581043,
		"y": 59.293225332,
		"h": 1.2307692308
	},
	{
		"stop_id": 8574198,
		"ID": 1278,
		"x": 72.5587611803,
		"y": 57.533213215,
		"h": 1.2307692308
	},
	{
		"stop_id": 8574199,
		"ID": 1278,
		"x": 72.1777132913,
		"y": 56.801213794,
		"h": 1.2307692308
	},
	{
		"stop_id": 8581030,
		"ID": 1278,
		"x": 72.6827707203,
		"y": 57.756170979,
		"h": 1.2307692308
	},
	{
		"stop_id": 8506755,
		"ID": 977,
		"x": 28.3577136613,
		"y": 87.505238727,
		"h": 1.2307692308
	},
	{
		"stop_id": 8573688,
		"ID": 977,
		"x": 27.4827462653,
		"y": 86.780221677,
		"h": 1.2307692308
	},
	{
		"stop_id": 8573689,
		"ID": 977,
		"x": 27.7477560253,
		"y": 87.154221818,
		"h": 1.2307692308
	},
	{
		"stop_id": 8573702,
		"ID": 977,
		"x": 29.4777332963,
		"y": 87.365154089,
		"h": 1.2307692308
	},
	{
		"stop_id": 8573703,
		"ID": 977,
		"x": 28.8077039943,
		"y": 87.505188311,
		"h": 1.2307692308
	},
	{
		"stop_id": 8573705,
		"ID": 977,
		"x": 26.2577146573,
		"y": 87.430236085,
		"h": 1.2307692308
	},
	{
		"stop_id": 8581535,
		"ID": 977,
		"x": 27.8787016963,
		"y": 87.397249268,
		"h": 1.2307692308
	},
	{
		"stop_id": 8583360,
		"ID": 977,
		"x": 27.7927076903,
		"y": 87.132203026,
		"h": 1.2307692308
	},
	{
		"stop_id": 8506761,
		"ID": 1406,
		"x": 96.3447066203,
		"y": 72.52817905,
		"h": 2.0879120879
	},
	{
		"stop_id": 8506765,
		"ID": 1406,
		"x": 99.7497498543,
		"y": 71.941187943,
		"h": 2.0879120879
	},
	{
		"stop_id": 8506771,
		"ID": 1406,
		"x": 100.3327708463,
		"y": 72.330201686,
		"h": 2.0879120879
	},
	{
		"stop_id": 8506860,
		"ID": 1406,
		"x": 98.4737100323,
		"y": 70.570247444,
		"h": 2.0879120879
	},
	{
		"stop_id": 8574078,
		"ID": 1406,
		"x": 98.0027606813,
		"y": 74.201250432,
		"h": 2.0879120879
	},
	{
		"stop_id": 8574079,
		"ID": 1406,
		"x": 97.7367139213,
		"y": 73.373217215,
		"h": 2.0879120879
	},
	{
		"stop_id": 8574080,
		"ID": 1406,
		"x": 97.2327439493,
		"y": 73.197213947,
		"h": 2.0879120879
	},
	{
		"stop_id": 8574081,
		"ID": 1406,
		"x": 96.8887012583,
		"y": 73.0341619,
		"h": 2.0879120879
	},
	{
		"stop_id": 8574082,
		"ID": 1406,
		"x": 98.2437436873,
		"y": 74.281201495,
		"h": 2.0879120879
	},
	{
		"stop_id": 8574096,
		"ID": 1406,
		"x": 100.5747164043,
		"y": 73.741191832,
		"h": 2.0879120879
	},
	{
		"stop_id": 8574123,
		"ID": 1406,
		"x": 98.4077237813,
		"y": 73.730240557,
		"h": 2.0879120879
	},
	{
		"stop_id": 8574124,
		"ID": 1406,
		"x": 98.8497679703,
		"y": 72.886204168,
		"h": 2.0879120879
	},
	{
		"stop_id": 8574125,
		"ID": 1406,
		"x": 99.2827700113,
		"y": 72.630221497,
		"h": 2.0879120879
	},
	{
		"stop_id": 8574126,
		"ID": 1406,
		"x": 99.8647102083,
		"y": 72.123247818,
		"h": 2.0879120879
	},
	{
		"stop_id": 8574127,
		"ID": 1406,
		"x": 101.0047225143,
		"y": 71.682181731,
		"h": 2.0879120879
	},
	{
		"stop_id": 8574128,
		"ID": 1406,
		"x": 101.3147484903,
		"y": 71.724201772,
		"h": 2.0879120879
	},
	{
		"stop_id": 8574129,
		"ID": 1406,
		"x": 101.5927203193,
		"y": 71.895163948,
		"h": 2.0879120879
	},
	{
		"stop_id": 8574138,
		"ID": 1406,
		"x": 101.7017102513,
		"y": 71.28417361,
		"h": 2.0879120879
	},
	{
		"stop_id": 8574142,
		"ID": 1406,
		"x": 100.8977129173,
		"y": 69.920148838,
		"h": 2.0879120879
	},
	{
		"stop_id": 8574143,
		"ID": 1406,
		"x": 100.1667744493,
		"y": 69.145147951,
		"h": 2.0879120879
	},
	{
		"stop_id": 8574148,
		"ID": 1406,
		"x": 99.0397681173,
		"y": 71.650151005,
		"h": 2.0879120879
	},
	{
		"stop_id": 8574149,
		"ID": 1406,
		"x": 98.8417171993,
		"y": 70.674191637,
		"h": 2.0879120879
	},
	{
		"stop_id": 8574150,
		"ID": 1406,
		"x": 97.7127543003,
		"y": 70.095164345,
		"h": 2.0879120879
	},
	{
		"stop_id": 8574154,
		"ID": 1406,
		"x": 95.7507613123,
		"y": 71.742213421,
		"h": 2.0879120879
	},
	{
		"stop_id": 8574477,
		"ID": 1406,
		"x": 99.9607322823,
		"y": 74.295168367,
		"h": 2.0879120879
	},
	{
		"stop_id": 8576150,
		"ID": 1406,
		"x": 95.5447120553,
		"y": 71.462195134,
		"h": 2.0879120879
	},
	{
		"stop_id": 8580542,
		"ID": 1406,
		"x": 97.9517384803,
		"y": 73.961202897,
		"h": 2.0879120879
	},
	{
		"stop_id": 8580720,
		"ID": 1406,
		"x": 99.4997286933,
		"y": 72.163242311,
		"h": 2.0879120879
	},
	{
		"stop_id": 8580996,
		"ID": 1406,
		"x": 100.0117462403,
		"y": 69.01016353,
		"h": 2.0879120879
	},
	{
		"stop_id": 8581399,
		"ID": 1406,
		"x": 96.0827650283,
		"y": 72.455208191,
		"h": 2.0879120879
	},
	{
		"stop_id": 8581403,
		"ID": 1406,
		"x": 98.7157256033,
		"y": 71.068218384,
		"h": 2.0879120879
	},
	{
		"stop_id": 8581566,
		"ID": 1406,
		"x": 95.8657414483,
		"y": 72.017174635,
		"h": 2.0879120879
	},
	{
		"stop_id": 8581740,
		"ID": 1406,
		"x": 98.2507254693,
		"y": 74.110213728,
		"h": 2.0879120879
	},
	{
		"stop_id": 8582242,
		"ID": 1406,
		"x": 97.2707131873,
		"y": 69.421203937,
		"h": 2.0879120879
	},
	{
		"stop_id": 8506763,
		"ID": 978,
		"x": 28.0567066543,
		"y": 94.222205988,
		"h": 1.1978021978
	},
	{
		"stop_id": 8506768,
		"ID": 978,
		"x": 27.9577500973,
		"y": 95.205227631,
		"h": 1.1978021978
	},
	{
		"stop_id": 8506878,
		"ID": 978,
		"x": 27.5577487123,
		"y": 94.980217665,
		"h": 1.1978021978
	},
	{
		"stop_id": 8530651,
		"ID": 978,
		"x": 27.7577031183,
		"y": 94.430161713,
		"h": 1.1978021978
	},
	{
		"stop_id": 8573433,
		"ID": 978,
		"x": 27.5577182753,
		"y": 94.505151597,
		"h": 1.1978021978
	},
	{
		"stop_id": 8573434,
		"ID": 978,
		"x": 28.9327655473,
		"y": 94.355194576,
		"h": 1.1978021978
	},
	{
		"stop_id": 8573454,
		"ID": 978,
		"x": 29.0827462963,
		"y": 97.305172342,
		"h": 1.1978021978
	},
	{
		"stop_id": 8506776,
		"ID": 1276,
		"x": 75.7327330623,
		"y": 46.680197995,
		"h": 1.0989010989
	},
	{
		"stop_id": 8574020,
		"ID": 1276,
		"x": 74.8277246703,
		"y": 48.352183195,
		"h": 1.0989010989
	},
	{
		"stop_id": 8574021,
		"ID": 1276,
		"x": 75.3567302703,
		"y": 47.140147274,
		"h": 1.0989010989
	},
	{
		"stop_id": 8574022,
		"ID": 1276,
		"x": 76.0217029703,
		"y": 45.908241771,
		"h": 1.0989010989
	},
	{
		"stop_id": 8506780,
		"ID": 1330,
		"x": 85.1267198983,
		"y": 47.208161679,
		"h": 1.3626373626
	},
	{
		"stop_id": 8506781,
		"ID": 1330,
		"x": 84.2167752543,
		"y": 46.967186927,
		"h": 1.3626373626
	},
	{
		"stop_id": 8506788,
		"ID": 1330,
		"x": 81.9757460983,
		"y": 46.448246171,
		"h": 1.3626373626
	},
	{
		"stop_id": 8530486,
		"ID": 1330,
		"x": 84.4907380143,
		"y": 46.731171086,
		"h": 1.3626373626
	},
	{
		"stop_id": 8530487,
		"ID": 1330,
		"x": 84.7217430313,
		"y": 45.996238454,
		"h": 1.3626373626
	},
	{
		"stop_id": 8530488,
		"ID": 1330,
		"x": 84.3477305193,
		"y": 43.812246568,
		"h": 1.3626373626
	},
	{
		"stop_id": 8530489,
		"ID": 1330,
		"x": 85.5727311223,
		"y": 47.71415968,
		"h": 1.3626373626
	},
	{
		"stop_id": 8530490,
		"ID": 1330,
		"x": 84.5597068553,
		"y": 48.30423845,
		"h": 1.3626373626
	},
	{
		"stop_id": 8574026,
		"ID": 1330,
		"x": 81.1057260883,
		"y": 46.365175487,
		"h": 1.3626373626
	},
	{
		"stop_id": 8574027,
		"ID": 1330,
		"x": 82.6917540823,
		"y": 46.571234113,
		"h": 1.3626373626
	},
	{
		"stop_id": 8574028,
		"ID": 1330,
		"x": 83.2977210013,
		"y": 46.856248569,
		"h": 1.3626373626
	},
	{
		"stop_id": 8574029,
		"ID": 1330,
		"x": 85.9067045783,
		"y": 46.92618287,
		"h": 1.3626373626
	},
	{
		"stop_id": 8506786,
		"ID": 1179,
		"x": 60.0047085713,
		"y": 60.709243435,
		"h": 1.032967033
	},
	{
		"stop_id": 8573996,
		"ID": 1179,
		"x": 60.4407746733,
		"y": 61.19524104,
		"h": 1.032967033
	},
	{
		"stop_id": 8506889,
		"ID": 975,
		"x": 27.3577277143,
		"y": 79.380234357,
		"h": 1.3956043956
	},
	{
		"stop_id": 8506895,
		"ID": 975,
		"x": 27.3017748203,
		"y": 77.837198365,
		"h": 1.3956043956
	},
	{
		"stop_id": 8506897,
		"ID": 975,
		"x": 27.2827073333,
		"y": 79.680144628,
		"h": 1.3956043956
	},
	{
		"stop_id": 8506898,
		"ID": 975,
		"x": 29.2577118663,
		"y": 77.68016854,
		"h": 1.3956043956
	},
	{
		"stop_id": 8573225,
		"ID": 975,
		"x": 27.6827212983,
		"y": 79.105144404,
		"h": 1.3956043956
	},
	{
		"stop_id": 8573226,
		"ID": 975,
		"x": 27.3827037743,
		"y": 79.030215253,
		"h": 1.3956043956
	},
	{
		"stop_id": 8573228,
		"ID": 975,
		"x": 27.5327449063,
		"y": 78.080235352,
		"h": 1.3956043956
	},
	{
		"stop_id": 8573229,
		"ID": 975,
		"x": 27.0327155303,
		"y": 77.055191211,
		"h": 1.3956043956
	},
	{
		"stop_id": 8573230,
		"ID": 975,
		"x": 27.2077716393,
		"y": 76.505220424,
		"h": 1.3956043956
	},
	{
		"stop_id": 8573232,
		"ID": 975,
		"x": 26.5607054823,
		"y": 74.986239534,
		"h": 1.3956043956
	},
	{
		"stop_id": 8579968,
		"ID": 975,
		"x": 26.6557294783,
		"y": 75.703180502,
		"h": 1.3956043956
	},
	{
		"stop_id": 8579969,
		"ID": 975,
		"x": 26.4607124043,
		"y": 75.426234123,
		"h": 1.3956043956
	},
	{
		"stop_id": 8590600,
		"ID": 975,
		"x": 26.4837241023,
		"y": 75.963207523,
		"h": 1.3956043956
	},
	{
		"stop_id": 8507002,
		"ID": 451,
		"x": -56.4802547827,
		"y": 18.066191803,
		"h": 5.0549450549
	},
	{
		"stop_id": 8507003,
		"ID": 451,
		"x": -54.6502593147,
		"y": 15.568222275,
		"h": 5.0549450549
	},
	{
		"stop_id": 8507050,
		"ID": 451,
		"x": -56.8362667467,
		"y": 15.839152208,
		"h": 5.0549450549
	},
	{
		"stop_id": 8507052,
		"ID": 451,
		"x": -55.2212802587,
		"y": 15.635249964,
		"h": 5.0549450549
	},
	{
		"stop_id": 8507053,
		"ID": 451,
		"x": -53.7952929707,
		"y": 15.380234858,
		"h": 5.0549450549
	},
	{
		"stop_id": 8507060,
		"ID": 451,
		"x": -58.9372398797,
		"y": 16.632171226,
		"h": 5.0549450549
	},
	{
		"stop_id": 8507061,
		"ID": 451,
		"x": -57.8322589947,
		"y": 16.330247445,
		"h": 5.0549450549
	},
	{
		"stop_id": 8507062,
		"ID": 451,
		"x": -56.1042978937,
		"y": 15.244226759,
		"h": 5.0549450549
	},
	{
		"stop_id": 8507067,
		"ID": 451,
		"x": -53.9902553347,
		"y": 18.114178009,
		"h": 5.0549450549
	},
	{
		"stop_id": 8507068,
		"ID": 451,
		"x": -55.2692753667,
		"y": 19.484170062,
		"h": 5.0549450549
	},
	{
		"stop_id": 8507110,
		"ID": 451,
		"x": -59.0672485197,
		"y": 17.070169057,
		"h": 5.0549450549
	},
	{
		"stop_id": 8507251,
		"ID": 451,
		"x": -55.6382807767,
		"y": 15.423174103,
		"h": 5.0549450549
	},
	{
		"stop_id": 8508075,
		"ID": 451,
		"x": -58.5032845407,
		"y": 18.296244217,
		"h": 5.0549450549
	},
	{
		"stop_id": 8516161,
		"ID": 451,
		"x": -57.7002959397,
		"y": 19.291213322,
		"h": 5.0549450549
	},
	{
		"stop_id": 8530257,
		"ID": 451,
		"x": -59.4702767647,
		"y": 16.861141109,
		"h": 5.0549450549
	},
	{
		"stop_id": 8530258,
		"ID": 451,
		"x": -59.4022859787,
		"y": 16.776209396,
		"h": 5.0549450549
	},
	{
		"stop_id": 8530259,
		"ID": 451,
		"x": -54.2392756367,
		"y": 15.397157107,
		"h": 5.0549450549
	},
	{
		"stop_id": 8571395,
		"ID": 451,
		"x": -58.6752659007,
		"y": 14.867155663,
		"h": 5.0549450549
	},
	{
		"stop_id": 8576987,
		"ID": 451,
		"x": -58.1792575067,
		"y": 19.187240657,
		"h": 5.0549450549
	},
	{
		"stop_id": 8576990,
		"ID": 451,
		"x": -57.8072387337,
		"y": 18.377242133,
		"h": 5.0549450549
	},
	{
		"stop_id": 8576991,
		"ID": 451,
		"x": -58.1332562657,
		"y": 17.870210073,
		"h": 5.0549450549
	},
	{
		"stop_id": 8576995,
		"ID": 451,
		"x": -57.2892940037,
		"y": 19.357176438,
		"h": 5.0549450549
	},
	{
		"stop_id": 8576996,
		"ID": 451,
		"x": -57.4962238877,
		"y": 18.967220531,
		"h": 5.0549450549
	},
	{
		"stop_id": 8576997,
		"ID": 451,
		"x": -58.3722541937,
		"y": 18.828224292,
		"h": 5.0549450549
	},
	{
		"stop_id": 8576999,
		"ID": 451,
		"x": -56.5372975767,
		"y": 18.849249754,
		"h": 5.0549450549
	},
	{
		"stop_id": 8577000,
		"ID": 451,
		"x": -56.6502878417,
		"y": 18.489219855,
		"h": 5.0549450549
	},
	{
		"stop_id": 8577001,
		"ID": 451,
		"x": -56.9482608367,
		"y": 18.139221632,
		"h": 5.0549450549
	},
	{
		"stop_id": 8577002,
		"ID": 451,
		"x": -56.7872600527,
		"y": 17.796223954,
		"h": 5.0549450549
	},
	{
		"stop_id": 8577003,
		"ID": 451,
		"x": -56.4402360517,
		"y": 17.961156852,
		"h": 5.0549450549
	},
	{
		"stop_id": 8577004,
		"ID": 451,
		"x": -56.0012474767,
		"y": 18.194202399,
		"h": 5.0549450549
	},
	{
		"stop_id": 8577005,
		"ID": 451,
		"x": -55.5532949507,
		"y": 18.182154615,
		"h": 5.0549450549
	},
	{
		"stop_id": 8577006,
		"ID": 451,
		"x": -55.6462437817,
		"y": 17.97220058,
		"h": 5.0549450549
	},
	{
		"stop_id": 8577007,
		"ID": 451,
		"x": -55.7772630667,
		"y": 17.650162924,
		"h": 5.0549450549
	},
	{
		"stop_id": 8577008,
		"ID": 451,
		"x": -55.8842587427,
		"y": 17.237205833,
		"h": 5.0549450549
	},
	{
		"stop_id": 8577009,
		"ID": 451,
		"x": -55.7182318307,
		"y": 16.906247058,
		"h": 5.0549450549
	},
	{
		"stop_id": 8577010,
		"ID": 451,
		"x": -55.3432754657,
		"y": 16.482168682,
		"h": 5.0549450549
	},
	{
		"stop_id": 8577011,
		"ID": 451,
		"x": -55.2152328697,
		"y": 16.409223768,
		"h": 5.0549450549
	},
	{
		"stop_id": 8577012,
		"ID": 451,
		"x": -55.0602278537,
		"y": 16.230245626,
		"h": 5.0549450549
	},
	{
		"stop_id": 8577013,
		"ID": 451,
		"x": -55.1912366487,
		"y": 15.682186368,
		"h": 5.0549450549
	},
	{
		"stop_id": 8577014,
		"ID": 451,
		"x": -54.6942271617,
		"y": 15.512155556,
		"h": 5.0549450549
	},
	{
		"stop_id": 8577015,
		"ID": 451,
		"x": -54.3552752497,
		"y": 15.163150148,
		"h": 5.0549450549
	},
	{
		"stop_id": 8577016,
		"ID": 451,
		"x": -54.3152381697,
		"y": 14.846239167,
		"h": 5.0549450549
	},
	{
		"stop_id": 8577018,
		"ID": 451,
		"x": -56.3962769307,
		"y": 15.531212721,
		"h": 5.0549450549
	},
	{
		"stop_id": 8577020,
		"ID": 451,
		"x": -55.6412333887,
		"y": 14.833190895,
		"h": 5.0549450549
	},
	{
		"stop_id": 8577021,
		"ID": 451,
		"x": -55.4342579357,
		"y": 14.761184584,
		"h": 5.0549450549
	},
	{
		"stop_id": 8577022,
		"ID": 451,
		"x": -55.1082743597,
		"y": 14.637247475,
		"h": 5.0549450549
	},
	{
		"stop_id": 8580567,
		"ID": 451,
		"x": -58.7512831797,
		"y": 14.938181319,
		"h": 5.0549450549
	},
	{
		"stop_id": 8581306,
		"ID": 451,
		"x": -58.0422303577,
		"y": 14.291210334,
		"h": 5.0549450549
	},
	{
		"stop_id": 8587479,
		"ID": 451,
		"x": -57.6522759117,
		"y": 17.041241739,
		"h": 5.0549450549
	},
	{
		"stop_id": 8587480,
		"ID": 451,
		"x": -57.2422758617,
		"y": 16.768248072,
		"h": 5.0549450549
	},
	{
		"stop_id": 8587481,
		"ID": 451,
		"x": -57.5682420107,
		"y": 16.434167876,
		"h": 5.0549450549
	},
	{
		"stop_id": 8587482,
		"ID": 451,
		"x": -58.7012972867,
		"y": 18.060193002,
		"h": 5.0549450549
	},
	{
		"stop_id": 8587483,
		"ID": 451,
		"x": -58.5412374147,
		"y": 17.743161897,
		"h": 5.0549450549
	},
	{
		"stop_id": 8587484,
		"ID": 451,
		"x": -58.3202473737,
		"y": 17.708188975,
		"h": 5.0549450549
	},
	{
		"stop_id": 8587485,
		"ID": 451,
		"x": -58.0252280147,
		"y": 17.545175429,
		"h": 5.0549450549
	},
	{
		"stop_id": 8588174,
		"ID": 451,
		"x": -57.1972946007,
		"y": 16.067224817,
		"h": 5.0549450549
	},
	{
		"stop_id": 8588699,
		"ID": 451,
		"x": -57.6672656447,
		"y": 18.605187903,
		"h": 5.0549450549
	},
	{
		"stop_id": 8588988,
		"ID": 451,
		"x": -59.0612244867,
		"y": 16.228163409,
		"h": 5.0549450549
	},
	{
		"stop_id": 8588989,
		"ID": 451,
		"x": -59.4202672667,
		"y": 17.101160478,
		"h": 5.0549450549
	},
	{
		"stop_id": 8588997,
		"ID": 451,
		"x": -57.5852458127,
		"y": 15.633178333,
		"h": 5.0549450549
	},
	{
		"stop_id": 8588998,
		"ID": 451,
		"x": -57.3132916427,
		"y": 15.566243707,
		"h": 5.0549450549
	},
	{
		"stop_id": 8588999,
		"ID": 451,
		"x": -58.1342853657,
		"y": 18.91121436,
		"h": 5.0549450549
	},
	{
		"stop_id": 8589000,
		"ID": 451,
		"x": -58.2322553957,
		"y": 18.363228244,
		"h": 5.0549450549
	},
	{
		"stop_id": 8589001,
		"ID": 451,
		"x": -57.8992552827,
		"y": 16.050188601,
		"h": 5.0549450549
	},
	{
		"stop_id": 8589002,
		"ID": 451,
		"x": -56.1672332817,
		"y": 15.948231998,
		"h": 5.0549450549
	},
	{
		"stop_id": 8589003,
		"ID": 451,
		"x": -58.2292324947,
		"y": 16.245204138,
		"h": 5.0549450549
	},
	{
		"stop_id": 8589005,
		"ID": 451,
		"x": -57.7702745197,
		"y": 15.831222363,
		"h": 5.0549450549
	},
	{
		"stop_id": 8589006,
		"ID": 451,
		"x": -56.4842276797,
		"y": 15.954168808,
		"h": 5.0549450549
	},
	{
		"stop_id": 8589007,
		"ID": 451,
		"x": -57.8362813417,
		"y": 19.013242325,
		"h": 5.0549450549
	},
	{
		"stop_id": 8589037,
		"ID": 451,
		"x": -54.8162291357,
		"y": 14.586228207,
		"h": 5.0549450549
	},
	{
		"stop_id": 8589199,
		"ID": 451,
		"x": -55.7082274207,
		"y": 15.712170465,
		"h": 5.0549450549
	},
	{
		"stop_id": 8589200,
		"ID": 451,
		"x": -56.1352563087,
		"y": 15.826185631,
		"h": 5.0549450549
	},
	{
		"stop_id": 8590003,
		"ID": 451,
		"x": -57.4122337847,
		"y": 17.239211569,
		"h": 5.0549450549
	},
	{
		"stop_id": 8590006,
		"ID": 451,
		"x": -58.6292394987,
		"y": 16.462237125,
		"h": 5.0549450549
	},
	{
		"stop_id": 8590007,
		"ID": 451,
		"x": -55.2302998297,
		"y": 18.342249956,
		"h": 5.0549450549
	},
	{
		"stop_id": 8590019,
		"ID": 451,
		"x": -57.3812979217,
		"y": 16.571198798,
		"h": 5.0549450549
	},
	{
		"stop_id": 8590020,
		"ID": 451,
		"x": -58.9062280127,
		"y": 17.63115504,
		"h": 5.0549450549
	},
	{
		"stop_id": 8590021,
		"ID": 451,
		"x": -58.8002940897,
		"y": 17.836168503,
		"h": 5.0549450549
	},
	{
		"stop_id": 8590032,
		"ID": 451,
		"x": -58.6742663627,
		"y": 17.093234003,
		"h": 5.0549450549
	},
	{
		"stop_id": 8590033,
		"ID": 451,
		"x": -58.3932829777,
		"y": 17.156210103,
		"h": 5.0549450549
	},
	{
		"stop_id": 8590034,
		"ID": 451,
		"x": -58.1582649367,
		"y": 17.131140415,
		"h": 5.0549450549
	},
	{
		"stop_id": 8590035,
		"ID": 451,
		"x": -58.1952381447,
		"y": 16.718243305,
		"h": 5.0549450549
	},
	{
		"stop_id": 8590036,
		"ID": 451,
		"x": -58.0162479207,
		"y": 16.730185464,
		"h": 5.0549450549
	},
	{
		"stop_id": 8590037,
		"ID": 451,
		"x": -57.7862240887,
		"y": 16.907237297,
		"h": 5.0549450549
	},
	{
		"stop_id": 8590048,
		"ID": 451,
		"x": -59.3392581177,
		"y": 16.981211246,
		"h": 5.0549450549
	},
	{
		"stop_id": 8590049,
		"ID": 451,
		"x": -57.5842551247,
		"y": 17.592227305,
		"h": 5.0549450549
	},
	{
		"stop_id": 8590050,
		"ID": 451,
		"x": -57.1242958117,
		"y": 17.727144773,
		"h": 5.0549450549
	},
	{
		"stop_id": 8590051,
		"ID": 451,
		"x": -54.9982915327,
		"y": 18.230144421,
		"h": 5.0549450549
	},
	{
		"stop_id": 8590052,
		"ID": 451,
		"x": -54.6422605557,
		"y": 18.005201478,
		"h": 5.0549450549
	},
	{
		"stop_id": 8590060,
		"ID": 451,
		"x": -59.0772518877,
		"y": 15.841177244,
		"h": 5.0549450549
	},
	{
		"stop_id": 8590061,
		"ID": 451,
		"x": -58.8422873097,
		"y": 16.00518167,
		"h": 5.0549450549
	},
	{
		"stop_id": 8590062,
		"ID": 451,
		"x": -59.0742329807,
		"y": 16.111210694,
		"h": 5.0549450549
	},
	{
		"stop_id": 8590063,
		"ID": 451,
		"x": -57.1422566677,
		"y": 15.380214375,
		"h": 5.0549450549
	},
	{
		"stop_id": 8590070,
		"ID": 451,
		"x": -56.1802539367,
		"y": 17.771201057,
		"h": 5.0549450549
	},
	{
		"stop_id": 8590071,
		"ID": 451,
		"x": -56.1962583437,
		"y": 17.411220672,
		"h": 5.0549450549
	},
	{
		"stop_id": 8590072,
		"ID": 451,
		"x": -56.2912975497,
		"y": 17.067203857,
		"h": 5.0549450549
	},
	{
		"stop_id": 8590079,
		"ID": 451,
		"x": -58.5932926217,
		"y": 18.51923618,
		"h": 5.0549450549
	},
	{
		"stop_id": 8590087,
		"ID": 451,
		"x": -57.9422726907,
		"y": 14.458216109,
		"h": 5.0549450549
	},
	{
		"stop_id": 8590088,
		"ID": 451,
		"x": -56.3762811757,
		"y": 18.486140837,
		"h": 5.0549450549
	},
	{
		"stop_id": 8590089,
		"ID": 451,
		"x": -57.0802415927,
		"y": 16.546197253,
		"h": 5.0549450549
	},
	{
		"stop_id": 8590090,
		"ID": 451,
		"x": -57.1062300527,
		"y": 16.783201818,
		"h": 5.0549450549
	},
	{
		"stop_id": 8590091,
		"ID": 451,
		"x": -56.7342897727,
		"y": 16.888207083,
		"h": 5.0549450549
	},
	{
		"stop_id": 8590092,
		"ID": 451,
		"x": -56.5922707697,
		"y": 16.680167152,
		"h": 5.0549450549
	},
	{
		"stop_id": 8590093,
		"ID": 451,
		"x": -56.3522375867,
		"y": 16.720205994,
		"h": 5.0549450549
	},
	{
		"stop_id": 8590102,
		"ID": 451,
		"x": -58.5412763647,
		"y": 15.130208504,
		"h": 5.0549450549
	},
	{
		"stop_id": 8590103,
		"ID": 451,
		"x": -58.4842418837,
		"y": 14.776142056,
		"h": 5.0549450549
	},
	{
		"stop_id": 8590104,
		"ID": 451,
		"x": -58.0922927457,
		"y": 14.660170963,
		"h": 5.0549450549
	},
	{
		"stop_id": 8590107,
		"ID": 451,
		"x": -58.2342888707,
		"y": 14.47414728,
		"h": 5.0549450549
	},
	{
		"stop_id": 8590110,
		"ID": 451,
		"x": -58.3172752597,
		"y": 15.005188403,
		"h": 5.0549450549
	},
	{
		"stop_id": 8590111,
		"ID": 451,
		"x": -59.2492548707,
		"y": 16.760209646,
		"h": 5.0549450549
	},
	{
		"stop_id": 8590112,
		"ID": 451,
		"x": -58.3582392357,
		"y": 17.04615871,
		"h": 5.0549450549
	},
	{
		"stop_id": 8590113,
		"ID": 451,
		"x": -58.6692806797,
		"y": 16.871226996,
		"h": 5.0549450549
	},
	{
		"stop_id": 8590114,
		"ID": 451,
		"x": -59.3592578597,
		"y": 16.541196791,
		"h": 5.0549450549
	},
	{
		"stop_id": 8590120,
		"ID": 451,
		"x": -58.2882404937,
		"y": 17.226159873,
		"h": 5.0549450549
	},
	{
		"stop_id": 8590126,
		"ID": 451,
		"x": -57.8522420177,
		"y": 14.692145081,
		"h": 5.0549450549
	},
	{
		"stop_id": 8590127,
		"ID": 451,
		"x": -57.1352708067,
		"y": 17.400186821,
		"h": 5.0549450549
	},
	{
		"stop_id": 8590129,
		"ID": 451,
		"x": -57.7822911437,
		"y": 19.155224593,
		"h": 5.0549450549
	},
	{
		"stop_id": 8593303,
		"ID": 451,
		"x": -57.8102487677,
		"y": 16.556152894,
		"h": 5.0549450549
	},
	{
		"stop_id": 8594260,
		"ID": 451,
		"x": -56.0302869567,
		"y": 19.007177993,
		"h": 5.0549450549
	},
	{
		"stop_id": 8595136,
		"ID": 451,
		"x": -57.4322682897,
		"y": 19.100204741,
		"h": 5.0549450549
	},
	{
		"stop_id": 8595138,
		"ID": 451,
		"x": -56.9722960547,
		"y": 19.110178016,
		"h": 5.0549450549
	},
	{
		"stop_id": 8595488,
		"ID": 451,
		"x": -54.6502593147,
		"y": 15.568222275,
		"h": 5.0549450549
	},
	{
		"stop_id": 8595543,
		"ID": 451,
		"x": -57.7922255567,
		"y": 19.285180446,
		"h": 5.0549450549
	},
	{
		"stop_id": 8595603,
		"ID": 451,
		"x": -54.8522424567,
		"y": 14.855231226,
		"h": 5.0549450549
	},
	{
		"stop_id": 8507005,
		"ID": 482,
		"x": -51.6092793297,
		"y": 11.664143064,
		"h": 2.0549450549
	},
	{
		"stop_id": 8507054,
		"ID": 482,
		"x": -52.7072494517,
		"y": 15.070238475,
		"h": 2.0549450549
	},
	{
		"stop_id": 8507055,
		"ID": 482,
		"x": -51.7002458097,
		"y": 14.792237568,
		"h": 2.0549450549
	},
	{
		"stop_id": 8507063,
		"ID": 482,
		"x": -50.3112568747,
		"y": 15.092189831,
		"h": 2.0549450549
	},
	{
		"stop_id": 8507250,
		"ID": 482,
		"x": -53.0732274327,
		"y": 15.182216219,
		"h": 2.0549450549
	},
	{
		"stop_id": 8508094,
		"ID": 482,
		"x": -53.5402250777,
		"y": 13.566191904,
		"h": 2.0549450549
	},
	{
		"stop_id": 8508200,
		"ID": 482,
		"x": -50.1282977927,
		"y": 13.451160314,
		"h": 2.0549450549
	},
	{
		"stop_id": 8508779,
		"ID": 482,
		"x": -48.7332631617,
		"y": 13.822192631,
		"h": 2.0549450549
	},
	{
		"stop_id": 8571723,
		"ID": 482,
		"x": -50.2792383947,
		"y": 15.071228881,
		"h": 2.0549450549
	},
	{
		"stop_id": 8571724,
		"ID": 482,
		"x": -49.7222790997,
		"y": 14.871245755,
		"h": 2.0549450549
	},
	{
		"stop_id": 8571725,
		"ID": 482,
		"x": -49.5672499697,
		"y": 15.069167166,
		"h": 2.0549450549
	},
	{
		"stop_id": 8571742,
		"ID": 482,
		"x": -49.1612397637,
		"y": 14.884213201,
		"h": 2.0549450549
	},
	{
		"stop_id": 8571753,
		"ID": 482,
		"x": -49.6422727277,
		"y": 14.530197503,
		"h": 2.0549450549
	},
	{
		"stop_id": 8575994,
		"ID": 482,
		"x": -49.7452248027,
		"y": 14.930239091,
		"h": 2.0549450549
	},
	{
		"stop_id": 8576100,
		"ID": 482,
		"x": -50.1662737817,
		"y": 13.476224234,
		"h": 2.0549450549
	},
	{
		"stop_id": 8577023,
		"ID": 482,
		"x": -53.9952319107,
		"y": 13.979184141,
		"h": 2.0549450549
	},
	{
		"stop_id": 8577024,
		"ID": 482,
		"x": -53.2442662327,
		"y": 13.408196703,
		"h": 2.0549450549
	},
	{
		"stop_id": 8577026,
		"ID": 482,
		"x": -51.6152803567,
		"y": 11.650238735,
		"h": 2.0549450549
	},
	{
		"stop_id": 8579895,
		"ID": 482,
		"x": -49.2942452797,
		"y": 14.552247971,
		"h": 2.0549450549
	},
	{
		"stop_id": 8580415,
		"ID": 482,
		"x": -49.0782996927,
		"y": 14.324171897,
		"h": 2.0549450549
	},
	{
		"stop_id": 8581765,
		"ID": 482,
		"x": -50.6052307207,
		"y": 12.942147431,
		"h": 2.0549450549
	},
	{
		"stop_id": 8581791,
		"ID": 482,
		"x": -51.2752813227,
		"y": 11.816238796,
		"h": 2.0549450549
	},
	{
		"stop_id": 8581792,
		"ID": 482,
		"x": -51.3442767707,
		"y": 13.482247828,
		"h": 2.0549450549
	},
	{
		"stop_id": 8581798,
		"ID": 482,
		"x": -51.9642945517,
		"y": 14.145213131,
		"h": 2.0549450549
	},
	{
		"stop_id": 8581839,
		"ID": 482,
		"x": -52.6982839337,
		"y": 15.088147374,
		"h": 2.0549450549
	},
	{
		"stop_id": 8581859,
		"ID": 482,
		"x": -52.3522915777,
		"y": 15.075220932,
		"h": 2.0549450549
	},
	{
		"stop_id": 8581860,
		"ID": 482,
		"x": -52.1032316797,
		"y": 15.172249649,
		"h": 2.0549450549
	},
	{
		"stop_id": 8581904,
		"ID": 482,
		"x": -50.1742447177,
		"y": 14.752224547,
		"h": 2.0549450549
	},
	{
		"stop_id": 8582589,
		"ID": 482,
		"x": -51.7412938037,
		"y": 13.930168228,
		"h": 2.0549450549
	},
	{
		"stop_id": 8588259,
		"ID": 482,
		"x": -51.6562695907,
		"y": 11.13424437,
		"h": 2.0549450549
	},
	{
		"stop_id": 8588905,
		"ID": 482,
		"x": -51.3602318137,
		"y": 10.987237611,
		"h": 2.0549450549
	},
	{
		"stop_id": 8589198,
		"ID": 482,
		"x": -50.5362824437,
		"y": 15.53018671,
		"h": 2.0549450549
	},
	{
		"stop_id": 8590402,
		"ID": 482,
		"x": -51.7332752917,
		"y": 11.621176647,
		"h": 2.0549450549
	},
	{
		"stop_id": 8507006,
		"ID": 481,
		"x": -50.5332977537,
		"y": 8.795179108,
		"h": 2.4505494505
	},
	{
		"stop_id": 8507007,
		"ID": 481,
		"x": -49.8092602637,
		"y": 5.268151894,
		"h": 2.4505494505
	},
	{
		"stop_id": 8571620,
		"ID": 481,
		"x": -50.5112999437,
		"y": 8.718172336,
		"h": 2.4505494505
	},
	{
		"stop_id": 8571621,
		"ID": 481,
		"x": -50.3012294377,
		"y": 8.354195665,
		"h": 2.4505494505
	},
	{
		"stop_id": 8571622,
		"ID": 481,
		"x": -49.9942989947,
		"y": 7.471221755,
		"h": 2.4505494505
	},
	{
		"stop_id": 8571623,
		"ID": 481,
		"x": -49.3132411227,
		"y": 6.259173101,
		"h": 2.4505494505
	},
	{
		"stop_id": 8571625,
		"ID": 481,
		"x": -49.7972477947,
		"y": 5.246160255,
		"h": 2.4505494505
	},
	{
		"stop_id": 8571628,
		"ID": 481,
		"x": -51.4652269377,
		"y": 5.084223167,
		"h": 2.4505494505
	},
	{
		"stop_id": 8574521,
		"ID": 481,
		"x": -50.1512808727,
		"y": 8.031151976,
		"h": 2.4505494505
	},
	{
		"stop_id": 8578929,
		"ID": 481,
		"x": -50.2342276777,
		"y": 8.943165664,
		"h": 2.4505494505
	},
	{
		"stop_id": 8578930,
		"ID": 481,
		"x": -49.9702359637,
		"y": 8.948146202,
		"h": 2.4505494505
	},
	{
		"stop_id": 8578932,
		"ID": 481,
		"x": -49.8222567817,
		"y": 8.619215325,
		"h": 2.4505494505
	},
	{
		"stop_id": 8578935,
		"ID": 481,
		"x": -49.6352727457,
		"y": 8.591178095,
		"h": 2.4505494505
	},
	{
		"stop_id": 8578944,
		"ID": 481,
		"x": -49.5592399797,
		"y": 8.803195258,
		"h": 2.4505494505
	},
	{
		"stop_id": 8578945,
		"ID": 481,
		"x": -49.9132959257,
		"y": 8.999154516,
		"h": 2.4505494505
	},
	{
		"stop_id": 8578952,
		"ID": 481,
		"x": -50.0182329267,
		"y": 9.165182584,
		"h": 2.4505494505
	},
	{
		"stop_id": 8578954,
		"ID": 481,
		"x": -50.9502787727,
		"y": 9.505151778,
		"h": 2.4505494505
	},
	{
		"stop_id": 8578955,
		"ID": 481,
		"x": -51.4792935677,
		"y": 9.281174923,
		"h": 2.4505494505
	},
	{
		"stop_id": 8578963,
		"ID": 481,
		"x": -51.3002321147,
		"y": 8.902223853,
		"h": 2.4505494505
	},
	{
		"stop_id": 8578965,
		"ID": 481,
		"x": -51.2962374577,
		"y": 8.717243481,
		"h": 2.4505494505
	},
	{
		"stop_id": 8578967,
		"ID": 481,
		"x": -51.2912583127,
		"y": 8.537155991,
		"h": 2.4505494505
	},
	{
		"stop_id": 8578968,
		"ID": 481,
		"x": -51.1442511957,
		"y": 8.31124531,
		"h": 2.4505494505
	},
	{
		"stop_id": 8578970,
		"ID": 481,
		"x": -50.9852775037,
		"y": 8.148166356,
		"h": 2.4505494505
	},
	{
		"stop_id": 8578973,
		"ID": 481,
		"x": -50.8392695867,
		"y": 8.303239204,
		"h": 2.4505494505
	},
	{
		"stop_id": 8578980,
		"ID": 481,
		"x": -50.6862680517,
		"y": 8.416192962,
		"h": 2.4505494505
	},
	{
		"stop_id": 8579011,
		"ID": 481,
		"x": -51.1382734937,
		"y": 8.877217372,
		"h": 2.4505494505
	},
	{
		"stop_id": 8579014,
		"ID": 481,
		"x": -50.7992797727,
		"y": 8.842247807,
		"h": 2.4505494505
	},
	{
		"stop_id": 8579020,
		"ID": 481,
		"x": -51.4772801987,
		"y": 8.090219594,
		"h": 2.4505494505
	},
	{
		"stop_id": 8579021,
		"ID": 481,
		"x": -50.2762746127,
		"y": 9.018250018,
		"h": 2.4505494505
	},
	{
		"stop_id": 8579026,
		"ID": 481,
		"x": -50.3372793737,
		"y": 9.17623751,
		"h": 2.4505494505
	},
	{
		"stop_id": 8579068,
		"ID": 481,
		"x": -50.3342580967,
		"y": 9.438157697,
		"h": 2.4505494505
	},
	{
		"stop_id": 8579069,
		"ID": 481,
		"x": -50.1052440587,
		"y": 9.613167253,
		"h": 2.4505494505
	},
	{
		"stop_id": 8579070,
		"ID": 481,
		"x": -49.9572640397,
		"y": 9.69122465,
		"h": 2.4505494505
	},
	{
		"stop_id": 8579074,
		"ID": 481,
		"x": -49.8512614417,
		"y": 9.707183955,
		"h": 2.4505494505
	},
	{
		"stop_id": 8579084,
		"ID": 481,
		"x": -49.9132851197,
		"y": 9.506198886,
		"h": 2.4505494505
	},
	{
		"stop_id": 8579087,
		"ID": 481,
		"x": -50.0042459047,
		"y": 9.378206061,
		"h": 2.4505494505
	},
	{
		"stop_id": 8580640,
		"ID": 481,
		"x": -51.3392780987,
		"y": 9.076149537,
		"h": 2.4505494505
	},
	{
		"stop_id": 8581760,
		"ID": 481,
		"x": -50.4872815287,
		"y": 8.120228906,
		"h": 2.4505494505
	},
	{
		"stop_id": 8581897,
		"ID": 481,
		"x": -50.6922785457,
		"y": 8.103242114,
		"h": 2.4505494505
	},
	{
		"stop_id": 8582062,
		"ID": 481,
		"x": -51.0942464597,
		"y": 9.434239622,
		"h": 2.4505494505
	},
	{
		"stop_id": 8588258,
		"ID": 481,
		"x": -50.7882513827,
		"y": 10.19319684,
		"h": 2.4505494505
	},
	{
		"stop_id": 8588260,
		"ID": 481,
		"x": -52.2662826077,
		"y": 10.565157604,
		"h": 2.4505494505
	},
	{
		"stop_id": 8588261,
		"ID": 481,
		"x": -53.0442795627,
		"y": 10.366251113,
		"h": 2.4505494505
	},
	{
		"stop_id": 8589514,
		"ID": 481,
		"x": -50.5902675267,
		"y": 9.662214664,
		"h": 2.4505494505
	},
	{
		"stop_id": 8594470,
		"ID": 481,
		"x": -51.8942495907,
		"y": 10.773184021,
		"h": 2.4505494505
	},
	{
		"stop_id": 8507008,
		"ID": 480,
		"x": -49.2982330867,
		"y": 2.749152802,
		"h": 1.4615384615
	},
	{
		"stop_id": 8507073,
		"ID": 480,
		"x": -54.0002422797,
		"y": 2.144207187,
		"h": 1.4615384615
	},
	{
		"stop_id": 8507713,
		"ID": 480,
		"x": -50.4992840987,
		"y": 4.461190676,
		"h": 1.4615384615
	},
	{
		"stop_id": 8507714,
		"ID": 480,
		"x": -51.3212742187,
		"y": 2.948203559,
		"h": 1.4615384615
	},
	{
		"stop_id": 8507715,
		"ID": 480,
		"x": -52.1002277757,
		"y": 3.831180408,
		"h": 1.4615384615
	},
	{
		"stop_id": 8507737,
		"ID": 480,
		"x": -54.4402777657,
		"y": 2.108232521,
		"h": 1.4615384615
	},
	{
		"stop_id": 8507789,
		"ID": 480,
		"x": -51.7032860007,
		"y": 4.953166714,
		"h": 1.4615384615
	},
	{
		"stop_id": 8571626,
		"ID": 480,
		"x": -50.0462867617,
		"y": 4.854217341,
		"h": 1.4615384615
	},
	{
		"stop_id": 8571627,
		"ID": 480,
		"x": -50.9862807627,
		"y": 5.058218845,
		"h": 1.4615384615
	},
	{
		"stop_id": 8571629,
		"ID": 480,
		"x": -52.2712623497,
		"y": 4.301210194,
		"h": 1.4615384615
	},
	{
		"stop_id": 8571704,
		"ID": 480,
		"x": -54.5772934327,
		"y": 2.39915334,
		"h": 1.4615384615
	},
	{
		"stop_id": 8571705,
		"ID": 480,
		"x": -54.0172911507,
		"y": 2.175207053,
		"h": 1.4615384615
	},
	{
		"stop_id": 8580568,
		"ID": 480,
		"x": -51.5602427727,
		"y": 2.977223381,
		"h": 1.4615384615
	},
	{
		"stop_id": 8581910,
		"ID": 480,
		"x": -52.2962751127,
		"y": 4.106189305,
		"h": 1.4615384615
	},
	{
		"stop_id": 8593308,
		"ID": 480,
		"x": -54.2372849797,
		"y": 1.376147214,
		"h": 1.4615384615
	},
	{
		"stop_id": 8507009,
		"ID": 512,
		"x": -48.7492754427,
		"y": 0.011160673,
		"h": 2.7802197802
	},
	{
		"stop_id": 8507094,
		"ID": 512,
		"x": -47.8082774687,
		"y": -2.341813056,
		"h": 2.7802197802
	},
	{
		"stop_id": 8507401,
		"ID": 512,
		"x": -45.0682863317,
		"y": -0.95882893,
		"h": 2.7802197802
	},
	{
		"stop_id": 8507411,
		"ID": 512,
		"x": -44.7392396287,
		"y": -0.318799198,
		"h": 2.7802197802
	},
	{
		"stop_id": 8507888,
		"ID": 512,
		"x": -48.0212670097,
		"y": -3.456801175,
		"h": 2.7802197802
	},
	{
		"stop_id": 8508250,
		"ID": 512,
		"x": -45.9462611787,
		"y": -3.501764584,
		"h": 2.7802197802
	},
	{
		"stop_id": 8508251,
		"ID": 512,
		"x": -46.2702752527,
		"y": -2.361803127,
		"h": 2.7802197802
	},
	{
		"stop_id": 8508252,
		"ID": 512,
		"x": -46.7302473987,
		"y": -1.398764659,
		"h": 2.7802197802
	},
	{
		"stop_id": 8508253,
		"ID": 512,
		"x": -46.9612364027,
		"y": -0.36483885,
		"h": 2.7802197802
	},
	{
		"stop_id": 8571711,
		"ID": 512,
		"x": -44.5102490127,
		"y": -2.161838929,
		"h": 2.7802197802
	},
	{
		"stop_id": 8571712,
		"ID": 512,
		"x": -44.2852485377,
		"y": -2.635842027,
		"h": 2.7802197802
	},
	{
		"stop_id": 8576555,
		"ID": 512,
		"x": -44.8592974897,
		"y": -3.393788043,
		"h": 2.7802197802
	},
	{
		"stop_id": 8576573,
		"ID": 512,
		"x": -43.9992710697,
		"y": 0.135214368,
		"h": 2.7802197802
	},
	{
		"stop_id": 8576574,
		"ID": 512,
		"x": -44.6382311847,
		"y": 0.474195951,
		"h": 2.7802197802
	},
	{
		"stop_id": 8576575,
		"ID": 512,
		"x": -44.4492863947,
		"y": 0.055234688,
		"h": 2.7802197802
	},
	{
		"stop_id": 8576577,
		"ID": 512,
		"x": -45.0252933587,
		"y": -0.70981801,
		"h": 2.7802197802
	},
	{
		"stop_id": 8576579,
		"ID": 512,
		"x": -44.8302479307,
		"y": -1.552771662,
		"h": 2.7802197802
	},
	{
		"stop_id": 8576580,
		"ID": 512,
		"x": -44.7502978967,
		"y": -1.79480858,
		"h": 2.7802197802
	},
	{
		"stop_id": 8576581,
		"ID": 512,
		"x": -44.8672474617,
		"y": -2.093807818,
		"h": 2.7802197802
	},
	{
		"stop_id": 8576582,
		"ID": 512,
		"x": -45.0382536787,
		"y": -2.53078546,
		"h": 2.7802197802
	},
	{
		"stop_id": 8576583,
		"ID": 512,
		"x": -45.0752710077,
		"y": -2.79278786,
		"h": 2.7802197802
	},
	{
		"stop_id": 8576584,
		"ID": 512,
		"x": -45.0472249337,
		"y": -3.204819484,
		"h": 2.7802197802
	},
	{
		"stop_id": 8576607,
		"ID": 512,
		"x": -43.6112242857,
		"y": -0.993784488,
		"h": 2.7802197802
	},
	{
		"stop_id": 8576608,
		"ID": 512,
		"x": -44.2482989747,
		"y": -1.293835246,
		"h": 2.7802197802
	},
	{
		"stop_id": 8576815,
		"ID": 512,
		"x": -47.5742785007,
		"y": -3.539846908,
		"h": 2.7802197802
	},
	{
		"stop_id": 8581789,
		"ID": 512,
		"x": -48.7352643187,
		"y": -2.351803961,
		"h": 2.7802197802
	},
	{
		"stop_id": 8581790,
		"ID": 512,
		"x": -47.8402464617,
		"y": -2.24282557,
		"h": 2.7802197802
	},
	{
		"stop_id": 8581793,
		"ID": 512,
		"x": -47.5222903567,
		"y": -2.128797562,
		"h": 2.7802197802
	},
	{
		"stop_id": 8581794,
		"ID": 512,
		"x": -47.8362867807,
		"y": -1.69575961,
		"h": 2.7802197802
	},
	{
		"stop_id": 8581795,
		"ID": 512,
		"x": -48.2092450007,
		"y": -1.59376577,
		"h": 2.7802197802
	},
	{
		"stop_id": 8582188,
		"ID": 512,
		"x": -48.0192430117,
		"y": -1.905781437,
		"h": 2.7802197802
	},
	{
		"stop_id": 8582190,
		"ID": 512,
		"x": -44.6952880557,
		"y": -2.261800052,
		"h": 2.7802197802
	},
	{
		"stop_id": 8588426,
		"ID": 512,
		"x": -44.7812659197,
		"y": -1.349767966,
		"h": 2.7802197802
	},
	{
		"stop_id": 8588565,
		"ID": 512,
		"x": -46.8422513847,
		"y": -0.519776024,
		"h": 2.7802197802
	},
	{
		"stop_id": 8588578,
		"ID": 512,
		"x": -45.7862960547,
		"y": -3.401789396,
		"h": 2.7802197802
	},
	{
		"stop_id": 8588579,
		"ID": 512,
		"x": -45.7132254897,
		"y": -3.123810707,
		"h": 2.7802197802
	},
	{
		"stop_id": 8588580,
		"ID": 512,
		"x": -46.1202541747,
		"y": -2.198826601,
		"h": 2.7802197802
	},
	{
		"stop_id": 8588581,
		"ID": 512,
		"x": -46.1952864087,
		"y": -1.913849645,
		"h": 2.7802197802
	},
	{
		"stop_id": 8589067,
		"ID": 512,
		"x": -46.1152421727,
		"y": -2.354784119,
		"h": 2.7802197802
	},
	{
		"stop_id": 8589068,
		"ID": 512,
		"x": -45.9062716617,
		"y": -2.752845046,
		"h": 2.7802197802
	},
	{
		"stop_id": 8591914,
		"ID": 512,
		"x": -47.3102963407,
		"y": -3.041831425,
		"h": 2.7802197802
	},
	{
		"stop_id": 8591915,
		"ID": 512,
		"x": -47.5712419937,
		"y": -3.227792416,
		"h": 2.7802197802
	},
	{
		"stop_id": 8591916,
		"ID": 512,
		"x": -47.3562875947,
		"y": -3.261816385,
		"h": 2.7802197802
	},
	{
		"stop_id": 8594536,
		"ID": 512,
		"x": -47.7512976667,
		"y": -3.570772958,
		"h": 2.7802197802
	},
	{
		"stop_id": 8594983,
		"ID": 512,
		"x": -46.7222787537,
		"y": -1.163849004,
		"h": 2.7802197802
	},
	{
		"stop_id": 8594985,
		"ID": 512,
		"x": -47.1602967247,
		"y": 0.844142714,
		"h": 2.7802197802
	},
	{
		"stop_id": 8595557,
		"ID": 512,
		"x": -47.0932273207,
		"y": -0.957755674,
		"h": 2.7802197802
	},
	{
		"stop_id": 8595558,
		"ID": 512,
		"x": -46.9572429547,
		"y": -0.303798963,
		"h": 2.7802197802
	},
	{
		"stop_id": 8595559,
		"ID": 512,
		"x": -47.0532332807,
		"y": 0.319207775,
		"h": 2.7802197802
	},
	{
		"stop_id": 8595560,
		"ID": 512,
		"x": -47.0752431457,
		"y": 0.620205496,
		"h": 2.7802197802
	},
	{
		"stop_id": 8595561,
		"ID": 512,
		"x": -46.8102750467,
		"y": -1.40082694,
		"h": 2.7802197802
	},
	{
		"stop_id": 8595562,
		"ID": 512,
		"x": -47.1662309047,
		"y": -0.517793447,
		"h": 2.7802197802
	},
	{
		"stop_id": 8595563,
		"ID": 512,
		"x": -47.0092989587,
		"y": -0.022764558,
		"h": 2.7802197802
	},
	{
		"stop_id": 8595564,
		"ID": 512,
		"x": -47.2902598067,
		"y": -0.245800053,
		"h": 2.7802197802
	},
	{
		"stop_id": 8595565,
		"ID": 512,
		"x": -46.4482247107,
		"y": -1.606811204,
		"h": 2.7802197802
	},
	{
		"stop_id": 8507064,
		"ID": 483,
		"x": -50.7722658777,
		"y": 16.956150033,
		"h": 1.5274725275
	},
	{
		"stop_id": 8507065,
		"ID": 483,
		"x": -51.4712911867,
		"y": 17.717225068,
		"h": 1.5274725275
	},
	{
		"stop_id": 8507066,
		"ID": 483,
		"x": -53.2372573867,
		"y": 18.072141339,
		"h": 1.5274725275
	},
	{
		"stop_id": 8571732,
		"ID": 483,
		"x": -50.3832535067,
		"y": 18.683227496,
		"h": 1.5274725275
	},
	{
		"stop_id": 8571733,
		"ID": 483,
		"x": -51.4942341567,
		"y": 17.739205435,
		"h": 1.5274725275
	},
	{
		"stop_id": 8571734,
		"ID": 483,
		"x": -50.7452500907,
		"y": 17.778187731,
		"h": 1.5274725275
	},
	{
		"stop_id": 8571735,
		"ID": 483,
		"x": -50.5112249917,
		"y": 17.810225994,
		"h": 1.5274725275
	},
	{
		"stop_id": 8571736,
		"ID": 483,
		"x": -50.1662816107,
		"y": 18.121154701,
		"h": 1.5274725275
	},
	{
		"stop_id": 8571737,
		"ID": 483,
		"x": -50.1932961297,
		"y": 18.452179103,
		"h": 1.5274725275
	},
	{
		"stop_id": 8582743,
		"ID": 483,
		"x": -51.8972451997,
		"y": 18.339212453,
		"h": 1.5274725275
	},
	{
		"stop_id": 8582744,
		"ID": 483,
		"x": -52.1632899057,
		"y": 18.298183283,
		"h": 1.5274725275
	},
	{
		"stop_id": 8582746,
		"ID": 483,
		"x": -51.5532277397,
		"y": 18.186143291,
		"h": 1.5274725275
	},
	{
		"stop_id": 8582747,
		"ID": 483,
		"x": -51.8822915307,
		"y": 18.137234264,
		"h": 1.5274725275
	},
	{
		"stop_id": 8582748,
		"ID": 483,
		"x": -51.5982542637,
		"y": 18.27324028,
		"h": 1.5274725275
	},
	{
		"stop_id": 8582749,
		"ID": 483,
		"x": -51.7292779847,
		"y": 18.009144608,
		"h": 1.5274725275
	},
	{
		"stop_id": 8589026,
		"ID": 483,
		"x": -53.9302428857,
		"y": 18.239191555,
		"h": 1.5274725275
	},
	{
		"stop_id": 8589043,
		"ID": 483,
		"x": -53.2222445057,
		"y": 18.26715138,
		"h": 1.5274725275
	},
	{
		"stop_id": 8507070,
		"ID": 479,
		"x": -49.4922981967,
		"y": -2.144809669,
		"h": 2.4505494505
	},
	{
		"stop_id": 8507071,
		"ID": 479,
		"x": -51.9802582837,
		"y": -0.82284293,
		"h": 2.4505494505
	},
	{
		"stop_id": 8507872,
		"ID": 479,
		"x": -54.1752730527,
		"y": -4.399750672,
		"h": 2.4505494505
	},
	{
		"stop_id": 8507873,
		"ID": 479,
		"x": -54.4592584727,
		"y": -3.181828857,
		"h": 2.4505494505
	},
	{
		"stop_id": 8507887,
		"ID": 479,
		"x": -48.9282454387,
		"y": -4.496803809,
		"h": 2.4505494505
	},
	{
		"stop_id": 8507889,
		"ID": 479,
		"x": -50.1182787237,
		"y": -4.77684995,
		"h": 2.4505494505
	},
	{
		"stop_id": 8507898,
		"ID": 479,
		"x": -48.3652887677,
		"y": -3.40276579,
		"h": 2.4505494505
	},
	{
		"stop_id": 8507899,
		"ID": 479,
		"x": -48.4822296877,
		"y": -3.860774625,
		"h": 2.4505494505
	},
	{
		"stop_id": 8507900,
		"ID": 479,
		"x": -54.3932653177,
		"y": -3.5208327,
		"h": 2.4505494505
	},
	{
		"stop_id": 8507901,
		"ID": 479,
		"x": -54.0992926177,
		"y": -2.629779039,
		"h": 2.4505494505
	},
	{
		"stop_id": 8576789,
		"ID": 479,
		"x": -53.5202682067,
		"y": -5.50578724,
		"h": 2.4505494505
	},
	{
		"stop_id": 8576790,
		"ID": 479,
		"x": -54.2062712497,
		"y": -4.088843125,
		"h": 2.4505494505
	},
	{
		"stop_id": 8576795,
		"ID": 479,
		"x": -53.3492660647,
		"y": -3.456789807,
		"h": 2.4505494505
	},
	{
		"stop_id": 8576796,
		"ID": 479,
		"x": -53.0122850797,
		"y": -3.812828462,
		"h": 2.4505494505
	},
	{
		"stop_id": 8576797,
		"ID": 479,
		"x": -52.8482990057,
		"y": -4.248754804,
		"h": 2.4505494505
	},
	{
		"stop_id": 8576798,
		"ID": 479,
		"x": -52.3462654317,
		"y": -4.429810002,
		"h": 2.4505494505
	},
	{
		"stop_id": 8576799,
		"ID": 479,
		"x": -51.6052585217,
		"y": -4.169837486,
		"h": 2.4505494505
	},
	{
		"stop_id": 8576800,
		"ID": 479,
		"x": -51.1192757877,
		"y": -4.431852741,
		"h": 2.4505494505
	},
	{
		"stop_id": 8576802,
		"ID": 479,
		"x": -53.1222308937,
		"y": -5.550832968,
		"h": 2.4505494505
	},
	{
		"stop_id": 8576803,
		"ID": 479,
		"x": -52.5942380017,
		"y": -5.30277373,
		"h": 2.4505494505
	},
	{
		"stop_id": 8576804,
		"ID": 479,
		"x": -52.3122941727,
		"y": -5.15280256,
		"h": 2.4505494505
	},
	{
		"stop_id": 8576805,
		"ID": 479,
		"x": -51.7492559987,
		"y": -5.513823886,
		"h": 2.4505494505
	},
	{
		"stop_id": 8576806,
		"ID": 479,
		"x": -51.2902376857,
		"y": -5.820800054,
		"h": 2.4505494505
	},
	{
		"stop_id": 8576807,
		"ID": 479,
		"x": -50.9952776267,
		"y": -6.115752362,
		"h": 2.4505494505
	},
	{
		"stop_id": 8576808,
		"ID": 479,
		"x": -50.8382721087,
		"y": -6.236806743,
		"h": 2.4505494505
	},
	{
		"stop_id": 8576809,
		"ID": 479,
		"x": -50.4522454357,
		"y": -6.030787774,
		"h": 2.4505494505
	},
	{
		"stop_id": 8576810,
		"ID": 479,
		"x": -50.3672591887,
		"y": -5.63779031,
		"h": 2.4505494505
	},
	{
		"stop_id": 8576811,
		"ID": 479,
		"x": -49.5922412027,
		"y": -4.706841806,
		"h": 2.4505494505
	},
	{
		"stop_id": 8576812,
		"ID": 479,
		"x": -49.3552480757,
		"y": -4.469762351,
		"h": 2.4505494505
	},
	{
		"stop_id": 8576813,
		"ID": 479,
		"x": -48.6222316797,
		"y": -4.459784229,
		"h": 2.4505494505
	},
	{
		"stop_id": 8576814,
		"ID": 479,
		"x": -48.5332382597,
		"y": -4.07975912,
		"h": 2.4505494505
	},
	{
		"stop_id": 8576890,
		"ID": 479,
		"x": -51.7532739087,
		"y": -5.017799468,
		"h": 2.4505494505
	},
	{
		"stop_id": 8581784,
		"ID": 479,
		"x": -50.6032998457,
		"y": -3.077848595,
		"h": 2.4505494505
	},
	{
		"stop_id": 8581785,
		"ID": 479,
		"x": -49.8832870477,
		"y": -3.253805694,
		"h": 2.4505494505
	},
	{
		"stop_id": 8581787,
		"ID": 479,
		"x": -49.0782597397,
		"y": -2.449803621,
		"h": 2.4505494505
	},
	{
		"stop_id": 8581788,
		"ID": 479,
		"x": -48.9182416237,
		"y": -2.578806813,
		"h": 2.4505494505
	},
	{
		"stop_id": 8581799,
		"ID": 479,
		"x": -52.7462403177,
		"y": -1.592838289,
		"h": 2.4505494505
	},
	{
		"stop_id": 8581800,
		"ID": 479,
		"x": -52.5562768547,
		"y": -1.621852787,
		"h": 2.4505494505
	},
	{
		"stop_id": 8581801,
		"ID": 479,
		"x": -51.7482940557,
		"y": -1.908763396,
		"h": 2.4505494505
	},
	{
		"stop_id": 8581802,
		"ID": 479,
		"x": -49.4982266047,
		"y": -2.161828447,
		"h": 2.4505494505
	},
	{
		"stop_id": 8581803,
		"ID": 479,
		"x": -50.9582792777,
		"y": -2.233832933,
		"h": 2.4505494505
	},
	{
		"stop_id": 8582186,
		"ID": 479,
		"x": -50.1842969777,
		"y": -2.171848004,
		"h": 2.4505494505
	},
	{
		"stop_id": 8582187,
		"ID": 479,
		"x": -50.1052645457,
		"y": -2.543801454,
		"h": 2.4505494505
	},
	{
		"stop_id": 8582211,
		"ID": 479,
		"x": -48.7042653987,
		"y": -2.804756789,
		"h": 2.4505494505
	},
	{
		"stop_id": 8587421,
		"ID": 479,
		"x": -51.9892801727,
		"y": -0.813849895,
		"h": 2.4505494505
	},
	{
		"stop_id": 8507072,
		"ID": 448,
		"x": -53.4362620087,
		"y": -0.536833067,
		"h": 1.5934065934
	},
	{
		"stop_id": 8507729,
		"ID": 448,
		"x": -56.1632629197,
		"y": 1.766243611,
		"h": 1.5934065934
	},
	{
		"stop_id": 8507745,
		"ID": 448,
		"x": -54.5502707097,
		"y": -2.249765188,
		"h": 1.5934065934
	},
	{
		"stop_id": 8507748,
		"ID": 448,
		"x": -55.0832657727,
		"y": -0.308759449,
		"h": 1.5934065934
	},
	{
		"stop_id": 8507749,
		"ID": 448,
		"x": -58.8412406257,
		"y": -1.458824831,
		"h": 1.5934065934
	},
	{
		"stop_id": 8507765,
		"ID": 448,
		"x": -56.8212351297,
		"y": 1.698192677,
		"h": 1.5934065934
	},
	{
		"stop_id": 8571651,
		"ID": 448,
		"x": -56.2102574437,
		"y": 0.011203117,
		"h": 1.5934065934
	},
	{
		"stop_id": 8571652,
		"ID": 448,
		"x": -54.9412341557,
		"y": -1.102833558,
		"h": 1.5934065934
	},
	{
		"stop_id": 8571653,
		"ID": 448,
		"x": -54.6582392097,
		"y": -1.462787641,
		"h": 1.5934065934
	},
	{
		"stop_id": 8571654,
		"ID": 448,
		"x": -54.5432896337,
		"y": -2.731782996,
		"h": 1.5934065934
	},
	{
		"stop_id": 8571655,
		"ID": 448,
		"x": -55.5902271427,
		"y": -3.136793797,
		"h": 1.5934065934
	},
	{
		"stop_id": 8571656,
		"ID": 448,
		"x": -55.7212644327,
		"y": -2.741791353,
		"h": 1.5934065934
	},
	{
		"stop_id": 8571657,
		"ID": 448,
		"x": -55.9932303607,
		"y": -2.79877125,
		"h": 1.5934065934
	},
	{
		"stop_id": 8571658,
		"ID": 448,
		"x": -56.7372700307,
		"y": -0.494781971,
		"h": 1.5934065934
	},
	{
		"stop_id": 8571659,
		"ID": 448,
		"x": -57.1912739507,
		"y": -0.680748988,
		"h": 1.5934065934
	},
	{
		"stop_id": 8571660,
		"ID": 448,
		"x": -58.3652962787,
		"y": -1.226843686,
		"h": 1.5934065934
	},
	{
		"stop_id": 8576791,
		"ID": 448,
		"x": -54.3422828507,
		"y": -2.693810484,
		"h": 1.5934065934
	},
	{
		"stop_id": 8576792,
		"ID": 448,
		"x": -53.5272442587,
		"y": -1.387807383,
		"h": 1.5934065934
	},
	{
		"stop_id": 8576793,
		"ID": 448,
		"x": -53.5042801267,
		"y": -0.550799522,
		"h": 1.5934065934
	},
	{
		"stop_id": 8507074,
		"ID": 449,
		"x": -54.9192343117,
		"y": 4.84825051,
		"h": 1.8571428571
	},
	{
		"stop_id": 8507075,
		"ID": 449,
		"x": -55.3652505097,
		"y": 7.136214688,
		"h": 1.8571428571
	},
	{
		"stop_id": 8507712,
		"ID": 449,
		"x": -56.8332241207,
		"y": 2.193219783,
		"h": 1.8571428571
	},
	{
		"stop_id": 8507734,
		"ID": 449,
		"x": -54.7832900497,
		"y": 2.978169465,
		"h": 1.8571428571
	},
	{
		"stop_id": 8507738,
		"ID": 449,
		"x": -57.6032364107,
		"y": 4.891188334,
		"h": 1.8571428571
	},
	{
		"stop_id": 8507739,
		"ID": 449,
		"x": -55.0432718257,
		"y": 2.376207679,
		"h": 1.8571428571
	},
	{
		"stop_id": 8507983,
		"ID": 449,
		"x": -57.6272969477,
		"y": 7.213165811,
		"h": 1.8571428571
	},
	{
		"stop_id": 8507986,
		"ID": 449,
		"x": -53.7502886537,
		"y": 5.226155624,
		"h": 1.8571428571
	},
	{
		"stop_id": 8571401,
		"ID": 449,
		"x": -57.0822800567,
		"y": 5.244240835,
		"h": 1.8571428571
	},
	{
		"stop_id": 8571402,
		"ID": 449,
		"x": -58.4972756357,
		"y": 3.562146966,
		"h": 1.8571428571
	},
	{
		"stop_id": 8571404,
		"ID": 449,
		"x": -58.4342258197,
		"y": 3.078242931,
		"h": 1.8571428571
	},
	{
		"stop_id": 8571405,
		"ID": 449,
		"x": -57.7202834047,
		"y": 2.859208693,
		"h": 1.8571428571
	},
	{
		"stop_id": 8571407,
		"ID": 449,
		"x": -56.8712285487,
		"y": 2.839201791,
		"h": 1.8571428571
	},
	{
		"stop_id": 8571409,
		"ID": 449,
		"x": -55.4872299587,
		"y": 2.290169986,
		"h": 1.8571428571
	},
	{
		"stop_id": 8571422,
		"ID": 449,
		"x": -57.7142389087,
		"y": 7.476162904,
		"h": 1.8571428571
	},
	{
		"stop_id": 8571425,
		"ID": 449,
		"x": -56.8232904327,
		"y": 5.695148256,
		"h": 1.8571428571
	},
	{
		"stop_id": 8571429,
		"ID": 449,
		"x": -55.8352328037,
		"y": 6.198183845,
		"h": 1.8571428571
	},
	{
		"stop_id": 8571430,
		"ID": 449,
		"x": -55.6352578527,
		"y": 5.072174451,
		"h": 1.8571428571
	},
	{
		"stop_id": 8571431,
		"ID": 449,
		"x": -55.4482413677,
		"y": 4.035210253,
		"h": 1.8571428571
	},
	{
		"stop_id": 8571630,
		"ID": 449,
		"x": -53.3312742237,
		"y": 5.083177202,
		"h": 1.8571428571
	},
	{
		"stop_id": 8571703,
		"ID": 449,
		"x": -57.9452856437,
		"y": 2.186236969,
		"h": 1.8571428571
	},
	{
		"stop_id": 8579865,
		"ID": 449,
		"x": -55.2652481807,
		"y": 3.368219218,
		"h": 1.8571428571
	},
	{
		"stop_id": 8581071,
		"ID": 449,
		"x": -54.9192907307,
		"y": 4.823237486,
		"h": 1.8571428571
	},
	{
		"stop_id": 8581327,
		"ID": 449,
		"x": -55.3712489337,
		"y": 7.206246923,
		"h": 1.8571428571
	},
	{
		"stop_id": 8582068,
		"ID": 449,
		"x": -55.7422416317,
		"y": 7.214218203,
		"h": 1.8571428571
	},
	{
		"stop_id": 8593307,
		"ID": 449,
		"x": -54.9262863867,
		"y": 3.255197598,
		"h": 1.8571428571
	},
	{
		"stop_id": 8593312,
		"ID": 449,
		"x": -55.2082382597,
		"y": 4.071180769,
		"h": 1.8571428571
	},
	{
		"stop_id": 8507076,
		"ID": 450,
		"x": -55.1692993087,
		"y": 10.517242155,
		"h": 2.1538461538
	},
	{
		"stop_id": 8507077,
		"ID": 450,
		"x": -57.1732860907,
		"y": 12.732238613,
		"h": 2.1538461538
	},
	{
		"stop_id": 8507092,
		"ID": 450,
		"x": -55.5922309037,
		"y": 11.21519538,
		"h": 2.1538461538
	},
	{
		"stop_id": 8507093,
		"ID": 450,
		"x": -57.6492548077,
		"y": 13.512249907,
		"h": 2.1538461538
	},
	{
		"stop_id": 8507727,
		"ID": 450,
		"x": -57.4422817457,
		"y": 11.461238333,
		"h": 2.1538461538
	},
	{
		"stop_id": 8507735,
		"ID": 450,
		"x": -57.9692638687,
		"y": 11.885177849,
		"h": 2.1538461538
	},
	{
		"stop_id": 8507790,
		"ID": 450,
		"x": -57.3502898737,
		"y": 12.205221803,
		"h": 2.1538461538
	},
	{
		"stop_id": 8507979,
		"ID": 450,
		"x": -57.2732297937,
		"y": 9.662245736,
		"h": 2.1538461538
	},
	{
		"stop_id": 8507990,
		"ID": 450,
		"x": -54.7422506347,
		"y": 10.030211511,
		"h": 2.1538461538
	},
	{
		"stop_id": 8571397,
		"ID": 450,
		"x": -57.5132514347,
		"y": 13.431143305,
		"h": 2.1538461538
	},
	{
		"stop_id": 8571398,
		"ID": 450,
		"x": -57.3022295147,
		"y": 12.82523538,
		"h": 2.1538461538
	},
	{
		"stop_id": 8571399,
		"ID": 450,
		"x": -58.2092722547,
		"y": 11.839201208,
		"h": 2.1538461538
	},
	{
		"stop_id": 8571400,
		"ID": 450,
		"x": -57.0192426337,
		"y": 10.853201513,
		"h": 2.1538461538
	},
	{
		"stop_id": 8571408,
		"ID": 450,
		"x": -57.3772782057,
		"y": 9.069227133,
		"h": 2.1538461538
	},
	{
		"stop_id": 8571416,
		"ID": 450,
		"x": -57.3442783407,
		"y": 8.700157592,
		"h": 2.1538461538
	},
	{
		"stop_id": 8571631,
		"ID": 450,
		"x": -54.7302803417,
		"y": 9.380213217,
		"h": 2.1538461538
	},
	{
		"stop_id": 8571632,
		"ID": 450,
		"x": -55.1852737887,
		"y": 10.578151109,
		"h": 2.1538461538
	},
	{
		"stop_id": 8580407,
		"ID": 450,
		"x": -57.5782329477,
		"y": 12.56821857,
		"h": 2.1538461538
	},
	{
		"stop_id": 8580678,
		"ID": 450,
		"x": -56.9692880707,
		"y": 10.265247734,
		"h": 2.1538461538
	},
	{
		"stop_id": 8581769,
		"ID": 450,
		"x": -57.3672960237,
		"y": 11.256158577,
		"h": 2.1538461538
	},
	{
		"stop_id": 8582228,
		"ID": 450,
		"x": -56.9832918237,
		"y": 9.881150628,
		"h": 2.1538461538
	},
	{
		"stop_id": 8587776,
		"ID": 450,
		"x": -54.9922945787,
		"y": 13.294178892,
		"h": 2.1538461538
	},
	{
		"stop_id": 8588264,
		"ID": 450,
		"x": -54.4642962287,
		"y": 10.84220786,
		"h": 2.1538461538
	},
	{
		"stop_id": 8588265,
		"ID": 450,
		"x": -54.8682768947,
		"y": 10.831197267,
		"h": 2.1538461538
	},
	{
		"stop_id": 8588267,
		"ID": 450,
		"x": -55.1592557827,
		"y": 11.044194011,
		"h": 2.1538461538
	},
	{
		"stop_id": 8588269,
		"ID": 450,
		"x": -55.1432329047,
		"y": 11.622177748,
		"h": 2.1538461538
	},
	{
		"stop_id": 8588270,
		"ID": 450,
		"x": -54.9972449597,
		"y": 11.734238159,
		"h": 2.1538461538
	},
	{
		"stop_id": 8588273,
		"ID": 450,
		"x": -54.6502428387,
		"y": 12.830210435,
		"h": 2.1538461538
	},
	{
		"stop_id": 8588275,
		"ID": 450,
		"x": -55.3802557087,
		"y": 11.360198006,
		"h": 2.1538461538
	},
	{
		"stop_id": 8588563,
		"ID": 450,
		"x": -54.9622931357,
		"y": 10.990206299,
		"h": 2.1538461538
	},
	{
		"stop_id": 8588703,
		"ID": 450,
		"x": -53.6482870327,
		"y": 10.663213105,
		"h": 2.1538461538
	},
	{
		"stop_id": 8588704,
		"ID": 450,
		"x": -53.3392415247,
		"y": 10.515232189,
		"h": 2.1538461538
	},
	{
		"stop_id": 8588904,
		"ID": 450,
		"x": -54.7002719237,
		"y": 11.885224133,
		"h": 2.1538461538
	},
	{
		"stop_id": 8590116,
		"ID": 450,
		"x": -54.6422357627,
		"y": 9.742143351,
		"h": 2.1538461538
	},
	{
		"stop_id": 8590124,
		"ID": 450,
		"x": -54.6552519557,
		"y": 11.355204052,
		"h": 2.1538461538
	},
	{
		"stop_id": 8594650,
		"ID": 450,
		"x": -55.4392312367,
		"y": 11.244205895,
		"h": 2.1538461538
	},
	{
		"stop_id": 8507100,
		"ID": 511,
		"x": -45.1522709797,
		"y": -4.366780365,
		"h": 3.7362637363
	},
	{
		"stop_id": 8507150,
		"ID": 511,
		"x": -45.0202702037,
		"y": -4.449834927,
		"h": 3.7362637363
	},
	{
		"stop_id": 8507159,
		"ID": 511,
		"x": -44.6662559907,
		"y": -8.18474955,
		"h": 3.7362637363
	},
	{
		"stop_id": 8507161,
		"ID": 511,
		"x": -44.1502686677,
		"y": -5.618797661,
		"h": 3.7362637363
	},
	{
		"stop_id": 8507172,
		"ID": 511,
		"x": -43.9992422687,
		"y": -5.421748666,
		"h": 3.7362637363
	},
	{
		"stop_id": 8507180,
		"ID": 511,
		"x": -45.1292719937,
		"y": -4.335819902,
		"h": 3.7362637363
	},
	{
		"stop_id": 8507181,
		"ID": 511,
		"x": -44.9672674647,
		"y": -4.004811013,
		"h": 3.7362637363
	},
	{
		"stop_id": 8571708,
		"ID": 511,
		"x": -45.1562614867,
		"y": -3.602843882,
		"h": 3.7362637363
	},
	{
		"stop_id": 8576557,
		"ID": 511,
		"x": -45.3272703857,
		"y": -3.714757317,
		"h": 3.7362637363
	},
	{
		"stop_id": 8576558,
		"ID": 511,
		"x": -45.3052557807,
		"y": -3.751834663,
		"h": 3.7362637363
	},
	{
		"stop_id": 8576559,
		"ID": 511,
		"x": -45.3082581107,
		"y": -4.092793967,
		"h": 3.7362637363
	},
	{
		"stop_id": 8576817,
		"ID": 511,
		"x": -45.4962517347,
		"y": -3.846782442,
		"h": 3.7362637363
	},
	{
		"stop_id": 8576830,
		"ID": 511,
		"x": -48.6942432377,
		"y": -7.985818084,
		"h": 3.7362637363
	},
	{
		"stop_id": 8576831,
		"ID": 511,
		"x": -48.9332826647,
		"y": -7.442753684,
		"h": 3.7362637363
	},
	{
		"stop_id": 8576832,
		"ID": 511,
		"x": -48.6702907907,
		"y": -7.373797635,
		"h": 3.7362637363
	},
	{
		"stop_id": 8576833,
		"ID": 511,
		"x": -48.6132584487,
		"y": -6.962817766,
		"h": 3.7362637363
	},
	{
		"stop_id": 8576834,
		"ID": 511,
		"x": -48.3472531027,
		"y": -6.357792097,
		"h": 3.7362637363
	},
	{
		"stop_id": 8576836,
		"ID": 511,
		"x": -47.7672512517,
		"y": -5.653755235,
		"h": 3.7362637363
	},
	{
		"stop_id": 8576837,
		"ID": 511,
		"x": -47.4262702627,
		"y": -5.462749073,
		"h": 3.7362637363
	},
	{
		"stop_id": 8576838,
		"ID": 511,
		"x": -46.3132672817,
		"y": -5.003805194,
		"h": 3.7362637363
	},
	{
		"stop_id": 8576856,
		"ID": 511,
		"x": -44.9782588397,
		"y": -8.840854572,
		"h": 3.7362637363
	},
	{
		"stop_id": 8576858,
		"ID": 511,
		"x": -45.3522722187,
		"y": -7.351781744,
		"h": 3.7362637363
	},
	{
		"stop_id": 8576859,
		"ID": 511,
		"x": -45.3342692007,
		"y": -6.856820591,
		"h": 3.7362637363
	},
	{
		"stop_id": 8576860,
		"ID": 511,
		"x": -45.3242727147,
		"y": -6.434804302,
		"h": 3.7362637363
	},
	{
		"stop_id": 8576861,
		"ID": 511,
		"x": -45.2942861517,
		"y": -5.935811829,
		"h": 3.7362637363
	},
	{
		"stop_id": 8576862,
		"ID": 511,
		"x": -45.3732887997,
		"y": -5.431855127,
		"h": 3.7362637363
	},
	{
		"stop_id": 8576863,
		"ID": 511,
		"x": -45.4522861747,
		"y": -4.956800779,
		"h": 3.7362637363
	},
	{
		"stop_id": 8576864,
		"ID": 511,
		"x": -45.0512843067,
		"y": -4.076831147,
		"h": 3.7362637363
	},
	{
		"stop_id": 8576865,
		"ID": 511,
		"x": -45.1122616167,
		"y": -4.135787494,
		"h": 3.7362637363
	},
	{
		"stop_id": 8576866,
		"ID": 511,
		"x": -44.7932511697,
		"y": -4.241836086,
		"h": 3.7362637363
	},
	{
		"stop_id": 8576867,
		"ID": 511,
		"x": -44.6432868997,
		"y": -4.418774617,
		"h": 3.7362637363
	},
	{
		"stop_id": 8576868,
		"ID": 511,
		"x": -44.5712246797,
		"y": -4.726750855,
		"h": 3.7362637363
	},
	{
		"stop_id": 8576869,
		"ID": 511,
		"x": -44.3792241677,
		"y": -5.139808354,
		"h": 3.7362637363
	},
	{
		"stop_id": 8576870,
		"ID": 511,
		"x": -43.8052730317,
		"y": -5.573760456,
		"h": 3.7362637363
	},
	{
		"stop_id": 8576871,
		"ID": 511,
		"x": -43.4862924147,
		"y": -5.829816192,
		"h": 3.7362637363
	},
	{
		"stop_id": 8587406,
		"ID": 511,
		"x": -45.5612874597,
		"y": -7.76482015,
		"h": 3.7362637363
	},
	{
		"stop_id": 8587471,
		"ID": 511,
		"x": -45.2852917677,
		"y": -8.441841109,
		"h": 3.7362637363
	},
	{
		"stop_id": 8587748,
		"ID": 511,
		"x": -45.6332328577,
		"y": -8.087819467,
		"h": 3.7362637363
	},
	{
		"stop_id": 8587872,
		"ID": 511,
		"x": -44.6942292907,
		"y": -5.190851921,
		"h": 3.7362637363
	},
	{
		"stop_id": 8587873,
		"ID": 511,
		"x": -44.8362628667,
		"y": -5.384859611,
		"h": 3.7362637363
	},
	{
		"stop_id": 8587874,
		"ID": 511,
		"x": -45.1672468337,
		"y": -5.72384231,
		"h": 3.7362637363
	},
	{
		"stop_id": 8587875,
		"ID": 511,
		"x": -45.3742237647,
		"y": -5.904764956,
		"h": 3.7362637363
	},
	{
		"stop_id": 8587876,
		"ID": 511,
		"x": -45.7342438157,
		"y": -6.567838921,
		"h": 3.7362637363
	},
	{
		"stop_id": 8587877,
		"ID": 511,
		"x": -45.8472635927,
		"y": -6.743856695,
		"h": 3.7362637363
	},
	{
		"stop_id": 8587878,
		"ID": 511,
		"x": -46.1062446917,
		"y": -7.038820232,
		"h": 3.7362637363
	},
	{
		"stop_id": 8587879,
		"ID": 511,
		"x": -46.1622769747,
		"y": -7.342767694,
		"h": 3.7362637363
	},
	{
		"stop_id": 8588099,
		"ID": 511,
		"x": -44.7542802047,
		"y": -8.880766404,
		"h": 3.7362637363
	},
	{
		"stop_id": 8588165,
		"ID": 511,
		"x": -46.4182383397,
		"y": -3.734834945,
		"h": 3.7362637363
	},
	{
		"stop_id": 8588166,
		"ID": 511,
		"x": -45.9182792977,
		"y": -4.176823266,
		"h": 3.7362637363
	},
	{
		"stop_id": 8588167,
		"ID": 511,
		"x": -46.2242334867,
		"y": -4.260782593,
		"h": 3.7362637363
	},
	{
		"stop_id": 8588168,
		"ID": 511,
		"x": -46.5392422057,
		"y": -4.365756845,
		"h": 3.7362637363
	},
	{
		"stop_id": 8588169,
		"ID": 511,
		"x": -46.7552430007,
		"y": -4.504852717,
		"h": 3.7362637363
	},
	{
		"stop_id": 8588171,
		"ID": 511,
		"x": -46.5282453007,
		"y": -5.0947712,
		"h": 3.7362637363
	},
	{
		"stop_id": 8588172,
		"ID": 511,
		"x": -45.8742975307,
		"y": -3.800752233,
		"h": 3.7362637363
	},
	{
		"stop_id": 8588173,
		"ID": 511,
		"x": -47.9392530377,
		"y": -5.859754594,
		"h": 3.7362637363
	},
	{
		"stop_id": 8588476,
		"ID": 511,
		"x": -46.1402318737,
		"y": -3.76878664,
		"h": 3.7362637363
	},
	{
		"stop_id": 8588477,
		"ID": 511,
		"x": -45.4432770937,
		"y": -4.438848355,
		"h": 3.7362637363
	},
	{
		"stop_id": 8588478,
		"ID": 511,
		"x": -46.8192906097,
		"y": -3.676789839,
		"h": 3.7362637363
	},
	{
		"stop_id": 8588479,
		"ID": 511,
		"x": -45.9862611167,
		"y": -4.852768328,
		"h": 3.7362637363
	},
	{
		"stop_id": 8588480,
		"ID": 511,
		"x": -45.6912802557,
		"y": -7.816817628,
		"h": 3.7362637363
	},
	{
		"stop_id": 8588481,
		"ID": 511,
		"x": -45.9962361437,
		"y": -7.580845501,
		"h": 3.7362637363
	},
	{
		"stop_id": 8588482,
		"ID": 511,
		"x": -45.6662391157,
		"y": -4.662821136,
		"h": 3.7362637363
	},
	{
		"stop_id": 8588582,
		"ID": 511,
		"x": -45.0332625257,
		"y": -3.666799668,
		"h": 3.7362637363
	},
	{
		"stop_id": 8590399,
		"ID": 511,
		"x": -44.2022343657,
		"y": -4.671781875,
		"h": 3.7362637363
	},
	{
		"stop_id": 8591908,
		"ID": 511,
		"x": -45.9162797327,
		"y": -6.079788833,
		"h": 3.7362637363
	},
	{
		"stop_id": 8591909,
		"ID": 511,
		"x": -46.0662984267,
		"y": -6.654756839,
		"h": 3.7362637363
	},
	{
		"stop_id": 8591910,
		"ID": 511,
		"x": -46.5262674507,
		"y": -6.588749316,
		"h": 3.7362637363
	},
	{
		"stop_id": 8591911,
		"ID": 511,
		"x": -46.1942732417,
		"y": -4.740849193,
		"h": 3.7362637363
	},
	{
		"stop_id": 8591912,
		"ID": 511,
		"x": -45.7362545297,
		"y": -5.341775031,
		"h": 3.7362637363
	},
	{
		"stop_id": 8591913,
		"ID": 511,
		"x": -45.2832997837,
		"y": -4.527845259,
		"h": 3.7362637363
	},
	{
		"stop_id": 8591917,
		"ID": 511,
		"x": -46.0972969577,
		"y": -4.847796036,
		"h": 3.7362637363
	},
	{
		"stop_id": 8591918,
		"ID": 511,
		"x": -46.3762411667,
		"y": -6.204778898,
		"h": 3.7362637363
	},
	{
		"stop_id": 8591919,
		"ID": 511,
		"x": -46.2922997407,
		"y": -5.838850448,
		"h": 3.7362637363
	},
	{
		"stop_id": 8591920,
		"ID": 511,
		"x": -45.8612269517,
		"y": -4.532762724,
		"h": 3.7362637363
	},
	{
		"stop_id": 8591921,
		"ID": 511,
		"x": -46.2372657927,
		"y": -4.513829875,
		"h": 3.7362637363
	},
	{
		"stop_id": 8591922,
		"ID": 511,
		"x": -46.2962879627,
		"y": -6.859822893,
		"h": 3.7362637363
	},
	{
		"stop_id": 8591923,
		"ID": 511,
		"x": -45.7262522947,
		"y": -6.027767826,
		"h": 3.7362637363
	},
	{
		"stop_id": 8591924,
		"ID": 511,
		"x": -45.9162297357,
		"y": -6.23475645,
		"h": 3.7362637363
	},
	{
		"stop_id": 8591925,
		"ID": 511,
		"x": -46.0602434747,
		"y": -5.450797163,
		"h": 3.7362637363
	},
	{
		"stop_id": 8591926,
		"ID": 511,
		"x": -45.8382924937,
		"y": -5.100777394,
		"h": 3.7362637363
	},
	{
		"stop_id": 8591927,
		"ID": 511,
		"x": -45.6432919877,
		"y": -4.281795152,
		"h": 3.7362637363
	},
	{
		"stop_id": 8591928,
		"ID": 511,
		"x": -46.5122344787,
		"y": -4.834825788,
		"h": 3.7362637363
	},
	{
		"stop_id": 8591929,
		"ID": 511,
		"x": -46.3222612697,
		"y": -5.562776692,
		"h": 3.7362637363
	},
	{
		"stop_id": 8594535,
		"ID": 511,
		"x": -47.0652863247,
		"y": -5.3098119,
		"h": 3.7362637363
	},
	{
		"stop_id": 8507151,
		"ID": 544,
		"x": -43.0272596627,
		"y": -6.557819514,
		"h": 2.6813186813
	},
	{
		"stop_id": 8507152,
		"ID": 544,
		"x": -42.2492583317,
		"y": -7.081765323,
		"h": 2.6813186813
	},
	{
		"stop_id": 8507153,
		"ID": 544,
		"x": -39.7332423717,
		"y": -9.062826178,
		"h": 2.6813186813
	},
	{
		"stop_id": 8507154,
		"ID": 544,
		"x": -40.5192485987,
		"y": -11.736854704,
		"h": 2.6813186813
	},
	{
		"stop_id": 8507164,
		"ID": 544,
		"x": -43.7942853467,
		"y": -9.376775763,
		"h": 2.6813186813
	},
	{
		"stop_id": 8507173,
		"ID": 544,
		"x": -42.9712865657,
		"y": -6.511751511,
		"h": 2.6813186813
	},
	{
		"stop_id": 8507174,
		"ID": 544,
		"x": -42.1812808907,
		"y": -6.984851391,
		"h": 2.6813186813
	},
	{
		"stop_id": 8507175,
		"ID": 544,
		"x": -41.3722906687,
		"y": -7.575849484,
		"h": 2.6813186813
	},
	{
		"stop_id": 8507176,
		"ID": 544,
		"x": -39.6342711327,
		"y": -9.024810374,
		"h": 2.6813186813
	},
	{
		"stop_id": 8507299,
		"ID": 544,
		"x": -43.5292729857,
		"y": -11.440779004,
		"h": 2.6813186813
	},
	{
		"stop_id": 8507483,
		"ID": 544,
		"x": -41.2702963997,
		"y": -11.966765333,
		"h": 2.6813186813
	},
	{
		"stop_id": 8507881,
		"ID": 544,
		"x": -38.6042515477,
		"y": -8.580832679,
		"h": 2.6813186813
	},
	{
		"stop_id": 8507882,
		"ID": 544,
		"x": -38.9672678057,
		"y": -9.092802043,
		"h": 2.6813186813
	},
	{
		"stop_id": 8507885,
		"ID": 544,
		"x": -39.3592936737,
		"y": -8.689826048,
		"h": 2.6813186813
	},
	{
		"stop_id": 8507886,
		"ID": 544,
		"x": -39.8922286967,
		"y": -8.246825968,
		"h": 2.6813186813
	},
	{
		"stop_id": 8576333,
		"ID": 544,
		"x": -41.2472750997,
		"y": -11.989817463,
		"h": 2.6813186813
	},
	{
		"stop_id": 8576334,
		"ID": 544,
		"x": -41.0522370537,
		"y": -12.222777712,
		"h": 2.6813186813
	},
	{
		"stop_id": 8576338,
		"ID": 544,
		"x": -41.5512983267,
		"y": -11.633785394,
		"h": 2.6813186813
	},
	{
		"stop_id": 8576339,
		"ID": 544,
		"x": -42.1642273497,
		"y": -11.753776592,
		"h": 2.6813186813
	},
	{
		"stop_id": 8576340,
		"ID": 544,
		"x": -42.2502394017,
		"y": -12.244830408,
		"h": 2.6813186813
	},
	{
		"stop_id": 8576347,
		"ID": 544,
		"x": -41.2872997997,
		"y": -11.635761208,
		"h": 2.6813186813
	},
	{
		"stop_id": 8576348,
		"ID": 544,
		"x": -41.1392785467,
		"y": -11.585836216,
		"h": 2.6813186813
	},
	{
		"stop_id": 8576349,
		"ID": 544,
		"x": -40.5982623977,
		"y": -11.715762349,
		"h": 2.6813186813
	},
	{
		"stop_id": 8576745,
		"ID": 544,
		"x": -38.5442357387,
		"y": -8.709798447,
		"h": 2.6813186813
	},
	{
		"stop_id": 8576747,
		"ID": 544,
		"x": -38.8562314947,
		"y": -8.544805193,
		"h": 2.6813186813
	},
	{
		"stop_id": 8576748,
		"ID": 544,
		"x": -38.6982594037,
		"y": -8.350822617,
		"h": 2.6813186813
	},
	{
		"stop_id": 8576757,
		"ID": 544,
		"x": -40.7672506117,
		"y": -8.027758523,
		"h": 2.6813186813
	},
	{
		"stop_id": 8576758,
		"ID": 544,
		"x": -39.9732693807,
		"y": -8.479766888,
		"h": 2.6813186813
	},
	{
		"stop_id": 8576760,
		"ID": 544,
		"x": -39.3522648027,
		"y": -8.146858851,
		"h": 2.6813186813
	},
	{
		"stop_id": 8576872,
		"ID": 544,
		"x": -42.7252355457,
		"y": -6.706827239,
		"h": 2.6813186813
	},
	{
		"stop_id": 8576874,
		"ID": 544,
		"x": -40.6092637177,
		"y": -8.592768308,
		"h": 2.6813186813
	},
	{
		"stop_id": 8576875,
		"ID": 544,
		"x": -40.1662490297,
		"y": -8.831798973,
		"h": 2.6813186813
	},
	{
		"stop_id": 8576876,
		"ID": 544,
		"x": -38.3772799217,
		"y": -9.410787495,
		"h": 2.6813186813
	},
	{
		"stop_id": 8583620,
		"ID": 544,
		"x": -40.5342667417,
		"y": -12.184795863,
		"h": 2.6813186813
	},
	{
		"stop_id": 8583621,
		"ID": 544,
		"x": -40.8652991617,
		"y": -12.014756349,
		"h": 2.6813186813
	},
	{
		"stop_id": 8583622,
		"ID": 544,
		"x": -40.5902798197,
		"y": -12.036788258,
		"h": 2.6813186813
	},
	{
		"stop_id": 8587598,
		"ID": 544,
		"x": -41.9632316537,
		"y": -7.259795958,
		"h": 2.6813186813
	},
	{
		"stop_id": 8588100,
		"ID": 544,
		"x": -44.2982944097,
		"y": -9.165759478,
		"h": 2.6813186813
	},
	{
		"stop_id": 8588101,
		"ID": 544,
		"x": -43.6852308797,
		"y": -9.638841086,
		"h": 2.6813186813
	},
	{
		"stop_id": 8588102,
		"ID": 544,
		"x": -43.2122914707,
		"y": -10.209851263,
		"h": 2.6813186813
	},
	{
		"stop_id": 8588103,
		"ID": 544,
		"x": -42.9342996717,
		"y": -10.50778851,
		"h": 2.6813186813
	},
	{
		"stop_id": 8588104,
		"ID": 544,
		"x": -42.3642857567,
		"y": -11.271780011,
		"h": 2.6813186813
	},
	{
		"stop_id": 8588105,
		"ID": 544,
		"x": -42.0912247907,
		"y": -11.578808097,
		"h": 2.6813186813
	},
	{
		"stop_id": 8588164,
		"ID": 544,
		"x": -41.7562985477,
		"y": -11.586821603,
		"h": 2.6813186813
	},
	{
		"stop_id": 8588190,
		"ID": 544,
		"x": -40.8942371727,
		"y": -11.641769433,
		"h": 2.6813186813
	},
	{
		"stop_id": 8588191,
		"ID": 544,
		"x": -41.2082360637,
		"y": -11.574820983,
		"h": 2.6813186813
	},
	{
		"stop_id": 8588491,
		"ID": 544,
		"x": -39.0972299087,
		"y": -7.786805674,
		"h": 2.6813186813
	},
	{
		"stop_id": 8588614,
		"ID": 544,
		"x": -40.8942702877,
		"y": -12.168813834,
		"h": 2.6813186813
	},
	{
		"stop_id": 8588615,
		"ID": 544,
		"x": -41.3222314997,
		"y": -11.744812152,
		"h": 2.6813186813
	},
	{
		"stop_id": 8590401,
		"ID": 544,
		"x": -41.9602240167,
		"y": -6.67382175,
		"h": 2.6813186813
	},
	{
		"stop_id": 8591839,
		"ID": 544,
		"x": -41.3292937837,
		"y": -11.686804411,
		"h": 2.6813186813
	},
	{
		"stop_id": 8595477,
		"ID": 544,
		"x": -42.6022725087,
		"y": -6.699808216,
		"h": 2.6813186813
	},
	{
		"stop_id": 8507155,
		"ID": 577,
		"x": -36.9102400467,
		"y": -10.834792645,
		"h": 1.8241758242
	},
	{
		"stop_id": 8507156,
		"ID": 577,
		"x": -36.2272245107,
		"y": -11.925829047,
		"h": 1.8241758242
	},
	{
		"stop_id": 8507177,
		"ID": 577,
		"x": -36.8402505687,
		"y": -10.855759626,
		"h": 1.8241758242
	},
	{
		"stop_id": 8507178,
		"ID": 577,
		"x": -36.1712240157,
		"y": -11.984751079,
		"h": 1.8241758242
	},
	{
		"stop_id": 8507186,
		"ID": 577,
		"x": -33.4672472097,
		"y": -12.246798162,
		"h": 1.8241758242
	},
	{
		"stop_id": 8507190,
		"ID": 577,
		"x": -36.1452719747,
		"y": -12.047792556,
		"h": 1.8241758242
	},
	{
		"stop_id": 8507191,
		"ID": 577,
		"x": -34.9832495317,
		"y": -11.772762437,
		"h": 1.8241758242
	},
	{
		"stop_id": 8507192,
		"ID": 577,
		"x": -34.7552900297,
		"y": -11.475780046,
		"h": 1.8241758242
	},
	{
		"stop_id": 8507194,
		"ID": 577,
		"x": -34.3822936647,
		"y": -10.369766211,
		"h": 1.8241758242
	},
	{
		"stop_id": 8507751,
		"ID": 577,
		"x": -34.7242535447,
		"y": -11.470759648,
		"h": 1.8241758242
	},
	{
		"stop_id": 8507861,
		"ID": 577,
		"x": -37.9152368897,
		"y": -14.814759307,
		"h": 1.8241758242
	},
	{
		"stop_id": 8571315,
		"ID": 577,
		"x": -33.6272934677,
		"y": -11.507784474,
		"h": 1.8241758242
	},
	{
		"stop_id": 8571316,
		"ID": 577,
		"x": -34.2052582967,
		"y": -11.571853333,
		"h": 1.8241758242
	},
	{
		"stop_id": 8576351,
		"ID": 577,
		"x": -37.5722748047,
		"y": -14.750807782,
		"h": 1.8241758242
	},
	{
		"stop_id": 8576877,
		"ID": 577,
		"x": -37.7472664317,
		"y": -9.719786544,
		"h": 1.8241758242
	},
	{
		"stop_id": 8576878,
		"ID": 577,
		"x": -37.4712910007,
		"y": -9.983794987,
		"h": 1.8241758242
	},
	{
		"stop_id": 8576879,
		"ID": 577,
		"x": -37.2362566477,
		"y": -10.234826279,
		"h": 1.8241758242
	},
	{
		"stop_id": 8576880,
		"ID": 577,
		"x": -37.0242809827,
		"y": -10.389775429,
		"h": 1.8241758242
	},
	{
		"stop_id": 8576881,
		"ID": 577,
		"x": -35.4982348797,
		"y": -12.5157925,
		"h": 1.8241758242
	},
	{
		"stop_id": 8576882,
		"ID": 577,
		"x": -34.9312541117,
		"y": -12.341838028,
		"h": 1.8241758242
	},
	{
		"stop_id": 8576883,
		"ID": 577,
		"x": -33.9542725457,
		"y": -12.320831514,
		"h": 1.8241758242
	},
	{
		"stop_id": 8581020,
		"ID": 577,
		"x": -34.4232245647,
		"y": -11.565771278,
		"h": 1.8241758242
	},
	{
		"stop_id": 8582596,
		"ID": 577,
		"x": -38.8352295747,
		"y": -13.711798997,
		"h": 1.8241758242
	},
	{
		"stop_id": 8582715,
		"ID": 577,
		"x": -38.2252791187,
		"y": -14.047820741,
		"h": 1.8241758242
	},
	{
		"stop_id": 8582859,
		"ID": 577,
		"x": -37.1962961177,
		"y": -14.798769697,
		"h": 1.8241758242
	},
	{
		"stop_id": 8587558,
		"ID": 577,
		"x": -36.4952267407,
		"y": -14.991757577,
		"h": 1.8241758242
	},
	{
		"stop_id": 8507157,
		"ID": 610,
		"x": -32.8652300507,
		"y": -12.090837542,
		"h": 1.5934065934
	},
	{
		"stop_id": 8507179,
		"ID": 610,
		"x": -32.4922916647,
		"y": -11.782780513,
		"h": 1.5934065934
	},
	{
		"stop_id": 8507195,
		"ID": 610,
		"x": -34.0092494407,
		"y": -9.253833344,
		"h": 1.5934065934
	},
	{
		"stop_id": 8507750,
		"ID": 610,
		"x": -32.8072825277,
		"y": -10.885851432,
		"h": 1.5934065934
	},
	{
		"stop_id": 8507772,
		"ID": 610,
		"x": -33.1582843487,
		"y": -11.284838882,
		"h": 1.5934065934
	},
	{
		"stop_id": 8507775,
		"ID": 610,
		"x": -31.3672376207,
		"y": -9.992772885,
		"h": 1.5934065934
	},
	{
		"stop_id": 8507791,
		"ID": 610,
		"x": -30.7212476887,
		"y": -11.700789244,
		"h": 1.5934065934
	},
	{
		"stop_id": 8507792,
		"ID": 610,
		"x": -29.2502722957,
		"y": -11.181801356,
		"h": 1.5934065934
	},
	{
		"stop_id": 8507798,
		"ID": 610,
		"x": -31.2542426817,
		"y": -10.936834309,
		"h": 1.5934065934
	},
	{
		"stop_id": 8507946,
		"ID": 610,
		"x": -31.2512413917,
		"y": -11.52178656,
		"h": 1.5934065934
	},
	{
		"stop_id": 8507947,
		"ID": 610,
		"x": -32.3262312277,
		"y": -10.452789874,
		"h": 1.5934065934
	},
	{
		"stop_id": 8507981,
		"ID": 610,
		"x": -32.0312780407,
		"y": -10.31080995,
		"h": 1.5934065934
	},
	{
		"stop_id": 8570512,
		"ID": 610,
		"x": -31.2512558907,
		"y": -10.372752998,
		"h": 1.5934065934
	},
	{
		"stop_id": 8571314,
		"ID": 610,
		"x": -32.5292351007,
		"y": -10.634804903,
		"h": 1.5934065934
	},
	{
		"stop_id": 8576884,
		"ID": 610,
		"x": -33.0032408877,
		"y": -12.039759671,
		"h": 1.5934065934
	},
	{
		"stop_id": 8576885,
		"ID": 610,
		"x": -31.6862583407,
		"y": -12.247758055,
		"h": 1.5934065934
	},
	{
		"stop_id": 8579807,
		"ID": 610,
		"x": -30.0632694727,
		"y": -11.376857094,
		"h": 1.5934065934
	},
	{
		"stop_id": 8581361,
		"ID": 610,
		"x": -29.2122557257,
		"y": -10.699804993,
		"h": 1.5934065934
	},
	{
		"stop_id": 8581645,
		"ID": 610,
		"x": -31.6542814447,
		"y": -10.085834715,
		"h": 1.5934065934
	},
	{
		"stop_id": 8507158,
		"ID": 609,
		"x": -30.8832437277,
		"y": -12.822809624,
		"h": 1.3956043956
	},
	{
		"stop_id": 8507167,
		"ID": 609,
		"x": -34.3392600977,
		"y": -15.382802259,
		"h": 1.3956043956
	},
	{
		"stop_id": 8507187,
		"ID": 609,
		"x": -30.6632498197,
		"y": -12.69979858,
		"h": 1.3956043956
	},
	{
		"stop_id": 8507494,
		"ID": 609,
		"x": -30.9562317797,
		"y": -14.886768553,
		"h": 1.3956043956
	},
	{
		"stop_id": 8507495,
		"ID": 609,
		"x": -33.9942712107,
		"y": -15.417799093,
		"h": 1.3956043956
	},
	{
		"stop_id": 8571328,
		"ID": 609,
		"x": -29.5412234957,
		"y": -17.527847565,
		"h": 1.3956043956
	},
	{
		"stop_id": 8571329,
		"ID": 609,
		"x": -29.8392982267,
		"y": -17.964779736,
		"h": 1.3956043956
	},
	{
		"stop_id": 8576886,
		"ID": 609,
		"x": -31.0772322917,
		"y": -12.383845753,
		"h": 1.3956043956
	},
	{
		"stop_id": 8576887,
		"ID": 609,
		"x": -30.1242702307,
		"y": -12.565767416,
		"h": 1.3956043956
	},
	{
		"stop_id": 8588812,
		"ID": 609,
		"x": -31.4922800467,
		"y": -14.519788055,
		"h": 1.3956043956
	},
	{
		"stop_id": 8588967,
		"ID": 609,
		"x": -33.5222529267,
		"y": -15.249787929,
		"h": 1.3956043956
	},
	{
		"stop_id": 8588968,
		"ID": 609,
		"x": -30.9782896537,
		"y": -14.883761363,
		"h": 1.3956043956
	},
	{
		"stop_id": 8588969,
		"ID": 609,
		"x": -34.0192548407,
		"y": -15.428800343,
		"h": 1.3956043956
	},
	{
		"stop_id": 8507166,
		"ID": 543,
		"x": -39.4702402827,
		"y": -13.116780041,
		"h": 2.3516483516
	},
	{
		"stop_id": 8507394,
		"ID": 543,
		"x": -40.4792618587,
		"y": -17.18580561,
		"h": 2.3516483516
	},
	{
		"stop_id": 8507458,
		"ID": 543,
		"x": -42.2442931697,
		"y": -16.875808516,
		"h": 2.3516483516
	},
	{
		"stop_id": 8507459,
		"ID": 543,
		"x": -43.3512536467,
		"y": -16.454818725,
		"h": 2.3516483516
	},
	{
		"stop_id": 8507481,
		"ID": 543,
		"x": -40.4082865207,
		"y": -17.351772781,
		"h": 2.3516483516
	},
	{
		"stop_id": 8507496,
		"ID": 543,
		"x": -39.9032647217,
		"y": -13.366792501,
		"h": 2.3516483516
	},
	{
		"stop_id": 8507860,
		"ID": 543,
		"x": -40.0272857047,
		"y": -15.031817014,
		"h": 2.3516483516
	},
	{
		"stop_id": 8507874,
		"ID": 543,
		"x": -39.1852668587,
		"y": -14.289851162,
		"h": 2.3516483516
	},
	{
		"stop_id": 8507875,
		"ID": 543,
		"x": -39.5232275087,
		"y": -15.840776306,
		"h": 2.3516483516
	},
	{
		"stop_id": 8507876,
		"ID": 543,
		"x": -41.2252846817,
		"y": -13.518855108,
		"h": 2.3516483516
	},
	{
		"stop_id": 8507877,
		"ID": 543,
		"x": -40.0612755727,
		"y": -13.671798083,
		"h": 2.3516483516
	},
	{
		"stop_id": 8507878,
		"ID": 543,
		"x": -42.3312748697,
		"y": -12.450835706,
		"h": 2.3516483516
	},
	{
		"stop_id": 8507879,
		"ID": 543,
		"x": -38.8862812697,
		"y": -15.940766905,
		"h": 2.3516483516
	},
	{
		"stop_id": 8576335,
		"ID": 543,
		"x": -40.8722877977,
		"y": -12.518810768,
		"h": 2.3516483516
	},
	{
		"stop_id": 8576336,
		"ID": 543,
		"x": -40.6342805017,
		"y": -13.069783276,
		"h": 2.3516483516
	},
	{
		"stop_id": 8576337,
		"ID": 543,
		"x": -40.4512531227,
		"y": -13.380801442,
		"h": 2.3516483516
	},
	{
		"stop_id": 8576341,
		"ID": 543,
		"x": -42.1842552907,
		"y": -13.044819817,
		"h": 2.3516483516
	},
	{
		"stop_id": 8576342,
		"ID": 543,
		"x": -41.0942942967,
		"y": -12.525838923,
		"h": 2.3516483516
	},
	{
		"stop_id": 8576343,
		"ID": 543,
		"x": -41.0812896577,
		"y": -12.79682438,
		"h": 2.3516483516
	},
	{
		"stop_id": 8576344,
		"ID": 543,
		"x": -40.8962260137,
		"y": -13.18177598,
		"h": 2.3516483516
	},
	{
		"stop_id": 8576345,
		"ID": 543,
		"x": -40.9422317857,
		"y": -13.469842805,
		"h": 2.3516483516
	},
	{
		"stop_id": 8576346,
		"ID": 543,
		"x": -41.2112716507,
		"y": -13.944804489,
		"h": 2.3516483516
	},
	{
		"stop_id": 8576350,
		"ID": 543,
		"x": -38.2622559807,
		"y": -15.030782421,
		"h": 2.3516483516
	},
	{
		"stop_id": 8576352,
		"ID": 543,
		"x": -38.3062989517,
		"y": -15.236821021,
		"h": 2.3516483516
	},
	{
		"stop_id": 8576353,
		"ID": 543,
		"x": -39.7032355757,
		"y": -15.530777116,
		"h": 2.3516483516
	},
	{
		"stop_id": 8576357,
		"ID": 543,
		"x": -40.8822747687,
		"y": -14.362772157,
		"h": 2.3516483516
	},
	{
		"stop_id": 8576358,
		"ID": 543,
		"x": -40.4042456927,
		"y": -14.603822959,
		"h": 2.3516483516
	},
	{
		"stop_id": 8576359,
		"ID": 543,
		"x": -40.2222497137,
		"y": -14.814786866,
		"h": 2.3516483516
	},
	{
		"stop_id": 8576360,
		"ID": 543,
		"x": -38.7352681097,
		"y": -15.07780744,
		"h": 2.3516483516
	},
	{
		"stop_id": 8576361,
		"ID": 543,
		"x": -39.6462858647,
		"y": -14.956853977,
		"h": 2.3516483516
	},
	{
		"stop_id": 8582734,
		"ID": 543,
		"x": -40.2662370717,
		"y": -17.165777774,
		"h": 2.3516483516
	},
	{
		"stop_id": 8582735,
		"ID": 543,
		"x": -40.9752259627,
		"y": -15.995772592,
		"h": 2.3516483516
	},
	{
		"stop_id": 8582736,
		"ID": 543,
		"x": -41.3202706427,
		"y": -14.937749615,
		"h": 2.3516483516
	},
	{
		"stop_id": 8583412,
		"ID": 543,
		"x": -40.3842610647,
		"y": -16.55985374,
		"h": 2.3516483516
	},
	{
		"stop_id": 8583852,
		"ID": 543,
		"x": -40.1592806767,
		"y": -15.490811773,
		"h": 2.3516483516
	},
	{
		"stop_id": 8583853,
		"ID": 543,
		"x": -40.3522956177,
		"y": -15.953779795,
		"h": 2.3516483516
	},
	{
		"stop_id": 8588606,
		"ID": 543,
		"x": -39.6332360327,
		"y": -13.180803191,
		"h": 2.3516483516
	},
	{
		"stop_id": 8588607,
		"ID": 543,
		"x": -39.8732644607,
		"y": -12.950816821,
		"h": 2.3516483516
	},
	{
		"stop_id": 8588610,
		"ID": 543,
		"x": -40.4422471027,
		"y": -12.394830145,
		"h": 2.3516483516
	},
	{
		"stop_id": 8588619,
		"ID": 543,
		"x": -39.4682722957,
		"y": -13.405808356,
		"h": 2.3516483516
	},
	{
		"stop_id": 8588799,
		"ID": 543,
		"x": -40.9992326547,
		"y": -15.439790098,
		"h": 2.3516483516
	},
	{
		"stop_id": 8588800,
		"ID": 543,
		"x": -40.3972831447,
		"y": -17.320833073,
		"h": 2.3516483516
	},
	{
		"stop_id": 8507169,
		"ID": 643,
		"x": -28.2142520187,
		"y": -12.377852632,
		"h": 3.3406593407
	},
	{
		"stop_id": 8507349,
		"ID": 643,
		"x": -28.1742317427,
		"y": -12.932816777,
		"h": 3.3406593407
	},
	{
		"stop_id": 8507367,
		"ID": 643,
		"x": -28.2422730837,
		"y": -13.089809616,
		"h": 3.3406593407
	},
	{
		"stop_id": 8507368,
		"ID": 643,
		"x": -27.0982955217,
		"y": -11.39283635,
		"h": 3.3406593407
	},
	{
		"stop_id": 8507369,
		"ID": 643,
		"x": -27.9052248157,
		"y": -10.588859022,
		"h": 3.3406593407
	},
	{
		"stop_id": 8507386,
		"ID": 643,
		"x": -24.7682674127,
		"y": -14.844852351,
		"h": 3.3406593407
	},
	{
		"stop_id": 8507388,
		"ID": 643,
		"x": -26.7702380297,
		"y": -14.204827965,
		"h": 3.3406593407
	},
	{
		"stop_id": 8507390,
		"ID": 643,
		"x": -25.2462586547,
		"y": -11.684759272,
		"h": 3.3406593407
	},
	{
		"stop_id": 8507396,
		"ID": 643,
		"x": -25.6982811377,
		"y": -11.619857361,
		"h": 3.3406593407
	},
	{
		"stop_id": 8507490,
		"ID": 643,
		"x": -24.8782791017,
		"y": -11.924761224,
		"h": 3.3406593407
	},
	{
		"stop_id": 8507491,
		"ID": 643,
		"x": -25.2332264647,
		"y": -10.370781777,
		"h": 3.3406593407
	},
	{
		"stop_id": 8507492,
		"ID": 643,
		"x": -26.8212324137,
		"y": -11.447798778,
		"h": 3.3406593407
	},
	{
		"stop_id": 8507493,
		"ID": 643,
		"x": -28.1602550057,
		"y": -12.330767381,
		"h": 3.3406593407
	},
	{
		"stop_id": 8507700,
		"ID": 643,
		"x": -26.2752807397,
		"y": -10.828798587,
		"h": 3.3406593407
	},
	{
		"stop_id": 8507701,
		"ID": 643,
		"x": -25.9842729987,
		"y": -10.618840919,
		"h": 3.3406593407
	},
	{
		"stop_id": 8507867,
		"ID": 643,
		"x": -28.8322969957,
		"y": -12.479779283,
		"h": 3.3406593407
	},
	{
		"stop_id": 8507893,
		"ID": 643,
		"x": -27.8872384047,
		"y": -12.106768011,
		"h": 3.3406593407
	},
	{
		"stop_id": 8507894,
		"ID": 643,
		"x": -27.1912737877,
		"y": -12.558830032,
		"h": 3.3406593407
	},
	{
		"stop_id": 8507895,
		"ID": 643,
		"x": -27.0412720867,
		"y": -13.100850903,
		"h": 3.3406593407
	},
	{
		"stop_id": 8507896,
		"ID": 643,
		"x": -27.2292882587,
		"y": -14.782845045,
		"h": 3.3406593407
	},
	{
		"stop_id": 8507897,
		"ID": 643,
		"x": -27.3842369277,
		"y": -14.534775296,
		"h": 3.3406593407
	},
	{
		"stop_id": 8508301,
		"ID": 643,
		"x": -24.4732372017,
		"y": -9.949819257,
		"h": 3.3406593407
	},
	{
		"stop_id": 8508370,
		"ID": 643,
		"x": -26.8082629767,
		"y": -11.315770732,
		"h": 3.3406593407
	},
	{
		"stop_id": 8508371,
		"ID": 643,
		"x": -24.5982760217,
		"y": -11.558830682,
		"h": 3.3406593407
	},
	{
		"stop_id": 8508372,
		"ID": 643,
		"x": -24.5732610027,
		"y": -10.225770821,
		"h": 3.3406593407
	},
	{
		"stop_id": 8571310,
		"ID": 643,
		"x": -28.1372347437,
		"y": -12.241822958,
		"h": 3.3406593407
	},
	{
		"stop_id": 8571311,
		"ID": 643,
		"x": -28.5062395007,
		"y": -11.988842716,
		"h": 3.3406593407
	},
	{
		"stop_id": 8571312,
		"ID": 643,
		"x": -28.8312495707,
		"y": -11.656795528,
		"h": 3.3406593407
	},
	{
		"stop_id": 8571323,
		"ID": 643,
		"x": -26.7902950677,
		"y": -14.189819031,
		"h": 3.3406593407
	},
	{
		"stop_id": 8571325,
		"ID": 643,
		"x": -27.7692724547,
		"y": -15.041760088,
		"h": 3.3406593407
	},
	{
		"stop_id": 8576374,
		"ID": 643,
		"x": -27.4982942487,
		"y": -11.791755463,
		"h": 3.3406593407
	},
	{
		"stop_id": 8576375,
		"ID": 643,
		"x": -27.2222369077,
		"y": -11.629852299,
		"h": 3.3406593407
	},
	{
		"stop_id": 8576376,
		"ID": 643,
		"x": -26.8162981777,
		"y": -11.468782593,
		"h": 3.3406593407
	},
	{
		"stop_id": 8576377,
		"ID": 643,
		"x": -26.6902370147,
		"y": -11.773804007,
		"h": 3.3406593407
	},
	{
		"stop_id": 8576378,
		"ID": 643,
		"x": -24.5762850807,
		"y": -11.708779782,
		"h": 3.3406593407
	},
	{
		"stop_id": 8576381,
		"ID": 643,
		"x": -27.3642268087,
		"y": -12.082851814,
		"h": 3.3406593407
	},
	{
		"stop_id": 8576383,
		"ID": 643,
		"x": -24.7822316247,
		"y": -10.142835547,
		"h": 3.3406593407
	},
	{
		"stop_id": 8576385,
		"ID": 643,
		"x": -24.3572825507,
		"y": -11.653799839,
		"h": 3.3406593407
	},
	{
		"stop_id": 8576386,
		"ID": 643,
		"x": -23.9002811607,
		"y": -11.639752436,
		"h": 3.3406593407
	},
	{
		"stop_id": 8576641,
		"ID": 643,
		"x": -27.3982854037,
		"y": -12.378854135,
		"h": 3.3406593407
	},
	{
		"stop_id": 8576888,
		"ID": 643,
		"x": -29.4722467297,
		"y": -12.550847718,
		"h": 3.3406593407
	},
	{
		"stop_id": 8576889,
		"ID": 643,
		"x": -28.9722539337,
		"y": -12.430805003,
		"h": 3.3406593407
	},
	{
		"stop_id": 8577037,
		"ID": 643,
		"x": -26.2742254667,
		"y": -11.512812874,
		"h": 3.3406593407
	},
	{
		"stop_id": 8577038,
		"ID": 643,
		"x": -26.7942954927,
		"y": -12.733758643,
		"h": 3.3406593407
	},
	{
		"stop_id": 8577039,
		"ID": 643,
		"x": -27.0272450837,
		"y": -12.036782288,
		"h": 3.3406593407
	},
	{
		"stop_id": 8578908,
		"ID": 643,
		"x": -28.6022450887,
		"y": -12.196780721,
		"h": 3.3406593407
	},
	{
		"stop_id": 8579113,
		"ID": 643,
		"x": -25.1172306767,
		"y": -12.144811201,
		"h": 3.3406593407
	},
	{
		"stop_id": 8579133,
		"ID": 643,
		"x": -26.5602769247,
		"y": -12.200753019,
		"h": 3.3406593407
	},
	{
		"stop_id": 8579134,
		"ID": 643,
		"x": -26.7772463427,
		"y": -12.033748964,
		"h": 3.3406593407
	},
	{
		"stop_id": 8579135,
		"ID": 643,
		"x": -26.0242508587,
		"y": -12.245794945,
		"h": 3.3406593407
	},
	{
		"stop_id": 8579161,
		"ID": 643,
		"x": -28.6192780687,
		"y": -11.891823251,
		"h": 3.3406593407
	},
	{
		"stop_id": 8579177,
		"ID": 643,
		"x": -28.4422439217,
		"y": -12.069773866,
		"h": 3.3406593407
	},
	{
		"stop_id": 8579281,
		"ID": 643,
		"x": -29.2682413297,
		"y": -11.786758871,
		"h": 3.3406593407
	},
	{
		"stop_id": 8579283,
		"ID": 643,
		"x": -29.3342357177,
		"y": -11.912824264,
		"h": 3.3406593407
	},
	{
		"stop_id": 8579288,
		"ID": 643,
		"x": -29.0762706347,
		"y": -11.942752235,
		"h": 3.3406593407
	},
	{
		"stop_id": 8579304,
		"ID": 643,
		"x": -28.2862984437,
		"y": -11.753797811,
		"h": 3.3406593407
	},
	{
		"stop_id": 8579332,
		"ID": 643,
		"x": -28.1352332677,
		"y": -12.418792316,
		"h": 3.3406593407
	},
	{
		"stop_id": 8579333,
		"ID": 643,
		"x": -28.1352609157,
		"y": -12.893814333,
		"h": 3.3406593407
	},
	{
		"stop_id": 8579334,
		"ID": 643,
		"x": -27.7162352287,
		"y": -12.554757063,
		"h": 3.3406593407
	},
	{
		"stop_id": 8579337,
		"ID": 643,
		"x": -27.4032658587,
		"y": -12.462813017,
		"h": 3.3406593407
	},
	{
		"stop_id": 8579339,
		"ID": 643,
		"x": -26.9872481757,
		"y": -12.94681104,
		"h": 3.3406593407
	},
	{
		"stop_id": 8579377,
		"ID": 643,
		"x": -27.0042238197,
		"y": -12.400844592,
		"h": 3.3406593407
	},
	{
		"stop_id": 8579710,
		"ID": 643,
		"x": -26.9672724567,
		"y": -12.582848197,
		"h": 3.3406593407
	},
	{
		"stop_id": 8579806,
		"ID": 643,
		"x": -28.7962366197,
		"y": -11.904854106,
		"h": 3.3406593407
	},
	{
		"stop_id": 8580532,
		"ID": 643,
		"x": -28.2842239857,
		"y": -11.857840487,
		"h": 3.3406593407
	},
	{
		"stop_id": 8580533,
		"ID": 643,
		"x": -28.3432504817,
		"y": -12.08382069,
		"h": 3.3406593407
	},
	{
		"stop_id": 8582257,
		"ID": 643,
		"x": -27.1522733117,
		"y": -14.319857477,
		"h": 3.3406593407
	},
	{
		"stop_id": 8582566,
		"ID": 643,
		"x": -26.9682451007,
		"y": -13.330793973,
		"h": 3.3406593407
	},
	{
		"stop_id": 8583218,
		"ID": 643,
		"x": -26.1602828807,
		"y": -11.642800341,
		"h": 3.3406593407
	},
	{
		"stop_id": 8583416,
		"ID": 643,
		"x": -29.2062900757,
		"y": -12.461791244,
		"h": 3.3406593407
	},
	{
		"stop_id": 8583417,
		"ID": 643,
		"x": -29.2972911757,
		"y": -12.213791895,
		"h": 3.3406593407
	},
	{
		"stop_id": 8583681,
		"ID": 643,
		"x": -27.8702982957,
		"y": -12.040755411,
		"h": 3.3406593407
	},
	{
		"stop_id": 8507258,
		"ID": 477,
		"x": -51.5742687967,
		"y": -14.907762821,
		"h": 1.4285714286
	},
	{
		"stop_id": 8507259,
		"ID": 477,
		"x": -51.8102301637,
		"y": -12.284764079,
		"h": 1.4285714286
	},
	{
		"stop_id": 8507286,
		"ID": 477,
		"x": -53.1602866967,
		"y": -15.202839253,
		"h": 1.4285714286
	},
	{
		"stop_id": 8507296,
		"ID": 477,
		"x": -50.7522852017,
		"y": -15.034772667,
		"h": 1.4285714286
	},
	{
		"stop_id": 8507297,
		"ID": 477,
		"x": -48.9742284427,
		"y": -14.920811352,
		"h": 1.4285714286
	},
	{
		"stop_id": 8507718,
		"ID": 477,
		"x": -50.0312893087,
		"y": -16.122757067,
		"h": 1.4285714286
	},
	{
		"stop_id": 8507722,
		"ID": 477,
		"x": -49.5232585387,
		"y": -15.589765208,
		"h": 1.4285714286
	},
	{
		"stop_id": 8571635,
		"ID": 477,
		"x": -48.9402790957,
		"y": -14.901852405,
		"h": 1.4285714286
	},
	{
		"stop_id": 8571636,
		"ID": 477,
		"x": -49.1862742657,
		"y": -15.120840911,
		"h": 1.4285714286
	},
	{
		"stop_id": 8571643,
		"ID": 477,
		"x": -50.2942654937,
		"y": -16.849757993,
		"h": 1.4285714286
	},
	{
		"stop_id": 8580535,
		"ID": 477,
		"x": -49.2222916677,
		"y": -15.579799637,
		"h": 1.4285714286
	},
	{
		"stop_id": 8581362,
		"ID": 477,
		"x": -49.8062379217,
		"y": -16.018784184,
		"h": 1.4285714286
	},
	{
		"stop_id": 8582970,
		"ID": 477,
		"x": -49.3932460297,
		"y": -15.83377702,
		"h": 1.4285714286
	},
	{
		"stop_id": 8583545,
		"ID": 477,
		"x": -50.1412701797,
		"y": -16.525800208,
		"h": 1.4285714286
	},
	{
		"stop_id": 8507260,
		"ID": 478,
		"x": -52.1132556717,
		"y": -11.200831637,
		"h": 1.5934065934
	},
	{
		"stop_id": 8507892,
		"ID": 478,
		"x": -50.1612341607,
		"y": -8.091821672,
		"h": 1.5934065934
	},
	{
		"stop_id": 8576794,
		"ID": 478,
		"x": -51.6842377987,
		"y": -8.313821965,
		"h": 1.5934065934
	},
	{
		"stop_id": 8576819,
		"ID": 478,
		"x": -53.0262382247,
		"y": -6.662846508,
		"h": 1.5934065934
	},
	{
		"stop_id": 8576820,
		"ID": 478,
		"x": -52.8732739867,
		"y": -7.085777989,
		"h": 1.5934065934
	},
	{
		"stop_id": 8576821,
		"ID": 478,
		"x": -52.5202943437,
		"y": -7.329824257,
		"h": 1.5934065934
	},
	{
		"stop_id": 8576822,
		"ID": 478,
		"x": -52.3412570887,
		"y": -7.525818321,
		"h": 1.5934065934
	},
	{
		"stop_id": 8576823,
		"ID": 478,
		"x": -52.1842747907,
		"y": -7.681814374,
		"h": 1.5934065934
	},
	{
		"stop_id": 8576824,
		"ID": 478,
		"x": -51.9342546587,
		"y": -7.890824906,
		"h": 1.5934065934
	},
	{
		"stop_id": 8576825,
		"ID": 478,
		"x": -50.9302784327,
		"y": -8.49975339,
		"h": 1.5934065934
	},
	{
		"stop_id": 8576826,
		"ID": 478,
		"x": -50.5322255357,
		"y": -8.160766624,
		"h": 1.5934065934
	},
	{
		"stop_id": 8576827,
		"ID": 478,
		"x": -49.7972483147,
		"y": -8.137812295,
		"h": 1.5934065934
	},
	{
		"stop_id": 8576828,
		"ID": 478,
		"x": -49.3432776427,
		"y": -8.224758376,
		"h": 1.5934065934
	},
	{
		"stop_id": 8576829,
		"ID": 478,
		"x": -48.8032610137,
		"y": -8.15476877,
		"h": 1.5934065934
	},
	{
		"stop_id": 8576839,
		"ID": 478,
		"x": -50.2692792537,
		"y": -8.859824414,
		"h": 1.5934065934
	},
	{
		"stop_id": 8576840,
		"ID": 478,
		"x": -49.4722438567,
		"y": -9.309749303,
		"h": 1.5934065934
	},
	{
		"stop_id": 8576841,
		"ID": 478,
		"x": -49.0082848047,
		"y": -9.757835287,
		"h": 1.5934065934
	},
	{
		"stop_id": 8576842,
		"ID": 478,
		"x": -48.5182962257,
		"y": -9.771840333,
		"h": 1.5934065934
	},
	{
		"stop_id": 8588475,
		"ID": 478,
		"x": -50.6942592517,
		"y": -8.650814412,
		"h": 1.5934065934
	},
	{
		"stop_id": 8507261,
		"ID": 539,
		"x": -43.4702507827,
		"y": -37.366821978,
		"h": 1.0659340659
	},
	{
		"stop_id": 8576642,
		"ID": 539,
		"x": -42.6972540987,
		"y": -35.478766881,
		"h": 1.0659340659
	},
	{
		"stop_id": 8576643,
		"ID": 539,
		"x": -42.5612300347,
		"y": -36.265768832,
		"h": 1.0659340659
	},
	{
		"stop_id": 8507262,
		"ID": 540,
		"x": -42.4682487837,
		"y": -35.284799729,
		"h": 1.7252747253
	},
	{
		"stop_id": 8507467,
		"ID": 540,
		"x": -41.3862452027,
		"y": -31.083764728,
		"h": 1.7252747253
	},
	{
		"stop_id": 8507475,
		"ID": 540,
		"x": -41.8832500627,
		"y": -33.186845949,
		"h": 1.7252747253
	},
	{
		"stop_id": 8507508,
		"ID": 540,
		"x": -41.6352706817,
		"y": -29.654810483,
		"h": 1.7252747253
	},
	{
		"stop_id": 8507589,
		"ID": 540,
		"x": -41.2602855507,
		"y": -32.344780742,
		"h": 1.7252747253
	},
	{
		"stop_id": 8507593,
		"ID": 540,
		"x": -39.9062333157,
		"y": -32.454764843,
		"h": 1.7252747253
	},
	{
		"stop_id": 8507594,
		"ID": 540,
		"x": -41.0072698147,
		"y": -32.966752969,
		"h": 1.7252747253
	},
	{
		"stop_id": 8530301,
		"ID": 540,
		"x": -42.6642669137,
		"y": -33.888780951,
		"h": 1.7252747253
	},
	{
		"stop_id": 8530302,
		"ID": 540,
		"x": -43.5572913227,
		"y": -33.550848059,
		"h": 1.7252747253
	},
	{
		"stop_id": 8576369,
		"ID": 540,
		"x": -41.5872336347,
		"y": -32.797772601,
		"h": 1.7252747253
	},
	{
		"stop_id": 8576370,
		"ID": 540,
		"x": -41.6382616497,
		"y": -33.240810583,
		"h": 1.7252747253
	},
	{
		"stop_id": 8576371,
		"ID": 540,
		"x": -41.8412909597,
		"y": -33.20083987,
		"h": 1.7252747253
	},
	{
		"stop_id": 8588176,
		"ID": 540,
		"x": -41.4422900057,
		"y": -30.139802,
		"h": 1.7252747253
	},
	{
		"stop_id": 8588809,
		"ID": 540,
		"x": -42.4782271887,
		"y": -35.259815933,
		"h": 1.7252747253
	},
	{
		"stop_id": 8589516,
		"ID": 540,
		"x": -42.4022417927,
		"y": -35.029818841,
		"h": 1.7252747253
	},
	{
		"stop_id": 8589517,
		"ID": 540,
		"x": -42.3342776477,
		"y": -34.629760208,
		"h": 1.7252747253
	},
	{
		"stop_id": 8589518,
		"ID": 540,
		"x": -42.2622653687,
		"y": -34.384765326,
		"h": 1.7252747253
	},
	{
		"stop_id": 8589519,
		"ID": 540,
		"x": -42.1222425517,
		"y": -34.134791548,
		"h": 1.7252747253
	},
	{
		"stop_id": 8589520,
		"ID": 540,
		"x": -41.8722965797,
		"y": -33.619804581,
		"h": 1.7252747253
	},
	{
		"stop_id": 8589521,
		"ID": 540,
		"x": -41.6532322917,
		"y": -33.317782198,
		"h": 1.7252747253
	},
	{
		"stop_id": 8589869,
		"ID": 540,
		"x": -41.0452855497,
		"y": -32.986769429,
		"h": 1.7252747253
	},
	{
		"stop_id": 8592319,
		"ID": 540,
		"x": -41.3212261467,
		"y": -32.548845161,
		"h": 1.7252747253
	},
	{
		"stop_id": 8592320,
		"ID": 540,
		"x": -41.5802899367,
		"y": -33.115797343,
		"h": 1.7252747253
	},
	{
		"stop_id": 8507273,
		"ID": 383,
		"x": -66.3672632277,
		"y": -29.224785245,
		"h": 1.0659340659
	},
	{
		"stop_id": 8507452,
		"ID": 383,
		"x": -65.9192451217,
		"y": -31.768846489,
		"h": 1.0659340659
	},
	{
		"stop_id": 8530678,
		"ID": 383,
		"x": -64.6652246867,
		"y": -27.031807206,
		"h": 1.0659340659
	},
	{
		"stop_id": 8507274,
		"ID": 413,
		"x": -63.8322639567,
		"y": -28.144765089,
		"h": 1.0989010989
	},
	{
		"stop_id": 8507290,
		"ID": 413,
		"x": -64.5982446137,
		"y": -26.811754369,
		"h": 1.0989010989
	},
	{
		"stop_id": 8577031,
		"ID": 413,
		"x": -64.6022308667,
		"y": -26.809750117,
		"h": 1.0989010989
	},
	{
		"stop_id": 8595617,
		"ID": 413,
		"x": -64.6462552717,
		"y": -26.536801992,
		"h": 1.0989010989
	},
	{
		"stop_id": 8507275,
		"ID": 412,
		"x": -63.5972307247,
		"y": -30.844801273,
		"h": 1.0989010989
	},
	{
		"stop_id": 8507276,
		"ID": 412,
		"x": -62.6682288677,
		"y": -32.144749034,
		"h": 1.0989010989
	},
	{
		"stop_id": 8507277,
		"ID": 412,
		"x": -61.0472304677,
		"y": -33.41484715,
		"h": 1.0989010989
	},
	{
		"stop_id": 8594851,
		"ID": 412,
		"x": -60.2722995707,
		"y": -35.259763459,
		"h": 1.0989010989
	},
	{
		"stop_id": 8507278,
		"ID": 411,
		"x": -59.9922548447,
		"y": -35.964795307,
		"h": 1.956043956
	},
	{
		"stop_id": 8507279,
		"ID": 411,
		"x": -59.3672847327,
		"y": -37.319789821,
		"h": 1.956043956
	},
	{
		"stop_id": 8507603,
		"ID": 411,
		"x": -58.9542551627,
		"y": -36.859753006,
		"h": 1.956043956
	},
	{
		"stop_id": 8507608,
		"ID": 411,
		"x": -59.3482987887,
		"y": -38.949804716,
		"h": 1.956043956
	},
	{
		"stop_id": 8507611,
		"ID": 411,
		"x": -59.2782516387,
		"y": -39.583775771,
		"h": 1.956043956
	},
	{
		"stop_id": 8507613,
		"ID": 411,
		"x": -58.8092276607,
		"y": -38.431832984,
		"h": 1.956043956
	},
	{
		"stop_id": 8507615,
		"ID": 411,
		"x": -59.2522353597,
		"y": -37.944753964,
		"h": 1.956043956
	},
	{
		"stop_id": 8507616,
		"ID": 411,
		"x": -58.5242903597,
		"y": -38.941811569,
		"h": 1.956043956
	},
	{
		"stop_id": 8530268,
		"ID": 411,
		"x": -59.8672775167,
		"y": -37.938762345,
		"h": 1.956043956
	},
	{
		"stop_id": 8530270,
		"ID": 411,
		"x": -62.0252363217,
		"y": -40.621833751,
		"h": 1.956043956
	},
	{
		"stop_id": 8579279,
		"ID": 411,
		"x": -59.3042823567,
		"y": -37.425837974,
		"h": 1.956043956
	},
	{
		"stop_id": 8589114,
		"ID": 411,
		"x": -60.2612673707,
		"y": -36.314834421,
		"h": 1.956043956
	},
	{
		"stop_id": 8589117,
		"ID": 411,
		"x": -59.7972669637,
		"y": -37.15882882,
		"h": 1.956043956
	},
	{
		"stop_id": 8589118,
		"ID": 411,
		"x": -59.5552711807,
		"y": -37.456751944,
		"h": 1.956043956
	},
	{
		"stop_id": 8589119,
		"ID": 411,
		"x": -59.8442277707,
		"y": -37.935761593,
		"h": 1.956043956
	},
	{
		"stop_id": 8589120,
		"ID": 411,
		"x": -59.3602744627,
		"y": -37.693749374,
		"h": 1.956043956
	},
	{
		"stop_id": 8589121,
		"ID": 411,
		"x": -59.5722489877,
		"y": -37.50277466,
		"h": 1.956043956
	},
	{
		"stop_id": 8589122,
		"ID": 411,
		"x": -59.0472482397,
		"y": -37.188812533,
		"h": 1.956043956
	},
	{
		"stop_id": 8589125,
		"ID": 411,
		"x": -59.6592931277,
		"y": -37.739779763,
		"h": 1.956043956
	},
	{
		"stop_id": 8591772,
		"ID": 411,
		"x": -59.7032412757,
		"y": -38.030810291,
		"h": 1.956043956
	},
	{
		"stop_id": 8594848,
		"ID": 411,
		"x": -59.6572983087,
		"y": -36.479832668,
		"h": 1.956043956
	},
	{
		"stop_id": 8594849,
		"ID": 411,
		"x": -59.8472442207,
		"y": -35.999818379,
		"h": 1.956043956
	},
	{
		"stop_id": 8594850,
		"ID": 411,
		"x": -60.0322559787,
		"y": -35.709779842,
		"h": 1.956043956
	},
	{
		"stop_id": 8594852,
		"ID": 411,
		"x": -60.5372736477,
		"y": -35.404801878,
		"h": 1.956043956
	},
	{
		"stop_id": 8594853,
		"ID": 411,
		"x": -60.4472267427,
		"y": -35.709851773,
		"h": 1.956043956
	},
	{
		"stop_id": 8594854,
		"ID": 411,
		"x": -60.4872243807,
		"y": -36.149838725,
		"h": 1.956043956
	},
	{
		"stop_id": 8594855,
		"ID": 411,
		"x": -59.8722384437,
		"y": -36.94883559,
		"h": 1.956043956
	},
	{
		"stop_id": 8594919,
		"ID": 411,
		"x": -58.7472641277,
		"y": -37.13485887,
		"h": 1.956043956
	},
	{
		"stop_id": 8594976,
		"ID": 411,
		"x": -58.5522953917,
		"y": -37.51979112,
		"h": 1.956043956
	},
	{
		"stop_id": 8595146,
		"ID": 411,
		"x": -60.3872244757,
		"y": -36.844856791,
		"h": 1.956043956
	},
	{
		"stop_id": 8507284,
		"ID": 415,
		"x": -61.3502347577,
		"y": -16.319800571,
		"h": 1.032967033
	},
	{
		"stop_id": 8507293,
		"ID": 415,
		"x": -59.9922253507,
		"y": -15.367775339,
		"h": 1.032967033
	},
	{
		"stop_id": 8507287,
		"ID": 510,
		"x": -46.9662370707,
		"y": -14.194756783,
		"h": 1.3956043956
	},
	{
		"stop_id": 8507288,
		"ID": 510,
		"x": -44.1632350847,
		"y": -12.249858814,
		"h": 1.3956043956
	},
	{
		"stop_id": 8507298,
		"ID": 510,
		"x": -44.6802351667,
		"y": -13.176750046,
		"h": 1.3956043956
	},
	{
		"stop_id": 8576845,
		"ID": 510,
		"x": -45.6002616397,
		"y": -10.89883043,
		"h": 1.3956043956
	},
	{
		"stop_id": 8576847,
		"ID": 510,
		"x": -45.1902802337,
		"y": -11.598763519,
		"h": 1.3956043956
	},
	{
		"stop_id": 8576848,
		"ID": 510,
		"x": -45.0642417667,
		"y": -12.906783285,
		"h": 1.3956043956
	},
	{
		"stop_id": 8576850,
		"ID": 510,
		"x": -44.4742685057,
		"y": -13.109753974,
		"h": 1.3956043956
	},
	{
		"stop_id": 8576851,
		"ID": 510,
		"x": -44.6742791187,
		"y": -13.171843812,
		"h": 1.3956043956
	},
	{
		"stop_id": 8576853,
		"ID": 510,
		"x": -45.3892512307,
		"y": -10.055795128,
		"h": 1.3956043956
	},
	{
		"stop_id": 8576854,
		"ID": 510,
		"x": -45.1052388907,
		"y": -10.014758221,
		"h": 1.3956043956
	},
	{
		"stop_id": 8587229,
		"ID": 510,
		"x": -45.8022533767,
		"y": -11.168770164,
		"h": 1.3956043956
	},
	{
		"stop_id": 8588503,
		"ID": 510,
		"x": -45.0442956157,
		"y": -9.697783019,
		"h": 1.3956043956
	},
	{
		"stop_id": 8595169,
		"ID": 510,
		"x": -44.7572878477,
		"y": -13.299781625,
		"h": 1.3956043956
	},
	{
		"stop_id": 8507294,
		"ID": 446,
		"x": -56.8872971757,
		"y": -15.004847077,
		"h": 1.032967033
	},
	{
		"stop_id": 8507295,
		"ID": 446,
		"x": -55.3962689227,
		"y": -15.053772975,
		"h": 1.032967033
	},
	{
		"stop_id": 8507350,
		"ID": 704,
		"x": -13.5482689117,
		"y": -18.629801938,
		"h": 2.7142857143
	},
	{
		"stop_id": 8507370,
		"ID": 704,
		"x": -15.2932335047,
		"y": -18.690754613,
		"h": 2.7142857143
	},
	{
		"stop_id": 8507376,
		"ID": 704,
		"x": -14.9602327967,
		"y": -18.914847239,
		"h": 2.7142857143
	},
	{
		"stop_id": 8507380,
		"ID": 704,
		"x": -14.1972418747,
		"y": -18.717795288,
		"h": 2.7142857143
	},
	{
		"stop_id": 8507381,
		"ID": 704,
		"x": -16.5182706347,
		"y": -18.055792102,
		"h": 2.7142857143
	},
	{
		"stop_id": 8507382,
		"ID": 704,
		"x": -18.6462366897,
		"y": -17.465839621,
		"h": 2.7142857143
	},
	{
		"stop_id": 8507552,
		"ID": 704,
		"x": -15.8802638327,
		"y": -20.41885188,
		"h": 2.7142857143
	},
	{
		"stop_id": 8507561,
		"ID": 704,
		"x": -17.4362280947,
		"y": -15.938768178,
		"h": 2.7142857143
	},
	{
		"stop_id": 8576510,
		"ID": 704,
		"x": -14.1092852337,
		"y": -18.731802901,
		"h": 2.7142857143
	},
	{
		"stop_id": 8576521,
		"ID": 704,
		"x": -14.9052782697,
		"y": -18.241752566,
		"h": 2.7142857143
	},
	{
		"stop_id": 8576522,
		"ID": 704,
		"x": -14.5332975047,
		"y": -18.201837097,
		"h": 2.7142857143
	},
	{
		"stop_id": 8576523,
		"ID": 704,
		"x": -15.2652925747,
		"y": -17.787853769,
		"h": 2.7142857143
	},
	{
		"stop_id": 8576524,
		"ID": 704,
		"x": -15.6072632957,
		"y": -17.249757251,
		"h": 2.7142857143
	},
	{
		"stop_id": 8576525,
		"ID": 704,
		"x": -15.2802296607,
		"y": -16.751754978,
		"h": 2.7142857143
	},
	{
		"stop_id": 8576526,
		"ID": 704,
		"x": -16.4492531807,
		"y": -16.547841801,
		"h": 2.7142857143
	},
	{
		"stop_id": 8576527,
		"ID": 704,
		"x": -16.9252309037,
		"y": -16.173830886,
		"h": 2.7142857143
	},
	{
		"stop_id": 8576528,
		"ID": 704,
		"x": -15.2382590467,
		"y": -18.584848482,
		"h": 2.7142857143
	},
	{
		"stop_id": 8576529,
		"ID": 704,
		"x": -14.6202854167,
		"y": -19.489830763,
		"h": 2.7142857143
	},
	{
		"stop_id": 8576530,
		"ID": 704,
		"x": -14.8862414487,
		"y": -19.284822911,
		"h": 2.7142857143
	},
	{
		"stop_id": 8576531,
		"ID": 704,
		"x": -15.0942333527,
		"y": -19.301822946,
		"h": 2.7142857143
	},
	{
		"stop_id": 8576532,
		"ID": 704,
		"x": -15.4152977497,
		"y": -19.410808811,
		"h": 2.7142857143
	},
	{
		"stop_id": 8576533,
		"ID": 704,
		"x": -15.8282442787,
		"y": -19.421841932,
		"h": 2.7142857143
	},
	{
		"stop_id": 8576534,
		"ID": 704,
		"x": -16.1382679097,
		"y": -19.439772113,
		"h": 2.7142857143
	},
	{
		"stop_id": 8576535,
		"ID": 704,
		"x": -16.3402538187,
		"y": -19.33484415,
		"h": 2.7142857143
	},
	{
		"stop_id": 8576536,
		"ID": 704,
		"x": -16.5302838437,
		"y": -19.261840231,
		"h": 2.7142857143
	},
	{
		"stop_id": 8576537,
		"ID": 704,
		"x": -16.7052282057,
		"y": -19.037754928,
		"h": 2.7142857143
	},
	{
		"stop_id": 8582465,
		"ID": 704,
		"x": -13.1052875847,
		"y": -18.044855099,
		"h": 2.7142857143
	},
	{
		"stop_id": 8582475,
		"ID": 704,
		"x": -13.3722512097,
		"y": -18.134854759,
		"h": 2.7142857143
	},
	{
		"stop_id": 8582476,
		"ID": 704,
		"x": -13.5742416417,
		"y": -18.179765044,
		"h": 2.7142857143
	},
	{
		"stop_id": 8582477,
		"ID": 704,
		"x": -13.8902292187,
		"y": -18.179848158,
		"h": 2.7142857143
	},
	{
		"stop_id": 8582478,
		"ID": 704,
		"x": -14.0102328137,
		"y": -18.230788208,
		"h": 2.7142857143
	},
	{
		"stop_id": 8582479,
		"ID": 704,
		"x": -13.5452794027,
		"y": -18.729831478,
		"h": 2.7142857143
	},
	{
		"stop_id": 8587540,
		"ID": 704,
		"x": -15.2712958717,
		"y": -18.684811643,
		"h": 2.7142857143
	},
	{
		"stop_id": 8588547,
		"ID": 704,
		"x": -14.7452825357,
		"y": -18.40675567,
		"h": 2.7142857143
	},
	{
		"stop_id": 8594313,
		"ID": 704,
		"x": -14.4852970797,
		"y": -19.359749101,
		"h": 2.7142857143
	},
	{
		"stop_id": 8594315,
		"ID": 704,
		"x": -14.7812642787,
		"y": -18.6238049,
		"h": 2.7142857143
	},
	{
		"stop_id": 8594316,
		"ID": 704,
		"x": -14.4252956487,
		"y": -18.681831617,
		"h": 2.7142857143
	},
	{
		"stop_id": 8594317,
		"ID": 704,
		"x": -15.4322835717,
		"y": -18.030768512,
		"h": 2.7142857143
	},
	{
		"stop_id": 8594318,
		"ID": 704,
		"x": -15.2192686407,
		"y": -18.087781401,
		"h": 2.7142857143
	},
	{
		"stop_id": 8594320,
		"ID": 704,
		"x": -14.9852888307,
		"y": -18.676798064,
		"h": 2.7142857143
	},
	{
		"stop_id": 8594321,
		"ID": 704,
		"x": -15.0602248387,
		"y": -16.209840625,
		"h": 2.7142857143
	},
	{
		"stop_id": 8594322,
		"ID": 704,
		"x": -14.3652531217,
		"y": -17.07776032,
		"h": 2.7142857143
	},
	{
		"stop_id": 8594323,
		"ID": 704,
		"x": -14.6432341427,
		"y": -18.962838266,
		"h": 2.7142857143
	},
	{
		"stop_id": 8594324,
		"ID": 704,
		"x": -14.8172786307,
		"y": -18.836852013,
		"h": 2.7142857143
	},
	{
		"stop_id": 8594325,
		"ID": 704,
		"x": -15.0762768267,
		"y": -18.769856128,
		"h": 2.7142857143
	},
	{
		"stop_id": 8594326,
		"ID": 704,
		"x": -13.8092931387,
		"y": -18.819788722,
		"h": 2.7142857143
	},
	{
		"stop_id": 8594327,
		"ID": 704,
		"x": -14.4322477557,
		"y": -19.029843945,
		"h": 2.7142857143
	},
	{
		"stop_id": 8594328,
		"ID": 704,
		"x": -14.4022721647,
		"y": -18.616846368,
		"h": 2.7142857143
	},
	{
		"stop_id": 8594329,
		"ID": 704,
		"x": -14.4022623427,
		"y": -18.912779032,
		"h": 2.7142857143
	},
	{
		"stop_id": 8594332,
		"ID": 704,
		"x": -14.5422609337,
		"y": -16.856754713,
		"h": 2.7142857143
	},
	{
		"stop_id": 8594492,
		"ID": 704,
		"x": -18.6442622427,
		"y": -17.485836524,
		"h": 2.7142857143
	},
	{
		"stop_id": 8594494,
		"ID": 704,
		"x": -16.4852423707,
		"y": -17.994856299,
		"h": 2.7142857143
	},
	{
		"stop_id": 8595887,
		"ID": 704,
		"x": -14.9662809637,
		"y": -18.935792085,
		"h": 2.7142857143
	},
	{
		"stop_id": 8507354,
		"ID": 734,
		"x": -12.6572814317,
		"y": -14.75985476,
		"h": 1.3956043956
	},
	{
		"stop_id": 8507562,
		"ID": 734,
		"x": -8.9762427397,
		"y": -15.203805627,
		"h": 1.3956043956
	},
	{
		"stop_id": 8507563,
		"ID": 734,
		"x": -12.5432495517,
		"y": -17.936859652,
		"h": 1.3956043956
	},
	{
		"stop_id": 8507564,
		"ID": 734,
		"x": -10.5342492007,
		"y": -16.751801366,
		"h": 1.3956043956
	},
	{
		"stop_id": 8507565,
		"ID": 734,
		"x": -11.3282772127,
		"y": -17.841821348,
		"h": 1.3956043956
	},
	{
		"stop_id": 8576514,
		"ID": 734,
		"x": -12.7082969607,
		"y": -17.993848905,
		"h": 1.3956043956
	},
	{
		"stop_id": 8576515,
		"ID": 734,
		"x": -11.8552860207,
		"y": -18.007793676,
		"h": 1.3956043956
	},
	{
		"stop_id": 8576516,
		"ID": 734,
		"x": -11.5902619737,
		"y": -17.879832976,
		"h": 1.3956043956
	},
	{
		"stop_id": 8576517,
		"ID": 734,
		"x": -10.0612515507,
		"y": -16.469763248,
		"h": 1.3956043956
	},
	{
		"stop_id": 8576518,
		"ID": 734,
		"x": -9.7272982097,
		"y": -15.786854482,
		"h": 1.3956043956
	},
	{
		"stop_id": 8587317,
		"ID": 734,
		"x": -11.0522444177,
		"y": -17.089751372,
		"h": 1.3956043956
	},
	{
		"stop_id": 8588697,
		"ID": 734,
		"x": -13.4672491607,
		"y": -15.772787897,
		"h": 1.3956043956
	},
	{
		"stop_id": 8594330,
		"ID": 734,
		"x": -10.5622538597,
		"y": -17.109775672,
		"h": 1.3956043956
	},
	{
		"stop_id": 8507356,
		"ID": 673,
		"x": -22.7422358257,
		"y": -20.784791332,
		"h": 1.4945054945
	},
	{
		"stop_id": 8507357,
		"ID": 673,
		"x": -21.2602977827,
		"y": -20.021776484,
		"h": 1.4945054945
	},
	{
		"stop_id": 8507371,
		"ID": 673,
		"x": -21.1202783707,
		"y": -20.245772968,
		"h": 1.4945054945
	},
	{
		"stop_id": 8507372,
		"ID": 673,
		"x": -22.7852555747,
		"y": -20.940802191,
		"h": 1.4945054945
	},
	{
		"stop_id": 8507374,
		"ID": 673,
		"x": -19.7732263587,
		"y": -23.156814237,
		"h": 1.4945054945
	},
	{
		"stop_id": 8507377,
		"ID": 673,
		"x": -23.8422996517,
		"y": -21.669791828,
		"h": 1.4945054945
	},
	{
		"stop_id": 8507384,
		"ID": 673,
		"x": -23.7702937187,
		"y": -21.665804588,
		"h": 1.4945054945
	},
	{
		"stop_id": 8507550,
		"ID": 673,
		"x": -21.9372735717,
		"y": -22.143822054,
		"h": 1.4945054945
	},
	{
		"stop_id": 8507555,
		"ID": 673,
		"x": -23.3532515827,
		"y": -20.46779682,
		"h": 1.4945054945
	},
	{
		"stop_id": 8571318,
		"ID": 673,
		"x": -23.8102623307,
		"y": -21.606790784,
		"h": 1.4945054945
	},
	{
		"stop_id": 8571319,
		"ID": 673,
		"x": -23.6842945917,
		"y": -22.219795753,
		"h": 1.4945054945
	},
	{
		"stop_id": 8571320,
		"ID": 673,
		"x": -23.2372347827,
		"y": -23.049749311,
		"h": 1.4945054945
	},
	{
		"stop_id": 8577035,
		"ID": 673,
		"x": -24.2572752627,
		"y": -20.103783688,
		"h": 1.4945054945
	},
	{
		"stop_id": 8579958,
		"ID": 673,
		"x": -23.9862603027,
		"y": -20.744841887,
		"h": 1.4945054945
	},
	{
		"stop_id": 8580370,
		"ID": 673,
		"x": -23.8182844147,
		"y": -22.008821927,
		"h": 1.4945054945
	},
	{
		"stop_id": 8580743,
		"ID": 673,
		"x": -23.4672846867,
		"y": -22.572784237,
		"h": 1.4945054945
	},
	{
		"stop_id": 8507358,
		"ID": 641,
		"x": -24.9072539427,
		"y": -25.885858021,
		"h": 1.1978021978
	},
	{
		"stop_id": 8507359,
		"ID": 641,
		"x": -25.2052644467,
		"y": -25.519831672,
		"h": 1.1978021978
	},
	{
		"stop_id": 8507378,
		"ID": 641,
		"x": -25.0882367777,
		"y": -21.886755707,
		"h": 1.1978021978
	},
	{
		"stop_id": 8507379,
		"ID": 641,
		"x": -24.5792418327,
		"y": -25.486750448,
		"h": 1.1978021978
	},
	{
		"stop_id": 8507455,
		"ID": 641,
		"x": -25.0322810297,
		"y": -26.198849322,
		"h": 1.1978021978
	},
	{
		"stop_id": 8507456,
		"ID": 641,
		"x": -27.6022765597,
		"y": -25.756765284,
		"h": 1.1978021978
	},
	{
		"stop_id": 8507560,
		"ID": 641,
		"x": -24.6822451137,
		"y": -23.519794265,
		"h": 1.1978021978
	},
	{
		"stop_id": 8507361,
		"ID": 703,
		"x": -18.6962495767,
		"y": -24.259805988,
		"h": 1.032967033
	},
	{
		"stop_id": 8507375,
		"ID": 703,
		"x": -16.5832679077,
		"y": -21.432793619,
		"h": 1.032967033
	},
	{
		"stop_id": 8507364,
		"ID": 702,
		"x": -18.0612678437,
		"y": -27.294786543,
		"h": 1
	},
	{
		"stop_id": 8507373,
		"ID": 672,
		"x": -21.3902319217,
		"y": -24.193858994,
		"h": 1.2307692308
	},
	{
		"stop_id": 8507453,
		"ID": 672,
		"x": -24.2302633207,
		"y": -26.479764604,
		"h": 1.2307692308
	},
	{
		"stop_id": 8507769,
		"ID": 672,
		"x": -24.2452514847,
		"y": -27.111840643,
		"h": 1.2307692308
	},
	{
		"stop_id": 8507774,
		"ID": 672,
		"x": -23.4532557957,
		"y": -24.54481756,
		"h": 1.2307692308
	},
	{
		"stop_id": 8507797,
		"ID": 672,
		"x": -24.1722640787,
		"y": -27.548854549,
		"h": 1.2307692308
	},
	{
		"stop_id": 8507799,
		"ID": 672,
		"x": -24.2382327347,
		"y": -26.467805475,
		"h": 1.2307692308
	},
	{
		"stop_id": 8571321,
		"ID": 672,
		"x": -23.6202731897,
		"y": -24.997829791,
		"h": 1.2307692308
	},
	{
		"stop_id": 8571322,
		"ID": 672,
		"x": -23.9232822097,
		"y": -25.653750214,
		"h": 1.2307692308
	},
	{
		"stop_id": 8507383,
		"ID": 674,
		"x": -20.6642812147,
		"y": -17.347778318,
		"h": 1.0659340659
	},
	{
		"stop_id": 8507387,
		"ID": 674,
		"x": -23.5602838137,
		"y": -15.675803897,
		"h": 1.0659340659
	},
	{
		"stop_id": 8594493,
		"ID": 674,
		"x": -20.6612957297,
		"y": -17.229808996,
		"h": 1.0659340659
	},
	{
		"stop_id": 8507389,
		"ID": 642,
		"x": -24.4352273897,
		"y": -17.859791018,
		"h": 1.2307692308
	},
	{
		"stop_id": 8507869,
		"ID": 642,
		"x": -26.5132663337,
		"y": -15.419815875,
		"h": 1.2307692308
	},
	{
		"stop_id": 8530336,
		"ID": 642,
		"x": -24.7702380507,
		"y": -19.233784165,
		"h": 1.2307692308
	},
	{
		"stop_id": 8530337,
		"ID": 642,
		"x": -25.3202821947,
		"y": -18.897782199,
		"h": 1.2307692308
	},
	{
		"stop_id": 8571326,
		"ID": 642,
		"x": -27.7852678567,
		"y": -15.63281434,
		"h": 1.2307692308
	},
	{
		"stop_id": 8571327,
		"ID": 642,
		"x": -28.8542807977,
		"y": -16.796767637,
		"h": 1.2307692308
	},
	{
		"stop_id": 8577036,
		"ID": 642,
		"x": -24.7482312027,
		"y": -19.158840145,
		"h": 1.2307692308
	},
	{
		"stop_id": 8582719,
		"ID": 642,
		"x": -24.4352273897,
		"y": -17.859791018,
		"h": 1.2307692308
	},
	{
		"stop_id": 8507397,
		"ID": 675,
		"x": -20.6122378207,
		"y": -9.91479424,
		"h": 1.4285714286
	},
	{
		"stop_id": 8507868,
		"ID": 675,
		"x": -23.8432401697,
		"y": -9.65082319,
		"h": 1.4285714286
	},
	{
		"stop_id": 8508302,
		"ID": 675,
		"x": -22.2752608617,
		"y": -8.53978408,
		"h": 1.4285714286
	},
	{
		"stop_id": 8508373,
		"ID": 675,
		"x": -21.9972700287,
		"y": -8.3908553,
		"h": 1.4285714286
	},
	{
		"stop_id": 8508379,
		"ID": 675,
		"x": -19.6812517797,
		"y": -9.034754115,
		"h": 1.4285714286
	},
	{
		"stop_id": 8576384,
		"ID": 675,
		"x": -24.4252733217,
		"y": -9.808797699,
		"h": 1.4285714286
	},
	{
		"stop_id": 8576387,
		"ID": 675,
		"x": -23.1502654167,
		"y": -11.679811073,
		"h": 1.4285714286
	},
	{
		"stop_id": 8576388,
		"ID": 675,
		"x": -22.7062666397,
		"y": -11.35581292,
		"h": 1.4285714286
	},
	{
		"stop_id": 8576389,
		"ID": 675,
		"x": -19.8532760697,
		"y": -9.556839256,
		"h": 1.4285714286
	},
	{
		"stop_id": 8576390,
		"ID": 675,
		"x": -19.5542790517,
		"y": -9.051804101,
		"h": 1.4285714286
	},
	{
		"stop_id": 8577040,
		"ID": 675,
		"x": -22.2052555787,
		"y": -8.387823235,
		"h": 1.4285714286
	},
	{
		"stop_id": 8580817,
		"ID": 675,
		"x": -21.1012429017,
		"y": -10.258804659,
		"h": 1.4285714286
	},
	{
		"stop_id": 8580891,
		"ID": 675,
		"x": -20.3382367247,
		"y": -9.841854698,
		"h": 1.4285714286
	},
	{
		"stop_id": 8587713,
		"ID": 675,
		"x": -21.7322757277,
		"y": -7.869800726,
		"h": 1.4285714286
	},
	{
		"stop_id": 8507399,
		"ID": 546,
		"x": -40.0052344727,
		"y": 3.872164328,
		"h": 1.8571428571
	},
	{
		"stop_id": 8507400,
		"ID": 546,
		"x": -42.0662675797,
		"y": 0.353141503,
		"h": 1.8571428571
	},
	{
		"stop_id": 8507403,
		"ID": 546,
		"x": -40.9732832247,
		"y": 0.439165324,
		"h": 1.8571428571
	},
	{
		"stop_id": 8576566,
		"ID": 546,
		"x": -40.2282261967,
		"y": 3.275235202,
		"h": 1.8571428571
	},
	{
		"stop_id": 8576567,
		"ID": 546,
		"x": -40.3952759557,
		"y": 2.829240147,
		"h": 1.8571428571
	},
	{
		"stop_id": 8576568,
		"ID": 546,
		"x": -40.3702336667,
		"y": 2.092159188,
		"h": 1.8571428571
	},
	{
		"stop_id": 8576569,
		"ID": 546,
		"x": -40.7882880187,
		"y": 1.015155521,
		"h": 1.8571428571
	},
	{
		"stop_id": 8576570,
		"ID": 546,
		"x": -41.5672630747,
		"y": 0.423220965,
		"h": 1.8571428571
	},
	{
		"stop_id": 8576571,
		"ID": 546,
		"x": -42.6172367237,
		"y": 0.216143086,
		"h": 1.8571428571
	},
	{
		"stop_id": 8576572,
		"ID": 546,
		"x": -43.3252317957,
		"y": 0.006171595,
		"h": 1.8571428571
	},
	{
		"stop_id": 8576589,
		"ID": 546,
		"x": -39.1662660117,
		"y": 2.298157659,
		"h": 1.8571428571
	},
	{
		"stop_id": 8576600,
		"ID": 546,
		"x": -39.4442364917,
		"y": 0.337192527,
		"h": 1.8571428571
	},
	{
		"stop_id": 8576601,
		"ID": 546,
		"x": -39.8252938587,
		"y": 0.274218368,
		"h": 1.8571428571
	},
	{
		"stop_id": 8576602,
		"ID": 546,
		"x": -40.3892418957,
		"y": 0.245250056,
		"h": 1.8571428571
	},
	{
		"stop_id": 8576603,
		"ID": 546,
		"x": -41.8652825847,
		"y": -0.021791618,
		"h": 1.8571428571
	},
	{
		"stop_id": 8576604,
		"ID": 546,
		"x": -42.3882790647,
		"y": -0.522804627,
		"h": 1.8571428571
	},
	{
		"stop_id": 8576606,
		"ID": 546,
		"x": -42.9562604297,
		"y": -0.696839635,
		"h": 1.8571428571
	},
	{
		"stop_id": 8576613,
		"ID": 546,
		"x": -42.3322673467,
		"y": 4.862154631,
		"h": 1.8571428571
	},
	{
		"stop_id": 8576618,
		"ID": 546,
		"x": -39.7842479097,
		"y": 4.852185249,
		"h": 1.8571428571
	},
	{
		"stop_id": 8576619,
		"ID": 546,
		"x": -39.6792693877,
		"y": 4.028214692,
		"h": 1.8571428571
	},
	{
		"stop_id": 8576626,
		"ID": 546,
		"x": -42.3882294277,
		"y": 2.130235964,
		"h": 1.8571428571
	},
	{
		"stop_id": 8576627,
		"ID": 546,
		"x": -41.6322915987,
		"y": 2.317229661,
		"h": 1.8571428571
	},
	{
		"stop_id": 8576628,
		"ID": 546,
		"x": -41.0862575937,
		"y": 2.573144032,
		"h": 1.8571428571
	},
	{
		"stop_id": 8576629,
		"ID": 546,
		"x": -41.2522868397,
		"y": 2.760172738,
		"h": 1.8571428571
	},
	{
		"stop_id": 8576630,
		"ID": 546,
		"x": -41.8252317577,
		"y": 2.856154019,
		"h": 1.8571428571
	},
	{
		"stop_id": 8576631,
		"ID": 546,
		"x": -41.2642332597,
		"y": 3.468171616,
		"h": 1.8571428571
	},
	{
		"stop_id": 8595480,
		"ID": 546,
		"x": -42.5642576177,
		"y": 2.194208095,
		"h": 1.8571428571
	},
	{
		"stop_id": 8507402,
		"ID": 611,
		"x": -30.1752580097,
		"y": -0.88085777,
		"h": 1.032967033
	},
	{
		"stop_id": 8576639,
		"ID": 611,
		"x": -30.3632499517,
		"y": -0.804851816,
		"h": 1.032967033
	},
	{
		"stop_id": 8507404,
		"ID": 579,
		"x": -33.7972882917,
		"y": -0.617794046,
		"h": 1.3956043956
	},
	{
		"stop_id": 8507405,
		"ID": 579,
		"x": -38.2632861917,
		"y": 0.089168634,
		"h": 1.3956043956
	},
	{
		"stop_id": 8571722,
		"ID": 579,
		"x": -38.3052366307,
		"y": -2.040751012,
		"h": 1.3956043956
	},
	{
		"stop_id": 8576596,
		"ID": 579,
		"x": -36.2372871497,
		"y": 1.643229874,
		"h": 1.3956043956
	},
	{
		"stop_id": 8576597,
		"ID": 579,
		"x": -36.7082863387,
		"y": 0.642216512,
		"h": 1.3956043956
	},
	{
		"stop_id": 8576598,
		"ID": 579,
		"x": -38.5452914087,
		"y": 0.082163642,
		"h": 1.3956043956
	},
	{
		"stop_id": 8576599,
		"ID": 579,
		"x": -38.9942560027,
		"y": 0.137180935,
		"h": 1.3956043956
	},
	{
		"stop_id": 8576633,
		"ID": 579,
		"x": -36.7692598687,
		"y": -0.740847182,
		"h": 1.3956043956
	},
	{
		"stop_id": 8576634,
		"ID": 579,
		"x": -35.8042826357,
		"y": -0.805780444,
		"h": 1.3956043956
	},
	{
		"stop_id": 8576635,
		"ID": 579,
		"x": -34.6952933947,
		"y": -0.589813388,
		"h": 1.3956043956
	},
	{
		"stop_id": 8576636,
		"ID": 579,
		"x": -33.4472414047,
		"y": -0.727773558,
		"h": 1.3956043956
	},
	{
		"stop_id": 8595168,
		"ID": 579,
		"x": -38.5182491257,
		"y": -2.234829325,
		"h": 1.3956043956
	},
	{
		"stop_id": 8595626,
		"ID": 579,
		"x": -37.3642512097,
		"y": 0.059211823,
		"h": 1.3956043956
	},
	{
		"stop_id": 8507406,
		"ID": 545,
		"x": -41.4272427877,
		"y": -4.893758354,
		"h": 2.2857142857
	},
	{
		"stop_id": 8507407,
		"ID": 545,
		"x": -41.9372773617,
		"y": -4.329777979,
		"h": 2.2857142857
	},
	{
		"stop_id": 8507408,
		"ID": 545,
		"x": -40.3762504127,
		"y": -3.716752296,
		"h": 2.2857142857
	},
	{
		"stop_id": 8507409,
		"ID": 545,
		"x": -43.4732274647,
		"y": -4.358807219,
		"h": 2.2857142857
	},
	{
		"stop_id": 8507410,
		"ID": 545,
		"x": -44.1902734857,
		"y": -4.273769763,
		"h": 2.2857142857
	},
	{
		"stop_id": 8507870,
		"ID": 545,
		"x": -42.5092256927,
		"y": -3.427758402,
		"h": 2.2857142857
	},
	{
		"stop_id": 8507871,
		"ID": 545,
		"x": -40.6042373707,
		"y": -4.910761226,
		"h": 2.2857142857
	},
	{
		"stop_id": 8571713,
		"ID": 545,
		"x": -43.8092471667,
		"y": -2.774783293,
		"h": 2.2857142857
	},
	{
		"stop_id": 8571714,
		"ID": 545,
		"x": -43.2942590577,
		"y": -2.357850463,
		"h": 2.2857142857
	},
	{
		"stop_id": 8571715,
		"ID": 545,
		"x": -42.5952331287,
		"y": -2.118776122,
		"h": 2.2857142857
	},
	{
		"stop_id": 8571716,
		"ID": 545,
		"x": -41.6822606207,
		"y": -2.084753706,
		"h": 2.2857142857
	},
	{
		"stop_id": 8571717,
		"ID": 545,
		"x": -41.2822324687,
		"y": -2.299761123,
		"h": 2.2857142857
	},
	{
		"stop_id": 8571718,
		"ID": 545,
		"x": -40.7922512987,
		"y": -2.15883135,
		"h": 2.2857142857
	},
	{
		"stop_id": 8571719,
		"ID": 545,
		"x": -40.2862993637,
		"y": -1.956778238,
		"h": 2.2857142857
	},
	{
		"stop_id": 8571720,
		"ID": 545,
		"x": -39.8372836667,
		"y": -1.660822528,
		"h": 2.2857142857
	},
	{
		"stop_id": 8571721,
		"ID": 545,
		"x": -39.3332733567,
		"y": -1.695817483,
		"h": 2.2857142857
	},
	{
		"stop_id": 8576542,
		"ID": 545,
		"x": -40.2642311127,
		"y": -4.902777077,
		"h": 2.2857142857
	},
	{
		"stop_id": 8576543,
		"ID": 545,
		"x": -40.8112701507,
		"y": -4.875842754,
		"h": 2.2857142857
	},
	{
		"stop_id": 8576544,
		"ID": 545,
		"x": -40.7752758207,
		"y": -4.392815117,
		"h": 2.2857142857
	},
	{
		"stop_id": 8576545,
		"ID": 545,
		"x": -40.9602855637,
		"y": -3.452801936,
		"h": 2.2857142857
	},
	{
		"stop_id": 8576546,
		"ID": 545,
		"x": -41.3112509747,
		"y": -3.422760917,
		"h": 2.2857142857
	},
	{
		"stop_id": 8576547,
		"ID": 545,
		"x": -41.6652687247,
		"y": -3.468858728,
		"h": 2.2857142857
	},
	{
		"stop_id": 8576548,
		"ID": 545,
		"x": -41.9442708097,
		"y": -3.360857303,
		"h": 2.2857142857
	},
	{
		"stop_id": 8576549,
		"ID": 545,
		"x": -42.1552332807,
		"y": -3.397829944,
		"h": 2.2857142857
	},
	{
		"stop_id": 8576550,
		"ID": 545,
		"x": -42.3102544817,
		"y": -3.416846358,
		"h": 2.2857142857
	},
	{
		"stop_id": 8576551,
		"ID": 545,
		"x": -42.6812979657,
		"y": -3.495839182,
		"h": 2.2857142857
	},
	{
		"stop_id": 8576552,
		"ID": 545,
		"x": -42.8952547577,
		"y": -3.639849103,
		"h": 2.2857142857
	},
	{
		"stop_id": 8576553,
		"ID": 545,
		"x": -43.1272579147,
		"y": -3.919859739,
		"h": 2.2857142857
	},
	{
		"stop_id": 8576554,
		"ID": 545,
		"x": -44.6342605837,
		"y": -3.570762673,
		"h": 2.2857142857
	},
	{
		"stop_id": 8576560,
		"ID": 545,
		"x": -41.0772925787,
		"y": -5.110794173,
		"h": 2.2857142857
	},
	{
		"stop_id": 8576561,
		"ID": 545,
		"x": -41.5742569677,
		"y": -4.514787693,
		"h": 2.2857142857
	},
	{
		"stop_id": 8576562,
		"ID": 545,
		"x": -42.4422924807,
		"y": -4.441752711,
		"h": 2.2857142857
	},
	{
		"stop_id": 8576563,
		"ID": 545,
		"x": -42.7412821577,
		"y": -4.625809992,
		"h": 2.2857142857
	},
	{
		"stop_id": 8576564,
		"ID": 545,
		"x": -42.8842530197,
		"y": -4.539834784,
		"h": 2.2857142857
	},
	{
		"stop_id": 8576565,
		"ID": 545,
		"x": -42.8312893117,
		"y": -4.245757911,
		"h": 2.2857142857
	},
	{
		"stop_id": 8580397,
		"ID": 545,
		"x": -42.0472363307,
		"y": -1.988789008,
		"h": 2.2857142857
	},
	{
		"stop_id": 8590400,
		"ID": 545,
		"x": -43.0242835587,
		"y": -5.89580702,
		"h": 2.2857142857
	},
	{
		"stop_id": 8595167,
		"ID": 545,
		"x": -38.9732953577,
		"y": -2.989807946,
		"h": 2.2857142857
	},
	{
		"stop_id": 8595478,
		"ID": 545,
		"x": -43.4132300537,
		"y": -5.379833297,
		"h": 2.2857142857
	},
	{
		"stop_id": 8595479,
		"ID": 545,
		"x": -43.8422903527,
		"y": -5.012794168,
		"h": 2.2857142857
	},
	{
		"stop_id": 8507454,
		"ID": 640,
		"x": -24.8562291237,
		"y": -27.374762938,
		"h": 1
	},
	{
		"stop_id": 8507457,
		"ID": 607,
		"x": -29.3282391607,
		"y": -26.27375821,
		"h": 1
	},
	{
		"stop_id": 8507461,
		"ID": 541,
		"x": -42.6222728567,
		"y": -27.65781196,
		"h": 1.2637362637
	},
	{
		"stop_id": 8507462,
		"ID": 541,
		"x": -42.1962268487,
		"y": -28.306799414,
		"h": 1.2637362637
	},
	{
		"stop_id": 8507476,
		"ID": 541,
		"x": -41.5702314617,
		"y": -29.467856198,
		"h": 1.2637362637
	},
	{
		"stop_id": 8507506,
		"ID": 541,
		"x": -42.7152307137,
		"y": -26.326749532,
		"h": 1.2637362637
	},
	{
		"stop_id": 8507507,
		"ID": 541,
		"x": -42.1272926627,
		"y": -28.875768906,
		"h": 1.2637362637
	},
	{
		"stop_id": 8507586,
		"ID": 541,
		"x": -42.8972880587,
		"y": -25.746750591,
		"h": 1.2637362637
	},
	{
		"stop_id": 8507588,
		"ID": 541,
		"x": -43.0112523297,
		"y": -25.323857883,
		"h": 1.2637362637
	},
	{
		"stop_id": 8576367,
		"ID": 541,
		"x": -43.3332942807,
		"y": -24.413845978,
		"h": 1.2637362637
	},
	{
		"stop_id": 8576368,
		"ID": 541,
		"x": -43.2282951427,
		"y": -24.712819104,
		"h": 1.2637362637
	},
	{
		"stop_id": 8507469,
		"ID": 508,
		"x": -43.4192970597,
		"y": -23.708840529,
		"h": 1.3956043956
	},
	{
		"stop_id": 8507502,
		"ID": 508,
		"x": -43.8732479787,
		"y": -22.854848895,
		"h": 1.3956043956
	},
	{
		"stop_id": 8507587,
		"ID": 508,
		"x": -43.7152861237,
		"y": -23.145798375,
		"h": 1.3956043956
	},
	{
		"stop_id": 8507855,
		"ID": 508,
		"x": -45.7022603707,
		"y": -25.265792361,
		"h": 1.3956043956
	},
	{
		"stop_id": 8507859,
		"ID": 508,
		"x": -45.4952767827,
		"y": -24.863775941,
		"h": 1.3956043956
	},
	{
		"stop_id": 8507997,
		"ID": 508,
		"x": -44.8202367277,
		"y": -23.869765834,
		"h": 1.3956043956
	},
	{
		"stop_id": 8576312,
		"ID": 508,
		"x": -46.4542940757,
		"y": -26.22185296,
		"h": 1.3956043956
	},
	{
		"stop_id": 8576313,
		"ID": 508,
		"x": -46.0922289857,
		"y": -25.935794191,
		"h": 1.3956043956
	},
	{
		"stop_id": 8576315,
		"ID": 508,
		"x": -44.2402701057,
		"y": -23.305803624,
		"h": 1.3956043956
	},
	{
		"stop_id": 8576316,
		"ID": 508,
		"x": -43.9852644797,
		"y": -23.013776631,
		"h": 1.3956043956
	},
	{
		"stop_id": 8576366,
		"ID": 508,
		"x": -43.8292546937,
		"y": -22.971791177,
		"h": 1.3956043956
	},
	{
		"stop_id": 8588423,
		"ID": 508,
		"x": -44.7332859637,
		"y": -23.571847274,
		"h": 1.3956043956
	},
	{
		"stop_id": 8588424,
		"ID": 508,
		"x": -46.7822456997,
		"y": -26.589857244,
		"h": 1.3956043956
	},
	{
		"stop_id": 8507478,
		"ID": 542,
		"x": -43.4212277167,
		"y": -22.824851435,
		"h": 1.6263736264
	},
	{
		"stop_id": 8507480,
		"ID": 542,
		"x": -40.4862414347,
		"y": -18.763840975,
		"h": 1.6263736264
	},
	{
		"stop_id": 8507503,
		"ID": 542,
		"x": -43.6122251507,
		"y": -22.562790076,
		"h": 1.6263736264
	},
	{
		"stop_id": 8507504,
		"ID": 542,
		"x": -41.2352339607,
		"y": -19.575814199,
		"h": 1.6263736264
	},
	{
		"stop_id": 8507766,
		"ID": 542,
		"x": -39.8882649307,
		"y": -19.569749625,
		"h": 1.6263736264
	},
	{
		"stop_id": 8571330,
		"ID": 542,
		"x": -40.4752417747,
		"y": -18.730789293,
		"h": 1.6263736264
	},
	{
		"stop_id": 8571331,
		"ID": 542,
		"x": -40.1692597077,
		"y": -18.734805858,
		"h": 1.6263736264
	},
	{
		"stop_id": 8571332,
		"ID": 542,
		"x": -39.8622559897,
		"y": -19.930844583,
		"h": 1.6263736264
	},
	{
		"stop_id": 8571333,
		"ID": 542,
		"x": -39.7352283437,
		"y": -20.813754776,
		"h": 1.6263736264
	},
	{
		"stop_id": 8576318,
		"ID": 542,
		"x": -43.4522632527,
		"y": -22.797810703,
		"h": 1.6263736264
	},
	{
		"stop_id": 8576363,
		"ID": 542,
		"x": -41.7642728497,
		"y": -20.124799287,
		"h": 1.6263736264
	},
	{
		"stop_id": 8576364,
		"ID": 542,
		"x": -43.0112753337,
		"y": -21.52775117,
		"h": 1.6263736264
	},
	{
		"stop_id": 8583254,
		"ID": 542,
		"x": -39.9362495057,
		"y": -19.279762294,
		"h": 1.6263736264
	},
	{
		"stop_id": 8583255,
		"ID": 542,
		"x": -39.8082677087,
		"y": -20.226814377,
		"h": 1.6263736264
	},
	{
		"stop_id": 8583256,
		"ID": 542,
		"x": -39.0642420667,
		"y": -21.772859707,
		"h": 1.6263736264
	},
	{
		"stop_id": 8587239,
		"ID": 542,
		"x": -42.6002588857,
		"y": -20.721752055,
		"h": 1.6263736264
	},
	{
		"stop_id": 8588707,
		"ID": 542,
		"x": -42.1402355987,
		"y": -20.445845756,
		"h": 1.6263736264
	},
	{
		"stop_id": 8594999,
		"ID": 542,
		"x": -43.4462438007,
		"y": -22.188825262,
		"h": 1.6263736264
	},
	{
		"stop_id": 8595144,
		"ID": 542,
		"x": -43.0672504077,
		"y": -22.899810355,
		"h": 1.6263736264
	},
	{
		"stop_id": 8595145,
		"ID": 542,
		"x": -43.2622413627,
		"y": -22.444786349,
		"h": 1.6263736264
	},
	{
		"stop_id": 8507500,
		"ID": 604,
		"x": -33.6612389747,
		"y": -43.5737673,
		"h": 1.2637362637
	},
	{
		"stop_id": 8507753,
		"ID": 604,
		"x": -30.4612721367,
		"y": -41.589800275,
		"h": 1.2637362637
	},
	{
		"stop_id": 8507761,
		"ID": 604,
		"x": -34.2382715327,
		"y": -43.935851336,
		"h": 1.2637362637
	},
	{
		"stop_id": 8507763,
		"ID": 604,
		"x": -31.3782531427,
		"y": -42.222820228,
		"h": 1.2637362637
	},
	{
		"stop_id": 8507771,
		"ID": 604,
		"x": -33.6442513347,
		"y": -43.571804169,
		"h": 1.2637362637
	},
	{
		"stop_id": 8571019,
		"ID": 604,
		"x": -33.2142767177,
		"y": -43.500787393,
		"h": 1.2637362637
	},
	{
		"stop_id": 8579581,
		"ID": 604,
		"x": -32.9272859237,
		"y": -43.236835432,
		"h": 1.2637362637
	},
	{
		"stop_id": 8580755,
		"ID": 604,
		"x": -30.7312576277,
		"y": -41.657802487,
		"h": 1.2637362637
	},
	{
		"stop_id": 8581729,
		"ID": 604,
		"x": -34.0282792867,
		"y": -43.815791851,
		"h": 1.2637362637
	},
	{
		"stop_id": 8507600,
		"ID": 442,
		"x": -57.7842613547,
		"y": -37.506815569,
		"h": 1.2307692308
	},
	{
		"stop_id": 8507601,
		"ID": 442,
		"x": -58.3342378437,
		"y": -37.276850604,
		"h": 1.2307692308
	},
	{
		"stop_id": 8507602,
		"ID": 442,
		"x": -57.3532775867,
		"y": -37.869842076,
		"h": 1.2307692308
	},
	{
		"stop_id": 8507604,
		"ID": 442,
		"x": -58.3552648107,
		"y": -37.732855108,
		"h": 1.2307692308
	},
	{
		"stop_id": 8507605,
		"ID": 442,
		"x": -58.7452941137,
		"y": -36.956771812,
		"h": 1.2307692308
	},
	{
		"stop_id": 8507606,
		"ID": 442,
		"x": -57.9242369997,
		"y": -37.780768961,
		"h": 1.2307692308
	},
	{
		"stop_id": 8530311,
		"ID": 442,
		"x": -53.6412733517,
		"y": -35.848841572,
		"h": 1.2307692308
	},
	{
		"stop_id": 8530315,
		"ID": 442,
		"x": -55.3792271767,
		"y": -37.9017753,
		"h": 1.2307692308
	},
	{
		"stop_id": 8507607,
		"ID": 410,
		"x": -59.8122671947,
		"y": -41.269829323,
		"h": 1.1318681319
	},
	{
		"stop_id": 8507609,
		"ID": 410,
		"x": -59.5172343777,
		"y": -43.81284327,
		"h": 1.1318681319
	},
	{
		"stop_id": 8507610,
		"ID": 410,
		"x": -59.4852833907,
		"y": -42.433838631,
		"h": 1.1318681319
	},
	{
		"stop_id": 8591771,
		"ID": 410,
		"x": -59.7442424927,
		"y": -42.037759546,
		"h": 1.1318681319
	},
	{
		"stop_id": 8591773,
		"ID": 410,
		"x": -59.2612866657,
		"y": -42.691841924,
		"h": 1.1318681319
	},
	{
		"stop_id": 8507612,
		"ID": 441,
		"x": -57.4782317337,
		"y": -40.542856597,
		"h": 1.2637362637
	},
	{
		"stop_id": 8507614,
		"ID": 441,
		"x": -58.3282872917,
		"y": -39.1587656,
		"h": 1.2637362637
	},
	{
		"stop_id": 8507617,
		"ID": 441,
		"x": -58.0852636347,
		"y": -39.568795033,
		"h": 1.2637362637
	},
	{
		"stop_id": 8507618,
		"ID": 441,
		"x": -57.8702754067,
		"y": -39.927798256,
		"h": 1.2637362637
	},
	{
		"stop_id": 8507619,
		"ID": 441,
		"x": -56.8502615667,
		"y": -40.827845328,
		"h": 1.2637362637
	},
	{
		"stop_id": 8507620,
		"ID": 441,
		"x": -57.2292689827,
		"y": -40.721848015,
		"h": 1.2637362637
	},
	{
		"stop_id": 8530277,
		"ID": 441,
		"x": -58.3282872917,
		"y": -39.1587656,
		"h": 1.2637362637
	},
	{
		"stop_id": 8530757,
		"ID": 441,
		"x": -55.4562618367,
		"y": -38.92977482,
		"h": 1.2637362637
	},
	{
		"stop_id": 8589240,
		"ID": 441,
		"x": -57.5862369387,
		"y": -40.293773714,
		"h": 1.2637362637
	},
	{
		"stop_id": 8507654,
		"ID": 107,
		"x": -115.3952317627,
		"y": -7.366844696,
		"h": 1.5934065934
	},
	{
		"stop_id": 8507670,
		"ID": 107,
		"x": -116.4672896527,
		"y": -4.07875184,
		"h": 1.5934065934
	},
	{
		"stop_id": 8507674,
		"ID": 107,
		"x": -115.0002813187,
		"y": -5.270797003,
		"h": 1.5934065934
	},
	{
		"stop_id": 8507682,
		"ID": 107,
		"x": -116.1422332187,
		"y": -5.68982319,
		"h": 1.5934065934
	},
	{
		"stop_id": 8507688,
		"ID": 107,
		"x": -114.1012246957,
		"y": -4.779758765,
		"h": 1.5934065934
	},
	{
		"stop_id": 8507690,
		"ID": 107,
		"x": -115.7312621527,
		"y": -5.107804543,
		"h": 1.5934065934
	},
	{
		"stop_id": 8507696,
		"ID": 107,
		"x": -116.8632342767,
		"y": -8.635831701,
		"h": 1.5934065934
	},
	{
		"stop_id": 8507698,
		"ID": 107,
		"x": -117.5172246147,
		"y": -7.61977836,
		"h": 1.5934065934
	},
	{
		"stop_id": 8507954,
		"ID": 107,
		"x": -113.1142372277,
		"y": -6.432765366,
		"h": 1.5934065934
	},
	{
		"stop_id": 8507966,
		"ID": 107,
		"x": -118.5172556487,
		"y": -6.244843362,
		"h": 1.5934065934
	},
	{
		"stop_id": 8570304,
		"ID": 107,
		"x": -117.8422266237,
		"y": -6.619749196,
		"h": 1.5934065934
	},
	{
		"stop_id": 8570309,
		"ID": 107,
		"x": -116.3362402987,
		"y": -3.78683093,
		"h": 1.5934065934
	},
	{
		"stop_id": 8570310,
		"ID": 107,
		"x": -115.1172890207,
		"y": -5.444811483,
		"h": 1.5934065934
	},
	{
		"stop_id": 8570311,
		"ID": 107,
		"x": -114.5672702277,
		"y": -4.544823918,
		"h": 1.5934065934
	},
	{
		"stop_id": 8570316,
		"ID": 107,
		"x": -113.2602500637,
		"y": -6.229795743,
		"h": 1.5934065934
	},
	{
		"stop_id": 8570398,
		"ID": 107,
		"x": -115.3042830427,
		"y": -8.34978266,
		"h": 1.5934065934
	},
	{
		"stop_id": 8579735,
		"ID": 107,
		"x": -116.3942470607,
		"y": -6.30678376,
		"h": 1.5934065934
	},
	{
		"stop_id": 8581610,
		"ID": 107,
		"x": -116.2002587117,
		"y": -8.649791218,
		"h": 1.5934065934
	},
	{
		"stop_id": 8583211,
		"ID": 107,
		"x": -116.8172552857,
		"y": -4.016835282,
		"h": 1.5934065934
	},
	{
		"stop_id": 8507660,
		"ID": 126,
		"x": -112.9662634927,
		"y": -7.000836523,
		"h": 1.5604395604
	},
	{
		"stop_id": 8507665,
		"ID": 126,
		"x": -113.3512291957,
		"y": -8.51978498,
		"h": 1.5604395604
	},
	{
		"stop_id": 8507960,
		"ID": 126,
		"x": -113.5782875467,
		"y": -11.356843712,
		"h": 1.5604395604
	},
	{
		"stop_id": 8507963,
		"ID": 126,
		"x": -112.0882981787,
		"y": -9.858791368,
		"h": 1.5604395604
	},
	{
		"stop_id": 8570317,
		"ID": 126,
		"x": -112.2282780697,
		"y": -9.433781142,
		"h": 1.5604395604
	},
	{
		"stop_id": 8570352,
		"ID": 126,
		"x": -112.5712414917,
		"y": -10.297789625,
		"h": 1.5604395604
	},
	{
		"stop_id": 8570353,
		"ID": 126,
		"x": -112.3182779317,
		"y": -10.085789106,
		"h": 1.5604395604
	},
	{
		"stop_id": 8570354,
		"ID": 126,
		"x": -110.2212530607,
		"y": -11.071799852,
		"h": 1.5604395604
	},
	{
		"stop_id": 8570355,
		"ID": 126,
		"x": -111.7162770797,
		"y": -10.102828899,
		"h": 1.5604395604
	},
	{
		"stop_id": 8570364,
		"ID": 126,
		"x": -108.6582939367,
		"y": -9.131836152,
		"h": 1.5604395604
	},
	{
		"stop_id": 8570370,
		"ID": 126,
		"x": -109.8172270117,
		"y": -7.919828559,
		"h": 1.5604395604
	},
	{
		"stop_id": 8570371,
		"ID": 126,
		"x": -111.3602523237,
		"y": -9.100810566,
		"h": 1.5604395604
	},
	{
		"stop_id": 8570372,
		"ID": 126,
		"x": -111.6452692557,
		"y": -9.419853442,
		"h": 1.5604395604
	},
	{
		"stop_id": 8570397,
		"ID": 126,
		"x": -114.5352961477,
		"y": -9.024790208,
		"h": 1.5604395604
	},
	{
		"stop_id": 8581437,
		"ID": 126,
		"x": -109.5392376227,
		"y": -10.631826677,
		"h": 1.5604395604
	},
	{
		"stop_id": 8581512,
		"ID": 126,
		"x": -113.5062343307,
		"y": -11.144820249,
		"h": 1.5604395604
	},
	{
		"stop_id": 8581514,
		"ID": 126,
		"x": -111.1162465257,
		"y": -10.447856978,
		"h": 1.5604395604
	},
	{
		"stop_id": 8581943,
		"ID": 126,
		"x": -111.8522248827,
		"y": -9.623833625,
		"h": 1.5604395604
	},
	{
		"stop_id": 8507691,
		"ID": 110,
		"x": -113.9652701697,
		"y": 10.024142073,
		"h": 1.1648351648
	},
	{
		"stop_id": 8507955,
		"ID": 110,
		"x": -114.1902417327,
		"y": 10.798183856,
		"h": 1.1648351648
	},
	{
		"stop_id": 8570284,
		"ID": 110,
		"x": -114.2252534927,
		"y": 10.486215016,
		"h": 1.1648351648
	},
	{
		"stop_id": 8570285,
		"ID": 110,
		"x": -113.9202428317,
		"y": 10.861207975,
		"h": 1.1648351648
	},
	{
		"stop_id": 8570286,
		"ID": 110,
		"x": -113.8472979457,
		"y": 11.097236037,
		"h": 1.1648351648
	},
	{
		"stop_id": 8570287,
		"ID": 110,
		"x": -114.0222363097,
		"y": 11.010218967,
		"h": 1.1648351648
	},
	{
		"stop_id": 8507711,
		"ID": 444,
		"x": -54.8192571357,
		"y": -21.751769131,
		"h": 1.2637362637
	},
	{
		"stop_id": 8507720,
		"ID": 444,
		"x": -54.6082796207,
		"y": -21.328830613,
		"h": 1.2637362637
	},
	{
		"stop_id": 8507723,
		"ID": 444,
		"x": -55.3582265397,
		"y": -23.055823516,
		"h": 1.2637362637
	},
	{
		"stop_id": 8507756,
		"ID": 444,
		"x": -56.3432451477,
		"y": -25.113796089,
		"h": 1.2637362637
	},
	{
		"stop_id": 8571639,
		"ID": 444,
		"x": -55.2322415067,
		"y": -22.412859089,
		"h": 1.2637362637
	},
	{
		"stop_id": 8571640,
		"ID": 444,
		"x": -55.6652959857,
		"y": -23.800847566,
		"h": 1.2637362637
	},
	{
		"stop_id": 8571641,
		"ID": 444,
		"x": -56.2122467467,
		"y": -24.664834632,
		"h": 1.2637362637
	},
	{
		"stop_id": 8581017,
		"ID": 444,
		"x": -55.9912473327,
		"y": -24.256835977,
		"h": 1.2637362637
	},
	{
		"stop_id": 8581018,
		"ID": 444,
		"x": -55.8682355247,
		"y": -23.976843792,
		"h": 1.2637362637
	},
	{
		"stop_id": 8507716,
		"ID": 419,
		"x": -62.3982449957,
		"y": 8.77614529,
		"h": 1.3296703297
	},
	{
		"stop_id": 8571419,
		"ID": 419,
		"x": -61.3432839027,
		"y": 9.873221449,
		"h": 1.3296703297
	},
	{
		"stop_id": 8571420,
		"ID": 419,
		"x": -60.8162320537,
		"y": 9.341151202,
		"h": 1.3296703297
	},
	{
		"stop_id": 8571421,
		"ID": 419,
		"x": -61.0162972097,
		"y": 9.164211212,
		"h": 1.3296703297
	},
	{
		"stop_id": 8571423,
		"ID": 419,
		"x": -60.0192921577,
		"y": 8.727174172,
		"h": 1.3296703297
	},
	{
		"stop_id": 8571424,
		"ID": 419,
		"x": -58.8372261037,
		"y": 8.096225104,
		"h": 1.3296703297
	},
	{
		"stop_id": 8579867,
		"ID": 419,
		"x": -61.3842875167,
		"y": 9.88724043,
		"h": 1.3296703297
	},
	{
		"stop_id": 8579868,
		"ID": 419,
		"x": -61.6052887157,
		"y": 9.785143136,
		"h": 1.3296703297
	},
	{
		"stop_id": 8581385,
		"ID": 419,
		"x": -62.0452669397,
		"y": 9.936158849,
		"h": 1.3296703297
	},
	{
		"stop_id": 8581386,
		"ID": 419,
		"x": -63.0812909267,
		"y": 10.034156139,
		"h": 1.3296703297
	},
	{
		"stop_id": 8581387,
		"ID": 419,
		"x": -62.6352653767,
		"y": 10.00223485,
		"h": 1.3296703297
	},
	{
		"stop_id": 8507721,
		"ID": 476,
		"x": -50.3932714297,
		"y": -18.032833873,
		"h": 1.2307692308
	},
	{
		"stop_id": 8507724,
		"ID": 476,
		"x": -51.5812449717,
		"y": -19.217806194,
		"h": 1.2307692308
	},
	{
		"stop_id": 8507725,
		"ID": 476,
		"x": -53.8802480957,
		"y": -20.835818423,
		"h": 1.2307692308
	},
	{
		"stop_id": 8507780,
		"ID": 476,
		"x": -52.4662782267,
		"y": -20.179853879,
		"h": 1.2307692308
	},
	{
		"stop_id": 8571637,
		"ID": 476,
		"x": -51.0432312487,
		"y": -18.485805387,
		"h": 1.2307692308
	},
	{
		"stop_id": 8581865,
		"ID": 476,
		"x": -52.5652516057,
		"y": -20.763816415,
		"h": 1.2307692308
	},
	{
		"stop_id": 8582971,
		"ID": 476,
		"x": -52.1792623997,
		"y": -20.28177564,
		"h": 1.2307692308
	},
	{
		"stop_id": 8583546,
		"ID": 476,
		"x": -52.1252279667,
		"y": -20.424778866,
		"h": 1.2307692308
	},
	{
		"stop_id": 8507726,
		"ID": 417,
		"x": -59.3072932837,
		"y": -1.698771576,
		"h": 1.1648351648
	},
	{
		"stop_id": 8507758,
		"ID": 417,
		"x": -59.4032767107,
		"y": -3.718806374,
		"h": 1.1648351648
	},
	{
		"stop_id": 8507783,
		"ID": 417,
		"x": -62.2562848347,
		"y": -1.441759624,
		"h": 1.1648351648
	},
	{
		"stop_id": 8571432,
		"ID": 417,
		"x": -59.6512615347,
		"y": -2.351782567,
		"h": 1.1648351648
	},
	{
		"stop_id": 8571696,
		"ID": 417,
		"x": -62.9142284947,
		"y": -1.946808645,
		"h": 1.1648351648
	},
	{
		"stop_id": 8589276,
		"ID": 417,
		"x": -63.7802611597,
		"y": -5.229837283,
		"h": 1.1648351648
	},
	{
		"stop_id": 8507728,
		"ID": 418,
		"x": -58.9542815667,
		"y": 3.159199969,
		"h": 1.5604395604
	},
	{
		"stop_id": 8507731,
		"ID": 418,
		"x": -60.2982285617,
		"y": 2.332207834,
		"h": 1.5604395604
	},
	{
		"stop_id": 8507732,
		"ID": 418,
		"x": -62.5752825197,
		"y": 4.818165466,
		"h": 1.5604395604
	},
	{
		"stop_id": 8507736,
		"ID": 418,
		"x": -64.4132344587,
		"y": 1.77321016,
		"h": 1.5604395604
	},
	{
		"stop_id": 8507740,
		"ID": 418,
		"x": -61.0602763757,
		"y": 1.973151264,
		"h": 1.5604395604
	},
	{
		"stop_id": 8507742,
		"ID": 418,
		"x": -62.4732874357,
		"y": 0.09323522,
		"h": 1.5604395604
	},
	{
		"stop_id": 8507744,
		"ID": 418,
		"x": -60.8422739637,
		"y": 4.819242268,
		"h": 1.5604395604
	},
	{
		"stop_id": 8507795,
		"ID": 418,
		"x": -59.7142339637,
		"y": 3.019196148,
		"h": 1.5604395604
	},
	{
		"stop_id": 8571403,
		"ID": 418,
		"x": -59.5372719287,
		"y": 3.035205724,
		"h": 1.5604395604
	},
	{
		"stop_id": 8571648,
		"ID": 418,
		"x": -59.5672778427,
		"y": 3.981249751,
		"h": 1.5604395604
	},
	{
		"stop_id": 8571649,
		"ID": 418,
		"x": -61.9852993257,
		"y": 4.768215545,
		"h": 1.5604395604
	},
	{
		"stop_id": 8571650,
		"ID": 418,
		"x": -62.5032463407,
		"y": 4.541209539,
		"h": 1.5604395604
	},
	{
		"stop_id": 8571693,
		"ID": 418,
		"x": -63.9992784067,
		"y": 1.092212672,
		"h": 1.5604395604
	},
	{
		"stop_id": 8571697,
		"ID": 418,
		"x": -62.1842878437,
		"y": -0.390807917,
		"h": 1.5604395604
	},
	{
		"stop_id": 8571698,
		"ID": 418,
		"x": -62.0582370437,
		"y": 1.501223181,
		"h": 1.5604395604
	},
	{
		"stop_id": 8571700,
		"ID": 418,
		"x": -60.7872745067,
		"y": 1.941188742,
		"h": 1.5604395604
	},
	{
		"stop_id": 8571702,
		"ID": 418,
		"x": -59.3682906977,
		"y": 2.404219606,
		"h": 1.5604395604
	},
	{
		"stop_id": 8582070,
		"ID": 418,
		"x": -58.6072409877,
		"y": 2.346165297,
		"h": 1.5604395604
	},
	{
		"stop_id": 8507733,
		"ID": 388,
		"x": -63.9122687587,
		"y": -2.048792708,
		"h": 1.6593406593
	},
	{
		"stop_id": 8507747,
		"ID": 388,
		"x": -63.8072760077,
		"y": -0.091753378,
		"h": 1.6593406593
	},
	{
		"stop_id": 8507757,
		"ID": 388,
		"x": -68.0812950627,
		"y": -3.006768448,
		"h": 1.6593406593
	},
	{
		"stop_id": 8507781,
		"ID": 388,
		"x": -64.4132866977,
		"y": -1.857763838,
		"h": 1.6593406593
	},
	{
		"stop_id": 8571666,
		"ID": 388,
		"x": -67.6722763257,
		"y": 1.767231514,
		"h": 1.6593406593
	},
	{
		"stop_id": 8571667,
		"ID": 388,
		"x": -68.2842639877,
		"y": 1.020251273,
		"h": 1.6593406593
	},
	{
		"stop_id": 8571668,
		"ID": 388,
		"x": -68.6122994997,
		"y": -0.578756644,
		"h": 1.6593406593
	},
	{
		"stop_id": 8571669,
		"ID": 388,
		"x": -68.7992844847,
		"y": -1.172779268,
		"h": 1.6593406593
	},
	{
		"stop_id": 8571671,
		"ID": 388,
		"x": -68.1542375207,
		"y": -2.40880463,
		"h": 1.6593406593
	},
	{
		"stop_id": 8571672,
		"ID": 388,
		"x": -67.3472994287,
		"y": -3.129816617,
		"h": 1.6593406593
	},
	{
		"stop_id": 8571674,
		"ID": 388,
		"x": -65.8182738317,
		"y": 1.293240891,
		"h": 1.6593406593
	},
	{
		"stop_id": 8571675,
		"ID": 388,
		"x": -66.0872711087,
		"y": 0.720228311,
		"h": 1.6593406593
	},
	{
		"stop_id": 8571676,
		"ID": 388,
		"x": -65.8442905727,
		"y": -0.174820206,
		"h": 1.6593406593
	},
	{
		"stop_id": 8571677,
		"ID": 388,
		"x": -66.0722653767,
		"y": -0.80979535,
		"h": 1.6593406593
	},
	{
		"stop_id": 8571678,
		"ID": 388,
		"x": -66.2373000287,
		"y": -2.014788944,
		"h": 1.6593406593
	},
	{
		"stop_id": 8571679,
		"ID": 388,
		"x": -66.2082771817,
		"y": -2.573772893,
		"h": 1.6593406593
	},
	{
		"stop_id": 8571694,
		"ID": 388,
		"x": -63.8972485667,
		"y": 0.294174157,
		"h": 1.6593406593
	},
	{
		"stop_id": 8571695,
		"ID": 388,
		"x": -64.3142315007,
		"y": -0.970832232,
		"h": 1.6593406593
	},
	{
		"stop_id": 8580594,
		"ID": 388,
		"x": -66.3502923947,
		"y": -3.004836212,
		"h": 1.6593406593
	},
	{
		"stop_id": 8581382,
		"ID": 388,
		"x": -64.6542261527,
		"y": -2.115811178,
		"h": 1.6593406593
	},
	{
		"stop_id": 8582069,
		"ID": 388,
		"x": -68.6222734457,
		"y": 0.206217045,
		"h": 1.6593406593
	},
	{
		"stop_id": 8507755,
		"ID": 574,
		"x": -34.9672317597,
		"y": -27.384781209,
		"h": 1.0659340659
	},
	{
		"stop_id": 8571339,
		"ID": 574,
		"x": -35.3802475637,
		"y": -27.158794676,
		"h": 1.0659340659
	},
	{
		"stop_id": 8571340,
		"ID": 574,
		"x": -35.1752911197,
		"y": -27.503802398,
		"h": 1.0659340659
	},
	{
		"stop_id": 8507759,
		"ID": 644,
		"x": -27.1692332527,
		"y": -7.367804269,
		"h": 1.1978021978
	},
	{
		"stop_id": 8507948,
		"ID": 644,
		"x": -27.3152829167,
		"y": -7.048761676,
		"h": 1.1978021978
	},
	{
		"stop_id": 8571317,
		"ID": 644,
		"x": -27.2022680027,
		"y": -7.492825945,
		"h": 1.1978021978
	},
	{
		"stop_id": 8581526,
		"ID": 644,
		"x": -27.2472742137,
		"y": -8.259800806,
		"h": 1.1978021978
	},
	{
		"stop_id": 8581556,
		"ID": 644,
		"x": -27.2632825847,
		"y": -7.377762904,
		"h": 1.1978021978
	},
	{
		"stop_id": 8581748,
		"ID": 644,
		"x": -27.2742334097,
		"y": -7.727781593,
		"h": 1.1978021978
	},
	{
		"stop_id": 8595449,
		"ID": 644,
		"x": -23.9082651067,
		"y": -5.444791733,
		"h": 1.1978021978
	},
	{
		"stop_id": 8507760,
		"ID": 575,
		"x": -37.9362692947,
		"y": -22.732811061,
		"h": 1.2967032967
	},
	{
		"stop_id": 8530298,
		"ID": 575,
		"x": -37.9082388537,
		"y": -23.171817776,
		"h": 1.2967032967
	},
	{
		"stop_id": 8530299,
		"ID": 575,
		"x": -39.0672352157,
		"y": -23.827783862,
		"h": 1.2967032967
	},
	{
		"stop_id": 8571334,
		"ID": 575,
		"x": -38.4542730937,
		"y": -22.450854084,
		"h": 1.2967032967
	},
	{
		"stop_id": 8571335,
		"ID": 575,
		"x": -37.4592785907,
		"y": -23.807826793,
		"h": 1.2967032967
	},
	{
		"stop_id": 8571336,
		"ID": 575,
		"x": -37.0772545777,
		"y": -24.782778941,
		"h": 1.2967032967
	},
	{
		"stop_id": 8571337,
		"ID": 575,
		"x": -37.1062341287,
		"y": -25.456779398,
		"h": 1.2967032967
	},
	{
		"stop_id": 8571338,
		"ID": 575,
		"x": -36.7462534587,
		"y": -26.038819347,
		"h": 1.2967032967
	},
	{
		"stop_id": 8581019,
		"ID": 575,
		"x": -38.6692765897,
		"y": -22.285748856,
		"h": 1.2967032967
	},
	{
		"stop_id": 8582987,
		"ID": 575,
		"x": -37.8262783277,
		"y": -23.052794438,
		"h": 1.2967032967
	},
	{
		"stop_id": 8507768,
		"ID": 416,
		"x": -61.4332880727,
		"y": -8.73575912,
		"h": 1.1318681319
	},
	{
		"stop_id": 8507794,
		"ID": 416,
		"x": -59.5512378367,
		"y": -8.447760883,
		"h": 1.1318681319
	},
	{
		"stop_id": 8507978,
		"ID": 416,
		"x": -59.5342851527,
		"y": -7.540858637,
		"h": 1.1318681319
	},
	{
		"stop_id": 8577882,
		"ID": 416,
		"x": -64.1542600387,
		"y": -8.734785966,
		"h": 1.1318681319
	},
	{
		"stop_id": 8577883,
		"ID": 416,
		"x": -63.1832328447,
		"y": -9.667791954,
		"h": 1.1318681319
	},
	{
		"stop_id": 8507778,
		"ID": 392,
		"x": -65.3492859977,
		"y": 23.895204465,
		"h": 1.7582417582
	},
	{
		"stop_id": 8507779,
		"ID": 392,
		"x": -65.9932250897,
		"y": 19.660214498,
		"h": 1.7582417582
	},
	{
		"stop_id": 8507949,
		"ID": 392,
		"x": -64.5412464567,
		"y": 24.6402316,
		"h": 1.7582417582
	},
	{
		"stop_id": 8507976,
		"ID": 392,
		"x": -63.8322856837,
		"y": 21.508206765,
		"h": 1.7582417582
	},
	{
		"stop_id": 8507985,
		"ID": 392,
		"x": -67.4432753087,
		"y": 23.330145144,
		"h": 1.7582417582
	},
	{
		"stop_id": 8571346,
		"ID": 392,
		"x": -65.0762625767,
		"y": 19.561148957,
		"h": 1.7582417582
	},
	{
		"stop_id": 8571347,
		"ID": 392,
		"x": -67.2972523867,
		"y": 20.003146067,
		"h": 1.7582417582
	},
	{
		"stop_id": 8571364,
		"ID": 392,
		"x": -63.6892813897,
		"y": 21.486207891,
		"h": 1.7582417582
	},
	{
		"stop_id": 8571365,
		"ID": 392,
		"x": -64.6592652457,
		"y": 21.624237289,
		"h": 1.7582417582
	},
	{
		"stop_id": 8571366,
		"ID": 392,
		"x": -65.8262511507,
		"y": 22.10814603,
		"h": 1.7582417582
	},
	{
		"stop_id": 8571367,
		"ID": 392,
		"x": -66.5582364687,
		"y": 22.307165711,
		"h": 1.7582417582
	},
	{
		"stop_id": 8571368,
		"ID": 392,
		"x": -67.0932744237,
		"y": 22.120149876,
		"h": 1.7582417582
	},
	{
		"stop_id": 8571369,
		"ID": 392,
		"x": -68.0622980707,
		"y": 21.947228742,
		"h": 1.7582417582
	},
	{
		"stop_id": 8571376,
		"ID": 392,
		"x": -63.9762251137,
		"y": 23.499171876,
		"h": 1.7582417582
	},
	{
		"stop_id": 8571377,
		"ID": 392,
		"x": -64.9692798697,
		"y": 24.170227655,
		"h": 1.7582417582
	},
	{
		"stop_id": 8571378,
		"ID": 392,
		"x": -65.4512643447,
		"y": 23.891189119,
		"h": 1.7582417582
	},
	{
		"stop_id": 8571379,
		"ID": 392,
		"x": -65.7662694357,
		"y": 23.785222483,
		"h": 1.7582417582
	},
	{
		"stop_id": 8571380,
		"ID": 392,
		"x": -66.4122749257,
		"y": 25.194246573,
		"h": 1.7582417582
	},
	{
		"stop_id": 8580004,
		"ID": 392,
		"x": -63.6102795207,
		"y": 22.808208251,
		"h": 1.7582417582
	},
	{
		"stop_id": 8580046,
		"ID": 392,
		"x": -65.5022400957,
		"y": 20.286164384,
		"h": 1.7582417582
	},
	{
		"stop_id": 8580219,
		"ID": 392,
		"x": -65.8822333337,
		"y": 19.919238044,
		"h": 1.7582417582
	},
	{
		"stop_id": 8580399,
		"ID": 392,
		"x": -63.9652556537,
		"y": 21.3071918,
		"h": 1.7582417582
	},
	{
		"stop_id": 8580400,
		"ID": 392,
		"x": -64.9442345377,
		"y": 20.848172019,
		"h": 1.7582417582
	},
	{
		"stop_id": 8587328,
		"ID": 392,
		"x": -67.6422944387,
		"y": 21.969220355,
		"h": 1.7582417582
	},
	{
		"stop_id": 8507788,
		"ID": 447,
		"x": -58.6852653187,
		"y": -6.777838252,
		"h": 1.1978021978
	},
	{
		"stop_id": 8507891,
		"ID": 447,
		"x": -53.4932889307,
		"y": -5.879838096,
		"h": 1.1978021978
	},
	{
		"stop_id": 8571433,
		"ID": 447,
		"x": -58.3942620937,
		"y": -5.776832347,
		"h": 1.1978021978
	},
	{
		"stop_id": 8571434,
		"ID": 447,
		"x": -59.0352449667,
		"y": -6.919846201,
		"h": 1.1978021978
	},
	{
		"stop_id": 8576801,
		"ID": 447,
		"x": -53.4212856727,
		"y": -5.891769523,
		"h": 1.1978021978
	},
	{
		"stop_id": 8576818,
		"ID": 447,
		"x": -53.3612861077,
		"y": -6.188857257,
		"h": 1.1978021978
	},
	{
		"stop_id": 8594301,
		"ID": 447,
		"x": -53.4412347677,
		"y": -5.962826306,
		"h": 1.1978021978
	},
	{
		"stop_id": 8507850,
		"ID": 507,
		"x": -47.9422926697,
		"y": -29.819820217,
		"h": 1.3626373626
	},
	{
		"stop_id": 8507852,
		"ID": 507,
		"x": -48.5322734857,
		"y": -31.42984237,
		"h": 1.3626373626
	},
	{
		"stop_id": 8507856,
		"ID": 507,
		"x": -47.1662527287,
		"y": -27.164840061,
		"h": 1.3626373626
	},
	{
		"stop_id": 8507999,
		"ID": 507,
		"x": -46.8712404587,
		"y": -29.455792104,
		"h": 1.3626373626
	},
	{
		"stop_id": 8530304,
		"ID": 507,
		"x": -46.8652304287,
		"y": -29.467785219,
		"h": 1.3626373626
	},
	{
		"stop_id": 8530305,
		"ID": 507,
		"x": -45.6342583667,
		"y": -30.19284143,
		"h": 1.3626373626
	},
	{
		"stop_id": 8576309,
		"ID": 507,
		"x": -48.1872900337,
		"y": -30.421810544,
		"h": 1.3626373626
	},
	{
		"stop_id": 8576310,
		"ID": 507,
		"x": -47.9642992767,
		"y": -29.590750495,
		"h": 1.3626373626
	},
	{
		"stop_id": 8576311,
		"ID": 507,
		"x": -47.4612371617,
		"y": -28.290778193,
		"h": 1.3626373626
	},
	{
		"stop_id": 8576314,
		"ID": 507,
		"x": -47.9492251367,
		"y": -29.254778239,
		"h": 1.3626373626
	},
	{
		"stop_id": 8588422,
		"ID": 507,
		"x": -47.6292464417,
		"y": -28.742783597,
		"h": 1.3626373626
	},
	{
		"stop_id": 8594920,
		"ID": 507,
		"x": -48.2822492797,
		"y": -30.929795884,
		"h": 1.3626373626
	},
	{
		"stop_id": 8507851,
		"ID": 474,
		"x": -50.4022938437,
		"y": -33.409759019,
		"h": 2.0549450549
	},
	{
		"stop_id": 8507853,
		"ID": 474,
		"x": -49.9722971957,
		"y": -33.779818547,
		"h": 2.0549450549
	},
	{
		"stop_id": 8507858,
		"ID": 474,
		"x": -50.5162931447,
		"y": -34.729801227,
		"h": 2.0549450549
	},
	{
		"stop_id": 8507996,
		"ID": 474,
		"x": -49.3532694647,
		"y": -32.141765425,
		"h": 2.0549450549
	},
	{
		"stop_id": 8507998,
		"ID": 474,
		"x": -49.1812596057,
		"y": -32.578793476,
		"h": 2.0549450549
	},
	{
		"stop_id": 8530308,
		"ID": 474,
		"x": -50.6822757007,
		"y": -33.77980888,
		"h": 2.0549450549
	},
	{
		"stop_id": 8530309,
		"ID": 474,
		"x": -50.3912420187,
		"y": -34.054835365,
		"h": 2.0549450549
	},
	{
		"stop_id": 8576305,
		"ID": 474,
		"x": -50.2762600307,
		"y": -33.734833903,
		"h": 2.0549450549
	},
	{
		"stop_id": 8576306,
		"ID": 474,
		"x": -50.4222546677,
		"y": -33.959836599,
		"h": 2.0549450549
	},
	{
		"stop_id": 8576307,
		"ID": 474,
		"x": -49.5372905927,
		"y": -33.080760111,
		"h": 2.0549450549
	},
	{
		"stop_id": 8576308,
		"ID": 474,
		"x": -48.7112304907,
		"y": -32.15875045,
		"h": 2.0549450549
	},
	{
		"stop_id": 8576319,
		"ID": 474,
		"x": -49.4332488687,
		"y": -32.278858008,
		"h": 2.0549450549
	},
	{
		"stop_id": 8576320,
		"ID": 474,
		"x": -49.5942554577,
		"y": -32.529808098,
		"h": 2.0549450549
	},
	{
		"stop_id": 8576321,
		"ID": 474,
		"x": -49.8492557917,
		"y": -32.863837448,
		"h": 2.0549450549
	},
	{
		"stop_id": 8576322,
		"ID": 474,
		"x": -49.9332936337,
		"y": -32.972805057,
		"h": 2.0549450549
	},
	{
		"stop_id": 8576323,
		"ID": 474,
		"x": -49.9762380917,
		"y": -33.096823949,
		"h": 2.0549450549
	},
	{
		"stop_id": 8576324,
		"ID": 474,
		"x": -50.1462574017,
		"y": -33.259841714,
		"h": 2.0549450549
	},
	{
		"stop_id": 8576325,
		"ID": 474,
		"x": -50.1172839827,
		"y": -34.052850522,
		"h": 2.0549450549
	},
	{
		"stop_id": 8576326,
		"ID": 474,
		"x": -50.2842974907,
		"y": -34.439857957,
		"h": 2.0549450549
	},
	{
		"stop_id": 8576327,
		"ID": 474,
		"x": -50.3152521597,
		"y": -34.779850141,
		"h": 2.0549450549
	},
	{
		"stop_id": 8576328,
		"ID": 474,
		"x": -50.2462564517,
		"y": -35.342795565,
		"h": 2.0549450549
	},
	{
		"stop_id": 8588698,
		"ID": 474,
		"x": -50.4482731027,
		"y": -35.169801447,
		"h": 2.0549450549
	},
	{
		"stop_id": 8592309,
		"ID": 474,
		"x": -50.7552735727,
		"y": -33.792812632,
		"h": 2.0549450549
	},
	{
		"stop_id": 8592310,
		"ID": 474,
		"x": -52.0342768667,
		"y": -34.99482417,
		"h": 2.0549450549
	},
	{
		"stop_id": 8592311,
		"ID": 474,
		"x": -52.6662780257,
		"y": -33.955751286,
		"h": 2.0549450549
	},
	{
		"stop_id": 8592312,
		"ID": 474,
		"x": -51.0012850077,
		"y": -34.105769264,
		"h": 2.0549450549
	},
	{
		"stop_id": 8592313,
		"ID": 474,
		"x": -51.9462261537,
		"y": -34.310822157,
		"h": 2.0549450549
	},
	{
		"stop_id": 8592314,
		"ID": 474,
		"x": -53.0032616427,
		"y": -33.895771122,
		"h": 2.0549450549
	},
	{
		"stop_id": 8592315,
		"ID": 474,
		"x": -52.4002683317,
		"y": -34.11484713,
		"h": 2.0549450549
	},
	{
		"stop_id": 8592316,
		"ID": 474,
		"x": -51.4722914317,
		"y": -34.431810402,
		"h": 2.0549450549
	},
	{
		"stop_id": 8592317,
		"ID": 474,
		"x": -51.1832391657,
		"y": -34.230756192,
		"h": 2.0549450549
	},
	{
		"stop_id": 8592318,
		"ID": 474,
		"x": -52.1482753957,
		"y": -34.167785768,
		"h": 2.0549450549
	},
	{
		"stop_id": 8594931,
		"ID": 474,
		"x": -49.9032323787,
		"y": -34.419797812,
		"h": 2.0549450549
	},
	{
		"stop_id": 8507857,
		"ID": 473,
		"x": -49.9082680977,
		"y": -37.234848477,
		"h": 1.2307692308
	},
	{
		"stop_id": 8530312,
		"ID": 473,
		"x": -49.9252987497,
		"y": -37.249772221,
		"h": 1.2307692308
	},
	{
		"stop_id": 8530313,
		"ID": 473,
		"x": -50.0222825037,
		"y": -38.332790376,
		"h": 1.2307692308
	},
	{
		"stop_id": 8530314,
		"ID": 473,
		"x": -54.0502606977,
		"y": -37.497818907,
		"h": 1.2307692308
	},
	{
		"stop_id": 8576329,
		"ID": 473,
		"x": -50.2522379557,
		"y": -35.986786298,
		"h": 1.2307692308
	},
	{
		"stop_id": 8576331,
		"ID": 473,
		"x": -52.4792673177,
		"y": -36.181840247,
		"h": 1.2307692308
	},
	{
		"stop_id": 8576332,
		"ID": 473,
		"x": -53.9972607287,
		"y": -37.486763856,
		"h": 1.2307692308
	},
	{
		"stop_id": 8592308,
		"ID": 473,
		"x": -50.2302820077,
		"y": -37.057830665,
		"h": 1.2307692308
	},
	{
		"stop_id": 8507862,
		"ID": 576,
		"x": -37.8882500527,
		"y": -16.556762171,
		"h": 1.2307692308
	},
	{
		"stop_id": 8576354,
		"ID": 576,
		"x": -38.5562880427,
		"y": -16.020767066,
		"h": 1.2307692308
	},
	{
		"stop_id": 8576355,
		"ID": 576,
		"x": -38.1882953117,
		"y": -16.191770256,
		"h": 1.2307692308
	},
	{
		"stop_id": 8576356,
		"ID": 576,
		"x": -38.1072962687,
		"y": -16.341777737,
		"h": 1.2307692308
	},
	{
		"stop_id": 8582874,
		"ID": 576,
		"x": -37.0472739517,
		"y": -17.439764574,
		"h": 1.2307692308
	},
	{
		"stop_id": 8582875,
		"ID": 576,
		"x": -36.7722707297,
		"y": -17.749767464,
		"h": 1.2307692308
	},
	{
		"stop_id": 8582876,
		"ID": 576,
		"x": -36.1472355017,
		"y": -18.224813727,
		"h": 1.2307692308
	},
	{
		"stop_id": 8582880,
		"ID": 576,
		"x": -34.7872519447,
		"y": -19.084767773,
		"h": 1.2307692308
	},
	{
		"stop_id": 8507880,
		"ID": 578,
		"x": -38.5842854917,
		"y": -6.497809352,
		"h": 1.1978021978
	},
	{
		"stop_id": 8507883,
		"ID": 578,
		"x": -38.9362466377,
		"y": -7.781804232,
		"h": 1.1978021978
	},
	{
		"stop_id": 8507884,
		"ID": 578,
		"x": -37.5432273487,
		"y": -5.97378887,
		"h": 1.1978021978
	},
	{
		"stop_id": 8576749,
		"ID": 578,
		"x": -38.7452470287,
		"y": -7.571811337,
		"h": 1.1978021978
	},
	{
		"stop_id": 8576751,
		"ID": 578,
		"x": -38.8812437107,
		"y": -6.932846715,
		"h": 1.1978021978
	},
	{
		"stop_id": 8576753,
		"ID": 578,
		"x": -38.2482738957,
		"y": -6.309855251,
		"h": 1.1978021978
	},
	{
		"stop_id": 8588490,
		"ID": 578,
		"x": -38.8412280087,
		"y": -7.845840974,
		"h": 1.1978021978
	},
	{
		"stop_id": 8508003,
		"ID": 485,
		"x": -51.6292533797,
		"y": 28.383174963,
		"h": 1.8241758242
	},
	{
		"stop_id": 8508004,
		"ID": 485,
		"x": -48.9032891257,
		"y": 29.96624795,
		"h": 1.8241758242
	},
	{
		"stop_id": 8508060,
		"ID": 485,
		"x": -54.2002555397,
		"y": 31.778158493,
		"h": 1.8241758242
	},
	{
		"stop_id": 8508061,
		"ID": 485,
		"x": -53.4002545527,
		"y": 32.483232391,
		"h": 1.8241758242
	},
	{
		"stop_id": 8508084,
		"ID": 485,
		"x": -48.9962548317,
		"y": 32.160202178,
		"h": 1.8241758242
	},
	{
		"stop_id": 8508085,
		"ID": 485,
		"x": -50.5652792537,
		"y": 33.492238746,
		"h": 1.8241758242
	},
	{
		"stop_id": 8576446,
		"ID": 485,
		"x": -51.6352832827,
		"y": 28.403177956,
		"h": 1.8241758242
	},
	{
		"stop_id": 8587810,
		"ID": 485,
		"x": -53.3802670587,
		"y": 32.539173877,
		"h": 1.8241758242
	},
	{
		"stop_id": 8587811,
		"ID": 485,
		"x": -52.1002616497,
		"y": 31.108191346,
		"h": 1.8241758242
	},
	{
		"stop_id": 8587812,
		"ID": 485,
		"x": -51.2562624687,
		"y": 31.037172405,
		"h": 1.8241758242
	},
	{
		"stop_id": 8587813,
		"ID": 485,
		"x": -49.6352816217,
		"y": 31.172202145,
		"h": 1.8241758242
	},
	{
		"stop_id": 8587814,
		"ID": 485,
		"x": -48.7902559987,
		"y": 31.507206973,
		"h": 1.8241758242
	},
	{
		"stop_id": 8587827,
		"ID": 485,
		"x": -49.4332392507,
		"y": 33.15221771,
		"h": 1.8241758242
	},
	{
		"stop_id": 8587839,
		"ID": 485,
		"x": -50.0242260817,
		"y": 30.703185435,
		"h": 1.8241758242
	},
	{
		"stop_id": 8588528,
		"ID": 485,
		"x": -50.7622518027,
		"y": 33.311171774,
		"h": 1.8241758242
	},
	{
		"stop_id": 8588529,
		"ID": 485,
		"x": -49.7732239657,
		"y": 32.552192957,
		"h": 1.8241758242
	},
	{
		"stop_id": 8588530,
		"ID": 485,
		"x": -48.9222907467,
		"y": 30.140199936,
		"h": 1.8241758242
	},
	{
		"stop_id": 8589025,
		"ID": 485,
		"x": -53.1452765637,
		"y": 33.253162901,
		"h": 1.8241758242
	},
	{
		"stop_id": 8589027,
		"ID": 485,
		"x": -53.1892591337,
		"y": 32.297242309,
		"h": 1.8241758242
	},
	{
		"stop_id": 8589028,
		"ID": 485,
		"x": -54.1872596397,
		"y": 31.520247777,
		"h": 1.8241758242
	},
	{
		"stop_id": 8589192,
		"ID": 485,
		"x": -48.8902462767,
		"y": 31.993187788,
		"h": 1.8241758242
	},
	{
		"stop_id": 8589193,
		"ID": 485,
		"x": -49.4442730677,
		"y": 31.442234248,
		"h": 1.8241758242
	},
	{
		"stop_id": 8589196,
		"ID": 485,
		"x": -49.8022897527,
		"y": 30.938236275,
		"h": 1.8241758242
	},
	{
		"stop_id": 8589910,
		"ID": 485,
		"x": -49.5452290847,
		"y": 33.24118774,
		"h": 1.8241758242
	},
	{
		"stop_id": 8593267,
		"ID": 485,
		"x": -48.8672848837,
		"y": 30.010226614,
		"h": 1.8241758242
	},
	{
		"stop_id": 8593494,
		"ID": 485,
		"x": -49.2012288697,
		"y": 30.571167125,
		"h": 1.8241758242
	},
	{
		"stop_id": 8508005,
		"ID": 517,
		"x": -45.8352934657,
		"y": 29.63217107,
		"h": 3.010989011
	},
	{
		"stop_id": 8508080,
		"ID": 517,
		"x": -45.2262567407,
		"y": 27.290197503,
		"h": 3.010989011
	},
	{
		"stop_id": 8508081,
		"ID": 517,
		"x": -46.0912326297,
		"y": 28.696170141,
		"h": 3.010989011
	},
	{
		"stop_id": 8508083,
		"ID": 517,
		"x": -46.8602671627,
		"y": 30.151170658,
		"h": 3.010989011
	},
	{
		"stop_id": 8508954,
		"ID": 517,
		"x": -44.4952862687,
		"y": 28.336151682,
		"h": 3.010989011
	},
	{
		"stop_id": 8508968,
		"ID": 517,
		"x": -45.1742352237,
		"y": 29.055197026,
		"h": 3.010989011
	},
	{
		"stop_id": 8508969,
		"ID": 517,
		"x": -45.7792426877,
		"y": 28.205170621,
		"h": 3.010989011
	},
	{
		"stop_id": 8576439,
		"ID": 517,
		"x": -46.1452373217,
		"y": 28.788209865,
		"h": 3.010989011
	},
	{
		"stop_id": 8576440,
		"ID": 517,
		"x": -46.6302471007,
		"y": 28.69318716,
		"h": 3.010989011
	},
	{
		"stop_id": 8576462,
		"ID": 517,
		"x": -45.2932637117,
		"y": 28.791205589,
		"h": 3.010989011
	},
	{
		"stop_id": 8576463,
		"ID": 517,
		"x": -45.1252764737,
		"y": 28.483218875,
		"h": 3.010989011
	},
	{
		"stop_id": 8576464,
		"ID": 517,
		"x": -44.8282405677,
		"y": 28.083172247,
		"h": 3.010989011
	},
	{
		"stop_id": 8576466,
		"ID": 517,
		"x": -43.7682827937,
		"y": 29.064231702,
		"h": 3.010989011
	},
	{
		"stop_id": 8576486,
		"ID": 517,
		"x": -46.2352809147,
		"y": 29.801239574,
		"h": 3.010989011
	},
	{
		"stop_id": 8576487,
		"ID": 517,
		"x": -46.0112960067,
		"y": 30.285242401,
		"h": 3.010989011
	},
	{
		"stop_id": 8576504,
		"ID": 517,
		"x": -45.9142245747,
		"y": 29.598191556,
		"h": 3.010989011
	},
	{
		"stop_id": 8587798,
		"ID": 517,
		"x": -45.5862324327,
		"y": 28.94514774,
		"h": 3.010989011
	},
	{
		"stop_id": 8587815,
		"ID": 517,
		"x": -47.1092603407,
		"y": 30.359201757,
		"h": 3.010989011
	},
	{
		"stop_id": 8587816,
		"ID": 517,
		"x": -46.7022550747,
		"y": 30.113157759,
		"h": 3.010989011
	},
	{
		"stop_id": 8587817,
		"ID": 517,
		"x": -46.2002528547,
		"y": 29.563185302,
		"h": 3.010989011
	},
	{
		"stop_id": 8587818,
		"ID": 517,
		"x": -45.6982449537,
		"y": 28.629152034,
		"h": 3.010989011
	},
	{
		"stop_id": 8587819,
		"ID": 517,
		"x": -45.7672593707,
		"y": 27.824208509,
		"h": 3.010989011
	},
	{
		"stop_id": 8587820,
		"ID": 517,
		"x": -45.5642360907,
		"y": 27.324184963,
		"h": 3.010989011
	},
	{
		"stop_id": 8587821,
		"ID": 517,
		"x": -45.6032581367,
		"y": 27.113197721,
		"h": 3.010989011
	},
	{
		"stop_id": 8587822,
		"ID": 517,
		"x": -45.2382259147,
		"y": 26.866155102,
		"h": 3.010989011
	},
	{
		"stop_id": 8587823,
		"ID": 517,
		"x": -45.4302647697,
		"y": 26.854242318,
		"h": 3.010989011
	},
	{
		"stop_id": 8587824,
		"ID": 517,
		"x": -44.9792563427,
		"y": 26.520151033,
		"h": 3.010989011
	},
	{
		"stop_id": 8587825,
		"ID": 517,
		"x": -44.8542467867,
		"y": 26.103229163,
		"h": 3.010989011
	},
	{
		"stop_id": 8587826,
		"ID": 517,
		"x": -44.6642472867,
		"y": 25.666240028,
		"h": 3.010989011
	},
	{
		"stop_id": 8587829,
		"ID": 517,
		"x": -46.0122832047,
		"y": 30.05322106,
		"h": 3.010989011
	},
	{
		"stop_id": 8587830,
		"ID": 517,
		"x": -45.3082799347,
		"y": 28.212179469,
		"h": 3.010989011
	},
	{
		"stop_id": 8587866,
		"ID": 517,
		"x": -45.8842989977,
		"y": 28.846173369,
		"h": 3.010989011
	},
	{
		"stop_id": 8587869,
		"ID": 517,
		"x": -45.3832844247,
		"y": 29.354192908,
		"h": 3.010989011
	},
	{
		"stop_id": 8588467,
		"ID": 517,
		"x": -47.4162253597,
		"y": 30.546223128,
		"h": 3.010989011
	},
	{
		"stop_id": 8588715,
		"ID": 517,
		"x": -45.1942261657,
		"y": 26.744194048,
		"h": 3.010989011
	},
	{
		"stop_id": 8588908,
		"ID": 517,
		"x": -45.1462550327,
		"y": 29.888176169,
		"h": 3.010989011
	},
	{
		"stop_id": 8588909,
		"ID": 517,
		"x": -45.0602700377,
		"y": 30.016235971,
		"h": 3.010989011
	},
	{
		"stop_id": 8588910,
		"ID": 517,
		"x": -45.0662980607,
		"y": 29.841234126,
		"h": 3.010989011
	},
	{
		"stop_id": 8588911,
		"ID": 517,
		"x": -46.7662886547,
		"y": 29.655206619,
		"h": 3.010989011
	},
	{
		"stop_id": 8588912,
		"ID": 517,
		"x": -47.0772446457,
		"y": 29.839200042,
		"h": 3.010989011
	},
	{
		"stop_id": 8588913,
		"ID": 517,
		"x": -47.2672321597,
		"y": 29.689162058,
		"h": 3.010989011
	},
	{
		"stop_id": 8588914,
		"ID": 517,
		"x": -47.2212450527,
		"y": 29.895151064,
		"h": 3.010989011
	},
	{
		"stop_id": 8588915,
		"ID": 517,
		"x": -46.7502956167,
		"y": 29.707159246,
		"h": 3.010989011
	},
	{
		"stop_id": 8588916,
		"ID": 517,
		"x": -46.0442780327,
		"y": 29.129185904,
		"h": 3.010989011
	},
	{
		"stop_id": 8588917,
		"ID": 517,
		"x": -46.0072728447,
		"y": 29.359177046,
		"h": 3.010989011
	},
	{
		"stop_id": 8588918,
		"ID": 517,
		"x": -46.4812850757,
		"y": 29.020141938,
		"h": 3.010989011
	},
	{
		"stop_id": 8588919,
		"ID": 517,
		"x": -45.5892659737,
		"y": 29.039193151,
		"h": 3.010989011
	},
	{
		"stop_id": 8588920,
		"ID": 517,
		"x": -45.4112595817,
		"y": 29.10720993,
		"h": 3.010989011
	},
	{
		"stop_id": 8588921,
		"ID": 517,
		"x": -45.4802675647,
		"y": 29.307157114,
		"h": 3.010989011
	},
	{
		"stop_id": 8588922,
		"ID": 517,
		"x": -45.7222938157,
		"y": 29.42420688,
		"h": 3.010989011
	},
	{
		"stop_id": 8588923,
		"ID": 517,
		"x": -45.2062659597,
		"y": 29.386193341,
		"h": 3.010989011
	},
	{
		"stop_id": 8589056,
		"ID": 517,
		"x": -46.5062483617,
		"y": 29.486236285,
		"h": 3.010989011
	},
	{
		"stop_id": 8589058,
		"ID": 517,
		"x": -46.4892553917,
		"y": 29.463149812,
		"h": 3.010989011
	},
	{
		"stop_id": 8591684,
		"ID": 517,
		"x": -46.1942527977,
		"y": 29.866146358,
		"h": 3.010989011
	},
	{
		"stop_id": 8593263,
		"ID": 517,
		"x": -46.4002577127,
		"y": 28.834217917,
		"h": 3.010989011
	},
	{
		"stop_id": 8593264,
		"ID": 517,
		"x": -46.4552966567,
		"y": 29.532152519,
		"h": 3.010989011
	},
	{
		"stop_id": 8593265,
		"ID": 517,
		"x": -45.7272781947,
		"y": 29.606186013,
		"h": 3.010989011
	},
	{
		"stop_id": 8593268,
		"ID": 517,
		"x": -45.1752968027,
		"y": 27.430176816,
		"h": 3.010989011
	},
	{
		"stop_id": 8593269,
		"ID": 517,
		"x": -45.0642993927,
		"y": 27.197207021,
		"h": 3.010989011
	},
	{
		"stop_id": 8593271,
		"ID": 517,
		"x": -45.1792666567,
		"y": 28.406155475,
		"h": 3.010989011
	},
	{
		"stop_id": 8594774,
		"ID": 517,
		"x": -45.6052424177,
		"y": 29.241157284,
		"h": 3.010989011
	},
	{
		"stop_id": 8594775,
		"ID": 517,
		"x": -46.4252587047,
		"y": 29.963238453,
		"h": 3.010989011
	},
	{
		"stop_id": 8508006,
		"ID": 552,
		"x": -42.6732463887,
		"y": 34.584154305,
		"h": 1.3626373626
	},
	{
		"stop_id": 8508695,
		"ID": 552,
		"x": -42.4082485687,
		"y": 39.133202844,
		"h": 1.3626373626
	},
	{
		"stop_id": 8571644,
		"ID": 552,
		"x": -40.3952730537,
		"y": 38.479225237,
		"h": 1.3626373626
	},
	{
		"stop_id": 8571772,
		"ID": 552,
		"x": -42.6582840937,
		"y": 34.58119534,
		"h": 1.3626373626
	},
	{
		"stop_id": 8576495,
		"ID": 552,
		"x": -44.1522426157,
		"y": 36.683207209,
		"h": 1.3626373626
	},
	{
		"stop_id": 8576963,
		"ID": 552,
		"x": -42.3132957307,
		"y": 38.643194805,
		"h": 1.3626373626
	},
	{
		"stop_id": 8588093,
		"ID": 552,
		"x": -41.7332332137,
		"y": 36.759159473,
		"h": 1.3626373626
	},
	{
		"stop_id": 8588627,
		"ID": 552,
		"x": -44.6302389587,
		"y": 36.812165564,
		"h": 1.3626373626
	},
	{
		"stop_id": 8589489,
		"ID": 552,
		"x": -43.6802277107,
		"y": 35.512229039,
		"h": 1.3626373626
	},
	{
		"stop_id": 8591887,
		"ID": 552,
		"x": -41.1982650187,
		"y": 37.610175507,
		"h": 1.3626373626
	},
	{
		"stop_id": 8591888,
		"ID": 552,
		"x": -40.1682847777,
		"y": 39.190155651,
		"h": 1.3626373626
	},
	{
		"stop_id": 8591889,
		"ID": 552,
		"x": -42.3742793037,
		"y": 34.909200933,
		"h": 1.3626373626
	},
	{
		"stop_id": 8508058,
		"ID": 453,
		"x": -55.0282310357,
		"y": 26.082174734,
		"h": 1.3626373626
	},
	{
		"stop_id": 8508059,
		"ID": 453,
		"x": -54.4882780807,
		"y": 28.164215839,
		"h": 1.3626373626
	},
	{
		"stop_id": 8508721,
		"ID": 453,
		"x": -57.1592414597,
		"y": 28.578166864,
		"h": 1.3626373626
	},
	{
		"stop_id": 8508850,
		"ID": 453,
		"x": -57.0422933657,
		"y": 29.591225574,
		"h": 1.3626373626
	},
	{
		"stop_id": 8571513,
		"ID": 453,
		"x": -54.5172705867,
		"y": 28.211216804,
		"h": 1.3626373626
	},
	{
		"stop_id": 8571514,
		"ID": 453,
		"x": -55.0662252577,
		"y": 28.327165301,
		"h": 1.3626373626
	},
	{
		"stop_id": 8571515,
		"ID": 453,
		"x": -56.7582696067,
		"y": 29.966233447,
		"h": 1.3626373626
	},
	{
		"stop_id": 8571516,
		"ID": 453,
		"x": -57.0952846187,
		"y": 30.034227397,
		"h": 1.3626373626
	},
	{
		"stop_id": 8580675,
		"ID": 453,
		"x": -57.0562784157,
		"y": 28.913175149,
		"h": 1.3626373626
	},
	{
		"stop_id": 8581330,
		"ID": 453,
		"x": -54.5462344737,
		"y": 28.402186796,
		"h": 1.3626373626
	},
	{
		"stop_id": 8589045,
		"ID": 453,
		"x": -54.9482530227,
		"y": 25.878236234,
		"h": 1.3626373626
	},
	{
		"stop_id": 8595426,
		"ID": 453,
		"x": -54.8522587857,
		"y": 28.625166647,
		"h": 1.3626373626
	},
	{
		"stop_id": 8508062,
		"ID": 454,
		"x": -53.6552440577,
		"y": 33.538231674,
		"h": 1.4615384615
	},
	{
		"stop_id": 8508716,
		"ID": 454,
		"x": -56.3422320127,
		"y": 36.130151452,
		"h": 1.4615384615
	},
	{
		"stop_id": 8508717,
		"ID": 454,
		"x": -55.6002696017,
		"y": 34.894242269,
		"h": 1.4615384615
	},
	{
		"stop_id": 8508718,
		"ID": 454,
		"x": -56.8602277547,
		"y": 34.014237786,
		"h": 1.4615384615
	},
	{
		"stop_id": 8508719,
		"ID": 454,
		"x": -57.7922859227,
		"y": 35.636236152,
		"h": 1.4615384615
	},
	{
		"stop_id": 8508720,
		"ID": 454,
		"x": -57.5462856087,
		"y": 32.577142248,
		"h": 1.4615384615
	},
	{
		"stop_id": 8508881,
		"ID": 454,
		"x": -56.6972341187,
		"y": 32.331144703,
		"h": 1.4615384615
	},
	{
		"stop_id": 8571509,
		"ID": 454,
		"x": -55.0692909987,
		"y": 35.143214756,
		"h": 1.4615384615
	},
	{
		"stop_id": 8571510,
		"ID": 454,
		"x": -57.7962888547,
		"y": 33.404191495,
		"h": 1.4615384615
	},
	{
		"stop_id": 8571511,
		"ID": 454,
		"x": -58.9132881447,
		"y": 33.053191219,
		"h": 1.4615384615
	},
	{
		"stop_id": 8571517,
		"ID": 454,
		"x": -56.8932507777,
		"y": 32.061231621,
		"h": 1.4615384615
	},
	{
		"stop_id": 8571518,
		"ID": 454,
		"x": -55.3932881927,
		"y": 36.593244099,
		"h": 1.4615384615
	},
	{
		"stop_id": 8571519,
		"ID": 454,
		"x": -55.7462577637,
		"y": 36.315175527,
		"h": 1.4615384615
	},
	{
		"stop_id": 8582984,
		"ID": 454,
		"x": -59.0642326857,
		"y": 33.07518637,
		"h": 1.4615384615
	},
	{
		"stop_id": 8583663,
		"ID": 454,
		"x": -58.9202671037,
		"y": 33.003162119,
		"h": 1.4615384615
	},
	{
		"stop_id": 8508063,
		"ID": 486,
		"x": -53.2502428657,
		"y": 35.119217773,
		"h": 1.4945054945
	},
	{
		"stop_id": 8508064,
		"ID": 486,
		"x": -52.4762993297,
		"y": 37.327141253,
		"h": 1.4945054945
	},
	{
		"stop_id": 8508086,
		"ID": 486,
		"x": -51.0152932177,
		"y": 37.269164141,
		"h": 1.4945054945
	},
	{
		"stop_id": 8571505,
		"ID": 486,
		"x": -51.0072356387,
		"y": 37.415148506,
		"h": 1.4945054945
	},
	{
		"stop_id": 8571506,
		"ID": 486,
		"x": -51.5242863187,
		"y": 37.628207404,
		"h": 1.4945054945
	},
	{
		"stop_id": 8571507,
		"ID": 486,
		"x": -52.0422579937,
		"y": 37.405170844,
		"h": 1.4945054945
	},
	{
		"stop_id": 8571508,
		"ID": 486,
		"x": -52.4862735127,
		"y": 37.29322087,
		"h": 1.4945054945
	},
	{
		"stop_id": 8578138,
		"ID": 486,
		"x": -52.0872873677,
		"y": 37.375207233,
		"h": 1.4945054945
	},
	{
		"stop_id": 8578140,
		"ID": 486,
		"x": -52.4352623777,
		"y": 38.645170746,
		"h": 1.4945054945
	},
	{
		"stop_id": 8578142,
		"ID": 486,
		"x": -52.5752831267,
		"y": 39.528178347,
		"h": 1.4945054945
	},
	{
		"stop_id": 8581759,
		"ID": 486,
		"x": -50.5312277987,
		"y": 37.124248993,
		"h": 1.4945054945
	},
	{
		"stop_id": 8581761,
		"ID": 486,
		"x": -52.2052331487,
		"y": 37.83120878,
		"h": 1.4945054945
	},
	{
		"stop_id": 8582193,
		"ID": 486,
		"x": -51.1352644647,
		"y": 37.756159357,
		"h": 1.4945054945
	},
	{
		"stop_id": 8589040,
		"ID": 486,
		"x": -53.1172474547,
		"y": 34.965163939,
		"h": 1.4945054945
	},
	{
		"stop_id": 8594537,
		"ID": 486,
		"x": -49.7862732777,
		"y": 34.100158486,
		"h": 1.4945054945
	},
	{
		"stop_id": 8595696,
		"ID": 486,
		"x": -52.5922374357,
		"y": 39.435215548,
		"h": 1.4945054945
	},
	{
		"stop_id": 8508079,
		"ID": 484,
		"x": -50.0422996607,
		"y": 23.927176214,
		"h": 1.4945054945
	},
	{
		"stop_id": 8508894,
		"ID": 484,
		"x": -52.9722842047,
		"y": 24.9761871,
		"h": 1.4945054945
	},
	{
		"stop_id": 8508951,
		"ID": 484,
		"x": -51.3202288147,
		"y": 26.38515891,
		"h": 1.4945054945
	},
	{
		"stop_id": 8508952,
		"ID": 484,
		"x": -52.2032736137,
		"y": 27.064141015,
		"h": 1.4945054945
	},
	{
		"stop_id": 8576445,
		"ID": 484,
		"x": -51.9962471427,
		"y": 27.65917805,
		"h": 1.4945054945
	},
	{
		"stop_id": 8576449,
		"ID": 484,
		"x": -50.8912841937,
		"y": 26.327187386,
		"h": 1.4945054945
	},
	{
		"stop_id": 8576450,
		"ID": 484,
		"x": -50.4572619987,
		"y": 24.366206305,
		"h": 1.4945054945
	},
	{
		"stop_id": 8576452,
		"ID": 484,
		"x": -50.1202310987,
		"y": 23.634223675,
		"h": 1.4945054945
	},
	{
		"stop_id": 8576454,
		"ID": 484,
		"x": -51.6532390927,
		"y": 22.881221436,
		"h": 1.4945054945
	},
	{
		"stop_id": 8576455,
		"ID": 484,
		"x": -51.9592375157,
		"y": 22.781207951,
		"h": 1.4945054945
	},
	{
		"stop_id": 8576456,
		"ID": 484,
		"x": -52.3692839007,
		"y": 22.734222028,
		"h": 1.4945054945
	},
	{
		"stop_id": 8577028,
		"ID": 484,
		"x": -54.5002456957,
		"y": 24.96521653,
		"h": 1.4945054945
	},
	{
		"stop_id": 8577029,
		"ID": 484,
		"x": -54.1152719867,
		"y": 25.010142877,
		"h": 1.4945054945
	},
	{
		"stop_id": 8577030,
		"ID": 484,
		"x": -53.2812331367,
		"y": 25.155168791,
		"h": 1.4945054945
	},
	{
		"stop_id": 8581762,
		"ID": 484,
		"x": -51.9602955637,
		"y": 28.007195363,
		"h": 1.4945054945
	},
	{
		"stop_id": 8588623,
		"ID": 484,
		"x": -54.0372425817,
		"y": 26.192200236,
		"h": 1.4945054945
	},
	{
		"stop_id": 8508100,
		"ID": 620,
		"x": -33.5272864927,
		"y": 47.084210186,
		"h": 2.0879120879
	},
	{
		"stop_id": 8508101,
		"ID": 620,
		"x": -31.2582792287,
		"y": 50.911180895,
		"h": 2.0879120879
	},
	{
		"stop_id": 8508151,
		"ID": 620,
		"x": -33.7232534777,
		"y": 47.917188011,
		"h": 2.0879120879
	},
	{
		"stop_id": 8508152,
		"ID": 620,
		"x": -34.2802697287,
		"y": 48.917165481,
		"h": 2.0879120879
	},
	{
		"stop_id": 8508161,
		"ID": 620,
		"x": -32.4222900857,
		"y": 49.303187473,
		"h": 2.0879120879
	},
	{
		"stop_id": 8508162,
		"ID": 620,
		"x": -30.6742280147,
		"y": 49.543165133,
		"h": 2.0879120879
	},
	{
		"stop_id": 8508163,
		"ID": 620,
		"x": -29.6532719327,
		"y": 48.710171799,
		"h": 2.0879120879
	},
	{
		"stop_id": 8508164,
		"ID": 620,
		"x": -29.6432815657,
		"y": 48.217143883,
		"h": 2.0879120879
	},
	{
		"stop_id": 8508168,
		"ID": 620,
		"x": -29.9812677827,
		"y": 49.167247157,
		"h": 2.0879120879
	},
	{
		"stop_id": 8508173,
		"ID": 620,
		"x": -31.2372421997,
		"y": 49.332203567,
		"h": 2.0879120879
	},
	{
		"stop_id": 8572712,
		"ID": 620,
		"x": -28.6412583447,
		"y": 47.701200229,
		"h": 2.0879120879
	},
	{
		"stop_id": 8572713,
		"ID": 620,
		"x": -29.3182867217,
		"y": 48.214237915,
		"h": 2.0879120879
	},
	{
		"stop_id": 8572714,
		"ID": 620,
		"x": -29.4222375027,
		"y": 48.47520022,
		"h": 2.0879120879
	},
	{
		"stop_id": 8572715,
		"ID": 620,
		"x": -29.6492384887,
		"y": 48.736208071,
		"h": 2.0879120879
	},
	{
		"stop_id": 8572785,
		"ID": 620,
		"x": -29.3902467587,
		"y": 47.94915373,
		"h": 2.0879120879
	},
	{
		"stop_id": 8576926,
		"ID": 620,
		"x": -33.5212253727,
		"y": 46.688220278,
		"h": 2.0879120879
	},
	{
		"stop_id": 8576927,
		"ID": 620,
		"x": -33.1272292507,
		"y": 46.502188148,
		"h": 2.0879120879
	},
	{
		"stop_id": 8576928,
		"ID": 620,
		"x": -32.9372446877,
		"y": 46.303142015,
		"h": 2.0879120879
	},
	{
		"stop_id": 8576929,
		"ID": 620,
		"x": -32.6292679317,
		"y": 45.534183863,
		"h": 2.0879120879
	},
	{
		"stop_id": 8576937,
		"ID": 620,
		"x": -33.5452551717,
		"y": 47.036213312,
		"h": 2.0879120879
	},
	{
		"stop_id": 8576945,
		"ID": 620,
		"x": -33.3112418137,
		"y": 46.297245773,
		"h": 2.0879120879
	},
	{
		"stop_id": 8581594,
		"ID": 620,
		"x": -28.8212688587,
		"y": 47.22919812,
		"h": 2.0879120879
	},
	{
		"stop_id": 8589201,
		"ID": 620,
		"x": -33.3962302037,
		"y": 48.126196148,
		"h": 2.0879120879
	},
	{
		"stop_id": 8589260,
		"ID": 620,
		"x": -32.7592422777,
		"y": 46.96223167,
		"h": 2.0879120879
	},
	{
		"stop_id": 8589929,
		"ID": 620,
		"x": -33.7422288737,
		"y": 47.510192364,
		"h": 2.0879120879
	},
	{
		"stop_id": 8589931,
		"ID": 620,
		"x": -32.4112243067,
		"y": 46.826180125,
		"h": 2.0879120879
	},
	{
		"stop_id": 8589932,
		"ID": 620,
		"x": -32.5742585417,
		"y": 46.713144103,
		"h": 2.0879120879
	},
	{
		"stop_id": 8589933,
		"ID": 620,
		"x": -33.8282874457,
		"y": 47.809220492,
		"h": 2.0879120879
	},
	{
		"stop_id": 8589934,
		"ID": 620,
		"x": -33.4262763267,
		"y": 47.710144773,
		"h": 2.0879120879
	},
	{
		"stop_id": 8589936,
		"ID": 620,
		"x": -33.5302396907,
		"y": 47.927151165,
		"h": 2.0879120879
	},
	{
		"stop_id": 8589937,
		"ID": 620,
		"x": -32.8902786237,
		"y": 46.64022323,
		"h": 2.0879120879
	},
	{
		"stop_id": 8589940,
		"ID": 620,
		"x": -34.0102466867,
		"y": 47.536155729,
		"h": 2.0879120879
	},
	{
		"stop_id": 8589943,
		"ID": 620,
		"x": -32.6472255237,
		"y": 47.066247256,
		"h": 2.0879120879
	},
	{
		"stop_id": 8594258,
		"ID": 620,
		"x": -33.3992799537,
		"y": 48.336198864,
		"h": 2.0879120879
	},
	{
		"stop_id": 8508153,
		"ID": 588,
		"x": -34.6832250997,
		"y": 49.659241331,
		"h": 1.1648351648
	},
	{
		"stop_id": 8508154,
		"ID": 588,
		"x": -35.1382245377,
		"y": 50.177215759,
		"h": 1.1648351648
	},
	{
		"stop_id": 8508155,
		"ID": 588,
		"x": -36.8982533207,
		"y": 50.081148595,
		"h": 1.1648351648
	},
	{
		"stop_id": 8508157,
		"ID": 588,
		"x": -39.1722593787,
		"y": 51.605237574,
		"h": 1.1648351648
	},
	{
		"stop_id": 8508193,
		"ID": 588,
		"x": -34.5522610457,
		"y": 49.325145985,
		"h": 1.1648351648
	},
	{
		"stop_id": 8572370,
		"ID": 588,
		"x": -35.6312361047,
		"y": 54.042239384,
		"h": 1.1648351648
	},
	{
		"stop_id": 8508172,
		"ID": 653,
		"x": -28.7532383997,
		"y": 44.141241758,
		"h": 1.5274725275
	},
	{
		"stop_id": 8508882,
		"ID": 653,
		"x": -25.0522455657,
		"y": 48.213228691,
		"h": 1.5274725275
	},
	{
		"stop_id": 8508883,
		"ID": 653,
		"x": -25.9022503507,
		"y": 46.40523329,
		"h": 1.5274725275
	},
	{
		"stop_id": 8572711,
		"ID": 653,
		"x": -25.6542969537,
		"y": 46.81623092,
		"h": 1.5274725275
	},
	{
		"stop_id": 8572776,
		"ID": 653,
		"x": -26.0912409837,
		"y": 42.820219019,
		"h": 1.5274725275
	},
	{
		"stop_id": 8572777,
		"ID": 653,
		"x": -26.3052844257,
		"y": 43.085173277,
		"h": 1.5274725275
	},
	{
		"stop_id": 8572778,
		"ID": 653,
		"x": -26.5672914417,
		"y": 43.364209875,
		"h": 1.5274725275
	},
	{
		"stop_id": 8572779,
		"ID": 653,
		"x": -26.9822996137,
		"y": 43.808180797,
		"h": 1.5274725275
	},
	{
		"stop_id": 8572780,
		"ID": 653,
		"x": -27.6182702127,
		"y": 44.567175167,
		"h": 1.5274725275
	},
	{
		"stop_id": 8572781,
		"ID": 653,
		"x": -28.0182785377,
		"y": 45.739183828,
		"h": 1.5274725275
	},
	{
		"stop_id": 8576932,
		"ID": 653,
		"x": -29.1592705837,
		"y": 44.562174863,
		"h": 1.5274725275
	},
	{
		"stop_id": 8576934,
		"ID": 653,
		"x": -28.6692346087,
		"y": 43.830159088,
		"h": 1.5274725275
	},
	{
		"stop_id": 8579864,
		"ID": 653,
		"x": -25.3462849547,
		"y": 47.878206375,
		"h": 1.5274725275
	},
	{
		"stop_id": 8580018,
		"ID": 653,
		"x": -27.7182927287,
		"y": 45.326205816,
		"h": 1.5274725275
	},
	{
		"stop_id": 8580401,
		"ID": 653,
		"x": -28.4552594327,
		"y": 46.46620187,
		"h": 1.5274725275
	},
	{
		"stop_id": 8580732,
		"ID": 653,
		"x": -26.1352559547,
		"y": 46.239146341,
		"h": 1.5274725275
	},
	{
		"stop_id": 8595695,
		"ID": 653,
		"x": -25.9992781717,
		"y": 43.313146233,
		"h": 1.5274725275
	},
	{
		"stop_id": 8508174,
		"ID": 619,
		"x": -32.8612715597,
		"y": 43.115242646,
		"h": 1.2637362637
	},
	{
		"stop_id": 8508182,
		"ID": 619,
		"x": -33.2352993967,
		"y": 43.991201085,
		"h": 1.2637362637
	},
	{
		"stop_id": 8508183,
		"ID": 619,
		"x": -32.6732712137,
		"y": 41.459221697,
		"h": 1.2637362637
	},
	{
		"stop_id": 8508184,
		"ID": 619,
		"x": -33.0552356387,
		"y": 40.116152596,
		"h": 1.2637362637
	},
	{
		"stop_id": 8576930,
		"ID": 619,
		"x": -31.0232430707,
		"y": 45.121236443,
		"h": 1.2637362637
	},
	{
		"stop_id": 8576931,
		"ID": 619,
		"x": -30.0072407407,
		"y": 44.799248055,
		"h": 1.2637362637
	},
	{
		"stop_id": 8576935,
		"ID": 619,
		"x": -28.4782878087,
		"y": 43.247141544,
		"h": 1.2637362637
	},
	{
		"stop_id": 8576936,
		"ID": 619,
		"x": -28.2402905807,
		"y": 42.776223975,
		"h": 1.2637362637
	},
	{
		"stop_id": 8593528,
		"ID": 619,
		"x": -33.3502391067,
		"y": 44.959158589,
		"h": 1.2637362637
	},
	{
		"stop_id": 8508175,
		"ID": 618,
		"x": -29.7782880107,
		"y": 35.411179573,
		"h": 1.2637362637
	},
	{
		"stop_id": 8508185,
		"ID": 618,
		"x": -33.0182614187,
		"y": 39.193220408,
		"h": 1.2637362637
	},
	{
		"stop_id": 8508186,
		"ID": 618,
		"x": -31.2792766037,
		"y": 38.182225933,
		"h": 1.2637362637
	},
	{
		"stop_id": 8508187,
		"ID": 618,
		"x": -29.0742300917,
		"y": 35.687249883,
		"h": 1.2637362637
	},
	{
		"stop_id": 8508658,
		"ID": 618,
		"x": -30.0902516387,
		"y": 34.957246951,
		"h": 1.2637362637
	},
	{
		"stop_id": 8571546,
		"ID": 618,
		"x": -33.0382855667,
		"y": 39.176231901,
		"h": 1.2637362637
	},
	{
		"stop_id": 8571567,
		"ID": 618,
		"x": -29.7442578587,
		"y": 35.647154392,
		"h": 1.2637362637
	},
	{
		"stop_id": 8571569,
		"ID": 618,
		"x": -29.6012725917,
		"y": 35.347144783,
		"h": 1.2637362637
	},
	{
		"stop_id": 8571575,
		"ID": 618,
		"x": -29.0532302077,
		"y": 35.662232157,
		"h": 1.2637362637
	},
	{
		"stop_id": 8508178,
		"ID": 651,
		"x": -27.9772901727,
		"y": 35.112208458,
		"h": 1.4945054945
	},
	{
		"stop_id": 8508179,
		"ID": 651,
		"x": -28.3342607537,
		"y": 33.656140751,
		"h": 1.4945054945
	},
	{
		"stop_id": 8508188,
		"ID": 651,
		"x": -27.9902285997,
		"y": 31.138175184,
		"h": 1.4945054945
	},
	{
		"stop_id": 8508189,
		"ID": 651,
		"x": -28.4402435767,
		"y": 31.846206316,
		"h": 1.4945054945
	},
	{
		"stop_id": 8508885,
		"ID": 651,
		"x": -28.7002802787,
		"y": 35.626147716,
		"h": 1.4945054945
	},
	{
		"stop_id": 8571562,
		"ID": 651,
		"x": -28.1272883017,
		"y": 35.530210975,
		"h": 1.4945054945
	},
	{
		"stop_id": 8571563,
		"ID": 651,
		"x": -27.5672586907,
		"y": 35.730209835,
		"h": 1.4945054945
	},
	{
		"stop_id": 8572752,
		"ID": 651,
		"x": -24.9852807027,
		"y": 35.972167025,
		"h": 1.4945054945
	},
	{
		"stop_id": 8572754,
		"ID": 651,
		"x": -23.3472524117,
		"y": 33.962201513,
		"h": 1.4945054945
	},
	{
		"stop_id": 8572755,
		"ID": 651,
		"x": -23.7402547517,
		"y": 33.329226172,
		"h": 1.4945054945
	},
	{
		"stop_id": 8576507,
		"ID": 651,
		"x": -28.1052590747,
		"y": 35.36923392,
		"h": 1.4945054945
	},
	{
		"stop_id": 8576508,
		"ID": 651,
		"x": -28.4632829597,
		"y": 32.315244513,
		"h": 1.4945054945
	},
	{
		"stop_id": 8587249,
		"ID": 651,
		"x": -28.1612488737,
		"y": 31.377183398,
		"h": 1.4945054945
	},
	{
		"stop_id": 8593533,
		"ID": 651,
		"x": -27.2422477937,
		"y": 35.850152354,
		"h": 1.4945054945
	},
	{
		"stop_id": 8593534,
		"ID": 651,
		"x": -26.2422887117,
		"y": 35.690144782,
		"h": 1.4945054945
	},
	{
		"stop_id": 8595141,
		"ID": 651,
		"x": -28.6202670197,
		"y": 35.50616123,
		"h": 1.4945054945
	},
	{
		"stop_id": 8508181,
		"ID": 587,
		"x": -33.8622322627,
		"y": 45.755168608,
		"h": 1.8571428571
	},
	{
		"stop_id": 8508957,
		"ID": 587,
		"x": -35.9012901417,
		"y": 45.671170105,
		"h": 1.8571428571
	},
	{
		"stop_id": 8508960,
		"ID": 587,
		"x": -36.6452405697,
		"y": 46.725206745,
		"h": 1.8571428571
	},
	{
		"stop_id": 8508961,
		"ID": 587,
		"x": -37.4522376477,
		"y": 45.934216599,
		"h": 1.8571428571
	},
	{
		"stop_id": 8508998,
		"ID": 587,
		"x": -35.9402383797,
		"y": 43.433236103,
		"h": 1.8571428571
	},
	{
		"stop_id": 8576920,
		"ID": 587,
		"x": -37.0162455747,
		"y": 46.398140259,
		"h": 1.8571428571
	},
	{
		"stop_id": 8576921,
		"ID": 587,
		"x": -36.4292976277,
		"y": 46.907156639,
		"h": 1.8571428571
	},
	{
		"stop_id": 8576923,
		"ID": 587,
		"x": -35.8422340347,
		"y": 47.06024031,
		"h": 1.8571428571
	},
	{
		"stop_id": 8576924,
		"ID": 587,
		"x": -34.6922873707,
		"y": 47.079196182,
		"h": 1.8571428571
	},
	{
		"stop_id": 8576925,
		"ID": 587,
		"x": -34.3762930177,
		"y": 46.944229216,
		"h": 1.8571428571
	},
	{
		"stop_id": 8576938,
		"ID": 587,
		"x": -33.7632831967,
		"y": 46.537180297,
		"h": 1.8571428571
	},
	{
		"stop_id": 8576939,
		"ID": 587,
		"x": -33.9532447807,
		"y": 46.38915507,
		"h": 1.8571428571
	},
	{
		"stop_id": 8576940,
		"ID": 587,
		"x": -34.1422727947,
		"y": 46.427140757,
		"h": 1.8571428571
	},
	{
		"stop_id": 8576942,
		"ID": 587,
		"x": -34.3642365327,
		"y": 45.821160822,
		"h": 1.8571428571
	},
	{
		"stop_id": 8576943,
		"ID": 587,
		"x": -35.1442940377,
		"y": 45.559178347,
		"h": 1.8571428571
	},
	{
		"stop_id": 8576944,
		"ID": 587,
		"x": -35.5892719957,
		"y": 45.463190408,
		"h": 1.8571428571
	},
	{
		"stop_id": 8576946,
		"ID": 587,
		"x": -33.4132493077,
		"y": 46.048199996,
		"h": 1.8571428571
	},
	{
		"stop_id": 8576947,
		"ID": 587,
		"x": -33.6532968657,
		"y": 46.038249512,
		"h": 1.8571428571
	},
	{
		"stop_id": 8576949,
		"ID": 587,
		"x": -33.8082418327,
		"y": 45.327146567,
		"h": 1.8571428571
	},
	{
		"stop_id": 8576950,
		"ID": 587,
		"x": -35.5422776537,
		"y": 43.630176823,
		"h": 1.8571428571
	},
	{
		"stop_id": 8589939,
		"ID": 587,
		"x": -34.0472405577,
		"y": 45.471197875,
		"h": 1.8571428571
	},
	{
		"stop_id": 8589941,
		"ID": 587,
		"x": -33.5492956667,
		"y": 45.61222758,
		"h": 1.8571428571
	},
	{
		"stop_id": 8593525,
		"ID": 587,
		"x": -33.4052944067,
		"y": 46.048235165,
		"h": 1.8571428571
	},
	{
		"stop_id": 8593526,
		"ID": 587,
		"x": -33.5022287697,
		"y": 45.815223143,
		"h": 1.8571428571
	},
	{
		"stop_id": 8593527,
		"ID": 587,
		"x": -33.5352345597,
		"y": 45.292208566,
		"h": 1.8571428571
	},
	{
		"stop_id": 8593531,
		"ID": 587,
		"x": -33.9452958507,
		"y": 45.813176679,
		"h": 1.8571428571
	},
	{
		"stop_id": 8594385,
		"ID": 587,
		"x": -34.5412419757,
		"y": 46.631229867,
		"h": 1.8571428571
	},
	{
		"stop_id": 8508201,
		"ID": 514,
		"x": -48.9032536757,
		"y": 9.79119341,
		"h": 1.6923076923
	},
	{
		"stop_id": 8508202,
		"ID": 514,
		"x": -45.8142739837,
		"y": 9.621241633,
		"h": 1.6923076923
	},
	{
		"stop_id": 8508256,
		"ID": 514,
		"x": -45.6902367307,
		"y": 8.538181913,
		"h": 1.6923076923
	},
	{
		"stop_id": 8508260,
		"ID": 514,
		"x": -44.8112749987,
		"y": 12.219248577,
		"h": 1.6923076923
	},
	{
		"stop_id": 8508785,
		"ID": 514,
		"x": -46.7052655117,
		"y": 12.986247818,
		"h": 1.6923076923
	},
	{
		"stop_id": 8571754,
		"ID": 514,
		"x": -47.3192802177,
		"y": 13.713223218,
		"h": 1.6923076923
	},
	{
		"stop_id": 8571755,
		"ID": 514,
		"x": -47.2622974027,
		"y": 13.674209367,
		"h": 1.6923076923
	},
	{
		"stop_id": 8571756,
		"ID": 514,
		"x": -46.7892592947,
		"y": 12.82820435,
		"h": 1.6923076923
	},
	{
		"stop_id": 8571759,
		"ID": 514,
		"x": -44.7792557537,
		"y": 12.82320519,
		"h": 1.6923076923
	},
	{
		"stop_id": 8571760,
		"ID": 514,
		"x": -44.7662545827,
		"y": 12.284172968,
		"h": 1.6923076923
	},
	{
		"stop_id": 8571761,
		"ID": 514,
		"x": -45.2522703647,
		"y": 13.036158735,
		"h": 1.6923076923
	},
	{
		"stop_id": 8571762,
		"ID": 514,
		"x": -45.5422260227,
		"y": 13.1672027,
		"h": 1.6923076923
	},
	{
		"stop_id": 8571763,
		"ID": 514,
		"x": -45.8602564677,
		"y": 13.486184837,
		"h": 1.6923076923
	},
	{
		"stop_id": 8571764,
		"ID": 514,
		"x": -46.4262733977,
		"y": 13.600186562,
		"h": 1.6923076923
	},
	{
		"stop_id": 8580414,
		"ID": 514,
		"x": -47.1312508507,
		"y": 13.00823945,
		"h": 1.6923076923
	},
	{
		"stop_id": 8588253,
		"ID": 514,
		"x": -45.8172885257,
		"y": 9.639244146,
		"h": 1.6923076923
	},
	{
		"stop_id": 8588254,
		"ID": 514,
		"x": -46.2452793377,
		"y": 9.394249861,
		"h": 1.6923076923
	},
	{
		"stop_id": 8588255,
		"ID": 514,
		"x": -47.0542564437,
		"y": 9.267199246,
		"h": 1.6923076923
	},
	{
		"stop_id": 8588257,
		"ID": 514,
		"x": -48.5572613617,
		"y": 9.046212087,
		"h": 1.6923076923
	},
	{
		"stop_id": 8588705,
		"ID": 514,
		"x": -44.9472853347,
		"y": 10.830174951,
		"h": 1.6923076923
	},
	{
		"stop_id": 8588706,
		"ID": 514,
		"x": -45.6182437557,
		"y": 9.955208721,
		"h": 1.6923076923
	},
	{
		"stop_id": 8589265,
		"ID": 514,
		"x": -45.3112852957,
		"y": 10.330247312,
		"h": 1.6923076923
	},
	{
		"stop_id": 8508203,
		"ID": 548,
		"x": -42.6552692367,
		"y": 11.747190492,
		"h": 1.2637362637
	},
	{
		"stop_id": 8508204,
		"ID": 548,
		"x": -39.9752507527,
		"y": 11.788219674,
		"h": 1.2637362637
	},
	{
		"stop_id": 8508750,
		"ID": 548,
		"x": -42.5082746267,
		"y": 15.668152386,
		"h": 1.2637362637
	},
	{
		"stop_id": 8508751,
		"ID": 548,
		"x": -43.6232283837,
		"y": 15.547210461,
		"h": 1.2637362637
	},
	{
		"stop_id": 8508880,
		"ID": 548,
		"x": -41.8132795017,
		"y": 15.623165308,
		"h": 1.2637362637
	},
	{
		"stop_id": 8571751,
		"ID": 548,
		"x": -41.3812240347,
		"y": 15.952205234,
		"h": 1.2637362637
	},
	{
		"stop_id": 8571752,
		"ID": 548,
		"x": -40.1342421297,
		"y": 16.434191356,
		"h": 1.2637362637
	},
	{
		"stop_id": 8580777,
		"ID": 548,
		"x": -42.7522445867,
		"y": 11.980150293,
		"h": 1.2637362637
	},
	{
		"stop_id": 8589280,
		"ID": 548,
		"x": -40.0422913337,
		"y": 11.830243793,
		"h": 1.2637362637
	},
	{
		"stop_id": 8508205,
		"ID": 582,
		"x": -37.8952925617,
		"y": 13.973161764,
		"h": 2.1208791209
	},
	{
		"stop_id": 8508206,
		"ID": 582,
		"x": -36.2442596557,
		"y": 17.15023701,
		"h": 2.1208791209
	},
	{
		"stop_id": 8508207,
		"ID": 582,
		"x": -33.4312605087,
		"y": 16.171178017,
		"h": 2.1208791209
	},
	{
		"stop_id": 8508269,
		"ID": 582,
		"x": -36.1082591917,
		"y": 19.128183917,
		"h": 2.1208791209
	},
	{
		"stop_id": 8508774,
		"ID": 582,
		"x": -38.9452548747,
		"y": 16.831191273,
		"h": 2.1208791209
	},
	{
		"stop_id": 8508879,
		"ID": 582,
		"x": -39.1192430587,
		"y": 16.439155706,
		"h": 2.1208791209
	},
	{
		"stop_id": 8508984,
		"ID": 582,
		"x": -35.6582833547,
		"y": 17.529215009,
		"h": 2.1208791209
	},
	{
		"stop_id": 8508988,
		"ID": 582,
		"x": -37.1852885367,
		"y": 14.900179759,
		"h": 2.1208791209
	},
	{
		"stop_id": 8576664,
		"ID": 582,
		"x": -33.3692426597,
		"y": 16.128205173,
		"h": 2.1208791209
	},
	{
		"stop_id": 8576690,
		"ID": 582,
		"x": -34.0742502387,
		"y": 16.83619434,
		"h": 2.1208791209
	},
	{
		"stop_id": 8576691,
		"ID": 582,
		"x": -33.8402742027,
		"y": 17.60717771,
		"h": 2.1208791209
	},
	{
		"stop_id": 8576695,
		"ID": 582,
		"x": -34.8272896487,
		"y": 16.870144108,
		"h": 2.1208791209
	},
	{
		"stop_id": 8576700,
		"ID": 582,
		"x": -33.9982617397,
		"y": 16.21518254,
		"h": 2.1208791209
	},
	{
		"stop_id": 8576702,
		"ID": 582,
		"x": -35.8762622567,
		"y": 16.085224601,
		"h": 2.1208791209
	},
	{
		"stop_id": 8576703,
		"ID": 582,
		"x": -36.3912331587,
		"y": 15.872191136,
		"h": 2.1208791209
	},
	{
		"stop_id": 8576704,
		"ID": 582,
		"x": -37.8542888277,
		"y": 14.029230373,
		"h": 2.1208791209
	},
	{
		"stop_id": 8576705,
		"ID": 582,
		"x": -36.8492262277,
		"y": 14.489232316,
		"h": 2.1208791209
	},
	{
		"stop_id": 8576706,
		"ID": 582,
		"x": -36.3082252027,
		"y": 14.235186192,
		"h": 2.1208791209
	},
	{
		"stop_id": 8588355,
		"ID": 582,
		"x": -33.4982724967,
		"y": 16.537194344,
		"h": 2.1208791209
	},
	{
		"stop_id": 8588356,
		"ID": 582,
		"x": -33.7882244977,
		"y": 16.681231486,
		"h": 2.1208791209
	},
	{
		"stop_id": 8588358,
		"ID": 582,
		"x": -34.2622896087,
		"y": 16.797147942,
		"h": 2.1208791209
	},
	{
		"stop_id": 8588360,
		"ID": 582,
		"x": -33.6322283607,
		"y": 16.264238085,
		"h": 2.1208791209
	},
	{
		"stop_id": 8588361,
		"ID": 582,
		"x": -36.9042438637,
		"y": 15.315246041,
		"h": 2.1208791209
	},
	{
		"stop_id": 8588362,
		"ID": 582,
		"x": -37.0712754307,
		"y": 15.020230294,
		"h": 2.1208791209
	},
	{
		"stop_id": 8588363,
		"ID": 582,
		"x": -36.0302799777,
		"y": 13.848181922,
		"h": 2.1208791209
	},
	{
		"stop_id": 8588364,
		"ID": 582,
		"x": -37.4602332217,
		"y": 14.534176211,
		"h": 2.1208791209
	},
	{
		"stop_id": 8588365,
		"ID": 582,
		"x": -37.6672482697,
		"y": 14.307176892,
		"h": 2.1208791209
	},
	{
		"stop_id": 8588384,
		"ID": 582,
		"x": -34.1242252957,
		"y": 16.77216773,
		"h": 2.1208791209
	},
	{
		"stop_id": 8588385,
		"ID": 582,
		"x": -33.4092751907,
		"y": 16.366158524,
		"h": 2.1208791209
	},
	{
		"stop_id": 8588631,
		"ID": 582,
		"x": -33.9462849037,
		"y": 16.52223986,
		"h": 2.1208791209
	},
	{
		"stop_id": 8588633,
		"ID": 582,
		"x": -35.8962700067,
		"y": 19.291224639,
		"h": 2.1208791209
	},
	{
		"stop_id": 8588931,
		"ID": 582,
		"x": -33.1672564017,
		"y": 16.545213923,
		"h": 2.1208791209
	},
	{
		"stop_id": 8588932,
		"ID": 582,
		"x": -33.3812687377,
		"y": 16.490238172,
		"h": 2.1208791209
	},
	{
		"stop_id": 8593270,
		"ID": 582,
		"x": -33.8512445087,
		"y": 16.324208856,
		"h": 2.1208791209
	},
	{
		"stop_id": 8594291,
		"ID": 582,
		"x": -34.1092364047,
		"y": 17.041156156,
		"h": 2.1208791209
	},
	{
		"stop_id": 8508208,
		"ID": 614,
		"x": -28.7042320127,
		"y": 14.243204772,
		"h": 1.8571428571
	},
	{
		"stop_id": 8508990,
		"ID": 614,
		"x": -31.3842797737,
		"y": 15.397210162,
		"h": 1.8571428571
	},
	{
		"stop_id": 8576665,
		"ID": 614,
		"x": -32.3122503217,
		"y": 16.08715271,
		"h": 1.8571428571
	},
	{
		"stop_id": 8576666,
		"ID": 614,
		"x": -31.2142487277,
		"y": 14.810142699,
		"h": 1.8571428571
	},
	{
		"stop_id": 8576667,
		"ID": 614,
		"x": -30.7372741257,
		"y": 14.516162565,
		"h": 1.8571428571
	},
	{
		"stop_id": 8576668,
		"ID": 614,
		"x": -30.2422330537,
		"y": 14.445208405,
		"h": 1.8571428571
	},
	{
		"stop_id": 8576669,
		"ID": 614,
		"x": -29.4922461007,
		"y": 14.494198315,
		"h": 1.8571428571
	},
	{
		"stop_id": 8576670,
		"ID": 614,
		"x": -29.2112646707,
		"y": 14.388233077,
		"h": 1.8571428571
	},
	{
		"stop_id": 8576671,
		"ID": 614,
		"x": -28.7102819387,
		"y": 14.264184852,
		"h": 1.8571428571
	},
	{
		"stop_id": 8576679,
		"ID": 614,
		"x": -30.8232631377,
		"y": 16.092160788,
		"h": 1.8571428571
	},
	{
		"stop_id": 8576680,
		"ID": 614,
		"x": -30.6292431227,
		"y": 16.467194733,
		"h": 1.8571428571
	},
	{
		"stop_id": 8588353,
		"ID": 614,
		"x": -33.1602621277,
		"y": 16.033188426,
		"h": 1.8571428571
	},
	{
		"stop_id": 8588354,
		"ID": 614,
		"x": -33.2792610047,
		"y": 16.236216391,
		"h": 1.8571428571
	},
	{
		"stop_id": 8588391,
		"ID": 614,
		"x": -33.0022520167,
		"y": 16.014214794,
		"h": 1.8571428571
	},
	{
		"stop_id": 8588392,
		"ID": 614,
		"x": -32.6432243017,
		"y": 16.081198287,
		"h": 1.8571428571
	},
	{
		"stop_id": 8588393,
		"ID": 614,
		"x": -32.7782467227,
		"y": 16.068248492,
		"h": 1.8571428571
	},
	{
		"stop_id": 8588394,
		"ID": 614,
		"x": -32.0322375747,
		"y": 16.015180328,
		"h": 1.8571428571
	},
	{
		"stop_id": 8588395,
		"ID": 614,
		"x": -31.6882777867,
		"y": 15.688159093,
		"h": 1.8571428571
	},
	{
		"stop_id": 8588400,
		"ID": 614,
		"x": -28.5712534937,
		"y": 14.494143335,
		"h": 1.8571428571
	},
	{
		"stop_id": 8588924,
		"ID": 614,
		"x": -33.1482688887,
		"y": 16.470146201,
		"h": 1.8571428571
	},
	{
		"stop_id": 8588925,
		"ID": 614,
		"x": -32.8722260897,
		"y": 16.394225858,
		"h": 1.8571428571
	},
	{
		"stop_id": 8588926,
		"ID": 614,
		"x": -32.6262833537,
		"y": 16.409231439,
		"h": 1.8571428571
	},
	{
		"stop_id": 8588927,
		"ID": 614,
		"x": -32.3272621597,
		"y": 16.372239331,
		"h": 1.8571428571
	},
	{
		"stop_id": 8588928,
		"ID": 614,
		"x": -32.4822266717,
		"y": 16.426228035,
		"h": 1.8571428571
	},
	{
		"stop_id": 8588929,
		"ID": 614,
		"x": -32.6812562527,
		"y": 16.510148901,
		"h": 1.8571428571
	},
	{
		"stop_id": 8588930,
		"ID": 614,
		"x": -32.8672294387,
		"y": 16.55322381,
		"h": 1.8571428571
	},
	{
		"stop_id": 8594290,
		"ID": 614,
		"x": -31.4032426637,
		"y": 15.188228893,
		"h": 1.8571428571
	},
	{
		"stop_id": 8508210,
		"ID": 679,
		"x": -21.8272690887,
		"y": 13.577213432,
		"h": 1.1648351648
	},
	{
		"stop_id": 8581293,
		"ID": 679,
		"x": -21.8442761237,
		"y": 13.556205303,
		"h": 1.1648351648
	},
	{
		"stop_id": 8581813,
		"ID": 679,
		"x": -22.9652369847,
		"y": 11.894192978,
		"h": 1.1648351648
	},
	{
		"stop_id": 8581814,
		"ID": 679,
		"x": -22.2152602797,
		"y": 12.717185375,
		"h": 1.1648351648
	},
	{
		"stop_id": 8583067,
		"ID": 679,
		"x": -19.4062851677,
		"y": 15.14223608,
		"h": 1.1648351648
	},
	{
		"stop_id": 8583068,
		"ID": 679,
		"x": -20.2422555087,
		"y": 14.73521264,
		"h": 1.1648351648
	},
	{
		"stop_id": 8508211,
		"ID": 710,
		"x": -15.8552485237,
		"y": 17.542238122,
		"h": 1.1648351648
	},
	{
		"stop_id": 8508679,
		"ID": 710,
		"x": -16.0042270937,
		"y": 15.220176981,
		"h": 1.1648351648
	},
	{
		"stop_id": 8572870,
		"ID": 710,
		"x": -15.8452386607,
		"y": 17.537197622,
		"h": 1.1648351648
	},
	{
		"stop_id": 8572871,
		"ID": 710,
		"x": -16.4282654677,
		"y": 16.806203338,
		"h": 1.1648351648
	},
	{
		"stop_id": 8572872,
		"ID": 710,
		"x": -16.4782705997,
		"y": 16.330241168,
		"h": 1.1648351648
	},
	{
		"stop_id": 8572873,
		"ID": 710,
		"x": -16.2622885947,
		"y": 15.885224097,
		"h": 1.1648351648
	},
	{
		"stop_id": 8508212,
		"ID": 740,
		"x": -13.4562763797,
		"y": 20.61818155,
		"h": 1.7582417582
	},
	{
		"stop_id": 8508213,
		"ID": 740,
		"x": -12.2992776237,
		"y": 22.355249268,
		"h": 1.7582417582
	},
	{
		"stop_id": 8572832,
		"ID": 740,
		"x": -13.1622426257,
		"y": 20.781225257,
		"h": 1.7582417582
	},
	{
		"stop_id": 8572833,
		"ID": 740,
		"x": -13.4412556987,
		"y": 20.614184473,
		"h": 1.7582417582
	},
	{
		"stop_id": 8577051,
		"ID": 740,
		"x": -12.3112795387,
		"y": 22.305236323,
		"h": 1.7582417582
	},
	{
		"stop_id": 8577052,
		"ID": 740,
		"x": -12.0902616377,
		"y": 22.36714131,
		"h": 1.7582417582
	},
	{
		"stop_id": 8577053,
		"ID": 740,
		"x": -12.0732566237,
		"y": 22.13314219,
		"h": 1.7582417582
	},
	{
		"stop_id": 8577054,
		"ID": 740,
		"x": -11.8082617827,
		"y": 21.161147158,
		"h": 1.7582417582
	},
	{
		"stop_id": 8577055,
		"ID": 740,
		"x": -11.3482973657,
		"y": 20.893143928,
		"h": 1.7582417582
	},
	{
		"stop_id": 8577056,
		"ID": 740,
		"x": -10.6042344857,
		"y": 20.531228343,
		"h": 1.7582417582
	},
	{
		"stop_id": 8577057,
		"ID": 740,
		"x": -9.8872750367,
		"y": 20.209201835,
		"h": 1.7582417582
	},
	{
		"stop_id": 8577058,
		"ID": 740,
		"x": -9.1642612737,
		"y": 20.089206329,
		"h": 1.7582417582
	},
	{
		"stop_id": 8577059,
		"ID": 740,
		"x": -9.0572783957,
		"y": 19.561141695,
		"h": 1.7582417582
	},
	{
		"stop_id": 8579700,
		"ID": 740,
		"x": -8.5992563847,
		"y": 19.300225464,
		"h": 1.7582417582
	},
	{
		"stop_id": 8579705,
		"ID": 740,
		"x": -12.6922856267,
		"y": 20.380231792,
		"h": 1.7582417582
	},
	{
		"stop_id": 8579706,
		"ID": 740,
		"x": -12.7762710617,
		"y": 19.719193816,
		"h": 1.7582417582
	},
	{
		"stop_id": 8579707,
		"ID": 740,
		"x": -12.9092462947,
		"y": 19.295242361,
		"h": 1.7582417582
	},
	{
		"stop_id": 8579708,
		"ID": 740,
		"x": -12.8422677507,
		"y": 18.955240349,
		"h": 1.7582417582
	},
	{
		"stop_id": 8579709,
		"ID": 740,
		"x": -12.9972306637,
		"y": 18.634177639,
		"h": 1.7582417582
	},
	{
		"stop_id": 8582261,
		"ID": 740,
		"x": -12.4932481997,
		"y": 21.316226693,
		"h": 1.7582417582
	},
	{
		"stop_id": 8582390,
		"ID": 740,
		"x": -12.6672609577,
		"y": 20.980216659,
		"h": 1.7582417582
	},
	{
		"stop_id": 8582757,
		"ID": 740,
		"x": -12.9682358057,
		"y": 20.686241335,
		"h": 1.7582417582
	},
	{
		"stop_id": 8583897,
		"ID": 740,
		"x": -12.1792822557,
		"y": 22.169207088,
		"h": 1.7582417582
	},
	{
		"stop_id": 8587025,
		"ID": 740,
		"x": -13.2642535237,
		"y": 17.441197324,
		"h": 1.7582417582
	},
	{
		"stop_id": 8508215,
		"ID": 742,
		"x": -11.0322491357,
		"y": 29.235234118,
		"h": 1.6263736264
	},
	{
		"stop_id": 8508216,
		"ID": 742,
		"x": -9.3542590137,
		"y": 29.420161615,
		"h": 1.6263736264
	},
	{
		"stop_id": 8508297,
		"ID": 742,
		"x": -14.0052254147,
		"y": 32.319197354,
		"h": 1.6263736264
	},
	{
		"stop_id": 8516354,
		"ID": 742,
		"x": -11.6972860497,
		"y": 30.308143786,
		"h": 1.6263736264
	},
	{
		"stop_id": 8557027,
		"ID": 742,
		"x": -12.8722683937,
		"y": 33.150149945,
		"h": 1.6263736264
	},
	{
		"stop_id": 8572818,
		"ID": 742,
		"x": -14.0922621577,
		"y": 31.199202808,
		"h": 1.6263736264
	},
	{
		"stop_id": 8572840,
		"ID": 742,
		"x": -11.0602865617,
		"y": 29.263244129,
		"h": 1.6263736264
	},
	{
		"stop_id": 8572843,
		"ID": 742,
		"x": -11.6332755817,
		"y": 29.558216821,
		"h": 1.6263736264
	},
	{
		"stop_id": 8572844,
		"ID": 742,
		"x": -11.7062942907,
		"y": 29.304145724,
		"h": 1.6263736264
	},
	{
		"stop_id": 8572845,
		"ID": 742,
		"x": -11.9642792927,
		"y": 28.758198615,
		"h": 1.6263736264
	},
	{
		"stop_id": 8577296,
		"ID": 742,
		"x": -9.6712445227,
		"y": 33.518157955,
		"h": 1.6263736264
	},
	{
		"stop_id": 8577336,
		"ID": 742,
		"x": -9.2972832737,
		"y": 30.903190221,
		"h": 1.6263736264
	},
	{
		"stop_id": 8577337,
		"ID": 742,
		"x": -10.1522381327,
		"y": 29.5272084,
		"h": 1.6263736264
	},
	{
		"stop_id": 8588142,
		"ID": 742,
		"x": -11.5282667247,
		"y": 29.632218858,
		"h": 1.6263736264
	},
	{
		"stop_id": 8588143,
		"ID": 742,
		"x": -11.5682733557,
		"y": 30.089165499,
		"h": 1.6263736264
	},
	{
		"stop_id": 8588144,
		"ID": 742,
		"x": -11.7252541747,
		"y": 30.300247372,
		"h": 1.6263736264
	},
	{
		"stop_id": 8588145,
		"ID": 742,
		"x": -11.7582728537,
		"y": 30.495208128,
		"h": 1.6263736264
	},
	{
		"stop_id": 8588147,
		"ID": 742,
		"x": -11.4892754557,
		"y": 30.54118196,
		"h": 1.6263736264
	},
	{
		"stop_id": 8589865,
		"ID": 742,
		"x": -9.3032265217,
		"y": 29.360223815,
		"h": 1.6263736264
	},
	{
		"stop_id": 8593492,
		"ID": 742,
		"x": -10.8612659997,
		"y": 30.576202387,
		"h": 1.6263736264
	},
	{
		"stop_id": 8508217,
		"ID": 771,
		"x": -6.1902738747,
		"y": 27.329245674,
		"h": 1.1648351648
	},
	{
		"stop_id": 8508674,
		"ID": 771,
		"x": -4.7342989357,
		"y": 25.96823029,
		"h": 1.1648351648
	},
	{
		"stop_id": 8572830,
		"ID": 771,
		"x": -4.3242554417,
		"y": 26.233178934,
		"h": 1.1648351648
	},
	{
		"stop_id": 8577291,
		"ID": 771,
		"x": -5.2212633997,
		"y": 31.027227391,
		"h": 1.1648351648
	},
	{
		"stop_id": 8589866,
		"ID": 771,
		"x": -6.0242938677,
		"y": 27.103158252,
		"h": 1.1648351648
	},
	{
		"stop_id": 8595907,
		"ID": 771,
		"x": -3.6532795027,
		"y": 27.18523346,
		"h": 1.1648351648
	},
	{
		"stop_id": 8508254,
		"ID": 513,
		"x": -46.6122390567,
		"y": 2.685153755,
		"h": 1.4285714286
	},
	{
		"stop_id": 8508255,
		"ID": 513,
		"x": -46.0562420967,
		"y": 5.045174981,
		"h": 1.4285714286
	},
	{
		"stop_id": 8571624,
		"ID": 513,
		"x": -49.2382576717,
		"y": 5.378177395,
		"h": 1.4285714286
	},
	{
		"stop_id": 8576609,
		"ID": 513,
		"x": -46.0462864407,
		"y": 5.028188782,
		"h": 1.4285714286
	},
	{
		"stop_id": 8576610,
		"ID": 513,
		"x": -45.8212670177,
		"y": 4.839162315,
		"h": 1.4285714286
	},
	{
		"stop_id": 8576611,
		"ID": 513,
		"x": -44.2352874737,
		"y": 4.761224334,
		"h": 1.4285714286
	},
	{
		"stop_id": 8576612,
		"ID": 513,
		"x": -43.5092667067,
		"y": 4.907217173,
		"h": 1.4285714286
	},
	{
		"stop_id": 8576621,
		"ID": 513,
		"x": -45.0822245007,
		"y": 4.443156269,
		"h": 1.4285714286
	},
	{
		"stop_id": 8581745,
		"ID": 513,
		"x": -49.2252918257,
		"y": 5.641225941,
		"h": 1.4285714286
	},
	{
		"stop_id": 8583108,
		"ID": 513,
		"x": -46.8442831077,
		"y": 3.633143899,
		"h": 1.4285714286
	},
	{
		"stop_id": 8583316,
		"ID": 513,
		"x": -48.9542826527,
		"y": 3.896242034,
		"h": 1.4285714286
	},
	{
		"stop_id": 8588561,
		"ID": 513,
		"x": -48.1172642177,
		"y": 2.305196768,
		"h": 1.4285714286
	},
	{
		"stop_id": 8588564,
		"ID": 513,
		"x": -48.4922975857,
		"y": 3.000177866,
		"h": 1.4285714286
	},
	{
		"stop_id": 8593311,
		"ID": 513,
		"x": -47.8122737017,
		"y": 2.873198286,
		"h": 1.4285714286
	},
	{
		"stop_id": 8508261,
		"ID": 515,
		"x": -45.3942436787,
		"y": 14.489148901,
		"h": 1.6593406593
	},
	{
		"stop_id": 8508262,
		"ID": 515,
		"x": -46.0112799397,
		"y": 17.06620012,
		"h": 1.6593406593
	},
	{
		"stop_id": 8508263,
		"ID": 515,
		"x": -45.6662921487,
		"y": 19.061187895,
		"h": 1.6593406593
	},
	{
		"stop_id": 8571743,
		"ID": 515,
		"x": -48.5792627257,
		"y": 14.858140204,
		"h": 1.6593406593
	},
	{
		"stop_id": 8571744,
		"ID": 515,
		"x": -48.0932993227,
		"y": 15.019148169,
		"h": 1.6593406593
	},
	{
		"stop_id": 8571745,
		"ID": 515,
		"x": -46.5072880157,
		"y": 15.346162703,
		"h": 1.6593406593
	},
	{
		"stop_id": 8571746,
		"ID": 515,
		"x": -45.8242525507,
		"y": 14.812198592,
		"h": 1.6593406593
	},
	{
		"stop_id": 8571747,
		"ID": 515,
		"x": -45.5552772027,
		"y": 14.692208243,
		"h": 1.6593406593
	},
	{
		"stop_id": 8571748,
		"ID": 515,
		"x": -45.4502908187,
		"y": 14.517141326,
		"h": 1.6593406593
	},
	{
		"stop_id": 8571749,
		"ID": 515,
		"x": -45.1832952747,
		"y": 14.939230875,
		"h": 1.6593406593
	},
	{
		"stop_id": 8571750,
		"ID": 515,
		"x": -44.3282622607,
		"y": 15.2041741,
		"h": 1.6593406593
	},
	{
		"stop_id": 8571770,
		"ID": 515,
		"x": -43.7922932097,
		"y": 17.01121325,
		"h": 1.6593406593
	},
	{
		"stop_id": 8571771,
		"ID": 515,
		"x": -43.3952304927,
		"y": 16.300232248,
		"h": 1.6593406593
	},
	{
		"stop_id": 8575852,
		"ID": 515,
		"x": -46.0092639057,
		"y": 17.050196113,
		"h": 1.6593406593
	},
	{
		"stop_id": 8575910,
		"ID": 515,
		"x": -46.4702436147,
		"y": 17.018142202,
		"h": 1.6593406593
	},
	{
		"stop_id": 8576138,
		"ID": 515,
		"x": -46.7422991957,
		"y": 16.754182884,
		"h": 1.6593406593
	},
	{
		"stop_id": 8576141,
		"ID": 515,
		"x": -47.3992616617,
		"y": 16.60316027,
		"h": 1.6593406593
	},
	{
		"stop_id": 8576144,
		"ID": 515,
		"x": -47.6382443397,
		"y": 16.182225854,
		"h": 1.6593406593
	},
	{
		"stop_id": 8579424,
		"ID": 515,
		"x": -46.2042426747,
		"y": 17.188160927,
		"h": 1.6593406593
	},
	{
		"stop_id": 8579436,
		"ID": 515,
		"x": -47.6652239257,
		"y": 15.513146268,
		"h": 1.6593406593
	},
	{
		"stop_id": 8579894,
		"ID": 515,
		"x": -47.6862973177,
		"y": 15.351239498,
		"h": 1.6593406593
	},
	{
		"stop_id": 8508264,
		"ID": 516,
		"x": -43.1452279587,
		"y": 22.279166818,
		"h": 1
	},
	{
		"stop_id": 8508265,
		"ID": 550,
		"x": -43.2432519047,
		"y": 24.672212784,
		"h": 1.3956043956
	},
	{
		"stop_id": 8508266,
		"ID": 550,
		"x": -41.1782339747,
		"y": 23.445246515,
		"h": 1.3956043956
	},
	{
		"stop_id": 8508662,
		"ID": 550,
		"x": -40.6182798307,
		"y": 26.77618823,
		"h": 1.3956043956
	},
	{
		"stop_id": 8508884,
		"ID": 550,
		"x": -41.9712436317,
		"y": 25.660176413,
		"h": 1.3956043956
	},
	{
		"stop_id": 8571528,
		"ID": 550,
		"x": -43.1992931157,
		"y": 24.668220694,
		"h": 1.3956043956
	},
	{
		"stop_id": 8571529,
		"ID": 550,
		"x": -42.7542908337,
		"y": 24.972189696,
		"h": 1.3956043956
	},
	{
		"stop_id": 8571530,
		"ID": 550,
		"x": -41.1752251677,
		"y": 26.127184662,
		"h": 1.3956043956
	},
	{
		"stop_id": 8571531,
		"ID": 550,
		"x": -40.3902835937,
		"y": 27.254187743,
		"h": 1.3956043956
	},
	{
		"stop_id": 8571765,
		"ID": 550,
		"x": -41.1572362087,
		"y": 23.418185612,
		"h": 1.3956043956
	},
	{
		"stop_id": 8576497,
		"ID": 550,
		"x": -44.1122253617,
		"y": 24.664211823,
		"h": 1.3956043956
	},
	{
		"stop_id": 8582597,
		"ID": 550,
		"x": -41.4342576957,
		"y": 23.085149021,
		"h": 1.3956043956
	},
	{
		"stop_id": 8589069,
		"ID": 550,
		"x": -43.5512764237,
		"y": 24.732183321,
		"h": 1.3956043956
	},
	{
		"stop_id": 8589070,
		"ID": 550,
		"x": -44.1732758117,
		"y": 25.013245611,
		"h": 1.3956043956
	},
	{
		"stop_id": 8508267,
		"ID": 583,
		"x": -39.0862563877,
		"y": 22.544156228,
		"h": 1.6263736264
	},
	{
		"stop_id": 8508268,
		"ID": 583,
		"x": -36.7592515607,
		"y": 20.254155405,
		"h": 1.6263736264
	},
	{
		"stop_id": 8508271,
		"ID": 583,
		"x": -38.0362258167,
		"y": 23.844144701,
		"h": 1.6263736264
	},
	{
		"stop_id": 8508668,
		"ID": 583,
		"x": -35.2392786247,
		"y": 24.252170295,
		"h": 1.6263736264
	},
	{
		"stop_id": 8571538,
		"ID": 583,
		"x": -38.0592277097,
		"y": 23.833166363,
		"h": 1.6263736264
	},
	{
		"stop_id": 8571539,
		"ID": 583,
		"x": -37.1972861587,
		"y": 23.438243581,
		"h": 1.6263736264
	},
	{
		"stop_id": 8571540,
		"ID": 583,
		"x": -36.6562736437,
		"y": 23.22418756,
		"h": 1.6263736264
	},
	{
		"stop_id": 8571541,
		"ID": 583,
		"x": -36.2112417587,
		"y": 23.638150176,
		"h": 1.6263736264
	},
	{
		"stop_id": 8571542,
		"ID": 583,
		"x": -35.7892369557,
		"y": 24.090186555,
		"h": 1.6263736264
	},
	{
		"stop_id": 8571543,
		"ID": 583,
		"x": -34.8892888077,
		"y": 24.5322143,
		"h": 1.6263736264
	},
	{
		"stop_id": 8571544,
		"ID": 583,
		"x": -34.6592373317,
		"y": 24.903158985,
		"h": 1.6263736264
	},
	{
		"stop_id": 8587242,
		"ID": 583,
		"x": -39.0692879077,
		"y": 22.564225843,
		"h": 1.6263736264
	},
	{
		"stop_id": 8587243,
		"ID": 583,
		"x": -38.1562300437,
		"y": 23.761220374,
		"h": 1.6263736264
	},
	{
		"stop_id": 8587448,
		"ID": 583,
		"x": -37.0612718257,
		"y": 24.752152851,
		"h": 1.6263736264
	},
	{
		"stop_id": 8588634,
		"ID": 583,
		"x": -36.7372384587,
		"y": 21.29714605,
		"h": 1.6263736264
	},
	{
		"stop_id": 8588635,
		"ID": 583,
		"x": -37.1782896617,
		"y": 21.82920473,
		"h": 1.6263736264
	},
	{
		"stop_id": 8588636,
		"ID": 583,
		"x": -37.6862780167,
		"y": 22.300237788,
		"h": 1.6263736264
	},
	{
		"stop_id": 8588641,
		"ID": 583,
		"x": -36.6342884697,
		"y": 20.209167245,
		"h": 1.6263736264
	},
	{
		"stop_id": 8588642,
		"ID": 583,
		"x": -36.3312275977,
		"y": 20.037250239,
		"h": 1.6263736264
	},
	{
		"stop_id": 8588643,
		"ID": 583,
		"x": -36.0532410227,
		"y": 19.764193919,
		"h": 1.6263736264
	},
	{
		"stop_id": 8508272,
		"ID": 584,
		"x": -37.0552769167,
		"y": 25.737168306,
		"h": 1.4615384615
	},
	{
		"stop_id": 8508281,
		"ID": 584,
		"x": -34.0382886267,
		"y": 27.732158773,
		"h": 1.4615384615
	},
	{
		"stop_id": 8508282,
		"ID": 584,
		"x": -35.3682405137,
		"y": 26.34014155,
		"h": 1.4615384615
	},
	{
		"stop_id": 8508283,
		"ID": 584,
		"x": -35.6372795597,
		"y": 26.045219572,
		"h": 1.4615384615
	},
	{
		"stop_id": 8571535,
		"ID": 584,
		"x": -38.0032932067,
		"y": 30.239174287,
		"h": 1.4615384615
	},
	{
		"stop_id": 8571536,
		"ID": 584,
		"x": -37.5002987157,
		"y": 30.106171374,
		"h": 1.4615384615
	},
	{
		"stop_id": 8571537,
		"ID": 584,
		"x": -36.1112344537,
		"y": 29.847243246,
		"h": 1.4615384615
	},
	{
		"stop_id": 8587244,
		"ID": 584,
		"x": -37.0772588387,
		"y": 25.700175477,
		"h": 1.4615384615
	},
	{
		"stop_id": 8587245,
		"ID": 584,
		"x": -36.5242373237,
		"y": 26.042153719,
		"h": 1.4615384615
	},
	{
		"stop_id": 8587246,
		"ID": 584,
		"x": -36.2462997347,
		"y": 26.192211703,
		"h": 1.4615384615
	},
	{
		"stop_id": 8587350,
		"ID": 584,
		"x": -34.9782266807,
		"y": 27.095167064,
		"h": 1.4615384615
	},
	{
		"stop_id": 8588512,
		"ID": 584,
		"x": -33.4122262427,
		"y": 27.920211611,
		"h": 1.4615384615
	},
	{
		"stop_id": 8593272,
		"ID": 584,
		"x": -36.9652399487,
		"y": 26.827230361,
		"h": 1.4615384615
	},
	{
		"stop_id": 8593273,
		"ID": 584,
		"x": -36.7072796657,
		"y": 27.697150236,
		"h": 1.4615384615
	},
	{
		"stop_id": 8593274,
		"ID": 584,
		"x": -36.5582785017,
		"y": 26.195218286,
		"h": 1.4615384615
	},
	{
		"stop_id": 8508292,
		"ID": 683,
		"x": -24.3022740667,
		"y": 37.265168684,
		"h": 1.4285714286
	},
	{
		"stop_id": 8508293,
		"ID": 683,
		"x": -22.7292403667,
		"y": 38.185157376,
		"h": 1.4285714286
	},
	{
		"stop_id": 8508294,
		"ID": 683,
		"x": -19.3902436597,
		"y": 38.592173936,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572751,
		"ID": 683,
		"x": -24.2722530437,
		"y": 37.282246107,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572753,
		"ID": 683,
		"x": -23.2302951997,
		"y": 35.269237013,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572768,
		"ID": 683,
		"x": -22.7502318047,
		"y": 38.169239892,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572769,
		"ID": 683,
		"x": -23.0232471657,
		"y": 38.375230256,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572790,
		"ID": 683,
		"x": -18.4172870487,
		"y": 36.330156025,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572791,
		"ID": 683,
		"x": -18.6452775247,
		"y": 36.245196731,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572792,
		"ID": 683,
		"x": -18.9852618497,
		"y": 36.034182818,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572793,
		"ID": 683,
		"x": -19.3352794447,
		"y": 35.385194724,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572794,
		"ID": 683,
		"x": -19.8832835407,
		"y": 34.761250528,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572795,
		"ID": 683,
		"x": -19.9302888487,
		"y": 34.400168381,
		"h": 1.4285714286
	},
	{
		"stop_id": 8581080,
		"ID": 683,
		"x": -23.9352499617,
		"y": 36.669231617,
		"h": 1.4285714286
	},
	{
		"stop_id": 8508295,
		"ID": 713,
		"x": -17.3672476407,
		"y": 36.644156431,
		"h": 1.3296703297
	},
	{
		"stop_id": 8572788,
		"ID": 713,
		"x": -17.3562709017,
		"y": 36.605211226,
		"h": 1.3296703297
	},
	{
		"stop_id": 8572816,
		"ID": 713,
		"x": -14.0392548957,
		"y": 32.330165311,
		"h": 1.3296703297
	},
	{
		"stop_id": 8581502,
		"ID": 713,
		"x": -17.5582827697,
		"y": 36.788221168,
		"h": 1.3296703297
	},
	{
		"stop_id": 8581975,
		"ID": 713,
		"x": -17.7032683387,
		"y": 36.483237772,
		"h": 1.3296703297
	},
	{
		"stop_id": 8583232,
		"ID": 713,
		"x": -17.6172825027,
		"y": 36.450158193,
		"h": 1.3296703297
	},
	{
		"stop_id": 8583233,
		"ID": 713,
		"x": -17.8692569187,
		"y": 35.968208054,
		"h": 1.3296703297
	},
	{
		"stop_id": 8583234,
		"ID": 713,
		"x": -18.1872984427,
		"y": 35.975209917,
		"h": 1.3296703297
	},
	{
		"stop_id": 8583235,
		"ID": 713,
		"x": -18.0272678777,
		"y": 36.326202422,
		"h": 1.3296703297
	},
	{
		"stop_id": 8591789,
		"ID": 713,
		"x": -17.7072980017,
		"y": 36.581156573,
		"h": 1.3296703297
	},
	{
		"stop_id": 8591790,
		"ID": 713,
		"x": -18.0342933947,
		"y": 36.419208609,
		"h": 1.3296703297
	},
	{
		"stop_id": 8508303,
		"ID": 676,
		"x": -19.9772585197,
		"y": -6.286829419,
		"h": 1.0659340659
	},
	{
		"stop_id": 8508374,
		"ID": 676,
		"x": -19.6852328067,
		"y": -6.283776202,
		"h": 1.0659340659
	},
	{
		"stop_id": 8582706,
		"ID": 676,
		"x": -19.9772518927,
		"y": -6.287829904,
		"h": 1.0659340659
	},
	{
		"stop_id": 8508304,
		"ID": 706,
		"x": -17.6122624297,
		"y": -4.484859079,
		"h": 1.3956043956
	},
	{
		"stop_id": 8508329,
		"ID": 706,
		"x": -15.2982910177,
		"y": -3.94677589,
		"h": 1.3956043956
	},
	{
		"stop_id": 8508378,
		"ID": 706,
		"x": -15.3482567157,
		"y": -6.446814398,
		"h": 1.3956043956
	},
	{
		"stop_id": 8576726,
		"ID": 706,
		"x": -14.7212688727,
		"y": -4.194831149,
		"h": 1.3956043956
	},
	{
		"stop_id": 8582707,
		"ID": 706,
		"x": -17.5552344267,
		"y": -4.477788205,
		"h": 1.3956043956
	},
	{
		"stop_id": 8583066,
		"ID": 706,
		"x": -14.0272402317,
		"y": -6.114836947,
		"h": 1.3956043956
	},
	{
		"stop_id": 8587021,
		"ID": 706,
		"x": -14.4452563927,
		"y": -6.284762254,
		"h": 1.3956043956
	},
	{
		"stop_id": 8587022,
		"ID": 706,
		"x": -14.8012360307,
		"y": -6.882755917,
		"h": 1.3956043956
	},
	{
		"stop_id": 8587024,
		"ID": 706,
		"x": -13.9902428377,
		"y": -7.64981952,
		"h": 1.3956043956
	},
	{
		"stop_id": 8587233,
		"ID": 706,
		"x": -13.8162622707,
		"y": -6.84784123,
		"h": 1.3956043956
	},
	{
		"stop_id": 8587234,
		"ID": 706,
		"x": -14.3012972917,
		"y": -7.35980404,
		"h": 1.3956043956
	},
	{
		"stop_id": 8588414,
		"ID": 706,
		"x": -14.1622823567,
		"y": -6.669826788,
		"h": 1.3956043956
	},
	{
		"stop_id": 8588415,
		"ID": 706,
		"x": -13.5082681547,
		"y": -7.147749411,
		"h": 1.3956043956
	},
	{
		"stop_id": 8508305,
		"ID": 736,
		"x": -13.8772408067,
		"y": -4.210783585,
		"h": 2.021978022
	},
	{
		"stop_id": 8508306,
		"ID": 736,
		"x": -9.9192443177,
		"y": -5.200771619,
		"h": 2.021978022
	},
	{
		"stop_id": 8508350,
		"ID": 736,
		"x": -13.9422698267,
		"y": -4.169813649,
		"h": 2.021978022
	},
	{
		"stop_id": 8508376,
		"ID": 736,
		"x": -13.9192566887,
		"y": -4.331836124,
		"h": 2.021978022
	},
	{
		"stop_id": 8508697,
		"ID": 736,
		"x": -9.3202290727,
		"y": -4.495832218,
		"h": 2.021978022
	},
	{
		"stop_id": 8508698,
		"ID": 736,
		"x": -10.8272813997,
		"y": -4.598802834,
		"h": 2.021978022
	},
	{
		"stop_id": 8508699,
		"ID": 736,
		"x": -9.4822418327,
		"y": -4.757777533,
		"h": 2.021978022
	},
	{
		"stop_id": 8576727,
		"ID": 736,
		"x": -14.3232458817,
		"y": -4.288772124,
		"h": 2.021978022
	},
	{
		"stop_id": 8576728,
		"ID": 736,
		"x": -13.9282875267,
		"y": -4.219844927,
		"h": 2.021978022
	},
	{
		"stop_id": 8576729,
		"ID": 736,
		"x": -13.1712793337,
		"y": -4.176774198,
		"h": 2.021978022
	},
	{
		"stop_id": 8576730,
		"ID": 736,
		"x": -13.0412456057,
		"y": -4.106837406,
		"h": 2.021978022
	},
	{
		"stop_id": 8576731,
		"ID": 736,
		"x": -12.7692296817,
		"y": -3.893822376,
		"h": 2.021978022
	},
	{
		"stop_id": 8576732,
		"ID": 736,
		"x": -12.5872544117,
		"y": -3.716855655,
		"h": 2.021978022
	},
	{
		"stop_id": 8576733,
		"ID": 736,
		"x": -12.0002604057,
		"y": -3.794812866,
		"h": 2.021978022
	},
	{
		"stop_id": 8576734,
		"ID": 736,
		"x": -11.2182832267,
		"y": -4.37185373,
		"h": 2.021978022
	},
	{
		"stop_id": 8576735,
		"ID": 736,
		"x": -11.0902936257,
		"y": -4.268761973,
		"h": 2.021978022
	},
	{
		"stop_id": 8576736,
		"ID": 736,
		"x": -10.9152938167,
		"y": -4.196857627,
		"h": 2.021978022
	},
	{
		"stop_id": 8576737,
		"ID": 736,
		"x": -13.0902748527,
		"y": -4.561796712,
		"h": 2.021978022
	},
	{
		"stop_id": 8576739,
		"ID": 736,
		"x": -12.5472397387,
		"y": -5.122853832,
		"h": 2.021978022
	},
	{
		"stop_id": 8576740,
		"ID": 736,
		"x": -12.1152709507,
		"y": -4.859856372,
		"h": 2.021978022
	},
	{
		"stop_id": 8576741,
		"ID": 736,
		"x": -11.7702521057,
		"y": -4.831760687,
		"h": 2.021978022
	},
	{
		"stop_id": 8576742,
		"ID": 736,
		"x": -11.1792593287,
		"y": -4.510835445,
		"h": 2.021978022
	},
	{
		"stop_id": 8579962,
		"ID": 736,
		"x": -9.9232494587,
		"y": -5.187797837,
		"h": 2.021978022
	},
	{
		"stop_id": 8581559,
		"ID": 736,
		"x": -13.3872941487,
		"y": -4.362768446,
		"h": 2.021978022
	},
	{
		"stop_id": 8581560,
		"ID": 736,
		"x": -8.9612413137,
		"y": -4.478796546,
		"h": 2.021978022
	},
	{
		"stop_id": 8581571,
		"ID": 736,
		"x": -9.7012410337,
		"y": -4.391853292,
		"h": 2.021978022
	},
	{
		"stop_id": 8581979,
		"ID": 736,
		"x": -11.3272336747,
		"y": -3.965847435,
		"h": 2.021978022
	},
	{
		"stop_id": 8582661,
		"ID": 736,
		"x": -12.3302303397,
		"y": -3.53484374,
		"h": 2.021978022
	},
	{
		"stop_id": 8587231,
		"ID": 736,
		"x": -12.8082993507,
		"y": -4.788831957,
		"h": 2.021978022
	},
	{
		"stop_id": 8587232,
		"ID": 736,
		"x": -13.0462806167,
		"y": -6.012789326,
		"h": 2.021978022
	},
	{
		"stop_id": 8587521,
		"ID": 736,
		"x": -9.1502566207,
		"y": -4.635811289,
		"h": 2.021978022
	},
	{
		"stop_id": 8588413,
		"ID": 736,
		"x": -12.2922805727,
		"y": -5.74484526,
		"h": 2.021978022
	},
	{
		"stop_id": 8508308,
		"ID": 791,
		"x": -2.7472235547,
		"y": -7.173821212,
		"h": 2.3186813187
	},
	{
		"stop_id": 8508359,
		"ID": 791,
		"x": 0.9707680733,
		"y": -9.923788067,
		"h": 2.3186813187
	},
	{
		"stop_id": 8508395,
		"ID": 791,
		"x": 0.7437505313,
		"y": -9.557765013,
		"h": 2.3186813187
	},
	{
		"stop_id": 8508767,
		"ID": 791,
		"x": 0.7007496663,
		"y": -9.555752361,
		"h": 2.3186813187
	},
	{
		"stop_id": 8508778,
		"ID": 791,
		"x": -0.7972343577,
		"y": -6.572771961,
		"h": 2.3186813187
	},
	{
		"stop_id": 8508981,
		"ID": 791,
		"x": -3.5432600937,
		"y": -10.293809414,
		"h": 2.3186813187
	},
	{
		"stop_id": 8530341,
		"ID": 791,
		"x": -2.4732791317,
		"y": -8.042803279,
		"h": 2.3186813187
	},
	{
		"stop_id": 8530342,
		"ID": 791,
		"x": -2.8412362807,
		"y": -8.594826238,
		"h": 2.3186813187
	},
	{
		"stop_id": 8530343,
		"ID": 791,
		"x": -2.1462618537,
		"y": -7.055799065,
		"h": 2.3186813187
	},
	{
		"stop_id": 8530344,
		"ID": 791,
		"x": -0.8602620177,
		"y": -6.521806737,
		"h": 2.3186813187
	},
	{
		"stop_id": 8530760,
		"ID": 791,
		"x": -1.6442326037,
		"y": -7.838838048,
		"h": 2.3186813187
	},
	{
		"stop_id": 8530799,
		"ID": 791,
		"x": -2.3012259697,
		"y": -7.637826158,
		"h": 2.3186813187
	},
	{
		"stop_id": 8530800,
		"ID": 791,
		"x": 0.4727538173,
		"y": -9.279778868,
		"h": 2.3186813187
	},
	{
		"stop_id": 8530801,
		"ID": 791,
		"x": -0.1572734647,
		"y": -8.852826887,
		"h": 2.3186813187
	},
	{
		"stop_id": 8570264,
		"ID": 791,
		"x": -1.0062736747,
		"y": -8.988820986,
		"h": 2.3186813187
	},
	{
		"stop_id": 8571581,
		"ID": 791,
		"x": -2.6922767527,
		"y": -7.163849433,
		"h": 2.3186813187
	},
	{
		"stop_id": 8571582,
		"ID": 791,
		"x": -2.1422379647,
		"y": -8.215843205,
		"h": 2.3186813187
	},
	{
		"stop_id": 8571583,
		"ID": 791,
		"x": -0.7202782997,
		"y": -8.560781054,
		"h": 2.3186813187
	},
	{
		"stop_id": 8571584,
		"ID": 791,
		"x": -0.8592622977,
		"y": -8.750805771,
		"h": 2.3186813187
	},
	{
		"stop_id": 8571585,
		"ID": 791,
		"x": -1.3782615037,
		"y": -9.055817748,
		"h": 2.3186813187
	},
	{
		"stop_id": 8571586,
		"ID": 791,
		"x": -2.1442498687,
		"y": -9.105795752,
		"h": 2.3186813187
	},
	{
		"stop_id": 8571587,
		"ID": 791,
		"x": -2.8712781447,
		"y": -8.829795138,
		"h": 2.3186813187
	},
	{
		"stop_id": 8571588,
		"ID": 791,
		"x": -3.1042717857,
		"y": -9.032774749,
		"h": 2.3186813187
	},
	{
		"stop_id": 8571592,
		"ID": 791,
		"x": -2.8492897367,
		"y": -6.664842721,
		"h": 2.3186813187
	},
	{
		"stop_id": 8571594,
		"ID": 791,
		"x": -0.2732800497,
		"y": -8.844750092,
		"h": 2.3186813187
	},
	{
		"stop_id": 8571595,
		"ID": 791,
		"x": -0.1372686707,
		"y": -9.234839283,
		"h": 2.3186813187
	},
	{
		"stop_id": 8571596,
		"ID": 791,
		"x": 1.2047590833,
		"y": -9.233813925,
		"h": 2.3186813187
	},
	{
		"stop_id": 8571597,
		"ID": 791,
		"x": 1.6667512753,
		"y": -9.309816528,
		"h": 2.3186813187
	},
	{
		"stop_id": 8581370,
		"ID": 791,
		"x": -2.2482302837,
		"y": -7.447769938,
		"h": 2.3186813187
	},
	{
		"stop_id": 8581371,
		"ID": 791,
		"x": -2.3322366717,
		"y": -7.688817447,
		"h": 2.3186813187
	},
	{
		"stop_id": 8581372,
		"ID": 791,
		"x": -2.4842412077,
		"y": -8.031790655,
		"h": 2.3186813187
	},
	{
		"stop_id": 8581373,
		"ID": 791,
		"x": -2.6002374517,
		"y": -6.946854806,
		"h": 2.3186813187
	},
	{
		"stop_id": 8581374,
		"ID": 791,
		"x": -2.4232806427,
		"y": -7.017762563,
		"h": 2.3186813187
	},
	{
		"stop_id": 8581375,
		"ID": 791,
		"x": -2.2682775697,
		"y": -7.054856715,
		"h": 2.3186813187
	},
	{
		"stop_id": 8581376,
		"ID": 791,
		"x": -2.2842600097,
		"y": -7.293807892,
		"h": 2.3186813187
	},
	{
		"stop_id": 8581562,
		"ID": 791,
		"x": -2.2092367567,
		"y": -6.961795538,
		"h": 2.3186813187
	},
	{
		"stop_id": 8581908,
		"ID": 791,
		"x": -2.3392978587,
		"y": -7.885771014,
		"h": 2.3186813187
	},
	{
		"stop_id": 8581915,
		"ID": 791,
		"x": -1.1622652037,
		"y": -8.503855273,
		"h": 2.3186813187
	},
	{
		"stop_id": 8581992,
		"ID": 791,
		"x": -2.9752312407,
		"y": -6.934849997,
		"h": 2.3186813187
	},
	{
		"stop_id": 8581993,
		"ID": 791,
		"x": -3.1122377727,
		"y": -6.851764867,
		"h": 2.3186813187
	},
	{
		"stop_id": 8581994,
		"ID": 791,
		"x": -2.5332686677,
		"y": -7.171785242,
		"h": 2.3186813187
	},
	{
		"stop_id": 8508309,
		"ID": 765,
		"x": -6.2622879877,
		"y": -3.822773367,
		"h": 1.7582417582
	},
	{
		"stop_id": 8570506,
		"ID": 765,
		"x": -5.2342714557,
		"y": -6.86885916,
		"h": 1.7582417582
	},
	{
		"stop_id": 8570534,
		"ID": 765,
		"x": -6.5812277787,
		"y": -6.112857911,
		"h": 1.7582417582
	},
	{
		"stop_id": 8571576,
		"ID": 765,
		"x": -6.2792630927,
		"y": -3.829817366,
		"h": 1.7582417582
	},
	{
		"stop_id": 8571577,
		"ID": 765,
		"x": -5.3282957607,
		"y": -4.298749631,
		"h": 1.7582417582
	},
	{
		"stop_id": 8571593,
		"ID": 765,
		"x": -4.1762779407,
		"y": -7.276828636,
		"h": 1.7582417582
	},
	{
		"stop_id": 8579711,
		"ID": 765,
		"x": -3.8342623367,
		"y": -6.963815518,
		"h": 1.7582417582
	},
	{
		"stop_id": 8580371,
		"ID": 765,
		"x": -6.2592551587,
		"y": -3.965824697,
		"h": 1.7582417582
	},
	{
		"stop_id": 8580604,
		"ID": 765,
		"x": -8.2732376607,
		"y": -5.921831669,
		"h": 1.7582417582
	},
	{
		"stop_id": 8581363,
		"ID": 765,
		"x": -4.6722829237,
		"y": -7.158778236,
		"h": 1.7582417582
	},
	{
		"stop_id": 8581364,
		"ID": 765,
		"x": -3.8772460647,
		"y": -7.248816262,
		"h": 1.7582417582
	},
	{
		"stop_id": 8581366,
		"ID": 765,
		"x": -4.1692731457,
		"y": -6.431856443,
		"h": 1.7582417582
	},
	{
		"stop_id": 8581368,
		"ID": 765,
		"x": -3.9212668207,
		"y": -6.288810405,
		"h": 1.7582417582
	},
	{
		"stop_id": 8581369,
		"ID": 765,
		"x": -3.3632826857,
		"y": -6.66380213,
		"h": 1.7582417582
	},
	{
		"stop_id": 8581407,
		"ID": 765,
		"x": -3.7952238187,
		"y": -7.190798524,
		"h": 1.7582417582
	},
	{
		"stop_id": 8581472,
		"ID": 765,
		"x": -5.8062550377,
		"y": -6.506827158,
		"h": 1.7582417582
	},
	{
		"stop_id": 8581473,
		"ID": 765,
		"x": -6.1372915467,
		"y": -6.345815263,
		"h": 1.7582417582
	},
	{
		"stop_id": 8581474,
		"ID": 765,
		"x": -7.0322696147,
		"y": -6.032791356,
		"h": 1.7582417582
	},
	{
		"stop_id": 8581475,
		"ID": 765,
		"x": -7.8532380127,
		"y": -5.941782646,
		"h": 1.7582417582
	},
	{
		"stop_id": 8581476,
		"ID": 765,
		"x": -8.0422280887,
		"y": -5.899834799,
		"h": 1.7582417582
	},
	{
		"stop_id": 8581479,
		"ID": 765,
		"x": -4.4972689127,
		"y": -7.211755018,
		"h": 1.7582417582
	},
	{
		"stop_id": 8581555,
		"ID": 765,
		"x": -8.3902694637,
		"y": -6.035784565,
		"h": 1.7582417582
	},
	{
		"stop_id": 8581592,
		"ID": 765,
		"x": -4.0962531117,
		"y": -6.656858983,
		"h": 1.7582417582
	},
	{
		"stop_id": 8587522,
		"ID": 765,
		"x": -7.0322295007,
		"y": -4.523857245,
		"h": 1.7582417582
	},
	{
		"stop_id": 8508310,
		"ID": 766,
		"x": -4.3882787997,
		"y": -0.627792891,
		"h": 1.1318681319
	},
	{
		"stop_id": 8508364,
		"ID": 766,
		"x": -5.4672410277,
		"y": -0.77584652,
		"h": 1.1318681319
	},
	{
		"stop_id": 8508367,
		"ID": 766,
		"x": -6.9662279607,
		"y": -0.329755265,
		"h": 1.1318681319
	},
	{
		"stop_id": 8583070,
		"ID": 766,
		"x": -4.3502735407,
		"y": 0.01925017,
		"h": 1.1318681319
	},
	{
		"stop_id": 8587662,
		"ID": 766,
		"x": -4.7422924557,
		"y": -0.669850733,
		"h": 1.1318681319
	},
	{
		"stop_id": 8508311,
		"ID": 793,
		"x": -3.5052852347,
		"y": 2.495162057,
		"h": 1.1318681319
	},
	{
		"stop_id": 8508312,
		"ID": 793,
		"x": -2.7042336007,
		"y": 4.967231057,
		"h": 1.1318681319
	},
	{
		"stop_id": 8572892,
		"ID": 793,
		"x": -3.2372245337,
		"y": 4.516149731,
		"h": 1.1318681319
	},
	{
		"stop_id": 8572893,
		"ID": 793,
		"x": -2.7042810857,
		"y": 4.996246958,
		"h": 1.1318681319
	},
	{
		"stop_id": 8582460,
		"ID": 793,
		"x": -3.5042580217,
		"y": 2.35320343,
		"h": 1.1318681319
	},
	{
		"stop_id": 8508313,
		"ID": 794,
		"x": 1.2227436373,
		"y": 8.833224905,
		"h": 1.6593406593
	},
	{
		"stop_id": 8508327,
		"ID": 794,
		"x": -0.2622263127,
		"y": 7.680185922,
		"h": 1.6593406593
	},
	{
		"stop_id": 8508743,
		"ID": 794,
		"x": 1.2807675003,
		"y": 8.586229487,
		"h": 1.6593406593
	},
	{
		"stop_id": 8508744,
		"ID": 794,
		"x": 1.2787157743,
		"y": 8.189202667,
		"h": 1.6593406593
	},
	{
		"stop_id": 8508790,
		"ID": 794,
		"x": -0.8482615737,
		"y": 10.538140503,
		"h": 1.6593406593
	},
	{
		"stop_id": 8508851,
		"ID": 794,
		"x": 0.1457425553,
		"y": 9.921202993,
		"h": 1.6593406593
	},
	{
		"stop_id": 8508852,
		"ID": 794,
		"x": -2.3432248197,
		"y": 7.94314082,
		"h": 1.6593406593
	},
	{
		"stop_id": 8508853,
		"ID": 794,
		"x": -0.1572530237,
		"y": 9.529176849,
		"h": 1.6593406593
	},
	{
		"stop_id": 8508977,
		"ID": 794,
		"x": -0.3612949427,
		"y": 9.41019257,
		"h": 1.6593406593
	},
	{
		"stop_id": 8508978,
		"ID": 794,
		"x": -1.4662256117,
		"y": 8.585198482,
		"h": 1.6593406593
	},
	{
		"stop_id": 8508980,
		"ID": 794,
		"x": -2.0442372437,
		"y": 8.244185035,
		"h": 1.6593406593
	},
	{
		"stop_id": 8530815,
		"ID": 794,
		"x": 0.2977108553,
		"y": 9.742177749,
		"h": 1.6593406593
	},
	{
		"stop_id": 8530816,
		"ID": 794,
		"x": -1.4732998097,
		"y": 5.990209722,
		"h": 1.6593406593
	},
	{
		"stop_id": 8530817,
		"ID": 794,
		"x": -2.5252348587,
		"y": 6.849223329,
		"h": 1.6593406593
	},
	{
		"stop_id": 8530818,
		"ID": 794,
		"x": 1.0756999773,
		"y": 8.770248915,
		"h": 1.6593406593
	},
	{
		"stop_id": 8572905,
		"ID": 794,
		"x": -0.3312880297,
		"y": 10.672214932,
		"h": 1.6593406593
	},
	{
		"stop_id": 8572916,
		"ID": 794,
		"x": 1.2437005013,
		"y": 8.834216666,
		"h": 1.6593406593
	},
	{
		"stop_id": 8579959,
		"ID": 794,
		"x": -1.2202508567,
		"y": 10.354164658,
		"h": 1.6593406593
	},
	{
		"stop_id": 8579960,
		"ID": 794,
		"x": 0.3417208733,
		"y": 10.195213201,
		"h": 1.6593406593
	},
	{
		"stop_id": 8581468,
		"ID": 794,
		"x": -0.7922763327,
		"y": 9.002144629,
		"h": 1.6593406593
	},
	{
		"stop_id": 8582459,
		"ID": 794,
		"x": 0.0167606343,
		"y": 7.62315282,
		"h": 1.6593406593
	},
	{
		"stop_id": 8508314,
		"ID": 820,
		"x": 1.8957362993,
		"y": 11.468193824,
		"h": 2.021978022
	},
	{
		"stop_id": 8508323,
		"ID": 820,
		"x": 2.0137647313,
		"y": 12.090216143,
		"h": 2.021978022
	},
	{
		"stop_id": 8508669,
		"ID": 820,
		"x": 2.4927318833,
		"y": 13.463200596,
		"h": 2.021978022
	},
	{
		"stop_id": 8508670,
		"ID": 820,
		"x": 5.3857153713,
		"y": 13.099223624,
		"h": 2.021978022
	},
	{
		"stop_id": 8508745,
		"ID": 820,
		"x": 1.7416999963,
		"y": 8.532246853,
		"h": 2.021978022
	},
	{
		"stop_id": 8508746,
		"ID": 820,
		"x": 1.9957749053,
		"y": 8.752210032,
		"h": 2.021978022
	},
	{
		"stop_id": 8508747,
		"ID": 820,
		"x": 2.6667254023,
		"y": 9.403208582,
		"h": 2.021978022
	},
	{
		"stop_id": 8508748,
		"ID": 820,
		"x": 3.2537538133,
		"y": 9.359220023,
		"h": 2.021978022
	},
	{
		"stop_id": 8508749,
		"ID": 820,
		"x": 3.5347035773,
		"y": 9.199201163,
		"h": 2.021978022
	},
	{
		"stop_id": 8508758,
		"ID": 820,
		"x": 3.5877397943,
		"y": 8.935164473,
		"h": 2.021978022
	},
	{
		"stop_id": 8508769,
		"ID": 820,
		"x": 3.9577354563,
		"y": 12.193208755,
		"h": 2.021978022
	},
	{
		"stop_id": 8508855,
		"ID": 820,
		"x": 4.2757002133,
		"y": 11.882197748,
		"h": 2.021978022
	},
	{
		"stop_id": 8508866,
		"ID": 820,
		"x": 4.4077242383,
		"y": 9.462200138,
		"h": 2.021978022
	},
	{
		"stop_id": 8508970,
		"ID": 820,
		"x": 3.5467239383,
		"y": 12.112244905,
		"h": 2.021978022
	},
	{
		"stop_id": 8508972,
		"ID": 820,
		"x": 0.7887376033,
		"y": 10.795173582,
		"h": 2.021978022
	},
	{
		"stop_id": 8508976,
		"ID": 820,
		"x": 1.2217666753,
		"y": 11.577242829,
		"h": 2.021978022
	},
	{
		"stop_id": 8508979,
		"ID": 820,
		"x": 0.7797354543,
		"y": 11.51916744,
		"h": 2.021978022
	},
	{
		"stop_id": 8530814,
		"ID": 820,
		"x": 1.5727254253,
		"y": 10.683199327,
		"h": 2.021978022
	},
	{
		"stop_id": 8557023,
		"ID": 820,
		"x": 1.7007173373,
		"y": 10.889186515,
		"h": 2.021978022
	},
	{
		"stop_id": 8557024,
		"ID": 820,
		"x": 1.5837149933,
		"y": 9.648158516,
		"h": 2.021978022
	},
	{
		"stop_id": 8572897,
		"ID": 820,
		"x": 1.8887540663,
		"y": 11.406197078,
		"h": 2.021978022
	},
	{
		"stop_id": 8572898,
		"ID": 820,
		"x": 2.8537011733,
		"y": 11.81022426,
		"h": 2.021978022
	},
	{
		"stop_id": 8572904,
		"ID": 820,
		"x": 1.7017412553,
		"y": 11.917237292,
		"h": 2.021978022
	},
	{
		"stop_id": 8572910,
		"ID": 820,
		"x": 1.1797234073,
		"y": 11.238174059,
		"h": 2.021978022
	},
	{
		"stop_id": 8572911,
		"ID": 820,
		"x": 4.1717414023,
		"y": 10.892175222,
		"h": 2.021978022
	},
	{
		"stop_id": 8572912,
		"ID": 820,
		"x": 4.4467222713,
		"y": 9.245158614,
		"h": 2.021978022
	},
	{
		"stop_id": 8580011,
		"ID": 820,
		"x": 2.4877515453,
		"y": 10.287190506,
		"h": 2.021978022
	},
	{
		"stop_id": 8580012,
		"ID": 820,
		"x": 1.5667656373,
		"y": 11.257248268,
		"h": 2.021978022
	},
	{
		"stop_id": 8581466,
		"ID": 820,
		"x": 2.1647634893,
		"y": 11.68120529,
		"h": 2.021978022
	},
	{
		"stop_id": 8581467,
		"ID": 820,
		"x": 2.1697703153,
		"y": 12.8611656,
		"h": 2.021978022
	},
	{
		"stop_id": 8581528,
		"ID": 820,
		"x": 1.9277447143,
		"y": 12.41418403,
		"h": 2.021978022
	},
	{
		"stop_id": 8581862,
		"ID": 820,
		"x": 4.2307210383,
		"y": 9.938249622,
		"h": 2.021978022
	},
	{
		"stop_id": 8508316,
		"ID": 821,
		"x": 3.9567677943,
		"y": 16.609239213,
		"h": 1.5604395604
	},
	{
		"stop_id": 8508317,
		"ID": 821,
		"x": 4.1367033183,
		"y": 18.211219623,
		"h": 1.5604395604
	},
	{
		"stop_id": 8508458,
		"ID": 821,
		"x": 4.0867648453,
		"y": 18.261160334,
		"h": 1.5604395604
	},
	{
		"stop_id": 8508503,
		"ID": 821,
		"x": 4.2567464393,
		"y": 18.311229663,
		"h": 1.5604395604
	},
	{
		"stop_id": 8508733,
		"ID": 821,
		"x": 6.3577563863,
		"y": 15.930227431,
		"h": 1.5604395604
	},
	{
		"stop_id": 8508974,
		"ID": 821,
		"x": 2.8687401733,
		"y": 14.558209133,
		"h": 1.5604395604
	},
	{
		"stop_id": 8572900,
		"ID": 821,
		"x": 5.8147284253,
		"y": 15.372141132,
		"h": 1.5604395604
	},
	{
		"stop_id": 8572907,
		"ID": 821,
		"x": 3.2077034793,
		"y": 14.905192538,
		"h": 1.5604395604
	},
	{
		"stop_id": 8572908,
		"ID": 821,
		"x": 3.6047184073,
		"y": 16.497211001,
		"h": 1.5604395604
	},
	{
		"stop_id": 8572909,
		"ID": 821,
		"x": 3.9507606853,
		"y": 16.594166312,
		"h": 1.5604395604
	},
	{
		"stop_id": 8581160,
		"ID": 821,
		"x": 2.4697684513,
		"y": 15.80121998,
		"h": 1.5604395604
	},
	{
		"stop_id": 8581164,
		"ID": 821,
		"x": 3.5117322233,
		"y": 16.311228031,
		"h": 1.5604395604
	},
	{
		"stop_id": 8581326,
		"ID": 821,
		"x": 3.0997470723,
		"y": 16.074189271,
		"h": 1.5604395604
	},
	{
		"stop_id": 8582115,
		"ID": 821,
		"x": 6.3967343343,
		"y": 17.493145248,
		"h": 1.5604395604
	},
	{
		"stop_id": 8582120,
		"ID": 821,
		"x": 5.8557195433,
		"y": 16.654240776,
		"h": 1.5604395604
	},
	{
		"stop_id": 8582121,
		"ID": 821,
		"x": 5.7247033243,
		"y": 16.137164353,
		"h": 1.5604395604
	},
	{
		"stop_id": 8582122,
		"ID": 821,
		"x": 6.1047594723,
		"y": 16.954156639,
		"h": 1.5604395604
	},
	{
		"stop_id": 8582458,
		"ID": 821,
		"x": 4.1287469643,
		"y": 18.229145263,
		"h": 1.5604395604
	},
	{
		"stop_id": 8508319,
		"ID": 847,
		"x": 6.2777007413,
		"y": 25.176242355,
		"h": 2.7472527473
	},
	{
		"stop_id": 8508478,
		"ID": 847,
		"x": 8.8957663443,
		"y": 24.161140841,
		"h": 2.7472527473
	},
	{
		"stop_id": 8508479,
		"ID": 847,
		"x": 8.0537719383,
		"y": 27.925169974,
		"h": 2.7472527473
	},
	{
		"stop_id": 8508480,
		"ID": 847,
		"x": 10.7757349963,
		"y": 23.324195872,
		"h": 2.7472527473
	},
	{
		"stop_id": 8508485,
		"ID": 847,
		"x": 9.4947724153,
		"y": 27.997202456,
		"h": 2.7472527473
	},
	{
		"stop_id": 8508504,
		"ID": 847,
		"x": 9.8507031713,
		"y": 27.025183337,
		"h": 2.7472527473
	},
	{
		"stop_id": 8516351,
		"ID": 847,
		"x": 5.9167206403,
		"y": 26.188212795,
		"h": 2.7472527473
	},
	{
		"stop_id": 8577144,
		"ID": 847,
		"x": 7.7807294843,
		"y": 27.385185755,
		"h": 2.7472527473
	},
	{
		"stop_id": 8577147,
		"ID": 847,
		"x": 6.4137435623,
		"y": 25.792235376,
		"h": 2.7472527473
	},
	{
		"stop_id": 8577148,
		"ID": 847,
		"x": 5.8067417473,
		"y": 24.732227906,
		"h": 2.7472527473
	},
	{
		"stop_id": 8577189,
		"ID": 847,
		"x": 9.5687354763,
		"y": 28.022187622,
		"h": 2.7472527473
	},
	{
		"stop_id": 8577190,
		"ID": 847,
		"x": 10.2627478433,
		"y": 27.921225319,
		"h": 2.7472527473
	},
	{
		"stop_id": 8588417,
		"ID": 847,
		"x": 6.7697091883,
		"y": 25.949175261,
		"h": 2.7472527473
	},
	{
		"stop_id": 8588747,
		"ID": 847,
		"x": 6.0007178453,
		"y": 25.271244171,
		"h": 2.7472527473
	},
	{
		"stop_id": 8588748,
		"ID": 847,
		"x": 6.6147594233,
		"y": 25.348194745,
		"h": 2.7472527473
	},
	{
		"stop_id": 8589673,
		"ID": 847,
		"x": 6.6357192163,
		"y": 27.086158736,
		"h": 2.7472527473
	},
	{
		"stop_id": 8589674,
		"ID": 847,
		"x": 7.9237657403,
		"y": 25.335211391,
		"h": 2.7472527473
	},
	{
		"stop_id": 8589675,
		"ID": 847,
		"x": 8.5567583773,
		"y": 24.232186439,
		"h": 2.7472527473
	},
	{
		"stop_id": 8589676,
		"ID": 847,
		"x": 6.1087008323,
		"y": 24.181214955,
		"h": 2.7472527473
	},
	{
		"stop_id": 8589677,
		"ID": 847,
		"x": 7.7057319203,
		"y": 25.601240839,
		"h": 2.7472527473
	},
	{
		"stop_id": 8589678,
		"ID": 847,
		"x": 8.4927132493,
		"y": 26.600242683,
		"h": 2.7472527473
	},
	{
		"stop_id": 8589679,
		"ID": 847,
		"x": 6.3197509983,
		"y": 25.272210429,
		"h": 2.7472527473
	},
	{
		"stop_id": 8589680,
		"ID": 847,
		"x": 8.8047122593,
		"y": 24.143195109,
		"h": 2.7472527473
	},
	{
		"stop_id": 8589681,
		"ID": 847,
		"x": 6.5627737143,
		"y": 25.565194239,
		"h": 2.7472527473
	},
	{
		"stop_id": 8589682,
		"ID": 847,
		"x": 8.6367494533,
		"y": 24.837250599,
		"h": 2.7472527473
	},
	{
		"stop_id": 8589683,
		"ID": 847,
		"x": 8.3897199793,
		"y": 24.648199849,
		"h": 2.7472527473
	},
	{
		"stop_id": 8589684,
		"ID": 847,
		"x": 8.2917306013,
		"y": 25.999245358,
		"h": 2.7472527473
	},
	{
		"stop_id": 8589685,
		"ID": 847,
		"x": 8.4807434813,
		"y": 25.65919313,
		"h": 2.7472527473
	},
	{
		"stop_id": 8589687,
		"ID": 847,
		"x": 6.5947493473,
		"y": 24.884244777,
		"h": 2.7472527473
	},
	{
		"stop_id": 8589688,
		"ID": 847,
		"x": 6.1757324003,
		"y": 24.481248047,
		"h": 2.7472527473
	},
	{
		"stop_id": 8589689,
		"ID": 847,
		"x": 8.7187241163,
		"y": 25.334161805,
		"h": 2.7472527473
	},
	{
		"stop_id": 8589690,
		"ID": 847,
		"x": 7.3517515413,
		"y": 25.687194025,
		"h": 2.7472527473
	},
	{
		"stop_id": 8589691,
		"ID": 847,
		"x": 5.9497440643,
		"y": 24.963162137,
		"h": 2.7472527473
	},
	{
		"stop_id": 8589692,
		"ID": 847,
		"x": 8.4017105023,
		"y": 26.867145517,
		"h": 2.7472527473
	},
	{
		"stop_id": 8589693,
		"ID": 847,
		"x": 6.1287358123,
		"y": 24.736217976,
		"h": 2.7472527473
	},
	{
		"stop_id": 8589694,
		"ID": 847,
		"x": 6.1337039153,
		"y": 26.242191692,
		"h": 2.7472527473
	},
	{
		"stop_id": 8589695,
		"ID": 847,
		"x": 8.6987293953,
		"y": 24.558233937,
		"h": 2.7472527473
	},
	{
		"stop_id": 8589696,
		"ID": 847,
		"x": 6.3977527303,
		"y": 24.580207616,
		"h": 2.7472527473
	},
	{
		"stop_id": 8589702,
		"ID": 847,
		"x": 5.7487719963,
		"y": 25.545197943,
		"h": 2.7472527473
	},
	{
		"stop_id": 8589721,
		"ID": 847,
		"x": 5.8847137263,
		"y": 26.271244939,
		"h": 2.7472527473
	},
	{
		"stop_id": 8589722,
		"ID": 847,
		"x": 5.9817215203,
		"y": 25.760222183,
		"h": 2.7472527473
	},
	{
		"stop_id": 8589733,
		"ID": 847,
		"x": 5.7427133753,
		"y": 25.238166643,
		"h": 2.7472527473
	},
	{
		"stop_id": 8589735,
		"ID": 847,
		"x": 5.8967323603,
		"y": 25.918161395,
		"h": 2.7472527473
	},
	{
		"stop_id": 8589769,
		"ID": 847,
		"x": 7.1547284733,
		"y": 27.459182343,
		"h": 2.7472527473
	},
	{
		"stop_id": 8589780,
		"ID": 847,
		"x": 7.2567283663,
		"y": 27.78419334,
		"h": 2.7472527473
	},
	{
		"stop_id": 8589787,
		"ID": 847,
		"x": 6.8807362563,
		"y": 27.444219653,
		"h": 2.7472527473
	},
	{
		"stop_id": 8589795,
		"ID": 847,
		"x": 7.7777444793,
		"y": 26.957221577,
		"h": 2.7472527473
	},
	{
		"stop_id": 8589811,
		"ID": 847,
		"x": 8.0407083793,
		"y": 27.155212849,
		"h": 2.7472527473
	},
	{
		"stop_id": 8589827,
		"ID": 847,
		"x": 6.6967367293,
		"y": 27.313199273,
		"h": 2.7472527473
	},
	{
		"stop_id": 8589841,
		"ID": 847,
		"x": 6.6807238723,
		"y": 27.495244064,
		"h": 2.7472527473
	},
	{
		"stop_id": 8589842,
		"ID": 847,
		"x": 6.7257516733,
		"y": 27.806158823,
		"h": 2.7472527473
	},
	{
		"stop_id": 8589845,
		"ID": 847,
		"x": 7.4287050933,
		"y": 27.671167788,
		"h": 2.7472527473
	},
	{
		"stop_id": 8589846,
		"ID": 847,
		"x": 7.0237319233,
		"y": 27.951240834,
		"h": 2.7472527473
	},
	{
		"stop_id": 8589853,
		"ID": 847,
		"x": 7.8537725393,
		"y": 27.090163964,
		"h": 2.7472527473
	},
	{
		"stop_id": 8508320,
		"ID": 822,
		"x": 6.7437701533,
		"y": 22.530248353,
		"h": 1.2307692308
	},
	{
		"stop_id": 8508449,
		"ID": 822,
		"x": 3.6157744823,
		"y": 19.927140838,
		"h": 1.2307692308
	},
	{
		"stop_id": 8508455,
		"ID": 822,
		"x": 2.0717656443,
		"y": 22.151184855,
		"h": 1.2307692308
	},
	{
		"stop_id": 8508456,
		"ID": 822,
		"x": 2.4427438843,
		"y": 20.90518007,
		"h": 1.2307692308
	},
	{
		"stop_id": 8595491,
		"ID": 822,
		"x": 6.7047096523,
		"y": 22.342144218,
		"h": 1.2307692308
	},
	{
		"stop_id": 8595492,
		"ID": 822,
		"x": 6.4617190463,
		"y": 22.54923842,
		"h": 1.2307692308
	},
	{
		"stop_id": 8595493,
		"ID": 822,
		"x": 6.6367412743,
		"y": 22.824236292,
		"h": 1.2307692308
	},
	{
		"stop_id": 8595494,
		"ID": 822,
		"x": 6.8167072943,
		"y": 22.545180748,
		"h": 1.2307692308
	},
	{
		"stop_id": 8508351,
		"ID": 707,
		"x": -15.3502569397,
		"y": -2.272818118,
		"h": 1.0989010989
	},
	{
		"stop_id": 8508352,
		"ID": 707,
		"x": -13.9422471787,
		"y": -0.591774111,
		"h": 1.0989010989
	},
	{
		"stop_id": 8508355,
		"ID": 707,
		"x": -13.4872369887,
		"y": -0.608847943,
		"h": 1.0989010989
	},
	{
		"stop_id": 8530354,
		"ID": 707,
		"x": -14.8212444437,
		"y": 1.784199019,
		"h": 1.0989010989
	},
	{
		"stop_id": 8508354,
		"ID": 737,
		"x": -12.3402558617,
		"y": 1.664231402,
		"h": 1.2637362637
	},
	{
		"stop_id": 8508682,
		"ID": 737,
		"x": -13.7182921117,
		"y": 2.750199422,
		"h": 1.2637362637
	},
	{
		"stop_id": 8508683,
		"ID": 737,
		"x": -10.3442584757,
		"y": 2.878230499,
		"h": 1.2637362637
	},
	{
		"stop_id": 8508867,
		"ID": 737,
		"x": -12.3602813207,
		"y": 1.706207154,
		"h": 1.2637362637
	},
	{
		"stop_id": 8572883,
		"ID": 737,
		"x": -13.4312375247,
		"y": 2.668142735,
		"h": 1.2637362637
	},
	{
		"stop_id": 8572884,
		"ID": 737,
		"x": -13.1372692117,
		"y": 2.483208473,
		"h": 1.2637362637
	},
	{
		"stop_id": 8572885,
		"ID": 737,
		"x": -12.5512334357,
		"y": 2.061228439,
		"h": 1.2637362637
	},
	{
		"stop_id": 8572886,
		"ID": 737,
		"x": -10.8832573937,
		"y": 2.023233528,
		"h": 1.2637362637
	},
	{
		"stop_id": 8583236,
		"ID": 737,
		"x": -14.0462502807,
		"y": 2.963140376,
		"h": 1.2637362637
	},
	{
		"stop_id": 8508356,
		"ID": 818,
		"x": 4.4067378393,
		"y": 1.216217498,
		"h": 1.3626373626
	},
	{
		"stop_id": 8508357,
		"ID": 818,
		"x": 3.6307346523,
		"y": -1.86078251,
		"h": 1.3626373626
	},
	{
		"stop_id": 8508854,
		"ID": 818,
		"x": 4.4247279313,
		"y": 1.247205496,
		"h": 1.3626373626
	},
	{
		"stop_id": 8530364,
		"ID": 818,
		"x": 4.6257304973,
		"y": -2.200824616,
		"h": 1.3626373626
	},
	{
		"stop_id": 8530365,
		"ID": 818,
		"x": 5.2787397963,
		"y": -1.481817044,
		"h": 1.3626373626
	},
	{
		"stop_id": 8595205,
		"ID": 818,
		"x": 3.6567529483,
		"y": -1.879851681,
		"h": 1.3626373626
	},
	{
		"stop_id": 8595206,
		"ID": 818,
		"x": 4.0867077443,
		"y": -1.894855749,
		"h": 1.3626373626
	},
	{
		"stop_id": 8595207,
		"ID": 818,
		"x": 4.3287291473,
		"y": -2.07782355,
		"h": 1.3626373626
	},
	{
		"stop_id": 8595208,
		"ID": 818,
		"x": 4.5407734133,
		"y": -2.227750958,
		"h": 1.3626373626
	},
	{
		"stop_id": 8595209,
		"ID": 818,
		"x": 5.6047708783,
		"y": -2.264830525,
		"h": 1.3626373626
	},
	{
		"stop_id": 8595210,
		"ID": 818,
		"x": 6.1497104983,
		"y": -1.722782162,
		"h": 1.3626373626
	},
	{
		"stop_id": 8595455,
		"ID": 818,
		"x": 3.6707121443,
		"y": -1.964752162,
		"h": 1.3626373626
	},
	{
		"stop_id": 8508363,
		"ID": 845,
		"x": 9.0917033543,
		"y": 15.521159816,
		"h": 1.0659340659
	},
	{
		"stop_id": 8508551,
		"ID": 845,
		"x": 10.9937128393,
		"y": 13.721161051,
		"h": 1.0659340659
	},
	{
		"stop_id": 8572901,
		"ID": 845,
		"x": 7.1087653213,
		"y": 16.443214903,
		"h": 1.0659340659
	},
	{
		"stop_id": 8508365,
		"ID": 869,
		"x": 13.0557456383,
		"y": 2.486202318,
		"h": 1.2307692308
	},
	{
		"stop_id": 8508368,
		"ID": 869,
		"x": 14.1477049623,
		"y": 4.656184574,
		"h": 1.2307692308
	},
	{
		"stop_id": 8508399,
		"ID": 869,
		"x": 13.8217023683,
		"y": 3.256232574,
		"h": 1.2307692308
	},
	{
		"stop_id": 8508501,
		"ID": 869,
		"x": 13.2897620713,
		"y": 2.862159995,
		"h": 1.2307692308
	},
	{
		"stop_id": 8508502,
		"ID": 869,
		"x": 14.7967562633,
		"y": 3.200249117,
		"h": 1.2307692308
	},
	{
		"stop_id": 8595400,
		"ID": 869,
		"x": 13.8357650083,
		"y": 3.242174699,
		"h": 1.2307692308
	},
	{
		"stop_id": 8595401,
		"ID": 869,
		"x": 13.3077472203,
		"y": 2.908184125,
		"h": 1.2307692308
	},
	{
		"stop_id": 8595402,
		"ID": 869,
		"x": 14.7987680583,
		"y": 3.161251013,
		"h": 1.2307692308
	},
	{
		"stop_id": 8508366,
		"ID": 868,
		"x": 13.5807151113,
		"y": 0.404154733,
		"h": 1.1648351648
	},
	{
		"stop_id": 8508493,
		"ID": 868,
		"x": 15.4367626363,
		"y": -2.153809659,
		"h": 1.1648351648
	},
	{
		"stop_id": 8508494,
		"ID": 868,
		"x": 14.9937235663,
		"y": -0.843798881,
		"h": 1.1648351648
	},
	{
		"stop_id": 8530371,
		"ID": 868,
		"x": 12.7177045973,
		"y": 0.09914991,
		"h": 1.1648351648
	},
	{
		"stop_id": 8530372,
		"ID": 868,
		"x": 12.6597457303,
		"y": -1.303814368,
		"h": 1.1648351648
	},
	{
		"stop_id": 8530373,
		"ID": 868,
		"x": 11.4387072143,
		"y": -1.681762705,
		"h": 1.1648351648
	},
	{
		"stop_id": 8508380,
		"ID": 792,
		"x": -0.1282344937,
		"y": -3.773831888,
		"h": 1.4945054945
	},
	{
		"stop_id": 8508740,
		"ID": 792,
		"x": -4.0842979447,
		"y": -4.221854777,
		"h": 1.4945054945
	},
	{
		"stop_id": 8508741,
		"ID": 792,
		"x": -2.5442695947,
		"y": -4.91975988,
		"h": 1.4945054945
	},
	{
		"stop_id": 8508742,
		"ID": 792,
		"x": -1.2942590577,
		"y": -6.233777551,
		"h": 1.4945054945
	},
	{
		"stop_id": 8508765,
		"ID": 792,
		"x": -3.5932432957,
		"y": -4.496765327,
		"h": 1.4945054945
	},
	{
		"stop_id": 8508766,
		"ID": 792,
		"x": -2.9132354847,
		"y": -4.941832577,
		"h": 1.4945054945
	},
	{
		"stop_id": 8508795,
		"ID": 792,
		"x": -1.7792469337,
		"y": -5.014806192,
		"h": 1.4945054945
	},
	{
		"stop_id": 8508857,
		"ID": 792,
		"x": -1.6752755137,
		"y": -5.792787117,
		"h": 1.4945054945
	},
	{
		"stop_id": 8508878,
		"ID": 792,
		"x": -1.9322694427,
		"y": -5.209834394,
		"h": 1.4945054945
	},
	{
		"stop_id": 8530345,
		"ID": 792,
		"x": -0.0692403097,
		"y": -5.264853372,
		"h": 1.4945054945
	},
	{
		"stop_id": 8530346,
		"ID": 792,
		"x": 1.2427176033,
		"y": -4.69379125,
		"h": 1.4945054945
	},
	{
		"stop_id": 8530349,
		"ID": 792,
		"x": -1.9392745837,
		"y": -5.180774681,
		"h": 1.4945054945
	},
	{
		"stop_id": 8571578,
		"ID": 792,
		"x": -3.3632754927,
		"y": -4.655808177,
		"h": 1.4945054945
	},
	{
		"stop_id": 8571579,
		"ID": 792,
		"x": -1.7572999477,
		"y": -5.395804998,
		"h": 1.4945054945
	},
	{
		"stop_id": 8571580,
		"ID": 792,
		"x": -1.6922557617,
		"y": -5.5308065,
		"h": 1.4945054945
	},
	{
		"stop_id": 8580744,
		"ID": 792,
		"x": -3.8902641747,
		"y": -4.405820104,
		"h": 1.4945054945
	},
	{
		"stop_id": 8508384,
		"ID": 871,
		"x": 13.1827695163,
		"y": 15.290174826,
		"h": 1.3956043956
	},
	{
		"stop_id": 8508392,
		"ID": 871,
		"x": 12.8597708813,
		"y": 15.947198956,
		"h": 1.3956043956
	},
	{
		"stop_id": 8508497,
		"ID": 871,
		"x": 15.5237232463,
		"y": 15.530215069,
		"h": 1.3956043956
	},
	{
		"stop_id": 8508552,
		"ID": 871,
		"x": 12.4837252703,
		"y": 14.988175383,
		"h": 1.3956043956
	},
	{
		"stop_id": 8508713,
		"ID": 871,
		"x": 12.1617484413,
		"y": 19.380186808,
		"h": 1.3956043956
	},
	{
		"stop_id": 8530681,
		"ID": 871,
		"x": 13.2657098033,
		"y": 15.284183153,
		"h": 1.3956043956
	},
	{
		"stop_id": 8580943,
		"ID": 871,
		"x": 11.7837133023,
		"y": 19.239231098,
		"h": 1.3956043956
	},
	{
		"stop_id": 8581504,
		"ID": 871,
		"x": 12.2787569823,
		"y": 18.43123847,
		"h": 1.3956043956
	},
	{
		"stop_id": 8581505,
		"ID": 871,
		"x": 13.2357426173,
		"y": 16.665212476,
		"h": 1.3956043956
	},
	{
		"stop_id": 8581520,
		"ID": 871,
		"x": 11.6437398713,
		"y": 18.46219521,
		"h": 1.3956043956
	},
	{
		"stop_id": 8581521,
		"ID": 871,
		"x": 12.4327165353,
		"y": 18.680247531,
		"h": 1.3956043956
	},
	{
		"stop_id": 8581522,
		"ID": 871,
		"x": 13.2347465923,
		"y": 16.46619026,
		"h": 1.3956043956
	},
	{
		"stop_id": 8581584,
		"ID": 871,
		"x": 11.9447025453,
		"y": 18.52817069,
		"h": 1.3956043956
	},
	{
		"stop_id": 8508394,
		"ID": 870,
		"x": 13.0947352663,
		"y": 13.057195804,
		"h": 1.3626373626
	},
	{
		"stop_id": 8508396,
		"ID": 870,
		"x": 11.4467012833,
		"y": 8.906214094,
		"h": 1.3626373626
	},
	{
		"stop_id": 8508725,
		"ID": 870,
		"x": 14.8497630543,
		"y": 10.950212315,
		"h": 1.3626373626
	},
	{
		"stop_id": 8508727,
		"ID": 870,
		"x": 15.1067457743,
		"y": 10.374184235,
		"h": 1.3626373626
	},
	{
		"stop_id": 8530374,
		"ID": 870,
		"x": 15.1647033073,
		"y": 10.372241491,
		"h": 1.3626373626
	},
	{
		"stop_id": 8530376,
		"ID": 870,
		"x": 15.1747382963,
		"y": 10.216161806,
		"h": 1.3626373626
	},
	{
		"stop_id": 8530377,
		"ID": 870,
		"x": 15.4927398963,
		"y": 8.909140312,
		"h": 1.3626373626
	},
	{
		"stop_id": 8572920,
		"ID": 870,
		"x": 13.2167051023,
		"y": 13.102153596,
		"h": 1.3626373626
	},
	{
		"stop_id": 8572921,
		"ID": 870,
		"x": 14.1247528313,
		"y": 11.592162027,
		"h": 1.3626373626
	},
	{
		"stop_id": 8572922,
		"ID": 870,
		"x": 14.4727349643,
		"y": 11.414249215,
		"h": 1.3626373626
	},
	{
		"stop_id": 8580003,
		"ID": 870,
		"x": 13.1117264613,
		"y": 13.082195552,
		"h": 1.3626373626
	},
	{
		"stop_id": 8582717,
		"ID": 870,
		"x": 13.5077596553,
		"y": 13.270145047,
		"h": 1.3626373626
	},
	{
		"stop_id": 8508465,
		"ID": 872,
		"x": 14.9966999933,
		"y": 21.977242952,
		"h": 1.7252747253
	},
	{
		"stop_id": 8508466,
		"ID": 872,
		"x": 15.4187282043,
		"y": 20.61024469,
		"h": 1.7252747253
	},
	{
		"stop_id": 8508489,
		"ID": 872,
		"x": 12.0257349643,
		"y": 23.640169748,
		"h": 1.7252747253
	},
	{
		"stop_id": 8508491,
		"ID": 872,
		"x": 11.7707269413,
		"y": 22.985150962,
		"h": 1.7252747253
	},
	{
		"stop_id": 8508710,
		"ID": 872,
		"x": 12.7557529313,
		"y": 20.707177194,
		"h": 1.7252747253
	},
	{
		"stop_id": 8508712,
		"ID": 872,
		"x": 13.5437089593,
		"y": 21.20420752,
		"h": 1.7252747253
	},
	{
		"stop_id": 8508798,
		"ID": 872,
		"x": 15.1077676933,
		"y": 20.430229632,
		"h": 1.7252747253
	},
	{
		"stop_id": 8508799,
		"ID": 872,
		"x": 14.4327648943,
		"y": 21.65523648,
		"h": 1.7252747253
	},
	{
		"stop_id": 8557028,
		"ID": 872,
		"x": 11.9847040143,
		"y": 22.934240922,
		"h": 1.7252747253
	},
	{
		"stop_id": 8557029,
		"ID": 872,
		"x": 11.4297134693,
		"y": 22.737147251,
		"h": 1.7252747253
	},
	{
		"stop_id": 8557030,
		"ID": 872,
		"x": 12.2527209483,
		"y": 22.906226005,
		"h": 1.7252747253
	},
	{
		"stop_id": 8572939,
		"ID": 872,
		"x": 11.9937260533,
		"y": 20.258149024,
		"h": 1.7252747253
	},
	{
		"stop_id": 8572940,
		"ID": 872,
		"x": 13.1337015823,
		"y": 20.989170852,
		"h": 1.7252747253
	},
	{
		"stop_id": 8572941,
		"ID": 872,
		"x": 14.0587318893,
		"y": 21.477160528,
		"h": 1.7252747253
	},
	{
		"stop_id": 8572942,
		"ID": 872,
		"x": 14.5207234623,
		"y": 21.049176157,
		"h": 1.7252747253
	},
	{
		"stop_id": 8572943,
		"ID": 872,
		"x": 14.8217299523,
		"y": 20.666243727,
		"h": 1.7252747253
	},
	{
		"stop_id": 8572944,
		"ID": 872,
		"x": 14.4137739723,
		"y": 20.317173184,
		"h": 1.7252747253
	},
	{
		"stop_id": 8579228,
		"ID": 872,
		"x": 12.3717476423,
		"y": 22.939237853,
		"h": 1.7252747253
	},
	{
		"stop_id": 8579242,
		"ID": 872,
		"x": 11.9977226373,
		"y": 22.490234655,
		"h": 1.7252747253
	},
	{
		"stop_id": 8579244,
		"ID": 872,
		"x": 12.5497403493,
		"y": 22.820204884,
		"h": 1.7252747253
	},
	{
		"stop_id": 8579841,
		"ID": 872,
		"x": 11.1197302203,
		"y": 21.93619204,
		"h": 1.7252747253
	},
	{
		"stop_id": 8579842,
		"ID": 872,
		"x": 12.3087104893,
		"y": 22.704220901,
		"h": 1.7252747253
	},
	{
		"stop_id": 8581322,
		"ID": 872,
		"x": 13.7897314763,
		"y": 20.034175726,
		"h": 1.7252747253
	},
	{
		"stop_id": 8508467,
		"ID": 900,
		"x": 19.1777356723,
		"y": 19.724158485,
		"h": 1.4285714286
	},
	{
		"stop_id": 8508496,
		"ID": 900,
		"x": 19.0107732483,
		"y": 16.760218319,
		"h": 1.4285714286
	},
	{
		"stop_id": 8508500,
		"ID": 900,
		"x": 18.9917743213,
		"y": 19.645211507,
		"h": 1.4285714286
	},
	{
		"stop_id": 8508728,
		"ID": 900,
		"x": 18.7377038753,
		"y": 20.005205682,
		"h": 1.4285714286
	},
	{
		"stop_id": 8508729,
		"ID": 900,
		"x": 16.6237005203,
		"y": 20.333240698,
		"h": 1.4285714286
	},
	{
		"stop_id": 8508797,
		"ID": 900,
		"x": 19.1457291113,
		"y": 19.70416778,
		"h": 1.4285714286
	},
	{
		"stop_id": 8508887,
		"ID": 900,
		"x": 18.1507195283,
		"y": 20.155174327,
		"h": 1.4285714286
	},
	{
		"stop_id": 8530721,
		"ID": 900,
		"x": 17.9357007673,
		"y": 20.26822359,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572945,
		"ID": 900,
		"x": 15.8657474143,
		"y": 20.458234766,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572946,
		"ID": 900,
		"x": 17.0217306353,
		"y": 20.225162645,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572947,
		"ID": 900,
		"x": 19.4407755913,
		"y": 19.385203609,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572948,
		"ID": 900,
		"x": 19.8937074563,
		"y": 19.170198555,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572950,
		"ID": 900,
		"x": 21.4877021333,
		"y": 18.805200185,
		"h": 1.4285714286
	},
	{
		"stop_id": 8580610,
		"ID": 900,
		"x": 18.4997284643,
		"y": 20.074239142,
		"h": 1.4285714286
	},
	{
		"stop_id": 8508495,
		"ID": 931,
		"x": 21.4577379443,
		"y": 17.330198829,
		"h": 1.3296703297
	},
	{
		"stop_id": 8508735,
		"ID": 931,
		"x": 23.0357343533,
		"y": 18.816226206,
		"h": 1.3296703297
	},
	{
		"stop_id": 8508755,
		"ID": 931,
		"x": 22.2207100093,
		"y": 18.587181526,
		"h": 1.3296703297
	},
	{
		"stop_id": 8530385,
		"ID": 931,
		"x": 22.4927435793,
		"y": 18.529215117,
		"h": 1.3296703297
	},
	{
		"stop_id": 8530386,
		"ID": 931,
		"x": 23.7137139213,
		"y": 17.490147903,
		"h": 1.3296703297
	},
	{
		"stop_id": 8530682,
		"ID": 931,
		"x": 22.0577451513,
		"y": 18.630198202,
		"h": 1.3296703297
	},
	{
		"stop_id": 8572951,
		"ID": 931,
		"x": 23.7537455203,
		"y": 18.831224122,
		"h": 1.3296703297
	},
	{
		"stop_id": 8572952,
		"ID": 931,
		"x": 24.8127704233,
		"y": 18.901158607,
		"h": 1.3296703297
	},
	{
		"stop_id": 8572953,
		"ID": 931,
		"x": 25.6017056073,
		"y": 18.885140738,
		"h": 1.3296703297
	},
	{
		"stop_id": 8573101,
		"ID": 931,
		"x": 25.0677213403,
		"y": 13.760176716,
		"h": 1.3296703297
	},
	{
		"stop_id": 8573102,
		"ID": 931,
		"x": 24.6167694073,
		"y": 13.738230127,
		"h": 1.3296703297
	},
	{
		"stop_id": 8508646,
		"ID": 709,
		"x": -15.9712580177,
		"y": 11.858212159,
		"h": 1.2637362637
	},
	{
		"stop_id": 8508647,
		"ID": 709,
		"x": -15.5582518977,
		"y": 8.234243731,
		"h": 1.2637362637
	},
	{
		"stop_id": 8508707,
		"ID": 709,
		"x": -15.7942386837,
		"y": 12.843167092,
		"h": 1.2637362637
	},
	{
		"stop_id": 8508759,
		"ID": 709,
		"x": -15.7882516747,
		"y": 10.12915139,
		"h": 1.2637362637
	},
	{
		"stop_id": 8572874,
		"ID": 709,
		"x": -15.9852784297,
		"y": 13.681234062,
		"h": 1.2637362637
	},
	{
		"stop_id": 8572875,
		"ID": 709,
		"x": -15.8302809157,
		"y": 11.120168802,
		"h": 1.2637362637
	},
	{
		"stop_id": 8572876,
		"ID": 709,
		"x": -15.6882325067,
		"y": 9.692200604,
		"h": 1.2637362637
	},
	{
		"stop_id": 8572877,
		"ID": 709,
		"x": -15.6212823487,
		"y": 9.234218603,
		"h": 1.2637362637
	},
	{
		"stop_id": 8572878,
		"ID": 709,
		"x": -15.6922639627,
		"y": 8.748206259,
		"h": 1.2637362637
	},
	{
		"stop_id": 8508648,
		"ID": 708,
		"x": -15.7682591887,
		"y": 6.939210062,
		"h": 1.2637362637
	},
	{
		"stop_id": 8508649,
		"ID": 708,
		"x": -15.9762759447,
		"y": 5.087230632,
		"h": 1.2637362637
	},
	{
		"stop_id": 8508681,
		"ID": 708,
		"x": -15.8972692037,
		"y": 4.507158559,
		"h": 1.2637362637
	},
	{
		"stop_id": 8508789,
		"ID": 708,
		"x": -14.2712924407,
		"y": 3.223237849,
		"h": 1.2637362637
	},
	{
		"stop_id": 8508865,
		"ID": 708,
		"x": -15.6432299007,
		"y": 4.085236656,
		"h": 1.2637362637
	},
	{
		"stop_id": 8530353,
		"ID": 708,
		"x": -14.3142462657,
		"y": 3.101179058,
		"h": 1.2637362637
	},
	{
		"stop_id": 8572879,
		"ID": 708,
		"x": -15.9582636607,
		"y": 5.973179116,
		"h": 1.2637362637
	},
	{
		"stop_id": 8572881,
		"ID": 708,
		"x": -14.9772403847,
		"y": 3.661163868,
		"h": 1.2637362637
	},
	{
		"stop_id": 8572882,
		"ID": 708,
		"x": -14.6032265567,
		"y": 3.433177306,
		"h": 1.2637362637
	},
	{
		"stop_id": 8508650,
		"ID": 714,
		"x": -15.7872958767,
		"y": 39.468179864,
		"h": 1.5274725275
	},
	{
		"stop_id": 8508651,
		"ID": 714,
		"x": -17.0122249007,
		"y": 39.728206486,
		"h": 1.5274725275
	},
	{
		"stop_id": 8508652,
		"ID": 714,
		"x": -18.0922750787,
		"y": 41.855179242,
		"h": 1.5274725275
	},
	{
		"stop_id": 8572763,
		"ID": 714,
		"x": -18.0322684367,
		"y": 42.099191516,
		"h": 1.5274725275
	},
	{
		"stop_id": 8572802,
		"ID": 714,
		"x": -17.3032843587,
		"y": 37.508238432,
		"h": 1.5274725275
	},
	{
		"stop_id": 8572804,
		"ID": 714,
		"x": -16.8172968167,
		"y": 38.780147316,
		"h": 1.5274725275
	},
	{
		"stop_id": 8572805,
		"ID": 714,
		"x": -16.0722541817,
		"y": 39.105199446,
		"h": 1.5274725275
	},
	{
		"stop_id": 8572806,
		"ID": 714,
		"x": -16.1052886137,
		"y": 39.690199421,
		"h": 1.5274725275
	},
	{
		"stop_id": 8572807,
		"ID": 714,
		"x": -17.0912469297,
		"y": 40.341232727,
		"h": 1.5274725275
	},
	{
		"stop_id": 8572808,
		"ID": 714,
		"x": -17.6042588637,
		"y": 41.580221719,
		"h": 1.5274725275
	},
	{
		"stop_id": 8573246,
		"ID": 714,
		"x": -17.3322686437,
		"y": 37.167161671,
		"h": 1.5274725275
	},
	{
		"stop_id": 8577304,
		"ID": 714,
		"x": -14.0422667577,
		"y": 38.088248794,
		"h": 1.5274725275
	},
	{
		"stop_id": 8577305,
		"ID": 714,
		"x": -14.4042849677,
		"y": 38.285158652,
		"h": 1.5274725275
	},
	{
		"stop_id": 8587733,
		"ID": 714,
		"x": -17.3262353387,
		"y": 37.46015747,
		"h": 1.5274725275
	},
	{
		"stop_id": 8587736,
		"ID": 714,
		"x": -14.5742711397,
		"y": 40.192244234,
		"h": 1.5274725275
	},
	{
		"stop_id": 8588509,
		"ID": 714,
		"x": -15.2422670077,
		"y": 38.943240674,
		"h": 1.5274725275
	},
	{
		"stop_id": 8588510,
		"ID": 714,
		"x": -15.3612253497,
		"y": 39.892149483,
		"h": 1.5274725275
	},
	{
		"stop_id": 8508653,
		"ID": 684,
		"x": -18.6812657527,
		"y": 43.399251154,
		"h": 1.2307692308
	},
	{
		"stop_id": 8572761,
		"ID": 684,
		"x": -19.0782574537,
		"y": 43.948195623,
		"h": 1.2307692308
	},
	{
		"stop_id": 8572764,
		"ID": 684,
		"x": -19.0952904367,
		"y": 42.002230129,
		"h": 1.2307692308
	},
	{
		"stop_id": 8572765,
		"ID": 684,
		"x": -19.5422347877,
		"y": 42.430234788,
		"h": 1.2307692308
	},
	{
		"stop_id": 8572766,
		"ID": 684,
		"x": -21.0662765087,
		"y": 42.819159729,
		"h": 1.2307692308
	},
	{
		"stop_id": 8572767,
		"ID": 684,
		"x": -22.3842546277,
		"y": 43.343177843,
		"h": 1.2307692308
	},
	{
		"stop_id": 8572809,
		"ID": 684,
		"x": -18.2602487847,
		"y": 42.709192556,
		"h": 1.2307692308
	},
	{
		"stop_id": 8572810,
		"ID": 684,
		"x": -19.6052241757,
		"y": 44.812148531,
		"h": 1.2307692308
	},
	{
		"stop_id": 8508655,
		"ID": 617,
		"x": -30.1542534827,
		"y": 33.81215544,
		"h": 1.3296703297
	},
	{
		"stop_id": 8508656,
		"ID": 617,
		"x": -30.4182939207,
		"y": 32.312210986,
		"h": 1.3296703297
	},
	{
		"stop_id": 8508659,
		"ID": 617,
		"x": -30.1052881507,
		"y": 31.626140083,
		"h": 1.3296703297
	},
	{
		"stop_id": 8571570,
		"ID": 617,
		"x": -30.3082864907,
		"y": 33.118215959,
		"h": 1.3296703297
	},
	{
		"stop_id": 8576509,
		"ID": 617,
		"x": -28.4362818117,
		"y": 31.583186949,
		"h": 1.3296703297
	},
	{
		"stop_id": 8588628,
		"ID": 617,
		"x": -32.9452377427,
		"y": 32.929247852,
		"h": 1.3296703297
	},
	{
		"stop_id": 8588629,
		"ID": 617,
		"x": -33.4852298277,
		"y": 32.769202267,
		"h": 1.3296703297
	},
	{
		"stop_id": 8588637,
		"ID": 617,
		"x": -31.5492360397,
		"y": 33.45319851,
		"h": 1.3296703297
	},
	{
		"stop_id": 8588640,
		"ID": 617,
		"x": -30.0382568097,
		"y": 31.113179159,
		"h": 1.3296703297
	},
	{
		"stop_id": 8588717,
		"ID": 617,
		"x": -28.6012393467,
		"y": 31.350190611,
		"h": 1.3296703297
	},
	{
		"stop_id": 8589195,
		"ID": 617,
		"x": -32.3032676937,
		"y": 33.263243548,
		"h": 1.3296703297
	},
	{
		"stop_id": 8508657,
		"ID": 646,
		"x": -25.2632967297,
		"y": 5.80923562,
		"h": 1.4615384615
	},
	{
		"stop_id": 8508703,
		"ID": 646,
		"x": -24.5262350177,
		"y": 7.029175368,
		"h": 1.4615384615
	},
	{
		"stop_id": 8508704,
		"ID": 646,
		"x": -25.9202237147,
		"y": 5.166149933,
		"h": 1.4615384615
	},
	{
		"stop_id": 8508770,
		"ID": 646,
		"x": -24.6002559767,
		"y": 6.673216067,
		"h": 1.4615384615
	},
	{
		"stop_id": 8508784,
		"ID": 646,
		"x": -27.4672821817,
		"y": 3.77821879,
		"h": 1.4615384615
	},
	{
		"stop_id": 8508868,
		"ID": 646,
		"x": -25.0132257867,
		"y": 2.313144564,
		"h": 1.4615384615
	},
	{
		"stop_id": 8508875,
		"ID": 646,
		"x": -24.9012477447,
		"y": 6.327162116,
		"h": 1.4615384615
	},
	{
		"stop_id": 8508876,
		"ID": 646,
		"x": -26.6682657407,
		"y": 3.118220003,
		"h": 1.4615384615
	},
	{
		"stop_id": 8530351,
		"ID": 646,
		"x": -24.8932997067,
		"y": 6.298192749,
		"h": 1.4615384615
	},
	{
		"stop_id": 8530352,
		"ID": 646,
		"x": -24.0832932707,
		"y": 4.655184912,
		"h": 1.4615384615
	},
	{
		"stop_id": 8572864,
		"ID": 646,
		"x": -26.4262905607,
		"y": 4.657156438,
		"h": 1.4615384615
	},
	{
		"stop_id": 8572865,
		"ID": 646,
		"x": -26.8322690167,
		"y": 4.385214479,
		"h": 1.4615384615
	},
	{
		"stop_id": 8572866,
		"ID": 646,
		"x": -26.4682936997,
		"y": 2.795154124,
		"h": 1.4615384615
	},
	{
		"stop_id": 8572867,
		"ID": 646,
		"x": -25.9872903907,
		"y": 2.607185743,
		"h": 1.4615384615
	},
	{
		"stop_id": 8580950,
		"ID": 646,
		"x": -25.5682945497,
		"y": 5.509217699,
		"h": 1.4615384615
	},
	{
		"stop_id": 8508660,
		"ID": 681,
		"x": -22.7552614957,
		"y": 26.010140468,
		"h": 1.032967033
	},
	{
		"stop_id": 8572759,
		"ID": 681,
		"x": -22.7182534977,
		"y": 27.28721,
		"h": 1.032967033
	},
	{
		"stop_id": 8508661,
		"ID": 551,
		"x": -40.0152265897,
		"y": 29.192164815,
		"h": 1.3626373626
	},
	{
		"stop_id": 8508953,
		"ID": 551,
		"x": -43.0022471067,
		"y": 30.060216988,
		"h": 1.3626373626
	},
	{
		"stop_id": 8508955,
		"ID": 551,
		"x": -42.0732255817,
		"y": 31.512151135,
		"h": 1.3626373626
	},
	{
		"stop_id": 8571532,
		"ID": 551,
		"x": -40.2752660427,
		"y": 28.763183189,
		"h": 1.3626373626
	},
	{
		"stop_id": 8571533,
		"ID": 551,
		"x": -39.7232786427,
		"y": 29.791249647,
		"h": 1.3626373626
	},
	{
		"stop_id": 8576467,
		"ID": 551,
		"x": -43.3602725127,
		"y": 29.53315264,
		"h": 1.3626373626
	},
	{
		"stop_id": 8576468,
		"ID": 551,
		"x": -43.2202529637,
		"y": 29.69718508,
		"h": 1.3626373626
	},
	{
		"stop_id": 8576470,
		"ID": 551,
		"x": -42.5482931157,
		"y": 30.911205447,
		"h": 1.3626373626
	},
	{
		"stop_id": 8576472,
		"ID": 551,
		"x": -41.5712305947,
		"y": 31.292197244,
		"h": 1.3626373626
	},
	{
		"stop_id": 8576473,
		"ID": 551,
		"x": -40.4622494827,
		"y": 31.422187191,
		"h": 1.3626373626
	},
	{
		"stop_id": 8576474,
		"ID": 551,
		"x": -39.9282744777,
		"y": 31.01514668,
		"h": 1.3626373626
	},
	{
		"stop_id": 8588907,
		"ID": 551,
		"x": -39.1932955817,
		"y": 30.337243981,
		"h": 1.3626373626
	},
	{
		"stop_id": 8508663,
		"ID": 549,
		"x": -41.1602430347,
		"y": 19.607199469,
		"h": 1.2637362637
	},
	{
		"stop_id": 8508664,
		"ID": 549,
		"x": -41.3702725927,
		"y": 18.241142824,
		"h": 1.2637362637
	},
	{
		"stop_id": 8508665,
		"ID": 549,
		"x": -41.9652567077,
		"y": 18.46624882,
		"h": 1.2637362637
	},
	{
		"stop_id": 8508666,
		"ID": 549,
		"x": -40.3382906137,
		"y": 21.530189316,
		"h": 1.2637362637
	},
	{
		"stop_id": 8508667,
		"ID": 549,
		"x": -40.5432901287,
		"y": 20.598240814,
		"h": 1.2637362637
	},
	{
		"stop_id": 8571766,
		"ID": 549,
		"x": -40.8192286977,
		"y": 22.034149393,
		"h": 1.2637362637
	},
	{
		"stop_id": 8571767,
		"ID": 549,
		"x": -40.7402413237,
		"y": 20.08322055,
		"h": 1.2637362637
	},
	{
		"stop_id": 8571768,
		"ID": 549,
		"x": -40.9172984717,
		"y": 19.111243243,
		"h": 1.2637362637
	},
	{
		"stop_id": 8571769,
		"ID": 549,
		"x": -42.7882845767,
		"y": 17.852199177,
		"h": 1.2637362637
	},
	{
		"stop_id": 8508684,
		"ID": 767,
		"x": -8.2282428487,
		"y": 3.733179338,
		"h": 1.3626373626
	},
	{
		"stop_id": 8572887,
		"ID": 767,
		"x": -7.4542283387,
		"y": 4.288189648,
		"h": 1.3626373626
	},
	{
		"stop_id": 8572888,
		"ID": 767,
		"x": -6.8262673437,
		"y": 4.027222679,
		"h": 1.3626373626
	},
	{
		"stop_id": 8572889,
		"ID": 767,
		"x": -6.4012968277,
		"y": 4.648224685,
		"h": 1.3626373626
	},
	{
		"stop_id": 8572890,
		"ID": 767,
		"x": -5.9152376027,
		"y": 4.964191667,
		"h": 1.3626373626
	},
	{
		"stop_id": 8572891,
		"ID": 767,
		"x": -5.1592816187,
		"y": 4.279202221,
		"h": 1.3626373626
	},
	{
		"stop_id": 8572917,
		"ID": 767,
		"x": -3.6522990137,
		"y": 5.145159272,
		"h": 1.3626373626
	},
	{
		"stop_id": 8572918,
		"ID": 767,
		"x": -3.8232866657,
		"y": 5.899207522,
		"h": 1.3626373626
	},
	{
		"stop_id": 8572919,
		"ID": 767,
		"x": -4.9962721847,
		"y": 4.409206249,
		"h": 1.3626373626
	},
	{
		"stop_id": 8580014,
		"ID": 767,
		"x": -4.5522699997,
		"y": 6.47621684,
		"h": 1.3626373626
	},
	{
		"stop_id": 8582768,
		"ID": 767,
		"x": -3.9362738307,
		"y": 6.531176661,
		"h": 1.3626373626
	},
	{
		"stop_id": 8582883,
		"ID": 767,
		"x": -4.6692826237,
		"y": 6.983203123,
		"h": 1.3626373626
	},
	{
		"stop_id": 8508691,
		"ID": 769,
		"x": -8.1672897187,
		"y": 19.179199891,
		"h": 1.0659340659
	},
	{
		"stop_id": 8508692,
		"ID": 769,
		"x": -7.2962377897,
		"y": 18.18420396,
		"h": 1.0659340659
	},
	{
		"stop_id": 8577061,
		"ID": 769,
		"x": -7.7352606267,
		"y": 18.843193203,
		"h": 1.0659340659
	},
	{
		"stop_id": 8508700,
		"ID": 586,
		"x": -37.7692290797,
		"y": 42.191150792,
		"h": 1.032967033
	},
	{
		"stop_id": 8571549,
		"ID": 586,
		"x": -34.3992438307,
		"y": 38.136244184,
		"h": 1.032967033
	},
	{
		"stop_id": 8508706,
		"ID": 677,
		"x": -24.4612930957,
		"y": 2.278235366,
		"h": 1.0989010989
	},
	{
		"stop_id": 8508768,
		"ID": 677,
		"x": -21.8012559287,
		"y": 1.014238903,
		"h": 1.0989010989
	},
	{
		"stop_id": 8572868,
		"ID": 677,
		"x": -23.6672308087,
		"y": 2.137216056,
		"h": 1.0989010989
	},
	{
		"stop_id": 8572869,
		"ID": 677,
		"x": -22.7192609637,
		"y": 1.737222631,
		"h": 1.0989010989
	},
	{
		"stop_id": 8508714,
		"ID": 455,
		"x": -54.7132624787,
		"y": 37.53419901,
		"h": 1.6593406593
	},
	{
		"stop_id": 8508888,
		"ID": 455,
		"x": -54.0852429097,
		"y": 38.373237065,
		"h": 1.6593406593
	},
	{
		"stop_id": 8570464,
		"ID": 455,
		"x": -54.9232849287,
		"y": 37.268208706,
		"h": 1.6593406593
	},
	{
		"stop_id": 8571481,
		"ID": 455,
		"x": -54.0222634387,
		"y": 40.911207748,
		"h": 1.6593406593
	},
	{
		"stop_id": 8571482,
		"ID": 455,
		"x": -55.0592415827,
		"y": 40.38923315,
		"h": 1.6593406593
	},
	{
		"stop_id": 8571483,
		"ID": 455,
		"x": -56.5982338447,
		"y": 39.280153978,
		"h": 1.6593406593
	},
	{
		"stop_id": 8571484,
		"ID": 455,
		"x": -57.6572817757,
		"y": 38.584189523,
		"h": 1.6593406593
	},
	{
		"stop_id": 8571485,
		"ID": 455,
		"x": -58.4352854137,
		"y": 39.059250818,
		"h": 1.6593406593
	},
	{
		"stop_id": 8571487,
		"ID": 455,
		"x": -53.3022524067,
		"y": 40.026199527,
		"h": 1.6593406593
	},
	{
		"stop_id": 8571489,
		"ID": 455,
		"x": -53.9102467297,
		"y": 39.167194601,
		"h": 1.6593406593
	},
	{
		"stop_id": 8571491,
		"ID": 455,
		"x": -54.6852269007,
		"y": 38.573152642,
		"h": 1.6593406593
	},
	{
		"stop_id": 8571492,
		"ID": 455,
		"x": -55.2282754317,
		"y": 38.665219996,
		"h": 1.6593406593
	},
	{
		"stop_id": 8571493,
		"ID": 455,
		"x": -56.1132985667,
		"y": 38.700200949,
		"h": 1.6593406593
	},
	{
		"stop_id": 8571494,
		"ID": 455,
		"x": -56.8212926837,
		"y": 37.996192991,
		"h": 1.6593406593
	},
	{
		"stop_id": 8571496,
		"ID": 455,
		"x": -57.6432618657,
		"y": 36.842195217,
		"h": 1.6593406593
	},
	{
		"stop_id": 8580361,
		"ID": 455,
		"x": -57.0232445067,
		"y": 37.661240901,
		"h": 1.6593406593
	},
	{
		"stop_id": 8581034,
		"ID": 455,
		"x": -53.9182455977,
		"y": 39.59521178,
		"h": 1.6593406593
	},
	{
		"stop_id": 8581590,
		"ID": 455,
		"x": -54.2362422137,
		"y": 38.749202587,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583357,
		"ID": 455,
		"x": -54.3702448597,
		"y": 40.926229612,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583868,
		"ID": 455,
		"x": -54.4102617597,
		"y": 38.589176311,
		"h": 1.6593406593
	},
	{
		"stop_id": 8589918,
		"ID": 455,
		"x": -58.1522916497,
		"y": 42.339217961,
		"h": 1.6593406593
	},
	{
		"stop_id": 8508715,
		"ID": 424,
		"x": -60.3622702487,
		"y": 34.386159325,
		"h": 1.4285714286
	},
	{
		"stop_id": 8508786,
		"ID": 424,
		"x": -63.3622292457,
		"y": 35.109229879,
		"h": 1.4285714286
	},
	{
		"stop_id": 8571474,
		"ID": 424,
		"x": -63.3422692267,
		"y": 35.352244598,
		"h": 1.4285714286
	},
	{
		"stop_id": 8571475,
		"ID": 424,
		"x": -63.0272385807,
		"y": 35.721157476,
		"h": 1.4285714286
	},
	{
		"stop_id": 8571476,
		"ID": 424,
		"x": -62.4452979877,
		"y": 36.687186601,
		"h": 1.4285714286
	},
	{
		"stop_id": 8571477,
		"ID": 424,
		"x": -62.1952306017,
		"y": 37.321215751,
		"h": 1.4285714286
	},
	{
		"stop_id": 8571486,
		"ID": 424,
		"x": -60.0672711907,
		"y": 38.001194183,
		"h": 1.4285714286
	},
	{
		"stop_id": 8571497,
		"ID": 424,
		"x": -58.4952329127,
		"y": 36.885212967,
		"h": 1.4285714286
	},
	{
		"stop_id": 8571498,
		"ID": 424,
		"x": -59.0112355167,
		"y": 37.186194594,
		"h": 1.4285714286
	},
	{
		"stop_id": 8571501,
		"ID": 424,
		"x": -59.7292397357,
		"y": 36.328223707,
		"h": 1.4285714286
	},
	{
		"stop_id": 8571502,
		"ID": 424,
		"x": -61.3342737987,
		"y": 35.544231597,
		"h": 1.4285714286
	},
	{
		"stop_id": 8571503,
		"ID": 424,
		"x": -61.0342755247,
		"y": 35.812196728,
		"h": 1.4285714286
	},
	{
		"stop_id": 8571504,
		"ID": 424,
		"x": -63.0542476767,
		"y": 35.336175875,
		"h": 1.4285714286
	},
	{
		"stop_id": 8581120,
		"ID": 424,
		"x": -63.5132322227,
		"y": 35.287204404,
		"h": 1.4285714286
	},
	{
		"stop_id": 8508724,
		"ID": 960,
		"x": 27.1097199733,
		"y": -7.825807957,
		"h": 1.1648351648
	},
	{
		"stop_id": 8577396,
		"ID": 960,
		"x": 28.9717160473,
		"y": -9.3108193,
		"h": 1.1648351648
	},
	{
		"stop_id": 8587429,
		"ID": 960,
		"x": 30.1577303573,
		"y": -7.803806517,
		"h": 1.1648351648
	},
	{
		"stop_id": 8587430,
		"ID": 960,
		"x": 29.6947374273,
		"y": -8.234765558,
		"h": 1.1648351648
	},
	{
		"stop_id": 8587431,
		"ID": 960,
		"x": 28.8077573623,
		"y": -10.369774878,
		"h": 1.1648351648
	},
	{
		"stop_id": 8589212,
		"ID": 960,
		"x": 29.0337649983,
		"y": -9.11578289,
		"h": 1.1648351648
	},
	{
		"stop_id": 8508726,
		"ID": 768,
		"x": -7.3132410787,
		"y": 11.203184808,
		"h": 1.032967033
	},
	{
		"stop_id": 8577654,
		"ID": 768,
		"x": -4.3112653207,
		"y": 9.656239263,
		"h": 1.032967033
	},
	{
		"stop_id": 8508737,
		"ID": 678,
		"x": -23.4272950687,
		"y": 9.944199811,
		"h": 1.1648351648
	},
	{
		"stop_id": 8508738,
		"ID": 678,
		"x": -23.7812773377,
		"y": 8.839243093,
		"h": 1.1648351648
	},
	{
		"stop_id": 8508739,
		"ID": 678,
		"x": -24.3222366627,
		"y": 7.790232091,
		"h": 1.1648351648
	},
	{
		"stop_id": 8572863,
		"ID": 678,
		"x": -23.7992368377,
		"y": 8.516182656,
		"h": 1.1648351648
	},
	{
		"stop_id": 8580948,
		"ID": 678,
		"x": -23.6262507587,
		"y": 9.516209201,
		"h": 1.1648351648
	},
	{
		"stop_id": 8580949,
		"ID": 678,
		"x": -24.0922541007,
		"y": 8.045177762,
		"h": 1.1648351648
	},
	{
		"stop_id": 8508752,
		"ID": 735,
		"x": -13.9572505007,
		"y": -8.226764606,
		"h": 1.0659340659
	},
	{
		"stop_id": 8587023,
		"ID": 735,
		"x": -12.9962563167,
		"y": -7.018827983,
		"h": 1.0659340659
	},
	{
		"stop_id": 8587235,
		"ID": 735,
		"x": -13.5292613697,
		"y": -7.667855503,
		"h": 1.0659340659
	},
	{
		"stop_id": 8508757,
		"ID": 680,
		"x": -24.0082927697,
		"y": 19.295181285,
		"h": 1.0989010989
	},
	{
		"stop_id": 8508994,
		"ID": 680,
		"x": -21.4982682967,
		"y": 22.2911644,
		"h": 1.0989010989
	},
	{
		"stop_id": 8576678,
		"ID": 680,
		"x": -22.1582687447,
		"y": 20.580238647,
		"h": 1.0989010989
	},
	{
		"stop_id": 8588412,
		"ID": 680,
		"x": -24.2672822607,
		"y": 18.834161075,
		"h": 1.0989010989
	},
	{
		"stop_id": 8508760,
		"ID": 842,
		"x": 10.0527697613,
		"y": -5.887806215,
		"h": 1.1648351648
	},
	{
		"stop_id": 8508859,
		"ID": 842,
		"x": 9.4347016253,
		"y": -1.686771421,
		"h": 1.1648351648
	},
	{
		"stop_id": 8571618,
		"ID": 842,
		"x": 7.1847594333,
		"y": -3.84675706,
		"h": 1.1648351648
	},
	{
		"stop_id": 8571619,
		"ID": 842,
		"x": 7.7917016923,
		"y": -2.683846442,
		"h": 1.1648351648
	},
	{
		"stop_id": 8595211,
		"ID": 842,
		"x": 7.1097416403,
		"y": -1.696809977,
		"h": 1.1648351648
	},
	{
		"stop_id": 8595212,
		"ID": 842,
		"x": 7.5017365913,
		"y": -1.357789021,
		"h": 1.1648351648
	},
	{
		"stop_id": 8508763,
		"ID": 840,
		"x": 5.4057540283,
		"y": -15.159799195,
		"h": 1
	},
	{
		"stop_id": 8508764,
		"ID": 839,
		"x": 6.8687176273,
		"y": -19.982785778,
		"h": 1.1648351648
	},
	{
		"stop_id": 8571611,
		"ID": 839,
		"x": 8.2827717853,
		"y": -22.171848521,
		"h": 1.1648351648
	},
	{
		"stop_id": 8571612,
		"ID": 839,
		"x": 6.6107307493,
		"y": -19.396755995,
		"h": 1.1648351648
	},
	{
		"stop_id": 8571613,
		"ID": 839,
		"x": 8.1937661573,
		"y": -21.470797083,
		"h": 1.1648351648
	},
	{
		"stop_id": 8582185,
		"ID": 839,
		"x": 7.9417440313,
		"y": -22.214828824,
		"h": 1.1648351648
	},
	{
		"stop_id": 8583733,
		"ID": 839,
		"x": 8.9517593523,
		"y": -23.499767077,
		"h": 1.1648351648
	},
	{
		"stop_id": 8508771,
		"ID": 819,
		"x": 5.1647660103,
		"y": 4.840236102,
		"h": 1.1978021978
	},
	{
		"stop_id": 8508971,
		"ID": 819,
		"x": 4.6947115523,
		"y": 2.549179621,
		"h": 1.1978021978
	},
	{
		"stop_id": 8572913,
		"ID": 819,
		"x": 5.6917433913,
		"y": 6.77319837,
		"h": 1.1978021978
	},
	{
		"stop_id": 8572914,
		"ID": 819,
		"x": 5.7227096383,
		"y": 6.215213229,
		"h": 1.1978021978
	},
	{
		"stop_id": 8572915,
		"ID": 819,
		"x": 5.3657270953,
		"y": 5.191174732,
		"h": 1.1978021978
	},
	{
		"stop_id": 8580102,
		"ID": 819,
		"x": 4.9637203793,
		"y": 4.297193118,
		"h": 1.1978021978
	},
	{
		"stop_id": 8583552,
		"ID": 819,
		"x": 4.7677655263,
		"y": 3.377218191,
		"h": 1.1978021978
	},
	{
		"stop_id": 8508772,
		"ID": 712,
		"x": -17.2702444517,
		"y": 27.523156472,
		"h": 1.2637362637
	},
	{
		"stop_id": 8572820,
		"ID": 712,
		"x": -14.8022663247,
		"y": 30.188219981,
		"h": 1.2637362637
	},
	{
		"stop_id": 8572821,
		"ID": 712,
		"x": -15.6332294277,
		"y": 30.336219366,
		"h": 1.2637362637
	},
	{
		"stop_id": 8572822,
		"ID": 712,
		"x": -16.1102322717,
		"y": 30.442220005,
		"h": 1.2637362637
	},
	{
		"stop_id": 8572823,
		"ID": 712,
		"x": -17.1972671297,
		"y": 29.695159433,
		"h": 1.2637362637
	},
	{
		"stop_id": 8572824,
		"ID": 712,
		"x": -17.2032783577,
		"y": 29.270202466,
		"h": 1.2637362637
	},
	{
		"stop_id": 8572825,
		"ID": 712,
		"x": -17.4252530767,
		"y": 28.515186383,
		"h": 1.2637362637
	},
	{
		"stop_id": 8572826,
		"ID": 712,
		"x": -17.5902584437,
		"y": 28.068204637,
		"h": 1.2637362637
	},
	{
		"stop_id": 8572827,
		"ID": 712,
		"x": -17.6422524757,
		"y": 27.499175248,
		"h": 1.2637362637
	},
	{
		"stop_id": 8508775,
		"ID": 817,
		"x": 5.8917565713,
		"y": -7.823846308,
		"h": 1.3296703297
	},
	{
		"stop_id": 8530347,
		"ID": 817,
		"x": 2.8207035993,
		"y": -5.967817615,
		"h": 1.3296703297
	},
	{
		"stop_id": 8570532,
		"ID": 817,
		"x": 2.0917640163,
		"y": -9.016848375,
		"h": 1.3296703297
	},
	{
		"stop_id": 8571598,
		"ID": 817,
		"x": 2.7537721193,
		"y": -8.89881859,
		"h": 1.3296703297
	},
	{
		"stop_id": 8571599,
		"ID": 817,
		"x": 3.5027447763,
		"y": -8.552783919,
		"h": 1.3296703297
	},
	{
		"stop_id": 8571600,
		"ID": 817,
		"x": 4.4847079243,
		"y": -8.36581172,
		"h": 1.3296703297
	},
	{
		"stop_id": 8571601,
		"ID": 817,
		"x": 5.1907523183,
		"y": -7.939756209,
		"h": 1.3296703297
	},
	{
		"stop_id": 8571614,
		"ID": 817,
		"x": 4.0067354993,
		"y": -8.502759777,
		"h": 1.3296703297
	},
	{
		"stop_id": 8571615,
		"ID": 817,
		"x": 4.7867667473,
		"y": -7.820822706,
		"h": 1.3296703297
	},
	{
		"stop_id": 8571616,
		"ID": 817,
		"x": 3.7417002453,
		"y": -7.504786952,
		"h": 1.3296703297
	},
	{
		"stop_id": 8571617,
		"ID": 817,
		"x": 4.7067757193,
		"y": -6.082815559,
		"h": 1.3296703297
	},
	{
		"stop_id": 8508780,
		"ID": 711,
		"x": -14.9592355057,
		"y": 24.265155018,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572834,
		"ID": 711,
		"x": -13.9562489547,
		"y": 21.738193788,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572835,
		"ID": 711,
		"x": -15.1242380427,
		"y": 21.331239884,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572836,
		"ID": 711,
		"x": -15.6412488727,
		"y": 20.966195441,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572837,
		"ID": 711,
		"x": -16.7442901257,
		"y": 20.855208391,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572838,
		"ID": 711,
		"x": -17.7912944057,
		"y": 20.961163498,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572839,
		"ID": 711,
		"x": -18.1892496277,
		"y": 20.703238475,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572853,
		"ID": 711,
		"x": -14.8322360987,
		"y": 24.355160096,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572854,
		"ID": 711,
		"x": -15.3912467387,
		"y": 23.949195442,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572855,
		"ID": 711,
		"x": -15.6622989427,
		"y": 23.416217279,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572856,
		"ID": 711,
		"x": -15.8192305177,
		"y": 22.893206722,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572857,
		"ID": 711,
		"x": -15.9512686227,
		"y": 22.654212231,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572858,
		"ID": 711,
		"x": -16.7182756197,
		"y": 22.863205364,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572859,
		"ID": 711,
		"x": -17.3222762787,
		"y": 23.913154266,
		"h": 1.4285714286
	},
	{
		"stop_id": 8508781,
		"ID": 764,
		"x": -5.0332750087,
		"y": -12.427832319,
		"h": 1.1978021978
	},
	{
		"stop_id": 8508788,
		"ID": 764,
		"x": -6.5332265357,
		"y": -12.929792798,
		"h": 1.1978021978
	},
	{
		"stop_id": 8571589,
		"ID": 764,
		"x": -4.4492712637,
		"y": -11.469856309,
		"h": 1.1978021978
	},
	{
		"stop_id": 8571590,
		"ID": 764,
		"x": -4.9552918217,
		"y": -12.605773775,
		"h": 1.1978021978
	},
	{
		"stop_id": 8571591,
		"ID": 764,
		"x": -5.9702667667,
		"y": -12.682760261,
		"h": 1.1978021978
	},
	{
		"stop_id": 8576519,
		"ID": 764,
		"x": -7.9022484467,
		"y": -13.849805795,
		"h": 1.1978021978
	},
	{
		"stop_id": 8594319,
		"ID": 764,
		"x": -7.5802798697,
		"y": -13.779760796,
		"h": 1.1978021978
	},
	{
		"stop_id": 8508791,
		"ID": 867,
		"x": 10.7517575443,
		"y": -5.796806485,
		"h": 1.0989010989
	},
	{
		"stop_id": 8508877,
		"ID": 867,
		"x": 15.8417207513,
		"y": -6.544850903,
		"h": 1.0989010989
	},
	{
		"stop_id": 8571606,
		"ID": 867,
		"x": 12.4277747373,
		"y": -6.075824301,
		"h": 1.0989010989
	},
	{
		"stop_id": 8571607,
		"ID": 867,
		"x": 13.0237520543,
		"y": -5.615805909,
		"h": 1.0989010989
	},
	{
		"stop_id": 8508792,
		"ID": 895,
		"x": 17.3017607503,
		"y": -6.749850889,
		"h": 1
	},
	{
		"stop_id": 8508793,
		"ID": 648,
		"x": -26.3862980167,
		"y": 16.326143053,
		"h": 1.5274725275
	},
	{
		"stop_id": 8576672,
		"ID": 648,
		"x": -28.3402920447,
		"y": 14.721140506,
		"h": 1.5274725275
	},
	{
		"stop_id": 8576673,
		"ID": 648,
		"x": -27.6082922887,
		"y": 15.345142989,
		"h": 1.5274725275
	},
	{
		"stop_id": 8576674,
		"ID": 648,
		"x": -27.2812921117,
		"y": 15.543237702,
		"h": 1.5274725275
	},
	{
		"stop_id": 8576675,
		"ID": 648,
		"x": -26.7512361587,
		"y": 15.868202349,
		"h": 1.5274725275
	},
	{
		"stop_id": 8576676,
		"ID": 648,
		"x": -25.7692293387,
		"y": 16.780197023,
		"h": 1.5274725275
	},
	{
		"stop_id": 8576677,
		"ID": 648,
		"x": -25.3692529197,
		"y": 17.371140408,
		"h": 1.5274725275
	},
	{
		"stop_id": 8588401,
		"ID": 648,
		"x": -27.7592740907,
		"y": 15.125214243,
		"h": 1.5274725275
	},
	{
		"stop_id": 8588403,
		"ID": 648,
		"x": -26.2042919567,
		"y": 16.267238742,
		"h": 1.5274725275
	},
	{
		"stop_id": 8588404,
		"ID": 648,
		"x": -25.8342721967,
		"y": 16.66320814,
		"h": 1.5274725275
	},
	{
		"stop_id": 8588405,
		"ID": 648,
		"x": -26.3282866127,
		"y": 16.573158097,
		"h": 1.5274725275
	},
	{
		"stop_id": 8588406,
		"ID": 648,
		"x": -26.0572330827,
		"y": 16.614144387,
		"h": 1.5274725275
	},
	{
		"stop_id": 8588407,
		"ID": 648,
		"x": -25.4902636767,
		"y": 17.099185259,
		"h": 1.5274725275
	},
	{
		"stop_id": 8588408,
		"ID": 648,
		"x": -25.2562952867,
		"y": 17.889187965,
		"h": 1.5274725275
	},
	{
		"stop_id": 8588409,
		"ID": 648,
		"x": -25.1072865817,
		"y": 18.09316156,
		"h": 1.5274725275
	},
	{
		"stop_id": 8588410,
		"ID": 648,
		"x": -24.8582871537,
		"y": 18.313174461,
		"h": 1.5274725275
	},
	{
		"stop_id": 8588411,
		"ID": 648,
		"x": -24.6482414867,
		"y": 18.527188208,
		"h": 1.5274725275
	},
	{
		"stop_id": 8508856,
		"ID": 795,
		"x": 0.1577161113,
		"y": 11.070206455,
		"h": 1
	},
	{
		"stop_id": 8508864,
		"ID": 930,
		"x": 22.8467590563,
		"y": 12.498198467,
		"h": 1.1648351648
	},
	{
		"stop_id": 8530758,
		"ID": 930,
		"x": 22.8527313163,
		"y": 12.507175402,
		"h": 1.1648351648
	},
	{
		"stop_id": 8530759,
		"ID": 930,
		"x": 21.1647468473,
		"y": 12.322217044,
		"h": 1.1648351648
	},
	{
		"stop_id": 8573103,
		"ID": 930,
		"x": 23.8007373983,
		"y": 13.535204793,
		"h": 1.1648351648
	},
	{
		"stop_id": 8573104,
		"ID": 930,
		"x": 23.3337138963,
		"y": 13.303221639,
		"h": 1.1648351648
	},
	{
		"stop_id": 8573105,
		"ID": 930,
		"x": 23.0587111823,
		"y": 12.903158731,
		"h": 1.1648351648
	},
	{
		"stop_id": 8508869,
		"ID": 682,
		"x": -23.4452300507,
		"y": 29.675229628,
		"h": 1.3296703297
	},
	{
		"stop_id": 8508870,
		"ID": 682,
		"x": -23.5652510357,
		"y": 32.416197622,
		"h": 1.3296703297
	},
	{
		"stop_id": 8572756,
		"ID": 682,
		"x": -23.7282629617,
		"y": 32.789206419,
		"h": 1.3296703297
	},
	{
		"stop_id": 8572757,
		"ID": 682,
		"x": -23.3412954217,
		"y": 31.592192056,
		"h": 1.3296703297
	},
	{
		"stop_id": 8572758,
		"ID": 682,
		"x": -23.3002654437,
		"y": 30.532162356,
		"h": 1.3296703297
	},
	{
		"stop_id": 8572797,
		"ID": 682,
		"x": -20.1592906177,
		"y": 32.80615353,
		"h": 1.3296703297
	},
	{
		"stop_id": 8572798,
		"ID": 682,
		"x": -20.3172525577,
		"y": 32.430221355,
		"h": 1.3296703297
	},
	{
		"stop_id": 8572799,
		"ID": 682,
		"x": -20.7342930717,
		"y": 31.418224308,
		"h": 1.3296703297
	},
	{
		"stop_id": 8572800,
		"ID": 682,
		"x": -20.6662455097,
		"y": 30.143150978,
		"h": 1.3296703297
	},
	{
		"stop_id": 8572801,
		"ID": 682,
		"x": -20.7192579147,
		"y": 29.351234746,
		"h": 1.3296703297
	},
	{
		"stop_id": 8580016,
		"ID": 682,
		"x": -20.4382241757,
		"y": 32.246204839,
		"h": 1.3296703297
	},
	{
		"stop_id": 8508892,
		"ID": 518,
		"x": -47.7992270927,
		"y": 33.373153057,
		"h": 1.4285714286
	},
	{
		"stop_id": 8508964,
		"ID": 518,
		"x": -46.3742863077,
		"y": 35.845238272,
		"h": 1.4285714286
	},
	{
		"stop_id": 8508965,
		"ID": 518,
		"x": -46.8132753697,
		"y": 34.982225719,
		"h": 1.4285714286
	},
	{
		"stop_id": 8508966,
		"ID": 518,
		"x": -47.1772494787,
		"y": 34.233246785,
		"h": 1.4285714286
	},
	{
		"stop_id": 8508967,
		"ID": 518,
		"x": -48.6902525147,
		"y": 32.217234921,
		"h": 1.4285714286
	},
	{
		"stop_id": 8576488,
		"ID": 518,
		"x": -47.8612849217,
		"y": 31.435157456,
		"h": 1.4285714286
	},
	{
		"stop_id": 8576489,
		"ID": 518,
		"x": -48.2062878807,
		"y": 31.697186728,
		"h": 1.4285714286
	},
	{
		"stop_id": 8576490,
		"ID": 518,
		"x": -48.4442849177,
		"y": 32.49618413,
		"h": 1.4285714286
	},
	{
		"stop_id": 8576491,
		"ID": 518,
		"x": -47.6882465347,
		"y": 33.684218319,
		"h": 1.4285714286
	},
	{
		"stop_id": 8576492,
		"ID": 518,
		"x": -46.6862375227,
		"y": 36.036214614,
		"h": 1.4285714286
	},
	{
		"stop_id": 8587828,
		"ID": 518,
		"x": -48.7402526757,
		"y": 32.566228848,
		"h": 1.4285714286
	},
	{
		"stop_id": 8587868,
		"ID": 518,
		"x": -48.9372709257,
		"y": 32.803226727,
		"h": 1.4285714286
	},
	{
		"stop_id": 8588306,
		"ID": 518,
		"x": -48.2152478077,
		"y": 32.683170237,
		"h": 1.4285714286
	},
	{
		"stop_id": 8588307,
		"ID": 518,
		"x": -47.9132340207,
		"y": 33.089210564,
		"h": 1.4285714286
	},
	{
		"stop_id": 8508893,
		"ID": 613,
		"x": -32.5532938017,
		"y": 9.132191016,
		"h": 1.2307692308
	},
	{
		"stop_id": 8576710,
		"ID": 613,
		"x": -33.2792274737,
		"y": 10.125140748,
		"h": 1.2307692308
	},
	{
		"stop_id": 8576711,
		"ID": 613,
		"x": -32.9102780597,
		"y": 7.868242191,
		"h": 1.2307692308
	},
	{
		"stop_id": 8576712,
		"ID": 613,
		"x": -34.1352555287,
		"y": 7.554164727,
		"h": 1.2307692308
	},
	{
		"stop_id": 8588372,
		"ID": 613,
		"x": -33.0082777317,
		"y": 9.684217984,
		"h": 1.2307692308
	},
	{
		"stop_id": 8588373,
		"ID": 613,
		"x": -32.6802361677,
		"y": 8.274158776,
		"h": 1.2307692308
	},
	{
		"stop_id": 8588374,
		"ID": 613,
		"x": -33.2532241017,
		"y": 7.552216256,
		"h": 1.2307692308
	},
	{
		"stop_id": 8588375,
		"ID": 613,
		"x": -33.7332561057,
		"y": 7.46818198,
		"h": 1.2307692308
	},
	{
		"stop_id": 8508898,
		"ID": 741,
		"x": -12.8542625267,
		"y": 25.134140312,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572846,
		"ID": 741,
		"x": -11.7942864677,
		"y": 27.792216851,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572849,
		"ID": 741,
		"x": -12.2922522177,
		"y": 26.380191814,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572850,
		"ID": 741,
		"x": -12.8022745007,
		"y": 25.552235644,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572851,
		"ID": 741,
		"x": -13.6832745987,
		"y": 25.138248696,
		"h": 1.4285714286
	},
	{
		"stop_id": 8572852,
		"ID": 741,
		"x": -14.1692881357,
		"y": 24.931179286,
		"h": 1.4285714286
	},
	{
		"stop_id": 8577063,
		"ID": 741,
		"x": -11.7732547297,
		"y": 22.969247041,
		"h": 1.4285714286
	},
	{
		"stop_id": 8577064,
		"ID": 741,
		"x": -11.6942986517,
		"y": 23.252155965,
		"h": 1.4285714286
	},
	{
		"stop_id": 8577067,
		"ID": 741,
		"x": -11.1562732407,
		"y": 25.560180369,
		"h": 1.4285714286
	},
	{
		"stop_id": 8579701,
		"ID": 741,
		"x": -11.0562679067,
		"y": 25.864171994,
		"h": 1.4285714286
	},
	{
		"stop_id": 8579702,
		"ID": 741,
		"x": -11.3432548887,
		"y": 24.65424638,
		"h": 1.4285714286
	},
	{
		"stop_id": 8579703,
		"ID": 741,
		"x": -11.5442549537,
		"y": 23.791231906,
		"h": 1.4285714286
	},
	{
		"stop_id": 8581591,
		"ID": 741,
		"x": -11.9272850487,
		"y": 26.426240674,
		"h": 1.4285714286
	},
	{
		"stop_id": 8587728,
		"ID": 741,
		"x": -11.3192847097,
		"y": 26.54520908,
		"h": 1.4285714286
	},
	{
		"stop_id": 8508899,
		"ID": 772,
		"x": -7.4232386087,
		"y": 32.266144269,
		"h": 1.1978021978
	},
	{
		"stop_id": 8577292,
		"ID": 772,
		"x": -5.9182729037,
		"y": 31.306177625,
		"h": 1.1978021978
	},
	{
		"stop_id": 8577293,
		"ID": 772,
		"x": -6.8252261897,
		"y": 31.808143701,
		"h": 1.1978021978
	},
	{
		"stop_id": 8577294,
		"ID": 772,
		"x": -7.9432250567,
		"y": 32.564229912,
		"h": 1.1978021978
	},
	{
		"stop_id": 8577295,
		"ID": 772,
		"x": -8.5262607217,
		"y": 32.92418947,
		"h": 1.1978021978
	},
	{
		"stop_id": 8577335,
		"ID": 772,
		"x": -8.4432678767,
		"y": 32.033146215,
		"h": 1.1978021978
	},
	{
		"stop_id": 8588803,
		"ID": 772,
		"x": -7.7582732127,
		"y": 32.298234633,
		"h": 1.1978021978
	},
	{
		"stop_id": 8508983,
		"ID": 896,
		"x": 18.6867757413,
		"y": -4.705814951,
		"h": 1
	},
	{
		"stop_id": 8508985,
		"ID": 581,
		"x": -35.1072431357,
		"y": 12.780218689,
		"h": 1.3626373626
	},
	{
		"stop_id": 8576707,
		"ID": 581,
		"x": -35.7092583937,
		"y": 13.404221458,
		"h": 1.3626373626
	},
	{
		"stop_id": 8576708,
		"ID": 581,
		"x": -34.9332585347,
		"y": 12.087230563,
		"h": 1.3626373626
	},
	{
		"stop_id": 8576709,
		"ID": 581,
		"x": -33.5072932247,
		"y": 11.155245938,
		"h": 1.3626373626
	},
	{
		"stop_id": 8588366,
		"ID": 581,
		"x": -35.3472781137,
		"y": 13.091181996,
		"h": 1.3626373626
	},
	{
		"stop_id": 8588367,
		"ID": 581,
		"x": -35.0602250347,
		"y": 12.389201942,
		"h": 1.3626373626
	},
	{
		"stop_id": 8588368,
		"ID": 581,
		"x": -34.2492865577,
		"y": 11.737245744,
		"h": 1.3626373626
	},
	{
		"stop_id": 8588369,
		"ID": 581,
		"x": -33.9692666697,
		"y": 11.652175264,
		"h": 1.3626373626
	},
	{
		"stop_id": 8588370,
		"ID": 581,
		"x": -33.6562569077,
		"y": 11.325242623,
		"h": 1.3626373626
	},
	{
		"stop_id": 8588371,
		"ID": 581,
		"x": -33.5132785107,
		"y": 10.677185634,
		"h": 1.3626373626
	},
	{
		"stop_id": 8588726,
		"ID": 581,
		"x": -37.7952293307,
		"y": 8.48515315,
		"h": 1.3626373626
	},
	{
		"stop_id": 8588756,
		"ID": 581,
		"x": -37.6222315017,
		"y": 7.987191282,
		"h": 1.3626373626
	},
	{
		"stop_id": 8508986,
		"ID": 580,
		"x": -36.6532820467,
		"y": 6.542188163,
		"h": 1.3956043956
	},
	{
		"stop_id": 8508987,
		"ID": 580,
		"x": -35.3582303517,
		"y": 2.756206271,
		"h": 1.3956043956
	},
	{
		"stop_id": 8576590,
		"ID": 580,
		"x": -37.8952938217,
		"y": 2.650162631,
		"h": 1.3956043956
	},
	{
		"stop_id": 8576592,
		"ID": 580,
		"x": -37.0732308337,
		"y": 3.339236512,
		"h": 1.3956043956
	},
	{
		"stop_id": 8576593,
		"ID": 580,
		"x": -36.6722566517,
		"y": 2.907204055,
		"h": 1.3956043956
	},
	{
		"stop_id": 8576594,
		"ID": 580,
		"x": -35.7112775337,
		"y": 2.684189588,
		"h": 1.3956043956
	},
	{
		"stop_id": 8576713,
		"ID": 580,
		"x": -35.1922606417,
		"y": 7.382210227,
		"h": 1.3956043956
	},
	{
		"stop_id": 8576714,
		"ID": 580,
		"x": -36.0342354857,
		"y": 7.392162652,
		"h": 1.3956043956
	},
	{
		"stop_id": 8588376,
		"ID": 580,
		"x": -34.4832560387,
		"y": 7.495213528,
		"h": 1.3956043956
	},
	{
		"stop_id": 8588377,
		"ID": 580,
		"x": -35.7872684547,
		"y": 7.417156843,
		"h": 1.3956043956
	},
	{
		"stop_id": 8588378,
		"ID": 580,
		"x": -36.1532771177,
		"y": 7.200147363,
		"h": 1.3956043956
	},
	{
		"stop_id": 8588483,
		"ID": 580,
		"x": -37.4662242697,
		"y": 2.952229967,
		"h": 1.3956043956
	},
	{
		"stop_id": 8588757,
		"ID": 580,
		"x": -37.1172592467,
		"y": 7.708148501,
		"h": 1.3956043956
	},
	{
		"stop_id": 8508989,
		"ID": 615,
		"x": -32.3992908647,
		"y": 20.619239461,
		"h": 1.5934065934
	},
	{
		"stop_id": 8508991,
		"ID": 615,
		"x": -31.4172517837,
		"y": 18.742217102,
		"h": 1.5934065934
	},
	{
		"stop_id": 8508992,
		"ID": 615,
		"x": -30.1792237227,
		"y": 21.050145646,
		"h": 1.5934065934
	},
	{
		"stop_id": 8508997,
		"ID": 615,
		"x": -30.8362277077,
		"y": 19.468172345,
		"h": 1.5934065934
	},
	{
		"stop_id": 8576681,
		"ID": 615,
		"x": -31.2132752297,
		"y": 17.002231615,
		"h": 1.5934065934
	},
	{
		"stop_id": 8576682,
		"ID": 615,
		"x": -31.6862946387,
		"y": 17.831227974,
		"h": 1.5934065934
	},
	{
		"stop_id": 8576684,
		"ID": 615,
		"x": -30.4422664927,
		"y": 19.891210526,
		"h": 1.5934065934
	},
	{
		"stop_id": 8576685,
		"ID": 615,
		"x": -29.8072802947,
		"y": 21.996187302,
		"h": 1.5934065934
	},
	{
		"stop_id": 8576692,
		"ID": 615,
		"x": -33.5202930197,
		"y": 18.261150111,
		"h": 1.5934065934
	},
	{
		"stop_id": 8576693,
		"ID": 615,
		"x": -33.2962512187,
		"y": 18.702154849,
		"h": 1.5934065934
	},
	{
		"stop_id": 8576694,
		"ID": 615,
		"x": -32.6542868427,
		"y": 19.634203817,
		"h": 1.5934065934
	},
	{
		"stop_id": 8588386,
		"ID": 615,
		"x": -33.7032601257,
		"y": 17.802211794,
		"h": 1.5934065934
	},
	{
		"stop_id": 8588387,
		"ID": 615,
		"x": -33.4512982037,
		"y": 18.44421956,
		"h": 1.5934065934
	},
	{
		"stop_id": 8588388,
		"ID": 615,
		"x": -33.0072487667,
		"y": 19.160245375,
		"h": 1.5934065934
	},
	{
		"stop_id": 8588389,
		"ID": 615,
		"x": -32.5382703197,
		"y": 19.876196508,
		"h": 1.5934065934
	},
	{
		"stop_id": 8588390,
		"ID": 615,
		"x": -32.4882908977,
		"y": 20.29721141,
		"h": 1.5934065934
	},
	{
		"stop_id": 8588396,
		"ID": 615,
		"x": -30.9602359507,
		"y": 16.70717016,
		"h": 1.5934065934
	},
	{
		"stop_id": 8588397,
		"ID": 615,
		"x": -31.6892862897,
		"y": 18.258225853,
		"h": 1.5934065934
	},
	{
		"stop_id": 8588398,
		"ID": 615,
		"x": -31.5892941857,
		"y": 18.587209201,
		"h": 1.5934065934
	},
	{
		"stop_id": 8508993,
		"ID": 616,
		"x": -30.2632358667,
		"y": 23.198147912,
		"h": 1.2307692308
	},
	{
		"stop_id": 8571545,
		"ID": 616,
		"x": -34.0442652357,
		"y": 25.074198278,
		"h": 1.2307692308
	},
	{
		"stop_id": 8576686,
		"ID": 616,
		"x": -31.2692545437,
		"y": 24.29421915,
		"h": 1.2307692308
	},
	{
		"stop_id": 8576687,
		"ID": 616,
		"x": -31.5372509977,
		"y": 25.380223791,
		"h": 1.2307692308
	},
	{
		"stop_id": 8576688,
		"ID": 616,
		"x": -32.2192899297,
		"y": 26.933251055,
		"h": 1.2307692308
	},
	{
		"stop_id": 8576689,
		"ID": 616,
		"x": -32.9092294807,
		"y": 27.769140887,
		"h": 1.2307692308
	},
	{
		"stop_id": 8587247,
		"ID": 616,
		"x": -32.5152852127,
		"y": 27.756248326,
		"h": 1.2307692308
	},
	{
		"stop_id": 8587248,
		"ID": 616,
		"x": -32.1032910487,
		"y": 27.883210868,
		"h": 1.2307692308
	},
	{
		"stop_id": 8509000,
		"ID": 1395,
		"x": 99.6547305623,
		"y": 8.658167167,
		"h": 4.8901098901
	},
	{
		"stop_id": 8509006,
		"ID": 1395,
		"x": 99.8207005083,
		"y": 9.643230001,
		"h": 4.8901098901
	},
	{
		"stop_id": 8509050,
		"ID": 1395,
		"x": 98.4287563553,
		"y": 8.276203026,
		"h": 4.8901098901
	},
	{
		"stop_id": 8509099,
		"ID": 1395,
		"x": 98.7637061333,
		"y": 5.963164657,
		"h": 4.8901098901
	},
	{
		"stop_id": 8509150,
		"ID": 1395,
		"x": 99.8417282783,
		"y": 8.043167015,
		"h": 4.8901098901
	},
	{
		"stop_id": 8509180,
		"ID": 1395,
		"x": 96.0497147433,
		"y": 7.453219984,
		"h": 4.8901098901
	},
	{
		"stop_id": 8530545,
		"ID": 1395,
		"x": 99.4307358793,
		"y": 8.013198893,
		"h": 4.8901098901
	},
	{
		"stop_id": 8530546,
		"ID": 1395,
		"x": 99.4417019113,
		"y": 7.079231434,
		"h": 4.8901098901
	},
	{
		"stop_id": 8571309,
		"ID": 1395,
		"x": 99.9857515063,
		"y": 10.800204745,
		"h": 4.8901098901
	},
	{
		"stop_id": 8571313,
		"ID": 1395,
		"x": 99.5637221403,
		"y": 8.566219556,
		"h": 4.8901098901
	},
	{
		"stop_id": 8571633,
		"ID": 1395,
		"x": 99.1057566273,
		"y": 8.841177778,
		"h": 4.8901098901
	},
	{
		"stop_id": 8571684,
		"ID": 1395,
		"x": 98.9537544673,
		"y": 9.03220132,
		"h": 4.8901098901
	},
	{
		"stop_id": 8571706,
		"ID": 1395,
		"x": 98.7967176663,
		"y": 9.232214107,
		"h": 4.8901098901
	},
	{
		"stop_id": 8571709,
		"ID": 1395,
		"x": 98.6377713413,
		"y": 9.39815057,
		"h": 4.8901098901
	},
	{
		"stop_id": 8571710,
		"ID": 1395,
		"x": 98.4927368873,
		"y": 9.592149973,
		"h": 4.8901098901
	},
	{
		"stop_id": 8571847,
		"ID": 1395,
		"x": 98.6017069123,
		"y": 9.720143598,
		"h": 4.8901098901
	},
	{
		"stop_id": 8571888,
		"ID": 1395,
		"x": 98.8477029403,
		"y": 9.789161872,
		"h": 4.8901098901
	},
	{
		"stop_id": 8571924,
		"ID": 1395,
		"x": 99.0077402163,
		"y": 9.510161207,
		"h": 4.8901098901
	},
	{
		"stop_id": 8571950,
		"ID": 1395,
		"x": 99.3387271863,
		"y": 8.965139907,
		"h": 4.8901098901
	},
	{
		"stop_id": 8572375,
		"ID": 1395,
		"x": 99.7977329893,
		"y": 9.08023539,
		"h": 4.8901098901
	},
	{
		"stop_id": 8572404,
		"ID": 1395,
		"x": 99.7677684263,
		"y": 9.640149638,
		"h": 4.8901098901
	},
	{
		"stop_id": 8572453,
		"ID": 1395,
		"x": 99.5477093353,
		"y": 9.780189037,
		"h": 4.8901098901
	},
	{
		"stop_id": 8572456,
		"ID": 1395,
		"x": 99.4177529983,
		"y": 9.570214402,
		"h": 4.8901098901
	},
	{
		"stop_id": 8572655,
		"ID": 1395,
		"x": 99.5077768183,
		"y": 9.180156649,
		"h": 4.8901098901
	},
	{
		"stop_id": 8572658,
		"ID": 1395,
		"x": 99.5977332333,
		"y": 8.830244601,
		"h": 4.8901098901
	},
	{
		"stop_id": 8572659,
		"ID": 1395,
		"x": 97.9727537923,
		"y": 7.795199243,
		"h": 4.8901098901
	},
	{
		"stop_id": 8572662,
		"ID": 1395,
		"x": 95.9477595873,
		"y": 7.172215952,
		"h": 4.8901098901
	},
	{
		"stop_id": 8572663,
		"ID": 1395,
		"x": 95.9957271183,
		"y": 7.434243548,
		"h": 4.8901098901
	},
	{
		"stop_id": 8572664,
		"ID": 1395,
		"x": 95.7547052443,
		"y": 7.615244818,
		"h": 4.8901098901
	},
	{
		"stop_id": 8572667,
		"ID": 1395,
		"x": 95.5157425713,
		"y": 7.635171083,
		"h": 4.8901098901
	},
	{
		"stop_id": 8572746,
		"ID": 1395,
		"x": 96.0817673733,
		"y": 7.652224801,
		"h": 4.8901098901
	},
	{
		"stop_id": 8572749,
		"ID": 1395,
		"x": 96.1297696423,
		"y": 7.883228179,
		"h": 4.8901098901
	},
	{
		"stop_id": 8572784,
		"ID": 1395,
		"x": 95.9507038683,
		"y": 7.786151934,
		"h": 4.8901098901
	},
	{
		"stop_id": 8572786,
		"ID": 1395,
		"x": 95.8377331933,
		"y": 7.600166767,
		"h": 4.8901098901
	},
	{
		"stop_id": 8573183,
		"ID": 1395,
		"x": 99.1757698133,
		"y": 9.169211527,
		"h": 4.8901098901
	},
	{
		"stop_id": 8574493,
		"ID": 1395,
		"x": 99.6937142393,
		"y": 8.140196849,
		"h": 4.8901098901
	},
	{
		"stop_id": 8574494,
		"ID": 1395,
		"x": 99.7897193103,
		"y": 7.753193969,
		"h": 4.8901098901
	},
	{
		"stop_id": 8574495,
		"ID": 1395,
		"x": 100.4567573093,
		"y": 7.212198534,
		"h": 4.8901098901
	},
	{
		"stop_id": 8574496,
		"ID": 1395,
		"x": 100.4127235453,
		"y": 6.890182937,
		"h": 4.8901098901
	},
	{
		"stop_id": 8574497,
		"ID": 1395,
		"x": 100.5147057443,
		"y": 5.812190357,
		"h": 4.8901098901
	},
	{
		"stop_id": 8574666,
		"ID": 1395,
		"x": 99.4207201443,
		"y": 8.031170503,
		"h": 4.8901098901
	},
	{
		"stop_id": 8574667,
		"ID": 1395,
		"x": 98.9267344773,
		"y": 7.957214997,
		"h": 4.8901098901
	},
	{
		"stop_id": 8574668,
		"ID": 1395,
		"x": 98.7327327583,
		"y": 7.930163819,
		"h": 4.8901098901
	},
	{
		"stop_id": 8574669,
		"ID": 1395,
		"x": 98.3057386313,
		"y": 7.870156947,
		"h": 4.8901098901
	},
	{
		"stop_id": 8574670,
		"ID": 1395,
		"x": 97.6767576433,
		"y": 7.732243149,
		"h": 4.8901098901
	},
	{
		"stop_id": 8574694,
		"ID": 1395,
		"x": 100.0927741053,
		"y": 8.990250208,
		"h": 4.8901098901
	},
	{
		"stop_id": 8574695,
		"ID": 1395,
		"x": 100.0577703293,
		"y": 9.295249809,
		"h": 4.8901098901
	},
	{
		"stop_id": 8574696,
		"ID": 1395,
		"x": 100.0427347173,
		"y": 9.69519943,
		"h": 4.8901098901
	},
	{
		"stop_id": 8574697,
		"ID": 1395,
		"x": 100.0927135983,
		"y": 9.917173423,
		"h": 4.8901098901
	},
	{
		"stop_id": 8574698,
		"ID": 1395,
		"x": 100.0577556473,
		"y": 10.149221528,
		"h": 4.8901098901
	},
	{
		"stop_id": 8574699,
		"ID": 1395,
		"x": 100.0077003603,
		"y": 10.655218736,
		"h": 4.8901098901
	},
	{
		"stop_id": 8574710,
		"ID": 1395,
		"x": 100.1957039563,
		"y": 8.145147425,
		"h": 4.8901098901
	},
	{
		"stop_id": 8574711,
		"ID": 1395,
		"x": 101.0357505523,
		"y": 7.268212075,
		"h": 4.8901098901
	},
	{
		"stop_id": 8574880,
		"ID": 1395,
		"x": 100.6877103123,
		"y": 6.798241721,
		"h": 4.8901098901
	},
	{
		"stop_id": 8574881,
		"ID": 1395,
		"x": 100.9027562123,
		"y": 6.250193305,
		"h": 4.8901098901
	},
	{
		"stop_id": 8575112,
		"ID": 1395,
		"x": 99.5547411993,
		"y": 8.634151047,
		"h": 4.8901098901
	},
	{
		"stop_id": 8580587,
		"ID": 1395,
		"x": 95.9437059203,
		"y": 7.187234517,
		"h": 4.8901098901
	},
	{
		"stop_id": 8581044,
		"ID": 1395,
		"x": 99.7697538693,
		"y": 8.719173524,
		"h": 4.8901098901
	},
	{
		"stop_id": 8581896,
		"ID": 1395,
		"x": 99.7037300213,
		"y": 9.856188145,
		"h": 4.8901098901
	},
	{
		"stop_id": 8582066,
		"ID": 1395,
		"x": 95.9117067183,
		"y": 7.279147905,
		"h": 4.8901098901
	},
	{
		"stop_id": 8582197,
		"ID": 1395,
		"x": 100.0607259713,
		"y": 8.642200439,
		"h": 4.8901098901
	},
	{
		"stop_id": 8594403,
		"ID": 1395,
		"x": 100.5316989183,
		"y": 9.90523666,
		"h": 4.8901098901
	},
	{
		"stop_id": 8594404,
		"ID": 1395,
		"x": 99.4057298653,
		"y": 8.881181005,
		"h": 4.8901098901
	},
	{
		"stop_id": 8594405,
		"ID": 1395,
		"x": 99.3367471123,
		"y": 8.351217775,
		"h": 4.8901098901
	},
	{
		"stop_id": 8594406,
		"ID": 1395,
		"x": 100.4597076493,
		"y": 8.888192471,
		"h": 4.8901098901
	},
	{
		"stop_id": 8594407,
		"ID": 1395,
		"x": 100.0807585773,
		"y": 7.898194593,
		"h": 4.8901098901
	},
	{
		"stop_id": 8594408,
		"ID": 1395,
		"x": 100.7297315283,
		"y": 9.208151652,
		"h": 4.8901098901
	},
	{
		"stop_id": 8594409,
		"ID": 1395,
		"x": 100.3517650923,
		"y": 10.58023691,
		"h": 4.8901098901
	},
	{
		"stop_id": 8594410,
		"ID": 1395,
		"x": 100.3877501523,
		"y": 10.384249372,
		"h": 4.8901098901
	},
	{
		"stop_id": 8594411,
		"ID": 1395,
		"x": 100.3147540403,
		"y": 9.709147032,
		"h": 4.8901098901
	},
	{
		"stop_id": 8594413,
		"ID": 1395,
		"x": 100.8407493103,
		"y": 9.15619453,
		"h": 4.8901098901
	},
	{
		"stop_id": 8594415,
		"ID": 1395,
		"x": 99.8077329693,
		"y": 8.302154085,
		"h": 4.8901098901
	},
	{
		"stop_id": 8594416,
		"ID": 1395,
		"x": 100.5807073593,
		"y": 9.585156426,
		"h": 4.8901098901
	},
	{
		"stop_id": 8594418,
		"ID": 1395,
		"x": 100.4717710983,
		"y": 10.129162507,
		"h": 4.8901098901
	},
	{
		"stop_id": 8594419,
		"ID": 1395,
		"x": 98.5357627603,
		"y": 8.583187191,
		"h": 4.8901098901
	},
	{
		"stop_id": 8594420,
		"ID": 1395,
		"x": 98.1727454693,
		"y": 9.15020293,
		"h": 4.8901098901
	},
	{
		"stop_id": 8594421,
		"ID": 1395,
		"x": 98.7557178693,
		"y": 8.508164165,
		"h": 4.8901098901
	},
	{
		"stop_id": 8594422,
		"ID": 1395,
		"x": 100.9897336723,
		"y": 9.352144051,
		"h": 4.8901098901
	},
	{
		"stop_id": 8594423,
		"ID": 1395,
		"x": 98.4077009343,
		"y": 8.65119481,
		"h": 4.8901098901
	},
	{
		"stop_id": 8594424,
		"ID": 1395,
		"x": 100.4927545803,
		"y": 9.955237836,
		"h": 4.8901098901
	},
	{
		"stop_id": 8594425,
		"ID": 1395,
		"x": 100.5117009153,
		"y": 7.645159596,
		"h": 4.8901098901
	},
	{
		"stop_id": 8594426,
		"ID": 1395,
		"x": 98.1897245903,
		"y": 8.79322968,
		"h": 4.8901098901
	},
	{
		"stop_id": 8594427,
		"ID": 1395,
		"x": 100.3007097863,
		"y": 9.467225469,
		"h": 4.8901098901
	},
	{
		"stop_id": 8594428,
		"ID": 1395,
		"x": 100.4877410213,
		"y": 9.291185987,
		"h": 4.8901098901
	},
	{
		"stop_id": 8594430,
		"ID": 1395,
		"x": 100.4847285053,
		"y": 8.96515205,
		"h": 4.8901098901
	},
	{
		"stop_id": 8594431,
		"ID": 1395,
		"x": 97.9327073913,
		"y": 9.172227085,
		"h": 4.8901098901
	},
	{
		"stop_id": 8594432,
		"ID": 1395,
		"x": 97.8767223753,
		"y": 8.781191071,
		"h": 4.8901098901
	},
	{
		"stop_id": 8594433,
		"ID": 1395,
		"x": 100.0987481483,
		"y": 8.384211725,
		"h": 4.8901098901
	},
	{
		"stop_id": 8594434,
		"ID": 1395,
		"x": 100.9007470613,
		"y": 9.254224235,
		"h": 4.8901098901
	},
	{
		"stop_id": 8594435,
		"ID": 1395,
		"x": 100.6277155623,
		"y": 7.419178998,
		"h": 4.8901098901
	},
	{
		"stop_id": 8594437,
		"ID": 1395,
		"x": 100.9997745593,
		"y": 6.653150378,
		"h": 4.8901098901
	},
	{
		"stop_id": 8594439,
		"ID": 1395,
		"x": 100.0407098413,
		"y": 8.466178523,
		"h": 4.8901098901
	},
	{
		"stop_id": 8594440,
		"ID": 1395,
		"x": 97.9627314363,
		"y": 8.123219387,
		"h": 4.8901098901
	},
	{
		"stop_id": 8594441,
		"ID": 1395,
		"x": 100.3437417403,
		"y": 9.877181243,
		"h": 4.8901098901
	},
	{
		"stop_id": 8594442,
		"ID": 1395,
		"x": 97.8257259733,
		"y": 8.403187486,
		"h": 4.8901098901
	},
	{
		"stop_id": 8594443,
		"ID": 1395,
		"x": 99.2747377783,
		"y": 8.224237204,
		"h": 4.8901098901
	},
	{
		"stop_id": 8594444,
		"ID": 1395,
		"x": 100.8947699293,
		"y": 7.096165727,
		"h": 4.8901098901
	},
	{
		"stop_id": 8594445,
		"ID": 1395,
		"x": 100.2487460483,
		"y": 8.672249289,
		"h": 4.8901098901
	},
	{
		"stop_id": 8594446,
		"ID": 1395,
		"x": 100.2907042733,
		"y": 9.248209942,
		"h": 4.8901098901
	},
	{
		"stop_id": 8594448,
		"ID": 1395,
		"x": 100.3267215463,
		"y": 9.031204673,
		"h": 4.8901098901
	},
	{
		"stop_id": 8594450,
		"ID": 1395,
		"x": 99.0617025273,
		"y": 8.305208113,
		"h": 4.8901098901
	},
	{
		"stop_id": 8594451,
		"ID": 1395,
		"x": 100.3137095363,
		"y": 7.935228422,
		"h": 4.8901098901
	},
	{
		"stop_id": 8594452,
		"ID": 1395,
		"x": 100.4097456443,
		"y": 10.158194506,
		"h": 4.8901098901
	},
	{
		"stop_id": 8594462,
		"ID": 1395,
		"x": 100.9747649023,
		"y": 9.503208615,
		"h": 4.8901098901
	},
	{
		"stop_id": 8594463,
		"ID": 1395,
		"x": 100.7547360033,
		"y": 9.777212252,
		"h": 4.8901098901
	},
	{
		"stop_id": 8594464,
		"ID": 1395,
		"x": 100.8277651493,
		"y": 9.702216171,
		"h": 4.8901098901
	},
	{
		"stop_id": 8594980,
		"ID": 1395,
		"x": 98.1577264163,
		"y": 7.910174786,
		"h": 4.8901098901
	},
	{
		"stop_id": 8594981,
		"ID": 1395,
		"x": 98.5927229143,
		"y": 8.270199153,
		"h": 4.8901098901
	},
	{
		"stop_id": 8594982,
		"ID": 1395,
		"x": 97.7407151563,
		"y": 8.056205547,
		"h": 4.8901098901
	},
	{
		"stop_id": 8595001,
		"ID": 1395,
		"x": 99.0067455173,
		"y": 8.23424416,
		"h": 4.8901098901
	},
	{
		"stop_id": 8595002,
		"ID": 1395,
		"x": 100.3447403883,
		"y": 8.98219909,
		"h": 4.8901098901
	},
	{
		"stop_id": 8595391,
		"ID": 1395,
		"x": 100.1837413093,
		"y": 7.879150334,
		"h": 4.8901098901
	},
	{
		"stop_id": 8595591,
		"ID": 1395,
		"x": 99.8397645673,
		"y": 8.597155004,
		"h": 4.8901098901
	},
	{
		"stop_id": 8595592,
		"ID": 1395,
		"x": 99.8127254603,
		"y": 8.418166443,
		"h": 4.8901098901
	},
	{
		"stop_id": 8595593,
		"ID": 1395,
		"x": 100.0207339693,
		"y": 8.594201963,
		"h": 4.8901098901
	},
	{
		"stop_id": 8595594,
		"ID": 1395,
		"x": 99.8977764913,
		"y": 9.016180062,
		"h": 4.8901098901
	},
	{
		"stop_id": 8595635,
		"ID": 1395,
		"x": 97.7857153493,
		"y": 8.129230527,
		"h": 4.8901098901
	},
	{
		"stop_id": 8595724,
		"ID": 1395,
		"x": 98.4007722743,
		"y": 8.385225058,
		"h": 4.8901098901
	},
	{
		"stop_id": 8595725,
		"ID": 1395,
		"x": 98.1667249773,
		"y": 8.25715755,
		"h": 4.8901098901
	},
	{
		"stop_id": 8509002,
		"ID": 1422,
		"x": 101.2257333953,
		"y": 21.418142642,
		"h": 1.9230769231
	},
	{
		"stop_id": 8509056,
		"ID": 1422,
		"x": 101.7767278013,
		"y": 20.294222555,
		"h": 1.9230769231
	},
	{
		"stop_id": 8509057,
		"ID": 1422,
		"x": 102.6927366713,
		"y": 22.594148603,
		"h": 1.9230769231
	},
	{
		"stop_id": 8509684,
		"ID": 1422,
		"x": 102.3247401603,
		"y": 23.484183322,
		"h": 1.9230769231
	},
	{
		"stop_id": 8530527,
		"ID": 1422,
		"x": 102.3377637633,
		"y": 23.534249111,
		"h": 1.9230769231
	},
	{
		"stop_id": 8557025,
		"ID": 1422,
		"x": 105.0077296093,
		"y": 19.658197456,
		"h": 1.9230769231
	},
	{
		"stop_id": 8574486,
		"ID": 1422,
		"x": 104.2717527453,
		"y": 21.803245861,
		"h": 1.9230769231
	},
	{
		"stop_id": 8574565,
		"ID": 1422,
		"x": 102.7947546143,
		"y": 23.029209999,
		"h": 1.9230769231
	},
	{
		"stop_id": 8574567,
		"ID": 1422,
		"x": 101.8867328403,
		"y": 21.740172604,
		"h": 1.9230769231
	},
	{
		"stop_id": 8574568,
		"ID": 1422,
		"x": 101.7847592183,
		"y": 21.508203995,
		"h": 1.9230769231
	},
	{
		"stop_id": 8574569,
		"ID": 1422,
		"x": 101.2917239863,
		"y": 21.458179713,
		"h": 1.9230769231
	},
	{
		"stop_id": 8574741,
		"ID": 1422,
		"x": 106.4577198903,
		"y": 21.920224655,
		"h": 1.9230769231
	},
	{
		"stop_id": 8574742,
		"ID": 1422,
		"x": 105.6917323643,
		"y": 20.758220509,
		"h": 1.9230769231
	},
	{
		"stop_id": 8574743,
		"ID": 1422,
		"x": 106.0567157053,
		"y": 21.705214145,
		"h": 1.9230769231
	},
	{
		"stop_id": 8574744,
		"ID": 1422,
		"x": 105.2957457423,
		"y": 20.176177118,
		"h": 1.9230769231
	},
	{
		"stop_id": 8577226,
		"ID": 1422,
		"x": 101.7167316573,
		"y": 20.761244866,
		"h": 1.9230769231
	},
	{
		"stop_id": 8579693,
		"ID": 1422,
		"x": 102.4677223353,
		"y": 23.132189355,
		"h": 1.9230769231
	},
	{
		"stop_id": 8579694,
		"ID": 1422,
		"x": 102.4837272653,
		"y": 23.134181503,
		"h": 1.9230769231
	},
	{
		"stop_id": 8579817,
		"ID": 1422,
		"x": 102.3027551633,
		"y": 19.508200412,
		"h": 1.9230769231
	},
	{
		"stop_id": 8579820,
		"ID": 1422,
		"x": 102.6377124373,
		"y": 22.672167777,
		"h": 1.9230769231
	},
	{
		"stop_id": 8580951,
		"ID": 1422,
		"x": 100.7897423073,
		"y": 21.879158057,
		"h": 1.9230769231
	},
	{
		"stop_id": 8580952,
		"ID": 1422,
		"x": 100.7137454563,
		"y": 21.659251155,
		"h": 1.9230769231
	},
	{
		"stop_id": 8580973,
		"ID": 1422,
		"x": 100.6347717463,
		"y": 21.816160339,
		"h": 1.9230769231
	},
	{
		"stop_id": 8581032,
		"ID": 1422,
		"x": 102.1707046473,
		"y": 19.974152928,
		"h": 1.9230769231
	},
	{
		"stop_id": 8581036,
		"ID": 1422,
		"x": 101.5267734233,
		"y": 21.389236614,
		"h": 1.9230769231
	},
	{
		"stop_id": 8581037,
		"ID": 1422,
		"x": 101.5947228023,
		"y": 21.013176079,
		"h": 1.9230769231
	},
	{
		"stop_id": 8581038,
		"ID": 1422,
		"x": 101.8667639523,
		"y": 20.515190413,
		"h": 1.9230769231
	},
	{
		"stop_id": 8581039,
		"ID": 1422,
		"x": 101.9767101353,
		"y": 20.324215184,
		"h": 1.9230769231
	},
	{
		"stop_id": 8583858,
		"ID": 1422,
		"x": 102.3737012243,
		"y": 21.550197459,
		"h": 1.9230769231
	},
	{
		"stop_id": 8509003,
		"ID": 1398,
		"x": 99.2287360913,
		"y": 25.412244731,
		"h": 2.0879120879
	},
	{
		"stop_id": 8509004,
		"ID": 1398,
		"x": 97.3867167323,
		"y": 26.083183236,
		"h": 2.0879120879
	},
	{
		"stop_id": 8509456,
		"ID": 1398,
		"x": 97.8517285803,
		"y": 22.742237222,
		"h": 2.0879120879
	},
	{
		"stop_id": 8509460,
		"ID": 1398,
		"x": 97.6417676803,
		"y": 24.241146044,
		"h": 2.0879120879
	},
	{
		"stop_id": 8509697,
		"ID": 1398,
		"x": 97.0407529973,
		"y": 25.244225929,
		"h": 2.0879120879
	},
	{
		"stop_id": 8509772,
		"ID": 1398,
		"x": 97.7907156793,
		"y": 27.721191795,
		"h": 2.0879120879
	},
	{
		"stop_id": 8509785,
		"ID": 1398,
		"x": 101.2567412003,
		"y": 25.168154135,
		"h": 2.0879120879
	},
	{
		"stop_id": 8509792,
		"ID": 1398,
		"x": 99.3997123883,
		"y": 25.773237362,
		"h": 2.0879120879
	},
	{
		"stop_id": 8509858,
		"ID": 1398,
		"x": 97.1827120433,
		"y": 23.830141417,
		"h": 2.0879120879
	},
	{
		"stop_id": 8574557,
		"ID": 1398,
		"x": 97.0627215083,
		"y": 25.236240292,
		"h": 2.0879120879
	},
	{
		"stop_id": 8574560,
		"ID": 1398,
		"x": 97.4827092503,
		"y": 22.905210755,
		"h": 2.0879120879
	},
	{
		"stop_id": 8574563,
		"ID": 1398,
		"x": 99.2137721493,
		"y": 25.434199349,
		"h": 2.0879120879
	},
	{
		"stop_id": 8574564,
		"ID": 1398,
		"x": 99.7637076423,
		"y": 25.73124867,
		"h": 2.0879120879
	},
	{
		"stop_id": 8574571,
		"ID": 1398,
		"x": 97.1327490233,
		"y": 23.739192091,
		"h": 2.0879120879
	},
	{
		"stop_id": 8575114,
		"ID": 1398,
		"x": 97.3607727413,
		"y": 26.063149038,
		"h": 2.0879120879
	},
	{
		"stop_id": 8580153,
		"ID": 1398,
		"x": 96.9117436163,
		"y": 25.081249373,
		"h": 2.0879120879
	},
	{
		"stop_id": 8581436,
		"ID": 1398,
		"x": 97.4917287293,
		"y": 24.148221067,
		"h": 2.0879120879
	},
	{
		"stop_id": 8581601,
		"ID": 1398,
		"x": 96.4157452223,
		"y": 23.280212861,
		"h": 2.0879120879
	},
	{
		"stop_id": 8581604,
		"ID": 1398,
		"x": 99.0027262003,
		"y": 26.06314955,
		"h": 2.0879120879
	},
	{
		"stop_id": 8581609,
		"ID": 1398,
		"x": 101.4697709843,
		"y": 25.078154794,
		"h": 2.0879120879
	},
	{
		"stop_id": 8582420,
		"ID": 1398,
		"x": 97.2117652663,
		"y": 26.889189632,
		"h": 2.0879120879
	},
	{
		"stop_id": 8582467,
		"ID": 1398,
		"x": 97.2527347843,
		"y": 25.665172997,
		"h": 2.0879120879
	},
	{
		"stop_id": 8582468,
		"ID": 1398,
		"x": 96.7477454713,
		"y": 25.880214809,
		"h": 2.0879120879
	},
	{
		"stop_id": 8582469,
		"ID": 1398,
		"x": 97.0267515213,
		"y": 25.441144818,
		"h": 2.0879120879
	},
	{
		"stop_id": 8582470,
		"ID": 1398,
		"x": 96.5247208133,
		"y": 26.402169814,
		"h": 2.0879120879
	},
	{
		"stop_id": 8582473,
		"ID": 1398,
		"x": 98.3807621103,
		"y": 24.408155177,
		"h": 2.0879120879
	},
	{
		"stop_id": 8582493,
		"ID": 1398,
		"x": 97.2127626053,
		"y": 25.224172739,
		"h": 2.0879120879
	},
	{
		"stop_id": 8582595,
		"ID": 1398,
		"x": 97.4237188783,
		"y": 24.927235981,
		"h": 2.0879120879
	},
	{
		"stop_id": 8582611,
		"ID": 1398,
		"x": 98.5627202673,
		"y": 23.997164545,
		"h": 2.0879120879
	},
	{
		"stop_id": 8582740,
		"ID": 1398,
		"x": 97.0047041513,
		"y": 24.847147809,
		"h": 2.0879120879
	},
	{
		"stop_id": 8583633,
		"ID": 1398,
		"x": 100.2757244663,
		"y": 26.943163999,
		"h": 2.0879120879
	},
	{
		"stop_id": 8583634,
		"ID": 1398,
		"x": 98.9687582413,
		"y": 26.93914745,
		"h": 2.0879120879
	},
	{
		"stop_id": 8594776,
		"ID": 1398,
		"x": 97.4857548513,
		"y": 25.027180979,
		"h": 2.0879120879
	},
	{
		"stop_id": 8594777,
		"ID": 1398,
		"x": 97.9037147143,
		"y": 24.798221392,
		"h": 2.0879120879
	},
	{
		"stop_id": 8509051,
		"ID": 1396,
		"x": 99.9037576913,
		"y": 11.323143157,
		"h": 1.2637362637
	},
	{
		"stop_id": 8570850,
		"ID": 1396,
		"x": 99.1597541033,
		"y": 11.152187737,
		"h": 1.2637362637
	},
	{
		"stop_id": 8571020,
		"ID": 1396,
		"x": 99.2767264863,
		"y": 11.35324947,
		"h": 1.2637362637
	},
	{
		"stop_id": 8571030,
		"ID": 1396,
		"x": 99.4307065223,
		"y": 11.510148319,
		"h": 1.2637362637
	},
	{
		"stop_id": 8571107,
		"ID": 1396,
		"x": 99.5747202943,
		"y": 11.391210257,
		"h": 1.2637362637
	},
	{
		"stop_id": 8571241,
		"ID": 1396,
		"x": 99.8317344713,
		"y": 11.290192855,
		"h": 1.2637362637
	},
	{
		"stop_id": 8574700,
		"ID": 1396,
		"x": 100.1417421913,
		"y": 11.258218478,
		"h": 1.2637362637
	},
	{
		"stop_id": 8574701,
		"ID": 1396,
		"x": 100.4577179443,
		"y": 12.355194559,
		"h": 1.2637362637
	},
	{
		"stop_id": 8574702,
		"ID": 1396,
		"x": 101.8117711963,
		"y": 13.624183726,
		"h": 1.2637362637
	},
	{
		"stop_id": 8509053,
		"ID": 1421,
		"x": 101.7627263333,
		"y": 16.044244224,
		"h": 1.7582417582
	},
	{
		"stop_id": 8509054,
		"ID": 1421,
		"x": 101.7467493093,
		"y": 17.807171956,
		"h": 1.7582417582
	},
	{
		"stop_id": 8509055,
		"ID": 1421,
		"x": 102.0947667613,
		"y": 19.483207495,
		"h": 1.7582417582
	},
	{
		"stop_id": 8570814,
		"ID": 1421,
		"x": 101.5987237123,
		"y": 16.090190547,
		"h": 1.7582417582
	},
	{
		"stop_id": 8574703,
		"ID": 1421,
		"x": 101.9047574393,
		"y": 13.864243749,
		"h": 1.7582417582
	},
	{
		"stop_id": 8574704,
		"ID": 1421,
		"x": 102.0677218923,
		"y": 14.205177525,
		"h": 1.7582417582
	},
	{
		"stop_id": 8574705,
		"ID": 1421,
		"x": 101.7247062883,
		"y": 14.716140475,
		"h": 1.7582417582
	},
	{
		"stop_id": 8574707,
		"ID": 1421,
		"x": 101.7467176753,
		"y": 16.002218593,
		"h": 1.7582417582
	},
	{
		"stop_id": 8574915,
		"ID": 1421,
		"x": 102.9937028803,
		"y": 13.902142285,
		"h": 1.7582417582
	},
	{
		"stop_id": 8574916,
		"ID": 1421,
		"x": 103.0327695113,
		"y": 14.060236287,
		"h": 1.7582417582
	},
	{
		"stop_id": 8574917,
		"ID": 1421,
		"x": 102.3297646713,
		"y": 13.767214722,
		"h": 1.7582417582
	},
	{
		"stop_id": 8574918,
		"ID": 1421,
		"x": 103.0527464523,
		"y": 14.362162431,
		"h": 1.7582417582
	},
	{
		"stop_id": 8574919,
		"ID": 1421,
		"x": 103.5597616293,
		"y": 14.750224631,
		"h": 1.7582417582
	},
	{
		"stop_id": 8580810,
		"ID": 1421,
		"x": 102.7787063113,
		"y": 19.078182058,
		"h": 1.7582417582
	},
	{
		"stop_id": 8580926,
		"ID": 1421,
		"x": 101.1707715793,
		"y": 16.071195357,
		"h": 1.7582417582
	},
	{
		"stop_id": 8581040,
		"ID": 1421,
		"x": 102.3987741543,
		"y": 19.273148221,
		"h": 1.7582417582
	},
	{
		"stop_id": 8581041,
		"ID": 1421,
		"x": 102.6307411463,
		"y": 19.111189455,
		"h": 1.7582417582
	},
	{
		"stop_id": 8581042,
		"ID": 1421,
		"x": 102.8277627863,
		"y": 19.472206793,
		"h": 1.7582417582
	},
	{
		"stop_id": 8581043,
		"ID": 1421,
		"x": 102.4377408933,
		"y": 19.487177056,
		"h": 1.7582417582
	},
	{
		"stop_id": 8581077,
		"ID": 1421,
		"x": 102.4927704603,
		"y": 18.751227717,
		"h": 1.7582417582
	},
	{
		"stop_id": 8581348,
		"ID": 1421,
		"x": 102.0197615243,
		"y": 17.616160722,
		"h": 1.7582417582
	},
	{
		"stop_id": 8581349,
		"ID": 1421,
		"x": 102.1827400483,
		"y": 17.980235007,
		"h": 1.7582417582
	},
	{
		"stop_id": 8581350,
		"ID": 1421,
		"x": 102.3267051523,
		"y": 18.390173554,
		"h": 1.7582417582
	},
	{
		"stop_id": 8582985,
		"ID": 1421,
		"x": 101.9947655903,
		"y": 17.155180975,
		"h": 1.7582417582
	},
	{
		"stop_id": 8509058,
		"ID": 1443,
		"x": 107.1687566923,
		"y": 22.633160628,
		"h": 1.6593406593
	},
	{
		"stop_id": 8509059,
		"ID": 1443,
		"x": 108.1647621263,
		"y": 23.061147971,
		"h": 1.6593406593
	},
	{
		"stop_id": 8509876,
		"ID": 1443,
		"x": 107.6367443643,
		"y": 24.14122463,
		"h": 1.6593406593
	},
	{
		"stop_id": 8530531,
		"ID": 1443,
		"x": 109.4147188463,
		"y": 23.716153016,
		"h": 1.6593406593
	},
	{
		"stop_id": 8530532,
		"ID": 1443,
		"x": 111.4447124993,
		"y": 25.276163211,
		"h": 1.6593406593
	},
	{
		"stop_id": 8573635,
		"ID": 1443,
		"x": 107.7257079523,
		"y": 22.506189377,
		"h": 1.6593406593
	},
	{
		"stop_id": 8574487,
		"ID": 1443,
		"x": 108.1827150193,
		"y": 23.064211207,
		"h": 1.6593406593
	},
	{
		"stop_id": 8574488,
		"ID": 1443,
		"x": 107.7547231413,
		"y": 22.980223946,
		"h": 1.6593406593
	},
	{
		"stop_id": 8574489,
		"ID": 1443,
		"x": 107.1457129833,
		"y": 22.654202912,
		"h": 1.6593406593
	},
	{
		"stop_id": 8574490,
		"ID": 1443,
		"x": 107.4157393493,
		"y": 23.093164525,
		"h": 1.6593406593
	},
	{
		"stop_id": 8574491,
		"ID": 1443,
		"x": 107.6977215553,
		"y": 23.861227605,
		"h": 1.6593406593
	},
	{
		"stop_id": 8574738,
		"ID": 1443,
		"x": 108.2707339623,
		"y": 23.171231765,
		"h": 1.6593406593
	},
	{
		"stop_id": 8574765,
		"ID": 1443,
		"x": 110.2057071913,
		"y": 22.834222572,
		"h": 1.6593406593
	},
	{
		"stop_id": 8574766,
		"ID": 1443,
		"x": 109.6297684093,
		"y": 23.272162888,
		"h": 1.6593406593
	},
	{
		"stop_id": 8574767,
		"ID": 1443,
		"x": 109.4747236763,
		"y": 23.535237905,
		"h": 1.6593406593
	},
	{
		"stop_id": 8581605,
		"ID": 1443,
		"x": 107.1307001253,
		"y": 22.73919593,
		"h": 1.6593406593
	},
	{
		"stop_id": 8581980,
		"ID": 1443,
		"x": 109.7157211683,
		"y": 23.582227806,
		"h": 1.6593406593
	},
	{
		"stop_id": 8581981,
		"ID": 1443,
		"x": 109.4157486013,
		"y": 23.73620112,
		"h": 1.6593406593
	},
	{
		"stop_id": 8581982,
		"ID": 1443,
		"x": 109.1617016223,
		"y": 23.677176039,
		"h": 1.6593406593
	},
	{
		"stop_id": 8582405,
		"ID": 1443,
		"x": 108.1677744243,
		"y": 22.86215731,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583411,
		"ID": 1443,
		"x": 107.8737238683,
		"y": 22.773146912,
		"h": 1.6593406593
	},
	{
		"stop_id": 8509060,
		"ID": 1460,
		"x": 111.4427395843,
		"y": 21.76420225,
		"h": 2.0549450549
	},
	{
		"stop_id": 8509976,
		"ID": 1460,
		"x": 113.3577333403,
		"y": 19.669163304,
		"h": 2.0549450549
	},
	{
		"stop_id": 8574749,
		"ID": 1460,
		"x": 112.1037411393,
		"y": 22.028212298,
		"h": 2.0549450549
	},
	{
		"stop_id": 8574750,
		"ID": 1460,
		"x": 113.1147472343,
		"y": 21.713194929,
		"h": 2.0549450549
	},
	{
		"stop_id": 8574751,
		"ID": 1460,
		"x": 112.3527747913,
		"y": 21.959205489,
		"h": 2.0549450549
	},
	{
		"stop_id": 8574752,
		"ID": 1460,
		"x": 113.4457129253,
		"y": 21.579208861,
		"h": 2.0549450549
	},
	{
		"stop_id": 8574753,
		"ID": 1460,
		"x": 114.3217242633,
		"y": 21.204199427,
		"h": 2.0549450549
	},
	{
		"stop_id": 8574754,
		"ID": 1460,
		"x": 111.7477366823,
		"y": 21.928218317,
		"h": 2.0549450549
	},
	{
		"stop_id": 8574755,
		"ID": 1460,
		"x": 111.8247375803,
		"y": 22.475173033,
		"h": 2.0549450549
	},
	{
		"stop_id": 8574756,
		"ID": 1460,
		"x": 111.4217327813,
		"y": 22.698155157,
		"h": 2.0549450549
	},
	{
		"stop_id": 8574757,
		"ID": 1460,
		"x": 112.9537566343,
		"y": 23.466219411,
		"h": 2.0549450549
	},
	{
		"stop_id": 8574758,
		"ID": 1460,
		"x": 112.9577379273,
		"y": 23.155146915,
		"h": 2.0549450549
	},
	{
		"stop_id": 8574759,
		"ID": 1460,
		"x": 115.0587623473,
		"y": 24.450201754,
		"h": 2.0549450549
	},
	{
		"stop_id": 8574760,
		"ID": 1460,
		"x": 112.5857627933,
		"y": 23.023163551,
		"h": 2.0549450549
	},
	{
		"stop_id": 8574761,
		"ID": 1460,
		"x": 111.8217735093,
		"y": 22.721211406,
		"h": 2.0549450549
	},
	{
		"stop_id": 8574763,
		"ID": 1460,
		"x": 111.3617442523,
		"y": 22.0691713,
		"h": 2.0549450549
	},
	{
		"stop_id": 8574764,
		"ID": 1460,
		"x": 110.6077586883,
		"y": 22.605238162,
		"h": 2.0549450549
	},
	{
		"stop_id": 8575063,
		"ID": 1460,
		"x": 112.3467736833,
		"y": 21.214210528,
		"h": 2.0549450549
	},
	{
		"stop_id": 8575064,
		"ID": 1460,
		"x": 112.8637614523,
		"y": 20.6511438,
		"h": 2.0549450549
	},
	{
		"stop_id": 8575065,
		"ID": 1460,
		"x": 113.2097101703,
		"y": 20.091168997,
		"h": 2.0549450549
	},
	{
		"stop_id": 8575070,
		"ID": 1460,
		"x": 111.6917357913,
		"y": 21.858210762,
		"h": 2.0549450549
	},
	{
		"stop_id": 8575119,
		"ID": 1460,
		"x": 111.4597734863,
		"y": 21.762244151,
		"h": 2.0549450549
	},
	{
		"stop_id": 8576907,
		"ID": 1460,
		"x": 114.5017452243,
		"y": 20.979230847,
		"h": 2.0549450549
	},
	{
		"stop_id": 8579816,
		"ID": 1460,
		"x": 113.5787711023,
		"y": 23.383247823,
		"h": 2.0549450549
	},
	{
		"stop_id": 8580783,
		"ID": 1460,
		"x": 111.4667740933,
		"y": 22.253245018,
		"h": 2.0549450549
	},
	{
		"stop_id": 8580784,
		"ID": 1460,
		"x": 111.5517574123,
		"y": 22.406160623,
		"h": 2.0549450549
	},
	{
		"stop_id": 8580848,
		"ID": 1460,
		"x": 110.9147317703,
		"y": 22.441179669,
		"h": 2.0549450549
	},
	{
		"stop_id": 8581176,
		"ID": 1460,
		"x": 111.4687269513,
		"y": 22.047216148,
		"h": 2.0549450549
	},
	{
		"stop_id": 8581438,
		"ID": 1460,
		"x": 113.3607203763,
		"y": 19.805157604,
		"h": 2.0549450549
	},
	{
		"stop_id": 8582203,
		"ID": 1460,
		"x": 111.1747686933,
		"y": 22.194158797,
		"h": 2.0549450549
	},
	{
		"stop_id": 8582406,
		"ID": 1460,
		"x": 111.9706992933,
		"y": 21.749231222,
		"h": 2.0549450549
	},
	{
		"stop_id": 8583556,
		"ID": 1460,
		"x": 112.2817195103,
		"y": 21.878192399,
		"h": 2.0549450549
	},
	{
		"stop_id": 8583570,
		"ID": 1460,
		"x": 111.1017362273,
		"y": 22.022239427,
		"h": 2.0549450549
	},
	{
		"stop_id": 8509061,
		"ID": 1459,
		"x": 113.0997138613,
		"y": 18.674189755,
		"h": 1.8241758242
	},
	{
		"stop_id": 8509062,
		"ID": 1459,
		"x": 113.8457235133,
		"y": 17.580211577,
		"h": 1.8241758242
	},
	{
		"stop_id": 8509063,
		"ID": 1459,
		"x": 115.0447017983,
		"y": 16.794175231,
		"h": 1.8241758242
	},
	{
		"stop_id": 8509633,
		"ID": 1459,
		"x": 112.1397647603,
		"y": 18.894156344,
		"h": 1.8241758242
	},
	{
		"stop_id": 8509733,
		"ID": 1459,
		"x": 113.1007346653,
		"y": 18.644190699,
		"h": 1.8241758242
	},
	{
		"stop_id": 8509736,
		"ID": 1459,
		"x": 116.4627497613,
		"y": 17.092203162,
		"h": 1.8241758242
	},
	{
		"stop_id": 8509758,
		"ID": 1459,
		"x": 113.6517322743,
		"y": 18.824212862,
		"h": 1.8241758242
	},
	{
		"stop_id": 8509862,
		"ID": 1459,
		"x": 115.9457618613,
		"y": 17.167169885,
		"h": 1.8241758242
	},
	{
		"stop_id": 8575066,
		"ID": 1459,
		"x": 113.3077406093,
		"y": 19.360197892,
		"h": 1.8241758242
	},
	{
		"stop_id": 8575067,
		"ID": 1459,
		"x": 113.9327682443,
		"y": 18.705148649,
		"h": 1.8241758242
	},
	{
		"stop_id": 8575068,
		"ID": 1459,
		"x": 114.4107020663,
		"y": 18.041198508,
		"h": 1.8241758242
	},
	{
		"stop_id": 8575069,
		"ID": 1459,
		"x": 115.2307497063,
		"y": 17.375175694,
		"h": 1.8241758242
	},
	{
		"stop_id": 8575071,
		"ID": 1459,
		"x": 111.6987241423,
		"y": 18.730220997,
		"h": 1.8241758242
	},
	{
		"stop_id": 8575077,
		"ID": 1459,
		"x": 112.7577048663,
		"y": 18.642166436,
		"h": 1.8241758242
	},
	{
		"stop_id": 8575078,
		"ID": 1459,
		"x": 112.3317176463,
		"y": 18.952179982,
		"h": 1.8241758242
	},
	{
		"stop_id": 8575079,
		"ID": 1459,
		"x": 115.0137199643,
		"y": 16.733211022,
		"h": 1.8241758242
	},
	{
		"stop_id": 8575080,
		"ID": 1459,
		"x": 115.6907227103,
		"y": 16.000224111,
		"h": 1.8241758242
	},
	{
		"stop_id": 8579997,
		"ID": 1459,
		"x": 116.0717713413,
		"y": 16.114193388,
		"h": 1.8241758242
	},
	{
		"stop_id": 8581052,
		"ID": 1459,
		"x": 113.4227393743,
		"y": 19.019203647,
		"h": 1.8241758242
	},
	{
		"stop_id": 8581173,
		"ID": 1459,
		"x": 116.1587283303,
		"y": 15.824249708,
		"h": 1.8241758242
	},
	{
		"stop_id": 8581175,
		"ID": 1459,
		"x": 113.9247488513,
		"y": 17.472181742,
		"h": 1.8241758242
	},
	{
		"stop_id": 8581648,
		"ID": 1459,
		"x": 113.8707174293,
		"y": 17.551243169,
		"h": 1.8241758242
	},
	{
		"stop_id": 8581656,
		"ID": 1459,
		"x": 113.2287724733,
		"y": 18.129182223,
		"h": 1.8241758242
	},
	{
		"stop_id": 8582761,
		"ID": 1459,
		"x": 113.5307603513,
		"y": 17.79816954,
		"h": 1.8241758242
	},
	{
		"stop_id": 8583684,
		"ID": 1459,
		"x": 115.2547508933,
		"y": 16.587232839,
		"h": 1.8241758242
	},
	{
		"stop_id": 8583744,
		"ID": 1459,
		"x": 115.0827500963,
		"y": 16.210172462,
		"h": 1.8241758242
	},
	{
		"stop_id": 8509064,
		"ID": 1473,
		"x": 117.9707511583,
		"y": 15.981207574,
		"h": 1.4615384615
	},
	{
		"stop_id": 8509065,
		"ID": 1473,
		"x": 120.8947289613,
		"y": 15.331190932,
		"h": 1.4615384615
	},
	{
		"stop_id": 8509695,
		"ID": 1473,
		"x": 120.0387629343,
		"y": 14.657178364,
		"h": 1.4615384615
	},
	{
		"stop_id": 8509975,
		"ID": 1473,
		"x": 117.6337681223,
		"y": 16.5962423,
		"h": 1.4615384615
	},
	{
		"stop_id": 8575081,
		"ID": 1473,
		"x": 117.9827455083,
		"y": 15.980229811,
		"h": 1.4615384615
	},
	{
		"stop_id": 8575082,
		"ID": 1473,
		"x": 117.1477396593,
		"y": 16.362170521,
		"h": 1.4615384615
	},
	{
		"stop_id": 8575088,
		"ID": 1473,
		"x": 118.3987118703,
		"y": 16.003186821,
		"h": 1.4615384615
	},
	{
		"stop_id": 8575089,
		"ID": 1473,
		"x": 119.4287575403,
		"y": 15.303169386,
		"h": 1.4615384615
	},
	{
		"stop_id": 8575090,
		"ID": 1473,
		"x": 119.7617313393,
		"y": 15.076155585,
		"h": 1.4615384615
	},
	{
		"stop_id": 8575091,
		"ID": 1473,
		"x": 120.0057520583,
		"y": 14.875177453,
		"h": 1.4615384615
	},
	{
		"stop_id": 8580193,
		"ID": 1473,
		"x": 117.6937552433,
		"y": 16.062170494,
		"h": 1.4615384615
	},
	{
		"stop_id": 8581174,
		"ID": 1473,
		"x": 116.5527098613,
		"y": 15.908156569,
		"h": 1.4615384615
	},
	{
		"stop_id": 8581201,
		"ID": 1473,
		"x": 120.4097260543,
		"y": 15.834164996,
		"h": 1.4615384615
	},
	{
		"stop_id": 8581202,
		"ID": 1473,
		"x": 120.5717406073,
		"y": 15.716154747,
		"h": 1.4615384615
	},
	{
		"stop_id": 8581443,
		"ID": 1473,
		"x": 119.2477351953,
		"y": 15.982189603,
		"h": 1.4615384615
	},
	{
		"stop_id": 8509067,
		"ID": 1501,
		"x": 125.9567036173,
		"y": 12.797245915,
		"h": 1.4615384615
	},
	{
		"stop_id": 8530533,
		"ID": 1501,
		"x": 125.9727751123,
		"y": 12.913194894,
		"h": 1.4615384615
	},
	{
		"stop_id": 8581194,
		"ID": 1501,
		"x": 125.9277266213,
		"y": 12.878205772,
		"h": 1.4615384615
	},
	{
		"stop_id": 8582852,
		"ID": 1501,
		"x": 127.0277087483,
		"y": 11.200194863,
		"h": 1.4615384615
	},
	{
		"stop_id": 8582853,
		"ID": 1501,
		"x": 126.2827103043,
		"y": 12.16017685,
		"h": 1.4615384615
	},
	{
		"stop_id": 8582860,
		"ID": 1501,
		"x": 126.7037406643,
		"y": 11.281173579,
		"h": 1.4615384615
	},
	{
		"stop_id": 8582863,
		"ID": 1501,
		"x": 126.3277311753,
		"y": 12.485237766,
		"h": 1.4615384615
	},
	{
		"stop_id": 8582864,
		"ID": 1501,
		"x": 126.1277139133,
		"y": 12.737162875,
		"h": 1.4615384615
	},
	{
		"stop_id": 8582867,
		"ID": 1501,
		"x": 127.4457164773,
		"y": 10.981145801,
		"h": 1.4615384615
	},
	{
		"stop_id": 8582869,
		"ID": 1501,
		"x": 126.2927356113,
		"y": 11.980196176,
		"h": 1.4615384615
	},
	{
		"stop_id": 8582889,
		"ID": 1501,
		"x": 125.9977344403,
		"y": 12.900178913,
		"h": 1.4615384615
	},
	{
		"stop_id": 8594546,
		"ID": 1501,
		"x": 126.8077522253,
		"y": 11.590171488,
		"h": 1.4615384615
	},
	{
		"stop_id": 8594547,
		"ID": 1501,
		"x": 126.9077654093,
		"y": 11.780148962,
		"h": 1.4615384615
	},
	{
		"stop_id": 8594548,
		"ID": 1501,
		"x": 127.1777225213,
		"y": 11.840192618,
		"h": 1.4615384615
	},
	{
		"stop_id": 8594549,
		"ID": 1501,
		"x": 127.3477297223,
		"y": 11.650202697,
		"h": 1.4615384615
	},
	{
		"stop_id": 8509068,
		"ID": 1487,
		"x": 126.4337505983,
		"y": 11.226156302,
		"h": 1.6923076923
	},
	{
		"stop_id": 8509069,
		"ID": 1487,
		"x": 125.4457580783,
		"y": 11.328156197,
		"h": 1.6923076923
	},
	{
		"stop_id": 8509080,
		"ID": 1487,
		"x": 126.3967416623,
		"y": 11.197198039,
		"h": 1.6923076923
	},
	{
		"stop_id": 8509081,
		"ID": 1487,
		"x": 124.7207083733,
		"y": 10.370250093,
		"h": 1.6923076923
	},
	{
		"stop_id": 8509082,
		"ID": 1487,
		"x": 123.9497390933,
		"y": 10.015184177,
		"h": 1.6923076923
	},
	{
		"stop_id": 8530535,
		"ID": 1487,
		"x": 122.2597626133,
		"y": 9.016238847,
		"h": 1.6923076923
	},
	{
		"stop_id": 8581196,
		"ID": 1487,
		"x": 123.3107541583,
		"y": 13.488161169,
		"h": 1.6923076923
	},
	{
		"stop_id": 8581197,
		"ID": 1487,
		"x": 123.6147431023,
		"y": 13.456217796,
		"h": 1.6923076923
	},
	{
		"stop_id": 8581452,
		"ID": 1487,
		"x": 123.7677705063,
		"y": 13.620185116,
		"h": 1.6923076923
	},
	{
		"stop_id": 8582845,
		"ID": 1487,
		"x": 126.5357357823,
		"y": 10.680225075,
		"h": 1.6923076923
	},
	{
		"stop_id": 8582847,
		"ID": 1487,
		"x": 126.6097205183,
		"y": 10.722237424,
		"h": 1.6923076923
	},
	{
		"stop_id": 8582849,
		"ID": 1487,
		"x": 123.7777092303,
		"y": 13.50014817,
		"h": 1.6923076923
	},
	{
		"stop_id": 8582850,
		"ID": 1487,
		"x": 126.6857119053,
		"y": 10.455224285,
		"h": 1.6923076923
	},
	{
		"stop_id": 8582851,
		"ID": 1487,
		"x": 126.5387366573,
		"y": 10.951146725,
		"h": 1.6923076923
	},
	{
		"stop_id": 8582855,
		"ID": 1487,
		"x": 126.3787558863,
		"y": 11.6351906,
		"h": 1.6923076923
	},
	{
		"stop_id": 8582856,
		"ID": 1487,
		"x": 126.5337123333,
		"y": 11.357176983,
		"h": 1.6923076923
	},
	{
		"stop_id": 8582862,
		"ID": 1487,
		"x": 125.5257366813,
		"y": 12.985183558,
		"h": 1.6923076923
	},
	{
		"stop_id": 8582866,
		"ID": 1487,
		"x": 126.5067087233,
		"y": 10.505145487,
		"h": 1.6923076923
	},
	{
		"stop_id": 8582868,
		"ID": 1487,
		"x": 125.2607564553,
		"y": 13.029249343,
		"h": 1.6923076923
	},
	{
		"stop_id": 8582870,
		"ID": 1487,
		"x": 126.5977260393,
		"y": 11.075219365,
		"h": 1.6923076923
	},
	{
		"stop_id": 8582891,
		"ID": 1487,
		"x": 124.0577409323,
		"y": 13.000247606,
		"h": 1.6923076923
	},
	{
		"stop_id": 8594551,
		"ID": 1487,
		"x": 126.4537336233,
		"y": 11.226222576,
		"h": 1.6923076923
	},
	{
		"stop_id": 8509070,
		"ID": 1500,
		"x": 125.8187335373,
		"y": 8.858236743,
		"h": 1.4945054945
	},
	{
		"stop_id": 8582842,
		"ID": 1500,
		"x": 127.8567512393,
		"y": 10.725202398,
		"h": 1.4945054945
	},
	{
		"stop_id": 8582843,
		"ID": 1500,
		"x": 129.0597140163,
		"y": 10.573211971,
		"h": 1.4945054945
	},
	{
		"stop_id": 8582844,
		"ID": 1500,
		"x": 127.1847436363,
		"y": 10.608167015,
		"h": 1.4945054945
	},
	{
		"stop_id": 8582846,
		"ID": 1500,
		"x": 128.5877224653,
		"y": 10.563218929,
		"h": 1.4945054945
	},
	{
		"stop_id": 8582848,
		"ID": 1500,
		"x": 127.3577163973,
		"y": 10.49023096,
		"h": 1.4945054945
	},
	{
		"stop_id": 8582854,
		"ID": 1500,
		"x": 129.3607225023,
		"y": 10.451146702,
		"h": 1.4945054945
	},
	{
		"stop_id": 8582857,
		"ID": 1500,
		"x": 126.7857272093,
		"y": 10.257141215,
		"h": 1.4945054945
	},
	{
		"stop_id": 8582861,
		"ID": 1500,
		"x": 127.6187268863,
		"y": 10.38718137,
		"h": 1.4945054945
	},
	{
		"stop_id": 8582865,
		"ID": 1500,
		"x": 126.8677511003,
		"y": 10.743187984,
		"h": 1.4945054945
	},
	{
		"stop_id": 8582886,
		"ID": 1500,
		"x": 127.9777322023,
		"y": 10.390212148,
		"h": 1.4945054945
	},
	{
		"stop_id": 8582887,
		"ID": 1500,
		"x": 128.1037292513,
		"y": 10.600156225,
		"h": 1.4945054945
	},
	{
		"stop_id": 8582888,
		"ID": 1500,
		"x": 129.6097746793,
		"y": 10.404195567,
		"h": 1.4945054945
	},
	{
		"stop_id": 8582890,
		"ID": 1500,
		"x": 126.7477697593,
		"y": 10.065209581,
		"h": 1.4945054945
	},
	{
		"stop_id": 8592591,
		"ID": 1500,
		"x": 125.7487551783,
		"y": 7.928250276,
		"h": 1.4945054945
	},
	{
		"stop_id": 8592592,
		"ID": 1500,
		"x": 125.3357231163,
		"y": 8.009215412,
		"h": 1.4945054945
	},
	{
		"stop_id": 8509071,
		"ID": 1486,
		"x": 124.5507236783,
		"y": 7.02524689,
		"h": 2.2857142857
	},
	{
		"stop_id": 8509072,
		"ID": 1486,
		"x": 123.6777486963,
		"y": 4.524203277,
		"h": 2.2857142857
	},
	{
		"stop_id": 8509073,
		"ID": 1486,
		"x": 122.1077261213,
		"y": 2.446203392,
		"h": 2.2857142857
	},
	{
		"stop_id": 8509083,
		"ID": 1486,
		"x": 123.3977394393,
		"y": 4.369150842,
		"h": 2.2857142857
	},
	{
		"stop_id": 8509084,
		"ID": 1486,
		"x": 122.2357031483,
		"y": 5.557231272,
		"h": 2.2857142857
	},
	{
		"stop_id": 8509088,
		"ID": 1486,
		"x": 122.1297310363,
		"y": 3.092165923,
		"h": 2.2857142857
	},
	{
		"stop_id": 8509089,
		"ID": 1486,
		"x": 121.6797313583,
		"y": 3.51215373,
		"h": 2.2857142857
	},
	{
		"stop_id": 8509090,
		"ID": 1486,
		"x": 122.3077527383,
		"y": 2.422142311,
		"h": 2.2857142857
	},
	{
		"stop_id": 8574848,
		"ID": 1486,
		"x": 123.6507023783,
		"y": 4.527155892,
		"h": 2.2857142857
	},
	{
		"stop_id": 8574849,
		"ID": 1486,
		"x": 124.5287548223,
		"y": 4.687147909,
		"h": 2.2857142857
	},
	{
		"stop_id": 8575116,
		"ID": 1486,
		"x": 122.0967331413,
		"y": 2.491246906,
		"h": 2.2857142857
	},
	{
		"stop_id": 8588890,
		"ID": 1486,
		"x": 123.4896993023,
		"y": 4.30122956,
		"h": 2.2857142857
	},
	{
		"stop_id": 8588891,
		"ID": 1486,
		"x": 123.6797413623,
		"y": 3.684217259,
		"h": 2.2857142857
	},
	{
		"stop_id": 8588892,
		"ID": 1486,
		"x": 123.8927361913,
		"y": 3.301143384,
		"h": 2.2857142857
	},
	{
		"stop_id": 8588893,
		"ID": 1486,
		"x": 124.2977496923,
		"y": 3.155204282,
		"h": 2.2857142857
	},
	{
		"stop_id": 8588894,
		"ID": 1486,
		"x": 124.6817251623,
		"y": 3.110188318,
		"h": 2.2857142857
	},
	{
		"stop_id": 8588895,
		"ID": 1486,
		"x": 125.3647069803,
		"y": 2.535235813,
		"h": 2.2857142857
	},
	{
		"stop_id": 8592593,
		"ID": 1486,
		"x": 124.6867342193,
		"y": 7.57520203,
		"h": 2.2857142857
	},
	{
		"stop_id": 8592594,
		"ID": 1486,
		"x": 124.7117445893,
		"y": 6.593221091,
		"h": 2.2857142857
	},
	{
		"stop_id": 8592595,
		"ID": 1486,
		"x": 124.5057442743,
		"y": 6.240196832,
		"h": 2.2857142857
	},
	{
		"stop_id": 8592596,
		"ID": 1486,
		"x": 124.2057131923,
		"y": 5.637156157,
		"h": 2.2857142857
	},
	{
		"stop_id": 8592597,
		"ID": 1486,
		"x": 123.7977034423,
		"y": 4.731191978,
		"h": 2.2857142857
	},
	{
		"stop_id": 8592598,
		"ID": 1486,
		"x": 123.4517404983,
		"y": 4.411176535,
		"h": 2.2857142857
	},
	{
		"stop_id": 8592599,
		"ID": 1486,
		"x": 123.3297550673,
		"y": 4.125167,
		"h": 2.2857142857
	},
	{
		"stop_id": 8592600,
		"ID": 1486,
		"x": 123.2547256653,
		"y": 3.774197538,
		"h": 2.2857142857
	},
	{
		"stop_id": 8592601,
		"ID": 1486,
		"x": 122.9877280953,
		"y": 3.574185954,
		"h": 2.2857142857
	},
	{
		"stop_id": 8592602,
		"ID": 1486,
		"x": 122.6787038933,
		"y": 3.562201773,
		"h": 2.2857142857
	},
	{
		"stop_id": 8592603,
		"ID": 1486,
		"x": 122.3877516023,
		"y": 3.320225434,
		"h": 2.2857142857
	},
	{
		"stop_id": 8592604,
		"ID": 1486,
		"x": 122.1877743933,
		"y": 3.077246832,
		"h": 2.2857142857
	},
	{
		"stop_id": 8592605,
		"ID": 1486,
		"x": 122.1147464643,
		"y": 2.660179959,
		"h": 2.2857142857
	},
	{
		"stop_id": 8592606,
		"ID": 1486,
		"x": 121.8757508203,
		"y": 2.365200749,
		"h": 2.2857142857
	},
	{
		"stop_id": 8592608,
		"ID": 1486,
		"x": 122.2977080733,
		"y": 2.702220746,
		"h": 2.2857142857
	},
	{
		"stop_id": 8592609,
		"ID": 1486,
		"x": 122.4137507453,
		"y": 2.940201138,
		"h": 2.2857142857
	},
	{
		"stop_id": 8592610,
		"ID": 1486,
		"x": 122.5967637043,
		"y": 3.13317789,
		"h": 2.2857142857
	},
	{
		"stop_id": 8592611,
		"ID": 1486,
		"x": 122.9767247023,
		"y": 3.394230018,
		"h": 2.2857142857
	},
	{
		"stop_id": 8592612,
		"ID": 1486,
		"x": 123.3417464533,
		"y": 3.683211473,
		"h": 2.2857142857
	},
	{
		"stop_id": 8592613,
		"ID": 1486,
		"x": 123.3967597403,
		"y": 4.104194386,
		"h": 2.2857142857
	},
	{
		"stop_id": 8592614,
		"ID": 1486,
		"x": 124.0327629723,
		"y": 4.76521004,
		"h": 2.2857142857
	},
	{
		"stop_id": 8593313,
		"ID": 1486,
		"x": 124.4877553403,
		"y": 7.129189952,
		"h": 2.2857142857
	},
	{
		"stop_id": 8595440,
		"ID": 1486,
		"x": 124.3427297813,
		"y": 4.722240765,
		"h": 2.2857142857
	},
	{
		"stop_id": 8509075,
		"ID": 1485,
		"x": 120.5517392883,
		"y": -0.365852187,
		"h": 1.3956043956
	},
	{
		"stop_id": 8509091,
		"ID": 1485,
		"x": 123.0167118993,
		"y": 1.949149449,
		"h": 1.3956043956
	},
	{
		"stop_id": 8509093,
		"ID": 1485,
		"x": 124.2757644333,
		"y": 0.398155611,
		"h": 1.3956043956
	},
	{
		"stop_id": 8509685,
		"ID": 1485,
		"x": 123.3027505683,
		"y": -2.27479172,
		"h": 1.3956043956
	},
	{
		"stop_id": 8509686,
		"ID": 1485,
		"x": 123.8377281803,
		"y": -3.459815248,
		"h": 1.3956043956
	},
	{
		"stop_id": 8581178,
		"ID": 1485,
		"x": 120.5427427103,
		"y": -0.320857307,
		"h": 1.3956043956
	},
	{
		"stop_id": 8582958,
		"ID": 1485,
		"x": 121.6687596203,
		"y": -0.086775335,
		"h": 1.3956043956
	},
	{
		"stop_id": 8587327,
		"ID": 1485,
		"x": 122.6177081133,
		"y": -1.089846688,
		"h": 1.3956043956
	},
	{
		"stop_id": 8587443,
		"ID": 1485,
		"x": 121.6577438203,
		"y": -0.179754047,
		"h": 1.3956043956
	},
	{
		"stop_id": 8589527,
		"ID": 1485,
		"x": 121.5727369393,
		"y": 1.320235306,
		"h": 1.3956043956
	},
	{
		"stop_id": 8589528,
		"ID": 1485,
		"x": 121.6977148423,
		"y": 0.970234173,
		"h": 1.3956043956
	},
	{
		"stop_id": 8589529,
		"ID": 1485,
		"x": 122.2077404573,
		"y": -0.609836733,
		"h": 1.3956043956
	},
	{
		"stop_id": 8594478,
		"ID": 1485,
		"x": 123.0657526633,
		"y": -1.933800812,
		"h": 1.3956043956
	},
	{
		"stop_id": 8509076,
		"ID": 1470,
		"x": 119.1467717843,
		"y": -2.747761908,
		"h": 1.4285714286
	},
	{
		"stop_id": 8509077,
		"ID": 1470,
		"x": 117.7227716433,
		"y": -6.088767275,
		"h": 1.4285714286
	},
	{
		"stop_id": 8509096,
		"ID": 1470,
		"x": 120.8867463073,
		"y": -2.846817375,
		"h": 1.4285714286
	},
	{
		"stop_id": 8509671,
		"ID": 1470,
		"x": 119.4127622153,
		"y": -2.162820999,
		"h": 1.4285714286
	},
	{
		"stop_id": 8509980,
		"ID": 1470,
		"x": 118.4907288093,
		"y": -6.39385019,
		"h": 1.4285714286
	},
	{
		"stop_id": 8530684,
		"ID": 1470,
		"x": 119.1927574193,
		"y": -2.761847946,
		"h": 1.4285714286
	},
	{
		"stop_id": 8574834,
		"ID": 1470,
		"x": 119.8377530013,
		"y": -1.332761426,
		"h": 1.4285714286
	},
	{
		"stop_id": 8574835,
		"ID": 1470,
		"x": 119.1737760493,
		"y": -2.704804447,
		"h": 1.4285714286
	},
	{
		"stop_id": 8574836,
		"ID": 1470,
		"x": 118.9997680113,
		"y": -3.301781811,
		"h": 1.4285714286
	},
	{
		"stop_id": 8574837,
		"ID": 1470,
		"x": 118.9257095453,
		"y": -3.861852677,
		"h": 1.4285714286
	},
	{
		"stop_id": 8574838,
		"ID": 1470,
		"x": 118.7827711133,
		"y": -4.294851707,
		"h": 1.4285714286
	},
	{
		"stop_id": 8574839,
		"ID": 1470,
		"x": 117.5867528743,
		"y": -6.359820463,
		"h": 1.4285714286
	},
	{
		"stop_id": 8580574,
		"ID": 1470,
		"x": 117.7357193913,
		"y": -6.037780895,
		"h": 1.4285714286
	},
	{
		"stop_id": 8592607,
		"ID": 1470,
		"x": 118.5827703783,
		"y": -4.838758788,
		"h": 1.4285714286
	},
	{
		"stop_id": 8509078,
		"ID": 1455,
		"x": 114.4127512633,
		"y": -8.456816336,
		"h": 1.0989010989
	},
	{
		"stop_id": 8509967,
		"ID": 1455,
		"x": 114.2207347143,
		"y": -7.582801731,
		"h": 1.0989010989
	},
	{
		"stop_id": 8574840,
		"ID": 1455,
		"x": 115.0417406593,
		"y": -7.68982698,
		"h": 1.0989010989
	},
	{
		"stop_id": 8574841,
		"ID": 1455,
		"x": 114.2697170913,
		"y": -7.717839559,
		"h": 1.0989010989
	},
	{
		"stop_id": 8509085,
		"ID": 1472,
		"x": 120.8287116483,
		"y": 7.016174544,
		"h": 1.032967033
	},
	{
		"stop_id": 8509087,
		"ID": 1472,
		"x": 120.0877495823,
		"y": 7.14722504,
		"h": 1.032967033
	},
	{
		"stop_id": 8509152,
		"ID": 1440,
		"x": 106.1557267223,
		"y": 6.45815931,
		"h": 1.3296703297
	},
	{
		"stop_id": 8509153,
		"ID": 1440,
		"x": 109.2537270003,
		"y": 6.260163186,
		"h": 1.3296703297
	},
	{
		"stop_id": 8509154,
		"ID": 1440,
		"x": 110.6087241203,
		"y": 6.338182699,
		"h": 1.3296703297
	},
	{
		"stop_id": 8509871,
		"ID": 1440,
		"x": 108.8817097023,
		"y": 6.701190115,
		"h": 1.3296703297
	},
	{
		"stop_id": 8574716,
		"ID": 1440,
		"x": 106.9947398773,
		"y": 6.949240247,
		"h": 1.3296703297
	},
	{
		"stop_id": 8574717,
		"ID": 1440,
		"x": 107.9077100393,
		"y": 6.855203135,
		"h": 1.3296703297
	},
	{
		"stop_id": 8574718,
		"ID": 1440,
		"x": 108.4067636263,
		"y": 6.896234206,
		"h": 1.3296703297
	},
	{
		"stop_id": 8574719,
		"ID": 1440,
		"x": 108.6507140533,
		"y": 6.754182401,
		"h": 1.3296703297
	},
	{
		"stop_id": 8574721,
		"ID": 1440,
		"x": 109.5577479853,
		"y": 6.705158427,
		"h": 1.3296703297
	},
	{
		"stop_id": 8574722,
		"ID": 1440,
		"x": 110.7157264263,
		"y": 6.700228051,
		"h": 1.3296703297
	},
	{
		"stop_id": 8581029,
		"ID": 1440,
		"x": 108.1007498093,
		"y": 6.816242318,
		"h": 1.3296703297
	},
	{
		"stop_id": 8509155,
		"ID": 1457,
		"x": 113.3497434803,
		"y": 5.285245273,
		"h": 1.032967033
	},
	{
		"stop_id": 8509156,
		"ID": 1457,
		"x": 113.1227513113,
		"y": 2.901250198,
		"h": 1.032967033
	},
	{
		"stop_id": 8509157,
		"ID": 1439,
		"x": 111.3427670633,
		"y": 1.220172305,
		"h": 1.3626373626
	},
	{
		"stop_id": 8594658,
		"ID": 1439,
		"x": 109.8027560123,
		"y": -0.005816681,
		"h": 1.3626373626
	},
	{
		"stop_id": 8594659,
		"ID": 1439,
		"x": 110.0297281933,
		"y": 0.211249051,
		"h": 1.3626373626
	},
	{
		"stop_id": 8594660,
		"ID": 1439,
		"x": 110.2587646043,
		"y": 0.231202778,
		"h": 1.3626373626
	},
	{
		"stop_id": 8594661,
		"ID": 1439,
		"x": 110.2917309503,
		"y": 0.359143312,
		"h": 1.3626373626
	},
	{
		"stop_id": 8594662,
		"ID": 1439,
		"x": 110.6587755003,
		"y": 0.429185729,
		"h": 1.3626373626
	},
	{
		"stop_id": 8594670,
		"ID": 1439,
		"x": 111.3567426503,
		"y": 1.295195674,
		"h": 1.3626373626
	},
	{
		"stop_id": 8594671,
		"ID": 1439,
		"x": 111.4097585323,
		"y": 1.565179563,
		"h": 1.3626373626
	},
	{
		"stop_id": 8594677,
		"ID": 1439,
		"x": 111.5157700563,
		"y": 1.830229405,
		"h": 1.3626373626
	},
	{
		"stop_id": 8594678,
		"ID": 1439,
		"x": 111.5357197173,
		"y": 2.158212281,
		"h": 1.3626373626
	},
	{
		"stop_id": 8594679,
		"ID": 1439,
		"x": 111.4827554523,
		"y": 2.290153365,
		"h": 1.3626373626
	},
	{
		"stop_id": 8594680,
		"ID": 1439,
		"x": 111.0077309343,
		"y": 2.060165681,
		"h": 1.3626373626
	},
	{
		"stop_id": 8509167,
		"ID": 1345,
		"x": 86.8387310863,
		"y": 4.271239787,
		"h": 1.2967032967
	},
	{
		"stop_id": 8509184,
		"ID": 1345,
		"x": 89.7737042753,
		"y": 3.645152108,
		"h": 1.2967032967
	},
	{
		"stop_id": 8509185,
		"ID": 1345,
		"x": 89.9177256323,
		"y": 2.468221418,
		"h": 1.2967032967
	},
	{
		"stop_id": 8509679,
		"ID": 1345,
		"x": 90.1217454093,
		"y": 2.045193942,
		"h": 1.2967032967
	},
	{
		"stop_id": 8573016,
		"ID": 1345,
		"x": 89.9687387423,
		"y": 3.91224376,
		"h": 1.2967032967
	},
	{
		"stop_id": 8573017,
		"ID": 1345,
		"x": 89.9277366453,
		"y": 3.500212067,
		"h": 1.2967032967
	},
	{
		"stop_id": 8573021,
		"ID": 1345,
		"x": 89.8377025123,
		"y": 2.370142346,
		"h": 1.2967032967
	},
	{
		"stop_id": 8573042,
		"ID": 1345,
		"x": 90.0537657203,
		"y": 2.079188874,
		"h": 1.2967032967
	},
	{
		"stop_id": 8581768,
		"ID": 1345,
		"x": 90.4347196833,
		"y": 0.930220271,
		"h": 1.2967032967
	},
	{
		"stop_id": 8587676,
		"ID": 1345,
		"x": 89.8777447183,
		"y": 2.43019158,
		"h": 1.2967032967
	},
	{
		"stop_id": 8509168,
		"ID": 1323,
		"x": 83.1077650633,
		"y": 3.158211948,
		"h": 2.0879120879
	},
	{
		"stop_id": 8509723,
		"ID": 1323,
		"x": 84.3827656163,
		"y": 6.185185545,
		"h": 2.0879120879
	},
	{
		"stop_id": 8509724,
		"ID": 1323,
		"x": 82.8507537463,
		"y": 6.756187802,
		"h": 2.0879120879
	},
	{
		"stop_id": 8509731,
		"ID": 1323,
		"x": 86.1597421033,
		"y": 5.393240914,
		"h": 2.0879120879
	},
	{
		"stop_id": 8509732,
		"ID": 1323,
		"x": 83.7907607223,
		"y": 7.389158212,
		"h": 2.0879120879
	},
	{
		"stop_id": 8509773,
		"ID": 1323,
		"x": 81.2967217813,
		"y": 6.384195063,
		"h": 2.0879120879
	},
	{
		"stop_id": 8509774,
		"ID": 1323,
		"x": 81.4507090003,
		"y": 5.236244709,
		"h": 2.0879120879
	},
	{
		"stop_id": 8509896,
		"ID": 1323,
		"x": 85.4627365693,
		"y": 6.186166103,
		"h": 2.0879120879
	},
	{
		"stop_id": 8574597,
		"ID": 1323,
		"x": 83.0887157753,
		"y": 3.150195817,
		"h": 2.0879120879
	},
	{
		"stop_id": 8574679,
		"ID": 1323,
		"x": 81.9677163993,
		"y": 6.271169463,
		"h": 2.0879120879
	},
	{
		"stop_id": 8574680,
		"ID": 1323,
		"x": 80.9007192363,
		"y": 6.116223525,
		"h": 2.0879120879
	},
	{
		"stop_id": 8574681,
		"ID": 1323,
		"x": 81.1687503423,
		"y": 5.61623888,
		"h": 2.0879120879
	},
	{
		"stop_id": 8574682,
		"ID": 1323,
		"x": 80.8387488773,
		"y": 5.054148985,
		"h": 2.0879120879
	},
	{
		"stop_id": 8574875,
		"ID": 1323,
		"x": 81.7207454133,
		"y": 6.340162535,
		"h": 2.0879120879
	},
	{
		"stop_id": 8574876,
		"ID": 1323,
		"x": 81.3587595433,
		"y": 5.397205473,
		"h": 2.0879120879
	},
	{
		"stop_id": 8574877,
		"ID": 1323,
		"x": 82.1337098703,
		"y": 6.547209466,
		"h": 2.0879120879
	},
	{
		"stop_id": 8574878,
		"ID": 1323,
		"x": 82.4897746983,
		"y": 6.524194013,
		"h": 2.0879120879
	},
	{
		"stop_id": 8579809,
		"ID": 1323,
		"x": 83.6017108153,
		"y": 6.382151444,
		"h": 2.0879120879
	},
	{
		"stop_id": 8582709,
		"ID": 1323,
		"x": 83.1277546073,
		"y": 6.960177083,
		"h": 2.0879120879
	},
	{
		"stop_id": 8582905,
		"ID": 1323,
		"x": 80.5677306583,
		"y": 4.858194271,
		"h": 2.0879120879
	},
	{
		"stop_id": 8582910,
		"ID": 1323,
		"x": 81.5877221733,
		"y": 5.368248024,
		"h": 2.0879120879
	},
	{
		"stop_id": 8582911,
		"ID": 1323,
		"x": 81.4367692963,
		"y": 5.429180464,
		"h": 2.0879120879
	},
	{
		"stop_id": 8582912,
		"ID": 1323,
		"x": 80.9157146393,
		"y": 5.793208415,
		"h": 2.0879120879
	},
	{
		"stop_id": 8582913,
		"ID": 1323,
		"x": 82.3707107253,
		"y": 6.268162256,
		"h": 2.0879120879
	},
	{
		"stop_id": 8582914,
		"ID": 1323,
		"x": 82.0677025943,
		"y": 6.312235998,
		"h": 2.0879120879
	},
	{
		"stop_id": 8582915,
		"ID": 1323,
		"x": 82.1627132113,
		"y": 6.373202212,
		"h": 2.0879120879
	},
	{
		"stop_id": 8582916,
		"ID": 1323,
		"x": 82.0547328253,
		"y": 6.357186954,
		"h": 2.0879120879
	},
	{
		"stop_id": 8582917,
		"ID": 1323,
		"x": 81.2937523333,
		"y": 6.497215011,
		"h": 2.0879120879
	},
	{
		"stop_id": 8582918,
		"ID": 1323,
		"x": 81.9987062833,
		"y": 5.781178831,
		"h": 2.0879120879
	},
	{
		"stop_id": 8582919,
		"ID": 1323,
		"x": 81.7857012473,
		"y": 5.836184791,
		"h": 2.0879120879
	},
	{
		"stop_id": 8582920,
		"ID": 1323,
		"x": 81.5827648023,
		"y": 5.872198515,
		"h": 2.0879120879
	},
	{
		"stop_id": 8582921,
		"ID": 1323,
		"x": 81.3767679933,
		"y": 5.792165811,
		"h": 2.0879120879
	},
	{
		"stop_id": 8582922,
		"ID": 1323,
		"x": 81.5967379773,
		"y": 5.513242752,
		"h": 2.0879120879
	},
	{
		"stop_id": 8583230,
		"ID": 1323,
		"x": 83.8917103813,
		"y": 2.682241053,
		"h": 2.0879120879
	},
	{
		"stop_id": 8509169,
		"ID": 1297,
		"x": 80.4897474753,
		"y": 1.363170332,
		"h": 2.3846153846
	},
	{
		"stop_id": 8509170,
		"ID": 1297,
		"x": 77.2887193123,
		"y": -0.189856228,
		"h": 2.3846153846
	},
	{
		"stop_id": 8509725,
		"ID": 1297,
		"x": 79.0277329693,
		"y": 2.102158498,
		"h": 2.3846153846
	},
	{
		"stop_id": 8509727,
		"ID": 1297,
		"x": 79.7387321203,
		"y": 4.013166338,
		"h": 2.3846153846
	},
	{
		"stop_id": 8509728,
		"ID": 1297,
		"x": 79.0667721603,
		"y": 1.327235739,
		"h": 2.3846153846
	},
	{
		"stop_id": 8509729,
		"ID": 1297,
		"x": 76.7607672463,
		"y": 0.910167172,
		"h": 2.3846153846
	},
	{
		"stop_id": 8509786,
		"ID": 1297,
		"x": 79.1277161133,
		"y": 2.970153366,
		"h": 2.3846153846
	},
	{
		"stop_id": 8509983,
		"ID": 1297,
		"x": 79.6577402363,
		"y": 4.18019002,
		"h": 2.3846153846
	},
	{
		"stop_id": 8509987,
		"ID": 1297,
		"x": 77.1677627503,
		"y": 2.250153327,
		"h": 2.3846153846
	},
	{
		"stop_id": 8574683,
		"ID": 1297,
		"x": 79.5197561713,
		"y": 3.670246768,
		"h": 2.3846153846
	},
	{
		"stop_id": 8574874,
		"ID": 1297,
		"x": 78.9797710013,
		"y": 2.534163058,
		"h": 2.3846153846
	},
	{
		"stop_id": 8574879,
		"ID": 1297,
		"x": 77.4207707583,
		"y": 2.322217754,
		"h": 2.3846153846
	},
	{
		"stop_id": 8575011,
		"ID": 1297,
		"x": 77.2507243103,
		"y": 0.980178424,
		"h": 2.3846153846
	},
	{
		"stop_id": 8575012,
		"ID": 1297,
		"x": 78.6737713983,
		"y": 1.092185025,
		"h": 2.3846153846
	},
	{
		"stop_id": 8575015,
		"ID": 1297,
		"x": 78.4857660903,
		"y": 2.986209421,
		"h": 2.3846153846
	},
	{
		"stop_id": 8579811,
		"ID": 1297,
		"x": 78.9047132063,
		"y": 1.538204232,
		"h": 2.3846153846
	},
	{
		"stop_id": 8580715,
		"ID": 1297,
		"x": 78.8757244113,
		"y": 3.067171342,
		"h": 2.3846153846
	},
	{
		"stop_id": 8580859,
		"ID": 1297,
		"x": 80.1847347013,
		"y": 4.916168847,
		"h": 2.3846153846
	},
	{
		"stop_id": 8581051,
		"ID": 1297,
		"x": 79.1367429013,
		"y": 1.557147367,
		"h": 2.3846153846
	},
	{
		"stop_id": 8581169,
		"ID": 1297,
		"x": 81.0537132883,
		"y": 0.933166232,
		"h": 2.3846153846
	},
	{
		"stop_id": 8581172,
		"ID": 1297,
		"x": 77.1677307433,
		"y": -0.447819625,
		"h": 2.3846153846
	},
	{
		"stop_id": 8581599,
		"ID": 1297,
		"x": 80.7107171703,
		"y": 0.841157037,
		"h": 2.3846153846
	},
	{
		"stop_id": 8581911,
		"ID": 1297,
		"x": 78.4267167983,
		"y": 1.121173329,
		"h": 2.3846153846
	},
	{
		"stop_id": 8582892,
		"ID": 1297,
		"x": 77.0607705993,
		"y": 2.070237125,
		"h": 2.3846153846
	},
	{
		"stop_id": 8582893,
		"ID": 1297,
		"x": 76.9077635153,
		"y": 2.300145732,
		"h": 2.3846153846
	},
	{
		"stop_id": 8582894,
		"ID": 1297,
		"x": 77.0377255823,
		"y": 2.330245445,
		"h": 2.3846153846
	},
	{
		"stop_id": 8582895,
		"ID": 1297,
		"x": 77.4127076763,
		"y": 2.524189719,
		"h": 2.3846153846
	},
	{
		"stop_id": 8582896,
		"ID": 1297,
		"x": 77.1007561813,
		"y": 2.382169246,
		"h": 2.3846153846
	},
	{
		"stop_id": 8582897,
		"ID": 1297,
		"x": 76.8977453193,
		"y": 2.488173734,
		"h": 2.3846153846
	},
	{
		"stop_id": 8582898,
		"ID": 1297,
		"x": 76.5197301503,
		"y": 2.507246405,
		"h": 2.3846153846
	},
	{
		"stop_id": 8582899,
		"ID": 1297,
		"x": 77.3197553863,
		"y": 2.335249624,
		"h": 2.3846153846
	},
	{
		"stop_id": 8582900,
		"ID": 1297,
		"x": 76.7607455753,
		"y": 2.050157148,
		"h": 2.3846153846
	},
	{
		"stop_id": 8582902,
		"ID": 1297,
		"x": 80.3177246593,
		"y": 2.928154992,
		"h": 2.3846153846
	},
	{
		"stop_id": 8582903,
		"ID": 1297,
		"x": 79.2277722293,
		"y": 3.659235256,
		"h": 2.3846153846
	},
	{
		"stop_id": 8582904,
		"ID": 1297,
		"x": 79.4487655743,
		"y": 3.778237139,
		"h": 2.3846153846
	},
	{
		"stop_id": 8583104,
		"ID": 1297,
		"x": 79.4267440663,
		"y": 4.922179345,
		"h": 2.3846153846
	},
	{
		"stop_id": 8583105,
		"ID": 1297,
		"x": 79.9247092923,
		"y": 2.939211107,
		"h": 2.3846153846
	},
	{
		"stop_id": 8583106,
		"ID": 1297,
		"x": 79.4807444193,
		"y": 4.776208496,
		"h": 2.3846153846
	},
	{
		"stop_id": 8583107,
		"ID": 1297,
		"x": 79.5647594043,
		"y": 4.977208975,
		"h": 2.3846153846
	},
	{
		"stop_id": 8583612,
		"ID": 1297,
		"x": 77.9917087143,
		"y": 2.541151499,
		"h": 2.3846153846
	},
	{
		"stop_id": 8583749,
		"ID": 1297,
		"x": 77.1917161423,
		"y": 2.08423896,
		"h": 2.3846153846
	},
	{
		"stop_id": 8583883,
		"ID": 1297,
		"x": 76.5377744783,
		"y": 2.412250146,
		"h": 2.3846153846
	},
	{
		"stop_id": 8583884,
		"ID": 1297,
		"x": 76.7967451353,
		"y": 2.390240043,
		"h": 2.3846153846
	},
	{
		"stop_id": 8509171,
		"ID": 1268,
		"x": 75.3387096293,
		"y": -0.582749957,
		"h": 2.1538461538
	},
	{
		"stop_id": 8509173,
		"ID": 1268,
		"x": 70.6197311643,
		"y": -0.760804667,
		"h": 2.1538461538
	},
	{
		"stop_id": 8509787,
		"ID": 1268,
		"x": 74.9377313443,
		"y": 1.040244157,
		"h": 2.1538461538
	},
	{
		"stop_id": 8509864,
		"ID": 1268,
		"x": 74.1637676883,
		"y": 0.425211089,
		"h": 2.1538461538
	},
	{
		"stop_id": 8509879,
		"ID": 1268,
		"x": 71.9227398393,
		"y": 1.076163882,
		"h": 2.1538461538
	},
	{
		"stop_id": 8574990,
		"ID": 1268,
		"x": 75.1237469943,
		"y": -0.708797178,
		"h": 2.1538461538
	},
	{
		"stop_id": 8574991,
		"ID": 1268,
		"x": 74.9477756863,
		"y": -0.958832782,
		"h": 2.1538461538
	},
	{
		"stop_id": 8574992,
		"ID": 1268,
		"x": 74.8937705553,
		"y": -1.618770282,
		"h": 2.1538461538
	},
	{
		"stop_id": 8574993,
		"ID": 1268,
		"x": 74.5417698473,
		"y": -1.79980168,
		"h": 2.1538461538
	},
	{
		"stop_id": 8574994,
		"ID": 1268,
		"x": 72.0947354233,
		"y": -1.561816432,
		"h": 2.1538461538
	},
	{
		"stop_id": 8575006,
		"ID": 1268,
		"x": 75.1487379313,
		"y": -2.24985317,
		"h": 2.1538461538
	},
	{
		"stop_id": 8575007,
		"ID": 1268,
		"x": 75.2727189713,
		"y": -2.644807882,
		"h": 2.1538461538
	},
	{
		"stop_id": 8575008,
		"ID": 1268,
		"x": 74.7677224083,
		"y": -2.116755569,
		"h": 2.1538461538
	},
	{
		"stop_id": 8575009,
		"ID": 1268,
		"x": 75.2327504653,
		"y": -0.426795396,
		"h": 2.1538461538
	},
	{
		"stop_id": 8575010,
		"ID": 1268,
		"x": 76.3417188033,
		"y": 0.223220578,
		"h": 2.1538461538
	},
	{
		"stop_id": 8575018,
		"ID": 1268,
		"x": 74.7207111953,
		"y": -0.597766251,
		"h": 2.1538461538
	},
	{
		"stop_id": 8575019,
		"ID": 1268,
		"x": 74.4147525883,
		"y": -0.423822286,
		"h": 2.1538461538
	},
	{
		"stop_id": 8575020,
		"ID": 1268,
		"x": 73.9987051933,
		"y": -0.087752777,
		"h": 2.1538461538
	},
	{
		"stop_id": 8575021,
		"ID": 1268,
		"x": 74.0237613473,
		"y": 0.189238887,
		"h": 2.1538461538
	},
	{
		"stop_id": 8575022,
		"ID": 1268,
		"x": 74.8527544623,
		"y": 0.818165546,
		"h": 2.1538461538
	},
	{
		"stop_id": 8575045,
		"ID": 1268,
		"x": 75.6487428023,
		"y": -0.681831597,
		"h": 2.1538461538
	},
	{
		"stop_id": 8575047,
		"ID": 1268,
		"x": 75.9297558573,
		"y": -1.168851109,
		"h": 2.1538461538
	},
	{
		"stop_id": 8575049,
		"ID": 1268,
		"x": 76.1827102333,
		"y": -1.942825031,
		"h": 2.1538461538
	},
	{
		"stop_id": 8575055,
		"ID": 1268,
		"x": 70.6317210803,
		"y": -0.6447907,
		"h": 2.1538461538
	},
	{
		"stop_id": 8575092,
		"ID": 1268,
		"x": 73.5877710773,
		"y": -0.579835552,
		"h": 2.1538461538
	},
	{
		"stop_id": 8575093,
		"ID": 1268,
		"x": 70.9717349803,
		"y": -0.248756991,
		"h": 2.1538461538
	},
	{
		"stop_id": 8575094,
		"ID": 1268,
		"x": 71.3187695723,
		"y": -0.133759953,
		"h": 2.1538461538
	},
	{
		"stop_id": 8575095,
		"ID": 1268,
		"x": 72.2327750253,
		"y": 0.10024792,
		"h": 2.1538461538
	},
	{
		"stop_id": 8575096,
		"ID": 1268,
		"x": 71.7257379553,
		"y": 0.281241468,
		"h": 2.1538461538
	},
	{
		"stop_id": 8575097,
		"ID": 1268,
		"x": 71.6647090933,
		"y": 0.838210569,
		"h": 2.1538461538
	},
	{
		"stop_id": 8575120,
		"ID": 1268,
		"x": 75.3577304733,
		"y": -0.609786411,
		"h": 2.1538461538
	},
	{
		"stop_id": 8580605,
		"ID": 1268,
		"x": 71.1147021953,
		"y": -0.306792259,
		"h": 2.1538461538
	},
	{
		"stop_id": 8581568,
		"ID": 1268,
		"x": 74.9087329433,
		"y": -2.2097725,
		"h": 2.1538461538
	},
	{
		"stop_id": 8581598,
		"ID": 1268,
		"x": 76.6707289703,
		"y": -0.76383732,
		"h": 2.1538461538
	},
	{
		"stop_id": 8582579,
		"ID": 1268,
		"x": 75.6067050333,
		"y": -0.342855023,
		"h": 2.1538461538
	},
	{
		"stop_id": 8583522,
		"ID": 1268,
		"x": 72.6247508213,
		"y": -0.513793986,
		"h": 2.1538461538
	},
	{
		"stop_id": 8509174,
		"ID": 1237,
		"x": 68.6877403073,
		"y": -1.373847496,
		"h": 1.6923076923
	},
	{
		"stop_id": 8509306,
		"ID": 1237,
		"x": 70.5147010193,
		"y": -2.581776821,
		"h": 1.6923076923
	},
	{
		"stop_id": 8509694,
		"ID": 1237,
		"x": 69.9957406673,
		"y": -2.051856064,
		"h": 1.6923076923
	},
	{
		"stop_id": 8509750,
		"ID": 1237,
		"x": 68.6637733833,
		"y": -2.836772995,
		"h": 1.6923076923
	},
	{
		"stop_id": 8509799,
		"ID": 1237,
		"x": 67.2017418843,
		"y": -3.71076089,
		"h": 1.6923076923
	},
	{
		"stop_id": 8530558,
		"ID": 1237,
		"x": 67.9017177963,
		"y": -6.343830863,
		"h": 1.6923076923
	},
	{
		"stop_id": 8530559,
		"ID": 1237,
		"x": 69.1967492803,
		"y": -6.174795985,
		"h": 1.6923076923
	},
	{
		"stop_id": 8530562,
		"ID": 1237,
		"x": 70.0817462483,
		"y": -2.240801495,
		"h": 1.6923076923
	},
	{
		"stop_id": 8530563,
		"ID": 1237,
		"x": 70.5077302873,
		"y": -3.526852554,
		"h": 1.6923076923
	},
	{
		"stop_id": 8530572,
		"ID": 1237,
		"x": 70.5677322603,
		"y": -5.11984179,
		"h": 1.6923076923
	},
	{
		"stop_id": 8574995,
		"ID": 1237,
		"x": 70.7367080893,
		"y": -1.715749816,
		"h": 1.6923076923
	},
	{
		"stop_id": 8574996,
		"ID": 1237,
		"x": 68.9877209813,
		"y": -2.669815797,
		"h": 1.6923076923
	},
	{
		"stop_id": 8574997,
		"ID": 1237,
		"x": 68.0267416423,
		"y": -3.241787734,
		"h": 1.6923076923
	},
	{
		"stop_id": 8574998,
		"ID": 1237,
		"x": 66.8007574243,
		"y": -4.04581193,
		"h": 1.6923076923
	},
	{
		"stop_id": 8574999,
		"ID": 1237,
		"x": 66.4187039183,
		"y": -3.996824372,
		"h": 1.6923076923
	},
	{
		"stop_id": 8575000,
		"ID": 1237,
		"x": 65.9547374203,
		"y": -4.017802773,
		"h": 1.6923076923
	},
	{
		"stop_id": 8575056,
		"ID": 1237,
		"x": 68.9437521053,
		"y": -0.921801414,
		"h": 1.6923076923
	},
	{
		"stop_id": 8575058,
		"ID": 1237,
		"x": 67.9167404873,
		"y": -0.862826458,
		"h": 1.6923076923
	},
	{
		"stop_id": 8580769,
		"ID": 1237,
		"x": 68.1907658213,
		"y": -0.744786847,
		"h": 1.6923076923
	},
	{
		"stop_id": 8581517,
		"ID": 1237,
		"x": 70.3007453443,
		"y": -2.071819336,
		"h": 1.6923076923
	},
	{
		"stop_id": 8581985,
		"ID": 1237,
		"x": 67.3667466723,
		"y": -3.724832107,
		"h": 1.6923076923
	},
	{
		"stop_id": 8583534,
		"ID": 1237,
		"x": 68.8037453233,
		"y": -2.742816131,
		"h": 1.6923076923
	},
	{
		"stop_id": 8509175,
		"ID": 1205,
		"x": 64.3137547343,
		"y": -3.110757859,
		"h": 1.6263736264
	},
	{
		"stop_id": 8509624,
		"ID": 1205,
		"x": 63.2666991543,
		"y": -2.800769709,
		"h": 1.6263736264
	},
	{
		"stop_id": 8509632,
		"ID": 1205,
		"x": 63.8317489653,
		"y": -3.120827476,
		"h": 1.6263736264
	},
	{
		"stop_id": 8509757,
		"ID": 1205,
		"x": 64.2967327523,
		"y": -1.686859803,
		"h": 1.6263736264
	},
	{
		"stop_id": 8575061,
		"ID": 1205,
		"x": 64.3097397543,
		"y": -3.119847465,
		"h": 1.6263736264
	},
	{
		"stop_id": 8575062,
		"ID": 1205,
		"x": 62.7657724203,
		"y": -3.113803585,
		"h": 1.6263736264
	},
	{
		"stop_id": 8581166,
		"ID": 1205,
		"x": 64.1997273133,
		"y": -1.462815072,
		"h": 1.6263736264
	},
	{
		"stop_id": 8581167,
		"ID": 1205,
		"x": 63.8537657373,
		"y": -1.546795283,
		"h": 1.6263736264
	},
	{
		"stop_id": 8581168,
		"ID": 1205,
		"x": 64.0447606443,
		"y": -1.579767704,
		"h": 1.6263736264
	},
	{
		"stop_id": 8583535,
		"ID": 1205,
		"x": 64.6227681063,
		"y": -1.253792417,
		"h": 1.6263736264
	},
	{
		"stop_id": 8583536,
		"ID": 1205,
		"x": 64.1927576843,
		"y": -1.199769016,
		"h": 1.6263736264
	},
	{
		"stop_id": 8583537,
		"ID": 1205,
		"x": 64.0807677933,
		"y": -1.166837013,
		"h": 1.6263736264
	},
	{
		"stop_id": 8583538,
		"ID": 1205,
		"x": 64.0117670933,
		"y": -1.328823165,
		"h": 1.6263736264
	},
	{
		"stop_id": 8583539,
		"ID": 1205,
		"x": 64.0157469753,
		"y": -1.443824059,
		"h": 1.6263736264
	},
	{
		"stop_id": 8583540,
		"ID": 1205,
		"x": 63.6257691183,
		"y": -1.44575146,
		"h": 1.6263736264
	},
	{
		"stop_id": 8583541,
		"ID": 1205,
		"x": 63.5757500143,
		"y": -1.305790726,
		"h": 1.6263736264
	},
	{
		"stop_id": 8583542,
		"ID": 1205,
		"x": 63.5807074183,
		"y": -1.145795647,
		"h": 1.6263736264
	},
	{
		"stop_id": 8583650,
		"ID": 1205,
		"x": 64.1757385343,
		"y": -1.632767049,
		"h": 1.6263736264
	},
	{
		"stop_id": 8583651,
		"ID": 1205,
		"x": 64.6357512883,
		"y": -1.941798981,
		"h": 1.6263736264
	},
	{
		"stop_id": 8583652,
		"ID": 1205,
		"x": 64.3617721683,
		"y": -1.853856869,
		"h": 1.6263736264
	},
	{
		"stop_id": 8509176,
		"ID": 1168,
		"x": 58.8417228653,
		"y": -4.58081951,
		"h": 1.2637362637
	},
	{
		"stop_id": 8509636,
		"ID": 1168,
		"x": 60.0467572953,
		"y": -4.61178757,
		"h": 1.2637362637
	},
	{
		"stop_id": 8574927,
		"ID": 1168,
		"x": 58.7257748423,
		"y": -4.530853256,
		"h": 1.2637362637
	},
	{
		"stop_id": 8574928,
		"ID": 1168,
		"x": 58.8637229673,
		"y": -4.560814978,
		"h": 1.2637362637
	},
	{
		"stop_id": 8574929,
		"ID": 1168,
		"x": 59.5777206023,
		"y": -4.349840072,
		"h": 1.2637362637
	},
	{
		"stop_id": 8574932,
		"ID": 1168,
		"x": 59.3117177953,
		"y": -4.079824494,
		"h": 1.2637362637
	},
	{
		"stop_id": 8574933,
		"ID": 1168,
		"x": 60.6287719013,
		"y": -3.413844699,
		"h": 1.2637362637
	},
	{
		"stop_id": 8577230,
		"ID": 1168,
		"x": 58.9367537183,
		"y": -4.388805425,
		"h": 1.2637362637
	},
	{
		"stop_id": 8580192,
		"ID": 1168,
		"x": 57.5307038453,
		"y": -4.995770995,
		"h": 1.2637362637
	},
	{
		"stop_id": 8509177,
		"ID": 1132,
		"x": 56.3457129663,
		"y": -5.737776869,
		"h": 1.2637362637
	},
	{
		"stop_id": 8509178,
		"ID": 1132,
		"x": 54.3637328943,
		"y": -6.720804745,
		"h": 1.2637362637
	},
	{
		"stop_id": 8574892,
		"ID": 1132,
		"x": 51.6846990463,
		"y": -7.136763239,
		"h": 1.2637362637
	},
	{
		"stop_id": 8574893,
		"ID": 1132,
		"x": 51.4767565813,
		"y": -7.493750429,
		"h": 1.2637362637
	},
	{
		"stop_id": 8574894,
		"ID": 1132,
		"x": 51.7517208693,
		"y": -7.611839512,
		"h": 1.2637362637
	},
	{
		"stop_id": 8589101,
		"ID": 1132,
		"x": 54.9577017093,
		"y": -6.269837963,
		"h": 1.2637362637
	},
	{
		"stop_id": 8589102,
		"ID": 1132,
		"x": 53.6927374463,
		"y": -6.859843369,
		"h": 1.2637362637
	},
	{
		"stop_id": 8589105,
		"ID": 1132,
		"x": 56.3337267373,
		"y": -5.726778942,
		"h": 1.2637362637
	},
	{
		"stop_id": 8590398,
		"ID": 1132,
		"x": 54.1627593653,
		"y": -6.674813675,
		"h": 1.2637362637
	},
	{
		"stop_id": 8509181,
		"ID": 1370,
		"x": 93.9357209593,
		"y": 6.291153751,
		"h": 1.4615384615
	},
	{
		"stop_id": 8509182,
		"ID": 1370,
		"x": 92.2117049543,
		"y": 5.747144767,
		"h": 1.4615384615
	},
	{
		"stop_id": 8509183,
		"ID": 1370,
		"x": 90.8647354473,
		"y": 5.159184391,
		"h": 1.4615384615
	},
	{
		"stop_id": 8530588,
		"ID": 1370,
		"x": 94.2607373323,
		"y": 2.239190206,
		"h": 1.4615384615
	},
	{
		"stop_id": 8572671,
		"ID": 1370,
		"x": 95.2697274603,
		"y": 7.671160177,
		"h": 1.4615384615
	},
	{
		"stop_id": 8572672,
		"ID": 1370,
		"x": 95.0857400383,
		"y": 7.554188158,
		"h": 1.4615384615
	},
	{
		"stop_id": 8572689,
		"ID": 1370,
		"x": 94.8107313943,
		"y": 7.398171666,
		"h": 1.4615384615
	},
	{
		"stop_id": 8572906,
		"ID": 1370,
		"x": 90.5477702923,
		"y": 5.270203309,
		"h": 1.4615384615
	},
	{
		"stop_id": 8574671,
		"ID": 1370,
		"x": 94.6157424143,
		"y": 6.787177065,
		"h": 1.4615384615
	},
	{
		"stop_id": 8574672,
		"ID": 1370,
		"x": 94.0547077313,
		"y": 6.742146346,
		"h": 1.4615384615
	},
	{
		"stop_id": 8574673,
		"ID": 1370,
		"x": 93.5057355023,
		"y": 6.33917461,
		"h": 1.4615384615
	},
	{
		"stop_id": 8574674,
		"ID": 1370,
		"x": 93.2037467693,
		"y": 6.142176338,
		"h": 1.4615384615
	},
	{
		"stop_id": 8574675,
		"ID": 1370,
		"x": 92.9567352563,
		"y": 6.012207459,
		"h": 1.4615384615
	},
	{
		"stop_id": 8574676,
		"ID": 1370,
		"x": 92.3047187323,
		"y": 5.835246196,
		"h": 1.4615384615
	},
	{
		"stop_id": 8581561,
		"ID": 1370,
		"x": 93.7567498583,
		"y": 6.657206363,
		"h": 1.4615384615
	},
	{
		"stop_id": 8509186,
		"ID": 1369,
		"x": 91.5597722183,
		"y": -1.028772433,
		"h": 1.9230769231
	},
	{
		"stop_id": 8509680,
		"ID": 1369,
		"x": 92.2627429903,
		"y": 2.020212316,
		"h": 1.9230769231
	},
	{
		"stop_id": 8530587,
		"ID": 1369,
		"x": 93.0697627633,
		"y": 1.65521044,
		"h": 1.9230769231
	},
	{
		"stop_id": 8574517,
		"ID": 1369,
		"x": 93.7247466663,
		"y": 0.11221006,
		"h": 1.9230769231
	},
	{
		"stop_id": 8574518,
		"ID": 1369,
		"x": 93.3967156903,
		"y": 0.192220819,
		"h": 1.9230769231
	},
	{
		"stop_id": 8574524,
		"ID": 1369,
		"x": 93.6667318803,
		"y": -1.667763251,
		"h": 1.9230769231
	},
	{
		"stop_id": 8574526,
		"ID": 1369,
		"x": 94.6287535653,
		"y": -1.832766387,
		"h": 1.9230769231
	},
	{
		"stop_id": 8574527,
		"ID": 1369,
		"x": 94.7827610993,
		"y": -1.720816589,
		"h": 1.9230769231
	},
	{
		"stop_id": 8574528,
		"ID": 1369,
		"x": 94.8917071463,
		"y": -1.630821199,
		"h": 1.9230769231
	},
	{
		"stop_id": 8574529,
		"ID": 1369,
		"x": 94.6617535513,
		"y": -1.274781681,
		"h": 1.9230769231
	},
	{
		"stop_id": 8574547,
		"ID": 1369,
		"x": 93.3407452473,
		"y": -2.936818532,
		"h": 1.9230769231
	},
	{
		"stop_id": 8574549,
		"ID": 1369,
		"x": 93.4337338223,
		"y": -1.966858366,
		"h": 1.9230769231
	},
	{
		"stop_id": 8574551,
		"ID": 1369,
		"x": 93.0267040823,
		"y": -2.053758988,
		"h": 1.9230769231
	},
	{
		"stop_id": 8574552,
		"ID": 1369,
		"x": 92.6727510403,
		"y": -1.595830301,
		"h": 1.9230769231
	},
	{
		"stop_id": 8574553,
		"ID": 1369,
		"x": 92.5027602623,
		"y": -1.374854459,
		"h": 1.9230769231
	},
	{
		"stop_id": 8574554,
		"ID": 1369,
		"x": 92.1787494333,
		"y": -0.994757942,
		"h": 1.9230769231
	},
	{
		"stop_id": 8574555,
		"ID": 1369,
		"x": 91.5467530483,
		"y": -1.048784196,
		"h": 1.9230769231
	},
	{
		"stop_id": 8577111,
		"ID": 1369,
		"x": 93.5857095643,
		"y": -0.1207652,
		"h": 1.9230769231
	},
	{
		"stop_id": 8577137,
		"ID": 1369,
		"x": 93.8567720873,
		"y": -1.416799297,
		"h": 1.9230769231
	},
	{
		"stop_id": 8577182,
		"ID": 1369,
		"x": 93.0597347813,
		"y": 1.596238735,
		"h": 1.9230769231
	},
	{
		"stop_id": 8580180,
		"ID": 1369,
		"x": 92.4767071203,
		"y": 1.907216079,
		"h": 1.9230769231
	},
	{
		"stop_id": 8580750,
		"ID": 1369,
		"x": 91.5477252303,
		"y": -0.905752491,
		"h": 1.9230769231
	},
	{
		"stop_id": 8581155,
		"ID": 1369,
		"x": 93.4867519743,
		"y": 0.695164888,
		"h": 1.9230769231
	},
	{
		"stop_id": 8581156,
		"ID": 1369,
		"x": 92.7626997583,
		"y": 1.869233723,
		"h": 1.9230769231
	},
	{
		"stop_id": 8581228,
		"ID": 1369,
		"x": 92.3537016003,
		"y": 1.999169447,
		"h": 1.9230769231
	},
	{
		"stop_id": 8581650,
		"ID": 1369,
		"x": 91.8897429533,
		"y": -2.702820924,
		"h": 1.9230769231
	},
	{
		"stop_id": 8582246,
		"ID": 1369,
		"x": 93.7727720253,
		"y": -3.038749077,
		"h": 1.9230769231
	},
	{
		"stop_id": 8583031,
		"ID": 1369,
		"x": 93.2807486533,
		"y": 1.044193855,
		"h": 1.9230769231
	},
	{
		"stop_id": 8583531,
		"ID": 1369,
		"x": 91.6037572353,
		"y": -1.659850645,
		"h": 1.9230769231
	},
	{
		"stop_id": 8509187,
		"ID": 1368,
		"x": 92.6697342173,
		"y": -4.638763216,
		"h": 2.5824175824
	},
	{
		"stop_id": 8509188,
		"ID": 1368,
		"x": 92.7137279883,
		"y": -6.335825816,
		"h": 2.5824175824
	},
	{
		"stop_id": 8509189,
		"ID": 1368,
		"x": 93.3527038843,
		"y": -8.729759421,
		"h": 2.5824175824
	},
	{
		"stop_id": 8509745,
		"ID": 1368,
		"x": 91.0027438343,
		"y": -6.392766084,
		"h": 2.5824175824
	},
	{
		"stop_id": 8570469,
		"ID": 1368,
		"x": 92.2627372443,
		"y": -5.762794961,
		"h": 2.5824175824
	},
	{
		"stop_id": 8574531,
		"ID": 1368,
		"x": 95.4417320153,
		"y": -8.377825177,
		"h": 2.5824175824
	},
	{
		"stop_id": 8574542,
		"ID": 1368,
		"x": 93.6797460103,
		"y": -4.97685378,
		"h": 2.5824175824
	},
	{
		"stop_id": 8574543,
		"ID": 1368,
		"x": 93.9457274593,
		"y": -4.635761821,
		"h": 2.5824175824
	},
	{
		"stop_id": 8574544,
		"ID": 1368,
		"x": 94.2987523423,
		"y": -4.246827076,
		"h": 2.5824175824
	},
	{
		"stop_id": 8574545,
		"ID": 1368,
		"x": 93.5737363173,
		"y": -4.616820277,
		"h": 2.5824175824
	},
	{
		"stop_id": 8574576,
		"ID": 1368,
		"x": 94.3827765773,
		"y": -8.444830935,
		"h": 2.5824175824
	},
	{
		"stop_id": 8574577,
		"ID": 1368,
		"x": 94.4077034543,
		"y": -7.619838684,
		"h": 2.5824175824
	},
	{
		"stop_id": 8574578,
		"ID": 1368,
		"x": 94.2817004153,
		"y": -7.276788504,
		"h": 2.5824175824
	},
	{
		"stop_id": 8574579,
		"ID": 1368,
		"x": 94.6157232103,
		"y": -6.586854316,
		"h": 2.5824175824
	},
	{
		"stop_id": 8574580,
		"ID": 1368,
		"x": 94.7547471703,
		"y": -6.600843855,
		"h": 2.5824175824
	},
	{
		"stop_id": 8574581,
		"ID": 1368,
		"x": 94.0517176323,
		"y": -6.937849397,
		"h": 2.5824175824
	},
	{
		"stop_id": 8574583,
		"ID": 1368,
		"x": 93.9037073213,
		"y": -6.304781696,
		"h": 2.5824175824
	},
	{
		"stop_id": 8574584,
		"ID": 1368,
		"x": 92.0727116443,
		"y": -6.777774765,
		"h": 2.5824175824
	},
	{
		"stop_id": 8574586,
		"ID": 1368,
		"x": 91.5827297753,
		"y": -6.494807169,
		"h": 2.5824175824
	},
	{
		"stop_id": 8574593,
		"ID": 1368,
		"x": 92.7987581573,
		"y": -7.06582308,
		"h": 2.5824175824
	},
	{
		"stop_id": 8574594,
		"ID": 1368,
		"x": 92.5267274373,
		"y": -7.220859144,
		"h": 2.5824175824
	},
	{
		"stop_id": 8574595,
		"ID": 1368,
		"x": 92.2977322573,
		"y": -6.747831032,
		"h": 2.5824175824
	},
	{
		"stop_id": 8574596,
		"ID": 1368,
		"x": 92.0367446593,
		"y": -6.459756332,
		"h": 2.5824175824
	},
	{
		"stop_id": 8574685,
		"ID": 1368,
		"x": 91.7007571373,
		"y": -8.103816212,
		"h": 2.5824175824
	},
	{
		"stop_id": 8574900,
		"ID": 1368,
		"x": 93.2056995523,
		"y": -7.183785396,
		"h": 2.5824175824
	},
	{
		"stop_id": 8574902,
		"ID": 1368,
		"x": 93.2867560553,
		"y": -9.110755369,
		"h": 2.5824175824
	},
	{
		"stop_id": 8574904,
		"ID": 1368,
		"x": 93.4187542903,
		"y": -8.583842902,
		"h": 2.5824175824
	},
	{
		"stop_id": 8574905,
		"ID": 1368,
		"x": 93.3597588543,
		"y": -8.310788982,
		"h": 2.5824175824
	},
	{
		"stop_id": 8574906,
		"ID": 1368,
		"x": 93.3207616313,
		"y": -8.041783501,
		"h": 2.5824175824
	},
	{
		"stop_id": 8574907,
		"ID": 1368,
		"x": 93.0697351323,
		"y": -9.205806242,
		"h": 2.5824175824
	},
	{
		"stop_id": 8574908,
		"ID": 1368,
		"x": 93.0327730383,
		"y": -8.595799744,
		"h": 2.5824175824
	},
	{
		"stop_id": 8574909,
		"ID": 1368,
		"x": 92.7957062203,
		"y": -8.530775,
		"h": 2.5824175824
	},
	{
		"stop_id": 8574910,
		"ID": 1368,
		"x": 92.4557244063,
		"y": -8.431767819,
		"h": 2.5824175824
	},
	{
		"stop_id": 8574911,
		"ID": 1368,
		"x": 92.2747057923,
		"y": -8.328825828,
		"h": 2.5824175824
	},
	{
		"stop_id": 8574912,
		"ID": 1368,
		"x": 92.2327323133,
		"y": -8.628801718,
		"h": 2.5824175824
	},
	{
		"stop_id": 8578057,
		"ID": 1368,
		"x": 93.7677635703,
		"y": -6.159807351,
		"h": 2.5824175824
	},
	{
		"stop_id": 8580179,
		"ID": 1368,
		"x": 93.3367162853,
		"y": -8.753853696,
		"h": 2.5824175824
	},
	{
		"stop_id": 8580447,
		"ID": 1368,
		"x": 94.5087577223,
		"y": -8.104756726,
		"h": 2.5824175824
	},
	{
		"stop_id": 8580450,
		"ID": 1368,
		"x": 94.1377681753,
		"y": -8.720790053,
		"h": 2.5824175824
	},
	{
		"stop_id": 8581649,
		"ID": 1368,
		"x": 92.7757111303,
		"y": -7.05284258,
		"h": 2.5824175824
	},
	{
		"stop_id": 8581651,
		"ID": 1368,
		"x": 92.3437606013,
		"y": -6.044752016,
		"h": 2.5824175824
	},
	{
		"stop_id": 8581652,
		"ID": 1368,
		"x": 92.1947216983,
		"y": -5.284790322,
		"h": 2.5824175824
	},
	{
		"stop_id": 8581863,
		"ID": 1368,
		"x": 93.6467284883,
		"y": -4.86983134,
		"h": 2.5824175824
	},
	{
		"stop_id": 8581864,
		"ID": 1368,
		"x": 92.2387675123,
		"y": -4.886790795,
		"h": 2.5824175824
	},
	{
		"stop_id": 8581887,
		"ID": 1368,
		"x": 92.6997642363,
		"y": -4.484761623,
		"h": 2.5824175824
	},
	{
		"stop_id": 8582716,
		"ID": 1368,
		"x": 94.2837146553,
		"y": -7.134841033,
		"h": 2.5824175824
	},
	{
		"stop_id": 8582960,
		"ID": 1368,
		"x": 92.5077207163,
		"y": -6.339837379,
		"h": 2.5824175824
	},
	{
		"stop_id": 8583524,
		"ID": 1368,
		"x": 93.4547315433,
		"y": -4.127787534,
		"h": 2.5824175824
	},
	{
		"stop_id": 8583610,
		"ID": 1368,
		"x": 91.1527359093,
		"y": -6.730828542,
		"h": 2.5824175824
	},
	{
		"stop_id": 8509192,
		"ID": 1416,
		"x": 103.5767577333,
		"y": -12.276833986,
		"h": 1.4945054945
	},
	{
		"stop_id": 8509301,
		"ID": 1416,
		"x": 102.9707623833,
		"y": -13.829843037,
		"h": 1.4945054945
	},
	{
		"stop_id": 8509304,
		"ID": 1416,
		"x": 101.2167246793,
		"y": -12.471817412,
		"h": 1.4945054945
	},
	{
		"stop_id": 8509305,
		"ID": 1416,
		"x": 106.6067061703,
		"y": -12.005781193,
		"h": 1.4945054945
	},
	{
		"stop_id": 8509789,
		"ID": 1416,
		"x": 102.7537751743,
		"y": -9.864847894,
		"h": 1.4945054945
	},
	{
		"stop_id": 8509970,
		"ID": 1416,
		"x": 105.2897006213,
		"y": -11.65680634,
		"h": 1.4945054945
	},
	{
		"stop_id": 8574504,
		"ID": 1416,
		"x": 104.0657045213,
		"y": -11.615834129,
		"h": 1.4945054945
	},
	{
		"stop_id": 8574505,
		"ID": 1416,
		"x": 103.9297443543,
		"y": -12.415791063,
		"h": 1.4945054945
	},
	{
		"stop_id": 8574634,
		"ID": 1416,
		"x": 103.5017380103,
		"y": -14.991777249,
		"h": 1.4945054945
	},
	{
		"stop_id": 8574862,
		"ID": 1416,
		"x": 102.6967262233,
		"y": -11.24881006,
		"h": 1.4945054945
	},
	{
		"stop_id": 8574863,
		"ID": 1416,
		"x": 101.8637181703,
		"y": -11.108829747,
		"h": 1.4945054945
	},
	{
		"stop_id": 8574864,
		"ID": 1416,
		"x": 102.8637710403,
		"y": -13.693844616,
		"h": 1.4945054945
	},
	{
		"stop_id": 8575113,
		"ID": 1416,
		"x": 103.5137594603,
		"y": -12.254749655,
		"h": 1.4945054945
	},
	{
		"stop_id": 8580921,
		"ID": 1416,
		"x": 102.6757129363,
		"y": -9.440815382,
		"h": 1.4945054945
	},
	{
		"stop_id": 8581190,
		"ID": 1416,
		"x": 102.9787237493,
		"y": -10.277780079,
		"h": 1.4945054945
	},
	{
		"stop_id": 8583813,
		"ID": 1416,
		"x": 103.3447655843,
		"y": -11.039843653,
		"h": 1.4945054945
	},
	{
		"stop_id": 8509193,
		"ID": 1437,
		"x": 107.2457642813,
		"y": -11.843794134,
		"h": 1.4285714286
	},
	{
		"stop_id": 8509194,
		"ID": 1437,
		"x": 109.5107690993,
		"y": -11.292791091,
		"h": 1.4285714286
	},
	{
		"stop_id": 8509751,
		"ID": 1437,
		"x": 109.2727314533,
		"y": -10.462752649,
		"h": 1.4285714286
	},
	{
		"stop_id": 8509875,
		"ID": 1437,
		"x": 111.1347666983,
		"y": -9.389752405,
		"h": 1.4285714286
	},
	{
		"stop_id": 8574842,
		"ID": 1437,
		"x": 111.4517058843,
		"y": -9.33978953,
		"h": 1.4285714286
	},
	{
		"stop_id": 8574844,
		"ID": 1437,
		"x": 107.8727321663,
		"y": -11.178851685,
		"h": 1.4285714286
	},
	{
		"stop_id": 8574845,
		"ID": 1437,
		"x": 106.6837697203,
		"y": -11.518772824,
		"h": 1.4285714286
	},
	{
		"stop_id": 8574866,
		"ID": 1437,
		"x": 109.1887145083,
		"y": -11.632828836,
		"h": 1.4285714286
	},
	{
		"stop_id": 8574867,
		"ID": 1437,
		"x": 109.4487324403,
		"y": -11.310777379,
		"h": 1.4285714286
	},
	{
		"stop_id": 8574870,
		"ID": 1437,
		"x": 107.7167061703,
		"y": -11.866813928,
		"h": 1.4285714286
	},
	{
		"stop_id": 8574871,
		"ID": 1437,
		"x": 110.7607750953,
		"y": -9.602799363,
		"h": 1.4285714286
	},
	{
		"stop_id": 8574873,
		"ID": 1437,
		"x": 107.0377633683,
		"y": -11.791749714,
		"h": 1.4285714286
	},
	{
		"stop_id": 8579854,
		"ID": 1437,
		"x": 110.3547488143,
		"y": -11.167834727,
		"h": 1.4285714286
	},
	{
		"stop_id": 8583425,
		"ID": 1437,
		"x": 109.4567302463,
		"y": -11.485819718,
		"h": 1.4285714286
	},
	{
		"stop_id": 8509195,
		"ID": 1454,
		"x": 111.9117244383,
		"y": -10.770842093,
		"h": 1.0989010989
	},
	{
		"stop_id": 8574868,
		"ID": 1454,
		"x": 112.0297499953,
		"y": -10.914820123,
		"h": 1.0989010989
	},
	{
		"stop_id": 8574869,
		"ID": 1454,
		"x": 111.8997589883,
		"y": -10.796763148,
		"h": 1.0989010989
	},
	{
		"stop_id": 8581154,
		"ID": 1454,
		"x": 115.7577776803,
		"y": -13.369854687,
		"h": 1.0989010989
	},
	{
		"stop_id": 8509197,
		"ID": 1468,
		"x": 116.9867488793,
		"y": -15.545846697,
		"h": 1.2307692308
	},
	{
		"stop_id": 8530594,
		"ID": 1468,
		"x": 117.3387259463,
		"y": -16.49481097,
		"h": 1.2307692308
	},
	{
		"stop_id": 8530595,
		"ID": 1468,
		"x": 118.8387426543,
		"y": -16.365758827,
		"h": 1.2307692308
	},
	{
		"stop_id": 8530738,
		"ID": 1468,
		"x": 119.5437141203,
		"y": -16.204844827,
		"h": 1.2307692308
	},
	{
		"stop_id": 8574651,
		"ID": 1468,
		"x": 116.9577744633,
		"y": -15.844753132,
		"h": 1.2307692308
	},
	{
		"stop_id": 8574652,
		"ID": 1468,
		"x": 117.0077095053,
		"y": -15.544784884,
		"h": 1.2307692308
	},
	{
		"stop_id": 8574655,
		"ID": 1468,
		"x": 117.3327701183,
		"y": -15.219803864,
		"h": 1.2307692308
	},
	{
		"stop_id": 8574735,
		"ID": 1468,
		"x": 121.1577283333,
		"y": -14.094822473,
		"h": 1.2307692308
	},
	{
		"stop_id": 8509198,
		"ID": 1467,
		"x": 119.4687290073,
		"y": -20.244750632,
		"h": 1.0659340659
	},
	{
		"stop_id": 8595927,
		"ID": 1467,
		"x": 119.7737654123,
		"y": -20.71275893,
		"h": 1.0659340659
	},
	{
		"stop_id": 8595928,
		"ID": 1467,
		"x": 119.3627376033,
		"y": -20.099772308,
		"h": 1.0659340659
	},
	{
		"stop_id": 8509199,
		"ID": 1481,
		"x": 124.7757348273,
		"y": -23.23282421,
		"h": 1.032967033
	},
	{
		"stop_id": 8595926,
		"ID": 1481,
		"x": 122.2377508873,
		"y": -21.395813265,
		"h": 1.032967033
	},
	{
		"stop_id": 8509250,
		"ID": 1494,
		"x": 128.1167223023,
		"y": -24.234769012,
		"h": 1.6263736264
	},
	{
		"stop_id": 8509251,
		"ID": 1494,
		"x": 127.0347437853,
		"y": -26.063768024,
		"h": 1.6263736264
	},
	{
		"stop_id": 8509254,
		"ID": 1494,
		"x": 127.6977271873,
		"y": -28.721854918,
		"h": 1.6263736264
	},
	{
		"stop_id": 8509275,
		"ID": 1494,
		"x": 127.8287292233,
		"y": -28.79084387,
		"h": 1.6263736264
	},
	{
		"stop_id": 8509276,
		"ID": 1494,
		"x": 129.2427472753,
		"y": -27.338781719,
		"h": 1.6263736264
	},
	{
		"stop_id": 8509350,
		"ID": 1494,
		"x": 126.4647759863,
		"y": -28.762802232,
		"h": 1.6263736264
	},
	{
		"stop_id": 8509351,
		"ID": 1494,
		"x": 127.6457281663,
		"y": -28.982836856,
		"h": 1.6263736264
	},
	{
		"stop_id": 8574941,
		"ID": 1494,
		"x": 127.8157303633,
		"y": -28.851752164,
		"h": 1.6263736264
	},
	{
		"stop_id": 8574971,
		"ID": 1494,
		"x": 128.1547488923,
		"y": -24.034831586,
		"h": 1.6263736264
	},
	{
		"stop_id": 8574972,
		"ID": 1494,
		"x": 127.3447467783,
		"y": -25.436757468,
		"h": 1.6263736264
	},
	{
		"stop_id": 8574973,
		"ID": 1494,
		"x": 128.0877721573,
		"y": -24.248797279,
		"h": 1.6263736264
	},
	{
		"stop_id": 8574974,
		"ID": 1494,
		"x": 126.9787463433,
		"y": -26.064839277,
		"h": 1.6263736264
	},
	{
		"stop_id": 8574975,
		"ID": 1494,
		"x": 126.7107454673,
		"y": -26.154787159,
		"h": 1.6263736264
	},
	{
		"stop_id": 8574976,
		"ID": 1494,
		"x": 126.5647680393,
		"y": -26.474837108,
		"h": 1.6263736264
	},
	{
		"stop_id": 8574977,
		"ID": 1494,
		"x": 126.2127160323,
		"y": -28.214839622,
		"h": 1.6263736264
	},
	{
		"stop_id": 8580585,
		"ID": 1494,
		"x": 126.9517390963,
		"y": -25.82778077,
		"h": 1.6263736264
	},
	{
		"stop_id": 8580593,
		"ID": 1494,
		"x": 127.0577507913,
		"y": -25.751752224,
		"h": 1.6263736264
	},
	{
		"stop_id": 8588804,
		"ID": 1494,
		"x": 126.8447342903,
		"y": -25.975796638,
		"h": 1.6263736264
	},
	{
		"stop_id": 8588805,
		"ID": 1494,
		"x": 126.7767355373,
		"y": -26.339810932,
		"h": 1.6263736264
	},
	{
		"stop_id": 8589914,
		"ID": 1494,
		"x": 126.8667232503,
		"y": -26.429776294,
		"h": 1.6263736264
	},
	{
		"stop_id": 8509252,
		"ID": 1480,
		"x": 125.9377140443,
		"y": -28.297848097,
		"h": 2.1868131868
	},
	{
		"stop_id": 8509253,
		"ID": 1480,
		"x": 125.0676995213,
		"y": -30.105779091,
		"h": 2.1868131868
	},
	{
		"stop_id": 8509270,
		"ID": 1480,
		"x": 124.3927100023,
		"y": -30.031820657,
		"h": 2.1868131868
	},
	{
		"stop_id": 8509271,
		"ID": 1480,
		"x": 124.2007032893,
		"y": -29.747860354,
		"h": 2.1868131868
	},
	{
		"stop_id": 8509273,
		"ID": 1480,
		"x": 122.8887160173,
		"y": -29.055789316,
		"h": 2.1868131868
	},
	{
		"stop_id": 8509274,
		"ID": 1480,
		"x": 120.5387223333,
		"y": -29.410800605,
		"h": 2.1868131868
	},
	{
		"stop_id": 8509277,
		"ID": 1480,
		"x": 123.3717722943,
		"y": -28.070857474,
		"h": 2.1868131868
	},
	{
		"stop_id": 8509383,
		"ID": 1480,
		"x": 123.2537697203,
		"y": -30.578818321,
		"h": 2.1868131868
	},
	{
		"stop_id": 8509762,
		"ID": 1480,
		"x": 122.5787257013,
		"y": -32.380758293,
		"h": 2.1868131868
	},
	{
		"stop_id": 8509870,
		"ID": 1480,
		"x": 124.3237603163,
		"y": -31.471852976,
		"h": 2.1868131868
	},
	{
		"stop_id": 8530601,
		"ID": 1480,
		"x": 122.9117409933,
		"y": -31.335800183,
		"h": 2.1868131868
	},
	{
		"stop_id": 8530602,
		"ID": 1480,
		"x": 122.2477611103,
		"y": -30.950749752,
		"h": 2.1868131868
	},
	{
		"stop_id": 8530604,
		"ID": 1480,
		"x": 125.5217497383,
		"y": -28.438792397,
		"h": 2.1868131868
	},
	{
		"stop_id": 8530685,
		"ID": 1480,
		"x": 124.0567667223,
		"y": -31.744817044,
		"h": 2.1868131868
	},
	{
		"stop_id": 8530741,
		"ID": 1480,
		"x": 121.4697459753,
		"y": -29.499838091,
		"h": 2.1868131868
	},
	{
		"stop_id": 8574515,
		"ID": 1480,
		"x": 124.9837529153,
		"y": -30.140831486,
		"h": 2.1868131868
	},
	{
		"stop_id": 8574788,
		"ID": 1480,
		"x": 124.6877486013,
		"y": -29.932812754,
		"h": 2.1868131868
	},
	{
		"stop_id": 8574943,
		"ID": 1480,
		"x": 125.4907141443,
		"y": -28.914758609,
		"h": 2.1868131868
	},
	{
		"stop_id": 8574944,
		"ID": 1480,
		"x": 125.8827256003,
		"y": -28.558793677,
		"h": 2.1868131868
	},
	{
		"stop_id": 8574945,
		"ID": 1480,
		"x": 124.9557151083,
		"y": -29.757769758,
		"h": 2.1868131868
	},
	{
		"stop_id": 8574946,
		"ID": 1480,
		"x": 124.4457733113,
		"y": -30.091811308,
		"h": 2.1868131868
	},
	{
		"stop_id": 8574947,
		"ID": 1480,
		"x": 124.2967184893,
		"y": -30.966754184,
		"h": 2.1868131868
	},
	{
		"stop_id": 8574948,
		"ID": 1480,
		"x": 124.6317673113,
		"y": -31.324852655,
		"h": 2.1868131868
	},
	{
		"stop_id": 8574949,
		"ID": 1480,
		"x": 124.1687681313,
		"y": -31.706808396,
		"h": 2.1868131868
	},
	{
		"stop_id": 8574950,
		"ID": 1480,
		"x": 123.4017486483,
		"y": -32.284825336,
		"h": 2.1868131868
	},
	{
		"stop_id": 8574952,
		"ID": 1480,
		"x": 123.5877265573,
		"y": -31.680821293,
		"h": 2.1868131868
	},
	{
		"stop_id": 8580216,
		"ID": 1480,
		"x": 124.1237447893,
		"y": -30.657852399,
		"h": 2.1868131868
	},
	{
		"stop_id": 8590451,
		"ID": 1480,
		"x": 124.4977682013,
		"y": -31.519803293,
		"h": 2.1868131868
	},
	{
		"stop_id": 8590452,
		"ID": 1480,
		"x": 124.8577017113,
		"y": -31.169787725,
		"h": 2.1868131868
	},
	{
		"stop_id": 8590453,
		"ID": 1480,
		"x": 124.4577131453,
		"y": -31.169805834,
		"h": 2.1868131868
	},
	{
		"stop_id": 8590454,
		"ID": 1480,
		"x": 125.0577380813,
		"y": -31.069783073,
		"h": 2.1868131868
	},
	{
		"stop_id": 8590455,
		"ID": 1480,
		"x": 124.2077240973,
		"y": -30.869823972,
		"h": 2.1868131868
	},
	{
		"stop_id": 8590456,
		"ID": 1480,
		"x": 124.2077633213,
		"y": -31.089809657,
		"h": 2.1868131868
	},
	{
		"stop_id": 8590457,
		"ID": 1480,
		"x": 124.3377642223,
		"y": -30.369821385,
		"h": 2.1868131868
	},
	{
		"stop_id": 8590458,
		"ID": 1480,
		"x": 124.6877160093,
		"y": -30.139788874,
		"h": 2.1868131868
	},
	{
		"stop_id": 8590459,
		"ID": 1480,
		"x": 124.5077552193,
		"y": -30.219815783,
		"h": 2.1868131868
	},
	{
		"stop_id": 8595909,
		"ID": 1480,
		"x": 124.3867653403,
		"y": -31.597825769,
		"h": 2.1868131868
	},
	{
		"stop_id": 8509255,
		"ID": 1493,
		"x": 128.9057333803,
		"y": -30.800836711,
		"h": 1.3956043956
	},
	{
		"stop_id": 8509352,
		"ID": 1493,
		"x": 129.6607387053,
		"y": -31.334785242,
		"h": 1.3956043956
	},
	{
		"stop_id": 8530605,
		"ID": 1493,
		"x": 129.7357407333,
		"y": -30.744850097,
		"h": 1.3956043956
	},
	{
		"stop_id": 8530606,
		"ID": 1493,
		"x": 130.8967288793,
		"y": -31.054757497,
		"h": 1.3956043956
	},
	{
		"stop_id": 8574935,
		"ID": 1493,
		"x": 128.9047695373,
		"y": -30.757824972,
		"h": 1.3956043956
	},
	{
		"stop_id": 8574936,
		"ID": 1493,
		"x": 129.7177696673,
		"y": -31.05983455,
		"h": 1.3956043956
	},
	{
		"stop_id": 8574937,
		"ID": 1493,
		"x": 129.1697301933,
		"y": -30.234791048,
		"h": 1.3956043956
	},
	{
		"stop_id": 8574938,
		"ID": 1493,
		"x": 129.4427378303,
		"y": -30.599803832,
		"h": 1.3956043956
	},
	{
		"stop_id": 8574939,
		"ID": 1493,
		"x": 129.0207052553,
		"y": -29.920822218,
		"h": 1.3956043956
	},
	{
		"stop_id": 8574940,
		"ID": 1493,
		"x": 128.6067214583,
		"y": -29.591791755,
		"h": 1.3956043956
	},
	{
		"stop_id": 8574978,
		"ID": 1493,
		"x": 130.2847607673,
		"y": -31.662794912,
		"h": 1.3956043956
	},
	{
		"stop_id": 8594232,
		"ID": 1493,
		"x": 129.4297010013,
		"y": -30.651819539,
		"h": 1.3956043956
	},
	{
		"stop_id": 8595595,
		"ID": 1493,
		"x": 129.1637741833,
		"y": -30.803755316,
		"h": 1.3956043956
	},
	{
		"stop_id": 8509256,
		"ID": 1495,
		"x": 130.6877077953,
		"y": -20.954844896,
		"h": 1.1978021978
	},
	{
		"stop_id": 8587849,
		"ID": 1495,
		"x": 131.2627406513,
		"y": -21.241788892,
		"h": 1.1978021978
	},
	{
		"stop_id": 8587884,
		"ID": 1495,
		"x": 130.9237627563,
		"y": -20.937795579,
		"h": 1.1978021978
	},
	{
		"stop_id": 8587885,
		"ID": 1495,
		"x": 131.5477450993,
		"y": -21.535803831,
		"h": 1.1978021978
	},
	{
		"stop_id": 8595923,
		"ID": 1495,
		"x": 128.9747648413,
		"y": -20.252801219,
		"h": 1.1978021978
	},
	{
		"stop_id": 8595924,
		"ID": 1495,
		"x": 126.7597587963,
		"y": -19.963828492,
		"h": 1.1978021978
	},
	{
		"stop_id": 8595975,
		"ID": 1495,
		"x": 130.7277477223,
		"y": -20.947792551,
		"h": 1.1978021978
	},
	{
		"stop_id": 8509257,
		"ID": 1509,
		"x": 131.8087556073,
		"y": -19.983842044,
		"h": 1.2967032967
	},
	{
		"stop_id": 8509258,
		"ID": 1509,
		"x": 133.5327149133,
		"y": -18.496752706,
		"h": 1.2967032967
	},
	{
		"stop_id": 8509259,
		"ID": 1509,
		"x": 135.0487705003,
		"y": -17.114764851,
		"h": 1.2967032967
	},
	{
		"stop_id": 8587850,
		"ID": 1509,
		"x": 131.6327669203,
		"y": -20.214785115,
		"h": 1.2967032967
	},
	{
		"stop_id": 8587886,
		"ID": 1509,
		"x": 132.9947034003,
		"y": -18.869839551,
		"h": 1.2967032967
	},
	{
		"stop_id": 8587889,
		"ID": 1509,
		"x": 133.4806990143,
		"y": -18.521782817,
		"h": 1.2967032967
	},
	{
		"stop_id": 8587890,
		"ID": 1509,
		"x": 135.1697315263,
		"y": -17.138757875,
		"h": 1.2967032967
	},
	{
		"stop_id": 8587894,
		"ID": 1509,
		"x": 133.5937414493,
		"y": -18.053788998,
		"h": 1.2967032967
	},
	{
		"stop_id": 8587895,
		"ID": 1509,
		"x": 134.7587110963,
		"y": -17.293781735,
		"h": 1.2967032967
	},
	{
		"stop_id": 8591849,
		"ID": 1509,
		"x": 135.5497288513,
		"y": -16.779838515,
		"h": 1.2967032967
	},
	{
		"stop_id": 8509260,
		"ID": 1524,
		"x": 138.0217180103,
		"y": -14.059772344,
		"h": 1.1648351648
	},
	{
		"stop_id": 8517481,
		"ID": 1524,
		"x": 136.1817672523,
		"y": -16.207799737,
		"h": 1.1648351648
	},
	{
		"stop_id": 8587852,
		"ID": 1524,
		"x": 137.1577607953,
		"y": -16.369855037,
		"h": 1.1648351648
	},
	{
		"stop_id": 8587863,
		"ID": 1524,
		"x": 136.9577300933,
		"y": -14.76975813,
		"h": 1.1648351648
	},
	{
		"stop_id": 8587891,
		"ID": 1524,
		"x": 137.9987749943,
		"y": -14.116808626,
		"h": 1.1648351648
	},
	{
		"stop_id": 8587897,
		"ID": 1524,
		"x": 138.0227154443,
		"y": -13.852858575,
		"h": 1.1648351648
	},
	{
		"stop_id": 8509261,
		"ID": 1525,
		"x": 140.8077314963,
		"y": -10.425837228,
		"h": 1.0659340659
	},
	{
		"stop_id": 8574635,
		"ID": 1525,
		"x": 138.9487122523,
		"y": -12.083802347,
		"h": 1.0659340659
	},
	{
		"stop_id": 8574636,
		"ID": 1525,
		"x": 140.0517233953,
		"y": -10.600774342,
		"h": 1.0659340659
	},
	{
		"stop_id": 8509262,
		"ID": 1538,
		"x": 143.0047324303,
		"y": -7.315860066,
		"h": 1.0989010989
	},
	{
		"stop_id": 8509994,
		"ID": 1538,
		"x": 143.0117034503,
		"y": -7.270798611,
		"h": 1.0989010989
	},
	{
		"stop_id": 8581578,
		"ID": 1538,
		"x": 143.5157017693,
		"y": -7.204794143,
		"h": 1.0989010989
	},
	{
		"stop_id": 8582204,
		"ID": 1538,
		"x": 143.3547103473,
		"y": -7.10380176,
		"h": 1.0989010989
	},
	{
		"stop_id": 8509263,
		"ID": 1539,
		"x": 141.9897182333,
		"y": -1.297851913,
		"h": 1.1318681319
	},
	{
		"stop_id": 8509264,
		"ID": 1539,
		"x": 144.3397328483,
		"y": 0.72719613,
		"h": 1.1318681319
	},
	{
		"stop_id": 8509269,
		"ID": 1539,
		"x": 143.2647584993,
		"y": 0.004248751,
		"h": 1.1318681319
	},
	{
		"stop_id": 8574850,
		"ID": 1539,
		"x": 141.9697378883,
		"y": -1.605854047,
		"h": 1.1318681319
	},
	{
		"stop_id": 8574851,
		"ID": 1539,
		"x": 142.0077362603,
		"y": -1.319824864,
		"h": 1.1318681319
	},
	{
		"stop_id": 8509265,
		"ID": 1550,
		"x": 147.3527257373,
		"y": 1.04721077,
		"h": 1.1648351648
	},
	{
		"stop_id": 8509266,
		"ID": 1550,
		"x": 151.2007166283,
		"y": 1.40723075,
		"h": 1.1648351648
	},
	{
		"stop_id": 8574540,
		"ID": 1550,
		"x": 147.3647686693,
		"y": 1.059195629,
		"h": 1.1648351648
	},
	{
		"stop_id": 8574541,
		"ID": 1550,
		"x": 147.4857385673,
		"y": 1.501198515,
		"h": 1.1648351648
	},
	{
		"stop_id": 8581817,
		"ID": 1550,
		"x": 151.4047686303,
		"y": 1.600188253,
		"h": 1.1648351648
	},
	{
		"stop_id": 8583806,
		"ID": 1550,
		"x": 148.7177196133,
		"y": 1.714153735,
		"h": 1.1648351648
	},
	{
		"stop_id": 8509267,
		"ID": 1557,
		"x": 155.4907023893,
		"y": 3.129160751,
		"h": 1.1318681319
	},
	{
		"stop_id": 8509281,
		"ID": 1557,
		"x": 156.5067018803,
		"y": 5.748227807,
		"h": 1.1318681319
	},
	{
		"stop_id": 8509776,
		"ID": 1557,
		"x": 154.6347003843,
		"y": 3.682226003,
		"h": 1.1318681319
	},
	{
		"stop_id": 8530607,
		"ID": 1557,
		"x": 154.5347580813,
		"y": 3.900235532,
		"h": 1.1318681319
	},
	{
		"stop_id": 8530608,
		"ID": 1557,
		"x": 154.9107391243,
		"y": 5.096183699,
		"h": 1.1318681319
	},
	{
		"stop_id": 8509268,
		"ID": 1564,
		"x": 157.6197083263,
		"y": 3.887221006,
		"h": 1.956043956
	},
	{
		"stop_id": 8509280,
		"ID": 1564,
		"x": 157.8387703043,
		"y": 4.065157418,
		"h": 1.956043956
	},
	{
		"stop_id": 8509706,
		"ID": 1564,
		"x": 158.6347367963,
		"y": 1.030218846,
		"h": 1.956043956
	},
	{
		"stop_id": 8509708,
		"ID": 1564,
		"x": 159.0147634983,
		"y": 2.890147832,
		"h": 1.956043956
	},
	{
		"stop_id": 8509711,
		"ID": 1564,
		"x": 156.4427251703,
		"y": 2.539187903,
		"h": 1.956043956
	},
	{
		"stop_id": 8509716,
		"ID": 1564,
		"x": 157.0277679583,
		"y": 2.925212791,
		"h": 1.956043956
	},
	{
		"stop_id": 8509747,
		"ID": 1564,
		"x": 158.7857365553,
		"y": 4.439169558,
		"h": 1.956043956
	},
	{
		"stop_id": 8509891,
		"ID": 1564,
		"x": 155.7127531743,
		"y": 1.997164657,
		"h": 1.956043956
	},
	{
		"stop_id": 8509962,
		"ID": 1564,
		"x": 157.4847101973,
		"y": 3.106191221,
		"h": 1.956043956
	},
	{
		"stop_id": 8509989,
		"ID": 1564,
		"x": 158.1687016563,
		"y": 4.007190069,
		"h": 1.956043956
	},
	{
		"stop_id": 8574783,
		"ID": 1564,
		"x": 155.7147254023,
		"y": 2.403149076,
		"h": 1.956043956
	},
	{
		"stop_id": 8574784,
		"ID": 1564,
		"x": 158.6807658893,
		"y": 3.53917272,
		"h": 1.956043956
	},
	{
		"stop_id": 8574861,
		"ID": 1564,
		"x": 157.7167731833,
		"y": 3.928235181,
		"h": 1.956043956
	},
	{
		"stop_id": 8579689,
		"ID": 1564,
		"x": 158.9877609103,
		"y": 4.465238578,
		"h": 1.956043956
	},
	{
		"stop_id": 8579818,
		"ID": 1564,
		"x": 159.2317190393,
		"y": 4.485172954,
		"h": 1.956043956
	},
	{
		"stop_id": 8579819,
		"ID": 1564,
		"x": 159.3077184653,
		"y": 4.335218437,
		"h": 1.956043956
	},
	{
		"stop_id": 8580150,
		"ID": 1564,
		"x": 156.0707693103,
		"y": 3.496225167,
		"h": 1.956043956
	},
	{
		"stop_id": 8580151,
		"ID": 1564,
		"x": 156.6457633093,
		"y": 3.655145302,
		"h": 1.956043956
	},
	{
		"stop_id": 8582838,
		"ID": 1564,
		"x": 159.0287463973,
		"y": 4.464178123,
		"h": 1.956043956
	},
	{
		"stop_id": 8582923,
		"ID": 1564,
		"x": 158.1517090123,
		"y": 3.861178714,
		"h": 1.956043956
	},
	{
		"stop_id": 8582924,
		"ID": 1564,
		"x": 158.3817079383,
		"y": 4.011167052,
		"h": 1.956043956
	},
	{
		"stop_id": 8582925,
		"ID": 1564,
		"x": 158.5577274783,
		"y": 4.120149625,
		"h": 1.956043956
	},
	{
		"stop_id": 8582926,
		"ID": 1564,
		"x": 158.6747025653,
		"y": 4.061232024,
		"h": 1.956043956
	},
	{
		"stop_id": 8582927,
		"ID": 1564,
		"x": 158.9297270333,
		"y": 4.065204745,
		"h": 1.956043956
	},
	{
		"stop_id": 8582928,
		"ID": 1564,
		"x": 159.1847092903,
		"y": 4.185212465,
		"h": 1.956043956
	},
	{
		"stop_id": 8582929,
		"ID": 1564,
		"x": 158.5557479983,
		"y": 4.302180339,
		"h": 1.956043956
	},
	{
		"stop_id": 8582930,
		"ID": 1564,
		"x": 158.4747496703,
		"y": 4.510140926,
		"h": 1.956043956
	},
	{
		"stop_id": 8582931,
		"ID": 1564,
		"x": 158.6567362613,
		"y": 4.524232771,
		"h": 1.956043956
	},
	{
		"stop_id": 8582932,
		"ID": 1564,
		"x": 159.0097717553,
		"y": 4.655154858,
		"h": 1.956043956
	},
	{
		"stop_id": 8583688,
		"ID": 1564,
		"x": 158.3007007303,
		"y": 4.106219202,
		"h": 1.956043956
	},
	{
		"stop_id": 8509302,
		"ID": 1415,
		"x": 103.6787100823,
		"y": -18.281806782,
		"h": 1.6263736264
	},
	{
		"stop_id": 8509303,
		"ID": 1415,
		"x": 104.4117188513,
		"y": -18.319760775,
		"h": 1.6263736264
	},
	{
		"stop_id": 8509768,
		"ID": 1415,
		"x": 105.1827664293,
		"y": -18.522836927,
		"h": 1.6263736264
	},
	{
		"stop_id": 8530589,
		"ID": 1415,
		"x": 105.2267742353,
		"y": -19.7237832,
		"h": 1.6263736264
	},
	{
		"stop_id": 8530591,
		"ID": 1415,
		"x": 102.3707123113,
		"y": -20.911797274,
		"h": 1.6263736264
	},
	{
		"stop_id": 8574506,
		"ID": 1415,
		"x": 104.9567599763,
		"y": -16.78485658,
		"h": 1.6263736264
	},
	{
		"stop_id": 8574629,
		"ID": 1415,
		"x": 104.8807472273,
		"y": -18.330835791,
		"h": 1.6263736264
	},
	{
		"stop_id": 8574630,
		"ID": 1415,
		"x": 104.4857108793,
		"y": -17.712770403,
		"h": 1.6263736264
	},
	{
		"stop_id": 8574631,
		"ID": 1415,
		"x": 103.9117422683,
		"y": -16.632822477,
		"h": 1.6263736264
	},
	{
		"stop_id": 8574632,
		"ID": 1415,
		"x": 103.8567540153,
		"y": -16.22585658,
		"h": 1.6263736264
	},
	{
		"stop_id": 8574633,
		"ID": 1415,
		"x": 103.7087458423,
		"y": -15.910833476,
		"h": 1.6263736264
	},
	{
		"stop_id": 8577207,
		"ID": 1415,
		"x": 105.1707756663,
		"y": -18.236806326,
		"h": 1.6263736264
	},
	{
		"stop_id": 8580716,
		"ID": 1415,
		"x": 105.5407295463,
		"y": -19.51075566,
		"h": 1.6263736264
	},
	{
		"stop_id": 8583643,
		"ID": 1415,
		"x": 106.0607709313,
		"y": -19.266783389,
		"h": 1.6263736264
	},
	{
		"stop_id": 8583644,
		"ID": 1415,
		"x": 105.9037501113,
		"y": -19.412793328,
		"h": 1.6263736264
	},
	{
		"stop_id": 8583645,
		"ID": 1415,
		"x": 105.7627433503,
		"y": -19.302802154,
		"h": 1.6263736264
	},
	{
		"stop_id": 8583646,
		"ID": 1415,
		"x": 105.6287081333,
		"y": -19.136789591,
		"h": 1.6263736264
	},
	{
		"stop_id": 8583647,
		"ID": 1415,
		"x": 105.5587483623,
		"y": -19.251813091,
		"h": 1.6263736264
	},
	{
		"stop_id": 8583648,
		"ID": 1415,
		"x": 105.5997116753,
		"y": -19.631795094,
		"h": 1.6263736264
	},
	{
		"stop_id": 8583649,
		"ID": 1415,
		"x": 105.2667668133,
		"y": -19.764832773,
		"h": 1.6263736264
	},
	{
		"stop_id": 8509307,
		"ID": 1412,
		"x": 104.7827633193,
		"y": -36.545858711,
		"h": 1.1318681319
	},
	{
		"stop_id": 8574731,
		"ID": 1412,
		"x": 101.4947057223,
		"y": -35.195751501,
		"h": 1.1318681319
	},
	{
		"stop_id": 8574732,
		"ID": 1412,
		"x": 102.3207663053,
		"y": -35.854827918,
		"h": 1.1318681319
	},
	{
		"stop_id": 8574733,
		"ID": 1412,
		"x": 102.7727349153,
		"y": -36.120777893,
		"h": 1.1318681319
	},
	{
		"stop_id": 8574734,
		"ID": 1412,
		"x": 103.0867184393,
		"y": -36.222838876,
		"h": 1.1318681319
	},
	{
		"stop_id": 8509353,
		"ID": 1506,
		"x": 132.4497075923,
		"y": -35.129800963,
		"h": 1.1978021978
	},
	{
		"stop_id": 8509354,
		"ID": 1506,
		"x": 134.6967606033,
		"y": -35.710789466,
		"h": 1.1978021978
	},
	{
		"stop_id": 8509371,
		"ID": 1506,
		"x": 135.7957624013,
		"y": -36.10476355,
		"h": 1.1978021978
	},
	{
		"stop_id": 8519370,
		"ID": 1506,
		"x": 135.6987526283,
		"y": -36.017820437,
		"h": 1.1978021978
	},
	{
		"stop_id": 8574979,
		"ID": 1506,
		"x": 134.7477616973,
		"y": -35.668769407,
		"h": 1.1978021978
	},
	{
		"stop_id": 8574980,
		"ID": 1506,
		"x": 135.7377647103,
		"y": -36.044805482,
		"h": 1.1978021978
	},
	{
		"stop_id": 8581577,
		"ID": 1506,
		"x": 131.9777314843,
		"y": -33.739784947,
		"h": 1.1978021978
	},
	{
		"stop_id": 8509356,
		"ID": 1520,
		"x": 138.6927397363,
		"y": -39.593822098,
		"h": 1.1978021978
	},
	{
		"stop_id": 8509373,
		"ID": 1520,
		"x": 136.4577020253,
		"y": -36.5698473,
		"h": 1.1978021978
	},
	{
		"stop_id": 8509375,
		"ID": 1520,
		"x": 136.6757744493,
		"y": -36.550841503,
		"h": 1.1978021978
	},
	{
		"stop_id": 8509376,
		"ID": 1520,
		"x": 138.7877223233,
		"y": -37.23884432,
		"h": 1.1978021978
	},
	{
		"stop_id": 8574807,
		"ID": 1520,
		"x": 141.0577692443,
		"y": -39.216754949,
		"h": 1.1978021978
	},
	{
		"stop_id": 8574808,
		"ID": 1520,
		"x": 138.8867322923,
		"y": -39.370767237,
		"h": 1.1978021978
	},
	{
		"stop_id": 8574981,
		"ID": 1520,
		"x": 136.6717637893,
		"y": -36.578778172,
		"h": 1.1978021978
	},
	{
		"stop_id": 8509357,
		"ID": 1519,
		"x": 139.6967248753,
		"y": -43.343797708,
		"h": 1.032967033
	},
	{
		"stop_id": 8509358,
		"ID": 1519,
		"x": 140.7347177103,
		"y": -44.469808872,
		"h": 1.032967033
	},
	{
		"stop_id": 8509359,
		"ID": 1532,
		"x": 141.3617221683,
		"y": -46.567801143,
		"h": 1.3956043956
	},
	{
		"stop_id": 8509360,
		"ID": 1532,
		"x": 141.6747421503,
		"y": -47.379770638,
		"h": 1.3956043956
	},
	{
		"stop_id": 8509361,
		"ID": 1532,
		"x": 141.6647765683,
		"y": -48.833831612,
		"h": 1.3956043956
	},
	{
		"stop_id": 8574796,
		"ID": 1532,
		"x": 141.6807682393,
		"y": -48.892804221,
		"h": 1.3956043956
	},
	{
		"stop_id": 8574797,
		"ID": 1532,
		"x": 142.1297636113,
		"y": -47.380809073,
		"h": 1.3956043956
	},
	{
		"stop_id": 8574798,
		"ID": 1532,
		"x": 142.0857779663,
		"y": -46.864853702,
		"h": 1.3956043956
	},
	{
		"stop_id": 8574799,
		"ID": 1532,
		"x": 142.3147502703,
		"y": -46.513835545,
		"h": 1.3956043956
	},
	{
		"stop_id": 8574800,
		"ID": 1532,
		"x": 142.6657024183,
		"y": -45.161790168,
		"h": 1.3956043956
	},
	{
		"stop_id": 8574801,
		"ID": 1532,
		"x": 143.3797628373,
		"y": -44.96783907,
		"h": 1.3956043956
	},
	{
		"stop_id": 8575117,
		"ID": 1532,
		"x": 142.8637466653,
		"y": -44.486779529,
		"h": 1.3956043956
	},
	{
		"stop_id": 8580005,
		"ID": 1532,
		"x": 143.1317014723,
		"y": -44.868850472,
		"h": 1.3956043956
	},
	{
		"stop_id": 8580077,
		"ID": 1532,
		"x": 142.1247488263,
		"y": -49.214770247,
		"h": 1.3956043956
	},
	{
		"stop_id": 8581991,
		"ID": 1532,
		"x": 141.8447628323,
		"y": -48.551760684,
		"h": 1.3956043956
	},
	{
		"stop_id": 8509363,
		"ID": 1531,
		"x": 142.3987573593,
		"y": -50.323765824,
		"h": 1.3956043956
	},
	{
		"stop_id": 8509364,
		"ID": 1531,
		"x": 143.5977299063,
		"y": -52.399839579,
		"h": 1.3956043956
	},
	{
		"stop_id": 8509365,
		"ID": 1531,
		"x": 145.3407646593,
		"y": -54.458820901,
		"h": 1.3956043956
	},
	{
		"stop_id": 8574790,
		"ID": 1531,
		"x": 143.6277153623,
		"y": -52.511837351,
		"h": 1.3956043956
	},
	{
		"stop_id": 8574791,
		"ID": 1531,
		"x": 143.9037647423,
		"y": -51.974762799,
		"h": 1.3956043956
	},
	{
		"stop_id": 8574792,
		"ID": 1531,
		"x": 143.4127341783,
		"y": -51.204807949,
		"h": 1.3956043956
	},
	{
		"stop_id": 8574793,
		"ID": 1531,
		"x": 143.1097116603,
		"y": -50.541845664,
		"h": 1.3956043956
	},
	{
		"stop_id": 8574794,
		"ID": 1531,
		"x": 142.4197309033,
		"y": -50.344752973,
		"h": 1.3956043956
	},
	{
		"stop_id": 8574795,
		"ID": 1531,
		"x": 142.2157333483,
		"y": -50.022792512,
		"h": 1.3956043956
	},
	{
		"stop_id": 8579987,
		"ID": 1531,
		"x": 143.6827439963,
		"y": -52.279854839,
		"h": 1.3956043956
	},
	{
		"stop_id": 8579989,
		"ID": 1531,
		"x": 145.3587683303,
		"y": -54.459767088,
		"h": 1.3956043956
	},
	{
		"stop_id": 8580187,
		"ID": 1531,
		"x": 142.9097298763,
		"y": -50.827850742,
		"h": 1.3956043956
	},
	{
		"stop_id": 8580505,
		"ID": 1531,
		"x": 142.6887096623,
		"y": -50.48678887,
		"h": 1.3956043956
	},
	{
		"stop_id": 8509366,
		"ID": 1543,
		"x": 147.3747099453,
		"y": -55.925759054,
		"h": 1.6593406593
	},
	{
		"stop_id": 8509367,
		"ID": 1543,
		"x": 147.9257539013,
		"y": -57.534817096,
		"h": 1.6593406593
	},
	{
		"stop_id": 8574920,
		"ID": 1543,
		"x": 147.3457094533,
		"y": -55.950778326,
		"h": 1.6593406593
	},
	{
		"stop_id": 8574921,
		"ID": 1543,
		"x": 148.3967297523,
		"y": -56.552807907,
		"h": 1.6593406593
	},
	{
		"stop_id": 8579983,
		"ID": 1543,
		"x": 148.0537329303,
		"y": -57.838750287,
		"h": 1.6593406593
	},
	{
		"stop_id": 8579984,
		"ID": 1543,
		"x": 147.4667159473,
		"y": -56.059752201,
		"h": 1.6593406593
	},
	{
		"stop_id": 8579985,
		"ID": 1543,
		"x": 147.8767498463,
		"y": -57.534831596,
		"h": 1.6593406593
	},
	{
		"stop_id": 8579988,
		"ID": 1543,
		"x": 147.5377407143,
		"y": -56.625813228,
		"h": 1.6593406593
	},
	{
		"stop_id": 8580023,
		"ID": 1543,
		"x": 147.2247651333,
		"y": -55.320800015,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583090,
		"ID": 1543,
		"x": 146.9147324513,
		"y": -54.860796556,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583092,
		"ID": 1543,
		"x": 146.4977499883,
		"y": -54.282856195,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583093,
		"ID": 1543,
		"x": 146.9667728613,
		"y": -55.008843036,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583094,
		"ID": 1543,
		"x": 146.9767563463,
		"y": -55.742839191,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583095,
		"ID": 1543,
		"x": 146.4877749203,
		"y": -54.548812113,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583096,
		"ID": 1543,
		"x": 147.1317439183,
		"y": -55.82385081,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583097,
		"ID": 1543,
		"x": 146.9707682973,
		"y": -55.170767858,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583098,
		"ID": 1543,
		"x": 146.9987505983,
		"y": -54.671835884,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583203,
		"ID": 1543,
		"x": 147.3767667383,
		"y": -56.084858453,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583444,
		"ID": 1543,
		"x": 146.8397283793,
		"y": -57.067818067,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583597,
		"ID": 1543,
		"x": 146.9727745503,
		"y": -55.39182362,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583713,
		"ID": 1543,
		"x": 147.1197137693,
		"y": -55.555754135,
		"h": 1.6593406593
	},
	{
		"stop_id": 8509368,
		"ID": 1542,
		"x": 148.7687331683,
		"y": -58.779840813,
		"h": 1.0989010989
	},
	{
		"stop_id": 8509369,
		"ID": 1542,
		"x": 150.7427510723,
		"y": -60.719859345,
		"h": 1.0989010989
	},
	{
		"stop_id": 8578641,
		"ID": 1542,
		"x": 150.6887133113,
		"y": -60.644766838,
		"h": 1.0989010989
	},
	{
		"stop_id": 8579986,
		"ID": 1542,
		"x": 148.7827016963,
		"y": -58.714845348,
		"h": 1.0989010989
	},
	{
		"stop_id": 8509372,
		"ID": 1505,
		"x": 134.5107621143,
		"y": -39.324844108,
		"h": 1
	},
	{
		"stop_id": 8509380,
		"ID": 1479,
		"x": 122.7287388503,
		"y": -34.976774413,
		"h": 1.2637362637
	},
	{
		"stop_id": 8509381,
		"ID": 1479,
		"x": 123.5547179573,
		"y": -37.437824349,
		"h": 1.2637362637
	},
	{
		"stop_id": 8509605,
		"ID": 1479,
		"x": 122.7097645903,
		"y": -34.951769511,
		"h": 1.2637362637
	},
	{
		"stop_id": 8509882,
		"ID": 1479,
		"x": 121.3767628983,
		"y": -34.201813285,
		"h": 1.2637362637
	},
	{
		"stop_id": 8574951,
		"ID": 1479,
		"x": 121.0957342193,
		"y": -34.70182738,
		"h": 1.2637362637
	},
	{
		"stop_id": 8574954,
		"ID": 1479,
		"x": 122.3797546793,
		"y": -32.467855993,
		"h": 1.2637362637
	},
	{
		"stop_id": 8574955,
		"ID": 1479,
		"x": 121.9037390013,
		"y": -34.453750241,
		"h": 1.2637362637
	},
	{
		"stop_id": 8574956,
		"ID": 1479,
		"x": 122.4937270953,
		"y": -34.520786611,
		"h": 1.2637362637
	},
	{
		"stop_id": 8583881,
		"ID": 1479,
		"x": 121.4847011893,
		"y": -34.427780923,
		"h": 1.2637362637
	},
	{
		"stop_id": 8509382,
		"ID": 1478,
		"x": 123.4207034733,
		"y": -39.047858475,
		"h": 1
	},
	{
		"stop_id": 8509400,
		"ID": 1425,
		"x": 101.4687729903,
		"y": 61.022146486,
		"h": 1.4285714286
	},
	{
		"stop_id": 8574170,
		"ID": 1425,
		"x": 103.9597381323,
		"y": 65.678164504,
		"h": 1.4285714286
	},
	{
		"stop_id": 8574171,
		"ID": 1425,
		"x": 103.4327057743,
		"y": 64.680180345,
		"h": 1.4285714286
	},
	{
		"stop_id": 8574176,
		"ID": 1425,
		"x": 102.4327540263,
		"y": 62.1812393,
		"h": 1.4285714286
	},
	{
		"stop_id": 8574178,
		"ID": 1425,
		"x": 101.4627514893,
		"y": 61.007190258,
		"h": 1.4285714286
	},
	{
		"stop_id": 8587487,
		"ID": 1425,
		"x": 101.2057156993,
		"y": 61.530177108,
		"h": 1.4285714286
	},
	{
		"stop_id": 8588225,
		"ID": 1425,
		"x": 102.8617261473,
		"y": 63.960214912,
		"h": 1.4285714286
	},
	{
		"stop_id": 8588226,
		"ID": 1425,
		"x": 102.7377400823,
		"y": 62.287245837,
		"h": 1.4285714286
	},
	{
		"stop_id": 8588227,
		"ID": 1425,
		"x": 102.7647588743,
		"y": 63.750234573,
		"h": 1.4285714286
	},
	{
		"stop_id": 8588228,
		"ID": 1425,
		"x": 102.8177314913,
		"y": 63.070223765,
		"h": 1.4285714286
	},
	{
		"stop_id": 8588229,
		"ID": 1425,
		"x": 102.9517609583,
		"y": 62.605208295,
		"h": 1.4285714286
	},
	{
		"stop_id": 8588230,
		"ID": 1425,
		"x": 102.2827318213,
		"y": 61.855147434,
		"h": 1.4285714286
	},
	{
		"stop_id": 8588231,
		"ID": 1425,
		"x": 101.6377382323,
		"y": 61.163212918,
		"h": 1.4285714286
	},
	{
		"stop_id": 8595700,
		"ID": 1425,
		"x": 103.8987484753,
		"y": 65.287194227,
		"h": 1.4285714286
	},
	{
		"stop_id": 8509401,
		"ID": 1403,
		"x": 98.9087644733,
		"y": 56.866201399,
		"h": 1.5274725275
	},
	{
		"stop_id": 8509623,
		"ID": 1403,
		"x": 98.2007079873,
		"y": 51.712149326,
		"h": 1.5274725275
	},
	{
		"stop_id": 8509690,
		"ID": 1403,
		"x": 96.5827337613,
		"y": 53.980193017,
		"h": 1.5274725275
	},
	{
		"stop_id": 8574314,
		"ID": 1403,
		"x": 95.9217298563,
		"y": 53.404178354,
		"h": 1.5274725275
	},
	{
		"stop_id": 8574372,
		"ID": 1403,
		"x": 98.3397584643,
		"y": 51.48218225,
		"h": 1.5274725275
	},
	{
		"stop_id": 8574373,
		"ID": 1403,
		"x": 98.4697637773,
		"y": 51.842207849,
		"h": 1.5274725275
	},
	{
		"stop_id": 8582414,
		"ID": 1403,
		"x": 101.1977596943,
		"y": 53.060193755,
		"h": 1.5274725275
	},
	{
		"stop_id": 8582415,
		"ID": 1403,
		"x": 98.5737735923,
		"y": 51.972213148,
		"h": 1.5274725275
	},
	{
		"stop_id": 8582567,
		"ID": 1403,
		"x": 100.7257385263,
		"y": 52.814189061,
		"h": 1.5274725275
	},
	{
		"stop_id": 8583547,
		"ID": 1403,
		"x": 98.1857083133,
		"y": 52.031166484,
		"h": 1.5274725275
	},
	{
		"stop_id": 8583548,
		"ID": 1403,
		"x": 98.4427332773,
		"y": 52.629241541,
		"h": 1.5274725275
	},
	{
		"stop_id": 8583549,
		"ID": 1403,
		"x": 98.2107415833,
		"y": 52.428211356,
		"h": 1.5274725275
	},
	{
		"stop_id": 8587405,
		"ID": 1403,
		"x": 98.6597637233,
		"y": 56.881235153,
		"h": 1.5274725275
	},
	{
		"stop_id": 8587447,
		"ID": 1403,
		"x": 97.4977580923,
		"y": 55.770169773,
		"h": 1.5274725275
	},
	{
		"stop_id": 8587496,
		"ID": 1403,
		"x": 99.3577518203,
		"y": 56.79025146,
		"h": 1.5274725275
	},
	{
		"stop_id": 8588235,
		"ID": 1403,
		"x": 96.7767641303,
		"y": 54.532162184,
		"h": 1.5274725275
	},
	{
		"stop_id": 8591470,
		"ID": 1403,
		"x": 96.1457198773,
		"y": 52.648222581,
		"h": 1.5274725275
	},
	{
		"stop_id": 8509402,
		"ID": 1378,
		"x": 96.4907276723,
		"y": 51.765223936,
		"h": 1.4285714286
	},
	{
		"stop_id": 8570047,
		"ID": 1378,
		"x": 94.3717066443,
		"y": 52.222214018,
		"h": 1.4285714286
	},
	{
		"stop_id": 8574305,
		"ID": 1378,
		"x": 92.4327096903,
		"y": 48.805189697,
		"h": 1.4285714286
	},
	{
		"stop_id": 8574306,
		"ID": 1378,
		"x": 92.7857724303,
		"y": 49.589183385,
		"h": 1.4285714286
	},
	{
		"stop_id": 8574307,
		"ID": 1378,
		"x": 92.7707619463,
		"y": 50.02620308,
		"h": 1.4285714286
	},
	{
		"stop_id": 8574308,
		"ID": 1378,
		"x": 93.0077313753,
		"y": 50.48015315,
		"h": 1.4285714286
	},
	{
		"stop_id": 8574309,
		"ID": 1378,
		"x": 93.3577023693,
		"y": 51.030224353,
		"h": 1.4285714286
	},
	{
		"stop_id": 8574310,
		"ID": 1378,
		"x": 93.6947277903,
		"y": 51.589214893,
		"h": 1.4285714286
	},
	{
		"stop_id": 8574311,
		"ID": 1378,
		"x": 94.2087735983,
		"y": 52.048160804,
		"h": 1.4285714286
	},
	{
		"stop_id": 8574312,
		"ID": 1378,
		"x": 94.7797726813,
		"y": 52.495178781,
		"h": 1.4285714286
	},
	{
		"stop_id": 8574313,
		"ID": 1378,
		"x": 95.4077093623,
		"y": 52.855214085,
		"h": 1.4285714286
	},
	{
		"stop_id": 8574316,
		"ID": 1378,
		"x": 96.4577169843,
		"y": 51.730211965,
		"h": 1.4285714286
	},
	{
		"stop_id": 8580492,
		"ID": 1378,
		"x": 93.6077262273,
		"y": 51.330171903,
		"h": 1.4285714286
	},
	{
		"stop_id": 8587566,
		"ID": 1378,
		"x": 96.3177435293,
		"y": 51.050225139,
		"h": 1.4285714286
	},
	{
		"stop_id": 8509404,
		"ID": 1377,
		"x": 94.9087268163,
		"y": 43.601140319,
		"h": 2.5494505495
	},
	{
		"stop_id": 8509635,
		"ID": 1377,
		"x": 92.5077288943,
		"y": 48.255158589,
		"h": 2.5494505495
	},
	{
		"stop_id": 8509780,
		"ID": 1377,
		"x": 92.0627628483,
		"y": 47.453157152,
		"h": 2.5494505495
	},
	{
		"stop_id": 8509781,
		"ID": 1377,
		"x": 92.2757156293,
		"y": 45.083204672,
		"h": 2.5494505495
	},
	{
		"stop_id": 8574034,
		"ID": 1377,
		"x": 91.2657157883,
		"y": 47.209198451,
		"h": 2.5494505495
	},
	{
		"stop_id": 8574035,
		"ID": 1377,
		"x": 91.2797353423,
		"y": 46.547172389,
		"h": 2.5494505495
	},
	{
		"stop_id": 8574036,
		"ID": 1377,
		"x": 92.1287053473,
		"y": 47.008210385,
		"h": 2.5494505495
	},
	{
		"stop_id": 8574037,
		"ID": 1377,
		"x": 92.1257223223,
		"y": 45.867200992,
		"h": 2.5494505495
	},
	{
		"stop_id": 8574039,
		"ID": 1377,
		"x": 93.7697710993,
		"y": 43.587194237,
		"h": 2.5494505495
	},
	{
		"stop_id": 8574040,
		"ID": 1377,
		"x": 94.3077477293,
		"y": 43.273141067,
		"h": 2.5494505495
	},
	{
		"stop_id": 8574317,
		"ID": 1377,
		"x": 91.7777678483,
		"y": 44.82815925,
		"h": 2.5494505495
	},
	{
		"stop_id": 8574319,
		"ID": 1377,
		"x": 91.3427239443,
		"y": 45.217227565,
		"h": 2.5494505495
	},
	{
		"stop_id": 8574320,
		"ID": 1377,
		"x": 91.0327158813,
		"y": 45.530202868,
		"h": 2.5494505495
	},
	{
		"stop_id": 8574321,
		"ID": 1377,
		"x": 90.8647298183,
		"y": 45.565201816,
		"h": 2.5494505495
	},
	{
		"stop_id": 8574322,
		"ID": 1377,
		"x": 90.8507132263,
		"y": 44.999222466,
		"h": 2.5494505495
	},
	{
		"stop_id": 8574324,
		"ID": 1377,
		"x": 90.5577301103,
		"y": 45.23024538,
		"h": 2.5494505495
	},
	{
		"stop_id": 8574384,
		"ID": 1377,
		"x": 95.2837273193,
		"y": 43.562194614,
		"h": 2.5494505495
	},
	{
		"stop_id": 8576317,
		"ID": 1377,
		"x": 92.1347646373,
		"y": 45.522227805,
		"h": 2.5494505495
	},
	{
		"stop_id": 8576362,
		"ID": 1377,
		"x": 93.4347266793,
		"y": 43.733250145,
		"h": 2.5494505495
	},
	{
		"stop_id": 8579727,
		"ID": 1377,
		"x": 92.7027228663,
		"y": 44.472238753,
		"h": 2.5494505495
	},
	{
		"stop_id": 8579728,
		"ID": 1377,
		"x": 92.9627750783,
		"y": 44.037176126,
		"h": 2.5494505495
	},
	{
		"stop_id": 8579996,
		"ID": 1377,
		"x": 91.5077429023,
		"y": 45.180164511,
		"h": 2.5494505495
	},
	{
		"stop_id": 8580497,
		"ID": 1377,
		"x": 92.6577416063,
		"y": 44.230198954,
		"h": 2.5494505495
	},
	{
		"stop_id": 8580681,
		"ID": 1377,
		"x": 92.1487018673,
		"y": 47.815239416,
		"h": 2.5494505495
	},
	{
		"stop_id": 8581988,
		"ID": 1377,
		"x": 94.4827477233,
		"y": 43.240198735,
		"h": 2.5494505495
	},
	{
		"stop_id": 8587568,
		"ID": 1377,
		"x": 94.1777449493,
		"y": 45.010150866,
		"h": 2.5494505495
	},
	{
		"stop_id": 8587569,
		"ID": 1377,
		"x": 94.3777705903,
		"y": 44.270203231,
		"h": 2.5494505495
	},
	{
		"stop_id": 8588220,
		"ID": 1377,
		"x": 93.9307013943,
		"y": 44.22715675,
		"h": 2.5494505495
	},
	{
		"stop_id": 8591449,
		"ID": 1377,
		"x": 94.6547286683,
		"y": 43.303160163,
		"h": 2.5494505495
	},
	{
		"stop_id": 8591450,
		"ID": 1377,
		"x": 94.2327571383,
		"y": 44.01321294,
		"h": 2.5494505495
	},
	{
		"stop_id": 8591454,
		"ID": 1377,
		"x": 94.2487451853,
		"y": 43.586234634,
		"h": 2.5494505495
	},
	{
		"stop_id": 8591455,
		"ID": 1377,
		"x": 94.5517710423,
		"y": 43.351200823,
		"h": 2.5494505495
	},
	{
		"stop_id": 8591456,
		"ID": 1377,
		"x": 94.3737588693,
		"y": 43.073222283,
		"h": 2.5494505495
	},
	{
		"stop_id": 8591459,
		"ID": 1377,
		"x": 94.9557484043,
		"y": 42.671173883,
		"h": 2.5494505495
	},
	{
		"stop_id": 8591461,
		"ID": 1377,
		"x": 94.4447362983,
		"y": 42.787242859,
		"h": 2.5494505495
	},
	{
		"stop_id": 8591463,
		"ID": 1377,
		"x": 94.6097567253,
		"y": 44.334164096,
		"h": 2.5494505495
	},
	{
		"stop_id": 8591464,
		"ID": 1377,
		"x": 94.4377731273,
		"y": 43.626165575,
		"h": 2.5494505495
	},
	{
		"stop_id": 8591466,
		"ID": 1377,
		"x": 94.7977097093,
		"y": 43.431211179,
		"h": 2.5494505495
	},
	{
		"stop_id": 8591467,
		"ID": 1377,
		"x": 94.6227330543,
		"y": 43.691242408,
		"h": 2.5494505495
	},
	{
		"stop_id": 8591776,
		"ID": 1377,
		"x": 91.7077462993,
		"y": 45.362195958,
		"h": 2.5494505495
	},
	{
		"stop_id": 8594205,
		"ID": 1377,
		"x": 94.1377626353,
		"y": 43.880189153,
		"h": 2.5494505495
	},
	{
		"stop_id": 8595369,
		"ID": 1377,
		"x": 94.8117514683,
		"y": 48.046178673,
		"h": 2.5494505495
	},
	{
		"stop_id": 8595370,
		"ID": 1377,
		"x": 92.9177426493,
		"y": 47.658230995,
		"h": 2.5494505495
	},
	{
		"stop_id": 8595371,
		"ID": 1377,
		"x": 93.4137227283,
		"y": 45.187152552,
		"h": 2.5494505495
	},
	{
		"stop_id": 8595372,
		"ID": 1377,
		"x": 92.8297285703,
		"y": 44.892211223,
		"h": 2.5494505495
	},
	{
		"stop_id": 8595373,
		"ID": 1377,
		"x": 92.8457460153,
		"y": 45.166206018,
		"h": 2.5494505495
	},
	{
		"stop_id": 8595947,
		"ID": 1377,
		"x": 94.8537249043,
		"y": 43.689236775,
		"h": 2.5494505495
	},
	{
		"stop_id": 8595948,
		"ID": 1377,
		"x": 94.9417585013,
		"y": 43.442185819,
		"h": 2.5494505495
	},
	{
		"stop_id": 8509406,
		"ID": 1376,
		"x": 96.1857239713,
		"y": 38.848197843,
		"h": 1.7912087912
	},
	{
		"stop_id": 8579695,
		"ID": 1376,
		"x": 95.5077178063,
		"y": 40.530245748,
		"h": 1.7912087912
	},
	{
		"stop_id": 8580882,
		"ID": 1376,
		"x": 95.6047508883,
		"y": 38.909182733,
		"h": 1.7912087912
	},
	{
		"stop_id": 8581989,
		"ID": 1376,
		"x": 95.7077598733,
		"y": 38.560218528,
		"h": 1.7912087912
	},
	{
		"stop_id": 8587407,
		"ID": 1376,
		"x": 95.3497542923,
		"y": 41.408155807,
		"h": 1.7912087912
	},
	{
		"stop_id": 8587408,
		"ID": 1376,
		"x": 95.6187281733,
		"y": 38.141180176,
		"h": 1.7912087912
	},
	{
		"stop_id": 8587570,
		"ID": 1376,
		"x": 94.8887376693,
		"y": 42.430211404,
		"h": 1.7912087912
	},
	{
		"stop_id": 8588177,
		"ID": 1376,
		"x": 96.1577304713,
		"y": 38.830226354,
		"h": 1.7912087912
	},
	{
		"stop_id": 8588197,
		"ID": 1376,
		"x": 96.2077699483,
		"y": 38.560178178,
		"h": 1.7912087912
	},
	{
		"stop_id": 8591452,
		"ID": 1376,
		"x": 95.1487159803,
		"y": 41.815183996,
		"h": 1.7912087912
	},
	{
		"stop_id": 8591453,
		"ID": 1376,
		"x": 95.0687253493,
		"y": 42.498174564,
		"h": 1.7912087912
	},
	{
		"stop_id": 8591458,
		"ID": 1376,
		"x": 94.5057498453,
		"y": 42.55516658,
		"h": 1.7912087912
	},
	{
		"stop_id": 8591460,
		"ID": 1376,
		"x": 94.7107697053,
		"y": 42.363195967,
		"h": 1.7912087912
	},
	{
		"stop_id": 8591462,
		"ID": 1376,
		"x": 95.4347174963,
		"y": 41.612223816,
		"h": 1.7912087912
	},
	{
		"stop_id": 8591465,
		"ID": 1376,
		"x": 95.2917514333,
		"y": 41.846158066,
		"h": 1.7912087912
	},
	{
		"stop_id": 8591469,
		"ID": 1376,
		"x": 95.0977367683,
		"y": 42.048182648,
		"h": 1.7912087912
	},
	{
		"stop_id": 8591775,
		"ID": 1376,
		"x": 95.4687581903,
		"y": 41.078176672,
		"h": 1.7912087912
	},
	{
		"stop_id": 8595254,
		"ID": 1376,
		"x": 94.1237389903,
		"y": 42.335189128,
		"h": 1.7912087912
	},
	{
		"stop_id": 8595255,
		"ID": 1376,
		"x": 93.3767417263,
		"y": 41.814229978,
		"h": 1.7912087912
	},
	{
		"stop_id": 8595256,
		"ID": 1376,
		"x": 93.1317052553,
		"y": 41.678141919,
		"h": 1.7912087912
	},
	{
		"stop_id": 8595257,
		"ID": 1376,
		"x": 92.7987121723,
		"y": 42.131233354,
		"h": 1.7912087912
	},
	{
		"stop_id": 8595258,
		"ID": 1376,
		"x": 92.2857407733,
		"y": 41.683148757,
		"h": 1.7912087912
	},
	{
		"stop_id": 8595259,
		"ID": 1376,
		"x": 91.6657729273,
		"y": 41.009185152,
		"h": 1.7912087912
	},
	{
		"stop_id": 8595976,
		"ID": 1376,
		"x": 95.3867619393,
		"y": 41.493198059,
		"h": 1.7912087912
	},
	{
		"stop_id": 8595977,
		"ID": 1376,
		"x": 95.2237141353,
		"y": 42.090166103,
		"h": 1.7912087912
	},
	{
		"stop_id": 8509411,
		"ID": 1374,
		"x": 92.7397294943,
		"y": 29.86119259,
		"h": 1.8241758242
	},
	{
		"stop_id": 8509678,
		"ID": 1374,
		"x": 91.8577215943,
		"y": 29.430220879,
		"h": 1.8241758242
	},
	{
		"stop_id": 8509959,
		"ID": 1374,
		"x": 93.2687740573,
		"y": 27.567162674,
		"h": 1.8241758242
	},
	{
		"stop_id": 8509964,
		"ID": 1374,
		"x": 91.7007347783,
		"y": 28.275222394,
		"h": 1.8241758242
	},
	{
		"stop_id": 8530499,
		"ID": 1374,
		"x": 91.7847502143,
		"y": 27.997223669,
		"h": 1.8241758242
	},
	{
		"stop_id": 8530503,
		"ID": 1374,
		"x": 94.9577618253,
		"y": 26.794249736,
		"h": 1.8241758242
	},
	{
		"stop_id": 8574412,
		"ID": 1374,
		"x": 92.3577549043,
		"y": 30.480207318,
		"h": 1.8241758242
	},
	{
		"stop_id": 8574413,
		"ID": 1374,
		"x": 92.4127143723,
		"y": 30.063241837,
		"h": 1.8241758242
	},
	{
		"stop_id": 8574561,
		"ID": 1374,
		"x": 94.9767649173,
		"y": 26.774169045,
		"h": 1.8241758242
	},
	{
		"stop_id": 8574614,
		"ID": 1374,
		"x": 92.6477113863,
		"y": 29.910217483,
		"h": 1.8241758242
	},
	{
		"stop_id": 8574616,
		"ID": 1374,
		"x": 92.1697053933,
		"y": 29.848191846,
		"h": 1.8241758242
	},
	{
		"stop_id": 8574617,
		"ID": 1374,
		"x": 91.9127682483,
		"y": 28.868238556,
		"h": 1.8241758242
	},
	{
		"stop_id": 8574618,
		"ID": 1374,
		"x": 91.7437071043,
		"y": 28.4961732,
		"h": 1.8241758242
	},
	{
		"stop_id": 8574619,
		"ID": 1374,
		"x": 91.8887644503,
		"y": 28.108185379,
		"h": 1.8241758242
	},
	{
		"stop_id": 8574622,
		"ID": 1374,
		"x": 93.0297109493,
		"y": 27.551245433,
		"h": 1.8241758242
	},
	{
		"stop_id": 8574624,
		"ID": 1374,
		"x": 93.0047761413,
		"y": 28.174154475,
		"h": 1.8241758242
	},
	{
		"stop_id": 8579884,
		"ID": 1374,
		"x": 91.5427414953,
		"y": 29.907197617,
		"h": 1.8241758242
	},
	{
		"stop_id": 8579886,
		"ID": 1374,
		"x": 91.9577083763,
		"y": 29.280186755,
		"h": 1.8241758242
	},
	{
		"stop_id": 8579888,
		"ID": 1374,
		"x": 91.5047477303,
		"y": 30.155229302,
		"h": 1.8241758242
	},
	{
		"stop_id": 8579890,
		"ID": 1374,
		"x": 91.7077339703,
		"y": 30.384247881,
		"h": 1.8241758242
	},
	{
		"stop_id": 8579891,
		"ID": 1374,
		"x": 93.1617353103,
		"y": 27.788168686,
		"h": 1.8241758242
	},
	{
		"stop_id": 8579893,
		"ID": 1374,
		"x": 91.9677591783,
		"y": 30.232167171,
		"h": 1.8241758242
	},
	{
		"stop_id": 8580770,
		"ID": 1374,
		"x": 92.3827378563,
		"y": 29.680140053,
		"h": 1.8241758242
	},
	{
		"stop_id": 8582474,
		"ID": 1374,
		"x": 95.6497037013,
		"y": 27.2361749,
		"h": 1.8241758242
	},
	{
		"stop_id": 8591778,
		"ID": 1374,
		"x": 92.7067339753,
		"y": 30.702202285,
		"h": 1.8241758242
	},
	{
		"stop_id": 8594789,
		"ID": 1374,
		"x": 92.1697093553,
		"y": 29.317169838,
		"h": 1.8241758242
	},
	{
		"stop_id": 8509412,
		"ID": 1350,
		"x": 90.6157191873,
		"y": 30.739150418,
		"h": 1.7582417582
	},
	{
		"stop_id": 8509673,
		"ID": 1350,
		"x": 90.2027092233,
		"y": 29.017141188,
		"h": 1.7582417582
	},
	{
		"stop_id": 8509675,
		"ID": 1350,
		"x": 89.0077298953,
		"y": 28.88021748,
		"h": 1.7582417582
	},
	{
		"stop_id": 8509963,
		"ID": 1350,
		"x": 89.9577009993,
		"y": 28.910228389,
		"h": 1.7582417582
	},
	{
		"stop_id": 8509978,
		"ID": 1350,
		"x": 90.5587236223,
		"y": 29.705144289,
		"h": 1.7582417582
	},
	{
		"stop_id": 8509979,
		"ID": 1350,
		"x": 90.6027465073,
		"y": 29.337155112,
		"h": 1.7582417582
	},
	{
		"stop_id": 8574821,
		"ID": 1350,
		"x": 90.9947128813,
		"y": 29.761195184,
		"h": 1.7582417582
	},
	{
		"stop_id": 8574822,
		"ID": 1350,
		"x": 90.8017417493,
		"y": 29.922240133,
		"h": 1.7582417582
	},
	{
		"stop_id": 8574823,
		"ID": 1350,
		"x": 90.4737083053,
		"y": 29.136173706,
		"h": 1.7582417582
	},
	{
		"stop_id": 8574824,
		"ID": 1350,
		"x": 90.4467042093,
		"y": 28.509170593,
		"h": 1.7582417582
	},
	{
		"stop_id": 8579880,
		"ID": 1350,
		"x": 90.0377513913,
		"y": 31.363151346,
		"h": 1.7582417582
	},
	{
		"stop_id": 8579881,
		"ID": 1350,
		"x": 90.3357146783,
		"y": 31.059154903,
		"h": 1.7582417582
	},
	{
		"stop_id": 8579882,
		"ID": 1350,
		"x": 91.1517678663,
		"y": 29.902178429,
		"h": 1.7582417582
	},
	{
		"stop_id": 8579883,
		"ID": 1350,
		"x": 90.7847719653,
		"y": 30.305146439,
		"h": 1.7582417582
	},
	{
		"stop_id": 8579885,
		"ID": 1350,
		"x": 90.5617264533,
		"y": 30.716213809,
		"h": 1.7582417582
	},
	{
		"stop_id": 8579889,
		"ID": 1350,
		"x": 89.3687046763,
		"y": 31.107161381,
		"h": 1.7582417582
	},
	{
		"stop_id": 8580033,
		"ID": 1350,
		"x": 89.6077151803,
		"y": 31.180206057,
		"h": 1.7582417582
	},
	{
		"stop_id": 8581608,
		"ID": 1350,
		"x": 90.5577532133,
		"y": 29.451231808,
		"h": 1.7582417582
	},
	{
		"stop_id": 8581772,
		"ID": 1350,
		"x": 91.2807644353,
		"y": 30.046235991,
		"h": 1.7582417582
	},
	{
		"stop_id": 8582000,
		"ID": 1350,
		"x": 89.0857068523,
		"y": 31.459175665,
		"h": 1.7582417582
	},
	{
		"stop_id": 8582099,
		"ID": 1350,
		"x": 86.9987023413,
		"y": 33.932143466,
		"h": 1.7582417582
	},
	{
		"stop_id": 8589891,
		"ID": 1350,
		"x": 91.3577552083,
		"y": 30.676182645,
		"h": 1.7582417582
	},
	{
		"stop_id": 8589893,
		"ID": 1350,
		"x": 90.6667360683,
		"y": 30.937165633,
		"h": 1.7582417582
	},
	{
		"stop_id": 8594790,
		"ID": 1350,
		"x": 88.7947393033,
		"y": 32.58923651,
		"h": 1.7582417582
	},
	{
		"stop_id": 8509413,
		"ID": 1328,
		"x": 85.1957303843,
		"y": 35.37215711,
		"h": 2.1208791209
	},
	{
		"stop_id": 8509466,
		"ID": 1328,
		"x": 84.3367615133,
		"y": 33.802204848,
		"h": 2.1208791209
	},
	{
		"stop_id": 8509467,
		"ID": 1328,
		"x": 85.0997366073,
		"y": 33.436159768,
		"h": 2.1208791209
	},
	{
		"stop_id": 8509470,
		"ID": 1328,
		"x": 81.4137222643,
		"y": 34.558238692,
		"h": 2.1208791209
	},
	{
		"stop_id": 8509650,
		"ID": 1328,
		"x": 84.7917412683,
		"y": 34.811196286,
		"h": 2.1208791209
	},
	{
		"stop_id": 8509651,
		"ID": 1328,
		"x": 83.0187686003,
		"y": 34.863173035,
		"h": 2.1208791209
	},
	{
		"stop_id": 8509652,
		"ID": 1328,
		"x": 83.8377073373,
		"y": 34.608184251,
		"h": 2.1208791209
	},
	{
		"stop_id": 8509654,
		"ID": 1328,
		"x": 82.4157744973,
		"y": 34.111232045,
		"h": 2.1208791209
	},
	{
		"stop_id": 8509656,
		"ID": 1328,
		"x": 83.5257161493,
		"y": 34.519155838,
		"h": 2.1208791209
	},
	{
		"stop_id": 8509782,
		"ID": 1328,
		"x": 81.9857168363,
		"y": 35.419210077,
		"h": 2.1208791209
	},
	{
		"stop_id": 8509890,
		"ID": 1328,
		"x": 81.7857614193,
		"y": 34.563177027,
		"h": 2.1208791209
	},
	{
		"stop_id": 8530496,
		"ID": 1328,
		"x": 81.8547193913,
		"y": 34.461173047,
		"h": 2.1208791209
	},
	{
		"stop_id": 8530497,
		"ID": 1328,
		"x": 80.8517428943,
		"y": 33.462143974,
		"h": 2.1208791209
	},
	{
		"stop_id": 8530498,
		"ID": 1328,
		"x": 80.8577011743,
		"y": 33.467177626,
		"h": 2.1208791209
	},
	{
		"stop_id": 8574768,
		"ID": 1328,
		"x": 86.0577213003,
		"y": 33.664154603,
		"h": 2.1208791209
	},
	{
		"stop_id": 8574769,
		"ID": 1328,
		"x": 86.2087346143,
		"y": 33.320220505,
		"h": 2.1208791209
	},
	{
		"stop_id": 8574770,
		"ID": 1328,
		"x": 86.0857088443,
		"y": 33.160183034,
		"h": 2.1208791209
	},
	{
		"stop_id": 8574771,
		"ID": 1328,
		"x": 85.2587169253,
		"y": 33.081164841,
		"h": 2.1208791209
	},
	{
		"stop_id": 8574772,
		"ID": 1328,
		"x": 84.6187113173,
		"y": 33.270238259,
		"h": 2.1208791209
	},
	{
		"stop_id": 8574773,
		"ID": 1328,
		"x": 84.3137133933,
		"y": 33.662194799,
		"h": 2.1208791209
	},
	{
		"stop_id": 8574775,
		"ID": 1328,
		"x": 85.3877168163,
		"y": 33.374222004,
		"h": 2.1208791209
	},
	{
		"stop_id": 8574776,
		"ID": 1328,
		"x": 85.1957564323,
		"y": 35.349249118,
		"h": 2.1208791209
	},
	{
		"stop_id": 8574777,
		"ID": 1328,
		"x": 84.8927158313,
		"y": 34.603245113,
		"h": 2.1208791209
	},
	{
		"stop_id": 8574778,
		"ID": 1328,
		"x": 84.1877402253,
		"y": 34.785223174,
		"h": 2.1208791209
	},
	{
		"stop_id": 8574779,
		"ID": 1328,
		"x": 83.2577349483,
		"y": 35.086203524,
		"h": 2.1208791209
	},
	{
		"stop_id": 8581480,
		"ID": 1328,
		"x": 84.9827260583,
		"y": 34.584191564,
		"h": 2.1208791209
	},
	{
		"stop_id": 8582091,
		"ID": 1328,
		"x": 85.6867020783,
		"y": 35.266249457,
		"h": 2.1208791209
	},
	{
		"stop_id": 8582098,
		"ID": 1328,
		"x": 86.2077529403,
		"y": 34.510223024,
		"h": 2.1208791209
	},
	{
		"stop_id": 8583714,
		"ID": 1328,
		"x": 82.4687277463,
		"y": 34.559208682,
		"h": 2.1208791209
	},
	{
		"stop_id": 8583715,
		"ID": 1328,
		"x": 81.1127234403,
		"y": 34.719142042,
		"h": 2.1208791209
	},
	{
		"stop_id": 8583716,
		"ID": 1328,
		"x": 82.1077542323,
		"y": 34.48821287,
		"h": 2.1208791209
	},
	{
		"stop_id": 8588539,
		"ID": 1328,
		"x": 84.8077709203,
		"y": 36.750143179,
		"h": 2.1208791209
	},
	{
		"stop_id": 8588540,
		"ID": 1328,
		"x": 85.0487546073,
		"y": 36.416150898,
		"h": 2.1208791209
	},
	{
		"stop_id": 8588541,
		"ID": 1328,
		"x": 85.6087110053,
		"y": 35.493209284,
		"h": 2.1208791209
	},
	{
		"stop_id": 8595404,
		"ID": 1328,
		"x": 84.9477564833,
		"y": 34.604248619,
		"h": 2.1208791209
	},
	{
		"stop_id": 8509414,
		"ID": 1329,
		"x": 82.4817142093,
		"y": 37.89324988,
		"h": 1.4285714286
	},
	{
		"stop_id": 8530665,
		"ID": 1329,
		"x": 81.6157097563,
		"y": 38.745140581,
		"h": 1.4285714286
	},
	{
		"stop_id": 8578567,
		"ID": 1329,
		"x": 82.4127044023,
		"y": 37.903166606,
		"h": 1.4285714286
	},
	{
		"stop_id": 8578569,
		"ID": 1329,
		"x": 82.7177342793,
		"y": 38.650205946,
		"h": 1.4285714286
	},
	{
		"stop_id": 8578571,
		"ID": 1329,
		"x": 81.1647559753,
		"y": 39.6702443,
		"h": 1.4285714286
	},
	{
		"stop_id": 8578572,
		"ID": 1329,
		"x": 80.7557112043,
		"y": 39.790237272,
		"h": 1.4285714286
	},
	{
		"stop_id": 8578573,
		"ID": 1329,
		"x": 80.4867022923,
		"y": 39.684139177,
		"h": 1.4285714286
	},
	{
		"stop_id": 8582012,
		"ID": 1329,
		"x": 84.1597404873,
		"y": 37.451170445,
		"h": 1.4285714286
	},
	{
		"stop_id": 8588536,
		"ID": 1329,
		"x": 83.0477190513,
		"y": 38.205169971,
		"h": 1.4285714286
	},
	{
		"stop_id": 8588537,
		"ID": 1329,
		"x": 83.4777085383,
		"y": 37.890222551,
		"h": 1.4285714286
	},
	{
		"stop_id": 8588538,
		"ID": 1329,
		"x": 84.0677460483,
		"y": 37.730189356,
		"h": 1.4285714286
	},
	{
		"stop_id": 8595381,
		"ID": 1329,
		"x": 82.6247459503,
		"y": 38.365182354,
		"h": 1.4285714286
	},
	{
		"stop_id": 8595382,
		"ID": 1329,
		"x": 82.0627104783,
		"y": 38.568170768,
		"h": 1.4285714286
	},
	{
		"stop_id": 8595383,
		"ID": 1329,
		"x": 81.7077108373,
		"y": 38.623220683,
		"h": 1.4285714286
	},
	{
		"stop_id": 8509415,
		"ID": 1303,
		"x": 79.7557440483,
		"y": 37.063196854,
		"h": 1.4285714286
	},
	{
		"stop_id": 8509416,
		"ID": 1303,
		"x": 78.0997199653,
		"y": 37.121142847,
		"h": 1.4285714286
	},
	{
		"stop_id": 8509450,
		"ID": 1303,
		"x": 78.1087063473,
		"y": 37.064191986,
		"h": 1.4285714286
	},
	{
		"stop_id": 8509451,
		"ID": 1303,
		"x": 78.2947031273,
		"y": 35.895187294,
		"h": 1.4285714286
	},
	{
		"stop_id": 8509452,
		"ID": 1303,
		"x": 80.3927387243,
		"y": 34.919226414,
		"h": 1.4285714286
	},
	{
		"stop_id": 8530493,
		"ID": 1303,
		"x": 80.1157257483,
		"y": 34.937178618,
		"h": 1.4285714286
	},
	{
		"stop_id": 8530494,
		"ID": 1303,
		"x": 80.0947403723,
		"y": 34.744190687,
		"h": 1.4285714286
	},
	{
		"stop_id": 8530663,
		"ID": 1303,
		"x": 77.9797401763,
		"y": 37.188201856,
		"h": 1.4285714286
	},
	{
		"stop_id": 8530664,
		"ID": 1303,
		"x": 79.8447307673,
		"y": 37.069175146,
		"h": 1.4285714286
	},
	{
		"stop_id": 8530841,
		"ID": 1303,
		"x": 80.0486998693,
		"y": 34.777249464,
		"h": 1.4285714286
	},
	{
		"stop_id": 8580592,
		"ID": 1303,
		"x": 80.0767650883,
		"y": 34.798147606,
		"h": 1.4285714286
	},
	{
		"stop_id": 8583717,
		"ID": 1303,
		"x": 80.6507654353,
		"y": 34.78218387,
		"h": 1.4285714286
	},
	{
		"stop_id": 8595374,
		"ID": 1303,
		"x": 79.8207329893,
		"y": 37.011230681,
		"h": 1.4285714286
	},
	{
		"stop_id": 8595380,
		"ID": 1303,
		"x": 78.0977063483,
		"y": 37.103192338,
		"h": 1.4285714286
	},
	{
		"stop_id": 8509417,
		"ID": 1275,
		"x": 75.0677067223,
		"y": 36.976195247,
		"h": 1.4945054945
	},
	{
		"stop_id": 8509418,
		"ID": 1275,
		"x": 71.8677342283,
		"y": 37.423229651,
		"h": 1.4945054945
	},
	{
		"stop_id": 8509992,
		"ID": 1275,
		"x": 71.8577481803,
		"y": 40.695241252,
		"h": 1.4945054945
	},
	{
		"stop_id": 8530660,
		"ID": 1275,
		"x": 71.9657736453,
		"y": 37.476217423,
		"h": 1.4945054945
	},
	{
		"stop_id": 8530661,
		"ID": 1275,
		"x": 75.1027524583,
		"y": 38.726214286,
		"h": 1.4945054945
	},
	{
		"stop_id": 8530662,
		"ID": 1275,
		"x": 76.1197680073,
		"y": 38.814178558,
		"h": 1.4945054945
	},
	{
		"stop_id": 8530666,
		"ID": 1275,
		"x": 74.7747702413,
		"y": 36.975239571,
		"h": 1.4945054945
	},
	{
		"stop_id": 8530856,
		"ID": 1275,
		"x": 75.2807509133,
		"y": 37.159171182,
		"h": 1.4945054945
	},
	{
		"stop_id": 8573898,
		"ID": 1275,
		"x": 72.2577056933,
		"y": 37.230145068,
		"h": 1.4945054945
	},
	{
		"stop_id": 8573899,
		"ID": 1275,
		"x": 72.6327275413,
		"y": 37.130162698,
		"h": 1.4945054945
	},
	{
		"stop_id": 8573900,
		"ID": 1275,
		"x": 71.8827382403,
		"y": 37.280222465,
		"h": 1.4945054945
	},
	{
		"stop_id": 8573901,
		"ID": 1275,
		"x": 71.8077309773,
		"y": 37.380202587,
		"h": 1.4945054945
	},
	{
		"stop_id": 8578501,
		"ID": 1275,
		"x": 71.1727371873,
		"y": 41.106142913,
		"h": 1.4945054945
	},
	{
		"stop_id": 8578502,
		"ID": 1275,
		"x": 71.3077495173,
		"y": 40.728247892,
		"h": 1.4945054945
	},
	{
		"stop_id": 8589107,
		"ID": 1275,
		"x": 71.9277112233,
		"y": 37.330145873,
		"h": 1.4945054945
	},
	{
		"stop_id": 8595375,
		"ID": 1275,
		"x": 75.0937202763,
		"y": 36.957212729,
		"h": 1.4945054945
	},
	{
		"stop_id": 8509440,
		"ID": 1373,
		"x": 90.7707157473,
		"y": 22.455211481,
		"h": 1.3956043956
	},
	{
		"stop_id": 8509453,
		"ID": 1373,
		"x": 95.7857354663,
		"y": 23.138200711,
		"h": 1.3956043956
	},
	{
		"stop_id": 8509454,
		"ID": 1373,
		"x": 95.9497469753,
		"y": 23.549170875,
		"h": 1.3956043956
	},
	{
		"stop_id": 8509455,
		"ID": 1373,
		"x": 96.3797022063,
		"y": 21.548185379,
		"h": 1.3956043956
	},
	{
		"stop_id": 8509458,
		"ID": 1373,
		"x": 95.2207492163,
		"y": 20.50820569,
		"h": 1.3956043956
	},
	{
		"stop_id": 8509974,
		"ID": 1373,
		"x": 95.7477252213,
		"y": 21.600190374,
		"h": 1.3956043956
	},
	{
		"stop_id": 8530505,
		"ID": 1373,
		"x": 94.3747034983,
		"y": 23.694214775,
		"h": 1.3956043956
	},
	{
		"stop_id": 8574556,
		"ID": 1373,
		"x": 95.4567030373,
		"y": 21.35718603,
		"h": 1.3956043956
	},
	{
		"stop_id": 8574558,
		"ID": 1373,
		"x": 95.7837445783,
		"y": 21.509159255,
		"h": 1.3956043956
	},
	{
		"stop_id": 8574559,
		"ID": 1373,
		"x": 96.3867159753,
		"y": 21.728194084,
		"h": 1.3956043956
	},
	{
		"stop_id": 8574572,
		"ID": 1373,
		"x": 96.4587021903,
		"y": 22.738190337,
		"h": 1.3956043956
	},
	{
		"stop_id": 8581602,
		"ID": 1373,
		"x": 96.2077114893,
		"y": 21.980184129,
		"h": 1.3956043956
	},
	{
		"stop_id": 8581668,
		"ID": 1373,
		"x": 95.6007114063,
		"y": 22.586231884,
		"h": 1.3956043956
	},
	{
		"stop_id": 8509457,
		"ID": 1397,
		"x": 95.4297654573,
		"y": 19.693251519,
		"h": 1.4285714286
	},
	{
		"stop_id": 8509459,
		"ID": 1397,
		"x": 95.8787642233,
		"y": 19.172250911,
		"h": 1.4285714286
	},
	{
		"stop_id": 8509468,
		"ID": 1397,
		"x": 95.9767261323,
		"y": 20.257198422,
		"h": 1.4285714286
	},
	{
		"stop_id": 8509720,
		"ID": 1397,
		"x": 99.8827488793,
		"y": 17.005162775,
		"h": 1.4285714286
	},
	{
		"stop_id": 8573157,
		"ID": 1397,
		"x": 100.1117545793,
		"y": 16.843249573,
		"h": 1.4285714286
	},
	{
		"stop_id": 8574573,
		"ID": 1397,
		"x": 96.1007327193,
		"y": 20.643215423,
		"h": 1.4285714286
	},
	{
		"stop_id": 8574708,
		"ID": 1397,
		"x": 100.0467499513,
		"y": 17.305144807,
		"h": 1.4285714286
	},
	{
		"stop_id": 8580198,
		"ID": 1397,
		"x": 100.1467607853,
		"y": 16.87321246,
		"h": 1.4285714286
	},
	{
		"stop_id": 8580953,
		"ID": 1397,
		"x": 100.5627421583,
		"y": 21.502166303,
		"h": 1.4285714286
	},
	{
		"stop_id": 8580954,
		"ID": 1397,
		"x": 100.4417595013,
		"y": 21.684195455,
		"h": 1.4285714286
	},
	{
		"stop_id": 8580955,
		"ID": 1397,
		"x": 100.3977167073,
		"y": 21.504185932,
		"h": 1.4285714286
	},
	{
		"stop_id": 8580956,
		"ID": 1397,
		"x": 100.3267042343,
		"y": 21.26517886,
		"h": 1.4285714286
	},
	{
		"stop_id": 8580957,
		"ID": 1397,
		"x": 100.4847088073,
		"y": 20.881181054,
		"h": 1.4285714286
	},
	{
		"stop_id": 8582407,
		"ID": 1397,
		"x": 100.4037367753,
		"y": 20.610210968,
		"h": 1.4285714286
	},
	{
		"stop_id": 8509462,
		"ID": 1245,
		"x": 68.6877223633,
		"y": 40.350181306,
		"h": 1.3956043956
	},
	{
		"stop_id": 8509463,
		"ID": 1245,
		"x": 70.4427450523,
		"y": 41.140162936,
		"h": 1.3956043956
	},
	{
		"stop_id": 8509464,
		"ID": 1245,
		"x": 68.7227502513,
		"y": 39.940160793,
		"h": 1.3956043956
	},
	{
		"stop_id": 8509465,
		"ID": 1245,
		"x": 70.7377401663,
		"y": 41.11015205,
		"h": 1.3956043956
	},
	{
		"stop_id": 8509990,
		"ID": 1245,
		"x": 69.3857362853,
		"y": 40.835227929,
		"h": 1.3956043956
	},
	{
		"stop_id": 8530491,
		"ID": 1245,
		"x": 69.5347706213,
		"y": 40.924201238,
		"h": 1.3956043956
	},
	{
		"stop_id": 8530492,
		"ID": 1245,
		"x": 69.7437301123,
		"y": 42.250157518,
		"h": 1.3956043956
	},
	{
		"stop_id": 8578495,
		"ID": 1245,
		"x": 68.3777428033,
		"y": 40.120206214,
		"h": 1.3956043956
	},
	{
		"stop_id": 8578496,
		"ID": 1245,
		"x": 69.0307683713,
		"y": 40.625146962,
		"h": 1.3956043956
	},
	{
		"stop_id": 8578497,
		"ID": 1245,
		"x": 69.1777417483,
		"y": 40.890209496,
		"h": 1.3956043956
	},
	{
		"stop_id": 8578498,
		"ID": 1245,
		"x": 69.9277611553,
		"y": 40.815214432,
		"h": 1.3956043956
	},
	{
		"stop_id": 8578499,
		"ID": 1245,
		"x": 70.3877500563,
		"y": 40.630210778,
		"h": 1.3956043956
	},
	{
		"stop_id": 8578500,
		"ID": 1245,
		"x": 70.3107551373,
		"y": 40.810230901,
		"h": 1.3956043956
	},
	{
		"stop_id": 8509469,
		"ID": 1352,
		"x": 87.2827307083,
		"y": 42.780232104,
		"h": 1.1648351648
	},
	{
		"stop_id": 8574323,
		"ID": 1352,
		"x": 90.6437239223,
		"y": 44.726184222,
		"h": 1.1648351648
	},
	{
		"stop_id": 8574326,
		"ID": 1352,
		"x": 90.0127549563,
		"y": 44.495172582,
		"h": 1.1648351648
	},
	{
		"stop_id": 8574328,
		"ID": 1352,
		"x": 88.9327084963,
		"y": 43.580156683,
		"h": 1.1648351648
	},
	{
		"stop_id": 8574329,
		"ID": 1352,
		"x": 87.6897456433,
		"y": 43.000162316,
		"h": 1.1648351648
	},
	{
		"stop_id": 8574330,
		"ID": 1352,
		"x": 89.7077274933,
		"y": 43.830238517,
		"h": 1.1648351648
	},
	{
		"stop_id": 8509600,
		"ID": 1574,
		"x": 163.4197179203,
		"y": 6.602246865,
		"h": 1.1648351648
	},
	{
		"stop_id": 8509704,
		"ID": 1574,
		"x": 163.1447295803,
		"y": 7.034195847,
		"h": 1.1648351648
	},
	{
		"stop_id": 8574785,
		"ID": 1574,
		"x": 161.2057028583,
		"y": 6.57124057,
		"h": 1.1648351648
	},
	{
		"stop_id": 8574789,
		"ID": 1574,
		"x": 163.5907065523,
		"y": 6.862156584,
		"h": 1.1648351648
	},
	{
		"stop_id": 8581816,
		"ID": 1574,
		"x": 162.1517648083,
		"y": 6.680233591,
		"h": 1.1648351648
	},
	{
		"stop_id": 8583807,
		"ID": 1574,
		"x": 161.4437083263,
		"y": 6.603174233,
		"h": 1.1648351648
	},
	{
		"stop_id": 8509601,
		"ID": 1442,
		"x": 109.6967359003,
		"y": 16.933220789,
		"h": 1.1978021978
	},
	{
		"stop_id": 8509779,
		"ID": 1442,
		"x": 110.6197593483,
		"y": 18.097214298,
		"h": 1.1978021978
	},
	{
		"stop_id": 8575072,
		"ID": 1442,
		"x": 110.9187706293,
		"y": 18.406146914,
		"h": 1.1978021978
	},
	{
		"stop_id": 8575073,
		"ID": 1442,
		"x": 110.8987080023,
		"y": 18.255209692,
		"h": 1.1978021978
	},
	{
		"stop_id": 8575074,
		"ID": 1442,
		"x": 110.8027447893,
		"y": 18.281161628,
		"h": 1.1978021978
	},
	{
		"stop_id": 8575075,
		"ID": 1442,
		"x": 110.3957131193,
		"y": 17.811230428,
		"h": 1.1978021978
	},
	{
		"stop_id": 8575076,
		"ID": 1442,
		"x": 110.4107508083,
		"y": 17.43319275,
		"h": 1.1978021978
	},
	{
		"stop_id": 8509602,
		"ID": 1234,
		"x": 69.3647632723,
		"y": -22.697761222,
		"h": 1.032967033
	},
	{
		"stop_id": 8583599,
		"ID": 1234,
		"x": 71.1057550303,
		"y": -21.033828178,
		"h": 1.032967033
	},
	{
		"stop_id": 8509603,
		"ID": 1343,
		"x": 90.3467379023,
		"y": -9.480835157,
		"h": 1.3626373626
	},
	{
		"stop_id": 8509851,
		"ID": 1343,
		"x": 88.1337530033,
		"y": -10.170749673,
		"h": 1.3626373626
	},
	{
		"stop_id": 8509982,
		"ID": 1343,
		"x": 89.1497236923,
		"y": -10.131832914,
		"h": 1.3626373626
	},
	{
		"stop_id": 8574686,
		"ID": 1343,
		"x": 91.3837549093,
		"y": -8.978854924,
		"h": 1.3626373626
	},
	{
		"stop_id": 8574687,
		"ID": 1343,
		"x": 90.7447689513,
		"y": -8.519755131,
		"h": 1.3626373626
	},
	{
		"stop_id": 8574688,
		"ID": 1343,
		"x": 90.9377369783,
		"y": -9.33079794,
		"h": 1.3626373626
	},
	{
		"stop_id": 8574689,
		"ID": 1343,
		"x": 89.9187237553,
		"y": -9.57982256,
		"h": 1.3626373626
	},
	{
		"stop_id": 8574690,
		"ID": 1343,
		"x": 89.2537241153,
		"y": -9.820779666,
		"h": 1.3626373626
	},
	{
		"stop_id": 8574691,
		"ID": 1343,
		"x": 89.3547583283,
		"y": -10.052792306,
		"h": 1.3626373626
	},
	{
		"stop_id": 8574692,
		"ID": 1343,
		"x": 88.9977022783,
		"y": -9.728831316,
		"h": 1.3626373626
	},
	{
		"stop_id": 8580713,
		"ID": 1343,
		"x": 90.6067109043,
		"y": -8.856822459,
		"h": 1.3626373626
	},
	{
		"stop_id": 8582158,
		"ID": 1343,
		"x": 86.5227657543,
		"y": -11.168781428,
		"h": 1.3626373626
	},
	{
		"stop_id": 8509606,
		"ID": 1464,
		"x": 119.6157120373,
		"y": -37.523759534,
		"h": 1.3626373626
	},
	{
		"stop_id": 8509880,
		"ID": 1464,
		"x": 118.4497659713,
		"y": -37.562796099,
		"h": 1.3626373626
	},
	{
		"stop_id": 8509881,
		"ID": 1464,
		"x": 119.0527390953,
		"y": -37.820858056,
		"h": 1.3626373626
	},
	{
		"stop_id": 8530598,
		"ID": 1464,
		"x": 119.6467432113,
		"y": -37.545857197,
		"h": 1.3626373626
	},
	{
		"stop_id": 8530599,
		"ID": 1464,
		"x": 120.5017453513,
		"y": -38.656845773,
		"h": 1.3626373626
	},
	{
		"stop_id": 8530667,
		"ID": 1464,
		"x": 117.8567025623,
		"y": -38.048843174,
		"h": 1.3626373626
	},
	{
		"stop_id": 8530668,
		"ID": 1464,
		"x": 116.1237394823,
		"y": -38.943759426,
		"h": 1.3626373626
	},
	{
		"stop_id": 8530669,
		"ID": 1464,
		"x": 116.5907017533,
		"y": -40.175805884,
		"h": 1.3626373626
	},
	{
		"stop_id": 8530715,
		"ID": 1464,
		"x": 118.2357476043,
		"y": -38.530780982,
		"h": 1.3626373626
	},
	{
		"stop_id": 8574957,
		"ID": 1464,
		"x": 119.1077675823,
		"y": -37.319764593,
		"h": 1.3626373626
	},
	{
		"stop_id": 8574958,
		"ID": 1464,
		"x": 116.0977282933,
		"y": -38.829858672,
		"h": 1.3626373626
	},
	{
		"stop_id": 8580786,
		"ID": 1464,
		"x": 118.2457247033,
		"y": -37.368753211,
		"h": 1.3626373626
	},
	{
		"stop_id": 8509607,
		"ID": 1450,
		"x": 115.3107249673,
		"y": -33.487801307,
		"h": 1.032967033
	},
	{
		"stop_id": 8574512,
		"ID": 1450,
		"x": 112.7697207713,
		"y": -34.337817767,
		"h": 1.032967033
	},
	{
		"stop_id": 8509609,
		"ID": 1401,
		"x": 99.9747527073,
		"y": 40.846245884,
		"h": 2.1868131868
	},
	{
		"stop_id": 8509614,
		"ID": 1401,
		"x": 97.4747576403,
		"y": 41.613195307,
		"h": 2.1868131868
	},
	{
		"stop_id": 8509618,
		"ID": 1401,
		"x": 99.8907715553,
		"y": 39.74818938,
		"h": 2.1868131868
	},
	{
		"stop_id": 8509620,
		"ID": 1401,
		"x": 97.3627553753,
		"y": 42.145176199,
		"h": 2.1868131868
	},
	{
		"stop_id": 8509985,
		"ID": 1401,
		"x": 98.2627208983,
		"y": 40.343210143,
		"h": 2.1868131868
	},
	{
		"stop_id": 8509991,
		"ID": 1401,
		"x": 97.1827684413,
		"y": 43.64415415,
		"h": 2.1868131868
	},
	{
		"stop_id": 8574341,
		"ID": 1401,
		"x": 97.6797212153,
		"y": 43.838237857,
		"h": 2.1868131868
	},
	{
		"stop_id": 8574342,
		"ID": 1401,
		"x": 97.9497233463,
		"y": 44.081169026,
		"h": 2.1868131868
	},
	{
		"stop_id": 8574343,
		"ID": 1401,
		"x": 98.2927325533,
		"y": 45.077202431,
		"h": 2.1868131868
	},
	{
		"stop_id": 8574360,
		"ID": 1401,
		"x": 97.6617615003,
		"y": 43.614220491,
		"h": 2.1868131868
	},
	{
		"stop_id": 8574361,
		"ID": 1401,
		"x": 98.2147237163,
		"y": 43.96920367,
		"h": 2.1868131868
	},
	{
		"stop_id": 8574362,
		"ID": 1401,
		"x": 99.6387334853,
		"y": 45.250159034,
		"h": 2.1868131868
	},
	{
		"stop_id": 8574364,
		"ID": 1401,
		"x": 97.2167231723,
		"y": 44.452246872,
		"h": 2.1868131868
	},
	{
		"stop_id": 8574385,
		"ID": 1401,
		"x": 96.1987569253,
		"y": 43.760173371,
		"h": 2.1868131868
	},
	{
		"stop_id": 8574386,
		"ID": 1401,
		"x": 96.6437726603,
		"y": 43.663205702,
		"h": 2.1868131868
	},
	{
		"stop_id": 8574387,
		"ID": 1401,
		"x": 97.2017642823,
		"y": 43.249176585,
		"h": 2.1868131868
	},
	{
		"stop_id": 8574388,
		"ID": 1401,
		"x": 97.2247672043,
		"y": 42.800143734,
		"h": 2.1868131868
	},
	{
		"stop_id": 8574389,
		"ID": 1401,
		"x": 97.7517223773,
		"y": 41.070234637,
		"h": 2.1868131868
	},
	{
		"stop_id": 8574390,
		"ID": 1401,
		"x": 98.0067435253,
		"y": 40.867242286,
		"h": 2.1868131868
	},
	{
		"stop_id": 8574392,
		"ID": 1401,
		"x": 98.3027285843,
		"y": 39.854151726,
		"h": 2.1868131868
	},
	{
		"stop_id": 8574415,
		"ID": 1401,
		"x": 100.0717109523,
		"y": 40.005171547,
		"h": 2.1868131868
	},
	{
		"stop_id": 8574416,
		"ID": 1401,
		"x": 99.9527512783,
		"y": 40.453176744,
		"h": 2.1868131868
	},
	{
		"stop_id": 8579680,
		"ID": 1401,
		"x": 97.4377333813,
		"y": 43.642214293,
		"h": 2.1868131868
	},
	{
		"stop_id": 8579682,
		"ID": 1401,
		"x": 99.1077361233,
		"y": 44.282157622,
		"h": 2.1868131868
	},
	{
		"stop_id": 8580163,
		"ID": 1401,
		"x": 99.7447132573,
		"y": 45.412152247,
		"h": 2.1868131868
	},
	{
		"stop_id": 8580232,
		"ID": 1401,
		"x": 97.8227410373,
		"y": 43.896188146,
		"h": 2.1868131868
	},
	{
		"stop_id": 8580529,
		"ID": 1401,
		"x": 97.2037294173,
		"y": 44.048194212,
		"h": 2.1868131868
	},
	{
		"stop_id": 8580811,
		"ID": 1401,
		"x": 97.0737092853,
		"y": 44.880208522,
		"h": 2.1868131868
	},
	{
		"stop_id": 8581000,
		"ID": 1401,
		"x": 98.1927111603,
		"y": 40.63918293,
		"h": 2.1868131868
	},
	{
		"stop_id": 8581819,
		"ID": 1401,
		"x": 98.1187428473,
		"y": 40.604188893,
		"h": 2.1868131868
	},
	{
		"stop_id": 8581820,
		"ID": 1401,
		"x": 97.4107118743,
		"y": 40.456211232,
		"h": 2.1868131868
	},
	{
		"stop_id": 8581821,
		"ID": 1401,
		"x": 97.5907583603,
		"y": 39.734187566,
		"h": 2.1868131868
	},
	{
		"stop_id": 8582435,
		"ID": 1401,
		"x": 97.5727140303,
		"y": 43.448155593,
		"h": 2.1868131868
	},
	{
		"stop_id": 8582436,
		"ID": 1401,
		"x": 96.9217348033,
		"y": 43.597233086,
		"h": 2.1868131868
	},
	{
		"stop_id": 8582437,
		"ID": 1401,
		"x": 97.4847121653,
		"y": 43.179246331,
		"h": 2.1868131868
	},
	{
		"stop_id": 8582877,
		"ID": 1401,
		"x": 97.2887197933,
		"y": 42.455176975,
		"h": 2.1868131868
	},
	{
		"stop_id": 8583503,
		"ID": 1401,
		"x": 97.4397432673,
		"y": 44.722163761,
		"h": 2.1868131868
	},
	{
		"stop_id": 8509611,
		"ID": 1399,
		"x": 97.0767040523,
		"y": 32.011246002,
		"h": 1.3296703297
	},
	{
		"stop_id": 8574401,
		"ID": 1399,
		"x": 97.6787431783,
		"y": 33.304173711,
		"h": 1.3296703297
	},
	{
		"stop_id": 8574402,
		"ID": 1399,
		"x": 97.4857648593,
		"y": 32.970221878,
		"h": 1.3296703297
	},
	{
		"stop_id": 8574403,
		"ID": 1399,
		"x": 97.3447333213,
		"y": 32.642206485,
		"h": 1.3296703297
	},
	{
		"stop_id": 8574404,
		"ID": 1399,
		"x": 97.3837493433,
		"y": 32.390228291,
		"h": 1.3296703297
	},
	{
		"stop_id": 8574405,
		"ID": 1399,
		"x": 96.6747528753,
		"y": 31.76624479,
		"h": 1.3296703297
	},
	{
		"stop_id": 8574406,
		"ID": 1399,
		"x": 96.4507296293,
		"y": 31.812191667,
		"h": 1.3296703297
	},
	{
		"stop_id": 8574407,
		"ID": 1399,
		"x": 96.2427503903,
		"y": 31.96822127,
		"h": 1.3296703297
	},
	{
		"stop_id": 8574408,
		"ID": 1399,
		"x": 96.6297335303,
		"y": 32.323233484,
		"h": 1.3296703297
	},
	{
		"stop_id": 8582105,
		"ID": 1399,
		"x": 96.8427344233,
		"y": 32.661240438,
		"h": 1.3296703297
	},
	{
		"stop_id": 8583740,
		"ID": 1399,
		"x": 99.0757727383,
		"y": 28.255184898,
		"h": 1.3296703297
	},
	{
		"stop_id": 8509612,
		"ID": 1402,
		"x": 96.6127029093,
		"y": 48.319180508,
		"h": 2.9450549451
	},
	{
		"stop_id": 8509613,
		"ID": 1402,
		"x": 98.2077149703,
		"y": 48.574241121,
		"h": 2.9450549451
	},
	{
		"stop_id": 8509619,
		"ID": 1402,
		"x": 99.5947308623,
		"y": 49.31017021,
		"h": 2.9450549451
	},
	{
		"stop_id": 8509621,
		"ID": 1402,
		"x": 99.7627277663,
		"y": 47.187207243,
		"h": 2.9450549451
	},
	{
		"stop_id": 8509622,
		"ID": 1402,
		"x": 99.9527318863,
		"y": 45.755168339,
		"h": 2.9450549451
	},
	{
		"stop_id": 8509625,
		"ID": 1402,
		"x": 101.1057747663,
		"y": 48.531219929,
		"h": 2.9450549451
	},
	{
		"stop_id": 8509626,
		"ID": 1402,
		"x": 99.8817271093,
		"y": 50.811195269,
		"h": 2.9450549451
	},
	{
		"stop_id": 8574344,
		"ID": 1402,
		"x": 99.5797196353,
		"y": 46.843197839,
		"h": 2.9450549451
	},
	{
		"stop_id": 8574345,
		"ID": 1402,
		"x": 98.5457724153,
		"y": 48.051179253,
		"h": 2.9450549451
	},
	{
		"stop_id": 8574346,
		"ID": 1402,
		"x": 98.1027651163,
		"y": 48.317211109,
		"h": 2.9450549451
	},
	{
		"stop_id": 8574347,
		"ID": 1402,
		"x": 98.5357693543,
		"y": 48.435165715,
		"h": 2.9450549451
	},
	{
		"stop_id": 8574348,
		"ID": 1402,
		"x": 99.2417716993,
		"y": 49.027229776,
		"h": 2.9450549451
	},
	{
		"stop_id": 8574349,
		"ID": 1402,
		"x": 99.3577450853,
		"y": 49.170245995,
		"h": 2.9450549451
	},
	{
		"stop_id": 8574350,
		"ID": 1402,
		"x": 99.9067486383,
		"y": 49.260159111,
		"h": 2.9450549451
	},
	{
		"stop_id": 8574351,
		"ID": 1402,
		"x": 100.3257352273,
		"y": 48.584221796,
		"h": 2.9450549451
	},
	{
		"stop_id": 8574352,
		"ID": 1402,
		"x": 100.5537047623,
		"y": 48.255159095,
		"h": 2.9450549451
	},
	{
		"stop_id": 8574363,
		"ID": 1402,
		"x": 99.9477293293,
		"y": 45.6591653,
		"h": 2.9450549451
	},
	{
		"stop_id": 8574365,
		"ID": 1402,
		"x": 96.5747215063,
		"y": 46.928211492,
		"h": 2.9450549451
	},
	{
		"stop_id": 8574367,
		"ID": 1402,
		"x": 97.1757110523,
		"y": 49.191166077,
		"h": 2.9450549451
	},
	{
		"stop_id": 8574370,
		"ID": 1402,
		"x": 97.9197723753,
		"y": 51.213214561,
		"h": 2.9450549451
	},
	{
		"stop_id": 8574371,
		"ID": 1402,
		"x": 98.2967036063,
		"y": 51.13615155,
		"h": 2.9450549451
	},
	{
		"stop_id": 8574374,
		"ID": 1402,
		"x": 99.0447725023,
		"y": 50.381145169,
		"h": 2.9450549451
	},
	{
		"stop_id": 8574375,
		"ID": 1402,
		"x": 99.2737007943,
		"y": 50.458227218,
		"h": 2.9450549451
	},
	{
		"stop_id": 8574376,
		"ID": 1402,
		"x": 99.3007047553,
		"y": 50.287230593,
		"h": 2.9450549451
	},
	{
		"stop_id": 8574377,
		"ID": 1402,
		"x": 99.9877228563,
		"y": 49.74023785,
		"h": 2.9450549451
	},
	{
		"stop_id": 8574378,
		"ID": 1402,
		"x": 99.7377635433,
		"y": 49.946168839,
		"h": 2.9450549451
	},
	{
		"stop_id": 8574379,
		"ID": 1402,
		"x": 99.9937096313,
		"y": 50.433174016,
		"h": 2.9450549451
	},
	{
		"stop_id": 8574380,
		"ID": 1402,
		"x": 99.1147204343,
		"y": 50.162249388,
		"h": 2.9450549451
	},
	{
		"stop_id": 8574382,
		"ID": 1402,
		"x": 97.4957092593,
		"y": 49.520153439,
		"h": 2.9450549451
	},
	{
		"stop_id": 8574383,
		"ID": 1402,
		"x": 97.4317588603,
		"y": 48.257158846,
		"h": 2.9450549451
	},
	{
		"stop_id": 8574425,
		"ID": 1402,
		"x": 99.0457588693,
		"y": 47.824182073,
		"h": 2.9450549451
	},
	{
		"stop_id": 8576755,
		"ID": 1402,
		"x": 99.6217153633,
		"y": 47.397182261,
		"h": 2.9450549451
	},
	{
		"stop_id": 8579675,
		"ID": 1402,
		"x": 97.6067213153,
		"y": 50.775169197,
		"h": 2.9450549451
	},
	{
		"stop_id": 8579676,
		"ID": 1402,
		"x": 96.6327060143,
		"y": 48.987223412,
		"h": 2.9450549451
	},
	{
		"stop_id": 8579677,
		"ID": 1402,
		"x": 97.2007163833,
		"y": 50.077218961,
		"h": 2.9450549451
	},
	{
		"stop_id": 8579678,
		"ID": 1402,
		"x": 99.0927086233,
		"y": 48.863200893,
		"h": 2.9450549451
	},
	{
		"stop_id": 8579679,
		"ID": 1402,
		"x": 99.4727198943,
		"y": 46.519247893,
		"h": 2.9450549451
	},
	{
		"stop_id": 8579683,
		"ID": 1402,
		"x": 97.9297028393,
		"y": 49.786232915,
		"h": 2.9450549451
	},
	{
		"stop_id": 8580200,
		"ID": 1402,
		"x": 96.9027550203,
		"y": 48.410233086,
		"h": 2.9450549451
	},
	{
		"stop_id": 8580206,
		"ID": 1402,
		"x": 97.7367739153,
		"y": 49.667228729,
		"h": 2.9450549451
	},
	{
		"stop_id": 8580488,
		"ID": 1402,
		"x": 96.5797035593,
		"y": 48.012247038,
		"h": 2.9450549451
	},
	{
		"stop_id": 8580490,
		"ID": 1402,
		"x": 97.8737085133,
		"y": 48.244177533,
		"h": 2.9450549451
	},
	{
		"stop_id": 8580498,
		"ID": 1402,
		"x": 95.5427639463,
		"y": 48.137196307,
		"h": 2.9450549451
	},
	{
		"stop_id": 8580500,
		"ID": 1402,
		"x": 99.9967412863,
		"y": 47.787170003,
		"h": 2.9450549451
	},
	{
		"stop_id": 8580526,
		"ID": 1402,
		"x": 96.8887353223,
		"y": 48.890204428,
		"h": 2.9450549451
	},
	{
		"stop_id": 8581004,
		"ID": 1402,
		"x": 97.6847645863,
		"y": 50.340155949,
		"h": 2.9450549451
	},
	{
		"stop_id": 8581005,
		"ID": 1402,
		"x": 97.5657373943,
		"y": 49.897140623,
		"h": 2.9450549451
	},
	{
		"stop_id": 8581006,
		"ID": 1402,
		"x": 97.8277000533,
		"y": 50.652239451,
		"h": 2.9450549451
	},
	{
		"stop_id": 8581007,
		"ID": 1402,
		"x": 96.7827094313,
		"y": 49.618209444,
		"h": 2.9450549451
	},
	{
		"stop_id": 8581008,
		"ID": 1402,
		"x": 99.2467745293,
		"y": 51.209225745,
		"h": 2.9450549451
	},
	{
		"stop_id": 8581010,
		"ID": 1402,
		"x": 99.6617053513,
		"y": 50.527240859,
		"h": 2.9450549451
	},
	{
		"stop_id": 8581011,
		"ID": 1402,
		"x": 99.8917281353,
		"y": 50.594144451,
		"h": 2.9450549451
	},
	{
		"stop_id": 8581842,
		"ID": 1402,
		"x": 100.1147268913,
		"y": 50.930237951,
		"h": 2.9450549451
	},
	{
		"stop_id": 8583075,
		"ID": 1402,
		"x": 100.1387025263,
		"y": 49.05719775,
		"h": 2.9450549451
	},
	{
		"stop_id": 8583251,
		"ID": 1402,
		"x": 96.9607096503,
		"y": 48.971177146,
		"h": 2.9450549451
	},
	{
		"stop_id": 8583677,
		"ID": 1402,
		"x": 100.1977686363,
		"y": 49.596191317,
		"h": 2.9450549451
	},
	{
		"stop_id": 8588287,
		"ID": 1402,
		"x": 99.6287576193,
		"y": 49.516167866,
		"h": 2.9450549451
	},
	{
		"stop_id": 8588954,
		"ID": 1402,
		"x": 96.0897535213,
		"y": 48.488167155,
		"h": 2.9450549451
	},
	{
		"stop_id": 8588955,
		"ID": 1402,
		"x": 95.7577594273,
		"y": 48.230234708,
		"h": 2.9450549451
	},
	{
		"stop_id": 8588956,
		"ID": 1402,
		"x": 95.9746997873,
		"y": 48.90220787,
		"h": 2.9450549451
	},
	{
		"stop_id": 8509617,
		"ID": 1400,
		"x": 100.2937682573,
		"y": 38.741176194,
		"h": 2.1538461538
	},
	{
		"stop_id": 8509629,
		"ID": 1400,
		"x": 98.5357118643,
		"y": 37.340236535,
		"h": 2.1538461538
	},
	{
		"stop_id": 8509630,
		"ID": 1400,
		"x": 99.1067446443,
		"y": 37.437191607,
		"h": 2.1538461538
	},
	{
		"stop_id": 8509698,
		"ID": 1400,
		"x": 99.9487206343,
		"y": 38.157148987,
		"h": 2.1538461538
	},
	{
		"stop_id": 8574393,
		"ID": 1400,
		"x": 98.3377251213,
		"y": 39.568148967,
		"h": 2.1538461538
	},
	{
		"stop_id": 8574394,
		"ID": 1400,
		"x": 98.4437719443,
		"y": 38.98220004,
		"h": 2.1538461538
	},
	{
		"stop_id": 8574396,
		"ID": 1400,
		"x": 98.4827174193,
		"y": 37.874210332,
		"h": 2.1538461538
	},
	{
		"stop_id": 8574398,
		"ID": 1400,
		"x": 98.6047714423,
		"y": 36.348157551,
		"h": 2.1538461538
	},
	{
		"stop_id": 8574399,
		"ID": 1400,
		"x": 98.5717076633,
		"y": 35.281187175,
		"h": 2.1538461538
	},
	{
		"stop_id": 8574400,
		"ID": 1400,
		"x": 98.2577018653,
		"y": 34.758152459,
		"h": 2.1538461538
	},
	{
		"stop_id": 8574414,
		"ID": 1400,
		"x": 99.6237351903,
		"y": 39.140248428,
		"h": 2.1538461538
	},
	{
		"stop_id": 8574417,
		"ID": 1400,
		"x": 98.5967651133,
		"y": 39.063229464,
		"h": 2.1538461538
	},
	{
		"stop_id": 8574418,
		"ID": 1400,
		"x": 98.8577076033,
		"y": 38.531235101,
		"h": 2.1538461538
	},
	{
		"stop_id": 8574419,
		"ID": 1400,
		"x": 99.0397364503,
		"y": 37.911177111,
		"h": 2.1538461538
	},
	{
		"stop_id": 8574420,
		"ID": 1400,
		"x": 99.9677556233,
		"y": 37.524181967,
		"h": 2.1538461538
	},
	{
		"stop_id": 8574421,
		"ID": 1400,
		"x": 100.0977569423,
		"y": 37.676143262,
		"h": 2.1538461538
	},
	{
		"stop_id": 8574422,
		"ID": 1400,
		"x": 100.2457226953,
		"y": 38.001195682,
		"h": 2.1538461538
	},
	{
		"stop_id": 8574423,
		"ID": 1400,
		"x": 100.4517237783,
		"y": 37.650182748,
		"h": 2.1538461538
	},
	{
		"stop_id": 8574424,
		"ID": 1400,
		"x": 100.4017395563,
		"y": 38.125170279,
		"h": 2.1538461538
	},
	{
		"stop_id": 8574426,
		"ID": 1400,
		"x": 98.8327137403,
		"y": 36.480230194,
		"h": 2.1538461538
	},
	{
		"stop_id": 8574427,
		"ID": 1400,
		"x": 98.9037057843,
		"y": 36.563196527,
		"h": 2.1538461538
	},
	{
		"stop_id": 8574428,
		"ID": 1400,
		"x": 99.1757314653,
		"y": 36.656198411,
		"h": 2.1538461538
	},
	{
		"stop_id": 8574429,
		"ID": 1400,
		"x": 99.3147127853,
		"y": 36.641226529,
		"h": 2.1538461538
	},
	{
		"stop_id": 8579674,
		"ID": 1400,
		"x": 99.6897620293,
		"y": 39.350211192,
		"h": 2.1538461538
	},
	{
		"stop_id": 8579696,
		"ID": 1400,
		"x": 95.9257045643,
		"y": 37.747168691,
		"h": 2.1538461538
	},
	{
		"stop_id": 8579697,
		"ID": 1400,
		"x": 96.8857447763,
		"y": 35.249163915,
		"h": 2.1538461538
	},
	{
		"stop_id": 8580201,
		"ID": 1400,
		"x": 98.6127660303,
		"y": 36.724160703,
		"h": 2.1538461538
	},
	{
		"stop_id": 8580228,
		"ID": 1400,
		"x": 100.6727128593,
		"y": 38.386149669,
		"h": 2.1538461538
	},
	{
		"stop_id": 8580602,
		"ID": 1400,
		"x": 98.4827544943,
		"y": 38.51524801,
		"h": 2.1538461538
	},
	{
		"stop_id": 8581001,
		"ID": 1400,
		"x": 99.8487482433,
		"y": 38.601216137,
		"h": 2.1538461538
	},
	{
		"stop_id": 8581002,
		"ID": 1400,
		"x": 99.6837715973,
		"y": 38.837239811,
		"h": 2.1538461538
	},
	{
		"stop_id": 8581003,
		"ID": 1400,
		"x": 98.6117253843,
		"y": 35.901153357,
		"h": 2.1538461538
	},
	{
		"stop_id": 8581093,
		"ID": 1400,
		"x": 99.8077295603,
		"y": 39.188219455,
		"h": 2.1538461538
	},
	{
		"stop_id": 8581841,
		"ID": 1400,
		"x": 98.6017668663,
		"y": 37.106220485,
		"h": 2.1538461538
	},
	{
		"stop_id": 8587571,
		"ID": 1400,
		"x": 96.5737633583,
		"y": 36.483207134,
		"h": 2.1538461538
	},
	{
		"stop_id": 8589894,
		"ID": 1400,
		"x": 96.4727285103,
		"y": 35.104191476,
		"h": 2.1538461538
	},
	{
		"stop_id": 8509634,
		"ID": 1321,
		"x": 84.8177029243,
		"y": -7.009780491,
		"h": 1.1318681319
	},
	{
		"stop_id": 8574599,
		"ID": 1321,
		"x": 85.5687244963,
		"y": -4.736831109,
		"h": 1.1318681319
	},
	{
		"stop_id": 8574600,
		"ID": 1321,
		"x": 85.2047086473,
		"y": -5.260832685,
		"h": 1.1318681319
	},
	{
		"stop_id": 8574601,
		"ID": 1321,
		"x": 84.7387523603,
		"y": -7.443803353,
		"h": 1.1318681319
	},
	{
		"stop_id": 8574602,
		"ID": 1321,
		"x": 84.5567293873,
		"y": -8.124832241,
		"h": 1.1318681319
	},
	{
		"stop_id": 8509657,
		"ID": 1375,
		"x": 92.3576996203,
		"y": 35.005214123,
		"h": 1.8571428571
	},
	{
		"stop_id": 8509658,
		"ID": 1375,
		"x": 95.0157187793,
		"y": 35.014207697,
		"h": 1.8571428571
	},
	{
		"stop_id": 8509659,
		"ID": 1375,
		"x": 95.0067401863,
		"y": 33.822234407,
		"h": 1.8571428571
	},
	{
		"stop_id": 8509850,
		"ID": 1375,
		"x": 94.8047327223,
		"y": 35.786206578,
		"h": 1.8571428571
	},
	{
		"stop_id": 8530507,
		"ID": 1375,
		"x": 94.7137213313,
		"y": 35.758154863,
		"h": 1.8571428571
	},
	{
		"stop_id": 8530508,
		"ID": 1375,
		"x": 93.8607429633,
		"y": 34.886212773,
		"h": 1.8571428571
	},
	{
		"stop_id": 8574332,
		"ID": 1375,
		"x": 95.3277268883,
		"y": 32.870164018,
		"h": 1.8571428571
	},
	{
		"stop_id": 8574333,
		"ID": 1375,
		"x": 95.1327543723,
		"y": 33.180152046,
		"h": 1.8571428571
	},
	{
		"stop_id": 8574334,
		"ID": 1375,
		"x": 95.0027594693,
		"y": 34.215151251,
		"h": 1.8571428571
	},
	{
		"stop_id": 8574336,
		"ID": 1375,
		"x": 94.8797363623,
		"y": 35.945184777,
		"h": 1.8571428571
	},
	{
		"stop_id": 8574337,
		"ID": 1375,
		"x": 94.3397604603,
		"y": 36.096222464,
		"h": 1.8571428571
	},
	{
		"stop_id": 8574338,
		"ID": 1375,
		"x": 93.9577060613,
		"y": 35.455223409,
		"h": 1.8571428571
	},
	{
		"stop_id": 8574339,
		"ID": 1375,
		"x": 93.5327611053,
		"y": 35.155231728,
		"h": 1.8571428571
	},
	{
		"stop_id": 8574340,
		"ID": 1375,
		"x": 92.8827390143,
		"y": 34.730169503,
		"h": 1.8571428571
	},
	{
		"stop_id": 8574409,
		"ID": 1375,
		"x": 95.5327540443,
		"y": 33.405204304,
		"h": 1.8571428571
	},
	{
		"stop_id": 8574410,
		"ID": 1375,
		"x": 95.3077023423,
		"y": 32.930141546,
		"h": 1.8571428571
	},
	{
		"stop_id": 8574411,
		"ID": 1375,
		"x": 92.9917768523,
		"y": 31.069153342,
		"h": 1.8571428571
	},
	{
		"stop_id": 8579698,
		"ID": 1375,
		"x": 93.7577197803,
		"y": 31.730184796,
		"h": 1.8571428571
	},
	{
		"stop_id": 8581152,
		"ID": 1375,
		"x": 96.2597717013,
		"y": 32.824216299,
		"h": 1.8571428571
	},
	{
		"stop_id": 8581606,
		"ID": 1375,
		"x": 95.0547685403,
		"y": 35.335178163,
		"h": 1.8571428571
	},
	{
		"stop_id": 8582095,
		"ID": 1375,
		"x": 95.6477651893,
		"y": 35.740200156,
		"h": 1.8571428571
	},
	{
		"stop_id": 8582096,
		"ID": 1375,
		"x": 95.8777373313,
		"y": 33.830250551,
		"h": 1.8571428571
	},
	{
		"stop_id": 8582101,
		"ID": 1375,
		"x": 95.9627738313,
		"y": 34.930244096,
		"h": 1.8571428571
	},
	{
		"stop_id": 8582113,
		"ID": 1375,
		"x": 95.7777590073,
		"y": 33.257235443,
		"h": 1.8571428571
	},
	{
		"stop_id": 8589892,
		"ID": 1375,
		"x": 96.2417469773,
		"y": 34.478240465,
		"h": 1.8571428571
	},
	{
		"stop_id": 8591819,
		"ID": 1375,
		"x": 95.8057316813,
		"y": 33.687242038,
		"h": 1.8571428571
	},
	{
		"stop_id": 8595645,
		"ID": 1375,
		"x": 95.5217129523,
		"y": 36.051196194,
		"h": 1.8571428571
	},
	{
		"stop_id": 8509660,
		"ID": 1367,
		"x": 94.0527445763,
		"y": -11.137857888,
		"h": 1.1978021978
	},
	{
		"stop_id": 8509661,
		"ID": 1367,
		"x": 93.9957173743,
		"y": -12.598857177,
		"h": 1.1978021978
	},
	{
		"stop_id": 8574535,
		"ID": 1367,
		"x": 94.1077031233,
		"y": -14.088773792,
		"h": 1.1978021978
	},
	{
		"stop_id": 8574817,
		"ID": 1367,
		"x": 92.8317685603,
		"y": -14.299816443,
		"h": 1.1978021978
	},
	{
		"stop_id": 8574818,
		"ID": 1367,
		"x": 92.0587602523,
		"y": -14.665805201,
		"h": 1.1978021978
	},
	{
		"stop_id": 8574819,
		"ID": 1367,
		"x": 92.3017542473,
		"y": -14.075846851,
		"h": 1.1978021978
	},
	{
		"stop_id": 8579860,
		"ID": 1367,
		"x": 93.6477331573,
		"y": -11.459815207,
		"h": 1.1978021978
	},
	{
		"stop_id": 8509662,
		"ID": 1366,
		"x": 92.8427372573,
		"y": -17.987771659,
		"h": 1.3626373626
	},
	{
		"stop_id": 8509663,
		"ID": 1366,
		"x": 92.6507029803,
		"y": -20.39282055,
		"h": 1.3626373626
	},
	{
		"stop_id": 8509752,
		"ID": 1366,
		"x": 92.5627436383,
		"y": -19.43282429,
		"h": 1.3626373626
	},
	{
		"stop_id": 8509966,
		"ID": 1366,
		"x": 91.0727452583,
		"y": -16.739757604,
		"h": 1.3626373626
	},
	{
		"stop_id": 8509968,
		"ID": 1366,
		"x": 93.8627681013,
		"y": -15.76375073,
		"h": 1.3626373626
	},
	{
		"stop_id": 8574814,
		"ID": 1366,
		"x": 92.7757128503,
		"y": -16.425754228,
		"h": 1.3626373626
	},
	{
		"stop_id": 8574815,
		"ID": 1366,
		"x": 92.7407027563,
		"y": -15.541809846,
		"h": 1.3626373626
	},
	{
		"stop_id": 8574816,
		"ID": 1366,
		"x": 92.3117094193,
		"y": -15.932775629,
		"h": 1.3626373626
	},
	{
		"stop_id": 8579861,
		"ID": 1366,
		"x": 93.5727134783,
		"y": -16.031821336,
		"h": 1.3626373626
	},
	{
		"stop_id": 8580886,
		"ID": 1366,
		"x": 92.5697065923,
		"y": -19.105826572,
		"h": 1.3626373626
	},
	{
		"stop_id": 8581095,
		"ID": 1366,
		"x": 92.6237077623,
		"y": -19.13181297,
		"h": 1.3626373626
	},
	{
		"stop_id": 8583443,
		"ID": 1366,
		"x": 93.3577555863,
		"y": -18.339855203,
		"h": 1.3626373626
	},
	{
		"stop_id": 8509664,
		"ID": 1365,
		"x": 92.2297645093,
		"y": -21.674843342,
		"h": 1.0989010989
	},
	{
		"stop_id": 8509754,
		"ID": 1365,
		"x": 93.6617061033,
		"y": -24.267833596,
		"h": 1.0989010989
	},
	{
		"stop_id": 8574724,
		"ID": 1365,
		"x": 93.5837686323,
		"y": -23.154802669,
		"h": 1.0989010989
	},
	{
		"stop_id": 8576261,
		"ID": 1365,
		"x": 93.4267088893,
		"y": -26.097749795,
		"h": 1.0989010989
	},
	{
		"stop_id": 8509665,
		"ID": 1318,
		"x": 82.7197641703,
		"y": -26.047829006,
		"h": 1.0989010989
	},
	{
		"stop_id": 8509884,
		"ID": 1318,
		"x": 84.5727629423,
		"y": -25.131759783,
		"h": 1.0989010989
	},
	{
		"stop_id": 8580182,
		"ID": 1318,
		"x": 84.5577684113,
		"y": -26.076852626,
		"h": 1.0989010989
	},
	{
		"stop_id": 8580923,
		"ID": 1318,
		"x": 84.6167228133,
		"y": -25.390795634,
		"h": 1.0989010989
	},
	{
		"stop_id": 8509666,
		"ID": 1292,
		"x": 78.7407305853,
		"y": -26.844833264,
		"h": 1
	},
	{
		"stop_id": 8509667,
		"ID": 1263,
		"x": 74.3827771133,
		"y": -28.369838371,
		"h": 1.0989010989
	},
	{
		"stop_id": 8509783,
		"ID": 1263,
		"x": 75.4987185383,
		"y": -27.786782999,
		"h": 1.0989010989
	},
	{
		"stop_id": 8509866,
		"ID": 1263,
		"x": 73.2077378673,
		"y": -31.694767315,
		"h": 1.0989010989
	},
	{
		"stop_id": 8582959,
		"ID": 1263,
		"x": 74.0167681033,
		"y": -29.868856856,
		"h": 1.0989010989
	},
	{
		"stop_id": 8509668,
		"ID": 1262,
		"x": 73.3347057523,
		"y": -33.315814299,
		"h": 1.0659340659
	},
	{
		"stop_id": 8509867,
		"ID": 1262,
		"x": 74.9807090233,
		"y": -35.425797363,
		"h": 1.0659340659
	},
	{
		"stop_id": 8580183,
		"ID": 1262,
		"x": 74.5677289853,
		"y": -34.954776991,
		"h": 1.0659340659
	},
	{
		"stop_id": 8509674,
		"ID": 1349,
		"x": 86.6047032843,
		"y": 25.465210902,
		"h": 1.1318681319
	},
	{
		"stop_id": 8530500,
		"ID": 1349,
		"x": 90.9647311903,
		"y": 25.048229535,
		"h": 1.1318681319
	},
	{
		"stop_id": 8530506,
		"ID": 1349,
		"x": 90.5707059173,
		"y": 23.823238876,
		"h": 1.1318681319
	},
	{
		"stop_id": 8574825,
		"ID": 1349,
		"x": 87.7207295103,
		"y": 27.061151263,
		"h": 1.1318681319
	},
	{
		"stop_id": 8574827,
		"ID": 1349,
		"x": 85.9787605433,
		"y": 24.676230792,
		"h": 1.1318681319
	},
	{
		"stop_id": 8509681,
		"ID": 1417,
		"x": 102.1227257093,
		"y": -3.818769844,
		"h": 1.5274725275
	},
	{
		"stop_id": 8509741,
		"ID": 1417,
		"x": 102.3347722933,
		"y": -8.431823473,
		"h": 1.5274725275
	},
	{
		"stop_id": 8509790,
		"ID": 1417,
		"x": 102.2217556303,
		"y": -5.177832987,
		"h": 1.5274725275
	},
	{
		"stop_id": 8530584,
		"ID": 1417,
		"x": 101.3577162983,
		"y": -5.521837999,
		"h": 1.5274725275
	},
	{
		"stop_id": 8574502,
		"ID": 1417,
		"x": 101.7577464893,
		"y": -4.50275655,
		"h": 1.5274725275
	},
	{
		"stop_id": 8574503,
		"ID": 1417,
		"x": 102.3297761183,
		"y": -5.866847386,
		"h": 1.5274725275
	},
	{
		"stop_id": 8574659,
		"ID": 1417,
		"x": 102.0507202783,
		"y": -6.08278774,
		"h": 1.5274725275
	},
	{
		"stop_id": 8574660,
		"ID": 1417,
		"x": 102.0977290923,
		"y": -6.52379093,
		"h": 1.5274725275
	},
	{
		"stop_id": 8574661,
		"ID": 1417,
		"x": 101.5727075553,
		"y": -7.327843695,
		"h": 1.5274725275
	},
	{
		"stop_id": 8582821,
		"ID": 1417,
		"x": 102.0187362683,
		"y": -5.098797266,
		"h": 1.5274725275
	},
	{
		"stop_id": 8582822,
		"ID": 1417,
		"x": 101.4687537803,
		"y": -5.50183828,
		"h": 1.5274725275
	},
	{
		"stop_id": 8582823,
		"ID": 1417,
		"x": 101.8477456933,
		"y": -5.12976532,
		"h": 1.5274725275
	},
	{
		"stop_id": 8582830,
		"ID": 1417,
		"x": 102.0787171723,
		"y": -4.054829035,
		"h": 1.5274725275
	},
	{
		"stop_id": 8582831,
		"ID": 1417,
		"x": 102.1227086363,
		"y": -4.964765597,
		"h": 1.5274725275
	},
	{
		"stop_id": 8582832,
		"ID": 1417,
		"x": 102.2467394003,
		"y": -5.595854612,
		"h": 1.5274725275
	},
	{
		"stop_id": 8582833,
		"ID": 1417,
		"x": 102.0857341063,
		"y": -4.481788315,
		"h": 1.5274725275
	},
	{
		"stop_id": 8582835,
		"ID": 1417,
		"x": 102.0357558583,
		"y": -3.771853153,
		"h": 1.5274725275
	},
	{
		"stop_id": 8509682,
		"ID": 1418,
		"x": 103.3537091733,
		"y": -3.501814294,
		"h": 1.3956043956
	},
	{
		"stop_id": 8509683,
		"ID": 1418,
		"x": 105.2097763523,
		"y": -3.482818039,
		"h": 1.3956043956
	},
	{
		"stop_id": 8509854,
		"ID": 1418,
		"x": 102.1237453313,
		"y": -1.609819474,
		"h": 1.3956043956
	},
	{
		"stop_id": 8509950,
		"ID": 1418,
		"x": 102.0347140453,
		"y": -2.798813067,
		"h": 1.3956043956
	},
	{
		"stop_id": 8530580,
		"ID": 1418,
		"x": 101.0187772723,
		"y": 0.347152028,
		"h": 1.3956043956
	},
	{
		"stop_id": 8530582,
		"ID": 1418,
		"x": 100.8477054403,
		"y": 0.245144397,
		"h": 1.3956043956
	},
	{
		"stop_id": 8574500,
		"ID": 1418,
		"x": 101.6567109793,
		"y": -0.066843432,
		"h": 1.3956043956
	},
	{
		"stop_id": 8574501,
		"ID": 1418,
		"x": 102.2507696763,
		"y": -2.265849982,
		"h": 1.3956043956
	},
	{
		"stop_id": 8580561,
		"ID": 1418,
		"x": 102.0877355813,
		"y": -3.349750701,
		"h": 1.3956043956
	},
	{
		"stop_id": 8581901,
		"ID": 1418,
		"x": 102.3987074693,
		"y": -1.92277471,
		"h": 1.3956043956
	},
	{
		"stop_id": 8582827,
		"ID": 1418,
		"x": 101.8337411563,
		"y": -3.047780686,
		"h": 1.3956043956
	},
	{
		"stop_id": 8582828,
		"ID": 1418,
		"x": 102.0167127713,
		"y": -2.907837909,
		"h": 1.3956043956
	},
	{
		"stop_id": 8583828,
		"ID": 1418,
		"x": 101.0067328533,
		"y": 0.346161481,
		"h": 1.3956043956
	},
	{
		"stop_id": 8509687,
		"ID": 1499,
		"x": 128.1147513303,
		"y": 3.652157863,
		"h": 1.1648351648
	},
	{
		"stop_id": 8509899,
		"ID": 1499,
		"x": 129.6677309023,
		"y": 2.189239062,
		"h": 1.1648351648
	},
	{
		"stop_id": 8530540,
		"ID": 1499,
		"x": 127.8207378103,
		"y": 3.858153024,
		"h": 1.1648351648
	},
	{
		"stop_id": 8530541,
		"ID": 1499,
		"x": 129.5347721083,
		"y": 4.673216495,
		"h": 1.1648351648
	},
	{
		"stop_id": 8587441,
		"ID": 1499,
		"x": 126.8317483803,
		"y": 0.422186426,
		"h": 1.1648351648
	},
	{
		"stop_id": 8588896,
		"ID": 1499,
		"x": 126.3037533353,
		"y": 1.183197163,
		"h": 1.1648351648
	},
	{
		"stop_id": 8509688,
		"ID": 1512,
		"x": 131.4127157093,
		"y": -0.122819813,
		"h": 1.0989010989
	},
	{
		"stop_id": 8509689,
		"ID": 1512,
		"x": 134.5567690503,
		"y": -2.420786735,
		"h": 1.0989010989
	},
	{
		"stop_id": 8509692,
		"ID": 1512,
		"x": 133.0297582993,
		"y": -2.454762902,
		"h": 1.0989010989
	},
	{
		"stop_id": 8509775,
		"ID": 1512,
		"x": 131.8977755753,
		"y": -1.796815622,
		"h": 1.0989010989
	},
	{
		"stop_id": 8509696,
		"ID": 1267,
		"x": 72.5997231163,
		"y": -8.162854016,
		"h": 1.8241758242
	},
	{
		"stop_id": 8509767,
		"ID": 1267,
		"x": 74.2727584353,
		"y": -6.128757971,
		"h": 1.8241758242
	},
	{
		"stop_id": 8509857,
		"ID": 1267,
		"x": 74.9207371443,
		"y": -7.140792186,
		"h": 1.8241758242
	},
	{
		"stop_id": 8509958,
		"ID": 1267,
		"x": 72.8827085213,
		"y": -7.068791104,
		"h": 1.8241758242
	},
	{
		"stop_id": 8530570,
		"ID": 1267,
		"x": 72.5807040063,
		"y": -7.106819523,
		"h": 1.8241758242
	},
	{
		"stop_id": 8530571,
		"ID": 1267,
		"x": 71.6207477783,
		"y": -6.375810821,
		"h": 1.8241758242
	},
	{
		"stop_id": 8574982,
		"ID": 1267,
		"x": 74.0427552293,
		"y": -6.27277683,
		"h": 1.8241758242
	},
	{
		"stop_id": 8574983,
		"ID": 1267,
		"x": 71.8997258203,
		"y": -7.958762522,
		"h": 1.8241758242
	},
	{
		"stop_id": 8574984,
		"ID": 1267,
		"x": 71.7827238443,
		"y": -8.37485853,
		"h": 1.8241758242
	},
	{
		"stop_id": 8575023,
		"ID": 1267,
		"x": 73.6937444773,
		"y": -6.010796009,
		"h": 1.8241758242
	},
	{
		"stop_id": 8575024,
		"ID": 1267,
		"x": 73.4587397543,
		"y": -5.857791771,
		"h": 1.8241758242
	},
	{
		"stop_id": 8575025,
		"ID": 1267,
		"x": 73.4047054713,
		"y": -5.648834315,
		"h": 1.8241758242
	},
	{
		"stop_id": 8575026,
		"ID": 1267,
		"x": 72.2057354433,
		"y": -7.787804734,
		"h": 1.8241758242
	},
	{
		"stop_id": 8575031,
		"ID": 1267,
		"x": 75.5997400613,
		"y": -5.705763289,
		"h": 1.8241758242
	},
	{
		"stop_id": 8575032,
		"ID": 1267,
		"x": 74.5477306383,
		"y": -7.641749989,
		"h": 1.8241758242
	},
	{
		"stop_id": 8575033,
		"ID": 1267,
		"x": 73.6937628083,
		"y": -8.936766756,
		"h": 1.8241758242
	},
	{
		"stop_id": 8575040,
		"ID": 1267,
		"x": 76.2007616593,
		"y": -5.444754608,
		"h": 1.8241758242
	},
	{
		"stop_id": 8575042,
		"ID": 1267,
		"x": 75.8177588383,
		"y": -7.269805428,
		"h": 1.8241758242
	},
	{
		"stop_id": 8575043,
		"ID": 1267,
		"x": 74.8937704643,
		"y": -8.051750689,
		"h": 1.8241758242
	},
	{
		"stop_id": 8575044,
		"ID": 1267,
		"x": 74.7307124233,
		"y": -8.601820066,
		"h": 1.8241758242
	},
	{
		"stop_id": 8575098,
		"ID": 1267,
		"x": 73.5127365893,
		"y": -6.446812524,
		"h": 1.8241758242
	},
	{
		"stop_id": 8575099,
		"ID": 1267,
		"x": 72.6977000333,
		"y": -7.199752468,
		"h": 1.8241758242
	},
	{
		"stop_id": 8575100,
		"ID": 1267,
		"x": 72.1427128793,
		"y": -7.627848749,
		"h": 1.8241758242
	},
	{
		"stop_id": 8575102,
		"ID": 1267,
		"x": 75.1667297283,
		"y": -5.344797698,
		"h": 1.8241758242
	},
	{
		"stop_id": 8580190,
		"ID": 1267,
		"x": 74.9677554863,
		"y": -8.389789808,
		"h": 1.8241758242
	},
	{
		"stop_id": 8583362,
		"ID": 1267,
		"x": 73.8167658023,
		"y": -6.401797115,
		"h": 1.8241758242
	},
	{
		"stop_id": 8509699,
		"ID": 1424,
		"x": 104.8777497193,
		"y": 36.604186412,
		"h": 1.0659340659
	},
	{
		"stop_id": 8530509,
		"ID": 1424,
		"x": 105.1136991063,
		"y": 36.346242841,
		"h": 1.0659340659
	},
	{
		"stop_id": 8581009,
		"ID": 1424,
		"x": 105.1067400573,
		"y": 36.367181304,
		"h": 1.0659340659
	},
	{
		"stop_id": 8509700,
		"ID": 1584,
		"x": 167.4847406783,
		"y": 9.969240338,
		"h": 1
	},
	{
		"stop_id": 8509701,
		"ID": 1563,
		"x": 159.3517523243,
		"y": -3.080774606,
		"h": 1.0659340659
	},
	{
		"stop_id": 8581212,
		"ID": 1563,
		"x": 161.0027074433,
		"y": -4.442859343,
		"h": 1.0659340659
	},
	{
		"stop_id": 8582805,
		"ID": 1563,
		"x": 160.1847115173,
		"y": -3.955768494,
		"h": 1.0659340659
	},
	{
		"stop_id": 8509703,
		"ID": 1575,
		"x": 162.1167713873,
		"y": 8.986154441,
		"h": 1.1648351648
	},
	{
		"stop_id": 8509713,
		"ID": 1575,
		"x": 163.1707288483,
		"y": 8.078202867,
		"h": 1.1648351648
	},
	{
		"stop_id": 8509863,
		"ID": 1575,
		"x": 164.7817140233,
		"y": 8.683237569,
		"h": 1.1648351648
	},
	{
		"stop_id": 8509953,
		"ID": 1575,
		"x": 161.2057555493,
		"y": 10.405168492,
		"h": 1.1648351648
	},
	{
		"stop_id": 8509973,
		"ID": 1575,
		"x": 163.4537019633,
		"y": 9.534174827,
		"h": 1.1648351648
	},
	{
		"stop_id": 8574516,
		"ID": 1575,
		"x": 164.7787715033,
		"y": 8.373193449,
		"h": 1.1648351648
	},
	{
		"stop_id": 8509707,
		"ID": 1587,
		"x": 167.1307191683,
		"y": 22.812175109,
		"h": 1.032967033
	},
	{
		"stop_id": 8582840,
		"ID": 1587,
		"x": 168.5467265723,
		"y": 22.550231966,
		"h": 1.032967033
	},
	{
		"stop_id": 8509709,
		"ID": 1585,
		"x": 169.4277496483,
		"y": 12.850250176,
		"h": 1.1978021978
	},
	{
		"stop_id": 8509749,
		"ID": 1585,
		"x": 167.7497595653,
		"y": 12.542169922,
		"h": 1.1978021978
	},
	{
		"stop_id": 8509795,
		"ID": 1585,
		"x": 170.7767133883,
		"y": 14.449201115,
		"h": 1.1978021978
	},
	{
		"stop_id": 8509887,
		"ID": 1585,
		"x": 168.4577161273,
		"y": 11.905219314,
		"h": 1.1978021978
	},
	{
		"stop_id": 8574737,
		"ID": 1585,
		"x": 167.8187585233,
		"y": 11.453215936,
		"h": 1.1978021978
	},
	{
		"stop_id": 8581094,
		"ID": 1585,
		"x": 168.7957122793,
		"y": 12.032164591,
		"h": 1.1978021978
	},
	{
		"stop_id": 8581818,
		"ID": 1585,
		"x": 167.9837208403,
		"y": 12.347159221,
		"h": 1.1978021978
	},
	{
		"stop_id": 8509710,
		"ID": 1572,
		"x": 161.6427266643,
		"y": -4.683787538,
		"h": 1
	},
	{
		"stop_id": 8509715,
		"ID": 1526,
		"x": 137.8587411873,
		"y": -1.141789336,
		"h": 1
	},
	{
		"stop_id": 8509718,
		"ID": 1577,
		"x": 164.3587479563,
		"y": 22.187211638,
		"h": 1.6593406593
	},
	{
		"stop_id": 8509719,
		"ID": 1577,
		"x": 163.5387617743,
		"y": 21.741180521,
		"h": 1.6593406593
	},
	{
		"stop_id": 8509765,
		"ID": 1577,
		"x": 165.7277294773,
		"y": 22.689236411,
		"h": 1.6593406593
	},
	{
		"stop_id": 8509873,
		"ID": 1577,
		"x": 162.7777229723,
		"y": 20.900198315,
		"h": 1.6593406593
	},
	{
		"stop_id": 8530609,
		"ID": 1577,
		"x": 163.7557601333,
		"y": 21.630156606,
		"h": 1.6593406593
	},
	{
		"stop_id": 8530610,
		"ID": 1577,
		"x": 163.0717241253,
		"y": 23.71117679,
		"h": 1.6593406593
	},
	{
		"stop_id": 8579814,
		"ID": 1577,
		"x": 165.9597142783,
		"y": 22.744176562,
		"h": 1.6593406593
	},
	{
		"stop_id": 8581957,
		"ID": 1577,
		"x": 165.5687105013,
		"y": 22.618147871,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583623,
		"ID": 1577,
		"x": 162.5007159243,
		"y": 20.689185984,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583624,
		"ID": 1577,
		"x": 162.6157160223,
		"y": 20.590231474,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583625,
		"ID": 1577,
		"x": 162.8097562823,
		"y": 20.989167316,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583626,
		"ID": 1577,
		"x": 162.7627072453,
		"y": 20.659231974,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583627,
		"ID": 1577,
		"x": 165.8177064113,
		"y": 22.489160511,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583628,
		"ID": 1577,
		"x": 165.8407291293,
		"y": 22.70018276,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583629,
		"ID": 1577,
		"x": 163.4947057853,
		"y": 21.595242932,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583630,
		"ID": 1577,
		"x": 163.7157555283,
		"y": 21.616198605,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583631,
		"ID": 1577,
		"x": 163.2927482213,
		"y": 21.371202117,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583637,
		"ID": 1577,
		"x": 165.2917277793,
		"y": 22.627163379,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583638,
		"ID": 1577,
		"x": 165.0167506093,
		"y": 22.605228562,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583639,
		"ID": 1577,
		"x": 165.4127446853,
		"y": 22.595238937,
		"h": 1.6593406593
	},
	{
		"stop_id": 8583704,
		"ID": 1577,
		"x": 164.1197505133,
		"y": 22.105149693,
		"h": 1.6593406593
	},
	{
		"stop_id": 8509721,
		"ID": 1324,
		"x": 84.2317560673,
		"y": 8.375211501,
		"h": 1
	},
	{
		"stop_id": 8509726,
		"ID": 1346,
		"x": 88.5277429643,
		"y": 5.507159047,
		"h": 1.1978021978
	},
	{
		"stop_id": 8509730,
		"ID": 1346,
		"x": 90.5137605013,
		"y": 5.597177243,
		"h": 1.1978021978
	},
	{
		"stop_id": 8509895,
		"ID": 1346,
		"x": 86.9617558383,
		"y": 5.574203404,
		"h": 1.1978021978
	},
	{
		"stop_id": 8574678,
		"ID": 1346,
		"x": 90.3167732603,
		"y": 5.755147084,
		"h": 1.1978021978
	},
	{
		"stop_id": 8581027,
		"ID": 1346,
		"x": 87.3487242283,
		"y": 5.645197932,
		"h": 1.1978021978
	},
	{
		"stop_id": 8582141,
		"ID": 1346,
		"x": 90.2377741013,
		"y": 5.070155177,
		"h": 1.1978021978
	},
	{
		"stop_id": 8583228,
		"ID": 1346,
		"x": 86.7187254393,
		"y": 5.556240212,
		"h": 1.1978021978
	},
	{
		"stop_id": 8509734,
		"ID": 1474,
		"x": 120.1367506473,
		"y": 20.317144943,
		"h": 1.2307692308
	},
	{
		"stop_id": 8509735,
		"ID": 1474,
		"x": 119.6137663283,
		"y": 19.004238709,
		"h": 1.2307692308
	},
	{
		"stop_id": 8509853,
		"ID": 1474,
		"x": 117.9386992553,
		"y": 17.573248412,
		"h": 1.2307692308
	},
	{
		"stop_id": 8557021,
		"ID": 1474,
		"x": 117.3857315443,
		"y": 16.714224917,
		"h": 1.2307692308
	},
	{
		"stop_id": 8575083,
		"ID": 1474,
		"x": 116.9587605523,
		"y": 16.972172561,
		"h": 1.2307692308
	},
	{
		"stop_id": 8575084,
		"ID": 1474,
		"x": 117.5187046223,
		"y": 17.325204133,
		"h": 1.2307692308
	},
	{
		"stop_id": 8575085,
		"ID": 1474,
		"x": 120.3037376883,
		"y": 21.103176347,
		"h": 1.2307692308
	},
	{
		"stop_id": 8581053,
		"ID": 1474,
		"x": 117.2167719613,
		"y": 16.797190528,
		"h": 1.2307692308
	},
	{
		"stop_id": 8509737,
		"ID": 1094,
		"x": 48.2277161963,
		"y": -16.14980181,
		"h": 1.1978021978
	},
	{
		"stop_id": 8509738,
		"ID": 1094,
		"x": 48.4097191583,
		"y": -14.906822438,
		"h": 1.1978021978
	},
	{
		"stop_id": 8509743,
		"ID": 1094,
		"x": 47.4527247333,
		"y": -17.689792776,
		"h": 1.1978021978
	},
	{
		"stop_id": 8509744,
		"ID": 1094,
		"x": 46.9847715313,
		"y": -17.714801556,
		"h": 1.1978021978
	},
	{
		"stop_id": 8509769,
		"ID": 1094,
		"x": 48.8857028683,
		"y": -12.532778134,
		"h": 1.1978021978
	},
	{
		"stop_id": 8509981,
		"ID": 1094,
		"x": 48.6467417093,
		"y": -14.095794423,
		"h": 1.1978021978
	},
	{
		"stop_id": 8574897,
		"ID": 1094,
		"x": 48.1247387743,
		"y": -16.679776645,
		"h": 1.1978021978
	},
	{
		"stop_id": 8509739,
		"ID": 1093,
		"x": 46.1227148723,
		"y": -19.687768763,
		"h": 1
	},
	{
		"stop_id": 8509746,
		"ID": 1489,
		"x": 122.0327690333,
		"y": 22.60815653,
		"h": 1.0989010989
	},
	{
		"stop_id": 8509865,
		"ID": 1489,
		"x": 120.9597095243,
		"y": 22.221207728,
		"h": 1.0989010989
	},
	{
		"stop_id": 8575086,
		"ID": 1489,
		"x": 120.6807318073,
		"y": 21.985205681,
		"h": 1.0989010989
	},
	{
		"stop_id": 8575087,
		"ID": 1489,
		"x": 121.3267043573,
		"y": 22.308186734,
		"h": 1.0989010989
	},
	{
		"stop_id": 8509753,
		"ID": 1238,
		"x": 68.1717622773,
		"y": 0.270223306,
		"h": 1.2637362637
	},
	{
		"stop_id": 8509984,
		"ID": 1238,
		"x": 68.4897272683,
		"y": -0.553813911,
		"h": 1.2637362637
	},
	{
		"stop_id": 8575052,
		"ID": 1238,
		"x": 69.9177070963,
		"y": 0.490234899,
		"h": 1.2637362637
	},
	{
		"stop_id": 8575053,
		"ID": 1238,
		"x": 69.0897643313,
		"y": 1.37114648,
		"h": 1.2637362637
	},
	{
		"stop_id": 8575054,
		"ID": 1238,
		"x": 68.4257743483,
		"y": 2.972207625,
		"h": 1.2637362637
	},
	{
		"stop_id": 8575057,
		"ID": 1238,
		"x": 68.7526993453,
		"y": -0.423753354,
		"h": 1.2637362637
	},
	{
		"stop_id": 8575059,
		"ID": 1238,
		"x": 67.2947760703,
		"y": -0.543804303,
		"h": 1.2637362637
	},
	{
		"stop_id": 8579976,
		"ID": 1238,
		"x": 67.7847192953,
		"y": -0.02980073,
		"h": 1.2637362637
	},
	{
		"stop_id": 8581600,
		"ID": 1238,
		"x": 69.0467345243,
		"y": -0.413769319,
		"h": 1.2637362637
	},
	{
		"stop_id": 8509755,
		"ID": 1433,
		"x": 110.0577729123,
		"y": -33.659769663,
		"h": 1.0659340659
	},
	{
		"stop_id": 8574510,
		"ID": 1433,
		"x": 109.4177195223,
		"y": -30.657794011,
		"h": 1.0659340659
	},
	{
		"stop_id": 8574511,
		"ID": 1433,
		"x": 109.4057448523,
		"y": -32.344835331,
		"h": 1.0659340659
	},
	{
		"stop_id": 8509756,
		"ID": 1430,
		"x": 106.9337215933,
		"y": -47.319768872,
		"h": 1.0989010989
	},
	{
		"stop_id": 8509956,
		"ID": 1430,
		"x": 108.0367529303,
		"y": -47.081807982,
		"h": 1.0989010989
	},
	{
		"stop_id": 8530597,
		"ID": 1430,
		"x": 110.1517405533,
		"y": -48.34680944,
		"h": 1.0989010989
	},
	{
		"stop_id": 8581576,
		"ID": 1430,
		"x": 108.2857209593,
		"y": -46.94076581,
		"h": 1.0989010989
	},
	{
		"stop_id": 8509759,
		"ID": 1554,
		"x": 156.7217559473,
		"y": -12.325757406,
		"h": 1.0989010989
	},
	{
		"stop_id": 8509778,
		"ID": 1554,
		"x": 152.3367409403,
		"y": -10.731805136,
		"h": 1.0989010989
	},
	{
		"stop_id": 8509861,
		"ID": 1554,
		"x": 150.8247615133,
		"y": -11.888840774,
		"h": 1.0989010989
	},
	{
		"stop_id": 8574641,
		"ID": 1554,
		"x": 153.8257128683,
		"y": -11.028826787,
		"h": 1.0989010989
	},
	{
		"stop_id": 8509760,
		"ID": 1449,
		"x": 111.5287310293,
		"y": -42.495762714,
		"h": 1.1648351648
	},
	{
		"stop_id": 8509794,
		"ID": 1449,
		"x": 113.7707647263,
		"y": -40.931780593,
		"h": 1.1648351648
	},
	{
		"stop_id": 8530714,
		"ID": 1449,
		"x": 114.4857275113,
		"y": -40.407823028,
		"h": 1.1648351648
	},
	{
		"stop_id": 8574960,
		"ID": 1449,
		"x": 114.2227017473,
		"y": -40.444777624,
		"h": 1.1648351648
	},
	{
		"stop_id": 8574961,
		"ID": 1449,
		"x": 113.7887231443,
		"y": -41.408802639,
		"h": 1.1648351648
	},
	{
		"stop_id": 8574962,
		"ID": 1449,
		"x": 112.8407398263,
		"y": -41.50784958,
		"h": 1.1648351648
	},
	{
		"stop_id": 8509761,
		"ID": 1385,
		"x": 100.0497568923,
		"y": -49.120824943,
		"h": 1.1978021978
	},
	{
		"stop_id": 8581122,
		"ID": 1385,
		"x": 98.0617005503,
		"y": -49.469798647,
		"h": 1.1978021978
	},
	{
		"stop_id": 8581125,
		"ID": 1385,
		"x": 95.6667505363,
		"y": -50.137848922,
		"h": 1.1978021978
	},
	{
		"stop_id": 8582954,
		"ID": 1385,
		"x": 97.5347561363,
		"y": -49.476763159,
		"h": 1.1978021978
	},
	{
		"stop_id": 8583705,
		"ID": 1385,
		"x": 100.4177727633,
		"y": -49.000760236,
		"h": 1.1978021978
	},
	{
		"stop_id": 8583846,
		"ID": 1385,
		"x": 97.2227498493,
		"y": -49.700836522,
		"h": 1.1978021978
	},
	{
		"stop_id": 8583847,
		"ID": 1385,
		"x": 98.7717163433,
		"y": -49.40282838,
		"h": 1.1978021978
	},
	{
		"stop_id": 8509763,
		"ID": 1394,
		"x": 100.9997346203,
		"y": 0.601195541,
		"h": 1.1978021978
	},
	{
		"stop_id": 8509793,
		"ID": 1394,
		"x": 100.0627170853,
		"y": 3.987188914,
		"h": 1.1978021978
	},
	{
		"stop_id": 8530581,
		"ID": 1394,
		"x": 99.1987662653,
		"y": 0.87017736,
		"h": 1.1978021978
	},
	{
		"stop_id": 8574498,
		"ID": 1394,
		"x": 100.0017634663,
		"y": 2.686210707,
		"h": 1.1978021978
	},
	{
		"stop_id": 8574499,
		"ID": 1394,
		"x": 100.5337249763,
		"y": 1.186223992,
		"h": 1.1978021978
	},
	{
		"stop_id": 8580560,
		"ID": 1394,
		"x": 100.0617108873,
		"y": 2.194160001,
		"h": 1.1978021978
	},
	{
		"stop_id": 8581028,
		"ID": 1394,
		"x": 100.2267588093,
		"y": 4.57418965,
		"h": 1.1978021978
	},
	{
		"stop_id": 8509766,
		"ID": 1388,
		"x": 99.4727087333,
		"y": -33.612833197,
		"h": 1.1648351648
	},
	{
		"stop_id": 8574726,
		"ID": 1388,
		"x": 96.4397187353,
		"y": -31.169844521,
		"h": 1.1648351648
	},
	{
		"stop_id": 8574727,
		"ID": 1388,
		"x": 96.8357174333,
		"y": -32.133804546,
		"h": 1.1648351648
	},
	{
		"stop_id": 8574728,
		"ID": 1388,
		"x": 97.4297364323,
		"y": -33.106810472,
		"h": 1.1648351648
	},
	{
		"stop_id": 8574729,
		"ID": 1388,
		"x": 98.0557685303,
		"y": -33.153824977,
		"h": 1.1648351648
	},
	{
		"stop_id": 8574730,
		"ID": 1388,
		"x": 100.5607247233,
		"y": -34.470826443,
		"h": 1.1648351648
	},
	{
		"stop_id": 8509777,
		"ID": 1570,
		"x": 164.9857580333,
		"y": -16.481851276,
		"h": 1.0989010989
	},
	{
		"stop_id": 8574646,
		"ID": 1570,
		"x": 164.7567401183,
		"y": -16.214756107,
		"h": 1.0989010989
	},
	{
		"stop_id": 8574647,
		"ID": 1570,
		"x": 165.5597055023,
		"y": -16.680831523,
		"h": 1.0989010989
	},
	{
		"stop_id": 8574656,
		"ID": 1570,
		"x": 165.5517417433,
		"y": -16.008772735,
		"h": 1.0989010989
	},
	{
		"stop_id": 8509784,
		"ID": 1364,
		"x": 94.0397654633,
		"y": -28.405776334,
		"h": 1.0659340659
	},
	{
		"stop_id": 8570270,
		"ID": 1364,
		"x": 94.8497507173,
		"y": -29.490813383,
		"h": 1.0659340659
	},
	{
		"stop_id": 8574725,
		"ID": 1364,
		"x": 93.4047196843,
		"y": -27.102791286,
		"h": 1.0659340659
	},
	{
		"stop_id": 8509791,
		"ID": 1236,
		"x": 70.1677716673,
		"y": -10.936799194,
		"h": 1.0989010989
	},
	{
		"stop_id": 8509957,
		"ID": 1236,
		"x": 71.6077554953,
		"y": -9.239774941,
		"h": 1.0989010989
	},
	{
		"stop_id": 8574986,
		"ID": 1236,
		"x": 68.2657416943,
		"y": -12.114834937,
		"h": 1.0989010989
	},
	{
		"stop_id": 8580188,
		"ID": 1236,
		"x": 69.6377236643,
		"y": -10.909778578,
		"h": 1.0989010989
	},
	{
		"stop_id": 8509796,
		"ID": 1342,
		"x": 91.4677393193,
		"y": -15.683755631,
		"h": 1.1318681319
	},
	{
		"stop_id": 8574820,
		"ID": 1342,
		"x": 90.7827019643,
		"y": -16.525855182,
		"h": 1.1318681319
	},
	{
		"stop_id": 8582116,
		"ID": 1342,
		"x": 91.6547089563,
		"y": -15.376799173,
		"h": 1.1318681319
	},
	{
		"stop_id": 8595447,
		"ID": 1342,
		"x": 89.9327256473,
		"y": -17.019811615,
		"h": 1.1318681319
	},
	{
		"stop_id": 8595448,
		"ID": 1342,
		"x": 87.6997379403,
		"y": -17.148766877,
		"h": 1.1318681319
	},
	{
		"stop_id": 8509797,
		"ID": 1434,
		"x": 107.6707126573,
		"y": -27.765846148,
		"h": 1.2307692308
	},
	{
		"stop_id": 8509889,
		"ID": 1434,
		"x": 108.3437246533,
		"y": -28.154772872,
		"h": 1.2307692308
	},
	{
		"stop_id": 8574508,
		"ID": 1434,
		"x": 108.4137427703,
		"y": -28.885791997,
		"h": 1.2307692308
	},
	{
		"stop_id": 8574509,
		"ID": 1434,
		"x": 108.7577538163,
		"y": -29.194782433,
		"h": 1.2307692308
	},
	{
		"stop_id": 8591719,
		"ID": 1434,
		"x": 109.0977624763,
		"y": -27.679818381,
		"h": 1.2307692308
	},
	{
		"stop_id": 8591720,
		"ID": 1434,
		"x": 109.8777178173,
		"y": -27.014756986,
		"h": 1.2307692308
	},
	{
		"stop_id": 8591721,
		"ID": 1434,
		"x": 109.8777178173,
		"y": -27.014756986,
		"h": 1.2307692308
	},
	{
		"stop_id": 8594181,
		"ID": 1434,
		"x": 108.5277178223,
		"y": -27.769852856,
		"h": 1.2307692308
	},
	{
		"stop_id": 8509798,
		"ID": 1581,
		"x": 170.5217578693,
		"y": -14.277804037,
		"h": 1.2637362637
	},
	{
		"stop_id": 8509869,
		"ID": 1581,
		"x": 169.0207433673,
		"y": -17.00676898,
		"h": 1.2637362637
	},
	{
		"stop_id": 8509951,
		"ID": 1581,
		"x": 167.6187684413,
		"y": -17.258800204,
		"h": 1.2637362637
	},
	{
		"stop_id": 8574648,
		"ID": 1581,
		"x": 168.5347081603,
		"y": -17.206815062,
		"h": 1.2637362637
	},
	{
		"stop_id": 8574649,
		"ID": 1581,
		"x": 169.5407669713,
		"y": -16.494784568,
		"h": 1.2637362637
	},
	{
		"stop_id": 8574650,
		"ID": 1581,
		"x": 170.5197066603,
		"y": -14.911770682,
		"h": 1.2637362637
	},
	{
		"stop_id": 8579856,
		"ID": 1581,
		"x": 166.6777554043,
		"y": -17.001774623,
		"h": 1.2637362637
	},
	{
		"stop_id": 8580143,
		"ID": 1581,
		"x": 166.0537428983,
		"y": -16.284826044,
		"h": 1.2637362637
	},
	{
		"stop_id": 8581567,
		"ID": 1581,
		"x": 170.8047305963,
		"y": -13.900827345,
		"h": 1.2637362637
	},
	{
		"stop_id": 8509855,
		"ID": 1561,
		"x": 158.7577323333,
		"y": -13.239782774,
		"h": 1.0659340659
	},
	{
		"stop_id": 8574642,
		"ID": 1561,
		"x": 159.9317402953,
		"y": -13.632769749,
		"h": 1.0659340659
	},
	{
		"stop_id": 8574852,
		"ID": 1561,
		"x": 161.3127702383,
		"y": -14.263755974,
		"h": 1.0659340659
	},
	{
		"stop_id": 8509856,
		"ID": 1419,
		"x": 101.1007519623,
		"y": 6.153200824,
		"h": 1.5934065934
	},
	{
		"stop_id": 8509859,
		"ID": 1419,
		"x": 103.7237390443,
		"y": 5.570153061,
		"h": 1.5934065934
	},
	{
		"stop_id": 8509897,
		"ID": 1419,
		"x": 105.6967494123,
		"y": 4.963230398,
		"h": 1.5934065934
	},
	{
		"stop_id": 8574712,
		"ID": 1419,
		"x": 101.6027007633,
		"y": 6.862216909,
		"h": 1.5934065934
	},
	{
		"stop_id": 8574713,
		"ID": 1419,
		"x": 102.1517738333,
		"y": 6.719244655,
		"h": 1.5934065934
	},
	{
		"stop_id": 8574715,
		"ID": 1419,
		"x": 103.2907187083,
		"y": 7.188230332,
		"h": 1.5934065934
	},
	{
		"stop_id": 8574746,
		"ID": 1419,
		"x": 105.5127652083,
		"y": 7.334167944,
		"h": 1.5934065934
	},
	{
		"stop_id": 8574747,
		"ID": 1419,
		"x": 104.5657678843,
		"y": 7.338219285,
		"h": 1.5934065934
	},
	{
		"stop_id": 8574748,
		"ID": 1419,
		"x": 104.6337512133,
		"y": 7.505234861,
		"h": 1.5934065934
	},
	{
		"stop_id": 8574882,
		"ID": 1419,
		"x": 101.0597300683,
		"y": 6.018202936,
		"h": 1.5934065934
	},
	{
		"stop_id": 8574883,
		"ID": 1419,
		"x": 101.4097602653,
		"y": 6.038185271,
		"h": 1.5934065934
	},
	{
		"stop_id": 8574884,
		"ID": 1419,
		"x": 101.7037501963,
		"y": 5.770201436,
		"h": 1.5934065934
	},
	{
		"stop_id": 8574885,
		"ID": 1419,
		"x": 103.1987717763,
		"y": 5.666154596,
		"h": 1.5934065934
	},
	{
		"stop_id": 8574886,
		"ID": 1419,
		"x": 103.4047330813,
		"y": 5.629173443,
		"h": 1.5934065934
	},
	{
		"stop_id": 8574887,
		"ID": 1419,
		"x": 104.1517336393,
		"y": 5.640246021,
		"h": 1.5934065934
	},
	{
		"stop_id": 8574913,
		"ID": 1419,
		"x": 101.9937443623,
		"y": 6.800156545,
		"h": 1.5934065934
	},
	{
		"stop_id": 8581553,
		"ID": 1419,
		"x": 101.2867645233,
		"y": 6.83624463,
		"h": 1.5934065934
	},
	{
		"stop_id": 8583391,
		"ID": 1419,
		"x": 102.1927263893,
		"y": 6.847242882,
		"h": 1.5934065934
	},
	{
		"stop_id": 8594429,
		"ID": 1419,
		"x": 101.2127295013,
		"y": 6.425226196,
		"h": 1.5934065934
	},
	{
		"stop_id": 8509860,
		"ID": 1410,
		"x": 103.2937502363,
		"y": -48.500762388,
		"h": 1.2637362637
	},
	{
		"stop_id": 8509883,
		"ID": 1410,
		"x": 101.8407029603,
		"y": -48.197760922,
		"h": 1.2637362637
	},
	{
		"stop_id": 8509885,
		"ID": 1410,
		"x": 106.1817414633,
		"y": -47.768854423,
		"h": 1.2637362637
	},
	{
		"stop_id": 8574968,
		"ID": 1410,
		"x": 105.4027400713,
		"y": -48.123834758,
		"h": 1.2637362637
	},
	{
		"stop_id": 8574969,
		"ID": 1410,
		"x": 102.8087283673,
		"y": -48.654848565,
		"h": 1.2637362637
	},
	{
		"stop_id": 8574970,
		"ID": 1410,
		"x": 102.5127644143,
		"y": -48.667813874,
		"h": 1.2637362637
	},
	{
		"stop_id": 8579684,
		"ID": 1410,
		"x": 101.8067496223,
		"y": -48.966759164,
		"h": 1.2637362637
	},
	{
		"stop_id": 8581096,
		"ID": 1410,
		"x": 105.7687594253,
		"y": -47.989815787,
		"h": 1.2637362637
	},
	{
		"stop_id": 8582063,
		"ID": 1410,
		"x": 102.9927477323,
		"y": -48.600849888,
		"h": 1.2637362637
	},
	{
		"stop_id": 8509872,
		"ID": 1320,
		"x": 83.8637526303,
		"y": -10.732836116,
		"h": 1.0989010989
	},
	{
		"stop_id": 8574603,
		"ID": 1320,
		"x": 82.2877334143,
		"y": -12.663822219,
		"h": 1.0989010989
	},
	{
		"stop_id": 8574604,
		"ID": 1320,
		"x": 81.8077005003,
		"y": -13.505805853,
		"h": 1.0989010989
	},
	{
		"stop_id": 8574605,
		"ID": 1320,
		"x": 81.4837373513,
		"y": -14.220760643,
		"h": 1.0989010989
	},
	{
		"stop_id": 8509874,
		"ID": 1435,
		"x": 105.9297036763,
		"y": -19.814761749,
		"h": 1.2637362637
	},
	{
		"stop_id": 8509894,
		"ID": 1435,
		"x": 107.1747407323,
		"y": -21.142832234,
		"h": 1.2637362637
	},
	{
		"stop_id": 8509972,
		"ID": 1435,
		"x": 107.8597131443,
		"y": -23.632860549,
		"h": 1.2637362637
	},
	{
		"stop_id": 8574507,
		"ID": 1435,
		"x": 106.9057424363,
		"y": -20.88784525,
		"h": 1.2637362637
	},
	{
		"stop_id": 8580717,
		"ID": 1435,
		"x": 107.7117705663,
		"y": -22.014782974,
		"h": 1.2637362637
	},
	{
		"stop_id": 8582067,
		"ID": 1435,
		"x": 107.3487757993,
		"y": -21.31581881,
		"h": 1.2637362637
	},
	{
		"stop_id": 8583640,
		"ID": 1435,
		"x": 106.1367585723,
		"y": -19.900796078,
		"h": 1.2637362637
	},
	{
		"stop_id": 8583641,
		"ID": 1435,
		"x": 106.0607427423,
		"y": -19.640776767,
		"h": 1.2637362637
	},
	{
		"stop_id": 8583642,
		"ID": 1435,
		"x": 106.2387429633,
		"y": -19.407774607,
		"h": 1.2637362637
	},
	{
		"stop_id": 8509878,
		"ID": 1484,
		"x": 124.4207533173,
		"y": -4.785791776,
		"h": 1.032967033
	},
	{
		"stop_id": 8587444,
		"ID": 1484,
		"x": 124.5577144763,
		"y": -5.369821954,
		"h": 1.032967033
	},
	{
		"stop_id": 8509886,
		"ID": 1588,
		"x": 171.3987324323,
		"y": -25.210772474,
		"h": 1
	},
	{
		"stop_id": 8509888,
		"ID": 1341,
		"x": 88.1757306703,
		"y": -23.211776811,
		"h": 1
	},
	{
		"stop_id": 8509892,
		"ID": 1344,
		"x": 85.4217738603,
		"y": -3.5497747,
		"h": 1.2307692308
	},
	{
		"stop_id": 8574588,
		"ID": 1344,
		"x": 90.4357699253,
		"y": -5.157751704,
		"h": 1.2307692308
	},
	{
		"stop_id": 8574589,
		"ID": 1344,
		"x": 90.5257430133,
		"y": -5.937803059,
		"h": 1.2307692308
	},
	{
		"stop_id": 8574590,
		"ID": 1344,
		"x": 90.4747228143,
		"y": -4.719751614,
		"h": 1.2307692308
	},
	{
		"stop_id": 8574591,
		"ID": 1344,
		"x": 90.4387696333,
		"y": -4.349793556,
		"h": 1.2307692308
	},
	{
		"stop_id": 8574592,
		"ID": 1344,
		"x": 90.4667575683,
		"y": -4.090769625,
		"h": 1.2307692308
	},
	{
		"stop_id": 8574611,
		"ID": 1344,
		"x": 86.6377208273,
		"y": -2.421758696,
		"h": 1.2307692308
	},
	{
		"stop_id": 8574612,
		"ID": 1344,
		"x": 86.2977106183,
		"y": -3.754785865,
		"h": 1.2307692308
	},
	{
		"stop_id": 8509893,
		"ID": 1294,
		"x": 81.1967035823,
		"y": -15.807834844,
		"h": 1.032967033
	},
	{
		"stop_id": 8574606,
		"ID": 1294,
		"x": 81.1677288433,
		"y": -14.579790402,
		"h": 1.032967033
	},
	{
		"stop_id": 8509898,
		"ID": 1571,
		"x": 162.4577334453,
		"y": -14.755780971,
		"h": 1.0989010989
	},
	{
		"stop_id": 8574644,
		"ID": 1571,
		"x": 162.0337742743,
		"y": -14.521830698,
		"h": 1.0989010989
	},
	{
		"stop_id": 8574657,
		"ID": 1571,
		"x": 164.6247690743,
		"y": -14.816799555,
		"h": 1.0989010989
	},
	{
		"stop_id": 8574853,
		"ID": 1571,
		"x": 162.8717737443,
		"y": -14.952804169,
		"h": 1.0989010989
	},
	{
		"stop_id": 8509952,
		"ID": 1265,
		"x": 73.6707061333,
		"y": -18.015809871,
		"h": 1.2307692308
	},
	{
		"stop_id": 8530568,
		"ID": 1265,
		"x": 73.1407618353,
		"y": -19.11079867,
		"h": 1.2307692308
	},
	{
		"stop_id": 8530569,
		"ID": 1265,
		"x": 71.4777504983,
		"y": -19.499826395,
		"h": 1.2307692308
	},
	{
		"stop_id": 8575038,
		"ID": 1265,
		"x": 73.9497727993,
		"y": -17.328768003,
		"h": 1.2307692308
	},
	{
		"stop_id": 8575039,
		"ID": 1265,
		"x": 73.3627212403,
		"y": -18.804774721,
		"h": 1.2307692308
	},
	{
		"stop_id": 8581516,
		"ID": 1265,
		"x": 72.8597261233,
		"y": -19.539762874,
		"h": 1.2307692308
	},
	{
		"stop_id": 8581533,
		"ID": 1265,
		"x": 73.8107154013,
		"y": -17.596835428,
		"h": 1.2307692308
	},
	{
		"stop_id": 8583598,
		"ID": 1265,
		"x": 73.2487332823,
		"y": -19.117750086,
		"h": 1.2307692308
	},
	{
		"stop_id": 8509955,
		"ID": 1372,
		"x": 92.7267561153,
		"y": 14.695150699,
		"h": 1
	},
	{
		"stop_id": 8509960,
		"ID": 1590,
		"x": 172.2537092363,
		"y": 19.024158368,
		"h": 1.1318681319
	},
	{
		"stop_id": 8580145,
		"ID": 1590,
		"x": 173.4007362013,
		"y": 15.693155383,
		"h": 1.1318681319
	},
	{
		"stop_id": 8580146,
		"ID": 1590,
		"x": 173.6367734533,
		"y": 15.367163169,
		"h": 1.1318681319
	},
	{
		"stop_id": 8580147,
		"ID": 1590,
		"x": 172.2277341333,
		"y": 15.681198065,
		"h": 1.1318681319
	},
	{
		"stop_id": 8581987,
		"ID": 1590,
		"x": 173.6327748473,
		"y": 14.991189904,
		"h": 1.1318681319
	},
	{
		"stop_id": 8509961,
		"ID": 1235,
		"x": 67.3277336963,
		"y": -14.119755253,
		"h": 1.1978021978
	},
	{
		"stop_id": 8574987,
		"ID": 1235,
		"x": 67.8847507163,
		"y": -12.471756892,
		"h": 1.1978021978
	},
	{
		"stop_id": 8574988,
		"ID": 1235,
		"x": 67.4067414563,
		"y": -12.608771481,
		"h": 1.1978021978
	},
	{
		"stop_id": 8574989,
		"ID": 1235,
		"x": 67.3847220033,
		"y": -13.849799557,
		"h": 1.1978021978
	},
	{
		"stop_id": 8581956,
		"ID": 1235,
		"x": 66.0547507243,
		"y": -15.505757589,
		"h": 1.1978021978
	},
	{
		"stop_id": 8581958,
		"ID": 1235,
		"x": 66.3277564713,
		"y": -15.359820933,
		"h": 1.1978021978
	},
	{
		"stop_id": 8581960,
		"ID": 1235,
		"x": 66.7757522893,
		"y": -14.771761401,
		"h": 1.1978021978
	},
	{
		"stop_id": 8509965,
		"ID": 1326,
		"x": 85.1247244193,
		"y": 23.42517316,
		"h": 1.1318681319
	},
	{
		"stop_id": 8574828,
		"ID": 1326,
		"x": 85.7077629183,
		"y": 24.230246387,
		"h": 1.1318681319
	},
	{
		"stop_id": 8574829,
		"ID": 1326,
		"x": 85.3427328703,
		"y": 23.860164746,
		"h": 1.1318681319
	},
	{
		"stop_id": 8581931,
		"ID": 1326,
		"x": 82.0577516133,
		"y": 22.030178233,
		"h": 1.1318681319
	},
	{
		"stop_id": 8595251,
		"ID": 1326,
		"x": 85.2677113163,
		"y": 23.575214248,
		"h": 1.1318681319
	},
	{
		"stop_id": 8509977,
		"ID": 1347,
		"x": 89.0817674643,
		"y": 14.850230639,
		"h": 1.032967033
	},
	{
		"stop_id": 8574575,
		"ID": 1347,
		"x": 89.6977311363,
		"y": 15.143173004,
		"h": 1.032967033
	},
	{
		"stop_id": 8509986,
		"ID": 1322,
		"x": 85.1977318613,
		"y": 1.550225635,
		"h": 1.1978021978
	},
	{
		"stop_id": 8574598,
		"ID": 1322,
		"x": 84.8987624483,
		"y": 1.729145844,
		"h": 1.1978021978
	},
	{
		"stop_id": 8574608,
		"ID": 1322,
		"x": 85.5757127633,
		"y": 0.618184628,
		"h": 1.1978021978
	},
	{
		"stop_id": 8574609,
		"ID": 1322,
		"x": 85.3547076263,
		"y": 0.16824662,
		"h": 1.1978021978
	},
	{
		"stop_id": 8581170,
		"ID": 1322,
		"x": 82.9747290373,
		"y": 1.343151557,
		"h": 1.1978021978
	},
	{
		"stop_id": 8581171,
		"ID": 1322,
		"x": 82.0987578643,
		"y": 1.051234762,
		"h": 1.1978021978
	},
	{
		"stop_id": 8583229,
		"ID": 1322,
		"x": 86.2537340813,
		"y": -0.87776648,
		"h": 1.1978021978
	},
	{
		"stop_id": 8516155,
		"ID": 11,
		"x": -161.1342306857,
		"y": -66.448817535,
		"h": 7
	},
	{
		"stop_id": 8587036,
		"ID": 11,
		"x": -159.8422926617,
		"y": -68.379758328,
		"h": 7
	},
	{
		"stop_id": 8587037,
		"ID": 11,
		"x": -160.3732436737,
		"y": -67.060792936,
		"h": 7
	},
	{
		"stop_id": 8587062,
		"ID": 11,
		"x": -160.7752638687,
		"y": -65.132771508,
		"h": 7
	},
	{
		"stop_id": 8587075,
		"ID": 11,
		"x": -160.8452949377,
		"y": -68.112810382,
		"h": 7
	},
	{
		"stop_id": 8587080,
		"ID": 11,
		"x": -163.1152916007,
		"y": -67.024779191,
		"h": 7
	},
	{
		"stop_id": 8587082,
		"ID": 11,
		"x": -161.6962416937,
		"y": -66.344753989,
		"h": 7
	},
	{
		"stop_id": 8587083,
		"ID": 11,
		"x": -161.7242886497,
		"y": -68.695767552,
		"h": 7
	},
	{
		"stop_id": 8587386,
		"ID": 11,
		"x": -164.0172457217,
		"y": -67.577770943,
		"h": 7
	},
	{
		"stop_id": 8587387,
		"ID": 11,
		"x": -159.7372909277,
		"y": -64.711752112,
		"h": 7
	},
	{
		"stop_id": 8587418,
		"ID": 11,
		"x": -162.0072514097,
		"y": -66.489820222,
		"h": 7
	},
	{
		"stop_id": 8587437,
		"ID": 11,
		"x": -160.1422567627,
		"y": -67.469774796,
		"h": 7
	},
	{
		"stop_id": 8587902,
		"ID": 11,
		"x": -161.4132463567,
		"y": -66.978804051,
		"h": 7
	},
	{
		"stop_id": 8587907,
		"ID": 11,
		"x": -159.7402885997,
		"y": -65.44382725,
		"h": 7
	},
	{
		"stop_id": 8588195,
		"ID": 11,
		"x": -159.7202931417,
		"y": -69.770758323,
		"h": 7
	},
	{
		"stop_id": 8588801,
		"ID": 11,
		"x": -159.5122889897,
		"y": -69.108774254,
		"h": 7
	},
	{
		"stop_id": 8588802,
		"ID": 11,
		"x": -160.8822443537,
		"y": -67.504810122,
		"h": 7
	},
	{
		"stop_id": 8589098,
		"ID": 11,
		"x": -161.2292885787,
		"y": -66.55484653,
		"h": 7
	},
	{
		"stop_id": 8592660,
		"ID": 11,
		"x": -164.3012739157,
		"y": -67.557858549,
		"h": 7
	},
	{
		"stop_id": 8592667,
		"ID": 11,
		"x": -160.3432690917,
		"y": -66.855829187,
		"h": 7
	},
	{
		"stop_id": 8592668,
		"ID": 11,
		"x": -159.9522306587,
		"y": -67.322831796,
		"h": 7
	},
	{
		"stop_id": 8592669,
		"ID": 11,
		"x": -159.9892616457,
		"y": -66.700828472,
		"h": 7
	},
	{
		"stop_id": 8592670,
		"ID": 11,
		"x": -160.5922657197,
		"y": -67.876771615,
		"h": 7
	},
	{
		"stop_id": 8592673,
		"ID": 11,
		"x": -159.6322392747,
		"y": -67.694798891,
		"h": 7
	},
	{
		"stop_id": 8592674,
		"ID": 11,
		"x": -159.5522502587,
		"y": -66.942758689,
		"h": 7
	},
	{
		"stop_id": 8592675,
		"ID": 11,
		"x": -160.1652913647,
		"y": -67.954808344,
		"h": 7
	},
	{
		"stop_id": 8592676,
		"ID": 11,
		"x": -159.4072921347,
		"y": -67.874841976,
		"h": 7
	},
	{
		"stop_id": 8592677,
		"ID": 11,
		"x": -159.9802282717,
		"y": -66.975817198,
		"h": 7
	},
	{
		"stop_id": 8592678,
		"ID": 11,
		"x": -159.6702565137,
		"y": -67.209756382,
		"h": 7
	},
	{
		"stop_id": 8592679,
		"ID": 11,
		"x": -160.9412297787,
		"y": -66.589803511,
		"h": 7
	},
	{
		"stop_id": 8592680,
		"ID": 11,
		"x": -160.2262684607,
		"y": -66.492767286,
		"h": 7
	},
	{
		"stop_id": 8592682,
		"ID": 11,
		"x": -159.2362325237,
		"y": -66.950856164,
		"h": 7
	},
	{
		"stop_id": 8592754,
		"ID": 11,
		"x": -164.0402384127,
		"y": -66.774751019,
		"h": 7
	},
	{
		"stop_id": 8592755,
		"ID": 11,
		"x": -164.0072923797,
		"y": -67.134770695,
		"h": 7
	},
	{
		"stop_id": 8592757,
		"ID": 11,
		"x": -163.8022926467,
		"y": -67.033789873,
		"h": 7
	},
	{
		"stop_id": 8592758,
		"ID": 11,
		"x": -163.5152850157,
		"y": -67.310782986,
		"h": 7
	},
	{
		"stop_id": 8592774,
		"ID": 11,
		"x": -160.1262545457,
		"y": -66.04981599,
		"h": 7
	},
	{
		"stop_id": 8592776,
		"ID": 11,
		"x": -158.8662463937,
		"y": -66.59681756,
		"h": 7
	},
	{
		"stop_id": 8592779,
		"ID": 11,
		"x": -159.2962330397,
		"y": -65.449820332,
		"h": 7
	},
	{
		"stop_id": 8592780,
		"ID": 11,
		"x": -159.6872703427,
		"y": -66.145809222,
		"h": 7
	},
	{
		"stop_id": 8592782,
		"ID": 11,
		"x": -160.1712569267,
		"y": -65.258795483,
		"h": 7
	},
	{
		"stop_id": 8592786,
		"ID": 11,
		"x": -159.2282837247,
		"y": -66.495813562,
		"h": 7
	},
	{
		"stop_id": 8592789,
		"ID": 11,
		"x": -159.7672276907,
		"y": -66.479808356,
		"h": 7
	},
	{
		"stop_id": 8592792,
		"ID": 11,
		"x": -159.3162783587,
		"y": -65.227796245,
		"h": 7
	},
	{
		"stop_id": 8592793,
		"ID": 11,
		"x": -158.6782621047,
		"y": -67.269757849,
		"h": 7
	},
	{
		"stop_id": 8592794,
		"ID": 11,
		"x": -159.7562433057,
		"y": -64.970823121,
		"h": 7
	},
	{
		"stop_id": 8592796,
		"ID": 11,
		"x": -159.0372751347,
		"y": -66.365758374,
		"h": 7
	},
	{
		"stop_id": 8592797,
		"ID": 11,
		"x": -161.6652737597,
		"y": -64.507783091,
		"h": 7
	},
	{
		"stop_id": 8592799,
		"ID": 11,
		"x": -159.3752317617,
		"y": -65.080845034,
		"h": 7
	},
	{
		"stop_id": 8592801,
		"ID": 11,
		"x": -159.6922578667,
		"y": -64.331814261,
		"h": 7
	},
	{
		"stop_id": 8592802,
		"ID": 11,
		"x": -160.9532889947,
		"y": -64.348858703,
		"h": 7
	},
	{
		"stop_id": 8592804,
		"ID": 11,
		"x": -159.9422894787,
		"y": -65.161753179,
		"h": 7
	},
	{
		"stop_id": 8592805,
		"ID": 11,
		"x": -159.1612460137,
		"y": -65.724767076,
		"h": 7
	},
	{
		"stop_id": 8592811,
		"ID": 11,
		"x": -161.3212285277,
		"y": -64.498786173,
		"h": 7
	},
	{
		"stop_id": 8592812,
		"ID": 11,
		"x": -159.7982782037,
		"y": -64.408776454,
		"h": 7
	},
	{
		"stop_id": 8592813,
		"ID": 11,
		"x": -158.5452971427,
		"y": -66.684787592,
		"h": 7
	},
	{
		"stop_id": 8592816,
		"ID": 11,
		"x": -160.5712550507,
		"y": -64.620853385,
		"h": 7
	},
	{
		"stop_id": 8592818,
		"ID": 11,
		"x": -160.6222803567,
		"y": -64.250770422,
		"h": 7
	},
	{
		"stop_id": 8592819,
		"ID": 11,
		"x": -160.0392854327,
		"y": -65.498801656,
		"h": 7
	},
	{
		"stop_id": 8592822,
		"ID": 11,
		"x": -160.3102344227,
		"y": -66.257780538,
		"h": 7
	},
	{
		"stop_id": 8592827,
		"ID": 11,
		"x": -160.9192824587,
		"y": -65.688825718,
		"h": 7
	},
	{
		"stop_id": 8592828,
		"ID": 11,
		"x": -159.2662787607,
		"y": -65.374821838,
		"h": 7
	},
	{
		"stop_id": 8592831,
		"ID": 11,
		"x": -159.8552953087,
		"y": -64.397826301,
		"h": 7
	},
	{
		"stop_id": 8592835,
		"ID": 11,
		"x": -161.2622340877,
		"y": -64.221824316,
		"h": 7
	},
	{
		"stop_id": 8592836,
		"ID": 11,
		"x": -162.1352315947,
		"y": -64.553765196,
		"h": 7
	},
	{
		"stop_id": 8592837,
		"ID": 11,
		"x": -159.2882732437,
		"y": -65.819849102,
		"h": 7
	},
	{
		"stop_id": 8592838,
		"ID": 11,
		"x": -159.4682979627,
		"y": -65.120781124,
		"h": 7
	},
	{
		"stop_id": 8592839,
		"ID": 11,
		"x": -160.4732828077,
		"y": -66.297760425,
		"h": 7
	},
	{
		"stop_id": 8592841,
		"ID": 11,
		"x": -160.0042328467,
		"y": -64.469849253,
		"h": 7
	},
	{
		"stop_id": 8592842,
		"ID": 11,
		"x": -160.6952565177,
		"y": -66.45382623,
		"h": 7
	},
	{
		"stop_id": 8592844,
		"ID": 11,
		"x": -161.1152391547,
		"y": -64.735834974,
		"h": 7
	},
	{
		"stop_id": 8592848,
		"ID": 11,
		"x": -159.4332813997,
		"y": -65.740856837,
		"h": 7
	},
	{
		"stop_id": 8592851,
		"ID": 11,
		"x": -159.1222711687,
		"y": -65.288801894,
		"h": 7
	},
	{
		"stop_id": 8592853,
		"ID": 11,
		"x": -159.5362933377,
		"y": -66.223794173,
		"h": 7
	},
	{
		"stop_id": 8592857,
		"ID": 11,
		"x": -159.0612801987,
		"y": -65.993798899,
		"h": 7
	},
	{
		"stop_id": 8592858,
		"ID": 11,
		"x": -160.9202419267,
		"y": -64.698853744,
		"h": 7
	},
	{
		"stop_id": 8592860,
		"ID": 11,
		"x": -158.7362667117,
		"y": -66.439847315,
		"h": 7
	},
	{
		"stop_id": 8592862,
		"ID": 11,
		"x": -159.4212954437,
		"y": -64.896749056,
		"h": 7
	},
	{
		"stop_id": 8592868,
		"ID": 11,
		"x": -160.2732470867,
		"y": -65.47279149,
		"h": 7
	},
	{
		"stop_id": 8592869,
		"ID": 11,
		"x": -160.4382773677,
		"y": -64.427836008,
		"h": 7
	},
	{
		"stop_id": 8592873,
		"ID": 11,
		"x": -160.2382296367,
		"y": -64.559800785,
		"h": 7
	},
	{
		"stop_id": 8592874,
		"ID": 11,
		"x": -160.4722955997,
		"y": -64.889781752,
		"h": 7
	},
	{
		"stop_id": 8592878,
		"ID": 11,
		"x": -158.9232404467,
		"y": -65.942809014,
		"h": 7
	},
	{
		"stop_id": 8592879,
		"ID": 11,
		"x": -159.0832422177,
		"y": -65.511804214,
		"h": 7
	},
	{
		"stop_id": 8592881,
		"ID": 11,
		"x": -159.5092654017,
		"y": -65.605853398,
		"h": 7
	},
	{
		"stop_id": 8592885,
		"ID": 11,
		"x": -159.6562632977,
		"y": -65.105781693,
		"h": 7
	},
	{
		"stop_id": 8592886,
		"ID": 11,
		"x": -158.9772922317,
		"y": -66.154832897,
		"h": 7
	},
	{
		"stop_id": 8592887,
		"ID": 11,
		"x": -159.7262618057,
		"y": -65.804840545,
		"h": 7
	},
	{
		"stop_id": 8592890,
		"ID": 11,
		"x": -160.2942357767,
		"y": -64.283808264,
		"h": 7
	},
	{
		"stop_id": 8592891,
		"ID": 11,
		"x": -160.8082509257,
		"y": -65.683789212,
		"h": 7
	},
	{
		"stop_id": 8592892,
		"ID": 11,
		"x": -159.1982508907,
		"y": -66.331760283,
		"h": 7
	},
	{
		"stop_id": 8592898,
		"ID": 11,
		"x": -159.1792687797,
		"y": -66.050785621,
		"h": 7
	},
	{
		"stop_id": 8592904,
		"ID": 11,
		"x": -160.5652666097,
		"y": -64.784833903,
		"h": 7
	},
	{
		"stop_id": 8592906,
		"ID": 11,
		"x": -159.9832375807,
		"y": -64.8237521,
		"h": 7
	},
	{
		"stop_id": 8592908,
		"ID": 11,
		"x": -160.5352797377,
		"y": -65.245845198,
		"h": 7
	},
	{
		"stop_id": 8592909,
		"ID": 11,
		"x": -159.3752680287,
		"y": -65.190802014,
		"h": 7
	},
	{
		"stop_id": 8592915,
		"ID": 11,
		"x": -159.9182943667,
		"y": -65.777758538,
		"h": 7
	},
	{
		"stop_id": 8592920,
		"ID": 11,
		"x": -160.4612854157,
		"y": -65.980761029,
		"h": 7
	},
	{
		"stop_id": 8592923,
		"ID": 11,
		"x": -160.3192421397,
		"y": -65.081781828,
		"h": 7
	},
	{
		"stop_id": 8592975,
		"ID": 11,
		"x": -162.1392287637,
		"y": -66.248769375,
		"h": 7
	},
	{
		"stop_id": 8592977,
		"ID": 11,
		"x": -161.4762941517,
		"y": -67.880758519,
		"h": 7
	},
	{
		"stop_id": 8592978,
		"ID": 11,
		"x": -162.1402819777,
		"y": -65.80480403,
		"h": 7
	},
	{
		"stop_id": 8592979,
		"ID": 11,
		"x": -161.8872363757,
		"y": -65.528795384,
		"h": 7
	},
	{
		"stop_id": 8592980,
		"ID": 11,
		"x": -161.3572825617,
		"y": -65.711833885,
		"h": 7
	},
	{
		"stop_id": 8592981,
		"ID": 11,
		"x": -161.6592490297,
		"y": -67.14176939,
		"h": 7
	},
	{
		"stop_id": 8592982,
		"ID": 11,
		"x": -161.7792742827,
		"y": -67.824845617,
		"h": 7
	},
	{
		"stop_id": 8592983,
		"ID": 11,
		"x": -161.5082644137,
		"y": -67.214800528,
		"h": 7
	},
	{
		"stop_id": 8592984,
		"ID": 11,
		"x": -162.3442570217,
		"y": -68.298818041,
		"h": 7
	},
	{
		"stop_id": 8592985,
		"ID": 11,
		"x": -162.0542746427,
		"y": -67.338784833,
		"h": 7
	},
	{
		"stop_id": 8592986,
		"ID": 11,
		"x": -162.3172988837,
		"y": -66.021832185,
		"h": 7
	},
	{
		"stop_id": 8592988,
		"ID": 11,
		"x": -161.4052324337,
		"y": -67.774774408,
		"h": 7
	},
	{
		"stop_id": 8592991,
		"ID": 11,
		"x": -161.4462516267,
		"y": -67.508806281,
		"h": 7
	},
	{
		"stop_id": 8592992,
		"ID": 11,
		"x": -161.3282544377,
		"y": -68.217790912,
		"h": 7
	},
	{
		"stop_id": 8592993,
		"ID": 11,
		"x": -161.8272351547,
		"y": -66.712778233,
		"h": 7
	},
	{
		"stop_id": 8592994,
		"ID": 11,
		"x": -160.5242692307,
		"y": -68.259811767,
		"h": 7
	},
	{
		"stop_id": 8592995,
		"ID": 11,
		"x": -161.2352657457,
		"y": -65.898777279,
		"h": 7
	},
	{
		"stop_id": 8592996,
		"ID": 11,
		"x": -160.8772596067,
		"y": -67.774841274,
		"h": 7
	},
	{
		"stop_id": 8592998,
		"ID": 11,
		"x": -161.9662855457,
		"y": -68.054835835,
		"h": 7
	},
	{
		"stop_id": 8593027,
		"ID": 11,
		"x": -162.5362791957,
		"y": -66.721782194,
		"h": 7
	},
	{
		"stop_id": 8593028,
		"ID": 11,
		"x": -162.8572578087,
		"y": -67.453786695,
		"h": 7
	},
	{
		"stop_id": 8593029,
		"ID": 11,
		"x": -163.5382828277,
		"y": -66.895790967,
		"h": 7
	},
	{
		"stop_id": 8593030,
		"ID": 11,
		"x": -163.1112398457,
		"y": -66.439809909,
		"h": 7
	},
	{
		"stop_id": 8593031,
		"ID": 11,
		"x": -163.7952654647,
		"y": -66.840787625,
		"h": 7
	},
	{
		"stop_id": 8593032,
		"ID": 11,
		"x": -163.0462275407,
		"y": -66.159853294,
		"h": 7
	},
	{
		"stop_id": 8593033,
		"ID": 11,
		"x": -162.9882304567,
		"y": -66.837829266,
		"h": 7
	},
	{
		"stop_id": 8593034,
		"ID": 11,
		"x": -162.4472543127,
		"y": -67.422849174,
		"h": 7
	},
	{
		"stop_id": 8593035,
		"ID": 11,
		"x": -162.8302700737,
		"y": -66.282836301,
		"h": 7
	},
	{
		"stop_id": 8593037,
		"ID": 11,
		"x": -162.9642739647,
		"y": -66.379835895,
		"h": 7
	},
	{
		"stop_id": 8593038,
		"ID": 11,
		"x": -162.8282358687,
		"y": -66.063843094,
		"h": 7
	},
	{
		"stop_id": 8593039,
		"ID": 11,
		"x": -162.6362958087,
		"y": -67.312790854,
		"h": 7
	},
	{
		"stop_id": 8593042,
		"ID": 11,
		"x": -162.9372269427,
		"y": -67.102756324,
		"h": 7
	},
	{
		"stop_id": 8593043,
		"ID": 11,
		"x": -162.7452645397,
		"y": -66.609824563,
		"h": 7
	},
	{
		"stop_id": 8593050,
		"ID": 11,
		"x": -162.2562767487,
		"y": -69.041779734,
		"h": 7
	},
	{
		"stop_id": 8593051,
		"ID": 11,
		"x": -162.9672355807,
		"y": -69.368796719,
		"h": 7
	},
	{
		"stop_id": 8593053,
		"ID": 11,
		"x": -160.8972542357,
		"y": -69.238763246,
		"h": 7
	},
	{
		"stop_id": 8593054,
		"ID": 11,
		"x": -162.4612981837,
		"y": -68.554773376,
		"h": 7
	},
	{
		"stop_id": 8593055,
		"ID": 11,
		"x": -160.1312880037,
		"y": -69.368816381,
		"h": 7
	},
	{
		"stop_id": 8593056,
		"ID": 11,
		"x": -162.3692926587,
		"y": -68.804825781,
		"h": 7
	},
	{
		"stop_id": 8593057,
		"ID": 11,
		"x": -161.3192281627,
		"y": -68.420848367,
		"h": 7
	},
	{
		"stop_id": 8593058,
		"ID": 11,
		"x": -160.0732359717,
		"y": -69.119844419,
		"h": 7
	},
	{
		"stop_id": 8593059,
		"ID": 11,
		"x": -162.6502347627,
		"y": -69.235775068,
		"h": 7
	},
	{
		"stop_id": 8593060,
		"ID": 11,
		"x": -160.3792460427,
		"y": -68.470801626,
		"h": 7
	},
	{
		"stop_id": 8593061,
		"ID": 11,
		"x": -162.5042423867,
		"y": -68.390829388,
		"h": 7
	},
	{
		"stop_id": 8593062,
		"ID": 11,
		"x": -160.0002271877,
		"y": -68.825758057,
		"h": 7
	},
	{
		"stop_id": 8593063,
		"ID": 11,
		"x": -161.3832965507,
		"y": -69.029824383,
		"h": 7
	},
	{
		"stop_id": 8593064,
		"ID": 11,
		"x": -161.5622789087,
		"y": -68.588760233,
		"h": 7
	},
	{
		"stop_id": 8593065,
		"ID": 11,
		"x": -162.5672646107,
		"y": -68.935771952,
		"h": 7
	},
	{
		"stop_id": 8593067,
		"ID": 11,
		"x": -161.2102291317,
		"y": -69.677803388,
		"h": 7
	},
	{
		"stop_id": 8593068,
		"ID": 11,
		"x": -160.6002943487,
		"y": -68.895834856,
		"h": 7
	},
	{
		"stop_id": 8593069,
		"ID": 11,
		"x": -162.8462667577,
		"y": -69.133819545,
		"h": 7
	},
	{
		"stop_id": 8593070,
		"ID": 11,
		"x": -161.1612842537,
		"y": -68.375801453,
		"h": 7
	},
	{
		"stop_id": 8593071,
		"ID": 11,
		"x": -161.9112241677,
		"y": -68.823807803,
		"h": 7
	},
	{
		"stop_id": 8593072,
		"ID": 11,
		"x": -161.4472472237,
		"y": -68.656848022,
		"h": 7
	},
	{
		"stop_id": 8593073,
		"ID": 11,
		"x": -162.9042760227,
		"y": -68.897792363,
		"h": 7
	},
	{
		"stop_id": 8593125,
		"ID": 11,
		"x": -159.3422768957,
		"y": -69.29279999,
		"h": 7
	},
	{
		"stop_id": 8593126,
		"ID": 11,
		"x": -159.6682590367,
		"y": -68.790780258,
		"h": 7
	},
	{
		"stop_id": 8593137,
		"ID": 11,
		"x": -162.7912649427,
		"y": -65.049829677,
		"h": 7
	},
	{
		"stop_id": 8593138,
		"ID": 11,
		"x": -162.2892991927,
		"y": -64.525804632,
		"h": 7
	},
	{
		"stop_id": 8593142,
		"ID": 11,
		"x": -163.1442325367,
		"y": -64.431859792,
		"h": 7
	},
	{
		"stop_id": 8593147,
		"ID": 11,
		"x": -163.5722482807,
		"y": -65.527781815,
		"h": 7
	},
	{
		"stop_id": 8593148,
		"ID": 11,
		"x": -163.1392795557,
		"y": -65.568777464,
		"h": 7
	},
	{
		"stop_id": 8593154,
		"ID": 11,
		"x": -163.1662670587,
		"y": -64.758801821,
		"h": 7
	},
	{
		"stop_id": 8593159,
		"ID": 11,
		"x": -162.9582968067,
		"y": -64.88076413,
		"h": 7
	},
	{
		"stop_id": 8593162,
		"ID": 11,
		"x": -162.4672616417,
		"y": -64.227819112,
		"h": 7
	},
	{
		"stop_id": 8593167,
		"ID": 11,
		"x": -162.3722347517,
		"y": -64.736753953,
		"h": 7
	},
	{
		"stop_id": 8593170,
		"ID": 11,
		"x": -162.9822885747,
		"y": -65.40880098,
		"h": 7
	},
	{
		"stop_id": 8593171,
		"ID": 11,
		"x": -162.7812296907,
		"y": -64.501764293,
		"h": 7
	},
	{
		"stop_id": 8593174,
		"ID": 11,
		"x": -162.4202751297,
		"y": -64.551821796,
		"h": 7
	},
	{
		"stop_id": 8593178,
		"ID": 11,
		"x": -163.3272947727,
		"y": -65.65083615,
		"h": 7
	},
	{
		"stop_id": 8593194,
		"ID": 11,
		"x": -159.9402832847,
		"y": -68.200802626,
		"h": 7
	},
	{
		"stop_id": 8593196,
		"ID": 11,
		"x": -159.7492507847,
		"y": -68.596765593,
		"h": 7
	},
	{
		"stop_id": 8593199,
		"ID": 11,
		"x": -160.1112402357,
		"y": -68.304813528,
		"h": 7
	},
	{
		"stop_id": 8593208,
		"ID": 11,
		"x": -159.0442415417,
		"y": -67.937848314,
		"h": 7
	},
	{
		"stop_id": 8595015,
		"ID": 11,
		"x": -160.0742610477,
		"y": -67.574857165,
		"h": 7
	},
	{
		"stop_id": 8595018,
		"ID": 11,
		"x": -161.9602898817,
		"y": -64.602754489,
		"h": 7
	},
	{
		"stop_id": 8595021,
		"ID": 11,
		"x": -159.4312294727,
		"y": -65.25580972,
		"h": 7
	},
	{
		"stop_id": 8595022,
		"ID": 11,
		"x": -159.8342237477,
		"y": -64.994770734,
		"h": 7
	},
	{
		"stop_id": 8595025,
		"ID": 11,
		"x": -161.6932927267,
		"y": -65.592773352,
		"h": 7
	},
	{
		"stop_id": 8595033,
		"ID": 11,
		"x": -162.4682296367,
		"y": -65.888854311,
		"h": 7
	},
	{
		"stop_id": 8595035,
		"ID": 11,
		"x": -160.0702662207,
		"y": -69.117781226,
		"h": 7
	},
	{
		"stop_id": 8595036,
		"ID": 11,
		"x": -162.6982386247,
		"y": -69.096759485,
		"h": 7
	},
	{
		"stop_id": 8595037,
		"ID": 11,
		"x": -161.1232493587,
		"y": -69.355834856,
		"h": 7
	},
	{
		"stop_id": 8595038,
		"ID": 11,
		"x": -161.1662729787,
		"y": -69.963831656,
		"h": 7
	},
	{
		"stop_id": 8530022,
		"ID": 325,
		"x": -77.4722632027,
		"y": -18.679830953,
		"h": 1
	},
	{
		"stop_id": 8530055,
		"ID": 139,
		"x": -104.8242569987,
		"y": -55.641824736,
		"h": 1
	},
	{
		"stop_id": 8530096,
		"ID": 344,
		"x": -74.1102239347,
		"y": -78.138803249,
		"h": 1.1978021978
	},
	{
		"stop_id": 8530097,
		"ID": 344,
		"x": -72.9102810327,
		"y": -77.214856372,
		"h": 1.1978021978
	},
	{
		"stop_id": 8530098,
		"ID": 344,
		"x": -72.1032438297,
		"y": -77.561848713,
		"h": 1.1978021978
	},
	{
		"stop_id": 8530100,
		"ID": 344,
		"x": -72.0762332197,
		"y": -76.720817303,
		"h": 1.1978021978
	},
	{
		"stop_id": 8530101,
		"ID": 344,
		"x": -70.3102995017,
		"y": -78.828780456,
		"h": 1.1978021978
	},
	{
		"stop_id": 8530102,
		"ID": 344,
		"x": -69.0532307507,
		"y": -79.385799863,
		"h": 1.1978021978
	},
	{
		"stop_id": 8530103,
		"ID": 344,
		"x": -72.7642579437,
		"y": -79.391818605,
		"h": 1.1978021978
	},
	{
		"stop_id": 8530152,
		"ID": 379,
		"x": -63.8102771067,
		"y": -53.587845773,
		"h": 1.2307692308
	},
	{
		"stop_id": 8570760,
		"ID": 379,
		"x": -68.5312983477,
		"y": -54.720763853,
		"h": 1.2307692308
	},
	{
		"stop_id": 8570761,
		"ID": 379,
		"x": -68.2482697247,
		"y": -54.531857842,
		"h": 1.2307692308
	},
	{
		"stop_id": 8570762,
		"ID": 379,
		"x": -67.8992596757,
		"y": -54.474759758,
		"h": 1.2307692308
	},
	{
		"stop_id": 8570763,
		"ID": 379,
		"x": -67.6382300197,
		"y": -54.235770813,
		"h": 1.2307692308
	},
	{
		"stop_id": 8570764,
		"ID": 379,
		"x": -68.4292241807,
		"y": -54.14485396,
		"h": 1.2307692308
	},
	{
		"stop_id": 8570765,
		"ID": 379,
		"x": -68.7302768847,
		"y": -53.928749128,
		"h": 1.2307692308
	},
	{
		"stop_id": 8570766,
		"ID": 379,
		"x": -68.9592388997,
		"y": -53.684838075,
		"h": 1.2307692308
	},
	{
		"stop_id": 8530173,
		"ID": 440,
		"x": -55.8722568567,
		"y": -47.175840121,
		"h": 1
	},
	{
		"stop_id": 8530195,
		"ID": 666,
		"x": -22.3872375797,
		"y": -59.774809408,
		"h": 1
	},
	{
		"stop_id": 8530208,
		"ID": 530,
		"x": -38.7542970487,
		"y": -89.1787662638,
		"h": 1
	},
	{
		"stop_id": 8530210,
		"ID": 563,
		"x": -37.1742999367,
		"y": -95.0328222408,
		"h": 1.032967033
	},
	{
		"stop_id": 8530211,
		"ID": 563,
		"x": -37.7612916457,
		"y": -91.4387662981,
		"h": 1.032967033
	},
	{
		"stop_id": 8530215,
		"ID": 597,
		"x": -31.9592751437,
		"y": -85.8408563876,
		"h": 1.032967033
	},
	{
		"stop_id": 8530217,
		"ID": 597,
		"x": -32.8512531337,
		"y": -86.3738012763,
		"h": 1.032967033
	},
	{
		"stop_id": 8530228,
		"ID": 695,
		"x": -17.2062272607,
		"y": -72.583806929,
		"h": 1
	},
	{
		"stop_id": 8530320,
		"ID": 733,
		"x": -13.1532506487,
		"y": -18.842757056,
		"h": 1.3296703297
	},
	{
		"stop_id": 8530321,
		"ID": 733,
		"x": -12.4192921407,
		"y": -19.480809405,
		"h": 1.3296703297
	},
	{
		"stop_id": 8576512,
		"ID": 733,
		"x": -13.2182870267,
		"y": -18.623811949,
		"h": 1.3296703297
	},
	{
		"stop_id": 8576513,
		"ID": 733,
		"x": -12.9572659397,
		"y": -18.190782605,
		"h": 1.3296703297
	},
	{
		"stop_id": 8582480,
		"ID": 733,
		"x": -13.1872439407,
		"y": -18.824788502,
		"h": 1.3296703297
	},
	{
		"stop_id": 8582481,
		"ID": 733,
		"x": -13.1242278107,
		"y": -19.019847489,
		"h": 1.3296703297
	},
	{
		"stop_id": 8582482,
		"ID": 733,
		"x": -13.1672740117,
		"y": -19.207835065,
		"h": 1.3296703297
	},
	{
		"stop_id": 8582483,
		"ID": 733,
		"x": -13.3342826737,
		"y": -19.442804189,
		"h": 1.3296703297
	},
	{
		"stop_id": 8582484,
		"ID": 733,
		"x": -13.5922951787,
		"y": -19.619770027,
		"h": 1.3296703297
	},
	{
		"stop_id": 8582485,
		"ID": 733,
		"x": -13.2072639827,
		"y": -19.939750623,
		"h": 1.3296703297
	},
	{
		"stop_id": 8594331,
		"ID": 733,
		"x": -13.0492761517,
		"y": -18.39382634,
		"h": 1.3296703297
	},
	{
		"stop_id": 8530368,
		"ID": 897,
		"x": 17.4017297073,
		"y": 1.325210882,
		"h": 1.0659340659
	},
	{
		"stop_id": 8530369,
		"ID": 897,
		"x": 18.8557518693,
		"y": 1.275182357,
		"h": 1.0659340659
	},
	{
		"stop_id": 8595403,
		"ID": 897,
		"x": 17.4127753783,
		"y": 1.315235995,
		"h": 1.0659340659
	},
	{
		"stop_id": 8530375,
		"ID": 898,
		"x": 16.2437717593,
		"y": 9.101186412,
		"h": 1
	},
	{
		"stop_id": 8530405,
		"ID": 1033,
		"x": 41.5657297273,
		"y": 25.348225442,
		"h": 1.4285714286
	},
	{
		"stop_id": 8530820,
		"ID": 1033,
		"x": 37.7207150803,
		"y": 23.661171412,
		"h": 1.4285714286
	},
	{
		"stop_id": 8577491,
		"ID": 1033,
		"x": 35.7236995413,
		"y": 24.643237391,
		"h": 1.4285714286
	},
	{
		"stop_id": 8577492,
		"ID": 1033,
		"x": 35.6647618783,
		"y": 24.776162723,
		"h": 1.4285714286
	},
	{
		"stop_id": 8577493,
		"ID": 1033,
		"x": 36.7957014753,
		"y": 24.665157363,
		"h": 1.4285714286
	},
	{
		"stop_id": 8577494,
		"ID": 1033,
		"x": 36.9967020043,
		"y": 24.492182583,
		"h": 1.4285714286
	},
	{
		"stop_id": 8577495,
		"ID": 1033,
		"x": 37.4647067113,
		"y": 24.434189391,
		"h": 1.4285714286
	},
	{
		"stop_id": 8577496,
		"ID": 1033,
		"x": 37.9877617933,
		"y": 24.294188951,
		"h": 1.4285714286
	},
	{
		"stop_id": 8577497,
		"ID": 1033,
		"x": 38.6377205983,
		"y": 24.398156838,
		"h": 1.4285714286
	},
	{
		"stop_id": 8577498,
		"ID": 1033,
		"x": 38.4847459563,
		"y": 24.755214985,
		"h": 1.4285714286
	},
	{
		"stop_id": 8577499,
		"ID": 1033,
		"x": 38.6867736693,
		"y": 25.615241883,
		"h": 1.4285714286
	},
	{
		"stop_id": 8577500,
		"ID": 1033,
		"x": 38.9297183263,
		"y": 25.487165208,
		"h": 1.4285714286
	},
	{
		"stop_id": 8577501,
		"ID": 1033,
		"x": 40.0417250743,
		"y": 25.809205761,
		"h": 1.4285714286
	},
	{
		"stop_id": 8595500,
		"ID": 1033,
		"x": 36.3847684233,
		"y": 25.95918164,
		"h": 1.4285714286
	},
	{
		"stop_id": 8530423,
		"ID": 1031,
		"x": 37.0517006283,
		"y": 12.019189357,
		"h": 1
	},
	{
		"stop_id": 8530483,
		"ID": 1246,
		"x": 70.0987496783,
		"y": 49.714177913,
		"h": 1
	},
	{
		"stop_id": 8530495,
		"ID": 1302,
		"x": 78.0947605173,
		"y": 32.230180295,
		"h": 1.032967033
	},
	{
		"stop_id": 8530842,
		"ID": 1302,
		"x": 79.3187725183,
		"y": 33.717175666,
		"h": 1.032967033
	},
	{
		"stop_id": 8530516,
		"ID": 1175,
		"x": 60.2527622423,
		"y": 38.033190949,
		"h": 1
	},
	{
		"stop_id": 8530528,
		"ID": 1423,
		"x": 103.7097453663,
		"y": 26.506160729,
		"h": 1
	},
	{
		"stop_id": 8530534,
		"ID": 1488,
		"x": 125.0367381623,
		"y": 14.848151351,
		"h": 1.2307692308
	},
	{
		"stop_id": 8581199,
		"ID": 1488,
		"x": 123.7577495853,
		"y": 13.780148265,
		"h": 1.2307692308
	},
	{
		"stop_id": 8581203,
		"ID": 1488,
		"x": 120.9527346103,
		"y": 15.588196805,
		"h": 1.2307692308
	},
	{
		"stop_id": 8581204,
		"ID": 1488,
		"x": 122.0447076053,
		"y": 14.915184025,
		"h": 1.2307692308
	},
	{
		"stop_id": 8581440,
		"ID": 1488,
		"x": 122.7767498933,
		"y": 14.620188704,
		"h": 1.2307692308
	},
	{
		"stop_id": 8581441,
		"ID": 1488,
		"x": 121.4887583473,
		"y": 15.006177415,
		"h": 1.2307692308
	},
	{
		"stop_id": 8581442,
		"ID": 1488,
		"x": 121.3637702293,
		"y": 15.229166497,
		"h": 1.2307692308
	},
	{
		"stop_id": 8583544,
		"ID": 1488,
		"x": 121.2107028963,
		"y": 15.501245538,
		"h": 1.2307692308
	},
	{
		"stop_id": 8530583,
		"ID": 1393,
		"x": 100.1227295893,
		"y": -1.159782327,
		"h": 1.1318681319
	},
	{
		"stop_id": 8530585,
		"ID": 1393,
		"x": 100.2107124103,
		"y": -5.989816618,
		"h": 1.1318681319
	},
	{
		"stop_id": 8530586,
		"ID": 1393,
		"x": 98.6677322373,
		"y": -5.959835598,
		"h": 1.1318681319
	},
	{
		"stop_id": 8582825,
		"ID": 1393,
		"x": 101.5047428153,
		"y": -3.553851683,
		"h": 1.1318681319
	},
	{
		"stop_id": 8582834,
		"ID": 1393,
		"x": 101.4177322493,
		"y": -4.45185661,
		"h": 1.1318681319
	},
	{
		"stop_id": 8530596,
		"ID": 1431,
		"x": 109.9897507533,
		"y": -46.111846661,
		"h": 1.1648351648
	},
	{
		"stop_id": 8574963,
		"ID": 1431,
		"x": 111.1467671683,
		"y": -44.1348123,
		"h": 1.1648351648
	},
	{
		"stop_id": 8574964,
		"ID": 1431,
		"x": 110.9637380493,
		"y": -45.035783778,
		"h": 1.1648351648
	},
	{
		"stop_id": 8574965,
		"ID": 1431,
		"x": 110.8007325243,
		"y": -45.151824682,
		"h": 1.1648351648
	},
	{
		"stop_id": 8574966,
		"ID": 1431,
		"x": 109.9407459143,
		"y": -46.055841068,
		"h": 1.1648351648
	},
	{
		"stop_id": 8574967,
		"ID": 1431,
		"x": 108.9137694663,
		"y": -46.639779747,
		"h": 1.1648351648
	},
	{
		"stop_id": 8530781,
		"ID": 1099,
		"x": 49.5757480553,
		"y": 14.425163985,
		"h": 1.0989010989
	},
	{
		"stop_id": 8530782,
		"ID": 1099,
		"x": 47.5037704673,
		"y": 14.226174665,
		"h": 1.0989010989
	},
	{
		"stop_id": 8587691,
		"ID": 1099,
		"x": 47.5147598723,
		"y": 14.242160576,
		"h": 1.0989010989
	},
	{
		"stop_id": 8587795,
		"ID": 1099,
		"x": 46.8437214863,
		"y": 15.943225652,
		"h": 1.0989010989
	},
	{
		"stop_id": 8530825,
		"ID": 669,
		"x": -18.2982690017,
		"y": -43.939816885,
		"h": 1
	},
	{
		"stop_id": 8530839,
		"ID": 998,
		"x": 34.4347518533,
		"y": 18.822218639,
		"h": 1.1648351648
	},
	{
		"stop_id": 8573134,
		"ID": 998,
		"x": 31.8727660563,
		"y": 17.935145232,
		"h": 1.1648351648
	},
	{
		"stop_id": 8573135,
		"ID": 998,
		"x": 32.4567393293,
		"y": 17.797145877,
		"h": 1.1648351648
	},
	{
		"stop_id": 8573136,
		"ID": 998,
		"x": 32.8217011033,
		"y": 17.70216902,
		"h": 1.1648351648
	},
	{
		"stop_id": 8573137,
		"ID": 998,
		"x": 33.6807176773,
		"y": 17.678184949,
		"h": 1.1648351648
	},
	{
		"stop_id": 8573139,
		"ID": 998,
		"x": 35.2407340293,
		"y": 17.686222016,
		"h": 1.1648351648
	},
	{
		"stop_id": 8531253,
		"ID": 1224,
		"x": 67.6167327633,
		"y": -77.553799757,
		"h": 1
	},
	{
		"stop_id": 8570022,
		"ID": 37,
		"x": -150.8512838567,
		"y": -26.186849441,
		"h": 1.0989010989
	},
	{
		"stop_id": 8583861,
		"ID": 37,
		"x": -149.5312835477,
		"y": -28.337782949,
		"h": 1.0989010989
	},
	{
		"stop_id": 8583862,
		"ID": 37,
		"x": -150.5612741917,
		"y": -27.378847092,
		"h": 1.0989010989
	},
	{
		"stop_id": 8583878,
		"ID": 37,
		"x": -151.0332596207,
		"y": -25.225839583,
		"h": 1.0989010989
	},
	{
		"stop_id": 8570023,
		"ID": 28,
		"x": -153.8192944667,
		"y": -22.89778007,
		"h": 1.0989010989
	},
	{
		"stop_id": 8595463,
		"ID": 28,
		"x": -155.5642547467,
		"y": -24.014783415,
		"h": 1.0989010989
	},
	{
		"stop_id": 8595465,
		"ID": 28,
		"x": -153.9142388157,
		"y": -22.968780723,
		"h": 1.0989010989
	},
	{
		"stop_id": 8595466,
		"ID": 28,
		"x": -154.3062788937,
		"y": -23.226781895,
		"h": 1.0989010989
	},
	{
		"stop_id": 8570037,
		"ID": 49,
		"x": -143.6102694677,
		"y": -36.279820128,
		"h": 1.1318681319
	},
	{
		"stop_id": 8570039,
		"ID": 49,
		"x": -143.1422529177,
		"y": -36.15280316,
		"h": 1.1318681319
	},
	{
		"stop_id": 8570040,
		"ID": 49,
		"x": -142.3112285997,
		"y": -35.602827525,
		"h": 1.1318681319
	},
	{
		"stop_id": 8570041,
		"ID": 49,
		"x": -141.9752257867,
		"y": -35.433773266,
		"h": 1.1318681319
	},
	{
		"stop_id": 8582676,
		"ID": 49,
		"x": -143.4862357017,
		"y": -36.177820519,
		"h": 1.1318681319
	},
	{
		"stop_id": 8570154,
		"ID": 53,
		"x": -138.5802666217,
		"y": -15.965847205,
		"h": 1.1978021978
	},
	{
		"stop_id": 8570155,
		"ID": 53,
		"x": -138.7032317357,
		"y": -16.128769728,
		"h": 1.1978021978
	},
	{
		"stop_id": 8570156,
		"ID": 53,
		"x": -139.0532748927,
		"y": -16.711826834,
		"h": 1.1978021978
	},
	{
		"stop_id": 8570158,
		"ID": 53,
		"x": -141.7422961087,
		"y": -15.569788468,
		"h": 1.1978021978
	},
	{
		"stop_id": 8570159,
		"ID": 53,
		"x": -143.1922524397,
		"y": -14.444794906,
		"h": 1.1978021978
	},
	{
		"stop_id": 8570160,
		"ID": 53,
		"x": -144.0482333027,
		"y": -14.582797596,
		"h": 1.1978021978
	},
	{
		"stop_id": 8580863,
		"ID": 53,
		"x": -142.4922883957,
		"y": -15.469765572,
		"h": 1.1978021978
	},
	{
		"stop_id": 8570172,
		"ID": 105,
		"x": -115.9182875617,
		"y": -18.562826497,
		"h": 1.5274725275
	},
	{
		"stop_id": 8570173,
		"ID": 105,
		"x": -114.6472321637,
		"y": -18.075775163,
		"h": 1.5274725275
	},
	{
		"stop_id": 8570174,
		"ID": 105,
		"x": -114.2522364947,
		"y": -17.67482839,
		"h": 1.5274725275
	},
	{
		"stop_id": 8570175,
		"ID": 105,
		"x": -114.2452956127,
		"y": -16.540837194,
		"h": 1.5274725275
	},
	{
		"stop_id": 8570207,
		"ID": 105,
		"x": -118.9902398677,
		"y": -17.174856969,
		"h": 1.5274725275
	},
	{
		"stop_id": 8570208,
		"ID": 105,
		"x": -118.7072580357,
		"y": -17.505825317,
		"h": 1.5274725275
	},
	{
		"stop_id": 8570209,
		"ID": 105,
		"x": -118.2402811417,
		"y": -17.152760424,
		"h": 1.5274725275
	},
	{
		"stop_id": 8570210,
		"ID": 105,
		"x": -118.0922542917,
		"y": -17.694830017,
		"h": 1.5274725275
	},
	{
		"stop_id": 8570211,
		"ID": 105,
		"x": -117.8322902237,
		"y": -18.037761121,
		"h": 1.5274725275
	},
	{
		"stop_id": 8570212,
		"ID": 105,
		"x": -117.6132592857,
		"y": -18.19685295,
		"h": 1.5274725275
	},
	{
		"stop_id": 8570215,
		"ID": 105,
		"x": -116.1242928307,
		"y": -15.864769087,
		"h": 1.5274725275
	},
	{
		"stop_id": 8570216,
		"ID": 105,
		"x": -116.0142485687,
		"y": -18.406843135,
		"h": 1.5274725275
	},
	{
		"stop_id": 8570217,
		"ID": 105,
		"x": -116.3382288607,
		"y": -17.506753921,
		"h": 1.5274725275
	},
	{
		"stop_id": 8570218,
		"ID": 105,
		"x": -115.1762452557,
		"y": -16.075832065,
		"h": 1.5274725275
	},
	{
		"stop_id": 8570219,
		"ID": 105,
		"x": -115.3102812997,
		"y": -16.428782281,
		"h": 1.5274725275
	},
	{
		"stop_id": 8579669,
		"ID": 105,
		"x": -118.0422420687,
		"y": -17.92277336,
		"h": 1.5274725275
	},
	{
		"stop_id": 8583395,
		"ID": 105,
		"x": -115.7012699967,
		"y": -18.89581163,
		"h": 1.5274725275
	},
	{
		"stop_id": 8570758,
		"ID": 348,
		"x": -68.5782985317,
		"y": -55.714846507,
		"h": 1.032967033
	},
	{
		"stop_id": 8570759,
		"ID": 348,
		"x": -69.3212614217,
		"y": -54.579818508,
		"h": 1.032967033
	},
	{
		"stop_id": 8570804,
		"ID": 409,
		"x": -60.0412701257,
		"y": -52.428799775,
		"h": 1.0659340659
	},
	{
		"stop_id": 8570805,
		"ID": 409,
		"x": -59.8312922077,
		"y": -51.319825249,
		"h": 1.0659340659
	},
	{
		"stop_id": 8570806,
		"ID": 409,
		"x": -60.0102379657,
		"y": -49.792853237,
		"h": 1.0659340659
	},
	{
		"stop_id": 8570901,
		"ID": 436,
		"x": -58.7653003857,
		"y": -71.167798342,
		"h": 1.3296703297
	},
	{
		"stop_id": 8570902,
		"ID": 436,
		"x": -58.4942736767,
		"y": -71.629757524,
		"h": 1.3296703297
	},
	{
		"stop_id": 8570903,
		"ID": 436,
		"x": -57.4722955587,
		"y": -72.788823311,
		"h": 1.3296703297
	},
	{
		"stop_id": 8570935,
		"ID": 436,
		"x": -58.8562948467,
		"y": -69.542788144,
		"h": 1.3296703297
	},
	{
		"stop_id": 8570936,
		"ID": 436,
		"x": -57.6232342607,
		"y": -71.1378386,
		"h": 1.3296703297
	},
	{
		"stop_id": 8574193,
		"ID": 436,
		"x": -57.4572284287,
		"y": -71.303750983,
		"h": 1.3296703297
	},
	{
		"stop_id": 8580267,
		"ID": 436,
		"x": -58.0132836507,
		"y": -72.037846548,
		"h": 1.3296703297
	},
	{
		"stop_id": 8580393,
		"ID": 436,
		"x": -58.7422677117,
		"y": -70.227775819,
		"h": 1.3296703297
	},
	{
		"stop_id": 8581102,
		"ID": 436,
		"x": -58.6672786257,
		"y": -69.671823321,
		"h": 1.3296703297
	},
	{
		"stop_id": 8581565,
		"ID": 436,
		"x": -57.2502509167,
		"y": -71.506772038,
		"h": 1.3296703297
	},
	{
		"stop_id": 8582950,
		"ID": 436,
		"x": -57.8552415577,
		"y": -70.851771452,
		"h": 1.3296703297
	},
	{
		"stop_id": 8570909,
		"ID": 434,
		"x": -54.6572508447,
		"y": -79.527831094,
		"h": 1.1978021978
	},
	{
		"stop_id": 8570910,
		"ID": 434,
		"x": -55.1752913857,
		"y": -78.770859178,
		"h": 1.1978021978
	},
	{
		"stop_id": 8570911,
		"ID": 434,
		"x": -55.6642777277,
		"y": -79.767810593,
		"h": 1.1978021978
	},
	{
		"stop_id": 8570912,
		"ID": 434,
		"x": -55.7432266407,
		"y": -82.341817575,
		"h": 1.1978021978
	},
	{
		"stop_id": 8570913,
		"ID": 434,
		"x": -55.8872665187,
		"y": -82.960775342,
		"h": 1.1978021978
	},
	{
		"stop_id": 8570914,
		"ID": 434,
		"x": -55.9432524007,
		"y": -83.8087917968,
		"h": 1.1978021978
	},
	{
		"stop_id": 8583763,
		"ID": 434,
		"x": -55.6733003627,
		"y": -81.455772128,
		"h": 1.1978021978
	},
	{
		"stop_id": 8570941,
		"ID": 437,
		"x": -57.9952991887,
		"y": -63.322780439,
		"h": 1
	},
	{
		"stop_id": 8571552,
		"ID": 585,
		"x": -35.8982982357,
		"y": 35.648181023,
		"h": 1.1648351648
	},
	{
		"stop_id": 8571554,
		"ID": 585,
		"x": -36.2402833407,
		"y": 33.277241092,
		"h": 1.1648351648
	},
	{
		"stop_id": 8571555,
		"ID": 585,
		"x": -35.2652275627,
		"y": 33.56721156,
		"h": 1.1648351648
	},
	{
		"stop_id": 8571559,
		"ID": 585,
		"x": -33.9942560857,
		"y": 35.404168904,
		"h": 1.1648351648
	},
	{
		"stop_id": 8588630,
		"ID": 585,
		"x": -36.1512956037,
		"y": 31.623203599,
		"h": 1.1648351648
	},
	{
		"stop_id": 8589194,
		"ID": 585,
		"x": -33.9032573107,
		"y": 33.055209885,
		"h": 1.1648351648
	},
	{
		"stop_id": 8571564,
		"ID": 652,
		"x": -25.9672312577,
		"y": 37.21514572,
		"h": 1.2967032967
	},
	{
		"stop_id": 8571565,
		"ID": 652,
		"x": -26.6362636017,
		"y": 38.628227593,
		"h": 1.2967032967
	},
	{
		"stop_id": 8571566,
		"ID": 652,
		"x": -26.8822935707,
		"y": 39.100145779,
		"h": 1.2967032967
	},
	{
		"stop_id": 8572770,
		"ID": 652,
		"x": -23.9092365657,
		"y": 39.561211375,
		"h": 1.2967032967
	},
	{
		"stop_id": 8572771,
		"ID": 652,
		"x": -24.0422345537,
		"y": 39.922183995,
		"h": 1.2967032967
	},
	{
		"stop_id": 8572772,
		"ID": 652,
		"x": -24.2252841647,
		"y": 40.489206514,
		"h": 1.2967032967
	},
	{
		"stop_id": 8572773,
		"ID": 652,
		"x": -24.6542662487,
		"y": 41.066232806,
		"h": 1.2967032967
	},
	{
		"stop_id": 8572774,
		"ID": 652,
		"x": -25.7842570627,
		"y": 41.960222614,
		"h": 1.2967032967
	},
	{
		"stop_id": 8572775,
		"ID": 652,
		"x": -25.9982938087,
		"y": 42.32322434,
		"h": 1.2967032967
	},
	{
		"stop_id": 8577646,
		"ID": 652,
		"x": -25.5692946817,
		"y": 41.797242566,
		"h": 1.2967032967
	},
	{
		"stop_id": 8571602,
		"ID": 841,
		"x": 6.5177001553,
		"y": -7.725804268,
		"h": 1.1318681319
	},
	{
		"stop_id": 8571603,
		"ID": 841,
		"x": 7.5067589033,
		"y": -7.795846514,
		"h": 1.1318681319
	},
	{
		"stop_id": 8571604,
		"ID": 841,
		"x": 7.5127512063,
		"y": -7.477821353,
		"h": 1.1318681319
	},
	{
		"stop_id": 8571605,
		"ID": 841,
		"x": 8.5537666193,
		"y": -6.848821585,
		"h": 1.1318681319
	},
	{
		"stop_id": 8582258,
		"ID": 841,
		"x": 9.0227655303,
		"y": -6.515832652,
		"h": 1.1318681319
	},
	{
		"stop_id": 8571608,
		"ID": 816,
		"x": 2.3867057863,
		"y": -12.408797243,
		"h": 1.0659340659
	},
	{
		"stop_id": 8571609,
		"ID": 816,
		"x": 3.4807615933,
		"y": -13.430840951,
		"h": 1.0659340659
	},
	{
		"stop_id": 8571610,
		"ID": 816,
		"x": 3.7757481543,
		"y": -13.572809082,
		"h": 1.0659340659
	},
	{
		"stop_id": 8571811,
		"ID": 100,
		"x": -118.6272843967,
		"y": 24.973152226,
		"h": 1.0989010989
	},
	{
		"stop_id": 8571812,
		"ID": 100,
		"x": -119.1332930967,
		"y": 24.487218118,
		"h": 1.0989010989
	},
	{
		"stop_id": 8571813,
		"ID": 100,
		"x": -119.8722471907,
		"y": 23.346170332,
		"h": 1.0989010989
	},
	{
		"stop_id": 8571814,
		"ID": 100,
		"x": -120.7552991397,
		"y": 22.758239137,
		"h": 1.0989010989
	},
	{
		"stop_id": 8571863,
		"ID": 87,
		"x": -123.7342505287,
		"y": 16.510192644,
		"h": 1.2637362637
	},
	{
		"stop_id": 8571864,
		"ID": 87,
		"x": -124.0562601047,
		"y": 17.189168992,
		"h": 1.2637362637
	},
	{
		"stop_id": 8571873,
		"ID": 87,
		"x": -128.7202595957,
		"y": 15.782202624,
		"h": 1.2637362637
	},
	{
		"stop_id": 8571874,
		"ID": 87,
		"x": -129.2742677707,
		"y": 15.968188278,
		"h": 1.2637362637
	},
	{
		"stop_id": 8571875,
		"ID": 87,
		"x": -128.8712699497,
		"y": 17.333216704,
		"h": 1.2637362637
	},
	{
		"stop_id": 8571876,
		"ID": 87,
		"x": -128.5582298307,
		"y": 17.752183552,
		"h": 1.2637362637
	},
	{
		"stop_id": 8571877,
		"ID": 87,
		"x": -128.0232892207,
		"y": 18.606218147,
		"h": 1.2637362637
	},
	{
		"stop_id": 8571878,
		"ID": 87,
		"x": -127.3582328757,
		"y": 19.021225318,
		"h": 1.2637362637
	},
	{
		"stop_id": 8571879,
		"ID": 87,
		"x": -126.8602538767,
		"y": 19.328229841,
		"h": 1.2637362637
	},
	{
		"stop_id": 8571880,
		"ID": 88,
		"x": -125.7602795787,
		"y": 19.879171834,
		"h": 1.0659340659
	},
	{
		"stop_id": 8571881,
		"ID": 88,
		"x": -124.7112687027,
		"y": 20.039190862,
		"h": 1.0659340659
	},
	{
		"stop_id": 8583695,
		"ID": 88,
		"x": -125.5582538787,
		"y": 19.952204757,
		"h": 1.0659340659
	},
	{
		"stop_id": 8571962,
		"ID": 367,
		"x": -69.8192907387,
		"y": 53.316241591,
		"h": 1.0989010989
	},
	{
		"stop_id": 8571963,
		"ID": 367,
		"x": -71.7062417347,
		"y": 53.612170953,
		"h": 1.0989010989
	},
	{
		"stop_id": 8572032,
		"ID": 367,
		"x": -72.7412575007,
		"y": 56.66824167,
		"h": 1.0989010989
	},
	{
		"stop_id": 8572033,
		"ID": 367,
		"x": -72.3722563177,
		"y": 56.608180704,
		"h": 1.0989010989
	},
	{
		"stop_id": 8572005,
		"ID": 369,
		"x": -69.6282800577,
		"y": 67.136151336,
		"h": 1.2637362637
	},
	{
		"stop_id": 8572006,
		"ID": 369,
		"x": -70.6362824897,
		"y": 67.690179758,
		"h": 1.2637362637
	},
	{
		"stop_id": 8572007,
		"ID": 369,
		"x": -70.7982465917,
		"y": 68.186248328,
		"h": 1.2637362637
	},
	{
		"stop_id": 8572012,
		"ID": 369,
		"x": -70.1232994467,
		"y": 62.892174102,
		"h": 1.2637362637
	},
	{
		"stop_id": 8572015,
		"ID": 369,
		"x": -72.1712486707,
		"y": 63.447160107,
		"h": 1.2637362637
	},
	{
		"stop_id": 8572016,
		"ID": 369,
		"x": -72.1952921807,
		"y": 64.722247685,
		"h": 1.2637362637
	},
	{
		"stop_id": 8572017,
		"ID": 369,
		"x": -72.6892784247,
		"y": 65.448222974,
		"h": 1.2637362637
	},
	{
		"stop_id": 8572018,
		"ID": 369,
		"x": -74.0662496117,
		"y": 66.483187648,
		"h": 1.2637362637
	},
	{
		"stop_id": 8582584,
		"ID": 369,
		"x": -70.9302973757,
		"y": 68.16615159,
		"h": 1.2637362637
	},
	{
		"stop_id": 8572019,
		"ID": 340,
		"x": -74.4072918797,
		"y": 67.057175613,
		"h": 1.4615384615
	},
	{
		"stop_id": 8572020,
		"ID": 340,
		"x": -74.4812466717,
		"y": 69.300153778,
		"h": 1.4615384615
	},
	{
		"stop_id": 8572092,
		"ID": 340,
		"x": -77.8682483577,
		"y": 68.815167649,
		"h": 1.4615384615
	},
	{
		"stop_id": 8572093,
		"ID": 340,
		"x": -77.1792976937,
		"y": 68.602173055,
		"h": 1.4615384615
	},
	{
		"stop_id": 8572094,
		"ID": 340,
		"x": -76.9412454157,
		"y": 67.596151304,
		"h": 1.4615384615
	},
	{
		"stop_id": 8572095,
		"ID": 340,
		"x": -76.8962783727,
		"y": 67.199206768,
		"h": 1.4615384615
	},
	{
		"stop_id": 8572098,
		"ID": 340,
		"x": -78.4622427447,
		"y": 69.968224534,
		"h": 1.4615384615
	},
	{
		"stop_id": 8572099,
		"ID": 340,
		"x": -77.4532572447,
		"y": 69.861148058,
		"h": 1.4615384615
	},
	{
		"stop_id": 8572100,
		"ID": 340,
		"x": -76.9442913127,
		"y": 69.991170811,
		"h": 1.4615384615
	},
	{
		"stop_id": 8572101,
		"ID": 340,
		"x": -76.2402927717,
		"y": 70.069209509,
		"h": 1.4615384615
	},
	{
		"stop_id": 8580762,
		"ID": 340,
		"x": -74.3082641497,
		"y": 67.751158061,
		"h": 1.4615384615
	},
	{
		"stop_id": 8580764,
		"ID": 340,
		"x": -74.3562536997,
		"y": 66.785206064,
		"h": 1.4615384615
	},
	{
		"stop_id": 8583257,
		"ID": 340,
		"x": -77.7682573137,
		"y": 69.651187011,
		"h": 1.4615384615
	},
	{
		"stop_id": 8583346,
		"ID": 340,
		"x": -78.1522467537,
		"y": 67.365212332,
		"h": 1.4615384615
	},
	{
		"stop_id": 8583347,
		"ID": 340,
		"x": -77.1872720887,
		"y": 69.987215609,
		"h": 1.4615384615
	},
	{
		"stop_id": 8572051,
		"ID": 211,
		"x": -96.3812358257,
		"y": 69.469229409,
		"h": 1.2307692308
	},
	{
		"stop_id": 8572052,
		"ID": 211,
		"x": -96.6192476637,
		"y": 69.48216324,
		"h": 1.2307692308
	},
	{
		"stop_id": 8572053,
		"ID": 211,
		"x": -97.2562448447,
		"y": 70.017199626,
		"h": 1.2307692308
	},
	{
		"stop_id": 8572060,
		"ID": 211,
		"x": -96.1982476577,
		"y": 66.385154131,
		"h": 1.2307692308
	},
	{
		"stop_id": 8572061,
		"ID": 211,
		"x": -97.2942904687,
		"y": 66.572249983,
		"h": 1.2307692308
	},
	{
		"stop_id": 8572062,
		"ID": 211,
		"x": -97.5972407327,
		"y": 66.708161263,
		"h": 1.2307692308
	},
	{
		"stop_id": 8572063,
		"ID": 211,
		"x": -97.4612331237,
		"y": 66.429217886,
		"h": 1.2307692308
	},
	{
		"stop_id": 8583348,
		"ID": 211,
		"x": -94.7182780497,
		"y": 68.630146049,
		"h": 1.2307692308
	},
	{
		"stop_id": 8572059,
		"ID": 243,
		"x": -93.1262363927,
		"y": 66.460166284,
		"h": 1.2637362637
	},
	{
		"stop_id": 8572079,
		"ID": 243,
		"x": -89.7282671117,
		"y": 66.141183088,
		"h": 1.2637362637
	},
	{
		"stop_id": 8572080,
		"ID": 243,
		"x": -90.1192896927,
		"y": 66.014208152,
		"h": 1.2637362637
	},
	{
		"stop_id": 8572081,
		"ID": 243,
		"x": -90.3082328287,
		"y": 65.864195262,
		"h": 1.2637362637
	},
	{
		"stop_id": 8583305,
		"ID": 243,
		"x": -92.8542390217,
		"y": 66.601173534,
		"h": 1.2637362637
	},
	{
		"stop_id": 8583420,
		"ID": 243,
		"x": -89.5722649327,
		"y": 67.995168086,
		"h": 1.2637362637
	},
	{
		"stop_id": 8583565,
		"ID": 243,
		"x": -91.2972369787,
		"y": 67.438206358,
		"h": 1.2637362637
	},
	{
		"stop_id": 8583566,
		"ID": 243,
		"x": -92.5792685237,
		"y": 67.021249716,
		"h": 1.2637362637
	},
	{
		"stop_id": 8583670,
		"ID": 243,
		"x": -90.4452731347,
		"y": 66.752154939,
		"h": 1.2637362637
	},
	{
		"stop_id": 8572064,
		"ID": 210,
		"x": -96.8542369367,
		"y": 65.266162958,
		"h": 1.032967033
	},
	{
		"stop_id": 8583308,
		"ID": 210,
		"x": -99.2682438417,
		"y": 62.899246966,
		"h": 1.032967033
	},
	{
		"stop_id": 8572065,
		"ID": 182,
		"x": -98.7102479757,
		"y": 64.742201224,
		"h": 1.032967033
	},
	{
		"stop_id": 8572067,
		"ID": 182,
		"x": -100.6282954867,
		"y": 64.416156551,
		"h": 1.032967033
	},
	{
		"stop_id": 8572148,
		"ID": 430,
		"x": -59.9132905767,
		"y": 70.586247466,
		"h": 1.3296703297
	},
	{
		"stop_id": 8572149,
		"ID": 430,
		"x": -61.3042944427,
		"y": 70.151183627,
		"h": 1.3296703297
	},
	{
		"stop_id": 8572150,
		"ID": 430,
		"x": -61.7162707727,
		"y": 70.369232117,
		"h": 1.3296703297
	},
	{
		"stop_id": 8572151,
		"ID": 430,
		"x": -62.6972629917,
		"y": 70.258246715,
		"h": 1.3296703297
	},
	{
		"stop_id": 8572152,
		"ID": 430,
		"x": -63.9942579127,
		"y": 70.916149904,
		"h": 1.3296703297
	},
	{
		"stop_id": 8572167,
		"ID": 430,
		"x": -59.4522674387,
		"y": 73.717199661,
		"h": 1.3296703297
	},
	{
		"stop_id": 8581246,
		"ID": 430,
		"x": -60.9442971987,
		"y": 70.190231775,
		"h": 1.3296703297
	},
	{
		"stop_id": 8581731,
		"ID": 430,
		"x": -61.3192986817,
		"y": 69.920147976,
		"h": 1.3296703297
	},
	{
		"stop_id": 8581732,
		"ID": 430,
		"x": -60.1012980997,
		"y": 69.674217756,
		"h": 1.3296703297
	},
	{
		"stop_id": 8581733,
		"ID": 430,
		"x": -60.5492982857,
		"y": 69.698171911,
		"h": 1.3296703297
	},
	{
		"stop_id": 8581829,
		"ID": 430,
		"x": -61.6542373747,
		"y": 68.833209452,
		"h": 1.3296703297
	},
	{
		"stop_id": 8572416,
		"ID": 722,
		"x": -17.9632836327,
		"y": 84.517149566,
		"h": 1.0989010989
	},
	{
		"stop_id": 8572417,
		"ID": 722,
		"x": -18.4282348167,
		"y": 84.450169251,
		"h": 1.0989010989
	},
	{
		"stop_id": 8580562,
		"ID": 722,
		"x": -15.0562366917,
		"y": 84.115215371,
		"h": 1.0989010989
	},
	{
		"stop_id": 8582522,
		"ID": 722,
		"x": -17.9992520797,
		"y": 83.385191719,
		"h": 1.0989010989
	},
	{
		"stop_id": 8572441,
		"ID": 752,
		"x": -9.6472361477,
		"y": 86.836220965,
		"h": 1.032967033
	},
	{
		"stop_id": 8580165,
		"ID": 752,
		"x": -9.4532428957,
		"y": 86.888239859,
		"h": 1.032967033
	},
	{
		"stop_id": 8572862,
		"ID": 647,
		"x": -23.8992865697,
		"y": 11.35923849,
		"h": 1.0989010989
	},
	{
		"stop_id": 8580947,
		"ID": 647,
		"x": -23.6292541127,
		"y": 10.431243861,
		"h": 1.0989010989
	},
	{
		"stop_id": 8591774,
		"ID": 647,
		"x": -26.1432243417,
		"y": 13.052153386,
		"h": 1.0989010989
	},
	{
		"stop_id": 8591788,
		"ID": 647,
		"x": -27.0792522527,
		"y": 13.53223708,
		"h": 1.0989010989
	},
	{
		"stop_id": 8573035,
		"ID": 798,
		"x": 0.6697153553,
		"y": 32.825182779,
		"h": 1.2637362637
	},
	{
		"stop_id": 8573036,
		"ID": 798,
		"x": 0.1377604363,
		"y": 33.106212823,
		"h": 1.2637362637
	},
	{
		"stop_id": 8573037,
		"ID": 798,
		"x": -0.3112379687,
		"y": 33.449154176,
		"h": 1.2637362637
	},
	{
		"stop_id": 8577286,
		"ID": 798,
		"x": -0.0862421227,
		"y": 31.702219386,
		"h": 1.2637362637
	},
	{
		"stop_id": 8577287,
		"ID": 798,
		"x": -1.2612651797,
		"y": 31.514247538,
		"h": 1.2637362637
	},
	{
		"stop_id": 8577288,
		"ID": 798,
		"x": -2.1662970527,
		"y": 30.976228801,
		"h": 1.2637362637
	},
	{
		"stop_id": 8577289,
		"ID": 798,
		"x": -3.0352550487,
		"y": 30.502175419,
		"h": 1.2637362637
	},
	{
		"stop_id": 8577290,
		"ID": 798,
		"x": -4.3382427347,
		"y": 30.684155067,
		"h": 1.2637362637
	},
	{
		"stop_id": 8588185,
		"ID": 798,
		"x": -1.8182883407,
		"y": 31.121240952,
		"h": 1.2637362637
	},
	{
		"stop_id": 8573109,
		"ID": 926,
		"x": 25.5297218623,
		"y": -14.02185489,
		"h": 1.0989010989
	},
	{
		"stop_id": 8573110,
		"ID": 926,
		"x": 24.0997663693,
		"y": -14.345837217,
		"h": 1.0989010989
	},
	{
		"stop_id": 8573111,
		"ID": 926,
		"x": 23.9047730493,
		"y": -14.178788674,
		"h": 1.0989010989
	},
	{
		"stop_id": 8583365,
		"ID": 926,
		"x": 25.9327377463,
		"y": -13.840791194,
		"h": 1.0989010989
	},
	{
		"stop_id": 8573112,
		"ID": 925,
		"x": 22.7627465223,
		"y": -15.187841444,
		"h": 1.0659340659
	},
	{
		"stop_id": 8573146,
		"ID": 925,
		"x": 24.4217542923,
		"y": -19.798796092,
		"h": 1.0659340659
	},
	{
		"stop_id": 8580792,
		"ID": 925,
		"x": 23.3047238283,
		"y": -15.195825918,
		"h": 1.0659340659
	},
	{
		"stop_id": 8574024,
		"ID": 1304,
		"x": 78.0277705123,
		"y": 44.926190107,
		"h": 1.0659340659
	},
	{
		"stop_id": 8574025,
		"ID": 1304,
		"x": 78.8236990743,
		"y": 45.202244074,
		"h": 1.0659340659
	},
	{
		"stop_id": 8578574,
		"ID": 1304,
		"x": 80.2577338053,
		"y": 40.130242754,
		"h": 1.0659340659
	},
	{
		"stop_id": 8574030,
		"ID": 1353,
		"x": 86.6567329253,
		"y": 46.777241693,
		"h": 1.0989010989
	},
	{
		"stop_id": 8574031,
		"ID": 1353,
		"x": 87.8877106093,
		"y": 46.691146111,
		"h": 1.0989010989
	},
	{
		"stop_id": 8574032,
		"ID": 1353,
		"x": 89.2787021933,
		"y": 46.48920646,
		"h": 1.0989010989
	},
	{
		"stop_id": 8574033,
		"ID": 1353,
		"x": 90.6337310973,
		"y": 46.73619975,
		"h": 1.0989010989
	},
	{
		"stop_id": 8574513,
		"ID": 1465,
		"x": 120.4877595443,
		"y": -34.174763955,
		"h": 1.032967033
	},
	{
		"stop_id": 8583898,
		"ID": 1465,
		"x": 115.9227162793,
		"y": -33.288816872,
		"h": 1.032967033
	},
	{
		"stop_id": 8574530,
		"ID": 1392,
		"x": 96.8007479643,
		"y": -11.434769299,
		"h": 1.3296703297
	},
	{
		"stop_id": 8574533,
		"ID": 1392,
		"x": 97.8617379753,
		"y": -10.795815003,
		"h": 1.3296703297
	},
	{
		"stop_id": 8574534,
		"ID": 1392,
		"x": 97.2117015543,
		"y": -11.316833279,
		"h": 1.3296703297
	},
	{
		"stop_id": 8574662,
		"ID": 1392,
		"x": 100.0687294843,
		"y": -8.611844674,
		"h": 1.3296703297
	},
	{
		"stop_id": 8574663,
		"ID": 1392,
		"x": 100.4997246713,
		"y": -8.319771618,
		"h": 1.3296703297
	},
	{
		"stop_id": 8574664,
		"ID": 1392,
		"x": 99.9317116713,
		"y": -9.106802342,
		"h": 1.3296703297
	},
	{
		"stop_id": 8574665,
		"ID": 1392,
		"x": 100.5437366923,
		"y": -8.815799361,
		"h": 1.3296703297
	},
	{
		"stop_id": 8580922,
		"ID": 1392,
		"x": 97.9977559523,
		"y": -10.874754671,
		"h": 1.3296703297
	},
	{
		"stop_id": 8582132,
		"ID": 1392,
		"x": 99.0727327033,
		"y": -10.468855027,
		"h": 1.3296703297
	},
	{
		"stop_id": 8582133,
		"ID": 1392,
		"x": 100.2497570813,
		"y": -10.697804973,
		"h": 1.3296703297
	},
	{
		"stop_id": 8582666,
		"ID": 1392,
		"x": 97.9417670823,
		"y": -10.724765289,
		"h": 1.3296703297
	},
	{
		"stop_id": 8574536,
		"ID": 1317,
		"x": 85.3677624953,
		"y": -28.119750289,
		"h": 1.0659340659
	},
	{
		"stop_id": 8574537,
		"ID": 1317,
		"x": 85.1827494243,
		"y": -29.644834347,
		"h": 1.0659340659
	},
	{
		"stop_id": 8574538,
		"ID": 1317,
		"x": 85.4327175993,
		"y": -30.319783864,
		"h": 1.0659340659
	},
	{
		"stop_id": 8574539,
		"ID": 1339,
		"x": 85.9827188123,
		"y": -32.119794836,
		"h": 1
	},
	{
		"stop_id": 8574607,
		"ID": 1319,
		"x": 81.0077182423,
		"y": -17.18576749,
		"h": 1
	},
	{
		"stop_id": 8574637,
		"ID": 1548,
		"x": 146.4577460053,
		"y": -7.806774683,
		"h": 1.0989010989
	},
	{
		"stop_id": 8574638,
		"ID": 1548,
		"x": 148.4667178253,
		"y": -9.232781416,
		"h": 1.0989010989
	},
	{
		"stop_id": 8574639,
		"ID": 1548,
		"x": 148.9327428453,
		"y": -9.096788122,
		"h": 1.0989010989
	},
	{
		"stop_id": 8574640,
		"ID": 1548,
		"x": 149.3047166553,
		"y": -10.983819379,
		"h": 1.0989010989
	},
	{
		"stop_id": 8574736,
		"ID": 1483,
		"x": 123.1327223633,
		"y": -13.719791328,
		"h": 1
	},
	{
		"stop_id": 8574781,
		"ID": 1586,
		"x": 168.3567291943,
		"y": 22.196192806,
		"h": 1.032967033
	},
	{
		"stop_id": 8582841,
		"ID": 1586,
		"x": 170.2687043493,
		"y": 22.028169694,
		"h": 1.032967033
	},
	{
		"stop_id": 8574787,
		"ID": 1565,
		"x": 160.1547652703,
		"y": 5.610201583,
		"h": 1
	},
	{
		"stop_id": 8574802,
		"ID": 1533,
		"x": 143.1257146993,
		"y": -42.149765477,
		"h": 1.2307692308
	},
	{
		"stop_id": 8574803,
		"ID": 1533,
		"x": 143.3927122113,
		"y": -41.584751698,
		"h": 1.2307692308
	},
	{
		"stop_id": 8574805,
		"ID": 1533,
		"x": 142.3347553733,
		"y": -40.289799685,
		"h": 1.2307692308
	},
	{
		"stop_id": 8574806,
		"ID": 1533,
		"x": 141.5597063023,
		"y": -39.470850559,
		"h": 1.2307692308
	},
	{
		"stop_id": 8574813,
		"ID": 1533,
		"x": 146.3287636153,
		"y": -40.154830239,
		"h": 1.2307692308
	},
	{
		"stop_id": 8580214,
		"ID": 1533,
		"x": 144.5427362283,
		"y": -41.777813888,
		"h": 1.2307692308
	},
	{
		"stop_id": 8580508,
		"ID": 1533,
		"x": 146.2047396933,
		"y": -40.898854575,
		"h": 1.2307692308
	},
	{
		"stop_id": 8580517,
		"ID": 1533,
		"x": 146.2737702513,
		"y": -40.648788555,
		"h": 1.2307692308
	},
	{
		"stop_id": 8574830,
		"ID": 1471,
		"x": 121.5977289143,
		"y": 2.026230454,
		"h": 1.0989010989
	},
	{
		"stop_id": 8574831,
		"ID": 1471,
		"x": 121.3657312263,
		"y": 1.493143756,
		"h": 1.0989010989
	},
	{
		"stop_id": 8574832,
		"ID": 1471,
		"x": 121.1477283403,
		"y": 1.001196341,
		"h": 1.0989010989
	},
	{
		"stop_id": 8574833,
		"ID": 1471,
		"x": 120.6257626813,
		"y": 0.046214764,
		"h": 1.0989010989
	},
	{
		"stop_id": 8574855,
		"ID": 1580,
		"x": 169.5887276293,
		"y": -18.397826804,
		"h": 1.1318681319
	},
	{
		"stop_id": 8574857,
		"ID": 1580,
		"x": 169.9077176093,
		"y": -23.578842918,
		"h": 1.1318681319
	},
	{
		"stop_id": 8579857,
		"ID": 1580,
		"x": 170.1717535873,
		"y": -20.957798994,
		"h": 1.1318681319
	},
	{
		"stop_id": 8579858,
		"ID": 1580,
		"x": 170.0997414913,
		"y": -19.213759838,
		"h": 1.1318681319
	},
	{
		"stop_id": 8579859,
		"ID": 1580,
		"x": 166.4017234043,
		"y": -19.321826387,
		"h": 1.1318681319
	},
	{
		"stop_id": 8575001,
		"ID": 1204,
		"x": 65.3617756103,
		"y": -3.933805563,
		"h": 1.1648351648
	},
	{
		"stop_id": 8575002,
		"ID": 1204,
		"x": 64.9567728103,
		"y": -4.062776894,
		"h": 1.1648351648
	},
	{
		"stop_id": 8575003,
		"ID": 1204,
		"x": 65.0147330673,
		"y": -4.17776582,
		"h": 1.1648351648
	},
	{
		"stop_id": 8575004,
		"ID": 1204,
		"x": 64.7927449723,
		"y": -4.393756878,
		"h": 1.1648351648
	},
	{
		"stop_id": 8575005,
		"ID": 1204,
		"x": 64.5607024783,
		"y": -4.475851237,
		"h": 1.1648351648
	},
	{
		"stop_id": 8583533,
		"ID": 1204,
		"x": 64.2727030913,
		"y": -4.561763004,
		"h": 1.1648351648
	},
	{
		"stop_id": 8575034,
		"ID": 1266,
		"x": 73.5447610763,
		"y": -10.056802531,
		"h": 1.0989010989
	},
	{
		"stop_id": 8575035,
		"ID": 1266,
		"x": 73.5587077923,
		"y": -11.80079333,
		"h": 1.0989010989
	},
	{
		"stop_id": 8575036,
		"ID": 1266,
		"x": 74.2687492083,
		"y": -13.261749389,
		"h": 1.0989010989
	},
	{
		"stop_id": 8575037,
		"ID": 1266,
		"x": 74.1117422773,
		"y": -14.264774975,
		"h": 1.0989010989
	},
	{
		"stop_id": 8575048,
		"ID": 1296,
		"x": 76.4597729043,
		"y": -1.703799182,
		"h": 1.0659340659
	},
	{
		"stop_id": 8575050,
		"ID": 1296,
		"x": 77.4277097753,
		"y": -3.969808329,
		"h": 1.0659340659
	},
	{
		"stop_id": 8575101,
		"ID": 1296,
		"x": 75.5127105843,
		"y": -3.922816668,
		"h": 1.0659340659
	},
	{
		"stop_id": 8575125,
		"ID": 1193,
		"x": 62.0057524583,
		"y": -67.221750987,
		"h": 1.8571428571
	},
	{
		"stop_id": 8575126,
		"ID": 1193,
		"x": 61.6297663243,
		"y": -67.93878678,
		"h": 1.8571428571
	},
	{
		"stop_id": 8575127,
		"ID": 1193,
		"x": 61.8777776243,
		"y": -68.156855127,
		"h": 1.8571428571
	},
	{
		"stop_id": 8575128,
		"ID": 1193,
		"x": 62.1957252863,
		"y": -67.983792215,
		"h": 1.8571428571
	},
	{
		"stop_id": 8575129,
		"ID": 1193,
		"x": 62.3757319973,
		"y": -68.237788684,
		"h": 1.8571428571
	},
	{
		"stop_id": 8575130,
		"ID": 1193,
		"x": 63.0557060993,
		"y": -68.276856828,
		"h": 1.8571428571
	},
	{
		"stop_id": 8575131,
		"ID": 1193,
		"x": 63.0467566983,
		"y": -68.269810999,
		"h": 1.8571428571
	},
	{
		"stop_id": 8575132,
		"ID": 1193,
		"x": 63.3387514453,
		"y": -68.295796165,
		"h": 1.8571428571
	},
	{
		"stop_id": 8575133,
		"ID": 1193,
		"x": 63.0247411333,
		"y": -67.785809628,
		"h": 1.8571428571
	},
	{
		"stop_id": 8575134,
		"ID": 1193,
		"x": 63.3287366103,
		"y": -68.034817954,
		"h": 1.8571428571
	},
	{
		"stop_id": 8575135,
		"ID": 1193,
		"x": 63.3237290873,
		"y": -67.837782579,
		"h": 1.8571428571
	},
	{
		"stop_id": 8575136,
		"ID": 1193,
		"x": 63.5057724063,
		"y": -67.62782647,
		"h": 1.8571428571
	},
	{
		"stop_id": 8575137,
		"ID": 1193,
		"x": 63.4837280023,
		"y": -67.842757606,
		"h": 1.8571428571
	},
	{
		"stop_id": 8575138,
		"ID": 1193,
		"x": 63.7337527753,
		"y": -67.572814703,
		"h": 1.8571428571
	},
	{
		"stop_id": 8575139,
		"ID": 1193,
		"x": 63.7467495683,
		"y": -67.914788221,
		"h": 1.8571428571
	},
	{
		"stop_id": 8575145,
		"ID": 1193,
		"x": 64.9107084693,
		"y": -68.20783508,
		"h": 1.8571428571
	},
	{
		"stop_id": 8575146,
		"ID": 1193,
		"x": 65.2367068093,
		"y": -68.22279961,
		"h": 1.8571428571
	},
	{
		"stop_id": 8575147,
		"ID": 1193,
		"x": 65.5987634133,
		"y": -68.165839459,
		"h": 1.8571428571
	},
	{
		"stop_id": 8575148,
		"ID": 1193,
		"x": 65.6426988103,
		"y": -68.082761266,
		"h": 1.8571428571
	},
	{
		"stop_id": 8580778,
		"ID": 1193,
		"x": 61.8827514543,
		"y": -67.519759713,
		"h": 1.8571428571
	},
	{
		"stop_id": 8580928,
		"ID": 1193,
		"x": 63.2567756013,
		"y": -68.127787696,
		"h": 1.8571428571
	},
	{
		"stop_id": 8581245,
		"ID": 1193,
		"x": 61.3167408223,
		"y": -68.876804173,
		"h": 1.8571428571
	},
	{
		"stop_id": 8581256,
		"ID": 1193,
		"x": 61.1797618293,
		"y": -68.605795722,
		"h": 1.8571428571
	},
	{
		"stop_id": 8581257,
		"ID": 1193,
		"x": 61.2377559833,
		"y": -68.306765947,
		"h": 1.8571428571
	},
	{
		"stop_id": 8582988,
		"ID": 1193,
		"x": 61.7607696613,
		"y": -67.699774971,
		"h": 1.8571428571
	},
	{
		"stop_id": 8582991,
		"ID": 1193,
		"x": 61.9087559033,
		"y": -67.260836791,
		"h": 1.8571428571
	},
	{
		"stop_id": 8582992,
		"ID": 1193,
		"x": 61.7767037643,
		"y": -67.52377849,
		"h": 1.8571428571
	},
	{
		"stop_id": 8575149,
		"ID": 1226,
		"x": 66.3937289243,
		"y": -67.819771584,
		"h": 1.0659340659
	},
	{
		"stop_id": 8575150,
		"ID": 1226,
		"x": 67.0487711373,
		"y": -68.003790533,
		"h": 1.0659340659
	},
	{
		"stop_id": 8575151,
		"ID": 1226,
		"x": 67.5007641883,
		"y": -68.246824905,
		"h": 1.0659340659
	},
	{
		"stop_id": 8575196,
		"ID": 1159,
		"x": 60.4557173753,
		"y": -57.446781265,
		"h": 1.3956043956
	},
	{
		"stop_id": 8575197,
		"ID": 1159,
		"x": 60.2027211683,
		"y": -57.283801496,
		"h": 1.3956043956
	},
	{
		"stop_id": 8575198,
		"ID": 1159,
		"x": 59.6317664623,
		"y": -56.293752682,
		"h": 1.3956043956
	},
	{
		"stop_id": 8575199,
		"ID": 1159,
		"x": 59.4877228533,
		"y": -55.928789704,
		"h": 1.3956043956
	},
	{
		"stop_id": 8575200,
		"ID": 1159,
		"x": 59.3827032883,
		"y": -55.614756532,
		"h": 1.3956043956
	},
	{
		"stop_id": 8575201,
		"ID": 1159,
		"x": 59.2497722743,
		"y": -54.512847544,
		"h": 1.3956043956
	},
	{
		"stop_id": 8575202,
		"ID": 1159,
		"x": 59.2387294553,
		"y": -54.0967826,
		"h": 1.3956043956
	},
	{
		"stop_id": 8575203,
		"ID": 1159,
		"x": 59.1517771243,
		"y": -53.950838156,
		"h": 1.3956043956
	},
	{
		"stop_id": 8575204,
		"ID": 1159,
		"x": 59.0637656163,
		"y": -53.652810301,
		"h": 1.3956043956
	},
	{
		"stop_id": 8575205,
		"ID": 1159,
		"x": 58.7177139303,
		"y": -53.013833432,
		"h": 1.3956043956
	},
	{
		"stop_id": 8580588,
		"ID": 1159,
		"x": 60.0817180123,
		"y": -53.848859185,
		"h": 1.3956043956
	},
	{
		"stop_id": 8581157,
		"ID": 1159,
		"x": 61.3377379093,
		"y": -56.415823094,
		"h": 1.3956043956
	},
	{
		"stop_id": 8587466,
		"ID": 1159,
		"x": 60.9237663703,
		"y": -55.83881029,
		"h": 1.3956043956
	},
	{
		"stop_id": 8575434,
		"ID": 1192,
		"x": 61.4817281103,
		"y": -77.779782443,
		"h": 1.9230769231
	},
	{
		"stop_id": 8575435,
		"ID": 1192,
		"x": 62.3177614853,
		"y": -77.404769973,
		"h": 1.9230769231
	},
	{
		"stop_id": 8575436,
		"ID": 1192,
		"x": 62.7067056023,
		"y": -77.267841656,
		"h": 1.9230769231
	},
	{
		"stop_id": 8575437,
		"ID": 1192,
		"x": 63.0637206403,
		"y": -77.239832544,
		"h": 1.9230769231
	},
	{
		"stop_id": 8575438,
		"ID": 1192,
		"x": 63.4227004393,
		"y": -77.125813316,
		"h": 1.9230769231
	},
	{
		"stop_id": 8575439,
		"ID": 1192,
		"x": 63.2667556773,
		"y": -77.374816416,
		"h": 1.9230769231
	},
	{
		"stop_id": 8575440,
		"ID": 1192,
		"x": 63.4117655873,
		"y": -77.440811576,
		"h": 1.9230769231
	},
	{
		"stop_id": 8575441,
		"ID": 1192,
		"x": 63.7747547653,
		"y": -77.05983614,
		"h": 1.9230769231
	},
	{
		"stop_id": 8575442,
		"ID": 1192,
		"x": 64.6477438473,
		"y": -76.747790405,
		"h": 1.9230769231
	},
	{
		"stop_id": 8575443,
		"ID": 1192,
		"x": 64.9137387053,
		"y": -76.248759425,
		"h": 1.9230769231
	},
	{
		"stop_id": 8575444,
		"ID": 1192,
		"x": 65.1967511583,
		"y": -76.735840118,
		"h": 1.9230769231
	},
	{
		"stop_id": 8575445,
		"ID": 1192,
		"x": 65.4127717093,
		"y": -76.313758127,
		"h": 1.9230769231
	},
	{
		"stop_id": 8575446,
		"ID": 1192,
		"x": 65.8337724573,
		"y": -76.255799346,
		"h": 1.9230769231
	},
	{
		"stop_id": 8575447,
		"ID": 1192,
		"x": 65.8577652913,
		"y": -76.872851399,
		"h": 1.9230769231
	},
	{
		"stop_id": 8575448,
		"ID": 1192,
		"x": 65.8537226233,
		"y": -77.028823418,
		"h": 1.9230769231
	},
	{
		"stop_id": 8575454,
		"ID": 1192,
		"x": 62.5187463063,
		"y": -78.198835863,
		"h": 1.9230769231
	},
	{
		"stop_id": 8575455,
		"ID": 1192,
		"x": 63.0277653763,
		"y": -78.150753131,
		"h": 1.9230769231
	},
	{
		"stop_id": 8575456,
		"ID": 1192,
		"x": 63.8547509353,
		"y": -77.587801092,
		"h": 1.9230769231
	},
	{
		"stop_id": 8575457,
		"ID": 1192,
		"x": 64.4716997433,
		"y": -77.281771552,
		"h": 1.9230769231
	},
	{
		"stop_id": 8575458,
		"ID": 1192,
		"x": 64.8187372493,
		"y": -77.208831509,
		"h": 1.9230769231
	},
	{
		"stop_id": 8575459,
		"ID": 1192,
		"x": 65.5267583633,
		"y": -77.113750712,
		"h": 1.9230769231
	},
	{
		"stop_id": 8575460,
		"ID": 1192,
		"x": 65.2677603173,
		"y": -77.418749977,
		"h": 1.9230769231
	},
	{
		"stop_id": 8575461,
		"ID": 1192,
		"x": 65.5767119853,
		"y": -77.535796427,
		"h": 1.9230769231
	},
	{
		"stop_id": 8575462,
		"ID": 1192,
		"x": 64.2487220353,
		"y": -77.678831658,
		"h": 1.9230769231
	},
	{
		"stop_id": 8575463,
		"ID": 1192,
		"x": 64.5587057213,
		"y": -78.250785203,
		"h": 1.9230769231
	},
	{
		"stop_id": 8575464,
		"ID": 1192,
		"x": 64.0687580763,
		"y": -78.080787318,
		"h": 1.9230769231
	},
	{
		"stop_id": 8575465,
		"ID": 1192,
		"x": 63.3617740893,
		"y": -78.286752159,
		"h": 1.9230769231
	},
	{
		"stop_id": 8575466,
		"ID": 1192,
		"x": 62.7747419183,
		"y": -78.579831084,
		"h": 1.9230769231
	},
	{
		"stop_id": 8580676,
		"ID": 1192,
		"x": 65.3917418653,
		"y": -77.116759727,
		"h": 1.9230769231
	},
	{
		"stop_id": 8575491,
		"ID": 950,
		"x": 30.6247158453,
		"y": -64.942843428,
		"h": 1.1978021978
	},
	{
		"stop_id": 8575492,
		"ID": 950,
		"x": 29.1647614513,
		"y": -64.874845911,
		"h": 1.1978021978
	},
	{
		"stop_id": 8575493,
		"ID": 950,
		"x": 28.7577295823,
		"y": -64.832779822,
		"h": 1.1978021978
	},
	{
		"stop_id": 8575494,
		"ID": 950,
		"x": 28.4997208733,
		"y": -64.872788964,
		"h": 1.1978021978
	},
	{
		"stop_id": 8575495,
		"ID": 950,
		"x": 28.0577678983,
		"y": -65.019852269,
		"h": 1.1978021978
	},
	{
		"stop_id": 8575496,
		"ID": 950,
		"x": 27.6517100503,
		"y": -65.007826618,
		"h": 1.1978021978
	},
	{
		"stop_id": 8575497,
		"ID": 950,
		"x": 27.4537084083,
		"y": -65.393796876,
		"h": 1.1978021978
	},
	{
		"stop_id": 8575499,
		"ID": 951,
		"x": 30.9977368423,
		"y": -62.899819193,
		"h": 1.1648351648
	},
	{
		"stop_id": 8575500,
		"ID": 951,
		"x": 30.7697188833,
		"y": -62.616838971,
		"h": 1.1648351648
	},
	{
		"stop_id": 8575501,
		"ID": 951,
		"x": 30.0507759643,
		"y": -62.444770774,
		"h": 1.1648351648
	},
	{
		"stop_id": 8575502,
		"ID": 951,
		"x": 29.8197691173,
		"y": -62.299771314,
		"h": 1.1648351648
	},
	{
		"stop_id": 8575503,
		"ID": 951,
		"x": 31.0877456003,
		"y": -62.644761394,
		"h": 1.1648351648
	},
	{
		"stop_id": 8580749,
		"ID": 951,
		"x": 27.3377561903,
		"y": -61.739857798,
		"h": 1.1648351648
	},
	{
		"stop_id": 8575617,
		"ID": 1115,
		"x": 56.4797620253,
		"y": -104.197749051,
		"h": 1.3296703297
	},
	{
		"stop_id": 8575618,
		"ID": 1115,
		"x": 55.8847261583,
		"y": -104.4327831946,
		"h": 1.3296703297
	},
	{
		"stop_id": 8575619,
		"ID": 1115,
		"x": 55.3997511553,
		"y": -104.6137543222,
		"h": 1.3296703297
	},
	{
		"stop_id": 8575620,
		"ID": 1115,
		"x": 55.0217078773,
		"y": -104.8168014769,
		"h": 1.3296703297
	},
	{
		"stop_id": 8580000,
		"ID": 1115,
		"x": 54.5387404273,
		"y": -105.6257728288,
		"h": 1.3296703297
	},
	{
		"stop_id": 8580053,
		"ID": 1115,
		"x": 53.9777431433,
		"y": -106.7508260596,
		"h": 1.3296703297
	},
	{
		"stop_id": 8580056,
		"ID": 1115,
		"x": 54.2777159713,
		"y": -106.5298487581,
		"h": 1.3296703297
	},
	{
		"stop_id": 8580058,
		"ID": 1115,
		"x": 54.8117258363,
		"y": -104.8827960559,
		"h": 1.3296703297
	},
	{
		"stop_id": 8580109,
		"ID": 1115,
		"x": 54.5137151663,
		"y": -105.8787527393,
		"h": 1.3296703297
	},
	{
		"stop_id": 8580791,
		"ID": 1115,
		"x": 53.4927062013,
		"y": -107.087752114,
		"h": 1.3296703297
	},
	{
		"stop_id": 8580910,
		"ID": 1115,
		"x": 54.5977589993,
		"y": -105.0928480091,
		"h": 1.3296703297
	},
	{
		"stop_id": 8575692,
		"ID": 956,
		"x": 27.5517350633,
		"y": -29.720762445,
		"h": 1.032967033
	},
	{
		"stop_id": 8575693,
		"ID": 956,
		"x": 26.9747004583,
		"y": -29.869851289,
		"h": 1.032967033
	},
	{
		"stop_id": 8575720,
		"ID": 1057,
		"x": 44.7007247023,
		"y": -31.888780912,
		"h": 1.032967033
	},
	{
		"stop_id": 8575721,
		"ID": 1057,
		"x": 44.5007410853,
		"y": -31.397819996,
		"h": 1.032967033
	},
	{
		"stop_id": 8575726,
		"ID": 1091,
		"x": 46.2467595373,
		"y": -33.277788162,
		"h": 1.3626373626
	},
	{
		"stop_id": 8575727,
		"ID": 1091,
		"x": 47.0387155463,
		"y": -33.257796664,
		"h": 1.3626373626
	},
	{
		"stop_id": 8575728,
		"ID": 1091,
		"x": 46.1067710433,
		"y": -32.513758512,
		"h": 1.3626373626
	},
	{
		"stop_id": 8575730,
		"ID": 1091,
		"x": 46.7227545203,
		"y": -34.503853244,
		"h": 1.3626373626
	},
	{
		"stop_id": 8575731,
		"ID": 1091,
		"x": 47.0847365103,
		"y": -35.008774326,
		"h": 1.3626373626
	},
	{
		"stop_id": 8580116,
		"ID": 1091,
		"x": 46.6577470013,
		"y": -32.506829286,
		"h": 1.3626373626
	},
	{
		"stop_id": 8580117,
		"ID": 1091,
		"x": 46.8187627253,
		"y": -32.70177637,
		"h": 1.3626373626
	},
	{
		"stop_id": 8580118,
		"ID": 1091,
		"x": 46.9547017203,
		"y": -32.958758791,
		"h": 1.3626373626
	},
	{
		"stop_id": 8580119,
		"ID": 1091,
		"x": 46.8877178963,
		"y": -33.499847804,
		"h": 1.3626373626
	},
	{
		"stop_id": 8580457,
		"ID": 1091,
		"x": 46.3177492913,
		"y": -32.485809031,
		"h": 1.3626373626
	},
	{
		"stop_id": 8581104,
		"ID": 1091,
		"x": 46.5077156423,
		"y": -34.357775602,
		"h": 1.3626373626
	},
	{
		"stop_id": 8582421,
		"ID": 1091,
		"x": 45.6747209583,
		"y": -32.225813957,
		"h": 1.3626373626
	},
	{
		"stop_id": 8575740,
		"ID": 1126,
		"x": 51.1727675793,
		"y": -41.336758618,
		"h": 1.0659340659
	},
	{
		"stop_id": 8575741,
		"ID": 1126,
		"x": 52.4327305923,
		"y": -42.519804274,
		"h": 1.0659340659
	},
	{
		"stop_id": 8575742,
		"ID": 1126,
		"x": 52.7997011633,
		"y": -42.824840996,
		"h": 1.0659340659
	},
	{
		"stop_id": 8575863,
		"ID": 987,
		"x": 31.7327201403,
		"y": -48.352809011,
		"h": 1.2307692308
	},
	{
		"stop_id": 8575864,
		"ID": 987,
		"x": 31.6777334943,
		"y": -48.137845694,
		"h": 1.2307692308
	},
	{
		"stop_id": 8575865,
		"ID": 987,
		"x": 32.2607739373,
		"y": -48.167791902,
		"h": 1.2307692308
	},
	{
		"stop_id": 8575866,
		"ID": 987,
		"x": 33.1597594563,
		"y": -47.632825138,
		"h": 1.2307692308
	},
	{
		"stop_id": 8575867,
		"ID": 987,
		"x": 33.4577450213,
		"y": -47.344839665,
		"h": 1.2307692308
	},
	{
		"stop_id": 8575868,
		"ID": 987,
		"x": 32.7077609043,
		"y": -47.541814802,
		"h": 1.2307692308
	},
	{
		"stop_id": 8575869,
		"ID": 987,
		"x": 34.2327043173,
		"y": -45.694835351,
		"h": 1.2307692308
	},
	{
		"stop_id": 8579922,
		"ID": 987,
		"x": 34.3147494253,
		"y": -45.384814799,
		"h": 1.2307692308
	},
	{
		"stop_id": 8575876,
		"ID": 920,
		"x": 26.3077030773,
		"y": -46.469839956,
		"h": 1.1318681319
	},
	{
		"stop_id": 8575877,
		"ID": 920,
		"x": 25.6327076143,
		"y": -46.169797432,
		"h": 1.1318681319
	},
	{
		"stop_id": 8575878,
		"ID": 920,
		"x": 25.2557198523,
		"y": -45.486826143,
		"h": 1.1318681319
	},
	{
		"stop_id": 8575879,
		"ID": 920,
		"x": 25.1327708103,
		"y": -44.808826026,
		"h": 1.1318681319
	},
	{
		"stop_id": 8583076,
		"ID": 920,
		"x": 25.0017255133,
		"y": -44.335834778,
		"h": 1.1318681319
	},
	{
		"stop_id": 8575885,
		"ID": 954,
		"x": 30.4377355063,
		"y": -41.782800644,
		"h": 1.032967033
	},
	{
		"stop_id": 8575886,
		"ID": 954,
		"x": 30.1297244073,
		"y": -41.532801108,
		"h": 1.032967033
	},
	{
		"stop_id": 8575888,
		"ID": 952,
		"x": 29.6287203193,
		"y": -52.782815915,
		"h": 1.1978021978
	},
	{
		"stop_id": 8575889,
		"ID": 952,
		"x": 28.6717037823,
		"y": -53.221811006,
		"h": 1.1978021978
	},
	{
		"stop_id": 8575890,
		"ID": 952,
		"x": 28.4347061123,
		"y": -53.40582461,
		"h": 1.1978021978
	},
	{
		"stop_id": 8575891,
		"ID": 952,
		"x": 28.2187708843,
		"y": -53.539826182,
		"h": 1.1978021978
	},
	{
		"stop_id": 8575892,
		"ID": 952,
		"x": 26.5337721423,
		"y": -53.697858071,
		"h": 1.1978021978
	},
	{
		"stop_id": 8587592,
		"ID": 952,
		"x": 30.1077695253,
		"y": -52.794835099,
		"h": 1.1978021978
	},
	{
		"stop_id": 8591543,
		"ID": 952,
		"x": 30.5277049583,
		"y": -53.320783543,
		"h": 1.1978021978
	},
	{
		"stop_id": 8575903,
		"ID": 887,
		"x": 21.7047057093,
		"y": -55.624816552,
		"h": 1.0659340659
	},
	{
		"stop_id": 8575904,
		"ID": 887,
		"x": 21.4207711593,
		"y": -55.687779609,
		"h": 1.0659340659
	},
	{
		"stop_id": 8575905,
		"ID": 887,
		"x": 21.3157284203,
		"y": -56.136779712,
		"h": 1.0659340659
	},
	{
		"stop_id": 8576614,
		"ID": 547,
		"x": -41.5242816407,
		"y": 5.958235436,
		"h": 1.0989010989
	},
	{
		"stop_id": 8576615,
		"ID": 547,
		"x": -41.9312910647,
		"y": 5.398165852,
		"h": 1.0989010989
	},
	{
		"stop_id": 8576616,
		"ID": 547,
		"x": -40.9112263577,
		"y": 6.064181751,
		"h": 1.0989010989
	},
	{
		"stop_id": 8576617,
		"ID": 547,
		"x": -39.8302304767,
		"y": 6.065224805,
		"h": 1.0989010989
	},
	{
		"stop_id": 8576637,
		"ID": 612,
		"x": -32.6042871447,
		"y": -0.547818772,
		"h": 1.032967033
	},
	{
		"stop_id": 8576638,
		"ID": 612,
		"x": -31.5012378377,
		"y": -0.579749445,
		"h": 1.032967033
	},
	{
		"stop_id": 8577071,
		"ID": 827,
		"x": 3.5877687593,
		"y": 49.580240607,
		"h": 1.5604395604
	},
	{
		"stop_id": 8577072,
		"ID": 827,
		"x": 4.6177644543,
		"y": 49.693150264,
		"h": 1.5604395604
	},
	{
		"stop_id": 8577075,
		"ID": 827,
		"x": 2.5877036923,
		"y": 48.682199854,
		"h": 1.5604395604
	},
	{
		"stop_id": 8577076,
		"ID": 827,
		"x": 3.0277116213,
		"y": 48.490146117,
		"h": 1.5604395604
	},
	{
		"stop_id": 8577077,
		"ID": 827,
		"x": 3.5027234953,
		"y": 48.933245173,
		"h": 1.5604395604
	},
	{
		"stop_id": 8577078,
		"ID": 827,
		"x": 3.9677438753,
		"y": 49.800221334,
		"h": 1.5604395604
	},
	{
		"stop_id": 8577079,
		"ID": 827,
		"x": 5.1867006283,
		"y": 50.044232974,
		"h": 1.5604395604
	},
	{
		"stop_id": 8577080,
		"ID": 827,
		"x": 4.4587018303,
		"y": 49.732234427,
		"h": 1.5604395604
	},
	{
		"stop_id": 8577342,
		"ID": 827,
		"x": 1.0377597113,
		"y": 51.46019527,
		"h": 1.5604395604
	},
	{
		"stop_id": 8577346,
		"ID": 827,
		"x": 3.7077407673,
		"y": 53.540247444,
		"h": 1.5604395604
	},
	{
		"stop_id": 8577347,
		"ID": 827,
		"x": 2.8077495493,
		"y": 53.03014657,
		"h": 1.5604395604
	},
	{
		"stop_id": 8577349,
		"ID": 827,
		"x": 0.9807569703,
		"y": 51.786160053,
		"h": 1.5604395604
	},
	{
		"stop_id": 8577350,
		"ID": 827,
		"x": 1.7647171933,
		"y": 49.740211258,
		"h": 1.5604395604
	},
	{
		"stop_id": 8577355,
		"ID": 827,
		"x": 1.2377602773,
		"y": 52.190167375,
		"h": 1.5604395604
	},
	{
		"stop_id": 8577356,
		"ID": 827,
		"x": 2.1327657143,
		"y": 53.080225886,
		"h": 1.5604395604
	},
	{
		"stop_id": 8587250,
		"ID": 827,
		"x": 2.6877749243,
		"y": 52.960172183,
		"h": 1.5604395604
	},
	{
		"stop_id": 8588727,
		"ID": 827,
		"x": 3.2257582963,
		"y": 53.05624425,
		"h": 1.5604395604
	},
	{
		"stop_id": 8589230,
		"ID": 827,
		"x": 2.4777653953,
		"y": 52.945182395,
		"h": 1.5604395604
	},
	{
		"stop_id": 8577297,
		"ID": 743,
		"x": -10.2862886707,
		"y": 34.063242326,
		"h": 1.2637362637
	},
	{
		"stop_id": 8577298,
		"ID": 743,
		"x": -10.6652652777,
		"y": 35.039142347,
		"h": 1.2637362637
	},
	{
		"stop_id": 8577299,
		"ID": 743,
		"x": -9.9972829607,
		"y": 35.784237697,
		"h": 1.2637362637
	},
	{
		"stop_id": 8577300,
		"ID": 743,
		"x": -10.9882920827,
		"y": 36.000182333,
		"h": 1.2637362637
	},
	{
		"stop_id": 8577301,
		"ID": 743,
		"x": -12.1062843277,
		"y": 36.759158283,
		"h": 1.2637362637
	},
	{
		"stop_id": 8577302,
		"ID": 743,
		"x": -13.1392339607,
		"y": 37.692223501,
		"h": 1.2637362637
	},
	{
		"stop_id": 8577303,
		"ID": 743,
		"x": -13.5052886587,
		"y": 37.923179034,
		"h": 1.2637362637
	},
	{
		"stop_id": 8577333,
		"ID": 743,
		"x": -8.6142857227,
		"y": 37.164219139,
		"h": 1.2637362637
	},
	{
		"stop_id": 8577334,
		"ID": 743,
		"x": -9.2282494957,
		"y": 36.35215844,
		"h": 1.2637362637
	},
	{
		"stop_id": 8577976,
		"ID": 426,
		"x": -63.2342556777,
		"y": 46.626170065,
		"h": 1.3296703297
	},
	{
		"stop_id": 8577980,
		"ID": 426,
		"x": -64.0992620707,
		"y": 47.47114281,
		"h": 1.3296703297
	},
	{
		"stop_id": 8588207,
		"ID": 426,
		"x": -60.8642844297,
		"y": 45.594165916,
		"h": 1.3296703297
	},
	{
		"stop_id": 8593842,
		"ID": 426,
		"x": -61.1962307567,
		"y": 46.431181472,
		"h": 1.3296703297
	},
	{
		"stop_id": 8593903,
		"ID": 426,
		"x": -61.4032270297,
		"y": 46.326176049,
		"h": 1.3296703297
	},
	{
		"stop_id": 8594091,
		"ID": 426,
		"x": -61.1142654767,
		"y": 46.108191958,
		"h": 1.3296703297
	},
	{
		"stop_id": 8594093,
		"ID": 426,
		"x": -60.9092675397,
		"y": 46.42722345,
		"h": 1.3296703297
	},
	{
		"stop_id": 8594094,
		"ID": 426,
		"x": -60.9802677397,
		"y": 46.008212857,
		"h": 1.3296703297
	},
	{
		"stop_id": 8594098,
		"ID": 426,
		"x": -60.8652775327,
		"y": 45.930142438,
		"h": 1.3296703297
	},
	{
		"stop_id": 8594100,
		"ID": 426,
		"x": -60.9382800677,
		"y": 46.082247544,
		"h": 1.3296703297
	},
	{
		"stop_id": 8594101,
		"ID": 426,
		"x": -61.0532372847,
		"y": 46.285171087,
		"h": 1.3296703297
	},
	{
		"stop_id": 8577985,
		"ID": 688,
		"x": -23.4552396667,
		"y": 63.627185484,
		"h": 1.7912087912
	},
	{
		"stop_id": 8577986,
		"ID": 688,
		"x": -23.0392813057,
		"y": 63.682222461,
		"h": 1.7912087912
	},
	{
		"stop_id": 8577987,
		"ID": 688,
		"x": -22.4132904857,
		"y": 63.526245012,
		"h": 1.7912087912
	},
	{
		"stop_id": 8577988,
		"ID": 688,
		"x": -22.0082344357,
		"y": 63.454202587,
		"h": 1.7912087912
	},
	{
		"stop_id": 8577989,
		"ID": 688,
		"x": -21.3212485527,
		"y": 63.383228333,
		"h": 1.7912087912
	},
	{
		"stop_id": 8577990,
		"ID": 688,
		"x": -21.0352396747,
		"y": 63.510169205,
		"h": 1.7912087912
	},
	{
		"stop_id": 8577991,
		"ID": 688,
		"x": -21.3402852207,
		"y": 64.375201069,
		"h": 1.7912087912
	},
	{
		"stop_id": 8577992,
		"ID": 688,
		"x": -21.2202316377,
		"y": 65.265232442,
		"h": 1.7912087912
	},
	{
		"stop_id": 8577993,
		"ID": 688,
		"x": -21.3202244617,
		"y": 65.639164861,
		"h": 1.7912087912
	},
	{
		"stop_id": 8577994,
		"ID": 688,
		"x": -21.3732989337,
		"y": 65.964147759,
		"h": 1.7912087912
	},
	{
		"stop_id": 8577995,
		"ID": 688,
		"x": -21.5732335497,
		"y": 66.114180192,
		"h": 1.7912087912
	},
	{
		"stop_id": 8577996,
		"ID": 688,
		"x": -22.1562486517,
		"y": 66.760220952,
		"h": 1.7912087912
	},
	{
		"stop_id": 8577997,
		"ID": 688,
		"x": -20.8572544847,
		"y": 65.8131841,
		"h": 1.7912087912
	},
	{
		"stop_id": 8577998,
		"ID": 688,
		"x": -19.8022546077,
		"y": 66.0122112,
		"h": 1.7912087912
	},
	{
		"stop_id": 8577999,
		"ID": 688,
		"x": -19.6002378437,
		"y": 66.231164237,
		"h": 1.7912087912
	},
	{
		"stop_id": 8578000,
		"ID": 688,
		"x": -19.5752643987,
		"y": 66.702202387,
		"h": 1.7912087912
	},
	{
		"stop_id": 8578001,
		"ID": 688,
		"x": -19.7672341187,
		"y": 67.168216795,
		"h": 1.7912087912
	},
	{
		"stop_id": 8578002,
		"ID": 688,
		"x": -20.7712993867,
		"y": 68.532226606,
		"h": 1.7912087912
	},
	{
		"stop_id": 8578003,
		"ID": 688,
		"x": -19.3612694947,
		"y": 66.654178363,
		"h": 1.7912087912
	},
	{
		"stop_id": 8578015,
		"ID": 688,
		"x": -19.6322253467,
		"y": 64.105206948,
		"h": 1.7912087912
	},
	{
		"stop_id": 8578016,
		"ID": 688,
		"x": -20.4782529757,
		"y": 63.781226811,
		"h": 1.7912087912
	},
	{
		"stop_id": 8589238,
		"ID": 688,
		"x": -21.9692652137,
		"y": 66.492230325,
		"h": 1.7912087912
	},
	{
		"stop_id": 8590413,
		"ID": 688,
		"x": -19.0432855477,
		"y": 64.116222729,
		"h": 1.7912087912
	},
	{
		"stop_id": 8590415,
		"ID": 688,
		"x": -20.7702508417,
		"y": 62.925185835,
		"h": 1.7912087912
	},
	{
		"stop_id": 8594879,
		"ID": 688,
		"x": -21.2882394967,
		"y": 63.570231301,
		"h": 1.7912087912
	},
	{
		"stop_id": 8578286,
		"ID": 623,
		"x": -31.8202460897,
		"y": 68.404200222,
		"h": 1.0989010989
	},
	{
		"stop_id": 8578287,
		"ID": 623,
		"x": -31.7522924687,
		"y": 68.015152723,
		"h": 1.0989010989
	},
	{
		"stop_id": 8578288,
		"ID": 623,
		"x": -31.3082792407,
		"y": 66.324152613,
		"h": 1.0989010989
	},
	{
		"stop_id": 8578289,
		"ID": 623,
		"x": -30.9422542747,
		"y": 65.830149099,
		"h": 1.0989010989
	},
	{
		"stop_id": 8578430,
		"ID": 1445,
		"x": 106.1087259313,
		"y": 72.406203464,
		"h": 1.5934065934
	},
	{
		"stop_id": 8578431,
		"ID": 1445,
		"x": 105.8077077753,
		"y": 71.955198933,
		"h": 1.5934065934
	},
	{
		"stop_id": 8578432,
		"ID": 1445,
		"x": 105.7977505683,
		"y": 71.612228869,
		"h": 1.5934065934
	},
	{
		"stop_id": 8578433,
		"ID": 1445,
		"x": 105.7077442443,
		"y": 71.240214893,
		"h": 1.5934065934
	},
	{
		"stop_id": 8578441,
		"ID": 1445,
		"x": 105.9377424103,
		"y": 70.349158246,
		"h": 1.5934065934
	},
	{
		"stop_id": 8591850,
		"ID": 1445,
		"x": 107.0777742653,
		"y": 70.650240395,
		"h": 1.5934065934
	},
	{
		"stop_id": 8591851,
		"ID": 1445,
		"x": 106.0577746473,
		"y": 70.660173557,
		"h": 1.5934065934
	},
	{
		"stop_id": 8591852,
		"ID": 1445,
		"x": 105.9577727383,
		"y": 71.400148036,
		"h": 1.5934065934
	},
	{
		"stop_id": 8591853,
		"ID": 1445,
		"x": 105.9477651663,
		"y": 70.970197021,
		"h": 1.5934065934
	},
	{
		"stop_id": 8591854,
		"ID": 1445,
		"x": 106.6577632143,
		"y": 70.630185675,
		"h": 1.5934065934
	},
	{
		"stop_id": 8591872,
		"ID": 1445,
		"x": 107.6147295373,
		"y": 70.684197404,
		"h": 1.5934065934
	},
	{
		"stop_id": 8591873,
		"ID": 1445,
		"x": 107.9397289153,
		"y": 70.902171837,
		"h": 1.5934065934
	},
	{
		"stop_id": 8591876,
		"ID": 1445,
		"x": 108.2647367303,
		"y": 71.773187896,
		"h": 1.5934065934
	},
	{
		"stop_id": 8594685,
		"ID": 1445,
		"x": 107.9097290203,
		"y": 71.140240087,
		"h": 1.5934065934
	},
	{
		"stop_id": 8594686,
		"ID": 1445,
		"x": 107.9017419003,
		"y": 71.406183106,
		"h": 1.5934065934
	},
	{
		"stop_id": 8594687,
		"ID": 1445,
		"x": 108.0377443103,
		"y": 71.831148598,
		"h": 1.5934065934
	},
	{
		"stop_id": 8595513,
		"ID": 1445,
		"x": 108.8527574763,
		"y": 71.691141468,
		"h": 1.5934065934
	},
	{
		"stop_id": 8595539,
		"ID": 1445,
		"x": 106.7467420623,
		"y": 70.237163431,
		"h": 1.5934065934
	},
	{
		"stop_id": 8595540,
		"ID": 1445,
		"x": 106.3157046243,
		"y": 70.084241017,
		"h": 1.5934065934
	},
	{
		"stop_id": 8578802,
		"ID": 1311,
		"x": 77.6577369633,
		"y": 80.205142191,
		"h": 1.5604395604
	},
	{
		"stop_id": 8582163,
		"ID": 1311,
		"x": 80.3057286693,
		"y": 85.442216275,
		"h": 1.5604395604
	},
	{
		"stop_id": 8583792,
		"ID": 1311,
		"x": 78.4377168243,
		"y": 85.334248185,
		"h": 1.5604395604
	},
	{
		"stop_id": 8587139,
		"ID": 1311,
		"x": 79.4307379393,
		"y": 85.033146308,
		"h": 1.5604395604
	},
	{
		"stop_id": 8587140,
		"ID": 1311,
		"x": 79.8427442893,
		"y": 85.125175032,
		"h": 1.5604395604
	},
	{
		"stop_id": 8587143,
		"ID": 1311,
		"x": 78.9977256683,
		"y": 85.078231156,
		"h": 1.5604395604
	},
	{
		"stop_id": 8587145,
		"ID": 1311,
		"x": 80.3477418593,
		"y": 85.128238335,
		"h": 1.5604395604
	},
	{
		"stop_id": 8587146,
		"ID": 1311,
		"x": 78.6107126253,
		"y": 85.050242245,
		"h": 1.5604395604
	},
	{
		"stop_id": 8587148,
		"ID": 1311,
		"x": 80.1977584323,
		"y": 84.625193925,
		"h": 1.5604395604
	},
	{
		"stop_id": 8587149,
		"ID": 1311,
		"x": 79.9477658763,
		"y": 85.839243098,
		"h": 1.5604395604
	},
	{
		"stop_id": 8587150,
		"ID": 1311,
		"x": 80.5127401893,
		"y": 85.280189423,
		"h": 1.5604395604
	},
	{
		"stop_id": 8587170,
		"ID": 1311,
		"x": 81.2167441723,
		"y": 83.523220253,
		"h": 1.5604395604
	},
	{
		"stop_id": 8587184,
		"ID": 1311,
		"x": 81.6657206253,
		"y": 82.584249098,
		"h": 1.5604395604
	},
	{
		"stop_id": 8587210,
		"ID": 1311,
		"x": 77.8327088893,
		"y": 84.114175979,
		"h": 1.5604395604
	},
	{
		"stop_id": 8587213,
		"ID": 1311,
		"x": 76.8307653703,
		"y": 80.853159475,
		"h": 1.5604395604
	},
	{
		"stop_id": 8587222,
		"ID": 1311,
		"x": 77.1777555803,
		"y": 82.028191379,
		"h": 1.5604395604
	},
	{
		"stop_id": 8587223,
		"ID": 1311,
		"x": 77.3677391593,
		"y": 82.500156232,
		"h": 1.5604395604
	},
	{
		"stop_id": 8587224,
		"ID": 1311,
		"x": 77.3507291593,
		"y": 82.285222824,
		"h": 1.5604395604
	},
	{
		"stop_id": 8579094,
		"ID": 62,
		"x": -138.5752716777,
		"y": -6.770846645,
		"h": 1.2637362637
	},
	{
		"stop_id": 8579095,
		"ID": 62,
		"x": -138.0782321317,
		"y": -6.73178791,
		"h": 1.2637362637
	},
	{
		"stop_id": 8579096,
		"ID": 62,
		"x": -136.9332883537,
		"y": -6.251812095,
		"h": 1.2637362637
	},
	{
		"stop_id": 8579097,
		"ID": 62,
		"x": -136.2222806477,
		"y": -6.027800617,
		"h": 1.2637362637
	},
	{
		"stop_id": 8579098,
		"ID": 62,
		"x": -135.8222802147,
		"y": -6.129843249,
		"h": 1.2637362637
	},
	{
		"stop_id": 8579099,
		"ID": 62,
		"x": -134.8222924667,
		"y": -5.567799081,
		"h": 1.2637362637
	},
	{
		"stop_id": 8579906,
		"ID": 62,
		"x": -137.7542941177,
		"y": -6.71178098,
		"h": 1.2637362637
	},
	{
		"stop_id": 8579907,
		"ID": 62,
		"x": -138.3242502247,
		"y": -6.726785177,
		"h": 1.2637362637
	},
	{
		"stop_id": 8579908,
		"ID": 62,
		"x": -137.9732914667,
		"y": -6.598858512,
		"h": 1.2637362637
	},
	{
		"stop_id": 8579315,
		"ID": 15,
		"x": -158.7422580457,
		"y": -45.069818251,
		"h": 1
	},
	{
		"stop_id": 8579319,
		"ID": 14,
		"x": -158.5972657177,
		"y": -49.11881528,
		"h": 1.2307692308
	},
	{
		"stop_id": 8579320,
		"ID": 14,
		"x": -159.9422420047,
		"y": -48.183827348,
		"h": 1.2307692308
	},
	{
		"stop_id": 8588298,
		"ID": 14,
		"x": -160.3232554197,
		"y": -52.470829195,
		"h": 1.2307692308
	},
	{
		"stop_id": 8595240,
		"ID": 14,
		"x": -159.0522520777,
		"y": -48.834834959,
		"h": 1.2307692308
	},
	{
		"stop_id": 8595241,
		"ID": 14,
		"x": -159.3722411067,
		"y": -48.159807298,
		"h": 1.2307692308
	},
	{
		"stop_id": 8595242,
		"ID": 14,
		"x": -159.2822867677,
		"y": -47.849766165,
		"h": 1.2307692308
	},
	{
		"stop_id": 8595243,
		"ID": 14,
		"x": -160.3172550797,
		"y": -48.069849952,
		"h": 1.2307692308
	},
	{
		"stop_id": 8595671,
		"ID": 14,
		"x": -161.0542468177,
		"y": -52.537760622,
		"h": 1.2307692308
	},
	{
		"stop_id": 8579494,
		"ID": 471,
		"x": -53.0722469267,
		"y": -51.354795694,
		"h": 1.032967033
	},
	{
		"stop_id": 8594715,
		"ID": 471,
		"x": -53.8372282977,
		"y": -51.164823843,
		"h": 1.032967033
	},
	{
		"stop_id": 8581493,
		"ID": 1428,
		"x": 101.4727439443,
		"y": 78.057163866,
		"h": 1.032967033
	},
	{
		"stop_id": 8581494,
		"ID": 1428,
		"x": 101.9017510593,
		"y": 77.577143691,
		"h": 1.032967033
	},
	{
		"stop_id": 8581959,
		"ID": 1202,
		"x": 65.1777238333,
		"y": -15.908783801,
		"h": 1
	},
	{
		"stop_id": 8582230,
		"ID": 627,
		"x": -29.3442626637,
		"y": 87.032202833,
		"h": 1.8241758242
	},
	{
		"stop_id": 8582231,
		"ID": 627,
		"x": -29.4652634077,
		"y": 86.932177279,
		"h": 1.8241758242
	},
	{
		"stop_id": 8582232,
		"ID": 627,
		"x": -29.7782336297,
		"y": 86.554202008,
		"h": 1.8241758242
	},
	{
		"stop_id": 8582233,
		"ID": 627,
		"x": -29.7122627337,
		"y": 86.30624773,
		"h": 1.8241758242
	},
	{
		"stop_id": 8594524,
		"ID": 627,
		"x": -33.7312629117,
		"y": 87.388216808,
		"h": 1.8241758242
	},
	{
		"stop_id": 8594530,
		"ID": 627,
		"x": -33.6162804687,
		"y": 87.008229079,
		"h": 1.8241758242
	},
	{
		"stop_id": 8595271,
		"ID": 627,
		"x": -31.5562477847,
		"y": 88.090235773,
		"h": 1.8241758242
	},
	{
		"stop_id": 8595272,
		"ID": 627,
		"x": -31.7652888867,
		"y": 87.658155172,
		"h": 1.8241758242
	},
	{
		"stop_id": 8595289,
		"ID": 627,
		"x": -32.0222970937,
		"y": 87.870209209,
		"h": 1.8241758242
	},
	{
		"stop_id": 8595290,
		"ID": 627,
		"x": -32.6772427977,
		"y": 88.31416353,
		"h": 1.8241758242
	},
	{
		"stop_id": 8595291,
		"ID": 627,
		"x": -32.6362692747,
		"y": 88.237184547,
		"h": 1.8241758242
	},
	{
		"stop_id": 8595292,
		"ID": 627,
		"x": -32.3352552017,
		"y": 88.147172923,
		"h": 1.8241758242
	},
	{
		"stop_id": 8595293,
		"ID": 627,
		"x": -31.9992847457,
		"y": 88.032211357,
		"h": 1.8241758242
	},
	{
		"stop_id": 8595294,
		"ID": 627,
		"x": -32.1272560827,
		"y": 87.422174485,
		"h": 1.8241758242
	},
	{
		"stop_id": 8595296,
		"ID": 627,
		"x": -33.1302343487,
		"y": 89.366201302,
		"h": 1.8241758242
	},
	{
		"stop_id": 8595297,
		"ID": 627,
		"x": -33.2432583397,
		"y": 89.614206783,
		"h": 1.8241758242
	},
	{
		"stop_id": 8595298,
		"ID": 627,
		"x": -33.1082472287,
		"y": 88.993141805,
		"h": 1.8241758242
	},
	{
		"stop_id": 8595299,
		"ID": 627,
		"x": -32.9032887097,
		"y": 89.043215194,
		"h": 1.8241758242
	},
	{
		"stop_id": 8595300,
		"ID": 627,
		"x": -31.3172584987,
		"y": 91.516199652,
		"h": 1.8241758242
	},
	{
		"stop_id": 8595302,
		"ID": 627,
		"x": -32.7332774787,
		"y": 85.907184214,
		"h": 1.8241758242
	},
	{
		"stop_id": 8595303,
		"ID": 627,
		"x": -32.4552853087,
		"y": 86.83623328,
		"h": 1.8241758242
	},
	{
		"stop_id": 8595305,
		"ID": 627,
		"x": -32.1432568347,
		"y": 87.17514494,
		"h": 1.8241758242
	},
	{
		"stop_id": 8595306,
		"ID": 627,
		"x": -32.1362438437,
		"y": 87.236221423,
		"h": 1.8241758242
	},
	{
		"stop_id": 8595308,
		"ID": 627,
		"x": -32.7252778247,
		"y": 86.874244144,
		"h": 1.8241758242
	},
	{
		"stop_id": 8595311,
		"ID": 627,
		"x": -30.7912335647,
		"y": 88.651223211,
		"h": 1.8241758242
	},
	{
		"stop_id": 8595312,
		"ID": 627,
		"x": -31.0112321317,
		"y": 88.477247327,
		"h": 1.8241758242
	},
	{
		"stop_id": 8582450,
		"ID": 1534,
		"x": 141.3417089983,
		"y": -35.873832157,
		"h": 1.032967033
	},
	{
		"stop_id": 8582714,
		"ID": 1534,
		"x": 142.2987302863,
		"y": -33.614822815,
		"h": 1.032967033
	},
	{
		"stop_id": 8582451,
		"ID": 1547,
		"x": 150.9287736533,
		"y": -15.217772408,
		"h": 1
	},
	{
		"stop_id": 8582784,
		"ID": 1298,
		"x": 76.8897198793,
		"y": 9.049203486,
		"h": 1.2637362637
	},
	{
		"stop_id": 8582785,
		"ID": 1298,
		"x": 77.2597037503,
		"y": 8.367238154,
		"h": 1.2637362637
	},
	{
		"stop_id": 8582786,
		"ID": 1298,
		"x": 78.1847519463,
		"y": 7.061234158,
		"h": 1.2637362637
	},
	{
		"stop_id": 8582787,
		"ID": 1298,
		"x": 78.4307735333,
		"y": 6.564183427,
		"h": 1.2637362637
	},
	{
		"stop_id": 8582906,
		"ID": 1298,
		"x": 80.9567561703,
		"y": 6.433236021,
		"h": 1.2637362637
	},
	{
		"stop_id": 8582907,
		"ID": 1298,
		"x": 80.7017118563,
		"y": 6.499189703,
		"h": 1.2637362637
	},
	{
		"stop_id": 8582908,
		"ID": 1298,
		"x": 80.5277227813,
		"y": 6.597188926,
		"h": 1.2637362637
	},
	{
		"stop_id": 8582909,
		"ID": 1298,
		"x": 80.6877477773,
		"y": 6.694239125,
		"h": 1.2637362637
	},
	{
		"stop_id": 8583504,
		"ID": 1298,
		"x": 80.8327215893,
		"y": 6.782155307,
		"h": 1.2637362637
	},
	{
		"stop_id": 8582818,
		"ID": 754,
		"x": -6.4622552547,
		"y": -68.3327543,
		"h": 1.0659340659
	},
	{
		"stop_id": 8582819,
		"ID": 754,
		"x": -7.2462232317,
		"y": -69.450848646,
		"h": 1.0659340659
	},
	{
		"stop_id": 8582820,
		"ID": 754,
		"x": -7.5412984687,
		"y": -70.040818196,
		"h": 1.0659340659
	},
	{
		"stop_id": 8583722,
		"ID": 918,
		"x": 21.9797335713,
		"y": -55.621772762,
		"h": 1
	},
	{
		"stop_id": 8587030,
		"ID": 2,
		"x": -170.3382451757,
		"y": -70.103797483,
		"h": 1.5604395604
	},
	{
		"stop_id": 8587032,
		"ID": 2,
		"x": -171.3872630447,
		"y": -70.389849041,
		"h": 1.5604395604
	},
	{
		"stop_id": 8587040,
		"ID": 2,
		"x": -173.2122791407,
		"y": -70.541809414,
		"h": 1.5604395604
	},
	{
		"stop_id": 8587089,
		"ID": 2,
		"x": -170.0232465247,
		"y": -71.262859693,
		"h": 1.5604395604
	},
	{
		"stop_id": 8587477,
		"ID": 2,
		"x": -173.5472494127,
		"y": -71.173835569,
		"h": 1.5604395604
	},
	{
		"stop_id": 8592632,
		"ID": 2,
		"x": -170.5492491417,
		"y": -70.022775809,
		"h": 1.5604395604
	},
	{
		"stop_id": 8592635,
		"ID": 2,
		"x": -170.3912477677,
		"y": -70.703779893,
		"h": 1.5604395604
	},
	{
		"stop_id": 8592636,
		"ID": 2,
		"x": -170.1652497307,
		"y": -71.247818181,
		"h": 1.5604395604
	},
	{
		"stop_id": 8592637,
		"ID": 2,
		"x": -171.2392435597,
		"y": -70.286841215,
		"h": 1.5604395604
	},
	{
		"stop_id": 8592639,
		"ID": 2,
		"x": -169.4092492717,
		"y": -71.3318309,
		"h": 1.5604395604
	},
	{
		"stop_id": 8592688,
		"ID": 2,
		"x": -172.7852253517,
		"y": -70.411820017,
		"h": 1.5604395604
	},
	{
		"stop_id": 8592689,
		"ID": 2,
		"x": -173.0122903877,
		"y": -70.607819222,
		"h": 1.5604395604
	},
	{
		"stop_id": 8593218,
		"ID": 2,
		"x": -171.7062553557,
		"y": -74.879828751,
		"h": 1.5604395604
	},
	{
		"stop_id": 8593244,
		"ID": 2,
		"x": -169.4752732127,
		"y": -74.527846488,
		"h": 1.5604395604
	},
	{
		"stop_id": 8593245,
		"ID": 2,
		"x": -170.3912632817,
		"y": -74.667839284,
		"h": 1.5604395604
	},
	{
		"stop_id": 8594963,
		"ID": 2,
		"x": -173.1482810797,
		"y": -75.109838049,
		"h": 1.5604395604
	},
	{
		"stop_id": 8595011,
		"ID": 2,
		"x": -171.2092637197,
		"y": -70.39179579,
		"h": 1.5604395604
	},
	{
		"stop_id": 8595012,
		"ID": 2,
		"x": -171.3692696777,
		"y": -70.553844747,
		"h": 1.5604395604
	},
	{
		"stop_id": 8587033,
		"ID": 10,
		"x": -162.8342680907,
		"y": -70.855786439,
		"h": 1.7252747253
	},
	{
		"stop_id": 8587050,
		"ID": 10,
		"x": -161.4332407747,
		"y": -70.590750682,
		"h": 1.7252747253
	},
	{
		"stop_id": 8587070,
		"ID": 10,
		"x": -160.2672729907,
		"y": -71.425855164,
		"h": 1.7252747253
	},
	{
		"stop_id": 8587380,
		"ID": 10,
		"x": -161.5762527047,
		"y": -71.967775566,
		"h": 1.7252747253
	},
	{
		"stop_id": 8587383,
		"ID": 10,
		"x": -159.7082836887,
		"y": -71.859824718,
		"h": 1.7252747253
	},
	{
		"stop_id": 8587640,
		"ID": 10,
		"x": -159.6562460137,
		"y": -72.101835527,
		"h": 1.7252747253
	},
	{
		"stop_id": 8592640,
		"ID": 10,
		"x": -160.3552243147,
		"y": -71.286751484,
		"h": 1.7252747253
	},
	{
		"stop_id": 8592641,
		"ID": 10,
		"x": -160.1932328767,
		"y": -70.703851165,
		"h": 1.7252747253
	},
	{
		"stop_id": 8592642,
		"ID": 10,
		"x": -162.2072352577,
		"y": -70.908794882,
		"h": 1.7252747253
	},
	{
		"stop_id": 8592643,
		"ID": 10,
		"x": -160.1312927107,
		"y": -70.337759025,
		"h": 1.7252747253
	},
	{
		"stop_id": 8592644,
		"ID": 10,
		"x": -161.7112612947,
		"y": -71.012787569,
		"h": 1.7252747253
	},
	{
		"stop_id": 8593052,
		"ID": 10,
		"x": -161.2752293467,
		"y": -70.093754438,
		"h": 1.7252747253
	},
	{
		"stop_id": 8594958,
		"ID": 10,
		"x": -164.2412972257,
		"y": -72.633811852,
		"h": 1.7252747253
	},
	{
		"stop_id": 8594959,
		"ID": 10,
		"x": -163.9612989047,
		"y": -73.085814031,
		"h": 1.7252747253
	},
	{
		"stop_id": 8594960,
		"ID": 10,
		"x": -163.5462685797,
		"y": -73.762817333,
		"h": 1.7252747253
	},
	{
		"stop_id": 8595013,
		"ID": 10,
		"x": -160.8082772867,
		"y": -71.446753608,
		"h": 1.7252747253
	},
	{
		"stop_id": 8595323,
		"ID": 10,
		"x": -160.1542450927,
		"y": -71.674775815,
		"h": 1.7252747253
	},
	{
		"stop_id": 8595324,
		"ID": 10,
		"x": -161.0322521887,
		"y": -72.135781094,
		"h": 1.7252747253
	},
	{
		"stop_id": 8595325,
		"ID": 10,
		"x": -161.3902406857,
		"y": -72.318789069,
		"h": 1.7252747253
	},
	{
		"stop_id": 8595326,
		"ID": 10,
		"x": -161.8262781237,
		"y": -72.109768162,
		"h": 1.7252747253
	},
	{
		"stop_id": 8595327,
		"ID": 10,
		"x": -162.8442466147,
		"y": -71.713829936,
		"h": 1.7252747253
	},
	{
		"stop_id": 8595328,
		"ID": 10,
		"x": -163.5422592407,
		"y": -71.47775722,
		"h": 1.7252747253
	},
	{
		"stop_id": 8595554,
		"ID": 10,
		"x": -163.4892316247,
		"y": -74.413766784,
		"h": 1.7252747253
	},
	{
		"stop_id": 8587034,
		"ID": 5,
		"x": -164.9612680007,
		"y": -67.719859008,
		"h": 2.5494505495
	},
	{
		"stop_id": 8587051,
		"ID": 5,
		"x": -164.3082566097,
		"y": -68.113760085,
		"h": 2.5494505495
	},
	{
		"stop_id": 8587072,
		"ID": 5,
		"x": -167.6352835037,
		"y": -68.050780305,
		"h": 2.5494505495
	},
	{
		"stop_id": 8587074,
		"ID": 5,
		"x": -168.0522467737,
		"y": -69.99382129,
		"h": 2.5494505495
	},
	{
		"stop_id": 8587076,
		"ID": 5,
		"x": -165.3932931137,
		"y": -69.270775408,
		"h": 2.5494505495
	},
	{
		"stop_id": 8587081,
		"ID": 5,
		"x": -163.5852916137,
		"y": -70.161845429,
		"h": 2.5494505495
	},
	{
		"stop_id": 8587091,
		"ID": 5,
		"x": -167.7822540377,
		"y": -71.459820845,
		"h": 2.5494505495
	},
	{
		"stop_id": 8587092,
		"ID": 5,
		"x": -164.6892792247,
		"y": -71.24083907,
		"h": 2.5494505495
	},
	{
		"stop_id": 8592650,
		"ID": 5,
		"x": -165.3892918277,
		"y": -67.98879877,
		"h": 2.5494505495
	},
	{
		"stop_id": 8592652,
		"ID": 5,
		"x": -166.3192338277,
		"y": -69.307793667,
		"h": 2.5494505495
	},
	{
		"stop_id": 8592656,
		"ID": 5,
		"x": -165.3312458917,
		"y": -69.256848824,
		"h": 2.5494505495
	},
	{
		"stop_id": 8592657,
		"ID": 5,
		"x": -165.1722403957,
		"y": -67.881847632,
		"h": 2.5494505495
	},
	{
		"stop_id": 8592658,
		"ID": 5,
		"x": -167.0842408187,
		"y": -69.1997652,
		"h": 2.5494505495
	},
	{
		"stop_id": 8592659,
		"ID": 5,
		"x": -165.8472560947,
		"y": -67.117783719,
		"h": 2.5494505495
	},
	{
		"stop_id": 8592661,
		"ID": 5,
		"x": -165.0232872887,
		"y": -69.206846121,
		"h": 2.5494505495
	},
	{
		"stop_id": 8592662,
		"ID": 5,
		"x": -165.6452237797,
		"y": -69.376775722,
		"h": 2.5494505495
	},
	{
		"stop_id": 8592663,
		"ID": 5,
		"x": -165.8362658637,
		"y": -68.058804354,
		"h": 2.5494505495
	},
	{
		"stop_id": 8592664,
		"ID": 5,
		"x": -166.1422316747,
		"y": -68.204750609,
		"h": 2.5494505495
	},
	{
		"stop_id": 8592665,
		"ID": 5,
		"x": -164.7072460757,
		"y": -67.617759395,
		"h": 2.5494505495
	},
	{
		"stop_id": 8592684,
		"ID": 5,
		"x": -168.2662917567,
		"y": -68.185811193,
		"h": 2.5494505495
	},
	{
		"stop_id": 8592685,
		"ID": 5,
		"x": -168.9282512717,
		"y": -68.835777318,
		"h": 2.5494505495
	},
	{
		"stop_id": 8592756,
		"ID": 5,
		"x": -164.4742681417,
		"y": -68.266765899,
		"h": 2.5494505495
	},
	{
		"stop_id": 8592759,
		"ID": 5,
		"x": -164.7302542007,
		"y": -68.658805278,
		"h": 2.5494505495
	},
	{
		"stop_id": 8592971,
		"ID": 5,
		"x": -167.4632272187,
		"y": -69.384821257,
		"h": 2.5494505495
	},
	{
		"stop_id": 8592972,
		"ID": 5,
		"x": -168.2752960867,
		"y": -70.173833986,
		"h": 2.5494505495
	},
	{
		"stop_id": 8592973,
		"ID": 5,
		"x": -167.9492767007,
		"y": -69.679791057,
		"h": 2.5494505495
	},
	{
		"stop_id": 8593044,
		"ID": 5,
		"x": -164.3712428327,
		"y": -70.103834861,
		"h": 2.5494505495
	},
	{
		"stop_id": 8593045,
		"ID": 5,
		"x": -164.5693004167,
		"y": -70.051820581,
		"h": 2.5494505495
	},
	{
		"stop_id": 8593046,
		"ID": 5,
		"x": -163.8552772347,
		"y": -70.463847088,
		"h": 2.5494505495
	},
	{
		"stop_id": 8593047,
		"ID": 5,
		"x": -163.3422785407,
		"y": -69.885831845,
		"h": 2.5494505495
	},
	{
		"stop_id": 8593048,
		"ID": 5,
		"x": -163.9322555427,
		"y": -70.132755822,
		"h": 2.5494505495
	},
	{
		"stop_id": 8593049,
		"ID": 5,
		"x": -164.0052243967,
		"y": -70.63682244,
		"h": 2.5494505495
	},
	{
		"stop_id": 8593232,
		"ID": 5,
		"x": -165.6292929577,
		"y": -71.844756427,
		"h": 2.5494505495
	},
	{
		"stop_id": 8593235,
		"ID": 5,
		"x": -164.2882542607,
		"y": -70.9668212,
		"h": 2.5494505495
	},
	{
		"stop_id": 8594956,
		"ID": 5,
		"x": -164.3212753307,
		"y": -71.522829862,
		"h": 2.5494505495
	},
	{
		"stop_id": 8594957,
		"ID": 5,
		"x": -164.7272574267,
		"y": -71.799762246,
		"h": 2.5494505495
	},
	{
		"stop_id": 8595014,
		"ID": 5,
		"x": -164.9592826077,
		"y": -68.924777666,
		"h": 2.5494505495
	},
	{
		"stop_id": 8595034,
		"ID": 5,
		"x": -163.6572336587,
		"y": -70.094790681,
		"h": 2.5494505495
	},
	{
		"stop_id": 8595043,
		"ID": 5,
		"x": -166.5052966647,
		"y": -69.081814081,
		"h": 2.5494505495
	},
	{
		"stop_id": 8595044,
		"ID": 5,
		"x": -167.5422658977,
		"y": -71.306775019,
		"h": 2.5494505495
	},
	{
		"stop_id": 8595045,
		"ID": 5,
		"x": -164.7042550787,
		"y": -71.141849305,
		"h": 2.5494505495
	},
	{
		"stop_id": 8595046,
		"ID": 5,
		"x": -164.9572479007,
		"y": -71.509807296,
		"h": 2.5494505495
	},
	{
		"stop_id": 8595047,
		"ID": 5,
		"x": -165.3422454067,
		"y": -71.618844152,
		"h": 2.5494505495
	},
	{
		"stop_id": 8595048,
		"ID": 5,
		"x": -165.6172798077,
		"y": -71.979831362,
		"h": 2.5494505495
	},
	{
		"stop_id": 8595224,
		"ID": 5,
		"x": -166.5962937167,
		"y": -68.945787519,
		"h": 2.5494505495
	},
	{
		"stop_id": 8595551,
		"ID": 5,
		"x": -164.2892838647,
		"y": -71.576750064,
		"h": 2.5494505495
	},
	{
		"stop_id": 8595552,
		"ID": 5,
		"x": -164.8542728257,
		"y": -72.108758174,
		"h": 2.5494505495
	},
	{
		"stop_id": 8595553,
		"ID": 5,
		"x": -164.6892711257,
		"y": -72.198788098,
		"h": 2.5494505495
	},
	{
		"stop_id": 8587035,
		"ID": 13,
		"x": -161.8052949607,
		"y": -56.410767792,
		"h": 1.7252747253
	},
	{
		"stop_id": 8587044,
		"ID": 13,
		"x": -161.2132826597,
		"y": -57.426821375,
		"h": 1.7252747253
	},
	{
		"stop_id": 8592720,
		"ID": 13,
		"x": -160.9862753757,
		"y": -57.195817674,
		"h": 1.7252747253
	},
	{
		"stop_id": 8592721,
		"ID": 13,
		"x": -161.0302380277,
		"y": -57.697840006,
		"h": 1.7252747253
	},
	{
		"stop_id": 8592722,
		"ID": 13,
		"x": -161.1842586357,
		"y": -56.988811764,
		"h": 1.7252747253
	},
	{
		"stop_id": 8592723,
		"ID": 13,
		"x": -161.0422736377,
		"y": -58.125795444,
		"h": 1.7252747253
	},
	{
		"stop_id": 8593041,
		"ID": 13,
		"x": -163.0492376807,
		"y": -57.443834682,
		"h": 1.7252747253
	},
	{
		"stop_id": 8593182,
		"ID": 13,
		"x": -158.2302255767,
		"y": -55.697774664,
		"h": 1.7252747253
	},
	{
		"stop_id": 8593185,
		"ID": 13,
		"x": -158.7252685887,
		"y": -55.046835213,
		"h": 1.7252747253
	},
	{
		"stop_id": 8593222,
		"ID": 13,
		"x": -163.2222649177,
		"y": -57.124783375,
		"h": 1.7252747253
	},
	{
		"stop_id": 8593225,
		"ID": 13,
		"x": -162.8342775107,
		"y": -54.545786749,
		"h": 1.7252747253
	},
	{
		"stop_id": 8593226,
		"ID": 13,
		"x": -163.9982527737,
		"y": -55.770807232,
		"h": 1.7252747253
	},
	{
		"stop_id": 8594934,
		"ID": 13,
		"x": -161.7892322647,
		"y": -58.069860193,
		"h": 1.7252747253
	},
	{
		"stop_id": 8595664,
		"ID": 13,
		"x": -159.5242331967,
		"y": -54.396840611,
		"h": 1.7252747253
	},
	{
		"stop_id": 8595665,
		"ID": 13,
		"x": -158.4752563947,
		"y": -55.249830613,
		"h": 1.7252747253
	},
	{
		"stop_id": 8595666,
		"ID": 13,
		"x": -158.7312955027,
		"y": -56.067814069,
		"h": 1.7252747253
	},
	{
		"stop_id": 8595667,
		"ID": 13,
		"x": -159.3792380357,
		"y": -56.042813505,
		"h": 1.7252747253
	},
	{
		"stop_id": 8595668,
		"ID": 13,
		"x": -160.3812383167,
		"y": -53.688845616,
		"h": 1.7252747253
	},
	{
		"stop_id": 8595669,
		"ID": 13,
		"x": -160.8922258567,
		"y": -53.272825878,
		"h": 1.7252747253
	},
	{
		"stop_id": 8595670,
		"ID": 13,
		"x": -161.2802492497,
		"y": -52.828813268,
		"h": 1.7252747253
	},
	{
		"stop_id": 8595675,
		"ID": 13,
		"x": -160.0083006287,
		"y": -56.231856983,
		"h": 1.7252747253
	},
	{
		"stop_id": 8595885,
		"ID": 13,
		"x": -162.7362290477,
		"y": -58.11482372,
		"h": 1.7252747253
	},
	{
		"stop_id": 8595886,
		"ID": 13,
		"x": -163.2362340097,
		"y": -53.937750383,
		"h": 1.7252747253
	},
	{
		"stop_id": 8587043,
		"ID": 31,
		"x": -153.5392613647,
		"y": -62.78585254,
		"h": 2.4835164835
	},
	{
		"stop_id": 8587054,
		"ID": 31,
		"x": -151.8312644777,
		"y": -60.888846015,
		"h": 2.4835164835
	},
	{
		"stop_id": 8587066,
		"ID": 31,
		"x": -150.7912745607,
		"y": -59.540788548,
		"h": 2.4835164835
	},
	{
		"stop_id": 8587068,
		"ID": 31,
		"x": -149.7272709607,
		"y": -61.343801928,
		"h": 2.4835164835
	},
	{
		"stop_id": 8587077,
		"ID": 31,
		"x": -152.8332855797,
		"y": -60.263787523,
		"h": 2.4835164835
	},
	{
		"stop_id": 8587085,
		"ID": 31,
		"x": -151.1912326007,
		"y": -63.245759059,
		"h": 2.4835164835
	},
	{
		"stop_id": 8587086,
		"ID": 31,
		"x": -152.8562563337,
		"y": -64.133781225,
		"h": 2.4835164835
	},
	{
		"stop_id": 8587382,
		"ID": 31,
		"x": -153.4132911607,
		"y": -63.00282589,
		"h": 2.4835164835
	},
	{
		"stop_id": 8587925,
		"ID": 31,
		"x": -153.9642349667,
		"y": -61.316795563,
		"h": 2.4835164835
	},
	{
		"stop_id": 8592717,
		"ID": 31,
		"x": -154.4112717797,
		"y": -61.65879894,
		"h": 2.4835164835
	},
	{
		"stop_id": 8592719,
		"ID": 31,
		"x": -154.2852365317,
		"y": -61.887799551,
		"h": 2.4835164835
	},
	{
		"stop_id": 8592732,
		"ID": 31,
		"x": -154.6832467317,
		"y": -61.359796282,
		"h": 2.4835164835
	},
	{
		"stop_id": 8592735,
		"ID": 31,
		"x": -153.7152321187,
		"y": -59.642763857,
		"h": 2.4835164835
	},
	{
		"stop_id": 8592738,
		"ID": 31,
		"x": -153.4482697787,
		"y": -59.198749958,
		"h": 2.4835164835
	},
	{
		"stop_id": 8592762,
		"ID": 31,
		"x": -153.0622937477,
		"y": -58.720765482,
		"h": 2.4835164835
	},
	{
		"stop_id": 8592763,
		"ID": 31,
		"x": -152.9242246777,
		"y": -58.493758411,
		"h": 2.4835164835
	},
	{
		"stop_id": 8592954,
		"ID": 31,
		"x": -150.6272306767,
		"y": -59.658772761,
		"h": 2.4835164835
	},
	{
		"stop_id": 8592955,
		"ID": 31,
		"x": -151.0462436127,
		"y": -59.861801974,
		"h": 2.4835164835
	},
	{
		"stop_id": 8592956,
		"ID": 31,
		"x": -150.9702878107,
		"y": -59.668832851,
		"h": 2.4835164835
	},
	{
		"stop_id": 8592959,
		"ID": 31,
		"x": -149.3822701177,
		"y": -61.208846386,
		"h": 2.4835164835
	},
	{
		"stop_id": 8592960,
		"ID": 31,
		"x": -151.4362315497,
		"y": -62.694828203,
		"h": 2.4835164835
	},
	{
		"stop_id": 8592962,
		"ID": 31,
		"x": -149.8652749017,
		"y": -61.24980114,
		"h": 2.4835164835
	},
	{
		"stop_id": 8592963,
		"ID": 31,
		"x": -151.4382576457,
		"y": -61.780801845,
		"h": 2.4835164835
	},
	{
		"stop_id": 8592964,
		"ID": 31,
		"x": -150.5732852087,
		"y": -61.472783855,
		"h": 2.4835164835
	},
	{
		"stop_id": 8592965,
		"ID": 31,
		"x": -151.3382451687,
		"y": -62.919782143,
		"h": 2.4835164835
	},
	{
		"stop_id": 8592967,
		"ID": 31,
		"x": -149.0812482157,
		"y": -61.109798645,
		"h": 2.4835164835
	},
	{
		"stop_id": 8592968,
		"ID": 31,
		"x": -150.2372684977,
		"y": -61.506843049,
		"h": 2.4835164835
	},
	{
		"stop_id": 8592969,
		"ID": 31,
		"x": -151.5262400147,
		"y": -62.493785886,
		"h": 2.4835164835
	},
	{
		"stop_id": 8592970,
		"ID": 31,
		"x": -151.3872481277,
		"y": -61.6478284,
		"h": 2.4835164835
	},
	{
		"stop_id": 8592999,
		"ID": 31,
		"x": -152.5372700137,
		"y": -60.958759497,
		"h": 2.4835164835
	},
	{
		"stop_id": 8593001,
		"ID": 31,
		"x": -152.6622812407,
		"y": -60.178811532,
		"h": 2.4835164835
	},
	{
		"stop_id": 8593002,
		"ID": 31,
		"x": -151.6162246007,
		"y": -59.957778704,
		"h": 2.4835164835
	},
	{
		"stop_id": 8593003,
		"ID": 31,
		"x": -151.7852943417,
		"y": -60.686757475,
		"h": 2.4835164835
	},
	{
		"stop_id": 8593004,
		"ID": 31,
		"x": -153.2332575227,
		"y": -60.489751972,
		"h": 2.4835164835
	},
	{
		"stop_id": 8593005,
		"ID": 31,
		"x": -151.9972420287,
		"y": -61.194833624,
		"h": 2.4835164835
	},
	{
		"stop_id": 8593006,
		"ID": 31,
		"x": -152.3862471977,
		"y": -60.21084551,
		"h": 2.4835164835
	},
	{
		"stop_id": 8593007,
		"ID": 31,
		"x": -151.6582597697,
		"y": -62.386827163,
		"h": 2.4835164835
	},
	{
		"stop_id": 8593081,
		"ID": 31,
		"x": -151.3412886917,
		"y": -64.011839258,
		"h": 2.4835164835
	},
	{
		"stop_id": 8593082,
		"ID": 31,
		"x": -152.6392871457,
		"y": -64.193820417,
		"h": 2.4835164835
	},
	{
		"stop_id": 8593087,
		"ID": 31,
		"x": -152.6702742147,
		"y": -63.874817549,
		"h": 2.4835164835
	},
	{
		"stop_id": 8595039,
		"ID": 31,
		"x": -151.4062573587,
		"y": -63.67976572,
		"h": 2.4835164835
	},
	{
		"stop_id": 8595226,
		"ID": 31,
		"x": -152.8762255827,
		"y": -63.300856952,
		"h": 2.4835164835
	},
	{
		"stop_id": 8595227,
		"ID": 31,
		"x": -152.4092537797,
		"y": -63.381856795,
		"h": 2.4835164835
	},
	{
		"stop_id": 8595457,
		"ID": 31,
		"x": -150.8402559247,
		"y": -60.103833209,
		"h": 2.4835164835
	},
	{
		"stop_id": 8595673,
		"ID": 31,
		"x": -153.4352417787,
		"y": -60.362769937,
		"h": 2.4835164835
	},
	{
		"stop_id": 8595674,
		"ID": 31,
		"x": -153.7422358217,
		"y": -60.168774947,
		"h": 2.4835164835
	},
	{
		"stop_id": 8587093,
		"ID": 20,
		"x": -159.4042525337,
		"y": -69.659787902,
		"h": 1.989010989
	},
	{
		"stop_id": 8587905,
		"ID": 20,
		"x": -156.4332400857,
		"y": -68.928844409,
		"h": 1.989010989
	},
	{
		"stop_id": 8587906,
		"ID": 20,
		"x": -156.7492312087,
		"y": -68.936794089,
		"h": 1.989010989
	},
	{
		"stop_id": 8589097,
		"ID": 20,
		"x": -157.0042920697,
		"y": -69.363855354,
		"h": 1.989010989
	},
	{
		"stop_id": 8592692,
		"ID": 20,
		"x": -157.0552569697,
		"y": -67.177792335,
		"h": 1.989010989
	},
	{
		"stop_id": 8592702,
		"ID": 20,
		"x": -156.8042440207,
		"y": -67.32980618,
		"h": 1.989010989
	},
	{
		"stop_id": 8593123,
		"ID": 20,
		"x": -156.2882818387,
		"y": -67.338842261,
		"h": 1.989010989
	},
	{
		"stop_id": 8593127,
		"ID": 20,
		"x": -159.3972510467,
		"y": -69.445769001,
		"h": 1.989010989
	},
	{
		"stop_id": 8593192,
		"ID": 20,
		"x": -157.3023004107,
		"y": -69.33782211,
		"h": 1.989010989
	},
	{
		"stop_id": 8593193,
		"ID": 20,
		"x": -157.3023004107,
		"y": -69.33782211,
		"h": 1.989010989
	},
	{
		"stop_id": 8593195,
		"ID": 20,
		"x": -157.8282248907,
		"y": -69.322759448,
		"h": 1.989010989
	},
	{
		"stop_id": 8593198,
		"ID": 20,
		"x": -158.0712936477,
		"y": -68.302847991,
		"h": 1.989010989
	},
	{
		"stop_id": 8593200,
		"ID": 20,
		"x": -156.6982966887,
		"y": -69.209779133,
		"h": 1.989010989
	},
	{
		"stop_id": 8593201,
		"ID": 20,
		"x": -156.9052779197,
		"y": -68.744839265,
		"h": 1.989010989
	},
	{
		"stop_id": 8593202,
		"ID": 20,
		"x": -157.1422580637,
		"y": -68.710787668,
		"h": 1.989010989
	},
	{
		"stop_id": 8593203,
		"ID": 20,
		"x": -156.7712869617,
		"y": -68.245790453,
		"h": 1.989010989
	},
	{
		"stop_id": 8593204,
		"ID": 20,
		"x": -158.8852233597,
		"y": -68.852804463,
		"h": 1.989010989
	},
	{
		"stop_id": 8593205,
		"ID": 20,
		"x": -158.6532542887,
		"y": -69.079851831,
		"h": 1.989010989
	},
	{
		"stop_id": 8593206,
		"ID": 20,
		"x": -158.4712611967,
		"y": -68.45076333,
		"h": 1.989010989
	},
	{
		"stop_id": 8593207,
		"ID": 20,
		"x": -156.7692772607,
		"y": -68.582809135,
		"h": 1.989010989
	},
	{
		"stop_id": 8593209,
		"ID": 20,
		"x": -158.7292852537,
		"y": -68.608759354,
		"h": 1.989010989
	},
	{
		"stop_id": 8593210,
		"ID": 20,
		"x": -156.7712293017,
		"y": -67.65475886,
		"h": 1.989010989
	},
	{
		"stop_id": 8593211,
		"ID": 20,
		"x": -157.1112386587,
		"y": -69.024814816,
		"h": 1.989010989
	},
	{
		"stop_id": 8593212,
		"ID": 20,
		"x": -156.5822553107,
		"y": -68.827844437,
		"h": 1.989010989
	},
	{
		"stop_id": 8593213,
		"ID": 20,
		"x": -156.9582248507,
		"y": -67.83375799,
		"h": 1.989010989
	},
	{
		"stop_id": 8593214,
		"ID": 20,
		"x": -157.7852859497,
		"y": -68.174851989,
		"h": 1.989010989
	},
	{
		"stop_id": 8593216,
		"ID": 20,
		"x": -158.5232790407,
		"y": -67.875778297,
		"h": 1.989010989
	},
	{
		"stop_id": 8595782,
		"ID": 20,
		"x": -154.9342400367,
		"y": -67.189754955,
		"h": 1.989010989
	},
	{
		"stop_id": 8595815,
		"ID": 20,
		"x": -155.3642474457,
		"y": -68.87679201,
		"h": 1.989010989
	},
	{
		"stop_id": 8595827,
		"ID": 20,
		"x": -155.2772700027,
		"y": -67.228818146,
		"h": 1.989010989
	},
	{
		"stop_id": 8595832,
		"ID": 20,
		"x": -156.4572665727,
		"y": -69.426768721,
		"h": 1.989010989
	},
	{
		"stop_id": 8587404,
		"ID": 1404,
		"x": 100.8827398743,
		"y": 60.450243495,
		"h": 1.3956043956
	},
	{
		"stop_id": 8587469,
		"ID": 1404,
		"x": 99.0577217973,
		"y": 57.730245978,
		"h": 1.3956043956
	},
	{
		"stop_id": 8587488,
		"ID": 1404,
		"x": 101.1177377893,
		"y": 60.9712363,
		"h": 1.3956043956
	},
	{
		"stop_id": 8587489,
		"ID": 1404,
		"x": 100.8287492893,
		"y": 59.93316004,
		"h": 1.3956043956
	},
	{
		"stop_id": 8587490,
		"ID": 1404,
		"x": 99.8217002223,
		"y": 59.570198805,
		"h": 1.3956043956
	},
	{
		"stop_id": 8587491,
		"ID": 1404,
		"x": 99.6277594903,
		"y": 58.362248804,
		"h": 1.3956043956
	},
	{
		"stop_id": 8587492,
		"ID": 1404,
		"x": 99.1677356953,
		"y": 57.315229681,
		"h": 1.3956043956
	},
	{
		"stop_id": 8588232,
		"ID": 1404,
		"x": 101.0077101733,
		"y": 61.350186254,
		"h": 1.3956043956
	},
	{
		"stop_id": 8588234,
		"ID": 1404,
		"x": 99.8977143563,
		"y": 61.980175052,
		"h": 1.3956043956
	},
	{
		"stop_id": 8588957,
		"ID": 1404,
		"x": 99.7577221713,
		"y": 58.990243332,
		"h": 1.3956043956
	},
	{
		"stop_id": 8595376,
		"ID": 1404,
		"x": 99.6457125063,
		"y": 60.455229089,
		"h": 1.3956043956
	},
	{
		"stop_id": 8595377,
		"ID": 1404,
		"x": 99.1067423793,
		"y": 61.325188697,
		"h": 1.3956043956
	},
	{
		"stop_id": 8595378,
		"ID": 1404,
		"x": 100.8617506573,
		"y": 60.753197596,
		"h": 1.3956043956
	},
	{
		"stop_id": 8587442,
		"ID": 1498,
		"x": 130.0717523573,
		"y": -5.138804668,
		"h": 1
	},
	{
		"stop_id": 8587456,
		"ID": 568,
		"x": -39.0992576417,
		"y": -64.729856488,
		"h": 1
	},
	{
		"stop_id": 8587594,
		"ID": 64,
		"x": -134.7132529667,
		"y": 3.101166257,
		"h": 1.032967033
	},
	{
		"stop_id": 8593785,
		"ID": 64,
		"x": -134.4392437857,
		"y": 3.078168497,
		"h": 1.032967033
	},
	{
		"stop_id": 8587919,
		"ID": 4,
		"x": -170.7352973537,
		"y": -59.184804084,
		"h": 1.3956043956
	},
	{
		"stop_id": 8587920,
		"ID": 4,
		"x": -168.9272448657,
		"y": -60.093766871,
		"h": 1.3956043956
	},
	{
		"stop_id": 8587922,
		"ID": 4,
		"x": -172.2372439477,
		"y": -60.999793656,
		"h": 1.3956043956
	},
	{
		"stop_id": 8587923,
		"ID": 4,
		"x": -171.3072820667,
		"y": -62.025808687,
		"h": 1.3956043956
	},
	{
		"stop_id": 8592771,
		"ID": 4,
		"x": -171.5922924207,
		"y": -63.808830194,
		"h": 1.3956043956
	},
	{
		"stop_id": 8593095,
		"ID": 4,
		"x": -169.0672725727,
		"y": -63.037819129,
		"h": 1.3956043956
	},
	{
		"stop_id": 8593227,
		"ID": 4,
		"x": -169.8142464047,
		"y": -59.672852767,
		"h": 1.3956043956
	},
	{
		"stop_id": 8593230,
		"ID": 4,
		"x": -168.6902385917,
		"y": -60.412805178,
		"h": 1.3956043956
	},
	{
		"stop_id": 8593236,
		"ID": 4,
		"x": -172.2382609597,
		"y": -61.522786707,
		"h": 1.3956043956
	},
	{
		"stop_id": 8593237,
		"ID": 4,
		"x": -171.9262405247,
		"y": -60.064844165,
		"h": 1.3956043956
	},
	{
		"stop_id": 8593238,
		"ID": 4,
		"x": -171.5032447237,
		"y": -59.762812857,
		"h": 1.3956043956
	},
	{
		"stop_id": 8595950,
		"ID": 4,
		"x": -171.2802614897,
		"y": -63.940789159,
		"h": 1.3956043956
	},
	{
		"stop_id": 8595951,
		"ID": 4,
		"x": -171.0502555137,
		"y": -63.241788042,
		"h": 1.3956043956
	},
	{
		"stop_id": 8587921,
		"ID": 7,
		"x": -168.0162439967,
		"y": -60.348760118,
		"h": 1.4285714286
	},
	{
		"stop_id": 8593023,
		"ID": 7,
		"x": -164.8832281217,
		"y": -61.32579116,
		"h": 1.4285714286
	},
	{
		"stop_id": 8593228,
		"ID": 7,
		"x": -168.5062571807,
		"y": -59.911792604,
		"h": 1.4285714286
	},
	{
		"stop_id": 8593229,
		"ID": 7,
		"x": -168.6602391247,
		"y": -60.160848767,
		"h": 1.4285714286
	},
	{
		"stop_id": 8593231,
		"ID": 7,
		"x": -168.4822593717,
		"y": -60.532849386,
		"h": 1.4285714286
	},
	{
		"stop_id": 8594937,
		"ID": 7,
		"x": -163.4182917077,
		"y": -58.995830835,
		"h": 1.4285714286
	},
	{
		"stop_id": 8594938,
		"ID": 7,
		"x": -163.8952919727,
		"y": -59.08479794,
		"h": 1.4285714286
	},
	{
		"stop_id": 8594939,
		"ID": 7,
		"x": -164.3282450247,
		"y": -59.087768569,
		"h": 1.4285714286
	},
	{
		"stop_id": 8594940,
		"ID": 7,
		"x": -164.6942359507,
		"y": -58.969794173,
		"h": 1.4285714286
	},
	{
		"stop_id": 8594941,
		"ID": 7,
		"x": -165.4622989537,
		"y": -59.052795686,
		"h": 1.4285714286
	},
	{
		"stop_id": 8594942,
		"ID": 7,
		"x": -164.9562599317,
		"y": -59.436759117,
		"h": 1.4285714286
	},
	{
		"stop_id": 8594943,
		"ID": 7,
		"x": -164.0072828897,
		"y": -59.768857502,
		"h": 1.4285714286
	},
	{
		"stop_id": 8594944,
		"ID": 7,
		"x": -164.5382774207,
		"y": -59.893755417,
		"h": 1.4285714286
	},
	{
		"stop_id": 8595458,
		"ID": 7,
		"x": -164.7642782437,
		"y": -61.162754225,
		"h": 1.4285714286
	},
	{
		"stop_id": 8587928,
		"ID": 913,
		"x": 18.7987637463,
		"y": 97.008247132,
		"h": 1
	},
	{
		"stop_id": 8588140,
		"ID": 1130,
		"x": 54.8497307283,
		"y": -20.002796702,
		"h": 1
	},
	{
		"stop_id": 8588141,
		"ID": 1164,
		"x": 57.0577762393,
		"y": -24.369843457,
		"h": 1
	},
	{
		"stop_id": 8589091,
		"ID": 810,
		"x": 1.9327053333,
		"y": -46.269849908,
		"h": 1
	},
	{
		"stop_id": 8589099,
		"ID": 1167,
		"x": 57.6227234943,
		"y": -11.874851539,
		"h": 1.0659340659
	},
	{
		"stop_id": 8589100,
		"ID": 1167,
		"x": 56.4077256403,
		"y": -10.469840236,
		"h": 1.0659340659
	},
	{
		"stop_id": 8589103,
		"ID": 1167,
		"x": 56.0577062483,
		"y": -8.619773996,
		"h": 1.0659340659
	},
	{
		"stop_id": 8592961,
		"ID": 40,
		"x": -147.8522985387,
		"y": -60.810768441,
		"h": 1.1318681319
	},
	{
		"stop_id": 8592966,
		"ID": 40,
		"x": -147.0862682617,
		"y": -60.77675387,
		"h": 1.1318681319
	},
	{
		"stop_id": 8595810,
		"ID": 40,
		"x": -145.3842353097,
		"y": -60.050791254,
		"h": 1.1318681319
	},
	{
		"stop_id": 8595823,
		"ID": 40,
		"x": -145.3362774397,
		"y": -59.730838134,
		"h": 1.1318681319
	},
	{
		"stop_id": 8595858,
		"ID": 40,
		"x": -145.6502762747,
		"y": -60.979784777,
		"h": 1.1318681319
	},
	{
		"stop_id": 8593079,
		"ID": 30,
		"x": -151.6222388817,
		"y": -64.372796144,
		"h": 4.6923076923
	},
	{
		"stop_id": 8593080,
		"ID": 30,
		"x": -151.8672530507,
		"y": -64.576859673,
		"h": 4.6923076923
	},
	{
		"stop_id": 8593083,
		"ID": 30,
		"x": -152.2112476307,
		"y": -64.427854143,
		"h": 4.6923076923
	},
	{
		"stop_id": 8593085,
		"ID": 30,
		"x": -152.9952938057,
		"y": -64.420813737,
		"h": 4.6923076923
	},
	{
		"stop_id": 8593086,
		"ID": 30,
		"x": -153.2442465607,
		"y": -64.626762719,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595358,
		"ID": 30,
		"x": -152.9462882457,
		"y": -65.983852573,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595359,
		"ID": 30,
		"x": -152.5112840987,
		"y": -65.489793394,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595360,
		"ID": 30,
		"x": -152.5762362097,
		"y": -65.908829328,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595361,
		"ID": 30,
		"x": -152.7372587237,
		"y": -65.911802853,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595363,
		"ID": 30,
		"x": -153.3682967647,
		"y": -66.112749123,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595364,
		"ID": 30,
		"x": -153.5002543727,
		"y": -66.177856667,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595365,
		"ID": 30,
		"x": -153.7672705267,
		"y": -66.243753597,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595366,
		"ID": 30,
		"x": -153.7672751427,
		"y": -66.283777959,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595734,
		"ID": 30,
		"x": -150.3312961097,
		"y": -65.001756477,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595735,
		"ID": 30,
		"x": -152.8292969287,
		"y": -66.092830949,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595736,
		"ID": 30,
		"x": -150.5402766477,
		"y": -65.737844363,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595737,
		"ID": 30,
		"x": -152.3162906927,
		"y": -64.991811549,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595738,
		"ID": 30,
		"x": -151.8362854767,
		"y": -65.391824315,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595740,
		"ID": 30,
		"x": -153.2332636137,
		"y": -65.658782815,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595742,
		"ID": 30,
		"x": -152.4252287317,
		"y": -66.891852314,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595743,
		"ID": 30,
		"x": -152.3252709487,
		"y": -66.223754685,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595744,
		"ID": 30,
		"x": -149.7162273297,
		"y": -65.028840847,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595745,
		"ID": 30,
		"x": -153.0682294157,
		"y": -66.130840197,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595746,
		"ID": 30,
		"x": -153.3172680527,
		"y": -65.404773928,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595747,
		"ID": 30,
		"x": -150.4382338427,
		"y": -66.593779153,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595749,
		"ID": 30,
		"x": -150.1642565367,
		"y": -64.950780463,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595753,
		"ID": 30,
		"x": -150.0862840377,
		"y": -65.430789392,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595754,
		"ID": 30,
		"x": -152.1022287647,
		"y": -67.807790883,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595755,
		"ID": 30,
		"x": -151.3312265167,
		"y": -66.338841328,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595760,
		"ID": 30,
		"x": -152.6052505057,
		"y": -66.450824459,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595761,
		"ID": 30,
		"x": -152.4412348517,
		"y": -66.570856643,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595762,
		"ID": 30,
		"x": -154.2052553487,
		"y": -67.254772727,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595763,
		"ID": 30,
		"x": -152.8482852617,
		"y": -66.207830948,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595764,
		"ID": 30,
		"x": -154.1392973587,
		"y": -67.016767378,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595765,
		"ID": 30,
		"x": -150.9882822097,
		"y": -65.102832507,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595766,
		"ID": 30,
		"x": -150.9732424227,
		"y": -65.108840733,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595767,
		"ID": 30,
		"x": -151.2922696977,
		"y": -67.978755801,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595768,
		"ID": 30,
		"x": -149.0032648487,
		"y": -66.948774195,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595769,
		"ID": 30,
		"x": -150.3932511667,
		"y": -65.215846074,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595770,
		"ID": 30,
		"x": -150.1152820197,
		"y": -67.872825267,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595771,
		"ID": 30,
		"x": -152.7202463277,
		"y": -64.845750075,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595772,
		"ID": 30,
		"x": -148.2842858247,
		"y": -66.885854953,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595773,
		"ID": 30,
		"x": -151.8132428657,
		"y": -67.336797346,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595774,
		"ID": 30,
		"x": -150.7862355987,
		"y": -65.003816937,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595776,
		"ID": 30,
		"x": -151.9832821347,
		"y": -66.667802436,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595777,
		"ID": 30,
		"x": -151.4522631897,
		"y": -64.98785819,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595779,
		"ID": 30,
		"x": -152.2022661717,
		"y": -65.975818491,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595780,
		"ID": 30,
		"x": -153.5652949367,
		"y": -67.961826197,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595781,
		"ID": 30,
		"x": -151.8922670277,
		"y": -67.591749165,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595783,
		"ID": 30,
		"x": -152.1522714117,
		"y": -65.745776143,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595784,
		"ID": 30,
		"x": -153.0412446937,
		"y": -65.297749499,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595787,
		"ID": 30,
		"x": -154.6562603347,
		"y": -67.048812314,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595790,
		"ID": 30,
		"x": -152.4312776147,
		"y": -65.437765851,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595791,
		"ID": 30,
		"x": -151.7692463127,
		"y": -67.175813437,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595793,
		"ID": 30,
		"x": -151.7472824197,
		"y": -65.76785046,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595794,
		"ID": 30,
		"x": -151.4072274927,
		"y": -66.900808061,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595796,
		"ID": 30,
		"x": -151.4202764827,
		"y": -66.197851975,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595797,
		"ID": 30,
		"x": -151.4542451127,
		"y": -66.59980249,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595798,
		"ID": 30,
		"x": -151.8832435897,
		"y": -65.975796237,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595799,
		"ID": 30,
		"x": -153.6142872897,
		"y": -65.53580818,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595800,
		"ID": 30,
		"x": -154.0552450047,
		"y": -65.97477423,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595801,
		"ID": 30,
		"x": -151.1472271467,
		"y": -66.348851907,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595804,
		"ID": 30,
		"x": -150.1512876287,
		"y": -65.683859351,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595806,
		"ID": 30,
		"x": -149.9032858177,
		"y": -67.34978361,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595807,
		"ID": 30,
		"x": -152.4282654737,
		"y": -67.326847827,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595809,
		"ID": 30,
		"x": -151.3362326107,
		"y": -65.11480385,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595811,
		"ID": 30,
		"x": -150.3082392377,
		"y": -64.848787506,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595812,
		"ID": 30,
		"x": -149.6182957007,
		"y": -67.113769916,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595813,
		"ID": 30,
		"x": -150.4312385587,
		"y": -65.550811636,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595816,
		"ID": 30,
		"x": -150.8032921717,
		"y": -66.392841966,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595817,
		"ID": 30,
		"x": -152.4832980947,
		"y": -66.171858712,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595818,
		"ID": 30,
		"x": -151.7052335027,
		"y": -66.957765576,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595820,
		"ID": 30,
		"x": -152.0672904547,
		"y": -66.424818409,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595821,
		"ID": 30,
		"x": -151.9002530107,
		"y": -67.294780845,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595822,
		"ID": 30,
		"x": -153.0312618517,
		"y": -66.972811687,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595824,
		"ID": 30,
		"x": -153.1492851667,
		"y": -67.559793268,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595826,
		"ID": 30,
		"x": -152.2092587807,
		"y": -66.296795187,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595828,
		"ID": 30,
		"x": -153.4692616187,
		"y": -65.413759986,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595830,
		"ID": 30,
		"x": -151.6492520547,
		"y": -67.877839977,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595834,
		"ID": 30,
		"x": -152.3742972987,
		"y": -66.369759626,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595835,
		"ID": 30,
		"x": -152.1442428637,
		"y": -66.973754542,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595838,
		"ID": 30,
		"x": -153.6082396837,
		"y": -66.762761579,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595839,
		"ID": 30,
		"x": -152.6912838637,
		"y": -66.210802098,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595840,
		"ID": 30,
		"x": -152.5562686887,
		"y": -66.252789,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595841,
		"ID": 30,
		"x": -152.9803000317,
		"y": -67.398856492,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595842,
		"ID": 30,
		"x": -151.7692465537,
		"y": -64.958804683,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595843,
		"ID": 30,
		"x": -154.1292418037,
		"y": -66.154841567,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595844,
		"ID": 30,
		"x": -151.3622664217,
		"y": -65.803825857,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595845,
		"ID": 30,
		"x": -150.5432839847,
		"y": -64.904853324,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595846,
		"ID": 30,
		"x": -151.9262991317,
		"y": -65.239805846,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595847,
		"ID": 30,
		"x": -151.1012526547,
		"y": -65.753853701,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595849,
		"ID": 30,
		"x": -152.0392582307,
		"y": -65.837779165,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595850,
		"ID": 30,
		"x": -152.1282893067,
		"y": -64.898851431,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595851,
		"ID": 30,
		"x": -152.2722677017,
		"y": -67.654767409,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595852,
		"ID": 30,
		"x": -148.5552421977,
		"y": -67.537829657,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595854,
		"ID": 30,
		"x": -152.7942557277,
		"y": -66.429797036,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595855,
		"ID": 30,
		"x": -151.6072742807,
		"y": -67.432763255,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595856,
		"ID": 30,
		"x": -151.4102918437,
		"y": -65.956857576,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595857,
		"ID": 30,
		"x": -148.6272786917,
		"y": -67.557784009,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595859,
		"ID": 30,
		"x": -152.0242719567,
		"y": -65.624767594,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595860,
		"ID": 30,
		"x": -151.8702447087,
		"y": -67.651787505,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595861,
		"ID": 30,
		"x": -152.5572549507,
		"y": -66.9308525,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595862,
		"ID": 30,
		"x": -152.0632761247,
		"y": -66.854807044,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595864,
		"ID": 30,
		"x": -148.3682705057,
		"y": -67.273857324,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595865,
		"ID": 30,
		"x": -150.8732337327,
		"y": -68.26780982,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595866,
		"ID": 30,
		"x": -151.3672385267,
		"y": -65.428857356,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595867,
		"ID": 30,
		"x": -151.5642688657,
		"y": -65.002834886,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595868,
		"ID": 30,
		"x": -150.4442535947,
		"y": -65.270781341,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595869,
		"ID": 30,
		"x": -149.4202287927,
		"y": -67.379756845,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595870,
		"ID": 30,
		"x": -149.4042237497,
		"y": -65.024804176,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595884,
		"ID": 30,
		"x": -152.6042379077,
		"y": -65.640792403,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595901,
		"ID": 30,
		"x": -152.3062763537,
		"y": -65.769769873,
		"h": 4.6923076923
	},
	{
		"stop_id": 8595903,
		"ID": 30,
		"x": -149.5812941647,
		"y": -66.951777638,
		"h": 4.6923076923
	},
	{
		"stop_id": 8594286,
		"ID": 1047,
		"x": 39.0877703903,
		"y": 104.03021855,
		"h": 1.032967033
	},
	{
		"stop_id": 8594287,
		"ID": 1047,
		"x": 38.8427689093,
		"y": 103.980179513,
		"h": 1.032967033
	},
	{
		"stop_id": 8594414,
		"ID": 1420,
		"x": 100.3307743463,
		"y": 10.837235064,
		"h": 1.032967033
	},
	{
		"stop_id": 8594417,
		"ID": 1420,
		"x": 100.7507500553,
		"y": 10.616178581,
		"h": 1.032967033
	},
	{
		"stop_id": 8594663,
		"ID": 1456,
		"x": 111.0487720883,
		"y": 0.562184639,
		"h": 1.3626373626
	},
	{
		"stop_id": 8594664,
		"ID": 1456,
		"x": 111.2377167683,
		"y": 0.752189863,
		"h": 1.3626373626
	},
	{
		"stop_id": 8594665,
		"ID": 1456,
		"x": 111.3927407943,
		"y": 1.102157382,
		"h": 1.3626373626
	},
	{
		"stop_id": 8594666,
		"ID": 1456,
		"x": 111.7197500113,
		"y": 0.754183649,
		"h": 1.3626373626
	},
	{
		"stop_id": 8594667,
		"ID": 1456,
		"x": 111.8467668743,
		"y": 0.894169405,
		"h": 1.3626373626
	},
	{
		"stop_id": 8594668,
		"ID": 1456,
		"x": 111.7717067673,
		"y": 1.154148989,
		"h": 1.3626373626
	},
	{
		"stop_id": 8594669,
		"ID": 1456,
		"x": 111.6027269623,
		"y": 1.191238697,
		"h": 1.3626373626
	},
	{
		"stop_id": 8594672,
		"ID": 1456,
		"x": 111.5907358663,
		"y": 1.570244239,
		"h": 1.3626373626
	},
	{
		"stop_id": 8594673,
		"ID": 1456,
		"x": 111.8317526263,
		"y": 1.154200985,
		"h": 1.3626373626
	},
	{
		"stop_id": 8594674,
		"ID": 1456,
		"x": 111.8257075353,
		"y": 1.221200684,
		"h": 1.3626373626
	},
	{
		"stop_id": 8594675,
		"ID": 1456,
		"x": 111.8027406603,
		"y": 1.460207618,
		"h": 1.3626373626
	},
	{
		"stop_id": 8594676,
		"ID": 1456,
		"x": 111.7527531483,
		"y": 1.661184157,
		"h": 1.3626373626
	},
	{
		"stop_id": 8594924,
		"ID": 414,
		"x": -64.6272555537,
		"y": -20.890812721,
		"h": 1
	},
	{
		"stop_id": 8595446,
		"ID": 650,
		"x": -26.9332597667,
		"y": 28.221218776,
		"h": 1
	},
	{
		"stop_id": 8595925,
		"ID": 1482,
		"x": 124.1507446823,
		"y": -20.718773262,
		"h": 1
	},
	{
		"stop_id": 8595954,
		"ID": 33,
		"x": -150.0292307367,
		"y": -52.409845094,
		"h": 1
	},
	{
		"stop_id": 8774687,
		"ID": 157,
		"x": -98.8162658857,
		"y": -84.4587630302,
		"h": 1
	}
];


//////////////////
// WEBPACK FOOTER
// ../res/stops.json
// module id = 13
// module chunks = 0